(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8abc"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8abc"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7E0eS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $590c744aa6eb78fe$export$71511d61b312f219; });
function $590c744aa6eb78fe$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("h2kUE", function(module, exports) {

$parcel$export(module.exports, "observable", function () { return observable; });
$parcel$export(module.exports, "isObservableObject", function () { return isObservableObject; });
$parcel$export(module.exports, "isObservableArray", function () { return isObservableArray; });
$parcel$export(module.exports, "isObservableMap", function () { return isObservableMap; });
$parcel$export(module.exports, "computed", function () { return computed; });
$parcel$export(module.exports, "_allowStateChanges", function () { return allowStateChanges; });
$parcel$export(module.exports, "untracked", function () { return untracked; });
$parcel$export(module.exports, "_getGlobalState", function () { return getGlobalState; });
$parcel$export(module.exports, "getDependencyTree", function () { return getDependencyTree; });
$parcel$export(module.exports, "Reaction", function () { return Reaction; });
$parcel$export(module.exports, "action", function () { return action; });
$parcel$export(module.exports, "reaction", function () { return reaction; });
$parcel$export(module.exports, "configure", function () { return configure; });
$parcel$export(module.exports, "toJS", function () { return toJS; });
$parcel$export(module.exports, "when", function () { return when; });
$parcel$export(module.exports, "makeObservable", function () { return makeObservable; });
$parcel$export(module.exports, "runInAction", function () { return runInAction; });

var $7E0eS = parcelRequire("7E0eS");
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value);
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function ownKeys(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if ((typeof key === "undefined" ? "undefined" : (0, $7E0eS._)(key)) === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _construct(t, e, r) {
    if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && _setPrototypeOf(p, r.prototype), p;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $7E0eS._)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $7E0eS._)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $7E0eS._)(i)) ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return _wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !_isNativeFunction(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return _construct(t, arguments, _getPrototypeOf(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), _setPrototypeOf(Wrapper, t);
    }, _wrapNativeSuper(t);
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return (typeof context === "undefined" ? "undefined" : (0, $7E0eS._)(context)) == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    };
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var _$mthd = initMthd;
        if (!isAction(_$mthd)) _$mthd = _createAction(_$mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            _$mthd = _$mthd.bind(this);
            _$mthd.isMobxAction = true;
        }
        return _$mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    var computedValues;
    // Defer ComputedValue creation until first access — avoids allocating
    // ComputedValues for getters that are never read on a given instance.
    // The factory is materialised by ObservableObjectAdministration on demand.
    function createComputedValue(target, adm) {
        var options = _extends({}, ann.options_, {
            get: get,
            context: target
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        return new ComputedValue(options);
    }
    addInitializer(function() {
        var _adm$lazyComputedKeys;
        var adm = asObservableObject(this)[$mobx];
        var target = this;
        var observable = adm.values_.get(key);
        if (observable instanceof ComputedValue && observable.derivation !== get) adm.values_["delete"](key);
        ((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null ? _adm$lazyComputedKeys : adm.lazyComputedKeys_ = new Map()).set(key, function() {
            return createComputedValue(target, adm);
        });
    });
    return function() {
        var adm = this[$mobx];
        var observable = adm.values_.get(key);
        if (observable instanceof ComputedValue && observable.derivation !== get) {
            var _computedValues;
            var computed = (_computedValues = computedValues) == null ? void 0 : _computedValues.get(this);
            if (!computed) {
                var _computedValues2;
                computed = createComputedValue(this, adm);
                ((_computedValues2 = computedValues) != null ? _computedValues2 : computedValues = new WeakMap()).set(this, computed);
            }
            return computed.get();
        }
        return adm.getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    if (kind !== "accessor") return;
    // Defer ObservableValue construction until first access. The factory is
    // materialised by ObservableObjectAdministration on demand, so unused
    // fields on wide classes never pay the per-instance allocation cost.
    function registerLazy(target, value) {
        var _adm$lazyObservableKe;
        var adm = asObservableObject(target)[$mobx];
        ((_adm$lazyObservableKe = adm.lazyObservableKeys_) != null ? _adm$lazyObservableKe : adm.lazyObservableKeys_ = new Map()).set(name, function() {
            var _ann$options_$enhance, _ann$options_;
            return new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        });
        return adm;
    }
    return {
        get: function get() {
            var _this$$mobx;
            var adm = (_this$$mobx = this[$mobx]) != null ? _this$$mobx : registerLazy(this, desc.get.call(this));
            return adm.getObservablePropValue_(name);
        },
        set: function set(value) {
            var _this$$mobx2;
            var adm = (_this$$mobx2 = this[$mobx]) != null ? _this$$mobx2 : registerLazy(this, value);
            return adm.setObservablePropValue_(name, value);
        },
        init: function init(value) {
            registerLazy(this, value);
            return value;
        }
    };
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = isAction(descriptor.set) ? descriptor.set // See #4553
         : createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if ((typeof v === "undefined" ? "undefined" : (0, $7E0eS._)(v)) === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        var _this$value_;
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "\t".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        if ("dispose" in Symbol && (0, $7E0eS._)(Symbol.dispose) === "symbol") dispose[Symbol.dispose] = dispose;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
var FlowCancellationError = /*#__PURE__*/ function(_Error) {
    function FlowCancellationError() {
        var _this;
        _this = _Error.call(this, "FLOW_CANCELLED") || this;
        Object.setPrototypeOf(_this, (this instanceof FlowCancellationError ? this.constructor : void 0).prototype);
        _this.name = "FlowCancellationError";
        return _this;
    }
    _inheritsLoose(FlowCancellationError, _Error);
    var _proto = FlowCancellationError.prototype;
    _proto.toString = function toString() {
        return "Error: " + this.message;
    };
    return FlowCancellationError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    var _adm$lazyComputedKeys;
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    var adm = value[$mobx];
    if ((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null && _adm$lazyComputedKeys.has(property)) return true;
    if (!adm.values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) {
            var _adm$lazyComputedKeys, _adm$lazyObservableKe;
            var adm = value[$mobx];
            return adm.values_.has(property) || !!((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null && _adm$lazyComputedKeys.has(property)) || !!((_adm$lazyObservableKe = adm.lazyObservableKeys_) != null && _adm$lazyObservableKe.has(property));
        }
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || (typeof source === "undefined" ? "undefined" : (0, $7E0eS._)(source)) !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && (typeof arg1 === "undefined" ? "undefined" : (0, $7E0eS._)(arg1)) === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if ((typeof name === "undefined" ? "undefined" : (0, $7E0eS._)(name)) === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.getOrInsert = function getOrInsert(key, value) {
        if (!this.has(key)) this.set(key, value);
        return this.get(key);
    };
    _proto.getOrInsertComputed = function getOrInsertComputed(key, callback) {
        if (!this.has(key)) this.set(key, callback(key));
        return this.get(key);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    };
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return makeIterable(iterator);
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
            // implemented reassignment same as it's done for ObservableMap
            value = change.newValue;
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var values = this.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next = values.next(), value = _values$next.value, done = _values$next.done;
                return !done ? {
                    value: [
                        value,
                        value
                    ],
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var values = this.data_.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next2 = values.next(), value = _values$next2.value, done = _values$next2.done;
                return !done ? {
                    value: self1.dehanceValue_(value),
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return makeIterable(iterator);
}
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.lazyComputedKeys_ = void 0;
        this.lazyObservableKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        var _ref, _this$values_$get;
        // Hot path: single map lookup. Lazy entries (rare) take the materialise branch.
        var observable = (_ref = (_this$values_$get = this.values_.get(key)) != null ? _this$values_$get : this.materializeLazyComputed_(key)) != null ? _ref : this.materializeLazyObservable_(key);
        return observable.get();
    };
    _proto.materializeLazyComputed_ = function materializeLazyComputed_(key) {
        var _this$lazyComputedKey;
        var factory = (_this$lazyComputedKey = this.lazyComputedKeys_) == null ? void 0 : _this$lazyComputedKey.get(key);
        if (!factory) return undefined;
        this.lazyComputedKeys_["delete"](key);
        if (this.lazyComputedKeys_.size === 0) this.lazyComputedKeys_ = undefined;
        var computed = factory();
        this.values_.set(key, computed);
        return computed;
    };
    _proto.materializeLazyObservable_ = function materializeLazyObservable_(key) {
        var _this$lazyObservableK;
        var factory = (_this$lazyObservableK = this.lazyObservableKeys_) == null ? void 0 : _this$lazyObservableK.get(key);
        if (!factory) return undefined;
        this.lazyObservableKeys_["delete"](key);
        if (this.lazyObservableKeys_.size === 0) this.lazyObservableKeys_ = undefined;
        var observable = factory();
        this.values_.set(key, observable);
        return observable;
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var _ref2, _this$values_$get2;
        var observable = (_ref2 = (_this$values_$get2 = this.values_.get(key)) != null ? _this$values_$get2 : this.materializeLazyComputed_(key)) != null ? _ref2 : this.materializeLazyObservable_(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    };
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    };
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    };
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    };
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if ((typeof thing === "undefined" ? "undefined" : (0, $7E0eS._)(thing)) === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            var _ref, _adm$values_$get;
            if (!property) return die(26);
            var adm = thing[$mobx];
            var _observable = (_ref = (_adm$values_$get = adm.values_.get(property)) != null ? _adm$values_$get : adm.materializeLazyComputed_(property)) != null ? _ref : adm.materializeLazyObservable_(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Modified: "Deep compare objects" part to iterate over keys in forward order instead of reverse order.
//
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a === "undefined" ? "undefined" : (0, $7E0eS._)(a);
    if (type !== "function" && type !== "object" && (typeof b === "undefined" ? "undefined" : (0, $7E0eS._)(b)) != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if ((typeof a === "undefined" ? "undefined" : (0, $7E0eS._)(a)) != "object" || (typeof b === "undefined" ? "undefined" : (0, $7E0eS._)(b)) != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var _length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== _length) return false;
        for(var i = 0; i < _length; i++){
            // Deep compare each member
            var key = keys[i];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
var _global$Iterator;
// safely get iterator prototype if available
var global$1 = /*#__PURE__*/ getGlobal();
var maybeIteratorPrototype = ((_global$Iterator = global$1.Iterator) == null ? void 0 : _global$Iterator.prototype) || {};
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : (0, $7E0eS._)(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("jAEAr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e430dccebb6451d6$export$71511d61b312f219; });

var $4z2hM = parcelRequire("4z2hM");
function $e430dccebb6451d6$export$71511d61b312f219(inner) {
    var iter = {}, waiting = false;
    function pump(key, value) {
        waiting = true;
        value = new Promise(function(resolve) {
            resolve(inner[key](value));
        });
        return {
            done: false,
            value: new (0, $4z2hM._)(value, /* kind: delegate */ 1)
        };
    }
    iter[typeof Symbol !== "undefined" && Symbol.iterator || "@@iterator"] = function() {
        return this;
    };
    iter.next = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("next", value);
    };
    if (typeof inner.throw === "function") iter.throw = function(value) {
        if (waiting) {
            waiting = false;
            throw value;
        }
        return pump("throw", value);
    };
    if (typeof inner.return === "function") iter.return = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("return", value);
    };
    return iter;
}

});
parcelRegister("4z2hM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $352c343ccd91c3ff$export$71511d61b312f219; });
function $352c343ccd91c3ff$export$71511d61b312f219(value, /** 0: await 1: delegate */ kind) {
    this.v = value;
    this.k = kind;
}

});


parcelRegister("dafVd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $99588f40b3d122b6$export$71511d61b312f219; });
function $99588f40b3d122b6$export$71511d61b312f219(iterable) {
    var method, async, sync, retry = 2;
    for("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new $99588f40b3d122b6$var$AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function $99588f40b3d122b6$var$AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return $99588f40b3d122b6$var$AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, $99588f40b3d122b6$var$AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new $99588f40b3d122b6$var$AsyncFromSyncIterator(s);
}

});

parcelRegister("3gP77", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $261a83dce9699282$export$71511d61b312f219; });
function $261a83dce9699282$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $261a83dce9699282$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $261a83dce9699282$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $261a83dce9699282$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("dm3mz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9b8ff03e39f7914e$export$71511d61b312f219; });

var $4z2hM = parcelRequire("4z2hM");
function $9b8ff03e39f7914e$export$71511d61b312f219(value) {
    return new (0, $4z2hM._)(value, /* kind: await */ 0);
}

});

parcelRegister("173N4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0cf96292990469e4$export$71511d61b312f219; });
function $0cf96292990469e4$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("cFHGC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $939b339a0d69884d$export$71511d61b312f219; });
function $939b339a0d69884d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $939b339a0d69884d$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $939b339a0d69884d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $939b339a0d69884d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("1XAnY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $16d7868dc491f7c4$export$71511d61b312f219; });

var $7Pjls = parcelRequire("7Pjls");
function $16d7868dc491f7c4$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $7Pjls._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("7Pjls", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5b2c4d59510e4c85$export$71511d61b312f219; });
function $5b2c4d59510e4c85$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("aUGqu", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7f200b52cf078100$export$71511d61b312f219; });

var $dbiLi = parcelRequire("dbiLi");

var $fSnLV = parcelRequire("fSnLV");

var $1ZfL4 = parcelRequire("1ZfL4");

var $dyckk = parcelRequire("dyckk");
function $7f200b52cf078100$export$71511d61b312f219(arr) {
    return (0, $dbiLi._)(arr) || (0, $fSnLV._)(arr) || (0, $dyckk._)(arr) || (0, $1ZfL4._)();
}

});
parcelRegister("dbiLi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $998adb2694c8379f$export$71511d61b312f219; });

var $mEET1 = parcelRequire("mEET1");
function $998adb2694c8379f$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $mEET1._)(arr);
}

});
parcelRegister("mEET1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0441981c80ae0b4b$export$71511d61b312f219; });
function $0441981c80ae0b4b$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("fSnLV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b8ee56c891a3392b$export$71511d61b312f219; });
function $b8ee56c891a3392b$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("1ZfL4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1727b62e6036c392$export$71511d61b312f219; });
function $1727b62e6036c392$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("dyckk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9dd80339453197e0$export$71511d61b312f219; });

var $mEET1 = parcelRequire("mEET1");
function $9dd80339453197e0$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $mEET1._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $mEET1._)(o, minLen);
}

});


parcelRegister("7t5yo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $56ff8cb30caacb19$export$71511d61b312f219; });

var $jKMwY = parcelRequire("jKMwY");
function $56ff8cb30caacb19$export$71511d61b312f219(fn) {
    return function() {
        return new (0, $jKMwY._)(fn.apply(this, arguments));
    };
}

});
parcelRegister("jKMwY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e617f567554d6241$export$71511d61b312f219; });

var $4z2hM = parcelRequire("4z2hM");
function $e617f567554d6241$export$71511d61b312f219(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) back = back.next = request;
            else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var overloaded = value instanceof (0, $4z2hM._);
            Promise.resolve(overloaded ? value.v : value).then(function(arg) {
                if (overloaded) {
                    var nextKey = key === "return" ? "return" : "next";
                    if (!value.k || arg.done) return resume(nextKey, arg);
                    else arg = gen[nextKey](arg).value;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) resume(front.key, front.arg);
        else back = null;
    }
    this._invoke = send;
    if (typeof gen.return !== "function") this.return = undefined;
}
$e617f567554d6241$export$71511d61b312f219.prototype[typeof Symbol === "function" && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
};
$e617f567554d6241$export$71511d61b312f219.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
$e617f567554d6241$export$71511d61b312f219.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
$e617f567554d6241$export$71511d61b312f219.prototype.return = function(arg) {
    return this._invoke("return", arg);
};

});


parcelRegister("13u2V", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0c4d60c8eb03fee1$export$71511d61b312f219; });
function $0c4d60c8eb03fee1$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}

});

parcelRegister("Csf8W", function(module, exports) {

$parcel$export(module.exports, "__values", function () { return $6fc8008516332bcb$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $7E0eS = parcelRequire("7E0eS");
var $6fc8008516332bcb$var$extendStatics = function extendStatics1(d, b) {
    $6fc8008516332bcb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $6fc8008516332bcb$var$extendStatics(d, b);
};
function $6fc8008516332bcb$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $6fc8008516332bcb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $6fc8008516332bcb$export$18ce0697a983be9b = function __assign1() {
    $6fc8008516332bcb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6fc8008516332bcb$export$18ce0697a983be9b.apply(this, arguments);
};
function $6fc8008516332bcb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6fc8008516332bcb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $7E0eS._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $6fc8008516332bcb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $6fc8008516332bcb$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $7E0eS._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $6fc8008516332bcb$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $6fc8008516332bcb$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $7E0eS._)(x)) === "symbol" ? x : "".concat(x);
}
function $6fc8008516332bcb$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $7E0eS._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $6fc8008516332bcb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $7E0eS._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $6fc8008516332bcb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $6fc8008516332bcb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $6fc8008516332bcb$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $6fc8008516332bcb$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $6fc8008516332bcb$export$45d3717a4c69092e(o, m, p);
}
function $6fc8008516332bcb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $6fc8008516332bcb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $6fc8008516332bcb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($6fc8008516332bcb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $6fc8008516332bcb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $6fc8008516332bcb$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $6fc8008516332bcb$export$10c90e4f7922046c(v) {
    return this instanceof $6fc8008516332bcb$export$10c90e4f7922046c ? (this.v = v, this) : new $6fc8008516332bcb$export$10c90e4f7922046c(v);
}
function $6fc8008516332bcb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $6fc8008516332bcb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $6fc8008516332bcb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $6fc8008516332bcb$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $6fc8008516332bcb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $6fc8008516332bcb$export$19a8beecd37a4c45 === "function" ? $6fc8008516332bcb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $6fc8008516332bcb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $6fc8008516332bcb$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $6fc8008516332bcb$var$ownKeys = function ownKeys1(o) {
    $6fc8008516332bcb$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $6fc8008516332bcb$var$ownKeys(o);
};
function $6fc8008516332bcb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $6fc8008516332bcb$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $6fc8008516332bcb$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $6fc8008516332bcb$var$__setModuleDefault(result, mod);
    return result;
}
function $6fc8008516332bcb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $6fc8008516332bcb$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $6fc8008516332bcb$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $6fc8008516332bcb$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $7E0eS._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $6fc8008516332bcb$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $6fc8008516332bcb$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $6fc8008516332bcb$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $6fc8008516332bcb$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $6fc8008516332bcb$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $6fc8008516332bcb$export$2e2bcd8739ae039 = {
    __extends: $6fc8008516332bcb$export$a8ba968b8961cb8a,
    __assign: $6fc8008516332bcb$export$18ce0697a983be9b,
    __rest: $6fc8008516332bcb$export$3c9a16f847548506,
    __decorate: $6fc8008516332bcb$export$29e00dfd3077644b,
    __param: $6fc8008516332bcb$export$d5ad3fd78186038f,
    __esDecorate: $6fc8008516332bcb$export$3a84e1ae4e97e9b0,
    __runInitializers: $6fc8008516332bcb$export$d831c04e792af3d,
    __propKey: $6fc8008516332bcb$export$6a2a36740a146cb8,
    __setFunctionName: $6fc8008516332bcb$export$d1a06452d3489bc7,
    __metadata: $6fc8008516332bcb$export$f1db080c865becb9,
    __awaiter: $6fc8008516332bcb$export$1050f835b63b671e,
    __generator: $6fc8008516332bcb$export$67ebef60e6f28a6,
    __createBinding: $6fc8008516332bcb$export$45d3717a4c69092e,
    __exportStar: $6fc8008516332bcb$export$f33643c0debef087,
    __values: $6fc8008516332bcb$export$19a8beecd37a4c45,
    __read: $6fc8008516332bcb$export$8d051b38c9118094,
    __spread: $6fc8008516332bcb$export$afc72e2116322959,
    __spreadArrays: $6fc8008516332bcb$export$6388937ca91ccae8,
    __spreadArray: $6fc8008516332bcb$export$1216008129fb82ed,
    __await: $6fc8008516332bcb$export$10c90e4f7922046c,
    __asyncGenerator: $6fc8008516332bcb$export$e427f37a30a4de9b,
    __asyncDelegator: $6fc8008516332bcb$export$bbd80228419bb833,
    __asyncValues: $6fc8008516332bcb$export$e3b29a3d6162315f,
    __makeTemplateObject: $6fc8008516332bcb$export$4fb47efe1390b86f,
    __importStar: $6fc8008516332bcb$export$c21735bcef00d192,
    __importDefault: $6fc8008516332bcb$export$da59b14a69baef04,
    __classPrivateFieldGet: $6fc8008516332bcb$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $6fc8008516332bcb$export$d40a35129aaff81f,
    __classPrivateFieldIn: $6fc8008516332bcb$export$81fdc39f203e4e04,
    __addDisposableResource: $6fc8008516332bcb$export$88ac25d8e944e405,
    __disposeResources: $6fc8008516332bcb$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $6fc8008516332bcb$export$889dfb5d17574b0b
};

});

parcelRegister("6rymm", function(module, exports) {

$parcel$export(module.exports, "useLocation", function () { return useLocation; });
$parcel$export(module.exports, "useParams", function () { return useParams; });
$parcel$export(module.exports, "Route", function () { return Route; });
$parcel$export(module.exports, "Routes", function () { return Routes; });
$parcel$export(module.exports, "HashRouter", function () { return HashRouter; });
/**
 * react-router v7.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $3gP77 = parcelRequire("3gP77");

var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7Pjls = parcelRequire("7Pjls");

var $hdIku = parcelRequire("hdIku");

var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");

var $iQDyc = parcelRequire("iQDyc");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");

var $1SdK7 = parcelRequire("1SdK7");

var $13u2V = parcelRequire("13u2V");

var $Csf8W = parcelRequire("Csf8W");
parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");
var $lliNT = parcelRequire("lliNT");
var $1aLYV = parcelRequire("1aLYV");
var $ee9c672aaaad304c$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/.pnpm/react-router@7.18.0_@preact+compat@18.3.2_preact@10.29.2__@preact+compat@18.3.2_preact@10.29.2_/node_modules/react-router/dist/development/chunk-4ZMWKKQ3.mjs"
});
var __typeError = function(msg) {
    throw TypeError(msg);
};
var __accessCheck = function(obj, member, msg) {
    return member.has(obj) || __typeError("Cannot " + msg);
};
var __privateGet = function(obj, member, getter) {
    return __accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = function(obj, member, value) {
    return member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = function(obj, member, value, setter) {
    return __accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value;
};
// lib/router/url.ts
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var PROTOCOL_RELATIVE_URL_REGEX = /^[\\/]{2}/;
function normalizeProtocolRelativeUrl(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}
// lib/router/history.ts
var Action = /* @__PURE__ */ function(Action2) {
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
}(Action || {});
var PopStateEventType = "popstate";
function isLocation(obj) {
    return (typeof obj === "undefined" ? "undefined" : (0, $7E0eS._)(obj)) === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function createMemoryHistory() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries;
    entries = initialEntries.map(function(entry, index2) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = "POP" /* Pop */ ;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to) {
        var state = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, key = arguments.length > 2 ? arguments[2] : void 0, mask = arguments.length > 3 ? arguments[3] : void 0;
        var location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: ".concat(JSON.stringify(to)));
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL: function(to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = "PUSH" /* Push */ ;
            var nextLocation = isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = "REPLACE" /* Replace */ ;
            var nextLocation = isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = "POP" /* Pop */ ;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
function createBrowserHistory() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    function createBrowserLocation(window2, globalHistory) {
        var _globalHistory_state;
        var maskedLocation = (_globalHistory_state = globalHistory.state) === null || _globalHistory_state === void 0 ? void 0 : _globalHistory_state.masked;
        var _ref = maskedLocation || window2.location, pathname = _ref.pathname, search = _ref.search, hash = _ref.hash;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function createHashHistory() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    function createHashLocation(window2, globalHistory) {
        var _parsePath = parsePath(window2.location.hash.substring(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        var base = window2.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window2.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(".concat(JSON.stringify(to), ")"));
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function createLocation(current, to) {
    var state = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, key = arguments.length > 3 ? arguments[3] : void 0, mask = arguments.length > 4 ? arguments[4] : void 0;
    var location = (0, $6fpqi._)((0, $1XAnY._)({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to), {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey(),
        mask: mask
    });
    return location;
}
function createPath(param) {
    var _param_pathname = param.pathname, pathname = _param_pathname === void 0 ? "/" : _param_pathname, _param_search = param.search, search = _param_search === void 0 ? "" : _param_search, _param_hash = param.hash, hash = _param_hash === void 0 ? "" : _param_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function parsePath(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref2, validateLocation) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var tmp = options.window, window2 = tmp === void 0 ? document.defaultView : tmp, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window2.history;
    var action = "POP" /* Pop */ ;
    var listener = null;
    var index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $6fpqi._)((0, $1XAnY._)({}, globalHistory.state), {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        var location = isLocation(to) ? to : createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        var location = isLocation(to) ? to : createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return createBrowserURLImpl(window2, to);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window2.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function createBrowserURLImpl(windowImpl, to) {
    var isAbsolute = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    invariant(base, "No window.location.(origin|href) available to create URL");
    var href = typeof to === "string" ? to : createPath(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && PROTOCOL_RELATIVE_URL_REGEX.test(href)) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function createContext(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var _map;
var RouterContextProvider = /*#__PURE__*/ function() {
    "use strict";
    function RouterContextProvider(init) {
        (0, $173N4._)(this, RouterContextProvider);
        __privateAdd(this, _map, /* @__PURE__ */ new Map());
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (init) try {
            for(var _iterator = init[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $f9AOD._)(_step.value, 2), context = _step_value[0], value = _step_value[1];
                this.set(context, value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    (0, $cFHGC._)(RouterContextProvider, [
        {
            /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ key: "get",
            value: function get(context) {
                if (__privateGet(this, _map).has(context)) return __privateGet(this, _map).get(context);
                if (context.defaultValue !== void 0) return context.defaultValue;
                throw new Error("No value found for context");
            }
        },
        {
            /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ key: "set",
            value: function set(context, value) {
                __privateGet(this, _map).set(context, value);
            }
        }
    ]);
    return RouterContextProvider;
}();
_map = new WeakMap();
var unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isUnsupportedLazyRouteObjectKey(key) {
    return unsupportedLazyRouteObjectKeys.has(key);
}
var unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function isUnsupportedLazyRouteFunctionKey(key) {
    return unsupportedLazyRouteFunctionKeys.has(key);
}
function isIndexRoute(route) {
    return route.index === true;
}
function convertRoutesToDataRoutes(routes, mapRouteProperties2) {
    var parentPath = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], manifest = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, allowInPlaceMutations = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    return routes.map(function(route, index) {
        var treePath = (0, $aUGqu._)(parentPath).concat([
            String(index)
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(allowInPlaceMutations || !manifest[id], 'Found a route id collision on id "'.concat(id, "\".  Route id's must be globally unique within Data Router usages"));
        if (isIndexRoute(route)) {
            var indexRoute = (0, $6fpqi._)((0, $1XAnY._)({}, route), {
                id: id
            });
            manifest[id] = mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            var pathOrLayoutRoute = (0, $6fpqi._)((0, $1XAnY._)({}, route), {
                id: id,
                children: void 0
            });
            manifest[id] = mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function mergeRouteUpdates(route, updates) {
    return Object.assign(route, (0, $1XAnY._)({}, updates, (0, $7E0eS._)(updates.lazy) === "object" && updates.lazy != null ? {
        lazy: (0, $1XAnY._)({}, route.lazy, updates.lazy)
    } : {}));
}
function matchRoutes(routes, locationArg) {
    var basename = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial, precomputedBranches) {
    var location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    var pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = precomputedBranches !== null && precomputedBranches !== void 0 ? precomputedBranches : flattenAndRankRoutes(routes);
    var matches = null;
    var decoded = decodePath(pathname);
    for(var i = 0; matches == null && i < branches.length; ++i)matches = matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function flattenAndRankRoutes(routes) {
    var branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    return branches;
}
function flattenRoutes(routes) {
    var branches = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], parentsMeta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], parentPath = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", _hasParentOptionalSegments = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var flattenRoute = function(route, index) {
        var hasParentOptionalSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _hasParentOptionalSegments, relativePath = arguments.length > 3 ? arguments[3] : void 0;
        var meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            invariant(meta.relativePath.startsWith(parentPath), 'Absolute route path "'.concat(meta.relativePath, '" nested under path "').concat(parentPath, '" is not valid. An absolute child route path must start with the combined path of all its parent routes.'));
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, 'Index routes must not have child routes. Please remove all child routes from route path "'.concat(path, '".'));
            flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: computeScore(path, route.index),
            routesMeta: routesMeta.map(function(meta2, i) {
                var _compilePath = (0, $f9AOD._)(compilePath(meta2.relativePath, meta2.caseSensitive, i === routesMeta.length - 1), 2), matcher = _compilePath[0], params = _compilePath[1];
                return (0, $6fpqi._)((0, $1XAnY._)({}, meta2), {
                    matcher: matcher,
                    compiledParams: params
                });
            })
        });
    };
    routes.forEach(function(route, index) {
        var _route_path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (route.path === "" || !((_route_path = route.path) === null || _route_path === void 0 ? void 0 : _route_path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, true, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
function explodeOptionalSegments(path) {
    var _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $iQDyc._)(segments), first = _segments[0], rest = _segments.slice(1);
    var isOptional = first.endsWith("?");
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $aUGqu._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $aUGqu._)(restExploded));
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score : compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var paramRe = /^:[\w-]+$/;
var dynamicSegmentValue = 3;
var indexRouteValue = 2;
var emptySegmentValue = 1;
var staticSegmentValue = 10;
var splatPenalty = -2;
var isSplat = function(s) {
    return s === "*";
};
function computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter(function(s) {
        return !isSplat(s);
    }).reduce(function(score, segment) {
        return score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue);
    }, initialScore);
}
function compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname) {
    var allowPartial = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        var match = // Use precomputed matcher if it exists
        meta.matcher && meta.compiledParams ? matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : matchPath(pattern, remainingPathname);
        var route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function generatePath(originalPath) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, 'Route path "'.concat(path, '" will be treated as if it were "').concat(path.replace(/\*$/, "/*"), '" because the `*` character must always follow a `/` in the pattern. To get rid of this warning, please change the route path to "').concat(path.replace(/\*$/, "/*"), '".'));
        path = path.replace(/\*$/, "/*");
    }
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify2 = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        var keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            var _keyMatch = (0, $f9AOD._)(keyMatch, 4), key = _keyMatch[1], optional = _keyMatch[2], suffix = _keyMatch[3];
            var param = params[key];
            invariant(optional === "?" || param != null, 'Missing ":'.concat(key, '" param'));
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $f9AOD._)(compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    return matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function matchPathImpl(pattern, pathname, matcher, compiledParams) {
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo2, param, index) {
        var paramName = param.paramName, isOptional = param.isOptional;
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function compilePath(path) {
    var caseSensitive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "'.concat(path, '" will be treated as if it were "').concat(path.replace(/\*$/, "/*"), '" because the `*` character must always follow a `/` in the pattern. To get rid of this warning, please change the route path to "').concat(path.replace(/\*$/, "/*"), '".'));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, function(match, paramName, isOptional, index, str) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            var nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map(function(v) {
            return decodeURIComponent(v).replace(/\//g, "%2F");
        }).join("/");
    } catch (error) {
        warning(false, 'The URL path "'.concat(value, '" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (').concat(error, ")."));
        return value;
    }
}
function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function prependBasename(param) {
    var basename = param.basename, pathname = param.pathname;
    return pathname === "/" ? basename : joinPaths([
        basename,
        pathname
    ]);
}
var isAbsoluteUrl = function(url) {
    return ABSOLUTE_URL_REGEX.test(url);
};
function resolvePath(to) {
    var fromPathname = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "/";
    var _ref = typeof to === "string" ? parsePath(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname;
    if (toPathname) {
        toPathname = removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = resolvePathname(toPathname.substring(1), "/");
        else pathname = resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    var segments = removeTrailingSlash(fromPathname).split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '".concat(char, "' character in a manually specified `to.").concat(field, "` field [").concat(JSON.stringify(path), "].  Please separate it out to the `to.").concat(dest, '` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.');
}
function getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
function getResolveToMatches(matches) {
    var pathMatches = getPathContributingMatches(matches);
    return pathMatches.map(function(match, idx) {
        return idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase;
    });
}
function resolveTo(toArg, routePathnames, locationPathname) {
    var isPathRelative = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = (0, $1XAnY._)({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = resolvePath(to, from);
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var removeDoubleSlashes = function(path) {
    return path.replace(/[\\/]{2,}/g, "/");
};
var joinPaths = function(paths) {
    return removeDoubleSlashes(paths.join("/"));
};
var removeTrailingSlash = function(path) {
    return path.replace(/\/+$/, "");
};
var normalizePathname = function(pathname) {
    return removeTrailingSlash(pathname).replace(/^\/*/, "/");
};
var normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
var normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
var DataWithResponseInit = function DataWithResponseInit(data2, init) {
    "use strict";
    (0, $173N4._)(this, DataWithResponseInit);
    this.type = "DataWithResponseInit";
    this.data = data2;
    this.init = init || null;
};
function data(data2, init) {
    return new DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var redirect = function(url) {
    var init = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, (0, $6fpqi._)((0, $1XAnY._)({}, responseInit), {
        headers: headers
    }));
};
var redirectDocument = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var replace = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var ErrorResponseImpl = function ErrorResponseImpl(status, statusText, data2) {
    "use strict";
    var internal = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    (0, $173N4._)(this, ErrorResponseImpl);
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data2 instanceof Error) {
        this.data = data2.toString();
        this.error = data2;
    } else this.data = data2;
};
function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function getRoutePattern(matches) {
    var parts = matches.map(function(m) {
        return m.route.path;
    }).filter(Boolean);
    return joinPaths(parts) || "/";
}
var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function parseToInfo(_to, basename) {
    var to = _to;
    if (typeof to !== "string" || !ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    var absoluteURL = to;
    var isExternal = false;
    if (isBrowser) try {
        var currentUrl = new URL(window.location.href);
        var targetUrl = PROTOCOL_RELATIVE_URL_REGEX.test(to) ? new URL(normalizeProtocolRelativeUrl(to, currentUrl.protocol)) : new URL(to);
        var path = stripBasename(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        warning(false, '<Link to="'.concat(to, '"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.'));
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var UninstrumentedSymbol = Symbol("Uninstrumented");
function getRouteInstrumentationUpdates(fns, route) {
    var aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach(function(fn) {
        return fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument: function(i) {
                var keys = Object.keys(aggregated);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (i[key]) aggregated[key].push(i[key]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        });
    });
    var updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        var instrumented = wrapImpl(aggregated.lazy, route.lazy, function() {
            return void 0;
        });
        if (instrumented) updates.lazy = instrumented;
    }
    if ((0, $7E0eS._)(route.lazy) === "object") {
        var lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach(function(key) {
            var lazyFn = lazyObject[key];
            var instrumentations = aggregated["lazy.".concat(key)];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                var instrumented = wrapImpl(instrumentations, lazyFn, function() {
                    return void 0;
                });
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, (0, $7Pjls._)({}, key, instrumented));
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach(function(key) {
        var handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            var _handler_UninstrumentedSymbol;
            var original = (_handler_UninstrumentedSymbol = handler[UninstrumentedSymbol]) !== null && _handler_UninstrumentedSymbol !== void 0 ? _handler_UninstrumentedSymbol : handler;
            var instrumented = wrapImpl(aggregated[key], original, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return getHandlerInfo(args[0]);
            });
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map(function(middleware) {
        var _middleware_UninstrumentedSymbol;
        var original = (_middleware_UninstrumentedSymbol = middleware[UninstrumentedSymbol]) !== null && _middleware_UninstrumentedSymbol !== void 0 ? _middleware_UninstrumentedSymbol : middleware;
        var instrumented = wrapImpl(aggregated.middleware, original, function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return getHandlerInfo(args[0]);
        });
        if (instrumented) {
            instrumented[UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function instrumentClientSideRouter(router, fns) {
    var aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach(function(fn) {
        return fn({
            instrument: function(i) {
                var keys = Object.keys(i);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (i[key]) aggregated[key].push(i[key]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        });
    });
    if (aggregated.navigate.length > 0) {
        var _router_navigate_UninstrumentedSymbol;
        var navigate = (_router_navigate_UninstrumentedSymbol = router.navigate[UninstrumentedSymbol]) !== null && _router_navigate_UninstrumentedSymbol !== void 0 ? _router_navigate_UninstrumentedSymbol : router.navigate;
        var instrumentedNavigate = wrapImpl(aggregated.navigate, navigate, function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _args = (0, $f9AOD._)(args, 2), to = _args[0], opts = _args[1];
            return (0, $1XAnY._)({
                to: typeof to === "number" || typeof to === "string" ? to : to ? createPath(to) : "."
            }, getRouterInfo(router, opts !== null && opts !== void 0 ? opts : {}));
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        var _router_fetch_UninstrumentedSymbol;
        var fetch2 = (_router_fetch_UninstrumentedSymbol = router.fetch[UninstrumentedSymbol]) !== null && _router_fetch_UninstrumentedSymbol !== void 0 ? _router_fetch_UninstrumentedSymbol : router.fetch;
        var instrumentedFetch = wrapImpl(aggregated.fetch, fetch2, function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _args = (0, $f9AOD._)(args, 4), key = _args[0], href = _args[2], opts = _args[3];
            return (0, $1XAnY._)({
                href: href !== null && href !== void 0 ? href : ".",
                fetcherKey: key
            }, getRouterInfo(router, opts !== null && opts !== void 0 ? opts : {}));
        });
        if (instrumentedFetch) {
            instrumentedFetch[UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function instrumentHandler(handler, fns) {
    var aggregated = {
        request: []
    };
    fns.forEach(function(fn) {
        return fn({
            instrument: function(i) {
                var keys = Object.keys(i);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (i[key]) aggregated[key].push(i[key]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        });
    });
    var instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = wrapImpl(aggregated.request, handler, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _args = (0, $f9AOD._)(args, 2), request = _args[0], context = _args[1];
        return {
            request: getReadonlyRequest(request),
            context: context != null ? getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var result;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            recurseRight(impls, getInfo.apply(void 0, (0, $aUGqu._)(args)), function() {
                                return handler.apply(void 0, (0, $aUGqu._)(args));
                            }, impls.length - 1)
                        ];
                    case 1:
                        result = _state.sent();
                        if (result.type === "error") throw result.value;
                        return [
                            2,
                            result.value
                        ];
                }
            });
        })();
    };
}
function recurseRight(impls, info, handler, index) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var impl, result, value, e, handlerPromise, callHandler, e1;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    impl = impls[index];
                    if (!!impl) return [
                        3,
                        5
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        handler()
                    ];
                case 2:
                    value = _state.sent();
                    result = {
                        type: "success",
                        value: value
                    };
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    result = {
                        type: "error",
                        value: e
                    };
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        3,
                        13
                    ];
                case 5:
                    handlerPromise = void 0;
                    callHandler = function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                            return (0, $13u2V._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
                                        else handlerPromise = recurseRight(impls, info, handler, index - 1);
                                        return [
                                            4,
                                            handlerPromise
                                        ];
                                    case 1:
                                        result = _state.sent();
                                        invariant(result, "Expected a result");
                                        if (result.type === "error" && result.value instanceof Error) return [
                                            2,
                                            {
                                                status: "error",
                                                error: result.value
                                            }
                                        ];
                                        return [
                                            2,
                                            {
                                                status: "success",
                                                error: void 0
                                            }
                                        ];
                                }
                            });
                        })();
                    };
                    _state.label = 6;
                case 6:
                    _state.trys.push([
                        6,
                        8,
                        ,
                        9
                    ]);
                    return [
                        4,
                        impl(callHandler, info)
                    ];
                case 7:
                    _state.sent();
                    return [
                        3,
                        9
                    ];
                case 8:
                    e1 = _state.sent();
                    console.error("An instrumentation function threw an error:", e1);
                    return [
                        3,
                        9
                    ];
                case 9:
                    if (!!handlerPromise) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        callHandler()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        4,
                        handlerPromise
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    if (result) return [
                        2,
                        result
                    ];
                    return [
                        2,
                        {
                            type: "error",
                            value: new Error("No result assigned in instrumentation chain.")
                        }
                    ];
            }
        });
    })();
}
function getHandlerInfo(args) {
    var request = args.request, context = args.context, params = args.params, pattern = args.pattern;
    return {
        request: getReadonlyRequest(request),
        params: (0, $1XAnY._)({}, params),
        pattern: pattern,
        context: getReadonlyContext(context)
    };
}
function getRouterInfo(router, opts) {
    return (0, $1XAnY._)({
        currentUrl: createPath(router.state.location)
    }, "formMethod" in opts ? {
        formMethod: opts.formMethod
    } : {}, "formEncType" in opts ? {
        formEncType: opts.formEncType
    } : {}, "formData" in opts ? {
        formData: opts.formData
    } : {}, "body" in opts ? {
        body: opts.body
    } : {});
}
function getReadonlyRequest(request) {
    var _request_headers;
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_request_headers = request.headers).get.apply(_request_headers, (0, $aUGqu._)(args));
            }
        }
    };
}
function getReadonlyContext(context) {
    if (isPlainObject(context)) {
        var frozen = (0, $1XAnY._)({}, context);
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: function(ctx) {
            return context.get(ctx);
        }
    };
}
var objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function isPlainObject(thing) {
    if (thing === null || (typeof thing === "undefined" ? "undefined" : (0, $7E0eS._)(thing)) !== "object") return false;
    var proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === objectProtoNames;
}
// lib/router/router.ts
var validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var validMutationMethods = new Set(validMutationMethodsArr);
var validRequestMethodsArr = [
    "GET"
].concat((0, $aUGqu._)(validMutationMethodsArr));
var validRequestMethods = new Set(validRequestMethodsArr);
var redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var IDLE_NAVIGATION = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var IDLE_FETCHER = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var IDLE_BLOCKER = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var _routes, _branches, _hmrRoutes, _hmrBranches;
var DataRoutes = /*#__PURE__*/ function() {
    "use strict";
    function DataRoutes(routes) {
        (0, $173N4._)(this, DataRoutes);
        __privateAdd(this, _routes);
        __privateAdd(this, _branches);
        __privateAdd(this, _hmrRoutes);
        __privateAdd(this, _hmrBranches);
        __privateSet(this, _routes, routes);
        __privateSet(this, _branches, flattenAndRankRoutes(routes));
    }
    (0, $cFHGC._)(DataRoutes, [
        {
            key: "stableRoutes",
            get: /** The stable route tree */ function get() {
                return __privateGet(this, _routes);
            }
        },
        {
            key: "activeRoutes",
            get: /** The in-flight route tree if one is active, otherwise the stable tree */ function get() {
                var __privateGet1;
                return (__privateGet1 = __privateGet(this, _hmrRoutes)) !== null && __privateGet1 !== void 0 ? __privateGet1 : __privateGet(this, _routes);
            }
        },
        {
            key: "branches",
            get: /** Pre-computed branches */ function get() {
                var __privateGet1;
                return (__privateGet1 = __privateGet(this, _hmrBranches)) !== null && __privateGet1 !== void 0 ? __privateGet1 : __privateGet(this, _branches);
            }
        },
        {
            key: "hasHMRRoutes",
            get: function get() {
                return __privateGet(this, _hmrRoutes) != null;
            }
        },
        {
            /** Replace the stable route tree and recompute its branches */ key: "setRoutes",
            value: function setRoutes(routes) {
                __privateSet(this, _routes, routes);
                __privateSet(this, _branches, flattenAndRankRoutes(routes));
            }
        },
        {
            /** Set a new in-flight route tree and recompute its branches */ key: "setHmrRoutes",
            value: function setHmrRoutes(routes) {
                __privateSet(this, _hmrRoutes, routes);
                __privateSet(this, _hmrBranches, flattenAndRankRoutes(routes));
            }
        },
        {
            /** Commit in-flight routes/branches to the stable slot and clear in-flight */ key: "commitHmrRoutes",
            value: function commitHmrRoutes() {
                if (__privateGet(this, _hmrRoutes)) {
                    __privateSet(this, _routes, __privateGet(this, _hmrRoutes));
                    __privateSet(this, _branches, __privateGet(this, _hmrBranches));
                    __privateSet(this, _hmrRoutes, void 0);
                    __privateSet(this, _hmrBranches, void 0);
                }
            }
        }
    ]);
    return DataRoutes;
}();
_routes = new WeakMap();
_branches = new WeakMap();
_hmrRoutes = new WeakMap();
_hmrBranches = new WeakMap();
function createRouter(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    var isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    var _mapRouteProperties = init.mapRouteProperties || defaultMapRouteProperties;
    var mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        var instrumentations = init.instrumentations;
        mapRouteProperties2 = function(route) {
            return (0, $1XAnY._)({}, _mapRouteProperties(route), getRouteInstrumentationUpdates(instrumentations.map(function(i) {
                return i.route;
            }).filter(Boolean), route));
        };
    }
    var manifest = {};
    var dataRoutes = new DataRoutes(convertRoutesToDataRoutes(init.routes, mapRouteProperties2, void 0, manifest));
    var basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = "/".concat(basename);
    var dataStrategyImpl = init.dataStrategy || defaultDataStrategyWithMiddleware;
    var future = (0, $1XAnY._)({}, init.future);
    var unlistenHistory = null;
    var subscribers = /* @__PURE__ */ new Set();
    var bufferedInitialStateUpdate = null;
    var savedScrollPositions2 = null;
    var getScrollRestorationKey2 = null;
    var getScrollPosition = null;
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = matchRoutesImpl(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    var initialMatchesIsFOW = false;
    var initialErrors = null;
    var initialized;
    var renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        var error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = getShortCircuitMatches(dataRoutes.activeRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = (0, $7Pjls._)({}, route.id, error);
    } else {
        if (initialMatches && !init.hydrationData) {
            var fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            var fogOfWar1 = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar1.active && fogOfWar1.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar1.matches;
            }
        } else if (initialMatches.some(function(m) {
            return m.route.lazy;
        })) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some(function(m) {
            return routeHasLoaderOrMiddleware(m.route);
        })) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            var errors = init.hydrationData ? init.hydrationData.errors : null;
            var relevantMatches = initialMatches;
            if (errors) {
                var idx = initialMatches.findIndex(function(m) {
                    return errors[m.route.id] !== void 0;
                });
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach(function(m) {
                var status = getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    var pendingAction = "POP" /* Pop */ ;
    var pendingPopstateNavigationDfd = null;
    var pendingPreventScrollReset = false;
    var pendingNavigationController;
    var pendingViewTransitionEnabled = false;
    var appliedViewTransitions = /* @__PURE__ */ new Map();
    var removePageHideEventListener = null;
    var isUninterruptedRevalidation = false;
    var isRevalidationRequired = false;
    var cancelledFetcherLoads = /* @__PURE__ */ new Set();
    var fetchControllers = /* @__PURE__ */ new Map();
    var incrementingLoadId = 0;
    var pendingNavigationLoadId = -1;
    var fetchReloadIds = /* @__PURE__ */ new Map();
    var fetchRedirectIds = /* @__PURE__ */ new Set();
    var fetchLoadMatches = /* @__PURE__ */ new Map();
    var activeFetchers = /* @__PURE__ */ new Map();
    var fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    var blockerFunctions = /* @__PURE__ */ new Map();
    var unblockBlockerHistoryUpdate = void 0;
    var pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(function(param) {
            var historyAction = param.action, location = param.location, delta = param.delta;
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                var nextHistoryUpdatePromise = new Promise(function(resolve) {
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(function() {
                            return init.history.go(delta);
                        });
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(state.fetchers, key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            var newErrors = bufferedInitialStateUpdate.newErrors;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return function() {
            return subscribers.delete(fn);
        };
    }
    function updateState(newState) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (newState.matches) newState.matches = newState.matches.map(function(m) {
            var route = manifest[m.route.id];
            var matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return (0, $6fpqi._)((0, $1XAnY._)({}, m), {
                route: route
            });
            return m;
        });
        state = (0, $1XAnY._)({}, state, newState);
        var unmountedFetchers = [];
        var mountedFetchers = [];
        state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach(function(key) {
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        var _newState_errors;
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: (_newState_errors = newState.errors) !== null && _newState_errors !== void 0 ? _newState_errors : null
        };
        (0, $aUGqu._)(subscribers).forEach(function(subscriber) {
            var _newState_errors;
            return subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: (_newState_errors = newState.errors) !== null && _newState_errors !== void 0 ? _newState_errors : null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            });
        });
        unmountedFetchers.forEach(function(key) {
            return deleteFetcher(state.fetchers, key);
        });
        mountedFetchers.forEach(function(key) {
            return state.fetchers.delete(key);
        });
    }
    function completeNavigation(location, newState) {
        var flushSync = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).flushSync;
        var _location_state, _location_state1;
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        var loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, IDLE_BLOCKER);
            });
        }
        var restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location_state1 = location.state) === null || _location_state1 === void 0 ? void 0 : _location_state1._isRedirect) !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        var viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState((0, $6fpqi._)((0, $1XAnY._)({}, newState), {
            // matches, errors, fetchers go through as-is
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd === null || pendingRevalidationDfd === void 0 ? void 0 : pendingRevalidationDfd.resolve();
        pendingRevalidationDfd = null;
    }
    function navigate(to, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var promise, normalizedPath, _normalizeNavigateOptions, path, submission, error, maskPath, partialPath, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
                        pendingPopstateNavigationDfd = null;
                        if (typeof to === "number") {
                            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = createDeferred();
                            promise = pendingPopstateNavigationDfd.promise;
                            init.history.go(to);
                            return [
                                2,
                                promise
                            ];
                        }
                        normalizedPath = normalizeTo(state.location, state.matches, basename, to, opts === null || opts === void 0 ? void 0 : opts.fromRouteId, opts === null || opts === void 0 ? void 0 : opts.relative);
                        _normalizeNavigateOptions = normalizeNavigateOptions(false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        if (opts === null || opts === void 0 ? void 0 : opts.mask) {
                            partialPath = typeof opts.mask === "string" ? parsePath(opts.mask) : (0, $1XAnY._)({}, state.location.mask, opts.mask);
                            maskPath = (0, $1XAnY._)({
                                pathname: "",
                                search: "",
                                hash: ""
                            }, partialPath);
                        }
                        currentLocation = state.location;
                        nextLocation = createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
                        nextLocation = (0, $1XAnY._)({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : void 0;
                        historyAction = "PUSH" /* Push */ ;
                        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
                        else if (userReplace === false) ;
                        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
                        flushSync = (opts && opts.flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: void 0,
                                        reset: void 0,
                                        location: nextLocation
                                    });
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, IDLE_BLOCKER);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.viewTransition,
                                flushSync: flushSync,
                                callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        var promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    function startNavigation(historyAction, location, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var routesToUse, matches, flushSync, fogOfWar, _handleNavigational404, error, notFoundMatches, route, loadingNavigation, request, scopedContext, _tmp, pendingActionResult, actionResult, _actionResult_pendingActionResult, routeId, result, _ref, shortCircuited, updatedMatches, loaderData, errors, workingFetchers;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = dataRoutes.activeRoutes;
                        matches = (opts === null || opts === void 0 ? void 0 : opts.initialHydration) && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
                        state.matches : matchRoutesImpl(routesToUse, location, basename, false, dataRoutes.branches);
                        flushSync = (opts && opts.flushSync) === true;
                        if (matches && state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        if (!matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $7Pjls._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        loadingNavigation = opts && opts.overrideNavigation ? (0, $6fpqi._)((0, $1XAnY._)({}, opts.overrideNavigation), {
                            matches: matches,
                            historyAction: historyAction
                        }) : void 0;
                        pendingNavigationController = new AbortController();
                        request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!init.getContext) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            init.getContext()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = new RouterContextProvider();
                        _state.label = 3;
                    case 3:
                        scopedContext = _tmp;
                        if (!(opts && opts.pendingError)) return [
                            3,
                            4
                        ];
                        pendingActionResult = [
                            findNearestBoundary(matches).route.id,
                            {
                                type: "error" /* error */ ,
                                error: opts.pendingError
                            }
                        ];
                        return [
                            3,
                            6
                        ];
                    case 4:
                        if (!(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 5:
                        actionResult = _state.sent();
                        if (actionResult.shortCircuited) return [
                            2
                        ];
                        if (actionResult.pendingActionResult) {
                            _actionResult_pendingActionResult = (0, $f9AOD._)(actionResult.pendingActionResult, 2), routeId = _actionResult_pendingActionResult[0], result = _actionResult_pendingActionResult[1];
                            if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                                pendingNavigationController = null;
                                completeNavigation(location, {
                                    matches: actionResult.matches,
                                    loaderData: {},
                                    errors: (0, $7Pjls._)({}, routeId, result.error)
                                });
                                return [
                                    2
                                ];
                            }
                        }
                        matches = actionResult.matches || matches;
                        pendingActionResult = actionResult.pendingActionResult;
                        loadingNavigation = getLoadingNavigation(location, matches, historyAction, opts.submission);
                        flushSync = false;
                        fogOfWar.active = false;
                        request = createClientSideRequest(init.history, request.url, request.signal);
                        _state.label = 6;
                    case 6:
                        return [
                            4,
                            handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate)
                        ];
                    case 7:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, updatedMatches = _ref.matches, loaderData = _ref.loaderData, errors = _ref.errors, workingFetchers = _ref.workingFetchers;
                        if (shortCircuited) return [
                            2
                        ];
                        pendingNavigationController = null;
                        completeNavigation(location, (0, $1XAnY._)((0, $6fpqi._)((0, $1XAnY._)({
                            matches: updatedMatches || matches
                        }, getActionDataForCommit(pendingActionResult)), {
                            loaderData: loaderData,
                            errors: errors
                        }), workingFetchers ? {
                            fetchers: workingFetchers
                        } : {}));
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function handleAction(_0, _1, _2, _3, _4, _5, _6, _7) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration) {
            var opts, navigation, discoverResult, _getShortCircuitMatches, matches2, route, boundaryId, _handleNavigational404, notFoundMatches, error, route1, result, actionMatch, dsMatches, results, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match, replace2, location2, boundaryMatch;
            var _arguments = arguments;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        opts = _arguments.length > 8 && _arguments[8] !== void 0 ? _arguments[8] : {};
                        interruptActiveLoads();
                        navigation = getSubmittingNavigation(location, matches, historyAction, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            if (discoverResult.partialMatches.length === 0) {
                                _getShortCircuitMatches = getShortCircuitMatches(dataRoutes.activeRoutes), matches2 = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                                return [
                                    2,
                                    {
                                        matches: matches2,
                                        pendingActionResult: [
                                            route.id,
                                            {
                                                type: "error" /* error */ ,
                                                error: discoverResult.error
                                            }
                                        ]
                                    }
                                ];
                            }
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    pendingActionResult: [
                                        boundaryId,
                                        {
                                            type: "error" /* error */ ,
                                            error: discoverResult.error
                                        }
                                    ]
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), notFoundMatches = _handleNavigational404.notFoundMatches, error = _handleNavigational404.error, route1 = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    pendingActionResult: [
                                        route1.id,
                                        {
                                            type: "error" /* error */ ,
                                            error: error
                                        }
                                    ]
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        actionMatch = getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            3
                        ];
                        result = {
                            type: "error" /* error */ ,
                            error: getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            5
                        ];
                    case 3:
                        dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
                        return [
                            4,
                            callDataStrategy(request, location, dsMatches, scopedContext, null)
                        ];
                    case 4:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (!result) {
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = matches[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    match = _step.value;
                                    if (results[match.route.id]) {
                                        result = results[match.route.id];
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 5;
                    case 5:
                        if (!isRedirectResult(result)) return [
                            3,
                            7
                        ];
                        if (opts && opts.replace != null) replace2 = opts.replace;
                        else {
                            location2 = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                            replace2 = location2 === state.location.pathname + state.location.search;
                        }
                        return [
                            4,
                            startRedirectNavigation(request, result, true, {
                                submission: submission,
                                replace: replace2
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        if (isErrorResult(result)) {
                            boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
                            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
                            return [
                                2,
                                {
                                    matches: matches,
                                    pendingActionResult: [
                                        boundaryMatch.route.id,
                                        result,
                                        actionMatch.route.id
                                    ]
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                matches: matches,
                                pendingActionResult: [
                                    actionMatch.route.id,
                                    result
                                ]
                            }
                        ];
                }
            });
        }).apply(this, arguments);
    }
    function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var loadingNavigation, activeSubmission, shouldUpdateNavigationState, actionData, discoverResult, _getShortCircuitMatches, matches2, route, boundaryId, _handleNavigational404, error, notFoundMatches, route1, routesToUse, _getMatchesToLoad, dsMatches, revalidatingFetchers, workingFetchers2, didUpdateFetcherRedirects2, updates, actionData1, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect2, workingFetchers, _processLoaderData, loaderData, errors, didUpdateFetcherRedirects, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        loadingNavigation = overrideNavigation || getLoadingNavigation(location, matches, historyAction, submission);
                        activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
                        shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        if (shouldUpdateNavigationState) {
                            actionData = getUpdatedActionData(pendingActionResult);
                            updateState((0, $1XAnY._)({
                                navigation: loadingNavigation
                            }, actionData !== void 0 ? {
                                actionData: actionData
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            if (discoverResult.partialMatches.length === 0) {
                                _getShortCircuitMatches = getShortCircuitMatches(dataRoutes.activeRoutes), matches2 = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                                return [
                                    2,
                                    {
                                        matches: matches2,
                                        loaderData: {},
                                        errors: (0, $7Pjls._)({}, route.id, discoverResult.error)
                                    }
                                ];
                            }
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    loaderData: {},
                                    errors: (0, $7Pjls._)({}, boundaryId, discoverResult.error)
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route1 = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    errors: (0, $7Pjls._)({}, route1.id, error)
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        routesToUse = dataRoutes.activeRoutes;
                        _getMatchesToLoad = getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate), dsMatches = _getMatchesToLoad.dsMatches, revalidatingFetchers = _getMatchesToLoad.revalidatingFetchers;
                        pendingNavigationLoadId = ++incrementingLoadId;
                        if (!init.dataStrategy && !dsMatches.some(function(m) {
                            return m.shouldLoad;
                        }) && !dsMatches.some(function(m) {
                            return m.route.middleware && m.route.middleware.length > 0;
                        }) && revalidatingFetchers.length === 0) {
                            workingFetchers2 = new Map(state.fetchers);
                            didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
                            completeNavigation(location, (0, $1XAnY._)({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $7Pjls._)({}, pendingActionResult[0], pendingActionResult[1].error) : null
                            }, getActionDataForCommit(pendingActionResult), didUpdateFetcherRedirects2 ? {
                                fetchers: workingFetchers2
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        if (shouldUpdateNavigationState) {
                            updates = {};
                            if (!isFogOfWar) {
                                updates.navigation = loadingNavigation;
                                actionData1 = getUpdatedActionData(pendingActionResult);
                                if (actionData1 !== void 0) updates.actionData = actionData1;
                            }
                            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
                            updateState(updates, {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            abortFetcher(rf.key);
                            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext)
                        ];
                    case 3:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        redirect2 = findRedirect(loaderResults);
                        if (!redirect2) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            startRedirectNavigation(request, redirect2.result, true, {
                                replace: replace2
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        redirect2 = findRedirect(fetcherResults);
                        if (!redirect2) return [
                            3,
                            7
                        ];
                        fetchRedirectIds.add(redirect2.key);
                        return [
                            4,
                            startRedirectNavigation(request, redirect2.result, true, {
                                replace: replace2
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        workingFetchers = new Map(state.fetchers);
                        _processLoaderData = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        if (initialHydration && state.errors) errors = (0, $1XAnY._)({}, state.errors, errors);
                        didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
                        shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            (0, $1XAnY._)({
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                workingFetchers: workingFetchers
                            } : {})
                        ];
                }
            });
        })();
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) return (0, $7Pjls._)({}, pendingActionResult[0], pendingActionResult[1].data);
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        var workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach(function(rf) {
            var fetcher = workingFetchers.get(rf.key);
            var revalidatingFetcher = getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    function fetch2(key, routeId, href, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var flushSync, routesToUse, normalizedPath, matches, fogOfWar, _normalizeNavigateOptions, path, submission, error, scopedContext, _tmp, preventScrollReset;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        abortFetcher(key);
                        flushSync = (opts && opts.flushSync) === true;
                        routesToUse = dataRoutes.activeRoutes;
                        normalizedPath = normalizeTo(state.location, state.matches, basename, href, routeId, opts === null || opts === void 0 ? void 0 : opts.relative);
                        matches = matchRoutesImpl(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
                        fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        if (!matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: normalizedPath
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        _normalizeNavigateOptions = normalizeNavigateOptions(true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        if (error) {
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        if (!init.getContext) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            init.getContext()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = new RouterContextProvider();
                        _state.label = 3;
                    case 3:
                        scopedContext = _tmp;
                        preventScrollReset = (opts && opts.preventScrollReset) === true;
                        if (!(submission && isMutationMethod(submission.formMethod))) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2
                        ];
                    case 5:
                        fetchLoadMatches.set(key, {
                            routeId: routeId,
                            path: path
                        });
                        return [
                            4,
                            handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission)
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var existingFetcher, abortController, fetchRequest, discoverResult, match, error, originatingLoadId, fetchMatches, actionResults, actionResult, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match2, nextLocation, revalidationRequest, routesToUse, matches, loadId, _getMatchesToLoad, dsMatches, revalidatingFetchers, loadFetcher, workingFetchers, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, fetcherIsMounted, getRedirectStateWithDoneFetcher, redirect2, finalFetchers, _processLoaderData, loaderData, errors;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else requestMatches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        match = getTargetMatch(requestMatches, path);
                        if (!match.route.action && !match.route.lazy) {
                            error = getInternalRouterError(405, {
                                method: submission.formMethod,
                                pathname: path,
                                routeId: routeId
                            });
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        fetchMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
                        return [
                            4,
                            callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key)
                        ];
                    case 3:
                        actionResults = _state.sent();
                        actionResult = actionResults[match.route.id];
                        if (!actionResult) {
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = fetchMatches[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    match2 = _step.value;
                                    if (actionResults[match2.route.id]) {
                                        actionResult = actionResults[match2.route.id];
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        if (fetchRequest.signal.aborted) {
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        if (fetchersQueuedForDeletion.has(key)) {
                            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                                updateFetcherState(key, getDoneFetcher(void 0));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if (isRedirectResult(actionResult)) {
                                fetchControllers.delete(key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    updateFetcherState(key, getDoneFetcher(void 0));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(fetchRequest, actionResult, false, {
                                            fetcherSubmission: submission,
                                            preventScrollReset: preventScrollReset
                                        })
                                    ];
                                }
                            }
                            if (isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = dataRoutes.activeRoutes;
                        matches = state.navigation.state !== "idle" ? matchRoutesImpl(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
                        invariant(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        _getMatchesToLoad = getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
                            match.route.id,
                            actionResult
                        ], callSiteDefaultShouldRevalidate), dsMatches = _getMatchesToLoad.dsMatches, revalidatingFetchers = _getMatchesToLoad.revalidatingFetchers;
                        loadFetcher = getLoadingFetcher(submission, actionResult.data);
                        workingFetchers = new Map(state.fetchers);
                        workingFetchers.set(key, loadFetcher);
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher2 = workingFetchers.get(staleKey);
                            var revalidatingFetcher = getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
                            workingFetchers.set(staleKey, revalidatingFetcher);
                            abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: workingFetchers
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext)
                        ];
                    case 4:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        fetcherIsMounted = state.fetchers.has(key);
                        getRedirectStateWithDoneFetcher = function(s) {
                            if (!fetcherIsMounted) return s;
                            var workingFetchers2 = new Map(s.fetchers);
                            workingFetchers2.set(key, getDoneFetcher(actionResult.data));
                            return (0, $6fpqi._)((0, $1XAnY._)({}, s), {
                                fetchers: workingFetchers2
                            });
                        };
                        redirect2 = findRedirect(loaderResults);
                        if (redirect2) {
                            state = getRedirectStateWithDoneFetcher(state);
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                                    preventScrollReset: preventScrollReset
                                })
                            ];
                        }
                        redirect2 = findRedirect(fetcherResults);
                        if (redirect2) {
                            fetchRedirectIds.add(redirect2.key);
                            state = getRedirectStateWithDoneFetcher(state);
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                                    preventScrollReset: preventScrollReset
                                })
                            ];
                        }
                        finalFetchers = new Map(state.fetchers);
                        if (fetcherIsMounted) finalFetchers.set(key, getDoneFetcher(actionResult.data));
                        _processLoaderData = processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        abortStaleFetchLoads(loadId, finalFetchers);
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            invariant(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: finalFetchers
                            });
                        } else {
                            updateState({
                                errors: errors,
                                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: finalFetchers
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var existingFetcher, abortController, fetchRequest, discoverResult, match, originatingLoadId, dsMatches, results, result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match2;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        match = getTargetMatch(matches, path);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
                        return [
                            4,
                            callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key)
                        ];
                    case 3:
                        results = _state.sent();
                        result = results[match.route.id];
                        if (!result) {
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = matches[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    match2 = _step.value;
                                    if (results[match2.route.id]) {
                                        result = results[match2.route.id];
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        if (fetchersQueuedForDeletion.has(key)) {
                            updateFetcherState(key, getDoneFetcher(void 0));
                            return [
                                2
                            ];
                        }
                        if (!isRedirectResult(result)) return [
                            3,
                            6
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            4
                        ];
                        updateFetcherState(key, getDoneFetcher(void 0));
                        return [
                            2
                        ];
                    case 4:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(fetchRequest, result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        if (isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        updateFetcherState(key, getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function startRedirectNavigation(_0, _1, _2) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function(request, redirect2, isNavigation) {
            var _ref, submission, fetcherSubmission, preventScrollReset, replace2, location, redirectLocation, isDocumentReload, url, redirectNavigationType, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            var _arguments = arguments;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {}, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, preventScrollReset = _ref.preventScrollReset, replace2 = _ref.replace;
                        if (!isNavigation) {
                            pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
                            pendingPopstateNavigationDfd = null;
                        }
                        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
                        location = redirect2.response.headers.get("Location");
                        invariant(location, "Expected a Location header on the redirect Response");
                        location = normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
                        redirectLocation = createLocation(state.location, location, {
                            _isRedirect: true
                        });
                        if (isBrowser3) {
                            isDocumentReload = false;
                            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
                            else if (isAbsoluteUrl(location)) {
                                url = createBrowserURLImpl(routerWindow, location, true);
                                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                stripBasename(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace2) routerWindow.location.replace(location);
                                else routerWindow.location.assign(location);
                                return [
                                    2
                                ];
                            }
                        }
                        pendingNavigationController = null;
                        redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
                        activeSubmission = submission || fetcherSubmission;
                        if (!(redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectNavigationType, redirectLocation, {
                                submission: (0, $6fpqi._)((0, $1XAnY._)({}, activeSubmission), {
                                    formAction: location
                                }),
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        overrideNavigation = getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
                        return [
                            4,
                            startNavigation(redirectNavigationType, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }).apply(this, arguments);
    }
    function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var results, dataResults, e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match, _results_match_route_id, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, _step_value, routeId, result, response, err;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dataResults = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false)
                        ];
                    case 2:
                        results = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        matches.filter(function(m) {
                            return m.shouldLoad;
                        }).forEach(function(m) {
                            dataResults[m.route.id] = {
                                type: "error" /* error */ ,
                                error: e
                            };
                        });
                        return [
                            2,
                            dataResults
                        ];
                    case 4:
                        if (request.signal.aborted) return [
                            2,
                            dataResults
                        ];
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (!isMutationMethod(request.method)) try {
                            for(_iterator = matches[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                match = _step.value;
                                ;
                                if (((_results_match_route_id = results[match.route.id]) === null || _results_match_route_id === void 0 ? void 0 : _results_match_route_id.type) === "error" /* error */ ) break;
                                if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                                    type: "error" /* error */ ,
                                    result: new Error("No result returned from dataStrategy for route ".concat(match.route.id))
                                };
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            11,
                            12,
                            13
                        ]);
                        _iterator1 = Object.entries(results)[Symbol.iterator]();
                        _state.label = 6;
                    case 6:
                        if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                            3,
                            10
                        ];
                        _step_value = (0, $f9AOD._)(_step1.value, 2), routeId = _step_value[0], result = _step_value[1];
                        if (!isRedirectDataStrategyResult(result)) return [
                            3,
                            7
                        ];
                        response = result.result;
                        dataResults[routeId] = {
                            type: "redirect" /* redirect */ ,
                            response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
                        };
                        return [
                            3,
                            9
                        ];
                    case 7:
                        return [
                            4,
                            convertDataStrategyResultToDataResult(result)
                        ];
                    case 8:
                        dataResults[routeId] = _state.sent();
                        _state.label = 9;
                    case 9:
                        _iteratorNormalCompletion1 = true;
                        return [
                            3,
                            6
                        ];
                    case 10:
                        return [
                            3,
                            13
                        ];
                    case 11:
                        err = _state.sent();
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                        return [
                            3,
                            13
                        ];
                    case 12:
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        })();
    }
    function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var loaderResultsPromise, fetcherResultsPromise, loaderResults, fetcherResults;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
                        fetcherResultsPromise = Promise.all(fetchersToLoad.map(function(f) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                var results, result;
                                return (0, $13u2V._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(f.matches && f.match && f.request && f.controller)) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key)
                                            ];
                                        case 1:
                                            results = _state.sent();
                                            result = results[f.match.route.id];
                                            return [
                                                2,
                                                (0, $7Pjls._)({}, f.key, result)
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                Promise.resolve((0, $7Pjls._)({}, f.key, {
                                                    type: "error" /* error */ ,
                                                    error: getInternalRouterError(404, {
                                                        pathname: f.path
                                                    })
                                                }))
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }));
                        return [
                            4,
                            loaderResultsPromise
                        ];
                    case 1:
                        loaderResults = _state.sent();
                        return [
                            4,
                            fetcherResultsPromise
                        ];
                    case 2:
                        fetcherResults = _state.sent().reduce(function(acc, r) {
                            return Object.assign(acc, r);
                        }, {});
                        return [
                            2,
                            {
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        })();
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher) {
        var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error) {
        var opts = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        var boundaryMatch = findNearestBoundary(state.matches, routeId);
        var workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: (0, $7Pjls._)({}, boundaryMatch.route.id, error),
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts === null || opts === void 0 ? void 0 : opts.reason);
        updateFetcherState(key, getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        var fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        var count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        var controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = fetchers.get(key);
                invariant(fetcher, "Expected fetcher: ".concat(key));
                var doneFetcher = getDoneFetcher(fetcher.data);
                fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone(fetchers) {
        var doneKeys = [];
        var didUpdateFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = fetchers.get(key);
                invariant(fetcher, "Expected fetcher: ".concat(key));
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    didUpdateFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $f9AOD._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = fetchers.get(key);
                    invariant(fetcher, "Expected fetcher: ".concat(key));
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: ".concat(blocker.state, " -> ").concat(newBlocker.state));
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(param) {
        var currentLocation = param.currentLocation, nextLocation = param.nextLocation, historyAction = param.historyAction;
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $f9AOD._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        var error = getInternalRouterError(404, {
            pathname: pathname
        });
        var routesToUse = dataRoutes.activeRoutes;
        var _getShortCircuitMatches = getShortCircuitMatches(routesToUse), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            var key = getScrollRestorationKey2(location, matches.map(function(m) {
                return convertRouteMatchToUiMatch(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            var activeBranches = dataRoutes.branches;
            if (!matches) {
                var fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                var partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    function discoverRoutes(matches, pathname, signal, fetcherKey) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var _loop, partialMatches, _ret;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _loop = function() {
                            var localManifest, e, activeBranches, newMatches, newPartialMatches, matchedDeeper;
                            return (0, $13u2V._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        localManifest = manifest;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4,
                                            init.patchRoutesOnNavigation({
                                                signal: signal,
                                                path: pathname,
                                                matches: partialMatches,
                                                fetcherKey: fetcherKey,
                                                patch: function(routeId, children) {
                                                    if (signal.aborted) return;
                                                    patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                                                }
                                            })
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                v: {
                                                    type: "error",
                                                    error: e,
                                                    partialMatches: partialMatches
                                                }
                                            }
                                        ];
                                    case 4:
                                        if (signal.aborted) return [
                                            2,
                                            {
                                                v: {
                                                    type: "aborted"
                                                }
                                            }
                                        ];
                                        activeBranches = dataRoutes.branches;
                                        newMatches = matchRoutesImpl(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
                                        newPartialMatches = null;
                                        if (newMatches) {
                                            if (Object.keys(newMatches[0].params).length === 0) return [
                                                2,
                                                {
                                                    v: {
                                                        type: "success",
                                                        matches: newMatches
                                                    }
                                                }
                                            ];
                                            else {
                                                newPartialMatches = matchRoutesImpl(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                                                matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                                                if (!matchedDeeper) return [
                                                    2,
                                                    {
                                                        v: {
                                                            type: "success",
                                                            matches: newMatches
                                                        }
                                                    }
                                                ];
                                            }
                                        }
                                        if (!newPartialMatches) newPartialMatches = matchRoutesImpl(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                                        if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: null
                                                }
                                            }
                                        ];
                                        partialMatches = newPartialMatches;
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        if (!init.patchRoutesOnNavigation) return [
                            2,
                            {
                                type: "success",
                                matches: matches
                            }
                        ];
                        partialMatches = matches;
                        _state.label = 1;
                    case 1:
                        if (!true) return [
                            3,
                            3
                        ];
                        return [
                            5,
                            (0, $Csf8W.__values)(_loop())
                        ];
                    case 2:
                        _ret = _state.sent();
                        if ((0, $7E0eS._)(_ret) === "object") return [
                            2,
                            _ret.v
                        ];
                        return [
                            3,
                            1
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every(function(m, i) {
            return m.route.id === b[i].route.id;
        });
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes(convertRoutesToDataRoutes(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children) {
        var unstable_allowElementMutations = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp: function(newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = instrumentClientSideRouter(router, init.instrumentations.map(function(i) {
        return i.router;
    }).filter(Boolean));
    return router;
}
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var _mapRouteProperties = (opts === null || opts === void 0 ? void 0 : opts.mapRouteProperties) || defaultMapRouteProperties;
    var mapRouteProperties2 = _mapRouteProperties;
    var future = (0, $1XAnY._)({}, opts === null || opts === void 0 ? void 0 : opts.future);
    if (opts === null || opts === void 0 ? void 0 : opts.instrumentations) {
        var instrumentations = opts.instrumentations;
        mapRouteProperties2 = function(route) {
            return (0, $1XAnY._)({}, _mapRouteProperties(route), getRouteInstrumentationUpdates(instrumentations.map(function(i) {
                return i.route;
            }).filter(Boolean), route));
        };
    }
    var dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties2, void 0, manifest);
    var routeBranches = flattenAndRankRoutes(dataRoutes);
    function query(_0) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function(request) {
            var _ref, requestContext, filterMatchesToLoad, skipLoaderErrorBubbling, skipRevalidation, dataStrategy, generateMiddlewareResponse, normalizePath, normalizePathImpl, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, staticContext, error1, _getShortCircuitMatches1, notFoundMatches, route1, staticContext1, renderedStaticContext, response, e, result;
            var _arguments = arguments;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, requestContext = _ref.requestContext, filterMatchesToLoad = _ref.filterMatchesToLoad, skipLoaderErrorBubbling = _ref.skipLoaderErrorBubbling, skipRevalidation = _ref.skipRevalidation, dataStrategy = _ref.dataStrategy, generateMiddlewareResponse = _ref.generateMiddlewareResponse, normalizePath = _ref.normalizePath;
                        normalizePathImpl = normalizePath || defaultNormalizePath;
                        method = request.method;
                        location = createLocation("", normalizePathImpl(request), null, "default");
                        matches = matchRoutesImpl(dataRoutes, location, basename, false, routeBranches);
                        requestContext = requestContext != null ? requestContext : new RouterContextProvider();
                        if (!isValidMethod(method) && method !== "HEAD") {
                            error = getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            staticContext = {
                                basename: basename,
                                location: location,
                                matches: methodNotAllowedMatches,
                                loaderData: {},
                                actionData: null,
                                errors: (0, $7Pjls._)({}, route.id, error),
                                statusCode: error.status,
                                loaderHeaders: {},
                                actionHeaders: {}
                            };
                            return [
                                2,
                                generateMiddlewareResponse ? generateMiddlewareResponse(function() {
                                    return Promise.resolve(staticContext);
                                }) : staticContext
                            ];
                        } else if (!matches) {
                            error1 = getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            staticContext1 = {
                                basename: basename,
                                location: location,
                                matches: notFoundMatches,
                                loaderData: {},
                                actionData: null,
                                errors: (0, $7Pjls._)({}, route1.id, error1),
                                statusCode: error1.status,
                                loaderHeaders: {},
                                actionHeaders: {}
                            };
                            return [
                                2,
                                generateMiddlewareResponse ? generateMiddlewareResponse(function() {
                                    return Promise.resolve(staticContext1);
                                }) : staticContext1
                            ];
                        }
                        if (!generateMiddlewareResponse) return [
                            3,
                            5
                        ];
                        invariant(requestContext instanceof RouterContextProvider, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            runServerMiddlewarePipeline({
                                request: request,
                                url: createDataFunctionUrl(request, location),
                                pattern: getRoutePattern(matches),
                                matches: matches,
                                params: matches[0].params,
                                // If we're calling middleware then it must be enabled so we can cast
                                // this to the proper type knowing it's not an `AppLoadContext`
                                context: requestContext
                            }, function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                    var res;
                                    return (0, $13u2V._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    generateMiddlewareResponse(function(revalidationRequest) {
                                                        var opts2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                                            var _opts2_filterMatchesToLoad, result2;
                                                            return (0, $13u2V._)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? (_opts2_filterMatchesToLoad = opts2.filterMatchesToLoad) !== null && _opts2_filterMatchesToLoad !== void 0 ? _opts2_filterMatchesToLoad : null : filterMatchesToLoad !== null && filterMatchesToLoad !== void 0 ? filterMatchesToLoad : null, skipRevalidation === true)
                                                                        ];
                                                                    case 1:
                                                                        result2 = _state.sent();
                                                                        if (isResponse(result2)) return [
                                                                            2,
                                                                            result2
                                                                        ];
                                                                        renderedStaticContext = (0, $1XAnY._)({
                                                                            location: location,
                                                                            basename: basename
                                                                        }, result2);
                                                                        return [
                                                                            2,
                                                                            renderedStaticContext
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    })
                                                ];
                                            case 1:
                                                res = _state.sent();
                                                return [
                                                    2,
                                                    res
                                                ];
                                        }
                                    });
                                })();
                            }, function(error, routeId) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                    var _, _tmp, e, staticContext, _matches_find, boundaryRouteId, staticContext1;
                                    return (0, $13u2V._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (isRedirectResponse(error)) return [
                                                    2,
                                                    error
                                                ];
                                                if (!isResponse(error)) return [
                                                    3,
                                                    4
                                                ];
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    4
                                                ]);
                                                _ = ErrorResponseImpl.bind;
                                                _tmp = [
                                                    void 0,
                                                    error.status,
                                                    error.statusText
                                                ];
                                                return [
                                                    4,
                                                    parseResponseBody(error)
                                                ];
                                            case 2:
                                                error = new (_.apply(ErrorResponseImpl, _tmp.concat([
                                                    _state.sent()
                                                ])));
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                e = _state.sent();
                                                error = e;
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 4:
                                                if (isDataWithResponseInit(error)) error = dataWithResponseInitToErrorResponse(error);
                                                if (renderedStaticContext) {
                                                    if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                                                    staticContext = getStaticContextFromError(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : findNearestBoundary(matches, routeId).route.id);
                                                    return [
                                                        2,
                                                        generateMiddlewareResponse(function() {
                                                            return Promise.resolve(staticContext);
                                                        })
                                                    ];
                                                } else {
                                                    ;
                                                    boundaryRouteId = skipLoaderErrorBubbling ? routeId : findNearestBoundary(matches, ((_matches_find = matches.find(function(m) {
                                                        return m.route.id === routeId || m.route.loader;
                                                    })) === null || _matches_find === void 0 ? void 0 : _matches_find.route.id) || routeId).route.id;
                                                    staticContext1 = {
                                                        matches: matches,
                                                        location: location,
                                                        basename: basename,
                                                        loaderData: {},
                                                        actionData: null,
                                                        errors: (0, $7Pjls._)({}, boundaryRouteId, error),
                                                        statusCode: isRouteErrorResponse(error) ? error.status : 500,
                                                        actionHeaders: {},
                                                        loaderHeaders: {}
                                                    };
                                                    return [
                                                        2,
                                                        generateMiddlewareResponse(function() {
                                                            return Promise.resolve(staticContext1);
                                                        })
                                                    ];
                                                }
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            })
                        ];
                    case 3:
                        response = _state.sent();
                        invariant(isResponse(response), "Expected a response in query()");
                        return [
                            2,
                            response
                        ];
                    case 4:
                        e = _state.sent();
                        if (isResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 5:
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true)
                        ];
                    case 6:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        return [
                            2,
                            (0, $1XAnY._)({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        }).apply(this, arguments);
    }
    function queryRoute(_0) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function(request) {
            var _ref, routeId, requestContext, dataStrategy, generateMiddlewareResponse, normalizePath, normalizePathImpl, method, location, matches, match, response, result;
            var _arguments = arguments;
            function handleQueryResult(result2) {
                if (isResponse(result2)) return result2;
                var error = result2.errors ? Object.values(result2.errors)[0] : void 0;
                if (error !== void 0) throw error;
                if (result2.actionData) return Object.values(result2.actionData)[0];
                if (result2.loaderData) return Object.values(result2.loaderData)[0];
                return void 0;
            }
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, routeId = _ref.routeId, requestContext = _ref.requestContext, dataStrategy = _ref.dataStrategy, generateMiddlewareResponse = _ref.generateMiddlewareResponse, normalizePath = _ref.normalizePath;
                        normalizePathImpl = normalizePath || defaultNormalizePath;
                        method = request.method;
                        location = createLocation("", normalizePathImpl(request), null, "default");
                        matches = matchRoutesImpl(dataRoutes, location, basename, false, routeBranches);
                        requestContext = requestContext != null ? requestContext : new RouterContextProvider();
                        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : getTargetMatch(matches, location);
                        if (routeId && !match) throw getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        if (!generateMiddlewareResponse) return [
                            3,
                            3
                        ];
                        invariant(requestContext instanceof RouterContextProvider, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
                        return [
                            4,
                            loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            runServerMiddlewarePipeline({
                                request: request,
                                url: createDataFunctionUrl(request, location),
                                pattern: getRoutePattern(matches),
                                matches: matches,
                                params: matches[0].params,
                                // If we're calling middleware then it must be enabled so we can cast
                                // this to the proper type knowing it's not an `AppLoadContext`
                                context: requestContext
                            }, function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                    var res;
                                    return (0, $13u2V._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    generateMiddlewareResponse(function(innerRequest) {
                                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                                            var result2, processed;
                                                            return (0, $13u2V._)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false)
                                                                        ];
                                                                    case 1:
                                                                        result2 = _state.sent();
                                                                        processed = handleQueryResult(result2);
                                                                        return [
                                                                            2,
                                                                            isResponse(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed)
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    })
                                                ];
                                            case 1:
                                                res = _state.sent();
                                                return [
                                                    2,
                                                    res
                                                ];
                                        }
                                    });
                                })();
                            }, function(error) {
                                if (isDataWithResponseInit(error)) return Promise.resolve(dataWithResponseInitToResponse(error));
                                if (isResponse(error)) return Promise.resolve(error);
                                throw error;
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            2,
                            response
                        ];
                    case 3:
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false)
                        ];
                    case 4:
                        result = _state.sent();
                        return [
                            2,
                            handleQueryResult(result)
                        ];
                }
            });
        }).apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var result2, result, e;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!isMutationMethod(request.method)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, location, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation)
                        ];
                    case 2:
                        result2 = _state.sent();
                        return [
                            2,
                            result2
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad)
                        ];
                    case 4:
                        result = _state.sent();
                        return [
                            2,
                            isResponse(result) ? result : (0, $6fpqi._)((0, $1XAnY._)({}, result), {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        if (isDataStrategyResult(e) && isResponse(e.result)) {
                            if (e.type === "error" /* error */ ) throw e.result;
                            return [
                                2,
                                e.result
                            ];
                        }
                        if (isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var result, error, dsMatches, results, boundaryMatch, loaderRequest, boundaryMatch1, handlerContext2, handlerContext;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: "error" /* error */ ,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
                        return [
                            4,
                            callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 2:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest);
                        _state.label = 3;
                    case 3:
                        if (isRedirectResult(result)) throw new Response(null, {
                            status: result.response.status,
                            headers: {
                                Location: result.response.headers.get("Location")
                            }
                        });
                        if (isRouteRequest) {
                            if (isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $7Pjls._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {}
                                }
                            ];
                        }
                        if (skipRevalidation) {
                            if (isErrorResult(result)) {
                                boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
                                return [
                                    2,
                                    {
                                        statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                        actionData: null,
                                        actionHeaders: (0, $1XAnY._)({}, result.headers ? (0, $7Pjls._)({}, actionMatch.route.id, result.headers) : {}),
                                        matches: matches,
                                        loaderData: {},
                                        errors: (0, $7Pjls._)({}, boundaryMatch.route.id, result.error),
                                        loaderHeaders: {}
                                    }
                                ];
                            } else return [
                                2,
                                {
                                    actionData: (0, $7Pjls._)({}, actionMatch.route.id, result.data),
                                    actionHeaders: result.headers ? (0, $7Pjls._)({}, actionMatch.route.id, result.headers) : {},
                                    matches: matches,
                                    loaderData: {},
                                    errors: null,
                                    statusCode: result.statusCode || 200,
                                    loaderHeaders: {}
                                }
                            ];
                        }
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        if (!isErrorResult(result)) return [
                            3,
                            5
                        ];
                        boundaryMatch1 = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                                boundaryMatch1.route.id,
                                result
                            ])
                        ];
                    case 4:
                        handlerContext2 = _state.sent();
                        return [
                            2,
                            (0, $6fpqi._)((0, $1XAnY._)({}, handlerContext2), {
                                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                actionData: null,
                                actionHeaders: (0, $1XAnY._)({}, result.headers ? (0, $7Pjls._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        return [
                            4,
                            loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad)
                        ];
                    case 6:
                        handlerContext = _state.sent();
                        return [
                            2,
                            (0, $6fpqi._)((0, $1XAnY._)((0, $6fpqi._)((0, $1XAnY._)({}, handlerContext), {
                                actionData: (0, $7Pjls._)({}, actionMatch.route.id, result.data)
                            }), result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}), {
                                actionHeaders: result.headers ? (0, $7Pjls._)({}, actionMatch.route.id, result.headers) : {}
                            })
                        ];
                }
            });
        })();
    }
    function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var isRouteRequest, dsMatches, maxIdx, pattern, results, handlerContext;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        if (isRouteRequest && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.loader) && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.lazy)) throw getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.id
                        });
                        if (routeMatch) dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
                        else {
                            maxIdx = pendingActionResult && isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
                            matches.findIndex(function(m) {
                                return m.route.id === pendingActionResult[0];
                            }) - 1 : void 0;
                            pattern = getRoutePattern(matches);
                            dsMatches = matches.map(function(match, index) {
                                if (maxIdx != null && index > maxIdx) return getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                                return getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
                            });
                        }
                        if (!dataStrategy && !dsMatches.some(function(m) {
                            return m.shouldLoad;
                        })) return [
                            2,
                            {
                                matches: matches,
                                loaderData: {},
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $7Pjls._)({}, pendingActionResult[0], pendingActionResult[1].error) : null,
                                statusCode: 200,
                                loaderHeaders: {}
                            }
                        ];
                        return [
                            4,
                            callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest);
                        handlerContext = processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
                        return [
                            2,
                            (0, $6fpqi._)((0, $1XAnY._)({}, handlerContext), {
                                matches: matches
                            })
                        ];
                }
            });
        })();
    }
    function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var results, dataResults;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            callDataStrategyImpl(dataStrategy || defaultDataStrategy, request, location, matches, null, requestContext, true)
                        ];
                    case 1:
                        results = _state.sent();
                        dataResults = {};
                        return [
                            4,
                            Promise.all(matches.map(function(match) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                    var result, response, _;
                                    return (0, $13u2V._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(match.route.id in results)) return [
                                                    2
                                                ];
                                                result = results[match.route.id];
                                                if (isRedirectDataStrategyResult(result)) {
                                                    response = result.result;
                                                    throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
                                                }
                                                if (isRouteRequest) {
                                                    if (isResponse(result.result)) throw result;
                                                    else if (isDataWithResponseInit(result.result)) throw dataWithResponseInitToResponse(result.result);
                                                }
                                                _ = match.route.id;
                                                return [
                                                    4,
                                                    convertDataStrategyResultToDataResult(result)
                                                ];
                                            case 1:
                                                dataResults[_] = _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        })();
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function getStaticContextFromError(routes, handlerContext, error, boundaryId) {
    var errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return (0, $6fpqi._)((0, $1XAnY._)({}, handlerContext), {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: (0, $7Pjls._)({}, errorBoundaryId, error)
    });
}
function throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    var method = isRouteRequest ? "queryRoute" : "query";
    throw new Error("".concat(method, "() call aborted without an `AbortSignal.reason`: ").concat(request.method, " ").concat(request.url));
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function defaultNormalizePath(request) {
    var url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    var path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        var nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            var params = new URLSearchParams(path.search);
            var indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?".concat(qs) : "";
        }
    }
    if (basename !== "/") path.pathname = prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return createPath(path);
}
function normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path: path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = rawFormMethod.toUpperCase();
    var formAction = stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, param) {
                var _param = (0, $f9AOD._)(param, 2), name = _param[0], value = _param[1];
                return "".concat(acc).concat(name, "=").concat(value, "\n");
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if (isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    var parsedPath = parsePath(path);
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?".concat(searchParams);
    return {
        path: createPath(parsedPath),
        submission: submission
    };
}
function getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    var _state_matches_;
    var actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    var maxIdx;
    if (initialHydration && state.errors) {
        var boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
    } else if (pendingActionResult && isErrorResult(pendingActionResult[1])) {
        var boundaryId1 = pendingActionResult[0];
        maxIdx = matches.findIndex(function(m) {
            return m.route.id === boundaryId1;
        }) - 1;
    }
    var actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    var shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    var baseShouldRevalidateArgs = (0, $6fpqi._)((0, $1XAnY._)({
        currentUrl: currentUrl,
        currentParams: ((_state_matches_ = state.matches[0]) === null || _state_matches_ === void 0 ? void 0 : _state_matches_.params) || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params
    }, submission), {
        actionResult: actionResult,
        actionStatus: actionStatus
    });
    var pattern = getRoutePattern(matches);
    var dsMatches = matches.map(function(match, index) {
        var route = match.route;
        var forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            var _getRouteHydrationStatus = getRouteHydrationStatus(route, state.loaderData, state.errors), shouldLoad2 = _getRouteHydrationStatus.shouldLoad;
            forceShouldLoad = shouldLoad2;
        } else if (isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        var defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if (isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        var shouldRevalidateArgs = (0, $6fpqi._)((0, $1XAnY._)({}, baseShouldRevalidateArgs), {
            defaultShouldRevalidate: defaultShouldRevalidate
        });
        var shouldLoad = shouldRevalidateLoader(match, shouldRevalidateArgs);
        return getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        if (initialHydration || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || fetchersQueuedForDeletion.has(key)) return;
        var fetcher = state.fetchers.get(key);
        var isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        var fetcherMatches = matchRoutesImpl(routesToUse, f.path, basename !== null && basename !== void 0 ? basename : "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        var fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        var fetchController = new AbortController();
        var fetchRequest = createClientSideRequest(history, f.path, fetchController.signal);
        var fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            var defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            var shouldRevalidateArgs = (0, $6fpqi._)((0, $1XAnY._)({}, baseShouldRevalidateArgs), {
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            if (shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    var hasData = loaderData != null && route.id in loaderData;
    var hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    var shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    var isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    var childrenToPatch;
    if (routeId) {
        var route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = ".concat(routeId));
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    var uniqueChildren = [];
    var existingChildren = [];
    children.forEach(function(newRoute) {
        var existingRoute = childrenToPatch.find(function(existingRoute2) {
            return isSameRoute(newRoute, existingRoute2);
        });
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        var _childrenToPatch;
        var newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String((childrenToPatch === null || childrenToPatch === void 0 ? void 0 : childrenToPatch.length) || "0")
        ], manifest);
        (_childrenToPatch = childrenToPatch).push.apply(_childrenToPatch, (0, $aUGqu._)(newRoutes));
    }
    if (allowElementMutations && existingChildren.length > 0) for(var i = 0; i < existingChildren.length; i++){
        var _existingChildren_i = existingChildren[i], existingRoute = _existingChildren_i.existingRoute, newRoute = _existingChildren_i.newRoute;
        var existingRouteTyped = existingRoute;
        var _convertRoutesToDataRoutes = (0, $f9AOD._)(convertRoutesToDataRoutes([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true), 1), newRouteTyped = _convertRoutesToDataRoutes[0];
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes((0, $aUGqu._)(dataRoutes.activeRoutes));
}
function isSameRoute(newRoute, existingRoute) {
    var _newRoute_children;
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    var _newRoute_children_every;
    return (_newRoute_children_every = (_newRoute_children = newRoute.children) === null || _newRoute_children === void 0 ? void 0 : _newRoute_children.every(function(aChild, i) {
        var _existingRoute_children;
        return (_existingRoute_children = existingRoute.children) === null || _existingRoute_children === void 0 ? void 0 : _existingRoute_children.some(function(bChild) {
            return isSameRoute(aChild, bChild);
        });
    })) !== null && _newRoute_children_every !== void 0 ? _newRoute_children_every : false;
}
var lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var loadLazyRouteProperty = function(param) {
    var key = param.key, route = param.route, manifest = param.manifest, mapRouteProperties2 = param.mapRouteProperties;
    var routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || (0, $7E0eS._)(routeToUpdate.lazy) !== "object") return;
    var lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    var cache = lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    var cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    var propertyPromise = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var isUnsupported, staticRouteValue, isStaticallyDefined, value;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isUnsupported = isUnsupportedLazyRouteObjectKey(key);
                        staticRouteValue = routeToUpdate[key];
                        isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
                        if (!isUnsupported) return [
                            3,
                            1
                        ];
                        warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
                        cache[key] = Promise.resolve();
                        return [
                            3,
                            4
                        ];
                    case 1:
                        if (!isStaticallyDefined) return [
                            3,
                            2
                        ];
                        warning(false, 'Route "'.concat(routeToUpdate.id, '" has a static property "').concat(key, '" defined. The lazy property will be ignored.'));
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            lazyFn()
                        ];
                    case 3:
                        value = _state.sent();
                        if (value != null) {
                            Object.assign(routeToUpdate, (0, $7Pjls._)({}, key, value));
                            Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
                        }
                        _state.label = 4;
                    case 4:
                        if ((0, $7E0eS._)(routeToUpdate.lazy) === "object") {
                            routeToUpdate.lazy[key] = void 0;
                            if (Object.values(routeToUpdate.lazy).every(function(value) {
                                return value === void 0;
                            })) routeToUpdate.lazy = void 0;
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    var routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        var cachedPromise = lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        var lazyRoutePromise2 = function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var lazyRoute, routeUpdates, lazyRouteProperty, lazyValue, isUnsupported, staticRouteValue, isStaticallyDefined;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            invariant(typeof route.lazy === "function", "No lazy route function found");
                            return [
                                4,
                                route.lazy()
                            ];
                        case 1:
                            lazyRoute = _state.sent();
                            routeUpdates = {};
                            for(var lazyRouteProperty in lazyRoute){
                                lazyValue = lazyRoute[lazyRouteProperty];
                                if (lazyValue === void 0) continue;
                                isUnsupported = isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                                staticRouteValue = routeToUpdate[lazyRouteProperty];
                                isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                                // on the route updates
                                lazyRouteProperty !== "hasErrorBoundary";
                                if (isUnsupported) warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                                else if (isStaticallyDefined) warning(!isStaticallyDefined, 'Route "'.concat(routeToUpdate.id, '" has a static property "').concat(lazyRouteProperty, '" defined but its lazy function is also returning a value for this property. The lazy route property "').concat(lazyRouteProperty, '" will be ignored.'));
                                else routeUpdates[lazyRouteProperty] = lazyValue;
                            }
                            Object.assign(routeToUpdate, routeUpdates);
                            Object.assign(routeToUpdate, (0, $6fpqi._)((0, $1XAnY._)({}, mapRouteProperties2(routeToUpdate)), {
                                lazy: void 0
                            }));
                            return [
                                2
                            ];
                    }
                });
            })();
        }();
        lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(function() {});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    var lazyKeys = Object.keys(route.lazy);
    var lazyPropertyPromises = [];
    var lazyHandlerPromise = void 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = lazyKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
            var promise = loadLazyRouteProperty({
                key: key,
                route: route,
                manifest: manifest,
                mapRouteProperties: mapRouteProperties2
            });
            if (promise) {
                lazyPropertyPromises.push(promise);
                if (key === type) lazyHandlerPromise = promise;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(function() {}) : void 0;
    lazyRoutePromise === null || lazyRoutePromise === void 0 ? void 0 : lazyRoutePromise.catch(function() {});
    lazyHandlerPromise === null || lazyHandlerPromise === void 0 ? void 0 : lazyHandlerPromise.catch(function() {});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function isNonNullable(value) {
    return value !== void 0;
}
function loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    var promises = matches.map(function(param) {
        var route = param.route;
        if ((0, $7E0eS._)(route.lazy) !== "object" || !route.lazy.middleware) return void 0;
        return loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter(isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
function defaultDataStrategy(args) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var matchesToLoad, keyedResults, results;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matchesToLoad = args.matches.filter(function(m) {
                        return m.shouldLoad;
                    });
                    keyedResults = {};
                    return [
                        4,
                        Promise.all(matchesToLoad.map(function(m) {
                            return m.resolve();
                        }))
                    ];
                case 1:
                    results = _state.sent();
                    results.forEach(function(result, i) {
                        keyedResults[matchesToLoad[i].route.id] = result;
                    });
                    return [
                        2,
                        keyedResults
                    ];
            }
        });
    })();
}
function defaultDataStrategyWithMiddleware(args) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        return (0, $13u2V._)(this, function(_state) {
            if (!args.matches.some(function(m) {
                return m.route.middleware;
            })) return [
                2,
                defaultDataStrategy(args)
            ];
            return [
                2,
                runClientMiddlewarePipeline(args, function() {
                    return defaultDataStrategy(args);
                })
            ];
        });
    })();
}
function runServerMiddlewarePipeline(args, handler, errorHandler) {
    return runMiddlewarePipeline(args, handler, processResult, isResponse, errorHandler);
    function processResult(result) {
        return isDataWithResponseInit(result) ? dataWithResponseInitToResponse(result) : result;
    }
}
function runClientMiddlewarePipeline(args, handler) {
    return runMiddlewarePipeline(args, handler, function(r) {
        if (isRedirectResponse(r)) throw r;
        return r;
    }, isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, (0, $7Pjls._)({}, routeId, {
            type: "error",
            result: error
        })));
        else {
            var matches = args.matches;
            var maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex(function(m) {
                return m.route.id === routeId;
            }), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex(function(m) {
                return m.shouldCallHandler();
            }), 0));
            var boundaryRouteId = findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve((0, $7Pjls._)({}, boundaryRouteId, {
                type: "error",
                result: error
            }));
        }
    }
}
function runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var matches, dataFnArgs, tuples, result;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matches = args.matches, dataFnArgs = (0, $6acIq._)(args, [
                        "matches"
                    ]);
                    tuples = matches.flatMap(function(m) {
                        return m.route.middleware ? m.route.middleware.map(function(fn) {
                            return [
                                m.route.id,
                                fn
                            ];
                        }) : [];
                    });
                    return [
                        4,
                        callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler)
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    })();
}
function callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler) {
    var idx = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 0;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var request, _request_signal_reason, tuple, result, _tuple, routeId, middleware, nextResult, next, value, result1, _tmp, error, response;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = args.request;
                    if (request.signal.aborted) throw (_request_signal_reason = request.signal.reason) !== null && _request_signal_reason !== void 0 ? _request_signal_reason : new Error("Request aborted: ".concat(request.method, " ").concat(request.url));
                    tuple = middlewares[idx];
                    if (!!tuple) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        handler()
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
                case 2:
                    _tuple = (0, $f9AOD._)(tuple, 2), routeId = _tuple[0], middleware = _tuple[1];
                    next = function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                            var result, error, _tmp;
                            return (0, $13u2V._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (nextResult) throw new Error("You may only call `next()` once per middleware");
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            5
                                        ]);
                                        return [
                                            4,
                                            callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1)
                                        ];
                                    case 2:
                                        result = _state.sent();
                                        nextResult = {
                                            value: result
                                        };
                                        return [
                                            2,
                                            nextResult.value
                                        ];
                                    case 3:
                                        error = _state.sent();
                                        _tmp = {};
                                        return [
                                            4,
                                            errorHandler(error, routeId, nextResult)
                                        ];
                                    case 4:
                                        nextResult = (_tmp.value = _state.sent(), _tmp);
                                        return [
                                            2,
                                            nextResult.value
                                        ];
                                    case 5:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    };
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        9,
                        ,
                        11
                    ]);
                    return [
                        4,
                        middleware(args, next)
                    ];
                case 4:
                    value = _state.sent();
                    result1 = value != null ? processResult(value) : void 0;
                    if (!isResult(result1)) return [
                        3,
                        5
                    ];
                    return [
                        2,
                        result1
                    ];
                case 5:
                    if (!nextResult) return [
                        3,
                        6
                    ];
                    return [
                        2,
                        result1 !== null && result1 !== void 0 ? result1 : nextResult.value
                    ];
                case 6:
                    _tmp = {};
                    return [
                        4,
                        next()
                    ];
                case 7:
                    nextResult = (_tmp.value = _state.sent(), _tmp);
                    return [
                        2,
                        nextResult.value
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    error = _state.sent();
                    return [
                        4,
                        errorHandler(error, routeId, nextResult)
                    ];
                case 10:
                    response = _state.sent();
                    return [
                        2,
                        response
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    })();
}
function getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    var lazyMiddlewarePromise = loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    var lazyRoutePromises = loadLazyRoute(match.route, isMutationMethod(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad) {
    var shouldRevalidateArgs = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : null, callSiteDefaultShouldRevalidate = arguments.length > 10 ? arguments[10] : void 0;
    var isUsingNewApi = false;
    var _lazyPromises = getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return (0, $6fpqi._)((0, $1XAnY._)({}, match), {
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler: function(defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return shouldRevalidateLoader(match, (0, $6fpqi._)((0, $1XAnY._)({}, shouldRevalidateArgs), {
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            }));
            if (typeof defaultShouldRevalidate === "boolean") return shouldRevalidateLoader(match, (0, $6fpqi._)((0, $1XAnY._)({}, shouldRevalidateArgs), {
                defaultShouldRevalidate: defaultShouldRevalidate
            }));
            return shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve: function(handlerOverride) {
            var _match_route = match.route, lazy = _match_route.lazy, loader = _match_route.loader, middleware = _match_route.middleware;
            var callHandler = isUsingNewApi || shouldLoad || handlerOverride && !isMutationMethod(request.method) && (lazy || loader);
            var isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && (isMutationMethod(request.method) || !isMiddlewareOnlyRoute)) return callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises === null || _lazyPromises === void 0 ? void 0 : _lazyPromises.handler,
                lazyRoutePromise: _lazyPromises === null || _lazyPromises === void 0 ? void 0 : _lazyPromises.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    });
}
function getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext) {
    var shouldRevalidateArgs = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : null;
    return matches.map(function(match) {
        if (match.route.id !== targetMatch.route.id) return (0, $6fpqi._)((0, $1XAnY._)({}, match), {
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: function() {
                return false;
            },
            _lazyPromises: getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: function() {
                return Promise.resolve({
                    type: "data",
                    result: void 0
                });
            }
        });
        return getDataStrategyMatch(mapRouteProperties2, manifest, request, path, getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
function callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var dataStrategyArgs, runClientMiddleware, results, e;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!matches.some(function(m) {
                        var _m__lazyPromises;
                        return (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.middleware;
                    })) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        Promise.all(matches.map(function(m) {
                            var _m__lazyPromises;
                            return (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.middleware;
                        }))
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    dataStrategyArgs = {
                        request: request,
                        url: createDataFunctionUrl(request, path),
                        pattern: getRoutePattern(matches),
                        params: matches[0].params,
                        context: scopedContext,
                        matches: matches
                    };
                    runClientMiddleware = isStaticHandler ? function() {
                        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
                    } : function(cb) {
                        var typedDataStrategyArgs = dataStrategyArgs;
                        return runClientMiddlewarePipeline(typedDataStrategyArgs, function() {
                            return cb((0, $6fpqi._)((0, $1XAnY._)({}, typedDataStrategyArgs), {
                                fetcherKey: fetcherKey,
                                runClientMiddleware: function() {
                                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                                }
                            }));
                        });
                    };
                    return [
                        4,
                        dataStrategyImpl((0, $6fpqi._)((0, $1XAnY._)({}, dataStrategyArgs), {
                            fetcherKey: fetcherKey,
                            runClientMiddleware: runClientMiddleware
                        }))
                    ];
                case 3:
                    results = _state.sent();
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4,
                        Promise.all(matches.flatMap(function(m) {
                            var _m__lazyPromises, _m__lazyPromises1;
                            return [
                                (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.handler,
                                (_m__lazyPromises1 = m._lazyPromises) === null || _m__lazyPromises1 === void 0 ? void 0 : _m__lazyPromises1.route
                            ];
                        }))
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    e = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2,
                        results
                    ];
            }
        });
    })();
}
function callLoaderOrAction(_0) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function(param) {
        var request, path, pattern, match, lazyHandlerPromise, lazyRoutePromise, handlerOverride, scopedContext, result, onReject, isAction, type, runHandler, handler, handlerError, _ref, value, handler2, ref, url, pathname, url1, pathname1, e;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = param.request, path = param.path, pattern = param.pattern, match = param.match, lazyHandlerPromise = param.lazyHandlerPromise, lazyRoutePromise = param.lazyRoutePromise, handlerOverride = param.handlerOverride, scopedContext = param.scopedContext;
                    isAction = isMutationMethod(request.method);
                    type = isAction ? "action" : "loader";
                    runHandler = function(handler) {
                        var reject;
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        var actualHandler = function(ctx) {
                            if (typeof handler !== "function") return Promise.reject(new Error('You cannot call the handler for a route which defines a boolean "'.concat(type, '" [routeId: ').concat(match.route.id, "]")));
                            return handler.apply(void 0, [
                                {
                                    request: request,
                                    url: createDataFunctionUrl(request, path),
                                    pattern: pattern,
                                    params: match.params,
                                    context: scopedContext
                                }
                            ].concat((0, $aUGqu._)(ctx !== void 0 ? [
                                ctx
                            ] : [])));
                        };
                        var handlerPromise = function() {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                var val, e;
                                return (0, $13u2V._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                2,
                                                ,
                                                3
                                            ]);
                                            return [
                                                4,
                                                handlerOverride ? handlerOverride(function(ctx) {
                                                    return actualHandler(ctx);
                                                }) : actualHandler()
                                            ];
                                        case 1:
                                            val = _state.sent();
                                            return [
                                                2,
                                                {
                                                    type: "data",
                                                    result: val
                                                }
                                            ];
                                        case 2:
                                            e = _state.sent();
                                            return [
                                                2,
                                                {
                                                    type: "error",
                                                    result: e
                                                }
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }();
                        return Promise.race([
                            handlerPromise,
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = isAction ? match.route.action : match.route.loader;
                    if (!(lazyHandlerPromise || lazyRoutePromise)) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            // Ensure all lazy route promises are resolved before continuing
                            lazyHandlerPromise,
                            lazyRoutePromise
                        ])
                    ];
                case 2:
                    _ref = (0, $f9AOD._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), value = _ref[0];
                    if (handlerError !== void 0) throw handlerError;
                    result = value;
                    return [
                        3,
                        7
                    ];
                case 3:
                    return [
                        4,
                        lazyHandlerPromise
                    ];
                case 4:
                    _state.sent();
                    handler2 = isAction ? match.route.action : match.route.loader;
                    if (!handler2) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        Promise.all([
                            runHandler(handler2),
                            lazyRoutePromise
                        ])
                    ];
                case 5:
                    ref = (0, $f9AOD._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), result = ref[0], ref;
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else return [
                        2,
                        {
                            type: "data" /* data */ ,
                            result: void 0
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: "error" /* error */ ,
                            result: e
                        }
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).apply(this, arguments);
}
function parseResponseBody(response) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var contentType;
        return (0, $13u2V._)(this, function(_state) {
            contentType = response.headers.get("Content-Type");
            if (contentType && /\bapplication\/json\b/.test(contentType)) return [
                2,
                response.body == null ? null : response.json()
            ];
            return [
                2,
                response.text()
            ];
        });
    })();
}
function convertDataStrategyResultToDataResult(dataStrategyResult) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var _result_init, _result_init1, result, type, data2, e, _result_init2, _result_init3, _result_init4;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = dataStrategyResult.result, type = dataStrategyResult.type;
                    if (!isResponse(result)) return [
                        3,
                        5
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        parseResponseBody(result)
                    ];
                case 2:
                    data2 = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: "error" /* error */ ,
                            error: e
                        }
                    ];
                case 4:
                    if (type === "error" /* error */ ) return [
                        2,
                        {
                            type: "error" /* error */ ,
                            error: new ErrorResponseImpl(result.status, result.statusText, data2),
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: "data" /* data */ ,
                            data: data2,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 5:
                    if (type === "error" /* error */ ) {
                        if (isDataWithResponseInit(result)) {
                            ;
                            if (result.data instanceof Error) return [
                                2,
                                {
                                    type: "error" /* error */ ,
                                    error: result.data,
                                    statusCode: (_result_init2 = result.init) === null || _result_init2 === void 0 ? void 0 : _result_init2.status,
                                    headers: ((_result_init3 = result.init) === null || _result_init3 === void 0 ? void 0 : _result_init3.headers) ? new Headers(result.init.headers) : void 0
                                }
                            ];
                            return [
                                2,
                                {
                                    type: "error" /* error */ ,
                                    error: dataWithResponseInitToErrorResponse(result),
                                    statusCode: isRouteErrorResponse(result) ? result.status : void 0,
                                    headers: ((_result_init4 = result.init) === null || _result_init4 === void 0 ? void 0 : _result_init4.headers) ? new Headers(result.init.headers) : void 0
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                type: "error" /* error */ ,
                                error: result,
                                statusCode: isRouteErrorResponse(result) ? result.status : void 0
                            }
                        ];
                    }
                    if (isDataWithResponseInit(result)) return [
                        2,
                        {
                            type: "data" /* data */ ,
                            data: result.data,
                            statusCode: (_result_init = result.init) === null || _result_init === void 0 ? void 0 : _result_init.status,
                            headers: ((_result_init1 = result.init) === null || _result_init1 === void 0 ? void 0 : _result_init1.headers) ? new Headers(result.init.headers) : void 0
                        }
                    ];
                    return [
                        2,
                        {
                            type: "data" /* data */ ,
                            data: result
                        }
                    ];
            }
        });
    })();
}
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    var location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!isAbsoluteUrl(location)) {
        var trimmedMatches = matches.slice(0, matches.findIndex(function(m) {
            return m.route.id === routeId;
        }) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function hasInvalidProtocol(location) {
    try {
        return invalidProtocols.includes(new URL(location).protocol);
    } catch (e) {
        return false;
    }
}
function normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if (isAbsoluteUrl(location)) {
        var normalizedLocation = location;
        var url = PROTOCOL_RELATIVE_URL_REGEX.test(normalizedLocation) ? new URL(normalizeProtocolRelativeUrl(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if (hasInvalidProtocol(url.toString())) throw new Error("Invalid redirect location");
        var isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        var url1 = historyInstance.createURL(location);
        if (hasInvalidProtocol(url1.toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL(stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function createDataFunctionUrl(request, path) {
    var url = new URL(request.url);
    var parsed = typeof path === "string" ? parsePath(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        var searchParams = new URLSearchParams(parsed.search);
        var indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = indexValues.filter(Boolean)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                searchParams.append("index", value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        url.search = searchParams.size ? "?".concat(searchParams.toString()) : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $f9AOD._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $f9AOD._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult) {
    var isStaticHandler = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, skipLoaderErrorBubbling = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    var pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach(function(match) {
        if (!(match.route.id in results)) return;
        var id = match.route.id;
        var result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            var error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                var boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = (0, $7Pjls._)({}, pendingActionResult[0], pendingError);
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    var _processRouteLoaderData = processRouteLoaderData(matches, results, pendingActionResult), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    revalidatingFetchers.filter(function(f) {
        return !f.matches || f.matches.some(function(m) {
            return m.shouldLoad;
        });
    }).forEach(function(rf) {
        var key = rf.key, match = rf.match, controller = rf.controller;
        if (controller && controller.signal.aborted) return;
        var result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        if (isErrorResult(result)) {
            var boundaryMatch = findNearestBoundary(state.matches, match === null || match === void 0 ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = (0, $6fpqi._)((0, $1XAnY._)({}, errors), (0, $7Pjls._)({}, boundaryMatch.route.id, result.error));
            workingFetchers.delete(key);
        } else if (isRedirectResult(result)) invariant(false, "Unhandled fetcher revalidation redirect");
        else {
            var doneFetcher = getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = Object.entries(newLoaderData).filter(function(param) {
        var _param = (0, $f9AOD._)(param, 2), v = _param[1];
        return v !== ResetLoaderDataSymbol;
    }).reduce(function(merged, param) {
        var _param = (0, $f9AOD._)(param, 2), k = _param[0], v = _param[1];
        merged[k] = v;
        return merged;
    }, {});
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: (0, $7Pjls._)({}, pendingActionResult[0], pendingActionResult[1].data)
    };
}
function findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $aUGqu._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function getShortCircuitMatches(routes) {
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function getInternalRouterError(status) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type, message = _ref.message;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a ".concat(method, ' request to "').concat(pathname, '" but did not provide a `loader` for route "').concat(routeId, '", so there is no way to handle the request.');
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "'.concat(routeId, '" does not match URL "').concat(pathname, '"');
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "'.concat(pathname, '"');
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a ".concat(method.toUpperCase(), ' request to "').concat(pathname, '" but did not provide an `action` for route "').concat(routeId, '", so there is no way to handle the request.');
        else if (method) errorMessage = 'Invalid request method "'.concat(method.toUpperCase(), '"');
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
function findRedirect(results) {
    var entries = Object.entries(results);
    for(var i = entries.length - 1; i >= 0; i--){
        var _entries_i = (0, $f9AOD._)(entries[i], 2), key = _entries_i[0], result = _entries_i[1];
        if (isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath((0, $6fpqi._)((0, $1XAnY._)({}, parsedPath), {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function dataWithResponseInitToResponse(data2) {
    var _data2_init;
    return Response.json(data2.data, (_data2_init = data2.init) !== null && _data2_init !== void 0 ? _data2_init : void 0);
}
function dataWithResponseInitToErrorResponse(data2) {
    var _data2_init, _data2_init1;
    var _data2_init_status, _data2_init_statusText;
    return new ErrorResponseImpl((_data2_init_status = (_data2_init = data2.init) === null || _data2_init === void 0 ? void 0 : _data2_init.status) !== null && _data2_init_status !== void 0 ? _data2_init_status : 500, (_data2_init_statusText = (_data2_init1 = data2.init) === null || _data2_init1 === void 0 ? void 0 : _data2_init1.statusText) !== null && _data2_init_statusText !== void 0 ? _data2_init_statusText : "Internal Server Error", data2.data);
}
function isDataStrategyResults(result) {
    return result != null && (typeof result === "undefined" ? "undefined" : (0, $7E0eS._)(result)) === "object" && Object.entries(result).every(function(param) {
        var _param = (0, $f9AOD._)(param, 2), key = _param[0], value = _param[1];
        return typeof key === "string" && isDataStrategyResult(value);
    });
}
function isDataStrategyResult(result) {
    return result != null && (typeof result === "undefined" ? "undefined" : (0, $7E0eS._)(result)) === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function isRedirectDataStrategyResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function isDataWithResponseInit(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && (0, $7E0eS._)(value.headers) === "object" && typeof value.body !== "undefined";
}
function isRedirectStatusCode(statusCode) {
    return redirectStatusCodes.has(statusCode);
}
function isRedirectResponse(result) {
    return isResponse(result) && isRedirectStatusCode(result.status) && result.headers.has("Location");
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toUpperCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toUpperCase());
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function getTargetMatch(matches, location) {
    var search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    var pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation1;
    }
}
function getSubmittingNavigation(location, matches, historyAction, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data2) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher1;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function getDoneFetcher(data2) {
    var fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $f9AOD._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {}
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $f9AOD._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $aUGqu._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (".concat(error, ")."));
        }
    }
}
function createDeferred() {
    var resolve;
    var reject;
    var promise = new Promise(function(res, rej) {
        resolve = function(val) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var e;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            res(val);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        reject = function(error) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var e;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rej(error);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
    });
    return {
        promise: promise,
        //@ts-ignore
        resolve: resolve,
        //@ts-ignore
        reject: reject
    };
}
var DataRouterContext = $tLNoZ.createContext(null);
DataRouterContext.displayName = "DataRouter";
var DataRouterStateContext = $tLNoZ.createContext(null);
DataRouterStateContext.displayName = "DataRouterState";
var RSCRouterContext = $tLNoZ.createContext(false);
function useIsRSCRouterContext() {
    return $lliNT.useContext(RSCRouterContext);
}
var ViewTransitionContext = $tLNoZ.createContext({
    isTransitioning: false
});
ViewTransitionContext.displayName = "ViewTransition";
var FetchersContext = $tLNoZ.createContext(/* @__PURE__ */ new Map());
FetchersContext.displayName = "Fetchers";
var AwaitContext = $tLNoZ.createContext(null);
AwaitContext.displayName = "Await";
var AwaitContextProvider = function(props) {
    return $tLNoZ.createElement(AwaitContext.Provider, props);
};
var NavigationContext = $tLNoZ.createContext(null);
NavigationContext.displayName = "Navigation";
var LocationContext = $tLNoZ.createContext(null);
LocationContext.displayName = "Location";
var RouteContext = $tLNoZ.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
RouteContext.displayName = "Route";
var RouteErrorContext = $tLNoZ.createContext(null);
RouteErrorContext.displayName = "RouteError";
var ENABLE_DEV_WARNINGS = true;
// lib/errors.ts
var ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var ERROR_DIGEST_REDIRECT = "REDIRECT";
var ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function decodeRedirectErrorDigest(digest) {
    if (digest.startsWith("".concat(ERROR_DIGEST_BASE, ":").concat(ERROR_DIGEST_REDIRECT, ":{"))) try {
        var parsed = JSON.parse(digest.slice(28));
        if ((typeof parsed === "undefined" ? "undefined" : (0, $7E0eS._)(parsed)) === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch (e) {}
}
function decodeRouteErrorResponseDigest(digest) {
    if (digest.startsWith("".concat(ERROR_DIGEST_BASE, ":").concat(ERROR_DIGEST_ROUTE_ERROR_RESPONSE, ":{"))) try {
        var parsed = JSON.parse(digest.slice(40));
        if ((typeof parsed === "undefined" ? "undefined" : (0, $7E0eS._)(parsed)) === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new ErrorResponseImpl(parsed.status, parsed.statusText, parsed.data);
    } catch (e) {}
}
// lib/hooks.tsx
function useHref(to) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    invariant(useInRouterContext(), "useHref() may be used only in the context of a <Router> component.");
    var _React2_useContext = $lliNT.useContext(NavigationContext), basename = _React2_useContext.basename, navigator = _React2_useContext.navigator;
    var _useResolvedPath = useResolvedPath(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function useInRouterContext() {
    return $lliNT.useContext(LocationContext) != null;
}
function useLocation() {
    invariant(useInRouterContext(), "useLocation() may be used only in the context of a <Router> component.");
    return $lliNT.useContext(LocationContext).location;
}
function useNavigationType() {
    return $lliNT.useContext(LocationContext).navigationType;
}
function useMatch(pattern) {
    invariant(useInRouterContext(), "useMatch() may be used only in the context of a <Router> component.");
    var pathname = useLocation().pathname;
    return $lliNT.useMemo(function() {
        return matchPath(pattern, decodePath(pathname));
    }, [
        pathname,
        pattern
    ]);
}
var navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function useIsomorphicLayoutEffect(cb) {
    var isStatic = $lliNT.useContext(NavigationContext).static;
    if (!isStatic) $lliNT.useLayoutEffect(cb);
}
function useNavigate() {
    var isDataRoute = $lliNT.useContext(RouteContext).isDataRoute;
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    invariant(useInRouterContext(), "useNavigate() may be used only in the context of a <Router> component.");
    var dataRouterContext = $lliNT.useContext(DataRouterContext);
    var _React2_useContext = $lliNT.useContext(NavigationContext), basename = _React2_useContext.basename, navigator = _React2_useContext.navigator;
    var matches = $lliNT.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify(getResolveToMatches(matches));
    var activeRef = $lliNT.useRef(false);
    useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $lliNT.useCallback(function(to) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        warning(activeRef.current, navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var OutletContext = $tLNoZ.createContext(null);
function useOutletContext() {
    return $lliNT.useContext(OutletContext);
}
function useOutlet(context) {
    var outlet = $lliNT.useContext(RouteContext).outlet;
    return $lliNT.useMemo(function() {
        return outlet && /* @__PURE__ */ $tLNoZ.createElement(OutletContext.Provider, {
            value: context
        }, outlet);
    }, [
        outlet,
        context
    ]);
}
function useParams() {
    var matches = $lliNT.useContext(RouteContext).matches;
    var routeMatch = matches[matches.length - 1];
    var _routeMatch_params;
    return (_routeMatch_params = routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.params) !== null && _routeMatch_params !== void 0 ? _routeMatch_params : {};
}
function useResolvedPath(to) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    var matches = $lliNT.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify(getResolveToMatches(matches));
    return $lliNT.useMemo(function() {
        return resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
function useRoutesImpl(routes, locationArg, dataRouterOpts) {
    invariant(useInRouterContext(), "useRoutes() may be used only in the context of a <Router> component.");
    var navigator = $lliNT.useContext(NavigationContext).navigator;
    var _React2_useContext = $lliNT.useContext(RouteContext), parentMatches = _React2_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    if (ENABLE_DEV_WARNINGS) {
        var parentPath = parentRoute && parentRoute.path || "";
        warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), 'You rendered descendant <Routes> (or called `useRoutes()`) at "'.concat(parentPathname, '" (under <Route path="').concat(parentPath, '">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won\'t match anymore and therefore the child routes will never render.\n\nPlease change the parent <Route path="').concat(parentPath, '"> to <Route path="').concat(parentPath === "/" ? "*" : "".concat(parentPath, "/*"), '">.'));
    }
    var locationFromContext = useLocation();
    var location;
    if (locationArg) {
        var _parsedLocationArg_pathname;
        var parsedLocationArg = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
        invariant(parentPathnameBase === "/" || ((_parsedLocationArg_pathname = parsedLocationArg.pathname) === null || _parsedLocationArg_pathname === void 0 ? void 0 : _parsedLocationArg_pathname.startsWith(parentPathnameBase)), 'When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "'.concat(parentPathnameBase, '" but pathname "').concat(parsedLocationArg.pathname, '" was given in the `location` prop.'));
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        var parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        var segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    var matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map(function(m) {
        return Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        });
    }) : matchRoutes(routes, {
        pathname: remainingPathname
    });
    if (ENABLE_DEV_WARNINGS) {
        warning(parentRoute || matches != null, 'No routes matched location "'.concat(location.pathname).concat(location.search).concat(location.hash, '" '));
        warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, 'Matched leaf route at location "'.concat(location.pathname).concat(location.search).concat(location.hash, '" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.'));
    }
    var renderedMatches = _renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $tLNoZ.createElement(LocationContext.Provider, {
        value: {
            location: (0, $1XAnY._)({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0
            }, location),
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    var error = useRouteError();
    var message = isRouteErrorResponse(error) ? "".concat(error.status, " ").concat(error.statusText) : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    if (ENABLE_DEV_WARNINGS) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $tLNoZ.createElement($tLNoZ.Fragment, null, /* @__PURE__ */ $tLNoZ.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $tLNoZ.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $tLNoZ.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $tLNoZ.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $tLNoZ.createElement($tLNoZ.Fragment, null, /* @__PURE__ */ $tLNoZ.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $tLNoZ.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $tLNoZ.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var defaultErrorElement = /* @__PURE__ */ $tLNoZ.createElement(DefaultErrorComponent, null);
var RenderErrorBoundary = /*#__PURE__*/ function(_React2_Component) {
    "use strict";
    (0, $hdIku._)(RenderErrorBoundary, _React2_Component);
    function RenderErrorBoundary(props) {
        (0, $173N4._)(this, RenderErrorBoundary);
        var _this;
        _this = (0, $7qXGD._)(this, RenderErrorBoundary, [
            props
        ]);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $cFHGC._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                if (this.props.onError) this.props.onError(error, errorInfo);
                else console.error("React Router caught the following error during render", error);
            }
        },
        {
            key: "render",
            value: function render() {
                var error = this.state.error;
                if (this.context && (typeof error === "undefined" ? "undefined" : (0, $7E0eS._)(error)) === "object" && error && "digest" in error && typeof error.digest === "string") {
                    var decoded = decodeRouteErrorResponseDigest(error.digest);
                    if (decoded) error = decoded;
                }
                var result = error !== void 0 ? /* @__PURE__ */ $tLNoZ.createElement(RouteContext.Provider, {
                    value: this.props.routeContext
                }, /* @__PURE__ */ $tLNoZ.createElement(RouteErrorContext.Provider, {
                    value: error,
                    children: this.props.component
                })) : this.props.children;
                if (this.context) return /* @__PURE__ */ $tLNoZ.createElement(RSCErrorHandler, {
                    error: error
                }, result);
                return result;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                return {
                    error: props.error !== void 0 ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($tLNoZ.Component);
RenderErrorBoundary.contextType = RSCRouterContext;
var errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function RSCErrorHandler(param) {
    var children = param.children, error = param.error;
    var basename = $lliNT.useContext(NavigationContext).basename;
    if ((typeof error === "undefined" ? "undefined" : (0, $7E0eS._)(error)) === "object" && error && "digest" in error && typeof error.digest === "string") {
        var redirect2 = decodeRedirectErrorDigest(error.digest);
        if (redirect2) {
            var existingRedirect = errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            var parsed = parseToInfo(redirect2.location, basename);
            var target = parsed.absoluteURL || parsed.to;
            if (hasInvalidProtocol(target)) throw new Error("Invalid redirect location");
            if (isBrowser && !errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = target;
                else {
                    var redirectPromise = Promise.resolve().then(function() {
                        return window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        });
                    });
                    errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $tLNoZ.createElement("meta", {
                httpEquiv: "refresh",
                content: "0;url=".concat(target)
            });
        }
    }
    return children;
}
function RenderedRoute(param) {
    var routeContext = param.routeContext, match = param.match, children = param.children;
    var dataRouterContext = $lliNT.useContext(DataRouterContext);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $tLNoZ.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches) {
    var parentMatches = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], dataRouterOpts = arguments.length > 2 ? arguments[2] : void 0;
    var dataRouterState = dataRouterOpts === null || dataRouterOpts === void 0 ? void 0 : dataRouterOpts.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    var errors = dataRouterState === null || dataRouterState === void 0 ? void 0 : dataRouterState.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors === null || errors === void 0 ? void 0 : errors[m.route.id]) !== void 0;
        });
        invariant(errorIndex >= 0, "Could not find a matching route for errors on route IDs: ".concat(Object.keys(errors).join(",")));
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(var i = 0; i < renderedMatches.length; i++){
            var match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                var loaderData = dataRouterState.loaderData, errors2 = dataRouterState.errors;
                var needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    var onErrorHandler = dataRouterOpts === null || dataRouterOpts === void 0 ? void 0 : dataRouterOpts.onError;
    var onError = dataRouterState && onErrorHandler ? function(error, errorInfo) {
        var _dataRouterState_matches_, _dataRouterState_matches;
        var _dataRouterState_matches__params;
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: (_dataRouterState_matches__params = (_dataRouterState_matches = dataRouterState.matches) === null || _dataRouterState_matches === void 0 ? void 0 : (_dataRouterState_matches_ = _dataRouterState_matches[0]) === null || _dataRouterState_matches_ === void 0 ? void 0 : _dataRouterState_matches_.params) !== null && _dataRouterState_matches__params !== void 0 ? _dataRouterState_matches__params : {},
            pattern: getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight(function(outlet, match, index) {
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $tLNoZ.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $tLNoZ.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $tLNoZ.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function getDataRouterConsoleError(hookName) {
    return "".concat(hookName, " must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.");
}
function useDataRouterContext(hookName) {
    var ctx = $lliNT.useContext(DataRouterContext);
    invariant(ctx, getDataRouterConsoleError(hookName));
    return ctx;
}
function useDataRouterState(hookName) {
    var state = $lliNT.useContext(DataRouterStateContext);
    invariant(state, getDataRouterConsoleError(hookName));
    return state;
}
function useRouteContext(hookName) {
    var route = $lliNT.useContext(RouteContext);
    invariant(route, getDataRouterConsoleError(hookName));
    return route;
}
function useCurrentRouteId(hookName) {
    var route = useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    invariant(thisRoute.route.id, "".concat(hookName, ' can only be used on routes that contain a unique "id"'));
    return thisRoute.route.id;
}
function useRouteId() {
    return useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function useNavigation() {
    var state = useDataRouterState("useNavigation" /* UseNavigation */ );
    return $lliNT.useMemo(function() {
        var _state_navigation = state.navigation, matches = _state_navigation.matches, historyAction = _state_navigation.historyAction, rest = (0, $6acIq._)(_state_navigation, [
            "matches",
            "historyAction"
        ]);
        return rest;
    }, [
        state.navigation
    ]);
}
function useRevalidator() {
    var dataRouterContext = useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    var state = useDataRouterState("useRevalidator" /* UseRevalidator */ );
    var revalidate = $lliNT.useCallback(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dataRouterContext.router.revalidate()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        dataRouterContext.router
    ]);
    return $lliNT.useMemo(function() {
        return {
            revalidate: revalidate,
            state: state.revalidation
        };
    }, [
        revalidate,
        state.revalidation
    ]);
}
function useMatches() {
    var _useDataRouterState = useDataRouterState("useMatches" /* UseMatches */ ), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $lliNT.useMemo(function() {
        return matches.map(function(m) {
            return convertRouteMatchToUiMatch(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
function useLoaderData() {
    var state = useDataRouterState("useLoaderData" /* UseLoaderData */ );
    var routeId = useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function useRouteLoaderData(routeId) {
    var state = useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function useActionData() {
    var state = useDataRouterState("useActionData" /* UseActionData */ );
    var routeId = useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function useRouteError() {
    var _state_errors;
    var error = $lliNT.useContext(RouteErrorContext);
    var state = useDataRouterState("useRouteError" /* UseRouteError */ );
    var routeId = useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return (_state_errors = state.errors) === null || _state_errors === void 0 ? void 0 : _state_errors[routeId];
}
function useAsyncValue() {
    var value = $lliNT.useContext(AwaitContext);
    return value === null || value === void 0 ? void 0 : value._data;
}
function useAsyncError() {
    var value = $lliNT.useContext(AwaitContext);
    return value === null || value === void 0 ? void 0 : value._error;
}
var blockerId = 0;
function useBlocker(shouldBlock) {
    var _useDataRouterContext = useDataRouterContext("useBlocker" /* UseBlocker */ ), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = useDataRouterState("useBlocker" /* UseBlocker */ );
    var _React2_useState = (0, $f9AOD._)($lliNT.useState(""), 2), blockerKey = _React2_useState[0], setBlockerKey = _React2_useState[1];
    var blockerFunction = $lliNT.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: (0, $6fpqi._)((0, $1XAnY._)({}, currentLocation), {
                pathname: stripBasename(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: (0, $6fpqi._)((0, $1XAnY._)({}, nextLocation), {
                pathname: stripBasename(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $lliNT.useEffect(function() {
        var key = String(++blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    $lliNT.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : IDLE_BLOCKER;
}
function useNavigateStable() {
    var router = useDataRouterContext("useNavigate" /* UseNavigateStable */ ).router;
    var id = useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    var activeRef = $lliNT.useRef(false);
    useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $lliNT.useCallback(function(to) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        warning(activeRef.current, navigateEffectWarning);
                        if (!activeRef.current) return [
                            2
                        ];
                        if (!(typeof to === "number")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            router.navigate(to)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            router.navigate(to, (0, $1XAnY._)({
                                fromRouteId: id
                            }, options))
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        router,
        id
    ]);
    return navigate;
}
var alreadyWarned = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned[key]) {
        alreadyWarned[key] = true;
        warning(false, message);
    }
}
function useRoute() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _state_actionData;
    var currentRouteId = useCurrentRouteId("useRoute" /* UseRoute */ );
    var _args_;
    var id = (_args_ = args[0]) !== null && _args_ !== void 0 ? _args_ : currentRouteId;
    var state = useDataRouterState("useRoute" /* UseRoute */ );
    var route = state.matches.find(function(param) {
        var route2 = param.route;
        return route2.id === id;
    });
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: (_state_actionData = state.actionData) === null || _state_actionData === void 0 ? void 0 : _state_actionData[id]
    };
}
function toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function useRouterState() {
    var _useDataRouterState = useDataRouterState("unstable_useRouterState" /* UseRouterState */ ), location = _useDataRouterState.location, type = _useDataRouterState.historyAction, matches = _useDataRouterState.matches, navigation = _useDataRouterState.navigation;
    var active = $lliNT.useMemo(function() {
        var _matches_;
        var _matches__params;
        return {
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: (_matches__params = (_matches_ = matches[matches.length - 1]) === null || _matches_ === void 0 ? void 0 : _matches_.params) !== null && _matches__params !== void 0 ? _matches__params : {},
            matches: matches.map(function(m) {
                return toRouterStateMatch(m);
            })
        };
    }, [
        location,
        matches,
        type
    ]);
    var pending = $lliNT.useMemo(function() {
        var _navigation_matches_;
        if (navigation.state === "idle") return null;
        var _navigation_matches__params;
        var shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: (_navigation_matches__params = (_navigation_matches_ = navigation.matches[navigation.matches.length - 1]) === null || _navigation_matches_ === void 0 ? void 0 : _navigation_matches_.params) !== null && _navigation_matches__params !== void 0 ? _navigation_matches__params : {},
            matches: navigation.matches.map(function(m) {
                return toRouterStateMatch(m);
            })
        };
        return navigation.state === "loading" ? (0, $6fpqi._)((0, $1XAnY._)({}, shared), {
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        }) : (0, $6fpqi._)((0, $1XAnY._)({}, shared), {
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        });
    }, [
        navigation
    ]);
    return $lliNT.useMemo(function() {
        return {
            active: active,
            pending: pending
        };
    }, [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var alreadyWarned2 = {};
function warnOnce(condition, message) {
    if (!condition && !alreadyWarned2[message]) {
        alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var USE_OPTIMISTIC = "useOptimistic";
var useOptimisticImpl = $1aLYV[USE_OPTIMISTIC];
var stableUseOptimisticSetter = function() {
    return void 0;
};
function useOptimisticSafe(val) {
    if (useOptimisticImpl) return useOptimisticImpl(val);
    else return [
        val,
        stableUseOptimisticSetter
    ];
}
function mapRouteProperties(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if (ENABLE_DEV_WARNINGS) {
            if (route.element) warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $1aLYV.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if (ENABLE_DEV_WARNINGS) {
            if (route.hydrateFallbackElement) warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $1aLYV.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if (ENABLE_DEV_WARNINGS) {
            if (route.errorElement) warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $1aLYV.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var hydrationRouteProperties = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function createMemoryRouter(routes, opts) {
    return createRouter({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: createMemoryHistory({
            initialEntries: opts === null || opts === void 0 ? void 0 : opts.initialEntries,
            initialIndex: opts === null || opts === void 0 ? void 0 : opts.initialIndex
        }),
        hydrationData: opts === null || opts === void 0 ? void 0 : opts.hydrationData,
        routes: routes,
        hydrationRouteProperties: hydrationRouteProperties,
        mapRouteProperties: mapRouteProperties,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        instrumentations: opts === null || opts === void 0 ? void 0 : opts.instrumentations
    }).initialize();
}
var Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $173N4._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
function RouterProvider(param) {
    var router = param.router, reactDomFlushSyncImpl = param.flushSync, onError = param.onError, useTransitions = param.useTransitions;
    var unstable_rsc = useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    var _React3_useState = (0, $f9AOD._)($1aLYV.useState(router.state), 2), _state = _React3_useState[0], setStateImpl = _React3_useState[1];
    var _useOptimisticSafe = (0, $f9AOD._)(useOptimisticSafe(_state), 2), state = _useOptimisticSafe[0], setOptimisticState = _useOptimisticSafe[1];
    var _React3_useState1 = (0, $f9AOD._)($1aLYV.useState(), 2), pendingState = _React3_useState1[0], setPendingState = _React3_useState1[1];
    var _React3_useState2 = (0, $f9AOD._)($1aLYV.useState({
        isTransitioning: false
    }), 2), vtContext = _React3_useState2[0], setVtContext = _React3_useState2[1];
    var _React3_useState3 = (0, $f9AOD._)($1aLYV.useState(), 2), renderDfd = _React3_useState3[0], setRenderDfd = _React3_useState3[1];
    var _React3_useState4 = (0, $f9AOD._)($1aLYV.useState(), 2), transition = _React3_useState4[0], setTransition = _React3_useState4[1];
    var _React3_useState5 = (0, $f9AOD._)($1aLYV.useState(), 2), interruption = _React3_useState5[0], setInterruption = _React3_useState5[1];
    var fetcherData = $1aLYV.useRef(/* @__PURE__ */ new Map());
    var setState = $1aLYV.useCallback(function(newState, param) {
        var deletedFetchers = param.deletedFetchers, newErrors = param.newErrors, flushSync = param.flushSync, viewTransitionOpts = param.viewTransitionOpts;
        if (newErrors && onError) Object.values(newErrors).forEach(function(error) {
            var _newState_matches_;
            var _newState_matches__params;
            return onError(error, {
                location: newState.location,
                params: (_newState_matches__params = (_newState_matches_ = newState.matches[0]) === null || _newState_matches_ === void 0 ? void 0 : _newState_matches_.params) !== null && _newState_matches__params !== void 0 ? _newState_matches__params : {},
                pattern: getRoutePattern(newState.matches)
            });
        });
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        warnOnce(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        var isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        warnOnce(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(function() {
                return setStateImpl(newState);
            });
            else if (useTransitions === false) setStateImpl(newState);
            else $1aLYV.startTransition(function() {
                if (useTransitions === true) setOptimisticState(function(s) {
                    return getOptimisticRouterState(s, newState);
                });
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(function() {
                if (transition) {
                    renderDfd === null || renderDfd === void 0 ? void 0 : renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            var t = router.window.document.startViewTransition(function() {
                reactDomFlushSyncImpl(function() {
                    return setStateImpl(newState);
                });
            });
            t.finished.finally(function() {
                reactDomFlushSyncImpl(function() {
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(function() {
                return setTransition(t);
            });
            return;
        }
        if (transition) {
            renderDfd === null || renderDfd === void 0 ? void 0 : renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $1aLYV.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    $1aLYV.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    $1aLYV.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition2 = router.window.document.startViewTransition(function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (useTransitions === false) setStateImpl(newState);
                                else $1aLYV.startTransition(function() {
                                    if (useTransitions === true) setOptimisticState(function(s) {
                                        return getOptimisticRouterState(s, newState);
                                    });
                                    setStateImpl(newState);
                                });
                                return [
                                    4,
                                    renderPromise
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            });
            transition2.finished.finally(function() {
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $1aLYV.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $1aLYV.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    var navigator = $1aLYV.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state2, opts) {
                return router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state2, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $1aLYV.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        };
    }, [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $1aLYV.createElement($1aLYV.Fragment, null, /* @__PURE__ */ $1aLYV.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $1aLYV.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /* @__PURE__ */ $1aLYV.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $1aLYV.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $1aLYV.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $1aLYV.createElement(MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function getOptimisticRouterState(currentState, newState) {
    return (0, $6fpqi._)((0, $1XAnY._)({}, currentState), {
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    });
}
var MemoizedDataRoutes = $1aLYV.memo(DataRoutes2);
function DataRoutes2(param) {
    var routes = param.routes, manifest = param.manifest, future = param.future, state = param.state, isStatic = param.isStatic, onError = param.onError;
    return useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function MemoryRouter(param) {
    var basename = param.basename, children = param.children, initialEntries = param.initialEntries, initialIndex = param.initialIndex, useTransitions = param.useTransitions;
    var historyRef = $1aLYV.useRef();
    if (historyRef.current == null) historyRef.current = createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React3_useState = (0, $f9AOD._)($1aLYV.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React3_useState[0], setStateImpl = _React3_useState[1];
    var setState = $1aLYV.useCallback(function(newState) {
        if (useTransitions === false) setStateImpl(newState);
        else $1aLYV.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        useTransitions
    ]);
    $1aLYV.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $1aLYV.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function Navigate(param) {
    var to = param.to, replace2 = param.replace, state = param.state, relative = param.relative;
    invariant(useInRouterContext(), "<Navigate> may be used only in the context of a <Router> component.");
    var _React3_useContext = $1aLYV.useContext(NavigationContext), isStatic = _React3_useContext.static;
    warning(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    var matches = $1aLYV.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var navigate = useNavigate();
    var path = resolveTo(to, getResolveToMatches(matches), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $1aLYV.useEffect(function() {
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function Outlet(props) {
    return useOutlet(props.context);
}
function Route(props) {
    invariant(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
function Router(param) {
    var tmp = param.basename, basenameProp = tmp === void 0 ? "/" : tmp, _param_children = param.children, children = _param_children === void 0 ? null : _param_children, locationProp = param.location, _param_navigationType = param.navigationType, navigationType = _param_navigationType === void 0 ? "POP" /* Pop */  : _param_navigationType, navigator = param.navigator, tmp1 = param.static, staticProp = tmp1 === void 0 ? false : tmp1, useTransitions = param.useTransitions;
    invariant(!useInRouterContext(), "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $1aLYV.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        };
    }, [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = parsePath(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key, mask = locationProp.mask;
    var locationContext = $1aLYV.useMemo(function() {
        var trailingPathname = stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    warning(locationContext != null, '<Router basename="'.concat(basename, '"> is not able to match the URL "').concat(pathname).concat(search).concat(hash, "\" because it does not start with the basename, so the <Router> won't render anything."));
    if (locationContext == null) return null;
    return /* @__PURE__ */ $1aLYV.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $1aLYV.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
function Routes(param) {
    var children = param.children, location = param.location;
    return useRoutes(createRoutesFromChildren(children), location);
}
function Await(param) {
    var children = param.children, errorElement = param.errorElement, resolve = param.resolve;
    var dataRouterContext = $1aLYV.useContext(DataRouterContext);
    var dataRouterStateContext = $1aLYV.useContext(DataRouterStateContext);
    var onError = $1aLYV.useCallback(function(error, errorInfo) {
        var _dataRouterStateContext_matches_;
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: ((_dataRouterStateContext_matches_ = dataRouterStateContext.matches[0]) === null || _dataRouterStateContext_matches_ === void 0 ? void 0 : _dataRouterStateContext_matches_.params) || {},
            pattern: getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $1aLYV.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $1aLYV.createElement(ResolveAwait, null, children));
}
var AwaitErrorBoundary = /*#__PURE__*/ function(_React3_Component) {
    "use strict";
    (0, $hdIku._)(AwaitErrorBoundary, _React3_Component);
    function AwaitErrorBoundary(props) {
        (0, $173N4._)(this, AwaitErrorBoundary);
        var _this;
        _this = (0, $7qXGD._)(this, AwaitErrorBoundary, [
            props
        ]);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $cFHGC._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                if (this.props.onError) this.props.onError(error, errorInfo);
                else console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = 0 /* pending */ ;
                if (!(resolve instanceof Promise)) {
                    status = 1 /* success */ ;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    status = 2 /* error */ ;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {});
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    promise = resolve;
                    status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
                } else {
                    status = 0 /* pending */ ;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data2) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data2;
                            }
                        });
                    }, function(error) {
                        var _this_props_onError, _this_props;
                        (_this_props_onError = (_this_props = _this.props).onError) === null || _this_props_onError === void 0 ? void 0 : _this_props_onError.call(_this_props, error);
                        Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === 2 /* error */  && !errorElement) throw promise._error;
                if (status === 2 /* error */ ) return /* @__PURE__ */ $1aLYV.createElement(AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === 1 /* success */ ) return /* @__PURE__ */ $1aLYV.createElement(AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($1aLYV.Component);
function ResolveAwait(param) {
    var children = param.children;
    var data2 = useAsyncValue();
    var toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $1aLYV.createElement($1aLYV.Fragment, null, toRender);
}
function createRoutesFromChildren(children) {
    var parentPath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var routes = [];
    $1aLYV.Children.forEach(children, function(element, index) {
        if (!$1aLYV.isValidElement(element)) return;
        var treePath = (0, $aUGqu._)(parentPath).concat([
            index
        ]);
        if (element.type === $1aLYV.Fragment) {
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        invariant(element.type === Route, "[".concat(typeof element.type === "string" ? element.type : element.type.name, "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>"));
        invariant(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var createRoutesFromElements = createRoutesFromChildren;
function renderMatches(matches) {
    return _renderMatches(matches);
}
function useRouteComponentProps() {
    return {
        params: useParams(),
        loaderData: useLoaderData(),
        actionData: useActionData(),
        matches: useMatches()
    };
}
function WithComponentProps(param) {
    var children = param.children;
    var props = useRouteComponentProps();
    return $1aLYV.cloneElement(children, props);
}
function withComponentProps(Component4) {
    return function WithComponentProps2() {
        var props = useRouteComponentProps();
        return $1aLYV.createElement(Component4, props);
    };
}
function useHydrateFallbackProps() {
    return {
        params: useParams(),
        loaderData: useLoaderData(),
        actionData: useActionData()
    };
}
function WithHydrateFallbackProps(param) {
    var children = param.children;
    var props = useHydrateFallbackProps();
    return $1aLYV.cloneElement(children, props);
}
function withHydrateFallbackProps(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        var props = useHydrateFallbackProps();
        return $1aLYV.createElement(HydrateFallback, props);
    };
}
function useErrorBoundaryProps() {
    return {
        params: useParams(),
        loaderData: useLoaderData(),
        actionData: useActionData(),
        error: useRouteError()
    };
}
function WithErrorBoundaryProps(param) {
    var children = param.children;
    var props = useErrorBoundaryProps();
    return $1aLYV.cloneElement(children, props);
}
function withErrorBoundaryProps(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        var props = useErrorBoundaryProps();
        return $1aLYV.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var defaultMethod = "get";
var defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event);
}
function createSearchParams() {
    var init = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo2, key) {
        var value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
var supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) {
        warning(false, '"'.concat(encType, '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` and will default to "').concat(defaultEncType, '"'));
        return null;
    }
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if (isFormElement(target)) {
        var attr = target.getAttribute("action");
        action = attr ? stripBasename(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? stripBasename(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(form, target);
        if (!isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? "".concat(name, ".") : "";
                formData.append("".concat(prefix, "x"), "0");
                formData.append("".concat(prefix, "y"), "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var HOLE = -1;
var NAN = -2;
var NEGATIVE_INFINITY = -3;
var NEGATIVE_ZERO = -4;
var NULL = -5;
var POSITIVE_INFINITY = -6;
var UNDEFINED = -7;
var TYPE_BIGINT = "B";
var TYPE_DATE = "D";
var TYPE_ERROR = "E";
var TYPE_MAP = "M";
var TYPE_NULL_OBJECT = "N";
var TYPE_PROMISE = "P";
var TYPE_REGEXP = "R";
var TYPE_SET = "S";
var TYPE_SYMBOL = "Y";
var TYPE_URL = "U";
var TYPE_PREVIOUS_RESOLVED = "Z";
var Deferred2 = function Deferred2() {
    "use strict";
    var _this = this;
    (0, $173N4._)(this, Deferred2);
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
    });
};
function createLineSplittingTransform() {
    var decoder = new TextDecoder();
    var leftover = "";
    return new TransformStream({
        transform: function(chunk, controller) {
            var str = decoder.decode(chunk, {
                stream: true
            });
            var parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var part = _step.value;
                    controller.enqueue(part);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        flush: function(controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var TIME_LIMIT_MS = 1;
var getNow = function() {
    return Date.now();
};
var yieldToMain = function() {
    return new Promise(function(resolve) {
        return setTimeout(resolve, 0);
    });
};
function flatten(input) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var indices, existing, index, stack;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    indices = this.indices;
                    existing = indices.get(input);
                    if (existing) return [
                        2,
                        [
                            existing
                        ]
                    ];
                    if (input === void 0) return [
                        2,
                        UNDEFINED
                    ];
                    if (input === null) return [
                        2,
                        NULL
                    ];
                    if (Number.isNaN(input)) return [
                        2,
                        NAN
                    ];
                    if (input === Number.POSITIVE_INFINITY) return [
                        2,
                        POSITIVE_INFINITY
                    ];
                    if (input === Number.NEGATIVE_INFINITY) return [
                        2,
                        NEGATIVE_INFINITY
                    ];
                    if (input === 0 && 1 / input < 0) return [
                        2,
                        NEGATIVE_ZERO
                    ];
                    index = this.index++;
                    indices.set(input, index);
                    stack = [
                        [
                            input,
                            index
                        ]
                    ];
                    return [
                        4,
                        stringify.call(this, stack)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        index
                    ];
            }
        });
    }).call(this);
}
function stringify(stack) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var _this, _this1, deferred, indices, plugins, postPlugins, str, lastYieldTime, flattenValue, i, now, _stack_pop, input, index, partsForObj, error, keyFor, isArray, pluginHandled, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, plugin, pluginResult, _pluginResult, pluginIdentifier, rest, result, i2, dateTime, isArray1, pluginHandled1, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, plugin1, pluginResult1, _pluginResult1, pluginIdentifier1, rest1, pluginHandled2, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, plugin2, pluginResult2, _pluginResult2, pluginIdentifier2, rest2;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _this = this;
                    _this1 = this, deferred = _this1.deferred, indices = _this1.indices, plugins = _this1.plugins, postPlugins = _this1.postPlugins;
                    str = this.stringified;
                    lastYieldTime = getNow();
                    flattenValue = function(value) {
                        var existing = indices.get(value);
                        if (existing) return [
                            existing
                        ];
                        if (value === void 0) return UNDEFINED;
                        if (value === null) return NULL;
                        if (Number.isNaN(value)) return NAN;
                        if (value === Number.POSITIVE_INFINITY) return POSITIVE_INFINITY;
                        if (value === Number.NEGATIVE_INFINITY) return NEGATIVE_INFINITY;
                        if (value === 0 && 1 / value < 0) return NEGATIVE_ZERO;
                        var index = _this.index++;
                        indices.set(value, index);
                        stack.push([
                            value,
                            index
                        ]);
                        return index;
                    };
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(stack.length > 0)) return [
                        3,
                        4
                    ];
                    now = getNow();
                    if (!(++i % 6e3 === 0 && now - lastYieldTime >= TIME_LIMIT_MS)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        yieldToMain()
                    ];
                case 2:
                    _state.sent();
                    lastYieldTime = getNow();
                    _state.label = 3;
                case 3:
                    _stack_pop = (0, $f9AOD._)(stack.pop(), 2), input = _stack_pop[0], index = _stack_pop[1];
                    partsForObj = function(obj) {
                        return Object.keys(obj).map(function(k) {
                            return '"_'.concat(flattenValue(k), '":').concat(flattenValue(obj[k]));
                        }).join(",");
                    };
                    error = null;
                    switch(typeof input === "undefined" ? "undefined" : (0, $7E0eS._)(input)){
                        case "boolean":
                        case "number":
                        case "string":
                            str[index] = JSON.stringify(input);
                            break;
                        case "bigint":
                            str[index] = '["'.concat(TYPE_BIGINT, '","').concat(input, '"]');
                            break;
                        case "symbol":
                            {
                                keyFor = Symbol.keyFor(input);
                                if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                                else str[index] = '["'.concat(TYPE_SYMBOL, '",').concat(JSON.stringify(keyFor), "]");
                                break;
                            }
                        case "object":
                            {
                                if (!input) {
                                    str[index] = "".concat(NULL);
                                    break;
                                }
                                isArray = Array.isArray(input);
                                pluginHandled = false;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (!isArray && plugins) try {
                                    for(_iterator = plugins[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        plugin = _step.value;
                                        pluginResult = plugin(input);
                                        if (Array.isArray(pluginResult)) {
                                            pluginHandled = true;
                                            _pluginResult = (0, $iQDyc._)(pluginResult), pluginIdentifier = _pluginResult[0], rest = _pluginResult.slice(1);
                                            str[index] = "[".concat(JSON.stringify(pluginIdentifier));
                                            if (rest.length > 0) str[index] += ",".concat(rest.map(function(v) {
                                                return flattenValue(v);
                                            }).join(","));
                                            str[index] += "]";
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                if (!pluginHandled) {
                                    result = isArray ? "[" : "{";
                                    if (isArray) {
                                        for(i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : HOLE);
                                        str[index] = "".concat(result, "]");
                                    } else if (input instanceof Date) {
                                        dateTime = input.getTime();
                                        str[index] = '["'.concat(TYPE_DATE, '",').concat(Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime, "]");
                                    } else if (input instanceof URL) str[index] = '["'.concat(TYPE_URL, '",').concat(JSON.stringify(input.href), "]");
                                    else if (input instanceof RegExp) str[index] = '["'.concat(TYPE_REGEXP, '",').concat(JSON.stringify(input.source), ",").concat(JSON.stringify(input.flags), "]");
                                    else if (input instanceof Set) {
                                        if (input.size > 0) str[index] = '["'.concat(TYPE_SET, '",').concat((0, $aUGqu._)(input).map(function(val) {
                                            return flattenValue(val);
                                        }).join(","), "]");
                                        else str[index] = '["'.concat(TYPE_SET, '"]');
                                    } else if (input instanceof Map) {
                                        if (input.size > 0) str[index] = '["'.concat(TYPE_MAP, '",').concat((0, $aUGqu._)(input).flatMap(function(param) {
                                            var _param = (0, $f9AOD._)(param, 2), k = _param[0], v = _param[1];
                                            return [
                                                flattenValue(k),
                                                flattenValue(v)
                                            ];
                                        }).join(","), "]");
                                        else str[index] = '["'.concat(TYPE_MAP, '"]');
                                    } else if (input instanceof Promise) {
                                        str[index] = '["'.concat(TYPE_PROMISE, '",').concat(index, "]");
                                        deferred[index] = input;
                                    } else if (input instanceof Error) {
                                        str[index] = '["'.concat(TYPE_ERROR, '",').concat(JSON.stringify(input.message));
                                        if (input.name !== "Error") str[index] += ",".concat(JSON.stringify(input.name));
                                        str[index] += "]";
                                    } else if (Object.getPrototypeOf(input) === null) str[index] = '["'.concat(TYPE_NULL_OBJECT, '",{').concat(partsForObj(input), "}]");
                                    else if (isPlainObject2(input)) str[index] = "{".concat(partsForObj(input), "}");
                                    else error = new Error("Cannot encode object with prototype");
                                }
                                break;
                            }
                        default:
                            {
                                isArray1 = Array.isArray(input);
                                pluginHandled1 = false;
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                if (!isArray1 && plugins) try {
                                    for(_iterator1 = plugins[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        plugin1 = _step1.value;
                                        pluginResult1 = plugin1(input);
                                        if (Array.isArray(pluginResult1)) {
                                            pluginHandled1 = true;
                                            _pluginResult1 = (0, $iQDyc._)(pluginResult1), pluginIdentifier1 = _pluginResult1[0], rest1 = _pluginResult1.slice(1);
                                            str[index] = "[".concat(JSON.stringify(pluginIdentifier1));
                                            if (rest1.length > 0) str[index] += ",".concat(rest1.map(function(v) {
                                                return flattenValue(v);
                                            }).join(","));
                                            str[index] += "]";
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                if (!pluginHandled1) error = new Error("Cannot encode function or unexpected type");
                            }
                    }
                    if (error) {
                        pluginHandled2 = false;
                        _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        if (postPlugins) try {
                            for(_iterator2 = postPlugins[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                plugin2 = _step2.value;
                                pluginResult2 = plugin2(input);
                                if (Array.isArray(pluginResult2)) {
                                    pluginHandled2 = true;
                                    _pluginResult2 = (0, $iQDyc._)(pluginResult2), pluginIdentifier2 = _pluginResult2[0], rest2 = _pluginResult2.slice(1);
                                    str[index] = "[".concat(JSON.stringify(pluginIdentifier2));
                                    if (rest2.length > 0) str[index] += ",".concat(rest2.map(function(v) {
                                        return flattenValue(v);
                                    }).join(","));
                                    str[index] += "]";
                                    break;
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                    _iterator2.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                        if (!pluginHandled2) throw error;
                    }
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
var objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function isPlainObject2(thing) {
    var proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function unflatten(parsed) {
    var _this = this, hydrated = _this.hydrated, values = _this.values;
    if (typeof parsed === "number") return hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    var startIndex = values.length;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parsed[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            values.push(value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    hydrated.length = values.length;
    return hydrate.call(this, startIndex);
}
function hydrate(index) {
    var _loop = function() {
        var _stack_pop = (0, $f9AOD._)(stack.pop(), 2), index2 = _stack_pop[0], set = _stack_pop[1];
        switch(index2){
            case UNDEFINED:
                set(void 0);
                return "continue";
            case NULL:
                set(null);
                return "continue";
            case NAN:
                set(NaN);
                return "continue";
            case POSITIVE_INFINITY:
                set(Infinity);
                return "continue";
            case NEGATIVE_INFINITY:
                set(-Infinity);
                return "continue";
            case NEGATIVE_ZERO:
                set(-0);
                return "continue";
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            return "continue";
        }
        var value = values[index2];
        if (!value || (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) !== "object") {
            hydrated[index2] = value;
            set(value);
            return "continue";
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                var _value = (0, $f9AOD._)(value, 3), type = _value[0], b = _value[1], c = _value[2];
                switch(type){
                    case TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        return "continue";
                    case TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        return "continue";
                    case TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        return "continue";
                    case TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        return "continue";
                    case TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        return "continue";
                    case TYPE_SET:
                        var newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(var i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            function(v) {
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        return "continue";
                    case TYPE_MAP:
                        var _loop = function(i1) {
                            var r = [];
                            stack.push([
                                value[i1 + 1],
                                function(v) {
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i1],
                                function(k) {
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(function() {
                                map.set(r[0], r[1]);
                            });
                        };
                        var map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(var i1 = value.length - 2; i1 > 0; i1 -= 2)_loop(i1);
                        set(map);
                        return "continue";
                    case TYPE_NULL_OBJECT:
                        var obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            var _loop1 = function() {
                                var key = _step.value;
                                var r = [];
                                stack.push([
                                    b[key],
                                    function(v) {
                                        r[1] = v;
                                    }
                                ]);
                                stack.push([
                                    Number(key.slice(1)),
                                    function(k) {
                                        r[0] = k;
                                    }
                                ]);
                                postRun.push(function() {
                                    obj[r[0]] = r[1];
                                });
                            };
                            for(var _iterator = Object.keys(b).reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop1();
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        set(obj);
                        return "continue";
                    case TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            var d = new Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        return "continue";
                    case TYPE_ERROR:
                        var _value1 = (0, $f9AOD._)(value, 3), message = _value1[1], errorType = _value1[2];
                        var error = errorType && globalObj && SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in globalObj && typeof globalObj[errorType] === "function" ? new globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        return "continue";
                    case TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        return "continue";
                    default:
                        if (Array.isArray(plugins)) {
                            var _loop2 = function(i2) {
                                var v = vals[i2];
                                stack.push([
                                    v,
                                    function(v2) {
                                        r[i2] = v2;
                                    }
                                ]);
                            };
                            var r = [];
                            var vals = value.slice(1);
                            for(var i2 = 0; i2 < vals.length; i2++)_loop2(i2);
                            postRun.push(function() {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var plugin = _step.value;
                                        var result2 = plugin.apply(void 0, [
                                            value[0]
                                        ].concat((0, $aUGqu._)(r)));
                                        if (result2) {
                                            set(hydrated[index2] = result2.value);
                                            return;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                throw new SyntaxError();
                            });
                            return "continue";
                        }
                        throw new SyntaxError();
                }
            } else {
                var _loop3 = function(i3) {
                    var n = value[i3];
                    if (n !== HOLE) stack.push([
                        n,
                        function(v) {
                            array[i3] = v;
                        }
                    ]);
                };
                var array = [];
                hydrated[index2] = array;
                for(var i3 = 0; i3 < value.length; i3++)_loop3(i3);
                set(array);
                return "continue";
            }
        } else {
            var object = {};
            hydrated[index2] = object;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                var _loop4 = function() {
                    var key = _step1.value;
                    var r = [];
                    stack.push([
                        value[key],
                        function(v) {
                            r[1] = v;
                        }
                    ]);
                    stack.push([
                        Number(key.slice(1)),
                        function(k) {
                            r[0] = k;
                        }
                    ]);
                    postRun.push(function() {
                        object[r[0]] = r[1];
                    });
                };
                for(var _iterator1 = Object.keys(value).reverse()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop4();
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            set(object);
            return "continue";
        }
    };
    var _this = this, hydrated = _this.hydrated, values = _this.values, deferred = _this.deferred, plugins = _this.plugins;
    var result;
    var stack = [
        [
            index,
            function(v) {
                result = v;
            }
        ]
    ];
    var postRun = [];
    while(stack.length > 0)_loop();
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
function decode(readable, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var plugins, done, reader, decoder, decoded, donePromise;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    plugins = (options !== null && options !== void 0 ? options : {}).plugins;
                    done = new Deferred2();
                    reader = readable.pipeThrough(createLineSplittingTransform()).getReader();
                    decoder = {
                        values: [],
                        hydrated: [],
                        deferred: {},
                        plugins: plugins
                    };
                    return [
                        4,
                        decodeInitial.call(decoder, reader)
                    ];
                case 1:
                    decoded = _state.sent();
                    donePromise = done.promise;
                    if (decoded.done) done.resolve();
                    else donePromise = decodeDeferred.call(decoder, reader).then(done.resolve).catch(function(reason) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.values(decoder.deferred)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var deferred = _step.value;
                                deferred.reject(reason);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        done.reject(reason);
                    });
                    return [
                        2,
                        {
                            done: donePromise.then(function() {
                                return reader.closed;
                            }),
                            value: decoded.value
                        }
                    ];
            }
        });
    })();
}
function decodeInitial(reader) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var read, line;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        reader.read()
                    ];
                case 1:
                    read = _state.sent();
                    if (!read.value) throw new SyntaxError();
                    try {
                        line = JSON.parse(read.value);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    return [
                        2,
                        {
                            done: read.done,
                            value: unflatten.call(this, line)
                        }
                    ];
            }
        });
    }).call(this);
}
function decodeDeferred(reader) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var read, line, colonIndex, deferredId, deferred, lineData, jsonLine, value, colonIndex1, deferredId1, deferred1, lineData1, jsonLine1, value1;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        reader.read()
                    ];
                case 1:
                    read = _state.sent();
                    _state.label = 2;
                case 2:
                    if (!!read.done) return [
                        3,
                        4
                    ];
                    if (!read.value) return [
                        3,
                        2
                    ];
                    line = read.value;
                    switch(line[0]){
                        case TYPE_PROMISE:
                            {
                                colonIndex = line.indexOf(":");
                                deferredId = Number(line.slice(1, colonIndex));
                                deferred = this.deferred[deferredId];
                                if (!deferred) throw new Error("Deferred ID ".concat(deferredId, " not found in stream"));
                                lineData = line.slice(colonIndex + 1);
                                jsonLine = void 0;
                                try {
                                    jsonLine = JSON.parse(lineData);
                                } catch (reason) {
                                    throw new SyntaxError();
                                }
                                value = unflatten.call(this, jsonLine);
                                deferred.resolve(value);
                                break;
                            }
                        case TYPE_ERROR:
                            {
                                colonIndex1 = line.indexOf(":");
                                deferredId1 = Number(line.slice(1, colonIndex1));
                                deferred1 = this.deferred[deferredId1];
                                if (!deferred1) throw new Error("Deferred ID ".concat(deferredId1, " not found in stream"));
                                lineData1 = line.slice(colonIndex1 + 1);
                                jsonLine1 = void 0;
                                try {
                                    jsonLine1 = JSON.parse(lineData1);
                                } catch (reason) {
                                    throw new SyntaxError();
                                }
                                value1 = unflatten.call(this, jsonLine1);
                                deferred1.reject(value1);
                                break;
                            }
                        default:
                            throw new SyntaxError();
                    }
                    return [
                        4,
                        reader.read()
                    ];
                case 3:
                    read = _state.sent();
                    return [
                        3,
                        2
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function encode(input, options) {
    var _ref = options !== null && options !== void 0 ? options : {}, onComplete = _ref.onComplete, plugins = _ref.plugins, postPlugins = _ref.postPlugins, signal = _ref.signal;
    var encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    var textEncoder = new TextEncoder();
    var lastSentIndex = 0;
    var readable = new ReadableStream({
        start: function(controller) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var id, seenPromises, processingChain, raceDone, racePromise, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                flatten.call(encoder, input)
                            ];
                        case 1:
                            id = _state.sent();
                            if (Array.isArray(id)) throw new Error("This should never happen");
                            if (id < 0) controller.enqueue(textEncoder.encode("".concat(id, "\n")));
                            else {
                                controller.enqueue(textEncoder.encode("[".concat(encoder.stringified.join(","), "]\n")));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                            seenPromises = /* @__PURE__ */ new WeakSet();
                            processingChain = Promise.resolve();
                            if (!Object.keys(encoder.deferred).length) return [
                                3,
                                5
                            ];
                            racePromise = new Promise(function(resolve, reject) {
                                raceDone = resolve;
                                if (signal) {
                                    var rejectPromise = function() {
                                        return reject(signal.reason || new Error("Signal was aborted."));
                                    };
                                    if (signal.aborted) rejectPromise();
                                    else signal.addEventListener("abort", function(event) {
                                        rejectPromise();
                                    });
                                }
                            });
                            _state.label = 2;
                        case 2:
                            if (!(Object.keys(encoder.deferred).length > 0)) return [
                                3,
                                4
                            ];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                _loop = function() {
                                    var _step_value = (0, $f9AOD._)(_step.value, 2), deferredId = _step_value[0], deferred = _step_value[1];
                                    if (seenPromises.has(deferred)) return "continue";
                                    seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                                    encoder.deferred[Number(deferredId)] = Promise.race([
                                        racePromise,
                                        deferred
                                    ]).then(function(resolved) {
                                        processingChain = processingChain.then(function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                                var id2, values;
                                                return (0, $13u2V._)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                flatten.call(encoder, resolved)
                                                            ];
                                                        case 1:
                                                            id2 = _state.sent();
                                                            if (Array.isArray(id2)) {
                                                                controller.enqueue(textEncoder.encode("".concat(TYPE_PROMISE).concat(deferredId, ':[["').concat(TYPE_PREVIOUS_RESOLVED, '",').concat(id2[0], "]]\n")));
                                                                encoder.index++;
                                                                lastSentIndex++;
                                                            } else if (id2 < 0) controller.enqueue(textEncoder.encode("".concat(TYPE_PROMISE).concat(deferredId, ":").concat(id2, "\n")));
                                                            else {
                                                                values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                                                controller.enqueue(textEncoder.encode("".concat(TYPE_PROMISE).concat(deferredId, ":[").concat(values, "]\n")));
                                                                lastSentIndex = encoder.stringified.length - 1;
                                                            }
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            })();
                                        });
                                        return processingChain;
                                    }, function(reason) {
                                        processingChain = processingChain.then(function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                                var id2, values;
                                                return (0, $13u2V._)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            if (!reason || (typeof reason === "undefined" ? "undefined" : (0, $7E0eS._)(reason)) !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                                            return [
                                                                4,
                                                                flatten.call(encoder, reason)
                                                            ];
                                                        case 1:
                                                            id2 = _state.sent();
                                                            if (Array.isArray(id2)) {
                                                                controller.enqueue(textEncoder.encode("".concat(TYPE_ERROR).concat(deferredId, ':[["').concat(TYPE_PREVIOUS_RESOLVED, '",').concat(id2[0], "]]\n")));
                                                                encoder.index++;
                                                                lastSentIndex++;
                                                            } else if (id2 < 0) controller.enqueue(textEncoder.encode("".concat(TYPE_ERROR).concat(deferredId, ":").concat(id2, "\n")));
                                                            else {
                                                                values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                                                controller.enqueue(textEncoder.encode("".concat(TYPE_ERROR).concat(deferredId, ":[").concat(values, "]\n")));
                                                                lastSentIndex = encoder.stringified.length - 1;
                                                            }
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            })();
                                        });
                                        return processingChain;
                                    }).finally(function() {
                                        delete encoder.deferred[Number(deferredId)];
                                    }));
                                };
                                for(_iterator = Object.entries(encoder.deferred)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return [
                                4,
                                Promise.race(Object.values(encoder.deferred))
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                2
                            ];
                        case 4:
                            raceDone();
                            _state.label = 5;
                        case 5:
                            return [
                                4,
                                Promise.all(Object.values(encoder.deferred))
                            ];
                        case 6:
                            _state.sent();
                            return [
                                4,
                                processingChain
                            ];
                        case 7:
                            _state.sent();
                            controller.close();
                            onComplete === null || onComplete === void 0 ? void 0 : onComplete();
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
function createRequestInit(request) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var init, contentType, _, _1;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    init = {
                        signal: request.signal
                    };
                    if (!(request.method !== "GET")) return [
                        3,
                        8
                    ];
                    init.method = request.method;
                    contentType = request.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        2
                    ];
                    init.headers = {
                        "Content-Type": contentType
                    };
                    _ = JSON.stringify;
                    return [
                        4,
                        request.json()
                    ];
                case 1:
                    init.body = _.apply(JSON, [
                        _state.sent()
                    ]);
                    return [
                        3,
                        8
                    ];
                case 2:
                    if (!(contentType && /\btext\/plain\b/.test(contentType))) return [
                        3,
                        4
                    ];
                    init.headers = {
                        "Content-Type": contentType
                    };
                    return [
                        4,
                        request.text()
                    ];
                case 3:
                    init.body = _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!(contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType))) return [
                        3,
                        6
                    ];
                    _1 = URLSearchParams.bind;
                    return [
                        4,
                        request.text()
                    ];
                case 5:
                    init.body = new (_1.apply(URLSearchParams, [
                        void 0,
                        _state.sent()
                    ]));
                    return [
                        3,
                        8
                    ];
                case 6:
                    return [
                        4,
                        request.formData()
                    ];
                case 7:
                    init.body = _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        2,
                        init
                    ];
            }
        });
    })();
}
// lib/dom/ssr/markup.ts
var ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function escapeHtml(html) {
    return html.replace(ESCAPE_REGEX, function(match) {
        return ESCAPE_LOOKUP[match];
    });
}
// lib/dom/ssr/invariant.ts
function invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var SingleFetchRedirectSymbol = Symbol("SingleFetchRedirect");
var SingleFetchNoResultError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $hdIku._)(SingleFetchNoResultError, Error1);
    function SingleFetchNoResultError() {
        (0, $173N4._)(this, SingleFetchNoResultError);
        return (0, $7qXGD._)(this, SingleFetchNoResultError, arguments);
    }
    return SingleFetchNoResultError;
}((0, $1SdK7._)(Error));
var SINGLE_FETCH_REDIRECT_STATUS = 202;
var NO_BODY_STATUS_CODES = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function StreamTransfer(param) {
    var context = param.context, identifier = param.identifier, reader = param.reader, textDecoder = param.textDecoder, nonce = param.nonce;
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    var streamCache = context.renderMeta.streamCache;
    var promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then(function(result) {
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch(function(e) {
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    var _promise_result = promise.result, done = _promise_result.done, value = _promise_result.value;
    var scriptTag = value ? /* @__PURE__ */ $tLNoZ.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: "window.__reactRouterContext.streamController.enqueue(".concat(escapeHtml(JSON.stringify(value)), ");")
        }
    }) : null;
    if (done) return /* @__PURE__ */ $tLNoZ.createElement($tLNoZ.Fragment, null, scriptTag, /* @__PURE__ */ $tLNoZ.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: "window.__reactRouterContext.streamController.close();"
        }
    }));
    else return /* @__PURE__ */ $tLNoZ.createElement($tLNoZ.Fragment, null, scriptTag, /* @__PURE__ */ $tLNoZ.createElement($1aLYV.Suspense, null, /* @__PURE__ */ $tLNoZ.createElement(StreamTransfer, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function getTurboStreamSingleFetchDataStrategy(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    var dataStrategy = getSingleFetchDataStrategyImpl(getRouter, function(match) {
        var manifestRoute = manifest.routes[match.route.id];
        invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return function(args) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            return (0, $13u2V._)(this, function(_state) {
                return [
                    2,
                    args.runClientMiddleware(dataStrategy)
                ];
            });
        })();
    };
}
function getSingleFetchDataStrategyImpl(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware) {
    var shouldAllowOptOut = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : function() {
        return true;
    };
    return function(args) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var request, matches, fetcherKey, router, foundRevalidatingServerLoader;
            return (0, $13u2V._)(this, function(_state) {
                request = args.request, matches = args.matches, fetcherKey = args.fetcherKey;
                router = getRouter();
                if (request.method !== "GET") return [
                    2,
                    singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware)
                ];
                foundRevalidatingServerLoader = matches.some(function(m) {
                    var _getRouteInfo = getRouteInfo(m), hasLoader = _getRouteInfo.hasLoader, hasClientLoader = _getRouteInfo.hasClientLoader;
                    return m.shouldCallHandler() && hasLoader && !hasClientLoader;
                });
                if (!ssr && !foundRevalidatingServerLoader) return [
                    2,
                    nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware)
                ];
                if (fetcherKey) return [
                    2,
                    singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware)
                ];
                return [
                    2,
                    singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut)
                ];
            });
        })();
    };
}
function singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var actionMatch, actionStatus, result;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    actionMatch = args.matches.find(function(m) {
                        return m.shouldCallHandler();
                    });
                    invariant2(actionMatch, "No action match found");
                    actionStatus = void 0;
                    return [
                        4,
                        actionMatch.resolve(function(handler) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                var result2;
                                return (0, $13u2V._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                handler(function() {
                                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                                        var _ref, data2, status;
                                                        return (0, $13u2V._)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    return [
                                                                        4,
                                                                        fetchAndDecode(args, basename, trailingSlashAware, [
                                                                            actionMatch.route.id
                                                                        ])
                                                                    ];
                                                                case 1:
                                                                    _ref = _state.sent(), data2 = _ref.data, status = _ref.status;
                                                                    actionStatus = status;
                                                                    return [
                                                                        2,
                                                                        unwrapSingleFetchResult(data2, actionMatch.route.id)
                                                                    ];
                                                            }
                                                        });
                                                    })();
                                                })
                                            ];
                                        case 1:
                                            result2 = _state.sent();
                                            return [
                                                2,
                                                result2
                                            ];
                                    }
                                });
                            })();
                        })
                    ];
                case 1:
                    result = _state.sent();
                    if (isResponse(result.result) || isRouteErrorResponse(result.result) || isDataWithResponseInit(result.result)) return [
                        2,
                        (0, $7Pjls._)({}, actionMatch.route.id, result)
                    ];
                    return [
                        2,
                        (0, $7Pjls._)({}, actionMatch.route.id, {
                            type: result.type,
                            result: data(result.result, actionStatus)
                        })
                    ];
            }
        });
    })();
}
function nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var matchesToLoad, results;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matchesToLoad = args.matches.filter(function(m) {
                        return m.shouldCallHandler();
                    });
                    results = {};
                    return [
                        4,
                        Promise.all(matchesToLoad.map(function(m) {
                            return m.resolve(function(handler) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                    var hasClientLoader, routeId, result, _tmp, e;
                                    return (0, $13u2V._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _state.trys.push([
                                                    0,
                                                    5,
                                                    ,
                                                    6
                                                ]);
                                                hasClientLoader = getRouteInfo(m).hasClientLoader;
                                                routeId = m.route.id;
                                                if (!hasClientLoader) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    handler(function() {
                                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                                            var _ref, data2;
                                                            return (0, $13u2V._)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            fetchAndDecode(args, basename, trailingSlashAware, [
                                                                                routeId
                                                                            ])
                                                                        ];
                                                                    case 1:
                                                                        _ref = _state.sent(), data2 = _ref.data;
                                                                        return [
                                                                            2,
                                                                            unwrapSingleFetchResult(data2, routeId)
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    })
                                                ];
                                            case 1:
                                                _tmp = _state.sent();
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 2:
                                                return [
                                                    4,
                                                    handler()
                                                ];
                                            case 3:
                                                _tmp = _state.sent();
                                                _state.label = 4;
                                            case 4:
                                                result = _tmp;
                                                results[m.route.id] = {
                                                    type: "data",
                                                    result: result
                                                };
                                                return [
                                                    3,
                                                    6
                                                ];
                                            case 5:
                                                e = _state.sent();
                                                results[m.route.id] = {
                                                    type: "error",
                                                    result: e
                                                };
                                                return [
                                                    3,
                                                    6
                                                ];
                                            case 6:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            });
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        results
                    ];
            }
        });
    })();
}
function singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware) {
    var shouldAllowOptOut = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : function() {
        return true;
    };
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var routesParams, foundOptOutRoute, routeDfds, singleFetchDfd, results, resolvePromise, isInitialLoad, targetRoutes, data2, e;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    routesParams = /* @__PURE__ */ new Set();
                    foundOptOutRoute = false;
                    routeDfds = args.matches.map(function() {
                        return createDeferred2();
                    });
                    singleFetchDfd = createDeferred2();
                    results = {};
                    resolvePromise = Promise.all(args.matches.map(function(m, i) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                            return (0, $13u2V._)(this, function(_state) {
                                return [
                                    2,
                                    m.resolve(function(handler) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                            var routeId, _getRouteInfo, hasLoader, hasClientLoader, defaultShouldRevalidate, shouldCall, result, e, result1, e1;
                                            return (0, $13u2V._)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        routeDfds[i].resolve();
                                                        routeId = m.route.id;
                                                        _getRouteInfo = getRouteInfo(m), hasLoader = _getRouteInfo.hasLoader, hasClientLoader = _getRouteInfo.hasClientLoader;
                                                        defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
                                                        shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
                                                        if (!shouldCall) {
                                                            foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                                                            hasLoader);
                                                            return [
                                                                2
                                                            ];
                                                        }
                                                        if (!(shouldAllowOptOut(m) && hasClientLoader)) return [
                                                            3,
                                                            5
                                                        ];
                                                        if (hasLoader) foundOptOutRoute = true;
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4,
                                                            handler(function() {
                                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                                                    var _ref, data2;
                                                                    return (0, $13u2V._)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                return [
                                                                                    4,
                                                                                    fetchAndDecode(args, basename, trailingSlashAware, [
                                                                                        routeId
                                                                                    ])
                                                                                ];
                                                                            case 1:
                                                                                _ref = _state.sent(), data2 = _ref.data;
                                                                                return [
                                                                                    2,
                                                                                    unwrapSingleFetchResult(data2, routeId)
                                                                                ];
                                                                        }
                                                                    });
                                                                })();
                                                            })
                                                        ];
                                                    case 2:
                                                        result = _state.sent();
                                                        results[routeId] = {
                                                            type: "data",
                                                            result: result
                                                        };
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 3:
                                                        e = _state.sent();
                                                        results[routeId] = {
                                                            type: "error",
                                                            result: e
                                                        };
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 4:
                                                        return [
                                                            2
                                                        ];
                                                    case 5:
                                                        if (hasLoader) routesParams.add(routeId);
                                                        _state.label = 6;
                                                    case 6:
                                                        _state.trys.push([
                                                            6,
                                                            8,
                                                            ,
                                                            9
                                                        ]);
                                                        return [
                                                            4,
                                                            handler(function() {
                                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                                                    var data2;
                                                                    return (0, $13u2V._)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                return [
                                                                                    4,
                                                                                    singleFetchDfd.promise
                                                                                ];
                                                                            case 1:
                                                                                data2 = _state.sent();
                                                                                return [
                                                                                    2,
                                                                                    unwrapSingleFetchResult(data2, routeId)
                                                                                ];
                                                                        }
                                                                    });
                                                                })();
                                                            })
                                                        ];
                                                    case 7:
                                                        result1 = _state.sent();
                                                        results[routeId] = {
                                                            type: "data",
                                                            result: result1
                                                        };
                                                        return [
                                                            3,
                                                            9
                                                        ];
                                                    case 8:
                                                        e1 = _state.sent();
                                                        results[routeId] = {
                                                            type: "error",
                                                            result: e1
                                                        };
                                                        return [
                                                            3,
                                                            9
                                                        ];
                                                    case 9:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        })();
                                    })
                                ];
                            });
                        })();
                    }));
                    return [
                        4,
                        Promise.all(routeDfds.map(function(d) {
                            return d.promise;
                        }))
                    ];
                case 1:
                    _state.sent();
                    isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
                    if (!((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive)) return [
                        3,
                        2
                    ];
                    singleFetchDfd.resolve({
                        routes: {}
                    });
                    return [
                        3,
                        6
                    ];
                case 2:
                    targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? (0, $aUGqu._)(routesParams.keys()) : void 0;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        fetchAndDecode(args, basename, trailingSlashAware, targetRoutes)
                    ];
                case 4:
                    data2 = _state.sent();
                    singleFetchDfd.resolve(data2.data);
                    return [
                        3,
                        6
                    ];
                case 5:
                    e = _state.sent();
                    singleFetchDfd.reject(e);
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        4,
                        resolvePromise
                    ];
                case 7:
                    _state.sent();
                    return [
                        4,
                        bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results)
                    ];
                case 8:
                    _state.sent();
                    return [
                        2,
                        results
                    ];
            }
        });
    })();
}
function bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var middlewareError, fetchedData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match, routeResult, _results_match_route_id, e;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        singleFetchPromise
                    ];
                case 1:
                    fetchedData = _state.sent();
                    if ("routes" in fetchedData) {
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = matches[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                match = _step.value;
                                if (match.route.id in fetchedData.routes) {
                                    routeResult = fetchedData.routes[match.route.id];
                                    if ("error" in routeResult) {
                                        ;
                                        middlewareError = routeResult.error;
                                        if (((_results_match_route_id = results[match.route.id]) === null || _results_match_route_id === void 0 ? void 0 : _results_match_route_id.result) == null) results[match.route.id] = {
                                            type: "error",
                                            result: middlewareError
                                        };
                                        break;
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                    if (middlewareError !== void 0) Array.from(routesParams.values()).forEach(function(routeId) {
                        if (results[routeId].result instanceof SingleFetchNoResultError) results[routeId].result = middlewareError;
                    });
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
}
function singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var fetcherMatch, routeId, result;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    fetcherMatch = args.matches.find(function(m) {
                        return m.shouldCallHandler();
                    });
                    invariant2(fetcherMatch, "No fetcher match found");
                    routeId = fetcherMatch.route.id;
                    return [
                        4,
                        fetcherMatch.resolve(function(handler) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                return (0, $13u2V._)(this, function(_state) {
                                    return [
                                        2,
                                        handler(function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                                var _ref, data2;
                                                return (0, $13u2V._)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                fetchAndDecode(args, basename, trailingSlashAware, [
                                                                    routeId
                                                                ])
                                                            ];
                                                        case 1:
                                                            _ref = _state.sent(), data2 = _ref.data;
                                                            return [
                                                                2,
                                                                unwrapSingleFetchResult(data2, routeId)
                                                            ];
                                                    }
                                                });
                                            })();
                                        })
                                    ];
                                });
                            })();
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        (0, $7Pjls._)({}, fetcherMatch.route.id, result)
                    ];
            }
        });
    })();
}
function stripIndexParam(url) {
    var indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    var indexValuesToKeep = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = indexValues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var indexValue = _step.value;
            if (indexValue) indexValuesToKeep.push(indexValue);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = indexValuesToKeep[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var toKeep = _step1.value;
            url.searchParams.append("index", toKeep);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return url;
}
function singleFetchUrl(reqUrl, basename, trailingSlashAware, extension) {
    var url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = "".concat(url.pathname, "_.").concat(extension);
        else url.pathname = "".concat(url.pathname, ".").concat(extension);
    } else {
        if (url.pathname === "/") url.pathname = "_root.".concat(extension);
        else if (basename && stripBasename(url.pathname, basename) === "/") url.pathname = "".concat(removeTrailingSlash(basename), "/_root.").concat(extension);
        else url.pathname = "".concat(removeTrailingSlash(url.pathname), ".").concat(extension);
    }
    return url;
}
function fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var request, url, res, _tmp, _, _tmp1, routes, decoded, data2, typed, typed1, routeId, e;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = args.request;
                    url = singleFetchUrl(request.url, basename, trailingSlashAware, "data");
                    if (request.method === "GET") {
                        url = stripIndexParam(url);
                        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
                    }
                    _tmp = [
                        url
                    ];
                    return [
                        4,
                        createRequestInit(request)
                    ];
                case 1:
                    return [
                        4,
                        fetch.apply(void 0, _tmp.concat([
                            _state.sent()
                        ]))
                    ];
                case 2:
                    res = _state.sent();
                    if (!(res.status >= 400 && !res.headers.has("X-Remix-Response"))) return [
                        3,
                        4
                    ];
                    _ = ErrorResponseImpl.bind;
                    _tmp1 = [
                        void 0,
                        res.status,
                        res.statusText
                    ];
                    return [
                        4,
                        res.text()
                    ];
                case 3:
                    throw new (_.apply(ErrorResponseImpl, _tmp1.concat([
                        _state.sent()
                    ])));
                case 4:
                    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return [
                        2,
                        {
                            status: SINGLE_FETCH_REDIRECT_STATUS,
                            data: {
                                redirect: {
                                    redirect: res.headers.get("X-Remix-Redirect"),
                                    status: Number(res.headers.get("X-Remix-Status") || "302"),
                                    revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                                    reload: res.headers.get("X-Remix-Reload-Document") === "true",
                                    replace: res.headers.get("X-Remix-Replace") === "true"
                                }
                            }
                        }
                    ];
                    if (NO_BODY_STATUS_CODES.has(res.status)) {
                        routes = {};
                        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
                            data: void 0
                        };
                        return [
                            2,
                            {
                                status: res.status,
                                data: {
                                    routes: routes
                                }
                            }
                        ];
                    }
                    invariant2(res.body, "No response body to decode");
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        7,
                        ,
                        8
                    ]);
                    return [
                        4,
                        decodeViaTurboStream(res.body, window)
                    ];
                case 6:
                    decoded = _state.sent();
                    if (request.method === "GET") {
                        typed = decoded.value;
                        if (SingleFetchRedirectSymbol in typed) data2 = {
                            redirect: typed[SingleFetchRedirectSymbol]
                        };
                        else data2 = {
                            routes: typed
                        };
                    } else {
                        typed1 = decoded.value;
                        routeId = targetRoutes === null || targetRoutes === void 0 ? void 0 : targetRoutes[0];
                        invariant2(routeId, "No routeId found for single fetch call decoding");
                        if ("redirect" in typed1) data2 = {
                            redirect: typed1
                        };
                        else data2 = {
                            routes: (0, $7Pjls._)({}, routeId, typed1)
                        };
                    }
                    return [
                        2,
                        {
                            status: res.status,
                            data: data2
                        }
                    ];
                case 7:
                    e = _state.sent();
                    throw new Error("Unable to decode turbo-stream response");
                case 8:
                    return [
                        2
                    ];
            }
        });
    })();
}
function decodeViaTurboStream(body, global) {
    return decode(body, {
        plugins: [
            function(type) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    rest[_key - 1] = arguments[_key];
                }
                if (type === "SanitizedError") {
                    var _rest = (0, $f9AOD._)(rest, 3), name = _rest[0], message = _rest[1], stack = _rest[2];
                    var Constructor = Error;
                    if (name && SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    var error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    var _rest1 = (0, $f9AOD._)(rest, 3), data2 = _rest1[0], status = _rest1[1], statusText = _rest1[2];
                    return {
                        value: new ErrorResponseImpl(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: (0, $7Pjls._)({}, SingleFetchRedirectSymbol, rest[0])
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        var _result_redirect = result.redirect, location = _result_redirect.redirect, revalidate = _result_redirect.revalidate, reload = _result_redirect.reload, replace2 = _result_redirect.replace, status = _result_redirect.status;
        throw redirect(location, {
            status: status,
            headers: (0, $1XAnY._)({}, revalidate ? {
                "X-Remix-Revalidate": "yes"
            } : null, reload ? {
                "X-Remix-Reload-Document": "yes"
            } : null, replace2 ? {
                "X-Remix-Replace": "yes"
            } : null)
        });
    }
    var routeResult = result.routes[routeId];
    if (routeResult == null) throw new SingleFetchNoResultError('No result found for routeId "'.concat(routeId, '"'));
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error('Invalid response found for routeId "'.concat(routeId, '"'));
}
function createDeferred2() {
    var resolve;
    var reject;
    var promise = new Promise(function(res, rej) {
        resolve = function(val) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var e;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            res(val);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        reject = function(error) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var e;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rej(error);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
    });
    return {
        promise: promise,
        //@ts-ignore
        resolve: resolve,
        //@ts-ignore
        reject: reject
    };
}
// lib/dom/ssr/routeModules.ts
function loadRouteModule(route, routeModulesCache) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var routeModule, error;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (route.id in routeModulesCache) return [
                        2,
                        routeModulesCache[route.id]
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        import(/* @vite-ignore */ /* webpackIgnore: true */ route.module)
                    ];
                case 2:
                    routeModule = _state.sent();
                    routeModulesCache[route.id] = routeModule;
                    return [
                        2,
                        routeModule
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Error loading route module `".concat(route.module, "`, reloading page..."));
                    console.error(error);
                    if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
                    $ee9c672aaaad304c$import_meta.hot) throw error;
                    window.location.reload();
                    return [
                        2,
                        new Promise(function() {})
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
// lib/dom/ssr/links.ts
function getKeyedLinksForMatches(matches, routeModules, manifest) {
    var descriptors = matches.map(function(match) {
        var _module_links;
        var module = routeModules[match.route.id];
        var route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map(function(href) {
                return {
                    rel: "stylesheet",
                    href: href
                };
            }) : [],
            (module === null || module === void 0 ? void 0 : (_module_links = module.links) === null || _module_links === void 0 ? void 0 : _module_links.call(module)) || []
        ];
    }).flat(2);
    var preloads = getModuleLinkHrefs(matches, manifest);
    return dedupeLinkDescriptors(descriptors, preloads);
}
function getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map(function(href) {
        return {
            rel: "stylesheet",
            href: href
        };
    });
}
function prefetchRouteCss(route) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var descriptors;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.css) return [
                        2
                    ];
                    descriptors = getRouteCssDescriptors(route);
                    return [
                        4,
                        Promise.all(descriptors.map(prefetchStyleLink))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function prefetchStyleLinks(route, routeModule) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var _descriptors, _descriptors1, descriptors, styleLinks, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, descriptor;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.css && !routeModule.links || !isPreloadSupported()) return [
                        2
                    ];
                    descriptors = [];
                    if (route.css) (_descriptors = descriptors).push.apply(_descriptors, (0, $aUGqu._)(getRouteCssDescriptors(route)));
                    if (routeModule.links) (_descriptors1 = descriptors).push.apply(_descriptors1, (0, $aUGqu._)(routeModule.links()));
                    if (descriptors.length === 0) return [
                        2
                    ];
                    styleLinks = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = descriptors[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            descriptor = _step.value;
                            if (!isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push((0, $6fpqi._)((0, $1XAnY._)({}, descriptor), {
                                rel: "preload",
                                as: "style"
                            }));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        4,
                        Promise.all(styleLinks.map(prefetchStyleLink))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function prefetchStyleLink(descriptor) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        return (0, $13u2V._)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector('link[rel="stylesheet"][href="'.concat(descriptor.href, '"]'))) return resolve();
                    var link = document.createElement("link");
                    Object.assign(link, descriptor);
                    function removeLink() {
                        if (document.head.contains(link)) document.head.removeChild(link);
                    }
                    link.onload = function() {
                        removeLink();
                        resolve();
                    };
                    link.onerror = function() {
                        removeLink();
                        resolve();
                    };
                    document.head.appendChild(link);
                })
            ];
        });
    })();
}
function isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
function getKeyedPrefetchLinks(matches, manifest, routeModules) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var links;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all(matches.map(function(match) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                var route, mod;
                                return (0, $13u2V._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            route = manifest.routes[match.route.id];
                                            if (!route) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                loadRouteModule(route, routeModules)
                                            ];
                                        case 1:
                                            mod = _state.sent();
                                            return [
                                                2,
                                                mod.links ? mod.links() : []
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                []
                                            ];
                                    }
                                });
                            })();
                        }))
                    ];
                case 1:
                    links = _state.sent();
                    return [
                        2,
                        dedupeLinkDescriptors(links.flat(1).filter(isHtmlLinkDescriptor).filter(function(link) {
                            return link.rel === "stylesheet" || link.rel === "preload";
                        }).map(function(link) {
                            return link.rel === "stylesheet" ? (0, $6fpqi._)((0, $1XAnY._)({}, link), {
                                rel: "prefetch",
                                as: "style"
                            }) : (0, $6fpqi._)((0, $1XAnY._)({}, link), {
                                rel: "prefetch"
                            });
                        }))
                    ];
            }
        });
    })();
}
function getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    var isNew = function(match, index) {
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    var matchPathChanged = function(match, index) {
        var // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        _currentMatches_index_route_path;
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || ((_currentMatches_index_route_path = currentMatches[index].route.path) === null || _currentMatches_index_route_path === void 0 ? void 0 : _currentMatches_index_route_path.endsWith("*")) && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter(function(match, index) {
        return isNew(match, index) || matchPathChanged(match, index);
    });
    if (mode === "data") return nextMatches.filter(function(match, index) {
        var manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            var _currentMatches_;
            var routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: ((_currentMatches_ = currentMatches[0]) === null || _currentMatches_ === void 0 ? void 0 : _currentMatches_.params) || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function getModuleLinkHrefs(matches, manifest) {
    var includeHydrateFallback = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).includeHydrateFallback;
    return dedupeHrefs(matches.map(function(match) {
        var route = manifest.routes[match.route.id];
        if (!route) return [];
        var hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function dedupeHrefs(hrefs) {
    return (0, $aUGqu._)(new Set(hrefs));
}
function sortKeys(obj) {
    var sorted = {};
    var keys = Object.keys(obj).sort();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            sorted[key] = obj[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return sorted;
}
function dedupeLinkDescriptors(descriptors, preloads) {
    var set = /* @__PURE__ */ new Set();
    var preloadsSet = new Set(preloads);
    return descriptors.reduce(function(deduped, descriptor) {
        var alreadyModulePreload = preloads && !isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        var key = JSON.stringify(sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var _isPreloadSupported;
function isPreloadSupported() {
    if (_isPreloadSupported !== void 0) return _isPreloadSupported;
    var el = document.createElement("link");
    _isPreloadSupported = el.relList.supports("preload");
    el = null;
    return _isPreloadSupported;
}
function RemixRootDefaultHydrateFallback() {
    var nonce = useFrameworkContext().nonce;
    return /* @__PURE__ */ $tLNoZ.createElement(BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, ENABLE_DEV_WARNINGS ? /* @__PURE__ */ $tLNoZ.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: '\n              console.log(\n                "\uD83D\uDCBF Hey developer \uD83D\uDC4B. You can provide a way better UX than this " +\n                "when your app is loading JS modules and/or running `clientLoader` " +\n                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +\n                "for more information."\n              );\n            '
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function groupRoutesByParentId(manifest) {
    var routes = {};
    Object.values(manifest).forEach(function(route) {
        if (route) {
            var parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function getRouteComponents(route, routeModule, isSpaMode) {
    var Component4 = getRouteModuleComponent(routeModule);
    var HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? RemixRootDefaultHydrateFallback : void 0;
    var ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? function() {
        return /* @__PURE__ */ $tLNoZ.createElement(RemixRootDefaultErrorBoundary, {
            error: useRouteError()
        });
    } : void 0;
    if (route.id === "root" && routeModule.Layout) return (0, $1XAnY._)({}, Component4 ? {
        element: /* @__PURE__ */ $tLNoZ.createElement(routeModule.Layout, null, /* @__PURE__ */ $tLNoZ.createElement(Component4, null))
    } : {
        Component: Component4
    }, ErrorBoundary ? {
        errorElement: /* @__PURE__ */ $tLNoZ.createElement(routeModule.Layout, null, /* @__PURE__ */ $tLNoZ.createElement(ErrorBoundary, null))
    } : {
        ErrorBoundary: ErrorBoundary
    }, HydrateFallback ? {
        hydrateFallbackElement: /* @__PURE__ */ $tLNoZ.createElement(routeModule.Layout, null, /* @__PURE__ */ $tLNoZ.createElement(HydrateFallback, null))
    } : {
        HydrateFallback: HydrateFallback
    });
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function createServerRoutes(manifest, routeModules, future, isSpaMode) {
    var parentId = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", routesByParentId = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : groupRoutesByParentId(manifest), spaModeLazyPromise = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : Promise.resolve({
        Component: function() {
            return null;
        }
    });
    return (routesByParentId[parentId] || []).map(function(route) {
        var routeModule = routeModules[route.id];
        invariant2(routeModule, "No `routeModule` available to create server routes");
        var dataRoute = (0, $6fpqi._)((0, $1XAnY._)({}, getRouteComponents(route, routeModule, isSpaMode)), {
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? function() {
                return spaModeLazyPromise;
            } : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? function() {
                return null;
            } : void 0
        });
        var children = createServerRoutes(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function createClientRoutesWithHMRRevalidationOptOut(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return createClientRoutes(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", groupRoutesByParentId(manifest), needsRevalidation);
}
function preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        var fn = type === "action" ? "serverAction()" : "serverLoader()";
        var msg = "You are trying to call ".concat(fn, " on a route that does not have a server ").concat(type, ' (routeId: "').concat(route.id, '")');
        console.error(msg);
        throw new ErrorResponseImpl(400, "Bad Request", new Error(msg), true);
    }
}
function noActionDefinedError(type, routeId) {
    var article = type === "clientAction" ? "a" : "an";
    var msg = 'Route "'.concat(routeId, '" does not have ').concat(article, " ").concat(type, ", but you are trying to submit to it. To fix this, please add ").concat(article, " `").concat(type, "` function to the route");
    console.error(msg);
    throw new ErrorResponseImpl(405, "Method Not Allowed", new Error(msg), true);
}
function createClientRoutes(manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    var parentId = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", routesByParentId = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : groupRoutesByParentId(manifest), needsRevalidation = arguments.length > 7 ? arguments[7] : void 0;
    return (routesByParentId[parentId] || []).map(function(route) {
        var routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw noActionDefinedError("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        function prefetchStylesAndCallHandler(handler) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var cachedModule, linkPrefetchPromise;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            cachedModule = routeModulesCache[route.id];
                            linkPrefetchPromise = cachedModule ? prefetchStyleLinks(route, cachedModule) : Promise.resolve();
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                ,
                                2,
                                4
                            ]);
                            return [
                                2,
                                handler()
                            ];
                        case 2:
                            return [
                                4,
                                linkPrefetchPromise
                            ];
                        case 3:
                            _state.sent();
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        var dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            var _initialState_loaderData, _initialState_errors, _routeModule_clientLoader;
            Object.assign(dataRoute, (0, $6fpqi._)((0, $1XAnY._)({}, dataRoute, getRouteComponents(route, routeModule, isSpaMode)), {
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            }));
            var hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            var initialData = hasInitialData ? initialState === null || initialState === void 0 ? void 0 : (_initialState_loaderData = initialState.loaderData) === null || _initialState_loaderData === void 0 ? void 0 : _initialState_loaderData[route.id] : void 0;
            var hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            var initialError = hasInitialError ? initialState === null || initialState === void 0 ? void 0 : (_initialState_errors = initialState.errors) === null || _initialState_errors === void 0 ? void 0 : _initialState_errors[route.id] : void 0;
            var isHydrationRequest = needsRevalidation == null && (((_routeModule_clientLoader = routeModule.clientLoader) === null || _routeModule_clientLoader === void 0 ? void 0 : _routeModule_clientLoader.hydrate) === true || !route.hasLoader);
            dataRoute.loader = function(param, singleFetch) {
                var request = param.request, params = param.params, context = param.context, pattern = param.pattern, url = param.url;
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _isHydrationRequest, result;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _isHydrationRequest = isHydrationRequest;
                                isHydrationRequest = false;
                                return [
                                    4,
                                    prefetchStylesAndCallHandler(function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                            return (0, $13u2V._)(this, function(_state) {
                                                invariant2(routeModule, "No `routeModule` available for critical-route loader");
                                                if (!routeModule.clientLoader) return [
                                                    2,
                                                    fetchServerLoader(singleFetch)
                                                ];
                                                return [
                                                    2,
                                                    routeModule.clientLoader({
                                                        request: request,
                                                        params: params,
                                                        context: context,
                                                        pattern: pattern,
                                                        url: url,
                                                        serverLoader: function() {
                                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                                                return (0, $13u2V._)(this, function(_state) {
                                                                    preventInvalidServerHandlerCall("loader", route);
                                                                    if (_isHydrationRequest) {
                                                                        if (hasInitialData) return [
                                                                            2,
                                                                            initialData
                                                                        ];
                                                                        if (hasInitialError) throw initialError;
                                                                    }
                                                                    return [
                                                                        2,
                                                                        fetchServerLoader(singleFetch)
                                                                    ];
                                                                });
                                                            })();
                                                        }
                                                    })
                                                ];
                                            });
                                        })();
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            };
            dataRoute.loader.hydrate = shouldHydrateRouteLoader(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = function(param, singleFetch) {
                var request = param.request, params = param.params, context = param.context, pattern = param.pattern, url = param.url;
                return prefetchStylesAndCallHandler(function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                        return (0, $13u2V._)(this, function(_state) {
                            invariant2(routeModule, "No `routeModule` available for critical-route action");
                            if (!routeModule.clientAction) {
                                if (isSpaMode) throw noActionDefinedError("clientAction", route.id);
                                return [
                                    2,
                                    fetchServerAction(singleFetch)
                                ];
                            }
                            return [
                                2,
                                routeModule.clientAction({
                                    request: request,
                                    params: params,
                                    context: context,
                                    pattern: pattern,
                                    url: url,
                                    serverAction: function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                            return (0, $13u2V._)(this, function(_state) {
                                                preventInvalidServerHandlerCall("action", route);
                                                return [
                                                    2,
                                                    fetchServerAction(singleFetch)
                                                ];
                                            });
                                        })();
                                    }
                                })
                            ];
                        });
                    })();
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = function(_, singleFetch) {
                return prefetchStylesAndCallHandler(function() {
                    return fetchServerLoader(singleFetch);
                });
            };
            if (!route.hasClientAction) dataRoute.action = function(_, singleFetch) {
                return prefetchStylesAndCallHandler(function() {
                    if (isSpaMode) throw noActionDefinedError("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            };
            var lazyRoutePromise;
            function getLazyRoute() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!lazyRoutePromise) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    lazyRoutePromise
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                lazyRoutePromise = function() {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                        var routeModulePromise;
                                        return (0, $13u2V._)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!(route.clientLoaderModule || route.clientActionModule)) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        new Promise(function(resolve) {
                                                            return setTimeout(resolve, 0);
                                                        })
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    _state.label = 2;
                                                case 2:
                                                    routeModulePromise = loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                                                    prefetchRouteModuleChunks(route);
                                                    return [
                                                        4,
                                                        routeModulePromise
                                                    ];
                                                case 3:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                            }
                                        });
                                    })();
                                }();
                                return [
                                    4,
                                    lazyRoutePromise
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                        var clientLoader, _tmp;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!route.clientLoaderModule) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule)
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 2:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 3:
                                    _tmp = _state.sent();
                                    _state.label = 4;
                                case 4:
                                    clientLoader = _tmp.clientLoader;
                                    invariant2(clientLoader, "No `clientLoader` export found");
                                    return [
                                        2,
                                        function(args, singleFetch) {
                                            return clientLoader((0, $6fpqi._)((0, $1XAnY._)({}, args), {
                                                serverLoader: function() {
                                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                                        return (0, $13u2V._)(this, function(_state) {
                                                            preventInvalidServerHandlerCall("loader", route);
                                                            return [
                                                                2,
                                                                fetchServerLoader(singleFetch)
                                                            ];
                                                        });
                                                    })();
                                                }
                                            }));
                                        }
                                    ];
                            }
                        });
                    })();
                } : void 0,
                action: route.hasClientAction ? function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                        var clientActionPromise, clientAction;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                                    prefetchRouteModuleChunks(route);
                                    return [
                                        4,
                                        clientActionPromise
                                    ];
                                case 1:
                                    clientAction = _state.sent().clientAction;
                                    invariant2(clientAction, "No `clientAction` export found");
                                    return [
                                        2,
                                        function(args, singleFetch) {
                                            return clientAction((0, $6fpqi._)((0, $1XAnY._)({}, args), {
                                                serverAction: function() {
                                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                                        return (0, $13u2V._)(this, function(_state) {
                                                            preventInvalidServerHandlerCall("action", route);
                                                            return [
                                                                2,
                                                                fetchServerAction(singleFetch)
                                                            ];
                                                        });
                                                    })();
                                                }
                                            }));
                                        }
                                    ];
                            }
                        });
                    })();
                } : void 0,
                middleware: route.hasClientMiddleware ? function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                        var clientMiddleware, _tmp;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!route.clientMiddlewareModule) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule)
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 2:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 3:
                                    _tmp = _state.sent();
                                    _state.label = 4;
                                case 4:
                                    clientMiddleware = _tmp.clientMiddleware;
                                    invariant2(clientMiddleware, "No `clientMiddleware` export found");
                                    return [
                                        2,
                                        clientMiddleware
                                    ];
                            }
                        });
                    })();
                } : void 0,
                shouldRevalidate: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                        var lazyRoute;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 1:
                                    lazyRoute = _state.sent();
                                    return [
                                        2,
                                        getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation)
                                    ];
                            }
                        });
                    })();
                },
                handle: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent().handle
                                    ];
                            }
                        });
                    })();
                },
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent().Component
                                    ];
                            }
                        });
                    })();
                },
                ErrorBoundary: route.hasErrorBoundary ? function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent().ErrorBoundary
                                    ];
                            }
                        });
                    })();
                } : void 0
            };
        }
        var children = createClientRoutes(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        var myParams = path ? compilePath(path)[1].map(function(p) {
            return p.paramName;
        }) : [];
        var didParamsChange = function(opts) {
            return myParams.some(function(p) {
                return opts.currentParams[p] !== opts.nextParams[p];
            });
        };
        if (route.shouldRevalidate) {
            var fn = route.shouldRevalidate;
            return function(opts) {
                return fn((0, $6fpqi._)((0, $1XAnY._)({}, opts), {
                    defaultShouldRevalidate: didParamsChange(opts)
                }));
            };
        } else return function(opts) {
            return didParamsChange(opts);
        };
    }
    return route.shouldRevalidate;
}
function wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    var handledRevalidation = false;
    return function(arg) {
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
function loadRouteModuleWithBlockingLinks(route, routeModules) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var routeModulePromise, prefetchRouteCssPromise, routeModule;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    routeModulePromise = loadRouteModule(route, routeModules);
                    prefetchRouteCssPromise = prefetchRouteCss(route);
                    return [
                        4,
                        routeModulePromise
                    ];
                case 1:
                    routeModule = _state.sent();
                    return [
                        4,
                        Promise.all([
                            prefetchRouteCssPromise,
                            prefetchStyleLinks(route, routeModule)
                        ])
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        {
                            Component: getRouteModuleComponent(routeModule),
                            ErrorBoundary: routeModule.ErrorBoundary,
                            clientMiddleware: routeModule.clientMiddleware,
                            clientAction: routeModule.clientAction,
                            clientLoader: routeModule.clientLoader,
                            handle: routeModule.handle,
                            links: routeModule.links,
                            meta: routeModule.meta,
                            shouldRevalidate: routeModule.shouldRevalidate
                        }
                    ];
            }
        });
    })();
}
function getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    var isEmptyObject = (0, $7E0eS._)(routeModule.default) === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function shouldHydrateRouteLoader(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var nextPaths = /* @__PURE__ */ new Set();
var discoveredPathsMaxSize = 1e3;
var discoveredPaths = /* @__PURE__ */ new Set();
var URL_LIMIT = 7680;
function getPathsWithAncestors(paths) {
    var result = /* @__PURE__ */ new Set();
    paths.forEach(function(path) {
        if (!path.startsWith("/")) path = "/".concat(path);
        for(var i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function getPartialManifest(_param, router) {
    var sri = _param.sri, manifest = (0, $6acIq._)(_param, [
        "sri"
    ]);
    var routeIds = new Set(router.state.matches.map(function(m) {
        return m.route.id;
    }));
    var segments = router.state.location.pathname.split("/").filter(Boolean);
    var paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push("/".concat(segments.join("/")));
        segments.pop();
    }
    paths.forEach(function(path) {
        var matches = matchRoutesImpl(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach(function(m) {
            return routeIds.add(m.route.id);
        });
    });
    var initialRoutes = (0, $aUGqu._)(routeIds).reduce(function(acc, id) {
        return Object.assign(acc, (0, $7Pjls._)({}, id, manifest.routes[id]));
    }, {});
    return (0, $6fpqi._)((0, $1XAnY._)({}, manifest), {
        routes: initialRoutes,
        sri: sri ? true : void 0
    });
}
function getPatchRoutesOnNavigationFunction(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return function(param) {
        var path = param.path, patch = param.patch, signal = param.signal, fetcherKey = param.fetcherKey;
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var state;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (discoveredPaths.has(path)) return [
                            2
                        ];
                        state = getRouter().state;
                        return [
                            4,
                            fetchAndApplyManifestPatches([
                                path
                            ], // If we're patching for a fetcher call, reload the current location
                            // Otherwise prefer any ongoing navigation location
                            fetcherKey ? window.location.href : createPath(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
}
function useFogOFWarDiscovery(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $lliNT.useEffect(function() {
        var // @ts-expect-error - TS doesn't know about this yet
        _window_navigator_connection, _window_navigator;
        if (!isFogOfWarEnabled(routeDiscovery, ssr) || ((_window_navigator = window.navigator) === null || _window_navigator === void 0 ? void 0 : (_window_navigator_connection = _window_navigator.connection) === null || _window_navigator_connection === void 0 ? void 0 : _window_navigator_connection.saveData) === true) return;
        function registerElement(el) {
            var path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            var pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!discoveredPaths.has(pathname)) nextPaths.add(pathname);
        }
        function fetchPatches() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var lazyPaths, e;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
                            lazyPaths = Array.from(nextPaths.keys()).filter(function(path) {
                                if (discoveredPaths.has(path)) {
                                    nextPaths.delete(path);
                                    return false;
                                }
                                return true;
                            });
                            if (lazyPaths.length === 0) return [
                                2
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            console.error("Failed to fetch manifest patches", e);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        var debouncedFetchPatches = debounce(fetchPatches, 100);
        fetchPatches();
        var observer = new MutationObserver(function() {
            return debouncedFetchPatches();
        });
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return function() {
            return observer.disconnect();
        };
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function getManifestPath(_manifestPath, basename) {
    var manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : joinPaths([
        basename,
        manifestPath
    ]);
}
var MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
function fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var searchParams, url, serverPatches, res, _, e, knownRoutes, patches, parentIds;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    paths = getPathsWithAncestors(paths);
                    searchParams = new URLSearchParams();
                    searchParams.set("paths", paths.sort().join(","));
                    searchParams.set("version", manifest.version);
                    url = new URL(getManifestPath(manifestPath, basename), window.location.origin);
                    url.search = searchParams.toString();
                    if (url.toString().length > URL_LIMIT) {
                        nextPaths.clear();
                        return [
                            2
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        9,
                        ,
                        10
                    ]);
                    return [
                        4,
                        fetch(url, {
                            signal: signal
                        })
                    ];
                case 2:
                    res = _state.sent();
                    if (!!res.ok) return [
                        3,
                        3
                    ];
                    throw new Error("".concat(res.status, " ").concat(res.statusText));
                case 3:
                    if (!(res.status === 204 && res.headers.has("X-Remix-Reload-Document"))) return [
                        3,
                        5
                    ];
                    if (!errorReloadPath) {
                        console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                        return [
                            2
                        ];
                    }
                    try {
                        if (sessionStorage.getItem(MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                            console.error("Unable to discover routes due to manifest version mismatch.");
                            return [
                                2
                            ];
                        }
                        sessionStorage.setItem(MANIFEST_VERSION_STORAGE_KEY, manifest.version);
                    } catch (e) {}
                    window.location.href = errorReloadPath;
                    console.warn("Detected manifest version mismatch, reloading...");
                    return [
                        4,
                        new Promise(function() {})
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        7
                    ];
                case 5:
                    if (!(res.status >= 400)) return [
                        3,
                        7
                    ];
                    _ = Error.bind;
                    return [
                        4,
                        res.text()
                    ];
                case 6:
                    throw new (_.apply(Error, [
                        void 0,
                        _state.sent()
                    ]));
                case 7:
                    try {
                        sessionStorage.removeItem(MANIFEST_VERSION_STORAGE_KEY);
                    } catch (e) {}
                    return [
                        4,
                        res.json()
                    ];
                case 8:
                    serverPatches = _state.sent();
                    return [
                        3,
                        10
                    ];
                case 9:
                    e = _state.sent();
                    if (signal === null || signal === void 0 ? void 0 : signal.aborted) return [
                        2
                    ];
                    throw e;
                case 10:
                    knownRoutes = new Set(Object.keys(manifest.routes));
                    patches = Object.values(serverPatches).reduce(function(acc, route) {
                        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
                        return acc;
                    }, {});
                    Object.assign(manifest.routes, patches);
                    paths.forEach(function(p) {
                        return addToFifoQueue(p, discoveredPaths);
                    });
                    parentIds = /* @__PURE__ */ new Set();
                    Object.values(patches).forEach(function(patch) {
                        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
                    });
                    parentIds.forEach(function(parentId) {
                        return patchRoutes(parentId || null, createClientRoutes(patches, routeModules, null, ssr, isSpaMode, parentId));
                    });
                    return [
                        2
                    ];
            }
        });
    })();
}
function addToFifoQueue(path, queue) {
    if (queue.size >= discoveredPathsMaxSize) {
        var first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function debounce(callback, wait) {
    var timeoutId;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(function() {
            return callback.apply(void 0, (0, $aUGqu._)(args));
        }, wait);
    };
}
// lib/dom/ssr/components.tsx
function useDataRouterContext2() {
    var context = $lliNT.useContext(DataRouterContext);
    invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function useDataRouterStateContext() {
    var context = $lliNT.useContext(DataRouterStateContext);
    invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var FrameworkContext = $tLNoZ.createContext(void 0);
FrameworkContext.displayName = "FrameworkContext";
function useFrameworkContext() {
    var context = $lliNT.useContext(FrameworkContext);
    invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function usePrefetchBehavior(prefetch, theirElementProps) {
    var frameworkContext = $lliNT.useContext(FrameworkContext);
    var _React8_useState = (0, $f9AOD._)($lliNT.useState(false), 2), maybePrefetch = _React8_useState[0], setMaybePrefetch = _React8_useState[1];
    var _React8_useState1 = (0, $f9AOD._)($lliNT.useState(false), 2), shouldPrefetch = _React8_useState1[0], setShouldPrefetch = _React8_useState1[1];
    var onFocus = theirElementProps.onFocus, onBlur = theirElementProps.onBlur, onMouseEnter = theirElementProps.onMouseEnter, onMouseLeave = theirElementProps.onMouseLeave, onTouchStart = theirElementProps.onTouchStart;
    var ref = $lliNT.useRef(null);
    $lliNT.useEffect(function() {
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            var callback = function(entries) {
                entries.forEach(function(entry) {
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            var observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return function() {
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $lliNT.useEffect(function() {
        if (maybePrefetch) {
            var id = setTimeout(function() {
                setShouldPrefetch(true);
            }, 100);
            return function() {
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    var setIntent = function() {
        setMaybePrefetch(true);
    };
    var cancelIntent = function() {
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: composeEventHandlers(onFocus, setIntent),
            onBlur: composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function composeEventHandlers(theirHandler, ourHandler) {
    return function(event) {
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !isHydrated) return [
        matches[0]
    ];
    if (errors) {
        var errorIdx = matches.findIndex(function(m) {
            return errors[m.route.id] !== void 0;
        });
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var CRITICAL_CSS_DATA_ATTRIBUTE = "data-react-router-critical-css";
function Links(param) {
    var nonce = param.nonce, crossOrigin = param.crossOrigin;
    var _useFrameworkContext = useFrameworkContext(), isSpaMode = _useFrameworkContext.isSpaMode, manifest = _useFrameworkContext.manifest, routeModules = _useFrameworkContext.routeModules, criticalCss = _useFrameworkContext.criticalCss, contextNonce = _useFrameworkContext.nonce;
    var _useDataRouterStateContext = useDataRouterStateContext(), errors = _useDataRouterStateContext.errors, routerMatches = _useDataRouterStateContext.matches;
    var matches = getActiveMatches(routerMatches, errors, isSpaMode);
    var keyedLinks = $lliNT.useMemo(function() {
        return getKeyedLinksForMatches(matches, routeModules, manifest);
    }, [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    var _obj, _obj1;
    return /* @__PURE__ */ $tLNoZ.createElement($tLNoZ.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $tLNoZ.createElement("style", (_obj = {}, (0, $7Pjls._)(_obj, CRITICAL_CSS_DATA_ATTRIBUTE, ""), (0, $7Pjls._)(_obj, "nonce", nonce), (0, $7Pjls._)(_obj, "dangerouslySetInnerHTML", {
        __html: criticalCss
    }), _obj)) : null, (typeof criticalCss === "undefined" ? "undefined" : (0, $7E0eS._)(criticalCss)) === "object" ? /* @__PURE__ */ $tLNoZ.createElement("link", (_obj1 = {}, (0, $7Pjls._)(_obj1, CRITICAL_CSS_DATA_ATTRIBUTE, ""), (0, $7Pjls._)(_obj1, "rel", "stylesheet"), (0, $7Pjls._)(_obj1, "href", criticalCss.href), (0, $7Pjls._)(_obj1, "nonce", nonce), (0, $7Pjls._)(_obj1, "crossOrigin", crossOrigin), _obj1)) : null, keyedLinks.map(function(param) {
        var key = param.key, link = param.link;
        var _link_crossOrigin, _link_crossOrigin1;
        return isPageLinkDescriptor(link) ? /* @__PURE__ */ $tLNoZ.createElement(PrefetchPageLinks, (0, $6fpqi._)((0, $1XAnY._)({
            key: key,
            nonce: nonce
        }, link), {
            crossOrigin: (_link_crossOrigin = link.crossOrigin) !== null && _link_crossOrigin !== void 0 ? _link_crossOrigin : crossOrigin
        })) : /* @__PURE__ */ $tLNoZ.createElement("link", (0, $6fpqi._)((0, $1XAnY._)({
            key: key,
            nonce: nonce
        }, link), {
            crossOrigin: (_link_crossOrigin1 = link.crossOrigin) !== null && _link_crossOrigin1 !== void 0 ? _link_crossOrigin1 : crossOrigin
        }));
    }));
}
function PrefetchPageLinks(_param) {
    var page = _param.page, linkProps = (0, $6acIq._)(_param, [
        "page"
    ]);
    var rsc = useIsRSCRouterContext();
    var _useFrameworkContext = useFrameworkContext(), contextNonce = _useFrameworkContext.nonce;
    var router = useDataRouterContext2().router;
    var matches = $lliNT.useMemo(function() {
        return matchRoutes(router.routes, page, router.basename);
    }, [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = (0, $6fpqi._)((0, $1XAnY._)({}, linkProps), {
        nonce: contextNonce
    });
    if (rsc) return /* @__PURE__ */ $tLNoZ.createElement(RSCPrefetchPageLinksImpl, (0, $1XAnY._)({
        page: page,
        matches: matches
    }, linkProps));
    return /* @__PURE__ */ $tLNoZ.createElement(PrefetchPageLinksImpl, (0, $1XAnY._)({
        page: page,
        matches: matches
    }, linkProps));
}
function useKeyedPrefetchLinks(matches) {
    var _useFrameworkContext = useFrameworkContext(), manifest = _useFrameworkContext.manifest, routeModules = _useFrameworkContext.routeModules;
    var _React8_useState = (0, $f9AOD._)($lliNT.useState([]), 2), keyedPrefetchLinks = _React8_useState[0], setKeyedPrefetchLinks = _React8_useState[1];
    $lliNT.useEffect(function() {
        var interrupted = false;
        getKeyedPrefetchLinks(matches, manifest, routeModules).then(function(links) {
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return function() {
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function RSCPrefetchPageLinksImpl(_param) {
    var page = _param.page, nextMatches = _param.matches, linkProps = (0, $6acIq._)(_param, [
        "page",
        "matches"
    ]);
    var location = useLocation();
    var future = useFrameworkContext().future;
    var basename = useDataRouterContext2().basename;
    var dataHrefs = $lliNT.useMemo(function() {
        if (page === location.pathname + location.search + location.hash) return [];
        var url = singleFetchUrl(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        var hasSomeRoutesWithShouldRevalidate = false;
        var targetRoutes = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = nextMatches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
                else targetRoutes.push(match.route.id);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $tLNoZ.createElement($tLNoZ.Fragment, null, dataHrefs.map(function(href) {
        return /* @__PURE__ */ $tLNoZ.createElement("link", (0, $1XAnY._)({
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href
        }, linkProps));
    }));
}
function PrefetchPageLinksImpl(_param) {
    var page = _param.page, nextMatches = _param.matches, linkProps = (0, $6acIq._)(_param, [
        "page",
        "matches"
    ]);
    var location = useLocation();
    var _useFrameworkContext = useFrameworkContext(), future = _useFrameworkContext.future, manifest = _useFrameworkContext.manifest, routeModules = _useFrameworkContext.routeModules;
    var basename = useDataRouterContext2().basename;
    var _useDataRouterStateContext = useDataRouterStateContext(), loaderData = _useDataRouterStateContext.loaderData, matches = _useDataRouterStateContext.matches;
    var newMatchesForData = $lliNT.useMemo(function() {
        return getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data");
    }, [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    var newMatchesForAssets = $lliNT.useMemo(function() {
        return getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets");
    }, [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    var dataHrefs = $lliNT.useMemo(function() {
        if (page === location.pathname + location.search + location.hash) return [];
        var routesParams = /* @__PURE__ */ new Set();
        var foundOptOutRoute = false;
        nextMatches.forEach(function(m) {
            var _routeModules_m_route_id;
            var manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some(function(m2) {
                return m2.route.id === m.route.id;
            }) && m.route.id in loaderData && ((_routeModules_m_route_id = routeModules[m.route.id]) === null || _routeModules_m_route_id === void 0 ? void 0 : _routeModules_m_route_id.shouldRevalidate)) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        var url = singleFetchUrl(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter(function(m) {
            return routesParams.has(m.route.id);
        }).map(function(m) {
            return m.route.id;
        }).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    var moduleHrefs = $lliNT.useMemo(function() {
        return getModuleLinkHrefs(newMatchesForAssets, manifest);
    }, [
        newMatchesForAssets,
        manifest
    ]);
    var keyedPrefetchLinks = useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $tLNoZ.createElement($tLNoZ.Fragment, null, dataHrefs.map(function(href) {
        return /* @__PURE__ */ $tLNoZ.createElement("link", (0, $1XAnY._)({
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href
        }, linkProps));
    }), moduleHrefs.map(function(href) {
        return /* @__PURE__ */ $tLNoZ.createElement("link", (0, $1XAnY._)({
            key: href,
            rel: "modulepreload",
            href: href
        }, linkProps));
    }), keyedPrefetchLinks.map(function(param) {
        var key = param.key, link = param.link;
        var _link_crossOrigin;
        return(// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $tLNoZ.createElement("link", (0, $6fpqi._)((0, $1XAnY._)({
            key: key,
            nonce: linkProps.nonce
        }, link), {
            crossOrigin: (_link_crossOrigin = link.crossOrigin) !== null && _link_crossOrigin !== void 0 ? _link_crossOrigin : linkProps.crossOrigin
        })));
    }));
}
function Meta() {
    var _useFrameworkContext = useFrameworkContext(), isSpaMode = _useFrameworkContext.isSpaMode, routeModules = _useFrameworkContext.routeModules;
    var _useDataRouterStateContext = useDataRouterStateContext(), errors = _useDataRouterStateContext.errors, routerMatches = _useDataRouterStateContext.matches, loaderData = _useDataRouterStateContext.loaderData;
    var location = useLocation();
    var _matches = getActiveMatches(routerMatches, errors, isSpaMode);
    var error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    var meta = [];
    var leafMeta = null;
    var matches = [];
    for(var i = 0; i < _matches.length; i++){
        var _match = _matches[i];
        var routeId = _match.route.id;
        var data2 = loaderData[routeId];
        var params = _match.params;
        var routeModule = routeModules[routeId];
        var routeMeta = [];
        var match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule === null || routeModule === void 0 ? void 0 : routeModule.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? (0, $aUGqu._)(routeModule.meta) : routeModule.meta;
        else if (leafMeta) routeMeta = (0, $aUGqu._)(leafMeta);
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = (0, $aUGqu._)(routeMeta);
        leafMeta = meta;
    }
    return /* @__PURE__ */ $tLNoZ.createElement($tLNoZ.Fragment, null, meta.flat().map(function(metaProps) {
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            var tagName = metaProps.tagName, rest = (0, $6acIq._)(metaProps, [
                "tagName"
            ]);
            if (!isValidMetaTag(tagName)) {
                console.warn("A meta object uses an invalid tagName: ".concat(tagName, ". Expected either 'link' or 'meta'"));
                return null;
            }
            var Comp = tagName;
            return /* @__PURE__ */ $tLNoZ.createElement(Comp, (0, $1XAnY._)({
                key: JSON.stringify(rest)
            }, rest));
        }
        if ("title" in metaProps) return /* @__PURE__ */ $tLNoZ.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            var _metaProps_charSet;
            (_metaProps_charSet = metaProps.charSet) !== null && _metaProps_charSet !== void 0 ? _metaProps_charSet : metaProps.charSet = metaProps.charset;
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $tLNoZ.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            var json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $tLNoZ.createElement("script", {
                key: "script:ld+json:".concat(json),
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: escapeHtml(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $tLNoZ.createElement("meta", (0, $1XAnY._)({
            key: JSON.stringify(metaProps)
        }, metaProps));
    }));
}
function isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var isHydrated = false;
function setIsHydrated() {
    isHydrated = true;
}
function Scripts(scriptProps) {
    var _useFrameworkContext = useFrameworkContext(), manifest = _useFrameworkContext.manifest, serverHandoffString = _useFrameworkContext.serverHandoffString, isSpaMode = _useFrameworkContext.isSpaMode, renderMeta = _useFrameworkContext.renderMeta, routeDiscovery = _useFrameworkContext.routeDiscovery, ssr = _useFrameworkContext.ssr, contextNonce = _useFrameworkContext.nonce;
    var _useDataRouterContext2 = useDataRouterContext2(), router = _useDataRouterContext2.router, isStatic = _useDataRouterContext2.static, staticContext = _useDataRouterContext2.staticContext;
    var _useDataRouterStateContext = useDataRouterStateContext(), routerMatches = _useDataRouterStateContext.matches;
    var isRSCRouterContext = useIsRSCRouterContext();
    var enableFogOfWar = isFogOfWarEnabled(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = (0, $6fpqi._)((0, $1XAnY._)({}, scriptProps), {
        nonce: contextNonce
    });
    if (renderMeta) renderMeta.didRenderScripts = true;
    var matches = getActiveMatches(routerMatches, null, isSpaMode);
    $lliNT.useEffect(function() {
        setIsHydrated();
    }, []);
    var initialScripts = $lliNT.useMemo(function() {
        var _manifest_hmr;
        if (isRSCRouterContext) return null;
        var streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        var contextScript = staticContext ? "window.__reactRouterContext = ".concat(serverHandoffString, ";").concat(streamScript) : " ";
        var routeModulesScript = !isStatic ? " " : "".concat(((_manifest_hmr = manifest.hmr) === null || _manifest_hmr === void 0 ? void 0 : _manifest_hmr.runtime) ? "import ".concat(JSON.stringify(manifest.hmr.runtime), ";") : "").concat(!enableFogOfWar ? "import ".concat(JSON.stringify(manifest.url)) : "", ";\n").concat(matches.map(function(match, routeIndex) {
            var routeVarName = "route".concat(routeIndex);
            var manifestEntry = manifest.routes[match.route.id];
            invariant2(manifestEntry, "Route ".concat(match.route.id, " not found in manifest"));
            var clientActionModule = manifestEntry.clientActionModule, clientLoaderModule = manifestEntry.clientLoaderModule, clientMiddlewareModule = manifestEntry.clientMiddlewareModule, hydrateFallbackModule = manifestEntry.hydrateFallbackModule, module = manifestEntry.module;
            var chunks = (0, $aUGqu._)(clientActionModule ? [
                {
                    module: clientActionModule,
                    varName: "".concat(routeVarName, "_clientAction")
                }
            ] : []).concat((0, $aUGqu._)(clientLoaderModule ? [
                {
                    module: clientLoaderModule,
                    varName: "".concat(routeVarName, "_clientLoader")
                }
            ] : []), (0, $aUGqu._)(clientMiddlewareModule ? [
                {
                    module: clientMiddlewareModule,
                    varName: "".concat(routeVarName, "_clientMiddleware")
                }
            ] : []), (0, $aUGqu._)(hydrateFallbackModule ? [
                {
                    module: hydrateFallbackModule,
                    varName: "".concat(routeVarName, "_HydrateFallback")
                }
            ] : []), [
                {
                    module: module,
                    varName: "".concat(routeVarName, "_main")
                }
            ]);
            if (chunks.length === 1) return "import * as ".concat(routeVarName, " from ").concat(JSON.stringify(module), ";");
            var chunkImportsSnippet = chunks.map(function(chunk) {
                return "import * as ".concat(chunk.varName, ' from "').concat(chunk.module, '";');
            }).join("\n");
            var mergedChunksSnippet = "const ".concat(routeVarName, " = {").concat(chunks.map(function(chunk) {
                return "...".concat(chunk.varName);
            }).join(","), "};");
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n"), "\n  ").concat(enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        "window.__reactRouterManifest = ".concat(JSON.stringify(getPartialManifest(manifest, router), null, 2), ";") : "", "\n  window.__reactRouterRouteModules = {").concat(matches.map(function(match, index) {
            return "".concat(JSON.stringify(match.route.id), ":route").concat(index);
        }).join(","), "};\n\nimport(").concat(JSON.stringify(manifest.entry.module), ");");
        return /* @__PURE__ */ $tLNoZ.createElement($tLNoZ.Fragment, null, /* @__PURE__ */ $tLNoZ.createElement("script", (0, $6fpqi._)((0, $1XAnY._)({}, scriptProps), {
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        })), /* @__PURE__ */ $tLNoZ.createElement("script", (0, $6fpqi._)((0, $1XAnY._)({}, scriptProps), {
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        })));
    }, []);
    var preloads = isHydrated || isRSCRouterContext ? [] : // Dedupe through a Set
    (0, $aUGqu._)(new Set(manifest.entry.imports.concat(getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    }))));
    var sri = (0, $7E0eS._)(manifest.sri) === "object" ? manifest.sri : {};
    warnOnce(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $tLNoZ.createElement($tLNoZ.Fragment, null, (0, $7E0eS._)(manifest.sri) === "object" ? /* @__PURE__ */ $tLNoZ.createElement("script", (0, $6fpqi._)((0, $1XAnY._)({}, scriptProps), {
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    })) : null, !enableFogOfWar ? /* @__PURE__ */ $tLNoZ.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $tLNoZ.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map(function(path) {
        return /* @__PURE__ */ $tLNoZ.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        });
    }), initialScripts);
}
function mergeRefs() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var RemixErrorBoundary = /*#__PURE__*/ function(_React9_Component) {
    "use strict";
    (0, $hdIku._)(RemixErrorBoundary, _React9_Component);
    function RemixErrorBoundary(props) {
        (0, $173N4._)(this, RemixErrorBoundary);
        var _this;
        _this = (0, $7qXGD._)(this, RemixErrorBoundary, [
            props
        ]);
        _this.state = {
            error: props.error || null,
            location: props.location
        };
        return _this;
    }
    (0, $cFHGC._)(RemixErrorBoundary, [
        {
            key: "render",
            value: function render() {
                if (this.state.error) return /* @__PURE__ */ $tLNoZ.createElement(RemixRootDefaultErrorBoundary, {
                    error: this.state.error,
                    isOutsideRemixApp: true
                });
                else return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (state.location !== props.location) return {
                    error: props.error || null,
                    location: props.location
                };
                return {
                    error: props.error || state.error,
                    location: state.location
                };
            }
        }
    ]);
    return RemixErrorBoundary;
}($tLNoZ.Component);
function RemixRootDefaultErrorBoundary(param) {
    var error = param.error, isOutsideRemixApp = param.isOutsideRemixApp;
    var nonce = useFrameworkContext().nonce;
    console.error(error);
    var heyDeveloper = /* @__PURE__ */ $tLNoZ.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: '\n        console.log(\n          "\uD83D\uDCBF Hey developer \uD83D\uDC4B. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."\n        );\n      '
        }
    });
    if (isRouteErrorResponse(error)) return /* @__PURE__ */ $tLNoZ.createElement(BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $tLNoZ.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), ENABLE_DEV_WARNINGS ? heyDeveloper : null);
    var errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        var errorString = error == null ? "Unknown Error" : (typeof error === "undefined" ? "undefined" : (0, $7E0eS._)(error)) === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $tLNoZ.createElement(BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $tLNoZ.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $tLNoZ.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function BoundaryShell(param) {
    var title = param.title, renderScripts = param.renderScripts, isOutsideRemixApp = param.isOutsideRemixApp, children = param.children;
    var _routeModules_root;
    var routeModules = useFrameworkContext().routeModules;
    if (((_routeModules_root = routeModules.root) === null || _routeModules_root === void 0 ? void 0 : _routeModules_root.Layout) && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $tLNoZ.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $tLNoZ.createElement("head", null, /* @__PURE__ */ $tLNoZ.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $tLNoZ.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $tLNoZ.createElement("title", null, title)), /* @__PURE__ */ $tLNoZ.createElement("body", null, /* @__PURE__ */ $tLNoZ.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $tLNoZ.createElement(Scripts, null) : null)));
}
var isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if (isBrowser2) window.__reactRouterVersion = "7.18.0";
} catch (e) {}
function createBrowserRouter(routes, opts) {
    return createRouter({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: createBrowserHistory({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes: routes,
        mapRouteProperties: mapRouteProperties,
        hydrationRouteProperties: hydrationRouteProperties,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window,
        instrumentations: opts === null || opts === void 0 ? void 0 : opts.instrumentations
    }).initialize();
}
function createHashRouter(routes, opts) {
    return createRouter({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: createHashHistory({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes: routes,
        mapRouteProperties: mapRouteProperties,
        hydrationRouteProperties: hydrationRouteProperties,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window,
        instrumentations: opts === null || opts === void 0 ? void 0 : opts.instrumentations
    }).initialize();
}
function parseHydrationData() {
    var _window;
    var state = (_window = window) === null || _window === void 0 ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = (0, $6fpqi._)((0, $1XAnY._)({}, state), {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $f9AOD._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new ErrorResponseImpl(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                if (typeof val.__subType === "string" && SUPPORTED_ERROR_TYPES.includes(val.__subType)) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        var error = new ErrorConstructor(val.message);
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {}
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
function BrowserRouter(param) {
    var basename = param.basename, children = param.children, useTransitions = param.useTransitions, window2 = param.window;
    var historyRef = $lliNT.useRef();
    if (historyRef.current == null) historyRef.current = createBrowserHistory({
        window: window2,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React10_useState = (0, $f9AOD._)($lliNT.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React10_useState[0], setStateImpl = _React10_useState[1];
    var setState = $lliNT.useCallback(function(newState) {
        if (useTransitions === false) setStateImpl(newState);
        else $1aLYV.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        useTransitions
    ]);
    $lliNT.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $tLNoZ.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function HashRouter(param) {
    var basename = param.basename, children = param.children, useTransitions = param.useTransitions, window2 = param.window;
    var historyRef = $lliNT.useRef();
    if (historyRef.current == null) historyRef.current = createHashHistory({
        window: window2,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React10_useState = (0, $f9AOD._)($lliNT.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React10_useState[0], setStateImpl = _React10_useState[1];
    var setState = $lliNT.useCallback(function(newState) {
        if (useTransitions === false) setStateImpl(newState);
        else $1aLYV.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        useTransitions
    ]);
    $lliNT.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $tLNoZ.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function HistoryRouter(param) {
    var basename = param.basename, children = param.children, history = param.history, useTransitions = param.useTransitions;
    var _React10_useState = (0, $f9AOD._)($lliNT.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React10_useState[0], setStateImpl = _React10_useState[1];
    var setState = $lliNT.useCallback(function(newState) {
        if (useTransitions === false) setStateImpl(newState);
        else $1aLYV.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        useTransitions
    ]);
    $lliNT.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $tLNoZ.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
HistoryRouter.displayName = "unstable_HistoryRouter";
var Link = $1aLYV.forwardRef(function LinkWithRef(_param, forwardedRef) {
    var onClick = _param.onClick, _param_discover = _param.discover, discover = _param_discover === void 0 ? "render" : _param_discover, _param_prefetch = _param.prefetch, prefetch = _param_prefetch === void 0 ? "none" : _param_prefetch, relative = _param.relative, reloadDocument = _param.reloadDocument, replace2 = _param.replace, mask = _param.mask, state = _param.state, target = _param.target, to = _param.to, preventScrollReset = _param.preventScrollReset, viewTransition = _param.viewTransition, defaultShouldRevalidate = _param.defaultShouldRevalidate, rest = (0, $6acIq._)(_param, [
        "onClick",
        "discover",
        "prefetch",
        "relative",
        "reloadDocument",
        "replace",
        "mask",
        "state",
        "target",
        "to",
        "preventScrollReset",
        "viewTransition",
        "defaultShouldRevalidate"
    ]);
    var _React10_useContext = $lliNT.useContext(NavigationContext), basename = _React10_useContext.basename, navigator = _React10_useContext.navigator, useTransitions = _React10_useContext.useTransitions;
    var isAbsolute = typeof to === "string" && ABSOLUTE_URL_REGEX.test(to);
    var parsed = parseToInfo(to, basename);
    to = parsed.to;
    var href = useHref(to, {
        relative: relative
    });
    var location = useLocation();
    var maskedHref = null;
    if (mask) {
        var resolved = resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    var _usePrefetchBehavior = (0, $f9AOD._)(usePrefetchBehavior(prefetch, rest), 3), shouldPrefetch = _usePrefetchBehavior[0], prefetchRef = _usePrefetchBehavior[1], prefetchHandlers = _usePrefetchBehavior[2];
    var internalOnClick = useLinkClickHandler(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    var isSpaLink = !(parsed.isExternal || reloadDocument);
    var link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $tLNoZ.createElement("a", (0, $6fpqi._)((0, $1XAnY._)({}, rest, prefetchHandlers), {
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    }));
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $tLNoZ.createElement($tLNoZ.Fragment, null, link, /* @__PURE__ */ $tLNoZ.createElement(PrefetchPageLinks, {
        page: href
    })) : link;
});
Link.displayName = "Link";
var NavLink = $1aLYV.forwardRef(function NavLinkWithRef(_param, ref) {
    var tmp = _param["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _param_caseSensitive = _param.caseSensitive, caseSensitive = _param_caseSensitive === void 0 ? false : _param_caseSensitive, tmp1 = _param.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _param_end = _param.end, end = _param_end === void 0 ? false : _param_end, styleProp = _param.style, to = _param.to, viewTransition = _param.viewTransition, children = _param.children, rest = (0, $6acIq._)(_param, [
        "aria-current",
        "caseSensitive",
        "className",
        "end",
        "style",
        "to",
        "viewTransition",
        "children"
    ]);
    var path = useResolvedPath(to, {
        relative: rest.relative
    });
    var location = useLocation();
    var routerState = $lliNT.useContext(DataRouterStateContext);
    var _React10_useContext = $lliNT.useContext(NavigationContext), navigator = _React10_useContext.navigator, basename = _React10_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = stripBasename(nextLocationPathname, basename) || nextLocationPathname;
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : void 0;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $tLNoZ.createElement(Link, (0, $6fpqi._)((0, $1XAnY._)({}, rest), {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
NavLink.displayName = "NavLink";
var Form = $1aLYV.forwardRef(function(_param, forwardedRef) {
    var _param_discover = _param.discover, discover = _param_discover === void 0 ? "render" : _param_discover, fetcherKey = _param.fetcherKey, navigate = _param.navigate, reloadDocument = _param.reloadDocument, replace2 = _param.replace, state = _param.state, _param_method = _param.method, method = _param_method === void 0 ? defaultMethod : _param_method, action = _param.action, onSubmit = _param.onSubmit, relative = _param.relative, preventScrollReset = _param.preventScrollReset, viewTransition = _param.viewTransition, defaultShouldRevalidate = _param.defaultShouldRevalidate, props = (0, $6acIq._)(_param, [
        "discover",
        "fetcherKey",
        "navigate",
        "reloadDocument",
        "replace",
        "state",
        "method",
        "action",
        "onSubmit",
        "relative",
        "preventScrollReset",
        "viewTransition",
        "defaultShouldRevalidate"
    ]);
    var useTransitions = $lliNT.useContext(NavigationContext).useTransitions;
    var submit = useSubmit();
    var formAction = useFormAction(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var isAbsolute = typeof action === "string" && ABSOLUTE_URL_REGEX.test(action);
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formmethod")) || method;
        var doSubmit = function() {
            return submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        };
        if (useTransitions && navigate !== false) $1aLYV.startTransition(function() {
            return doSubmit();
        });
        else doSubmit();
    };
    return /* @__PURE__ */ $tLNoZ.createElement("form", (0, $6fpqi._)((0, $1XAnY._)({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props), {
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    }));
});
Form.displayName = "Form";
function ScrollRestoration(_param) {
    var getKey = _param.getKey, storageKey = _param.storageKey, props = (0, $6acIq._)(_param, [
        "getKey",
        "storageKey"
    ]);
    var remixContext = $lliNT.useContext(FrameworkContext);
    var basename = $lliNT.useContext(NavigationContext).basename;
    var location = useLocation();
    var matches = useMatches();
    useScrollRestoration({
        getKey: getKey,
        storageKey: storageKey
    });
    var ssrKey = $lliNT.useMemo(function() {
        if (!remixContext || !getKey) return null;
        var userKey = getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    var restoreScroll = (function(storageKey2, restoreKey) {
        if (!window.history.state || !window.history.state.key) {
            var key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            var positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            var storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    if (props.nonce == null && (remixContext === null || remixContext === void 0 ? void 0 : remixContext.nonce)) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $tLNoZ.createElement("script", (0, $6fpqi._)((0, $1XAnY._)({}, props), {
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: "(".concat(restoreScroll, ")(").concat(escapeHtml(JSON.stringify(storageKey || SCROLL_RESTORATION_STORAGE_KEY)), ", ").concat(escapeHtml(JSON.stringify(ssrKey)), ")")
        }
    }));
}
ScrollRestoration.displayName = "ScrollRestoration";
function getDataRouterConsoleError2(hookName) {
    return "".concat(hookName, " must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.");
}
function useDataRouterContext3(hookName) {
    var ctx = $lliNT.useContext(DataRouterContext);
    invariant(ctx, getDataRouterConsoleError2(hookName));
    return ctx;
}
function useDataRouterState2(hookName) {
    var state = $lliNT.useContext(DataRouterStateContext);
    invariant(state, getDataRouterConsoleError2(hookName));
    return state;
}
function useLinkClickHandler(to) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, target = _ref.target, replaceProp = _ref.replace, mask = _ref.mask, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, viewTransition = _ref.viewTransition, defaultShouldRevalidate = _ref.defaultShouldRevalidate, useTransitions = _ref.useTransitions;
    var navigate = useNavigate();
    var location = useLocation();
    var path = useResolvedPath(to, {
        relative: relative
    });
    return $lliNT.useCallback(function(event) {
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            var replace2 = replaceProp !== void 0 ? replaceProp : createPath(location) === createPath(path);
            var doNavigate = function() {
                return navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            };
            if (useTransitions) $1aLYV.startTransition(function() {
                return doNavigate();
            });
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function useSearchParams(defaultInit) {
    warning(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    var defaultSearchParamsRef = $lliNT.useRef(createSearchParams(defaultInit));
    var hasSetSearchParamsRef = $lliNT.useRef(false);
    var location = useLocation();
    var searchParams = $lliNT.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = useNavigate();
    var setSearchParams = $lliNT.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var fetcherId = 0;
var getUniqueFetcherId = function() {
    return "__".concat(String(++fetcherId), "__");
};
function useSubmit() {
    var router = useDataRouterContext3("useSubmit" /* UseSubmit */ ).router;
    var basename = $lliNT.useContext(NavigationContext).basename;
    var currentRouteId = useRouteId();
    var routerFetch = router.fetch;
    var routerNavigate = router.navigate;
    return $lliNT.useCallback(function(target) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var _getFormSubmissionInfo, action, method, encType, formData, body, key;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _getFormSubmissionInfo = getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
                        if (!(options.navigate === false)) return [
                            3,
                            2
                        ];
                        key = options.fetcherKey || getUniqueFetcherId();
                        return [
                            4,
                            routerFetch(key, currentRouteId, options.action || action, {
                                defaultShouldRevalidate: options.defaultShouldRevalidate,
                                preventScrollReset: options.preventScrollReset,
                                formData: formData,
                                body: body,
                                formMethod: options.method || method,
                                formEncType: options.encType || encType,
                                flushSync: options.flushSync
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            routerNavigate(options.action || action, {
                                defaultShouldRevalidate: options.defaultShouldRevalidate,
                                preventScrollReset: options.preventScrollReset,
                                formData: formData,
                                body: body,
                                formMethod: options.method || method,
                                formEncType: options.encType || encType,
                                replace: options.replace,
                                state: options.state,
                                fromRouteId: currentRouteId,
                                flushSync: options.flushSync,
                                viewTransition: options.viewTransition
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function useFormAction(action) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    var basename = $lliNT.useContext(NavigationContext).basename;
    var routeContext = $lliNT.useContext(RouteContext);
    invariant(routeContext, "useFormAction must be used inside a RouteContext");
    var _routeContext_matches_slice = (0, $f9AOD._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    var path = (0, $1XAnY._)({}, useResolvedPath(action ? action : ".", {
        relative: relative
    }));
    var location = useLocation();
    if (action == null) {
        path.search = location.search;
        var params = new URLSearchParams(path.search);
        var indexValues = params.getAll("index");
        var hasNakedIndexParam = indexValues.some(function(v) {
            return v === "";
        });
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?".concat(qs) : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
function useFetcher() {
    var key = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).key;
    var _route_matches_;
    var router = useDataRouterContext3("useFetcher" /* UseFetcher */ ).router;
    var state = useDataRouterState2("useFetcher" /* UseFetcher */ );
    var fetcherData = $lliNT.useContext(FetchersContext);
    var route = $lliNT.useContext(RouteContext);
    var routeId = (_route_matches_ = route.matches[route.matches.length - 1]) === null || _route_matches_ === void 0 ? void 0 : _route_matches_.route.id;
    invariant(fetcherData, "useFetcher must be used inside a FetchersContext");
    invariant(route, "useFetcher must be used inside a RouteContext");
    invariant(routeId != null, 'useFetcher can only be used on routes that contain a unique "id"');
    var defaultKey = $lliNT.useId();
    var _React10_useState = (0, $f9AOD._)($lliNT.useState(key || defaultKey), 2), fetcherKey = _React10_useState[0], setFetcherKey = _React10_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    var deleteFetcher = router.deleteFetcher, getFetcher = router.getFetcher, resetFetcher = router.resetFetcher, routerFetch = router.fetch;
    $lliNT.useEffect(function() {
        getFetcher(fetcherKey);
        return function() {
            return deleteFetcher(fetcherKey);
        };
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    var load = $lliNT.useCallback(function(href, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        invariant(routeId, "No routeId available for fetcher.load()");
                        return [
                            4,
                            routerFetch(fetcherKey, routeId, href, opts)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    var submitImpl = useSubmit();
    var submit = $lliNT.useCallback(function(target, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            submitImpl(target, (0, $6fpqi._)((0, $1XAnY._)({}, opts), {
                                navigate: false,
                                fetcherKey: fetcherKey
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        fetcherKey,
        submitImpl
    ]);
    var reset = $lliNT.useCallback(function(opts) {
        return resetFetcher(fetcherKey, opts);
    }, [
        resetFetcher,
        fetcherKey
    ]);
    var FetcherForm = $lliNT.useMemo(function() {
        var FetcherForm2 = $1aLYV.forwardRef(function(props, ref) {
            return /* @__PURE__ */ $tLNoZ.createElement(Form, (0, $6fpqi._)((0, $1XAnY._)({}, props), {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    var fetcher = state.fetchers.get(fetcherKey) || IDLE_FETCHER;
    var data2 = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $lliNT.useMemo(function() {
        return (0, $6fpqi._)((0, $1XAnY._)({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset
        }, fetcher), {
            data: data2
        });
    }, [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function useFetchers() {
    var state = useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $lliNT.useMemo(function() {
        return Array.from(state.fetchers.entries()).map(function(param) {
            var _param = (0, $f9AOD._)(param, 2), key = _param[0], fetcher = _param[1];
            return (0, $6fpqi._)((0, $1XAnY._)({}, fetcher), {
                key: key
            });
        });
    }, [
        state.fetchers
    ]);
}
var SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var savedScrollPositions = {};
function getScrollRestorationKey(location, matches, basename, getKey) {
    var key = null;
    if (getKey) {
        if (basename !== "/") key = getKey((0, $6fpqi._)((0, $1XAnY._)({}, location), {
            pathname: stripBasename(location.pathname, basename) || location.pathname
        }), matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function useScrollRestoration() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ ).router;
    var _useDataRouterState2 = useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ ), restoreScrollPosition = _useDataRouterState2.restoreScrollPosition, preventScrollReset = _useDataRouterState2.preventScrollReset;
    var basename = $lliNT.useContext(NavigationContext).basename;
    var location = useLocation();
    var matches = useMatches();
    var navigation = useNavigation();
    $lliNT.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    usePageHide($lliNT.useCallback(function() {
        if (navigation.state === "idle") {
            var key = getScrollRestorationKey(location, matches, basename, getKey);
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {
            warning(false, "Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (".concat(error, ")."));
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $lliNT.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $lliNT.useLayoutEffect(function() {
            var disableScrollRestoration = router === null || router === void 0 ? void 0 : router.enableScrollRestoration(savedScrollPositions, function() {
                return window.scrollY;
            }, getKey ? function(location2, matches2) {
                return getScrollRestorationKey(location2, matches2, basename, getKey);
            } : void 0);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        $lliNT.useLayoutEffect(function() {
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch (e) {
                warning(false, '"'.concat(location.hash.slice(1), '" is not a decodable element ID. The view will not scroll to it.'));
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function useBeforeUnload(callback, options) {
    var capture = (options || {}).capture;
    $lliNT.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $lliNT.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function usePrompt(param) {
    var when = param.when, message = param.message;
    var blocker = useBlocker(when);
    $lliNT.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $lliNT.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function useViewTransitionState(to) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    var vtContext = $lliNT.useContext(ViewTransitionContext);
    invariant(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    var basename = useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ ).basename;
    var path = useResolvedPath(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = stripBasename(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = stripBasename(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return matchPath(path.pathname, nextPath) != null || matchPath(path.pathname, currentPath) != null;
}
function StaticRouter(param) {
    var basename = param.basename, children = param.children, tmp = param.location, locationProp = tmp === void 0 ? "/" : tmp;
    if (typeof locationProp === "string") locationProp = parsePath(locationProp);
    var action = "POP" /* Pop */ ;
    var location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    var staticNavigator = getStatelessNavigator();
    return /* @__PURE__ */ $tLNoZ.createElement(Router, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function StaticRouterProvider(param) {
    var context = param.context, router = param.router, tmp = param.hydrate, hydrate2 = tmp === void 0 ? true : tmp, nonce = param.nonce;
    invariant(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    var dataRouterContext = {
        router: router,
        navigator: getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    var fetchersContext = /* @__PURE__ */ new Map();
    var hydrateScript = "";
    if (hydrate2 !== false) {
        var data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: serializeErrors(context.errors)
        };
        var json = escapeHtml(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = "window.__staticRouterHydrationData = JSON.parse(".concat(json, ");");
    }
    var state = dataRouterContext.router.state;
    return /* @__PURE__ */ $tLNoZ.createElement($tLNoZ.Fragment, null, /* @__PURE__ */ $tLNoZ.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $tLNoZ.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /* @__PURE__ */ $tLNoZ.createElement(FetchersContext.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $tLNoZ.createElement(ViewTransitionContext.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $tLNoZ.createElement(Router, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $tLNoZ.createElement(DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $tLNoZ.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function serializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $f9AOD._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            if (isRouteErrorResponse(val)) serialized[key] = (0, $6fpqi._)((0, $1XAnY._)({}, val), {
                __type: "RouteErrorResponse"
            });
            else if (val instanceof Error) serialized[key] = (0, $1XAnY._)({
                message: val.message,
                __type: "Error"
            }, val.name !== "Error" ? {
                __subType: val.name
            } : {});
            else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
function getStatelessNavigator() {
    return {
        createHref: createHref,
        encodeLocation: encodeLocation,
        push: function(to) {
            throw new Error("You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a `navigate(".concat(JSON.stringify(to), ")` somewhere in your app."));
        },
        replace: function(to) {
            throw new Error("You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a `navigate(".concat(JSON.stringify(to), ", { replace: true })` somewhere in your app."));
        },
        go: function(delta) {
            throw new Error("You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a `navigate(".concat(delta, ")` somewhere in your app."));
        },
        back: function() {
            throw new Error("You cannot use navigator.back() on the server because it is a stateless environment.");
        },
        forward: function() {
            throw new Error("You cannot use navigator.forward() on the server because it is a stateless environment.");
        }
    };
}
function createStaticHandler2(routes, opts) {
    return createStaticHandler(routes, (0, $6fpqi._)((0, $1XAnY._)({}, opts), {
        mapRouteProperties: mapRouteProperties
    }));
}
function createStaticRouter(routes, context) {
    var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var manifest = {};
    var dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, void 0, manifest);
    var matches = context.matches.map(function(match) {
        var route = manifest[match.route.id] || match.route;
        return (0, $6fpqi._)((0, $1XAnY._)({}, match), {
            route: route
        });
    });
    var msg = function(method) {
        return "You cannot use router.".concat(method, "() on the server because it is a stateless environment");
    };
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return (0, $1XAnY._)({
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false
            }, opts === null || opts === void 0 ? void 0 : opts.future);
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: IDLE_NAVIGATION,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize: function() {
            throw msg("initialize");
        },
        subscribe: function() {
            throw msg("subscribe");
        },
        enableScrollRestoration: function() {
            throw msg("enableScrollRestoration");
        },
        navigate: function() {
            throw msg("navigate");
        },
        fetch: function() {
            throw msg("fetch");
        },
        revalidate: function() {
            throw msg("revalidate");
        },
        createHref: createHref,
        encodeLocation: encodeLocation,
        getFetcher: function() {
            return IDLE_FETCHER;
        },
        deleteFetcher: function() {
            throw msg("deleteFetcher");
        },
        resetFetcher: function() {
            throw msg("resetFetcher");
        },
        dispose: function() {
            throw msg("dispose");
        },
        getBlocker: function() {
            return IDLE_BLOCKER;
        },
        deleteBlocker: function() {
            throw msg("deleteBlocker");
        },
        patchRoutes: function() {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes: function() {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp: function() {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function createHref(to) {
    return typeof to === "string" ? to : createPath(to);
}
function encodeLocation(to) {
    var href = typeof to === "string" ? to : createPath(to);
    href = href.replace(/ $/, "%20");
    var encoded = ABSOLUTE_URL_REGEX.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}

});
parcelRegister("7qXGD", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5699429d06f3bb79$export$71511d61b312f219; });

var $kg0zo = parcelRequire("kg0zo");

var $euUQR = parcelRequire("euUQR");

var $fdc2U = parcelRequire("fdc2U");
function $5699429d06f3bb79$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $kg0zo._)(derived);
    return (0, $fdc2U._)(_this, (0, $euUQR._)() ? Reflect.construct(derived, args || [], (0, $kg0zo._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("kg0zo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ebf5be710afaab4a$export$71511d61b312f219; });
function $ebf5be710afaab4a$export$71511d61b312f219(o) {
    $ebf5be710afaab4a$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ebf5be710afaab4a$export$71511d61b312f219(o);
}

});

parcelRegister("euUQR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a8dff79067a3c1ae$export$71511d61b312f219; });
function $a8dff79067a3c1ae$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($a8dff79067a3c1ae$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("fdc2U", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b13169fb786eb9c8$export$71511d61b312f219; });

var $gXzGB = parcelRequire("gXzGB");

var $7E0eS = parcelRequire("7E0eS");
function $b13169fb786eb9c8$export$71511d61b312f219(self, call) {
    if (call && ((0, $7E0eS._)(call) === "object" || typeof call === "function")) return call;
    return (0, $gXzGB._)(self);
}

});
parcelRegister("gXzGB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c58dd68f03809c9f$export$71511d61b312f219; });
function $c58dd68f03809c9f$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("hdIku", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c896097e7c10d773$export$71511d61b312f219; });

var $fyVjP = parcelRequire("fyVjP");
function $c896097e7c10d773$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $fyVjP._)(subClass, superClass);
}

});
parcelRegister("fyVjP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b5467e4dcf9df57b$export$71511d61b312f219; });
function $b5467e4dcf9df57b$export$71511d61b312f219(o, p) {
    $b5467e4dcf9df57b$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b5467e4dcf9df57b$export$71511d61b312f219(o, p);
}

});


parcelRegister("6fpqi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $48c7dd510ebacb86$export$71511d61b312f219; });
function $48c7dd510ebacb86$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $48c7dd510ebacb86$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $48c7dd510ebacb86$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("6acIq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $47cd8a44b5fc4469$export$71511d61b312f219; });

var $5sh6U = parcelRequire("5sh6U");
function $47cd8a44b5fc4469$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $5sh6U._)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("5sh6U", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3f8cd710f9652db5$export$71511d61b312f219; });
function $3f8cd710f9652db5$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("f9AOD", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b08441208992b1a4$export$71511d61b312f219; });

var $9366V = parcelRequire("9366V");

var $faN4O = parcelRequire("faN4O");

var $2aJ1i = parcelRequire("2aJ1i");

var $dyckk = parcelRequire("dyckk");
function $b08441208992b1a4$export$71511d61b312f219(arr, i) {
    return (0, $9366V._)(arr) || (0, $faN4O._)(arr, i) || (0, $dyckk._)(arr, i) || (0, $2aJ1i._)();
}

});
parcelRegister("9366V", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6969224e78caffb5$export$71511d61b312f219; });
function $6969224e78caffb5$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("faN4O", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b0bddbcdf915a311$export$71511d61b312f219; });
function $b0bddbcdf915a311$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("2aJ1i", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $194f6ff112bed8c6$export$71511d61b312f219; });
function $194f6ff112bed8c6$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("iQDyc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $db8bc344974bb245$export$71511d61b312f219; });

var $9366V = parcelRequire("9366V");

var $fSnLV = parcelRequire("fSnLV");

var $2aJ1i = parcelRequire("2aJ1i");

var $dyckk = parcelRequire("dyckk");
function $db8bc344974bb245$export$71511d61b312f219(arr) {
    return (0, $9366V._)(arr) || (0, $fSnLV._)(arr) || (0, $dyckk._)(arr) || (0, $2aJ1i._)();
}

});

parcelRegister("1SdK7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $15d57e9fad4077d2$export$71511d61b312f219; });

var $2Ysl1 = parcelRequire("2Ysl1");

var $kg0zo = parcelRequire("kg0zo");

var $PC69E = parcelRequire("PC69E");

var $fyVjP = parcelRequire("fyVjP");
function $15d57e9fad4077d2$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $15d57e9fad4077d2$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $PC69E._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $2Ysl1._)(Class, arguments, (0, $kg0zo._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $fyVjP._)(Wrapper, Class);
    };
    return $15d57e9fad4077d2$export$71511d61b312f219(Class);
}

});
parcelRegister("2Ysl1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $22a72ab9392d6183$export$71511d61b312f219; });

var $euUQR = parcelRequire("euUQR");

var $fyVjP = parcelRequire("fyVjP");
function $22a72ab9392d6183$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $euUQR._)()) $22a72ab9392d6183$export$71511d61b312f219 = Reflect.construct;
    else $22a72ab9392d6183$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $fyVjP._)(instance, Class.prototype);
        return instance;
    };
    return $22a72ab9392d6183$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("PC69E", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09b2510eb3fb01bb$export$71511d61b312f219; });
function $09b2510eb3fb01bb$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("1aLYV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "useSyncExternalStore", function () { return $0dabf1c3a9f3320f$export$306c0aa65ff9ec16; });
$parcel$export(module.exports, "startTransition", function () { return $0dabf1c3a9f3320f$export$7568632d0d33d16d; });
$parcel$export(module.exports, "useDeferredValue", function () { return $0dabf1c3a9f3320f$export$6a7bc4e911dc01cf; });
$parcel$export(module.exports, "useTransition", function () { return $0dabf1c3a9f3320f$export$7b286972b8d8ccbf; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $0dabf1c3a9f3320f$export$aaabe4eda9ed9969; });
$parcel$export(module.exports, "PureComponent", function () { return $0dabf1c3a9f3320f$export$221d75b3f55bb0bd; });
$parcel$export(module.exports, "memo", function () { return $0dabf1c3a9f3320f$export$7c73462e0d25e514; });
$parcel$export(module.exports, "forwardRef", function () { return $0dabf1c3a9f3320f$export$257a8862b851cb5b; });
$parcel$export(module.exports, "Children", function () { return $0dabf1c3a9f3320f$export$dca3b0875bd9a954; });
$parcel$export(module.exports, "Suspense", function () { return $0dabf1c3a9f3320f$export$74bf444e3cd11ea5; });
$parcel$export(module.exports, "lazy", function () { return $0dabf1c3a9f3320f$export$488013bae63b21da; });
$parcel$export(module.exports, "SuspenseList", function () { return $0dabf1c3a9f3320f$export$998bcd577473dd93; });
$parcel$export(module.exports, "createPortal", function () { return $0dabf1c3a9f3320f$export$d39a5bbd09211389; });
$parcel$export(module.exports, "render", function () { return $0dabf1c3a9f3320f$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "hydrate", function () { return $0dabf1c3a9f3320f$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $0dabf1c3a9f3320f$export$ae55be85d98224ed; });
$parcel$export(module.exports, "version", function () { return $0dabf1c3a9f3320f$export$83d89fbfd8236492; });
$parcel$export(module.exports, "createFactory", function () { return $0dabf1c3a9f3320f$export$d38cd72104c1f0e9; });
$parcel$export(module.exports, "isValidElement", function () { return $0dabf1c3a9f3320f$export$a8257692ac88316c; });
$parcel$export(module.exports, "isFragment", function () { return $0dabf1c3a9f3320f$export$9522e17588c12572; });
$parcel$export(module.exports, "isMemo", function () { return $0dabf1c3a9f3320f$export$56885ab8b9c456ab; });
$parcel$export(module.exports, "cloneElement", function () { return $0dabf1c3a9f3320f$export$e530037191fcd5d7; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $0dabf1c3a9f3320f$export$502457920280e6be; });
$parcel$export(module.exports, "findDOMNode", function () { return $0dabf1c3a9f3320f$export$466bfc07425424d5; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $0dabf1c3a9f3320f$export$c78a37762a8d58e1; });
$parcel$export(module.exports, "flushSync", function () { return $0dabf1c3a9f3320f$export$cd75ccfd720a3cd4; });
$parcel$export(module.exports, "isElement", function () { return $0dabf1c3a9f3320f$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "default", function () { return $0dabf1c3a9f3320f$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Component", function () { return (parcelRequire("tLNoZ")).Component; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("tLNoZ")).Fragment; });
$parcel$export(module.exports, "StrictMode", function () { return (parcelRequire("tLNoZ")).Fragment; });
$parcel$export(module.exports, "createContext", function () { return (parcelRequire("tLNoZ")).createContext; });
$parcel$export(module.exports, "createElement", function () { return (parcelRequire("tLNoZ")).createElement; });
$parcel$export(module.exports, "createRef", function () { return (parcelRequire("tLNoZ")).createRef; });

var $7E0eS = parcelRequire("7E0eS");

var $tLNoZ = parcelRequire("tLNoZ");

var $lliNT = parcelRequire("lliNT");
function $0dabf1c3a9f3320f$var$g(n, t) {
    for(var _$e in t)n[_$e] = t[_$e];
    return n;
}
function $0dabf1c3a9f3320f$var$E(n, t) {
    for(var _$e in n)if ("__source" !== _$e && !(_$e in t)) return !0;
    for(var _$r in t)if ("__source" !== _$r && n[_$r] !== t[_$r]) return !0;
    return !1;
}
function $0dabf1c3a9f3320f$export$306c0aa65ff9ec16(n, t) {
    var _$e = t(), _$r = (0, $lliNT.useState)({
        t: {
            __: _$e,
            u: t
        }
    }), _$u = _$r[0].t, o = _$r[1];
    return (0, $lliNT.useLayoutEffect)(function() {
        _$u.__ = _$e, _$u.u = t, $0dabf1c3a9f3320f$var$R(_$u) && o({
            t: _$u
        });
    }, [
        n,
        _$e,
        t
    ]), (0, $lliNT.useEffect)(function() {
        return $0dabf1c3a9f3320f$var$R(_$u) && o({
            t: _$u
        }), n(function() {
            $0dabf1c3a9f3320f$var$R(_$u) && o({
                t: _$u
            });
        });
    }, [
        n
    ]), _$e;
}
function $0dabf1c3a9f3320f$var$R(n) {
    try {
        return !((_$t = n.__) === (_$e = n.u()) && (0 !== _$t || 1 / _$t == 1 / _$e) || _$t != _$t && _$e != _$e);
    } catch (n) {
        return !0;
    }
    var _$t, _$e;
}
function $0dabf1c3a9f3320f$export$7568632d0d33d16d(n) {
    n();
}
function $0dabf1c3a9f3320f$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $0dabf1c3a9f3320f$export$7b286972b8d8ccbf() {
    return [
        !1,
        $0dabf1c3a9f3320f$export$7568632d0d33d16d
    ];
}
var $0dabf1c3a9f3320f$export$aaabe4eda9ed9969 = (0, $lliNT.useLayoutEffect);
function $0dabf1c3a9f3320f$export$221d75b3f55bb0bd(n, t) {
    this.props = n, this.context = t;
}
function $0dabf1c3a9f3320f$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var _$t = this.props.ref;
        return _$t != n.ref && _$t && ("function" == typeof _$t ? _$t(null) : _$t.current = null), e ? !e(this.props, n) || _$t != n.ref : $0dabf1c3a9f3320f$var$E(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $tLNoZ.createElement)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.__f = u.prototype.isReactComponent = !0, u.type = n, u;
}
($0dabf1c3a9f3320f$export$221d75b3f55bb0bd.prototype = new (0, $tLNoZ.Component)).isPureReactComponent = !0, $0dabf1c3a9f3320f$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $0dabf1c3a9f3320f$var$E(this.props, n) || $0dabf1c3a9f3320f$var$E(this.state, t);
};
var $0dabf1c3a9f3320f$var$T = (0, $tLNoZ.options).__b;
(0, $tLNoZ.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $0dabf1c3a9f3320f$var$T && $0dabf1c3a9f3320f$var$T(n);
};
var $0dabf1c3a9f3320f$var$A = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $0dabf1c3a9f3320f$export$257a8862b851cb5b(n) {
    function t(t) {
        var _$e = $0dabf1c3a9f3320f$var$g({}, t);
        return delete _$e.ref, n(_$e, t.ref || null);
    }
    return t.$$typeof = $0dabf1c3a9f3320f$var$A, t.render = n, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $0dabf1c3a9f3320f$var$F = function F(n, t) {
    return null == n ? null : (0, $tLNoZ.toChildArray)((0, $tLNoZ.toChildArray)(n).map(t));
}, $0dabf1c3a9f3320f$export$dca3b0875bd9a954 = {
    map: $0dabf1c3a9f3320f$var$F,
    forEach: $0dabf1c3a9f3320f$var$F,
    count: function count(n) {
        return n ? (0, $tLNoZ.toChildArray)(n).length : 0;
    },
    only: function only(n) {
        var _$t = (0, $tLNoZ.toChildArray)(n);
        if (1 !== _$t.length) throw "Children.only";
        return _$t[0];
    },
    toArray: (0, $tLNoZ.toChildArray)
}, $0dabf1c3a9f3320f$var$O = (0, $tLNoZ.options).__e;
(0, $tLNoZ.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var _$u, o = t; o = o.__;)if ((_$u = o.__c) && _$u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), _$u.__c(n, t);
    }
    $0dabf1c3a9f3320f$var$O(n, t, e, r);
};
var $0dabf1c3a9f3320f$var$U = (0, $tLNoZ.options).unmount;
function $0dabf1c3a9f3320f$var$V(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $0dabf1c3a9f3320f$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c.__e = !0, n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $0dabf1c3a9f3320f$var$V(n, t, e);
    })), n;
}
function $0dabf1c3a9f3320f$var$W(n, t, e) {
    return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $0dabf1c3a9f3320f$var$W(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.appendChild(n.__e), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $0dabf1c3a9f3320f$export$74bf444e3cd11ea5() {
    this.__u = 0, this.o = null, this.__b = null;
}
function $0dabf1c3a9f3320f$var$j(n) {
    var _$t = n.__ && n.__.__c;
    return _$t && _$t.__a && _$t.__a(n);
}
function $0dabf1c3a9f3320f$export$488013bae63b21da(n) {
    var _$e, _$r, _$u, o = null;
    function i(i) {
        if (_$e || (_$e = n()).then(function(n) {
            n && (o = n.default || n), _$u = !0;
        }, function(n) {
            _$r = n, _$u = !0;
        }), _$r) throw _$r;
        if (!_$u) throw _$e;
        return o ? (0, $tLNoZ.createElement)(o, i) : null;
    }
    return i.displayName = "Lazy", i.__f = !0, i;
}
function $0dabf1c3a9f3320f$export$998bcd577473dd93() {
    this.i = null, this.l = null;
}
(0, $tLNoZ.options).unmount = function(n) {
    var _$t = n.__c;
    _$t && (_$t.__z = !0), _$t && _$t.__R && _$t.__R(), _$t && 32 & n.__u && (n.type = null), $0dabf1c3a9f3320f$var$U && $0dabf1c3a9f3320f$var$U(n);
}, ($0dabf1c3a9f3320f$export$74bf444e3cd11ea5.prototype = new (0, $tLNoZ.Component)).__c = function(n, t) {
    var _$e = t.__c, _$r = this;
    null == _$r.o && (_$r.o = []), _$r.o.push(_$e);
    var _$u = $0dabf1c3a9f3320f$var$j(_$r.__v), o = !1, i = function i() {
        o || _$r.__z || (o = !0, _$e.__R = null, _$u ? _$u(_$c) : _$c());
    };
    _$e.__R = i;
    var _$l = _$e.__P;
    _$e.__P = null;
    var _$c = function c() {
        if (!--_$r.__u) {
            if (_$r.state.__a) {
                var _$n = _$r.state.__a;
                _$r.__v.__k[0] = $0dabf1c3a9f3320f$var$W(_$n, _$n.__c.__P, _$n.__c.__O);
            }
            var _$t;
            for(_$r.setState({
                __a: _$r.__b = null
            }); _$t = _$r.o.pop();)_$t.__P = _$l, _$t.forceUpdate();
        }
    };
    _$r.__u++ || 32 & t.__u || _$r.setState({
        __a: _$r.__b = _$r.__v.__k[0]
    }), n.then(i, i);
}, $0dabf1c3a9f3320f$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.o = [];
}, $0dabf1c3a9f3320f$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var _$r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $0dabf1c3a9f3320f$var$V(this.__b, _$r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $tLNoZ.createElement)((0, $tLNoZ.Fragment), null, n.fallback);
    return i && (i.__u &= -33), [
        (0, $tLNoZ.createElement)((0, $tLNoZ.Fragment), null, e.__a ? null : n.children),
        i
    ];
};
var $0dabf1c3a9f3320f$var$H = function H(n, t, e) {
    if (++e[1] === e[0] && n.l.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.l.size)) for(e = n.i; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.i = e = e[2];
    }
};
function $0dabf1c3a9f3320f$var$Z(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $0dabf1c3a9f3320f$var$Y(n) {
    var _$e = this, _$r = n.h;
    if (_$e.componentWillUnmount = function() {
        (0, $tLNoZ.render)(null, _$e.v), _$e.v = null, _$e.h = null;
    }, _$e.h && _$e.h !== _$r && _$e.componentWillUnmount(), !_$e.v) {
        for(var _$u = _$e.__v; null !== _$u && !_$u.__m && null !== _$u.__;)_$u = _$u.__;
        _$e.h = _$r, _$e.v = {
            nodeType: 1,
            parentNode: _$r,
            childNodes: [],
            __k: {
                __m: _$u.__m
            },
            contains: function contains() {
                return !0;
            },
            namespaceURI: _$r.namespaceURI,
            insertBefore: function insertBefore(n, t) {
                this.childNodes.push(n), _$e.h.insertBefore(n, t);
            },
            removeChild: function removeChild(n) {
                this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), _$e.h.removeChild(n);
            }
        };
    }
    (0, $tLNoZ.render)((0, $tLNoZ.createElement)($0dabf1c3a9f3320f$var$Z, {
        context: _$e.context
    }, n.__v), _$e.v);
}
function $0dabf1c3a9f3320f$export$d39a5bbd09211389(n, e) {
    var _$r = (0, $tLNoZ.createElement)($0dabf1c3a9f3320f$var$Y, {
        __v: n,
        h: e
    });
    return _$r.containerInfo = e, _$r;
}
($0dabf1c3a9f3320f$export$998bcd577473dd93.prototype = new (0, $tLNoZ.Component)).__a = function(n) {
    var _$t = this, _$e = $0dabf1c3a9f3320f$var$j(_$t.__v), _$r = _$t.l.get(n);
    return _$r[0]++, function(u) {
        var o = function o() {
            _$t.props.revealOrder ? (_$r.push(u), $0dabf1c3a9f3320f$var$H(_$t, n, _$r)) : u();
        };
        _$e ? _$e(o) : o();
    };
}, $0dabf1c3a9f3320f$export$998bcd577473dd93.prototype.render = function(n) {
    this.i = null, this.l = new Map;
    var _$t = (0, $tLNoZ.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && _$t.reverse();
    for(var _$e = _$t.length; _$e--;)this.l.set(_$t[_$e], this.i = [
        1,
        0,
        this.i
    ]);
    return n.children;
}, $0dabf1c3a9f3320f$export$998bcd577473dd93.prototype.componentDidUpdate = $0dabf1c3a9f3320f$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var _$n = this;
    this.l.forEach(function(t, e) {
        $0dabf1c3a9f3320f$var$H(_$n, e, t);
    });
};
var $0dabf1c3a9f3320f$var$q = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $0dabf1c3a9f3320f$var$G = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $0dabf1c3a9f3320f$var$J = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $0dabf1c3a9f3320f$var$K = /[A-Z0-9]/g, $0dabf1c3a9f3320f$var$Q = "undefined" != typeof document, $0dabf1c3a9f3320f$var$X = function X(n) {
    return ("undefined" != typeof Symbol && "symbol" == (0, $7E0eS._)(Symbol()) ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function $0dabf1c3a9f3320f$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $tLNoZ.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $0dabf1c3a9f3320f$export$fa8d919ba61d84db(n, t, e) {
    return (0, $tLNoZ.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $tLNoZ.Component).prototype.isReactComponent = !0, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $tLNoZ.Component).prototype, t, {
        configurable: !0,
        get: function get() {
            return this["UNSAFE_" + t];
        },
        set: function set(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $0dabf1c3a9f3320f$var$en = (0, $tLNoZ.options).event;
(0, $tLNoZ.options).event = function(n) {
    return $0dabf1c3a9f3320f$var$en && (n = $0dabf1c3a9f3320f$var$en(n)), n.persist = function() {}, n.isPropagationStopped = function() {
        return this.cancelBubble;
    }, n.isDefaultPrevented = function() {
        return this.defaultPrevented;
    }, n.nativeEvent = n;
};
var $0dabf1c3a9f3320f$var$rn, $0dabf1c3a9f3320f$var$un = {
    configurable: !0,
    get: function get() {
        return this.class;
    }
}, $0dabf1c3a9f3320f$var$on = (0, $tLNoZ.options).vnode;
(0, $tLNoZ.options).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var _$t = n.props, _$e = n.type, _$u = {}, o = -1 == _$e.indexOf("-");
        for(var i in _$t){
            var _$l = _$t[i];
            if (!("value" === i && "defaultValue" in _$t && null == _$l || $0dabf1c3a9f3320f$var$Q && "children" === i && "noscript" === _$e || "class" === i || "className" === i)) {
                var _$c = i.toLowerCase();
                "defaultValue" === i && "value" in _$t && null == _$t.value ? i = "value" : "download" === i && !0 === _$l ? _$l = "" : "translate" === _$c && "no" === _$l ? _$l = !1 : "o" === _$c[0] && "n" === _$c[1] ? "ondoubleclick" === _$c ? i = "ondblclick" : "onchange" !== _$c || "input" !== _$e && "textarea" !== _$e || $0dabf1c3a9f3320f$var$X(_$t.type) ? "onfocus" === _$c ? i = "onfocusin" : "onblur" === _$c ? i = "onfocusout" : $0dabf1c3a9f3320f$var$J.test(i) && (i = _$c) : _$c = i = "oninput" : o && $0dabf1c3a9f3320f$var$G.test(i) ? i = i.replace($0dabf1c3a9f3320f$var$K, "-$&").toLowerCase() : null === _$l && (_$l = void 0), "oninput" === _$c && _$u[i = _$c] && (i = "oninputCapture"), _$u[i] = _$l;
            }
        }
        "select" == _$e && (_$u.multiple && Array.isArray(_$u.value) && (_$u.value = (0, $tLNoZ.toChildArray)(_$t.children).forEach(function(n) {
            n.props.selected = -1 != _$u.value.indexOf(n.props.value);
        })), null != _$u.defaultValue && (_$u.value = (0, $tLNoZ.toChildArray)(_$t.children).forEach(function(n) {
            n.props.selected = _$u.multiple ? -1 != _$u.defaultValue.indexOf(n.props.value) : _$u.defaultValue == n.props.value;
        }))), _$t.class && !_$t.className ? (_$u.class = _$t.class, Object.defineProperty(_$u, "className", $0dabf1c3a9f3320f$var$un)) : _$t.className && (_$u.class = _$u.className = _$t.className), n.props = _$u;
    }(n), n.$$typeof = $0dabf1c3a9f3320f$var$q, $0dabf1c3a9f3320f$var$on && $0dabf1c3a9f3320f$var$on(n);
};
var $0dabf1c3a9f3320f$var$ln = (0, $tLNoZ.options).__r;
(0, $tLNoZ.options).__r = function(n) {
    $0dabf1c3a9f3320f$var$ln && $0dabf1c3a9f3320f$var$ln(n), $0dabf1c3a9f3320f$var$rn = n.__c;
};
var $0dabf1c3a9f3320f$var$cn = (0, $tLNoZ.options).diffed;
(0, $tLNoZ.options).diffed = function(n) {
    $0dabf1c3a9f3320f$var$cn && $0dabf1c3a9f3320f$var$cn(n);
    var _$t = n.props, _$e = n.__e;
    null != _$e && "textarea" === n.type && "value" in _$t && _$t.value !== _$e.value && (_$e.value = null == _$t.value ? "" : _$t.value), $0dabf1c3a9f3320f$var$rn = null;
};
var $0dabf1c3a9f3320f$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function readContext(n) {
                return $0dabf1c3a9f3320f$var$rn.__n[n.__c].props.value;
            },
            useCallback: (0, $lliNT.useCallback),
            useContext: (0, $lliNT.useContext),
            useDebugValue: (0, $lliNT.useDebugValue),
            useDeferredValue: $0dabf1c3a9f3320f$export$6a7bc4e911dc01cf,
            useEffect: (0, $lliNT.useEffect),
            useId: (0, $lliNT.useId),
            useImperativeHandle: (0, $lliNT.useImperativeHandle),
            useInsertionEffect: $0dabf1c3a9f3320f$export$aaabe4eda9ed9969,
            useLayoutEffect: (0, $lliNT.useLayoutEffect),
            useMemo: (0, $lliNT.useMemo),
            useReducer: (0, $lliNT.useReducer),
            useRef: (0, $lliNT.useRef),
            useState: (0, $lliNT.useState),
            useSyncExternalStore: $0dabf1c3a9f3320f$export$306c0aa65ff9ec16,
            useTransition: $0dabf1c3a9f3320f$export$7b286972b8d8ccbf
        }
    }
}, $0dabf1c3a9f3320f$export$83d89fbfd8236492 = "18.3.1";
function $0dabf1c3a9f3320f$export$d38cd72104c1f0e9(n) {
    return (0, $tLNoZ.createElement).bind(null, n);
}
function $0dabf1c3a9f3320f$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $0dabf1c3a9f3320f$var$q;
}
function $0dabf1c3a9f3320f$export$9522e17588c12572(n) {
    return $0dabf1c3a9f3320f$export$a8257692ac88316c(n) && n.type === (0, $tLNoZ.Fragment);
}
function $0dabf1c3a9f3320f$export$56885ab8b9c456ab(n) {
    return !!n && "string" == typeof n.displayName && 0 == n.displayName.indexOf("Memo(");
}
function $0dabf1c3a9f3320f$export$e530037191fcd5d7(n) {
    return $0dabf1c3a9f3320f$export$a8257692ac88316c(n) ? (0, $tLNoZ.cloneElement).apply(null, arguments) : n;
}
function $0dabf1c3a9f3320f$export$502457920280e6be(n) {
    return !!n.__k && ((0, $tLNoZ.render)(null, n), !0);
}
function $0dabf1c3a9f3320f$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $0dabf1c3a9f3320f$export$c78a37762a8d58e1 = function _n(n, t) {
    return n(t);
}, $0dabf1c3a9f3320f$export$cd75ccfd720a3cd4 = function bn(n, t) {
    var _$r = (0, $tLNoZ.options).debounceRendering;
    (0, $tLNoZ.options).debounceRendering = function(n) {
        return n();
    };
    var _$u = n(t);
    return (0, $tLNoZ.options).debounceRendering = _$r, _$u;
}, $0dabf1c3a9f3320f$export$45a5e7f76e0caa8d = $0dabf1c3a9f3320f$export$a8257692ac88316c, $0dabf1c3a9f3320f$export$2e2bcd8739ae039 = {
    useState: (0, $lliNT.useState),
    useId: (0, $lliNT.useId),
    useReducer: (0, $lliNT.useReducer),
    useEffect: (0, $lliNT.useEffect),
    useLayoutEffect: (0, $lliNT.useLayoutEffect),
    useInsertionEffect: $0dabf1c3a9f3320f$export$aaabe4eda9ed9969,
    useTransition: $0dabf1c3a9f3320f$export$7b286972b8d8ccbf,
    useDeferredValue: $0dabf1c3a9f3320f$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $0dabf1c3a9f3320f$export$306c0aa65ff9ec16,
    startTransition: $0dabf1c3a9f3320f$export$7568632d0d33d16d,
    useRef: (0, $lliNT.useRef),
    useImperativeHandle: (0, $lliNT.useImperativeHandle),
    useMemo: (0, $lliNT.useMemo),
    useCallback: (0, $lliNT.useCallback),
    useContext: (0, $lliNT.useContext),
    useDebugValue: (0, $lliNT.useDebugValue),
    version: "18.3.1",
    Children: $0dabf1c3a9f3320f$export$dca3b0875bd9a954,
    render: $0dabf1c3a9f3320f$export$b3890eb0ae9dca99,
    hydrate: $0dabf1c3a9f3320f$export$fa8d919ba61d84db,
    unmountComponentAtNode: $0dabf1c3a9f3320f$export$502457920280e6be,
    createPortal: $0dabf1c3a9f3320f$export$d39a5bbd09211389,
    createElement: (0, $tLNoZ.createElement),
    createContext: (0, $tLNoZ.createContext),
    createFactory: $0dabf1c3a9f3320f$export$d38cd72104c1f0e9,
    cloneElement: $0dabf1c3a9f3320f$export$e530037191fcd5d7,
    createRef: (0, $tLNoZ.createRef),
    Fragment: (0, $tLNoZ.Fragment),
    isValidElement: $0dabf1c3a9f3320f$export$a8257692ac88316c,
    isElement: $0dabf1c3a9f3320f$export$45a5e7f76e0caa8d,
    isFragment: $0dabf1c3a9f3320f$export$9522e17588c12572,
    isMemo: $0dabf1c3a9f3320f$export$56885ab8b9c456ab,
    findDOMNode: $0dabf1c3a9f3320f$export$466bfc07425424d5,
    Component: (0, $tLNoZ.Component),
    PureComponent: $0dabf1c3a9f3320f$export$221d75b3f55bb0bd,
    memo: $0dabf1c3a9f3320f$export$7c73462e0d25e514,
    forwardRef: $0dabf1c3a9f3320f$export$257a8862b851cb5b,
    flushSync: $0dabf1c3a9f3320f$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $0dabf1c3a9f3320f$export$c78a37762a8d58e1,
    StrictMode: (0, $tLNoZ.Fragment),
    Suspense: $0dabf1c3a9f3320f$export$74bf444e3cd11ea5,
    SuspenseList: $0dabf1c3a9f3320f$export$998bcd577473dd93,
    lazy: $0dabf1c3a9f3320f$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $0dabf1c3a9f3320f$export$ae55be85d98224ed
};
$parcel$exportWildcard(module.exports, $lliNT);

});
parcelRegister("tLNoZ", function(module, exports) {

$parcel$export(module.exports, "options", function () { return $0597c8ccd7701957$export$41c562ebe57d11e2; });
$parcel$export(module.exports, "createElement", function () { return $0597c8ccd7701957$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "createRef", function () { return $0597c8ccd7701957$export$7d1e3a5e95ceca43; });
$parcel$export(module.exports, "Fragment", function () { return $0597c8ccd7701957$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Component", function () { return $0597c8ccd7701957$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "toChildArray", function () { return $0597c8ccd7701957$export$47e4c5b300681277; });
$parcel$export(module.exports, "render", function () { return $0597c8ccd7701957$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "hydrate", function () { return $0597c8ccd7701957$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "cloneElement", function () { return $0597c8ccd7701957$export$e530037191fcd5d7; });
$parcel$export(module.exports, "createContext", function () { return $0597c8ccd7701957$export$fd42f52fd3ae1109; });

var $7E0eS = parcelRequire("7E0eS");
var $0597c8ccd7701957$var$n, $0597c8ccd7701957$export$41c562ebe57d11e2, $0597c8ccd7701957$var$u, $0597c8ccd7701957$export$a8257692ac88316c, $0597c8ccd7701957$var$i, $0597c8ccd7701957$var$r, $0597c8ccd7701957$var$o, $0597c8ccd7701957$var$e, $0597c8ccd7701957$var$f, $0597c8ccd7701957$var$c, $0597c8ccd7701957$var$a, $0597c8ccd7701957$var$s, $0597c8ccd7701957$var$h, $0597c8ccd7701957$var$p, $0597c8ccd7701957$var$v, $0597c8ccd7701957$var$y, $0597c8ccd7701957$var$d = {}, $0597c8ccd7701957$var$w = [], $0597c8ccd7701957$var$_ = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $0597c8ccd7701957$var$g = Array.isArray;
function $0597c8ccd7701957$var$m(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $0597c8ccd7701957$var$b(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $0597c8ccd7701957$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $0597c8ccd7701957$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $0597c8ccd7701957$var$x(l, e, i, r, null);
}
function $0597c8ccd7701957$var$x(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$0597c8ccd7701957$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $0597c8ccd7701957$export$41c562ebe57d11e2.vnode && $0597c8ccd7701957$export$41c562ebe57d11e2.vnode(e), e;
}
function $0597c8ccd7701957$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $0597c8ccd7701957$export$ffb0004e005737fa(n) {
    return n.children;
}
function $0597c8ccd7701957$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $0597c8ccd7701957$var$$(n, l) {
    if (null == l) return n.__ ? $0597c8ccd7701957$var$$(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $0597c8ccd7701957$var$$(n) : null;
}
function $0597c8ccd7701957$var$I(n) {
    if (n.__P && n.__d) {
        var u = n.__v, t = u.__e, i = [], r = [], o = $0597c8ccd7701957$var$m({}, u);
        o.__v = u.__v + 1, $0597c8ccd7701957$export$41c562ebe57d11e2.vnode && $0597c8ccd7701957$export$41c562ebe57d11e2.vnode(o), $0597c8ccd7701957$var$q(n.__P, o, u, n.__n, n.__P.namespaceURI, 32 & u.__u ? [
            t
        ] : null, i, null == t ? $0597c8ccd7701957$var$$(u) : t, !!(32 & u.__u), r), o.__v = u.__v, o.__.__k[o.__i] = o, $0597c8ccd7701957$var$D(i, o, r), u.__e = u.__ = null, o.__e != t && $0597c8ccd7701957$var$P(o);
    }
}
function $0597c8ccd7701957$var$P(n) {
    if (null != (n = n.__) && null != n.__c) return n.__e = n.__c.base = null, n.__k.some(function(l) {
        if (null != l && null != l.__e) return n.__e = n.__c.base = l.__e;
    }), $0597c8ccd7701957$var$P(n);
}
function $0597c8ccd7701957$var$A(n) {
    (!n.__d && (n.__d = !0) && $0597c8ccd7701957$var$i.push(n) && !$0597c8ccd7701957$var$H.__r++ || $0597c8ccd7701957$var$r != $0597c8ccd7701957$export$41c562ebe57d11e2.debounceRendering) && (($0597c8ccd7701957$var$r = $0597c8ccd7701957$export$41c562ebe57d11e2.debounceRendering) || $0597c8ccd7701957$var$o)($0597c8ccd7701957$var$H);
}
function $0597c8ccd7701957$var$H() {
    try {
        for(var n, l = 1; $0597c8ccd7701957$var$i.length;)$0597c8ccd7701957$var$i.length > l && $0597c8ccd7701957$var$i.sort($0597c8ccd7701957$var$e), n = $0597c8ccd7701957$var$i.shift(), l = $0597c8ccd7701957$var$i.length, $0597c8ccd7701957$var$I(n);
    } finally{
        $0597c8ccd7701957$var$i.length = $0597c8ccd7701957$var$H.__r = 0;
    }
}
function $0597c8ccd7701957$var$L(n, l, u, t, i, r, o, e, f, c, a) {
    var s, h, p, v, y, _, g, m = t && t.__k || $0597c8ccd7701957$var$w, b = l.length;
    for(f = $0597c8ccd7701957$var$T(u, l, m, f, b), s = 0; s < b; s++)null != (p = u.__k[s]) && (h = -1 != p.__i && m[p.__i] || $0597c8ccd7701957$var$d, p.__i = s, _ = $0597c8ccd7701957$var$q(n, p, h, i, r, o, e, f, c, a), v = p.__e, p.ref && h.ref != p.ref && (h.ref && $0597c8ccd7701957$var$J(h.ref, null, p), a.push(p.ref, p.__c || v, p)), null == y && null != v && (y = v), (g = !!(4 & p.__u)) || h.__k === p.__k ? (f = $0597c8ccd7701957$var$j(p, f, n, g), g && h.__e && (h.__e = null)) : "function" == typeof p.type && void 0 !== _ ? f = _ : v && (f = v.nextSibling), p.__u &= -7);
    return u.__e = y, f;
}
function $0597c8ccd7701957$var$T(n, l, u, t, i) {
    var r, o, e, f, c, a = u.length, s = a, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? ("string" == typeof o || "number" == typeof o || "bigint" == (typeof o === "undefined" ? "undefined" : (0, $7E0eS._)(o)) || o.constructor == String ? o = n.__k[r] = $0597c8ccd7701957$var$x(null, o, null, null, null) : $0597c8ccd7701957$var$g(o) ? o = n.__k[r] = $0597c8ccd7701957$var$x($0597c8ccd7701957$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : void 0 === o.constructor && o.__b > 0 ? o = n.__k[r] = $0597c8ccd7701957$var$x(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : n.__k[r] = o, f = r + h, o.__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = $0597c8ccd7701957$var$O(o, u, f, s)) && (s--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > a ? h-- : i < a && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (s) for(r = 0; r < a; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $0597c8ccd7701957$var$$(e)), $0597c8ccd7701957$var$K(e, e));
    return t;
}
function $0597c8ccd7701957$var$j(n, l, u, t) {
    var i, r;
    if ("function" == typeof n.type) {
        for(i = n.__k, r = 0; i && r < i.length; r++)i[r] && (i[r].__ = n, l = $0597c8ccd7701957$var$j(i[r], l, u, t));
        return l;
    }
    n.__e != l && (t && (l && n.type && !l.parentNode && (l = $0597c8ccd7701957$var$$(n)), u.insertBefore(n.__e, l || null)), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $0597c8ccd7701957$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($0597c8ccd7701957$var$g(n) ? n.some(function(n) {
        $0597c8ccd7701957$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $0597c8ccd7701957$var$O(n, l, u, t) {
    var i, r, o, e = n.key, f = n.type, c = l[u], a = null != c && 0 == (2 & c.__u);
    if (null === c && null == e || a && e == c.key && f == c.type) return u;
    if (t > (a ? 1 : 0)) {
        for(i = u - 1, r = u + 1; i >= 0 || r < l.length;)if (null != (c = l[o = i >= 0 ? i-- : r++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return o;
    }
    return -1;
}
function $0597c8ccd7701957$var$z(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $0597c8ccd7701957$var$_.test(l) ? u : u + "px";
}
function $0597c8ccd7701957$var$N(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $0597c8ccd7701957$var$z(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $0597c8ccd7701957$var$z(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($0597c8ccd7701957$var$s, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u[$0597c8ccd7701957$var$a] = t[$0597c8ccd7701957$var$a] : (u[$0597c8ccd7701957$var$a] = $0597c8ccd7701957$var$h, n.addEventListener(l, r ? $0597c8ccd7701957$var$v : $0597c8ccd7701957$var$p, r)) : n.removeEventListener(l, r ? $0597c8ccd7701957$var$v : $0597c8ccd7701957$var$p, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $0597c8ccd7701957$var$V(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u[$0597c8ccd7701957$var$c]) u[$0597c8ccd7701957$var$c] = $0597c8ccd7701957$var$h++;
            else if (u[$0597c8ccd7701957$var$c] < t[$0597c8ccd7701957$var$a]) return;
            return t($0597c8ccd7701957$export$41c562ebe57d11e2.event ? $0597c8ccd7701957$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $0597c8ccd7701957$var$q(n, u, t, i, r, o, e, f, c, a) {
    var s, h, p, v, y, d, _, k, x, M, $, I, P, A, _$H, T = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (s = $0597c8ccd7701957$export$41c562ebe57d11e2.__b) && s(u);
    n: if ("function" == typeof T) try {
        if (k = u.props, x = T.prototype && T.prototype.render, M = (s = T.contextType) && i[s.__c], $ = s ? M ? M.props.value : s.__ : i, t.__c ? _ = (h = u.__c = t.__c).__ = h.__E : (x ? u.__c = h = new T(k, $) : (u.__c = h = new $0597c8ccd7701957$export$16fa2f45be04daa8(k, $), h.constructor = T, h.render = $0597c8ccd7701957$var$Q), M && M.sub(h), h.state || (h.state = {}), h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), x && null == h.__s && (h.__s = h.state), x && null != T.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $0597c8ccd7701957$var$m({}, h.__s)), $0597c8ccd7701957$var$m(h.__s, T.getDerivedStateFromProps(k, h.__s))), v = h.props, y = h.state, h.__v = u, p) x && null == T.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), x && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (x && null == T.getDerivedStateFromProps && k !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(k, $), u.__v == t.__v || !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(k, h.__s, $)) {
                u.__v != t.__v && (h.props = k, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $0597c8ccd7701957$var$w.push.apply(h.__h, h._sb), h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(k, h.__s, $), x && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, d);
            });
        }
        if (h.context = $, h.props = k, h.__P = n, h.__e = !1, I = $0597c8ccd7701957$export$41c562ebe57d11e2.__r, P = 0, x) h.state = h.__s, h.__d = !1, I && I(u), s = h.render(h.props, h.state, h.context), $0597c8ccd7701957$var$w.push.apply(h.__h, h._sb), h._sb = [];
        else do h.__d = !1, I && I(u), s = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++P < 25);
        h.state = h.__s, null != h.getChildContext && (i = $0597c8ccd7701957$var$m($0597c8ccd7701957$var$m({}, i), h.getChildContext())), x && !p && null != h.getSnapshotBeforeUpdate && (d = h.getSnapshotBeforeUpdate(v, y)), A = null != s && s.type === $0597c8ccd7701957$export$ffb0004e005737fa && null == s.key ? $0597c8ccd7701957$var$E(s.props.children) : s, f = $0597c8ccd7701957$var$L(n, $0597c8ccd7701957$var$g(A) ? A : [
            A
        ], u, t, i, r, o, e, f, c, a), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), _ && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else {
                for(_$H = o.length; _$H--;)$0597c8ccd7701957$var$b(o[_$H]);
                $0597c8ccd7701957$var$B(u);
            }
        } else u.__e = t.__e, u.__k = t.__k, n.then || $0597c8ccd7701957$var$B(u);
        $0597c8ccd7701957$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $0597c8ccd7701957$var$G(t.__e, u, t, i, r, o, e, c, a);
    return (s = $0597c8ccd7701957$export$41c562ebe57d11e2.diffed) && s(u), 128 & u.__u ? void 0 : f;
}
function $0597c8ccd7701957$var$B(n) {
    n && (n.__c && (n.__c.__e = !0), n.__k && n.__k.some($0597c8ccd7701957$var$B));
}
function $0597c8ccd7701957$var$D(n, u, t) {
    for(var i = 0; i < t.length; i++)$0597c8ccd7701957$var$J(t[i], t[++i], t[++i]);
    $0597c8ccd7701957$export$41c562ebe57d11e2.__c && $0597c8ccd7701957$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $0597c8ccd7701957$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $0597c8ccd7701957$var$E(n) {
    return "object" != (typeof n === "undefined" ? "undefined" : (0, $7E0eS._)(n)) || null == n || n.__b > 0 ? n : $0597c8ccd7701957$var$g(n) ? n.map($0597c8ccd7701957$var$E) : void 0 !== n.constructor ? null : $0597c8ccd7701957$var$m({}, n);
}
function $0597c8ccd7701957$var$G(u, t, i, r, o, e, f, c, a) {
    var s, h, p, v, y, w, _, m = i.props || $0597c8ccd7701957$var$d, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(s = 0; s < e.length; s++)if ((y = e[s]) && "setAttribute" in y == !!x && (x ? y.localName == x : 3 == y.nodeType)) {
            u = y, e[s] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && ($0597c8ccd7701957$export$41c562ebe57d11e2.__m && $0597c8ccd7701957$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == x) m === k || c && u.data == k || (u.data = k);
    else {
        if (e = "textarea" == x && null != k.defaultValue ? null : e && $0597c8ccd7701957$var$n.call(u.childNodes), !c && null != e) for(m = {}, s = 0; s < u.attributes.length; s++)m[(y = u.attributes[s]).name] = y.value;
        for(s in m)y = m[s], "dangerouslySetInnerHTML" == s ? p = y : "children" == s || s in k || "value" == s && "defaultValue" in k || "checked" == s && "defaultChecked" in k || $0597c8ccd7701957$var$N(u, s, null, y, o);
        for(s in k)y = k[s], "children" == s ? v = y : "dangerouslySetInnerHTML" == s ? h = y : "value" == s ? w = y : "checked" == s ? _ = y : c && "function" != typeof y || m[s] === y || $0597c8ccd7701957$var$N(u, s, y, m[s], o);
        if (h) c || p && (h.__html == p.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (p && (u.innerHTML = ""), $0597c8ccd7701957$var$L("template" == t.type ? u.content : u, $0597c8ccd7701957$var$g(v) ? v : [
            v
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $0597c8ccd7701957$var$$(i, 0), c, a), null != e) for(s = e.length; s--;)$0597c8ccd7701957$var$b(e[s]);
        c && "textarea" != x || (s = "value", "progress" == x && null == w ? u.removeAttribute("value") : null != w && (w !== u[s] || "progress" == x && !w || "option" == x && w != m[s]) && $0597c8ccd7701957$var$N(u, s, w, m[s], o), s = "checked", null != _ && _ != u[s] && $0597c8ccd7701957$var$N(u, s, _, m[s], o));
    }
    return u;
}
function $0597c8ccd7701957$var$J(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $0597c8ccd7701957$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $0597c8ccd7701957$var$K(n, u, t) {
    var i, r;
    if ($0597c8ccd7701957$export$41c562ebe57d11e2.unmount && $0597c8ccd7701957$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $0597c8ccd7701957$var$J(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $0597c8ccd7701957$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $0597c8ccd7701957$var$K(i[r], u, t || "function" != typeof n.type);
    t || $0597c8ccd7701957$var$b(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $0597c8ccd7701957$var$Q(n, l, u) {
    return this.constructor(n, u);
}
function $0597c8ccd7701957$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $0597c8ccd7701957$export$41c562ebe57d11e2.__ && $0597c8ccd7701957$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $0597c8ccd7701957$var$q(t, u = (!r && i || t).__k = $0597c8ccd7701957$export$c8a8987d4410bf2d($0597c8ccd7701957$export$ffb0004e005737fa, null, [
        u
    ]), o || $0597c8ccd7701957$var$d, $0597c8ccd7701957$var$d, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $0597c8ccd7701957$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $0597c8ccd7701957$var$D(e, u, f);
}
function $0597c8ccd7701957$export$fa8d919ba61d84db(n, l) {
    $0597c8ccd7701957$export$b3890eb0ae9dca99(n, l, $0597c8ccd7701957$export$fa8d919ba61d84db);
}
function $0597c8ccd7701957$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $0597c8ccd7701957$var$m({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $0597c8ccd7701957$var$n.call(arguments, 2) : t), $0597c8ccd7701957$var$x(l.type, f, i || l.key, r || l.ref, null);
}
function $0597c8ccd7701957$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $0597c8ccd7701957$var$A(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var _$l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), _$l && _$l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $0597c8ccd7701957$var$y++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$0597c8ccd7701957$var$n = $0597c8ccd7701957$var$w.slice, $0597c8ccd7701957$export$41c562ebe57d11e2 = {
    __e: function __e(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $0597c8ccd7701957$var$u = 0, $0597c8ccd7701957$export$a8257692ac88316c = function t(n) {
    return null != n && void 0 === n.constructor;
}, $0597c8ccd7701957$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $0597c8ccd7701957$var$m({}, this.state), "function" == typeof n && (n = n($0597c8ccd7701957$var$m({}, u), this.props)), n && $0597c8ccd7701957$var$m(u, n), null != n && this.__v && (l && this._sb.push(l), $0597c8ccd7701957$var$A(this));
}, $0597c8ccd7701957$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $0597c8ccd7701957$var$A(this));
}, $0597c8ccd7701957$export$16fa2f45be04daa8.prototype.render = $0597c8ccd7701957$export$ffb0004e005737fa, $0597c8ccd7701957$var$i = [], $0597c8ccd7701957$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $0597c8ccd7701957$var$e = function e(n, l) {
    return n.__v.__b - l.__v.__b;
}, $0597c8ccd7701957$var$H.__r = 0, $0597c8ccd7701957$var$f = Math.random().toString(8), $0597c8ccd7701957$var$c = "__d" + $0597c8ccd7701957$var$f, $0597c8ccd7701957$var$a = "__a" + $0597c8ccd7701957$var$f, $0597c8ccd7701957$var$s = /(PointerCapture)$|Capture$/i, $0597c8ccd7701957$var$h = 0, $0597c8ccd7701957$var$p = $0597c8ccd7701957$var$V(!1), $0597c8ccd7701957$var$v = $0597c8ccd7701957$var$V(!0), $0597c8ccd7701957$var$y = 0;

});

parcelRegister("lliNT", function(module, exports) {

$parcel$export(module.exports, "useState", function () { return $f89a252b45db028e$export$60241385465d0a34; });
$parcel$export(module.exports, "useReducer", function () { return $f89a252b45db028e$export$13e3392192263954; });
$parcel$export(module.exports, "useEffect", function () { return $f89a252b45db028e$export$6d9c69b0de29b591; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $f89a252b45db028e$export$e5c5a5f917a5871c; });
$parcel$export(module.exports, "useRef", function () { return $f89a252b45db028e$export$b8f5890fc79d6aca; });
$parcel$export(module.exports, "useMemo", function () { return $f89a252b45db028e$export$1538c33de8887b59; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $f89a252b45db028e$export$d5a552a76deda3c2; });
$parcel$export(module.exports, "useCallback", function () { return $f89a252b45db028e$export$35808ee640e87ca7; });
$parcel$export(module.exports, "useContext", function () { return $f89a252b45db028e$export$fae74005e78b1a27; });
$parcel$export(module.exports, "useDebugValue", function () { return $f89a252b45db028e$export$dc8fbce3eb94dc1e; });
$parcel$export(module.exports, "useErrorBoundary", function () { return $f89a252b45db028e$export$c052f6604b7d51fe; });
$parcel$export(module.exports, "useId", function () { return $f89a252b45db028e$export$f680877a34711e37; });

var $tLNoZ = parcelRequire("tLNoZ");
var $f89a252b45db028e$var$t, $f89a252b45db028e$var$r, $f89a252b45db028e$var$u, $f89a252b45db028e$var$i, $f89a252b45db028e$var$o = 0, $f89a252b45db028e$var$f = [], $f89a252b45db028e$var$c = (0, $tLNoZ.options), $f89a252b45db028e$var$e = $f89a252b45db028e$var$c.__b, $f89a252b45db028e$var$a = $f89a252b45db028e$var$c.__r, $f89a252b45db028e$var$v = $f89a252b45db028e$var$c.diffed, $f89a252b45db028e$var$l = $f89a252b45db028e$var$c.__c, $f89a252b45db028e$var$m = $f89a252b45db028e$var$c.unmount, $f89a252b45db028e$var$s = $f89a252b45db028e$var$c.__;
function $f89a252b45db028e$var$p(n, t) {
    $f89a252b45db028e$var$c.__h && $f89a252b45db028e$var$c.__h($f89a252b45db028e$var$r, n, $f89a252b45db028e$var$o || t), $f89a252b45db028e$var$o = 0;
    var u = $f89a252b45db028e$var$r.__H || ($f89a252b45db028e$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $f89a252b45db028e$export$60241385465d0a34(n) {
    return $f89a252b45db028e$var$o = 1, $f89a252b45db028e$export$13e3392192263954($f89a252b45db028e$var$D, n);
}
function $f89a252b45db028e$export$13e3392192263954(n, u, i) {
    var o = $f89a252b45db028e$var$p($f89a252b45db028e$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $f89a252b45db028e$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $f89a252b45db028e$var$r, !$f89a252b45db028e$var$r.__f)) {
        var f = function f(n, t, r) {
            if (!o.__c.__H) return !0;
            var _$u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (_$u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var _$i = o.__c.props !== n;
            return _$u.some(function(n) {
                if (n.__N) {
                    var _$t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, _$t !== n.__[0] && (_$i = !0);
                }
            }), c && c.call(this, n, t, r) || _$i;
        };
        $f89a252b45db028e$var$r.__f = !0;
        var c = $f89a252b45db028e$var$r.shouldComponentUpdate, e = $f89a252b45db028e$var$r.componentWillUpdate;
        $f89a252b45db028e$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var _$u = c;
                c = void 0, f(n, t, r), c = _$u;
            }
            e && e.call(this, n, t, r);
        }, $f89a252b45db028e$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $f89a252b45db028e$export$6d9c69b0de29b591(n, u) {
    var i = $f89a252b45db028e$var$p($f89a252b45db028e$var$t++, 3);
    !$f89a252b45db028e$var$c.__s && $f89a252b45db028e$var$C(i.__H, u) && (i.__ = n, i.u = u, $f89a252b45db028e$var$r.__H.__h.push(i));
}
function $f89a252b45db028e$export$e5c5a5f917a5871c(n, u) {
    var i = $f89a252b45db028e$var$p($f89a252b45db028e$var$t++, 4);
    !$f89a252b45db028e$var$c.__s && $f89a252b45db028e$var$C(i.__H, u) && (i.__ = n, i.u = u, $f89a252b45db028e$var$r.__h.push(i));
}
function $f89a252b45db028e$export$b8f5890fc79d6aca(n) {
    return $f89a252b45db028e$var$o = 5, $f89a252b45db028e$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $f89a252b45db028e$export$d5a552a76deda3c2(n, t, r) {
    $f89a252b45db028e$var$o = 6, $f89a252b45db028e$export$e5c5a5f917a5871c(function() {
        if ("function" == typeof n) {
            var _$r = n(t());
            return function() {
                n(null), _$r && "function" == typeof _$r && _$r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function $f89a252b45db028e$export$1538c33de8887b59(n, r) {
    var u = $f89a252b45db028e$var$p($f89a252b45db028e$var$t++, 7);
    return $f89a252b45db028e$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $f89a252b45db028e$export$35808ee640e87ca7(n, t) {
    return $f89a252b45db028e$var$o = 8, $f89a252b45db028e$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $f89a252b45db028e$export$fae74005e78b1a27(n) {
    var u = $f89a252b45db028e$var$r.context[n.__c], i = $f89a252b45db028e$var$p($f89a252b45db028e$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($f89a252b45db028e$var$r)), u.props.value) : n.__;
}
function $f89a252b45db028e$export$dc8fbce3eb94dc1e(n, t) {
    $f89a252b45db028e$var$c.useDebugValue && $f89a252b45db028e$var$c.useDebugValue(t ? t(n) : n);
}
function $f89a252b45db028e$export$c052f6604b7d51fe(n) {
    var u = $f89a252b45db028e$var$p($f89a252b45db028e$var$t++, 10), i = $f89a252b45db028e$export$60241385465d0a34();
    return u.__ = n, $f89a252b45db028e$var$r.componentDidCatch || ($f89a252b45db028e$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $f89a252b45db028e$export$f680877a34711e37() {
    var _$n = $f89a252b45db028e$var$p($f89a252b45db028e$var$t++, 11);
    if (!_$n.__) {
        for(var u = $f89a252b45db028e$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        _$n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return _$n.__;
}
function $f89a252b45db028e$var$j() {
    for(var _$n; _$n = $f89a252b45db028e$var$f.shift();){
        var t = _$n.__H;
        if (_$n.__P && t) try {
            t.__h.some($f89a252b45db028e$var$z), t.__h.some($f89a252b45db028e$var$B), t.__h = [];
        } catch (r) {
            t.__h = [], $f89a252b45db028e$var$c.__e(r, _$n.__v);
        }
    }
}
$f89a252b45db028e$var$c.__b = function(n) {
    $f89a252b45db028e$var$r = null, $f89a252b45db028e$var$e && $f89a252b45db028e$var$e(n);
}, $f89a252b45db028e$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $f89a252b45db028e$var$s && $f89a252b45db028e$var$s(n, t);
}, $f89a252b45db028e$var$c.__r = function(n) {
    $f89a252b45db028e$var$a && $f89a252b45db028e$var$a(n), $f89a252b45db028e$var$t = 0;
    var i = ($f89a252b45db028e$var$r = n.__c).__H;
    i && ($f89a252b45db028e$var$u === $f89a252b45db028e$var$r ? (i.__h = [], $f89a252b45db028e$var$r.__h = [], i.__.some(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.some($f89a252b45db028e$var$z), i.__h.some($f89a252b45db028e$var$B), i.__h = [], $f89a252b45db028e$var$t = 0)), $f89a252b45db028e$var$u = $f89a252b45db028e$var$r;
}, $f89a252b45db028e$var$c.diffed = function(n) {
    $f89a252b45db028e$var$v && $f89a252b45db028e$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $f89a252b45db028e$var$f.push(t) && $f89a252b45db028e$var$i === $f89a252b45db028e$var$c.requestAnimationFrame || (($f89a252b45db028e$var$i = $f89a252b45db028e$var$c.requestAnimationFrame) || $f89a252b45db028e$var$w)($f89a252b45db028e$var$j)), t.__H.__.some(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), $f89a252b45db028e$var$u = $f89a252b45db028e$var$r = null;
}, $f89a252b45db028e$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.some($f89a252b45db028e$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $f89a252b45db028e$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $f89a252b45db028e$var$c.__e(r, n.__v);
        }
    }), $f89a252b45db028e$var$l && $f89a252b45db028e$var$l(n, t);
}, $f89a252b45db028e$var$c.unmount = function(n) {
    $f89a252b45db028e$var$m && $f89a252b45db028e$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.some(function(n) {
        try {
            $f89a252b45db028e$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $f89a252b45db028e$var$c.__e(t, r.__v));
};
var $f89a252b45db028e$var$k = "function" == typeof requestAnimationFrame;
function $f89a252b45db028e$var$w(n) {
    var t, r = function r() {
        clearTimeout(u), $f89a252b45db028e$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 35);
    $f89a252b45db028e$var$k && (t = requestAnimationFrame(r));
}
function $f89a252b45db028e$var$z(n) {
    var t = $f89a252b45db028e$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $f89a252b45db028e$var$r = t;
}
function $f89a252b45db028e$var$B(n) {
    var t = $f89a252b45db028e$var$r;
    n.__c = n.__(), $f89a252b45db028e$var$r = t;
}
function $f89a252b45db028e$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $f89a252b45db028e$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});



parcelRegister("c5KQ9", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $024595d31d12e077$export$2b8d127b894957b9; }, function (v) { return $024595d31d12e077$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $024595d31d12e077$export$cea3a54a6425200c; }, function (v) { return $024595d31d12e077$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $024595d31d12e077$export$a7c73072b1a182ae; }, function (v) { return $024595d31d12e077$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $024595d31d12e077$export$9f27bc3417b4524d; }, function (v) { return $024595d31d12e077$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $024595d31d12e077$export$db77ccec0bb4ccac; }, function (v) { return $024595d31d12e077$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $024595d31d12e077$export$8392c0c9d3dcbd35; }, function (v) { return $024595d31d12e077$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $024595d31d12e077$export$ffb0004e005737fa; }, function (v) { return $024595d31d12e077$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $024595d31d12e077$export$b624eff549462981; }, function (v) { return $024595d31d12e077$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $024595d31d12e077$export$7897aa7841a5380c; }, function (v) { return $024595d31d12e077$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $024595d31d12e077$export$602eac185826482c; }, function (v) { return $024595d31d12e077$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $024595d31d12e077$export$e2c29f18771995cb; }, function (v) { return $024595d31d12e077$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $024595d31d12e077$export$5f8d39834fd61797; }, function (v) { return $024595d31d12e077$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $024595d31d12e077$export$74bf444e3cd11ea5; }, function (v) { return $024595d31d12e077$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $024595d31d12e077$export$92387174baf9b227; }, function (v) { return $024595d31d12e077$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $024595d31d12e077$export$ec112efeb987d9c6; }, function (v) { return $024595d31d12e077$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $024595d31d12e077$export$b706b080d889d2c9; }, function (v) { return $024595d31d12e077$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $024595d31d12e077$export$5be5a87408f70ddc; }, function (v) { return $024595d31d12e077$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $024595d31d12e077$export$45a5e7f76e0caa8d; }, function (v) { return $024595d31d12e077$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $024595d31d12e077$export$455c2e768291efa6; }, function (v) { return $024595d31d12e077$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $024595d31d12e077$export$9522e17588c12572; }, function (v) { return $024595d31d12e077$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $024595d31d12e077$export$2110ac352bb060b9; }, function (v) { return $024595d31d12e077$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $024595d31d12e077$export$56885ab8b9c456ab; }, function (v) { return $024595d31d12e077$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $024595d31d12e077$export$d927fcb6adf8f9de; }, function (v) { return $024595d31d12e077$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $024595d31d12e077$export$b82d16f27459e05a; }, function (v) { return $024595d31d12e077$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $024595d31d12e077$export$522c17b4f5e123e8; }, function (v) { return $024595d31d12e077$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $024595d31d12e077$export$1aabd8a0274ecfd6; }, function (v) { return $024595d31d12e077$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $024595d31d12e077$export$9b621391a187a31a; }, function (v) { return $024595d31d12e077$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $024595d31d12e077$export$f5bbd400c2f4426f; }, function (v) { return $024595d31d12e077$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $7E0eS = parcelRequire("7E0eS");
var $024595d31d12e077$export$2b8d127b894957b9;
var $024595d31d12e077$export$cea3a54a6425200c;
var $024595d31d12e077$export$a7c73072b1a182ae;
var $024595d31d12e077$export$9f27bc3417b4524d;
var $024595d31d12e077$export$db77ccec0bb4ccac;
var $024595d31d12e077$export$8392c0c9d3dcbd35;
var $024595d31d12e077$export$ffb0004e005737fa;
var $024595d31d12e077$export$b624eff549462981;
var $024595d31d12e077$export$7897aa7841a5380c;
var $024595d31d12e077$export$602eac185826482c;
var $024595d31d12e077$export$e2c29f18771995cb;
var $024595d31d12e077$export$5f8d39834fd61797;
var $024595d31d12e077$export$74bf444e3cd11ea5;
var $024595d31d12e077$export$92387174baf9b227;
var $024595d31d12e077$export$ec112efeb987d9c6;
var $024595d31d12e077$export$b706b080d889d2c9;
var $024595d31d12e077$export$5be5a87408f70ddc;
var $024595d31d12e077$export$45a5e7f76e0caa8d;
var $024595d31d12e077$export$455c2e768291efa6;
var $024595d31d12e077$export$9522e17588c12572;
var $024595d31d12e077$export$2110ac352bb060b9;
var $024595d31d12e077$export$56885ab8b9c456ab;
var $024595d31d12e077$export$d927fcb6adf8f9de;
var $024595d31d12e077$export$b82d16f27459e05a;
var $024595d31d12e077$export$522c17b4f5e123e8;
var $024595d31d12e077$export$1aabd8a0274ecfd6;
var $024595d31d12e077$export$9b621391a187a31a;
var $024595d31d12e077$export$f5bbd400c2f4426f;
'use strict';
var $024595d31d12e077$var$b = "function" === typeof Symbol && Symbol.for, $024595d31d12e077$var$c = $024595d31d12e077$var$b ? Symbol.for("react.element") : 60103, $024595d31d12e077$var$d = $024595d31d12e077$var$b ? Symbol.for("react.portal") : 60106, $024595d31d12e077$var$e = $024595d31d12e077$var$b ? Symbol.for("react.fragment") : 60107, $024595d31d12e077$var$f = $024595d31d12e077$var$b ? Symbol.for("react.strict_mode") : 60108, $024595d31d12e077$var$g = $024595d31d12e077$var$b ? Symbol.for("react.profiler") : 60114, $024595d31d12e077$var$h = $024595d31d12e077$var$b ? Symbol.for("react.provider") : 60109, $024595d31d12e077$var$k = $024595d31d12e077$var$b ? Symbol.for("react.context") : 60110, $024595d31d12e077$var$l = $024595d31d12e077$var$b ? Symbol.for("react.async_mode") : 60111, $024595d31d12e077$var$m = $024595d31d12e077$var$b ? Symbol.for("react.concurrent_mode") : 60111, $024595d31d12e077$var$n = $024595d31d12e077$var$b ? Symbol.for("react.forward_ref") : 60112, $024595d31d12e077$var$p = $024595d31d12e077$var$b ? Symbol.for("react.suspense") : 60113, $024595d31d12e077$var$q = $024595d31d12e077$var$b ? Symbol.for("react.suspense_list") : 60120, $024595d31d12e077$var$r = $024595d31d12e077$var$b ? Symbol.for("react.memo") : 60115, $024595d31d12e077$var$t = $024595d31d12e077$var$b ? Symbol.for("react.lazy") : 60116, $024595d31d12e077$var$v = $024595d31d12e077$var$b ? Symbol.for("react.block") : 60121, $024595d31d12e077$var$w = $024595d31d12e077$var$b ? Symbol.for("react.fundamental") : 60117, $024595d31d12e077$var$x = $024595d31d12e077$var$b ? Symbol.for("react.responder") : 60118, $024595d31d12e077$var$y = $024595d31d12e077$var$b ? Symbol.for("react.scope") : 60119;
function $024595d31d12e077$var$z(a) {
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $7E0eS._)(a)) && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $024595d31d12e077$var$c:
                switch(a = a.type, a){
                    case $024595d31d12e077$var$l:
                    case $024595d31d12e077$var$m:
                    case $024595d31d12e077$var$e:
                    case $024595d31d12e077$var$g:
                    case $024595d31d12e077$var$f:
                    case $024595d31d12e077$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $024595d31d12e077$var$k:
                            case $024595d31d12e077$var$n:
                            case $024595d31d12e077$var$t:
                            case $024595d31d12e077$var$r:
                            case $024595d31d12e077$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $024595d31d12e077$var$d:
                return u;
        }
    }
}
function $024595d31d12e077$var$A(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$m;
}
$024595d31d12e077$export$2b8d127b894957b9 = $024595d31d12e077$var$l;
$024595d31d12e077$export$cea3a54a6425200c = $024595d31d12e077$var$m;
$024595d31d12e077$export$a7c73072b1a182ae = $024595d31d12e077$var$k;
$024595d31d12e077$export$9f27bc3417b4524d = $024595d31d12e077$var$h;
$024595d31d12e077$export$db77ccec0bb4ccac = $024595d31d12e077$var$c;
$024595d31d12e077$export$8392c0c9d3dcbd35 = $024595d31d12e077$var$n;
$024595d31d12e077$export$ffb0004e005737fa = $024595d31d12e077$var$e;
$024595d31d12e077$export$b624eff549462981 = $024595d31d12e077$var$t;
$024595d31d12e077$export$7897aa7841a5380c = $024595d31d12e077$var$r;
$024595d31d12e077$export$602eac185826482c = $024595d31d12e077$var$d;
$024595d31d12e077$export$e2c29f18771995cb = $024595d31d12e077$var$g;
$024595d31d12e077$export$5f8d39834fd61797 = $024595d31d12e077$var$f;
$024595d31d12e077$export$74bf444e3cd11ea5 = $024595d31d12e077$var$p;
$024595d31d12e077$export$92387174baf9b227 = function(a) {
    return $024595d31d12e077$var$A(a) || $024595d31d12e077$var$z(a) === $024595d31d12e077$var$l;
};
$024595d31d12e077$export$ec112efeb987d9c6 = $024595d31d12e077$var$A;
$024595d31d12e077$export$b706b080d889d2c9 = function(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$k;
};
$024595d31d12e077$export$5be5a87408f70ddc = function(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$h;
};
$024595d31d12e077$export$45a5e7f76e0caa8d = function(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $7E0eS._)(a)) && null !== a && a.$$typeof === $024595d31d12e077$var$c;
};
$024595d31d12e077$export$455c2e768291efa6 = function(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$n;
};
$024595d31d12e077$export$9522e17588c12572 = function(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$e;
};
$024595d31d12e077$export$2110ac352bb060b9 = function(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$t;
};
$024595d31d12e077$export$56885ab8b9c456ab = function(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$r;
};
$024595d31d12e077$export$d927fcb6adf8f9de = function(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$d;
};
$024595d31d12e077$export$b82d16f27459e05a = function(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$g;
};
$024595d31d12e077$export$522c17b4f5e123e8 = function(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$f;
};
$024595d31d12e077$export$1aabd8a0274ecfd6 = function(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$p;
};
$024595d31d12e077$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $024595d31d12e077$var$e || a === $024595d31d12e077$var$m || a === $024595d31d12e077$var$g || a === $024595d31d12e077$var$f || a === $024595d31d12e077$var$p || a === $024595d31d12e077$var$q || "object" === (typeof a === "undefined" ? "undefined" : (0, $7E0eS._)(a)) && null !== a && (a.$$typeof === $024595d31d12e077$var$t || a.$$typeof === $024595d31d12e077$var$r || a.$$typeof === $024595d31d12e077$var$h || a.$$typeof === $024595d31d12e077$var$k || a.$$typeof === $024595d31d12e077$var$n || a.$$typeof === $024595d31d12e077$var$w || a.$$typeof === $024595d31d12e077$var$x || a.$$typeof === $024595d31d12e077$var$y || a.$$typeof === $024595d31d12e077$var$v);
};
$024595d31d12e077$export$f5bbd400c2f4426f = $024595d31d12e077$var$z;

});

parcelRegister("2ZsbG", function(module, exports) {
Prism.languages.javascript = Prism.languages.extend('clike', {
    'class-name': [
        Prism.languages.clike['class-name'],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    'keyword': [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    'number': {
        pattern: RegExp(/(^|[^\w$])/.source + '(?:' + // constant
        (/NaN|Infinity/.source + '|' + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
        /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
        lookbehind: true
    },
    'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
Prism.languages.insertBefore('javascript', 'keyword', {
    'regex': {
        pattern: RegExp(// lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + '(?:' + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + '|' + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ')' + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            'regex-source': {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: 'language-regex',
                inside: Prism.languages.regex
            },
            'regex-delimiter': /^\/|\/$/,
            'regex-flags': /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    'function-variable': {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: 'function'
    },
    'parameter': [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: Prism.languages.javascript
        }
    ],
    'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
Prism.languages.insertBefore('javascript', 'string', {
    'hashbang': {
        pattern: /^#!.*/,
        greedy: true,
        alias: 'comment'
    },
    'template-string': {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            'template-punctuation': {
                pattern: /^`|`$/,
                alias: 'string'
            },
            'interpolation': {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    'interpolation-punctuation': {
                        pattern: /^\$\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: Prism.languages.javascript
                }
            },
            'string': /[\s\S]+/
        }
    },
    'string-property': {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: 'property'
    }
});
Prism.languages.insertBefore('javascript', 'operator', {
    'literal-property': {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: 'property'
    }
});
if (Prism.languages.markup) {
    Prism.languages.markup.tag.addInlined('script', 'javascript');
    // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
}
Prism.languages.js = Prism.languages.javascript;

});

parcelRegister("knnJU", function(module, exports) {
(function(Prism1) {
    var javascript = Prism1.util.clone(Prism1.languages.javascript);
    var space = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source;
    var braces = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source;
    var spread = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
    /**
	 * @param {string} source
	 * @param {string} [flags]
	 */ function re(source, flags) {
        source = source.replace(/<S>/g, function() {
            return space;
        }).replace(/<BRACES>/g, function() {
            return braces;
        }).replace(/<SPREAD>/g, function() {
            return spread;
        });
        return RegExp(source, flags);
    }
    spread = re(spread).source;
    Prism1.languages.jsx = Prism1.languages.extend('markup', javascript);
    Prism1.languages.jsx.tag.pattern = re(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source);
    Prism1.languages.jsx.tag.inside['tag'].pattern = /^<\/?[^\s>\/]*/;
    Prism1.languages.jsx.tag.inside['attr-value'].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/;
    Prism1.languages.jsx.tag.inside['tag'].inside['class-name'] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/;
    Prism1.languages.jsx.tag.inside['comment'] = javascript['comment'];
    Prism1.languages.insertBefore('inside', 'attr-name', {
        'spread': {
            pattern: re(/<SPREAD>/.source),
            inside: Prism1.languages.jsx
        }
    }, Prism1.languages.jsx.tag);
    Prism1.languages.insertBefore('inside', 'special-attr', {
        'script': {
            // Allow for two levels of nesting
            pattern: re(/=<BRACES>/.source),
            alias: 'language-javascript',
            inside: {
                'script-punctuation': {
                    pattern: /^=(?=\{)/,
                    alias: 'punctuation'
                },
                rest: Prism1.languages.jsx
            }
        }
    }, Prism1.languages.jsx.tag);
    // The following will handle plain text inside tags
    var stringifyToken = function stringifyToken1(token) {
        if (!token) return '';
        if (typeof token === 'string') return token;
        if (typeof token.content === 'string') return token.content;
        return token.content.map(stringifyToken).join('');
    };
    var walkTokens = function walkTokens1(tokens) {
        var openedTags = [];
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            var notTagNorBrace = false;
            if (typeof token !== 'string') {
                if (token.type === 'tag' && token.content[0] && token.content[0].type === 'tag') {
                    // We found a tag, now find its kind
                    if (token.content[0].content[0].content === '</') // Closing tag
                    {
                        if (openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1])) // Pop matching opening tag
                        openedTags.pop();
                    } else {
                        if (token.content[token.content.length - 1].content === '/>') ;
                        else // Opening tag
                        openedTags.push({
                            tagName: stringifyToken(token.content[0].content[1]),
                            openedBraces: 0
                        });
                    }
                } else if (openedTags.length > 0 && token.type === 'punctuation' && token.content === '{') // Here we might have entered a JSX context inside a tag
                openedTags[openedTags.length - 1].openedBraces++;
                else if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === 'punctuation' && token.content === '}') // Here we might have left a JSX context inside a tag
                openedTags[openedTags.length - 1].openedBraces--;
                else notTagNorBrace = true;
            }
            if (notTagNorBrace || typeof token === 'string') {
                if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
                    // Here we are inside a tag, and not inside a JSX context.
                    // That's plain text: drop any tokens matched.
                    var plainText = stringifyToken(token);
                    // And merge text with adjacent text
                    if (i < tokens.length - 1 && (typeof tokens[i + 1] === 'string' || tokens[i + 1].type === 'plain-text')) {
                        plainText += stringifyToken(tokens[i + 1]);
                        tokens.splice(i + 1, 1);
                    }
                    if (i > 0 && (typeof tokens[i - 1] === 'string' || tokens[i - 1].type === 'plain-text')) {
                        plainText = stringifyToken(tokens[i - 1]) + plainText;
                        tokens.splice(i - 1, 1);
                        i--;
                    }
                    tokens[i] = new Prism1.Token('plain-text', plainText, null, plainText);
                }
            }
            if (token.content && typeof token.content !== 'string') walkTokens(token.content);
        }
    };
    Prism1.hooks.add('after-tokenize', function(env) {
        if (env.language !== 'jsx' && env.language !== 'tsx') return;
        walkTokens(env.tokens);
    });
})(Prism);

});

parcelRegister("fHM7w", function(module, exports) {
(function(Prism1) {
    var typescript = Prism1.util.clone(Prism1.languages.typescript);
    Prism1.languages.tsx = Prism1.languages.extend('jsx', typescript);
    // doesn't work with TS because TS is too complex
    delete Prism1.languages.tsx['parameter'];
    delete Prism1.languages.tsx['literal-property'];
    // This will prevent collisions between TSX tags and TS generic types.
    // Idea by https://github.com/karlhorky
    // Discussion: https://github.com/PrismJS/prism/issues/2594#issuecomment-710666928
    var tag = Prism1.languages.tsx.tag;
    tag.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + '(?:' + tag.pattern.source + ')', tag.pattern.flags);
    tag.lookbehind = true;
})(Prism);

});

parcelRegister("3RSag", function(module, exports) {
(function(Prism1) {
    Prism1.languages.typescript = Prism1.languages.extend('javascript', {
        'class-name': {
            pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
            lookbehind: true,
            greedy: true,
            inside: null // see below
        },
        'builtin': /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
    });
    // The keywords TypeScript adds to JavaScript
    Prism1.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, // keywords that have to be followed by an identifier
    /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, // This is for `import type *, {}`
    /\btype\b(?=\s*(?:[\{*]|$))/);
    // doesn't work with TS because TS is too complex
    delete Prism1.languages.typescript['parameter'];
    delete Prism1.languages.typescript['literal-property'];
    // a version of typescript specifically for highlighting types
    var typeInside = Prism1.languages.extend('typescript', {});
    delete typeInside['class-name'];
    Prism1.languages.typescript['class-name'].inside = typeInside;
    Prism1.languages.insertBefore('typescript', 'function', {
        'decorator': {
            pattern: /@[$\w\xA0-\uFFFF]+/,
            inside: {
                'at': {
                    pattern: /^@/,
                    alias: 'operator'
                },
                'function': /^[\s\S]+/
            }
        },
        'generic-function': {
            // e.g. foo<T extends "bar" | "baz">( ...
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
            greedy: true,
            inside: {
                'function': /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
                'generic': {
                    pattern: /<[\s\S]+/,
                    alias: 'class-name',
                    inside: typeInside
                }
            }
        }
    });
    Prism1.languages.ts = Prism1.languages.typescript;
})(Prism);

});

parcelRegister("fmjrn", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $b2e7fd98a98d1fda$export$306c0aa65ff9ec16; }, function (v) { return $b2e7fd98a98d1fda$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b2e7fd98a98d1fda$export$306c0aa65ff9ec16;
"use strict";
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
var $1aLYV = parcelRequire("1aLYV");
function $b2e7fd98a98d1fda$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $b2e7fd98a98d1fda$var$objectIs = "function" === typeof Object.is ? Object.is : $b2e7fd98a98d1fda$var$is, $b2e7fd98a98d1fda$var$useState = $lliNT.useState, $b2e7fd98a98d1fda$var$useEffect = $lliNT.useEffect, $b2e7fd98a98d1fda$var$useLayoutEffect = $lliNT.useLayoutEffect, $b2e7fd98a98d1fda$var$useDebugValue = $lliNT.useDebugValue;
function $b2e7fd98a98d1fda$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $b2e7fd98a98d1fda$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $b2e7fd98a98d1fda$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $b2e7fd98a98d1fda$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $b2e7fd98a98d1fda$var$useEffect(function() {
        $b2e7fd98a98d1fda$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $b2e7fd98a98d1fda$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $b2e7fd98a98d1fda$var$useDebugValue(value);
    return value;
}
function $b2e7fd98a98d1fda$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$b2e7fd98a98d1fda$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $b2e7fd98a98d1fda$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $b2e7fd98a98d1fda$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $b2e7fd98a98d1fda$var$useSyncExternalStore$1 : $b2e7fd98a98d1fda$var$useSyncExternalStore$2;
$b2e7fd98a98d1fda$export$306c0aa65ff9ec16 = void 0 !== $1aLYV.useSyncExternalStore ? $1aLYV.useSyncExternalStore : $b2e7fd98a98d1fda$var$shim;

});

parcelRegister("cInIr", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ 
var $7E0eS = parcelRequire("7E0eS");
var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = (typeof $parcel$global === "undefined" ? "undefined" : (0, $7E0eS._)($parcel$global)) == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = (typeof self === "undefined" ? "undefined" : (0, $7E0eS._)(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function getTag(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value);
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */ function isEqualWith(value, other, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    var result = customizer ? customizer(value, other) : undefined;
    return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value);
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = isEqualWith;

});

parcelRegister("hVyKU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $d0d2b840e6276801$export$2e2bcd8739ae039; });

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $13u2V = parcelRequire("13u2V");

var $1aLYV = parcelRequire("1aLYV");

var $7G4Sm = parcelRequire("7G4Sm");

var $5aDIn = parcelRequire("5aDIn");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $d0d2b840e6276801$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d0d2b840e6276801$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d0d2b840e6276801$var$ReactEditorJS(_a) {
    var factory = _a.factory, holder = _a.holder, defaultValue = _a.defaultValue, children = _a.children, value = _a.value, onInitialize = _a.onInitialize, restProps = $d0d2b840e6276801$var$__rest(_a, [
        "factory",
        "holder",
        "defaultValue",
        "children",
        "value",
        "onInitialize"
    ]);
    var memoizedHolder = (0, $1aLYV.default).useRef(holder !== null && holder !== void 0 ? holder : "react-editor-js-".concat(Date.now().toString(16)));
    var editorJS = (0, $1aLYV.default).useRef(null);
    (0, $1aLYV.default).useEffect(function() {
        editorJS.current = factory(Object.assign(Object.assign({
            holder: memoizedHolder.current
        }, defaultValue && {
            data: defaultValue
        }), restProps));
        onInitialize === null || onInitialize === void 0 || onInitialize(editorJS.current);
        return function() {
            var _$_a;
            (_$_a = editorJS.current) === null || _$_a === void 0 || _$_a.destroy();
        };
    }, []);
    (0, $1aLYV.default).useEffect(function() {
        var _$_a;
        if (value) (_$_a = editorJS.current) === null || _$_a === void 0 || _$_a.render(value);
    }, [
        value
    ]);
    return children || (0, $1aLYV.default).createElement("div", {
        id: memoizedHolder.current
    });
}
var $d0d2b840e6276801$var$ClientEditorCore = /*#__PURE__*/ function() {
    "use strict";
    function ClientEditorCore(_a) {
        (0, $173N4._)(this, ClientEditorCore);
        var tools = _a.tools, config = $d0d2b840e6276801$var$__rest(_a, [
            "tools"
        ]);
        var extendTools = Object.assign({
            // default tools
            paragraph: {
                class: (0, $5aDIn.default),
                inlineToolbar: true
            }
        }, tools);
        this._editorJS = new (0, $7G4Sm.default)(Object.assign({
            tools: extendTools
        }, config));
    }
    (0, $cFHGC._)(ClientEditorCore, [
        {
            key: "dangerouslyLowLevelInstance",
            get: function get() {
                return this._editorJS;
            }
        },
        {
            key: "clear",
            value: function clear() {
                return $d0d2b840e6276801$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._editorJS.clear()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "save",
            value: function save() {
                return $d0d2b840e6276801$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $13u2V._)(this, function(_state) {
                        return [
                            2,
                            this._editorJS.save()
                        ];
                    });
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                return $d0d2b840e6276801$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._editorJS.isReady
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._editorJS.destroy()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "render",
            value: function render(data) {
                return $d0d2b840e6276801$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._editorJS.render(data)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return ClientEditorCore;
}();
function $d0d2b840e6276801$export$2e2bcd8739ae039(props) {
    var factory = (0, $1aLYV.default).useCallback(function(config) {
        return new $d0d2b840e6276801$var$ClientEditorCore(config);
    }, []);
    return (0, $1aLYV.default).createElement($d0d2b840e6276801$var$ReactEditorJS, Object.assign({
        factory: factory
    }, props));
}

});
parcelRegister("7G4Sm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bdbe1ebf6713620$export$2e2bcd8739ae039; });

var $gXzGB = parcelRequire("gXzGB");

var $3gP77 = parcelRequire("3gP77");

var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7Pjls = parcelRequire("7Pjls");

var $dWsrg = parcelRequire("dWsrg");

var $kg0zo = parcelRequire("kg0zo");

var $hdIku = parcelRequire("hdIku");

var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");

var $1SdK7 = parcelRequire("1SdK7");

var $13u2V = parcelRequire("13u2V");

var $Csf8W = parcelRequire("Csf8W");
(function() {
    "use strict";
    try {
        if ((typeof document === "undefined" ? "undefined" : (0, $7E0eS._)(document)) < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-hint--align-start{text-align:left}.ce-hint--align-center{text-align:center}.ce-hint__description{opacity:.6;margin-top:3px}")), document.head.appendChild(e);
        }
    } catch (t1) {
        console.error("vite-plugin-css-injected-by-js", t1);
    }
})();
var $5bdbe1ebf6713620$var$Ce = (typeof globalThis === "undefined" ? "undefined" : (0, $7E0eS._)(globalThis)) < "u" ? globalThis : (typeof window === "undefined" ? "undefined" : (0, $7E0eS._)(window)) < "u" ? window : (typeof $parcel$global === "undefined" ? "undefined" : (0, $7E0eS._)($parcel$global)) < "u" ? $parcel$global : (typeof self === "undefined" ? "undefined" : (0, $7E0eS._)(self)) < "u" ? self : {};
function $5bdbe1ebf6713620$var$Ke(n) {
    return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function $5bdbe1ebf6713620$var$Xn(n) {
    if (n.__esModule) return n;
    var e = n.default;
    if (typeof e == "function") {
        var t1 = function o() {
            return this instanceof o ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
        };
        t1.prototype = e.prototype;
    } else t1 = {};
    return Object.defineProperty(t1, "__esModule", {
        value: !0
    }), Object.keys(n).forEach(function(o) {
        var i = Object.getOwnPropertyDescriptor(n, o);
        Object.defineProperty(t1, o, i.get ? i : {
            enumerable: !0,
            get: function get() {
                return n[o];
            }
        });
    }), t1;
}
function $5bdbe1ebf6713620$var$ot() {}
Object.assign($5bdbe1ebf6713620$var$ot, {
    default: $5bdbe1ebf6713620$var$ot,
    register: $5bdbe1ebf6713620$var$ot,
    revert: function revert() {},
    __esModule: !0
});
Element.prototype.matches || (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function(n) {
    var e = (this.document || this.ownerDocument).querySelectorAll(n);
    var t1 = e.length;
    for(; --t1 >= 0 && e.item(t1) !== this;);
    return t1 > -1;
});
Element.prototype.closest || (Element.prototype.closest = function(n) {
    var e = this;
    if (!document.documentElement.contains(e)) return null;
    do {
        if (e.matches(n)) return e;
        e = e.parentElement || e.parentNode;
    }while (e !== null);
    return null;
});
Element.prototype.prepend || (Element.prototype.prepend = function(e) {
    var t1 = document.createDocumentFragment();
    Array.isArray(e) || (e = [
        e
    ]), e.forEach(function(o) {
        var i = o instanceof Node;
        t1.appendChild(i ? o : document.createTextNode(o));
    }), this.insertBefore(t1, this.firstChild);
});
Element.prototype.scrollIntoViewIfNeeded || (Element.prototype.scrollIntoViewIfNeeded = function(n) {
    n = arguments.length === 0 ? !0 : !!n;
    var e = this.parentNode, t1 = window.getComputedStyle(e, null), o = parseInt(t1.getPropertyValue("border-top-width")), i = parseInt(t1.getPropertyValue("border-left-width")), s = this.offsetTop - e.offsetTop < e.scrollTop, r = this.offsetTop - e.offsetTop + this.clientHeight - o > e.scrollTop + e.clientHeight, a = this.offsetLeft - e.offsetLeft < e.scrollLeft, l = this.offsetLeft - e.offsetLeft + this.clientWidth - i > e.scrollLeft + e.clientWidth, c = s && !r;
    (s || r) && n && (e.scrollTop = this.offsetTop - e.offsetTop - e.clientHeight / 2 - o + this.clientHeight / 2), (a || l) && n && (e.scrollLeft = this.offsetLeft - e.offsetLeft - e.clientWidth / 2 - i + this.clientWidth / 2), (s || r || a || l) && !n && this.scrollIntoView(c);
});
window.requestIdleCallback = window.requestIdleCallback || function(n) {
    var e = Date.now();
    return setTimeout(function() {
        n({
            didTimeout: !1,
            timeRemaining: function timeRemaining() {
                return Math.max(0, 50 - (Date.now() - e));
            }
        });
    }, 1);
};
window.cancelIdleCallback = window.cancelIdleCallback || function(n) {
    clearTimeout(n);
};
var $5bdbe1ebf6713620$var$Vn = function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    return crypto.getRandomValues(new Uint8Array(n)).reduce(function(e, t1) {
        return t1 &= 63, t1 < 36 ? e += t1.toString(36) : t1 < 62 ? e += (t1 - 26).toString(36).toUpperCase() : t1 > 62 ? e += "-" : e += "_", e;
    }, "");
};
var $5bdbe1ebf6713620$var$Lo = /* @__PURE__ */ function(n) {
    return n.VERBOSE = "VERBOSE", n.INFO = "INFO", n.WARN = "WARN", n.ERROR = "ERROR", n;
}($5bdbe1ebf6713620$var$Lo || {});
var $5bdbe1ebf6713620$var$y = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    DELETE: 46,
    META: 91,
    SLASH: 191
}, $5bdbe1ebf6713620$var$qn = {
    LEFT: 0,
    WHEEL: 1,
    RIGHT: 2,
    BACKWARD: 3,
    FORWARD: 4
};
function $5bdbe1ebf6713620$var$Ie(n, e) {
    var t1 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "log", o = arguments.length > 3 ? arguments[3] : void 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "color: inherit";
    if (!("console" in window) || !window.console[t1]) return;
    var s = [
        "info",
        "log",
        "warn",
        "error"
    ].includes(t1), r = [];
    switch($5bdbe1ebf6713620$var$Ie.logLevel){
        case "ERROR":
            if (t1 !== "error") return;
            break;
        case "WARN":
            if (![
                "error",
                "warn"
            ].includes(t1)) return;
            break;
        case "INFO":
            if (!s || n) return;
            break;
    }
    o && r.push(o);
    var a = "Editor.js 2.31.6", l = "line-height: 1em;\n            color: #006FEA;\n            display: inline-block;\n            font-size: 11px;\n            line-height: 1em;\n            background-color: #fff;\n            padding: 4px 9px;\n            border-radius: 30px;\n            border: 1px solid rgba(56, 138, 229, 0.16);\n            margin: 4px 5px 4px 0;";
    n && (s ? (r.unshift(l, i), e = "%c".concat(a, "%c ").concat(e)) : e = "( ".concat(a, " )").concat(e));
    try {
        var _console, _console1;
        s ? o ? (_console = console)[t1].apply(_console, [
            "".concat(e, " %o")
        ].concat((0, $aUGqu._)(r))) : (_console1 = console)[t1].apply(_console1, [
            e
        ].concat((0, $aUGqu._)(r))) : console[t1](e);
    } catch (e) {}
}
$5bdbe1ebf6713620$var$Ie.logLevel = "VERBOSE";
function $5bdbe1ebf6713620$var$Zn(n) {
    $5bdbe1ebf6713620$var$Ie.logLevel = n;
}
var $5bdbe1ebf6713620$var$S = $5bdbe1ebf6713620$var$Ie.bind(window, !1), $5bdbe1ebf6713620$var$X = $5bdbe1ebf6713620$var$Ie.bind(window, !0);
function $5bdbe1ebf6713620$var$le(n) {
    return Object.prototype.toString.call(n).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $5bdbe1ebf6713620$var$A(n) {
    return $5bdbe1ebf6713620$var$le(n) === "function" || $5bdbe1ebf6713620$var$le(n) === "asyncfunction";
}
function $5bdbe1ebf6713620$var$D(n) {
    return $5bdbe1ebf6713620$var$le(n) === "object";
}
function $5bdbe1ebf6713620$var$te(n) {
    return $5bdbe1ebf6713620$var$le(n) === "string";
}
function $5bdbe1ebf6713620$var$Gn(n) {
    return $5bdbe1ebf6713620$var$le(n) === "boolean";
}
function $5bdbe1ebf6713620$var$yo(n) {
    return $5bdbe1ebf6713620$var$le(n) === "number";
}
function $5bdbe1ebf6713620$var$wo(n) {
    return $5bdbe1ebf6713620$var$le(n) === "undefined";
}
function $5bdbe1ebf6713620$var$V(n) {
    return n ? Object.keys(n).length === 0 && n.constructor === Object : !0;
}
function $5bdbe1ebf6713620$var$Po(n) {
    return n > 47 && n < 58 || // number keys
    n === 32 || n === 13 || // Space bar & return key(s)
    n === 229 || // processing key input for certain languages — Chinese, Japanese, etc.
    n > 64 && n < 91 || // letter keys
    n > 95 && n < 112 || // Numpad keys
    n > 185 && n < 193 || // ;=,-./` (in order)
    n > 218 && n < 223;
}
function $5bdbe1ebf6713620$var$Qn(n) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {}, t1 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {};
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        function o(i, s, r) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var e;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                i.function(i.data)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                s($5bdbe1ebf6713620$var$wo(i.data) ? {} : i.data)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            r($5bdbe1ebf6713620$var$wo(i.data) ? {} : i.data);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        return (0, $13u2V._)(this, function(_state) {
            return [
                2,
                n.reduce(function(i, s) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        i
                                    ];
                                case 1:
                                    return [
                                        2,
                                        (_state.sent(), o(s, e, t1))
                                    ];
                            }
                        });
                    })();
                }, Promise.resolve())
            ];
        });
    })();
}
function $5bdbe1ebf6713620$var$No(n) {
    return Array.prototype.slice.call(n);
}
function $5bdbe1ebf6713620$var$Fe(n, e) {
    return function() {
        var t1 = this, o = arguments;
        window.setTimeout(function() {
            return n.apply(t1, o);
        }, e);
    };
}
function $5bdbe1ebf6713620$var$Jn(n) {
    return n.name.split(".").pop();
}
function $5bdbe1ebf6713620$var$ei(n) {
    return /^[-\w]+\/([-+\w]+|\*)$/.test(n);
}
function $5bdbe1ebf6713620$var$Eo(n, e, t1) {
    var _this = this;
    var o;
    return function() {
        for(var _len = arguments.length, i = new Array(_len), _key = 0; _key < _len; _key++){
            i[_key] = arguments[_key];
        }
        var s = _this, r = function() {
            o = null, t1 || n.apply(s, i);
        }, a = t1 && !o;
        window.clearTimeout(o), o = window.setTimeout(r, e), a && n.apply(s, i);
    };
}
function $5bdbe1ebf6713620$var$dt(n, e, t1) {
    var o, i, s, r = null, a = 0;
    t1 || (t1 = {});
    var l = function l() {
        a = t1.leading === !1 ? 0 : Date.now(), r = null, s = n.apply(o, i), r || (o = i = null);
    };
    return function() {
        var c = Date.now();
        !a && t1.leading === !1 && (a = c);
        var d = e - (c - a);
        return o = this, i = arguments, d <= 0 || d > e ? (r && (clearTimeout(r), r = null), a = c, s = n.apply(o, i), r || (o = i = null)) : !r && t1.trailing !== !1 && (r = setTimeout(l, d)), s;
    };
}
function $5bdbe1ebf6713620$var$ti() {
    var n = {
        win: !1,
        mac: !1,
        x11: !1,
        linux: !1
    }, e = Object.keys(n).find(function(t1) {
        return window.navigator.appVersion.toLowerCase().indexOf(t1) !== -1;
    });
    return e && (n[e] = !0), n;
}
function $5bdbe1ebf6713620$var$je(n) {
    return n[0].toUpperCase() + n.slice(1);
}
function $5bdbe1ebf6713620$var$ut(n) {
    for(var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        e[_key - 1] = arguments[_key];
    }
    if (!e.length) return n;
    var t1 = e.shift();
    if ($5bdbe1ebf6713620$var$D(n) && $5bdbe1ebf6713620$var$D(t1)) for(var o in t1)$5bdbe1ebf6713620$var$D(t1[o]) ? (n[o] || Object.assign(n, (0, $7Pjls._)({}, o, {})), $5bdbe1ebf6713620$var$ut(n[o], t1[o])) : Object.assign(n, (0, $7Pjls._)({}, o, t1[o]));
    return $5bdbe1ebf6713620$var$ut.apply(void 0, [
        n
    ].concat((0, $aUGqu._)(e)));
}
function $5bdbe1ebf6713620$var$vt(n) {
    var e = $5bdbe1ebf6713620$var$ti();
    return n = n.replace(/shift/gi, "\u21E7").replace(/backspace/gi, "\u232B").replace(/enter/gi, "\u23CE").replace(/up/gi, "\u2191").replace(/left/gi, "\u2192").replace(/down/gi, "\u2193").replace(/right/gi, "\u2190").replace(/escape/gi, "\u238B").replace(/insert/gi, "Ins").replace(/delete/gi, "\u2421").replace(/\+/gi, " + "), e.mac ? n = n.replace(/ctrl|cmd/gi, "\u2318").replace(/alt/gi, "\u2325") : n = n.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), n;
}
function $5bdbe1ebf6713620$var$oi(n) {
    try {
        return new URL(n).href;
    } catch (e) {}
    return n.substring(0, 2) === "//" ? window.location.protocol + n : window.location.origin + n;
}
function $5bdbe1ebf6713620$var$ni() {
    return $5bdbe1ebf6713620$var$Vn(10);
}
function $5bdbe1ebf6713620$var$ii(n) {
    window.open(n, "_blank");
}
function $5bdbe1ebf6713620$var$si() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return "".concat(n).concat(Math.floor(Math.random() * 1e8).toString(16));
}
function $5bdbe1ebf6713620$var$ht(n, e, t1) {
    var o = "\xab".concat(e, "\xbb is deprecated and will be removed in the next major release. Please use the \xab").concat(t1, "\xbb instead.");
    n && $5bdbe1ebf6713620$var$X(o, "warn");
}
function $5bdbe1ebf6713620$var$me(n, e, t1) {
    var o = t1.value ? "value" : "get", i = t1[o], s = "#".concat(e, "Cache");
    if (t1[o] = function() {
        for(var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++){
            r[_key] = arguments[_key];
        }
        var _i;
        return this[s] === void 0 && (this[s] = (_i = i).apply.apply(_i, [
            this
        ].concat((0, $aUGqu._)(r)))), this[s];
    }, o === "get" && t1.set) {
        var r = t1.set;
        t1.set = function(a) {
            delete n[s], r.apply(this, a);
        };
    }
    return t1;
}
var $5bdbe1ebf6713620$var$Ro = 650;
function $5bdbe1ebf6713620$var$be() {
    return window.matchMedia("(max-width: ".concat($5bdbe1ebf6713620$var$Ro, "px)")).matches;
}
var $5bdbe1ebf6713620$var$pt = (typeof window === "undefined" ? "undefined" : (0, $7E0eS._)(window)) < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
function $5bdbe1ebf6713620$var$ri(n, e) {
    var t1 = Array.isArray(n) || $5bdbe1ebf6713620$var$D(n), o = Array.isArray(e) || $5bdbe1ebf6713620$var$D(e);
    return t1 || o ? JSON.stringify(n) === JSON.stringify(e) : n === e;
}
var $5bdbe1ebf6713620$var$u = /*#__PURE__*/ function() {
    "use strict";
    function u() {
        (0, $173N4._)(this, u);
    }
    (0, $cFHGC._)(u, null, [
        {
            key: "isSingleTag",
            value: /**
   * Check if passed tag has no closed tag
   *
   * @param {HTMLElement} tag - element to check
   * @returns {boolean}
   */ function isSingleTag(e) {
                return e.tagName && [
                    "AREA",
                    "BASE",
                    "BR",
                    "COL",
                    "COMMAND",
                    "EMBED",
                    "HR",
                    "IMG",
                    "INPUT",
                    "KEYGEN",
                    "LINK",
                    "META",
                    "PARAM",
                    "SOURCE",
                    "TRACK",
                    "WBR"
                ].includes(e.tagName);
            }
        },
        {
            key: "isLineBreakTag",
            value: /**
   * Check if element is BR or WBR
   *
   * @param {HTMLElement} element - element to check
   * @returns {boolean}
   */ function isLineBreakTag(e) {
                return e && e.tagName && [
                    "BR",
                    "WBR"
                ].includes(e.tagName);
            }
        },
        {
            key: "make",
            value: /**
   * Helper for making Elements with class name and attributes
   *
   * @param  {string} tagName - new Element tag name
   * @param  {string[]|string} [classNames] - list or name of CSS class name(s)
   * @param  {object} [attributes] - any attributes
   * @returns {HTMLElement}
   */ function make(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var i = document.createElement(e);
                if (Array.isArray(t1)) {
                    var _i_classList;
                    var s = t1.filter(function(r) {
                        return r !== void 0;
                    });
                    (_i_classList = i.classList).add.apply(_i_classList, (0, $aUGqu._)(s));
                } else t1 && i.classList.add(t1);
                for(var s1 in o)Object.prototype.hasOwnProperty.call(o, s1) && (i[s1] = o[s1]);
                return i;
            }
        },
        {
            key: "text",
            value: /**
   * Creates Text Node with the passed content
   *
   * @param {string} content - text content
   * @returns {Text}
   */ function text(e) {
                return document.createTextNode(e);
            }
        },
        {
            key: "append",
            value: /**
   * Append one or several elements to the parent
   *
   * @param  {Element|DocumentFragment} parent - where to append
   * @param  {Element|Element[]|DocumentFragment|Text|Text[]} elements - element or elements list
   */ function append(e, t1) {
                Array.isArray(t1) ? t1.forEach(function(o) {
                    return e.appendChild(o);
                }) : e.appendChild(t1);
            }
        },
        {
            key: "prepend",
            value: /**
   * Append element or a couple to the beginning of the parent elements
   *
   * @param {Element} parent - where to append
   * @param {Element|Element[]} elements - element or elements list
   */ function prepend(e, t1) {
                Array.isArray(t1) ? (t1 = t1.reverse(), t1.forEach(function(o) {
                    return e.prepend(o);
                })) : e.prepend(t1);
            }
        },
        {
            key: "swap",
            value: /**
   * Swap two elements in parent
   *
   * @param {HTMLElement} el1 - from
   * @param {HTMLElement} el2 - to
   * @deprecated
   */ function swap(e, t1) {
                var o = document.createElement("div"), i = e.parentNode;
                i.insertBefore(o, e), i.insertBefore(e, t1), i.insertBefore(t1, o), i.removeChild(o);
            }
        },
        {
            key: "find",
            value: /**
   * Selector Decorator
   *
   * Returns first match
   *
   * @param {Element} el - element we searching inside. Default - DOM Document
   * @param {string} selector - searching string
   * @returns {Element}
   */ function find() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document, t1 = arguments.length > 1 ? arguments[1] : void 0;
                return e.querySelector(t1);
            }
        },
        {
            key: "get",
            value: /**
   * Get Element by Id
   *
   * @param {string} id - id to find
   * @returns {HTMLElement | null}
   */ function get(e) {
                return document.getElementById(e);
            }
        },
        {
            key: "findAll",
            value: /**
   * Selector Decorator.
   *
   * Returns all matches
   *
   * @param {Element|Document} el - element we searching inside. Default - DOM Document
   * @param {string} selector - searching string
   * @returns {NodeList}
   */ function findAll() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document, t1 = arguments.length > 1 ? arguments[1] : void 0;
                return e.querySelectorAll(t1);
            }
        },
        {
            key: "allInputsSelector",
            get: /**
   * Returns CSS selector for all text inputs
   */ function get() {
                return "[contenteditable=true], textarea, input:not([type]), " + [
                    "text",
                    "password",
                    "email",
                    "number",
                    "search",
                    "tel",
                    "url"
                ].map(function(t1) {
                    return 'input[type="'.concat(t1, '"]');
                }).join(", ");
            }
        },
        {
            key: "findAllInputs",
            value: /**
   * Find all contenteditable, textarea and editable input elements passed holder contains
   *
   * @param holder - element where to find inputs
   */ function findAllInputs(e) {
                return $5bdbe1ebf6713620$var$No(e.querySelectorAll(u.allInputsSelector)).reduce(function(t1, o) {
                    return u.isNativeInput(o) || u.containsOnlyInlineElements(o) ? (0, $aUGqu._)(t1).concat([
                        o
                    ]) : (0, $aUGqu._)(t1).concat((0, $aUGqu._)(u.getDeepestBlockElements(o)));
                }, []);
            }
        },
        {
            key: "getDeepestNode",
            value: /**
   * Search for deepest node which is Leaf.
   * Leaf is the vertex that doesn't have any child nodes
   *
   * @description Method recursively goes throw the all Node until it finds the Leaf
   * @param {Node} node - root Node. From this vertex we start Deep-first search
   *                      {@link https://en.wikipedia.org/wiki/Depth-first_search}
   * @param {boolean} [atLast] - find last text node
   * @returns - it can be text Node or Element Node, so that caret will able to work with it
   *            Can return null if node is Document or DocumentFragment, or node is not attached to the DOM
   */ function getDeepestNode(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                var o = t1 ? "lastChild" : "firstChild", i = t1 ? "previousSibling" : "nextSibling";
                if (e && e.nodeType === Node.ELEMENT_NODE && e[o]) {
                    var s = e[o];
                    if (u.isSingleTag(s) && !u.isNativeInput(s) && !u.isLineBreakTag(s)) {
                        if (s[i]) s = s[i];
                        else if (s.parentNode[i]) s = s.parentNode[i];
                        else return s.parentNode;
                    }
                    return this.getDeepestNode(s, t1);
                }
                return e;
            }
        },
        {
            key: "isElement",
            value: /**
   * Check if object is DOM node
   *
   * @param {*} node - object to check
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function isElement(e) {
                return $5bdbe1ebf6713620$var$yo(e) ? !1 : e && e.nodeType && e.nodeType === Node.ELEMENT_NODE;
            }
        },
        {
            key: "isFragment",
            value: /**
   * Check if object is DocumentFragment node
   *
   * @param {object} node - object to check
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function isFragment(e) {
                return $5bdbe1ebf6713620$var$yo(e) ? !1 : e && e.nodeType && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
            }
        },
        {
            key: "isContentEditable",
            value: /**
   * Check if passed element is contenteditable
   *
   * @param {HTMLElement} element - html element to check
   * @returns {boolean}
   */ function isContentEditable(e) {
                return e.contentEditable === "true";
            }
        },
        {
            key: "isNativeInput",
            value: /**
   * Checks target if it is native input
   *
   * @param {*} target - HTML element or string
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function isNativeInput(e) {
                var t1 = [
                    "INPUT",
                    "TEXTAREA"
                ];
                return e && e.tagName ? t1.includes(e.tagName) : !1;
            }
        },
        {
            key: "canSetCaret",
            value: /**
   * Checks if we can set caret
   *
   * @param {HTMLElement} target - target to check
   * @returns {boolean}
   */ function canSetCaret(e) {
                var t1 = !0;
                if (u.isNativeInput(e)) switch(e.type){
                    case "file":
                    case "checkbox":
                    case "radio":
                    case "hidden":
                    case "submit":
                    case "button":
                    case "image":
                    case "reset":
                        t1 = !1;
                        break;
                }
                else t1 = u.isContentEditable(e);
                return t1;
            }
        },
        {
            key: "isNodeEmpty",
            value: /**
   * Checks node if it is empty
   *
   * @description Method checks simple Node without any childs for emptiness
   * If you have Node with 2 or more children id depth, you better use {@link Dom#isEmpty} method
   * @param {Node} node - node to check
   * @param {string} [ignoreChars] - char or substring to treat as empty
   * @returns {boolean} true if it is empty
   */ function isNodeEmpty(e, t1) {
                var o;
                return this.isSingleTag(e) && !this.isLineBreakTag(e) ? !1 : (this.isElement(e) && this.isNativeInput(e) ? o = e.value : o = e.textContent.replace("\u200B", ""), t1 && (o = o.replace(new RegExp(t1, "g"), "")), o.length === 0);
            }
        },
        {
            key: "isLeaf",
            value: /**
   * checks node if it is doesn't have any child nodes
   *
   * @param {Node} node - node to check
   * @returns {boolean}
   */ function isLeaf(e) {
                return e ? e.childNodes.length === 0 : !1;
            }
        },
        {
            key: "isEmpty",
            value: /**
   * breadth-first search (BFS)
   * {@link https://en.wikipedia.org/wiki/Breadth-first_search}
   *
   * @description Pushes to stack all DOM leafs and checks for emptiness
   * @param {Node} node - node to check
   * @param {string} [ignoreChars] - char or substring to treat as empty
   * @returns {boolean}
   */ function isEmpty(e, t1) {
                var o = [
                    e
                ];
                for(; o.length > 0;)if (e = o.shift(), !!e) {
                    var _o;
                    if (this.isLeaf(e) && !this.isNodeEmpty(e, t1)) return !1;
                    e.childNodes && (_o = o).push.apply(_o, (0, $aUGqu._)(Array.from(e.childNodes)));
                }
                return !0;
            }
        },
        {
            key: "isHTMLString",
            value: /**
   * Check if string contains html elements
   *
   * @param {string} str - string to check
   * @returns {boolean}
   */ function isHTMLString(e) {
                var t1 = u.make("div");
                return t1.innerHTML = e, t1.childElementCount > 0;
            }
        },
        {
            key: "getContentLength",
            value: /**
   * Return length of node`s text content
   *
   * @param {Node} node - node with content
   * @returns {number}
   */ function getContentLength(e) {
                return u.isNativeInput(e) ? e.value.length : e.nodeType === Node.TEXT_NODE ? e.length : e.textContent.length;
            }
        },
        {
            key: "blockElements",
            get: /**
   * Return array of names of block html elements
   *
   * @returns {string[]}
   */ function get() {
                return [
                    "address",
                    "article",
                    "aside",
                    "blockquote",
                    "canvas",
                    "div",
                    "dl",
                    "dt",
                    "fieldset",
                    "figcaption",
                    "figure",
                    "footer",
                    "form",
                    "h1",
                    "h2",
                    "h3",
                    "h4",
                    "h5",
                    "h6",
                    "header",
                    "hgroup",
                    "hr",
                    "li",
                    "main",
                    "nav",
                    "noscript",
                    "ol",
                    "output",
                    "p",
                    "pre",
                    "ruby",
                    "section",
                    "table",
                    "tbody",
                    "thead",
                    "tr",
                    "tfoot",
                    "ul",
                    "video"
                ];
            }
        },
        {
            key: "containsOnlyInlineElements",
            value: /**
   * Check if passed content includes only inline elements
   *
   * @param {string|HTMLElement} data - element or html string
   * @returns {boolean}
   */ function containsOnlyInlineElements(e) {
                var t1;
                $5bdbe1ebf6713620$var$te(e) ? (t1 = document.createElement("div"), t1.innerHTML = e) : t1 = e;
                var o = function(i) {
                    return !u.blockElements.includes(i.tagName.toLowerCase()) && Array.from(i.children).every(o);
                };
                return Array.from(t1.children).every(o);
            }
        },
        {
            key: "getDeepestBlockElements",
            value: /**
   * Find and return all block elements in the passed parent (including subtree)
   *
   * @param {HTMLElement} parent - root element
   * @returns {HTMLElement[]}
   */ function getDeepestBlockElements(e) {
                return u.containsOnlyInlineElements(e) ? [
                    e
                ] : Array.from(e.children).reduce(function(t1, o) {
                    return (0, $aUGqu._)(t1).concat((0, $aUGqu._)(u.getDeepestBlockElements(o)));
                }, []);
            }
        },
        {
            key: "getHolder",
            value: /**
   * Helper for get holder from {string} or return HTMLElement
   *
   * @param {string | HTMLElement} element - holder's id or holder's HTML Element
   * @returns {HTMLElement}
   */ function getHolder(e) {
                return $5bdbe1ebf6713620$var$te(e) ? document.getElementById(e) : e;
            }
        },
        {
            key: "isAnchor",
            value: /**
   * Returns true if element is anchor (is A tag)
   *
   * @param {Element} element - element to check
   * @returns {boolean}
   */ function isAnchor(e) {
                return e.tagName.toLowerCase() === "a";
            }
        },
        {
            key: "getClosestAnchor",
            value: /**
   * Returns the closest ancestor anchor (A tag) of the given element (including itself)
   * 
   * @param element - element to check
   * @returns {HTMLAnchorElement | null}
   */ function getClosestAnchor(e) {
                return e.closest("a");
            }
        },
        {
            key: "offset",
            value: /**
   * Return element's offset related to the document
   *
   * @todo handle case when editor initialized in scrollable popup
   * @param el - element to compute offset
   */ function offset(e) {
                var t1 = e.getBoundingClientRect(), o = window.pageXOffset || document.documentElement.scrollLeft, i = window.pageYOffset || document.documentElement.scrollTop, s = t1.top + i, r = t1.left + o;
                return {
                    top: s,
                    left: r,
                    bottom: s + t1.height,
                    right: r + t1.width
                };
            }
        },
        {
            key: "getNodeByOffset",
            value: /**
   * Find text node and offset by total content offset
   *
   * @param {Node} root - root node to start search from
   * @param {number} totalOffset - offset relative to the root node content
   * @returns {{node: Node | null, offset: number}} - node and offset inside node
   */ function getNodeByOffset(e, t1) {
                var o = 0, i = null;
                var s = document.createTreeWalker(e, NodeFilter.SHOW_TEXT, null);
                var r = s.nextNode();
                for(; r;){
                    var c = r.textContent, d = c === null ? 0 : c.length;
                    if (i = r, o + d >= t1) break;
                    o += d, r = s.nextNode();
                }
                if (!i) return {
                    node: null,
                    offset: 0
                };
                var a = i.textContent;
                if (a === null || a.length === 0) return {
                    node: null,
                    offset: 0
                };
                var l = Math.min(t1 - o, a.length);
                return {
                    node: i,
                    offset: l
                };
            }
        }
    ]);
    return u;
}();
function $5bdbe1ebf6713620$var$ai(n) {
    return !/[^\t\n\r ]/.test(n);
}
function $5bdbe1ebf6713620$var$li(n) {
    var e = window.getComputedStyle(n), t1 = parseFloat(e.fontSize), o = parseFloat(e.lineHeight) || t1 * 1.2, i = parseFloat(e.paddingTop), s = parseFloat(e.borderTopWidth), r = parseFloat(e.marginTop), a = t1 * 0.8, l = (o - t1) / 2;
    return r + s + i + l + a;
}
function $5bdbe1ebf6713620$var$Do(n) {
    n.dataset.empty = $5bdbe1ebf6713620$var$u.isEmpty(n) ? "true" : "false";
}
var $5bdbe1ebf6713620$var$ci = {
    blockTunes: {
        toggler: {
            "Click to tune": "",
            "or drag to move": ""
        }
    },
    inlineToolbar: {
        converter: {
            "Convert to": ""
        }
    },
    toolbar: {
        toolbox: {
            Add: ""
        }
    },
    popover: {
        Filter: "",
        "Nothing found": "",
        "Convert to": ""
    }
}, $5bdbe1ebf6713620$var$di = {
    Text: "",
    Link: "",
    Bold: "",
    Italic: ""
}, $5bdbe1ebf6713620$var$ui = {
    link: {
        "Add a link": ""
    },
    stub: {
        "The block can not be displayed correctly.": ""
    }
}, $5bdbe1ebf6713620$var$hi = {
    delete: {
        Delete: "",
        "Click to delete": ""
    },
    moveUp: {
        "Move up": ""
    },
    moveDown: {
        "Move down": ""
    }
}, $5bdbe1ebf6713620$var$Fo = {
    ui: $5bdbe1ebf6713620$var$ci,
    toolNames: $5bdbe1ebf6713620$var$di,
    tools: $5bdbe1ebf6713620$var$ui,
    blockTunes: $5bdbe1ebf6713620$var$hi
}, $5bdbe1ebf6713620$var$jo = /*#__PURE__*/ function() {
    "use strict";
    function he() {
        (0, $173N4._)(this, he);
    }
    (0, $cFHGC._)(he, null, [
        {
            key: "ui",
            value: /**
   * Type-safe translation for internal UI texts:
   * Perform translation of the string by namespace and a key
   *
   * @example I18n.ui(I18nInternalNS.ui.blockTunes.toggler, 'Click to tune')
   * @param internalNamespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ function ui(e, t1) {
                return he._t(e, t1);
            }
        },
        {
            key: "t",
            value: /**
   * Translate for external strings that is not presented in default dictionary.
   * For example, for user-specified tool names
   *
   * @param namespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ function t1(e, _t) {
                return he._t(e, _t);
            }
        },
        {
            key: "setDictionary",
            value: /**
   * Adjust module for using external dictionary
   *
   * @param dictionary - new messages list to override default
   */ function setDictionary(e) {
                he.currentDictionary = e;
            }
        },
        {
            key: "_t",
            value: /**
   * Perform translation both for internal and external namespaces
   * If there is no translation found, returns passed key as a translated message
   *
   * @param namespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ function _t(e, t1) {
                var o = he.getNamespace(e);
                return !o || !o[t1] ? t1 : o[t1];
            }
        },
        {
            key: "getNamespace",
            value: /**
   * Find messages section by namespace path
   *
   * @param namespace - path to section
   */ function getNamespace(e) {
                return e.split(".").reduce(function(o, i) {
                    return !o || !Object.keys(o).length ? {} : o[i];
                }, he.currentDictionary);
            }
        }
    ]);
    return he;
}();
$5bdbe1ebf6713620$var$jo.currentDictionary = $5bdbe1ebf6713620$var$Fo;
var $5bdbe1ebf6713620$var$z = $5bdbe1ebf6713620$var$jo;
var $5bdbe1ebf6713620$var$Ho = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $hdIku._)(Ho, Error1);
    function Ho() {
        (0, $173N4._)(this, Ho);
        return (0, $7qXGD._)(this, Ho, arguments);
    }
    return Ho;
}((0, $1SdK7._)(Error));
var $5bdbe1ebf6713620$var$Oe = /*#__PURE__*/ function() {
    "use strict";
    function Oe() {
        (0, $173N4._)(this, Oe);
        this.subscribers = {};
    }
    (0, $cFHGC._)(Oe, [
        {
            /**
   * Subscribe any event on callback
   *
   * @param eventName - event name
   * @param callback - subscriber
   */ key: "on",
            value: function on(e, t1) {
                e in this.subscribers || (this.subscribers[e] = []), this.subscribers[e].push(t1);
            }
        },
        {
            /**
   * Subscribe any event on callback. Callback will be called once and be removed from subscribers array after call.
   *
   * @param eventName - event name
   * @param callback - subscriber
   */ key: "once",
            value: function once(e, t1) {
                var _this = this;
                e in this.subscribers || (this.subscribers[e] = []);
                var o = function(i) {
                    var s = t1(i), r = _this.subscribers[e].indexOf(o);
                    return r !== -1 && _this.subscribers[e].splice(r, 1), s;
                };
                this.subscribers[e].push(o);
            }
        },
        {
            /**
   * Emit callbacks with passed data
   *
   * @param eventName - event name
   * @param data - subscribers get this data when they were fired
   */ key: "emit",
            value: function emit(e, t1) {
                $5bdbe1ebf6713620$var$V(this.subscribers) || !this.subscribers[e] || this.subscribers[e].reduce(function(o, i) {
                    var s = i(o);
                    return s !== void 0 ? s : o;
                }, t1);
            }
        },
        {
            /**
   * Unsubscribe callback from event
   *
   * @param eventName - event name
   * @param callback - event handler
   */ key: "off",
            value: function off(e, t1) {
                if (this.subscribers[e] === void 0) {
                    console.warn('EventDispatcher .off(): there is no subscribers for event "'.concat(e.toString(), '". Probably, .off() called before .on()'));
                    return;
                }
                for(var o = 0; o < this.subscribers[e].length; o++)if (this.subscribers[e][o] === t1) {
                    delete this.subscribers[e][o];
                    break;
                }
            }
        },
        {
            /**
   * Destroyer
   * clears subscribers list
   */ key: "destroy",
            value: function destroy() {
                this.subscribers = {};
            }
        }
    ]);
    return Oe;
}();
function $5bdbe1ebf6713620$var$J(n) {
    Object.setPrototypeOf(this, {
        /**
     * Block id
     *
     * @returns {string}
     */ get id () {
            return n.id;
        },
        /**
     * Tool name
     *
     * @returns {string}
     */ get name () {
            return n.name;
        },
        /**
     * Tool config passed on Editor's initialization
     *
     * @returns {ToolConfig}
     */ get config () {
            return n.config;
        },
        /**
     * .ce-block element, that wraps plugin contents
     *
     * @returns {HTMLElement}
     */ get holder () {
            return n.holder;
        },
        /**
     * True if Block content is empty
     *
     * @returns {boolean}
     */ get isEmpty () {
            return n.isEmpty;
        },
        /**
     * True if Block is selected with Cross-Block selection
     *
     * @returns {boolean}
     */ get selected () {
            return n.selected;
        },
        /**
     * Set Block's stretch state
     *
     * @param {boolean} state — state to set
     */ set stretched (t){
            n.stretched = t;
        },
        /**
     * True if Block is stretched
     *
     * @returns {boolean}
     */ get stretched () {
            return n.stretched;
        },
        /**
     * True if Block has inputs to be focused
     */ get focusable () {
            return n.focusable;
        },
        /**
     * Call Tool method with errors handler under-the-hood
     *
     * @param {string} methodName - method to call
     * @param {object} param - object with parameters
     * @returns {unknown}
     */ call: function(t1, o) {
            return n.call(t1, o);
        },
        /**
     * Save Block content
     *
     * @returns {Promise<void|SavedData>}
     */ save: function() {
            return n.save();
        },
        /**
     * Validate Block data
     *
     * @param {BlockToolData} data - data to validate
     * @returns {Promise<boolean>}
     */ validate: function(t1) {
            return n.validate(t1);
        },
        /**
     * Allows to say Editor that Block was changed. Used to manually trigger Editor's 'onChange' callback
     * Can be useful for block changes invisible for editor core.
     */ dispatchChange: function() {
            n.dispatchChange();
        },
        /**
     * Tool could specify several entries to be displayed at the Toolbox (for example, "Heading 1", "Heading 2", "Heading 3")
     * This method returns the entry that is related to the Block (depended on the Block data)
     */ getActiveToolboxEntry: function() {
            return n.getActiveToolboxEntry();
        }
    });
}
var $5bdbe1ebf6713620$var$_e = /*#__PURE__*/ function() {
    "use strict";
    function _e() {
        (0, $173N4._)(this, _e);
        this.allListeners = [];
    }
    (0, $cFHGC._)(_e, [
        {
            /**
   * Assigns event listener on element and returns unique identifier
   *
   * @param {EventTarget} element - DOM element that needs to be listened
   * @param {string} eventType - event type
   * @param {Function} handler - method that will be fired on event
   * @param {boolean|AddEventListenerOptions} options - useCapture or {capture, passive, once}
   */ key: "on",
            value: function on(e, t1, o) {
                var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
                var s = $5bdbe1ebf6713620$var$si("l"), r = {
                    id: s,
                    element: e,
                    eventType: t1,
                    handler: o,
                    options: i
                };
                if (!this.findOne(e, t1, o)) return this.allListeners.push(r), e.addEventListener(t1, o, i), s;
            }
        },
        {
            /**
   * Removes event listener from element
   *
   * @param {EventTarget} element - DOM element that we removing listener
   * @param {string} eventType - event type
   * @param {Function} handler - remove handler, if element listens several handlers on the same event type
   * @param {boolean|AddEventListenerOptions} options - useCapture or {capture, passive, once}
   */ key: "off",
            value: function off(e, t1, o, i) {
                var _this = this;
                var s = this.findAll(e, t1, o);
                s.forEach(function(r, a) {
                    var l = _this.allListeners.indexOf(s[a]);
                    l > -1 && (_this.allListeners.splice(l, 1), r.element.removeEventListener(r.eventType, r.handler, r.options));
                });
            }
        },
        {
            /**
   * Removes listener by id
   *
   * @param {string} id - listener identifier
   */ key: "offById",
            value: function offById(e) {
                var t1 = this.findById(e);
                t1 && t1.element.removeEventListener(t1.eventType, t1.handler, t1.options);
            }
        },
        {
            /**
   * Finds and returns first listener by passed params
   *
   * @param {EventTarget} element - event target
   * @param {string} [eventType] - event type
   * @param {Function} [handler] - event handler
   * @returns {ListenerData|null}
   */ key: "findOne",
            value: function findOne(e, t1, o) {
                var i = this.findAll(e, t1, o);
                return i.length > 0 ? i[0] : null;
            }
        },
        {
            /**
   * Return all stored listeners by passed params
   *
   * @param {EventTarget} element - event target
   * @param {string} eventType - event type
   * @param {Function} handler - event handler
   * @returns {ListenerData[]}
   */ key: "findAll",
            value: function findAll(e, t1, o) {
                var i;
                var s = e ? this.findByEventTarget(e) : [];
                return e && t1 && o ? i = s.filter(function(r) {
                    return r.eventType === t1 && r.handler === o;
                }) : e && t1 ? i = s.filter(function(r) {
                    return r.eventType === t1;
                }) : i = s, i;
            }
        },
        {
            /**
   * Removes all listeners
   */ key: "removeAll",
            value: function removeAll() {
                this.allListeners.map(function(e) {
                    e.element.removeEventListener(e.eventType, e.handler, e.options);
                }), this.allListeners = [];
            }
        },
        {
            /**
   * Module cleanup on destruction
   */ key: "destroy",
            value: function destroy() {
                this.removeAll();
            }
        },
        {
            /**
   * Search method: looks for listener by passed element
   *
   * @param {EventTarget} element - searching element
   * @returns {Array} listeners that found on element
   */ key: "findByEventTarget",
            value: function findByEventTarget(e) {
                return this.allListeners.filter(function(t1) {
                    if (t1.element === e) return t1;
                });
            }
        },
        {
            /**
   * Search method: looks for listener by passed event type
   *
   * @param {string} eventType - event type
   * @returns {ListenerData[]} listeners that found on element
   */ key: "findByType",
            value: function findByType(e) {
                return this.allListeners.filter(function(t1) {
                    if (t1.eventType === e) return t1;
                });
            }
        },
        {
            /**
   * Search method: looks for listener by passed handler
   *
   * @param {Function} handler - event handler
   * @returns {ListenerData[]} listeners that found on element
   */ key: "findByHandler",
            value: function findByHandler(e) {
                return this.allListeners.filter(function(t1) {
                    if (t1.handler === e) return t1;
                });
            }
        },
        {
            /**
   * Returns listener data found by id
   *
   * @param {string} id - listener identifier
   * @returns {ListenerData}
   */ key: "findById",
            value: function findById(e) {
                return this.allListeners.find(function(t1) {
                    return t1.id === e;
                });
            }
        }
    ]);
    return _e;
}();
var $5bdbe1ebf6713620$var$E = /*#__PURE__*/ function _target() {
    "use strict";
    function E(param) {
        var _this = this;
        var e = param.config, t1 = param.eventsDispatcher;
        var _this1 = this;
        (0, $173N4._)(this, E);
        if (this.nodes = {}, this.listeners = new $5bdbe1ebf6713620$var$_e(), this.readOnlyMutableListeners = {
            /**
       * Assigns event listener on DOM element and pushes into special array that might be removed
       *
       * @param {EventTarget} element - DOM Element
       * @param {string} eventType - Event name
       * @param {Function} handler - Event handler
       * @param {boolean|AddEventListenerOptions} options - Listening options
       */ on: function(o, i, s) {
                var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
                _this1.mutableListenerIds.push(_this1.listeners.on(o, i, s, r));
            },
            /**
       * Clears all mutable listeners
       */ clearAll: function() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = _this.mutableListenerIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var o = _step.value;
                        _this.listeners.offById(o);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                _this.mutableListenerIds = [];
            }
        }, this.mutableListenerIds = [], (this instanceof E ? this.constructor : void 0) === E) throw new TypeError("Constructors for abstract class Module are not allowed.");
        this.config = e, this.eventsDispatcher = t1;
    }
    (0, $cFHGC._)(E, [
        {
            key: "state",
            set: /**
   * Editor modules setter
   *
   * @param {EditorModules} Editor - Editor's Modules
   */ function set(e) {
                this.Editor = e;
            }
        },
        {
            /**
   * Remove memorized nodes
   */ key: "removeAllNodes",
            value: function removeAllNodes() {
                for(var e in this.nodes){
                    var t1 = this.nodes[e];
                    t1 instanceof HTMLElement && t1.remove();
                }
            }
        },
        {
            key: "isRtl",
            get: /**
   * Returns true if current direction is RTL (Right-To-Left)
   */ function get() {
                return this.config.i18n.direction === "rtl";
            }
        }
    ]);
    return E;
}();
var $5bdbe1ebf6713620$var$b = /*#__PURE__*/ function() {
    "use strict";
    function b() {
        (0, $173N4._)(this, b);
        this.instance = null, this.selection = null, this.savedSelectionRange = null, this.isFakeBackgroundEnabled = !1, this.commandBackground = "backColor";
    }
    (0, $cFHGC._)(b, [
        {
            /**
   * Removes fake background
   */ key: "removeFakeBackground",
            value: function removeFakeBackground() {
                this.isFakeBackgroundEnabled && (document.execCommand(this.commandBackground, !1, "transparent"), this.isFakeBackgroundEnabled = !1);
            }
        },
        {
            /**
   * Sets fake background
   */ key: "setFakeBackground",
            value: function setFakeBackground() {
                document.execCommand(this.commandBackground, !1, "#a8d6ff"), this.isFakeBackgroundEnabled = !0;
            }
        },
        {
            /**
   * Save SelectionUtils's range
   */ key: "save",
            value: function save() {
                this.savedSelectionRange = b.range;
            }
        },
        {
            /**
   * Restore saved SelectionUtils's range
   */ key: "restore",
            value: function restore() {
                if (!this.savedSelectionRange) return;
                var e = window.getSelection();
                e.removeAllRanges(), e.addRange(this.savedSelectionRange);
            }
        },
        {
            /**
   * Clears saved selection
   */ key: "clearSaved",
            value: function clearSaved() {
                this.savedSelectionRange = null;
            }
        },
        {
            /**
   * Collapse current selection
   */ key: "collapseToEnd",
            value: function collapseToEnd() {
                var e = window.getSelection(), t1 = document.createRange();
                t1.selectNodeContents(e.focusNode), t1.collapse(!1), e.removeAllRanges(), e.addRange(t1);
            }
        },
        {
            /**
   * Looks ahead to find passed tag from current selection
   *
   * @param  {string} tagName       - tag to found
   * @param  {string} [className]   - tag's class name
   * @param  {number} [searchDepth] - count of tags that can be included. For better performance.
   * @returns {HTMLElement|null}
   */ key: "findParentTag",
            value: function findParentTag(e, t1) {
                var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
                var i = window.getSelection();
                var s = null;
                return !i || !i.anchorNode || !i.focusNode ? null : ([
                    /** the Node in which the selection begins */ i.anchorNode,
                    /** the Node in which the selection ends */ i.focusNode
                ].forEach(function(a) {
                    var l = o;
                    for(; l > 0 && a.parentNode && !(a.tagName === e && (s = a, t1 && a.classList && !a.classList.contains(t1) && (s = null), s));)a = a.parentNode, l--;
                }), s);
            }
        },
        {
            /**
   * Expands selection range to the passed parent node
   *
   * @param {HTMLElement} element - element which contents should be selected
   */ key: "expandToTag",
            value: function expandToTag(e) {
                var t1 = window.getSelection();
                t1.removeAllRanges();
                var o = document.createRange();
                o.selectNodeContents(e), t1.addRange(o);
            }
        }
    ], [
        {
            key: "CSS",
            get: /**
   * Editor styles
   *
   * @returns {{editorWrapper: string, editorZone: string}}
   */ function get() {
                return {
                    editorWrapper: "codex-editor",
                    editorZone: "codex-editor__redactor"
                };
            }
        },
        {
            key: "anchorNode",
            get: /**
   * Returns selected anchor
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Selection/anchorNode}
   *
   * @returns {Node|null}
   */ function get() {
                var e = window.getSelection();
                return e ? e.anchorNode : null;
            }
        },
        {
            key: "anchorElement",
            get: /**
   * Returns selected anchor element
   *
   * @returns {Element|null}
   */ function get() {
                var e = window.getSelection();
                if (!e) return null;
                var t1 = e.anchorNode;
                return t1 ? $5bdbe1ebf6713620$var$u.isElement(t1) ? t1 : t1.parentElement : null;
            }
        },
        {
            key: "anchorOffset",
            get: /**
   * Returns selection offset according to the anchor node
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Selection/anchorOffset}
   *
   * @returns {number|null}
   */ function get() {
                var e = window.getSelection();
                return e ? e.anchorOffset : null;
            }
        },
        {
            key: "isCollapsed",
            get: /**
   * Is current selection range collapsed
   *
   * @returns {boolean|null}
   */ function get() {
                var e = window.getSelection();
                return e ? e.isCollapsed : null;
            }
        },
        {
            key: "isAtEditor",
            get: /**
   * Check current selection if it is at Editor's zone
   *
   * @returns {boolean}
   */ function get() {
                return this.isSelectionAtEditor(b.get());
            }
        },
        {
            key: "isSelectionAtEditor",
            value: /**
   * Check if passed selection is at Editor's zone
   *
   * @param selection - Selection object to check
   */ function isSelectionAtEditor(e) {
                if (!e) return !1;
                var t1 = e.anchorNode || e.focusNode;
                t1 && t1.nodeType === Node.TEXT_NODE && (t1 = t1.parentNode);
                var o = null;
                return t1 && t1 instanceof Element && (o = t1.closest(".".concat(b.CSS.editorZone))), o ? o.nodeType === Node.ELEMENT_NODE : !1;
            }
        },
        {
            key: "isRangeAtEditor",
            value: /**
   * Check if passed range at Editor zone
   *
   * @param range - range to check
   */ function isRangeAtEditor(e) {
                if (!e) return;
                var t1 = e.startContainer;
                t1 && t1.nodeType === Node.TEXT_NODE && (t1 = t1.parentNode);
                var o = null;
                return t1 && t1 instanceof Element && (o = t1.closest(".".concat(b.CSS.editorZone))), o ? o.nodeType === Node.ELEMENT_NODE : !1;
            }
        },
        {
            key: "isSelectionExists",
            get: /**
   * Methods return boolean that true if selection exists on the page
   */ function get() {
                return !!b.get().anchorNode;
            }
        },
        {
            key: "range",
            get: /**
   * Return first range
   *
   * @returns {Range|null}
   */ function get() {
                return this.getRangeFromSelection(this.get());
            }
        },
        {
            key: "getRangeFromSelection",
            value: /**
   * Returns range from passed Selection object
   *
   * @param selection - Selection object to get Range from
   */ function getRangeFromSelection(e) {
                return e && e.rangeCount ? e.getRangeAt(0) : null;
            }
        },
        {
            key: "rect",
            get: /**
   * Calculates position and size of selected text
   *
   * @returns {DOMRect | ClientRect}
   */ function get() {
                var e = document.selection, t1, o = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
                if (e && e.type !== "Control") return e, t1 = e.createRange(), o.x = t1.boundingLeft, o.y = t1.boundingTop, o.width = t1.boundingWidth, o.height = t1.boundingHeight, o;
                if (!window.getSelection) return $5bdbe1ebf6713620$var$S("Method window.getSelection is not supported", "warn"), o;
                if (e = window.getSelection(), e.rangeCount === null || isNaN(e.rangeCount)) return $5bdbe1ebf6713620$var$S("Method SelectionUtils.rangeCount is not supported", "warn"), o;
                if (e.rangeCount === 0) return o;
                if (t1 = e.getRangeAt(0).cloneRange(), t1.getBoundingClientRect && (o = t1.getBoundingClientRect()), o.x === 0 && o.y === 0) {
                    var i = document.createElement("span");
                    if (i.getBoundingClientRect) {
                        i.appendChild(document.createTextNode("\u200B")), t1.insertNode(i), o = i.getBoundingClientRect();
                        var s = i.parentNode;
                        s.removeChild(i), s.normalize();
                    }
                }
                return o;
            }
        },
        {
            key: "text",
            get: /**
   * Returns selected text as String
   *
   * @returns {string}
   */ function get() {
                return window.getSelection ? window.getSelection().toString() : "";
            }
        },
        {
            key: "get",
            value: /**
   * Returns window SelectionUtils
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Window/getSelection}
   *
   * @returns {Selection}
   */ function get() {
                return window.getSelection();
            }
        },
        {
            key: "setCursor",
            value: /**
   * Set focus to contenteditable or native input element
   *
   * @param element - element where to set focus
   * @param offset - offset of cursor
   */ function setCursor(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var o = document.createRange(), i = window.getSelection();
                return $5bdbe1ebf6713620$var$u.isNativeInput(e) ? $5bdbe1ebf6713620$var$u.canSetCaret(e) ? (e.focus(), e.selectionStart = e.selectionEnd = t1, e.getBoundingClientRect()) : void 0 : (o.setStart(e, t1), o.setEnd(e, t1), i.removeAllRanges(), i.addRange(o), o.getBoundingClientRect());
            }
        },
        {
            key: "isRangeInsideContainer",
            value: /**
   * Check if current range exists and belongs to container
   *
   * @param container - where range should be
   */ function isRangeInsideContainer(e) {
                var t1 = b.range;
                return t1 === null ? !1 : e.contains(t1.startContainer);
            }
        },
        {
            key: "addFakeCursor",
            value: /**
   * Adds fake cursor to the current range
   */ function addFakeCursor() {
                var e = b.range;
                if (e === null) return;
                var t1 = $5bdbe1ebf6713620$var$u.make("span", "codex-editor__fake-cursor");
                t1.dataset.mutationFree = "true", e.collapse(), e.insertNode(t1);
            }
        },
        {
            key: "isFakeCursorInsideContainer",
            value: /**
   * Check if passed element contains a fake cursor
   *
   * @param el - where to check
   */ function isFakeCursorInsideContainer(e) {
                return $5bdbe1ebf6713620$var$u.find(e, ".codex-editor__fake-cursor") !== null;
            }
        },
        {
            key: "removeFakeCursor",
            value: /**
   * Removes fake cursor from a container
   *
   * @param container - container to look for
   */ function removeFakeCursor() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document.body;
                var t1 = $5bdbe1ebf6713620$var$u.find(e, ".codex-editor__fake-cursor");
                t1 && t1.remove();
            }
        }
    ]);
    return b;
}();
function $5bdbe1ebf6713620$var$pi(n, e) {
    var t1 = n.type, o = n.target, i = n.addedNodes, s = n.removedNodes;
    return n.type === "attributes" && n.attributeName === "data-empty" ? !1 : !!(e.contains(o) || t1 === "childList" && (Array.from(i).some(function(l) {
        return l === e;
    }) || Array.from(s).some(function(l) {
        return l === e;
    })));
}
var $5bdbe1ebf6713620$var$ft = "redactor dom changed", $5bdbe1ebf6713620$var$$o = "block changed", $5bdbe1ebf6713620$var$zo = "fake cursor is about to be toggled", $5bdbe1ebf6713620$var$Uo = "fake cursor have been set", $5bdbe1ebf6713620$var$Te = "editor mobile layout toggled";
function $5bdbe1ebf6713620$var$gt(n, e) {
    if (!n.conversionConfig) return !1;
    var t1 = n.conversionConfig[e];
    return $5bdbe1ebf6713620$var$A(t1) || $5bdbe1ebf6713620$var$te(t1);
}
function $5bdbe1ebf6713620$var$He(n, e) {
    return $5bdbe1ebf6713620$var$gt(n.tool, e);
}
function $5bdbe1ebf6713620$var$Wo(n, e) {
    return Object.entries(n).some(function(param) {
        var _param = (0, $f9AOD._)(param, 2), t1 = _param[0], o = _param[1];
        return e[t1] && $5bdbe1ebf6713620$var$ri(e[t1], o);
    });
}
function $5bdbe1ebf6713620$var$Yo(n, e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var o, i;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        n.save()
                    ];
                case 1:
                    o = _state.sent().data, i = e.find(function(s) {
                        return s.name === n.name;
                    });
                    return [
                        2,
                        i !== void 0 && !$5bdbe1ebf6713620$var$gt(i, "export") ? [] : e.reduce(function(s, r) {
                            if (!$5bdbe1ebf6713620$var$gt(r, "import") || r.toolbox === void 0) return s;
                            var a = r.toolbox.filter(function(l) {
                                if ($5bdbe1ebf6713620$var$V(l) || l.icon === void 0) return !1;
                                if (l.data !== void 0) {
                                    if ($5bdbe1ebf6713620$var$Wo(l.data, o)) return !1;
                                } else if (r.name === n.name) return !1;
                                return !0;
                            });
                            return s.push((0, $6fpqi._)((0, $1XAnY._)({}, r), {
                                toolbox: a
                            })), s;
                        }, [])
                    ];
            }
        });
    })();
}
function $5bdbe1ebf6713620$var$xo(n, e) {
    return n.mergeable ? n.name === e.name ? !0 : $5bdbe1ebf6713620$var$He(e, "export") && $5bdbe1ebf6713620$var$He(n, "import") : !1;
}
function $5bdbe1ebf6713620$var$fi(n, e) {
    var t1 = e == null ? void 0 : e.export;
    return $5bdbe1ebf6713620$var$A(t1) ? t1(n) : $5bdbe1ebf6713620$var$te(t1) ? n[t1] : (t1 !== void 0 && $5bdbe1ebf6713620$var$S("Conversion \xabexport\xbb property must be a string or function. String means key of saved data object to export. Function should export processed string to export."), "");
}
function $5bdbe1ebf6713620$var$Bo(n, e, t1) {
    var o = e == null ? void 0 : e.import;
    return $5bdbe1ebf6713620$var$A(o) ? o(n, t1) : $5bdbe1ebf6713620$var$te(o) ? (0, $7Pjls._)({}, o, n) : (o !== void 0 && $5bdbe1ebf6713620$var$S("Conversion \xabimport\xbb property must be a string or function. String means key of tool data to import. Function accepts a imported string and return composed tool data."), {});
}
var $5bdbe1ebf6713620$var$_ = /* @__PURE__ */ function(n) {
    return n.Default = "default", n.Separator = "separator", n.Html = "html", n;
}($5bdbe1ebf6713620$var$_ || {}), $5bdbe1ebf6713620$var$ee = /* @__PURE__ */ function(n) {
    return n.APPEND_CALLBACK = "appendCallback", n.RENDERED = "rendered", n.MOVED = "moved", n.UPDATED = "updated", n.REMOVED = "removed", n.ON_PASTE = "onPaste", n;
}($5bdbe1ebf6713620$var$ee || {});
var $5bdbe1ebf6713620$var$R = /*#__PURE__*/ function(Oe) {
    "use strict";
    (0, $hdIku._)(R, Oe);
    function R(param, r) {
        var tmp = param.id, e = tmp === void 0 ? $5bdbe1ebf6713620$var$ni() : tmp, t1 = param.data, o = param.tool, i = param.readOnly, s = param.tunesData;
        (0, $173N4._)(this, R);
        var _this;
        _this = (0, $7qXGD._)(this, R), _this.cachedInputs = [], _this.toolRenderedElement = null, _this.tunesInstances = /* @__PURE__ */ new Map(), _this.defaultTunesInstances = /* @__PURE__ */ new Map(), _this.unavailableTunesData = {}, _this.inputIndex = 0, _this.editorEventBus = null, _this.handleFocus = function() {
            _this.dropInputsCache(), _this.updateCurrentInput();
        }, _this.didMutated = function(a) {
            var l = a === void 0, c = a instanceof InputEvent;
            !l && !c && _this.detectToolRootChange(a);
            var d;
            l || c ? d = !0 : d = !(a.length > 0 && a.every(function(p) {
                var g = p.addedNodes, f = p.removedNodes, v = p.target;
                return (0, $aUGqu._)(Array.from(g)).concat((0, $aUGqu._)(Array.from(f)), [
                    v
                ]).some(function(T) {
                    return $5bdbe1ebf6713620$var$u.isElement(T) || (T = T.parentElement), T && T.closest('[data-mutation-free="true"]') !== null;
                });
            })), d && (_this.dropInputsCache(), _this.updateCurrentInput(), _this.toggleInputsEmptyMark(), _this.call("updated"), _this.emit("didMutated", _this));
        }, _this.name = o.name, _this.id = e, _this.settings = o.settings, _this.config = o.settings.config || {}, _this.editorEventBus = r || null, _this.blockAPI = new $5bdbe1ebf6713620$var$J(_this), _this.tool = o, _this.toolInstance = o.create(t1, _this.blockAPI, i), _this.tunes = o.tunes, _this.composeTunes(s), _this.holder = _this.compose(), window.requestIdleCallback(function() {
            _this.watchBlockMutations(), _this.addInputEvents(), _this.toggleInputsEmptyMark();
        });
        return _this;
    }
    (0, $cFHGC._)(R, [
        {
            key: "inputs",
            get: /**
   * Find and return all editable elements (contenteditable and native inputs) in the Tool HTML
   */ function get() {
                if (this.cachedInputs.length !== 0) return this.cachedInputs;
                var e = $5bdbe1ebf6713620$var$u.findAllInputs(this.holder);
                return this.inputIndex > e.length - 1 && (this.inputIndex = e.length - 1), this.cachedInputs = e, e;
            }
        },
        {
            key: "currentInput",
            get: /**
   * Return current Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ function get() {
                return this.inputs[this.inputIndex];
            },
            set: /**
   * Set input index to the passed element
   *
   * @param element - HTML Element to set as current input
   */ function set(e) {
                var t1 = this.inputs.findIndex(function(o) {
                    return o === e || o.contains(e);
                });
                t1 !== -1 && (this.inputIndex = t1);
            }
        },
        {
            key: "firstInput",
            get: /**
   * Return first Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ function get() {
                return this.inputs[0];
            }
        },
        {
            key: "lastInput",
            get: /**
   * Return first Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ function get() {
                var e = this.inputs;
                return e[e.length - 1];
            }
        },
        {
            key: "nextInput",
            get: /**
   * Return next Tool`s input or undefined if it doesn't exist
   * If Block doesn't contain inputs, return undefined
   */ function get() {
                return this.inputs[this.inputIndex + 1];
            }
        },
        {
            key: "previousInput",
            get: /**
   * Return previous Tool`s input or undefined if it doesn't exist
   * If Block doesn't contain inputs, return undefined
   */ function get() {
                return this.inputs[this.inputIndex - 1];
            }
        },
        {
            key: "data",
            get: /**
   * Get Block's JSON data
   *
   * @returns {object}
   */ function get() {
                return this.save().then(function(e) {
                    return e && !$5bdbe1ebf6713620$var$V(e.data) ? e.data : {};
                });
            }
        },
        {
            key: "sanitize",
            get: /**
   * Returns tool's sanitizer config
   *
   * @returns {object}
   */ function get() {
                return this.tool.sanitizeConfig;
            }
        },
        {
            key: "mergeable",
            get: /**
   * is block mergeable
   * We plugin have merge function then we call it mergeable
   *
   * @returns {boolean}
   */ function get() {
                return $5bdbe1ebf6713620$var$A(this.toolInstance.merge);
            }
        },
        {
            key: "focusable",
            get: /**
   * If Block contains inputs, it is focusable
   */ function get() {
                return this.inputs.length !== 0;
            }
        },
        {
            key: "isEmpty",
            get: /**
   * Check block for emptiness
   *
   * @returns {boolean}
   */ function get() {
                var e = $5bdbe1ebf6713620$var$u.isEmpty(this.pluginsContent, "/"), t1 = !this.hasMedia;
                return e && t1;
            }
        },
        {
            key: "hasMedia",
            get: /**
   * Check if block has a media content such as images, iframe and other
   *
   * @returns {boolean}
   */ function get() {
                var e = [
                    "img",
                    "iframe",
                    "video",
                    "audio",
                    "source",
                    "input",
                    "textarea",
                    "twitterwidget"
                ];
                return !!this.holder.querySelector(e.join(","));
            }
        },
        {
            key: "selected",
            get: /**
   * Returns True if it is Selected
   *
   * @returns {boolean}
   */ function get() {
                return this.holder.classList.contains(R.CSS.selected);
            },
            set: /**
   * Set selected state
   * We don't need to mark Block as Selected when it is empty
   *
   * @param {boolean} state - 'true' to select, 'false' to remove selection
   */ function set(e) {
                var i, s;
                this.holder.classList.toggle(R.CSS.selected, e);
                var t1 = e === !0 && $5bdbe1ebf6713620$var$b.isRangeInsideContainer(this.holder), o = e === !1 && $5bdbe1ebf6713620$var$b.isFakeCursorInsideContainer(this.holder);
                (t1 || o) && ((i = this.editorEventBus) == null || i.emit($5bdbe1ebf6713620$var$zo, {
                    state: e
                }), t1 ? $5bdbe1ebf6713620$var$b.addFakeCursor() : $5bdbe1ebf6713620$var$b.removeFakeCursor(this.holder), (s = this.editorEventBus) == null || s.emit($5bdbe1ebf6713620$var$Uo, {
                    state: e
                }));
            }
        },
        {
            key: "stretched",
            get: /**
   * Return Block's stretched state
   *
   * @returns {boolean}
   */ function get() {
                return this.holder.classList.contains(R.CSS.wrapperStretched);
            },
            set: /**
   * Set stretched state
   *
   * @param {boolean} state - 'true' to enable, 'false' to disable stretched state
   */ function set(e) {
                this.holder.classList.toggle(R.CSS.wrapperStretched, e);
            }
        },
        {
            key: "dropTarget",
            set: /**
   * Toggle drop target state
   *
   * @param {boolean} state - 'true' if block is drop target, false otherwise
   */ function set(e) {
                this.holder.classList.toggle(R.CSS.dropTarget, e);
            }
        },
        {
            key: "pluginsContent",
            get: /**
   * Returns Plugins content
   *
   * @returns {HTMLElement}
   */ function get() {
                return this.toolRenderedElement;
            }
        },
        {
            /**
   * Calls Tool's method
   *
   * Method checks tool property {MethodName}. Fires method with passes params If it is instance of Function
   *
   * @param {string} methodName - method to call
   * @param {object} params - method argument
   */ key: "call",
            value: function call(e, t1) {
                if ($5bdbe1ebf6713620$var$A(this.toolInstance[e])) {
                    e === "appendCallback" && $5bdbe1ebf6713620$var$S("`appendCallback` hook is deprecated and will be removed in the next major release. Use `rendered` hook instead", "warn");
                    try {
                        this.toolInstance[e].call(this.toolInstance, t1);
                    } catch (o) {
                        $5bdbe1ebf6713620$var$S("Error during '".concat(e, "' call: ").concat(o.message), "error");
                    }
                }
            }
        },
        {
            key: "mergeWith",
            value: /**
   * Call plugins merge method
   *
   * @param {BlockToolData} data - data to merge
   */ function mergeWith(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.toolInstance.merge(e)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "save",
            value: /**
   * Extracts data from Block
   * Groups Tool's save processing time
   *
   * @returns {object}
   */ function save() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _this, e, t1, o, i;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.toolInstance.save(this.pluginsContent)
                                ];
                            case 1:
                                e = _state.sent(), t1 = this.unavailableTunesData;
                                (0, $aUGqu._)(this.tunesInstances.entries()).concat((0, $aUGqu._)(this.defaultTunesInstances.entries())).forEach(function(param) {
                                    var _param = (0, $f9AOD._)(param, 2), s = _param[0], r = _param[1];
                                    if ($5bdbe1ebf6713620$var$A(r.save)) try {
                                        t1[s] = r.save();
                                    } catch (a) {
                                        $5bdbe1ebf6713620$var$S("Tune ".concat(r.constructor.name, " save method throws an Error %o"), "warn", a);
                                    }
                                });
                                o = window.performance.now();
                                return [
                                    2,
                                    Promise.resolve(e).then(function(s) {
                                        return i = window.performance.now(), {
                                            id: _this.id,
                                            tool: _this.name,
                                            data: s,
                                            tunes: t1,
                                            time: i - o
                                        };
                                    }).catch(function(s) {
                                        $5bdbe1ebf6713620$var$S("Saving process for ".concat(_this.name, " tool failed due to the ").concat(s), "log", "red");
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "validate",
            value: /**
   * Uses Tool's validation method to check the correctness of output data
   * Tool's validation method is optional
   *
   * @description Method returns true|false whether data passed the validation or not
   * @param {BlockToolData} data - data to validate
   * @returns {Promise<boolean>} valid
   */ function validate(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var t1, _tmp;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t1 = !0;
                                _tmp = this.toolInstance.validate instanceof Function;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.toolInstance.validate(e)
                                ];
                            case 1:
                                _tmp = t1 = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    (_tmp, t1)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Returns data to render in Block Tunes menu.
   * Splits block tunes into 2 groups: block specific tunes and common tunes
   */ key: "getTunes",
            value: function getTunes() {
                var _e;
                var e = [], t1 = [], o = typeof this.toolInstance.renderSettings == "function" ? this.toolInstance.renderSettings() : [];
                return $5bdbe1ebf6713620$var$u.isElement(o) ? e.push({
                    type: $5bdbe1ebf6713620$var$_.Html,
                    element: o
                }) : Array.isArray(o) ? (_e = e).push.apply(_e, (0, $aUGqu._)(o)) : e.push(o), (0, $aUGqu._)(this.tunesInstances.values()).concat((0, $aUGqu._)(this.defaultTunesInstances.values())).map(function(s) {
                    return s.render();
                }).forEach(function(s) {
                    var _t;
                    $5bdbe1ebf6713620$var$u.isElement(s) ? t1.push({
                        type: $5bdbe1ebf6713620$var$_.Html,
                        element: s
                    }) : Array.isArray(s) ? (_t = t1).push.apply(_t, (0, $aUGqu._)(s)) : t1.push(s);
                }), {
                    toolTunes: e,
                    commonTunes: t1
                };
            }
        },
        {
            /**
   * Update current input index with selection anchor node
   */ key: "updateCurrentInput",
            value: function updateCurrentInput() {
                this.currentInput = $5bdbe1ebf6713620$var$u.isNativeInput(document.activeElement) || !$5bdbe1ebf6713620$var$b.anchorNode ? document.activeElement : $5bdbe1ebf6713620$var$b.anchorNode;
            }
        },
        {
            /**
   * Allows to say Editor that Block was changed. Used to manually trigger Editor's 'onChange' callback
   * Can be useful for block changes invisible for editor core.
   */ key: "dispatchChange",
            value: function dispatchChange() {
                this.didMutated();
            }
        },
        {
            /**
   * Call Tool instance destroy method
   */ key: "destroy",
            value: function destroy() {
                this.unwatchBlockMutations(), this.removeInputEvents(), (0, $dWsrg._)((0, $kg0zo._)(R.prototype), "destroy", this).call(this), $5bdbe1ebf6713620$var$A(this.toolInstance.destroy) && this.toolInstance.destroy();
            }
        },
        {
            key: "getActiveToolboxEntry",
            value: /**
   * Tool could specify several entries to be displayed at the Toolbox (for example, "Heading 1", "Heading 2", "Heading 3")
   * This method returns the entry that is related to the Block (depended on the Block data)
   */ function getActiveToolboxEntry() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var e, t1, o;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = this.tool.toolbox;
                                if (e.length === 1) return [
                                    2,
                                    Promise.resolve(this.tool.toolbox[0])
                                ];
                                return [
                                    4,
                                    this.data
                                ];
                            case 1:
                                t1 = _state.sent(), o = e;
                                return [
                                    2,
                                    o == null ? void 0 : o.find(function(i) {
                                        return $5bdbe1ebf6713620$var$Wo(i.data, t1);
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "exportDataAsString",
            value: /**
   * Exports Block data as string using conversion config
   */ function exportDataAsString() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var e;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.data
                                ];
                            case 1:
                                e = _state.sent();
                                return [
                                    2,
                                    $5bdbe1ebf6713620$var$fi(e, this.tool.conversionConfig)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Make default Block wrappers and put Tool`s content there
   *
   * @returns {HTMLDivElement}
   */ key: "compose",
            value: function compose() {
                var e = $5bdbe1ebf6713620$var$u.make("div", R.CSS.wrapper), t1 = $5bdbe1ebf6713620$var$u.make("div", R.CSS.content), o = this.toolInstance.render();
                e.dataset.id = this.id, this.toolRenderedElement = o, t1.appendChild(this.toolRenderedElement);
                var i = t1;
                return (0, $aUGqu._)(this.tunesInstances.values()).concat((0, $aUGqu._)(this.defaultTunesInstances.values())).forEach(function(s) {
                    if ($5bdbe1ebf6713620$var$A(s.wrap)) try {
                        i = s.wrap(i);
                    } catch (r) {
                        $5bdbe1ebf6713620$var$S("Tune ".concat(s.constructor.name, " wrap method throws an Error %o"), "warn", r);
                    }
                }), e.appendChild(i), e;
            }
        },
        {
            /**
   * Instantiate Block Tunes
   *
   * @param tunesData - current Block tunes data
   * @private
   */ key: "composeTunes",
            value: function composeTunes(e) {
                var _this = this;
                Array.from(this.tunes.values()).forEach(function(t1) {
                    (t1.isInternal ? _this.defaultTunesInstances : _this.tunesInstances).set(t1.name, t1.create(e[t1.name], _this.blockAPI));
                }), Object.entries(e).forEach(function(param) {
                    var _param = (0, $f9AOD._)(param, 2), t1 = _param[0], o = _param[1];
                    _this.tunesInstances.has(t1) || (_this.unavailableTunesData[t1] = o);
                });
            }
        },
        {
            /**
   * Adds focus event listeners to all inputs and contenteditable
   */ key: "addInputEvents",
            value: function addInputEvents() {
                var _this = this;
                this.inputs.forEach(function(e) {
                    e.addEventListener("focus", _this.handleFocus), $5bdbe1ebf6713620$var$u.isNativeInput(e) && e.addEventListener("input", _this.didMutated);
                });
            }
        },
        {
            /**
   * removes focus event listeners from all inputs and contenteditable
   */ key: "removeInputEvents",
            value: function removeInputEvents() {
                var _this = this;
                this.inputs.forEach(function(e) {
                    e.removeEventListener("focus", _this.handleFocus), $5bdbe1ebf6713620$var$u.isNativeInput(e) && e.removeEventListener("input", _this.didMutated);
                });
            }
        },
        {
            /**
   * Listen common editor Dom Changed event and detect mutations related to the  Block
   */ key: "watchBlockMutations",
            value: function watchBlockMutations() {
                var _this = this;
                var e;
                this.redactorDomChangedCallback = function(t1) {
                    var o = t1.mutations;
                    o.some(function(s) {
                        return $5bdbe1ebf6713620$var$pi(s, _this.toolRenderedElement);
                    }) && _this.didMutated(o);
                }, (e = this.editorEventBus) == null || e.on($5bdbe1ebf6713620$var$ft, this.redactorDomChangedCallback);
            }
        },
        {
            /**
   * Remove redactor dom change event listener
   */ key: "unwatchBlockMutations",
            value: function unwatchBlockMutations() {
                var e;
                (e = this.editorEventBus) == null || e.off($5bdbe1ebf6713620$var$ft, this.redactorDomChangedCallback);
            }
        },
        {
            /**
   * Sometimes Tool can replace own main element, for example H2 -> H4 or UL -> OL
   * We need to detect such changes and update a link to tools main element with the new one
   *
   * @param mutations - records of block content mutations
   */ key: "detectToolRootChange",
            value: function detectToolRootChange(e) {
                var _this = this;
                e.forEach(function(t1) {
                    if (Array.from(t1.removedNodes).includes(_this.toolRenderedElement)) {
                        var i = t1.addedNodes[t1.addedNodes.length - 1];
                        _this.toolRenderedElement = i;
                    }
                });
            }
        },
        {
            /**
   * Clears inputs cached value
   */ key: "dropInputsCache",
            value: function dropInputsCache() {
                this.cachedInputs = [];
            }
        },
        {
            /**
   * Mark inputs with 'data-empty' attribute with the empty state
   */ key: "toggleInputsEmptyMark",
            value: function toggleInputsEmptyMark() {
                this.inputs.forEach($5bdbe1ebf6713620$var$Do);
            }
        }
    ], [
        {
            key: "CSS",
            get: /**
   * CSS classes for the Block
   *
   * @returns {{wrapper: string, content: string}}
   */ function get() {
                return {
                    wrapper: "ce-block",
                    wrapperStretched: "ce-block--stretched",
                    content: "ce-block__content",
                    selected: "ce-block--selected",
                    dropTarget: "ce-block--drop-target"
                };
            }
        }
    ]);
    return R;
}($5bdbe1ebf6713620$var$Oe);
var $5bdbe1ebf6713620$var$gi = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(gi, E);
    function gi() {
        (0, $173N4._)(this, gi);
        var _this;
        var _this1, _arguments = arguments;
        _this = (0, $7qXGD._)(this, gi, (0, $aUGqu._)(_arguments)), _this1 = _this, _this1.insert = function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _this1.config.defaultBlock, t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = arguments.length > 3 ? arguments[3] : void 0, s = arguments.length > 4 ? arguments[4] : void 0, r = arguments.length > 5 ? arguments[5] : void 0, a = arguments.length > 6 ? arguments[6] : void 0;
            var l = _this1.Editor.BlockManager.insert({
                id: a,
                tool: e,
                data: t1,
                index: i,
                needToFocus: s,
                replace: r
            });
            return new $5bdbe1ebf6713620$var$J(l);
        }, _this1.composeBlockData = function(e) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var t1;
                return (0, $13u2V._)(this, function(_state) {
                    t1 = _this1.Editor.Tools.blockTools.get(e);
                    return [
                        2,
                        new $5bdbe1ebf6713620$var$R({
                            tool: t1,
                            api: _this1.Editor.API,
                            readOnly: !0,
                            data: {},
                            tunesData: {}
                        }).data
                    ];
                });
            })();
        }, _this1.update = function(e, t1, o) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var _this_Editor, i, s, r;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this_Editor = _this1.Editor, i = _this_Editor.BlockManager, s = i.getBlockById(e);
                            if (s === void 0) throw new Error('Block with id "'.concat(e, '" not found'));
                            return [
                                4,
                                i.update(s, t1, o)
                            ];
                        case 1:
                            r = _state.sent();
                            return [
                                2,
                                new $5bdbe1ebf6713620$var$J(r)
                            ];
                    }
                });
            })();
        }, _this1.convert = function(e, t1, o) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var h, p, _this_Editor, i, s, r, a, l, c, d, g, g1;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this_Editor = _this1.Editor, i = _this_Editor.BlockManager, s = _this_Editor.Tools, r = i.getBlockById(e);
                            if (!r) throw new Error('Block with id "'.concat(e, '" not found'));
                            a = s.blockTools.get(r.name), l = s.blockTools.get(t1);
                            if (!l) throw new Error('Block Tool with type "'.concat(t1, '" not found'));
                            c = ((h = a == null ? void 0 : a.conversionConfig) == null ? void 0 : h.export) !== void 0, d = ((p = l.conversionConfig) == null ? void 0 : p.import) !== void 0;
                            if (!(c && d)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                i.convert(r, t1, o)
                            ];
                        case 1:
                            g = _state.sent();
                            return [
                                2,
                                new $5bdbe1ebf6713620$var$J(g)
                            ];
                        case 2:
                            g1 = [
                                c ? !1 : $5bdbe1ebf6713620$var$je(r.name),
                                d ? !1 : $5bdbe1ebf6713620$var$je(t1)
                            ].filter(Boolean).join(" and ");
                            throw new Error('Conversion from "'.concat(r.name, '" to "').concat(t1, '" is not possible. ').concat(g1, ' tool(s) should provide a "conversionConfig"'));
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        }, _this1.insertMany = function(e) {
            var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _this1.Editor.BlockManager.blocks.length - 1;
            _this1.validateIndex(t1);
            var o = e.map(function(param) {
                var i = param.id, s = param.type, r = param.data;
                return _this1.Editor.BlockManager.composeBlock({
                    id: i,
                    tool: s || _this1.config.defaultBlock,
                    data: r
                });
            });
            return _this1.Editor.BlockManager.insertMany(o, t1), o.map(function(i) {
                return new $5bdbe1ebf6713620$var$J(i);
            });
        };
        return _this;
    }
    (0, $cFHGC._)(gi, [
        {
            key: "methods",
            get: /**
   * Available methods
   *
   * @returns {Blocks}
   */ function get() {
                var _this = this;
                var _this1 = this;
                return {
                    clear: function() {
                        return _this.clear();
                    },
                    render: function(e) {
                        return _this.render(e);
                    },
                    renderFromHTML: function(e) {
                        return _this.renderFromHTML(e);
                    },
                    delete: function(e) {
                        return _this.delete(e);
                    },
                    swap: function(e, t1) {
                        return _this.swap(e, t1);
                    },
                    move: function(e, t1) {
                        return _this.move(e, t1);
                    },
                    getBlockByIndex: function(e) {
                        return _this.getBlockByIndex(e);
                    },
                    getById: function(e) {
                        return _this.getById(e);
                    },
                    getCurrentBlockIndex: function() {
                        return _this.getCurrentBlockIndex();
                    },
                    getBlockIndex: function(e) {
                        return _this.getBlockIndex(e);
                    },
                    getBlocksCount: function() {
                        return _this.getBlocksCount();
                    },
                    getBlockByElement: function(e) {
                        return _this.getBlockByElement(e);
                    },
                    stretchBlock: function(e) {
                        var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                        return _this1.stretchBlock(e, t1);
                    },
                    insertNewBlock: function() {
                        return _this.insertNewBlock();
                    },
                    insert: this.insert,
                    insertMany: this.insertMany,
                    update: this.update,
                    composeBlockData: this.composeBlockData,
                    convert: this.convert
                };
            }
        },
        {
            /**
   * Returns Blocks count
   *
   * @returns {number}
   */ key: "getBlocksCount",
            value: function getBlocksCount() {
                return this.Editor.BlockManager.blocks.length;
            }
        },
        {
            /**
   * Returns current block index
   *
   * @returns {number}
   */ key: "getCurrentBlockIndex",
            value: function getCurrentBlockIndex() {
                return this.Editor.BlockManager.currentBlockIndex;
            }
        },
        {
            /**
   * Returns the index of Block by id;
   *
   * @param id - block id
   */ key: "getBlockIndex",
            value: function getBlockIndex(e) {
                var t1 = this.Editor.BlockManager.getBlockById(e);
                if (!t1) {
                    $5bdbe1ebf6713620$var$X("There is no block with id `" + e + "`", "warn");
                    return;
                }
                return this.Editor.BlockManager.getBlockIndex(t1);
            }
        },
        {
            /**
   * Returns BlockAPI object by Block index
   *
   * @param {number} index - index to get
   */ key: "getBlockByIndex",
            value: function getBlockByIndex(e) {
                var t1 = this.Editor.BlockManager.getBlockByIndex(e);
                if (t1 === void 0) {
                    $5bdbe1ebf6713620$var$X("There is no block at index `" + e + "`", "warn");
                    return;
                }
                return new $5bdbe1ebf6713620$var$J(t1);
            }
        },
        {
            /**
   * Returns BlockAPI object by Block id
   *
   * @param id - id of block to get
   */ key: "getById",
            value: function getById(e) {
                var t1 = this.Editor.BlockManager.getBlockById(e);
                return t1 === void 0 ? ($5bdbe1ebf6713620$var$X("There is no block with id `" + e + "`", "warn"), null) : new $5bdbe1ebf6713620$var$J(t1);
            }
        },
        {
            /**
   * Get Block API object by any child html element
   *
   * @param element - html element to get Block by
   */ key: "getBlockByElement",
            value: function getBlockByElement(e) {
                var t1 = this.Editor.BlockManager.getBlock(e);
                if (t1 === void 0) {
                    $5bdbe1ebf6713620$var$X("There is no block corresponding to element `" + e + "`", "warn");
                    return;
                }
                return new $5bdbe1ebf6713620$var$J(t1);
            }
        },
        {
            /**
   * Call Block Manager method that swap Blocks
   *
   * @param {number} fromIndex - position of first Block
   * @param {number} toIndex - position of second Block
   * @deprecated — use 'move' instead
   */ key: "swap",
            value: function swap(e, t1) {
                $5bdbe1ebf6713620$var$S("`blocks.swap()` method is deprecated and will be removed in the next major release. Use `block.move()` method instead", "info"), this.Editor.BlockManager.swap(e, t1);
            }
        },
        {
            /**
   * Move block from one index to another
   *
   * @param {number} toIndex - index to move to
   * @param {number} fromIndex - index to move from
   */ key: "move",
            value: function move(e, t1) {
                this.Editor.BlockManager.move(e, t1);
            }
        },
        {
            /**
   * Deletes Block
   *
   * @param {number} blockIndex - index of Block to delete
   */ key: "delete",
            value: function _delete() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.Editor.BlockManager.currentBlockIndex;
                try {
                    var _$t = this.Editor.BlockManager.getBlockByIndex(e);
                    this.Editor.BlockManager.removeBlock(_$t);
                } catch (t1) {
                    $5bdbe1ebf6713620$var$X(t1, "warn");
                    return;
                }
                this.Editor.BlockManager.blocks.length === 0 && this.Editor.BlockManager.insert(), this.Editor.BlockManager.currentBlock && this.Editor.Caret.setToBlock(this.Editor.BlockManager.currentBlock, this.Editor.Caret.positions.END), this.Editor.Toolbar.close();
            }
        },
        {
            key: "clear",
            value: /**
   * Clear Editor's area
   */ function clear() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.Editor.BlockManager.clear(!0)
                                ];
                            case 1:
                                _state.sent(), this.Editor.InlineToolbar.close();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "render",
            value: /**
   * Fills Editor with Blocks data
   *
   * @param {OutputData} data — Saved Editor data
   */ function render(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (e === void 0 || e.blocks === void 0) throw new Error("Incorrect data passed to the render() method");
                                this.Editor.ModificationsObserver.disable();
                                return [
                                    4,
                                    this.Editor.BlockManager.clear()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this.Editor.Renderer.render(e.blocks)
                                ];
                            case 2:
                                _state.sent(), this.Editor.ModificationsObserver.enable();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "renderFromHTML",
            value: /**
   * Render passed HTML string
   *
   * @param {string} data - HTML string to render
   * @returns {Promise<void>}
   */ function renderFromHTML(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.Editor.BlockManager.clear()
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), this.Editor.Paste.processText(e, !0))
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Stretch Block's content
   *
   * @param {number} index - index of Block to stretch
   * @param {boolean} status - true to enable, false to disable
   * @deprecated Use BlockAPI interface to stretch Blocks
   */ key: "stretchBlock",
            value: function stretchBlock(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                $5bdbe1ebf6713620$var$ht(!0, "blocks.stretchBlock()", "BlockAPI");
                var o = this.Editor.BlockManager.getBlockByIndex(e);
                o && (o.stretched = t1);
            }
        },
        {
            /**
   * Insert new Block
   * After set caret to this Block
   *
   * @todo remove in 3.0.0
   * @deprecated with insert() method
   */ key: "insertNewBlock",
            value: function insertNewBlock() {
                $5bdbe1ebf6713620$var$S("Method blocks.insertNewBlock() is deprecated and it will be removed in the next major release. Use blocks.insert() instead.", "warn"), this.insert();
            }
        },
        {
            /**
   * Validated block index and throws an error if it's invalid
   *
   * @param index - index to validate
   */ key: "validateIndex",
            value: function validateIndex(e) {
                if (typeof e != "number") throw new Error("Index should be a number");
                if (e < 0) throw new Error("Index should be greater than or equal to 0");
                if (e === null) throw new Error("Index should be greater than or equal to 0");
            }
        }
    ]);
    return gi;
}($5bdbe1ebf6713620$var$E);
function $5bdbe1ebf6713620$var$mi(n, e) {
    return typeof n == "number" ? e.BlockManager.getBlockByIndex(n) : typeof n == "string" ? e.BlockManager.getBlockById(n) : e.BlockManager.getBlockById(n.id);
}
var $5bdbe1ebf6713620$var$bi = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(bi, E);
    function bi() {
        (0, $173N4._)(this, bi);
        var _this;
        _this = (0, $7qXGD._)(this, bi, arguments), _this.setToFirstBlock = function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _this.Editor.Caret.positions.DEFAULT, t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            return _this.Editor.BlockManager.firstBlock ? (_this.Editor.Caret.setToBlock(_this.Editor.BlockManager.firstBlock, e, t1), !0) : !1;
        }, _this.setToLastBlock = function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _this.Editor.Caret.positions.DEFAULT, t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            return _this.Editor.BlockManager.lastBlock ? (_this.Editor.Caret.setToBlock(_this.Editor.BlockManager.lastBlock, e, t1), !0) : !1;
        }, _this.setToPreviousBlock = function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _this.Editor.Caret.positions.DEFAULT, t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            return _this.Editor.BlockManager.previousBlock ? (_this.Editor.Caret.setToBlock(_this.Editor.BlockManager.previousBlock, e, t1), !0) : !1;
        }, _this.setToNextBlock = function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _this.Editor.Caret.positions.DEFAULT, t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            return _this.Editor.BlockManager.nextBlock ? (_this.Editor.Caret.setToBlock(_this.Editor.BlockManager.nextBlock, e, t1), !0) : !1;
        }, _this.setToBlock = function(e) {
            var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _this.Editor.Caret.positions.DEFAULT, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
            var i = $5bdbe1ebf6713620$var$mi(e, _this.Editor);
            return i === void 0 ? !1 : (_this.Editor.Caret.setToBlock(i, t1, o), !0);
        }, _this.focus = function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
            return e ? _this.setToLastBlock(_this.Editor.Caret.positions.END) : _this.setToFirstBlock(_this.Editor.Caret.positions.START);
        };
        return _this;
    }
    (0, $cFHGC._)(bi, [
        {
            key: "methods",
            get: /**
   * Available methods
   *
   * @returns {Caret}
   */ function get() {
                return {
                    setToFirstBlock: this.setToFirstBlock,
                    setToLastBlock: this.setToLastBlock,
                    setToPreviousBlock: this.setToPreviousBlock,
                    setToNextBlock: this.setToNextBlock,
                    setToBlock: this.setToBlock,
                    focus: this.focus
                };
            }
        }
    ]);
    return bi;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$vi = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(vi, E);
    function vi() {
        (0, $173N4._)(this, vi);
        return (0, $7qXGD._)(this, vi, arguments);
    }
    (0, $cFHGC._)(vi, [
        {
            key: "methods",
            get: /**
   * Available methods
   *
   * @returns {Events}
   */ function get() {
                var _this = this;
                return {
                    emit: function(e, t1) {
                        return _this.emit(e, t1);
                    },
                    off: function(e, t1) {
                        return _this.off(e, t1);
                    },
                    on: function(e, t1) {
                        return _this.on(e, t1);
                    }
                };
            }
        },
        {
            /**
   * Subscribe on Events
   *
   * @param {string} eventName - event name to subscribe
   * @param {Function} callback - event handler
   */ key: "on",
            value: function on(e, t1) {
                this.eventsDispatcher.on(e, t1);
            }
        },
        {
            /**
   * Emit event with data
   *
   * @param {string} eventName - event to emit
   * @param {object} data - event's data
   */ key: "emit",
            value: function emit(e, t1) {
                this.eventsDispatcher.emit(e, t1);
            }
        },
        {
            /**
   * Unsubscribe from Event
   *
   * @param {string} eventName - event to unsubscribe
   * @param {Function} callback - event handler
   */ key: "off",
            value: function off(e, t1) {
                this.eventsDispatcher.off(e, t1);
            }
        }
    ]);
    return vi;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$kt = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(kt, E);
    function kt() {
        (0, $173N4._)(this, kt);
        return (0, $7qXGD._)(this, kt, arguments);
    }
    (0, $cFHGC._)(kt, [
        {
            key: "methods",
            get: /**
   * Return I18n API methods with global dictionary access
   */ function get() {
                return {
                    t: function() {
                        $5bdbe1ebf6713620$var$X("I18n.t() method can be accessed only from Tools", "warn");
                    }
                };
            }
        },
        {
            /**
   * Return I18n API methods with tool namespaced dictionary
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ key: "getMethodsForTool",
            value: function getMethodsForTool(e, t1) {
                return Object.assign(this.methods, {
                    t: function(o) {
                        return $5bdbe1ebf6713620$var$z.t(kt.getNamespace(e, t1), o);
                    }
                });
            }
        }
    ], [
        {
            key: "getNamespace",
            value: /**
   * Return namespace section for tool or block tune
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ function getNamespace(e, t1) {
                return t1 ? "blockTunes.".concat(e) : "tools.".concat(e);
            }
        }
    ]);
    return kt;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$ki = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(ki, E);
    function ki() {
        (0, $173N4._)(this, ki);
        return (0, $7qXGD._)(this, ki, arguments);
    }
    (0, $cFHGC._)(ki, [
        {
            key: "methods",
            get: /**
   * Editor.js Core API modules
   */ function get() {
                return {
                    blocks: this.Editor.BlocksAPI.methods,
                    caret: this.Editor.CaretAPI.methods,
                    tools: this.Editor.ToolsAPI.methods,
                    events: this.Editor.EventsAPI.methods,
                    listeners: this.Editor.ListenersAPI.methods,
                    notifier: this.Editor.NotifierAPI.methods,
                    sanitizer: this.Editor.SanitizerAPI.methods,
                    saver: this.Editor.SaverAPI.methods,
                    selection: this.Editor.SelectionAPI.methods,
                    styles: this.Editor.StylesAPI.classes,
                    toolbar: this.Editor.ToolbarAPI.methods,
                    inlineToolbar: this.Editor.InlineToolbarAPI.methods,
                    tooltip: this.Editor.TooltipAPI.methods,
                    i18n: this.Editor.I18nAPI.methods,
                    readOnly: this.Editor.ReadOnlyAPI.methods,
                    ui: this.Editor.UiAPI.methods
                };
            }
        },
        {
            /**
   * Returns Editor.js Core API methods for passed tool
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ key: "getMethodsForTool",
            value: function getMethodsForTool(e, t1) {
                return Object.assign(this.methods, {
                    i18n: this.Editor.I18nAPI.getMethodsForTool(e, t1)
                });
            }
        }
    ]);
    return ki;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$yi = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(yi, E);
    function yi() {
        (0, $173N4._)(this, yi);
        return (0, $7qXGD._)(this, yi, arguments);
    }
    (0, $cFHGC._)(yi, [
        {
            key: "methods",
            get: /**
   * Available methods
   *
   * @returns {InlineToolbar}
   */ function get() {
                var _this = this;
                return {
                    close: function() {
                        return _this.close();
                    },
                    open: function() {
                        return _this.open();
                    }
                };
            }
        },
        {
            /**
   * Open Inline Toolbar
   */ key: "open",
            value: function open() {
                this.Editor.InlineToolbar.tryToShow();
            }
        },
        {
            /**
   * Close Inline Toolbar
   */ key: "close",
            value: function close() {
                this.Editor.InlineToolbar.close();
            }
        }
    ]);
    return yi;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$wi = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(wi, E);
    function wi() {
        (0, $173N4._)(this, wi);
        return (0, $7qXGD._)(this, wi, arguments);
    }
    (0, $cFHGC._)(wi, [
        {
            key: "methods",
            get: /**
   * Available methods
   *
   * @returns {Listeners}
   */ function get() {
                var _this = this;
                return {
                    on: function(e, t1, o, i) {
                        return _this.on(e, t1, o, i);
                    },
                    off: function(e, t1, o, i) {
                        return _this.off(e, t1, o, i);
                    },
                    offById: function(e) {
                        return _this.offById(e);
                    }
                };
            }
        },
        {
            /**
   * Ads a DOM event listener. Return it's id.
   *
   * @param {HTMLElement} element - Element to set handler to
   * @param {string} eventType - event type
   * @param {() => void} handler - event handler
   * @param {boolean} useCapture - capture event or not
   */ key: "on",
            value: function on(e, t1, o, i) {
                return this.listeners.on(e, t1, o, i);
            }
        },
        {
            /**
   * Removes DOM listener from element
   *
   * @param {Element} element - Element to remove handler from
   * @param eventType - event type
   * @param handler - event handler
   * @param {boolean} useCapture - capture event or not
   */ key: "off",
            value: function off(e, t1, o, i) {
                this.listeners.off(e, t1, o, i);
            }
        },
        {
            /**
   * Removes DOM listener by the listener id
   *
   * @param id - id of the listener to remove
   */ key: "offById",
            value: function offById(e) {
                this.listeners.offById(e);
            }
        }
    ]);
    return wi;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$Ko = {
    exports: {}
};
(function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                (typeof Symbol === "undefined" ? "undefined" : (0, $7E0eS._)(Symbol)) < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && (typeof s === "undefined" ? "undefined" : (0, $7E0eS._)(s)) == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function r() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "/", i(i.s = 0);
        }([
            function(t1, o, i) {
                i(1), /*!
       * Codex JavaScript Notification module
       * https://github.com/codex-team/js-notifier
       */ t1.exports = function() {
                    var s = i(6), r = "cdx-notify--bounce-in", a = null;
                    return {
                        show: function show(l) {
                            if (l.message) {
                                (function() {
                                    if (a) return !0;
                                    a = s.getWrapper(), document.body.appendChild(a);
                                })();
                                var c = null, d = l.time || 8e3;
                                switch(l.type){
                                    case "confirm":
                                        c = s.confirm(l);
                                        break;
                                    case "prompt":
                                        c = s.prompt(l);
                                        break;
                                    default:
                                        c = s.alert(l), window.setTimeout(function() {
                                            c.remove();
                                        }, d);
                                }
                                a.appendChild(c), c.classList.add(r);
                            }
                        }
                    };
                }();
            },
            function(t1, o, i) {
                var s = i(2);
                typeof s == "string" && (s = [
                    [
                        t1.i,
                        s,
                        ""
                    ]
                ]);
                var r = {
                    hmr: !0,
                    transform: void 0,
                    insertInto: void 0
                };
                i(4)(s, r), s.locals && (t1.exports = s.locals);
            },
            function(t1, o, i) {
                (t1.exports = i(3)(!1)).push([
                    t1.i,
                    '.cdx-notify--error{background:#fffbfb!important}.cdx-notify--error::before{background:#fb5d5d!important}.cdx-notify__input{max-width:130px;padding:5px 10px;background:#f7f7f7;border:0;border-radius:3px;font-size:13px;color:#656b7c;outline:0}.cdx-notify__input:-ms-input-placeholder{color:#656b7c}.cdx-notify__input::placeholder{color:#656b7c}.cdx-notify__input:focus:-ms-input-placeholder{color:rgba(101,107,124,.3)}.cdx-notify__input:focus::placeholder{color:rgba(101,107,124,.3)}.cdx-notify__button{border:none;border-radius:3px;font-size:13px;padding:5px 10px;cursor:pointer}.cdx-notify__button:last-child{margin-left:10px}.cdx-notify__button--cancel{background:#f2f5f7;box-shadow:0 2px 1px 0 rgba(16,19,29,0);color:#656b7c}.cdx-notify__button--cancel:hover{background:#eee}.cdx-notify__button--confirm{background:#34c992;box-shadow:0 1px 1px 0 rgba(18,49,35,.05);color:#fff}.cdx-notify__button--confirm:hover{background:#33b082}.cdx-notify__btns-wrapper{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;margin-top:5px}.cdx-notify__cross{position:absolute;top:5px;right:5px;width:10px;height:10px;padding:5px;opacity:.54;cursor:pointer}.cdx-notify__cross::after,.cdx-notify__cross::before{content:\'\';position:absolute;left:9px;top:5px;height:12px;width:2px;background:#575d67}.cdx-notify__cross::before{transform:rotate(-45deg)}.cdx-notify__cross::after{transform:rotate(45deg)}.cdx-notify__cross:hover{opacity:1}.cdx-notifies{position:fixed;z-index:2;bottom:20px;left:20px;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif}.cdx-notify{position:relative;width:220px;margin-top:15px;padding:13px 16px;background:#fff;box-shadow:0 11px 17px 0 rgba(23,32,61,.13);border-radius:5px;font-size:14px;line-height:1.4em;word-wrap:break-word}.cdx-notify::before{content:\'\';position:absolute;display:block;top:0;left:0;width:3px;height:calc(100% - 6px);margin:3px;border-radius:5px;background:0 0}@keyframes bounceIn{0%{opacity:0;transform:scale(.3)}50%{opacity:1;transform:scale(1.05)}70%{transform:scale(.9)}100%{transform:scale(1)}}.cdx-notify--bounce-in{animation-name:bounceIn;animation-duration:.6s;animation-iteration-count:1}.cdx-notify--success{background:#fafffe!important}.cdx-notify--success::before{background:#41ffb1!important}',
                    ""
                ]);
            },
            function(t1, o) {
                t1.exports = function(i) {
                    var s = [];
                    return s.toString = function() {
                        return this.map(function(r) {
                            var a = function(l, c) {
                                var d = l[1] || "", h = l[3];
                                if (!h) return d;
                                if (c && typeof btoa == "function") {
                                    var p = (f = h, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(f)))) + " */"), g = h.sources.map(function(v) {
                                        return "/*# sourceURL=" + h.sourceRoot + v + " */";
                                    });
                                    return [
                                        d
                                    ].concat(g).concat([
                                        p
                                    ]).join("\n");
                                }
                                var f;
                                return [
                                    d
                                ].join("\n");
                            }(r, i);
                            return r[2] ? "@media " + r[2] + "{" + a + "}" : a;
                        }).join("");
                    }, s.i = function(r, a) {
                        typeof r == "string" && (r = [
                            [
                                null,
                                r,
                                ""
                            ]
                        ]);
                        for(var l = {}, c = 0; c < this.length; c++){
                            var d = this[c][0];
                            typeof d == "number" && (l[d] = !0);
                        }
                        for(c = 0; c < r.length; c++){
                            var h = r[c];
                            typeof h[0] == "number" && l[h[0]] || (a && !h[2] ? h[2] = a : a && (h[2] = "(" + h[2] + ") and (" + a + ")"), s.push(h));
                        }
                    }, s;
                };
            },
            function(t1, o, i) {
                var s, r, a = {}, l = (s = function s() {
                    return window && document && document.all && !window.atob;
                }, function l() {
                    return r === void 0 && (r = s.apply(this, arguments)), r;
                }), c = function(k) {
                    var m = {};
                    return function(w) {
                        if (typeof w == "function") return w();
                        if (m[w] === void 0) {
                            var x = (function(I) {
                                return document.querySelector(I);
                            }).call(this, w);
                            if (window.HTMLIFrameElement && x instanceof window.HTMLIFrameElement) try {
                                x = x.contentDocument.head;
                            } catch (e) {
                                x = null;
                            }
                            m[w] = x;
                        }
                        return m[w];
                    };
                }(), d = null, h = 0, p = [], g = i(5);
                function f(k, m) {
                    for(var w = 0; w < k.length; w++){
                        var x = k[w], I = a[x.id];
                        if (I) {
                            I.refs++;
                            for(var C = 0; C < I.parts.length; C++)I.parts[C](x.parts[C]);
                            for(; C < x.parts.length; C++)I.parts.push(F(x.parts[C], m));
                        } else {
                            var N = [];
                            for(C = 0; C < x.parts.length; C++)N.push(F(x.parts[C], m));
                            a[x.id] = {
                                id: x.id,
                                refs: 1,
                                parts: N
                            };
                        }
                    }
                }
                function v(k, m) {
                    for(var w = [], x = {}, I = 0; I < k.length; I++){
                        var C = k[I], N = m.base ? C[0] + m.base : C[0], B = {
                            css: C[1],
                            media: C[2],
                            sourceMap: C[3]
                        };
                        x[N] ? x[N].parts.push(B) : w.push(x[N] = {
                            id: N,
                            parts: [
                                B
                            ]
                        });
                    }
                    return w;
                }
                function O(k, m) {
                    var w = c(k.insertInto);
                    if (!w) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
                    var x = p[p.length - 1];
                    if (k.insertAt === "top") x ? x.nextSibling ? w.insertBefore(m, x.nextSibling) : w.appendChild(m) : w.insertBefore(m, w.firstChild), p.push(m);
                    else if (k.insertAt === "bottom") w.appendChild(m);
                    else {
                        if ((0, $7E0eS._)(k.insertAt) != "object" || !k.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
                        var I = c(k.insertInto + " " + k.insertAt.before);
                        w.insertBefore(m, I);
                    }
                }
                function T(k) {
                    if (k.parentNode === null) return !1;
                    k.parentNode.removeChild(k);
                    var m = p.indexOf(k);
                    m >= 0 && p.splice(m, 1);
                }
                function M(k) {
                    var m = document.createElement("style");
                    return k.attrs.type === void 0 && (k.attrs.type = "text/css"), q(m, k.attrs), O(k, m), m;
                }
                function q(k, m) {
                    Object.keys(m).forEach(function(w) {
                        k.setAttribute(w, m[w]);
                    });
                }
                function F(k, m) {
                    var w, x, I, C;
                    if (m.transform && k.css) {
                        if (!(C = m.transform(k.css))) return function() {};
                        k.css = C;
                    }
                    if (m.singleton) {
                        var N = h++;
                        w = d || (d = M(m)), x = ie.bind(null, w, N, !1), I = ie.bind(null, w, N, !0);
                    } else k.sourceMap && typeof URL == "function" && typeof URL.createObjectURL == "function" && typeof URL.revokeObjectURL == "function" && typeof Blob == "function" && typeof btoa == "function" ? (w = function(B) {
                        var W = document.createElement("link");
                        return B.attrs.type === void 0 && (B.attrs.type = "text/css"), B.attrs.rel = "stylesheet", q(W, B.attrs), O(B, W), W;
                    }(m), x = (function(B, W, ve) {
                        var se = ve.css, tt = ve.sourceMap, Yn = W.convertToAbsoluteUrls === void 0 && tt;
                        (W.convertToAbsoluteUrls || Yn) && (se = g(se)), tt && (se += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(tt)))) + " */");
                        var Kn = new Blob([
                            se
                        ], {
                            type: "text/css"
                        }), ko = B.href;
                        B.href = URL.createObjectURL(Kn), ko && URL.revokeObjectURL(ko);
                    }).bind(null, w, m), I = function I() {
                        T(w), w.href && URL.revokeObjectURL(w.href);
                    }) : (w = M(m), x = (function(B, W) {
                        var ve = W.css, se = W.media;
                        if (se && B.setAttribute("media", se), B.styleSheet) B.styleSheet.cssText = ve;
                        else {
                            for(; B.firstChild;)B.removeChild(B.firstChild);
                            B.appendChild(document.createTextNode(ve));
                        }
                    }).bind(null, w), I = function I() {
                        T(w);
                    });
                    return x(k), function(B) {
                        if (B) {
                            if (B.css === k.css && B.media === k.media && B.sourceMap === k.sourceMap) return;
                            x(k = B);
                        } else I();
                    };
                }
                t1.exports = function(k, m) {
                    if ((typeof DEBUG === "undefined" ? "undefined" : (0, $7E0eS._)(DEBUG)) < "u" && DEBUG && (typeof document === "undefined" ? "undefined" : (0, $7E0eS._)(document)) != "object") throw new Error("The style-loader cannot be used in a non-browser environment");
                    (m = m || {}).attrs = (0, $7E0eS._)(m.attrs) == "object" ? m.attrs : {}, m.singleton || typeof m.singleton == "boolean" || (m.singleton = l()), m.insertInto || (m.insertInto = "head"), m.insertAt || (m.insertAt = "bottom");
                    var w = v(k, m);
                    return f(w, m), function(x) {
                        for(var I = [], C = 0; C < w.length; C++){
                            var N = w[C];
                            (B = a[N.id]).refs--, I.push(B);
                        }
                        for(x && f(v(x, m), m), C = 0; C < I.length; C++){
                            var B;
                            if ((B = I[C]).refs === 0) {
                                for(var W = 0; W < B.parts.length; W++)B.parts[W]();
                                delete a[B.id];
                            }
                        }
                    };
                };
                var H, Q = (H = [], function Q(k, m) {
                    return H[k] = m, H.filter(Boolean).join("\n");
                });
                function ie(k, m, w, x) {
                    var I = w ? "" : x.css;
                    if (k.styleSheet) k.styleSheet.cssText = Q(m, I);
                    else {
                        var C = document.createTextNode(I), N = k.childNodes;
                        N[m] && k.removeChild(N[m]), N.length ? k.insertBefore(C, N[m]) : k.appendChild(C);
                    }
                }
            },
            function(t1, o) {
                t1.exports = function(i) {
                    var s = (typeof window === "undefined" ? "undefined" : (0, $7E0eS._)(window)) < "u" && window.location;
                    if (!s) throw new Error("fixUrls requires window.location");
                    if (!i || typeof i != "string") return i;
                    var r = s.protocol + "//" + s.host, a = r + s.pathname.replace(/\/[^\/]*$/, "/");
                    return i.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(l, c) {
                        var d, h = c.trim().replace(/^"(.*)"$/, function(p, g) {
                            return g;
                        }).replace(/^'(.*)'$/, function(p, g) {
                            return g;
                        });
                        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(h) ? l : (d = h.indexOf("//") === 0 ? h : h.indexOf("/") === 0 ? r + h : a + h.replace(/^\.\//, ""), "url(" + JSON.stringify(d) + ")");
                    });
                };
            },
            function(t1, o, i) {
                var s, r, a, l, c, d, h, p, g;
                t1.exports = (s = "cdx-notifies", r = "cdx-notify", a = "cdx-notify__cross", l = "cdx-notify__button--confirm", c = "cdx-notify__button--cancel", d = "cdx-notify__input", h = "cdx-notify__button", p = "cdx-notify__btns-wrapper", {
                    alert: g = function g(f) {
                        var v = document.createElement("DIV"), O = document.createElement("DIV"), T = f.message, M = f.style;
                        return v.classList.add(r), M && v.classList.add(r + "--" + M), v.innerHTML = T, O.classList.add(a), O.addEventListener("click", v.remove.bind(v)), v.appendChild(O), v;
                    },
                    confirm: function confirm(f) {
                        var v = g(f), O = document.createElement("div"), T = document.createElement("button"), M = document.createElement("button"), q = v.querySelector("." + a), F = f.cancelHandler, H = f.okHandler;
                        return O.classList.add(p), T.innerHTML = f.okText || "Confirm", M.innerHTML = f.cancelText || "Cancel", T.classList.add(h), M.classList.add(h), T.classList.add(l), M.classList.add(c), F && typeof F == "function" && (M.addEventListener("click", F), q.addEventListener("click", F)), H && typeof H == "function" && T.addEventListener("click", H), T.addEventListener("click", v.remove.bind(v)), M.addEventListener("click", v.remove.bind(v)), O.appendChild(T), O.appendChild(M), v.appendChild(O), v;
                    },
                    prompt: function prompt(f) {
                        var v = g(f), O = document.createElement("div"), T = document.createElement("button"), M = document.createElement("input"), q = v.querySelector("." + a), F = f.cancelHandler, H = f.okHandler;
                        return O.classList.add(p), T.innerHTML = f.okText || "Ok", T.classList.add(h), T.classList.add(l), M.classList.add(d), f.placeholder && M.setAttribute("placeholder", f.placeholder), f.default && (M.value = f.default), f.inputType && (M.type = f.inputType), F && typeof F == "function" && q.addEventListener("click", F), H && typeof H == "function" && T.addEventListener("click", function() {
                            H(M.value);
                        }), T.addEventListener("click", v.remove.bind(v)), O.appendChild(M), O.appendChild(T), v.appendChild(O), v;
                    },
                    getWrapper: function getWrapper() {
                        var f = document.createElement("DIV");
                        return f.classList.add(s), f;
                    }
                });
            }
        ]);
    });
})($5bdbe1ebf6713620$var$Ko);
var $5bdbe1ebf6713620$var$Ei = $5bdbe1ebf6713620$var$Ko.exports;
var $5bdbe1ebf6713620$var$xi = /* @__PURE__ */ $5bdbe1ebf6713620$var$Ke($5bdbe1ebf6713620$var$Ei);
var $5bdbe1ebf6713620$var$Bi = /*#__PURE__*/ function() {
    "use strict";
    function Bi() {
        (0, $173N4._)(this, Bi);
    }
    (0, $cFHGC._)(Bi, [
        {
            /**
   * Show web notification
   *
   * @param {NotifierOptions | ConfirmNotifierOptions | PromptNotifierOptions} options - notification options
   */ key: "show",
            value: function show(e) {
                $5bdbe1ebf6713620$var$xi.show(e);
            }
        }
    ]);
    return Bi;
}();
var $5bdbe1ebf6713620$var$Ci = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(Ci, E);
    function Ci(param) {
        var e = param.config, t1 = param.eventsDispatcher;
        (0, $173N4._)(this, Ci);
        var _this;
        _this = (0, $7qXGD._)(this, Ci, [
            {
                config: e,
                eventsDispatcher: t1
            }
        ]), _this.notifier = new $5bdbe1ebf6713620$var$Bi();
        return _this;
    }
    (0, $cFHGC._)(Ci, [
        {
            key: "methods",
            get: /**
   * Available methods
   */ function get() {
                var _this = this;
                return {
                    show: function(e) {
                        return _this.show(e);
                    }
                };
            }
        },
        {
            /**
   * Show notification
   *
   * @param {NotifierOptions} options - message option
   */ key: "show",
            value: function show(e) {
                return this.notifier.show(e);
            }
        }
    ]);
    return Ci;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$Ti = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(Ti, E);
    function Ti() {
        (0, $173N4._)(this, Ti);
        return (0, $7qXGD._)(this, Ti, arguments);
    }
    (0, $cFHGC._)(Ti, [
        {
            key: "methods",
            get: /**
   * Available methods
   */ function get() {
                var _this = this;
                var e = function() {
                    return _this.isEnabled;
                };
                return {
                    toggle: function(t1) {
                        return _this.toggle(t1);
                    },
                    get isEnabled () {
                        return e();
                    }
                };
            }
        },
        {
            /**
   * Set or toggle read-only state
   *
   * @param {boolean|undefined} state - set or toggle state
   * @returns {boolean} current value
   */ key: "toggle",
            value: function toggle(e) {
                return this.Editor.ReadOnly.toggle(e);
            }
        },
        {
            key: "isEnabled",
            get: /**
   * Returns current read-only state
   */ function get() {
                return this.Editor.ReadOnly.isEnabled;
            }
        }
    ]);
    return Ti;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$Xo = {
    exports: {}
};
(function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })($5bdbe1ebf6713620$var$Ce, function() {
        function t1(h) {
            var p = h.tags, g = Object.keys(p), f = g.map(function(v) {
                return (0, $7E0eS._)(p[v]);
            }).every(function(v) {
                return v === "object" || v === "boolean" || v === "function";
            });
            if (!f) throw new Error("The configuration was invalid");
            this.config = h;
        }
        var o = [
            "P",
            "LI",
            "TD",
            "TH",
            "DIV",
            "H1",
            "H2",
            "H3",
            "H4",
            "H5",
            "H6",
            "PRE"
        ];
        function i(h) {
            return o.indexOf(h.nodeName) !== -1;
        }
        var s = [
            "A",
            "B",
            "STRONG",
            "I",
            "EM",
            "SUB",
            "SUP",
            "U",
            "STRIKE"
        ];
        function r(h) {
            return s.indexOf(h.nodeName) !== -1;
        }
        t1.prototype.clean = function(h) {
            var p = document.implementation.createHTMLDocument(), g = p.createElement("div");
            return g.innerHTML = h, this._sanitize(p, g), g.innerHTML;
        }, t1.prototype._sanitize = function(h, p) {
            var g = a(h, p), f = g.firstChild();
            if (f) do {
                if (f.nodeType === Node.TEXT_NODE) {
                    if (f.data.trim() === "" && (f.previousElementSibling && i(f.previousElementSibling) || f.nextElementSibling && i(f.nextElementSibling))) {
                        p.removeChild(f), this._sanitize(h, p);
                        break;
                    } else continue;
                }
                if (f.nodeType === Node.COMMENT_NODE) {
                    p.removeChild(f), this._sanitize(h, p);
                    break;
                }
                var v = r(f), O;
                v && (O = Array.prototype.some.call(f.childNodes, i));
                var T = !!p.parentNode, M = i(p) && i(f) && T, q = f.nodeName.toLowerCase(), F = l(this.config, q, f), H = v && O;
                if (H || c(f, F) || !this.config.keepNestedBlockElements && M) {
                    if (!(f.nodeName === "SCRIPT" || f.nodeName === "STYLE")) for(; f.childNodes.length > 0;)p.insertBefore(f.childNodes[0], f);
                    p.removeChild(f), this._sanitize(h, p);
                    break;
                }
                for(var Q = 0; Q < f.attributes.length; Q += 1){
                    var ie = f.attributes[Q];
                    d(ie, F, f) && (f.removeAttribute(ie.name), Q = Q - 1);
                }
                this._sanitize(h, f);
            }while (f = g.nextSibling());
        };
        function a(h, p) {
            return h.createTreeWalker(p, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT, null, !1);
        }
        function l(h, p, g) {
            return typeof h.tags[p] == "function" ? h.tags[p](g) : h.tags[p];
        }
        function c(h, p) {
            return (typeof p === "undefined" ? "undefined" : (0, $7E0eS._)(p)) > "u" ? !0 : typeof p == "boolean" ? !p : !1;
        }
        function d(h, p, g) {
            var f = h.name.toLowerCase();
            return p === !0 ? !1 : typeof p[f] == "function" ? !p[f](h.value, g) : (0, $7E0eS._)(p[f]) > "u" || p[f] === !1 ? !0 : typeof p[f] == "string" ? p[f] !== h.value : !1;
        }
        return t1;
    });
})($5bdbe1ebf6713620$var$Xo);
var $5bdbe1ebf6713620$var$Si = $5bdbe1ebf6713620$var$Xo.exports;
var $5bdbe1ebf6713620$var$Ii = /* @__PURE__ */ $5bdbe1ebf6713620$var$Ke($5bdbe1ebf6713620$var$Si);
function $5bdbe1ebf6713620$var$yt(n, e) {
    return n.map(function(t1) {
        var o = $5bdbe1ebf6713620$var$A(e) ? e(t1.tool) : e;
        return $5bdbe1ebf6713620$var$V(o) || (t1.data = $5bdbe1ebf6713620$var$wt(t1.data, o)), t1;
    });
}
function $5bdbe1ebf6713620$var$Z(n) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var t1 = {
        tags: e
    };
    return new $5bdbe1ebf6713620$var$Ii(t1).clean(n);
}
function $5bdbe1ebf6713620$var$wt(n, e) {
    return Array.isArray(n) ? $5bdbe1ebf6713620$var$Oi(n, e) : $5bdbe1ebf6713620$var$D(n) ? $5bdbe1ebf6713620$var$_i(n, e) : $5bdbe1ebf6713620$var$te(n) ? $5bdbe1ebf6713620$var$Mi(n, e) : n;
}
function $5bdbe1ebf6713620$var$Oi(n, e) {
    return n.map(function(t1) {
        return $5bdbe1ebf6713620$var$wt(t1, e);
    });
}
function $5bdbe1ebf6713620$var$_i(n, e) {
    var t1 = {};
    for(var o in n){
        if (!Object.prototype.hasOwnProperty.call(n, o)) continue;
        var i = n[o], s = $5bdbe1ebf6713620$var$Ai(e[o]) ? e[o] : e;
        t1[o] = $5bdbe1ebf6713620$var$wt(i, s);
    }
    return t1;
}
function $5bdbe1ebf6713620$var$Mi(n, e) {
    return $5bdbe1ebf6713620$var$D(e) ? $5bdbe1ebf6713620$var$Z(n, e) : e === !1 ? $5bdbe1ebf6713620$var$Z(n, {}) : n;
}
function $5bdbe1ebf6713620$var$Ai(n) {
    return $5bdbe1ebf6713620$var$D(n) || $5bdbe1ebf6713620$var$Gn(n) || $5bdbe1ebf6713620$var$A(n);
}
var $5bdbe1ebf6713620$var$Li = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(Li, E);
    function Li() {
        (0, $173N4._)(this, Li);
        return (0, $7qXGD._)(this, Li, arguments);
    }
    (0, $cFHGC._)(Li, [
        {
            key: "methods",
            get: /**
   * Available methods
   *
   * @returns {SanitizerConfig}
   */ function get() {
                var _this = this;
                return {
                    clean: function(e, t1) {
                        return _this.clean(e, t1);
                    }
                };
            }
        },
        {
            /**
   * Perform sanitizing of a string
   *
   * @param {string} taintString - what to sanitize
   * @param {SanitizerConfig} config - sanitizer config
   * @returns {string}
   */ key: "clean",
            value: function clean(e, t1) {
                return $5bdbe1ebf6713620$var$Z(e, t1);
            }
        }
    ]);
    return Li;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$Pi = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(Pi, E);
    function Pi() {
        (0, $173N4._)(this, Pi);
        return (0, $7qXGD._)(this, Pi, arguments);
    }
    (0, $cFHGC._)(Pi, [
        {
            key: "methods",
            get: /**
   * Available methods
   *
   * @returns {Saver}
   */ function get() {
                var _this = this;
                return {
                    save: function() {
                        return _this.save();
                    }
                };
            }
        },
        {
            /**
   * Return Editor's data
   *
   * @returns {OutputData}
   */ key: "save",
            value: function save() {
                var e = "Editor's content can not be saved in read-only mode";
                return this.Editor.ReadOnly.isEnabled ? ($5bdbe1ebf6713620$var$X(e, "warn"), Promise.reject(new Error(e))) : this.Editor.Saver.save();
            }
        }
    ]);
    return Pi;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$Ni = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(Ni, E);
    function Ni() {
        (0, $173N4._)(this, Ni);
        var _this;
        _this = (0, $7qXGD._)(this, Ni, arguments), _this.selectionUtils = new $5bdbe1ebf6713620$var$b();
        return _this;
    }
    (0, $cFHGC._)(Ni, [
        {
            key: "methods",
            get: /**
   * Available methods
   *
   * @returns {SelectionAPIInterface}
   */ function get() {
                var _this = this;
                return {
                    findParentTag: function(e, t1) {
                        return _this.findParentTag(e, t1);
                    },
                    expandToTag: function(e) {
                        return _this.expandToTag(e);
                    },
                    save: function() {
                        return _this.selectionUtils.save();
                    },
                    restore: function() {
                        return _this.selectionUtils.restore();
                    },
                    setFakeBackground: function() {
                        return _this.selectionUtils.setFakeBackground();
                    },
                    removeFakeBackground: function() {
                        return _this.selectionUtils.removeFakeBackground();
                    }
                };
            }
        },
        {
            /**
   * Looks ahead from selection and find passed tag with class name
   *
   * @param {string} tagName - tag to find
   * @param {string} className - tag's class name
   * @returns {HTMLElement|null}
   */ key: "findParentTag",
            value: function findParentTag(e, t1) {
                return this.selectionUtils.findParentTag(e, t1);
            }
        },
        {
            /**
   * Expand selection to passed tag
   *
   * @param {HTMLElement} node - tag that should contain selection
   */ key: "expandToTag",
            value: function expandToTag(e) {
                this.selectionUtils.expandToTag(e);
            }
        }
    ]);
    return Ni;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$Ri = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(Ri, E);
    function Ri() {
        (0, $173N4._)(this, Ri);
        return (0, $7qXGD._)(this, Ri, arguments);
    }
    (0, $cFHGC._)(Ri, [
        {
            key: "methods",
            get: /**
   * Available methods
   */ function get() {
                var _this = this;
                return {
                    getBlockTools: function() {
                        return Array.from(_this.Editor.Tools.blockTools.values());
                    }
                };
            }
        }
    ]);
    return Ri;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$Di = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(Di, E);
    function Di() {
        (0, $173N4._)(this, Di);
        return (0, $7qXGD._)(this, Di, arguments);
    }
    (0, $cFHGC._)(Di, [
        {
            key: "classes",
            get: /**
   * Exported classes
   */ function get() {
                return {
                    /**
       * Base Block styles
       */ block: "cdx-block",
                    /**
       * Inline Tools styles
       */ inlineToolButton: "ce-inline-tool",
                    inlineToolButtonActive: "ce-inline-tool--active",
                    /**
       * UI elements
       */ input: "cdx-input",
                    loader: "cdx-loader",
                    button: "cdx-button",
                    /**
       * Settings styles
       */ settingsButton: "cdx-settings-button",
                    settingsButtonActive: "cdx-settings-button--active"
                };
            }
        }
    ]);
    return Di;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$Fi = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(Fi, E);
    function Fi() {
        (0, $173N4._)(this, Fi);
        return (0, $7qXGD._)(this, Fi, arguments);
    }
    (0, $cFHGC._)(Fi, [
        {
            key: "methods",
            get: /**
   * Available methods
   *
   * @returns {Toolbar}
   */ function get() {
                var _this = this;
                return {
                    close: function() {
                        return _this.close();
                    },
                    open: function() {
                        return _this.open();
                    },
                    toggleBlockSettings: function(e) {
                        return _this.toggleBlockSettings(e);
                    },
                    toggleToolbox: function(e) {
                        return _this.toggleToolbox(e);
                    }
                };
            }
        },
        {
            /**
   * Open toolbar
   */ key: "open",
            value: function open() {
                this.Editor.Toolbar.moveAndOpen();
            }
        },
        {
            /**
   * Close toolbar and all included elements
   */ key: "close",
            value: function close() {
                this.Editor.Toolbar.close();
            }
        },
        {
            /**
   * Toggles Block Setting of the current block
   *
   * @param {boolean} openingState —  opening state of Block Setting
   */ key: "toggleBlockSettings",
            value: function toggleBlockSettings(e) {
                if (this.Editor.BlockManager.currentBlockIndex === -1) {
                    $5bdbe1ebf6713620$var$X("Could't toggle the Toolbar because there is no block selected ", "warn");
                    return;
                }
                (e !== null && e !== void 0 ? e : !this.Editor.BlockSettings.opened) ? (this.Editor.Toolbar.moveAndOpen(), this.Editor.BlockSettings.open()) : this.Editor.BlockSettings.close();
            }
        },
        {
            /**
   * Open toolbox
   *
   * @param {boolean} openingState - Opening state of toolbox
   */ key: "toggleToolbox",
            value: function toggleToolbox(e) {
                if (this.Editor.BlockManager.currentBlockIndex === -1) {
                    $5bdbe1ebf6713620$var$X("Could't toggle the Toolbox because there is no block selected ", "warn");
                    return;
                }
                (e !== null && e !== void 0 ? e : !this.Editor.Toolbar.toolbox.opened) ? (this.Editor.Toolbar.moveAndOpen(), this.Editor.Toolbar.toolbox.open()) : this.Editor.Toolbar.toolbox.close();
            }
        }
    ]);
    return Fi;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$Vo = {
    exports: {}
};
/*!
 * CodeX.Tooltips
 * 
 * @version 1.0.5
 * 
 * @licence MIT
 * @author CodeX <https://codex.so>
 * 
 * 
 */ (function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                (typeof Symbol === "undefined" ? "undefined" : (0, $7E0eS._)(Symbol)) < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && (typeof s === "undefined" ? "undefined" : (0, $7E0eS._)(s)) == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function r() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "", i(i.s = 0);
        }([
            function(t1, o, i) {
                t1.exports = i(1);
            },
            function(t1, o, i) {
                i.r(o), i.d(o, "default", function() {
                    return s;
                });
                var s = /*#__PURE__*/ function() {
                    "use strict";
                    function s() {
                        var _this = this;
                        (0, $173N4._)(this, s);
                        this.nodes = {
                            wrapper: null,
                            content: null
                        }, this.showed = !1, this.offsetTop = 10, this.offsetLeft = 10, this.offsetRight = 10, this.hidingDelay = 0, this.handleWindowScroll = function() {
                            _this.showed && _this.hide(!0);
                        }, this.loadStyles(), this.prepare(), window.addEventListener("scroll", this.handleWindowScroll, {
                            passive: !0
                        });
                    }
                    (0, $cFHGC._)(s, [
                        {
                            key: "CSS",
                            get: function get() {
                                return {
                                    tooltip: "ct",
                                    tooltipContent: "ct__content",
                                    tooltipShown: "ct--shown",
                                    placement: {
                                        left: "ct--left",
                                        bottom: "ct--bottom",
                                        right: "ct--right",
                                        top: "ct--top"
                                    }
                                };
                            }
                        },
                        {
                            key: "show",
                            value: function show(a, l, c) {
                                var _this = this;
                                var _this_nodes_wrapper_classList;
                                this.nodes.wrapper || this.prepare(), this.hidingTimeout && clearTimeout(this.hidingTimeout);
                                var d = Object.assign({
                                    placement: "bottom",
                                    marginTop: 0,
                                    marginLeft: 0,
                                    marginRight: 0,
                                    marginBottom: 0,
                                    delay: 70,
                                    hidingDelay: 0
                                }, c);
                                if (d.hidingDelay && (this.hidingDelay = d.hidingDelay), this.nodes.content.innerHTML = "", typeof l == "string") this.nodes.content.appendChild(document.createTextNode(l));
                                else {
                                    if (!(l instanceof Node)) throw Error("[CodeX Tooltip] Wrong type of \xabcontent\xbb passed. It should be an instance of Node or String. But " + (typeof l === "undefined" ? "undefined" : (0, $7E0eS._)(l)) + " given.");
                                    this.nodes.content.appendChild(l);
                                }
                                switch((_this_nodes_wrapper_classList = this.nodes.wrapper.classList).remove.apply(_this_nodes_wrapper_classList, (0, $aUGqu._)(Object.values(this.CSS.placement))), d.placement){
                                    case "top":
                                        this.placeTop(a, d);
                                        break;
                                    case "left":
                                        this.placeLeft(a, d);
                                        break;
                                    case "right":
                                        this.placeRight(a, d);
                                        break;
                                    case "bottom":
                                    default:
                                        this.placeBottom(a, d);
                                }
                                d && d.delay ? this.showingTimeout = setTimeout(function() {
                                    _this.nodes.wrapper.classList.add(_this.CSS.tooltipShown), _this.showed = !0;
                                }, d.delay) : (this.nodes.wrapper.classList.add(this.CSS.tooltipShown), this.showed = !0);
                            }
                        },
                        {
                            key: "hide",
                            value: function hide() {
                                var _this = this;
                                var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                                if (this.hidingDelay && !a) return this.hidingTimeout && clearTimeout(this.hidingTimeout), void (this.hidingTimeout = setTimeout(function() {
                                    _this.hide(!0);
                                }, this.hidingDelay));
                                this.nodes.wrapper.classList.remove(this.CSS.tooltipShown), this.showed = !1, this.showingTimeout && clearTimeout(this.showingTimeout);
                            }
                        },
                        {
                            key: "onHover",
                            value: function onHover(a, l, c) {
                                var _this = this;
                                a.addEventListener("mouseenter", function() {
                                    _this.show(a, l, c);
                                }), a.addEventListener("mouseleave", function() {
                                    _this.hide();
                                });
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.nodes.wrapper.remove(), window.removeEventListener("scroll", this.handleWindowScroll);
                            }
                        },
                        {
                            key: "prepare",
                            value: function prepare() {
                                this.nodes.wrapper = this.make("div", this.CSS.tooltip), this.nodes.content = this.make("div", this.CSS.tooltipContent), this.append(this.nodes.wrapper, this.nodes.content), this.append(document.body, this.nodes.wrapper);
                            }
                        },
                        {
                            key: "loadStyles",
                            value: function loadStyles() {
                                var a = "codex-tooltips-style";
                                if (document.getElementById(a)) return;
                                var l = i(2), c = this.make("style", null, {
                                    textContent: l.toString(),
                                    id: a
                                });
                                this.prepend(document.head, c);
                            }
                        },
                        {
                            key: "placeBottom",
                            value: function placeBottom(a, l) {
                                var c = a.getBoundingClientRect(), d = c.left + a.clientWidth / 2 - this.nodes.wrapper.offsetWidth / 2, h = c.bottom + window.pageYOffset + this.offsetTop + l.marginTop;
                                this.applyPlacement("bottom", d, h);
                            }
                        },
                        {
                            key: "placeTop",
                            value: function placeTop(a, l) {
                                var c = a.getBoundingClientRect(), d = c.left + a.clientWidth / 2 - this.nodes.wrapper.offsetWidth / 2, h = c.top + window.pageYOffset - this.nodes.wrapper.clientHeight - this.offsetTop;
                                this.applyPlacement("top", d, h);
                            }
                        },
                        {
                            key: "placeLeft",
                            value: function placeLeft(a, l) {
                                var c = a.getBoundingClientRect(), d = c.left - this.nodes.wrapper.offsetWidth - this.offsetLeft - l.marginLeft, h = c.top + window.pageYOffset + a.clientHeight / 2 - this.nodes.wrapper.offsetHeight / 2;
                                this.applyPlacement("left", d, h);
                            }
                        },
                        {
                            key: "placeRight",
                            value: function placeRight(a, l) {
                                var c = a.getBoundingClientRect(), d = c.right + this.offsetRight + l.marginRight, h = c.top + window.pageYOffset + a.clientHeight / 2 - this.nodes.wrapper.offsetHeight / 2;
                                this.applyPlacement("right", d, h);
                            }
                        },
                        {
                            key: "applyPlacement",
                            value: function applyPlacement(a, l, c) {
                                this.nodes.wrapper.classList.add(this.CSS.placement[a]), this.nodes.wrapper.style.left = l + "px", this.nodes.wrapper.style.top = c + "px";
                            }
                        },
                        {
                            key: "make",
                            value: function make(a) {
                                var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                                var _d_classList;
                                var d = document.createElement(a);
                                Array.isArray(l) ? (_d_classList = d.classList).add.apply(_d_classList, (0, $aUGqu._)(l)) : l && d.classList.add(l);
                                for(var h in c)c.hasOwnProperty(h) && (d[h] = c[h]);
                                return d;
                            }
                        },
                        {
                            key: "append",
                            value: function append(a, l) {
                                Array.isArray(l) ? l.forEach(function(c) {
                                    return a.appendChild(c);
                                }) : a.appendChild(l);
                            }
                        },
                        {
                            key: "prepend",
                            value: function prepend(a, l) {
                                Array.isArray(l) ? (l = l.reverse()).forEach(function(c) {
                                    return a.prepend(c);
                                }) : a.prepend(l);
                            }
                        }
                    ]);
                    return s;
                }();
            },
            function(t1, o) {
                t1.exports = '.ct{z-index:999;opacity:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;-webkit-transition:opacity 50ms ease-in,-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,transform 70ms cubic-bezier(.215,.61,.355,1),-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);will-change:opacity,top,left;-webkit-box-shadow:0 8px 12px 0 rgba(29,32,43,.17),0 4px 5px -3px rgba(5,6,12,.49);box-shadow:0 8px 12px 0 rgba(29,32,43,.17),0 4px 5px -3px rgba(5,6,12,.49);border-radius:9px}.ct,.ct:before{position:absolute;top:0;left:0}.ct:before{content:"";bottom:0;right:0;background-color:#1d202b;z-index:-1;border-radius:4px}@supports(-webkit-mask-box-image:url("")){.ct:before{border-radius:0;-webkit-mask-box-image:url(\'data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10.71 0h2.58c3.02 0 4.64.42 6.1 1.2a8.18 8.18 0 013.4 3.4C23.6 6.07 24 7.7 24 10.71v2.58c0 3.02-.42 4.64-1.2 6.1a8.18 8.18 0 01-3.4 3.4c-1.47.8-3.1 1.21-6.11 1.21H10.7c-3.02 0-4.64-.42-6.1-1.2a8.18 8.18 0 01-3.4-3.4C.4 17.93 0 16.3 0 13.29V10.7c0-3.02.42-4.64 1.2-6.1a8.18 8.18 0 013.4-3.4C6.07.4 7.7 0 10.71 0z"/></svg>\') 48% 41% 37.9% 53.3%}}@media (--mobile){.ct{display:none}}.ct__content{padding:6px 10px;color:#cdd1e0;font-size:12px;text-align:center;letter-spacing:.02em;line-height:1em}.ct:after{content:"";width:8px;height:8px;position:absolute;background-color:#1d202b;z-index:-1}.ct--bottom{-webkit-transform:translateY(5px);transform:translateY(5px)}.ct--bottom:after{top:-3px;left:50%;-webkit-transform:translateX(-50%) rotate(-45deg);transform:translateX(-50%) rotate(-45deg)}.ct--top{-webkit-transform:translateY(-5px);transform:translateY(-5px)}.ct--top:after{top:auto;bottom:-3px;left:50%;-webkit-transform:translateX(-50%) rotate(-45deg);transform:translateX(-50%) rotate(-45deg)}.ct--left{-webkit-transform:translateX(-5px);transform:translateX(-5px)}.ct--left:after{top:50%;left:auto;right:0;-webkit-transform:translate(41.6%,-50%) rotate(-45deg);transform:translate(41.6%,-50%) rotate(-45deg)}.ct--right{-webkit-transform:translateX(5px);transform:translateX(5px)}.ct--right:after{top:50%;left:0;-webkit-transform:translate(-41.6%,-50%) rotate(-45deg);transform:translate(-41.6%,-50%) rotate(-45deg)}.ct--shown{opacity:1;-webkit-transform:none;transform:none}';
            }
        ]).default;
    });
})($5bdbe1ebf6713620$var$Vo);
var $5bdbe1ebf6713620$var$ji = $5bdbe1ebf6713620$var$Vo.exports;
var $5bdbe1ebf6713620$var$Hi = /* @__PURE__ */ $5bdbe1ebf6713620$var$Ke($5bdbe1ebf6713620$var$ji);
var $5bdbe1ebf6713620$var$U = null;
function $5bdbe1ebf6713620$var$Et() {
    $5bdbe1ebf6713620$var$U || ($5bdbe1ebf6713620$var$U = new $5bdbe1ebf6713620$var$Hi());
}
function $5bdbe1ebf6713620$var$$i(n, e, t1) {
    $5bdbe1ebf6713620$var$Et(), $5bdbe1ebf6713620$var$U == null || $5bdbe1ebf6713620$var$U.show(n, e, t1);
}
function $5bdbe1ebf6713620$var$$e() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    $5bdbe1ebf6713620$var$Et(), $5bdbe1ebf6713620$var$U == null || $5bdbe1ebf6713620$var$U.hide(n);
}
function $5bdbe1ebf6713620$var$ze(n, e, t1) {
    $5bdbe1ebf6713620$var$Et(), $5bdbe1ebf6713620$var$U == null || $5bdbe1ebf6713620$var$U.onHover(n, e, t1);
}
function $5bdbe1ebf6713620$var$zi() {
    $5bdbe1ebf6713620$var$U == null || $5bdbe1ebf6713620$var$U.destroy(), $5bdbe1ebf6713620$var$U = null;
}
var $5bdbe1ebf6713620$var$Ui = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(Ui, E);
    function Ui(param) {
        var e = param.config, t1 = param.eventsDispatcher;
        (0, $173N4._)(this, Ui);
        return (0, $7qXGD._)(this, Ui, [
            {
                config: e,
                eventsDispatcher: t1
            }
        ]);
    }
    (0, $cFHGC._)(Ui, [
        {
            key: "methods",
            get: /**
   * Available methods
   */ function get() {
                var _this = this;
                return {
                    show: function(e, t1, o) {
                        return _this.show(e, t1, o);
                    },
                    hide: function() {
                        return _this.hide();
                    },
                    onHover: function(e, t1, o) {
                        return _this.onHover(e, t1, o);
                    }
                };
            }
        },
        {
            /**
   * Method show tooltip on element with passed HTML content
   *
   * @param {HTMLElement} element - element on which tooltip should be shown
   * @param {TooltipContent} content - tooltip content
   * @param {TooltipOptions} options - tooltip options
   */ key: "show",
            value: function show(e, t1, o) {
                $5bdbe1ebf6713620$var$$i(e, t1, o);
            }
        },
        {
            /**
   * Method hides tooltip on HTML page
   */ key: "hide",
            value: function hide() {
                $5bdbe1ebf6713620$var$$e();
            }
        },
        {
            /**
   * Decorator for showing Tooltip by mouseenter/mouseleave
   *
   * @param {HTMLElement} element - element on which tooltip should be shown
   * @param {TooltipContent} content - tooltip content
   * @param {TooltipOptions} options - tooltip options
   */ key: "onHover",
            value: function onHover(e, t1, o) {
                $5bdbe1ebf6713620$var$ze(e, t1, o);
            }
        }
    ]);
    return Ui;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$Wi = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(Wi, E);
    function Wi() {
        (0, $173N4._)(this, Wi);
        return (0, $7qXGD._)(this, Wi, arguments);
    }
    (0, $cFHGC._)(Wi, [
        {
            key: "methods",
            get: /**
   * Available methods / getters
   */ function get() {
                return {
                    nodes: this.editorNodes
                };
            }
        },
        {
            key: "editorNodes",
            get: /**
   * Exported classes
   */ function get() {
                return {
                    /**
       * Top-level editor instance wrapper
       */ wrapper: this.Editor.UI.nodes.wrapper,
                    /**
       * Element that holds all the Blocks
       */ redactor: this.Editor.UI.nodes.redactor
                };
            }
        }
    ]);
    return Wi;
}($5bdbe1ebf6713620$var$E);
function $5bdbe1ebf6713620$var$qo(n, e) {
    var t1 = {};
    return Object.entries(n).forEach(function(param) {
        var _param = (0, $f9AOD._)(param, 2), o = _param[0], i = _param[1];
        if ($5bdbe1ebf6713620$var$D(i)) {
            var s = e ? "".concat(e, ".").concat(o) : o;
            Object.values(i).every(function(a) {
                return $5bdbe1ebf6713620$var$te(a);
            }) ? t1[o] = s : t1[o] = $5bdbe1ebf6713620$var$qo(i, s);
            return;
        }
        t1[o] = i;
    }), t1;
}
var $5bdbe1ebf6713620$var$K = $5bdbe1ebf6713620$var$qo($5bdbe1ebf6713620$var$Fo);
function $5bdbe1ebf6713620$var$Yi(n, e) {
    var t1 = {};
    return Object.keys(n).forEach(function(o) {
        var i = e[o];
        i !== void 0 ? t1[i] = n[o] : t1[o] = n[o];
    }), t1;
}
var $5bdbe1ebf6713620$var$Zo = /*#__PURE__*/ function() {
    "use strict";
    function Ee(e, t1) {
        (0, $173N4._)(this, Ee);
        this.cursor = -1, this.items = [], this.items = e || [], this.focusedCssClass = t1;
    }
    (0, $cFHGC._)(Ee, [
        {
            key: "currentItem",
            get: /**
   * Returns Focused button Node
   *
   * @returns {HTMLElement}
   */ function get() {
                return this.cursor === -1 ? null : this.items[this.cursor];
            }
        },
        {
            /**
   * Sets cursor to specified position
   *
   * @param cursorPosition - new cursor position
   */ key: "setCursor",
            value: function setCursor(e) {
                e < this.items.length && e >= -1 && (this.dropCursor(), this.cursor = e, this.items[this.cursor].classList.add(this.focusedCssClass));
            }
        },
        {
            /**
   * Sets items. Can be used when iterable items changed dynamically
   *
   * @param {HTMLElement[]} nodeList - nodes to iterate
   */ key: "setItems",
            value: function setItems(e) {
                this.items = e;
            }
        },
        {
            /**
   * Sets cursor next to the current
   */ key: "next",
            value: function next() {
                this.cursor = this.leafNodesAndReturnIndex(Ee.directions.RIGHT);
            }
        },
        {
            /**
   * Sets cursor before current
   */ key: "previous",
            value: function previous() {
                this.cursor = this.leafNodesAndReturnIndex(Ee.directions.LEFT);
            }
        },
        {
            /**
   * Sets cursor to the default position and removes CSS-class from previously focused item
   */ key: "dropCursor",
            value: function dropCursor() {
                this.cursor !== -1 && (this.items[this.cursor].classList.remove(this.focusedCssClass), this.cursor = -1);
            }
        },
        {
            /**
   * Leafs nodes inside the target list from active element
   *
   * @param {string} direction - leaf direction. Can be 'left' or 'right'
   * @returns {number} index of focused node
   */ key: "leafNodesAndReturnIndex",
            value: function leafNodesAndReturnIndex(e) {
                var _this = this;
                if (this.items.length === 0) return this.cursor;
                var t1 = this.cursor;
                return t1 === -1 ? t1 = e === Ee.directions.RIGHT ? -1 : 0 : this.items[t1].classList.remove(this.focusedCssClass), e === Ee.directions.RIGHT ? t1 = (t1 + 1) % this.items.length : t1 = (this.items.length + t1 - 1) % this.items.length, $5bdbe1ebf6713620$var$u.canSetCaret(this.items[t1]) && $5bdbe1ebf6713620$var$Fe(function() {
                    return $5bdbe1ebf6713620$var$b.setCursor(_this.items[t1]);
                }, 50)(), this.items[t1].classList.add(this.focusedCssClass), t1;
            }
        }
    ]);
    return Ee;
}();
$5bdbe1ebf6713620$var$Zo.directions = {
    RIGHT: "right",
    LEFT: "left"
};
var $5bdbe1ebf6713620$var$ke = $5bdbe1ebf6713620$var$Zo;
var $5bdbe1ebf6713620$var$ce = /*#__PURE__*/ function() {
    "use strict";
    function ce(e) {
        var _this = this;
        (0, $173N4._)(this, ce);
        this.iterator = null, this.activated = !1, this.flipCallbacks = [], this.onKeyDown = function(t1) {
            if (!(!_this.isEventReadyForHandling(t1) || t1.shiftKey === !0)) switch(ce.usedKeys.includes(t1.keyCode) && t1.preventDefault(), t1.keyCode){
                case $5bdbe1ebf6713620$var$y.TAB:
                    _this.handleTabPress(t1);
                    break;
                case $5bdbe1ebf6713620$var$y.LEFT:
                case $5bdbe1ebf6713620$var$y.UP:
                    _this.flipLeft();
                    break;
                case $5bdbe1ebf6713620$var$y.RIGHT:
                case $5bdbe1ebf6713620$var$y.DOWN:
                    _this.flipRight();
                    break;
                case $5bdbe1ebf6713620$var$y.ENTER:
                    _this.handleEnterPress(t1);
                    break;
            }
        }, this.iterator = new $5bdbe1ebf6713620$var$ke(e.items, e.focusedItemClass), this.activateCallback = e.activateCallback, this.allowedKeys = e.allowedKeys || ce.usedKeys;
    }
    (0, $cFHGC._)(ce, [
        {
            key: "isActivated",
            get: /**
   * True if flipper is currently activated
   */ function get() {
                return this.activated;
            }
        },
        {
            /**
   * Active tab/arrows handling by flipper
   *
   * @param items - Some modules (like, InlineToolbar, BlockSettings) might refresh buttons dynamically
   * @param cursorPosition - index of the item that should be focused once flipper is activated
   */ key: "activate",
            value: function activate(e, t1) {
                this.activated = !0, e && this.iterator.setItems(e), t1 !== void 0 && this.iterator.setCursor(t1), document.addEventListener("keydown", this.onKeyDown, !0);
            }
        },
        {
            /**
   * Disable tab/arrows handling by flipper
   */ key: "deactivate",
            value: function deactivate() {
                this.activated = !1, this.dropCursor(), document.removeEventListener("keydown", this.onKeyDown);
            }
        },
        {
            /**
   * Focus first item
   */ key: "focusFirst",
            value: function focusFirst() {
                this.dropCursor(), this.flipRight();
            }
        },
        {
            /**
   * Focuses previous flipper iterator item
   */ key: "flipLeft",
            value: function flipLeft() {
                this.iterator.previous(), this.flipCallback();
            }
        },
        {
            /**
   * Focuses next flipper iterator item
   */ key: "flipRight",
            value: function flipRight() {
                this.iterator.next(), this.flipCallback();
            }
        },
        {
            /**
   * Return true if some button is focused
   */ key: "hasFocus",
            value: function hasFocus() {
                return !!this.iterator.currentItem;
            }
        },
        {
            /**
   * Registeres function that should be executed on each navigation action
   *
   * @param cb - function to execute
   */ key: "onFlip",
            value: function onFlip(e) {
                this.flipCallbacks.push(e);
            }
        },
        {
            /**
   * Unregisteres function that is executed on each navigation action
   *
   * @param cb - function to stop executing
   */ key: "removeOnFlip",
            value: function removeOnFlip(e) {
                this.flipCallbacks = this.flipCallbacks.filter(function(t1) {
                    return t1 !== e;
                });
            }
        },
        {
            /**
   * Drops flipper's iterator cursor
   *
   * @see DomIterator#dropCursor
   */ key: "dropCursor",
            value: function dropCursor() {
                this.iterator.dropCursor();
            }
        },
        {
            /**
   * This function is fired before handling flipper keycodes
   * The result of this function defines if it is need to be handled or not
   *
   * @param {KeyboardEvent} event - keydown keyboard event
   * @returns {boolean}
   */ key: "isEventReadyForHandling",
            value: function isEventReadyForHandling(e) {
                return this.activated && this.allowedKeys.includes(e.keyCode);
            }
        },
        {
            /**
   * When flipper is activated tab press will leaf the items
   *
   * @param {KeyboardEvent} event - tab keydown event
   */ key: "handleTabPress",
            value: function handleTabPress(e) {
                switch(e.shiftKey ? $5bdbe1ebf6713620$var$ke.directions.LEFT : $5bdbe1ebf6713620$var$ke.directions.RIGHT){
                    case $5bdbe1ebf6713620$var$ke.directions.RIGHT:
                        this.flipRight();
                        break;
                    case $5bdbe1ebf6713620$var$ke.directions.LEFT:
                        this.flipLeft();
                        break;
                }
            }
        },
        {
            /**
   * Enter press will click current item if flipper is activated
   *
   * @param {KeyboardEvent} event - enter keydown event
   */ key: "handleEnterPress",
            value: function handleEnterPress(e) {
                this.activated && (this.iterator.currentItem && (e.stopPropagation(), e.preventDefault(), this.iterator.currentItem.click()), $5bdbe1ebf6713620$var$A(this.activateCallback) && this.activateCallback(this.iterator.currentItem));
            }
        },
        {
            /**
   * Fired after flipping in any direction
   */ key: "flipCallback",
            value: function flipCallback() {
                this.iterator.currentItem && this.iterator.currentItem.scrollIntoViewIfNeeded(), this.flipCallbacks.forEach(function(e) {
                    return e();
                });
            }
        }
    ], [
        {
            key: "usedKeys",
            get: /**
   * Array of keys (codes) that is handled by Flipper
   * Used to:
   *  - preventDefault only for this keys, not all keydowns (@see constructor)
   *  - to skip external behaviours only for these keys, when filler is activated (@see BlockEvents@arrowRightAndDown)
   */ function get() {
                return [
                    $5bdbe1ebf6713620$var$y.TAB,
                    $5bdbe1ebf6713620$var$y.LEFT,
                    $5bdbe1ebf6713620$var$y.RIGHT,
                    $5bdbe1ebf6713620$var$y.ENTER,
                    $5bdbe1ebf6713620$var$y.UP,
                    $5bdbe1ebf6713620$var$y.DOWN
                ];
            }
        }
    ]);
    return ce;
}();
var $5bdbe1ebf6713620$var$Ki = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9 12L9 7.1C9 7.04477 9.04477 7 9.1 7H10.4C11.5 7 14 7.1 14 9.5C14 9.5 14 12 11 12M9 12V16.8C9 16.9105 9.08954 17 9.2 17H12.5C14 17 15 16 15 14.5C15 11.7046 11 12 11 12M9 12H11"/></svg>', $5bdbe1ebf6713620$var$Xi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 10L11.8586 14.8586C11.9367 14.9367 12.0633 14.9367 12.1414 14.8586L17 10"/></svg>', $5bdbe1ebf6713620$var$Vi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.5 17.5L9.64142 12.6414C9.56331 12.5633 9.56331 12.4367 9.64142 12.3586L14.5 7.5"/></svg>', $5bdbe1ebf6713620$var$qi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9.58284 17.5L14.4414 12.6414C14.5195 12.5633 14.5195 12.4367 14.4414 12.3586L9.58284 7.5"/></svg>', $5bdbe1ebf6713620$var$Zi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 15L11.8586 10.1414C11.9367 10.0633 12.0633 10.0633 12.1414 10.1414L17 15"/></svg>', $5bdbe1ebf6713620$var$Gi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 8L12 12M12 12L16 16M12 12L16 8M12 12L8 16"/></svg>', $5bdbe1ebf6713620$var$Qi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="2"/></svg>', $5bdbe1ebf6713620$var$Ji = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M13.34 10C12.4223 12.7337 11 17 11 17"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.21 7H14.2"/></svg>', $5bdbe1ebf6713620$var$Co = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7.69998 12.6L7.67896 12.62C6.53993 13.7048 6.52012 15.5155 7.63516 16.625V16.625C8.72293 17.7073 10.4799 17.7102 11.5712 16.6314L13.0263 15.193C14.0703 14.1609 14.2141 12.525 13.3662 11.3266L13.22 11.12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16.22 11.12L16.3564 10.9805C17.2895 10.0265 17.3478 8.5207 16.4914 7.49733V7.49733C15.5691 6.39509 13.9269 6.25143 12.8271 7.17675L11.3901 8.38588C10.0935 9.47674 9.95706 11.4241 11.0888 12.6852L11.12 12.72"/></svg>', $5bdbe1ebf6713620$var$es = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.40999 7.29999H9.4"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 7.29999H14.59"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.30999 12H9.3"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 12H14.59"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.40999 16.7H9.4"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 16.7H14.59"/></svg>', $5bdbe1ebf6713620$var$ts = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 7V12M12 17V12M17 12H12M12 12H7"/></svg>', $5bdbe1ebf6713620$var$Go = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M11.5 17.5L5 11M5 11V15.5M5 11H9.5"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12.5 6.5L19 13M19 13V8.5M19 13H14.5"/></svg>', $5bdbe1ebf6713620$var$os = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="10.5" cy="10.5" r="5.5" stroke="currentColor" stroke-width="2"/><line x1="15.4142" x2="19" y1="15" y2="18.5858" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>', $5bdbe1ebf6713620$var$ns = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M15.7795 11.5C15.7795 11.5 16.053 11.1962 16.5497 10.6722C17.4442 9.72856 17.4701 8.2475 16.5781 7.30145V7.30145C15.6482 6.31522 14.0873 6.29227 13.1288 7.25073L11.8796 8.49999"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8.24517 12.3883C8.24517 12.3883 7.97171 12.6922 7.47504 13.2161C6.58051 14.1598 6.55467 15.6408 7.44666 16.5869V16.5869C8.37653 17.5731 9.93744 17.5961 10.8959 16.6376L12.1452 15.3883"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M17.7802 15.1032L16.597 14.9422C16.0109 14.8624 15.4841 15.3059 15.4627 15.8969L15.4199 17.0818"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6.39064 9.03238L7.58432 9.06668C8.17551 9.08366 8.6522 8.58665 8.61056 7.99669L8.5271 6.81397"/><line x1="12.1142" x2="11.7" y1="12.2" y2="11.7858" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>', $5bdbe1ebf6713620$var$is = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><rect width="14" height="14" x="5" y="5" stroke="currentColor" stroke-width="2" rx="4"/><line x1="12" x2="12" y1="9" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 15.02V15.01"/></svg>', $5bdbe1ebf6713620$var$ss = "__", $5bdbe1ebf6713620$var$rs = "--";
function $5bdbe1ebf6713620$var$ne(n) {
    return function(e, t1) {
        return [
            [
                n,
                e
            ].filter(function(i) {
                return !!i;
            }).join($5bdbe1ebf6713620$var$ss),
            t1
        ].filter(function(i) {
            return !!i;
        }).join($5bdbe1ebf6713620$var$rs);
    };
}
var $5bdbe1ebf6713620$var$ye = $5bdbe1ebf6713620$var$ne("ce-hint"), $5bdbe1ebf6713620$var$we = {
    root: $5bdbe1ebf6713620$var$ye(),
    alignedStart: $5bdbe1ebf6713620$var$ye(null, "align-left"),
    alignedCenter: $5bdbe1ebf6713620$var$ye(null, "align-center"),
    title: $5bdbe1ebf6713620$var$ye("title"),
    description: $5bdbe1ebf6713620$var$ye("description")
};
var $5bdbe1ebf6713620$var$as = /*#__PURE__*/ function() {
    "use strict";
    function as(e) {
        (0, $173N4._)(this, as);
        this.nodes = {
            root: $5bdbe1ebf6713620$var$u.make("div", [
                $5bdbe1ebf6713620$var$we.root,
                e.alignment === "center" ? $5bdbe1ebf6713620$var$we.alignedCenter : $5bdbe1ebf6713620$var$we.alignedStart
            ]),
            title: $5bdbe1ebf6713620$var$u.make("div", $5bdbe1ebf6713620$var$we.title, {
                textContent: e.title
            })
        }, this.nodes.root.appendChild(this.nodes.title), e.description !== void 0 && (this.nodes.description = $5bdbe1ebf6713620$var$u.make("div", $5bdbe1ebf6713620$var$we.description, {
            textContent: e.description
        }), this.nodes.root.appendChild(this.nodes.description));
    }
    (0, $cFHGC._)(as, [
        {
            /**
   * Returns the root element of the hint content
   */ key: "getElement",
            value: function getElement() {
                return this.nodes.root;
            }
        }
    ]);
    return as;
}();
var $5bdbe1ebf6713620$var$xt = /*#__PURE__*/ function() {
    "use strict";
    function xt(e) {
        (0, $173N4._)(this, xt);
        this.params = e;
    }
    (0, $cFHGC._)(xt, [
        {
            key: "name",
            get: /**
   * Item name if exists
   */ function get() {
                if (this.params !== void 0 && "name" in this.params) return this.params.name;
            }
        },
        {
            /**
   * Destroys the instance
   */ key: "destroy",
            value: function destroy() {
                $5bdbe1ebf6713620$var$$e();
            }
        },
        {
            /**
   * Called when children popover is opened (if exists)
   */ key: "onChildrenOpen",
            value: function onChildrenOpen() {
                var e;
                this.params !== void 0 && "children" in this.params && typeof ((e = this.params.children) == null ? void 0 : e.onOpen) == "function" && this.params.children.onOpen();
            }
        },
        {
            /**
   * Called when children popover is closed (if exists)
   */ key: "onChildrenClose",
            value: function onChildrenClose() {
                var e;
                this.params !== void 0 && "children" in this.params && typeof ((e = this.params.children) == null ? void 0 : e.onClose) == "function" && this.params.children.onClose();
            }
        },
        {
            /**
   * Called on popover item click
   */ key: "handleClick",
            value: function handleClick() {
                var e, t1;
                this.params !== void 0 && "onActivate" in this.params && ((t1 = (e = this.params).onActivate) == null || t1.call(e, this.params));
            }
        },
        {
            /**
   * Adds hint to the item element if hint data is provided
   *
   * @param itemElement - popover item root element to add hint to
   * @param hintData - hint data
   */ key: "addHint",
            value: function addHint(e, t1) {
                var o = new $5bdbe1ebf6713620$var$as(t1);
                $5bdbe1ebf6713620$var$ze(e, o.getElement(), {
                    placement: t1.position,
                    hidingDelay: 100
                });
            }
        },
        {
            key: "children",
            get: /**
   * Returns item children that are represented as popover items
   */ function get() {
                var e;
                return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.items) !== void 0 ? this.params.children.items : [];
            }
        },
        {
            key: "hasChildren",
            get: /**
   * Returns true if item has any type of children
   */ function get() {
                return this.children.length > 0;
            }
        },
        {
            key: "isChildrenOpen",
            get: /**
   * Returns true if item children should be open instantly after popover is opened and not on item click/hover
   */ function get() {
                var e;
                return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.isOpen) === !0;
            }
        },
        {
            key: "isChildrenFlippable",
            get: /**
   * True if item children items should be navigatable via keyboard
   */ function get() {
                var e;
                return !(this.params === void 0 || !("children" in this.params) || ((e = this.params.children) == null ? void 0 : e.isFlippable) === !1);
            }
        },
        {
            key: "isChildrenSearchable",
            get: /**
   * Returns true if item has children that should be searchable
   */ function get() {
                var e;
                return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.searchable) === !0;
            }
        },
        {
            key: "closeOnActivate",
            get: /**
   * True if popover should close once item is activated
   */ function get() {
                return this.params !== void 0 && "closeOnActivate" in this.params && this.params.closeOnActivate;
            }
        },
        {
            key: "isActive",
            get: /**
   * True if item is active
   */ function get() {
                return this.params === void 0 || !("isActive" in this.params) ? !1 : typeof this.params.isActive == "function" ? this.params.isActive() : this.params.isActive === !0;
            }
        }
    ]);
    return xt;
}();
var $5bdbe1ebf6713620$var$Y = $5bdbe1ebf6713620$var$ne("ce-popover-item"), $5bdbe1ebf6713620$var$L = {
    container: $5bdbe1ebf6713620$var$Y(),
    active: $5bdbe1ebf6713620$var$Y(null, "active"),
    disabled: $5bdbe1ebf6713620$var$Y(null, "disabled"),
    focused: $5bdbe1ebf6713620$var$Y(null, "focused"),
    hidden: $5bdbe1ebf6713620$var$Y(null, "hidden"),
    confirmationState: $5bdbe1ebf6713620$var$Y(null, "confirmation"),
    noHover: $5bdbe1ebf6713620$var$Y(null, "no-hover"),
    noFocus: $5bdbe1ebf6713620$var$Y(null, "no-focus"),
    title: $5bdbe1ebf6713620$var$Y("title"),
    secondaryTitle: $5bdbe1ebf6713620$var$Y("secondary-title"),
    icon: $5bdbe1ebf6713620$var$Y("icon"),
    iconTool: $5bdbe1ebf6713620$var$Y("icon", "tool"),
    iconChevronRight: $5bdbe1ebf6713620$var$Y("icon", "chevron-right"),
    wobbleAnimation: $5bdbe1ebf6713620$var$ne("wobble")()
};
var $5bdbe1ebf6713620$var$re = /*#__PURE__*/ function(xt) {
    "use strict";
    (0, $hdIku._)(re, xt);
    function re(e, t1) {
        (0, $173N4._)(this, re);
        var _this;
        _this = (0, $7qXGD._)(this, re, [
            e
        ]), _this.params = e, _this.nodes = {
            root: null,
            icon: null
        }, _this.confirmationState = null, _this.removeSpecialFocusBehavior = function() {
            var o;
            (o = _this.nodes.root) == null || o.classList.remove($5bdbe1ebf6713620$var$L.noFocus);
        }, _this.removeSpecialHoverBehavior = function() {
            var o;
            (o = _this.nodes.root) == null || o.classList.remove($5bdbe1ebf6713620$var$L.noHover);
        }, _this.onErrorAnimationEnd = function() {
            var o, i;
            (o = _this.nodes.icon) == null || o.classList.remove($5bdbe1ebf6713620$var$L.wobbleAnimation), (i = _this.nodes.icon) == null || i.removeEventListener("animationend", _this.onErrorAnimationEnd);
        }, _this.nodes.root = _this.make(e, t1);
        return _this;
    }
    (0, $cFHGC._)(re, [
        {
            key: "isDisabled",
            get: /**
   * True if item is disabled and hence not clickable
   */ function get() {
                return this.params.isDisabled === !0;
            }
        },
        {
            key: "toggle",
            get: /**
   * Exposes popover item toggle parameter
   */ function get() {
                return this.params.toggle;
            }
        },
        {
            key: "title",
            get: /**
   * Item title
   */ function get() {
                return this.params.title;
            }
        },
        {
            key: "isConfirmationStateEnabled",
            get: /**
   * True if confirmation state is enabled for popover item
   */ function get() {
                return this.confirmationState !== null;
            }
        },
        {
            key: "isFocused",
            get: /**
   * True if item is focused in keyboard navigation process
   */ function get() {
                return this.nodes.root === null ? !1 : this.nodes.root.classList.contains($5bdbe1ebf6713620$var$L.focused);
            }
        },
        {
            /**
   * Returns popover item root element
   */ key: "getElement",
            value: function getElement() {
                return this.nodes.root;
            }
        },
        {
            /**
   * Called on popover item click
   */ key: "handleClick",
            value: function handleClick() {
                if (this.isConfirmationStateEnabled && this.confirmationState !== null) {
                    this.activateOrEnableConfirmationMode(this.confirmationState);
                    return;
                }
                this.activateOrEnableConfirmationMode(this.params);
            }
        },
        {
            /**
   * Toggles item active state
   *
   * @param isActive - true if item should strictly should become active
   */ key: "toggleActive",
            value: function toggleActive(e) {
                var t1;
                (t1 = this.nodes.root) == null || t1.classList.toggle($5bdbe1ebf6713620$var$L.active, e);
            }
        },
        {
            /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ key: "toggleHidden",
            value: function toggleHidden(e) {
                var t1;
                (t1 = this.nodes.root) == null || t1.classList.toggle($5bdbe1ebf6713620$var$L.hidden, e);
            }
        },
        {
            /**
   * Resets popover item to its original state
   */ key: "reset",
            value: function reset() {
                this.isConfirmationStateEnabled && this.disableConfirmationMode();
            }
        },
        {
            /**
   * Method called once item becomes focused during keyboard navigation
   */ key: "onFocus",
            value: function onFocus() {
                this.disableSpecialHoverAndFocusBehavior();
            }
        },
        {
            /**
   * Constructs HTML element corresponding to popover item params
   *
   * @param params - item construction params
   * @param renderParams - popover item render params
   */ key: "make",
            value: function make(e, t1) {
                var s, r;
                var o = (t1 == null ? void 0 : t1.wrapperTag) || "div", i = $5bdbe1ebf6713620$var$u.make(o, $5bdbe1ebf6713620$var$L.container, {
                    type: o === "button" ? "button" : void 0
                });
                return e.name && (i.dataset.itemName = e.name), this.nodes.icon = $5bdbe1ebf6713620$var$u.make("div", [
                    $5bdbe1ebf6713620$var$L.icon,
                    $5bdbe1ebf6713620$var$L.iconTool
                ], {
                    innerHTML: e.icon || $5bdbe1ebf6713620$var$Qi
                }), i.appendChild(this.nodes.icon), e.title !== void 0 && i.appendChild($5bdbe1ebf6713620$var$u.make("div", $5bdbe1ebf6713620$var$L.title, {
                    innerHTML: e.title || ""
                })), e.secondaryLabel && i.appendChild($5bdbe1ebf6713620$var$u.make("div", $5bdbe1ebf6713620$var$L.secondaryTitle, {
                    textContent: e.secondaryLabel
                })), this.hasChildren && i.appendChild($5bdbe1ebf6713620$var$u.make("div", [
                    $5bdbe1ebf6713620$var$L.icon,
                    $5bdbe1ebf6713620$var$L.iconChevronRight
                ], {
                    innerHTML: $5bdbe1ebf6713620$var$qi
                })), this.isActive && i.classList.add($5bdbe1ebf6713620$var$L.active), e.isDisabled && i.classList.add($5bdbe1ebf6713620$var$L.disabled), e.hint !== void 0 && ((s = t1 == null ? void 0 : t1.hint) == null ? void 0 : s.enabled) !== !1 && this.addHint(i, (0, $6fpqi._)((0, $1XAnY._)({}, e.hint), {
                    position: ((r = t1 == null ? void 0 : t1.hint) == null ? void 0 : r.position) || "right"
                })), i;
            }
        },
        {
            /**
   * Activates confirmation mode for the item.
   *
   * @param newState - new popover item params that should be applied
   */ key: "enableConfirmationMode",
            value: function enableConfirmationMode(e) {
                if (this.nodes.root === null) return;
                var t1 = (0, $6fpqi._)((0, $1XAnY._)({}, this.params, e), {
                    confirmation: "confirmation" in e ? e.confirmation : void 0
                }), o = this.make(t1);
                this.nodes.root.innerHTML = o.innerHTML, this.nodes.root.classList.add($5bdbe1ebf6713620$var$L.confirmationState), this.confirmationState = e, this.enableSpecialHoverAndFocusBehavior();
            }
        },
        {
            /**
   * Returns item to its original state
   */ key: "disableConfirmationMode",
            value: function disableConfirmationMode() {
                if (this.nodes.root === null) return;
                var e = this.make(this.params);
                this.nodes.root.innerHTML = e.innerHTML, this.nodes.root.classList.remove($5bdbe1ebf6713620$var$L.confirmationState), this.confirmationState = null, this.disableSpecialHoverAndFocusBehavior();
            }
        },
        {
            /**
   * Enables special focus and hover behavior for item in confirmation state.
   * This is needed to prevent item from being highlighted as hovered/focused just after click.
   */ key: "enableSpecialHoverAndFocusBehavior",
            value: function enableSpecialHoverAndFocusBehavior() {
                var e, t1, o;
                (e = this.nodes.root) == null || e.classList.add($5bdbe1ebf6713620$var$L.noHover), (t1 = this.nodes.root) == null || t1.classList.add($5bdbe1ebf6713620$var$L.noFocus), (o = this.nodes.root) == null || o.addEventListener("mouseleave", this.removeSpecialHoverBehavior, {
                    once: !0
                });
            }
        },
        {
            /**
   * Disables special focus and hover behavior
   */ key: "disableSpecialHoverAndFocusBehavior",
            value: function disableSpecialHoverAndFocusBehavior() {
                var e;
                this.removeSpecialFocusBehavior(), this.removeSpecialHoverBehavior(), (e = this.nodes.root) == null || e.removeEventListener("mouseleave", this.removeSpecialHoverBehavior);
            }
        },
        {
            /**
   * Executes item's onActivate callback if the item has no confirmation configured
   *
   * @param item - item to activate or bring to confirmation mode
   */ key: "activateOrEnableConfirmationMode",
            value: function activateOrEnableConfirmationMode(e) {
                var t1;
                if (!("confirmation" in e) || e.confirmation === void 0) try {
                    (t1 = e.onActivate) == null || t1.call(e, e), this.disableConfirmationMode();
                } catch (e) {
                    this.animateError();
                }
                else this.enableConfirmationMode(e.confirmation);
            }
        },
        {
            /**
   * Animates item which symbolizes that error occured while executing 'onActivate()' callback
   */ key: "animateError",
            value: function animateError() {
                var e, t1, o;
                (e = this.nodes.icon) != null && e.classList.contains($5bdbe1ebf6713620$var$L.wobbleAnimation) || ((t1 = this.nodes.icon) == null || t1.classList.add($5bdbe1ebf6713620$var$L.wobbleAnimation), (o = this.nodes.icon) == null || o.addEventListener("animationend", this.onErrorAnimationEnd));
            }
        }
    ]);
    return re;
}($5bdbe1ebf6713620$var$xt);
var $5bdbe1ebf6713620$var$nt = $5bdbe1ebf6713620$var$ne("ce-popover-item-separator"), $5bdbe1ebf6713620$var$it = {
    container: $5bdbe1ebf6713620$var$nt(),
    line: $5bdbe1ebf6713620$var$nt("line"),
    hidden: $5bdbe1ebf6713620$var$nt(null, "hidden")
};
var $5bdbe1ebf6713620$var$Qo = /*#__PURE__*/ function(xt) {
    "use strict";
    (0, $hdIku._)(Qo, xt);
    function Qo() {
        (0, $173N4._)(this, Qo);
        var _this;
        _this = (0, $7qXGD._)(this, Qo), _this.nodes = {
            root: $5bdbe1ebf6713620$var$u.make("div", $5bdbe1ebf6713620$var$it.container),
            line: $5bdbe1ebf6713620$var$u.make("div", $5bdbe1ebf6713620$var$it.line)
        }, _this.nodes.root.appendChild(_this.nodes.line);
        return _this;
    }
    (0, $cFHGC._)(Qo, [
        {
            /**
   * Returns popover separator root element
   */ key: "getElement",
            value: function getElement() {
                return this.nodes.root;
            }
        },
        {
            /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ key: "toggleHidden",
            value: function toggleHidden(e) {
                var t1;
                (t1 = this.nodes.root) == null || t1.classList.toggle($5bdbe1ebf6713620$var$it.hidden, e);
            }
        }
    ]);
    return Qo;
}($5bdbe1ebf6713620$var$xt);
var $5bdbe1ebf6713620$var$G = /* @__PURE__ */ function(n) {
    return n.Closed = "closed", n.ClosedOnActivate = "closed-on-activate", n;
}($5bdbe1ebf6713620$var$G || {});
var $5bdbe1ebf6713620$var$$ = $5bdbe1ebf6713620$var$ne("ce-popover"), $5bdbe1ebf6713620$var$P = {
    popover: $5bdbe1ebf6713620$var$$(),
    popoverContainer: $5bdbe1ebf6713620$var$$("container"),
    popoverOpenTop: $5bdbe1ebf6713620$var$$(null, "open-top"),
    popoverOpenLeft: $5bdbe1ebf6713620$var$$(null, "open-left"),
    popoverOpened: $5bdbe1ebf6713620$var$$(null, "opened"),
    search: $5bdbe1ebf6713620$var$$("search"),
    nothingFoundMessage: $5bdbe1ebf6713620$var$$("nothing-found-message"),
    nothingFoundMessageDisplayed: $5bdbe1ebf6713620$var$$("nothing-found-message", "displayed"),
    items: $5bdbe1ebf6713620$var$$("items"),
    overlay: $5bdbe1ebf6713620$var$$("overlay"),
    overlayHidden: $5bdbe1ebf6713620$var$$("overlay", "hidden"),
    popoverNested: $5bdbe1ebf6713620$var$$(null, "nested"),
    getPopoverNestedClass: function(n) {
        return $5bdbe1ebf6713620$var$$(null, "nested-level-".concat(n.toString()));
    },
    popoverInline: $5bdbe1ebf6713620$var$$(null, "inline"),
    popoverHeader: $5bdbe1ebf6713620$var$$("header")
};
var $5bdbe1ebf6713620$var$fe = /* @__PURE__ */ function(n) {
    return n.NestingLevel = "--nesting-level", n.PopoverHeight = "--popover-height", n.InlinePopoverWidth = "--inline-popover-width", n.TriggerItemLeft = "--trigger-item-left", n.TriggerItemTop = "--trigger-item-top", n;
}($5bdbe1ebf6713620$var$fe || {});
var $5bdbe1ebf6713620$var$To = $5bdbe1ebf6713620$var$ne("ce-popover-item-html"), $5bdbe1ebf6713620$var$So = {
    root: $5bdbe1ebf6713620$var$To(),
    hidden: $5bdbe1ebf6713620$var$To(null, "hidden")
};
var $5bdbe1ebf6713620$var$Se = /*#__PURE__*/ function(xt) {
    "use strict";
    (0, $hdIku._)(Se, xt);
    function Se(e, t1) {
        (0, $173N4._)(this, Se);
        var _this;
        var o, i;
        _this = (0, $7qXGD._)(this, Se, [
            e
        ]), _this.nodes = {
            root: $5bdbe1ebf6713620$var$u.make("div", $5bdbe1ebf6713620$var$So.root)
        }, _this.nodes.root.appendChild(e.element), e.name && (_this.nodes.root.dataset.itemName = e.name), e.hint !== void 0 && ((o = t1 == null ? void 0 : t1.hint) == null ? void 0 : o.enabled) !== !1 && _this.addHint(_this.nodes.root, (0, $6fpqi._)((0, $1XAnY._)({}, e.hint), {
            position: ((i = t1 == null ? void 0 : t1.hint) == null ? void 0 : i.position) || "right"
        }));
        return _this;
    }
    (0, $cFHGC._)(Se, [
        {
            /**
   * Returns popover item root element
   */ key: "getElement",
            value: function getElement() {
                return this.nodes.root;
            }
        },
        {
            /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ key: "toggleHidden",
            value: function toggleHidden(e) {
                var t1;
                (t1 = this.nodes.root) == null || t1.classList.toggle($5bdbe1ebf6713620$var$So.hidden, e);
            }
        },
        {
            /**
   * Returns list of buttons and inputs inside custom content
   */ key: "getControls",
            value: function getControls() {
                var e = this.nodes.root.querySelectorAll("button, ".concat($5bdbe1ebf6713620$var$u.allInputsSelector));
                return Array.from(e);
            }
        }
    ]);
    return Se;
}($5bdbe1ebf6713620$var$xt);
var $5bdbe1ebf6713620$var$Jo = /*#__PURE__*/ function(Oe) {
    "use strict";
    (0, $hdIku._)(Jo, Oe);
    function Jo(e) {
        var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $173N4._)(this, Jo);
        var _this;
        _this = (0, $7qXGD._)(this, Jo), _this.params = e, _this.itemsRenderParams = t1, _this.listeners = new $5bdbe1ebf6713620$var$_e(), _this.messages = {
            nothingFound: "Nothing found",
            search: "Search"
        }, _this.items = _this.buildItems(e.items), e.messages && (_this.messages = (0, $1XAnY._)({}, _this.messages, e.messages)), _this.nodes = {}, _this.nodes.popoverContainer = $5bdbe1ebf6713620$var$u.make("div", [
            $5bdbe1ebf6713620$var$P.popoverContainer
        ]), _this.nodes.nothingFoundMessage = $5bdbe1ebf6713620$var$u.make("div", [
            $5bdbe1ebf6713620$var$P.nothingFoundMessage
        ], {
            textContent: _this.messages.nothingFound
        }), _this.nodes.popoverContainer.appendChild(_this.nodes.nothingFoundMessage), _this.nodes.items = $5bdbe1ebf6713620$var$u.make("div", [
            $5bdbe1ebf6713620$var$P.items
        ]), _this.items.forEach(function(o) {
            var i = o.getElement();
            i !== null && _this.nodes.items.appendChild(i);
        }), _this.nodes.popoverContainer.appendChild(_this.nodes.items), _this.listeners.on(_this.nodes.popoverContainer, "click", function(o) {
            return _this.handleClick(o);
        }), _this.nodes.popover = $5bdbe1ebf6713620$var$u.make("div", [
            $5bdbe1ebf6713620$var$P.popover,
            _this.params.class
        ]), _this.nodes.popover.appendChild(_this.nodes.popoverContainer);
        return _this;
    }
    (0, $cFHGC._)(Jo, [
        {
            key: "itemsDefault",
            get: /**
   * List of default popover items that are searchable and may have confirmation state
   */ function get() {
                return this.items.filter(function(e) {
                    return e instanceof $5bdbe1ebf6713620$var$re;
                });
            }
        },
        {
            /**
   * Returns HTML element corresponding to the popover
   */ key: "getElement",
            value: function getElement() {
                return this.nodes.popover;
            }
        },
        {
            /**
   * Open popover
   */ key: "show",
            value: function show() {
                this.nodes.popover.classList.add($5bdbe1ebf6713620$var$P.popoverOpened), this.search !== void 0 && this.search.focus();
            }
        },
        {
            /**
   * Closes popover
   */ key: "hide",
            value: function hide() {
                this.nodes.popover.classList.remove($5bdbe1ebf6713620$var$P.popoverOpened), this.nodes.popover.classList.remove($5bdbe1ebf6713620$var$P.popoverOpenTop), this.itemsDefault.forEach(function(e) {
                    return e.reset();
                }), this.search !== void 0 && this.search.clear(), this.emit($5bdbe1ebf6713620$var$G.Closed);
            }
        },
        {
            /**
   * Clears memory
   */ key: "destroy",
            value: function destroy() {
                var e;
                this.items.forEach(function(t1) {
                    return t1.destroy();
                }), this.nodes.popover.remove(), this.listeners.removeAll(), (e = this.search) == null || e.destroy();
            }
        },
        {
            /**
   * Looks for the item by name and imitates click on it
   *
   * @param name - name of the item to activate
   */ key: "activateItemByName",
            value: function activateItemByName(e) {
                var t1 = this.items.find(function(o) {
                    return o.name === e;
                });
                this.handleItemClick(t1);
            }
        },
        {
            /**
   * Factory method for creating popover items
   *
   * @param items - list of items params
   */ key: "buildItems",
            value: function buildItems(e) {
                var _this = this;
                return e.map(function(t1) {
                    switch(t1.type){
                        case $5bdbe1ebf6713620$var$_.Separator:
                            return new $5bdbe1ebf6713620$var$Qo();
                        case $5bdbe1ebf6713620$var$_.Html:
                            return new $5bdbe1ebf6713620$var$Se(t1, _this.itemsRenderParams[$5bdbe1ebf6713620$var$_.Html]);
                        default:
                            return new $5bdbe1ebf6713620$var$re(t1, _this.itemsRenderParams[$5bdbe1ebf6713620$var$_.Default]);
                    }
                });
            }
        },
        {
            /**
   * Retrieves popover item that is the target of the specified event
   *
   * @param event - event to retrieve popover item from
   */ key: "getTargetItem",
            value: function getTargetItem(e) {
                return this.items.filter(function(t1) {
                    return t1 instanceof $5bdbe1ebf6713620$var$re || t1 instanceof $5bdbe1ebf6713620$var$Se;
                }).find(function(t1) {
                    var o = t1.getElement();
                    return o === null ? !1 : e.composedPath().includes(o);
                });
            }
        },
        {
            /**
   * Handles popover item click
   *
   * @param item - item to handle click of
   */ key: "handleItemClick",
            value: function handleItemClick(e) {
                if (!("isDisabled" in e && e.isDisabled)) {
                    if (e.hasChildren) {
                        this.showNestedItems(e), "handleClick" in e && typeof e.handleClick == "function" && e.handleClick();
                        return;
                    }
                    this.itemsDefault.filter(function(t1) {
                        return t1 !== e;
                    }).forEach(function(t1) {
                        return t1.reset();
                    }), "handleClick" in e && typeof e.handleClick == "function" && e.handleClick(), this.toggleItemActivenessIfNeeded(e), e.closeOnActivate && (this.hide(), this.emit($5bdbe1ebf6713620$var$G.ClosedOnActivate));
                }
            }
        },
        {
            /**
   * Handles clicks inside popover
   *
   * @param event - item to handle click of
   */ key: "handleClick",
            value: function handleClick(e) {
                var t1 = this.getTargetItem(e);
                t1 !== void 0 && this.handleItemClick(t1);
            }
        },
        {
            /**
   * - Toggles item active state, if clicked popover item has property 'toggle' set to true.
   *
   * - Performs radiobutton-like behavior if the item has property 'toggle' set to string key.
   * (All the other items with the same key get inactive, and the item gets active)
   *
   * @param clickedItem - popover item that was clicked
   */ key: "toggleItemActivenessIfNeeded",
            value: function toggleItemActivenessIfNeeded(e) {
                if (e instanceof $5bdbe1ebf6713620$var$re && (e.toggle === !0 && e.toggleActive(), typeof e.toggle == "string")) {
                    var t1 = this.itemsDefault.filter(function(o) {
                        return o.toggle === e.toggle;
                    });
                    if (t1.length === 1) {
                        e.toggleActive();
                        return;
                    }
                    t1.forEach(function(o) {
                        o.toggleActive(o === e);
                    });
                }
            }
        }
    ]);
    return Jo;
}($5bdbe1ebf6713620$var$Oe);
var $5bdbe1ebf6713620$var$Ue = /* @__PURE__ */ function(n) {
    return n.Search = "search", n;
}($5bdbe1ebf6713620$var$Ue || {});
var $5bdbe1ebf6713620$var$st = $5bdbe1ebf6713620$var$ne("cdx-search-field"), $5bdbe1ebf6713620$var$rt = {
    wrapper: $5bdbe1ebf6713620$var$st(),
    icon: $5bdbe1ebf6713620$var$st("icon"),
    input: $5bdbe1ebf6713620$var$st("input")
};
var $5bdbe1ebf6713620$var$ls = /*#__PURE__*/ function(Oe) {
    "use strict";
    (0, $hdIku._)(ls, Oe);
    function ls(param) {
        var e = param.items, t1 = param.placeholder;
        (0, $173N4._)(this, ls);
        var _this;
        _this = (0, $7qXGD._)(this, ls), _this.listeners = new $5bdbe1ebf6713620$var$_e(), _this.items = e, _this.wrapper = $5bdbe1ebf6713620$var$u.make("div", $5bdbe1ebf6713620$var$rt.wrapper);
        var o = $5bdbe1ebf6713620$var$u.make("div", $5bdbe1ebf6713620$var$rt.icon, {
            innerHTML: $5bdbe1ebf6713620$var$os
        });
        _this.input = $5bdbe1ebf6713620$var$u.make("input", $5bdbe1ebf6713620$var$rt.input, {
            placeholder: t1,
            /**
       * Used to prevent focusing on the input by Tab key
       * (Popover in the Toolbar lays below the blocks,
       * so Tab in the last block will focus this hidden input if this property is not set)
       */ tabIndex: -1
        }), _this.wrapper.appendChild(o), _this.wrapper.appendChild(_this.input), _this.listeners.on(_this.input, "input", function() {
            _this.searchQuery = _this.input.value, _this.emit($5bdbe1ebf6713620$var$Ue.Search, {
                query: _this.searchQuery,
                items: _this.foundItems
            });
        });
        return _this;
    }
    (0, $cFHGC._)(ls, [
        {
            /**
   * Returns search field element
   */ key: "getElement",
            value: function getElement() {
                return this.wrapper;
            }
        },
        {
            /**
   * Sets focus to the input
   */ key: "focus",
            value: function focus() {
                this.input.focus();
            }
        },
        {
            /**
   * Clears search query and results
   */ key: "clear",
            value: function clear() {
                this.input.value = "", this.searchQuery = "", this.emit($5bdbe1ebf6713620$var$Ue.Search, {
                    query: "",
                    items: this.foundItems
                });
            }
        },
        {
            /**
   * Clears memory
   */ key: "destroy",
            value: function destroy() {
                this.listeners.removeAll();
            }
        },
        {
            key: "foundItems",
            get: /**
   * Returns list of found items for the current search query
   */ function get() {
                var _this = this;
                return this.items.filter(function(e) {
                    return _this.checkItem(e);
                });
            }
        },
        {
            /**
   * Contains logic for checking whether passed item conforms the search query
   *
   * @param item - item to be checked
   */ key: "checkItem",
            value: function checkItem(e) {
                var i, s;
                var t1 = ((i = e.title) == null ? void 0 : i.toLowerCase()) || "", o = (s = this.searchQuery) == null ? void 0 : s.toLowerCase();
                return o !== void 0 ? t1.includes(o) : !1;
            }
        }
    ]);
    return ls;
}($5bdbe1ebf6713620$var$Oe);
var $5bdbe1ebf6713620$var$cs = Object.defineProperty, $5bdbe1ebf6713620$var$ds = Object.getOwnPropertyDescriptor, $5bdbe1ebf6713620$var$us = function(n, e, t1, o) {
    for(var i = o > 1 ? void 0 : o ? $5bdbe1ebf6713620$var$ds(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $5bdbe1ebf6713620$var$cs(e, t1, i), i;
};
var $5bdbe1ebf6713620$var$en = /*#__PURE__*/ function(Jo) {
    "use strict";
    (0, $hdIku._)(tn, Jo);
    function tn(e, t1) {
        (0, $173N4._)(this, tn);
        var _this;
        _this = (0, $7qXGD._)(this, tn, [
            e,
            t1
        ]), _this.nestingLevel = 0, _this.nestedPopoverTriggerItem = null, _this.previouslyHoveredItem = null, _this.scopeElement = document.body, _this.hide = function() {
            var o;
            (0, $dWsrg._)(((0, $gXzGB._)(_this), (0, $kg0zo._)(tn.prototype)), "hide", _this).call(_this), _this.destroyNestedPopoverIfExists(), (o = _this.flipper) == null || o.deactivate(), _this.previouslyHoveredItem = null;
        }, _this.onFlip = function() {
            var o = _this.itemsDefault.find(function(i) {
                return i.isFocused;
            });
            o == null || o.onFocus();
        }, _this.onSearch = function(o) {
            var a;
            var i = o.query === "", s = o.items.length === 0;
            _this.items.forEach(function(l) {
                var c = !1;
                l instanceof $5bdbe1ebf6713620$var$re ? c = !o.items.includes(l) : (l instanceof $5bdbe1ebf6713620$var$Qo || l instanceof $5bdbe1ebf6713620$var$Se) && (c = s || !i), l.toggleHidden(c);
            }), _this.toggleNothingFoundMessage(s);
            var r = o.query === "" ? _this.flippableElements : o.items.map(function(l) {
                return l.getElement();
            });
            (a = _this.flipper) != null && a.isActivated && (_this.flipper.deactivate(), _this.flipper.activate(r));
        }, e.nestingLevel !== void 0 && (_this.nestingLevel = e.nestingLevel), _this.nestingLevel > 0 && _this.nodes.popover.classList.add($5bdbe1ebf6713620$var$P.popoverNested), e.scopeElement !== void 0 && (_this.scopeElement = e.scopeElement), _this.nodes.popoverContainer !== null && _this.listeners.on(_this.nodes.popoverContainer, "mouseover", function(o) {
            return _this.handleHover(o);
        }), e.searchable && _this.addSearch(), e.flippable !== !1 && (_this.flipper = new $5bdbe1ebf6713620$var$ce({
            items: _this.flippableElements,
            focusedItemClass: $5bdbe1ebf6713620$var$L.focused,
            allowedKeys: [
                $5bdbe1ebf6713620$var$y.TAB,
                $5bdbe1ebf6713620$var$y.UP,
                $5bdbe1ebf6713620$var$y.DOWN,
                $5bdbe1ebf6713620$var$y.ENTER
            ]
        }), _this.flipper.onFlip(_this.onFlip));
        return _this;
    }
    (0, $cFHGC._)(tn, [
        {
            /**
   * Returns true if some item inside popover is focused
   */ key: "hasFocus",
            value: function hasFocus() {
                return this.flipper === void 0 ? !1 : this.flipper.hasFocus();
            }
        },
        {
            key: "scrollTop",
            get: /**
   * Scroll position inside items container of the popover
   */ function get() {
                return this.nodes.items === null ? 0 : this.nodes.items.scrollTop;
            }
        },
        {
            key: "offsetTop",
            get: /**
   * Returns visible element offset top
   */ function get() {
                return this.nodes.popoverContainer === null ? 0 : this.nodes.popoverContainer.offsetTop;
            }
        },
        {
            /**
   * Open popover
   */ key: "show",
            value: function show() {
                var e;
                this.nodes.popover.style.setProperty($5bdbe1ebf6713620$var$fe.PopoverHeight, this.size.height + "px"), this.shouldOpenBottom || this.nodes.popover.classList.add($5bdbe1ebf6713620$var$P.popoverOpenTop), this.shouldOpenRight || this.nodes.popover.classList.add($5bdbe1ebf6713620$var$P.popoverOpenLeft), (0, $dWsrg._)((0, $kg0zo._)(tn.prototype), "show", this).call(this), (e = this.flipper) == null || e.activate(this.flippableElements);
            }
        },
        {
            /**
   * Clears memory
   */ key: "destroy",
            value: function destroy() {
                this.hide(), (0, $dWsrg._)((0, $kg0zo._)(tn.prototype), "destroy", this).call(this);
            }
        },
        {
            /**
   * Handles displaying nested items for the item.
   *
   * @param item – item to show nested popover for
   */ key: "showNestedItems",
            value: function showNestedItems(e) {
                this.nestedPopover !== null && this.nestedPopover !== void 0 || (this.nestedPopoverTriggerItem = e, this.showNestedPopoverForItem(e));
            }
        },
        {
            /**
   * Handles hover events inside popover items container
   *
   * @param event - hover event data
   */ key: "handleHover",
            value: function handleHover(e) {
                var t1 = this.getTargetItem(e);
                t1 !== void 0 && this.previouslyHoveredItem !== t1 && (this.destroyNestedPopoverIfExists(), this.previouslyHoveredItem = t1, t1.hasChildren && this.showNestedPopoverForItem(t1));
            }
        },
        {
            /**
   * Sets CSS variable with position of item near which nested popover should be displayed.
   * Is used for correct positioning of the nested popover
   *
   * @param nestedPopoverEl - nested popover element
   * @param item – item near which nested popover should be displayed
   */ key: "setTriggerItemPosition",
            value: function setTriggerItemPosition(e, t1) {
                var o = t1.getElement(), i = (o ? o.offsetTop : 0) - this.scrollTop, s = this.offsetTop + i;
                e.style.setProperty($5bdbe1ebf6713620$var$fe.TriggerItemTop, s + "px");
            }
        },
        {
            /**
   * Destroys existing nested popover
   */ key: "destroyNestedPopoverIfExists",
            value: function destroyNestedPopoverIfExists() {
                var e, t1;
                this.nestedPopover === void 0 || this.nestedPopover === null || (this.nestedPopover.off($5bdbe1ebf6713620$var$G.ClosedOnActivate, this.hide), this.nestedPopover.hide(), this.nestedPopover.destroy(), this.nestedPopover.getElement().remove(), this.nestedPopover = null, (e = this.flipper) == null || e.activate(this.flippableElements), (t1 = this.nestedPopoverTriggerItem) == null || t1.onChildrenClose());
            }
        },
        {
            /**
   * Creates and displays nested popover for specified item.
   * Is used only on desktop
   *
   * @param item - item to display nested popover by
   */ key: "showNestedPopoverForItem",
            value: function showNestedPopoverForItem(e) {
                var o;
                this.nestedPopover = new tn({
                    searchable: e.isChildrenSearchable,
                    items: e.children,
                    nestingLevel: this.nestingLevel + 1,
                    flippable: e.isChildrenFlippable,
                    messages: this.messages
                }), e.onChildrenOpen(), this.nestedPopover.on($5bdbe1ebf6713620$var$G.ClosedOnActivate, this.hide);
                var t1 = this.nestedPopover.getElement();
                return this.nodes.popover.appendChild(t1), this.setTriggerItemPosition(t1, e), t1.style.setProperty($5bdbe1ebf6713620$var$fe.NestingLevel, this.nestedPopover.nestingLevel.toString()), this.nestedPopover.show(), (o = this.flipper) == null || o.deactivate(), this.nestedPopover;
            }
        },
        {
            key: "shouldOpenBottom",
            get: /**
   * Checks if popover should be opened bottom.
   * It should happen when there is enough space below or not enough space above
   */ function get() {
                if (this.nodes.popover === void 0 || this.nodes.popover === null) return !1;
                var e = this.nodes.popoverContainer.getBoundingClientRect(), t1 = this.scopeElement.getBoundingClientRect(), o = this.size.height, i = e.top + o, s = e.top - o, r = Math.min(window.innerHeight, t1.bottom);
                return s < t1.top || i <= r;
            }
        },
        {
            key: "shouldOpenRight",
            get: /**
   * Checks if popover should be opened left.
   * It should happen when there is enough space in the right or not enough space in the left
   */ function get() {
                if (this.nodes.popover === void 0 || this.nodes.popover === null) return !1;
                var e = this.nodes.popover.getBoundingClientRect(), t1 = this.scopeElement.getBoundingClientRect(), o = this.size.width, i = e.right + o, s = e.left - o, r = Math.min(window.innerWidth, t1.right);
                return s < t1.left || i <= r;
            }
        },
        {
            key: "size",
            get: function get() {
                var i;
                var e = {
                    height: 0,
                    width: 0
                };
                if (this.nodes.popover === null) return e;
                var t1 = this.nodes.popover.cloneNode(!0);
                t1.style.visibility = "hidden", t1.style.position = "absolute", t1.style.top = "-1000px", t1.classList.add($5bdbe1ebf6713620$var$P.popoverOpened), (i = t1.querySelector("." + $5bdbe1ebf6713620$var$P.popoverNested)) == null || i.remove(), document.body.appendChild(t1);
                var o = t1.querySelector("." + $5bdbe1ebf6713620$var$P.popoverContainer);
                return e.height = o.offsetHeight, e.width = o.offsetWidth, t1.remove(), e;
            }
        },
        {
            key: "flippableElements",
            get: /**
   * Returns list of elements available for keyboard navigation.
   */ function get() {
                return this.items.map(function(t1) {
                    if (t1 instanceof $5bdbe1ebf6713620$var$re) return t1.getElement();
                    if (t1 instanceof $5bdbe1ebf6713620$var$Se) return t1.getControls();
                }).flat().filter(function(t1) {
                    return t1 != null;
                });
            }
        },
        {
            /**
   * Adds search to the popover
   */ key: "addSearch",
            value: function addSearch() {
                this.search = new $5bdbe1ebf6713620$var$ls({
                    items: this.itemsDefault,
                    placeholder: this.messages.search
                }), this.search.on($5bdbe1ebf6713620$var$Ue.Search, this.onSearch);
                var e = this.search.getElement();
                e.classList.add($5bdbe1ebf6713620$var$P.search), this.nodes.popoverContainer.insertBefore(e, this.nodes.popoverContainer.firstChild);
            }
        },
        {
            /**
   * Toggles nothing found message visibility
   *
   * @param isDisplayed - true if the message should be displayed
   */ key: "toggleNothingFoundMessage",
            value: function toggleNothingFoundMessage(e) {
                this.nodes.nothingFoundMessage.classList.toggle($5bdbe1ebf6713620$var$P.nothingFoundMessageDisplayed, e);
            }
        }
    ]);
    return tn;
}($5bdbe1ebf6713620$var$Jo);
$5bdbe1ebf6713620$var$us([
    $5bdbe1ebf6713620$var$me
], $5bdbe1ebf6713620$var$en.prototype, "size", 1);
var $5bdbe1ebf6713620$var$Bt = $5bdbe1ebf6713620$var$en;
var $5bdbe1ebf6713620$var$hs = /*#__PURE__*/ function(Bt) {
    "use strict";
    (0, $hdIku._)(hs, Bt);
    function hs(e) {
        (0, $173N4._)(this, hs);
        var _this;
        var t1 = !$5bdbe1ebf6713620$var$be();
        var _obj;
        _this = (0, $7qXGD._)(this, hs, [
            (0, $6fpqi._)((0, $1XAnY._)({}, e), {
                class: $5bdbe1ebf6713620$var$P.popoverInline
            }),
            (_obj = {}, (0, $7Pjls._)(_obj, $5bdbe1ebf6713620$var$_.Default, {
                /**
           * We use button instead of div here to fix bug associated with focus loss (which leads to selection change) on click in safari
           *
           * @todo figure out better way to solve the issue
           */ wrapperTag: "button",
                hint: {
                    position: "top",
                    alignment: "center",
                    enabled: t1
                }
            }), (0, $7Pjls._)(_obj, $5bdbe1ebf6713620$var$_.Html, {
                hint: {
                    position: "top",
                    alignment: "center",
                    enabled: t1
                }
            }), _obj)
        ]), _this.items.forEach(function(o) {
            !(o instanceof $5bdbe1ebf6713620$var$re) && !(o instanceof $5bdbe1ebf6713620$var$Se) || o.hasChildren && o.isChildrenOpen && _this.showNestedItems(o);
        });
        return _this;
    }
    (0, $cFHGC._)(hs, [
        {
            key: "offsetLeft",
            get: /**
   * Returns visible element offset top
   */ function get() {
                return this.nodes.popoverContainer === null ? 0 : this.nodes.popoverContainer.offsetLeft;
            }
        },
        {
            /**
   * Open popover
   */ key: "show",
            value: function show() {
                this.nestingLevel === 0 && this.nodes.popover.style.setProperty($5bdbe1ebf6713620$var$fe.InlinePopoverWidth, this.size.width + "px"), (0, $dWsrg._)((0, $kg0zo._)(hs.prototype), "show", this).call(this);
            }
        },
        {
            /**
   * Disable hover event handling.
   * Overrides parent's class behavior
   */ key: "handleHover",
            value: function handleHover() {}
        },
        {
            /**
   * Sets CSS variable with position of item near which nested popover should be displayed.
   * Is used to position nested popover right below clicked item
   *
   * @param nestedPopoverEl - nested popover element
   * @param item – item near which nested popover should be displayed
   */ key: "setTriggerItemPosition",
            value: function setTriggerItemPosition(e, t1) {
                var o = t1.getElement(), i = o ? o.offsetLeft : 0, s = this.offsetLeft + i;
                e.style.setProperty($5bdbe1ebf6713620$var$fe.TriggerItemLeft, s + "px");
            }
        },
        {
            /**
   * Handles displaying nested items for the item.
   * Overriding in order to add toggling behaviour
   *
   * @param item – item to toggle nested popover for
   */ key: "showNestedItems",
            value: function showNestedItems(e) {
                if (this.nestedPopoverTriggerItem === e) {
                    this.destroyNestedPopoverIfExists(), this.nestedPopoverTriggerItem = null;
                    return;
                }
                (0, $dWsrg._)((0, $kg0zo._)(hs.prototype), "showNestedItems", this).call(this, e);
            }
        },
        {
            /**
   * Creates and displays nested popover for specified item.
   * Is used only on desktop
   *
   * @param item - item to display nested popover by
   */ key: "showNestedPopoverForItem",
            value: function showNestedPopoverForItem(e) {
                var t1 = (0, $dWsrg._)((0, $kg0zo._)(hs.prototype), "showNestedPopoverForItem", this).call(this, e);
                return t1.getElement().classList.add($5bdbe1ebf6713620$var$P.getPopoverNestedClass(t1.nestingLevel)), t1;
            }
        },
        {
            /**
   * Overrides default item click handling.
   * Helps to close nested popover once other item is clicked.
   *
   * @param item - clicked item
   */ key: "handleItemClick",
            value: function handleItemClick(e) {
                var t1;
                e !== this.nestedPopoverTriggerItem && ((t1 = this.nestedPopoverTriggerItem) == null || t1.handleClick(), (0, $dWsrg._)((0, $kg0zo._)(hs.prototype), "destroyNestedPopoverIfExists", this).call(this)), (0, $dWsrg._)((0, $kg0zo._)(hs.prototype), "handleItemClick", this).call(this, e);
            }
        }
    ]);
    return hs;
}($5bdbe1ebf6713620$var$Bt);
var $5bdbe1ebf6713620$var$on = /*#__PURE__*/ function() {
    "use strict";
    function xe() {
        (0, $173N4._)(this, xe);
        this.scrollPosition = null;
    }
    (0, $cFHGC._)(xe, [
        {
            /**
   * Locks body element scroll
   */ key: "lock",
            value: function lock() {
                $5bdbe1ebf6713620$var$pt ? this.lockHard() : document.body.classList.add(xe.CSS.scrollLocked);
            }
        },
        {
            /**
   * Unlocks body element scroll
   */ key: "unlock",
            value: function unlock() {
                $5bdbe1ebf6713620$var$pt ? this.unlockHard() : document.body.classList.remove(xe.CSS.scrollLocked);
            }
        },
        {
            /**
   * Locks scroll in a hard way (via setting fixed position to body element)
   */ key: "lockHard",
            value: function lockHard() {
                this.scrollPosition = window.pageYOffset, document.documentElement.style.setProperty("--window-scroll-offset", "".concat(this.scrollPosition, "px")), document.body.classList.add(xe.CSS.scrollLockedHard);
            }
        },
        {
            /**
   * Unlocks hard scroll lock
   */ key: "unlockHard",
            value: function unlockHard() {
                document.body.classList.remove(xe.CSS.scrollLockedHard), this.scrollPosition !== null && window.scrollTo(0, this.scrollPosition), this.scrollPosition = null;
            }
        }
    ]);
    return xe;
}();
$5bdbe1ebf6713620$var$on.CSS = {
    scrollLocked: "ce-scroll-locked",
    scrollLockedHard: "ce-scroll-locked--hard"
};
var $5bdbe1ebf6713620$var$ps = $5bdbe1ebf6713620$var$on;
var $5bdbe1ebf6713620$var$at = $5bdbe1ebf6713620$var$ne("ce-popover-header"), $5bdbe1ebf6713620$var$lt = {
    root: $5bdbe1ebf6713620$var$at(),
    text: $5bdbe1ebf6713620$var$at("text"),
    backButton: $5bdbe1ebf6713620$var$at("back-button")
};
var $5bdbe1ebf6713620$var$fs = /*#__PURE__*/ function() {
    "use strict";
    function fs(param) {
        var e = param.text, t1 = param.onBackButtonClick;
        (0, $173N4._)(this, fs);
        this.listeners = new $5bdbe1ebf6713620$var$_e(), this.text = e, this.onBackButtonClick = t1, this.nodes = {
            root: $5bdbe1ebf6713620$var$u.make("div", [
                $5bdbe1ebf6713620$var$lt.root
            ]),
            backButton: $5bdbe1ebf6713620$var$u.make("button", [
                $5bdbe1ebf6713620$var$lt.backButton
            ]),
            text: $5bdbe1ebf6713620$var$u.make("div", [
                $5bdbe1ebf6713620$var$lt.text
            ])
        }, this.nodes.backButton.innerHTML = $5bdbe1ebf6713620$var$Vi, this.nodes.root.appendChild(this.nodes.backButton), this.listeners.on(this.nodes.backButton, "click", this.onBackButtonClick), this.nodes.text.innerText = this.text, this.nodes.root.appendChild(this.nodes.text);
    }
    (0, $cFHGC._)(fs, [
        {
            /**
   * Returns popover header root html element
   */ key: "getElement",
            value: function getElement() {
                return this.nodes.root;
            }
        },
        {
            /**
   * Destroys the instance
   */ key: "destroy",
            value: function destroy() {
                this.nodes.root.remove(), this.listeners.destroy();
            }
        }
    ]);
    return fs;
}();
var $5bdbe1ebf6713620$var$gs = /*#__PURE__*/ function() {
    "use strict";
    function gs() {
        (0, $173N4._)(this, gs);
        this.history = [];
    }
    (0, $cFHGC._)(gs, [
        {
            /**
   * Push new popover state
   *
   * @param state - new state
   */ key: "push",
            value: function push(e) {
                this.history.push(e);
            }
        },
        {
            /**
   * Pop last popover state
   */ key: "pop",
            value: function pop() {
                return this.history.pop();
            }
        },
        {
            key: "currentTitle",
            get: /**
   * Title retrieved from the current state
   */ function get() {
                return this.history.length === 0 ? "" : this.history[this.history.length - 1].title;
            }
        },
        {
            key: "currentItems",
            get: /**
   * Items list retrieved from the current state
   */ function get() {
                return this.history.length === 0 ? [] : this.history[this.history.length - 1].items;
            }
        },
        {
            /**
   * Returns history to initial popover state
   */ key: "reset",
            value: function reset() {
                for(; this.history.length > 1;)this.pop();
            }
        }
    ]);
    return gs;
}();
var $5bdbe1ebf6713620$var$nn = /*#__PURE__*/ function(Jo) {
    "use strict";
    (0, $hdIku._)(nn, Jo);
    function nn(e) {
        (0, $173N4._)(this, nn);
        var _this;
        var _obj;
        _this = (0, $7qXGD._)(this, nn, [
            e,
            (_obj = {}, (0, $7Pjls._)(_obj, $5bdbe1ebf6713620$var$_.Default, {
                hint: {
                    enabled: !1
                }
            }), (0, $7Pjls._)(_obj, $5bdbe1ebf6713620$var$_.Html, {
                hint: {
                    enabled: !1
                }
            }), _obj)
        ]), _this.scrollLocker = new $5bdbe1ebf6713620$var$ps(), _this.history = new $5bdbe1ebf6713620$var$gs(), _this.isHidden = !0, _this.nodes.overlay = $5bdbe1ebf6713620$var$u.make("div", [
            $5bdbe1ebf6713620$var$P.overlay,
            $5bdbe1ebf6713620$var$P.overlayHidden
        ]), _this.nodes.popover.insertBefore(_this.nodes.overlay, _this.nodes.popover.firstChild), _this.listeners.on(_this.nodes.overlay, "click", function() {
            _this.hide();
        }), _this.history.push({
            items: e.items
        });
        return _this;
    }
    (0, $cFHGC._)(nn, [
        {
            /**
   * Open popover
   */ key: "show",
            value: function show() {
                this.nodes.overlay.classList.remove($5bdbe1ebf6713620$var$P.overlayHidden), (0, $dWsrg._)((0, $kg0zo._)(nn.prototype), "show", this).call(this), this.scrollLocker.lock(), this.isHidden = !1;
            }
        },
        {
            /**
   * Closes popover
   */ key: "hide",
            value: function hide() {
                this.isHidden || ((0, $dWsrg._)((0, $kg0zo._)(nn.prototype), "hide", this).call(this), this.nodes.overlay.classList.add($5bdbe1ebf6713620$var$P.overlayHidden), this.scrollLocker.unlock(), this.history.reset(), this.isHidden = !0);
            }
        },
        {
            /**
   * Clears memory
   */ key: "destroy",
            value: function destroy() {
                (0, $dWsrg._)((0, $kg0zo._)(nn.prototype), "destroy", this).call(this), this.scrollLocker.unlock();
            }
        },
        {
            /**
   * Handles displaying nested items for the item
   *
   * @param item – item to show nested popover for
   */ key: "showNestedItems",
            value: function showNestedItems(e) {
                this.updateItemsAndHeader(e.children, e.title), this.history.push({
                    title: e.title,
                    items: e.children
                });
            }
        },
        {
            /**
   * Removes rendered popover items and header and displays new ones
   *
   * @param items - new popover items
   * @param title - new popover header text
   */ key: "updateItemsAndHeader",
            value: function updateItemsAndHeader(e, t1) {
                var _this = this;
                if (this.header !== null && this.header !== void 0 && (this.header.destroy(), this.header = null), t1 !== void 0) {
                    this.header = new $5bdbe1ebf6713620$var$fs({
                        text: t1,
                        onBackButtonClick: function() {
                            _this.history.pop(), _this.updateItemsAndHeader(_this.history.currentItems, _this.history.currentTitle);
                        }
                    });
                    var o = this.header.getElement();
                    o !== null && this.nodes.popoverContainer.insertBefore(o, this.nodes.popoverContainer.firstChild);
                }
                this.items.forEach(function(o) {
                    var i;
                    return (i = o.getElement()) == null ? void 0 : i.remove();
                }), this.items = this.buildItems(e), this.items.forEach(function(o) {
                    var s;
                    var i = o.getElement();
                    i !== null && ((s = _this.nodes.items) == null || s.appendChild(i));
                });
            }
        }
    ]);
    return nn;
}($5bdbe1ebf6713620$var$Jo);
var $5bdbe1ebf6713620$var$ms = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(ms, E);
    function ms() {
        (0, $173N4._)(this, ms);
        var _this;
        _this = (0, $7qXGD._)(this, ms, arguments), _this.opened = !1, _this.hasMobileLayoutToggleListener = !1, _this.selection = new $5bdbe1ebf6713620$var$b(), _this.popover = null, _this.close = function() {
            _this.opened && (_this.opened = !1, $5bdbe1ebf6713620$var$b.isAtEditor || _this.selection.restore(), _this.selection.clearSaved(), !_this.Editor.CrossBlockSelection.isCrossBlockSelectionStarted && _this.Editor.BlockManager.currentBlock && _this.Editor.BlockSelection.unselectBlock(_this.Editor.BlockManager.currentBlock), _this.eventsDispatcher.emit(_this.events.closed), _this.popover && (_this.popover.off($5bdbe1ebf6713620$var$G.Closed, _this.onPopoverClose), _this.popover.destroy(), _this.popover.getElement().remove(), _this.popover = null));
        }, _this.onPopoverClose = function() {
            _this.close();
        };
        return _this;
    }
    (0, $cFHGC._)(ms, [
        {
            key: "events",
            get: /**
   * Module Events
   */ function get() {
                return {
                    opened: "block-settings-opened",
                    closed: "block-settings-closed"
                };
            }
        },
        {
            key: "CSS",
            get: /**
   * Block Settings CSS
   */ function get() {
                return {
                    settings: "ce-settings"
                };
            }
        },
        {
            key: "flipper",
            get: /**
   * Getter for inner popover's flipper instance
   *
   * @todo remove once BlockSettings becomes standalone non-module class
   */ function get() {
                var e;
                if (this.popover !== null) return "flipper" in this.popover ? (e = this.popover) == null ? void 0 : e.flipper : void 0;
            }
        },
        {
            /**
   * Panel with block settings with 2 sections:
   *  - Tool's Settings
   *  - Default Settings [Move, Remove, etc]
   */ key: "make",
            value: function make() {
                this.nodes.wrapper = $5bdbe1ebf6713620$var$u.make("div", [
                    this.CSS.settings
                ]), this.eventsDispatcher.on($5bdbe1ebf6713620$var$Te, this.close), this.hasMobileLayoutToggleListener = !0;
            }
        },
        {
            /**
   * Destroys module
   */ key: "destroy",
            value: function destroy() {
                this.removeAllNodes(), this.listeners.destroy(), this.hasMobileLayoutToggleListener && (this.eventsDispatcher.off($5bdbe1ebf6713620$var$Te, this.close), this.hasMobileLayoutToggleListener = !1);
            }
        },
        {
            key: "open",
            value: /**
   * Open Block Settings pane
   *
   * @param targetBlock - near which Block we should open BlockSettings
   */ function open() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var e, s, _e_getTunes, t1, o, i, _, _1, _tmp;
                    var _arguments = arguments;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : this.Editor.BlockManager.currentBlock;
                                this.opened = !0, this.selection.save(), this.Editor.BlockSelection.selectBlock(e), this.Editor.BlockSelection.clearCache();
                                _e_getTunes = e.getTunes(), t1 = _e_getTunes.toolTunes, o = _e_getTunes.commonTunes;
                                this.eventsDispatcher.emit(this.events.opened);
                                i = $5bdbe1ebf6713620$var$be() ? $5bdbe1ebf6713620$var$nn : $5bdbe1ebf6713620$var$Bt;
                                _ = this;
                                _1 = i.bind;
                                _tmp = {
                                    searchable: !0
                                };
                                return [
                                    4,
                                    this.getTunesItems(e, o, t1)
                                ];
                            case 1:
                                _.popover = new (_1.apply(i, [
                                    void 0,
                                    (_tmp.items = _state.sent(), _tmp.scopeElement = this.Editor.API.methods.ui.nodes.redactor, _tmp.messages = {
                                        nothingFound: $5bdbe1ebf6713620$var$z.ui($5bdbe1ebf6713620$var$K.ui.popover, "Nothing found"),
                                        search: $5bdbe1ebf6713620$var$z.ui($5bdbe1ebf6713620$var$K.ui.popover, "Filter")
                                    }, _tmp)
                                ])), this.popover.on($5bdbe1ebf6713620$var$G.Closed, this.onPopoverClose), (s = this.nodes.wrapper) == null || s.append(this.popover.getElement()), this.popover.show();
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            /**
   * Returns root block settings element
   */ key: "getElement",
            value: function getElement() {
                return this.nodes.wrapper;
            }
        },
        {
            key: "getTunesItems",
            value: /**
   * Returns list of items to be displayed in block tunes menu.
   * Merges tool specific tunes, conversion menu and common tunes in one list in predefined order
   *
   * @param currentBlock –  block we are about to open block tunes for
   * @param commonTunes – common tunes
   * @param toolTunes - tool specific tunes
   */ function getTunesItems(e, t1, o) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _this, _i, _i1, i, s, a;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                i = [];
                                o !== void 0 && o.length > 0 && ((_i = i).push.apply(_i, (0, $aUGqu._)(o)), i.push({
                                    type: $5bdbe1ebf6713620$var$_.Separator
                                }));
                                s = Array.from(this.Editor.Tools.blockTools.values());
                                return [
                                    4,
                                    $5bdbe1ebf6713620$var$Yo(e, s)
                                ];
                            case 1:
                                a = _state.sent().reduce(function(l, c) {
                                    return c.toolbox.forEach(function(d) {
                                        l.push({
                                            icon: d.icon,
                                            title: $5bdbe1ebf6713620$var$z.t($5bdbe1ebf6713620$var$K.toolNames, d.title),
                                            name: c.name,
                                            closeOnActivate: !0,
                                            onActivate: function() {
                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                                    var _this_Editor, h, p, g, f;
                                                    return (0, $13u2V._)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                _this_Editor = this.Editor, h = _this_Editor.BlockManager, p = _this_Editor.Caret, g = _this_Editor.Toolbar;
                                                                return [
                                                                    4,
                                                                    h.convert(e, c.name, d.data)
                                                                ];
                                                            case 1:
                                                                f = _state.sent();
                                                                g.close(), p.setToBlock(f, p.positions.END);
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                }).call(_this);
                                            }
                                        });
                                    }), l;
                                }, []);
                                return [
                                    2,
                                    (a.length > 0 && (i.push({
                                        icon: $5bdbe1ebf6713620$var$Go,
                                        name: "convert-to",
                                        title: $5bdbe1ebf6713620$var$z.ui($5bdbe1ebf6713620$var$K.ui.popover, "Convert to"),
                                        children: {
                                            searchable: !0,
                                            items: a
                                        }
                                    }), i.push({
                                        type: $5bdbe1ebf6713620$var$_.Separator
                                    })), (_i1 = i).push.apply(_i1, (0, $aUGqu._)(t1)), i.map(function(l) {
                                        return _this.resolveTuneAliases(l);
                                    }))
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Resolves aliases in tunes menu items
   *
   * @param item - item with resolved aliases
   */ key: "resolveTuneAliases",
            value: function resolveTuneAliases(e) {
                if (e.type === $5bdbe1ebf6713620$var$_.Separator || e.type === $5bdbe1ebf6713620$var$_.Html) return e;
                var t1 = $5bdbe1ebf6713620$var$Yi(e, {
                    label: "title"
                });
                return e.confirmation && (t1.confirmation = this.resolveTuneAliases(e.confirmation)), t1;
            }
        }
    ]);
    return ms;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$sn = {
    exports: {}
};
/*!
 * Library for handling keyboard shortcuts
 * @copyright CodeX (https://codex.so)
 * @license MIT
 * @author CodeX (https://codex.so)
 * @version 1.2.0
 */ (function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                (typeof Symbol === "undefined" ? "undefined" : (0, $7E0eS._)(Symbol)) < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && (typeof s === "undefined" ? "undefined" : (0, $7E0eS._)(s)) == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function r() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "", i(i.s = 0);
        }([
            function(t1, o, i) {
                function s(l, c) {
                    for(var d = 0; d < c.length; d++){
                        var h = c[d];
                        h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(l, h.key, h);
                    }
                }
                function r(l, c, d) {
                    return c && s(l.prototype, c), d && s(l, d), l;
                }
                i.r(o);
                var a = function() {
                    function l(c) {
                        var d = this;
                        (function(h, p) {
                            if (!(h instanceof p)) throw new TypeError("Cannot call a class as a function");
                        })(this, l), this.commands = {}, this.keys = {}, this.name = c.name, this.parseShortcutName(c.name), this.element = c.on, this.callback = c.callback, this.executeShortcut = function(h) {
                            d.execute(h);
                        }, this.element.addEventListener("keydown", this.executeShortcut, !1);
                    }
                    return r(l, null, [
                        {
                            key: "supportedCommands",
                            get: function get() {
                                return {
                                    SHIFT: [
                                        "SHIFT"
                                    ],
                                    CMD: [
                                        "CMD",
                                        "CONTROL",
                                        "COMMAND",
                                        "WINDOWS",
                                        "CTRL"
                                    ],
                                    ALT: [
                                        "ALT",
                                        "OPTION"
                                    ]
                                };
                            }
                        },
                        {
                            key: "keyCodes",
                            get: function get() {
                                return {
                                    0: 48,
                                    1: 49,
                                    2: 50,
                                    3: 51,
                                    4: 52,
                                    5: 53,
                                    6: 54,
                                    7: 55,
                                    8: 56,
                                    9: 57,
                                    A: 65,
                                    B: 66,
                                    C: 67,
                                    D: 68,
                                    E: 69,
                                    F: 70,
                                    G: 71,
                                    H: 72,
                                    I: 73,
                                    J: 74,
                                    K: 75,
                                    L: 76,
                                    M: 77,
                                    N: 78,
                                    O: 79,
                                    P: 80,
                                    Q: 81,
                                    R: 82,
                                    S: 83,
                                    T: 84,
                                    U: 85,
                                    V: 86,
                                    W: 87,
                                    X: 88,
                                    Y: 89,
                                    Z: 90,
                                    BACKSPACE: 8,
                                    ENTER: 13,
                                    ESCAPE: 27,
                                    LEFT: 37,
                                    UP: 38,
                                    RIGHT: 39,
                                    DOWN: 40,
                                    INSERT: 45,
                                    DELETE: 46,
                                    ".": 190
                                };
                            }
                        }
                    ]), r(l, [
                        {
                            key: "parseShortcutName",
                            value: function value(c) {
                                c = c.split("+");
                                for(var d = 0; d < c.length; d++){
                                    c[d] = c[d].toUpperCase();
                                    var h = !1;
                                    for(var p in l.supportedCommands)if (l.supportedCommands[p].includes(c[d])) {
                                        h = this.commands[p] = !0;
                                        break;
                                    }
                                    h || (this.keys[c[d]] = !0);
                                }
                                for(var g in l.supportedCommands)this.commands[g] || (this.commands[g] = !1);
                            }
                        },
                        {
                            key: "execute",
                            value: function value(c) {
                                var d, h = {
                                    CMD: c.ctrlKey || c.metaKey,
                                    SHIFT: c.shiftKey,
                                    ALT: c.altKey
                                }, p = !0;
                                for(d in this.commands)this.commands[d] !== h[d] && (p = !1);
                                var g, f = !0;
                                for(g in this.keys)f = f && c.keyCode === l.keyCodes[g];
                                p && f && this.callback(c);
                            }
                        },
                        {
                            key: "remove",
                            value: function value() {
                                this.element.removeEventListener("keydown", this.executeShortcut);
                            }
                        }
                    ]), l;
                }();
                o.default = a;
            }
        ]).default;
    });
})($5bdbe1ebf6713620$var$sn);
var $5bdbe1ebf6713620$var$bs = $5bdbe1ebf6713620$var$sn.exports;
var $5bdbe1ebf6713620$var$vs = /* @__PURE__ */ $5bdbe1ebf6713620$var$Ke($5bdbe1ebf6713620$var$bs);
var $5bdbe1ebf6713620$var$ks = /*#__PURE__*/ function() {
    "use strict";
    function ks() {
        (0, $173N4._)(this, ks);
        this.registeredShortcuts = /* @__PURE__ */ new Map();
    }
    (0, $cFHGC._)(ks, [
        {
            /**
   * Register shortcut
   *
   * @param shortcut - shortcut options
   */ key: "add",
            value: function add(e) {
                if (this.findShortcut(e.on, e.name)) throw Error("Shortcut ".concat(e.name, " is already registered for ").concat(e.on, ". Please remove it before add a new handler."));
                var o = new $5bdbe1ebf6713620$var$vs({
                    name: e.name,
                    on: e.on,
                    callback: e.handler
                }), i = this.registeredShortcuts.get(e.on) || [];
                this.registeredShortcuts.set(e.on, (0, $aUGqu._)(i).concat([
                    o
                ]));
            }
        },
        {
            /**
   * Remove shortcut
   *
   * @param element - Element shortcut is set for
   * @param name - shortcut name
   */ key: "remove",
            value: function remove(e, t1) {
                var o = this.findShortcut(e, t1);
                if (!o) return;
                o.remove();
                var s = this.registeredShortcuts.get(e).filter(function(r) {
                    return r !== o;
                });
                if (s.length === 0) {
                    this.registeredShortcuts.delete(e);
                    return;
                }
                this.registeredShortcuts.set(e, s);
            }
        },
        {
            /**
   * Get Shortcut instance if exist
   *
   * @param element - Element shorcut is set for
   * @param shortcut - shortcut name
   * @returns {number} index - shortcut index if exist
   */ key: "findShortcut",
            value: function findShortcut(e, t1) {
                return (this.registeredShortcuts.get(e) || []).find(function(param) {
                    var i = param.name;
                    return i === t1;
                });
            }
        }
    ]);
    return ks;
}();
var $5bdbe1ebf6713620$var$ge = new $5bdbe1ebf6713620$var$ks();
var $5bdbe1ebf6713620$var$ys = Object.defineProperty, $5bdbe1ebf6713620$var$ws = Object.getOwnPropertyDescriptor, $5bdbe1ebf6713620$var$rn = function(n, e, t1, o) {
    for(var i = o > 1 ? void 0 : o ? $5bdbe1ebf6713620$var$ws(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $5bdbe1ebf6713620$var$ys(e, t1, i), i;
}, $5bdbe1ebf6713620$var$Le = /* @__PURE__ */ function(n) {
    return n.Opened = "toolbox-opened", n.Closed = "toolbox-closed", n.BlockAdded = "toolbox-block-added", n;
}($5bdbe1ebf6713620$var$Le || {});
var $5bdbe1ebf6713620$var$Ct = /*#__PURE__*/ function(Oe) {
    "use strict";
    (0, $hdIku._)(an, Oe);
    function an(param) {
        var e = param.api, t1 = param.tools, o = param.i18nLabels;
        (0, $173N4._)(this, an);
        var _this;
        _this = (0, $7qXGD._)(this, an), _this.opened = !1, _this.listeners = new $5bdbe1ebf6713620$var$_e(), _this.popover = null, _this.handleMobileLayoutToggle = function() {
            _this.destroyPopover(), _this.initPopover();
        }, _this.onPopoverClose = function() {
            _this.opened = !1, _this.emit("toolbox-closed");
        }, _this.api = e, _this.tools = t1, _this.i18nLabels = o, _this.enableShortcuts(), _this.nodes = {
            toolbox: $5bdbe1ebf6713620$var$u.make("div", an.CSS.toolbox)
        }, _this.initPopover(), _this.api.events.on($5bdbe1ebf6713620$var$Te, _this.handleMobileLayoutToggle);
        return _this;
    }
    (0, $cFHGC._)(an, [
        {
            key: "isEmpty",
            get: /**
   * Returns True if Toolbox is Empty and nothing to show
   *
   * @returns {boolean}
   */ function get() {
                return this.toolsToBeDisplayed.length === 0;
            }
        },
        {
            /**
   * Returns root block settings element
   */ key: "getElement",
            value: function getElement() {
                return this.nodes.toolbox;
            }
        },
        {
            /**
   * Returns true if the Toolbox has the Flipper activated and the Flipper has selected button
   */ key: "hasFocus",
            value: function hasFocus() {
                if (this.popover !== null) return "hasFocus" in this.popover ? this.popover.hasFocus() : void 0;
            }
        },
        {
            /**
   * Destroy Module
   */ key: "destroy",
            value: function destroy() {
                var e;
                (0, $dWsrg._)((0, $kg0zo._)(an.prototype), "destroy", this).call(this), this.nodes && this.nodes.toolbox && this.nodes.toolbox.remove(), this.removeAllShortcuts(), (e = this.popover) == null || e.off($5bdbe1ebf6713620$var$G.Closed, this.onPopoverClose), this.listeners.destroy(), this.api.events.off($5bdbe1ebf6713620$var$Te, this.handleMobileLayoutToggle);
            }
        },
        {
            /**
   * Toolbox Tool's button click handler
   *
   * @param toolName - tool type to be activated
   * @param blockDataOverrides - Block data predefined by the activated Toolbox item
   */ key: "toolButtonActivated",
            value: function toolButtonActivated(e, t1) {
                this.insertNewBlock(e, t1);
            }
        },
        {
            /**
   * Open Toolbox with Tools
   */ key: "open",
            value: function open() {
                var e;
                this.isEmpty || ((e = this.popover) == null || e.show(), this.opened = !0, this.emit("toolbox-opened"));
            }
        },
        {
            /**
   * Close Toolbox
   */ key: "close",
            value: function close() {
                var e;
                (e = this.popover) == null || e.hide(), this.opened = !1, this.emit("toolbox-closed");
            }
        },
        {
            /**
   * Close Toolbox
   */ key: "toggle",
            value: function toggle() {
                this.opened ? this.close() : this.open();
            }
        },
        {
            /**
   * Creates toolbox popover and appends it inside wrapper element
   */ key: "initPopover",
            value: function initPopover() {
                var t1;
                var e = $5bdbe1ebf6713620$var$be() ? $5bdbe1ebf6713620$var$nn : $5bdbe1ebf6713620$var$Bt;
                this.popover = new e({
                    scopeElement: this.api.ui.nodes.redactor,
                    searchable: !0,
                    messages: {
                        nothingFound: this.i18nLabels.nothingFound,
                        search: this.i18nLabels.filter
                    },
                    items: this.toolboxItemsToBeDisplayed
                }), this.popover.on($5bdbe1ebf6713620$var$G.Closed, this.onPopoverClose), (t1 = this.nodes.toolbox) == null || t1.append(this.popover.getElement());
            }
        },
        {
            /**
   * Destroys popover instance and removes it from DOM
   */ key: "destroyPopover",
            value: function destroyPopover() {
                this.popover !== null && (this.popover.hide(), this.popover.off($5bdbe1ebf6713620$var$G.Closed, this.onPopoverClose), this.popover.destroy(), this.popover = null), this.nodes.toolbox !== null && (this.nodes.toolbox.innerHTML = "");
            }
        },
        {
            key: "toolsToBeDisplayed",
            get: function get() {
                var e = [];
                return this.tools.forEach(function(t1) {
                    t1.toolbox && e.push(t1);
                }), e;
            }
        },
        {
            key: "toolboxItemsToBeDisplayed",
            get: function get() {
                var _this = this;
                var e = function(t1, o) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
                    return {
                        icon: t1.icon,
                        title: $5bdbe1ebf6713620$var$z.t($5bdbe1ebf6713620$var$K.toolNames, t1.title || $5bdbe1ebf6713620$var$je(o.name)),
                        name: o.name,
                        onActivate: function() {
                            _this.toolButtonActivated(o.name, t1.data);
                        },
                        secondaryLabel: o.shortcut && i ? $5bdbe1ebf6713620$var$vt(o.shortcut) : ""
                    };
                };
                return this.toolsToBeDisplayed.reduce(function(t1, o) {
                    return Array.isArray(o.toolbox) ? o.toolbox.forEach(function(i, s) {
                        t1.push(e(i, o, s === 0));
                    }) : o.toolbox !== void 0 && t1.push(e(o.toolbox, o)), t1;
                }, []);
            }
        },
        {
            /**
   * Iterate all tools and enable theirs shortcuts if specified
   */ key: "enableShortcuts",
            value: function enableShortcuts() {
                var _this = this;
                this.toolsToBeDisplayed.forEach(function(e) {
                    var t1 = e.shortcut;
                    t1 && _this.enableShortcutForTool(e.name, t1);
                });
            }
        },
        {
            /**
   * Enable shortcut Block Tool implemented shortcut
   *
   * @param {string} toolName - Tool name
   * @param {string} shortcut - shortcut according to the ShortcutData Module format
   */ key: "enableShortcutForTool",
            value: function enableShortcutForTool(e, t1) {
                var _this = this;
                $5bdbe1ebf6713620$var$ge.add({
                    name: t1,
                    on: this.api.ui.nodes.redactor,
                    handler: function(o) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                            var i, s, r, e1;
                            return (0, $13u2V._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        o.preventDefault();
                                        i = this.api.blocks.getCurrentBlockIndex(), s = this.api.blocks.getBlockByIndex(i);
                                        if (!s) return [
                                            3,
                                            4
                                        ];
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4,
                                            this.api.blocks.convert(s.id, e)
                                        ];
                                    case 2:
                                        r = _state.sent();
                                        this.api.caret.setToBlock(r, "end");
                                        return [
                                            2
                                        ];
                                    case 3:
                                        e1 = _state.sent();
                                        return [
                                            3,
                                            4
                                        ];
                                    case 4:
                                        this.insertNewBlock(e);
                                        return [
                                            2
                                        ];
                                }
                            });
                        }).call(_this);
                    }
                });
            }
        },
        {
            /**
   * Removes all added shortcuts
   * Fired when the Read-Only mode is activated
   */ key: "removeAllShortcuts",
            value: function removeAllShortcuts() {
                var _this = this;
                this.toolsToBeDisplayed.forEach(function(e) {
                    var t1 = e.shortcut;
                    t1 && $5bdbe1ebf6713620$var$ge.remove(_this.api.ui.nodes.redactor, t1);
                });
            }
        },
        {
            key: "insertNewBlock",
            value: /**
   * Inserts new block
   * Can be called when button clicked on Toolbox or by ShortcutData
   *
   * @param {string} toolName - Tool name
   * @param blockDataOverrides - predefined Block data
   */ function insertNewBlock(e, t1) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var o, i, s, r, l, a;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                o = this.api.blocks.getCurrentBlockIndex(), i = this.api.blocks.getBlockByIndex(o);
                                if (!i) return [
                                    2
                                ];
                                s = i.isEmpty ? o : o + 1;
                                if (!t1) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.api.blocks.composeBlockData(e)
                                ];
                            case 1:
                                l = _state.sent();
                                r = Object.assign(l, t1);
                                _state.label = 2;
                            case 2:
                                a = this.api.blocks.insert(e, r, void 0, s, void 0, i.isEmpty);
                                a.call($5bdbe1ebf6713620$var$ee.APPEND_CALLBACK), this.api.caret.setToBlock(s), this.emit("toolbox-block-added", {
                                    block: a
                                }), this.api.toolbar.close();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ], [
        {
            key: "CSS",
            get: /**
   * CSS styles
   */ function get() {
                return {
                    toolbox: "ce-toolbox"
                };
            }
        }
    ]);
    return an;
}($5bdbe1ebf6713620$var$Oe);
$5bdbe1ebf6713620$var$rn([
    $5bdbe1ebf6713620$var$me
], $5bdbe1ebf6713620$var$Ct.prototype, "toolsToBeDisplayed", 1);
$5bdbe1ebf6713620$var$rn([
    $5bdbe1ebf6713620$var$me
], $5bdbe1ebf6713620$var$Ct.prototype, "toolboxItemsToBeDisplayed", 1);
var $5bdbe1ebf6713620$var$Es = $5bdbe1ebf6713620$var$Ct;
var $5bdbe1ebf6713620$var$ln = "block hovered";
function $5bdbe1ebf6713620$var$xs(n, e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var t1, o;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    t1 = navigator.keyboard;
                    if (!t1) return [
                        2,
                        e
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        t1.getLayoutMap()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent().get(n) || e
                    ];
                case 3:
                    o = _state.sent();
                    return [
                        2,
                        (console.error(o), e)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
var $5bdbe1ebf6713620$var$Bs = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(Bs, E);
    function Bs(param) {
        var e = param.config, t1 = param.eventsDispatcher;
        (0, $173N4._)(this, Bs);
        var _this;
        _this = (0, $7qXGD._)(this, Bs, [
            {
                config: e,
                eventsDispatcher: t1
            }
        ]), _this.toolboxInstance = null;
        return _this;
    }
    (0, $cFHGC._)(Bs, [
        {
            key: "CSS",
            get: /**
   * CSS styles
   *
   * @returns {object}
   */ function get() {
                return {
                    toolbar: "ce-toolbar",
                    content: "ce-toolbar__content",
                    actions: "ce-toolbar__actions",
                    actionsOpened: "ce-toolbar__actions--opened",
                    toolbarOpened: "ce-toolbar--opened",
                    openedToolboxHolderModifier: "codex-editor--toolbox-opened",
                    plusButton: "ce-toolbar__plus",
                    plusButtonShortcut: "ce-toolbar__plus-shortcut",
                    settingsToggler: "ce-toolbar__settings-btn",
                    settingsTogglerHidden: "ce-toolbar__settings-btn--hidden"
                };
            }
        },
        {
            key: "opened",
            get: /**
   * Returns the Toolbar opening state
   *
   * @returns {boolean}
   */ function get() {
                return this.nodes.wrapper.classList.contains(this.CSS.toolbarOpened);
            }
        },
        {
            key: "toolbox",
            get: /**
   * Public interface for accessing the Toolbox
   */ function get() {
                var _this = this;
                var e;
                return {
                    opened: (e = this.toolboxInstance) == null ? void 0 : e.opened,
                    close: function() {
                        var t1;
                        (t1 = _this.toolboxInstance) == null || t1.close();
                    },
                    open: function() {
                        if (_this.toolboxInstance === null) {
                            $5bdbe1ebf6713620$var$S("toolbox.open() called before initialization is finished", "warn");
                            return;
                        }
                        _this.Editor.BlockManager.currentBlock = _this.hoveredBlock, _this.toolboxInstance.open();
                    },
                    toggle: function() {
                        if (_this.toolboxInstance === null) {
                            $5bdbe1ebf6713620$var$S("toolbox.toggle() called before initialization is finished", "warn");
                            return;
                        }
                        _this.toolboxInstance.toggle();
                    },
                    hasFocus: function() {
                        var t1;
                        return (t1 = _this.toolboxInstance) == null ? void 0 : t1.hasFocus();
                    }
                };
            }
        },
        {
            key: "blockActions",
            get: /**
   * Block actions appearance manipulations
   */ function get() {
                var _this = this;
                return {
                    hide: function() {
                        _this.nodes.actions.classList.remove(_this.CSS.actionsOpened);
                    },
                    show: function() {
                        _this.nodes.actions.classList.add(_this.CSS.actionsOpened);
                    }
                };
            }
        },
        {
            key: "blockTunesToggler",
            get: /**
   * Methods for working with Block Tunes toggler
   */ function get() {
                var _this = this;
                return {
                    hide: function() {
                        return _this.nodes.settingsToggler.classList.add(_this.CSS.settingsTogglerHidden);
                    },
                    show: function() {
                        return _this.nodes.settingsToggler.classList.remove(_this.CSS.settingsTogglerHidden);
                    }
                };
            }
        },
        {
            /**
   * Toggles read-only mode
   *
   * @param {boolean} readOnlyEnabled - read-only mode
   */ key: "toggleReadOnly",
            value: function toggleReadOnly(e) {
                var _this = this;
                e ? (this.destroy(), this.Editor.BlockSettings.destroy(), this.disableModuleBindings()) : window.requestIdleCallback(function() {
                    _this.drawUI(), _this.enableModuleBindings();
                }, {
                    timeout: 2e3
                });
            }
        },
        {
            /**
   * Move Toolbar to the passed (or current) Block
   *
   * @param block - block to move Toolbar near it
   */ key: "moveAndOpen",
            value: function moveAndOpen() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.Editor.BlockManager.currentBlock;
                if (this.toolboxInstance === null) {
                    $5bdbe1ebf6713620$var$S("Can't open Toolbar since Editor initialization is not finished yet", "warn");
                    return;
                }
                if (this.toolboxInstance.opened && this.toolboxInstance.close(), this.Editor.BlockSettings.opened && this.Editor.BlockSettings.close(), !e) return;
                this.hoveredBlock = e;
                var t1 = e.holder, _this_Editor_UI = this.Editor.UI, o = _this_Editor_UI.isMobile;
                var i;
                var s = 20, r = e.firstInput, a = t1.getBoundingClientRect(), l = r !== void 0 ? r.getBoundingClientRect() : null, c = l !== null ? l.top - a.top : null, d = c !== null ? c > s : void 0;
                if (o) i = t1.offsetTop + t1.offsetHeight;
                else if (r === void 0 || d) {
                    var h = parseInt(window.getComputedStyle(e.pluginsContent).paddingTop);
                    i = t1.offsetTop + h;
                } else {
                    var h1 = $5bdbe1ebf6713620$var$li(r), p = parseInt(window.getComputedStyle(this.nodes.plusButton).height, 10), g = 8;
                    i = t1.offsetTop + h1 - p + g + c;
                }
                this.nodes.wrapper.style.top = "".concat(Math.floor(i), "px"), this.Editor.BlockManager.blocks.length === 1 && e.isEmpty ? this.blockTunesToggler.hide() : this.blockTunesToggler.show(), this.open();
            }
        },
        {
            /**
   * Close the Toolbar
   */ key: "close",
            value: function close() {
                var e, t1;
                this.Editor.ReadOnly.isEnabled || ((e = this.nodes.wrapper) == null || e.classList.remove(this.CSS.toolbarOpened), this.blockActions.hide(), (t1 = this.toolboxInstance) == null || t1.close(), this.Editor.BlockSettings.close(), this.reset());
            }
        },
        {
            /**
   * Reset the Toolbar position to prevent DOM height growth, for example after blocks deletion
   */ key: "reset",
            value: function reset() {
                this.nodes.wrapper.style.top = "unset";
            }
        },
        {
            /**
   * Open Toolbar with Plus Button and Actions
   *
   * @param {boolean} withBlockActions - by default, Toolbar opens with Block Actions.
   *                                     This flag allows to open Toolbar without Actions.
   */ key: "open",
            value: function open() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
                this.nodes.wrapper.classList.add(this.CSS.toolbarOpened), e ? this.blockActions.show() : this.blockActions.hide();
            }
        },
        {
            key: "make",
            value: /**
   * Draws Toolbar elements
   */ function make() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _this, e, t1, o, i;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                this.nodes.wrapper = $5bdbe1ebf6713620$var$u.make("div", this.CSS.toolbar), [
                                    "content",
                                    "actions"
                                ].forEach(function(s) {
                                    _this.nodes[s] = $5bdbe1ebf6713620$var$u.make("div", _this.CSS[s]);
                                }), $5bdbe1ebf6713620$var$u.append(this.nodes.wrapper, this.nodes.content), $5bdbe1ebf6713620$var$u.append(this.nodes.content, this.nodes.actions), this.nodes.plusButton = $5bdbe1ebf6713620$var$u.make("div", this.CSS.plusButton, {
                                    innerHTML: $5bdbe1ebf6713620$var$ts
                                }), $5bdbe1ebf6713620$var$u.append(this.nodes.actions, this.nodes.plusButton), this.readOnlyMutableListeners.on(this.nodes.plusButton, "click", function() {
                                    $5bdbe1ebf6713620$var$$e(!0), _this.plusButtonClicked();
                                }, !1);
                                e = $5bdbe1ebf6713620$var$u.make("div");
                                e.appendChild(document.createTextNode($5bdbe1ebf6713620$var$z.ui($5bdbe1ebf6713620$var$K.ui.toolbar.toolbox, "Add"))), e.appendChild($5bdbe1ebf6713620$var$u.make("div", this.CSS.plusButtonShortcut, {
                                    textContent: "/"
                                })), $5bdbe1ebf6713620$var$ze(this.nodes.plusButton, e, {
                                    hidingDelay: 400
                                }), this.nodes.settingsToggler = $5bdbe1ebf6713620$var$u.make("span", this.CSS.settingsToggler, {
                                    innerHTML: $5bdbe1ebf6713620$var$es
                                }), $5bdbe1ebf6713620$var$u.append(this.nodes.actions, this.nodes.settingsToggler);
                                t1 = $5bdbe1ebf6713620$var$u.make("div"), o = $5bdbe1ebf6713620$var$u.text($5bdbe1ebf6713620$var$z.ui($5bdbe1ebf6713620$var$K.ui.blockTunes.toggler, "Click to tune"));
                                return [
                                    4,
                                    $5bdbe1ebf6713620$var$xs("Slash", "/")
                                ];
                            case 1:
                                i = _state.sent();
                                t1.appendChild(o), t1.appendChild($5bdbe1ebf6713620$var$u.make("div", this.CSS.plusButtonShortcut, {
                                    textContent: $5bdbe1ebf6713620$var$vt("CMD + ".concat(i))
                                })), $5bdbe1ebf6713620$var$ze(this.nodes.settingsToggler, t1, {
                                    hidingDelay: 400
                                }), $5bdbe1ebf6713620$var$u.append(this.nodes.actions, this.makeToolbox()), $5bdbe1ebf6713620$var$u.append(this.nodes.actions, this.Editor.BlockSettings.getElement()), $5bdbe1ebf6713620$var$u.append(this.Editor.UI.nodes.wrapper, this.nodes.wrapper);
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Creates the Toolbox instance and return it's rendered element
   */ key: "makeToolbox",
            value: function makeToolbox() {
                var _this = this;
                return this.toolboxInstance = new $5bdbe1ebf6713620$var$Es({
                    api: this.Editor.API.methods,
                    tools: this.Editor.Tools.blockTools,
                    i18nLabels: {
                        filter: $5bdbe1ebf6713620$var$z.ui($5bdbe1ebf6713620$var$K.ui.popover, "Filter"),
                        nothingFound: $5bdbe1ebf6713620$var$z.ui($5bdbe1ebf6713620$var$K.ui.popover, "Nothing found")
                    }
                }), this.toolboxInstance.on($5bdbe1ebf6713620$var$Le.Opened, function() {
                    _this.Editor.UI.nodes.wrapper.classList.add(_this.CSS.openedToolboxHolderModifier);
                }), this.toolboxInstance.on($5bdbe1ebf6713620$var$Le.Closed, function() {
                    _this.Editor.UI.nodes.wrapper.classList.remove(_this.CSS.openedToolboxHolderModifier);
                }), this.toolboxInstance.on($5bdbe1ebf6713620$var$Le.BlockAdded, function(param) {
                    var e = param.block;
                    var _this_Editor = _this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.Caret, i = t1.getBlockById(e.id);
                    i.inputs.length === 0 && (i === t1.lastBlock ? (t1.insertAtEnd(), o.setToBlock(t1.lastBlock)) : o.setToBlock(t1.nextBlock));
                }), this.toolboxInstance.getElement();
            }
        },
        {
            /**
   * Handler for Plus Button
   */ key: "plusButtonClicked",
            value: function plusButtonClicked() {
                var e;
                this.Editor.BlockManager.currentBlock = this.hoveredBlock, (e = this.toolboxInstance) == null || e.toggle();
            }
        },
        {
            /**
   * Enable bindings
   */ key: "enableModuleBindings",
            value: function enableModuleBindings() {
                var _this = this;
                this.readOnlyMutableListeners.on(this.nodes.settingsToggler, "mousedown", function(e) {
                    var t1;
                    e.stopPropagation(), _this.settingsTogglerClicked(), (t1 = _this.toolboxInstance) != null && t1.opened && _this.toolboxInstance.close(), $5bdbe1ebf6713620$var$$e(!0);
                }, !0), $5bdbe1ebf6713620$var$be() || this.eventsDispatcher.on($5bdbe1ebf6713620$var$ln, function(e) {
                    var t1;
                    _this.Editor.BlockSettings.opened || (t1 = _this.toolboxInstance) != null && t1.opened || _this.moveAndOpen(e.block);
                });
            }
        },
        {
            /**
   * Disable bindings
   */ key: "disableModuleBindings",
            value: function disableModuleBindings() {
                this.readOnlyMutableListeners.clearAll();
            }
        },
        {
            /**
   * Clicks on the Block Settings toggler
   */ key: "settingsTogglerClicked",
            value: function settingsTogglerClicked() {
                this.Editor.BlockManager.currentBlock = this.hoveredBlock, this.Editor.BlockSettings.opened ? this.Editor.BlockSettings.close() : this.Editor.BlockSettings.open(this.hoveredBlock);
            }
        },
        {
            /**
   * Draws Toolbar UI
   *
   * Toolbar contains BlockSettings and Toolbox.
   * That's why at first we draw its components and then Toolbar itself
   *
   * Steps:
   *  - Make Toolbar dependent components like BlockSettings, Toolbox and so on
   *  - Make itself and append dependent nodes to itself
   *
   */ key: "drawUI",
            value: function drawUI() {
                this.Editor.BlockSettings.make(), this.make();
            }
        },
        {
            /**
   * Removes all created and saved HTMLElements
   * It is used in Read-Only mode
   */ key: "destroy",
            value: function destroy() {
                this.removeAllNodes(), this.toolboxInstance && this.toolboxInstance.destroy();
            }
        }
    ]);
    return Bs;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$ae = /* @__PURE__ */ function(n) {
    return n[n.Block = 0] = "Block", n[n.Inline = 1] = "Inline", n[n.Tune = 2] = "Tune", n;
}($5bdbe1ebf6713620$var$ae || {}), $5bdbe1ebf6713620$var$Pe = /* @__PURE__ */ function(n) {
    return n.Shortcut = "shortcut", n.Toolbox = "toolbox", n.EnabledInlineTools = "inlineToolbar", n.EnabledBlockTunes = "tunes", n.Config = "config", n;
}($5bdbe1ebf6713620$var$Pe || {}), $5bdbe1ebf6713620$var$cn = /* @__PURE__ */ function(n) {
    return n.Shortcut = "shortcut", n.SanitizeConfig = "sanitize", n;
}($5bdbe1ebf6713620$var$cn || {}), $5bdbe1ebf6713620$var$pe = /* @__PURE__ */ function(n) {
    return n.IsEnabledLineBreaks = "enableLineBreaks", n.Toolbox = "toolbox", n.ConversionConfig = "conversionConfig", n.IsReadOnlySupported = "isReadOnlySupported", n.PasteConfig = "pasteConfig", n;
}($5bdbe1ebf6713620$var$pe || {}), $5bdbe1ebf6713620$var$We = /* @__PURE__ */ function(n) {
    return n.IsInline = "isInline", n.Title = "title", n.IsReadOnlySupported = "isReadOnlySupported", n;
}($5bdbe1ebf6713620$var$We || {}), $5bdbe1ebf6713620$var$mt = /* @__PURE__ */ function(n) {
    return n.IsTune = "isTune", n;
}($5bdbe1ebf6713620$var$mt || {});
var $5bdbe1ebf6713620$var$Tt = /*#__PURE__*/ function() {
    "use strict";
    function Tt(param) {
        var e = param.name, t1 = param.constructable, o = param.config, i = param.api, s = param.isDefault, tmp = param.isInternal, r = tmp === void 0 ? !1 : tmp, a = param.defaultPlaceholder;
        (0, $173N4._)(this, Tt);
        this.api = i, this.name = e, this.constructable = t1, this.config = o, this.isDefault = s, this.isInternal = r, this.defaultPlaceholder = a;
    }
    (0, $cFHGC._)(Tt, [
        {
            key: "settings",
            get: /**
   * Returns Tool user configuration
   */ function get() {
                var e = this.config.config || {};
                return this.isDefault && !("placeholder" in e) && this.defaultPlaceholder && (e.placeholder = this.defaultPlaceholder), e;
            }
        },
        {
            /**
   * Calls Tool's reset method
   */ key: "reset",
            value: function reset() {
                if ($5bdbe1ebf6713620$var$A(this.constructable.reset)) return this.constructable.reset();
            }
        },
        {
            /**
   * Calls Tool's prepare method
   */ key: "prepare",
            value: function prepare() {
                if ($5bdbe1ebf6713620$var$A(this.constructable.prepare)) return this.constructable.prepare({
                    toolName: this.name,
                    config: this.settings
                });
            }
        },
        {
            key: "shortcut",
            get: /**
   * Returns shortcut for Tool (internal or specified by user)
   */ function get() {
                var e = this.constructable.shortcut;
                return this.config.shortcut || e;
            }
        },
        {
            key: "sanitizeConfig",
            get: /**
   * Returns Tool's sanitizer configuration
   */ function get() {
                return this.constructable.sanitize || {};
            }
        },
        {
            /**
   * Returns true if Tools is inline
   */ key: "isInline",
            value: function isInline() {
                return this.type === $5bdbe1ebf6713620$var$ae.Inline;
            }
        },
        {
            /**
   * Returns true if Tools is block
   */ key: "isBlock",
            value: function isBlock() {
                return this.type === $5bdbe1ebf6713620$var$ae.Block;
            }
        },
        {
            /**
   * Returns true if Tools is tune
   */ key: "isTune",
            value: function isTune() {
                return this.type === $5bdbe1ebf6713620$var$ae.Tune;
            }
        }
    ]);
    return Tt;
}();
var $5bdbe1ebf6713620$var$Cs = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(Cs, E);
    function Cs(param) {
        var e = param.config, t1 = param.eventsDispatcher;
        (0, $173N4._)(this, Cs);
        var _this;
        _this = (0, $7qXGD._)(this, Cs, [
            {
                config: e,
                eventsDispatcher: t1
            }
        ]), _this.CSS = {
            inlineToolbar: "ce-inline-toolbar"
        }, _this.opened = !1, _this.popover = null, _this.toolbarVerticalMargin = $5bdbe1ebf6713620$var$be() ? 20 : 6, _this.tools = /* @__PURE__ */ new Map(), window.requestIdleCallback(function() {
            _this.make();
        }, {
            timeout: 2e3
        });
        return _this;
    }
    (0, $cFHGC._)(Cs, [
        {
            key: "tryToShow",
            value: /**
   *  Moving / appearance
   *  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
   */ /**
   * Shows Inline Toolbar if something is selected
   *
   * @param [needToClose] - pass true to close toolbar if it is not allowed.
   *                                  Avoid to use it just for closing IT, better call .close() clearly.
   */ function tryToShow() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var e, _tmp;
                    var _arguments = arguments;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : !1;
                                e && this.close();
                                _tmp = this.allowedToShow();
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.open()
                                ];
                            case 1:
                                _tmp = (_state.sent(), this.Editor.Toolbar.close());
                                _state.label = 2;
                            case 2:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            /**
   * Hides Inline Toolbar
   */ key: "close",
            value: function close() {
                var e, t1;
                if (this.opened) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.tools[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $f9AOD._)(_step.value, 2), o = _step_value[0], i = _step_value[1];
                            var s = this.getToolShortcut(o.name);
                            s !== void 0 && $5bdbe1ebf6713620$var$ge.remove(this.Editor.UI.nodes.redactor, s), $5bdbe1ebf6713620$var$A(i.clear) && i.clear();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this.tools = /* @__PURE__ */ new Map(), this.reset(), this.opened = !1, (e = this.popover) == null || e.hide(), (t1 = this.popover) == null || t1.destroy(), this.popover = null;
                }
            }
        },
        {
            /**
   * Check if node is contained by Inline Toolbar
   *
   * @param {Node} node — node to check
   */ key: "containsNode",
            value: function containsNode(e) {
                return this.nodes.wrapper === void 0 ? !1 : this.nodes.wrapper.contains(e);
            }
        },
        {
            /**
   * Removes UI and its components
   */ key: "destroy",
            value: function destroy() {
                var e;
                this.removeAllNodes(), (e = this.popover) == null || e.destroy(), this.popover = null;
            }
        },
        {
            /**
   * Making DOM
   */ key: "make",
            value: function make() {
                this.nodes.wrapper = $5bdbe1ebf6713620$var$u.make("div", [
                    this.CSS.inlineToolbar
                ].concat((0, $aUGqu._)(this.isRtl ? [
                    this.Editor.UI.CSS.editorRtlFix
                ] : []))), $5bdbe1ebf6713620$var$u.append(this.Editor.UI.nodes.wrapper, this.nodes.wrapper);
            }
        },
        {
            key: "open",
            value: /**
   * Shows Inline Toolbar
   */ function open() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var t1, e;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (this.opened) return [
                                    2
                                ];
                                this.opened = !0, this.popover !== null && this.popover.destroy(), this.createToolsInstances();
                                return [
                                    4,
                                    this.getPopoverItems()
                                ];
                            case 1:
                                e = _state.sent();
                                this.popover = new $5bdbe1ebf6713620$var$hs({
                                    items: e,
                                    scopeElement: this.Editor.API.methods.ui.nodes.redactor,
                                    messages: {
                                        nothingFound: $5bdbe1ebf6713620$var$z.ui($5bdbe1ebf6713620$var$K.ui.popover, "Nothing found"),
                                        search: $5bdbe1ebf6713620$var$z.ui($5bdbe1ebf6713620$var$K.ui.popover, "Filter")
                                    }
                                }), this.move(this.popover.size.width), (t1 = this.nodes.wrapper) == null || t1.append(this.popover.getElement()), this.popover.show();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Move Toolbar to the selected text
   *
   * @param popoverWidth - width of the toolbar popover
   */ key: "move",
            value: function move(e) {
                var t1 = $5bdbe1ebf6713620$var$b.rect, o = this.Editor.UI.nodes.wrapper.getBoundingClientRect(), i = {
                    x: t1.x - o.x,
                    y: t1.y + t1.height - // + window.scrollY
                    o.top + this.toolbarVerticalMargin
                };
                i.x + e + o.x > this.Editor.UI.contentRect.right && (i.x = this.Editor.UI.contentRect.right - e - o.x), this.nodes.wrapper.style.left = Math.floor(i.x) + "px", this.nodes.wrapper.style.top = Math.floor(i.y) + "px";
            }
        },
        {
            /**
   * Clear orientation classes and reset position
   */ key: "reset",
            value: function reset() {
                this.nodes.wrapper.style.left = "0", this.nodes.wrapper.style.top = "0";
            }
        },
        {
            /**
   * Need to show Inline Toolbar or not
   */ key: "allowedToShow",
            value: function allowedToShow() {
                var e = [
                    "IMG",
                    "INPUT"
                ], t1 = $5bdbe1ebf6713620$var$b.get(), o = $5bdbe1ebf6713620$var$b.text;
                if (!t1 || !t1.anchorNode || t1.isCollapsed || o.length < 1) return !1;
                var i = $5bdbe1ebf6713620$var$u.isElement(t1.anchorNode) ? t1.anchorNode : t1.anchorNode.parentElement;
                if (i === null || t1 !== null && e.includes(i.tagName)) return !1;
                var s = this.Editor.BlockManager.getBlock(t1.anchorNode);
                return !s || this.getTools().some(function(c) {
                    return s.tool.inlineTools.has(c.name);
                }) === !1 ? !1 : i.closest("[contenteditable]") !== null;
            }
        },
        {
            /**
   *  Working with Tools
   *  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
   */ /**
   * Returns tools that are available for current block
   *
   * Used to check if Inline Toolbar could be shown
   * and to render tools in the Inline Toolbar
   */ key: "getTools",
            value: function getTools() {
                var _this = this;
                var e = this.Editor.BlockManager.currentBlock;
                return e ? Array.from(e.tool.inlineTools.values()).filter(function(o) {
                    return !(_this.Editor.ReadOnly.isEnabled && o.isReadOnlySupported !== !0);
                }) : [];
            }
        },
        {
            /**
   * Constructs tools instances and saves them to this.tools
   */ key: "createToolsInstances",
            value: function createToolsInstances() {
                var _this = this;
                this.tools = /* @__PURE__ */ new Map(), this.getTools().forEach(function(t1) {
                    var o = t1.create();
                    _this.tools.set(t1, o);
                });
            }
        },
        {
            key: "getPopoverItems",
            value: /**
   * Returns Popover Items for tools segregated by their appearance type: regular items and custom html elements.
   */ function getPopoverItems() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _this, e, t1, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _this1, _loop, _iterator, _step, err;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                e = [];
                                t1 = 0;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _loop = function() {
                                    var _step_value, o, i, s, r, a, l;
                                    return (0, $13u2V._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _step_value = (0, $f9AOD._)(_step.value, 2), o = _step_value[0], i = _step_value[1];
                                                return [
                                                    4,
                                                    i.render()
                                                ];
                                            case 1:
                                                s = _state.sent(), r = _this1.getToolShortcut(o.name);
                                                if (r !== void 0) try {
                                                    _this1.enableShortcuts(o.name, r);
                                                } catch (e) {}
                                                a = r !== void 0 ? $5bdbe1ebf6713620$var$vt(r) : void 0, l = $5bdbe1ebf6713620$var$z.t($5bdbe1ebf6713620$var$K.toolNames, o.title || $5bdbe1ebf6713620$var$je(o.name));
                                                [
                                                    s
                                                ].flat().forEach(function(c) {
                                                    var h, p;
                                                    var d = {
                                                        name: o.name,
                                                        onActivate: function() {
                                                            _this.toolClicked(i);
                                                        },
                                                        hint: {
                                                            title: l,
                                                            description: a
                                                        }
                                                    };
                                                    if ($5bdbe1ebf6713620$var$u.isElement(c)) {
                                                        var g = (0, $6fpqi._)((0, $1XAnY._)({}, d), {
                                                            element: c,
                                                            type: $5bdbe1ebf6713620$var$_.Html
                                                        });
                                                        if ($5bdbe1ebf6713620$var$A(i.renderActions)) {
                                                            var f = i.renderActions();
                                                            g.children = {
                                                                isOpen: (h = i.checkState) == null ? void 0 : h.call(i, $5bdbe1ebf6713620$var$b.get()),
                                                                /** Disable keyboard navigation in actions, as it might conflict with enter press handling */ isFlippable: !1,
                                                                items: [
                                                                    {
                                                                        type: $5bdbe1ebf6713620$var$_.Html,
                                                                        element: f
                                                                    }
                                                                ]
                                                            };
                                                        } else (p = i.checkState) == null || p.call(i, $5bdbe1ebf6713620$var$b.get());
                                                        e.push(g);
                                                    } else if (c.type === $5bdbe1ebf6713620$var$_.Html) e.push((0, $6fpqi._)((0, $1XAnY._)({}, d, c), {
                                                        type: $5bdbe1ebf6713620$var$_.Html
                                                    }));
                                                    else if (c.type === $5bdbe1ebf6713620$var$_.Separator) e.push({
                                                        type: $5bdbe1ebf6713620$var$_.Separator
                                                    });
                                                    else {
                                                        var g1 = (0, $6fpqi._)((0, $1XAnY._)({}, d, c), {
                                                            type: $5bdbe1ebf6713620$var$_.Default
                                                        });
                                                        "children" in g1 && t1 !== 0 && e.push({
                                                            type: $5bdbe1ebf6713620$var$_.Separator
                                                        }), e.push(g1), "children" in g1 && t1 < _this.tools.size - 1 && e.push({
                                                            type: $5bdbe1ebf6713620$var$_.Separator
                                                        });
                                                    }
                                                }), t1++;
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                _iterator = this.tools[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                _this1 = this;
                                return [
                                    5,
                                    (0, $Csf8W.__values)(_loop())
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Get shortcut name for tool
   *
   * @param toolName — Tool name
   */ key: "getToolShortcut",
            value: function getToolShortcut(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.Tools, o = t1.inlineTools.get(e), i = t1.internal.inlineTools;
                return Array.from(i.keys()).includes(e) ? this.inlineTools[e][$5bdbe1ebf6713620$var$cn.Shortcut] : o == null ? void 0 : o.shortcut;
            }
        },
        {
            /**
   * Enable Tool shortcut with Editor Shortcuts Module
   *
   * @param toolName - tool name
   * @param shortcut - shortcut according to the ShortcutData Module format
   */ key: "enableShortcuts",
            value: function enableShortcuts(e, t1) {
                var _this = this;
                $5bdbe1ebf6713620$var$ge.add({
                    name: t1,
                    handler: function(o) {
                        var s;
                        var _this_Editor_BlockManager = _this.Editor.BlockManager, i = _this_Editor_BlockManager.currentBlock;
                        i && i.tool.enabledInlineTools && (o.preventDefault(), (s = _this.popover) == null || s.activateItemByName(e));
                    },
                    /**
       * We need to bind shortcut to the document to make it work in read-only mode
       */ on: document
                });
            }
        },
        {
            /**
   * Inline Tool button clicks
   *
   * @param tool - Tool's instance
   */ key: "toolClicked",
            value: function toolClicked(e) {
                var o;
                var t1 = $5bdbe1ebf6713620$var$b.range;
                (o = e.surround) == null || o.call(e, t1), this.checkToolsState();
            }
        },
        {
            /**
   * Check Tools` state by selection
   */ key: "checkToolsState",
            value: function checkToolsState() {
                var e;
                (e = this.tools) == null || e.forEach(function(t1) {
                    var o;
                    (o = t1.checkState) == null || o.call(t1, $5bdbe1ebf6713620$var$b.get());
                });
            }
        },
        {
            key: "inlineTools",
            get: /**
   * Get inline tools tools
   * Tools that has isInline is true
   */ function get() {
                var e = {};
                return Array.from(this.Editor.Tools.inlineTools.entries()).forEach(function(param) {
                    var _param = (0, $f9AOD._)(param, 2), t1 = _param[0], o = _param[1];
                    e[t1] = o.create();
                }), e;
            }
        }
    ]);
    return Cs;
}($5bdbe1ebf6713620$var$E);
function $5bdbe1ebf6713620$var$dn() {
    var n = window.getSelection();
    if (n === null) return [
        null,
        0
    ];
    var e = n.focusNode, t1 = n.focusOffset;
    return e === null ? [
        null,
        0
    ] : (e.nodeType !== Node.TEXT_NODE && e.childNodes.length > 0 && (e.childNodes[t1] ? (e = e.childNodes[t1], t1 = 0) : (e = e.childNodes[t1 - 1], t1 = e.textContent.length)), [
        e,
        t1
    ]);
}
function $5bdbe1ebf6713620$var$un(n, e, t1, o) {
    var i = document.createRange();
    o === "left" ? (i.setStart(n, 0), i.setEnd(e, t1)) : (i.setStart(e, t1), i.setEnd(n, n.childNodes.length));
    var s = i.cloneContents(), r = document.createElement("div");
    r.appendChild(s);
    var a = r.textContent || "";
    return $5bdbe1ebf6713620$var$ai(a);
}
function $5bdbe1ebf6713620$var$Ne(n) {
    var e = $5bdbe1ebf6713620$var$u.getDeepestNode(n);
    if (e === null || $5bdbe1ebf6713620$var$u.isEmpty(n)) return !0;
    if ($5bdbe1ebf6713620$var$u.isNativeInput(e)) return e.selectionEnd === 0;
    if ($5bdbe1ebf6713620$var$u.isEmpty(n)) return !0;
    var _dn = (0, $f9AOD._)($5bdbe1ebf6713620$var$dn(), 2), t1 = _dn[0], o = _dn[1];
    return t1 === null ? !1 : $5bdbe1ebf6713620$var$un(n, t1, o, "left");
}
function $5bdbe1ebf6713620$var$Re(n) {
    var e = $5bdbe1ebf6713620$var$u.getDeepestNode(n, !0);
    if (e === null) return !0;
    if ($5bdbe1ebf6713620$var$u.isNativeInput(e)) return e.selectionEnd === e.value.length;
    var _dn = (0, $f9AOD._)($5bdbe1ebf6713620$var$dn(), 2), t1 = _dn[0], o = _dn[1];
    return t1 === null ? !1 : $5bdbe1ebf6713620$var$un(n, t1, o, "right");
}
var $5bdbe1ebf6713620$var$hn = {}, $5bdbe1ebf6713620$var$St = {}, $5bdbe1ebf6713620$var$Xe = {}, $5bdbe1ebf6713620$var$de = {}, $5bdbe1ebf6713620$var$It = {}, $5bdbe1ebf6713620$var$Ot = {};
Object.defineProperty($5bdbe1ebf6713620$var$Ot, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$Ot.allInputsSelector = $5bdbe1ebf6713620$var$Ts;
function $5bdbe1ebf6713620$var$Ts() {
    var n = [
        "text",
        "password",
        "email",
        "number",
        "search",
        "tel",
        "url"
    ];
    return "[contenteditable=true], textarea, input:not([type]), " + n.map(function(e) {
        return 'input[type="'.concat(e, '"]');
    }).join(", ");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.allInputsSelector = void 0;
    var e = $5bdbe1ebf6713620$var$Ot;
    Object.defineProperty(n, "allInputsSelector", {
        enumerable: !0,
        get: function get() {
            return e.allInputsSelector;
        }
    });
})($5bdbe1ebf6713620$var$It);
var $5bdbe1ebf6713620$var$ue = {}, $5bdbe1ebf6713620$var$_t = {};
Object.defineProperty($5bdbe1ebf6713620$var$_t, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$_t.isNativeInput = $5bdbe1ebf6713620$var$Ss;
function $5bdbe1ebf6713620$var$Ss(n) {
    var e = [
        "INPUT",
        "TEXTAREA"
    ];
    return n && n.tagName ? e.includes(n.tagName) : !1;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isNativeInput = void 0;
    var e = $5bdbe1ebf6713620$var$_t;
    Object.defineProperty(n, "isNativeInput", {
        enumerable: !0,
        get: function get() {
            return e.isNativeInput;
        }
    });
})($5bdbe1ebf6713620$var$ue);
var $5bdbe1ebf6713620$var$pn = {}, $5bdbe1ebf6713620$var$Mt = {};
Object.defineProperty($5bdbe1ebf6713620$var$Mt, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$Mt.append = $5bdbe1ebf6713620$var$Is;
function $5bdbe1ebf6713620$var$Is(n, e) {
    Array.isArray(e) ? e.forEach(function(t1) {
        n.appendChild(t1);
    }) : n.appendChild(e);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.append = void 0;
    var e = $5bdbe1ebf6713620$var$Mt;
    Object.defineProperty(n, "append", {
        enumerable: !0,
        get: function get() {
            return e.append;
        }
    });
})($5bdbe1ebf6713620$var$pn);
var $5bdbe1ebf6713620$var$At = {}, $5bdbe1ebf6713620$var$Lt = {};
Object.defineProperty($5bdbe1ebf6713620$var$Lt, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$Lt.blockElements = $5bdbe1ebf6713620$var$Os;
function $5bdbe1ebf6713620$var$Os() {
    return [
        "address",
        "article",
        "aside",
        "blockquote",
        "canvas",
        "div",
        "dl",
        "dt",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "hgroup",
        "hr",
        "li",
        "main",
        "nav",
        "noscript",
        "ol",
        "output",
        "p",
        "pre",
        "ruby",
        "section",
        "table",
        "tbody",
        "thead",
        "tr",
        "tfoot",
        "ul",
        "video"
    ];
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.blockElements = void 0;
    var e = $5bdbe1ebf6713620$var$Lt;
    Object.defineProperty(n, "blockElements", {
        enumerable: !0,
        get: function get() {
            return e.blockElements;
        }
    });
})($5bdbe1ebf6713620$var$At);
var $5bdbe1ebf6713620$var$fn = {}, $5bdbe1ebf6713620$var$Pt = {};
Object.defineProperty($5bdbe1ebf6713620$var$Pt, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$Pt.calculateBaseline = $5bdbe1ebf6713620$var$_s;
function $5bdbe1ebf6713620$var$_s(n) {
    var e = window.getComputedStyle(n), t1 = parseFloat(e.fontSize), o = parseFloat(e.lineHeight) || t1 * 1.2, i = parseFloat(e.paddingTop), s = parseFloat(e.borderTopWidth), r = parseFloat(e.marginTop), a = t1 * 0.8, l = (o - t1) / 2, c = r + s + i + l + a;
    return c;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.calculateBaseline = void 0;
    var e = $5bdbe1ebf6713620$var$Pt;
    Object.defineProperty(n, "calculateBaseline", {
        enumerable: !0,
        get: function get() {
            return e.calculateBaseline;
        }
    });
})($5bdbe1ebf6713620$var$fn);
var $5bdbe1ebf6713620$var$gn = {}, $5bdbe1ebf6713620$var$Nt = {}, $5bdbe1ebf6713620$var$Rt = {}, $5bdbe1ebf6713620$var$Dt = {};
Object.defineProperty($5bdbe1ebf6713620$var$Dt, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$Dt.isContentEditable = $5bdbe1ebf6713620$var$Ms;
function $5bdbe1ebf6713620$var$Ms(n) {
    return n.contentEditable === "true";
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isContentEditable = void 0;
    var e = $5bdbe1ebf6713620$var$Dt;
    Object.defineProperty(n, "isContentEditable", {
        enumerable: !0,
        get: function get() {
            return e.isContentEditable;
        }
    });
})($5bdbe1ebf6713620$var$Rt);
Object.defineProperty($5bdbe1ebf6713620$var$Nt, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$Nt.canSetCaret = $5bdbe1ebf6713620$var$Ps;
var $5bdbe1ebf6713620$var$As = $5bdbe1ebf6713620$var$ue, $5bdbe1ebf6713620$var$Ls = $5bdbe1ebf6713620$var$Rt;
function $5bdbe1ebf6713620$var$Ps(n) {
    var e = !0;
    if ((0, $5bdbe1ebf6713620$var$As.isNativeInput)(n)) switch(n.type){
        case "file":
        case "checkbox":
        case "radio":
        case "hidden":
        case "submit":
        case "button":
        case "image":
        case "reset":
            e = !1;
            break;
    }
    else e = (0, $5bdbe1ebf6713620$var$Ls.isContentEditable)(n);
    return e;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.canSetCaret = void 0;
    var e = $5bdbe1ebf6713620$var$Nt;
    Object.defineProperty(n, "canSetCaret", {
        enumerable: !0,
        get: function get() {
            return e.canSetCaret;
        }
    });
})($5bdbe1ebf6713620$var$gn);
var $5bdbe1ebf6713620$var$Ve = {}, $5bdbe1ebf6713620$var$Ft = {};
function $5bdbe1ebf6713620$var$Ns(n, e, t1) {
    var o = t1.value !== void 0 ? "value" : "get", i = t1[o], s = "#".concat(e, "Cache");
    if (t1[o] = function() {
        for(var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++){
            r[_key] = arguments[_key];
        }
        return this[s] === void 0 && (this[s] = i.apply(this, r)), this[s];
    }, o === "get" && t1.set) {
        var r = t1.set;
        t1.set = function(a) {
            delete n[s], r.apply(this, a);
        };
    }
    return t1;
}
function $5bdbe1ebf6713620$var$mn() {
    var n = {
        win: !1,
        mac: !1,
        x11: !1,
        linux: !1
    }, e = Object.keys(n).find(function(t1) {
        return window.navigator.appVersion.toLowerCase().indexOf(t1) !== -1;
    });
    return e !== void 0 && (n[e] = !0), n;
}
function $5bdbe1ebf6713620$var$jt(n) {
    return n != null && n !== "" && ((typeof n === "undefined" ? "undefined" : (0, $7E0eS._)(n)) != "object" || Object.keys(n).length > 0);
}
function $5bdbe1ebf6713620$var$Rs(n) {
    return !$5bdbe1ebf6713620$var$jt(n);
}
var $5bdbe1ebf6713620$var$Ds = function() {
    return (typeof window === "undefined" ? "undefined" : (0, $7E0eS._)(window)) < "u" && window.navigator !== null && $5bdbe1ebf6713620$var$jt(window.navigator.platform) && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
};
function $5bdbe1ebf6713620$var$Fs(n) {
    var e = $5bdbe1ebf6713620$var$mn();
    return n = n.replace(/shift/gi, "\u21E7").replace(/backspace/gi, "\u232B").replace(/enter/gi, "\u23CE").replace(/up/gi, "\u2191").replace(/left/gi, "\u2192").replace(/down/gi, "\u2193").replace(/right/gi, "\u2190").replace(/escape/gi, "\u238B").replace(/insert/gi, "Ins").replace(/delete/gi, "\u2421").replace(/\+/gi, "+"), e.mac ? n = n.replace(/ctrl|cmd/gi, "\u2318").replace(/alt/gi, "\u2325") : n = n.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), n;
}
function $5bdbe1ebf6713620$var$js(n) {
    return n[0].toUpperCase() + n.slice(1);
}
function $5bdbe1ebf6713620$var$Hs(n) {
    var e = document.createElement("div");
    e.style.position = "absolute", e.style.left = "-999px", e.style.bottom = "-999px", e.innerHTML = n, document.body.appendChild(e);
    var t1 = window.getSelection(), o = document.createRange();
    if (o.selectNode(e), t1 === null) throw new Error("Cannot copy text to clipboard");
    t1.removeAllRanges(), t1.addRange(o), document.execCommand("copy"), document.body.removeChild(e);
}
function $5bdbe1ebf6713620$var$$s(n, e, t1) {
    var _this = this;
    var o;
    return function() {
        for(var _len = arguments.length, i = new Array(_len), _key = 0; _key < _len; _key++){
            i[_key] = arguments[_key];
        }
        var s = _this, r = function() {
            o = void 0, t1 !== !0 && n.apply(s, i);
        }, a = t1 === !0 && o !== void 0;
        window.clearTimeout(o), o = window.setTimeout(r, e), a && n.apply(s, i);
    };
}
function $5bdbe1ebf6713620$var$oe(n) {
    return Object.prototype.toString.call(n).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $5bdbe1ebf6713620$var$zs(n) {
    return $5bdbe1ebf6713620$var$oe(n) === "boolean";
}
function $5bdbe1ebf6713620$var$bn(n) {
    return $5bdbe1ebf6713620$var$oe(n) === "function" || $5bdbe1ebf6713620$var$oe(n) === "asyncfunction";
}
function $5bdbe1ebf6713620$var$Us(n) {
    return $5bdbe1ebf6713620$var$bn(n) && /^\s*class\s+/.test(n.toString());
}
function $5bdbe1ebf6713620$var$Ws(n) {
    return $5bdbe1ebf6713620$var$oe(n) === "number";
}
function $5bdbe1ebf6713620$var$De(n) {
    return $5bdbe1ebf6713620$var$oe(n) === "object";
}
function $5bdbe1ebf6713620$var$Ys(n) {
    return Promise.resolve(n) === n;
}
function $5bdbe1ebf6713620$var$Ks(n) {
    return $5bdbe1ebf6713620$var$oe(n) === "string";
}
function $5bdbe1ebf6713620$var$Xs(n) {
    return $5bdbe1ebf6713620$var$oe(n) === "undefined";
}
function $5bdbe1ebf6713620$var$bt(n) {
    for(var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        e[_key - 1] = arguments[_key];
    }
    if (!e.length) return n;
    var t1 = e.shift();
    if ($5bdbe1ebf6713620$var$De(n) && $5bdbe1ebf6713620$var$De(t1)) for(var o in t1)$5bdbe1ebf6713620$var$De(t1[o]) ? (n[o] === void 0 && Object.assign(n, (0, $7Pjls._)({}, o, {})), $5bdbe1ebf6713620$var$bt(n[o], t1[o])) : Object.assign(n, (0, $7Pjls._)({}, o, t1[o]));
    return $5bdbe1ebf6713620$var$bt.apply(void 0, [
        n
    ].concat((0, $aUGqu._)(e)));
}
function $5bdbe1ebf6713620$var$Vs(n, e, t1) {
    var o = "\xab".concat(e, "\xbb is deprecated and will be removed in the next major release. Please use the \xab").concat(t1, "\xbb instead.");
    n && console.warn(o);
}
function $5bdbe1ebf6713620$var$qs(n) {
    try {
        return new URL(n).href;
    } catch (e) {}
    return n.substring(0, 2) === "//" ? window.location.protocol + n : window.location.origin + n;
}
function $5bdbe1ebf6713620$var$Zs(n) {
    return n > 47 && n < 58 || n === 32 || n === 13 || n === 229 || n > 64 && n < 91 || n > 95 && n < 112 || n > 185 && n < 193 || n > 218 && n < 223;
}
var $5bdbe1ebf6713620$var$Gs = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    DELETE: 46,
    META: 91,
    SLASH: 191
}, $5bdbe1ebf6713620$var$Qs = {
    LEFT: 0,
    WHEEL: 1,
    RIGHT: 2,
    BACKWARD: 3,
    FORWARD: 4
};
var $5bdbe1ebf6713620$var$Js = /*#__PURE__*/ function() {
    "use strict";
    function Js() {
        (0, $173N4._)(this, Js);
        this.completed = Promise.resolve();
    }
    (0, $cFHGC._)(Js, [
        {
            /**
   * Add new promise to queue
   * @param operation - promise should be added to queue
   */ key: "add",
            value: function add(e) {
                var _this = this;
                return new Promise(function(t1, o) {
                    _this.completed = _this.completed.then(e).then(t1).catch(o);
                });
            }
        }
    ]);
    return Js;
}();
function $5bdbe1ebf6713620$var$er(n, e, t1) {
    var o, i, s, r = null, a = 0;
    t1 || (t1 = {});
    var l = function l() {
        a = t1.leading === !1 ? 0 : Date.now(), r = null, s = n.apply(o, i), r === null && (o = i = null);
    };
    return function() {
        var c = Date.now();
        !a && t1.leading === !1 && (a = c);
        var d = e - (c - a);
        return o = this, i = arguments, d <= 0 || d > e ? (r && (clearTimeout(r), r = null), a = c, s = n.apply(o, i), r === null && (o = i = null)) : !r && t1.trailing !== !1 && (r = setTimeout(l, d)), s;
    };
}
var $5bdbe1ebf6713620$var$tr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    PromiseQueue: $5bdbe1ebf6713620$var$Js,
    beautifyShortcut: $5bdbe1ebf6713620$var$Fs,
    cacheable: $5bdbe1ebf6713620$var$Ns,
    capitalize: $5bdbe1ebf6713620$var$js,
    copyTextToClipboard: $5bdbe1ebf6713620$var$Hs,
    debounce: $5bdbe1ebf6713620$var$$s,
    deepMerge: $5bdbe1ebf6713620$var$bt,
    deprecationAssert: $5bdbe1ebf6713620$var$Vs,
    getUserOS: $5bdbe1ebf6713620$var$mn,
    getValidUrl: $5bdbe1ebf6713620$var$qs,
    isBoolean: $5bdbe1ebf6713620$var$zs,
    isClass: $5bdbe1ebf6713620$var$Us,
    isEmpty: $5bdbe1ebf6713620$var$Rs,
    isFunction: $5bdbe1ebf6713620$var$bn,
    isIosDevice: $5bdbe1ebf6713620$var$Ds,
    isNumber: $5bdbe1ebf6713620$var$Ws,
    isObject: $5bdbe1ebf6713620$var$De,
    isPrintableKey: $5bdbe1ebf6713620$var$Zs,
    isPromise: $5bdbe1ebf6713620$var$Ys,
    isString: $5bdbe1ebf6713620$var$Ks,
    isUndefined: $5bdbe1ebf6713620$var$Xs,
    keyCodes: $5bdbe1ebf6713620$var$Gs,
    mouseButtons: $5bdbe1ebf6713620$var$Qs,
    notEmpty: $5bdbe1ebf6713620$var$jt,
    throttle: $5bdbe1ebf6713620$var$er,
    typeOf: $5bdbe1ebf6713620$var$oe
}, Symbol.toStringTag, {
    value: "Module"
})), $5bdbe1ebf6713620$var$Ht = /* @__PURE__ */ $5bdbe1ebf6713620$var$Xn($5bdbe1ebf6713620$var$tr);
Object.defineProperty($5bdbe1ebf6713620$var$Ft, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$Ft.containsOnlyInlineElements = $5bdbe1ebf6713620$var$ir;
var $5bdbe1ebf6713620$var$or = $5bdbe1ebf6713620$var$Ht, $5bdbe1ebf6713620$var$nr = $5bdbe1ebf6713620$var$At;
function $5bdbe1ebf6713620$var$ir(n) {
    var e;
    (0, $5bdbe1ebf6713620$var$or.isString)(n) ? (e = document.createElement("div"), e.innerHTML = n) : e = n;
    var t1 = function t2(o) {
        return !(0, $5bdbe1ebf6713620$var$nr.blockElements)().includes(o.tagName.toLowerCase()) && Array.from(o.children).every(t1);
    };
    return Array.from(e.children).every(t1);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.containsOnlyInlineElements = void 0;
    var e = $5bdbe1ebf6713620$var$Ft;
    Object.defineProperty(n, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function get() {
            return e.containsOnlyInlineElements;
        }
    });
})($5bdbe1ebf6713620$var$Ve);
var $5bdbe1ebf6713620$var$vn = {}, $5bdbe1ebf6713620$var$$t = {}, $5bdbe1ebf6713620$var$qe = {}, $5bdbe1ebf6713620$var$zt = {};
Object.defineProperty($5bdbe1ebf6713620$var$zt, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$zt.make = $5bdbe1ebf6713620$var$sr;
function $5bdbe1ebf6713620$var$sr(n, e, t1) {
    var o;
    e === void 0 && (e = null), t1 === void 0 && (t1 = {});
    var i = document.createElement(n);
    if (Array.isArray(e)) {
        var s = e.filter(function(a) {
            return a !== void 0;
        });
        (o = i.classList).add.apply(o, s);
    } else e !== null && i.classList.add(e);
    for(var r in t1)Object.prototype.hasOwnProperty.call(t1, r) && (i[r] = t1[r]);
    return i;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.make = void 0;
    var e = $5bdbe1ebf6713620$var$zt;
    Object.defineProperty(n, "make", {
        enumerable: !0,
        get: function get() {
            return e.make;
        }
    });
})($5bdbe1ebf6713620$var$qe);
Object.defineProperty($5bdbe1ebf6713620$var$$t, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$$t.fragmentToString = $5bdbe1ebf6713620$var$ar;
var $5bdbe1ebf6713620$var$rr = $5bdbe1ebf6713620$var$qe;
function $5bdbe1ebf6713620$var$ar(n) {
    var e = (0, $5bdbe1ebf6713620$var$rr.make)("div");
    return e.appendChild(n), e.innerHTML;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.fragmentToString = void 0;
    var e = $5bdbe1ebf6713620$var$$t;
    Object.defineProperty(n, "fragmentToString", {
        enumerable: !0,
        get: function get() {
            return e.fragmentToString;
        }
    });
})($5bdbe1ebf6713620$var$vn);
var $5bdbe1ebf6713620$var$kn = {}, $5bdbe1ebf6713620$var$Ut = {};
Object.defineProperty($5bdbe1ebf6713620$var$Ut, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$Ut.getContentLength = $5bdbe1ebf6713620$var$cr;
var $5bdbe1ebf6713620$var$lr = $5bdbe1ebf6713620$var$ue;
function $5bdbe1ebf6713620$var$cr(n) {
    var e, t1;
    return (0, $5bdbe1ebf6713620$var$lr.isNativeInput)(n) ? n.value.length : n.nodeType === Node.TEXT_NODE ? n.length : (t1 = (e = n.textContent) === null || e === void 0 ? void 0 : e.length) !== null && t1 !== void 0 ? t1 : 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getContentLength = void 0;
    var e = $5bdbe1ebf6713620$var$Ut;
    Object.defineProperty(n, "getContentLength", {
        enumerable: !0,
        get: function get() {
            return e.getContentLength;
        }
    });
})($5bdbe1ebf6713620$var$kn);
var $5bdbe1ebf6713620$var$Wt = {}, $5bdbe1ebf6713620$var$Yt = {}, $5bdbe1ebf6713620$var$Io = $5bdbe1ebf6713620$var$Ce && $5bdbe1ebf6713620$var$Ce.__spreadArray || function(n, e, t1) {
    if (t1 || arguments.length === 2) for(var o = 0, i = e.length, s; o < i; o++)(s || !(o in e)) && (s || (s = Array.prototype.slice.call(e, 0, o)), s[o] = e[o]);
    return n.concat(s || Array.prototype.slice.call(e));
};
Object.defineProperty($5bdbe1ebf6713620$var$Yt, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$Yt.getDeepestBlockElements = $5bdbe1ebf6713620$var$yn;
var $5bdbe1ebf6713620$var$dr = $5bdbe1ebf6713620$var$Ve;
function $5bdbe1ebf6713620$var$yn(n) {
    return (0, $5bdbe1ebf6713620$var$dr.containsOnlyInlineElements)(n) ? [
        n
    ] : Array.from(n.children).reduce(function(e, t1) {
        return $5bdbe1ebf6713620$var$Io($5bdbe1ebf6713620$var$Io([], e, !0), $5bdbe1ebf6713620$var$yn(t1), !0);
    }, []);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getDeepestBlockElements = void 0;
    var e = $5bdbe1ebf6713620$var$Yt;
    Object.defineProperty(n, "getDeepestBlockElements", {
        enumerable: !0,
        get: function get() {
            return e.getDeepestBlockElements;
        }
    });
})($5bdbe1ebf6713620$var$Wt);
var $5bdbe1ebf6713620$var$wn = {}, $5bdbe1ebf6713620$var$Kt = {}, $5bdbe1ebf6713620$var$Ze = {}, $5bdbe1ebf6713620$var$Xt = {};
Object.defineProperty($5bdbe1ebf6713620$var$Xt, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$Xt.isLineBreakTag = $5bdbe1ebf6713620$var$ur;
function $5bdbe1ebf6713620$var$ur(n) {
    return [
        "BR",
        "WBR"
    ].includes(n.tagName);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isLineBreakTag = void 0;
    var e = $5bdbe1ebf6713620$var$Xt;
    Object.defineProperty(n, "isLineBreakTag", {
        enumerable: !0,
        get: function get() {
            return e.isLineBreakTag;
        }
    });
})($5bdbe1ebf6713620$var$Ze);
var $5bdbe1ebf6713620$var$Ge = {}, $5bdbe1ebf6713620$var$Vt = {};
Object.defineProperty($5bdbe1ebf6713620$var$Vt, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$Vt.isSingleTag = $5bdbe1ebf6713620$var$hr;
function $5bdbe1ebf6713620$var$hr(n) {
    return [
        "AREA",
        "BASE",
        "BR",
        "COL",
        "COMMAND",
        "EMBED",
        "HR",
        "IMG",
        "INPUT",
        "KEYGEN",
        "LINK",
        "META",
        "PARAM",
        "SOURCE",
        "TRACK",
        "WBR"
    ].includes(n.tagName);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isSingleTag = void 0;
    var e = $5bdbe1ebf6713620$var$Vt;
    Object.defineProperty(n, "isSingleTag", {
        enumerable: !0,
        get: function get() {
            return e.isSingleTag;
        }
    });
})($5bdbe1ebf6713620$var$Ge);
Object.defineProperty($5bdbe1ebf6713620$var$Kt, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$Kt.getDeepestNode = $5bdbe1ebf6713620$var$En;
var $5bdbe1ebf6713620$var$pr = $5bdbe1ebf6713620$var$ue, $5bdbe1ebf6713620$var$fr = $5bdbe1ebf6713620$var$Ze, $5bdbe1ebf6713620$var$gr = $5bdbe1ebf6713620$var$Ge;
function $5bdbe1ebf6713620$var$En(n, e) {
    e === void 0 && (e = !1);
    var t1 = e ? "lastChild" : "firstChild", o = e ? "previousSibling" : "nextSibling";
    if (n.nodeType === Node.ELEMENT_NODE && n[t1]) {
        var i = n[t1];
        if ((0, $5bdbe1ebf6713620$var$gr.isSingleTag)(i) && !(0, $5bdbe1ebf6713620$var$pr.isNativeInput)(i) && !(0, $5bdbe1ebf6713620$var$fr.isLineBreakTag)(i)) {
            if (i[o]) i = i[o];
            else if (i.parentNode !== null && i.parentNode[o]) i = i.parentNode[o];
            else return i.parentNode;
        }
        return $5bdbe1ebf6713620$var$En(i, e);
    }
    return n;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getDeepestNode = void 0;
    var e = $5bdbe1ebf6713620$var$Kt;
    Object.defineProperty(n, "getDeepestNode", {
        enumerable: !0,
        get: function get() {
            return e.getDeepestNode;
        }
    });
})($5bdbe1ebf6713620$var$wn);
var $5bdbe1ebf6713620$var$xn = {}, $5bdbe1ebf6713620$var$qt = {}, $5bdbe1ebf6713620$var$Me = $5bdbe1ebf6713620$var$Ce && $5bdbe1ebf6713620$var$Ce.__spreadArray || function(n, e, t1) {
    if (t1 || arguments.length === 2) for(var o = 0, i = e.length, s; o < i; o++)(s || !(o in e)) && (s || (s = Array.prototype.slice.call(e, 0, o)), s[o] = e[o]);
    return n.concat(s || Array.prototype.slice.call(e));
};
Object.defineProperty($5bdbe1ebf6713620$var$qt, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$qt.findAllInputs = $5bdbe1ebf6713620$var$yr;
var $5bdbe1ebf6713620$var$mr = $5bdbe1ebf6713620$var$Ve, $5bdbe1ebf6713620$var$br = $5bdbe1ebf6713620$var$Wt, $5bdbe1ebf6713620$var$vr = $5bdbe1ebf6713620$var$It, $5bdbe1ebf6713620$var$kr = $5bdbe1ebf6713620$var$ue;
function $5bdbe1ebf6713620$var$yr(n) {
    return Array.from(n.querySelectorAll((0, $5bdbe1ebf6713620$var$vr.allInputsSelector)())).reduce(function(e, t1) {
        return (0, $5bdbe1ebf6713620$var$kr.isNativeInput)(t1) || (0, $5bdbe1ebf6713620$var$mr.containsOnlyInlineElements)(t1) ? $5bdbe1ebf6713620$var$Me($5bdbe1ebf6713620$var$Me([], e, !0), [
            t1
        ], !1) : $5bdbe1ebf6713620$var$Me($5bdbe1ebf6713620$var$Me([], e, !0), (0, $5bdbe1ebf6713620$var$br.getDeepestBlockElements)(t1), !0);
    }, []);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.findAllInputs = void 0;
    var e = $5bdbe1ebf6713620$var$qt;
    Object.defineProperty(n, "findAllInputs", {
        enumerable: !0,
        get: function get() {
            return e.findAllInputs;
        }
    });
})($5bdbe1ebf6713620$var$xn);
var $5bdbe1ebf6713620$var$Bn = {}, $5bdbe1ebf6713620$var$Zt = {};
Object.defineProperty($5bdbe1ebf6713620$var$Zt, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$Zt.isCollapsedWhitespaces = $5bdbe1ebf6713620$var$wr;
function $5bdbe1ebf6713620$var$wr(n) {
    return !/[^\t\n\r ]/.test(n);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCollapsedWhitespaces = void 0;
    var e = $5bdbe1ebf6713620$var$Zt;
    Object.defineProperty(n, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function get() {
            return e.isCollapsedWhitespaces;
        }
    });
})($5bdbe1ebf6713620$var$Bn);
var $5bdbe1ebf6713620$var$Gt = {}, $5bdbe1ebf6713620$var$Qt = {};
Object.defineProperty($5bdbe1ebf6713620$var$Qt, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$Qt.isElement = $5bdbe1ebf6713620$var$xr;
var $5bdbe1ebf6713620$var$Er = $5bdbe1ebf6713620$var$Ht;
function $5bdbe1ebf6713620$var$xr(n) {
    return (0, $5bdbe1ebf6713620$var$Er.isNumber)(n) ? !1 : !!n && !!n.nodeType && n.nodeType === Node.ELEMENT_NODE;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isElement = void 0;
    var e = $5bdbe1ebf6713620$var$Qt;
    Object.defineProperty(n, "isElement", {
        enumerable: !0,
        get: function get() {
            return e.isElement;
        }
    });
})($5bdbe1ebf6713620$var$Gt);
var $5bdbe1ebf6713620$var$Cn = {}, $5bdbe1ebf6713620$var$Jt = {}, $5bdbe1ebf6713620$var$eo = {}, $5bdbe1ebf6713620$var$to = {};
Object.defineProperty($5bdbe1ebf6713620$var$to, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$to.isLeaf = $5bdbe1ebf6713620$var$Br;
function $5bdbe1ebf6713620$var$Br(n) {
    return n === null ? !1 : n.childNodes.length === 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isLeaf = void 0;
    var e = $5bdbe1ebf6713620$var$to;
    Object.defineProperty(n, "isLeaf", {
        enumerable: !0,
        get: function get() {
            return e.isLeaf;
        }
    });
})($5bdbe1ebf6713620$var$eo);
var $5bdbe1ebf6713620$var$oo = {}, $5bdbe1ebf6713620$var$no = {};
Object.defineProperty($5bdbe1ebf6713620$var$no, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$no.isNodeEmpty = $5bdbe1ebf6713620$var$Or;
var $5bdbe1ebf6713620$var$Cr = $5bdbe1ebf6713620$var$Ze, $5bdbe1ebf6713620$var$Tr = $5bdbe1ebf6713620$var$Gt, $5bdbe1ebf6713620$var$Sr = $5bdbe1ebf6713620$var$ue, $5bdbe1ebf6713620$var$Ir = $5bdbe1ebf6713620$var$Ge;
function $5bdbe1ebf6713620$var$Or(n, e) {
    var t1 = "";
    return (0, $5bdbe1ebf6713620$var$Ir.isSingleTag)(n) && !(0, $5bdbe1ebf6713620$var$Cr.isLineBreakTag)(n) ? !1 : ((0, $5bdbe1ebf6713620$var$Tr.isElement)(n) && (0, $5bdbe1ebf6713620$var$Sr.isNativeInput)(n) ? t1 = n.value : n.textContent !== null && (t1 = n.textContent.replace("\u200B", "")), e !== void 0 && (t1 = t1.replace(new RegExp(e, "g"), "")), t1.trim().length === 0);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isNodeEmpty = void 0;
    var e = $5bdbe1ebf6713620$var$no;
    Object.defineProperty(n, "isNodeEmpty", {
        enumerable: !0,
        get: function get() {
            return e.isNodeEmpty;
        }
    });
})($5bdbe1ebf6713620$var$oo);
Object.defineProperty($5bdbe1ebf6713620$var$Jt, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$Jt.isEmpty = $5bdbe1ebf6713620$var$Ar;
var $5bdbe1ebf6713620$var$_r = $5bdbe1ebf6713620$var$eo, $5bdbe1ebf6713620$var$Mr = $5bdbe1ebf6713620$var$oo;
function $5bdbe1ebf6713620$var$Ar(n, e) {
    n.normalize();
    for(var t1 = [
        n
    ]; t1.length > 0;){
        var o = t1.shift();
        if (o) {
            if (n = o, (0, $5bdbe1ebf6713620$var$_r.isLeaf)(n) && !(0, $5bdbe1ebf6713620$var$Mr.isNodeEmpty)(n, e)) return !1;
            t1.push.apply(t1, Array.from(n.childNodes));
        }
    }
    return !0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isEmpty = void 0;
    var e = $5bdbe1ebf6713620$var$Jt;
    Object.defineProperty(n, "isEmpty", {
        enumerable: !0,
        get: function get() {
            return e.isEmpty;
        }
    });
})($5bdbe1ebf6713620$var$Cn);
var $5bdbe1ebf6713620$var$Tn = {}, $5bdbe1ebf6713620$var$io = {};
Object.defineProperty($5bdbe1ebf6713620$var$io, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$io.isFragment = $5bdbe1ebf6713620$var$Pr;
var $5bdbe1ebf6713620$var$Lr = $5bdbe1ebf6713620$var$Ht;
function $5bdbe1ebf6713620$var$Pr(n) {
    return (0, $5bdbe1ebf6713620$var$Lr.isNumber)(n) ? !1 : !!n && !!n.nodeType && n.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isFragment = void 0;
    var e = $5bdbe1ebf6713620$var$io;
    Object.defineProperty(n, "isFragment", {
        enumerable: !0,
        get: function get() {
            return e.isFragment;
        }
    });
})($5bdbe1ebf6713620$var$Tn);
var $5bdbe1ebf6713620$var$Sn = {}, $5bdbe1ebf6713620$var$so = {};
Object.defineProperty($5bdbe1ebf6713620$var$so, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$so.isHTMLString = $5bdbe1ebf6713620$var$Rr;
var $5bdbe1ebf6713620$var$Nr = $5bdbe1ebf6713620$var$qe;
function $5bdbe1ebf6713620$var$Rr(n) {
    var e = (0, $5bdbe1ebf6713620$var$Nr.make)("div");
    return e.innerHTML = n, e.childElementCount > 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isHTMLString = void 0;
    var e = $5bdbe1ebf6713620$var$so;
    Object.defineProperty(n, "isHTMLString", {
        enumerable: !0,
        get: function get() {
            return e.isHTMLString;
        }
    });
})($5bdbe1ebf6713620$var$Sn);
var $5bdbe1ebf6713620$var$In = {}, $5bdbe1ebf6713620$var$ro = {};
Object.defineProperty($5bdbe1ebf6713620$var$ro, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$ro.offset = $5bdbe1ebf6713620$var$Dr;
function $5bdbe1ebf6713620$var$Dr(n) {
    var e = n.getBoundingClientRect(), t1 = window.pageXOffset || document.documentElement.scrollLeft, o = window.pageYOffset || document.documentElement.scrollTop, i = e.top + o, s = e.left + t1;
    return {
        top: i,
        left: s,
        bottom: i + e.height,
        right: s + e.width
    };
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.offset = void 0;
    var e = $5bdbe1ebf6713620$var$ro;
    Object.defineProperty(n, "offset", {
        enumerable: !0,
        get: function get() {
            return e.offset;
        }
    });
})($5bdbe1ebf6713620$var$In);
var $5bdbe1ebf6713620$var$On = {}, $5bdbe1ebf6713620$var$ao = {};
Object.defineProperty($5bdbe1ebf6713620$var$ao, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$ao.prepend = $5bdbe1ebf6713620$var$Fr;
function $5bdbe1ebf6713620$var$Fr(n, e) {
    Array.isArray(e) ? (e = e.reverse(), e.forEach(function(t1) {
        return n.prepend(t1);
    })) : n.prepend(e);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.prepend = void 0;
    var e = $5bdbe1ebf6713620$var$ao;
    Object.defineProperty(n, "prepend", {
        enumerable: !0,
        get: function get() {
            return e.prepend;
        }
    });
})($5bdbe1ebf6713620$var$On);
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.prepend = n.offset = n.make = n.isLineBreakTag = n.isSingleTag = n.isNodeEmpty = n.isLeaf = n.isHTMLString = n.isFragment = n.isEmpty = n.isElement = n.isContentEditable = n.isCollapsedWhitespaces = n.findAllInputs = n.isNativeInput = n.allInputsSelector = n.getDeepestNode = n.getDeepestBlockElements = n.getContentLength = n.fragmentToString = n.containsOnlyInlineElements = n.canSetCaret = n.calculateBaseline = n.blockElements = n.append = void 0;
    var e = $5bdbe1ebf6713620$var$It;
    Object.defineProperty(n, "allInputsSelector", {
        enumerable: !0,
        get: function get() {
            return e.allInputsSelector;
        }
    });
    var t1 = $5bdbe1ebf6713620$var$ue;
    Object.defineProperty(n, "isNativeInput", {
        enumerable: !0,
        get: function get() {
            return t1.isNativeInput;
        }
    });
    var o = $5bdbe1ebf6713620$var$pn;
    Object.defineProperty(n, "append", {
        enumerable: !0,
        get: function get() {
            return o.append;
        }
    });
    var i = $5bdbe1ebf6713620$var$At;
    Object.defineProperty(n, "blockElements", {
        enumerable: !0,
        get: function get() {
            return i.blockElements;
        }
    });
    var s = $5bdbe1ebf6713620$var$fn;
    Object.defineProperty(n, "calculateBaseline", {
        enumerable: !0,
        get: function get() {
            return s.calculateBaseline;
        }
    });
    var r = $5bdbe1ebf6713620$var$gn;
    Object.defineProperty(n, "canSetCaret", {
        enumerable: !0,
        get: function get() {
            return r.canSetCaret;
        }
    });
    var a = $5bdbe1ebf6713620$var$Ve;
    Object.defineProperty(n, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function get() {
            return a.containsOnlyInlineElements;
        }
    });
    var l = $5bdbe1ebf6713620$var$vn;
    Object.defineProperty(n, "fragmentToString", {
        enumerable: !0,
        get: function get() {
            return l.fragmentToString;
        }
    });
    var c = $5bdbe1ebf6713620$var$kn;
    Object.defineProperty(n, "getContentLength", {
        enumerable: !0,
        get: function get() {
            return c.getContentLength;
        }
    });
    var d = $5bdbe1ebf6713620$var$Wt;
    Object.defineProperty(n, "getDeepestBlockElements", {
        enumerable: !0,
        get: function get() {
            return d.getDeepestBlockElements;
        }
    });
    var h = $5bdbe1ebf6713620$var$wn;
    Object.defineProperty(n, "getDeepestNode", {
        enumerable: !0,
        get: function get() {
            return h.getDeepestNode;
        }
    });
    var p = $5bdbe1ebf6713620$var$xn;
    Object.defineProperty(n, "findAllInputs", {
        enumerable: !0,
        get: function get() {
            return p.findAllInputs;
        }
    });
    var g = $5bdbe1ebf6713620$var$Bn;
    Object.defineProperty(n, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function get() {
            return g.isCollapsedWhitespaces;
        }
    });
    var f = $5bdbe1ebf6713620$var$Rt;
    Object.defineProperty(n, "isContentEditable", {
        enumerable: !0,
        get: function get() {
            return f.isContentEditable;
        }
    });
    var v = $5bdbe1ebf6713620$var$Gt;
    Object.defineProperty(n, "isElement", {
        enumerable: !0,
        get: function get() {
            return v.isElement;
        }
    });
    var O = $5bdbe1ebf6713620$var$Cn;
    Object.defineProperty(n, "isEmpty", {
        enumerable: !0,
        get: function get() {
            return O.isEmpty;
        }
    });
    var T = $5bdbe1ebf6713620$var$Tn;
    Object.defineProperty(n, "isFragment", {
        enumerable: !0,
        get: function get() {
            return T.isFragment;
        }
    });
    var M = $5bdbe1ebf6713620$var$Sn;
    Object.defineProperty(n, "isHTMLString", {
        enumerable: !0,
        get: function get() {
            return M.isHTMLString;
        }
    });
    var q = $5bdbe1ebf6713620$var$eo;
    Object.defineProperty(n, "isLeaf", {
        enumerable: !0,
        get: function get() {
            return q.isLeaf;
        }
    });
    var F = $5bdbe1ebf6713620$var$oo;
    Object.defineProperty(n, "isNodeEmpty", {
        enumerable: !0,
        get: function get() {
            return F.isNodeEmpty;
        }
    });
    var H = $5bdbe1ebf6713620$var$Ze;
    Object.defineProperty(n, "isLineBreakTag", {
        enumerable: !0,
        get: function get() {
            return H.isLineBreakTag;
        }
    });
    var Q = $5bdbe1ebf6713620$var$Ge;
    Object.defineProperty(n, "isSingleTag", {
        enumerable: !0,
        get: function get() {
            return Q.isSingleTag;
        }
    });
    var ie = $5bdbe1ebf6713620$var$qe;
    Object.defineProperty(n, "make", {
        enumerable: !0,
        get: function get() {
            return ie.make;
        }
    });
    var k = $5bdbe1ebf6713620$var$In;
    Object.defineProperty(n, "offset", {
        enumerable: !0,
        get: function get() {
            return k.offset;
        }
    });
    var m = $5bdbe1ebf6713620$var$On;
    Object.defineProperty(n, "prepend", {
        enumerable: !0,
        get: function get() {
            return m.prepend;
        }
    });
})($5bdbe1ebf6713620$var$de);
var $5bdbe1ebf6713620$var$Qe = {};
Object.defineProperty($5bdbe1ebf6713620$var$Qe, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$Qe.getContenteditableSlice = $5bdbe1ebf6713620$var$Hr;
var $5bdbe1ebf6713620$var$jr = $5bdbe1ebf6713620$var$de;
function $5bdbe1ebf6713620$var$Hr(n, e, t1, o, i) {
    var s;
    i === void 0 && (i = !1);
    var r = document.createRange();
    if (o === "left" ? (r.setStart(n, 0), r.setEnd(e, t1)) : (r.setStart(e, t1), r.setEnd(n, n.childNodes.length)), i === !0) {
        var a = r.extractContents();
        return (0, $5bdbe1ebf6713620$var$jr.fragmentToString)(a);
    }
    var l = r.cloneContents(), c = document.createElement("div");
    c.appendChild(l);
    var d = (s = c.textContent) !== null && s !== void 0 ? s : "";
    return d;
}
Object.defineProperty($5bdbe1ebf6713620$var$Xe, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$Xe.checkContenteditableSliceForEmptiness = $5bdbe1ebf6713620$var$Ur;
var $5bdbe1ebf6713620$var$$r = $5bdbe1ebf6713620$var$de, $5bdbe1ebf6713620$var$zr = $5bdbe1ebf6713620$var$Qe;
function $5bdbe1ebf6713620$var$Ur(n, e, t1, o) {
    var i = (0, $5bdbe1ebf6713620$var$zr.getContenteditableSlice)(n, e, t1, o);
    return (0, $5bdbe1ebf6713620$var$$r.isCollapsedWhitespaces)(i);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.checkContenteditableSliceForEmptiness = void 0;
    var e = $5bdbe1ebf6713620$var$Xe;
    Object.defineProperty(n, "checkContenteditableSliceForEmptiness", {
        enumerable: !0,
        get: function get() {
            return e.checkContenteditableSliceForEmptiness;
        }
    });
})($5bdbe1ebf6713620$var$St);
var $5bdbe1ebf6713620$var$_n = {};
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getContenteditableSlice = void 0;
    var e = $5bdbe1ebf6713620$var$Qe;
    Object.defineProperty(n, "getContenteditableSlice", {
        enumerable: !0,
        get: function get() {
            return e.getContenteditableSlice;
        }
    });
})($5bdbe1ebf6713620$var$_n);
var $5bdbe1ebf6713620$var$Mn = {}, $5bdbe1ebf6713620$var$lo = {};
Object.defineProperty($5bdbe1ebf6713620$var$lo, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$lo.focus = $5bdbe1ebf6713620$var$Yr;
var $5bdbe1ebf6713620$var$Wr = $5bdbe1ebf6713620$var$de;
function $5bdbe1ebf6713620$var$Yr(n, e) {
    var t1, o;
    if (e === void 0 && (e = !0), (0, $5bdbe1ebf6713620$var$Wr.isNativeInput)(n)) {
        n.focus();
        var i = e ? 0 : n.value.length;
        n.setSelectionRange(i, i);
    } else {
        var s = document.createRange(), r = window.getSelection();
        if (!r) return;
        var a = function a(p) {
            var g = document.createTextNode("");
            p.appendChild(g), s.setStart(g, 0), s.setEnd(g, 0);
        }, l = function l(p) {
            return p != null;
        }, c = n.childNodes, d = e ? c[0] : c[c.length - 1];
        if (l(d)) {
            for(; l(d) && d.nodeType !== Node.TEXT_NODE;)d = e ? d.firstChild : d.lastChild;
            if (l(d) && d.nodeType === Node.TEXT_NODE) {
                var h = (o = (t1 = d.textContent) === null || t1 === void 0 ? void 0 : t1.length) !== null && o !== void 0 ? o : 0, i = e ? 0 : h;
                s.setStart(d, i), s.setEnd(d, i);
            } else a(n);
        } else a(n);
        r.removeAllRanges(), r.addRange(s);
    }
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.focus = void 0;
    var e = $5bdbe1ebf6713620$var$lo;
    Object.defineProperty(n, "focus", {
        enumerable: !0,
        get: function get() {
            return e.focus;
        }
    });
})($5bdbe1ebf6713620$var$Mn);
var $5bdbe1ebf6713620$var$co = {}, $5bdbe1ebf6713620$var$Je = {};
Object.defineProperty($5bdbe1ebf6713620$var$Je, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$Je.getCaretNodeAndOffset = $5bdbe1ebf6713620$var$Kr;
function $5bdbe1ebf6713620$var$Kr() {
    var n = window.getSelection();
    if (n === null) return [
        null,
        0
    ];
    var e = n.focusNode, t1 = n.focusOffset;
    return e === null ? [
        null,
        0
    ] : (e.nodeType !== Node.TEXT_NODE && e.childNodes.length > 0 && (e.childNodes[t1] !== void 0 ? (e = e.childNodes[t1], t1 = 0) : (e = e.childNodes[t1 - 1], e.textContent !== null && (t1 = e.textContent.length))), [
        e,
        t1
    ]);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getCaretNodeAndOffset = void 0;
    var e = $5bdbe1ebf6713620$var$Je;
    Object.defineProperty(n, "getCaretNodeAndOffset", {
        enumerable: !0,
        get: function get() {
            return e.getCaretNodeAndOffset;
        }
    });
})($5bdbe1ebf6713620$var$co);
var $5bdbe1ebf6713620$var$An = {}, $5bdbe1ebf6713620$var$et = {};
Object.defineProperty($5bdbe1ebf6713620$var$et, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$et.getRange = $5bdbe1ebf6713620$var$Xr;
function $5bdbe1ebf6713620$var$Xr() {
    var n = window.getSelection();
    return n && n.rangeCount ? n.getRangeAt(0) : null;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getRange = void 0;
    var e = $5bdbe1ebf6713620$var$et;
    Object.defineProperty(n, "getRange", {
        enumerable: !0,
        get: function get() {
            return e.getRange;
        }
    });
})($5bdbe1ebf6713620$var$An);
var $5bdbe1ebf6713620$var$Ln = {}, $5bdbe1ebf6713620$var$uo = {};
Object.defineProperty($5bdbe1ebf6713620$var$uo, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$uo.isCaretAtEndOfInput = $5bdbe1ebf6713620$var$Zr;
var $5bdbe1ebf6713620$var$Oo = $5bdbe1ebf6713620$var$de, $5bdbe1ebf6713620$var$Vr = $5bdbe1ebf6713620$var$co, $5bdbe1ebf6713620$var$qr = $5bdbe1ebf6713620$var$St;
function $5bdbe1ebf6713620$var$Zr(n) {
    var e = (0, $5bdbe1ebf6713620$var$Oo.getDeepestNode)(n, !0);
    if (e === null) return !0;
    if ((0, $5bdbe1ebf6713620$var$Oo.isNativeInput)(e)) return e.selectionEnd === e.value.length;
    var t1 = (0, $5bdbe1ebf6713620$var$Vr.getCaretNodeAndOffset)(), o = t1[0], i = t1[1];
    return o === null ? !1 : (0, $5bdbe1ebf6713620$var$qr.checkContenteditableSliceForEmptiness)(n, o, i, "right");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCaretAtEndOfInput = void 0;
    var e = $5bdbe1ebf6713620$var$uo;
    Object.defineProperty(n, "isCaretAtEndOfInput", {
        enumerable: !0,
        get: function get() {
            return e.isCaretAtEndOfInput;
        }
    });
})($5bdbe1ebf6713620$var$Ln);
var $5bdbe1ebf6713620$var$Pn = {}, $5bdbe1ebf6713620$var$ho = {};
Object.defineProperty($5bdbe1ebf6713620$var$ho, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$ho.isCaretAtStartOfInput = $5bdbe1ebf6713620$var$Jr;
var $5bdbe1ebf6713620$var$Ae = $5bdbe1ebf6713620$var$de, $5bdbe1ebf6713620$var$Gr = $5bdbe1ebf6713620$var$Je, $5bdbe1ebf6713620$var$Qr = $5bdbe1ebf6713620$var$Xe;
function $5bdbe1ebf6713620$var$Jr(n) {
    var e = (0, $5bdbe1ebf6713620$var$Ae.getDeepestNode)(n);
    if (e === null || (0, $5bdbe1ebf6713620$var$Ae.isEmpty)(n)) return !0;
    if ((0, $5bdbe1ebf6713620$var$Ae.isNativeInput)(e)) return e.selectionEnd === 0;
    if ((0, $5bdbe1ebf6713620$var$Ae.isEmpty)(n)) return !0;
    var t1 = (0, $5bdbe1ebf6713620$var$Gr.getCaretNodeAndOffset)(), o = t1[0], i = t1[1];
    return o === null ? !1 : (0, $5bdbe1ebf6713620$var$Qr.checkContenteditableSliceForEmptiness)(n, o, i, "left");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCaretAtStartOfInput = void 0;
    var e = $5bdbe1ebf6713620$var$ho;
    Object.defineProperty(n, "isCaretAtStartOfInput", {
        enumerable: !0,
        get: function get() {
            return e.isCaretAtStartOfInput;
        }
    });
})($5bdbe1ebf6713620$var$Pn);
var $5bdbe1ebf6713620$var$Nn = {}, $5bdbe1ebf6713620$var$po = {};
Object.defineProperty($5bdbe1ebf6713620$var$po, "__esModule", {
    value: !0
});
$5bdbe1ebf6713620$var$po.save = $5bdbe1ebf6713620$var$oa;
var $5bdbe1ebf6713620$var$ea = $5bdbe1ebf6713620$var$de, $5bdbe1ebf6713620$var$ta = $5bdbe1ebf6713620$var$et;
function $5bdbe1ebf6713620$var$oa() {
    var n = (0, $5bdbe1ebf6713620$var$ta.getRange)(), e = (0, $5bdbe1ebf6713620$var$ea.make)("span");
    if (e.id = "cursor", e.hidden = !0, !!n) return n.insertNode(e), function() {
        var o = window.getSelection();
        o && (n.setStartAfter(e), n.setEndAfter(e), o.removeAllRanges(), o.addRange(n), setTimeout(function() {
            e.remove();
        }, 150));
    };
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.save = void 0;
    var e = $5bdbe1ebf6713620$var$po;
    Object.defineProperty(n, "save", {
        enumerable: !0,
        get: function get() {
            return e.save;
        }
    });
})($5bdbe1ebf6713620$var$Nn);
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.save = n.isCaretAtStartOfInput = n.isCaretAtEndOfInput = n.getRange = n.getCaretNodeAndOffset = n.focus = n.getContenteditableSlice = n.checkContenteditableSliceForEmptiness = void 0;
    var e = $5bdbe1ebf6713620$var$St;
    Object.defineProperty(n, "checkContenteditableSliceForEmptiness", {
        enumerable: !0,
        get: function get() {
            return e.checkContenteditableSliceForEmptiness;
        }
    });
    var t1 = $5bdbe1ebf6713620$var$_n;
    Object.defineProperty(n, "getContenteditableSlice", {
        enumerable: !0,
        get: function get() {
            return t1.getContenteditableSlice;
        }
    });
    var o = $5bdbe1ebf6713620$var$Mn;
    Object.defineProperty(n, "focus", {
        enumerable: !0,
        get: function get() {
            return o.focus;
        }
    });
    var i = $5bdbe1ebf6713620$var$co;
    Object.defineProperty(n, "getCaretNodeAndOffset", {
        enumerable: !0,
        get: function get() {
            return i.getCaretNodeAndOffset;
        }
    });
    var s = $5bdbe1ebf6713620$var$An;
    Object.defineProperty(n, "getRange", {
        enumerable: !0,
        get: function get() {
            return s.getRange;
        }
    });
    var r = $5bdbe1ebf6713620$var$Ln;
    Object.defineProperty(n, "isCaretAtEndOfInput", {
        enumerable: !0,
        get: function get() {
            return r.isCaretAtEndOfInput;
        }
    });
    var a = $5bdbe1ebf6713620$var$Pn;
    Object.defineProperty(n, "isCaretAtStartOfInput", {
        enumerable: !0,
        get: function get() {
            return a.isCaretAtStartOfInput;
        }
    });
    var l = $5bdbe1ebf6713620$var$Nn;
    Object.defineProperty(n, "save", {
        enumerable: !0,
        get: function get() {
            return l.save;
        }
    });
})($5bdbe1ebf6713620$var$hn);
var $5bdbe1ebf6713620$var$na = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(na, E);
    function na() {
        (0, $173N4._)(this, na);
        return (0, $7qXGD._)(this, na, arguments);
    }
    (0, $cFHGC._)(na, [
        {
            /**
   * All keydowns on Block
   *
   * @param {KeyboardEvent} event - keydown
   */ key: "keydown",
            value: function keydown(e) {
                switch(this.beforeKeydownProcessing(e), e.keyCode){
                    case $5bdbe1ebf6713620$var$y.BACKSPACE:
                        this.backspace(e);
                        break;
                    case $5bdbe1ebf6713620$var$y.DELETE:
                        this.delete(e);
                        break;
                    case $5bdbe1ebf6713620$var$y.ENTER:
                        this.enter(e);
                        break;
                    case $5bdbe1ebf6713620$var$y.DOWN:
                    case $5bdbe1ebf6713620$var$y.RIGHT:
                        this.arrowRightAndDown(e);
                        break;
                    case $5bdbe1ebf6713620$var$y.UP:
                    case $5bdbe1ebf6713620$var$y.LEFT:
                        this.arrowLeftAndUp(e);
                        break;
                    case $5bdbe1ebf6713620$var$y.TAB:
                        this.tabPressed(e);
                        break;
                }
                e.key === "/" && !e.ctrlKey && !e.metaKey && this.slashPressed(e), e.code === "Slash" && (e.ctrlKey || e.metaKey) && (e.preventDefault(), this.commandSlashPressed());
            }
        },
        {
            /**
   * Fires on keydown before event processing
   *
   * @param {KeyboardEvent} event - keydown
   */ key: "beforeKeydownProcessing",
            value: function beforeKeydownProcessing(e) {
                this.needToolbarClosing(e) && $5bdbe1ebf6713620$var$Po(e.keyCode) && (this.Editor.Toolbar.close(), e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || this.Editor.BlockSelection.clearSelection(e));
            }
        },
        {
            /**
   * Key up on Block:
   * - shows Inline Toolbar if something selected
   * - shows conversion toolbar with 85% of block selection
   *
   * @param {KeyboardEvent} event - keyup event
   */ key: "keyup",
            value: function keyup(e) {
                e.shiftKey || this.Editor.UI.checkEmptiness();
            }
        },
        {
            /**
   * Add drop target styles
   *
   * @param {DragEvent} event - drag over event
   */ key: "dragOver",
            value: function dragOver(e) {
                var t1 = this.Editor.BlockManager.getBlockByChildNode(e.target);
                t1.dropTarget = !0;
            }
        },
        {
            /**
   * Remove drop target style
   *
   * @param {DragEvent} event - drag leave event
   */ key: "dragLeave",
            value: function dragLeave(e) {
                var t1 = this.Editor.BlockManager.getBlockByChildNode(e.target);
                t1.dropTarget = !1;
            }
        },
        {
            /**
   * Copying selected blocks
   * Before putting to the clipboard we sanitize all blocks and then copy to the clipboard
   *
   * @param {ClipboardEvent} event - clipboard event
   */ key: "handleCommandC",
            value: function handleCommandC(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockSelection;
                t1.anyBlockSelected && t1.copySelectedBlocks(e);
            }
        },
        {
            /**
   * Copy and Delete selected Blocks
   *
   * @param {ClipboardEvent} event - clipboard event
   */ key: "handleCommandX",
            value: function handleCommandX(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockSelection, o = _this_Editor.BlockManager, i = _this_Editor.Caret;
                t1.anyBlockSelected && t1.copySelectedBlocks(e).then(function() {
                    var s = o.removeSelectedBlocks(), r = o.insertDefaultBlockAtIndex(s, !0);
                    i.setToBlock(r, i.positions.START), t1.clearSelection(e);
                });
            }
        },
        {
            /**
   * Tab pressed inside a Block.
   *
   * @param {KeyboardEvent} event - keydown
   */ key: "tabPressed",
            value: function tabPressed(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.InlineToolbar, o = _this_Editor.Caret;
                if (t1.opened) return;
                (e.shiftKey ? o.navigatePrevious(!0) : o.navigateNext(!0)) && e.preventDefault();
            }
        },
        {
            /**
   * '/' + 'command' keydown inside a Block
   */ key: "commandSlashPressed",
            value: function commandSlashPressed() {
                this.Editor.BlockSelection.selectedBlocks.length > 1 || this.activateBlockSettings();
            }
        },
        {
            /**
   * '/' keydown inside a Block
   *
   * @param event - keydown
   */ key: "slashPressed",
            value: function slashPressed(e) {
                !this.Editor.UI.nodes.wrapper.contains(e.target) || !this.Editor.BlockManager.currentBlock.isEmpty || (e.preventDefault(), this.Editor.Caret.insertContentAtCaretPosition("/"), this.activateToolbox());
            }
        },
        {
            /**
   * ENTER pressed on block
   *
   * @param {KeyboardEvent} event - keydown
   */ key: "enter",
            value: function enter(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.UI, i = t1.currentBlock;
                if (i === void 0 || i.tool.isLineBreaksEnabled || o.someToolbarOpened && o.someFlipperButtonFocused || e.shiftKey && !$5bdbe1ebf6713620$var$pt) return;
                var s = i;
                i.currentInput !== void 0 && $5bdbe1ebf6713620$var$Ne(i.currentInput) && !i.hasMedia ? this.Editor.BlockManager.insertDefaultBlockAtIndex(this.Editor.BlockManager.currentBlockIndex) : i.currentInput && $5bdbe1ebf6713620$var$Re(i.currentInput) ? s = this.Editor.BlockManager.insertDefaultBlockAtIndex(this.Editor.BlockManager.currentBlockIndex + 1) : s = this.Editor.BlockManager.split(), this.Editor.Caret.setToBlock(s), this.Editor.Toolbar.moveAndOpen(s), e.preventDefault();
            }
        },
        {
            /**
   * Handle backspace keydown on Block
   *
   * @param {KeyboardEvent} event - keydown
   */ key: "backspace",
            value: function backspace(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.Caret, i = t1.currentBlock, s = t1.previousBlock;
                if (i === void 0 || !$5bdbe1ebf6713620$var$b.isCollapsed || !i.currentInput || !$5bdbe1ebf6713620$var$Ne(i.currentInput)) return;
                if (e.preventDefault(), this.Editor.Toolbar.close(), !(i.currentInput === i.firstInput)) {
                    o.navigatePrevious();
                    return;
                }
                if (s === null) return;
                if (s.isEmpty) {
                    t1.removeBlock(s);
                    return;
                }
                if (i.isEmpty) {
                    t1.removeBlock(i);
                    var l = t1.currentBlock;
                    o.setToBlock(l, o.positions.END);
                    return;
                }
                $5bdbe1ebf6713620$var$xo(s, i) ? this.mergeBlocks(s, i) : o.setToBlock(s, o.positions.END);
            }
        },
        {
            /**
   * Handles delete keydown on Block
   * Removes char after the caret.
   * If caret is at the end of the block, merge next block with current
   *
   * @param {KeyboardEvent} event - keydown
   */ key: "delete",
            value: function _delete(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.Caret, i = t1.currentBlock, s = t1.nextBlock;
                if (!$5bdbe1ebf6713620$var$b.isCollapsed || !$5bdbe1ebf6713620$var$Re(i.currentInput)) return;
                if (e.preventDefault(), this.Editor.Toolbar.close(), !(i.currentInput === i.lastInput)) {
                    o.navigateNext();
                    return;
                }
                if (s === null) return;
                if (s.isEmpty) {
                    t1.removeBlock(s);
                    return;
                }
                if (i.isEmpty) {
                    t1.removeBlock(i), o.setToBlock(s, o.positions.START);
                    return;
                }
                $5bdbe1ebf6713620$var$xo(i, s) ? this.mergeBlocks(i, s) : o.setToBlock(s, o.positions.START);
            }
        },
        {
            /**
   * Merge passed Blocks
   *
   * @param targetBlock - to which Block we want to merge
   * @param blockToMerge - what Block we want to merge
   */ key: "mergeBlocks",
            value: function mergeBlocks(e, t1) {
                var _this_Editor = this.Editor, o = _this_Editor.BlockManager, i = _this_Editor.Toolbar;
                e.lastInput !== void 0 && ($5bdbe1ebf6713620$var$hn.focus(e.lastInput, !1), o.mergeBlocks(e, t1).then(function() {
                    i.close();
                }));
            }
        },
        {
            /**
   * Handle right and down keyboard keys
   *
   * @param {KeyboardEvent} event - keyboard event
   */ key: "arrowRightAndDown",
            value: function arrowRightAndDown(e) {
                var _this = this;
                var t1 = $5bdbe1ebf6713620$var$ce.usedKeys.includes(e.keyCode) && (!e.shiftKey || e.keyCode === $5bdbe1ebf6713620$var$y.TAB);
                if (this.Editor.UI.someToolbarOpened && t1) return;
                this.Editor.Toolbar.close();
                var _this_Editor_BlockManager = this.Editor.BlockManager, o = _this_Editor_BlockManager.currentBlock, s = ((o == null ? void 0 : o.currentInput) !== void 0 ? $5bdbe1ebf6713620$var$Re(o.currentInput) : void 0) || this.Editor.BlockSelection.anyBlockSelected;
                if (e.shiftKey && e.keyCode === $5bdbe1ebf6713620$var$y.DOWN && s) {
                    this.Editor.CrossBlockSelection.toggleBlockSelectedState();
                    return;
                }
                if (e.keyCode === $5bdbe1ebf6713620$var$y.DOWN || e.keyCode === $5bdbe1ebf6713620$var$y.RIGHT && !this.isRtl ? this.Editor.Caret.navigateNext() : this.Editor.Caret.navigatePrevious()) {
                    e.preventDefault();
                    return;
                }
                $5bdbe1ebf6713620$var$Fe(function() {
                    _this.Editor.BlockManager.currentBlock && _this.Editor.BlockManager.currentBlock.updateCurrentInput();
                }, 20)(), this.Editor.BlockSelection.clearSelection(e);
            }
        },
        {
            /**
   * Handle left and up keyboard keys
   *
   * @param {KeyboardEvent} event - keyboard event
   */ key: "arrowLeftAndUp",
            value: function arrowLeftAndUp(e) {
                var _this = this;
                if (this.Editor.UI.someToolbarOpened) {
                    if ($5bdbe1ebf6713620$var$ce.usedKeys.includes(e.keyCode) && (!e.shiftKey || e.keyCode === $5bdbe1ebf6713620$var$y.TAB)) return;
                    this.Editor.UI.closeAllToolbars();
                }
                this.Editor.Toolbar.close();
                var _this_Editor_BlockManager = this.Editor.BlockManager, t1 = _this_Editor_BlockManager.currentBlock, i = ((t1 == null ? void 0 : t1.currentInput) !== void 0 ? $5bdbe1ebf6713620$var$Ne(t1.currentInput) : void 0) || this.Editor.BlockSelection.anyBlockSelected;
                if (e.shiftKey && e.keyCode === $5bdbe1ebf6713620$var$y.UP && i) {
                    this.Editor.CrossBlockSelection.toggleBlockSelectedState(!1);
                    return;
                }
                if (e.keyCode === $5bdbe1ebf6713620$var$y.UP || e.keyCode === $5bdbe1ebf6713620$var$y.LEFT && !this.isRtl ? this.Editor.Caret.navigatePrevious() : this.Editor.Caret.navigateNext()) {
                    e.preventDefault();
                    return;
                }
                $5bdbe1ebf6713620$var$Fe(function() {
                    _this.Editor.BlockManager.currentBlock && _this.Editor.BlockManager.currentBlock.updateCurrentInput();
                }, 20)(), this.Editor.BlockSelection.clearSelection(e);
            }
        },
        {
            /**
   * Cases when we need to close Toolbar
   *
   * @param {KeyboardEvent} event - keyboard event
   */ key: "needToolbarClosing",
            value: function needToolbarClosing(e) {
                var t1 = e.keyCode === $5bdbe1ebf6713620$var$y.ENTER && this.Editor.Toolbar.toolbox.opened, o = e.keyCode === $5bdbe1ebf6713620$var$y.ENTER && this.Editor.BlockSettings.opened, i = e.keyCode === $5bdbe1ebf6713620$var$y.ENTER && this.Editor.InlineToolbar.opened, s = e.keyCode === $5bdbe1ebf6713620$var$y.TAB;
                return !(e.shiftKey || s || t1 || o || i);
            }
        },
        {
            /**
   * If Toolbox is not open, then just open it and show plus button
   */ key: "activateToolbox",
            value: function activateToolbox() {
                this.Editor.Toolbar.opened || this.Editor.Toolbar.moveAndOpen(), this.Editor.Toolbar.toolbox.open();
            }
        },
        {
            /**
   * Open Toolbar and show BlockSettings before flipping Tools
   */ key: "activateBlockSettings",
            value: function activateBlockSettings() {
                this.Editor.Toolbar.opened || this.Editor.Toolbar.moveAndOpen(), this.Editor.BlockSettings.opened || this.Editor.BlockSettings.open();
            }
        }
    ]);
    return na;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$ct = /*#__PURE__*/ function() {
    "use strict";
    function ct(e) {
        (0, $173N4._)(this, ct);
        this.blocks = [], this.workingArea = e;
    }
    (0, $cFHGC._)(ct, [
        {
            key: "length",
            get: /**
   * Get length of Block instances array
   *
   * @returns {number}
   */ function get() {
                return this.blocks.length;
            }
        },
        {
            key: "array",
            get: /**
   * Get Block instances array
   *
   * @returns {Block[]}
   */ function get() {
                return this.blocks;
            }
        },
        {
            key: "nodes",
            get: /**
   * Get blocks html elements array
   *
   * @returns {HTMLElement[]}
   */ function get() {
                return $5bdbe1ebf6713620$var$No(this.workingArea.children);
            }
        },
        {
            /**
   * Push new Block to the blocks array and append it to working area
   *
   * @param {Block} block - Block to add
   */ key: "push",
            value: function push(e) {
                this.blocks.push(e), this.insertToDOM(e);
            }
        },
        {
            /**
   * Swaps blocks with indexes first and second
   *
   * @param {number} first - first block index
   * @param {number} second - second block index
   * @deprecated — use 'move' instead
   */ key: "swap",
            value: function swap(e, t1) {
                var o = this.blocks[t1];
                $5bdbe1ebf6713620$var$u.swap(this.blocks[e].holder, o.holder), this.blocks[t1] = this.blocks[e], this.blocks[e] = o;
            }
        },
        {
            /**
   * Move a block from one to another index
   *
   * @param {number} toIndex - new index of the block
   * @param {number} fromIndex - block to move
   */ key: "move",
            value: function move(e, t1) {
                var o = this.blocks.splice(t1, 1)[0], i = e - 1, s = Math.max(0, i), r = this.blocks[s];
                e > 0 ? this.insertToDOM(o, "afterend", r) : this.insertToDOM(o, "beforebegin", r), this.blocks.splice(e, 0, o);
                var a = this.composeBlockEvent("move", {
                    fromIndex: t1,
                    toIndex: e
                });
                o.call($5bdbe1ebf6713620$var$ee.MOVED, a);
            }
        },
        {
            /**
   * Insert new Block at passed index
   *
   * @param {number} index — index to insert Block
   * @param {Block} block — Block to insert
   * @param {boolean} replace — it true, replace block on given index
   */ key: "insert",
            value: function insert(e, t1) {
                var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                if (!this.length) {
                    this.push(t1);
                    return;
                }
                e > this.length && (e = this.length), o && (this.blocks[e].holder.remove(), this.blocks[e].call($5bdbe1ebf6713620$var$ee.REMOVED));
                var i = o ? 1 : 0;
                if (this.blocks.splice(e, i, t1), e > 0) {
                    var s = this.blocks[e - 1];
                    this.insertToDOM(t1, "afterend", s);
                } else {
                    var s1 = this.blocks[e + 1];
                    s1 ? this.insertToDOM(t1, "beforebegin", s1) : this.insertToDOM(t1);
                }
            }
        },
        {
            /**
   * Replaces block under passed index with passed block
   *
   * @param index - index of existed block
   * @param block - new block
   */ key: "replace",
            value: function replace(e, t1) {
                if (this.blocks[e] === void 0) throw Error("Incorrect index");
                this.blocks[e].holder.replaceWith(t1.holder), this.blocks[e] = t1;
            }
        },
        {
            /**
   * Inserts several blocks at once
   *
   * @param blocks - blocks to insert
   * @param index - index to insert blocks at
   */ key: "insertMany",
            value: function insertMany(e, t1) {
                var _this_blocks;
                var o = new DocumentFragment();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        o.appendChild(i.holder);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this.length > 0) {
                    var _this_blocks1;
                    if (t1 > 0) {
                        var i1 = Math.min(t1 - 1, this.length - 1);
                        this.blocks[i1].holder.after(o);
                    } else t1 === 0 && this.workingArea.prepend(o);
                    (_this_blocks1 = this.blocks).splice.apply(_this_blocks1, [
                        t1,
                        0
                    ].concat((0, $aUGqu._)(e)));
                } else (_this_blocks = this.blocks).push.apply(_this_blocks, (0, $aUGqu._)(e)), this.workingArea.appendChild(o);
                e.forEach(function(i) {
                    return i.call($5bdbe1ebf6713620$var$ee.RENDERED);
                });
            }
        },
        {
            /**
   * Remove block
   *
   * @param {number} index - index of Block to remove
   */ key: "remove",
            value: function remove(e) {
                isNaN(e) && (e = this.length - 1), this.blocks[e].holder.remove(), this.blocks[e].call($5bdbe1ebf6713620$var$ee.REMOVED), this.blocks.splice(e, 1);
            }
        },
        {
            /**
   * Remove all blocks
   */ key: "removeAll",
            value: function removeAll() {
                this.workingArea.innerHTML = "", this.blocks.forEach(function(e) {
                    return e.call($5bdbe1ebf6713620$var$ee.REMOVED);
                }), this.blocks.length = 0;
            }
        },
        {
            /**
   * Insert Block after passed target
   *
   * @todo decide if this method is necessary
   * @param {Block} targetBlock — target after which Block should be inserted
   * @param {Block} newBlock — Block to insert
   */ key: "insertAfter",
            value: function insertAfter(e, t1) {
                var o = this.blocks.indexOf(e);
                this.insert(o + 1, t1);
            }
        },
        {
            /**
   * Get Block by index
   *
   * @param {number} index — Block index
   * @returns {Block}
   */ key: "get",
            value: function get(e) {
                return this.blocks[e];
            }
        },
        {
            /**
   * Return index of passed Block
   *
   * @param {Block} block - Block to find
   * @returns {number}
   */ key: "indexOf",
            value: function indexOf(e) {
                return this.blocks.indexOf(e);
            }
        },
        {
            /**
   * Insert new Block into DOM
   *
   * @param {Block} block - Block to insert
   * @param {InsertPosition} position — insert position (if set, will use insertAdjacentElement)
   * @param {Block} target — Block related to position
   */ key: "insertToDOM",
            value: function insertToDOM(e, t1, o) {
                t1 ? o.holder.insertAdjacentElement(t1, e.holder) : this.workingArea.appendChild(e.holder), e.call($5bdbe1ebf6713620$var$ee.RENDERED);
            }
        },
        {
            /**
   * Composes Block event with passed type and details
   *
   * @param {string} type - event type
   * @param {object} detail - event detail
   */ key: "composeBlockEvent",
            value: function composeBlockEvent(e, t1) {
                return new CustomEvent(e, {
                    detail: t1
                });
            }
        }
    ], [
        {
            key: "set",
            value: /**
   * Proxy trap to implement array-like setter
   *
   * @example
   * blocks[0] = new Block(...)
   * @param {Blocks} instance — Blocks instance
   * @param {PropertyKey} property — block index or any Blocks class property key to set
   * @param {Block} value — value to set
   * @returns {boolean}
   */ function set(e, t1, o) {
                return isNaN(Number(t1)) ? (Reflect.set(e, t1, o), !0) : (e.insert(+t1, o), !0);
            }
        },
        {
            key: "get",
            value: /**
   * Proxy trap to implement array-like getter
   *
   * @param {Blocks} instance — Blocks instance
   * @param {PropertyKey} property — Blocks class property key
   * @returns {Block|*}
   */ function get(e, t1) {
                return isNaN(Number(t1)) ? Reflect.get(e, t1) : e.get(+t1);
            }
        }
    ]);
    return ct;
}();
var $5bdbe1ebf6713620$var$_o = "block-removed", $5bdbe1ebf6713620$var$Mo = "block-added", $5bdbe1ebf6713620$var$ia = "block-moved", $5bdbe1ebf6713620$var$Ao = "block-changed";
var $5bdbe1ebf6713620$var$sa = /*#__PURE__*/ function() {
    "use strict";
    function sa() {
        (0, $173N4._)(this, sa);
        this.completed = Promise.resolve();
    }
    (0, $cFHGC._)(sa, [
        {
            /**
   * Add new promise to queue
   *
   * @param operation - promise should be added to queue
   */ key: "add",
            value: function add(e) {
                var _this = this;
                return new Promise(function(t1, o) {
                    _this.completed = _this.completed.then(e).then(t1).catch(o);
                });
            }
        }
    ]);
    return sa;
}();
var $5bdbe1ebf6713620$var$ra = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(ra, E);
    function ra() {
        (0, $173N4._)(this, ra);
        var _this;
        _this = (0, $7qXGD._)(this, ra, arguments), _this._currentBlockIndex = -1, _this._blocks = null;
        return _this;
    }
    (0, $cFHGC._)(ra, [
        {
            key: "currentBlockIndex",
            get: /**
   * Returns current Block index
   *
   * @returns {number}
   */ function get() {
                return this._currentBlockIndex;
            },
            set: /**
   * Set current Block index and fire Block lifecycle callbacks
   *
   * @param {number} newIndex - index of Block to set as current
   */ function set(e) {
                this._currentBlockIndex = e;
            }
        },
        {
            key: "firstBlock",
            get: /**
   * returns first Block
   *
   * @returns {Block}
   */ function get() {
                return this._blocks[0];
            }
        },
        {
            key: "lastBlock",
            get: /**
   * returns last Block
   *
   * @returns {Block}
   */ function get() {
                return this._blocks[this._blocks.length - 1];
            }
        },
        {
            key: "currentBlock",
            get: /**
   * Get current Block instance
   *
   * @returns {Block}
   */ function get() {
                return this._blocks[this.currentBlockIndex];
            },
            set: /**
   * Set passed Block as a current
   *
   * @param block - block to set as a current
   */ function set(e) {
                this.currentBlockIndex = this.getBlockIndex(e);
            }
        },
        {
            key: "nextBlock",
            get: /**
   * Returns next Block instance
   *
   * @returns {Block|null}
   */ function get() {
                return this.currentBlockIndex === this._blocks.length - 1 ? null : this._blocks[this.currentBlockIndex + 1];
            }
        },
        {
            key: "nextContentfulBlock",
            get: /**
   * Return first Block with inputs after current Block
   *
   * @returns {Block | undefined}
   */ function get() {
                return this.blocks.slice(this.currentBlockIndex + 1).find(function(t1) {
                    return !!t1.inputs.length;
                });
            }
        },
        {
            key: "previousContentfulBlock",
            get: /**
   * Return first Block with inputs before current Block
   *
   * @returns {Block | undefined}
   */ function get() {
                return this.blocks.slice(0, this.currentBlockIndex).reverse().find(function(t1) {
                    return !!t1.inputs.length;
                });
            }
        },
        {
            key: "previousBlock",
            get: /**
   * Returns previous Block instance
   *
   * @returns {Block|null}
   */ function get() {
                return this.currentBlockIndex === 0 ? null : this._blocks[this.currentBlockIndex - 1];
            }
        },
        {
            key: "blocks",
            get: /**
   * Get array of Block instances
   *
   * @returns {Block[]} {@link Blocks#array}
   */ function get() {
                return this._blocks.array;
            }
        },
        {
            key: "isEditorEmpty",
            get: /**
   * Check if each Block is empty
   *
   * @returns {boolean}
   */ function get() {
                return this.blocks.every(function(e) {
                    return e.isEmpty;
                });
            }
        },
        {
            /**
   * Should be called after Editor.UI preparation
   * Define this._blocks property
   */ key: "prepare",
            value: function prepare() {
                var _this = this;
                var e = new $5bdbe1ebf6713620$var$ct(this.Editor.UI.nodes.redactor);
                this._blocks = new Proxy(e, {
                    set: $5bdbe1ebf6713620$var$ct.set,
                    get: $5bdbe1ebf6713620$var$ct.get
                }), this.listeners.on(document, "copy", function(t1) {
                    return _this.Editor.BlockEvents.handleCommandC(t1);
                });
            }
        },
        {
            /**
   * Toggle read-only state
   *
   * If readOnly is true:
   *  - Unbind event handlers from created Blocks
   *
   * if readOnly is false:
   *  - Bind event handlers to all existing Blocks
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ key: "toggleReadOnly",
            value: function toggleReadOnly(e) {
                e ? this.disableModuleBindings() : this.enableModuleBindings();
            }
        },
        {
            /**
   * Creates Block instance by tool name
   *
   * @param {object} options - block creation options
   * @param {string} options.tool - tools passed in editor config {@link EditorConfig#tools}
   * @param {string} [options.id] - unique id for this block
   * @param {BlockToolData} [options.data] - constructor params
   * @returns {Block}
   */ key: "composeBlock",
            value: function composeBlock(param) {
                var _this = this;
                var e = param.tool, tmp = param.data, t1 = tmp === void 0 ? {} : tmp, o = param.id, tmp1 = param.tunes, i = tmp1 === void 0 ? {} : tmp1;
                var s = this.Editor.ReadOnly.isEnabled, r = this.Editor.Tools.blockTools.get(e), a = new $5bdbe1ebf6713620$var$R({
                    id: o,
                    data: t1,
                    tool: r,
                    api: this.Editor.API,
                    readOnly: s,
                    tunesData: i
                }, this.eventsDispatcher);
                return s || window.requestIdleCallback(function() {
                    _this.bindBlockEvents(a);
                }, {
                    timeout: 2e3
                }), a;
            }
        },
        {
            /**
   * Insert new block into _blocks
   *
   * @param {object} options - insert options
   * @param {string} [options.id] - block's unique id
   * @param {string} [options.tool] - plugin name, by default method inserts the default block type
   * @param {object} [options.data] - plugin data
   * @param {number} [options.index] - index where to insert new Block
   * @param {boolean} [options.needToFocus] - flag shows if needed to update current Block index
   * @param {boolean} [options.replace] - flag shows if block by passed index should be replaced with inserted one
   * @returns {Block}
   */ key: "insert",
            value: function insert() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = _ref.id, tmp = _ref.tool, t1 = tmp === void 0 ? this.config.defaultBlock : tmp, tmp1 = _ref.data, o = tmp1 === void 0 ? {} : tmp1, i = _ref.index, tmp2 = _ref.needToFocus, s = tmp2 === void 0 ? !0 : tmp2, tmp3 = _ref.replace, r = tmp3 === void 0 ? !1 : tmp3, tmp4 = _ref.tunes, a = tmp4 === void 0 ? {} : tmp4;
                var l = i;
                l === void 0 && (l = this.currentBlockIndex + (r ? 0 : 1));
                var c = this.composeBlock({
                    id: e,
                    tool: t1,
                    data: o,
                    tunes: a
                });
                return r && this.blockDidMutated($5bdbe1ebf6713620$var$_o, this.getBlockByIndex(l), {
                    index: l
                }), this._blocks.insert(l, c, r), this.blockDidMutated($5bdbe1ebf6713620$var$Mo, c, {
                    index: l
                }), s ? this.currentBlockIndex = l : l <= this.currentBlockIndex && this.currentBlockIndex++, c;
            }
        },
        {
            /**
   * Inserts several blocks at once
   *
   * @param blocks - blocks to insert
   * @param index - index where to insert
   */ key: "insertMany",
            value: function insertMany(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this._blocks.insertMany(e, t1);
            }
        },
        {
            key: "update",
            value: /**
   * Update Block data.
   *
   * Currently we don't have an 'update' method in the Tools API, so we just create a new block with the same id and type
   * Should not trigger 'block-removed' or 'block-added' events.
   *
   * If neither data nor tunes is provided, return the provided block instead.
   *
   * @param block - block to update
   * @param data - (optional) new data
   * @param tunes - (optional) tune data
   */ function update(e, t1, o) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var i, s, r;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!t1 && !o) return [
                                    2,
                                    e
                                ];
                                return [
                                    4,
                                    e.data
                                ];
                            case 1:
                                i = _state.sent(), s = this.composeBlock({
                                    id: e.id,
                                    tool: e.name,
                                    data: Object.assign({}, i, t1 !== null && t1 !== void 0 ? t1 : {}),
                                    tunes: o !== null && o !== void 0 ? o : e.tunes
                                }), r = this.getBlockIndex(e);
                                return [
                                    2,
                                    (this._blocks.replace(r, s), this.blockDidMutated($5bdbe1ebf6713620$var$Ao, s, {
                                        index: r
                                    }), s)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Replace passed Block with the new one with specified Tool and data
   *
   * @param block - block to replace
   * @param newTool - new Tool name
   * @param data - new Tool data
   */ key: "replace",
            value: function replace(e, t1, o) {
                var i = this.getBlockIndex(e);
                return this.insert({
                    tool: t1,
                    data: o,
                    index: i,
                    replace: !0
                });
            }
        },
        {
            /**
   * Insert pasted content. Call onPaste callback after insert.
   *
   * @param {string} toolName - name of Tool to insert
   * @param {PasteEvent} pasteEvent - pasted data
   * @param {boolean} replace - should replace current block
   */ key: "paste",
            value: function paste(e, t1) {
                var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                var i = this.insert({
                    tool: e,
                    replace: o
                });
                try {
                    window.requestIdleCallback(function() {
                        i.call($5bdbe1ebf6713620$var$ee.ON_PASTE, t1);
                    });
                } catch (s) {
                    $5bdbe1ebf6713620$var$S("".concat(e, ": onPaste callback call is failed"), "error", s);
                }
                return i;
            }
        },
        {
            /**
   * Insert new default block at passed index
   *
   * @param {number} index - index where Block should be inserted
   * @param {boolean} needToFocus - if true, updates current Block index
   *
   * TODO: Remove method and use insert() with index instead (?)
   * @returns {Block} inserted Block
   */ key: "insertDefaultBlockAtIndex",
            value: function insertDefaultBlockAtIndex(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                var o = this.composeBlock({
                    tool: this.config.defaultBlock
                });
                return this._blocks[e] = o, this.blockDidMutated($5bdbe1ebf6713620$var$Mo, o, {
                    index: e
                }), t1 ? this.currentBlockIndex = e : e <= this.currentBlockIndex && this.currentBlockIndex++, o;
            }
        },
        {
            /**
   * Always inserts at the end
   *
   * @returns {Block}
   */ key: "insertAtEnd",
            value: function insertAtEnd() {
                return this.currentBlockIndex = this.blocks.length - 1, this.insert();
            }
        },
        {
            key: "mergeBlocks",
            value: /**
   * Merge two blocks
   *
   * @param {Block} targetBlock - previous block will be append to this block
   * @param {Block} blockToMerge - block that will be merged with target block
   * @returns {Promise} - the sequence that can be continued
   */ function mergeBlocks(e, t1) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var o, i, _yt, s, i1, s1, _tmp;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(e.name === t1.name && e.mergeable)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    t1.data
                                ];
                            case 1:
                                i = _state.sent();
                                if ($5bdbe1ebf6713620$var$V(i)) {
                                    console.error("Could not merge Block. Failed to extract original Block data.");
                                    return [
                                        2
                                    ];
                                }
                                _yt = (0, $f9AOD._)($5bdbe1ebf6713620$var$yt([
                                    i
                                ], e.tool.sanitizeConfig), 1), s = _yt[0];
                                o = s;
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                if (!(e.mergeable && $5bdbe1ebf6713620$var$He(t1, "export") && $5bdbe1ebf6713620$var$He(e, "import"))) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    t1.exportDataAsString()
                                ];
                            case 3:
                                i1 = _state.sent(), s1 = $5bdbe1ebf6713620$var$Z(i1, e.tool.sanitizeConfig);
                                o = $5bdbe1ebf6713620$var$Bo(s1, e.tool.conversionConfig);
                                _state.label = 4;
                            case 4:
                                _tmp = o !== void 0;
                                if (!_tmp) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    e.mergeWith(o)
                                ];
                            case 5:
                                _tmp = (_state.sent(), this.removeBlock(t1), this.currentBlockIndex = this._blocks.indexOf(e));
                                _state.label = 6;
                            case 6:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Remove passed Block
   *
   * @param block - Block to remove
   * @param addLastBlock - if true, adds new default block at the end. @todo remove this logic and use event-bus instead
   */ key: "removeBlock",
            value: function removeBlock(e) {
                var _this = this;
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                return new Promise(function(o) {
                    var i = _this._blocks.indexOf(e);
                    if (!_this.validateIndex(i)) throw new Error("Can't find a Block to remove");
                    _this._blocks.remove(i), e.destroy(), _this.blockDidMutated($5bdbe1ebf6713620$var$_o, e, {
                        index: i
                    }), _this.currentBlockIndex >= i && _this.currentBlockIndex--, _this.blocks.length ? i === 0 && (_this.currentBlockIndex = 0) : (_this.unsetCurrentBlock(), t1 && _this.insert()), o();
                });
            }
        },
        {
            /**
   * Remove only selected Blocks
   * and returns first Block index where started removing...
   *
   * @returns {number|undefined}
   */ key: "removeSelectedBlocks",
            value: function removeSelectedBlocks() {
                var e;
                for(var t1 = this.blocks.length - 1; t1 >= 0; t1--)this.blocks[t1].selected && (this.removeBlock(this.blocks[t1]), e = t1);
                return e;
            }
        },
        {
            /**
   * Attention!
   * After removing insert the new default typed Block and focus on it
   * Removes all blocks
   */ key: "removeAllBlocks",
            value: function removeAllBlocks() {
                for(var e = this.blocks.length - 1; e >= 0; e--)this._blocks.remove(e);
                this.unsetCurrentBlock(), this.insert(), this.currentBlock.firstInput.focus();
            }
        },
        {
            /**
   * Split current Block
   * 1. Extract content from Caret position to the Block`s end
   * 2. Insert a new Block below current one with extracted content
   *
   * @returns {Block}
   */ key: "split",
            value: function split() {
                var e = this.Editor.Caret.extractFragmentFromCaretPosition(), t1 = $5bdbe1ebf6713620$var$u.make("div");
                t1.appendChild(e);
                var o = {
                    text: $5bdbe1ebf6713620$var$u.isEmpty(t1) ? "" : t1.innerHTML
                };
                return this.insert({
                    data: o
                });
            }
        },
        {
            /**
   * Returns Block by passed index
   *
   * @param {number} index - index to get. -1 to get last
   * @returns {Block}
   */ key: "getBlockByIndex",
            value: function getBlockByIndex(e) {
                return e === -1 && (e = this._blocks.length - 1), this._blocks[e];
            }
        },
        {
            /**
   * Returns an index for passed Block
   *
   * @param block - block to find index
   */ key: "getBlockIndex",
            value: function getBlockIndex(e) {
                return this._blocks.indexOf(e);
            }
        },
        {
            /**
   * Returns the Block by passed id
   *
   * @param id - id of block to get
   * @returns {Block}
   */ key: "getBlockById",
            value: function getBlockById(e) {
                return this._blocks.array.find(function(t1) {
                    return t1.id === e;
                });
            }
        },
        {
            /**
   * Get Block instance by html element
   *
   * @param {Node} element - html element to get Block by
   */ key: "getBlock",
            value: function getBlock(e) {
                $5bdbe1ebf6713620$var$u.isElement(e) || (e = e.parentNode);
                var t1 = this._blocks.nodes, o = e.closest(".".concat($5bdbe1ebf6713620$var$R.CSS.wrapper)), i = t1.indexOf(o);
                if (i >= 0) return this._blocks[i];
            }
        },
        {
            /**
   * 1) Find first-level Block from passed child Node
   * 2) Mark it as current
   *
   * @param {Node} childNode - look ahead from this node.
   * @returns {Block | undefined} can return undefined in case when the passed child note is not a part of the current editor instance
   */ key: "setCurrentBlockByChildNode",
            value: function setCurrentBlockByChildNode(e) {
                $5bdbe1ebf6713620$var$u.isElement(e) || (e = e.parentNode);
                var t1 = e.closest(".".concat($5bdbe1ebf6713620$var$R.CSS.wrapper));
                if (!t1) return;
                var o = t1.closest(".".concat(this.Editor.UI.CSS.editorWrapper));
                if (o != null && o.isEqualNode(this.Editor.UI.nodes.wrapper)) return this.currentBlockIndex = this._blocks.nodes.indexOf(t1), this.currentBlock.updateCurrentInput(), this.currentBlock;
            }
        },
        {
            /**
   * Return block which contents passed node
   *
   * @param {Node} childNode - node to get Block by
   * @returns {Block}
   */ key: "getBlockByChildNode",
            value: function getBlockByChildNode(e) {
                if (!e || !(e instanceof Node)) return;
                $5bdbe1ebf6713620$var$u.isElement(e) || (e = e.parentNode);
                var t1 = e.closest(".".concat($5bdbe1ebf6713620$var$R.CSS.wrapper));
                return this.blocks.find(function(o) {
                    return o.holder === t1;
                });
            }
        },
        {
            /**
   * Swap Blocks Position
   *
   * @param {number} fromIndex - index of first block
   * @param {number} toIndex - index of second block
   * @deprecated — use 'move' instead
   */ key: "swap",
            value: function swap(e, t1) {
                this._blocks.swap(e, t1), this.currentBlockIndex = t1;
            }
        },
        {
            /**
   * Move a block to a new index
   *
   * @param {number} toIndex - index where to move Block
   * @param {number} fromIndex - index of Block to move
   */ key: "move",
            value: function move(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.currentBlockIndex;
                if (isNaN(e) || isNaN(t1)) {
                    $5bdbe1ebf6713620$var$S("Warning during 'move' call: incorrect indices provided.", "warn");
                    return;
                }
                if (!this.validateIndex(e) || !this.validateIndex(t1)) {
                    $5bdbe1ebf6713620$var$S("Warning during 'move' call: indices cannot be lower than 0 or greater than the amount of blocks.", "warn");
                    return;
                }
                this._blocks.move(e, t1), this.currentBlockIndex = e, this.blockDidMutated($5bdbe1ebf6713620$var$ia, this.currentBlock, {
                    fromIndex: t1,
                    toIndex: e
                });
            }
        },
        {
            key: "convert",
            value: /**
   * Converts passed Block to the new Tool
   * Uses Conversion Config
   *
   * @param blockToConvert - Block that should be converted
   * @param targetToolName - name of the Tool to convert to
   * @param blockDataOverrides - optional new Block data overrides
   */ function convert(e, t1, o) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var s, r, a, l;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    e.save()
                                ];
                            case 1:
                                if (!_state.sent()) throw new Error("Could not convert Block. Failed to extract original Block data.");
                                s = this.Editor.Tools.blockTools.get(t1);
                                if (!s) throw new Error("Could not convert Block. Tool \xab".concat(t1, "\xbb not found."));
                                return [
                                    4,
                                    e.exportDataAsString()
                                ];
                            case 2:
                                r = _state.sent(), a = $5bdbe1ebf6713620$var$Z(r, s.sanitizeConfig);
                                l = $5bdbe1ebf6713620$var$Bo(a, s.conversionConfig, s.settings);
                                return [
                                    2,
                                    (o && (l = Object.assign(l, o)), this.replace(e, s.name, l))
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Sets current Block Index -1 which means unknown
   * and clear highlights
   */ key: "unsetCurrentBlock",
            value: function unsetCurrentBlock() {
                this.currentBlockIndex = -1;
            }
        },
        {
            key: "clear",
            value: /**
   * Clears Editor
   *
   * @param {boolean} needToAddDefaultBlock - 1) in internal calls (for example, in api.blocks.render)
   *                                             we don't need to add an empty default block
   *                                        2) in api.blocks.clear we should add empty block
   */ function clear() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _this, e, t1;
                    var _arguments = arguments;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                e = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : !1;
                                t1 = new $5bdbe1ebf6713620$var$sa();
                                (0, $aUGqu._)(this.blocks).forEach(function(i) {
                                    t1.add(function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                            return (0, $13u2V._)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            this.removeBlock(i, !1)
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        }).call(_this);
                                    });
                                });
                                return [
                                    4,
                                    t1.completed
                                ];
                            case 1:
                                _state.sent(), this.unsetCurrentBlock(), e && this.insert(), this.Editor.UI.checkEmptiness();
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "destroy",
            value: /**
   * Cleans up all the block tools' resources
   * This is called when editor is destroyed
   */ function destroy() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(this.blocks.map(function(e) {
                                        return e.destroy();
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Bind Block events
   *
   * @param {Block} block - Block to which event should be bound
   */ key: "bindBlockEvents",
            value: function bindBlockEvents(e) {
                var _this = this;
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockEvents;
                this.readOnlyMutableListeners.on(e.holder, "keydown", function(o) {
                    t1.keydown(o);
                }), this.readOnlyMutableListeners.on(e.holder, "keyup", function(o) {
                    t1.keyup(o);
                }), this.readOnlyMutableListeners.on(e.holder, "dragover", function(o) {
                    t1.dragOver(o);
                }), this.readOnlyMutableListeners.on(e.holder, "dragleave", function(o) {
                    t1.dragLeave(o);
                }), e.on("didMutated", function(o) {
                    return _this.blockDidMutated($5bdbe1ebf6713620$var$Ao, o, {
                        index: _this.getBlockIndex(o)
                    });
                });
            }
        },
        {
            /**
   * Disable mutable handlers and bindings
   */ key: "disableModuleBindings",
            value: function disableModuleBindings() {
                this.readOnlyMutableListeners.clearAll();
            }
        },
        {
            /**
   * Enables all module handlers and bindings for all Blocks
   */ key: "enableModuleBindings",
            value: function enableModuleBindings() {
                var _this = this;
                this.readOnlyMutableListeners.on(document, "cut", function(e) {
                    return _this.Editor.BlockEvents.handleCommandX(e);
                }), this.blocks.forEach(function(e) {
                    _this.bindBlockEvents(e);
                });
            }
        },
        {
            /**
   * Validates that the given index is not lower than 0 or higher than the amount of blocks
   *
   * @param {number} index - index of blocks array to validate
   * @returns {boolean}
   */ key: "validateIndex",
            value: function validateIndex(e) {
                return !(e < 0 || e >= this._blocks.length);
            }
        },
        {
            /**
   * Block mutation callback
   *
   * @param mutationType - what happened with block
   * @param block - mutated block
   * @param detailData - additional data to pass with change event
   */ key: "blockDidMutated",
            value: function blockDidMutated(e, t1, o) {
                var i = new CustomEvent(e, {
                    detail: (0, $1XAnY._)({
                        target: new $5bdbe1ebf6713620$var$J(t1)
                    }, o)
                });
                return this.eventsDispatcher.emit($5bdbe1ebf6713620$var$$o, {
                    event: i
                }), t1;
            }
        }
    ]);
    return ra;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$aa = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(aa, E);
    function aa() {
        (0, $173N4._)(this, aa);
        var _this;
        _this = (0, $7qXGD._)(this, aa, arguments), _this.anyBlockSelectedCache = null, _this.needToSelectAll = !1, _this.nativeInputSelected = !1, _this.readyToBlockSelection = !1;
        return _this;
    }
    (0, $cFHGC._)(aa, [
        {
            key: "sanitizerConfig",
            get: /**
   * Sanitizer Config
   *
   * @returns {SanitizerConfig}
   */ function get() {
                return {
                    p: {},
                    h1: {},
                    h2: {},
                    h3: {},
                    h4: {},
                    h5: {},
                    h6: {},
                    ol: {},
                    ul: {},
                    li: {},
                    br: !0,
                    img: {
                        src: !0,
                        width: !0,
                        height: !0
                    },
                    a: {
                        href: !0
                    },
                    b: {},
                    i: {},
                    u: {}
                };
            }
        },
        {
            key: "allBlocksSelected",
            get: /**
   * Flag that identifies all Blocks selection
   *
   * @returns {boolean}
   */ function get() {
                var _this_Editor = this.Editor, e = _this_Editor.BlockManager;
                return e.blocks.every(function(t1) {
                    return t1.selected === !0;
                });
            },
            set: /**
   * Set selected all blocks
   *
   * @param {boolean} state - state to set
   */ function set(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager;
                t1.blocks.forEach(function(o) {
                    o.selected = e;
                }), this.clearCache();
            }
        },
        {
            key: "anyBlockSelected",
            get: /**
   * Flag that identifies any Block selection
   *
   * @returns {boolean}
   */ function get() {
                var _this_Editor = this.Editor, e = _this_Editor.BlockManager;
                return this.anyBlockSelectedCache === null && (this.anyBlockSelectedCache = e.blocks.some(function(t1) {
                    return t1.selected === !0;
                })), this.anyBlockSelectedCache;
            }
        },
        {
            key: "selectedBlocks",
            get: /**
   * Return selected Blocks array
   *
   * @returns {Block[]}
   */ function get() {
                return this.Editor.BlockManager.blocks.filter(function(e) {
                    return e.selected;
                });
            }
        },
        {
            /**
   * Module Preparation
   * Registers Shortcuts CMD+A and CMD+C
   * to select all and copy them
   */ key: "prepare",
            value: function prepare() {
                var _this = this;
                this.selection = new $5bdbe1ebf6713620$var$b(), $5bdbe1ebf6713620$var$ge.add({
                    name: "CMD+A",
                    handler: function(e) {
                        var _this_Editor = _this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.ReadOnly;
                        if (o.isEnabled) {
                            e.preventDefault(), _this.selectAllBlocks();
                            return;
                        }
                        t1.currentBlock && _this.handleCommandA(e);
                    },
                    on: this.Editor.UI.nodes.redactor
                });
            }
        },
        {
            /**
   * Toggle read-only state
   *
   *  - Remove all ranges
   *  - Unselect all Blocks
   */ key: "toggleReadOnly",
            value: function toggleReadOnly() {
                $5bdbe1ebf6713620$var$b.get().removeAllRanges(), this.allBlocksSelected = !1;
            }
        },
        {
            /**
   * Remove selection of Block
   *
   * @param {number?} index - Block index according to the BlockManager's indexes
   */ key: "unSelectBlockByIndex",
            value: function unSelectBlockByIndex(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager;
                var o;
                isNaN(e) ? o = t1.currentBlock : o = t1.getBlockByIndex(e), o.selected = !1, this.clearCache();
            }
        },
        {
            /**
   * Clear selection from Blocks
   *
   * @param {Event} reason - event caused clear of selection
   * @param {boolean} restoreSelection - if true, restore saved selection
   */ key: "clearSelection",
            value: function clearSelection(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                var _this_Editor = this.Editor, o = _this_Editor.BlockManager, i = _this_Editor.Caret, s = _this_Editor.RectangleSelection;
                this.needToSelectAll = !1, this.nativeInputSelected = !1, this.readyToBlockSelection = !1;
                var r = e && e instanceof KeyboardEvent, a = r && $5bdbe1ebf6713620$var$Po(e.keyCode);
                if (this.anyBlockSelected && r && a && !$5bdbe1ebf6713620$var$b.isSelectionExists) {
                    var l = o.removeSelectedBlocks();
                    o.insertDefaultBlockAtIndex(l, !0), i.setToBlock(o.currentBlock), $5bdbe1ebf6713620$var$Fe(function() {
                        var c = e.key;
                        i.insertContentAtCaretPosition(c.length > 1 ? "" : c);
                    }, 20)();
                }
                if (this.Editor.CrossBlockSelection.clear(e), !this.anyBlockSelected || s.isRectActivated()) {
                    this.Editor.RectangleSelection.clearSelection();
                    return;
                }
                t1 && this.selection.restore(), this.allBlocksSelected = !1;
            }
        },
        {
            /**
   * Reduce each Block and copy its content
   *
   * @param {ClipboardEvent} e - copy/cut event
   * @returns {Promise<void>}
   */ key: "copySelectedBlocks",
            value: function copySelectedBlocks(e) {
                var _this = this;
                e.preventDefault();
                var t1 = $5bdbe1ebf6713620$var$u.make("div");
                this.selectedBlocks.forEach(function(s) {
                    var r = $5bdbe1ebf6713620$var$Z(s.holder.innerHTML, _this.sanitizerConfig), a = $5bdbe1ebf6713620$var$u.make("p");
                    a.innerHTML = r, t1.appendChild(a);
                });
                var o = Array.from(t1.childNodes).map(function(s) {
                    return s.textContent;
                }).join("\n\n"), i = t1.innerHTML;
                return e.clipboardData.setData("text/plain", o), e.clipboardData.setData("text/html", i), Promise.all(this.selectedBlocks.map(function(s) {
                    return s.save();
                })).then(function(s) {
                    try {
                        e.clipboardData.setData(_this.Editor.Paste.MIME_TYPE, JSON.stringify(s));
                    } catch (e) {}
                });
            }
        },
        {
            /**
   * Select Block by its index
   *
   * @param {number?} index - Block index according to the BlockManager's indexes
   */ key: "selectBlockByIndex",
            value: function selectBlockByIndex(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = t1.getBlockByIndex(e);
                o !== void 0 && this.selectBlock(o);
            }
        },
        {
            /**
   * Select passed Block
   *
   * @param {Block} block - Block to select
   */ key: "selectBlock",
            value: function selectBlock(e) {
                this.selection.save(), $5bdbe1ebf6713620$var$b.get().removeAllRanges(), e.selected = !0, this.clearCache(), this.Editor.InlineToolbar.close();
            }
        },
        {
            /**
   * Remove selection from passed Block
   *
   * @param {Block} block - Block to unselect
   */ key: "unselectBlock",
            value: function unselectBlock(e) {
                e.selected = !1, this.clearCache();
            }
        },
        {
            /**
   * Clear anyBlockSelected cache
   */ key: "clearCache",
            value: function clearCache() {
                this.anyBlockSelectedCache = null;
            }
        },
        {
            /**
   * Module destruction
   * De-registers Shortcut CMD+A
   */ key: "destroy",
            value: function destroy() {
                $5bdbe1ebf6713620$var$ge.remove(this.Editor.UI.nodes.redactor, "CMD+A");
            }
        },
        {
            /**
   * First CMD+A selects all input content by native behaviour,
   * next CMD+A keypress selects all blocks
   *
   * @param {KeyboardEvent} event - keyboard event
   */ key: "handleCommandA",
            value: function handleCommandA(e) {
                if (this.Editor.RectangleSelection.clearSelection(), $5bdbe1ebf6713620$var$u.isNativeInput(e.target) && !this.readyToBlockSelection) {
                    this.readyToBlockSelection = !0;
                    return;
                }
                var t1 = this.Editor.BlockManager.getBlock(e.target), o = t1.inputs;
                if (o.length > 1 && !this.readyToBlockSelection) {
                    this.readyToBlockSelection = !0;
                    return;
                }
                if (o.length === 1 && !this.needToSelectAll) {
                    this.needToSelectAll = !0;
                    return;
                }
                this.needToSelectAll ? (e.preventDefault(), this.selectAllBlocks(), this.needToSelectAll = !1, this.readyToBlockSelection = !1) : this.readyToBlockSelection && (e.preventDefault(), this.selectBlock(t1), this.needToSelectAll = !0);
            }
        },
        {
            /**
   * Select All Blocks
   * Each Block has selected setter that makes Block copyable
   */ key: "selectAllBlocks",
            value: function selectAllBlocks() {
                this.selection.save(), $5bdbe1ebf6713620$var$b.get().removeAllRanges(), this.allBlocksSelected = !0, this.Editor.InlineToolbar.close();
            }
        }
    ]);
    return aa;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$Ye = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(Ye, E);
    function Ye() {
        (0, $173N4._)(this, Ye);
        return (0, $7qXGD._)(this, Ye, arguments);
    }
    (0, $cFHGC._)(Ye, [
        {
            key: "positions",
            get: /**
   * Allowed caret positions in input
   *
   * @static
   * @returns {{START: string, END: string, DEFAULT: string}}
   */ function get() {
                return {
                    START: "start",
                    END: "end",
                    DEFAULT: "default"
                };
            }
        },
        {
            /**
   * Method gets Block instance and puts caret to the text node with offset
   * There two ways that method applies caret position:
   *   - first found text node: sets at the beginning, but you can pass an offset
   *   - last found text node: sets at the end of the node. Also, you can customize the behaviour
   *
   * @param {Block} block - Block class
   * @param {string} position - position where to set caret.
   *                            If default - leave default behaviour and apply offset if it's passed
   * @param {number} offset - caret offset regarding to the block content
   */ key: "setToBlock",
            value: function setToBlock(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.positions.DEFAULT, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var c;
                var _this_Editor = this.Editor, i = _this_Editor.BlockManager, s = _this_Editor.BlockSelection;
                if (s.clearSelection(), !e.focusable) {
                    (c = window.getSelection()) == null || c.removeAllRanges(), s.selectBlock(e), i.currentBlock = e;
                    return;
                }
                var r;
                switch(t1){
                    case this.positions.START:
                        r = e.firstInput;
                        break;
                    case this.positions.END:
                        r = e.lastInput;
                        break;
                    default:
                        r = e.currentInput;
                }
                if (!r) return;
                var a, l = o;
                if (t1 === this.positions.START) a = $5bdbe1ebf6713620$var$u.getDeepestNode(r, !1), l = 0;
                else if (t1 === this.positions.END) a = $5bdbe1ebf6713620$var$u.getDeepestNode(r, !0), l = $5bdbe1ebf6713620$var$u.getContentLength(a);
                else {
                    var _u_getNodeByOffset = $5bdbe1ebf6713620$var$u.getNodeByOffset(r, o), d = _u_getNodeByOffset.node, h = _u_getNodeByOffset.offset;
                    d ? (a = d, l = h) : (a = $5bdbe1ebf6713620$var$u.getDeepestNode(r, !1), l = 0);
                }
                this.set(a, l), i.setCurrentBlockByChildNode(e.holder), i.currentBlock.currentInput = r;
            }
        },
        {
            /**
   * Set caret to the current input of current Block.
   *
   * @param {HTMLElement} input - input where caret should be set
   * @param {string} position - position of the caret.
   *                            If default - leave default behaviour and apply offset if it's passed
   * @param {number} offset - caret offset regarding to the text node
   */ key: "setToInput",
            value: function setToInput(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.positions.DEFAULT, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var _this_Editor_BlockManager = this.Editor.BlockManager, i = _this_Editor_BlockManager.currentBlock, s = $5bdbe1ebf6713620$var$u.getDeepestNode(e);
                switch(t1){
                    case this.positions.START:
                        this.set(s, 0);
                        break;
                    case this.positions.END:
                        this.set(s, $5bdbe1ebf6713620$var$u.getContentLength(s));
                        break;
                    default:
                        o && this.set(s, o);
                }
                i.currentInput = e;
            }
        },
        {
            /**
   * Creates Document Range and sets caret to the element with offset
   *
   * @param {HTMLElement} element - target node.
   * @param {number} offset - offset
   */ key: "set",
            value: function set(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var _b_setCursor = $5bdbe1ebf6713620$var$b.setCursor(e, t1), i = _b_setCursor.top, s = _b_setCursor.bottom, r = window.innerHeight;
                i < 0 ? window.scrollBy(0, i - 30) : s > r && window.scrollBy(0, s - r + 30);
            }
        },
        {
            /**
   * Set Caret to the last Block
   * If last block is not empty, append another empty block
   */ key: "setToTheLastBlock",
            value: function setToTheLastBlock() {
                var e = this.Editor.BlockManager.lastBlock;
                if (e) {
                    if (e.tool.isDefault && e.isEmpty) this.setToBlock(e);
                    else {
                        var t1 = this.Editor.BlockManager.insertAtEnd();
                        this.setToBlock(t1);
                    }
                }
            }
        },
        {
            /**
   * Extract content fragment of current Block from Caret position to the end of the Block
   */ key: "extractFragmentFromCaretPosition",
            value: function extractFragmentFromCaretPosition() {
                var e = $5bdbe1ebf6713620$var$b.get();
                if (e.rangeCount) {
                    var t1 = e.getRangeAt(0), o = this.Editor.BlockManager.currentBlock.currentInput;
                    if (t1.deleteContents(), o) {
                        if ($5bdbe1ebf6713620$var$u.isNativeInput(o)) {
                            var i = o, s = document.createDocumentFragment(), r = i.value.substring(0, i.selectionStart), a = i.value.substring(i.selectionStart);
                            return s.textContent = a, i.value = r, s;
                        } else {
                            var i1 = t1.cloneRange();
                            return i1.selectNodeContents(o), i1.setStart(t1.endContainer, t1.endOffset), i1.extractContents();
                        }
                    }
                }
            }
        },
        {
            /**
   * Set's caret to the next Block or Tool`s input
   * Before moving caret, we should check if caret position is at the end of Plugins node
   * Using {@link Dom#getDeepestNode} to get a last node and match with current selection
   *
   * @param {boolean} force - pass true to skip check for caret position
   */ key: "navigateNext",
            value: function navigateNext() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = t1.currentBlock, i = t1.nextBlock;
                if (o === void 0) return !1;
                var s = o.nextInput, r = o.currentInput, a = r !== void 0 ? $5bdbe1ebf6713620$var$Re(r) : void 0;
                var l = i;
                var c = e || a || !o.focusable;
                if (s && c) return this.setToInput(s, this.positions.START), !0;
                if (l === null) {
                    if (o.tool.isDefault || !c) return !1;
                    l = t1.insertAtEnd();
                }
                return c ? (this.setToBlock(l, this.positions.START), !0) : !1;
            }
        },
        {
            /**
   * Set's caret to the previous Tool`s input or Block
   * Before moving caret, we should check if caret position is start of the Plugins node
   * Using {@link Dom#getDeepestNode} to get a last node and match with current selection
   *
   * @param {boolean} force - pass true to skip check for caret position
   */ key: "navigatePrevious",
            value: function navigatePrevious() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                var _this_Editor_BlockManager = this.Editor.BlockManager, t1 = _this_Editor_BlockManager.currentBlock, o = _this_Editor_BlockManager.previousBlock;
                if (!t1) return !1;
                var i = t1.previousInput, s = t1.currentInput, r = s !== void 0 ? $5bdbe1ebf6713620$var$Ne(s) : void 0, a = e || r || !t1.focusable;
                return i && a ? (this.setToInput(i, this.positions.END), !0) : o !== null && a ? (this.setToBlock(o, this.positions.END), !0) : !1;
            }
        },
        {
            /**
   * Inserts shadow element after passed element where caret can be placed
   *
   * @param {Element} element - element after which shadow caret should be inserted
   */ key: "createShadow",
            value: function createShadow(e) {
                var t1 = document.createElement("span");
                t1.classList.add(Ye.CSS.shadowCaret), e.insertAdjacentElement("beforeend", t1);
            }
        },
        {
            /**
   * Restores caret position
   *
   * @param {HTMLElement} element - element where caret should be restored
   */ key: "restoreCaret",
            value: function restoreCaret(e) {
                var t1 = e.querySelector(".".concat(Ye.CSS.shadowCaret));
                if (!t1) return;
                new $5bdbe1ebf6713620$var$b().expandToTag(t1);
                var i = document.createRange();
                i.selectNode(t1), i.extractContents();
            }
        },
        {
            /**
   * Inserts passed content at caret position
   *
   * @param {string} content - content to insert
   */ key: "insertContentAtCaretPosition",
            value: function insertContentAtCaretPosition(e) {
                var t1 = document.createDocumentFragment(), o = document.createElement("div"), i = $5bdbe1ebf6713620$var$b.get(), s = $5bdbe1ebf6713620$var$b.range;
                o.innerHTML = e, Array.from(o.childNodes).forEach(function(c) {
                    return t1.appendChild(c);
                }), t1.childNodes.length === 0 && t1.appendChild(new Text());
                var r = t1.lastChild;
                s.deleteContents(), s.insertNode(t1);
                var a = document.createRange(), l = r.nodeType === Node.TEXT_NODE ? r : r.firstChild;
                l !== null && l.textContent !== null && a.setStart(l, l.textContent.length), i.removeAllRanges(), i.addRange(a);
            }
        }
    ], [
        {
            key: "CSS",
            get: /**
   * Elements styles that can be useful for Caret Module
   */ function get() {
                return {
                    shadowCaret: "cdx-shadow-caret"
                };
            }
        }
    ]);
    return Ye;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$la = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(la, E);
    function la() {
        (0, $173N4._)(this, la);
        var _this;
        _this = (0, $7qXGD._)(this, la, arguments), _this.onMouseUp = function() {
            _this.listeners.off(document, "mouseover", _this.onMouseOver), _this.listeners.off(document, "mouseup", _this.onMouseUp);
        }, _this.onMouseOver = function(e) {
            var _this_Editor = _this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.BlockSelection;
            if (e.relatedTarget === null && e.target === null) return;
            var i = t1.getBlockByChildNode(e.relatedTarget) || _this.lastSelectedBlock, s = t1.getBlockByChildNode(e.target);
            if (!(!i || !s) && s !== i) {
                if (i === _this.firstSelectedBlock) {
                    $5bdbe1ebf6713620$var$b.get().removeAllRanges(), i.selected = !0, s.selected = !0, o.clearCache();
                    return;
                }
                if (s === _this.firstSelectedBlock) {
                    i.selected = !1, s.selected = !1, o.clearCache();
                    return;
                }
                _this.Editor.InlineToolbar.close(), _this.toggleBlocksSelectedState(i, s), _this.lastSelectedBlock = s;
            }
        };
        return _this;
    }
    (0, $cFHGC._)(la, [
        {
            key: "prepare",
            value: /**
   * Module preparation
   *
   * @returns {Promise}
   */ function prepare() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _this;
                    return (0, $13u2V._)(this, function(_state) {
                        _this = this;
                        this.listeners.on(document, "mousedown", function(e) {
                            _this.enableCrossBlockSelection(e);
                        });
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            /**
   * Sets up listeners
   *
   * @param {MouseEvent} event - mouse down event
   */ key: "watchSelection",
            value: function watchSelection(e) {
                if (e.button !== $5bdbe1ebf6713620$var$qn.LEFT) return;
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager;
                this.firstSelectedBlock = t1.getBlock(e.target), this.lastSelectedBlock = this.firstSelectedBlock, this.listeners.on(document, "mouseover", this.onMouseOver), this.listeners.on(document, "mouseup", this.onMouseUp);
            }
        },
        {
            key: "isCrossBlockSelectionStarted",
            get: /**
   * Return boolean is cross block selection started:
   * there should be at least 2 selected blocks
   */ function get() {
                return !!this.firstSelectedBlock && !!this.lastSelectedBlock && this.firstSelectedBlock !== this.lastSelectedBlock;
            }
        },
        {
            /**
   * Change selection state of the next Block
   * Used for CBS via Shift + arrow keys
   *
   * @param {boolean} next - if true, toggle next block. Previous otherwise
   */ key: "toggleBlockSelectedState",
            value: function toggleBlockSelectedState() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.BlockSelection;
                this.lastSelectedBlock || (this.lastSelectedBlock = this.firstSelectedBlock = t1.currentBlock), this.firstSelectedBlock === this.lastSelectedBlock && (this.firstSelectedBlock.selected = !0, o.clearCache(), $5bdbe1ebf6713620$var$b.get().removeAllRanges());
                var i = t1.blocks.indexOf(this.lastSelectedBlock) + (e ? 1 : -1), s = t1.blocks[i];
                s && (this.lastSelectedBlock.selected !== s.selected ? (s.selected = !0, o.clearCache()) : (this.lastSelectedBlock.selected = !1, o.clearCache()), this.lastSelectedBlock = s, this.Editor.InlineToolbar.close(), s.holder.scrollIntoView({
                    block: "nearest"
                }));
            }
        },
        {
            /**
   * Clear saved state
   *
   * @param {Event} reason - event caused clear of selection
   */ key: "clear",
            value: function clear(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.BlockSelection, i = _this_Editor.Caret, s = t1.blocks.indexOf(this.firstSelectedBlock), r = t1.blocks.indexOf(this.lastSelectedBlock);
                if (o.anyBlockSelected && s > -1 && r > -1 && e && e instanceof KeyboardEvent) switch(e.keyCode){
                    case $5bdbe1ebf6713620$var$y.DOWN:
                    case $5bdbe1ebf6713620$var$y.RIGHT:
                        i.setToBlock(t1.blocks[Math.max(s, r)], i.positions.END);
                        break;
                    case $5bdbe1ebf6713620$var$y.UP:
                    case $5bdbe1ebf6713620$var$y.LEFT:
                        i.setToBlock(t1.blocks[Math.min(s, r)], i.positions.START);
                        break;
                    default:
                        i.setToBlock(t1.blocks[Math.max(s, r)], i.positions.END);
                }
                this.firstSelectedBlock = this.lastSelectedBlock = null;
            }
        },
        {
            /**
   * Enables Cross Block Selection
   *
   * @param {MouseEvent} event - mouse down event
   */ key: "enableCrossBlockSelection",
            value: function enableCrossBlockSelection(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.UI;
                $5bdbe1ebf6713620$var$b.isCollapsed || this.Editor.BlockSelection.clearSelection(e), t1.nodes.redactor.contains(e.target) ? this.watchSelection(e) : this.Editor.BlockSelection.clearSelection(e);
            }
        },
        {
            /**
   * Change blocks selection state between passed two blocks.
   *
   * @param {Block} firstBlock - first block in range
   * @param {Block} lastBlock - last block in range
   */ key: "toggleBlocksSelectedState",
            value: function toggleBlocksSelectedState(e, t1) {
                var _this_Editor = this.Editor, o = _this_Editor.BlockManager, i = _this_Editor.BlockSelection, s = o.blocks.indexOf(e), r = o.blocks.indexOf(t1), a = e.selected !== t1.selected;
                for(var l = Math.min(s, r); l <= Math.max(s, r); l++){
                    var c = o.blocks[l];
                    c !== this.firstSelectedBlock && c !== (a ? e : t1) && (o.blocks[l].selected = !o.blocks[l].selected, i.clearCache());
                }
            }
        }
    ]);
    return la;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$ca = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(ca, E);
    function ca() {
        (0, $173N4._)(this, ca);
        var _this;
        _this = (0, $7qXGD._)(this, ca, arguments), _this.isStartedAtEditor = !1;
        return _this;
    }
    (0, $cFHGC._)(ca, [
        {
            /**
   * Toggle read-only state
   *
   * if state is true:
   *  - disable all drag-n-drop event handlers
   *
   * if state is false:
   *  - restore drag-n-drop event handlers
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ key: "toggleReadOnly",
            value: function toggleReadOnly(e) {
                e ? this.disableModuleBindings() : this.enableModuleBindings();
            }
        },
        {
            /**
   * Add drag events listeners to editor zone
   */ key: "enableModuleBindings",
            value: function enableModuleBindings() {
                var _this = this;
                var _this_Editor = this.Editor, e = _this_Editor.UI;
                this.readOnlyMutableListeners.on(e.nodes.holder, "drop", function(t1) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.processDrop(t1)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }).call(_this);
                }, !0), this.readOnlyMutableListeners.on(e.nodes.holder, "dragstart", function() {
                    _this.processDragStart();
                }), this.readOnlyMutableListeners.on(e.nodes.holder, "dragover", function(t1) {
                    _this.processDragOver(t1);
                }, !0);
            }
        },
        {
            /**
   * Unbind drag-n-drop event handlers
   */ key: "disableModuleBindings",
            value: function disableModuleBindings() {
                this.readOnlyMutableListeners.clearAll();
            }
        },
        {
            key: "processDrop",
            value: /**
   * Handle drop event
   *
   * @param {DragEvent} dropEvent - drop event
   */ function processDrop(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _this_Editor, t1, o, i, s, r;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.Paste, i = _this_Editor.Caret;
                                e.preventDefault(), t1.blocks.forEach(function(r) {
                                    r.dropTarget = !1;
                                }), $5bdbe1ebf6713620$var$b.isAtEditor && !$5bdbe1ebf6713620$var$b.isCollapsed && this.isStartedAtEditor && document.execCommand("delete"), this.isStartedAtEditor = !1;
                                s = t1.setCurrentBlockByChildNode(e.target);
                                if (s) this.Editor.Caret.setToBlock(s, i.positions.END);
                                else {
                                    r = t1.setCurrentBlockByChildNode(t1.lastBlock.holder);
                                    this.Editor.Caret.setToBlock(r, i.positions.END);
                                }
                                return [
                                    4,
                                    o.processDataTransfer(e.dataTransfer, !0)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Handle drag start event
   */ key: "processDragStart",
            value: function processDragStart() {
                $5bdbe1ebf6713620$var$b.isAtEditor && !$5bdbe1ebf6713620$var$b.isCollapsed && (this.isStartedAtEditor = !0), this.Editor.InlineToolbar.close();
            }
        },
        {
            /**
   * @param {DragEvent} dragEvent - drag event
   */ key: "processDragOver",
            value: function processDragOver(e) {
                e.preventDefault();
            }
        }
    ]);
    return ca;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$da = 180, $5bdbe1ebf6713620$var$ua = 400;
var $5bdbe1ebf6713620$var$ha = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(ha, E);
    function ha(param) {
        var e = param.config, t1 = param.eventsDispatcher;
        (0, $173N4._)(this, ha);
        var _this;
        _this = (0, $7qXGD._)(this, ha, [
            {
                config: e,
                eventsDispatcher: t1
            }
        ]), _this.disabled = !1, _this.batchingTimeout = null, _this.batchingOnChangeQueue = /* @__PURE__ */ new Map(), _this.batchTime = $5bdbe1ebf6713620$var$ua, _this.mutationObserver = new MutationObserver(function(o) {
            _this.redactorChanged(o);
        }), _this.eventsDispatcher.on($5bdbe1ebf6713620$var$$o, function(o) {
            _this.particularBlockChanged(o.event);
        }), _this.eventsDispatcher.on($5bdbe1ebf6713620$var$zo, function() {
            _this.disable();
        }), _this.eventsDispatcher.on($5bdbe1ebf6713620$var$Uo, function() {
            _this.enable();
        });
        return _this;
    }
    (0, $cFHGC._)(ha, [
        {
            /**
   * Enables onChange event
   */ key: "enable",
            value: function enable() {
                this.mutationObserver.observe(this.Editor.UI.nodes.redactor, {
                    childList: !0,
                    subtree: !0,
                    characterData: !0,
                    attributes: !0
                }), this.disabled = !1;
            }
        },
        {
            /**
   * Disables onChange event
   */ key: "disable",
            value: function disable() {
                this.mutationObserver.disconnect(), this.disabled = !0;
            }
        },
        {
            /**
   * Call onChange event passed to Editor.js configuration
   *
   * @param event - some of our custom change events
   */ key: "particularBlockChanged",
            value: function particularBlockChanged(e) {
                var _this = this;
                this.disabled || !$5bdbe1ebf6713620$var$A(this.config.onChange) || (this.batchingOnChangeQueue.set("block:".concat(e.detail.target.id, ":event:").concat(e.type), e), this.batchingTimeout && clearTimeout(this.batchingTimeout), this.batchingTimeout = setTimeout(function() {
                    var t1;
                    _this.batchingOnChangeQueue.size === 1 ? t1 = _this.batchingOnChangeQueue.values().next().value : t1 = Array.from(_this.batchingOnChangeQueue.values()), _this.config.onChange && _this.config.onChange(_this.Editor.API.methods, t1), _this.batchingOnChangeQueue.clear();
                }, this.batchTime));
            }
        },
        {
            /**
   * Fired on every blocks wrapper dom change
   *
   * @param mutations - mutations happened
   */ key: "redactorChanged",
            value: function redactorChanged(e) {
                this.eventsDispatcher.emit($5bdbe1ebf6713620$var$ft, {
                    mutations: e
                });
            }
        }
    ]);
    return ha;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$Rn = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(Dn, E);
    function Dn() {
        (0, $173N4._)(this, Dn);
        var _this;
        var _this1, _arguments = arguments;
        _this = (0, $7qXGD._)(this, Dn, (0, $aUGqu._)(_arguments)), _this1 = _this, _this1.MIME_TYPE = "application/x-editor-js", _this1.toolsTags = {}, _this1.tagsByTool = {}, _this1.toolsPatterns = [], _this1.toolsFiles = {}, _this1.exceptionList = [], _this1.processTool = function(e) {
            try {
                var _$t = e.create({}, {}, !1);
                if (e.pasteConfig === !1) {
                    _this1.exceptionList.push(e.name);
                    return;
                }
                if (!$5bdbe1ebf6713620$var$A(_$t.onPaste)) return;
                _this1.getTagsConfig(e), _this1.getFilesConfig(e), _this1.getPatternsConfig(e);
            } catch (t1) {
                $5bdbe1ebf6713620$var$S("Paste handling for \xab".concat(e.name, "\xbb Tool hasn't been set up because of the error"), "warn", t1);
            }
        }, _this1.handlePasteEvent = function(e) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var _this_Editor, t1, o, i;
                return (0, $13u2V._)(this, function(_state) {
                    _this_Editor = _this1.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.Toolbar, i = t1.setCurrentBlockByChildNode(e.target);
                    !i || _this1.isNativeBehaviour(e.target) && !e.clipboardData.types.includes("Files") || i && _this1.exceptionList.includes(i.name) || (e.preventDefault(), _this1.processDataTransfer(e.clipboardData), o.close());
                    return [
                        2
                    ];
                });
            })();
        };
        return _this;
    }
    (0, $cFHGC._)(Dn, [
        {
            key: "prepare",
            value: /**
   * Set onPaste callback and collect tools` paste configurations
   */ function prepare() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    return (0, $13u2V._)(this, function(_state) {
                        this.processTools();
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            /**
   * Set read-only state
   *
   * @param {boolean} readOnlyEnabled - read only flag value
   */ key: "toggleReadOnly",
            value: function toggleReadOnly(e) {
                e ? this.unsetCallback() : this.setCallback();
            }
        },
        {
            key: "processDataTransfer",
            value: /**
   * Handle pasted or dropped data transfer object
   *
   * @param {DataTransfer} dataTransfer - pasted or dropped data transfer object
   * @param {boolean} isDragNDrop - true if data transfer comes from drag'n'drop events
   */ function processDataTransfer(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function(e) {
                    var _this, t1, _this_Editor, o, i, r, a, l, c, d, h, _tmp;
                    var _arguments = arguments;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                t1 = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : !1;
                                _this_Editor = this.Editor, o = _this_Editor.Tools, i = e.types;
                                if (!((i.includes ? i.includes("Files") : i.contains("Files")) && !$5bdbe1ebf6713620$var$V(this.toolsFiles))) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.processFiles(e.files)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                r = e.getData(this.MIME_TYPE), a = e.getData("text/plain");
                                l = e.getData("text/html");
                                if (r) try {
                                    this.insertEditorJSData(JSON.parse(r));
                                    return [
                                        2
                                    ];
                                } catch (e) {}
                                t1 && a.trim() && l.trim() && (l = "<p>" + (l.trim() ? l : a) + "</p>");
                                c = Object.keys(this.toolsTags).reduce(function(p, g) {
                                    var _this_toolsTags_g_sanitizationConfig;
                                    return p[g.toLowerCase()] = (_this_toolsTags_g_sanitizationConfig = _this.toolsTags[g].sanitizationConfig) !== null && _this_toolsTags_g_sanitizationConfig !== void 0 ? _this_toolsTags_g_sanitizationConfig : {}, p;
                                }, {}), d = Object.assign({}, c, o.getAllInlineToolsSanitizeConfig(), {
                                    br: {}
                                }), h = $5bdbe1ebf6713620$var$Z(l, d);
                                if (!(!h.trim() || h.trim() === a || !$5bdbe1ebf6713620$var$u.isHTMLString(h))) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    this.processText(a)
                                ];
                            case 3:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                return [
                                    4,
                                    this.processText(h, !0)
                                ];
                            case 5:
                                _tmp = _state.sent();
                                _state.label = 6;
                            case 6:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "processText",
            value: /**
   * Process pasted text and divide them into Blocks
   *
   * @param {string} data - text to process. Can be HTML or plain.
   * @param {boolean} isHTML - if passed string is HTML, this parameter should be true
   */ function processText(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function(e) {
                    var _this, t1, _this_Editor, o, i, s, a;
                    var _arguments = arguments;
                    return (0, $13u2V._)(this, function(_state) {
                        _this = this;
                        t1 = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : !1;
                        _this_Editor = this.Editor, o = _this_Editor.Caret, i = _this_Editor.BlockManager, s = t1 ? this.processHTML(e) : this.processPlain(e);
                        if (!s.length) return [
                            2
                        ];
                        if (s.length === 1) {
                            s[0].isBlock ? this.processSingleBlock(s.pop()) : this.processInlinePaste(s.pop());
                            return [
                                2
                            ];
                        }
                        a = i.currentBlock && i.currentBlock.tool.isDefault && i.currentBlock.isEmpty;
                        s.map(function(l, c) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                return (0, $13u2V._)(this, function(_state) {
                                    return [
                                        2,
                                        this.insertBlock(l, c === 0 && a)
                                    ];
                                });
                            }).call(_this);
                        }), i.currentBlock && o.setToBlock(i.currentBlock, o.positions.END);
                        return [
                            2
                        ];
                    });
                }).apply(this, arguments);
            }
        },
        {
            /**
   * Set onPaste callback handler
   */ key: "setCallback",
            value: function setCallback() {
                this.listeners.on(this.Editor.UI.nodes.holder, "paste", this.handlePasteEvent);
            }
        },
        {
            /**
   * Unset onPaste callback handler
   */ key: "unsetCallback",
            value: function unsetCallback() {
                this.listeners.off(this.Editor.UI.nodes.holder, "paste", this.handlePasteEvent);
            }
        },
        {
            /**
   * Get and process tool`s paste configs
   */ key: "processTools",
            value: function processTools() {
                var e = this.Editor.Tools.blockTools;
                Array.from(e.values()).forEach(this.processTool);
            }
        },
        {
            /**
   * Get tags name list from either tag name or sanitization config.
   *
   * @param {string | object} tagOrSanitizeConfig - tag name or sanitize config object.
   * @returns {string[]} array of tags.
   */ key: "collectTagNames",
            value: function collectTagNames(e) {
                return $5bdbe1ebf6713620$var$te(e) ? [
                    e
                ] : $5bdbe1ebf6713620$var$D(e) ? Object.keys(e) : [];
            }
        },
        {
            /**
   * Get tags to substitute by Tool
   *
   * @param tool - BlockTool object
   */ key: "getTagsConfig",
            value: function getTagsConfig(e) {
                var _this = this;
                if (e.pasteConfig === !1) return;
                var t1 = e.pasteConfig.tags || [], o = [];
                t1.forEach(function(i) {
                    var _o;
                    var s = _this.collectTagNames(i);
                    (_o = o).push.apply(_o, (0, $aUGqu._)(s)), s.forEach(function(r) {
                        if (Object.prototype.hasOwnProperty.call(_this.toolsTags, r)) {
                            $5bdbe1ebf6713620$var$S("Paste handler for \xab".concat(e.name, "\xbb Tool on \xab").concat(r, "\xbb tag is skipped because it is already used by \xab").concat(_this.toolsTags[r].tool.name, "\xbb Tool."), "warn");
                            return;
                        }
                        var a = $5bdbe1ebf6713620$var$D(i) ? i[r] : null;
                        _this.toolsTags[r.toUpperCase()] = {
                            tool: e,
                            sanitizationConfig: a
                        };
                    });
                }), this.tagsByTool[e.name] = o.map(function(i) {
                    return i.toUpperCase();
                });
            }
        },
        {
            /**
   * Get files` types and extensions to substitute by Tool
   *
   * @param tool - BlockTool object
   */ key: "getFilesConfig",
            value: function getFilesConfig(e) {
                if (e.pasteConfig === !1) return;
                var _e_pasteConfig = e.pasteConfig, tmp = _e_pasteConfig.files, t1 = tmp === void 0 ? {} : tmp;
                var o = t1.extensions, i = t1.mimeTypes;
                !o && !i || (o && !Array.isArray(o) && ($5bdbe1ebf6713620$var$S("\xabextensions\xbb property of the onDrop config for \xab".concat(e.name, "\xbb Tool should be an array")), o = []), i && !Array.isArray(i) && ($5bdbe1ebf6713620$var$S("\xabmimeTypes\xbb property of the onDrop config for \xab".concat(e.name, "\xbb Tool should be an array")), i = []), i && (i = i.filter(function(s) {
                    return $5bdbe1ebf6713620$var$ei(s) ? !0 : ($5bdbe1ebf6713620$var$S("MIME type value \xab".concat(s, "\xbb for the \xab").concat(e.name, "\xbb Tool is not a valid MIME type"), "warn"), !1);
                })), this.toolsFiles[e.name] = {
                    extensions: o || [],
                    mimeTypes: i || []
                });
            }
        },
        {
            /**
   * Get RegExp patterns to substitute by Tool
   *
   * @param tool - BlockTool object
   */ key: "getPatternsConfig",
            value: function getPatternsConfig(e) {
                var _this = this;
                e.pasteConfig === !1 || !e.pasteConfig.patterns || $5bdbe1ebf6713620$var$V(e.pasteConfig.patterns) || Object.entries(e.pasteConfig.patterns).forEach(function(param) {
                    var _param = (0, $f9AOD._)(param, 2), t1 = _param[0], o = _param[1];
                    o instanceof RegExp || $5bdbe1ebf6713620$var$S("Pattern ".concat(o, " for \xab").concat(e.name, "\xbb Tool is skipped because it should be a Regexp instance."), "warn"), _this.toolsPatterns.push({
                        key: t1,
                        pattern: o,
                        tool: e
                    });
                });
            }
        },
        {
            /**
   * Check if browser behavior suits better
   *
   * @param {EventTarget} element - element where content has been pasted
   * @returns {boolean}
   */ key: "isNativeBehaviour",
            value: function isNativeBehaviour(e) {
                return $5bdbe1ebf6713620$var$u.isNativeInput(e);
            }
        },
        {
            key: "processFiles",
            value: /**
   * Get files from data transfer object and insert related Tools
   *
   * @param {FileList} items - pasted or dropped items
   */ function processFiles(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _this, _this_Editor, t1, o, s;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                _this_Editor = this.Editor, t1 = _this_Editor.BlockManager;
                                return [
                                    4,
                                    Promise.all(Array.from(e).map(function(r) {
                                        return _this.processFile(r);
                                    }))
                                ];
                            case 1:
                                o = _state.sent(), o = o.filter(function(r) {
                                    return !!r;
                                });
                                s = t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty;
                                o.forEach(function(r, a) {
                                    t1.paste(r.type, r.event, a === 0 && s);
                                });
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "processFile",
            value: /**
   * Get information about file and find Tool to handle it
   *
   * @param {File} file - file to process
   */ function processFile(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var t1, o, _o, i;
                    return (0, $13u2V._)(this, function(_state) {
                        t1 = $5bdbe1ebf6713620$var$Jn(e), o = Object.entries(this.toolsFiles).find(function(param) {
                            var _param = (0, $f9AOD._)(param, 2), r = _param[0], _param_ = _param[1], a = _param_.mimeTypes, l = _param_.extensions;
                            var _e_type_split = (0, $f9AOD._)(e.type.split("/"), 2), c = _e_type_split[0], d = _e_type_split[1], h = l.find(function(g) {
                                return g.toLowerCase() === t1.toLowerCase();
                            }), p = a.find(function(g) {
                                var _g_split = (0, $f9AOD._)(g.split("/"), 2), f = _g_split[0], v = _g_split[1];
                                return f === c && (v === d || v === "*");
                            });
                            return !!h || !!p;
                        });
                        if (!o) return [
                            2
                        ];
                        _o = (0, $f9AOD._)(o, 1), i = _o[0];
                        return [
                            2,
                            {
                                event: this.composePasteEvent("file", {
                                    file: e
                                }),
                                type: i
                            }
                        ];
                    });
                }).call(this);
            }
        },
        {
            /**
   * Split HTML string to blocks and return it as array of Block data
   *
   * @param {string} innerHTML - html string to process
   * @returns {PasteData[]}
   */ key: "processHTML",
            value: function processHTML(e) {
                var _this = this;
                var _this_Editor = this.Editor, t1 = _this_Editor.Tools, o = $5bdbe1ebf6713620$var$u.make("DIV");
                return o.innerHTML = e, this.getNodes(o).map(function(s) {
                    var r, a = t1.defaultTool, l = !1;
                    switch(s.nodeType){
                        case Node.DOCUMENT_FRAGMENT_NODE:
                            r = $5bdbe1ebf6713620$var$u.make("div"), r.appendChild(s);
                            break;
                        case Node.ELEMENT_NODE:
                            r = s, l = !0, _this.toolsTags[r.tagName] && (a = _this.toolsTags[r.tagName].tool);
                            break;
                    }
                    var _ref = a.pasteConfig || {
                        tags: []
                    }, c = _ref.tags, d = c.reduce(function(g, f) {
                        return _this.collectTagNames(f).forEach(function(O) {
                            var T = $5bdbe1ebf6713620$var$D(f) ? f[O] : null;
                            g[O.toLowerCase()] = T || {};
                        }), g;
                    }, {}), h = Object.assign({}, d, a.baseSanitizeConfig);
                    if (r.tagName.toLowerCase() === "table") {
                        var g = $5bdbe1ebf6713620$var$Z(r.outerHTML, h);
                        r = $5bdbe1ebf6713620$var$u.make("div", void 0, {
                            innerHTML: g
                        }).firstChild;
                    } else r.innerHTML = $5bdbe1ebf6713620$var$Z(r.innerHTML, h);
                    var p = _this.composePasteEvent("tag", {
                        data: r
                    });
                    return {
                        content: r,
                        isBlock: l,
                        tool: a.name,
                        event: p
                    };
                }).filter(function(s) {
                    var r = $5bdbe1ebf6713620$var$u.isEmpty(s.content), a = $5bdbe1ebf6713620$var$u.isSingleTag(s.content);
                    return !r || a;
                });
            }
        },
        {
            /**
   * Split plain text by new line symbols and return it as array of Block data
   *
   * @param {string} plain - string to process
   * @returns {PasteData[]}
   */ key: "processPlain",
            value: function processPlain(e) {
                var _this = this;
                var _this_config = this.config, t1 = _this_config.defaultBlock;
                if (!e) return [];
                var o = t1;
                return e.split(/\r?\n/).filter(function(i) {
                    return i.trim();
                }).map(function(i) {
                    var s = $5bdbe1ebf6713620$var$u.make("div");
                    s.textContent = i;
                    var r = _this.composePasteEvent("tag", {
                        data: s
                    });
                    return {
                        content: s,
                        tool: o,
                        isBlock: !1,
                        event: r
                    };
                });
            }
        },
        {
            key: "processSingleBlock",
            value: /**
   * Process paste of single Block tool content
   *
   * @param {PasteData} dataToInsert - data of Block to insert
   */ function processSingleBlock(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _this_Editor, t1, o, i;
                    return (0, $13u2V._)(this, function(_state) {
                        _this_Editor = this.Editor, t1 = _this_Editor.Caret, o = _this_Editor.BlockManager, i = o.currentBlock;
                        if (!i || e.tool !== i.name || !$5bdbe1ebf6713620$var$u.containsOnlyInlineElements(e.content.innerHTML)) {
                            this.insertBlock(e, (i == null ? void 0 : i.tool.isDefault) && i.isEmpty);
                            return [
                                2
                            ];
                        }
                        t1.insertContentAtCaretPosition(e.content.innerHTML);
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "processInlinePaste",
            value: /**
   * Process paste to single Block:
   * 1. Find patterns` matches
   * 2. Insert new block if it is not the same type as current one
   * 3. Just insert text if there is no substitutions
   *
   * @param {PasteData} dataToInsert - data of Block to insert
   */ function processInlinePaste(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _this_Editor, t1, o, i, r, a, l, r1;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.Caret, i = e.content;
                                if (!(t1.currentBlock && t1.currentBlock.tool.isDefault && i.textContent.length < Dn.PATTERN_PROCESSING_MAX_LENGTH)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.processPattern(i.textContent)
                                ];
                            case 1:
                                r = _state.sent();
                                if (r) {
                                    a = t1.currentBlock && t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty, l = t1.paste(r.tool, r.event, a);
                                    o.setToBlock(l, o.positions.END);
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 2;
                            case 2:
                                if (t1.currentBlock && t1.currentBlock.currentInput) {
                                    r1 = t1.currentBlock.tool.baseSanitizeConfig;
                                    document.execCommand("insertHTML", !1, $5bdbe1ebf6713620$var$Z(i.innerHTML, r1));
                                } else this.insertBlock(e);
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "processPattern",
            value: /**
   * Get patterns` matches
   *
   * @param {string} text - text to process
   * @returns {Promise<{event: PasteEvent, tool: string}>}
   */ function processPattern(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var t1;
                    return (0, $13u2V._)(this, function(_state) {
                        t1 = this.toolsPatterns.find(function(i) {
                            var s = i.pattern.exec(e);
                            return s ? e === s.shift() : !1;
                        });
                        return [
                            2,
                            t1 ? {
                                event: this.composePasteEvent("pattern", {
                                    key: t1.key,
                                    data: e
                                }),
                                tool: t1.tool.name
                            } : void 0
                        ];
                    });
                }).call(this);
            }
        },
        {
            /**
   * Insert pasted Block content to Editor
   *
   * @param {PasteData} data - data to insert
   * @param {boolean} canReplaceCurrentBlock - if true and is current Block is empty, will replace current Block
   * @returns {void}
   */ key: "insertBlock",
            value: function insertBlock(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                var _this_Editor = this.Editor, o = _this_Editor.BlockManager, i = _this_Editor.Caret, s = o.currentBlock;
                var r;
                if (t1 && s && s.isEmpty) {
                    r = o.paste(e.tool, e.event, !0), i.setToBlock(r, i.positions.END);
                    return;
                }
                r = o.paste(e.tool, e.event), i.setToBlock(r, i.positions.END);
            }
        },
        {
            /**
   * Insert data passed as application/x-editor-js JSON
   *
   * @param {Array} blocks — Blocks' data to insert
   * @returns {void}
   */ key: "insertEditorJSData",
            value: function insertEditorJSData(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.Caret, i = _this_Editor.Tools;
                $5bdbe1ebf6713620$var$yt(e, function(r) {
                    return i.blockTools.get(r).sanitizeConfig;
                }).forEach(function(param, l) {
                    var r = param.tool, a = param.data;
                    var c = !1;
                    l === 0 && (c = t1.currentBlock && t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty);
                    var d = t1.insert({
                        tool: r,
                        data: a,
                        replace: c
                    });
                    o.setToBlock(d, o.positions.END);
                });
            }
        },
        {
            /**
   * Fetch nodes from Element node
   *
   * @param {Node} node - current node
   * @param {Node[]} nodes - processed nodes
   * @param {Node} destNode - destination node
   */ key: "processElementNode",
            value: function processElementNode(e, t1, o) {
                var i = Object.keys(this.toolsTags), s = e, _ref = this.toolsTags[s.tagName] || {}, r = _ref.tool, a = this.tagsByTool[r == null ? void 0 : r.name] || [], l = i.includes(s.tagName), c = $5bdbe1ebf6713620$var$u.blockElements.includes(s.tagName.toLowerCase()), d = Array.from(s.children).some(function(param) {
                    var p = param.tagName;
                    return i.includes(p) && !a.includes(p);
                }), h = Array.from(s.children).some(function(param) {
                    var p = param.tagName;
                    return $5bdbe1ebf6713620$var$u.blockElements.includes(p.toLowerCase());
                });
                if (!c && !l && !d) return o.appendChild(s), (0, $aUGqu._)(t1).concat([
                    o
                ]);
                if (l && !d || c && !h && !d) return (0, $aUGqu._)(t1).concat([
                    o,
                    s
                ]);
            }
        },
        {
            /**
   * Recursively divide HTML string to two types of nodes:
   * 1. Block element
   * 2. Document Fragments contained text and markup tags like a, b, i etc.
   *
   * @param {Node} wrapper - wrapper of paster HTML content
   * @returns {Node[]}
   */ key: "getNodes",
            value: function getNodes(e) {
                var _this = this;
                var t1 = Array.from(e.childNodes);
                var o;
                var i = function(s, r) {
                    if ($5bdbe1ebf6713620$var$u.isEmpty(r) && !$5bdbe1ebf6713620$var$u.isSingleTag(r)) return s;
                    var a = s[s.length - 1];
                    var l = new DocumentFragment();
                    switch(a && $5bdbe1ebf6713620$var$u.isFragment(a) && (l = s.pop()), r.nodeType){
                        case Node.ELEMENT_NODE:
                            if (o = _this.processElementNode(r, s, l), o) return o;
                            break;
                        case Node.TEXT_NODE:
                            return l.appendChild(r), (0, $aUGqu._)(s).concat([
                                l
                            ]);
                        default:
                            return (0, $aUGqu._)(s).concat([
                                l
                            ]);
                    }
                    return (0, $aUGqu._)(s).concat((0, $aUGqu._)(Array.from(r.childNodes).reduce(i, [])));
                };
                return t1.reduce(i, []);
            }
        },
        {
            /**
   * Compose paste event with passed type and detail
   *
   * @param {string} type - event type
   * @param {PasteEventDetail} detail - event detail
   */ key: "composePasteEvent",
            value: function composePasteEvent(e, t1) {
                return new CustomEvent(e, {
                    detail: t1
                });
            }
        }
    ]);
    return Dn;
}($5bdbe1ebf6713620$var$E);
$5bdbe1ebf6713620$var$Rn.PATTERN_PROCESSING_MAX_LENGTH = 450;
var $5bdbe1ebf6713620$var$pa = $5bdbe1ebf6713620$var$Rn;
var $5bdbe1ebf6713620$var$fa = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(fa, E);
    function fa() {
        (0, $173N4._)(this, fa);
        var _this;
        _this = (0, $7qXGD._)(this, fa, arguments), _this.toolsDontSupportReadOnly = [], _this.readOnlyEnabled = !1;
        return _this;
    }
    (0, $cFHGC._)(fa, [
        {
            key: "isEnabled",
            get: /**
   * Returns state of read only mode
   */ function get() {
                return this.readOnlyEnabled;
            }
        },
        {
            key: "prepare",
            value: /**
   * Set initial state
   */ function prepare() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _this_Editor, e, t1, o;
                    return (0, $13u2V._)(this, function(_state) {
                        _this_Editor = this.Editor, e = _this_Editor.Tools, t1 = e.blockTools, o = [];
                        Array.from(t1.entries()).forEach(function(param) {
                            var _param = (0, $f9AOD._)(param, 2), i = _param[0], s = _param[1];
                            s.isReadOnlySupported || o.push(i);
                        }), this.toolsDontSupportReadOnly = o, this.config.readOnly && o.length > 0 && this.throwCriticalError(), this.toggle(this.config.readOnly, !0);
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "toggle",
            value: /**
   * Set read-only mode or toggle current state
   * Call all Modules `toggleReadOnly` method and re-render Editor
   *
   * @param state - (optional) read-only state or toggle
   * @param isInitial - (optional) true when editor is initializing
   */ function toggle() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var e, t1, o, s, i;
                    var _arguments = arguments;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : !this.readOnlyEnabled, t1 = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : !1;
                                e && this.toolsDontSupportReadOnly.length > 0 && this.throwCriticalError();
                                o = this.readOnlyEnabled;
                                this.readOnlyEnabled = e;
                                for(var s in this.Editor)this.Editor[s].toggleReadOnly && this.Editor[s].toggleReadOnly(e);
                                if (o === e) return [
                                    2,
                                    this.readOnlyEnabled
                                ];
                                if (t1) return [
                                    2,
                                    this.readOnlyEnabled
                                ];
                                this.Editor.ModificationsObserver.disable();
                                return [
                                    4,
                                    this.Editor.Saver.save()
                                ];
                            case 1:
                                i = _state.sent();
                                return [
                                    4,
                                    this.Editor.BlockManager.clear()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    this.Editor.Renderer.render(i.blocks)
                                ];
                            case 3:
                                return [
                                    2,
                                    (_state.sent(), this.Editor.ModificationsObserver.enable(), this.readOnlyEnabled)
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            /**
   * Throws an error about tools which don't support read-only mode
   */ key: "throwCriticalError",
            value: function throwCriticalError() {
                throw new $5bdbe1ebf6713620$var$Ho("To enable read-only mode all connected tools should support it. Tools ".concat(this.toolsDontSupportReadOnly.join(", "), " don't support read-only mode."));
            }
        }
    ]);
    return fa;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$Be = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(Be, E);
    function Be() {
        (0, $173N4._)(this, Be);
        var _this;
        _this = (0, $7qXGD._)(this, Be, arguments), _this.isRectSelectionActivated = !1, _this.SCROLL_SPEED = 3, _this.HEIGHT_OF_SCROLL_ZONE = 40, _this.BOTTOM_SCROLL_ZONE = 1, _this.TOP_SCROLL_ZONE = 2, _this.MAIN_MOUSE_BUTTON = 0, _this.mousedown = !1, _this.isScrolling = !1, _this.inScrollZone = null, _this.startX = 0, _this.startY = 0, _this.mouseX = 0, _this.mouseY = 0, _this.stackOfSelected = [], _this.listenerIds = [];
        return _this;
    }
    (0, $cFHGC._)(Be, [
        {
            /**
   * Module Preparation
   * Creating rect and hang handlers
   */ key: "prepare",
            value: function prepare() {
                this.enableModuleBindings();
            }
        },
        {
            /**
   * Init rect params
   *
   * @param {number} pageX - X coord of mouse
   * @param {number} pageY - Y coord of mouse
   */ key: "startSelection",
            value: function startSelection(e, t1) {
                var o = document.elementFromPoint(e - window.pageXOffset, t1 - window.pageYOffset);
                o.closest(".".concat(this.Editor.Toolbar.CSS.toolbar)) || (this.Editor.BlockSelection.allBlocksSelected = !1, this.clearSelection(), this.stackOfSelected = []);
                var s = [
                    ".".concat($5bdbe1ebf6713620$var$R.CSS.content),
                    ".".concat(this.Editor.Toolbar.CSS.toolbar),
                    ".".concat(this.Editor.InlineToolbar.CSS.inlineToolbar)
                ], r = o.closest("." + this.Editor.UI.CSS.editorWrapper), a = s.some(function(l) {
                    return !!o.closest(l);
                });
                !r || a || (this.mousedown = !0, this.startX = e, this.startY = t1);
            }
        },
        {
            /**
   * Clear all params to end selection
   */ key: "endSelection",
            value: function endSelection() {
                this.mousedown = !1, this.startX = 0, this.startY = 0, this.overlayRectangle.style.display = "none";
            }
        },
        {
            /**
   * is RectSelection Activated
   */ key: "isRectActivated",
            value: function isRectActivated() {
                return this.isRectSelectionActivated;
            }
        },
        {
            /**
   * Mark that selection is end
   */ key: "clearSelection",
            value: function clearSelection() {
                this.isRectSelectionActivated = !1;
            }
        },
        {
            /**
   * Sets Module necessary event handlers
   */ key: "enableModuleBindings",
            value: function enableModuleBindings() {
                var _this = this;
                var _this_genHTML = this.genHTML(), e = _this_genHTML.container;
                this.listeners.on(e, "mousedown", function(t1) {
                    _this.processMouseDown(t1);
                }, !1), this.listeners.on(document.body, "mousemove", $5bdbe1ebf6713620$var$dt(function(t1) {
                    _this.processMouseMove(t1);
                }, 10), {
                    passive: !0
                }), this.listeners.on(document.body, "mouseleave", function() {
                    _this.processMouseLeave();
                }), this.listeners.on(window, "scroll", $5bdbe1ebf6713620$var$dt(function(t1) {
                    _this.processScroll(t1);
                }, 10), {
                    passive: !0
                }), this.listeners.on(document.body, "mouseup", function() {
                    _this.processMouseUp();
                }, !1);
            }
        },
        {
            /**
   * Handle mouse down events
   *
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ key: "processMouseDown",
            value: function processMouseDown(e) {
                if (e.button !== this.MAIN_MOUSE_BUTTON) return;
                e.target.closest($5bdbe1ebf6713620$var$u.allInputsSelector) !== null || this.startSelection(e.pageX, e.pageY);
            }
        },
        {
            /**
   * Handle mouse move events
   *
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ key: "processMouseMove",
            value: function processMouseMove(e) {
                this.changingRectangle(e), this.scrollByZones(e.clientY);
            }
        },
        {
            /**
   * Handle mouse leave
   */ key: "processMouseLeave",
            value: function processMouseLeave() {
                this.clearSelection(), this.endSelection();
            }
        },
        {
            /**
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ key: "processScroll",
            value: function processScroll(e) {
                this.changingRectangle(e);
            }
        },
        {
            /**
   * Handle mouse up
   */ key: "processMouseUp",
            value: function processMouseUp() {
                this.clearSelection(), this.endSelection();
            }
        },
        {
            /**
   * Scroll If mouse in scroll zone
   *
   * @param {number} clientY - Y coord of mouse
   */ key: "scrollByZones",
            value: function scrollByZones(e) {
                if (this.inScrollZone = null, e <= this.HEIGHT_OF_SCROLL_ZONE && (this.inScrollZone = this.TOP_SCROLL_ZONE), document.documentElement.clientHeight - e <= this.HEIGHT_OF_SCROLL_ZONE && (this.inScrollZone = this.BOTTOM_SCROLL_ZONE), !this.inScrollZone) {
                    this.isScrolling = !1;
                    return;
                }
                this.isScrolling || (this.scrollVertical(this.inScrollZone === this.TOP_SCROLL_ZONE ? -this.SCROLL_SPEED : this.SCROLL_SPEED), this.isScrolling = !0);
            }
        },
        {
            /**
   * Generates required HTML elements
   *
   * @returns {Object<string, Element>}
   */ key: "genHTML",
            value: function genHTML() {
                var _this_Editor = this.Editor, e = _this_Editor.UI, t1 = e.nodes.holder.querySelector("." + e.CSS.editorWrapper), o = $5bdbe1ebf6713620$var$u.make("div", Be.CSS.overlay, {}), i = $5bdbe1ebf6713620$var$u.make("div", Be.CSS.overlayContainer, {}), s = $5bdbe1ebf6713620$var$u.make("div", Be.CSS.rect, {});
                return i.appendChild(s), o.appendChild(i), t1.appendChild(o), this.overlayRectangle = s, {
                    container: t1,
                    overlay: o
                };
            }
        },
        {
            /**
   * Activates scrolling if blockSelection is active and mouse is in scroll zone
   *
   * @param {number} speed - speed of scrolling
   */ key: "scrollVertical",
            value: function scrollVertical(e) {
                var _this = this;
                if (!(this.inScrollZone && this.mousedown)) return;
                var t1 = window.pageYOffset;
                window.scrollBy(0, e), this.mouseY += window.pageYOffset - t1, setTimeout(function() {
                    _this.scrollVertical(e);
                }, 0);
            }
        },
        {
            /**
   * Handles the change in the rectangle and its effect
   *
   * @param {MouseEvent} event - mouse event
   */ key: "changingRectangle",
            value: function changingRectangle(e) {
                if (!this.mousedown) return;
                e.pageY !== void 0 && (this.mouseX = e.pageX, this.mouseY = e.pageY);
                var _this_genInfoForMouseSelection = this.genInfoForMouseSelection(), t1 = _this_genInfoForMouseSelection.rightPos, o = _this_genInfoForMouseSelection.leftPos, i = _this_genInfoForMouseSelection.index, s = this.startX > t1 && this.mouseX > t1, r = this.startX < o && this.mouseX < o;
                this.rectCrossesBlocks = !(s || r), this.isRectSelectionActivated || (this.rectCrossesBlocks = !1, this.isRectSelectionActivated = !0, this.shrinkRectangleToPoint(), this.overlayRectangle.style.display = "block"), this.updateRectangleSize(), this.Editor.Toolbar.close(), i !== void 0 && (this.trySelectNextBlock(i), this.inverseSelection(), $5bdbe1ebf6713620$var$b.get().removeAllRanges());
            }
        },
        {
            /**
   * Shrink rect to singular point
   */ key: "shrinkRectangleToPoint",
            value: function shrinkRectangleToPoint() {
                this.overlayRectangle.style.left = "".concat(this.startX - window.pageXOffset, "px"), this.overlayRectangle.style.top = "".concat(this.startY - window.pageYOffset, "px"), this.overlayRectangle.style.bottom = "calc(100% - ".concat(this.startY - window.pageYOffset, "px"), this.overlayRectangle.style.right = "calc(100% - ".concat(this.startX - window.pageXOffset, "px");
            }
        },
        {
            /**
   * Select or unselect all of blocks in array if rect is out or in selectable area
   */ key: "inverseSelection",
            value: function inverseSelection() {
                var t1 = this.Editor.BlockManager.getBlockByIndex(this.stackOfSelected[0]).selected;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (this.rectCrossesBlocks && !t1) try {
                    for(var _iterator = this.stackOfSelected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var o = _step.value;
                        this.Editor.BlockSelection.selectBlockByIndex(o);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                if (!this.rectCrossesBlocks && t1) try {
                    for(var _iterator1 = this.stackOfSelected[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var o1 = _step1.value;
                        this.Editor.BlockSelection.unSelectBlockByIndex(o1);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            /**
   * Updates size of rectangle
   */ key: "updateRectangleSize",
            value: function updateRectangleSize() {
                this.mouseY >= this.startY ? (this.overlayRectangle.style.top = "".concat(this.startY - window.pageYOffset, "px"), this.overlayRectangle.style.bottom = "calc(100% - ".concat(this.mouseY - window.pageYOffset, "px")) : (this.overlayRectangle.style.bottom = "calc(100% - ".concat(this.startY - window.pageYOffset, "px"), this.overlayRectangle.style.top = "".concat(this.mouseY - window.pageYOffset, "px")), this.mouseX >= this.startX ? (this.overlayRectangle.style.left = "".concat(this.startX - window.pageXOffset, "px"), this.overlayRectangle.style.right = "calc(100% - ".concat(this.mouseX - window.pageXOffset, "px")) : (this.overlayRectangle.style.right = "calc(100% - ".concat(this.startX - window.pageXOffset, "px"), this.overlayRectangle.style.left = "".concat(this.mouseX - window.pageXOffset, "px"));
            }
        },
        {
            /**
   * Collects information needed to determine the behavior of the rectangle
   *
   * @returns {object} index - index next Block, leftPos - start of left border of Block, rightPos - right border
   */ key: "genInfoForMouseSelection",
            value: function genInfoForMouseSelection() {
                var t1 = document.body.offsetWidth / 2, o = this.mouseY - window.pageYOffset, i = document.elementFromPoint(t1, o), s = this.Editor.BlockManager.getBlockByChildNode(i);
                var r;
                s !== void 0 && (r = this.Editor.BlockManager.blocks.findIndex(function(h) {
                    return h.holder === s.holder;
                }));
                var a = this.Editor.BlockManager.lastBlock.holder.querySelector("." + $5bdbe1ebf6713620$var$R.CSS.content), l = Number.parseInt(window.getComputedStyle(a).width, 10) / 2, c = t1 - l, d = t1 + l;
                return {
                    index: r,
                    leftPos: c,
                    rightPos: d
                };
            }
        },
        {
            /**
   * Select block with index index
   *
   * @param index - index of block in redactor
   */ key: "addBlockInSelection",
            value: function addBlockInSelection(e) {
                this.rectCrossesBlocks && this.Editor.BlockSelection.selectBlockByIndex(e), this.stackOfSelected.push(e);
            }
        },
        {
            /**
   * Adds a block to the selection and determines which blocks should be selected
   *
   * @param {object} index - index of new block in the reactor
   */ key: "trySelectNextBlock",
            value: function trySelectNextBlock(e) {
                var _this = this;
                var t1 = this.stackOfSelected[this.stackOfSelected.length - 1] === e, o = this.stackOfSelected.length, i = 1, s = -1, r = 0;
                if (t1) return;
                var a = this.stackOfSelected[o - 1] - this.stackOfSelected[o - 2] > 0;
                var l = r;
                o > 1 && (l = a ? i : s);
                var c = e > this.stackOfSelected[o - 1] && l === i, d = e < this.stackOfSelected[o - 1] && l === s, p = !(c || d || l === r);
                if (!p && (e > this.stackOfSelected[o - 1] || this.stackOfSelected[o - 1] === void 0)) {
                    var v = this.stackOfSelected[o - 1] + 1 || e;
                    for(v; v <= e; v++)this.addBlockInSelection(v);
                    return;
                }
                if (!p && e < this.stackOfSelected[o - 1]) {
                    for(var v1 = this.stackOfSelected[o - 1] - 1; v1 >= e; v1--)this.addBlockInSelection(v1);
                    return;
                }
                if (!p) return;
                var g = o - 1, f;
                for(e > this.stackOfSelected[o - 1] ? f = function() {
                    return e > _this.stackOfSelected[g];
                } : f = function() {
                    return e < _this.stackOfSelected[g];
                }; f();)this.rectCrossesBlocks && this.Editor.BlockSelection.unSelectBlockByIndex(this.stackOfSelected[g]), this.stackOfSelected.pop(), g--;
            }
        }
    ], [
        {
            key: "CSS",
            get: /**
   * CSS classes for the Block
   *
   * @returns {{wrapper: string, content: string}}
   */ function get() {
                return {
                    overlay: "codex-editor-overlay",
                    overlayContainer: "codex-editor-overlay__container",
                    rect: "codex-editor-overlay__rectangle",
                    topScrollZone: "codex-editor-overlay__scroll-zone--top",
                    bottomScrollZone: "codex-editor-overlay__scroll-zone--bottom"
                };
            }
        }
    ]);
    return Be;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$ga = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(ga, E);
    function ga() {
        (0, $173N4._)(this, ga);
        return (0, $7qXGD._)(this, ga, arguments);
    }
    (0, $cFHGC._)(ga, [
        {
            key: "render",
            value: /**
   * Renders passed blocks as one batch
   *
   * @param blocksData - blocks to render
   */ function render(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _this;
                    return (0, $13u2V._)(this, function(_state) {
                        _this = this;
                        return [
                            2,
                            new Promise(function(t1) {
                                var _this_Editor = _this.Editor, o = _this_Editor.Tools, i = _this_Editor.BlockManager;
                                if (e.length === 0) i.insert();
                                else {
                                    var s = e.map(function(param) {
                                        var r = param.type, a = param.data, l = param.tunes, c = param.id;
                                        o.available.has(r) === !1 && ($5bdbe1ebf6713620$var$X("Tool \xab".concat(r, "\xbb is not found. Check 'tools' property at the Editor.js config."), "warn"), a = _this.composeStubDataForTool(r, a, c), r = o.stubTool);
                                        var d;
                                        try {
                                            d = i.composeBlock({
                                                id: c,
                                                tool: r,
                                                data: a,
                                                tunes: l
                                            });
                                        } catch (h) {
                                            $5bdbe1ebf6713620$var$S("Block \xab".concat(r, "\xbb skipped because of plugins error"), "error", {
                                                data: a,
                                                error: h
                                            }), a = _this.composeStubDataForTool(r, a, c), r = o.stubTool, d = i.composeBlock({
                                                id: c,
                                                tool: r,
                                                data: a,
                                                tunes: l
                                            });
                                        }
                                        return d;
                                    });
                                    i.insertMany(s);
                                }
                                window.requestIdleCallback(function() {
                                    t1();
                                }, {
                                    timeout: 2e3
                                });
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            /**
   * Create data for the Stub Tool that will be used instead of unavailable tool
   *
   * @param tool - unavailable tool name to stub
   * @param data - data of unavailable block
   * @param [id] - id of unavailable block
   */ key: "composeStubDataForTool",
            value: function composeStubDataForTool(e, t1, o) {
                var _this_Editor = this.Editor, i = _this_Editor.Tools;
                var s = e;
                if (i.unavailable.has(e)) {
                    var r = i.unavailable.get(e).toolbox;
                    r !== void 0 && r[0].title !== void 0 && (s = r[0].title);
                }
                return {
                    savedData: {
                        id: o,
                        type: e,
                        data: t1
                    },
                    title: s
                };
            }
        }
    ]);
    return ga;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$ma = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(ma, E);
    function ma() {
        (0, $173N4._)(this, ma);
        return (0, $7qXGD._)(this, ma, arguments);
    }
    (0, $cFHGC._)(ma, [
        {
            key: "save",
            value: /**
   * Composes new chain of Promises to fire them alternatelly
   *
   * @returns {OutputData}
   */ function save() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _this, _this_Editor, e, t1, o, i, _$s, r, s;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                _this_Editor = this.Editor, e = _this_Editor.BlockManager, t1 = _this_Editor.Tools, o = e.blocks, i = [];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                o.forEach(function(a) {
                                    i.push(_this.getSavedData(a));
                                });
                                return [
                                    4,
                                    Promise.all(i)
                                ];
                            case 2:
                                _$s = _state.sent();
                                return [
                                    4,
                                    $5bdbe1ebf6713620$var$yt(_$s, function(a) {
                                        return t1.blockTools.get(a).sanitizeConfig;
                                    })
                                ];
                            case 3:
                                r = _state.sent();
                                return [
                                    2,
                                    this.makeOutput(r)
                                ];
                            case 4:
                                s = _state.sent();
                                $5bdbe1ebf6713620$var$X("Saving failed due to the Error %o", "error", s);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getSavedData",
            value: /**
   * Saves and validates
   *
   * @param {Block} block - Editor's Tool
   * @returns {ValidatedData} - Tool's validated data
   */ function getSavedData(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var t1, o, _tmp;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    e.save()
                                ];
                            case 1:
                                t1 = _state.sent();
                                _tmp = t1;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    e.validate(t1.data)
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                o = _tmp;
                                return [
                                    2,
                                    (0, $6fpqi._)((0, $1XAnY._)({}, t1), {
                                        isValid: o
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * Creates output object with saved data, time and version of editor
   *
   * @param {ValidatedData} allExtractedData - data extracted from Blocks
   * @returns {OutputData}
   */ key: "makeOutput",
            value: function makeOutput(e) {
                var _this = this;
                var t1 = [];
                return e.forEach(function(param) {
                    var o = param.id, i = param.tool, s = param.data, r = param.tunes, a = param.isValid;
                    if (!a) {
                        $5bdbe1ebf6713620$var$S("Block \xab".concat(i, "\xbb skipped because saved data is invalid"));
                        return;
                    }
                    if (i === _this.Editor.Tools.stubTool) {
                        t1.push(s);
                        return;
                    }
                    var l = (0, $1XAnY._)({
                        id: o,
                        type: i,
                        data: s
                    }, !$5bdbe1ebf6713620$var$V(r) && {
                        tunes: r
                    });
                    t1.push(l);
                }), {
                    time: +/* @__PURE__ */ new Date(),
                    blocks: t1,
                    version: "2.31.6"
                };
            }
        }
    ]);
    return ma;
}($5bdbe1ebf6713620$var$E);
(function() {
    try {
        if ((typeof document === "undefined" ? "undefined" : (0, $7E0eS._)(document)) < "u") {
            var n = document.createElement("style");
            n.appendChild(document.createTextNode(".ce-paragraph{line-height:1.6em;outline:none}.ce-block:only-of-type .ce-paragraph[data-placeholder-active]:empty:before,.ce-block:only-of-type .ce-paragraph[data-placeholder-active][data-empty=true]:before{content:attr(data-placeholder-active)}.ce-paragraph p:first-of-type{margin-top:0}.ce-paragraph p:last-of-type{margin-bottom:0}")), document.head.appendChild(n);
        }
    } catch (e) {
        console.error("vite-plugin-css-injected-by-js", e);
    }
})();
var $5bdbe1ebf6713620$var$ba = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 9V7.2C8 7.08954 8.08954 7 8.2 7L12 7M16 9V7.2C16 7.08954 15.9105 7 15.8 7L12 7M12 7L12 17M12 17H10M12 17H14"/></svg>';
function $5bdbe1ebf6713620$var$va(n) {
    var _t;
    var e = document.createElement("div");
    e.innerHTML = n.trim();
    var t1 = document.createDocumentFragment();
    return (_t = t1).append.apply(_t, (0, $aUGqu._)(Array.from(e.childNodes))), t1;
}
/**
 * Base Paragraph Block for the Editor.js.
 * Represents a regular text block
 *
 * @author CodeX (team@codex.so)
 * @copyright CodeX 2018
 * @license The MIT License (MIT)
 */ var $5bdbe1ebf6713620$var$fo = /*#__PURE__*/ function() {
    "use strict";
    function fo(param) {
        var e = param.data, t1 = param.config, o = param.api, i = param.readOnly;
        (0, $173N4._)(this, fo);
        var _t_preserveBlank;
        this.api = o, this.readOnly = i, this._CSS = {
            block: this.api.styles.block,
            wrapper: "ce-paragraph"
        }, this.readOnly || (this.onKeyUp = this.onKeyUp.bind(this)), this._placeholder = t1.placeholder ? t1.placeholder : fo.DEFAULT_PLACEHOLDER, this._data = e !== null && e !== void 0 ? e : {}, this._element = null, this._preserveBlank = (_t_preserveBlank = t1.preserveBlank) !== null && _t_preserveBlank !== void 0 ? _t_preserveBlank : !1;
    }
    (0, $cFHGC._)(fo, [
        {
            /**
   * Check if text content is empty and set empty string to inner html.
   * We need this because some browsers (e.g. Safari) insert <br> into empty contenteditanle elements
   *
   * @param {KeyboardEvent} e - key up event
   */ key: "onKeyUp",
            value: function onKeyUp(e) {
                if (e.code !== "Backspace" && e.code !== "Delete" || !this._element) return;
                var _this__element = this._element, t1 = _this__element.textContent;
                t1 === "" && (this._element.innerHTML = "");
            }
        },
        {
            /**
   * Create Tool's view
   *
   * @returns {HTMLDivElement}
   * @private
   */ key: "drawView",
            value: function drawView() {
                var e = document.createElement("DIV");
                return e.classList.add(this._CSS.wrapper, this._CSS.block), e.contentEditable = "false", e.dataset.placeholderActive = this.api.i18n.t(this._placeholder), this._data.text && (e.innerHTML = this._data.text), this.readOnly || (e.contentEditable = "true", e.addEventListener("keyup", this.onKeyUp)), e;
            }
        },
        {
            /**
   * Return Tool's view
   *
   * @returns {HTMLDivElement}
   */ key: "render",
            value: function render() {
                return this._element = this.drawView(), this._element;
            }
        },
        {
            /**
   * Method that specified how to merge two Text blocks.
   * Called by Editor.js by backspace at the beginning of the Block
   *
   * @param {ParagraphData} data
   * @public
   */ key: "merge",
            value: function merge(e) {
                if (!this._element) return;
                this._data.text += e.text;
                var t1 = $5bdbe1ebf6713620$var$va(e.text);
                this._element.appendChild(t1), this._element.normalize();
            }
        },
        {
            /**
   * Validate Paragraph block data:
   * - check for emptiness
   *
   * @param {ParagraphData} savedData — data received after saving
   * @returns {boolean} false if saved data is not correct, otherwise true
   * @public
   */ key: "validate",
            value: function validate(e) {
                return !(e.text.trim() === "" && !this._preserveBlank);
            }
        },
        {
            /**
   * Extract Tool's data from the view
   *
   * @param {HTMLDivElement} toolsContent - Paragraph tools rendered view
   * @returns {ParagraphData} - saved data
   * @public
   */ key: "save",
            value: function save(e) {
                return {
                    text: e.innerHTML
                };
            }
        },
        {
            /**
   * On paste callback fired from Editor.
   *
   * @param {HTMLPasteEvent} event - event with pasted data
   */ key: "onPaste",
            value: function onPaste(e) {
                var _this = this;
                var t1 = {
                    text: e.detail.data.innerHTML
                };
                this._data = t1, window.requestAnimationFrame(function() {
                    _this._element && (_this._element.innerHTML = _this._data.text || "");
                });
            }
        }
    ], [
        {
            key: "DEFAULT_PLACEHOLDER",
            get: /**
   * Default placeholder for Paragraph Tool
   *
   * @returns {string}
   * @class
   */ function get() {
                return "";
            }
        },
        {
            key: "conversionConfig",
            get: /**
   * Enable Conversion Toolbar. Paragraph can be converted to/from other tools
   * @returns {ConversionConfig}
   */ function get() {
                return {
                    export: "text",
                    // to convert Paragraph to other block, use 'text' property of saved data
                    import: "text"
                };
            }
        },
        {
            key: "sanitize",
            get: /**
   * Sanitizer rules
   * @returns {SanitizerConfig} - Edtior.js sanitizer config
   */ function get() {
                return {
                    text: {
                        br: !0
                    }
                };
            }
        },
        {
            key: "isReadOnlySupported",
            get: /**
   * Returns true to notify the core that read-only mode is supported
   *
   * @returns {boolean}
   */ function get() {
                return !0;
            }
        },
        {
            key: "pasteConfig",
            get: /**
   * Used by Editor paste handling API.
   * Provides configuration to handle P tags.
   *
   * @returns {PasteConfig} - Paragraph Paste Setting
   */ function get() {
                return {
                    tags: [
                        "P"
                    ]
                };
            }
        },
        {
            key: "toolbox",
            get: /**
   * Icon and title for displaying at the Toolbox
   *
   * @returns {ToolboxConfig} - Paragraph Toolbox Setting
   */ function get() {
                return {
                    icon: $5bdbe1ebf6713620$var$ba,
                    title: "Text"
                };
            }
        }
    ]);
    return fo;
}();
var $5bdbe1ebf6713620$var$go = /*#__PURE__*/ function() {
    "use strict";
    function go() {
        (0, $173N4._)(this, go);
        this.commandName = "bold";
    }
    (0, $cFHGC._)(go, [
        {
            /**
   * Create button for Inline Toolbar
   */ key: "render",
            value: function render() {
                var _this = this;
                return {
                    icon: $5bdbe1ebf6713620$var$Ki,
                    name: "bold",
                    onActivate: function() {
                        document.execCommand(_this.commandName);
                    },
                    isActive: function() {
                        return document.queryCommandState(_this.commandName);
                    }
                };
            }
        },
        {
            key: "shortcut",
            get: /**
   * Set a shortcut
   *
   * @returns {boolean}
   */ function get() {
                return "CMD+B";
            }
        }
    ], [
        {
            key: "sanitize",
            get: /**
   * Sanitizer Rule
   * Leave <b> tags
   *
   * @returns {object}
   */ function get() {
                return {
                    b: {}
                };
            }
        }
    ]);
    return go;
}();
$5bdbe1ebf6713620$var$go.isInline = !0;
$5bdbe1ebf6713620$var$go.title = "Bold";
var $5bdbe1ebf6713620$var$mo = /*#__PURE__*/ function() {
    "use strict";
    function mo() {
        (0, $173N4._)(this, mo);
        this.commandName = "italic", this.CSS = {
            button: "ce-inline-tool",
            buttonActive: "ce-inline-tool--active",
            buttonModifier: "ce-inline-tool--italic"
        }, this.nodes = {
            button: null
        };
    }
    (0, $cFHGC._)(mo, [
        {
            /**
   * Create button for Inline Toolbar
   */ key: "render",
            value: function render() {
                return this.nodes.button = document.createElement("button"), this.nodes.button.type = "button", this.nodes.button.classList.add(this.CSS.button, this.CSS.buttonModifier), this.nodes.button.innerHTML = $5bdbe1ebf6713620$var$Ji, this.nodes.button;
            }
        },
        {
            /**
   * Wrap range with <i> tag
   */ key: "surround",
            value: function surround() {
                document.execCommand(this.commandName);
            }
        },
        {
            /**
   * Check selection and set activated state to button if there are <i> tag
   */ key: "checkState",
            value: function checkState() {
                var e = document.queryCommandState(this.commandName);
                return this.nodes.button.classList.toggle(this.CSS.buttonActive, e), e;
            }
        },
        {
            key: "shortcut",
            get: /**
   * Set a shortcut
   */ function get() {
                return "CMD+I";
            }
        }
    ], [
        {
            key: "sanitize",
            get: /**
   * Sanitizer Rule
   * Leave <i> tags
   *
   * @returns {object}
   */ function get() {
                return {
                    i: {}
                };
            }
        }
    ]);
    return mo;
}();
$5bdbe1ebf6713620$var$mo.isInline = !0;
$5bdbe1ebf6713620$var$mo.title = "Italic";
var $5bdbe1ebf6713620$var$bo = /*#__PURE__*/ function() {
    "use strict";
    function bo(param) {
        var e = param.api;
        (0, $173N4._)(this, bo);
        this.commandLink = "createLink", this.commandUnlink = "unlink", this.ENTER_KEY = 13, this.CSS = {
            button: "ce-inline-tool",
            buttonActive: "ce-inline-tool--active",
            buttonModifier: "ce-inline-tool--link",
            buttonUnlink: "ce-inline-tool--unlink",
            input: "ce-inline-tool-input",
            inputShowed: "ce-inline-tool-input--showed"
        }, this.nodes = {
            button: null,
            input: null
        }, this.inputOpened = !1, this.toolbar = e.toolbar, this.inlineToolbar = e.inlineToolbar, this.notifier = e.notifier, this.i18n = e.i18n, this.selection = new $5bdbe1ebf6713620$var$b();
    }
    (0, $cFHGC._)(bo, [
        {
            /**
   * Create button for Inline Toolbar
   */ key: "render",
            value: function render() {
                return this.nodes.button = document.createElement("button"), this.nodes.button.type = "button", this.nodes.button.classList.add(this.CSS.button, this.CSS.buttonModifier), this.nodes.button.innerHTML = $5bdbe1ebf6713620$var$Co, this.nodes.button;
            }
        },
        {
            /**
   * Input for the link
   */ key: "renderActions",
            value: function renderActions() {
                var _this = this;
                return this.nodes.input = document.createElement("input"), this.nodes.input.placeholder = this.i18n.t("Add a link"), this.nodes.input.enterKeyHint = "done", this.nodes.input.classList.add(this.CSS.input), this.nodes.input.addEventListener("keydown", function(e) {
                    e.keyCode === _this.ENTER_KEY && _this.enterPressed(e);
                }), this.nodes.input;
            }
        },
        {
            /**
   * Handle clicks on the Inline Toolbar icon
   *
   * @param {Range} range - range to wrap with link
   */ key: "surround",
            value: function surround(e) {
                if (e) {
                    this.inputOpened ? (this.selection.restore(), this.selection.removeFakeBackground()) : (this.selection.setFakeBackground(), this.selection.save());
                    var t1 = this.selection.findParentTag("A");
                    if (t1) {
                        this.inputOpened ? (this.closeActions(!1), this.checkState()) : (this.selection.expandToTag(t1), this.unlink(), this.closeActions(), this.checkState(), this.toolbar.close());
                        return;
                    }
                }
                this.toggleActions();
            }
        },
        {
            /**
   * Check selection and set activated state to button if there are <a> tag
   */ key: "checkState",
            value: function checkState() {
                var e = this.selection.findParentTag("A");
                if (e) {
                    this.nodes.button.innerHTML = $5bdbe1ebf6713620$var$ns, this.nodes.button.classList.add(this.CSS.buttonUnlink), this.nodes.button.classList.add(this.CSS.buttonActive), this.openActions();
                    var t1 = e.getAttribute("href");
                    this.nodes.input.defaultValue = t1 !== "null" ? t1 : "", this.selection.save();
                } else this.nodes.button.innerHTML = $5bdbe1ebf6713620$var$Co, this.nodes.button.classList.remove(this.CSS.buttonUnlink), this.nodes.button.classList.remove(this.CSS.buttonActive);
                return !!e;
            }
        },
        {
            /**
   * Function called with Inline Toolbar closing
   */ key: "clear",
            value: function clear() {
                this.closeActions();
            }
        },
        {
            key: "shortcut",
            get: /**
   * Set a shortcut
   */ function get() {
                return "CMD+K";
            }
        },
        {
            /**
   * Show/close link input
   */ key: "toggleActions",
            value: function toggleActions() {
                this.inputOpened ? this.closeActions(!1) : this.openActions(!0);
            }
        },
        {
            /**
   * @param {boolean} needFocus - on link creation we need to focus input. On editing - nope.
   */ key: "openActions",
            value: function openActions() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                this.nodes.input.classList.add(this.CSS.inputShowed), e && this.nodes.input.focus(), this.inputOpened = !0;
            }
        },
        {
            /**
   * Close input
   *
   * @param {boolean} clearSavedSelection — we don't need to clear saved selection
   *                                        on toggle-clicks on the icon of opened Toolbar
   */ key: "closeActions",
            value: function closeActions() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
                if (this.selection.isFakeBackgroundEnabled) {
                    var t1 = new $5bdbe1ebf6713620$var$b();
                    t1.save(), this.selection.restore(), this.selection.removeFakeBackground(), t1.restore();
                }
                this.nodes.input.classList.remove(this.CSS.inputShowed), this.nodes.input.value = "", e && this.selection.clearSaved(), this.inputOpened = !1;
            }
        },
        {
            /**
   * Enter pressed on input
   *
   * @param {KeyboardEvent} event - enter keydown event
   */ key: "enterPressed",
            value: function enterPressed(e) {
                var t1 = this.nodes.input.value || "";
                if (!t1.trim()) {
                    this.selection.restore(), this.unlink(), e.preventDefault(), this.closeActions();
                    return;
                }
                if (!this.validateURL(t1)) {
                    this.notifier.show({
                        message: "Pasted link is not valid.",
                        style: "error"
                    }), $5bdbe1ebf6713620$var$S("Incorrect Link pasted", "warn", t1);
                    return;
                }
                t1 = this.prepareLink(t1), this.selection.restore(), this.selection.removeFakeBackground(), this.insertLink(t1), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation(), this.selection.collapseToEnd(), this.inlineToolbar.close();
            }
        },
        {
            /**
   * Detects if passed string is URL
   *
   * @param {string} str - string to validate
   * @returns {boolean}
   */ key: "validateURL",
            value: function validateURL(e) {
                return !/\s/.test(e);
            }
        },
        {
            /**
   * Process link before injection
   * - sanitize
   * - add protocol for links like 'google.com'
   *
   * @param {string} link - raw user input
   */ key: "prepareLink",
            value: function prepareLink(e) {
                return e = e.trim(), e = this.addProtocol(e), e;
            }
        },
        {
            /**
   * Add 'http' protocol to the links like 'vc.ru', 'google.com'
   *
   * @param {string} link - string to process
   */ key: "addProtocol",
            value: function addProtocol(e) {
                if (/^(\w+):(\/\/)?/.test(e)) return e;
                var t1 = /^\/[^/\s]/.test(e), o = e.substring(0, 1) === "#", i = /^\/\/[^/\s]/.test(e);
                return !t1 && !o && !i && (e = "http://" + e), e;
            }
        },
        {
            /**
   * Inserts <a> tag with "href"
   *
   * @param {string} link - "href" value
   */ key: "insertLink",
            value: function insertLink(e) {
                var t1 = this.selection.findParentTag("A");
                t1 && this.selection.expandToTag(t1), document.execCommand(this.commandLink, !1, e);
            }
        },
        {
            /**
   * Removes <a> tag
   */ key: "unlink",
            value: function unlink() {
                document.execCommand(this.commandUnlink);
            }
        }
    ], [
        {
            key: "sanitize",
            get: /**
   * Sanitizer Rule
   * Leave <a> tags
   *
   * @returns {object}
   */ function get() {
                return {
                    a: {
                        href: !0,
                        target: "_blank",
                        rel: "nofollow"
                    }
                };
            }
        }
    ]);
    return bo;
}();
$5bdbe1ebf6713620$var$bo.isInline = !0;
$5bdbe1ebf6713620$var$bo.title = "Link";
var $5bdbe1ebf6713620$var$Fn = /*#__PURE__*/ function() {
    "use strict";
    function Fn(param) {
        var e = param.api;
        (0, $173N4._)(this, Fn);
        this.i18nAPI = e.i18n, this.blocksAPI = e.blocks, this.selectionAPI = e.selection, this.toolsAPI = e.tools, this.caretAPI = e.caret;
    }
    (0, $cFHGC._)(Fn, [
        {
            key: "render",
            value: /**
   * Returns tool's UI config
   */ function render() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _this, e, t1, o, i, s, r, a, l;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                e = $5bdbe1ebf6713620$var$b.get(), t1 = this.blocksAPI.getBlockByElement(e.anchorNode);
                                if (t1 === void 0) return [
                                    2,
                                    []
                                ];
                                o = this.toolsAPI.getBlockTools();
                                return [
                                    4,
                                    $5bdbe1ebf6713620$var$Yo(t1, o)
                                ];
                            case 1:
                                i = _state.sent();
                                if (i.length === 0) return [
                                    2,
                                    []
                                ];
                                s = i.reduce(function(c, d) {
                                    var h;
                                    return (h = d.toolbox) == null || h.forEach(function(p) {
                                        c.push({
                                            icon: p.icon,
                                            title: $5bdbe1ebf6713620$var$z.t($5bdbe1ebf6713620$var$K.toolNames, p.title),
                                            name: d.name,
                                            closeOnActivate: !0,
                                            onActivate: function() {
                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                                    var g;
                                                    return (0, $13u2V._)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                return [
                                                                    4,
                                                                    this.blocksAPI.convert(t1.id, d.name, p.data)
                                                                ];
                                                            case 1:
                                                                g = _state.sent();
                                                                this.caretAPI.setToBlock(g, "end");
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                }).call(_this);
                                            }
                                        });
                                    }), c;
                                }, []);
                                return [
                                    4,
                                    t1.getActiveToolboxEntry()
                                ];
                            case 2:
                                r = _state.sent(), a = r !== void 0 ? r.icon : $5bdbe1ebf6713620$var$Go, l = !$5bdbe1ebf6713620$var$be();
                                return [
                                    2,
                                    {
                                        icon: a,
                                        name: "convert-to",
                                        hint: {
                                            title: this.i18nAPI.t("Convert to")
                                        },
                                        children: {
                                            searchable: l,
                                            items: s,
                                            onOpen: function() {
                                                l && (_this.selectionAPI.setFakeBackground(), _this.selectionAPI.save());
                                            },
                                            onClose: function() {
                                                l && (_this.selectionAPI.restore(), _this.selectionAPI.removeFakeBackground());
                                            }
                                        }
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return Fn;
}();
$5bdbe1ebf6713620$var$Fn.isInline = !0;
var $5bdbe1ebf6713620$var$jn = /*#__PURE__*/ function() {
    "use strict";
    function jn(param) {
        var e = param.data, t1 = param.api;
        (0, $173N4._)(this, jn);
        this.CSS = {
            wrapper: "ce-stub",
            info: "ce-stub__info",
            title: "ce-stub__title",
            subtitle: "ce-stub__subtitle"
        }, this.api = t1, this.title = e.title || this.api.i18n.t("Error"), this.subtitle = this.api.i18n.t("The block can not be displayed correctly."), this.savedData = e.savedData, this.wrapper = this.make();
    }
    (0, $cFHGC._)(jn, [
        {
            /**
   * Returns stub holder
   *
   * @returns {HTMLElement}
   */ key: "render",
            value: function render() {
                return this.wrapper;
            }
        },
        {
            /**
   * Return original Tool data
   *
   * @returns {BlockToolData}
   */ key: "save",
            value: function save() {
                return this.savedData;
            }
        },
        {
            /**
   * Create Tool html markup
   *
   * @returns {HTMLElement}
   */ key: "make",
            value: function make() {
                var e = $5bdbe1ebf6713620$var$u.make("div", this.CSS.wrapper), t1 = $5bdbe1ebf6713620$var$is, o = $5bdbe1ebf6713620$var$u.make("div", this.CSS.info), i = $5bdbe1ebf6713620$var$u.make("div", this.CSS.title, {
                    textContent: this.title
                }), s = $5bdbe1ebf6713620$var$u.make("div", this.CSS.subtitle, {
                    textContent: this.subtitle
                });
                return e.innerHTML = t1, o.appendChild(i), o.appendChild(s), e.appendChild(o), e;
            }
        }
    ]);
    return jn;
}();
$5bdbe1ebf6713620$var$jn.isReadOnlySupported = !0;
var $5bdbe1ebf6713620$var$ka = /*#__PURE__*/ function(Tt) {
    "use strict";
    (0, $hdIku._)(ka, Tt);
    function ka() {
        (0, $173N4._)(this, ka);
        var _this;
        _this = (0, $7qXGD._)(this, ka, arguments), _this.type = $5bdbe1ebf6713620$var$ae.Inline;
        return _this;
    }
    (0, $cFHGC._)(ka, [
        {
            key: "title",
            get: /**
   * Returns title for Inline Tool if specified by user
   */ function get() {
                return this.constructable[$5bdbe1ebf6713620$var$We.Title];
            }
        },
        {
            /**
   * Constructs new InlineTool instance from constructable
   */ key: "create",
            value: function create() {
                return new this.constructable({
                    api: this.api,
                    config: this.settings
                });
            }
        },
        {
            key: "isReadOnlySupported",
            get: /**
   * Allows inline tool to be available in read-only mode
   * Can be used, for example, by comments tool
   */ function get() {
                var _this_constructable_We_IsReadOnlySupported;
                return (_this_constructable_We_IsReadOnlySupported = this.constructable[$5bdbe1ebf6713620$var$We.IsReadOnlySupported]) !== null && _this_constructable_We_IsReadOnlySupported !== void 0 ? _this_constructable_We_IsReadOnlySupported : !1;
            }
        }
    ]);
    return ka;
}($5bdbe1ebf6713620$var$Tt);
var $5bdbe1ebf6713620$var$ya = /*#__PURE__*/ function(Tt) {
    "use strict";
    (0, $hdIku._)(ya, Tt);
    function ya() {
        (0, $173N4._)(this, ya);
        var _this;
        _this = (0, $7qXGD._)(this, ya, arguments), _this.type = $5bdbe1ebf6713620$var$ae.Tune;
        return _this;
    }
    (0, $cFHGC._)(ya, [
        {
            /**
   * Constructs new BlockTune instance from constructable
   *
   * @param data - Tune data
   * @param block - Block API object
   */ key: "create",
            value: function create(e, t1) {
                return new this.constructable({
                    api: this.api,
                    config: this.settings,
                    block: t1,
                    data: e
                });
            }
        }
    ]);
    return ya;
}($5bdbe1ebf6713620$var$Tt);
var $5bdbe1ebf6713620$var$j = /*#__PURE__*/ function(Map1) {
    "use strict";
    (0, $hdIku._)(j, Map1);
    function j() {
        (0, $173N4._)(this, j);
        return (0, $7qXGD._)(this, j, arguments);
    }
    (0, $cFHGC._)(j, [
        {
            key: "blockTools",
            get: /**
   * Returns Block Tools collection
   */ function get() {
                var e = Array.from(this.entries()).filter(function(param) {
                    var _param = (0, $f9AOD._)(param, 2), t1 = _param[1];
                    return t1.isBlock();
                });
                return new j(e);
            }
        },
        {
            key: "inlineTools",
            get: /**
   * Returns Inline Tools collection
   */ function get() {
                var e = Array.from(this.entries()).filter(function(param) {
                    var _param = (0, $f9AOD._)(param, 2), t1 = _param[1];
                    return t1.isInline();
                });
                return new j(e);
            }
        },
        {
            key: "blockTunes",
            get: /**
   * Returns Block Tunes collection
   */ function get() {
                var e = Array.from(this.entries()).filter(function(param) {
                    var _param = (0, $f9AOD._)(param, 2), t1 = _param[1];
                    return t1.isTune();
                });
                return new j(e);
            }
        },
        {
            key: "internalTools",
            get: /**
   * Returns internal Tools collection
   */ function get() {
                var e = Array.from(this.entries()).filter(function(param) {
                    var _param = (0, $f9AOD._)(param, 2), t1 = _param[1];
                    return t1.isInternal;
                });
                return new j(e);
            }
        },
        {
            key: "externalTools",
            get: /**
   * Returns Tools collection provided by user
   */ function get() {
                var e = Array.from(this.entries()).filter(function(param) {
                    var _param = (0, $f9AOD._)(param, 2), t1 = _param[1];
                    return !t1.isInternal;
                });
                return new j(e);
            }
        }
    ]);
    return j;
}((0, $1SdK7._)(Map));
var $5bdbe1ebf6713620$var$wa = Object.defineProperty, $5bdbe1ebf6713620$var$Ea = Object.getOwnPropertyDescriptor, $5bdbe1ebf6713620$var$Hn = function(n, e, t1, o) {
    for(var i = o > 1 ? void 0 : o ? $5bdbe1ebf6713620$var$Ea(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $5bdbe1ebf6713620$var$wa(e, t1, i), i;
};
var $5bdbe1ebf6713620$var$vo = /*#__PURE__*/ function(Tt) {
    "use strict";
    (0, $hdIku._)(vo, Tt);
    function vo() {
        (0, $173N4._)(this, vo);
        var _this;
        _this = (0, $7qXGD._)(this, vo, arguments), _this.type = $5bdbe1ebf6713620$var$ae.Block, _this.inlineTools = new $5bdbe1ebf6713620$var$j(), _this.tunes = new $5bdbe1ebf6713620$var$j();
        return _this;
    }
    (0, $cFHGC._)(vo, [
        {
            /**
   * Creates new Tool instance
   *
   * @param data - Tool data
   * @param block - BlockAPI for current Block
   * @param readOnly - True if Editor is in read-only mode
   */ key: "create",
            value: function create(e, t1, o) {
                return new this.constructable({
                    data: e,
                    block: t1,
                    readOnly: o,
                    api: this.api,
                    config: this.settings
                });
            }
        },
        {
            key: "isReadOnlySupported",
            get: /**
   * Returns true if read-only mode is supported by Tool
   */ function get() {
                return this.constructable[$5bdbe1ebf6713620$var$pe.IsReadOnlySupported] === !0;
            }
        },
        {
            key: "isLineBreaksEnabled",
            get: /**
   * Returns true if Tool supports linebreaks
   */ function get() {
                return this.constructable[$5bdbe1ebf6713620$var$pe.IsEnabledLineBreaks];
            }
        },
        {
            key: "toolbox",
            get: /**
   * Returns Tool toolbox configuration (internal or user-specified).
   *
   * Merges internal and user-defined toolbox configs based on the following rules:
   *
   * - If both internal and user-defined toolbox configs are arrays their items are merged.
   * Length of the second one is kept.
   *
   * - If both are objects their properties are merged.
   *
   * - If one is an object and another is an array than internal config is replaced with user-defined
   * config. This is made to allow user to override default tool's toolbox representation (single/multiple entries)
   */ function get() {
                var e = this.constructable[$5bdbe1ebf6713620$var$pe.Toolbox], t1 = this.config[$5bdbe1ebf6713620$var$Pe.Toolbox];
                if (!$5bdbe1ebf6713620$var$V(e) && t1 !== !1) return t1 ? Array.isArray(e) ? Array.isArray(t1) ? t1.map(function(o, i) {
                    var s = e[i];
                    return s ? (0, $1XAnY._)({}, s, o) : o;
                }) : [
                    t1
                ] : Array.isArray(t1) ? t1 : [
                    (0, $1XAnY._)({}, e, t1)
                ] : Array.isArray(e) ? e : [
                    e
                ];
            }
        },
        {
            key: "conversionConfig",
            get: /**
   * Returns Tool conversion configuration
   */ function get() {
                return this.constructable[$5bdbe1ebf6713620$var$pe.ConversionConfig];
            }
        },
        {
            key: "enabledInlineTools",
            get: /**
   * Returns enabled inline tools for Tool
   */ function get() {
                return this.config[$5bdbe1ebf6713620$var$Pe.EnabledInlineTools] || !1;
            }
        },
        {
            key: "enabledBlockTunes",
            get: /**
   * Returns enabled tunes for Tool
   */ function get() {
                return this.config[$5bdbe1ebf6713620$var$Pe.EnabledBlockTunes];
            }
        },
        {
            key: "pasteConfig",
            get: /**
   * Returns Tool paste configuration
   */ function get() {
                var _this_constructable_pe_PasteConfig;
                return (_this_constructable_pe_PasteConfig = this.constructable[$5bdbe1ebf6713620$var$pe.PasteConfig]) !== null && _this_constructable_pe_PasteConfig !== void 0 ? _this_constructable_pe_PasteConfig : {};
            }
        },
        {
            key: "sanitizeConfig",
            get: function get() {
                var e = (0, $dWsrg._)((0, $kg0zo._)(vo.prototype), "sanitizeConfig", this), t1 = this.baseSanitizeConfig;
                if ($5bdbe1ebf6713620$var$V(e)) return t1;
                var o = {};
                for(var i in e)if (Object.prototype.hasOwnProperty.call(e, i)) {
                    var s = e[i];
                    $5bdbe1ebf6713620$var$D(s) ? o[i] = Object.assign({}, t1, s) : o[i] = s;
                }
                return o;
            }
        },
        {
            key: "baseSanitizeConfig",
            get: function get() {
                var e = {};
                return Array.from(this.inlineTools.values()).forEach(function(t1) {
                    return Object.assign(e, t1.sanitizeConfig);
                }), Array.from(this.tunes.values()).forEach(function(t1) {
                    return Object.assign(e, t1.sanitizeConfig);
                }), e;
            }
        }
    ]);
    return vo;
}($5bdbe1ebf6713620$var$Tt);
$5bdbe1ebf6713620$var$Hn([
    $5bdbe1ebf6713620$var$me
], $5bdbe1ebf6713620$var$vo.prototype, "sanitizeConfig", 1);
$5bdbe1ebf6713620$var$Hn([
    $5bdbe1ebf6713620$var$me
], $5bdbe1ebf6713620$var$vo.prototype, "baseSanitizeConfig", 1);
var $5bdbe1ebf6713620$var$xa = /*#__PURE__*/ function() {
    "use strict";
    function xa(e, t1, o) {
        (0, $173N4._)(this, xa);
        this.api = o, this.config = e, this.editorConfig = t1;
    }
    (0, $cFHGC._)(xa, [
        {
            /**
   * Returns Tool object based on it's type
   *
   * @param name - tool name
   */ key: "get",
            value: function get(e) {
                var _this_config_e = this.config[e], t1 = _this_config_e.class, tmp = _this_config_e.isInternal, o = tmp === void 0 ? !1 : tmp, i = (0, $6acIq._)(_this_config_e, [
                    "class",
                    "isInternal"
                ]), s = this.getConstructor(t1), r = t1[$5bdbe1ebf6713620$var$mt.IsTune];
                return new s({
                    name: e,
                    constructable: t1,
                    config: i,
                    api: this.api.getMethodsForTool(e, r),
                    isDefault: e === this.editorConfig.defaultBlock,
                    defaultPlaceholder: this.editorConfig.placeholder,
                    isInternal: o
                });
            }
        },
        {
            /**
   * Find appropriate Tool object constructor for Tool constructable
   *
   * @param constructable - Tools constructable
   */ key: "getConstructor",
            value: function getConstructor(e) {
                switch(!0){
                    case e[$5bdbe1ebf6713620$var$We.IsInline]:
                        return $5bdbe1ebf6713620$var$ka;
                    case e[$5bdbe1ebf6713620$var$mt.IsTune]:
                        return $5bdbe1ebf6713620$var$ya;
                    default:
                        return $5bdbe1ebf6713620$var$vo;
                }
            }
        }
    ]);
    return xa;
}();
var $5bdbe1ebf6713620$var$$n = /*#__PURE__*/ function() {
    "use strict";
    function $n(param) {
        var e = param.api;
        (0, $173N4._)(this, $n);
        this.CSS = {
            animation: "wobble"
        }, this.api = e;
    }
    (0, $cFHGC._)($n, [
        {
            /**
   * Tune's appearance in block settings menu
   */ key: "render",
            value: function render() {
                var _this = this;
                return {
                    icon: $5bdbe1ebf6713620$var$Xi,
                    title: this.api.i18n.t("Move down"),
                    onActivate: function() {
                        return _this.handleClick();
                    },
                    name: "move-down"
                };
            }
        },
        {
            /**
   * Handle clicks on 'move down' button
   */ key: "handleClick",
            value: function handleClick() {
                var e = this.api.blocks.getCurrentBlockIndex(), t1 = this.api.blocks.getBlockByIndex(e + 1);
                if (!t1) throw new Error("Unable to move Block down since it is already the last");
                var o = t1.holder, i = o.getBoundingClientRect();
                var s = Math.abs(window.innerHeight - o.offsetHeight);
                i.top < window.innerHeight && (s = window.scrollY + o.offsetHeight), window.scrollTo(0, s), this.api.blocks.move(e + 1), this.api.toolbar.toggleBlockSettings(!0);
            }
        }
    ]);
    return $n;
}();
$5bdbe1ebf6713620$var$$n.isTune = !0;
var $5bdbe1ebf6713620$var$zn = /*#__PURE__*/ function() {
    "use strict";
    function zn(param) {
        var e = param.api;
        (0, $173N4._)(this, zn);
        this.api = e;
    }
    (0, $cFHGC._)(zn, [
        {
            /**
   * Tune's appearance in block settings menu
   */ key: "render",
            value: function render() {
                var _this = this;
                return {
                    icon: $5bdbe1ebf6713620$var$Gi,
                    title: this.api.i18n.t("Delete"),
                    name: "delete",
                    confirmation: {
                        title: this.api.i18n.t("Click to delete"),
                        onActivate: function() {
                            return _this.handleClick();
                        }
                    }
                };
            }
        },
        {
            /**
   * Delete block conditions passed
   */ key: "handleClick",
            value: function handleClick() {
                this.api.blocks.delete();
            }
        }
    ]);
    return zn;
}();
$5bdbe1ebf6713620$var$zn.isTune = !0;
var $5bdbe1ebf6713620$var$Un = /*#__PURE__*/ function() {
    "use strict";
    function Un(param) {
        var e = param.api;
        (0, $173N4._)(this, Un);
        this.CSS = {
            animation: "wobble"
        }, this.api = e;
    }
    (0, $cFHGC._)(Un, [
        {
            /**
   * Tune's appearance in block settings menu
   */ key: "render",
            value: function render() {
                var _this = this;
                return {
                    icon: $5bdbe1ebf6713620$var$Zi,
                    title: this.api.i18n.t("Move up"),
                    onActivate: function() {
                        return _this.handleClick();
                    },
                    name: "move-up"
                };
            }
        },
        {
            /**
   * Move current block up
   */ key: "handleClick",
            value: function handleClick() {
                var e = this.api.blocks.getCurrentBlockIndex(), t1 = this.api.blocks.getBlockByIndex(e), o = this.api.blocks.getBlockByIndex(e - 1);
                if (e === 0 || !t1 || !o) throw new Error("Unable to move Block up since it is already the first");
                var i = t1.holder, s = o.holder, r = i.getBoundingClientRect(), a = s.getBoundingClientRect();
                var l;
                a.top > 0 ? l = Math.abs(r.top) - Math.abs(a.top) : l = Math.abs(r.top) + a.height, window.scrollBy(0, -1 * l), this.api.blocks.move(e - 1), this.api.toolbar.toggleBlockSettings(!0);
            }
        }
    ]);
    return Un;
}();
$5bdbe1ebf6713620$var$Un.isTune = !0;
var $5bdbe1ebf6713620$var$Ba = Object.defineProperty, $5bdbe1ebf6713620$var$Ca = Object.getOwnPropertyDescriptor, $5bdbe1ebf6713620$var$Ta = function(n, e, t1, o) {
    for(var i = o > 1 ? void 0 : o ? $5bdbe1ebf6713620$var$Ca(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $5bdbe1ebf6713620$var$Ba(e, t1, i), i;
};
var $5bdbe1ebf6713620$var$Wn = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(Wn, E);
    function Wn() {
        (0, $173N4._)(this, Wn);
        var _this;
        _this = (0, $7qXGD._)(this, Wn, arguments), _this.stubTool = "stub", _this.toolsAvailable = new $5bdbe1ebf6713620$var$j(), _this.toolsUnavailable = new $5bdbe1ebf6713620$var$j();
        return _this;
    }
    (0, $cFHGC._)(Wn, [
        {
            key: "available",
            get: /**
   * Returns available Tools
   */ function get() {
                return this.toolsAvailable;
            }
        },
        {
            key: "unavailable",
            get: /**
   * Returns unavailable Tools
   */ function get() {
                return this.toolsUnavailable;
            }
        },
        {
            key: "inlineTools",
            get: /**
   * Return Tools for the Inline Toolbar
   */ function get() {
                return this.available.inlineTools;
            }
        },
        {
            key: "blockTools",
            get: /**
   * Return editor block tools
   */ function get() {
                return this.available.blockTools;
            }
        },
        {
            key: "blockTunes",
            get: /**
   * Return available Block Tunes
   *
   * @returns {object} - object of Inline Tool's classes
   */ function get() {
                return this.available.blockTunes;
            }
        },
        {
            key: "defaultTool",
            get: /**
   * Returns default Tool object
   */ function get() {
                return this.blockTools.get(this.config.defaultBlock);
            }
        },
        {
            key: "internal",
            get: /**
   * Returns internal tools
   */ function get() {
                return this.available.internalTools;
            }
        },
        {
            key: "prepare",
            value: /**
   * Creates instances via passed or default configuration
   *
   * @returns {Promise<void>}
   */ function prepare() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _this, e, t1;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                if (this.validateTools(), this.config.tools = $5bdbe1ebf6713620$var$ut({}, this.internalTools, this.config.tools), !Object.prototype.hasOwnProperty.call(this.config, "tools") || Object.keys(this.config.tools).length === 0) throw Error("Can't start without tools");
                                e = this.prepareConfig();
                                this.factory = new $5bdbe1ebf6713620$var$xa(e, this.config, this.Editor.API);
                                t1 = this.getListOfPrepareFunctions(e);
                                if (t1.length === 0) return [
                                    2,
                                    Promise.resolve()
                                ];
                                return [
                                    4,
                                    $5bdbe1ebf6713620$var$Qn(t1, function(o) {
                                        _this.toolPrepareMethodSuccess(o);
                                    }, function(o) {
                                        _this.toolPrepareMethodFallback(o);
                                    })
                                ];
                            case 1:
                                _state.sent(), this.prepareBlockTools();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getAllInlineToolsSanitizeConfig",
            value: function getAllInlineToolsSanitizeConfig() {
                var e = {};
                return Array.from(this.inlineTools.values()).forEach(function(t1) {
                    Object.assign(e, t1.sanitizeConfig);
                }), e;
            }
        },
        {
            /**
   * Calls each Tool reset method to clean up anything set by Tool
   */ key: "destroy",
            value: function destroy() {
                Object.values(this.available).forEach(function(e) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                        var _tmp;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _tmp = $5bdbe1ebf6713620$var$A(e.reset);
                                    if (!_tmp) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        e.reset()
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    _state.label = 2;
                                case 2:
                                    _tmp;
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                });
            }
        },
        {
            key: "internalTools",
            get: /**
   * Returns internal tools
   * Includes Bold, Italic, Link and Paragraph
   */ function get() {
                return {
                    convertTo: {
                        class: $5bdbe1ebf6713620$var$Fn,
                        isInternal: !0
                    },
                    link: {
                        class: $5bdbe1ebf6713620$var$bo,
                        isInternal: !0
                    },
                    bold: {
                        class: $5bdbe1ebf6713620$var$go,
                        isInternal: !0
                    },
                    italic: {
                        class: $5bdbe1ebf6713620$var$mo,
                        isInternal: !0
                    },
                    paragraph: {
                        class: $5bdbe1ebf6713620$var$fo,
                        inlineToolbar: !0,
                        isInternal: !0
                    },
                    stub: {
                        class: $5bdbe1ebf6713620$var$jn,
                        isInternal: !0
                    },
                    moveUp: {
                        class: $5bdbe1ebf6713620$var$Un,
                        isInternal: !0
                    },
                    delete: {
                        class: $5bdbe1ebf6713620$var$zn,
                        isInternal: !0
                    },
                    moveDown: {
                        class: $5bdbe1ebf6713620$var$$n,
                        isInternal: !0
                    }
                };
            }
        },
        {
            /**
   * Tool prepare method success callback
   *
   * @param {object} data - append tool to available list
   */ key: "toolPrepareMethodSuccess",
            value: function toolPrepareMethodSuccess(e) {
                var t1 = this.factory.get(e.toolName);
                if (t1.isInline()) {
                    var i = [
                        "render"
                    ].filter(function(s) {
                        return !t1.create()[s];
                    });
                    if (i.length) {
                        $5bdbe1ebf6713620$var$S("Incorrect Inline Tool: ".concat(t1.name, ". Some of required methods is not implemented %o"), "warn", i), this.toolsUnavailable.set(t1.name, t1);
                        return;
                    }
                }
                this.toolsAvailable.set(t1.name, t1);
            }
        },
        {
            /**
   * Tool prepare method fail callback
   *
   * @param {object} data - append tool to unavailable list
   */ key: "toolPrepareMethodFallback",
            value: function toolPrepareMethodFallback(e) {
                this.toolsUnavailable.set(e.toolName, this.factory.get(e.toolName));
            }
        },
        {
            /**
   * Binds prepare function of plugins with user or default config
   *
   * @returns {Array} list of functions that needs to be fired sequentially
   * @param config - tools config
   */ key: "getListOfPrepareFunctions",
            value: function getListOfPrepareFunctions(e) {
                var t1 = [];
                return Object.entries(e).forEach(function(param) {
                    var _param = (0, $f9AOD._)(param, 2), o = _param[0], i = _param[1];
                    t1.push({
                        // eslint-disable-next-line @typescript-eslint/no-empty-function
                        function: $5bdbe1ebf6713620$var$A(i.class.prepare) ? i.class.prepare : function() {},
                        data: {
                            toolName: o,
                            config: i.config
                        }
                    });
                }), t1;
            }
        },
        {
            /**
   * Assign enabled Inline Tools and Block Tunes for Block Tool
   */ key: "prepareBlockTools",
            value: function prepareBlockTools() {
                var _this = this;
                Array.from(this.blockTools.values()).forEach(function(e) {
                    _this.assignInlineToolsToBlockTool(e), _this.assignBlockTunesToBlockTool(e);
                });
            }
        },
        {
            /**
   * Assign enabled Inline Tools for Block Tool
   *
   * @param tool - Block Tool
   */ key: "assignInlineToolsToBlockTool",
            value: function assignInlineToolsToBlockTool(e) {
                var _this = this;
                if (this.config.inlineToolbar !== !1) {
                    if (e.enabledInlineTools === !0) {
                        e.inlineTools = new $5bdbe1ebf6713620$var$j(Array.isArray(this.config.inlineToolbar) ? this.config.inlineToolbar.map(function(t1) {
                            return [
                                t1,
                                _this.inlineTools.get(t1)
                            ];
                        }) : Array.from(this.inlineTools.entries()));
                        return;
                    }
                    Array.isArray(e.enabledInlineTools) && (e.inlineTools = new $5bdbe1ebf6713620$var$j(/** Prepend ConvertTo Inline Tool */ [
                        "convertTo"
                    ].concat((0, $aUGqu._)(e.enabledInlineTools)).map(function(t1) {
                        return [
                            t1,
                            _this.inlineTools.get(t1)
                        ];
                    })));
                }
            }
        },
        {
            /**
   * Assign enabled Block Tunes for Block Tool
   *
   * @param tool — Block Tool
   */ key: "assignBlockTunesToBlockTool",
            value: function assignBlockTunesToBlockTool(e) {
                var _this = this;
                if (e.enabledBlockTunes !== !1) {
                    if (Array.isArray(e.enabledBlockTunes)) {
                        var t1 = new $5bdbe1ebf6713620$var$j(e.enabledBlockTunes.map(function(o) {
                            return [
                                o,
                                _this.blockTunes.get(o)
                            ];
                        }));
                        e.tunes = new $5bdbe1ebf6713620$var$j((0, $aUGqu._)(t1).concat((0, $aUGqu._)(this.blockTunes.internalTools)));
                        return;
                    }
                    if (Array.isArray(this.config.tunes)) {
                        var t2 = new $5bdbe1ebf6713620$var$j(this.config.tunes.map(function(o) {
                            return [
                                o,
                                _this.blockTunes.get(o)
                            ];
                        }));
                        e.tunes = new $5bdbe1ebf6713620$var$j((0, $aUGqu._)(t2).concat((0, $aUGqu._)(this.blockTunes.internalTools)));
                        return;
                    }
                    e.tunes = this.blockTunes.internalTools;
                }
            }
        },
        {
            /**
   * Validate Tools configuration objects and throw Error for user if it is invalid
   */ key: "validateTools",
            value: function validateTools() {
                for(var e in this.config.tools)if (Object.prototype.hasOwnProperty.call(this.config.tools, e)) {
                    if (e in this.internalTools) return;
                    var t1 = this.config.tools[e];
                    if (!$5bdbe1ebf6713620$var$A(t1) && !$5bdbe1ebf6713620$var$A(t1.class)) throw Error("Tool \xab".concat(e, "\xbb must be a constructor function or an object with function in the \xabclass\xbb property"));
                }
            }
        },
        {
            /**
   * Unify tools config
   */ key: "prepareConfig",
            value: function prepareConfig() {
                var e = {};
                for(var t1 in this.config.tools)$5bdbe1ebf6713620$var$D(this.config.tools[t1]) ? e[t1] = this.config.tools[t1] : e[t1] = {
                    class: this.config.tools[t1]
                };
                return e;
            }
        }
    ]);
    return Wn;
}($5bdbe1ebf6713620$var$E);
$5bdbe1ebf6713620$var$Ta([
    $5bdbe1ebf6713620$var$me
], $5bdbe1ebf6713620$var$Wn.prototype, "getAllInlineToolsSanitizeConfig", 1);
var $5bdbe1ebf6713620$var$Sa = ':root{--selectionColor: #e1f2ff;--inlineSelectionColor: #d4ecff;--bg-light: #eff2f5;--grayText: #707684;--color-dark: #1D202B;--color-active-icon: #388AE5;--color-gray-border: rgba(201, 201, 204, .48);--content-width: 650px;--narrow-mode-right-padding: 50px;--toolbox-buttons-size: 26px;--toolbox-buttons-size--mobile: 36px;--icon-size: 20px;--icon-size--mobile: 28px;--block-padding-vertical: .4em;--color-line-gray: #EFF0F1 }.codex-editor{position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;z-index:1}.codex-editor .hide{display:none}.codex-editor__redactor [contenteditable]:empty:after{content:"\\feff"}@media (min-width: 651px){.codex-editor--narrow .codex-editor__redactor{margin-right:50px}}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .codex-editor__redactor{margin-left:50px;margin-right:0}}@media (min-width: 651px){.codex-editor--narrow .ce-toolbar__actions{right:-5px}}.codex-editor-copyable{position:absolute;height:1px;width:1px;top:-400%;opacity:.001}.codex-editor-overlay{position:fixed;top:0;left:0;right:0;bottom:0;z-index:999;pointer-events:none;overflow:hidden}.codex-editor-overlay__container{position:relative;pointer-events:auto;z-index:0}.codex-editor-overlay__rectangle{position:absolute;pointer-events:none;background-color:#2eaadc33;border:1px solid transparent}.codex-editor svg{max-height:100%}.codex-editor path{stroke:currentColor}.codex-editor ::-moz-selection{background-color:#d4ecff}.codex-editor ::selection{background-color:#d4ecff}.codex-editor--toolbox-opened [contentEditable=true][data-placeholder]:focus:before{opacity:0!important}.ce-scroll-locked{overflow:hidden}.ce-scroll-locked--hard{overflow:hidden;top:calc(-1 * var(--window-scroll-offset));position:fixed;width:100%}.ce-toolbar{position:absolute;left:0;right:0;top:0;-webkit-transition:opacity .1s ease;transition:opacity .1s ease;will-change:opacity,top;display:none}.ce-toolbar--opened{display:block}.ce-toolbar__content{max-width:650px;margin:0 auto;position:relative}.ce-toolbar__plus{color:#1d202b;cursor:pointer;width:26px;height:26px;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-ms-flex-negative:0;flex-shrink:0}@media (max-width: 650px){.ce-toolbar__plus{width:36px;height:36px}}@media (hover: hover){.ce-toolbar__plus:hover{background-color:#eff2f5}}.ce-toolbar__plus--active{background-color:#eff2f5;-webkit-animation:bounceIn .75s 1;animation:bounceIn .75s 1;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.ce-toolbar__plus-shortcut{opacity:.6;word-spacing:-2px;margin-top:5px}@media (max-width: 650px){.ce-toolbar__plus{position:absolute;background-color:#fff;border:1px solid #E8E8EB;-webkit-box-shadow:0 3px 15px -3px rgba(13,20,33,.13);box-shadow:0 3px 15px -3px #0d142121;border-radius:6px;z-index:2;position:static}.ce-toolbar__plus--left-oriented:before{left:15px;margin-left:0}.ce-toolbar__plus--right-oriented:before{left:auto;right:15px;margin-left:0}}.ce-toolbar__actions{position:absolute;right:100%;opacity:0;display:-webkit-box;display:-ms-flexbox;display:flex;padding-right:5px}.ce-toolbar__actions--opened{opacity:1}@media (max-width: 650px){.ce-toolbar__actions{right:auto}}.ce-toolbar__settings-btn{color:#1d202b;width:26px;height:26px;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;margin-left:3px;cursor:pointer;user-select:none}@media (max-width: 650px){.ce-toolbar__settings-btn{width:36px;height:36px}}@media (hover: hover){.ce-toolbar__settings-btn:hover{background-color:#eff2f5}}.ce-toolbar__settings-btn--active{background-color:#eff2f5;-webkit-animation:bounceIn .75s 1;animation:bounceIn .75s 1;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}@media (min-width: 651px){.ce-toolbar__settings-btn{width:24px}}.ce-toolbar__settings-btn--hidden{display:none}@media (max-width: 650px){.ce-toolbar__settings-btn{position:absolute;background-color:#fff;border:1px solid #E8E8EB;-webkit-box-shadow:0 3px 15px -3px rgba(13,20,33,.13);box-shadow:0 3px 15px -3px #0d142121;border-radius:6px;z-index:2;position:static}.ce-toolbar__settings-btn--left-oriented:before{left:15px;margin-left:0}.ce-toolbar__settings-btn--right-oriented:before{left:auto;right:15px;margin-left:0}}.ce-toolbar__plus svg,.ce-toolbar__settings-btn svg{width:24px;height:24px}@media (min-width: 651px){.codex-editor--narrow .ce-toolbar__plus{left:5px}}@media (min-width: 651px){.codex-editor--narrow .ce-toolbox .ce-popover{right:0;left:auto;left:initial}}.ce-inline-toolbar{--y-offset: 8px;--color-background-icon-active: rgba(56, 138, 229, .1);--color-text-icon-active: #388AE5;--color-text-primary: black;position:absolute;visibility:hidden;-webkit-transition:opacity .25s ease;transition:opacity .25s ease;will-change:opacity,left,top;top:0;left:0;z-index:3;opacity:1;visibility:visible}.ce-inline-toolbar [hidden]{display:none!important}.ce-inline-toolbar__toggler-and-button-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;padding:0 6px}.ce-inline-toolbar__buttons{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-inline-toolbar__dropdown{display:-webkit-box;display:-ms-flexbox;display:flex;padding:6px;margin:0 6px 0 -6px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;border-right:1px solid rgba(201,201,204,.48);-webkit-box-sizing:border-box;box-sizing:border-box}@media (hover: hover){.ce-inline-toolbar__dropdown:hover{background:#eff2f5}}.ce-inline-toolbar__dropdown--hidden{display:none}.ce-inline-toolbar__dropdown-content,.ce-inline-toolbar__dropdown-arrow{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-inline-toolbar__dropdown-content svg,.ce-inline-toolbar__dropdown-arrow svg{width:20px;height:20px}.ce-inline-toolbar__shortcut{opacity:.6;word-spacing:-3px;margin-top:3px}.ce-inline-tool{color:var(--color-text-primary);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:0;border-radius:4px;line-height:normal;height:100%;padding:0;width:28px;background-color:transparent;cursor:pointer}@media (max-width: 650px){.ce-inline-tool{width:36px;height:36px}}@media (hover: hover){.ce-inline-tool:hover{background-color:#f8f8f8}}.ce-inline-tool svg{display:block;width:20px;height:20px}@media (max-width: 650px){.ce-inline-tool svg{width:28px;height:28px}}.ce-inline-tool--link .icon--unlink,.ce-inline-tool--unlink .icon--link{display:none}.ce-inline-tool--unlink .icon--unlink{display:inline-block;margin-bottom:-1px}.ce-inline-tool-input{background:#F8F8F8;border:1px solid rgba(226,226,229,.2);border-radius:6px;padding:4px 8px;font-size:14px;line-height:22px;outline:none;margin:0;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;display:none;font-weight:500;-webkit-appearance:none;font-family:inherit}@media (max-width: 650px){.ce-inline-tool-input{font-size:15px;font-weight:500}}.ce-inline-tool-input::-webkit-input-placeholder{color:#707684}.ce-inline-tool-input::-moz-placeholder{color:#707684}.ce-inline-tool-input:-ms-input-placeholder{color:#707684}.ce-inline-tool-input::-ms-input-placeholder{color:#707684}.ce-inline-tool-input::placeholder{color:#707684}.ce-inline-tool-input--showed{display:block}.ce-inline-tool--active{background:var(--color-background-icon-active);color:var(--color-text-icon-active)}@-webkit-keyframes fade-in{0%{opacity:0}to{opacity:1}}@keyframes fade-in{0%{opacity:0}to{opacity:1}}.ce-block{-webkit-animation:fade-in .3s ease;animation:fade-in .3s ease;-webkit-animation-fill-mode:none;animation-fill-mode:none;-webkit-animation-fill-mode:initial;animation-fill-mode:initial}.ce-block:first-of-type{margin-top:0}.ce-block--selected .ce-block__content{background:#e1f2ff}.ce-block--selected .ce-block__content [contenteditable]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ce-block--selected .ce-block__content img,.ce-block--selected .ce-block__content .ce-stub{opacity:.55}.ce-block--stretched .ce-block__content{max-width:none}.ce-block__content{position:relative;max-width:650px;margin:0 auto;-webkit-transition:background-color .15s ease;transition:background-color .15s ease}.ce-block--drop-target .ce-block__content:before{content:"";position:absolute;top:100%;left:-20px;margin-top:-1px;height:8px;width:8px;border:solid #388AE5;border-width:1px 1px 0 0;-webkit-transform-origin:right;transform-origin:right;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.ce-block--drop-target .ce-block__content:after{content:"";position:absolute;top:100%;height:1px;width:100%;color:#388ae5;background:repeating-linear-gradient(90deg,#388AE5,#388AE5 1px,#fff 1px,#fff 6px)}.ce-block a{cursor:pointer;-webkit-text-decoration:underline;text-decoration:underline}.ce-block b{font-weight:700}.ce-block i{font-style:italic}@-webkit-keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}20%{-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}60%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}20%{-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}60%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@-webkit-keyframes selectionBounce{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}50%{-webkit-transform:scale3d(1.01,1.01,1.01);transform:scale3d(1.01,1.01,1.01)}70%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes selectionBounce{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}50%{-webkit-transform:scale3d(1.01,1.01,1.01);transform:scale3d(1.01,1.01,1.01)}70%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@-webkit-keyframes buttonClicked{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.95,.95,.95);transform:scale3d(.95,.95,.95)}60%{-webkit-transform:scale3d(1.02,1.02,1.02);transform:scale3d(1.02,1.02,1.02)}80%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes buttonClicked{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.95,.95,.95);transform:scale3d(.95,.95,.95)}60%{-webkit-transform:scale3d(1.02,1.02,1.02);transform:scale3d(1.02,1.02,1.02)}80%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}.cdx-block{padding:.4em 0}.cdx-block::-webkit-input-placeholder{line-height:normal!important}.cdx-input{border:1px solid rgba(201,201,204,.48);-webkit-box-shadow:inset 0 1px 2px 0 rgba(35,44,72,.06);box-shadow:inset 0 1px 2px #232c480f;border-radius:3px;padding:10px 12px;outline:none;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.cdx-input[data-placeholder]:before{position:static!important}.cdx-input[data-placeholder]:before{display:inline-block;width:0;white-space:nowrap;pointer-events:none}.cdx-settings-button{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:3px;cursor:pointer;border:0;outline:none;background-color:transparent;vertical-align:bottom;color:inherit;margin:0;min-width:26px;min-height:26px}.cdx-settings-button--focused{background:rgba(34,186,255,.08)!important}.cdx-settings-button--focused{-webkit-box-shadow:inset 0 0 0px 1px rgba(7,161,227,.08);box-shadow:inset 0 0 0 1px #07a1e314}.cdx-settings-button--focused-animated{-webkit-animation-name:buttonClicked;animation-name:buttonClicked;-webkit-animation-duration:.25s;animation-duration:.25s}.cdx-settings-button--active{color:#388ae5}.cdx-settings-button svg{width:auto;height:auto}@media (max-width: 650px){.cdx-settings-button svg{width:28px;height:28px}}@media (max-width: 650px){.cdx-settings-button{width:36px;height:36px;border-radius:8px}}@media (hover: hover){.cdx-settings-button:hover{background-color:#eff2f5}}.cdx-loader{position:relative;border:1px solid rgba(201,201,204,.48)}.cdx-loader:before{content:"";position:absolute;left:50%;top:50%;width:18px;height:18px;margin:-11px 0 0 -11px;border:2px solid rgba(201,201,204,.48);border-left-color:#388ae5;border-radius:50%;-webkit-animation:cdxRotation 1.2s infinite linear;animation:cdxRotation 1.2s infinite linear}@-webkit-keyframes cdxRotation{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes cdxRotation{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.cdx-button{padding:13px;border-radius:3px;border:1px solid rgba(201,201,204,.48);font-size:14.9px;background:#fff;-webkit-box-shadow:0 2px 2px 0 rgba(18,30,57,.04);box-shadow:0 2px 2px #121e390a;color:#707684;text-align:center;cursor:pointer}@media (hover: hover){.cdx-button:hover{background:#FBFCFE;-webkit-box-shadow:0 1px 3px 0 rgba(18,30,57,.08);box-shadow:0 1px 3px #121e3914}}.cdx-button svg{height:20px;margin-right:.2em;margin-top:-2px}.ce-stub{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:12px 18px;margin:10px 0;border-radius:10px;background:#eff2f5;border:1px solid #EFF0F1;color:#707684;font-size:14px}.ce-stub svg{width:20px;height:20px}.ce-stub__info{margin-left:14px}.ce-stub__title{font-weight:500;text-transform:capitalize}.codex-editor.codex-editor--rtl{direction:rtl}.codex-editor.codex-editor--rtl .cdx-list{padding-left:0;padding-right:40px}.codex-editor.codex-editor--rtl .ce-toolbar__plus{right:-26px;left:auto}.codex-editor.codex-editor--rtl .ce-toolbar__actions{right:auto;left:-26px}@media (max-width: 650px){.codex-editor.codex-editor--rtl .ce-toolbar__actions{margin-left:0;margin-right:auto;padding-right:0;padding-left:10px}}.codex-editor.codex-editor--rtl .ce-settings{left:5px;right:auto}.codex-editor.codex-editor--rtl .ce-settings:before{right:auto;left:25px}.codex-editor.codex-editor--rtl .ce-settings__button:not(:nth-child(3n+3)){margin-left:3px;margin-right:0}.codex-editor.codex-editor--rtl .ce-conversion-tool__icon{margin-right:0;margin-left:10px}.codex-editor.codex-editor--rtl .ce-inline-toolbar__dropdown{border-right:0px solid transparent;border-left:1px solid rgba(201,201,204,.48);margin:0 -6px 0 6px}.codex-editor.codex-editor--rtl .ce-inline-toolbar__dropdown .icon--toggler-down{margin-left:0;margin-right:4px}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .ce-toolbar__plus{left:0;right:5px}}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .ce-toolbar__actions{left:-5px}}.cdx-search-field{--icon-margin-right: 10px;background:#F8F8F8;border:1px solid rgba(226,226,229,.2);border-radius:6px;padding:2px;display:grid;grid-template-columns:auto auto 1fr;grid-template-rows:auto}.cdx-search-field__icon{width:26px;height:26px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:var(--icon-margin-right)}.cdx-search-field__icon svg{width:20px;height:20px;color:#707684}.cdx-search-field__input{font-size:14px;outline:none;font-weight:500;font-family:inherit;border:0;background:transparent;margin:0;padding:0;line-height:22px;min-width:calc(100% - 26px - var(--icon-margin-right))}.cdx-search-field__input::-webkit-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::-moz-placeholder{color:#707684;font-weight:500}.cdx-search-field__input:-ms-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::-ms-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::placeholder{color:#707684;font-weight:500}.ce-popover{--border-radius: 6px;--width: 200px;--max-height: 270px;--padding: 6px;--offset-from-target: 8px;--color-border: #EFF0F1;--color-shadow: rgba(13, 20, 33, .1);--color-background: white;--color-text-primary: black;--color-text-secondary: #707684;--color-border-icon: rgba(201, 201, 204, .48);--color-border-icon-disabled: #EFF0F1;--color-text-icon-active: #388AE5;--color-background-icon-active: rgba(56, 138, 229, .1);--color-background-item-focus: rgba(34, 186, 255, .08);--color-shadow-item-focus: rgba(7, 161, 227, .08);--color-background-item-hover: #F8F8F8;--color-background-item-confirm: #E24A4A;--color-background-item-confirm-hover: #CE4343;--popover-top: calc(100% + var(--offset-from-target));--popover-left: 0;--nested-popover-overlap: 4px;--icon-size: 20px;--item-padding: 3px;--item-height: calc(var(--icon-size) + 2 * var(--item-padding))}.ce-popover__container{min-width:var(--width);width:var(--width);max-height:var(--max-height);border-radius:var(--border-radius);overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:0px 3px 15px -3px var(--color-shadow);box-shadow:0 3px 15px -3px var(--color-shadow);position:absolute;left:var(--popover-left);top:var(--popover-top);background:var(--color-background);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;z-index:4;opacity:0;max-height:0;pointer-events:none;padding:0;border:none}.ce-popover--opened>.ce-popover__container{opacity:1;padding:var(--padding);max-height:var(--max-height);pointer-events:auto;-webkit-animation:panelShowing .1s ease;animation:panelShowing .1s ease;border:1px solid var(--color-border)}@media (max-width: 650px){.ce-popover--opened>.ce-popover__container{-webkit-animation:panelShowingMobile .25s ease;animation:panelShowingMobile .25s ease}}.ce-popover--open-top .ce-popover__container{--popover-top: calc(-1 * (var(--offset-from-target) + var(--popover-height)))}.ce-popover--open-left .ce-popover__container{--popover-left: calc(-1 * var(--width) + 100%)}.ce-popover__items{overflow-y:auto;-ms-scroll-chaining:none;overscroll-behavior:contain}@media (max-width: 650px){.ce-popover__overlay{position:fixed;top:0;bottom:0;left:0;right:0;background:#1D202B;z-index:3;opacity:.5;-webkit-transition:opacity .12s ease-in;transition:opacity .12s ease-in;will-change:opacity;visibility:visible}}.ce-popover__overlay--hidden{display:none}@media (max-width: 650px){.ce-popover .ce-popover__container{--offset: 5px;position:fixed;max-width:none;min-width:calc(100% - var(--offset) * 2);left:var(--offset);right:var(--offset);bottom:calc(var(--offset) + env(safe-area-inset-bottom));top:auto;border-radius:10px}}.ce-popover__search{margin-bottom:5px}.ce-popover__nothing-found-message{color:#707684;display:none;cursor:default;padding:3px;font-size:14px;line-height:20px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ce-popover__nothing-found-message--displayed{display:block}.ce-popover--nested .ce-popover__container{--popover-left: calc(var(--nesting-level) * (var(--width) - var(--nested-popover-overlap)));top:calc(var(--trigger-item-top) - var(--nested-popover-overlap));position:absolute}.ce-popover--open-top.ce-popover--nested .ce-popover__container{top:calc(var(--trigger-item-top) - var(--popover-height) + var(--item-height) + var(--offset-from-target) + var(--nested-popover-overlap))}.ce-popover--open-left .ce-popover--nested .ce-popover__container{--popover-left: calc(-1 * (var(--nesting-level) + 1) * var(--width) + 100%)}.ce-popover-item-separator{padding:4px 3px}.ce-popover-item-separator--hidden{display:none}.ce-popover-item-separator__line{height:1px;background:var(--color-border);width:100%}.ce-popover-item-html--hidden{display:none}.ce-popover-item{--border-radius: 6px;border-radius:var(--border-radius);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:var(--item-padding);color:var(--color-text-primary);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:none;background:transparent}@media (max-width: 650px){.ce-popover-item{padding:4px}}.ce-popover-item:not(:last-of-type){margin-bottom:1px}.ce-popover-item__icon{width:26px;height:26px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ce-popover-item__icon svg{width:20px;height:20px}@media (max-width: 650px){.ce-popover-item__icon{width:36px;height:36px;border-radius:8px}.ce-popover-item__icon svg{width:28px;height:28px}}.ce-popover-item__icon--tool{margin-right:4px}.ce-popover-item__title{font-size:14px;line-height:20px;font-weight:500;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin-right:auto}@media (max-width: 650px){.ce-popover-item__title{font-size:16px}}.ce-popover-item__secondary-title{color:var(--color-text-secondary);font-size:12px;white-space:nowrap;letter-spacing:-.1em;padding-right:5px;opacity:.6}@media (max-width: 650px){.ce-popover-item__secondary-title{display:none}}.ce-popover-item--active{background:var(--color-background-icon-active);color:var(--color-text-icon-active)}.ce-popover-item--disabled{color:var(--color-text-secondary);cursor:default;pointer-events:none}.ce-popover-item--focused:not(.ce-popover-item--no-focus){background:var(--color-background-item-focus)!important}.ce-popover-item--hidden{display:none}@media (hover: hover){.ce-popover-item:hover{cursor:pointer}.ce-popover-item:hover:not(.ce-popover-item--no-hover){background-color:var(--color-background-item-hover)}}.ce-popover-item--confirmation{background:var(--color-background-item-confirm)}.ce-popover-item--confirmation .ce-popover-item__title,.ce-popover-item--confirmation .ce-popover-item__icon{color:#fff}@media (hover: hover){.ce-popover-item--confirmation:not(.ce-popover-item--no-hover):hover{background:var(--color-background-item-confirm-hover)}}.ce-popover-item--confirmation:not(.ce-popover-item--no-focus).ce-popover-item--focused{background:var(--color-background-item-confirm-hover)!important}@-webkit-keyframes panelShowing{0%{opacity:0;-webkit-transform:translateY(-8px) scale(.9);transform:translateY(-8px) scale(.9)}70%{opacity:1;-webkit-transform:translateY(2px);transform:translateY(2px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes panelShowing{0%{opacity:0;-webkit-transform:translateY(-8px) scale(.9);transform:translateY(-8px) scale(.9)}70%{opacity:1;-webkit-transform:translateY(2px);transform:translateY(2px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@-webkit-keyframes panelShowingMobile{0%{opacity:0;-webkit-transform:translateY(14px) scale(.98);transform:translateY(14px) scale(.98)}70%{opacity:1;-webkit-transform:translateY(-4px);transform:translateY(-4px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes panelShowingMobile{0%{opacity:0;-webkit-transform:translateY(14px) scale(.98);transform:translateY(14px) scale(.98)}70%{opacity:1;-webkit-transform:translateY(-4px);transform:translateY(-4px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}.wobble{-webkit-animation-name:wobble;animation-name:wobble;-webkit-animation-duration:.4s;animation-duration:.4s}@-webkit-keyframes wobble{0%{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-9%,0,0);transform:translate3d(-9%,0,0)}30%{-webkit-transform:translate3d(9%,0,0);transform:translate3d(9%,0,0)}45%{-webkit-transform:translate3d(-4%,0,0);transform:translate3d(-4%,0,0)}60%{-webkit-transform:translate3d(4%,0,0);transform:translate3d(4%,0,0)}75%{-webkit-transform:translate3d(-1%,0,0);transform:translate3d(-1%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}}@keyframes wobble{0%{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-9%,0,0);transform:translate3d(-9%,0,0)}30%{-webkit-transform:translate3d(9%,0,0);transform:translate3d(9%,0,0)}45%{-webkit-transform:translate3d(-4%,0,0);transform:translate3d(-4%,0,0)}60%{-webkit-transform:translate3d(4%,0,0);transform:translate3d(4%,0,0)}75%{-webkit-transform:translate3d(-1%,0,0);transform:translate3d(-1%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}}.ce-popover-header{margin-bottom:8px;margin-top:4px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ce-popover-header__text{font-size:18px;font-weight:600}.ce-popover-header__back-button{border:0;background:transparent;width:36px;height:36px;color:var(--color-text-primary)}.ce-popover-header__back-button svg{display:block;width:28px;height:28px}.ce-popover--inline{--height: 38px;--height-mobile: 46px;--container-padding: 4px;position:relative}.ce-popover--inline .ce-popover__custom-content{margin-bottom:0}.ce-popover--inline .ce-popover__items{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-popover--inline .ce-popover__container{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;padding:var(--container-padding);height:var(--height);top:0;min-width:-webkit-max-content;min-width:-moz-max-content;min-width:max-content;width:-webkit-max-content;width:-moz-max-content;width:max-content;-webkit-animation:none;animation:none}@media (max-width: 650px){.ce-popover--inline .ce-popover__container{height:var(--height-mobile);position:absolute}}.ce-popover--inline .ce-popover-item-separator{padding:0 4px}.ce-popover--inline .ce-popover-item-separator__line{height:100%;width:1px}.ce-popover--inline .ce-popover-item{border-radius:4px;padding:4px}.ce-popover--inline .ce-popover-item__icon--tool{-webkit-box-shadow:none;box-shadow:none;background:transparent;margin-right:0}.ce-popover--inline .ce-popover-item__icon{width:auto;width:initial;height:auto;height:initial}.ce-popover--inline .ce-popover-item__icon svg{width:20px;height:20px}@media (max-width: 650px){.ce-popover--inline .ce-popover-item__icon svg{width:28px;height:28px}}.ce-popover--inline .ce-popover-item:not(:last-of-type){margin-bottom:0;margin-bottom:initial}.ce-popover--inline .ce-popover-item-html{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ce-popover--inline .ce-popover-item__icon--chevron-right{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.ce-popover--inline .ce-popover--nested-level-1 .ce-popover__container{--offset: 3px;left:0;top:calc(var(--height) + var(--offset))}@media (max-width: 650px){.ce-popover--inline .ce-popover--nested-level-1 .ce-popover__container{top:calc(var(--height-mobile) + var(--offset))}}.ce-popover--inline .ce-popover--nested .ce-popover__container{min-width:var(--width);width:var(--width);height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;padding:6px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ce-popover--inline .ce-popover--nested .ce-popover__items{display:block;width:100%}.ce-popover--inline .ce-popover--nested .ce-popover-item{border-radius:6px;padding:3px}@media (max-width: 650px){.ce-popover--inline .ce-popover--nested .ce-popover-item{padding:4px}}.ce-popover--inline .ce-popover--nested .ce-popover-item__icon--tool{margin-right:4px}.ce-popover--inline .ce-popover--nested .ce-popover-item__icon{width:26px;height:26px}.ce-popover--inline .ce-popover--nested .ce-popover-item-separator{padding:4px 3px}.ce-popover--inline .ce-popover--nested .ce-popover-item-separator__line{width:100%;height:1px}.codex-editor [data-placeholder]:empty:before,.codex-editor [data-placeholder][data-empty=true]:before{pointer-events:none;color:#707684;cursor:text;content:attr(data-placeholder)}.codex-editor [data-placeholder-active]:empty:before,.codex-editor [data-placeholder-active][data-empty=true]:before{pointer-events:none;color:#707684;cursor:text}.codex-editor [data-placeholder-active]:empty:focus:before,.codex-editor [data-placeholder-active][data-empty=true]:focus:before{content:attr(data-placeholder-active)}\n';
var $5bdbe1ebf6713620$var$Ia = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $hdIku._)(Ia, E);
    function Ia() {
        (0, $173N4._)(this, Ia);
        var _this;
        _this = (0, $7qXGD._)(this, Ia, arguments), _this.isMobile = !1, _this.contentRectCache = null, _this.resizeDebouncer = $5bdbe1ebf6713620$var$Eo(function() {
            _this.windowResize();
        }, 200), _this.selectionChangeDebounced = $5bdbe1ebf6713620$var$Eo(function() {
            _this.selectionChanged();
        }, $5bdbe1ebf6713620$var$da), _this.documentTouchedListener = function(e) {
            _this.documentTouched(e);
        };
        return _this;
    }
    (0, $cFHGC._)(Ia, [
        {
            key: "CSS",
            get: /**
   * Editor.js UI CSS class names
   *
   * @returns {{editorWrapper: string, editorZone: string}}
   */ function get() {
                return {
                    editorWrapper: "codex-editor",
                    editorWrapperNarrow: "codex-editor--narrow",
                    editorZone: "codex-editor__redactor",
                    editorZoneHidden: "codex-editor__redactor--hidden",
                    editorEmpty: "codex-editor--empty",
                    editorRtlFix: "codex-editor--rtl"
                };
            }
        },
        {
            key: "contentRect",
            get: /**
   * Return Width of center column of Editor
   *
   * @returns {DOMRect}
   */ function get() {
                if (this.contentRectCache !== null) return this.contentRectCache;
                var e = this.nodes.wrapper.querySelector(".".concat($5bdbe1ebf6713620$var$R.CSS.content));
                return e ? (this.contentRectCache = e.getBoundingClientRect(), this.contentRectCache) : {
                    width: 650,
                    left: 0,
                    right: 0
                };
            }
        },
        {
            key: "prepare",
            value: /**
   * Making main interface
   */ function prepare() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    return (0, $13u2V._)(this, function(_state) {
                        this.setIsMobile(), this.make(), this.loadStyles();
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            /**
   * Toggle read-only state
   *
   * If readOnly is true:
   *  - removes all listeners from main UI module elements
   *
   * if readOnly is false:
   *  - enables all listeners to UI module elements
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ key: "toggleReadOnly",
            value: function toggleReadOnly(e) {
                var _this = this;
                e ? this.unbindReadOnlySensitiveListeners() : window.requestIdleCallback(function() {
                    _this.bindReadOnlySensitiveListeners();
                }, {
                    timeout: 2e3
                });
            }
        },
        {
            /**
   * Check if Editor is empty and set CSS class to wrapper
   */ key: "checkEmptiness",
            value: function checkEmptiness() {
                var _this_Editor = this.Editor, e = _this_Editor.BlockManager;
                this.nodes.wrapper.classList.toggle(this.CSS.editorEmpty, e.isEditorEmpty);
            }
        },
        {
            key: "someToolbarOpened",
            get: /**
   * Check if one of Toolbar is opened
   * Used to prevent global keydowns (for example, Enter) conflicts with Enter-on-toolbar
   *
   * @returns {boolean}
   */ function get() {
                var _this_Editor = this.Editor, e = _this_Editor.Toolbar, t1 = _this_Editor.BlockSettings, o = _this_Editor.InlineToolbar;
                return !!(t1.opened || o.opened || e.toolbox.opened);
            }
        },
        {
            key: "someFlipperButtonFocused",
            get: /**
   * Check for some Flipper-buttons is under focus
   */ function get() {
                return this.Editor.Toolbar.toolbox.hasFocus() ? !0 : Object.entries(this.Editor).filter(function(param) {
                    var _param = (0, $f9AOD._)(param, 2), e = _param[0], t1 = _param[1];
                    return t1.flipper instanceof $5bdbe1ebf6713620$var$ce;
                }).some(function(param) {
                    var _param = (0, $f9AOD._)(param, 2), e = _param[0], t1 = _param[1];
                    return t1.flipper.hasFocus();
                });
            }
        },
        {
            /**
   * Clean editor`s UI
   */ key: "destroy",
            value: function destroy() {
                this.nodes.holder.innerHTML = "", this.unbindReadOnlyInsensitiveListeners();
            }
        },
        {
            /**
   * Close all Editor's toolbars
   */ key: "closeAllToolbars",
            value: function closeAllToolbars() {
                var _this_Editor = this.Editor, e = _this_Editor.Toolbar, t1 = _this_Editor.BlockSettings, o = _this_Editor.InlineToolbar;
                t1.close(), o.close(), e.toolbox.close();
            }
        },
        {
            /**
   * Check for mobile mode and save the result
   */ key: "setIsMobile",
            value: function setIsMobile() {
                var e = window.innerWidth < $5bdbe1ebf6713620$var$Ro;
                e !== this.isMobile && this.eventsDispatcher.emit($5bdbe1ebf6713620$var$Te, {
                    isEnabled: this.isMobile
                }), this.isMobile = e;
            }
        },
        {
            /**
   * Makes Editor.js interface
   */ key: "make",
            value: function make() {
                this.nodes.holder = $5bdbe1ebf6713620$var$u.getHolder(this.config.holder), this.nodes.wrapper = $5bdbe1ebf6713620$var$u.make("div", [
                    this.CSS.editorWrapper
                ].concat((0, $aUGqu._)(this.isRtl ? [
                    this.CSS.editorRtlFix
                ] : []))), this.nodes.redactor = $5bdbe1ebf6713620$var$u.make("div", this.CSS.editorZone), this.nodes.holder.offsetWidth < this.contentRect.width && this.nodes.wrapper.classList.add(this.CSS.editorWrapperNarrow), this.nodes.redactor.style.paddingBottom = this.config.minHeight + "px", this.nodes.wrapper.appendChild(this.nodes.redactor), this.nodes.holder.appendChild(this.nodes.wrapper), this.bindReadOnlyInsensitiveListeners();
            }
        },
        {
            /**
   * Appends CSS
   */ key: "loadStyles",
            value: function loadStyles() {
                var e = "editor-js-styles";
                if ($5bdbe1ebf6713620$var$u.get(e)) return;
                var t1 = $5bdbe1ebf6713620$var$u.make("style", null, {
                    id: e,
                    textContent: $5bdbe1ebf6713620$var$Sa.toString()
                });
                this.config.style && !$5bdbe1ebf6713620$var$V(this.config.style) && this.config.style.nonce && t1.setAttribute("nonce", this.config.style.nonce), $5bdbe1ebf6713620$var$u.prepend(document.head, t1);
            }
        },
        {
            /**
   * Adds listeners that should work both in read-only and read-write modes
   */ key: "bindReadOnlyInsensitiveListeners",
            value: function bindReadOnlyInsensitiveListeners() {
                this.listeners.on(document, "selectionchange", this.selectionChangeDebounced), this.listeners.on(window, "resize", this.resizeDebouncer, {
                    passive: !0
                }), this.listeners.on(this.nodes.redactor, "mousedown", this.documentTouchedListener, {
                    capture: !0,
                    passive: !0
                }), this.listeners.on(this.nodes.redactor, "touchstart", this.documentTouchedListener, {
                    capture: !0,
                    passive: !0
                });
            }
        },
        {
            /**
   * Removes listeners that should work both in read-only and read-write modes
   */ key: "unbindReadOnlyInsensitiveListeners",
            value: function unbindReadOnlyInsensitiveListeners() {
                this.listeners.off(document, "selectionchange", this.selectionChangeDebounced), this.listeners.off(window, "resize", this.resizeDebouncer), this.listeners.off(this.nodes.redactor, "mousedown", this.documentTouchedListener), this.listeners.off(this.nodes.redactor, "touchstart", this.documentTouchedListener);
            }
        },
        {
            /**
   * Adds listeners that should work only in read-only mode
   */ key: "bindReadOnlySensitiveListeners",
            value: function bindReadOnlySensitiveListeners() {
                var _this = this;
                this.readOnlyMutableListeners.on(this.nodes.redactor, "click", function(e) {
                    _this.redactorClicked(e);
                }, !1), this.readOnlyMutableListeners.on(document, "keydown", function(e) {
                    _this.documentKeydown(e);
                }, !0), this.readOnlyMutableListeners.on(document, "mousedown", function(e) {
                    _this.documentClicked(e);
                }, !0), this.watchBlockHoveredEvents(), this.enableInputsEmptyMark();
            }
        },
        {
            /**
   * Listen redactor mousemove to emit 'block-hovered' event
   */ key: "watchBlockHoveredEvents",
            value: function watchBlockHoveredEvents() {
                var _this = this;
                var e;
                this.readOnlyMutableListeners.on(this.nodes.redactor, "mousemove", $5bdbe1ebf6713620$var$dt(function(t1) {
                    var o = t1.target.closest(".ce-block");
                    _this.Editor.BlockSelection.anyBlockSelected || o && e !== o && (e = o, _this.eventsDispatcher.emit($5bdbe1ebf6713620$var$ln, {
                        block: _this.Editor.BlockManager.getBlockByChildNode(o)
                    }));
                }, 20), {
                    passive: !0
                });
            }
        },
        {
            /**
   * Unbind events that should work only in read-only mode
   */ key: "unbindReadOnlySensitiveListeners",
            value: function unbindReadOnlySensitiveListeners() {
                this.readOnlyMutableListeners.clearAll();
            }
        },
        {
            /**
   * Resize window handler
   */ key: "windowResize",
            value: function windowResize() {
                this.contentRectCache = null, this.setIsMobile();
            }
        },
        {
            /**
   * All keydowns on document
   *
   * @param {KeyboardEvent} event - keyboard event
   */ key: "documentKeydown",
            value: function documentKeydown(e) {
                switch(e.keyCode){
                    case $5bdbe1ebf6713620$var$y.ENTER:
                        this.enterPressed(e);
                        break;
                    case $5bdbe1ebf6713620$var$y.BACKSPACE:
                    case $5bdbe1ebf6713620$var$y.DELETE:
                        this.backspacePressed(e);
                        break;
                    case $5bdbe1ebf6713620$var$y.ESC:
                        this.escapePressed(e);
                        break;
                    default:
                        this.defaultBehaviour(e);
                        break;
                }
            }
        },
        {
            /**
   * Ignore all other document's keydown events
   *
   * @param {KeyboardEvent} event - keyboard event
   */ key: "defaultBehaviour",
            value: function defaultBehaviour(e) {
                var _this_Editor_BlockManager = this.Editor.BlockManager, t1 = _this_Editor_BlockManager.currentBlock, o = e.target.closest(".".concat(this.CSS.editorWrapper)), i = e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
                if (t1 !== void 0 && o === null) {
                    this.Editor.BlockEvents.keydown(e);
                    return;
                }
                o || t1 && i || (this.Editor.BlockManager.unsetCurrentBlock(), this.Editor.Toolbar.close());
            }
        },
        {
            /**
   * @param {KeyboardEvent} event - keyboard event
   */ key: "backspacePressed",
            value: function backspacePressed(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.BlockSelection, i = _this_Editor.Caret;
                if (o.anyBlockSelected && !$5bdbe1ebf6713620$var$b.isSelectionExists) {
                    var s = t1.removeSelectedBlocks(), r = t1.insertDefaultBlockAtIndex(s, !0);
                    i.setToBlock(r, i.positions.START), o.clearSelection(e), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation();
                }
            }
        },
        {
            /**
   * Escape pressed
   * If some of Toolbar components are opened, then close it otherwise close Toolbar
   *
   * @param {Event} event - escape keydown event
   */ key: "escapePressed",
            value: function escapePressed(e) {
                this.Editor.BlockSelection.clearSelection(e), this.Editor.Toolbar.toolbox.opened ? (this.Editor.Toolbar.toolbox.close(), this.Editor.Caret.setToBlock(this.Editor.BlockManager.currentBlock, this.Editor.Caret.positions.END)) : this.Editor.BlockSettings.opened ? this.Editor.BlockSettings.close() : this.Editor.InlineToolbar.opened ? this.Editor.InlineToolbar.close() : this.Editor.Toolbar.close();
            }
        },
        {
            /**
   * Enter pressed on document
   *
   * @param {KeyboardEvent} event - keyboard event
   */ key: "enterPressed",
            value: function enterPressed(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.BlockSelection;
                if (this.someToolbarOpened) return;
                var i = t1.currentBlockIndex >= 0;
                if (o.anyBlockSelected && !$5bdbe1ebf6713620$var$b.isSelectionExists) {
                    o.clearSelection(e), e.preventDefault(), e.stopImmediatePropagation(), e.stopPropagation();
                    return;
                }
                if (!this.someToolbarOpened && i && e.target.tagName === "BODY") {
                    var s = this.Editor.BlockManager.insert();
                    e.preventDefault(), this.Editor.Caret.setToBlock(s), this.Editor.Toolbar.moveAndOpen(s);
                }
                this.Editor.BlockSelection.clearSelection(e);
            }
        },
        {
            /**
   * All clicks on document
   *
   * @param {MouseEvent} event - Click event
   */ key: "documentClicked",
            value: function documentClicked(e) {
                var a, l;
                if (!e.isTrusted) return;
                var t1 = e.target;
                this.nodes.holder.contains(t1) || $5bdbe1ebf6713620$var$b.isAtEditor || (this.Editor.BlockManager.unsetCurrentBlock(), this.Editor.Toolbar.close());
                var i = (a = this.Editor.BlockSettings.nodes.wrapper) == null ? void 0 : a.contains(t1), s = (l = this.Editor.Toolbar.nodes.settingsToggler) == null ? void 0 : l.contains(t1), r = i || s;
                if (this.Editor.BlockSettings.opened && !r) {
                    this.Editor.BlockSettings.close();
                    var c = this.Editor.BlockManager.getBlockByChildNode(t1);
                    this.Editor.Toolbar.moveAndOpen(c);
                }
                this.Editor.BlockSelection.clearSelection(e);
            }
        },
        {
            /**
   * First touch on editor
   * Fired before click
   *
   * Used to change current block — we need to do it before 'selectionChange' event.
   * Also:
   * - Move and show the Toolbar
   * - Set a Caret
   *
   * @param event - touch or mouse event
   */ key: "documentTouched",
            value: function documentTouched(e) {
                var t1 = e.target;
                if (t1 === this.nodes.redactor) {
                    var o = e instanceof MouseEvent ? e.clientX : e.touches[0].clientX, i = e instanceof MouseEvent ? e.clientY : e.touches[0].clientY;
                    t1 = document.elementFromPoint(o, i);
                }
                try {
                    this.Editor.BlockManager.setCurrentBlockByChildNode(t1);
                } catch (e) {
                    this.Editor.RectangleSelection.isRectActivated() || this.Editor.Caret.setToTheLastBlock();
                }
                this.Editor.ReadOnly.isEnabled || this.Editor.Toolbar.moveAndOpen();
            }
        },
        {
            /**
   * All clicks on the redactor zone
   *
   * @param {MouseEvent} event - click event
   * @description
   * - By clicks on the Editor's bottom zone:
   *      - if last Block is empty, set a Caret to this
   *      - otherwise, add a new empty Block and set a Caret to that
   */ key: "redactorClicked",
            value: function redactorClicked(e) {
                if (!$5bdbe1ebf6713620$var$b.isCollapsed) return;
                var t1 = e.target, o = e.metaKey || e.ctrlKey, i = $5bdbe1ebf6713620$var$u.getClosestAnchor(t1);
                if (i && o) {
                    e.stopImmediatePropagation(), e.stopPropagation();
                    var s = i.getAttribute("href"), r = $5bdbe1ebf6713620$var$oi(s);
                    $5bdbe1ebf6713620$var$ii(r);
                    return;
                }
                this.processBottomZoneClick(e);
            }
        },
        {
            /**
   * Check if user clicks on the Editor's bottom zone:
   *  - set caret to the last block
   *  - or add new empty block
   *
   * @param event - click event
   */ key: "processBottomZoneClick",
            value: function processBottomZoneClick(e) {
                var t1 = this.Editor.BlockManager.getBlockByIndex(-1), o = $5bdbe1ebf6713620$var$u.offset(t1.holder).bottom, i = e.pageY, _this_Editor = this.Editor, s = _this_Editor.BlockSelection;
                if (e.target instanceof Element && e.target.isEqualNode(this.nodes.redactor) && /**
    * If there is cross block selection started, target will be equal to redactor so we need additional check
    */ !s.anyBlockSelected && /**
    * Prevent caret jumping (to last block) when clicking between blocks
    */ o < i) {
                    e.stopImmediatePropagation(), e.stopPropagation();
                    var _this_Editor1 = this.Editor, a = _this_Editor1.BlockManager, l = _this_Editor1.Caret, c = _this_Editor1.Toolbar;
                    (!a.lastBlock.tool.isDefault || !a.lastBlock.isEmpty) && a.insertAtEnd(), l.setToTheLastBlock(), c.moveAndOpen(a.lastBlock);
                }
            }
        },
        {
            /**
   * Handle selection changes on mobile devices
   * Uses for showing the Inline Toolbar
   */ key: "selectionChanged",
            value: function selectionChanged() {
                var _this_Editor = this.Editor, e = _this_Editor.CrossBlockSelection, t1 = _this_Editor.BlockSelection, o = $5bdbe1ebf6713620$var$b.anchorElement;
                if (e.isCrossBlockSelectionStarted && t1.anyBlockSelected && $5bdbe1ebf6713620$var$b.get().removeAllRanges(), !o) {
                    $5bdbe1ebf6713620$var$b.range || this.Editor.InlineToolbar.close();
                    return;
                }
                var i = o.closest(".".concat($5bdbe1ebf6713620$var$R.CSS.content));
                (i === null || i.closest(".".concat($5bdbe1ebf6713620$var$b.CSS.editorWrapper)) !== this.nodes.wrapper) && (this.Editor.InlineToolbar.containsNode(o) || this.Editor.InlineToolbar.close(), !(o.dataset.inlineToolbar === "true")) || (this.Editor.BlockManager.currentBlock || this.Editor.BlockManager.setCurrentBlockByChildNode(o), this.Editor.InlineToolbar.tryToShow(!0));
            }
        },
        {
            /**
   * Editor.js provides and ability to show placeholders for empty contenteditable elements
   *
   * This method watches for input and focus events and toggles 'data-empty' attribute
   * to workaroud the case, when inputs contains only <br>s and has no visible content
   * Then, CSS could rely on this attribute to show placeholders
   */ key: "enableInputsEmptyMark",
            value: function enableInputsEmptyMark() {
                function e(t1) {
                    var o = t1.target;
                    $5bdbe1ebf6713620$var$Do(o);
                }
                this.readOnlyMutableListeners.on(this.nodes.wrapper, "input", e), this.readOnlyMutableListeners.on(this.nodes.wrapper, "focusin", e), this.readOnlyMutableListeners.on(this.nodes.wrapper, "focusout", e);
            }
        }
    ]);
    return Ia;
}($5bdbe1ebf6713620$var$E);
var $5bdbe1ebf6713620$var$Oa = {
    // API Modules
    BlocksAPI: $5bdbe1ebf6713620$var$gi,
    CaretAPI: $5bdbe1ebf6713620$var$bi,
    EventsAPI: $5bdbe1ebf6713620$var$vi,
    I18nAPI: $5bdbe1ebf6713620$var$kt,
    API: $5bdbe1ebf6713620$var$ki,
    InlineToolbarAPI: $5bdbe1ebf6713620$var$yi,
    ListenersAPI: $5bdbe1ebf6713620$var$wi,
    NotifierAPI: $5bdbe1ebf6713620$var$Ci,
    ReadOnlyAPI: $5bdbe1ebf6713620$var$Ti,
    SanitizerAPI: $5bdbe1ebf6713620$var$Li,
    SaverAPI: $5bdbe1ebf6713620$var$Pi,
    SelectionAPI: $5bdbe1ebf6713620$var$Ni,
    ToolsAPI: $5bdbe1ebf6713620$var$Ri,
    StylesAPI: $5bdbe1ebf6713620$var$Di,
    ToolbarAPI: $5bdbe1ebf6713620$var$Fi,
    TooltipAPI: $5bdbe1ebf6713620$var$Ui,
    UiAPI: $5bdbe1ebf6713620$var$Wi,
    // Toolbar Modules
    BlockSettings: $5bdbe1ebf6713620$var$ms,
    Toolbar: $5bdbe1ebf6713620$var$Bs,
    InlineToolbar: $5bdbe1ebf6713620$var$Cs,
    // Modules
    BlockEvents: $5bdbe1ebf6713620$var$na,
    BlockManager: $5bdbe1ebf6713620$var$ra,
    BlockSelection: $5bdbe1ebf6713620$var$aa,
    Caret: $5bdbe1ebf6713620$var$Ye,
    CrossBlockSelection: $5bdbe1ebf6713620$var$la,
    DragNDrop: $5bdbe1ebf6713620$var$ca,
    ModificationsObserver: $5bdbe1ebf6713620$var$ha,
    Paste: $5bdbe1ebf6713620$var$pa,
    ReadOnly: $5bdbe1ebf6713620$var$fa,
    RectangleSelection: $5bdbe1ebf6713620$var$Be,
    Renderer: $5bdbe1ebf6713620$var$ga,
    Saver: $5bdbe1ebf6713620$var$ma,
    Tools: $5bdbe1ebf6713620$var$Wn,
    UI: $5bdbe1ebf6713620$var$Ia
};
var $5bdbe1ebf6713620$var$_a = /*#__PURE__*/ function() {
    "use strict";
    function _a(e) {
        var _this = this;
        (0, $173N4._)(this, _a);
        this.moduleInstances = {}, this.eventsDispatcher = new $5bdbe1ebf6713620$var$Oe();
        var t1, o;
        this.isReady = new Promise(function(i, s) {
            t1 = i, o = s;
        }), Promise.resolve().then(function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var _this_moduleInstances, i, s, r, a;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            this.configuration = e, this.validate(), this.init();
                            return [
                                4,
                                this.start()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                this.render()
                            ];
                        case 2:
                            _state.sent();
                            _this_moduleInstances = this.moduleInstances, i = _this_moduleInstances.BlockManager, s = _this_moduleInstances.Caret, r = _this_moduleInstances.UI, a = _this_moduleInstances.ModificationsObserver;
                            r.checkEmptiness(), a.enable(), this.configuration.autofocus === !0 && this.configuration.readOnly !== !0 && s.setToBlock(i.blocks[0], s.positions.START), t1();
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        }).catch(function(i) {
            $5bdbe1ebf6713620$var$S("Editor.js is not ready because of ".concat(i), "error"), o(i);
        });
    }
    (0, $cFHGC._)(_a, [
        {
            key: "configuration",
            get: /**
   * Returns private property
   *
   * @returns {EditorConfig}
   */ function get() {
                return this.config;
            },
            set: /**
   * Setting for configuration
   *
   * @param {EditorConfig|string} config - Editor's config to set
   */ function set(e) {
                var o, i;
                $5bdbe1ebf6713620$var$D(e) ? this.config = (0, $1XAnY._)({}, e) : this.config = {
                    holder: e
                }, $5bdbe1ebf6713620$var$ht(!!this.config.holderId, "config.holderId", "config.holder"), this.config.holderId && !this.config.holder && (this.config.holder = this.config.holderId, this.config.holderId = null), this.config.holder == null && (this.config.holder = "editorjs"), this.config.logLevel || (this.config.logLevel = $5bdbe1ebf6713620$var$Lo.VERBOSE), $5bdbe1ebf6713620$var$Zn(this.config.logLevel), $5bdbe1ebf6713620$var$ht(!!this.config.initialBlock, "config.initialBlock", "config.defaultBlock"), this.config.defaultBlock = this.config.defaultBlock || this.config.initialBlock || "paragraph", this.config.minHeight = this.config.minHeight !== void 0 ? this.config.minHeight : 300;
                var t1 = {
                    type: this.config.defaultBlock,
                    data: {}
                };
                this.config.placeholder = this.config.placeholder || !1, this.config.sanitizer = this.config.sanitizer || {
                    p: !0,
                    b: !0,
                    a: !0
                }, this.config.hideToolbar = this.config.hideToolbar ? this.config.hideToolbar : !1, this.config.tools = this.config.tools || {}, this.config.i18n = this.config.i18n || {}, this.config.data = this.config.data || {
                    blocks: []
                }, this.config.onReady = this.config.onReady || function() {}, this.config.onChange = this.config.onChange || function() {}, this.config.inlineToolbar = this.config.inlineToolbar !== void 0 ? this.config.inlineToolbar : !0, ($5bdbe1ebf6713620$var$V(this.config.data) || !this.config.data.blocks || this.config.data.blocks.length === 0) && (this.config.data = {
                    blocks: [
                        t1
                    ]
                }), this.config.readOnly = this.config.readOnly || !1, (o = this.config.i18n) != null && o.messages && $5bdbe1ebf6713620$var$z.setDictionary(this.config.i18n.messages), this.config.i18n.direction = ((i = this.config.i18n) == null ? void 0 : i.direction) || "ltr";
            }
        },
        {
            /**
   * Checks for required fields in Editor's config
   */ key: "validate",
            value: function validate() {
                var _this_config = this.config, e = _this_config.holderId, t1 = _this_config.holder;
                if (e && t1) throw Error("\xabholderId\xbb and \xabholder\xbb param can't assign at the same time.");
                if ($5bdbe1ebf6713620$var$te(t1) && !$5bdbe1ebf6713620$var$u.get(t1)) throw Error("element with ID \xab".concat(t1, "\xbb is missing. Pass correct holder's ID."));
                if (t1 && $5bdbe1ebf6713620$var$D(t1) && !$5bdbe1ebf6713620$var$u.isElement(t1)) throw Error("\xabholder\xbb value must be an Element node");
            }
        },
        {
            /**
   * Initializes modules:
   *  - make and save instances
   *  - configure
   */ key: "init",
            value: function init() {
                this.constructModules(), this.configureModules();
            }
        },
        {
            key: "start",
            value: /**
   * Start Editor!
   *
   * Get list of modules that needs to be prepared and return a sequence (Promise)
   *
   * @returns {Promise<void>}
   */ function start() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _this;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    [
                                        "Tools",
                                        "UI",
                                        "BlockManager",
                                        "Paste",
                                        "BlockSelection",
                                        "RectangleSelection",
                                        "CrossBlockSelection",
                                        "ReadOnly"
                                    ].reduce(function(t1, o) {
                                        return t1.then(function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                                var i;
                                                return (0, $13u2V._)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            _state.trys.push([
                                                                0,
                                                                2,
                                                                ,
                                                                3
                                                            ]);
                                                            return [
                                                                4,
                                                                this.moduleInstances[o].prepare()
                                                            ];
                                                        case 1:
                                                            _state.sent();
                                                            return [
                                                                3,
                                                                3
                                                            ];
                                                        case 2:
                                                            i = _state.sent();
                                                            if (i instanceof $5bdbe1ebf6713620$var$Ho) throw new Error(i.message);
                                                            $5bdbe1ebf6713620$var$S("Module ".concat(o, " was skipped because of %o"), "warn", i);
                                                            return [
                                                                3,
                                                                3
                                                            ];
                                                        case 3:
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            }).call(_this);
                                        });
                                    }, Promise.resolve())
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Render initial data
   */ key: "render",
            value: function render() {
                return this.moduleInstances.Renderer.render(this.config.data.blocks);
            }
        },
        {
            /**
   * Make modules instances and save it to the @property this.moduleInstances
   */ key: "constructModules",
            value: function constructModules() {
                var _this = this;
                Object.entries($5bdbe1ebf6713620$var$Oa).forEach(function(param) {
                    var _param = (0, $f9AOD._)(param, 2), e = _param[0], t1 = _param[1];
                    try {
                        _this.moduleInstances[e] = new t1({
                            config: _this.configuration,
                            eventsDispatcher: _this.eventsDispatcher
                        });
                    } catch (o) {
                        $5bdbe1ebf6713620$var$S("[constructModules]", "Module ".concat(e, " skipped because"), "error", o);
                    }
                });
            }
        },
        {
            /**
   * Modules instances configuration:
   *  - pass other modules to the 'state' property
   *  - ...
   */ key: "configureModules",
            value: function configureModules() {
                for(var e in this.moduleInstances)Object.prototype.hasOwnProperty.call(this.moduleInstances, e) && (this.moduleInstances[e].state = this.getModulesDiff(e));
            }
        },
        {
            /**
   * Return modules without passed name
   *
   * @param {string} name - module for witch modules difference should be calculated
   */ key: "getModulesDiff",
            value: function getModulesDiff(e) {
                var t1 = {};
                for(var o in this.moduleInstances)o !== e && (t1[o] = this.moduleInstances[o]);
                return t1;
            }
        }
    ]);
    return _a;
}();
/**
 * Editor.js
 *
 * @license Apache-2.0
 * @see Editor.js <https://editorjs.io>
 * @author CodeX Team <https://codex.so>
 */ var $5bdbe1ebf6713620$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Aa(e) {
        var _this = this;
        (0, $173N4._)(this, Aa);
        var t1 = function() {};
        $5bdbe1ebf6713620$var$D(e) && $5bdbe1ebf6713620$var$A(e.onReady) && (t1 = e.onReady);
        var o = new $5bdbe1ebf6713620$var$_a(e);
        this.isReady = o.isReady.then(function() {
            _this.exportAPI(o), t1();
        });
    }
    (0, $cFHGC._)(Aa, [
        {
            /**
   * Export external API methods
   *
   * @param {Core} editor — Editor's instance
   */ key: "exportAPI",
            value: function exportAPI(e) {
                var _this = this;
                var t1 = [
                    "configuration"
                ], o = function() {
                    Object.values(e.moduleInstances).forEach(function(s) {
                        $5bdbe1ebf6713620$var$A(s.destroy) && s.destroy(), s.listeners.removeAll();
                    }), $5bdbe1ebf6713620$var$zi(), e = null;
                    for(var s in _this)Object.prototype.hasOwnProperty.call(_this, s) && delete _this[s];
                    Object.setPrototypeOf(_this, null);
                };
                t1.forEach(function(s) {
                    _this[s] = e[s];
                }), this.destroy = o, Object.setPrototypeOf(this, e.moduleInstances.API.methods), delete this.exportAPI, Object.entries({
                    blocks: {
                        clear: "clear",
                        render: "render"
                    },
                    caret: {
                        focus: "focus"
                    },
                    events: {
                        on: "on",
                        off: "off",
                        emit: "emit"
                    },
                    saver: {
                        save: "save"
                    }
                }).forEach(function(param) {
                    var _param = (0, $f9AOD._)(param, 2), s = _param[0], r = _param[1];
                    Object.entries(r).forEach(function(param) {
                        var _param = (0, $f9AOD._)(param, 2), a = _param[0], l = _param[1];
                        _this[l] = e.moduleInstances.API.methods[s][a];
                    });
                });
            }
        }
    ], [
        {
            key: "version",
            get: /** Editor version */ function get() {
                return "2.31.6";
            }
        }
    ]);
    return Aa;
}();

});
parcelRegister("dWsrg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a266c07c539ac56a$export$71511d61b312f219; });

var $7BbpS = parcelRequire("7BbpS");
function $a266c07c539ac56a$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $a266c07c539ac56a$export$71511d61b312f219 = Reflect.get;
    else $a266c07c539ac56a$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $7BbpS._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $a266c07c539ac56a$export$71511d61b312f219(target, property, receiver || target);
}

});
parcelRegister("7BbpS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5884d826e884657a$export$71511d61b312f219; });

var $kg0zo = parcelRequire("kg0zo");
function $5884d826e884657a$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $kg0zo._)(object);
        if (object === null) break;
    }
    return object;
}

});



parcelRegister("5aDIn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59c40db05385952c$export$2e2bcd8739ae039; });

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");
(function() {
    "use strict";
    try {
        if ((typeof document === "undefined" ? "undefined" : (0, $7E0eS._)(document)) < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-paragraph{line-height:1.6em;outline:none}.ce-block:only-of-type .ce-paragraph[data-placeholder-active]:empty:before,.ce-block:only-of-type .ce-paragraph[data-placeholder-active][data-empty=true]:before{content:attr(data-placeholder-active)}.ce-paragraph p:first-of-type{margin-top:0}.ce-paragraph p:last-of-type{margin-bottom:0}")), document.head.appendChild(e);
        }
    } catch (a) {
        console.error("vite-plugin-css-injected-by-js", a);
    }
})();
var $59c40db05385952c$var$a = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 9V7.2C8 7.08954 8.08954 7 8.2 7L12 7M16 9V7.2C16 7.08954 15.9105 7 15.8 7L12 7M12 7L12 17M12 17H10M12 17H14"/></svg>';
function $59c40db05385952c$var$l(r) {
    var _e;
    var t = document.createElement("div");
    t.innerHTML = r.trim();
    var e = document.createDocumentFragment();
    return (_e = e).append.apply(_e, (0, $aUGqu._)(Array.from(t.childNodes))), e;
}
/**
 * Base Paragraph Block for the Editor.js.
 * Represents a regular text block
 *
 * @author CodeX (team@codex.so)
 * @copyright CodeX 2018
 * @license The MIT License (MIT)
 */ var $59c40db05385952c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function n(param) {
        var t = param.data, e = param.config, i = param.api, s = param.readOnly;
        (0, $173N4._)(this, n);
        var _e_preserveBlank;
        this.api = i, this.readOnly = s, this._CSS = {
            block: this.api.styles.block,
            wrapper: "ce-paragraph"
        }, this.readOnly || (this.onKeyUp = this.onKeyUp.bind(this)), this._placeholder = e.placeholder ? e.placeholder : n.DEFAULT_PLACEHOLDER, this._data = t !== null && t !== void 0 ? t : {}, this._element = null, this._preserveBlank = (_e_preserveBlank = e.preserveBlank) !== null && _e_preserveBlank !== void 0 ? _e_preserveBlank : !1;
    }
    (0, $cFHGC._)(n, [
        {
            /**
   * Check if text content is empty and set empty string to inner html.
   * We need this because some browsers (e.g. Safari) insert <br> into empty contenteditanle elements
   *
   * @param {KeyboardEvent} e - key up event
   */ key: "onKeyUp",
            value: function onKeyUp(t) {
                if (t.code !== "Backspace" && t.code !== "Delete" || !this._element) return;
                var _this__element = this._element, e = _this__element.textContent;
                e === "" && (this._element.innerHTML = "");
            }
        },
        {
            /**
   * Create Tool's view
   *
   * @returns {HTMLDivElement}
   * @private
   */ key: "drawView",
            value: function drawView() {
                var t = document.createElement("DIV");
                return t.classList.add(this._CSS.wrapper, this._CSS.block), t.contentEditable = "false", t.dataset.placeholderActive = this.api.i18n.t(this._placeholder), this._data.text && (t.innerHTML = this._data.text), this.readOnly || (t.contentEditable = "true", t.addEventListener("keyup", this.onKeyUp)), t;
            }
        },
        {
            /**
   * Return Tool's view
   *
   * @returns {HTMLDivElement}
   */ key: "render",
            value: function render() {
                return this._element = this.drawView(), this._element;
            }
        },
        {
            /**
   * Method that specified how to merge two Text blocks.
   * Called by Editor.js by backspace at the beginning of the Block
   *
   * @param {ParagraphData} data
   * @public
   */ key: "merge",
            value: function merge(t) {
                if (!this._element) return;
                this._data.text += t.text;
                var e = $59c40db05385952c$var$l(t.text);
                this._element.appendChild(e), this._element.normalize();
            }
        },
        {
            /**
   * Validate Paragraph block data:
   * - check for emptiness
   *
   * @param {ParagraphData} savedData — data received after saving
   * @returns {boolean} false if saved data is not correct, otherwise true
   * @public
   */ key: "validate",
            value: function validate(t) {
                return !(t.text.trim() === "" && !this._preserveBlank);
            }
        },
        {
            /**
   * Extract Tool's data from the view
   *
   * @param {HTMLDivElement} toolsContent - Paragraph tools rendered view
   * @returns {ParagraphData} - saved data
   * @public
   */ key: "save",
            value: function save(t) {
                return {
                    text: t.innerHTML
                };
            }
        },
        {
            /**
   * On paste callback fired from Editor.
   *
   * @param {HTMLPasteEvent} event - event with pasted data
   */ key: "onPaste",
            value: function onPaste(t) {
                var _this = this;
                var e = {
                    text: t.detail.data.innerHTML
                };
                this._data = e, window.requestAnimationFrame(function() {
                    _this._element && (_this._element.innerHTML = _this._data.text || "");
                });
            }
        }
    ], [
        {
            key: "DEFAULT_PLACEHOLDER",
            get: /**
   * Default placeholder for Paragraph Tool
   *
   * @returns {string}
   * @class
   */ function get() {
                return "";
            }
        },
        {
            key: "conversionConfig",
            get: /**
   * Enable Conversion Toolbar. Paragraph can be converted to/from other tools
   * @returns {ConversionConfig}
   */ function get() {
                return {
                    export: "text",
                    // to convert Paragraph to other block, use 'text' property of saved data
                    import: "text"
                };
            }
        },
        {
            key: "sanitize",
            get: /**
   * Sanitizer rules
   * @returns {SanitizerConfig} - Edtior.js sanitizer config
   */ function get() {
                return {
                    text: {
                        br: !0
                    }
                };
            }
        },
        {
            key: "isReadOnlySupported",
            get: /**
   * Returns true to notify the core that read-only mode is supported
   *
   * @returns {boolean}
   */ function get() {
                return !0;
            }
        },
        {
            key: "pasteConfig",
            get: /**
   * Used by Editor paste handling API.
   * Provides configuration to handle P tags.
   *
   * @returns {PasteConfig} - Paragraph Paste Setting
   */ function get() {
                return {
                    tags: [
                        "P"
                    ]
                };
            }
        },
        {
            key: "toolbox",
            get: /**
   * Icon and title for displaying at the Toolbox
   *
   * @returns {ToolboxConfig} - Paragraph Toolbox Setting
   */ function get() {
                return {
                    icon: $59c40db05385952c$var$a,
                    title: "Text"
                };
            }
        }
    ]);
    return n;
}();

});


parcelRegister("3ALtG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $29d98ffe53ae724f$export$2e2bcd8739ae039; });

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $13u2V = parcelRequire("13u2V");

var $1aLYV = parcelRequire("1aLYV");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $29d98ffe53ae724f$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $29d98ffe53ae724f$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $29d98ffe53ae724f$var$ReactEditorJS(_a) {
    var factory = _a.factory, holder = _a.holder, defaultValue = _a.defaultValue, children = _a.children, value = _a.value, onInitialize = _a.onInitialize, restProps = $29d98ffe53ae724f$var$__rest(_a, [
        "factory",
        "holder",
        "defaultValue",
        "children",
        "value",
        "onInitialize"
    ]);
    var memoizedHolder = (0, $1aLYV.default).useRef(holder !== null && holder !== void 0 ? holder : "react-editor-js-".concat(Date.now().toString(16)));
    var editorJS = (0, $1aLYV.default).useRef(null);
    (0, $1aLYV.default).useEffect(function() {
        editorJS.current = factory(Object.assign(Object.assign({
            holder: memoizedHolder.current
        }, defaultValue && {
            data: defaultValue
        }), restProps));
        onInitialize === null || onInitialize === void 0 || onInitialize(editorJS.current);
        return function() {
            var _$_a;
            (_$_a = editorJS.current) === null || _$_a === void 0 || _$_a.destroy();
        };
    }, []);
    (0, $1aLYV.default).useEffect(function() {
        var _$_a;
        if (value) (_$_a = editorJS.current) === null || _$_a === void 0 || _$_a.render(value);
    }, [
        value
    ]);
    return children || (0, $1aLYV.default).createElement("div", {
        id: memoizedHolder.current
    });
}
var $29d98ffe53ae724f$var$ServerEditorCore = /*#__PURE__*/ function() {
    "use strict";
    function ServerEditorCore(param) {
        var data = param.data;
        (0, $173N4._)(this, ServerEditorCore);
        if (data) this._memoizedData = data;
    }
    (0, $cFHGC._)(ServerEditorCore, [
        {
            key: "dangerouslyLowLevelInstance",
            get: function get() {
                return null;
            }
        },
        {
            key: "clear",
            value: function clear() {
                return $29d98ffe53ae724f$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $13u2V._)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                });
            }
        },
        {
            key: "save",
            value: function save() {
                return $29d98ffe53ae724f$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $13u2V._)(this, function(_state) {
                        return [
                            2,
                            this._memoizedData
                        ];
                    });
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                return $29d98ffe53ae724f$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $13u2V._)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return $29d98ffe53ae724f$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $13u2V._)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                });
            }
        }
    ]);
    return ServerEditorCore;
}();
function $29d98ffe53ae724f$export$2e2bcd8739ae039(props) {
    var factory = (0, $1aLYV.default).useCallback(function(config) {
        return new $29d98ffe53ae724f$var$ServerEditorCore(config);
    }, []);
    return (0, $1aLYV.default).createElement($29d98ffe53ae724f$var$ReactEditorJS, Object.assign({
        factory: factory
    }, props));
}

});

parcelRegister("lR0Op", function(module, exports) {

var $7E0eS = parcelRequire("7E0eS");

var $9iKK3 = parcelRequire("9iKK3");
var $fe8f2d71ebd2399b$require$Buffer = $9iKK3.Buffer;
"use strict";
/**
 * This module defines nodes used to define types and validations for objects and interfaces.
 */ // tslint:disable:no-shadowed-variable prefer-for-of
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.basicTypes = exports.BasicType = exports.TParamList = exports.TParam = exports.param = exports.TFunc = exports.func = exports.TProp = exports.TOptional = exports.opt = exports.TIface = exports.iface = exports.TEnumLiteral = exports.enumlit = exports.TEnumType = exports.enumtype = exports.TIntersection = exports.intersection = exports.TUnion = exports.union = exports.TTuple = exports.tuple = exports.TArray = exports.array = exports.TLiteral = exports.lit = exports.TName = exports.name = exports.TType = void 0;

var $5Qkok = parcelRequire("5Qkok");
/** Node that represents a type. */ var TType = /** @class */ function() {
    function TType() {}
    return TType;
}();
exports.TType = TType;
/** Parses a type spec into a TType node. */ function parseSpec(typeSpec) {
    return typeof typeSpec === "string" ? name(typeSpec) : typeSpec;
}
function getNamedType(suite, name) {
    var ttype = suite[name];
    if (!ttype) throw new Error("Unknown type " + name);
    return ttype;
}
/**
 * Defines a type name, either built-in, or defined in this suite. It can typically be included in
 * the specs as just a plain string.
 */ function name(value) {
    return new TName(value);
}
exports.name = name;
var TName = /** @class */ function(_super) {
    __extends(TName, _super);
    function TName(name) {
        var _this = _super.call(this) || this;
        _this.name = name;
        _this._failMsg = "is not a " + name;
        return _this;
    }
    TName.prototype.getChecker = function(suite, strict, allowedProps) {
        var _this = this;
        var ttype = getNamedType(suite, this.name);
        var checker = ttype.getChecker(suite, strict, allowedProps);
        if (ttype instanceof BasicType || ttype instanceof TName) return checker;
        // For complex types, add an additional "is not a <Type>" message on failure.
        return function(value, ctx) {
            return checker(value, ctx) ? true : ctx.fail(null, _this._failMsg, 0);
        };
    };
    return TName;
}(TType);
exports.TName = TName;
/**
 * Defines a literal value, e.g. lit('hello') or lit(123).
 */ function lit(value) {
    return new TLiteral(value);
}
exports.lit = lit;
var TLiteral = /** @class */ function(_super) {
    __extends(TLiteral, _super);
    function TLiteral(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        _this.name = JSON.stringify(value);
        _this._failMsg = "is not " + _this.name;
        return _this;
    }
    TLiteral.prototype.getChecker = function(suite, strict) {
        var _this = this;
        return function(value, ctx) {
            return value === _this.value ? true : ctx.fail(null, _this._failMsg, -1);
        };
    };
    return TLiteral;
}(TType);
exports.TLiteral = TLiteral;
/**
 * Defines an array type, e.g. array('number').
 */ function array(typeSpec) {
    return new TArray(parseSpec(typeSpec));
}
exports.array = array;
var TArray = /** @class */ function(_super) {
    __extends(TArray, _super);
    function TArray(ttype) {
        var _this = _super.call(this) || this;
        _this.ttype = ttype;
        return _this;
    }
    TArray.prototype.getChecker = function(suite, strict) {
        var itemChecker = this.ttype.getChecker(suite, strict);
        return function(value, ctx) {
            if (!Array.isArray(value)) return ctx.fail(null, "is not an array", 0);
            for(var i = 0; i < value.length; i++){
                var ok = itemChecker(value[i], ctx);
                if (!ok) return ctx.fail(i, null, 1);
            }
            return true;
        };
    };
    return TArray;
}(TType);
exports.TArray = TArray;
/**
 * Defines a tuple type, e.g. tuple('string', 'number').
 */ function tuple() {
    var typeSpec = [];
    for(var _i = 0; _i < arguments.length; _i++)typeSpec[_i] = arguments[_i];
    return new TTuple(typeSpec.map(function(t) {
        return parseSpec(t);
    }));
}
exports.tuple = tuple;
var TTuple = /** @class */ function(_super) {
    __extends(TTuple, _super);
    function TTuple(ttypes) {
        var _this = _super.call(this) || this;
        _this.ttypes = ttypes;
        return _this;
    }
    TTuple.prototype.getChecker = function(suite, strict) {
        var itemCheckers = this.ttypes.map(function(t) {
            return t.getChecker(suite, strict);
        });
        var checker = function checker(value, ctx) {
            if (!Array.isArray(value)) return ctx.fail(null, "is not an array", 0);
            for(var i = 0; i < itemCheckers.length; i++){
                var ok = itemCheckers[i](value[i], ctx);
                if (!ok) return ctx.fail(i, null, 1);
            }
            return true;
        };
        if (!strict) return checker;
        return function(value, ctx) {
            if (!checker(value, ctx)) return false;
            return value.length <= itemCheckers.length ? true : ctx.fail(itemCheckers.length, "is extraneous", 2);
        };
    };
    return TTuple;
}(TType);
exports.TTuple = TTuple;
/**
 * Defines a union type, e.g. union('number', 'null').
 */ function union() {
    var typeSpec = [];
    for(var _i = 0; _i < arguments.length; _i++)typeSpec[_i] = arguments[_i];
    return new TUnion(typeSpec.map(function(t) {
        return parseSpec(t);
    }));
}
exports.union = union;
var TUnion = /** @class */ function(_super) {
    __extends(TUnion, _super);
    function TUnion(ttypes) {
        var _this = _super.call(this) || this;
        _this.ttypes = ttypes;
        var names = ttypes.map(function(t) {
            return t instanceof TName || t instanceof TLiteral ? t.name : null;
        }).filter(function(n) {
            return n;
        });
        var otherTypes = ttypes.length - names.length;
        if (names.length) {
            if (otherTypes > 0) names.push(otherTypes + " more");
            _this._failMsg = "is none of " + names.join(", ");
        } else _this._failMsg = "is none of " + otherTypes + " types";
        return _this;
    }
    TUnion.prototype.getChecker = function(suite, strict) {
        var _this = this;
        var itemCheckers = this.ttypes.map(function(t) {
            return t.getChecker(suite, strict);
        });
        return function(value, ctx) {
            var ur = ctx.unionResolver();
            for(var i = 0; i < itemCheckers.length; i++){
                var ok = itemCheckers[i](value, ur.createContext());
                if (ok) return true;
            }
            ctx.resolveUnion(ur);
            return ctx.fail(null, _this._failMsg, 0);
        };
    };
    return TUnion;
}(TType);
exports.TUnion = TUnion;
/**
 * Defines an intersection type, e.g. intersection('number', 'null').
 */ function intersection() {
    var typeSpec = [];
    for(var _i = 0; _i < arguments.length; _i++)typeSpec[_i] = arguments[_i];
    return new TIntersection(typeSpec.map(function(t) {
        return parseSpec(t);
    }));
}
exports.intersection = intersection;
var TIntersection = /** @class */ function(_super) {
    __extends(TIntersection, _super);
    function TIntersection(ttypes) {
        var _this = _super.call(this) || this;
        _this.ttypes = ttypes;
        return _this;
    }
    TIntersection.prototype.getChecker = function(suite, strict) {
        var allowedProps = new Set();
        var itemCheckers = this.ttypes.map(function(t) {
            return t.getChecker(suite, strict, allowedProps);
        });
        return function(value, ctx) {
            var ok = itemCheckers.every(function(checker) {
                return checker(value, ctx);
            });
            if (ok) return true;
            return ctx.fail(null, null, 0);
        };
    };
    return TIntersection;
}(TType);
exports.TIntersection = TIntersection;
/**
 * Defines an enum type, e.g. enum({'A': 1, 'B': 2}).
 */ function enumtype(values) {
    return new TEnumType(values);
}
exports.enumtype = enumtype;
var TEnumType = /** @class */ function(_super) {
    __extends(TEnumType, _super);
    function TEnumType(members) {
        var _this = _super.call(this) || this;
        _this.members = members;
        _this.validValues = new Set();
        _this._failMsg = "is not a valid enum value";
        _this.validValues = new Set(Object.keys(members).map(function(name) {
            return members[name];
        }));
        return _this;
    }
    TEnumType.prototype.getChecker = function(suite, strict) {
        var _this = this;
        return function(value, ctx) {
            return _this.validValues.has(value) ? true : ctx.fail(null, _this._failMsg, 0);
        };
    };
    return TEnumType;
}(TType);
exports.TEnumType = TEnumType;
/**
 * Defines a literal enum value, such as Direction.Up, specified as enumlit("Direction", "Up").
 */ function enumlit(name, prop) {
    return new TEnumLiteral(name, prop);
}
exports.enumlit = enumlit;
var TEnumLiteral = /** @class */ function(_super) {
    __extends(TEnumLiteral, _super);
    function TEnumLiteral(enumName, prop) {
        var _this = _super.call(this) || this;
        _this.enumName = enumName;
        _this.prop = prop;
        _this._failMsg = "is not " + enumName + "." + prop;
        return _this;
    }
    TEnumLiteral.prototype.getChecker = function(suite, strict) {
        var _this = this;
        var ttype = getNamedType(suite, this.enumName);
        if (!(ttype instanceof TEnumType)) throw new Error("Type " + this.enumName + " used in enumlit is not an enum type");
        var val = ttype.members[this.prop];
        if (!ttype.members.hasOwnProperty(this.prop)) throw new Error("Unknown value " + this.enumName + "." + this.prop + " used in enumlit");
        return function(value, ctx) {
            return value === val ? true : ctx.fail(null, _this._failMsg, -1);
        };
    };
    return TEnumLiteral;
}(TType);
exports.TEnumLiteral = TEnumLiteral;
function makeIfaceProps(props) {
    return Object.keys(props).map(function(name) {
        return makeIfaceProp(name, props[name]);
    });
}
function makeIfaceProp(name, prop) {
    return prop instanceof TOptional ? new TProp(name, prop.ttype, true) : new TProp(name, parseSpec(prop), false);
}
/**
 * Defines an interface. The first argument is an array of interfaces that it extends, and the
 * second is an array of properties.
 */ function iface(bases, props) {
    return new TIface(bases, makeIfaceProps(props));
}
exports.iface = iface;
var TIface = /** @class */ function(_super) {
    __extends(TIface, _super);
    function TIface(bases, props) {
        var _this = _super.call(this) || this;
        _this.bases = bases;
        _this.props = props;
        _this.propSet = new Set(props.map(function(p) {
            return p.name;
        }));
        return _this;
    }
    TIface.prototype.getChecker = function(suite, strict, allowedProps) {
        var _this = this;
        var baseCheckers = this.bases.map(function(b) {
            return getNamedType(suite, b).getChecker(suite, strict);
        });
        var propCheckers = this.props.map(function(prop) {
            return prop.ttype.getChecker(suite, strict);
        });
        var testCtx = new $5Qkok.NoopContext();
        // Consider a prop required if it's not optional AND does not allow for undefined as a value.
        var isPropRequired = this.props.map(function(prop, i) {
            return !prop.isOpt && !propCheckers[i](undefined, testCtx);
        });
        var checker = function checker(value, ctx) {
            if ((typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) !== "object" || value === null) return ctx.fail(null, "is not an object", 0);
            for(var i = 0; i < baseCheckers.length; i++){
                if (!baseCheckers[i](value, ctx)) return false;
            }
            for(var i = 0; i < propCheckers.length; i++){
                var name_1 = _this.props[i].name;
                var v = value[name_1];
                if (v === undefined) {
                    if (isPropRequired[i]) return ctx.fail(name_1, "is missing", 1);
                } else {
                    var ok = propCheckers[i](v, ctx);
                    if (!ok) return ctx.fail(name_1, null, 1);
                }
            }
            return true;
        };
        if (!strict) return checker;
        var propSet = this.propSet;
        if (allowedProps) {
            this.propSet.forEach(function(prop) {
                return allowedProps.add(prop);
            });
            propSet = allowedProps;
        }
        // In strict mode, check also for unknown enumerable properties.
        return function(value, ctx) {
            if (!checker(value, ctx)) return false;
            for(var prop in value){
                if (!propSet.has(prop)) return ctx.fail(prop, "is extraneous", 2);
            }
            return true;
        };
    };
    return TIface;
}(TType);
exports.TIface = TIface;
/**
 * Defines an optional property on an interface.
 */ function opt(typeSpec) {
    return new TOptional(parseSpec(typeSpec));
}
exports.opt = opt;
var TOptional = /** @class */ function(_super) {
    __extends(TOptional, _super);
    function TOptional(ttype) {
        var _this = _super.call(this) || this;
        _this.ttype = ttype;
        return _this;
    }
    TOptional.prototype.getChecker = function(suite, strict) {
        var itemChecker = this.ttype.getChecker(suite, strict);
        return function(value, ctx) {
            return value === undefined || itemChecker(value, ctx);
        };
    };
    return TOptional;
}(TType);
exports.TOptional = TOptional;
/**
 * Defines a property in an interface.
 */ var TProp = /** @class */ function() {
    function TProp(name, ttype, isOpt) {
        this.name = name;
        this.ttype = ttype;
        this.isOpt = isOpt;
    }
    return TProp;
}();
exports.TProp = TProp;
/**
 * Defines a function. The first argument declares the function's return type, the rest declare
 * its parameters.
 */ function func(resultSpec) {
    var params = [];
    for(var _i = 1; _i < arguments.length; _i++)params[_i - 1] = arguments[_i];
    return new TFunc(new TParamList(params), parseSpec(resultSpec));
}
exports.func = func;
var TFunc = /** @class */ function(_super) {
    __extends(TFunc, _super);
    function TFunc(paramList, result) {
        var _this = _super.call(this) || this;
        _this.paramList = paramList;
        _this.result = result;
        return _this;
    }
    TFunc.prototype.getChecker = function(suite, strict) {
        return function(value, ctx) {
            return typeof value === "function" ? true : ctx.fail(null, "is not a function", 0);
        };
    };
    return TFunc;
}(TType);
exports.TFunc = TFunc;
/**
 * Defines a function parameter.
 */ function param(name, typeSpec, isOpt) {
    return new TParam(name, parseSpec(typeSpec), Boolean(isOpt));
}
exports.param = param;
var TParam = /** @class */ function() {
    function TParam(name, ttype, isOpt) {
        this.name = name;
        this.ttype = ttype;
        this.isOpt = isOpt;
    }
    return TParam;
}();
exports.TParam = TParam;
/**
 * Defines a function parameter list.
 */ var TParamList = /** @class */ function(_super) {
    __extends(TParamList, _super);
    function TParamList(params) {
        var _this = _super.call(this) || this;
        _this.params = params;
        return _this;
    }
    TParamList.prototype.getChecker = function(suite, strict) {
        var _this = this;
        var itemCheckers = this.params.map(function(t) {
            return t.ttype.getChecker(suite, strict);
        });
        var testCtx = new $5Qkok.NoopContext();
        var isParamRequired = this.params.map(function(param, i) {
            return !param.isOpt && !itemCheckers[i](undefined, testCtx);
        });
        var checker = function checker(value, ctx) {
            if (!Array.isArray(value)) return ctx.fail(null, "is not an array", 0);
            for(var i = 0; i < itemCheckers.length; i++){
                var p = _this.params[i];
                if (value[i] === undefined) {
                    if (isParamRequired[i]) return ctx.fail(p.name, "is missing", 1);
                } else {
                    var ok = itemCheckers[i](value[i], ctx);
                    if (!ok) return ctx.fail(p.name, null, 1);
                }
            }
            return true;
        };
        if (!strict) return checker;
        return function(value, ctx) {
            if (!checker(value, ctx)) return false;
            return value.length <= itemCheckers.length ? true : ctx.fail(itemCheckers.length, "is extraneous", 2);
        };
    };
    return TParamList;
}(TType);
exports.TParamList = TParamList;
/**
 * Single TType implementation for all basic built-in types.
 */ var BasicType = /** @class */ function(_super) {
    __extends(BasicType, _super);
    function BasicType(validator, message) {
        var _this = _super.call(this) || this;
        _this.validator = validator;
        _this.message = message;
        return _this;
    }
    BasicType.prototype.getChecker = function(suite, strict) {
        var _this = this;
        return function(value, ctx) {
            return _this.validator(value) ? true : ctx.fail(null, _this.message, 0);
        };
    };
    return BasicType;
}(TType);
exports.BasicType = BasicType;
/**
 * Defines the suite of basic types.
 */ exports.basicTypes = {
    any: new BasicType(function(v) {
        return true;
    }, "is invalid"),
    number: new BasicType(function(v) {
        return typeof v === "number";
    }, "is not a number"),
    object: new BasicType(function(v) {
        return (typeof v === "undefined" ? "undefined" : (0, $7E0eS._)(v)) === "object" && v;
    }, "is not an object"),
    boolean: new BasicType(function(v) {
        return typeof v === "boolean";
    }, "is not a boolean"),
    string: new BasicType(function(v) {
        return typeof v === "string";
    }, "is not a string"),
    symbol: new BasicType(function(v) {
        return (typeof v === "undefined" ? "undefined" : (0, $7E0eS._)(v)) === "symbol";
    }, "is not a symbol"),
    void: new BasicType(function(v) {
        return v == null;
    }, "is not void"),
    undefined: new BasicType(function(v) {
        return v === undefined;
    }, "is not undefined"),
    null: new BasicType(function(v) {
        return v === null;
    }, "is not null"),
    never: new BasicType(function(v) {
        return false;
    }, "is unexpected"),
    Date: new BasicType(getIsNativeChecker("[object Date]"), "is not a Date"),
    RegExp: new BasicType(getIsNativeChecker("[object RegExp]"), "is not a RegExp")
};
// This approach for checking native object types mirrors that of lodash. Its advantage over
// `isinstance` is that it can still return true for native objects created in different JS
// execution environments.
var nativeToString = Object.prototype.toString;
function getIsNativeChecker(tag) {
    return function(v) {
        return (typeof v === "undefined" ? "undefined" : (0, $7E0eS._)(v)) === "object" && v && nativeToString.call(v) === tag;
    };
}
if (typeof $fe8f2d71ebd2399b$require$Buffer !== "undefined") exports.basicTypes.Buffer = new BasicType(function(v) {
    return $fe8f2d71ebd2399b$require$Buffer.isBuffer(v);
}, "is not a Buffer");
var _loop_1 = function _loop_1(array_1) {
    exports.basicTypes[array_1.name] = new BasicType(function(v) {
        return v instanceof array_1;
    }, "is not a " + array_1.name);
};
// Support typed arrays of various flavors
for(var _i = 0, _a = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array,
    ArrayBuffer
]; _i < _a.length; _i++){
    var array_1 = _a[_i];
    _loop_1(array_1);
}

});
parcelRegister("9iKK3", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $6c5a0d6caccac2f9$export$a143d493d941bafc; }, function (v) { return $6c5a0d6caccac2f9$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $6c5a0d6caccac2f9$export$f99ded8fe4b79145; }, function (v) { return $6c5a0d6caccac2f9$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");

var $7E0eS = parcelRequire("7E0eS");
var $6c5a0d6caccac2f9$export$a143d493d941bafc;
var $6c5a0d6caccac2f9$export$e4cf37d7f6fb9e0a;
var $6c5a0d6caccac2f9$export$f99ded8fe4b79145;
var $6c5a0d6caccac2f9$export$599f31c3813fae4d;
'use strict';

var $cOFqU = parcelRequire("cOFqU");

var $lqFFf = parcelRequire("lqFFf");
var $6c5a0d6caccac2f9$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$6c5a0d6caccac2f9$export$a143d493d941bafc = $6c5a0d6caccac2f9$var$Buffer;
$6c5a0d6caccac2f9$export$e4cf37d7f6fb9e0a = $6c5a0d6caccac2f9$var$SlowBuffer;
$6c5a0d6caccac2f9$export$f99ded8fe4b79145 = 50;
var $6c5a0d6caccac2f9$var$K_MAX_LENGTH = 0x7fffffff;
$6c5a0d6caccac2f9$export$599f31c3813fae4d = $6c5a0d6caccac2f9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $6c5a0d6caccac2f9$var$Buffer.TYPED_ARRAY_SUPPORT = $6c5a0d6caccac2f9$var$typedArraySupport();
if (!$6c5a0d6caccac2f9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $6c5a0d6caccac2f9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($6c5a0d6caccac2f9$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($6c5a0d6caccac2f9$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $6c5a0d6caccac2f9$var$createBuffer(length) {
    if (length > $6c5a0d6caccac2f9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $6c5a0d6caccac2f9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $6c5a0d6caccac2f9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $6c5a0d6caccac2f9$var$allocUnsafe(arg);
    }
    return $6c5a0d6caccac2f9$var$from(arg, encodingOrOffset, length);
}
$6c5a0d6caccac2f9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $6c5a0d6caccac2f9$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $6c5a0d6caccac2f9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $6c5a0d6caccac2f9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)));
    if ($6c5a0d6caccac2f9$var$isInstance(value, ArrayBuffer) || value && $6c5a0d6caccac2f9$var$isInstance(value.buffer, ArrayBuffer)) return $6c5a0d6caccac2f9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($6c5a0d6caccac2f9$var$isInstance(value, SharedArrayBuffer) || value && $6c5a0d6caccac2f9$var$isInstance(value.buffer, SharedArrayBuffer))) return $6c5a0d6caccac2f9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $6c5a0d6caccac2f9$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $6c5a0d6caccac2f9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $6c5a0d6caccac2f9$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $6c5a0d6caccac2f9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $6c5a0d6caccac2f9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($6c5a0d6caccac2f9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($6c5a0d6caccac2f9$var$Buffer, Uint8Array);
function $6c5a0d6caccac2f9$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $6c5a0d6caccac2f9$var$alloc(size, fill, encoding) {
    $6c5a0d6caccac2f9$var$assertSize(size);
    if (size <= 0) return $6c5a0d6caccac2f9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $6c5a0d6caccac2f9$var$createBuffer(size).fill(fill, encoding) : $6c5a0d6caccac2f9$var$createBuffer(size).fill(fill);
    return $6c5a0d6caccac2f9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $6c5a0d6caccac2f9$var$Buffer.alloc = function(size, fill, encoding) {
    return $6c5a0d6caccac2f9$var$alloc(size, fill, encoding);
};
function $6c5a0d6caccac2f9$var$allocUnsafe(size) {
    $6c5a0d6caccac2f9$var$assertSize(size);
    return $6c5a0d6caccac2f9$var$createBuffer(size < 0 ? 0 : $6c5a0d6caccac2f9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $6c5a0d6caccac2f9$var$Buffer.allocUnsafe = function(size) {
    return $6c5a0d6caccac2f9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $6c5a0d6caccac2f9$var$Buffer.allocUnsafeSlow = function(size) {
    return $6c5a0d6caccac2f9$var$allocUnsafe(size);
};
function $6c5a0d6caccac2f9$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$6c5a0d6caccac2f9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $6c5a0d6caccac2f9$var$byteLength(string, encoding) | 0;
    var buf = $6c5a0d6caccac2f9$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $6c5a0d6caccac2f9$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $6c5a0d6caccac2f9$var$checked(array.length) | 0;
    var buf = $6c5a0d6caccac2f9$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $6c5a0d6caccac2f9$var$fromArrayView(arrayView) {
    if ($6c5a0d6caccac2f9$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $6c5a0d6caccac2f9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $6c5a0d6caccac2f9$var$fromArrayLike(arrayView);
}
function $6c5a0d6caccac2f9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $6c5a0d6caccac2f9$var$Buffer.prototype);
    return buf;
}
function $6c5a0d6caccac2f9$var$fromObject(obj) {
    if ($6c5a0d6caccac2f9$var$Buffer.isBuffer(obj)) {
        var len = $6c5a0d6caccac2f9$var$checked(obj.length) | 0;
        var buf = $6c5a0d6caccac2f9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $6c5a0d6caccac2f9$var$numberIsNaN(obj.length)) return $6c5a0d6caccac2f9$var$createBuffer(0);
        return $6c5a0d6caccac2f9$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $6c5a0d6caccac2f9$var$fromArrayLike(obj.data);
}
function $6c5a0d6caccac2f9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $6c5a0d6caccac2f9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $6c5a0d6caccac2f9$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $6c5a0d6caccac2f9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $6c5a0d6caccac2f9$var$Buffer.alloc(+length);
}
$6c5a0d6caccac2f9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $6c5a0d6caccac2f9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$6c5a0d6caccac2f9$var$Buffer.compare = function compare(a, b) {
    if ($6c5a0d6caccac2f9$var$isInstance(a, Uint8Array)) a = $6c5a0d6caccac2f9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($6c5a0d6caccac2f9$var$isInstance(b, Uint8Array)) b = $6c5a0d6caccac2f9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(a) || !$6c5a0d6caccac2f9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$6c5a0d6caccac2f9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$6c5a0d6caccac2f9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $6c5a0d6caccac2f9$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $6c5a0d6caccac2f9$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($6c5a0d6caccac2f9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(buf)) buf = $6c5a0d6caccac2f9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $6c5a0d6caccac2f9$var$byteLength(string, encoding) {
    if ($6c5a0d6caccac2f9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $6c5a0d6caccac2f9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $7E0eS._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $6c5a0d6caccac2f9$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $6c5a0d6caccac2f9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $6c5a0d6caccac2f9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$6c5a0d6caccac2f9$var$Buffer.byteLength = $6c5a0d6caccac2f9$var$byteLength;
function $6c5a0d6caccac2f9$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $6c5a0d6caccac2f9$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $6c5a0d6caccac2f9$var$utf8Slice(this, start, end);
        case 'ascii':
            return $6c5a0d6caccac2f9$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $6c5a0d6caccac2f9$var$latin1Slice(this, start, end);
        case 'base64':
            return $6c5a0d6caccac2f9$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6c5a0d6caccac2f9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$6c5a0d6caccac2f9$var$Buffer.prototype._isBuffer = true;
function $6c5a0d6caccac2f9$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$6c5a0d6caccac2f9$var$swap(this, i, i + 1);
    return this;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $6c5a0d6caccac2f9$var$swap(this, i, i + 3);
        $6c5a0d6caccac2f9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $6c5a0d6caccac2f9$var$swap(this, i, i + 7);
        $6c5a0d6caccac2f9$var$swap(this, i + 1, i + 6);
        $6c5a0d6caccac2f9$var$swap(this, i + 2, i + 5);
        $6c5a0d6caccac2f9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $6c5a0d6caccac2f9$var$utf8Slice(this, 0, length);
    return $6c5a0d6caccac2f9$var$slowToString.apply(this, arguments);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.toLocaleString = $6c5a0d6caccac2f9$var$Buffer.prototype.toString;
$6c5a0d6caccac2f9$var$Buffer.prototype.equals = function equals(b) {
    if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $6c5a0d6caccac2f9$var$Buffer.compare(this, b) === 0;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $6c5a0d6caccac2f9$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($6c5a0d6caccac2f9$var$customInspectSymbol) $6c5a0d6caccac2f9$var$Buffer.prototype[$6c5a0d6caccac2f9$var$customInspectSymbol] = $6c5a0d6caccac2f9$var$Buffer.prototype.inspect;
$6c5a0d6caccac2f9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($6c5a0d6caccac2f9$var$isInstance(target, Uint8Array)) target = $6c5a0d6caccac2f9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $7E0eS._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $6c5a0d6caccac2f9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($6c5a0d6caccac2f9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $6c5a0d6caccac2f9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($6c5a0d6caccac2f9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $6c5a0d6caccac2f9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $6c5a0d6caccac2f9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $6c5a0d6caccac2f9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $6c5a0d6caccac2f9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $6c5a0d6caccac2f9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $6c5a0d6caccac2f9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($6c5a0d6caccac2f9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $6c5a0d6caccac2f9$var$utf8Write(buf, string, offset, length) {
    return $6c5a0d6caccac2f9$var$blitBuffer($6c5a0d6caccac2f9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $6c5a0d6caccac2f9$var$asciiWrite(buf, string, offset, length) {
    return $6c5a0d6caccac2f9$var$blitBuffer($6c5a0d6caccac2f9$var$asciiToBytes(string), buf, offset, length);
}
function $6c5a0d6caccac2f9$var$base64Write(buf, string, offset, length) {
    return $6c5a0d6caccac2f9$var$blitBuffer($6c5a0d6caccac2f9$var$base64ToBytes(string), buf, offset, length);
}
function $6c5a0d6caccac2f9$var$ucs2Write(buf, string, offset, length) {
    return $6c5a0d6caccac2f9$var$blitBuffer($6c5a0d6caccac2f9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$6c5a0d6caccac2f9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $6c5a0d6caccac2f9$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $6c5a0d6caccac2f9$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $6c5a0d6caccac2f9$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $6c5a0d6caccac2f9$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6c5a0d6caccac2f9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$6c5a0d6caccac2f9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $6c5a0d6caccac2f9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $cOFqU.fromByteArray(buf);
    else return $cOFqU.fromByteArray(buf.slice(start, end));
}
function $6c5a0d6caccac2f9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $6c5a0d6caccac2f9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $6c5a0d6caccac2f9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $6c5a0d6caccac2f9$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $6c5a0d6caccac2f9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $6c5a0d6caccac2f9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $6c5a0d6caccac2f9$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $6c5a0d6caccac2f9$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $6c5a0d6caccac2f9$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $6c5a0d6caccac2f9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $6c5a0d6caccac2f9$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $6c5a0d6caccac2f9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $6c5a0d6caccac2f9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$6c5a0d6caccac2f9$var$Buffer.prototype.readUintLE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUintBE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUint8 = $6c5a0d6caccac2f9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUint16LE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUint16BE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUint32LE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUint32BE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readBigUInt64LE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $6c5a0d6caccac2f9$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6c5a0d6caccac2f9$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$6c5a0d6caccac2f9$var$Buffer.prototype.readBigUInt64BE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $6c5a0d6caccac2f9$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6c5a0d6caccac2f9$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$6c5a0d6caccac2f9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readBigInt64LE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $6c5a0d6caccac2f9$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6c5a0d6caccac2f9$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$6c5a0d6caccac2f9$var$Buffer.prototype.readBigInt64BE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $6c5a0d6caccac2f9$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6c5a0d6caccac2f9$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$6c5a0d6caccac2f9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return $lqFFf.read(this, offset, true, 23, 4);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return $lqFFf.read(this, offset, false, 23, 4);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 8, this.length);
    return $lqFFf.read(this, offset, true, 52, 8);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 8, this.length);
    return $lqFFf.read(this, offset, false, 52, 8);
};
function $6c5a0d6caccac2f9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUintLE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6c5a0d6caccac2f9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUintBE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6c5a0d6caccac2f9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUint8 = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUint16LE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUint16BE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUint32LE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUint32BE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $6c5a0d6caccac2f9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $6c5a0d6caccac2f9$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $6c5a0d6caccac2f9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $6c5a0d6caccac2f9$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.writeBigUInt64LE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6c5a0d6caccac2f9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6c5a0d6caccac2f9$var$Buffer.prototype.writeBigUInt64BE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6c5a0d6caccac2f9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6c5a0d6caccac2f9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $6c5a0d6caccac2f9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $6c5a0d6caccac2f9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeBigInt64LE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6c5a0d6caccac2f9$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$6c5a0d6caccac2f9$var$Buffer.prototype.writeBigInt64BE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6c5a0d6caccac2f9$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $6c5a0d6caccac2f9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $6c5a0d6caccac2f9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $lqFFf.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $6c5a0d6caccac2f9$var$writeFloat(this, value, offset, true, noAssert);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $6c5a0d6caccac2f9$var$writeFloat(this, value, offset, false, noAssert);
};
function $6c5a0d6caccac2f9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $lqFFf.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $6c5a0d6caccac2f9$var$writeDouble(this, value, offset, true, noAssert);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $6c5a0d6caccac2f9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$6c5a0d6caccac2f9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$6c5a0d6caccac2f9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$6c5a0d6caccac2f9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $6c5a0d6caccac2f9$var$Buffer.isBuffer(val) ? val : $6c5a0d6caccac2f9$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $6c5a0d6caccac2f9$var$errors = {};
function $6c5a0d6caccac2f9$var$E(sym, getMessage, Base) {
    $6c5a0d6caccac2f9$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $hdIku._)(NodeError, Base);
        function NodeError() {
            (0, $173N4._)(this, NodeError);
            var _this;
            _this = (0, $7qXGD._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $cFHGC._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$6c5a0d6caccac2f9$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$6c5a0d6caccac2f9$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $7E0eS._)(actual));
}, TypeError);
$6c5a0d6caccac2f9$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $6c5a0d6caccac2f9$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $7E0eS._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $6c5a0d6caccac2f9$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $6c5a0d6caccac2f9$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $6c5a0d6caccac2f9$var$checkBounds(buf, offset, byteLength) {
    $6c5a0d6caccac2f9$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $6c5a0d6caccac2f9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $6c5a0d6caccac2f9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $7E0eS._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $6c5a0d6caccac2f9$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $6c5a0d6caccac2f9$var$checkBounds(buf, offset, byteLength);
}
function $6c5a0d6caccac2f9$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $6c5a0d6caccac2f9$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $6c5a0d6caccac2f9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $6c5a0d6caccac2f9$var$validateNumber(value, type);
        throw new $6c5a0d6caccac2f9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $6c5a0d6caccac2f9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $6c5a0d6caccac2f9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $6c5a0d6caccac2f9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $6c5a0d6caccac2f9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($6c5a0d6caccac2f9$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $6c5a0d6caccac2f9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $6c5a0d6caccac2f9$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $6c5a0d6caccac2f9$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $6c5a0d6caccac2f9$var$base64ToBytes(str) {
    return $cOFqU.toByteArray($6c5a0d6caccac2f9$var$base64clean(str));
}
function $6c5a0d6caccac2f9$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $6c5a0d6caccac2f9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $6c5a0d6caccac2f9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $6c5a0d6caccac2f9$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $6c5a0d6caccac2f9$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $6c5a0d6caccac2f9$var$BufferBigIntNotDefined : fn;
}
function $6c5a0d6caccac2f9$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("cOFqU", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $954a4b447490bcaa$export$d622b2ad8d90c771; }, function (v) { return $954a4b447490bcaa$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $954a4b447490bcaa$export$6100ba28696e12de; }, function (v) { return $954a4b447490bcaa$export$6100ba28696e12de = v; });
var $954a4b447490bcaa$export$a48f0734ac7c2329;
var $954a4b447490bcaa$export$d622b2ad8d90c771;
var $954a4b447490bcaa$export$6100ba28696e12de;
'use strict';
$954a4b447490bcaa$export$a48f0734ac7c2329 = $954a4b447490bcaa$var$byteLength;
$954a4b447490bcaa$export$d622b2ad8d90c771 = $954a4b447490bcaa$var$toByteArray;
$954a4b447490bcaa$export$6100ba28696e12de = $954a4b447490bcaa$var$fromByteArray;
var $954a4b447490bcaa$var$lookup = [];
var $954a4b447490bcaa$var$revLookup = [];
var $954a4b447490bcaa$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $954a4b447490bcaa$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $954a4b447490bcaa$var$i = 0, $954a4b447490bcaa$var$len = $954a4b447490bcaa$var$code.length; $954a4b447490bcaa$var$i < $954a4b447490bcaa$var$len; ++$954a4b447490bcaa$var$i){
    $954a4b447490bcaa$var$lookup[$954a4b447490bcaa$var$i] = $954a4b447490bcaa$var$code[$954a4b447490bcaa$var$i];
    $954a4b447490bcaa$var$revLookup[$954a4b447490bcaa$var$code.charCodeAt($954a4b447490bcaa$var$i)] = $954a4b447490bcaa$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$954a4b447490bcaa$var$revLookup['-'.charCodeAt(0)] = 62;
$954a4b447490bcaa$var$revLookup['_'.charCodeAt(0)] = 63;
function $954a4b447490bcaa$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $954a4b447490bcaa$var$byteLength(b64) {
    var lens = $954a4b447490bcaa$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $954a4b447490bcaa$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $954a4b447490bcaa$var$toByteArray(b64) {
    var tmp;
    var lens = $954a4b447490bcaa$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $954a4b447490bcaa$var$Arr($954a4b447490bcaa$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i)] << 18 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i)] << 2 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i)] << 10 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $954a4b447490bcaa$var$tripletToBase64(num) {
    return $954a4b447490bcaa$var$lookup[num >> 18 & 0x3F] + $954a4b447490bcaa$var$lookup[num >> 12 & 0x3F] + $954a4b447490bcaa$var$lookup[num >> 6 & 0x3F] + $954a4b447490bcaa$var$lookup[num & 0x3F];
}
function $954a4b447490bcaa$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($954a4b447490bcaa$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $954a4b447490bcaa$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($954a4b447490bcaa$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($954a4b447490bcaa$var$lookup[tmp >> 2] + $954a4b447490bcaa$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($954a4b447490bcaa$var$lookup[tmp >> 10] + $954a4b447490bcaa$var$lookup[tmp >> 4 & 0x3F] + $954a4b447490bcaa$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("lqFFf", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $f99c5859a5f73a56$export$aafa59e2e03f2942; }, function (v) { return $f99c5859a5f73a56$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $f99c5859a5f73a56$export$68d8715fc104d294; }, function (v) { return $f99c5859a5f73a56$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $f99c5859a5f73a56$export$aafa59e2e03f2942;
var $f99c5859a5f73a56$export$68d8715fc104d294;
$f99c5859a5f73a56$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$f99c5859a5f73a56$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("5Qkok", function(module, exports) {
"use strict";
var $4411a0679c40a5bd$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DetailContext = module.exports.NoopContext = module.exports.VError = void 0;
/**
 * Error thrown by validation. Besides an informative message, it includes the path to the
 * property which triggered the failure.
 */ var $4411a0679c40a5bd$var$VError = /** @class */ function(_super) {
    $4411a0679c40a5bd$var$__extends(VError, _super);
    function VError(path, message) {
        var _this = _super.call(this, message) || this;
        _this.path = path;
        // See https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work for info about this workaround.
        Object.setPrototypeOf(_this, VError.prototype);
        return _this;
    }
    return VError;
}(Error);
module.exports.VError = $4411a0679c40a5bd$var$VError;
/**
 * Fast implementation of IContext used for first-pass validation. If that fails, we can validate
 * using DetailContext to collect error messages. That's faster for the common case when messages
 * normally pass validation.
 */ var $4411a0679c40a5bd$var$NoopContext = /** @class */ function() {
    function NoopContext() {}
    NoopContext.prototype.fail = function(relPath, message, score) {
        return false;
    };
    NoopContext.prototype.unionResolver = function() {
        return this;
    };
    NoopContext.prototype.createContext = function() {
        return this;
    };
    NoopContext.prototype.resolveUnion = function(ur) {};
    return NoopContext;
}();
module.exports.NoopContext = $4411a0679c40a5bd$var$NoopContext;
/**
 * Complete implementation of IContext that collects meaningfull errors.
 */ var $4411a0679c40a5bd$var$DetailContext = /** @class */ function() {
    function DetailContext() {
        // Stack of property names and associated messages for reporting helpful error messages.
        this._propNames = [
            ""
        ];
        this._messages = [
            null
        ];
        // Score is used to choose the best union member whose DetailContext to use for reporting.
        // Higher score means better match (or rather less severe mismatch).
        this._score = 0;
    }
    DetailContext.prototype.fail = function(relPath, message, score) {
        this._propNames.push(relPath);
        this._messages.push(message);
        this._score += score;
        return false;
    };
    DetailContext.prototype.unionResolver = function() {
        return new $4411a0679c40a5bd$var$DetailUnionResolver();
    };
    DetailContext.prototype.resolveUnion = function(unionResolver) {
        var _a, _b;
        var u = unionResolver;
        var best = null;
        for(var _i = 0, _c = u.contexts; _i < _c.length; _i++){
            var ctx = _c[_i];
            if (!best || ctx._score >= best._score) best = ctx;
        }
        if (best && best._score > 0) {
            (_a = this._propNames).push.apply(_a, best._propNames);
            (_b = this._messages).push.apply(_b, best._messages);
        }
    };
    DetailContext.prototype.getError = function(path) {
        var msgParts = [];
        for(var i = this._propNames.length - 1; i >= 0; i--){
            var p = this._propNames[i];
            path += typeof p === "number" ? "[" + p + "]" : p ? "." + p : "";
            var m = this._messages[i];
            if (m) msgParts.push(path + " " + m);
        }
        return new $4411a0679c40a5bd$var$VError(path, msgParts.join("; "));
    };
    DetailContext.prototype.getErrorDetail = function(path) {
        var details = [];
        for(var i = this._propNames.length - 1; i >= 0; i--){
            var p = this._propNames[i];
            path += typeof p === "number" ? "[" + p + "]" : p ? "." + p : "";
            var message = this._messages[i];
            if (message) details.push({
                path: path,
                message: message
            });
        }
        var detail = null;
        for(var i = details.length - 1; i >= 0; i--){
            if (detail) details[i].nested = [
                detail
            ];
            detail = details[i];
        }
        return detail;
    };
    return DetailContext;
}();
module.exports.DetailContext = $4411a0679c40a5bd$var$DetailContext;
var $4411a0679c40a5bd$var$DetailUnionResolver = /** @class */ function() {
    function DetailUnionResolver() {
        this.contexts = [];
    }
    DetailUnionResolver.prototype.createContext = function() {
        var ctx = new $4411a0679c40a5bd$var$DetailContext();
        this.contexts.push(ctx);
        return ctx;
    };
    return DetailUnionResolver;
}();

});


parcelRegister("dNvVv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $hgwVv = parcelRequire("hgwVv");
function $a0b89debaf1d2861$var$emptyFunction() {}
function $a0b89debaf1d2861$var$emptyFunctionWithReset() {}
$a0b89debaf1d2861$var$emptyFunctionWithReset.resetWarningCache = $a0b89debaf1d2861$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $hgwVv) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $a0b89debaf1d2861$var$emptyFunctionWithReset,
        resetWarningCache: $a0b89debaf1d2861$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("hgwVv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $c91d78cefd8560cc$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $c91d78cefd8560cc$var$ReactPropTypesSecret;

});


parcelRegister("kh3Tr", function(module, exports) {

module.exports = (parcelRequire("e8PZf"))($parcel$resolve("7JXq8")).then(function() {
    return parcelRequire('ddAXi');
});

});
parcelRegister("e8PZf", function(module, exports) {
"use strict";

var $2whz5 = parcelRequire("2whz5");
module.exports = $2whz5(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("2whz5", function(module, exports) {
"use strict";
var $1d5c31fa25ebdcba$var$cachedBundles = {};
var $1d5c31fa25ebdcba$var$cachedPreloads = {};
var $1d5c31fa25ebdcba$var$cachedPrefetches = {};
function $1d5c31fa25ebdcba$var$getCache(type) {
    switch(type){
        case 'preload':
            return $1d5c31fa25ebdcba$var$cachedPreloads;
        case 'prefetch':
            return $1d5c31fa25ebdcba$var$cachedPrefetches;
        default:
            return $1d5c31fa25ebdcba$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1d5c31fa25ebdcba$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("dM9eC", function(module, exports) {

module.exports = (parcelRequire("e8PZf"))($parcel$resolve("9V63F")).then(function() {
    return parcelRequire('dmHCI');
});

});

parcelRegister("hDKce", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ 
var $7E0eS = parcelRequire("7E0eS");
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined1;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = (typeof $parcel$global === "undefined" ? "undefined" : (0, $7E0eS._)($parcel$global)) == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = (typeof self === "undefined" ? "undefined" : (0, $7E0eS._)(self)) == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined1 : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined1 : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined1) result = result === undefined1 ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined1 : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, _$Function = context.Function, Math = context.Math, _$Object = context.Object, _$RegExp = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = _$Function.prototype, objectProto = _$Object.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(_$Object);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = _$RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined1, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined1, getPrototype = overArg(_$Object.getPrototypeOf, _$Object), objectCreate = _$Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined1, symIterator = Symbol ? Symbol.iterator : undefined1, symToStringTag = Symbol ? Symbol.toStringTag : undefined1;
        var defineProperty = function() {
            try {
                var func = getNative(_$Object, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = _$Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(_$Object.keys, _$Object), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(_$Object, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined1, symbolToString = symbolProto ? symbolProto.toString : undefined1;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var _$result = new object;
                object.prototype = undefined1;
                return _$result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined1;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var _$result = new LazyWrapper(this.__wrapped__);
            _$result.__actions__ = copyArray(this.__actions__);
            _$result.__dir__ = this.__dir__;
            _$result.__filtered__ = this.__filtered__;
            _$result.__iteratees__ = copyArray(this.__iteratees__);
            _$result.__takeCount__ = this.__takeCount__;
            _$result.__views__ = copyArray(this.__views__);
            return _$result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var _$result = new LazyWrapper(this);
                _$result.__dir__ = -1;
                _$result.__filtered__ = true;
            } else {
                _$result = this.clone();
                _$result.__dir__ *= -1;
            }
            return _$result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var _$result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], _$iteratee = data.iteratee, type = data.type, computed = _$iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                _$result[resIndex++] = value;
            }
            return _$result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var _$result = this.has(key) && delete this.__data__[key];
            this.size -= _$result ? 1 : 0;
            return _$result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var _$result = data[key];
                return _$result === HASH_UNDEFINED ? undefined1 : _$result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined1;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined1 : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined1 ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined1 : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var _$result = getMapData(this, key)['delete'](key);
            this.size -= _$result ? 1 : 0;
            return _$result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), _$size = data.size;
            data.set(key, value);
            this.size += data.size == _$size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, _$result = data['delete'](key);
            this.size = data.size;
            return _$result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, _$result = skipIndexes ? baseTimes(value.length, String) : [], length = _$result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) _$result.push(key);
            return _$result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined1;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined1 && !eq(object[key], value) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, _$result = Array1(length), skip = object == null;
            while(++index < length)_$result[index] = skip ? undefined1 : get(object, paths[index]);
            return _$result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined1) number = number <= upper ? number : upper;
                if (lower !== undefined1) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var _$result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) _$result = object ? customizer(value, key, object, stack) : customizer(value);
            if (_$result !== undefined1) return _$result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                _$result = initCloneArray(value);
                if (!isDeep) return copyArray(value, _$result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    _$result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(_$result, value)) : copySymbols(value, baseAssign(_$result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    _$result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, _$result);
            if (isSet(value)) value.forEach(function(subValue) {
                _$result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                _$result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined1 : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(_$result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return _$result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = _$Object(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined1 && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined1, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, _$includes = arrayIncludes, isCommon = true, length = array.length, _$result = [], valuesLength = values.length;
            if (!length) return _$result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                _$includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                _$includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    _$result.push(value);
                } else if (!_$includes(values, computed, comparator)) _$result.push(value);
            }
            return _$result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var _$result = true;
            baseEach(collection, function(value, index, collection) {
                _$result = !!predicate(value, index, collection);
                return _$result;
            });
            return _$result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined1 ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, _$result = value;
            }
            return _$result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined1 || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var _$result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) _$result.push(value);
            });
            return _$result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined1;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var _$result = keysFunc(object);
            return isArray(object) ? _$result : arrayPush(_$result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined1 ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in _$Object(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in _$Object(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var _$includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, _$result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined1;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && _$result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : _$includes(_$result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : _$includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    _$result.push(value);
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined1 : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = _$Object(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined1 && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var _$result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(_$result === undefined1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : _$result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if ((typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var _$result = [];
            for(var key in _$Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') _$result.push(key);
            return _$result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), _$result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) _$result.push(key);
            return _$result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, _$result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                _$result[++index] = iteratee(value, key, collection);
            });
            return _$result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined1;
                    if (newValue === undefined1) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined1;
            var isCommon = newValue === undefined1;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined1;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var _$result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(_$result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, _$result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(_$result, castPath(path, object), value);
            }
            return _$result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var _$indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = _$indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), _$result = Array1(length);
            while(length--){
                _$result[fromRight ? length : ++index] = start;
                start += step;
            }
            return _$result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var _$result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return _$result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) _$result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return _$result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined1;
                    if (newValue === undefined1) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function baseSetData(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function baseSetToString(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var _$result = Array1(length);
            while(++index < length)_$result[index] = array[index + start];
            return _$result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var _$result;
            baseEach(collection, function(value, index, collection) {
                _$result = predicate(value, index, collection);
                return !_$result;
            });
            return !!_$result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined1;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, _$result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    _$result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var _$result = value + '';
            return _$result == '0' && 1 / value == -INFINITY ? '-0' : _$result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, _$includes = arrayIncludes, length = array.length, isCommon = true, _$result = [], seen = _$result;
            if (comparator) {
                isCommon = false;
                _$includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var _$set = iteratee ? null : createSet(array);
                if (_$set) return setToArray(_$set);
                isCommon = false;
                _$includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : _$result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    _$result.push(value);
                } else if (!_$includes(seen, computed, comparator)) {
                    if (seen !== _$result) seen.push(computed);
                    _$result.push(value);
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var _$result = value;
            if (_$result instanceof LazyWrapper) _$result = _$result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, _$result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, _$result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) _$result[index] = baseDifference(_$result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(_$result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, _$result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined1;
                assignFunc(_$result, props[index], value);
            }
            return _$result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined1 ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, _$result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(_$result);
            return _$result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var _$result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(_$result).set(new Uint8Array(arrayBuffer));
            return _$result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var _$result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            _$result.lastIndex = regexp.lastIndex;
            return _$result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? _$Object(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var _$result = compareAscending(objCriteria[index], othCriteria[index]);
                if (_$result) {
                    if (index >= ordersLength) return _$result;
                    var order = orders[index];
                    return _$result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), _$result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)_$result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) _$result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)_$result[leftIndex++] = args[argsIndex++];
            return _$result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), _$result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)_$result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)_$result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) _$result[offset + holders[holdersIndex]] = args[argsIndex++];
            return _$result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined1;
                if (newValue === undefined1) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined1, guard = length > 2 ? sources[2] : undefined1;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined1;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined1 : customizer;
                    length = 1;
                }
                object = _$Object(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = _$Object(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = _$Object(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined1;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), _$result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(_$result) ? _$result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined1, args, holders, undefined1, undefined1, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = _$Object(collection);
                if (!isArrayLike(collection)) {
                    var _$iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function predicate(key) {
                        return _$iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[_$iteratee ? collection[index] : index] : undefined1;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined1;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, _$result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)_$result = funcs[index].call(this, _$result);
                    return _$result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined1 : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var _$result;
                if (value === undefined1 && other === undefined1) return defaultValue;
                if (value !== undefined1) _$result = value;
                if (other !== undefined1) {
                    if (_$result === undefined1) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    _$result = operator(value, other);
                }
                return _$result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined1 ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var _$result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(_$result), 0, length).join('') : _$result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined1;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined1) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined1 ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined1, newHoldersRight = isCurry ? undefined1 : holders, newPartials = isCurry ? partials : undefined1, newPartialsRight = isCurry ? undefined1 : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var _$result = wrapFunc.apply(undefined1, newData);
            if (isLaziable(func)) setData(_$result, newData);
            _$result.placeholder = placeholder;
            return setWrapToString(_$result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function createSet(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined1;
            }
            ary = ary === undefined1 ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined1 ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined1;
            }
            var data = isBindKey ? undefined1 : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var _$result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) _$result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) _$result = createPartial(func, bitmask, thisArg, partials);
            else _$result = createHybrid.apply(undefined1, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(_$result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined1, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined1 : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, _$result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined1;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined1) {
                    if (compared) continue;
                    _$result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        _$result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    _$result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return _$result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var _$result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return _$result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var _$result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    _$result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (_$result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) _$result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return _$result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined1, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function getData(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var _$result = func.name + '', array = realNames[_$result], length = hasOwnProperty.call(realNames, _$result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return _$result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var _$result = lodash.iteratee || iteratee;
            _$result = _$result === iteratee ? baseIteratee : _$result;
            return arguments.length ? _$result(arguments[0], arguments[1]) : _$result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var _$result = keys(object), length = _$result.length;
            while(length--){
                var key = _$result[length], value = object[key];
                _$result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return _$result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined1;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined1;
                var unmasked = true;
            } catch (e) {}
            var _$result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return _$result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function getSymbols(object) {
            if (object == null) return [];
            object = _$Object(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function getSymbolsIn(object) {
            var _$result = [];
            while(object){
                arrayPush(_$result, getSymbols(object));
                object = getPrototype(object);
            }
            return _$result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function getTag(value) {
            var _$result = baseGetTag(value), Ctor = _$result == objectTag ? value.constructor : undefined1, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return _$result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], _$size = data.size;
                switch(data.type){
                    case 'drop':
                        start += _$size;
                        break;
                    case 'dropRight':
                        end -= _$size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + _$size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - _$size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, _$result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(_$result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (_$result || ++index != length) return _$result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, _$result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                _$result.index = array.index;
                _$result.input = array.input;
            }
            return _$result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value);
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index === "undefined" ? "undefined" : (0, $7E0eS._)(index);
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value);
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in _$Object(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value);
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined1 || key in _$Object(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var _$result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = _$result.cache;
            return _$result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var _$result = [];
            if (object != null) for(var key in _$Object(object))_$result.push(key);
            return _$result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined1 ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined1;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined1, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined1 ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var _$result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) _$result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                _$result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return _$result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var _$result = value + '';
            return _$result == '0' && 1 / value == -INFINITY ? '-0' : _$result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var _$result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            _$result.__actions__ = copyArray(wrapper.__actions__);
            _$result.__index__ = wrapper.__index__;
            _$result.__values__ = wrapper.__values__;
            return _$result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined1) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, _$result = Array1(nativeCeil(length / size));
            while(index < length)_$result[resIndex++] = baseSlice(array, index, index += size);
            return _$result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, _$result = [];
            while(++index < length){
                var value = array[index];
                if (value) _$result[resIndex++] = value;
            }
            return _$result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var _$iteratee = last(values);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(_$iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined1, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, _$result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(_$result, pair[0], pair[1]);
            }
            return _$result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined1;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (_$iteratee === last(mapped)) _$iteratee = undefined1;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(_$iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined1;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined1, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined1;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined1;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined1, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, _$result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return _$result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var _$result = [];
            if (!(array && array.length)) return _$result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    _$result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return _$result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined1 ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(_$iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined1, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined1;
            return array && array.length ? baseUniq(array, undefined1, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var _$result = unzip(array);
            if (iteratee == null) return _$result;
            return arrayMap(_$result, function(group) {
                return apply(iteratee, undefined1, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(_$iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined1, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, _$iteratee = length > 1 ? arrays[length - 1] : undefined1;
            _$iteratee = typeof _$iteratee == 'function' ? (arrays.pop(), _$iteratee) : undefined1;
            return unzipWith(arrays, _$iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var _$result = lodash(value);
            _$result.__chain__ = true;
            return _$result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function interceptor(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined1
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined1);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined1) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined1 : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var _$result, parent = this;
            while(parent instanceof baseLodash){
                var _$clone = wrapperClone(parent);
                _$clone.__index__ = 0;
                _$clone.__values__ = undefined1;
                if (_$result) previous.__wrapped__ = _$clone;
                else _$result = _$clone;
                var previous = _$clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return _$result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined1
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', _$result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                _$result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return _$result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined1 : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined1 : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined1, undefined1, undefined1, undefined1, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var _$result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) _$result = func.apply(this, arguments);
                if (n <= 1) func = undefined1;
                return _$result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var _$result = createWrap(func, WRAP_CURRY_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            _$result.placeholder = curry.placeholder;
            return _$result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var _$result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            _$result.placeholder = curryRight.placeholder;
            return _$result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, _$result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined1;
                lastInvokeTime = time;
                _$result = func.apply(thisArg, args);
                return _$result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : _$result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined1;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined1;
                return _$result;
            }
            function cancel() {
                if (timerId !== undefined1) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined1;
            }
            function flush() {
                return timerId === undefined1 ? _$result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined1) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined1) timerId = setTimeout(timerExpired, wait);
                return _$result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function memoized1() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var _$result = func.apply(this, args);
                memoized.cache = cache.set(key, _$result) || cache;
                return _$result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined1, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined1, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined1, undefined1, undefined1, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined1 ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function isArguments(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            var _$result = customizer ? customizer(value, other) : undefined1;
            return _$result === undefined1 ? baseIsEqual(value, other, undefined1, customizer) : !!_$result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value);
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined1;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var _$result = toFinite(value), remainder = _$result % 1;
            return _$result === _$result ? remainder ? _$result - remainder : _$result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var _$result = baseCreate(prototype);
            return properties == null ? _$result : baseAssign(_$result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = _$Object(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined1;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined1, customDefaultsMerge);
            return apply(mergeWith, undefined1, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var _$result = object == null ? undefined1 : baseGet(object, path);
            return _$result === undefined1 ? defaultValue : _$result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var _$result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(_$result, iteratee(value, key, object), value);
            });
            return _$result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var _$result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(_$result, key, iteratee(value, key, object));
            });
            return _$result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var _$result = {};
            if (object == null) return _$result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), _$result);
            if (isDeep) _$result = baseClone(_$result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(_$result, paths[length]);
            return _$result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined1;
            }
            while(++index < length){
                var value = object == null ? undefined1 : object[toKey(path[index])];
                if (value === undefined1) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined1) {
                upper = lower;
                lower = undefined1;
            }
            if (upper !== undefined1) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined1) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined1) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined1;
            if (floating === undefined1) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined1;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined1;
                }
            }
            if (lower === undefined1 && upper === undefined1) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined1) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined1 ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined1;
            limit = limit === undefined1 ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined1;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = _$RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var _$result = attempt(function() {
                return _$Function(importsKeys, sourceURL + 'return ' + source).apply(undefined1, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            _$result.source = source;
            if (isError(_$result)) throw _$result;
            return _$result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var _$result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined1) return _$result + omission;
            if (strSymbols) end += _$result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = _$result;
                    if (!separator.global) separator = _$RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    _$result = _$result.slice(0, newEnd === undefined1 ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = _$result.lastIndexOf(separator);
                if (index > -1) _$result = _$result.slice(0, index);
            }
            return _$result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined1 : pattern;
            if (pattern === undefined1) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined1, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var _$chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (_$chain || chainAll) {
                        var _$result = object(this.__wrapped__), actions = _$result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        _$result.__chain__ = chainAll;
                        return _$result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined1 : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var _$result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return _$result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined1;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined1;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined1;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined1;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined1 ? 1 : nativeMax(toInteger(n), 0);
                var _$result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (_$result.__filtered__) _$result.__takeCount__ = nativeMin(n, _$result.__takeCount__);
                else _$result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (_$result.__dir__ < 0 ? 'Right' : '')
                });
                return _$result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var _$result = this.clone();
                _$result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                _$result.__filtered__ = _$result.__filtered__ || isFilter;
                return _$result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var _$result = this;
            if (_$result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(_$result);
            if (start < 0) _$result = _$result.takeRight(-start);
            else if (start) _$result = _$result.drop(start);
            if (end !== undefined1) {
                end = toInteger(end);
                _$result = end < 0 ? _$result.dropRight(-end) : _$result.take(end - start);
            }
            return _$result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, _$iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function interceptor(value) {
                    var _$result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? _$result[0] : _$result;
                };
                if (useLazy && checkIteratee && typeof _$iteratee == 'function' && _$iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var _$result = func.apply(value, args);
                    _$result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined1
                    });
                    return new LodashWrapper(_$result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                _$result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? _$result.value()[0] : _$result.value() : _$result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined1, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined1
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && (0, $7E0eS._)(define.amd) == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(undefined);

});

parcelRegister("l5IE3", function(module, exports) {

$parcel$export(module.exports, "marked", function () { return marked; });
/**
 * marked v15.0.12 - a markdown parser
 * Copyright (c) 2011-2025, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ // src/defaults.ts

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7Pjls = parcelRequire("7Pjls");

var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");
var _class;
function _getDefaults() {
    return {
        async: false,
        breaks: false,
        extensions: null,
        gfm: true,
        hooks: null,
        pedantic: false,
        renderer: null,
        silent: false,
        tokenizer: null,
        walkTokens: null
    };
}
var _defaults = _getDefaults();
function changeDefaults(newDefaults) {
    _defaults = newDefaults;
}
// src/rules.ts
var noopTest = {
    exec: function() {
        return null;
    }
};
function edit(regex) {
    var opt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var source = typeof regex === "string" ? regex : regex.source;
    var obj = {
        replace: function(name, val) {
            var valSource = typeof val === "string" ? val : val.source;
            valSource = valSource.replace(other.caret, "$1");
            source = source.replace(name, valSource);
            return obj;
        },
        getRegex: function() {
            return new RegExp(source, opt);
        }
    };
    return obj;
}
var other = {
    codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
    outputLinkReplace: /\\([\[\]])/g,
    indentCodeCompensation: /^(\s+)(?:```)/,
    beginningSpace: /^\s+/,
    endingHash: /#$/,
    startingSpaceChar: /^ /,
    endingSpaceChar: / $/,
    nonSpaceChar: /[^ ]/,
    newLineCharGlobal: /\n/g,
    tabCharGlobal: /\t/g,
    multipleSpaceGlobal: /\s+/g,
    blankLine: /^[ \t]*$/,
    doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
    blockquoteStart: /^ {0,3}>/,
    blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
    blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
    listReplaceTabs: /^\t+/,
    listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
    listIsTask: /^\[[ xX]\] /,
    listReplaceTask: /^\[[ xX]\] +/,
    anyLine: /\n.*\n/,
    hrefBrackets: /^<(.*)>$/,
    tableDelimiter: /[:|]/,
    tableAlignChars: /^\||\| *$/g,
    tableRowBlankLine: /\n[ \t]*$/,
    tableAlignRight: /^ *-+: *$/,
    tableAlignCenter: /^ *:-+: *$/,
    tableAlignLeft: /^ *:-+ *$/,
    startATag: /^<a /i,
    endATag: /^<\/a>/i,
    startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
    endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
    startAngleBracket: /^</,
    endAngleBracket: />$/,
    pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
    unicodeAlphaNumeric: RegExp("[\\p{L}\\p{N}]", "u"),
    escapeTest: /[&<>"']/,
    escapeReplace: /[&<>"']/g,
    escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
    escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
    unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig,
    caret: /(^|[^\[])\^/g,
    percentDecode: /%25/g,
    findPipe: /\|/g,
    splitPipe: / \|/,
    slashPipe: /\\\|/g,
    carriageReturn: /\r\n|\r/g,
    spaceLine: /^ +$/gm,
    notSpaceStart: /^\S*/,
    endingNewline: /\n$/,
    listItemRegex: function(bull) {
        return new RegExp("^( {0,3}".concat(bull, ")((?:[	 ][^\\n]*)?(?:\\n|$))"));
    },
    nextBulletRegex: function(indent) {
        return new RegExp("^ {0,".concat(Math.min(3, indent - 1), "}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))"));
    },
    hrRegex: function(indent) {
        return new RegExp("^ {0,".concat(Math.min(3, indent - 1), "}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)"));
    },
    fencesBeginRegex: function(indent) {
        return new RegExp("^ {0,".concat(Math.min(3, indent - 1), "}(?:```|~~~)"));
    },
    headingBeginRegex: function(indent) {
        return new RegExp("^ {0,".concat(Math.min(3, indent - 1), "}#"));
    },
    htmlBeginRegex: function(indent) {
        return new RegExp("^ {0,".concat(Math.min(3, indent - 1), "}<(?:[a-z].*>|!--)"), "i");
    }
};
var newline = /^(?:[ \t]*(?:\n|$))+/;
var blockCode = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/;
var fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
var hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
var heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
var bullet = /(?:[*+-]|\d{1,9}[.)])/;
var lheadingCore = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/;
var lheading = edit(lheadingCore).replace(/bull/g, bullet).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex();
var lheadingGfm = edit(lheadingCore).replace(/bull/g, bullet).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex();
var _paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
var blockText = /^[^\n]+/;
var _blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
var def = edit(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", _blockLabel).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex();
var list = edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, bullet).getRegex();
var _tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
var _comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
var html = edit("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", _comment).replace("tag", _tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
var paragraph = edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex();
var blockquote = edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", paragraph).getRegex();
var blockNormal = {
    blockquote: blockquote,
    code: blockCode,
    def: def,
    fences: fences,
    heading: heading,
    hr: hr,
    html: html,
    lheading: lheading,
    list: list,
    newline: newline,
    paragraph: paragraph,
    table: noopTest,
    text: blockText
};
var gfmTable = edit("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex();
var blockGfm = (0, $6fpqi._)((0, $1XAnY._)({}, blockNormal), {
    lheading: lheadingGfm,
    table: gfmTable,
    paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", gfmTable).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex()
});
var blockPedantic = (0, $6fpqi._)((0, $1XAnY._)({}, blockNormal), {
    html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", _comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: noopTest,
    // fences not supported
    lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", lheading).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
});
var escape = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
var inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
var br = /^( {2,}|\\)\n(?!\s*$)/;
var inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
var _punctuation = RegExp("[\\p{P}\\p{S}]", "u");
var _punctuationOrSpace = RegExp("[\\s\\p{P}\\p{S}]", "u");
var _notPunctuationOrSpace = RegExp("[^\\s\\p{P}\\p{S}]", "u");
var punctuation = edit(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, _punctuationOrSpace).getRegex();
var _punctuationGfmStrongEm = RegExp("(?!~)[\\p{P}\\p{S}]", "u");
var _punctuationOrSpaceGfmStrongEm = RegExp("(?!~)[\\s\\p{P}\\p{S}]", "u");
var _notPunctuationOrSpaceGfmStrongEm = RegExp("(?:[^\\s\\p{P}\\p{S}]|~)", "u");
var blockSkip = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g;
var emStrongLDelimCore = /^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/;
var emStrongLDelim = edit(emStrongLDelimCore, "u").replace(/punct/g, _punctuation).getRegex();
var emStrongLDelimGfm = edit(emStrongLDelimCore, "u").replace(/punct/g, _punctuationGfmStrongEm).getRegex();
var emStrongRDelimAstCore = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)";
var emStrongRDelimAst = edit(emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, _notPunctuationOrSpace).replace(/punctSpace/g, _punctuationOrSpace).replace(/punct/g, _punctuation).getRegex();
var emStrongRDelimAstGfm = edit(emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, _notPunctuationOrSpaceGfmStrongEm).replace(/punctSpace/g, _punctuationOrSpaceGfmStrongEm).replace(/punct/g, _punctuationGfmStrongEm).getRegex();
var emStrongRDelimUnd = edit("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, _notPunctuationOrSpace).replace(/punctSpace/g, _punctuationOrSpace).replace(/punct/g, _punctuation).getRegex();
var anyPunctuation = edit(/\\(punct)/, "gu").replace(/punct/g, _punctuation).getRegex();
var autolink = edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex();
var _inlineComment = edit(_comment).replace("(?:-->|$)", "-->").getRegex();
var tag = edit("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", _inlineComment).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex();
var _inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
var link = edit(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]*(?:\n[ \t]*)?)(title))?\s*\)/).replace("label", _inlineLabel).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex();
var reflink = edit(/^!?\[(label)\]\[(ref)\]/).replace("label", _inlineLabel).replace("ref", _blockLabel).getRegex();
var nolink = edit(/^!?\[(ref)\](?:\[\])?/).replace("ref", _blockLabel).getRegex();
var reflinkSearch = edit("reflink|nolink(?!\\()", "g").replace("reflink", reflink).replace("nolink", nolink).getRegex();
var inlineNormal = {
    _backpedal: noopTest,
    // only used for GFM url
    anyPunctuation: anyPunctuation,
    autolink: autolink,
    blockSkip: blockSkip,
    br: br,
    code: inlineCode,
    del: noopTest,
    emStrongLDelim: emStrongLDelim,
    emStrongRDelimAst: emStrongRDelimAst,
    emStrongRDelimUnd: emStrongRDelimUnd,
    escape: escape,
    link: link,
    nolink: nolink,
    punctuation: punctuation,
    reflink: reflink,
    reflinkSearch: reflinkSearch,
    tag: tag,
    text: inlineText,
    url: noopTest
};
var inlinePedantic = (0, $6fpqi._)((0, $1XAnY._)({}, inlineNormal), {
    link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", _inlineLabel).getRegex(),
    reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", _inlineLabel).getRegex()
});
var inlineGfm = (0, $6fpqi._)((0, $1XAnY._)({}, inlineNormal), {
    emStrongRDelimAst: emStrongRDelimAstGfm,
    emStrongLDelim: emStrongLDelimGfm,
    url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
    _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
});
var inlineBreaks = (0, $6fpqi._)((0, $1XAnY._)({}, inlineGfm), {
    br: edit(br).replace("{2,}", "*").getRegex(),
    text: edit(inlineGfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
});
var block = {
    normal: blockNormal,
    gfm: blockGfm,
    pedantic: blockPedantic
};
var inline = {
    normal: inlineNormal,
    gfm: inlineGfm,
    breaks: inlineBreaks,
    pedantic: inlinePedantic
};
// src/helpers.ts
var escapeReplacements = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
var getEscapeReplacement = function(ch) {
    return escapeReplacements[ch];
};
function escape2(html2, encode) {
    if (encode) {
        if (other.escapeTest.test(html2)) return html2.replace(other.escapeReplace, getEscapeReplacement);
    } else {
        if (other.escapeTestNoEncode.test(html2)) return html2.replace(other.escapeReplaceNoEncode, getEscapeReplacement);
    }
    return html2;
}
function cleanUrl(href) {
    try {
        href = encodeURI(href).replace(other.percentDecode, "%");
    } catch (e) {
        return null;
    }
    return href;
}
function splitCells(tableRow, count) {
    var _cells_at;
    var row = tableRow.replace(other.findPipe, function(match, offset, str) {
        var escaped = false;
        var curr = offset;
        while(--curr >= 0 && str[curr] === "\\")escaped = !escaped;
        if (escaped) return "|";
        else return " |";
    }), cells = row.split(other.splitPipe);
    var i = 0;
    if (!cells[0].trim()) cells.shift();
    if (cells.length > 0 && !((_cells_at = cells.at(-1)) === null || _cells_at === void 0 ? void 0 : _cells_at.trim())) cells.pop();
    if (count) {
        if (cells.length > count) cells.splice(count);
        else while(cells.length < count)cells.push("");
    }
    for(; i < cells.length; i++)cells[i] = cells[i].trim().replace(other.slashPipe, "|");
    return cells;
}
function rtrim(str, c, invert) {
    var l = str.length;
    if (l === 0) return "";
    var suffLen = 0;
    while(suffLen < l){
        var currChar = str.charAt(l - suffLen - 1);
        if (currChar === c && !invert) suffLen++;
        else if (currChar !== c && invert) suffLen++;
        else break;
    }
    return str.slice(0, l - suffLen);
}
function findClosingBracket(str, b) {
    if (str.indexOf(b[1]) === -1) return -1;
    var level = 0;
    for(var i = 0; i < str.length; i++){
        if (str[i] === "\\") i++;
        else if (str[i] === b[0]) level++;
        else if (str[i] === b[1]) {
            level--;
            if (level < 0) return i;
        }
    }
    if (level > 0) return -2;
    return -1;
}
// src/Tokenizer.ts
function outputLink(cap, link2, raw, lexer2, rules) {
    var href = link2.href;
    var title = link2.title || null;
    var text = cap[1].replace(rules.other.outputLinkReplace, "$1");
    lexer2.state.inLink = true;
    var token = {
        type: cap[0].charAt(0) === "!" ? "image" : "link",
        raw: raw,
        href: href,
        title: title,
        text: text,
        tokens: lexer2.inlineTokens(text)
    };
    lexer2.state.inLink = false;
    return token;
}
function indentCodeCompensation(raw, text, rules) {
    var matchIndentToCode = raw.match(rules.other.indentCodeCompensation);
    if (matchIndentToCode === null) return text;
    var indentToCode = matchIndentToCode[1];
    return text.split("\n").map(function(node) {
        var matchIndentInNode = node.match(rules.other.beginningSpace);
        if (matchIndentInNode === null) return node;
        var _matchIndentInNode = (0, $f9AOD._)(matchIndentInNode, 1), indentInNode = _matchIndentInNode[0];
        if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
        return node;
    }).join("\n");
}
var _Tokenizer = /*#__PURE__*/ function() {
    "use strict";
    function _Tokenizer(options2) {
        (0, $173N4._)(this, _Tokenizer);
        (0, $7Pjls._)(this, "options", void 0);
        (0, $7Pjls._)(this, "rules", void 0);
        // set by the lexer
        (0, $7Pjls._)(this, "lexer", void 0);
        this.options = options2 || _defaults;
    }
    (0, $cFHGC._)(_Tokenizer, [
        {
            key: "space",
            value: function space(src) {
                var cap = this.rules.block.newline.exec(src);
                if (cap && cap[0].length > 0) return {
                    type: "space",
                    raw: cap[0]
                };
            }
        },
        {
            key: "code",
            value: function code(src) {
                var cap = this.rules.block.code.exec(src);
                if (cap) {
                    var text = cap[0].replace(this.rules.other.codeRemoveIndent, "");
                    return {
                        type: "code",
                        raw: cap[0],
                        codeBlockStyle: "indented",
                        text: !this.options.pedantic ? rtrim(text, "\n") : text
                    };
                }
            }
        },
        {
            key: "fences",
            value: function fences(src) {
                var cap = this.rules.block.fences.exec(src);
                if (cap) {
                    var raw = cap[0];
                    var text = indentCodeCompensation(raw, cap[3] || "", this.rules);
                    return {
                        type: "code",
                        raw: raw,
                        lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : cap[2],
                        text: text
                    };
                }
            }
        },
        {
            key: "heading",
            value: function heading(src) {
                var cap = this.rules.block.heading.exec(src);
                if (cap) {
                    var text = cap[2].trim();
                    if (this.rules.other.endingHash.test(text)) {
                        var trimmed = rtrim(text, "#");
                        if (this.options.pedantic) text = trimmed.trim();
                        else if (!trimmed || this.rules.other.endingSpaceChar.test(trimmed)) text = trimmed.trim();
                    }
                    return {
                        type: "heading",
                        raw: cap[0],
                        depth: cap[1].length,
                        text: text,
                        tokens: this.lexer.inline(text)
                    };
                }
            }
        },
        {
            key: "hr",
            value: function hr(src) {
                var cap = this.rules.block.hr.exec(src);
                if (cap) return {
                    type: "hr",
                    raw: rtrim(cap[0], "\n")
                };
            }
        },
        {
            key: "blockquote",
            value: function blockquote(src) {
                var cap = this.rules.block.blockquote.exec(src);
                if (cap) {
                    var lines = rtrim(cap[0], "\n").split("\n");
                    var raw = "";
                    var text = "";
                    var tokens = [];
                    while(lines.length > 0){
                        var inBlockquote = false;
                        var currentLines = [];
                        var i = void 0;
                        for(i = 0; i < lines.length; i++){
                            if (this.rules.other.blockquoteStart.test(lines[i])) {
                                currentLines.push(lines[i]);
                                inBlockquote = true;
                            } else if (!inBlockquote) currentLines.push(lines[i]);
                            else break;
                        }
                        lines = lines.slice(i);
                        var currentRaw = currentLines.join("\n");
                        var currentText = currentRaw.replace(this.rules.other.blockquoteSetextReplace, "\n    $1").replace(this.rules.other.blockquoteSetextReplace2, "");
                        raw = raw ? "".concat(raw, "\n").concat(currentRaw) : currentRaw;
                        text = text ? "".concat(text, "\n").concat(currentText) : currentText;
                        var top = this.lexer.state.top;
                        this.lexer.state.top = true;
                        this.lexer.blockTokens(currentText, tokens, true);
                        this.lexer.state.top = top;
                        if (lines.length === 0) break;
                        var lastToken = tokens.at(-1);
                        if ((lastToken === null || lastToken === void 0 ? void 0 : lastToken.type) === "code") break;
                        else if ((lastToken === null || lastToken === void 0 ? void 0 : lastToken.type) === "blockquote") {
                            var oldToken = lastToken;
                            var newText = oldToken.raw + "\n" + lines.join("\n");
                            var newToken = this.blockquote(newText);
                            tokens[tokens.length - 1] = newToken;
                            raw = raw.substring(0, raw.length - oldToken.raw.length) + newToken.raw;
                            text = text.substring(0, text.length - oldToken.text.length) + newToken.text;
                            break;
                        } else if ((lastToken === null || lastToken === void 0 ? void 0 : lastToken.type) === "list") {
                            var oldToken1 = lastToken;
                            var newText1 = oldToken1.raw + "\n" + lines.join("\n");
                            var newToken1 = this.list(newText1);
                            tokens[tokens.length - 1] = newToken1;
                            raw = raw.substring(0, raw.length - lastToken.raw.length) + newToken1.raw;
                            text = text.substring(0, text.length - oldToken1.raw.length) + newToken1.raw;
                            lines = newText1.substring(tokens.at(-1).raw.length).split("\n");
                            continue;
                        }
                    }
                    return {
                        type: "blockquote",
                        raw: raw,
                        tokens: tokens,
                        text: text
                    };
                }
            }
        },
        {
            key: "list",
            value: function list(src) {
                var _this = this;
                var cap = this.rules.block.list.exec(src);
                if (cap) {
                    var bull = cap[1].trim();
                    var isordered = bull.length > 1;
                    var list2 = {
                        type: "list",
                        raw: "",
                        ordered: isordered,
                        start: isordered ? +bull.slice(0, -1) : "",
                        loose: false,
                        items: []
                    };
                    bull = isordered ? "\\d{1,9}\\".concat(bull.slice(-1)) : "\\".concat(bull);
                    if (this.options.pedantic) bull = isordered ? bull : "[*+-]";
                    var itemRegex = this.rules.other.listItemRegex(bull);
                    var endsWithBlankLine = false;
                    while(src){
                        var endEarly = false;
                        var raw = "";
                        var itemContents = "";
                        if (!(cap = itemRegex.exec(src))) break;
                        if (this.rules.block.hr.test(src)) break;
                        raw = cap[0];
                        src = src.substring(raw.length);
                        var line = cap[2].split("\n", 1)[0].replace(this.rules.other.listReplaceTabs, function(t) {
                            return " ".repeat(3 * t.length);
                        });
                        var nextLine = src.split("\n", 1)[0];
                        var blankLine = !line.trim();
                        var indent = 0;
                        if (this.options.pedantic) {
                            indent = 2;
                            itemContents = line.trimStart();
                        } else if (blankLine) indent = cap[1].length + 1;
                        else {
                            indent = cap[2].search(this.rules.other.nonSpaceChar);
                            indent = indent > 4 ? 1 : indent;
                            itemContents = line.slice(indent);
                            indent += cap[1].length;
                        }
                        if (blankLine && this.rules.other.blankLine.test(nextLine)) {
                            raw += nextLine + "\n";
                            src = src.substring(nextLine.length + 1);
                            endEarly = true;
                        }
                        if (!endEarly) {
                            var nextBulletRegex = this.rules.other.nextBulletRegex(indent);
                            var hrRegex = this.rules.other.hrRegex(indent);
                            var fencesBeginRegex = this.rules.other.fencesBeginRegex(indent);
                            var headingBeginRegex = this.rules.other.headingBeginRegex(indent);
                            var htmlBeginRegex = this.rules.other.htmlBeginRegex(indent);
                            while(src){
                                var rawLine = src.split("\n", 1)[0];
                                var nextLineWithoutTabs = void 0;
                                nextLine = rawLine;
                                if (this.options.pedantic) {
                                    nextLine = nextLine.replace(this.rules.other.listReplaceNesting, "  ");
                                    nextLineWithoutTabs = nextLine;
                                } else nextLineWithoutTabs = nextLine.replace(this.rules.other.tabCharGlobal, "    ");
                                if (fencesBeginRegex.test(nextLine)) break;
                                if (headingBeginRegex.test(nextLine)) break;
                                if (htmlBeginRegex.test(nextLine)) break;
                                if (nextBulletRegex.test(nextLine)) break;
                                if (hrRegex.test(nextLine)) break;
                                if (nextLineWithoutTabs.search(this.rules.other.nonSpaceChar) >= indent || !nextLine.trim()) itemContents += "\n" + nextLineWithoutTabs.slice(indent);
                                else {
                                    if (blankLine) break;
                                    if (line.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4) break;
                                    if (fencesBeginRegex.test(line)) break;
                                    if (headingBeginRegex.test(line)) break;
                                    if (hrRegex.test(line)) break;
                                    itemContents += "\n" + nextLine;
                                }
                                if (!blankLine && !nextLine.trim()) blankLine = true;
                                raw += rawLine + "\n";
                                src = src.substring(rawLine.length + 1);
                                line = nextLineWithoutTabs.slice(indent);
                            }
                        }
                        if (!list2.loose) {
                            if (endsWithBlankLine) list2.loose = true;
                            else if (this.rules.other.doubleBlankLine.test(raw)) endsWithBlankLine = true;
                        }
                        var istask = null;
                        var ischecked = void 0;
                        if (this.options.gfm) {
                            istask = this.rules.other.listIsTask.exec(itemContents);
                            if (istask) {
                                ischecked = istask[0] !== "[ ] ";
                                itemContents = itemContents.replace(this.rules.other.listReplaceTask, "");
                            }
                        }
                        list2.items.push({
                            type: "list_item",
                            raw: raw,
                            task: !!istask,
                            checked: ischecked,
                            loose: false,
                            text: itemContents,
                            tokens: []
                        });
                        list2.raw += raw;
                    }
                    var lastItem = list2.items.at(-1);
                    if (lastItem) {
                        lastItem.raw = lastItem.raw.trimEnd();
                        lastItem.text = lastItem.text.trimEnd();
                    } else return;
                    list2.raw = list2.raw.trimEnd();
                    for(var i = 0; i < list2.items.length; i++){
                        this.lexer.state.top = false;
                        list2.items[i].tokens = this.lexer.blockTokens(list2.items[i].text, []);
                        if (!list2.loose) {
                            var spacers = list2.items[i].tokens.filter(function(t) {
                                return t.type === "space";
                            });
                            var hasMultipleLineBreaks = spacers.length > 0 && spacers.some(function(t) {
                                return _this.rules.other.anyLine.test(t.raw);
                            });
                            list2.loose = hasMultipleLineBreaks;
                        }
                    }
                    if (list2.loose) for(var i1 = 0; i1 < list2.items.length; i1++)list2.items[i1].loose = true;
                    return list2;
                }
            }
        },
        {
            key: "html",
            value: function html(src) {
                var cap = this.rules.block.html.exec(src);
                if (cap) {
                    var token = {
                        type: "html",
                        block: true,
                        raw: cap[0],
                        pre: cap[1] === "pre" || cap[1] === "script" || cap[1] === "style",
                        text: cap[0]
                    };
                    return token;
                }
            }
        },
        {
            key: "def",
            value: function def(src) {
                var cap = this.rules.block.def.exec(src);
                if (cap) {
                    var tag2 = cap[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " ");
                    var href = cap[2] ? cap[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "";
                    var title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : cap[3];
                    return {
                        type: "def",
                        tag: tag2,
                        raw: cap[0],
                        href: href,
                        title: title
                    };
                }
            }
        },
        {
            key: "table",
            value: function table(src) {
                var _this = this;
                var _cap_;
                var cap = this.rules.block.table.exec(src);
                if (!cap) return;
                if (!this.rules.other.tableDelimiter.test(cap[2])) return;
                var headers = splitCells(cap[1]);
                var aligns = cap[2].replace(this.rules.other.tableAlignChars, "").split("|");
                var rows = ((_cap_ = cap[3]) === null || _cap_ === void 0 ? void 0 : _cap_.trim()) ? cap[3].replace(this.rules.other.tableRowBlankLine, "").split("\n") : [];
                var item = {
                    type: "table",
                    raw: cap[0],
                    header: [],
                    align: [],
                    rows: []
                };
                if (headers.length !== aligns.length) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = aligns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var align = _step.value;
                        if (this.rules.other.tableAlignRight.test(align)) item.align.push("right");
                        else if (this.rules.other.tableAlignCenter.test(align)) item.align.push("center");
                        else if (this.rules.other.tableAlignLeft.test(align)) item.align.push("left");
                        else item.align.push(null);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                for(var i = 0; i < headers.length; i++)item.header.push({
                    text: headers[i],
                    tokens: this.lexer.inline(headers[i]),
                    header: true,
                    align: item.align[i]
                });
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = rows[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var row = _step1.value;
                        item.rows.push(splitCells(row, item.header.length).map(function(cell, i) {
                            return {
                                text: cell,
                                tokens: _this.lexer.inline(cell),
                                header: false,
                                align: item.align[i]
                            };
                        }));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return item;
            }
        },
        {
            key: "lheading",
            value: function lheading(src) {
                var cap = this.rules.block.lheading.exec(src);
                if (cap) return {
                    type: "heading",
                    raw: cap[0],
                    depth: cap[2].charAt(0) === "=" ? 1 : 2,
                    text: cap[1],
                    tokens: this.lexer.inline(cap[1])
                };
            }
        },
        {
            key: "paragraph",
            value: function paragraph(src) {
                var cap = this.rules.block.paragraph.exec(src);
                if (cap) {
                    var text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
                    return {
                        type: "paragraph",
                        raw: cap[0],
                        text: text,
                        tokens: this.lexer.inline(text)
                    };
                }
            }
        },
        {
            key: "text",
            value: function text(src) {
                var cap = this.rules.block.text.exec(src);
                if (cap) return {
                    type: "text",
                    raw: cap[0],
                    text: cap[0],
                    tokens: this.lexer.inline(cap[0])
                };
            }
        },
        {
            key: "escape",
            value: function escape(src) {
                var cap = this.rules.inline.escape.exec(src);
                if (cap) return {
                    type: "escape",
                    raw: cap[0],
                    text: cap[1]
                };
            }
        },
        {
            key: "tag",
            value: function tag(src) {
                var cap = this.rules.inline.tag.exec(src);
                if (cap) {
                    if (!this.lexer.state.inLink && this.rules.other.startATag.test(cap[0])) this.lexer.state.inLink = true;
                    else if (this.lexer.state.inLink && this.rules.other.endATag.test(cap[0])) this.lexer.state.inLink = false;
                    if (!this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = true;
                    else if (this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = false;
                    return {
                        type: "html",
                        raw: cap[0],
                        inLink: this.lexer.state.inLink,
                        inRawBlock: this.lexer.state.inRawBlock,
                        block: false,
                        text: cap[0]
                    };
                }
            }
        },
        {
            key: "link",
            value: function link(src) {
                var cap = this.rules.inline.link.exec(src);
                if (cap) {
                    var trimmedUrl = cap[2].trim();
                    if (!this.options.pedantic && this.rules.other.startAngleBracket.test(trimmedUrl)) {
                        if (!this.rules.other.endAngleBracket.test(trimmedUrl)) return;
                        var rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
                        if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
                    } else {
                        var lastParenIndex = findClosingBracket(cap[2], "()");
                        if (lastParenIndex === -2) return;
                        if (lastParenIndex > -1) {
                            var start = cap[0].indexOf("!") === 0 ? 5 : 4;
                            var linkLen = start + cap[1].length + lastParenIndex;
                            cap[2] = cap[2].substring(0, lastParenIndex);
                            cap[0] = cap[0].substring(0, linkLen).trim();
                            cap[3] = "";
                        }
                    }
                    var href = cap[2];
                    var title = "";
                    if (this.options.pedantic) {
                        var link2 = this.rules.other.pedanticHrefTitle.exec(href);
                        if (link2) {
                            href = link2[1];
                            title = link2[3];
                        }
                    } else title = cap[3] ? cap[3].slice(1, -1) : "";
                    href = href.trim();
                    if (this.rules.other.startAngleBracket.test(href)) {
                        if (this.options.pedantic && !this.rules.other.endAngleBracket.test(trimmedUrl)) href = href.slice(1);
                        else href = href.slice(1, -1);
                    }
                    return outputLink(cap, {
                        href: href ? href.replace(this.rules.inline.anyPunctuation, "$1") : href,
                        title: title ? title.replace(this.rules.inline.anyPunctuation, "$1") : title
                    }, cap[0], this.lexer, this.rules);
                }
            }
        },
        {
            key: "reflink",
            value: function reflink(src, links) {
                var cap;
                if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
                    var linkString = (cap[2] || cap[1]).replace(this.rules.other.multipleSpaceGlobal, " ");
                    var link2 = links[linkString.toLowerCase()];
                    if (!link2) {
                        var text = cap[0].charAt(0);
                        return {
                            type: "text",
                            raw: text,
                            text: text
                        };
                    }
                    return outputLink(cap, link2, cap[0], this.lexer, this.rules);
                }
            }
        },
        {
            key: "emStrong",
            value: function emStrong(src, maskedSrc) {
                var prevChar = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
                var match = this.rules.inline.emStrongLDelim.exec(src);
                if (!match) return;
                if (match[3] && prevChar.match(this.rules.other.unicodeAlphaNumeric)) return;
                var nextChar = match[1] || match[2] || "";
                if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
                    var lLength = (0, $aUGqu._)(match[0]).length - 1;
                    var rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                    var endReg = match[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                    endReg.lastIndex = 0;
                    maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                    while((match = endReg.exec(maskedSrc)) != null){
                        rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                        if (!rDelim) continue;
                        rLength = (0, $aUGqu._)(rDelim).length;
                        if (match[3] || match[4]) {
                            delimTotal += rLength;
                            continue;
                        } else if (match[5] || match[6]) {
                            if (lLength % 3 && !((lLength + rLength) % 3)) {
                                midDelimTotal += rLength;
                                continue;
                            }
                        }
                        delimTotal -= rLength;
                        if (delimTotal > 0) continue;
                        rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                        var lastCharLength = (0, $aUGqu._)(match[0])[0].length;
                        var raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                        if (Math.min(lLength, rLength) % 2) {
                            var text2 = raw.slice(1, -1);
                            return {
                                type: "em",
                                raw: raw,
                                text: text2,
                                tokens: this.lexer.inlineTokens(text2)
                            };
                        }
                        var text = raw.slice(2, -2);
                        return {
                            type: "strong",
                            raw: raw,
                            text: text,
                            tokens: this.lexer.inlineTokens(text)
                        };
                    }
                }
            }
        },
        {
            key: "codespan",
            value: function codespan(src) {
                var cap = this.rules.inline.code.exec(src);
                if (cap) {
                    var text = cap[2].replace(this.rules.other.newLineCharGlobal, " ");
                    var hasNonSpaceChars = this.rules.other.nonSpaceChar.test(text);
                    var hasSpaceCharsOnBothEnds = this.rules.other.startingSpaceChar.test(text) && this.rules.other.endingSpaceChar.test(text);
                    if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
                    return {
                        type: "codespan",
                        raw: cap[0],
                        text: text
                    };
                }
            }
        },
        {
            key: "br",
            value: function br(src) {
                var cap = this.rules.inline.br.exec(src);
                if (cap) return {
                    type: "br",
                    raw: cap[0]
                };
            }
        },
        {
            key: "del",
            value: function del(src) {
                var cap = this.rules.inline.del.exec(src);
                if (cap) return {
                    type: "del",
                    raw: cap[0],
                    text: cap[2],
                    tokens: this.lexer.inlineTokens(cap[2])
                };
            }
        },
        {
            key: "autolink",
            value: function autolink(src) {
                var cap = this.rules.inline.autolink.exec(src);
                if (cap) {
                    var text, href;
                    if (cap[2] === "@") {
                        text = cap[1];
                        href = "mailto:" + text;
                    } else {
                        text = cap[1];
                        href = text;
                    }
                    return {
                        type: "link",
                        raw: cap[0],
                        text: text,
                        href: href,
                        tokens: [
                            {
                                type: "text",
                                raw: text,
                                text: text
                            }
                        ]
                    };
                }
            }
        },
        {
            key: "url",
            value: function url(src) {
                var cap;
                if (cap = this.rules.inline.url.exec(src)) {
                    var text, href;
                    if (cap[2] === "@") {
                        text = cap[0];
                        href = "mailto:" + text;
                    } else {
                        var prevCapZero;
                        do {
                            var _this_rules_inline__backpedal_exec;
                            prevCapZero = cap[0];
                            var _this_rules_inline__backpedal_exec_;
                            cap[0] = (_this_rules_inline__backpedal_exec_ = (_this_rules_inline__backpedal_exec = this.rules.inline._backpedal.exec(cap[0])) === null || _this_rules_inline__backpedal_exec === void 0 ? void 0 : _this_rules_inline__backpedal_exec[0]) !== null && _this_rules_inline__backpedal_exec_ !== void 0 ? _this_rules_inline__backpedal_exec_ : "";
                        }while (prevCapZero !== cap[0]);
                        text = cap[0];
                        if (cap[1] === "www.") href = "http://" + cap[0];
                        else href = cap[0];
                    }
                    return {
                        type: "link",
                        raw: cap[0],
                        text: text,
                        href: href,
                        tokens: [
                            {
                                type: "text",
                                raw: text,
                                text: text
                            }
                        ]
                    };
                }
            }
        },
        {
            key: "inlineText",
            value: function inlineText(src) {
                var cap = this.rules.inline.text.exec(src);
                if (cap) {
                    var escaped = this.lexer.state.inRawBlock;
                    return {
                        type: "text",
                        raw: cap[0],
                        text: cap[0],
                        escaped: escaped
                    };
                }
            }
        }
    ]);
    return _Tokenizer;
}();
// src/Lexer.ts
var _Lexer = /*#__PURE__*/ function() {
    "use strict";
    function __Lexer(options2) {
        (0, $173N4._)(this, __Lexer);
        (0, $7Pjls._)(this, "tokens", void 0);
        (0, $7Pjls._)(this, "options", void 0);
        (0, $7Pjls._)(this, "state", void 0);
        (0, $7Pjls._)(this, "tokenizer", void 0);
        (0, $7Pjls._)(this, "inlineQueue", void 0);
        this.tokens = [];
        this.tokens.links = /* @__PURE__ */ Object.create(null);
        this.options = options2 || _defaults;
        this.options.tokenizer = this.options.tokenizer || new _Tokenizer();
        this.tokenizer = this.options.tokenizer;
        this.tokenizer.options = this.options;
        this.tokenizer.lexer = this;
        this.inlineQueue = [];
        this.state = {
            inLink: false,
            inRawBlock: false,
            top: true
        };
        var rules = {
            other: other,
            block: block.normal,
            inline: inline.normal
        };
        if (this.options.pedantic) {
            rules.block = block.pedantic;
            rules.inline = inline.pedantic;
        } else if (this.options.gfm) {
            rules.block = block.gfm;
            if (this.options.breaks) rules.inline = inline.breaks;
            else rules.inline = inline.gfm;
        }
        this.tokenizer.rules = rules;
    }
    (0, $cFHGC._)(__Lexer, [
        {
            /**
   * Preprocessing
   */ key: "lex",
            value: function lex(src) {
                src = src.replace(other.carriageReturn, "\n");
                this.blockTokens(src, this.tokens);
                for(var i = 0; i < this.inlineQueue.length; i++){
                    var next = this.inlineQueue[i];
                    this.inlineTokens(next.src, next.tokens);
                }
                this.inlineQueue = [];
                return this.tokens;
            }
        },
        {
            key: "blockTokens",
            value: function blockTokens(src) {
                var _this, _loop = function() {
                    var _this_options_extensions_block, _this_options_extensions, _this_options_extensions1;
                    var token = void 0;
                    if ((_this_options_extensions = _this.options.extensions) === null || _this_options_extensions === void 0 ? void 0 : (_this_options_extensions_block = _this_options_extensions.block) === null || _this_options_extensions_block === void 0 ? void 0 : _this_options_extensions_block.some(function(extTokenizer) {
                        if (token = extTokenizer.call({
                            lexer: _this1
                        }, src, tokens)) {
                            src = src.substring(token.raw.length);
                            tokens.push(token);
                            return true;
                        }
                        return false;
                    })) return "continue";
                    if (token = _this.tokenizer.space(src)) {
                        src = src.substring(token.raw.length);
                        var lastToken = tokens.at(-1);
                        if (token.raw.length === 1 && lastToken !== void 0) lastToken.raw += "\n";
                        else tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.code(src)) {
                        src = src.substring(token.raw.length);
                        var lastToken1 = tokens.at(-1);
                        if ((lastToken1 === null || lastToken1 === void 0 ? void 0 : lastToken1.type) === "paragraph" || (lastToken1 === null || lastToken1 === void 0 ? void 0 : lastToken1.type) === "text") {
                            lastToken1.raw += "\n" + token.raw;
                            lastToken1.text += "\n" + token.text;
                            _this.inlineQueue.at(-1).src = lastToken1.text;
                        } else tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.fences(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.heading(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.hr(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.blockquote(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.list(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.html(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.def(src)) {
                        src = src.substring(token.raw.length);
                        var lastToken2 = tokens.at(-1);
                        if ((lastToken2 === null || lastToken2 === void 0 ? void 0 : lastToken2.type) === "paragraph" || (lastToken2 === null || lastToken2 === void 0 ? void 0 : lastToken2.type) === "text") {
                            lastToken2.raw += "\n" + token.raw;
                            lastToken2.text += "\n" + token.raw;
                            _this.inlineQueue.at(-1).src = lastToken2.text;
                        } else if (!_this.tokens.links[token.tag]) _this.tokens.links[token.tag] = {
                            href: token.href,
                            title: token.title
                        };
                        return "continue";
                    }
                    if (token = _this.tokenizer.table(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.lheading(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    var cutSrc = src;
                    if ((_this_options_extensions1 = _this.options.extensions) === null || _this_options_extensions1 === void 0 ? void 0 : _this_options_extensions1.startBlock) {
                        var startIndex = Infinity;
                        var tempSrc = src.slice(1);
                        var tempStart = void 0;
                        _this.options.extensions.startBlock.forEach(function(getStartIndex) {
                            tempStart = getStartIndex.call({
                                lexer: _this1
                            }, tempSrc);
                            if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                        });
                        if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                    }
                    if (_this.state.top && (token = _this.tokenizer.paragraph(cutSrc))) {
                        var lastToken3 = tokens.at(-1);
                        if (lastParagraphClipped && (lastToken3 === null || lastToken3 === void 0 ? void 0 : lastToken3.type) === "paragraph") {
                            lastToken3.raw += "\n" + token.raw;
                            lastToken3.text += "\n" + token.text;
                            _this.inlineQueue.pop();
                            _this.inlineQueue.at(-1).src = lastToken3.text;
                        } else tokens.push(token);
                        lastParagraphClipped = cutSrc.length !== src.length;
                        src = src.substring(token.raw.length);
                        return "continue";
                    }
                    if (token = _this.tokenizer.text(src)) {
                        src = src.substring(token.raw.length);
                        var lastToken4 = tokens.at(-1);
                        if ((lastToken4 === null || lastToken4 === void 0 ? void 0 : lastToken4.type) === "text") {
                            lastToken4.raw += "\n" + token.raw;
                            lastToken4.text += "\n" + token.text;
                            _this.inlineQueue.pop();
                            _this.inlineQueue.at(-1).src = lastToken4.text;
                        } else tokens.push(token);
                        return "continue";
                    }
                    if (src) {
                        var errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                        if (_this.options.silent) {
                            console.error(errMsg);
                            return "break";
                        } else throw new Error(errMsg);
                    }
                };
                var _this1 = this;
                var tokens = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], lastParagraphClipped = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                if (this.options.pedantic) src = src.replace(other.tabCharGlobal, "    ").replace(other.spaceLine, "");
                while(src){
                    var _ret = (_this = this, _loop());
                    if (_ret === "break") break;
                }
                this.state.top = true;
                return tokens;
            }
        },
        {
            key: "inline",
            value: function inline(src) {
                var tokens = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                this.inlineQueue.push({
                    src: src,
                    tokens: tokens
                });
                return tokens;
            }
        },
        {
            /**
   * Lexing/Compiling
   */ key: "inlineTokens",
            value: function inlineTokens(src) {
                var _this, _loop = function() {
                    var _this_options_extensions_inline, _this_options_extensions, _this_options_extensions1;
                    if (!keepPrevChar) prevChar = "";
                    keepPrevChar = false;
                    var token = void 0;
                    if ((_this_options_extensions = _this.options.extensions) === null || _this_options_extensions === void 0 ? void 0 : (_this_options_extensions_inline = _this_options_extensions.inline) === null || _this_options_extensions_inline === void 0 ? void 0 : _this_options_extensions_inline.some(function(extTokenizer) {
                        if (token = extTokenizer.call({
                            lexer: _this1
                        }, src, tokens)) {
                            src = src.substring(token.raw.length);
                            tokens.push(token);
                            return true;
                        }
                        return false;
                    })) return "continue";
                    if (token = _this.tokenizer.escape(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.tag(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.link(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.reflink(src, _this.tokens.links)) {
                        src = src.substring(token.raw.length);
                        var lastToken = tokens.at(-1);
                        if (token.type === "text" && (lastToken === null || lastToken === void 0 ? void 0 : lastToken.type) === "text") {
                            lastToken.raw += token.raw;
                            lastToken.text += token.text;
                        } else tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.codespan(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.br(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.del(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.autolink(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (!_this.state.inLink && (token = _this.tokenizer.url(src))) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    var cutSrc = src;
                    if ((_this_options_extensions1 = _this.options.extensions) === null || _this_options_extensions1 === void 0 ? void 0 : _this_options_extensions1.startInline) {
                        var startIndex = Infinity;
                        var tempSrc = src.slice(1);
                        var tempStart = void 0;
                        _this.options.extensions.startInline.forEach(function(getStartIndex) {
                            tempStart = getStartIndex.call({
                                lexer: _this1
                            }, tempSrc);
                            if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                        });
                        if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                    }
                    if (token = _this.tokenizer.inlineText(cutSrc)) {
                        src = src.substring(token.raw.length);
                        if (token.raw.slice(-1) !== "_") prevChar = token.raw.slice(-1);
                        keepPrevChar = true;
                        var lastToken1 = tokens.at(-1);
                        if ((lastToken1 === null || lastToken1 === void 0 ? void 0 : lastToken1.type) === "text") {
                            lastToken1.raw += token.raw;
                            lastToken1.text += token.text;
                        } else tokens.push(token);
                        return "continue";
                    }
                    if (src) {
                        var errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                        if (_this.options.silent) {
                            console.error(errMsg);
                            return "break";
                        } else throw new Error(errMsg);
                    }
                };
                var _this1 = this;
                var tokens = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                var maskedSrc = src;
                var match = null;
                if (this.tokens.links) {
                    var links = Object.keys(this.tokens.links);
                    if (links.length > 0) {
                        while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                    }
                }
                while((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
                while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
                var keepPrevChar = false;
                var prevChar = "";
                while(src){
                    var _ret = (_this = this, _loop());
                    if (_ret === "break") break;
                }
                return tokens;
            }
        }
    ], [
        {
            key: "rules",
            get: /**
   * Expose Rules
   */ function get() {
                return {
                    block: block,
                    inline: inline
                };
            }
        },
        {
            key: "lex",
            value: /**
   * Static Lex Method
   */ function lex(src, options2) {
                var lexer2 = new __Lexer(options2);
                return lexer2.lex(src);
            }
        },
        {
            key: "lexInline",
            value: /**
   * Static Lex Inline Method
   */ function lexInline(src, options2) {
                var lexer2 = new __Lexer(options2);
                return lexer2.inlineTokens(src);
            }
        }
    ]);
    return __Lexer;
}();
// src/Renderer.ts
var _Renderer = /*#__PURE__*/ function() {
    "use strict";
    function _Renderer(options2) {
        (0, $173N4._)(this, _Renderer);
        (0, $7Pjls._)(this, "options", void 0);
        (0, $7Pjls._)(this, "parser", void 0);
        this.options = options2 || _defaults;
    }
    (0, $cFHGC._)(_Renderer, [
        {
            key: "space",
            value: function space(token) {
                return "";
            }
        },
        {
            key: "code",
            value: function code(param) {
                var text = param.text, lang = param.lang, escaped = param.escaped;
                var _match;
                var langString = (_match = (lang || "").match(other.notSpaceStart)) === null || _match === void 0 ? void 0 : _match[0];
                var code = text.replace(other.endingNewline, "") + "\n";
                if (!langString) return "<pre><code>" + (escaped ? code : escape2(code, true)) + "</code></pre>\n";
                return '<pre><code class="language-' + escape2(langString) + '">' + (escaped ? code : escape2(code, true)) + "</code></pre>\n";
            }
        },
        {
            key: "blockquote",
            value: function blockquote(param) {
                var tokens = param.tokens;
                var body = this.parser.parse(tokens);
                return "<blockquote>\n".concat(body, "</blockquote>\n");
            }
        },
        {
            key: "html",
            value: function html(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "heading",
            value: function heading(param) {
                var tokens = param.tokens, depth = param.depth;
                return "<h".concat(depth, ">").concat(this.parser.parseInline(tokens), "</h").concat(depth, ">\n");
            }
        },
        {
            key: "hr",
            value: function hr(token) {
                return "<hr>\n";
            }
        },
        {
            key: "list",
            value: function list(token) {
                var ordered = token.ordered;
                var start = token.start;
                var body = "";
                for(var j = 0; j < token.items.length; j++){
                    var item = token.items[j];
                    body += this.listitem(item);
                }
                var type = ordered ? "ol" : "ul";
                var startAttr = ordered && start !== 1 ? ' start="' + start + '"' : "";
                return "<" + type + startAttr + ">\n" + body + "</" + type + ">\n";
            }
        },
        {
            key: "listitem",
            value: function listitem(item) {
                var itemBody = "";
                if (item.task) {
                    var checkbox = this.checkbox({
                        checked: !!item.checked
                    });
                    if (item.loose) {
                        var _item_tokens_;
                        if (((_item_tokens_ = item.tokens[0]) === null || _item_tokens_ === void 0 ? void 0 : _item_tokens_.type) === "paragraph") {
                            item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                            if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") {
                                item.tokens[0].tokens[0].text = checkbox + " " + escape2(item.tokens[0].tokens[0].text);
                                item.tokens[0].tokens[0].escaped = true;
                            }
                        } else item.tokens.unshift({
                            type: "text",
                            raw: checkbox + " ",
                            text: checkbox + " ",
                            escaped: true
                        });
                    } else itemBody += checkbox + " ";
                }
                itemBody += this.parser.parse(item.tokens, !!item.loose);
                return "<li>".concat(itemBody, "</li>\n");
            }
        },
        {
            key: "checkbox",
            value: function checkbox(param) {
                var checked = param.checked;
                return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
            }
        },
        {
            key: "paragraph",
            value: function paragraph(param) {
                var tokens = param.tokens;
                return "<p>".concat(this.parser.parseInline(tokens), "</p>\n");
            }
        },
        {
            key: "table",
            value: function table(token) {
                var header = "";
                var cell = "";
                for(var j = 0; j < token.header.length; j++)cell += this.tablecell(token.header[j]);
                header += this.tablerow({
                    text: cell
                });
                var body = "";
                for(var j1 = 0; j1 < token.rows.length; j1++){
                    var row = token.rows[j1];
                    cell = "";
                    for(var k = 0; k < row.length; k++)cell += this.tablecell(row[k]);
                    body += this.tablerow({
                        text: cell
                    });
                }
                if (body) body = "<tbody>".concat(body, "</tbody>");
                return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
            }
        },
        {
            key: "tablerow",
            value: function tablerow(param) {
                var text = param.text;
                return "<tr>\n".concat(text, "</tr>\n");
            }
        },
        {
            key: "tablecell",
            value: function tablecell(token) {
                var content = this.parser.parseInline(token.tokens);
                var type = token.header ? "th" : "td";
                var tag2 = token.align ? "<".concat(type, ' align="').concat(token.align, '">') : "<".concat(type, ">");
                return tag2 + content + "</".concat(type, ">\n");
            }
        },
        {
            /**
   * span level renderer
   */ key: "strong",
            value: function strong(param) {
                var tokens = param.tokens;
                return "<strong>".concat(this.parser.parseInline(tokens), "</strong>");
            }
        },
        {
            key: "em",
            value: function em(param) {
                var tokens = param.tokens;
                return "<em>".concat(this.parser.parseInline(tokens), "</em>");
            }
        },
        {
            key: "codespan",
            value: function codespan(param) {
                var text = param.text;
                return "<code>".concat(escape2(text, true), "</code>");
            }
        },
        {
            key: "br",
            value: function br(token) {
                return "<br>";
            }
        },
        {
            key: "del",
            value: function del(param) {
                var tokens = param.tokens;
                return "<del>".concat(this.parser.parseInline(tokens), "</del>");
            }
        },
        {
            key: "link",
            value: function link(param) {
                var href = param.href, title = param.title, tokens = param.tokens;
                var text = this.parser.parseInline(tokens);
                var cleanHref = cleanUrl(href);
                if (cleanHref === null) return text;
                href = cleanHref;
                var out = '<a href="' + href + '"';
                if (title) out += ' title="' + escape2(title) + '"';
                out += ">" + text + "</a>";
                return out;
            }
        },
        {
            key: "image",
            value: function image(param) {
                var href = param.href, title = param.title, text = param.text, tokens = param.tokens;
                if (tokens) text = this.parser.parseInline(tokens, this.parser.textRenderer);
                var cleanHref = cleanUrl(href);
                if (cleanHref === null) return escape2(text);
                href = cleanHref;
                var out = '<img src="'.concat(href, '" alt="').concat(text, '"');
                if (title) out += ' title="'.concat(escape2(title), '"');
                out += ">";
                return out;
            }
        },
        {
            key: "text",
            value: function text(token) {
                return "tokens" in token && token.tokens ? this.parser.parseInline(token.tokens) : "escaped" in token && token.escaped ? token.text : escape2(token.text);
            }
        }
    ]);
    return _Renderer;
}();
// src/TextRenderer.ts
var _TextRenderer = /*#__PURE__*/ function() {
    "use strict";
    function _TextRenderer() {
        (0, $173N4._)(this, _TextRenderer);
    }
    (0, $cFHGC._)(_TextRenderer, [
        {
            // no need for block level renderers
            key: "strong",
            value: function strong(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "em",
            value: function em(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "codespan",
            value: function codespan(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "del",
            value: function del(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "html",
            value: function html(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "text",
            value: function text(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "link",
            value: function link(param) {
                var text = param.text;
                return "" + text;
            }
        },
        {
            key: "image",
            value: function image(param) {
                var text = param.text;
                return "" + text;
            }
        },
        {
            key: "br",
            value: function br() {
                return "";
            }
        }
    ]);
    return _TextRenderer;
}();
// src/Parser.ts
var _Parser = /*#__PURE__*/ function() {
    "use strict";
    function __Parser(options2) {
        (0, $173N4._)(this, __Parser);
        (0, $7Pjls._)(this, "options", void 0);
        (0, $7Pjls._)(this, "renderer", void 0);
        (0, $7Pjls._)(this, "textRenderer", void 0);
        this.options = options2 || _defaults;
        this.options.renderer = this.options.renderer || new _Renderer();
        this.renderer = this.options.renderer;
        this.renderer.options = this.options;
        this.renderer.parser = this;
        this.textRenderer = new _TextRenderer();
    }
    (0, $cFHGC._)(__Parser, [
        {
            /**
   * Parse Loop
   */ key: "parse",
            value: function parse(tokens) {
                var top = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var out = "";
                for(var i = 0; i < tokens.length; i++){
                    var _this_options_extensions_renderers, _this_options_extensions;
                    var anyToken = tokens[i];
                    if ((_this_options_extensions = this.options.extensions) === null || _this_options_extensions === void 0 ? void 0 : (_this_options_extensions_renderers = _this_options_extensions.renderers) === null || _this_options_extensions_renderers === void 0 ? void 0 : _this_options_extensions_renderers[anyToken.type]) {
                        var genericToken = anyToken;
                        var ret = this.options.extensions.renderers[genericToken.type].call({
                            parser: this
                        }, genericToken);
                        if (ret !== false || ![
                            "space",
                            "hr",
                            "heading",
                            "code",
                            "table",
                            "blockquote",
                            "list",
                            "html",
                            "paragraph",
                            "text"
                        ].includes(genericToken.type)) {
                            out += ret || "";
                            continue;
                        }
                    }
                    var token = anyToken;
                    switch(token.type){
                        case "space":
                            out += this.renderer.space(token);
                            continue;
                        case "hr":
                            out += this.renderer.hr(token);
                            continue;
                        case "heading":
                            out += this.renderer.heading(token);
                            continue;
                        case "code":
                            out += this.renderer.code(token);
                            continue;
                        case "table":
                            out += this.renderer.table(token);
                            continue;
                        case "blockquote":
                            out += this.renderer.blockquote(token);
                            continue;
                        case "list":
                            out += this.renderer.list(token);
                            continue;
                        case "html":
                            out += this.renderer.html(token);
                            continue;
                        case "paragraph":
                            out += this.renderer.paragraph(token);
                            continue;
                        case "text":
                            {
                                var textToken = token;
                                var body = this.renderer.text(textToken);
                                while(i + 1 < tokens.length && tokens[i + 1].type === "text"){
                                    textToken = tokens[++i];
                                    body += "\n" + this.renderer.text(textToken);
                                }
                                if (top) out += this.renderer.paragraph({
                                    type: "paragraph",
                                    raw: body,
                                    text: body,
                                    tokens: [
                                        {
                                            type: "text",
                                            raw: body,
                                            text: body,
                                            escaped: true
                                        }
                                    ]
                                });
                                else out += body;
                                continue;
                            }
                        default:
                            {
                                var errMsg = 'Token with "' + token.type + '" type was not found.';
                                if (this.options.silent) {
                                    console.error(errMsg);
                                    return "";
                                } else throw new Error(errMsg);
                            }
                    }
                }
                return out;
            }
        },
        {
            /**
   * Parse Inline Tokens
   */ key: "parseInline",
            value: function parseInline(tokens) {
                var renderer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.renderer;
                var out = "";
                for(var i = 0; i < tokens.length; i++){
                    var _this_options_extensions_renderers, _this_options_extensions;
                    var anyToken = tokens[i];
                    if ((_this_options_extensions = this.options.extensions) === null || _this_options_extensions === void 0 ? void 0 : (_this_options_extensions_renderers = _this_options_extensions.renderers) === null || _this_options_extensions_renderers === void 0 ? void 0 : _this_options_extensions_renderers[anyToken.type]) {
                        var ret = this.options.extensions.renderers[anyToken.type].call({
                            parser: this
                        }, anyToken);
                        if (ret !== false || ![
                            "escape",
                            "html",
                            "link",
                            "image",
                            "strong",
                            "em",
                            "codespan",
                            "br",
                            "del",
                            "text"
                        ].includes(anyToken.type)) {
                            out += ret || "";
                            continue;
                        }
                    }
                    var token = anyToken;
                    switch(token.type){
                        case "escape":
                            out += renderer.text(token);
                            break;
                        case "html":
                            out += renderer.html(token);
                            break;
                        case "link":
                            out += renderer.link(token);
                            break;
                        case "image":
                            out += renderer.image(token);
                            break;
                        case "strong":
                            out += renderer.strong(token);
                            break;
                        case "em":
                            out += renderer.em(token);
                            break;
                        case "codespan":
                            out += renderer.codespan(token);
                            break;
                        case "br":
                            out += renderer.br(token);
                            break;
                        case "del":
                            out += renderer.del(token);
                            break;
                        case "text":
                            out += renderer.text(token);
                            break;
                        default:
                            {
                                var errMsg = 'Token with "' + token.type + '" type was not found.';
                                if (this.options.silent) {
                                    console.error(errMsg);
                                    return "";
                                } else throw new Error(errMsg);
                            }
                    }
                }
                return out;
            }
        }
    ], [
        {
            key: "parse",
            value: /**
   * Static Parse Method
   */ function parse(tokens, options2) {
                var parser2 = new __Parser(options2);
                return parser2.parse(tokens);
            }
        },
        {
            key: "parseInline",
            value: /**
   * Static Parse Inline Method
   */ function parseInline(tokens, options2) {
                var parser2 = new __Parser(options2);
                return parser2.parseInline(tokens);
            }
        }
    ]);
    return __Parser;
}();
// src/Hooks.ts
var _Hooks = (_class = /*#__PURE__*/ function() {
    "use strict";
    function _class(options2) {
        (0, $173N4._)(this, _class);
        (0, $7Pjls._)(this, "options", void 0);
        (0, $7Pjls._)(this, "block", void 0);
        this.options = options2 || _defaults;
    }
    (0, $cFHGC._)(_class, [
        {
            /**
   * Process markdown before marked
   */ key: "preprocess",
            value: function preprocess(markdown) {
                return markdown;
            }
        },
        {
            /**
   * Process HTML after marked is finished
   */ key: "postprocess",
            value: function postprocess(html2) {
                return html2;
            }
        },
        {
            /**
   * Process all tokens before walk tokens
   */ key: "processAllTokens",
            value: function processAllTokens(tokens) {
                return tokens;
            }
        },
        {
            /**
   * Provide function to tokenize markdown
   */ key: "provideLexer",
            value: function provideLexer() {
                return this.block ? _Lexer.lex : _Lexer.lexInline;
            }
        },
        {
            /**
   * Provide function to parse tokens
   */ key: "provideParser",
            value: function provideParser() {
                return this.block ? _Parser.parse : _Parser.parseInline;
            }
        }
    ]);
    return _class;
}(), (0, $7Pjls._)(_class, "passThroughHooks", /* @__PURE__ */ new Set([
    "preprocess",
    "postprocess",
    "processAllTokens"
])), _class);
// src/Instance.ts
var Marked = /*#__PURE__*/ function() {
    "use strict";
    function Marked() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, Marked);
        (0, $7Pjls._)(this, "defaults", _getDefaults());
        (0, $7Pjls._)(this, "options", this.setOptions);
        (0, $7Pjls._)(this, "parse", this.parseMarkdown(true));
        (0, $7Pjls._)(this, "parseInline", this.parseMarkdown(false));
        (0, $7Pjls._)(this, "Parser", _Parser);
        (0, $7Pjls._)(this, "Renderer", _Renderer);
        (0, $7Pjls._)(this, "TextRenderer", _TextRenderer);
        (0, $7Pjls._)(this, "Lexer", _Lexer);
        (0, $7Pjls._)(this, "Tokenizer", _Tokenizer);
        (0, $7Pjls._)(this, "Hooks", _Hooks);
        this.use.apply(this, (0, $aUGqu._)(args));
    }
    (0, $cFHGC._)(Marked, [
        {
            /**
   * Run callback for every token
   */ key: "walkTokens",
            value: function walkTokens(tokens, callback) {
                var _this = this;
                var values = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _this1, _loop = function() {
                        var token = _step.value;
                        values = values.concat(callback.call(_this1, token));
                        switch(token.type){
                            case "table":
                                {
                                    var tableToken = token;
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = tableToken.header[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var cell = _step1.value;
                                            values = values.concat(_this1.walkTokens(cell.tokens, callback));
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined, _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                    try {
                                        for(var _iterator1 = tableToken.rows[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator1.next()).done); _iteratorNormalCompletion2 = true){
                                            var row = _step2.value;
                                            try {
                                                for(var _iterator2 = row[Symbol.iterator](), _step3; !(_iteratorNormalCompletion1 = (_step3 = _iterator2.next()).done); _iteratorNormalCompletion1 = true){
                                                    var cell1 = _step3.value;
                                                    values = values.concat(_this1.walkTokens(cell1.tokens, callback));
                                                }
                                            } catch (err) {
                                                _didIteratorError1 = true;
                                                _iteratorError1 = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion1 && _iterator2.return != null) {
                                                        _iterator2.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError1) {
                                                        throw _iteratorError1;
                                                    }
                                                }
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError2) {
                                                throw _iteratorError2;
                                            }
                                        }
                                    }
                                    break;
                                }
                            case "list":
                                {
                                    var listToken = token;
                                    values = values.concat(_this1.walkTokens(listToken.items, callback));
                                    break;
                                }
                            default:
                                {
                                    var _this_defaults_extensions_childTokens, _this_defaults_extensions;
                                    var genericToken = token;
                                    if ((_this_defaults_extensions = _this1.defaults.extensions) === null || _this_defaults_extensions === void 0 ? void 0 : (_this_defaults_extensions_childTokens = _this_defaults_extensions.childTokens) === null || _this_defaults_extensions_childTokens === void 0 ? void 0 : _this_defaults_extensions_childTokens[genericToken.type]) _this1.defaults.extensions.childTokens[genericToken.type].forEach(function(childTokens) {
                                        var tokens2 = genericToken[childTokens].flat(Infinity);
                                        values = values.concat(_this.walkTokens(tokens2, callback));
                                    });
                                    else if (genericToken.tokens) values = values.concat(_this1.walkTokens(genericToken.tokens, callback));
                                }
                        }
                    };
                    for(var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_this1 = this, _loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return values;
            }
        },
        {
            key: "use",
            value: function use() {
                var _this = this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var extensions = this.defaults.extensions || {
                    renderers: {},
                    childTokens: {}
                };
                args.forEach(function(pack) {
                    var opts = (0, $1XAnY._)({}, pack);
                    opts.async = _this.defaults.async || opts.async || false;
                    if (pack.extensions) {
                        pack.extensions.forEach(function(ext) {
                            if (!ext.name) throw new Error("extension name required");
                            if ("renderer" in ext) {
                                var prevRenderer = extensions.renderers[ext.name];
                                if (prevRenderer) extensions.renderers[ext.name] = function() {
                                    for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
                                        args2[_key] = arguments[_key];
                                    }
                                    var ret = ext.renderer.apply(this, args2);
                                    if (ret === false) ret = prevRenderer.apply(this, args2);
                                    return ret;
                                };
                                else extensions.renderers[ext.name] = ext.renderer;
                            }
                            if ("tokenizer" in ext) {
                                if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                                var extLevel = extensions[ext.level];
                                if (extLevel) extLevel.unshift(ext.tokenizer);
                                else extensions[ext.level] = [
                                    ext.tokenizer
                                ];
                                if (ext.start) {
                                    if (ext.level === "block") {
                                        if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                        else extensions.startBlock = [
                                            ext.start
                                        ];
                                    } else if (ext.level === "inline") {
                                        if (extensions.startInline) extensions.startInline.push(ext.start);
                                        else extensions.startInline = [
                                            ext.start
                                        ];
                                    }
                                }
                            }
                            if ("childTokens" in ext && ext.childTokens) extensions.childTokens[ext.name] = ext.childTokens;
                        });
                        opts.extensions = extensions;
                    }
                    if (pack.renderer) {
                        var _loop = function(prop) {
                            if (!(prop in renderer)) throw new Error("renderer '".concat(prop, "' does not exist"));
                            if ([
                                "options",
                                "parser"
                            ].includes(prop)) return "continue";
                            var rendererProp = prop;
                            var rendererFunc = pack.renderer[rendererProp];
                            var prevRenderer = renderer[rendererProp];
                            renderer[rendererProp] = function() {
                                for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
                                    args2[_key] = arguments[_key];
                                }
                                var ret = rendererFunc.apply(renderer, args2);
                                if (ret === false) ret = prevRenderer.apply(renderer, args2);
                                return ret || "";
                            };
                        };
                        var renderer = _this.defaults.renderer || new _Renderer(_this.defaults);
                        for(var prop in pack.renderer)_loop(prop);
                        opts.renderer = renderer;
                    }
                    if (pack.tokenizer) {
                        var _loop1 = function(prop1) {
                            if (!(prop1 in tokenizer)) throw new Error("tokenizer '".concat(prop1, "' does not exist"));
                            if ([
                                "options",
                                "rules",
                                "lexer"
                            ].includes(prop1)) return "continue";
                            var tokenizerProp = prop1;
                            var tokenizerFunc = pack.tokenizer[tokenizerProp];
                            var prevTokenizer = tokenizer[tokenizerProp];
                            tokenizer[tokenizerProp] = function() {
                                for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
                                    args2[_key] = arguments[_key];
                                }
                                var ret = tokenizerFunc.apply(tokenizer, args2);
                                if (ret === false) ret = prevTokenizer.apply(tokenizer, args2);
                                return ret;
                            };
                        };
                        var tokenizer = _this.defaults.tokenizer || new _Tokenizer(_this.defaults);
                        for(var prop1 in pack.tokenizer)_loop1(prop1);
                        opts.tokenizer = tokenizer;
                    }
                    if (pack.hooks) {
                        var _loop2 = function(prop2) {
                            if (!(prop2 in hooks)) throw new Error("hook '".concat(prop2, "' does not exist"));
                            if ([
                                "options",
                                "block"
                            ].includes(prop2)) return "continue";
                            var hooksProp = prop2;
                            var hooksFunc = pack.hooks[hooksProp];
                            var prevHook = hooks[hooksProp];
                            if (_Hooks.passThroughHooks.has(prop2)) hooks[hooksProp] = function(arg) {
                                if (_this.defaults.async) return Promise.resolve(hooksFunc.call(hooks, arg)).then(function(ret2) {
                                    return prevHook.call(hooks, ret2);
                                });
                                var ret = hooksFunc.call(hooks, arg);
                                return prevHook.call(hooks, ret);
                            };
                            else hooks[hooksProp] = function() {
                                for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
                                    args2[_key] = arguments[_key];
                                }
                                var ret = hooksFunc.apply(hooks, args2);
                                if (ret === false) ret = prevHook.apply(hooks, args2);
                                return ret;
                            };
                        };
                        var hooks = _this.defaults.hooks || new _Hooks();
                        for(var prop2 in pack.hooks)_loop2(prop2);
                        opts.hooks = hooks;
                    }
                    if (pack.walkTokens) {
                        var walkTokens2 = _this.defaults.walkTokens;
                        var packWalktokens = pack.walkTokens;
                        opts.walkTokens = function(token) {
                            var values = [];
                            values.push(packWalktokens.call(this, token));
                            if (walkTokens2) values = values.concat(walkTokens2.call(this, token));
                            return values;
                        };
                    }
                    _this.defaults = (0, $1XAnY._)({}, _this.defaults, opts);
                });
                return this;
            }
        },
        {
            key: "setOptions",
            value: function setOptions(opt) {
                this.defaults = (0, $1XAnY._)({}, this.defaults, opt);
                return this;
            }
        },
        {
            key: "lexer",
            value: function lexer(src, options2) {
                return _Lexer.lex(src, options2 !== null && options2 !== void 0 ? options2 : this.defaults);
            }
        },
        {
            key: "parser",
            value: function parser(tokens, options2) {
                return _Parser.parse(tokens, options2 !== null && options2 !== void 0 ? options2 : this.defaults);
            }
        },
        {
            key: "parseMarkdown",
            value: function parseMarkdown(blockType) {
                var _this = this;
                var parse2 = function(src, options2) {
                    var origOpt = (0, $1XAnY._)({}, options2);
                    var opt = (0, $1XAnY._)({}, _this.defaults, origOpt);
                    var throwError = _this.onError(!!opt.silent, !!opt.async);
                    if (_this.defaults.async === true && origOpt.async === false) return throwError(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
                    if (typeof src === "undefined" || src === null) return throwError(new Error("marked(): input parameter is undefined or null"));
                    if (typeof src !== "string") return throwError(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
                    if (opt.hooks) {
                        opt.hooks.options = opt;
                        opt.hooks.block = blockType;
                    }
                    var lexer2 = opt.hooks ? opt.hooks.provideLexer() : blockType ? _Lexer.lex : _Lexer.lexInline;
                    var parser2 = opt.hooks ? opt.hooks.provideParser() : blockType ? _Parser.parse : _Parser.parseInline;
                    if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then(function(src2) {
                        return lexer2(src2, opt);
                    }).then(function(tokens) {
                        return opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens;
                    }).then(function(tokens) {
                        return opt.walkTokens ? Promise.all(_this.walkTokens(tokens, opt.walkTokens)).then(function() {
                            return tokens;
                        }) : tokens;
                    }).then(function(tokens) {
                        return parser2(tokens, opt);
                    }).then(function(html2) {
                        return opt.hooks ? opt.hooks.postprocess(html2) : html2;
                    }).catch(throwError);
                    try {
                        if (opt.hooks) src = opt.hooks.preprocess(src);
                        var tokens = lexer2(src, opt);
                        if (opt.hooks) tokens = opt.hooks.processAllTokens(tokens);
                        if (opt.walkTokens) _this.walkTokens(tokens, opt.walkTokens);
                        var html2 = parser2(tokens, opt);
                        if (opt.hooks) html2 = opt.hooks.postprocess(html2);
                        return html2;
                    } catch (e) {
                        return throwError(e);
                    }
                };
                return parse2;
            }
        },
        {
            key: "onError",
            value: function onError(silent, async) {
                return function(e) {
                    e.message += "\nPlease report this to https://github.com/markedjs/marked.";
                    if (silent) {
                        var msg = "<p>An error occurred:</p><pre>" + escape2(e.message + "", true) + "</pre>";
                        if (async) return Promise.resolve(msg);
                        return msg;
                    }
                    if (async) return Promise.reject(e);
                    throw e;
                };
            }
        }
    ]);
    return Marked;
}();
// src/marked.ts
var markedInstance = new Marked();
function marked(src, opt) {
    return markedInstance.parse(src, opt);
}
marked.options = marked.setOptions = function(options2) {
    markedInstance.setOptions(options2);
    marked.defaults = markedInstance.defaults;
    changeDefaults(marked.defaults);
    return marked;
};
marked.getDefaults = _getDefaults;
marked.defaults = _defaults;
marked.use = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _markedInstance;
    (_markedInstance = markedInstance).use.apply(_markedInstance, (0, $aUGqu._)(args));
    marked.defaults = markedInstance.defaults;
    changeDefaults(marked.defaults);
    return marked;
};
marked.walkTokens = function(tokens, callback) {
    return markedInstance.walkTokens(tokens, callback);
};
marked.parseInline = markedInstance.parseInline;
marked.Parser = _Parser;
marked.parser = _Parser.parse;
marked.Renderer = _Renderer;
marked.TextRenderer = _TextRenderer;
marked.Lexer = _Lexer;
marked.lexer = _Lexer.lex;
marked.Tokenizer = _Tokenizer;
marked.Hooks = _Hooks;
marked.parse = marked;
var options = marked.options;
var setOptions = marked.setOptions;
var use = marked.use;
var walkTokens = marked.walkTokens;
var parseInline = marked.parseInline;
var parse = marked;
var parser = _Parser.parse;
var lexer = _Lexer.lex;

});

parcelRegister("c9Z2T", function(module, exports) {

$parcel$export(module.exports, "HTTPClient", function () { return $cbd22d3323bef9ca$export$45cf759b359d3d24; });

var $gXzGB = parcelRequire("gXzGB");

var $dafVd = parcelRequire("dafVd");

var $3gP77 = parcelRequire("3gP77");

var $dm3mz = parcelRequire("dm3mz");

var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $dWsrg = parcelRequire("dWsrg");

var $kg0zo = parcelRequire("kg0zo");

var $hdIku = parcelRequire("hdIku");

var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");

var $7t5yo = parcelRequire("7t5yo");

var $1SdK7 = parcelRequire("1SdK7");

var $13u2V = parcelRequire("13u2V");

var $318vE = parcelRequire("318vE");

var $lhPyT = parcelRequire("lhPyT");
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $eef213ff4197108b$exports = {};
$parcel$export($eef213ff4197108b$exports, "Stack", function() {
    return $eef213ff4197108b$export$694e0d28c7ffc90c;
});
var _Array_prototype = Array.prototype, $eef213ff4197108b$var$push = _Array_prototype.push;
var $eef213ff4197108b$export$694e0d28c7ffc90c = /*#__PURE__*/ function() {
    "use strict";
    function $eef213ff4197108b$export$694e0d28c7ffc90c() {
        (0, $173N4._)(this, $eef213ff4197108b$export$694e0d28c7ffc90c);
        this.length = 0;
    }
    (0, $cFHGC._)($eef213ff4197108b$export$694e0d28c7ffc90c, [
        {
            key: "use",
            value: function use() {
                for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
                    middlewares[_key] = arguments[_key];
                }
                $eef213ff4197108b$var$push.apply(this, middlewares);
                return this;
            }
        },
        {
            key: "execute",
            value: function execute(context) {
                var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var middleware = this[depth];
                if (middleware instanceof Function) return middleware(context, this.execute.bind(this, context, ++depth));
            }
        },
        {
            key: "mount",
            value: function mount(condition, stack) {
                return this.use(function(context, next) {
                    return condition(context) ? stack.execute(context) : next();
                });
            }
        }
    ]);
    return $eef213ff4197108b$export$694e0d28c7ffc90c;
}();
var $0fe1f1400993ba8a$exports = {};
$parcel$export($0fe1f1400993ba8a$exports, "BodyRequestMethods", function() {
    return $0fe1f1400993ba8a$export$4125cfe7e08e2040;
});
$parcel$export($0fe1f1400993ba8a$exports, "HTTPError", function() {
    return $0fe1f1400993ba8a$export$aa9d629c530f62a7;
});
$parcel$export($0fe1f1400993ba8a$exports, "headerParser", function() {
    return $0fe1f1400993ba8a$export$b725a69477e4d33f;
});
$parcel$export($0fe1f1400993ba8a$exports, "parseHeaders", function() {
    return $0fe1f1400993ba8a$export$eea2c1c5e1a37e50;
});
$parcel$export($0fe1f1400993ba8a$exports, "parseBody", function() {
    return $0fe1f1400993ba8a$export$3b629cd0ff482602;
});
$parcel$export($0fe1f1400993ba8a$exports, "FILE_TYPE_MAGIC_NUMBER_SIZE", function() {
    return $0fe1f1400993ba8a$export$153cac11fce574d;
});
$parcel$export($0fe1f1400993ba8a$exports, "defaultHTTPRuntime", function() {
    return $0fe1f1400993ba8a$export$80e06a8ed038dcf8;
});
$parcel$export($0fe1f1400993ba8a$exports, "HTTPToolkit", function() {
    return $0fe1f1400993ba8a$export$7370b3fc922cf1e6;
});
$parcel$export($0fe1f1400993ba8a$exports, "requestXHR", function() {
    return $0fe1f1400993ba8a$export$4f2a8c8c11a6373a;
});
$parcel$export($0fe1f1400993ba8a$exports, "requestFetch", function() {
    return $0fe1f1400993ba8a$export$bda27a3e49197b9;
});
$parcel$export($0fe1f1400993ba8a$exports, "parseResponse", function() {
    return $0fe1f1400993ba8a$export$ba14d9a5a581e827;
});
$parcel$export($0fe1f1400993ba8a$exports, "parseFetchBody", function() {
    return $0fe1f1400993ba8a$export$b7b86d31099674dc;
});
$parcel$export($0fe1f1400993ba8a$exports, "rawRequest", function() {
    return $0fe1f1400993ba8a$export$3052fa16c23a17ef;
});
$parcel$export($0fe1f1400993ba8a$exports, "requestHead", function() {
    return $0fe1f1400993ba8a$export$199f266664335871;
});
$parcel$export($0fe1f1400993ba8a$exports, "request", function() {
    return $0fe1f1400993ba8a$export$b5fe3f66a567bec0;
});
var $22de11b45b0eeb97$exports = {};
$parcel$export($22de11b45b0eeb97$exports, "FileMethod", function() {
    return $22de11b45b0eeb97$export$226b21d2db5eaf9f;
});
$parcel$export($22de11b45b0eeb97$exports, "defaultDataRuntime", function() {
    return $22de11b45b0eeb97$export$f7195e83247c5fe1;
});
$parcel$export($22de11b45b0eeb97$exports, "DataToolkit", function() {
    return $22de11b45b0eeb97$export$bc241bb96b6158a8;
});
$parcel$export($22de11b45b0eeb97$exports, "polyfillProgressEvent", function() {
    return $22de11b45b0eeb97$export$5e6a03ce7b01784;
});
$parcel$export($22de11b45b0eeb97$exports, "parseDocument", function() {
    return $22de11b45b0eeb97$export$b6a9369736b19f4d;
});
$parcel$export($22de11b45b0eeb97$exports, "makeFormData", function() {
    return $22de11b45b0eeb97$export$2c28ab2e118e73f1;
});
$parcel$export($22de11b45b0eeb97$exports, "serializeNode", function() {
    return $22de11b45b0eeb97$export$a0beee2e55fb5dd1;
});
$parcel$export($22de11b45b0eeb97$exports, "serialize", function() {
    return $22de11b45b0eeb97$export$dfdc1655ccc5b9cb;
});
$parcel$export($22de11b45b0eeb97$exports, "takeBytes", function() {
    return $22de11b45b0eeb97$export$45c4469e58b7b0ca;
});
$parcel$export($22de11b45b0eeb97$exports, "readBytes", function() {
    return $22de11b45b0eeb97$export$f9f241124ee3198e;
});
$parcel$export($22de11b45b0eeb97$exports, "makeStream", function() {
    return $22de11b45b0eeb97$export$4b366c43f3cabead;
});
$parcel$export($22de11b45b0eeb97$exports, "streamFromProgress", function() {
    return $22de11b45b0eeb97$export$f8162fcba31fa547;
});
$parcel$export($22de11b45b0eeb97$exports, "emitStreamProgress", function() {
    return $22de11b45b0eeb97$export$cebfdbc318a33abe;
});
$parcel$export($22de11b45b0eeb97$exports, "readAs", function() {
    return $22de11b45b0eeb97$export$e209cbb66c5b18c;
});
$parcel$export($22de11b45b0eeb97$exports, "encodeBase64", function() {
    return $22de11b45b0eeb97$export$8fb536984ec8b4d7;
});
var $22de11b45b0eeb97$export$226b21d2db5eaf9f = /*#__PURE__*/ function(FileMethod) {
    FileMethod["text"] = "readAsText";
    FileMethod["dataURL"] = "readAsDataURL";
    FileMethod["binaryString"] = "readAsBinaryString";
    FileMethod["arrayBuffer"] = "readAsArrayBuffer";
    return FileMethod;
}({});
var $22de11b45b0eeb97$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
var $22de11b45b0eeb97$export$f7195e83247c5fe1 = {
    DOMParser: globalThis.DOMParser,
    Node: globalThis.Node,
    Document: globalThis.Document,
    HTMLElement: globalThis.HTMLElement,
    SVGElement: globalThis.SVGElement,
    FormData: globalThis.FormData,
    URLSearchParams: globalThis.URLSearchParams,
    Blob: globalThis.Blob,
    FileReader: globalThis.FileReader,
    Event: globalThis.Event,
    ProgressEvent: globalThis.ProgressEvent,
    ReadableStream: (0, $318vE.ReadableStream)
};
var $22de11b45b0eeb97$export$bc241bb96b6158a8 = /*#__PURE__*/ function() {
    "use strict";
    function $22de11b45b0eeb97$export$bc241bb96b6158a8() {
        var _this = this;
        var runtime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $22de11b45b0eeb97$export$f7195e83247c5fe1;
        var _this1 = this;
        (0, $173N4._)(this, $22de11b45b0eeb97$export$bc241bb96b6158a8);
        var _this2 = this;
        var _globalThis;
        this.runtime = runtime;
        this.polyfillProgressEvent = function() {
            return (_globalThis = globalThis).ProgressEvent || (_globalThis.ProgressEvent = /*#__PURE__*/ function(_this_runtime_Event) {
                (0, $hdIku._)(ProgressEvent, _this_runtime_Event);
                function ProgressEvent(type) {
                    var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    (0, $173N4._)(this, ProgressEvent);
                    var _this;
                    var lengthComputable = _param.lengthComputable, total = _param.total, loaded = _param.loaded, meta = (0, $6acIq._)(_param, [
                        "lengthComputable",
                        "total",
                        "loaded"
                    ]);
                    _this = (0, $7qXGD._)(this, ProgressEvent, [
                        type,
                        meta
                    ]);
                    _this.lengthComputable = lengthComputable;
                    _this.total = total;
                    _this.loaded = loaded;
                    return _this;
                }
                return ProgressEvent;
            }(_this2.runtime.Event));
        };
        this.parseDocument = function(text) {
            var contentType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var _this_runtime, DOMParser, _ref, type;
                return (0, $13u2V._)(this, function(_state) {
                    _this_runtime = this.runtime, DOMParser = _this_runtime.DOMParser;
                    _ref = (0, $f9AOD._)((contentType === null || contentType === void 0 ? void 0 : contentType.split(';')) || [], 1), type = _ref[0];
                    return [
                        2,
                        new DOMParser().parseFromString(text, type || 'text/html')
                    ];
                });
            }).call(_this1);
        };
        this.makeFormData = function(data) {
            var _this_runtime = _this.runtime, FormData = _this_runtime.FormData;
            var formData = new FormData();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(data)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $f9AOD._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                    var list = typeof value !== 'string' && (0, $lhPyT.likeArray)(value) ? value : [
                        value
                    ];
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = Array.from(list)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var item = _step1.value;
                            if (item != null) {
                                if ((typeof item === "undefined" ? "undefined" : (0, $7E0eS._)(item)) === 'object') formData.append(key, item, item.name);
                                else formData.append(key, item);
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return formData;
        };
        this.serializeNode = function(root) {
            var _this_runtime = _this.runtime, URLSearchParams = _this_runtime.URLSearchParams, FormData = _this_runtime.FormData, Document = _this_runtime.Document, HTMLElement = _this_runtime.HTMLElement, SVGElement = _this_runtime.SVGElement;
            var contentType;
            if (!(root instanceof HTMLFormElement)) return {
                contentType: root instanceof SVGElement ? 'image/svg' : root instanceof Document || root instanceof HTMLElement ? 'text/html' : 'application/xml',
                data: (0, $lhPyT.stringifyDOM)(root)
            };
            if (root.querySelector('input[type="file"][name]')) return {
                contentType: 'multipart/form-data',
                data: new FormData(root)
            };
            var data = (0, $lhPyT.formToJSON)(root);
            switch(contentType = root.enctype){
                case 'text/plain':
                    return {
                        contentType: contentType,
                        data: Object.entries(data).map(function(param) {
                            var _param = (0, $f9AOD._)(param, 2), name = _param[0], value = _param[1];
                            return "".concat(name, "=").concat(value);
                        }).join('\n')
                    };
                case 'application/x-www-form-urlencoded':
                    return {
                        contentType: contentType,
                        data: new URLSearchParams(data)
                    };
                default:
                    return {
                        contentType: 'application/json',
                        data: JSON.stringify(data)
                    };
            }
        };
        this.serialize = function(data, contentType) {
            var _this_runtime = _this.runtime, Node = _this_runtime.Node, URLSearchParams = _this_runtime.URLSearchParams, FormData = _this_runtime.FormData, Blob = _this_runtime.Blob, ReadableStream = _this_runtime.ReadableStream;
            var _ref = (0, $f9AOD._)((contentType === null || contentType === void 0 ? void 0 : contentType.split(';')) || [], 1), type = _ref[0];
            switch(type){
                case 'application/x-www-form-urlencoded':
                    return {
                        contentType: contentType,
                        data: new URLSearchParams(data)
                    };
                case 'multipart/form-data':
                    return {
                        data: _this.makeFormData(data)
                    };
                case 'application/json':
                    return {
                        contentType: contentType,
                        data: JSON.stringify(data)
                    };
                case 'text/html':
                case 'application/xml':
                case 'image/svg':
                    return {
                        contentType: contentType,
                        data: (0, $lhPyT.stringifyDOM)(data)
                    };
            }
            if (type) return {
                data: data,
                contentType: contentType
            };
            try {
                if (data instanceof URLSearchParams) return {
                    contentType: 'application/x-www-form-urlencoded',
                    data: data
                };
            } catch (e) {}
            try {
                if (data instanceof FormData) return {
                    data: data
                };
            } catch (e) {}
            try {
                if (data instanceof Node) return _this.serializeNode(data);
            } catch (e) {}
            try {
                if ((0, $lhPyT.isTypedArray)(data) || data instanceof ArrayBuffer || data instanceof DataView || data instanceof Blob || data instanceof ReadableStream) return {
                    contentType: 'application/octet-stream',
                    data: data
                };
            } catch (e) {}
            try {
                return {
                    contentType: 'application/json',
                    data: JSON.stringify(data)
                };
            } catch (e) {}
            throw new Error('Unserialized Object needs a specific Content-Type');
        };
        this.readBytes = function(stream) {
            var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Infinity;
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var _this_runtime, Blob, chunks;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this_runtime = this.runtime, Blob = _this_runtime.Blob;
                            return [
                                4,
                                Array.fromAsync(this.takeBytes(stream, limit))
                            ];
                        case 1:
                            chunks = _state.sent();
                            return [
                                2,
                                new Blob(chunks).arrayBuffer()
                            ];
                    }
                });
            }).call(_this1);
        };
        this.makeStream = function() {
            for(var _len = arguments.length, chunks = new Array(_len), _key = 0; _key < _len; _key++){
                chunks[_key] = arguments[_key];
            }
            var _this_runtime = _this1.runtime, Blob = _this_runtime.Blob;
            return new Blob(chunks).stream();
        };
        this.streamFromProgress = function(target) {
            return (0, $lhPyT.createAsyncIterator)(function(param) {
                var next = param.next, complete = param.complete, error = param.error;
                var handleProgress = function(param) {
                    var loaded = param.loaded, total = param.total;
                    next({
                        loaded: loaded,
                        total: total
                    });
                    if (loaded >= total) complete();
                };
                target.addEventListener('progress', handleProgress);
                target.addEventListener('error', error);
                return function() {
                    target.removeEventListener('progress', handleProgress);
                    target.removeEventListener('error', error);
                };
            });
        };
        this.emitStreamProgress = function(stream, total, eventTarget) {
            var _this_runtime = _this.runtime, ProgressEvent = _this_runtime.ProgressEvent;
            return function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function() {
                    var loaded, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, event, err;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                loaded = 0;
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $dafVd._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    (0, $dm3mz._)(_iterator.next())
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                chunk = _value;
                                return [
                                    4,
                                    chunk
                                ];
                            case 4:
                                _state.sent();
                                loaded += chunk.byteLength;
                                event = new ProgressEvent('progress', {
                                    lengthComputable: isNaN(total),
                                    loaded: loaded,
                                    total: total
                                });
                                eventTarget.dispatchEvent(event);
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    (0, $dm3mz._)(_iterator.return())
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }();
        };
        this.readAs = function(file, method, encoding) {
            var _this_runtime = _this.runtime, FileReader = _this_runtime.FileReader;
            var reader = new FileReader();
            var result = new Promise(function(resolve, reject) {
                reader.onerror = reject;
                reader.onload = function() {
                    return resolve(reader.result);
                };
                reader[$22de11b45b0eeb97$export$226b21d2db5eaf9f[method]](file, encoding);
            });
            return {
                progress: _this.streamFromProgress(reader),
                result: result
            };
        };
        this./**
     * @param  raw - Binary data
     *
     * @return  Base64 encoded data
     */ encodeBase64 = function(raw) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var _this_runtime, Blob, text, text1;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this_runtime = this.runtime, Blob = _this_runtime.Blob;
                            if (!(raw instanceof Blob)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                this.readAs(raw, 'dataURL').result
                            ];
                        case 1:
                            text = _state.sent();
                            return [
                                2,
                                ($22de11b45b0eeb97$var$DataURI.exec(text) || '')[4]
                            ];
                        case 2:
                            text1 = encodeURIComponent(raw).replace(/%([0-9A-F]{2})/g, function(_, p1) {
                                return String.fromCharCode(+('0x' + p1));
                            });
                            return [
                                2,
                                btoa(text1)
                            ];
                    }
                });
            }).call(_this);
        };
        if (runtime.Event) this.runtime.ProgressEvent = this.polyfillProgressEvent();
    }
    (0, $cFHGC._)($22de11b45b0eeb97$export$bc241bb96b6158a8, [
        {
            key: "takeBytes",
            value: function takeBytes(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function(stream) {
                    var limit, total, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, remaining, err;
                    var _arguments = arguments;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                limit = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : Infinity;
                                total = 0;
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    9,
                                    10,
                                    15
                                ]);
                                _iterator = (0, $dafVd._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    (0, $dm3mz._)(_iterator.next())
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    8
                                ];
                                _value = _step.value;
                                chunk = _value;
                                remaining = limit - total;
                                if (!(chunk.byteLength > remaining)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    chunk.slice(0, remaining)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 5:
                                return [
                                    4,
                                    new Uint8Array(chunk)
                                ];
                            case 6:
                                _state.sent();
                                total += chunk.byteLength;
                                if (total >= limit) return [
                                    3,
                                    8
                                ];
                                _state.label = 7;
                            case 7:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 8:
                                return [
                                    3,
                                    15
                                ];
                            case 9:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    15
                                ];
                            case 10:
                                _state.trys.push([
                                    10,
                                    ,
                                    13,
                                    14
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    12
                                ];
                                return [
                                    4,
                                    (0, $dm3mz._)(_iterator.return())
                                ];
                            case 11:
                                _state.sent();
                                _state.label = 12;
                            case 12:
                                return [
                                    3,
                                    14
                                ];
                            case 13:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 14:
                                return [
                                    7
                                ];
                            case 15:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        }
    ]);
    return $22de11b45b0eeb97$export$bc241bb96b6158a8;
}();
var _ref = new $22de11b45b0eeb97$export$bc241bb96b6158a8(), $22de11b45b0eeb97$export$5e6a03ce7b01784 = _ref.polyfillProgressEvent, $22de11b45b0eeb97$export$b6a9369736b19f4d = _ref.parseDocument, $22de11b45b0eeb97$export$2c28ab2e118e73f1 = _ref.makeFormData, $22de11b45b0eeb97$export$a0beee2e55fb5dd1 = _ref.serializeNode, $22de11b45b0eeb97$export$dfdc1655ccc5b9cb = _ref.serialize, $22de11b45b0eeb97$export$45c4469e58b7b0ca = _ref.takeBytes, $22de11b45b0eeb97$export$f9f241124ee3198e = _ref.readBytes, $22de11b45b0eeb97$export$4b366c43f3cabead = _ref.makeStream, $22de11b45b0eeb97$export$f8162fcba31fa547 = _ref.streamFromProgress, $22de11b45b0eeb97$export$cebfdbc318a33abe = _ref.emitStreamProgress, $22de11b45b0eeb97$export$e209cbb66c5b18c = _ref.readAs, $22de11b45b0eeb97$export$8fb536984ec8b4d7 = _ref.encodeBase64;
var $0fe1f1400993ba8a$export$4125cfe7e08e2040 = /*#__PURE__*/ function(BodyRequestMethods) {
    BodyRequestMethods["POST"] = "POST";
    BodyRequestMethods["PUT"] = "PUT";
    BodyRequestMethods["PATCH"] = "PATCH";
    BodyRequestMethods["DELETE"] = "DELETE";
    return BodyRequestMethods;
}({});
var $0fe1f1400993ba8a$export$aa9d629c530f62a7 = /*#__PURE__*/ function(URIError1) {
    "use strict";
    (0, $hdIku._)($0fe1f1400993ba8a$export$aa9d629c530f62a7, URIError1);
    function $0fe1f1400993ba8a$export$aa9d629c530f62a7(message, request, response) {
        (0, $173N4._)(this, $0fe1f1400993ba8a$export$aa9d629c530f62a7);
        var _this;
        _this = (0, $7qXGD._)(this, $0fe1f1400993ba8a$export$aa9d629c530f62a7, [
            message
        ]), _this.request = request, _this.response = response;
        return _this;
    }
    return $0fe1f1400993ba8a$export$aa9d629c530f62a7;
}((0, $1SdK7._)(URIError));
var $0fe1f1400993ba8a$export$b725a69477e4d33f = {
    Link: function(value) {
        return Object.fromEntries(Array.from(value.matchAll(/<(\S+?)>; rel="(\w+)"(?:; title="(.*?)")?/g), function(param) {
            var _param = (0, $f9AOD._)(param, 4), _ = _param[0], URI = _param[1], rel = _param[2], title = _param[3];
            return [
                rel,
                {
                    rel: rel,
                    URI: URI,
                    title: title
                }
            ];
        }));
    }
};
var $0fe1f1400993ba8a$export$eea2c1c5e1a37e50 = function(raw) {
    return Object.fromEntries(Array.from(raw.trim().matchAll(/^([\w-]+):\s*(.*)/gm), function(param) {
        var _param = (0, $f9AOD._)(param, 3), _ = _param[0], key = _param[1], value = _param[2];
        var _$0fe1f1400993ba8a$export$b725a69477e4d33f_key;
        key = key.replace(/(^[a-z]|-[a-z])/g, function(char) {
            return char.toUpperCase();
        });
        var _$0fe1f1400993ba8a$export$b725a69477e4d33f_key1;
        return [
            key,
            (_$0fe1f1400993ba8a$export$b725a69477e4d33f_key1 = (_$0fe1f1400993ba8a$export$b725a69477e4d33f_key = $0fe1f1400993ba8a$export$b725a69477e4d33f[key]) === null || _$0fe1f1400993ba8a$export$b725a69477e4d33f_key === void 0 ? void 0 : _$0fe1f1400993ba8a$export$b725a69477e4d33f_key.call($0fe1f1400993ba8a$export$b725a69477e4d33f, value)) !== null && _$0fe1f1400993ba8a$export$b725a69477e4d33f_key1 !== void 0 ? _$0fe1f1400993ba8a$export$b725a69477e4d33f_key1 : value
        ];
    }));
};
function $0fe1f1400993ba8a$export$3b629cd0ff482602(raw, contentType) {
    if (contentType.includes('json')) return (0, $lhPyT.parseJSON)(raw);
    if (contentType.match(/html|xml/)) try {
        return this.parseDocument(raw, contentType);
    } catch (e) {}
    if (contentType.includes('text')) return raw;
    return new TextEncoder().encode(raw).buffer;
}
var $0fe1f1400993ba8a$export$153cac11fce574d = 4100;
var $0fe1f1400993ba8a$export$80e06a8ed038dcf8 = (0, $6fpqi._)((0, $1XAnY._)({}, $22de11b45b0eeb97$export$f7195e83247c5fe1), {
    EventTarget: globalThis.EventTarget,
    XMLHttpRequest: globalThis.XMLHttpRequest,
    Headers: globalThis.Headers,
    fetch: globalThis.fetch
});
var $0fe1f1400993ba8a$export$7370b3fc922cf1e6 = /*#__PURE__*/ function($22de11b45b0eeb97$export$bc241bb96b6158a8) {
    "use strict";
    (0, $hdIku._)($0fe1f1400993ba8a$export$7370b3fc922cf1e6, $22de11b45b0eeb97$export$bc241bb96b6158a8);
    function $0fe1f1400993ba8a$export$7370b3fc922cf1e6() {
        var runtime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $0fe1f1400993ba8a$export$80e06a8ed038dcf8;
        (0, $173N4._)(this, $0fe1f1400993ba8a$export$7370b3fc922cf1e6);
        var _this;
        var _this1;
        _this = (0, $7qXGD._)(this, $0fe1f1400993ba8a$export$7370b3fc922cf1e6, [
            runtime
        ]), _this1 = _this, _this1.runtime = runtime, _this1.requestXHR = function(_param) {
            var tmp = _param.method, method = tmp === void 0 ? 'GET' : tmp, path = _param.path, tmp1 = _param.headers, headers = tmp1 === void 0 ? {} : tmp1, body = _param.body, signal = _param.signal, rest = (0, $6acIq._)(_param, [
                "method",
                "path",
                "headers",
                "body",
                "signal"
            ]);
            var _this_runtime = _this1.runtime, XMLHttpRequest = _this_runtime.XMLHttpRequest, Headers = _this_runtime.Headers, Blob = _this_runtime.Blob, ReadableStream = _this_runtime.ReadableStream;
            var request = new XMLHttpRequest();
            var header = new Headers(headers);
            var bodyPromise = body instanceof ReadableStream ? Array.fromAsync(body).then(function(parts) {
                return new Blob(parts);
            }) : Promise.resolve(body);
            var abort = function() {
                return request.abort();
            };
            signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', abort);
            var response = new Promise(function(resolve, reject) {
                var _header_get;
                request.onreadystatechange = function() {
                    var readyState = request.readyState, status = request.status, statusText = request.statusText, responseType = request.responseType;
                    if (readyState !== 4 || !status && !(signal === null || signal === void 0 ? void 0 : signal.aborted)) return;
                    resolve({
                        status: status,
                        statusText: statusText,
                        headers: $0fe1f1400993ba8a$export$eea2c1c5e1a37e50(request.getAllResponseHeaders()),
                        body: responseType && responseType !== 'text' ? request.response : request.responseText
                    });
                };
                request.onerror = request.ontimeout = reject;
                var _ref = (0, $f9AOD._)(((_header_get = header.get('Accept')) === null || _header_get === void 0 ? void 0 : _header_get.split(',')) || [
                    rest.responseType === 'document' ? 'application/xhtml+xml' : rest.responseType === 'json' ? 'application/json' : ''
                ], 1), MIMEType = _ref[0];
                if (MIMEType) request.overrideMimeType(MIMEType);
                request.open(method, path + '');
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = header[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $f9AOD._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        request.setRequestHeader(key, value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                Object.assign(request, rest);
                bodyPromise.then(function(body) {
                    return request.send(body);
                });
            }).then(function(_param) {
                var body = _param.body, meta = (0, $6acIq._)(_param, [
                    "body"
                ]);
                signal === null || signal === void 0 ? void 0 : signal.throwIfAborted();
                var contentType = request.getResponseHeader('Content-Type') || '';
                if (typeof body === 'string' && !contentType.includes('text')) body = $0fe1f1400993ba8a$export$3b629cd0ff482602(body, contentType);
                return (0, $6fpqi._)((0, $1XAnY._)({}, meta), {
                    body: body
                });
            });
            response.finally(function() {
                return signal === null || signal === void 0 ? void 0 : signal.removeEventListener('abort', abort);
            });
            return {
                response: response,
                upload: _this1.streamFromProgress(request.upload),
                download: _this1.streamFromProgress(request)
            };
        }, _this1.requestFetch = function(param) {
            var path = param.path, method = param.method, headers = param.headers, withCredentials = param.withCredentials, body = param.body, signal = param.signal, timeout = param.timeout, responseType = param.responseType;
            var _this_runtime = _this1.runtime, EventTarget = _this_runtime.EventTarget, Headers = _this_runtime.Headers, ReadableStream = _this_runtime.ReadableStream, fetch = _this_runtime.fetch;
            var signals = [
                signal,
                timeout && AbortSignal.timeout(timeout)
            ].filter(Boolean);
            headers = headers instanceof Headers ? Object.fromEntries(headers.entries()) : headers instanceof Array ? Object.fromEntries(headers) : headers;
            headers = responseType === 'text' ? (0, $6fpqi._)((0, $1XAnY._)({}, headers), {
                Accept: 'text/plain'
            }) : responseType === 'json' ? (0, $6fpqi._)((0, $1XAnY._)({}, headers), {
                Accept: 'application/json'
            }) : responseType === 'document' ? (0, $6fpqi._)((0, $1XAnY._)({}, headers), {
                Accept: 'text/html, application/xhtml+xml, application/xml'
            }) : responseType === 'arraybuffer' || responseType === 'blob' ? (0, $6fpqi._)((0, $1XAnY._)({}, headers), {
                Accept: 'application/octet-stream'
            }) : headers;
            var isStream = body instanceof ReadableStream;
            var upload;
            if (isStream) {
                var uploadProgress = new EventTarget();
                body = ReadableStream.from(_this1.emitStreamProgress(body, +headers['Content-Length'], uploadProgress));
                upload = _this1.streamFromProgress(uploadProgress);
            }
            var downloadProgress = new EventTarget();
            var response = fetch(path + '', {
                method: method,
                headers: headers,
                credentials: withCredentials ? 'include' : 'omit',
                body: body,
                signal: signals[0] && AbortSignal.any(signals),
                // @ts-expect-error https://developer.chrome.com/docs/capabilities/web-apis/fetch-streaming-requests
                duplex: isStream ? 'half' : undefined
            }).then(function(response) {
                return _this1.parseResponse(response, responseType, downloadProgress);
            });
            var download = _this1.streamFromProgress(downloadProgress);
            return {
                response: response,
                upload: upload,
                download: download
            };
        }, _this1.parseResponse = function(param, responseType, downloadProgress) {
            var status = param.status, statusText = param.statusText, headers = param.headers, body = param.body;
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var _this_runtime, ReadableStream, contentType, header, stream, rBody;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this_runtime = _this1.runtime, ReadableStream = _this_runtime.ReadableStream;
                            contentType = headers.get('Content-Type') || '';
                            header = $0fe1f1400993ba8a$export$eea2c1c5e1a37e50((0, $aUGqu._)(headers).map(function(param) {
                                var _param = (0, $f9AOD._)(param, 2), key = _param[0], value = _param[1];
                                return "".concat(key, ": ").concat(value);
                            }).join('\n'));
                            if (status === 204 || !body) return [
                                2,
                                {
                                    status: status,
                                    statusText: statusText,
                                    headers: header,
                                    body: undefined
                                }
                            ];
                            stream = ReadableStream.from(_this1.emitStreamProgress(ReadableStream.from(body), +headers.get('Content-Length'), downloadProgress));
                            return [
                                4,
                                _this1.parseFetchBody(stream, contentType, responseType)
                            ];
                        case 1:
                            rBody = _state.sent();
                            return [
                                2,
                                {
                                    status: status,
                                    statusText: statusText,
                                    headers: header,
                                    body: rBody
                                }
                            ];
                    }
                });
            })();
        }, _this1.parseFetchBody = function(stream, contentType, responseType) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var _this_runtime, Blob, blob, _, text;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this_runtime = _this1.runtime, Blob = _this_runtime.Blob;
                            _ = Blob.bind;
                            return [
                                4,
                                Array.fromAsync(stream)
                            ];
                        case 1:
                            blob = new (_.apply(Blob, [
                                void 0,
                                _state.sent(),
                                {
                                    type: contentType
                                }
                            ]));
                            if (responseType === 'blob') return [
                                2,
                                blob
                            ];
                            if (responseType === 'arraybuffer') return [
                                2,
                                blob.arrayBuffer()
                            ];
                            return [
                                4,
                                blob.text()
                            ];
                        case 2:
                            text = _state.sent();
                            if (responseType === 'text') return [
                                2,
                                text
                            ];
                            return [
                                2,
                                $0fe1f1400993ba8a$export$3b629cd0ff482602(text, contentType)
                            ];
                    }
                });
            })();
        }, _this1.rawRequest = typeof _this1.runtime.XMLHttpRequest === 'function' ? _this1.requestXHR : _this1.requestFetch, _this1./**
     * Sends a `HEAD` request, falling back to simulation when the server does
     * not support `HEAD`. Tries, in order:
     * 1. A standard `HEAD` request via `fetch()`.
     * 2. A `Range` GET to retrieve the first {@link FILE_TYPE_MAGIC_NUMBER_SIZE}
     *    bytes (magic-number file header).
     * 3. A plain `GET` that reads the first {@link FILE_TYPE_MAGIC_NUMBER_SIZE}
     *    bytes then cancels the body stream.
     */ requestHead = function(param) {
            var path = param.path, headers = param.headers, withCredentials = param.withCredentials, timeout = param.timeout, signal = param.signal;
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var _this_runtime, Headers, fetch, normalizedHeaders, signals, fetchOptions, toHeaders, response, e, response1, _tmp, e1, response2, body;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this_runtime = _this1.runtime, Headers = _this_runtime.Headers, fetch = _this_runtime.fetch;
                            normalizedHeaders = !headers ? {} : headers instanceof Headers ? Object.fromEntries(headers) : Array.isArray(headers) ? Object.fromEntries(headers) : headers;
                            signals = [
                                signal,
                                timeout && AbortSignal.timeout(timeout)
                            ].filter(Boolean);
                            fetchOptions = {
                                credentials: withCredentials ? 'include' : 'omit',
                                signal: signals[1] ? AbortSignal.any(signals) : signals[0]
                            };
                            toHeaders = function(raw) {
                                return $0fe1f1400993ba8a$export$eea2c1c5e1a37e50((0, $aUGqu._)(raw).map(function(param) {
                                    var _param = (0, $f9AOD._)(param, 2), k = _param[0], v = _param[1];
                                    return "".concat(k, ": ").concat(v);
                                }).join('\n'));
                            };
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetch(path + '', (0, $6fpqi._)((0, $1XAnY._)({
                                    method: 'HEAD'
                                }, fetchOptions), {
                                    headers: normalizedHeaders
                                }))
                            ];
                        case 2:
                            response = _state.sent();
                            if (response.ok) return [
                                2,
                                {
                                    headers: toHeaders(response.headers)
                                }
                            ];
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            _state.trys.push([
                                4,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4,
                                fetch(path + '', (0, $6fpqi._)((0, $1XAnY._)({}, fetchOptions), {
                                    headers: (0, $6fpqi._)((0, $1XAnY._)({}, normalizedHeaders), {
                                        Range: "bytes=0-".concat($0fe1f1400993ba8a$export$153cac11fce574d - 1)
                                    })
                                }))
                            ];
                        case 5:
                            response1 = _state.sent();
                            if (!response1.ok) throw new Error("".concat(response1.status, " ").concat(response1.statusText));
                            _tmp = {
                                headers: toHeaders(response1.headers)
                            };
                            return [
                                4,
                                response1.arrayBuffer()
                            ];
                        case 6:
                            return [
                                2,
                                (_tmp.body = _state.sent(), _tmp)
                            ];
                        case 7:
                            e1 = _state.sent();
                            return [
                                3,
                                8
                            ];
                        case 8:
                            return [
                                4,
                                fetch(path, (0, $6fpqi._)((0, $1XAnY._)({}, fetchOptions), {
                                    headers: normalizedHeaders
                                }))
                            ];
                        case 9:
                            response2 = _state.sent();
                            return [
                                4,
                                _this1.readBytes((0, $318vE.ReadableStream).from(response2.body), $0fe1f1400993ba8a$export$153cac11fce574d)
                            ];
                        case 10:
                            body = _state.sent();
                            return [
                                2,
                                {
                                    headers: toHeaders(response2.headers),
                                    body: body
                                }
                            ];
                    }
                });
            })();
        }, _this1./**
     * Sends a {@link Request}, with automatic HEAD-simulation fallback for
     * servers that do not support the `HEAD` method.
     */ request = function(option) {
            if (option.method !== 'HEAD') return _this1.rawRequest(option);
            var response = _this1.requestHead(option).then(function(param) {
                var headers = param.headers, body = param.body;
                return {
                    status: 204,
                    statusText: 'No Content',
                    headers: headers,
                    body: body
                };
            });
            return {
                response: response,
                download: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function() {
                        return (0, $13u2V._)(this, function(_state) {
                            return [
                                2
                            ];
                        });
                    })();
                }()
            };
        };
        return _this;
    }
    return $0fe1f1400993ba8a$export$7370b3fc922cf1e6;
}($22de11b45b0eeb97$export$bc241bb96b6158a8);
var _ref1 = new $0fe1f1400993ba8a$export$7370b3fc922cf1e6(), $0fe1f1400993ba8a$export$4f2a8c8c11a6373a = _ref1.requestXHR, $0fe1f1400993ba8a$export$bda27a3e49197b9 = _ref1.requestFetch, $0fe1f1400993ba8a$export$ba14d9a5a581e827 = _ref1.parseResponse, $0fe1f1400993ba8a$export$b7b86d31099674dc = _ref1.parseFetchBody, $0fe1f1400993ba8a$export$3052fa16c23a17ef = _ref1.rawRequest, $0fe1f1400993ba8a$export$199f266664335871 = _ref1.requestHead, $0fe1f1400993ba8a$export$b5fe3f66a567bec0 = _ref1.request;
var $cbd22d3323bef9ca$exports = {};
$parcel$export($cbd22d3323bef9ca$exports, "HTTPClient", function() {
    return $cbd22d3323bef9ca$export$45cf759b359d3d24;
});
var _Array_prototype1 = Array.prototype, $cbd22d3323bef9ca$var$splice = _Array_prototype1.splice;
var $cbd22d3323bef9ca$export$45cf759b359d3d24 = /*#__PURE__*/ function($eef213ff4197108b$export$694e0d28c7ffc90c) {
    "use strict";
    (0, $hdIku._)($cbd22d3323bef9ca$export$45cf759b359d3d24, $eef213ff4197108b$export$694e0d28c7ffc90c);
    function $cbd22d3323bef9ca$export$45cf759b359d3d24() {
        var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $173N4._)(this, $cbd22d3323bef9ca$export$45cf759b359d3d24);
        var _this;
        var _this1, _superprop_get_use = function() {
            return (0, $dWsrg._)(((0, $gXzGB._)(_this), (0, $kg0zo._)($cbd22d3323bef9ca$export$45cf759b359d3d24.prototype)), "use", _this);
        };
        var tmp = _param.baseURI, baseURI = tmp === void 0 ? function() {
            var _globalThis_document;
            return (_globalThis_document = globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.baseURI;
        }() : tmp, tmp1 = _param.baseRequest, baseRequest = tmp1 === void 0 ? $0fe1f1400993ba8a$export$b5fe3f66a567bec0 : tmp1, options = (0, $6acIq._)(_param, [
            "baseURI",
            "baseRequest"
        ]);
        _this = (0, $7qXGD._)(this, $cbd22d3323bef9ca$export$45cf759b359d3d24), _this1 = _this, _this1.defaultWare = function(param, next) {
            var request = param.request, response = param.response;
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var tmp, method, tmp1, headers, body, _$22de11b45b0eeb97$export$dfdc1655ccc5b9cb, contentType, data;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            tmp = request.method, method = tmp === void 0 ? 'GET' : tmp, tmp1 = request.headers, headers = tmp1 === void 0 ? {} : tmp1, body = request.body;
                            if (method in $0fe1f1400993ba8a$export$4125cfe7e08e2040 && body && (typeof body === "undefined" ? "undefined" : (0, $7E0eS._)(body)) === 'object') {
                                _$22de11b45b0eeb97$export$dfdc1655ccc5b9cb = $22de11b45b0eeb97$export$dfdc1655ccc5b9cb(body, headers['Content-Type']), contentType = _$22de11b45b0eeb97$export$dfdc1655ccc5b9cb.contentType, data = _$22de11b45b0eeb97$export$dfdc1655ccc5b9cb.data;
                                if (contentType) headers['Content-Type'] = contentType;
                                request.body = data;
                            }
                            return [
                                4,
                                next()
                            ];
                        case 1:
                            _state.sent();
                            if (response.status > 299) throw new $0fe1f1400993ba8a$export$aa9d629c530f62a7(response.statusText, request, response);
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        _this1.baseURI = baseURI;
        _this1.baseRequest = baseRequest;
        _this1.options = options;
        _superprop_get_use().call(_this1, _this1.defaultWare);
        _superprop_get_use().call(_this1, function(param) {
            var data = param.request, response = param.response;
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var _, _tmp;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            data.path = new URL(data.path, _this1.baseURI) + '';
                            _ = Object.assign;
                            _tmp = [
                                response
                            ];
                            return [
                                4,
                                _this1.baseRequest((0, $1XAnY._)({}, options, data)).response
                            ];
                        case 1:
                            _.apply(Object, _tmp.concat([
                                _state.sent()
                            ]));
                            return [
                                2
                            ];
                    }
                });
            })();
        });
        return _this;
    }
    (0, $cFHGC._)($cbd22d3323bef9ca$export$45cf759b359d3d24, [
        {
            key: "use",
            value: function use() {
                for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
                    middlewares[_key] = arguments[_key];
                }
                var _$cbd22d3323bef9ca$var$splice;
                (_$cbd22d3323bef9ca$var$splice = $cbd22d3323bef9ca$var$splice).call.apply(_$cbd22d3323bef9ca$var$splice, [
                    this,
                    -2,
                    0
                ].concat((0, $aUGqu._)(middlewares)));
                return this;
            }
        },
        {
            key: "request",
            value: function request(data) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var context;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                context = {
                                    request: (0, $6fpqi._)((0, $1XAnY._)({}, data), {
                                        headers: (0, $1XAnY._)({}, data.headers)
                                    }),
                                    response: {}
                                };
                                return [
                                    4,
                                    this.execute(context)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    context.response
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "head",
            value: function head(path, headers, options) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _ref, data;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.request((0, $1XAnY._)({
                                        method: 'HEAD',
                                        path: path,
                                        headers: headers
                                    }, options))
                                ];
                            case 1:
                                _ref = _state.sent(), data = _ref.headers;
                                return [
                                    2,
                                    data
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "get",
            value: function get(path, headers, options) {
                return this.request((0, $1XAnY._)({
                    method: 'GET',
                    path: path,
                    headers: headers
                }, options));
            }
        },
        {
            key: "post",
            value: function post(path, body, headers, options) {
                return this.request((0, $1XAnY._)({
                    method: 'POST',
                    path: path,
                    headers: headers,
                    body: body
                }, options));
            }
        },
        {
            key: "put",
            value: function put(path, body, headers, options) {
                return this.request((0, $1XAnY._)({
                    method: 'PUT',
                    path: path,
                    headers: headers,
                    body: body
                }, options));
            }
        },
        {
            key: "patch",
            value: function patch(path, body, headers, options) {
                return this.request((0, $1XAnY._)({
                    method: 'PATCH',
                    path: path,
                    headers: headers,
                    body: body
                }, options));
            }
        },
        {
            key: "delete",
            value: function _delete(path, body, headers, options) {
                return this.request((0, $1XAnY._)({
                    method: 'DELETE',
                    path: path,
                    headers: headers,
                    body: body
                }, options));
            }
        },
        {
            key: "download",
            value: function download(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function(path) {
                    var _param, headers, tmp, chunkSize, tmp1, _ref, tmp2, start, tmp3, end, options, _ref1, length, total, i, j, _ref2, status, body, loaded;
                    var _arguments = arguments;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _param = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                                headers = _param.headers, tmp = _param.chunkSize, chunkSize = tmp === void 0 ? Math.pow(1024, 2) : tmp, tmp1 = _param.range, _ref = (0, $f9AOD._)(tmp1 === void 0 ? [] : tmp1, 2), tmp2 = _ref[0], start = tmp2 === void 0 ? 0 : tmp2, tmp3 = _ref[1], end = tmp3 === void 0 ? Infinity : tmp3, options = (0, $6acIq._)(_param, [
                                    "headers",
                                    "chunkSize",
                                    "range"
                                ]);
                                return [
                                    4,
                                    (0, $dm3mz._)(this.head(path, headers, options))
                                ];
                            case 1:
                                _ref1 = _state.sent(), length = _ref1['Content-Length'];
                                total = +length;
                                if (end === Infinity) end = total;
                                i = start, j = i - 1 + chunkSize;
                                _state.label = 2;
                            case 2:
                                if (!(i < end)) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    (0, $dm3mz._)(this.get(path, (0, $6fpqi._)((0, $1XAnY._)({}, headers), {
                                        Range: "bytes=".concat(i, "-").concat(j)
                                    }), options))
                                ];
                            case 3:
                                _ref2 = _state.sent(), status = _ref2.status, body = _ref2.body;
                                if (!(status !== 206)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    {
                                        total: total,
                                        loaded: total,
                                        percent: 100,
                                        buffer: body
                                    }
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 5:
                                loaded = i + body.byteLength;
                                return [
                                    4,
                                    {
                                        total: total,
                                        loaded: loaded,
                                        percent: +(loaded / total * 100).toFixed(2),
                                        buffer: body
                                    }
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                i = j + 1, j += chunkSize;
                                return [
                                    3,
                                    2
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        }
    ]);
    return $cbd22d3323bef9ca$export$45cf759b359d3d24;
}($eef213ff4197108b$export$694e0d28c7ffc90c);

});
parcelRegister("318vE", function(module, exports) {

$parcel$export(module.exports, "ReadableStreamDefaultReader", function () { return $9159c2fc84b5e85b$export$a890bf36e2af9168; });
$parcel$export(module.exports, "ReadableStreamBYOBRequest", function () { return $9159c2fc84b5e85b$export$fbcf11583158d2c; });
$parcel$export(module.exports, "ReadableByteStreamController", function () { return $9159c2fc84b5e85b$export$2047cf34091e94ac; });
$parcel$export(module.exports, "ReadableStreamBYOBReader", function () { return $9159c2fc84b5e85b$export$20068a30393fcc28; });
$parcel$export(module.exports, "WritableStream", function () { return $9159c2fc84b5e85b$export$826849241f7970f8; });
$parcel$export(module.exports, "WritableStreamDefaultController", function () { return $9159c2fc84b5e85b$export$9e6890cb9a51c7c2; });
$parcel$export(module.exports, "WritableStreamDefaultWriter", function () { return $9159c2fc84b5e85b$export$9295348f005d6054; });
$parcel$export(module.exports, "ReadableStreamDefaultController", function () { return $9159c2fc84b5e85b$export$b0bb6d0989d67700; });
$parcel$export(module.exports, "ReadableStream", function () { return $9159c2fc84b5e85b$export$5d3e1e5268af5f76; });
$parcel$export(module.exports, "ByteLengthQueuingStrategy", function () { return $9159c2fc84b5e85b$export$d386b5f37d154119; });
$parcel$export(module.exports, "CountQueuingStrategy", function () { return $9159c2fc84b5e85b$export$9ebfec18c2dfc625; });
$parcel$export(module.exports, "TransformStream", function () { return $9159c2fc84b5e85b$export$d102341634899398; });
$parcel$export(module.exports, "TransformStreamDefaultController", function () { return $9159c2fc84b5e85b$export$a55559184460222; });
/**
 * @license
 * web-streams-polyfill v4.3.0
 * Copyright 2026 Mattias Buelens, Diwank Singh Tomer and other contributors.
 * This code is released under the MIT license.
 * SPDX-License-Identifier: MIT
 */ 
var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7Pjls = parcelRequire("7Pjls");

var $7E0eS = parcelRequire("7E0eS");
function $9159c2fc84b5e85b$var$e() {}
function $9159c2fc84b5e85b$var$t(e) {
    return "object" == (typeof e === "undefined" ? "undefined" : (0, $7E0eS._)(e)) && null !== e || "function" == typeof e;
}
var $9159c2fc84b5e85b$var$r = $9159c2fc84b5e85b$var$e;
function $9159c2fc84b5e85b$var$o(e, t) {
    try {
        Object.defineProperty(e, "name", {
            value: t,
            configurable: !0
        });
    } catch (e) {}
}
var $9159c2fc84b5e85b$var$n = Promise, $9159c2fc84b5e85b$var$i = Promise.resolve.bind($9159c2fc84b5e85b$var$n), $9159c2fc84b5e85b$var$a = Promise.prototype.then, $9159c2fc84b5e85b$var$s = Promise.reject.bind($9159c2fc84b5e85b$var$n), $9159c2fc84b5e85b$var$l = $9159c2fc84b5e85b$var$i;
function $9159c2fc84b5e85b$var$u(e) {
    return new $9159c2fc84b5e85b$var$n(e);
}
function $9159c2fc84b5e85b$var$c(e) {
    return $9159c2fc84b5e85b$var$u(function(t) {
        return t(e);
    });
}
function $9159c2fc84b5e85b$var$d(e) {
    return $9159c2fc84b5e85b$var$s(e);
}
function $9159c2fc84b5e85b$var$f(e, t, r) {
    return $9159c2fc84b5e85b$var$a.call(e, t, r);
}
function $9159c2fc84b5e85b$var$h(e, t, o) {
    $9159c2fc84b5e85b$var$f($9159c2fc84b5e85b$var$f(e, t, o), void 0, $9159c2fc84b5e85b$var$r);
}
function $9159c2fc84b5e85b$var$b(e, t) {
    $9159c2fc84b5e85b$var$h(e, t);
}
function $9159c2fc84b5e85b$var$_(e, t) {
    $9159c2fc84b5e85b$var$h(e, void 0, t);
}
function $9159c2fc84b5e85b$var$m(e, t, r) {
    return $9159c2fc84b5e85b$var$f(e, t, r);
}
function $9159c2fc84b5e85b$var$p(e) {
    $9159c2fc84b5e85b$var$f(e, void 0, $9159c2fc84b5e85b$var$r);
}
var $9159c2fc84b5e85b$var$y = function(e) {
    if ("function" == typeof queueMicrotask) $9159c2fc84b5e85b$var$y = queueMicrotask;
    else {
        var _$e = $9159c2fc84b5e85b$var$c(void 0);
        $9159c2fc84b5e85b$var$y = function(t) {
            return $9159c2fc84b5e85b$var$f(_$e, t);
        };
    }
    return $9159c2fc84b5e85b$var$y(e);
};
function $9159c2fc84b5e85b$var$S(e, t, r) {
    if ("function" != typeof e) throw new TypeError("Argument is not a function");
    return Function.prototype.apply.call(e, t, r);
}
function $9159c2fc84b5e85b$var$g(e, t, r) {
    try {
        return $9159c2fc84b5e85b$var$c($9159c2fc84b5e85b$var$S(e, t, r));
    } catch (e) {
        return $9159c2fc84b5e85b$var$d(e);
    }
}
var $9159c2fc84b5e85b$var$v = /*#__PURE__*/ function() {
    "use strict";
    function v() {
        (0, $173N4._)(this, v);
        this._cursor = 0, this._size = 0, this._front = {
            _elements: [],
            _next: void 0
        }, this._back = this._front, this._cursor = 0, this._size = 0;
    }
    (0, $cFHGC._)(v, [
        {
            key: "length",
            get: function get() {
                return this._size;
            }
        },
        {
            key: "push",
            value: function push(e) {
                var t = this._back;
                var r = t;
                16383 === t._elements.length && (r = {
                    _elements: [],
                    _next: void 0
                }), t._elements.push(e), r !== t && (this._back = r, t._next = r), ++this._size;
            }
        },
        {
            key: "shift",
            value: function shift() {
                var _$e = this._front;
                var t = _$e;
                var r = this._cursor;
                var _$o = r + 1;
                var n = _$e._elements, i = n[r];
                return 16384 === _$o && (t = _$e._next, _$o = 0), --this._size, this._cursor = _$o, _$e !== t && (this._front = t), n[r] = void 0, i;
            }
        },
        {
            key: "forEach",
            value: function forEach(e) {
                var t = this._cursor, r = this._front, _$o = r._elements;
                for(; !(t === _$o.length && void 0 === r._next || t === _$o.length && (r = r._next, _$o = r._elements, t = 0, 0 === _$o.length));)e(_$o[t]), ++t;
            }
        },
        {
            key: "peek",
            value: function peek() {
                var _$e = this._front, t = this._cursor;
                return _$e._elements[t];
            }
        }
    ]);
    return v;
}();
var $9159c2fc84b5e85b$var$w = Symbol("[[AbortSteps]]"), $9159c2fc84b5e85b$var$R = Symbol("[[ErrorSteps]]"), $9159c2fc84b5e85b$var$T = Symbol("[[CancelSteps]]"), $9159c2fc84b5e85b$var$P = Symbol("[[PullSteps]]"), $9159c2fc84b5e85b$var$C = Symbol("[[CanPullSyncSteps]]"), $9159c2fc84b5e85b$var$q = Symbol("[[ReleaseSteps]]");
function $9159c2fc84b5e85b$var$E(e, t) {
    e._ownerReadableStream = t, t._reader = e, "readable" === t._state ? $9159c2fc84b5e85b$var$j(e) : "closed" === t._state ? function(e) {
        $9159c2fc84b5e85b$var$j(e), $9159c2fc84b5e85b$var$z(e);
    }(e) : $9159c2fc84b5e85b$var$k(e, t._storedError);
}
function $9159c2fc84b5e85b$var$W(e, t) {
    return $9159c2fc84b5e85b$var$Mr(e._ownerReadableStream, t);
}
function $9159c2fc84b5e85b$var$O(e) {
    var t = e._ownerReadableStream;
    "readable" === t._state ? $9159c2fc84b5e85b$var$A(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")) : function(e, t) {
        $9159c2fc84b5e85b$var$k(e, t);
    }(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")), t._readableStreamController[$9159c2fc84b5e85b$var$q](), t._reader = void 0, e._ownerReadableStream = void 0;
}
function $9159c2fc84b5e85b$var$B(e) {
    return new TypeError("Cannot " + e + " a stream using a released reader");
}
function $9159c2fc84b5e85b$var$j(e) {
    e._closedPromise = $9159c2fc84b5e85b$var$u(function(t, r) {
        e._closedPromise_resolve = t, e._closedPromise_reject = r;
    });
}
function $9159c2fc84b5e85b$var$k(e, t) {
    $9159c2fc84b5e85b$var$j(e), $9159c2fc84b5e85b$var$A(e, t);
}
function $9159c2fc84b5e85b$var$A(e, t) {
    void 0 !== e._closedPromise_reject && ($9159c2fc84b5e85b$var$p(e._closedPromise), e._closedPromise_reject(t), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0);
}
function $9159c2fc84b5e85b$var$z(e) {
    void 0 !== e._closedPromise_resolve && (e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0);
}
var $9159c2fc84b5e85b$var$D = Number.isFinite || function(e) {
    return "number" == typeof e && isFinite(e);
}, $9159c2fc84b5e85b$var$F = Math.trunc || function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
};
function $9159c2fc84b5e85b$var$L(e, t) {
    if (void 0 !== e && "object" != (0, $7E0eS._)(r = e) && "function" != typeof r) throw new TypeError("".concat(t, " is not an object."));
    var r;
}
function $9159c2fc84b5e85b$var$I(e, t) {
    if ("function" != typeof e) throw new TypeError("".concat(t, " is not a function."));
}
function $9159c2fc84b5e85b$var$$(e, t) {
    if (!function(e) {
        return "object" == (typeof e === "undefined" ? "undefined" : (0, $7E0eS._)(e)) && null !== e || "function" == typeof e;
    }(e)) throw new TypeError("".concat(t, " is not an object."));
}
function $9159c2fc84b5e85b$var$M(e, t, r) {
    if (void 0 === e) throw new TypeError("Parameter ".concat(t, " is required in '").concat(r, "'."));
}
function $9159c2fc84b5e85b$var$Y(e, t, r) {
    if (void 0 === e) throw new TypeError("".concat(t, " is required in '").concat(r, "'."));
}
function $9159c2fc84b5e85b$var$x(e) {
    return Number(e);
}
function $9159c2fc84b5e85b$var$Q(e) {
    return 0 === e ? 0 : e;
}
function $9159c2fc84b5e85b$var$N(e, t) {
    var r = Number.MAX_SAFE_INTEGER;
    var _$o = Number(e);
    if (_$o = $9159c2fc84b5e85b$var$Q(_$o), !$9159c2fc84b5e85b$var$D(_$o)) throw new TypeError("".concat(t, " is not a finite number"));
    if (_$o = function(e) {
        return $9159c2fc84b5e85b$var$Q($9159c2fc84b5e85b$var$F(e));
    }(_$o), _$o < 0 || _$o > r) throw new TypeError("".concat(t, " is outside the accepted range of 0 to ").concat(r, ", inclusive"));
    return $9159c2fc84b5e85b$var$D(_$o) && 0 !== _$o ? _$o : 0;
}
function $9159c2fc84b5e85b$var$H(e, t) {
    if (!$9159c2fc84b5e85b$var$Ir(e)) throw new TypeError("".concat(t, " is not a ReadableStream."));
}
function $9159c2fc84b5e85b$var$V(e) {
    return new $9159c2fc84b5e85b$export$a890bf36e2af9168(e);
}
function $9159c2fc84b5e85b$var$U(e, t) {
    e._reader._readRequests.push(t);
}
function $9159c2fc84b5e85b$var$G(e, t, r) {
    var _$o = e._reader._readRequests.shift();
    r ? _$o._closeSteps() : _$o._chunkSteps(t);
}
function $9159c2fc84b5e85b$var$X(e) {
    return e._reader._readRequests.length;
}
function $9159c2fc84b5e85b$var$J(e) {
    var t = e._reader;
    return void 0 !== t && !!$9159c2fc84b5e85b$var$ee(t);
}
var $9159c2fc84b5e85b$export$a890bf36e2af9168 = /*#__PURE__*/ function() {
    "use strict";
    function ReadableStreamDefaultReader(e) {
        (0, $173N4._)(this, ReadableStreamDefaultReader);
        if ($9159c2fc84b5e85b$var$M(e, 1, "ReadableStreamDefaultReader"), $9159c2fc84b5e85b$var$H(e, "First parameter"), $9159c2fc84b5e85b$var$$r(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
        $9159c2fc84b5e85b$var$E(this, e), this._readRequests = new $9159c2fc84b5e85b$var$v;
    }
    (0, $cFHGC._)(ReadableStreamDefaultReader, [
        {
            key: "closed",
            get: function get() {
                return $9159c2fc84b5e85b$var$ee(this) ? this._closedPromise : $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$ne("closed"));
            }
        },
        {
            key: "cancel",
            value: function cancel(e) {
                return $9159c2fc84b5e85b$var$ee(this) ? void 0 === this._ownerReadableStream ? $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$B("cancel")) : $9159c2fc84b5e85b$var$W(this, e) : $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$ne("cancel"));
            }
        },
        {
            key: "read",
            value: function read() {
                if (!$9159c2fc84b5e85b$var$ee(this)) return $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$ne("read"));
                if (void 0 === this._ownerReadableStream) return $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$B("read from"));
                var _$e = $9159c2fc84b5e85b$var$re(this) ? new $9159c2fc84b5e85b$var$Z : new $9159c2fc84b5e85b$var$K;
                return $9159c2fc84b5e85b$var$te(this, _$e), _$e._promise;
            }
        },
        {
            key: "releaseLock",
            value: function releaseLock() {
                if (!$9159c2fc84b5e85b$var$ee(this)) throw $9159c2fc84b5e85b$var$ne("releaseLock");
                void 0 !== this._ownerReadableStream && function(e) {
                    $9159c2fc84b5e85b$var$O(e);
                    var t = new TypeError("Reader was released");
                    $9159c2fc84b5e85b$var$oe(e, t);
                }(this);
            }
        }
    ]);
    return ReadableStreamDefaultReader;
}();
Object.defineProperties($9159c2fc84b5e85b$export$a890bf36e2af9168.prototype, {
    cancel: {
        enumerable: !0
    },
    read: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    }
}), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$a890bf36e2af9168.prototype.cancel, "cancel"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$a890bf36e2af9168.prototype.read, "read"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$a890bf36e2af9168.prototype.releaseLock, "releaseLock"), "symbol" == (0, $7E0eS._)(Symbol.toStringTag) && Object.defineProperty($9159c2fc84b5e85b$export$a890bf36e2af9168.prototype, Symbol.toStringTag, {
    value: "ReadableStreamDefaultReader",
    configurable: !0
});
var $9159c2fc84b5e85b$var$K = /*#__PURE__*/ function() {
    "use strict";
    function K() {
        var _this = this;
        (0, $173N4._)(this, K);
        this._promise = $9159c2fc84b5e85b$var$u(function(e, t) {
            _this._resolvePromise = e, _this._rejectPromise = t;
        });
    }
    (0, $cFHGC._)(K, [
        {
            key: "_chunkSteps",
            value: function _chunkSteps(e) {
                this._resolvePromise({
                    value: e,
                    done: !1
                });
            }
        },
        {
            key: "_closeSteps",
            value: function _closeSteps() {
                this._resolvePromise({
                    value: void 0,
                    done: !0
                });
            }
        },
        {
            key: "_errorSteps",
            value: function _errorSteps(e) {
                this._rejectPromise(e);
            }
        }
    ]);
    return K;
}();
var $9159c2fc84b5e85b$var$Z = /*#__PURE__*/ function() {
    "use strict";
    function Z() {
        (0, $173N4._)(this, Z);
        this._promise = void 0;
    }
    (0, $cFHGC._)(Z, [
        {
            key: "_chunkSteps",
            value: function _chunkSteps(e) {
                this._promise = $9159c2fc84b5e85b$var$l({
                    value: e,
                    done: !1
                });
            }
        },
        {
            key: "_closeSteps",
            value: function _closeSteps() {
                this._promise = $9159c2fc84b5e85b$var$l({
                    value: void 0,
                    done: !0
                });
            }
        },
        {
            key: "_errorSteps",
            value: function _errorSteps(e) {
                this._promise = $9159c2fc84b5e85b$var$d(e);
            }
        }
    ]);
    return Z;
}();
function $9159c2fc84b5e85b$var$ee(e) {
    return !!$9159c2fc84b5e85b$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readRequests") && e instanceof $9159c2fc84b5e85b$export$a890bf36e2af9168;
}
function $9159c2fc84b5e85b$var$te(e, t) {
    var r = e._ownerReadableStream;
    r._disturbed = !0, "closed" === r._state ? t._closeSteps() : "errored" === r._state ? t._errorSteps(r._storedError) : r._readableStreamController[$9159c2fc84b5e85b$var$P](t);
}
function $9159c2fc84b5e85b$var$re(e) {
    var t = e._ownerReadableStream;
    return "closed" === t._state || "errored" === t._state || t._readableStreamController[$9159c2fc84b5e85b$var$C]();
}
function $9159c2fc84b5e85b$var$oe(e, t) {
    var r = e._readRequests;
    e._readRequests = new $9159c2fc84b5e85b$var$v, r.forEach(function(e) {
        e._errorSteps(t);
    });
}
function $9159c2fc84b5e85b$var$ne(e) {
    return new TypeError("ReadableStreamDefaultReader.prototype.".concat(e, " can only be used on a ReadableStreamDefaultReader"));
}
var $9159c2fc84b5e85b$var$ie, $9159c2fc84b5e85b$var$ae, $9159c2fc84b5e85b$var$se;
function $9159c2fc84b5e85b$var$le(e) {
    return e.slice();
}
function $9159c2fc84b5e85b$var$ue(e, t, r, o, n) {
    new Uint8Array(e).set(new Uint8Array(r, o, n), t);
}
var $9159c2fc84b5e85b$var$ce = function(e) {
    return $9159c2fc84b5e85b$var$ce = "function" == typeof e.transfer ? function(e) {
        return e.transfer();
    } : "function" == typeof structuredClone ? function(e) {
        return structuredClone(e, {
            transfer: [
                e
            ]
        });
    } : function(e) {
        return e;
    }, $9159c2fc84b5e85b$var$ce(e);
}, $9159c2fc84b5e85b$var$de = function(e) {
    return $9159c2fc84b5e85b$var$de = "boolean" == typeof e.detached ? function(e) {
        return e.detached;
    } : function(e) {
        return 0 === e.byteLength;
    }, $9159c2fc84b5e85b$var$de(e);
};
function $9159c2fc84b5e85b$var$fe(e, t, r) {
    if (e.slice) return e.slice(t, r);
    var _$o = r - t, n = new ArrayBuffer(_$o);
    return $9159c2fc84b5e85b$var$ue(n, 0, e, t, _$o), n;
}
function $9159c2fc84b5e85b$var$he(e, t) {
    var r = e[t];
    if (null != r) {
        if ("function" != typeof r) throw new TypeError("".concat(String(t), " is not a function"));
        return r;
    }
}
function $9159c2fc84b5e85b$var$be(e) {
    try {
        var t = e.done, r = e.value;
        return $9159c2fc84b5e85b$var$f($9159c2fc84b5e85b$var$l(r), function(e) {
            return {
                done: t,
                value: e
            };
        });
    } catch (e) {
        return $9159c2fc84b5e85b$var$d(e);
    }
}
var $9159c2fc84b5e85b$var$_e = null !== ($9159c2fc84b5e85b$var$se = null !== ($9159c2fc84b5e85b$var$ie = Symbol.asyncIterator) && void 0 !== $9159c2fc84b5e85b$var$ie ? $9159c2fc84b5e85b$var$ie : null === ($9159c2fc84b5e85b$var$ae = Symbol.for) || void 0 === $9159c2fc84b5e85b$var$ae ? void 0 : $9159c2fc84b5e85b$var$ae.call(Symbol, "Symbol.asyncIterator")) && void 0 !== $9159c2fc84b5e85b$var$se ? $9159c2fc84b5e85b$var$se : "@@asyncIterator";
function $9159c2fc84b5e85b$var$me(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "sync", _$o = arguments.length > 2 ? arguments[2] : void 0;
    if (void 0 === _$o) {
        if ("async" === r) {
            if (void 0 === (_$o = $9159c2fc84b5e85b$var$he(e, $9159c2fc84b5e85b$var$_e))) return function(e) {
                var r = {
                    next: function() {
                        var _$t;
                        try {
                            _$t = $9159c2fc84b5e85b$var$pe(e);
                        } catch (e) {
                            return $9159c2fc84b5e85b$var$d(e);
                        }
                        return $9159c2fc84b5e85b$var$be(_$t);
                    },
                    return: function(r) {
                        var _$o;
                        try {
                            var _$t = $9159c2fc84b5e85b$var$he(e.iterator, "return");
                            if (void 0 === _$t) return $9159c2fc84b5e85b$var$c({
                                done: !0,
                                value: r
                            });
                            _$o = $9159c2fc84b5e85b$var$S(_$t, e.iterator, [
                                r
                            ]);
                        } catch (e) {
                            return $9159c2fc84b5e85b$var$d(e);
                        }
                        return $9159c2fc84b5e85b$var$t(_$o) ? $9159c2fc84b5e85b$var$be(_$o) : $9159c2fc84b5e85b$var$d(new TypeError("The iterator.return() method must return an object"));
                    }
                };
                return {
                    iterator: r,
                    nextMethod: r.next,
                    done: !1
                };
            }($9159c2fc84b5e85b$var$me(e, "sync", $9159c2fc84b5e85b$var$he(e, Symbol.iterator)));
        } else _$o = $9159c2fc84b5e85b$var$he(e, Symbol.iterator);
    }
    if (void 0 === _$o) throw new TypeError("The object is not iterable");
    var n = $9159c2fc84b5e85b$var$S(_$o, e, []);
    if (!$9159c2fc84b5e85b$var$t(n)) throw new TypeError("The iterator method must return an object");
    return {
        iterator: n,
        nextMethod: n.next,
        done: !1
    };
}
function $9159c2fc84b5e85b$var$pe(e) {
    var r = $9159c2fc84b5e85b$var$S(e.nextMethod, e.iterator, []);
    if (!$9159c2fc84b5e85b$var$t(r)) throw new TypeError("The iterator.next() method must return an object");
    return r;
}
var $9159c2fc84b5e85b$var$ye = /*#__PURE__*/ function() {
    "use strict";
    function ye(e, t) {
        (0, $173N4._)(this, ye);
        this._ongoingPromise = void 0, this._isFinished = !1, this._reader = e, this._preventCancel = t;
    }
    (0, $cFHGC._)(ye, [
        {
            key: "next",
            value: function next() {
                var _this = this;
                var _$e = function() {
                    return _this._nextSteps();
                };
                return this._ongoingPromise = this._ongoingPromise ? $9159c2fc84b5e85b$var$m(this._ongoingPromise, _$e, _$e) : _$e(), this._ongoingPromise;
            }
        },
        {
            key: "return",
            value: function _return(e) {
                var _this = this;
                var t = function() {
                    return _this._returnSteps(e);
                };
                return this._ongoingPromise = this._ongoingPromise ? $9159c2fc84b5e85b$var$m(this._ongoingPromise, t, t) : t(), this._ongoingPromise;
            }
        },
        {
            key: "_nextSteps",
            value: function _nextSteps() {
                if (this._isFinished) return Promise.resolve({
                    value: void 0,
                    done: !0
                });
                var _$e = this._reader, t = new $9159c2fc84b5e85b$var$Se(this);
                return $9159c2fc84b5e85b$var$te(_$e, t), t._promise;
            }
        },
        {
            key: "_returnSteps",
            value: function _returnSteps(e) {
                if (this._isFinished) return Promise.resolve({
                    value: e,
                    done: !0
                });
                this._isFinished = !0;
                var t = this._reader;
                if (!this._preventCancel) {
                    var r = $9159c2fc84b5e85b$var$W(t, e);
                    return $9159c2fc84b5e85b$var$O(t), $9159c2fc84b5e85b$var$m(r, function() {
                        return {
                            value: e,
                            done: !0
                        };
                    });
                }
                return $9159c2fc84b5e85b$var$O(t), $9159c2fc84b5e85b$var$c({
                    value: e,
                    done: !0
                });
            }
        }
    ]);
    return ye;
}();
var $9159c2fc84b5e85b$var$Se = /*#__PURE__*/ function() {
    "use strict";
    function Se(e) {
        var _this = this;
        (0, $173N4._)(this, Se);
        this._iterator = e, this._promise = $9159c2fc84b5e85b$var$u(function(e, t) {
            _this._resolvePromise = e, _this._rejectPromise = t;
        });
    }
    (0, $cFHGC._)(Se, [
        {
            key: "_chunkSteps",
            value: function _chunkSteps(e) {
                var _this = this;
                this._iterator._ongoingPromise = void 0, $9159c2fc84b5e85b$var$y(function() {
                    return _this._resolvePromise({
                        value: e,
                        done: !1
                    });
                });
            }
        },
        {
            key: "_closeSteps",
            value: function _closeSteps() {
                var _$e = this._iterator;
                _$e._ongoingPromise = void 0, _$e._isFinished = !0, $9159c2fc84b5e85b$var$O(_$e._reader), this._resolvePromise({
                    value: void 0,
                    done: !0
                });
            }
        },
        {
            key: "_errorSteps",
            value: function _errorSteps(e) {
                var t = this._iterator;
                t._ongoingPromise = void 0, t._isFinished = !0, $9159c2fc84b5e85b$var$O(t._reader), this._rejectPromise(e);
            }
        }
    ]);
    return Se;
}();
var $9159c2fc84b5e85b$var$ge = (0, $7Pjls._)({
    next: function() {
        return $9159c2fc84b5e85b$var$ve(this) ? this._asyncIteratorImpl.next() : $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$we("next"));
    },
    return: function(e) {
        return $9159c2fc84b5e85b$var$ve(this) ? this._asyncIteratorImpl.return(e) : $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$we("return"));
    }
}, $9159c2fc84b5e85b$var$_e, function() {
    return this;
});
function $9159c2fc84b5e85b$var$ve(e) {
    if (!$9159c2fc84b5e85b$var$t(e)) return !1;
    if (!Object.prototype.hasOwnProperty.call(e, "_asyncIteratorImpl")) return !1;
    try {
        return e._asyncIteratorImpl instanceof $9159c2fc84b5e85b$var$ye;
    } catch (e) {
        return !1;
    }
}
function $9159c2fc84b5e85b$var$we(e) {
    return new TypeError("ReadableStreamAsyncIterator.".concat(e, " can only be used on a ReadableSteamAsyncIterator"));
}
Object.defineProperty($9159c2fc84b5e85b$var$ge, $9159c2fc84b5e85b$var$_e, {
    enumerable: !1
});
var $9159c2fc84b5e85b$var$Re = Number.isNaN || function(e) {
    return e != e;
};
function $9159c2fc84b5e85b$var$Te(e) {
    var t = $9159c2fc84b5e85b$var$fe(e.buffer, e.byteOffset, e.byteOffset + e.byteLength);
    return new Uint8Array(t);
}
function $9159c2fc84b5e85b$var$Pe(e) {
    var t = e._queue.shift();
    return e._queueTotalSize -= t.size, e._queueTotalSize < 0 && (e._queueTotalSize = 0), t.value;
}
function $9159c2fc84b5e85b$var$Ce(e, t, r) {
    if ("number" != typeof (_$o = r) || $9159c2fc84b5e85b$var$Re(_$o) || _$o < 0 || r === 1 / 0) throw new RangeError("Size must be a finite, non-NaN, non-negative number.");
    var _$o;
    e._queue.push({
        value: t,
        size: r
    }), e._queueTotalSize += r;
}
function $9159c2fc84b5e85b$var$qe(e) {
    e._queue = new $9159c2fc84b5e85b$var$v, e._queueTotalSize = 0;
}
function $9159c2fc84b5e85b$var$Ee(e) {
    return e === DataView;
}
function $9159c2fc84b5e85b$var$We(e) {
    return $9159c2fc84b5e85b$var$Ee(e) ? 1 : e.BYTES_PER_ELEMENT;
}
var $9159c2fc84b5e85b$export$fbcf11583158d2c = /*#__PURE__*/ function() {
    "use strict";
    function ReadableStreamBYOBRequest() {
        (0, $173N4._)(this, ReadableStreamBYOBRequest);
        throw new TypeError("Illegal constructor");
    }
    (0, $cFHGC._)(ReadableStreamBYOBRequest, [
        {
            key: "view",
            get: function get() {
                if (!$9159c2fc84b5e85b$var$Be(this)) throw $9159c2fc84b5e85b$var$ot("view");
                return this._view;
            }
        },
        {
            key: "respond",
            value: function respond(e) {
                if (!$9159c2fc84b5e85b$var$Be(this)) throw $9159c2fc84b5e85b$var$ot("respond");
                if ($9159c2fc84b5e85b$var$M(e, 1, "respond"), e = $9159c2fc84b5e85b$var$N(e, "First parameter"), void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
                if ($9159c2fc84b5e85b$var$de(this._view.buffer)) throw new TypeError("The BYOB request's buffer has been detached and so cannot be used as a response");
                $9159c2fc84b5e85b$var$et(this._associatedReadableByteStreamController, e);
            }
        },
        {
            key: "respondWithNewView",
            value: function respondWithNewView(e) {
                if (!$9159c2fc84b5e85b$var$Be(this)) throw $9159c2fc84b5e85b$var$ot("respondWithNewView");
                if ($9159c2fc84b5e85b$var$M(e, 1, "respondWithNewView"), !ArrayBuffer.isView(e)) throw new TypeError("You can only respond with array buffer views");
                if (void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
                if ($9159c2fc84b5e85b$var$de(e.buffer)) throw new TypeError("The given view's buffer has been detached and so cannot be used as a response");
                $9159c2fc84b5e85b$var$tt(this._associatedReadableByteStreamController, e);
            }
        }
    ]);
    return ReadableStreamBYOBRequest;
}();
Object.defineProperties($9159c2fc84b5e85b$export$fbcf11583158d2c.prototype, {
    respond: {
        enumerable: !0
    },
    respondWithNewView: {
        enumerable: !0
    },
    view: {
        enumerable: !0
    }
}), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$fbcf11583158d2c.prototype.respond, "respond"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$fbcf11583158d2c.prototype.respondWithNewView, "respondWithNewView"), "symbol" == (0, $7E0eS._)(Symbol.toStringTag) && Object.defineProperty($9159c2fc84b5e85b$export$fbcf11583158d2c.prototype, Symbol.toStringTag, {
    value: "ReadableStreamBYOBRequest",
    configurable: !0
});
var $9159c2fc84b5e85b$export$2047cf34091e94ac = /*#__PURE__*/ function() {
    "use strict";
    function ReadableByteStreamController() {
        (0, $173N4._)(this, ReadableByteStreamController);
        throw new TypeError("Illegal constructor");
    }
    (0, $cFHGC._)(ReadableByteStreamController, [
        {
            key: "byobRequest",
            get: function get() {
                if (!$9159c2fc84b5e85b$var$Oe(this)) throw $9159c2fc84b5e85b$var$nt("byobRequest");
                return $9159c2fc84b5e85b$var$Ke(this);
            }
        },
        {
            key: "desiredSize",
            get: function get() {
                if (!$9159c2fc84b5e85b$var$Oe(this)) throw $9159c2fc84b5e85b$var$nt("desiredSize");
                return $9159c2fc84b5e85b$var$Ze(this);
            }
        },
        {
            key: "close",
            value: function close() {
                if (!$9159c2fc84b5e85b$var$Oe(this)) throw $9159c2fc84b5e85b$var$nt("close");
                if (this._closeRequested) throw new TypeError("The stream has already been closed; do not close it again!");
                var _$e = this._controlledReadableByteStream._state;
                if ("readable" !== _$e) throw new TypeError("The stream (in ".concat(_$e, " state) is not in the readable state and cannot be closed"));
                $9159c2fc84b5e85b$var$Ue(this);
            }
        },
        {
            key: "enqueue",
            value: function enqueue(e) {
                if (!$9159c2fc84b5e85b$var$Oe(this)) throw $9159c2fc84b5e85b$var$nt("enqueue");
                if ($9159c2fc84b5e85b$var$M(e, 1, "enqueue"), !ArrayBuffer.isView(e)) throw new TypeError("chunk must be an array buffer view");
                if (0 === e.byteLength) throw new TypeError("chunk must have non-zero byteLength");
                if (0 === e.buffer.byteLength) throw new TypeError("chunk's buffer must have non-zero byteLength");
                if (this._closeRequested) throw new TypeError("stream is closed or draining");
                var t = this._controlledReadableByteStream._state;
                if ("readable" !== t) throw new TypeError("The stream (in ".concat(t, " state) is not in the readable state and cannot be enqueued to"));
                $9159c2fc84b5e85b$var$Ge(this, e);
            }
        },
        {
            key: "error",
            value: function error(e) {
                if (!$9159c2fc84b5e85b$var$Oe(this)) throw $9159c2fc84b5e85b$var$nt("error");
                $9159c2fc84b5e85b$var$Xe(this, e);
            }
        },
        {
            key: $9159c2fc84b5e85b$var$T,
            value: function value(e) {
                $9159c2fc84b5e85b$var$ke(this), $9159c2fc84b5e85b$var$qe(this);
                var t = this._cancelAlgorithm(e);
                return $9159c2fc84b5e85b$var$Ve(this), t;
            }
        },
        {
            key: $9159c2fc84b5e85b$var$P,
            value: function value(e) {
                var _$t = this._controlledReadableByteStream;
                if (this._queueTotalSize > 0) return void $9159c2fc84b5e85b$var$Je(this, e);
                var r = this._autoAllocateChunkSize;
                if (void 0 !== r) {
                    var _$t1;
                    try {
                        _$t1 = new ArrayBuffer(r);
                    } catch (t) {
                        return void e._errorSteps(t);
                    }
                    var _$o = {
                        buffer: _$t1,
                        bufferByteLength: r,
                        byteOffset: 0,
                        byteLength: r,
                        bytesFilled: 0,
                        minimumFill: 1,
                        elementSize: 1,
                        viewConstructor: Uint8Array,
                        readerType: "default"
                    };
                    this._pendingPullIntos.push(_$o);
                }
                $9159c2fc84b5e85b$var$U(_$t, e), $9159c2fc84b5e85b$var$je(this);
            }
        },
        {
            key: $9159c2fc84b5e85b$var$C,
            value: function value() {
                return this._queueTotalSize > 0;
            }
        },
        {
            key: $9159c2fc84b5e85b$var$q,
            value: function value() {
                if (this._pendingPullIntos.length > 0) {
                    var _$e = this._pendingPullIntos.peek();
                    _$e.readerType = "none", this._pendingPullIntos = new $9159c2fc84b5e85b$var$v, this._pendingPullIntos.push(_$e);
                }
            }
        }
    ]);
    return ReadableByteStreamController;
}();
function $9159c2fc84b5e85b$var$Oe(e) {
    return !!$9159c2fc84b5e85b$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableByteStream") && e instanceof $9159c2fc84b5e85b$export$2047cf34091e94ac;
}
function $9159c2fc84b5e85b$var$Be(e) {
    return !!$9159c2fc84b5e85b$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_associatedReadableByteStreamController") && e instanceof $9159c2fc84b5e85b$export$fbcf11583158d2c;
}
function $9159c2fc84b5e85b$var$je(e) {
    var t = function(e) {
        var t = e._controlledReadableByteStream;
        if ("readable" !== t._state) return !1;
        if (e._closeRequested) return !1;
        if (!e._started) return !1;
        if ($9159c2fc84b5e85b$var$J(t) && $9159c2fc84b5e85b$var$X(t) > 0) return !0;
        if ($9159c2fc84b5e85b$var$ut(t) && $9159c2fc84b5e85b$var$lt(t) > 0) return !0;
        var r = $9159c2fc84b5e85b$var$Ze(e);
        if (r > 0) return !0;
        return !1;
    }(e);
    if (!t) return;
    if (e._pulling) return void (e._pullAgain = !0);
    e._pulling = !0;
    $9159c2fc84b5e85b$var$h(e._pullAlgorithm(), function() {
        return e._pulling = !1, e._pullAgain && (e._pullAgain = !1, $9159c2fc84b5e85b$var$je(e)), null;
    }, function(t) {
        return $9159c2fc84b5e85b$var$Xe(e, t), null;
    });
}
function $9159c2fc84b5e85b$var$ke(e) {
    $9159c2fc84b5e85b$var$xe(e), e._pendingPullIntos = new $9159c2fc84b5e85b$var$v;
}
function $9159c2fc84b5e85b$var$Ae(e, t) {
    var r = !1;
    "closed" === e._state && (r = !0);
    var _$o = $9159c2fc84b5e85b$var$De(t);
    "default" === t.readerType ? $9159c2fc84b5e85b$var$G(e, _$o, r) : function(e, t, r) {
        var _$o = e._reader, n = _$o._readIntoRequests.shift();
        r ? n._closeSteps(t) : n._chunkSteps(t);
    }(e, _$o, r);
}
function $9159c2fc84b5e85b$var$ze(e, t) {
    for(var r = 0; r < t.length; ++r)$9159c2fc84b5e85b$var$Ae(e, t[r]);
}
function $9159c2fc84b5e85b$var$De(e) {
    var t = e.bytesFilled, r = e.elementSize;
    return new e.viewConstructor(e.buffer, e.byteOffset, t / r);
}
function $9159c2fc84b5e85b$var$Fe(e, t, r, o) {
    e._queue.push({
        buffer: t,
        byteOffset: r,
        byteLength: o
    }), e._queueTotalSize += o;
}
function $9159c2fc84b5e85b$var$Le(e, t, r, o) {
    var n;
    try {
        n = $9159c2fc84b5e85b$var$fe(t, r, r + o);
    } catch (t) {
        throw $9159c2fc84b5e85b$var$Xe(e, t), t;
    }
    $9159c2fc84b5e85b$var$Fe(e, n, 0, o);
}
function $9159c2fc84b5e85b$var$Ie(e, t) {
    t.bytesFilled > 0 && $9159c2fc84b5e85b$var$Le(e, t.buffer, t.byteOffset, t.bytesFilled), $9159c2fc84b5e85b$var$He(e);
}
function $9159c2fc84b5e85b$var$$e(e, t) {
    var r = Math.min(e._queueTotalSize, t.byteLength - t.bytesFilled), _$o = t.bytesFilled + r;
    var n = r, i = !1;
    var a = _$o - _$o % t.elementSize;
    a >= t.minimumFill && (n = a - t.bytesFilled, i = !0);
    var s = e._queue;
    for(; n > 0;){
        var r1 = s.peek(), _$o1 = Math.min(n, r1.byteLength), i1 = t.byteOffset + t.bytesFilled;
        $9159c2fc84b5e85b$var$ue(t.buffer, i1, r1.buffer, r1.byteOffset, _$o1), r1.byteLength === _$o1 ? s.shift() : (r1.byteOffset += _$o1, r1.byteLength -= _$o1), e._queueTotalSize -= _$o1, $9159c2fc84b5e85b$var$Me(e, _$o1, t), n -= _$o1;
    }
    return i;
}
function $9159c2fc84b5e85b$var$Me(e, t, r) {
    r.bytesFilled += t;
}
function $9159c2fc84b5e85b$var$Ye(e) {
    0 === e._queueTotalSize && e._closeRequested ? ($9159c2fc84b5e85b$var$Ve(e), $9159c2fc84b5e85b$var$Yr(e._controlledReadableByteStream)) : $9159c2fc84b5e85b$var$je(e);
}
function $9159c2fc84b5e85b$var$xe(e) {
    null !== e._byobRequest && (e._byobRequest._associatedReadableByteStreamController = void 0, e._byobRequest._view = null, e._byobRequest = null);
}
function $9159c2fc84b5e85b$var$Qe(e) {
    var t = [];
    for(; e._pendingPullIntos.length > 0 && 0 !== e._queueTotalSize;){
        var r = e._pendingPullIntos.peek();
        $9159c2fc84b5e85b$var$$e(e, r) && ($9159c2fc84b5e85b$var$He(e), t.push(r));
    }
    return t;
}
function $9159c2fc84b5e85b$var$Ne(e, t) {
    var r = e._pendingPullIntos.peek();
    $9159c2fc84b5e85b$var$xe(e);
    "closed" === e._controlledReadableByteStream._state ? function(e, t) {
        "none" === t.readerType && $9159c2fc84b5e85b$var$He(e);
        var r = e._controlledReadableByteStream;
        if ($9159c2fc84b5e85b$var$ut(r)) {
            var _$t = [];
            for(; _$t.length < $9159c2fc84b5e85b$var$lt(r);)_$t.push($9159c2fc84b5e85b$var$He(e));
            $9159c2fc84b5e85b$var$ze(r, _$t);
        }
    }(e, r) : function(e, t, r) {
        if ($9159c2fc84b5e85b$var$Me(0, t, r), "none" === r.readerType) {
            $9159c2fc84b5e85b$var$Ie(e, r);
            var _$t = $9159c2fc84b5e85b$var$Qe(e);
            return void $9159c2fc84b5e85b$var$ze(e._controlledReadableByteStream, _$t);
        }
        if (r.bytesFilled < r.minimumFill) return;
        $9159c2fc84b5e85b$var$He(e);
        var _$o = r.bytesFilled % r.elementSize;
        if (_$o > 0) {
            var _$t1 = r.byteOffset + r.bytesFilled;
            $9159c2fc84b5e85b$var$Le(e, r.buffer, _$t1 - _$o, _$o);
        }
        r.bytesFilled -= _$o;
        var n = $9159c2fc84b5e85b$var$Qe(e);
        $9159c2fc84b5e85b$var$Ae(e._controlledReadableByteStream, r), $9159c2fc84b5e85b$var$ze(e._controlledReadableByteStream, n);
    }(e, t, r), $9159c2fc84b5e85b$var$je(e);
}
function $9159c2fc84b5e85b$var$He(e) {
    return e._pendingPullIntos.shift();
}
function $9159c2fc84b5e85b$var$Ve(e) {
    e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0;
}
function $9159c2fc84b5e85b$var$Ue(e) {
    var t = e._controlledReadableByteStream;
    if (!e._closeRequested && "readable" === t._state) {
        if (e._queueTotalSize > 0) e._closeRequested = !0;
        else {
            if (e._pendingPullIntos.length > 0) {
                var t1 = e._pendingPullIntos.peek();
                if (t1.bytesFilled % t1.elementSize !== 0) {
                    var t2 = new TypeError("Insufficient bytes to fill elements in the given buffer");
                    throw $9159c2fc84b5e85b$var$Xe(e, t2), t2;
                }
            }
            $9159c2fc84b5e85b$var$Ve(e), $9159c2fc84b5e85b$var$Yr(t);
        }
    }
}
function $9159c2fc84b5e85b$var$Ge(e, t) {
    var r = e._controlledReadableByteStream;
    if (e._closeRequested || "readable" !== r._state) return;
    var _$o = t.buffer, n = t.byteOffset, i = t.byteLength;
    if ($9159c2fc84b5e85b$var$de(_$o)) throw new TypeError("chunk's buffer is detached and so cannot be enqueued");
    var a = $9159c2fc84b5e85b$var$ce(_$o);
    if (e._pendingPullIntos.length > 0) {
        var _$t = e._pendingPullIntos.peek();
        if ($9159c2fc84b5e85b$var$de(_$t.buffer)) throw new TypeError("The BYOB request's buffer has been detached and so cannot be filled with an enqueued chunk");
        $9159c2fc84b5e85b$var$xe(e), _$t.buffer = $9159c2fc84b5e85b$var$ce(_$t.buffer), "none" === _$t.readerType && $9159c2fc84b5e85b$var$Ie(e, _$t);
    }
    if ($9159c2fc84b5e85b$var$J(r)) {
        if (function(e) {
            var _$t = e._controlledReadableByteStream._reader;
            for(; _$t._readRequests.length > 0;){
                if (0 === e._queueTotalSize) return;
                $9159c2fc84b5e85b$var$Je(e, _$t._readRequests.shift());
            }
        }(e), 0 === $9159c2fc84b5e85b$var$X(r)) $9159c2fc84b5e85b$var$Fe(e, a, n, i);
        else {
            e._pendingPullIntos.length > 0 && $9159c2fc84b5e85b$var$He(e);
            $9159c2fc84b5e85b$var$G(r, new Uint8Array(a, n, i), !1);
        }
    } else if ($9159c2fc84b5e85b$var$ut(r)) {
        $9159c2fc84b5e85b$var$Fe(e, a, n, i);
        $9159c2fc84b5e85b$var$ze(r, $9159c2fc84b5e85b$var$Qe(e));
    } else $9159c2fc84b5e85b$var$Fe(e, a, n, i);
    $9159c2fc84b5e85b$var$je(e);
}
function $9159c2fc84b5e85b$var$Xe(e, t) {
    var r = e._controlledReadableByteStream;
    "readable" === r._state && ($9159c2fc84b5e85b$var$ke(e), $9159c2fc84b5e85b$var$qe(e), $9159c2fc84b5e85b$var$Ve(e), $9159c2fc84b5e85b$var$xr(r, t));
}
function $9159c2fc84b5e85b$var$Je(e, t) {
    var r = e._queue.shift();
    e._queueTotalSize -= r.byteLength, $9159c2fc84b5e85b$var$Ye(e);
    var _$o = new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
    t._chunkSteps(_$o);
}
function $9159c2fc84b5e85b$var$Ke(e) {
    if (null === e._byobRequest && e._pendingPullIntos.length > 0) {
        var t = e._pendingPullIntos.peek(), r = new Uint8Array(t.buffer, t.byteOffset + t.bytesFilled, t.byteLength - t.bytesFilled), _$o = Object.create($9159c2fc84b5e85b$export$fbcf11583158d2c.prototype);
        !function(e, t, r) {
            e._associatedReadableByteStreamController = t, e._view = r;
        }(_$o, e, r), e._byobRequest = _$o;
    }
    return e._byobRequest;
}
function $9159c2fc84b5e85b$var$Ze(e) {
    var t = e._controlledReadableByteStream._state;
    return "errored" === t ? null : "closed" === t ? 0 : e._strategyHWM - e._queueTotalSize;
}
function $9159c2fc84b5e85b$var$et(e, t) {
    var r = e._pendingPullIntos.peek();
    if ("closed" === e._controlledReadableByteStream._state) {
        if (0 !== t) throw new TypeError("bytesWritten must be 0 when calling respond() on a closed stream");
    } else {
        if (0 === t) throw new TypeError("bytesWritten must be greater than 0 when calling respond() on a readable stream");
        if (r.bytesFilled + t > r.byteLength) throw new RangeError("bytesWritten out of range");
    }
    r.buffer = $9159c2fc84b5e85b$var$ce(r.buffer), $9159c2fc84b5e85b$var$Ne(e, t);
}
function $9159c2fc84b5e85b$var$tt(e, t) {
    var r = e._pendingPullIntos.peek();
    if ("closed" === e._controlledReadableByteStream._state) {
        if (0 !== t.byteLength) throw new TypeError("The view's length must be 0 when calling respondWithNewView() on a closed stream");
    } else if (0 === t.byteLength) throw new TypeError("The view's length must be greater than 0 when calling respondWithNewView() on a readable stream");
    if (r.byteOffset + r.bytesFilled !== t.byteOffset) throw new RangeError("The region specified by view does not match byobRequest");
    if (r.bufferByteLength !== t.buffer.byteLength) throw new RangeError("The buffer of view has different capacity than byobRequest");
    if (r.bytesFilled + t.byteLength > r.byteLength) throw new RangeError("The region specified by view is larger than byobRequest");
    var _$o = t.byteLength;
    r.buffer = $9159c2fc84b5e85b$var$ce(t.buffer), $9159c2fc84b5e85b$var$Ne(e, _$o);
}
function $9159c2fc84b5e85b$var$rt(e, t, r, o, n, i, a) {
    t._controlledReadableByteStream = e, t._pullAgain = !1, t._pulling = !1, t._byobRequest = null, t._queue = t._queueTotalSize = void 0, $9159c2fc84b5e85b$var$qe(t), t._closeRequested = !1, t._started = !1, t._strategyHWM = i, t._pullAlgorithm = o, t._cancelAlgorithm = n, t._autoAllocateChunkSize = a, t._pendingPullIntos = new $9159c2fc84b5e85b$var$v, e._readableStreamController = t;
    $9159c2fc84b5e85b$var$h($9159c2fc84b5e85b$var$c(r()), function() {
        return t._started = !0, $9159c2fc84b5e85b$var$je(t), null;
    }, function(e) {
        return $9159c2fc84b5e85b$var$Xe(t, e), null;
    });
}
function $9159c2fc84b5e85b$var$ot(e) {
    return new TypeError("ReadableStreamBYOBRequest.prototype.".concat(e, " can only be used on a ReadableStreamBYOBRequest"));
}
function $9159c2fc84b5e85b$var$nt(e) {
    return new TypeError("ReadableByteStreamController.prototype.".concat(e, " can only be used on a ReadableByteStreamController"));
}
function $9159c2fc84b5e85b$var$it(e, t) {
    if ("byob" !== (e = "".concat(e))) throw new TypeError("".concat(t, " '").concat(e, "' is not a valid enumeration value for ReadableStreamReaderMode"));
    return e;
}
function $9159c2fc84b5e85b$var$at(e) {
    return new $9159c2fc84b5e85b$export$20068a30393fcc28(e);
}
function $9159c2fc84b5e85b$var$st(e, t) {
    e._reader._readIntoRequests.push(t);
}
function $9159c2fc84b5e85b$var$lt(e) {
    return e._reader._readIntoRequests.length;
}
function $9159c2fc84b5e85b$var$ut(e) {
    var t = e._reader;
    return void 0 !== t && !!$9159c2fc84b5e85b$var$ft(t);
}
Object.defineProperties($9159c2fc84b5e85b$export$2047cf34091e94ac.prototype, {
    close: {
        enumerable: !0
    },
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    byobRequest: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$2047cf34091e94ac.prototype.close, "close"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$2047cf34091e94ac.prototype.enqueue, "enqueue"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$2047cf34091e94ac.prototype.error, "error"), "symbol" == (0, $7E0eS._)(Symbol.toStringTag) && Object.defineProperty($9159c2fc84b5e85b$export$2047cf34091e94ac.prototype, Symbol.toStringTag, {
    value: "ReadableByteStreamController",
    configurable: !0
});
var $9159c2fc84b5e85b$export$20068a30393fcc28 = /*#__PURE__*/ function() {
    "use strict";
    function ReadableStreamBYOBReader(e) {
        (0, $173N4._)(this, ReadableStreamBYOBReader);
        if ($9159c2fc84b5e85b$var$M(e, 1, "ReadableStreamBYOBReader"), $9159c2fc84b5e85b$var$H(e, "First parameter"), $9159c2fc84b5e85b$var$$r(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
        if (!$9159c2fc84b5e85b$var$Oe(e._readableStreamController)) throw new TypeError("Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte source");
        $9159c2fc84b5e85b$var$E(this, e), this._readIntoRequests = new $9159c2fc84b5e85b$var$v;
    }
    (0, $cFHGC._)(ReadableStreamBYOBReader, [
        {
            key: "closed",
            get: function get() {
                return $9159c2fc84b5e85b$var$ft(this) ? this._closedPromise : $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$_t("closed"));
            }
        },
        {
            key: "cancel",
            value: function cancel(e) {
                return $9159c2fc84b5e85b$var$ft(this) ? void 0 === this._ownerReadableStream ? $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$B("cancel")) : $9159c2fc84b5e85b$var$W(this, e) : $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$_t("cancel"));
            }
        },
        {
            key: "read",
            value: function read(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (!$9159c2fc84b5e85b$var$ft(this)) return $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$_t("read"));
                if (!ArrayBuffer.isView(e)) return $9159c2fc84b5e85b$var$d(new TypeError("view must be an array buffer view"));
                if (0 === e.byteLength) return $9159c2fc84b5e85b$var$d(new TypeError("view must have non-zero byteLength"));
                if (0 === e.buffer.byteLength) return $9159c2fc84b5e85b$var$d(new TypeError("view's buffer must have non-zero byteLength"));
                if ($9159c2fc84b5e85b$var$de(e.buffer)) return $9159c2fc84b5e85b$var$d(new TypeError("view's buffer has been detached"));
                var r;
                try {
                    r = function(e, t) {
                        var r;
                        return $9159c2fc84b5e85b$var$L(e, t), {
                            min: $9159c2fc84b5e85b$var$N(null !== (r = null == e ? void 0 : e.min) && void 0 !== r ? r : 1, "".concat(t, " has member 'min' that"))
                        };
                    }(t, "options");
                } catch (e) {
                    return $9159c2fc84b5e85b$var$d(e);
                }
                var _$o = r.min;
                if (0 === _$o) return $9159c2fc84b5e85b$var$d(new TypeError("options.min must be greater than 0"));
                if (function(e) {
                    return $9159c2fc84b5e85b$var$Ee(e.constructor);
                }(e)) {
                    if (_$o > e.byteLength) return $9159c2fc84b5e85b$var$d(new RangeError("options.min must be less than or equal to view's byteLength"));
                } else if (_$o > e.length) return $9159c2fc84b5e85b$var$d(new RangeError("options.min must be less than or equal to view's length"));
                if (void 0 === this._ownerReadableStream) return $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$B("read from"));
                var n = function(e, t, r) {
                    var _$o = e._ownerReadableStream;
                    return "errored" === _$o._state || function(e, t, r) {
                        var _$o = e._controlledReadableByteStream, n = $9159c2fc84b5e85b$var$We(t.constructor), i = t.byteLength, a = r * n;
                        return !(e._pendingPullIntos.length > 0) && ("closed" === _$o._state || e._queueTotalSize >= a);
                    }(_$o._readableStreamController, t, r);
                }(this, e, _$o) ? new $9159c2fc84b5e85b$var$dt : new $9159c2fc84b5e85b$var$ct;
                return $9159c2fc84b5e85b$var$ht(this, e, _$o, n), n._promise;
            }
        },
        {
            key: "releaseLock",
            value: function releaseLock() {
                if (!$9159c2fc84b5e85b$var$ft(this)) throw $9159c2fc84b5e85b$var$_t("releaseLock");
                void 0 !== this._ownerReadableStream && function(e) {
                    $9159c2fc84b5e85b$var$O(e);
                    var t = new TypeError("Reader was released");
                    $9159c2fc84b5e85b$var$bt(e, t);
                }(this);
            }
        }
    ]);
    return ReadableStreamBYOBReader;
}();
Object.defineProperties($9159c2fc84b5e85b$export$20068a30393fcc28.prototype, {
    cancel: {
        enumerable: !0
    },
    read: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    }
}), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$20068a30393fcc28.prototype.cancel, "cancel"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$20068a30393fcc28.prototype.read, "read"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$20068a30393fcc28.prototype.releaseLock, "releaseLock"), "symbol" == (0, $7E0eS._)(Symbol.toStringTag) && Object.defineProperty($9159c2fc84b5e85b$export$20068a30393fcc28.prototype, Symbol.toStringTag, {
    value: "ReadableStreamBYOBReader",
    configurable: !0
});
var $9159c2fc84b5e85b$var$ct = /*#__PURE__*/ function() {
    "use strict";
    function ct() {
        var _this = this;
        (0, $173N4._)(this, ct);
        this._promise = $9159c2fc84b5e85b$var$u(function(e, t) {
            _this._resolvePromise = e, _this._rejectPromise = t;
        });
    }
    (0, $cFHGC._)(ct, [
        {
            key: "_chunkSteps",
            value: function _chunkSteps(e) {
                this._resolvePromise({
                    value: e,
                    done: !1
                });
            }
        },
        {
            key: "_closeSteps",
            value: function _closeSteps(e) {
                this._resolvePromise({
                    value: e,
                    done: !0
                });
            }
        },
        {
            key: "_errorSteps",
            value: function _errorSteps(e) {
                this._rejectPromise(e);
            }
        }
    ]);
    return ct;
}();
var $9159c2fc84b5e85b$var$dt = /*#__PURE__*/ function() {
    "use strict";
    function dt() {
        (0, $173N4._)(this, dt);
        this._promise = void 0;
    }
    (0, $cFHGC._)(dt, [
        {
            key: "_chunkSteps",
            value: function _chunkSteps(e) {
                this._promise = $9159c2fc84b5e85b$var$l({
                    value: e,
                    done: !1
                });
            }
        },
        {
            key: "_closeSteps",
            value: function _closeSteps(e) {
                this._promise = $9159c2fc84b5e85b$var$l({
                    value: e,
                    done: !0
                });
            }
        },
        {
            key: "_errorSteps",
            value: function _errorSteps(e) {
                this._promise = $9159c2fc84b5e85b$var$d(e);
            }
        }
    ]);
    return dt;
}();
function $9159c2fc84b5e85b$var$ft(e) {
    return !!$9159c2fc84b5e85b$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readIntoRequests") && e instanceof $9159c2fc84b5e85b$export$20068a30393fcc28;
}
function $9159c2fc84b5e85b$var$ht(e, t, r, o) {
    var n = e._ownerReadableStream;
    n._disturbed = !0, "errored" === n._state ? o._errorSteps(n._storedError) : function(e, t, r, o) {
        var n = e._controlledReadableByteStream, i = t.constructor, a = $9159c2fc84b5e85b$var$We(i), s = t.byteOffset, l = t.byteLength, u = r * a;
        var c;
        try {
            c = $9159c2fc84b5e85b$var$ce(t.buffer);
        } catch (e) {
            return void o._errorSteps(e);
        }
        var d = {
            buffer: c,
            bufferByteLength: c.byteLength,
            byteOffset: s,
            byteLength: l,
            bytesFilled: 0,
            minimumFill: u,
            elementSize: a,
            viewConstructor: i,
            readerType: "byob"
        };
        if (e._pendingPullIntos.length > 0) return e._pendingPullIntos.push(d), void $9159c2fc84b5e85b$var$st(n, o);
        if ("closed" === n._state) {
            var _$e = new i(d.buffer, d.byteOffset, 0);
            return void o._closeSteps(_$e);
        }
        if (e._queueTotalSize > 0) {
            if ($9159c2fc84b5e85b$var$$e(e, d)) {
                var _$t = $9159c2fc84b5e85b$var$De(d);
                return $9159c2fc84b5e85b$var$Ye(e), void o._chunkSteps(_$t);
            }
            if (e._closeRequested) {
                var _$t1 = new TypeError("Insufficient bytes to fill elements in the given buffer");
                return $9159c2fc84b5e85b$var$Xe(e, _$t1), void o._errorSteps(_$t1);
            }
        }
        e._pendingPullIntos.push(d), $9159c2fc84b5e85b$var$st(n, o), $9159c2fc84b5e85b$var$je(e);
    }(n._readableStreamController, t, r, o);
}
function $9159c2fc84b5e85b$var$bt(e, t) {
    var r = e._readIntoRequests;
    e._readIntoRequests = new $9159c2fc84b5e85b$var$v, r.forEach(function(e) {
        e._errorSteps(t);
    });
}
function $9159c2fc84b5e85b$var$_t(e) {
    return new TypeError("ReadableStreamBYOBReader.prototype.".concat(e, " can only be used on a ReadableStreamBYOBReader"));
}
function $9159c2fc84b5e85b$var$mt(e, t) {
    var r = e.highWaterMark;
    if (void 0 === r) return t;
    if ($9159c2fc84b5e85b$var$Re(r) || r < 0) throw new RangeError("Invalid highWaterMark");
    return r;
}
function $9159c2fc84b5e85b$var$pt(e) {
    var t = e.size;
    return t || function() {
        return 1;
    };
}
function $9159c2fc84b5e85b$var$yt(e, t) {
    $9159c2fc84b5e85b$var$L(e, t);
    var r = null == e ? void 0 : e.highWaterMark, _$o = null == e ? void 0 : e.size;
    return {
        highWaterMark: void 0 === r ? void 0 : $9159c2fc84b5e85b$var$x(r),
        size: void 0 === _$o ? void 0 : $9159c2fc84b5e85b$var$St(_$o, "".concat(t, " has member 'size' that"))
    };
}
function $9159c2fc84b5e85b$var$St(e, t) {
    return $9159c2fc84b5e85b$var$I(e, t), function(t) {
        return $9159c2fc84b5e85b$var$x(e(t));
    };
}
function $9159c2fc84b5e85b$var$gt(e, t, r) {
    return $9159c2fc84b5e85b$var$I(e, r), function(r) {
        return $9159c2fc84b5e85b$var$g(e, t, [
            r
        ]);
    };
}
function $9159c2fc84b5e85b$var$vt(e, t, r) {
    return $9159c2fc84b5e85b$var$I(e, r), function() {
        return $9159c2fc84b5e85b$var$g(e, t, []);
    };
}
function $9159c2fc84b5e85b$var$wt(e, t, r) {
    return $9159c2fc84b5e85b$var$I(e, r), function(r) {
        return $9159c2fc84b5e85b$var$S(e, t, [
            r
        ]);
    };
}
function $9159c2fc84b5e85b$var$Rt(e, t, r) {
    return $9159c2fc84b5e85b$var$I(e, r), function(r, o) {
        return $9159c2fc84b5e85b$var$g(e, t, [
            r,
            o
        ]);
    };
}
function $9159c2fc84b5e85b$var$Tt(e, t) {
    if (!$9159c2fc84b5e85b$var$qt(e)) throw new TypeError("".concat(t, " is not a WritableStream."));
}
var $9159c2fc84b5e85b$export$826849241f7970f8 = /*#__PURE__*/ function() {
    "use strict";
    function WritableStream() {
        var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $173N4._)(this, WritableStream);
        void 0 === _$e ? _$e = null : $9159c2fc84b5e85b$var$$(_$e, "First parameter");
        var r = $9159c2fc84b5e85b$var$yt(t, "Second parameter"), _$o = function(e, t) {
            $9159c2fc84b5e85b$var$L(e, t);
            var r = null == e ? void 0 : e.abort, _$o = null == e ? void 0 : e.close, n = null == e ? void 0 : e.start, i = null == e ? void 0 : e.type, a = null == e ? void 0 : e.write;
            return {
                abort: void 0 === r ? void 0 : $9159c2fc84b5e85b$var$gt(r, e, "".concat(t, " has member 'abort' that")),
                close: void 0 === _$o ? void 0 : $9159c2fc84b5e85b$var$vt(_$o, e, "".concat(t, " has member 'close' that")),
                start: void 0 === n ? void 0 : $9159c2fc84b5e85b$var$wt(n, e, "".concat(t, " has member 'start' that")),
                write: void 0 === a ? void 0 : $9159c2fc84b5e85b$var$Rt(a, e, "".concat(t, " has member 'write' that")),
                type: i
            };
        }(_$e, "First parameter");
        $9159c2fc84b5e85b$var$Ct(this);
        if (void 0 !== _$o.type) throw new RangeError("Invalid type is specified");
        var n = $9159c2fc84b5e85b$var$pt(r);
        !function(e, t, r, o) {
            var n = Object.create($9159c2fc84b5e85b$export$9e6890cb9a51c7c2.prototype);
            var i, a, s, l;
            i = void 0 !== t.start ? function() {
                return t.start(n);
            } : function() {};
            a = void 0 !== t.write ? function(e) {
                return t.write(e, n);
            } : function() {
                return $9159c2fc84b5e85b$var$c(void 0);
            };
            s = void 0 !== t.close ? function() {
                return t.close();
            } : function() {
                return $9159c2fc84b5e85b$var$c(void 0);
            };
            l = void 0 !== t.abort ? function(e) {
                return t.abort(e);
            } : function() {
                return $9159c2fc84b5e85b$var$c(void 0);
            };
            $9159c2fc84b5e85b$var$Nt(e, n, i, a, s, l, r, o);
        }(this, _$o, $9159c2fc84b5e85b$var$mt(r, 1), n);
    }
    (0, $cFHGC._)(WritableStream, [
        {
            key: "locked",
            get: function get() {
                if (!$9159c2fc84b5e85b$var$qt(this)) throw $9159c2fc84b5e85b$var$Kt("locked");
                return $9159c2fc84b5e85b$var$Et(this);
            }
        },
        {
            key: "abort",
            value: function abort(e) {
                return $9159c2fc84b5e85b$var$qt(this) ? $9159c2fc84b5e85b$var$Et(this) ? $9159c2fc84b5e85b$var$d(new TypeError("Cannot abort a stream that already has a writer")) : $9159c2fc84b5e85b$var$Wt(this, e) : $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$Kt("abort"));
            }
        },
        {
            key: "close",
            value: function close() {
                return $9159c2fc84b5e85b$var$qt(this) ? $9159c2fc84b5e85b$var$Et(this) ? $9159c2fc84b5e85b$var$d(new TypeError("Cannot close a stream that already has a writer")) : $9159c2fc84b5e85b$var$At(this) ? $9159c2fc84b5e85b$var$d(new TypeError("Cannot close an already-closing stream")) : $9159c2fc84b5e85b$var$Ot(this) : $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$Kt("close"));
            }
        },
        {
            key: "getWriter",
            value: function getWriter() {
                if (!$9159c2fc84b5e85b$var$qt(this)) throw $9159c2fc84b5e85b$var$Kt("getWriter");
                return $9159c2fc84b5e85b$var$Pt(this);
            }
        }
    ]);
    return WritableStream;
}();
function $9159c2fc84b5e85b$var$Pt(e) {
    return new $9159c2fc84b5e85b$export$9295348f005d6054(e);
}
function $9159c2fc84b5e85b$var$Ct(e) {
    e._state = "writable", e._storedError = void 0, e._writer = void 0, e._writableStreamController = void 0, e._writeRequests = new $9159c2fc84b5e85b$var$v, e._inFlightWriteRequest = void 0, e._closeRequest = void 0, e._inFlightCloseRequest = void 0, e._pendingAbortRequest = void 0, e._backpressure = !1;
}
function $9159c2fc84b5e85b$var$qt(e) {
    return !!$9159c2fc84b5e85b$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_writableStreamController") && e instanceof $9159c2fc84b5e85b$export$826849241f7970f8;
}
function $9159c2fc84b5e85b$var$Et(e) {
    return void 0 !== e._writer;
}
function $9159c2fc84b5e85b$var$Wt(e, t) {
    var r;
    if ("closed" === e._state || "errored" === e._state) return $9159c2fc84b5e85b$var$c(void 0);
    e._writableStreamController._abortReason = t, null === (r = e._writableStreamController._abortController) || void 0 === r || r.abort(t);
    var _$o = e._state;
    if ("closed" === _$o || "errored" === _$o) return $9159c2fc84b5e85b$var$c(void 0);
    if (void 0 !== e._pendingAbortRequest) return e._pendingAbortRequest._promise;
    var n = !1;
    "erroring" === _$o && (n = !0, t = void 0);
    var i = $9159c2fc84b5e85b$var$u(function(r, o) {
        e._pendingAbortRequest = {
            _promise: void 0,
            _resolve: r,
            _reject: o,
            _reason: t,
            _wasAlreadyErroring: n
        };
    });
    return e._pendingAbortRequest._promise = i, n || $9159c2fc84b5e85b$var$jt(e, t), i;
}
function $9159c2fc84b5e85b$var$Ot(e) {
    var t = e._state;
    if ("closed" === t || "errored" === t) return $9159c2fc84b5e85b$var$d(new TypeError("The stream (in ".concat(t, " state) is not in the writable state and cannot be closed")));
    var r = $9159c2fc84b5e85b$var$u(function(t, r) {
        var _$o = {
            _resolve: t,
            _reject: r
        };
        e._closeRequest = _$o;
    }), _$o = e._writer;
    var n;
    return void 0 !== _$o && e._backpressure && "writable" === t && $9159c2fc84b5e85b$var$cr(_$o), $9159c2fc84b5e85b$var$Ce(n = e._writableStreamController, $9159c2fc84b5e85b$var$xt, 0), $9159c2fc84b5e85b$var$Ut(n), r;
}
function $9159c2fc84b5e85b$var$Bt(e, t) {
    "writable" !== e._state ? $9159c2fc84b5e85b$var$kt(e) : $9159c2fc84b5e85b$var$jt(e, t);
}
function $9159c2fc84b5e85b$var$jt(e, t) {
    var r = e._writableStreamController;
    e._state = "erroring", e._storedError = t;
    var _$o = e._writer;
    void 0 !== _$o && $9159c2fc84b5e85b$var$$t(_$o, t), !function(e) {
        if (void 0 === e._inFlightWriteRequest && void 0 === e._inFlightCloseRequest) return !1;
        return !0;
    }(e) && r._started && $9159c2fc84b5e85b$var$kt(e);
}
function $9159c2fc84b5e85b$var$kt(e) {
    e._state = "errored", e._writableStreamController[$9159c2fc84b5e85b$var$R]();
    var t = e._storedError;
    if (e._writeRequests.forEach(function(e) {
        e._reject(t);
    }), e._writeRequests = new $9159c2fc84b5e85b$var$v, void 0 === e._pendingAbortRequest) return void $9159c2fc84b5e85b$var$zt(e);
    var r = e._pendingAbortRequest;
    if (e._pendingAbortRequest = void 0, r._wasAlreadyErroring) return r._reject(t), void $9159c2fc84b5e85b$var$zt(e);
    $9159c2fc84b5e85b$var$h(e._writableStreamController[$9159c2fc84b5e85b$var$w](r._reason), function() {
        return r._resolve(), $9159c2fc84b5e85b$var$zt(e), null;
    }, function(t) {
        return r._reject(t), $9159c2fc84b5e85b$var$zt(e), null;
    });
}
function $9159c2fc84b5e85b$var$At(e) {
    return void 0 !== e._closeRequest || void 0 !== e._inFlightCloseRequest;
}
function $9159c2fc84b5e85b$var$zt(e) {
    void 0 !== e._closeRequest && (e._closeRequest._reject(e._storedError), e._closeRequest = void 0);
    var t = e._writer;
    void 0 !== t && $9159c2fc84b5e85b$var$nr(t, e._storedError);
}
function $9159c2fc84b5e85b$var$Dt(e, t) {
    var r = e._writer;
    void 0 !== r && t !== e._backpressure && (t ? function(e) {
        $9159c2fc84b5e85b$var$ar(e);
    }(r) : $9159c2fc84b5e85b$var$cr(r)), e._backpressure = t;
}
Object.defineProperties($9159c2fc84b5e85b$export$826849241f7970f8.prototype, {
    abort: {
        enumerable: !0
    },
    close: {
        enumerable: !0
    },
    getWriter: {
        enumerable: !0
    },
    locked: {
        enumerable: !0
    }
}), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$826849241f7970f8.prototype.abort, "abort"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$826849241f7970f8.prototype.close, "close"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$826849241f7970f8.prototype.getWriter, "getWriter"), "symbol" == (0, $7E0eS._)(Symbol.toStringTag) && Object.defineProperty($9159c2fc84b5e85b$export$826849241f7970f8.prototype, Symbol.toStringTag, {
    value: "WritableStream",
    configurable: !0
});
var $9159c2fc84b5e85b$export$9295348f005d6054 = /*#__PURE__*/ function() {
    "use strict";
    function WritableStreamDefaultWriter(e) {
        (0, $173N4._)(this, WritableStreamDefaultWriter);
        if ($9159c2fc84b5e85b$var$M(e, 1, "WritableStreamDefaultWriter"), $9159c2fc84b5e85b$var$Tt(e, "First parameter"), $9159c2fc84b5e85b$var$Et(e)) throw new TypeError("This stream has already been locked for exclusive writing by another writer");
        this._ownerWritableStream = e, e._writer = this;
        var t = e._state;
        if ("writable" === t) !$9159c2fc84b5e85b$var$At(e) && e._backpressure ? $9159c2fc84b5e85b$var$ar(this) : $9159c2fc84b5e85b$var$lr(this), $9159c2fc84b5e85b$var$rr(this);
        else if ("erroring" === t) $9159c2fc84b5e85b$var$sr(this, e._storedError), $9159c2fc84b5e85b$var$rr(this);
        else if ("closed" === t) $9159c2fc84b5e85b$var$lr(this), $9159c2fc84b5e85b$var$rr(r = this), $9159c2fc84b5e85b$var$ir(r);
        else {
            var t1 = e._storedError;
            $9159c2fc84b5e85b$var$sr(this, t1), $9159c2fc84b5e85b$var$or(this, t1);
        }
        var r;
    }
    (0, $cFHGC._)(WritableStreamDefaultWriter, [
        {
            key: "closed",
            get: function get() {
                return $9159c2fc84b5e85b$var$Ft(this) ? this._closedPromise : $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$er("closed"));
            }
        },
        {
            key: "desiredSize",
            get: function get() {
                if (!$9159c2fc84b5e85b$var$Ft(this)) throw $9159c2fc84b5e85b$var$er("desiredSize");
                if (void 0 === this._ownerWritableStream) throw $9159c2fc84b5e85b$var$tr("desiredSize");
                return function(e) {
                    var t = e._ownerWritableStream, r = t._state;
                    if ("errored" === r || "erroring" === r) return null;
                    if ("closed" === r) return 0;
                    return $9159c2fc84b5e85b$var$Vt(t._writableStreamController);
                }(this);
            }
        },
        {
            key: "ready",
            get: function get() {
                return $9159c2fc84b5e85b$var$Ft(this) ? this._readyPromise : $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$er("ready"));
            }
        },
        {
            key: "abort",
            value: function abort(e) {
                return $9159c2fc84b5e85b$var$Ft(this) ? void 0 === this._ownerWritableStream ? $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$tr("abort")) : function(e, t) {
                    return $9159c2fc84b5e85b$var$Wt(e._ownerWritableStream, t);
                }(this, e) : $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$er("abort"));
            }
        },
        {
            key: "close",
            value: function close() {
                if (!$9159c2fc84b5e85b$var$Ft(this)) return $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$er("close"));
                var _$e = this._ownerWritableStream;
                return void 0 === _$e ? $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$tr("close")) : $9159c2fc84b5e85b$var$At(_$e) ? $9159c2fc84b5e85b$var$d(new TypeError("Cannot close an already-closing stream")) : $9159c2fc84b5e85b$var$Lt(this);
            }
        },
        {
            key: "releaseLock",
            value: function releaseLock() {
                if (!$9159c2fc84b5e85b$var$Ft(this)) throw $9159c2fc84b5e85b$var$er("releaseLock");
                void 0 !== this._ownerWritableStream && $9159c2fc84b5e85b$var$Mt(this);
            }
        },
        {
            key: "write",
            value: function write(e) {
                return $9159c2fc84b5e85b$var$Ft(this) ? void 0 === this._ownerWritableStream ? $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$tr("write to")) : $9159c2fc84b5e85b$var$Yt(this, e) : $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$er("write"));
            }
        }
    ]);
    return WritableStreamDefaultWriter;
}();
function $9159c2fc84b5e85b$var$Ft(e) {
    return !!$9159c2fc84b5e85b$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_ownerWritableStream") && e instanceof $9159c2fc84b5e85b$export$9295348f005d6054;
}
function $9159c2fc84b5e85b$var$Lt(e) {
    return $9159c2fc84b5e85b$var$Ot(e._ownerWritableStream);
}
function $9159c2fc84b5e85b$var$It(e, t) {
    "pending" === e._closedPromiseState ? $9159c2fc84b5e85b$var$nr(e, t) : function(e, t) {
        $9159c2fc84b5e85b$var$or(e, t);
    }(e, t);
}
function $9159c2fc84b5e85b$var$$t(e, t) {
    "pending" === e._readyPromiseState ? $9159c2fc84b5e85b$var$ur(e, t) : function(e, t) {
        $9159c2fc84b5e85b$var$sr(e, t);
    }(e, t);
}
function $9159c2fc84b5e85b$var$Mt(e) {
    var t = e._ownerWritableStream, r = new TypeError("Writer was released and can no longer be used to monitor the stream's closedness");
    $9159c2fc84b5e85b$var$$t(e, r), $9159c2fc84b5e85b$var$It(e, r), t._writer = void 0, e._ownerWritableStream = void 0;
}
function $9159c2fc84b5e85b$var$Yt(e, t) {
    var r = e._ownerWritableStream, _$o = r._writableStreamController, n = function(e, t) {
        if (void 0 === e._strategySizeAlgorithm) return 1;
        try {
            return e._strategySizeAlgorithm(t);
        } catch (t) {
            return $9159c2fc84b5e85b$var$Gt(e, t), 1;
        }
    }(_$o, t);
    if (r !== e._ownerWritableStream) return $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$tr("write to"));
    var i = r._state;
    if ("errored" === i) return $9159c2fc84b5e85b$var$d(r._storedError);
    if ($9159c2fc84b5e85b$var$At(r) || "closed" === i) return $9159c2fc84b5e85b$var$d(new TypeError("The stream is closing or closed and cannot be written to"));
    if ("erroring" === i) return $9159c2fc84b5e85b$var$d(r._storedError);
    var a = function(e) {
        return $9159c2fc84b5e85b$var$u(function(t, r) {
            var _$o = {
                _resolve: t,
                _reject: r
            };
            e._writeRequests.push(_$o);
        });
    }(r);
    return function(e, t, r) {
        try {
            $9159c2fc84b5e85b$var$Ce(e, t, r);
        } catch (t) {
            return void $9159c2fc84b5e85b$var$Gt(e, t);
        }
        var _$o = e._controlledWritableStream;
        if (!$9159c2fc84b5e85b$var$At(_$o) && "writable" === _$o._state) $9159c2fc84b5e85b$var$Dt(_$o, $9159c2fc84b5e85b$var$Xt(e));
        $9159c2fc84b5e85b$var$Ut(e);
    }(_$o, t, n), a;
}
Object.defineProperties($9159c2fc84b5e85b$export$9295348f005d6054.prototype, {
    abort: {
        enumerable: !0
    },
    close: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    write: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    },
    ready: {
        enumerable: !0
    }
}), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$9295348f005d6054.prototype.abort, "abort"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$9295348f005d6054.prototype.close, "close"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$9295348f005d6054.prototype.releaseLock, "releaseLock"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$9295348f005d6054.prototype.write, "write"), "symbol" == (0, $7E0eS._)(Symbol.toStringTag) && Object.defineProperty($9159c2fc84b5e85b$export$9295348f005d6054.prototype, Symbol.toStringTag, {
    value: "WritableStreamDefaultWriter",
    configurable: !0
});
var $9159c2fc84b5e85b$var$xt = {};
var $9159c2fc84b5e85b$export$9e6890cb9a51c7c2 = /*#__PURE__*/ function() {
    "use strict";
    function WritableStreamDefaultController() {
        (0, $173N4._)(this, WritableStreamDefaultController);
        throw new TypeError("Illegal constructor");
    }
    (0, $cFHGC._)(WritableStreamDefaultController, [
        {
            key: "abortReason",
            get: function get() {
                if (!$9159c2fc84b5e85b$var$Qt(this)) throw $9159c2fc84b5e85b$var$Zt("abortReason");
                return this._abortReason;
            }
        },
        {
            key: "signal",
            get: function get() {
                if (!$9159c2fc84b5e85b$var$Qt(this)) throw $9159c2fc84b5e85b$var$Zt("signal");
                if (void 0 === this._abortController) throw new TypeError("WritableStreamDefaultController.prototype.signal is not supported");
                return this._abortController.signal;
            }
        },
        {
            key: "error",
            value: function error(e) {
                if (!$9159c2fc84b5e85b$var$Qt(this)) throw $9159c2fc84b5e85b$var$Zt("error");
                "writable" === this._controlledWritableStream._state && $9159c2fc84b5e85b$var$Jt(this, e);
            }
        },
        {
            key: $9159c2fc84b5e85b$var$w,
            value: function value(e) {
                var t = this._abortAlgorithm(e);
                return $9159c2fc84b5e85b$var$Ht(this), t;
            }
        },
        {
            key: $9159c2fc84b5e85b$var$R,
            value: function value() {
                $9159c2fc84b5e85b$var$qe(this);
            }
        }
    ]);
    return WritableStreamDefaultController;
}();
function $9159c2fc84b5e85b$var$Qt(e) {
    return !!$9159c2fc84b5e85b$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledWritableStream") && e instanceof $9159c2fc84b5e85b$export$9e6890cb9a51c7c2;
}
function $9159c2fc84b5e85b$var$Nt(e, t, r, o, n, i, a, s) {
    t._controlledWritableStream = e, e._writableStreamController = t, t._queue = void 0, t._queueTotalSize = void 0, $9159c2fc84b5e85b$var$qe(t), t._abortReason = void 0, t._abortController = function() {
        if ("function" == typeof AbortController) return new AbortController;
    }(), t._started = !1, t._strategySizeAlgorithm = s, t._strategyHWM = a, t._writeAlgorithm = o, t._closeAlgorithm = n, t._abortAlgorithm = i;
    var l = $9159c2fc84b5e85b$var$Xt(t);
    $9159c2fc84b5e85b$var$Dt(e, l);
    $9159c2fc84b5e85b$var$h($9159c2fc84b5e85b$var$c(r()), function() {
        return t._started = !0, $9159c2fc84b5e85b$var$Ut(t), null;
    }, function(r) {
        return t._started = !0, $9159c2fc84b5e85b$var$Bt(e, r), null;
    });
}
function $9159c2fc84b5e85b$var$Ht(e) {
    e._writeAlgorithm = void 0, e._closeAlgorithm = void 0, e._abortAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
}
function $9159c2fc84b5e85b$var$Vt(e) {
    return e._strategyHWM - e._queueTotalSize;
}
function $9159c2fc84b5e85b$var$Ut(e) {
    var t = e._controlledWritableStream;
    if (!e._started) return;
    if (void 0 !== t._inFlightWriteRequest) return;
    if ("erroring" === t._state) return void $9159c2fc84b5e85b$var$kt(t);
    if (0 === e._queue.length) return;
    var r = e._queue.peek().value;
    r === $9159c2fc84b5e85b$var$xt ? function(e) {
        var t = e._controlledWritableStream;
        (function(e) {
            e._inFlightCloseRequest = e._closeRequest, e._closeRequest = void 0;
        })(t), $9159c2fc84b5e85b$var$Pe(e);
        var r = e._closeAlgorithm();
        $9159c2fc84b5e85b$var$Ht(e), $9159c2fc84b5e85b$var$h(r, function() {
            return function(e) {
                e._inFlightCloseRequest._resolve(void 0), e._inFlightCloseRequest = void 0, "erroring" === e._state && (e._storedError = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._resolve(), e._pendingAbortRequest = void 0)), e._state = "closed";
                var t = e._writer;
                void 0 !== t && $9159c2fc84b5e85b$var$ir(t);
            }(t), null;
        }, function(e) {
            return function(e, t) {
                e._inFlightCloseRequest._reject(t), e._inFlightCloseRequest = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._reject(t), e._pendingAbortRequest = void 0), $9159c2fc84b5e85b$var$Bt(e, t);
            }(t, e), null;
        });
    }(e) : function(e, t) {
        var r = e._controlledWritableStream;
        !function(e) {
            e._inFlightWriteRequest = e._writeRequests.shift();
        }(r);
        var _$o = e._writeAlgorithm(t);
        $9159c2fc84b5e85b$var$h(_$o, function() {
            !function(e) {
                e._inFlightWriteRequest._resolve(void 0), e._inFlightWriteRequest = void 0;
            }(r);
            var _$t = r._state;
            if ($9159c2fc84b5e85b$var$Pe(e), !$9159c2fc84b5e85b$var$At(r) && "writable" === _$t) {
                var _$t1 = $9159c2fc84b5e85b$var$Xt(e);
                $9159c2fc84b5e85b$var$Dt(r, _$t1);
            }
            return $9159c2fc84b5e85b$var$Ut(e), null;
        }, function(t) {
            return "writable" === r._state && $9159c2fc84b5e85b$var$Ht(e), function(e, t) {
                e._inFlightWriteRequest._reject(t), e._inFlightWriteRequest = void 0, $9159c2fc84b5e85b$var$Bt(e, t);
            }(r, t), null;
        });
    }(e, r);
}
function $9159c2fc84b5e85b$var$Gt(e, t) {
    "writable" === e._controlledWritableStream._state && $9159c2fc84b5e85b$var$Jt(e, t);
}
function $9159c2fc84b5e85b$var$Xt(e) {
    return $9159c2fc84b5e85b$var$Vt(e) <= 0;
}
function $9159c2fc84b5e85b$var$Jt(e, t) {
    var r = e._controlledWritableStream;
    $9159c2fc84b5e85b$var$Ht(e), $9159c2fc84b5e85b$var$jt(r, t);
}
function $9159c2fc84b5e85b$var$Kt(e) {
    return new TypeError("WritableStream.prototype.".concat(e, " can only be used on a WritableStream"));
}
function $9159c2fc84b5e85b$var$Zt(e) {
    return new TypeError("WritableStreamDefaultController.prototype.".concat(e, " can only be used on a WritableStreamDefaultController"));
}
function $9159c2fc84b5e85b$var$er(e) {
    return new TypeError("WritableStreamDefaultWriter.prototype.".concat(e, " can only be used on a WritableStreamDefaultWriter"));
}
function $9159c2fc84b5e85b$var$tr(e) {
    return new TypeError("Cannot " + e + " a stream using a released writer");
}
function $9159c2fc84b5e85b$var$rr(e) {
    e._closedPromise = $9159c2fc84b5e85b$var$u(function(t, r) {
        e._closedPromise_resolve = t, e._closedPromise_reject = r, e._closedPromiseState = "pending";
    });
}
function $9159c2fc84b5e85b$var$or(e, t) {
    $9159c2fc84b5e85b$var$rr(e), $9159c2fc84b5e85b$var$nr(e, t);
}
function $9159c2fc84b5e85b$var$nr(e, t) {
    void 0 !== e._closedPromise_reject && ($9159c2fc84b5e85b$var$p(e._closedPromise), e._closedPromise_reject(t), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "rejected");
}
function $9159c2fc84b5e85b$var$ir(e) {
    void 0 !== e._closedPromise_resolve && (e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "resolved");
}
function $9159c2fc84b5e85b$var$ar(e) {
    e._readyPromise = $9159c2fc84b5e85b$var$u(function(t, r) {
        e._readyPromise_resolve = t, e._readyPromise_reject = r;
    }), e._readyPromiseState = "pending";
}
function $9159c2fc84b5e85b$var$sr(e, t) {
    $9159c2fc84b5e85b$var$ar(e), $9159c2fc84b5e85b$var$ur(e, t);
}
function $9159c2fc84b5e85b$var$lr(e) {
    $9159c2fc84b5e85b$var$ar(e), $9159c2fc84b5e85b$var$cr(e);
}
function $9159c2fc84b5e85b$var$ur(e, t) {
    void 0 !== e._readyPromise_reject && ($9159c2fc84b5e85b$var$p(e._readyPromise), e._readyPromise_reject(t), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "rejected");
}
function $9159c2fc84b5e85b$var$cr(e) {
    void 0 !== e._readyPromise_resolve && (e._readyPromise_resolve(void 0), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "fulfilled");
}
Object.defineProperties($9159c2fc84b5e85b$export$9e6890cb9a51c7c2.prototype, {
    abortReason: {
        enumerable: !0
    },
    signal: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    }
}), "symbol" == (0, $7E0eS._)(Symbol.toStringTag) && Object.defineProperty($9159c2fc84b5e85b$export$9e6890cb9a51c7c2.prototype, Symbol.toStringTag, {
    value: "WritableStreamDefaultController",
    configurable: !0
});
var $9159c2fc84b5e85b$var$dr = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof $parcel$global ? $parcel$global : void 0;
var $9159c2fc84b5e85b$var$fr = function() {
    var _$e = null == $9159c2fc84b5e85b$var$dr ? void 0 : $9159c2fc84b5e85b$var$dr.DOMException;
    return function(e) {
        if ("function" != typeof e && "object" != (typeof e === "undefined" ? "undefined" : (0, $7E0eS._)(e))) return !1;
        if ("DOMException" !== e.name) return !1;
        try {
            return new e, !0;
        } catch (e) {
            return !1;
        }
    }(_$e) ? _$e : void 0;
}() || function() {
    var _$e = function e(_e1, t) {
        this.message = _e1 || "", this.name = t || "Error", Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
    };
    return $9159c2fc84b5e85b$var$o(_$e, "DOMException"), _$e.prototype = Object.create(Error.prototype), Object.defineProperty(_$e.prototype, "constructor", {
        value: _$e,
        writable: !0,
        configurable: !0
    }), _$e;
}();
function $9159c2fc84b5e85b$var$hr(e, t, r, o, n, i) {
    var a = $9159c2fc84b5e85b$var$V(e), s = $9159c2fc84b5e85b$var$Pt(t);
    e._disturbed = !0;
    var l = new $9159c2fc84b5e85b$var$br(s), _ = new $9159c2fc84b5e85b$var$mr(l);
    return $9159c2fc84b5e85b$var$u(function(m, y) {
        var S;
        if (void 0 !== i) {
            if (S = function() {
                var r = void 0 !== i.reason ? i.reason : new $9159c2fc84b5e85b$var$fr("Aborted", "AbortError"), a = [];
                o || a.push(function() {
                    return "writable" === t._state ? $9159c2fc84b5e85b$var$Wt(t, r) : $9159c2fc84b5e85b$var$c(void 0);
                }), n || a.push(function() {
                    return "readable" === e._state ? $9159c2fc84b5e85b$var$Mr(e, r) : $9159c2fc84b5e85b$var$c(void 0);
                }), T(function() {
                    return Promise.all(a.map(function(e) {
                        return e();
                    }));
                }, !0, r);
            }, i.aborted) return void S();
            i.addEventListener("abort", S);
        }
        function g() {
            for(; !l._shuttingDown && !t._backpressure && "writable" === t._state && !$9159c2fc84b5e85b$var$At(t) && "readable" === e._state && $9159c2fc84b5e85b$var$re(a);)$9159c2fc84b5e85b$var$te(a, _);
            if (l._shuttingDown) return $9159c2fc84b5e85b$var$c(!0);
            if (t._backpressure) return $9159c2fc84b5e85b$var$f(s._readyPromise, g);
            var r = new $9159c2fc84b5e85b$var$_r(l);
            return $9159c2fc84b5e85b$var$te(a, r), r._promise;
        }
        var v, w, R;
        if ($9159c2fc84b5e85b$var$pr(e, a._closedPromise, function(e) {
            return o ? P(!0, e) : T(function() {
                return $9159c2fc84b5e85b$var$Wt(t, e);
            }, !0, e), null;
        }), $9159c2fc84b5e85b$var$pr(t, s._closedPromise, function(t) {
            return n ? P(!0, t) : T(function() {
                return $9159c2fc84b5e85b$var$Mr(e, t);
            }, !0, t), null;
        }), v = e, w = a._closedPromise, R = function() {
            return r ? P() : T(function() {
                return function(e) {
                    var _$t = e._ownerWritableStream, _$r = _$t._state;
                    return $9159c2fc84b5e85b$var$At(_$t) || "closed" === _$r ? $9159c2fc84b5e85b$var$c(void 0) : "errored" === _$r ? $9159c2fc84b5e85b$var$d(_$t._storedError) : $9159c2fc84b5e85b$var$Lt(e);
                }(s);
            }), null;
        }, "closed" === v._state ? R() : $9159c2fc84b5e85b$var$b(w, R), $9159c2fc84b5e85b$var$At(t) || "closed" === t._state) {
            var _$t = new TypeError("the destination writable stream closed before all data could be piped to it");
            n ? P(!0, _$t) : T(function() {
                return $9159c2fc84b5e85b$var$Mr(e, _$t);
            }, !0, _$t);
        }
        function T(e, r, o) {
            function n() {
                return $9159c2fc84b5e85b$var$h(e(), function() {
                    return C(r, o);
                }, function(e) {
                    return C(!0, e);
                }), null;
            }
            l._shuttingDown || (l._shuttingDown = !0, "writable" !== t._state || $9159c2fc84b5e85b$var$At(t) ? n() : $9159c2fc84b5e85b$var$b(l._waitForWritesToFinish(), n));
        }
        function P(e, r) {
            l._shuttingDown || (l._shuttingDown = !0, "writable" !== t._state || $9159c2fc84b5e85b$var$At(t) ? C(e, r) : $9159c2fc84b5e85b$var$b(l._waitForWritesToFinish(), function() {
                return C(e, r);
            }));
        }
        function C(e, t) {
            return $9159c2fc84b5e85b$var$Mt(s), $9159c2fc84b5e85b$var$O(a), void 0 !== i && i.removeEventListener("abort", S), e ? y(t) : m(void 0), null;
        }
        $9159c2fc84b5e85b$var$p($9159c2fc84b5e85b$var$u(function(e, t) {
            !function r(o) {
                o ? e() : $9159c2fc84b5e85b$var$f(g(), r, t);
            }(!1);
        }));
    });
}
var $9159c2fc84b5e85b$var$br = /*#__PURE__*/ function() {
    "use strict";
    function br(e) {
        (0, $173N4._)(this, br);
        this._writer = e, this._shuttingDown = !1, this._currentWrite = $9159c2fc84b5e85b$var$c(void 0);
    }
    (0, $cFHGC._)(br, [
        {
            key: "_waitForWritesToFinish",
            value: function _waitForWritesToFinish() {
                var _this = this;
                var _$e = this._currentWrite;
                return $9159c2fc84b5e85b$var$f(this._currentWrite, function() {
                    return _$e !== _this._currentWrite ? _this._waitForWritesToFinish() : void 0;
                });
            }
        }
    ]);
    return br;
}();
var $9159c2fc84b5e85b$var$_r = /*#__PURE__*/ function() {
    "use strict";
    function _r(e) {
        var _this = this;
        (0, $173N4._)(this, _r);
        this._state = e, this._promise = $9159c2fc84b5e85b$var$u(function(e, t) {
            _this._resolvePromise = e, _this._rejectPromise = t;
        });
    }
    (0, $cFHGC._)(_r, [
        {
            key: "_chunkSteps",
            value: function _chunkSteps(t) {
                this._state._currentWrite = $9159c2fc84b5e85b$var$f($9159c2fc84b5e85b$var$Yt(this._state._writer, t), void 0, $9159c2fc84b5e85b$var$e), this._resolvePromise(!1);
            }
        },
        {
            key: "_closeSteps",
            value: function _closeSteps() {
                this._resolvePromise(!0);
            }
        },
        {
            key: "_errorSteps",
            value: function _errorSteps(e) {
                this._rejectPromise(e);
            }
        }
    ]);
    return _r;
}();
var $9159c2fc84b5e85b$var$mr = /*#__PURE__*/ function() {
    "use strict";
    function mr(e) {
        (0, $173N4._)(this, mr);
        this._state = e;
    }
    (0, $cFHGC._)(mr, [
        {
            key: "_chunkSteps",
            value: function _chunkSteps(t) {
                this._state._currentWrite = $9159c2fc84b5e85b$var$f($9159c2fc84b5e85b$var$Yt(this._state._writer, t), void 0, $9159c2fc84b5e85b$var$e);
            }
        },
        {
            key: "_closeSteps",
            value: function _closeSteps() {}
        },
        {
            key: "_errorSteps",
            value: function _errorSteps(e) {}
        }
    ]);
    return mr;
}();
function $9159c2fc84b5e85b$var$pr(e, t, r) {
    "errored" === e._state ? r(e._storedError) : $9159c2fc84b5e85b$var$_(t, r);
}
var $9159c2fc84b5e85b$export$b0bb6d0989d67700 = /*#__PURE__*/ function() {
    "use strict";
    function ReadableStreamDefaultController() {
        (0, $173N4._)(this, ReadableStreamDefaultController);
        throw new TypeError("Illegal constructor");
    }
    (0, $cFHGC._)(ReadableStreamDefaultController, [
        {
            key: "desiredSize",
            get: function get() {
                if (!$9159c2fc84b5e85b$var$yr(this)) throw $9159c2fc84b5e85b$var$Er("desiredSize");
                return $9159c2fc84b5e85b$var$Pr(this);
            }
        },
        {
            key: "close",
            value: function close() {
                if (!$9159c2fc84b5e85b$var$yr(this)) throw $9159c2fc84b5e85b$var$Er("close");
                if (!$9159c2fc84b5e85b$var$Cr(this)) throw new TypeError("The stream is not in a state that permits close");
                $9159c2fc84b5e85b$var$wr(this);
            }
        },
        {
            key: "enqueue",
            value: function enqueue(e) {
                if (!$9159c2fc84b5e85b$var$yr(this)) throw $9159c2fc84b5e85b$var$Er("enqueue");
                if (!$9159c2fc84b5e85b$var$Cr(this)) throw new TypeError("The stream is not in a state that permits enqueue");
                return $9159c2fc84b5e85b$var$Rr(this, e);
            }
        },
        {
            key: "error",
            value: function error(e) {
                if (!$9159c2fc84b5e85b$var$yr(this)) throw $9159c2fc84b5e85b$var$Er("error");
                $9159c2fc84b5e85b$var$Tr(this, e);
            }
        },
        {
            key: $9159c2fc84b5e85b$var$T,
            value: function value(e) {
                $9159c2fc84b5e85b$var$qe(this);
                var t = this._cancelAlgorithm(e);
                return $9159c2fc84b5e85b$var$vr(this), t;
            }
        },
        {
            key: $9159c2fc84b5e85b$var$P,
            value: function value(e) {
                var t = this._controlledReadableStream;
                if (this._queue.length > 0) {
                    var r = $9159c2fc84b5e85b$var$Pe(this);
                    this._closeRequested && 0 === this._queue.length ? ($9159c2fc84b5e85b$var$vr(this), $9159c2fc84b5e85b$var$Yr(t)) : $9159c2fc84b5e85b$var$Sr(this), e._chunkSteps(r);
                } else $9159c2fc84b5e85b$var$U(t, e), $9159c2fc84b5e85b$var$Sr(this);
            }
        },
        {
            key: $9159c2fc84b5e85b$var$C,
            value: function value() {
                return this._queue.length > 0;
            }
        },
        {
            key: $9159c2fc84b5e85b$var$q,
            value: function value() {}
        }
    ]);
    return ReadableStreamDefaultController;
}();
function $9159c2fc84b5e85b$var$yr(e) {
    return !!$9159c2fc84b5e85b$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableStream") && e instanceof $9159c2fc84b5e85b$export$b0bb6d0989d67700;
}
function $9159c2fc84b5e85b$var$Sr(e) {
    if (!$9159c2fc84b5e85b$var$gr(e)) return;
    if (e._pulling) return void (e._pullAgain = !0);
    e._pulling = !0;
    $9159c2fc84b5e85b$var$h(e._pullAlgorithm(), function() {
        return e._pulling = !1, e._pullAgain && (e._pullAgain = !1, $9159c2fc84b5e85b$var$Sr(e)), null;
    }, function(t) {
        return $9159c2fc84b5e85b$var$Tr(e, t), null;
    });
}
function $9159c2fc84b5e85b$var$gr(e) {
    var t = e._controlledReadableStream;
    if (!$9159c2fc84b5e85b$var$Cr(e)) return !1;
    if (!e._started) return !1;
    if ($9159c2fc84b5e85b$var$$r(t) && $9159c2fc84b5e85b$var$X(t) > 0) return !0;
    return $9159c2fc84b5e85b$var$Pr(e) > 0;
}
function $9159c2fc84b5e85b$var$vr(e) {
    e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
}
function $9159c2fc84b5e85b$var$wr(e) {
    if (!$9159c2fc84b5e85b$var$Cr(e)) return;
    var t = e._controlledReadableStream;
    e._closeRequested = !0, 0 === e._queue.length && ($9159c2fc84b5e85b$var$vr(e), $9159c2fc84b5e85b$var$Yr(t));
}
function $9159c2fc84b5e85b$var$Rr(e, t) {
    if (!$9159c2fc84b5e85b$var$Cr(e)) return;
    var r = e._controlledReadableStream;
    if ($9159c2fc84b5e85b$var$$r(r) && $9159c2fc84b5e85b$var$X(r) > 0) $9159c2fc84b5e85b$var$G(r, t, !1);
    else {
        var r1;
        try {
            r1 = e._strategySizeAlgorithm(t);
        } catch (t) {
            throw $9159c2fc84b5e85b$var$Tr(e, t), t;
        }
        try {
            $9159c2fc84b5e85b$var$Ce(e, t, r1);
        } catch (t) {
            throw $9159c2fc84b5e85b$var$Tr(e, t), t;
        }
    }
    $9159c2fc84b5e85b$var$Sr(e);
}
function $9159c2fc84b5e85b$var$Tr(e, t) {
    var r = e._controlledReadableStream;
    "readable" === r._state && ($9159c2fc84b5e85b$var$qe(e), $9159c2fc84b5e85b$var$vr(e), $9159c2fc84b5e85b$var$xr(r, t));
}
function $9159c2fc84b5e85b$var$Pr(e) {
    var t = e._controlledReadableStream._state;
    return "errored" === t ? null : "closed" === t ? 0 : e._strategyHWM - e._queueTotalSize;
}
function $9159c2fc84b5e85b$var$Cr(e) {
    var t = e._controlledReadableStream._state;
    return !e._closeRequested && "readable" === t;
}
function $9159c2fc84b5e85b$var$qr(e, t, r, o, n, i, a) {
    t._controlledReadableStream = e, t._queue = void 0, t._queueTotalSize = void 0, $9159c2fc84b5e85b$var$qe(t), t._started = !1, t._closeRequested = !1, t._pullAgain = !1, t._pulling = !1, t._strategySizeAlgorithm = a, t._strategyHWM = i, t._pullAlgorithm = o, t._cancelAlgorithm = n, e._readableStreamController = t;
    $9159c2fc84b5e85b$var$h($9159c2fc84b5e85b$var$c(r()), function() {
        return t._started = !0, $9159c2fc84b5e85b$var$Sr(t), null;
    }, function(e) {
        return $9159c2fc84b5e85b$var$Tr(t, e), null;
    });
}
function $9159c2fc84b5e85b$var$Er(e) {
    return new TypeError("ReadableStreamDefaultController.prototype.".concat(e, " can only be used on a ReadableStreamDefaultController"));
}
function $9159c2fc84b5e85b$var$Wr(e, t) {
    return $9159c2fc84b5e85b$var$Oe(e._readableStreamController) ? function(e) {
        var t, r, _$o, n, i, a = $9159c2fc84b5e85b$var$V(e), s = !1, l = !1, d = !1, f = !1, h = !1;
        var b = $9159c2fc84b5e85b$var$u(function(e) {
            i = e;
        });
        function m(e) {
            $9159c2fc84b5e85b$var$_(e._closedPromise, function(t) {
                return e !== a || ($9159c2fc84b5e85b$var$Xe(_$o._readableStreamController, t), $9159c2fc84b5e85b$var$Xe(n._readableStreamController, t), f && h || i(void 0)), null;
            });
        }
        function p() {
            $9159c2fc84b5e85b$var$ft(a) && ($9159c2fc84b5e85b$var$O(a), a = $9159c2fc84b5e85b$var$V(e), m(a));
            $9159c2fc84b5e85b$var$te(a, {
                _chunkSteps: function(t) {
                    $9159c2fc84b5e85b$var$y(function() {
                        l = !1, d = !1;
                        var r = t;
                        var a = t;
                        if (!f && !h) try {
                            a = $9159c2fc84b5e85b$var$Te(t);
                        } catch (t) {
                            return $9159c2fc84b5e85b$var$Xe(_$o._readableStreamController, t), $9159c2fc84b5e85b$var$Xe(n._readableStreamController, t), void i($9159c2fc84b5e85b$var$Mr(e, t));
                        }
                        f || $9159c2fc84b5e85b$var$Ge(_$o._readableStreamController, r), h || $9159c2fc84b5e85b$var$Ge(n._readableStreamController, a), s = !1, l ? g() : d && v();
                    });
                },
                _closeSteps: function() {
                    s = !1, f || $9159c2fc84b5e85b$var$Ue(_$o._readableStreamController), h || $9159c2fc84b5e85b$var$Ue(n._readableStreamController), _$o._readableStreamController._pendingPullIntos.length > 0 && $9159c2fc84b5e85b$var$et(_$o._readableStreamController, 0), n._readableStreamController._pendingPullIntos.length > 0 && $9159c2fc84b5e85b$var$et(n._readableStreamController, 0), f && h || i(void 0);
                },
                _errorSteps: function() {
                    s = !1;
                }
            });
        }
        function S(t, r) {
            $9159c2fc84b5e85b$var$ee(a) && ($9159c2fc84b5e85b$var$O(a), a = $9159c2fc84b5e85b$var$at(e), m(a));
            var _$u = r ? n : _$o, c = r ? _$o : n;
            $9159c2fc84b5e85b$var$ht(a, t, 1, {
                _chunkSteps: function(t) {
                    $9159c2fc84b5e85b$var$y(function() {
                        l = !1, d = !1;
                        var _$o = r ? h : f;
                        if (r ? f : h) _$o || $9159c2fc84b5e85b$var$tt(_$u._readableStreamController, t);
                        else {
                            var _$r;
                            try {
                                _$r = $9159c2fc84b5e85b$var$Te(t);
                            } catch (t) {
                                return $9159c2fc84b5e85b$var$Xe(_$u._readableStreamController, t), $9159c2fc84b5e85b$var$Xe(c._readableStreamController, t), void i($9159c2fc84b5e85b$var$Mr(e, t));
                            }
                            _$o || $9159c2fc84b5e85b$var$tt(_$u._readableStreamController, t), $9159c2fc84b5e85b$var$Ge(c._readableStreamController, _$r);
                        }
                        s = !1, l ? g() : d && v();
                    });
                },
                _closeSteps: function(e) {
                    s = !1;
                    var _$t = r ? h : f, _$o = r ? f : h;
                    _$t || $9159c2fc84b5e85b$var$Ue(_$u._readableStreamController), _$o || $9159c2fc84b5e85b$var$Ue(c._readableStreamController), void 0 !== e && (_$t || $9159c2fc84b5e85b$var$tt(_$u._readableStreamController, e), !_$o && c._readableStreamController._pendingPullIntos.length > 0 && $9159c2fc84b5e85b$var$et(c._readableStreamController, 0)), _$t && _$o || i(void 0);
                },
                _errorSteps: function() {
                    s = !1;
                }
            });
        }
        function g() {
            if (s) return l = !0, $9159c2fc84b5e85b$var$c(void 0);
            s = !0;
            var _$e = $9159c2fc84b5e85b$var$Ke(_$o._readableStreamController);
            return null === _$e ? p() : S(_$e._view, !1), $9159c2fc84b5e85b$var$c(void 0);
        }
        function v() {
            if (s) return d = !0, $9159c2fc84b5e85b$var$c(void 0);
            s = !0;
            var _$e = $9159c2fc84b5e85b$var$Ke(n._readableStreamController);
            return null === _$e ? p() : S(_$e._view, !0), $9159c2fc84b5e85b$var$c(void 0);
        }
        function w(o) {
            if (f = !0, t = o, h) {
                var _$o = $9159c2fc84b5e85b$var$le([
                    t,
                    r
                ]), n = $9159c2fc84b5e85b$var$Mr(e, _$o);
                i(n);
            }
            return b;
        }
        function R(o) {
            if (h = !0, r = o, f) {
                var _$o = $9159c2fc84b5e85b$var$le([
                    t,
                    r
                ]), n = $9159c2fc84b5e85b$var$Mr(e, _$o);
                i(n);
            }
            return b;
        }
        function T() {}
        return _$o = $9159c2fc84b5e85b$var$Fr(T, g, w), n = $9159c2fc84b5e85b$var$Fr(T, v, R), m(a), [
            _$o,
            n
        ];
    }(e) : function(e) {
        var t = $9159c2fc84b5e85b$var$V(e);
        var r, _$o, n, i, a, s = !1, l = !1, d = !1, f = !1;
        var h = $9159c2fc84b5e85b$var$u(function(e) {
            a = e;
        });
        function b() {
            if (s) return l = !0, $9159c2fc84b5e85b$var$c(void 0);
            s = !0;
            return $9159c2fc84b5e85b$var$te(t, {
                _chunkSteps: function(e) {
                    $9159c2fc84b5e85b$var$y(function() {
                        l = !1;
                        var t = e, r = e;
                        d || $9159c2fc84b5e85b$var$Rr(n._readableStreamController, t), f || $9159c2fc84b5e85b$var$Rr(i._readableStreamController, r), s = !1, l && b();
                    });
                },
                _closeSteps: function() {
                    s = !1, d || $9159c2fc84b5e85b$var$wr(n._readableStreamController), f || $9159c2fc84b5e85b$var$wr(i._readableStreamController), d && f || a(void 0);
                },
                _errorSteps: function() {
                    s = !1;
                }
            }), $9159c2fc84b5e85b$var$c(void 0);
        }
        function m(t) {
            if (d = !0, r = t, f) {
                var _$t = $9159c2fc84b5e85b$var$le([
                    r,
                    _$o
                ]), n = $9159c2fc84b5e85b$var$Mr(e, _$t);
                a(n);
            }
            return h;
        }
        function p(t) {
            if (f = !0, _$o = t, d) {
                var _$t = $9159c2fc84b5e85b$var$le([
                    r,
                    _$o
                ]), n = $9159c2fc84b5e85b$var$Mr(e, _$t);
                a(n);
            }
            return h;
        }
        function S() {}
        return n = $9159c2fc84b5e85b$var$Dr(S, b, m), i = $9159c2fc84b5e85b$var$Dr(S, b, p), $9159c2fc84b5e85b$var$_(t._closedPromise, function(e) {
            return $9159c2fc84b5e85b$var$Tr(n._readableStreamController, e), $9159c2fc84b5e85b$var$Tr(i._readableStreamController, e), d && f || a(void 0), null;
        }), [
            n,
            i
        ];
    }(e);
}
function $9159c2fc84b5e85b$var$Or(r) {
    var _$o;
    return $9159c2fc84b5e85b$var$t(_$o = r) && void 0 !== _$o.getReader ? function(r) {
        var _$o;
        function n() {
            var _$e;
            try {
                _$e = r.read();
            } catch (e) {
                return $9159c2fc84b5e85b$var$d(e);
            }
            return $9159c2fc84b5e85b$var$m(_$e, function(e) {
                if (!$9159c2fc84b5e85b$var$t(e)) throw new TypeError("The promise returned by the reader.read() method must fulfill with an object");
                if (e.done) $9159c2fc84b5e85b$var$wr(_$o._readableStreamController);
                else {
                    var _$t = e.value;
                    $9159c2fc84b5e85b$var$Rr(_$o._readableStreamController, _$t);
                }
            });
        }
        function i(e) {
            try {
                return $9159c2fc84b5e85b$var$c(r.cancel(e));
            } catch (e) {
                return $9159c2fc84b5e85b$var$d(e);
            }
        }
        return _$o = $9159c2fc84b5e85b$var$Dr($9159c2fc84b5e85b$var$e, n, i, 0), _$o;
    }(r.getReader()) : function(r) {
        var _$o;
        var n = $9159c2fc84b5e85b$var$me(r, "async");
        function i() {
            var _$e;
            try {
                _$e = $9159c2fc84b5e85b$var$pe(n);
            } catch (e) {
                return $9159c2fc84b5e85b$var$d(e);
            }
            return $9159c2fc84b5e85b$var$m($9159c2fc84b5e85b$var$c(_$e), function(e) {
                if (!$9159c2fc84b5e85b$var$t(e)) throw new TypeError("The promise returned by the iterator.next() method must fulfill with an object");
                if (e.done) $9159c2fc84b5e85b$var$wr(_$o._readableStreamController);
                else {
                    var _$t = e.value;
                    $9159c2fc84b5e85b$var$Rr(_$o._readableStreamController, _$t);
                }
            });
        }
        function a(e) {
            var _$r = n.iterator;
            var _$o;
            try {
                _$o = $9159c2fc84b5e85b$var$he(_$r, "return");
            } catch (e) {
                return $9159c2fc84b5e85b$var$d(e);
            }
            if (void 0 === _$o) return $9159c2fc84b5e85b$var$c(void 0);
            return $9159c2fc84b5e85b$var$m($9159c2fc84b5e85b$var$g(_$o, _$r, [
                e
            ]), function(e) {
                if (!$9159c2fc84b5e85b$var$t(e)) throw new TypeError("The promise returned by the iterator.return() method must fulfill with an object");
            });
        }
        return _$o = $9159c2fc84b5e85b$var$Dr($9159c2fc84b5e85b$var$e, i, a, 0), _$o;
    }(r);
}
function $9159c2fc84b5e85b$var$Br(e, t, r) {
    return $9159c2fc84b5e85b$var$I(e, r), function(r) {
        return $9159c2fc84b5e85b$var$g(e, t, [
            r
        ]);
    };
}
function $9159c2fc84b5e85b$var$jr(e, t, r) {
    return $9159c2fc84b5e85b$var$I(e, r), function(r) {
        return $9159c2fc84b5e85b$var$g(e, t, [
            r
        ]);
    };
}
function $9159c2fc84b5e85b$var$kr(e, t, r) {
    return $9159c2fc84b5e85b$var$I(e, r), function(r) {
        return $9159c2fc84b5e85b$var$S(e, t, [
            r
        ]);
    };
}
function $9159c2fc84b5e85b$var$Ar(e, t) {
    if ("bytes" !== (e = "".concat(e))) throw new TypeError("".concat(t, " '").concat(e, "' is not a valid enumeration value for ReadableStreamType"));
    return e;
}
function $9159c2fc84b5e85b$var$zr(e, t) {
    $9159c2fc84b5e85b$var$L(e, t);
    var r = null == e ? void 0 : e.preventAbort, _$o = null == e ? void 0 : e.preventCancel, n = null == e ? void 0 : e.preventClose, i = null == e ? void 0 : e.signal;
    return void 0 !== i && function(e, t) {
        if (!function(e) {
            if ("object" != (typeof e === "undefined" ? "undefined" : (0, $7E0eS._)(e)) || null === e) return !1;
            try {
                return "boolean" == typeof e.aborted;
            } catch (e) {
                return !1;
            }
        }(e)) throw new TypeError("".concat(t, " is not an AbortSignal."));
    }(i, "".concat(t, " has member 'signal' that")), {
        preventAbort: Boolean(r),
        preventCancel: Boolean(_$o),
        preventClose: Boolean(n),
        signal: i
    };
}
Object.defineProperties($9159c2fc84b5e85b$export$b0bb6d0989d67700.prototype, {
    close: {
        enumerable: !0
    },
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$b0bb6d0989d67700.prototype.close, "close"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$b0bb6d0989d67700.prototype.enqueue, "enqueue"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$b0bb6d0989d67700.prototype.error, "error"), "symbol" == (0, $7E0eS._)(Symbol.toStringTag) && Object.defineProperty($9159c2fc84b5e85b$export$b0bb6d0989d67700.prototype, Symbol.toStringTag, {
    value: "ReadableStreamDefaultController",
    configurable: !0
});
var $9159c2fc84b5e85b$export$5d3e1e5268af5f76 = /*#__PURE__*/ function() {
    "use strict";
    function ReadableStream() {
        var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $173N4._)(this, ReadableStream);
        void 0 === _$e ? _$e = null : $9159c2fc84b5e85b$var$$(_$e, "First parameter");
        var r = $9159c2fc84b5e85b$var$yt(t, "Second parameter"), _$o = function(e, t) {
            $9159c2fc84b5e85b$var$L(e, t);
            var r = e, _$o = null == r ? void 0 : r.autoAllocateChunkSize, n = null == r ? void 0 : r.cancel, i = null == r ? void 0 : r.pull, a = null == r ? void 0 : r.start, s = null == r ? void 0 : r.type;
            return {
                autoAllocateChunkSize: void 0 === _$o ? void 0 : $9159c2fc84b5e85b$var$N(_$o, "".concat(t, " has member 'autoAllocateChunkSize' that")),
                cancel: void 0 === n ? void 0 : $9159c2fc84b5e85b$var$Br(n, r, "".concat(t, " has member 'cancel' that")),
                pull: void 0 === i ? void 0 : $9159c2fc84b5e85b$var$jr(i, r, "".concat(t, " has member 'pull' that")),
                start: void 0 === a ? void 0 : $9159c2fc84b5e85b$var$kr(a, r, "".concat(t, " has member 'start' that")),
                type: void 0 === s ? void 0 : $9159c2fc84b5e85b$var$Ar(s, "".concat(t, " has member 'type' that"))
            };
        }(_$e, "First parameter");
        if ($9159c2fc84b5e85b$var$Lr(this), "bytes" === _$o.type) {
            if (void 0 !== r.size) throw new RangeError("The strategy for a byte stream cannot have a size function");
            !function(e, t, r) {
                var _$o = Object.create($9159c2fc84b5e85b$export$2047cf34091e94ac.prototype);
                var n, i, a;
                n = void 0 !== t.start ? function() {
                    return t.start(_$o);
                } : function() {}, i = void 0 !== t.pull ? function() {
                    return t.pull(_$o);
                } : function() {
                    return $9159c2fc84b5e85b$var$c(void 0);
                }, a = void 0 !== t.cancel ? function(e) {
                    return t.cancel(e);
                } : function() {
                    return $9159c2fc84b5e85b$var$c(void 0);
                };
                var s = t.autoAllocateChunkSize;
                if (0 === s) throw new TypeError("autoAllocateChunkSize must be greater than 0");
                $9159c2fc84b5e85b$var$rt(e, _$o, n, i, a, r, s);
            }(this, _$o, $9159c2fc84b5e85b$var$mt(r, 0));
        } else {
            var _$e1 = $9159c2fc84b5e85b$var$pt(r);
            !function(e, t, r, o) {
                var n = Object.create($9159c2fc84b5e85b$export$b0bb6d0989d67700.prototype);
                var i, a, s;
                i = void 0 !== t.start ? function() {
                    return t.start(n);
                } : function() {}, a = void 0 !== t.pull ? function() {
                    return t.pull(n);
                } : function() {
                    return $9159c2fc84b5e85b$var$c(void 0);
                }, s = void 0 !== t.cancel ? function(e) {
                    return t.cancel(e);
                } : function() {
                    return $9159c2fc84b5e85b$var$c(void 0);
                }, $9159c2fc84b5e85b$var$qr(e, n, i, a, s, r, o);
            }(this, _$o, $9159c2fc84b5e85b$var$mt(r, 1), _$e1);
        }
    }
    (0, $cFHGC._)(ReadableStream, [
        {
            key: "locked",
            get: function get() {
                if (!$9159c2fc84b5e85b$var$Ir(this)) throw $9159c2fc84b5e85b$var$Qr("locked");
                return $9159c2fc84b5e85b$var$$r(this);
            }
        },
        {
            key: "cancel",
            value: function cancel(e) {
                return $9159c2fc84b5e85b$var$Ir(this) ? $9159c2fc84b5e85b$var$$r(this) ? $9159c2fc84b5e85b$var$d(new TypeError("Cannot cancel a stream that already has a reader")) : $9159c2fc84b5e85b$var$Mr(this, e) : $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$Qr("cancel"));
            }
        },
        {
            key: "getReader",
            value: function getReader(e) {
                if (!$9159c2fc84b5e85b$var$Ir(this)) throw $9159c2fc84b5e85b$var$Qr("getReader");
                return void 0 === function(e, t) {
                    $9159c2fc84b5e85b$var$L(e, t);
                    var r = null == e ? void 0 : e.mode;
                    return {
                        mode: void 0 === r ? void 0 : $9159c2fc84b5e85b$var$it(r, "".concat(t, " has member 'mode' that"))
                    };
                }(e, "First parameter").mode ? $9159c2fc84b5e85b$var$V(this) : $9159c2fc84b5e85b$var$at(this);
            }
        },
        {
            key: "pipeThrough",
            value: function pipeThrough(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (!$9159c2fc84b5e85b$var$Ir(this)) throw $9159c2fc84b5e85b$var$Qr("pipeThrough");
                $9159c2fc84b5e85b$var$M(e, 1, "pipeThrough");
                var r = function(e, t) {
                    $9159c2fc84b5e85b$var$L(e, t);
                    var r = null == e ? void 0 : e.readable;
                    $9159c2fc84b5e85b$var$Y(r, "readable", "ReadableWritablePair"), $9159c2fc84b5e85b$var$H(r, "".concat(t, " has member 'readable' that"));
                    var _$o = null == e ? void 0 : e.writable;
                    return $9159c2fc84b5e85b$var$Y(_$o, "writable", "ReadableWritablePair"), $9159c2fc84b5e85b$var$Tt(_$o, "".concat(t, " has member 'writable' that")), {
                        readable: r,
                        writable: _$o
                    };
                }(e, "First parameter"), _$o = $9159c2fc84b5e85b$var$zr(t, "Second parameter");
                if ($9159c2fc84b5e85b$var$$r(this)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked ReadableStream");
                if ($9159c2fc84b5e85b$var$Et(r.writable)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked WritableStream");
                return $9159c2fc84b5e85b$var$p($9159c2fc84b5e85b$var$hr(this, r.writable, _$o.preventClose, _$o.preventAbort, _$o.preventCancel, _$o.signal)), r.readable;
            }
        },
        {
            key: "pipeTo",
            value: function pipeTo(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (!$9159c2fc84b5e85b$var$Ir(this)) return $9159c2fc84b5e85b$var$d($9159c2fc84b5e85b$var$Qr("pipeTo"));
                if (void 0 === e) return $9159c2fc84b5e85b$var$d("Parameter 1 is required in 'pipeTo'.");
                if (!$9159c2fc84b5e85b$var$qt(e)) return $9159c2fc84b5e85b$var$d(new TypeError("ReadableStream.prototype.pipeTo's first argument must be a WritableStream"));
                var r;
                try {
                    r = $9159c2fc84b5e85b$var$zr(t, "Second parameter");
                } catch (e) {
                    return $9159c2fc84b5e85b$var$d(e);
                }
                return $9159c2fc84b5e85b$var$$r(this) ? $9159c2fc84b5e85b$var$d(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream")) : $9159c2fc84b5e85b$var$Et(e) ? $9159c2fc84b5e85b$var$d(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream")) : $9159c2fc84b5e85b$var$hr(this, e, r.preventClose, r.preventAbort, r.preventCancel, r.signal);
            }
        },
        {
            key: "tee",
            value: function tee() {
                if (!$9159c2fc84b5e85b$var$Ir(this)) throw $9159c2fc84b5e85b$var$Qr("tee");
                return $9159c2fc84b5e85b$var$le($9159c2fc84b5e85b$var$Wr(this));
            }
        },
        {
            key: "values",
            value: function values(e) {
                if (!$9159c2fc84b5e85b$var$Ir(this)) throw $9159c2fc84b5e85b$var$Qr("values");
                return function(e, t) {
                    var r = $9159c2fc84b5e85b$var$V(e), _$o = new $9159c2fc84b5e85b$var$ye(r, t), n = Object.create($9159c2fc84b5e85b$var$ge);
                    return n._asyncIteratorImpl = _$o, n;
                }(this, function(e, t) {
                    $9159c2fc84b5e85b$var$L(e, t);
                    var r = null == e ? void 0 : e.preventCancel;
                    return {
                        preventCancel: Boolean(r)
                    };
                }(e, "First parameter").preventCancel);
            }
        },
        {
            key: $9159c2fc84b5e85b$var$_e,
            value: function value(e) {
                return this.values(e);
            }
        }
    ], [
        {
            key: "from",
            value: function from(e) {
                return $9159c2fc84b5e85b$var$Or(e);
            }
        }
    ]);
    return ReadableStream;
}();
function $9159c2fc84b5e85b$var$Dr(e, t, r) {
    var _$o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, n = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function() {
        return 1;
    };
    var i = Object.create($9159c2fc84b5e85b$export$5d3e1e5268af5f76.prototype);
    $9159c2fc84b5e85b$var$Lr(i);
    return $9159c2fc84b5e85b$var$qr(i, Object.create($9159c2fc84b5e85b$export$b0bb6d0989d67700.prototype), e, t, r, _$o, n), i;
}
function $9159c2fc84b5e85b$var$Fr(e, t, r) {
    var _$o = Object.create($9159c2fc84b5e85b$export$5d3e1e5268af5f76.prototype);
    $9159c2fc84b5e85b$var$Lr(_$o);
    return $9159c2fc84b5e85b$var$rt(_$o, Object.create($9159c2fc84b5e85b$export$2047cf34091e94ac.prototype), e, t, r, 0, void 0), _$o;
}
function $9159c2fc84b5e85b$var$Lr(e) {
    e._state = "readable", e._reader = void 0, e._storedError = void 0, e._disturbed = !1;
}
function $9159c2fc84b5e85b$var$Ir(e) {
    return !!$9159c2fc84b5e85b$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readableStreamController") && e instanceof $9159c2fc84b5e85b$export$5d3e1e5268af5f76;
}
function $9159c2fc84b5e85b$var$$r(e) {
    return void 0 !== e._reader;
}
function $9159c2fc84b5e85b$var$Mr(t, r) {
    if (t._disturbed = !0, "closed" === t._state) return $9159c2fc84b5e85b$var$c(void 0);
    if ("errored" === t._state) return $9159c2fc84b5e85b$var$d(t._storedError);
    $9159c2fc84b5e85b$var$Yr(t);
    var _$o = t._reader;
    if (void 0 !== _$o && $9159c2fc84b5e85b$var$ft(_$o)) {
        var _$e = _$o._readIntoRequests;
        _$o._readIntoRequests = new $9159c2fc84b5e85b$var$v, _$e.forEach(function(e) {
            e._closeSteps(void 0);
        });
    }
    return $9159c2fc84b5e85b$var$m(t._readableStreamController[$9159c2fc84b5e85b$var$T](r), $9159c2fc84b5e85b$var$e);
}
function $9159c2fc84b5e85b$var$Yr(e) {
    e._state = "closed";
    var t = e._reader;
    if (void 0 !== t && ($9159c2fc84b5e85b$var$z(t), $9159c2fc84b5e85b$var$ee(t))) {
        var _$e = t._readRequests;
        t._readRequests = new $9159c2fc84b5e85b$var$v, _$e.forEach(function(e) {
            e._closeSteps();
        });
    }
}
function $9159c2fc84b5e85b$var$xr(e, t) {
    e._state = "errored", e._storedError = t;
    var r = e._reader;
    void 0 !== r && ($9159c2fc84b5e85b$var$A(r, t), $9159c2fc84b5e85b$var$ee(r) ? $9159c2fc84b5e85b$var$oe(r, t) : $9159c2fc84b5e85b$var$bt(r, t));
}
function $9159c2fc84b5e85b$var$Qr(e) {
    return new TypeError("ReadableStream.prototype.".concat(e, " can only be used on a ReadableStream"));
}
function $9159c2fc84b5e85b$var$Nr(e, t) {
    $9159c2fc84b5e85b$var$L(e, t);
    var r = null == e ? void 0 : e.highWaterMark;
    return $9159c2fc84b5e85b$var$Y(r, "highWaterMark", "QueuingStrategyInit"), {
        highWaterMark: $9159c2fc84b5e85b$var$x(r)
    };
}
Object.defineProperties($9159c2fc84b5e85b$export$5d3e1e5268af5f76, {
    from: {
        enumerable: !0
    }
}), Object.defineProperties($9159c2fc84b5e85b$export$5d3e1e5268af5f76.prototype, {
    cancel: {
        enumerable: !0
    },
    getReader: {
        enumerable: !0
    },
    pipeThrough: {
        enumerable: !0
    },
    pipeTo: {
        enumerable: !0
    },
    tee: {
        enumerable: !0
    },
    values: {
        enumerable: !0
    },
    locked: {
        enumerable: !0
    }
}), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$5d3e1e5268af5f76.from, "from"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$5d3e1e5268af5f76.prototype.cancel, "cancel"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$5d3e1e5268af5f76.prototype.getReader, "getReader"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$5d3e1e5268af5f76.prototype.pipeThrough, "pipeThrough"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$5d3e1e5268af5f76.prototype.pipeTo, "pipeTo"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$5d3e1e5268af5f76.prototype.tee, "tee"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$5d3e1e5268af5f76.prototype.values, "values"), "symbol" == (0, $7E0eS._)(Symbol.toStringTag) && Object.defineProperty($9159c2fc84b5e85b$export$5d3e1e5268af5f76.prototype, Symbol.toStringTag, {
    value: "ReadableStream",
    configurable: !0
}), Object.defineProperty($9159c2fc84b5e85b$export$5d3e1e5268af5f76.prototype, $9159c2fc84b5e85b$var$_e, {
    value: $9159c2fc84b5e85b$export$5d3e1e5268af5f76.prototype.values,
    writable: !0,
    configurable: !0
});
var $9159c2fc84b5e85b$var$Hr = function(e) {
    return e.byteLength;
};
$9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$var$Hr, "size");
var $9159c2fc84b5e85b$export$d386b5f37d154119 = /*#__PURE__*/ function() {
    "use strict";
    function ByteLengthQueuingStrategy(e) {
        (0, $173N4._)(this, ByteLengthQueuingStrategy);
        $9159c2fc84b5e85b$var$M(e, 1, "ByteLengthQueuingStrategy"), e = $9159c2fc84b5e85b$var$Nr(e, "First parameter"), this._byteLengthQueuingStrategyHighWaterMark = e.highWaterMark;
    }
    (0, $cFHGC._)(ByteLengthQueuingStrategy, [
        {
            key: "highWaterMark",
            get: function get() {
                if (!$9159c2fc84b5e85b$var$Ur(this)) throw $9159c2fc84b5e85b$var$Vr("highWaterMark");
                return this._byteLengthQueuingStrategyHighWaterMark;
            }
        },
        {
            key: "size",
            get: function get() {
                if (!$9159c2fc84b5e85b$var$Ur(this)) throw $9159c2fc84b5e85b$var$Vr("size");
                return $9159c2fc84b5e85b$var$Hr;
            }
        }
    ]);
    return ByteLengthQueuingStrategy;
}();
function $9159c2fc84b5e85b$var$Vr(e) {
    return new TypeError("ByteLengthQueuingStrategy.prototype.".concat(e, " can only be used on a ByteLengthQueuingStrategy"));
}
function $9159c2fc84b5e85b$var$Ur(e) {
    return !!$9159c2fc84b5e85b$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_byteLengthQueuingStrategyHighWaterMark") && e instanceof $9159c2fc84b5e85b$export$d386b5f37d154119;
}
Object.defineProperties($9159c2fc84b5e85b$export$d386b5f37d154119.prototype, {
    highWaterMark: {
        enumerable: !0
    },
    size: {
        enumerable: !0
    }
}), "symbol" == (0, $7E0eS._)(Symbol.toStringTag) && Object.defineProperty($9159c2fc84b5e85b$export$d386b5f37d154119.prototype, Symbol.toStringTag, {
    value: "ByteLengthQueuingStrategy",
    configurable: !0
});
var $9159c2fc84b5e85b$var$Gr = function() {
    return 1;
};
$9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$var$Gr, "size");
var $9159c2fc84b5e85b$export$9ebfec18c2dfc625 = /*#__PURE__*/ function() {
    "use strict";
    function CountQueuingStrategy(e) {
        (0, $173N4._)(this, CountQueuingStrategy);
        $9159c2fc84b5e85b$var$M(e, 1, "CountQueuingStrategy"), e = $9159c2fc84b5e85b$var$Nr(e, "First parameter"), this._countQueuingStrategyHighWaterMark = e.highWaterMark;
    }
    (0, $cFHGC._)(CountQueuingStrategy, [
        {
            key: "highWaterMark",
            get: function get() {
                if (!$9159c2fc84b5e85b$var$Jr(this)) throw $9159c2fc84b5e85b$var$Xr("highWaterMark");
                return this._countQueuingStrategyHighWaterMark;
            }
        },
        {
            key: "size",
            get: function get() {
                if (!$9159c2fc84b5e85b$var$Jr(this)) throw $9159c2fc84b5e85b$var$Xr("size");
                return $9159c2fc84b5e85b$var$Gr;
            }
        }
    ]);
    return CountQueuingStrategy;
}();
function $9159c2fc84b5e85b$var$Xr(e) {
    return new TypeError("CountQueuingStrategy.prototype.".concat(e, " can only be used on a CountQueuingStrategy"));
}
function $9159c2fc84b5e85b$var$Jr(e) {
    return !!$9159c2fc84b5e85b$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_countQueuingStrategyHighWaterMark") && e instanceof $9159c2fc84b5e85b$export$9ebfec18c2dfc625;
}
function $9159c2fc84b5e85b$var$Kr(e, t, r) {
    return $9159c2fc84b5e85b$var$I(e, r), function(r) {
        return $9159c2fc84b5e85b$var$g(e, t, [
            r
        ]);
    };
}
function $9159c2fc84b5e85b$var$Zr(e, t, r) {
    return $9159c2fc84b5e85b$var$I(e, r), function(r) {
        return $9159c2fc84b5e85b$var$S(e, t, [
            r
        ]);
    };
}
function $9159c2fc84b5e85b$var$eo(e, t, r) {
    return $9159c2fc84b5e85b$var$I(e, r), function(r, o) {
        return $9159c2fc84b5e85b$var$g(e, t, [
            r,
            o
        ]);
    };
}
function $9159c2fc84b5e85b$var$to(e, t, r) {
    return $9159c2fc84b5e85b$var$I(e, r), function(r) {
        return $9159c2fc84b5e85b$var$g(e, t, [
            r
        ]);
    };
}
Object.defineProperties($9159c2fc84b5e85b$export$9ebfec18c2dfc625.prototype, {
    highWaterMark: {
        enumerable: !0
    },
    size: {
        enumerable: !0
    }
}), "symbol" == (0, $7E0eS._)(Symbol.toStringTag) && Object.defineProperty($9159c2fc84b5e85b$export$9ebfec18c2dfc625.prototype, Symbol.toStringTag, {
    value: "CountQueuingStrategy",
    configurable: !0
});
var $9159c2fc84b5e85b$export$d102341634899398 = /*#__PURE__*/ function() {
    "use strict";
    function TransformStream() {
        var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        (0, $173N4._)(this, TransformStream);
        void 0 === _$e && (_$e = null);
        var _$o = $9159c2fc84b5e85b$var$yt(t, "Second parameter"), n = $9159c2fc84b5e85b$var$yt(r, "Third parameter"), i = function(e, t) {
            $9159c2fc84b5e85b$var$L(e, t);
            var r = null == e ? void 0 : e.cancel, _$o = null == e ? void 0 : e.flush, n = null == e ? void 0 : e.readableType, i = null == e ? void 0 : e.start, a = null == e ? void 0 : e.transform, s = null == e ? void 0 : e.writableType;
            return {
                cancel: void 0 === r ? void 0 : $9159c2fc84b5e85b$var$to(r, e, "".concat(t, " has member 'cancel' that")),
                flush: void 0 === _$o ? void 0 : $9159c2fc84b5e85b$var$Kr(_$o, e, "".concat(t, " has member 'flush' that")),
                readableType: n,
                start: void 0 === i ? void 0 : $9159c2fc84b5e85b$var$Zr(i, e, "".concat(t, " has member 'start' that")),
                transform: void 0 === a ? void 0 : $9159c2fc84b5e85b$var$eo(a, e, "".concat(t, " has member 'transform' that")),
                writableType: s
            };
        }(_$e, "First parameter");
        if (void 0 !== i.readableType) throw new RangeError("Invalid readableType specified");
        if (void 0 !== i.writableType) throw new RangeError("Invalid writableType specified");
        var a = $9159c2fc84b5e85b$var$mt(n, 0), s = $9159c2fc84b5e85b$var$pt(n), l = $9159c2fc84b5e85b$var$mt(_$o, 1), f = $9159c2fc84b5e85b$var$pt(_$o);
        var b;
        !function(e, t, r, o, n, i) {
            function a() {
                return t;
            }
            function s(t) {
                return function(e, t) {
                    var _$r = e._transformStreamController;
                    if (e._backpressure) return $9159c2fc84b5e85b$var$m(e._backpressureChangePromise, function() {
                        var _$o = e._writable;
                        if ("erroring" === _$o._state) throw _$o._storedError;
                        return $9159c2fc84b5e85b$var$co(_$r, t);
                    });
                    return $9159c2fc84b5e85b$var$co(_$r, t);
                }(e, t);
            }
            function l(t) {
                return function(e, t) {
                    var _$r = e._transformStreamController;
                    if (void 0 !== _$r._finishPromise) return _$r._finishPromise;
                    var _$o = e._readable;
                    _$r._finishPromise = $9159c2fc84b5e85b$var$u(function(e, t) {
                        _$r._finishPromise_resolve = e, _$r._finishPromise_reject = t;
                    });
                    var _$n = _$r._cancelAlgorithm(t);
                    return $9159c2fc84b5e85b$var$lo(_$r), $9159c2fc84b5e85b$var$h(_$n, function() {
                        return "errored" === _$o._state ? $9159c2fc84b5e85b$var$bo(_$r, _$o._storedError) : ($9159c2fc84b5e85b$var$Tr(_$o._readableStreamController, t), $9159c2fc84b5e85b$var$ho(_$r)), null;
                    }, function(e) {
                        return $9159c2fc84b5e85b$var$Tr(_$o._readableStreamController, e), $9159c2fc84b5e85b$var$bo(_$r, e), null;
                    }), _$r._finishPromise;
                }(e, t);
            }
            function c() {
                return function(e) {
                    var t = e._transformStreamController;
                    if (void 0 !== t._finishPromise) return t._finishPromise;
                    var _$r = e._readable;
                    t._finishPromise = $9159c2fc84b5e85b$var$u(function(e, r) {
                        t._finishPromise_resolve = e, t._finishPromise_reject = r;
                    });
                    var _$o = t._flushAlgorithm();
                    return $9159c2fc84b5e85b$var$lo(t), $9159c2fc84b5e85b$var$h(_$o, function() {
                        return "errored" === _$r._state ? $9159c2fc84b5e85b$var$bo(t, _$r._storedError) : ($9159c2fc84b5e85b$var$wr(_$r._readableStreamController), $9159c2fc84b5e85b$var$ho(t)), null;
                    }, function(e) {
                        return $9159c2fc84b5e85b$var$Tr(_$r._readableStreamController, e), $9159c2fc84b5e85b$var$bo(t, e), null;
                    }), t._finishPromise;
                }(e);
            }
            function d() {
                return function(e) {
                    return $9159c2fc84b5e85b$var$ao(e, !1), e._backpressureChangePromise;
                }(e);
            }
            function f(t) {
                return function(e, t) {
                    var _$r = e._transformStreamController;
                    if (void 0 !== _$r._finishPromise) return _$r._finishPromise;
                    var _$o = e._writable;
                    _$r._finishPromise = $9159c2fc84b5e85b$var$u(function(e, t) {
                        _$r._finishPromise_resolve = e, _$r._finishPromise_reject = t;
                    });
                    var _$n = _$r._cancelAlgorithm(t);
                    return $9159c2fc84b5e85b$var$lo(_$r), $9159c2fc84b5e85b$var$h(_$n, function() {
                        return "errored" === _$o._state ? $9159c2fc84b5e85b$var$bo(_$r, _$o._storedError) : ($9159c2fc84b5e85b$var$Gt(_$o._writableStreamController, t), $9159c2fc84b5e85b$var$io(e), $9159c2fc84b5e85b$var$ho(_$r)), null;
                    }, function(t) {
                        return $9159c2fc84b5e85b$var$Gt(_$o._writableStreamController, t), $9159c2fc84b5e85b$var$io(e), $9159c2fc84b5e85b$var$bo(_$r, t), null;
                    }), _$r._finishPromise;
                }(e, t);
            }
            e._writable = function(e, t, r, o) {
                var _$n = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, _$i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : function() {
                    return 1;
                };
                var _$a = Object.create($9159c2fc84b5e85b$export$826849241f7970f8.prototype);
                return $9159c2fc84b5e85b$var$Ct(_$a), $9159c2fc84b5e85b$var$Nt(_$a, Object.create($9159c2fc84b5e85b$export$9e6890cb9a51c7c2.prototype), e, t, r, o, _$n, _$i), _$a;
            }(a, s, c, l, r, o), e._readable = $9159c2fc84b5e85b$var$Dr(a, d, f, n, i), e._backpressure = void 0, e._backpressureChangePromise = void 0, e._backpressureChangePromise_resolve = void 0, $9159c2fc84b5e85b$var$ao(e, !0), e._transformStreamController = void 0;
        }(this, $9159c2fc84b5e85b$var$u(function(e) {
            b = e;
        }), l, f, a, s), function(e, t) {
            var r = Object.create($9159c2fc84b5e85b$export$a55559184460222.prototype);
            var _$o, n, i;
            _$o = void 0 !== t.transform ? function(e) {
                return t.transform(e, r);
            } : function(e) {
                try {
                    return $9159c2fc84b5e85b$var$uo(r, e), $9159c2fc84b5e85b$var$c(void 0);
                } catch (e) {
                    return $9159c2fc84b5e85b$var$d(e);
                }
            };
            n = void 0 !== t.flush ? function() {
                return t.flush(r);
            } : function() {
                return $9159c2fc84b5e85b$var$c(void 0);
            };
            i = void 0 !== t.cancel ? function(e) {
                return t.cancel(e);
            } : function() {
                return $9159c2fc84b5e85b$var$c(void 0);
            };
            !function(e, t, r, o, n) {
                t._controlledTransformStream = e, e._transformStreamController = t, t._transformAlgorithm = r, t._flushAlgorithm = o, t._cancelAlgorithm = n, t._finishPromise = void 0, t._finishPromise_resolve = void 0, t._finishPromise_reject = void 0;
            }(e, r, _$o, n, i);
        }(this, i), void 0 !== i.start ? b(i.start(this._transformStreamController)) : b(void 0);
    }
    (0, $cFHGC._)(TransformStream, [
        {
            key: "readable",
            get: function get() {
                if (!$9159c2fc84b5e85b$var$ro(this)) throw $9159c2fc84b5e85b$var$_o("readable");
                return this._readable;
            }
        },
        {
            key: "writable",
            get: function get() {
                if (!$9159c2fc84b5e85b$var$ro(this)) throw $9159c2fc84b5e85b$var$_o("writable");
                return this._writable;
            }
        }
    ]);
    return TransformStream;
}();
function $9159c2fc84b5e85b$var$ro(e) {
    return !!$9159c2fc84b5e85b$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_transformStreamController") && e instanceof $9159c2fc84b5e85b$export$d102341634899398;
}
function $9159c2fc84b5e85b$var$oo(e, t) {
    $9159c2fc84b5e85b$var$Tr(e._readable._readableStreamController, t), $9159c2fc84b5e85b$var$no(e, t);
}
function $9159c2fc84b5e85b$var$no(e, t) {
    $9159c2fc84b5e85b$var$lo(e._transformStreamController), $9159c2fc84b5e85b$var$Gt(e._writable._writableStreamController, t), $9159c2fc84b5e85b$var$io(e);
}
function $9159c2fc84b5e85b$var$io(e) {
    e._backpressure && $9159c2fc84b5e85b$var$ao(e, !1);
}
function $9159c2fc84b5e85b$var$ao(e, t) {
    void 0 !== e._backpressureChangePromise && e._backpressureChangePromise_resolve(), e._backpressureChangePromise = $9159c2fc84b5e85b$var$u(function(t) {
        e._backpressureChangePromise_resolve = t;
    }), e._backpressure = t;
}
Object.defineProperties($9159c2fc84b5e85b$export$d102341634899398.prototype, {
    readable: {
        enumerable: !0
    },
    writable: {
        enumerable: !0
    }
}), "symbol" == (0, $7E0eS._)(Symbol.toStringTag) && Object.defineProperty($9159c2fc84b5e85b$export$d102341634899398.prototype, Symbol.toStringTag, {
    value: "TransformStream",
    configurable: !0
});
var $9159c2fc84b5e85b$export$a55559184460222 = /*#__PURE__*/ function() {
    "use strict";
    function TransformStreamDefaultController() {
        (0, $173N4._)(this, TransformStreamDefaultController);
        throw new TypeError("Illegal constructor");
    }
    (0, $cFHGC._)(TransformStreamDefaultController, [
        {
            key: "desiredSize",
            get: function get() {
                if (!$9159c2fc84b5e85b$var$so(this)) throw $9159c2fc84b5e85b$var$fo("desiredSize");
                return $9159c2fc84b5e85b$var$Pr(this._controlledTransformStream._readable._readableStreamController);
            }
        },
        {
            key: "enqueue",
            value: function enqueue(e) {
                if (!$9159c2fc84b5e85b$var$so(this)) throw $9159c2fc84b5e85b$var$fo("enqueue");
                $9159c2fc84b5e85b$var$uo(this, e);
            }
        },
        {
            key: "error",
            value: function error(e) {
                if (!$9159c2fc84b5e85b$var$so(this)) throw $9159c2fc84b5e85b$var$fo("error");
                var t;
                t = e, $9159c2fc84b5e85b$var$oo(this._controlledTransformStream, t);
            }
        },
        {
            key: "terminate",
            value: function terminate() {
                if (!$9159c2fc84b5e85b$var$so(this)) throw $9159c2fc84b5e85b$var$fo("terminate");
                !function(e) {
                    var t = e._controlledTransformStream;
                    $9159c2fc84b5e85b$var$wr(t._readable._readableStreamController);
                    var r = new TypeError("TransformStream terminated");
                    $9159c2fc84b5e85b$var$no(t, r);
                }(this);
            }
        }
    ]);
    return TransformStreamDefaultController;
}();
function $9159c2fc84b5e85b$var$so(e) {
    return !!$9159c2fc84b5e85b$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledTransformStream") && e instanceof $9159c2fc84b5e85b$export$a55559184460222;
}
function $9159c2fc84b5e85b$var$lo(e) {
    e._transformAlgorithm = void 0, e._flushAlgorithm = void 0, e._cancelAlgorithm = void 0;
}
function $9159c2fc84b5e85b$var$uo(e, t) {
    var r = e._controlledTransformStream, _$o = r._readable._readableStreamController;
    if (!$9159c2fc84b5e85b$var$Cr(_$o)) throw new TypeError("Readable side is not in a state that permits enqueue");
    try {
        $9159c2fc84b5e85b$var$Rr(_$o, t);
    } catch (e) {
        throw $9159c2fc84b5e85b$var$no(r, e), r._readable._storedError;
    }
    var n = function(e) {
        return !$9159c2fc84b5e85b$var$gr(e);
    }(_$o);
    n !== r._backpressure && $9159c2fc84b5e85b$var$ao(r, !0);
}
function $9159c2fc84b5e85b$var$co(e, t) {
    return $9159c2fc84b5e85b$var$m(e._transformAlgorithm(t), void 0, function(t) {
        throw $9159c2fc84b5e85b$var$oo(e._controlledTransformStream, t), t;
    });
}
function $9159c2fc84b5e85b$var$fo(e) {
    return new TypeError("TransformStreamDefaultController.prototype.".concat(e, " can only be used on a TransformStreamDefaultController"));
}
function $9159c2fc84b5e85b$var$ho(e) {
    void 0 !== e._finishPromise_resolve && (e._finishPromise_resolve(), e._finishPromise_resolve = void 0, e._finishPromise_reject = void 0);
}
function $9159c2fc84b5e85b$var$bo(e, t) {
    void 0 !== e._finishPromise_reject && ($9159c2fc84b5e85b$var$p(e._finishPromise), e._finishPromise_reject(t), e._finishPromise_resolve = void 0, e._finishPromise_reject = void 0);
}
function $9159c2fc84b5e85b$var$_o(e) {
    return new TypeError("TransformStream.prototype.".concat(e, " can only be used on a TransformStream"));
}
Object.defineProperties($9159c2fc84b5e85b$export$a55559184460222.prototype, {
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    terminate: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$a55559184460222.prototype.enqueue, "enqueue"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$a55559184460222.prototype.error, "error"), $9159c2fc84b5e85b$var$o($9159c2fc84b5e85b$export$a55559184460222.prototype.terminate, "terminate"), "symbol" == (0, $7E0eS._)(Symbol.toStringTag) && Object.defineProperty($9159c2fc84b5e85b$export$a55559184460222.prototype, Symbol.toStringTag, {
    value: "TransformStreamDefaultController",
    configurable: !0
});

});

parcelRegister("lhPyT", function(module, exports) {

$parcel$export(module.exports, "isEmpty", function () { return $f7f32ea09725ee93$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "proxyPrototype", function () { return $f7f32ea09725ee93$export$2a489b3f92f4996a; });
$parcel$export(module.exports, "toHyphenCase", function () { return $f7f32ea09725ee93$export$3f34ca2fef821bbd; });
$parcel$export(module.exports, "toCamelCase", function () { return $f7f32ea09725ee93$export$86f54f62aa7a7514; });
$parcel$export(module.exports, "uniqueID", function () { return $f7f32ea09725ee93$export$89912e019eef22aa; });
$parcel$export(module.exports, "encodeBase64", function () { return $f7f32ea09725ee93$export$8fb536984ec8b4d7; });
$parcel$export(module.exports, "groupBy", function () { return $f7f32ea09725ee93$export$3f063810d7bf01bd; });
$parcel$export(module.exports, "likeArray", function () { return $f7f32ea09725ee93$export$b5a4d6f439a5044d; });
$parcel$export(module.exports, "isTypedArray", function () { return $f7f32ea09725ee93$export$b119cc7e1840e59c; });
$parcel$export(module.exports, "makeArray", function () { return $f7f32ea09725ee93$export$7b85fd78dd236198; });
$parcel$export(module.exports, "splitArray", function () { return $f7f32ea09725ee93$export$697c3df919c0e61a; });
$parcel$export(module.exports, "countBy", function () { return $f7f32ea09725ee93$export$1d012a0dff3dab06; });
$parcel$export(module.exports, "createAsyncIterator", function () { return $f7f32ea09725ee93$export$86c18c6347f4a8c4; });
$parcel$export(module.exports, "ByteSize", function () { return $f7f32ea09725ee93$export$271f7c16f175f804; });
$parcel$export(module.exports, "sum", function () { return $f7f32ea09725ee93$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "averageOf", function () { return $f7f32ea09725ee93$export$e1f36757ecda301d; });
$parcel$export(module.exports, "Second", function () { return $f7f32ea09725ee93$export$c489aa6f7fd82b1a; });
$parcel$export(module.exports, "Day", function () { return $f7f32ea09725ee93$export$7a9a31a911eb9a20; });
$parcel$export(module.exports, "Timestamp", function () { return $f7f32ea09725ee93$export$d9bcbd5e1ff81430; });
$parcel$export(module.exports, "diffTime", function () { return $f7f32ea09725ee93$export$506c8e8f8c8edda; });
$parcel$export(module.exports, "formatDate", function () { return $f7f32ea09725ee93$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "changeMonth", function () { return $f7f32ea09725ee93$export$62ad822b3a5fd9a0; });
$parcel$export(module.exports, "parseJSON", function () { return $f7f32ea09725ee93$export$27924e57e9afff7f; });
$parcel$export(module.exports, "parseURLData", function () { return $f7f32ea09725ee93$export$eb9b2aadbe449a20; });
$parcel$export(module.exports, "buildURLData", function () { return $f7f32ea09725ee93$export$13397a83aa5915d6; });
$parcel$export(module.exports, "blobOf", function () { return $f7f32ea09725ee93$export$fd89523fba250fa4; });
$parcel$export(module.exports, "parseCookie", function () { return $f7f32ea09725ee93$export$d0eaf3e94be578f6; });
$parcel$export(module.exports, "setCookie", function () { return $f7f32ea09725ee93$export$110700823644f4a6; });
$parcel$export(module.exports, "parseDOM", function () { return $f7f32ea09725ee93$export$d66b332881d9723f; });
$parcel$export(module.exports, "stringifyDOM", function () { return $f7f32ea09725ee93$export$b0709844452f8b6b; });
$parcel$export(module.exports, "walkDOM", function () { return $f7f32ea09725ee93$export$5118471ee5d5453b; });
$parcel$export(module.exports, "getVisibleText", function () { return $f7f32ea09725ee93$export$be4650432daa84fd; });
$parcel$export(module.exports, "insertToCursor", function () { return $f7f32ea09725ee93$export$28d9d24a8cd0ffc2; });
$parcel$export(module.exports, "scrollTo", function () { return $f7f32ea09725ee93$export$3f99968195accfaf; });
$parcel$export(module.exports, "formToJSON", function () { return $f7f32ea09725ee93$export$86d7c59254d6a2c9; });
$parcel$export(module.exports, "sleep", function () { return $f7f32ea09725ee93$export$e772c8ff12451969; });
$parcel$export(module.exports, "serviceWorkerUpdate", function () { return $f7f32ea09725ee93$export$d635d04af3887bbe; });

var $jAEAr = parcelRequire("jAEAr");

var $dafVd = parcelRequire("dafVd");

var $3gP77 = parcelRequire("3gP77");

var $dm3mz = parcelRequire("dm3mz");

var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $dWsrg = parcelRequire("dWsrg");

var $kg0zo = parcelRequire("kg0zo");

var $hdIku = parcelRequire("hdIku");

var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");

var $7t5yo = parcelRequire("7t5yo");

var $13u2V = parcelRequire("13u2V");

var $Csf8W = parcelRequire("Csf8W");
var $f7f32ea09725ee93$var$_String;
function $f7f32ea09725ee93$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $f7f32ea09725ee93$var$$9b05bcda60cc529c$exports = {};
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $f7f32ea09725ee93$export$61cc6ed0f143570b;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $f7f32ea09725ee93$export$dd1bc94b04021eeb;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $f7f32ea09725ee93$export$a09f818797e212c4;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $f7f32ea09725ee93$export$170f4e08cad8229d;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "proxyPrototype", function() {
    return $f7f32ea09725ee93$export$2a489b3f92f4996a;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $f7f32ea09725ee93$export$67a6ce548ae77071;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $f7f32ea09725ee93$export$a48f0734ac7c2329;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $f7f32ea09725ee93$export$3f34ca2fef821bbd;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $f7f32ea09725ee93$export$86f54f62aa7a7514;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $f7f32ea09725ee93$export$89912e019eef22aa;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "encodeBase64", function() {
    return $f7f32ea09725ee93$export$8fb536984ec8b4d7;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "decodeBase64", function() {
    return $f7f32ea09725ee93$export$94fdf11bafc8de6b;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $f7f32ea09725ee93$export$1c8ba402144543e5;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $f7f32ea09725ee93$export$2ddabb89308e1a22;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $f7f32ea09725ee93$export$14527669107aa301;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $f7f32ea09725ee93$export$3f063810d7bf01bd;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $f7f32ea09725ee93$export$b5a4d6f439a5044d;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $f7f32ea09725ee93$export$b119cc7e1840e59c;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $f7f32ea09725ee93$export$7b85fd78dd236198;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $f7f32ea09725ee93$export$697c3df919c0e61a;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $f7f32ea09725ee93$export$1d012a0dff3dab06;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $f7f32ea09725ee93$export$e6b5ff3168b5942b;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "clone", function() {
    return $f7f32ea09725ee93$export$9cd59f9826255e47;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "treeFrom", function() {
    return $f7f32ea09725ee93$export$fbc9cd6af26fa64f;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $f7f32ea09725ee93$export$69a3209f1a06c04d;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "createAsyncIterator", function() {
    return $f7f32ea09725ee93$export$86c18c6347f4a8c4;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $f7f32ea09725ee93$export$dce9414bed0662c;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$9b05bcda60cc529c$exports, "ByteSize", function() {
    return $f7f32ea09725ee93$export$271f7c16f175f804;
});
var $f7f32ea09725ee93$var$$6a9944941b4c1893$exports = {};
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$6a9944941b4c1893$exports, "sum", function() {
    return $f7f32ea09725ee93$export$8a63f25cc62965f1;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $f7f32ea09725ee93$export$e1f36757ecda301d;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $f7f32ea09725ee93$export$8e694e1eafd55acb;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $f7f32ea09725ee93$export$57d7c52a66287430;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $f7f32ea09725ee93$export$2b4693832ca3ce16;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $f7f32ea09725ee93$export$5b784e078da1ce6;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $f7f32ea09725ee93$export$17ec9c9f4f23588c;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$6a9944941b4c1893$exports, "Scalar", function() {
    return $f7f32ea09725ee93$export$595dbf49c602a1f;
});
function $f7f32ea09725ee93$export$8a63f25cc62965f1() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return data.reduce(function(sum, item) {
        return sum + item;
    }, 0);
}
function $f7f32ea09725ee93$export$e1f36757ecda301d() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return $f7f32ea09725ee93$export$8a63f25cc62965f1.apply(void 0, (0, $aUGqu._)(data)) / data.length;
}
function $f7f32ea09725ee93$export$8e694e1eafd55acb(data) {
    var sample = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var average = $f7f32ea09725ee93$export$e1f36757ecda301d.apply(void 0, (0, $aUGqu._)(data));
    var summary = $f7f32ea09725ee93$export$8a63f25cc62965f1.apply(void 0, (0, $aUGqu._)(data.map(function(item) {
        return Math.pow(item - average, 2);
    })));
    return summary / (data.length - (sample ? 1 : 0));
}
function $f7f32ea09725ee93$export$57d7c52a66287430(data) {
    var sample = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return Math.sqrt($f7f32ea09725ee93$export$8e694e1eafd55acb(data, sample));
}
function $f7f32ea09725ee93$export$2b4693832ca3ce16() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return Math.sqrt($f7f32ea09725ee93$export$8a63f25cc62965f1.apply(void 0, (0, $aUGqu._)(data.map(function(item) {
        return Math.pow(item, 2);
    }))));
}
function $f7f32ea09725ee93$export$5b784e078da1ce6(raw, length) {
    var text = raw.toFixed(length + 2);
    var offset = text.indexOf('.') + length + 1;
    var cut = function(text) {
        return text.slice(0, offset - (length ? 0 : 1));
    };
    if (!+text.slice(offset)) return cut(text);
    var result = cut((+cut(text) + Math.pow(10, -length)).toFixed(length));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
function $f7f32ea09725ee93$export$17ec9c9f4f23588c(raw) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var text = raw.toFixed(length + 2);
    var floatOffset = text.indexOf('.');
    if (floatOffset < 0) return length ? "".concat(text, ".").concat('0'.repeat(length)) : text;
    var offset = floatOffset + length + 1;
    var before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    var carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $f7f32ea09725ee93$export$5b784e078da1ce6(raw, length);
    var result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
var $f7f32ea09725ee93$export$595dbf49c602a1f = /*#__PURE__*/ function() {
    "use strict";
    function $6a9944941b4c1893$export$595dbf49c602a1f(value) {
        (0, $173N4._)(this, $6a9944941b4c1893$export$595dbf49c602a1f);
        this.value = value;
    }
    (0, $cFHGC._)($6a9944941b4c1893$export$595dbf49c602a1f, [
        {
            key: "valueOf",
            value: function valueOf() {
                return this.value;
            }
        },
        {
            key: "toShortString",
            value: function toShortString() {
                var fractionDigits = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 2;
                var _this = this, units = _this.units, value = _this.value;
                var _ref = (0, $aUGqu._)(units).reverse().find(function(param) {
                    var base = param.base;
                    return Math.abs(value) >= base;
                }) || units[0], base = _ref.base, name = _ref.name;
                return "".concat((value / base).toFixed(fractionDigits), " ").concat(name);
            }
        }
    ], [
        {
            key: "distanceOf",
            value: function distanceOf(a, b) {
                return Reflect.construct(this, [
                    a - b
                ]);
            }
        }
    ]);
    return $6a9944941b4c1893$export$595dbf49c602a1f;
}();
var $f7f32ea09725ee93$export$61cc6ed0f143570b = function(value) {
    return !(value != null) || Number.isNaN(value);
};
var $f7f32ea09725ee93$export$dd1bc94b04021eeb = function(value) {
    return $f7f32ea09725ee93$export$61cc6ed0f143570b(value) || ((typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) === 'object' ? !Object.keys(value).length : value === '');
};
var $f7f32ea09725ee93$export$a09f818797e212c4 = function(data) {
    return Object.prototype.toString.call(data).slice(8, -1);
};
var $f7f32ea09725ee93$export$170f4e08cad8229d = function(Sub, Super) {
    return Sub.prototype instanceof Super;
};
function $f7f32ea09725ee93$export$2a489b3f92f4996a(target, dataStore, setter) {
    var prototype = Object.getPrototypeOf(target);
    var prototypeProxy = new Proxy(prototype, {
        set: function(_, key, value, receiver) {
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter === null || setter === void 0 ? void 0 : setter(key, value);
            return true;
        },
        get: function(prototype, key, receiver) {
            return key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver);
        }
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
var $f7f32ea09725ee93$export$67a6ce548ae77071 = function(raw) {
    return /^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + '', undefined, {
        numeric: true
    }) > 0;
};
var $f7f32ea09725ee93$export$a48f0734ac7c2329 = function(raw) {
    return raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, 'xx').length;
};
var $f7f32ea09725ee93$export$3f34ca2fef821bbd = function(raw) {
    return raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, function(match, offset) {
        return "".concat(offset ? '-' : '').concat((match[1] || match[0]).toLowerCase());
    });
};
var $f7f32ea09725ee93$export$86f54f62aa7a7514 = function(raw) {
    var large = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, function(match, offset) {
        return offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase();
    });
};
var $f7f32ea09725ee93$export$89912e019eef22aa = function() {
    return (Date.now() + parseInt((Math.random() + '').slice(2))).toString(36);
};
var $f7f32ea09725ee93$export$8fb536984ec8b4d7 = function(input) {
    return btoa(($f7f32ea09725ee93$var$_String = String).fromCharCode.apply($f7f32ea09725ee93$var$_String, (0, $aUGqu._)(new TextEncoder().encode(input))));
};
var $f7f32ea09725ee93$export$94fdf11bafc8de6b = function(input) {
    return new TextDecoder().decode(Uint8Array.from(atob(input), function(char) {
        return char.charCodeAt(0);
    }));
};
var $f7f32ea09725ee93$export$1c8ba402144543e5 = function(values, keys) {
    return Object.fromEntries(values.map(function(value, index) {
        return [
            keys[index],
            value
        ];
    }));
};
var $f7f32ea09725ee93$export$2ddabb89308e1a22 = /*#__PURE__*/ function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
    return DiffStatus;
}({});
function $f7f32ea09725ee93$export$14527669107aa301(oldList, newList) {
    var map = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = oldList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            map[item] = -1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = newList[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var item1 = _step1.value;
            var _map, _item;
            (_map = map)[_item = item1] || (_map[_item] = 0);
            map[item1] += 1;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return {
        map: map,
        group: $f7f32ea09725ee93$export$3f063810d7bf01bd(Object.entries(map), function(param) {
            var _param = (0, $f9AOD._)(param, 2), key = _param[0], status = _param[1];
            return status;
        })
    };
}
function $f7f32ea09725ee93$export$b5a4d6f439a5044d(data) {
    if ($f7f32ea09725ee93$export$61cc6ed0f143570b(data)) return false;
    var length = data.length;
    return typeof length === 'number' && length >= 0 && ~~length === length;
}
var $f7f32ea09725ee93$export$b119cc7e1840e59c = function(data) {
    return data instanceof Object.getPrototypeOf(Int8Array);
};
function $f7f32ea09725ee93$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($f7f32ea09725ee93$export$61cc6ed0f143570b(data)) return [];
    if ($f7f32ea09725ee93$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
var $f7f32ea09725ee93$export$697c3df919c0e61a = function(array, unitLength) {
    return array.reduce(function(grid, item, index) {
        var _grid, _ref;
        ((_grid = grid)[_ref = ~~(index / unitLength)] || (_grid[_ref] = []))[index % unitLength] = item;
        return grid;
    }, []);
};
function $f7f32ea09725ee93$export$3f063810d7bf01bd(list, iteratee) {
    var data = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
            if (!(keys instanceof Array)) keys = [
                keys
            ];
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = new Set(keys.filter(function(key) {
                    return key != null;
                }))[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var key = _step1.value;
                    (data[key] = data[key] || []).push(item);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return data;
}
function $f7f32ea09725ee93$export$1d012a0dff3dab06(list, iteratee) {
    var group = $f7f32ea09725ee93$export$3f063810d7bf01bd(list, iteratee);
    var sortedList = Object.entries(group).map(function(param) {
        var _param = (0, $f9AOD._)(param, 2), key = _param[0], _param_ = _param[1], length = _param_.length;
        return [
            key,
            length
        ];
    });
    return Object.fromEntries(sortedList);
}
function $f7f32ea09725ee93$export$e6b5ff3168b5942b(list, subKey, handler) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (handler(item)) return [
                item
            ];
            if (item[subKey] instanceof Array) {
                var result = $f7f32ea09725ee93$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
                if (result.length) return [
                    item
                ].concat((0, $aUGqu._)(result));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [];
}
function $f7f32ea09725ee93$export$9cd59f9826255e47(data) {
    try {
        return globalThis.structuredClone(data);
    } catch (e) {
        return JSON.parse(JSON.stringify(data));
    }
}
function $f7f32ea09725ee93$export$fbc9cd6af26fa64f(list) {
    var idKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'id', parentIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'parentId', childrenKey = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 'children';
    list = $f7f32ea09725ee93$export$9cd59f9826255e47(list);
    var map = {};
    var roots = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            map[item[idKey]] = item;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = list[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var item1 = _step1.value;
            var parent = map[item1[parentIdKey]];
            if (!parent) roots.push(item1);
            else {
                var _parent, _childrenKey;
                (_parent = parent)[_childrenKey = childrenKey] || (_parent[_childrenKey] = []);
                parent[childrenKey].push(item1);
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    if (!roots[0]) throw new ReferenceError('No root node is found');
    return roots;
}
function $f7f32ea09725ee93$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function() {
        for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
            data[_key] = arguments[_key];
        }
        var _executor;
        if (cacheData != null) return cacheData;
        console.trace("[Cache] execute: ".concat(title));
        cacheData = (_executor = executor).call.apply(_executor, [
            this,
            function() {
                return cacheData = undefined;
            }
        ].concat((0, $aUGqu._)(data)));
        Promise.resolve(cacheData).then(function(data) {
            return console.log("[Cache] refreshed: ".concat(title, " => ").concat(data));
        }, function(error) {
            return console.error("[Cache] failed: ".concat((error === null || error === void 0 ? void 0 : error.message) || error));
        });
        return cacheData;
    };
}
function $f7f32ea09725ee93$export$86c18c6347f4a8c4(executor) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function() {
        var _Promise_withResolvers, promise, resolve, reject, doneSymbol, done, disposer, value, ref;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _Promise_withResolvers = Promise.withResolvers(), promise = _Promise_withResolvers.promise, resolve = _Promise_withResolvers.resolve, reject = _Promise_withResolvers.reject;
                    doneSymbol = Symbol('done'), done = Promise.withResolvers();
                    disposer = executor({
                        next: function(value) {
                            return resolve(value);
                        },
                        error: function(error) {
                            reject(error);
                            // @ts-ignore
                            disposer === null || disposer === void 0 ? void 0 : disposer();
                        },
                        complete: function() {
                            done.resolve(doneSymbol);
                            // @ts-ignore
                            disposer === null || disposer === void 0 ? void 0 : disposer();
                        }
                    });
                    _state.label = 1;
                case 1:
                    if (!true) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        (0, $dm3mz._)(Promise.race([
                            promise,
                            done.promise
                        ]))
                    ];
                case 2:
                    value = _state.sent();
                    if (value === doneSymbol) return [
                        2
                    ];
                    return [
                        4,
                        value
                    ];
                case 3:
                    _state.sent();
                    ref = Promise.withResolvers(), promise = ref.promise, resolve = ref.resolve, reject = ref.reject, ref;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $f7f32ea09725ee93$export$dce9414bed0662c() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++){
        sources[_key] = arguments[_key];
    }
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function() {
        var _loop, iterators;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function() {
                        var dones, i, iterator, _ref, done, value;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    dones = [];
                                    i = 0, iterator = void 0;
                                    _state.label = 1;
                                case 1:
                                    if (!(iterator = iterators[i])) return [
                                        3,
                                        6
                                    ];
                                    return [
                                        4,
                                        (0, $dm3mz._)(iterator.next())
                                    ];
                                case 2:
                                    _ref = _state.sent(), done = _ref.done, value = _ref.value;
                                    if (!!done) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        value
                                    ];
                                case 3:
                                    _state.sent();
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    dones.push(i);
                                    _state.label = 5;
                                case 5:
                                    i++;
                                    return [
                                        3,
                                        1
                                    ];
                                case 6:
                                    iterators = iterators.filter(function(_, i) {
                                        return !dones.includes(i);
                                    });
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    iterators = sources.map(function(item) {
                        return item();
                    });
                    _state.label = 1;
                case 1:
                    if (!iterators[0]) return [
                        3,
                        3
                    ];
                    return [
                        5,
                        (0, $Csf8W.__values)(_loop())
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
}
var $f7f32ea09725ee93$export$271f7c16f175f804 = /*#__PURE__*/ function($6a9944941b4c1893$export$595dbf49c602a1f) {
    "use strict";
    (0, $hdIku._)($9b05bcda60cc529c$export$271f7c16f175f804, $6a9944941b4c1893$export$595dbf49c602a1f);
    function $9b05bcda60cc529c$export$271f7c16f175f804() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $9b05bcda60cc529c$export$271f7c16f175f804);
        var _this;
        _this = (0, $7qXGD._)(this, $9b05bcda60cc529c$export$271f7c16f175f804, (0, $aUGqu._)(args)), _this.units = [
            '',
            'K',
            'M',
            'G',
            'T',
            'P',
            'E',
            'Z',
            'Y'
        ].map(function(name, i) {
            return {
                base: Math.pow(1024, i),
                name: name + 'B'
            };
        });
        return _this;
    }
    return $9b05bcda60cc529c$export$271f7c16f175f804;
}($f7f32ea09725ee93$export$595dbf49c602a1f);
var $f7f32ea09725ee93$var$$f872d8bba1c0f79f$exports = {};
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $f7f32ea09725ee93$export$c489aa6f7fd82b1a;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $f7f32ea09725ee93$export$cbd942915f33be50;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $f7f32ea09725ee93$export$9b886f8493244014;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $f7f32ea09725ee93$export$e99cbb807a5bb10d;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $f7f32ea09725ee93$export$7a9a31a911eb9a20;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $f7f32ea09725ee93$export$fca4f8121099df57;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $f7f32ea09725ee93$export$6ce2f08d515512;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $f7f32ea09725ee93$export$951c8378cdfec6e6;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $f7f32ea09725ee93$export$1a4097b876a13bf7;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$f872d8bba1c0f79f$exports, "Timestamp", function() {
    return $f7f32ea09725ee93$export$d9bcbd5e1ff81430;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $f7f32ea09725ee93$export$506c8e8f8c8edda;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $f7f32ea09725ee93$export$3ae94a2503e890a1;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$f872d8bba1c0f79f$exports, "changeYear", function() {
    return $f7f32ea09725ee93$export$7e1c707225b48c34;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $f7f32ea09725ee93$export$62ad822b3a5fd9a0;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$f872d8bba1c0f79f$exports, "changeDate", function() {
    return $f7f32ea09725ee93$export$9e85258502147ffb;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$f872d8bba1c0f79f$exports, "makeDateRange", function() {
    return $f7f32ea09725ee93$export$3c1f2e5bc03748e2;
});
var $f7f32ea09725ee93$export$c489aa6f7fd82b1a = 1000;
var $f7f32ea09725ee93$export$cbd942915f33be50 = $f7f32ea09725ee93$export$c489aa6f7fd82b1a * 60;
var $f7f32ea09725ee93$export$9b886f8493244014 = $f7f32ea09725ee93$export$cbd942915f33be50 * 15;
var $f7f32ea09725ee93$export$e99cbb807a5bb10d = $f7f32ea09725ee93$export$9b886f8493244014 * 4;
var $f7f32ea09725ee93$export$7a9a31a911eb9a20 = $f7f32ea09725ee93$export$e99cbb807a5bb10d * 24;
var $f7f32ea09725ee93$export$fca4f8121099df57 = $f7f32ea09725ee93$export$7a9a31a911eb9a20 * 7;
var $f7f32ea09725ee93$export$6ce2f08d515512 = $f7f32ea09725ee93$export$7a9a31a911eb9a20 * 365;
var $f7f32ea09725ee93$export$951c8378cdfec6e6 = $f7f32ea09725ee93$export$6ce2f08d515512 / 12;
var $f7f32ea09725ee93$export$1a4097b876a13bf7 = $f7f32ea09725ee93$export$951c8378cdfec6e6 * 3;
var $f7f32ea09725ee93$export$d9bcbd5e1ff81430 = /*#__PURE__*/ function($6a9944941b4c1893$export$595dbf49c602a1f) {
    "use strict";
    (0, $hdIku._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430, $6a9944941b4c1893$export$595dbf49c602a1f);
    function $f872d8bba1c0f79f$export$d9bcbd5e1ff81430() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $f872d8bba1c0f79f$export$d9bcbd5e1ff81430);
        var _this;
        _this = (0, $7qXGD._)(this, $f872d8bba1c0f79f$export$d9bcbd5e1ff81430, (0, $aUGqu._)(args)), _this.units = [
            {
                base: $f7f32ea09725ee93$export$c489aa6f7fd82b1a,
                name: 's'
            },
            {
                base: $f7f32ea09725ee93$export$cbd942915f33be50,
                name: 'm'
            },
            {
                base: $f7f32ea09725ee93$export$e99cbb807a5bb10d,
                name: 'H'
            },
            {
                base: $f7f32ea09725ee93$export$7a9a31a911eb9a20,
                name: 'D'
            },
            {
                base: $f7f32ea09725ee93$export$fca4f8121099df57,
                name: 'W'
            },
            {
                base: $f7f32ea09725ee93$export$951c8378cdfec6e6,
                name: 'M'
            },
            {
                base: $f7f32ea09725ee93$export$6ce2f08d515512,
                name: 'Y'
            }
        ];
        return _this;
    }
    (0, $cFHGC._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430, [
        {
            key: "toShortString",
            value: function toShortString() {
                var fractionDigits = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                return (0, $dWsrg._)((0, $kg0zo._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430.prototype), "toShortString", this).call(this, fractionDigits);
            }
        }
    ]);
    return $f872d8bba1c0f79f$export$d9bcbd5e1ff81430;
}($f7f32ea09725ee93$export$595dbf49c602a1f);
function $f7f32ea09725ee93$export$506c8e8f8c8edda(end) {
    var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    var timeDistance = $f7f32ea09725ee93$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    var _timeDistance_toShortString_split = (0, $f9AOD._)(timeDistance.toShortString().split(/\s+/), 2), value = _timeDistance_toShortString_split[0], unit = _timeDistance_toShortString_split[1];
    return {
        distance: +value,
        unit: unit
    };
}
function $f7f32ea09725ee93$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + '';
    return function(template) {
        return (value.length < template.length ? value.padStart(template.length, '0') : value).slice(-Math.max(template.length, 2));
    };
}
function $f7f32ea09725ee93$export$3ae94a2503e890a1() {
    var time = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date(), template = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';
    var date = new Date(time);
    var localDate = new Date(+date - date.getTimezoneOffset() * $f7f32ea09725ee93$export$cbd942915f33be50);
    var _localDate_toJSON_split = (0, $f9AOD._)(localDate.toJSON().split(/\D/), 7), year = _localDate_toJSON_split[0], month = _localDate_toJSON_split[1], day = _localDate_toJSON_split[2], hour = _localDate_toJSON_split[3], minute = _localDate_toJSON_split[4], second = _localDate_toJSON_split[5], millisecond = _localDate_toJSON_split[6];
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $f7f32ea09725ee93$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $f7f32ea09725ee93$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $f7f32ea09725ee93$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $f7f32ea09725ee93$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $f7f32ea09725ee93$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $f7f32ea09725ee93$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $f7f32ea09725ee93$export$7e1c707225b48c34(date, delta) {
    date = new Date(date);
    date.setFullYear(date.getFullYear() + delta);
    return date;
}
function $f7f32ea09725ee93$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    var month = date.getMonth() + delta;
    date = $f7f32ea09725ee93$export$7e1c707225b48c34(date, Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
var $f7f32ea09725ee93$export$9e85258502147ffb = function(date, unit, delta) {
    return unit === $f7f32ea09725ee93$export$6ce2f08d515512 ? $f7f32ea09725ee93$export$7e1c707225b48c34(date, delta) : unit === $f7f32ea09725ee93$export$951c8378cdfec6e6 ? $f7f32ea09725ee93$export$62ad822b3a5fd9a0(date, delta) : new Date(+new Date(date) + delta * unit);
};
var $f7f32ea09725ee93$var$$f872d8bba1c0f79f$var$DateLength2Unit = {
    4: $f7f32ea09725ee93$export$6ce2f08d515512,
    7: $f7f32ea09725ee93$export$951c8378cdfec6e6,
    10: $f7f32ea09725ee93$export$7a9a31a911eb9a20,
    13: $f7f32ea09725ee93$export$e99cbb807a5bb10d,
    16: $f7f32ea09725ee93$export$cbd942915f33be50,
    19: $f7f32ea09725ee93$export$c489aa6f7fd82b1a
};
function $f7f32ea09725ee93$export$3c1f2e5bc03748e2(value) {
    var defaultValue = "2025-01-01T00:00:00.000Z";
    var startedAt = new Date(value + defaultValue.slice(value.length));
    var endedAt = $f7f32ea09725ee93$export$9e85258502147ffb(startedAt, $f7f32ea09725ee93$var$$f872d8bba1c0f79f$var$DateLength2Unit[value.length], 1);
    return [
        startedAt,
        endedAt
    ];
}
var $f7f32ea09725ee93$var$$ba0e5dc395660a7c$exports = {};
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $f7f32ea09725ee93$export$27924e57e9afff7f;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $f7f32ea09725ee93$export$7ea17d45ecdcf634;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$ba0e5dc395660a7c$exports, "stringifyTextTable", function() {
    return $f7f32ea09725ee93$export$bf304e455230454a;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $f7f32ea09725ee93$export$bb8626e4916f587b;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$ba0e5dc395660a7c$exports, "parseTextTableAsync", function() {
    return $f7f32ea09725ee93$export$88182f6768071c72;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$ba0e5dc395660a7c$exports, "readTextTable", function() {
    return $f7f32ea09725ee93$export$2427785258f88523;
});
function $f7f32ea09725ee93$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === 'string' && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            var date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    var value = parseItem(raw);
    if (typeof value !== 'string' || $f7f32ea09725ee93$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, function(key, value) {
            return parseItem(value);
        });
    } catch (e) {
        return raw;
    }
}
function $f7f32ea09725ee93$export$7ea17d45ecdcf634(raw) {
    var parsed = $f7f32ea09725ee93$export$27924e57e9afff7f(raw);
    if (typeof parsed !== 'string') return parsed;
    var number = +parsed;
    return Number.isNaN(number) || number + '' !== parsed ? parsed : number;
}
var $f7f32ea09725ee93$export$bf304e455230454a = function(data) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ',';
    return [
        Object.keys(data[0]).join(separator)
    ].concat((0, $aUGqu._)(data.map(function(item) {
        return Object.values(item).map(function(value) {
            return JSON.stringify(value);
        }).join(separator);
    }))).join('\n');
};
function $f7f32ea09725ee93$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    var quote = raw[0];
    var index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError("A ".concat(quote, " is missing"));
    return raw.slice(1, index);
}
function $f7f32ea09725ee93$var$$ba0e5dc395660a7c$var$parseRow(row) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ',';
    var list = [];
    do {
        var value = void 0;
        if (row[0] === '"' || row[0] === "'") {
            value = $f7f32ea09725ee93$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
            row = row.slice(value.length + 3);
        } else {
            var index = row.indexOf(separator);
            if (index > -1) {
                value = row.slice(0, index);
                row = row.slice(index + 1);
            } else {
                value = row;
                row = '';
            }
        }
        list.push($f7f32ea09725ee93$export$7ea17d45ecdcf634(value.trim()));
    }while (row);
    return list;
}
function $f7f32ea09725ee93$export$bb8626e4916f587b(raw, header) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ',';
    var data = raw.trim().split(/[\r\n]+/).map(function(row) {
        return $f7f32ea09725ee93$var$$ba0e5dc395660a7c$var$parseRow(row, separator);
    });
    return !header ? data : data.slice(1).map(function(row) {
        return $f7f32ea09725ee93$export$1c8ba402144543e5(row, data[0]);
    });
}
var $f7f32ea09725ee93$export$88182f6768071c72 = function(raw) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        return (0, $13u2V._)(this, function(_state) {
            return [
                2,
                Array.fromAsync($f7f32ea09725ee93$export$2427785258f88523(raw[Symbol.iterator]()))
            ];
        });
    })();
};
function $f7f32ea09725ee93$var$$ba0e5dc395660a7c$var$characterStream(chunks) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        8,
                        13
                    ]);
                    _iterator = (0, $dafVd._)(chunks);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $dm3mz._)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        6
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        5,
                        (0, $Csf8W.__values)((0, $jAEAr._)((0, $dafVd._)(chunk)))
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 6:
                    return [
                        3,
                        13
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        13
                    ];
                case 8:
                    _state.trys.push([
                        8,
                        ,
                        11,
                        12
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        (0, $dm3mz._)(_iterator.return())
                    ];
                case 9:
                    _state.sent();
                    _state.label = 10;
                case 10:
                    return [
                        3,
                        12
                    ];
                case 11:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        7
                    ];
                case 13:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $f7f32ea09725ee93$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ',';
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function() {
        var inQuote, quoteChar, prevChar, cellBuffer, currentRow, completeCell, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, char, err;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    inQuote = false;
                    quoteChar = '';
                    prevChar = '';
                    cellBuffer = '';
                    currentRow = [];
                    completeCell = function() {
                        currentRow.push($f7f32ea09725ee93$export$7ea17d45ecdcf634(cellBuffer.trim()));
                        cellBuffer = '';
                    };
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $dafVd._)(chars);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $dm3mz._)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    char = _value;
                    if (!(char === '\n' || char === '\r')) return [
                        3,
                        6
                    ];
                    if (char === '\n' && prevChar === '\r') {
                        prevChar = char;
                        return [
                            3,
                            8
                        ];
                    }
                    completeCell();
                    if (!(currentRow.length > 1 || currentRow[0])) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        currentRow
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    currentRow = [];
                    return [
                        3,
                        7
                    ];
                case 6:
                    if ((char === '"' || char === "'") && !inQuote && cellBuffer.trim() === '') {
                        inQuote = true;
                        quoteChar = char;
                    } else if (char === quoteChar && inQuote) {
                        inQuote = false;
                        quoteChar = '';
                    } else if (inQuote) cellBuffer += char;
                    else if (char === separator) completeCell();
                    else cellBuffer += char;
                    _state.label = 7;
                case 7:
                    prevChar = char;
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        (0, $dm3mz._)(_iterator.return())
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!(cellBuffer || currentRow.length > 0)) return [
                        3,
                        18
                    ];
                    completeCell();
                    if (!(currentRow.length > 1 || currentRow[0])) return [
                        3,
                        18
                    ];
                    return [
                        4,
                        currentRow
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $f7f32ea09725ee93$export$2427785258f88523(chunks, header) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ',';
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function() {
        var headerRow, isFirstRow, chars, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, row, err;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    isFirstRow = true;
                    chars = $f7f32ea09725ee93$var$$ba0e5dc395660a7c$var$characterStream(chunks);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $dafVd._)($f7f32ea09725ee93$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $dm3mz._)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    row = _value;
                    if (!(header && isFirstRow)) return [
                        3,
                        4
                    ];
                    headerRow = row;
                    isFirstRow = false;
                    return [
                        3,
                        6
                    ];
                case 4:
                    return [
                        4,
                        header && headerRow ? $f7f32ea09725ee93$export$1c8ba402144543e5(row, headerRow) : row
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        (0, $dm3mz._)(_iterator.return())
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        2
                    ];
            }
        });
    })();
}
var $f7f32ea09725ee93$var$$083124ac4b1a50a0$exports = {};
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $f7f32ea09725ee93$export$71e6483fc2b024eb;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $f7f32ea09725ee93$export$eb9b2aadbe449a20;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $f7f32ea09725ee93$export$13397a83aa5915d6;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $f7f32ea09725ee93$export$fd89523fba250fa4;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $f7f32ea09725ee93$export$504fbde693c1771c;
});
var $f7f32ea09725ee93$export$71e6483fc2b024eb = function(URI) {
    return new URL(URI, document.baseURI).origin !== location.origin;
};
function $f7f32ea09725ee93$export$eb9b2aadbe449a20() {
    var raw = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
        var _globalThis_location;
        return ((_globalThis_location = globalThis.location) === null || _globalThis_location === void 0 ? void 0 : _globalThis_location.search) || '';
    }(), toBuiltIn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var rawData = raw.split('#').map(function(URI) {
        var _URI_split = (0, $f9AOD._)(URI.split('?'), 2), before = _URI_split[0], after = _URI_split[1];
        return new URLSearchParams(after || (before.includes('=') ? before : ''));
    }).join('&');
    var data = new URLSearchParams(rawData);
    return Object.fromEntries((0, $aUGqu._)(data.keys()).map(function(key) {
        var list = toBuiltIn ? data.getAll(key).map($f7f32ea09725ee93$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
var $f7f32ea09725ee93$var$$083124ac4b1a50a0$var$stringify = function(value) {
    return typeof value === 'string' ? value : $f7f32ea09725ee93$export$b5a4d6f439a5044d(value) ? $f7f32ea09725ee93$export$7b85fd78dd236198(value) + '' : JSON.stringify(value);
};
function $f7f32ea09725ee93$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    var list = map.map(function(param) {
        var _param = (0, $f9AOD._)(param, 2), key = _param[0], value = _param[1];
        return !$f7f32ea09725ee93$export$dd1bc94b04021eeb(value) && [
            key,
            $f7f32ea09725ee93$var$$083124ac4b1a50a0$var$stringify(value)
        ];
    }).filter(Boolean);
    return new URLSearchParams(list);
}
var $f7f32ea09725ee93$export$fd89523fba250fa4 = function(URI) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(URI + '')
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().blob()
                    ];
            }
        });
    })();
};
var $f7f32ea09725ee93$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $f7f32ea09725ee93$export$504fbde693c1771c(URI) {
    var _ref = (0, $f9AOD._)($f7f32ea09725ee93$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [], 5), _ = _ref[0], type = _ref[1], __ = _ref[2], base64 = _ref[3], data = _ref[4];
    data = base64 ? atob(data) : data;
    var aBuffer = Uint8Array.from(data, function(char) {
        return char.charCodeAt(0);
    });
    return new Blob([
        aBuffer
    ], {
        type: type
    });
}
var $f7f32ea09725ee93$var$$d677628cc2ac1e37$exports = {};
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$d677628cc2ac1e37$exports, "parseCookie", function() {
    return $f7f32ea09725ee93$export$d0eaf3e94be578f6;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$d677628cc2ac1e37$exports, "setCookie", function() {
    return $f7f32ea09725ee93$export$110700823644f4a6;
});
var $f7f32ea09725ee93$export$d0eaf3e94be578f6 = function() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
        var _globalThis_document;
        return (_globalThis_document = globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.cookie;
    }();
    return value ? Object.fromEntries(value.split(/;\s*/).map(function(item) {
        return item.split('=');
    })) : {};
};
function $f7f32ea09725ee93$export$110700823644f4a6(key, value) {
    var attributes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var data = "".concat(key, "=").concat(value), option = Object.entries(attributes).map(function(param) {
        var _param = (0, $f9AOD._)(param, 2), _$key = _param[0], _$value = _param[1];
        return typeof _$value === 'boolean' ? _$value ? _$key : '' : "".concat(_$key, "=").concat(_$value);
    }).filter(Boolean).join('; ');
    document.cookie = "".concat(data, "; expires=").concat(new Date(0));
    return document.cookie = "".concat(data, "; ").concat(option);
}
var $f7f32ea09725ee93$var$$50872bf213056663$exports = {};
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $f7f32ea09725ee93$export$1b9ac4d3de3ffd2e;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$50872bf213056663$exports, "makeSHA", function() {
    return $f7f32ea09725ee93$export$d51f3b55e8d1aa73;
});
var $f7f32ea09725ee93$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), function(_, cell) {
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $f7f32ea09725ee93$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = raw[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var char = _step.value;
            value = value >> 8 & 0x00ffffff ^ $f7f32ea09725ee93$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return '0x' + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if ((typeof self === "undefined" ? "undefined" : (0, $7E0eS._)(self)) === 'object') {
    if ('msCrypto' in globalThis) {
        var $f7f32ea09725ee93$var$_loop = function(key) {
            var origin = $f7f32ea09725ee93$var$subtle[key];
            if (origin instanceof Function) $f7f32ea09725ee93$var$subtle[key] = function() {
                var observer = origin.apply(this, arguments);
                return new Promise(function(resolve, reject) {
                    observer.oncomplete = function(param) {
                        var target = param.target;
                        return resolve(target.result);
                    };
                    observer.onabort = observer.onerror = reject;
                });
            };
        };
        // @ts-ignore
        var $f7f32ea09725ee93$var$_ref = globalThis.crypto = globalThis.msCrypto, $f7f32ea09725ee93$var$subtle = $f7f32ea09725ee93$var$_ref.subtle;
        for(var $f7f32ea09725ee93$var$key in $f7f32ea09725ee93$var$subtle)$f7f32ea09725ee93$var$_loop($f7f32ea09725ee93$var$key);
    }
    var $f7f32ea09725ee93$var$crypto1 = globalThis.crypto;
    if (!($f7f32ea09725ee93$var$crypto1 === null || $f7f32ea09725ee93$var$crypto1 === void 0 ? void 0 : $f7f32ea09725ee93$var$crypto1.subtle) && ($f7f32ea09725ee93$var$crypto1 === null || $f7f32ea09725ee93$var$crypto1 === void 0 ? void 0 : $f7f32ea09725ee93$var$crypto1['webkitSubtle'])) $f7f32ea09725ee93$var$crypto1.subtle = $f7f32ea09725ee93$var$crypto1['webkitSubtle'];
}
function $f7f32ea09725ee93$export$d51f3b55e8d1aa73(raw) {
    var algorithm = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'SHA-1';
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var buffer;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        crypto.subtle.digest(algorithm, new TextEncoder().encode(raw))
                    ];
                case 1:
                    buffer = _state.sent();
                    return [
                        2,
                        Array.from(new Uint8Array(buffer), function(byte) {
                            return byte.toString(16).padStart(2, '0');
                        }).join('')
                    ];
            }
        });
    })();
}
var $f7f32ea09725ee93$var$$93a3089d2937b23f$exports = {};
var $f7f32ea09725ee93$var$$3e0a089cc13f69ad$exports = {};
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$3e0a089cc13f69ad$exports, "XMLNamespace", function() {
    return $f7f32ea09725ee93$export$f5a4056b78c72efa;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $f7f32ea09725ee93$export$2ee022bbbc550b25;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $f7f32ea09725ee93$export$a549dd5cef7f8327;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $f7f32ea09725ee93$export$8eece510bcb9c62c;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $f7f32ea09725ee93$export$b8a1af58c024fefd;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $f7f32ea09725ee93$export$a2cf0d4bb6e06de4;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $f7f32ea09725ee93$export$d66b332881d9723f;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $f7f32ea09725ee93$export$b0709844452f8b6b;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $f7f32ea09725ee93$export$5118471ee5d5453b;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$3e0a089cc13f69ad$exports, "inViewport", function() {
    return $f7f32ea09725ee93$export$6e196edbcc00e5bc;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $f7f32ea09725ee93$export$be4650432daa84fd;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $f7f32ea09725ee93$export$578e38b4a3e0b255;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $f7f32ea09725ee93$export$7cd14c57bbb84350;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $f7f32ea09725ee93$export$5100419dfae0456d;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $f7f32ea09725ee93$export$28d9d24a8cd0ffc2;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $f7f32ea09725ee93$export$3f99968195accfaf;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $f7f32ea09725ee93$export$eafdbaa868ea9975;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $f7f32ea09725ee93$export$36a0c1ca2ae264fa;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $f7f32ea09725ee93$export$86d7c59254d6a2c9;
});
var $f7f32ea09725ee93$export$f5a4056b78c72efa = {
    html: 'http://www.w3.org/1999/xhtml',
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
var $f7f32ea09725ee93$var$$3e0a089cc13f69ad$var$templateMap = {};
function $f7f32ea09725ee93$export$2ee022bbbc550b25(tagName) {
    if ($f7f32ea09725ee93$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $f7f32ea09725ee93$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    var spawn = document.createElement('template');
    spawn.innerHTML = "<".concat(tagName, " />");
    return $f7f32ea09725ee93$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $f7f32ea09725ee93$export$a549dd5cef7f8327(tagName) {
    if (tagName.includes('-')) return 'html';
    var _tagName_split = (0, $f9AOD._)(tagName.split(':'), 2), prefix = _tagName_split[0], localName = _tagName_split[1];
    if (localName) return prefix === 'html' ? 'html' : 'xml';
    var node = $f7f32ea09725ee93$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? 'html' : 'xml';
}
var $f7f32ea09725ee93$export$8eece510bcb9c62c = function(Class) {
    return $f7f32ea09725ee93$export$170f4e08cad8229d(Class, HTMLElement);
};
var $f7f32ea09725ee93$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $f7f32ea09725ee93$export$b8a1af58c024fefd(Class) {
    var name = $f7f32ea09725ee93$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var _ref = new Class(), tagName = _ref.tagName;
    $f7f32ea09725ee93$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $f7f32ea09725ee93$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ var ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                'sizes'
            ]
        ],
        [
            HTMLIFrameElement,
            [
                'sandbox'
            ]
        ],
        [
            HTMLObjectElement,
            [
                'form'
            ]
        ],
        [
            HTMLInputElement,
            [
                'form',
                'list'
            ]
        ],
        [
            HTMLButtonElement,
            [
                'form'
            ]
        ],
        [
            HTMLSelectElement,
            [
                'form'
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                'form'
            ]
        ],
        [
            HTMLOutputElement,
            [
                'form'
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                'form'
            ]
        ]
    ];
    var template = $f7f32ea09725ee93$export$2ee022bbbc550b25(tagName);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ReadOnly_Properties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $f9AOD._)(_step.value, 2), Class = _step_value[0], keys = _step_value[1];
            if (template instanceof Class && keys.includes(propertyName)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $f7f32ea09725ee93$export$d66b332881d9723f(HTML) {
    var spawn = document.createElement('template');
    spawn.innerHTML = HTML;
    return (0, $aUGqu._)(spawn.content.childNodes).map(function(node) {
        node.remove();
        return node;
    });
}
var $f7f32ea09725ee93$export$b0709844452f8b6b = function(node) {
    return new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, '');
};
function $f7f32ea09725ee93$export$5118471ee5d5453b(root, type) {
    var children, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, node, err;
    return (0, $13u2V._)(this, function(_state) {
        switch(_state.label){
            case 0:
                children = (0, $aUGqu._)(root.childNodes);
                if (!($f7f32ea09725ee93$export$dd1bc94b04021eeb(type) || type === root.nodeType)) return [
                    3,
                    2
                ];
                return [
                    4,
                    root
                ];
            case 1:
                _state.sent();
                _state.label = 2;
            case 2:
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    8,
                    9,
                    10
                ]);
                _iterator = children[Symbol.iterator]();
                _state.label = 4;
            case 4:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    7
                ];
                node = _step.value;
                return [
                    5,
                    (0, $Csf8W.__values)($f7f32ea09725ee93$export$5118471ee5d5453b(node, type))
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    4
                ];
            case 7:
                return [
                    3,
                    10
                ];
            case 8:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    10
                ];
            case 9:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
function $f7f32ea09725ee93$export$6e196edbcc00e5bc(element) {
    var _element_getBoundingClientRect = element.getBoundingClientRect(), left = _element_getBoundingClientRect.left, top = _element_getBoundingClientRect.top;
    return document.elementFromPoint(left, top) === element;
}
function $f7f32ea09725ee93$export$be4650432daa84fd(root) {
    var text = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $f7f32ea09725ee93$export$5118471ee5d5453b(root)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, nodeType = _step_value.nodeType, parentElement = _step_value.parentElement, nodeValue = _step_value.nodeValue;
            if (nodeType === Node.TEXT_NODE && parentElement.getAttribute('aria-hidden') !== 'true') {
                var _parentElement_getBoundingClientRect = parentElement.getBoundingClientRect(), width = _parentElement_getBoundingClientRect.width, height = _parentElement_getBoundingClientRect.height;
                if (width && height) text += nodeValue.trim().replace(/\s+/g, ' ');
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return text;
}
function $f7f32ea09725ee93$export$578e38b4a3e0b255(param) {
    var offsetWidth = param.offsetWidth, children = param.children, pageHeight = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 841.89, pageWidth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 595.28;
    var scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return (0, $aUGqu._)(children).reduce(function(pages, node) {
        var _pages, _bottomIndex;
        var top = node.offsetTop, height = node.offsetHeight;
        top += offset;
        var bottom = top + height;
        var bottomOffset = bottom / scrollHeight;
        var topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        ((_pages = pages)[_bottomIndex = bottomIndex] || (_pages[_bottomIndex] = [])).push(node);
        return pages;
    }, []);
}
function $f7f32ea09725ee93$export$7cd14c57bbb84350(URI) {
    var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var alternate = _param.alternate, options = (0, $6acIq._)(_param, [
        "alternate"
    ]);
    var style = (0, $aUGqu._)(document.styleSheets).find(function(param) {
        var href = param.href;
        return href === URI;
    });
    if (style) return Promise.resolve(style);
    var link = document.createElement('link');
    return new Promise(function(resolve, reject) {
        link.onload = function() {
            return resolve(link.sheet);
        };
        link.onerror = function(_1, _2, _3, _4, error) {
            return reject(error);
        };
        Object.assign(link, options);
        link.rel = (alternate ? 'alternate ' : '') + 'stylesheet';
        link.href = URI;
        document.head.append(link);
    });
}
function $f7f32ea09725ee93$export$5100419dfae0456d(data) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, indent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '    ';
    var padding = indent.repeat(depth);
    return Object.entries(data).map(function(param) {
        var _param = (0, $f9AOD._)(param, 2), key = _param[0], value = _param[1];
        return (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) !== 'object' ? "".concat(padding).concat($f7f32ea09725ee93$export$3f34ca2fef821bbd(key), ": ").concat(value, ";") : "".concat(padding).concat(key, " {\n").concat($f7f32ea09725ee93$export$5100419dfae0456d(value, depth + 1, indent), "\n").concat(padding, "}");
    }).join('\n');
}
function $f7f32ea09725ee93$export$28d9d24a8cd0ffc2() {
    for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++){
        nodes[_key] = arguments[_key];
    }
    var _fragment, _node;
    var fragment = document.createDocumentFragment();
    (_fragment = fragment).append.apply(_fragment, (0, $aUGqu._)(nodes));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $f7f32ea09725ee93$export$5118471ee5d5453b(fragment)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var node = _step.value;
            if (![
                1,
                3,
                11
            ].includes(node.nodeType) || [
                'meta',
                'title',
                'link',
                'script'
            ].includes(node.nodeName.toLowerCase())) (_node = node).replaceWith.apply(_node, (0, $aUGqu._)(node.childNodes));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var selection = globalThis.getSelection();
    if (!selection) return;
    var range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $f7f32ea09725ee93$export$3f99968195accfaf(selector, root, align, justify) {
    var _querySelector;
    var _ref = (0, $f9AOD._)(/^#(.+)/.exec(selector) || [], 2), _ = _ref[0], ID = _ref[1];
    if (ID === 'top') window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
    else (_querySelector = (root || document).querySelector(ID ? '[id="'.concat(ID, '"]') : selector)) === null || _querySelector === void 0 ? void 0 : _querySelector.scrollIntoView({
        behavior: 'smooth',
        block: align,
        inline: justify
    });
}
var $f7f32ea09725ee93$export$eafdbaa868ea9975 = function(box, handler) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 6;
    return Array.from(box.querySelectorAll(Array.from(new Array(depth), function(_, index) {
        return "h".concat(++index);
    }) + ''), function(header) {
        new IntersectionObserver(function(param) {
            var _param = (0, $f9AOD._)(param, 1), item = _param[0];
            if (!item.isIntersecting) return;
            var target = item.target;
            handler({
                target: target,
                links: (0, $aUGqu._)(target.ownerDocument.querySelectorAll('[href="#'.concat(target.id, '"]')))
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, '-');
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
};
function $f7f32ea09725ee93$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === 'visible' ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(function(param) {
        var _param = (0, $f9AOD._)(param, 1), _param_ = _param[0], isIntersecting = _param_.isIntersecting;
        return change(isIntersecting ? last | 2 : last & 1);
    }).observe(root);
    document.addEventListener('visibilitychange', function() {
        return change(document.visibilityState === 'visible' ? last | 1 : last & 2);
    });
}
function $f7f32ea09725ee93$export$86d7c59254d6a2c9(form) {
    var elements = form.elements, data = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var field = _step.value;
            var name = field.name, value = field.value, checked = field.checked, defaultValue = field.defaultValue, selectedOptions = field.selectedOptions, files = field.files;
            var type = field.type;
            if (!name || value === '') continue;
            var box = type !== 'fieldset' && field.closest('fieldset');
            if (box && box !== form) continue;
            var parsedValue = value;
            switch(type){
                case 'radio':
                case 'checkbox':
                    if (checked) parsedValue = !defaultValue || $f7f32ea09725ee93$export$7ea17d45ecdcf634(defaultValue);
                    else if ($f7f32ea09725ee93$export$b5a4d6f439a5044d(elements.namedItem(name))) continue;
                    else parsedValue = false;
                    break;
                case 'select-multiple':
                    parsedValue = Array.from(selectedOptions, function(param) {
                        var value = param.value;
                        return $f7f32ea09725ee93$export$7ea17d45ecdcf634(value);
                    });
                    break;
                case 'fieldset':
                    parsedValue = $f7f32ea09725ee93$export$86d7c59254d6a2c9(field);
                    break;
                case 'file':
                    parsedValue = files && Array.from(files);
                    break;
                case 'date':
                case 'datetime-local':
                case 'month':
                case 'hidden':
                case 'number':
                case 'range':
                case 'select-one':
                    parsedValue = $f7f32ea09725ee93$export$7ea17d45ecdcf634(value);
            }
            if (name in data) data[name] = [].concat(data[name], parsedValue);
            else data[name] = !(parsedValue instanceof Array) || !$f7f32ea09725ee93$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return data;
}
var $f7f32ea09725ee93$var$$bb23e0c794fefbef$exports = {};
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $f7f32ea09725ee93$export$e772c8ff12451969;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $f7f32ea09725ee93$export$57207d71b8c929c8;
});
function $f7f32ea09725ee93$export$e772c8ff12451969() {
    var seconds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    return new Promise(function(resolve) {
        return setTimeout(resolve, seconds * 1000);
    });
}
function $f7f32ea09725ee93$export$57207d71b8c929c8(executor) {
    var seconds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var stop = false;
    (function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var result;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!stop) return [
                            3,
                            4
                        ];
                        result = executor();
                        if (!(result instanceof Promise)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            result
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            $f7f32ea09725ee93$export$e772c8ff12451969(seconds)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    })();
    return function() {
        return stop = true;
    };
}
var $f7f32ea09725ee93$var$$19ed8aeb7905a045$exports = {};
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $f7f32ea09725ee93$export$10b1921597150314;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $f7f32ea09725ee93$export$3e2b244719956741;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $f7f32ea09725ee93$export$1d1d2ed6b55cf67f;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $f7f32ea09725ee93$export$2155c0b5a4b77fb8;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $f7f32ea09725ee93$export$9d97473344489dfc;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $f7f32ea09725ee93$export$d635d04af3887bbe;
});
function $f7f32ea09725ee93$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
var $f7f32ea09725ee93$export$3e2b244719956741 = typeof window !== 'undefined' ? new Promise(function(resolve) {
    var _document;
    function done() {
        var _document;
        (_document = document) === null || _document === void 0 ? void 0 : _document.removeEventListener('DOMContentLoaded', done);
        window.removeEventListener('load', done);
        resolve();
    }
    (_document = document) === null || _document === void 0 ? void 0 : _document.addEventListener('DOMContentLoaded', done);
    window.addEventListener('load', done);
    setTimeout(function check() {
        var _document;
        ((_document = document) === null || _document === void 0 ? void 0 : _document.readyState) === 'complete' ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $f7f32ea09725ee93$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise(function(resolve, reject) {
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + 'end', end);
            element.removeEventListener(scope + 'cancel', cancel);
        }
        element.addEventListener(scope + 'end', end);
        element.addEventListener(scope + 'cancel', cancel);
    });
}
function $f7f32ea09725ee93$export$2155c0b5a4b77fb8(handlers) {
    function server(_param) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var _param_data, type, id, source, origin, data, _handlers_type, result;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _param_data = _param.data, type = _param_data.type, id = _param_data.id, source = _param.source, origin = _param.origin, data = (0, $6acIq._)(_param.data, [
                            "type",
                            "id"
                        ]);
                        result = (_handlers_type = handlers[type]) === null || _handlers_type === void 0 ? void 0 : _handlers_type.call(handlers, data);
                        if (!(result instanceof Promise)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            result
                        ];
                    case 1:
                        result = _state.sent();
                        _state.label = 2;
                    case 2:
                        // @ts-ignore
                        source.postMessage((0, $6fpqi._)((0, $1XAnY._)({}, result), {
                            id: id
                        }), origin);
                        return [
                            2
                        ];
                }
            });
        })();
    }
    globalThis.addEventListener('message', server);
    return function() {
        return globalThis.removeEventListener('message', server);
    };
}
function $f7f32ea09725ee93$export$9d97473344489dfc(target) {
    var origin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '*';
    return function(type, data) {
        return new Promise(function(resolve) {
            var UID = $f7f32ea09725ee93$export$89912e019eef22aa();
            function handler(_param) {
                var _param_data = _param.data, id = _param_data.id, _$data = (0, $6acIq._)(_param.data, [
                    "id"
                ]);
                if (id !== UID) return;
                resolve(_$data);
                globalThis.removeEventListener('message', handler);
            }
            globalThis.addEventListener('message', handler);
            // @ts-ignore
            target.postMessage((0, $1XAnY._)({
                id: UID,
                type: type
            }, data), origin);
        });
    };
}
function $f7f32ea09725ee93$export$d635d04af3887bbe(registration) {
    return new Promise(function(resolve) {
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = function() {
            var _registration_installing;
            return (_registration_installing = registration.installing) === null || _registration_installing === void 0 ? void 0 : _registration_installing.addEventListener('statechange', function() {
                if (this.state === 'installed' && navigator.serviceWorker.controller) resolve(this);
            });
        };
    });
}
var $f7f32ea09725ee93$var$$7a08303ce13c49c5$exports = {};
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $f7f32ea09725ee93$export$1b88f6b6d432a52a;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $f7f32ea09725ee93$export$b70f6380221b1350;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $f7f32ea09725ee93$export$75d6cbe4503e149;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $f7f32ea09725ee93$export$b2618d51188815c2;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $f7f32ea09725ee93$export$490814474ddbb428;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $f7f32ea09725ee93$export$3ea201dffb50dfef;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $f7f32ea09725ee93$export$d1012c7198c6b460;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $f7f32ea09725ee93$export$a35a418b7b17958e;
});
var $f7f32ea09725ee93$export$1b88f6b6d432a52a = /*#__PURE__*/ function() {
    "use strict";
    function $7a08303ce13c49c5$export$1b88f6b6d432a52a(from, to) {
        (0, $173N4._)(this, $7a08303ce13c49c5$export$1b88f6b6d432a52a);
        this.from = from;
        this.to = to;
    }
    (0, $cFHGC._)($7a08303ce13c49c5$export$1b88f6b6d432a52a, [
        {
            key: "length",
            get: function get() {
                var _this = this, from = _this.from, to = _this.to;
                return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - from.z, 2) : 0));
            }
        },
        {
            key: "direction",
            get: function get() {
                var _this = this, from = _this.from, to = _this.to;
                var XD = to.x - from.x, YD = to.y - from.y, ZD = to.z - from.z;
                var XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
                switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
                    case XL:
                        return XD > 0 ? 'right' : 'left';
                    case YL:
                        return YD > 0 ? 'forward' : 'backward';
                    case ZL:
                        return ZD > 0 ? 'up' : 'down';
                }
            }
        }
    ]);
    return $7a08303ce13c49c5$export$1b88f6b6d432a52a;
}();
function $f7f32ea09725ee93$export$b70f6380221b1350(from, to) {
    var threshold = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : parseInt(getComputedStyle(document.body).fontSize) * 6;
    var _getSelection;
    var vector = new $f7f32ea09725ee93$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !((_getSelection = getSelection()) === null || _getSelection === void 0 ? void 0 : _getSelection.toString().trim())) return vector;
}
function $f7f32ea09725ee93$export$75d6cbe4503e149(type, element) {
    var _getComputedStyle = getComputedStyle(element), transitionDuration = _getComputedStyle.transitionDuration, animationDuration = _getComputedStyle.animationDuration;
    var duration = type === 'animation' ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === 'ms' ? 1 : 1000);
}
function $f7f32ea09725ee93$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $f7f32ea09725ee93$export$1d1d2ed6b55cf67f(type, element).catch(function(event) {
            return Promise.resolve(event);
        }),
        new Promise(function(resolve) {
            return setTimeout(resolve, $f7f32ea09725ee93$export$75d6cbe4503e149(type, element));
        })
    ]);
}
function $f7f32ea09725ee93$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    var end = $f7f32ea09725ee93$export$b2618d51188815c2(type, element);
    return new Promise(function(resolve) {
        return requestAnimationFrame(function() {
            element.classList.add(className);
            end.then(resolve);
        });
    });
}
function $f7f32ea09725ee93$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var end;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = $f7f32ea09725ee93$export$b2618d51188815c2(type, element);
                    element.classList.remove(className);
                    return [
                        4,
                        end
                    ];
                case 1:
                    _state.sent();
                    if (remove) element.remove();
                    else element.style.display = 'none';
                    return [
                        2
                    ];
            }
        });
    })();
}
function $f7f32ea09725ee93$export$490814474ddbb428(element, className) {
    var display = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'block';
    return $f7f32ea09725ee93$var$$7a08303ce13c49c5$var$fadeIn('transition', element, className, display);
}
function $f7f32ea09725ee93$export$3ea201dffb50dfef(element, className) {
    var display = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'block';
    return $f7f32ea09725ee93$var$$7a08303ce13c49c5$var$fadeIn('animation', element, className, display);
}
function $f7f32ea09725ee93$export$d1012c7198c6b460(element, className, remove) {
    return $f7f32ea09725ee93$var$$7a08303ce13c49c5$var$fadeOut('transition', element, className, remove);
}
function $f7f32ea09725ee93$export$a35a418b7b17958e(element, className, remove) {
    return $f7f32ea09725ee93$var$$7a08303ce13c49c5$var$fadeOut('animation', element, className, remove);
}
var $f7f32ea09725ee93$var$$69bd9f0117925302$exports = {};
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$69bd9f0117925302$exports, "describe", function() {
    return $f7f32ea09725ee93$export$cd5450f3a47e3789;
});
$f7f32ea09725ee93$var$$parcel$export($f7f32ea09725ee93$var$$69bd9f0117925302$exports, "it", function() {
    return $f7f32ea09725ee93$export$3486a10f30cf1ee4;
});
function $f7f32ea09725ee93$export$cd5450f3a47e3789(title, cases) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.log(title);
                    console.time(title);
                    return [
                        4,
                        cases()
                    ];
                case 1:
                    _state.sent();
                    console.timeEnd(title);
                    return [
                        2
                    ];
            }
        });
    })();
}
function $f7f32ea09725ee93$export$3486a10f30cf1ee4(title, userCase) {
    var secondsOut = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var expect, timeOut;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    title = '    ' + title;
                    console.time(title);
                    expect = function(status) {
                        var assert = typeof status === 'function' ? status : undefined;
                        var _assert;
                        status = (_assert = assert === null || assert === void 0 ? void 0 : assert()) !== null && _assert !== void 0 ? _assert : status;
                        if (!status) throw new Error("Assertion failed: ".concat(title, "\n\n").concat(assert || ''));
                    };
                    timeOut = function() {
                        return $f7f32ea09725ee93$export$e772c8ff12451969(secondsOut).then(function() {
                            return Promise.reject(new RangeError('Timed out'));
                        });
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    return [
                        4,
                        Promise.race([
                            userCase(expect),
                            timeOut()
                        ])
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    console.timeEnd(title);
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}

});


parcelRegister("glFKd", function(module, exports) {

module.exports = (parcelRequire("e8PZf"))($parcel$resolve("fshZK")).then(function() {
    return parcelRequire('BWRo5');
});

});

parcelRegister("9xvOC", function(module, exports) {

module.exports = (parcelRequire("e8PZf"))($parcel$resolve("8cJhl")).then(function() {
    return parcelRequire('hByxG');
});

});

parcelRegister("cSRQI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96144c89e28b8727$export$2e2bcd8739ae039; });
var $96144c89e28b8727$var$config = {
    ReadableStream: globalThis.ReadableStream,
    WritableStream: globalThis.WritableStream,
    TransformStream: globalThis.TransformStream,
    DOMException: globalThis.DOMException,
    Blob: globalThis.Blob,
    File: globalThis.File
};
var $96144c89e28b8727$export$2e2bcd8739ae039 = $96144c89e28b8727$var$config;

});

parcelRegister("k2i9B", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "FileSystemDirectoryHandle", function () { return $e962138bbd6c9e57$export$80c69d2381792bb3; });
$parcel$export(module.exports, "default", function () { return $e962138bbd6c9e57$export$2e2bcd8739ae039; });

var $jAEAr = parcelRequire("jAEAr");

var $dafVd = parcelRequire("dafVd");

var $3gP77 = parcelRequire("3gP77");

var $dm3mz = parcelRequire("dm3mz");

var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $2Ysl1 = parcelRequire("2Ysl1");

var $cFHGC = parcelRequire("cFHGC");

var $7Pjls = parcelRequire("7Pjls");

var $hdIku = parcelRequire("hdIku");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $7t5yo = parcelRequire("7t5yo");

var $13u2V = parcelRequire("13u2V");

var $Csf8W = parcelRequire("Csf8W");

var $33uF2 = parcelRequire("33uF2");

var $2taKJ = parcelRequire("2taKJ");
var $e962138bbd6c9e57$var$GONE = (0, $2taKJ.errors).GONE, $e962138bbd6c9e57$var$MOD_ERR = (0, $2taKJ.errors).MOD_ERR;
var $e962138bbd6c9e57$var$kAdapter = Symbol('adapter');
var $e962138bbd6c9e57$var$_kAdapter = $e962138bbd6c9e57$var$kAdapter;



var $e962138bbd6c9e57$export$80c69d2381792bb3 = /*#__PURE__*/ function(FileSystemHandle) {
    "use strict";
    (0, $hdIku._)(FileSystemDirectoryHandle, FileSystemHandle);
    function FileSystemDirectoryHandle(adapter) {
        (0, $173N4._)(this, FileSystemDirectoryHandle);
        var _this;
        _this = (0, $7qXGD._)(this, FileSystemDirectoryHandle, [
            adapter
        ]), /** @type {FileSystemDirectoryHandle} */ (0, $7Pjls._)(_this, $e962138bbd6c9e57$var$_kAdapter, void 0);
        _this[$e962138bbd6c9e57$var$kAdapter] = adapter;
        return _this;
    }
    (0, $cFHGC._)(FileSystemDirectoryHandle, [
        {
            key: "getDirectoryHandle",
            value: /**
   * @param {string} name Name of the directory
   * @param {object} [options]
   * @param {boolean} [options.create] create the directory if don't exist
   * @returns {Promise<FileSystemDirectoryHandle>}
   */ function getDirectoryHandle(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function(name) {
                    var options, handle;
                    var _arguments = arguments;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                                if (name === '') throw new TypeError("Name can't be an empty string.");
                                if (name === '.' || name === '..' || name.includes('/')) throw new TypeError("Name contains invalid characters.");
                                options.create = !!options.create;
                                return [
                                    4,
                                    this[$e962138bbd6c9e57$var$kAdapter].getDirectoryHandle(name, options)
                                ];
                            case 1:
                                handle = _state.sent();
                                return [
                                    2,
                                    new FileSystemDirectoryHandle(handle)
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "entries",
            value: /** @returns {AsyncGenerator<[string, FileSystemHandle | FileSystemDirectoryHandle]>} */ function entries() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function() {
                    var FileSystemFileHandle, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, _value1, _, entry, err;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $dm3mz._)(Promise.resolve((parcelRequire("ZBaWG"))))
                                ];
                            case 1:
                                FileSystemFileHandle = _state.sent().FileSystemFileHandle;
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    8,
                                    9,
                                    14
                                ]);
                                _iterator = (0, $dafVd._)(this[$e962138bbd6c9e57$var$kAdapter].entries());
                                _state.label = 3;
                            case 3:
                                return [
                                    4,
                                    (0, $dm3mz._)(_iterator.next())
                                ];
                            case 4:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    7
                                ];
                                _value = _step.value;
                                _value1 = (0, $f9AOD._)(_value, 2), _ = _value1[0], entry = _value1[1];
                                return [
                                    4,
                                    [
                                        entry.name,
                                        entry.kind === 'file' ? new FileSystemFileHandle(entry) : new FileSystemDirectoryHandle(entry)
                                    ]
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    3
                                ];
                            case 7:
                                return [
                                    3,
                                    14
                                ];
                            case 8:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    14
                                ];
                            case 9:
                                _state.trys.push([
                                    9,
                                    ,
                                    12,
                                    13
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    11
                                ];
                                return [
                                    4,
                                    (0, $dm3mz._)(_iterator.return())
                                ];
                            case 10:
                                _state.sent();
                                _state.label = 11;
                            case 11:
                                return [
                                    3,
                                    13
                                ];
                            case 12:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 13:
                                return [
                                    7
                                ];
                            case 14:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getEntries",
            value: /** @deprecated use .entries() instead */ function getEntries() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function() {
                    var FileSystemFileHandle, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, entry, err;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $dm3mz._)(Promise.resolve((parcelRequire("ZBaWG"))))
                                ];
                            case 1:
                                FileSystemFileHandle = _state.sent().FileSystemFileHandle;
                                console.warn('deprecated, use .entries() instead');
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    8,
                                    9,
                                    14
                                ]);
                                _iterator = (0, $dafVd._)(this[$e962138bbd6c9e57$var$kAdapter].entries());
                                _state.label = 3;
                            case 3:
                                return [
                                    4,
                                    (0, $dm3mz._)(_iterator.next())
                                ];
                            case 4:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    7
                                ];
                                _value = _step.value;
                                entry = _value;
                                return [
                                    4,
                                    entry.kind === 'file' ? new FileSystemFileHandle(entry) : new FileSystemDirectoryHandle(entry)
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    3
                                ];
                            case 7:
                                return [
                                    3,
                                    14
                                ];
                            case 8:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    14
                                ];
                            case 9:
                                _state.trys.push([
                                    9,
                                    ,
                                    12,
                                    13
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    11
                                ];
                                return [
                                    4,
                                    (0, $dm3mz._)(_iterator.return())
                                ];
                            case 10:
                                _state.sent();
                                _state.label = 11;
                            case 11:
                                return [
                                    3,
                                    13
                                ];
                            case 12:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 13:
                                return [
                                    7
                                ];
                            case 14:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getFileHandle",
            value: /**
   * @param {string} name Name of the file
   * @param {object} [options]
   * @param {boolean} [options.create] create the file if don't exist
   */ function getFileHandle(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function(name) {
                    var options, FileSystemFileHandle, handle;
                    var _arguments = arguments;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                                return [
                                    4,
                                    Promise.resolve((parcelRequire("ZBaWG")))
                                ];
                            case 1:
                                FileSystemFileHandle = _state.sent().FileSystemFileHandle;
                                if (name === '') throw new TypeError("Name can't be an empty string.");
                                if (name === '.' || name === '..' || name.includes('/')) throw new TypeError("Name contains invalid characters.");
                                options.create = !!options.create;
                                return [
                                    4,
                                    this[$e962138bbd6c9e57$var$kAdapter].getFileHandle(name, options)
                                ];
                            case 2:
                                handle = _state.sent();
                                return [
                                    2,
                                    new FileSystemFileHandle(handle)
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "removeEntry",
            value: /**
   * @param {string} name
   * @param {object} [options]
   * @param {boolean} [options.recursive]
   */ function removeEntry(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function(name) {
                    var options;
                    var _arguments = arguments;
                    return (0, $13u2V._)(this, function(_state) {
                        options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        if (name === '') throw new TypeError("Name can't be an empty string.");
                        if (name === '.' || name === '..' || name.includes('/')) throw new TypeError("Name contains invalid characters.");
                        options.recursive = !!options.recursive // cuz node's fs.rm require boolean
                        ;
                        return [
                            2,
                            this[$e962138bbd6c9e57$var$kAdapter].removeEntry(name, options)
                        ];
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "resolve",
            value: function resolve(possibleDescendant) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var openSet, _openSet_pop, current, path, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, entry, err;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    possibleDescendant.isSameEntry(this)
                                ];
                            case 1:
                                if (_state.sent()) return [
                                    2,
                                    []
                                ];
                                openSet = [
                                    {
                                        handle: this,
                                        path: []
                                    }
                                ];
                                _state.label = 2;
                            case 2:
                                if (!openSet.length) return [
                                    3,
                                    16
                                ];
                                _openSet_pop = openSet.pop(), current = _openSet_pop.handle, path = _openSet_pop.path;
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    9,
                                    10,
                                    15
                                ]);
                                _iterator = (0, $dafVd._)(current.values());
                                _state.label = 4;
                            case 4:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 5:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    8
                                ];
                                _value = _step.value;
                                entry = _value;
                                return [
                                    4,
                                    entry.isSameEntry(possibleDescendant)
                                ];
                            case 6:
                                if (_state.sent()) return [
                                    2,
                                    (0, $aUGqu._)(path).concat([
                                        entry.name
                                    ])
                                ];
                                if (entry.kind === 'directory') openSet.push({
                                    handle: entry,
                                    path: (0, $aUGqu._)(path).concat([
                                        entry.name
                                    ])
                                });
                                _state.label = 7;
                            case 7:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    4
                                ];
                            case 8:
                                return [
                                    3,
                                    15
                                ];
                            case 9:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    15
                                ];
                            case 10:
                                _state.trys.push([
                                    10,
                                    ,
                                    13,
                                    14
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    12
                                ];
                                return [
                                    4,
                                    _iterator.return()
                                ];
                            case 11:
                                _state.sent();
                                _state.label = 12;
                            case 12:
                                return [
                                    3,
                                    14
                                ];
                            case 13:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 14:
                                return [
                                    7
                                ];
                            case 15:
                                return [
                                    3,
                                    2
                                ];
                            case 16:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "keys",
            value: function keys() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, _value1, name, err;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $dafVd._)(this[$e962138bbd6c9e57$var$kAdapter].entries());
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    (0, $dm3mz._)(_iterator.next())
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                _value1 = (0, $f9AOD._)(_value, 1), name = _value1[0];
                                return [
                                    4,
                                    name
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    (0, $dm3mz._)(_iterator.return())
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "values",
            value: function values() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function() {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, _value1, _, entry, err;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $dafVd._)(this);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    (0, $dm3mz._)(_iterator.next())
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                _value1 = (0, $f9AOD._)(_value, 2), _ = _value1[0], entry = _value1[1];
                                return [
                                    4,
                                    entry
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    (0, $dm3mz._)(_iterator.return())
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: Symbol.asyncIterator,
            value: function value() {
                return this.entries();
            }
        }
    ]);
    return FileSystemDirectoryHandle;
}((0, $33uF2.default));
Object.defineProperty($e962138bbd6c9e57$export$80c69d2381792bb3.prototype, Symbol.toStringTag, {
    value: 'FileSystemDirectoryHandle',
    writable: false,
    enumerable: false,
    configurable: true
});
Object.defineProperties($e962138bbd6c9e57$export$80c69d2381792bb3.prototype, {
    getDirectoryHandle: {
        enumerable: true
    },
    entries: {
        enumerable: true
    },
    getFileHandle: {
        enumerable: true
    },
    removeEntry: {
        enumerable: true
    }
});
if (globalThis.FileSystemDirectoryHandle) {
    var $e962138bbd6c9e57$var$proto = globalThis.FileSystemDirectoryHandle.prototype;
    $e962138bbd6c9e57$var$proto.resolve = function resolve(possibleDescendant) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var openSet, _openSet_pop, current, path, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, entry, err;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            possibleDescendant.isSameEntry(this)
                        ];
                    case 1:
                        if (_state.sent()) return [
                            2,
                            []
                        ];
                        openSet = [
                            {
                                handle: this,
                                path: []
                            }
                        ];
                        _state.label = 2;
                    case 2:
                        if (!openSet.length) return [
                            3,
                            16
                        ];
                        _openSet_pop = openSet.pop(), current = _openSet_pop.handle, path = _openSet_pop.path;
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            9,
                            10,
                            15
                        ]);
                        _iterator = (0, $dafVd._)(current.values());
                        _state.label = 4;
                    case 4:
                        return [
                            4,
                            _iterator.next()
                        ];
                    case 5:
                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                            3,
                            8
                        ];
                        _value = _step.value;
                        entry = _value;
                        return [
                            4,
                            entry.isSameEntry(possibleDescendant)
                        ];
                    case 6:
                        if (_state.sent()) return [
                            2,
                            (0, $aUGqu._)(path).concat([
                                entry.name
                            ])
                        ];
                        if (entry.kind === 'directory') openSet.push({
                            handle: entry,
                            path: (0, $aUGqu._)(path).concat([
                                entry.name
                            ])
                        });
                        _state.label = 7;
                    case 7:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            4
                        ];
                    case 8:
                        return [
                            3,
                            15
                        ];
                    case 9:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            15
                        ];
                    case 10:
                        _state.trys.push([
                            10,
                            ,
                            13,
                            14
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                            3,
                            12
                        ];
                        return [
                            4,
                            _iterator.return()
                        ];
                    case 11:
                        _state.sent();
                        _state.label = 12;
                    case 12:
                        return [
                            3,
                            14
                        ];
                    case 13:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 14:
                        return [
                            7
                        ];
                    case 15:
                        return [
                            3,
                            2
                        ];
                    case 16:
                        return [
                            2,
                            null
                        ];
                }
            });
        }).call(this);
    };
    // Safari allows us operate on deleted files,
    // so we need to check if they still exist.
    // Hope to remove this one day.
    function ensureDoActuallyStillExist(handle) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var root, path;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            navigator.storage.getDirectory()
                        ];
                    case 1:
                        root = _state.sent();
                        return [
                            4,
                            root.resolve(handle)
                        ];
                    case 2:
                        path = _state.sent();
                        if (path === null) throw (0, $2Ysl1._)(DOMException, (0, $aUGqu._)($e962138bbd6c9e57$var$GONE));
                        return [
                            2
                        ];
                }
            });
        })();
    }
    var $e962138bbd6c9e57$var$entries = $e962138bbd6c9e57$var$proto.entries;
    $e962138bbd6c9e57$var$proto.entries = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function() {
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $dm3mz._)(ensureDoActuallyStillExist(this))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            5,
                            (0, $Csf8W.__values)((0, $jAEAr._)((0, $dafVd._)($e962138bbd6c9e57$var$entries.call(this))))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    };
    $e962138bbd6c9e57$var$proto[Symbol.asyncIterator] = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function() {
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            5,
                            (0, $Csf8W.__values)((0, $jAEAr._)((0, $dafVd._)(this.entries())))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        }).call(this);
    };
    var $e962138bbd6c9e57$var$removeEntry = $e962138bbd6c9e57$var$proto.removeEntry;
    $e962138bbd6c9e57$var$proto.removeEntry = function(_0) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function(name) {
            var _this, options;
            var _arguments = arguments;
            return (0, $13u2V._)(this, function(_state) {
                _this = this;
                options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                return [
                    2,
                    $e962138bbd6c9e57$var$removeEntry.call(this, name, options).catch(function(err) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                            var unknown, empty;
                            return (0, $13u2V._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        unknown = err instanceof DOMException && err.name === 'UnknownError';
                                        if (!(unknown && !options.recursive)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $e962138bbd6c9e57$var$entries.call(this).next()
                                        ];
                                    case 1:
                                        empty = _state.sent().done;
                                        if (!empty) throw (0, $2Ysl1._)(DOMException, (0, $aUGqu._)($e962138bbd6c9e57$var$MOD_ERR));
                                        _state.label = 2;
                                    case 2:
                                        throw err;
                                }
                            });
                        }).call(_this);
                    })
                ];
            });
        }).apply(this, arguments);
    };
}
var $e962138bbd6c9e57$export$2e2bcd8739ae039 = $e962138bbd6c9e57$export$80c69d2381792bb3;

});
parcelRegister("33uF2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23996f836b5e69a5$export$2e2bcd8739ae039; });

var $3gP77 = parcelRequire("3gP77");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7Pjls = parcelRequire("7Pjls");

var $7E0eS = parcelRequire("7E0eS");

var $13u2V = parcelRequire("13u2V");
var $23996f836b5e69a5$var$_globalThis_FileSystemHandle_prototype;
var $23996f836b5e69a5$var$kAdapter = Symbol('adapter');
var $23996f836b5e69a5$var$_kAdapter = $23996f836b5e69a5$var$kAdapter;
/**
 * @typedef {Object} FileSystemHandlePermissionDescriptor
 * @property {('read'|'readwrite')} [mode='read']
 */ var $23996f836b5e69a5$export$90d155f9f7c2d644 = /*#__PURE__*/ function() {
    "use strict";
    function FileSystemHandle(adapter) {
        (0, $173N4._)(this, FileSystemHandle);
        /** @type {FileSystemHandle} */ (0, $7Pjls._)(this, $23996f836b5e69a5$var$_kAdapter, void 0);
        /** @type {string} */ (0, $7Pjls._)(this, "name", void 0);
        /** @type {('file'|'directory')} */ (0, $7Pjls._)(this, "kind", void 0);
        this.kind = adapter.kind;
        this.name = adapter.name;
        this[$23996f836b5e69a5$var$kAdapter] = adapter;
    }
    (0, $cFHGC._)(FileSystemHandle, [
        {
            key: "queryPermission",
            value: /** @param {FileSystemHandlePermissionDescriptor} descriptor */ function queryPermission() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var descriptor, _descriptor_mode, mode, handle;
                    var _arguments = arguments;
                    return (0, $13u2V._)(this, function(_state) {
                        descriptor = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                        _descriptor_mode = descriptor.mode, mode = _descriptor_mode === void 0 ? 'read' : _descriptor_mode;
                        handle = this[$23996f836b5e69a5$var$kAdapter];
                        if (handle.queryPermission) return [
                            2,
                            handle.queryPermission({
                                mode: mode
                            })
                        ];
                        if (mode === 'read') return [
                            2,
                            'granted'
                        ];
                        else if (mode === 'readwrite') return [
                            2,
                            handle.writable ? 'granted' : 'denied'
                        ];
                        else throw new TypeError("Mode ".concat(mode, " must be 'read' or 'readwrite'"));
                        return [
                            2
                        ];
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "requestPermission",
            value: function requestPermission() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _ref, _ref_mode, mode, handle;
                    var _arguments = arguments;
                    return (0, $13u2V._)(this, function(_state) {
                        _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_mode = _ref.mode, mode = _ref_mode === void 0 ? 'read' : _ref_mode;
                        handle = this[$23996f836b5e69a5$var$kAdapter];
                        if (handle.requestPermission) return [
                            2,
                            handle.requestPermission({
                                mode: mode
                            })
                        ];
                        if (mode === 'read') return [
                            2,
                            'granted'
                        ];
                        else if (mode === 'readwrite') return [
                            2,
                            handle.writable ? 'granted' : 'denied'
                        ];
                        else throw new TypeError("Mode ".concat(mode, " must be 'read' or 'readwrite'"));
                        return [
                            2
                        ];
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "remove",
            value: /**
   * Attempts to remove the entry represented by handle from the underlying file system.
   *
   * @param {object} options
   * @param {boolean} [options.recursive=false]
   */ function remove() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var options;
                    var _arguments = arguments;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                                return [
                                    4,
                                    this[$23996f836b5e69a5$var$kAdapter].remove(options)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "isSameEntry",
            value: /**
   * @param {FileSystemHandle} other
   */ function isSameEntry(other) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    return (0, $13u2V._)(this, function(_state) {
                        if (this === other) return [
                            2,
                            true
                        ];
                        if (!other || (typeof other === "undefined" ? "undefined" : (0, $7E0eS._)(other)) !== 'object' || this.kind !== other.kind || !other[$23996f836b5e69a5$var$kAdapter]) return [
                            2,
                            false
                        ];
                        return [
                            2,
                            this[$23996f836b5e69a5$var$kAdapter].isSameEntry(other[$23996f836b5e69a5$var$kAdapter])
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return FileSystemHandle;
}();
Object.defineProperty($23996f836b5e69a5$export$90d155f9f7c2d644.prototype, Symbol.toStringTag, {
    value: 'FileSystemHandle',
    writable: false,
    enumerable: false,
    configurable: true
});
var $23996f836b5e69a5$var$_queryPermission;
// Safari safari doesn't support writable streams yet.
if (globalThis.FileSystemHandle) ($23996f836b5e69a5$var$_queryPermission = ($23996f836b5e69a5$var$_globalThis_FileSystemHandle_prototype = globalThis.FileSystemHandle.prototype).queryPermission) !== null && $23996f836b5e69a5$var$_queryPermission !== void 0 ? $23996f836b5e69a5$var$_queryPermission : $23996f836b5e69a5$var$_globalThis_FileSystemHandle_prototype.queryPermission = function(descriptor) {
    return 'granted';
};
var $23996f836b5e69a5$export$2e2bcd8739ae039 = $23996f836b5e69a5$export$90d155f9f7c2d644;

});

parcelRegister("2taKJ", function(module, exports) {

$parcel$export(module.exports, "errors", function () { return $1cc6a1753cd9a307$export$30f3b02011db23c0; });
$parcel$export(module.exports, "config", function () { return $1cc6a1753cd9a307$export$e506a1d27d1eaa20; });
$parcel$export(module.exports, "fromDataTransfer", function () { return $1cc6a1753cd9a307$export$34af8373a76882c2; });
$parcel$export(module.exports, "getDirHandlesFromInput", function () { return $1cc6a1753cd9a307$export$7d17e35d81e093f2; });
$parcel$export(module.exports, "getFileHandlesFromInput", function () { return $1cc6a1753cd9a307$export$45ac616e835cfe89; });

var $3gP77 = parcelRequire("3gP77");

var $f9AOD = parcelRequire("f9AOD");

var $13u2V = parcelRequire("13u2V");
var $1cc6a1753cd9a307$export$30f3b02011db23c0 = {
    INVALID: [
        'seeking position failed.',
        'InvalidStateError'
    ],
    GONE: [
        'A requested file or directory could not be found at the time an operation was processed.',
        'NotFoundError'
    ],
    MISMATCH: [
        'The path supplied exists, but was not an entry of requested type.',
        'TypeMismatchError'
    ],
    MOD_ERR: [
        'The object can not be modified in this way.',
        'InvalidModificationError'
    ],
    SYNTAX: function(m) {
        return [
            "Failed to execute 'write' on 'UnderlyingSinkBase': Invalid params passed. ".concat(m),
            'SyntaxError'
        ];
    },
    SECURITY: [
        'It was determined that certain files are unsafe for access within a Web application, or that too many calls are being made on file resources.',
        'SecurityError'
    ],
    DISALLOWED: [
        'The request is not allowed by the user agent or the platform in the current context.',
        'NotAllowedError'
    ]
};
var $1cc6a1753cd9a307$export$e506a1d27d1eaa20 = {
    writable: globalThis.WritableStream
};



function $1cc6a1753cd9a307$export$34af8373a76882c2(entries) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var _ref, memory, sandbox, fs, folder;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.warn('deprecated fromDataTransfer - use `dt.items[0].getAsFileSystemHandle()` instead');
                    return [
                        4,
                        Promise.all([
                            (parcelRequire("ZM9GY")),
                            (parcelRequire("9xvOC")),
                            Promise.resolve((parcelRequire("k2i9B")))
                        ])
                    ];
                case 1:
                    _ref = (0, $f9AOD._).apply(void 0, [
                        _state.sent(),
                        3
                    ]), memory = _ref[0], sandbox = _ref[1], fs = _ref[2];
                    folder = new memory.FolderHandle('', false);
                    folder._entries = entries.map(function(entry) {
                        return entry.isFile ? new sandbox.FileHandle(entry, false) : new sandbox.FolderHandle(entry, false);
                    });
                    return [
                        2,
                        new fs.FileSystemDirectoryHandle(folder)
                    ];
            }
        });
    })();
}


function $1cc6a1753cd9a307$export$7d17e35d81e093f2(input) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var _ref, FolderHandle, FileHandle, FileSystemDirectoryHandle, files, rootName, root;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (parcelRequire("ZM9GY"))
                    ];
                case 1:
                    _ref = _state.sent(), FolderHandle = _ref.FolderHandle, FileHandle = _ref.FileHandle;
                    return [
                        4,
                        Promise.resolve((parcelRequire("k2i9B")))
                    ];
                case 2:
                    FileSystemDirectoryHandle = _state.sent().FileSystemDirectoryHandle;
                    files = Array.from(input.files);
                    rootName = files[0].webkitRelativePath.split('/', 1)[0];
                    root = new FolderHandle(rootName, false);
                    files.forEach(function(file) {
                        var path = file.webkitRelativePath.split('/');
                        path.shift();
                        var name = path.pop();
                        var dir = path.reduce(function(dir, path) {
                            if (!dir._entries[path]) dir._entries[path] = new FolderHandle(path, false);
                            return dir._entries[path];
                        }, root);
                        dir._entries[name] = new FileHandle(file.name, file, false);
                    });
                    return [
                        2,
                        new FileSystemDirectoryHandle(root)
                    ];
            }
        });
    })();
}


function $1cc6a1753cd9a307$export$45ac616e835cfe89(input) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var FileHandle, FileSystemFileHandle;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (parcelRequire("ZM9GY"))
                    ];
                case 1:
                    FileHandle = _state.sent().FileHandle;
                    return [
                        4,
                        Promise.resolve((parcelRequire("ZBaWG")))
                    ];
                case 2:
                    FileSystemFileHandle = _state.sent().FileSystemFileHandle;
                    return [
                        2,
                        Array.from(input.files).map(function(file) {
                            return new FileSystemFileHandle(new FileHandle(file.name, file, false));
                        })
                    ];
            }
        });
    })();
}

});
parcelRegister("ZM9GY", function(module, exports) {

module.exports = (parcelRequire("e8PZf"))($parcel$resolve("5qKZE")).then(function() {
    return parcelRequire('aFkMI');
});

});

parcelRegister("ZBaWG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "FileSystemFileHandle", function () { return $0b9288e863d75e76$export$db2751aad7d8e0f3; });
$parcel$export(module.exports, "default", function () { return $0b9288e863d75e76$export$2e2bcd8739ae039; });

var $3gP77 = parcelRequire("3gP77");

var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $2Ysl1 = parcelRequire("2Ysl1");

var $cFHGC = parcelRequire("cFHGC");

var $7Pjls = parcelRequire("7Pjls");

var $hdIku = parcelRequire("hdIku");

var $1XAnY = parcelRequire("1XAnY");

var $aUGqu = parcelRequire("aUGqu");

var $13u2V = parcelRequire("13u2V");

var $33uF2 = parcelRequire("33uF2");

var $9CUQs = parcelRequire("9CUQs");

var $2taKJ = parcelRequire("2taKJ");
var $0b9288e863d75e76$var$INVALID = (0, $2taKJ.errors).INVALID, $0b9288e863d75e76$var$SYNTAX = (0, $2taKJ.errors).SYNTAX, $0b9288e863d75e76$var$GONE = (0, $2taKJ.errors).GONE;
var $0b9288e863d75e76$var$kAdapter = Symbol('adapter');
var $0b9288e863d75e76$var$_kAdapter = $0b9288e863d75e76$var$kAdapter;
var $0b9288e863d75e76$export$db2751aad7d8e0f3 = /*#__PURE__*/ function(FileSystemHandle) {
    "use strict";
    (0, $hdIku._)(FileSystemFileHandle, FileSystemHandle);
    function FileSystemFileHandle(adapter) {
        (0, $173N4._)(this, FileSystemFileHandle);
        var _this;
        _this = (0, $7qXGD._)(this, FileSystemFileHandle, [
            adapter
        ]), /** @type {FileSystemFileHandle} */ (0, $7Pjls._)(_this, $0b9288e863d75e76$var$_kAdapter, void 0);
        _this[$0b9288e863d75e76$var$kAdapter] = adapter;
        return _this;
    }
    (0, $cFHGC._)(FileSystemFileHandle, [
        {
            key: "createWritable",
            value: /**
   * @param  {Object} [options={}]
   * @param  {boolean} [options.keepExistingData]
   * @returns {Promise<FileSystemWritableFileStream>}
   */ function createWritable() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var options, _;
                    var _arguments = arguments;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                                _ = (0, $9CUQs.default).bind;
                                return [
                                    4,
                                    this[$0b9288e863d75e76$var$kAdapter].createWritable(options)
                                ];
                            case 1:
                                return [
                                    2,
                                    new (_.apply((0, $9CUQs.default), [
                                        void 0,
                                        _state.sent()
                                    ]))
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "getFile",
            value: /**
   * @returns {Promise<File>}
   */ function getFile() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    return (0, $13u2V._)(this, function(_state) {
                        return [
                            2,
                            this[$0b9288e863d75e76$var$kAdapter].getFile()
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return FileSystemFileHandle;
}((0, $33uF2.default));
Object.defineProperty($0b9288e863d75e76$export$db2751aad7d8e0f3.prototype, Symbol.toStringTag, {
    value: 'FileSystemFileHandle',
    writable: false,
    enumerable: false,
    configurable: true
});
Object.defineProperties($0b9288e863d75e76$export$db2751aad7d8e0f3.prototype, {
    createWritable: {
        enumerable: true
    },
    getFile: {
        enumerable: true
    }
});
// Safari doesn't support async createWritable streams yet.
if (globalThis.FileSystemFileHandle && !globalThis.FileSystemFileHandle.prototype.createWritable) {
    var $0b9288e863d75e76$var$wm = new WeakMap();
    var $0b9288e863d75e76$var$workerUrl;
    // Worker code that should be inlined (can't use any external functions)
    var $0b9288e863d75e76$var$code = function() {
        var fileHandle, handle;
        onmessage = function(evt) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var port, cmd, _, file, dir, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, folder, err;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            port = evt.ports[0];
                            cmd = evt.data;
                            _ = cmd.type;
                            switch(_){
                                case 'open':
                                    return [
                                        3,
                                        1
                                    ];
                                case 'write':
                                    return [
                                        3,
                                        13
                                    ];
                                case 'truncate':
                                    return [
                                        3,
                                        14
                                    ];
                                case 'abort':
                                    return [
                                        3,
                                        15
                                    ];
                                case 'close':
                                    return [
                                        3,
                                        15
                                    ];
                            }
                            return [
                                3,
                                16
                            ];
                        case 1:
                            file = cmd.name;
                            return [
                                4,
                                navigator.storage.getDirectory()
                            ];
                        case 2:
                            dir = _state.sent();
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                8,
                                9,
                                10
                            ]);
                            _iterator = cmd.path[Symbol.iterator]();
                            _state.label = 4;
                        case 4:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                7
                            ];
                            folder = _step.value;
                            return [
                                4,
                                dir.getDirectoryHandle(folder)
                            ];
                        case 5:
                            dir = _state.sent();
                            _state.label = 6;
                        case 6:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                4
                            ];
                        case 7:
                            return [
                                3,
                                10
                            ];
                        case 8:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                10
                            ];
                        case 9:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 10:
                            return [
                                4,
                                dir.getFileHandle(file)
                            ];
                        case 11:
                            fileHandle = _state.sent();
                            return [
                                4,
                                fileHandle.createSyncAccessHandle()
                            ];
                        case 12:
                            handle = _state.sent();
                            return [
                                3,
                                16
                            ];
                        case 13:
                            handle.write(cmd.data, {
                                at: cmd.position
                            });
                            handle.flush();
                            return [
                                3,
                                16
                            ];
                        case 14:
                            handle.truncate(cmd.size);
                            return [
                                3,
                                16
                            ];
                        case 15:
                            handle.close();
                            return [
                                3,
                                16
                            ];
                        case 16:
                            port.postMessage(0);
                            return [
                                2
                            ];
                    }
                });
            })();
        };
    };
    globalThis.FileSystemFileHandle.prototype.createWritable = function(options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var stringCode, blob, worker, position, textEncoder, size, send, root, parent, path, controller, ws;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Safari only support writing data in a worker with sync access handle.
                        if (!$0b9288e863d75e76$var$workerUrl) {
                            stringCode = "(".concat($0b9288e863d75e76$var$code.toString(), ")()");
                            blob = new Blob([
                                stringCode
                            ], {
                                type: 'text/javascript'
                            });
                            $0b9288e863d75e76$var$workerUrl = URL.createObjectURL(blob);
                        }
                        worker = new Worker($0b9288e863d75e76$var$workerUrl, {
                            type: 'module'
                        });
                        position = 0;
                        textEncoder = new TextEncoder();
                        return [
                            4,
                            this.getFile().then(function(file) {
                                return file.size;
                            })
                        ];
                    case 1:
                        size = _state.sent();
                        send = function(message) {
                            return new Promise(function(resolve, reject) {
                                var mc = new MessageChannel();
                                mc.port1.onmessage = function(evt) {
                                    if (evt.data instanceof Error) reject(evt.data);
                                    else resolve(evt.data);
                                    mc.port1.close();
                                    mc.port2.close();
                                    mc.port1.onmessage = null;
                                };
                                worker.postMessage(message, [
                                    mc.port2
                                ]);
                            });
                        };
                        return [
                            4,
                            navigator.storage.getDirectory()
                        ];
                    case 2:
                        root = _state.sent();
                        return [
                            4,
                            $0b9288e863d75e76$var$wm.get(this)
                        ];
                    case 3:
                        parent = _state.sent();
                        return [
                            4,
                            root.resolve(parent)
                        ];
                    case 4:
                        path = _state.sent();
                        // Should likely never happen, but just in case...
                        if (path === null) throw (0, $2Ysl1._)(DOMException, (0, $aUGqu._)($0b9288e863d75e76$var$GONE));
                        return [
                            4,
                            send({
                                type: 'open',
                                path: path,
                                name: this.name
                            })
                        ];
                    case 5:
                        _state.sent();
                        if (!((options === null || options === void 0 ? void 0 : options.keepExistingData) === false)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            send({
                                type: 'truncate',
                                size: 0
                            })
                        ];
                    case 6:
                        _state.sent();
                        size = 0;
                        _state.label = 7;
                    case 7:
                        ws = new (0, $9CUQs.default)({
                            start: function(ctrl) {
                                controller = ctrl;
                            },
                            write: function(chunk) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                    var isPlainObject, _chunk, _position, ab;
                                    return (0, $13u2V._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                isPlainObject = (chunk === null || chunk === void 0 ? void 0 : chunk.constructor) === Object;
                                                if (isPlainObject) chunk = (0, $1XAnY._)({}, chunk);
                                                else chunk = {
                                                    type: 'write',
                                                    data: chunk,
                                                    position: position
                                                };
                                                if (!(chunk.type === 'write')) return [
                                                    3,
                                                    8
                                                ];
                                                if (!!('data' in chunk)) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    send({
                                                        type: 'close'
                                                    })
                                                ];
                                            case 1:
                                                _state.sent();
                                                throw (0, $2Ysl1._)(DOMException, (0, $aUGqu._)($0b9288e863d75e76$var$SYNTAX('write requires a data argument')));
                                            case 2:
                                                (_position = (_chunk = chunk).position) !== null && _position !== void 0 ? _position : _chunk.position = position;
                                                if (!(typeof chunk.data === 'string')) return [
                                                    3,
                                                    3
                                                ];
                                                chunk.data = textEncoder.encode(chunk.data);
                                                return [
                                                    3,
                                                    7
                                                ];
                                            case 3:
                                                if (!(chunk.data instanceof ArrayBuffer)) return [
                                                    3,
                                                    4
                                                ];
                                                chunk.data = new Uint8Array(chunk.data);
                                                return [
                                                    3,
                                                    7
                                                ];
                                            case 4:
                                                if (!(!(chunk.data instanceof Uint8Array) && ArrayBuffer.isView(chunk.data))) return [
                                                    3,
                                                    5
                                                ];
                                                chunk.data = new Uint8Array(chunk.data.buffer, chunk.data.byteOffset, chunk.data.byteLength);
                                                return [
                                                    3,
                                                    7
                                                ];
                                            case 5:
                                                if (!!(chunk.data instanceof Uint8Array)) return [
                                                    3,
                                                    7
                                                ];
                                                return [
                                                    4,
                                                    new Response(chunk.data).arrayBuffer()
                                                ];
                                            case 6:
                                                ab = _state.sent();
                                                chunk.data = new Uint8Array(ab);
                                                _state.label = 7;
                                            case 7:
                                                if (Number.isInteger(chunk.position) && chunk.position >= 0) position = chunk.position;
                                                position += chunk.data.byteLength;
                                                size += chunk.data.byteLength;
                                                return [
                                                    3,
                                                    15
                                                ];
                                            case 8:
                                                if (!(chunk.type === 'seek')) return [
                                                    3,
                                                    12
                                                ];
                                                if (!(Number.isInteger(chunk.position) && chunk.position >= 0)) return [
                                                    3,
                                                    9
                                                ];
                                                if (size < chunk.position) throw (0, $2Ysl1._)(DOMException, (0, $aUGqu._)($0b9288e863d75e76$var$INVALID));
                                                console.log('seeking', chunk);
                                                position = chunk.position;
                                                return [
                                                    2
                                                ]; // Don't need to enqueue seek...
                                            case 9:
                                                return [
                                                    4,
                                                    send({
                                                        type: 'close'
                                                    })
                                                ];
                                            case 10:
                                                _state.sent();
                                                throw (0, $2Ysl1._)(DOMException, (0, $aUGqu._)($0b9288e863d75e76$var$SYNTAX('seek requires a position argument')));
                                            case 11:
                                                return [
                                                    3,
                                                    15
                                                ];
                                            case 12:
                                                if (!(chunk.type === 'truncate')) return [
                                                    3,
                                                    15
                                                ];
                                                if (!(Number.isInteger(chunk.size) && chunk.size >= 0)) return [
                                                    3,
                                                    13
                                                ];
                                                size = chunk.size;
                                                if (position > size) position = size;
                                                return [
                                                    3,
                                                    15
                                                ];
                                            case 13:
                                                return [
                                                    4,
                                                    send({
                                                        type: 'close'
                                                    })
                                                ];
                                            case 14:
                                                _state.sent();
                                                throw (0, $2Ysl1._)(DOMException, (0, $aUGqu._)($0b9288e863d75e76$var$SYNTAX('truncate requires a size argument')));
                                            case 15:
                                                return [
                                                    4,
                                                    send(chunk)
                                                ];
                                            case 16:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            },
                            close: function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                    return (0, $13u2V._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    send({
                                                        type: 'close'
                                                    })
                                                ];
                                            case 1:
                                                _state.sent();
                                                worker.terminate();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            },
                            abort: function(reason) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                    return (0, $13u2V._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    send({
                                                        type: 'abort',
                                                        reason: reason
                                                    })
                                                ];
                                            case 1:
                                                _state.sent();
                                                worker.terminate();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            }
                        });
                        return [
                            2,
                            ws
                        ];
                }
            });
        }).call(this);
    };
    var $0b9288e863d75e76$var$orig = FileSystemDirectoryHandle.prototype.getFileHandle;
    FileSystemDirectoryHandle.prototype.getFileHandle = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var _orig, handle;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (_orig = $0b9288e863d75e76$var$orig).call.apply(_orig, [
                                this
                            ].concat((0, $aUGqu._)(args)))
                        ];
                    case 1:
                        handle = _state.sent();
                        $0b9288e863d75e76$var$wm.set(handle, this);
                        return [
                            2,
                            handle
                        ];
                }
            });
        }).call(this);
    };
}
var $0b9288e863d75e76$export$2e2bcd8739ae039 = $0b9288e863d75e76$export$db2751aad7d8e0f3;

});
parcelRegister("9CUQs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7023c1ed9d1f5683$export$2e2bcd8739ae039; });

var $3gP77 = parcelRequire("3gP77");

var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $9QNeL = parcelRequire("9QNeL");

var $5stq2 = parcelRequire("5stq2");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");

var $1SdK7 = parcelRequire("1SdK7");

var $13u2V = parcelRequire("13u2V");

var $cSRQI = parcelRequire("cSRQI");
var $7023c1ed9d1f5683$var$WritableStream = (0, $cSRQI.default).WritableStream;
var $7023c1ed9d1f5683$var$_writer = /*#__PURE__*/ new WeakMap();
var $7023c1ed9d1f5683$export$fea83bdfcd3f94c = /*#__PURE__*/ function(WritableStream) {
    "use strict";
    (0, $hdIku._)(FileSystemWritableFileStream, WritableStream);
    function FileSystemWritableFileStream(writer) {
        (0, $173N4._)(this, FileSystemWritableFileStream);
        var _this;
        _this = (0, $7qXGD._)(this, FileSystemWritableFileStream, [
            writer
        ]), (0, $9QNeL._)(_this, $7023c1ed9d1f5683$var$_writer, {
            writable: true,
            value: void 0
        });
        (0, $5stq2._)(_this, $7023c1ed9d1f5683$var$_writer, writer);
        // Stupid Safari hack to extend native classes
        // https://bugs.webkit.org/show_bug.cgi?id=226201
        Object.setPrototypeOf(_this, FileSystemWritableFileStream.prototype);
        /** @private */ _this._closed = false;
        return _this;
    }
    (0, $cFHGC._)(FileSystemWritableFileStream, [
        {
            key: "close",
            value: function close() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var w, p;
                    return (0, $13u2V._)(this, function(_state) {
                        this._closed = true;
                        w = this.getWriter();
                        p = w.close();
                        w.releaseLock();
                        return [
                            2,
                            p
                        ];
                    });
                // return super.close ? super.close() : this.getWriter().close()
                }).call(this);
            }
        },
        {
            /** @param {number} position */ key: "seek",
            value: function seek(position) {
                return this.write({
                    type: 'seek',
                    position: position
                });
            }
        },
        {
            /** @param {number} size */ key: "truncate",
            value: function truncate(size) {
                return this.write({
                    type: 'truncate',
                    size: size
                });
            }
        },
        {
            // The write(data) method steps are:
            key: "write",
            value: function write(data) {
                if (this._closed) return Promise.reject(new TypeError('Cannot write to a CLOSED writable stream'));
                // 1. Let writer be the result of getting a writer for this.
                var writer = this.getWriter();
                // 2. Let result be the result of writing a chunk to writer given data.
                var result = writer.write(data);
                // 3. Release writer.
                writer.releaseLock();
                // 4. Return result.
                return result;
            }
        }
    ]);
    return FileSystemWritableFileStream;
}((0, $1SdK7._)($7023c1ed9d1f5683$var$WritableStream));
Object.defineProperty($7023c1ed9d1f5683$export$fea83bdfcd3f94c.prototype, Symbol.toStringTag, {
    value: 'FileSystemWritableFileStream',
    writable: false,
    enumerable: false,
    configurable: true
});
Object.defineProperties($7023c1ed9d1f5683$export$fea83bdfcd3f94c.prototype, {
    close: {
        enumerable: true
    },
    seek: {
        enumerable: true
    },
    truncate: {
        enumerable: true
    },
    write: {
        enumerable: true
    }
});
// Safari safari doesn't support writable streams yet.
if (globalThis.FileSystemFileHandle && !globalThis.FileSystemFileHandle.prototype.createWritable && !globalThis.FileSystemWritableFileStream) globalThis.FileSystemWritableFileStream = $7023c1ed9d1f5683$export$fea83bdfcd3f94c;
var $7023c1ed9d1f5683$export$2e2bcd8739ae039 = $7023c1ed9d1f5683$export$fea83bdfcd3f94c;

});
parcelRegister("9QNeL", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $72bf29d791b281e8$export$71511d61b312f219; });

var $5AGSS = parcelRequire("5AGSS");
function $72bf29d791b281e8$export$71511d61b312f219(obj, privateMap, value) {
    (0, $5AGSS._)(obj, privateMap);
    privateMap.set(obj, value);
}

});
parcelRegister("5AGSS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4121946ee3f78738$export$71511d61b312f219; });
function $4121946ee3f78738$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}

});


parcelRegister("5stq2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3f96634aace83525$export$71511d61b312f219; });

var $fpuuc = parcelRequire("fpuuc");

var $Exh2u = parcelRequire("Exh2u");
function $3f96634aace83525$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $Exh2u._)(receiver, privateMap, "set");
    (0, $fpuuc._)(receiver, descriptor, value);
    return value;
}

});
parcelRegister("fpuuc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b380d6b413158e0a$export$71511d61b312f219; });
function $b380d6b413158e0a$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}

});

parcelRegister("Exh2u", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $079d8c07c496cf50$export$71511d61b312f219; });
function $079d8c07c496cf50$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}

});






var $170f306dcfaf302b$exports = {};
$parcel$extendImportMap({
    "7JXq8": "zh-TW.0ae7138a.js",
    "9V63F": "en-US.cab2e276.js",
    "5qKZE": "memory.fdc5ec9e.js",
    "8cJhl": "sandbox.c534df64.js",
    "fshZK": "downloader.e244be99.js"
});


var $7E0eS = parcelRequire("7E0eS");

var $tLNoZ = parcelRequire("tLNoZ");
var $d35b2f3ed94b921d$var$t = /["&<]/;
function $d35b2f3ed94b921d$var$n(r) {
    if (0 === r.length || !1 === $d35b2f3ed94b921d$var$t.test(r)) return r;
    for(var e = 0, n = 0, o = "", f = ""; n < r.length; n++){
        switch(r.charCodeAt(n)){
            case 34:
                f = "&quot;";
                break;
            case 38:
                f = "&amp;";
                break;
            case 60:
                f = "&lt;";
                break;
            default:
                continue;
        }
        n !== e && (o += r.slice(e, n)), o += f, e = n + 1;
    }
    return n !== e && (o += r.slice(e, n)), o;
}
var $d35b2f3ed94b921d$var$o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $d35b2f3ed94b921d$var$f = 0, $d35b2f3ed94b921d$var$i = Array.isArray;
function $d35b2f3ed94b921d$export$34b9dba7ce09269b(e, t, n, o, i, u) {
    t || (t = {});
    var a, c, p = t;
    if ("ref" in p) for(c in p = {}, t)"ref" == c ? a = t[c] : p[c] = t[c];
    var l = {
        type: e,
        props: p,
        key: n,
        ref: a,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: --$d35b2f3ed94b921d$var$f,
        __i: -1,
        __u: 0,
        __source: i,
        __self: u
    };
    if ("function" == typeof e && (a = e.defaultProps)) for(c in a)void 0 === p[c] && (p[c] = a[c]);
    return (0, $tLNoZ.options).vnode && (0, $tLNoZ.options).vnode(l), l;
}
function $d35b2f3ed94b921d$export$45700d561b2268ac(r) {
    var t = $d35b2f3ed94b921d$export$34b9dba7ce09269b((0, $tLNoZ.Fragment), {
        tpl: r,
        exprs: [].slice.call(arguments, 1)
    });
    return t.key = t.__v, t;
}
var $d35b2f3ed94b921d$var$c = {}, $d35b2f3ed94b921d$var$p = /[A-Z]/g;
function $d35b2f3ed94b921d$export$991f6ffe102e5bac(e, t) {
    if ((0, $tLNoZ.options).attr) {
        var f = (0, $tLNoZ.options).attr(e, t);
        if ("string" == typeof f) return f;
    }
    if (t = function(r) {
        return null !== r && "object" == (typeof r === "undefined" ? "undefined" : (0, $7E0eS._)(r)) && "function" == typeof r.valueOf ? r.valueOf() : r;
    }(t), "ref" === e || "key" === e) return "";
    if ("style" === e && "object" == (typeof t === "undefined" ? "undefined" : (0, $7E0eS._)(t))) {
        var i = "";
        for(var u in t){
            var a = t[u];
            if (null != a && "" !== a) {
                var l = "-" == u[0] ? u : $d35b2f3ed94b921d$var$c[u] || ($d35b2f3ed94b921d$var$c[u] = u.replace($d35b2f3ed94b921d$var$p, "-$&").toLowerCase()), s = ";";
                "number" != typeof a || l.startsWith("--") || $d35b2f3ed94b921d$var$o.test(l) || (s = "px;"), i = i + l + ":" + a + s;
            }
        }
        return e + '="' + $d35b2f3ed94b921d$var$n(i) + '"';
    }
    return null == t || !1 === t || "function" == typeof t || "object" == (typeof t === "undefined" ? "undefined" : (0, $7E0eS._)(t)) ? "" : !0 === t ? e : e + '="' + $d35b2f3ed94b921d$var$n("" + t) + '"';
}
function $d35b2f3ed94b921d$export$40e96e718441efeb(r) {
    if (null == r || "boolean" == typeof r || "function" == typeof r) return null;
    if ("object" == (typeof r === "undefined" ? "undefined" : (0, $7E0eS._)(r))) {
        if (void 0 === r.constructor) return r;
        if ($d35b2f3ed94b921d$var$i(r)) {
            for(var e = 0; e < r.length; e++)r[e] = $d35b2f3ed94b921d$export$40e96e718441efeb(r[e]);
            return r;
        }
    }
    return $d35b2f3ed94b921d$var$n("" + r);
}


var $3959ba5a3cb8c567$var$OriginalPromise = Promise;
/**
 * ES5 subclassing is used per:
 * https://github.com/rtsao/browser-unhandled-rejection/issues/1
 * https://kangax.github.io/compat-table/es6/#test-Promise_is_subclassable
 *
 * Adapted from: https://gist.github.com/domenic/8ed6048b187ee8f2ec75
 */ var $3959ba5a3cb8c567$var$InstrumentedPromise$1 = function Promise1(resolver) {
    if (!(this instanceof $3959ba5a3cb8c567$var$InstrumentedPromise$1)) throw new TypeError('Cannot call a class as a function');
    var promise = new $3959ba5a3cb8c567$var$OriginalPromise(function(resolve, reject) {
        return resolver(resolve, function(arg) {
            $3959ba5a3cb8c567$var$OriginalPromise.resolve().then(function() {
                if (promise._hasDownstreams === undefined) $3959ba5a3cb8c567$var$dispatchUnhandledRejectionEvent(promise, arg);
            });
            return reject(arg);
        });
    });
    promise.__proto__ = $3959ba5a3cb8c567$var$InstrumentedPromise$1.prototype;
    return promise;
};
$3959ba5a3cb8c567$var$InstrumentedPromise$1.__proto__ = $3959ba5a3cb8c567$var$OriginalPromise;
$3959ba5a3cb8c567$var$InstrumentedPromise$1.prototype.__proto__ = $3959ba5a3cb8c567$var$OriginalPromise.prototype;
$3959ba5a3cb8c567$var$InstrumentedPromise$1.prototype.then = function then(onFulfilled, onRejected) {
    var next = $3959ba5a3cb8c567$var$OriginalPromise.prototype.then.call(this, onFulfilled, onRejected);
    this._hasDownstreams = true;
    return next;
};
function $3959ba5a3cb8c567$var$dispatchUnhandledRejectionEvent(promise, reason) {
    var event = document.createEvent('Event');
    /**
   * Note: these properties should not be enumerable, which is the default setting
   */ Object.defineProperties(event, {
        promise: {
            value: promise,
            writable: false
        },
        reason: {
            value: reason,
            writable: false
        }
    });
    event.initEvent('unhandledrejection', false, true // PromiseRejectionEvent is cancelable
    );
    window.dispatchEvent(event);
}
function $3959ba5a3cb8c567$export$baf72085f5fb4df() {
    return typeof PromiseRejectionEvent === 'undefined';
}
function $3959ba5a3cb8c567$export$cea1c58a6db52bca() {
    Promise = $3959ba5a3cb8c567$var$InstrumentedPromise$1;
}
function $3959ba5a3cb8c567$export$dfb5619354ba860() {
    if ($3959ba5a3cb8c567$export$baf72085f5fb4df()) $3959ba5a3cb8c567$export$cea1c58a6db52bca();
}
var $3959ba5a3cb8c567$export$2e2bcd8739ae039 = $3959ba5a3cb8c567$var$InstrumentedPromise$1;



var $h2kUE = parcelRequire("h2kUE");

var $1aLYV = parcelRequire("1aLYV");
function $ce7e531d844c2b97$export$882461b6382ed46c(container) {
    return {
        // eslint-disable-next-line
        render: function render1(children) {
            (0, $1aLYV.render)(children, container);
        },
        // eslint-disable-next-line
        unmount: function unmount() {
            (0, $1aLYV.unmountComponentAtNode)(container);
        }
    };
}
function $ce7e531d844c2b97$export$757ceba2d55c277e(container, children) {
    (0, $1aLYV.hydrate)(children, container);
    return $ce7e531d844c2b97$export$882461b6382ed46c(container);
}
var $ce7e531d844c2b97$export$2e2bcd8739ae039 = {
    createRoot: $ce7e531d844c2b97$export$882461b6382ed46c,
    hydrateRoot: $ce7e531d844c2b97$export$757ceba2d55c277e
};



var $lhPyT = parcelRequire("lhPyT");

var $tLNoZ = parcelRequire("tLNoZ");

var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");
var $8bd163097a5514bf$exports = {};

var $7E0eS = parcelRequire("7E0eS");
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if ((typeof arg === "undefined" ? "undefined" : (0, $7E0eS._)(arg)) !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($8bd163097a5514bf$exports) {
        classNames.default = classNames;
        $8bd163097a5514bf$exports = classNames;
    } else if (typeof define === 'function' && (0, $7E0eS._)(define.amd) === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $1aLYV = parcelRequire("1aLYV");
function $84bd84ada0211356$export$71511d61b312f219() {
    $84bd84ada0211356$export$71511d61b312f219 = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $84bd84ada0211356$export$71511d61b312f219.apply(this, arguments);
}


function $64559a1d4554a279$export$71511d61b312f219(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");
parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");
var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

"use client";
var $86d2028892b8b8bc$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
var $86d2028892b8b8bc$export$ff817e17bad2e091 = 'xs';
var $86d2028892b8b8bc$var$ThemeContext = /*#__PURE__*/ $tLNoZ.createContext({
    prefixes: {},
    breakpoints: $86d2028892b8b8bc$export$666ad80b5007f835,
    minBreakpoint: $86d2028892b8b8bc$export$ff817e17bad2e091
});
var $86d2028892b8b8bc$export$b631efc24e9d5e2f = $86d2028892b8b8bc$var$ThemeContext.Consumer, $86d2028892b8b8bc$var$Provider = $86d2028892b8b8bc$var$ThemeContext.Provider;
function $86d2028892b8b8bc$var$ThemeProvider(param) {
    var _param_prefixes = param.prefixes, prefixes = _param_prefixes === void 0 ? {} : _param_prefixes, _param_breakpoints = param.breakpoints, breakpoints = _param_breakpoints === void 0 ? $86d2028892b8b8bc$export$666ad80b5007f835 : _param_breakpoints, _param_minBreakpoint = param.minBreakpoint, minBreakpoint = _param_minBreakpoint === void 0 ? $86d2028892b8b8bc$export$ff817e17bad2e091 : _param_minBreakpoint, dir = param.dir, children = param.children;
    var contextValue = (0, $lliNT.useMemo)(function() {
        return {
            prefixes: (0, $1XAnY._)({}, prefixes),
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        };
    }, [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($86d2028892b8b8bc$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $86d2028892b8b8bc$export$7f387860ebffb32c(prefix, defaultPrefix) {
    var prefixes = (0, $lliNT.useContext)($86d2028892b8b8bc$var$ThemeContext).prefixes;
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $86d2028892b8b8bc$export$8970c8db816a5863() {
    var breakpoints = (0, $lliNT.useContext)($86d2028892b8b8bc$var$ThemeContext).breakpoints;
    return breakpoints;
}
function $86d2028892b8b8bc$export$d926d6ef38f3fd32() {
    var minBreakpoint = (0, $lliNT.useContext)($86d2028892b8b8bc$var$ThemeContext).minBreakpoint;
    return minBreakpoint;
}
function $86d2028892b8b8bc$export$35e511eefa30ac5a() {
    var dir = (0, $lliNT.useContext)($86d2028892b8b8bc$var$ThemeContext).dir;
    return dir === 'rtl';
}
function $86d2028892b8b8bc$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    var isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    var prefix = opts.prefix, _opts_forwardRefAs = opts.forwardRefAs, forwardRefAs = _opts_forwardRefAs === void 0 ? isClassy ? 'ref' : 'innerRef' : _opts_forwardRefAs;
    var Wrapped = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
        var props = (0, $84bd84ada0211356$export$71511d61b312f219)({}, (0, $64559a1d4554a279$export$71511d61b312f219)(_param));
        props[forwardRefAs] = ref;
        var bsPrefix = $86d2028892b8b8bc$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({}, props), {
            bsPrefix: bsPrefix
        }));
    });
    Wrapped.displayName = "Bootstrap(".concat(Component.displayName || Component.name, ")");
    return Wrapped;
}
var $86d2028892b8b8bc$export$2e2bcd8739ae039 = $86d2028892b8b8bc$var$ThemeProvider;



"use client";
var $1a4cf9540da0f5bb$var$Container = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, _param_fluid = _param.fluid, fluid = _param_fluid === void 0 ? false : _param_fluid, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, className = _param.className, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "fluid",
        "as",
        "className"
    ]);
    var prefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'container');
    var suffix = typeof fluid === 'string' ? "-".concat(fluid) : '-fluid';
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, fluid ? "".concat(prefix).concat(suffix) : prefix)
    }));
});
$1a4cf9540da0f5bb$var$Container.displayName = 'Container';
var $1a4cf9540da0f5bb$export$2e2bcd8739ae039 = $1a4cf9540da0f5bb$var$Container;



var $6rymm = parcelRequire("6rymm");

var $f9AOD = parcelRequire("f9AOD");

var $baaeda96f7555c00$exports = {};
var $baaeda96f7555c00$var$$14c85ffeff1ab241$export$fad3c8302a7540c6, $baaeda96f7555c00$var$$14c85ffeff1ab241$export$5f81b96ae5b0befd, $baaeda96f7555c00$var$$14c85ffeff1ab241$export$1a22ace05a045e3f, $baaeda96f7555c00$var$$14c85ffeff1ab241$export$c7aa240077ad8340, $baaeda96f7555c00$var$$14c85ffeff1ab241$export$5add10f2a1e13991, $baaeda96f7555c00$var$$cb8a09c271d9e2a2$export$70443d1bfecdb242, $baaeda96f7555c00$var$$cb8a09c271d9e2a2$export$a025291d1676ce41, $baaeda96f7555c00$var$$cb8a09c271d9e2a2$export$2585081e06ef4cbf, $baaeda96f7555c00$var$$4bfbcb67a3daf664$export$79ffe56a765070d2, $baaeda96f7555c00$var$$4bfbcb67a3daf664$export$cddc5598d4bb8461, $baaeda96f7555c00$var$$4bfbcb67a3daf664$export$73b7b5b52b6662d7, $baaeda96f7555c00$var$$7d37db9df1578ff2$export$5c452ff88e35e47d, $baaeda96f7555c00$var$$7d37db9df1578ff2$export$30d389775d7a0f3c, $baaeda96f7555c00$var$$7d37db9df1578ff2$export$a8ff84c12d48cfa6, $baaeda96f7555c00$var$$7d37db9df1578ff2$export$896c314ae37c4db9, $baaeda96f7555c00$var$$7d37db9df1578ff2$export$717db1a952ac2d26, $baaeda96f7555c00$var$$7d37db9df1578ff2$export$74fdf2685172213b, $baaeda96f7555c00$var$$7d37db9df1578ff2$export$fb184b623420d9be, $baaeda96f7555c00$var$$7d37db9df1578ff2$export$ec176431609ba4c9, $baaeda96f7555c00$var$$7d37db9df1578ff2$export$ea7c3e02973c1d5b, $baaeda96f7555c00$var$$c628d4ba96623bb8$export$1a22ace05a045e3f, $baaeda96f7555c00$var$$c628d4ba96623bb8$export$c7aa240077ad8340;
var $83f83764f225915f$export$71511d61b312f219;
"use strict";
var $c18e3812bf284031$export$71511d61b312f219;
"use strict";
function $c18e3812bf284031$var$_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
$c18e3812bf284031$export$71511d61b312f219 = $c18e3812bf284031$var$_array_with_holes;


var $017c39db4c48e95d$export$71511d61b312f219;
"use strict";
function $017c39db4c48e95d$var$_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
$017c39db4c48e95d$export$71511d61b312f219 = $017c39db4c48e95d$var$_iterable_to_array_limit;


var $1656378974c9464f$export$71511d61b312f219;
"use strict";
function $1656378974c9464f$var$_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$1656378974c9464f$export$71511d61b312f219 = $1656378974c9464f$var$_non_iterable_rest;


var $c2dbeb089f9f1560$export$71511d61b312f219;
"use strict";
var $7814c48c5beace1f$export$71511d61b312f219;
"use strict";
function $7814c48c5beace1f$var$_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$7814c48c5beace1f$export$71511d61b312f219 = $7814c48c5beace1f$var$_array_like_to_array;


function $c2dbeb089f9f1560$var$_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7814c48c5beace1f$export$71511d61b312f219(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7814c48c5beace1f$export$71511d61b312f219(o, minLen);
}
$c2dbeb089f9f1560$export$71511d61b312f219 = $c2dbeb089f9f1560$var$_unsupported_iterable_to_array;


function $83f83764f225915f$var$_sliced_to_array(arr, i) {
    return $c18e3812bf284031$export$71511d61b312f219(arr) || $017c39db4c48e95d$export$71511d61b312f219(arr, i) || $c2dbeb089f9f1560$export$71511d61b312f219(arr, i) || $1656378974c9464f$export$71511d61b312f219();
}
$83f83764f225915f$export$71511d61b312f219 = $83f83764f225915f$var$_sliced_to_array;


var $2b3349705fb2cb54$export$71511d61b312f219;
"use strict";
var $25a65ecfaee1324e$export$71511d61b312f219;
"use strict";

function $25a65ecfaee1324e$var$_array_without_holes(arr) {
    if (Array.isArray(arr)) return $7814c48c5beace1f$export$71511d61b312f219(arr);
}
$25a65ecfaee1324e$export$71511d61b312f219 = $25a65ecfaee1324e$var$_array_without_holes;


var $b16444858f6a2e44$export$71511d61b312f219;
"use strict";
function $b16444858f6a2e44$var$_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
$b16444858f6a2e44$export$71511d61b312f219 = $b16444858f6a2e44$var$_iterable_to_array;


var $9e139abf24489187$export$71511d61b312f219;
"use strict";
function $9e139abf24489187$var$_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$9e139abf24489187$export$71511d61b312f219 = $9e139abf24489187$var$_non_iterable_spread;



function $2b3349705fb2cb54$var$_to_consumable_array(arr) {
    return $25a65ecfaee1324e$export$71511d61b312f219(arr) || $b16444858f6a2e44$export$71511d61b312f219(arr) || $c2dbeb089f9f1560$export$71511d61b312f219(arr) || $9e139abf24489187$export$71511d61b312f219();
}
$2b3349705fb2cb54$export$71511d61b312f219 = $2b3349705fb2cb54$var$_to_consumable_array;



var $tLNoZ = parcelRequire("tLNoZ");

var $412ca59b3f02764c$export$71511d61b312f219;
"use strict";
var $ae6313b3cbf000af$export$71511d61b312f219;
"use strict";
function $ae6313b3cbf000af$var$_get_prototype_of(o) {
    $ae6313b3cbf000af$export$71511d61b312f219 = $ae6313b3cbf000af$var$_get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ae6313b3cbf000af$var$_get_prototype_of(o);
}
$ae6313b3cbf000af$export$71511d61b312f219 = $ae6313b3cbf000af$var$_get_prototype_of;


var $89f24628c68feef3$export$71511d61b312f219;
"use strict";
function $89f24628c68feef3$var$_is_native_reflect_construct() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($89f24628c68feef3$export$71511d61b312f219 = $89f24628c68feef3$var$_is_native_reflect_construct = function() {
        return !!result;
    })();
}
$89f24628c68feef3$export$71511d61b312f219 = $89f24628c68feef3$var$_is_native_reflect_construct;


var $ac94374e5d197642$export$71511d61b312f219;
"use strict";
var $a927f4d62235d407$export$71511d61b312f219;
"use strict";
function $a927f4d62235d407$var$_assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
$a927f4d62235d407$export$71511d61b312f219 = $a927f4d62235d407$var$_assert_this_initialized;


var $823e69b1ff06d0bf$export$71511d61b312f219;
"use strict";
function $823e69b1ff06d0bf$var$_type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
$823e69b1ff06d0bf$export$71511d61b312f219 = $823e69b1ff06d0bf$var$_type_of;


function $ac94374e5d197642$var$_possible_constructor_return(self, call) {
    if (call && ($823e69b1ff06d0bf$export$71511d61b312f219(call) === "object" || typeof call === "function")) return call;
    return $a927f4d62235d407$export$71511d61b312f219(self);
}
$ac94374e5d197642$export$71511d61b312f219 = $ac94374e5d197642$var$_possible_constructor_return;


function $412ca59b3f02764c$var$_call_super(_this, derived, args) {
    // Super
    derived = $ae6313b3cbf000af$export$71511d61b312f219(derived);
    return $ac94374e5d197642$export$71511d61b312f219(_this, $89f24628c68feef3$export$71511d61b312f219() ? Reflect.construct(derived, args || [], $ae6313b3cbf000af$export$71511d61b312f219(_this).constructor) : derived.apply(_this, args));
}
$412ca59b3f02764c$export$71511d61b312f219 = $412ca59b3f02764c$var$_call_super;


var $da4a22c62e4dca4b$export$71511d61b312f219;
"use strict";
function $da4a22c62e4dca4b$var$_class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$da4a22c62e4dca4b$export$71511d61b312f219 = $da4a22c62e4dca4b$var$_class_call_check;


var $f5ddaea1b57cff1c$export$71511d61b312f219;
"use strict";
function $f5ddaea1b57cff1c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f5ddaea1b57cff1c$var$_create_class(Constructor, protoProps, staticProps) {
    if (protoProps) $f5ddaea1b57cff1c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f5ddaea1b57cff1c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
$f5ddaea1b57cff1c$export$71511d61b312f219 = $f5ddaea1b57cff1c$var$_create_class;


var $4319b45daef5668a$export$71511d61b312f219;
"use strict";
var $6c65bdb48c5f0e16$export$71511d61b312f219;
"use strict";
function $6c65bdb48c5f0e16$var$_set_prototype_of(o, p) {
    $6c65bdb48c5f0e16$export$71511d61b312f219 = $6c65bdb48c5f0e16$var$_set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6c65bdb48c5f0e16$var$_set_prototype_of(o, p);
}
$6c65bdb48c5f0e16$export$71511d61b312f219 = $6c65bdb48c5f0e16$var$_set_prototype_of;


function $4319b45daef5668a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6c65bdb48c5f0e16$export$71511d61b312f219(subClass, superClass);
}
$4319b45daef5668a$export$71511d61b312f219 = $4319b45daef5668a$var$_inherits;


parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");
var $1aLYV = parcelRequire("1aLYV");
var $37561f8b8d5393c0$exports = {};

var $7E0eS = parcelRequire("7E0eS");
'use strict';
Object.defineProperty($37561f8b8d5393c0$exports, '__esModule', {
    value: true
});
var $244e45c4ae06bfb5$exports = {};
'use strict';
Object.defineProperty($244e45c4ae06bfb5$exports, '__esModule', {
    value: true
});
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ function $244e45c4ae06bfb5$var$isObject(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $244e45c4ae06bfb5$var$isPlainObject(o) {
    var ctor, prot;
    if ($244e45c4ae06bfb5$var$isObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (ctor === undefined) return true;
    // If has modified prototype
    prot = ctor.prototype;
    if ($244e45c4ae06bfb5$var$isObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty('isPrototypeOf') === false) return false;
    // Most likely a plain Object
    return true;
}
$244e45c4ae06bfb5$exports.isPlainObject = $244e45c4ae06bfb5$var$isPlainObject;



var $1aLYV = parcelRequire("1aLYV");
var $8327cfee14109576$exports = {};

var $7E0eS = parcelRequire("7E0eS");
"use strict";
var $8327cfee14109576$var$__assign = undefined && undefined.__assign || function() {
    $8327cfee14109576$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8327cfee14109576$var$__assign.apply(this, arguments);
};
var $8327cfee14109576$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty($8327cfee14109576$exports, "__esModule", {
    value: true
});
$8327cfee14109576$exports.prettyPrint = void 0;
var $8327cfee14109576$var$seen = [];
/**
 * Check if a value is an object or a function. Keep in mind that array, function, regexp, etc, are objects in JavaScript.
 *
 * @param value the value to check
 * @return true if the value is an object or a function
 */ function $8327cfee14109576$var$isObj(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value);
    return value !== null && (type === 'object' || type === 'function');
}
/**
 * Check if a value is a regular expression.
 *
 * @param value the value to check
 * @return true if the value is a regular expression
 */ function $8327cfee14109576$var$isRegexp(value) {
    return Object.prototype.toString.call(value) === '[object RegExp]';
}
/**
 * Get an array of all of the enumerable symbols for an object.
 *
 * @param object the object to get the enumerable symbols for
 */ function $8327cfee14109576$var$getOwnEnumPropSymbols(object) {
    return Object.getOwnPropertySymbols(object).filter(function(keySymbol) {
        return Object.prototype.propertyIsEnumerable.call(object, keySymbol);
    });
}
/**
 * pretty print an object
 *
 * @param input the object to pretty print
 * @param options the formatting options, transforms, and filters
 * @param pad the padding string
 */ function $8327cfee14109576$var$prettyPrint(input, options, pad) {
    if (pad === void 0) pad = '';
    // sensible option defaults
    var defaultOptions = {
        indent: '\t',
        singleQuotes: true
    };
    var combinedOptions = $8327cfee14109576$var$__assign($8327cfee14109576$var$__assign({}, defaultOptions), options);
    var tokens;
    if (combinedOptions.inlineCharacterLimit === undefined) tokens = {
        newLine: '\n',
        newLineOrSpace: '\n',
        pad: pad,
        indent: pad + combinedOptions.indent
    };
    else tokens = {
        newLine: '@@__PRETTY_PRINT_NEW_LINE__@@',
        newLineOrSpace: '@@__PRETTY_PRINT_NEW_LINE_OR_SPACE__@@',
        pad: '@@__PRETTY_PRINT_PAD__@@',
        indent: '@@__PRETTY_PRINT_INDENT__@@'
    };
    var expandWhiteSpace = function expandWhiteSpace(string) {
        if (combinedOptions.inlineCharacterLimit === undefined) return string;
        var oneLined = string.replace(new RegExp(tokens.newLine, 'g'), '').replace(new RegExp(tokens.newLineOrSpace, 'g'), ' ').replace(new RegExp(tokens.pad + '|' + tokens.indent, 'g'), '');
        if (oneLined.length <= combinedOptions.inlineCharacterLimit) return oneLined;
        return string.replace(new RegExp(tokens.newLine + '|' + tokens.newLineOrSpace, 'g'), '\n').replace(new RegExp(tokens.pad, 'g'), pad).replace(new RegExp(tokens.indent, 'g'), pad + combinedOptions.indent);
    };
    if ($8327cfee14109576$var$seen.indexOf(input) !== -1) return '"[Circular]"';
    if (input === null || input === undefined || typeof input === 'number' || typeof input === 'boolean' || typeof input === 'function' || (typeof input === "undefined" ? "undefined" : (0, $7E0eS._)(input)) === 'symbol' || $8327cfee14109576$var$isRegexp(input)) return String(input);
    if (input instanceof Date) return "new Date('".concat(input.toISOString(), "')");
    if (Array.isArray(input)) {
        if (input.length === 0) return '[]';
        $8327cfee14109576$var$seen.push(input);
        var ret = '[' + tokens.newLine + input.map(function(el, i) {
            var eol = input.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
            var value = $8327cfee14109576$var$prettyPrint(el, combinedOptions, pad + combinedOptions.indent);
            if (combinedOptions.transform) value = combinedOptions.transform(input, i, value);
            return tokens.indent + value + eol;
        }).join('') + tokens.pad + ']';
        $8327cfee14109576$var$seen.pop();
        return expandWhiteSpace(ret);
    }
    if ($8327cfee14109576$var$isObj(input)) {
        var objKeys_1 = $8327cfee14109576$var$__spreadArray($8327cfee14109576$var$__spreadArray([], Object.keys(input), true), $8327cfee14109576$var$getOwnEnumPropSymbols(input), true);
        if (combinedOptions.filter) objKeys_1 = objKeys_1.filter(function(el) {
            return combinedOptions.filter && combinedOptions.filter(input, el);
        });
        if (objKeys_1.length === 0) return '{}';
        $8327cfee14109576$var$seen.push(input);
        var ret = '{' + tokens.newLine + objKeys_1.map(function(el, i) {
            var eol = objKeys_1.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
            var isSymbol = (typeof el === "undefined" ? "undefined" : (0, $7E0eS._)(el)) === 'symbol';
            var isClassic = !isSymbol && /^[a-z$_][a-z$_0-9]*$/i.test(el.toString());
            var key = isSymbol || isClassic ? el : $8327cfee14109576$var$prettyPrint(el, combinedOptions);
            var value = $8327cfee14109576$var$prettyPrint(input[el], combinedOptions, pad + combinedOptions.indent);
            if (combinedOptions.transform) value = combinedOptions.transform(input, el, value);
            return tokens.indent + String(key) + ': ' + value + eol;
        }).join('') + tokens.pad + '}';
        $8327cfee14109576$var$seen.pop();
        return expandWhiteSpace(ret);
    }
    input = String(input).replace(/[\r\n]/g, function(x) {
        return x === '\n' ? '\\n' : '\\r';
    });
    if (!combinedOptions.singleQuotes) {
        input = input.replace(/"/g, '\\"');
        return "\"".concat(input, "\"");
    }
    input = input.replace(/\\?'/g, '\\\'');
    return "'".concat(input, "'");
}
$8327cfee14109576$exports.prettyPrint = $8327cfee14109576$var$prettyPrint;


var $75fcee2ea3d13b1e$exports = {};
'use strict';

$75fcee2ea3d13b1e$exports = (parcelRequire("c5KQ9"));


function $37561f8b8d5393c0$var$_interopDefaultLegacy(e) {
    return e && (typeof e === "undefined" ? "undefined" : (0, $7E0eS._)(e)) === 'object' && 'default' in e ? e : {
        'default': e
    };
}
function $37561f8b8d5393c0$var$_interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) Object.keys(e).forEach(function(k) {
        if (k !== 'default') {
            var d = Object.getOwnPropertyDescriptor(e, k);
            Object.defineProperty(n, k, d.get ? d : {
                enumerable: true,
                get: function get() {
                    return e[k];
                }
            });
        }
    });
    n["default"] = e;
    return Object.freeze(n);
}
var $37561f8b8d5393c0$var$React__namespace = /*#__PURE__*/ $37561f8b8d5393c0$var$_interopNamespace($1aLYV);
var $37561f8b8d5393c0$var$React__default = /*#__PURE__*/ $37561f8b8d5393c0$var$_interopDefaultLegacy($1aLYV);
var $37561f8b8d5393c0$var$spacer = function spacer(times, tabStop) {
    if (times === 0) return '';
    return new Array(times * tabStop).fill(' ').join('');
};
function $37561f8b8d5393c0$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $37561f8b8d5393c0$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $37561f8b8d5393c0$var$_arrayLikeToArray(r);
}
function $37561f8b8d5393c0$var$_defineProperty(e, r, t) {
    return (r = $37561f8b8d5393c0$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $37561f8b8d5393c0$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $37561f8b8d5393c0$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $37561f8b8d5393c0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $37561f8b8d5393c0$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $37561f8b8d5393c0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $37561f8b8d5393c0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $37561f8b8d5393c0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $37561f8b8d5393c0$var$_toConsumableArray(r) {
    return $37561f8b8d5393c0$var$_arrayWithoutHoles(r) || $37561f8b8d5393c0$var$_iterableToArray(r) || $37561f8b8d5393c0$var$_unsupportedIterableToArray(r) || $37561f8b8d5393c0$var$_nonIterableSpread();
}
function $37561f8b8d5393c0$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $7E0eS._)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $7E0eS._)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $37561f8b8d5393c0$var$_toPropertyKey(t) {
    var i = $37561f8b8d5393c0$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $7E0eS._)(i)) ? i : i + "";
}
function $37561f8b8d5393c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $37561f8b8d5393c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $37561f8b8d5393c0$var$_typeof(o);
}
function $37561f8b8d5393c0$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $37561f8b8d5393c0$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $37561f8b8d5393c0$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $37561f8b8d5393c0$var$safeSortObject(value, seen) {
    // return non-object value as is
    if (value === null || $37561f8b8d5393c0$var$_typeof(value) !== 'object') return value;
    // return date and regexp values as is
    if (value instanceof Date || value instanceof RegExp) return value;
    // return react element as is but remove _owner key because it can lead to recursion
    if (/*#__PURE__*/ $37561f8b8d5393c0$var$React__namespace.isValidElement(value)) {
        var copyObj = $37561f8b8d5393c0$var$_objectSpread2({}, value);
        delete copyObj._owner;
        return copyObj;
    }
    seen.add(value);
    // make a copy of array with each item passed through the sorting algorithm
    if (Array.isArray(value)) return value.map(function(v) {
        return $37561f8b8d5393c0$var$safeSortObject(v, seen);
    });
    // make a copy of object with key sorted
    return Object.keys(value).sort().reduce(function(result, key) {
        if (key === 'current' || seen.has(value[key])) // eslint-disable-next-line no-param-reassign
        result[key] = '[Circular]';
        else // eslint-disable-next-line no-param-reassign
        result[key] = $37561f8b8d5393c0$var$safeSortObject(value[key], seen);
        return result;
    }, {});
}
function $37561f8b8d5393c0$var$sortObject(value) {
    return $37561f8b8d5393c0$var$safeSortObject(value, new WeakSet());
}
/* eslint-disable no-use-before-define */ var $37561f8b8d5393c0$var$createStringTreeNode = function createStringTreeNode(value) {
    return {
        type: 'string',
        value: value
    };
};
var $37561f8b8d5393c0$var$createNumberTreeNode = function createNumberTreeNode(value) {
    return {
        type: 'number',
        value: value
    };
};
var $37561f8b8d5393c0$var$createReactElementTreeNode = function createReactElementTreeNode(displayName, props, defaultProps, childrens) {
    return {
        type: 'ReactElement',
        displayName: displayName,
        props: props,
        defaultProps: defaultProps,
        childrens: childrens
    };
};
var $37561f8b8d5393c0$var$createReactFragmentTreeNode = function createReactFragmentTreeNode(key, childrens) {
    return {
        type: 'ReactFragment',
        key: key,
        childrens: childrens
    };
};
var $37561f8b8d5393c0$var$supportFragment = Boolean($1aLYV.Fragment);
var $37561f8b8d5393c0$var$getFunctionTypeName = function getFunctionTypeName(functionType) {
    if (!functionType.name || functionType.name === '_default') return 'No Display Name';
    return functionType.name;
};
var $37561f8b8d5393c0$var$_getWrappedComponentDisplayName = function getWrappedComponentDisplayName(Component) {
    switch(true){
        case Boolean(Component.displayName):
            return Component.displayName;
        case Component.$$typeof === $75fcee2ea3d13b1e$exports.Memo:
            return $37561f8b8d5393c0$var$_getWrappedComponentDisplayName(Component.type);
        case Component.$$typeof === $75fcee2ea3d13b1e$exports.ForwardRef:
            return $37561f8b8d5393c0$var$_getWrappedComponentDisplayName(Component.render);
        default:
            return $37561f8b8d5393c0$var$getFunctionTypeName(Component);
    }
};
// heavily inspired by:
// https://github.com/facebook/react/blob/3746eaf985dd92f8aa5f5658941d07b6b855e9d9/packages/react-devtools-shared/src/backend/renderer.js#L399-L496
var $37561f8b8d5393c0$var$getReactElementDisplayName = function getReactElementDisplayName(element) {
    switch(true){
        case typeof element.type === 'string':
            return element.type;
        case typeof element.type === 'function':
            if (element.type.displayName) return element.type.displayName;
            return $37561f8b8d5393c0$var$getFunctionTypeName(element.type);
        case $75fcee2ea3d13b1e$exports.isForwardRef(element):
        case $75fcee2ea3d13b1e$exports.isMemo(element):
            return $37561f8b8d5393c0$var$_getWrappedComponentDisplayName(element.type);
        case $75fcee2ea3d13b1e$exports.isContextConsumer(element):
            return "".concat(element.type._context.displayName || 'Context', ".Consumer");
        case $75fcee2ea3d13b1e$exports.isContextProvider(element):
            return "".concat(element.type.displayName || 'Context', ".Provider");
        case $75fcee2ea3d13b1e$exports.isLazy(element):
            return 'Lazy';
        case $75fcee2ea3d13b1e$exports.isProfiler(element):
            return 'Profiler';
        case $75fcee2ea3d13b1e$exports.isStrictMode(element):
            return 'StrictMode';
        case $75fcee2ea3d13b1e$exports.isSuspense(element):
            return 'Suspense';
        default:
            return 'UnknownElementType';
    }
};
var $37561f8b8d5393c0$var$noChildren = function noChildren(propsValue, propName) {
    return propName !== 'children';
};
var $37561f8b8d5393c0$var$onlyMeaningfulChildren = function onlyMeaningfulChildren(children) {
    return children !== true && children !== false && children !== null && children !== '';
};
var $37561f8b8d5393c0$var$filterProps = function filterProps(originalProps, cb) {
    var filteredProps = {};
    Object.keys(originalProps).filter(function(key) {
        return cb(originalProps[key], key);
    }).forEach(function(key) {
        return filteredProps[key] = originalProps[key];
    });
    return filteredProps;
};
var $37561f8b8d5393c0$var$_parseReactElement = function parseReactElement(element, options) {
    var _options$displayName = options.displayName, displayNameFn = _options$displayName === void 0 ? $37561f8b8d5393c0$var$getReactElementDisplayName : _options$displayName;
    if (typeof element === 'string') return $37561f8b8d5393c0$var$createStringTreeNode(element);
    else if (typeof element === 'number') return $37561f8b8d5393c0$var$createNumberTreeNode(element);
    else if (!/*#__PURE__*/ $37561f8b8d5393c0$var$React__default["default"].isValidElement(element)) throw new Error("react-element-to-jsx-string: Expected a React.Element, got `".concat($37561f8b8d5393c0$var$_typeof(element), "`"));
    var displayName = displayNameFn(element);
    var props = $37561f8b8d5393c0$var$filterProps(element.props, $37561f8b8d5393c0$var$noChildren);
    var key = element.key;
    if (typeof key === 'string' && key.search(/^\./)) // React automatically add key=".X" when there are some children
    props.key = key;
    var defaultProps = $37561f8b8d5393c0$var$filterProps(element.type.defaultProps || {}, $37561f8b8d5393c0$var$noChildren);
    var childrens = $37561f8b8d5393c0$var$React__default["default"].Children.toArray(element.props.children).filter($37561f8b8d5393c0$var$onlyMeaningfulChildren).map(function(child) {
        return $37561f8b8d5393c0$var$_parseReactElement(child, options);
    });
    if ($37561f8b8d5393c0$var$supportFragment && element.type === $1aLYV.Fragment) return $37561f8b8d5393c0$var$createReactFragmentTreeNode(key, childrens);
    return $37561f8b8d5393c0$var$createReactElementTreeNode(displayName, props, defaultProps, childrens);
};
function $37561f8b8d5393c0$var$noRefCheck() {}
var $37561f8b8d5393c0$var$inlineFunction = function inlineFunction(fn) {
    return fn.toString().split('\n').map(function(line) {
        return line.trim();
    }).join('');
};
var $37561f8b8d5393c0$var$preserveFunctionLineBreak = function preserveFunctionLineBreak(fn) {
    return fn.toString();
};
var $37561f8b8d5393c0$var$defaultFunctionValue = $37561f8b8d5393c0$var$inlineFunction;
var $37561f8b8d5393c0$var$formatFunction = function formatFunction(fn, options) {
    var _options$functionValu = options.functionValue, functionValue = _options$functionValu === void 0 ? $37561f8b8d5393c0$var$defaultFunctionValue : _options$functionValu, showFunctions = options.showFunctions;
    if (!showFunctions && functionValue === $37561f8b8d5393c0$var$defaultFunctionValue) return functionValue($37561f8b8d5393c0$var$noRefCheck);
    return functionValue(fn);
};
var $37561f8b8d5393c0$var$formatComplexDataStructure = function formatComplexDataStructure(value, inline, lvl, options) {
    var normalizedValue = $37561f8b8d5393c0$var$sortObject(value);
    var stringifiedValue = $8327cfee14109576$exports.prettyPrint(normalizedValue, {
        transform: function transform(currentObj, prop, originalResult) {
            var currentValue = currentObj[prop];
            if (currentValue && /*#__PURE__*/ $1aLYV.isValidElement(currentValue)) return $37561f8b8d5393c0$var$formatTreeNode($37561f8b8d5393c0$var$_parseReactElement(currentValue, options), true, lvl, options);
            if (typeof currentValue === 'function') return $37561f8b8d5393c0$var$formatFunction(currentValue, options);
            return originalResult;
        }
    });
    if (inline) return stringifiedValue.replace(/\s+/g, ' ').replace(/{ /g, '{').replace(/ }/g, '}').replace(/\[ /g, '[').replace(/ ]/g, ']');
    // Replace tabs with spaces, and add necessary indentation in front of each new line
    return stringifiedValue.replace(/\t/g, $37561f8b8d5393c0$var$spacer(1, options.tabStop)).replace(/\n([^$])/g, "\n".concat($37561f8b8d5393c0$var$spacer(lvl + 1, options.tabStop), "$1"));
};
var $37561f8b8d5393c0$var$escape$1 = function escape(s) {
    return s.replace(/"/g, '&quot;');
};
var $37561f8b8d5393c0$var$formatPropValue = function formatPropValue(propValue, inline, lvl, options) {
    if (typeof propValue === 'number') return "{".concat(String(propValue), "}");
    if (typeof propValue === 'string') return "\"".concat($37561f8b8d5393c0$var$escape$1(propValue), "\"");
    // > "Symbols (new in ECMAScript 2015, not yet supported in Flow)"
    // @see: https://flow.org/en/docs/types/primitives/
    // $FlowFixMe: Flow does not support Symbol
    if ($37561f8b8d5393c0$var$_typeof(propValue) === 'symbol') {
        var symbolDescription = propValue.valueOf().toString().replace(/Symbol\((.*)\)/, '$1');
        if (!symbolDescription) return "{Symbol()}";
        return "{Symbol('".concat(symbolDescription, "')}");
    }
    if (typeof propValue === 'function') return "{".concat($37561f8b8d5393c0$var$formatFunction(propValue, options), "}");
    if (/*#__PURE__*/ $1aLYV.isValidElement(propValue)) return "{".concat($37561f8b8d5393c0$var$formatTreeNode($37561f8b8d5393c0$var$_parseReactElement(propValue, options), true, lvl, options), "}");
    if (propValue instanceof Date) {
        if (isNaN(propValue.valueOf())) return "{new Date(NaN)}";
        return "{new Date(\"".concat(propValue.toISOString(), "\")}");
    }
    if ($244e45c4ae06bfb5$exports.isPlainObject(propValue) || Array.isArray(propValue)) return "{".concat($37561f8b8d5393c0$var$formatComplexDataStructure(propValue, inline, lvl, options), "}");
    return "{".concat(String(propValue), "}");
};
var $37561f8b8d5393c0$var$formatProp = function formatProp(name, hasValue, value, hasDefaultValue, defaultValue, inline, lvl, options) {
    if (!hasValue && !hasDefaultValue) throw new Error("The prop \"".concat(name, "\" has no value and no default: could not be formatted"));
    var usedValue = hasValue ? value : defaultValue;
    var useBooleanShorthandSyntax = options.useBooleanShorthandSyntax, tabStop = options.tabStop;
    var formattedPropValue = $37561f8b8d5393c0$var$formatPropValue(usedValue, inline, lvl, options);
    var attributeFormattedInline = ' ';
    var attributeFormattedMultiline = "\n".concat($37561f8b8d5393c0$var$spacer(lvl + 1, tabStop));
    var isMultilineAttribute = formattedPropValue.includes('\n');
    if (useBooleanShorthandSyntax && formattedPropValue === '{false}' && !hasDefaultValue) {
        // If a boolean is false and not different from it's default, we do not render the attribute
        attributeFormattedInline = '';
        attributeFormattedMultiline = '';
    } else if (useBooleanShorthandSyntax && formattedPropValue === '{true}') {
        attributeFormattedInline += "".concat(name);
        attributeFormattedMultiline += "".concat(name);
    } else {
        attributeFormattedInline += "".concat(name, "=").concat(formattedPropValue);
        attributeFormattedMultiline += "".concat(name, "=").concat(formattedPropValue);
    }
    return {
        attributeFormattedInline: attributeFormattedInline,
        attributeFormattedMultiline: attributeFormattedMultiline,
        isMultilineAttribute: isMultilineAttribute
    };
};
var $37561f8b8d5393c0$var$mergeSiblingPlainStringChildrenReducer = function mergeSiblingPlainStringChildrenReducer(previousNodes, currentNode) {
    var nodes = previousNodes.slice(0, previousNodes.length > 0 ? previousNodes.length - 1 : 0);
    var previousNode = previousNodes[previousNodes.length - 1];
    if (previousNode && (currentNode.type === 'string' || currentNode.type === 'number') && (previousNode.type === 'string' || previousNode.type === 'number')) nodes.push($37561f8b8d5393c0$var$createStringTreeNode(String(previousNode.value) + String(currentNode.value)));
    else {
        if (previousNode) nodes.push(previousNode);
        nodes.push(currentNode);
    }
    return nodes;
};
var $37561f8b8d5393c0$var$isKeyOrRefProps = function isKeyOrRefProps(propName) {
    return [
        'key',
        'ref'
    ].includes(propName);
};
var $37561f8b8d5393c0$var$sortPropsByNames = function sortPropsByNames(shouldSortUserProps) {
    return function(props) {
        var haveKeyProp = props.includes('key');
        var haveRefProp = props.includes('ref');
        var userPropsOnly = props.filter(function(oneProp) {
            return !$37561f8b8d5393c0$var$isKeyOrRefProps(oneProp);
        });
        var sortedProps = shouldSortUserProps ? $37561f8b8d5393c0$var$_toConsumableArray(userPropsOnly.sort()) // We use basic lexical order
         : $37561f8b8d5393c0$var$_toConsumableArray(userPropsOnly);
        if (haveRefProp) sortedProps.unshift('ref');
        if (haveKeyProp) sortedProps.unshift('key');
        return sortedProps;
    };
};
function $37561f8b8d5393c0$var$createPropFilter(props, filter) {
    if (Array.isArray(filter)) return function(key) {
        return filter.indexOf(key) === -1;
    };
    else return function(key) {
        return filter(props[key], key);
    };
}
var $37561f8b8d5393c0$var$compensateMultilineStringElementIndentation = function compensateMultilineStringElementIndentation(element, formattedElement, inline, lvl, options) {
    var tabStop = options.tabStop;
    if (element.type === 'string') return formattedElement.split('\n').map(function(line, offset) {
        if (offset === 0) return line;
        return "".concat($37561f8b8d5393c0$var$spacer(lvl, tabStop)).concat(line);
    }).join('\n');
    return formattedElement;
};
var $37561f8b8d5393c0$var$formatOneChildren = function formatOneChildren(inline, lvl, options) {
    return function(element) {
        return $37561f8b8d5393c0$var$compensateMultilineStringElementIndentation(element, $37561f8b8d5393c0$var$formatTreeNode(element, inline, lvl, options), inline, lvl, options);
    };
};
var $37561f8b8d5393c0$var$onlyPropsWithOriginalValue = function onlyPropsWithOriginalValue(defaultProps, props) {
    return function(propName) {
        var haveDefaultValue = Object.keys(defaultProps).includes(propName);
        return !haveDefaultValue || haveDefaultValue && defaultProps[propName] !== props[propName];
    };
};
var $37561f8b8d5393c0$var$isInlineAttributeTooLong = function isInlineAttributeTooLong(attributes, inlineAttributeString, lvl, tabStop, maxInlineAttributesLineLength) {
    if (!maxInlineAttributesLineLength) return attributes.length > 1;
    return $37561f8b8d5393c0$var$spacer(lvl, tabStop).length + inlineAttributeString.length > maxInlineAttributesLineLength;
};
var $37561f8b8d5393c0$var$shouldRenderMultilineAttr = function shouldRenderMultilineAttr(attributes, inlineAttributeString, containsMultilineAttr, inline, lvl, tabStop, maxInlineAttributesLineLength) {
    return ($37561f8b8d5393c0$var$isInlineAttributeTooLong(attributes, inlineAttributeString, lvl, tabStop, maxInlineAttributesLineLength) || containsMultilineAttr) && !inline;
};
var $37561f8b8d5393c0$var$formatReactElementNode = function formatReactElementNode(node, inline, lvl, options) {
    var type = node.type, _node$displayName = node.displayName, displayName = _node$displayName === void 0 ? '' : _node$displayName, childrens = node.childrens, _node$props = node.props, props = _node$props === void 0 ? {} : _node$props, _node$defaultProps = node.defaultProps, defaultProps = _node$defaultProps === void 0 ? {} : _node$defaultProps;
    if (type !== 'ReactElement') throw new Error("The \"formatReactElementNode\" function could only format node of type \"ReactElement\". Given:  ".concat(type));
    var filterProps = options.filterProps, maxInlineAttributesLineLength = options.maxInlineAttributesLineLength, showDefaultProps = options.showDefaultProps, sortProps = options.sortProps, tabStop = options.tabStop;
    var out = "<".concat(displayName);
    var outInlineAttr = out;
    var outMultilineAttr = out;
    var containsMultilineAttr = false;
    var visibleAttributeNames = [];
    var propFilter = $37561f8b8d5393c0$var$createPropFilter(props, filterProps);
    Object.keys(props).filter(propFilter).filter($37561f8b8d5393c0$var$onlyPropsWithOriginalValue(defaultProps, props)).forEach(function(propName) {
        return visibleAttributeNames.push(propName);
    });
    Object.keys(defaultProps).filter(propFilter).filter(function() {
        return showDefaultProps;
    }).filter(function(defaultPropName) {
        return !visibleAttributeNames.includes(defaultPropName);
    }).forEach(function(defaultPropName) {
        return visibleAttributeNames.push(defaultPropName);
    });
    var attributes = $37561f8b8d5393c0$var$sortPropsByNames(sortProps)(visibleAttributeNames);
    attributes.forEach(function(attributeName) {
        var _formatProp = $37561f8b8d5393c0$var$formatProp(attributeName, Object.keys(props).includes(attributeName), props[attributeName], Object.keys(defaultProps).includes(attributeName), defaultProps[attributeName], inline, lvl, options), attributeFormattedInline = _formatProp.attributeFormattedInline, attributeFormattedMultiline = _formatProp.attributeFormattedMultiline, isMultilineAttribute = _formatProp.isMultilineAttribute;
        if (isMultilineAttribute) containsMultilineAttr = true;
        outInlineAttr += attributeFormattedInline;
        outMultilineAttr += attributeFormattedMultiline;
    });
    outMultilineAttr += "\n".concat($37561f8b8d5393c0$var$spacer(lvl, tabStop));
    if ($37561f8b8d5393c0$var$shouldRenderMultilineAttr(attributes, outInlineAttr, containsMultilineAttr, inline, lvl, tabStop, maxInlineAttributesLineLength)) out = outMultilineAttr;
    else out = outInlineAttr;
    if (childrens && childrens.length > 0) {
        var newLvl = lvl + 1;
        out += '>';
        if (!inline) {
            out += '\n';
            out += $37561f8b8d5393c0$var$spacer(newLvl, tabStop);
        }
        out += childrens.reduce($37561f8b8d5393c0$var$mergeSiblingPlainStringChildrenReducer, []).map($37561f8b8d5393c0$var$formatOneChildren(inline, newLvl, options)).join(!inline ? "\n".concat($37561f8b8d5393c0$var$spacer(newLvl, tabStop)) : '');
        if (!inline) {
            out += '\n';
            out += $37561f8b8d5393c0$var$spacer(newLvl - 1, tabStop);
        }
        out += "</".concat(displayName, ">");
    } else {
        if (!$37561f8b8d5393c0$var$isInlineAttributeTooLong(attributes, outInlineAttr, lvl, tabStop, maxInlineAttributesLineLength)) out += ' ';
        out += '/>';
    }
    return out;
};
var $37561f8b8d5393c0$var$REACT_FRAGMENT_TAG_NAME_SHORT_SYNTAX = '';
var $37561f8b8d5393c0$var$REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX = 'React.Fragment';
var $37561f8b8d5393c0$var$toReactElementTreeNode = function toReactElementTreeNode(displayName, key, childrens) {
    var props = {};
    if (key) props = {
        key: key
    };
    return {
        type: 'ReactElement',
        displayName: displayName,
        props: props,
        defaultProps: {},
        childrens: childrens
    };
};
var $37561f8b8d5393c0$var$isKeyedFragment = function isKeyedFragment(_ref) {
    var key = _ref.key;
    return Boolean(key);
};
var $37561f8b8d5393c0$var$hasNoChildren = function hasNoChildren(_ref2) {
    var childrens = _ref2.childrens;
    return childrens.length === 0;
};
var $37561f8b8d5393c0$var$formatReactFragmentNode = function formatReactFragmentNode(node, inline, lvl, options) {
    var type = node.type, key = node.key, childrens = node.childrens;
    if (type !== 'ReactFragment') throw new Error("The \"formatReactFragmentNode\" function could only format node of type \"ReactFragment\". Given: ".concat(type));
    var useFragmentShortSyntax = options.useFragmentShortSyntax;
    var displayName;
    if (useFragmentShortSyntax) {
        if ($37561f8b8d5393c0$var$hasNoChildren(node) || $37561f8b8d5393c0$var$isKeyedFragment(node)) displayName = $37561f8b8d5393c0$var$REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX;
        else displayName = $37561f8b8d5393c0$var$REACT_FRAGMENT_TAG_NAME_SHORT_SYNTAX;
    } else displayName = $37561f8b8d5393c0$var$REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX;
    return $37561f8b8d5393c0$var$formatReactElementNode($37561f8b8d5393c0$var$toReactElementTreeNode(displayName, key, childrens), inline, lvl, options);
};
var $37561f8b8d5393c0$var$jsxStopChars = [
    '<',
    '>',
    '{',
    '}'
];
var $37561f8b8d5393c0$var$shouldBeEscaped = function shouldBeEscaped(s) {
    return $37561f8b8d5393c0$var$jsxStopChars.some(function(jsxStopChar) {
        return s.includes(jsxStopChar);
    });
};
var $37561f8b8d5393c0$var$escape = function escape(s) {
    if (!$37561f8b8d5393c0$var$shouldBeEscaped(s)) return s;
    return "{`".concat(s, "`}");
};
var $37561f8b8d5393c0$var$preserveTrailingSpace = function preserveTrailingSpace(s) {
    var result = s;
    if (result.endsWith(' ')) result = result.replace(/^(.*?)(\s+)$/, "$1{'$2'}");
    if (result.startsWith(' ')) result = result.replace(/^(\s+)(.*)$/, "{'$1'}$2");
    return result;
};
var $37561f8b8d5393c0$var$formatTreeNode = function formatTreeNode(node, inline, lvl, options) {
    if (node.type === 'number') return String(node.value);
    if (node.type === 'string') return node.value ? "".concat($37561f8b8d5393c0$var$preserveTrailingSpace($37561f8b8d5393c0$var$escape(String(node.value)))) : '';
    if (node.type === 'ReactElement') return $37561f8b8d5393c0$var$formatReactElementNode(node, inline, lvl, options);
    if (node.type === 'ReactFragment') return $37561f8b8d5393c0$var$formatReactFragmentNode(node, inline, lvl, options);
    throw new TypeError("Unknow format type \"".concat(node.type, "\""));
};
var $37561f8b8d5393c0$var$formatTree = function formatTree(node, options) {
    return $37561f8b8d5393c0$var$formatTreeNode(node, false, 0, options);
};
var $37561f8b8d5393c0$var$reactElementToJsxString = function reactElementToJsxString(element) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$filterProps = _ref.filterProps, filterProps = _ref$filterProps === void 0 ? [] : _ref$filterProps, _ref$showDefaultProps = _ref.showDefaultProps, showDefaultProps = _ref$showDefaultProps === void 0 ? true : _ref$showDefaultProps, _ref$showFunctions = _ref.showFunctions, showFunctions = _ref$showFunctions === void 0 ? false : _ref$showFunctions, functionValue = _ref.functionValue, _ref$tabStop = _ref.tabStop, tabStop = _ref$tabStop === void 0 ? 2 : _ref$tabStop, _ref$useBooleanShorth = _ref.useBooleanShorthandSyntax, useBooleanShorthandSyntax = _ref$useBooleanShorth === void 0 ? true : _ref$useBooleanShorth, _ref$useFragmentShort = _ref.useFragmentShortSyntax, useFragmentShortSyntax = _ref$useFragmentShort === void 0 ? true : _ref$useFragmentShort, _ref$sortProps = _ref.sortProps, sortProps = _ref$sortProps === void 0 ? true : _ref$sortProps, maxInlineAttributesLineLength = _ref.maxInlineAttributesLineLength, displayName = _ref.displayName;
    if (!element) throw new Error('react-element-to-jsx-string: Expected a ReactElement');
    var options = {
        filterProps: filterProps,
        showDefaultProps: showDefaultProps,
        showFunctions: showFunctions,
        functionValue: functionValue,
        tabStop: tabStop,
        useBooleanShorthandSyntax: useBooleanShorthandSyntax,
        useFragmentShortSyntax: useFragmentShortSyntax,
        sortProps: sortProps,
        maxInlineAttributesLineLength: maxInlineAttributesLineLength,
        displayName: displayName
    };
    return $37561f8b8d5393c0$var$formatTree($37561f8b8d5393c0$var$_parseReactElement(element, options), options);
};
$37561f8b8d5393c0$exports["default"] = $37561f8b8d5393c0$var$reactElementToJsxString;
$37561f8b8d5393c0$exports.inlineFunction = $37561f8b8d5393c0$var$inlineFunction;
$37561f8b8d5393c0$exports.preserveFunctionLineBreak = $37561f8b8d5393c0$var$preserveFunctionLineBreak;


var $0e70cb6ccf37e2dd$exports = {};
/* **********************************************
     Begin prism-core.js
********************************************** */ /// <reference lib="WebWorker"/>
var $0e70cb6ccf37e2dd$var$_self = typeof window !== 'undefined' ? window // if in browser
 : typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope ? self // if in worker
 : {} // if in node js
;
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */ var $0e70cb6ccf37e2dd$var$Prism = function(_self) {
    // Private helper vars
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    // The grammar object for plaintext
    var plainTextGrammar = {};
    var _ = {
        /**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ manual: _self.Prism && _self.Prism.manual,
        /**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
        /**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */ util: {
            encode: function encode(tokens) {
                if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                else if (Array.isArray(tokens)) return tokens.map(encode);
                else return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
            },
            /**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */ type: function type(o) {
                return Object.prototype.toString.call(o).slice(8, -1);
            },
            /**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */ objId: function objId(obj) {
                if (!obj['__id']) Object.defineProperty(obj, '__id', {
                    value: ++uniqueId
                });
                return obj['__id'];
            },
            /**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */ clone: function deepClone(o, visited) {
                visited = visited || {};
                var clone;
                var id;
                switch(_.util.type(o)){
                    case 'Object':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = /** @type {Record<string, any>} */ {};
                        visited[id] = clone;
                        for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                        return /** @type {any} */ clone;
                    case 'Array':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = [];
                        visited[id] = clone;
                        /** @type {any} */ o.forEach(function(v, i) {
                            clone[i] = deepClone(v, visited);
                        });
                        return /** @type {any} */ clone;
                    default:
                        return o;
                }
            },
            /**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */ getLanguage: function getLanguage(element) {
                while(element){
                    var m = lang.exec(element.className);
                    if (m) return m[1].toLowerCase();
                    element = element.parentElement;
                }
                return 'none';
            },
            /**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */ setLanguage: function setLanguage(element, language) {
                // remove all `language-xxxx` classes
                // (this might leave behind a leading space)
                element.className = element.className.replace(RegExp(lang, 'gi'), '');
                // add the new `language-xxxx` class
                // (using `classList` will automatically clean up spaces for us)
                element.classList.add('language-' + language);
            },
            /**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */ currentScript: function currentScript() {
                if (typeof document === 'undefined') return null;
                if (document.currentScript && document.currentScript.tagName === 'SCRIPT' && true /* hack to trip TS' flow analysis */ ) return /** @type {any} */ document.currentScript;
                // IE11 workaround
                // we'll get the src of the current script by parsing IE11's error stack trace
                // this will not work for inline scripts
                try {
                    throw new Error();
                } catch (err) {
                    // Get file src url from stack. Specifically works with the format of stack traces in IE.
                    // A stack will look like this:
                    //
                    // Error
                    //    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
                    //    at Global code (http://localhost/components/prism-core.js:606:1)
                    var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                    if (src) {
                        var scripts = document.getElementsByTagName('script');
                        for(var i in scripts){
                            if (scripts[i].src == src) return scripts[i];
                        }
                    }
                    return null;
                }
            },
            /**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */ isActive: function isActive(element, className, defaultActivation) {
                var no = 'no-' + className;
                while(element){
                    var classList = element.classList;
                    if (classList.contains(className)) return true;
                    if (classList.contains(no)) return false;
                    element = element.parentElement;
                }
                return !!defaultActivation;
            }
        },
        /**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ languages: {
            /**
			 * The grammar for plain, unformatted text.
			 */ plain: plainTextGrammar,
            plaintext: plainTextGrammar,
            text: plainTextGrammar,
            txt: plainTextGrammar,
            /**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */ extend: function extend(id, redef) {
                var lang = _.util.clone(_.languages[id]);
                for(var key in redef)lang[key] = redef[key];
                return lang;
            },
            /**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */ insertBefore: function insertBefore(inside, before, insert, root) {
                root = root || /** @type {any} */ _.languages;
                var grammar = root[inside];
                /** @type {Grammar} */ var ret = {};
                for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    // Do not insert token which also occur in insert. See #1525
                    if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                }
                var old = root[inside];
                root[inside] = ret;
                // Update references in other language definitions
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === old && key != inside) this[key] = ret;
                });
                return ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function DFS(o, callback, type, visited) {
                visited = visited || {};
                var objId = _.util.objId;
                for(var i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    var property = o[i];
                    var propertyType = _.util.type(property);
                    if (propertyType === 'Object' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, null, visited);
                    } else if (propertyType === 'Array' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        /**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */ highlightAll: function highlightAll(async, callback) {
            _.highlightAllUnder(document, async, callback);
        },
        /**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */ highlightAllUnder: function highlightAllUnder(container, async, callback) {
            var env = {
                callback: callback,
                container: container,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            _.hooks.run('before-highlightall', env);
            env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
            _.hooks.run('before-all-elements-highlight', env);
            for(var i = 0, element; element = env.elements[i++];)_.highlightElement(element, async === true, env.callback);
        },
        /**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */ highlightElement: function highlightElement(element, async, callback) {
            // Find language
            var language = _.util.getLanguage(element);
            var grammar = _.languages[language];
            // Set language on the element, if not present
            _.util.setLanguage(element, language);
            // Set language on the parent, for styling
            var parent = element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre') _.util.setLanguage(parent, language);
            var code = element.textContent;
            var env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };
            function insertHighlightedCode(highlightedCode) {
                env.highlightedCode = highlightedCode;
                _.hooks.run('before-insert', env);
                env.element.innerHTML = env.highlightedCode;
                _.hooks.run('after-highlight', env);
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
            }
            _.hooks.run('before-sanity-check', env);
            // plugins may change/add the parent/element
            parent = env.element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) parent.setAttribute('tabindex', '0');
            if (!env.code) {
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
                return;
            }
            _.hooks.run('before-highlight', env);
            if (!env.grammar) {
                insertHighlightedCode(_.util.encode(env.code));
                return;
            }
            if (async && _self.Worker) {
                var worker = new Worker(_.filename);
                worker.onmessage = function(evt) {
                    insertHighlightedCode(evt.data);
                };
                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
        },
        /**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */ highlight: function highlight(text, grammar, language) {
            var env = {
                code: text,
                grammar: grammar,
                language: language
            };
            _.hooks.run('before-tokenize', env);
            if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
            env.tokens = _.tokenize(env.code, env.grammar);
            _.hooks.run('after-tokenize', env);
            return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */ tokenize: function tokenize(text, grammar) {
            var rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            var tokenList = new LinkedList();
            addAfter(tokenList, tokenList.head, text);
            matchGrammar(text, tokenList, grammar, tokenList.head, 0);
            return toArray(tokenList);
        },
        /**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ hooks: {
            all: {},
            /**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */ add: function add(name, callback) {
                var hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            /**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */ run: function run(name, env) {
                var callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        },
        Token: Token
    };
    _self.Prism = _;
    // Typescript note:
    // The following can be used to import the Token type in JSDoc:
    //
    //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
    /**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */ function Token(type, content, alias, matchedStr) {
        /**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */ this.type = type;
        /**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */ this.content = content;
        /**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */ this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || '').length | 0;
    }
    /**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */ /**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */ Token.stringify = function stringify(o, language) {
        if (typeof o == 'string') return o;
        if (Array.isArray(o)) {
            var s = '';
            o.forEach(function(e) {
                s += stringify(e, language);
            });
            return s;
        }
        var env = {
            type: o.type,
            content: stringify(o.content, language),
            tag: 'span',
            classes: [
                'token',
                o.type
            ],
            attributes: {},
            language: language
        };
        var aliases = o.alias;
        if (aliases) {
            if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
            else env.classes.push(aliases);
        }
        _.hooks.run('wrap', env);
        var attributes = '';
        for(var name in env.attributes)attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
        return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
    };
    /**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */ function matchPattern(pattern, pos, text, lookbehind) {
        pattern.lastIndex = pos;
        var match = pattern.exec(text);
        if (match && lookbehind && match[1]) {
            // change the match to remove the text matched by the Prism lookbehind group
            var lookbehindLength = match[1].length;
            match.index += lookbehindLength;
            match[0] = match[0].slice(lookbehindLength);
        }
        return match;
    }
    /**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */ function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
        for(var token in grammar){
            if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
            var patterns = grammar[token];
            patterns = Array.isArray(patterns) ? patterns : [
                patterns
            ];
            for(var j = 0; j < patterns.length; ++j){
                if (rematch && rematch.cause == token + ',' + j) return;
                var patternObj = patterns[j];
                var inside = patternObj.inside;
                var lookbehind = !!patternObj.lookbehind;
                var greedy = !!patternObj.greedy;
                var alias = patternObj.alias;
                if (greedy && !patternObj.pattern.global) {
                    // Without the global flag, lastIndex won't work
                    var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                    patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
                }
                /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
                for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                    if (rematch && pos >= rematch.reach) break;
                    var str = currentNode.value;
                    if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                    return;
                    if (str instanceof Token) continue;
                    var removeCount = 1; // this is the to parameter of removeBetween
                    var match;
                    if (greedy) {
                        match = matchPattern(pattern, pos, text, lookbehind);
                        if (!match || match.index >= text.length) break;
                        var from = match.index;
                        var to = match.index + match[0].length;
                        var p = pos;
                        // find the node that contains the match
                        p += currentNode.value.length;
                        while(from >= p){
                            currentNode = currentNode.next;
                            p += currentNode.value.length;
                        }
                        // adjust pos (and p)
                        p -= currentNode.value.length;
                        pos = p;
                        // the current node is a Token, then the match starts inside another Token, which is invalid
                        if (currentNode.value instanceof Token) continue;
                        // find the last node which is affected by this match
                        for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === 'string'); k = k.next){
                            removeCount++;
                            p += k.value.length;
                        }
                        removeCount--;
                        // replace with the new match
                        str = text.slice(pos, p);
                        match.index -= pos;
                    } else {
                        match = matchPattern(pattern, 0, str, lookbehind);
                        if (!match) continue;
                    }
                    // eslint-disable-next-line no-redeclare
                    var from = match.index;
                    var matchStr = match[0];
                    var before = str.slice(0, from);
                    var after = str.slice(from + matchStr.length);
                    var reach = pos + str.length;
                    if (rematch && reach > rematch.reach) rematch.reach = reach;
                    var removeFrom = currentNode.prev;
                    if (before) {
                        removeFrom = addAfter(tokenList, removeFrom, before);
                        pos += before.length;
                    }
                    removeRange(tokenList, removeFrom, removeCount);
                    var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                    currentNode = addAfter(tokenList, removeFrom, wrapped);
                    if (after) addAfter(tokenList, currentNode, after);
                    if (removeCount > 1) {
                        // at least one Token object was removed, so we have to do some rematching
                        // this can only happen if the current pattern is greedy
                        /** @type {RematchOptions} */ var nestedRematch = {
                            cause: token + ',' + j,
                            reach: reach
                        };
                        matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                        // the reach might have been extended because of the rematching
                        if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                    }
                }
            }
        }
    }
    /**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */ /**
	 * @template T
	 * @private
	 */ function LinkedList() {
        /** @type {LinkedListNode<T>} */ var head = {
            value: null,
            prev: null,
            next: null
        };
        /** @type {LinkedListNode<T>} */ var tail = {
            value: null,
            prev: head,
            next: null
        };
        head.next = tail;
        /** @type {LinkedListNode<T>} */ this.head = head;
        /** @type {LinkedListNode<T>} */ this.tail = tail;
        this.length = 0;
    }
    /**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */ function addAfter(list, node, value) {
        // assumes that node != list.tail && values.length >= 0
        var next = node.next;
        var newNode = {
            value: value,
            prev: node,
            next: next
        };
        node.next = newNode;
        next.prev = newNode;
        list.length++;
        return newNode;
    }
    /**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */ function removeRange(list, node, count) {
        var next = node.next;
        for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
        node.next = next;
        next.prev = node;
        list.length -= i;
    }
    /**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */ function toArray(list) {
        var array = [];
        var node = list.head.next;
        while(node !== list.tail){
            array.push(node.value);
            node = node.next;
        }
        return array;
    }
    if (!_self.document) {
        if (!_self.addEventListener) // in Node.js
        return _;
        if (!_.disableWorkerMessageHandler) // In worker
        _self.addEventListener('message', function(evt) {
            var message = JSON.parse(evt.data);
            var lang = message.language;
            var code = message.code;
            var immediateClose = message.immediateClose;
            _self.postMessage(_.highlight(code, _.languages[lang], lang));
            if (immediateClose) _self.close();
        }, false);
        return _;
    }
    // Get current script and highlight
    var script = _.util.currentScript();
    if (script) {
        _.filename = script.src;
        if (script.hasAttribute('data-manual')) _.manual = true;
    }
    function highlightAutomaticallyCallback() {
        if (!_.manual) _.highlightAll();
    }
    if (!_.manual) {
        // If the document state is "loading", then we'll use DOMContentLoaded.
        // If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
        // DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
        // might take longer one animation frame to execute which can create a race condition where only some plugins have
        // been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
        // See https://github.com/PrismJS/prism/issues/2102
        var readyState = document.readyState;
        if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
        else if (window.requestAnimationFrame) window.requestAnimationFrame(highlightAutomaticallyCallback);
        else window.setTimeout(highlightAutomaticallyCallback, 16);
    }
    return _;
}($0e70cb6ccf37e2dd$var$_self);
if ($0e70cb6ccf37e2dd$exports) $0e70cb6ccf37e2dd$exports = $0e70cb6ccf37e2dd$var$Prism;
// hack for components to work correctly in node.js
if (typeof $parcel$global !== 'undefined') $parcel$global.Prism = $0e70cb6ccf37e2dd$var$Prism;
// some additional documentation/types
/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */ /**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */ /**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */ /**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */ /* **********************************************
     Begin prism-markup.js
********************************************** */ $0e70cb6ccf37e2dd$var$Prism.languages.markup = {
    'comment': {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    'prolog': {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    'doctype': {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            'internal-subset': {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            'string': {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            'punctuation': /^<!|>$|[[\]]/,
            'doctype-tag': /^DOCTYPE/i,
            'name': /[^\s<>'"]+/
        }
    },
    'cdata': {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    'tag': {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            'tag': {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    'punctuation': /^<\/?/,
                    'namespace': /^[^\s>\/:]+:/
                }
            },
            'special-attr': [],
            'attr-value': {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    'punctuation': [
                        {
                            pattern: /^=/,
                            alias: 'attr-equals'
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            'punctuation': /\/?>/,
            'attr-name': {
                pattern: /[^\s>\/]+/,
                inside: {
                    'namespace': /^[^\s>\/:]+:/
                }
            }
        }
    },
    'entity': [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: 'named-entity'
        },
        /&#x?[\da-f]{1,8};/i
    ]
};
$0e70cb6ccf37e2dd$var$Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = $0e70cb6ccf37e2dd$var$Prism.languages.markup['entity'];
$0e70cb6ccf37e2dd$var$Prism.languages.markup['doctype'].inside['internal-subset'].inside = $0e70cb6ccf37e2dd$var$Prism.languages.markup;
// Plugin to make entity title show the real entity, idea by Roman Komarov
$0e70cb6ccf37e2dd$var$Prism.hooks.add('wrap', function(env) {
    if (env.type === 'entity') env.attributes['title'] = env.content.replace(/&amp;/, '&');
});
Object.defineProperty($0e70cb6ccf37e2dd$var$Prism.languages.markup.tag, 'addInlined', {
    /**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */ value: function addInlined(tagName, lang) {
        var includedCdataInside = {};
        includedCdataInside['language-' + lang] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: $0e70cb6ccf37e2dd$var$Prism.languages[lang]
        };
        includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
        var inside = {
            'included-cdata': {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: includedCdataInside
            }
        };
        inside['language-' + lang] = {
            pattern: /[\s\S]+/,
            inside: $0e70cb6ccf37e2dd$var$Prism.languages[lang]
        };
        var def = {};
        def[tagName] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return tagName;
            }), 'i'),
            lookbehind: true,
            greedy: true,
            inside: inside
        };
        $0e70cb6ccf37e2dd$var$Prism.languages.insertBefore('markup', 'cdata', def);
    }
});
Object.defineProperty($0e70cb6ccf37e2dd$var$Prism.languages.markup.tag, 'addAttribute', {
    /**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */ value: function value(attrName, lang) {
        $0e70cb6ccf37e2dd$var$Prism.languages.markup.tag.inside['special-attr'].push({
            pattern: RegExp(/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, 'i'),
            lookbehind: true,
            inside: {
                'attr-name': /^[^\s=]+/,
                'attr-value': {
                    pattern: /=[\s\S]+/,
                    inside: {
                        'value': {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                lang,
                                'language-' + lang
                            ],
                            inside: $0e70cb6ccf37e2dd$var$Prism.languages[lang]
                        },
                        'punctuation': [
                            {
                                pattern: /^=/,
                                alias: 'attr-equals'
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
});
$0e70cb6ccf37e2dd$var$Prism.languages.html = $0e70cb6ccf37e2dd$var$Prism.languages.markup;
$0e70cb6ccf37e2dd$var$Prism.languages.mathml = $0e70cb6ccf37e2dd$var$Prism.languages.markup;
$0e70cb6ccf37e2dd$var$Prism.languages.svg = $0e70cb6ccf37e2dd$var$Prism.languages.markup;
$0e70cb6ccf37e2dd$var$Prism.languages.xml = $0e70cb6ccf37e2dd$var$Prism.languages.extend('markup', {});
$0e70cb6ccf37e2dd$var$Prism.languages.ssml = $0e70cb6ccf37e2dd$var$Prism.languages.xml;
$0e70cb6ccf37e2dd$var$Prism.languages.atom = $0e70cb6ccf37e2dd$var$Prism.languages.xml;
$0e70cb6ccf37e2dd$var$Prism.languages.rss = $0e70cb6ccf37e2dd$var$Prism.languages.xml;
/* **********************************************
     Begin prism-css.js
********************************************** */ (function(Prism) {
    var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    Prism.languages.css = {
        'comment': /\/\*[\s\S]*?\*\//,
        'atrule': {
            pattern: RegExp('@[\\w-](?:' + /[^;{\s"']|\s+(?!\s)/.source + '|' + string.source + ')*?' + /(?:;|(?=\s*\{))/.source),
            inside: {
                'rule': /^@[\w-]+/,
                'selector-function-argument': {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: 'selector'
                },
                'keyword': {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                }
            }
        },
        'url': {
            // https://drafts.csswg.org/css-values-3/#urls
            pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
            greedy: true,
            inside: {
                'function': /^url/i,
                'punctuation': /^\(|\)$/,
                'string': {
                    pattern: RegExp('^' + string.source + '$'),
                    alias: 'url'
                }
            }
        },
        'selector': {
            pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
            lookbehind: true
        },
        'string': {
            pattern: string,
            greedy: true
        },
        'property': {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        'important': /!important\b/i,
        'function': {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        'punctuation': /[(){};:,]/
    };
    Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
    var markup = Prism.languages.markup;
    if (markup) {
        markup.tag.addInlined('style', 'css');
        markup.tag.addAttribute('style', 'css');
    }
})($0e70cb6ccf37e2dd$var$Prism);
/* **********************************************
     Begin prism-clike.js
********************************************** */ $0e70cb6ccf37e2dd$var$Prism.languages.clike = {
    'comment': [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    'string': {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    'class-name': {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            'punctuation': /[.\\]/
        }
    },
    'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    'boolean': /\b(?:false|true)\b/,
    'function': /\b\w+(?=\()/,
    'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    'punctuation': /[{}[\];(),.:]/
};
/* **********************************************
     Begin prism-javascript.js
********************************************** */ $0e70cb6ccf37e2dd$var$Prism.languages.javascript = $0e70cb6ccf37e2dd$var$Prism.languages.extend('clike', {
    'class-name': [
        $0e70cb6ccf37e2dd$var$Prism.languages.clike['class-name'],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    'keyword': [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    'number': {
        pattern: RegExp(/(^|[^\w$])/.source + '(?:' + // constant
        (/NaN|Infinity/.source + '|' + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
        /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
        lookbehind: true
    },
    'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
$0e70cb6ccf37e2dd$var$Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
$0e70cb6ccf37e2dd$var$Prism.languages.insertBefore('javascript', 'keyword', {
    'regex': {
        pattern: RegExp(// lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + '(?:' + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + '|' + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ')' + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            'regex-source': {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: 'language-regex',
                inside: $0e70cb6ccf37e2dd$var$Prism.languages.regex
            },
            'regex-delimiter': /^\/|\/$/,
            'regex-flags': /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    'function-variable': {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: 'function'
    },
    'parameter': [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: $0e70cb6ccf37e2dd$var$Prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: $0e70cb6ccf37e2dd$var$Prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: $0e70cb6ccf37e2dd$var$Prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: $0e70cb6ccf37e2dd$var$Prism.languages.javascript
        }
    ],
    'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
$0e70cb6ccf37e2dd$var$Prism.languages.insertBefore('javascript', 'string', {
    'hashbang': {
        pattern: /^#!.*/,
        greedy: true,
        alias: 'comment'
    },
    'template-string': {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            'template-punctuation': {
                pattern: /^`|`$/,
                alias: 'string'
            },
            'interpolation': {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    'interpolation-punctuation': {
                        pattern: /^\$\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: $0e70cb6ccf37e2dd$var$Prism.languages.javascript
                }
            },
            'string': /[\s\S]+/
        }
    },
    'string-property': {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: 'property'
    }
});
$0e70cb6ccf37e2dd$var$Prism.languages.insertBefore('javascript', 'operator', {
    'literal-property': {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: 'property'
    }
});
if ($0e70cb6ccf37e2dd$var$Prism.languages.markup) {
    $0e70cb6ccf37e2dd$var$Prism.languages.markup.tag.addInlined('script', 'javascript');
    // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    $0e70cb6ccf37e2dd$var$Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
}
$0e70cb6ccf37e2dd$var$Prism.languages.js = $0e70cb6ccf37e2dd$var$Prism.languages.javascript;
/* **********************************************
     Begin prism-file-highlight.js
********************************************** */ (function() {
    if (typeof $0e70cb6ccf37e2dd$var$Prism === 'undefined' || typeof document === 'undefined') return;
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
    if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    var LOADING_MESSAGE = "Loading\u2026";
    var FAILURE_MESSAGE = function FAILURE_MESSAGE(status, message) {
        return "\u2716 Error " + status + ' while fetching file: ' + message;
    };
    var FAILURE_EMPTY_MESSAGE = "\u2716 Error: File does not exist or is empty";
    var EXTENSIONS = {
        'js': 'javascript',
        'py': 'python',
        'rb': 'ruby',
        'ps1': 'powershell',
        'psm1': 'powershell',
        'sh': 'bash',
        'bat': 'batch',
        'h': 'c',
        'tex': 'latex'
    };
    var STATUS_ATTR = 'data-src-status';
    var STATUS_LOADING = 'loading';
    var STATUS_LOADED = 'loaded';
    var STATUS_FAILED = 'failed';
    var SELECTOR = 'pre[data-src]:not([' + STATUS_ATTR + '="' + STATUS_LOADED + '"])' + ':not([' + STATUS_ATTR + '="' + STATUS_LOADING + '"])';
    /**
	 * Loads the given file.
	 *
	 * @param {string} src The URL or path of the source file to load.
	 * @param {(result: string) => void} success
	 * @param {(reason: string) => void} error
	 */ function loadFile(src, success, error) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', src, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState == 4) {
                if (xhr.status < 400 && xhr.responseText) success(xhr.responseText);
                else if (xhr.status >= 400) error(FAILURE_MESSAGE(xhr.status, xhr.statusText));
                else error(FAILURE_EMPTY_MESSAGE);
            }
        };
        xhr.send(null);
    }
    /**
	 * Parses the given range.
	 *
	 * This returns a range with inclusive ends.
	 *
	 * @param {string | null | undefined} range
	 * @returns {[number, number | undefined] | undefined}
	 */ function parseRange(range) {
        var m = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(range || '');
        if (m) {
            var start = Number(m[1]);
            var comma = m[2];
            var end = m[3];
            if (!comma) return [
                start,
                start
            ];
            if (!end) return [
                start,
                undefined
            ];
            return [
                start,
                Number(end)
            ];
        }
        return undefined;
    }
    $0e70cb6ccf37e2dd$var$Prism.hooks.add('before-highlightall', function(env) {
        env.selector += ', ' + SELECTOR;
    });
    $0e70cb6ccf37e2dd$var$Prism.hooks.add('before-sanity-check', function(env) {
        var pre = /** @type {HTMLPreElement} */ env.element;
        if (pre.matches(SELECTOR)) {
            env.code = ''; // fast-path the whole thing and go to complete
            pre.setAttribute(STATUS_ATTR, STATUS_LOADING); // mark as loading
            // add code element with loading message
            var code = pre.appendChild(document.createElement('CODE'));
            code.textContent = LOADING_MESSAGE;
            var src = pre.getAttribute('data-src');
            var language = env.language;
            if (language === 'none') {
                // the language might be 'none' because there is no language set;
                // in this case, we want to use the extension as the language
                var extension = (/\.(\w+)$/.exec(src) || [
                    ,
                    'none'
                ])[1];
                language = EXTENSIONS[extension] || extension;
            }
            // set language classes
            $0e70cb6ccf37e2dd$var$Prism.util.setLanguage(code, language);
            $0e70cb6ccf37e2dd$var$Prism.util.setLanguage(pre, language);
            // preload the language
            var autoloader = $0e70cb6ccf37e2dd$var$Prism.plugins.autoloader;
            if (autoloader) autoloader.loadLanguages(language);
            // load file
            loadFile(src, function(text) {
                // mark as loaded
                pre.setAttribute(STATUS_ATTR, STATUS_LOADED);
                // handle data-range
                var range = parseRange(pre.getAttribute('data-range'));
                if (range) {
                    var lines = text.split(/\r\n?|\n/g);
                    // the range is one-based and inclusive on both ends
                    var start = range[0];
                    var end = range[1] == null ? lines.length : range[1];
                    if (start < 0) start += lines.length;
                    start = Math.max(0, Math.min(start - 1, lines.length));
                    if (end < 0) end += lines.length;
                    end = Math.max(0, Math.min(end, lines.length));
                    text = lines.slice(start, end).join('\n');
                    // add data-start for line numbers
                    if (!pre.hasAttribute('data-start')) pre.setAttribute('data-start', String(start + 1));
                }
                // highlight code
                code.textContent = text;
                $0e70cb6ccf37e2dd$var$Prism.highlightElement(code);
            }, function(error) {
                // mark as failed
                pre.setAttribute(STATUS_ATTR, STATUS_FAILED);
                code.textContent = error;
            });
        }
    });
    $0e70cb6ccf37e2dd$var$Prism.plugins.fileHighlight = {
        /**
		 * Executes the File Highlight plugin for all matching `pre` elements under the given container.
		 *
		 * Note: Elements which are already loaded or currently loading will not be touched by this method.
		 *
		 * @param {ParentNode} [container=document]
		 */ highlight: function highlight(container) {
            var elements = (container || document).querySelectorAll(SELECTOR);
            for(var i = 0, element; element = elements[i++];)$0e70cb6ccf37e2dd$var$Prism.highlightElement(element);
        }
    };
    var logged = false;
    /** @deprecated Use `Prism.plugins.fileHighlight.highlight` instead. */ $0e70cb6ccf37e2dd$var$Prism.fileHighlight = function() {
        if (!logged) {
            console.warn('Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead.');
            logged = true;
        }
        $0e70cb6ccf37e2dd$var$Prism.plugins.fileHighlight.highlight.apply(this, arguments);
    };
})();






!(parcelRequire("2ZsbG")), !(parcelRequire("knnJU")), !(parcelRequire("fHM7w")), (parcelRequire("3RSag"));
var $57751a2649dd1683$export$71511d61b312f219;
"use strict";
var $69d13e150157bede$export$71511d61b312f219;
"use strict";

function $69d13e150157bede$var$_super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $ae6313b3cbf000af$export$71511d61b312f219(object);
        if (object === null) break;
    }
    return object;
}
$69d13e150157bede$export$71511d61b312f219 = $69d13e150157bede$var$_super_prop_base;


function $57751a2649dd1683$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $57751a2649dd1683$export$71511d61b312f219 = $57751a2649dd1683$var$_get = Reflect.get;
    else $57751a2649dd1683$export$71511d61b312f219 = $57751a2649dd1683$var$_get = function get(target, property, receiver) {
        var base = $69d13e150157bede$export$71511d61b312f219(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $57751a2649dd1683$var$_get(target, property, receiver || target);
}
$57751a2649dd1683$export$71511d61b312f219 = $57751a2649dd1683$var$_get;





var $h2kUE = parcelRequire("h2kUE");

var $7E0eS = parcelRequire("7E0eS");

var $h2kUE = parcelRequire("h2kUE");
parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");
var $1aLYV = parcelRequire("1aLYV");

var $h2kUE = parcelRequire("h2kUE");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
if (!(0, $lliNT.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $h2kUE.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");



var $1aLYV = parcelRequire("1aLYV");


var $1aLYV = parcelRequire("1aLYV");

var $h2kUE = parcelRequire("h2kUE");
function $91e7d24e2fdb9269$export$fb2daceae6f5097a(callback) {
    callback();
}
function $91e7d24e2fdb9269$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $91e7d24e2fdb9269$export$fb2daceae6f5097a;
    (0, $h2kUE.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $91e7d24e2fdb9269$export$13ce1459b9a04b51 = function isObserverBatched() {
    return true;
};


var $80c5a2b99477631d$var$deprecatedMessages = [];
function $80c5a2b99477631d$export$be38475be17599d(msg) {
    if (!$80c5a2b99477631d$var$deprecatedMessages.includes(msg)) {
        $80c5a2b99477631d$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}



var $h2kUE = parcelRequire("h2kUE");

var $1aLYV = parcelRequire("1aLYV");

var $h2kUE = parcelRequire("h2kUE");
function $9809f448a741f2c4$export$ef795f1f307682c7(v) {
    return (0, $h2kUE.getDependencyTree)(v);
}


var $fbb6d1707652b0db$var$globalIsUsingStaticRendering = false;
function $fbb6d1707652b0db$export$5d52eaa7c0f24c9e(enable) {
    $fbb6d1707652b0db$var$globalIsUsingStaticRendering = enable;
}
function $fbb6d1707652b0db$export$55979271896d643e() {
    return $fbb6d1707652b0db$var$globalIsUsingStaticRendering;
}


var $6e775122473ffa8f$export$e901ba0ffe10ba41 = 10000;
var $6e775122473ffa8f$export$1ae22ce5a82f26b6 = 10000;
var $6e775122473ffa8f$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function value(maxAge) {
                if (maxAge === void 0) maxAge = $6e775122473ffa8f$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function value() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function value(target, _value, token) {
            this.registrations.set(token, {
                value: _value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function value(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function value() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $6e775122473ffa8f$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $6e775122473ffa8f$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $6e775122473ffa8f$export$b7a00d372cedeedd;


var $62a2b68bdaef3c11$export$10e8a12fbfd8583c = new (0, $6e775122473ffa8f$export$da5d55a244964b51)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});


var $2106ff17257e9272$exports = {};
'use strict';

$2106ff17257e9272$exports = (parcelRequire("fmjrn"));


function $7ff3518511e72ec8$var$createReaction(adm) {
    adm.reaction = new (0, $h2kUE.Reaction)("observer".concat(adm.name), function() {
        var _a;
        adm.stateVersion = Symbol();
        // onStoreChange won't be available until the component "mounts".
        // If state changes in between initial render and mount,
        // `useSyncExternalStore` should handle that by checking the state version and issuing update.
        (_a = adm.onStoreChange) === null || _a === void 0 || _a.call(adm);
    });
}
function $7ff3518511e72ec8$export$b9c7ecd090a87b14(render, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $fbb6d1707652b0db$export$55979271896d643e)()) return render();
    var admRef = (0, $1aLYV.default).useRef(null);
    if (!admRef.current) {
        // First render
        var adm_1 = {
            reaction: null,
            onStoreChange: null,
            stateVersion: Symbol(),
            name: baseComponentName,
            subscribe: function subscribe(onStoreChange) {
                // Do NOT access admRef here!
                (0, $62a2b68bdaef3c11$export$10e8a12fbfd8583c).unregister(adm_1);
                adm_1.onStoreChange = onStoreChange;
                if (!adm_1.reaction) {
                    // We've lost our reaction and therefore all subscriptions, occurs when:
                    // 1. Timer based finalization registry disposed reaction before component mounted.
                    // 2. React "re-mounts" same component without calling render in between (typically <StrictMode>).
                    // We have to recreate reaction and schedule re-render to recreate subscriptions,
                    // even if state did not change.
                    $7ff3518511e72ec8$var$createReaction(adm_1);
                    // `onStoreChange` won't force update if subsequent `getSnapshot` returns same value.
                    // So we make sure that is not the case
                    adm_1.stateVersion = Symbol();
                }
                return function() {
                    var _a;
                    // Do NOT access admRef here!
                    adm_1.onStoreChange = null;
                    (_a = adm_1.reaction) === null || _a === void 0 || _a.dispose();
                    adm_1.reaction = null;
                };
            },
            getSnapshot: function getSnapshot() {
                // Do NOT access admRef here!
                return adm_1.stateVersion;
            }
        };
        admRef.current = adm_1;
    }
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or reaction was disposed by registry before subscribe
        $7ff3518511e72ec8$var$createReaction(adm);
        // StrictMode/ConcurrentMode/Suspense may mean that our component is
        // rendered and abandoned multiple times, so we need to track leaked
        // Reactions.
        (0, $62a2b68bdaef3c11$export$10e8a12fbfd8583c).register(admRef, adm, adm);
    }
    (0, $1aLYV.default).useDebugValue(adm.reaction, (0, $9809f448a741f2c4$export$ef795f1f307682c7));
    (0, $2106ff17257e9272$exports.useSyncExternalStore)(// Both of these must be stable, otherwise it would keep resubscribing every render.
    adm.subscribe, adm.getSnapshot, adm.getSnapshot);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var renderResult;
    var exception;
    adm.reaction.track(function() {
        try {
            renderResult = render();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return renderResult;
}





var $1aLYV = parcelRequire("1aLYV");


var $3216ea70456c1fc3$var$_a, $3216ea70456c1fc3$var$_b;
var $3216ea70456c1fc3$var$warnObserverOptionsDeprecated = true;
var $3216ea70456c1fc3$var$warnLegacyContextTypes = true;
var $3216ea70456c1fc3$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $3216ea70456c1fc3$var$isFunctionNameConfigurable = ($3216ea70456c1fc3$var$_b = ($3216ea70456c1fc3$var$_a = Object.getOwnPropertyDescriptor(function() {}, "name")) === null || $3216ea70456c1fc3$var$_a === void 0 ? void 0 : $3216ea70456c1fc3$var$_a.configurable) !== null && $3216ea70456c1fc3$var$_b !== void 0 ? $3216ea70456c1fc3$var$_b : false;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $3216ea70456c1fc3$var$ReactForwardRefSymbol = $3216ea70456c1fc3$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $1aLYV.forwardRef) === "function" && (0, $1aLYV.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $3216ea70456c1fc3$var$ReactMemoSymbol = $3216ea70456c1fc3$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $1aLYV.memo) === "function" && (0, $1aLYV.memo)(function(props) {
    return null;
})["$$typeof"];
function $3216ea70456c1fc3$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($3216ea70456c1fc3$var$ReactMemoSymbol && baseComponent["$$typeof"] === $3216ea70456c1fc3$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $fbb6d1707652b0db$export$55979271896d643e)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($3216ea70456c1fc3$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $3216ea70456c1fc3$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function observerComponent(props, ref) {
        return (0, $7ff3518511e72ec8$export$b9c7ecd090a87b14)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    observerComponent.displayName = baseComponent.displayName;
    if ($3216ea70456c1fc3$var$isFunctionNameConfigurable) Object.defineProperty(observerComponent, "name", {
        value: baseComponent.name,
        writable: true,
        configurable: true
    });
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $1aLYV.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $1aLYV.memo)(observerComponent);
    $3216ea70456c1fc3$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $3216ea70456c1fc3$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $3216ea70456c1fc3$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$3216ea70456c1fc3$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}



var $7E0eS = parcelRequire("7E0eS");

function $ba69a7c3116b7737$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    if (children && render) console.error("MobX Observer: Do not use children and render in the same time in `Observer`");
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $7ff3518511e72ec8$export$b9c7ecd090a87b14)(component);
}
$ba69a7c3116b7737$export$c1cbdee04e18ea8b.displayName = "Observer";
function $ba69a7c3116b7737$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + (0, $7E0eS._)(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
}



var $h2kUE = parcelRequire("h2kUE");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
function $1229c05c588bf1c4$export$aa207039f277c5f(initializer, annotations) {
    return (0, $lliNT.useState)(function() {
        return (0, $h2kUE.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}



var $h2kUE = parcelRequire("h2kUE");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");



var $h2kUE = parcelRequire("h2kUE");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
function $09aa7638cd2a5e28$export$e0ded3646391939c(current) {
    // We're deliberately not using idiomatic destructuring for the hook here.
    // Accessing the state value as an array element prevents TypeScript from generating unnecessary helpers in the resulting code.
    // For further details, please refer to mobxjs/mobx#3842.
    var res = (0, $lliNT.useState)(function() {
        return (0, $h2kUE.observable)(current, {}, {
            deep: false
        });
    })[0];
    (0, $h2kUE.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}


function $ce69ca68d499f0b3$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $09aa7638cd2a5e28$export$e0ded3646391939c)(current);
    return (0, $lliNT.useState)(function() {
        return (0, $h2kUE.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}



var $c67965437e8f595b$var$_a;
(0, $91e7d24e2fdb9269$export$294943bbc3c74f4f)((0, $1aLYV.unstable_batchedUpdates));
var $c67965437e8f595b$export$469d51fb8d268227 = ($c67965437e8f595b$var$_a = (0, $62a2b68bdaef3c11$export$10e8a12fbfd8583c)["finalizeAllImmediately"]) !== null && $c67965437e8f595b$var$_a !== void 0 ? $c67965437e8f595b$var$_a : function clearTimers() {};
function $c67965437e8f595b$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $7ff3518511e72ec8$export$b9c7ecd090a87b14)(fn, baseComponentName);
}
function $c67965437e8f595b$export$7613124ee4202834(enable) {
    (0, $fbb6d1707652b0db$export$5d52eaa7c0f24c9e)(enable);
}


function $e04d4b638436dc5e$var$shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if ($e04d4b638436dc5e$var$is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : (0, $7E0eS._)(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : (0, $7E0eS._)(objB)) !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.hasOwnProperty.call(objB, keysA[i]) || !$e04d4b638436dc5e$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $e04d4b638436dc5e$var$is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $e04d4b638436dc5e$var$hoistBlackList = {
    $$typeof: 1,
    render: 1,
    compare: 1,
    type: 1,
    childContextTypes: 1,
    contextType: 1,
    contextTypes: 1,
    defaultProps: 1,
    getDefaultProps: 1,
    getDerivedStateFromError: 1,
    getDerivedStateFromProps: 1,
    mixins: 1,
    displayName: 1,
    propTypes: 1
};
function $e04d4b638436dc5e$var$copyStaticProperties(base, target) {
    var protoProps = Object.getOwnPropertyNames(Object.getPrototypeOf(base));
    Object.getOwnPropertyNames(base).forEach(function(key) {
        if (!$e04d4b638436dc5e$var$hoistBlackList[key] && protoProps.indexOf(key) === -1) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}
/**
 * Utilities for patching componentWillUnmount, to make sure @disposeOnUnmount works correctly icm with user defined hooks
 * and the handler provided by mobx-react
 */ var $e04d4b638436dc5e$var$mobxMixins = /*#__PURE__*/ Symbol("patchMixins");
var $e04d4b638436dc5e$var$mobxPatchedDefinition = /*#__PURE__*/ Symbol("patchedDefinition");
function $e04d4b638436dc5e$var$getMixins(target, methodName) {
    var mixins = target[$e04d4b638436dc5e$var$mobxMixins] = target[$e04d4b638436dc5e$var$mobxMixins] || {};
    var methodMixins = mixins[methodName] = mixins[methodName] || {};
    methodMixins.locks = methodMixins.locks || 0;
    methodMixins.methods = methodMixins.methods || [];
    return methodMixins;
}
function $e04d4b638436dc5e$var$wrapper(realMethod, mixins) {
    var _this = this;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
    mixins.locks++;
    try {
        var retVal;
        if (realMethod !== undefined && realMethod !== null) retVal = realMethod.apply(this, args);
        return retVal;
    } finally{
        mixins.locks--;
        if (mixins.locks === 0) mixins.methods.forEach(function(mx) {
            mx.apply(_this, args);
        });
    }
}
function $e04d4b638436dc5e$var$wrapFunction(realMethod, mixins) {
    var fn = function fn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $e04d4b638436dc5e$var$wrapper.call.apply($e04d4b638436dc5e$var$wrapper, [
            this,
            realMethod,
            mixins
        ].concat(args));
    };
    return fn;
}
function $e04d4b638436dc5e$var$patch(target, methodName, mixinMethod) {
    var mixins = $e04d4b638436dc5e$var$getMixins(target, methodName);
    if (mixins.methods.indexOf(mixinMethod) < 0) mixins.methods.push(mixinMethod);
    var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
    if (oldDefinition && oldDefinition[$e04d4b638436dc5e$var$mobxPatchedDefinition]) // already patched definition, do not repatch
    return;
    var originalMethod = target[methodName];
    var newDefinition = $e04d4b638436dc5e$var$createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
    Object.defineProperty(target, methodName, newDefinition);
}
function $e04d4b638436dc5e$var$createDefinition(target, methodName, enumerable, mixins, originalMethod) {
    var _ref;
    var wrappedFunc = $e04d4b638436dc5e$var$wrapFunction(originalMethod, mixins);
    return _ref = {}, _ref[$e04d4b638436dc5e$var$mobxPatchedDefinition] = true, _ref.get = function get() {
        return wrappedFunc;
    }, _ref.set = function set(value) {
        if (this === target) wrappedFunc = $e04d4b638436dc5e$var$wrapFunction(value, mixins);
        else {
            // when it is an instance of the prototype/a child prototype patch that particular case again separately
            // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
            // e.g. the method for super might not be the same as the method for the prototype which might be not the same
            // as the method for the instance
            var newDefinition = $e04d4b638436dc5e$var$createDefinition(this, methodName, enumerable, mixins, value);
            Object.defineProperty(this, methodName, newDefinition);
        }
    }, _ref.configurable = true, _ref.enumerable = enumerable, _ref;
}
var $e04d4b638436dc5e$var$administrationSymbol = /*#__PURE__*/ Symbol("ObserverAdministration");
var $e04d4b638436dc5e$var$isMobXReactObserverSymbol = /*#__PURE__*/ Symbol("isMobXReactObserver");
var $e04d4b638436dc5e$var$observablePropDescriptors;
function $e04d4b638436dc5e$var$getAdministration(component) {
    var _component$administra;
    // We create administration lazily, because we can't patch constructor
    // and the exact moment of initialization partially depends on React internals.
    // At the time of writing this, the first thing invoked is one of the observable getter/setter (state/props/context).
    return (_component$administra = component[$e04d4b638436dc5e$var$administrationSymbol]) != null ? _component$administra : component[$e04d4b638436dc5e$var$administrationSymbol] = {
        reaction: null,
        mounted: false,
        reactionInvalidatedBeforeMount: false,
        forceUpdate: null,
        name: $e04d4b638436dc5e$var$getDisplayName(component.constructor),
        state: undefined,
        props: undefined,
        context: undefined
    };
}
function $e04d4b638436dc5e$var$makeClassComponentObserver(componentClass) {
    var prototype = componentClass.prototype;
    if (componentClass[$e04d4b638436dc5e$var$isMobXReactObserverSymbol]) {
        var displayName = $e04d4b638436dc5e$var$getDisplayName(componentClass);
        throw new Error("The provided component class (" + displayName + ") has already been declared as an observer component.");
    } else componentClass[$e04d4b638436dc5e$var$isMobXReactObserverSymbol] = true;
    if (prototype.componentWillReact) throw new Error("The componentWillReact life-cycle event is no longer supported");
    if (componentClass["__proto__"] !== (0, $1aLYV.PureComponent)) {
        if (!prototype.shouldComponentUpdate) prototype.shouldComponentUpdate = $e04d4b638436dc5e$var$observerSCU;
        else if (prototype.shouldComponentUpdate !== $e04d4b638436dc5e$var$observerSCU) // n.b. unequal check, instead of existence check, as @observer might be on superclass as well
        throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
    }
    var originalRender = prototype.render;
    if (typeof originalRender !== "function") {
        var _displayName = $e04d4b638436dc5e$var$getDisplayName(componentClass);
        throw new Error("[mobx-react] class component (" + _displayName + ") is missing `render` method." + "\n`observer` requires `render` being a function defined on prototype." + "\n`render = () => {}` or `render = function() {}` is not supported.");
    }
    prototype.render = function() {
        Object.defineProperty(this, "render", {
            // There is no safe way to replace render, therefore it's forbidden.
            configurable: false,
            writable: false,
            value: (0, $fbb6d1707652b0db$export$55979271896d643e)() ? originalRender : $e04d4b638436dc5e$var$createReactiveRender.call(this, originalRender)
        });
        return this.render();
    };
    var originalComponentDidMount = prototype.componentDidMount;
    prototype.componentDidMount = function() {
        var _this = this;
        var _displayName2;
        // `componentDidMount` may not be called at all. React can abandon the instance after `render`.
        // That's why we use finalization registry to dispose reaction created during render.
        // Happens with `<Suspend>` see #3492
        //
        // `componentDidMount` can be called immediately after `componentWillUnmount` without calling `render` in between.
        // Happens with `<StrictMode>`see #3395.
        //
        // If `componentDidMount` is called, it's guaranteed to run synchronously with render (similary to `useLayoutEffect`).
        // Therefore we don't have to worry about external (observable) state being updated before mount (no state version checking).
        //
        // Things may change: "In the future, React will provide a feature that lets components preserve state between unmounts"
        var admin = $e04d4b638436dc5e$var$getAdministration(this);
        admin.mounted = true;
        // Component instance committed, prevent reaction disposal.
        (0, $62a2b68bdaef3c11$export$10e8a12fbfd8583c).unregister(this);
        // We don't set forceUpdate before mount because it requires a reference to `this`,
        // therefore `this` could NOT be garbage collected before mount,
        // preventing reaction disposal by FinalizationRegistry and leading to memory leak.
        // As an alternative we could have `admin.instanceRef = new WeakRef(this)`, but lets avoid it if possible.
        admin.forceUpdate = function() {
            return _this.forceUpdate();
        };
        if (!admin.reaction || admin.reactionInvalidatedBeforeMount) // Missing reaction:
        // 1. Instance was unmounted (reaction disposed) and immediately remounted without running render #3395.
        // 2. Reaction was disposed by finalization registry before mount. Shouldn't ever happen for class components:
        // `componentDidMount` runs synchronously after render, but our registry are deferred (can't run in between).
        // In any case we lost subscriptions to observables, so we have to create new reaction and re-render to resubscribe.
        // The reaction will be created lazily by following render.
        // Reaction invalidated before mount:
        // 1. A descendant's `componenDidMount` invalidated it's parent #3730
        admin.forceUpdate();
        return originalComponentDidMount == null ? void 0 : originalComponentDidMount.apply(this, arguments);
    };
    // TODO@major Overly complicated "patch" is only needed to support the deprecated @disposeOnUnmount
    $e04d4b638436dc5e$var$patch(prototype, "componentWillUnmount", function() {
        var _admin$reaction;
        if ((0, $fbb6d1707652b0db$export$55979271896d643e)()) return;
        var admin = $e04d4b638436dc5e$var$getAdministration(this);
        (_admin$reaction = admin.reaction) == null || _admin$reaction.dispose();
        admin.reaction = null;
        admin.forceUpdate = null;
        admin.mounted = false;
        admin.reactionInvalidatedBeforeMount = false;
    });
    return componentClass;
}
// Generates a friendly name for debugging
function $e04d4b638436dc5e$var$getDisplayName(componentClass) {
    return componentClass.displayName || componentClass.name || "<component>";
}
function $e04d4b638436dc5e$var$createReactiveRender(originalRender) {
    var boundOriginalRender = originalRender.bind(this);
    var admin = $e04d4b638436dc5e$var$getAdministration(this);
    function reactiveRender() {
        if (!admin.reaction) {
            // Create reaction lazily to support re-mounting #3395
            admin.reaction = $e04d4b638436dc5e$var$createReaction(admin);
            if (!admin.mounted) // React can abandon this instance and never call `componentDidMount`/`componentWillUnmount`,
            // we have to make sure reaction will be disposed.
            (0, $62a2b68bdaef3c11$export$10e8a12fbfd8583c).register(this, admin, this);
        }
        var error = undefined;
        var renderResult = undefined;
        admin.reaction.track(function() {
            try {
                // TODO@major
                // Optimization: replace with _allowStateChangesStart/End (not available in mobx@6.0.0)
                renderResult = (0, $h2kUE._allowStateChanges)(false, boundOriginalRender);
            } catch (e) {
                error = e;
            }
        });
        if (error) throw error;
        return renderResult;
    }
    return reactiveRender;
}
function $e04d4b638436dc5e$var$createReaction(admin) {
    return new (0, $h2kUE.Reaction)(admin.name + ".render()", function() {
        if (!admin.mounted) {
            // This is neccessary to avoid react warning about calling forceUpdate on component that isn't mounted yet.
            // This happens when component is abandoned after render - our reaction is already created and reacts to changes.
            // `componenDidMount` runs synchronously after `render`, so unlike functional component, there is no delay during which the reaction could be invalidated.
            // However `componentDidMount` runs AFTER it's descendants' `componentDidMount`, which CAN invalidate the reaction, see #3730. Therefore remember and forceUpdate on mount.
            admin.reactionInvalidatedBeforeMount = true;
            return;
        }
        try {
            admin.forceUpdate == null || admin.forceUpdate();
        } catch (error) {
            var _admin$reaction2;
            (_admin$reaction2 = admin.reaction) == null || _admin$reaction2.dispose();
            admin.reaction = null;
        }
    });
}
function $e04d4b638436dc5e$var$observerSCU(nextProps, nextState) {
    if ((0, $fbb6d1707652b0db$export$55979271896d643e)()) console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
    // update on any state changes (as is the default)
    if (this.state !== nextState) return true;
    // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.
    return !$e04d4b638436dc5e$var$shallowEqual(this.props, nextProps);
}
function $e04d4b638436dc5e$var$createObservablePropDescriptor(key) {
    return {
        configurable: true,
        enumerable: true,
        get: function get() {
            var admin = $e04d4b638436dc5e$var$getAdministration(this);
            var derivation = (0, $h2kUE._getGlobalState)().trackingDerivation;
            if (derivation && derivation !== admin.reaction) throw new Error("[mobx-react] Cannot read \"" + admin.name + "." + key + "\" in a reactive context, as it isn't observable.\n                    Please use component lifecycle method to copy the value into a local observable first.\n                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations");
            return admin[key];
        },
        set: function set(value) {
            $e04d4b638436dc5e$var$getAdministration(this)[key] = value;
        }
    };
}
function $e04d4b638436dc5e$export$b6ae1bc530f4c149(component, context) {
    if (context && context.kind !== "class") throw new Error("The @observer decorator can be used on classes only");
    if (component["isMobxInjector"] === true) console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`");
    if (Object.prototype.isPrototypeOf.call((0, $tLNoZ.Component), component) || Object.prototype.isPrototypeOf.call((0, $1aLYV.PureComponent), component)) // Class component
    return $e04d4b638436dc5e$var$makeClassComponentObserver(component);
    else // Function component
    return (0, $3216ea70456c1fc3$export$b6ae1bc530f4c149)(component);
}
function $e04d4b638436dc5e$var$_extends() {
    return $e04d4b638436dc5e$var$_extends = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e04d4b638436dc5e$var$_extends.apply(null, arguments);
}
function $e04d4b638436dc5e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $e04d4b638436dc5e$var$_excluded = [
    "children"
];
var $e04d4b638436dc5e$export$f07786cea590ef31 = /*#__PURE__*/ (0, $1aLYV.default).createContext({});
function $e04d4b638436dc5e$export$2881499e37b75b9a(props) {
    var children = props.children, stores = $e04d4b638436dc5e$var$_objectWithoutPropertiesLoose(props, $e04d4b638436dc5e$var$_excluded);
    var parentValue = (0, $1aLYV.default).useContext($e04d4b638436dc5e$export$f07786cea590ef31);
    var mutableProviderRef = (0, $1aLYV.default).useRef($e04d4b638436dc5e$var$_extends({}, parentValue, stores));
    var value = mutableProviderRef.current;
    var newValue;
    return (0, $1aLYV.default).createElement($e04d4b638436dc5e$export$f07786cea590ef31.Provider, {
        value: value
    }, children);
}
$e04d4b638436dc5e$export$2881499e37b75b9a.displayName = "MobXProvider";
/**
 * Store Injection
 */ function $e04d4b638436dc5e$var$createStoreInjector(grabStoresFn, component, injectNames, makeReactive) {
    // Support forward refs
    var Injector = (0, $1aLYV.default).forwardRef(function(props, ref) {
        var newProps = $e04d4b638436dc5e$var$_extends({}, props);
        var context = (0, $1aLYV.default).useContext($e04d4b638436dc5e$export$f07786cea590ef31);
        Object.assign(newProps, grabStoresFn(context || {}, newProps) || {});
        if (ref) newProps.ref = ref;
        return (0, $1aLYV.default).createElement(component, newProps);
    });
    if (makeReactive) Injector = $e04d4b638436dc5e$export$b6ae1bc530f4c149(Injector);
    Injector["isMobxInjector"] = true; // assigned late to suppress observer warning
    // Static fields from component should be visible on the generated Injector
    $e04d4b638436dc5e$var$copyStaticProperties(component, Injector);
    Injector["wrappedComponent"] = component;
    Injector.displayName = $e04d4b638436dc5e$var$getInjectName(component, injectNames);
    return Injector;
}
function $e04d4b638436dc5e$var$getInjectName(component, injectNames) {
    var displayName;
    var componentName = component.displayName || component.name || component.constructor && component.constructor.name || "Component";
    if (injectNames) displayName = "inject-with-" + injectNames + "(" + componentName + ")";
    else displayName = "inject(" + componentName + ")";
    return displayName;
}
function $e04d4b638436dc5e$var$grabStoresByName(storeNames) {
    return function(baseStores, nextProps) {
        storeNames.forEach(function(storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}
/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */ function $e04d4b638436dc5e$export$a976684a0efeb93f() {
    for(var _len = arguments.length, storeNames = new Array(_len), _key = 0; _key < _len; _key++)storeNames[_key] = arguments[_key];
    if (typeof arguments[0] === "function") {
        var grabStoresFn = arguments[0];
        return function(componentClass) {
            return $e04d4b638436dc5e$var$createStoreInjector(grabStoresFn, componentClass, grabStoresFn.name, true);
        };
    } else return function(componentClass) {
        return $e04d4b638436dc5e$var$createStoreInjector($e04d4b638436dc5e$var$grabStoresByName(storeNames), componentClass, storeNames.join("-"), false);
    };
}
var $e04d4b638436dc5e$var$reactMajorVersion = /*#__PURE__*/ Number.parseInt((0, $1aLYV.default).version, 10);
var $e04d4b638436dc5e$var$warnedAboutDisposeOnUnmountDeprecated = false;
var $e04d4b638436dc5e$var$protoStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountProto");
var $e04d4b638436dc5e$var$instStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountInst");
function $e04d4b638436dc5e$var$runDisposersOnWillUnmount() {
    var _this = this;
    [].concat(this[$e04d4b638436dc5e$var$protoStoreKey] || [], this[$e04d4b638436dc5e$var$instStoreKey] || []).forEach(function(propKeyOrFunction) {
        var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;
        if (prop !== undefined && prop !== null) {
            if (Array.isArray(prop)) prop.map(function(f) {
                return f();
            });
            else prop();
        }
    });
}
/**
 * @deprecated `disposeOnUnmount` is not compatible with React 18 and higher.
 */ function $e04d4b638436dc5e$export$4e749cb731da87a9(target, propertyKeyOrFunction) {
    if (Array.isArray(propertyKeyOrFunction)) return propertyKeyOrFunction.map(function(fn) {
        return $e04d4b638436dc5e$export$4e749cb731da87a9(target, fn);
    });
    if (!$e04d4b638436dc5e$var$warnedAboutDisposeOnUnmountDeprecated) {
        if ($e04d4b638436dc5e$var$reactMajorVersion >= 18) console.error("[mobx-react] disposeOnUnmount is not compatible with React 18 and higher. Don't use it.");
        else console.warn("[mobx-react] disposeOnUnmount is deprecated. It won't work correctly with React 18 and higher.");
        $e04d4b638436dc5e$var$warnedAboutDisposeOnUnmountDeprecated = true;
    }
    var c = Object.getPrototypeOf(target).constructor;
    var c2 = Object.getPrototypeOf(target.constructor);
    // Special case for react-hot-loader
    var c3 = Object.getPrototypeOf(Object.getPrototypeOf(target));
    if (!(c === (0, $1aLYV.default).Component || c === (0, $1aLYV.default).PureComponent || c2 === (0, $1aLYV.default).Component || c2 === (0, $1aLYV.default).PureComponent || c3 === (0, $1aLYV.default).Component || c3 === (0, $1aLYV.default).PureComponent)) throw new Error("[mobx-react] disposeOnUnmount only supports direct subclasses of React.Component or React.PureComponent.");
    if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function" && !Array.isArray(propertyKeyOrFunction)) throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
    // decorator's target is the prototype, so it doesn't have any instance properties like props
    var isDecorator = typeof propertyKeyOrFunction === "string";
    // add property key / function we want run (disposed) to the store
    var componentWasAlreadyModified = !!target[$e04d4b638436dc5e$var$protoStoreKey] || !!target[$e04d4b638436dc5e$var$instStoreKey];
    var store = isDecorator ? // decorators are added to the prototype store
    target[$e04d4b638436dc5e$var$protoStoreKey] || (target[$e04d4b638436dc5e$var$protoStoreKey] = []) : // functions are added to the instance store
    target[$e04d4b638436dc5e$var$instStoreKey] || (target[$e04d4b638436dc5e$var$instStoreKey] = []);
    store.push(propertyKeyOrFunction);
    // tweak the component class componentWillUnmount if not done already
    if (!componentWasAlreadyModified) $e04d4b638436dc5e$var$patch(target, "componentWillUnmount", $e04d4b638436dc5e$var$runDisposersOnWillUnmount);
    // return the disposer as is if invoked as a non decorator
    if (typeof propertyKeyOrFunction !== "string") return propertyKeyOrFunction;
}
// Copied from React.PropTypes
function $e04d4b638436dc5e$var$createChainableTypeChecker(validator) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)rest[_key - 6] = arguments[_key];
        return (0, $h2kUE.untracked)(function() {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else // @ts-ignore rest arg is necessary for some React internals - fails tests otherwise
            return validator.apply(void 0, [
                props,
                propName,
                componentName,
                location,
                propFullName
            ].concat(rest));
        });
    }
    var chainedCheckType = checkType.bind(null, false);
    // Add isRequired to satisfy Requirable
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
// Copied from React.PropTypes
function $e04d4b638436dc5e$var$isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") return true;
    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") return true;
    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
    return false;
}
// Copied from React.PropTypes
function $e04d4b638436dc5e$var$getPropType(propValue) {
    var propType = typeof propValue === "undefined" ? "undefined" : (0, $7E0eS._)(propValue);
    if (Array.isArray(propValue)) return "array";
    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
    if ($e04d4b638436dc5e$var$isSymbol(propType, propValue)) return "symbol";
    return propType;
}
// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function $e04d4b638436dc5e$var$getPreciseType(propValue) {
    var propType = $e04d4b638436dc5e$var$getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) return "date";
        else if (propValue instanceof RegExp) return "regexp";
    }
    return propType;
}
function $e04d4b638436dc5e$var$createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return $e04d4b638436dc5e$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        return (0, $h2kUE.untracked)(function() {
            if (allowNativeType) {
                if ($e04d4b638436dc5e$var$getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker;
            switch(mobxType){
                case "Array":
                    mobxChecker = (0, $h2kUE.isObservableArray);
                    break;
                case "Object":
                    mobxChecker = (0, $h2kUE.isObservableObject);
                    break;
                case "Map":
                    mobxChecker = (0, $h2kUE.isObservableMap);
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = $e04d4b638436dc5e$var$getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}
function $e04d4b638436dc5e$var$createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return $e04d4b638436dc5e$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++)rest[_key2 - 5] = arguments[_key2];
        return (0, $h2kUE.untracked)(function() {
            if (typeof typeChecker !== "function") return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            else {
                var error = $e04d4b638436dc5e$var$createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName, location, propFullName);
                if (error instanceof Error) return error;
                var propValue = props[propName];
                for(var i = 0; i < propValue.length; i++){
                    error = typeChecker.apply(void 0, [
                        propValue,
                        i,
                        componentName,
                        location,
                        propFullName + "[" + i + "]"
                    ].concat(rest));
                    if (error instanceof Error) return error;
                }
                return null;
            }
        });
    });
}
var $e04d4b638436dc5e$var$observableArray = /*#__PURE__*/ $e04d4b638436dc5e$var$createObservableTypeCheckerCreator(false, "Array");
var $e04d4b638436dc5e$var$observableArrayOf = /*#__PURE__*/ $e04d4b638436dc5e$var$createObservableArrayOfTypeChecker.bind(null, false);
var $e04d4b638436dc5e$var$observableMap = /*#__PURE__*/ $e04d4b638436dc5e$var$createObservableTypeCheckerCreator(false, "Map");
var $e04d4b638436dc5e$var$observableObject = /*#__PURE__*/ $e04d4b638436dc5e$var$createObservableTypeCheckerCreator(false, "Object");
var $e04d4b638436dc5e$var$arrayOrObservableArray = /*#__PURE__*/ $e04d4b638436dc5e$var$createObservableTypeCheckerCreator(true, "Array");
var $e04d4b638436dc5e$var$arrayOrObservableArrayOf = /*#__PURE__*/ $e04d4b638436dc5e$var$createObservableArrayOfTypeChecker.bind(null, true);
var $e04d4b638436dc5e$var$objectOrObservableObject = /*#__PURE__*/ $e04d4b638436dc5e$var$createObservableTypeCheckerCreator(true, "Object");
var $e04d4b638436dc5e$export$e0c95a451cd220b7 = {
    observableArray: $e04d4b638436dc5e$var$observableArray,
    observableArrayOf: $e04d4b638436dc5e$var$observableArrayOf,
    observableMap: $e04d4b638436dc5e$var$observableMap,
    observableObject: $e04d4b638436dc5e$var$observableObject,
    arrayOrObservableArray: $e04d4b638436dc5e$var$arrayOrObservableArray,
    arrayOrObservableArrayOf: $e04d4b638436dc5e$var$arrayOrObservableArrayOf,
    objectOrObservableObject: $e04d4b638436dc5e$var$objectOrObservableObject
};
if (!(0, $tLNoZ.Component)) throw new Error("mobx-react requires React to be available");
if (!(0, $h2kUE.observable)) throw new Error("mobx-react requires mobx to be available");


var $524de0d5a72e1bc6$exports = {};








var $cInIr = parcelRequire("cInIr");

var $h2kUE = parcelRequire("h2kUE");
parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");

var $lhPyT = parcelRequire("lhPyT");
function $524de0d5a72e1bc6$var$$parcel$exportWildcard(e, t) {
    return Object.keys(t).forEach(function(r) {
        "default" === r || "__esModule" === r || Object.prototype.hasOwnProperty.call(e, r) || Object.defineProperty(e, r, {
            enumerable: !0,
            get: function get() {
                return t[r];
            }
        });
    }), e;
}
function $524de0d5a72e1bc6$var$$parcel$interopDefault(e) {
    return e && e.__esModule ? e.default : e;
}
function $524de0d5a72e1bc6$var$$parcel$export(e, t, r, a) {
    Object.defineProperty(e, t, {
        get: r,
        set: a,
        enumerable: !0,
        configurable: !0
    });
}
var $524de0d5a72e1bc6$var$$0172b398bee57f0a$exports = {};
$524de0d5a72e1bc6$var$$parcel$export($524de0d5a72e1bc6$var$$0172b398bee57f0a$exports, "isEqualProps", function() {
    return $524de0d5a72e1bc6$var$$0172b398bee57f0a$export$7112c88e033533b8;
}), $524de0d5a72e1bc6$var$$parcel$export($524de0d5a72e1bc6$var$$0172b398bee57f0a$exports, "reaction", function() {
    return $524de0d5a72e1bc6$var$$0172b398bee57f0a$export$7203b476385689ae;
}), $524de0d5a72e1bc6$var$$parcel$export($524de0d5a72e1bc6$var$$0172b398bee57f0a$exports, "ObservedComponent", function() {
    return $524de0d5a72e1bc6$var$$0172b398bee57f0a$export$bf180ef329d1efd8;
});
var $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__esDecorate = function $0172b398bee57f0a$var$__esDecorate(e, t, r, a, s, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), f = !1, d = r.length - 1; d >= 0; d--){
        var b = {};
        for(var p in a)b[p] = "access" === p ? {} : a[p];
        for(var p in a.access)b.access[p] = a.access[p];
        b.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[d])("accessor" === o ? {
            get: u.get,
            set: u.set
        } : u[l], b);
        if ("accessor" === o) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (c = i(v.get)) && (u.get = c), (c = i(v.set)) && (u.set = c), (c = i(v.init)) && s.unshift(c);
        } else (c = i(v)) && ("field" === o ? s.unshift(c) : u[l] = c);
    }
    $ && Object.defineProperty($, a.name, u), f = !0;
}, $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__runInitializers = function $0172b398bee57f0a$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, s = 0; s < t.length; s++)r = a ? t[s].call(e, r) : t[s].call(e);
    return a ? r : void 0;
}, $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__classPrivateFieldGet = function $0172b398bee57f0a$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__classPrivateFieldSet = function $0172b398bee57f0a$var$__classPrivateFieldSet(e, t, r, a, s) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !s) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !s : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? s.call(e, r) : s ? s.value = r : t.set(e, r), r;
}, $524de0d5a72e1bc6$var$$0172b398bee57f0a$export$7112c88e033533b8 = function $0172b398bee57f0a$export$7112c88e033533b8(e, t) {
    return $524de0d5a72e1bc6$var$$parcel$interopDefault($cInIr)(e, t, function(e, t, r) {
        return [
            "_owner",
            "$$typeof"
        ].includes(r) || void 0;
    });
}, $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$reactionMap = new WeakMap, $524de0d5a72e1bc6$var$$0172b398bee57f0a$export$7203b476385689ae = function $0172b398bee57f0a$export$7203b476385689ae(e) {
    return function(t, r) {
        return (0, r.addInitializer)(function() {
            var _$r = $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$reactionMap.get(this) || [];
            _$r.push({
                expression: e,
                effect: t
            }), $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$reactionMap.set(this, _$r);
        });
    };
}, $524de0d5a72e1bc6$var$$0172b398bee57f0a$export$bf180ef329d1efd8 = function() {
    var e, t, r, a, s, n, i, c, o, l, $, u, f = $tLNoZ.Component, d = [], b = [], p = [], v = [], _ = [], h = [];
    return r = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), s.set(_$e, $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__runInitializers(_$e, d, _$e.props)), n.set(_$e, ($524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__runInitializers(_$e, b), $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__runInitializers(_$e, p, _$e.state))), i.set(_$e, ($524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__runInitializers(_$e, v), $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__runInitializers(_$e, _, _$e.context))), a.set(_$e, $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__runInitializers(_$e, h)), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "observedProps",
                get: function get() {
                    return $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, s, "f");
                },
                set: function set(e) {
                    $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, s, e, "f");
                }
            },
            {
                key: "observedState",
                get: function get() {
                    return $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, n, "f");
                },
                set: function set(e) {
                    $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, n, e, "f");
                }
            },
            {
                key: "observedContext",
                get: function get() {
                    return $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, i, "f");
                },
                set: function set(e) {
                    $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, i, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    var _$e, _$t = this;
                    $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, a, null == (_$e = $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$reactionMap.get(this)) ? void 0 : _$e.map(function(e) {
                        var r = e.expression, a = e.effect;
                        return (0, $h2kUE.reaction)(function(e) {
                            return r(_$t, e);
                        }, a.bind(_$t));
                    }), "f");
                }
            },
            {
                key: "componentWillUnmount",
                value: function value() {
                    var _$e;
                    null == (_$e = $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, a, "f")) || _$e.forEach(function(e) {
                        return e();
                    });
                }
            },
            {
                key: "componentDidUpdate",
                value: function value(e, r, a) {
                    var s;
                    $524de0d5a72e1bc6$var$$0172b398bee57f0a$export$7112c88e033533b8(e, this.props) || (this.observedProps = Object.assign({}, this.props)), $524de0d5a72e1bc6$var$$0172b398bee57f0a$export$7112c88e033533b8(r, this.state) || (this.observedState = Object.assign({}, this.state)), null == (s = (0, $57751a2649dd1683$export$71511d61b312f219)((0, $ae6313b3cbf000af$export$71511d61b312f219)(t.prototype), "componentDidUpdate", this)) || s.call(this, e, r, a);
                }
            }
        ]), t;
    }(f), a = new WeakMap, s = new WeakMap, n = new WeakMap, i = new WeakMap, t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = f[Symbol.metadata]) ? e : null) : void 0, l = [
        (e = $h2kUE.observable).shallow.bind(e)
    ], $ = [
        (c = $h2kUE.observable).shallow.bind(c)
    ], u = [
        (o = $h2kUE.observable).shallow.bind(o)
    ], $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__esDecorate(r, null, l, {
        kind: "accessor",
        name: "observedProps",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "observedProps" in e;
            },
            get: function get(e) {
                return e.observedProps;
            },
            set: function set(e, t) {
                e.observedProps = t;
            }
        },
        metadata: t
    }, d, b), $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__esDecorate(r, null, $, {
        kind: "accessor",
        name: "observedState",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "observedState" in e;
            },
            get: function get(e) {
                return e.observedState;
            },
            set: function set(e, t) {
                e.observedState = t;
            }
        },
        metadata: t
    }, p, v), $524de0d5a72e1bc6$var$$0172b398bee57f0a$var$__esDecorate(r, null, u, {
        kind: "accessor",
        name: "observedContext",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "observedContext" in e;
            },
            get: function get(e) {
                return e.observedContext;
            },
            set: function set(e, t) {
                e.observedContext = t;
            }
        },
        metadata: t
    }, _, h), t && Object.defineProperty(r, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), r;
}(), $524de0d5a72e1bc6$var$$621b7277d4dc39e9$exports = {};
$524de0d5a72e1bc6$var$$parcel$export($524de0d5a72e1bc6$var$$621b7277d4dc39e9$exports, "FormComponent", function() {
    return $524de0d5a72e1bc6$var$$621b7277d4dc39e9$export$cec7cafc710f5d68;
});
var $524de0d5a72e1bc6$var$$621b7277d4dc39e9$var$__runInitializers = function $621b7277d4dc39e9$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, s = 0; s < t.length; s++)r = a ? t[s].call(e, r) : t[s].call(e);
    return a ? r : void 0;
}, $524de0d5a72e1bc6$var$$621b7277d4dc39e9$var$__esDecorate = function $621b7277d4dc39e9$var$__esDecorate(e, t, r, a, s, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), f = !1, d = r.length - 1; d >= 0; d--){
        var b = {};
        for(var p in a)b[p] = "access" === p ? {} : a[p];
        for(var p in a.access)b.access[p] = a.access[p];
        b.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[d])("accessor" === o ? {
            get: u.get,
            set: u.set
        } : u[l], b);
        if ("accessor" === o) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (c = i(v.get)) && (u.get = c), (c = i(v.set)) && (u.set = c), (c = i(v.init)) && s.unshift(c);
        } else (c = i(v)) && ("field" === o ? s.unshift(c) : u[l] = c);
    }
    $ && Object.defineProperty($, a.name, u), f = !0;
}, $524de0d5a72e1bc6$var$$621b7277d4dc39e9$var$__classPrivateFieldGet = function $621b7277d4dc39e9$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $524de0d5a72e1bc6$var$$621b7277d4dc39e9$var$__classPrivateFieldSet = function $621b7277d4dc39e9$var$__classPrivateFieldSet(e, t, r, a, s) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !s) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !s : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? s.call(e, r) : s ? s.value = r : t.set(e, r), r;
}, $524de0d5a72e1bc6$var$$621b7277d4dc39e9$export$cec7cafc710f5d68 = function() {
    var e, t, r, a, s, n, i, c, o, l = [], $ = [], u = [];
    return e = function(e) {
        "use strict";
        function n() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, n), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, n, arguments), Object.defineProperty(_$e, "ref", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($524de0d5a72e1bc6$var$$621b7277d4dc39e9$var$__runInitializers(_$e, l), (0, $tLNoZ.createRef)())
            }), s.set(_$e, $524de0d5a72e1bc6$var$$621b7277d4dc39e9$var$__runInitializers(_$e, $, _$e.props.defaultValue)), t.set(_$e, $524de0d5a72e1bc6$var$$621b7277d4dc39e9$var$__runInitializers(_$e, u)), r.set(_$e, void 0), a.set(_$e, function(t) {
                !(0, $lhPyT.isEmpty)(t) && (0, $lhPyT.isEmpty)(_$e.innerValue) && (_$e.innerValue = t);
            }), Object.defineProperty(_$e, "emitValue", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    var r, a;
                    return null == (a = (r = _$e.observedProps).onChange) ? void 0 : a.call(r, t && (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "object" ? (0, $h2kUE.toJS)(t) : t);
                }
            }), Object.defineProperty(_$e, "reset", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value() {
                    return _$e.innerValue = _$e.props.defaultValue;
                }
            }), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(n, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(n, [
            {
                key: "innerValue",
                get: function get() {
                    return $524de0d5a72e1bc6$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, s, "f");
                },
                set: function set(e) {
                    $524de0d5a72e1bc6$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, s, e, "f");
                }
            },
            {
                key: "value",
                get: function get() {
                    var _$e;
                    return null != (_$e = this.observedProps.value) ? _$e : this.innerValue;
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    var _$e, s, _$n = this;
                    $524de0d5a72e1bc6$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, t, (0, $h2kUE.reaction)(function() {
                        return _$n.observedProps.defaultValue;
                    }, $524de0d5a72e1bc6$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, a, "f")), "f"), $524de0d5a72e1bc6$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, r, (0, $h2kUE.reaction)(function() {
                        return _$n.innerValue;
                    }, this.emitValue), "f"), null == (s = null == (_$e = this.ref.current) ? void 0 : _$e.form) || s.addEventListener("reset", this.reset);
                }
            },
            {
                key: "componentWillUnmount",
                value: function value() {
                    var _$e, a, s, _$n;
                    null == (_$e = $524de0d5a72e1bc6$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, t, "f")) || _$e.call(this), $524de0d5a72e1bc6$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, t, void 0, "f"), null == (a = $524de0d5a72e1bc6$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, r, "f")) || a.call(this), $524de0d5a72e1bc6$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, r, void 0, "f"), null == (_$n = null == (s = this.ref.current) ? void 0 : s.form) || _$n.removeEventListener("reset", this.reset);
                }
            }
        ]), n;
    }($524de0d5a72e1bc6$var$$0172b398bee57f0a$export$bf180ef329d1efd8), t = new WeakMap, r = new WeakMap, a = new WeakMap, s = new WeakMap, o = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (c = $524de0d5a72e1bc6$var$$0172b398bee57f0a$export$bf180ef329d1efd8[Symbol.metadata]) ? c : null) : void 0, n = [
        $h2kUE.observable
    ], i = [
        $h2kUE.computed
    ], $524de0d5a72e1bc6$var$$621b7277d4dc39e9$var$__esDecorate(e, null, n, {
        kind: "accessor",
        name: "innerValue",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "innerValue" in e;
            },
            get: function get(e) {
                return e.innerValue;
            },
            set: function set(e, t) {
                e.innerValue = t;
            }
        },
        metadata: o
    }, $, u), $524de0d5a72e1bc6$var$$621b7277d4dc39e9$var$__esDecorate(e, null, i, {
        kind: "getter",
        name: "value",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "value" in e;
            },
            get: function get(e) {
                return e.value;
            }
        },
        metadata: o
    }, null, l), o && Object.defineProperty(e, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: o
    }), e;
}();
$524de0d5a72e1bc6$var$$parcel$exportWildcard($524de0d5a72e1bc6$exports, $524de0d5a72e1bc6$var$$0172b398bee57f0a$exports), $524de0d5a72e1bc6$var$$parcel$exportWildcard($524de0d5a72e1bc6$exports, $524de0d5a72e1bc6$var$$621b7277d4dc39e9$exports);



var $lhPyT = parcelRequire("lhPyT");
var $83c809b827209ab4$export$71511d61b312f219;
"use strict";
var $6d8df9a8ccf09ba3$export$71511d61b312f219;
"use strict";


function $6d8df9a8ccf09ba3$var$_construct(Parent, args, Class) {
    if ($89f24628c68feef3$export$71511d61b312f219()) $6d8df9a8ccf09ba3$export$71511d61b312f219 = $6d8df9a8ccf09ba3$var$_construct = Reflect.construct;
    else $6d8df9a8ccf09ba3$export$71511d61b312f219 = $6d8df9a8ccf09ba3$var$_construct = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $6c65bdb48c5f0e16$export$71511d61b312f219(instance, Class.prototype);
        return instance;
    };
    return $6d8df9a8ccf09ba3$var$_construct.apply(null, arguments);
}
$6d8df9a8ccf09ba3$export$71511d61b312f219 = $6d8df9a8ccf09ba3$var$_construct;



var $5bc1abbcab0546ee$export$71511d61b312f219;
"use strict";
function $5bc1abbcab0546ee$var$_is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
$5bc1abbcab0546ee$export$71511d61b312f219 = $5bc1abbcab0546ee$var$_is_native_function;



function $83c809b827209ab4$var$_wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $83c809b827209ab4$export$71511d61b312f219 = $83c809b827209ab4$var$_wrap_native_super = function(Class) {
        if (Class === null || !$5bc1abbcab0546ee$export$71511d61b312f219(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $6d8df9a8ccf09ba3$export$71511d61b312f219(Class, arguments, $ae6313b3cbf000af$export$71511d61b312f219(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $6c65bdb48c5f0e16$export$71511d61b312f219(Wrapper, Class);
    };
    return $83c809b827209ab4$var$_wrap_native_super(Class);
}
$83c809b827209ab4$export$71511d61b312f219 = $83c809b827209ab4$var$_wrap_native_super;



var $dafVd = parcelRequire("dafVd");

var $3gP77 = parcelRequire("3gP77");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $aUGqu = parcelRequire("aUGqu");

var $7t5yo = parcelRequire("7t5yo");

var $13u2V = parcelRequire("13u2V");
function $edbe2f6a95b5edf7$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $edbe2f6a95b5edf7$var$$22de11b45b0eeb97$exports = {};
$edbe2f6a95b5edf7$var$$parcel$export($edbe2f6a95b5edf7$var$$22de11b45b0eeb97$exports, "Defer", function() {
    return $edbe2f6a95b5edf7$export$c7e91f8aec23ae14;
});
$edbe2f6a95b5edf7$var$$parcel$export($edbe2f6a95b5edf7$var$$22de11b45b0eeb97$exports, "makeDefer", function() {
    return $edbe2f6a95b5edf7$export$51ca94569b882c51;
});
var $edbe2f6a95b5edf7$export$c7e91f8aec23ae14 = function $22de11b45b0eeb97$export$c7e91f8aec23ae14() {
    "use strict";
    var _this = this;
    (0, $173N4._)(this, $22de11b45b0eeb97$export$c7e91f8aec23ae14);
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
    });
};
var $edbe2f6a95b5edf7$export$51ca94569b882c51 = function() {
    return new $edbe2f6a95b5edf7$export$c7e91f8aec23ae14();
};
var $edbe2f6a95b5edf7$var$$e3640f413e0c36e7$exports = {};
$edbe2f6a95b5edf7$var$$parcel$export($edbe2f6a95b5edf7$var$$e3640f413e0c36e7$exports, "Observable", function() {
    return $edbe2f6a95b5edf7$export$77cea355fa80b5f4;
});
if (!Symbol.observable) Reflect.set(Symbol, "observable", Symbol("observable"));
var $edbe2f6a95b5edf7$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    "use strict";
    function $e3640f413e0c36e7$export$77cea355fa80b5f4(subscriber) {
        (0, $173N4._)(this, $e3640f413e0c36e7$export$77cea355fa80b5f4);
        this.subscriber = subscriber;
    }
    (0, $cFHGC._)($e3640f413e0c36e7$export$77cea355fa80b5f4, [
        {
            key: Symbol.observable,
            value: function value() {
                return this;
            }
        },
        {
            key: Symbol.asyncIterator,
            value: function value() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function() {
                    var queue, canceler, done, observer;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                queue = [
                                    new $edbe2f6a95b5edf7$export$c7e91f8aec23ae14()
                                ], done = false;
                                observer = {
                                    next: function(value) {
                                        if (done) return;
                                        queue[queue.length - 1].resolve(value);
                                        queue.push(new $edbe2f6a95b5edf7$export$c7e91f8aec23ae14());
                                    },
                                    error: function(reason) {
                                        if (!done) queue[queue.length - 1].reject(reason), done = true;
                                        if (canceler) canceler();
                                    },
                                    complete: function() {
                                        if (!done) queue[queue.length - 1].resolve(), done = true;
                                        if (canceler) canceler();
                                    }
                                };
                                canceler = this.subscriber(observer);
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    queue[0].promise
                                ];
                            case 2:
                                _state.sent();
                                queue.shift();
                                _state.label = 3;
                            case 3:
                                if (queue[0]) return [
                                    3,
                                    1
                                ];
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "toPromise",
            value: function toPromise() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var stack, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, item, err;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                stack = [];
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    12
                                ]);
                                _iterator = (0, $dafVd._)(this);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    5
                                ];
                                _value = _step.value;
                                item = _value;
                                stack.push(item);
                                if (stack.length > 2) stack.shift();
                                _state.label = 4;
                            case 4:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    12
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    12
                                ];
                            case 7:
                                _state.trys.push([
                                    7,
                                    ,
                                    10,
                                    11
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    _iterator.return()
                                ];
                            case 8:
                                _state.sent();
                                _state.label = 9;
                            case 9:
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 11:
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    2,
                                    stack[0]
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(onNext, onError, onComplete) {
                var _this = this;
                var stop = false;
                (function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, item, err, error;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        13,
                                        ,
                                        14
                                    ]);
                                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        6,
                                        7,
                                        12
                                    ]);
                                    _iterator = (0, $dafVd._)(this);
                                    _state.label = 2;
                                case 2:
                                    return [
                                        4,
                                        _iterator.next()
                                    ];
                                case 3:
                                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                        3,
                                        5
                                    ];
                                    _value = _step.value;
                                    item = _value;
                                    if (!stop) onNext(item);
                                    else return [
                                        3,
                                        5
                                    ];
                                    _state.label = 4;
                                case 4:
                                    _iteratorAbruptCompletion = false;
                                    return [
                                        3,
                                        2
                                    ];
                                case 5:
                                    return [
                                        3,
                                        12
                                    ];
                                case 6:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        12
                                    ];
                                case 7:
                                    _state.trys.push([
                                        7,
                                        ,
                                        10,
                                        11
                                    ]);
                                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                        3,
                                        9
                                    ];
                                    return [
                                        4,
                                        _iterator.return()
                                    ];
                                case 8:
                                    _state.sent();
                                    _state.label = 9;
                                case 9:
                                    return [
                                        3,
                                        11
                                    ];
                                case 10:
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                    return [
                                        7
                                    ];
                                case 11:
                                    return [
                                        7
                                    ];
                                case 12:
                                    if (onComplete instanceof Function) onComplete();
                                    return [
                                        3,
                                        14
                                    ];
                                case 13:
                                    error = _state.sent();
                                    if (onError instanceof Function) onError(error);
                                    return [
                                        3,
                                        14
                                    ];
                                case 14:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }).call(_this);
                })();
                return {
                    unsubscribe: function() {
                        return stop = true;
                    },
                    get closed () {
                        return stop;
                    }
                };
            }
        }
    ], [
        {
            key: "fromStream",
            value: function fromStream(list) {
                return new this(function(param) {
                    var next = param.next, complete = param.complete, error = param.error;
                    var stopped = false;
                    (function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, item, err, bug;
                            return (0, $13u2V._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            13,
                                            ,
                                            14
                                        ]);
                                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            6,
                                            7,
                                            12
                                        ]);
                                        _iterator = (0, $dafVd._)(list);
                                        _state.label = 2;
                                    case 2:
                                        return [
                                            4,
                                            _iterator.next()
                                        ];
                                    case 3:
                                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                            3,
                                            5
                                        ];
                                        _value = _step.value;
                                        item = _value;
                                        if (!stopped) next(item);
                                        else return [
                                            3,
                                            5
                                        ];
                                        _state.label = 4;
                                    case 4:
                                        _iteratorAbruptCompletion = false;
                                        return [
                                            3,
                                            2
                                        ];
                                    case 5:
                                        return [
                                            3,
                                            12
                                        ];
                                    case 6:
                                        err = _state.sent();
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                        return [
                                            3,
                                            12
                                        ];
                                    case 7:
                                        _state.trys.push([
                                            7,
                                            ,
                                            10,
                                            11
                                        ]);
                                        if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                            3,
                                            9
                                        ];
                                        return [
                                            4,
                                            _iterator.return()
                                        ];
                                    case 8:
                                        _state.sent();
                                        _state.label = 9;
                                    case 9:
                                        return [
                                            3,
                                            11
                                        ];
                                    case 10:
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                        return [
                                            7
                                        ];
                                    case 11:
                                        return [
                                            7
                                        ];
                                    case 12:
                                        if (!stopped) complete();
                                        return [
                                            3,
                                            14
                                        ];
                                    case 13:
                                        bug = _state.sent();
                                        if (!stopped) error(bug);
                                        return [
                                            3,
                                            14
                                        ];
                                    case 14:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    })();
                    return function() {
                        return stopped = true;
                    };
                });
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
                    items[_key] = arguments[_key];
                }
                return this.fromStream(items);
            }
        },
        {
            key: "from",
            value: function from(observable) {
                if (Symbol.iterator in observable) return this.of.apply(this, (0, $aUGqu._)(observable));
                if (Symbol.asyncIterator in observable) return this.fromStream(observable);
                return new this(function(param) {
                    var next = param.next, error = param.error, complete = param.complete;
                    return observable.subscribe(next, error, complete).unsubscribe;
                });
            }
        },
        {
            key: "fromEvent",
            value: function fromEvent(target, name) {
                return new this(function(param) {
                    var next = param.next, error = param.error;
                    if (typeof target.on === "function") target.on(name, next).on("error", error);
                    else {
                        target.addEventListener(name, next);
                        target.addEventListener("error", error);
                    }
                    return function() {
                        if (typeof target.off === "function") target.off(name, next).off("error", error);
                        else {
                            target.removeEventListener(name, next);
                            target.removeEventListener("error", error);
                        }
                    };
                });
            }
        }
    ]);
    return $e3640f413e0c36e7$export$77cea355fa80b5f4;
}();
var $edbe2f6a95b5edf7$var$$603f33a01a36ab56$exports = {};
$edbe2f6a95b5edf7$var$$parcel$export($edbe2f6a95b5edf7$var$$603f33a01a36ab56$exports, "createQueue", function() {
    return $edbe2f6a95b5edf7$export$d16acf4b6e75743d;
});
function $edbe2f6a95b5edf7$export$d16acf4b6e75743d() {
    var feedNext, stop;
    var observable = new $edbe2f6a95b5edf7$export$77cea355fa80b5f4(function(param) {
        var next = param.next, complete = param.complete;
        feedNext = next, stop = complete;
    });
    return {
        process: function(data) {
            var defer = new $edbe2f6a95b5edf7$export$c7e91f8aec23ae14();
            if (!feedNext) throw Error("Can't process data before Queue consuming");
            feedNext({
                defer: defer,
                data: data
            });
            return defer.promise;
        },
        destroy: function() {
            if (!stop) throw Error("Can't stop a Queue before Queue consuming");
            stop();
        },
        observable: observable
    };
}


var $ea05ccc2484f951f$export$71511d61b312f219;
"use strict";
function $ea05ccc2484f951f$var$_ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
$ea05ccc2484f951f$export$71511d61b312f219 = $ea05ccc2484f951f$var$_ts_generator;




function $6d65d154b3035a5c$export$da8ca15f4115b46e() {
    if (typeof window !== 'undefined') {
        var Component = (parcelRequire("hVyKU"));
        return Component.default || Component;
    } else {
        var Component1 = (parcelRequire("3ALtG"));
        return Component1.default || Component1;
    }
}


var $3e3a7251f1f53fd8$exports = {};

var $1XAnY = parcelRequire("1XAnY");
"use strict";
var $3e3a7251f1f53fd8$var$e = {
    code: function(param) {
        var e = param.data;
        return "<pre><code>".concat(e.code, "</code></pre>");
    },
    embed: function(param) {
        var e = param.data;
        var t = e.service;
        return "vimeo" === t ? '<iframe src="'.concat(e.embed, '" height="').concat(e.height, '" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>') : "youtube" === t ? '<iframe width="'.concat(e.width, '" height="').concat(e.height, '" src="').concat(e.embed, '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>') : (console.error("[editorjs-html]: Only Youtube & Vimeo embeds are available by default. Write your own embed parser for other options."), "");
    },
    header: function(param) {
        var e = param.data;
        return "<h".concat(e.level, ">").concat(e.text, "</h").concat(e.level, ">");
    },
    image: function(param) {
        var e = param.data;
        var _e_file;
        var t = e.caption ? e.caption : "Image";
        return '<img src="'.concat((e === null || e === void 0 ? void 0 : (_e_file = e.file) === null || _e_file === void 0 ? void 0 : _e_file.url) || (e === null || e === void 0 ? void 0 : e.url), '" alt="').concat(t, '" />');
    },
    list: function(param) {
        var e = param.data;
        var t = "unordered" === e.style ? "ul" : "ol", r = function(e, t) {
            var o = e.map(function(e) {
                var _e_items;
                if (!e.content && !e.items) return "<li>".concat(e, "</li>");
                var o = "";
                return ((_e_items = e.items) === null || _e_items === void 0 ? void 0 : _e_items.length) && (o = r(e.items, t)), e.content ? "<li>".concat(e.content).concat(o, "</li>") : void 0;
            });
            return "<".concat(t, ">").concat(o.join(""), "</").concat(t, ">");
        };
        return r(e.items, t);
    },
    paragraph: function(param) {
        var e = param.data;
        var t = e.alignment || e.align;
        return t ? '<p style="text-align:'.concat(t, '"> ').concat(e.text, " </p>") : "<p>".concat(e.text, "</p>");
    },
    quote: function(param) {
        var e = param.data;
        return "<blockquote>".concat(e.text, "</blockquote> - ").concat(e.caption);
    },
    delimiter: function(param) {
        var e = param.data;
        return "<br/>";
    }
};
$3e3a7251f1f53fd8$exports = function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        strict: !1
    };
    var o = (0, $1XAnY._)({}, $3e3a7251f1f53fd8$var$e, t);
    return {
        parse: function(e) {
            return function(param, t, r) {
                var _$e = param.blocks;
                return _$e.reduce(function(e, o) {
                    if (o.type in t) return e + t[o.type](o);
                    var i = "[editorjs-html]: Parser function for ".concat(o.type, " does not exist");
                    if (r.strict) throw new Error(i);
                    return console.error(i), e;
                }, "");
            }(e, o, r);
        },
        parseBlock: function(e) {
            return function(e, t, r) {
                if (e.type in t) return t[e.type](e);
                var o = "[editorjs-html]: Parser function for ".concat(e.type, " does not exist");
                if (r.strict) throw new Error(o);
                console.error(o);
            }(e, o, r);
        }
    };
};



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $2Ysl1 = parcelRequire("2Ysl1");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");

var $13u2V = parcelRequire("13u2V");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");
parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");
var $lliNT = parcelRequire("lliNT");

var $7E0eS = parcelRequire("7E0eS");
function $51b1b578e3b8ff34$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == (typeof e === "undefined" ? "undefined" : (0, $7E0eS._)(e))) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $51b1b578e3b8ff34$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $51b1b578e3b8ff34$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $51b1b578e3b8ff34$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $51b1b578e3b8ff34$export$2e2bcd8739ae039 = $51b1b578e3b8ff34$export$4f5d2d50c9deca37;


var $dfab79d8c9f9a829$var$__create = Object.create;
var $dfab79d8c9f9a829$var$__defProp = Object.defineProperty;
var $dfab79d8c9f9a829$var$__defProps = Object.defineProperties;
var $dfab79d8c9f9a829$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $dfab79d8c9f9a829$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $dfab79d8c9f9a829$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $dfab79d8c9f9a829$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $dfab79d8c9f9a829$var$__getProtoOf = Object.getPrototypeOf;
var $dfab79d8c9f9a829$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $dfab79d8c9f9a829$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $dfab79d8c9f9a829$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $dfab79d8c9f9a829$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $dfab79d8c9f9a829$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($dfab79d8c9f9a829$var$__hasOwnProp.call(b, prop)) $dfab79d8c9f9a829$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($dfab79d8c9f9a829$var$__getOwnPropSymbols) try {
        for(var _iterator = $dfab79d8c9f9a829$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($dfab79d8c9f9a829$var$__propIsEnum.call(b, prop)) $dfab79d8c9f9a829$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $dfab79d8c9f9a829$var$__spreadProps = function(a, b) {
    return $dfab79d8c9f9a829$var$__defProps(a, $dfab79d8c9f9a829$var$__getOwnPropDescs(b));
};
var $dfab79d8c9f9a829$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($dfab79d8c9f9a829$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $dfab79d8c9f9a829$var$__getOwnPropSymbols) try {
        for(var _iterator = $dfab79d8c9f9a829$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $dfab79d8c9f9a829$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
var $dfab79d8c9f9a829$var$__commonJS = function(cb, mod) {
    return function __require() {
        return mod || (0, cb[$dfab79d8c9f9a829$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
};
var $dfab79d8c9f9a829$var$__export = function(target, all) {
    for(var name in all)$dfab79d8c9f9a829$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $dfab79d8c9f9a829$var$__copyProps = function(to, from, except, desc) {
    if (from && (typeof from === "undefined" ? "undefined" : (0, $7E0eS._)(from)) === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$dfab79d8c9f9a829$var$__hasOwnProp.call(to, key) && key !== except) $dfab79d8c9f9a829$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $dfab79d8c9f9a829$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $dfab79d8c9f9a829$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $dfab79d8c9f9a829$var$__toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? $dfab79d8c9f9a829$var$__create($dfab79d8c9f9a829$var$__getProtoOf(mod)) : {}, $dfab79d8c9f9a829$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $dfab79d8c9f9a829$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
// ../../node_modules/.pnpm/prismjs@1.29.0_patch_hash=vrxx3pzkik6jpmgpayxfjunetu/node_modules/prismjs/prism.js
var $dfab79d8c9f9a829$var$require_prism = $dfab79d8c9f9a829$var$__commonJS({
    "../../node_modules/.pnpm/prismjs@1.29.0_patch_hash=vrxx3pzkik6jpmgpayxfjunetu/node_modules/prismjs/prism.js": function(exports, module) {
        var Prism2 = function() {
            var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
            var uniqueId = 0;
            var plainTextGrammar = {};
            var _ = {
                /**
         * A namespace for utility methods.
         *
         * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
         * change or disappear at any time.
         *
         * @namespace
         * @memberof Prism
         */ util: {
                    encode: function encode(tokens) {
                        if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                        else if (Array.isArray(tokens)) return tokens.map(encode);
                        else return tokens.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
                    },
                    /**
           * Returns the name of the type of the given value.
           *
           * @param {any} o
           * @returns {string}
           * @example
           * type(null)      === 'Null'
           * type(undefined) === 'Undefined'
           * type(123)       === 'Number'
           * type('foo')     === 'String'
           * type(true)      === 'Boolean'
           * type([1, 2])    === 'Array'
           * type({})        === 'Object'
           * type(String)    === 'Function'
           * type(/abc+/)    === 'RegExp'
           */ type: function type(o) {
                        return Object.prototype.toString.call(o).slice(8, -1);
                    },
                    /**
           * Returns a unique number for the given object. Later calls will still return the same number.
           *
           * @param {Object} obj
           * @returns {number}
           */ objId: function objId(obj) {
                        if (!obj["__id"]) Object.defineProperty(obj, "__id", {
                            value: ++uniqueId
                        });
                        return obj["__id"];
                    },
                    /**
           * Creates a deep clone of the given object.
           *
           * The main intended use of this function is to clone language definitions.
           *
           * @param {T} o
           * @param {Record<number, any>} [visited]
           * @returns {T}
           * @template T
           */ clone: function deepClone(o, visited) {
                        visited = visited || {};
                        var clone;
                        var id;
                        switch(_.util.type(o)){
                            case "Object":
                                id = _.util.objId(o);
                                if (visited[id]) return visited[id];
                                clone = /** @type {Record<string, any>} */ {};
                                visited[id] = clone;
                                for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                                return /** @type {any} */ clone;
                            case "Array":
                                id = _.util.objId(o);
                                if (visited[id]) return visited[id];
                                clone = [];
                                visited[id] = clone;
                                /** @type {Array} */ /** @type {any} */ o.forEach(function(v, i) {
                                    clone[i] = deepClone(v, visited);
                                });
                                return /** @type {any} */ clone;
                            default:
                                return o;
                        }
                    },
                    /**
           * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
           *
           * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
           *
           * @param {Element} element
           * @returns {string}
           */ getLanguage: function getLanguage(element) {
                        while(element){
                            var m = lang.exec(element.className);
                            if (m) return m[1].toLowerCase();
                            element = element.parentElement;
                        }
                        return "none";
                    },
                    /**
           * Sets the Prism `language-xxxx` class of the given element.
           *
           * @param {Element} element
           * @param {string} language
           * @returns {void}
           */ setLanguage: function setLanguage(element, language) {
                        element.className = element.className.replace(RegExp(lang, "gi"), "");
                        element.classList.add("language-" + language);
                    },
                    /**
           * Returns whether a given class is active for `element`.
           *
           * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
           * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
           * given class is just the given class with a `no-` prefix.
           *
           * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
           * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
           * ancestors have the given class or the negated version of it, then the default activation will be returned.
           *
           * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
           * version of it, the class is considered active.
           *
           * @param {Element} element
           * @param {string} className
           * @param {boolean} [defaultActivation=false]
           * @returns {boolean}
           */ isActive: function isActive(element, className, defaultActivation) {
                        var no = "no-" + className;
                        while(element){
                            var classList = element.classList;
                            if (classList.contains(className)) return true;
                            if (classList.contains(no)) return false;
                            element = element.parentElement;
                        }
                        return !!defaultActivation;
                    }
                },
                /**
         * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
         *
         * @namespace
         * @memberof Prism
         * @public
         */ languages: {
                    /**
           * The grammar for plain, unformatted text.
           */ plain: plainTextGrammar,
                    plaintext: plainTextGrammar,
                    text: plainTextGrammar,
                    txt: plainTextGrammar,
                    /**
           * Creates a deep copy of the language with the given id and appends the given tokens.
           *
           * If a token in `redef` also appears in the copied language, then the existing token in the copied language
           * will be overwritten at its original position.
           *
           * ## Best practices
           *
           * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
           * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
           * understand the language definition because, normally, the order of tokens matters in Prism grammars.
           *
           * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
           * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
           *
           * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
           * @param {Grammar} redef The new tokens to append.
           * @returns {Grammar} The new language created.
           * @public
           * @example
           * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
           *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
           *     // at its original position
           *     'comment': { ... },
           *     // CSS doesn't have a 'color' token, so this token will be appended
           *     'color': /\b(?:red|green|blue)\b/
           * });
           */ extend: function extend(id, redef) {
                        var lang2 = _.util.clone(_.languages[id]);
                        for(var key in redef)lang2[key] = redef[key];
                        return lang2;
                    },
                    /**
           * Inserts tokens _before_ another token in a language definition or any other grammar.
           *
           * ## Usage
           *
           * This helper method makes it easy to modify existing languages. For example, the CSS language definition
           * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
           * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
           * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
           * this:
           *
           * ```js
           * Prism.languages.markup.style = {
           *     // token
           * };
           * ```
           *
           * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
           * before existing tokens. For the CSS example above, you would use it like this:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'cdata', {
           *     'style': {
           *         // token
           *     }
           * });
           * ```
           *
           * ## Special cases
           *
           * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
           * will be ignored.
           *
           * This behavior can be used to insert tokens after `before`:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'comment', {
           *     'comment': Prism.languages.markup.comment,
           *     // tokens after 'comment'
           * });
           * ```
           *
           * ## Limitations
           *
           * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
           * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
           * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
           * deleting properties which is necessary to insert at arbitrary positions.
           *
           * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
           * Instead, it will create a new object and replace all references to the target object with the new one. This
           * can be done without temporarily deleting properties, so the iteration order is well-defined.
           *
           * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
           * you hold the target object in a variable, then the value of the variable will not change.
           *
           * ```js
           * var oldMarkup = Prism.languages.markup;
           * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
           *
           * assert(oldMarkup !== Prism.languages.markup);
           * assert(newMarkup === Prism.languages.markup);
           * ```
           *
           * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
           * object to be modified.
           * @param {string} before The key to insert before.
           * @param {Grammar} insert An object containing the key-value pairs to be inserted.
           * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
           * object to be modified.
           *
           * Defaults to `Prism.languages`.
           * @returns {Grammar} The new grammar object.
           * @public
           */ insertBefore: function insertBefore(inside, before, insert, root) {
                        root = root || /** @type {any} */ _.languages;
                        var grammar = root[inside];
                        var ret = {};
                        for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                            if (token == before) {
                                for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                            }
                            if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                        }
                        var old = root[inside];
                        root[inside] = ret;
                        _.languages.DFS(_.languages, function(key, value) {
                            if (value === old && key != inside) this[key] = ret;
                        });
                        return ret;
                    },
                    // Traverse a language definition with Depth First Search
                    DFS: function DFS(o, callback, type, visited) {
                        visited = visited || {};
                        var objId = _.util.objId;
                        for(var i in o)if (o.hasOwnProperty(i)) {
                            callback.call(o, i, o[i], type || i);
                            var property = o[i];
                            var propertyType = _.util.type(property);
                            if (propertyType === "Object" && !visited[objId(property)]) {
                                visited[objId(property)] = true;
                                DFS(property, callback, null, visited);
                            } else if (propertyType === "Array" && !visited[objId(property)]) {
                                visited[objId(property)] = true;
                                DFS(property, callback, i, visited);
                            }
                        }
                    }
                },
                plugins: {},
                /**
         * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
         * and the language definitions to use, and returns a string with the HTML produced.
         *
         * The following hooks will be run:
         * 1. `before-tokenize`
         * 2. `after-tokenize`
         * 3. `wrap`: On each {@link Token}.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @param {string} language The name of the language definition passed to `grammar`.
         * @returns {string} The highlighted HTML.
         * @memberof Prism
         * @public
         * @example
         * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
         */ highlight: function highlight(text, grammar, language) {
                    var env = {
                        code: text,
                        grammar: grammar,
                        language: language
                    };
                    _.hooks.run("before-tokenize", env);
                    if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
                    env.tokens = _.tokenize(env.code, env.grammar);
                    _.hooks.run("after-tokenize", env);
                    return Token.stringify(_.util.encode(env.tokens), env.language);
                },
                /**
         * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
         * and the language definitions to use, and returns an array with the tokenized code.
         *
         * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
         *
         * This method could be useful in other contexts as well, as a very crude parser.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @returns {TokenStream} An array of strings and tokens, a token stream.
         * @memberof Prism
         * @public
         * @example
         * let code = `var foo = 0;`;
         * let tokens = Prism.tokenize(code, Prism.languages.javascript);
         * tokens.forEach(token => {
         *     if (token instanceof Prism.Token && token.type === 'number') {
         *         console.log(`Found numeric literal: ${token.content}`);
         *     }
         * });
         */ tokenize: function tokenize(text, grammar) {
                    var rest = grammar.rest;
                    if (rest) {
                        for(var token in rest)grammar[token] = rest[token];
                        delete grammar.rest;
                    }
                    var tokenList = new LinkedList();
                    addAfter(tokenList, tokenList.head, text);
                    matchGrammar(text, tokenList, grammar, tokenList.head, 0);
                    return toArray(tokenList);
                },
                /**
         * @namespace
         * @memberof Prism
         * @public
         */ hooks: {
                    all: {},
                    /**
           * Adds the given callback to the list of callbacks for the given hook.
           *
           * The callback will be invoked when the hook it is registered for is run.
           * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
           *
           * One callback function can be registered to multiple hooks and the same hook multiple times.
           *
           * @param {string} name The name of the hook.
           * @param {HookCallback} callback The callback function which is given environment variables.
           * @public
           */ add: function add(name, callback) {
                        var hooks2 = _.hooks.all;
                        hooks2[name] = hooks2[name] || [];
                        hooks2[name].push(callback);
                    },
                    /**
           * Runs a hook invoking all registered callbacks with the given environment variables.
           *
           * Callbacks will be invoked synchronously and in the order in which they were registered.
           *
           * @param {string} name The name of the hook.
           * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
           * @public
           */ run: function run(name, env) {
                        var callbacks = _.hooks.all[name];
                        if (!callbacks || !callbacks.length) return;
                        for(var i = 0, callback; callback = callbacks[i++];)callback(env);
                    }
                },
                Token: Token
            };
            function Token(type, content, alias, matchedStr) {
                this.type = type;
                this.content = content;
                this.alias = alias;
                this.length = (matchedStr || "").length | 0;
            }
            Token.stringify = function stringify(o, language) {
                if (typeof o == "string") return o;
                if (Array.isArray(o)) {
                    var s = "";
                    o.forEach(function(e) {
                        s += stringify(e, language);
                    });
                    return s;
                }
                var env = {
                    type: o.type,
                    content: stringify(o.content, language),
                    tag: "span",
                    classes: [
                        "token",
                        o.type
                    ],
                    attributes: {},
                    language: language
                };
                var aliases = o.alias;
                if (aliases) {
                    if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
                    else env.classes.push(aliases);
                }
                _.hooks.run("wrap", env);
                var attributes = "";
                for(var name in env.attributes)attributes += " " + name + '="' + (env.attributes[name] || "").replace(/"/g, "&quot;") + '"';
                return "<" + env.tag + ' class="' + env.classes.join(" ") + '"' + attributes + ">" + env.content + "</" + env.tag + ">";
            };
            function matchPattern(pattern, pos, text, lookbehind) {
                pattern.lastIndex = pos;
                var match = pattern.exec(text);
                if (match && lookbehind && match[1]) {
                    var lookbehindLength = match[1].length;
                    match.index += lookbehindLength;
                    match[0] = match[0].slice(lookbehindLength);
                }
                return match;
            }
            function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
                for(var token in grammar){
                    if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
                    var patterns = grammar[token];
                    patterns = Array.isArray(patterns) ? patterns : [
                        patterns
                    ];
                    for(var j = 0; j < patterns.length; ++j){
                        if (rematch && rematch.cause == token + "," + j) return;
                        var patternObj = patterns[j];
                        var inside = patternObj.inside;
                        var lookbehind = !!patternObj.lookbehind;
                        var greedy = !!patternObj.greedy;
                        var alias = patternObj.alias;
                        if (greedy && !patternObj.pattern.global) {
                            var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                            patternObj.pattern = RegExp(patternObj.pattern.source, flags + "g");
                        }
                        var pattern = patternObj.pattern || patternObj;
                        for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                            if (rematch && pos >= rematch.reach) break;
                            var str = currentNode.value;
                            if (tokenList.length > text.length) return;
                            if (str instanceof Token) continue;
                            var removeCount = 1;
                            var match;
                            if (greedy) {
                                match = matchPattern(pattern, pos, text, lookbehind);
                                if (!match || match.index >= text.length) break;
                                var from = match.index;
                                var to = match.index + match[0].length;
                                var p = pos;
                                p += currentNode.value.length;
                                while(from >= p){
                                    currentNode = currentNode.next;
                                    p += currentNode.value.length;
                                }
                                p -= currentNode.value.length;
                                pos = p;
                                if (currentNode.value instanceof Token) continue;
                                for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === "string"); k = k.next){
                                    removeCount++;
                                    p += k.value.length;
                                }
                                removeCount--;
                                str = text.slice(pos, p);
                                match.index -= pos;
                            } else {
                                match = matchPattern(pattern, 0, str, lookbehind);
                                if (!match) continue;
                            }
                            var from = match.index;
                            var matchStr = match[0];
                            var before = str.slice(0, from);
                            var after = str.slice(from + matchStr.length);
                            var reach = pos + str.length;
                            if (rematch && reach > rematch.reach) rematch.reach = reach;
                            var removeFrom = currentNode.prev;
                            if (before) {
                                removeFrom = addAfter(tokenList, removeFrom, before);
                                pos += before.length;
                            }
                            removeRange(tokenList, removeFrom, removeCount);
                            var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                            currentNode = addAfter(tokenList, removeFrom, wrapped);
                            if (after) addAfter(tokenList, currentNode, after);
                            if (removeCount > 1) {
                                var nestedRematch = {
                                    cause: token + "," + j,
                                    reach: reach
                                };
                                matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                                if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                            }
                        }
                    }
                }
            }
            function LinkedList() {
                var head = {
                    value: null,
                    prev: null,
                    next: null
                };
                var tail = {
                    value: null,
                    prev: head,
                    next: null
                };
                head.next = tail;
                this.head = head;
                this.tail = tail;
                this.length = 0;
            }
            function addAfter(list, node, value) {
                var next = node.next;
                var newNode = {
                    value: value,
                    prev: node,
                    next: next
                };
                node.next = newNode;
                next.prev = newNode;
                list.length++;
                return newNode;
            }
            function removeRange(list, node, count) {
                var next = node.next;
                for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
                node.next = next;
                next.prev = node;
                list.length -= i;
            }
            function toArray(list) {
                var array = [];
                var node = list.head.next;
                while(node !== list.tail){
                    array.push(node.value);
                    node = node.next;
                }
                return array;
            }
            return _;
        }();
        module.exports = Prism2;
        Prism2.default = Prism2;
    }
});
// src/prism-langs.ts
var $dfab79d8c9f9a829$export$dc7257ffb0972f87 = $dfab79d8c9f9a829$var$__toESM($dfab79d8c9f9a829$var$require_prism());
$dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.markup = {
    comment: {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    prolog: {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    doctype: {
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            "internal-subset": {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null
            },
            string: {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            punctuation: /^<!|>$|[[\]]/,
            "doctype-tag": /^DOCTYPE/i,
            name: /[^\s<>'"]+/
        }
    },
    cdata: {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    tag: {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            tag: {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    punctuation: /^<\/?/,
                    namespace: /^[^\s>\/:]+:/
                }
            },
            "special-attr": [],
            "attr-value": {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    punctuation: [
                        {
                            pattern: /^=/,
                            alias: "attr-equals"
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            punctuation: /\/?>/,
            "attr-name": {
                pattern: /[^\s>\/]+/,
                inside: {
                    namespace: /^[^\s>\/:]+:/
                }
            }
        }
    },
    entity: [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: "named-entity"
        },
        /&#x?[\da-f]{1,8};/i
    ]
}, $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.markup.tag.inside["attr-value"].inside.entity = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.markup.entity, $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.markup.doctype.inside["internal-subset"].inside = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.markup, $dfab79d8c9f9a829$export$dc7257ffb0972f87.hooks.add("wrap", function(e) {
    "entity" === e.type && (e.attributes.title = e.content.replace(/&amp;/, "&"));
}), Object.defineProperty($dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.markup.tag, "addInlined", {
    value: function value(e, n) {
        var t = {}, t = (t["language-" + n] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages[n]
        }, t.cdata = /^<!\[CDATA\[|\]\]>$/i, {
            "included-cdata": {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: t
            }
        }), n = (t["language-" + n] = {
            pattern: /[\s\S]+/,
            inside: $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages[n]
        }, {});
        n[e] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return e;
            }), "i"),
            lookbehind: true,
            greedy: true,
            inside: t
        }, $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.insertBefore("markup", "cdata", n);
    }
}), Object.defineProperty($dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.markup.tag, "addAttribute", {
    value: function value(e, n) {
        $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.markup.tag.inside["special-attr"].push({
            pattern: RegExp(/(^|["'\s])/.source + "(?:" + e + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"),
            lookbehind: true,
            inside: {
                "attr-name": /^[^\s=]+/,
                "attr-value": {
                    pattern: /=[\s\S]+/,
                    inside: {
                        value: {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                n,
                                "language-" + n
                            ],
                            inside: $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages[n]
                        },
                        punctuation: [
                            {
                                pattern: /^=/,
                                alias: "attr-equals"
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
}), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.html = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.markup, $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.mathml = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.markup, $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.svg = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.markup, $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.xml = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.extend("markup", {}), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.ssml = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.xml, $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.atom = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.xml, $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.rss = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.xml, function(e) {
    var n = {
        pattern: /\\[\\(){}[\]^$+*?|.]/,
        alias: "escape"
    }, t = /\\(?:x[\da-fA-F]{2}|u[\da-fA-F]{4}|u\{[\da-fA-F]+\}|0[0-7]{0,2}|[123][0-7]{2}|c[a-zA-Z]|.)/, a = "(?:[^\\\\-]|" + t.source + ")", a = RegExp(a + "-" + a), r = {
        pattern: /(<|')[^<>']+(?=[>']$)/,
        lookbehind: true,
        alias: "variable"
    };
    e.languages.regex = {
        "char-class": {
            pattern: /((?:^|[^\\])(?:\\\\)*)\[(?:[^\\\]]|\\[\s\S])*\]/,
            lookbehind: true,
            inside: {
                "char-class-negation": {
                    pattern: /(^\[)\^/,
                    lookbehind: true,
                    alias: "operator"
                },
                "char-class-punctuation": {
                    pattern: /^\[|\]$/,
                    alias: "punctuation"
                },
                range: {
                    pattern: a,
                    inside: {
                        escape: t,
                        "range-punctuation": {
                            pattern: /-/,
                            alias: "operator"
                        }
                    }
                },
                "special-escape": n,
                "char-set": {
                    pattern: /\\[wsd]|\\p\{[^{}]+\}/i,
                    alias: "class-name"
                },
                escape: t
            }
        },
        "special-escape": n,
        "char-set": {
            pattern: /\.|\\[wsd]|\\p\{[^{}]+\}/i,
            alias: "class-name"
        },
        backreference: [
            {
                pattern: /\\(?![123][0-7]{2})[1-9]/,
                alias: "keyword"
            },
            {
                pattern: /\\k<[^<>']+>/,
                alias: "keyword",
                inside: {
                    "group-name": r
                }
            }
        ],
        anchor: {
            pattern: /[$^]|\\[ABbGZz]/,
            alias: "function"
        },
        escape: t,
        group: [
            {
                pattern: /\((?:\?(?:<[^<>']+>|'[^<>']+'|[>:]|<?[=!]|[idmnsuxU]+(?:-[idmnsuxU]+)?:?))?/,
                alias: "punctuation",
                inside: {
                    "group-name": r
                }
            },
            {
                pattern: /\)/,
                alias: "punctuation"
            }
        ],
        quantifier: {
            pattern: /(?:[+*?]|\{\d+(?:,\d*)?\})[?+]?/,
            alias: "number"
        },
        alternation: {
            pattern: /\|/,
            alias: "keyword"
        }
    };
}($dfab79d8c9f9a829$export$dc7257ffb0972f87), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.clike = {
    comment: [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            punctuation: /[.\\]/
        }
    },
    keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b\w+(?=\()/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    punctuation: /[{}[\];(),.:]/
}, $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.javascript = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.extend("clike", {
    "class-name": [
        $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.clike["class-name"],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    keyword: [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    number: {
        pattern: RegExp(/(^|[^\w$])/.source + "(?:" + /NaN|Infinity/.source + "|" + /0[bB][01]+(?:_[01]+)*n?/.source + "|" + /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + /\d+(?:_\d+)*n/.source + "|" + /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source + ")" + /(?![\w$])/.source),
        lookbehind: true
    },
    operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
}), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.insertBefore("javascript", "keyword", {
    regex: {
        pattern: RegExp(/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            "regex-source": {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: "language-regex",
                inside: $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.regex
            },
            "regex-delimiter": /^\/|\/$/,
            "regex-flags": /^[a-z]+$/
        }
    },
    "function-variable": {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
    },
    parameter: [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.javascript
        }
    ],
    constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
}), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.insertBefore("javascript", "string", {
    hashbang: {
        pattern: /^#!.*/,
        greedy: true,
        alias: "comment"
    },
    "template-string": {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            "template-punctuation": {
                pattern: /^`|`$/,
                alias: "string"
            },
            interpolation: {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    "interpolation-punctuation": {
                        pattern: /^\$\{|\}$/,
                        alias: "punctuation"
                    },
                    rest: $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.javascript
                }
            },
            string: /[\s\S]+/
        }
    },
    "string-property": {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: "property"
    }
}), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.insertBefore("javascript", "operator", {
    "literal-property": {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: "property"
    }
}), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.markup && ($dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.markup.tag.addInlined("script", "javascript"), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript")), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.js = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.javascript, $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.actionscript = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.extend("javascript", {
    keyword: /\b(?:as|break|case|catch|class|const|default|delete|do|dynamic|each|else|extends|final|finally|for|function|get|if|implements|import|in|include|instanceof|interface|internal|is|namespace|native|new|null|override|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|use|var|void|while|with)\b/,
    operator: /\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/
}), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.actionscript["class-name"].alias = "function", delete $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.actionscript.parameter, delete $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.actionscript["literal-property"], $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.markup && $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.insertBefore("actionscript", "string", {
    xml: {
        pattern: /(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/,
        lookbehind: true,
        inside: $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.markup
    }
}), function(e) {
    var n = /#(?!\{).+/, t = {
        pattern: /#\{[^}]+\}/,
        alias: "variable"
    };
    e.languages.coffeescript = e.languages.extend("javascript", {
        comment: n,
        string: [
            {
                pattern: /'(?:\\[\s\S]|[^\\'])*'/,
                greedy: true
            },
            {
                pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                greedy: true,
                inside: {
                    interpolation: t
                }
            }
        ],
        keyword: /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,
        "class-member": {
            pattern: /@(?!\d)\w+/,
            alias: "variable"
        }
    }), e.languages.insertBefore("coffeescript", "comment", {
        "multiline-comment": {
            pattern: /###[\s\S]+?###/,
            alias: "comment"
        },
        "block-regex": {
            pattern: /\/{3}[\s\S]*?\/{3}/,
            alias: "regex",
            inside: {
                comment: n,
                interpolation: t
            }
        }
    }), e.languages.insertBefore("coffeescript", "string", {
        "inline-javascript": {
            pattern: /`(?:\\[\s\S]|[^\\`])*`/,
            inside: {
                delimiter: {
                    pattern: /^`|`$/,
                    alias: "punctuation"
                },
                script: {
                    pattern: /[\s\S]+/,
                    alias: "language-javascript",
                    inside: e.languages.javascript
                }
            }
        },
        "multiline-string": [
            {
                pattern: /'''[\s\S]*?'''/,
                greedy: true,
                alias: "string"
            },
            {
                pattern: /"""[\s\S]*?"""/,
                greedy: true,
                alias: "string",
                inside: {
                    interpolation: t
                }
            }
        ]
    }), e.languages.insertBefore("coffeescript", "keyword", {
        property: /(?!\d)\w+(?=\s*:(?!:))/
    }), delete e.languages.coffeescript["template-string"], e.languages.coffee = e.languages.coffeescript;
}($dfab79d8c9f9a829$export$dc7257ffb0972f87), function(l) {
    var e = l.languages.javadoclike = {
        parameter: {
            pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*@(?:arg|arguments|param)\s+)\w+/m,
            lookbehind: true
        },
        keyword: {
            pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*|\{)@[a-z][a-zA-Z-]+\b/m,
            lookbehind: true
        },
        punctuation: /[{}]/
    };
    Object.defineProperty(e, "addSupport", {
        value: function value(e2, o) {
            (e2 = "string" == typeof e2 ? [
                e2
            ] : e2).forEach(function(e3) {
                var n = function n(e4) {
                    e4.inside || (e4.inside = {}), e4.inside.rest = o;
                }, t = "doc-comment";
                if (a = l.languages[e3]) {
                    var a, r = a[t];
                    if ((r = r ? r : (a = l.languages.insertBefore(e3, "comment", {
                        "doc-comment": {
                            pattern: /(^|[^\\])\/\*\*[^/][\s\S]*?(?:\*\/|$)/,
                            lookbehind: true,
                            alias: "comment"
                        }
                    }))[t]) instanceof RegExp && (r = a[t] = {
                        pattern: r
                    }), Array.isArray(r)) for(var s = 0, i = r.length; s < i; s++)r[s] instanceof RegExp && (r[s] = {
                        pattern: r[s]
                    }), n(r[s]);
                    else n(r);
                }
            });
        }
    }), e.addSupport([
        "java",
        "javascript",
        "php"
    ], e);
}($dfab79d8c9f9a829$export$dc7257ffb0972f87), function(e) {
    var n = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/, n = (e.languages.css = {
        comment: /\/\*[\s\S]*?\*\//,
        atrule: {
            pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + n.source + ")*?" + /(?:;|(?=\s*\{))/.source),
            inside: {
                rule: /^@[\w-]+/,
                "selector-function-argument": {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: "selector"
                },
                keyword: {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                }
            }
        },
        url: {
            pattern: RegExp("\\burl\\((?:" + n.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
            greedy: true,
            inside: {
                function: /^url/i,
                punctuation: /^\(|\)$/,
                string: {
                    pattern: RegExp("^" + n.source + "$"),
                    alias: "url"
                }
            }
        },
        selector: {
            pattern: RegExp("(^|[{}\\s])[^{}\\s](?:[^{};\"'\\s]|\\s+(?![\\s{])|" + n.source + ")*(?=\\s*\\{)"),
            lookbehind: true
        },
        string: {
            pattern: n,
            greedy: true
        },
        property: {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        important: /!important\b/i,
        function: {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        punctuation: /[(){};:,]/
    }, e.languages.css.atrule.inside.rest = e.languages.css, e.languages.markup);
    n && (n.tag.addInlined("style", "css"), n.tag.addAttribute("style", "css"));
}($dfab79d8c9f9a829$export$dc7257ffb0972f87), function(e) {
    var n = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, n = (e.languages.css.selector = {
        pattern: e.languages.css.selector.pattern,
        lookbehind: true,
        inside: n = {
            "pseudo-element": /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/,
            "pseudo-class": /:[-\w]+/,
            class: /\.[-\w]+/,
            id: /#[-\w]+/,
            attribute: {
                pattern: RegExp("\\[(?:[^[\\]\"']|" + n.source + ")*\\]"),
                greedy: true,
                inside: {
                    punctuation: /^\[|\]$/,
                    "case-sensitivity": {
                        pattern: /(\s)[si]$/i,
                        lookbehind: true,
                        alias: "keyword"
                    },
                    namespace: {
                        pattern: /^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/,
                        lookbehind: true,
                        inside: {
                            punctuation: /\|$/
                        }
                    },
                    "attr-name": {
                        pattern: /^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/,
                        lookbehind: true
                    },
                    "attr-value": [
                        n,
                        {
                            pattern: /(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/,
                            lookbehind: true
                        }
                    ],
                    operator: /[|~*^$]?=/
                }
            },
            "n-th": [
                {
                    pattern: /(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/,
                    lookbehind: true,
                    inside: {
                        number: /[\dn]+/,
                        operator: /[+-]/
                    }
                },
                {
                    pattern: /(\(\s*)(?:even|odd)(?=\s*\))/i,
                    lookbehind: true
                }
            ],
            combinator: />|\+|~|\|\|/,
            punctuation: /[(),]/
        }
    }, e.languages.css.atrule.inside["selector-function-argument"].inside = n, e.languages.insertBefore("css", "property", {
        variable: {
            pattern: /(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i,
            lookbehind: true
        }
    }), {
        pattern: /(\b\d+)(?:%|[a-z]+(?![\w-]))/,
        lookbehind: true
    }), t = {
        pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
        lookbehind: true
    };
    e.languages.insertBefore("css", "function", {
        operator: {
            pattern: /(\s)[+\-*\/](?=\s)/,
            lookbehind: true
        },
        hexcode: {
            pattern: /\B#[\da-f]{3,8}\b/i,
            alias: "color"
        },
        color: [
            {
                pattern: /(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|RebeccaPurple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i,
                lookbehind: true
            },
            {
                pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
                inside: {
                    unit: n,
                    number: t,
                    function: /[\w-]+(?=\()/,
                    punctuation: /[(),]/
                }
            }
        ],
        entity: /\\[\da-f]{1,8}/i,
        unit: n,
        number: t
    });
}($dfab79d8c9f9a829$export$dc7257ffb0972f87), function(e) {
    var n = /[*&][^\s[\]{},]+/, t = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/, a = "(?:" + t.source + "(?:[ 	]+" + n.source + ")?|" + n.source + "(?:[ 	]+" + t.source + ")?)", r = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function() {
        return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
    }), s = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
    function i(e2, n2) {
        n2 = (n2 || "").replace(/m/g, "") + "m";
        var t2 = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
            return a;
        }).replace(/<<value>>/g, function() {
            return e2;
        });
        return RegExp(t2, n2);
    }
    e.languages.yaml = {
        scalar: {
            pattern: RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function() {
                return a;
            })),
            lookbehind: true,
            alias: "string"
        },
        comment: /#.*/,
        key: {
            pattern: RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
                return a;
            }).replace(/<<key>>/g, function() {
                return "(?:" + r + "|" + s + ")";
            })),
            lookbehind: true,
            greedy: true,
            alias: "atrule"
        },
        directive: {
            pattern: /(^[ \t]*)%.+/m,
            lookbehind: true,
            alias: "important"
        },
        datetime: {
            pattern: i(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source),
            lookbehind: true,
            alias: "number"
        },
        boolean: {
            pattern: i(/false|true/.source, "i"),
            lookbehind: true,
            alias: "important"
        },
        null: {
            pattern: i(/null|~/.source, "i"),
            lookbehind: true,
            alias: "important"
        },
        string: {
            pattern: i(s),
            lookbehind: true,
            greedy: true
        },
        number: {
            pattern: i(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, "i"),
            lookbehind: true
        },
        tag: t,
        important: n,
        punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
    }, e.languages.yml = e.languages.yaml;
}($dfab79d8c9f9a829$export$dc7257ffb0972f87), function(o) {
    var n = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
    function e(e2) {
        return e2 = e2.replace(/<inner>/g, function() {
            return n;
        }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + e2 + ")");
    }
    var t = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, a = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
        return t;
    }), r = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source, l = (o.languages.markdown = o.languages.extend("markup", {}), o.languages.insertBefore("markdown", "prolog", {
        "front-matter-block": {
            pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
            lookbehind: true,
            greedy: true,
            inside: {
                punctuation: /^---|---$/,
                "front-matter": {
                    pattern: /\S+(?:\s+\S+)*/,
                    alias: [
                        "yaml",
                        "language-yaml"
                    ],
                    inside: o.languages.yaml
                }
            }
        },
        blockquote: {
            pattern: /^>(?:[\t ]*>)*/m,
            alias: "punctuation"
        },
        table: {
            pattern: RegExp("^" + a + r + "(?:" + a + ")*", "m"),
            inside: {
                "table-data-rows": {
                    pattern: RegExp("^(" + a + r + ")(?:" + a + ")*$"),
                    lookbehind: true,
                    inside: {
                        "table-data": {
                            pattern: RegExp(t),
                            inside: o.languages.markdown
                        },
                        punctuation: /\|/
                    }
                },
                "table-line": {
                    pattern: RegExp("^(" + a + ")" + r + "$"),
                    lookbehind: true,
                    inside: {
                        punctuation: /\||:?-{3,}:?/
                    }
                },
                "table-header-row": {
                    pattern: RegExp("^" + a + "$"),
                    inside: {
                        "table-header": {
                            pattern: RegExp(t),
                            alias: "important",
                            inside: o.languages.markdown
                        },
                        punctuation: /\|/
                    }
                }
            }
        },
        code: [
            {
                pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
                lookbehind: true,
                alias: "keyword"
            },
            {
                pattern: /^```[\s\S]*?^```$/m,
                greedy: true,
                inside: {
                    "code-block": {
                        pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
                        lookbehind: true
                    },
                    "code-language": {
                        pattern: /^(```).+/,
                        lookbehind: true
                    },
                    punctuation: /```/
                }
            }
        ],
        title: [
            {
                pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
                alias: "important",
                inside: {
                    punctuation: /==+$|--+$/
                }
            },
            {
                pattern: /(^\s*)#.+/m,
                lookbehind: true,
                alias: "important",
                inside: {
                    punctuation: /^#+|#+$/
                }
            }
        ],
        hr: {
            pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
            lookbehind: true,
            alias: "punctuation"
        },
        list: {
            pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
            lookbehind: true,
            alias: "punctuation"
        },
        "url-reference": {
            pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
            inside: {
                variable: {
                    pattern: /^(!?\[)[^\]]+/,
                    lookbehind: true
                },
                string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
                punctuation: /^[\[\]!:]|[<>]/
            },
            alias: "url"
        },
        bold: {
            pattern: e(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                content: {
                    pattern: /(^..)[\s\S]+(?=..$)/,
                    lookbehind: true,
                    inside: {}
                },
                punctuation: /\*\*|__/
            }
        },
        italic: {
            pattern: e(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                content: {
                    pattern: /(^.)[\s\S]+(?=.$)/,
                    lookbehind: true,
                    inside: {}
                },
                punctuation: /[*_]/
            }
        },
        strike: {
            pattern: e(/(~~?)(?:(?!~)<inner>)+\2/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                content: {
                    pattern: /(^~~?)[\s\S]+(?=\1$)/,
                    lookbehind: true,
                    inside: {}
                },
                punctuation: /~~?/
            }
        },
        "code-snippet": {
            pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
            lookbehind: true,
            greedy: true,
            alias: [
                "code",
                "keyword"
            ]
        },
        url: {
            pattern: e(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                operator: /^!/,
                content: {
                    pattern: /(^\[)[^\]]+(?=\])/,
                    lookbehind: true,
                    inside: {}
                },
                variable: {
                    pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
                    lookbehind: true
                },
                url: {
                    pattern: /(^\]\()[^\s)]+/,
                    lookbehind: true
                },
                string: {
                    pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
                    lookbehind: true
                }
            }
        }
    }), [
        "url",
        "bold",
        "italic",
        "strike"
    ].forEach(function(n2) {
        [
            "url",
            "bold",
            "italic",
            "strike",
            "code-snippet"
        ].forEach(function(e2) {
            n2 !== e2 && (o.languages.markdown[n2].inside.content.inside[e2] = o.languages.markdown[e2]);
        });
    }), o.hooks.add("after-tokenize", function(e2) {
        "markdown" !== e2.language && "md" !== e2.language || !function e3(n2) {
            if (n2 && "string" != typeof n2) for(var t2 = 0, a2 = n2.length; t2 < a2; t2++){
                var r2, s = n2[t2];
                "code" !== s.type ? e3(s.content) : (r2 = s.content[1], s = s.content[3], r2 && s && "code-language" === r2.type && "code-block" === s.type && "string" == typeof r2.content && (r2 = r2.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp"), r2 = "language-" + (r2 = (/[a-z][\w-]*/i.exec(r2) || [
                    ""
                ])[0].toLowerCase()), s.alias ? "string" == typeof s.alias ? s.alias = [
                    s.alias,
                    r2
                ] : s.alias.push(r2) : s.alias = [
                    r2
                ]));
            }
        }(e2.tokens);
    }), o.hooks.add("wrap", function(e2) {
        if ("code-block" === e2.type) {
            for(var n2 = "", t2 = 0, a2 = e2.classes.length; t2 < a2; t2++){
                var r2 = e2.classes[t2], r2 = /language-(.+)/.exec(r2);
                if (r2) {
                    n2 = r2[1];
                    break;
                }
            }
            var s, i = o.languages[n2];
            i ? e2.content = o.highlight(function(e3) {
                e3 = e3.replace(l, "");
                return e3 = e3.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(e4, n3) {
                    var t3;
                    return "#" === (n3 = n3.toLowerCase())[0] ? (t3 = "x" === n3[1] ? parseInt(n3.slice(2), 16) : Number(n3.slice(1)), c(t3)) : u[n3] || e4;
                });
            }(e2.content), i, n2) : n2 && "none" !== n2 && o.plugins.autoloader && (s = "md-" + /* @__PURE__ */ new Date().valueOf() + "-" + Math.floor(1e16 * Math.random()), e2.attributes.id = s, o.plugins.autoloader.loadLanguages(n2, function() {
                var e3 = document.getElementById(s);
                e3 && (e3.innerHTML = o.highlight(e3.textContent, o.languages[n2], n2));
            }));
        }
    }), RegExp(o.languages.markup.tag.pattern.source, "gi")), u = {
        amp: "&",
        lt: "<",
        gt: ">",
        quot: '"'
    }, c = String.fromCodePoint || String.fromCharCode;
    o.languages.md = o.languages.markdown;
}($dfab79d8c9f9a829$export$dc7257ffb0972f87), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.graphql = {
    comment: /#.*/,
    description: {
        pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,
        greedy: true,
        alias: "string",
        inside: {
            "language-markdown": {
                pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,
                lookbehind: true,
                inside: $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.markdown
            }
        }
    },
    string: {
        pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,
        greedy: true
    },
    number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    boolean: /\b(?:false|true)\b/,
    variable: /\$[a-z_]\w*/i,
    directive: {
        pattern: /@[a-z_]\w*/i,
        alias: "function"
    },
    "attr-name": {
        pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,
        greedy: true
    },
    "atom-input": {
        pattern: /\b[A-Z]\w*Input\b/,
        alias: "class-name"
    },
    scalar: /\b(?:Boolean|Float|ID|Int|String)\b/,
    constant: /\b[A-Z][A-Z_\d]*\b/,
    "class-name": {
        pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,
        lookbehind: true
    },
    fragment: {
        pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: "function"
    },
    "definition-mutation": {
        pattern: /(\bmutation\s+)[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: "function"
    },
    "definition-query": {
        pattern: /(\bquery\s+)[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: "function"
    },
    keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,
    operator: /[!=|&]|\.{3}/,
    "property-query": /\w+(?=\s*\()/,
    object: /\w+(?=\s*\{)/,
    punctuation: /[!(){}\[\]:=,]/,
    property: /\w+/
}, $dfab79d8c9f9a829$export$dc7257ffb0972f87.hooks.add("after-tokenize", function(e) {
    if ("graphql" === e.language) for(var i = e.tokens.filter(function(e2) {
        return "string" != typeof e2 && "comment" !== e2.type && "scalar" !== e2.type;
    }), o = 0; o < i.length;){
        var n = i[o++];
        if ("keyword" === n.type && "mutation" === n.content) {
            var t = [];
            if (p([
                "definition-mutation",
                "punctuation"
            ]) && "(" === c(1).content) {
                o += 2;
                var a = d(/^\($/, /^\)$/);
                if (-1 === a) continue;
                for(; o < a; o++){
                    var r = c(0);
                    "variable" === r.type && (g(r, "variable-input"), t.push(r.content));
                }
                o = a + 1;
            }
            if (p([
                "punctuation",
                "property-query"
            ]) && "{" === c(0).content && (o++, g(c(0), "property-mutation"), 0 < t.length)) {
                var s = d(/^\{$/, /^\}$/);
                if (-1 !== s) for(var l = o; l < s; l++){
                    var u = i[l];
                    "variable" === u.type && 0 <= t.indexOf(u.content) && g(u, "variable-input");
                }
            }
        }
    }
    function c(e2) {
        return i[o + e2];
    }
    function p(e2, n2) {
        n2 = n2 || 0;
        for(var t2 = 0; t2 < e2.length; t2++){
            var a2 = c(t2 + n2);
            if (!a2 || a2.type !== e2[t2]) return;
        }
        return 1;
    }
    function d(e2, n2) {
        for(var t2 = 1, a2 = o; a2 < i.length; a2++){
            var r2 = i[a2], s2 = r2.content;
            if ("punctuation" === r2.type && "string" == typeof s2) {
                if (e2.test(s2)) t2++;
                else if (n2.test(s2) && 0 === --t2) return a2;
            }
        }
        return -1;
    }
    function g(e2, n2) {
        var t2 = e2.alias;
        t2 ? Array.isArray(t2) || (e2.alias = t2 = [
            t2
        ]) : e2.alias = t2 = [], t2.push(n2);
    }
}), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.sql = {
    comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
        lookbehind: true
    },
    variable: [
        {
            pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
            greedy: true
        },
        /@[\w.$]+/
    ],
    string: {
        pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
        greedy: true,
        lookbehind: true
    },
    identifier: {
        pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
        greedy: true,
        lookbehind: true,
        inside: {
            punctuation: /^`|`$/
        }
    },
    function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
    keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
    boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
    number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
    operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
    punctuation: /[;[\]()`,.]/
}, function(b) {
    var e = b.languages.javascript["template-string"], t = e.pattern.source, m = e.inside.interpolation, f = m.inside["interpolation-punctuation"], s = m.pattern.source;
    function n(e2, n2) {
        if (b.languages[e2]) return {
            pattern: RegExp("((?:" + n2 + ")\\s*)" + t),
            lookbehind: true,
            greedy: true,
            inside: {
                "template-punctuation": {
                    pattern: /^`|`$/,
                    alias: "string"
                },
                "embedded-code": {
                    pattern: /[\s\S]+/,
                    alias: e2
                }
            }
        };
    }
    function h(e2, n2, t2) {
        e2 = {
            code: e2,
            grammar: n2,
            language: t2
        };
        return b.hooks.run("before-tokenize", e2), e2.tokens = b.tokenize(e2.code, e2.grammar), b.hooks.run("after-tokenize", e2), e2.tokens;
    }
    function l(a2, e2, r) {
        var n2 = b.tokenize(a2, {
            interpolation: {
                pattern: RegExp(s),
                lookbehind: true
            }
        }), p = 0, d = {}, n2 = h(n2.map(function(e3) {
            if ("string" == typeof e3) return e3;
            for(var n3, t2, e3 = e3.content; -1 !== a2.indexOf((t2 = p++, n3 = "___" + r.toUpperCase() + "_" + t2 + "___")););
            return d[n3] = e3, n3;
        }).join(""), e2, r), g = Object.keys(d);
        return p = 0, function e3(n3) {
            for(var t2 = 0; t2 < n3.length; t2++){
                if (p >= g.length) return;
                var a3, r2, s2, i, o, l2, u2, c = n3[t2];
                "string" == typeof c || "string" == typeof c.content ? (a3 = g[p], -1 !== (u2 = (l2 = "string" == typeof c ? c : c.content).indexOf(a3)) && (++p, r2 = l2.substring(0, u2), o = d[a3], s2 = void 0, (i = {})["interpolation-punctuation"] = f, 3 === (i = b.tokenize(o, i)).length && ((s2 = [
                    1,
                    1
                ]).push.apply(s2, h(i[1], b.languages.javascript, "javascript")), i.splice.apply(i, s2)), s2 = new b.Token("interpolation", i, m.alias, o), i = l2.substring(u2 + a3.length), o = [], r2 && o.push(r2), o.push(s2), i && (e3(l2 = [
                    i
                ]), o.push.apply(o, l2)), "string" == typeof c ? (n3.splice.apply(n3, [
                    t2,
                    1
                ].concat(o)), t2 += o.length - 1) : c.content = o)) : (u2 = c.content, Array.isArray(u2) ? e3(u2) : e3([
                    u2
                ]));
            }
        }(n2), new b.Token(r, n2, "language-" + r, a2);
    }
    b.languages.javascript["template-string"] = [
        n("css", /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source),
        n("html", /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source),
        n("svg", /\bsvg/.source),
        n("markdown", /\b(?:markdown|md)/.source),
        n("graphql", /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source),
        n("sql", /\bsql/.source),
        e
    ].filter(Boolean);
    var a = {
        javascript: true,
        js: true,
        typescript: true,
        ts: true,
        jsx: true,
        tsx: true
    };
    function u(e2) {
        return "string" == typeof e2 ? e2 : Array.isArray(e2) ? e2.map(u).join("") : u(e2.content);
    }
    b.hooks.add("after-tokenize", function(e2) {
        e2.language in a && !function e3(n2) {
            for(var t2 = 0, a2 = n2.length; t2 < a2; t2++){
                var r, s2, i, o = n2[t2];
                "string" != typeof o && (r = o.content, Array.isArray(r) ? "template-string" === o.type ? (o = r[1], 3 === r.length && "string" != typeof o && "embedded-code" === o.type && (s2 = u(o), o = o.alias, o = Array.isArray(o) ? o[0] : o, i = b.languages[o]) && (r[1] = l(s2, i, o))) : e3(r) : "string" != typeof r && e3([
                    r
                ]));
            }
        }(e2.tokens);
    });
}($dfab79d8c9f9a829$export$dc7257ffb0972f87), function(e) {
    e.languages.typescript = e.languages.extend("javascript", {
        "class-name": {
            pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
            lookbehind: true,
            greedy: true,
            inside: null
        },
        builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
    }), e.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, /\btype\b(?=\s*(?:[\{*]|$))/), delete e.languages.typescript.parameter, delete e.languages.typescript["literal-property"];
    var n = e.languages.extend("typescript", {});
    delete n["class-name"], e.languages.typescript["class-name"].inside = n, e.languages.insertBefore("typescript", "function", {
        decorator: {
            pattern: /@[$\w\xA0-\uFFFF]+/,
            inside: {
                at: {
                    pattern: /^@/,
                    alias: "operator"
                },
                function: /^[\s\S]+/
            }
        },
        "generic-function": {
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
            greedy: true,
            inside: {
                function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
                generic: {
                    pattern: /<[\s\S]+/,
                    alias: "class-name",
                    inside: n
                }
            }
        }
    }), e.languages.ts = e.languages.typescript;
}($dfab79d8c9f9a829$export$dc7257ffb0972f87), function(e) {
    var n = e.languages.javascript, t = /\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})+\}/.source, a = "(@(?:arg|argument|param|property)\\s+(?:" + t + "\\s+)?)";
    e.languages.jsdoc = e.languages.extend("javadoclike", {
        parameter: {
            pattern: RegExp(a + /(?:(?!\s)[$\w\xA0-\uFFFF.])+(?=\s|$)/.source),
            lookbehind: true,
            inside: {
                punctuation: /\./
            }
        }
    }), e.languages.insertBefore("jsdoc", "keyword", {
        "optional-parameter": {
            pattern: RegExp(a + /\[(?:(?!\s)[$\w\xA0-\uFFFF.])+(?:=[^[\]]+)?\](?=\s|$)/.source),
            lookbehind: true,
            inside: {
                parameter: {
                    pattern: /(^\[)[$\w\xA0-\uFFFF\.]+/,
                    lookbehind: true,
                    inside: {
                        punctuation: /\./
                    }
                },
                code: {
                    pattern: /(=)[\s\S]*(?=\]$)/,
                    lookbehind: true,
                    inside: n,
                    alias: "language-javascript"
                },
                punctuation: /[=[\]]/
            }
        },
        "class-name": [
            {
                pattern: RegExp(/(@(?:augments|class|extends|interface|memberof!?|template|this|typedef)\s+(?:<TYPE>\s+)?)[A-Z]\w*(?:\.[A-Z]\w*)*/.source.replace(/<TYPE>/g, function() {
                    return t;
                })),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            {
                pattern: RegExp("(@[a-z]+\\s+)" + t),
                lookbehind: true,
                inside: {
                    string: n.string,
                    number: n.number,
                    boolean: n.boolean,
                    keyword: e.languages.typescript.keyword,
                    operator: /=>|\.\.\.|[&|?:*]/,
                    punctuation: /[.,;=<>{}()[\]]/
                }
            }
        ],
        example: {
            pattern: /(@example\s+(?!\s))(?:[^@\s]|\s+(?!\s))+?(?=\s*(?:\*\s*)?(?:@\w|\*\/))/,
            lookbehind: true,
            inside: {
                code: {
                    pattern: /^([\t ]*(?:\*\s*)?)\S.*$/m,
                    lookbehind: true,
                    inside: n,
                    alias: "language-javascript"
                }
            }
        }
    }), e.languages.javadoclike.addSupport("javascript", e.languages.jsdoc);
}($dfab79d8c9f9a829$export$dc7257ffb0972f87), function(e) {
    e.languages.flow = e.languages.extend("javascript", {}), e.languages.insertBefore("flow", "keyword", {
        type: [
            {
                pattern: /\b(?:[Bb]oolean|Function|[Nn]umber|[Ss]tring|[Ss]ymbol|any|mixed|null|void)\b/,
                alias: "class-name"
            }
        ]
    }), e.languages.flow["function-variable"].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i, delete e.languages.flow.parameter, e.languages.insertBefore("flow", "operator", {
        "flow-punctuation": {
            pattern: /\{\||\|\}/,
            alias: "punctuation"
        }
    }), Array.isArray(e.languages.flow.keyword) || (e.languages.flow.keyword = [
        e.languages.flow.keyword
    ]), e.languages.flow.keyword.unshift({
        pattern: /(^|[^$]\b)(?:Class|declare|opaque|type)\b(?!\$)/,
        lookbehind: true
    }, {
        pattern: /(^|[^$]\B)\$(?:Diff|Enum|Exact|Keys|ObjMap|PropertyType|Record|Shape|Subtype|Supertype|await)\b(?!\$)/,
        lookbehind: true
    });
}($dfab79d8c9f9a829$export$dc7257ffb0972f87), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.n4js = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.extend("javascript", {
    keyword: /\b(?:Array|any|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/
}), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.insertBefore("n4js", "constant", {
    annotation: {
        pattern: /@+\w+/,
        alias: "operator"
    }
}), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.n4jsd = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.n4js, function(e) {
    function n(e2, n2) {
        return RegExp(e2.replace(/<ID>/g, function() {
            return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
        }), n2);
    }
    e.languages.insertBefore("javascript", "function-variable", {
        "method-variable": {
            pattern: RegExp("(\\.\\s*)" + e.languages.javascript["function-variable"].pattern.source),
            lookbehind: true,
            alias: [
                "function-variable",
                "method",
                "function",
                "property-access"
            ]
        }
    }), e.languages.insertBefore("javascript", "function", {
        method: {
            pattern: RegExp("(\\.\\s*)" + e.languages.javascript.function.source),
            lookbehind: true,
            alias: [
                "function",
                "property-access"
            ]
        }
    }), e.languages.insertBefore("javascript", "constant", {
        "known-class-name": [
            {
                pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/,
                alias: "class-name"
            },
            {
                pattern: /\b(?:[A-Z]\w*)Error\b/,
                alias: "class-name"
            }
        ]
    }), e.languages.insertBefore("javascript", "keyword", {
        imports: {
            pattern: n(/(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source),
            lookbehind: true,
            inside: e.languages.javascript
        },
        exports: {
            pattern: n(/(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source),
            lookbehind: true,
            inside: e.languages.javascript
        }
    }), e.languages.javascript.keyword.unshift({
        pattern: /\b(?:as|default|export|from|import)\b/,
        alias: "module"
    }, {
        pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/,
        alias: "control-flow"
    }, {
        pattern: /\bnull\b/,
        alias: [
            "null",
            "nil"
        ]
    }, {
        pattern: /\bundefined\b/,
        alias: "nil"
    }), e.languages.insertBefore("javascript", "operator", {
        spread: {
            pattern: /\.{3}/,
            alias: "operator"
        },
        arrow: {
            pattern: /=>/,
            alias: "operator"
        }
    }), e.languages.insertBefore("javascript", "punctuation", {
        "property-access": {
            pattern: n(/(\.\s*)#?<ID>/.source),
            lookbehind: true
        },
        "maybe-class-name": {
            pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/,
            lookbehind: true
        },
        dom: {
            pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/,
            alias: "variable"
        },
        console: {
            pattern: /\bconsole(?=\s*\.)/,
            alias: "class-name"
        }
    });
    for(var t = [
        "function",
        "function-variable",
        "method",
        "method-variable",
        "property-access"
    ], a = 0; a < t.length; a++){
        var r = t[a], s = e.languages.javascript[r], r = (s = "RegExp" === e.util.type(s) ? e.languages.javascript[r] = {
            pattern: s
        } : s).inside || {};
        (s.inside = r)["maybe-class-name"] = /^[A-Z][\s\S]*/;
    }
}($dfab79d8c9f9a829$export$dc7257ffb0972f87), function(s) {
    var e = s.util.clone(s.languages.javascript), t = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, a = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, r = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
    function n(e2, n2) {
        return e2 = e2.replace(/<S>/g, function() {
            return t;
        }).replace(/<BRACES>/g, function() {
            return a;
        }).replace(/<SPREAD>/g, function() {
            return r;
        }), RegExp(e2, n2);
    }
    r = n(r).source, s.languages.jsx = s.languages.extend("markup", e), s.languages.jsx.tag.pattern = n(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source), s.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, s.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, s.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, s.languages.jsx.tag.inside.comment = e.comment, s.languages.insertBefore("inside", "attr-name", {
        spread: {
            pattern: n(/<SPREAD>/.source),
            inside: s.languages.jsx
        }
    }, s.languages.jsx.tag), s.languages.insertBefore("inside", "special-attr", {
        script: {
            pattern: n(/=<BRACES>/.source),
            alias: "language-javascript",
            inside: {
                "script-punctuation": {
                    pattern: /^=(?=\{)/,
                    alias: "punctuation"
                },
                rest: s.languages.jsx
            }
        }
    }, s.languages.jsx.tag);
    function i(e2) {
        for(var n2 = [], t2 = 0; t2 < e2.length; t2++){
            var a2 = e2[t2], r2 = false;
            "string" != typeof a2 && ("tag" === a2.type && a2.content[0] && "tag" === a2.content[0].type ? "</" === a2.content[0].content[0].content ? 0 < n2.length && n2[n2.length - 1].tagName === o(a2.content[0].content[1]) && n2.pop() : "/>" !== a2.content[a2.content.length - 1].content && n2.push({
                tagName: o(a2.content[0].content[1]),
                openedBraces: 0
            }) : 0 < n2.length && "punctuation" === a2.type && "{" === a2.content ? n2[n2.length - 1].openedBraces++ : 0 < n2.length && 0 < n2[n2.length - 1].openedBraces && "punctuation" === a2.type && "}" === a2.content ? n2[n2.length - 1].openedBraces-- : r2 = true), (r2 || "string" == typeof a2) && 0 < n2.length && 0 === n2[n2.length - 1].openedBraces && (r2 = o(a2), t2 < e2.length - 1 && ("string" == typeof e2[t2 + 1] || "plain-text" === e2[t2 + 1].type) && (r2 += o(e2[t2 + 1]), e2.splice(t2 + 1, 1)), 0 < t2 && ("string" == typeof e2[t2 - 1] || "plain-text" === e2[t2 - 1].type) && (r2 = o(e2[t2 - 1]) + r2, e2.splice(t2 - 1, 1), t2--), e2[t2] = new s.Token("plain-text", r2, null, r2)), a2.content && "string" != typeof a2.content && i(a2.content);
        }
    }
    var o = function o1(e2) {
        return e2 ? "string" == typeof e2 ? e2 : "string" == typeof e2.content ? e2.content : e2.content.map(o).join("") : "";
    };
    s.hooks.add("after-tokenize", function(e2) {
        "jsx" !== e2.language && "tsx" !== e2.language || i(e2.tokens);
    });
}($dfab79d8c9f9a829$export$dc7257ffb0972f87), function(e) {
    var n = e.util.clone(e.languages.typescript), n = (e.languages.tsx = e.languages.extend("jsx", n), delete e.languages.tsx.parameter, delete e.languages.tsx["literal-property"], e.languages.tsx.tag);
    n.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + "(?:" + n.pattern.source + ")", n.pattern.flags), n.lookbehind = true;
}($dfab79d8c9f9a829$export$dc7257ffb0972f87), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.swift = {
    comment: {
        pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
        lookbehind: true,
        greedy: true
    },
    "string-literal": [
        {
            pattern: RegExp(/(^|[^"#])/.source + "(?:" + /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
                    lookbehind: true,
                    inside: null
                },
                "interpolation-punctuation": {
                    pattern: /^\)|\\\($/,
                    alias: "punctuation"
                },
                punctuation: /\\(?=[\r\n])/,
                string: /[\s\S]+/
            }
        },
        {
            pattern: RegExp(/(^|[^"#])(#+)/.source + "(?:" + /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")\\2"),
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
                    lookbehind: true,
                    inside: null
                },
                "interpolation-punctuation": {
                    pattern: /^\)|\\#+\($/,
                    alias: "punctuation"
                },
                string: /[\s\S]+/
            }
        }
    ],
    directive: {
        pattern: RegExp(/#/.source + "(?:" + /(?:elseif|if)\b/.source + "(?:[ 	]*" + /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+|" + /(?:else|endif)\b/.source + ")"),
        alias: "property",
        inside: {
            "directive-name": /^#\w+/,
            boolean: /\b(?:false|true)\b/,
            number: /\b\d+(?:\.\d+)*\b/,
            operator: /!|&&|\|\||[<>]=?/,
            punctuation: /[(),]/
        }
    },
    literal: {
        pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
        alias: "constant"
    },
    "other-directive": {
        pattern: /#\w+\b/,
        alias: "property"
    },
    attribute: {
        pattern: /@\w+/,
        alias: "atrule"
    },
    "function-definition": {
        pattern: /(\bfunc\s+)\w+/,
        lookbehind: true,
        alias: "function"
    },
    label: {
        pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
        lookbehind: true,
        alias: "important"
    },
    keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
    boolean: /\b(?:false|true)\b/,
    nil: {
        pattern: /\bnil\b/,
        alias: "constant"
    },
    "short-argument": /\$\d+\b/,
    omit: {
        pattern: /\b_\b/,
        alias: "keyword"
    },
    number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
    "class-name": /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
    operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
    punctuation: /[{}[\]();,.:\\]/
}, $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.swift["string-literal"].forEach(function(e) {
    e.inside.interpolation.inside = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.swift;
}), function(e) {
    e.languages.kotlin = e.languages.extend("clike", {
        keyword: {
            pattern: /(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/,
            lookbehind: true
        },
        function: [
            {
                pattern: /(?:`[^\r\n`]+`|\b\w+)(?=\s*\()/,
                greedy: true
            },
            {
                pattern: /(\.)(?:`[^\r\n`]+`|\w+)(?=\s*\{)/,
                lookbehind: true,
                greedy: true
            }
        ],
        number: /\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/,
        operator: /\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/
    }), delete e.languages.kotlin["class-name"];
    var n = {
        "interpolation-punctuation": {
            pattern: /^\$\{?|\}$/,
            alias: "punctuation"
        },
        expression: {
            pattern: /[\s\S]+/,
            inside: e.languages.kotlin
        }
    };
    e.languages.insertBefore("kotlin", "string", {
        "string-literal": [
            {
                pattern: /"""(?:[^$]|\$(?:(?!\{)|\{[^{}]*\}))*?"""/,
                alias: "multiline",
                inside: {
                    interpolation: {
                        pattern: /\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                        inside: n
                    },
                    string: /[\s\S]+/
                }
            },
            {
                pattern: /"(?:[^"\\\r\n$]|\\.|\$(?:(?!\{)|\{[^{}]*\}))*"/,
                alias: "singleline",
                inside: {
                    interpolation: {
                        pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                        lookbehind: true,
                        inside: n
                    },
                    string: /[\s\S]+/
                }
            }
        ],
        char: {
            pattern: /'(?:[^'\\\r\n]|\\(?:.|u[a-fA-F0-9]{0,4}))'/,
            greedy: true
        }
    }), delete e.languages.kotlin.string, e.languages.insertBefore("kotlin", "keyword", {
        annotation: {
            pattern: /\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/,
            alias: "builtin"
        }
    }), e.languages.insertBefore("kotlin", "function", {
        label: {
            pattern: /\b\w+@|@\w+\b/,
            alias: "symbol"
        }
    }), e.languages.kt = e.languages.kotlin, e.languages.kts = e.languages.kotlin;
}($dfab79d8c9f9a829$export$dc7257ffb0972f87), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.c = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.extend("clike", {
    comment: {
        pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: true
    },
    string: {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: true
    },
    "class-name": {
        pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
        lookbehind: true
    },
    keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
    operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
}), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.insertBefore("c", "string", {
    char: {
        pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
        greedy: true
    }
}), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.insertBefore("c", "string", {
    macro: {
        pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
        lookbehind: true,
        greedy: true,
        alias: "property",
        inside: {
            string: [
                {
                    pattern: /^(#\s*include\s*)<[^>]+>/,
                    lookbehind: true
                },
                $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.c.string
            ],
            char: $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.c.char,
            comment: $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.c.comment,
            "macro-name": [
                {
                    pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
                    lookbehind: true
                },
                {
                    pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
                    lookbehind: true,
                    alias: "function"
                }
            ],
            directive: {
                pattern: /^(#\s*)[a-z]+/,
                lookbehind: true,
                alias: "keyword"
            },
            "directive-hash": /^#/,
            punctuation: /##|\\(?=[\r\n])/,
            expression: {
                pattern: /\S[\s\S]*/,
                inside: $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.c
            }
        }
    }
}), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.insertBefore("c", "function", {
    constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
}), delete $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.c.boolean, $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.objectivec = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.extend("c", {
    string: {
        pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: true
    },
    keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
    operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
}), delete $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.objectivec["class-name"], $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.objc = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.objectivec, $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.reason = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.extend("clike", {
    string: {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
        greedy: true
    },
    "class-name": /\b[A-Z]\w*/,
    keyword: /\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/,
    operator: /\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/
}), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.insertBefore("reason", "class-name", {
    char: {
        pattern: /'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/,
        greedy: true
    },
    constructor: /\b[A-Z]\w*\b(?!\s*\.)/,
    label: {
        pattern: /\b[a-z]\w*(?=::)/,
        alias: "symbol"
    }
}), delete $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.reason.function, function(e) {
    for(var n = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source, t = 0; t < 2; t++)n = n.replace(/<self>/g, function() {
        return n;
    });
    n = n.replace(/<self>/g, function() {
        return /[^\s\S]/.source;
    }), e.languages.rust = {
        comment: [
            {
                pattern: RegExp(/(^|[^\\])/.source + n),
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
            greedy: true
        },
        char: {
            pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
            greedy: true
        },
        attribute: {
            pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
            greedy: true,
            alias: "attr-name",
            inside: {
                string: null
            }
        },
        "closure-params": {
            pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
            lookbehind: true,
            greedy: true,
            inside: {
                "closure-punctuation": {
                    pattern: /^\||\|$/,
                    alias: "punctuation"
                },
                rest: null
            }
        },
        "lifetime-annotation": {
            pattern: /'\w+/,
            alias: "symbol"
        },
        "fragment-specifier": {
            pattern: /(\$\w+:)[a-z]+/,
            lookbehind: true,
            alias: "punctuation"
        },
        variable: /\$\w+/,
        "function-definition": {
            pattern: /(\bfn\s+)\w+/,
            lookbehind: true,
            alias: "function"
        },
        "type-definition": {
            pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
            lookbehind: true,
            alias: "class-name"
        },
        "module-declaration": [
            {
                pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
                lookbehind: true,
                alias: "namespace"
            },
            {
                pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
                lookbehind: true,
                alias: "namespace",
                inside: {
                    punctuation: /::/
                }
            }
        ],
        keyword: [
            /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
            /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
        ],
        function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
        macro: {
            pattern: /\b\w+!/,
            alias: "property"
        },
        constant: /\b[A-Z_][A-Z_\d]+\b/,
        "class-name": /\b[A-Z]\w*\b/,
        namespace: {
            pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
            inside: {
                punctuation: /::/
            }
        },
        number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
        boolean: /\b(?:false|true)\b/,
        punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
        operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
    }, e.languages.rust["closure-params"].inside.rest = e.languages.rust, e.languages.rust.attribute.inside.string = e.languages.rust.string;
}($dfab79d8c9f9a829$export$dc7257ffb0972f87), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.go = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.extend("clike", {
    string: {
        pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,
        lookbehind: true,
        greedy: true
    },
    keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
    boolean: /\b(?:_|false|iota|nil|true)\b/,
    number: [
        /\b0(?:b[01_]+|o[0-7_]+)i?\b/i,
        /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
        /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i
    ],
    operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
    builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/
}), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.insertBefore("go", "string", {
    char: {
        pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/,
        greedy: true
    }
}), delete $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.go["class-name"], function(e) {
    var n = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/, t = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
        return n.source;
    });
    e.languages.cpp = e.languages.extend("c", {
        "class-name": [
            {
                pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
                    return n.source;
                })),
                lookbehind: true
            },
            /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
            /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
            /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
        ],
        keyword: n,
        number: {
            pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
            greedy: true
        },
        operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
        boolean: /\b(?:false|true)\b/
    }), e.languages.insertBefore("cpp", "string", {
        module: {
            pattern: RegExp(/(\b(?:import|module)\s+)/.source + "(?:" + /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
                return t;
            }) + ")"),
            lookbehind: true,
            greedy: true,
            inside: {
                string: /^[<"][\s\S]+/,
                operator: /:/,
                punctuation: /\./
            }
        },
        "raw-string": {
            pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
            alias: "string",
            greedy: true
        }
    }), e.languages.insertBefore("cpp", "keyword", {
        "generic-function": {
            pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
            inside: {
                function: /^\w+/,
                generic: {
                    pattern: /<[\s\S]+/,
                    alias: "class-name",
                    inside: e.languages.cpp
                }
            }
        }
    }), e.languages.insertBefore("cpp", "operator", {
        "double-colon": {
            pattern: /::/,
            alias: "punctuation"
        }
    }), e.languages.insertBefore("cpp", "class-name", {
        "base-clause": {
            pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
            lookbehind: true,
            greedy: true,
            inside: e.languages.extend("cpp", {})
        }
    }), e.languages.insertBefore("inside", "double-colon", {
        "class-name": /\b[a-z_]\w*\b(?!\s*::)/i
    }, e.languages.cpp["base-clause"]);
}($dfab79d8c9f9a829$export$dc7257ffb0972f87), $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.python = {
    comment: {
        pattern: /(^|[^\\])#.*/,
        lookbehind: true,
        greedy: true
    },
    "string-interpolation": {
        pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
        greedy: true,
        inside: {
            interpolation: {
                pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
                lookbehind: true,
                inside: {
                    "format-spec": {
                        pattern: /(:)[^:(){}]+(?=\}$)/,
                        lookbehind: true
                    },
                    "conversion-option": {
                        pattern: /![sra](?=[:}]$)/,
                        alias: "punctuation"
                    },
                    rest: null
                }
            },
            string: /[\s\S]+/
        }
    },
    "triple-quoted-string": {
        pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
        greedy: true,
        alias: "string"
    },
    string: {
        pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
        greedy: true
    },
    function: {
        pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
        lookbehind: true
    },
    "class-name": {
        pattern: /(\bclass\s+)\w+/i,
        lookbehind: true
    },
    decorator: {
        pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
        lookbehind: true,
        alias: [
            "annotation",
            "punctuation"
        ],
        inside: {
            punctuation: /\./
        }
    },
    keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
    builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
    boolean: /\b(?:False|None|True)\b/,
    number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
    operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
    punctuation: /[{}[\];(),.:]/
}, $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.python["string-interpolation"].inside.interpolation.inside.rest = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.python, $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.py = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.python, $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.json = {
    property: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
        lookbehind: true,
        greedy: true
    },
    string: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
        lookbehind: true,
        greedy: true
    },
    comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: true
    },
    number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    punctuation: /[{}[\],]/,
    operator: /:/,
    boolean: /\b(?:false|true)\b/,
    null: {
        pattern: /\bnull\b/,
        alias: "keyword"
    }
}, $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.webmanifest = $dfab79d8c9f9a829$export$dc7257ffb0972f87.languages.json;
// src/themes/index.ts
var $dfab79d8c9f9a829$export$d9a33280f07116d9 = {};
$dfab79d8c9f9a829$var$__export($dfab79d8c9f9a829$export$d9a33280f07116d9, {
    dracula: function() {
        return $dfab79d8c9f9a829$var$dracula_default;
    },
    duotoneDark: function() {
        return $dfab79d8c9f9a829$var$duotoneDark_default;
    },
    duotoneLight: function() {
        return $dfab79d8c9f9a829$var$duotoneLight_default;
    },
    github: function() {
        return $dfab79d8c9f9a829$var$github_default;
    },
    gruvboxMaterialDark: function() {
        return $dfab79d8c9f9a829$var$gruvboxMaterialDark_default;
    },
    gruvboxMaterialLight: function() {
        return $dfab79d8c9f9a829$var$gruvboxMaterialLight_default;
    },
    jettwaveDark: function() {
        return $dfab79d8c9f9a829$var$jettwaveDark_default;
    },
    jettwaveLight: function() {
        return $dfab79d8c9f9a829$var$jettwaveLight_default;
    },
    nightOwl: function() {
        return $dfab79d8c9f9a829$var$nightOwl_default;
    },
    nightOwlLight: function() {
        return $dfab79d8c9f9a829$var$nightOwlLight_default;
    },
    oceanicNext: function() {
        return $dfab79d8c9f9a829$var$oceanicNext_default;
    },
    okaidia: function() {
        return $dfab79d8c9f9a829$var$okaidia_default;
    },
    oneDark: function() {
        return $dfab79d8c9f9a829$var$oneDark_default;
    },
    oneLight: function() {
        return $dfab79d8c9f9a829$var$oneLight_default;
    },
    palenight: function() {
        return $dfab79d8c9f9a829$var$palenight_default;
    },
    shadesOfPurple: function() {
        return $dfab79d8c9f9a829$var$shadesOfPurple_default;
    },
    synthwave84: function() {
        return $dfab79d8c9f9a829$var$synthwave84_default;
    },
    ultramin: function() {
        return $dfab79d8c9f9a829$var$ultramin_default;
    },
    vsDark: function() {
        return $dfab79d8c9f9a829$var$vsDark_default;
    },
    vsLight: function() {
        return $dfab79d8c9f9a829$var$vsLight_default;
    }
});
// src/themes/dracula.ts
var $dfab79d8c9f9a829$var$theme = {
    plain: {
        color: "#F8F8F2",
        backgroundColor: "#282A36"
    },
    styles: [
        {
            types: [
                "prolog",
                "constant",
                "builtin"
            ],
            style: {
                color: "rgb(189, 147, 249)"
            }
        },
        {
            types: [
                "inserted",
                "function"
            ],
            style: {
                color: "rgb(80, 250, 123)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgb(255, 85, 85)"
            }
        },
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(255, 184, 108)"
            }
        },
        {
            types: [
                "punctuation",
                "symbol"
            ],
            style: {
                color: "rgb(248, 248, 242)"
            }
        },
        {
            types: [
                "string",
                "char",
                "tag",
                "selector"
            ],
            style: {
                color: "rgb(255, 121, 198)"
            }
        },
        {
            types: [
                "keyword",
                "variable"
            ],
            style: {
                color: "rgb(189, 147, 249)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(98, 114, 164)"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "rgb(241, 250, 140)"
            }
        }
    ]
};
var $dfab79d8c9f9a829$var$dracula_default = $dfab79d8c9f9a829$var$theme;
// src/themes/duotoneDark.ts
var $dfab79d8c9f9a829$var$theme2 = {
    plain: {
        backgroundColor: "#2a2734",
        color: "#9a86fd"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "doctype",
                "cdata",
                "punctuation"
            ],
            style: {
                color: "#6c6783"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        },
        {
            types: [
                "tag",
                "operator",
                "number"
            ],
            style: {
                color: "#e09142"
            }
        },
        {
            types: [
                "property",
                "function"
            ],
            style: {
                color: "#9a86fd"
            }
        },
        {
            types: [
                "tag-id",
                "selector",
                "atrule-id"
            ],
            style: {
                color: "#eeebff"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "#c4b9fe"
            }
        },
        {
            types: [
                "boolean",
                "string",
                "entity",
                "url",
                "attr-value",
                "keyword",
                "control",
                "directive",
                "unit",
                "statement",
                "regex",
                "atrule",
                "placeholder",
                "variable"
            ],
            style: {
                color: "#ffcc99"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "#c4b9fe"
            }
        }
    ]
};
var $dfab79d8c9f9a829$var$duotoneDark_default = $dfab79d8c9f9a829$var$theme2;
// src/themes/duotoneLight.ts
var $dfab79d8c9f9a829$var$theme3 = {
    plain: {
        backgroundColor: "#faf8f5",
        color: "#728fcb"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "doctype",
                "cdata",
                "punctuation"
            ],
            style: {
                color: "#b6ad9a"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        },
        {
            types: [
                "tag",
                "operator",
                "number"
            ],
            style: {
                color: "#063289"
            }
        },
        {
            types: [
                "property",
                "function"
            ],
            style: {
                color: "#b29762"
            }
        },
        {
            types: [
                "tag-id",
                "selector",
                "atrule-id"
            ],
            style: {
                color: "#2d2006"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "#896724"
            }
        },
        {
            types: [
                "boolean",
                "string",
                "entity",
                "url",
                "attr-value",
                "keyword",
                "control",
                "directive",
                "unit",
                "statement",
                "regex",
                "atrule"
            ],
            style: {
                color: "#728fcb"
            }
        },
        {
            types: [
                "placeholder",
                "variable"
            ],
            style: {
                color: "#93abdc"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "#896724"
            }
        }
    ]
};
var $dfab79d8c9f9a829$var$duotoneLight_default = $dfab79d8c9f9a829$var$theme3;
// src/themes/github.ts
var $dfab79d8c9f9a829$var$theme4 = {
    plain: {
        color: "#393A34",
        backgroundColor: "#f6f8fa"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "doctype",
                "cdata"
            ],
            style: {
                color: "#999988",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        },
        {
            types: [
                "string",
                "attr-value"
            ],
            style: {
                color: "#e3116c"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "#393A34"
            }
        },
        {
            types: [
                "entity",
                "url",
                "symbol",
                "number",
                "boolean",
                "variable",
                "constant",
                "property",
                "regex",
                "inserted"
            ],
            style: {
                color: "#36acaa"
            }
        },
        {
            types: [
                "atrule",
                "keyword",
                "attr-name",
                "selector"
            ],
            style: {
                color: "#00a4db"
            }
        },
        {
            types: [
                "function",
                "deleted",
                "tag"
            ],
            style: {
                color: "#d73a49"
            }
        },
        {
            types: [
                "function-variable"
            ],
            style: {
                color: "#6f42c1"
            }
        },
        {
            types: [
                "tag",
                "selector",
                "keyword"
            ],
            style: {
                color: "#00009f"
            }
        }
    ]
};
var $dfab79d8c9f9a829$var$github_default = $dfab79d8c9f9a829$var$theme4;
// src/themes/nightOwl.ts
var $dfab79d8c9f9a829$var$theme5 = {
    plain: {
        color: "#d6deeb",
        backgroundColor: "#011627"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(162, 191, 252)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgba(239, 83, 80, 0.56)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "inserted",
                "attr-name"
            ],
            style: {
                color: "rgb(173, 219, 103)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(99, 119, 119)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "url"
            ],
            style: {
                color: "rgb(173, 219, 103)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(214, 222, 235)"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "rgb(247, 140, 108)"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function"
            ],
            style: {
                color: "rgb(130, 170, 255)"
            }
        },
        {
            // This was manually added after the auto-generation
            // so that punctuations are not italicised
            types: [
                "punctuation"
            ],
            style: {
                color: "rgb(199, 146, 234)"
            }
        },
        {
            types: [
                "selector",
                "doctype"
            ],
            style: {
                color: "rgb(199, 146, 234)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(255, 203, 139)"
            }
        },
        {
            types: [
                "tag",
                "operator",
                "keyword"
            ],
            style: {
                color: "rgb(127, 219, 202)"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "rgb(255, 88, 116)"
            }
        },
        {
            types: [
                "property"
            ],
            style: {
                color: "rgb(128, 203, 196)"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                color: "rgb(178, 204, 214)"
            }
        }
    ]
};
var $dfab79d8c9f9a829$var$nightOwl_default = $dfab79d8c9f9a829$var$theme5;
// src/themes/nightOwlLight.ts
var $dfab79d8c9f9a829$var$theme6 = {
    plain: {
        color: "#403f53",
        backgroundColor: "#FBFBFB"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(162, 191, 252)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgba(239, 83, 80, 0.56)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "inserted",
                "attr-name"
            ],
            style: {
                color: "rgb(72, 118, 214)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(152, 159, 177)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "builtin",
                "char",
                "constant",
                "url"
            ],
            style: {
                color: "rgb(72, 118, 214)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(201, 103, 101)"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "rgb(170, 9, 130)"
            }
        },
        {
            // This was manually added after the auto-generation
            // so that punctuations are not italicised
            types: [
                "punctuation"
            ],
            style: {
                color: "rgb(153, 76, 195)"
            }
        },
        {
            types: [
                "function",
                "selector",
                "doctype"
            ],
            style: {
                color: "rgb(153, 76, 195)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(17, 17, 17)"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "rgb(153, 76, 195)"
            }
        },
        {
            types: [
                "operator",
                "property",
                "keyword",
                "namespace"
            ],
            style: {
                color: "rgb(12, 150, 155)"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "rgb(188, 84, 84)"
            }
        }
    ]
};
var $dfab79d8c9f9a829$var$nightOwlLight_default = $dfab79d8c9f9a829$var$theme6;
// src/themes/oceanicNext.ts
var $dfab79d8c9f9a829$var$colors = {
    char: "#D8DEE9",
    comment: "#999999",
    keyword: "#c5a5c5",
    primitive: "#5a9bcf",
    string: "#8dc891",
    variable: "#d7deea",
    boolean: "#ff8b50",
    punctuation: "#5FB3B3",
    tag: "#fc929e",
    function: "#79b6f2",
    className: "#FAC863",
    method: "#6699CC",
    operator: "#fc929e"
};
var $dfab79d8c9f9a829$var$theme7 = {
    plain: {
        backgroundColor: "#282c34",
        color: "#ffffff"
    },
    styles: [
        {
            types: [
                "attr-name"
            ],
            style: {
                color: $dfab79d8c9f9a829$var$colors.keyword
            }
        },
        {
            types: [
                "attr-value"
            ],
            style: {
                color: $dfab79d8c9f9a829$var$colors.string
            }
        },
        {
            types: [
                "comment",
                "block-comment",
                "prolog",
                "doctype",
                "cdata",
                "shebang"
            ],
            style: {
                color: $dfab79d8c9f9a829$var$colors.comment
            }
        },
        {
            types: [
                "property",
                "number",
                "function-name",
                "constant",
                "symbol",
                "deleted"
            ],
            style: {
                color: $dfab79d8c9f9a829$var$colors.primitive
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: $dfab79d8c9f9a829$var$colors.boolean
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: $dfab79d8c9f9a829$var$colors.tag
            }
        },
        {
            types: [
                "string"
            ],
            style: {
                color: $dfab79d8c9f9a829$var$colors.string
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: $dfab79d8c9f9a829$var$colors.string
            }
        },
        {
            types: [
                "selector",
                "char",
                "builtin",
                "inserted"
            ],
            style: {
                color: $dfab79d8c9f9a829$var$colors.char
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: $dfab79d8c9f9a829$var$colors.function
            }
        },
        {
            types: [
                "operator",
                "entity",
                "url",
                "variable"
            ],
            style: {
                color: $dfab79d8c9f9a829$var$colors.variable
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                color: $dfab79d8c9f9a829$var$colors.keyword
            }
        },
        {
            types: [
                "atrule",
                "class-name"
            ],
            style: {
                color: $dfab79d8c9f9a829$var$colors.className
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                fontWeight: "400"
            }
        },
        {
            types: [
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        }
    ]
};
var $dfab79d8c9f9a829$var$oceanicNext_default = $dfab79d8c9f9a829$var$theme7;
// src/themes/okaidia.ts
var $dfab79d8c9f9a829$var$theme8 = {
    plain: {
        color: "#f8f8f2",
        backgroundColor: "#272822"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(162, 191, 252)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "#f92672",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                color: "rgb(173, 219, 103)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "#8292a2",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "url"
            ],
            style: {
                color: "#a6e22e"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "#f8f8f2"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "#ae81ff"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function",
                "class-name"
            ],
            style: {
                color: "#e6db74"
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: "#f8f8f2"
            }
        },
        {
            types: [
                "selector",
                "doctype"
            ],
            style: {
                color: "#a6e22e",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "tag",
                "operator",
                "keyword"
            ],
            style: {
                color: "#66d9ef"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "#ae81ff"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                color: "rgb(178, 204, 214)",
                opacity: 0.7
            }
        },
        {
            types: [
                "tag",
                "property"
            ],
            style: {
                color: "#f92672"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "#a6e22e !important"
            }
        },
        {
            types: [
                "doctype"
            ],
            style: {
                color: "#8292a2"
            }
        },
        {
            types: [
                "rule"
            ],
            style: {
                color: "#e6db74"
            }
        }
    ]
};
var $dfab79d8c9f9a829$var$okaidia_default = $dfab79d8c9f9a829$var$theme8;
// src/themes/palenight.ts
var $dfab79d8c9f9a829$var$theme9 = {
    plain: {
        color: "#bfc7d5",
        backgroundColor: "#292d3e"
    },
    styles: [
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(105, 112, 152)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "inserted"
            ],
            style: {
                color: "rgb(195, 232, 141)"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "rgb(247, 140, 108)"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function"
            ],
            style: {
                color: "rgb(130, 170, 255)"
            }
        },
        {
            types: [
                "punctuation",
                "selector"
            ],
            style: {
                color: "rgb(199, 146, 234)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(191, 199, 213)"
            }
        },
        {
            types: [
                "class-name",
                "attr-name"
            ],
            style: {
                color: "rgb(255, 203, 107)"
            }
        },
        {
            types: [
                "tag",
                "deleted"
            ],
            style: {
                color: "rgb(255, 85, 114)"
            }
        },
        {
            types: [
                "operator"
            ],
            style: {
                color: "rgb(137, 221, 255)"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "rgb(255, 88, 116)"
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "doctype"
            ],
            style: {
                color: "rgb(199, 146, 234)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                color: "rgb(178, 204, 214)"
            }
        },
        {
            types: [
                "url"
            ],
            style: {
                color: "rgb(221, 221, 221)"
            }
        }
    ]
};
var $dfab79d8c9f9a829$var$palenight_default = $dfab79d8c9f9a829$var$theme9;
// src/themes/shadesOfPurple.ts
var $dfab79d8c9f9a829$var$theme10 = {
    plain: {
        color: "#9EFEFF",
        backgroundColor: "#2D2A55"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(255, 238, 128)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgba(239, 83, 80, 0.56)"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                color: "rgb(173, 219, 103)"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(179, 98, 255)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: "rgb(255, 255, 255)"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "rgb(255, 98, 140)"
            }
        },
        {
            types: [
                "string",
                "url"
            ],
            style: {
                color: "rgb(165, 255, 144)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(255, 238, 128)"
            }
        },
        {
            types: [
                "number",
                "boolean"
            ],
            style: {
                color: "rgb(255, 98, 140)"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "rgb(255, 180, 84)"
            }
        },
        {
            types: [
                "keyword",
                "operator",
                "property",
                "namespace",
                "tag",
                "selector",
                "doctype"
            ],
            style: {
                color: "rgb(255, 157, 0)"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function",
                "class-name"
            ],
            style: {
                color: "rgb(250, 208, 0)"
            }
        }
    ]
};
var $dfab79d8c9f9a829$var$shadesOfPurple_default = $dfab79d8c9f9a829$var$theme10;
// src/themes/synthwave84.ts
var $dfab79d8c9f9a829$var$theme11 = {
    plain: {
        backgroundColor: "linear-gradient(to bottom, #2a2139 75%, #34294f)",
        backgroundImage: "#34294f",
        color: "#f92aad",
        textShadow: "0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"
    },
    styles: [
        {
            types: [
                "comment",
                "block-comment",
                "prolog",
                "doctype",
                "cdata"
            ],
            style: {
                color: "#495495",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: "#ccc"
            }
        },
        {
            types: [
                "tag",
                "attr-name",
                "namespace",
                "number",
                "unit",
                "hexcode",
                "deleted"
            ],
            style: {
                color: "#e2777a"
            }
        },
        {
            types: [
                "property",
                "selector"
            ],
            style: {
                color: "#72f1b8",
                textShadow: "0 0 2px #100c0f, 0 0 10px #257c5575, 0 0 35px #21272475"
            }
        },
        {
            types: [
                "function-name"
            ],
            style: {
                color: "#6196cc"
            }
        },
        {
            types: [
                "boolean",
                "selector-id",
                "function"
            ],
            style: {
                color: "#fdfdfd",
                textShadow: "0 0 2px #001716, 0 0 3px #03edf975, 0 0 5px #03edf975, 0 0 8px #03edf975"
            }
        },
        {
            types: [
                "class-name",
                "maybe-class-name",
                "builtin"
            ],
            style: {
                color: "#fff5f6",
                textShadow: "0 0 2px #000, 0 0 10px #fc1f2c75, 0 0 5px #fc1f2c75, 0 0 25px #fc1f2c75"
            }
        },
        {
            types: [
                "constant",
                "symbol"
            ],
            style: {
                color: "#f92aad",
                textShadow: "0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"
            }
        },
        {
            types: [
                "important",
                "atrule",
                "keyword",
                "selector-class"
            ],
            style: {
                color: "#f4eee4",
                textShadow: "0 0 2px #393a33, 0 0 8px #f39f0575, 0 0 2px #f39f0575"
            }
        },
        {
            types: [
                "string",
                "char",
                "attr-value",
                "regex",
                "variable"
            ],
            style: {
                color: "#f87c32"
            }
        },
        {
            types: [
                "parameter"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "entity",
                "url"
            ],
            style: {
                color: "#67cdcc"
            }
        },
        {
            types: [
                "operator"
            ],
            style: {
                color: "ffffffee"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "entity"
            ],
            style: {
                cursor: "help"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                color: "green"
            }
        }
    ]
};
var $dfab79d8c9f9a829$var$synthwave84_default = $dfab79d8c9f9a829$var$theme11;
// src/themes/ultramin.ts
var $dfab79d8c9f9a829$var$theme12 = {
    plain: {
        color: "#282a2e",
        backgroundColor: "#ffffff"
    },
    styles: [
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(197, 200, 198)"
            }
        },
        {
            types: [
                "string",
                "number",
                "builtin",
                "variable"
            ],
            style: {
                color: "rgb(150, 152, 150)"
            }
        },
        {
            types: [
                "class-name",
                "function",
                "tag",
                "attr-name"
            ],
            style: {
                color: "rgb(40, 42, 46)"
            }
        }
    ]
};
var $dfab79d8c9f9a829$var$ultramin_default = $dfab79d8c9f9a829$var$theme12;
// src/themes/vsDark.ts
var $dfab79d8c9f9a829$var$theme13 = {
    plain: {
        color: "#9CDCFE",
        backgroundColor: "#1E1E1E"
    },
    styles: [
        {
            types: [
                "prolog"
            ],
            style: {
                color: "rgb(0, 0, 128)"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(106, 153, 85)"
            }
        },
        {
            types: [
                "builtin",
                "changed",
                "keyword",
                "interpolation-punctuation"
            ],
            style: {
                color: "rgb(86, 156, 214)"
            }
        },
        {
            types: [
                "number",
                "inserted"
            ],
            style: {
                color: "rgb(181, 206, 168)"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "rgb(100, 102, 149)"
            }
        },
        {
            types: [
                "attr-name",
                "variable"
            ],
            style: {
                color: "rgb(156, 220, 254)"
            }
        },
        {
            types: [
                "deleted",
                "string",
                "attr-value",
                "template-punctuation"
            ],
            style: {
                color: "rgb(206, 145, 120)"
            }
        },
        {
            types: [
                "selector"
            ],
            style: {
                color: "rgb(215, 186, 125)"
            }
        },
        {
            // Fix tag color
            types: [
                "tag"
            ],
            style: {
                color: "rgb(78, 201, 176)"
            }
        },
        {
            // Fix tag color for HTML
            types: [
                "tag"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "rgb(86, 156, 214)"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "rgb(212, 212, 212)"
            }
        },
        {
            // Fix punctuation color for HTML
            types: [
                "punctuation"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#808080"
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: "rgb(220, 220, 170)"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(78, 201, 176)"
            }
        },
        {
            types: [
                "char"
            ],
            style: {
                color: "rgb(209, 105, 105)"
            }
        }
    ]
};
var $dfab79d8c9f9a829$var$vsDark_default = $dfab79d8c9f9a829$var$theme13;
// src/themes/vsLight.ts
var $dfab79d8c9f9a829$var$theme14 = {
    plain: {
        color: "#000000",
        backgroundColor: "#ffffff"
    },
    styles: [
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(0, 128, 0)"
            }
        },
        {
            types: [
                "builtin"
            ],
            style: {
                color: "rgb(0, 112, 193)"
            }
        },
        {
            types: [
                "number",
                "variable",
                "inserted"
            ],
            style: {
                color: "rgb(9, 134, 88)"
            }
        },
        {
            types: [
                "operator"
            ],
            style: {
                color: "rgb(0, 0, 0)"
            }
        },
        {
            types: [
                "constant",
                "char"
            ],
            style: {
                color: "rgb(129, 31, 63)"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "rgb(128, 0, 0)"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "rgb(255, 0, 0)"
            }
        },
        {
            types: [
                "deleted",
                "string"
            ],
            style: {
                color: "rgb(163, 21, 21)"
            }
        },
        {
            types: [
                "changed",
                "punctuation"
            ],
            style: {
                color: "rgb(4, 81, 165)"
            }
        },
        {
            types: [
                "function",
                "keyword"
            ],
            style: {
                color: "rgb(0, 0, 255)"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(38, 127, 153)"
            }
        }
    ]
};
var $dfab79d8c9f9a829$var$vsLight_default = $dfab79d8c9f9a829$var$theme14;
// src/themes/jettwaveDark.ts
var $dfab79d8c9f9a829$var$theme15 = {
    plain: {
        color: "#f8fafc",
        backgroundColor: "#011627"
    },
    styles: [
        {
            types: [
                "prolog"
            ],
            style: {
                color: "#000080"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "#6A9955"
            }
        },
        {
            types: [
                "builtin",
                "changed",
                "keyword",
                "interpolation-punctuation"
            ],
            style: {
                color: "#569CD6"
            }
        },
        {
            types: [
                "number",
                "inserted"
            ],
            style: {
                color: "#B5CEA8"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "#f8fafc"
            }
        },
        {
            types: [
                "attr-name",
                "variable"
            ],
            style: {
                color: "#9CDCFE"
            }
        },
        {
            types: [
                "deleted",
                "string",
                "attr-value",
                "template-punctuation"
            ],
            style: {
                color: "#cbd5e1"
            }
        },
        {
            types: [
                "selector"
            ],
            style: {
                color: "#D7BA7D"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "tag"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "#D4D4D4"
            }
        },
        {
            types: [
                "punctuation"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#808080"
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: "#7dd3fc"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "char"
            ],
            style: {
                color: "#D16969"
            }
        }
    ]
};
var $dfab79d8c9f9a829$var$jettwaveDark_default = $dfab79d8c9f9a829$var$theme15;
// src/themes/jettwaveLight.ts
var $dfab79d8c9f9a829$var$theme16 = {
    plain: {
        color: "#0f172a",
        backgroundColor: "#f1f5f9"
    },
    styles: [
        {
            types: [
                "prolog"
            ],
            style: {
                color: "#000080"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "#6A9955"
            }
        },
        {
            types: [
                "builtin",
                "changed",
                "keyword",
                "interpolation-punctuation"
            ],
            style: {
                color: "#0c4a6e"
            }
        },
        {
            types: [
                "number",
                "inserted"
            ],
            style: {
                color: "#B5CEA8"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "#0f172a"
            }
        },
        {
            types: [
                "attr-name",
                "variable"
            ],
            style: {
                color: "#0c4a6e"
            }
        },
        {
            types: [
                "deleted",
                "string",
                "attr-value",
                "template-punctuation"
            ],
            style: {
                color: "#64748b"
            }
        },
        {
            types: [
                "selector"
            ],
            style: {
                color: "#D7BA7D"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "tag"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "#475569"
            }
        },
        {
            types: [
                "punctuation"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#808080"
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: "#0e7490"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "char"
            ],
            style: {
                color: "#D16969"
            }
        }
    ]
};
var $dfab79d8c9f9a829$var$jettwaveLight_default = $dfab79d8c9f9a829$var$theme16;
// src/themes/oneDark.ts
var $dfab79d8c9f9a829$var$theme17 = {
    plain: {
        backgroundColor: "hsl(220, 13%, 18%)",
        color: "hsl(220, 14%, 71%)",
        textShadow: "0 1px rgba(0, 0, 0, 0.3)"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "cdata"
            ],
            style: {
                color: "hsl(220, 10%, 40%)"
            }
        },
        {
            types: [
                "doctype",
                "punctuation",
                "entity"
            ],
            style: {
                color: "hsl(220, 14%, 71%)"
            }
        },
        {
            types: [
                "attr-name",
                "class-name",
                "maybe-class-name",
                "boolean",
                "constant",
                "number",
                "atrule"
            ],
            style: {
                color: "hsl(29, 54%, 61%)"
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                color: "hsl(286, 60%, 67%)"
            }
        },
        {
            types: [
                "property",
                "tag",
                "symbol",
                "deleted",
                "important"
            ],
            style: {
                color: "hsl(355, 65%, 65%)"
            }
        },
        {
            types: [
                "selector",
                "string",
                "char",
                "builtin",
                "inserted",
                "regex",
                "attr-value"
            ],
            style: {
                color: "hsl(95, 38%, 62%)"
            }
        },
        {
            types: [
                "variable",
                "operator",
                "function"
            ],
            style: {
                color: "hsl(207, 82%, 66%)"
            }
        },
        {
            types: [
                "url"
            ],
            style: {
                color: "hsl(187, 47%, 55%)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "hsl(220, 14%, 71%)"
            }
        }
    ]
};
var $dfab79d8c9f9a829$var$oneDark_default = $dfab79d8c9f9a829$var$theme17;
// src/themes/oneLight.ts
var $dfab79d8c9f9a829$var$theme18 = {
    plain: {
        backgroundColor: "hsl(230, 1%, 98%)",
        color: "hsl(230, 8%, 24%)"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "cdata"
            ],
            style: {
                color: "hsl(230, 4%, 64%)"
            }
        },
        {
            types: [
                "doctype",
                "punctuation",
                "entity"
            ],
            style: {
                color: "hsl(230, 8%, 24%)"
            }
        },
        {
            types: [
                "attr-name",
                "class-name",
                "boolean",
                "constant",
                "number",
                "atrule"
            ],
            style: {
                color: "hsl(35, 99%, 36%)"
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                color: "hsl(301, 63%, 40%)"
            }
        },
        {
            types: [
                "property",
                "tag",
                "symbol",
                "deleted",
                "important"
            ],
            style: {
                color: "hsl(5, 74%, 59%)"
            }
        },
        {
            types: [
                "selector",
                "string",
                "char",
                "builtin",
                "inserted",
                "regex",
                "attr-value",
                "punctuation"
            ],
            style: {
                color: "hsl(119, 34%, 47%)"
            }
        },
        {
            types: [
                "variable",
                "operator",
                "function"
            ],
            style: {
                color: "hsl(221, 87%, 60%)"
            }
        },
        {
            types: [
                "url"
            ],
            style: {
                color: "hsl(198, 99%, 37%)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "hsl(230, 8%, 24%)"
            }
        }
    ]
};
var $dfab79d8c9f9a829$var$oneLight_default = $dfab79d8c9f9a829$var$theme18;
// src/themes/gruvboxMaterialDark.ts
var $dfab79d8c9f9a829$var$theme19 = {
    plain: {
        color: "#ebdbb2",
        backgroundColor: "#292828"
    },
    styles: [
        {
            types: [
                "imports",
                "class-name",
                "maybe-class-name",
                "constant",
                "doctype",
                "builtin",
                "function"
            ],
            style: {
                color: "#d8a657"
            }
        },
        {
            types: [
                "property-access"
            ],
            style: {
                color: "#7daea3"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#e78a4e"
            }
        },
        {
            types: [
                "attr-name",
                "char",
                "url",
                "regex"
            ],
            style: {
                color: "#a9b665"
            }
        },
        {
            types: [
                "attr-value",
                "string"
            ],
            style: {
                color: "#89b482"
            }
        },
        {
            types: [
                "comment",
                "prolog",
                "cdata",
                "operator",
                "inserted"
            ],
            style: {
                color: "#a89984"
            }
        },
        {
            types: [
                "delimiter",
                "boolean",
                "keyword",
                "selector",
                "important",
                "atrule",
                "property",
                "variable",
                "deleted"
            ],
            style: {
                color: "#ea6962"
            }
        },
        {
            types: [
                "entity",
                "number",
                "symbol"
            ],
            style: {
                color: "#d3869b"
            }
        }
    ]
};
var $dfab79d8c9f9a829$var$gruvboxMaterialDark_default = $dfab79d8c9f9a829$var$theme19;
// src/themes/gruvboxMaterialLight.ts
var $dfab79d8c9f9a829$var$theme20 = {
    plain: {
        color: "#654735",
        backgroundColor: "#f9f5d7"
    },
    styles: [
        {
            types: [
                "delimiter",
                "boolean",
                "keyword",
                "selector",
                "important",
                "atrule",
                "property",
                "variable",
                "deleted"
            ],
            style: {
                color: "#af2528"
            }
        },
        {
            types: [
                "imports",
                "class-name",
                "maybe-class-name",
                "constant",
                "doctype",
                "builtin"
            ],
            style: {
                color: "#b4730e"
            }
        },
        {
            types: [
                "string",
                "attr-value"
            ],
            style: {
                color: "#477a5b"
            }
        },
        {
            types: [
                "property-access"
            ],
            style: {
                color: "#266b79"
            }
        },
        {
            types: [
                "function",
                "attr-name",
                "char",
                "url"
            ],
            style: {
                color: "#72761e"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#b94c07"
            }
        },
        {
            types: [
                "comment",
                "prolog",
                "cdata",
                "operator",
                "inserted"
            ],
            style: {
                color: "#a89984"
            }
        },
        {
            types: [
                "entity",
                "number",
                "symbol"
            ],
            style: {
                color: "#924f79"
            }
        }
    ]
};
var $dfab79d8c9f9a829$var$gruvboxMaterialLight_default = $dfab79d8c9f9a829$var$theme20;
var $dfab79d8c9f9a829$var$useGetLineProps = function(themeDictionary) {
    return (0, $lliNT.useCallback)(function(_a) {
        var _b = _a, className = _b.className, style = _b.style, line = _b.line, rest = $dfab79d8c9f9a829$var$__objRest(_b, [
            "className",
            "style",
            "line"
        ]);
        var output = $dfab79d8c9f9a829$var$__spreadProps($dfab79d8c9f9a829$var$__spreadValues({}, rest), {
            className: (0, $51b1b578e3b8ff34$export$2e2bcd8739ae039)("token-line", className)
        });
        if ((typeof themeDictionary === "undefined" ? "undefined" : (0, $7E0eS._)(themeDictionary)) === "object" && "plain" in themeDictionary) output.style = themeDictionary.plain;
        if ((typeof style === "undefined" ? "undefined" : (0, $7E0eS._)(style)) === "object") output.style = $dfab79d8c9f9a829$var$__spreadValues($dfab79d8c9f9a829$var$__spreadValues({}, output.style || {}), style);
        return output;
    }, [
        themeDictionary
    ]);
};
var $dfab79d8c9f9a829$var$useGetTokenProps = function(themeDictionary) {
    var styleForToken = (0, $lliNT.useCallback)(function(param) {
        var types = param.types, empty = param.empty;
        var _Object;
        if (themeDictionary == null) return void 0;
        else if (types.length === 1 && types[0] === "plain") return empty != null ? {
            display: "inline-block"
        } : void 0;
        else if (types.length === 1 && empty != null) return themeDictionary[types[0]];
        return (_Object = Object).assign.apply(_Object, [
            empty != null ? {
                display: "inline-block"
            } : {}
        ].concat((0, $aUGqu._)(types.map(function(type) {
            return themeDictionary[type];
        }))));
    }, [
        themeDictionary
    ]);
    return (0, $lliNT.useCallback)(function(_a) {
        var _b = _a, token = _b.token, className = _b.className, style = _b.style, rest = $dfab79d8c9f9a829$var$__objRest(_b, [
            "token",
            "className",
            "style"
        ]);
        var output = $dfab79d8c9f9a829$var$__spreadProps($dfab79d8c9f9a829$var$__spreadValues({}, rest), {
            className: (0, $51b1b578e3b8ff34$export$2e2bcd8739ae039).apply(void 0, [
                "token"
            ].concat((0, $aUGqu._)(token.types), [
                className
            ])),
            children: token.content,
            style: styleForToken(token)
        });
        if (style != null) output.style = $dfab79d8c9f9a829$var$__spreadValues($dfab79d8c9f9a829$var$__spreadValues({}, output.style || {}), style);
        return output;
    }, [
        styleForToken
    ]);
};
// src/utils/normalizeTokens.ts
var $dfab79d8c9f9a829$var$newlineRe = /\r\n|\r|\n/;
var $dfab79d8c9f9a829$var$normalizeEmptyLines = function(line) {
    if (line.length === 0) line.push({
        types: [
            "plain"
        ],
        content: "\n",
        empty: true
    });
    else if (line.length === 1 && line[0].content === "") {
        line[0].content = "\n";
        line[0].empty = true;
    }
};
var $dfab79d8c9f9a829$var$appendTypes = function(types, add) {
    var typesSize = types.length;
    if (typesSize > 0 && types[typesSize - 1] === add) return types;
    return types.concat(add);
};
var $dfab79d8c9f9a829$var$normalizeTokens = function(tokens) {
    var typeArrStack = [
        []
    ];
    var tokenArrStack = [
        tokens
    ];
    var tokenArrIndexStack = [
        0
    ];
    var tokenArrSizeStack = [
        tokens.length
    ];
    var i = 0;
    var stackIndex = 0;
    var currentLine = [];
    var acc = [
        currentLine
    ];
    while(stackIndex > -1){
        while((i = tokenArrIndexStack[stackIndex]++) < tokenArrSizeStack[stackIndex]){
            var content = void 0;
            var types = typeArrStack[stackIndex];
            var tokenArr = tokenArrStack[stackIndex];
            var token = tokenArr[i];
            if (typeof token === "string") {
                types = stackIndex > 0 ? types : [
                    "plain"
                ];
                content = token;
            } else {
                types = $dfab79d8c9f9a829$var$appendTypes(types, token.type);
                if (token.alias) types = $dfab79d8c9f9a829$var$appendTypes(types, token.alias);
                content = token.content;
            }
            if (typeof content !== "string") {
                stackIndex++;
                typeArrStack.push(types);
                tokenArrStack.push(content);
                tokenArrIndexStack.push(0);
                tokenArrSizeStack.push(content.length);
                continue;
            }
            var splitByNewlines = content.split($dfab79d8c9f9a829$var$newlineRe);
            var newlineCount = splitByNewlines.length;
            currentLine.push({
                types: types,
                content: splitByNewlines[0]
            });
            for(var i2 = 1; i2 < newlineCount; i2++){
                $dfab79d8c9f9a829$var$normalizeEmptyLines(currentLine);
                acc.push(currentLine = []);
                currentLine.push({
                    types: types,
                    content: splitByNewlines[i2]
                });
            }
        }
        stackIndex--;
        typeArrStack.pop();
        tokenArrStack.pop();
        tokenArrIndexStack.pop();
        tokenArrSizeStack.pop();
    }
    $dfab79d8c9f9a829$var$normalizeEmptyLines(currentLine);
    return acc;
};
var $dfab79d8c9f9a829$export$2dc420fd853fdcc4 = $dfab79d8c9f9a829$var$normalizeTokens;
var $dfab79d8c9f9a829$export$7b94e077f7691ca1 = function(param) {
    var prism = param.prism, code = param.code, grammar = param.grammar, language = param.language;
    return (0, $lliNT.useMemo)(function() {
        if (grammar == null) return $dfab79d8c9f9a829$export$2dc420fd853fdcc4([
            code
        ]);
        var prismConfig = {
            code: code,
            grammar: grammar,
            language: language,
            tokens: []
        };
        prism.hooks.run("before-tokenize", prismConfig);
        prismConfig.tokens = prism.tokenize(code, grammar);
        prism.hooks.run("after-tokenize", prismConfig);
        return $dfab79d8c9f9a829$export$2dc420fd853fdcc4(prismConfig.tokens);
    }, [
        code,
        grammar,
        language,
        // prism is a stable import
        prism
    ]);
};
// src/utils/themeToDict.ts
var $dfab79d8c9f9a829$var$themeToDict = function(theme21, language) {
    var plain = theme21.plain;
    var themeDict = theme21.styles.reduce(function(acc, themeEntry) {
        var languages2 = themeEntry.languages, style = themeEntry.style;
        if (languages2 && !languages2.includes(language)) return acc;
        themeEntry.types.forEach(function(type) {
            var accStyle = $dfab79d8c9f9a829$var$__spreadValues($dfab79d8c9f9a829$var$__spreadValues({}, acc[type]), style);
            acc[type] = accStyle;
        });
        return acc;
    }, {});
    themeDict.root = plain;
    themeDict.plain = $dfab79d8c9f9a829$var$__spreadProps($dfab79d8c9f9a829$var$__spreadValues({}, plain), {
        backgroundColor: void 0
    });
    return themeDict;
};
var $dfab79d8c9f9a829$var$themeToDict_default = $dfab79d8c9f9a829$var$themeToDict;
// src/components/highlight.ts
var $dfab79d8c9f9a829$var$Highlight = function(param) {
    var children = param.children, _language = param.language, code = param.code, theme21 = param.theme, prism = param.prism;
    var language = _language.toLowerCase();
    var themeDictionary = $dfab79d8c9f9a829$var$themeToDict_default(theme21, language);
    var getLineProps = $dfab79d8c9f9a829$var$useGetLineProps(themeDictionary);
    var getTokenProps = $dfab79d8c9f9a829$var$useGetTokenProps(themeDictionary);
    var grammar = prism.languages[language];
    var tokens = $dfab79d8c9f9a829$export$7b94e077f7691ca1({
        prism: prism,
        language: language,
        code: code,
        grammar: grammar
    });
    return children({
        tokens: tokens,
        className: "prism-code language-".concat(language),
        style: themeDictionary != null ? themeDictionary.root : {},
        getLineProps: getLineProps,
        getTokenProps: getTokenProps
    });
};
// src/index.ts
var $dfab79d8c9f9a829$export$39dbc3f558091353 = function(props) {
    return (0, $tLNoZ.createElement)($dfab79d8c9f9a829$var$Highlight, $dfab79d8c9f9a829$var$__spreadProps($dfab79d8c9f9a829$var$__spreadValues({}, props), {
        prism: props.prism || $dfab79d8c9f9a829$export$dc7257ffb0972f87,
        theme: props.theme || $dfab79d8c9f9a829$var$vsDark_default,
        code: props.code,
        language: props.language
    }));
};
 /*! Bundled license information:

prismjs/prism.js:
  (**
   * Prism: Lightweight, robust, elegant syntax highlighting
   *
   * @license MIT <https://opensource.org/licenses/MIT>
   * @author Lea Verou <https://lea.verou.me>
   * @namespace
   * @public
   *)
*/ 

parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");
var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

var $7E0eS = parcelRequire("7E0eS");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
var $cd2892b5c6b5fc3f$var$m = {
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
};
function $cd2892b5c6b5fc3f$var$p(c) {
    var a = window.getSelection();
    a.empty();
    a.addRange(c);
}
function $cd2892b5c6b5fc3f$var$q(c) {
    return (c.metaKey || c.ctrlKey) && !c.altKey && "KeyZ" === c.code;
}
function $cd2892b5c6b5fc3f$var$r(c) {
    c = [
        c.firstChild
    ];
    for(var b, a = ""; b = c.pop();)b.nodeType === Node.TEXT_NODE ? a += b.textContent : b.nodeType === Node.ELEMENT_NODE && "BR" === b.nodeName && (a += "\n"), b.nextSibling && c.push(b.nextSibling), b.firstChild && c.push(b.firstChild);
    "\n" !== a[a.length - 1] && (a += "\n");
    return a;
}
function $cd2892b5c6b5fc3f$var$w(c) {
    var a = window.getSelection().getRangeAt(0), b = a.collapsed ? 0 : a.toString().length, f = document.createRange();
    f.setStart(c, 0);
    f.setEnd(a.startContainer, a.startOffset);
    return {
        position: c = (f = f.toString()).length,
        extent: b,
        content: f = (f = f.split("\n"))[a = f.length - 1],
        line: a
    };
}
function $cd2892b5c6b5fc3f$var$C(c, a, b) {
    0 >= a && (a = 0);
    if (!b || 0 > b) b = a;
    var f = document.createRange();
    c = [
        c.firstChild
    ];
    for(var d, l = 0, g = a; d = c[c.length - 1];){
        if (d.nodeType === Node.TEXT_NODE) {
            if (l + d.textContent.length >= g) {
                var h = g - l;
                if (g === a) {
                    if (g = f, h < d.textContent.length ? g.setStart(d, h) : g.setStartAfter(d), b !== a) {
                        g = b;
                        continue;
                    } else break;
                } else {
                    a = f;
                    h < (b = d).textContent.length ? a.setEnd(b, h) : a.setEndAfter(b);
                    break;
                }
            }
            l += d.textContent.length;
        } else if (d.nodeType === Node.ELEMENT_NODE && "BR" === d.nodeName) {
            if (l + 1 >= g) {
                if (g === a) {
                    if (h = f, 0 < d.textContent.length ? h.setStart(d, 0) : h.setStartAfter(d), b !== a) {
                        g = b;
                        continue;
                    } else break;
                } else {
                    a = f;
                    0 < (b = d).textContent.length ? a.setEnd(b, 0) : a.setEndAfter(b);
                    break;
                }
            }
            l++;
        }
        c.pop();
        d.nextSibling && c.push(d.nextSibling);
        d.firstChild && c.push(d.firstChild);
    }
    return f;
}
function $cd2892b5c6b5fc3f$export$52a148af2bad544(c, a, b) {
    function f(k) {
        var _$b = c.current;
        if (_$b) {
            var a = $cd2892b5c6b5fc3f$var$w(_$b);
            _$b = $cd2892b5c6b5fc3f$var$r(_$b);
            a.position += k.length - _$b.length;
            e.position = a;
            e.onChange(k, a);
        }
    }
    function l(k, b) {
        var e = c.current;
        if (e) {
            var a = window.getSelection().getRangeAt(0);
            a.deleteContents();
            a.collapse();
            var d = b || 0;
            (a = $cd2892b5c6b5fc3f$var$C(e, b = (a = $cd2892b5c6b5fc3f$var$w(e)).position + (0 > d ? d : 0), a.position + (0 < d ? d : 0))).deleteContents();
            k && a.insertNode(document.createTextNode(k));
            $cd2892b5c6b5fc3f$var$p($cd2892b5c6b5fc3f$var$C(e, b + k.length));
        }
    }
    function d(b) {
        var a = c.current;
        if (a) {
            a.focus();
            var e = 0;
            if ("number" == typeof b) e = b;
            else {
                var k = $cd2892b5c6b5fc3f$var$r(a).split("\n").slice(0, b.row);
                b.row && (e += k.join("\n").length + 1);
                e += b.column;
            }
            $cd2892b5c6b5fc3f$var$p($cd2892b5c6b5fc3f$var$C(a, e));
        }
    }
    function g() {
        var _$b = c.current;
        return {
            text: $cd2892b5c6b5fc3f$var$r(_$b),
            position: _$b = $cd2892b5c6b5fc3f$var$w(_$b)
        };
    }
    function h() {
        e.observer.disconnect();
    }
    b || (b = {});
    var D = (0, $lliNT.useState)([])[1], e = (0, $lliNT.useState)(function() {
        var e = {
            observer: null,
            disconnected: !1,
            onChange: a,
            queue: [],
            history: [],
            historyAt: -1,
            position: null
        };
        "undefined" != typeof MutationObserver && (e.observer = new MutationObserver(function b(_b) {
            var _$a;
            (_$a = e.queue).push.apply(_$a, _b);
        }));
        return e;
    })[0], n = (0, $lliNT.useMemo)(function() {
        return {
            update: f,
            insert: l,
            move: d,
            getState: g
        };
    }, []);
    if ("object" != (typeof navigator === "undefined" ? "undefined" : (0, $7E0eS._)(navigator))) return n;
    (0, $lliNT.useLayoutEffect)(function() {
        e.onChange = a;
        if (c.current && !b.disabled) {
            e.disconnected = !1;
            e.observer.observe(c.current, $cd2892b5c6b5fc3f$var$m);
            if (e.position) {
                var k = e.position, d = k.position;
                $cd2892b5c6b5fc3f$var$p($cd2892b5c6b5fc3f$var$C(c.current, d, d + k.extent));
            }
            return h;
        }
    });
    (0, $lliNT.useLayoutEffect)(function() {
        if (!c.current || b.disabled) e.history.length = 0, e.historyAt = -1;
        else {
            var a = c.current;
            if (e.position) {
                a.focus();
                var d = e.position, f = d.position;
                $cd2892b5c6b5fc3f$var$p($cd2892b5c6b5fc3f$var$C(a, f, f + d.extent));
            }
            var g = a.style.whiteSpace, h = a.contentEditable, l = !0;
            try {
                a.contentEditable = "plaintext-only";
            } catch (u) {
                a.contentEditable = "true", l = !1;
            }
            "pre" !== g && (a.style.whiteSpace = "pre-wrap");
            b.indentation && (a.style.tabSize = a.style.MozTabSize = "" + b.indentation);
            d = "" + " ".repeat(b.indentation || 0);
            var x, E = new RegExp("^(?:" + d + ")"), F = new RegExp("^(?:" + d + ")*(" + d + ")$"), t = function t(b) {
                if (c.current && e.position) {
                    var u = $cd2892b5c6b5fc3f$var$r(a), d = $cd2892b5c6b5fc3f$var$w(a), f = (new Date).valueOf(), g = e.history[e.historyAt];
                    !b && 500 > f - x || g && g[1] === u ? x = f : (b = ++e.historyAt, e.history[b] = [
                        d,
                        u
                    ], e.history.splice(b + 1), 500 < b && (e.historyAt--, e.history.shift()));
                }
            }, v = function v() {
                var _$b;
                (_$b = e.queue).push.apply(_$b, e.observer.takeRecords());
                _$b = $cd2892b5c6b5fc3f$var$w(a);
                if (e.queue.length) {
                    e.observer.disconnect();
                    e.disconnected = !0;
                    var d = $cd2892b5c6b5fc3f$var$r(a);
                    e.position = _$b;
                    for(var _$c, f; _$c = e.queue.pop();){
                        null !== _$c.oldValue && (_$c.target.textContent = _$c.oldValue);
                        for(f = _$c.removedNodes.length - 1; 0 <= f; f--)_$c.target.insertBefore(_$c.removedNodes[f], _$c.nextSibling);
                        for(f = _$c.addedNodes.length - 1; 0 <= f; f--)_$c.addedNodes[f].parentNode && _$c.target.removeChild(_$c.addedNodes[f]);
                    }
                    e.onChange(d, _$b);
                }
            }, y = function y(c) {
                if (!c.defaultPrevented && c.target === a) {
                    if (e.disconnected) return c.preventDefault(), D([]);
                    if ($cd2892b5c6b5fc3f$var$q(c)) c.preventDefault(), c.shiftKey ? (c = ++e.historyAt, (c = e.history[c]) || (e.historyAt = e.history.length - 1)) : (c = --e.historyAt, (c = e.history[c]) || (e.historyAt = 0)), c && (e.observer.disconnect(), e.disconnected = !0, e.position = c[0], e.onChange(c[1], c[0]));
                    else {
                        t();
                        if ("Enter" === c.key) {
                            c.preventDefault();
                            var d = $cd2892b5c6b5fc3f$var$w(a), f = /\S/g.exec(d.content);
                            d = "\n" + d.content.slice(0, f ? f.index : d.content.length);
                            n.insert(d);
                        } else if ((!l || b.indentation) && "Backspace" === c.key) c.preventDefault(), window.getSelection().getRangeAt(0).collapsed ? (d = $cd2892b5c6b5fc3f$var$w(a), d = F.exec(d.content), n.insert("", d ? -d[1].length : -1)) : n.insert("", 0);
                        else if (b.indentation && "Tab" === c.key) {
                            c.preventDefault();
                            f = (d = $cd2892b5c6b5fc3f$var$w(a)).position - d.content.length;
                            var g = $cd2892b5c6b5fc3f$var$r(a);
                            d = c.shiftKey ? g.slice(0, f) + d.content.replace(E, "") + g.slice(f + d.content.length) : g.slice(0, f) + (b.indentation ? " ".repeat(b.indentation) : "\t") + g.slice(f);
                            n.update(d);
                        }
                        c.repeat && v();
                    }
                }
            }, z = function z(b) {
                b.defaultPrevented || b.isComposing || ($cd2892b5c6b5fc3f$var$q(b) || t(), v(), a.focus());
            }, A = function A(b) {
                e.position = window.getSelection().rangeCount && b.target === a ? $cd2892b5c6b5fc3f$var$w(a) : null;
            }, B = function B(a) {
                a.preventDefault();
                t(!0);
                n.insert(a.clipboardData.getData("text/plain"));
                t(!0);
                v();
            };
            document.addEventListener("selectstart", A);
            window.addEventListener("keydown", y);
            a.addEventListener("paste", B);
            a.addEventListener("keyup", z);
            return function() {
                document.removeEventListener("selectstart", A);
                window.removeEventListener("keydown", y);
                a.removeEventListener("paste", B);
                a.removeEventListener("keyup", z);
                a.style.whiteSpace = g;
                a.contentEditable = h;
            };
        }
    }, [
        c.current,
        b.disabled,
        b.indentation
    ]);
    return n;
}




var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");
/* eslint max-len: 0 */ 
var $173N4 = parcelRequire("173N4");

var $173N4 = parcelRequire("173N4");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");
var $71dd7c884f6bca78$export$ee633ab6cd0138cc;
(function(ContextualKeyword) {
    var NONE = 0;
    ContextualKeyword[ContextualKeyword["NONE"] = NONE] = "NONE";
    var _abstract = NONE + 1;
    ContextualKeyword[ContextualKeyword["_abstract"] = _abstract] = "_abstract";
    var _accessor = _abstract + 1;
    ContextualKeyword[ContextualKeyword["_accessor"] = _accessor] = "_accessor";
    var _as = _accessor + 1;
    ContextualKeyword[ContextualKeyword["_as"] = _as] = "_as";
    var _assert = _as + 1;
    ContextualKeyword[ContextualKeyword["_assert"] = _assert] = "_assert";
    var _asserts = _assert + 1;
    ContextualKeyword[ContextualKeyword["_asserts"] = _asserts] = "_asserts";
    var _async = _asserts + 1;
    ContextualKeyword[ContextualKeyword["_async"] = _async] = "_async";
    var _await = _async + 1;
    ContextualKeyword[ContextualKeyword["_await"] = _await] = "_await";
    var _checks = _await + 1;
    ContextualKeyword[ContextualKeyword["_checks"] = _checks] = "_checks";
    var _constructor = _checks + 1;
    ContextualKeyword[ContextualKeyword["_constructor"] = _constructor] = "_constructor";
    var _declare = _constructor + 1;
    ContextualKeyword[ContextualKeyword["_declare"] = _declare] = "_declare";
    var _enum = _declare + 1;
    ContextualKeyword[ContextualKeyword["_enum"] = _enum] = "_enum";
    var _exports = _enum + 1;
    ContextualKeyword[ContextualKeyword["_exports"] = _exports] = "_exports";
    var _from = _exports + 1;
    ContextualKeyword[ContextualKeyword["_from"] = _from] = "_from";
    var _get = _from + 1;
    ContextualKeyword[ContextualKeyword["_get"] = _get] = "_get";
    var _global = _get + 1;
    ContextualKeyword[ContextualKeyword["_global"] = _global] = "_global";
    var _implements = _global + 1;
    ContextualKeyword[ContextualKeyword["_implements"] = _implements] = "_implements";
    var _infer = _implements + 1;
    ContextualKeyword[ContextualKeyword["_infer"] = _infer] = "_infer";
    var _interface = _infer + 1;
    ContextualKeyword[ContextualKeyword["_interface"] = _interface] = "_interface";
    var _is = _interface + 1;
    ContextualKeyword[ContextualKeyword["_is"] = _is] = "_is";
    var _keyof = _is + 1;
    ContextualKeyword[ContextualKeyword["_keyof"] = _keyof] = "_keyof";
    var _mixins = _keyof + 1;
    ContextualKeyword[ContextualKeyword["_mixins"] = _mixins] = "_mixins";
    var _module = _mixins + 1;
    ContextualKeyword[ContextualKeyword["_module"] = _module] = "_module";
    var _namespace = _module + 1;
    ContextualKeyword[ContextualKeyword["_namespace"] = _namespace] = "_namespace";
    var _of = _namespace + 1;
    ContextualKeyword[ContextualKeyword["_of"] = _of] = "_of";
    var _opaque = _of + 1;
    ContextualKeyword[ContextualKeyword["_opaque"] = _opaque] = "_opaque";
    var _out = _opaque + 1;
    ContextualKeyword[ContextualKeyword["_out"] = _out] = "_out";
    var _override = _out + 1;
    ContextualKeyword[ContextualKeyword["_override"] = _override] = "_override";
    var _private = _override + 1;
    ContextualKeyword[ContextualKeyword["_private"] = _private] = "_private";
    var _protected = _private + 1;
    ContextualKeyword[ContextualKeyword["_protected"] = _protected] = "_protected";
    var _proto = _protected + 1;
    ContextualKeyword[ContextualKeyword["_proto"] = _proto] = "_proto";
    var _public = _proto + 1;
    ContextualKeyword[ContextualKeyword["_public"] = _public] = "_public";
    var _readonly = _public + 1;
    ContextualKeyword[ContextualKeyword["_readonly"] = _readonly] = "_readonly";
    var _require = _readonly + 1;
    ContextualKeyword[ContextualKeyword["_require"] = _require] = "_require";
    var _satisfies = _require + 1;
    ContextualKeyword[ContextualKeyword["_satisfies"] = _satisfies] = "_satisfies";
    var _set = _satisfies + 1;
    ContextualKeyword[ContextualKeyword["_set"] = _set] = "_set";
    var _static = _set + 1;
    ContextualKeyword[ContextualKeyword["_static"] = _static] = "_static";
    var _symbol = _static + 1;
    ContextualKeyword[ContextualKeyword["_symbol"] = _symbol] = "_symbol";
    var _type = _symbol + 1;
    ContextualKeyword[ContextualKeyword["_type"] = _type] = "_type";
    var _unique = _type + 1;
    ContextualKeyword[ContextualKeyword["_unique"] = _unique] = "_unique";
    var _using = _unique + 1;
    ContextualKeyword[ContextualKeyword["_using"] = _using] = "_using";
})($71dd7c884f6bca78$export$ee633ab6cd0138cc || ($71dd7c884f6bca78$export$ee633ab6cd0138cc = {}));


// Generated file, do not edit! Run "yarn generate" to re-generate this file.
/* istanbul ignore file */ /**
 * Enum of all token types, with bit fields to signify meaningful properties.
 */ var $30a0d13de21d779e$export$f435f793048e7a0f;
(function(TokenType) {
    // Precedence 0 means not an operator; otherwise it is a positive number up to 12.
    var PRECEDENCE_MASK = 0xf;
    TokenType[TokenType["PRECEDENCE_MASK"] = PRECEDENCE_MASK] = "PRECEDENCE_MASK";
    var IS_KEYWORD = 16;
    TokenType[TokenType["IS_KEYWORD"] = IS_KEYWORD] = "IS_KEYWORD";
    var IS_ASSIGN = 32;
    TokenType[TokenType["IS_ASSIGN"] = IS_ASSIGN] = "IS_ASSIGN";
    var IS_RIGHT_ASSOCIATIVE = 64;
    TokenType[TokenType["IS_RIGHT_ASSOCIATIVE"] = IS_RIGHT_ASSOCIATIVE] = "IS_RIGHT_ASSOCIATIVE";
    var IS_PREFIX = 128;
    TokenType[TokenType["IS_PREFIX"] = IS_PREFIX] = "IS_PREFIX";
    var IS_POSTFIX = 256;
    TokenType[TokenType["IS_POSTFIX"] = IS_POSTFIX] = "IS_POSTFIX";
    var IS_EXPRESSION_START = 512;
    TokenType[TokenType["IS_EXPRESSION_START"] = IS_EXPRESSION_START] = "IS_EXPRESSION_START";
    var num = 512;
    TokenType[TokenType["num"] = num] = "num"; // num startsExpr
    var bigint = 1536;
    TokenType[TokenType["bigint"] = bigint] = "bigint"; // bigint startsExpr
    var decimal = 2560;
    TokenType[TokenType["decimal"] = decimal] = "decimal"; // decimal startsExpr
    var regexp = 3584;
    TokenType[TokenType["regexp"] = regexp] = "regexp"; // regexp startsExpr
    var string = 4608;
    TokenType[TokenType["string"] = string] = "string"; // string startsExpr
    var name = 5632;
    TokenType[TokenType["name"] = name] = "name"; // name startsExpr
    var eof = 6144;
    TokenType[TokenType["eof"] = eof] = "eof"; // eof
    var bracketL = 7680;
    TokenType[TokenType["bracketL"] = bracketL] = "bracketL"; // [ startsExpr
    var bracketR = 8192;
    TokenType[TokenType["bracketR"] = bracketR] = "bracketR"; // ]
    var braceL = 9728;
    TokenType[TokenType["braceL"] = braceL] = "braceL"; // { startsExpr
    var braceBarL = 10752;
    TokenType[TokenType["braceBarL"] = braceBarL] = "braceBarL"; // {| startsExpr
    var braceR = 11264;
    TokenType[TokenType["braceR"] = braceR] = "braceR"; // }
    var braceBarR = 12288;
    TokenType[TokenType["braceBarR"] = braceBarR] = "braceBarR"; // |}
    var parenL = 13824;
    TokenType[TokenType["parenL"] = parenL] = "parenL"; // ( startsExpr
    var parenR = 14336;
    TokenType[TokenType["parenR"] = parenR] = "parenR"; // )
    var comma = 15360;
    TokenType[TokenType["comma"] = comma] = "comma"; // ,
    var semi = 16384;
    TokenType[TokenType["semi"] = semi] = "semi"; // ;
    var colon = 17408;
    TokenType[TokenType["colon"] = colon] = "colon"; // :
    var doubleColon = 18432;
    TokenType[TokenType["doubleColon"] = doubleColon] = "doubleColon"; // ::
    var dot = 19456;
    TokenType[TokenType["dot"] = dot] = "dot"; // .
    var question = 20480;
    TokenType[TokenType["question"] = question] = "question"; // ?
    var questionDot = 21504;
    TokenType[TokenType["questionDot"] = questionDot] = "questionDot"; // ?.
    var arrow = 22528;
    TokenType[TokenType["arrow"] = arrow] = "arrow"; // =>
    var template = 23552;
    TokenType[TokenType["template"] = template] = "template"; // template
    var ellipsis = 24576;
    TokenType[TokenType["ellipsis"] = ellipsis] = "ellipsis"; // ...
    var backQuote = 25600;
    TokenType[TokenType["backQuote"] = backQuote] = "backQuote"; // `
    var dollarBraceL = 27136;
    TokenType[TokenType["dollarBraceL"] = dollarBraceL] = "dollarBraceL"; // ${ startsExpr
    var at = 27648;
    TokenType[TokenType["at"] = at] = "at"; // @
    var hash = 29184;
    TokenType[TokenType["hash"] = hash] = "hash"; // # startsExpr
    var eq = 29728;
    TokenType[TokenType["eq"] = eq] = "eq"; // = isAssign
    var assign = 30752;
    TokenType[TokenType["assign"] = assign] = "assign"; // _= isAssign
    var preIncDec = 32640;
    TokenType[TokenType["preIncDec"] = preIncDec] = "preIncDec"; // ++/-- prefix postfix startsExpr
    var postIncDec = 33664;
    TokenType[TokenType["postIncDec"] = postIncDec] = "postIncDec"; // ++/-- prefix postfix startsExpr
    var bang = 34432;
    TokenType[TokenType["bang"] = bang] = "bang"; // ! prefix startsExpr
    var tilde = 35456;
    TokenType[TokenType["tilde"] = tilde] = "tilde"; // ~ prefix startsExpr
    var pipeline = 35841;
    TokenType[TokenType["pipeline"] = pipeline] = "pipeline"; // |> prec:1
    var nullishCoalescing = 36866;
    TokenType[TokenType["nullishCoalescing"] = nullishCoalescing] = "nullishCoalescing"; // ?? prec:2
    var logicalOR = 37890;
    TokenType[TokenType["logicalOR"] = logicalOR] = "logicalOR"; // || prec:2
    var logicalAND = 38915;
    TokenType[TokenType["logicalAND"] = logicalAND] = "logicalAND"; // && prec:3
    var bitwiseOR = 39940;
    TokenType[TokenType["bitwiseOR"] = bitwiseOR] = "bitwiseOR"; // | prec:4
    var bitwiseXOR = 40965;
    TokenType[TokenType["bitwiseXOR"] = bitwiseXOR] = "bitwiseXOR"; // ^ prec:5
    var bitwiseAND = 41990;
    TokenType[TokenType["bitwiseAND"] = bitwiseAND] = "bitwiseAND"; // & prec:6
    var equality = 43015;
    TokenType[TokenType["equality"] = equality] = "equality"; // ==/!= prec:7
    var lessThan = 44040;
    TokenType[TokenType["lessThan"] = lessThan] = "lessThan"; // < prec:8
    var greaterThan = 45064;
    TokenType[TokenType["greaterThan"] = greaterThan] = "greaterThan"; // > prec:8
    var relationalOrEqual = 46088;
    TokenType[TokenType["relationalOrEqual"] = relationalOrEqual] = "relationalOrEqual"; // <=/>= prec:8
    var bitShiftL = 47113;
    TokenType[TokenType["bitShiftL"] = bitShiftL] = "bitShiftL"; // << prec:9
    var bitShiftR = 48137;
    TokenType[TokenType["bitShiftR"] = bitShiftR] = "bitShiftR"; // >>/>>> prec:9
    var plus = 49802;
    TokenType[TokenType["plus"] = plus] = "plus"; // + prec:10 prefix startsExpr
    var minus = 50826;
    TokenType[TokenType["minus"] = minus] = "minus"; // - prec:10 prefix startsExpr
    var modulo = 51723;
    TokenType[TokenType["modulo"] = modulo] = "modulo"; // % prec:11 startsExpr
    var star = 52235;
    TokenType[TokenType["star"] = star] = "star"; // * prec:11
    var slash = 53259;
    TokenType[TokenType["slash"] = slash] = "slash"; // / prec:11
    var exponent = 54348;
    TokenType[TokenType["exponent"] = exponent] = "exponent"; // ** prec:12 rightAssociative
    var jsxName = 55296;
    TokenType[TokenType["jsxName"] = jsxName] = "jsxName"; // jsxName
    var jsxText = 56320;
    TokenType[TokenType["jsxText"] = jsxText] = "jsxText"; // jsxText
    var jsxEmptyText = 57344;
    TokenType[TokenType["jsxEmptyText"] = jsxEmptyText] = "jsxEmptyText"; // jsxEmptyText
    var jsxTagStart = 58880;
    TokenType[TokenType["jsxTagStart"] = jsxTagStart] = "jsxTagStart"; // jsxTagStart startsExpr
    var jsxTagEnd = 59392;
    TokenType[TokenType["jsxTagEnd"] = jsxTagEnd] = "jsxTagEnd"; // jsxTagEnd
    var typeParameterStart = 60928;
    TokenType[TokenType["typeParameterStart"] = typeParameterStart] = "typeParameterStart"; // typeParameterStart startsExpr
    var nonNullAssertion = 61440;
    TokenType[TokenType["nonNullAssertion"] = nonNullAssertion] = "nonNullAssertion"; // nonNullAssertion
    var _break = 62480;
    TokenType[TokenType["_break"] = _break] = "_break"; // break keyword
    var _case = 63504;
    TokenType[TokenType["_case"] = _case] = "_case"; // case keyword
    var _catch = 64528;
    TokenType[TokenType["_catch"] = _catch] = "_catch"; // catch keyword
    var _continue = 65552;
    TokenType[TokenType["_continue"] = _continue] = "_continue"; // continue keyword
    var _debugger = 66576;
    TokenType[TokenType["_debugger"] = _debugger] = "_debugger"; // debugger keyword
    var _default = 67600;
    TokenType[TokenType["_default"] = _default] = "_default"; // default keyword
    var _do = 68624;
    TokenType[TokenType["_do"] = _do] = "_do"; // do keyword
    var _else = 69648;
    TokenType[TokenType["_else"] = _else] = "_else"; // else keyword
    var _finally = 70672;
    TokenType[TokenType["_finally"] = _finally] = "_finally"; // finally keyword
    var _for = 71696;
    TokenType[TokenType["_for"] = _for] = "_for"; // for keyword
    var _function = 73232;
    TokenType[TokenType["_function"] = _function] = "_function"; // function keyword startsExpr
    var _if = 73744;
    TokenType[TokenType["_if"] = _if] = "_if"; // if keyword
    var _return = 74768;
    TokenType[TokenType["_return"] = _return] = "_return"; // return keyword
    var _switch = 75792;
    TokenType[TokenType["_switch"] = _switch] = "_switch"; // switch keyword
    var _throw = 77456;
    TokenType[TokenType["_throw"] = _throw] = "_throw"; // throw keyword prefix startsExpr
    var _try = 77840;
    TokenType[TokenType["_try"] = _try] = "_try"; // try keyword
    var _var = 78864;
    TokenType[TokenType["_var"] = _var] = "_var"; // var keyword
    var _let = 79888;
    TokenType[TokenType["_let"] = _let] = "_let"; // let keyword
    var _const = 80912;
    TokenType[TokenType["_const"] = _const] = "_const"; // const keyword
    var _while = 81936;
    TokenType[TokenType["_while"] = _while] = "_while"; // while keyword
    var _with = 82960;
    TokenType[TokenType["_with"] = _with] = "_with"; // with keyword
    var _new = 84496;
    TokenType[TokenType["_new"] = _new] = "_new"; // new keyword startsExpr
    var _this = 85520;
    TokenType[TokenType["_this"] = _this] = "_this"; // this keyword startsExpr
    var _super = 86544;
    TokenType[TokenType["_super"] = _super] = "_super"; // super keyword startsExpr
    var _class = 87568;
    TokenType[TokenType["_class"] = _class] = "_class"; // class keyword startsExpr
    var _extends = 88080;
    TokenType[TokenType["_extends"] = _extends] = "_extends"; // extends keyword
    var _export = 89104;
    TokenType[TokenType["_export"] = _export] = "_export"; // export keyword
    var _import = 90640;
    TokenType[TokenType["_import"] = _import] = "_import"; // import keyword startsExpr
    var _yield = 91664;
    TokenType[TokenType["_yield"] = _yield] = "_yield"; // yield keyword startsExpr
    var _null = 92688;
    TokenType[TokenType["_null"] = _null] = "_null"; // null keyword startsExpr
    var _true = 93712;
    TokenType[TokenType["_true"] = _true] = "_true"; // true keyword startsExpr
    var _false = 94736;
    TokenType[TokenType["_false"] = _false] = "_false"; // false keyword startsExpr
    var _in = 95256;
    TokenType[TokenType["_in"] = _in] = "_in"; // in prec:8 keyword
    var _instanceof = 96280;
    TokenType[TokenType["_instanceof"] = _instanceof] = "_instanceof"; // instanceof prec:8 keyword
    var _typeof = 97936;
    TokenType[TokenType["_typeof"] = _typeof] = "_typeof"; // typeof keyword prefix startsExpr
    var _void = 98960;
    TokenType[TokenType["_void"] = _void] = "_void"; // void keyword prefix startsExpr
    var _delete = 99984;
    TokenType[TokenType["_delete"] = _delete] = "_delete"; // delete keyword prefix startsExpr
    var _async = 100880;
    TokenType[TokenType["_async"] = _async] = "_async"; // async keyword startsExpr
    var _get = 101904;
    TokenType[TokenType["_get"] = _get] = "_get"; // get keyword startsExpr
    var _set = 102928;
    TokenType[TokenType["_set"] = _set] = "_set"; // set keyword startsExpr
    var _declare = 103952;
    TokenType[TokenType["_declare"] = _declare] = "_declare"; // declare keyword startsExpr
    var _readonly = 104976;
    TokenType[TokenType["_readonly"] = _readonly] = "_readonly"; // readonly keyword startsExpr
    var _abstract = 106000;
    TokenType[TokenType["_abstract"] = _abstract] = "_abstract"; // abstract keyword startsExpr
    var _static = 107024;
    TokenType[TokenType["_static"] = _static] = "_static"; // static keyword startsExpr
    var _public = 107536;
    TokenType[TokenType["_public"] = _public] = "_public"; // public keyword
    var _private = 108560;
    TokenType[TokenType["_private"] = _private] = "_private"; // private keyword
    var _protected = 109584;
    TokenType[TokenType["_protected"] = _protected] = "_protected"; // protected keyword
    var _override = 110608;
    TokenType[TokenType["_override"] = _override] = "_override"; // override keyword
    var _as = 112144;
    TokenType[TokenType["_as"] = _as] = "_as"; // as keyword startsExpr
    var _enum = 113168;
    TokenType[TokenType["_enum"] = _enum] = "_enum"; // enum keyword startsExpr
    var _type = 114192;
    TokenType[TokenType["_type"] = _type] = "_type"; // type keyword startsExpr
    var _implements = 115216;
    TokenType[TokenType["_implements"] = _implements] = "_implements"; // implements keyword startsExpr
})($30a0d13de21d779e$export$f435f793048e7a0f || ($30a0d13de21d779e$export$f435f793048e7a0f = {}));
function $30a0d13de21d779e$export$b78065ce79336a93(tokenType) {
    switch(tokenType){
        case $30a0d13de21d779e$export$f435f793048e7a0f.num:
            return "num";
        case $30a0d13de21d779e$export$f435f793048e7a0f.bigint:
            return "bigint";
        case $30a0d13de21d779e$export$f435f793048e7a0f.decimal:
            return "decimal";
        case $30a0d13de21d779e$export$f435f793048e7a0f.regexp:
            return "regexp";
        case $30a0d13de21d779e$export$f435f793048e7a0f.string:
            return "string";
        case $30a0d13de21d779e$export$f435f793048e7a0f.name:
            return "name";
        case $30a0d13de21d779e$export$f435f793048e7a0f.eof:
            return "eof";
        case $30a0d13de21d779e$export$f435f793048e7a0f.bracketL:
            return "[";
        case $30a0d13de21d779e$export$f435f793048e7a0f.bracketR:
            return "]";
        case $30a0d13de21d779e$export$f435f793048e7a0f.braceL:
            return "{";
        case $30a0d13de21d779e$export$f435f793048e7a0f.braceBarL:
            return "{|";
        case $30a0d13de21d779e$export$f435f793048e7a0f.braceR:
            return "}";
        case $30a0d13de21d779e$export$f435f793048e7a0f.braceBarR:
            return "|}";
        case $30a0d13de21d779e$export$f435f793048e7a0f.parenL:
            return "(";
        case $30a0d13de21d779e$export$f435f793048e7a0f.parenR:
            return ")";
        case $30a0d13de21d779e$export$f435f793048e7a0f.comma:
            return ",";
        case $30a0d13de21d779e$export$f435f793048e7a0f.semi:
            return ";";
        case $30a0d13de21d779e$export$f435f793048e7a0f.colon:
            return ":";
        case $30a0d13de21d779e$export$f435f793048e7a0f.doubleColon:
            return "::";
        case $30a0d13de21d779e$export$f435f793048e7a0f.dot:
            return ".";
        case $30a0d13de21d779e$export$f435f793048e7a0f.question:
            return "?";
        case $30a0d13de21d779e$export$f435f793048e7a0f.questionDot:
            return "?.";
        case $30a0d13de21d779e$export$f435f793048e7a0f.arrow:
            return "=>";
        case $30a0d13de21d779e$export$f435f793048e7a0f.template:
            return "template";
        case $30a0d13de21d779e$export$f435f793048e7a0f.ellipsis:
            return "...";
        case $30a0d13de21d779e$export$f435f793048e7a0f.backQuote:
            return "`";
        case $30a0d13de21d779e$export$f435f793048e7a0f.dollarBraceL:
            return "${";
        case $30a0d13de21d779e$export$f435f793048e7a0f.at:
            return "@";
        case $30a0d13de21d779e$export$f435f793048e7a0f.hash:
            return "#";
        case $30a0d13de21d779e$export$f435f793048e7a0f.eq:
            return "=";
        case $30a0d13de21d779e$export$f435f793048e7a0f.assign:
            return "_=";
        case $30a0d13de21d779e$export$f435f793048e7a0f.preIncDec:
            return "++/--";
        case $30a0d13de21d779e$export$f435f793048e7a0f.postIncDec:
            return "++/--";
        case $30a0d13de21d779e$export$f435f793048e7a0f.bang:
            return "!";
        case $30a0d13de21d779e$export$f435f793048e7a0f.tilde:
            return "~";
        case $30a0d13de21d779e$export$f435f793048e7a0f.pipeline:
            return "|>";
        case $30a0d13de21d779e$export$f435f793048e7a0f.nullishCoalescing:
            return "??";
        case $30a0d13de21d779e$export$f435f793048e7a0f.logicalOR:
            return "||";
        case $30a0d13de21d779e$export$f435f793048e7a0f.logicalAND:
            return "&&";
        case $30a0d13de21d779e$export$f435f793048e7a0f.bitwiseOR:
            return "|";
        case $30a0d13de21d779e$export$f435f793048e7a0f.bitwiseXOR:
            return "^";
        case $30a0d13de21d779e$export$f435f793048e7a0f.bitwiseAND:
            return "&";
        case $30a0d13de21d779e$export$f435f793048e7a0f.equality:
            return "==/!=";
        case $30a0d13de21d779e$export$f435f793048e7a0f.lessThan:
            return "<";
        case $30a0d13de21d779e$export$f435f793048e7a0f.greaterThan:
            return ">";
        case $30a0d13de21d779e$export$f435f793048e7a0f.relationalOrEqual:
            return "<=/>=";
        case $30a0d13de21d779e$export$f435f793048e7a0f.bitShiftL:
            return "<<";
        case $30a0d13de21d779e$export$f435f793048e7a0f.bitShiftR:
            return ">>/>>>";
        case $30a0d13de21d779e$export$f435f793048e7a0f.plus:
            return "+";
        case $30a0d13de21d779e$export$f435f793048e7a0f.minus:
            return "-";
        case $30a0d13de21d779e$export$f435f793048e7a0f.modulo:
            return "%";
        case $30a0d13de21d779e$export$f435f793048e7a0f.star:
            return "*";
        case $30a0d13de21d779e$export$f435f793048e7a0f.slash:
            return "/";
        case $30a0d13de21d779e$export$f435f793048e7a0f.exponent:
            return "**";
        case $30a0d13de21d779e$export$f435f793048e7a0f.jsxName:
            return "jsxName";
        case $30a0d13de21d779e$export$f435f793048e7a0f.jsxText:
            return "jsxText";
        case $30a0d13de21d779e$export$f435f793048e7a0f.jsxEmptyText:
            return "jsxEmptyText";
        case $30a0d13de21d779e$export$f435f793048e7a0f.jsxTagStart:
            return "jsxTagStart";
        case $30a0d13de21d779e$export$f435f793048e7a0f.jsxTagEnd:
            return "jsxTagEnd";
        case $30a0d13de21d779e$export$f435f793048e7a0f.typeParameterStart:
            return "typeParameterStart";
        case $30a0d13de21d779e$export$f435f793048e7a0f.nonNullAssertion:
            return "nonNullAssertion";
        case $30a0d13de21d779e$export$f435f793048e7a0f._break:
            return "break";
        case $30a0d13de21d779e$export$f435f793048e7a0f._case:
            return "case";
        case $30a0d13de21d779e$export$f435f793048e7a0f._catch:
            return "catch";
        case $30a0d13de21d779e$export$f435f793048e7a0f._continue:
            return "continue";
        case $30a0d13de21d779e$export$f435f793048e7a0f._debugger:
            return "debugger";
        case $30a0d13de21d779e$export$f435f793048e7a0f._default:
            return "default";
        case $30a0d13de21d779e$export$f435f793048e7a0f._do:
            return "do";
        case $30a0d13de21d779e$export$f435f793048e7a0f._else:
            return "else";
        case $30a0d13de21d779e$export$f435f793048e7a0f._finally:
            return "finally";
        case $30a0d13de21d779e$export$f435f793048e7a0f._for:
            return "for";
        case $30a0d13de21d779e$export$f435f793048e7a0f._function:
            return "function";
        case $30a0d13de21d779e$export$f435f793048e7a0f._if:
            return "if";
        case $30a0d13de21d779e$export$f435f793048e7a0f._return:
            return "return";
        case $30a0d13de21d779e$export$f435f793048e7a0f._switch:
            return "switch";
        case $30a0d13de21d779e$export$f435f793048e7a0f._throw:
            return "throw";
        case $30a0d13de21d779e$export$f435f793048e7a0f._try:
            return "try";
        case $30a0d13de21d779e$export$f435f793048e7a0f._var:
            return "var";
        case $30a0d13de21d779e$export$f435f793048e7a0f._let:
            return "let";
        case $30a0d13de21d779e$export$f435f793048e7a0f._const:
            return "const";
        case $30a0d13de21d779e$export$f435f793048e7a0f._while:
            return "while";
        case $30a0d13de21d779e$export$f435f793048e7a0f._with:
            return "with";
        case $30a0d13de21d779e$export$f435f793048e7a0f._new:
            return "new";
        case $30a0d13de21d779e$export$f435f793048e7a0f._this:
            return "this";
        case $30a0d13de21d779e$export$f435f793048e7a0f._super:
            return "super";
        case $30a0d13de21d779e$export$f435f793048e7a0f._class:
            return "class";
        case $30a0d13de21d779e$export$f435f793048e7a0f._extends:
            return "extends";
        case $30a0d13de21d779e$export$f435f793048e7a0f._export:
            return "export";
        case $30a0d13de21d779e$export$f435f793048e7a0f._import:
            return "import";
        case $30a0d13de21d779e$export$f435f793048e7a0f._yield:
            return "yield";
        case $30a0d13de21d779e$export$f435f793048e7a0f._null:
            return "null";
        case $30a0d13de21d779e$export$f435f793048e7a0f._true:
            return "true";
        case $30a0d13de21d779e$export$f435f793048e7a0f._false:
            return "false";
        case $30a0d13de21d779e$export$f435f793048e7a0f._in:
            return "in";
        case $30a0d13de21d779e$export$f435f793048e7a0f._instanceof:
            return "instanceof";
        case $30a0d13de21d779e$export$f435f793048e7a0f._typeof:
            return "typeof";
        case $30a0d13de21d779e$export$f435f793048e7a0f._void:
            return "void";
        case $30a0d13de21d779e$export$f435f793048e7a0f._delete:
            return "delete";
        case $30a0d13de21d779e$export$f435f793048e7a0f._async:
            return "async";
        case $30a0d13de21d779e$export$f435f793048e7a0f._get:
            return "get";
        case $30a0d13de21d779e$export$f435f793048e7a0f._set:
            return "set";
        case $30a0d13de21d779e$export$f435f793048e7a0f._declare:
            return "declare";
        case $30a0d13de21d779e$export$f435f793048e7a0f._readonly:
            return "readonly";
        case $30a0d13de21d779e$export$f435f793048e7a0f._abstract:
            return "abstract";
        case $30a0d13de21d779e$export$f435f793048e7a0f._static:
            return "static";
        case $30a0d13de21d779e$export$f435f793048e7a0f._public:
            return "public";
        case $30a0d13de21d779e$export$f435f793048e7a0f._private:
            return "private";
        case $30a0d13de21d779e$export$f435f793048e7a0f._protected:
            return "protected";
        case $30a0d13de21d779e$export$f435f793048e7a0f._override:
            return "override";
        case $30a0d13de21d779e$export$f435f793048e7a0f._as:
            return "as";
        case $30a0d13de21d779e$export$f435f793048e7a0f._enum:
            return "enum";
        case $30a0d13de21d779e$export$f435f793048e7a0f._type:
            return "type";
        case $30a0d13de21d779e$export$f435f793048e7a0f._implements:
            return "implements";
        default:
            return "";
    }
}


var $f0b680e833c1be0d$export$775b6bb06e53a214 = function Scope(startTokenIndex, endTokenIndex, isFunctionScope) {
    "use strict";
    (0, $173N4._)(this, Scope);
    this.startTokenIndex = startTokenIndex;
    this.endTokenIndex = endTokenIndex;
    this.isFunctionScope = isFunctionScope;
};
var $f0b680e833c1be0d$export$43b973415d9649ac = function StateSnapshot(potentialArrowAt, noAnonFunctionType, inDisallowConditionalTypesContext, tokensLength, scopesLength, pos, type, contextualKeyword, start, end, isType, scopeDepth, error) {
    "use strict";
    (0, $173N4._)(this, StateSnapshot);
    this.potentialArrowAt = potentialArrowAt;
    this.noAnonFunctionType = noAnonFunctionType;
    this.inDisallowConditionalTypesContext = inDisallowConditionalTypesContext;
    this.tokensLength = tokensLength;
    this.scopesLength = scopesLength;
    this.pos = pos;
    this.type = type;
    this.contextualKeyword = contextualKeyword;
    this.start = start;
    this.end = end;
    this.isType = isType;
    this.scopeDepth = scopeDepth;
    this.error = error;
};
var $f0b680e833c1be0d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function State() {
        (0, $173N4._)(this, State);
        State.prototype.__init.call(this);
        State.prototype.__init2.call(this);
        State.prototype.__init3.call(this);
        State.prototype.__init4.call(this);
        State.prototype.__init5.call(this);
        State.prototype.__init6.call(this);
        State.prototype.__init7.call(this);
        State.prototype.__init8.call(this);
        State.prototype.__init9.call(this);
        State.prototype.__init10.call(this);
        State.prototype.__init11.call(this);
        State.prototype.__init12.call(this);
        State.prototype.__init13.call(this);
    }
    (0, $cFHGC._)(State, [
        {
            // Used to signify the start of a potential arrow function
            key: "__init",
            value: function __init() {
                this.potentialArrowAt = -1;
            }
        },
        {
            // Used by Flow to handle an edge case involving function type parsing.
            key: "__init2",
            value: function __init2() {
                this.noAnonFunctionType = false;
            }
        },
        {
            // Used by TypeScript to handle ambiguities when parsing conditional types.
            key: "__init3",
            value: function __init3() {
                this.inDisallowConditionalTypesContext = false;
            }
        },
        {
            // Token store.
            key: "__init4",
            value: function __init4() {
                this.tokens = [];
            }
        },
        {
            // Array of all observed scopes, ordered by their ending position.
            key: "__init5",
            value: function __init5() {
                this.scopes = [];
            }
        },
        {
            // The current position of the tokenizer in the input.
            key: "__init6",
            value: function __init6() {
                this.pos = 0;
            }
        },
        {
            // Information about the current token.
            key: "__init7",
            value: function __init7() {
                this.type = (0, $30a0d13de21d779e$export$f435f793048e7a0f).eof;
            }
        },
        {
            key: "__init8",
            value: function __init8() {
                this.contextualKeyword = (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc).NONE;
            }
        },
        {
            key: "__init9",
            value: function __init9() {
                this.start = 0;
            }
        },
        {
            key: "__init10",
            value: function __init10() {
                this.end = 0;
            }
        },
        {
            key: "__init11",
            value: function __init11() {
                this.isType = false;
            }
        },
        {
            key: "__init12",
            value: function __init12() {
                this.scopeDepth = 0;
            }
        },
        {
            /**
   * If the parser is in an error state, then the token is always tt.eof and all functions can
   * keep executing but should be written so they don't get into an infinite loop in this situation.
   *
   * This approach, combined with the ability to snapshot and restore state, allows us to implement
   * backtracking without exceptions and without needing to explicitly propagate error states
   * everywhere.
   */ key: "__init13",
            value: function __init13() {
                this.error = null;
            }
        },
        {
            key: "snapshot",
            value: function snapshot() {
                return new $f0b680e833c1be0d$export$43b973415d9649ac(this.potentialArrowAt, this.noAnonFunctionType, this.inDisallowConditionalTypesContext, this.tokens.length, this.scopes.length, this.pos, this.type, this.contextualKeyword, this.start, this.end, this.isType, this.scopeDepth, this.error);
            }
        },
        {
            key: "restoreFromSnapshot",
            value: function restoreFromSnapshot(snapshot) {
                this.potentialArrowAt = snapshot.potentialArrowAt;
                this.noAnonFunctionType = snapshot.noAnonFunctionType;
                this.inDisallowConditionalTypesContext = snapshot.inDisallowConditionalTypesContext;
                this.tokens.length = snapshot.tokensLength;
                this.scopes.length = snapshot.scopesLength;
                this.pos = snapshot.pos;
                this.type = snapshot.type;
                this.contextualKeyword = snapshot.contextualKeyword;
                this.start = snapshot.start;
                this.end = snapshot.end;
                this.isType = snapshot.isType;
                this.scopeDepth = snapshot.scopeDepth;
                this.error = snapshot.error;
            }
        }
    ]);
    return State;
}();


var $270fc0c37efdc8f8$export$dbe39bbf2ade60d5;
(function(charCodes) {
    var backSpace = 8;
    charCodes[charCodes["backSpace"] = backSpace] = "backSpace";
    var lineFeed = 10;
    charCodes[charCodes["lineFeed"] = lineFeed] = "lineFeed"; //  '\n'
    var tab = 9;
    charCodes[charCodes["tab"] = tab] = "tab"; //  '\t'
    var carriageReturn = 13;
    charCodes[charCodes["carriageReturn"] = carriageReturn] = "carriageReturn"; //  '\r'
    var shiftOut = 14;
    charCodes[charCodes["shiftOut"] = shiftOut] = "shiftOut";
    var space = 32;
    charCodes[charCodes["space"] = space] = "space";
    var exclamationMark = 33;
    charCodes[charCodes["exclamationMark"] = exclamationMark] = "exclamationMark"; //  '!'
    var quotationMark = 34;
    charCodes[charCodes["quotationMark"] = quotationMark] = "quotationMark"; //  '"'
    var numberSign = 35;
    charCodes[charCodes["numberSign"] = numberSign] = "numberSign"; //  '#'
    var dollarSign = 36;
    charCodes[charCodes["dollarSign"] = dollarSign] = "dollarSign"; //  '$'
    var percentSign = 37;
    charCodes[charCodes["percentSign"] = percentSign] = "percentSign"; //  '%'
    var ampersand = 38;
    charCodes[charCodes["ampersand"] = ampersand] = "ampersand"; //  '&'
    var apostrophe = 39;
    charCodes[charCodes["apostrophe"] = apostrophe] = "apostrophe"; //  '''
    var leftParenthesis = 40;
    charCodes[charCodes["leftParenthesis"] = leftParenthesis] = "leftParenthesis"; //  '('
    var rightParenthesis = 41;
    charCodes[charCodes["rightParenthesis"] = rightParenthesis] = "rightParenthesis"; //  ')'
    var asterisk = 42;
    charCodes[charCodes["asterisk"] = asterisk] = "asterisk"; //  '*'
    var plusSign = 43;
    charCodes[charCodes["plusSign"] = plusSign] = "plusSign"; //  '+'
    var comma = 44;
    charCodes[charCodes["comma"] = comma] = "comma"; //  ','
    var dash = 45;
    charCodes[charCodes["dash"] = dash] = "dash"; //  '-'
    var dot = 46;
    charCodes[charCodes["dot"] = dot] = "dot"; //  '.'
    var slash = 47;
    charCodes[charCodes["slash"] = slash] = "slash"; //  '/'
    var digit0 = 48;
    charCodes[charCodes["digit0"] = digit0] = "digit0"; //  '0'
    var digit1 = 49;
    charCodes[charCodes["digit1"] = digit1] = "digit1"; //  '1'
    var digit2 = 50;
    charCodes[charCodes["digit2"] = digit2] = "digit2"; //  '2'
    var digit3 = 51;
    charCodes[charCodes["digit3"] = digit3] = "digit3"; //  '3'
    var digit4 = 52;
    charCodes[charCodes["digit4"] = digit4] = "digit4"; //  '4'
    var digit5 = 53;
    charCodes[charCodes["digit5"] = digit5] = "digit5"; //  '5'
    var digit6 = 54;
    charCodes[charCodes["digit6"] = digit6] = "digit6"; //  '6'
    var digit7 = 55;
    charCodes[charCodes["digit7"] = digit7] = "digit7"; //  '7'
    var digit8 = 56;
    charCodes[charCodes["digit8"] = digit8] = "digit8"; //  '8'
    var digit9 = 57;
    charCodes[charCodes["digit9"] = digit9] = "digit9"; //  '9'
    var colon = 58;
    charCodes[charCodes["colon"] = colon] = "colon"; //  ':'
    var semicolon = 59;
    charCodes[charCodes["semicolon"] = semicolon] = "semicolon"; //  ';'
    var lessThan = 60;
    charCodes[charCodes["lessThan"] = lessThan] = "lessThan"; //  '<'
    var equalsTo = 61;
    charCodes[charCodes["equalsTo"] = equalsTo] = "equalsTo"; //  '='
    var greaterThan = 62;
    charCodes[charCodes["greaterThan"] = greaterThan] = "greaterThan"; //  '>'
    var questionMark = 63;
    charCodes[charCodes["questionMark"] = questionMark] = "questionMark"; //  '?'
    var atSign = 64;
    charCodes[charCodes["atSign"] = atSign] = "atSign"; //  '@'
    var uppercaseA = 65;
    charCodes[charCodes["uppercaseA"] = uppercaseA] = "uppercaseA"; //  'A'
    var uppercaseB = 66;
    charCodes[charCodes["uppercaseB"] = uppercaseB] = "uppercaseB"; //  'B'
    var uppercaseC = 67;
    charCodes[charCodes["uppercaseC"] = uppercaseC] = "uppercaseC"; //  'C'
    var uppercaseD = 68;
    charCodes[charCodes["uppercaseD"] = uppercaseD] = "uppercaseD"; //  'D'
    var uppercaseE = 69;
    charCodes[charCodes["uppercaseE"] = uppercaseE] = "uppercaseE"; //  'E'
    var uppercaseF = 70;
    charCodes[charCodes["uppercaseF"] = uppercaseF] = "uppercaseF"; //  'F'
    var uppercaseG = 71;
    charCodes[charCodes["uppercaseG"] = uppercaseG] = "uppercaseG"; //  'G'
    var uppercaseH = 72;
    charCodes[charCodes["uppercaseH"] = uppercaseH] = "uppercaseH"; //  'H'
    var uppercaseI = 73;
    charCodes[charCodes["uppercaseI"] = uppercaseI] = "uppercaseI"; //  'I'
    var uppercaseJ = 74;
    charCodes[charCodes["uppercaseJ"] = uppercaseJ] = "uppercaseJ"; //  'J'
    var uppercaseK = 75;
    charCodes[charCodes["uppercaseK"] = uppercaseK] = "uppercaseK"; //  'K'
    var uppercaseL = 76;
    charCodes[charCodes["uppercaseL"] = uppercaseL] = "uppercaseL"; //  'L'
    var uppercaseM = 77;
    charCodes[charCodes["uppercaseM"] = uppercaseM] = "uppercaseM"; //  'M'
    var uppercaseN = 78;
    charCodes[charCodes["uppercaseN"] = uppercaseN] = "uppercaseN"; //  'N'
    var uppercaseO = 79;
    charCodes[charCodes["uppercaseO"] = uppercaseO] = "uppercaseO"; //  'O'
    var uppercaseP = 80;
    charCodes[charCodes["uppercaseP"] = uppercaseP] = "uppercaseP"; //  'P'
    var uppercaseQ = 81;
    charCodes[charCodes["uppercaseQ"] = uppercaseQ] = "uppercaseQ"; //  'Q'
    var uppercaseR = 82;
    charCodes[charCodes["uppercaseR"] = uppercaseR] = "uppercaseR"; //  'R'
    var uppercaseS = 83;
    charCodes[charCodes["uppercaseS"] = uppercaseS] = "uppercaseS"; //  'S'
    var uppercaseT = 84;
    charCodes[charCodes["uppercaseT"] = uppercaseT] = "uppercaseT"; //  'T'
    var uppercaseU = 85;
    charCodes[charCodes["uppercaseU"] = uppercaseU] = "uppercaseU"; //  'U'
    var uppercaseV = 86;
    charCodes[charCodes["uppercaseV"] = uppercaseV] = "uppercaseV"; //  'V'
    var uppercaseW = 87;
    charCodes[charCodes["uppercaseW"] = uppercaseW] = "uppercaseW"; //  'W'
    var uppercaseX = 88;
    charCodes[charCodes["uppercaseX"] = uppercaseX] = "uppercaseX"; //  'X'
    var uppercaseY = 89;
    charCodes[charCodes["uppercaseY"] = uppercaseY] = "uppercaseY"; //  'Y'
    var uppercaseZ = 90;
    charCodes[charCodes["uppercaseZ"] = uppercaseZ] = "uppercaseZ"; //  'Z'
    var leftSquareBracket = 91;
    charCodes[charCodes["leftSquareBracket"] = leftSquareBracket] = "leftSquareBracket"; //  '['
    var backslash = 92;
    charCodes[charCodes["backslash"] = backslash] = "backslash"; //  '\    '
    var rightSquareBracket = 93;
    charCodes[charCodes["rightSquareBracket"] = rightSquareBracket] = "rightSquareBracket"; //  ']'
    var caret = 94;
    charCodes[charCodes["caret"] = caret] = "caret"; //  '^'
    var underscore = 95;
    charCodes[charCodes["underscore"] = underscore] = "underscore"; //  '_'
    var graveAccent = 96;
    charCodes[charCodes["graveAccent"] = graveAccent] = "graveAccent"; //  '`'
    var lowercaseA = 97;
    charCodes[charCodes["lowercaseA"] = lowercaseA] = "lowercaseA"; //  'a'
    var lowercaseB = 98;
    charCodes[charCodes["lowercaseB"] = lowercaseB] = "lowercaseB"; //  'b'
    var lowercaseC = 99;
    charCodes[charCodes["lowercaseC"] = lowercaseC] = "lowercaseC"; //  'c'
    var lowercaseD = 100;
    charCodes[charCodes["lowercaseD"] = lowercaseD] = "lowercaseD"; //  'd'
    var lowercaseE = 101;
    charCodes[charCodes["lowercaseE"] = lowercaseE] = "lowercaseE"; //  'e'
    var lowercaseF = 102;
    charCodes[charCodes["lowercaseF"] = lowercaseF] = "lowercaseF"; //  'f'
    var lowercaseG = 103;
    charCodes[charCodes["lowercaseG"] = lowercaseG] = "lowercaseG"; //  'g'
    var lowercaseH = 104;
    charCodes[charCodes["lowercaseH"] = lowercaseH] = "lowercaseH"; //  'h'
    var lowercaseI = 105;
    charCodes[charCodes["lowercaseI"] = lowercaseI] = "lowercaseI"; //  'i'
    var lowercaseJ = 106;
    charCodes[charCodes["lowercaseJ"] = lowercaseJ] = "lowercaseJ"; //  'j'
    var lowercaseK = 107;
    charCodes[charCodes["lowercaseK"] = lowercaseK] = "lowercaseK"; //  'k'
    var lowercaseL = 108;
    charCodes[charCodes["lowercaseL"] = lowercaseL] = "lowercaseL"; //  'l'
    var lowercaseM = 109;
    charCodes[charCodes["lowercaseM"] = lowercaseM] = "lowercaseM"; //  'm'
    var lowercaseN = 110;
    charCodes[charCodes["lowercaseN"] = lowercaseN] = "lowercaseN"; //  'n'
    var lowercaseO = 111;
    charCodes[charCodes["lowercaseO"] = lowercaseO] = "lowercaseO"; //  'o'
    var lowercaseP = 112;
    charCodes[charCodes["lowercaseP"] = lowercaseP] = "lowercaseP"; //  'p'
    var lowercaseQ = 113;
    charCodes[charCodes["lowercaseQ"] = lowercaseQ] = "lowercaseQ"; //  'q'
    var lowercaseR = 114;
    charCodes[charCodes["lowercaseR"] = lowercaseR] = "lowercaseR"; //  'r'
    var lowercaseS = 115;
    charCodes[charCodes["lowercaseS"] = lowercaseS] = "lowercaseS"; //  's'
    var lowercaseT = 116;
    charCodes[charCodes["lowercaseT"] = lowercaseT] = "lowercaseT"; //  't'
    var lowercaseU = 117;
    charCodes[charCodes["lowercaseU"] = lowercaseU] = "lowercaseU"; //  'u'
    var lowercaseV = 118;
    charCodes[charCodes["lowercaseV"] = lowercaseV] = "lowercaseV"; //  'v'
    var lowercaseW = 119;
    charCodes[charCodes["lowercaseW"] = lowercaseW] = "lowercaseW"; //  'w'
    var lowercaseX = 120;
    charCodes[charCodes["lowercaseX"] = lowercaseX] = "lowercaseX"; //  'x'
    var lowercaseY = 121;
    charCodes[charCodes["lowercaseY"] = lowercaseY] = "lowercaseY"; //  'y'
    var lowercaseZ = 122;
    charCodes[charCodes["lowercaseZ"] = lowercaseZ] = "lowercaseZ"; //  'z'
    var leftCurlyBrace = 123;
    charCodes[charCodes["leftCurlyBrace"] = leftCurlyBrace] = "leftCurlyBrace"; //  '{'
    var verticalBar = 124;
    charCodes[charCodes["verticalBar"] = verticalBar] = "verticalBar"; //  '|'
    var rightCurlyBrace = 125;
    charCodes[charCodes["rightCurlyBrace"] = rightCurlyBrace] = "rightCurlyBrace"; //  '}'
    var tilde = 126;
    charCodes[charCodes["tilde"] = tilde] = "tilde"; //  '~'
    var nonBreakingSpace = 160;
    charCodes[charCodes["nonBreakingSpace"] = nonBreakingSpace] = "nonBreakingSpace";
    // eslint-disable-next-line no-irregular-whitespace
    var oghamSpaceMark = 5760;
    charCodes[charCodes["oghamSpaceMark"] = oghamSpaceMark] = "oghamSpaceMark"; // ' '
    var lineSeparator = 8232;
    charCodes[charCodes["lineSeparator"] = lineSeparator] = "lineSeparator";
    var paragraphSeparator = 8233;
    charCodes[charCodes["paragraphSeparator"] = paragraphSeparator] = "paragraphSeparator";
})($270fc0c37efdc8f8$export$dbe39bbf2ade60d5 || ($270fc0c37efdc8f8$export$dbe39bbf2ade60d5 = {}));
function $270fc0c37efdc8f8$export$727d9dbc4fbb948f(code) {
    return code >= $270fc0c37efdc8f8$export$dbe39bbf2ade60d5.digit0 && code <= $270fc0c37efdc8f8$export$dbe39bbf2ade60d5.digit9 || code >= $270fc0c37efdc8f8$export$dbe39bbf2ade60d5.lowercaseA && code <= $270fc0c37efdc8f8$export$dbe39bbf2ade60d5.lowercaseF || code >= $270fc0c37efdc8f8$export$dbe39bbf2ade60d5.uppercaseA && code <= $270fc0c37efdc8f8$export$dbe39bbf2ade60d5.uppercaseF;
}


var $875661fa68d3a4de$export$43bb667a94af025a;
var $875661fa68d3a4de$export$757c2735689d2de8;
var $875661fa68d3a4de$export$92e334f8fe49aa94;
var $875661fa68d3a4de$export$ca000e230c0caa3e;
var $875661fa68d3a4de$export$b7e3ae3d7c15e42e;
var $875661fa68d3a4de$export$d854af1c30ac0f3a;
function $875661fa68d3a4de$export$d0c215ddd78b3d24() {
    return $875661fa68d3a4de$export$d854af1c30ac0f3a++;
}
function $875661fa68d3a4de$export$2ca6ff5cad32970a(error) {
    if ("pos" in error) {
        var loc = $875661fa68d3a4de$export$66bfa486b735c2f7(error.pos);
        error.message += " (".concat(loc.line, ":").concat(loc.column, ")");
        error.loc = loc;
    }
    return error;
}
var $875661fa68d3a4de$export$f564f979629709cc = function Loc(line, column) {
    "use strict";
    (0, $173N4._)(this, Loc);
    this.line = line;
    this.column = column;
};
function $875661fa68d3a4de$export$66bfa486b735c2f7(pos) {
    var line = 1;
    var column = 1;
    for(var i = 0; i < pos; i++)if ($875661fa68d3a4de$export$b7e3ae3d7c15e42e.charCodeAt(i) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lineFeed) {
        line++;
        column = 1;
    } else column++;
    return new $875661fa68d3a4de$export$f564f979629709cc(line, column);
}
function $875661fa68d3a4de$export$84bb9899435eeb61(inputCode, isJSXEnabledArg, isTypeScriptEnabledArg, isFlowEnabledArg) {
    $875661fa68d3a4de$export$b7e3ae3d7c15e42e = inputCode;
    $875661fa68d3a4de$export$ca000e230c0caa3e = new (0, $f0b680e833c1be0d$export$2e2bcd8739ae039)();
    $875661fa68d3a4de$export$d854af1c30ac0f3a = 1;
    $875661fa68d3a4de$export$43bb667a94af025a = isJSXEnabledArg;
    $875661fa68d3a4de$export$757c2735689d2de8 = isTypeScriptEnabledArg;
    $875661fa68d3a4de$export$92e334f8fe49aa94 = isFlowEnabledArg;
}






function $40d5f3c610bd8f72$export$d382681f238736f1(contextualKeyword) {
    return (0, $875661fa68d3a4de$export$ca000e230c0caa3e).contextualKeyword === contextualKeyword;
}
function $40d5f3c610bd8f72$export$d1b5391c35999eba(contextualKeyword) {
    var l = (0, $e2df986cc8bbbda9$export$ef1b94c514fc060a)();
    return l.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).name && l.contextualKeyword === contextualKeyword;
}
function $40d5f3c610bd8f72$export$b8f8f7fffeb6fb36(contextualKeyword) {
    return (0, $875661fa68d3a4de$export$ca000e230c0caa3e).contextualKeyword === contextualKeyword && (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name);
}
function $40d5f3c610bd8f72$export$b8ead11dfed96f19(contextualKeyword) {
    if (!$40d5f3c610bd8f72$export$b8f8f7fffeb6fb36(contextualKeyword)) $40d5f3c610bd8f72$export$4c195bc1a97b6f7f();
}
function $40d5f3c610bd8f72$export$1c0919cee6560c3() {
    return (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).eof) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR) || $40d5f3c610bd8f72$export$942fa35f3a7c108c();
}
function $40d5f3c610bd8f72$export$942fa35f3a7c108c() {
    var prevToken = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1];
    var lastTokEnd = prevToken ? prevToken.end : 0;
    for(var i = lastTokEnd; i < (0, $875661fa68d3a4de$export$ca000e230c0caa3e).start; i++){
        var code = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt(i);
        if (code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lineFeed || code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).carriageReturn || code === 0x2028 || code === 0x2029) return true;
    }
    return false;
}
function $40d5f3c610bd8f72$export$a4f1ee8cbd9b31ba() {
    var nextStart = (0, $e2df986cc8bbbda9$export$1678d89ce52f4a6)();
    for(var i = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).end; i < nextStart; i++){
        var code = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt(i);
        if (code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lineFeed || code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).carriageReturn || code === 0x2028 || code === 0x2029) return true;
    }
    return false;
}
function $40d5f3c610bd8f72$export$12d132b6e81066e4() {
    return (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).semi) || $40d5f3c610bd8f72$export$1c0919cee6560c3();
}
function $40d5f3c610bd8f72$export$62fa27d385e555f3() {
    if (!$40d5f3c610bd8f72$export$12d132b6e81066e4()) $40d5f3c610bd8f72$export$4c195bc1a97b6f7f('Unexpected token, expected ";"');
}
function $40d5f3c610bd8f72$export$3570f33b1a1f3329(type) {
    var matched = (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)(type);
    if (!matched) $40d5f3c610bd8f72$export$4c195bc1a97b6f7f('Unexpected token, expected "'.concat((0, $30a0d13de21d779e$export$b78065ce79336a93)(type), '"'));
}
function $40d5f3c610bd8f72$export$4c195bc1a97b6f7f() {
    var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Unexpected token", pos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $875661fa68d3a4de$export$ca000e230c0caa3e).start;
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).error) return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var err = new SyntaxError(message);
    err.pos = pos;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).error = err;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).length;
    (0, $e2df986cc8bbbda9$export$58122cd1933ef607)((0, $30a0d13de21d779e$export$f435f793048e7a0f).eof);
}





var $6b4b576bbcb1fdb0$export$518c7e3eadd435e0 = [
    0x0009,
    0x000b,
    0x000c,
    (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).space,
    (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).nonBreakingSpace,
    (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).oghamSpaceMark,
    0x2000,
    0x2001,
    0x2002,
    0x2003,
    0x2004,
    0x2005,
    0x2006,
    0x2007,
    0x2008,
    0x2009,
    0x200a,
    0x202f,
    0x205f,
    0x3000,
    0xfeff
];
var $6b4b576bbcb1fdb0$export$4856bde7911f0623 = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g;
var $6b4b576bbcb1fdb0$export$4347b22d2e0ca480 = new Uint8Array(65536);
var $6b4b576bbcb1fdb0$var$_iteratorNormalCompletion = true, $6b4b576bbcb1fdb0$var$_didIteratorError = false, $6b4b576bbcb1fdb0$var$_iteratorError = undefined;
try {
    for(var $6b4b576bbcb1fdb0$var$_iterator = $6b4b576bbcb1fdb0$export$518c7e3eadd435e0[Symbol.iterator](), $6b4b576bbcb1fdb0$var$_step; !($6b4b576bbcb1fdb0$var$_iteratorNormalCompletion = ($6b4b576bbcb1fdb0$var$_step = $6b4b576bbcb1fdb0$var$_iterator.next()).done); $6b4b576bbcb1fdb0$var$_iteratorNormalCompletion = true){
        var $6b4b576bbcb1fdb0$var$char = $6b4b576bbcb1fdb0$var$_step.value;
        $6b4b576bbcb1fdb0$export$4347b22d2e0ca480[$6b4b576bbcb1fdb0$var$char] = 1;
    }
} catch (err) {
    $6b4b576bbcb1fdb0$var$_didIteratorError = true;
    $6b4b576bbcb1fdb0$var$_iteratorError = err;
} finally{
    try {
        if (!$6b4b576bbcb1fdb0$var$_iteratorNormalCompletion && $6b4b576bbcb1fdb0$var$_iterator.return != null) {
            $6b4b576bbcb1fdb0$var$_iterator.return();
        }
    } finally{
        if ($6b4b576bbcb1fdb0$var$_didIteratorError) {
            throw $6b4b576bbcb1fdb0$var$_iteratorError;
        }
    }
}


function $c0e0280b0658a40b$var$computeIsIdentifierChar(code) {
    if (code < 48) return code === 36;
    if (code < 58) return true;
    if (code < 65) return false;
    if (code < 91) return true;
    if (code < 97) return code === 95;
    if (code < 123) return true;
    if (code < 128) return false;
    throw new Error("Should not be called with non-ASCII char code.");
}
var $c0e0280b0658a40b$export$d19df39e3926cfef = new Uint8Array(65536);
for(var $c0e0280b0658a40b$var$i = 0; $c0e0280b0658a40b$var$i < 128; $c0e0280b0658a40b$var$i++)$c0e0280b0658a40b$export$d19df39e3926cfef[$c0e0280b0658a40b$var$i] = $c0e0280b0658a40b$var$computeIsIdentifierChar($c0e0280b0658a40b$var$i) ? 1 : 0;
for(var $c0e0280b0658a40b$var$i1 = 128; $c0e0280b0658a40b$var$i1 < 65536; $c0e0280b0658a40b$var$i1++)$c0e0280b0658a40b$export$d19df39e3926cfef[$c0e0280b0658a40b$var$i1] = 1;
var $c0e0280b0658a40b$var$_iteratorNormalCompletion = true, $c0e0280b0658a40b$var$_didIteratorError = false, $c0e0280b0658a40b$var$_iteratorError = undefined;
try {
    // Aside from whitespace and newlines, all characters outside the ASCII space are either
    // identifier characters or invalid. Since we're not performing code validation, we can just
    // treat all invalid characters as identifier characters.
    for(var $c0e0280b0658a40b$var$_iterator = (0, $6b4b576bbcb1fdb0$export$518c7e3eadd435e0)[Symbol.iterator](), $c0e0280b0658a40b$var$_step; !($c0e0280b0658a40b$var$_iteratorNormalCompletion = ($c0e0280b0658a40b$var$_step = $c0e0280b0658a40b$var$_iterator.next()).done); $c0e0280b0658a40b$var$_iteratorNormalCompletion = true){
        var $c0e0280b0658a40b$var$whitespaceChar = $c0e0280b0658a40b$var$_step.value;
        $c0e0280b0658a40b$export$d19df39e3926cfef[$c0e0280b0658a40b$var$whitespaceChar] = 0;
    }
} catch (err) {
    $c0e0280b0658a40b$var$_didIteratorError = true;
    $c0e0280b0658a40b$var$_iteratorError = err;
} finally{
    try {
        if (!$c0e0280b0658a40b$var$_iteratorNormalCompletion && $c0e0280b0658a40b$var$_iterator.return != null) {
            $c0e0280b0658a40b$var$_iterator.return();
        }
    } finally{
        if ($c0e0280b0658a40b$var$_didIteratorError) {
            throw $c0e0280b0658a40b$var$_iteratorError;
        }
    }
}
$c0e0280b0658a40b$export$d19df39e3926cfef[0x2028] = 0;
$c0e0280b0658a40b$export$d19df39e3926cfef[0x2029] = 0;
var $c0e0280b0658a40b$export$dc1d1d7d9fdffb8 = $c0e0280b0658a40b$export$d19df39e3926cfef.slice();
for(var $c0e0280b0658a40b$var$numChar = (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit0; $c0e0280b0658a40b$var$numChar <= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit9; $c0e0280b0658a40b$var$numChar++)$c0e0280b0658a40b$export$dc1d1d7d9fdffb8[$c0e0280b0658a40b$var$numChar] = 0;








// Generated file, do not edit! Run "yarn generate" to re-generate this file.


var $0b397910bcd61a0d$export$cb39af7c41e25635 = new Int32Array([
    // ""
    -1,
    27,
    783,
    918,
    1755,
    2376,
    2862,
    3483,
    -1,
    3699,
    -1,
    4617,
    4752,
    4833,
    5130,
    5508,
    5940,
    -1,
    6480,
    6939,
    7749,
    8181,
    8451,
    8613,
    -1,
    8829,
    -1,
    // "a"
    -1,
    -1,
    54,
    243,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    432,
    -1,
    -1,
    -1,
    675,
    -1,
    -1,
    -1,
    // "ab"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    81,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abs"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    108,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abst"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    135,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abstr"
    -1,
    162,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abstra"
    -1,
    -1,
    -1,
    189,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abstrac"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    216,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abstract"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._abstract << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ac"
    -1,
    -1,
    -1,
    270,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "acc"
    -1,
    -1,
    -1,
    -1,
    -1,
    297,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "acce"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    324,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "acces"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    351,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "access"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    378,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "accesso"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    405,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "accessor"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._accessor << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "as"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._as << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    459,
    -1,
    -1,
    -1,
    -1,
    -1,
    594,
    -1,
    // "ass"
    -1,
    -1,
    -1,
    -1,
    -1,
    486,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "asse"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    513,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "asser"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    540,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "assert"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._assert << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    567,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "asserts"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._asserts << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "asy"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    621,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "asyn"
    -1,
    -1,
    -1,
    648,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "async"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._async << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "aw"
    -1,
    702,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "awa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    729,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "awai"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    756,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "await"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._await << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "b"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    810,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "br"
    -1,
    -1,
    -1,
    -1,
    -1,
    837,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "bre"
    -1,
    864,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "brea"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    891,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "break"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._break << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "c"
    -1,
    945,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1107,
    -1,
    -1,
    -1,
    1242,
    -1,
    -1,
    1350,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ca"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    972,
    1026,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cas"
    -1,
    -1,
    -1,
    -1,
    -1,
    999,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "case"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._case << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cat"
    -1,
    -1,
    -1,
    1053,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "catc"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1080,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "catch"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._catch << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ch"
    -1,
    -1,
    -1,
    -1,
    -1,
    1134,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "che"
    -1,
    -1,
    -1,
    1161,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "chec"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1188,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "check"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1215,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "checks"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._checks << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cl"
    -1,
    1269,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cla"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1296,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "clas"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1323,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "class"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._class << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "co"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1377,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "con"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1404,
    1620,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cons"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1431,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "const"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._const << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1458,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "constr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1485,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "constru"
    -1,
    -1,
    -1,
    1512,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "construc"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1539,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "construct"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1566,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "constructo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1593,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "constructor"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._constructor << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cont"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1647,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "conti"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1674,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "contin"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1701,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "continu"
    -1,
    -1,
    -1,
    -1,
    -1,
    1728,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "continue"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._continue << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "d"
    -1,
    -1,
    -1,
    -1,
    -1,
    1782,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2349,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "de"
    -1,
    -1,
    1809,
    1971,
    -1,
    -1,
    2106,
    -1,
    -1,
    -1,
    -1,
    -1,
    2241,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "deb"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1836,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "debu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1863,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "debug"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1890,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "debugg"
    -1,
    -1,
    -1,
    -1,
    -1,
    1917,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "debugge"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1944,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "debugger"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._debugger << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "dec"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1998,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "decl"
    -1,
    2025,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "decla"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2052,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "declar"
    -1,
    -1,
    -1,
    -1,
    -1,
    2079,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "declare"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._declare << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "def"
    -1,
    2133,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "defa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2160,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "defau"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2187,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "defaul"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2214,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "default"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._default << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "del"
    -1,
    -1,
    -1,
    -1,
    -1,
    2268,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "dele"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2295,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "delet"
    -1,
    -1,
    -1,
    -1,
    -1,
    2322,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "delete"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._delete << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "do"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._do << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "e"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2403,
    -1,
    2484,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2565,
    -1,
    -1,
    // "el"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2430,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "els"
    -1,
    -1,
    -1,
    -1,
    -1,
    2457,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "else"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._else << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "en"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2511,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "enu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2538,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "enum"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._enum << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ex"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2592,
    -1,
    -1,
    -1,
    2727,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "exp"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2619,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "expo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2646,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "expor"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2673,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "export"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2700,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "exports"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._exports << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ext"
    -1,
    -1,
    -1,
    -1,
    -1,
    2754,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "exte"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2781,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "exten"
    -1,
    -1,
    -1,
    -1,
    2808,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "extend"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2835,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "extends"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._extends << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "f"
    -1,
    2889,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2997,
    -1,
    -1,
    -1,
    -1,
    -1,
    3159,
    -1,
    -1,
    3213,
    -1,
    -1,
    3294,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2916,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fal"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2943,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fals"
    -1,
    -1,
    -1,
    -1,
    -1,
    2970,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "false"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._false << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3024,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fin"
    -1,
    3051,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fina"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3078,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "final"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3105,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "finall"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3132,
    -1,
    // "finally"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._finally << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3186,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "for"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._for << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3240,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fro"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3267,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "from"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._from << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3321,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fun"
    -1,
    -1,
    -1,
    3348,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "func"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3375,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "funct"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3402,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "functi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3429,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "functio"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3456,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "function"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._function << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "g"
    -1,
    -1,
    -1,
    -1,
    -1,
    3510,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3564,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ge"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3537,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "get"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._get << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "gl"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3591,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "glo"
    -1,
    -1,
    3618,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "glob"
    -1,
    3645,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "globa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3672,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "global"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._global << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "i"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3726,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3753,
    4077,
    -1,
    -1,
    -1,
    -1,
    4590,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "if"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._if << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "im"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3780,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "imp"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3807,
    -1,
    -1,
    3996,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "impl"
    -1,
    -1,
    -1,
    -1,
    -1,
    3834,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "imple"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3861,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "implem"
    -1,
    -1,
    -1,
    -1,
    -1,
    3888,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "impleme"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3915,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "implemen"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3942,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "implement"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3969,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "implements"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._implements << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "impo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4023,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "impor"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4050,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "import"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._import << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "in"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._in << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4104,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4185,
    4401,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "inf"
    -1,
    -1,
    -1,
    -1,
    -1,
    4131,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "infe"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4158,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "infer"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._infer << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ins"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4212,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "inst"
    -1,
    4239,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "insta"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4266,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "instan"
    -1,
    -1,
    -1,
    4293,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "instanc"
    -1,
    -1,
    -1,
    -1,
    -1,
    4320,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "instance"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4347,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "instanceo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4374,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "instanceof"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._instanceof << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "int"
    -1,
    -1,
    -1,
    -1,
    -1,
    4428,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "inte"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4455,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "inter"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4482,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "interf"
    -1,
    4509,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "interfa"
    -1,
    -1,
    -1,
    4536,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "interfac"
    -1,
    -1,
    -1,
    -1,
    -1,
    4563,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "interface"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._interface << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "is"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._is << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "k"
    -1,
    -1,
    -1,
    -1,
    -1,
    4644,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ke"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4671,
    -1,
    // "key"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4698,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "keyo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4725,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "keyof"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._keyof << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "l"
    -1,
    -1,
    -1,
    -1,
    -1,
    4779,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "le"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4806,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "let"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._let << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "m"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4860,
    -1,
    -1,
    -1,
    -1,
    -1,
    4995,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4887,
    -1,
    -1,
    // "mix"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4914,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mixi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4941,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mixin"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4968,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mixins"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._mixins << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mo"
    -1,
    -1,
    -1,
    -1,
    5022,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mod"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5049,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "modu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5076,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "modul"
    -1,
    -1,
    -1,
    -1,
    -1,
    5103,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "module"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._module << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "n"
    -1,
    5157,
    -1,
    -1,
    -1,
    5373,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5427,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "na"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5184,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "nam"
    -1,
    -1,
    -1,
    -1,
    -1,
    5211,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "name"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5238,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "names"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5265,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "namesp"
    -1,
    5292,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "namespa"
    -1,
    -1,
    -1,
    5319,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "namespac"
    -1,
    -1,
    -1,
    -1,
    -1,
    5346,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "namespace"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._namespace << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ne"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5400,
    -1,
    -1,
    -1,
    // "new"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._new << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "nu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5454,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "nul"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5481,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "null"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._null << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "o"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5535,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5562,
    -1,
    -1,
    -1,
    -1,
    5697,
    5751,
    -1,
    -1,
    -1,
    -1,
    // "of"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._of << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "op"
    -1,
    5589,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "opa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5616,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "opaq"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5643,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "opaqu"
    -1,
    -1,
    -1,
    -1,
    -1,
    5670,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "opaque"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._opaque << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ou"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5724,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "out"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._out << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ov"
    -1,
    -1,
    -1,
    -1,
    -1,
    5778,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ove"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5805,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "over"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5832,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "overr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5859,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "overri"
    -1,
    -1,
    -1,
    -1,
    5886,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "overrid"
    -1,
    -1,
    -1,
    -1,
    -1,
    5913,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "override"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._override << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "p"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5967,
    -1,
    -1,
    6345,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "pr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5994,
    -1,
    -1,
    -1,
    -1,
    -1,
    6129,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "pri"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6021,
    -1,
    -1,
    -1,
    -1,
    // "priv"
    -1,
    6048,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "priva"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6075,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "privat"
    -1,
    -1,
    -1,
    -1,
    -1,
    6102,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "private"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._private << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "pro"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6156,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "prot"
    -1,
    -1,
    -1,
    -1,
    -1,
    6183,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6318,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "prote"
    -1,
    -1,
    -1,
    6210,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "protec"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6237,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "protect"
    -1,
    -1,
    -1,
    -1,
    -1,
    6264,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "protecte"
    -1,
    -1,
    -1,
    -1,
    6291,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "protected"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._protected << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "proto"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._proto << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "pu"
    -1,
    -1,
    6372,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "pub"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6399,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "publ"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6426,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "publi"
    -1,
    -1,
    -1,
    6453,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "public"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._public << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "r"
    -1,
    -1,
    -1,
    -1,
    -1,
    6507,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "re"
    -1,
    6534,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6696,
    -1,
    -1,
    6831,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "rea"
    -1,
    -1,
    -1,
    -1,
    6561,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "read"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6588,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "reado"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6615,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "readon"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6642,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "readonl"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6669,
    -1,
    // "readonly"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._readonly << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "req"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6723,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "requ"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6750,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "requi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6777,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "requir"
    -1,
    -1,
    -1,
    -1,
    -1,
    6804,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "require"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._require << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ret"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6858,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "retu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6885,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "retur"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6912,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "return"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._return << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "s"
    -1,
    6966,
    -1,
    -1,
    -1,
    7182,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7236,
    7371,
    -1,
    7479,
    -1,
    7614,
    -1,
    // "sa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6993,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sat"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7020,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sati"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7047,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "satis"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7074,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "satisf"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7101,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "satisfi"
    -1,
    -1,
    -1,
    -1,
    -1,
    7128,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "satisfie"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7155,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "satisfies"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._satisfies << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "se"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7209,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "set"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._set << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "st"
    -1,
    7263,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sta"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7290,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "stat"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7317,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "stati"
    -1,
    -1,
    -1,
    7344,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "static"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._static << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "su"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7398,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sup"
    -1,
    -1,
    -1,
    -1,
    -1,
    7425,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "supe"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7452,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "super"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._super << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sw"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7506,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "swi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7533,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "swit"
    -1,
    -1,
    -1,
    7560,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "switc"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7587,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "switch"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._switch << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sy"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7641,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sym"
    -1,
    -1,
    7668,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "symb"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7695,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "symbo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7722,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "symbol"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._symbol << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "t"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7776,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7938,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8046,
    -1,
    // "th"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7803,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7857,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "thi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7830,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "this"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._this << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "thr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7884,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "thro"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7911,
    -1,
    -1,
    -1,
    // "throw"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._throw << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "tr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7965,
    -1,
    -1,
    -1,
    8019,
    -1,
    // "tru"
    -1,
    -1,
    -1,
    -1,
    -1,
    7992,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "true"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._true << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "try"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._try << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ty"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8073,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "typ"
    -1,
    -1,
    -1,
    -1,
    -1,
    8100,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "type"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8127,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "typeo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8154,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "typeof"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._typeof << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "u"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8208,
    -1,
    -1,
    -1,
    -1,
    8343,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "un"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8235,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "uni"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8262,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "uniq"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8289,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "uniqu"
    -1,
    -1,
    -1,
    -1,
    -1,
    8316,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "unique"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._unique << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "us"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8370,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "usi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8397,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "usin"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8424,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "using"
    (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._using << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "v"
    -1,
    8478,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8532,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "va"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8505,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "var"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._var << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "vo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8559,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "voi"
    -1,
    -1,
    -1,
    -1,
    8586,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "void"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._void << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "w"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8640,
    8748,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "wh"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8667,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "whi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8694,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "whil"
    -1,
    -1,
    -1,
    -1,
    -1,
    8721,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "while"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._while << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "wi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8775,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "wit"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8802,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "with"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._with << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "y"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8856,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "yi"
    -1,
    -1,
    -1,
    -1,
    -1,
    8883,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "yie"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8910,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "yiel"
    -1,
    -1,
    -1,
    -1,
    8937,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "yield"
    ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._yield << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1
]);



function $2a792a0a209052a3$export$2e2bcd8739ae039() {
    var treePos = 0;
    var code = 0;
    var pos = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
    while(pos < (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).length){
        code = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt(pos);
        if (code < (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseA || code > (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseZ) break;
        var next = (0, $0b397910bcd61a0d$export$cb39af7c41e25635)[treePos + (code - (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseA) + 1];
        if (next === -1) break;
        else {
            treePos = next;
            pos++;
        }
    }
    var keywordValue = (0, $0b397910bcd61a0d$export$cb39af7c41e25635)[treePos];
    if (keywordValue > -1 && !(0, $c0e0280b0658a40b$export$d19df39e3926cfef)[code]) {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos = pos;
        if (keywordValue & 1) (0, $e2df986cc8bbbda9$export$58122cd1933ef607)(keywordValue >>> 1);
        else (0, $e2df986cc8bbbda9$export$58122cd1933ef607)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name, keywordValue >>> 1);
        return;
    }
    while(pos < (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).length){
        var ch = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt(pos);
        if ((0, $c0e0280b0658a40b$export$d19df39e3926cfef)[ch]) pos++;
        else if (ch === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).backslash) {
            // \u
            pos += 2;
            if ((0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt(pos) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).leftCurlyBrace) {
                while(pos < (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).length && (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt(pos) !== (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).rightCurlyBrace)pos++;
                pos++;
            }
        } else if (ch === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).atSign && (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt(pos + 1) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).atSign) pos += 2;
        else break;
    }
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos = pos;
    (0, $e2df986cc8bbbda9$export$58122cd1933ef607)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name);
}



var $e2df986cc8bbbda9$export$99f888ada3c99de3;
(function(IdentifierRole) {
    var Access = 0;
    IdentifierRole[IdentifierRole["Access"] = Access] = "Access";
    var ExportAccess = Access + 1;
    IdentifierRole[IdentifierRole["ExportAccess"] = ExportAccess] = "ExportAccess";
    var TopLevelDeclaration = ExportAccess + 1;
    IdentifierRole[IdentifierRole["TopLevelDeclaration"] = TopLevelDeclaration] = "TopLevelDeclaration";
    var FunctionScopedDeclaration = TopLevelDeclaration + 1;
    IdentifierRole[IdentifierRole["FunctionScopedDeclaration"] = FunctionScopedDeclaration] = "FunctionScopedDeclaration";
    var BlockScopedDeclaration = FunctionScopedDeclaration + 1;
    IdentifierRole[IdentifierRole["BlockScopedDeclaration"] = BlockScopedDeclaration] = "BlockScopedDeclaration";
    var ObjectShorthandTopLevelDeclaration = BlockScopedDeclaration + 1;
    IdentifierRole[IdentifierRole["ObjectShorthandTopLevelDeclaration"] = ObjectShorthandTopLevelDeclaration] = "ObjectShorthandTopLevelDeclaration";
    var ObjectShorthandFunctionScopedDeclaration = ObjectShorthandTopLevelDeclaration + 1;
    IdentifierRole[IdentifierRole["ObjectShorthandFunctionScopedDeclaration"] = ObjectShorthandFunctionScopedDeclaration] = "ObjectShorthandFunctionScopedDeclaration";
    var ObjectShorthandBlockScopedDeclaration = ObjectShorthandFunctionScopedDeclaration + 1;
    IdentifierRole[IdentifierRole["ObjectShorthandBlockScopedDeclaration"] = ObjectShorthandBlockScopedDeclaration] = "ObjectShorthandBlockScopedDeclaration";
    var ObjectShorthand = ObjectShorthandBlockScopedDeclaration + 1;
    IdentifierRole[IdentifierRole["ObjectShorthand"] = ObjectShorthand] = "ObjectShorthand";
    // Any identifier bound in an import statement, e.g. both A and b from
    // `import A, * as b from 'A';`
    var ImportDeclaration = ObjectShorthand + 1;
    IdentifierRole[IdentifierRole["ImportDeclaration"] = ImportDeclaration] = "ImportDeclaration";
    var ObjectKey = ImportDeclaration + 1;
    IdentifierRole[IdentifierRole["ObjectKey"] = ObjectKey] = "ObjectKey";
    // The `foo` in `import {foo as bar} from "./abc";`.
    var ImportAccess = ObjectKey + 1;
    IdentifierRole[IdentifierRole["ImportAccess"] = ImportAccess] = "ImportAccess";
})($e2df986cc8bbbda9$export$99f888ada3c99de3 || ($e2df986cc8bbbda9$export$99f888ada3c99de3 = {}));
var $e2df986cc8bbbda9$export$4620c92ad8b511d9;
(function(JSXRole) {
    // The element is self-closing or has a body that resolves to empty. We
    // shouldn't emit children at all in this case.
    var NoChildren = 0;
    JSXRole[JSXRole["NoChildren"] = NoChildren] = "NoChildren";
    // The element has a single explicit child, which might still be an arbitrary
    // expression like an array. We should emit that expression as the children.
    var OneChild = NoChildren + 1;
    JSXRole[JSXRole["OneChild"] = OneChild] = "OneChild";
    // The element has at least two explicitly-specified children or has spread
    // children, so child positions are assumed to be "static". We should wrap
    // these children in an array.
    var StaticChildren = OneChild + 1;
    JSXRole[JSXRole["StaticChildren"] = StaticChildren] = "StaticChildren";
    // The element has a prop named "key" after a prop spread, so we should fall
    // back to the createElement function.
    var KeyAfterPropSpread = StaticChildren + 1;
    JSXRole[JSXRole["KeyAfterPropSpread"] = KeyAfterPropSpread] = "KeyAfterPropSpread";
})($e2df986cc8bbbda9$export$4620c92ad8b511d9 || ($e2df986cc8bbbda9$export$4620c92ad8b511d9 = {}));
function $e2df986cc8bbbda9$export$31dc9881735f7118(token) {
    var role = token.identifierRole;
    return role === $e2df986cc8bbbda9$export$99f888ada3c99de3.TopLevelDeclaration || role === $e2df986cc8bbbda9$export$99f888ada3c99de3.FunctionScopedDeclaration || role === $e2df986cc8bbbda9$export$99f888ada3c99de3.BlockScopedDeclaration || role === $e2df986cc8bbbda9$export$99f888ada3c99de3.ObjectShorthandTopLevelDeclaration || role === $e2df986cc8bbbda9$export$99f888ada3c99de3.ObjectShorthandFunctionScopedDeclaration || role === $e2df986cc8bbbda9$export$99f888ada3c99de3.ObjectShorthandBlockScopedDeclaration;
}
function $e2df986cc8bbbda9$export$268f8ae8b035d918(token) {
    var role = token.identifierRole;
    return role === $e2df986cc8bbbda9$export$99f888ada3c99de3.FunctionScopedDeclaration || role === $e2df986cc8bbbda9$export$99f888ada3c99de3.BlockScopedDeclaration || role === $e2df986cc8bbbda9$export$99f888ada3c99de3.ObjectShorthandFunctionScopedDeclaration || role === $e2df986cc8bbbda9$export$99f888ada3c99de3.ObjectShorthandBlockScopedDeclaration;
}
function $e2df986cc8bbbda9$export$c08b4dec8c3c03d(token) {
    var role = token.identifierRole;
    return role === $e2df986cc8bbbda9$export$99f888ada3c99de3.TopLevelDeclaration || role === $e2df986cc8bbbda9$export$99f888ada3c99de3.ObjectShorthandTopLevelDeclaration || role === $e2df986cc8bbbda9$export$99f888ada3c99de3.ImportDeclaration;
}
function $e2df986cc8bbbda9$export$6aae06a56367d123(token) {
    var role = token.identifierRole;
    // Treat top-level declarations as block scope since the distinction doesn't matter here.
    return role === $e2df986cc8bbbda9$export$99f888ada3c99de3.TopLevelDeclaration || role === $e2df986cc8bbbda9$export$99f888ada3c99de3.BlockScopedDeclaration || role === $e2df986cc8bbbda9$export$99f888ada3c99de3.ObjectShorthandTopLevelDeclaration || role === $e2df986cc8bbbda9$export$99f888ada3c99de3.ObjectShorthandBlockScopedDeclaration;
}
function $e2df986cc8bbbda9$export$157aa1605fc4e080(token) {
    var role = token.identifierRole;
    return role === $e2df986cc8bbbda9$export$99f888ada3c99de3.FunctionScopedDeclaration || role === $e2df986cc8bbbda9$export$99f888ada3c99de3.ObjectShorthandFunctionScopedDeclaration;
}
function $e2df986cc8bbbda9$export$dea1d79574e9c731(token) {
    return token.identifierRole === $e2df986cc8bbbda9$export$99f888ada3c99de3.ObjectShorthandTopLevelDeclaration || token.identifierRole === $e2df986cc8bbbda9$export$99f888ada3c99de3.ObjectShorthandBlockScopedDeclaration || token.identifierRole === $e2df986cc8bbbda9$export$99f888ada3c99de3.ObjectShorthandFunctionScopedDeclaration;
}
var $e2df986cc8bbbda9$export$50792b0e93539fde = function Token() {
    "use strict";
    (0, $173N4._)(this, Token);
    this.type = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type;
    this.contextualKeyword = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).contextualKeyword;
    this.start = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).start;
    this.end = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).end;
    this.scopeDepth = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth;
    this.isType = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).isType;
    this.identifierRole = null;
    this.jsxRole = null;
    this.shadowsGlobal = false;
    this.isAsyncOperation = false;
    this.contextId = null;
    this.rhsEndIndex = null;
    this.isExpression = false;
    this.numNullishCoalesceStarts = 0;
    this.numNullishCoalesceEnds = 0;
    this.isOptionalChainStart = false;
    this.isOptionalChainEnd = false;
    this.subscriptStartIndex = null;
    this.nullishStartIndex = null;
};
function $e2df986cc8bbbda9$export$48cfd1e771a65c4f() {
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.push(new $e2df986cc8bbbda9$export$50792b0e93539fde());
    $e2df986cc8bbbda9$export$be17f8ab6696df13();
}
function $e2df986cc8bbbda9$export$e4355ff2fab571ee() {
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.push(new $e2df986cc8bbbda9$export$50792b0e93539fde());
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).start = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
    $e2df986cc8bbbda9$var$readTmplToken();
}
function $e2df986cc8bbbda9$export$f6864f1ed2347988() {
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).assign) --(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
    $e2df986cc8bbbda9$var$readRegexp();
}
function $e2df986cc8bbbda9$export$218282073d8f0a8b(existingTokensInType) {
    for(var i = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - existingTokensInType; i < (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length; i++)(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[i].isType = true;
    var oldIsType = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).isType;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).isType = true;
    return oldIsType;
}
function $e2df986cc8bbbda9$export$89977347ddb984a8(oldIsType) {
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).isType = oldIsType;
}
function $e2df986cc8bbbda9$export$3106cdec37e36f77(type) {
    if ($e2df986cc8bbbda9$export$4659b591c19bdf3d(type)) {
        $e2df986cc8bbbda9$export$48cfd1e771a65c4f();
        return true;
    } else return false;
}
function $e2df986cc8bbbda9$export$cb3e65614411a57c(tokenType) {
    var oldIsType = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).isType;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).isType = true;
    $e2df986cc8bbbda9$export$3106cdec37e36f77(tokenType);
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).isType = oldIsType;
}
function $e2df986cc8bbbda9$export$4659b591c19bdf3d(type) {
    return (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type === type;
}
function $e2df986cc8bbbda9$export$d2a09c60d66edd78() {
    var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
    $e2df986cc8bbbda9$export$48cfd1e771a65c4f();
    var type = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return type;
}
var $e2df986cc8bbbda9$export$1df511c75b9e0d8b = function TypeAndKeyword(type, contextualKeyword) {
    "use strict";
    (0, $173N4._)(this, TypeAndKeyword);
    this.type = type;
    this.contextualKeyword = contextualKeyword;
};
function $e2df986cc8bbbda9$export$ef1b94c514fc060a() {
    var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
    $e2df986cc8bbbda9$export$48cfd1e771a65c4f();
    var type = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type;
    var contextualKeyword = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).contextualKeyword;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return new $e2df986cc8bbbda9$export$1df511c75b9e0d8b(type, contextualKeyword);
}
function $e2df986cc8bbbda9$export$1678d89ce52f4a6() {
    return $e2df986cc8bbbda9$export$b8d8ba48247ea123((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos);
}
function $e2df986cc8bbbda9$export$b8d8ba48247ea123(pos) {
    (0, $6b4b576bbcb1fdb0$export$4856bde7911f0623).lastIndex = pos;
    var skip = (0, $6b4b576bbcb1fdb0$export$4856bde7911f0623).exec((0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e));
    return pos + skip[0].length;
}
function $e2df986cc8bbbda9$export$847169391b2516b8() {
    return (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt($e2df986cc8bbbda9$export$1678d89ce52f4a6());
}
function $e2df986cc8bbbda9$export$be17f8ab6696df13() {
    $e2df986cc8bbbda9$export$b240c79c2d18160();
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).start = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos >= (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).length) {
        var tokens = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens;
        // We normally run past the end a bit, but if we're way past the end, avoid an infinite loop.
        // Also check the token positions rather than the types since sometimes we rewrite the token
        // type to something else.
        if (tokens.length >= 2 && tokens[tokens.length - 1].start >= (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).length && tokens[tokens.length - 2].start >= (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).length) (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)("Unexpectedly reached the end of input.");
        $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).eof);
        return;
    }
    $e2df986cc8bbbda9$var$readToken((0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos));
}
function $e2df986cc8bbbda9$var$readToken(code) {
    // Identifier or keyword. '\uXXXX' sequences are allowed in
    // identifiers, so '\' also dispatches to that.
    if ((0, $c0e0280b0658a40b$export$dc1d1d7d9fdffb8)[code] || code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).backslash || code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).atSign && (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 1) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).atSign) (0, $2a792a0a209052a3$export$2e2bcd8739ae039)();
    else $e2df986cc8bbbda9$export$e0ebb9fd4c2c4701(code);
}
function $e2df986cc8bbbda9$var$skipBlockComment() {
    while((0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos) !== (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).asterisk || (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 1) !== (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).slash){
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos++;
        if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos > (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).length) {
            (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)("Unterminated comment", (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos - 2);
            return;
        }
    }
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos += 2;
}
function $e2df986cc8bbbda9$export$37e131e7c1112aff(startSkip) {
    var ch = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos += startSkip);
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos < (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).length) while(ch !== (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lineFeed && ch !== (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).carriageReturn && ch !== (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lineSeparator && ch !== (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).paragraphSeparator && ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos < (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).length)ch = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos);
}
function $e2df986cc8bbbda9$export$b240c79c2d18160() {
    while((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos < (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).length){
        var ch = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos);
        switch(ch){
            case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).carriageReturn:
                if ((0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 1) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lineFeed) ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
            case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lineFeed:
            case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lineSeparator:
            case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).paragraphSeparator:
                ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
                break;
            case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).slash:
                switch((0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 1)){
                    case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).asterisk:
                        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos += 2;
                        $e2df986cc8bbbda9$var$skipBlockComment();
                        break;
                    case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).slash:
                        $e2df986cc8bbbda9$export$37e131e7c1112aff(2);
                        break;
                    default:
                        return;
                }
                break;
            default:
                if ((0, $6b4b576bbcb1fdb0$export$4347b22d2e0ca480)[ch]) ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
                else return;
        }
    }
}
function $e2df986cc8bbbda9$export$58122cd1933ef607(type) {
    var contextualKeyword = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc).NONE;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).end = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type = type;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).contextualKeyword = contextualKeyword;
}
// ### Token reading
// This is the function that is called to fetch the next token. It
// is somewhat obscure, because it works in character codes rather
// than characters, and because operator parsing has been inlined
// into it.
//
// All in the name of speed.
function $e2df986cc8bbbda9$var$readToken_dot() {
    var nextChar = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 1);
    if (nextChar >= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit0 && nextChar <= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit9) {
        $e2df986cc8bbbda9$var$readNumber(true);
        return;
    }
    if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).dot && (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 2) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).dot) {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos += 3;
        $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).ellipsis);
    } else {
        ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
        $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).dot);
    }
}
function $e2df986cc8bbbda9$var$readToken_slash() {
    var nextChar = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).equalsTo) $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).assign, 2);
    else $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).slash, 1);
}
function $e2df986cc8bbbda9$var$readToken_mult_modulo(code) {
    // '%*'
    var tokenType = code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).asterisk ? (0, $30a0d13de21d779e$export$f435f793048e7a0f).star : (0, $30a0d13de21d779e$export$f435f793048e7a0f).modulo;
    var width = 1;
    var nextChar = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 1);
    // Exponentiation operator **
    if (code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).asterisk && nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).asterisk) {
        width++;
        nextChar = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 2);
        tokenType = (0, $30a0d13de21d779e$export$f435f793048e7a0f).exponent;
    }
    // Match *= or %=, disallowing *=> which can be valid in flow.
    if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).equalsTo && (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 2) !== (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).greaterThan) {
        width++;
        tokenType = (0, $30a0d13de21d779e$export$f435f793048e7a0f).assign;
    }
    $e2df986cc8bbbda9$var$finishOp(tokenType, width);
}
function $e2df986cc8bbbda9$var$readToken_pipe_amp(code) {
    // '|&'
    var nextChar = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === code) {
        if ((0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 2) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).equalsTo) // ||= or &&=
        $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).assign, 3);
        else // || or &&
        $e2df986cc8bbbda9$var$finishOp(code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).verticalBar ? (0, $30a0d13de21d779e$export$f435f793048e7a0f).logicalOR : (0, $30a0d13de21d779e$export$f435f793048e7a0f).logicalAND, 2);
        return;
    }
    if (code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).verticalBar) {
        // '|>'
        if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).greaterThan) {
            $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).pipeline, 2);
            return;
        } else if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).rightCurlyBrace && (0, $875661fa68d3a4de$export$92e334f8fe49aa94)) {
            // '|}'
            $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceBarR, 2);
            return;
        }
    }
    if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).equalsTo) {
        $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).assign, 2);
        return;
    }
    $e2df986cc8bbbda9$var$finishOp(code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).verticalBar ? (0, $30a0d13de21d779e$export$f435f793048e7a0f).bitwiseOR : (0, $30a0d13de21d779e$export$f435f793048e7a0f).bitwiseAND, 1);
}
function $e2df986cc8bbbda9$var$readToken_caret() {
    // '^'
    var nextChar = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).equalsTo) $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).assign, 2);
    else $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).bitwiseXOR, 1);
}
function $e2df986cc8bbbda9$var$readToken_plus_min(code) {
    // '+-'
    var nextChar = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === code) {
        // Tentatively call this a prefix operator, but it might be changed to postfix later.
        $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).preIncDec, 2);
        return;
    }
    if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).equalsTo) $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).assign, 2);
    else if (code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).plusSign) $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).plus, 1);
    else $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).minus, 1);
}
function $e2df986cc8bbbda9$var$readToken_lt() {
    var nextChar = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lessThan) {
        if ((0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 2) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).equalsTo) {
            $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).assign, 3);
            return;
        }
        // We see <<, but need to be really careful about whether to treat it as a
        // true left-shift or as two < tokens.
        if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).isType) // Within a type, << might come up in a snippet like `Array<<T>() => void>`,
        // so treat it as two < tokens. Importantly, this should only override <<
        // rather than other tokens like <= . If we treated <= as < in a type
        // context, then the snippet `a as T <= 1` would incorrectly start parsing
        // a type argument on T. We don't need to worry about `a as T << 1`
        // because TypeScript disallows that syntax.
        $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan, 1);
        else // Outside a type, this might be a true left-shift operator, or it might
        // still be two open-type-arg tokens, such as in `f<<T>() => void>()`. We
        // look at the token while considering the `f`, so we don't yet know that
        // we're in a type context. In this case, we initially tokenize as a
        // left-shift and correct after-the-fact as necessary in
        // tsParseTypeArgumentsWithPossibleBitshift .
        $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).bitShiftL, 2);
        return;
    }
    if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).equalsTo) // <=
    $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).relationalOrEqual, 2);
    else $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan, 1);
}
function $e2df986cc8bbbda9$var$readToken_gt() {
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).isType) {
        // Avoid right-shift for things like `Array<Array<string>>` and
        // greater-than-or-equal for things like `const a: Array<number>=[];`.
        $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).greaterThan, 1);
        return;
    }
    var nextChar = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).greaterThan) {
        var size = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 2) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).greaterThan ? 3 : 2;
        if ((0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + size) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).equalsTo) {
            $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).assign, size + 1);
            return;
        }
        $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).bitShiftR, size);
        return;
    }
    if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).equalsTo) // >=
    $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).relationalOrEqual, 2);
    else $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).greaterThan, 1);
}
function $e2df986cc8bbbda9$export$4d00b4f4d9d7a9b3() {
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).greaterThan) {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos -= 1;
        $e2df986cc8bbbda9$var$readToken_gt();
    }
}
function $e2df986cc8bbbda9$var$readToken_eq_excl(code) {
    // '=!'
    var nextChar = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).equalsTo) {
        $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).equality, (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 2) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).equalsTo ? 3 : 2);
        return;
    }
    if (code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).equalsTo && nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).greaterThan) {
        // '=>'
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos += 2;
        $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).arrow);
        return;
    }
    $e2df986cc8bbbda9$var$finishOp(code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).equalsTo ? (0, $30a0d13de21d779e$export$f435f793048e7a0f).eq : (0, $30a0d13de21d779e$export$f435f793048e7a0f).bang, 1);
}
function $e2df986cc8bbbda9$var$readToken_question() {
    // '?'
    var nextChar = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 1);
    var nextChar2 = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 2);
    if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).questionMark && // In Flow (but not TypeScript), ??string is a valid type that should be
    // tokenized as two individual ? tokens.
    !((0, $875661fa68d3a4de$export$92e334f8fe49aa94) && (0, $875661fa68d3a4de$export$ca000e230c0caa3e).isType)) {
        if (nextChar2 === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).equalsTo) // '??='
        $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).assign, 3);
        else // '??'
        $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).nullishCoalescing, 2);
    } else if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).dot && !(nextChar2 >= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit0 && nextChar2 <= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit9)) {
        // '.' not followed by a number
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos += 2;
        $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).questionDot);
    } else {
        ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
        $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).question);
    }
}
function $e2df986cc8bbbda9$export$e0ebb9fd4c2c4701(code) {
    switch(code){
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).numberSign:
            ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
            $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).hash);
            return;
        // The interpretation of a dot depends on whether it is followed
        // by a digit or another two dots.
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).dot:
            $e2df986cc8bbbda9$var$readToken_dot();
            return;
        // Punctuation tokens.
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).leftParenthesis:
            ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
            $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL);
            return;
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).rightParenthesis:
            ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
            $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
            return;
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).semicolon:
            ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
            $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).semi);
            return;
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).comma:
            ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
            $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
            return;
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).leftSquareBracket:
            ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
            $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL);
            return;
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).rightSquareBracket:
            ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
            $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR);
            return;
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).leftCurlyBrace:
            if ((0, $875661fa68d3a4de$export$92e334f8fe49aa94) && (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 1) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).verticalBar) $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceBarL, 2);
            else {
                ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
                $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
            }
            return;
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).rightCurlyBrace:
            ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
            $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR);
            return;
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).colon:
            if ((0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 1) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).colon) $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).doubleColon, 2);
            else {
                ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
                $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon);
            }
            return;
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).questionMark:
            $e2df986cc8bbbda9$var$readToken_question();
            return;
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).atSign:
            ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
            $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).at);
            return;
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).graveAccent:
            ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
            $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).backQuote);
            return;
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit0:
            {
                var nextChar = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 1);
                // '0x', '0X', '0o', '0O', '0b', '0B'
                if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseX || nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).uppercaseX || nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseO || nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).uppercaseO || nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseB || nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).uppercaseB) {
                    $e2df986cc8bbbda9$var$readRadixNumber();
                    return;
                }
            }
        // Anything else beginning with a digit is an integer, octal
        // number, or float.
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit1:
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit2:
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit3:
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit4:
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit5:
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit6:
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit7:
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit8:
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit9:
            $e2df986cc8bbbda9$var$readNumber(false);
            return;
        // Quotes produce strings.
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).quotationMark:
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).apostrophe:
            $e2df986cc8bbbda9$var$readString(code);
            return;
        // Operators are parsed inline in tiny state machines. '=' (charCodes.equalsTo) is
        // often referred to. `finishOp` simply skips the amount of
        // characters it is given as second argument, and returns a token
        // of the type given by its first argument.
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).slash:
            $e2df986cc8bbbda9$var$readToken_slash();
            return;
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).percentSign:
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).asterisk:
            $e2df986cc8bbbda9$var$readToken_mult_modulo(code);
            return;
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).verticalBar:
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).ampersand:
            $e2df986cc8bbbda9$var$readToken_pipe_amp(code);
            return;
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).caret:
            $e2df986cc8bbbda9$var$readToken_caret();
            return;
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).plusSign:
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).dash:
            $e2df986cc8bbbda9$var$readToken_plus_min(code);
            return;
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lessThan:
            $e2df986cc8bbbda9$var$readToken_lt();
            return;
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).greaterThan:
            $e2df986cc8bbbda9$var$readToken_gt();
            return;
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).equalsTo:
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).exclamationMark:
            $e2df986cc8bbbda9$var$readToken_eq_excl(code);
            return;
        case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).tilde:
            $e2df986cc8bbbda9$var$finishOp((0, $30a0d13de21d779e$export$f435f793048e7a0f).tilde, 1);
            return;
        default:
            break;
    }
    (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)("Unexpected character '".concat(String.fromCharCode(code), "'"), (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos);
}
function $e2df986cc8bbbda9$var$finishOp(type, size) {
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos += size;
    $e2df986cc8bbbda9$export$58122cd1933ef607(type);
}
function $e2df986cc8bbbda9$var$readRegexp() {
    var start = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
    var escaped = false;
    var inClass = false;
    for(;;){
        if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos >= (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).length) {
            (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)("Unterminated regular expression", start);
            return;
        }
        var code = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos);
        if (escaped) escaped = false;
        else {
            if (code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).leftSquareBracket) inClass = true;
            else if (code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).rightSquareBracket && inClass) inClass = false;
            else if (code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).slash && !inClass) break;
            escaped = code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).backslash;
        }
        ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
    }
    ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
    // Need to use `skipWord` because '\uXXXX' sequences are allowed here (don't ask).
    $e2df986cc8bbbda9$export$abcfffe72e6e8184();
    $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).regexp);
}
/**
 * Read a decimal integer. Note that this can't be unified with the similar code
 * in readRadixNumber (which also handles hex digits) because "e" needs to be
 * the end of the integer so that we can properly handle scientific notation.
 */ function $e2df986cc8bbbda9$var$readInt() {
    while(true){
        var code = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos);
        if (code >= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit0 && code <= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit9 || code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).underscore) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos++;
        else break;
    }
}
function $e2df986cc8bbbda9$var$readRadixNumber() {
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos += 2; // 0x
    // Walk to the end of the number, allowing hex digits.
    while(true){
        var code = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos);
        if (code >= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit0 && code <= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit9 || code >= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseA && code <= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseF || code >= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).uppercaseA && code <= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).uppercaseF || code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).underscore) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos++;
        else break;
    }
    var nextChar = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos);
    if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseN) {
        ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
        $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).bigint);
    } else $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).num);
}
// Read an integer, octal integer, or floating-point number.
function $e2df986cc8bbbda9$var$readNumber(startsWithDot) {
    var isBigInt = false;
    var isDecimal = false;
    if (!startsWithDot) $e2df986cc8bbbda9$var$readInt();
    var nextChar = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos);
    if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).dot) {
        ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
        $e2df986cc8bbbda9$var$readInt();
        nextChar = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos);
    }
    if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).uppercaseE || nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseE) {
        nextChar = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt(++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos);
        if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).plusSign || nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).dash) ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
        $e2df986cc8bbbda9$var$readInt();
        nextChar = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos);
    }
    if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseN) {
        ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
        isBigInt = true;
    } else if (nextChar === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseM) {
        ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
        isDecimal = true;
    }
    if (isBigInt) {
        $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).bigint);
        return;
    }
    if (isDecimal) {
        $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).decimal);
        return;
    }
    $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).num);
}
function $e2df986cc8bbbda9$var$readString(quote) {
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos++;
    for(;;){
        if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos >= (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).length) {
            (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)("Unterminated string constant");
            return;
        }
        var ch = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos);
        if (ch === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).backslash) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos++;
        else if (ch === quote) break;
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos++;
    }
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos++;
    $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).string);
}
// Reads template string tokens.
function $e2df986cc8bbbda9$var$readTmplToken() {
    for(;;){
        if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos >= (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).length) {
            (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)("Unterminated template");
            return;
        }
        var ch = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos);
        if (ch === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).graveAccent || ch === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).dollarSign && (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos + 1) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).leftCurlyBrace) {
            if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos === (0, $875661fa68d3a4de$export$ca000e230c0caa3e).start && $e2df986cc8bbbda9$export$4659b591c19bdf3d((0, $30a0d13de21d779e$export$f435f793048e7a0f).template)) {
                if (ch === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).dollarSign) {
                    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos += 2;
                    $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).dollarBraceL);
                    return;
                } else {
                    ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
                    $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).backQuote);
                    return;
                }
            }
            $e2df986cc8bbbda9$export$58122cd1933ef607((0, $30a0d13de21d779e$export$f435f793048e7a0f).template);
            return;
        }
        if (ch === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).backslash) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos++;
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos++;
    }
}
function $e2df986cc8bbbda9$export$abcfffe72e6e8184() {
    while((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos < (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).length){
        var ch = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos);
        if ((0, $c0e0280b0658a40b$export$d19df39e3926cfef)[ch]) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos++;
        else if (ch === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).backslash) {
            // \u
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos += 2;
            if ((0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).leftCurlyBrace) {
                while((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos < (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).length && (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos) !== (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).rightCurlyBrace)(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos++;
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos++;
            }
        } else break;
    }
}





function $60f9e6aa148c791b$export$2e2bcd8739ae039(tokens) {
    var index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : tokens.currentIndex();
    var endIndex = index + 1;
    if ($60f9e6aa148c791b$var$isSpecifierEnd(tokens, endIndex)) {
        // import {A}
        var name = tokens.identifierNameAtIndex(index);
        return {
            isType: false,
            leftName: name,
            rightName: name,
            endIndex: endIndex
        };
    }
    endIndex++;
    if ($60f9e6aa148c791b$var$isSpecifierEnd(tokens, endIndex)) // import {type A}
    return {
        isType: true,
        leftName: null,
        rightName: null,
        endIndex: endIndex
    };
    endIndex++;
    if ($60f9e6aa148c791b$var$isSpecifierEnd(tokens, endIndex)) // import {A as B}
    return {
        isType: false,
        leftName: tokens.identifierNameAtIndex(index),
        rightName: tokens.identifierNameAtIndex(index + 2),
        endIndex: endIndex
    };
    endIndex++;
    if ($60f9e6aa148c791b$var$isSpecifierEnd(tokens, endIndex)) // import {type A as B}
    return {
        isType: true,
        leftName: null,
        rightName: null,
        endIndex: endIndex
    };
    throw new Error("Unexpected import/export specifier at ".concat(index));
}
function $60f9e6aa148c791b$var$isSpecifierEnd(tokens, index) {
    var token = tokens.tokens[index];
    return token.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR || token.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).comma;
}





var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");
// Use a Map rather than object to avoid unexpected __proto__ access.
var $e60312112908d881$export$2e2bcd8739ae039 = new Map([
    [
        "quot",
        "\u0022"
    ],
    [
        "amp",
        "&"
    ],
    [
        "apos",
        "\u0027"
    ],
    [
        "lt",
        "<"
    ],
    [
        "gt",
        ">"
    ],
    [
        "nbsp",
        "\u00A0"
    ],
    [
        "iexcl",
        "\u00A1"
    ],
    [
        "cent",
        "\u00A2"
    ],
    [
        "pound",
        "\u00A3"
    ],
    [
        "curren",
        "\u00A4"
    ],
    [
        "yen",
        "\u00A5"
    ],
    [
        "brvbar",
        "\u00A6"
    ],
    [
        "sect",
        "\u00A7"
    ],
    [
        "uml",
        "\u00A8"
    ],
    [
        "copy",
        "\u00A9"
    ],
    [
        "ordf",
        "\u00AA"
    ],
    [
        "laquo",
        "\u00AB"
    ],
    [
        "not",
        "\u00AC"
    ],
    [
        "shy",
        "\u00AD"
    ],
    [
        "reg",
        "\u00AE"
    ],
    [
        "macr",
        "\u00AF"
    ],
    [
        "deg",
        "\u00B0"
    ],
    [
        "plusmn",
        "\u00B1"
    ],
    [
        "sup2",
        "\u00B2"
    ],
    [
        "sup3",
        "\u00B3"
    ],
    [
        "acute",
        "\u00B4"
    ],
    [
        "micro",
        "\u00B5"
    ],
    [
        "para",
        "\u00B6"
    ],
    [
        "middot",
        "\u00B7"
    ],
    [
        "cedil",
        "\u00B8"
    ],
    [
        "sup1",
        "\u00B9"
    ],
    [
        "ordm",
        "\u00BA"
    ],
    [
        "raquo",
        "\u00BB"
    ],
    [
        "frac14",
        "\u00BC"
    ],
    [
        "frac12",
        "\u00BD"
    ],
    [
        "frac34",
        "\u00BE"
    ],
    [
        "iquest",
        "\u00BF"
    ],
    [
        "Agrave",
        "\u00C0"
    ],
    [
        "Aacute",
        "\u00C1"
    ],
    [
        "Acirc",
        "\u00C2"
    ],
    [
        "Atilde",
        "\u00C3"
    ],
    [
        "Auml",
        "\u00C4"
    ],
    [
        "Aring",
        "\u00C5"
    ],
    [
        "AElig",
        "\u00C6"
    ],
    [
        "Ccedil",
        "\u00C7"
    ],
    [
        "Egrave",
        "\u00C8"
    ],
    [
        "Eacute",
        "\u00C9"
    ],
    [
        "Ecirc",
        "\u00CA"
    ],
    [
        "Euml",
        "\u00CB"
    ],
    [
        "Igrave",
        "\u00CC"
    ],
    [
        "Iacute",
        "\u00CD"
    ],
    [
        "Icirc",
        "\u00CE"
    ],
    [
        "Iuml",
        "\u00CF"
    ],
    [
        "ETH",
        "\u00D0"
    ],
    [
        "Ntilde",
        "\u00D1"
    ],
    [
        "Ograve",
        "\u00D2"
    ],
    [
        "Oacute",
        "\u00D3"
    ],
    [
        "Ocirc",
        "\u00D4"
    ],
    [
        "Otilde",
        "\u00D5"
    ],
    [
        "Ouml",
        "\u00D6"
    ],
    [
        "times",
        "\u00D7"
    ],
    [
        "Oslash",
        "\u00D8"
    ],
    [
        "Ugrave",
        "\u00D9"
    ],
    [
        "Uacute",
        "\u00DA"
    ],
    [
        "Ucirc",
        "\u00DB"
    ],
    [
        "Uuml",
        "\u00DC"
    ],
    [
        "Yacute",
        "\u00DD"
    ],
    [
        "THORN",
        "\u00DE"
    ],
    [
        "szlig",
        "\u00DF"
    ],
    [
        "agrave",
        "\u00E0"
    ],
    [
        "aacute",
        "\u00E1"
    ],
    [
        "acirc",
        "\u00E2"
    ],
    [
        "atilde",
        "\u00E3"
    ],
    [
        "auml",
        "\u00E4"
    ],
    [
        "aring",
        "\u00E5"
    ],
    [
        "aelig",
        "\u00E6"
    ],
    [
        "ccedil",
        "\u00E7"
    ],
    [
        "egrave",
        "\u00E8"
    ],
    [
        "eacute",
        "\u00E9"
    ],
    [
        "ecirc",
        "\u00EA"
    ],
    [
        "euml",
        "\u00EB"
    ],
    [
        "igrave",
        "\u00EC"
    ],
    [
        "iacute",
        "\u00ED"
    ],
    [
        "icirc",
        "\u00EE"
    ],
    [
        "iuml",
        "\u00EF"
    ],
    [
        "eth",
        "\u00F0"
    ],
    [
        "ntilde",
        "\u00F1"
    ],
    [
        "ograve",
        "\u00F2"
    ],
    [
        "oacute",
        "\u00F3"
    ],
    [
        "ocirc",
        "\u00F4"
    ],
    [
        "otilde",
        "\u00F5"
    ],
    [
        "ouml",
        "\u00F6"
    ],
    [
        "divide",
        "\u00F7"
    ],
    [
        "oslash",
        "\u00F8"
    ],
    [
        "ugrave",
        "\u00F9"
    ],
    [
        "uacute",
        "\u00FA"
    ],
    [
        "ucirc",
        "\u00FB"
    ],
    [
        "uuml",
        "\u00FC"
    ],
    [
        "yacute",
        "\u00FD"
    ],
    [
        "thorn",
        "\u00FE"
    ],
    [
        "yuml",
        "\u00FF"
    ],
    [
        "OElig",
        "\u0152"
    ],
    [
        "oelig",
        "\u0153"
    ],
    [
        "Scaron",
        "\u0160"
    ],
    [
        "scaron",
        "\u0161"
    ],
    [
        "Yuml",
        "\u0178"
    ],
    [
        "fnof",
        "\u0192"
    ],
    [
        "circ",
        "\u02C6"
    ],
    [
        "tilde",
        "\u02DC"
    ],
    [
        "Alpha",
        "\u0391"
    ],
    [
        "Beta",
        "\u0392"
    ],
    [
        "Gamma",
        "\u0393"
    ],
    [
        "Delta",
        "\u0394"
    ],
    [
        "Epsilon",
        "\u0395"
    ],
    [
        "Zeta",
        "\u0396"
    ],
    [
        "Eta",
        "\u0397"
    ],
    [
        "Theta",
        "\u0398"
    ],
    [
        "Iota",
        "\u0399"
    ],
    [
        "Kappa",
        "\u039A"
    ],
    [
        "Lambda",
        "\u039B"
    ],
    [
        "Mu",
        "\u039C"
    ],
    [
        "Nu",
        "\u039D"
    ],
    [
        "Xi",
        "\u039E"
    ],
    [
        "Omicron",
        "\u039F"
    ],
    [
        "Pi",
        "\u03A0"
    ],
    [
        "Rho",
        "\u03A1"
    ],
    [
        "Sigma",
        "\u03A3"
    ],
    [
        "Tau",
        "\u03A4"
    ],
    [
        "Upsilon",
        "\u03A5"
    ],
    [
        "Phi",
        "\u03A6"
    ],
    [
        "Chi",
        "\u03A7"
    ],
    [
        "Psi",
        "\u03A8"
    ],
    [
        "Omega",
        "\u03A9"
    ],
    [
        "alpha",
        "\u03B1"
    ],
    [
        "beta",
        "\u03B2"
    ],
    [
        "gamma",
        "\u03B3"
    ],
    [
        "delta",
        "\u03B4"
    ],
    [
        "epsilon",
        "\u03B5"
    ],
    [
        "zeta",
        "\u03B6"
    ],
    [
        "eta",
        "\u03B7"
    ],
    [
        "theta",
        "\u03B8"
    ],
    [
        "iota",
        "\u03B9"
    ],
    [
        "kappa",
        "\u03BA"
    ],
    [
        "lambda",
        "\u03BB"
    ],
    [
        "mu",
        "\u03BC"
    ],
    [
        "nu",
        "\u03BD"
    ],
    [
        "xi",
        "\u03BE"
    ],
    [
        "omicron",
        "\u03BF"
    ],
    [
        "pi",
        "\u03C0"
    ],
    [
        "rho",
        "\u03C1"
    ],
    [
        "sigmaf",
        "\u03C2"
    ],
    [
        "sigma",
        "\u03C3"
    ],
    [
        "tau",
        "\u03C4"
    ],
    [
        "upsilon",
        "\u03C5"
    ],
    [
        "phi",
        "\u03C6"
    ],
    [
        "chi",
        "\u03C7"
    ],
    [
        "psi",
        "\u03C8"
    ],
    [
        "omega",
        "\u03C9"
    ],
    [
        "thetasym",
        "\u03D1"
    ],
    [
        "upsih",
        "\u03D2"
    ],
    [
        "piv",
        "\u03D6"
    ],
    [
        "ensp",
        "\u2002"
    ],
    [
        "emsp",
        "\u2003"
    ],
    [
        "thinsp",
        "\u2009"
    ],
    [
        "zwnj",
        "\u200C"
    ],
    [
        "zwj",
        "\u200D"
    ],
    [
        "lrm",
        "\u200E"
    ],
    [
        "rlm",
        "\u200F"
    ],
    [
        "ndash",
        "\u2013"
    ],
    [
        "mdash",
        "\u2014"
    ],
    [
        "lsquo",
        "\u2018"
    ],
    [
        "rsquo",
        "\u2019"
    ],
    [
        "sbquo",
        "\u201A"
    ],
    [
        "ldquo",
        "\u201C"
    ],
    [
        "rdquo",
        "\u201D"
    ],
    [
        "bdquo",
        "\u201E"
    ],
    [
        "dagger",
        "\u2020"
    ],
    [
        "Dagger",
        "\u2021"
    ],
    [
        "bull",
        "\u2022"
    ],
    [
        "hellip",
        "\u2026"
    ],
    [
        "permil",
        "\u2030"
    ],
    [
        "prime",
        "\u2032"
    ],
    [
        "Prime",
        "\u2033"
    ],
    [
        "lsaquo",
        "\u2039"
    ],
    [
        "rsaquo",
        "\u203A"
    ],
    [
        "oline",
        "\u203E"
    ],
    [
        "frasl",
        "\u2044"
    ],
    [
        "euro",
        "\u20AC"
    ],
    [
        "image",
        "\u2111"
    ],
    [
        "weierp",
        "\u2118"
    ],
    [
        "real",
        "\u211C"
    ],
    [
        "trade",
        "\u2122"
    ],
    [
        "alefsym",
        "\u2135"
    ],
    [
        "larr",
        "\u2190"
    ],
    [
        "uarr",
        "\u2191"
    ],
    [
        "rarr",
        "\u2192"
    ],
    [
        "darr",
        "\u2193"
    ],
    [
        "harr",
        "\u2194"
    ],
    [
        "crarr",
        "\u21B5"
    ],
    [
        "lArr",
        "\u21D0"
    ],
    [
        "uArr",
        "\u21D1"
    ],
    [
        "rArr",
        "\u21D2"
    ],
    [
        "dArr",
        "\u21D3"
    ],
    [
        "hArr",
        "\u21D4"
    ],
    [
        "forall",
        "\u2200"
    ],
    [
        "part",
        "\u2202"
    ],
    [
        "exist",
        "\u2203"
    ],
    [
        "empty",
        "\u2205"
    ],
    [
        "nabla",
        "\u2207"
    ],
    [
        "isin",
        "\u2208"
    ],
    [
        "notin",
        "\u2209"
    ],
    [
        "ni",
        "\u220B"
    ],
    [
        "prod",
        "\u220F"
    ],
    [
        "sum",
        "\u2211"
    ],
    [
        "minus",
        "\u2212"
    ],
    [
        "lowast",
        "\u2217"
    ],
    [
        "radic",
        "\u221A"
    ],
    [
        "prop",
        "\u221D"
    ],
    [
        "infin",
        "\u221E"
    ],
    [
        "ang",
        "\u2220"
    ],
    [
        "and",
        "\u2227"
    ],
    [
        "or",
        "\u2228"
    ],
    [
        "cap",
        "\u2229"
    ],
    [
        "cup",
        "\u222A"
    ],
    [
        "int",
        "\u222B"
    ],
    [
        "there4",
        "\u2234"
    ],
    [
        "sim",
        "\u223C"
    ],
    [
        "cong",
        "\u2245"
    ],
    [
        "asymp",
        "\u2248"
    ],
    [
        "ne",
        "\u2260"
    ],
    [
        "equiv",
        "\u2261"
    ],
    [
        "le",
        "\u2264"
    ],
    [
        "ge",
        "\u2265"
    ],
    [
        "sub",
        "\u2282"
    ],
    [
        "sup",
        "\u2283"
    ],
    [
        "nsub",
        "\u2284"
    ],
    [
        "sube",
        "\u2286"
    ],
    [
        "supe",
        "\u2287"
    ],
    [
        "oplus",
        "\u2295"
    ],
    [
        "otimes",
        "\u2297"
    ],
    [
        "perp",
        "\u22A5"
    ],
    [
        "sdot",
        "\u22C5"
    ],
    [
        "lceil",
        "\u2308"
    ],
    [
        "rceil",
        "\u2309"
    ],
    [
        "lfloor",
        "\u230A"
    ],
    [
        "rfloor",
        "\u230B"
    ],
    [
        "lang",
        "\u2329"
    ],
    [
        "rang",
        "\u232A"
    ],
    [
        "loz",
        "\u25CA"
    ],
    [
        "spades",
        "\u2660"
    ],
    [
        "clubs",
        "\u2663"
    ],
    [
        "hearts",
        "\u2665"
    ],
    [
        "diams",
        "\u2666"
    ]
]);






var $f9AOD = parcelRequire("f9AOD");
function $373ad0219e94492e$export$2e2bcd8739ae039(options) {
    var _splitPragma = (0, $f9AOD._)($373ad0219e94492e$var$splitPragma(options.jsxPragma || "React.createElement"), 2), base = _splitPragma[0], suffix = _splitPragma[1];
    var _splitPragma1 = (0, $f9AOD._)($373ad0219e94492e$var$splitPragma(options.jsxFragmentPragma || "React.Fragment"), 2), fragmentBase = _splitPragma1[0], fragmentSuffix = _splitPragma1[1];
    return {
        base: base,
        suffix: suffix,
        fragmentBase: fragmentBase,
        fragmentSuffix: fragmentSuffix
    };
}
function $373ad0219e94492e$var$splitPragma(pragma) {
    var dotIndex = pragma.indexOf(".");
    if (dotIndex === -1) dotIndex = pragma.length;
    return [
        pragma.slice(0, dotIndex),
        pragma.slice(dotIndex)
    ];
}



var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");
var $8757da14f0d3faf0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Transformer() {
        (0, $173N4._)(this, Transformer);
    }
    (0, $cFHGC._)(Transformer, [
        {
            // Return true if anything was processed, false otherwise.
            key: "getPrefixCode",
            value: function getPrefixCode() {
                return "";
            }
        },
        {
            key: "getHoistedCode",
            value: function getHoistedCode() {
                return "";
            }
        },
        {
            key: "getSuffixCode",
            value: function getSuffixCode() {
                return "";
            }
        }
    ]);
    return Transformer;
}();


var $9619a3b5c46ce6b8$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Transformer) {
    "use strict";
    (0, $hdIku._)(JSXTransformer, Transformer);
    function JSXTransformer(rootTransformer, tokens, importProcessor, nameManager, options) {
        (0, $173N4._)(this, JSXTransformer);
        var _this;
        _this = (0, $7qXGD._)(this, JSXTransformer);
        _this.rootTransformer = rootTransformer;
        _this.tokens = tokens;
        _this.importProcessor = importProcessor;
        _this.nameManager = nameManager;
        _this.options = options;
        JSXTransformer.prototype.__init.call(_this);
        JSXTransformer.prototype.__init2.call(_this);
        JSXTransformer.prototype.__init3.call(_this);
        JSXTransformer.prototype.__init4.call(_this);
        JSXTransformer.prototype.__init5.call(_this);
        _this.jsxPragmaInfo = (0, $373ad0219e94492e$export$2e2bcd8739ae039)(options);
        _this.isAutomaticRuntime = options.jsxRuntime === "automatic";
        _this.jsxImportSource = options.jsxImportSource || "react";
        return _this;
    }
    (0, $cFHGC._)(JSXTransformer, [
        {
            // State for calculating the line number of each JSX tag in development.
            key: "__init",
            value: function __init() {
                this.lastLineNumber = 1;
            }
        },
        {
            key: "__init2",
            value: function __init2() {
                this.lastIndex = 0;
            }
        },
        {
            // In development, variable name holding the name of the current file.
            key: "__init3",
            value: function __init3() {
                this.filenameVarName = null;
            }
        },
        {
            // Mapping of claimed names for imports in the automatic transform, e,g.
            // {jsx: "_jsx"}. This determines which imports to generate in the prefix.
            key: "__init4",
            value: function __init4() {
                this.esmAutomaticImportNameResolutions = {};
            }
        },
        {
            // When automatically adding imports in CJS mode, we store the variable name
            // holding the imported CJS module so we can require it in the prefix.
            key: "__init5",
            value: function __init5() {
                this.cjsAutomaticModuleNameResolutions = {};
            }
        },
        {
            key: "process",
            value: function process() {
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagStart)) {
                    this.processJSXTag();
                    return true;
                }
                return false;
            }
        },
        {
            key: "getPrefixCode",
            value: function getPrefixCode() {
                var prefix = "";
                if (this.filenameVarName) prefix += "const ".concat(this.filenameVarName, " = ").concat(JSON.stringify(this.options.filePath || ""), ";");
                if (this.isAutomaticRuntime) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (this.importProcessor) try {
                        // CJS mode: emit require statements for all modules that were referenced.
                        for(var _iterator = Object.entries(this.cjsAutomaticModuleNameResolutions)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $f9AOD._)(_step.value, 2), path = _step_value[0], resolvedName = _step_value[1];
                            prefix += "var ".concat(resolvedName, ' = require("').concat(path, '");');
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    else {
                        // ESM mode: consolidate and emit import statements for referenced names.
                        var _this_esmAutomaticImportNameResolutions = this.esmAutomaticImportNameResolutions, createElementResolution = _this_esmAutomaticImportNameResolutions.createElement, otherResolutions = (0, $6acIq._)(_this_esmAutomaticImportNameResolutions, [
                            "createElement"
                        ]);
                        if (createElementResolution) prefix += "import {createElement as ".concat(createElementResolution, '} from "').concat(this.jsxImportSource, '";');
                        var importSpecifiers = Object.entries(otherResolutions).map(function(param) {
                            var _param = (0, $f9AOD._)(param, 2), name = _param[0], resolvedName = _param[1];
                            return "".concat(name, " as ").concat(resolvedName);
                        }).join(", ");
                        if (importSpecifiers) {
                            var importPath = this.jsxImportSource + (this.options.production ? "/jsx-runtime" : "/jsx-dev-runtime");
                            prefix += "import {".concat(importSpecifiers, '} from "').concat(importPath, '";');
                        }
                    }
                }
                return prefix;
            }
        },
        {
            key: "processJSXTag",
            value: function processJSXTag() {
                var _this_tokens_currentToken = this.tokens.currentToken(), jsxRole = _this_tokens_currentToken.jsxRole, start = _this_tokens_currentToken.start;
                // Calculate line number information at the very start (if in development
                // mode) so that the information is guaranteed to be queried in token order.
                var elementLocationCode = this.options.production ? null : this.getElementLocationCode(start);
                if (this.isAutomaticRuntime && jsxRole !== (0, $e2df986cc8bbbda9$export$4620c92ad8b511d9).KeyAfterPropSpread) this.transformTagToJSXFunc(elementLocationCode, jsxRole);
                else this.transformTagToCreateElement(elementLocationCode);
            }
        },
        {
            key: "getElementLocationCode",
            value: function getElementLocationCode(firstTokenStart) {
                var lineNumber = this.getLineNumberForIndex(firstTokenStart);
                return "lineNumber: ".concat(lineNumber);
            }
        },
        {
            /**
   * Get the line number for this source position. This is calculated lazily and
   * must be called in increasing order by index.
   */ key: "getLineNumberForIndex",
            value: function getLineNumberForIndex(index) {
                var code = this.tokens.code;
                while(this.lastIndex < index && this.lastIndex < code.length){
                    if (code[this.lastIndex] === "\n") this.lastLineNumber++;
                    this.lastIndex++;
                }
                return this.lastLineNumber;
            }
        },
        {
            /**
   * Convert the current JSX element to a call to jsx, jsxs, or jsxDEV. This is
   * the primary transformation for the automatic transform.
   *
   * Example:
   * <div a={1} key={2}>Hello{x}</div>
   * becomes
   * jsxs('div', {a: 1, children: ["Hello", x]}, 2)
   */ key: "transformTagToJSXFunc",
            value: function transformTagToJSXFunc(elementLocationCode, jsxRole) {
                var isStatic = jsxRole === (0, $e2df986cc8bbbda9$export$4620c92ad8b511d9).StaticChildren;
                // First tag is always jsxTagStart.
                this.tokens.replaceToken(this.getJSXFuncInvocationCode(isStatic));
                var keyCode = null;
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagEnd)) {
                    // Fragment syntax.
                    this.tokens.replaceToken("".concat(this.getFragmentCode(), ", {"));
                    this.processAutomaticChildrenAndEndProps(jsxRole);
                } else {
                    // Normal open tag or self-closing tag.
                    this.processTagIntro();
                    this.tokens.appendCode(", {");
                    keyCode = this.processProps(true);
                    if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f).slash, (0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagEnd)) // Self-closing tag, no children to add, so close the props.
                    this.tokens.appendCode("}");
                    else if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagEnd)) {
                        // Tag with children.
                        this.tokens.removeToken();
                        this.processAutomaticChildrenAndEndProps(jsxRole);
                    } else throw new Error("Expected either /> or > at the end of the tag.");
                    // If a key was present, move it to its own arg. Note that moving code
                    // like this will cause line numbers to get out of sync within the JSX
                    // element if the key expression has a newline in it. This is unfortunate,
                    // but hopefully should be rare.
                    if (keyCode) this.tokens.appendCode(", ".concat(keyCode));
                }
                if (!this.options.production) {
                    // If the key wasn't already added, add it now so we can correctly set
                    // positional args for jsxDEV.
                    if (keyCode === null) this.tokens.appendCode(", void 0");
                    this.tokens.appendCode(", ".concat(isStatic, ", ").concat(this.getDevSource(elementLocationCode), ", this"));
                }
                // We're at the close-tag or the end of a self-closing tag, so remove
                // everything else and close the function call.
                this.tokens.removeInitialToken();
                while(!this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagEnd))this.tokens.removeToken();
                this.tokens.replaceToken(")");
            }
        },
        {
            /**
   * Convert the current JSX element to a createElement call. In the classic
   * runtime, this is the only case. In the automatic runtime, this is called
   * as a fallback in some situations.
   *
   * Example:
   * <div a={1} key={2}>Hello{x}</div>
   * becomes
   * React.createElement('div', {a: 1, key: 2}, "Hello", x)
   */ key: "transformTagToCreateElement",
            value: function transformTagToCreateElement(elementLocationCode) {
                // First tag is always jsxTagStart.
                this.tokens.replaceToken(this.getCreateElementInvocationCode());
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagEnd)) {
                    // Fragment syntax.
                    this.tokens.replaceToken("".concat(this.getFragmentCode(), ", null"));
                    this.processChildren(true);
                } else {
                    // Normal open tag or self-closing tag.
                    this.processTagIntro();
                    this.processPropsObjectWithDevInfo(elementLocationCode);
                    if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f).slash, (0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagEnd)) ;
                    else if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagEnd)) {
                        // Tag with children and a close-tag; process the children as args.
                        this.tokens.removeToken();
                        this.processChildren(true);
                    } else throw new Error("Expected either /> or > at the end of the tag.");
                }
                // We're at the close-tag or the end of a self-closing tag, so remove
                // everything else and close the function call.
                this.tokens.removeInitialToken();
                while(!this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagEnd))this.tokens.removeToken();
                this.tokens.replaceToken(")");
            }
        },
        {
            /**
   * Get the code for the relevant function for this context: jsx, jsxs,
   * or jsxDEV. The following open-paren is included as well.
   *
   * These functions are only used for the automatic runtime, so they are always
   * auto-imported, but the auto-import will be either CJS or ESM based on the
   * target module format.
   */ key: "getJSXFuncInvocationCode",
            value: function getJSXFuncInvocationCode(isStatic) {
                if (this.options.production) {
                    if (isStatic) return this.claimAutoImportedFuncInvocation("jsxs", "/jsx-runtime");
                    else return this.claimAutoImportedFuncInvocation("jsx", "/jsx-runtime");
                } else return this.claimAutoImportedFuncInvocation("jsxDEV", "/jsx-dev-runtime");
            }
        },
        {
            /**
   * Return the code to use for the createElement function, e.g.
   * `React.createElement`, including the following open-paren.
   *
   * This is the main function to use for the classic runtime. For the
   * automatic runtime, this function is used as a fallback function to
   * preserve behavior when there is a prop spread followed by an explicit
   * key. In that automatic runtime case, the function should be automatically
   * imported.
   */ key: "getCreateElementInvocationCode",
            value: function getCreateElementInvocationCode() {
                if (this.isAutomaticRuntime) return this.claimAutoImportedFuncInvocation("createElement", "");
                else {
                    var jsxPragmaInfo = this.jsxPragmaInfo;
                    var resolvedPragmaBaseName = this.importProcessor ? this.importProcessor.getIdentifierReplacement(jsxPragmaInfo.base) || jsxPragmaInfo.base : jsxPragmaInfo.base;
                    return "".concat(resolvedPragmaBaseName).concat(jsxPragmaInfo.suffix, "(");
                }
            }
        },
        {
            /**
   * Return the code to use as the component when compiling a shorthand
   * fragment, e.g. `React.Fragment`.
   *
   * This may be called from either the classic or automatic runtime, and
   * the value should be auto-imported for the automatic runtime.
   */ key: "getFragmentCode",
            value: function getFragmentCode() {
                if (this.isAutomaticRuntime) return this.claimAutoImportedName("Fragment", this.options.production ? "/jsx-runtime" : "/jsx-dev-runtime");
                else {
                    var jsxPragmaInfo = this.jsxPragmaInfo;
                    var resolvedFragmentPragmaBaseName = this.importProcessor ? this.importProcessor.getIdentifierReplacement(jsxPragmaInfo.fragmentBase) || jsxPragmaInfo.fragmentBase : jsxPragmaInfo.fragmentBase;
                    return resolvedFragmentPragmaBaseName + jsxPragmaInfo.fragmentSuffix;
                }
            }
        },
        {
            /**
   * Return code that invokes the given function.
   *
   * When the imports transform is enabled, use the CJSImportTransformer
   * strategy of using `.call(void 0, ...` to avoid passing a `this` value in a
   * situation that would otherwise look like a method call.
   */ key: "claimAutoImportedFuncInvocation",
            value: function claimAutoImportedFuncInvocation(funcName, importPathSuffix) {
                var funcCode = this.claimAutoImportedName(funcName, importPathSuffix);
                if (this.importProcessor) return "".concat(funcCode, ".call(void 0, ");
                else return "".concat(funcCode, "(");
            }
        },
        {
            key: "claimAutoImportedName",
            value: function claimAutoImportedName(funcName, importPathSuffix) {
                if (this.importProcessor) {
                    // CJS mode: claim a name for the module and mark it for import.
                    var path = this.jsxImportSource + importPathSuffix;
                    if (!this.cjsAutomaticModuleNameResolutions[path]) this.cjsAutomaticModuleNameResolutions[path] = this.importProcessor.getFreeIdentifierForPath(path);
                    return "".concat(this.cjsAutomaticModuleNameResolutions[path], ".").concat(funcName);
                } else {
                    // ESM mode: claim a name for this function and add it to the names that
                    // should be auto-imported when the prefix is generated.
                    if (!this.esmAutomaticImportNameResolutions[funcName]) this.esmAutomaticImportNameResolutions[funcName] = this.nameManager.claimFreeName("_".concat(funcName));
                    return this.esmAutomaticImportNameResolutions[funcName];
                }
            }
        },
        {
            /**
   * Process the first part of a tag, before any props.
   */ key: "processTagIntro",
            value: function processTagIntro() {
                // Walk forward until we see one of these patterns:
                // jsxName to start the first prop, preceded by another jsxName to end the tag name.
                // jsxName to start the first prop, preceded by greaterThan to end the type argument.
                // [open brace] to start the first prop.
                // [jsxTagEnd] to end the open-tag.
                // [slash, jsxTagEnd] to end the self-closing tag.
                var introEnd = this.tokens.currentIndex() + 1;
                while(this.tokens.tokens[introEnd].isType || !this.tokens.matches2AtIndex(introEnd - 1, (0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxName, (0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxName) && !this.tokens.matches2AtIndex(introEnd - 1, (0, $30a0d13de21d779e$export$f435f793048e7a0f).greaterThan, (0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxName) && !this.tokens.matches1AtIndex(introEnd, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL) && !this.tokens.matches1AtIndex(introEnd, (0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagEnd) && !this.tokens.matches2AtIndex(introEnd, (0, $30a0d13de21d779e$export$f435f793048e7a0f).slash, (0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagEnd))introEnd++;
                if (introEnd === this.tokens.currentIndex() + 1) {
                    var tagName = this.tokens.identifierName();
                    if ($9619a3b5c46ce6b8$export$b682d115586a1832(tagName)) this.tokens.replaceToken("'".concat(tagName, "'"));
                }
                while(this.tokens.currentIndex() < introEnd)this.rootTransformer.processToken();
            }
        },
        {
            /**
   * Starting at the beginning of the props, add the props argument to
   * React.createElement, including the comma before it.
   */ key: "processPropsObjectWithDevInfo",
            value: function processPropsObjectWithDevInfo(elementLocationCode) {
                var devProps = this.options.production ? "" : "__self: this, __source: ".concat(this.getDevSource(elementLocationCode));
                if (!this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxName) && !this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) {
                    if (devProps) this.tokens.appendCode(", {".concat(devProps, "}"));
                    else this.tokens.appendCode(", null");
                    return;
                }
                this.tokens.appendCode(", {");
                this.processProps(false);
                if (devProps) this.tokens.appendCode(" ".concat(devProps, "}"));
                else this.tokens.appendCode("}");
            }
        },
        {
            /**
   * Transform the core part of the props, assuming that a { has already been
   * inserted before us and that a } will be inserted after us.
   *
   * If extractKeyCode is true (i.e. when using any jsx... function), any prop
   * named "key" has its code captured and returned rather than being emitted to
   * the output code. This shifts line numbers, and emitting the code later will
   * correct line numbers again. If no key is found or if extractKeyCode is
   * false, this function returns null.
   */ key: "processProps",
            value: function processProps(extractKeyCode) {
                var keyCode = null;
                while(true){
                    if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxName, (0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) {
                        // This is a regular key={value} or key="value" prop.
                        var propName = this.tokens.identifierName();
                        if (extractKeyCode && propName === "key") {
                            if (keyCode !== null) // The props list has multiple keys. Different implementations are
                            // inconsistent about what to do here: as of this writing, Babel and
                            // swc keep the *last* key and completely remove the rest, while
                            // TypeScript uses the *first* key and leaves the others as regular
                            // props. The React team collaborated with Babel on the
                            // implementation of this behavior, so presumably the Babel behavior
                            // is the one to use.
                            // Since we won't ever be emitting the previous key code, we need to
                            // at least emit its newlines here so that the line numbers match up
                            // in the long run.
                            this.tokens.appendCode(keyCode.replace(/[^\n]/g, ""));
                            // key
                            this.tokens.removeToken();
                            // =
                            this.tokens.removeToken();
                            var snapshot = this.tokens.snapshot();
                            this.processPropValue();
                            keyCode = this.tokens.dangerouslyGetAndRemoveCodeSinceSnapshot(snapshot);
                            continue;
                        } else {
                            this.processPropName(propName);
                            this.tokens.replaceToken(": ");
                            this.processPropValue();
                        }
                    } else if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxName)) {
                        // This is a shorthand prop like <input disabled />.
                        var propName1 = this.tokens.identifierName();
                        this.processPropName(propName1);
                        this.tokens.appendCode(": true");
                    } else if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) {
                        // This is prop spread, like <div {...getProps()}>, which we can pass
                        // through fairly directly as an object spread.
                        this.tokens.replaceToken("");
                        this.rootTransformer.processBalancedCode();
                        this.tokens.replaceToken("");
                    } else break;
                    this.tokens.appendCode(",");
                }
                return keyCode;
            }
        },
        {
            key: "processPropName",
            value: function processPropName(propName) {
                if (propName.includes("-")) this.tokens.replaceToken("'".concat(propName, "'"));
                else this.tokens.copyToken();
            }
        },
        {
            key: "processPropValue",
            value: function processPropValue() {
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) {
                    this.tokens.replaceToken("");
                    this.rootTransformer.processBalancedCode();
                    this.tokens.replaceToken("");
                } else if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagStart)) this.processJSXTag();
                else this.processStringPropValue();
            }
        },
        {
            key: "processStringPropValue",
            value: function processStringPropValue() {
                var token = this.tokens.currentToken();
                var valueCode = this.tokens.code.slice(token.start + 1, token.end - 1);
                var replacementCode = $9619a3b5c46ce6b8$var$formatJSXTextReplacement(valueCode);
                var literalCode = $9619a3b5c46ce6b8$var$formatJSXStringValueLiteral(valueCode);
                this.tokens.replaceToken(literalCode + replacementCode);
            }
        },
        {
            /**
   * Starting in the middle of the props object literal, produce an additional
   * prop for the children and close the object literal.
   */ key: "processAutomaticChildrenAndEndProps",
            value: function processAutomaticChildrenAndEndProps(jsxRole) {
                if (jsxRole === (0, $e2df986cc8bbbda9$export$4620c92ad8b511d9).StaticChildren) {
                    this.tokens.appendCode(" children: [");
                    this.processChildren(false);
                    this.tokens.appendCode("]}");
                } else {
                    // The parser information tells us whether we will see a real child or if
                    // all remaining children (if any) will resolve to empty. If there are no
                    // non-empty children, don't emit a children prop at all, but still
                    // process children so that we properly transform the code into nothing.
                    if (jsxRole === (0, $e2df986cc8bbbda9$export$4620c92ad8b511d9).OneChild) this.tokens.appendCode(" children: ");
                    this.processChildren(false);
                    this.tokens.appendCode("}");
                }
            }
        },
        {
            /**
   * Transform children into a comma-separated list, which will be either
   * arguments to createElement or array elements of a children prop.
   */ key: "processChildren",
            value: function processChildren(needsInitialComma) {
                var needsComma = needsInitialComma;
                while(true){
                    if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagStart, (0, $30a0d13de21d779e$export$f435f793048e7a0f).slash)) // Closing tag, so no more children.
                    return;
                    var didEmitElement = false;
                    if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) {
                        if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) {
                            // Empty interpolations and comment-only interpolations are allowed
                            // and don't create an extra child arg.
                            this.tokens.replaceToken("");
                            this.tokens.replaceToken("");
                        } else {
                            // Interpolated expression.
                            this.tokens.replaceToken(needsComma ? ", " : "");
                            this.rootTransformer.processBalancedCode();
                            this.tokens.replaceToken("");
                            didEmitElement = true;
                        }
                    } else if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagStart)) {
                        // Child JSX element
                        this.tokens.appendCode(needsComma ? ", " : "");
                        this.processJSXTag();
                        didEmitElement = true;
                    } else if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxText) || this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxEmptyText)) didEmitElement = this.processChildTextElement(needsComma);
                    else throw new Error("Unexpected token when processing JSX children.");
                    if (didEmitElement) needsComma = true;
                }
            }
        },
        {
            /**
   * Turn a JSX text element into a string literal, or nothing at all if the JSX
   * text resolves to the empty string.
   *
   * Returns true if a string literal is emitted, false otherwise.
   */ key: "processChildTextElement",
            value: function processChildTextElement(needsComma) {
                var token = this.tokens.currentToken();
                var valueCode = this.tokens.code.slice(token.start, token.end);
                var replacementCode = $9619a3b5c46ce6b8$var$formatJSXTextReplacement(valueCode);
                var literalCode = $9619a3b5c46ce6b8$var$formatJSXTextLiteral(valueCode);
                if (literalCode === '""') {
                    this.tokens.replaceToken(replacementCode);
                    return false;
                } else {
                    this.tokens.replaceToken("".concat(needsComma ? ", " : "").concat(literalCode).concat(replacementCode));
                    return true;
                }
            }
        },
        {
            key: "getDevSource",
            value: function getDevSource(elementLocationCode) {
                return "{fileName: ".concat(this.getFilenameVarName(), ", ").concat(elementLocationCode, "}");
            }
        },
        {
            key: "getFilenameVarName",
            value: function getFilenameVarName() {
                if (!this.filenameVarName) this.filenameVarName = this.nameManager.claimFreeName("_jsxFileName");
                return this.filenameVarName;
            }
        }
    ]);
    return JSXTransformer;
}((0, $8757da14f0d3faf0$export$2e2bcd8739ae039));
function $9619a3b5c46ce6b8$export$b682d115586a1832(s) {
    var firstChar = s.charCodeAt(0);
    return firstChar >= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseA && firstChar <= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseZ;
}
/**
 * Turn the given jsxText string into a JS string literal. Leading and trailing
 * whitespace on lines is removed, except immediately after the open-tag and
 * before the close-tag. Empty lines are completely removed, and spaces are
 * added between lines after that.
 *
 * We use JSON.stringify to introduce escape characters as necessary, and trim
 * the start and end of each line and remove blank lines.
 */ function $9619a3b5c46ce6b8$var$formatJSXTextLiteral(text) {
    var result = "";
    var whitespace = "";
    var isInInitialLineWhitespace = false;
    var seenNonWhitespace = false;
    for(var i = 0; i < text.length; i++){
        var c = text[i];
        if (c === " " || c === "\t" || c === "\r") {
            if (!isInInitialLineWhitespace) whitespace += c;
        } else if (c === "\n") {
            whitespace = "";
            isInInitialLineWhitespace = true;
        } else {
            if (seenNonWhitespace && isInInitialLineWhitespace) result += " ";
            result += whitespace;
            whitespace = "";
            if (c === "&") {
                var _processEntity = $9619a3b5c46ce6b8$var$processEntity(text, i + 1), entity = _processEntity.entity, newI = _processEntity.newI;
                i = newI - 1;
                result += entity;
            } else result += c;
            seenNonWhitespace = true;
            isInInitialLineWhitespace = false;
        }
    }
    if (!isInInitialLineWhitespace) result += whitespace;
    return JSON.stringify(result);
}
/**
 * Produce the code that should be printed after the JSX text string literal,
 * with most content removed, but all newlines preserved and all spacing at the
 * end preserved.
 */ function $9619a3b5c46ce6b8$var$formatJSXTextReplacement(text) {
    var numNewlines = 0;
    var numSpaces = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = text[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var c = _step.value;
            if (c === "\n") {
                numNewlines++;
                numSpaces = 0;
            } else if (c === " ") numSpaces++;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return "\n".repeat(numNewlines) + " ".repeat(numSpaces);
}
/**
 * Format a string in the value position of a JSX prop.
 *
 * Use the same implementation as convertAttribute from
 * babel-helper-builder-react-jsx.
 */ function $9619a3b5c46ce6b8$var$formatJSXStringValueLiteral(text) {
    var result = "";
    for(var i = 0; i < text.length; i++){
        var c = text[i];
        if (c === "\n") {
            if (/\s/.test(text[i + 1])) {
                result += " ";
                while(i < text.length && /\s/.test(text[i + 1]))i++;
            } else result += "\n";
        } else if (c === "&") {
            var _processEntity = $9619a3b5c46ce6b8$var$processEntity(text, i + 1), entity = _processEntity.entity, newI = _processEntity.newI;
            result += entity;
            i = newI - 1;
        } else result += c;
    }
    return JSON.stringify(result);
}
/**
 * Starting at a &, see if there's an HTML entity (specified by name, decimal
 * char code, or hex char code) and return it if so.
 *
 * Modified from jsxReadString in babel-parser.
 */ function $9619a3b5c46ce6b8$var$processEntity(text, indexAfterAmpersand) {
    var str = "";
    var count = 0;
    var entity;
    var i = indexAfterAmpersand;
    if (text[i] === "#") {
        var radix = 10;
        i++;
        var numStart;
        if (text[i] === "x") {
            radix = 16;
            i++;
            numStart = i;
            while(i < text.length && $9619a3b5c46ce6b8$var$isHexDigit(text.charCodeAt(i)))i++;
        } else {
            numStart = i;
            while(i < text.length && $9619a3b5c46ce6b8$var$isDecimalDigit(text.charCodeAt(i)))i++;
        }
        if (text[i] === ";") {
            var numStr = text.slice(numStart, i);
            if (numStr) {
                i++;
                entity = String.fromCodePoint(parseInt(numStr, radix));
            }
        }
    } else while(i < text.length && count++ < 10){
        var ch = text[i];
        i++;
        if (ch === ";") {
            entity = (0, $e60312112908d881$export$2e2bcd8739ae039).get(str);
            break;
        }
        str += ch;
    }
    if (!entity) return {
        entity: "&",
        newI: indexAfterAmpersand
    };
    return {
        entity: entity,
        newI: i
    };
}
function $9619a3b5c46ce6b8$var$isDecimalDigit(code) {
    return code >= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit0 && code <= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit9;
}
function $9619a3b5c46ce6b8$var$isHexDigit(code) {
    return code >= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit0 && code <= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).digit9 || code >= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseA && code <= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseF || code >= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).uppercaseA && code <= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).uppercaseF;
}



function $ff5972888e844943$export$d0e55db0e89d76b7(tokens, options) {
    var jsxPragmaInfo = (0, $373ad0219e94492e$export$2e2bcd8739ae039)(options);
    var nonTypeIdentifiers = new Set();
    for(var i = 0; i < tokens.tokens.length; i++){
        var token = tokens.tokens[i];
        if (token.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).name && !token.isType && (token.identifierRole === (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).Access || token.identifierRole === (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ObjectShorthand || token.identifierRole === (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ExportAccess) && !token.shadowsGlobal) nonTypeIdentifiers.add(tokens.identifierNameForToken(token));
        if (token.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagStart) nonTypeIdentifiers.add(jsxPragmaInfo.base);
        if (token.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagStart && i + 1 < tokens.tokens.length && tokens.tokens[i + 1].type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagEnd) {
            nonTypeIdentifiers.add(jsxPragmaInfo.base);
            nonTypeIdentifiers.add(jsxPragmaInfo.fragmentBase);
        }
        if (token.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxName && token.identifierRole === (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).Access) {
            var identifierName = tokens.identifierNameForToken(token);
            // Lower-case single-component tag names like "div" don't count.
            if (!(0, $9619a3b5c46ce6b8$export$b682d115586a1832)(identifierName) || tokens.tokens[i + 1].type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).dot) nonTypeIdentifiers.add(tokens.identifierNameForToken(token));
        }
    }
    return nonTypeIdentifiers;
}


var $77ef7ccbdb89a5f3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function CJSImportProcessor(nameManager, tokens, enableLegacyTypeScriptModuleInterop, options, isTypeScriptTransformEnabled, keepUnusedImports, helperManager) {
        (0, $173N4._)(this, CJSImportProcessor);
        this.nameManager = nameManager;
        this.tokens = tokens;
        this.enableLegacyTypeScriptModuleInterop = enableLegacyTypeScriptModuleInterop;
        this.options = options;
        this.isTypeScriptTransformEnabled = isTypeScriptTransformEnabled;
        this.keepUnusedImports = keepUnusedImports;
        this.helperManager = helperManager;
        CJSImportProcessor.prototype.__init.call(this);
        CJSImportProcessor.prototype.__init2.call(this);
        CJSImportProcessor.prototype.__init3.call(this);
        CJSImportProcessor.prototype.__init4.call(this);
        CJSImportProcessor.prototype.__init5.call(this);
    }
    (0, $cFHGC._)(CJSImportProcessor, [
        {
            key: "__init",
            value: function __init() {
                this.nonTypeIdentifiers = new Set();
            }
        },
        {
            key: "__init2",
            value: function __init2() {
                this.importInfoByPath = new Map();
            }
        },
        {
            key: "__init3",
            value: function __init3() {
                this.importsToReplace = new Map();
            }
        },
        {
            key: "__init4",
            value: function __init4() {
                this.identifierReplacements = new Map();
            }
        },
        {
            key: "__init5",
            value: function __init5() {
                this.exportBindingsByLocalName = new Map();
            }
        },
        {
            key: "preprocessTokens",
            value: function preprocessTokens() {
                for(var i = 0; i < this.tokens.tokens.length; i++){
                    if (this.tokens.matches1AtIndex(i, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._import) && !this.tokens.matches3AtIndex(i, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._import, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) this.preprocessImportAtIndex(i);
                    if (this.tokens.matches1AtIndex(i, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._export) && !this.tokens.matches2AtIndex(i, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) this.preprocessExportAtIndex(i);
                }
                this.generateImportReplacements();
            }
        },
        {
            /**
   * In TypeScript, import statements that only import types should be removed.
   * This includes `import {} from 'foo';`, but not `import 'foo';`.
   */ key: "pruneTypeOnlyImports",
            value: function pruneTypeOnlyImports() {
                var _this = this;
                this.nonTypeIdentifiers = (0, $ff5972888e844943$export$d0e55db0e89d76b7)(this.tokens, this.options);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.importInfoByPath.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $f9AOD._)(_step.value, 2), path = _step_value[0], importInfo = _step_value[1];
                        if (importInfo.hasBareImport || importInfo.hasStarExport || importInfo.exportStarNames.length > 0 || importInfo.namedExports.length > 0) continue;
                        var names = (0, $aUGqu._)(importInfo.defaultNames).concat((0, $aUGqu._)(importInfo.wildcardNames), (0, $aUGqu._)(importInfo.namedImports.map(function(param) {
                            var localName = param.localName;
                            return localName;
                        })));
                        if (names.every(function(name) {
                            return _this.shouldAutomaticallyElideImportedName(name);
                        })) this.importsToReplace.set(path, "");
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "shouldAutomaticallyElideImportedName",
            value: function shouldAutomaticallyElideImportedName(name) {
                return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && !this.nonTypeIdentifiers.has(name);
            }
        },
        {
            key: "generateImportReplacements",
            value: function generateImportReplacements() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.importInfoByPath.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $f9AOD._)(_step.value, 2), path = _step_value[0], importInfo = _step_value[1];
                        var defaultNames = importInfo.defaultNames, wildcardNames = importInfo.wildcardNames, namedImports = importInfo.namedImports, namedExports = importInfo.namedExports, exportStarNames = importInfo.exportStarNames, hasStarExport = importInfo.hasStarExport;
                        if (defaultNames.length === 0 && wildcardNames.length === 0 && namedImports.length === 0 && namedExports.length === 0 && exportStarNames.length === 0 && !hasStarExport) {
                            // Import is never used, so don't even assign a name.
                            this.importsToReplace.set(path, "require('".concat(path, "');"));
                            continue;
                        }
                        var primaryImportName = this.getFreeIdentifierForPath(path);
                        var secondaryImportName = void 0;
                        if (this.enableLegacyTypeScriptModuleInterop) secondaryImportName = primaryImportName;
                        else secondaryImportName = wildcardNames.length > 0 ? wildcardNames[0] : this.getFreeIdentifierForPath(path);
                        var requireCode = "var ".concat(primaryImportName, " = require('").concat(path, "');");
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        if (wildcardNames.length > 0) try {
                            for(var _iterator1 = wildcardNames[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var wildcardName = _step1.value;
                                var moduleExpr = this.enableLegacyTypeScriptModuleInterop ? primaryImportName : "".concat(this.helperManager.getHelperName("interopRequireWildcard"), "(").concat(primaryImportName, ")");
                                requireCode += " var ".concat(wildcardName, " = ").concat(moduleExpr, ";");
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        else if (exportStarNames.length > 0 && secondaryImportName !== primaryImportName) requireCode += " var ".concat(secondaryImportName, " = ").concat(this.helperManager.getHelperName("interopRequireWildcard"), "(").concat(primaryImportName, ");");
                        else if (defaultNames.length > 0 && secondaryImportName !== primaryImportName) requireCode += " var ".concat(secondaryImportName, " = ").concat(this.helperManager.getHelperName("interopRequireDefault"), "(").concat(primaryImportName, ");");
                        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        try {
                            for(var _iterator2 = namedExports[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                var _step_value1 = _step2.value, importedName = _step_value1.importedName, localName = _step_value1.localName;
                                requireCode += " ".concat(this.helperManager.getHelperName("createNamedExportFrom"), "(").concat(primaryImportName, ", '").concat(localName, "', '").concat(importedName, "');");
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                    _iterator2.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                        try {
                            for(var _iterator3 = exportStarNames[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                var exportStarName = _step3.value;
                                requireCode += " exports.".concat(exportStarName, " = ").concat(secondaryImportName, ";");
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                    _iterator3.return();
                                }
                            } finally{
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                        if (hasStarExport) requireCode += " ".concat(this.helperManager.getHelperName("createStarExport"), "(").concat(primaryImportName, ");");
                        this.importsToReplace.set(path, requireCode);
                        var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                        try {
                            for(var _iterator4 = defaultNames[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                                var defaultName = _step4.value;
                                this.identifierReplacements.set(defaultName, "".concat(secondaryImportName, ".default"));
                            }
                        } catch (err) {
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                    _iterator4.return();
                                }
                            } finally{
                                if (_didIteratorError4) {
                                    throw _iteratorError4;
                                }
                            }
                        }
                        var _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                        try {
                            for(var _iterator5 = namedImports[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                                var _step_value2 = _step5.value, importedName1 = _step_value2.importedName, localName1 = _step_value2.localName;
                                this.identifierReplacements.set(localName1, "".concat(primaryImportName, ".").concat(importedName1));
                            }
                        } catch (err) {
                            _didIteratorError5 = true;
                            _iteratorError5 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                                    _iterator5.return();
                                }
                            } finally{
                                if (_didIteratorError5) {
                                    throw _iteratorError5;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "getFreeIdentifierForPath",
            value: function getFreeIdentifierForPath(path) {
                var components = path.split("/");
                var lastComponent = components[components.length - 1];
                var baseName = lastComponent.replace(/\W/g, "");
                return this.nameManager.claimFreeName("_".concat(baseName));
            }
        },
        {
            key: "preprocessImportAtIndex",
            value: function preprocessImportAtIndex(index) {
                var _importInfo_defaultNames, _importInfo_wildcardNames, _importInfo_namedImports;
                var defaultNames = [];
                var wildcardNames = [];
                var namedImports = [];
                index++;
                if ((this.tokens.matchesContextualAtIndex(index, (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type) || this.tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._typeof)) && !this.tokens.matches1AtIndex(index + 1, (0, $30a0d13de21d779e$export$f435f793048e7a0f).comma) && !this.tokens.matchesContextualAtIndex(index + 1, (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._from)) // import type declaration, so no need to process anything.
                return;
                if (this.tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) // Dynamic import, so nothing to do
                return;
                if (this.tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) {
                    defaultNames.push(this.tokens.identifierNameAtIndex(index));
                    index++;
                    if (this.tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) index++;
                }
                if (this.tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).star)) {
                    // * as
                    index += 2;
                    wildcardNames.push(this.tokens.identifierNameAtIndex(index));
                    index++;
                }
                if (this.tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) {
                    var result = this.getNamedImports(index + 1);
                    index = result.newIndex;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = result.namedImports[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var namedImport = _step.value;
                            // Treat {default as X} as a default import to ensure usage of require interop helper
                            if (namedImport.importedName === "default") defaultNames.push(namedImport.localName);
                            else namedImports.push(namedImport);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                if (this.tokens.matchesContextualAtIndex(index, (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._from)) index++;
                if (!this.tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).string)) throw new Error("Expected string token at the end of import statement.");
                var path = this.tokens.stringValueAtIndex(index);
                var importInfo = this.getImportInfo(path);
                (_importInfo_defaultNames = importInfo.defaultNames).push.apply(_importInfo_defaultNames, (0, $aUGqu._)(defaultNames));
                (_importInfo_wildcardNames = importInfo.wildcardNames).push.apply(_importInfo_wildcardNames, (0, $aUGqu._)(wildcardNames));
                (_importInfo_namedImports = importInfo.namedImports).push.apply(_importInfo_namedImports, (0, $aUGqu._)(namedImports));
                if (defaultNames.length === 0 && wildcardNames.length === 0 && namedImports.length === 0) importInfo.hasBareImport = true;
            }
        },
        {
            key: "preprocessExportAtIndex",
            value: function preprocessExportAtIndex(index) {
                if (this.tokens.matches2AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._var) || this.tokens.matches2AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._let) || this.tokens.matches2AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._const)) this.preprocessVarExportAtIndex(index);
                else if (this.tokens.matches2AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._function) || this.tokens.matches2AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._class)) {
                    var exportName = this.tokens.identifierNameAtIndex(index + 2);
                    this.addExportBinding(exportName, exportName);
                } else if (this.tokens.matches3AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._function)) {
                    var exportName1 = this.tokens.identifierNameAtIndex(index + 3);
                    this.addExportBinding(exportName1, exportName1);
                } else if (this.tokens.matches2AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) this.preprocessNamedExportAtIndex(index);
                else if (this.tokens.matches2AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f).star)) this.preprocessExportStarAtIndex(index);
            }
        },
        {
            key: "preprocessVarExportAtIndex",
            value: function preprocessVarExportAtIndex(index) {
                var depth = 0;
                // Handle cases like `export let {x} = y;`, starting at the open-brace in that case.
                for(var i = index + 2;; i++){
                    if (this.tokens.matches1AtIndex(i, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL) || this.tokens.matches1AtIndex(i, (0, $30a0d13de21d779e$export$f435f793048e7a0f).dollarBraceL) || this.tokens.matches1AtIndex(i, (0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL)) depth++;
                    else if (this.tokens.matches1AtIndex(i, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR) || this.tokens.matches1AtIndex(i, (0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR)) depth--;
                    else if (depth === 0 && !this.tokens.matches1AtIndex(i, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) break;
                    else if (this.tokens.matches1AtIndex(1, (0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) {
                        var endIndex = this.tokens.currentToken().rhsEndIndex;
                        if (endIndex == null) throw new Error("Expected = token with an end index.");
                        i = endIndex - 1;
                    } else {
                        var token = this.tokens.tokens[i];
                        if ((0, $e2df986cc8bbbda9$export$31dc9881735f7118)(token)) {
                            var exportName = this.tokens.identifierNameAtIndex(i);
                            this.identifierReplacements.set(exportName, "exports.".concat(exportName));
                        }
                    }
                }
            }
        },
        {
            /**
   * Walk this export statement just in case it's an export...from statement.
   * If it is, combine it into the import info for that path. Otherwise, just
   * bail out; it'll be handled later.
   */ key: "preprocessNamedExportAtIndex",
            value: function preprocessNamedExportAtIndex(index) {
                var _importInfo_namedExports;
                // export {
                index += 2;
                var _this_getNamedImports = this.getNamedImports(index), newIndex = _this_getNamedImports.newIndex, namedImports = _this_getNamedImports.namedImports;
                index = newIndex;
                if (this.tokens.matchesContextualAtIndex(index, (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._from)) index++;
                else {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // Reinterpret "a as b" to be local/exported rather than imported/local.
                        for(var _iterator = namedImports[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = _step.value, localName = _step_value.importedName, exportedName = _step_value.localName;
                            this.addExportBinding(localName, exportedName);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return;
                }
                if (!this.tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).string)) throw new Error("Expected string token at the end of import statement.");
                var path = this.tokens.stringValueAtIndex(index);
                var importInfo = this.getImportInfo(path);
                (_importInfo_namedExports = importInfo.namedExports).push.apply(_importInfo_namedExports, (0, $aUGqu._)(namedImports));
            }
        },
        {
            key: "preprocessExportStarAtIndex",
            value: function preprocessExportStarAtIndex(index) {
                var exportedName = null;
                if (this.tokens.matches3AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f).star, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._as)) {
                    // export * as
                    index += 3;
                    exportedName = this.tokens.identifierNameAtIndex(index);
                    // foo from
                    index += 2;
                } else // export * from
                index += 3;
                if (!this.tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).string)) throw new Error("Expected string token at the end of star export statement.");
                var path = this.tokens.stringValueAtIndex(index);
                var importInfo = this.getImportInfo(path);
                if (exportedName !== null) importInfo.exportStarNames.push(exportedName);
                else importInfo.hasStarExport = true;
            }
        },
        {
            key: "getNamedImports",
            value: function getNamedImports(index) {
                var namedImports = [];
                while(true){
                    if (this.tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) {
                        index++;
                        break;
                    }
                    var specifierInfo = (0, $60f9e6aa148c791b$export$2e2bcd8739ae039)(this.tokens, index);
                    index = specifierInfo.endIndex;
                    if (!specifierInfo.isType) namedImports.push({
                        importedName: specifierInfo.leftName,
                        localName: specifierInfo.rightName
                    });
                    if (this.tokens.matches2AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).comma, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) {
                        index += 2;
                        break;
                    } else if (this.tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) {
                        index++;
                        break;
                    } else if (this.tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) index++;
                    else throw new Error("Unexpected token: ".concat(JSON.stringify(this.tokens.tokens[index])));
                }
                return {
                    newIndex: index,
                    namedImports: namedImports
                };
            }
        },
        {
            /**
   * Get a mutable import info object for this path, creating one if it doesn't
   * exist yet.
   */ key: "getImportInfo",
            value: function getImportInfo(path) {
                var existingInfo = this.importInfoByPath.get(path);
                if (existingInfo) return existingInfo;
                var newInfo = {
                    defaultNames: [],
                    wildcardNames: [],
                    namedImports: [],
                    namedExports: [],
                    hasBareImport: false,
                    exportStarNames: [],
                    hasStarExport: false
                };
                this.importInfoByPath.set(path, newInfo);
                return newInfo;
            }
        },
        {
            key: "addExportBinding",
            value: function addExportBinding(localName, exportedName) {
                if (!this.exportBindingsByLocalName.has(localName)) this.exportBindingsByLocalName.set(localName, []);
                this.exportBindingsByLocalName.get(localName).push(exportedName);
            }
        },
        {
            /**
   * Return the code to use for the import for this path, or the empty string if
   * the code has already been "claimed" by a previous import.
   */ key: "claimImportCode",
            value: function claimImportCode(importPath) {
                var result = this.importsToReplace.get(importPath);
                this.importsToReplace.set(importPath, "");
                return result || "";
            }
        },
        {
            key: "getIdentifierReplacement",
            value: function getIdentifierReplacement(identifierName) {
                return this.identifierReplacements.get(identifierName) || null;
            }
        },
        {
            /**
   * Return a string like `exports.foo = exports.bar`.
   */ key: "resolveExportBinding",
            value: function resolveExportBinding(assignedName) {
                var exportedNames = this.exportBindingsByLocalName.get(assignedName);
                if (!exportedNames || exportedNames.length === 0) return null;
                return exportedNames.map(function(exportedName) {
                    return "exports.".concat(exportedName);
                }).join(" = ");
            }
        },
        {
            /**
   * Return all imported/exported names where we might be interested in whether usages of those
   * names are shadowed.
   */ key: "getGlobalNames",
            value: function getGlobalNames() {
                return new Set((0, $aUGqu._)(this.identifierReplacements.keys()).concat((0, $aUGqu._)(this.exportBindingsByLocalName.keys())));
            }
        }
    ]);
    return CJSImportProcessor;
}();



var $6acIq = parcelRequire("6acIq");
// src/set-array.ts

var $173N4 = parcelRequire("173N4");
// src/vlq.ts

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $9iKK3 = parcelRequire("9iKK3");
var $c3d5dfc216d20be4$require$Buffer = $9iKK3.Buffer;
var $c3d5dfc216d20be4$var$comma = ",".charCodeAt(0);
var $c3d5dfc216d20be4$var$semicolon = ";".charCodeAt(0);
var $c3d5dfc216d20be4$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $c3d5dfc216d20be4$var$intToChar = new Uint8Array(64);
var $c3d5dfc216d20be4$var$charToInt = new Uint8Array(128);
for(var $c3d5dfc216d20be4$var$i = 0; $c3d5dfc216d20be4$var$i < $c3d5dfc216d20be4$var$chars.length; $c3d5dfc216d20be4$var$i++){
    var $c3d5dfc216d20be4$var$c = $c3d5dfc216d20be4$var$chars.charCodeAt($c3d5dfc216d20be4$var$i);
    $c3d5dfc216d20be4$var$intToChar[$c3d5dfc216d20be4$var$i] = $c3d5dfc216d20be4$var$c;
    $c3d5dfc216d20be4$var$charToInt[$c3d5dfc216d20be4$var$c] = $c3d5dfc216d20be4$var$i;
}
function $c3d5dfc216d20be4$var$decodeInteger(reader, relative) {
    var value = 0;
    var shift = 0;
    var integer = 0;
    do {
        var c = reader.next();
        integer = $c3d5dfc216d20be4$var$charToInt[c];
        value |= (integer & 31) << shift;
        shift += 5;
    }while (integer & 32);
    var shouldNegate = value & 1;
    value >>>= 1;
    if (shouldNegate) value = -2147483648 | -value;
    return relative + value;
}
function $c3d5dfc216d20be4$var$encodeInteger(builder, num, relative) {
    var delta = num - relative;
    delta = delta < 0 ? -delta << 1 | 1 : delta << 1;
    do {
        var clamped = delta & 31;
        delta >>>= 5;
        if (delta > 0) clamped |= 32;
        builder.write($c3d5dfc216d20be4$var$intToChar[clamped]);
    }while (delta > 0);
    return num;
}
function $c3d5dfc216d20be4$var$hasMoreVlq(reader, max) {
    if (reader.pos >= max) return false;
    return reader.peek() !== $c3d5dfc216d20be4$var$comma;
}
// src/strings.ts
var $c3d5dfc216d20be4$var$bufLength = 16384;
var $c3d5dfc216d20be4$var$td = typeof TextDecoder !== "undefined" ? /* @__PURE__ */ new TextDecoder() : typeof $c3d5dfc216d20be4$require$Buffer !== "undefined" ? {
    decode: function(buf) {
        var out = $c3d5dfc216d20be4$require$Buffer.from(buf.buffer, buf.byteOffset, buf.byteLength);
        return out.toString();
    }
} : {
    decode: function(buf) {
        var out = "";
        for(var i = 0; i < buf.length; i++)out += String.fromCharCode(buf[i]);
        return out;
    }
};
var $c3d5dfc216d20be4$var$StringWriter = /*#__PURE__*/ function() {
    "use strict";
    function StringWriter() {
        (0, $173N4._)(this, StringWriter);
        this.pos = 0;
        this.out = "";
        this.buffer = new Uint8Array($c3d5dfc216d20be4$var$bufLength);
    }
    (0, $cFHGC._)(StringWriter, [
        {
            key: "write",
            value: function write(v) {
                var buffer = this.buffer;
                buffer[this.pos++] = v;
                if (this.pos === $c3d5dfc216d20be4$var$bufLength) {
                    this.out += $c3d5dfc216d20be4$var$td.decode(buffer);
                    this.pos = 0;
                }
            }
        },
        {
            key: "flush",
            value: function flush() {
                var _this = this, buffer = _this.buffer, out = _this.out, pos = _this.pos;
                return pos > 0 ? out + $c3d5dfc216d20be4$var$td.decode(buffer.subarray(0, pos)) : out;
            }
        }
    ]);
    return StringWriter;
}();
var $c3d5dfc216d20be4$var$StringReader = /*#__PURE__*/ function() {
    "use strict";
    function StringReader(buffer) {
        (0, $173N4._)(this, StringReader);
        this.pos = 0;
        this.buffer = buffer;
    }
    (0, $cFHGC._)(StringReader, [
        {
            key: "next",
            value: function next() {
                return this.buffer.charCodeAt(this.pos++);
            }
        },
        {
            key: "peek",
            value: function peek() {
                return this.buffer.charCodeAt(this.pos);
            }
        },
        {
            key: "indexOf",
            value: function indexOf(char) {
                var _this = this, buffer = _this.buffer, pos = _this.pos;
                var idx = buffer.indexOf(char, pos);
                return idx === -1 ? buffer.length : idx;
            }
        }
    ]);
    return StringReader;
}();
// src/scopes.ts
var $c3d5dfc216d20be4$var$EMPTY = [];
function $c3d5dfc216d20be4$export$b644ec5c290d956e(input) {
    var length = input.length;
    var reader = new $c3d5dfc216d20be4$var$StringReader(input);
    var scopes = [];
    var stack = [];
    var line = 0;
    for(; reader.pos < length; reader.pos++){
        line = $c3d5dfc216d20be4$var$decodeInteger(reader, line);
        var column = $c3d5dfc216d20be4$var$decodeInteger(reader, 0);
        if (!$c3d5dfc216d20be4$var$hasMoreVlq(reader, length)) {
            var last = stack.pop();
            last[2] = line;
            last[3] = column;
            continue;
        }
        var kind = $c3d5dfc216d20be4$var$decodeInteger(reader, 0);
        var fields = $c3d5dfc216d20be4$var$decodeInteger(reader, 0);
        var hasName = fields & 1;
        var scope = hasName ? [
            line,
            column,
            0,
            0,
            kind,
            $c3d5dfc216d20be4$var$decodeInteger(reader, 0)
        ] : [
            line,
            column,
            0,
            0,
            kind
        ];
        var vars = $c3d5dfc216d20be4$var$EMPTY;
        if ($c3d5dfc216d20be4$var$hasMoreVlq(reader, length)) {
            vars = [];
            do {
                var varsIndex = $c3d5dfc216d20be4$var$decodeInteger(reader, 0);
                vars.push(varsIndex);
            }while ($c3d5dfc216d20be4$var$hasMoreVlq(reader, length));
        }
        scope.vars = vars;
        scopes.push(scope);
        stack.push(scope);
    }
    return scopes;
}
function $c3d5dfc216d20be4$export$b8cf1ed92d4ce741(scopes) {
    var writer = new $c3d5dfc216d20be4$var$StringWriter();
    for(var i = 0; i < scopes.length;)i = $c3d5dfc216d20be4$var$_encodeOriginalScopes(scopes, i, writer, [
        0
    ]);
    return writer.flush();
}
function $c3d5dfc216d20be4$var$_encodeOriginalScopes(scopes, index, writer, state) {
    var scope = scopes[index];
    var startLine = scope[0], startColumn = scope[1], endLine = scope[2], endColumn = scope[3], kind = scope[4], vars = scope.vars;
    if (index > 0) writer.write($c3d5dfc216d20be4$var$comma);
    state[0] = $c3d5dfc216d20be4$var$encodeInteger(writer, startLine, state[0]);
    $c3d5dfc216d20be4$var$encodeInteger(writer, startColumn, 0);
    $c3d5dfc216d20be4$var$encodeInteger(writer, kind, 0);
    var fields = scope.length === 6 ? 1 : 0;
    $c3d5dfc216d20be4$var$encodeInteger(writer, fields, 0);
    if (scope.length === 6) $c3d5dfc216d20be4$var$encodeInteger(writer, scope[5], 0);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = vars[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var v = _step.value;
            $c3d5dfc216d20be4$var$encodeInteger(writer, v, 0);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    for(index++; index < scopes.length;){
        var next = scopes[index];
        var l = next[0], c = next[1];
        if (l > endLine || l === endLine && c >= endColumn) break;
        index = $c3d5dfc216d20be4$var$_encodeOriginalScopes(scopes, index, writer, state);
    }
    writer.write($c3d5dfc216d20be4$var$comma);
    state[0] = $c3d5dfc216d20be4$var$encodeInteger(writer, endLine, state[0]);
    $c3d5dfc216d20be4$var$encodeInteger(writer, endColumn, 0);
    return index;
}
function $c3d5dfc216d20be4$export$dadc7b4b4811a4cd(input) {
    var length = input.length;
    var reader = new $c3d5dfc216d20be4$var$StringReader(input);
    var ranges = [];
    var stack = [];
    var genLine = 0;
    var definitionSourcesIndex = 0;
    var definitionScopeIndex = 0;
    var callsiteSourcesIndex = 0;
    var callsiteLine = 0;
    var callsiteColumn = 0;
    var bindingLine = 0;
    var bindingColumn = 0;
    do {
        var semi = reader.indexOf(";");
        var genColumn = 0;
        for(; reader.pos < semi; reader.pos++){
            genColumn = $c3d5dfc216d20be4$var$decodeInteger(reader, genColumn);
            if (!$c3d5dfc216d20be4$var$hasMoreVlq(reader, semi)) {
                var last = stack.pop();
                last[2] = genLine;
                last[3] = genColumn;
                continue;
            }
            var fields = $c3d5dfc216d20be4$var$decodeInteger(reader, 0);
            var hasDefinition = fields & 1;
            var hasCallsite = fields & 2;
            var hasScope = fields & 4;
            var callsite = null;
            var bindings = $c3d5dfc216d20be4$var$EMPTY;
            var range = void 0;
            if (hasDefinition) {
                var defSourcesIndex = $c3d5dfc216d20be4$var$decodeInteger(reader, definitionSourcesIndex);
                definitionScopeIndex = $c3d5dfc216d20be4$var$decodeInteger(reader, definitionSourcesIndex === defSourcesIndex ? definitionScopeIndex : 0);
                definitionSourcesIndex = defSourcesIndex;
                range = [
                    genLine,
                    genColumn,
                    0,
                    0,
                    defSourcesIndex,
                    definitionScopeIndex
                ];
            } else range = [
                genLine,
                genColumn,
                0,
                0
            ];
            range.isScope = !!hasScope;
            if (hasCallsite) {
                var prevCsi = callsiteSourcesIndex;
                var prevLine = callsiteLine;
                callsiteSourcesIndex = $c3d5dfc216d20be4$var$decodeInteger(reader, callsiteSourcesIndex);
                var sameSource = prevCsi === callsiteSourcesIndex;
                callsiteLine = $c3d5dfc216d20be4$var$decodeInteger(reader, sameSource ? callsiteLine : 0);
                callsiteColumn = $c3d5dfc216d20be4$var$decodeInteger(reader, sameSource && prevLine === callsiteLine ? callsiteColumn : 0);
                callsite = [
                    callsiteSourcesIndex,
                    callsiteLine,
                    callsiteColumn
                ];
            }
            range.callsite = callsite;
            if ($c3d5dfc216d20be4$var$hasMoreVlq(reader, semi)) {
                bindings = [];
                do {
                    bindingLine = genLine;
                    bindingColumn = genColumn;
                    var expressionsCount = $c3d5dfc216d20be4$var$decodeInteger(reader, 0);
                    var expressionRanges = void 0;
                    if (expressionsCount < -1) {
                        expressionRanges = [
                            [
                                $c3d5dfc216d20be4$var$decodeInteger(reader, 0)
                            ]
                        ];
                        for(var i = -1; i > expressionsCount; i--){
                            var prevBl = bindingLine;
                            bindingLine = $c3d5dfc216d20be4$var$decodeInteger(reader, bindingLine);
                            bindingColumn = $c3d5dfc216d20be4$var$decodeInteger(reader, bindingLine === prevBl ? bindingColumn : 0);
                            var expression = $c3d5dfc216d20be4$var$decodeInteger(reader, 0);
                            expressionRanges.push([
                                expression,
                                bindingLine,
                                bindingColumn
                            ]);
                        }
                    } else expressionRanges = [
                        [
                            expressionsCount
                        ]
                    ];
                    bindings.push(expressionRanges);
                }while ($c3d5dfc216d20be4$var$hasMoreVlq(reader, semi));
            }
            range.bindings = bindings;
            ranges.push(range);
            stack.push(range);
        }
        genLine++;
        reader.pos = semi + 1;
    }while (reader.pos < length);
    return ranges;
}
function $c3d5dfc216d20be4$export$8e469a859d564769(ranges) {
    if (ranges.length === 0) return "";
    var writer = new $c3d5dfc216d20be4$var$StringWriter();
    for(var i = 0; i < ranges.length;)i = $c3d5dfc216d20be4$var$_encodeGeneratedRanges(ranges, i, writer, [
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ]);
    return writer.flush();
}
function $c3d5dfc216d20be4$var$_encodeGeneratedRanges(ranges, index, writer, state) {
    var range = ranges[index];
    var startLine = range[0], startColumn = range[1], endLine = range[2], endColumn = range[3], isScope = range.isScope, callsite = range.callsite, bindings = range.bindings;
    if (state[0] < startLine) {
        $c3d5dfc216d20be4$var$catchupLine(writer, state[0], startLine);
        state[0] = startLine;
        state[1] = 0;
    } else if (index > 0) writer.write($c3d5dfc216d20be4$var$comma);
    state[1] = $c3d5dfc216d20be4$var$encodeInteger(writer, range[1], state[1]);
    var fields = (range.length === 6 ? 1 : 0) | (callsite ? 2 : 0) | (isScope ? 4 : 0);
    $c3d5dfc216d20be4$var$encodeInteger(writer, fields, 0);
    if (range.length === 6) {
        var sourcesIndex = range[4], scopesIndex = range[5];
        if (sourcesIndex !== state[2]) state[3] = 0;
        state[2] = $c3d5dfc216d20be4$var$encodeInteger(writer, sourcesIndex, state[2]);
        state[3] = $c3d5dfc216d20be4$var$encodeInteger(writer, scopesIndex, state[3]);
    }
    if (callsite) {
        var _range_callsite = range.callsite, sourcesIndex1 = _range_callsite[0], callLine = _range_callsite[1], callColumn = _range_callsite[2];
        if (sourcesIndex1 !== state[4]) {
            state[5] = 0;
            state[6] = 0;
        } else if (callLine !== state[5]) state[6] = 0;
        state[4] = $c3d5dfc216d20be4$var$encodeInteger(writer, sourcesIndex1, state[4]);
        state[5] = $c3d5dfc216d20be4$var$encodeInteger(writer, callLine, state[5]);
        state[6] = $c3d5dfc216d20be4$var$encodeInteger(writer, callColumn, state[6]);
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (bindings) try {
        for(var _iterator = bindings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var binding = _step.value;
            if (binding.length > 1) $c3d5dfc216d20be4$var$encodeInteger(writer, -binding.length, 0);
            var expression = binding[0][0];
            $c3d5dfc216d20be4$var$encodeInteger(writer, expression, 0);
            var bindingStartLine = startLine;
            var bindingStartColumn = startColumn;
            for(var i = 1; i < binding.length; i++){
                var expRange = binding[i];
                bindingStartLine = $c3d5dfc216d20be4$var$encodeInteger(writer, expRange[1], bindingStartLine);
                bindingStartColumn = $c3d5dfc216d20be4$var$encodeInteger(writer, expRange[2], bindingStartColumn);
                $c3d5dfc216d20be4$var$encodeInteger(writer, expRange[0], 0);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    for(index++; index < ranges.length;){
        var next = ranges[index];
        var l = next[0], c = next[1];
        if (l > endLine || l === endLine && c >= endColumn) break;
        index = $c3d5dfc216d20be4$var$_encodeGeneratedRanges(ranges, index, writer, state);
    }
    if (state[0] < endLine) {
        $c3d5dfc216d20be4$var$catchupLine(writer, state[0], endLine);
        state[0] = endLine;
        state[1] = 0;
    } else writer.write($c3d5dfc216d20be4$var$comma);
    state[1] = $c3d5dfc216d20be4$var$encodeInteger(writer, endColumn, state[1]);
    return index;
}
function $c3d5dfc216d20be4$var$catchupLine(writer, lastLine, line) {
    do writer.write($c3d5dfc216d20be4$var$semicolon);
    while (++lastLine < line);
}
// src/sourcemap-codec.ts
function $c3d5dfc216d20be4$export$2f872c0f2117be69(mappings) {
    var length = mappings.length;
    var reader = new $c3d5dfc216d20be4$var$StringReader(mappings);
    var decoded = [];
    var genColumn = 0;
    var sourcesIndex = 0;
    var sourceLine = 0;
    var sourceColumn = 0;
    var namesIndex = 0;
    do {
        var semi = reader.indexOf(";");
        var line = [];
        var sorted = true;
        var lastCol = 0;
        genColumn = 0;
        while(reader.pos < semi){
            var seg = void 0;
            genColumn = $c3d5dfc216d20be4$var$decodeInteger(reader, genColumn);
            if (genColumn < lastCol) sorted = false;
            lastCol = genColumn;
            if ($c3d5dfc216d20be4$var$hasMoreVlq(reader, semi)) {
                sourcesIndex = $c3d5dfc216d20be4$var$decodeInteger(reader, sourcesIndex);
                sourceLine = $c3d5dfc216d20be4$var$decodeInteger(reader, sourceLine);
                sourceColumn = $c3d5dfc216d20be4$var$decodeInteger(reader, sourceColumn);
                if ($c3d5dfc216d20be4$var$hasMoreVlq(reader, semi)) {
                    namesIndex = $c3d5dfc216d20be4$var$decodeInteger(reader, namesIndex);
                    seg = [
                        genColumn,
                        sourcesIndex,
                        sourceLine,
                        sourceColumn,
                        namesIndex
                    ];
                } else seg = [
                    genColumn,
                    sourcesIndex,
                    sourceLine,
                    sourceColumn
                ];
            } else seg = [
                genColumn
            ];
            line.push(seg);
            reader.pos++;
        }
        if (!sorted) $c3d5dfc216d20be4$var$sort(line);
        decoded.push(line);
        reader.pos = semi + 1;
    }while (reader.pos <= length);
    return decoded;
}
function $c3d5dfc216d20be4$var$sort(line) {
    line.sort($c3d5dfc216d20be4$var$sortComparator);
}
function $c3d5dfc216d20be4$var$sortComparator(a, b) {
    return a[0] - b[0];
}
function $c3d5dfc216d20be4$export$c564cdbbe6da493(decoded) {
    var writer = new $c3d5dfc216d20be4$var$StringWriter();
    var sourcesIndex = 0;
    var sourceLine = 0;
    var sourceColumn = 0;
    var namesIndex = 0;
    for(var i = 0; i < decoded.length; i++){
        var line = decoded[i];
        if (i > 0) writer.write($c3d5dfc216d20be4$var$semicolon);
        if (line.length === 0) continue;
        var genColumn = 0;
        for(var j = 0; j < line.length; j++){
            var segment = line[j];
            if (j > 0) writer.write($c3d5dfc216d20be4$var$comma);
            genColumn = $c3d5dfc216d20be4$var$encodeInteger(writer, segment[0], genColumn);
            if (segment.length === 1) continue;
            sourcesIndex = $c3d5dfc216d20be4$var$encodeInteger(writer, segment[1], sourcesIndex);
            sourceLine = $c3d5dfc216d20be4$var$encodeInteger(writer, segment[2], sourceLine);
            sourceColumn = $c3d5dfc216d20be4$var$encodeInteger(writer, segment[3], sourceColumn);
            if (segment.length === 4) continue;
            namesIndex = $c3d5dfc216d20be4$var$encodeInteger(writer, segment[4], namesIndex);
        }
    }
    return writer.flush();
}


// src/trace-mapping.ts

var $173N4 = parcelRequire("173N4");

var $df241fa210fb8490$exports = {};
(function(global, factory) {
    $df241fa210fb8490$exports = factory();
})($df241fa210fb8490$exports, function() {
    'use strict';
    // Matches the scheme of a URL, eg "http://"
    var schemeRegex = /^[\w+.-]+:\/\//;
    /**
     * Matches the parts of a URL:
     * 1. Scheme, including ":", guaranteed.
     * 2. User/password, including "@", optional.
     * 3. Host, guaranteed.
     * 4. Port, including ":", optional.
     * 5. Path, including "/", optional.
     * 6. Query, including "?", optional.
     * 7. Hash, including "#", optional.
     */ var urlRegex = /^([\w+.-]+:)\/\/([^@/#?]*@)?([^:/#?]*)(:\d+)?(\/[^#?]*)?(\?[^#]*)?(#.*)?/;
    /**
     * File URLs are weird. They dont' need the regular `//` in the scheme, they may or may not start
     * with a leading `/`, they can have a domain (but only if they don't start with a Windows drive).
     *
     * 1. Host, optional.
     * 2. Path, which may include "/", guaranteed.
     * 3. Query, including "?", optional.
     * 4. Hash, including "#", optional.
     */ var fileRegex = /^file:(?:\/\/((?![a-z]:)[^/#?]*)?)?(\/?[^#?]*)(\?[^#]*)?(#.*)?/i;
    function isAbsoluteUrl(input) {
        return schemeRegex.test(input);
    }
    function isSchemeRelativeUrl(input) {
        return input.startsWith('//');
    }
    function isAbsolutePath(input) {
        return input.startsWith('/');
    }
    function isFileUrl(input) {
        return input.startsWith('file:');
    }
    function isRelative(input) {
        return /^[.?#]/.test(input);
    }
    function parseAbsoluteUrl(input) {
        var match = urlRegex.exec(input);
        return makeUrl(match[1], match[2] || '', match[3], match[4] || '', match[5] || '/', match[6] || '', match[7] || '');
    }
    function parseFileUrl(input) {
        var match = fileRegex.exec(input);
        var path = match[2];
        return makeUrl('file:', '', match[1] || '', '', isAbsolutePath(path) ? path : '/' + path, match[3] || '', match[4] || '');
    }
    function makeUrl(scheme, user, host, port, path, query, hash) {
        return {
            scheme: scheme,
            user: user,
            host: host,
            port: port,
            path: path,
            query: query,
            hash: hash,
            type: 7 /* Absolute */ 
        };
    }
    function parseUrl(input) {
        if (isSchemeRelativeUrl(input)) {
            var url = parseAbsoluteUrl('http:' + input);
            url.scheme = '';
            url.type = 6 /* SchemeRelative */ ;
            return url;
        }
        if (isAbsolutePath(input)) {
            var url1 = parseAbsoluteUrl('http://foo.com' + input);
            url1.scheme = '';
            url1.host = '';
            url1.type = 5 /* AbsolutePath */ ;
            return url1;
        }
        if (isFileUrl(input)) return parseFileUrl(input);
        if (isAbsoluteUrl(input)) return parseAbsoluteUrl(input);
        var url2 = parseAbsoluteUrl('http://foo.com/' + input);
        url2.scheme = '';
        url2.host = '';
        url2.type = input ? input.startsWith('?') ? 3 /* Query */  : input.startsWith('#') ? 2 /* Hash */  : 4 /* RelativePath */  : 1 /* Empty */ ;
        return url2;
    }
    function stripPathFilename(path) {
        // If a path ends with a parent directory "..", then it's a relative path with excess parent
        // paths. It's not a file, so we can't strip it.
        if (path.endsWith('/..')) return path;
        var index = path.lastIndexOf('/');
        return path.slice(0, index + 1);
    }
    function mergePaths(url, base) {
        normalizePath(base, base.type);
        // If the path is just a "/", then it was an empty path to begin with (remember, we're a relative
        // path).
        if (url.path === '/') url.path = base.path;
        else // Resolution happens relative to the base path's directory, not the file.
        url.path = stripPathFilename(base.path) + url.path;
    }
    /**
     * The path can have empty directories "//", unneeded parents "foo/..", or current directory
     * "foo/.". We need to normalize to a standard representation.
     */ function normalizePath(url, type) {
        var rel = type <= 4 /* RelativePath */ ;
        var pieces = url.path.split('/');
        // We need to preserve the first piece always, so that we output a leading slash. The item at
        // pieces[0] is an empty string.
        var pointer = 1;
        // Positive is the number of real directories we've output, used for popping a parent directory.
        // Eg, "foo/bar/.." will have a positive 2, and we can decrement to be left with just "foo".
        var positive = 0;
        // We need to keep a trailing slash if we encounter an empty directory (eg, splitting "foo/" will
        // generate `["foo", ""]` pieces). And, if we pop a parent directory. But once we encounter a
        // real directory, we won't need to append, unless the other conditions happen again.
        var addTrailingSlash = false;
        for(var i = 1; i < pieces.length; i++){
            var piece = pieces[i];
            // An empty directory, could be a trailing slash, or just a double "//" in the path.
            if (!piece) {
                addTrailingSlash = true;
                continue;
            }
            // If we encounter a real directory, then we don't need to append anymore.
            addTrailingSlash = false;
            // A current directory, which we can always drop.
            if (piece === '.') continue;
            // A parent directory, we need to see if there are any real directories we can pop. Else, we
            // have an excess of parents, and we'll need to keep the "..".
            if (piece === '..') {
                if (positive) {
                    addTrailingSlash = true;
                    positive--;
                    pointer--;
                } else if (rel) // If we're in a relativePath, then we need to keep the excess parents. Else, in an absolute
                // URL, protocol relative URL, or an absolute path, we don't need to keep excess.
                pieces[pointer++] = piece;
                continue;
            }
            // We've encountered a real directory. Move it to the next insertion pointer, which accounts for
            // any popped or dropped directories.
            pieces[pointer++] = piece;
            positive++;
        }
        var path = '';
        for(var i1 = 1; i1 < pointer; i1++)path += '/' + pieces[i1];
        if (!path || addTrailingSlash && !path.endsWith('/..')) path += '/';
        url.path = path;
    }
    /**
     * Attempts to resolve `input` URL/path relative to `base`.
     */ function resolve(input, base) {
        if (!input && !base) return '';
        var url = parseUrl(input);
        var inputType = url.type;
        if (base && inputType !== 7 /* Absolute */ ) {
            var baseUrl = parseUrl(base);
            var baseType = baseUrl.type;
            switch(inputType){
                case 1 /* Empty */ :
                    url.hash = baseUrl.hash;
                // fall through
                case 2 /* Hash */ :
                    url.query = baseUrl.query;
                // fall through
                case 3 /* Query */ :
                case 4 /* RelativePath */ :
                    mergePaths(url, baseUrl);
                // fall through
                case 5 /* AbsolutePath */ :
                    // The host, user, and port are joined, you can't copy one without the others.
                    url.user = baseUrl.user;
                    url.host = baseUrl.host;
                    url.port = baseUrl.port;
                // fall through
                case 6 /* SchemeRelative */ :
                    // The input doesn't have a schema at least, so we need to copy at least that over.
                    url.scheme = baseUrl.scheme;
            }
            if (baseType > inputType) inputType = baseType;
        }
        normalizePath(url, inputType);
        var queryHash = url.query + url.hash;
        switch(inputType){
            // This is impossible, because of the empty checks at the start of the function.
            // case UrlType.Empty:
            case 2 /* Hash */ :
            case 3 /* Query */ :
                return queryHash;
            case 4 /* RelativePath */ :
                {
                    // The first char is always a "/", and we need it to be relative.
                    var path = url.path.slice(1);
                    if (!path) return queryHash || '.';
                    if (isRelative(base || input) && !isRelative(path)) // If base started with a leading ".", or there is no base and input started with a ".",
                    // then we need to ensure that the relative path starts with a ".". We don't know if
                    // relative starts with a "..", though, so check before prepending.
                    return './' + path + queryHash;
                    return path + queryHash;
                }
            case 5 /* AbsolutePath */ :
                return url.path + queryHash;
            default:
                return url.scheme + '//' + url.user + url.host + url.port + url.path + queryHash;
        }
    }
    return resolve;
});


// src/strip-filename.ts
function $cbe8c846b8420652$var$stripFilename(path) {
    if (!path) return "";
    var index = path.lastIndexOf("/");
    return path.slice(0, index + 1);
}
// src/resolve.ts
function $cbe8c846b8420652$var$resolver(mapUrl, sourceRoot) {
    var from = $cbe8c846b8420652$var$stripFilename(mapUrl);
    var prefix = sourceRoot ? sourceRoot + "/" : "";
    return function(source) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($df241fa210fb8490$exports)))(prefix + (source || ""), from);
    };
}
// src/sourcemap-segment.ts
var $cbe8c846b8420652$var$COLUMN = 0;
var $cbe8c846b8420652$var$SOURCES_INDEX = 1;
var $cbe8c846b8420652$var$SOURCE_LINE = 2;
var $cbe8c846b8420652$var$SOURCE_COLUMN = 3;
var $cbe8c846b8420652$var$NAMES_INDEX = 4;
var $cbe8c846b8420652$var$REV_GENERATED_LINE = 1;
var $cbe8c846b8420652$var$REV_GENERATED_COLUMN = 2;
// src/sort.ts
function $cbe8c846b8420652$var$maybeSort(mappings, owned) {
    var unsortedIndex = $cbe8c846b8420652$var$nextUnsortedSegmentLine(mappings, 0);
    if (unsortedIndex === mappings.length) return mappings;
    if (!owned) mappings = mappings.slice();
    for(var i = unsortedIndex; i < mappings.length; i = $cbe8c846b8420652$var$nextUnsortedSegmentLine(mappings, i + 1))mappings[i] = $cbe8c846b8420652$var$sortSegments(mappings[i], owned);
    return mappings;
}
function $cbe8c846b8420652$var$nextUnsortedSegmentLine(mappings, start) {
    for(var i = start; i < mappings.length; i++){
        if (!$cbe8c846b8420652$var$isSorted(mappings[i])) return i;
    }
    return mappings.length;
}
function $cbe8c846b8420652$var$isSorted(line) {
    for(var j = 1; j < line.length; j++){
        if (line[j][$cbe8c846b8420652$var$COLUMN] < line[j - 1][$cbe8c846b8420652$var$COLUMN]) return false;
    }
    return true;
}
function $cbe8c846b8420652$var$sortSegments(line, owned) {
    if (!owned) line = line.slice();
    return line.sort($cbe8c846b8420652$var$sortComparator);
}
function $cbe8c846b8420652$var$sortComparator(a, b) {
    return a[$cbe8c846b8420652$var$COLUMN] - b[$cbe8c846b8420652$var$COLUMN];
}
// src/by-source.ts
function $cbe8c846b8420652$var$buildBySources(decoded, memos) {
    var sources = memos.map(function() {
        return [];
    });
    for(var i = 0; i < decoded.length; i++){
        var line = decoded[i];
        for(var j = 0; j < line.length; j++){
            var seg = line[j];
            if (seg.length === 1) continue;
            var sourceIndex2 = seg[$cbe8c846b8420652$var$SOURCES_INDEX];
            var sourceLine = seg[$cbe8c846b8420652$var$SOURCE_LINE];
            var sourceColumn = seg[$cbe8c846b8420652$var$SOURCE_COLUMN];
            var source = sources[sourceIndex2];
            var segs = source[sourceLine] || (source[sourceLine] = []);
            segs.push([
                sourceColumn,
                i,
                seg[$cbe8c846b8420652$var$COLUMN]
            ]);
        }
    }
    for(var i1 = 0; i1 < sources.length; i1++){
        var source1 = sources[i1];
        for(var j1 = 0; j1 < source1.length; j1++){
            var line1 = source1[j1];
            if (line1) line1.sort($cbe8c846b8420652$var$sortComparator);
        }
    }
    return sources;
}
// src/binary-search.ts
var $cbe8c846b8420652$var$found = false;
function $cbe8c846b8420652$var$binarySearch(haystack, needle, low, high) {
    while(low <= high){
        var mid = low + (high - low >> 1);
        var cmp = haystack[mid][$cbe8c846b8420652$var$COLUMN] - needle;
        if (cmp === 0) {
            $cbe8c846b8420652$var$found = true;
            return mid;
        }
        if (cmp < 0) low = mid + 1;
        else high = mid - 1;
    }
    $cbe8c846b8420652$var$found = false;
    return low - 1;
}
function $cbe8c846b8420652$var$upperBound(haystack, needle, index) {
    for(var i = index + 1; i < haystack.length; index = i++){
        if (haystack[i][$cbe8c846b8420652$var$COLUMN] !== needle) break;
    }
    return index;
}
function $cbe8c846b8420652$var$lowerBound(haystack, needle, index) {
    for(var i = index - 1; i >= 0; index = i--){
        if (haystack[i][$cbe8c846b8420652$var$COLUMN] !== needle) break;
    }
    return index;
}
function $cbe8c846b8420652$var$memoizedState() {
    return {
        lastKey: -1,
        lastNeedle: -1,
        lastIndex: -1
    };
}
function $cbe8c846b8420652$var$memoizedBinarySearch(haystack, needle, state, key) {
    var lastKey = state.lastKey, lastNeedle = state.lastNeedle, lastIndex = state.lastIndex;
    var low = 0;
    var high = haystack.length - 1;
    if (key === lastKey) {
        if (needle === lastNeedle) {
            $cbe8c846b8420652$var$found = lastIndex !== -1 && haystack[lastIndex][$cbe8c846b8420652$var$COLUMN] === needle;
            return lastIndex;
        }
        if (needle >= lastNeedle) low = lastIndex === -1 ? 0 : lastIndex;
        else high = lastIndex;
    }
    state.lastKey = key;
    state.lastNeedle = needle;
    return state.lastIndex = $cbe8c846b8420652$var$binarySearch(haystack, needle, low, high);
}
// src/types.ts
function $cbe8c846b8420652$var$parse(map) {
    return typeof map === "string" ? JSON.parse(map) : map;
}
// src/flatten-map.ts
var $cbe8c846b8420652$export$cfb1ea40164567c5 = function FlattenMap(map, mapUrl) {
    var parsed = $cbe8c846b8420652$var$parse(map);
    if (!("sections" in parsed)) return new $cbe8c846b8420652$export$6fc8edf86512ec85(parsed, mapUrl);
    var mappings = [];
    var sources = [];
    var sourcesContent = [];
    var names = [];
    var ignoreList = [];
    $cbe8c846b8420652$var$recurse(parsed, mapUrl, mappings, sources, sourcesContent, names, ignoreList, 0, 0, Infinity, Infinity);
    var joined = {
        version: 3,
        file: parsed.file,
        names: names,
        sources: sources,
        sourcesContent: sourcesContent,
        mappings: mappings,
        ignoreList: ignoreList
    };
    return $cbe8c846b8420652$export$20ee0c4a5619bf3d(joined);
};
function $cbe8c846b8420652$var$recurse(input, mapUrl, mappings, sources, sourcesContent, names, ignoreList, lineOffset, columnOffset, stopLine, stopColumn) {
    var sections = input.sections;
    for(var i = 0; i < sections.length; i++){
        var _sections_i = sections[i], map = _sections_i.map, offset = _sections_i.offset;
        var sl = stopLine;
        var sc = stopColumn;
        if (i + 1 < sections.length) {
            var nextOffset = sections[i + 1].offset;
            sl = Math.min(stopLine, lineOffset + nextOffset.line);
            if (sl === stopLine) sc = Math.min(stopColumn, columnOffset + nextOffset.column);
            else if (sl < stopLine) sc = columnOffset + nextOffset.column;
        }
        $cbe8c846b8420652$var$addSection(map, mapUrl, mappings, sources, sourcesContent, names, ignoreList, lineOffset + offset.line, columnOffset + offset.column, sl, sc);
    }
}
function $cbe8c846b8420652$var$addSection(input, mapUrl, mappings, sources, sourcesContent, names, ignoreList, lineOffset, columnOffset, stopLine, stopColumn) {
    var parsed = $cbe8c846b8420652$var$parse(input);
    if ("sections" in parsed) return $cbe8c846b8420652$var$recurse.apply(void 0, arguments);
    var map = new $cbe8c846b8420652$export$6fc8edf86512ec85(parsed, mapUrl);
    var sourcesOffset = sources.length;
    var namesOffset = names.length;
    var decoded = $cbe8c846b8420652$export$ecd113d4f34af700(map);
    var resolvedSources = map.resolvedSources, contents = map.sourcesContent, ignores = map.ignoreList;
    $cbe8c846b8420652$var$append(sources, resolvedSources);
    $cbe8c846b8420652$var$append(names, map.names);
    if (contents) $cbe8c846b8420652$var$append(sourcesContent, contents);
    else for(var i = 0; i < resolvedSources.length; i++)sourcesContent.push(null);
    if (ignores) for(var i1 = 0; i1 < ignores.length; i1++)ignoreList.push(ignores[i1] + sourcesOffset);
    for(var i2 = 0; i2 < decoded.length; i2++){
        var lineI = lineOffset + i2;
        if (lineI > stopLine) return;
        var out = $cbe8c846b8420652$var$getLine(mappings, lineI);
        var cOffset = i2 === 0 ? columnOffset : 0;
        var line = decoded[i2];
        for(var j = 0; j < line.length; j++){
            var seg = line[j];
            var column = cOffset + seg[$cbe8c846b8420652$var$COLUMN];
            if (lineI === stopLine && column >= stopColumn) return;
            if (seg.length === 1) {
                out.push([
                    column
                ]);
                continue;
            }
            var sourcesIndex = sourcesOffset + seg[$cbe8c846b8420652$var$SOURCES_INDEX];
            var sourceLine = seg[$cbe8c846b8420652$var$SOURCE_LINE];
            var sourceColumn = seg[$cbe8c846b8420652$var$SOURCE_COLUMN];
            out.push(seg.length === 4 ? [
                column,
                sourcesIndex,
                sourceLine,
                sourceColumn
            ] : [
                column,
                sourcesIndex,
                sourceLine,
                sourceColumn,
                namesOffset + seg[$cbe8c846b8420652$var$NAMES_INDEX]
            ]);
        }
    }
}
function $cbe8c846b8420652$var$append(arr, other) {
    for(var i = 0; i < other.length; i++)arr.push(other[i]);
}
function $cbe8c846b8420652$var$getLine(arr, index) {
    for(var i = arr.length; i <= index; i++)arr[i] = [];
    return arr[index];
}
// src/trace-mapping.ts
var $cbe8c846b8420652$var$LINE_GTR_ZERO = "`line` must be greater than 0 (lines start at line 1)";
var $cbe8c846b8420652$var$COL_GTR_EQ_ZERO = "`column` must be greater than or equal to 0 (columns start at column 0)";
var $cbe8c846b8420652$export$b99fbecff261243 = -1;
var $cbe8c846b8420652$export$4ecd616dce182dff = 1;
var $cbe8c846b8420652$export$6fc8edf86512ec85 = function TraceMap(map, mapUrl) {
    "use strict";
    (0, $173N4._)(this, TraceMap);
    var isString = typeof map === "string";
    if (!isString && map._decodedMemo) return map;
    var parsed = $cbe8c846b8420652$var$parse(map);
    var version = parsed.version, file = parsed.file, names = parsed.names, sourceRoot = parsed.sourceRoot, sources = parsed.sources, sourcesContent = parsed.sourcesContent;
    this.version = version;
    this.file = file;
    this.names = names || [];
    this.sourceRoot = sourceRoot;
    this.sources = sources;
    this.sourcesContent = sourcesContent;
    this.ignoreList = parsed.ignoreList || parsed.x_google_ignoreList || void 0;
    var resolve = $cbe8c846b8420652$var$resolver(mapUrl, sourceRoot);
    this.resolvedSources = sources.map(resolve);
    var mappings = parsed.mappings;
    if (typeof mappings === "string") {
        this._encoded = mappings;
        this._decoded = void 0;
    } else if (Array.isArray(mappings)) {
        this._encoded = void 0;
        this._decoded = $cbe8c846b8420652$var$maybeSort(mappings, isString);
    } else if (parsed.sections) throw new Error("TraceMap passed sectioned source map, please use FlattenMap export instead");
    else throw new Error("invalid source map: ".concat(JSON.stringify(parsed)));
    this._decodedMemo = $cbe8c846b8420652$var$memoizedState();
    this._bySources = void 0;
    this._bySourceMemos = void 0;
};
function $cbe8c846b8420652$var$cast(map) {
    return map;
}
function $cbe8c846b8420652$export$59408758bba4b625(map) {
    var _a, _b;
    return (_b = (_a = $cbe8c846b8420652$var$cast(map))._encoded) != null ? _b : _a._encoded = (0, $c3d5dfc216d20be4$export$c564cdbbe6da493)($cbe8c846b8420652$var$cast(map)._decoded);
}
function $cbe8c846b8420652$export$ecd113d4f34af700(map) {
    var _a;
    return (_a = $cbe8c846b8420652$var$cast(map))._decoded || (_a._decoded = (0, $c3d5dfc216d20be4$export$2f872c0f2117be69)($cbe8c846b8420652$var$cast(map)._encoded));
}
function $cbe8c846b8420652$export$6d863e58cd035563(map, line, column) {
    var decoded = $cbe8c846b8420652$export$ecd113d4f34af700(map);
    if (line >= decoded.length) return null;
    var segments = decoded[line];
    var index = $cbe8c846b8420652$var$traceSegmentInternal(segments, $cbe8c846b8420652$var$cast(map)._decodedMemo, line, column, $cbe8c846b8420652$export$4ecd616dce182dff);
    return index === -1 ? null : segments[index];
}
function $cbe8c846b8420652$export$56d62ac80d274c78(map, needle) {
    var line = needle.line, column = needle.column, bias = needle.bias;
    line--;
    if (line < 0) throw new Error($cbe8c846b8420652$var$LINE_GTR_ZERO);
    if (column < 0) throw new Error($cbe8c846b8420652$var$COL_GTR_EQ_ZERO);
    var decoded = $cbe8c846b8420652$export$ecd113d4f34af700(map);
    if (line >= decoded.length) return $cbe8c846b8420652$var$OMapping(null, null, null, null);
    var segments = decoded[line];
    var index = $cbe8c846b8420652$var$traceSegmentInternal(segments, $cbe8c846b8420652$var$cast(map)._decodedMemo, line, column, bias || $cbe8c846b8420652$export$4ecd616dce182dff);
    if (index === -1) return $cbe8c846b8420652$var$OMapping(null, null, null, null);
    var segment = segments[index];
    if (segment.length === 1) return $cbe8c846b8420652$var$OMapping(null, null, null, null);
    var names = map.names, resolvedSources = map.resolvedSources;
    return $cbe8c846b8420652$var$OMapping(resolvedSources[segment[$cbe8c846b8420652$var$SOURCES_INDEX]], segment[$cbe8c846b8420652$var$SOURCE_LINE] + 1, segment[$cbe8c846b8420652$var$SOURCE_COLUMN], segment.length === 5 ? names[segment[$cbe8c846b8420652$var$NAMES_INDEX]] : null);
}
function $cbe8c846b8420652$export$5bf80d5312a8ff17(map, needle) {
    var source = needle.source, line = needle.line, column = needle.column, bias = needle.bias;
    return $cbe8c846b8420652$var$generatedPosition(map, source, line, column, bias || $cbe8c846b8420652$export$4ecd616dce182dff, false);
}
function $cbe8c846b8420652$export$69d37f329d319dca(map, needle) {
    var source = needle.source, line = needle.line, column = needle.column, bias = needle.bias;
    return $cbe8c846b8420652$var$generatedPosition(map, source, line, column, bias || $cbe8c846b8420652$export$b99fbecff261243, true);
}
function $cbe8c846b8420652$export$78c99866f56beaa4(map, cb) {
    var decoded = $cbe8c846b8420652$export$ecd113d4f34af700(map);
    var names = map.names, resolvedSources = map.resolvedSources;
    for(var i = 0; i < decoded.length; i++){
        var line = decoded[i];
        for(var j = 0; j < line.length; j++){
            var seg = line[j];
            var generatedLine = i + 1;
            var generatedColumn = seg[0];
            var source = null;
            var originalLine = null;
            var originalColumn = null;
            var name = null;
            if (seg.length !== 1) {
                source = resolvedSources[seg[1]];
                originalLine = seg[2] + 1;
                originalColumn = seg[3];
            }
            if (seg.length === 5) name = names[seg[4]];
            cb({
                generatedLine: generatedLine,
                generatedColumn: generatedColumn,
                source: source,
                originalLine: originalLine,
                originalColumn: originalColumn,
                name: name
            });
        }
    }
}
function $cbe8c846b8420652$var$sourceIndex(map, source) {
    var sources = map.sources, resolvedSources = map.resolvedSources;
    var index = sources.indexOf(source);
    if (index === -1) index = resolvedSources.indexOf(source);
    return index;
}
function $cbe8c846b8420652$export$a685fd8184719fc9(map, source) {
    var sourcesContent = map.sourcesContent;
    if (sourcesContent == null) return null;
    var index = $cbe8c846b8420652$var$sourceIndex(map, source);
    return index === -1 ? null : sourcesContent[index];
}
function $cbe8c846b8420652$export$ac3f691269cd6d9b(map, source) {
    var ignoreList = map.ignoreList;
    if (ignoreList == null) return false;
    var index = $cbe8c846b8420652$var$sourceIndex(map, source);
    return index === -1 ? false : ignoreList.includes(index);
}
function $cbe8c846b8420652$export$20ee0c4a5619bf3d(map, mapUrl) {
    var tracer = new $cbe8c846b8420652$export$6fc8edf86512ec85($cbe8c846b8420652$var$clone(map, []), mapUrl);
    $cbe8c846b8420652$var$cast(tracer)._decoded = map.mappings;
    return tracer;
}
function $cbe8c846b8420652$export$f6477d963c19e792(map) {
    return $cbe8c846b8420652$var$clone(map, $cbe8c846b8420652$export$ecd113d4f34af700(map));
}
function $cbe8c846b8420652$export$f859692979919a94(map) {
    return $cbe8c846b8420652$var$clone(map, $cbe8c846b8420652$export$59408758bba4b625(map));
}
function $cbe8c846b8420652$var$clone(map, mappings) {
    return {
        version: map.version,
        file: map.file,
        names: map.names,
        sourceRoot: map.sourceRoot,
        sources: map.sources,
        sourcesContent: map.sourcesContent,
        mappings: mappings,
        ignoreList: map.ignoreList || map.x_google_ignoreList
    };
}
function $cbe8c846b8420652$var$OMapping(source, line, column, name) {
    return {
        source: source,
        line: line,
        column: column,
        name: name
    };
}
function $cbe8c846b8420652$var$GMapping(line, column) {
    return {
        line: line,
        column: column
    };
}
function $cbe8c846b8420652$var$traceSegmentInternal(segments, memo, line, column, bias) {
    var index = $cbe8c846b8420652$var$memoizedBinarySearch(segments, column, memo, line);
    if ($cbe8c846b8420652$var$found) index = (bias === $cbe8c846b8420652$export$b99fbecff261243 ? $cbe8c846b8420652$var$upperBound : $cbe8c846b8420652$var$lowerBound)(segments, column, index);
    else if (bias === $cbe8c846b8420652$export$b99fbecff261243) index++;
    if (index === -1 || index === segments.length) return -1;
    return index;
}
function $cbe8c846b8420652$var$sliceGeneratedPositions(segments, memo, line, column, bias) {
    var min = $cbe8c846b8420652$var$traceSegmentInternal(segments, memo, line, column, $cbe8c846b8420652$export$4ecd616dce182dff);
    if (!$cbe8c846b8420652$var$found && bias === $cbe8c846b8420652$export$b99fbecff261243) min++;
    if (min === -1 || min === segments.length) return [];
    var matchedColumn = $cbe8c846b8420652$var$found ? column : segments[min][$cbe8c846b8420652$var$COLUMN];
    if (!$cbe8c846b8420652$var$found) min = $cbe8c846b8420652$var$lowerBound(segments, matchedColumn, min);
    var max = $cbe8c846b8420652$var$upperBound(segments, matchedColumn, min);
    var result = [];
    for(; min <= max; min++){
        var segment = segments[min];
        result.push($cbe8c846b8420652$var$GMapping(segment[$cbe8c846b8420652$var$REV_GENERATED_LINE] + 1, segment[$cbe8c846b8420652$var$REV_GENERATED_COLUMN]));
    }
    return result;
}
function $cbe8c846b8420652$var$generatedPosition(map, source, line, column, bias, all) {
    var _a, _b;
    line--;
    if (line < 0) throw new Error($cbe8c846b8420652$var$LINE_GTR_ZERO);
    if (column < 0) throw new Error($cbe8c846b8420652$var$COL_GTR_EQ_ZERO);
    var sources = map.sources, resolvedSources = map.resolvedSources;
    var sourceIndex2 = sources.indexOf(source);
    if (sourceIndex2 === -1) sourceIndex2 = resolvedSources.indexOf(source);
    if (sourceIndex2 === -1) return all ? [] : $cbe8c846b8420652$var$GMapping(null, null);
    var bySourceMemos = (_a = $cbe8c846b8420652$var$cast(map))._bySourceMemos || (_a._bySourceMemos = sources.map($cbe8c846b8420652$var$memoizedState));
    var generated = (_b = $cbe8c846b8420652$var$cast(map))._bySources || (_b._bySources = $cbe8c846b8420652$var$buildBySources($cbe8c846b8420652$export$ecd113d4f34af700(map), bySourceMemos));
    var segments = generated[sourceIndex2][line];
    if (segments == null) return all ? [] : $cbe8c846b8420652$var$GMapping(null, null);
    var memo = bySourceMemos[sourceIndex2];
    if (all) return $cbe8c846b8420652$var$sliceGeneratedPositions(segments, memo, line, column, bias);
    var index = $cbe8c846b8420652$var$traceSegmentInternal(segments, memo, line, column, bias);
    if (index === -1) return $cbe8c846b8420652$var$GMapping(null, null);
    var segment = segments[index];
    return $cbe8c846b8420652$var$GMapping(segment[$cbe8c846b8420652$var$REV_GENERATED_LINE] + 1, segment[$cbe8c846b8420652$var$REV_GENERATED_COLUMN]);
}


var $2438fa76de4b93b8$var$SetArray = function SetArray() {
    "use strict";
    (0, $173N4._)(this, SetArray);
    this._indexes = {
        __proto__: null
    };
    this.array = [];
};
function $2438fa76de4b93b8$var$cast(set) {
    return set;
}
function $2438fa76de4b93b8$var$get(setarr, key) {
    return $2438fa76de4b93b8$var$cast(setarr)._indexes[key];
}
function $2438fa76de4b93b8$var$put(setarr, key) {
    var index = $2438fa76de4b93b8$var$get(setarr, key);
    if (index !== void 0) return index;
    var _cast = $2438fa76de4b93b8$var$cast(setarr), array = _cast.array, indexes = _cast._indexes;
    var length = array.push(key);
    return indexes[key] = length - 1;
}
function $2438fa76de4b93b8$var$remove(setarr, key) {
    var index = $2438fa76de4b93b8$var$get(setarr, key);
    if (index === void 0) return;
    var _cast = $2438fa76de4b93b8$var$cast(setarr), array = _cast.array, indexes = _cast._indexes;
    for(var i = index + 1; i < array.length; i++){
        var k = array[i];
        array[i - 1] = k;
        indexes[k]--;
    }
    indexes[key] = void 0;
    array.pop();
}
// src/sourcemap-segment.ts
var $2438fa76de4b93b8$var$COLUMN = 0;
var $2438fa76de4b93b8$var$SOURCES_INDEX = 1;
var $2438fa76de4b93b8$var$SOURCE_LINE = 2;
var $2438fa76de4b93b8$var$SOURCE_COLUMN = 3;
var $2438fa76de4b93b8$var$NAMES_INDEX = 4;
// src/gen-mapping.ts
var $2438fa76de4b93b8$var$NO_NAME = -1;
var $2438fa76de4b93b8$export$92fb4a3d57ca7ec = function GenMapping() {
    "use strict";
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, file = _ref.file, sourceRoot = _ref.sourceRoot;
    (0, $173N4._)(this, GenMapping);
    this._names = new $2438fa76de4b93b8$var$SetArray();
    this._sources = new $2438fa76de4b93b8$var$SetArray();
    this._sourcesContent = [];
    this._mappings = [];
    this.file = file;
    this.sourceRoot = sourceRoot;
    this._ignoreList = new $2438fa76de4b93b8$var$SetArray();
};
function $2438fa76de4b93b8$var$cast2(map) {
    return map;
}
function $2438fa76de4b93b8$export$1c43f9ac826b6462(map, genLine, genColumn, source, sourceLine, sourceColumn, name, content) {
    return $2438fa76de4b93b8$var$addSegmentInternal(false, map, genLine, genColumn, source, sourceLine, sourceColumn, name, content);
}
function $2438fa76de4b93b8$export$2d9a54e47969bead(map, mapping) {
    return $2438fa76de4b93b8$var$addMappingInternal(false, map, mapping);
}
var $2438fa76de4b93b8$export$bffbcf5bdbbd3679 = function(map, genLine, genColumn, source, sourceLine, sourceColumn, name, content) {
    return $2438fa76de4b93b8$var$addSegmentInternal(true, map, genLine, genColumn, source, sourceLine, sourceColumn, name, content);
};
var $2438fa76de4b93b8$export$6623d26b0c62901b = function(map, mapping) {
    return $2438fa76de4b93b8$var$addMappingInternal(true, map, mapping);
};
function $2438fa76de4b93b8$export$c6155c9e474ba16b(map, source, content) {
    var _cast2 = $2438fa76de4b93b8$var$cast2(map), sources = _cast2._sources, sourcesContent = _cast2._sourcesContent;
    var index = $2438fa76de4b93b8$var$put(sources, source);
    sourcesContent[index] = content;
}
function $2438fa76de4b93b8$export$6db5baaf5ada6795(map, source) {
    var ignore = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var _cast2 = $2438fa76de4b93b8$var$cast2(map), sources = _cast2._sources, sourcesContent = _cast2._sourcesContent, ignoreList = _cast2._ignoreList;
    var index = $2438fa76de4b93b8$var$put(sources, source);
    if (index === sourcesContent.length) sourcesContent[index] = null;
    if (ignore) $2438fa76de4b93b8$var$put(ignoreList, index);
    else $2438fa76de4b93b8$var$remove(ignoreList, index);
}
function $2438fa76de4b93b8$export$74ae13ad22f29c85(map) {
    var _cast2 = $2438fa76de4b93b8$var$cast2(map), mappings = _cast2._mappings, sources = _cast2._sources, sourcesContent = _cast2._sourcesContent, names = _cast2._names, ignoreList = _cast2._ignoreList;
    $2438fa76de4b93b8$var$removeEmptyFinalLines(mappings);
    return {
        version: 3,
        file: map.file || void 0,
        names: names.array,
        sourceRoot: map.sourceRoot || void 0,
        sources: sources.array,
        sourcesContent: sourcesContent,
        mappings: mappings,
        // originalScopes,
        // generatedRanges,
        ignoreList: ignoreList.array
    };
}
function $2438fa76de4b93b8$export$da8de8cfd71f671a(map) {
    var decoded = $2438fa76de4b93b8$export$74ae13ad22f29c85(map);
    return Object.assign({}, decoded, {
        // originalScopes: decoded.originalScopes.map((os) => encodeOriginalScopes(os)),
        // generatedRanges: encodeGeneratedRanges(decoded.generatedRanges as GeneratedRange[]),
        mappings: (0, $c3d5dfc216d20be4$export$c564cdbbe6da493)(decoded.mappings)
    });
}
function $2438fa76de4b93b8$export$d81aa96f14f987cc(input) {
    var map = new (0, $cbe8c846b8420652$export$6fc8edf86512ec85)(input);
    var gen = new $2438fa76de4b93b8$export$92fb4a3d57ca7ec({
        file: map.file,
        sourceRoot: map.sourceRoot
    });
    $2438fa76de4b93b8$var$putAll($2438fa76de4b93b8$var$cast2(gen)._names, map.names);
    $2438fa76de4b93b8$var$putAll($2438fa76de4b93b8$var$cast2(gen)._sources, map.sources);
    $2438fa76de4b93b8$var$cast2(gen)._sourcesContent = map.sourcesContent || map.sources.map(function() {
        return null;
    });
    $2438fa76de4b93b8$var$cast2(gen)._mappings = (0, $cbe8c846b8420652$export$ecd113d4f34af700)(map);
    if (map.ignoreList) $2438fa76de4b93b8$var$putAll($2438fa76de4b93b8$var$cast2(gen)._ignoreList, map.ignoreList);
    return gen;
}
function $2438fa76de4b93b8$export$f06617c6577f8fbd(map) {
    var out = [];
    var _cast2 = $2438fa76de4b93b8$var$cast2(map), mappings = _cast2._mappings, sources = _cast2._sources, names = _cast2._names;
    for(var i = 0; i < mappings.length; i++){
        var line = mappings[i];
        for(var j = 0; j < line.length; j++){
            var seg = line[j];
            var generated = {
                line: i + 1,
                column: seg[$2438fa76de4b93b8$var$COLUMN]
            };
            var source = void 0;
            var original = void 0;
            var name = void 0;
            if (seg.length !== 1) {
                source = sources.array[seg[$2438fa76de4b93b8$var$SOURCES_INDEX]];
                original = {
                    line: seg[$2438fa76de4b93b8$var$SOURCE_LINE] + 1,
                    column: seg[$2438fa76de4b93b8$var$SOURCE_COLUMN]
                };
                if (seg.length === 5) name = names.array[seg[$2438fa76de4b93b8$var$NAMES_INDEX]];
            }
            out.push({
                generated: generated,
                source: source,
                original: original,
                name: name
            });
        }
    }
    return out;
}
function $2438fa76de4b93b8$var$addSegmentInternal(skipable, map, genLine, genColumn, source, sourceLine, sourceColumn, name, content) {
    var _cast2 = $2438fa76de4b93b8$var$cast2(map), mappings = _cast2._mappings, sources = _cast2._sources, sourcesContent = _cast2._sourcesContent, names = _cast2._names;
    var line = $2438fa76de4b93b8$var$getIndex(mappings, genLine);
    var index = $2438fa76de4b93b8$var$getColumnIndex(line, genColumn);
    if (!source) {
        if (skipable && $2438fa76de4b93b8$var$skipSourceless(line, index)) return;
        return $2438fa76de4b93b8$var$insert(line, index, [
            genColumn
        ]);
    }
    $2438fa76de4b93b8$var$assert(sourceLine);
    $2438fa76de4b93b8$var$assert(sourceColumn);
    var sourcesIndex = $2438fa76de4b93b8$var$put(sources, source);
    var namesIndex = name ? $2438fa76de4b93b8$var$put(names, name) : $2438fa76de4b93b8$var$NO_NAME;
    if (sourcesIndex === sourcesContent.length) sourcesContent[sourcesIndex] = content != null ? content : null;
    if (skipable && $2438fa76de4b93b8$var$skipSource(line, index, sourcesIndex, sourceLine, sourceColumn, namesIndex)) return;
    return $2438fa76de4b93b8$var$insert(line, index, name ? [
        genColumn,
        sourcesIndex,
        sourceLine,
        sourceColumn,
        namesIndex
    ] : [
        genColumn,
        sourcesIndex,
        sourceLine,
        sourceColumn
    ]);
}
function $2438fa76de4b93b8$var$assert(_val) {}
function $2438fa76de4b93b8$var$getIndex(arr, index) {
    for(var i = arr.length; i <= index; i++)arr[i] = [];
    return arr[index];
}
function $2438fa76de4b93b8$var$getColumnIndex(line, genColumn) {
    var index = line.length;
    for(var i = index - 1; i >= 0; index = i--){
        var current = line[i];
        if (genColumn >= current[$2438fa76de4b93b8$var$COLUMN]) break;
    }
    return index;
}
function $2438fa76de4b93b8$var$insert(array, index, value) {
    for(var i = array.length; i > index; i--)array[i] = array[i - 1];
    array[index] = value;
}
function $2438fa76de4b93b8$var$removeEmptyFinalLines(mappings) {
    var length = mappings.length;
    var len = length;
    for(var i = len - 1; i >= 0; len = i, i--){
        if (mappings[i].length > 0) break;
    }
    if (len < length) mappings.length = len;
}
function $2438fa76de4b93b8$var$putAll(setarr, array) {
    for(var i = 0; i < array.length; i++)$2438fa76de4b93b8$var$put(setarr, array[i]);
}
function $2438fa76de4b93b8$var$skipSourceless(line, index) {
    if (index === 0) return true;
    var prev = line[index - 1];
    return prev.length === 1;
}
function $2438fa76de4b93b8$var$skipSource(line, index, sourcesIndex, sourceLine, sourceColumn, namesIndex) {
    if (index === 0) return false;
    var prev = line[index - 1];
    if (prev.length === 1) return false;
    return sourcesIndex === prev[$2438fa76de4b93b8$var$SOURCES_INDEX] && sourceLine === prev[$2438fa76de4b93b8$var$SOURCE_LINE] && sourceColumn === prev[$2438fa76de4b93b8$var$SOURCE_COLUMN] && namesIndex === (prev.length === 5 ? prev[$2438fa76de4b93b8$var$NAMES_INDEX] : $2438fa76de4b93b8$var$NO_NAME);
}
function $2438fa76de4b93b8$var$addMappingInternal(skipable, map, mapping) {
    var generated = mapping.generated, source = mapping.source, original = mapping.original, name = mapping.name, content = mapping.content;
    if (!source) return $2438fa76de4b93b8$var$addSegmentInternal(skipable, map, generated.line - 1, generated.column, null, null, null, null, null);
    $2438fa76de4b93b8$var$assert(original);
    return $2438fa76de4b93b8$var$addSegmentInternal(skipable, map, generated.line - 1, generated.column, source, original.line - 1, original.column, name, content);
}



function $b44756059e18104f$export$2e2bcd8739ae039(param, filePath, options, source, tokens) {
    var generatedCode = param.code, rawMappings = param.mappings;
    var sourceColumns = $b44756059e18104f$var$computeSourceColumns(source, tokens);
    var map = new (0, $2438fa76de4b93b8$export$92fb4a3d57ca7ec)({
        file: options.compiledFilename
    });
    var tokenIndex = 0;
    // currentMapping is the output source index for the current input token being
    // considered.
    var currentMapping = rawMappings[0];
    while(currentMapping === undefined && tokenIndex < rawMappings.length - 1){
        tokenIndex++;
        currentMapping = rawMappings[tokenIndex];
    }
    var line = 0;
    var lineStart = 0;
    if (currentMapping !== lineStart) (0, $2438fa76de4b93b8$export$bffbcf5bdbbd3679)(map, line, 0, filePath, line, 0);
    for(var i = 0; i < generatedCode.length; i++){
        if (i === currentMapping) {
            var genColumn = currentMapping - lineStart;
            var sourceColumn = sourceColumns[tokenIndex];
            (0, $2438fa76de4b93b8$export$bffbcf5bdbbd3679)(map, line, genColumn, filePath, line, sourceColumn);
            while((currentMapping === i || currentMapping === undefined) && tokenIndex < rawMappings.length - 1){
                tokenIndex++;
                currentMapping = rawMappings[tokenIndex];
            }
        }
        if (generatedCode.charCodeAt(i) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lineFeed) {
            line++;
            lineStart = i + 1;
            if (currentMapping !== lineStart) (0, $2438fa76de4b93b8$export$bffbcf5bdbbd3679)(map, line, 0, filePath, line, 0);
        }
    }
    var _toEncodedMap = (0, $2438fa76de4b93b8$export$da8de8cfd71f671a)(map), sourceRoot = _toEncodedMap.sourceRoot, sourcesContent = _toEncodedMap.sourcesContent, sourceMap = (0, $6acIq._)(_toEncodedMap, [
        "sourceRoot",
        "sourcesContent"
    ]);
    return sourceMap;
}
/**
 * Create an array mapping each token index to the 0-based column of the start
 * position of the token.
 */ function $b44756059e18104f$var$computeSourceColumns(code, tokens) {
    var sourceColumns = new Array(tokens.length);
    var tokenIndex = 0;
    var currentMapping = tokens[tokenIndex].start;
    var lineStart = 0;
    for(var i = 0; i < code.length; i++){
        if (i === currentMapping) {
            sourceColumns[tokenIndex] = currentMapping - lineStart;
            tokenIndex++;
            currentMapping = tokens[tokenIndex].start;
        }
        if (code.charCodeAt(i) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lineFeed) lineStart = i + 1;
    }
    return sourceColumns;
}



var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $f9AOD = parcelRequire("f9AOD");
var $13685afd3632ccc0$var$HELPERS = {
    require: '\n    import {createRequire as CREATE_REQUIRE_NAME} from "module";\n    const require = CREATE_REQUIRE_NAME(import.meta.url);\n  ',
    interopRequireWildcard: "\n    function interopRequireWildcard(obj) {\n      if (obj && obj.__esModule) {\n        return obj;\n      } else {\n        var newObj = {};\n        if (obj != null) {\n          for (var key in obj) {\n            if (Object.prototype.hasOwnProperty.call(obj, key)) {\n              newObj[key] = obj[key];\n            }\n          }\n        }\n        newObj.default = obj;\n        return newObj;\n      }\n    }\n  ",
    interopRequireDefault: "\n    function interopRequireDefault(obj) {\n      return obj && obj.__esModule ? obj : { default: obj };\n    }\n  ",
    createNamedExportFrom: "\n    function createNamedExportFrom(obj, localName, importedName) {\n      Object.defineProperty(exports, localName, {enumerable: true, configurable: true, get: () => obj[importedName]});\n    }\n  ",
    // Note that TypeScript and Babel do this differently; TypeScript does a simple existence
    // check in the exports object and does a plain assignment, whereas Babel uses
    // defineProperty and builds an object of explicitly-exported names so that star exports can
    // always take lower precedence. For now, we do the easier TypeScript thing.
    createStarExport: '\n    function createStarExport(obj) {\n      Object.keys(obj)\n        .filter((key) => key !== "default" && key !== "__esModule")\n        .forEach((key) => {\n          if (exports.hasOwnProperty(key)) {\n            return;\n          }\n          Object.defineProperty(exports, key, {enumerable: true, configurable: true, get: () => obj[key]});\n        });\n    }\n  ',
    nullishCoalesce: "\n    function nullishCoalesce(lhs, rhsFn) {\n      if (lhs != null) {\n        return lhs;\n      } else {\n        return rhsFn();\n      }\n    }\n  ",
    asyncNullishCoalesce: "\n    async function asyncNullishCoalesce(lhs, rhsFn) {\n      if (lhs != null) {\n        return lhs;\n      } else {\n        return await rhsFn();\n      }\n    }\n  ",
    optionalChain: "\n    function optionalChain(ops) {\n      let lastAccessLHS = undefined;\n      let value = ops[0];\n      let i = 1;\n      while (i < ops.length) {\n        const op = ops[i];\n        const fn = ops[i + 1];\n        i += 2;\n        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {\n          return undefined;\n        }\n        if (op === 'access' || op === 'optionalAccess') {\n          lastAccessLHS = value;\n          value = fn(value);\n        } else if (op === 'call' || op === 'optionalCall') {\n          value = fn((...args) => value.call(lastAccessLHS, ...args));\n          lastAccessLHS = undefined;\n        }\n      }\n      return value;\n    }\n  ",
    asyncOptionalChain: "\n    async function asyncOptionalChain(ops) {\n      let lastAccessLHS = undefined;\n      let value = ops[0];\n      let i = 1;\n      while (i < ops.length) {\n        const op = ops[i];\n        const fn = ops[i + 1];\n        i += 2;\n        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {\n          return undefined;\n        }\n        if (op === 'access' || op === 'optionalAccess') {\n          lastAccessLHS = value;\n          value = await fn(value);\n        } else if (op === 'call' || op === 'optionalCall') {\n          value = await fn((...args) => value.call(lastAccessLHS, ...args));\n          lastAccessLHS = undefined;\n        }\n      }\n      return value;\n    }\n  ",
    optionalChainDelete: "\n    function optionalChainDelete(ops) {\n      const result = OPTIONAL_CHAIN_NAME(ops);\n      return result == null ? true : result;\n    }\n  ",
    asyncOptionalChainDelete: "\n    async function asyncOptionalChainDelete(ops) {\n      const result = await ASYNC_OPTIONAL_CHAIN_NAME(ops);\n      return result == null ? true : result;\n    }\n  "
};
var $13685afd3632ccc0$export$b203ad16abdeb845 = /*#__PURE__*/ function() {
    "use strict";
    function HelperManager(nameManager) {
        (0, $173N4._)(this, HelperManager);
        this.nameManager = nameManager;
        HelperManager.prototype.__init.call(this);
        HelperManager.prototype.__init2.call(this);
    }
    (0, $cFHGC._)(HelperManager, [
        {
            key: "__init",
            value: function __init() {
                this.helperNames = {};
            }
        },
        {
            key: "__init2",
            value: function __init2() {
                this.createRequireName = null;
            }
        },
        {
            key: "getHelperName",
            value: function getHelperName(baseName) {
                var helperName = this.helperNames[baseName];
                if (helperName) return helperName;
                helperName = this.nameManager.claimFreeName("_".concat(baseName));
                this.helperNames[baseName] = helperName;
                return helperName;
            }
        },
        {
            key: "emitHelpers",
            value: function emitHelpers() {
                var resultCode = "";
                if (this.helperNames.optionalChainDelete) this.getHelperName("optionalChain");
                if (this.helperNames.asyncOptionalChainDelete) this.getHelperName("asyncOptionalChain");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries($13685afd3632ccc0$var$HELPERS)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $f9AOD._)(_step.value, 2), baseName = _step_value[0], helperCodeTemplate = _step_value[1];
                        var helperName = this.helperNames[baseName];
                        var helperCode = helperCodeTemplate;
                        if (baseName === "optionalChainDelete") helperCode = helperCode.replace("OPTIONAL_CHAIN_NAME", this.helperNames.optionalChain);
                        else if (baseName === "asyncOptionalChainDelete") helperCode = helperCode.replace("ASYNC_OPTIONAL_CHAIN_NAME", this.helperNames.asyncOptionalChain);
                        else if (baseName === "require") {
                            if (this.createRequireName === null) this.createRequireName = this.nameManager.claimFreeName("_createRequire");
                            helperCode = helperCode.replace(/CREATE_REQUIRE_NAME/g, this.createRequireName);
                        }
                        if (helperName) {
                            resultCode += " ";
                            resultCode += helperCode.replace(baseName, helperName).replace(/\s+/g, " ").trim();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return resultCode;
            }
        }
    ]);
    return HelperManager;
}();




function $94eca5bd9dd2b130$export$2e2bcd8739ae039(tokens, scopes, globalNames) {
    if (!$94eca5bd9dd2b130$export$c1aa0d0852b733f5(tokens, globalNames)) return;
    $94eca5bd9dd2b130$var$markShadowedGlobals(tokens, scopes, globalNames);
}
function $94eca5bd9dd2b130$export$c1aa0d0852b733f5(tokens, globalNames) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = tokens.tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var token = _step.value;
            if (token.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).name && !token.isType && (0, $e2df986cc8bbbda9$export$268f8ae8b035d918)(token) && globalNames.has(tokens.identifierNameForToken(token))) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $94eca5bd9dd2b130$var$markShadowedGlobals(tokens, scopes, globalNames) {
    var scopeStack = [];
    var scopeIndex = scopes.length - 1;
    // Scopes were generated at completion time, so they're sorted by end index, so we can maintain a
    // good stack by going backwards through them.
    for(var i = tokens.tokens.length - 1;; i--){
        while(scopeStack.length > 0 && scopeStack[scopeStack.length - 1].startTokenIndex === i + 1)scopeStack.pop();
        while(scopeIndex >= 0 && scopes[scopeIndex].endTokenIndex === i + 1){
            scopeStack.push(scopes[scopeIndex]);
            scopeIndex--;
        }
        // Process scopes after the last iteration so we can make sure we pop all of them.
        if (i < 0) break;
        var token = tokens.tokens[i];
        var name = tokens.identifierNameForToken(token);
        if (scopeStack.length > 1 && !token.isType && token.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).name && globalNames.has(name)) {
            if ((0, $e2df986cc8bbbda9$export$6aae06a56367d123)(token)) $94eca5bd9dd2b130$var$markShadowedForScope(scopeStack[scopeStack.length - 1], tokens, name);
            else if ((0, $e2df986cc8bbbda9$export$157aa1605fc4e080)(token)) {
                var stackIndex = scopeStack.length - 1;
                while(stackIndex > 0 && !scopeStack[stackIndex].isFunctionScope)stackIndex--;
                if (stackIndex < 0) throw new Error("Did not find parent function scope.");
                $94eca5bd9dd2b130$var$markShadowedForScope(scopeStack[stackIndex], tokens, name);
            }
        }
    }
    if (scopeStack.length > 0) throw new Error("Expected empty scope stack after processing file.");
}
function $94eca5bd9dd2b130$var$markShadowedForScope(scope, tokens, name) {
    for(var i = scope.startTokenIndex; i < scope.endTokenIndex; i++){
        var token = tokens.tokens[i];
        if ((token.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).name || token.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxName) && tokens.identifierNameForToken(token) === name) token.shadowsGlobal = true;
    }
}



var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

function $7ec29e635da6786d$export$2e2bcd8739ae039(code, tokens) {
    var names = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var token = _step.value;
            if (token.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) names.push(code.slice(token.start, token.end));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return names;
}


var $2e2ed5a6d21d4ed4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function NameManager(code, tokens) {
        (0, $173N4._)(this, NameManager);
        NameManager.prototype.__init.call(this);
        this.usedNames = new Set((0, $7ec29e635da6786d$export$2e2bcd8739ae039)(code, tokens));
    }
    (0, $cFHGC._)(NameManager, [
        {
            key: "__init",
            value: function __init() {
                this.usedNames = new Set();
            }
        },
        {
            key: "claimFreeName",
            value: function claimFreeName(name) {
                var newName = this.findFreeName(name);
                this.usedNames.add(newName);
                return newName;
            }
        },
        {
            key: "findFreeName",
            value: function findFreeName(name) {
                if (!this.usedNames.has(name)) return name;
                var suffixNum = 2;
                while(this.usedNames.has(name + String(suffixNum)))suffixNum++;
                return name + String(suffixNum);
            }
        }
    ]);
    return NameManager;
}();


var $1afaa5110dbefeee$exports = {};
"use strict";
var $1afaa5110dbefeee$var$__spreadArrays = $1afaa5110dbefeee$exports && $1afaa5110dbefeee$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty($1afaa5110dbefeee$exports, "__esModule", {
    value: true
});
$1afaa5110dbefeee$exports.Checker = $1afaa5110dbefeee$exports.createCheckers = void 0;

var $lR0Op = parcelRequire("lR0Op");

var $5Qkok = parcelRequire("5Qkok");

var $lR0Op = parcelRequire("lR0Op");
Object.defineProperty($1afaa5110dbefeee$exports, "TArray", {
    enumerable: true,
    get: function get() {
        return $lR0Op.TArray;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "TEnumType", {
    enumerable: true,
    get: function get() {
        return $lR0Op.TEnumType;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "TEnumLiteral", {
    enumerable: true,
    get: function get() {
        return $lR0Op.TEnumLiteral;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "TFunc", {
    enumerable: true,
    get: function get() {
        return $lR0Op.TFunc;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "TIface", {
    enumerable: true,
    get: function get() {
        return $lR0Op.TIface;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "TLiteral", {
    enumerable: true,
    get: function get() {
        return $lR0Op.TLiteral;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "TName", {
    enumerable: true,
    get: function get() {
        return $lR0Op.TName;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "TOptional", {
    enumerable: true,
    get: function get() {
        return $lR0Op.TOptional;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "TParam", {
    enumerable: true,
    get: function get() {
        return $lR0Op.TParam;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "TParamList", {
    enumerable: true,
    get: function get() {
        return $lR0Op.TParamList;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "TProp", {
    enumerable: true,
    get: function get() {
        return $lR0Op.TProp;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "TTuple", {
    enumerable: true,
    get: function get() {
        return $lR0Op.TTuple;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "TType", {
    enumerable: true,
    get: function get() {
        return $lR0Op.TType;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "TUnion", {
    enumerable: true,
    get: function get() {
        return $lR0Op.TUnion;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "TIntersection", {
    enumerable: true,
    get: function get() {
        return $lR0Op.TIntersection;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "array", {
    enumerable: true,
    get: function get() {
        return $lR0Op.array;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "enumlit", {
    enumerable: true,
    get: function get() {
        return $lR0Op.enumlit;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "enumtype", {
    enumerable: true,
    get: function get() {
        return $lR0Op.enumtype;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "func", {
    enumerable: true,
    get: function get() {
        return $lR0Op.func;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "iface", {
    enumerable: true,
    get: function get() {
        return $lR0Op.iface;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "lit", {
    enumerable: true,
    get: function get() {
        return $lR0Op.lit;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "name", {
    enumerable: true,
    get: function get() {
        return $lR0Op.name;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "opt", {
    enumerable: true,
    get: function get() {
        return $lR0Op.opt;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "param", {
    enumerable: true,
    get: function get() {
        return $lR0Op.param;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "tuple", {
    enumerable: true,
    get: function get() {
        return $lR0Op.tuple;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "union", {
    enumerable: true,
    get: function get() {
        return $lR0Op.union;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "intersection", {
    enumerable: true,
    get: function get() {
        return $lR0Op.intersection;
    }
});
Object.defineProperty($1afaa5110dbefeee$exports, "BasicType", {
    enumerable: true,
    get: function get() {
        return $lR0Op.BasicType;
    }
});

var $5Qkok = parcelRequire("5Qkok");
Object.defineProperty($1afaa5110dbefeee$exports, "VError", {
    enumerable: true,
    get: function get() {
        return $5Qkok.VError;
    }
});
/**
 * Takes one of more type suites (e.g. a module generated by `ts-interface-builder`), and combines
 * them into a suite of interface checkers. If a type is used by name, that name should be present
 * among the passed-in type suites.
 *
 * The returned object maps type names to Checker objects.
 */ function $1afaa5110dbefeee$var$createCheckers() {
    var typeSuite = [];
    for(var _i = 0; _i < arguments.length; _i++)typeSuite[_i] = arguments[_i];
    var fullSuite = Object.assign.apply(Object, $1afaa5110dbefeee$var$__spreadArrays([
        {},
        $lR0Op.basicTypes
    ], typeSuite));
    var checkers = {};
    for(var _a = 0, typeSuite_1 = typeSuite; _a < typeSuite_1.length; _a++){
        var suite_1 = typeSuite_1[_a];
        for(var _b = 0, _c = Object.keys(suite_1); _b < _c.length; _b++){
            var name = _c[_b];
            checkers[name] = new $1afaa5110dbefeee$var$Checker(fullSuite, suite_1[name]);
        }
    }
    return checkers;
}
$1afaa5110dbefeee$exports.createCheckers = $1afaa5110dbefeee$var$createCheckers;
/**
 * Checker implements validation of objects, and also includes accessors to validate method calls.
 * Checkers should be created using `createCheckers()`.
 */ var $1afaa5110dbefeee$var$Checker = /** @class */ function() {
    // Create checkers by using `createCheckers()` function.
    function Checker(suite, ttype, _path) {
        if (_path === void 0) _path = 'value';
        this.suite = suite;
        this.ttype = ttype;
        this._path = _path;
        this.props = new Map();
        if (ttype instanceof $lR0Op.TIface) for(var _i = 0, _a = ttype.props; _i < _a.length; _i++){
            var p = _a[_i];
            this.props.set(p.name, p.ttype);
        }
        this.checkerPlain = this.ttype.getChecker(suite, false);
        this.checkerStrict = this.ttype.getChecker(suite, true);
    }
    /**
     * Set the path to report in errors, instead of the default "value". (E.g. if the Checker is for
     * a "person" interface, set path to "person" to report e.g. "person.name is not a string".)
     */ Checker.prototype.setReportedPath = function(path) {
        this._path = path;
    };
    /**
     * Check that the given value satisfies this checker's type, or throw Error.
     */ Checker.prototype.check = function(value) {
        return this._doCheck(this.checkerPlain, value);
    };
    /**
     * A fast check for whether or not the given value satisfies this Checker's type. This returns
     * true or false, does not produce an error message, and is fast both on success and on failure.
     */ Checker.prototype.test = function(value) {
        return this.checkerPlain(value, new $5Qkok.NoopContext());
    };
    /**
     * Returns an error object describing the errors if the given value does not satisfy this
     * Checker's type, or null if it does.
     */ Checker.prototype.validate = function(value) {
        return this._doValidate(this.checkerPlain, value);
    };
    /**
     * Check that the given value satisfies this checker's type strictly. This checks that objects
     * and tuples have no extra members. Note that this prevents backward compatibility, so usually
     * a plain check() is more appropriate.
     */ Checker.prototype.strictCheck = function(value) {
        return this._doCheck(this.checkerStrict, value);
    };
    /**
     * A fast strict check for whether or not the given value satisfies this Checker's type. Returns
     * true or false, does not produce an error message, and is fast both on success and on failure.
     */ Checker.prototype.strictTest = function(value) {
        return this.checkerStrict(value, new $5Qkok.NoopContext());
    };
    /**
     * Returns an error object describing the errors if the given value does not satisfy this
     * Checker's type strictly, or null if it does.
     */ Checker.prototype.strictValidate = function(value) {
        return this._doValidate(this.checkerStrict, value);
    };
    /**
     * If this checker is for an interface, returns a Checker for the type required for the given
     * property of this interface.
     */ Checker.prototype.getProp = function(prop) {
        var ttype = this.props.get(prop);
        if (!ttype) throw new Error("Type has no property " + prop);
        return new Checker(this.suite, ttype, this._path + "." + prop);
    };
    /**
     * If this checker is for an interface, returns a Checker for the argument-list required to call
     * the given method of this interface. E.g. if this Checker is for the interface:
     *    interface Foo {
     *      find(s: string, pos?: number): number;
     *    }
     * Then methodArgs("find").check(...) will succeed for ["foo"] and ["foo", 3], but not for [17].
     */ Checker.prototype.methodArgs = function(methodName) {
        var tfunc = this._getMethod(methodName);
        return new Checker(this.suite, tfunc.paramList);
    };
    /**
     * If this checker is for an interface, returns a Checker for the return value of the given
     * method of this interface.
     */ Checker.prototype.methodResult = function(methodName) {
        var tfunc = this._getMethod(methodName);
        return new Checker(this.suite, tfunc.result);
    };
    /**
     * If this checker is for a function, returns a Checker for its argument-list.
     */ Checker.prototype.getArgs = function() {
        if (!(this.ttype instanceof $lR0Op.TFunc)) throw new Error("getArgs() applied to non-function");
        return new Checker(this.suite, this.ttype.paramList);
    };
    /**
     * If this checker is for a function, returns a Checker for its result.
     */ Checker.prototype.getResult = function() {
        if (!(this.ttype instanceof $lR0Op.TFunc)) throw new Error("getResult() applied to non-function");
        return new Checker(this.suite, this.ttype.result);
    };
    /**
     * Return the type for which this is a checker.
     */ Checker.prototype.getType = function() {
        return this.ttype;
    };
    /**
     * Actual implementation of check() and strictCheck().
     */ Checker.prototype._doCheck = function(checkerFunc, value) {
        var noopCtx = new $5Qkok.NoopContext();
        if (!checkerFunc(value, noopCtx)) {
            var detailCtx = new $5Qkok.DetailContext();
            checkerFunc(value, detailCtx);
            throw detailCtx.getError(this._path);
        }
    };
    Checker.prototype._doValidate = function(checkerFunc, value) {
        var noopCtx = new $5Qkok.NoopContext();
        if (checkerFunc(value, noopCtx)) return null;
        var detailCtx = new $5Qkok.DetailContext();
        checkerFunc(value, detailCtx);
        return detailCtx.getErrorDetail(this._path);
    };
    Checker.prototype._getMethod = function(methodName) {
        var ttype = this.props.get(methodName);
        if (!ttype) throw new Error("Type has no property " + methodName);
        if (!(ttype instanceof $lR0Op.TFunc)) throw new Error("Property " + methodName + " is not a method");
        return ttype;
    };
    return Checker;
}();
$1afaa5110dbefeee$exports.Checker = $1afaa5110dbefeee$var$Checker;


/**
 * This module was automatically generated by `ts-interface-builder`
 */ 
var $5557fcdd9c967955$export$563a914cafbdc389 = $1afaa5110dbefeee$exports.union($1afaa5110dbefeee$exports.lit("jsx"), $1afaa5110dbefeee$exports.lit("typescript"), $1afaa5110dbefeee$exports.lit("flow"), $1afaa5110dbefeee$exports.lit("imports"), $1afaa5110dbefeee$exports.lit("react-hot-loader"), $1afaa5110dbefeee$exports.lit("jest"));
var $5557fcdd9c967955$export$6314eb8a2e5cb73e = $1afaa5110dbefeee$exports.iface([], {
    compiledFilename: "string"
});
var $5557fcdd9c967955$export$c019608e5b5bb4cb = $1afaa5110dbefeee$exports.iface([], {
    transforms: $1afaa5110dbefeee$exports.array("Transform"),
    disableESTransforms: $1afaa5110dbefeee$exports.opt("boolean"),
    jsxRuntime: $1afaa5110dbefeee$exports.opt($1afaa5110dbefeee$exports.union($1afaa5110dbefeee$exports.lit("classic"), $1afaa5110dbefeee$exports.lit("automatic"), $1afaa5110dbefeee$exports.lit("preserve"))),
    production: $1afaa5110dbefeee$exports.opt("boolean"),
    jsxImportSource: $1afaa5110dbefeee$exports.opt("string"),
    jsxPragma: $1afaa5110dbefeee$exports.opt("string"),
    jsxFragmentPragma: $1afaa5110dbefeee$exports.opt("string"),
    keepUnusedImports: $1afaa5110dbefeee$exports.opt("boolean"),
    preserveDynamicImport: $1afaa5110dbefeee$exports.opt("boolean"),
    injectCreateRequireForImportRequire: $1afaa5110dbefeee$exports.opt("boolean"),
    enableLegacyTypeScriptModuleInterop: $1afaa5110dbefeee$exports.opt("boolean"),
    enableLegacyBabel5ModuleInterop: $1afaa5110dbefeee$exports.opt("boolean"),
    sourceMapOptions: $1afaa5110dbefeee$exports.opt("SourceMapOptions"),
    filePath: $1afaa5110dbefeee$exports.opt("string")
});
var $5557fcdd9c967955$var$exportedTypeSuite = {
    Transform: $5557fcdd9c967955$export$563a914cafbdc389,
    SourceMapOptions: $5557fcdd9c967955$export$6314eb8a2e5cb73e,
    Options: $5557fcdd9c967955$export$c019608e5b5bb4cb
};
var $5557fcdd9c967955$export$2e2bcd8739ae039 = $5557fcdd9c967955$var$exportedTypeSuite;


var $0296dc5ee5a905be$var$_createCheckers = (0, $1afaa5110dbefeee$exports.createCheckers)((0, $5557fcdd9c967955$export$2e2bcd8739ae039)), $0296dc5ee5a905be$var$OptionsChecker = $0296dc5ee5a905be$var$_createCheckers.Options;
function $0296dc5ee5a905be$export$1dd09873c1bdd0fc(options) {
    $0296dc5ee5a905be$var$OptionsChecker.strictCheck(options);
}



var $173N4 = parcelRequire("173N4");




/* eslint max-len: 0 */ 
/* eslint max-len: 0 */ 



/* eslint max-len: 0 */ // A recursive descent parser operates by defining functions for all
// syntactic elements, and recursively calling those, each function
// advancing the input stream and returning an AST node. Precedence
// of constructs (for example, the fact that `!x[1]` means `!(x[1])`
// instead of `(!x)[1]` is handled by the fact that the parser
// function that parses unary prefix operators is called first, and
// in turn calls the function that parses `[]` subscripts — that
// way, it'll receive the node for `x[1]` already parsed, and wraps
// *that* in the unary operator node.
//
// Acorn uses an [operator precedence parser][opp] to handle binary
// operator precedence, because it is much more compact than using
// the technique outlined above, which uses different, nesting
// functions to specify precedence, for all of the ten binary
// precedence levels that JavaScript defines.
//
// [opp]: http://en.wikipedia.org/wiki/Operator-precedence_parser

var $173N4 = parcelRequire("173N4");





















function $43e5b81ee278119a$export$83bfd0877be8807a() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    (0, $9d7bd82cb980c61d$export$b97bbe8a7805284f)(false);
}
function $43e5b81ee278119a$export$9504bd2748b5750c(isBlockScope) {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    $43e5b81ee278119a$export$e1f90e6766854abd(isBlockScope);
}
function $43e5b81ee278119a$export$7538cb03fa894c83(isBlockScope) {
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    $43e5b81ee278119a$export$80e4117797ed03a6(isBlockScope);
}
function $43e5b81ee278119a$export$cba413304e86fc0d() {
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ImportDeclaration;
}
function $43e5b81ee278119a$export$80e4117797ed03a6(isBlockScope) {
    var identifierRole;
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth === 0) identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).TopLevelDeclaration;
    else if (isBlockScope) identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).BlockScopedDeclaration;
    else identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).FunctionScopedDeclaration;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = identifierRole;
}
function $43e5b81ee278119a$export$e1f90e6766854abd(isBlockScope) {
    switch((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type){
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._this:
            {
                // In TypeScript, "this" may be the name of a parameter, so allow it.
                var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(0);
                (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
                (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
                return;
            }
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._yield:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).name:
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type = (0, $30a0d13de21d779e$export$f435f793048e7a0f).name;
            $43e5b81ee278119a$export$7538cb03fa894c83(isBlockScope);
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL:
            (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
            $43e5b81ee278119a$export$befa6d966a25698e((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR, isBlockScope, true);
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL:
            (0, $9d7bd82cb980c61d$export$908e61e44ae774e)(true, isBlockScope);
            return;
        default:
            (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
    }
}
function $43e5b81ee278119a$export$befa6d966a25698e(close, isBlockScope) {
    var allowEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, allowModifiers = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, contextId = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
    var first = true;
    var hasRemovedComma = false;
    var firstItemTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    while(!(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)(close) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
            // After a "this" type in TypeScript, we need to set the following comma (if any) to also be
            // a type token so that it will be removed.
            if (!hasRemovedComma && (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[firstItemTokenIndex].isType) {
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
                hasRemovedComma = true;
            }
        }
        if (allowEmpty && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) ;
        else if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)(close)) break;
        else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).ellipsis)) {
            $43e5b81ee278119a$export$9504bd2748b5750c(isBlockScope);
            $43e5b81ee278119a$var$parseAssignableListItemTypes();
            // Support rest element trailing commas allowed by TypeScript <2.9.
            (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)(close);
            break;
        } else $43e5b81ee278119a$var$parseAssignableListItem(allowModifiers, isBlockScope);
    }
}
function $43e5b81ee278119a$var$parseAssignableListItem(allowModifiers, isBlockScope) {
    if (allowModifiers) (0, $f50510ec4ff63acc$export$77616e6d401f584a)([
        (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._public,
        (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._protected,
        (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._private,
        (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._readonly,
        (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._override
    ]);
    $43e5b81ee278119a$export$867fe1bcec5186c9(isBlockScope);
    $43e5b81ee278119a$var$parseAssignableListItemTypes();
    $43e5b81ee278119a$export$867fe1bcec5186c9(isBlockScope, true);
}
function $43e5b81ee278119a$var$parseAssignableListItemTypes() {
    if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) (0, $37322500987f8c0d$export$a9031cdcb39989e3)();
    else if (0, $875661fa68d3a4de$export$757c2735689d2de8) (0, $f50510ec4ff63acc$export$9b46e2c9fd90d888)();
}
function $43e5b81ee278119a$export$867fe1bcec5186c9(isBlockScope) {
    var leftAlreadyParsed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!leftAlreadyParsed) $43e5b81ee278119a$export$e1f90e6766854abd(isBlockScope);
    if (!(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) return;
    var eqIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1;
    (0, $9d7bd82cb980c61d$export$b97bbe8a7805284f)();
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[eqIndex].rhsEndIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
}





function $f50510ec4ff63acc$var$tsIsIdentifier() {
    // TODO: actually a bit more complex in TypeScript, but shouldn't matter.
    // See https://github.com/Microsoft/TypeScript/issues/15008
    return (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name);
}
function $f50510ec4ff63acc$var$isLiteralPropertyName() {
    return (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name) || Boolean((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type & (0, $30a0d13de21d779e$export$f435f793048e7a0f).IS_KEYWORD) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).string) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).num) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bigint) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).decimal);
}
function $f50510ec4ff63acc$var$tsNextTokenCanFollowModifier() {
    // Note: TypeScript's implementation is much more complicated because
    // more things are considered modifiers there.
    // This implementation only handles modifiers not handled by babylon itself. And "static".
    // TODO: Would be nice to avoid lookahead. Want a hasLineBreakUpNext() method...
    var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    var canFollowModifier = ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).star) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).ellipsis) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).hash) || $f50510ec4ff63acc$var$isLiteralPropertyName()) && !(0, $40d5f3c610bd8f72$export$942fa35f3a7c108c)();
    if (canFollowModifier) return true;
    else {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return false;
    }
}
function $f50510ec4ff63acc$export$77616e6d401f584a(allowedModifiers) {
    while(true){
        var modifier = $f50510ec4ff63acc$export$a90a97ddca783020(allowedModifiers);
        if (modifier === null) break;
    }
}
function $f50510ec4ff63acc$export$a90a97ddca783020(allowedModifiers) {
    if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) return null;
    var modifier = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).contextualKeyword;
    if (allowedModifiers.indexOf(modifier) !== -1 && $f50510ec4ff63acc$var$tsNextTokenCanFollowModifier()) {
        switch(modifier){
            case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._readonly:
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._readonly;
                break;
            case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._abstract:
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._abstract;
                break;
            case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._static:
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._static;
                break;
            case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._public:
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._public;
                break;
            case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._private:
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._private;
                break;
            case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._protected:
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._protected;
                break;
            case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._override:
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._override;
                break;
            case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._declare:
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._declare;
                break;
            default:
                break;
        }
        return modifier;
    }
    return null;
}
function $f50510ec4ff63acc$var$tsParseEntityName() {
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    while((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).dot))(0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
}
function $f50510ec4ff63acc$var$tsParseTypeReference() {
    $f50510ec4ff63acc$var$tsParseEntityName();
    if (!(0, $40d5f3c610bd8f72$export$942fa35f3a7c108c)() && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) $f50510ec4ff63acc$var$tsParseTypeArguments();
}
function $f50510ec4ff63acc$var$tsParseThisTypePredicate() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    $f50510ec4ff63acc$export$728a3256ac690042();
}
function $f50510ec4ff63acc$var$tsParseThisTypeNode() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
}
function $f50510ec4ff63acc$var$tsParseTypeQuery() {
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._typeof);
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._import)) $f50510ec4ff63acc$var$tsParseImportType();
    else $f50510ec4ff63acc$var$tsParseEntityName();
    if (!(0, $40d5f3c610bd8f72$export$942fa35f3a7c108c)() && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) $f50510ec4ff63acc$var$tsParseTypeArguments();
}
function $f50510ec4ff63acc$var$tsParseImportType() {
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._import);
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL);
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).string);
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).dot)) $f50510ec4ff63acc$var$tsParseEntityName();
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) $f50510ec4ff63acc$var$tsParseTypeArguments();
}
function $f50510ec4ff63acc$var$tsParseTypeParameter() {
    (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._const);
    var hadIn = (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._in);
    var hadOut = (0, $40d5f3c610bd8f72$export$b8f8f7fffeb6fb36)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._out);
    (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._const);
    if ((hadIn || hadOut) && !(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) // The "in" or "out" keyword must have actually been the type parameter
    // name, so set it as the name.
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f).name;
    else (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._extends)) $f50510ec4ff63acc$export$13a289e680c077c1();
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) $f50510ec4ff63acc$export$13a289e680c077c1();
}
function $f50510ec4ff63acc$export$827faab4e65d5897() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) $f50510ec4ff63acc$var$tsParseTypeParameters();
}
function $f50510ec4ff63acc$var$tsParseTypeParameters() {
    var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(0);
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).typeParameterStart)) (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    else (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
    while(!(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).greaterThan) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        $f50510ec4ff63acc$var$tsParseTypeParameter();
        (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
    }
    (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
}
// Note: In TypeScript implementation we must provide `yieldContext` and `awaitContext`,
// but here it's always false, because this is only used for types.
function $f50510ec4ff63acc$var$tsFillSignature(returnToken) {
    // Arrow fns *must* have return token (`=>`). Normal functions can omit it.
    var returnTokenRequired = returnToken === (0, $30a0d13de21d779e$export$f435f793048e7a0f).arrow;
    $f50510ec4ff63acc$export$827faab4e65d5897();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL);
    // Create a scope even though we're doing type parsing so we don't accidentally
    // treat params as top-level bindings.
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth++;
    $f50510ec4ff63acc$var$tsParseBindingListForSignature(false);
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth--;
    if (returnTokenRequired) $f50510ec4ff63acc$var$tsParseTypeOrTypePredicateAnnotation(returnToken);
    else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)(returnToken)) $f50510ec4ff63acc$var$tsParseTypeOrTypePredicateAnnotation(returnToken);
}
function $f50510ec4ff63acc$var$tsParseBindingListForSignature(isBlockScope) {
    (0, $43e5b81ee278119a$export$befa6d966a25698e)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR, isBlockScope);
}
function $f50510ec4ff63acc$var$tsParseTypeMemberSemicolon() {
    if (!(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
}
function $f50510ec4ff63acc$var$tsParseSignatureMember() {
    $f50510ec4ff63acc$var$tsFillSignature((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon);
    $f50510ec4ff63acc$var$tsParseTypeMemberSemicolon();
}
function $f50510ec4ff63acc$var$tsIsUnambiguouslyIndexSignature() {
    var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)(); // Skip '{'
    var isIndexSignature = (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name) && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon);
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return isIndexSignature;
}
function $f50510ec4ff63acc$var$tsTryParseIndexSignature() {
    if (!((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL) && $f50510ec4ff63acc$var$tsIsUnambiguouslyIndexSignature())) return false;
    var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(0);
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL);
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    $f50510ec4ff63acc$export$728a3256ac690042();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR);
    $f50510ec4ff63acc$export$e4623eb563192e0f();
    $f50510ec4ff63acc$var$tsParseTypeMemberSemicolon();
    (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
    return true;
}
function $f50510ec4ff63acc$var$tsParsePropertyOrMethodSignature(isReadonly) {
    (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).question);
    if (!isReadonly && ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan))) {
        $f50510ec4ff63acc$var$tsFillSignature((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon);
        $f50510ec4ff63acc$var$tsParseTypeMemberSemicolon();
    } else {
        $f50510ec4ff63acc$export$e4623eb563192e0f();
        $f50510ec4ff63acc$var$tsParseTypeMemberSemicolon();
    }
}
function $f50510ec4ff63acc$var$tsParseTypeMember() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) {
        // call signature
        $f50510ec4ff63acc$var$tsParseSignatureMember();
        return;
    }
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._new)) {
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) // constructor signature
        $f50510ec4ff63acc$var$tsParseSignatureMember();
        else $f50510ec4ff63acc$var$tsParsePropertyOrMethodSignature(false);
        return;
    }
    var readonly = !!$f50510ec4ff63acc$export$a90a97ddca783020([
        (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._readonly
    ]);
    var found = $f50510ec4ff63acc$var$tsTryParseIndexSignature();
    if (found) return;
    ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._get) || (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._set)) && $f50510ec4ff63acc$var$tsNextTokenCanFollowModifier();
    (0, $9d7bd82cb980c61d$export$ab65037f9c8fb3d3)(-1 /* Types don't need context IDs. */ );
    $f50510ec4ff63acc$var$tsParsePropertyOrMethodSignature(readonly);
}
function $f50510ec4ff63acc$var$tsParseTypeLiteral() {
    $f50510ec4ff63acc$var$tsParseObjectTypeMembers();
}
function $f50510ec4ff63acc$var$tsParseObjectTypeMembers() {
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
    while(!(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error)$f50510ec4ff63acc$var$tsParseTypeMember();
}
function $f50510ec4ff63acc$var$tsLookaheadIsStartOfMappedType() {
    var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
    var isStartOfMappedType = $f50510ec4ff63acc$var$tsIsStartOfMappedType();
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return isStartOfMappedType;
}
function $f50510ec4ff63acc$var$tsIsStartOfMappedType() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).plus) || (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).minus)) return (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._readonly);
    if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._readonly)) (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL)) return false;
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    if (!$f50510ec4ff63acc$var$tsIsIdentifier()) return false;
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    return (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._in);
}
function $f50510ec4ff63acc$var$tsParseMappedTypeParameter() {
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._in);
    $f50510ec4ff63acc$export$13a289e680c077c1();
}
function $f50510ec4ff63acc$var$tsParseMappedType() {
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).plus) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).minus)) {
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._readonly);
    } else (0, $40d5f3c610bd8f72$export$b8f8f7fffeb6fb36)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._readonly);
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL);
    $f50510ec4ff63acc$var$tsParseMappedTypeParameter();
    if ((0, $40d5f3c610bd8f72$export$b8f8f7fffeb6fb36)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._as)) $f50510ec4ff63acc$export$13a289e680c077c1();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR);
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).plus) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).minus)) {
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).question);
    } else (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).question);
    $f50510ec4ff63acc$var$tsTryParseType();
    (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR);
}
function $f50510ec4ff63acc$var$tsParseTupleType() {
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL);
    while(!(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        // Do not validate presence of either none or only labeled elements
        $f50510ec4ff63acc$var$tsParseTupleElementType();
        (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
    }
}
function $f50510ec4ff63acc$var$tsParseTupleElementType() {
    // parses `...TsType[]`
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).ellipsis)) $f50510ec4ff63acc$export$13a289e680c077c1();
    else {
        // parses `TsType?`
        $f50510ec4ff63acc$export$13a289e680c077c1();
        (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).question);
    }
    // The type we parsed above was actually a label
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon)) // Labeled tuple types must affix the label with `...` or `?`, so no need to handle those here
    $f50510ec4ff63acc$export$13a289e680c077c1();
}
function $f50510ec4ff63acc$var$tsParseParenthesizedType() {
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL);
    $f50510ec4ff63acc$export$13a289e680c077c1();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
}
function $f50510ec4ff63acc$var$tsParseTemplateLiteralType() {
    // Finish `, read quasi
    (0, $e2df986cc8bbbda9$export$e4355ff2fab571ee)();
    // Finish quasi, read ${
    (0, $e2df986cc8bbbda9$export$e4355ff2fab571ee)();
    while(!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).backQuote) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).dollarBraceL);
        $f50510ec4ff63acc$export$13a289e680c077c1();
        // Finish }, read quasi
        (0, $e2df986cc8bbbda9$export$e4355ff2fab571ee)();
        // Finish quasi, read either ${ or `
        (0, $e2df986cc8bbbda9$export$e4355ff2fab571ee)();
    }
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
}
var $f50510ec4ff63acc$var$FunctionType;
(function(FunctionType) {
    var TSFunctionType = 0;
    FunctionType[FunctionType["TSFunctionType"] = TSFunctionType] = "TSFunctionType";
    var TSConstructorType = TSFunctionType + 1;
    FunctionType[FunctionType["TSConstructorType"] = TSConstructorType] = "TSConstructorType";
    var TSAbstractConstructorType = TSConstructorType + 1;
    FunctionType[FunctionType["TSAbstractConstructorType"] = TSAbstractConstructorType] = "TSAbstractConstructorType";
})($f50510ec4ff63acc$var$FunctionType || ($f50510ec4ff63acc$var$FunctionType = {}));
function $f50510ec4ff63acc$var$tsParseFunctionOrConstructorType(type) {
    if (type === $f50510ec4ff63acc$var$FunctionType.TSAbstractConstructorType) (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._abstract);
    if (type === $f50510ec4ff63acc$var$FunctionType.TSConstructorType || type === $f50510ec4ff63acc$var$FunctionType.TSAbstractConstructorType) (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._new);
    var oldInDisallowConditionalTypesContext = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).inDisallowConditionalTypesContext;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = false;
    $f50510ec4ff63acc$var$tsFillSignature((0, $30a0d13de21d779e$export$f435f793048e7a0f).arrow);
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
}
function $f50510ec4ff63acc$var$tsParseNonArrayType() {
    switch((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type){
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).name:
            $f50510ec4ff63acc$var$tsParseTypeReference();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._void:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._null:
            (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).string:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).num:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).bigint:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).decimal:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._true:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._false:
            (0, $9d7bd82cb980c61d$export$d1b3e78ad34a47ef)();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).minus:
            (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
            (0, $9d7bd82cb980c61d$export$d1b3e78ad34a47ef)();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._this:
            $f50510ec4ff63acc$var$tsParseThisTypeNode();
            if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._is) && !(0, $40d5f3c610bd8f72$export$942fa35f3a7c108c)()) $f50510ec4ff63acc$var$tsParseThisTypePredicate();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._typeof:
            $f50510ec4ff63acc$var$tsParseTypeQuery();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._import:
            $f50510ec4ff63acc$var$tsParseImportType();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL:
            if ($f50510ec4ff63acc$var$tsLookaheadIsStartOfMappedType()) $f50510ec4ff63acc$var$tsParseMappedType();
            else $f50510ec4ff63acc$var$tsParseTypeLiteral();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL:
            $f50510ec4ff63acc$var$tsParseTupleType();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL:
            $f50510ec4ff63acc$var$tsParseParenthesizedType();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).backQuote:
            $f50510ec4ff63acc$var$tsParseTemplateLiteralType();
            return;
        default:
            if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type & (0, $30a0d13de21d779e$export$f435f793048e7a0f).IS_KEYWORD) {
                (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f).name;
                return;
            }
            break;
    }
    (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
}
function $f50510ec4ff63acc$var$tsParseArrayTypeOrHigher() {
    $f50510ec4ff63acc$var$tsParseNonArrayType();
    while(!(0, $40d5f3c610bd8f72$export$942fa35f3a7c108c)() && (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL))if (!(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR)) {
        // If we hit ] immediately, this is an array type, otherwise it's an indexed access type.
        $f50510ec4ff63acc$export$13a289e680c077c1();
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR);
    }
}
function $f50510ec4ff63acc$var$tsParseInferType() {
    (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._infer);
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._extends)) {
        // Infer type constraints introduce an ambiguity about whether the "extends"
        // is a constraint for this infer type or is another conditional type.
        var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._extends);
        var oldInDisallowConditionalTypesContext = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).inDisallowConditionalTypesContext;
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = true;
        $f50510ec4ff63acc$export$13a289e680c077c1();
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
        if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).error || !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).inDisallowConditionalTypesContext && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).question)) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    }
}
function $f50510ec4ff63acc$var$tsParseTypeOperatorOrHigher() {
    if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._keyof) || (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._unique) || (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._readonly)) {
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        $f50510ec4ff63acc$var$tsParseTypeOperatorOrHigher();
    } else if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._infer)) $f50510ec4ff63acc$var$tsParseInferType();
    else {
        var oldInDisallowConditionalTypesContext = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).inDisallowConditionalTypesContext;
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = false;
        $f50510ec4ff63acc$var$tsParseArrayTypeOrHigher();
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
    }
}
function $f50510ec4ff63acc$var$tsParseIntersectionTypeOrHigher() {
    (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bitwiseAND);
    $f50510ec4ff63acc$var$tsParseTypeOperatorOrHigher();
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bitwiseAND)) while((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bitwiseAND))$f50510ec4ff63acc$var$tsParseTypeOperatorOrHigher();
}
function $f50510ec4ff63acc$var$tsParseUnionTypeOrHigher() {
    (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bitwiseOR);
    $f50510ec4ff63acc$var$tsParseIntersectionTypeOrHigher();
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bitwiseOR)) while((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bitwiseOR))$f50510ec4ff63acc$var$tsParseIntersectionTypeOrHigher();
}
function $f50510ec4ff63acc$var$tsIsStartOfFunctionType() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) return true;
    return (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL) && $f50510ec4ff63acc$var$tsLookaheadIsUnambiguouslyStartOfFunctionType();
}
function $f50510ec4ff63acc$var$tsSkipParameterStart() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._this)) {
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        return true;
    }
    // If this is a possible array/object destructure, walk to the matching bracket/brace.
    // The next token after will tell us definitively whether this is a function param.
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL)) {
        var depth = 1;
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        while(depth > 0 && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
            if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL)) depth++;
            else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR)) depth--;
            (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        }
        return true;
    }
    return false;
}
function $f50510ec4ff63acc$var$tsLookaheadIsUnambiguouslyStartOfFunctionType() {
    var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
    var isUnambiguouslyStartOfFunctionType = $f50510ec4ff63acc$var$tsIsUnambiguouslyStartOfFunctionType();
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return isUnambiguouslyStartOfFunctionType;
}
function $f50510ec4ff63acc$var$tsIsUnambiguouslyStartOfFunctionType() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).ellipsis)) // ( )
    // ( ...
    return true;
    if ($f50510ec4ff63acc$var$tsSkipParameterStart()) {
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).question) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) // ( xxx :
        // ( xxx ,
        // ( xxx ?
        // ( xxx =
        return true;
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR)) {
            (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
            if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).arrow)) // ( xxx ) =>
            return true;
        }
    }
    return false;
}
function $f50510ec4ff63acc$var$tsParseTypeOrTypePredicateAnnotation(returnToken) {
    var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(0);
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)(returnToken);
    var finishedReturn = $f50510ec4ff63acc$var$tsParseTypePredicateOrAssertsPrefix();
    if (!finishedReturn) $f50510ec4ff63acc$export$13a289e680c077c1();
    (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
}
function $f50510ec4ff63acc$var$tsTryParseTypeOrTypePredicateAnnotation() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon)) $f50510ec4ff63acc$var$tsParseTypeOrTypePredicateAnnotation((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon);
}
function $f50510ec4ff63acc$export$e4623eb563192e0f() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon)) $f50510ec4ff63acc$export$728a3256ac690042();
}
function $f50510ec4ff63acc$var$tsTryParseType() {
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon)) $f50510ec4ff63acc$export$13a289e680c077c1();
}
/**
 * Detect a few special return syntax cases: `x is T`, `asserts x`, `asserts x is T`,
 * `asserts this is T`.
 *
 * Returns true if we parsed the return type, false if there's still a type to be parsed.
 */ function $f50510ec4ff63acc$var$tsParseTypePredicateOrAssertsPrefix() {
    var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
    if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._asserts)) {
        // Normally this is `asserts x is T`, but at this point, it might be `asserts is T` (a user-
        // defined type guard on the `asserts` variable) or just a type called `asserts`.
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        if ((0, $40d5f3c610bd8f72$export$b8f8f7fffeb6fb36)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._is)) {
            // If we see `asserts is`, then this must be of the form `asserts is T`, since
            // `asserts is is T` isn't valid.
            $f50510ec4ff63acc$export$13a289e680c077c1();
            return true;
        } else if ($f50510ec4ff63acc$var$tsIsIdentifier() || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._this)) {
            (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
            if ((0, $40d5f3c610bd8f72$export$b8f8f7fffeb6fb36)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._is)) // If we see `is`, then this is `asserts x is T`. Otherwise, it's `asserts x`.
            $f50510ec4ff63acc$export$13a289e680c077c1();
            return true;
        } else {
            // Regular type, so bail out and start type parsing from scratch.
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            return false;
        }
    } else if ($f50510ec4ff63acc$var$tsIsIdentifier() || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._this)) {
        // This is a regular identifier, which may or may not have "is" after it.
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._is) && !(0, $40d5f3c610bd8f72$export$942fa35f3a7c108c)()) {
            (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
            $f50510ec4ff63acc$export$13a289e680c077c1();
            return true;
        } else {
            // Regular type, so bail out and start type parsing from scratch.
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            return false;
        }
    }
    return false;
}
function $f50510ec4ff63acc$export$728a3256ac690042() {
    var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(0);
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon);
    $f50510ec4ff63acc$export$13a289e680c077c1();
    (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
}
function $f50510ec4ff63acc$export$13a289e680c077c1() {
    $f50510ec4ff63acc$export$817427f5f29c80bc();
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).inDisallowConditionalTypesContext || (0, $40d5f3c610bd8f72$export$942fa35f3a7c108c)() || !(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._extends)) return;
    // extends type
    var oldInDisallowConditionalTypesContext = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).inDisallowConditionalTypesContext;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = true;
    $f50510ec4ff63acc$export$817427f5f29c80bc();
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).question);
    // true type
    $f50510ec4ff63acc$export$13a289e680c077c1();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon);
    // false type
    $f50510ec4ff63acc$export$13a289e680c077c1();
}
function $f50510ec4ff63acc$var$isAbstractConstructorSignature() {
    return (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._abstract) && (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)() === (0, $30a0d13de21d779e$export$f435f793048e7a0f)._new;
}
function $f50510ec4ff63acc$export$817427f5f29c80bc() {
    if ($f50510ec4ff63acc$var$tsIsStartOfFunctionType()) {
        $f50510ec4ff63acc$var$tsParseFunctionOrConstructorType($f50510ec4ff63acc$var$FunctionType.TSFunctionType);
        return;
    }
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._new)) {
        // As in `new () => Date`
        $f50510ec4ff63acc$var$tsParseFunctionOrConstructorType($f50510ec4ff63acc$var$FunctionType.TSConstructorType);
        return;
    } else if ($f50510ec4ff63acc$var$isAbstractConstructorSignature()) {
        // As in `abstract new () => Date`
        $f50510ec4ff63acc$var$tsParseFunctionOrConstructorType($f50510ec4ff63acc$var$FunctionType.TSAbstractConstructorType);
        return;
    }
    $f50510ec4ff63acc$var$tsParseUnionTypeOrHigher();
}
function $f50510ec4ff63acc$export$ecfac1712a900e29() {
    var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(1);
    $f50510ec4ff63acc$export$13a289e680c077c1();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).greaterThan);
    (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
    (0, $9d7bd82cb980c61d$export$165911d2b803e372)();
}
function $f50510ec4ff63acc$export$382de4b7ab7e7990() {
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagStart)) {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f).typeParameterStart;
        var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(1);
        while(!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).greaterThan) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
            $f50510ec4ff63acc$export$13a289e680c077c1();
            (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
        }
        // Process >, but the one after needs to be parsed JSX-style.
        (0, $2c27fc7dc0d1372f$export$a1b2c368381052e6)();
        (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
    }
}
function $f50510ec4ff63acc$var$tsParseHeritageClause() {
    while(!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        $f50510ec4ff63acc$var$tsParseExpressionWithTypeArguments();
        (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
    }
}
function $f50510ec4ff63acc$var$tsParseExpressionWithTypeArguments() {
    // Note: TS uses parseLeftHandSideExpressionOrHigher,
    // then has grammar errors later if it's not an EntityName.
    $f50510ec4ff63acc$var$tsParseEntityName();
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) $f50510ec4ff63acc$var$tsParseTypeArguments();
}
function $f50510ec4ff63acc$var$tsParseInterfaceDeclaration() {
    (0, $43e5b81ee278119a$export$7538cb03fa894c83)(false);
    $f50510ec4ff63acc$export$827faab4e65d5897();
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._extends)) $f50510ec4ff63acc$var$tsParseHeritageClause();
    $f50510ec4ff63acc$var$tsParseObjectTypeMembers();
}
function $f50510ec4ff63acc$var$tsParseTypeAliasDeclaration() {
    (0, $43e5b81ee278119a$export$7538cb03fa894c83)(false);
    $f50510ec4ff63acc$export$827faab4e65d5897();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq);
    $f50510ec4ff63acc$export$13a289e680c077c1();
    (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
}
function $f50510ec4ff63acc$var$tsParseEnumMember() {
    // Computed property names are grammar errors in an enum, so accept just string literal or identifier.
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).string)) (0, $9d7bd82cb980c61d$export$d1b3e78ad34a47ef)();
    else (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) {
        var eqIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1;
        (0, $9d7bd82cb980c61d$export$b97bbe8a7805284f)();
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[eqIndex].rhsEndIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    }
}
function $f50510ec4ff63acc$var$tsParseEnumDeclaration() {
    (0, $43e5b81ee278119a$export$7538cb03fa894c83)(false);
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
    while(!(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        $f50510ec4ff63acc$var$tsParseEnumMember();
        (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
    }
}
function $f50510ec4ff63acc$var$tsParseModuleBlock() {
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
    (0, $0568c3da8e64a362$export$e5110a9b2ab486ee)(/* end */ (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR);
}
function $f50510ec4ff63acc$var$tsParseModuleOrNamespaceDeclaration() {
    (0, $43e5b81ee278119a$export$7538cb03fa894c83)(false);
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).dot)) $f50510ec4ff63acc$var$tsParseModuleOrNamespaceDeclaration();
    else $f50510ec4ff63acc$var$tsParseModuleBlock();
}
function $f50510ec4ff63acc$var$tsParseAmbientExternalModuleDeclaration() {
    if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._global)) (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).string)) (0, $9d7bd82cb980c61d$export$fa61731cf32bc243)();
    else (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) $f50510ec4ff63acc$var$tsParseModuleBlock();
    else (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
}
function $f50510ec4ff63acc$export$bb14276cd4f56f44() {
    (0, $43e5b81ee278119a$export$cba413304e86fc0d)();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq);
    $f50510ec4ff63acc$var$tsParseModuleReference();
    (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
}
function $f50510ec4ff63acc$var$tsIsExternalModuleReference() {
    return (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._require) && (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)() === (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL;
}
function $f50510ec4ff63acc$var$tsParseModuleReference() {
    if ($f50510ec4ff63acc$var$tsIsExternalModuleReference()) $f50510ec4ff63acc$var$tsParseExternalModuleReference();
    else $f50510ec4ff63acc$var$tsParseEntityName();
}
function $f50510ec4ff63acc$var$tsParseExternalModuleReference() {
    (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._require);
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL);
    if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).string)) (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
    (0, $9d7bd82cb980c61d$export$d1b3e78ad34a47ef)();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
}
// Utilities
// Returns true if a statement matched.
function $f50510ec4ff63acc$var$tsTryParseDeclare() {
    if ((0, $40d5f3c610bd8f72$export$12d132b6e81066e4)()) return false;
    switch((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type){
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._function:
            {
                var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(1);
                (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
                // We don't need to precisely get the function start here, since it's only used to mark
                // the function as a type if it's bodiless, and it's already a type here.
                var functionStart = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).start;
                (0, $0568c3da8e64a362$export$ba3dc2bd7c065219)(functionStart, /* isStatement */ true);
                (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
                return true;
            }
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._class:
            {
                var oldIsType1 = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(1);
                (0, $0568c3da8e64a362$export$542081d93172af)(/* isStatement */ true, /* optionalId */ false);
                (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType1);
                return true;
            }
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._const:
            if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._const) && (0, $40d5f3c610bd8f72$export$d1b5391c35999eba)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._enum)) {
                var oldIsType2 = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(1);
                // `const enum = 0;` not allowed because "enum" is a strict mode reserved word.
                (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._const);
                (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._enum);
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._enum;
                $f50510ec4ff63acc$var$tsParseEnumDeclaration();
                (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType2);
                return true;
            }
        // falls through
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._var:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._let:
            {
                var oldIsType3 = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(1);
                (0, $0568c3da8e64a362$export$73f0614724a3919a)((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type !== (0, $30a0d13de21d779e$export$f435f793048e7a0f)._var);
                (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType3);
                return true;
            }
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).name:
            {
                var oldIsType4 = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(1);
                var contextualKeyword = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).contextualKeyword;
                var matched = false;
                if (contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._global) {
                    $f50510ec4ff63acc$var$tsParseAmbientExternalModuleDeclaration();
                    matched = true;
                } else matched = $f50510ec4ff63acc$var$tsParseDeclaration(contextualKeyword, /* isBeforeToken */ true);
                (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType4);
                return matched;
            }
        default:
            return false;
    }
}
// Note: this won't be called unless the keyword is allowed in `shouldParseExportDeclaration`.
// Returns true if it matched a declaration.
function $f50510ec4ff63acc$var$tsTryParseExportDeclaration() {
    return $f50510ec4ff63acc$var$tsParseDeclaration((0, $875661fa68d3a4de$export$ca000e230c0caa3e).contextualKeyword, /* isBeforeToken */ true);
}
// Returns true if it matched a statement.
function $f50510ec4ff63acc$var$tsParseExpressionStatement(contextualKeyword) {
    switch(contextualKeyword){
        case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._declare:
            {
                var declareTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1;
                var matched = $f50510ec4ff63acc$var$tsTryParseDeclare();
                if (matched) {
                    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[declareTokenIndex].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._declare;
                    return true;
                }
                break;
            }
        case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._global:
            // `global { }` (with no `declare`) may appear inside an ambient module declaration.
            // Would like to use tsParseAmbientExternalModuleDeclaration here, but already ran past "global".
            if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) {
                $f50510ec4ff63acc$var$tsParseModuleBlock();
                return true;
            }
            break;
        default:
            return $f50510ec4ff63acc$var$tsParseDeclaration(contextualKeyword, /* isBeforeToken */ false);
    }
    return false;
}
/**
 * Common code for parsing a declaration.
 *
 * isBeforeToken indicates that the current parser state is at the contextual
 * keyword (and that it is not yet emitted) rather than reading the token after
 * it. When isBeforeToken is true, we may be preceded by an `export` token and
 * should include that token in a type context we create, e.g. to handle
 * `export interface` or `export type`. (This is a bit of a hack and should be
 * cleaned up at some point.)
 *
 * Returns true if it matched a declaration.
 */ function $f50510ec4ff63acc$var$tsParseDeclaration(contextualKeyword, isBeforeToken) {
    switch(contextualKeyword){
        case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._abstract:
            if ($f50510ec4ff63acc$var$tsCheckLineTerminator(isBeforeToken) && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._class)) {
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._abstract;
                (0, $0568c3da8e64a362$export$542081d93172af)(/* isStatement */ true, /* optionalId */ false);
                return true;
            }
            break;
        case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._enum:
            if ($f50510ec4ff63acc$var$tsCheckLineTerminator(isBeforeToken) && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) {
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._enum;
                $f50510ec4ff63acc$var$tsParseEnumDeclaration();
                return true;
            }
            break;
        case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._interface:
            if ($f50510ec4ff63acc$var$tsCheckLineTerminator(isBeforeToken) && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) {
                // `next` is true in "export" and "declare" contexts, so we want to remove that token
                // as well.
                var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(isBeforeToken ? 2 : 1);
                $f50510ec4ff63acc$var$tsParseInterfaceDeclaration();
                (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
                return true;
            }
            break;
        case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._module:
            if ($f50510ec4ff63acc$var$tsCheckLineTerminator(isBeforeToken)) {
                if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).string)) {
                    var oldIsType1 = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(isBeforeToken ? 2 : 1);
                    $f50510ec4ff63acc$var$tsParseAmbientExternalModuleDeclaration();
                    (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType1);
                    return true;
                } else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) {
                    var oldIsType2 = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(isBeforeToken ? 2 : 1);
                    $f50510ec4ff63acc$var$tsParseModuleOrNamespaceDeclaration();
                    (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType2);
                    return true;
                }
            }
            break;
        case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._namespace:
            if ($f50510ec4ff63acc$var$tsCheckLineTerminator(isBeforeToken) && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) {
                var oldIsType3 = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(isBeforeToken ? 2 : 1);
                $f50510ec4ff63acc$var$tsParseModuleOrNamespaceDeclaration();
                (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType3);
                return true;
            }
            break;
        case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type:
            if ($f50510ec4ff63acc$var$tsCheckLineTerminator(isBeforeToken) && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) {
                var oldIsType4 = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(isBeforeToken ? 2 : 1);
                $f50510ec4ff63acc$var$tsParseTypeAliasDeclaration();
                (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType4);
                return true;
            }
            break;
        default:
            break;
    }
    return false;
}
function $f50510ec4ff63acc$var$tsCheckLineTerminator(isBeforeToken) {
    if (isBeforeToken) {
        // Babel checks hasFollowingLineBreak here and returns false, but this
        // doesn't actually come up, e.g. `export interface` can never be on its own
        // line in valid code.
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        return true;
    } else return !(0, $40d5f3c610bd8f72$export$12d132b6e81066e4)();
}
// Returns true if there was a generic async arrow function.
function $f50510ec4ff63acc$var$tsTryParseGenericAsyncArrowFunction() {
    var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
    $f50510ec4ff63acc$var$tsParseTypeParameters();
    (0, $0568c3da8e64a362$export$dd0fc1c64275f2c4)();
    $f50510ec4ff63acc$var$tsTryParseTypeOrTypePredicateAnnotation();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).arrow);
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).error) {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return false;
    }
    (0, $9d7bd82cb980c61d$export$50f85c246417e18)(true);
    return true;
}
/**
 * If necessary, hack the tokenizer state so that this bitshift was actually a
 * less-than token, then keep parsing. This should only be used in situations
 * where we restore from snapshot on error (which reverts this change) or
 * where bitshift would be illegal anyway (e.g. in a class "extends" clause).
 *
 * This hack is useful to handle situations like foo<<T>() => void>() where
 * there can legitimately be two open-angle-brackets in a row in TS.
 */ function $f50510ec4ff63acc$var$tsParseTypeArgumentsWithPossibleBitshift() {
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).bitShiftL) {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos -= 1;
        (0, $e2df986cc8bbbda9$export$58122cd1933ef607)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan);
    }
    $f50510ec4ff63acc$var$tsParseTypeArguments();
}
function $f50510ec4ff63acc$var$tsParseTypeArguments() {
    var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(0);
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan);
    while(!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).greaterThan) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        $f50510ec4ff63acc$export$13a289e680c077c1();
        (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
    }
    if (!oldIsType) {
        // If the type arguments are present in an expression context, e.g.
        // f<number>(), then the > sign should be tokenized as a non-type token.
        // In particular, f(a < b, c >= d) should parse the >= as a single token,
        // resulting in a syntax error and fallback to the non-type-args
        // interpretation. In the success case, even though the > is tokenized as a
        // non-type token, it still must be marked as a type token so that it is
        // erased.
        (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
        (0, $e2df986cc8bbbda9$export$4d00b4f4d9d7a9b3)();
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).greaterThan);
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
    } else {
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).greaterThan);
        (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
    }
}
function $f50510ec4ff63acc$export$5df75dadb7a629b6() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) switch((0, $875661fa68d3a4de$export$ca000e230c0caa3e).contextualKeyword){
        case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._abstract:
        case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._declare:
        case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._enum:
        case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._interface:
        case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._module:
        case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._namespace:
        case (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type:
            return true;
        default:
            break;
    }
    return false;
}
function $f50510ec4ff63acc$export$3c36bc5140dd8c64(functionStart, funcContextId) {
    // For arrow functions, `parseArrow` handles the return type itself.
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon)) $f50510ec4ff63acc$var$tsParseTypeOrTypePredicateAnnotation((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon);
    // The original code checked the node type to make sure this function type allows a missing
    // body, but we skip that to avoid sending around the node type. We instead just use the
    // allowExpressionBody boolean to make sure it's not an arrow function.
    if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL) && (0, $40d5f3c610bd8f72$export$12d132b6e81066e4)()) {
        // Retroactively mark the function declaration as a type.
        var i = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1;
        while(i >= 0 && ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[i].start >= functionStart || (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[i].type === (0, $30a0d13de21d779e$export$f435f793048e7a0f)._default || (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[i].type === (0, $30a0d13de21d779e$export$f435f793048e7a0f)._export)){
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[i].isType = true;
            i--;
        }
        return;
    }
    (0, $9d7bd82cb980c61d$export$50f85c246417e18)(false, funcContextId);
}
function $f50510ec4ff63acc$export$f6cd10065188a17f(startTokenIndex, noCalls, stopState) {
    if (!(0, $40d5f3c610bd8f72$export$942fa35f3a7c108c)() && (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bang)) {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f).nonNullAssertion;
        return;
    }
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bitShiftL)) {
        // There are number of things we are going to "maybe" parse, like type arguments on
        // tagged template expressions. If any of them fail, walk it back and continue.
        var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
        if (!noCalls && (0, $9d7bd82cb980c61d$export$960e7b0728d0d49e)()) {
            // Almost certainly this is a generic async function `async <T>() => ...
            // But it might be a call with a type argument `async<T>();`
            var asyncArrowFn = $f50510ec4ff63acc$var$tsTryParseGenericAsyncArrowFunction();
            if (asyncArrowFn) return;
        }
        $f50510ec4ff63acc$var$tsParseTypeArgumentsWithPossibleBitshift();
        if (!noCalls && (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) {
            // With f<T>(), the subscriptStartIndex marker is on the ( token.
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
            (0, $9d7bd82cb980c61d$export$970763873d9efa73)();
        } else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).backQuote)) // Tagged template with a type argument.
        (0, $9d7bd82cb980c61d$export$2e2dbd43b49fd373)();
        else if (// The remaining possible case is an instantiation expression, e.g.
        // Array<number> . Check for a few cases that would disqualify it and
        // cause us to bail out.
        // a<b>>c is not (a<b>)>c, but a<(b>>c)
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).greaterThan || // a<b>c is (a<b)>c
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type !== (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL && Boolean((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type & (0, $30a0d13de21d779e$export$f435f793048e7a0f).IS_EXPRESSION_START) && !(0, $40d5f3c610bd8f72$export$942fa35f3a7c108c)()) // Bail out. We have something like a<b>c, which is not an expression with
        // type arguments but an (a < b) > c comparison.
        (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
        if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).error) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        else return;
    } else if (!noCalls && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).questionDot) && (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)() === (0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan) {
        // If we see f?.<, then this must be an optional call with a type argument.
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[startTokenIndex].isOptionalChainStart = true;
        // With f?.<T>(), the subscriptStartIndex marker is on the ?. token.
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
        $f50510ec4ff63acc$var$tsParseTypeArguments();
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL);
        (0, $9d7bd82cb980c61d$export$970763873d9efa73)();
    }
    (0, $9d7bd82cb980c61d$export$31dc8e486c1a1be6)(startTokenIndex, noCalls, stopState);
}
function $f50510ec4ff63acc$export$6714566ca8db2f39() {
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._import)) {
        // One of these cases:
        // export import A = B;
        // export import type A = require("A");
        if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type) && (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)() !== (0, $30a0d13de21d779e$export$f435f793048e7a0f).eq) // Eat a `type` token, unless it's actually an identifier name.
        (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type);
        $f50510ec4ff63acc$export$bb14276cd4f56f44();
        return true;
    } else if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) {
        // `export = x;`
        (0, $9d7bd82cb980c61d$export$ed9c825e502c46c8)();
        (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
        return true;
    } else if ((0, $40d5f3c610bd8f72$export$b8f8f7fffeb6fb36)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._as)) {
        // `export as namespace A;`
        // See `parseNamespaceExportDeclaration` in TypeScript's own parser
        (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._namespace);
        (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
        (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
        return true;
    } else {
        if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type)) {
            var nextType = (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)();
            // export type {foo} from 'a';
            // export type * from 'a';'
            // export type * as ns from 'a';'
            if (nextType === (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL || nextType === (0, $30a0d13de21d779e$export$f435f793048e7a0f).star) (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        }
        return false;
    }
}
function $f50510ec4ff63acc$export$718ece2f88417ffd() {
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) {
        // import {foo}
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ImportDeclaration;
        return;
    }
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) {
        // import {type foo}
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ImportDeclaration;
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 2].isType = true;
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
        return;
    }
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) {
        // import {foo as bar}
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 3].identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ImportAccess;
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ImportDeclaration;
        return;
    }
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    // import {type foo as bar}
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 3].identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ImportAccess;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ImportDeclaration;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 4].isType = true;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 3].isType = true;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 2].isType = true;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
}
function $f50510ec4ff63acc$export$7994f3b86b6c7d1e() {
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) {
        // export {foo}
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ExportAccess;
        return;
    }
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) {
        // export {type foo}
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ExportAccess;
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 2].isType = true;
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
        return;
    }
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) {
        // export {foo as bar}
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 3].identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ExportAccess;
        return;
    }
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    // export {type foo as bar}
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 3].identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ExportAccess;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 4].isType = true;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 3].isType = true;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 2].isType = true;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
}
function $f50510ec4ff63acc$export$95d54e02ae7a0197() {
    if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._abstract) && (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)() === (0, $30a0d13de21d779e$export$f435f793048e7a0f)._class) {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._abstract;
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)(); // Skip "abstract"
        (0, $0568c3da8e64a362$export$542081d93172af)(true, true);
        return true;
    }
    if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._interface)) {
        // Make sure "export default" are considered type tokens so the whole thing is removed.
        var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(2);
        $f50510ec4ff63acc$var$tsParseDeclaration((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._interface, true);
        (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
        return true;
    }
    return false;
}
function $f50510ec4ff63acc$export$bd8d07f8ee509b14() {
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type === (0, $30a0d13de21d779e$export$f435f793048e7a0f)._const) {
        var ahead = (0, $e2df986cc8bbbda9$export$ef1b94c514fc060a)();
        if (ahead.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).name && ahead.contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._enum) {
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._const);
            (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._enum);
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._enum;
            $f50510ec4ff63acc$var$tsParseEnumDeclaration();
            return true;
        }
    }
    return false;
}
function $f50510ec4ff63acc$export$9d02a6e20851f734(isStatic) {
    var memberStartIndexAfterStatic = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    $f50510ec4ff63acc$export$77616e6d401f584a([
        (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._abstract,
        (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._readonly,
        (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._declare,
        (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._static,
        (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._override
    ]);
    var modifiersEndIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    var found = $f50510ec4ff63acc$var$tsTryParseIndexSignature();
    if (found) {
        // Index signatures are type declarations, so set the modifier tokens as
        // type tokens. Most tokens could be assumed to be type tokens, but `static`
        // is ambiguous unless we set it explicitly here.
        var memberStartIndex = isStatic ? memberStartIndexAfterStatic - 1 : memberStartIndexAfterStatic;
        for(var i = memberStartIndex; i < modifiersEndIndex; i++)(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[i].isType = true;
        return true;
    }
    return false;
}
function $f50510ec4ff63acc$export$a642c15f5070c816(contextualKeyword) {
    var matched = $f50510ec4ff63acc$var$tsParseExpressionStatement(contextualKeyword);
    if (!matched) (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
}
function $f50510ec4ff63acc$export$b29e6741ccf6da0a() {
    // "export declare" is equivalent to just "export".
    var isDeclare = (0, $40d5f3c610bd8f72$export$b8f8f7fffeb6fb36)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._declare);
    if (isDeclare) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._declare;
    var matchedDeclaration = false;
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) {
        if (isDeclare) {
            var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(2);
            matchedDeclaration = $f50510ec4ff63acc$var$tsTryParseExportDeclaration();
            (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
        } else matchedDeclaration = $f50510ec4ff63acc$var$tsTryParseExportDeclaration();
    }
    if (!matchedDeclaration) {
        if (isDeclare) {
            var oldIsType1 = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(2);
            (0, $0568c3da8e64a362$export$68b986de0b252bc8)(true);
            (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType1);
        } else (0, $0568c3da8e64a362$export$68b986de0b252bc8)(true);
    }
}
function $f50510ec4ff63acc$export$ea9d02c53bf69095(hasSuper) {
    if (hasSuper && ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bitShiftL))) $f50510ec4ff63acc$var$tsParseTypeArgumentsWithPossibleBitshift();
    if ((0, $40d5f3c610bd8f72$export$b8f8f7fffeb6fb36)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._implements)) {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._implements;
        var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(1);
        $f50510ec4ff63acc$var$tsParseHeritageClause();
        (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
    }
}
function $f50510ec4ff63acc$export$f7c2ce498525881a() {
    $f50510ec4ff63acc$export$827faab4e65d5897();
}
function $f50510ec4ff63acc$export$ba34d58430377f94() {
    $f50510ec4ff63acc$export$827faab4e65d5897();
}
function $f50510ec4ff63acc$export$41c8703baf1bbf07() {
    var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(0);
    if (!(0, $40d5f3c610bd8f72$export$942fa35f3a7c108c)()) (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bang);
    $f50510ec4ff63acc$export$e4623eb563192e0f();
    (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
}
function $f50510ec4ff63acc$export$490a9bc22f3cab3f() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon)) $f50510ec4ff63acc$export$728a3256ac690042();
}
function $f50510ec4ff63acc$export$daa24143ef798a56(noIn, isWithinParens) {
    // Note: When the JSX plugin is on, type assertions (`<T> x`) aren't valid syntax.
    if (0, $875661fa68d3a4de$export$43bb667a94af025a) return $f50510ec4ff63acc$export$fbbf4e3ed219417f(noIn, isWithinParens);
    else return $f50510ec4ff63acc$export$9606be81aa771b16(noIn, isWithinParens);
}
function $f50510ec4ff63acc$export$fbbf4e3ed219417f(noIn, isWithinParens) {
    if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) return (0, $9d7bd82cb980c61d$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
    // Prefer to parse JSX if possible. But may be an arrow fn.
    var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
    var wasArrow = (0, $9d7bd82cb980c61d$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).error) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    else return wasArrow;
    // Otherwise, try as type-parameterized arrow function.
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type = (0, $30a0d13de21d779e$export$f435f793048e7a0f).typeParameterStart;
    // This is similar to TypeScript's `tryParseParenthesizedArrowFunctionExpression`.
    $f50510ec4ff63acc$var$tsParseTypeParameters();
    wasArrow = (0, $9d7bd82cb980c61d$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
    if (!wasArrow) (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
    return wasArrow;
}
function $f50510ec4ff63acc$export$9606be81aa771b16(noIn, isWithinParens) {
    if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) return (0, $9d7bd82cb980c61d$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
    var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
    // This is similar to TypeScript's `tryParseParenthesizedArrowFunctionExpression`.
    $f50510ec4ff63acc$var$tsParseTypeParameters();
    var wasArrow = (0, $9d7bd82cb980c61d$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
    if (!wasArrow) (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).error) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    else return wasArrow;
    // Try parsing a type cast instead of an arrow function.
    // This will start with a type assertion (via parseMaybeUnary).
    // But don't directly call `tsParseTypeAssertion` because we want to handle any binary after it.
    return (0, $9d7bd82cb980c61d$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
}
function $f50510ec4ff63acc$export$e20067ab7c70da1d() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon)) {
        // This is different from how the TS parser does it.
        // TS uses lookahead. Babylon parses it as a parenthesized expression and converts.
        var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
        $f50510ec4ff63acc$var$tsParseTypeOrTypePredicateAnnotation((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon);
        if ((0, $40d5f3c610bd8f72$export$1c0919cee6560c3)()) (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
        if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).arrow)) (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
        if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).error) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    }
    return (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).arrow);
}
function $f50510ec4ff63acc$export$9b46e2c9fd90d888() {
    var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(0);
    (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).question);
    $f50510ec4ff63acc$export$e4623eb563192e0f();
    (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
}
function $f50510ec4ff63acc$export$fd0439ea9a1ac1ea() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bitShiftL)) $f50510ec4ff63acc$var$tsParseTypeArgumentsWithPossibleBitshift();
    (0, $0568c3da8e64a362$export$50c128b10ac5ea5b)();
}


/**
 * Read token with JSX contents.
 *
 * In addition to detecting jsxTagStart and also regular tokens that might be
 * part of an expression, this code detects the start and end of text ranges
 * within JSX children. In order to properly count the number of children, we
 * distinguish jsxText from jsxEmptyText, which is a text range that simplifies
 * to the empty string after JSX whitespace trimming.
 *
 * It turns out that a JSX text range will simplify to the empty string if and
 * only if both of these conditions hold:
 * - The range consists entirely of whitespace characters (only counting space,
 *   tab, \r, and \n).
 * - The range has at least one newline.
 * This can be proven by analyzing any implementation of whitespace trimming,
 * e.g. formatJSXTextLiteral in Sucrase or cleanJSXElementLiteralChild in Babel.
 */ function $2c27fc7dc0d1372f$var$jsxReadToken() {
    var sawNewline = false;
    var sawNonWhitespace = false;
    while(true){
        if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos >= (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).length) {
            (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)("Unterminated JSX contents");
            return;
        }
        var ch = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos);
        if (ch === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lessThan || ch === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).leftCurlyBrace) {
            if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos === (0, $875661fa68d3a4de$export$ca000e230c0caa3e).start) {
                if (ch === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lessThan) {
                    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos++;
                    (0, $e2df986cc8bbbda9$export$58122cd1933ef607)((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagStart);
                    return;
                }
                (0, $e2df986cc8bbbda9$export$e0ebb9fd4c2c4701)(ch);
                return;
            }
            if (sawNewline && !sawNonWhitespace) (0, $e2df986cc8bbbda9$export$58122cd1933ef607)((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxEmptyText);
            else (0, $e2df986cc8bbbda9$export$58122cd1933ef607)((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxText);
            return;
        }
        // This is part of JSX text.
        if (ch === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lineFeed) sawNewline = true;
        else if (ch !== (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).space && ch !== (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).carriageReturn && ch !== (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).tab) sawNonWhitespace = true;
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos++;
    }
}
function $2c27fc7dc0d1372f$var$jsxReadString(quote) {
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos++;
    for(;;){
        if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos >= (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).length) {
            (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)("Unterminated string constant");
            return;
        }
        var ch = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos);
        if (ch === quote) {
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos++;
            break;
        }
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos++;
    }
    (0, $e2df986cc8bbbda9$export$58122cd1933ef607)((0, $30a0d13de21d779e$export$f435f793048e7a0f).string);
}
// Read a JSX identifier (valid tag or attribute name).
//
// Optimized version since JSX identifiers can't contain
// escape characters and so can be read as single slice.
// Also assumes that first character was already checked
// by isIdentifierStart in readToken.
function $2c27fc7dc0d1372f$var$jsxReadWord() {
    var ch;
    do {
        if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos > (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).length) {
            (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)("Unexpectedly reached the end of input.");
            return;
        }
        ch = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt(++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos);
    }while ((0, $c0e0280b0658a40b$export$d19df39e3926cfef)[ch] || ch === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).dash);
    (0, $e2df986cc8bbbda9$export$58122cd1933ef607)((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxName);
}
// Parse next token as JSX identifier
function $2c27fc7dc0d1372f$var$jsxParseIdentifier() {
    $2c27fc7dc0d1372f$export$a1b2c368381052e6();
}
// Parse namespaced identifier.
function $2c27fc7dc0d1372f$var$jsxParseNamespacedName(identifierRole) {
    $2c27fc7dc0d1372f$var$jsxParseIdentifier();
    if (!(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon)) {
        // Plain identifier, so this is an access.
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = identifierRole;
        return;
    }
    // Process the second half of the namespaced name.
    $2c27fc7dc0d1372f$var$jsxParseIdentifier();
}
// Parses element name in any form - namespaced, member
// or single identifier.
function $2c27fc7dc0d1372f$var$jsxParseElementName() {
    var firstTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    $2c27fc7dc0d1372f$var$jsxParseNamespacedName((0, $e2df986cc8bbbda9$export$99f888ada3c99de3).Access);
    var hadDot = false;
    while((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).dot)){
        hadDot = true;
        $2c27fc7dc0d1372f$export$a1b2c368381052e6();
        $2c27fc7dc0d1372f$var$jsxParseIdentifier();
    }
    // For tags like <div> with a lowercase letter and no dots, the name is
    // actually *not* an identifier access, since it's referring to a built-in
    // tag name. Remove the identifier role in this case so that it's not
    // accidentally transformed by the imports transform when preserving JSX.
    if (!hadDot) {
        var firstToken = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[firstTokenIndex];
        var firstChar = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt(firstToken.start);
        if (firstChar >= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseA && firstChar <= (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseZ) firstToken.identifierRole = null;
    }
}
// Parses any type of JSX attribute value.
function $2c27fc7dc0d1372f$var$jsxParseAttributeValue() {
    switch((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type){
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL:
            (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
            (0, $9d7bd82cb980c61d$export$ed9c825e502c46c8)();
            $2c27fc7dc0d1372f$export$a1b2c368381052e6();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagStart:
            $2c27fc7dc0d1372f$export$7cbe8c53d909e342();
            $2c27fc7dc0d1372f$export$a1b2c368381052e6();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).string:
            $2c27fc7dc0d1372f$export$a1b2c368381052e6();
            return;
        default:
            (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)("JSX value should be either an expression or a quoted JSX text");
    }
}
// Parse JSX spread child, after already processing the {
// Does not parse the closing }
function $2c27fc7dc0d1372f$var$jsxParseSpreadChild() {
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).ellipsis);
    (0, $9d7bd82cb980c61d$export$ed9c825e502c46c8)();
}
// Parses JSX opening tag starting after "<".
// Returns true if the tag was self-closing.
// Does not parse the last token.
function $2c27fc7dc0d1372f$var$jsxParseOpeningElement(initialTokenIndex) {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagEnd)) // This is an open-fragment.
    return false;
    $2c27fc7dc0d1372f$var$jsxParseElementName();
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) (0, $f50510ec4ff63acc$export$382de4b7ab7e7990)();
    var hasSeenPropSpread = false;
    while(!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).slash) && !(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagEnd) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) {
            hasSeenPropSpread = true;
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).ellipsis);
            (0, $9d7bd82cb980c61d$export$b97bbe8a7805284f)();
            // }
            $2c27fc7dc0d1372f$export$a1b2c368381052e6();
            continue;
        }
        if (hasSeenPropSpread && (0, $875661fa68d3a4de$export$ca000e230c0caa3e).end - (0, $875661fa68d3a4de$export$ca000e230c0caa3e).start === 3 && (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).start) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseK && (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).start + 1) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseE && (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).start + 2) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lowercaseY) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[initialTokenIndex].jsxRole = (0, $e2df986cc8bbbda9$export$4620c92ad8b511d9).KeyAfterPropSpread;
        $2c27fc7dc0d1372f$var$jsxParseNamespacedName((0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ObjectKey);
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) {
            $2c27fc7dc0d1372f$export$a1b2c368381052e6();
            $2c27fc7dc0d1372f$var$jsxParseAttributeValue();
        }
    }
    var isSelfClosing = (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).slash);
    if (isSelfClosing) // /
    $2c27fc7dc0d1372f$export$a1b2c368381052e6();
    return isSelfClosing;
}
// Parses JSX closing tag starting after "</".
// Does not parse the last token.
function $2c27fc7dc0d1372f$var$jsxParseClosingElement() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagEnd)) // Fragment syntax, so we immediately have a tag end.
    return;
    $2c27fc7dc0d1372f$var$jsxParseElementName();
}
// Parses entire JSX element, including its opening tag
// (starting after "<"), attributes, contents and closing tag.
// Does not parse the last token.
function $2c27fc7dc0d1372f$var$jsxParseElementAt() {
    var initialTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[initialTokenIndex].jsxRole = (0, $e2df986cc8bbbda9$export$4620c92ad8b511d9).NoChildren;
    var numExplicitChildren = 0;
    var isSelfClosing = $2c27fc7dc0d1372f$var$jsxParseOpeningElement(initialTokenIndex);
    if (!isSelfClosing) {
        $2c27fc7dc0d1372f$var$nextJSXExprToken();
        while(true)switch((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type){
            case (0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagStart:
                $2c27fc7dc0d1372f$export$a1b2c368381052e6();
                if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).slash)) {
                    $2c27fc7dc0d1372f$export$a1b2c368381052e6();
                    $2c27fc7dc0d1372f$var$jsxParseClosingElement();
                    // Key after prop spread takes precedence over number of children,
                    // since it means we switch to createElement, which doesn't care
                    // about number of children.
                    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[initialTokenIndex].jsxRole !== (0, $e2df986cc8bbbda9$export$4620c92ad8b511d9).KeyAfterPropSpread) {
                        if (numExplicitChildren === 1) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[initialTokenIndex].jsxRole = (0, $e2df986cc8bbbda9$export$4620c92ad8b511d9).OneChild;
                        else if (numExplicitChildren > 1) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[initialTokenIndex].jsxRole = (0, $e2df986cc8bbbda9$export$4620c92ad8b511d9).StaticChildren;
                    }
                    return;
                }
                numExplicitChildren++;
                $2c27fc7dc0d1372f$var$jsxParseElementAt();
                $2c27fc7dc0d1372f$var$nextJSXExprToken();
                break;
            case (0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxText:
                numExplicitChildren++;
                $2c27fc7dc0d1372f$var$nextJSXExprToken();
                break;
            case (0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxEmptyText:
                $2c27fc7dc0d1372f$var$nextJSXExprToken();
                break;
            case (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL:
                (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
                if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).ellipsis)) {
                    $2c27fc7dc0d1372f$var$jsxParseSpreadChild();
                    $2c27fc7dc0d1372f$var$nextJSXExprToken();
                    // Spread children are a mechanism to explicitly mark children as
                    // static, so count it as 2 children to satisfy the "more than one
                    // child" condition.
                    numExplicitChildren += 2;
                } else {
                    // If we see {}, this is an empty pseudo-expression that doesn't
                    // count as a child.
                    if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) {
                        numExplicitChildren++;
                        (0, $9d7bd82cb980c61d$export$ed9c825e502c46c8)();
                    }
                    $2c27fc7dc0d1372f$var$nextJSXExprToken();
                }
                break;
            // istanbul ignore next - should never happen
            default:
                (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
                return;
        }
    }
}
function $2c27fc7dc0d1372f$export$7cbe8c53d909e342() {
    $2c27fc7dc0d1372f$export$a1b2c368381052e6();
    $2c27fc7dc0d1372f$var$jsxParseElementAt();
}
function $2c27fc7dc0d1372f$export$a1b2c368381052e6() {
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.push(new (0, $e2df986cc8bbbda9$export$50792b0e93539fde)());
    (0, $e2df986cc8bbbda9$export$b240c79c2d18160)();
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).start = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
    var code = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos);
    if ((0, $c0e0280b0658a40b$export$dc1d1d7d9fdffb8)[code]) $2c27fc7dc0d1372f$var$jsxReadWord();
    else if (code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).quotationMark || code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).apostrophe) $2c27fc7dc0d1372f$var$jsxReadString(code);
    else {
        // The following tokens are just one character each.
        ++(0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
        switch(code){
            case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).greaterThan:
                (0, $e2df986cc8bbbda9$export$58122cd1933ef607)((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagEnd);
                break;
            case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).lessThan:
                (0, $e2df986cc8bbbda9$export$58122cd1933ef607)((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagStart);
                break;
            case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).slash:
                (0, $e2df986cc8bbbda9$export$58122cd1933ef607)((0, $30a0d13de21d779e$export$f435f793048e7a0f).slash);
                break;
            case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).equalsTo:
                (0, $e2df986cc8bbbda9$export$58122cd1933ef607)((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq);
                break;
            case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).leftCurlyBrace:
                (0, $e2df986cc8bbbda9$export$58122cd1933ef607)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
                break;
            case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).dot:
                (0, $e2df986cc8bbbda9$export$58122cd1933ef607)((0, $30a0d13de21d779e$export$f435f793048e7a0f).dot);
                break;
            case (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).colon:
                (0, $e2df986cc8bbbda9$export$58122cd1933ef607)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon);
                break;
            default:
                (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
        }
    }
}
function $2c27fc7dc0d1372f$var$nextJSXExprToken() {
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.push(new (0, $e2df986cc8bbbda9$export$50792b0e93539fde)());
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).start = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos;
    $2c27fc7dc0d1372f$var$jsxReadToken();
}








function $0a40c39f8b7da2a0$export$a1aa0436beedb1fa(noIn) {
    // If we see ?:, this can't possibly be a valid conditional. typedParseParenItem will be called
    // later to finish off the arrow parameter. We also need to handle bare ? tokens for optional
    // parameters without type annotations, i.e. ?, and ?) .
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).question)) {
        var nextType = (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)();
        if (nextType === (0, $30a0d13de21d779e$export$f435f793048e7a0f).colon || nextType === (0, $30a0d13de21d779e$export$f435f793048e7a0f).comma || nextType === (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR) return;
    }
    (0, $9d7bd82cb980c61d$export$a3d1b6cb707072ce)(noIn);
}
function $0a40c39f8b7da2a0$export$72bae99899f77e0f() {
    (0, $e2df986cc8bbbda9$export$cb3e65614411a57c)((0, $30a0d13de21d779e$export$f435f793048e7a0f).question);
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon)) {
        if (0, $875661fa68d3a4de$export$757c2735689d2de8) (0, $f50510ec4ff63acc$export$728a3256ac690042)();
        else if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) (0, $37322500987f8c0d$export$6c833037db1a1e96)();
    }
}













var $9d7bd82cb980c61d$export$8cd93656cd4760 = function StopState(stop) {
    "use strict";
    (0, $173N4._)(this, StopState);
    this.stop = stop;
};
function $9d7bd82cb980c61d$export$ed9c825e502c46c8() {
    var noIn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    $9d7bd82cb980c61d$export$b97bbe8a7805284f(noIn);
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) while((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma))$9d7bd82cb980c61d$export$b97bbe8a7805284f(noIn);
}
function $9d7bd82cb980c61d$export$b97bbe8a7805284f() {
    var noIn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, isWithinParens = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) return (0, $f50510ec4ff63acc$export$daa24143ef798a56)(noIn, isWithinParens);
    else if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) return (0, $37322500987f8c0d$export$abad2599830a7c66)(noIn, isWithinParens);
    else return $9d7bd82cb980c61d$export$bb0065dd8e05bcbd(noIn, isWithinParens);
}
function $9d7bd82cb980c61d$export$bb0065dd8e05bcbd(noIn, isWithinParens) {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._yield)) {
        $9d7bd82cb980c61d$var$parseYield();
        return false;
    }
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._yield)) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).potentialArrowAt = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).start;
    var wasArrow = $9d7bd82cb980c61d$var$parseMaybeConditional(noIn);
    if (isWithinParens) $9d7bd82cb980c61d$var$parseParenItem();
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type & (0, $30a0d13de21d779e$export$f435f793048e7a0f).IS_ASSIGN) {
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        $9d7bd82cb980c61d$export$b97bbe8a7805284f(noIn);
        return false;
    }
    return wasArrow;
}
// Parse a ternary conditional (`?:`) operator.
// Returns true if the expression was an arrow function.
function $9d7bd82cb980c61d$var$parseMaybeConditional(noIn) {
    var wasArrow = $9d7bd82cb980c61d$var$parseExprOps(noIn);
    if (wasArrow) return true;
    $9d7bd82cb980c61d$var$parseConditional(noIn);
    return false;
}
function $9d7bd82cb980c61d$var$parseConditional(noIn) {
    if ((0, $875661fa68d3a4de$export$757c2735689d2de8) || (0, $875661fa68d3a4de$export$92e334f8fe49aa94)) (0, $0a40c39f8b7da2a0$export$a1aa0436beedb1fa)(noIn);
    else $9d7bd82cb980c61d$export$a3d1b6cb707072ce(noIn);
}
function $9d7bd82cb980c61d$export$a3d1b6cb707072ce(noIn) {
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).question)) {
        $9d7bd82cb980c61d$export$b97bbe8a7805284f();
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon);
        $9d7bd82cb980c61d$export$b97bbe8a7805284f(noIn);
    }
}
// Start the precedence parser.
// Returns true if this was an arrow function
function $9d7bd82cb980c61d$var$parseExprOps(noIn) {
    var startTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    var wasArrow = $9d7bd82cb980c61d$export$165911d2b803e372();
    if (wasArrow) return true;
    $9d7bd82cb980c61d$var$parseExprOp(startTokenIndex, -1, noIn);
    return false;
}
// Parse binary operators with the operator precedence parsing
// algorithm. `left` is the left-hand side of the operator.
// `minPrec` provides context that allows the function to stop and
// defer further parser to one of its callers when it encounters an
// operator that has a lower precedence than the set it is parsing.
function $9d7bd82cb980c61d$var$parseExprOp(startTokenIndex, minPrec, noIn) {
    if ((0, $875661fa68d3a4de$export$757c2735689d2de8) && ((0, $30a0d13de21d779e$export$f435f793048e7a0f)._in & (0, $30a0d13de21d779e$export$f435f793048e7a0f).PRECEDENCE_MASK) > minPrec && !(0, $40d5f3c610bd8f72$export$942fa35f3a7c108c)() && ((0, $40d5f3c610bd8f72$export$b8f8f7fffeb6fb36)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._as) || (0, $40d5f3c610bd8f72$export$b8f8f7fffeb6fb36)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._satisfies))) {
        var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(1);
        (0, $f50510ec4ff63acc$export$13a289e680c077c1)();
        (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
        (0, $e2df986cc8bbbda9$export$4d00b4f4d9d7a9b3)();
        $9d7bd82cb980c61d$var$parseExprOp(startTokenIndex, minPrec, noIn);
        return;
    }
    var prec = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type & (0, $30a0d13de21d779e$export$f435f793048e7a0f).PRECEDENCE_MASK;
    if (prec > 0 && (!noIn || !(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._in))) {
        if (prec > minPrec) {
            var op = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type;
            (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
            if (op === (0, $30a0d13de21d779e$export$f435f793048e7a0f).nullishCoalescing) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].nullishStartIndex = startTokenIndex;
            var rhsStartTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
            $9d7bd82cb980c61d$export$165911d2b803e372();
            // Extend the right operand of this operator if possible.
            $9d7bd82cb980c61d$var$parseExprOp(rhsStartTokenIndex, op & (0, $30a0d13de21d779e$export$f435f793048e7a0f).IS_RIGHT_ASSOCIATIVE ? prec - 1 : prec, noIn);
            if (op === (0, $30a0d13de21d779e$export$f435f793048e7a0f).nullishCoalescing) {
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[startTokenIndex].numNullishCoalesceStarts++;
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].numNullishCoalesceEnds++;
            }
            // Continue with any future operator holding this expression as the left operand.
            $9d7bd82cb980c61d$var$parseExprOp(startTokenIndex, minPrec, noIn);
        }
    }
}
function $9d7bd82cb980c61d$export$165911d2b803e372() {
    if ((0, $875661fa68d3a4de$export$757c2735689d2de8) && !(0, $875661fa68d3a4de$export$43bb667a94af025a) && (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) {
        (0, $f50510ec4ff63acc$export$ecfac1712a900e29)();
        return false;
    }
    if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._module) && (0, $e2df986cc8bbbda9$export$847169391b2516b8)() === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).leftCurlyBrace && !(0, $40d5f3c610bd8f72$export$a4f1ee8cbd9b31ba)()) {
        $9d7bd82cb980c61d$var$parseModuleExpression();
        return false;
    }
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type & (0, $30a0d13de21d779e$export$f435f793048e7a0f).IS_PREFIX) {
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        $9d7bd82cb980c61d$export$165911d2b803e372();
        return false;
    }
    var wasArrow = $9d7bd82cb980c61d$export$dba7f678c228244a();
    if (wasArrow) return true;
    while((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type & (0, $30a0d13de21d779e$export$f435f793048e7a0f).IS_POSTFIX && !(0, $40d5f3c610bd8f72$export$1c0919cee6560c3)()){
        // The tokenizer calls everything a preincrement, so make it a postincrement when
        // we see it in that context.
        if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).preIncDec) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type = (0, $30a0d13de21d779e$export$f435f793048e7a0f).postIncDec;
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    }
    return false;
}
function $9d7bd82cb980c61d$export$dba7f678c228244a() {
    var startTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    var wasArrow = $9d7bd82cb980c61d$export$fa61731cf32bc243();
    if (wasArrow) return true;
    $9d7bd82cb980c61d$var$parseSubscripts(startTokenIndex);
    // If there was any optional chain operation, the start token would be marked
    // as such, so also mark the end now.
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length > startTokenIndex && (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[startTokenIndex].isOptionalChainStart) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].isOptionalChainEnd = true;
    return false;
}
function $9d7bd82cb980c61d$var$parseSubscripts(startTokenIndex) {
    var noCalls = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) (0, $37322500987f8c0d$export$7c7ba3c0c5ae1f67)(startTokenIndex, noCalls);
    else $9d7bd82cb980c61d$export$c2cc03eea353aa42(startTokenIndex, noCalls);
}
function $9d7bd82cb980c61d$export$c2cc03eea353aa42(startTokenIndex) {
    var noCalls = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var stopState = new $9d7bd82cb980c61d$export$8cd93656cd4760(false);
    do $9d7bd82cb980c61d$var$parseSubscript(startTokenIndex, noCalls, stopState);
    while (!stopState.stop && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error);
}
function $9d7bd82cb980c61d$var$parseSubscript(startTokenIndex, noCalls, stopState) {
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) (0, $f50510ec4ff63acc$export$f6cd10065188a17f)(startTokenIndex, noCalls, stopState);
    else if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) (0, $37322500987f8c0d$export$4eb11794b3b71235)(startTokenIndex, noCalls, stopState);
    else $9d7bd82cb980c61d$export$31dc8e486c1a1be6(startTokenIndex, noCalls, stopState);
}
function $9d7bd82cb980c61d$export$31dc8e486c1a1be6(startTokenIndex, noCalls, stopState) {
    if (!noCalls && (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).doubleColon)) {
        $9d7bd82cb980c61d$var$parseNoCallExpr();
        stopState.stop = true;
        // Propagate startTokenIndex so that `a::b?.()` will keep `a` as the first token. We may want
        // to revisit this in the future when fully supporting bind syntax.
        $9d7bd82cb980c61d$var$parseSubscripts(startTokenIndex, noCalls);
    } else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).questionDot)) {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[startTokenIndex].isOptionalChainStart = true;
        if (noCalls && (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)() === (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL) {
            stopState.stop = true;
            return;
        }
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
        if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL)) {
            $9d7bd82cb980c61d$export$ed9c825e502c46c8();
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR);
        } else if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) $9d7bd82cb980c61d$export$970763873d9efa73();
        else $9d7bd82cb980c61d$var$parseMaybePrivateName();
    } else if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).dot)) {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
        $9d7bd82cb980c61d$var$parseMaybePrivateName();
    } else if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL)) {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
        $9d7bd82cb980c61d$export$ed9c825e502c46c8();
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR);
    } else if (!noCalls && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) {
        if ($9d7bd82cb980c61d$export$960e7b0728d0d49e()) {
            // We see "async", but it's possible it's a usage of the name "async". Parse as if it's a
            // function call, and if we see an arrow later, backtrack and re-parse as a parameter list.
            var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
            var asyncStartTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
            (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
            var callContextId = (0, $875661fa68d3a4de$export$d0c215ddd78b3d24)();
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].contextId = callContextId;
            $9d7bd82cb980c61d$export$970763873d9efa73();
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].contextId = callContextId;
            if ($9d7bd82cb980c61d$var$shouldParseAsyncArrow()) {
                // We hit an arrow, so backtrack and start again parsing function parameters.
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
                stopState.stop = true;
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth++;
                (0, $0568c3da8e64a362$export$dd0fc1c64275f2c4)();
                $9d7bd82cb980c61d$var$parseAsyncArrowFromCallExpression(asyncStartTokenIndex);
            }
        } else {
            (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
            var callContextId1 = (0, $875661fa68d3a4de$export$d0c215ddd78b3d24)();
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].contextId = callContextId1;
            $9d7bd82cb980c61d$export$970763873d9efa73();
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].contextId = callContextId1;
        }
    } else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).backQuote)) // Tagged template expression.
    $9d7bd82cb980c61d$export$2e2dbd43b49fd373();
    else stopState.stop = true;
}
function $9d7bd82cb980c61d$export$960e7b0728d0d49e() {
    // This was made less strict than the original version to avoid passing around nodes, but it
    // should be safe to have rare false positives here.
    return (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._async && !(0, $40d5f3c610bd8f72$export$1c0919cee6560c3)();
}
function $9d7bd82cb980c61d$export$970763873d9efa73() {
    var first = true;
    while(!(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
            if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR)) break;
        }
        $9d7bd82cb980c61d$var$parseExprListItem(false);
    }
}
function $9d7bd82cb980c61d$var$shouldParseAsyncArrow() {
    return (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).arrow);
}
function $9d7bd82cb980c61d$var$parseAsyncArrowFromCallExpression(startTokenIndex) {
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) (0, $f50510ec4ff63acc$export$490a9bc22f3cab3f)();
    else if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) (0, $37322500987f8c0d$export$6c11d14a2632a0dc)();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).arrow);
    $9d7bd82cb980c61d$export$9286d8f9fb90b029(startTokenIndex);
}
// Parse a no-call expression (like argument of `new` or `::` operators).
function $9d7bd82cb980c61d$var$parseNoCallExpr() {
    var startTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    $9d7bd82cb980c61d$export$fa61731cf32bc243();
    $9d7bd82cb980c61d$var$parseSubscripts(startTokenIndex, true);
}
function $9d7bd82cb980c61d$export$fa61731cf32bc243() {
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).modulo)) {
        // V8 intrinsic expression. Just parse the identifier, and the function invocation is parsed
        // naturally.
        $9d7bd82cb980c61d$export$321543c11f6250ad();
        return false;
    }
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxText) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxEmptyText)) {
        $9d7bd82cb980c61d$export$d1b3e78ad34a47ef();
        return false;
    } else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan) && (0, $875661fa68d3a4de$export$43bb667a94af025a)) {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type = (0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxTagStart;
        (0, $2c27fc7dc0d1372f$export$7cbe8c53d909e342)();
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        return false;
    }
    var canBeArrow = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).potentialArrowAt === (0, $875661fa68d3a4de$export$ca000e230c0caa3e).start;
    switch((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type){
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).slash:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).assign:
            (0, $e2df986cc8bbbda9$export$f6864f1ed2347988)();
        // Fall through.
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._super:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._this:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).regexp:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).num:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).bigint:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).decimal:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).string:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._null:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._true:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._false:
            (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
            return false;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._import:
            (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
            if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).dot)) {
                // import.meta
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f).name;
                (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
                $9d7bd82cb980c61d$export$321543c11f6250ad();
            }
            return false;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).name:
            {
                var startTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
                var functionStart = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).start;
                var contextualKeyword = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).contextualKeyword;
                $9d7bd82cb980c61d$export$321543c11f6250ad();
                if (contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._await) {
                    $9d7bd82cb980c61d$var$parseAwait();
                    return false;
                } else if (contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._async && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._function) && !(0, $40d5f3c610bd8f72$export$1c0919cee6560c3)()) {
                    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
                    (0, $0568c3da8e64a362$export$ba3dc2bd7c065219)(functionStart, false);
                    return false;
                } else if (canBeArrow && contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._async && !(0, $40d5f3c610bd8f72$export$1c0919cee6560c3)() && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) {
                    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth++;
                    (0, $43e5b81ee278119a$export$7538cb03fa894c83)(false);
                    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).arrow);
                    // let foo = async bar => {};
                    $9d7bd82cb980c61d$export$9286d8f9fb90b029(startTokenIndex);
                    return true;
                } else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._do) && !(0, $40d5f3c610bd8f72$export$1c0919cee6560c3)()) {
                    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
                    (0, $0568c3da8e64a362$export$4aed668c47d45036)();
                    return false;
                }
                if (canBeArrow && !(0, $40d5f3c610bd8f72$export$1c0919cee6560c3)() && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).arrow)) {
                    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth++;
                    (0, $43e5b81ee278119a$export$80e4117797ed03a6)(false);
                    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).arrow);
                    $9d7bd82cb980c61d$export$9286d8f9fb90b029(startTokenIndex);
                    return true;
                }
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).Access;
                return false;
            }
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._do:
            (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
            (0, $0568c3da8e64a362$export$4aed668c47d45036)();
            return false;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL:
            {
                var wasArrow = $9d7bd82cb980c61d$var$parseParenAndDistinguishExpression(canBeArrow);
                return wasArrow;
            }
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL:
            (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
            $9d7bd82cb980c61d$var$parseExprList((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR, true);
            return false;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL:
            $9d7bd82cb980c61d$export$908e61e44ae774e(false, false);
            return false;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._function:
            $9d7bd82cb980c61d$var$parseFunctionExpression();
            return false;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).at:
            (0, $0568c3da8e64a362$export$3f4d9519f687227a)();
        // Fall through.
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._class:
            (0, $0568c3da8e64a362$export$542081d93172af)(false);
            return false;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._new:
            $9d7bd82cb980c61d$var$parseNew();
            return false;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).backQuote:
            $9d7bd82cb980c61d$export$2e2dbd43b49fd373();
            return false;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).doubleColon:
            (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
            $9d7bd82cb980c61d$var$parseNoCallExpr();
            return false;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).hash:
            {
                var code = (0, $e2df986cc8bbbda9$export$847169391b2516b8)();
                if ((0, $c0e0280b0658a40b$export$dc1d1d7d9fdffb8)[code] || code === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).backslash) $9d7bd82cb980c61d$var$parseMaybePrivateName();
                else (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
                // Smart pipeline topic reference.
                return false;
            }
        default:
            (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
            return false;
    }
}
function $9d7bd82cb980c61d$var$parseMaybePrivateName() {
    (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).hash);
    $9d7bd82cb980c61d$export$321543c11f6250ad();
}
function $9d7bd82cb980c61d$var$parseFunctionExpression() {
    var functionStart = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).start;
    $9d7bd82cb980c61d$export$321543c11f6250ad();
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).dot)) // function.sent
    $9d7bd82cb980c61d$export$321543c11f6250ad();
    (0, $0568c3da8e64a362$export$ba3dc2bd7c065219)(functionStart, false);
}
function $9d7bd82cb980c61d$export$d1b3e78ad34a47ef() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
}
function $9d7bd82cb980c61d$export$d5ddb48bead5eb08() {
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL);
    $9d7bd82cb980c61d$export$ed9c825e502c46c8();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
}
// Returns true if this was an arrow expression.
function $9d7bd82cb980c61d$var$parseParenAndDistinguishExpression(canBeArrow) {
    // Assume this is a normal parenthesized expression, but if we see an arrow, we'll bail and
    // start over as a parameter list.
    var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
    var startTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL);
    var first = true;
    while(!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
            if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR)) break;
        }
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).ellipsis)) {
            (0, $43e5b81ee278119a$export$9504bd2748b5750c)(false);
            $9d7bd82cb980c61d$var$parseParenItem();
            break;
        } else $9d7bd82cb980c61d$export$b97bbe8a7805284f(false, true);
    }
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
    if (canBeArrow && $9d7bd82cb980c61d$var$shouldParseArrow()) {
        var wasArrow = $9d7bd82cb980c61d$export$92291a002e3a40fe();
        if (wasArrow) {
            // It was an arrow function this whole time, so start over and parse it as params so that we
            // get proper token annotations.
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth++;
            // Don't specify a context ID because arrow functions don't need a context ID.
            (0, $0568c3da8e64a362$export$dd0fc1c64275f2c4)();
            $9d7bd82cb980c61d$export$92291a002e3a40fe();
            $9d7bd82cb980c61d$export$9286d8f9fb90b029(startTokenIndex);
            if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).error) {
                // Nevermind! This must have been something that looks very much like an
                // arrow function but where its "parameter list" isn't actually a valid
                // parameter list. Force non-arrow parsing.
                // See https://github.com/alangpierce/sucrase/issues/666 for an example.
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
                $9d7bd82cb980c61d$var$parseParenAndDistinguishExpression(false);
                return false;
            }
            return true;
        }
    }
    return false;
}
function $9d7bd82cb980c61d$var$shouldParseArrow() {
    return (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon) || !(0, $40d5f3c610bd8f72$export$1c0919cee6560c3)();
}
function $9d7bd82cb980c61d$export$92291a002e3a40fe() {
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) return (0, $f50510ec4ff63acc$export$e20067ab7c70da1d)();
    else if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) return (0, $37322500987f8c0d$export$1ee5238ec4961bad)();
    else return (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).arrow);
}
function $9d7bd82cb980c61d$var$parseParenItem() {
    if ((0, $875661fa68d3a4de$export$757c2735689d2de8) || (0, $875661fa68d3a4de$export$92e334f8fe49aa94)) (0, $0a40c39f8b7da2a0$export$72bae99899f77e0f)();
}
// New's precedence is slightly tricky. It must allow its argument to
// be a `[]` or dot subscript expression, but not a call — at least,
// not without wrapping it in parentheses. Thus, it uses the noCalls
// argument to parseSubscripts to prevent it from consuming the
// argument list.
function $9d7bd82cb980c61d$var$parseNew() {
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._new);
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).dot)) {
        // new.target
        $9d7bd82cb980c61d$export$321543c11f6250ad();
        return;
    }
    $9d7bd82cb980c61d$var$parseNewCallee();
    if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) (0, $37322500987f8c0d$export$3d50348827f45b9a)();
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) $9d7bd82cb980c61d$var$parseExprList((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
}
function $9d7bd82cb980c61d$var$parseNewCallee() {
    $9d7bd82cb980c61d$var$parseNoCallExpr();
    (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).questionDot);
}
function $9d7bd82cb980c61d$export$2e2dbd43b49fd373() {
    // Finish `, read quasi
    (0, $e2df986cc8bbbda9$export$e4355ff2fab571ee)();
    // Finish quasi, read ${
    (0, $e2df986cc8bbbda9$export$e4355ff2fab571ee)();
    while(!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).backQuote) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).dollarBraceL);
        $9d7bd82cb980c61d$export$ed9c825e502c46c8();
        // Finish }, read quasi
        (0, $e2df986cc8bbbda9$export$e4355ff2fab571ee)();
        // Finish quasi, read either ${ or `
        (0, $e2df986cc8bbbda9$export$e4355ff2fab571ee)();
    }
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
}
function $9d7bd82cb980c61d$export$908e61e44ae774e(isPattern, isBlockScope) {
    // Attach a context ID to the object open and close brace and each object key.
    var contextId = (0, $875661fa68d3a4de$export$d0c215ddd78b3d24)();
    var first = true;
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
    while(!(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
            if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) break;
        }
        var isGenerator = false;
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).ellipsis)) {
            var previousIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
            (0, $43e5b81ee278119a$export$83bfd0877be8807a)();
            if (isPattern) {
                // Mark role when the only thing being spread over is an identifier.
                if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length === previousIndex + 2) (0, $43e5b81ee278119a$export$80e4117797ed03a6)(isBlockScope);
                if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) break;
            }
            continue;
        }
        if (!isPattern) isGenerator = (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).star);
        if (!isPattern && (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._async)) {
            if (isGenerator) (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
            $9d7bd82cb980c61d$export$321543c11f6250ad();
            if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) ;
            else {
                if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).star)) {
                    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
                    isGenerator = true;
                }
                $9d7bd82cb980c61d$export$ab65037f9c8fb3d3(contextId);
            }
        } else $9d7bd82cb980c61d$export$ab65037f9c8fb3d3(contextId);
        $9d7bd82cb980c61d$var$parseObjPropValue(isPattern, isBlockScope, contextId);
    }
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
}
function $9d7bd82cb980c61d$var$isGetterOrSetterMethod(isPattern) {
    // We go off of the next and don't bother checking if the node key is actually "get" or "set".
    // This lets us avoid generating a node, and should only make the validation worse.
    return !isPattern && ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).string) || // get "string"() {}
    (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).num) || // get 1() {}
    (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL) || // get ["string"]() {}
    (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name) || // get foo() {}
    !!((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type & (0, $30a0d13de21d779e$export$f435f793048e7a0f).IS_KEYWORD) // get debugger() {}
    );
}
// Returns true if this was a method.
function $9d7bd82cb980c61d$var$parseObjectMethod(isPattern, objectContextId) {
    // We don't need to worry about modifiers because object methods can't have optional bodies, so
    // the start will never be used.
    var functionStart = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).start;
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) {
        if (isPattern) (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
        $9d7bd82cb980c61d$export$9b0b57f9abc43790(functionStart, /* isConstructor */ false);
        return true;
    }
    if ($9d7bd82cb980c61d$var$isGetterOrSetterMethod(isPattern)) {
        $9d7bd82cb980c61d$export$ab65037f9c8fb3d3(objectContextId);
        $9d7bd82cb980c61d$export$9b0b57f9abc43790(functionStart, /* isConstructor */ false);
        return true;
    }
    return false;
}
function $9d7bd82cb980c61d$var$parseObjectProperty(isPattern, isBlockScope) {
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon)) {
        if (isPattern) (0, $43e5b81ee278119a$export$867fe1bcec5186c9)(isBlockScope);
        else $9d7bd82cb980c61d$export$b97bbe8a7805284f(false);
        return;
    }
    // Since there's no colon, we assume this is an object shorthand.
    // If we're in a destructuring, we've now discovered that the key was actually an assignee, so
    // we need to tag it as a declaration with the appropriate scope. Otherwise, we might need to
    // transform it on access, so mark it as a normal object shorthand.
    var identifierRole;
    if (isPattern) {
        if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth === 0) identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ObjectShorthandTopLevelDeclaration;
        else if (isBlockScope) identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ObjectShorthandBlockScopedDeclaration;
        else identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ObjectShorthandFunctionScopedDeclaration;
    } else identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ObjectShorthand;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = identifierRole;
    // Regardless of whether we know this to be a pattern or if we're in an ambiguous context, allow
    // parsing as if there's a default value.
    (0, $43e5b81ee278119a$export$867fe1bcec5186c9)(isBlockScope, true);
}
function $9d7bd82cb980c61d$var$parseObjPropValue(isPattern, isBlockScope, objectContextId) {
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) (0, $f50510ec4ff63acc$export$f7c2ce498525881a)();
    else if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) (0, $37322500987f8c0d$export$73c225682ce16be1)();
    var wasMethod = $9d7bd82cb980c61d$var$parseObjectMethod(isPattern, objectContextId);
    if (!wasMethod) $9d7bd82cb980c61d$var$parseObjectProperty(isPattern, isBlockScope);
}
function $9d7bd82cb980c61d$export$ab65037f9c8fb3d3(objectContextId) {
    if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) (0, $37322500987f8c0d$export$addd776ef798f4b2)();
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL)) {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].contextId = objectContextId;
        $9d7bd82cb980c61d$export$b97bbe8a7805284f();
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR);
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].contextId = objectContextId;
    } else {
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).num) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).string) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bigint) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).decimal)) $9d7bd82cb980c61d$export$fa61731cf32bc243();
        else $9d7bd82cb980c61d$var$parseMaybePrivateName();
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ObjectKey;
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].contextId = objectContextId;
    }
}
function $9d7bd82cb980c61d$export$9b0b57f9abc43790(functionStart, isConstructor) {
    var funcContextId = (0, $875661fa68d3a4de$export$d0c215ddd78b3d24)();
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth++;
    var startTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    var allowModifiers = isConstructor; // For TypeScript parameter properties
    (0, $0568c3da8e64a362$export$dd0fc1c64275f2c4)(allowModifiers, funcContextId);
    $9d7bd82cb980c61d$export$85b927192bdce5b9(functionStart, funcContextId);
    var endTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopes.push(new (0, $f0b680e833c1be0d$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, true));
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth--;
}
function $9d7bd82cb980c61d$export$9286d8f9fb90b029(startTokenIndex) {
    $9d7bd82cb980c61d$export$50f85c246417e18(true);
    var endTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopes.push(new (0, $f0b680e833c1be0d$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, true));
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth--;
}
function $9d7bd82cb980c61d$export$85b927192bdce5b9(functionStart) {
    var funcContextId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) (0, $f50510ec4ff63acc$export$3c36bc5140dd8c64)(functionStart, funcContextId);
    else if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) (0, $37322500987f8c0d$export$8dd4098a83322b31)(funcContextId);
    else $9d7bd82cb980c61d$export$50f85c246417e18(false, funcContextId);
}
function $9d7bd82cb980c61d$export$50f85c246417e18(allowExpression) {
    var funcContextId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var isExpression = allowExpression && !(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
    if (isExpression) $9d7bd82cb980c61d$export$b97bbe8a7805284f();
    else (0, $0568c3da8e64a362$export$4aed668c47d45036)(true, funcContextId);
}
// Parses a comma-separated list of expressions, and returns them as
// an array. `close` is the token type that ends the list, and
// `allowEmpty` can be turned on to allow subsequent commas with
// nothing in between them to be parsed as `null` (which is needed
// for array literals).
function $9d7bd82cb980c61d$var$parseExprList(close) {
    var allowEmpty = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var first = true;
    while(!(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)(close) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
            if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)(close)) break;
        }
        $9d7bd82cb980c61d$var$parseExprListItem(allowEmpty);
    }
}
function $9d7bd82cb980c61d$var$parseExprListItem(allowEmpty) {
    if (allowEmpty && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) ;
    else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).ellipsis)) {
        (0, $43e5b81ee278119a$export$83bfd0877be8807a)();
        $9d7bd82cb980c61d$var$parseParenItem();
    } else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).question)) // Partial function application proposal.
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    else $9d7bd82cb980c61d$export$b97bbe8a7805284f(false, true);
}
function $9d7bd82cb980c61d$export$321543c11f6250ad() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f).name;
}
// Parses await expression inside async function.
function $9d7bd82cb980c61d$var$parseAwait() {
    $9d7bd82cb980c61d$export$165911d2b803e372();
}
// Parses yield expression inside generator.
function $9d7bd82cb980c61d$var$parseYield() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).semi) && !(0, $40d5f3c610bd8f72$export$1c0919cee6560c3)()) {
        (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).star);
        $9d7bd82cb980c61d$export$b97bbe8a7805284f();
    }
}
// https://github.com/tc39/proposal-js-module-blocks
function $9d7bd82cb980c61d$var$parseModuleExpression() {
    (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._module);
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
    // For now, just call parseBlockBody to parse the block. In the future when we
    // implement full support, we'll want to emit scopes and possibly other
    // information.
    (0, $0568c3da8e64a362$export$e5110a9b2ab486ee)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR);
}




function $37322500987f8c0d$var$isMaybeDefaultImport(lookahead) {
    return (lookahead.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).name || !!(lookahead.type & (0, $30a0d13de21d779e$export$f435f793048e7a0f).IS_KEYWORD)) && lookahead.contextualKeyword !== (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._from;
}
function $37322500987f8c0d$var$flowParseTypeInitialiser(tok) {
    var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(0);
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)(tok || (0, $30a0d13de21d779e$export$f435f793048e7a0f).colon);
    $37322500987f8c0d$var$flowParseType();
    (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
}
function $37322500987f8c0d$var$flowParsePredicate() {
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).modulo);
    (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._checks);
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) {
        (0, $9d7bd82cb980c61d$export$ed9c825e502c46c8)();
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
    }
}
function $37322500987f8c0d$var$flowParseTypeAndPredicateInitialiser() {
    var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(0);
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon);
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).modulo)) $37322500987f8c0d$var$flowParsePredicate();
    else {
        $37322500987f8c0d$var$flowParseType();
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).modulo)) $37322500987f8c0d$var$flowParsePredicate();
    }
    (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
}
function $37322500987f8c0d$var$flowParseDeclareClass() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    $37322500987f8c0d$var$flowParseInterfaceish(/* isClass */ true);
}
function $37322500987f8c0d$var$flowParseDeclareFunction() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) $37322500987f8c0d$export$d1d23833c686097a();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL);
    $37322500987f8c0d$var$flowParseFunctionTypeParams();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
    $37322500987f8c0d$var$flowParseTypeAndPredicateInitialiser();
    (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
}
function $37322500987f8c0d$var$flowParseDeclare() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._class)) $37322500987f8c0d$var$flowParseDeclareClass();
    else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._function)) $37322500987f8c0d$var$flowParseDeclareFunction();
    else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._var)) $37322500987f8c0d$var$flowParseDeclareVariable();
    else if ((0, $40d5f3c610bd8f72$export$b8f8f7fffeb6fb36)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._module)) {
        if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).dot)) $37322500987f8c0d$var$flowParseDeclareModuleExports();
        else $37322500987f8c0d$var$flowParseDeclareModule();
    } else if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type)) $37322500987f8c0d$var$flowParseDeclareTypeAlias();
    else if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._opaque)) $37322500987f8c0d$var$flowParseDeclareOpaqueType();
    else if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._interface)) $37322500987f8c0d$var$flowParseDeclareInterface();
    else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export)) $37322500987f8c0d$var$flowParseDeclareExportDeclaration();
    else (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
}
function $37322500987f8c0d$var$flowParseDeclareVariable() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    $37322500987f8c0d$var$flowParseTypeAnnotatableIdentifier();
    (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
}
function $37322500987f8c0d$var$flowParseDeclareModule() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).string)) (0, $9d7bd82cb980c61d$export$fa61731cf32bc243)();
    else (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
    while(!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error)if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._import)) {
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        (0, $0568c3da8e64a362$export$532df1d0416e9789)();
    } else (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR);
}
function $37322500987f8c0d$var$flowParseDeclareExportDeclaration() {
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export);
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._default)) {
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._function) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._class)) // declare export default class ...
        // declare export default function ...
        $37322500987f8c0d$var$flowParseDeclare();
        else {
            // declare export default [type];
            $37322500987f8c0d$var$flowParseType();
            (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
        }
    } else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._var) || // declare export var ...
    (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._function) || // declare export function ...
    (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._class) || // declare export class ...
    (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._opaque) // declare export opaque ..
    ) $37322500987f8c0d$var$flowParseDeclare();
    else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).star) || // declare export * from ''
    (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL) || // declare export {} ...
    (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._interface) || // declare export interface ...
    (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type) || // declare export type ...
    (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._opaque) // declare export opaque type ...
    ) (0, $0568c3da8e64a362$export$3d6d7ef9486a61c3)();
    else (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
}
function $37322500987f8c0d$var$flowParseDeclareModuleExports() {
    (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._exports);
    $37322500987f8c0d$export$6c833037db1a1e96();
    (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
}
function $37322500987f8c0d$var$flowParseDeclareTypeAlias() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    $37322500987f8c0d$var$flowParseTypeAlias();
}
function $37322500987f8c0d$var$flowParseDeclareOpaqueType() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    $37322500987f8c0d$var$flowParseOpaqueType(true);
}
function $37322500987f8c0d$var$flowParseDeclareInterface() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    $37322500987f8c0d$var$flowParseInterfaceish();
}
// Interfaces
function $37322500987f8c0d$var$flowParseInterfaceish() {
    var isClass = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    $37322500987f8c0d$var$flowParseRestrictedIdentifier();
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) $37322500987f8c0d$export$d1d23833c686097a();
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._extends)) do $37322500987f8c0d$var$flowParseInterfaceExtends();
    while (!isClass && (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma));
    if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._mixins)) {
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        do $37322500987f8c0d$var$flowParseInterfaceExtends();
        while ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma));
    }
    if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._implements)) {
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        do $37322500987f8c0d$var$flowParseInterfaceExtends();
        while ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma));
    }
    $37322500987f8c0d$var$flowParseObjectType(isClass, false, isClass);
}
function $37322500987f8c0d$var$flowParseInterfaceExtends() {
    $37322500987f8c0d$var$flowParseQualifiedTypeIdentifier(false);
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) $37322500987f8c0d$var$flowParseTypeParameterInstantiation();
}
function $37322500987f8c0d$var$flowParseInterface() {
    $37322500987f8c0d$var$flowParseInterfaceish();
}
function $37322500987f8c0d$var$flowParseRestrictedIdentifier() {
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
}
function $37322500987f8c0d$var$flowParseTypeAlias() {
    $37322500987f8c0d$var$flowParseRestrictedIdentifier();
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) $37322500987f8c0d$export$d1d23833c686097a();
    $37322500987f8c0d$var$flowParseTypeInitialiser((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq);
    (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
}
function $37322500987f8c0d$var$flowParseOpaqueType(declare) {
    (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type);
    $37322500987f8c0d$var$flowParseRestrictedIdentifier();
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) $37322500987f8c0d$export$d1d23833c686097a();
    // Parse the supertype
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon)) $37322500987f8c0d$var$flowParseTypeInitialiser((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon);
    if (!declare) $37322500987f8c0d$var$flowParseTypeInitialiser((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq);
    (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
}
function $37322500987f8c0d$var$flowParseTypeParameter() {
    $37322500987f8c0d$export$addd776ef798f4b2();
    $37322500987f8c0d$var$flowParseTypeAnnotatableIdentifier();
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) $37322500987f8c0d$var$flowParseType();
}
function $37322500987f8c0d$export$d1d23833c686097a() {
    var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(0);
    // istanbul ignore else: this condition is already checked at all call sites
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).typeParameterStart)) (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    else (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
    do {
        $37322500987f8c0d$var$flowParseTypeParameter();
        if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).greaterThan)) (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
    }while (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).greaterThan) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error);
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).greaterThan);
    (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
}
function $37322500987f8c0d$var$flowParseTypeParameterInstantiation() {
    var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(0);
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan);
    while(!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).greaterThan) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        $37322500987f8c0d$var$flowParseType();
        if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).greaterThan)) (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
    }
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).greaterThan);
    (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
}
function $37322500987f8c0d$var$flowParseInterfaceType() {
    (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._interface);
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._extends)) do $37322500987f8c0d$var$flowParseInterfaceExtends();
    while ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma));
    $37322500987f8c0d$var$flowParseObjectType(false, false, false);
}
function $37322500987f8c0d$var$flowParseObjectPropertyKey() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).num) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).string)) (0, $9d7bd82cb980c61d$export$fa61731cf32bc243)();
    else (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
}
function $37322500987f8c0d$var$flowParseObjectTypeIndexer() {
    // Note: bracketL has already been consumed
    if ((0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)() === (0, $30a0d13de21d779e$export$f435f793048e7a0f).colon) {
        $37322500987f8c0d$var$flowParseObjectPropertyKey();
        $37322500987f8c0d$var$flowParseTypeInitialiser();
    } else $37322500987f8c0d$var$flowParseType();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR);
    $37322500987f8c0d$var$flowParseTypeInitialiser();
}
function $37322500987f8c0d$var$flowParseObjectTypeInternalSlot() {
    // Note: both bracketL have already been consumed
    $37322500987f8c0d$var$flowParseObjectPropertyKey();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR);
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR);
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) $37322500987f8c0d$var$flowParseObjectTypeMethodish();
    else {
        (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).question);
        $37322500987f8c0d$var$flowParseTypeInitialiser();
    }
}
function $37322500987f8c0d$var$flowParseObjectTypeMethodish() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) $37322500987f8c0d$export$d1d23833c686097a();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL);
    while(!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR) && !(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).ellipsis) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        $37322500987f8c0d$var$flowParseFunctionTypeParam();
        if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR)) (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
    }
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).ellipsis)) $37322500987f8c0d$var$flowParseFunctionTypeParam();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
    $37322500987f8c0d$var$flowParseTypeInitialiser();
}
function $37322500987f8c0d$var$flowParseObjectTypeCallProperty() {
    $37322500987f8c0d$var$flowParseObjectTypeMethodish();
}
function $37322500987f8c0d$var$flowParseObjectType(allowStatic, allowExact, allowProto) {
    var endDelim;
    if (allowExact && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceBarL)) {
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceBarL);
        endDelim = (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceBarR;
    } else {
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
        endDelim = (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR;
    }
    while(!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)(endDelim) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        if (allowProto && (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._proto)) {
            var lookahead = (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)();
            if (lookahead !== (0, $30a0d13de21d779e$export$f435f793048e7a0f).colon && lookahead !== (0, $30a0d13de21d779e$export$f435f793048e7a0f).question) {
                (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
                allowStatic = false;
            }
        }
        if (allowStatic && (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._static)) {
            var lookahead1 = (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)();
            if (lookahead1 !== (0, $30a0d13de21d779e$export$f435f793048e7a0f).colon && lookahead1 !== (0, $30a0d13de21d779e$export$f435f793048e7a0f).question) (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        }
        $37322500987f8c0d$export$addd776ef798f4b2();
        if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL)) {
            if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL)) $37322500987f8c0d$var$flowParseObjectTypeInternalSlot();
            else $37322500987f8c0d$var$flowParseObjectTypeIndexer();
        } else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) $37322500987f8c0d$var$flowParseObjectTypeCallProperty();
        else {
            if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._get) || (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._set)) {
                var lookahead2 = (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)();
                if (lookahead2 === (0, $30a0d13de21d779e$export$f435f793048e7a0f).name || lookahead2 === (0, $30a0d13de21d779e$export$f435f793048e7a0f).string || lookahead2 === (0, $30a0d13de21d779e$export$f435f793048e7a0f).num) (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
            }
            $37322500987f8c0d$var$flowParseObjectTypeProperty();
        }
        $37322500987f8c0d$var$flowObjectTypeSemicolon();
    }
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)(endDelim);
}
function $37322500987f8c0d$var$flowParseObjectTypeProperty() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).ellipsis)) {
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).ellipsis);
        if (!(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).semi);
        // Explicit inexact object syntax.
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) return;
        $37322500987f8c0d$var$flowParseType();
    } else {
        $37322500987f8c0d$var$flowParseObjectPropertyKey();
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) // This is a method property
        $37322500987f8c0d$var$flowParseObjectTypeMethodish();
        else {
            (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).question);
            $37322500987f8c0d$var$flowParseTypeInitialiser();
        }
    }
}
function $37322500987f8c0d$var$flowObjectTypeSemicolon() {
    if (!(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).semi) && !(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma) && !(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR) && !(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceBarR)) (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
}
function $37322500987f8c0d$var$flowParseQualifiedTypeIdentifier(initialIdAlreadyParsed) {
    if (!initialIdAlreadyParsed) (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    while((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).dot))(0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
}
function $37322500987f8c0d$var$flowParseGenericType() {
    $37322500987f8c0d$var$flowParseQualifiedTypeIdentifier(true);
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) $37322500987f8c0d$var$flowParseTypeParameterInstantiation();
}
function $37322500987f8c0d$var$flowParseTypeofType() {
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._typeof);
    $37322500987f8c0d$var$flowParsePrimaryType();
}
function $37322500987f8c0d$var$flowParseTupleType() {
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL);
    // We allow trailing commas
    while((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos < (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).length && !(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR)){
        $37322500987f8c0d$var$flowParseType();
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR)) break;
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
    }
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR);
}
function $37322500987f8c0d$var$flowParseFunctionTypeParam() {
    var lookahead = (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)();
    if (lookahead === (0, $30a0d13de21d779e$export$f435f793048e7a0f).colon || lookahead === (0, $30a0d13de21d779e$export$f435f793048e7a0f).question) {
        (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
        (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).question);
        $37322500987f8c0d$var$flowParseTypeInitialiser();
    } else $37322500987f8c0d$var$flowParseType();
}
function $37322500987f8c0d$var$flowParseFunctionTypeParams() {
    while(!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR) && !(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).ellipsis) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        $37322500987f8c0d$var$flowParseFunctionTypeParam();
        if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR)) (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
    }
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).ellipsis)) $37322500987f8c0d$var$flowParseFunctionTypeParam();
}
// The parsing of types roughly parallels the parsing of expressions, and
// primary types are kind of like primary expressions...they're the
// primitives with which other types are constructed.
function $37322500987f8c0d$var$flowParsePrimaryType() {
    var isGroupedType = false;
    var oldNoAnonFunctionType = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).noAnonFunctionType;
    switch((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type){
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).name:
            if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._interface)) {
                $37322500987f8c0d$var$flowParseInterfaceType();
                return;
            }
            (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
            $37322500987f8c0d$var$flowParseGenericType();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL:
            $37322500987f8c0d$var$flowParseObjectType(false, false, false);
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceBarL:
            $37322500987f8c0d$var$flowParseObjectType(false, true, false);
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL:
            $37322500987f8c0d$var$flowParseTupleType();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan:
            $37322500987f8c0d$export$d1d23833c686097a();
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL);
            $37322500987f8c0d$var$flowParseFunctionTypeParams();
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).arrow);
            $37322500987f8c0d$var$flowParseType();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL:
            (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
            // Check to see if this is actually a grouped type
            if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR) && !(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).ellipsis)) {
                if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) {
                    var token = (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)();
                    isGroupedType = token !== (0, $30a0d13de21d779e$export$f435f793048e7a0f).question && token !== (0, $30a0d13de21d779e$export$f435f793048e7a0f).colon;
                } else isGroupedType = true;
            }
            if (isGroupedType) {
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).noAnonFunctionType = false;
                $37322500987f8c0d$var$flowParseType();
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).noAnonFunctionType = oldNoAnonFunctionType;
                // A `,` or a `) =>` means this is an anonymous function type
                if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).noAnonFunctionType || !((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR) && (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)() === (0, $30a0d13de21d779e$export$f435f793048e7a0f).arrow)) {
                    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
                    return;
                } else // Eat a comma if there is one
                (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
            }
            $37322500987f8c0d$var$flowParseFunctionTypeParams();
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).arrow);
            $37322500987f8c0d$var$flowParseType();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).minus:
            (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
            (0, $9d7bd82cb980c61d$export$d1b3e78ad34a47ef)();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).string:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).num:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._true:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._false:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._null:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._this:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._void:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).star:
            (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
            return;
        default:
            if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type === (0, $30a0d13de21d779e$export$f435f793048e7a0f)._typeof) {
                $37322500987f8c0d$var$flowParseTypeofType();
                return;
            } else if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type & (0, $30a0d13de21d779e$export$f435f793048e7a0f).IS_KEYWORD) {
                (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
                (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f).name;
                return;
            }
    }
    (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
}
function $37322500987f8c0d$var$flowParsePostfixType() {
    $37322500987f8c0d$var$flowParsePrimaryType();
    while(!(0, $40d5f3c610bd8f72$export$1c0919cee6560c3)() && ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).questionDot))){
        (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).questionDot);
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL);
        if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR)) ;
        else {
            // Indexed access type
            $37322500987f8c0d$var$flowParseType();
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR);
        }
    }
}
function $37322500987f8c0d$var$flowParsePrefixType() {
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).question)) $37322500987f8c0d$var$flowParsePrefixType();
    else $37322500987f8c0d$var$flowParsePostfixType();
}
function $37322500987f8c0d$var$flowParseAnonFunctionWithoutParens() {
    $37322500987f8c0d$var$flowParsePrefixType();
    if (!(0, $875661fa68d3a4de$export$ca000e230c0caa3e).noAnonFunctionType && (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).arrow)) $37322500987f8c0d$var$flowParseType();
}
function $37322500987f8c0d$var$flowParseIntersectionType() {
    (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bitwiseAND);
    $37322500987f8c0d$var$flowParseAnonFunctionWithoutParens();
    while((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bitwiseAND))$37322500987f8c0d$var$flowParseAnonFunctionWithoutParens();
}
function $37322500987f8c0d$var$flowParseUnionType() {
    (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bitwiseOR);
    $37322500987f8c0d$var$flowParseIntersectionType();
    while((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bitwiseOR))$37322500987f8c0d$var$flowParseIntersectionType();
}
function $37322500987f8c0d$var$flowParseType() {
    $37322500987f8c0d$var$flowParseUnionType();
}
function $37322500987f8c0d$export$6c833037db1a1e96() {
    $37322500987f8c0d$var$flowParseTypeInitialiser();
}
function $37322500987f8c0d$var$flowParseTypeAnnotatableIdentifier() {
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon)) $37322500987f8c0d$export$6c833037db1a1e96();
}
function $37322500987f8c0d$export$addd776ef798f4b2() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).plus) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).minus)) {
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
    }
}
function $37322500987f8c0d$export$8dd4098a83322b31(funcContextId) {
    // For arrow functions, `parseArrow` handles the return type itself.
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon)) $37322500987f8c0d$var$flowParseTypeAndPredicateInitialiser();
    (0, $9d7bd82cb980c61d$export$50f85c246417e18)(false, funcContextId);
}
function $37322500987f8c0d$export$4eb11794b3b71235(startTokenIndex, noCalls, stopState) {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).questionDot) && (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)() === (0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan) {
        if (noCalls) {
            stopState.stop = true;
            return;
        }
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        $37322500987f8c0d$var$flowParseTypeParameterInstantiation();
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL);
        (0, $9d7bd82cb980c61d$export$970763873d9efa73)();
        return;
    } else if (!noCalls && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) {
        var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
        $37322500987f8c0d$var$flowParseTypeParameterInstantiation();
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL);
        (0, $9d7bd82cb980c61d$export$970763873d9efa73)();
        if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).error) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        else return;
    }
    (0, $9d7bd82cb980c61d$export$31dc8e486c1a1be6)(startTokenIndex, noCalls, stopState);
}
function $37322500987f8c0d$export$3d50348827f45b9a() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) {
        var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
        $37322500987f8c0d$var$flowParseTypeParameterInstantiation();
        if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).error) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    }
}
function $37322500987f8c0d$export$d29f5a1d65cdba9d() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name) && (0, $875661fa68d3a4de$export$ca000e230c0caa3e).contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._interface) {
        var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(0);
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        $37322500987f8c0d$var$flowParseInterface();
        (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
        return true;
    } else if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._enum)) {
        $37322500987f8c0d$var$flowParseEnumDeclaration();
        return true;
    }
    return false;
}
function $37322500987f8c0d$export$c6f815d203f26c4f() {
    if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._enum)) {
        $37322500987f8c0d$var$flowParseEnumDeclaration();
        return true;
    }
    return false;
}
function $37322500987f8c0d$export$3b5c354482eb1586(contextualKeyword) {
    if (contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._declare) {
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._class) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._function) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._var) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export)) {
            var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(1);
            $37322500987f8c0d$var$flowParseDeclare();
            (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
        }
    } else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) {
        if (contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._interface) {
            var oldIsType1 = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(1);
            $37322500987f8c0d$var$flowParseInterface();
            (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType1);
        } else if (contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type) {
            var oldIsType2 = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(1);
            $37322500987f8c0d$var$flowParseTypeAlias();
            (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType2);
        } else if (contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._opaque) {
            var oldIsType3 = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(1);
            $37322500987f8c0d$var$flowParseOpaqueType(false);
            (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType3);
        }
    }
    (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
}
function $37322500987f8c0d$export$74061750bc0f2203() {
    return (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type) || (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._interface) || (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._opaque) || (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._enum);
}
function $37322500987f8c0d$export$8a047f67d2009628() {
    return (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name) && ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type || (0, $875661fa68d3a4de$export$ca000e230c0caa3e).contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._interface || (0, $875661fa68d3a4de$export$ca000e230c0caa3e).contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._opaque || (0, $875661fa68d3a4de$export$ca000e230c0caa3e).contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._enum);
}
function $37322500987f8c0d$export$64e87490a40a8a82() {
    if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type)) {
        var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(1);
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) {
            // export type { foo, bar };
            (0, $0568c3da8e64a362$export$909d3b50f7924101)();
            (0, $0568c3da8e64a362$export$49b6f13e189abea3)();
        } else // export type Foo = Bar;
        $37322500987f8c0d$var$flowParseTypeAlias();
        (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
    } else if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._opaque)) {
        var oldIsType1 = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(1);
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        // export opaque type Foo = Bar;
        $37322500987f8c0d$var$flowParseOpaqueType(false);
        (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType1);
    } else if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._interface)) {
        var oldIsType2 = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(1);
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        $37322500987f8c0d$var$flowParseInterface();
        (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType2);
    } else (0, $0568c3da8e64a362$export$68b986de0b252bc8)(true);
}
function $37322500987f8c0d$export$563bbc61583bd08() {
    return (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).star) || (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type) && (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)() === (0, $30a0d13de21d779e$export$f435f793048e7a0f).star;
}
function $37322500987f8c0d$export$dc2ba80ebf42d8d6() {
    if ((0, $40d5f3c610bd8f72$export$b8f8f7fffeb6fb36)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type)) {
        var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(2);
        (0, $0568c3da8e64a362$export$18fb3cb64b956ba0)();
        (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
    } else (0, $0568c3da8e64a362$export$18fb3cb64b956ba0)();
}
function $37322500987f8c0d$export$131557296be11580(hasSuper) {
    if (hasSuper && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) $37322500987f8c0d$var$flowParseTypeParameterInstantiation();
    if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._implements)) {
        var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(0);
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._implements;
        do {
            $37322500987f8c0d$var$flowParseRestrictedIdentifier();
            if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) $37322500987f8c0d$var$flowParseTypeParameterInstantiation();
        }while ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma));
        (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
    }
}
function $37322500987f8c0d$export$73c225682ce16be1() {
    // method shorthand
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) {
        $37322500987f8c0d$export$d1d23833c686097a();
        if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
    }
}
function $37322500987f8c0d$export$a9031cdcb39989e3() {
    var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(0);
    (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).question);
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon)) $37322500987f8c0d$export$6c833037db1a1e96();
    (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
}
function $37322500987f8c0d$export$2ca2c81ecd0ec221() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._typeof) || (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type)) {
        var lh = (0, $e2df986cc8bbbda9$export$ef1b94c514fc060a)();
        if ($37322500987f8c0d$var$isMaybeDefaultImport(lh) || lh.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL || lh.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).star) (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    }
}
function $37322500987f8c0d$export$217da275bf556fe8() {
    var isTypeKeyword = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type || (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type === (0, $30a0d13de21d779e$export$f435f793048e7a0f)._typeof;
    if (isTypeKeyword) (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    else (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._as) && !(0, $40d5f3c610bd8f72$export$d1b5391c35999eba)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._as)) {
        (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
        if (isTypeKeyword && !(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name) && !((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type & (0, $30a0d13de21d779e$export$f435f793048e7a0f).IS_KEYWORD)) ;
        else // `import {type as foo`
        (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    } else {
        if (isTypeKeyword && ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name) || !!((0, $875661fa68d3a4de$export$ca000e230c0caa3e).type & (0, $30a0d13de21d779e$export$f435f793048e7a0f).IS_KEYWORD))) // `import {type foo`
        (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
        if ((0, $40d5f3c610bd8f72$export$b8f8f7fffeb6fb36)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._as)) (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    }
}
function $37322500987f8c0d$export$e3b9ccf4c3c69613() {
    // Originally this checked if the method is a getter/setter, but if it was, we'd crash soon
    // anyway, so don't try to propagate that information.
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) {
        var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(0);
        $37322500987f8c0d$export$d1d23833c686097a();
        (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
    }
}
function $37322500987f8c0d$export$273b459834534d69() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon)) $37322500987f8c0d$export$6c833037db1a1e96();
}
function $37322500987f8c0d$export$6c11d14a2632a0dc() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon)) {
        var oldNoAnonFunctionType = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).noAnonFunctionType;
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).noAnonFunctionType = true;
        $37322500987f8c0d$export$6c833037db1a1e96();
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).noAnonFunctionType = oldNoAnonFunctionType;
    }
}
function $37322500987f8c0d$export$abad2599830a7c66(noIn, isWithinParens) {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) {
        var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
        var wasArrow = (0, $9d7bd82cb980c61d$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
        if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).error) {
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type = (0, $30a0d13de21d779e$export$f435f793048e7a0f).typeParameterStart;
        } else return wasArrow;
        var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(0);
        $37322500987f8c0d$export$d1d23833c686097a();
        (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
        wasArrow = (0, $9d7bd82cb980c61d$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
        if (wasArrow) return true;
        (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
    }
    return (0, $9d7bd82cb980c61d$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
}
function $37322500987f8c0d$export$1ee5238ec4961bad() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon)) {
        var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(0);
        var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
        var oldNoAnonFunctionType = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).noAnonFunctionType;
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).noAnonFunctionType = true;
        $37322500987f8c0d$var$flowParseTypeAndPredicateInitialiser();
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).noAnonFunctionType = oldNoAnonFunctionType;
        if ((0, $40d5f3c610bd8f72$export$1c0919cee6560c3)()) (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
        if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).arrow)) (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
        if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).error) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
    }
    return (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).arrow);
}
function $37322500987f8c0d$export$7c7ba3c0c5ae1f67(startTokenIndex) {
    var noCalls = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._async && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) {
        var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
        var wasArrow = $37322500987f8c0d$var$parseAsyncArrowWithTypeParameters();
        if (wasArrow && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error) return;
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    }
    (0, $9d7bd82cb980c61d$export$c2cc03eea353aa42)(startTokenIndex, noCalls);
}
// Returns true if there was an arrow function here.
function $37322500987f8c0d$var$parseAsyncArrowWithTypeParameters() {
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth++;
    var startTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    (0, $0568c3da8e64a362$export$dd0fc1c64275f2c4)();
    if (!(0, $9d7bd82cb980c61d$export$92291a002e3a40fe)()) return false;
    (0, $9d7bd82cb980c61d$export$9286d8f9fb90b029)(startTokenIndex);
    return true;
}
function $37322500987f8c0d$var$flowParseEnumDeclaration() {
    (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._enum);
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._enum;
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    $37322500987f8c0d$var$flowParseEnumBody();
}
function $37322500987f8c0d$var$flowParseEnumBody() {
    if ((0, $40d5f3c610bd8f72$export$b8f8f7fffeb6fb36)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._of)) (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
    $37322500987f8c0d$var$flowParseEnumMembers();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR);
}
function $37322500987f8c0d$var$flowParseEnumMembers() {
    while(!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).ellipsis)) break;
        $37322500987f8c0d$var$flowParseEnumMember();
        if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
    }
}
function $37322500987f8c0d$var$flowParseEnumMember() {
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) // Flow enum values are always just one token (a string, number, or boolean literal).
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
}












function $0568c3da8e64a362$export$cb09d803724ddba2() {
    $0568c3da8e64a362$export$e5110a9b2ab486ee((0, $30a0d13de21d779e$export$f435f793048e7a0f).eof);
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopes.push(new (0, $f0b680e833c1be0d$export$775b6bb06e53a214)(0, (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length, true));
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth !== 0) throw new Error("Invalid scope depth at end of file: ".concat((0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth));
    return new (0, $8404178774830e3d$export$b6afa8811b7e644e)((0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens, (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopes);
}
function $0568c3da8e64a362$export$68b986de0b252bc8(declaration) {
    if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) {
        if ((0, $37322500987f8c0d$export$d29f5a1d65cdba9d)()) return;
    }
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).at)) $0568c3da8e64a362$export$3f4d9519f687227a();
    $0568c3da8e64a362$var$parseStatementContent(declaration);
}
function $0568c3da8e64a362$var$parseStatementContent(declaration) {
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) {
        if ((0, $f50510ec4ff63acc$export$bd8d07f8ee509b14)()) return;
    }
    var starttype = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type;
    // Most types of statements are recognized by the keyword they
    // start with. Many are trivial to parse, some require a bit of
    // complexity.
    switch(starttype){
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._break:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._continue:
            $0568c3da8e64a362$var$parseBreakContinueStatement();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._debugger:
            $0568c3da8e64a362$var$parseDebuggerStatement();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._do:
            $0568c3da8e64a362$var$parseDoStatement();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._for:
            $0568c3da8e64a362$var$parseForStatement();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._function:
            if ((0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)() === (0, $30a0d13de21d779e$export$f435f793048e7a0f).dot) break;
            if (!declaration) (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
            $0568c3da8e64a362$var$parseFunctionStatement();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._class:
            if (!declaration) (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
            $0568c3da8e64a362$export$542081d93172af(true);
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._if:
            $0568c3da8e64a362$var$parseIfStatement();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._return:
            $0568c3da8e64a362$var$parseReturnStatement();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._switch:
            $0568c3da8e64a362$var$parseSwitchStatement();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._throw:
            $0568c3da8e64a362$var$parseThrowStatement();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._try:
            $0568c3da8e64a362$var$parseTryStatement();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._let:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._const:
            if (!declaration) (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)(); // NOTE: falls through to _var
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._var:
            $0568c3da8e64a362$export$73f0614724a3919a(starttype !== (0, $30a0d13de21d779e$export$f435f793048e7a0f)._var);
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._while:
            $0568c3da8e64a362$var$parseWhileStatement();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL:
            $0568c3da8e64a362$export$4aed668c47d45036();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).semi:
            $0568c3da8e64a362$var$parseEmptyStatement();
            return;
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._export:
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f)._import:
            {
                var nextType = (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)();
                if (nextType === (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL || nextType === (0, $30a0d13de21d779e$export$f435f793048e7a0f).dot) break;
                (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
                if (starttype === (0, $30a0d13de21d779e$export$f435f793048e7a0f)._import) $0568c3da8e64a362$export$532df1d0416e9789();
                else $0568c3da8e64a362$export$3d6d7ef9486a61c3();
                return;
            }
        case (0, $30a0d13de21d779e$export$f435f793048e7a0f).name:
            if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._async) {
                var functionStart = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).start;
                // peek ahead and see if next token is a function
                var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
                (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
                if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._function) && !(0, $40d5f3c610bd8f72$export$1c0919cee6560c3)()) {
                    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._function);
                    $0568c3da8e64a362$export$ba3dc2bd7c065219(functionStart, true);
                    return;
                } else (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            } else if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._using && !(0, $40d5f3c610bd8f72$export$a4f1ee8cbd9b31ba)() && // Statements like `using[0]` and `using in foo` aren't actual using
            // declarations.
            (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)() === (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) {
                $0568c3da8e64a362$export$73f0614724a3919a(true);
                return;
            } else if ($0568c3da8e64a362$var$startsAwaitUsing()) {
                (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._await);
                $0568c3da8e64a362$export$73f0614724a3919a(true);
                return;
            }
        default:
            break;
    }
    // If the statement does not start with a statement keyword or a
    // brace, it's an ExpressionStatement or LabeledStatement. We
    // simply start parsing an expression, and afterwards, if the
    // next token is a colon and the expression was a simple
    // Identifier node, we switch to interpreting it as a label.
    var initialTokensLength = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    (0, $9d7bd82cb980c61d$export$ed9c825e502c46c8)();
    var simpleName = null;
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length === initialTokensLength + 1) {
        var token = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1];
        if (token.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) simpleName = token.contextualKeyword;
    }
    if (simpleName == null) {
        (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
        return;
    }
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon)) $0568c3da8e64a362$var$parseLabeledStatement();
    else // This was an identifier, so we might want to handle flow/typescript-specific cases.
    $0568c3da8e64a362$var$parseIdentifierStatement(simpleName);
}
/**
 * Determine if we're positioned at an `await using` declaration.
 *
 * Note that this can happen either in place of a regular variable declaration
 * or in a loop body, and in both places, there are similar-looking cases where
 * we need to return false.
 *
 * Examples returning true:
 * await using foo = bar();
 * for (await using a of b) {}
 *
 * Examples returning false:
 * await using
 * await using + 1
 * await using instanceof T
 * for (await using;;) {}
 *
 * For now, we early return if we don't see `await`, then do a simple
 * backtracking-based lookahead for the `using` and identifier tokens. In the
 * future, this could be optimized with a character-based approach.
 */ function $0568c3da8e64a362$var$startsAwaitUsing() {
    if (!(0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._await)) return false;
    var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
    // await
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    if (!(0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._using) || (0, $40d5f3c610bd8f72$export$942fa35f3a7c108c)()) {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return false;
    }
    // using
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name) || (0, $40d5f3c610bd8f72$export$942fa35f3a7c108c)()) {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return false;
    }
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return true;
}
function $0568c3da8e64a362$export$3f4d9519f687227a() {
    while((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).at))$0568c3da8e64a362$var$parseDecorator();
}
function $0568c3da8e64a362$var$parseDecorator() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) {
        (0, $9d7bd82cb980c61d$export$ed9c825e502c46c8)();
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
    } else {
        (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
        while((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).dot))(0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
        $0568c3da8e64a362$var$parseMaybeDecoratorArguments();
    }
}
function $0568c3da8e64a362$var$parseMaybeDecoratorArguments() {
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) (0, $f50510ec4ff63acc$export$fd0439ea9a1ac1ea)();
    else $0568c3da8e64a362$export$50c128b10ac5ea5b();
}
function $0568c3da8e64a362$export$50c128b10ac5ea5b() {
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) (0, $9d7bd82cb980c61d$export$970763873d9efa73)();
}
function $0568c3da8e64a362$var$parseBreakContinueStatement() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    if (!(0, $40d5f3c610bd8f72$export$12d132b6e81066e4)()) {
        (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
        (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
    }
}
function $0568c3da8e64a362$var$parseDebuggerStatement() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
}
function $0568c3da8e64a362$var$parseDoStatement() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    $0568c3da8e64a362$export$68b986de0b252bc8(false);
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._while);
    (0, $9d7bd82cb980c61d$export$d5ddb48bead5eb08)();
    (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).semi);
}
function $0568c3da8e64a362$var$parseForStatement() {
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth++;
    var startTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    $0568c3da8e64a362$var$parseAmbiguousForStatement();
    var endTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopes.push(new (0, $f0b680e833c1be0d$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, false));
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth--;
}
/**
 * Determine if this token is a `using` declaration (explicit resource
 * management) as part of a loop.
 * https://github.com/tc39/proposal-explicit-resource-management
 */ function $0568c3da8e64a362$var$isUsingInLoop() {
    if (!(0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._using)) return false;
    // This must be `for (using of`, where `using` is the name of the loop
    // variable.
    if ((0, $40d5f3c610bd8f72$export$d1b5391c35999eba)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._of)) return false;
    return true;
}
// Disambiguating between a `for` and a `for`/`in` or `for`/`of`
// loop is non-trivial. Basically, we have to parse the init `var`
// statement or expression, disallowing the `in` operator (see
// the second parameter to `parseExpression`), and then check
// whether the next token is `in` or `of`. When there is no init
// part (semicolon immediately after the opening parenthesis), it
// is a regular `for` loop.
function $0568c3da8e64a362$var$parseAmbiguousForStatement() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    var forAwait = false;
    if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._await)) {
        forAwait = true;
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    }
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL);
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).semi)) {
        if (forAwait) (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
        $0568c3da8e64a362$var$parseFor();
        return;
    }
    var isAwaitUsing = $0568c3da8e64a362$var$startsAwaitUsing();
    if (isAwaitUsing || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._var) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._let) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._const) || $0568c3da8e64a362$var$isUsingInLoop()) {
        if (isAwaitUsing) (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._await);
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        $0568c3da8e64a362$var$parseVar(true, (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type !== (0, $30a0d13de21d779e$export$f435f793048e7a0f)._var);
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._in) || (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._of)) {
            $0568c3da8e64a362$var$parseForIn(forAwait);
            return;
        }
        $0568c3da8e64a362$var$parseFor();
        return;
    }
    (0, $9d7bd82cb980c61d$export$ed9c825e502c46c8)(true);
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._in) || (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._of)) {
        $0568c3da8e64a362$var$parseForIn(forAwait);
        return;
    }
    if (forAwait) (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
    $0568c3da8e64a362$var$parseFor();
}
function $0568c3da8e64a362$var$parseFunctionStatement() {
    var functionStart = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).start;
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    $0568c3da8e64a362$export$ba3dc2bd7c065219(functionStart, true);
}
function $0568c3da8e64a362$var$parseIfStatement() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    (0, $9d7bd82cb980c61d$export$d5ddb48bead5eb08)();
    $0568c3da8e64a362$export$68b986de0b252bc8(false);
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._else)) $0568c3da8e64a362$export$68b986de0b252bc8(false);
}
function $0568c3da8e64a362$var$parseReturnStatement() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    // In `return` (and `break`/`continue`), the keywords with
    // optional arguments, we eagerly look for a semicolon or the
    // possibility to insert one.
    if (!(0, $40d5f3c610bd8f72$export$12d132b6e81066e4)()) {
        (0, $9d7bd82cb980c61d$export$ed9c825e502c46c8)();
        (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
    }
}
function $0568c3da8e64a362$var$parseSwitchStatement() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    (0, $9d7bd82cb980c61d$export$d5ddb48bead5eb08)();
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth++;
    var startTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
    // Don't bother validation; just go through any sequence of cases, defaults, and statements.
    while(!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error)if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._case) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._default)) {
        var isCase = (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._case);
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        if (isCase) (0, $9d7bd82cb980c61d$export$ed9c825e502c46c8)();
        (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon);
    } else $0568c3da8e64a362$export$68b986de0b252bc8(true);
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)(); // Closing brace
    var endTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopes.push(new (0, $f0b680e833c1be0d$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, false));
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth--;
}
function $0568c3da8e64a362$var$parseThrowStatement() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    (0, $9d7bd82cb980c61d$export$ed9c825e502c46c8)();
    (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
}
function $0568c3da8e64a362$var$parseCatchClauseParam() {
    (0, $43e5b81ee278119a$export$e1f90e6766854abd)(true);
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) (0, $f50510ec4ff63acc$export$e4623eb563192e0f)();
}
function $0568c3da8e64a362$var$parseTryStatement() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    $0568c3da8e64a362$export$4aed668c47d45036();
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._catch)) {
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        var catchBindingStartTokenIndex = null;
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) {
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth++;
            catchBindingStartTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL);
            $0568c3da8e64a362$var$parseCatchClauseParam();
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
        }
        $0568c3da8e64a362$export$4aed668c47d45036();
        if (catchBindingStartTokenIndex != null) {
            // We need a special scope for the catch binding which includes the binding itself and the
            // catch block.
            var endTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopes.push(new (0, $f0b680e833c1be0d$export$775b6bb06e53a214)(catchBindingStartTokenIndex, endTokenIndex, false));
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth--;
        }
    }
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._finally)) $0568c3da8e64a362$export$4aed668c47d45036();
}
function $0568c3da8e64a362$export$73f0614724a3919a(isBlockScope) {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    $0568c3da8e64a362$var$parseVar(false, isBlockScope);
    (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
}
function $0568c3da8e64a362$var$parseWhileStatement() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    (0, $9d7bd82cb980c61d$export$d5ddb48bead5eb08)();
    $0568c3da8e64a362$export$68b986de0b252bc8(false);
}
function $0568c3da8e64a362$var$parseEmptyStatement() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
}
function $0568c3da8e64a362$var$parseLabeledStatement() {
    $0568c3da8e64a362$export$68b986de0b252bc8(true);
}
/**
 * Parse a statement starting with an identifier of the given name. Subclasses match on the name
 * to handle statements like "declare".
 */ function $0568c3da8e64a362$var$parseIdentifierStatement(contextualKeyword) {
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) (0, $f50510ec4ff63acc$export$a642c15f5070c816)(contextualKeyword);
    else if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) (0, $37322500987f8c0d$export$3b5c354482eb1586)(contextualKeyword);
    else (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
}
function $0568c3da8e64a362$export$4aed668c47d45036() {
    var isFunctionScope = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, contextId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var startTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth++;
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
    if (contextId) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
    $0568c3da8e64a362$export$e5110a9b2ab486ee((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR);
    if (contextId) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
    var endTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopes.push(new (0, $f0b680e833c1be0d$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, isFunctionScope));
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth--;
}
function $0568c3da8e64a362$export$e5110a9b2ab486ee(end) {
    while(!(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)(end) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error)$0568c3da8e64a362$export$68b986de0b252bc8(true);
}
// Parse a regular `for` loop. The disambiguation code in
// `parseStatement` will already have parsed the init statement or
// expression.
function $0568c3da8e64a362$var$parseFor() {
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).semi);
    if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).semi)) (0, $9d7bd82cb980c61d$export$ed9c825e502c46c8)();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).semi);
    if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR)) (0, $9d7bd82cb980c61d$export$ed9c825e502c46c8)();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
    $0568c3da8e64a362$export$68b986de0b252bc8(false);
}
// Parse a `for`/`in` and `for`/`of` loop, which are almost
// same from parser's perspective.
function $0568c3da8e64a362$var$parseForIn(forAwait) {
    if (forAwait) (0, $40d5f3c610bd8f72$export$b8f8f7fffeb6fb36)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._of);
    else (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    (0, $9d7bd82cb980c61d$export$ed9c825e502c46c8)();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
    $0568c3da8e64a362$export$68b986de0b252bc8(false);
}
// Parse a list of variable declarations.
function $0568c3da8e64a362$var$parseVar(isFor, isBlockScope) {
    while(true){
        $0568c3da8e64a362$var$parseVarHead(isBlockScope);
        if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) {
            var eqIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1;
            (0, $9d7bd82cb980c61d$export$b97bbe8a7805284f)(isFor);
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[eqIndex].rhsEndIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
        }
        if (!(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) break;
    }
}
function $0568c3da8e64a362$var$parseVarHead(isBlockScope) {
    (0, $43e5b81ee278119a$export$e1f90e6766854abd)(isBlockScope);
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) (0, $f50510ec4ff63acc$export$41c8703baf1bbf07)();
    else if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) (0, $37322500987f8c0d$export$273b459834534d69)();
}
function $0568c3da8e64a362$export$ba3dc2bd7c065219(functionStart, isStatement) {
    var optionalId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).star)) (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    if (isStatement && !optionalId && !(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name) && !(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._yield)) (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
    var nameScopeStartTokenIndex = null;
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) {
        // Expression-style functions should limit their name's scope to the function body, so we make
        // a new function scope to enforce that.
        if (!isStatement) {
            nameScopeStartTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth++;
        }
        (0, $43e5b81ee278119a$export$7538cb03fa894c83)(false);
    }
    var startTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth++;
    $0568c3da8e64a362$export$dd0fc1c64275f2c4();
    (0, $9d7bd82cb980c61d$export$85b927192bdce5b9)(functionStart);
    var endTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    // In addition to the block scope of the function body, we need a separate function-style scope
    // that includes the params.
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopes.push(new (0, $f0b680e833c1be0d$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, true));
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth--;
    if (nameScopeStartTokenIndex !== null) {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopes.push(new (0, $f0b680e833c1be0d$export$775b6bb06e53a214)(nameScopeStartTokenIndex, endTokenIndex, true));
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth--;
    }
}
function $0568c3da8e64a362$export$dd0fc1c64275f2c4() {
    var allowModifiers = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, funcContextId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) (0, $f50510ec4ff63acc$export$ba34d58430377f94)();
    else if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) (0, $37322500987f8c0d$export$e3b9ccf4c3c69613)();
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL);
    if (funcContextId) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].contextId = funcContextId;
    (0, $43e5b81ee278119a$export$befa6d966a25698e)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR, false, false, allowModifiers, funcContextId);
    if (funcContextId) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].contextId = funcContextId;
}
function $0568c3da8e64a362$export$542081d93172af(isStatement) {
    var optionalId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    // Put a context ID on the class keyword, the open-brace, and the close-brace, so that later
    // code can easily navigate to meaningful points on the class.
    var contextId = (0, $875661fa68d3a4de$export$d0c215ddd78b3d24)();
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].isExpression = !isStatement;
    // Like with functions, we declare a special "name scope" from the start of the name to the end
    // of the class, but only with expression-style classes, to represent the fact that the name is
    // available to the body of the class but not an outer declaration.
    var nameScopeStartTokenIndex = null;
    if (!isStatement) {
        nameScopeStartTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth++;
    }
    $0568c3da8e64a362$var$parseClassId(isStatement, optionalId);
    $0568c3da8e64a362$var$parseClassSuper();
    var openBraceIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    $0568c3da8e64a362$var$parseClassBody(contextId);
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).error) return;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[openBraceIndex].contextId = contextId;
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
    if (nameScopeStartTokenIndex !== null) {
        var endTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopes.push(new (0, $f0b680e833c1be0d$export$775b6bb06e53a214)(nameScopeStartTokenIndex, endTokenIndex, false));
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).scopeDepth--;
    }
}
function $0568c3da8e64a362$var$isClassProperty() {
    return (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).semi) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bang) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon);
}
function $0568c3da8e64a362$var$isClassMethod() {
    return (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan);
}
function $0568c3da8e64a362$var$parseClassBody(classContextId) {
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
    while(!(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).semi)) continue;
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).at)) {
            $0568c3da8e64a362$var$parseDecorator();
            continue;
        }
        var memberStart = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).start;
        $0568c3da8e64a362$var$parseClassMember(memberStart, classContextId);
    }
}
function $0568c3da8e64a362$var$parseClassMember(memberStart, classContextId) {
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) (0, $f50510ec4ff63acc$export$77616e6d401f584a)([
        (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._declare,
        (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._public,
        (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._protected,
        (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._private,
        (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._override
    ]);
    var isStatic = false;
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name) && (0, $875661fa68d3a4de$export$ca000e230c0caa3e).contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._static) {
        (0, $9d7bd82cb980c61d$export$321543c11f6250ad)(); // eats 'static'
        if ($0568c3da8e64a362$var$isClassMethod()) {
            $0568c3da8e64a362$var$parseClassMethod(memberStart, /* isConstructor */ false);
            return;
        } else if ($0568c3da8e64a362$var$isClassProperty()) {
            $0568c3da8e64a362$export$8c8d5281ed4948bc();
            return;
        }
        // otherwise something static
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._static;
        isStatic = true;
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) {
            // This is a static block. Mark the word "static" with the class context ID for class element
            // detection and parse as a regular block.
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].contextId = classContextId;
            $0568c3da8e64a362$export$4aed668c47d45036();
            return;
        }
    }
    $0568c3da8e64a362$var$parseClassMemberWithIsStatic(memberStart, isStatic, classContextId);
}
function $0568c3da8e64a362$var$parseClassMemberWithIsStatic(memberStart, isStatic, classContextId) {
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) {
        if ((0, $f50510ec4ff63acc$export$9d02a6e20851f734)(isStatic)) return;
    }
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).star)) {
        // a generator
        $0568c3da8e64a362$export$763528f37ffee534(classContextId);
        $0568c3da8e64a362$var$parseClassMethod(memberStart, /* isConstructor */ false);
        return;
    }
    // Get the identifier name so we can tell if it's actually a keyword like "async", "get", or
    // "set".
    $0568c3da8e64a362$export$763528f37ffee534(classContextId);
    var isConstructor = false;
    var token = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1];
    // We allow "constructor" as either an identifier or a string.
    if (token.contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._constructor) isConstructor = true;
    $0568c3da8e64a362$export$be741144f2438eed();
    if ($0568c3da8e64a362$var$isClassMethod()) $0568c3da8e64a362$var$parseClassMethod(memberStart, isConstructor);
    else if ($0568c3da8e64a362$var$isClassProperty()) $0568c3da8e64a362$export$8c8d5281ed4948bc();
    else if (token.contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._async && !(0, $40d5f3c610bd8f72$export$12d132b6e81066e4)()) {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._async;
        // an async method
        var isGenerator = (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).star);
        if (isGenerator) (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        // The so-called parsed name would have been "async": get the real name.
        $0568c3da8e64a362$export$763528f37ffee534(classContextId);
        $0568c3da8e64a362$export$be741144f2438eed();
        $0568c3da8e64a362$var$parseClassMethod(memberStart, false);
    } else if ((token.contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._get || token.contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._set) && !((0, $40d5f3c610bd8f72$export$12d132b6e81066e4)() && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).star))) {
        if (token.contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._get) (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._get;
        else (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._set;
        // `get\n*` is an uninitialized property named 'get' followed by a generator.
        // a getter or setter
        // The so-called parsed name would have been "get/set": get the real name.
        $0568c3da8e64a362$export$763528f37ffee534(classContextId);
        $0568c3da8e64a362$var$parseClassMethod(memberStart, /* isConstructor */ false);
    } else if (token.contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._accessor && !(0, $40d5f3c610bd8f72$export$12d132b6e81066e4)()) {
        $0568c3da8e64a362$export$763528f37ffee534(classContextId);
        $0568c3da8e64a362$export$8c8d5281ed4948bc();
    } else if ((0, $40d5f3c610bd8f72$export$12d132b6e81066e4)()) // an uninitialized class property (due to ASI, since we don't otherwise recognize the next token)
    $0568c3da8e64a362$export$8c8d5281ed4948bc();
    else (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)();
}
function $0568c3da8e64a362$var$parseClassMethod(functionStart, isConstructor) {
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) (0, $f50510ec4ff63acc$export$827faab4e65d5897)();
    else if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) {
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) (0, $37322500987f8c0d$export$d1d23833c686097a)();
    }
    (0, $9d7bd82cb980c61d$export$9b0b57f9abc43790)(functionStart, isConstructor);
}
function $0568c3da8e64a362$export$763528f37ffee534(classContextId) {
    (0, $9d7bd82cb980c61d$export$ab65037f9c8fb3d3)(classContextId);
}
function $0568c3da8e64a362$export$be741144f2438eed() {
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) {
        var oldIsType = (0, $e2df986cc8bbbda9$export$218282073d8f0a8b)(0);
        (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).question);
        (0, $e2df986cc8bbbda9$export$89977347ddb984a8)(oldIsType);
    }
}
function $0568c3da8e64a362$export$8c8d5281ed4948bc() {
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) {
        (0, $e2df986cc8bbbda9$export$cb3e65614411a57c)((0, $30a0d13de21d779e$export$f435f793048e7a0f).bang);
        (0, $f50510ec4ff63acc$export$e4623eb563192e0f)();
    } else if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) {
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon)) (0, $37322500987f8c0d$export$6c833037db1a1e96)();
    }
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) {
        var equalsTokenIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        (0, $9d7bd82cb980c61d$export$b97bbe8a7805284f)();
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[equalsTokenIndex].rhsEndIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
    }
    (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
}
function $0568c3da8e64a362$var$parseClassId(isStatement) {
    var optionalId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if ((0, $875661fa68d3a4de$export$757c2735689d2de8) && (!isStatement || optionalId) && (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._implements)) return;
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) (0, $43e5b81ee278119a$export$7538cb03fa894c83)(true);
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) (0, $f50510ec4ff63acc$export$827faab4e65d5897)();
    else if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) {
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) (0, $37322500987f8c0d$export$d1d23833c686097a)();
    }
}
// Returns true if there was a superclass.
function $0568c3da8e64a362$var$parseClassSuper() {
    var hasSuper = false;
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._extends)) {
        (0, $9d7bd82cb980c61d$export$dba7f678c228244a)();
        hasSuper = true;
    } else hasSuper = false;
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) (0, $f50510ec4ff63acc$export$ea9d02c53bf69095)(hasSuper);
    else if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) (0, $37322500987f8c0d$export$131557296be11580)(hasSuper);
}
function $0568c3da8e64a362$export$3d6d7ef9486a61c3() {
    var exportIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1;
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) {
        if ((0, $f50510ec4ff63acc$export$6714566ca8db2f39)()) return;
    }
    // export * from '...'
    if ($0568c3da8e64a362$var$shouldParseExportStar()) $0568c3da8e64a362$var$parseExportStar();
    else if ($0568c3da8e64a362$var$isExportDefaultSpecifier()) {
        // export default from
        (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
        if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma) && (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)() === (0, $30a0d13de21d779e$export$f435f793048e7a0f).star) {
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).star);
            (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._as);
            (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
        } else $0568c3da8e64a362$var$parseExportSpecifiersMaybe();
        $0568c3da8e64a362$export$49b6f13e189abea3();
    } else if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._default)) // export default ...
    $0568c3da8e64a362$var$parseExportDefaultExpression();
    else if ($0568c3da8e64a362$var$shouldParseExportDeclaration()) $0568c3da8e64a362$var$parseExportDeclaration();
    else {
        // export { x, y as z } [from '...']
        $0568c3da8e64a362$export$909d3b50f7924101();
        $0568c3da8e64a362$export$49b6f13e189abea3();
    }
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[exportIndex].rhsEndIndex = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length;
}
function $0568c3da8e64a362$var$parseExportDefaultExpression() {
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) {
        if ((0, $f50510ec4ff63acc$export$95d54e02ae7a0197)()) return;
    }
    if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) {
        if ((0, $37322500987f8c0d$export$c6f815d203f26c4f)()) return;
    }
    var functionStart = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).start;
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._function)) $0568c3da8e64a362$export$ba3dc2bd7c065219(functionStart, true, true);
    else if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._async) && (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)() === (0, $30a0d13de21d779e$export$f435f793048e7a0f)._function) {
        // async function declaration
        (0, $40d5f3c610bd8f72$export$b8f8f7fffeb6fb36)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._async);
        (0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._function);
        $0568c3da8e64a362$export$ba3dc2bd7c065219(functionStart, true, true);
    } else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._class)) $0568c3da8e64a362$export$542081d93172af(true, true);
    else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).at)) {
        $0568c3da8e64a362$export$3f4d9519f687227a();
        $0568c3da8e64a362$export$542081d93172af(true, true);
    } else {
        (0, $9d7bd82cb980c61d$export$b97bbe8a7805284f)();
        (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
    }
}
function $0568c3da8e64a362$var$parseExportDeclaration() {
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) (0, $f50510ec4ff63acc$export$b29e6741ccf6da0a)();
    else if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) (0, $37322500987f8c0d$export$64e87490a40a8a82)();
    else $0568c3da8e64a362$export$68b986de0b252bc8(true);
}
function $0568c3da8e64a362$var$isExportDefaultSpecifier() {
    if ((0, $875661fa68d3a4de$export$757c2735689d2de8) && (0, $f50510ec4ff63acc$export$5df75dadb7a629b6)()) return false;
    else if ((0, $875661fa68d3a4de$export$92e334f8fe49aa94) && (0, $37322500987f8c0d$export$8a047f67d2009628)()) return false;
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) return (0, $875661fa68d3a4de$export$ca000e230c0caa3e).contextualKeyword !== (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._async;
    if (!(0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._default)) return false;
    var _next = (0, $e2df986cc8bbbda9$export$1678d89ce52f4a6)();
    var lookahead = (0, $e2df986cc8bbbda9$export$ef1b94c514fc060a)();
    var hasFrom = lookahead.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).name && lookahead.contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._from;
    if (lookahead.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).comma) return true;
    // lookahead again when `export default from` is seen
    if (hasFrom) {
        var nextAfterFrom = (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt((0, $e2df986cc8bbbda9$export$b8d8ba48247ea123)(_next + 4));
        return nextAfterFrom === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).quotationMark || nextAfterFrom === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).apostrophe;
    }
    return false;
}
function $0568c3da8e64a362$var$parseExportSpecifiersMaybe() {
    if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) $0568c3da8e64a362$export$909d3b50f7924101();
}
function $0568c3da8e64a362$export$49b6f13e189abea3() {
    if ((0, $40d5f3c610bd8f72$export$b8f8f7fffeb6fb36)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._from)) {
        (0, $9d7bd82cb980c61d$export$fa61731cf32bc243)();
        $0568c3da8e64a362$var$maybeParseImportAttributes();
    }
    (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
}
function $0568c3da8e64a362$var$shouldParseExportStar() {
    if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) return (0, $37322500987f8c0d$export$563bbc61583bd08)();
    else return (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).star);
}
function $0568c3da8e64a362$var$parseExportStar() {
    if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) (0, $37322500987f8c0d$export$dc2ba80ebf42d8d6)();
    else $0568c3da8e64a362$export$18fb3cb64b956ba0();
}
function $0568c3da8e64a362$export$18fb3cb64b956ba0() {
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).star);
    if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._as)) $0568c3da8e64a362$var$parseExportNamespace();
    else $0568c3da8e64a362$export$49b6f13e189abea3();
}
function $0568c3da8e64a362$var$parseExportNamespace() {
    (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $30a0d13de21d779e$export$f435f793048e7a0f)._as;
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    $0568c3da8e64a362$var$parseExportSpecifiersMaybe();
    $0568c3da8e64a362$export$49b6f13e189abea3();
}
function $0568c3da8e64a362$var$shouldParseExportDeclaration() {
    return (0, $875661fa68d3a4de$export$757c2735689d2de8) && (0, $f50510ec4ff63acc$export$5df75dadb7a629b6)() || (0, $875661fa68d3a4de$export$92e334f8fe49aa94) && (0, $37322500987f8c0d$export$74061750bc0f2203)() || (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type === (0, $30a0d13de21d779e$export$f435f793048e7a0f)._var || (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type === (0, $30a0d13de21d779e$export$f435f793048e7a0f)._const || (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type === (0, $30a0d13de21d779e$export$f435f793048e7a0f)._let || (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type === (0, $30a0d13de21d779e$export$f435f793048e7a0f)._function || (0, $875661fa68d3a4de$export$ca000e230c0caa3e).type === (0, $30a0d13de21d779e$export$f435f793048e7a0f)._class || (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._async) || (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).at);
}
function $0568c3da8e64a362$export$909d3b50f7924101() {
    var first = true;
    // export { x, y as z } [from '...']
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
    while(!(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
            if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) break;
        }
        $0568c3da8e64a362$var$parseExportSpecifier();
    }
}
function $0568c3da8e64a362$var$parseExportSpecifier() {
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) {
        (0, $f50510ec4ff63acc$export$7994f3b86b6c7d1e)();
        return;
    }
    (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
    (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ExportAccess;
    if ((0, $40d5f3c610bd8f72$export$b8f8f7fffeb6fb36)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._as)) (0, $9d7bd82cb980c61d$export$321543c11f6250ad)();
}
/**
 * Starting at the `module` token in an import, determine if it was truly an
 * import reflection token or just looks like one.
 *
 * Returns true for:
 * import module foo from "foo";
 * import module from from "foo";
 *
 * Returns false for:
 * import module from "foo";
 * import module, {bar} from "foo";
 */ function $0568c3da8e64a362$var$isImportReflection() {
    var snapshot = (0, $875661fa68d3a4de$export$ca000e230c0caa3e).snapshot();
    (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._module);
    if ((0, $40d5f3c610bd8f72$export$b8f8f7fffeb6fb36)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._from)) {
        if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._from)) {
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            return true;
        } else {
            (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            return false;
        }
    } else if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return false;
    } else {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return true;
    }
}
/**
 * Eat the "module" token from the import reflection proposal.
 * https://github.com/tc39/proposal-import-reflection
 */ function $0568c3da8e64a362$var$parseMaybeImportReflection() {
    // isImportReflection does snapshot/restore, so only run it if we see the word
    // "module".
    if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._module) && $0568c3da8e64a362$var$isImportReflection()) (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
}
function $0568c3da8e64a362$export$532df1d0416e9789() {
    if ((0, $875661fa68d3a4de$export$757c2735689d2de8) && (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name) && (0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)() === (0, $30a0d13de21d779e$export$f435f793048e7a0f).eq) {
        (0, $f50510ec4ff63acc$export$bb14276cd4f56f44)();
        return;
    }
    if ((0, $875661fa68d3a4de$export$757c2735689d2de8) && (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type)) {
        var lookahead = (0, $e2df986cc8bbbda9$export$ef1b94c514fc060a)();
        if (lookahead.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).name && lookahead.contextualKeyword !== (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._from) {
            // One of these `import type` cases:
            // import type T = require('T');
            // import type A from 'A';
            (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type);
            if ((0, $e2df986cc8bbbda9$export$d2a09c60d66edd78)() === (0, $30a0d13de21d779e$export$f435f793048e7a0f).eq) {
                (0, $f50510ec4ff63acc$export$bb14276cd4f56f44)();
                return;
            }
        // If this is an `import type...from` statement, then we already ate the
        // type token, so proceed to the regular import parser.
        } else if (lookahead.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).star || lookahead.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL) // One of these `import type` cases, in which case we can eat the type token
        // and proceed as normal:
        // import type * as A from 'A';
        // import type {a} from 'A';
        (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type);
    // Otherwise, we are importing the name "type".
    }
    // import '...'
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).string)) (0, $9d7bd82cb980c61d$export$fa61731cf32bc243)();
    else {
        $0568c3da8e64a362$var$parseMaybeImportReflection();
        $0568c3da8e64a362$var$parseImportSpecifiers();
        (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._from);
        (0, $9d7bd82cb980c61d$export$fa61731cf32bc243)();
    }
    $0568c3da8e64a362$var$maybeParseImportAttributes();
    (0, $40d5f3c610bd8f72$export$62fa27d385e555f3)();
}
// eslint-disable-next-line no-unused-vars
function $0568c3da8e64a362$var$shouldParseDefaultImport() {
    return (0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).name);
}
function $0568c3da8e64a362$var$parseImportSpecifierLocal() {
    (0, $43e5b81ee278119a$export$cba413304e86fc0d)();
}
// Parses a comma-separated list of module imports.
function $0568c3da8e64a362$var$parseImportSpecifiers() {
    if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) (0, $37322500987f8c0d$export$2ca2c81ecd0ec221)();
    var first = true;
    if ($0568c3da8e64a362$var$shouldParseDefaultImport()) {
        // import defaultObj, { x, y as z } from '...'
        $0568c3da8e64a362$var$parseImportSpecifierLocal();
        if (!(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) return;
    }
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f).star)) {
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        (0, $40d5f3c610bd8f72$export$b8ead11dfed96f19)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._as);
        $0568c3da8e64a362$var$parseImportSpecifierLocal();
        return;
    }
    (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
    while(!(0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR) && !(0, $875661fa68d3a4de$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            // Detect an attempt to deep destructure
            if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).colon)) (0, $40d5f3c610bd8f72$export$4c195bc1a97b6f7f)("ES2015 named imports do not destructure. Use another statement for destructuring after the import.");
            (0, $40d5f3c610bd8f72$export$3570f33b1a1f3329)((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma);
            if ((0, $e2df986cc8bbbda9$export$3106cdec37e36f77)((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) break;
        }
        $0568c3da8e64a362$var$parseImportSpecifier();
    }
}
function $0568c3da8e64a362$var$parseImportSpecifier() {
    if (0, $875661fa68d3a4de$export$757c2735689d2de8) {
        (0, $f50510ec4ff63acc$export$718ece2f88417ffd)();
        return;
    }
    if (0, $875661fa68d3a4de$export$92e334f8fe49aa94) {
        (0, $37322500987f8c0d$export$217da275bf556fe8)();
        return;
    }
    (0, $43e5b81ee278119a$export$cba413304e86fc0d)();
    if ((0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._as)) {
        (0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens[(0, $875661fa68d3a4de$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ImportAccess;
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        (0, $43e5b81ee278119a$export$cba413304e86fc0d)();
    }
}
/**
 * Parse import attributes like `with {type: "json"}`, or the legacy form
 * `assert {type: "json"}`.
 *
 * Import attributes technically have their own syntax, but are always parseable
 * as a plain JS object, so just do that for simplicity.
 */ function $0568c3da8e64a362$var$maybeParseImportAttributes() {
    if ((0, $e2df986cc8bbbda9$export$4659b591c19bdf3d)((0, $30a0d13de21d779e$export$f435f793048e7a0f)._with) || (0, $40d5f3c610bd8f72$export$d382681f238736f1)((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._assert) && !(0, $40d5f3c610bd8f72$export$942fa35f3a7c108c)()) {
        (0, $e2df986cc8bbbda9$export$48cfd1e771a65c4f)();
        (0, $9d7bd82cb980c61d$export$908e61e44ae774e)(false, false);
    }
}


function $df17bf6bab09f84f$export$f1c553d4f1a2351() {
    // If enabled, skip leading hashbang line.
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).pos === 0 && (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt(0) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).numberSign && (0, $875661fa68d3a4de$export$b7e3ae3d7c15e42e).charCodeAt(1) === (0, $270fc0c37efdc8f8$export$dbe39bbf2ade60d5).exclamationMark) (0, $e2df986cc8bbbda9$export$37e131e7c1112aff)(2);
    (0, $e2df986cc8bbbda9$export$be17f8ab6696df13)();
    return (0, $0568c3da8e64a362$export$cb09d803724ddba2)();
}


var $8404178774830e3d$export$b6afa8811b7e644e = function File(tokens, scopes) {
    "use strict";
    (0, $173N4._)(this, File);
    this.tokens = tokens;
    this.scopes = scopes;
};
function $8404178774830e3d$export$98e6a39c04603d36(input, isJSXEnabled, isTypeScriptEnabled, isFlowEnabled) {
    if (isFlowEnabled && isTypeScriptEnabled) throw new Error("Cannot combine flow and typescript plugins.");
    (0, $875661fa68d3a4de$export$84bb9899435eeb61)(input, isJSXEnabled, isTypeScriptEnabled, isFlowEnabled);
    var result = (0, $df17bf6bab09f84f$export$f1c553d4f1a2351)();
    if ((0, $875661fa68d3a4de$export$ca000e230c0caa3e).error) throw (0, $875661fa68d3a4de$export$2ca6ff5cad32970a)((0, $875661fa68d3a4de$export$ca000e230c0caa3e).error);
    return result;
}



var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");


function $c86c0ea1cbd9e8f5$export$2e2bcd8739ae039(tokens) {
    var index = tokens.currentIndex();
    var depth = 0;
    var startToken = tokens.currentToken();
    do {
        var token = tokens.tokens[index];
        if (token.isOptionalChainStart) depth++;
        if (token.isOptionalChainEnd) depth--;
        depth += token.numNullishCoalesceStarts;
        depth -= token.numNullishCoalesceEnds;
        if (token.contextualKeyword === (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._await && token.identifierRole == null && token.scopeDepth === startToken.scopeDepth) return true;
        index += 1;
    }while (depth > 0 && index < tokens.tokens.length);
    return false;
}


var $373eec7d62cfbd05$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function TokenProcessor(code, tokens, isFlowEnabled, disableESTransforms, helperManager) {
        (0, $173N4._)(this, TokenProcessor);
        this.code = code;
        this.tokens = tokens;
        this.isFlowEnabled = isFlowEnabled;
        this.disableESTransforms = disableESTransforms;
        this.helperManager = helperManager;
        TokenProcessor.prototype.__init.call(this);
        TokenProcessor.prototype.__init2.call(this);
        TokenProcessor.prototype.__init3.call(this);
    }
    (0, $cFHGC._)(TokenProcessor, [
        {
            key: "__init",
            value: function __init() {
                this.resultCode = "";
            }
        },
        {
            // Array mapping input token index to optional string index position in the
            // output code.
            key: "__init2",
            value: function __init2() {
                this.resultMappings = new Array(this.tokens.length);
            }
        },
        {
            key: "__init3",
            value: function __init3() {
                this.tokenIndex = 0;
            }
        },
        {
            /**
   * Snapshot the token state in a way that can be restored later, useful for
   * things like lookahead.
   *
   * resultMappings do not need to be copied since in all use cases, they will
   * be overwritten anyway after restore.
   */ key: "snapshot",
            value: function snapshot() {
                return {
                    resultCode: this.resultCode,
                    tokenIndex: this.tokenIndex
                };
            }
        },
        {
            key: "restoreToSnapshot",
            value: function restoreToSnapshot(snapshot) {
                this.resultCode = snapshot.resultCode;
                this.tokenIndex = snapshot.tokenIndex;
            }
        },
        {
            /**
   * Remove and return the code generated since the snapshot, leaving the
   * current token position in-place. Unlike most TokenProcessor operations,
   * this operation can result in input/output line number mismatches because
   * the removed code may contain newlines, so this operation should be used
   * sparingly.
   */ key: "dangerouslyGetAndRemoveCodeSinceSnapshot",
            value: function dangerouslyGetAndRemoveCodeSinceSnapshot(snapshot) {
                var result = this.resultCode.slice(snapshot.resultCode.length);
                this.resultCode = snapshot.resultCode;
                return result;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.resultCode = "";
                this.resultMappings = new Array(this.tokens.length);
                this.tokenIndex = 0;
            }
        },
        {
            key: "matchesContextualAtIndex",
            value: function matchesContextualAtIndex(index, contextualKeyword) {
                return this.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) && this.tokens[index].contextualKeyword === contextualKeyword;
            }
        },
        {
            key: "identifierNameAtIndex",
            value: function identifierNameAtIndex(index) {
                // TODO: We need to process escapes since technically you can have unicode escapes in variable
                // names.
                return this.identifierNameForToken(this.tokens[index]);
            }
        },
        {
            key: "identifierNameAtRelativeIndex",
            value: function identifierNameAtRelativeIndex(relativeIndex) {
                return this.identifierNameForToken(this.tokenAtRelativeIndex(relativeIndex));
            }
        },
        {
            key: "identifierName",
            value: function identifierName() {
                return this.identifierNameForToken(this.currentToken());
            }
        },
        {
            key: "identifierNameForToken",
            value: function identifierNameForToken(token) {
                return this.code.slice(token.start, token.end);
            }
        },
        {
            key: "rawCodeForToken",
            value: function rawCodeForToken(token) {
                return this.code.slice(token.start, token.end);
            }
        },
        {
            key: "stringValueAtIndex",
            value: function stringValueAtIndex(index) {
                return this.stringValueForToken(this.tokens[index]);
            }
        },
        {
            key: "stringValue",
            value: function stringValue() {
                return this.stringValueForToken(this.currentToken());
            }
        },
        {
            key: "stringValueForToken",
            value: function stringValueForToken(token) {
                // This is used to identify when two imports are the same and to resolve TypeScript enum keys.
                // Ideally we'd process escapes within the strings, but for now we pretty much take the raw
                // code.
                return this.code.slice(token.start + 1, token.end - 1);
            }
        },
        {
            key: "matches1AtIndex",
            value: function matches1AtIndex(index, t1) {
                return this.tokens[index].type === t1;
            }
        },
        {
            key: "matches2AtIndex",
            value: function matches2AtIndex(index, t1, t2) {
                return this.tokens[index].type === t1 && this.tokens[index + 1].type === t2;
            }
        },
        {
            key: "matches3AtIndex",
            value: function matches3AtIndex(index, t1, t2, t3) {
                return this.tokens[index].type === t1 && this.tokens[index + 1].type === t2 && this.tokens[index + 2].type === t3;
            }
        },
        {
            key: "matches1",
            value: function matches1(t1) {
                return this.tokens[this.tokenIndex].type === t1;
            }
        },
        {
            key: "matches2",
            value: function matches2(t1, t2) {
                return this.tokens[this.tokenIndex].type === t1 && this.tokens[this.tokenIndex + 1].type === t2;
            }
        },
        {
            key: "matches3",
            value: function matches3(t1, t2, t3) {
                return this.tokens[this.tokenIndex].type === t1 && this.tokens[this.tokenIndex + 1].type === t2 && this.tokens[this.tokenIndex + 2].type === t3;
            }
        },
        {
            key: "matches4",
            value: function matches4(t1, t2, t3, t4) {
                return this.tokens[this.tokenIndex].type === t1 && this.tokens[this.tokenIndex + 1].type === t2 && this.tokens[this.tokenIndex + 2].type === t3 && this.tokens[this.tokenIndex + 3].type === t4;
            }
        },
        {
            key: "matches5",
            value: function matches5(t1, t2, t3, t4, t5) {
                return this.tokens[this.tokenIndex].type === t1 && this.tokens[this.tokenIndex + 1].type === t2 && this.tokens[this.tokenIndex + 2].type === t3 && this.tokens[this.tokenIndex + 3].type === t4 && this.tokens[this.tokenIndex + 4].type === t5;
            }
        },
        {
            key: "matchesContextual",
            value: function matchesContextual(contextualKeyword) {
                return this.matchesContextualAtIndex(this.tokenIndex, contextualKeyword);
            }
        },
        {
            key: "matchesContextIdAndLabel",
            value: function matchesContextIdAndLabel(type, contextId) {
                return this.matches1(type) && this.currentToken().contextId === contextId;
            }
        },
        {
            key: "previousWhitespaceAndComments",
            value: function previousWhitespaceAndComments() {
                var whitespaceAndComments = this.code.slice(this.tokenIndex > 0 ? this.tokens[this.tokenIndex - 1].end : 0, this.tokenIndex < this.tokens.length ? this.tokens[this.tokenIndex].start : this.code.length);
                if (this.isFlowEnabled) whitespaceAndComments = whitespaceAndComments.replace(/@flow/g, "");
                return whitespaceAndComments;
            }
        },
        {
            key: "replaceToken",
            value: function replaceToken(newCode) {
                this.resultCode += this.previousWhitespaceAndComments();
                this.appendTokenPrefix();
                this.resultMappings[this.tokenIndex] = this.resultCode.length;
                this.resultCode += newCode;
                this.appendTokenSuffix();
                this.tokenIndex++;
            }
        },
        {
            key: "replaceTokenTrimmingLeftWhitespace",
            value: function replaceTokenTrimmingLeftWhitespace(newCode) {
                this.resultCode += this.previousWhitespaceAndComments().replace(/[^\r\n]/g, "");
                this.appendTokenPrefix();
                this.resultMappings[this.tokenIndex] = this.resultCode.length;
                this.resultCode += newCode;
                this.appendTokenSuffix();
                this.tokenIndex++;
            }
        },
        {
            key: "removeInitialToken",
            value: function removeInitialToken() {
                this.replaceToken("");
            }
        },
        {
            key: "removeToken",
            value: function removeToken() {
                this.replaceTokenTrimmingLeftWhitespace("");
            }
        },
        {
            /**
   * Remove all code until the next }, accounting for balanced braces.
   */ key: "removeBalancedCode",
            value: function removeBalancedCode() {
                var braceDepth = 0;
                while(!this.isAtEnd()){
                    if (this.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) braceDepth++;
                    else if (this.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) {
                        if (braceDepth === 0) return;
                        braceDepth--;
                    }
                    this.removeToken();
                }
            }
        },
        {
            key: "copyExpectedToken",
            value: function copyExpectedToken(tokenType) {
                if (this.tokens[this.tokenIndex].type !== tokenType) throw new Error("Expected token ".concat(tokenType));
                this.copyToken();
            }
        },
        {
            key: "copyToken",
            value: function copyToken() {
                this.resultCode += this.previousWhitespaceAndComments();
                this.appendTokenPrefix();
                this.resultMappings[this.tokenIndex] = this.resultCode.length;
                this.resultCode += this.code.slice(this.tokens[this.tokenIndex].start, this.tokens[this.tokenIndex].end);
                this.appendTokenSuffix();
                this.tokenIndex++;
            }
        },
        {
            key: "copyTokenWithPrefix",
            value: function copyTokenWithPrefix(prefix) {
                this.resultCode += this.previousWhitespaceAndComments();
                this.appendTokenPrefix();
                this.resultCode += prefix;
                this.resultMappings[this.tokenIndex] = this.resultCode.length;
                this.resultCode += this.code.slice(this.tokens[this.tokenIndex].start, this.tokens[this.tokenIndex].end);
                this.appendTokenSuffix();
                this.tokenIndex++;
            }
        },
        {
            key: "appendTokenPrefix",
            value: function appendTokenPrefix() {
                var token = this.currentToken();
                if (token.numNullishCoalesceStarts || token.isOptionalChainStart) token.isAsyncOperation = (0, $c86c0ea1cbd9e8f5$export$2e2bcd8739ae039)(this);
                if (this.disableESTransforms) return;
                if (token.numNullishCoalesceStarts) for(var i = 0; i < token.numNullishCoalesceStarts; i++){
                    if (token.isAsyncOperation) {
                        this.resultCode += "await ";
                        this.resultCode += this.helperManager.getHelperName("asyncNullishCoalesce");
                    } else this.resultCode += this.helperManager.getHelperName("nullishCoalesce");
                    this.resultCode += "(";
                }
                if (token.isOptionalChainStart) {
                    if (token.isAsyncOperation) this.resultCode += "await ";
                    if (this.tokenIndex > 0 && this.tokenAtRelativeIndex(-1).type === (0, $30a0d13de21d779e$export$f435f793048e7a0f)._delete) {
                        if (token.isAsyncOperation) this.resultCode += this.helperManager.getHelperName("asyncOptionalChainDelete");
                        else this.resultCode += this.helperManager.getHelperName("optionalChainDelete");
                    } else if (token.isAsyncOperation) this.resultCode += this.helperManager.getHelperName("asyncOptionalChain");
                    else this.resultCode += this.helperManager.getHelperName("optionalChain");
                    this.resultCode += "([";
                }
            }
        },
        {
            key: "appendTokenSuffix",
            value: function appendTokenSuffix() {
                var token = this.currentToken();
                if (token.isOptionalChainEnd && !this.disableESTransforms) this.resultCode += "])";
                if (token.numNullishCoalesceEnds && !this.disableESTransforms) for(var i = 0; i < token.numNullishCoalesceEnds; i++)this.resultCode += "))";
            }
        },
        {
            key: "appendCode",
            value: function appendCode(code) {
                this.resultCode += code;
            }
        },
        {
            key: "currentToken",
            value: function currentToken() {
                return this.tokens[this.tokenIndex];
            }
        },
        {
            key: "currentTokenCode",
            value: function currentTokenCode() {
                var token = this.currentToken();
                return this.code.slice(token.start, token.end);
            }
        },
        {
            key: "tokenAtRelativeIndex",
            value: function tokenAtRelativeIndex(relativeIndex) {
                return this.tokens[this.tokenIndex + relativeIndex];
            }
        },
        {
            key: "currentIndex",
            value: function currentIndex() {
                return this.tokenIndex;
            }
        },
        {
            /**
   * Move to the next token. Only suitable in preprocessing steps. When
   * generating new code, you should use copyToken or removeToken.
   */ key: "nextToken",
            value: function nextToken() {
                if (this.tokenIndex === this.tokens.length) throw new Error("Unexpectedly reached end of input.");
                this.tokenIndex++;
            }
        },
        {
            key: "previousToken",
            value: function previousToken() {
                this.tokenIndex--;
            }
        },
        {
            key: "finish",
            value: function finish() {
                if (this.tokenIndex !== this.tokens.length) throw new Error("Tried to finish processing tokens before reaching the end.");
                this.resultCode += this.previousWhitespaceAndComments();
                return {
                    code: this.resultCode,
                    mappings: this.resultMappings
                };
            }
        },
        {
            key: "isAtEnd",
            value: function isAtEnd() {
                return this.tokenIndex === this.tokens.length;
            }
        }
    ]);
    return TokenProcessor;
}();



var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $aUGqu = parcelRequire("aUGqu");




function $5cc1ddf63d070d97$export$2e2bcd8739ae039(rootTransformer, tokens, nameManager, disableESTransforms) {
    var snapshot = tokens.snapshot();
    var headerInfo = $5cc1ddf63d070d97$var$processClassHeader(tokens);
    var constructorInitializerStatements = [];
    var instanceInitializerNames = [];
    var staticInitializerNames = [];
    var constructorInsertPos = null;
    var fields = [];
    var rangesToRemove = [];
    var classContextId = tokens.currentToken().contextId;
    if (classContextId == null) throw new Error("Expected non-null class context ID on class open-brace.");
    tokens.nextToken();
    while(!tokens.matchesContextIdAndLabel((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR, classContextId)){
        var ref;
        if (tokens.matchesContextual((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._constructor) && !tokens.currentToken().isType) ref = $5cc1ddf63d070d97$var$processConstructor(tokens), constructorInitializerStatements = ref.constructorInitializerStatements, constructorInsertPos = ref.constructorInsertPos, ref;
        else if (tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).semi)) {
            if (!disableESTransforms) rangesToRemove.push({
                start: tokens.currentIndex(),
                end: tokens.currentIndex() + 1
            });
            tokens.nextToken();
        } else if (tokens.currentToken().isType) tokens.nextToken();
        else {
            // Either a method or a field. Skip to the identifier part.
            var statementStartIndex = tokens.currentIndex();
            var isStatic = false;
            var isESPrivate = false;
            var isDeclareOrAbstract = false;
            while($5cc1ddf63d070d97$var$isAccessModifier(tokens.currentToken())){
                if (tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._static)) isStatic = true;
                if (tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).hash)) isESPrivate = true;
                if (tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._declare) || tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._abstract)) isDeclareOrAbstract = true;
                tokens.nextToken();
            }
            if (isStatic && tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) {
                // This is a static block, so don't process it in any special way.
                $5cc1ddf63d070d97$var$skipToNextClassElement(tokens, classContextId);
                continue;
            }
            if (isESPrivate) {
                // Sucrase doesn't attempt to transpile private fields; just leave them as-is.
                $5cc1ddf63d070d97$var$skipToNextClassElement(tokens, classContextId);
                continue;
            }
            if (tokens.matchesContextual((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._constructor) && !tokens.currentToken().isType) {
                var ref1;
                ref1 = $5cc1ddf63d070d97$var$processConstructor(tokens), constructorInitializerStatements = ref1.constructorInitializerStatements, constructorInsertPos = ref1.constructorInsertPos, ref1;
                continue;
            }
            var nameStartIndex = tokens.currentIndex();
            $5cc1ddf63d070d97$var$skipFieldName(tokens);
            if (tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan) || tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) {
                // This is a method, so nothing to process.
                $5cc1ddf63d070d97$var$skipToNextClassElement(tokens, classContextId);
                continue;
            }
            // There might be a type annotation that we need to skip.
            while(tokens.currentToken().isType)tokens.nextToken();
            if (tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) {
                var equalsIndex = tokens.currentIndex();
                // This is an initializer, so we need to wrap in an initializer method.
                var valueEnd = tokens.currentToken().rhsEndIndex;
                if (valueEnd == null) throw new Error("Expected rhsEndIndex on class field assignment.");
                tokens.nextToken();
                while(tokens.currentIndex() < valueEnd)rootTransformer.processToken();
                var initializerName = void 0;
                if (isStatic) {
                    initializerName = nameManager.claimFreeName("__initStatic");
                    staticInitializerNames.push(initializerName);
                } else {
                    initializerName = nameManager.claimFreeName("__init");
                    instanceInitializerNames.push(initializerName);
                }
                // Fields start at the name, so `static x = 1;` has a field range of `x = 1;`.
                fields.push({
                    initializerName: initializerName,
                    equalsIndex: equalsIndex,
                    start: nameStartIndex,
                    end: tokens.currentIndex()
                });
            } else if (!disableESTransforms || isDeclareOrAbstract) // This is a regular field declaration, like `x;`. With the class transform enabled, we just
            // remove the line so that no output is produced. With the class transform disabled, we
            // usually want to preserve the declaration (but still strip types), but if the `declare`
            // or `abstract` keyword is specified, we should remove the line to avoid initializing the
            // value to undefined.
            rangesToRemove.push({
                start: statementStartIndex,
                end: tokens.currentIndex()
            });
        }
    }
    tokens.restoreToSnapshot(snapshot);
    if (disableESTransforms) // With ES transforms disabled, we don't want to transform regular class
    // field declarations, and we don't need to do any additional tricks to
    // reference the constructor for static init, but we still need to transform
    // TypeScript field initializers defined as constructor parameters and we
    // still need to remove `declare` fields. For now, we run the same code
    // path but omit any field information, as if the class had no field
    // declarations. In the future, when we fully drop the class fields
    // transform, we can simplify this code significantly.
    return {
        headerInfo: headerInfo,
        constructorInitializerStatements: constructorInitializerStatements,
        instanceInitializerNames: [],
        staticInitializerNames: [],
        constructorInsertPos: constructorInsertPos,
        fields: [],
        rangesToRemove: rangesToRemove
    };
    else return {
        headerInfo: headerInfo,
        constructorInitializerStatements: constructorInitializerStatements,
        instanceInitializerNames: instanceInitializerNames,
        staticInitializerNames: staticInitializerNames,
        constructorInsertPos: constructorInsertPos,
        fields: fields,
        rangesToRemove: rangesToRemove
    };
}
/**
 * Move the token processor to the next method/field in the class.
 *
 * To do that, we seek forward to the next start of a class name (either an open
 * bracket or an identifier, or the closing curly brace), then seek backward to
 * include any access modifiers.
 */ function $5cc1ddf63d070d97$var$skipToNextClassElement(tokens, classContextId) {
    tokens.nextToken();
    while(tokens.currentToken().contextId !== classContextId)tokens.nextToken();
    while($5cc1ddf63d070d97$var$isAccessModifier(tokens.tokenAtRelativeIndex(-1)))tokens.previousToken();
}
function $5cc1ddf63d070d97$var$processClassHeader(tokens) {
    var classToken = tokens.currentToken();
    var contextId = classToken.contextId;
    if (contextId == null) throw new Error("Expected context ID on class token.");
    var isExpression = classToken.isExpression;
    if (isExpression == null) throw new Error("Expected isExpression on class token.");
    var className = null;
    var hasSuperclass = false;
    tokens.nextToken();
    if (tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) className = tokens.identifierName();
    while(!tokens.matchesContextIdAndLabel((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL, contextId)){
        // If this has a superclass, there will always be an `extends` token. If it doesn't have a
        // superclass, only type parameters and `implements` clauses can show up here, all of which
        // consist only of type tokens. A declaration like `class A<B extends C> {` should *not* count
        // as having a superclass.
        if (tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._extends) && !tokens.currentToken().isType) hasSuperclass = true;
        tokens.nextToken();
    }
    return {
        isExpression: isExpression,
        className: className,
        hasSuperclass: hasSuperclass
    };
}
/**
 * Extract useful information out of a constructor, starting at the "constructor" name.
 */ function $5cc1ddf63d070d97$var$processConstructor(tokens) {
    var constructorInitializerStatements = [];
    tokens.nextToken();
    var constructorContextId = tokens.currentToken().contextId;
    if (constructorContextId == null) throw new Error("Expected context ID on open-paren starting constructor params.");
    // Advance through parameters looking for access modifiers.
    while(!tokens.matchesContextIdAndLabel((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR, constructorContextId))if (tokens.currentToken().contextId === constructorContextId) {
        // Current token is an open paren or comma just before a param, so check
        // that param for access modifiers.
        tokens.nextToken();
        if ($5cc1ddf63d070d97$var$isAccessModifier(tokens.currentToken())) {
            tokens.nextToken();
            while($5cc1ddf63d070d97$var$isAccessModifier(tokens.currentToken()))tokens.nextToken();
            var token = tokens.currentToken();
            if (token.type !== (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) throw new Error("Expected identifier after access modifiers in constructor arg.");
            var name = tokens.identifierNameForToken(token);
            constructorInitializerStatements.push("this.".concat(name, " = ").concat(name));
        }
    } else tokens.nextToken();
    // )
    tokens.nextToken();
    // Constructor type annotations are invalid, but skip them anyway since
    // they're easy to skip.
    while(tokens.currentToken().isType)tokens.nextToken();
    var constructorInsertPos = tokens.currentIndex();
    // Advance through body looking for a super call.
    var foundSuperCall = false;
    while(!tokens.matchesContextIdAndLabel((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR, constructorContextId)){
        if (!foundSuperCall && tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._super, (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) {
            tokens.nextToken();
            var superCallContextId = tokens.currentToken().contextId;
            if (superCallContextId == null) throw new Error("Expected a context ID on the super call");
            while(!tokens.matchesContextIdAndLabel((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR, superCallContextId))tokens.nextToken();
            constructorInsertPos = tokens.currentIndex();
            foundSuperCall = true;
        }
        tokens.nextToken();
    }
    // }
    tokens.nextToken();
    return {
        constructorInitializerStatements: constructorInitializerStatements,
        constructorInsertPos: constructorInsertPos
    };
}
/**
 * Determine if this is any token that can go before the name in a method/field.
 */ function $5cc1ddf63d070d97$var$isAccessModifier(token) {
    return [
        (0, $30a0d13de21d779e$export$f435f793048e7a0f)._async,
        (0, $30a0d13de21d779e$export$f435f793048e7a0f)._get,
        (0, $30a0d13de21d779e$export$f435f793048e7a0f)._set,
        (0, $30a0d13de21d779e$export$f435f793048e7a0f).plus,
        (0, $30a0d13de21d779e$export$f435f793048e7a0f).minus,
        (0, $30a0d13de21d779e$export$f435f793048e7a0f)._readonly,
        (0, $30a0d13de21d779e$export$f435f793048e7a0f)._static,
        (0, $30a0d13de21d779e$export$f435f793048e7a0f)._public,
        (0, $30a0d13de21d779e$export$f435f793048e7a0f)._private,
        (0, $30a0d13de21d779e$export$f435f793048e7a0f)._protected,
        (0, $30a0d13de21d779e$export$f435f793048e7a0f)._override,
        (0, $30a0d13de21d779e$export$f435f793048e7a0f)._abstract,
        (0, $30a0d13de21d779e$export$f435f793048e7a0f).star,
        (0, $30a0d13de21d779e$export$f435f793048e7a0f)._declare,
        (0, $30a0d13de21d779e$export$f435f793048e7a0f).hash
    ].includes(token.type);
}
/**
 * The next token or set of tokens is either an identifier or an expression in square brackets, for
 * a method or field name.
 */ function $5cc1ddf63d070d97$var$skipFieldName(tokens) {
    if (tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL)) {
        var startToken = tokens.currentToken();
        var classContextId = startToken.contextId;
        if (classContextId == null) throw new Error("Expected class context ID on computed name open bracket.");
        while(!tokens.matchesContextIdAndLabel((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR, classContextId))tokens.nextToken();
        tokens.nextToken();
    } else tokens.nextToken();
}



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");




function $3ff68279ff116ec4$export$2e2bcd8739ae039(tokens) {
    // import
    tokens.removeInitialToken();
    // name
    tokens.removeToken();
    // =
    tokens.removeToken();
    // name or require
    tokens.removeToken();
    // Handle either `import A = require('A')` or `import A = B.C.D`.
    if (tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) {
        // (
        tokens.removeToken();
        // path string
        tokens.removeToken();
        // )
        tokens.removeToken();
    } else while(tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).dot)){
        // .
        tokens.removeToken();
        // name
        tokens.removeToken();
    }
}




var $cc6e9bad918e06e9$export$cab8fec5d7ea8d7 = {
    typeDeclarations: new Set(),
    valueDeclarations: new Set()
};
function $cc6e9bad918e06e9$export$2e2bcd8739ae039(tokens) {
    var typeDeclarations = new Set();
    var valueDeclarations = new Set();
    for(var i = 0; i < tokens.tokens.length; i++){
        var token = tokens.tokens[i];
        if (token.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).name && (0, $e2df986cc8bbbda9$export$c08b4dec8c3c03d)(token)) {
            if (token.isType) typeDeclarations.add(tokens.identifierNameForToken(token));
            else valueDeclarations.add(tokens.identifierNameForToken(token));
        }
    }
    return {
        typeDeclarations: typeDeclarations,
        valueDeclarations: valueDeclarations
    };
}





function $2e0dfa576f54c5b0$export$2e2bcd8739ae039(tokens) {
    var closeBraceIndex = tokens.currentIndex();
    while(!tokens.matches1AtIndex(closeBraceIndex, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR))closeBraceIndex++;
    return tokens.matchesContextualAtIndex(closeBraceIndex + 1, (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._from) && tokens.matches1AtIndex(closeBraceIndex + 2, (0, $30a0d13de21d779e$export$f435f793048e7a0f).string);
}




function $9fd9c604ced25884$export$7e9be594554aa1b0(tokens) {
    if (tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._with, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL) || tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL) && tokens.matchesContextual((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._assert)) {
        // assert
        tokens.removeToken();
        // {
        tokens.removeToken();
        tokens.removeBalancedCode();
        // }
        tokens.removeToken();
    }
}



function $66e89981e25b5ac4$export$2e2bcd8739ae039(isTypeScriptTransformEnabled, keepUnusedImports, tokens, declarationInfo) {
    if (!isTypeScriptTransformEnabled || keepUnusedImports) return false;
    var exportToken = tokens.currentToken();
    if (exportToken.rhsEndIndex == null) throw new Error("Expected non-null rhsEndIndex on export token.");
    // The export must be of the form `export default a` or `export default a;`.
    var numTokens = exportToken.rhsEndIndex - tokens.currentIndex();
    if (numTokens !== 3 && !(numTokens === 4 && tokens.matches1AtIndex(exportToken.rhsEndIndex - 1, (0, $30a0d13de21d779e$export$f435f793048e7a0f).semi))) return false;
    var identifierToken = tokens.tokenAtRelativeIndex(2);
    if (identifierToken.type !== (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) return false;
    var exportedName = tokens.identifierNameForToken(identifierToken);
    return declarationInfo.typeDeclarations.has(exportedName) && !declarationInfo.valueDeclarations.has(exportedName);
}



var $b176b2eb478eac92$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Transformer) {
    "use strict";
    (0, $hdIku._)(CJSImportTransformer, Transformer);
    function CJSImportTransformer(rootTransformer, tokens, importProcessor, nameManager, helperManager, reactHotLoaderTransformer, enableLegacyBabel5ModuleInterop, enableLegacyTypeScriptModuleInterop, isTypeScriptTransformEnabled, isFlowTransformEnabled, preserveDynamicImport, keepUnusedImports) {
        (0, $173N4._)(this, CJSImportTransformer);
        var _this;
        _this = (0, $7qXGD._)(this, CJSImportTransformer);
        _this.rootTransformer = rootTransformer;
        _this.tokens = tokens;
        _this.importProcessor = importProcessor;
        _this.nameManager = nameManager;
        _this.helperManager = helperManager;
        _this.reactHotLoaderTransformer = reactHotLoaderTransformer;
        _this.enableLegacyBabel5ModuleInterop = enableLegacyBabel5ModuleInterop;
        _this.enableLegacyTypeScriptModuleInterop = enableLegacyTypeScriptModuleInterop;
        _this.isTypeScriptTransformEnabled = isTypeScriptTransformEnabled;
        _this.isFlowTransformEnabled = isFlowTransformEnabled;
        _this.preserveDynamicImport = preserveDynamicImport;
        _this.keepUnusedImports = keepUnusedImports;
        CJSImportTransformer.prototype.__init.call(_this);
        CJSImportTransformer.prototype.__init2.call(_this);
        CJSImportTransformer.prototype.__init3.call(_this);
        _this.declarationInfo = isTypeScriptTransformEnabled ? (0, $cc6e9bad918e06e9$export$2e2bcd8739ae039)(tokens) : (0, $cc6e9bad918e06e9$export$cab8fec5d7ea8d7);
        return _this;
    }
    (0, $cFHGC._)(CJSImportTransformer, [
        {
            key: "__init",
            value: function __init() {
                this.hadExport = false;
            }
        },
        {
            key: "__init2",
            value: function __init2() {
                this.hadNamedExport = false;
            }
        },
        {
            key: "__init3",
            value: function __init3() {
                this.hadDefaultExport = false;
            }
        },
        {
            key: "getPrefixCode",
            value: function getPrefixCode() {
                var prefix = "";
                if (this.hadExport) prefix += 'Object.defineProperty(exports, "__esModule", {value: true});';
                return prefix;
            }
        },
        {
            key: "getSuffixCode",
            value: function getSuffixCode() {
                if (this.enableLegacyBabel5ModuleInterop && this.hadDefaultExport && !this.hadNamedExport) return "\nmodule.exports = exports.default;\n";
                return "";
            }
        },
        {
            key: "process",
            value: function process() {
                // TypeScript `import foo = require('foo');` should always just be translated to plain require.
                if (this.tokens.matches3((0, $30a0d13de21d779e$export$f435f793048e7a0f)._import, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) return this.processImportEquals();
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._import)) {
                    this.processImport();
                    return true;
                }
                if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) {
                    this.tokens.replaceToken("module.exports");
                    return true;
                }
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export) && !this.tokens.currentToken().isType) {
                    this.hadExport = true;
                    return this.processExport();
                }
                if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).postIncDec)) {
                    // Fall through to normal identifier matching if this doesn't apply.
                    if (this.processPostIncDec()) return true;
                }
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).name) || this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).jsxName)) return this.processIdentifier();
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) return this.processAssignment();
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).assign)) return this.processComplexAssignment();
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).preIncDec)) return this.processPreIncDec();
                return false;
            }
        },
        {
            key: "processImportEquals",
            value: function processImportEquals() {
                var importName = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
                if (this.importProcessor.shouldAutomaticallyElideImportedName(importName)) // If this name is only used as a type, elide the whole import.
                (0, $3ff68279ff116ec4$export$2e2bcd8739ae039)(this.tokens);
                else // Otherwise, switch `import` to `const`.
                this.tokens.replaceToken("const");
                return true;
            }
        },
        {
            /**
   * Transform this:
   * import foo, {bar} from 'baz';
   * into
   * var _baz = require('baz'); var _baz2 = _interopRequireDefault(_baz);
   *
   * The import code was already generated in the import preprocessing step, so
   * we just need to look it up.
   */ key: "processImport",
            value: function processImport() {
                if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._import, (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) {
                    if (this.preserveDynamicImport) {
                        // Bail out, only making progress for this one token.
                        this.tokens.copyToken();
                        return;
                    }
                    var requireWrapper = this.enableLegacyTypeScriptModuleInterop ? "" : "".concat(this.helperManager.getHelperName("interopRequireWildcard"), "(");
                    this.tokens.replaceToken("Promise.resolve().then(() => ".concat(requireWrapper, "require"));
                    var contextId = this.tokens.currentToken().contextId;
                    if (contextId == null) throw new Error("Expected context ID on dynamic import invocation.");
                    this.tokens.copyToken();
                    while(!this.tokens.matchesContextIdAndLabel((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR, contextId))this.rootTransformer.processToken();
                    this.tokens.replaceToken(requireWrapper ? ")))" : "))");
                    return;
                }
                var shouldElideImport = this.removeImportAndDetectIfShouldElide();
                if (shouldElideImport) this.tokens.removeToken();
                else {
                    var path = this.tokens.stringValue();
                    this.tokens.replaceTokenTrimmingLeftWhitespace(this.importProcessor.claimImportCode(path));
                    this.tokens.appendCode(this.importProcessor.claimImportCode(path));
                }
                (0, $9fd9c604ced25884$export$7e9be594554aa1b0)(this.tokens);
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).semi)) this.tokens.removeToken();
            }
        },
        {
            /**
   * Erase this import (since any CJS output would be completely different), and
   * return true if this import is should be elided due to being a type-only
   * import. Such imports will not be emitted at all to avoid side effects.
   *
   * Import elision only happens with the TypeScript or Flow transforms enabled.
   *
   * TODO: This function has some awkward overlap with
   *  CJSImportProcessor.pruneTypeOnlyImports , and the two should be unified.
   *  That function handles TypeScript implicit import name elision, and removes
   *  an import if all typical imported names (without `type`) are removed due
   *  to being type-only imports. This function handles Flow import removal and
   *  properly distinguishes `import 'foo'` from `import {} from 'foo'` for TS
   *  purposes.
   *
   * The position should end at the import string.
   */ key: "removeImportAndDetectIfShouldElide",
            value: function removeImportAndDetectIfShouldElide() {
                this.tokens.removeInitialToken();
                if (this.tokens.matchesContextual((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type) && !this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, (0, $30a0d13de21d779e$export$f435f793048e7a0f).comma) && !this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._from)) {
                    // This is an "import type" statement, so exit early.
                    this.removeRemainingImport();
                    return true;
                }
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).name) || this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).star)) {
                    // We have a default import or namespace import, so there must be some
                    // non-type import.
                    this.removeRemainingImport();
                    return false;
                }
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).string)) // This is a bare import, so we should proceed with the import.
                return false;
                var foundNonTypeImport = false;
                var foundAnyNamedImport = false;
                while(!this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).string)){
                    // Check if any named imports are of the form "foo" or "foo as bar", with
                    // no leading "type".
                    if (!foundNonTypeImport && this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL) || this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) {
                        this.tokens.removeToken();
                        if (!this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) foundAnyNamedImport = true;
                        if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).comma) || this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR) || this.tokens.matches4((0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).comma) || this.tokens.matches4((0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) foundNonTypeImport = true;
                    }
                    this.tokens.removeToken();
                }
                if (this.keepUnusedImports) return false;
                if (this.isTypeScriptTransformEnabled) return !foundNonTypeImport;
                else if (this.isFlowTransformEnabled) // In Flow, unlike TS, `import {} from 'foo';` preserves the import.
                return foundAnyNamedImport && !foundNonTypeImport;
                else return false;
            }
        },
        {
            key: "removeRemainingImport",
            value: function removeRemainingImport() {
                while(!this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).string))this.tokens.removeToken();
            }
        },
        {
            key: "processIdentifier",
            value: function processIdentifier() {
                var token = this.tokens.currentToken();
                if (token.shadowsGlobal) return false;
                if (token.identifierRole === (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ObjectShorthand) return this.processObjectShorthand();
                if (token.identifierRole !== (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).Access) return false;
                var replacement = this.importProcessor.getIdentifierReplacement(this.tokens.identifierNameForToken(token));
                if (!replacement) return false;
                // Tolerate any number of closing parens while looking for an opening paren
                // that indicates a function call.
                var possibleOpenParenIndex = this.tokens.currentIndex() + 1;
                while(possibleOpenParenIndex < this.tokens.tokens.length && this.tokens.tokens[possibleOpenParenIndex].type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR)possibleOpenParenIndex++;
                // Avoid treating imported functions as methods of their `exports` object
                // by using `(0, f)` when the identifier is in a paren expression. Else
                // use `Function.prototype.call` when the identifier is a guaranteed
                // function call. When using `call`, pass undefined as the context.
                if (this.tokens.tokens[possibleOpenParenIndex].type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL) {
                    if (this.tokens.tokenAtRelativeIndex(1).type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL && this.tokens.tokenAtRelativeIndex(-1).type !== (0, $30a0d13de21d779e$export$f435f793048e7a0f)._new) {
                        this.tokens.replaceToken("".concat(replacement, ".call(void 0, "));
                        // Remove the old paren.
                        this.tokens.removeToken();
                        // Balance out the new paren.
                        this.rootTransformer.processBalancedCode();
                        this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
                    } else // See here: http://2ality.com/2015/12/references.html
                    this.tokens.replaceToken("(0, ".concat(replacement, ")"));
                } else this.tokens.replaceToken(replacement);
                return true;
            }
        },
        {
            key: "processObjectShorthand",
            value: function processObjectShorthand() {
                var identifier = this.tokens.identifierName();
                var replacement = this.importProcessor.getIdentifierReplacement(identifier);
                if (!replacement) return false;
                this.tokens.replaceToken("".concat(identifier, ": ").concat(replacement));
                return true;
            }
        },
        {
            key: "processExport",
            value: function processExport() {
                if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._enum) || this.tokens.matches3((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._const, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._enum)) {
                    this.hadNamedExport = true;
                    // Let the TypeScript transform handle it.
                    return false;
                }
                if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._default)) {
                    if (this.tokens.matches3((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._default, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._enum)) {
                        this.hadDefaultExport = true;
                        // Flow export default enums need some special handling, so handle them
                        // in that tranform rather than this one.
                        return false;
                    }
                    this.processExportDefault();
                    return true;
                } else if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) {
                    this.processExportBindings();
                    return true;
                } else if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type)) {
                    // export type {a};
                    // export type {a as b};
                    // export type {a} from './b';
                    // export type * from './b';
                    // export type * as ns from './b';
                    this.tokens.removeInitialToken();
                    this.tokens.removeToken();
                    if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) {
                        while(!this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR))this.tokens.removeToken();
                        this.tokens.removeToken();
                    } else {
                        // *
                        this.tokens.removeToken();
                        if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._as)) {
                            // as
                            this.tokens.removeToken();
                            // ns
                            this.tokens.removeToken();
                        }
                    }
                    // Remove type re-export `... } from './T'`
                    if (this.tokens.matchesContextual((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._from) && this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, (0, $30a0d13de21d779e$export$f435f793048e7a0f).string)) {
                        this.tokens.removeToken();
                        this.tokens.removeToken();
                        (0, $9fd9c604ced25884$export$7e9be594554aa1b0)(this.tokens);
                    }
                    return true;
                }
                this.hadNamedExport = true;
                if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._var) || this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._let) || this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._const)) {
                    this.processExportVar();
                    return true;
                } else if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._function) || // export async function
                this.tokens.matches3((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._function)) {
                    this.processExportFunction();
                    return true;
                } else if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._class) || this.tokens.matches3((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._abstract, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._class) || this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f).at)) {
                    this.processExportClass();
                    return true;
                } else if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f).star)) {
                    this.processExportStar();
                    return true;
                } else throw new Error("Unrecognized export syntax.");
            }
        },
        {
            key: "processAssignment",
            value: function processAssignment() {
                var index = this.tokens.currentIndex();
                var identifierToken = this.tokens.tokens[index - 1];
                // If the LHS is a type identifier, this must be a declaration like `let a: b = c;`,
                // with `b` as the identifier, so nothing needs to be done in that case.
                if (identifierToken.isType || identifierToken.type !== (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) return false;
                if (identifierToken.shadowsGlobal) return false;
                if (index >= 2 && this.tokens.matches1AtIndex(index - 2, (0, $30a0d13de21d779e$export$f435f793048e7a0f).dot)) return false;
                if (index >= 2 && [
                    (0, $30a0d13de21d779e$export$f435f793048e7a0f)._var,
                    (0, $30a0d13de21d779e$export$f435f793048e7a0f)._let,
                    (0, $30a0d13de21d779e$export$f435f793048e7a0f)._const
                ].includes(this.tokens.tokens[index - 2].type)) // Declarations don't need an extra assignment. This doesn't avoid the
                // assignment for comma-separated declarations, but it's still correct
                // since the assignment is just redundant.
                return false;
                var assignmentSnippet = this.importProcessor.resolveExportBinding(this.tokens.identifierNameForToken(identifierToken));
                if (!assignmentSnippet) return false;
                this.tokens.copyToken();
                this.tokens.appendCode(" ".concat(assignmentSnippet, " ="));
                return true;
            }
        },
        {
            /**
   * Process something like `a += 3`, where `a` might be an exported value.
   */ key: "processComplexAssignment",
            value: function processComplexAssignment() {
                var index = this.tokens.currentIndex();
                var identifierToken = this.tokens.tokens[index - 1];
                if (identifierToken.type !== (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) return false;
                if (identifierToken.shadowsGlobal) return false;
                if (index >= 2 && this.tokens.matches1AtIndex(index - 2, (0, $30a0d13de21d779e$export$f435f793048e7a0f).dot)) return false;
                var assignmentSnippet = this.importProcessor.resolveExportBinding(this.tokens.identifierNameForToken(identifierToken));
                if (!assignmentSnippet) return false;
                this.tokens.appendCode(" = ".concat(assignmentSnippet));
                this.tokens.copyToken();
                return true;
            }
        },
        {
            /**
   * Process something like `++a`, where `a` might be an exported value.
   */ key: "processPreIncDec",
            value: function processPreIncDec() {
                var index = this.tokens.currentIndex();
                var identifierToken = this.tokens.tokens[index + 1];
                if (identifierToken.type !== (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) return false;
                if (identifierToken.shadowsGlobal) return false;
                // Ignore things like ++a.b and ++a[b] and ++a().b.
                if (index + 2 < this.tokens.tokens.length && (this.tokens.matches1AtIndex(index + 2, (0, $30a0d13de21d779e$export$f435f793048e7a0f).dot) || this.tokens.matches1AtIndex(index + 2, (0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL) || this.tokens.matches1AtIndex(index + 2, (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL))) return false;
                var identifierName = this.tokens.identifierNameForToken(identifierToken);
                var assignmentSnippet = this.importProcessor.resolveExportBinding(identifierName);
                if (!assignmentSnippet) return false;
                this.tokens.appendCode("".concat(assignmentSnippet, " = "));
                this.tokens.copyToken();
                return true;
            }
        },
        {
            /**
   * Process something like `a++`, where `a` might be an exported value.
   * This starts at the `a`, not at the `++`.
   */ key: "processPostIncDec",
            value: function processPostIncDec() {
                var index = this.tokens.currentIndex();
                var identifierToken = this.tokens.tokens[index];
                var operatorToken = this.tokens.tokens[index + 1];
                if (identifierToken.type !== (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) return false;
                if (identifierToken.shadowsGlobal) return false;
                if (index >= 1 && this.tokens.matches1AtIndex(index - 1, (0, $30a0d13de21d779e$export$f435f793048e7a0f).dot)) return false;
                var identifierName = this.tokens.identifierNameForToken(identifierToken);
                var assignmentSnippet = this.importProcessor.resolveExportBinding(identifierName);
                if (!assignmentSnippet) return false;
                var operatorCode = this.tokens.rawCodeForToken(operatorToken);
                // We might also replace the identifier with something like exports.x, so
                // do that replacement here as well.
                var base = this.importProcessor.getIdentifierReplacement(identifierName) || identifierName;
                if (operatorCode === "++") this.tokens.replaceToken("(".concat(base, " = ").concat(assignmentSnippet, " = ").concat(base, " + 1, ").concat(base, " - 1)"));
                else if (operatorCode === "--") this.tokens.replaceToken("(".concat(base, " = ").concat(assignmentSnippet, " = ").concat(base, " - 1, ").concat(base, " + 1)"));
                else throw new Error("Unexpected operator: ".concat(operatorCode));
                this.tokens.removeToken();
                return true;
            }
        },
        {
            key: "processExportDefault",
            value: function processExportDefault() {
                var exportedRuntimeValue = true;
                if (this.tokens.matches4((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._default, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._function, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) || // export default async function
                this.tokens.matches5((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._default, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._function, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._async)) {
                    this.tokens.removeInitialToken();
                    this.tokens.removeToken();
                    // Named function export case: change it to a top-level function
                    // declaration followed by exports statement.
                    var name = this.processNamedFunction();
                    this.tokens.appendCode(" exports.default = ".concat(name, ";"));
                } else if (this.tokens.matches4((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._default, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._class, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) || this.tokens.matches5((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._default, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._abstract, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._class, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) || this.tokens.matches3((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._default, (0, $30a0d13de21d779e$export$f435f793048e7a0f).at)) {
                    this.tokens.removeInitialToken();
                    this.tokens.removeToken();
                    this.copyDecorators();
                    if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._abstract)) this.tokens.removeToken();
                    var name1 = this.rootTransformer.processNamedClass();
                    this.tokens.appendCode(" exports.default = ".concat(name1, ";"));
                // After this point, this is a plain "export default E" statement.
                } else if ((0, $66e89981e25b5ac4$export$2e2bcd8739ae039)(this.isTypeScriptTransformEnabled, this.keepUnusedImports, this.tokens, this.declarationInfo)) {
                    // If the exported value is just an identifier and should be elided by TypeScript
                    // rules, then remove it entirely. It will always have the form `export default e`,
                    // where `e` is an identifier.
                    exportedRuntimeValue = false;
                    this.tokens.removeInitialToken();
                    this.tokens.removeToken();
                    this.tokens.removeToken();
                } else if (this.reactHotLoaderTransformer) {
                    // We need to assign E to a variable. Change "export default E" to
                    // "let _default; exports.default = _default = E"
                    var defaultVarName = this.nameManager.claimFreeName("_default");
                    this.tokens.replaceToken("let ".concat(defaultVarName, "; exports."));
                    this.tokens.copyToken();
                    this.tokens.appendCode(" = ".concat(defaultVarName, " ="));
                    this.reactHotLoaderTransformer.setExtractedDefaultExportName(defaultVarName);
                } else {
                    // Change "export default E" to "exports.default = E"
                    this.tokens.replaceToken("exports.");
                    this.tokens.copyToken();
                    this.tokens.appendCode(" =");
                }
                if (exportedRuntimeValue) this.hadDefaultExport = true;
            }
        },
        {
            key: "copyDecorators",
            value: function copyDecorators() {
                while(this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).at)){
                    this.tokens.copyToken();
                    if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) {
                        this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL);
                        this.rootTransformer.processBalancedCode();
                        this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
                    } else {
                        this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).name);
                        while(this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).dot)){
                            this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).dot);
                            this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).name);
                        }
                        if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) {
                            this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL);
                            this.rootTransformer.processBalancedCode();
                            this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
                        }
                    }
                }
            }
        },
        {
            /**
   * Transform a declaration like `export var`, `export let`, or `export const`.
   */ key: "processExportVar",
            value: function processExportVar() {
                if (this.isSimpleExportVar()) this.processSimpleExportVar();
                else this.processComplexExportVar();
            }
        },
        {
            /**
   * Determine if the export is of the form:
   * export var/let/const [varName] = [expr];
   * In other words, determine if function name inference might apply.
   */ key: "isSimpleExportVar",
            value: function isSimpleExportVar() {
                var tokenIndex = this.tokens.currentIndex();
                // export
                tokenIndex++;
                // var/let/const
                tokenIndex++;
                if (!this.tokens.matches1AtIndex(tokenIndex, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) return false;
                tokenIndex++;
                while(tokenIndex < this.tokens.tokens.length && this.tokens.tokens[tokenIndex].isType)tokenIndex++;
                if (!this.tokens.matches1AtIndex(tokenIndex, (0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) return false;
                return true;
            }
        },
        {
            /**
   * Transform an `export var` declaration initializing a single variable.
   *
   * For example, this:
   * export const f = () => {};
   * becomes this:
   * const f = () => {}; exports.f = f;
   *
   * The variable is unused (e.g. exports.f has the true value of the export).
   * We need to produce an assignment of this form so that the function will
   * have an inferred name of "f", which wouldn't happen in the more general
   * case below.
   */ key: "processSimpleExportVar",
            value: function processSimpleExportVar() {
                // export
                this.tokens.removeInitialToken();
                // var/let/const
                this.tokens.copyToken();
                var varName = this.tokens.identifierName();
                // x: number  ->  x
                while(!this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq))this.rootTransformer.processToken();
                var endIndex = this.tokens.currentToken().rhsEndIndex;
                if (endIndex == null) throw new Error("Expected = token with an end index.");
                while(this.tokens.currentIndex() < endIndex)this.rootTransformer.processToken();
                this.tokens.appendCode("; exports.".concat(varName, " = ").concat(varName));
            }
        },
        {
            /**
   * Transform normal declaration exports, including handling destructuring.
   * For example, this:
   * export const {x: [a = 2, b], c} = d;
   * becomes this:
   * ({x: [exports.a = 2, exports.b], c: exports.c} = d;)
   */ key: "processComplexExportVar",
            value: function processComplexExportVar() {
                this.tokens.removeInitialToken();
                this.tokens.removeToken();
                var needsParens = this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
                if (needsParens) this.tokens.appendCode("(");
                var depth = 0;
                while(true){
                    if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL) || this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).dollarBraceL) || this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL)) {
                        depth++;
                        this.tokens.copyToken();
                    } else if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR) || this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketR)) {
                        depth--;
                        this.tokens.copyToken();
                    } else if (depth === 0 && !this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).name) && !this.tokens.currentToken().isType) break;
                    else if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) {
                        // Default values might have assignments in the RHS that we want to ignore, so skip past
                        // them.
                        var endIndex = this.tokens.currentToken().rhsEndIndex;
                        if (endIndex == null) throw new Error("Expected = token with an end index.");
                        while(this.tokens.currentIndex() < endIndex)this.rootTransformer.processToken();
                    } else {
                        var token = this.tokens.currentToken();
                        if ((0, $e2df986cc8bbbda9$export$31dc9881735f7118)(token)) {
                            var name = this.tokens.identifierName();
                            var replacement = this.importProcessor.getIdentifierReplacement(name);
                            if (replacement === null) throw new Error("Expected a replacement for ".concat(name, " in `export var` syntax."));
                            if ((0, $e2df986cc8bbbda9$export$dea1d79574e9c731)(token)) replacement = "".concat(name, ": ").concat(replacement);
                            this.tokens.replaceToken(replacement);
                        } else this.rootTransformer.processToken();
                    }
                }
                if (needsParens) {
                    // Seek to the end of the RHS.
                    var endIndex1 = this.tokens.currentToken().rhsEndIndex;
                    if (endIndex1 == null) throw new Error("Expected = token with an end index.");
                    while(this.tokens.currentIndex() < endIndex1)this.rootTransformer.processToken();
                    this.tokens.appendCode(")");
                }
            }
        },
        {
            /**
   * Transform this:
   * export function foo() {}
   * into this:
   * function foo() {} exports.foo = foo;
   */ key: "processExportFunction",
            value: function processExportFunction() {
                this.tokens.replaceToken("");
                var name = this.processNamedFunction();
                this.tokens.appendCode(" exports.".concat(name, " = ").concat(name, ";"));
            }
        },
        {
            /**
   * Skip past a function with a name and return that name.
   */ key: "processNamedFunction",
            value: function processNamedFunction() {
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._function)) this.tokens.copyToken();
                else if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._function)) {
                    if (!this.tokens.matchesContextual((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._async)) throw new Error("Expected async keyword in function export.");
                    this.tokens.copyToken();
                    this.tokens.copyToken();
                }
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).star)) this.tokens.copyToken();
                if (!this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) throw new Error("Expected identifier for exported function name.");
                var name = this.tokens.identifierName();
                this.tokens.copyToken();
                if (this.tokens.currentToken().isType) {
                    this.tokens.removeInitialToken();
                    while(this.tokens.currentToken().isType)this.tokens.removeToken();
                }
                this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL);
                this.rootTransformer.processBalancedCode();
                this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
                this.rootTransformer.processPossibleTypeRange();
                this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
                this.rootTransformer.processBalancedCode();
                this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR);
                return name;
            }
        },
        {
            /**
   * Transform this:
   * export class A {}
   * into this:
   * class A {} exports.A = A;
   */ key: "processExportClass",
            value: function processExportClass() {
                this.tokens.removeInitialToken();
                this.copyDecorators();
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._abstract)) this.tokens.removeToken();
                var name = this.rootTransformer.processNamedClass();
                this.tokens.appendCode(" exports.".concat(name, " = ").concat(name, ";"));
            }
        },
        {
            /**
   * Transform this:
   * export {a, b as c};
   * into this:
   * exports.a = a; exports.c = b;
   *
   * OR
   *
   * Transform this:
   * export {a, b as c} from './foo';
   * into the pre-generated Object.defineProperty code from the ImportProcessor.
   *
   * For the first case, if the TypeScript transform is enabled, we need to skip
   * exports that are only defined as types.
   */ key: "processExportBindings",
            value: function processExportBindings() {
                this.tokens.removeInitialToken();
                this.tokens.removeToken();
                var isReExport = (0, $2e0dfa576f54c5b0$export$2e2bcd8739ae039)(this.tokens);
                var exportStatements = [];
                while(true){
                    if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) {
                        this.tokens.removeToken();
                        break;
                    }
                    var specifierInfo = (0, $60f9e6aa148c791b$export$2e2bcd8739ae039)(this.tokens);
                    while(this.tokens.currentIndex() < specifierInfo.endIndex)this.tokens.removeToken();
                    var shouldRemoveExport = specifierInfo.isType || !isReExport && this.shouldElideExportedIdentifier(specifierInfo.leftName);
                    if (!shouldRemoveExport) {
                        var exportedName = specifierInfo.rightName;
                        if (exportedName === "default") this.hadDefaultExport = true;
                        else this.hadNamedExport = true;
                        var localName = specifierInfo.leftName;
                        var newLocalName = this.importProcessor.getIdentifierReplacement(localName);
                        exportStatements.push("exports.".concat(exportedName, " = ").concat(newLocalName || localName, ";"));
                    }
                    if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) {
                        this.tokens.removeToken();
                        break;
                    }
                    if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) {
                        this.tokens.removeToken();
                        this.tokens.removeToken();
                        break;
                    } else if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) this.tokens.removeToken();
                    else throw new Error("Unexpected token: ".concat(JSON.stringify(this.tokens.currentToken())));
                }
                if (this.tokens.matchesContextual((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._from)) {
                    // This is an export...from, so throw away the normal named export code
                    // and use the Object.defineProperty code from ImportProcessor.
                    this.tokens.removeToken();
                    var path = this.tokens.stringValue();
                    this.tokens.replaceTokenTrimmingLeftWhitespace(this.importProcessor.claimImportCode(path));
                    (0, $9fd9c604ced25884$export$7e9be594554aa1b0)(this.tokens);
                } else // This is a normal named export, so use that.
                this.tokens.appendCode(exportStatements.join(" "));
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).semi)) this.tokens.removeToken();
            }
        },
        {
            key: "processExportStar",
            value: function processExportStar() {
                this.tokens.removeInitialToken();
                while(!this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).string))this.tokens.removeToken();
                var path = this.tokens.stringValue();
                this.tokens.replaceTokenTrimmingLeftWhitespace(this.importProcessor.claimImportCode(path));
                (0, $9fd9c604ced25884$export$7e9be594554aa1b0)(this.tokens);
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).semi)) this.tokens.removeToken();
            }
        },
        {
            key: "shouldElideExportedIdentifier",
            value: function shouldElideExportedIdentifier(name) {
                return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && !this.declarationInfo.valueDeclarations.has(name);
            }
        }
    ]);
    return CJSImportTransformer;
}((0, $8757da14f0d3faf0$export$2e2bcd8739ae039));



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");










var $ae865af7cb421f92$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Transformer) {
    "use strict";
    (0, $hdIku._)(ESMImportTransformer, Transformer);
    function ESMImportTransformer(tokens, nameManager, helperManager, reactHotLoaderTransformer, isTypeScriptTransformEnabled, isFlowTransformEnabled, keepUnusedImports, options) {
        (0, $173N4._)(this, ESMImportTransformer);
        var _this;
        _this = (0, $7qXGD._)(this, ESMImportTransformer);
        _this.tokens = tokens;
        _this.nameManager = nameManager;
        _this.helperManager = helperManager;
        _this.reactHotLoaderTransformer = reactHotLoaderTransformer;
        _this.isTypeScriptTransformEnabled = isTypeScriptTransformEnabled;
        _this.isFlowTransformEnabled = isFlowTransformEnabled;
        _this.keepUnusedImports = keepUnusedImports;
        _this.nonTypeIdentifiers = isTypeScriptTransformEnabled && !keepUnusedImports ? (0, $ff5972888e844943$export$d0e55db0e89d76b7)(tokens, options) : new Set();
        _this.declarationInfo = isTypeScriptTransformEnabled && !keepUnusedImports ? (0, $cc6e9bad918e06e9$export$2e2bcd8739ae039)(tokens) : (0, $cc6e9bad918e06e9$export$cab8fec5d7ea8d7);
        _this.injectCreateRequireForImportRequire = Boolean(options.injectCreateRequireForImportRequire);
        return _this;
    }
    (0, $cFHGC._)(ESMImportTransformer, [
        {
            key: "process",
            value: function process() {
                // TypeScript `import foo = require('foo');` should always just be translated to plain require.
                if (this.tokens.matches3((0, $30a0d13de21d779e$export$f435f793048e7a0f)._import, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) return this.processImportEquals();
                if (this.tokens.matches4((0, $30a0d13de21d779e$export$f435f793048e7a0f)._import, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).eq) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type)) {
                    // import type T = require('T')
                    this.tokens.removeInitialToken();
                    // This construct is always exactly 8 tokens long, so remove the 7 remaining tokens.
                    for(var i = 0; i < 7; i++)this.tokens.removeToken();
                    return true;
                }
                if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) {
                    this.tokens.replaceToken("module.exports");
                    return true;
                }
                if (this.tokens.matches5((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._import, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).eq) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type)) {
                    // export import type T = require('T')
                    this.tokens.removeInitialToken();
                    // This construct is always exactly 9 tokens long, so remove the 8 remaining tokens.
                    for(var i1 = 0; i1 < 8; i1++)this.tokens.removeToken();
                    return true;
                }
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._import)) return this.processImport();
                if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._default)) return this.processExportDefault();
                if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) return this.processNamedExports();
                if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type)) {
                    // export type {a};
                    // export type {a as b};
                    // export type {a} from './b';
                    // export type * from './b';
                    // export type * as ns from './b';
                    this.tokens.removeInitialToken();
                    this.tokens.removeToken();
                    if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) {
                        while(!this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR))this.tokens.removeToken();
                        this.tokens.removeToken();
                    } else {
                        // *
                        this.tokens.removeToken();
                        if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._as)) {
                            // as
                            this.tokens.removeToken();
                            // ns
                            this.tokens.removeToken();
                        }
                    }
                    // Remove type re-export `... } from './T'`
                    if (this.tokens.matchesContextual((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._from) && this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, (0, $30a0d13de21d779e$export$f435f793048e7a0f).string)) {
                        this.tokens.removeToken();
                        this.tokens.removeToken();
                        (0, $9fd9c604ced25884$export$7e9be594554aa1b0)(this.tokens);
                    }
                    return true;
                }
                return false;
            }
        },
        {
            key: "processImportEquals",
            value: function processImportEquals() {
                var importName = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
                if (this.shouldAutomaticallyElideImportedName(importName)) // If this name is only used as a type, elide the whole import.
                (0, $3ff68279ff116ec4$export$2e2bcd8739ae039)(this.tokens);
                else if (this.injectCreateRequireForImportRequire) {
                    // We're using require in an environment (Node ESM) that doesn't provide
                    // it as a global, so generate a helper to import it.
                    // import -> const
                    this.tokens.replaceToken("const");
                    // Foo
                    this.tokens.copyToken();
                    // =
                    this.tokens.copyToken();
                    // require
                    this.tokens.replaceToken(this.helperManager.getHelperName("require"));
                } else // Otherwise, just switch `import` to `const`.
                this.tokens.replaceToken("const");
                return true;
            }
        },
        {
            key: "processImport",
            value: function processImport() {
                if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._import, (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) // Dynamic imports don't need to be transformed.
                return false;
                var snapshot = this.tokens.snapshot();
                var allImportsRemoved = this.removeImportTypeBindings();
                if (allImportsRemoved) {
                    this.tokens.restoreToSnapshot(snapshot);
                    while(!this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).string))this.tokens.removeToken();
                    this.tokens.removeToken();
                    (0, $9fd9c604ced25884$export$7e9be594554aa1b0)(this.tokens);
                    if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).semi)) this.tokens.removeToken();
                }
                return true;
            }
        },
        {
            /**
   * Remove type bindings from this import, leaving the rest of the import intact.
   *
   * Return true if this import was ONLY types, and thus is eligible for removal. This will bail out
   * of the replacement operation, so we can return early here.
   */ key: "removeImportTypeBindings",
            value: function removeImportTypeBindings() {
                this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f)._import);
                if (this.tokens.matchesContextual((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._type) && !this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, (0, $30a0d13de21d779e$export$f435f793048e7a0f).comma) && !this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._from)) // This is an "import type" statement, so exit early.
                return true;
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).string)) {
                    // This is a bare import, so we should proceed with the import.
                    this.tokens.copyToken();
                    return false;
                }
                // Skip the "module" token in import reflection.
                if (this.tokens.matchesContextual((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._module) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._from)) this.tokens.copyToken();
                var foundNonTypeImport = false;
                var foundAnyNamedImport = false;
                var needsComma = false;
                // Handle default import.
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) {
                    if (this.shouldAutomaticallyElideImportedName(this.tokens.identifierName())) {
                        this.tokens.removeToken();
                        if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) this.tokens.removeToken();
                    } else {
                        foundNonTypeImport = true;
                        this.tokens.copyToken();
                        if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) {
                            // We're in a statement like:
                            // import A, * as B from './A';
                            // or
                            // import A, {foo} from './A';
                            // where the `A` is being kept. The comma should be removed if an only
                            // if the next part of the import statement is elided, but that's hard
                            // to determine at this point in the code. Instead, always remove it
                            // and set a flag to add it back if necessary.
                            needsComma = true;
                            this.tokens.removeToken();
                        }
                    }
                }
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).star)) {
                    if (this.shouldAutomaticallyElideImportedName(this.tokens.identifierNameAtRelativeIndex(2))) {
                        this.tokens.removeToken();
                        this.tokens.removeToken();
                        this.tokens.removeToken();
                    } else {
                        if (needsComma) this.tokens.appendCode(",");
                        foundNonTypeImport = true;
                        this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).star);
                        this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).name);
                        this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).name);
                    }
                } else if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) {
                    if (needsComma) this.tokens.appendCode(",");
                    this.tokens.copyToken();
                    while(!this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)){
                        foundAnyNamedImport = true;
                        var specifierInfo = (0, $60f9e6aa148c791b$export$2e2bcd8739ae039)(this.tokens);
                        if (specifierInfo.isType || this.shouldAutomaticallyElideImportedName(specifierInfo.rightName)) {
                            while(this.tokens.currentIndex() < specifierInfo.endIndex)this.tokens.removeToken();
                            if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) this.tokens.removeToken();
                        } else {
                            foundNonTypeImport = true;
                            while(this.tokens.currentIndex() < specifierInfo.endIndex)this.tokens.copyToken();
                            if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) this.tokens.copyToken();
                        }
                    }
                    this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR);
                }
                if (this.keepUnusedImports) return false;
                if (this.isTypeScriptTransformEnabled) return !foundNonTypeImport;
                else if (this.isFlowTransformEnabled) // In Flow, unlike TS, `import {} from 'foo';` preserves the import.
                return foundAnyNamedImport && !foundNonTypeImport;
                else return false;
            }
        },
        {
            key: "shouldAutomaticallyElideImportedName",
            value: function shouldAutomaticallyElideImportedName(name) {
                return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && !this.nonTypeIdentifiers.has(name);
            }
        },
        {
            key: "processExportDefault",
            value: function processExportDefault() {
                if ((0, $66e89981e25b5ac4$export$2e2bcd8739ae039)(this.isTypeScriptTransformEnabled, this.keepUnusedImports, this.tokens, this.declarationInfo)) {
                    // If the exported value is just an identifier and should be elided by TypeScript
                    // rules, then remove it entirely. It will always have the form `export default e`,
                    // where `e` is an identifier.
                    this.tokens.removeInitialToken();
                    this.tokens.removeToken();
                    this.tokens.removeToken();
                    return true;
                }
                var alreadyHasName = this.tokens.matches4((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._default, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._function, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) || // export default async function
                this.tokens.matches5((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._default, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._function, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, (0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._async) || this.tokens.matches4((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._default, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._class, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) || this.tokens.matches5((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._default, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._abstract, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._class, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name);
                if (!alreadyHasName && this.reactHotLoaderTransformer) {
                    // This is a plain "export default E" statement and we need to assign E to a variable.
                    // Change "export default E" to "let _default; export default _default = E"
                    var defaultVarName = this.nameManager.claimFreeName("_default");
                    this.tokens.replaceToken("let ".concat(defaultVarName, "; export"));
                    this.tokens.copyToken();
                    this.tokens.appendCode(" ".concat(defaultVarName, " ="));
                    this.reactHotLoaderTransformer.setExtractedDefaultExportName(defaultVarName);
                    return true;
                }
                return false;
            }
        },
        {
            /**
   * Handle a statement with one of these forms:
   * export {a, type b};
   * export {c, type d} from 'foo';
   *
   * In both cases, any explicit type exports should be removed. In the first
   * case, we also need to handle implicit export elision for names declared as
   * types. In the second case, we must NOT do implicit named export elision,
   * but we must remove the runtime import if all exports are type exports.
   */ key: "processNamedExports",
            value: function processNamedExports() {
                if (!this.isTypeScriptTransformEnabled) return false;
                this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export);
                this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
                var isReExport = (0, $2e0dfa576f54c5b0$export$2e2bcd8739ae039)(this.tokens);
                var foundNonTypeExport = false;
                while(!this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)){
                    var specifierInfo = (0, $60f9e6aa148c791b$export$2e2bcd8739ae039)(this.tokens);
                    if (specifierInfo.isType || !isReExport && this.shouldElideExportedName(specifierInfo.leftName)) {
                        // Type export, so remove all tokens, including any comma.
                        while(this.tokens.currentIndex() < specifierInfo.endIndex)this.tokens.removeToken();
                        if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) this.tokens.removeToken();
                    } else {
                        // Non-type export, so copy all tokens, including any comma.
                        foundNonTypeExport = true;
                        while(this.tokens.currentIndex() < specifierInfo.endIndex)this.tokens.copyToken();
                        if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) this.tokens.copyToken();
                    }
                }
                this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR);
                if (!this.keepUnusedImports && isReExport && !foundNonTypeExport) {
                    // This is a type-only re-export, so skip evaluating the other module. Technically this
                    // leaves the statement as `export {}`, but that's ok since that's a no-op.
                    this.tokens.removeToken();
                    this.tokens.removeToken();
                    (0, $9fd9c604ced25884$export$7e9be594554aa1b0)(this.tokens);
                }
                return true;
            }
        },
        {
            /**
   * ESM elides all imports with the rule that we only elide if we see that it's
   * a type and never see it as a value. This is in contrast to CJS, which
   * elides imports that are completely unknown.
   */ key: "shouldElideExportedName",
            value: function shouldElideExportedName(name) {
                return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && this.declarationInfo.typeDeclarations.has(name) && !this.declarationInfo.valueDeclarations.has(name);
            }
        }
    ]);
    return ESMImportTransformer;
}((0, $8757da14f0d3faf0$export$2e2bcd8739ae039));



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");



var $766644b25b9d5ae2$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Transformer) {
    "use strict";
    (0, $hdIku._)(FlowTransformer, Transformer);
    function FlowTransformer(rootTransformer, tokens, isImportsTransformEnabled) {
        (0, $173N4._)(this, FlowTransformer);
        var _this;
        _this = (0, $7qXGD._)(this, FlowTransformer);
        _this.rootTransformer = rootTransformer;
        _this.tokens = tokens;
        _this.isImportsTransformEnabled = isImportsTransformEnabled;
        return _this;
    }
    (0, $cFHGC._)(FlowTransformer, [
        {
            key: "process",
            value: function process() {
                if (this.rootTransformer.processPossibleArrowParamEnd() || this.rootTransformer.processPossibleAsyncArrowWithTypeParams() || this.rootTransformer.processPossibleTypeRange()) return true;
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._enum)) {
                    this.processEnum();
                    return true;
                }
                if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._enum)) {
                    this.processNamedExportEnum();
                    return true;
                }
                if (this.tokens.matches3((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._default, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._enum)) {
                    this.processDefaultExportEnum();
                    return true;
                }
                return false;
            }
        },
        {
            /**
   * Handle a declaration like:
   * export enum E ...
   *
   * With this imports transform, this becomes:
   * const E = [[enum]]; exports.E = E;
   *
   * otherwise, it becomes:
   * export const E = [[enum]];
   */ key: "processNamedExportEnum",
            value: function processNamedExportEnum() {
                if (this.isImportsTransformEnabled) {
                    // export
                    this.tokens.removeInitialToken();
                    var enumName = this.tokens.identifierNameAtRelativeIndex(1);
                    this.processEnum();
                    this.tokens.appendCode(" exports.".concat(enumName, " = ").concat(enumName, ";"));
                } else {
                    this.tokens.copyToken();
                    this.processEnum();
                }
            }
        },
        {
            /**
   * Handle a declaration like:
   * export default enum E
   *
   * With the imports transform, this becomes:
   * const E = [[enum]]; exports.default = E;
   *
   * otherwise, it becomes:
   * const E = [[enum]]; export default E;
   */ key: "processDefaultExportEnum",
            value: function processDefaultExportEnum() {
                // export
                this.tokens.removeInitialToken();
                // default
                this.tokens.removeToken();
                var enumName = this.tokens.identifierNameAtRelativeIndex(1);
                this.processEnum();
                if (this.isImportsTransformEnabled) this.tokens.appendCode(" exports.default = ".concat(enumName, ";"));
                else this.tokens.appendCode(" export default ".concat(enumName, ";"));
            }
        },
        {
            /**
   * Transpile flow enums to invoke the "flow-enums-runtime" library.
   *
   * Currently, the transpiled code always uses `require("flow-enums-runtime")`,
   * but if future flexibility is needed, we could expose a config option for
   * this string (similar to configurable JSX). Even when targeting ESM, the
   * default behavior of babel-plugin-transform-flow-enums is to use require
   * rather than injecting an import.
   *
   * Flow enums are quite a bit simpler than TS enums and have some convenient
   * constraints:
   * - Element initializers must be either always present or always absent. That
   *   means that we can use fixed lookahead on the first element (if any) and
   *   assume that all elements are like that.
   * - The right-hand side of an element initializer must be a literal value,
   *   not a complex expression and not referencing other elements. That means
   *   we can simply copy a single token.
   *
   * Enums can be broken up into three basic cases:
   *
   * Mirrored enums:
   * enum E {A, B}
   *   ->
   * const E = require("flow-enums-runtime").Mirrored(["A", "B"]);
   *
   * Initializer enums:
   * enum E {A = 1, B = 2}
   *   ->
   * const E = require("flow-enums-runtime")({A: 1, B: 2});
   *
   * Symbol enums:
   * enum E of symbol {A, B}
   *   ->
   * const E = require("flow-enums-runtime")({A: Symbol("A"), B: Symbol("B")});
   *
   * We can statically detect which of the three cases this is by looking at the
   * "of" declaration (if any) and seeing if the first element has an initializer.
   * Since the other transform details are so similar between the three cases, we
   * use a single implementation and vary the transform within processEnumElement
   * based on case.
   */ key: "processEnum",
            value: function processEnum() {
                // enum E -> const E
                this.tokens.replaceToken("const");
                this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).name);
                var isSymbolEnum = false;
                if (this.tokens.matchesContextual((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._of)) {
                    this.tokens.removeToken();
                    isSymbolEnum = this.tokens.matchesContextual((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._symbol);
                    this.tokens.removeToken();
                }
                var hasInitializers = this.tokens.matches3((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).eq);
                this.tokens.appendCode(' = require("flow-enums-runtime")');
                var isMirrored = !isSymbolEnum && !hasInitializers;
                this.tokens.replaceTokenTrimmingLeftWhitespace(isMirrored ? ".Mirrored([" : "({");
                while(!this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)){
                    // ... is allowed at the end and has no runtime behavior.
                    if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).ellipsis)) {
                        this.tokens.removeToken();
                        break;
                    }
                    this.processEnumElement(isSymbolEnum, hasInitializers);
                    if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) this.tokens.copyToken();
                }
                this.tokens.replaceToken(isMirrored ? "]);" : "});");
            }
        },
        {
            /**
   * Process an individual enum element, producing either an array element or an
   * object element based on what type of enum this is.
   */ key: "processEnumElement",
            value: function processEnumElement(isSymbolEnum, hasInitializers) {
                if (isSymbolEnum) {
                    // Symbol enums never have initializers and are expanded to object elements.
                    // A, -> A: Symbol("A"),
                    var elementName = this.tokens.identifierName();
                    this.tokens.copyToken();
                    this.tokens.appendCode(': Symbol("'.concat(elementName, '")'));
                } else if (hasInitializers) {
                    // Initializers are expanded to object elements.
                    // A = 1, -> A: 1,
                    this.tokens.copyToken();
                    this.tokens.replaceTokenTrimmingLeftWhitespace(":");
                    this.tokens.copyToken();
                } else // Enum elements without initializers become string literal array elements.
                // A, -> "A",
                this.tokens.replaceToken('"'.concat(this.tokens.identifierName(), '"'));
            }
        }
    ]);
    return FlowTransformer;
}((0, $8757da14f0d3faf0$export$2e2bcd8739ae039));



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");

var $aUGqu = parcelRequire("aUGqu");


function $92709096ffea6ef7$var$_optionalChain(ops) {
    var lastAccessLHS = undefined;
    var value = ops[0];
    var i = 1;
    while(i < ops.length){
        var op = ops[i];
        var fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            var _value;
            value = fn(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_value = value).call.apply(_value, [
                    lastAccessLHS
                ].concat((0, $aUGqu._)(args)));
            });
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var $92709096ffea6ef7$var$JEST_GLOBAL_NAME = "jest";
var $92709096ffea6ef7$var$HOISTED_METHODS = [
    "mock",
    "unmock",
    "enableAutomock",
    "disableAutomock"
];
var $92709096ffea6ef7$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Transformer) {
    "use strict";
    (0, $hdIku._)(JestHoistTransformer, Transformer);
    function JestHoistTransformer(rootTransformer, tokens, nameManager, importProcessor) {
        (0, $173N4._)(this, JestHoistTransformer);
        var _this;
        _this = (0, $7qXGD._)(this, JestHoistTransformer);
        _this.rootTransformer = rootTransformer;
        _this.tokens = tokens;
        _this.nameManager = nameManager;
        _this.importProcessor = importProcessor;
        JestHoistTransformer.prototype.__init.call(_this);
        return _this;
    }
    (0, $cFHGC._)(JestHoistTransformer, [
        {
            key: "__init",
            value: function __init() {
                this.hoistedFunctionNames = [];
            }
        },
        {
            key: "process",
            value: function process() {
                if (this.tokens.currentToken().scopeDepth === 0 && this.tokens.matches4((0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).dot, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL) && this.tokens.identifierName() === $92709096ffea6ef7$var$JEST_GLOBAL_NAME) {
                    // TODO: This only works if imports transform is active, which it will be for jest.
                    //       But if jest adds module support and we no longer need the import transform, this needs fixing.
                    if ($92709096ffea6ef7$var$_optionalChain([
                        this,
                        'access',
                        function(_) {
                            return _.importProcessor;
                        },
                        'optionalAccess',
                        function(_2) {
                            return _2.getGlobalNames;
                        },
                        'call',
                        function(_3) {
                            return _3();
                        },
                        'optionalAccess',
                        function(_4) {
                            return _4.has;
                        },
                        'call',
                        function(_5) {
                            return _5($92709096ffea6ef7$var$JEST_GLOBAL_NAME);
                        }
                    ])) return false;
                    return this.extractHoistedCalls();
                }
                return false;
            }
        },
        {
            key: "getHoistedCode",
            value: function getHoistedCode() {
                if (this.hoistedFunctionNames.length > 0) // This will be placed before module interop code, but that's fine since
                // imports aren't allowed in module mock factories.
                return this.hoistedFunctionNames.map(function(name) {
                    return "".concat(name, "();");
                }).join("");
                return "";
            }
        },
        {
            /**
   * Extracts any methods calls on the jest-object that should be hoisted.
   *
   * According to the jest docs, https://jestjs.io/docs/en/jest-object#jestmockmodulename-factory-options,
   * mock, unmock, enableAutomock, disableAutomock, are the methods that should be hoisted.
   *
   * We do not apply the same checks of the arguments as babel-plugin-jest-hoist does.
   */ key: "extractHoistedCalls",
            value: function extractHoistedCalls() {
                // We're handling a chain of calls where `jest` may or may not need to be inserted for each call
                // in the chain, so remove the initial `jest` to make the loop implementation cleaner.
                this.tokens.removeToken();
                // Track some state so that multiple non-hoisted chained calls in a row keep their chaining
                // syntax.
                var followsNonHoistedJestCall = false;
                // Iterate through all chained calls on the jest object.
                while(this.tokens.matches3((0, $30a0d13de21d779e$export$f435f793048e7a0f).dot, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)){
                    var methodName = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
                    var shouldHoist = $92709096ffea6ef7$var$HOISTED_METHODS.includes(methodName);
                    if (shouldHoist) {
                        // We've matched e.g. `.mock(...)` or similar call.
                        // Replace the initial `.` with `function __jestHoist(){jest.`
                        var hoistedFunctionName = this.nameManager.claimFreeName("__jestHoist");
                        this.hoistedFunctionNames.push(hoistedFunctionName);
                        this.tokens.replaceToken("function ".concat(hoistedFunctionName, "(){").concat($92709096ffea6ef7$var$JEST_GLOBAL_NAME, "."));
                        this.tokens.copyToken();
                        this.tokens.copyToken();
                        this.rootTransformer.processBalancedCode();
                        this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
                        this.tokens.appendCode(";}");
                        followsNonHoistedJestCall = false;
                    } else {
                        // This is a non-hoisted method, so just transform the code as usual.
                        if (followsNonHoistedJestCall) // If we didn't hoist the previous call, we can leave the code as-is to chain off of the
                        // previous method call. It's important to preserve the code here because we don't know
                        // for sure that the method actually returned the jest object for chaining.
                        this.tokens.copyToken();
                        else // If we hoisted the previous call, we know it returns the jest object back, so we insert
                        // the identifier `jest` to continue the chain.
                        this.tokens.replaceToken("".concat($92709096ffea6ef7$var$JEST_GLOBAL_NAME, "."));
                        this.tokens.copyToken();
                        this.tokens.copyToken();
                        this.rootTransformer.processBalancedCode();
                        this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
                        followsNonHoistedJestCall = true;
                    }
                }
                return true;
            }
        }
    ]);
    return JestHoistTransformer;
}((0, $8757da14f0d3faf0$export$2e2bcd8739ae039));




var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");


var $b46aec32bb446bca$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Transformer) {
    "use strict";
    (0, $hdIku._)(NumericSeparatorTransformer, Transformer);
    function NumericSeparatorTransformer(tokens) {
        (0, $173N4._)(this, NumericSeparatorTransformer);
        var _this;
        _this = (0, $7qXGD._)(this, NumericSeparatorTransformer);
        _this.tokens = tokens;
        return _this;
    }
    (0, $cFHGC._)(NumericSeparatorTransformer, [
        {
            key: "process",
            value: function process() {
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).num)) {
                    var code = this.tokens.currentTokenCode();
                    if (code.includes("_")) {
                        this.tokens.replaceToken(code.replace(/_/g, ""));
                        return true;
                    }
                }
                return false;
            }
        }
    ]);
    return NumericSeparatorTransformer;
}((0, $8757da14f0d3faf0$export$2e2bcd8739ae039));



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");


var $4e877a7ee19f5c8e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Transformer) {
    "use strict";
    (0, $hdIku._)(OptionalCatchBindingTransformer, Transformer);
    function OptionalCatchBindingTransformer(tokens, nameManager) {
        (0, $173N4._)(this, OptionalCatchBindingTransformer);
        var _this;
        _this = (0, $7qXGD._)(this, OptionalCatchBindingTransformer);
        _this.tokens = tokens;
        _this.nameManager = nameManager;
        return _this;
    }
    (0, $cFHGC._)(OptionalCatchBindingTransformer, [
        {
            key: "process",
            value: function process() {
                if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._catch, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) {
                    this.tokens.copyToken();
                    this.tokens.appendCode(" (".concat(this.nameManager.claimFreeName("e"), ")"));
                    return true;
                }
                return false;
            }
        }
    ]);
    return OptionalCatchBindingTransformer;
}((0, $8757da14f0d3faf0$export$2e2bcd8739ae039));



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");


var $d4f6f045763f2ea2$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Transformer) {
    "use strict";
    (0, $hdIku._)(OptionalChainingNullishTransformer, Transformer);
    function OptionalChainingNullishTransformer(tokens, nameManager) {
        (0, $173N4._)(this, OptionalChainingNullishTransformer);
        var _this;
        _this = (0, $7qXGD._)(this, OptionalChainingNullishTransformer);
        _this.tokens = tokens;
        _this.nameManager = nameManager;
        return _this;
    }
    (0, $cFHGC._)(OptionalChainingNullishTransformer, [
        {
            key: "process",
            value: function process() {
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).nullishCoalescing)) {
                    var token = this.tokens.currentToken();
                    if (this.tokens.tokens[token.nullishStartIndex].isAsyncOperation) this.tokens.replaceTokenTrimmingLeftWhitespace(", async () => (");
                    else this.tokens.replaceTokenTrimmingLeftWhitespace(", () => (");
                    return true;
                }
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._delete)) {
                    var nextToken = this.tokens.tokenAtRelativeIndex(1);
                    if (nextToken.isOptionalChainStart) {
                        this.tokens.removeInitialToken();
                        return true;
                    }
                }
                var token1 = this.tokens.currentToken();
                var chainStart = token1.subscriptStartIndex;
                if (chainStart != null && this.tokens.tokens[chainStart].isOptionalChainStart && // Super subscripts can't be optional (since super is never null/undefined), and the syntax
                // relies on the subscript being intact, so leave this token alone.
                this.tokens.tokenAtRelativeIndex(-1).type !== (0, $30a0d13de21d779e$export$f435f793048e7a0f)._super) {
                    var param = this.nameManager.claimFreeName("_");
                    var arrowStartSnippet;
                    if (chainStart > 0 && this.tokens.matches1AtIndex(chainStart - 1, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._delete) && this.isLastSubscriptInChain()) // Delete operations are special: we already removed the delete keyword, and to still
                    // perform a delete, we need to insert a delete in the very last part of the chain, which
                    // in correct code will always be a property access.
                    arrowStartSnippet = "".concat(param, " => delete ").concat(param);
                    else arrowStartSnippet = "".concat(param, " => ").concat(param);
                    if (this.tokens.tokens[chainStart].isAsyncOperation) arrowStartSnippet = "async ".concat(arrowStartSnippet);
                    if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f).questionDot, (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL) || this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f).questionDot, (0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan)) {
                        if (this.justSkippedSuper()) this.tokens.appendCode(".bind(this)");
                        this.tokens.replaceTokenTrimmingLeftWhitespace(", 'optionalCall', ".concat(arrowStartSnippet));
                    } else if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f).questionDot, (0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL)) this.tokens.replaceTokenTrimmingLeftWhitespace(", 'optionalAccess', ".concat(arrowStartSnippet));
                    else if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).questionDot)) this.tokens.replaceTokenTrimmingLeftWhitespace(", 'optionalAccess', ".concat(arrowStartSnippet, "."));
                    else if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).dot)) this.tokens.replaceTokenTrimmingLeftWhitespace(", 'access', ".concat(arrowStartSnippet, "."));
                    else if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL)) this.tokens.replaceTokenTrimmingLeftWhitespace(", 'access', ".concat(arrowStartSnippet, "["));
                    else if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) {
                        if (this.justSkippedSuper()) this.tokens.appendCode(".bind(this)");
                        this.tokens.replaceTokenTrimmingLeftWhitespace(", 'call', ".concat(arrowStartSnippet, "("));
                    } else throw new Error("Unexpected subscript operator in optional chain.");
                    return true;
                }
                return false;
            }
        },
        {
            /**
   * Determine if the current token is the last of its chain, so that we know whether it's eligible
   * to have a delete op inserted.
   *
   * We can do this by walking forward until we determine one way or another. Each
   * isOptionalChainStart token must be paired with exactly one isOptionalChainEnd token after it in
   * a nesting way, so we can track depth and walk to the end of the chain (the point where the
   * depth goes negative) and see if any other subscript token is after us in the chain.
   */ key: "isLastSubscriptInChain",
            value: function isLastSubscriptInChain() {
                var depth = 0;
                for(var i = this.tokens.currentIndex() + 1;; i++){
                    if (i >= this.tokens.tokens.length) throw new Error("Reached the end of the code while finding the end of the access chain.");
                    if (this.tokens.tokens[i].isOptionalChainStart) depth++;
                    else if (this.tokens.tokens[i].isOptionalChainEnd) depth--;
                    if (depth < 0) return true;
                    // This subscript token is a later one in the same chain.
                    if (depth === 0 && this.tokens.tokens[i].subscriptStartIndex != null) return false;
                }
            }
        },
        {
            /**
   * Determine if we are the open-paren in an expression like super.a()?.b.
   *
   * We can do this by walking backward to find the previous subscript. If that subscript was
   * preceded by a super, then we must be the subscript after it, so if this is a call expression,
   * we'll need to attach the right context.
   */ key: "justSkippedSuper",
            value: function justSkippedSuper() {
                var depth = 0;
                var index = this.tokens.currentIndex() - 1;
                while(true){
                    if (index < 0) throw new Error("Reached the start of the code while finding the start of the access chain.");
                    if (this.tokens.tokens[index].isOptionalChainStart) depth--;
                    else if (this.tokens.tokens[index].isOptionalChainEnd) depth++;
                    if (depth < 0) return false;
                    // This subscript token is a later one in the same chain.
                    if (depth === 0 && this.tokens.tokens[index].subscriptStartIndex != null) return this.tokens.tokens[index - 1].type === (0, $30a0d13de21d779e$export$f435f793048e7a0f)._super;
                    index--;
                }
            }
        }
    ]);
    return OptionalChainingNullishTransformer;
}((0, $8757da14f0d3faf0$export$2e2bcd8739ae039));



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");



var $7328f8940300cc2f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Transformer) {
    "use strict";
    (0, $hdIku._)(ReactDisplayNameTransformer, Transformer);
    function ReactDisplayNameTransformer(rootTransformer, tokens, importProcessor, options) {
        (0, $173N4._)(this, ReactDisplayNameTransformer);
        var _this;
        _this = (0, $7qXGD._)(this, ReactDisplayNameTransformer);
        _this.rootTransformer = rootTransformer;
        _this.tokens = tokens;
        _this.importProcessor = importProcessor;
        _this.options = options;
        return _this;
    }
    (0, $cFHGC._)(ReactDisplayNameTransformer, [
        {
            key: "process",
            value: function process() {
                var startIndex = this.tokens.currentIndex();
                if (this.tokens.identifierName() === "createReactClass") {
                    var newName = this.importProcessor && this.importProcessor.getIdentifierReplacement("createReactClass");
                    if (newName) this.tokens.replaceToken("(0, ".concat(newName, ")"));
                    else this.tokens.copyToken();
                    this.tryProcessCreateClassCall(startIndex);
                    return true;
                }
                if (this.tokens.matches3((0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).dot, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) && this.tokens.identifierName() === "React" && this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 2) === "createClass") {
                    var newName1 = this.importProcessor ? this.importProcessor.getIdentifierReplacement("React") || "React" : "React";
                    if (newName1) {
                        this.tokens.replaceToken(newName1);
                        this.tokens.copyToken();
                        this.tokens.copyToken();
                    } else {
                        this.tokens.copyToken();
                        this.tokens.copyToken();
                        this.tokens.copyToken();
                    }
                    this.tryProcessCreateClassCall(startIndex);
                    return true;
                }
                return false;
            }
        },
        {
            /**
   * This is called with the token position at the open-paren.
   */ key: "tryProcessCreateClassCall",
            value: function tryProcessCreateClassCall(startIndex) {
                var displayName = this.findDisplayName(startIndex);
                if (!displayName) return;
                if (this.classNeedsDisplayName()) {
                    this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL);
                    this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
                    this.tokens.appendCode("displayName: '".concat(displayName, "',"));
                    this.rootTransformer.processBalancedCode();
                    this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR);
                    this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
                }
            }
        },
        {
            key: "findDisplayName",
            value: function findDisplayName(startIndex) {
                if (startIndex < 2) return null;
                if (this.tokens.matches2AtIndex(startIndex - 2, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) // This is an assignment (or declaration) and the LHS is either an identifier or a member
                // expression ending in an identifier, so use that identifier name.
                return this.tokens.identifierNameAtIndex(startIndex - 2);
                if (startIndex >= 2 && this.tokens.tokens[startIndex - 2].identifierRole === (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ObjectKey) // This is an object literal value.
                return this.tokens.identifierNameAtIndex(startIndex - 2);
                if (this.tokens.matches2AtIndex(startIndex - 2, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._default)) return this.getDisplayNameFromFilename();
                return null;
            }
        },
        {
            key: "getDisplayNameFromFilename",
            value: function getDisplayNameFromFilename() {
                var filePath = this.options.filePath || "unknown";
                var pathSegments = filePath.split("/");
                var filename = pathSegments[pathSegments.length - 1];
                var dotIndex = filename.lastIndexOf(".");
                var baseFilename = dotIndex === -1 ? filename : filename.slice(0, dotIndex);
                if (baseFilename === "index" && pathSegments[pathSegments.length - 2]) return pathSegments[pathSegments.length - 2];
                else return baseFilename;
            }
        },
        {
            /**
   * We only want to add a display name when this is a function call containing
   * one argument, which is an object literal without `displayName` as an
   * existing key.
   */ key: "classNeedsDisplayName",
            value: function classNeedsDisplayName() {
                var index = this.tokens.currentIndex();
                if (!this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) return false;
                // The block starts on the {, and we expect any displayName key to be in
                // that context. We need to ignore other other contexts to avoid matching
                // nested displayName keys.
                var objectStartIndex = index + 1;
                var objectContextId = this.tokens.tokens[objectStartIndex].contextId;
                if (objectContextId == null) throw new Error("Expected non-null context ID on object open-brace.");
                for(; index < this.tokens.tokens.length; index++){
                    var token = this.tokens.tokens[index];
                    if (token.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR && token.contextId === objectContextId) {
                        index++;
                        break;
                    }
                    if (this.tokens.identifierNameAtIndex(index) === "displayName" && this.tokens.tokens[index].identifierRole === (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ObjectKey && token.contextId === objectContextId) // We found a displayName key, so bail out.
                    return false;
                }
                if (index === this.tokens.tokens.length) throw new Error("Unexpected end of input when processing React class.");
                // If we got this far, we know we have createClass with an object with no
                // display name, so we want to proceed as long as that was the only argument.
                return this.tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR) || this.tokens.matches2AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).comma, (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR);
            }
        }
    ]);
    return ReactDisplayNameTransformer;
}((0, $8757da14f0d3faf0$export$2e2bcd8739ae039));



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");


var $f102aa61ffb655cf$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Transformer) {
    "use strict";
    (0, $hdIku._)(ReactHotLoaderTransformer, Transformer);
    function ReactHotLoaderTransformer(tokens, filePath) {
        (0, $173N4._)(this, ReactHotLoaderTransformer);
        var _this;
        _this = (0, $7qXGD._)(this, ReactHotLoaderTransformer);
        _this.tokens = tokens;
        _this.filePath = filePath;
        ReactHotLoaderTransformer.prototype.__init.call(_this);
        return _this;
    }
    (0, $cFHGC._)(ReactHotLoaderTransformer, [
        {
            key: "__init",
            value: function __init() {
                this.extractedDefaultExportName = null;
            }
        },
        {
            key: "setExtractedDefaultExportName",
            value: function setExtractedDefaultExportName(extractedDefaultExportName) {
                this.extractedDefaultExportName = extractedDefaultExportName;
            }
        },
        {
            key: "getPrefixCode",
            value: function getPrefixCode() {
                return "\n      (function () {\n        var enterModule = require('react-hot-loader').enterModule;\n        enterModule && enterModule(module);\n      })();".replace(/\s+/g, " ").trim();
            }
        },
        {
            key: "getSuffixCode",
            value: function getSuffixCode() {
                var _this = this;
                var topLevelNames = new Set();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.tokens.tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var token = _step.value;
                        if (!token.isType && (0, $e2df986cc8bbbda9$export$c08b4dec8c3c03d)(token) && token.identifierRole !== (0, $e2df986cc8bbbda9$export$99f888ada3c99de3).ImportDeclaration) topLevelNames.add(this.tokens.identifierNameForToken(token));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var namesToRegister = Array.from(topLevelNames).map(function(name) {
                    return {
                        variableName: name,
                        uniqueLocalName: name
                    };
                });
                if (this.extractedDefaultExportName) namesToRegister.push({
                    variableName: this.extractedDefaultExportName,
                    uniqueLocalName: "default"
                });
                return "\n;(function () {\n  var reactHotLoader = require('react-hot-loader').default;\n  var leaveModule = require('react-hot-loader').leaveModule;\n  if (!reactHotLoader) {\n    return;\n  }\n".concat(namesToRegister.map(function(param) {
                    var variableName = param.variableName, uniqueLocalName = param.uniqueLocalName;
                    return "  reactHotLoader.register(".concat(variableName, ', "').concat(uniqueLocalName, '", ').concat(JSON.stringify(_this.filePath || ""), ");");
                }).join("\n"), "\n  leaveModule(module);\n})();");
            }
        },
        {
            key: "process",
            value: function process() {
                return false;
            }
        }
    ]);
    return ReactHotLoaderTransformer;
}((0, $8757da14f0d3faf0$export$2e2bcd8739ae039));



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");


// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Lexical_grammar
// Hard-code a list of reserved words rather than trying to use keywords or contextual keywords
// from the parser, since currently there are various exceptions, like `package` being reserved
// but unused and various contextual keywords being reserved. Note that we assume that all code
// compiled by Sucrase is in a module, so strict mode words and await are all considered reserved
// here.
var $9713f7853ea221f8$var$RESERVED_WORDS = new Set([
    // Reserved keywords as of ECMAScript 2015
    "break",
    "case",
    "catch",
    "class",
    "const",
    "continue",
    "debugger",
    "default",
    "delete",
    "do",
    "else",
    "export",
    "extends",
    "finally",
    "for",
    "function",
    "if",
    "import",
    "in",
    "instanceof",
    "new",
    "return",
    "super",
    "switch",
    "this",
    "throw",
    "try",
    "typeof",
    "var",
    "void",
    "while",
    "with",
    "yield",
    // Future reserved keywords
    "enum",
    "implements",
    "interface",
    "let",
    "package",
    "private",
    "protected",
    "public",
    "static",
    "await",
    // Literals that cannot be used as identifiers
    "false",
    "null",
    "true"
]);
function $9713f7853ea221f8$export$2e2bcd8739ae039(name) {
    if (name.length === 0) return false;
    if (!(0, $c0e0280b0658a40b$export$dc1d1d7d9fdffb8)[name.charCodeAt(0)]) return false;
    for(var i = 1; i < name.length; i++){
        if (!(0, $c0e0280b0658a40b$export$d19df39e3926cfef)[name.charCodeAt(i)]) return false;
    }
    return !$9713f7853ea221f8$var$RESERVED_WORDS.has(name);
}



var $871ee556aea9d069$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Transformer) {
    "use strict";
    (0, $hdIku._)(TypeScriptTransformer, Transformer);
    function TypeScriptTransformer(rootTransformer, tokens, isImportsTransformEnabled) {
        (0, $173N4._)(this, TypeScriptTransformer);
        var _this;
        _this = (0, $7qXGD._)(this, TypeScriptTransformer);
        _this.rootTransformer = rootTransformer;
        _this.tokens = tokens;
        _this.isImportsTransformEnabled = isImportsTransformEnabled;
        return _this;
    }
    (0, $cFHGC._)(TypeScriptTransformer, [
        {
            key: "process",
            value: function process() {
                if (this.rootTransformer.processPossibleArrowParamEnd() || this.rootTransformer.processPossibleAsyncArrowWithTypeParams() || this.rootTransformer.processPossibleTypeRange()) return true;
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._public) || this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._protected) || this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._private) || this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._abstract) || this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._readonly) || this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._override) || this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).nonNullAssertion)) {
                    this.tokens.removeInitialToken();
                    return true;
                }
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._enum) || this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._const, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._enum)) {
                    this.processEnum();
                    return true;
                }
                if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._enum) || this.tokens.matches3((0, $30a0d13de21d779e$export$f435f793048e7a0f)._export, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._const, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._enum)) {
                    this.processEnum(true);
                    return true;
                }
                return false;
            }
        },
        {
            key: "processEnum",
            value: function processEnum() {
                var isExport = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                // We might have "export const enum", so just remove all relevant tokens.
                this.tokens.removeInitialToken();
                while(this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._const) || this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._enum))this.tokens.removeToken();
                var enumName = this.tokens.identifierName();
                this.tokens.removeToken();
                if (isExport && !this.isImportsTransformEnabled) this.tokens.appendCode("export ");
                this.tokens.appendCode("var ".concat(enumName, "; (function (").concat(enumName, ")"));
                this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
                this.processEnumBody(enumName);
                this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR);
                if (isExport && this.isImportsTransformEnabled) this.tokens.appendCode(")(".concat(enumName, " || (exports.").concat(enumName, " = ").concat(enumName, " = {}));"));
                else this.tokens.appendCode(")(".concat(enumName, " || (").concat(enumName, " = {}));"));
            }
        },
        {
            /**
   * Transform an enum into equivalent JS. This has complexity in a few places:
   * - TS allows string enums, numeric enums, and a mix of the two styles within an enum.
   * - Enum keys are allowed to be referenced in later enum values.
   * - Enum keys are allowed to be strings.
   * - When enum values are omitted, they should follow an auto-increment behavior.
   */ key: "processEnumBody",
            value: function processEnumBody(enumName) {
                // Code that can be used to reference the previous enum member, or null if this is the first
                // enum member.
                var previousValueCode = null;
                while(true){
                    if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) break;
                    var _this_extractEnumKeyInfo = this.extractEnumKeyInfo(this.tokens.currentToken()), nameStringCode = _this_extractEnumKeyInfo.nameStringCode, variableName = _this_extractEnumKeyInfo.variableName;
                    this.tokens.removeInitialToken();
                    if (this.tokens.matches3((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq, (0, $30a0d13de21d779e$export$f435f793048e7a0f).string, (0, $30a0d13de21d779e$export$f435f793048e7a0f).comma) || this.tokens.matches3((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq, (0, $30a0d13de21d779e$export$f435f793048e7a0f).string, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) this.processStringLiteralEnumMember(enumName, nameStringCode, variableName);
                    else if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) this.processExplicitValueEnumMember(enumName, nameStringCode, variableName);
                    else this.processImplicitValueEnumMember(enumName, nameStringCode, variableName, previousValueCode);
                    if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) this.tokens.removeToken();
                    if (variableName != null) previousValueCode = variableName;
                    else previousValueCode = "".concat(enumName, "[").concat(nameStringCode, "]");
                }
            }
        },
        {
            /**
   * Detect name information about this enum key, which will be used to determine which code to emit
   * and whether we should declare a variable as part of this declaration.
   *
   * Some cases to keep in mind:
   * - Enum keys can be implicitly referenced later, e.g. `X = 1, Y = X`. In Sucrase, we implement
   *   this by declaring a variable `X` so that later expressions can use it.
   * - In addition to the usual identifier key syntax, enum keys are allowed to be string literals,
   *   e.g. `"hello world" = 3,`. Template literal syntax is NOT allowed.
   * - Even if the enum key is defined as a string literal, it may still be referenced by identifier
   *   later, e.g. `"X" = 1, Y = X`. That means that we need to detect whether or not a string
   *   literal is identifier-like and emit a variable if so, even if the declaration did not use an
   *   identifier.
   * - Reserved keywords like `break` are valid enum keys, but are not valid to be referenced later
   *   and would be a syntax error if we emitted a variable, so we need to skip the variable
   *   declaration in those cases.
   *
   * The variableName return value captures these nuances: if non-null, we can and must emit a
   * variable declaration, and if null, we can't and shouldn't.
   */ key: "extractEnumKeyInfo",
            value: function extractEnumKeyInfo(nameToken) {
                if (nameToken.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).name) {
                    var name = this.tokens.identifierNameForToken(nameToken);
                    return {
                        nameStringCode: '"'.concat(name, '"'),
                        variableName: (0, $9713f7853ea221f8$export$2e2bcd8739ae039)(name) ? name : null
                    };
                } else if (nameToken.type === (0, $30a0d13de21d779e$export$f435f793048e7a0f).string) {
                    var name1 = this.tokens.stringValueForToken(nameToken);
                    return {
                        nameStringCode: this.tokens.code.slice(nameToken.start, nameToken.end),
                        variableName: (0, $9713f7853ea221f8$export$2e2bcd8739ae039)(name1) ? name1 : null
                    };
                } else throw new Error("Expected name or string at beginning of enum element.");
            }
        },
        {
            /**
   * Handle an enum member where the RHS is just a string literal (not omitted, not a number, and
   * not a complex expression). This is the typical form for TS string enums, and in this case, we
   * do *not* create a reverse mapping.
   *
   * This is called after deleting the key token, when the token processor is at the equals sign.
   *
   * Example 1:
   * someKey = "some value"
   * ->
   * const someKey = "some value"; MyEnum["someKey"] = someKey;
   *
   * Example 2:
   * "some key" = "some value"
   * ->
   * MyEnum["some key"] = "some value";
   */ key: "processStringLiteralEnumMember",
            value: function processStringLiteralEnumMember(enumName, nameStringCode, variableName) {
                if (variableName != null) {
                    this.tokens.appendCode("const ".concat(variableName));
                    // =
                    this.tokens.copyToken();
                    // value string
                    this.tokens.copyToken();
                    this.tokens.appendCode("; ".concat(enumName, "[").concat(nameStringCode, "] = ").concat(variableName, ";"));
                } else {
                    this.tokens.appendCode("".concat(enumName, "[").concat(nameStringCode, "]"));
                    // =
                    this.tokens.copyToken();
                    // value string
                    this.tokens.copyToken();
                    this.tokens.appendCode(";");
                }
            }
        },
        {
            /**
   * Handle an enum member initialized with an expression on the right-hand side (other than a
   * string literal). In these cases, we should transform the expression and emit code that sets up
   * a reverse mapping.
   *
   * The TypeScript implementation of this operation distinguishes between expressions that can be
   * "constant folded" at compile time (i.e. consist of number literals and simple math operations
   * on those numbers) and ones that are dynamic. For constant expressions, it emits the resolved
   * numeric value, and auto-incrementing is only allowed in that case. Evaluating expressions at
   * compile time would add significant complexity to Sucrase, so Sucrase instead leaves the
   * expression as-is, and will later emit something like `MyEnum["previousKey"] + 1` to implement
   * auto-incrementing.
   *
   * This is called after deleting the key token, when the token processor is at the equals sign.
   *
   * Example 1:
   * someKey = 1 + 1
   * ->
   * const someKey = 1 + 1; MyEnum[MyEnum["someKey"] = someKey] = "someKey";
   *
   * Example 2:
   * "some key" = 1 + 1
   * ->
   * MyEnum[MyEnum["some key"] = 1 + 1] = "some key";
   */ key: "processExplicitValueEnumMember",
            value: function processExplicitValueEnumMember(enumName, nameStringCode, variableName) {
                var rhsEndIndex = this.tokens.currentToken().rhsEndIndex;
                if (rhsEndIndex == null) throw new Error("Expected rhsEndIndex on enum assign.");
                if (variableName != null) {
                    this.tokens.appendCode("const ".concat(variableName));
                    this.tokens.copyToken();
                    while(this.tokens.currentIndex() < rhsEndIndex)this.rootTransformer.processToken();
                    this.tokens.appendCode("; ".concat(enumName, "[").concat(enumName, "[").concat(nameStringCode, "] = ").concat(variableName, "] = ").concat(nameStringCode, ";"));
                } else {
                    this.tokens.appendCode("".concat(enumName, "[").concat(enumName, "[").concat(nameStringCode, "]"));
                    this.tokens.copyToken();
                    while(this.tokens.currentIndex() < rhsEndIndex)this.rootTransformer.processToken();
                    this.tokens.appendCode("] = ".concat(nameStringCode, ";"));
                }
            }
        },
        {
            /**
   * Handle an enum member with no right-hand side expression. In this case, the value is the
   * previous value plus 1, or 0 if there was no previous value. We should also always emit a
   * reverse mapping.
   *
   * Example 1:
   * someKey2
   * ->
   * const someKey2 = someKey1 + 1; MyEnum[MyEnum["someKey2"] = someKey2] = "someKey2";
   *
   * Example 2:
   * "some key 2"
   * ->
   * MyEnum[MyEnum["some key 2"] = someKey1 + 1] = "some key 2";
   */ key: "processImplicitValueEnumMember",
            value: function processImplicitValueEnumMember(enumName, nameStringCode, variableName, previousValueCode) {
                var valueCode = previousValueCode != null ? "".concat(previousValueCode, " + 1") : "0";
                if (variableName != null) {
                    this.tokens.appendCode("const ".concat(variableName, " = ").concat(valueCode, "; "));
                    valueCode = variableName;
                }
                this.tokens.appendCode("".concat(enumName, "[").concat(enumName, "[").concat(nameStringCode, "] = ").concat(valueCode, "] = ").concat(nameStringCode, ";"));
            }
        }
    ]);
    return TypeScriptTransformer;
}((0, $8757da14f0d3faf0$export$2e2bcd8739ae039));


var $7d6fd1b1d8441ecc$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function RootTransformer(sucraseContext, transforms, enableLegacyBabel5ModuleInterop, options) {
        (0, $173N4._)(this, RootTransformer);
        RootTransformer.prototype.__init.call(this);
        RootTransformer.prototype.__init2.call(this);
        this.nameManager = sucraseContext.nameManager;
        this.helperManager = sucraseContext.helperManager;
        var tokenProcessor = sucraseContext.tokenProcessor, importProcessor = sucraseContext.importProcessor;
        this.tokens = tokenProcessor;
        this.isImportsTransformEnabled = transforms.includes("imports");
        this.isReactHotLoaderTransformEnabled = transforms.includes("react-hot-loader");
        this.disableESTransforms = Boolean(options.disableESTransforms);
        if (!options.disableESTransforms) {
            this.transformers.push(new (0, $d4f6f045763f2ea2$export$2e2bcd8739ae039)(tokenProcessor, this.nameManager));
            this.transformers.push(new (0, $b46aec32bb446bca$export$2e2bcd8739ae039)(tokenProcessor));
            this.transformers.push(new (0, $4e877a7ee19f5c8e$export$2e2bcd8739ae039)(tokenProcessor, this.nameManager));
        }
        if (transforms.includes("jsx")) {
            if (options.jsxRuntime !== "preserve") this.transformers.push(new (0, $9619a3b5c46ce6b8$export$2e2bcd8739ae039)(this, tokenProcessor, importProcessor, this.nameManager, options));
            this.transformers.push(new (0, $7328f8940300cc2f$export$2e2bcd8739ae039)(this, tokenProcessor, importProcessor, options));
        }
        var reactHotLoaderTransformer = null;
        if (transforms.includes("react-hot-loader")) {
            if (!options.filePath) throw new Error("filePath is required when using the react-hot-loader transform.");
            reactHotLoaderTransformer = new (0, $f102aa61ffb655cf$export$2e2bcd8739ae039)(tokenProcessor, options.filePath);
            this.transformers.push(reactHotLoaderTransformer);
        }
        // Note that we always want to enable the imports transformer, even when the import transform
        // itself isn't enabled, since we need to do type-only import pruning for both Flow and
        // TypeScript.
        if (transforms.includes("imports")) {
            if (importProcessor === null) throw new Error("Expected non-null importProcessor with imports transform enabled.");
            this.transformers.push(new (0, $b176b2eb478eac92$export$2e2bcd8739ae039)(this, tokenProcessor, importProcessor, this.nameManager, this.helperManager, reactHotLoaderTransformer, enableLegacyBabel5ModuleInterop, Boolean(options.enableLegacyTypeScriptModuleInterop), transforms.includes("typescript"), transforms.includes("flow"), Boolean(options.preserveDynamicImport), Boolean(options.keepUnusedImports)));
        } else this.transformers.push(new (0, $ae865af7cb421f92$export$2e2bcd8739ae039)(tokenProcessor, this.nameManager, this.helperManager, reactHotLoaderTransformer, transforms.includes("typescript"), transforms.includes("flow"), Boolean(options.keepUnusedImports), options));
        if (transforms.includes("flow")) this.transformers.push(new (0, $766644b25b9d5ae2$export$2e2bcd8739ae039)(this, tokenProcessor, transforms.includes("imports")));
        if (transforms.includes("typescript")) this.transformers.push(new (0, $871ee556aea9d069$export$2e2bcd8739ae039)(this, tokenProcessor, transforms.includes("imports")));
        if (transforms.includes("jest")) this.transformers.push(new (0, $92709096ffea6ef7$export$2e2bcd8739ae039)(this, tokenProcessor, this.nameManager, importProcessor));
    }
    (0, $cFHGC._)(RootTransformer, [
        {
            key: "__init",
            value: function __init() {
                this.transformers = [];
            }
        },
        {
            key: "__init2",
            value: function __init2() {
                this.generatedVariables = [];
            }
        },
        {
            key: "transform",
            value: function transform() {
                this.tokens.reset();
                this.processBalancedCode();
                var shouldAddUseStrict = this.isImportsTransformEnabled;
                // "use strict" always needs to be first, so override the normal transformer order.
                var prefix = shouldAddUseStrict ? '"use strict";' : "";
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.transformers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var transformer = _step.value;
                        prefix += transformer.getPrefixCode();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                prefix += this.helperManager.emitHelpers();
                prefix += this.generatedVariables.map(function(v) {
                    return " var ".concat(v, ";");
                }).join("");
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = this.transformers[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var transformer1 = _step1.value;
                        prefix += transformer1.getHoistedCode();
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                var suffix = "";
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = this.transformers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var transformer2 = _step2.value;
                        suffix += transformer2.getSuffixCode();
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
                var result = this.tokens.finish();
                var code = result.code;
                if (code.startsWith("#!")) {
                    var newlineIndex = code.indexOf("\n");
                    if (newlineIndex === -1) {
                        newlineIndex = code.length;
                        code += "\n";
                    }
                    return {
                        code: code.slice(0, newlineIndex + 1) + prefix + code.slice(newlineIndex + 1) + suffix,
                        // The hashbang line has no tokens, so shifting the tokens to account
                        // for prefix can happen normally.
                        mappings: this.shiftMappings(result.mappings, prefix.length)
                    };
                } else return {
                    code: prefix + code + suffix,
                    mappings: this.shiftMappings(result.mappings, prefix.length)
                };
            }
        },
        {
            key: "processBalancedCode",
            value: function processBalancedCode() {
                var braceDepth = 0;
                var parenDepth = 0;
                while(!this.tokens.isAtEnd()){
                    if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL) || this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).dollarBraceL)) braceDepth++;
                    else if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) {
                        if (braceDepth === 0) return;
                        braceDepth--;
                    }
                    if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) parenDepth++;
                    else if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR)) {
                        if (parenDepth === 0) return;
                        parenDepth--;
                    }
                    this.processToken();
                }
            }
        },
        {
            key: "processToken",
            value: function processToken() {
                if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._class)) {
                    this.processClass();
                    return;
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.transformers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var transformer = _step.value;
                        var wasProcessed = transformer.process();
                        if (wasProcessed) return;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.tokens.copyToken();
            }
        },
        {
            /**
   * Skip past a class with a name and return that name.
   */ key: "processNamedClass",
            value: function processNamedClass() {
                if (!this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f)._class, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) throw new Error("Expected identifier for exported class name.");
                var name = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
                this.processClass();
                return name;
            }
        },
        {
            key: "processClass",
            value: function processClass() {
                var classInfo = (0, $5cc1ddf63d070d97$export$2e2bcd8739ae039)(this, this.tokens, this.nameManager, this.disableESTransforms);
                // Both static and instance initializers need a class name to use to invoke the initializer, so
                // assign to one if necessary.
                var needsCommaExpression = (classInfo.headerInfo.isExpression || !classInfo.headerInfo.className) && classInfo.staticInitializerNames.length + classInfo.instanceInitializerNames.length > 0;
                var className = classInfo.headerInfo.className;
                if (needsCommaExpression) {
                    className = this.nameManager.claimFreeName("_class");
                    this.generatedVariables.push(className);
                    this.tokens.appendCode(" (".concat(className, " ="));
                }
                var classToken = this.tokens.currentToken();
                var contextId = classToken.contextId;
                if (contextId == null) throw new Error("Expected class to have a context ID.");
                this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f)._class);
                while(!this.tokens.matchesContextIdAndLabel((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL, contextId))this.processToken();
                this.processClassBody(classInfo, className);
                var staticInitializerStatements = classInfo.staticInitializerNames.map(function(name) {
                    return "".concat(className, ".").concat(name, "()");
                });
                if (needsCommaExpression) this.tokens.appendCode(", ".concat(staticInitializerStatements.map(function(s) {
                    return "".concat(s, ", ");
                }).join("")).concat(className, ")"));
                else if (classInfo.staticInitializerNames.length > 0) this.tokens.appendCode(" ".concat(staticInitializerStatements.map(function(s) {
                    return "".concat(s, ";");
                }).join(" ")));
            }
        },
        {
            /**
   * We want to just handle class fields in all contexts, since TypeScript supports them. Later,
   * when some JS implementations support class fields, this should be made optional.
   */ key: "processClassBody",
            value: function processClassBody(classInfo, className) {
                var headerInfo = classInfo.headerInfo, constructorInsertPos = classInfo.constructorInsertPos, constructorInitializerStatements = classInfo.constructorInitializerStatements, fields = classInfo.fields, instanceInitializerNames = classInfo.instanceInitializerNames, rangesToRemove = classInfo.rangesToRemove;
                var fieldIndex = 0;
                var rangeToRemoveIndex = 0;
                var classContextId = this.tokens.currentToken().contextId;
                if (classContextId == null) throw new Error("Expected non-null context ID on class.");
                this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL);
                if (this.isReactHotLoaderTransformEnabled) this.tokens.appendCode("__reactstandin__regenerateByEval(key, code) {this[key] = eval(code);}");
                var needsConstructorInit = constructorInitializerStatements.length + instanceInitializerNames.length > 0;
                if (constructorInsertPos === null && needsConstructorInit) {
                    var constructorInitializersCode = this.makeConstructorInitCode(constructorInitializerStatements, instanceInitializerNames, className);
                    if (headerInfo.hasSuperclass) {
                        var argsName = this.nameManager.claimFreeName("args");
                        this.tokens.appendCode("constructor(...".concat(argsName, ") { super(...").concat(argsName, "); ").concat(constructorInitializersCode, "; }"));
                    } else this.tokens.appendCode("constructor() { ".concat(constructorInitializersCode, "; }"));
                }
                while(!this.tokens.matchesContextIdAndLabel((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR, classContextId)){
                    if (fieldIndex < fields.length && this.tokens.currentIndex() === fields[fieldIndex].start) {
                        var needsCloseBrace = false;
                        if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).bracketL)) this.tokens.copyTokenWithPrefix("".concat(fields[fieldIndex].initializerName, "() {this"));
                        else if (this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).string) || this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f).num)) {
                            this.tokens.copyTokenWithPrefix("".concat(fields[fieldIndex].initializerName, "() {this["));
                            needsCloseBrace = true;
                        } else this.tokens.copyTokenWithPrefix("".concat(fields[fieldIndex].initializerName, "() {this."));
                        while(this.tokens.currentIndex() < fields[fieldIndex].end){
                            if (needsCloseBrace && this.tokens.currentIndex() === fields[fieldIndex].equalsIndex) this.tokens.appendCode("]");
                            this.processToken();
                        }
                        this.tokens.appendCode("}");
                        fieldIndex++;
                    } else if (rangeToRemoveIndex < rangesToRemove.length && this.tokens.currentIndex() >= rangesToRemove[rangeToRemoveIndex].start) {
                        if (this.tokens.currentIndex() < rangesToRemove[rangeToRemoveIndex].end) this.tokens.removeInitialToken();
                        while(this.tokens.currentIndex() < rangesToRemove[rangeToRemoveIndex].end)this.tokens.removeToken();
                        rangeToRemoveIndex++;
                    } else if (this.tokens.currentIndex() === constructorInsertPos) {
                        this.tokens.copyToken();
                        if (needsConstructorInit) this.tokens.appendCode(";".concat(this.makeConstructorInitCode(constructorInitializerStatements, instanceInitializerNames, className), ";"));
                        this.processToken();
                    } else this.processToken();
                }
                this.tokens.copyExpectedToken((0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR);
            }
        },
        {
            key: "makeConstructorInitCode",
            value: function makeConstructorInitCode(constructorInitializerStatements, instanceInitializerNames, className) {
                return (0, $aUGqu._)(constructorInitializerStatements).concat((0, $aUGqu._)(instanceInitializerNames.map(function(name) {
                    return "".concat(className, ".prototype.").concat(name, ".call(this)");
                }))).join(";");
            }
        },
        {
            /**
   * Normally it's ok to simply remove type tokens, but we need to be more careful when dealing with
   * arrow function return types since they can confuse the parser. In that case, we want to move
   * the close-paren to the same line as the arrow.
   *
   * See https://github.com/alangpierce/sucrase/issues/391 for more details.
   */ key: "processPossibleArrowParamEnd",
            value: function processPossibleArrowParamEnd() {
                if (this.tokens.matches2((0, $30a0d13de21d779e$export$f435f793048e7a0f).parenR, (0, $30a0d13de21d779e$export$f435f793048e7a0f).colon) && this.tokens.tokenAtRelativeIndex(1).isType) {
                    var nextNonTypeIndex = this.tokens.currentIndex() + 1;
                    // Look ahead to see if this is an arrow function or something else.
                    while(this.tokens.tokens[nextNonTypeIndex].isType)nextNonTypeIndex++;
                    if (this.tokens.matches1AtIndex(nextNonTypeIndex, (0, $30a0d13de21d779e$export$f435f793048e7a0f).arrow)) {
                        this.tokens.removeInitialToken();
                        while(this.tokens.currentIndex() < nextNonTypeIndex)this.tokens.removeToken();
                        this.tokens.replaceTokenTrimmingLeftWhitespace(") =>");
                        return true;
                    }
                }
                return false;
            }
        },
        {
            /**
   * An async arrow function might be of the form:
   *
   * async <
   *   T
   * >() => {}
   *
   * in which case, removing the type parameters will cause a syntax error. Detect this case and
   * move the open-paren earlier.
   */ key: "processPossibleAsyncArrowWithTypeParams",
            value: function processPossibleAsyncArrowWithTypeParams() {
                if (!this.tokens.matchesContextual((0, $71dd7c884f6bca78$export$ee633ab6cd0138cc)._async) && !this.tokens.matches1((0, $30a0d13de21d779e$export$f435f793048e7a0f)._async)) return false;
                var nextToken = this.tokens.tokenAtRelativeIndex(1);
                if (nextToken.type !== (0, $30a0d13de21d779e$export$f435f793048e7a0f).lessThan || !nextToken.isType) return false;
                var nextNonTypeIndex = this.tokens.currentIndex() + 1;
                // Look ahead to see if this is an arrow function or something else.
                while(this.tokens.tokens[nextNonTypeIndex].isType)nextNonTypeIndex++;
                if (this.tokens.matches1AtIndex(nextNonTypeIndex, (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) {
                    this.tokens.replaceToken("async (");
                    this.tokens.removeInitialToken();
                    while(this.tokens.currentIndex() < nextNonTypeIndex)this.tokens.removeToken();
                    this.tokens.removeToken();
                    // We ate a ( token, so we need to process the tokens in between and then the ) token so that
                    // we remain balanced.
                    this.processBalancedCode();
                    this.processToken();
                    return true;
                }
                return false;
            }
        },
        {
            key: "processPossibleTypeRange",
            value: function processPossibleTypeRange() {
                if (this.tokens.currentToken().isType) {
                    this.tokens.removeInitialToken();
                    while(this.tokens.currentToken().isType)this.tokens.removeToken();
                    return true;
                }
                return false;
            }
        },
        {
            key: "shiftMappings",
            value: function shiftMappings(mappings, prefixLength) {
                for(var i = 0; i < mappings.length; i++){
                    var mapping = mappings[i];
                    if (mapping !== undefined) mappings[i] = mapping + prefixLength;
                }
                return mappings;
            }
        }
    ]);
    return RootTransformer;
}();



var $aUGqu = parcelRequire("aUGqu");
var $ae878a909bbfa795$export$1e511d4a378977f5;
var $ae878a909bbfa795$export$f2e513d2bc4a3b5a;
var $ae878a909bbfa795$export$2e2bcd8739ae039;
"use strict";
$ae878a909bbfa795$export$1e511d4a378977f5 = true;
$ae878a909bbfa795$export$f2e513d2bc4a3b5a = void 0;
var $ae878a909bbfa795$var$LF = '\n';
var $ae878a909bbfa795$var$CR = '\r';
var $ae878a909bbfa795$var$LinesAndColumns = /** @class */ function() {
    function LinesAndColumns(string) {
        this.string = string;
        var offsets = [
            0
        ];
        for(var offset = 0; offset < string.length;)switch(string[offset]){
            case $ae878a909bbfa795$var$LF:
                offset += $ae878a909bbfa795$var$LF.length;
                offsets.push(offset);
                break;
            case $ae878a909bbfa795$var$CR:
                offset += $ae878a909bbfa795$var$CR.length;
                if (string[offset] === $ae878a909bbfa795$var$LF) offset += $ae878a909bbfa795$var$LF.length;
                offsets.push(offset);
                break;
            default:
                offset++;
                break;
        }
        this.offsets = offsets;
    }
    LinesAndColumns.prototype.locationForIndex = function(index) {
        if (index < 0 || index > this.string.length) return null;
        var line = 0;
        var offsets = this.offsets;
        while(offsets[line + 1] <= index)line++;
        var column = index - offsets[line];
        return {
            line: line,
            column: column
        };
    };
    LinesAndColumns.prototype.indexForLocation = function(location) {
        var line = location.line, column = location.column;
        if (line < 0 || line >= this.offsets.length) return null;
        if (column < 0 || column > this.lengthOfLine(line)) return null;
        return this.offsets[line] + column;
    };
    LinesAndColumns.prototype.lengthOfLine = function(line) {
        var offset = this.offsets[line];
        var nextOffset = line === this.offsets.length - 1 ? this.string.length : this.offsets[line + 1];
        return nextOffset - offset;
    };
    return LinesAndColumns;
}();
$ae878a909bbfa795$export$f2e513d2bc4a3b5a = $ae878a909bbfa795$var$LinesAndColumns;
$ae878a909bbfa795$export$2e2bcd8739ae039 = $ae878a909bbfa795$var$LinesAndColumns;



function $a3f631c7db03a881$export$2e2bcd8739ae039(code, tokens) {
    if (tokens.length === 0) return "";
    var tokenKeys = Object.keys(tokens[0]).filter(function(k) {
        return k !== "type" && k !== "value" && k !== "start" && k !== "end" && k !== "loc";
    });
    var typeKeys = Object.keys(tokens[0].type).filter(function(k) {
        return k !== "label" && k !== "keyword";
    });
    var headings = [
        "Location",
        "Label",
        "Raw"
    ].concat((0, $aUGqu._)(tokenKeys), (0, $aUGqu._)(typeKeys));
    var lines = new (0, $ae878a909bbfa795$export$2e2bcd8739ae039)(code);
    var rows = [
        headings
    ].concat((0, $aUGqu._)(tokens.map(getTokenComponents)));
    var padding = headings.map(function() {
        return 0;
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var components = _step.value;
            for(var i = 0; i < components.length; i++)padding[i] = Math.max(padding[i], components[i].length);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return rows.map(function(components) {
        return components.map(function(component, i) {
            return component.padEnd(padding[i]);
        }).join(" ");
    }).join("\n");
    function getTokenComponents(token) {
        var raw = code.slice(token.start, token.end);
        return [
            formatRange(token.start, token.end),
            (0, $30a0d13de21d779e$export$b78065ce79336a93)(token.type),
            $a3f631c7db03a881$var$truncate(String(raw), 14)
        ].concat(// @ts-ignore: Intentional dynamic access by key.
        (0, $aUGqu._)(tokenKeys.map(function(key) {
            return formatValue(token[key], key);
        })), // @ts-ignore: Intentional dynamic access by key.
        (0, $aUGqu._)(typeKeys.map(function(key) {
            return formatValue(token.type[key], key);
        })));
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function formatValue(value, key) {
        if (value === true) return key;
        else if (value === false || value === null) return "";
        else return String(value);
    }
    function formatRange(start, end) {
        return "".concat(formatPos(start), "-").concat(formatPos(end));
    }
    function formatPos(pos) {
        var location = lines.locationForIndex(pos);
        if (!location) return "Unknown";
        else return "".concat(location.line + 1, ":").concat(location.column + 1);
    }
}
function $a3f631c7db03a881$var$truncate(s, length) {
    if (s.length > length) return "".concat(s.slice(0, length - 3), "...");
    else return s;
}




function $1c66a3f8d54033c7$export$2e2bcd8739ae039(tokens) {
    var importedNames = new Set();
    for(var i = 0; i < tokens.tokens.length; i++)if (tokens.matches1AtIndex(i, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._import) && !tokens.matches3AtIndex(i, (0, $30a0d13de21d779e$export$f435f793048e7a0f)._import, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name, (0, $30a0d13de21d779e$export$f435f793048e7a0f).eq)) $1c66a3f8d54033c7$var$collectNamesForImport(tokens, i, importedNames);
    return importedNames;
}
function $1c66a3f8d54033c7$var$collectNamesForImport(tokens, index, importedNames) {
    index++;
    if (tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).parenL)) // Dynamic import, so nothing to do
    return;
    if (tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).name)) {
        importedNames.add(tokens.identifierNameAtIndex(index));
        index++;
        if (tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) index++;
    }
    if (tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).star)) {
        // * as
        index += 2;
        importedNames.add(tokens.identifierNameAtIndex(index));
        index++;
    }
    if (tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceL)) {
        index++;
        $1c66a3f8d54033c7$var$collectNamesForNamedImport(tokens, index, importedNames);
    }
}
function $1c66a3f8d54033c7$var$collectNamesForNamedImport(tokens, index, importedNames) {
    while(true){
        if (tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) return;
        var specifierInfo = (0, $60f9e6aa148c791b$export$2e2bcd8739ae039)(tokens, index);
        index = specifierInfo.endIndex;
        if (!specifierInfo.isType) importedNames.add(specifierInfo.rightName);
        if (tokens.matches2AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).comma, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) return;
        else if (tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).braceR)) return;
        else if (tokens.matches1AtIndex(index, (0, $30a0d13de21d779e$export$f435f793048e7a0f).comma)) index++;
        else throw new Error("Unexpected token: ".concat(JSON.stringify(tokens.tokens[index])));
    }
}


function $18c9d56f5c9372a4$export$c506eb22e615ba4a() {
    /* istanbul ignore next */ return "3.35.1";
}
function $18c9d56f5c9372a4$export$51186ad6e864892a(code, options) {
    (0, $0296dc5ee5a905be$export$1dd09873c1bdd0fc)(options);
    try {
        var sucraseContext = $18c9d56f5c9372a4$var$getSucraseContext(code, options);
        var transformer = new (0, $7d6fd1b1d8441ecc$export$2e2bcd8739ae039)(sucraseContext, options.transforms, Boolean(options.enableLegacyBabel5ModuleInterop), options);
        var transformerResult = transformer.transform();
        var result = {
            code: transformerResult.code
        };
        if (options.sourceMapOptions) {
            if (!options.filePath) throw new Error("filePath must be specified when generating a source map.");
            result = (0, $6fpqi._)((0, $1XAnY._)({}, result), {
                sourceMap: (0, $b44756059e18104f$export$2e2bcd8739ae039)(transformerResult, options.filePath, options.sourceMapOptions, code, sucraseContext.tokenProcessor.tokens)
            });
        }
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        if (options.filePath) e.message = "Error transforming ".concat(options.filePath, ": ").concat(e.message);
        throw e;
    }
}
function $18c9d56f5c9372a4$export$fd97d3ecabd3e6b7(code, options) {
    var tokens = $18c9d56f5c9372a4$var$getSucraseContext(code, options).tokenProcessor.tokens;
    return (0, $a3f631c7db03a881$export$2e2bcd8739ae039)(code, tokens);
}
/**
 * Call into the parser/tokenizer and do some further preprocessing:
 * - Come up with a set of used names so that we can assign new names.
 * - Preprocess all import/export statements so we know which globals we are interested in.
 * - Compute situations where any of those globals are shadowed.
 *
 * In the future, some of these preprocessing steps can be skipped based on what actual work is
 * being done.
 */ function $18c9d56f5c9372a4$var$getSucraseContext(code, options) {
    var isJSXEnabled = options.transforms.includes("jsx");
    var isTypeScriptEnabled = options.transforms.includes("typescript");
    var isFlowEnabled = options.transforms.includes("flow");
    var disableESTransforms = options.disableESTransforms === true;
    var file = (0, $8404178774830e3d$export$98e6a39c04603d36)(code, isJSXEnabled, isTypeScriptEnabled, isFlowEnabled);
    var tokens = file.tokens;
    var scopes = file.scopes;
    var nameManager = new (0, $2e2ed5a6d21d4ed4$export$2e2bcd8739ae039)(code, tokens);
    var helperManager = new (0, $13685afd3632ccc0$export$b203ad16abdeb845)(nameManager);
    var tokenProcessor = new (0, $373eec7d62cfbd05$export$2e2bcd8739ae039)(code, tokens, isFlowEnabled, disableESTransforms, helperManager);
    var enableLegacyTypeScriptModuleInterop = Boolean(options.enableLegacyTypeScriptModuleInterop);
    var importProcessor = null;
    if (options.transforms.includes("imports")) {
        importProcessor = new (0, $77ef7ccbdb89a5f3$export$2e2bcd8739ae039)(nameManager, tokenProcessor, enableLegacyTypeScriptModuleInterop, options, options.transforms.includes("typescript"), Boolean(options.keepUnusedImports), helperManager);
        importProcessor.preprocessTokens();
        // We need to mark shadowed globals after processing imports so we know that the globals are,
        // but before type-only import pruning, since that relies on shadowing information.
        (0, $94eca5bd9dd2b130$export$2e2bcd8739ae039)(tokenProcessor, scopes, importProcessor.getGlobalNames());
        if (options.transforms.includes("typescript") && !options.keepUnusedImports) importProcessor.pruneTypeOnlyImports();
    } else if (options.transforms.includes("typescript") && !options.keepUnusedImports) // Shadowed global detection is needed for TS implicit elision of imported names.
    (0, $94eca5bd9dd2b130$export$2e2bcd8739ae039)(tokenProcessor, scopes, (0, $1c66a3f8d54033c7$export$2e2bcd8739ae039)(tokenProcessor));
    return {
        tokenProcessor: tokenProcessor,
        scopes: scopes,
        nameManager: nameManager,
        importProcessor: importProcessor,
        helperManager: helperManager
    };
}


var $d9ebcb6027e216ce$var$_this = undefined;
var $d9ebcb6027e216ce$var$__defProp = Object.defineProperty;
var $d9ebcb6027e216ce$var$__defProps = Object.defineProperties;
var $d9ebcb6027e216ce$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d9ebcb6027e216ce$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d9ebcb6027e216ce$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d9ebcb6027e216ce$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d9ebcb6027e216ce$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $d9ebcb6027e216ce$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $d9ebcb6027e216ce$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($d9ebcb6027e216ce$var$__hasOwnProp.call(b, prop)) $d9ebcb6027e216ce$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($d9ebcb6027e216ce$var$__getOwnPropSymbols) try {
        for(var _iterator = $d9ebcb6027e216ce$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($d9ebcb6027e216ce$var$__propIsEnum.call(b, prop)) $d9ebcb6027e216ce$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $d9ebcb6027e216ce$var$__spreadProps = function(a, b) {
    return $d9ebcb6027e216ce$var$__defProps(a, $d9ebcb6027e216ce$var$__getOwnPropDescs(b));
};
var $d9ebcb6027e216ce$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($d9ebcb6027e216ce$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $d9ebcb6027e216ce$var$__getOwnPropSymbols) try {
        for(var _iterator = $d9ebcb6027e216ce$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $d9ebcb6027e216ce$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
var $d9ebcb6027e216ce$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $d9ebcb6027e216ce$var$CodeEditor = function(props) {
    var _props_tabMode = props.tabMode, tabMode = _props_tabMode === void 0 ? "indentation" : _props_tabMode;
    var editorRef = (0, $lliNT.useRef)(null);
    var _useState = (0, $f9AOD._)((0, $lliNT.useState)(props.code || ""), 2), code = _useState[0], setCode = _useState[1];
    var theme = props.theme;
    (0, $lliNT.useEffect)(function() {
        setCode(props.code);
    }, [
        props.code
    ]);
    (0, $cd2892b5c6b5fc3f$export$52a148af2bad544)(editorRef, function(text) {
        var t = text.slice(0, -1);
        setCode(t);
        if (props.onChange) props.onChange(t);
    }, {
        disabled: props.disabled,
        indentation: tabMode === "indentation" ? 2 : void 0
    });
    return /* @__PURE__ */ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
        className: props.className,
        style: props.style,
        children: /* @__PURE__ */ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $dfab79d8c9f9a829$export$39dbc3f558091353), {
            code: code,
            theme: props.theme || (0, $dfab79d8c9f9a829$export$d9a33280f07116d9).nightOwl,
            language: props.language,
            children: function(param) {
                var _className = param.className, tokens = param.tokens, getLineProps = param.getLineProps, getTokenProps = param.getTokenProps, _style = param.style;
                return /* @__PURE__ */ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("pre", {
                    className: _className,
                    style: $d9ebcb6027e216ce$var$__spreadValues($d9ebcb6027e216ce$var$__spreadValues({
                        margin: 0,
                        outline: "none",
                        padding: 10,
                        fontFamily: "inherit"
                    }, theme && (0, $7E0eS._)(theme.plain) === "object" ? theme.plain : {}), _style),
                    ref: editorRef,
                    spellCheck: "false",
                    children: tokens.map(function(line, lineIndex) {
                        return /* @__PURE__ */ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("span", $d9ebcb6027e216ce$var$__spreadProps($d9ebcb6027e216ce$var$__spreadValues({}, getLineProps({
                            line: line
                        })), {
                            children: [
                                line.filter(function(token) {
                                    return !token.empty;
                                }).map(function(token, tokenIndex) {
                                    return /* @__PURE__ */ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("span", $d9ebcb6027e216ce$var$__spreadValues({}, getTokenProps({
                                        token: token
                                    })), "token-".concat(tokenIndex));
                                }),
                                "\n"
                            ]
                        }), "line-".concat(lineIndex));
                    })
                });
            }
        })
    });
};
var $d9ebcb6027e216ce$export$7cda8d932e2f33c0 = $d9ebcb6027e216ce$var$CodeEditor;
var $d9ebcb6027e216ce$var$LiveContext = (0, $tLNoZ.createContext)({});
var $d9ebcb6027e216ce$export$5a6106fef69bde7b = $d9ebcb6027e216ce$var$LiveContext;
var $d9ebcb6027e216ce$var$defaultTransforms = [
    "jsx",
    "imports"
];
function $d9ebcb6027e216ce$var$transform() {
    var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var transforms = Array.isArray(opts.transforms) ? opts.transforms.filter(Boolean) : $d9ebcb6027e216ce$var$defaultTransforms;
    return function(code) {
        return (0, $18c9d56f5c9372a4$export$51186ad6e864892a)(code, {
            transforms: transforms
        }).code;
    };
}
var $d9ebcb6027e216ce$var$errorBoundary = function(Element, errorCallback) {
    return /*#__PURE__*/ function(Component) {
        "use strict";
        (0, $hdIku._)(ErrorBoundary, Component);
        function ErrorBoundary() {
            (0, $173N4._)(this, ErrorBoundary);
            return (0, $7qXGD._)(this, ErrorBoundary, arguments);
        }
        (0, $cFHGC._)(ErrorBoundary, [
            {
                key: "componentDidCatch",
                value: function componentDidCatch(error) {
                    errorCallback(error);
                }
            },
            {
                key: "render",
                value: function render() {
                    return typeof Element === "function" ? /* @__PURE__ */ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Element, {}) : (0, $1aLYV.default).isValidElement(Element) ? Element : null;
                }
            }
        ]);
        return ErrorBoundary;
    }((0, $tLNoZ.Component));
};
var $d9ebcb6027e216ce$var$errorBoundary_default = $d9ebcb6027e216ce$var$errorBoundary;
// src/utils/transpile/evalCode.ts
var $d9ebcb6027e216ce$var$evalCode = function(code, scope) {
    var scopeKeys = Object.keys(scope);
    var scopeValues = scopeKeys.map(function(key) {
        return scope[key];
    });
    return (0, $2Ysl1._)(Function, (0, $aUGqu._)(scopeKeys).concat([
        code
    ])).apply($d9ebcb6027e216ce$var$_this, (0, $aUGqu._)(scopeValues));
};
var $d9ebcb6027e216ce$var$evalCode_default = $d9ebcb6027e216ce$var$evalCode;
// src/utils/transpile/compose.ts
function $d9ebcb6027e216ce$var$compose() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++){
        functions[_key] = arguments[_key];
    }
    return functions.reduce(function(acc, currentFn) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return acc(currentFn.apply(void 0, (0, $aUGqu._)(args)));
        };
    });
}
// src/utils/transpile/index.ts
var $d9ebcb6027e216ce$var$jsxConst = 'const _jsxFileName = "";';
var $d9ebcb6027e216ce$var$trimCode = function(code) {
    return code.trim().replace(/;$/, "");
};
var $d9ebcb6027e216ce$var$spliceJsxConst = function(code) {
    return code.replace($d9ebcb6027e216ce$var$jsxConst, "").trim();
};
var $d9ebcb6027e216ce$var$addJsxConst = function(code) {
    return $d9ebcb6027e216ce$var$jsxConst + code;
};
var $d9ebcb6027e216ce$var$wrapReturn = function(code) {
    return "return (".concat(code, ")");
};
var $d9ebcb6027e216ce$export$129b3480f9fbae0c = function(param, errorCallback) {
    var _param_code = param.code, code = _param_code === void 0 ? "" : _param_code, _param_scope = param.scope, scope = _param_scope === void 0 ? {} : _param_scope, _param_enableTypeScript = param.enableTypeScript, enableTypeScript = _param_enableTypeScript === void 0 ? true : _param_enableTypeScript;
    var firstPassTransforms = [
        "jsx"
    ];
    enableTypeScript && firstPassTransforms.push("typescript");
    var transformed = $d9ebcb6027e216ce$var$compose($d9ebcb6027e216ce$var$addJsxConst, $d9ebcb6027e216ce$var$transform({
        transforms: [
            "imports"
        ]
    }), $d9ebcb6027e216ce$var$spliceJsxConst, $d9ebcb6027e216ce$var$trimCode, $d9ebcb6027e216ce$var$transform({
        transforms: firstPassTransforms
    }), $d9ebcb6027e216ce$var$wrapReturn, $d9ebcb6027e216ce$var$trimCode)(code);
    return $d9ebcb6027e216ce$var$errorBoundary_default($d9ebcb6027e216ce$var$evalCode_default(transformed, $d9ebcb6027e216ce$var$__spreadValues({
        React: (0, $1aLYV.default)
    }, scope)), errorCallback);
};
var $d9ebcb6027e216ce$export$f4350c01fab98156 = function(param, resultCallback, errorCallback) {
    var _param_code = param.code, code = _param_code === void 0 ? "" : _param_code, _param_scope = param.scope, scope = _param_scope === void 0 ? {} : _param_scope, _param_enableTypeScript = param.enableTypeScript, enableTypeScript = _param_enableTypeScript === void 0 ? true : _param_enableTypeScript;
    var render = function(element) {
        if (typeof element === "undefined") errorCallback(new SyntaxError("`render` must be called with valid JSX."));
        else resultCallback($d9ebcb6027e216ce$var$errorBoundary_default(element, errorCallback));
    };
    if (!/render\s*\(/.test(code)) return errorCallback(new SyntaxError("No-Inline evaluations must call `render`."));
    var transforms = [
        "jsx",
        "imports"
    ];
    enableTypeScript && transforms.splice(1, 0, "typescript");
    $d9ebcb6027e216ce$var$evalCode_default($d9ebcb6027e216ce$var$transform({
        transforms: transforms
    })(code), $d9ebcb6027e216ce$var$__spreadProps($d9ebcb6027e216ce$var$__spreadValues({
        React: (0, $1aLYV.default)
    }, scope), {
        render: render
    }));
};
function $d9ebcb6027e216ce$var$LiveProvider(param) {
    var children = param.children, _param_code = param.code, code = _param_code === void 0 ? "" : _param_code, _param_language = param.language, language = _param_language === void 0 ? "tsx" : _param_language, theme = param.theme, _param_enableTypeScript = param.enableTypeScript, enableTypeScript = _param_enableTypeScript === void 0 ? true : _param_enableTypeScript, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, scope = param.scope, transformCode = param.transformCode, _param_noInline = param.noInline, noInline = _param_noInline === void 0 ? false : _param_noInline;
    var _useState2 = (0, $f9AOD._)((0, $lliNT.useState)({
        error: void 0,
        element: void 0
    }), 2), state = _useState2[0], setState = _useState2[1];
    function transpileAsync(newCode) {
        return $d9ebcb6027e216ce$var$__async(this, null, function() {
            var errorCallback, transformResult, transformedCode, renderElement, input, error, e;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        errorCallback = function(error) {
                            setState(function(previousState) {
                                return $d9ebcb6027e216ce$var$__spreadProps($d9ebcb6027e216ce$var$__spreadValues({}, previousState), {
                                    error: error.toString(),
                                    element: void 0
                                });
                            });
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        transformResult = transformCode ? transformCode(newCode) : newCode;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            Promise.resolve(transformResult)
                        ];
                    case 3:
                        transformedCode = _state.sent();
                        renderElement = function(element) {
                            return setState({
                                error: void 0,
                                element: element,
                                newCode: newCode
                            });
                        };
                        if (typeof transformedCode !== "string") throw new Error("Code failed to transform");
                        input = {
                            code: transformedCode,
                            scope: scope,
                            enableTypeScript: enableTypeScript
                        };
                        if (noInline) {
                            setState(function(previousState) {
                                return $d9ebcb6027e216ce$var$__spreadProps($d9ebcb6027e216ce$var$__spreadValues({}, previousState), {
                                    error: void 0,
                                    element: null
                                });
                            });
                            $d9ebcb6027e216ce$export$f4350c01fab98156(input, renderElement, errorCallback);
                        } else renderElement($d9ebcb6027e216ce$export$129b3480f9fbae0c(input, errorCallback));
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        return [
                            2,
                            errorCallback(error)
                        ];
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        e = _state.sent();
                        errorCallback(e);
                        return [
                            2,
                            Promise.resolve()
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
    }
    var onError = function(error) {
        return setState({
            error: error.toString()
        });
    };
    (0, $lliNT.useEffect)(function() {
        transpileAsync(code).catch(onError);
    }, [
        code,
        scope,
        noInline,
        transformCode
    ]);
    var onChange = function(newCode) {
        transpileAsync(newCode).catch(onError);
    };
    return /* @__PURE__ */ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($d9ebcb6027e216ce$export$5a6106fef69bde7b.Provider, {
        value: $d9ebcb6027e216ce$var$__spreadProps($d9ebcb6027e216ce$var$__spreadValues({}, state), {
            code: code,
            language: language,
            theme: theme,
            disabled: disabled,
            onError: onError,
            onChange: onChange
        }),
        children: children
    });
}
var $d9ebcb6027e216ce$export$7f6f1b77ca3c3ed3 = $d9ebcb6027e216ce$var$LiveProvider;
function $d9ebcb6027e216ce$export$f8f60579bb81d0e5(props) {
    var _useContext = (0, $lliNT.useContext)($d9ebcb6027e216ce$export$5a6106fef69bde7b), code = _useContext.code, language = _useContext.language, theme = _useContext.theme, disabled = _useContext.disabled, onChange = _useContext.onChange;
    return /* @__PURE__ */ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($d9ebcb6027e216ce$export$7cda8d932e2f33c0, $d9ebcb6027e216ce$var$__spreadValues({
        theme: theme,
        code: code,
        language: language,
        disabled: disabled,
        onChange: onChange
    }, props));
}
function $d9ebcb6027e216ce$export$1991b613205b2adc(props) {
    var error = (0, $lliNT.useContext)($d9ebcb6027e216ce$export$5a6106fef69bde7b).error;
    return error ? /* @__PURE__ */ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("pre", $d9ebcb6027e216ce$var$__spreadProps($d9ebcb6027e216ce$var$__spreadValues({}, props), {
        children: error
    })) : null;
}
var $d9ebcb6027e216ce$var$ErrorBoundary = /*#__PURE__*/ function(Component2) {
    "use strict";
    (0, $hdIku._)(ErrorBoundary, Component2);
    function ErrorBoundary(props) {
        (0, $173N4._)(this, ErrorBoundary);
        var _this;
        _this = (0, $7qXGD._)(this, ErrorBoundary, [
            props
        ]);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    (0, $cFHGC._)(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(err) {
                var _a, _b;
                (_b = (_a = this.props).onError) == null || _b.call(_a, err);
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) return null;
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError() {
                return {
                    hasError: true
                };
            }
        }
    ]);
    return ErrorBoundary;
}((0, $tLNoZ.Component));
function $d9ebcb6027e216ce$var$LivePreview(_a) {
    var _b = _a, tmp = _b.Component, Component3 = tmp === void 0 ? "div" : tmp, rest = $d9ebcb6027e216ce$var$__objRest(_b, [
        "Component"
    ]);
    var _useContext3 = (0, $lliNT.useContext)($d9ebcb6027e216ce$export$5a6106fef69bde7b), Element = _useContext3.element, onError = _useContext3.onError, newCode = _useContext3.newCode;
    return /* @__PURE__ */ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($d9ebcb6027e216ce$var$ErrorBoundary, {
        onError: onError,
        children: /* @__PURE__ */ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component3, $d9ebcb6027e216ce$var$__spreadProps($d9ebcb6027e216ce$var$__spreadValues({}, rest), {
            children: Element ? /* @__PURE__ */ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Element, {}) : null
        }))
    }, newCode);
}
var $d9ebcb6027e216ce$export$ba3ca6901d2e4f5f = $d9ebcb6027e216ce$var$LivePreview;
function $d9ebcb6027e216ce$export$3039ad97e9f7b4e0(WrappedComponent) {
    var WithLive = function(props) {
        return /* @__PURE__ */ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($d9ebcb6027e216ce$export$5a6106fef69bde7b.Consumer, {
            children: function(live) {
                return /* @__PURE__ */ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(WrappedComponent, $d9ebcb6027e216ce$var$__spreadValues({
                    live: live
                }, props));
            }
        });
    };
    WithLive.displayName = "WithLive";
    return WithLive;
}



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");


"use client";
var $b4b154a3007acf25$var$Badge = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, _param_bg = _param.bg, bg = _param_bg === void 0 ? 'primary' : _param_bg, _param_pill = _param.pill, pill = _param_pill === void 0 ? false : _param_pill, text = _param.text, className = _param.className, tmp = _param.as, Component = tmp === void 0 ? 'span' : tmp, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "bg",
        "pill",
        "text",
        "className",
        "as"
    ]);
    var prefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'badge');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, prefix, pill && "rounded-pill", text && "text-".concat(text), bg && "bg-".concat(bg))
    }));
});
$b4b154a3007acf25$var$Badge.displayName = 'Badge';
var $b4b154a3007acf25$export$2e2bcd8739ae039 = $b4b154a3007acf25$var$Badge;


var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");


var $1aLYV = parcelRequire("1aLYV");

var $f9AOD = parcelRequire("f9AOD");

var $1aLYV = parcelRequire("1aLYV");

var $a2ef149eb04c6f18$var$_excluded = [
    "as",
    "disabled"
];
function $a2ef149eb04c6f18$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $a2ef149eb04c6f18$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $a2ef149eb04c6f18$export$a0ee72f2c720a5c3(param) {
    var tagName = param.tagName, disabled = param.disabled, href = param.href, target = param.target, rel = param.rel, role = param.role, onClick = param.onClick, _param_tabIndex = param.tabIndex, tabIndex = _param_tabIndex === void 0 ? 0 : _param_tabIndex, type = param.type;
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    var meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    var handleClick = function(event) {
        if (disabled || tagName === 'a' && $a2ef149eb04c6f18$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    var handleKeyDown = function(event) {
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
var $a2ef149eb04c6f18$var$Button = /*#__PURE__*/ $1aLYV.forwardRef(function(_ref, ref) {
    var asProp = _ref.as, disabled = _ref.disabled, props = $a2ef149eb04c6f18$var$_objectWithoutPropertiesLoose(_ref, $a2ef149eb04c6f18$var$_excluded);
    var _useButtonProps = (0, $f9AOD._)($a2ef149eb04c6f18$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props)), 2), buttonProps = _useButtonProps[0], _useButtonProps_ = _useButtonProps[1], Component = _useButtonProps_.tagName;
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$a2ef149eb04c6f18$var$Button.displayName = 'Button';
var $a2ef149eb04c6f18$export$2e2bcd8739ae039 = $a2ef149eb04c6f18$var$Button;




"use client";
var $3a399bf6b2fd4261$var$Button = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var as = _param.as, bsPrefix = _param.bsPrefix, _param_variant = _param.variant, variant = _param_variant === void 0 ? 'primary' : _param_variant, size = _param.size, _param_active = _param.active, active = _param_active === void 0 ? false : _param_active, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, className = _param.className, props = (0, $6acIq._)(_param, [
        "as",
        "bsPrefix",
        "variant",
        "size",
        "active",
        "disabled",
        "className"
    ]);
    var prefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'btn');
    var _useButtonProps = (0, $f9AOD._)((0, $a2ef149eb04c6f18$export$a0ee72f2c720a5c3)((0, $1XAnY._)({
        tagName: as,
        disabled: disabled
    }, props)), 2), buttonProps = _useButtonProps[0], tagName = _useButtonProps[1].tagName;
    var Component = tagName;
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({}, buttonProps, props), {
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, prefix, active && 'active', variant && "".concat(prefix, "-").concat(variant), size && "".concat(prefix, "-").concat(size), props.href && disabled && 'disabled')
    }));
});
$3a399bf6b2fd4261$var$Button.displayName = 'Button';
var $3a399bf6b2fd4261$export$2e2bcd8739ae039 = $3a399bf6b2fd4261$var$Button;


var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");


var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");



"use client";
var $4ca9d2dbc486d719$var$CardBody = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'card-body');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$4ca9d2dbc486d719$var$CardBody.displayName = 'CardBody';
var $4ca9d2dbc486d719$export$2e2bcd8739ae039 = $4ca9d2dbc486d719$var$CardBody;



var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");



"use client";
var $f4b8fa1ef8747a38$var$CardFooter = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'card-footer');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$f4b8fa1ef8747a38$var$CardFooter.displayName = 'CardFooter';
var $f4b8fa1ef8747a38$export$2e2bcd8739ae039 = $f4b8fa1ef8747a38$var$CardFooter;



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");
"use client";
var $30bbb1217fcc28a5$var$context = /*#__PURE__*/ $tLNoZ.createContext(null);
$30bbb1217fcc28a5$var$context.displayName = 'CardHeaderContext';
var $30bbb1217fcc28a5$export$2e2bcd8739ae039 = $30bbb1217fcc28a5$var$context;



"use client";
var $212d9772903e4346$var$CardHeader = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "as"
    ]);
    var prefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'card-header');
    var contextValue = (0, $lliNT.useMemo)(function() {
        return {
            cardHeaderBsPrefix: prefix
        };
    }, [
        prefix
    ]);
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $30bbb1217fcc28a5$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({
            ref: ref
        }, props), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, prefix)
        }))
    });
});
$212d9772903e4346$var$CardHeader.displayName = 'CardHeader';
var $212d9772903e4346$export$2e2bcd8739ae039 = $212d9772903e4346$var$CardHeader;



var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");


"use client";
var $f0c22de246382186$var$CardImg = /*#__PURE__*/ $1aLYV.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, variant = _param.variant, tmp = _param.as, Component = tmp === void 0 ? 'img' : tmp, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "variant",
        "as"
    ]);
    var prefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'card-img');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(variant ? "".concat(prefix, "-").concat(variant) : prefix, className)
    }, props));
});
$f0c22de246382186$var$CardImg.displayName = 'CardImg';
var $f0c22de246382186$export$2e2bcd8739ae039 = $f0c22de246382186$var$CardImg;



var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");



"use client";
var $46760b3f4250689c$var$CardImgOverlay = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'card-img-overlay');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$46760b3f4250689c$var$CardImgOverlay.displayName = 'CardImgOverlay';
var $46760b3f4250689c$export$2e2bcd8739ae039 = $46760b3f4250689c$var$CardImgOverlay;



var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");



"use client";
var $5c6b0fbab7f1367d$var$CardLink = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'a' : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'card-link');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$5c6b0fbab7f1367d$var$CardLink.displayName = 'CardLink';
var $5c6b0fbab7f1367d$export$2e2bcd8739ae039 = $5c6b0fbab7f1367d$var$CardLink;



var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $1aLYV = parcelRequire("1aLYV");


var $2dc371b22567e8b5$export$2e2bcd8739ae039 = function(className) {
    return(/*#__PURE__*/ // eslint-disable-next-line react/display-name
    $1aLYV.forwardRef(function(p, ref) {
        return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", (0, $6fpqi._)((0, $1XAnY._)({}, p), {
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(p.className, className)
        }));
    }));
};



"use client";
var $d819c203c4bdafed$var$DivStyledAsH6 = (0, $2dc371b22567e8b5$export$2e2bcd8739ae039)('h6');
var $d819c203c4bdafed$var$CardSubtitle = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? $d819c203c4bdafed$var$DivStyledAsH6 : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'card-subtitle');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$d819c203c4bdafed$var$CardSubtitle.displayName = 'CardSubtitle';
var $d819c203c4bdafed$export$2e2bcd8739ae039 = $d819c203c4bdafed$var$CardSubtitle;



var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");



"use client";
var $f42b680685ce2ffc$var$CardText = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'p' : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'card-text');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$f42b680685ce2ffc$var$CardText.displayName = 'CardText';
var $f42b680685ce2ffc$export$2e2bcd8739ae039 = $f42b680685ce2ffc$var$CardText;



var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");




"use client";
var $6a5134c84da462e6$var$DivStyledAsH5 = (0, $2dc371b22567e8b5$export$2e2bcd8739ae039)('h5');
var $6a5134c84da462e6$var$CardTitle = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? $6a5134c84da462e6$var$DivStyledAsH5 : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'card-title');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$6a5134c84da462e6$var$CardTitle.displayName = 'CardTitle';
var $6a5134c84da462e6$export$2e2bcd8739ae039 = $6a5134c84da462e6$var$CardTitle;



"use client";
var $71075948dbe2717f$var$Card = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, bg = _param.bg, text = _param.text, border = _param.border, _param_body = _param.body, body = _param_body === void 0 ? false : _param_body, children = _param.children, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "bg",
        "text",
        "border",
        "body",
        "children",
        "as"
    ]);
    var prefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'card');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, prefix, bg && "bg-".concat(bg), text && "text-".concat(text), border && "border-".concat(border)),
        children: body ? /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $4ca9d2dbc486d719$export$2e2bcd8739ae039), {
            children: children
        }) : children
    }));
});
$71075948dbe2717f$var$Card.displayName = 'Card';
var $71075948dbe2717f$export$2e2bcd8739ae039 = Object.assign($71075948dbe2717f$var$Card, {
    Img: (0, $f0c22de246382186$export$2e2bcd8739ae039),
    Title: (0, $6a5134c84da462e6$export$2e2bcd8739ae039),
    Subtitle: (0, $d819c203c4bdafed$export$2e2bcd8739ae039),
    Body: (0, $4ca9d2dbc486d719$export$2e2bcd8739ae039),
    Link: (0, $5c6b0fbab7f1367d$export$2e2bcd8739ae039),
    Text: (0, $f42b680685ce2ffc$export$2e2bcd8739ae039),
    Header: (0, $212d9772903e4346$export$2e2bcd8739ae039),
    Footer: (0, $f4b8fa1ef8747a38$export$2e2bcd8739ae039),
    ImgOverlay: (0, $46760b3f4250689c$export$2e2bcd8739ae039)
});


var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");


var $1aLYV = parcelRequire("1aLYV");


"use client";
function $bce75f99777ea046$export$2ed43d61a0a9f5a3(_param) {
    var as = _param.as, bsPrefix = _param.bsPrefix, className = _param.className, props = (0, $6acIq._)(_param, [
        "as",
        "bsPrefix",
        "className"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'col');
    var breakpoints = (0, $86d2028892b8b8bc$export$8970c8db816a5863)();
    var minBreakpoint = (0, $86d2028892b8b8bc$export$d926d6ef38f3fd32)();
    var spans = [];
    var classes = [];
    breakpoints.forEach(function(brkPoint) {
        var propValue = props[brkPoint];
        delete props[brkPoint];
        var span;
        var offset;
        var order;
        var ref;
        if ((typeof propValue === "undefined" ? "undefined" : (0, $7E0eS._)(propValue)) === 'object' && propValue != null) ref = propValue, span = ref.span, offset = ref.offset, order = ref.order, ref;
        else span = propValue;
        var infix = brkPoint !== minBreakpoint ? "-".concat(brkPoint) : '';
        if (span) spans.push(span === true ? "".concat(bsPrefix).concat(infix) : "".concat(bsPrefix).concat(infix, "-").concat(span));
        if (order != null) classes.push("order".concat(infix, "-").concat(order));
        if (offset != null) classes.push("offset".concat(infix, "-").concat(offset));
    });
    return [
        (0, $6fpqi._)((0, $1XAnY._)({}, props), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports))).apply(void 0, [
                className
            ].concat((0, $aUGqu._)(spans), (0, $aUGqu._)(classes)))
        }),
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
var $bce75f99777ea046$var$Col = /*#__PURE__*/ $1aLYV.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function(props, ref) {
    var _useCol = $bce75f99777ea046$export$2ed43d61a0a9f5a3(props), _useCol1 = (0, $f9AOD._)(_useCol, 2), className = _useCol1[0].className, _useCol_ = _useCol1[1], tmp = _useCol_.as, Component = tmp === void 0 ? 'div' : tmp, bsPrefix = _useCol_.bsPrefix, spans = _useCol_.spans, colProps = (0, $6acIq._)(_useCol[0], [
        "className"
    ]);
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({}, colProps), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, !spans.length && bsPrefix)
    }));
});
$bce75f99777ea046$var$Col.displayName = 'Col';
var $bce75f99777ea046$export$2e2bcd8739ae039 = $bce75f99777ea046$var$Col;


var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

var $f9AOD = parcelRequire("f9AOD");
var $aa7848f343bf09c4$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $aa7848f343bf09c4$export$2e2bcd8739ae039(element, selector) {
    return $aa7848f343bf09c4$var$toArray(element.querySelectorAll(selector));
}


/* eslint-disable no-return-assign */ var $64f258eaaf92e603$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $fe9809a8616a080a$export$63fefd044b2bc624 = false;
var $fe9809a8616a080a$export$a614c6b395900f69 = false;
try {
    var $fe9809a8616a080a$var$options = {
        get passive () {
            return $fe9809a8616a080a$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $fe9809a8616a080a$export$a614c6b395900f69 = $fe9809a8616a080a$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $64f258eaaf92e603$export$2e2bcd8739ae039) {
        window.addEventListener('test', $fe9809a8616a080a$var$options, $fe9809a8616a080a$var$options);
        window.removeEventListener('test', $fe9809a8616a080a$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $fe9809a8616a080a$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$fe9809a8616a080a$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$fe9809a8616a080a$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $fe9809a8616a080a$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $fe9809a8616a080a$export$2e2bcd8739ae039 = $fe9809a8616a080a$var$addEventListener;


parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

var $7Pjls = parcelRequire("7Pjls");

var $f9AOD = parcelRequire("f9AOD");

var $iQDyc = parcelRequire("iQDyc");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
function $04ea7b391e033f55$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $04ea7b391e033f55$var$_toPropertyKey(arg) {
    var key = $04ea7b391e033f55$var$_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, $7E0eS._)(key)) === "symbol" ? key : String(key);
}
function $04ea7b391e033f55$var$_toPrimitive(input, hint) {
    if ((typeof input === "undefined" ? "undefined" : (0, $7E0eS._)(input)) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((typeof res === "undefined" ? "undefined" : (0, $7E0eS._)(res)) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $04ea7b391e033f55$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $04ea7b391e033f55$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $lliNT.useRef)(propValue !== undefined);
    var _useState = (0, $f9AOD._)((0, $lliNT.useState)(defaultValue), 2), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $lliNT.useCallback)(function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _args = (0, $iQDyc._)(args), value = _args[0], rest = _args.slice(1);
            var returnValue = handler == null ? void 0 : handler.apply(void 0, [
                value
            ].concat((0, $aUGqu._)(rest)));
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $04ea7b391e033f55$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _ref = result, _defaultKey = $04ea7b391e033f55$export$26cbf8c37e721e67(fieldName), defaultValue = _ref[_defaultKey], propsValue = _ref[fieldName], rest = $04ea7b391e033f55$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($04ea7b391e033f55$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = (0, $f9AOD._)($04ea7b391e033f55$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), 2), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        var _obj;
        return Object.assign({}, rest, (_obj = {}, (0, $7Pjls._)(_obj, fieldName, value), (0, $7Pjls._)(_obj, handlerName, handler), _obj));
    }, props);
}


parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
function $26d665efc2403b23$export$2e2bcd8739ae039(value) {
    var ref = (0, $lliNT.useRef)(null);
    (0, $lliNT.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
}



var $f9AOD = parcelRequire("f9AOD");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
function $de985634587468d0$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    var _useReducer = (0, $f9AOD._)((0, $lliNT.useReducer)(function(revision) {
        return revision + 1;
    }, 0), 2), dispatch = _useReducer[1];
    return dispatch;
}


parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

var $aUGqu = parcelRequire("aUGqu");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $bd6a6b6e866a8ae9$var$useCommittedRef(value) {
    var ref = (0, $lliNT.useRef)(value);
    (0, $lliNT.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $bd6a6b6e866a8ae9$export$2e2bcd8739ae039 = $bd6a6b6e866a8ae9$var$useCommittedRef;


function $5ec89db9ae56f810$export$2e2bcd8739ae039(fn) {
    var ref = (0, $bd6a6b6e866a8ae9$export$2e2bcd8739ae039)(fn);
    return (0, $lliNT.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _ref;
        return ref.current && (_ref = ref).current.apply(_ref, (0, $aUGqu._)(args));
    }, [
        ref
    ]);
}


function $e02dbeaef4c9770c$export$2e2bcd8739ae039(eventTarget, event, listener) {
    var capture = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var handler = (0, $5ec89db9ae56f810$export$2e2bcd8739ae039)(listener);
    (0, $lliNT.useEffect)(function() {
        var target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return function() {
            return target.removeEventListener(event, handler, capture);
        };
    }, [
        eventTarget
    ]);
}



parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");
var $a0823358c6520d01$var$DropdownContext = /*#__PURE__*/ $tLNoZ.createContext(null);
var $a0823358c6520d01$export$2e2bcd8739ae039 = $a0823358c6520d01$var$DropdownContext;



var $f9AOD = parcelRequire("f9AOD");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
function $f77f18df0f494e37$export$2e2bcd8739ae039() {
    return (0, $lliNT.useState)(null);
}




var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

var $7E0eS = parcelRequire("7E0eS");
var $e720145b3d6bea34$var$has = Object.prototype.hasOwnProperty;
function $e720145b3d6bea34$var$find(iter, tar, key) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = iter.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            key = _step.value;
            if ($e720145b3d6bea34$export$de8294bb3be0322f(key, tar)) return key;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $e720145b3d6bea34$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $e720145b3d6bea34$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = foo[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    len = _step.value;
                    tmp = len;
                    if (tmp && (typeof tmp === "undefined" ? "undefined" : (0, $7E0eS._)(tmp)) === 'object') {
                        tmp = $e720145b3d6bea34$var$find(bar, tmp);
                        if (!tmp) return false;
                    }
                    if (!bar.has(tmp)) return false;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = foo[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    len = _step1.value;
                    tmp = len[0];
                    if (tmp && (typeof tmp === "undefined" ? "undefined" : (0, $7E0eS._)(tmp)) === 'object') {
                        tmp = $e720145b3d6bea34$var$find(bar, tmp);
                        if (!tmp) return false;
                    }
                    if (!$e720145b3d6bea34$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || (typeof foo === "undefined" ? "undefined" : (0, $7E0eS._)(foo)) === 'object') {
            len = 0;
            for(ctor in foo){
                if ($e720145b3d6bea34$var$has.call(foo, ctor) && ++len && !$e720145b3d6bea34$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$e720145b3d6bea34$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}


parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
function $1b54fe6f859435c1$export$2e2bcd8739ae039() {
    var mounted = (0, $lliNT.useRef)(true);
    var isMounted = (0, $lliNT.useRef)(function() {
        return mounted.current;
    });
    (0, $lliNT.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}


/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $aae7ecc3aff66783$var$useSafeState(state) {
    var isMounted = (0, $1b54fe6f859435c1$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $lliNT.useCallback)(function(nextState) {
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $aae7ecc3aff66783$export$2e2bcd8739ae039 = $aae7ecc3aff66783$var$useSafeState;



function $f9d884b554ea4bf4$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $1e4f141c0d6b4103$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $bbffdd6323c1f82e$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $bbffdd6323c1f82e$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $bbffdd6323c1f82e$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $72df85f12ea79b54$export$8960430cfd85939f = Math.max;
var $72df85f12ea79b54$export$96ec731ed4dcb222 = Math.min;
var $72df85f12ea79b54$export$2077e0241d6afd3c = Math.round;



function $4637f1b0681fa27a$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $b1834fcf2fae3cca$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $4637f1b0681fa27a$export$2e2bcd8739ae039)());
}


function $60809149f86c2179$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $72df85f12ea79b54$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $72df85f12ea79b54$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(element) ? (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b1834fcf2fae3cca$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $103f1f67b99aec04$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $60809149f86c2179$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $39cf95a59efb4181$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $bbffdd6323c1f82e$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $4a1bdbded0efa4e8$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}



function $3e3b1486c04ee7a8$export$2e2bcd8739ae039(element) {
    return (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $582da07d1f9d6e0d$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(element)) >= 0;
}




function $cff48eaff5e06d70$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $bc26653e17f18903$export$2e2bcd8739ae039(element) {
    if ((0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $bbffdd6323c1f82e$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $5f7645d1b576086d$var$getTrueOffsetParent(element) {
    if (!(0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $5f7645d1b576086d$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $4637f1b0681fa27a$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $4637f1b0681fa27a$export$2e2bcd8739ae039)());
    if (isIE && (0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $bc26653e17f18903$export$2e2bcd8739ae039)(element);
    if ((0, $bbffdd6323c1f82e$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $5f7645d1b576086d$export$2e2bcd8739ae039(element) {
    var window = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(element);
    var offsetParent = $5f7645d1b576086d$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $582da07d1f9d6e0d$export$2e2bcd8739ae039)(offsetParent) && (0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $5f7645d1b576086d$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $5f7645d1b576086d$var$getContainingBlock(element) || window;
}


function $e0d7cc9881440195$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $a7122274de1cc429$export$f28d906d67a997f3(min, value, max) {
    return (0, $72df85f12ea79b54$export$8960430cfd85939f)(min, (0, $72df85f12ea79b54$export$96ec731ed4dcb222)(value, max));
}
function $a7122274de1cc429$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $a7122274de1cc429$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $55af678c44975866$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $8dd19ddc34578741$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $55af678c44975866$export$2e2bcd8739ae039)(), paddingObject);
}


function $a96029e4eb2bae52$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


var $22e99ddc6089aa5c$export$1e95b668f3b82d = 'top';
var $22e99ddc6089aa5c$export$40e543e69a8b3fbb = 'bottom';
var $22e99ddc6089aa5c$export$79ffe56a765070d2 = 'right';
var $22e99ddc6089aa5c$export$eabcd2c8791e7bf4 = 'left';
var $22e99ddc6089aa5c$export$dfb5619354ba860 = 'auto';
var $22e99ddc6089aa5c$export$aec2ce47c367b8c3 = [
    $22e99ddc6089aa5c$export$1e95b668f3b82d,
    $22e99ddc6089aa5c$export$40e543e69a8b3fbb,
    $22e99ddc6089aa5c$export$79ffe56a765070d2,
    $22e99ddc6089aa5c$export$eabcd2c8791e7bf4
];
var $22e99ddc6089aa5c$export$b3571188c770cc5a = 'start';
var $22e99ddc6089aa5c$export$bd5df0f255a350f8 = 'end';
var $22e99ddc6089aa5c$export$390fd549c5303b4d = 'clippingParents';
var $22e99ddc6089aa5c$export$d7b7311ec04a3e8f = 'viewport';
var $22e99ddc6089aa5c$export$ae5ab1c730825774 = 'popper';
var $22e99ddc6089aa5c$export$ca50aac9f3ba507f = 'reference';
var $22e99ddc6089aa5c$export$368f9a87e87fa4e1 = /*#__PURE__*/ $22e99ddc6089aa5c$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $22e99ddc6089aa5c$export$b3571188c770cc5a,
        placement + "-" + $22e99ddc6089aa5c$export$bd5df0f255a350f8
    ]);
}, []);
var $22e99ddc6089aa5c$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($22e99ddc6089aa5c$export$aec2ce47c367b8c3, [
    $22e99ddc6089aa5c$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $22e99ddc6089aa5c$export$b3571188c770cc5a,
        placement + "-" + $22e99ddc6089aa5c$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $22e99ddc6089aa5c$export$421679a7c3d56e = 'beforeRead';
var $22e99ddc6089aa5c$export$aafa59e2e03f2942 = 'read';
var $22e99ddc6089aa5c$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $22e99ddc6089aa5c$export$c65e99957a05207c = 'beforeMain';
var $22e99ddc6089aa5c$export$f22da7240b7add18 = 'main';
var $22e99ddc6089aa5c$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $22e99ddc6089aa5c$export$8d4d2d70e7d46032 = 'beforeWrite';
var $22e99ddc6089aa5c$export$68d8715fc104d294 = 'write';
var $22e99ddc6089aa5c$export$70a6e5159acce2e6 = 'afterWrite';
var $22e99ddc6089aa5c$export$d087d3878fdf71d5 = [
    $22e99ddc6089aa5c$export$421679a7c3d56e,
    $22e99ddc6089aa5c$export$aafa59e2e03f2942,
    $22e99ddc6089aa5c$export$6964f6c886723980,
    $22e99ddc6089aa5c$export$c65e99957a05207c,
    $22e99ddc6089aa5c$export$f22da7240b7add18,
    $22e99ddc6089aa5c$export$bab79516f2d662fe,
    $22e99ddc6089aa5c$export$8d4d2d70e7d46032,
    $22e99ddc6089aa5c$export$68d8715fc104d294,
    $22e99ddc6089aa5c$export$70a6e5159acce2e6
];


var $187ac7d7e133663b$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $8dd19ddc34578741$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $a96029e4eb2bae52$export$2e2bcd8739ae039)(padding, (0, $22e99ddc6089aa5c$export$aec2ce47c367b8c3)));
};
function $187ac7d7e133663b$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $e0d7cc9881440195$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4),
        (0, $22e99ddc6089aa5c$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $187ac7d7e133663b$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $103f1f67b99aec04$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $22e99ddc6089aa5c$export$1e95b668f3b82d) : (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb) : (0, $22e99ddc6089aa5c$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5f7645d1b576086d$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $a7122274de1cc429$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $187ac7d7e133663b$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $39cf95a59efb4181$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $187ac7d7e133663b$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $187ac7d7e133663b$var$arrow,
    effect: $187ac7d7e133663b$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $82387fc5bc72ad7c$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $ccbbd6437d6f1dc0$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $ccbbd6437d6f1dc0$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $72df85f12ea79b54$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $72df85f12ea79b54$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $ccbbd6437d6f1dc0$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4);
    var sideY = (0, $22e99ddc6089aa5c$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5f7645d1b576086d$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(popper);
            if ((0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $22e99ddc6089aa5c$export$1e95b668f3b82d) || (placement === (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4) || placement === (0, $22e99ddc6089aa5c$export$79ffe56a765070d2)) && variation === (0, $22e99ddc6089aa5c$export$bd5df0f255a350f8)) {
            sideY = (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4) || (placement === (0, $22e99ddc6089aa5c$export$1e95b668f3b82d) || placement === (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb)) && variation === (0, $22e99ddc6089aa5c$export$bd5df0f255a350f8)) {
            sideX = (0, $22e99ddc6089aa5c$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $ccbbd6437d6f1dc0$var$unsetSides);
    var _ref4 = roundOffsets === true ? $ccbbd6437d6f1dc0$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $ccbbd6437d6f1dc0$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $82387fc5bc72ad7c$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $ccbbd6437d6f1dc0$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $ccbbd6437d6f1dc0$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ccbbd6437d6f1dc0$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $ccbbd6437d6f1dc0$var$computeStyles,
    data: {}
};



var $ac76324de7a4bf14$var$passive = {
    passive: true
};
function $ac76324de7a4bf14$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $ac76324de7a4bf14$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $ac76324de7a4bf14$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $ac76324de7a4bf14$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $ac76324de7a4bf14$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ac76324de7a4bf14$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $ac76324de7a4bf14$var$effect,
    data: {}
};


var $280b7124a30a8a0e$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $280b7124a30a8a0e$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $280b7124a30a8a0e$var$hash[matched];
    });
}



var $45cb87f5d981a852$var$hash = {
    start: 'end',
    end: 'start'
};
function $45cb87f5d981a852$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $45cb87f5d981a852$var$hash[matched];
    });
}








function $0457e65694e7b463$export$2e2bcd8739ae039(node) {
    var win = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $82e56b3c9202f1bc$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $60809149f86c2179$export$2e2bcd8739ae039)((0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(element)).left + (0, $0457e65694e7b463$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $ed96f5b6e84ce0d6$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(element);
    var html = (0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b1834fcf2fae3cca$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $82e56b3c9202f1bc$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $bead1d02fb1ff5b7$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $0457e65694e7b463$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $72df85f12ea79b54$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $72df85f12ea79b54$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $82e56b3c9202f1bc$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $72df85f12ea79b54$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $07fcf859739eaae8$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $4af9f5dd66ae033b$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(node) && (0, $07fcf859739eaae8$export$2e2bcd8739ae039)(node)) return node;
    return $4af9f5dd66ae033b$export$2e2bcd8739ae039((0, $bc26653e17f18903$export$2e2bcd8739ae039)(node));
}





function $bdbb9e30d785ac6a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $4af9f5dd66ae033b$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $07fcf859739eaae8$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($bdbb9e30d785ac6a$export$2e2bcd8739ae039((0, $bc26653e17f18903$export$2e2bcd8739ae039)(target)));
}










function $f29ca087f4c184d0$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $4c533b586cbb17f5$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $60809149f86c2179$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $4c533b586cbb17f5$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $22e99ddc6089aa5c$export$d7b7311ec04a3e8f) ? (0, $f29ca087f4c184d0$export$2e2bcd8739ae039)((0, $ed96f5b6e84ce0d6$export$2e2bcd8739ae039)(element, strategy)) : (0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(clippingParent) ? $4c533b586cbb17f5$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $f29ca087f4c184d0$export$2e2bcd8739ae039)((0, $bead1d02fb1ff5b7$export$2e2bcd8739ae039)((0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $4c533b586cbb17f5$var$getClippingParents(element) {
    var clippingParents = (0, $bdbb9e30d785ac6a$export$2e2bcd8739ae039)((0, $bc26653e17f18903$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(element) ? (0, $5f7645d1b576086d$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(clippingParent) && (0, $39cf95a59efb4181$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $4c533b586cbb17f5$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $4c533b586cbb17f5$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $4c533b586cbb17f5$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $72df85f12ea79b54$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $72df85f12ea79b54$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $72df85f12ea79b54$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $72df85f12ea79b54$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $4c533b586cbb17f5$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $c0a524493d0afb7d$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $82387fc5bc72ad7c$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $22e99ddc6089aa5c$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $22e99ddc6089aa5c$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $e0d7cc9881440195$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $22e99ddc6089aa5c$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $22e99ddc6089aa5c$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $50ef0f40f7ca922c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $22e99ddc6089aa5c$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $22e99ddc6089aa5c$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $22e99ddc6089aa5c$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $8dd19ddc34578741$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $a96029e4eb2bae52$export$2e2bcd8739ae039)(padding, (0, $22e99ddc6089aa5c$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $22e99ddc6089aa5c$export$ae5ab1c730825774) ? (0, $22e99ddc6089aa5c$export$ca50aac9f3ba507f) : (0, $22e99ddc6089aa5c$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $4c533b586cbb17f5$export$2e2bcd8739ae039)((0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $60809149f86c2179$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $c0a524493d0afb7d$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $f29ca087f4c184d0$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $22e99ddc6089aa5c$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $22e99ddc6089aa5c$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $22e99ddc6089aa5c$export$79ffe56a765070d2),
                (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $22e99ddc6089aa5c$export$1e95b668f3b82d),
                (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $c934dccc7bdf321d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $22e99ddc6089aa5c$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $82387fc5bc72ad7c$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $22e99ddc6089aa5c$export$368f9a87e87fa4e1) : (0, $22e99ddc6089aa5c$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $82387fc5bc72ad7c$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $22e99ddc6089aa5c$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $50ef0f40f7ca922c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $c7ad662b98d4d1dc$var$getExpandedFallbackPlacements(placement) {
    if ((0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(placement) === (0, $22e99ddc6089aa5c$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $280b7124a30a8a0e$export$2e2bcd8739ae039)(placement);
    return [
        (0, $45cb87f5d981a852$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $45cb87f5d981a852$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $c7ad662b98d4d1dc$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $280b7124a30a8a0e$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $c7ad662b98d4d1dc$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(placement) === (0, $22e99ddc6089aa5c$export$dfb5619354ba860) ? (0, $c934dccc7bdf321d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $82387fc5bc72ad7c$export$2e2bcd8739ae039)(placement) === (0, $22e99ddc6089aa5c$export$b3571188c770cc5a);
        var isVertical = [
            (0, $22e99ddc6089aa5c$export$1e95b668f3b82d),
            (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $50ef0f40f7ca922c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $22e99ddc6089aa5c$export$79ffe56a765070d2) : (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb) : (0, $22e99ddc6089aa5c$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $280b7124a30a8a0e$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $280b7124a30a8a0e$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $c7ad662b98d4d1dc$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $c7ad662b98d4d1dc$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $2d88d9f94be5b0ba$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $2d88d9f94be5b0ba$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $22e99ddc6089aa5c$export$1e95b668f3b82d),
        (0, $22e99ddc6089aa5c$export$79ffe56a765070d2),
        (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb),
        (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $2d88d9f94be5b0ba$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $50ef0f40f7ca922c$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $50ef0f40f7ca922c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $2d88d9f94be5b0ba$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $2d88d9f94be5b0ba$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $2d88d9f94be5b0ba$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $2d88d9f94be5b0ba$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $2d88d9f94be5b0ba$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $2d88d9f94be5b0ba$var$hide
};




function $311ce567045aea2b$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4),
        (0, $22e99ddc6089aa5c$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4),
        (0, $22e99ddc6089aa5c$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $311ce567045aea2b$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $22e99ddc6089aa5c$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $311ce567045aea2b$export$7fa02d8595b015ed(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $311ce567045aea2b$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $311ce567045aea2b$var$offset
};



function $3133aaf1ec566bd5$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $c0a524493d0afb7d$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3133aaf1ec566bd5$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $3133aaf1ec566bd5$var$popperOffsets,
    data: {}
};





function $e4efa183da5e1e17$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $00a8e20b8c0bfbdf$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $50ef0f40f7ca922c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $82387fc5bc72ad7c$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $e0d7cc9881440195$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $e4efa183da5e1e17$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $22e99ddc6089aa5c$export$1e95b668f3b82d) : (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb) : (0, $22e99ddc6089aa5c$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $22e99ddc6089aa5c$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $22e99ddc6089aa5c$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $103f1f67b99aec04$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $55af678c44975866$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $a7122274de1cc429$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5f7645d1b576086d$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $a7122274de1cc429$export$f28d906d67a997f3)(tether ? (0, $72df85f12ea79b54$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $72df85f12ea79b54$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $22e99ddc6089aa5c$export$1e95b668f3b82d) : (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb) : (0, $22e99ddc6089aa5c$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $22e99ddc6089aa5c$export$1e95b668f3b82d),
            (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $a7122274de1cc429$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $a7122274de1cc429$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $00a8e20b8c0bfbdf$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $00a8e20b8c0bfbdf$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};







function $8d58228048724510$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $1112e259f7d2e76a$export$2e2bcd8739ae039(node) {
    if (node === (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(node) || !(0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(node)) return (0, $0457e65694e7b463$export$2e2bcd8739ae039)(node);
    else return (0, $8d58228048724510$export$2e2bcd8739ae039)(node);
}








function $97cb7d18733c60e6$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $72df85f12ea79b54$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $72df85f12ea79b54$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $97cb7d18733c60e6$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(offsetParent) && $97cb7d18733c60e6$var$isElementScaled(offsetParent);
    var documentElement = (0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $60809149f86c2179$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $07fcf859739eaae8$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $1112e259f7d2e76a$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $60809149f86c2179$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $82e56b3c9202f1bc$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $02405386c900bb58$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $02405386c900bb58$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $02405386c900bb58$var$order(modifiers); // order based on phase
    return (0, $22e99ddc6089aa5c$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $dcb610874f96ade2$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f0869ad452512909$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $c029c2062637204e$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $c029c2062637204e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $c029c2062637204e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $c029c2062637204e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $c029c2062637204e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(reference) ? (0, $bdbb9e30d785ac6a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $bdbb9e30d785ac6a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $bdbb9e30d785ac6a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $02405386c900bb58$export$2e2bcd8739ae039)((0, $f0869ad452512909$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$c029c2062637204e$var$areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $97cb7d18733c60e6$export$2e2bcd8739ae039)(_$reference, (0, $5f7645d1b576086d$export$2e2bcd8739ae039)(_$popper), state.options.strategy === 'fixed'),
                    popper: (0, $103f1f67b99aec04$export$2e2bcd8739ae039)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dcb610874f96ade2$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$c029c2062637204e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $c029c2062637204e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $c029c2062637204e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


var $030a5a9217d4d390$export$8f7491d57c8f97a9 = (0, $c029c2062637204e$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $2d88d9f94be5b0ba$export$2e2bcd8739ae039),
        (0, $3133aaf1ec566bd5$export$2e2bcd8739ae039),
        (0, $ccbbd6437d6f1dc0$export$2e2bcd8739ae039),
        (0, $ac76324de7a4bf14$export$2e2bcd8739ae039),
        (0, $311ce567045aea2b$export$2e2bcd8739ae039),
        (0, $c7ad662b98d4d1dc$export$2e2bcd8739ae039),
        (0, $00a8e20b8c0bfbdf$export$2e2bcd8739ae039),
        (0, $187ac7d7e133663b$export$2e2bcd8739ae039)
    ]
});


var $9390401862fca20b$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $9390401862fca20b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
var $9390401862fca20b$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false,
    phase: 'afterWrite',
    fn: function() {
        return undefined;
    }
};
// until docjs supports type exports...
var $9390401862fca20b$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: function(param) {
        var state = param.state;
        return function() {
            var _state_elements = state.elements, reference = _state_elements.reference, popper = _state_elements.popper;
            if ('removeAttribute' in reference) {
                var ids = (reference.getAttribute('aria-describedby') || '').split(',').filter(function(id) {
                    return id.trim() !== popper.id;
                });
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        };
    },
    fn: function(param) {
        var state = param.state;
        var _popper$getAttribute;
        var _state_elements = state.elements, popper = _state_elements.popper, reference = _state_elements.reference;
        var role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            var ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? "".concat(ids, ",").concat(popper.id) : popper.id);
        }
    }
};
var $9390401862fca20b$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $9390401862fca20b$var$usePopper(referenceElement, popperElement) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _ref_enabled = _ref.enabled, enabled = _ref_enabled === void 0 ? true : _ref_enabled, _ref_placement = _ref.placement, placement = _ref_placement === void 0 ? 'bottom' : _ref_placement, _ref_strategy = _ref.strategy, strategy = _ref_strategy === void 0 ? 'absolute' : _ref_strategy, _ref_modifiers = _ref.modifiers, modifiers = _ref_modifiers === void 0 ? $9390401862fca20b$var$EMPTY_MODIFIERS : _ref_modifiers, config = $9390401862fca20b$var$_objectWithoutPropertiesLoose(_ref, $9390401862fca20b$var$_excluded);
    var prevModifiers = (0, $lliNT.useRef)(modifiers);
    var popperInstanceRef = (0, $lliNT.useRef)();
    var update = (0, $lliNT.useCallback)(function() {
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    var forceUpdate = (0, $lliNT.useCallback)(function() {
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    var _useSafeState = (0, $f9AOD._)((0, $aae7ecc3aff66783$export$2e2bcd8739ae039)((0, $lliNT.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    })), 2), popperState = _useSafeState[0], setState = _useSafeState[1];
    var updateModifier = (0, $lliNT.useMemo)(function() {
        return {
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: function(param) {
                var state = param.state;
                var styles = {};
                var attributes = {};
                Object.keys(state.elements).forEach(function(element) {
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        };
    }, [
        update,
        forceUpdate,
        setState
    ]);
    var nextModifiers = (0, $lliNT.useMemo)(function() {
        if (!(0, $e720145b3d6bea34$export$de8294bb3be0322f)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $lliNT.useEffect)(function() {
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: (0, $aUGqu._)(nextModifiers).concat([
                updateModifier,
                $9390401862fca20b$var$disabledApplyStylesModifier
            ])
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $lliNT.useEffect)(function() {
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $030a5a9217d4d390$export$8f7491d57c8f97a9)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: (0, $aUGqu._)(nextModifiers).concat([
                $9390401862fca20b$var$ariaDescribedByModifier,
                updateModifier
            ])
        }));
        return function() {
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState(function(s) {
                    return Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    });
                });
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $9390401862fca20b$export$2e2bcd8739ae039 = $9390401862fca20b$var$usePopper;


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $a784322fcbc350d7$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}



/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $0e5e4de4085acd94$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $0e5e4de4085acd94$export$2e2bcd8739ae039 = $0e5e4de4085acd94$var$removeEventListener;


function $709dbe0f51f464e8$var$listen(node, eventName, handler, options) {
    (0, $fe9809a8616a080a$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $0e5e4de4085acd94$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $709dbe0f51f464e8$export$2e2bcd8739ae039 = $709dbe0f51f464e8$var$listen;


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $cb03b130654deaba$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

var $7b1e807e6b1a71ff$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $7b1e807e6b1a71ff$var$__DEV__ = false;
var $7b1e807e6b1a71ff$var$warning = function warning() {};
if ($7b1e807e6b1a71ff$var$__DEV__) {
    var $7b1e807e6b1a71ff$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $7b1e807e6b1a71ff$var$warning = function warning(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $7b1e807e6b1a71ff$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$7b1e807e6b1a71ff$exports = $7b1e807e6b1a71ff$var$warning;


var $dbe0b2383da860c9$var$noop = function() {};
function $dbe0b2383da860c9$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $dbe0b2383da860c9$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $dbe0b2383da860c9$export$347601c75fcd4732 = function(ref) {
    return ref && ('current' in ref ? ref.current : ref);
};
var $dbe0b2383da860c9$var$InitialTriggerEvents = {
    click: 'mousedown',
    mouseup: 'mousedown',
    pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $dbe0b2383da860c9$var$useClickOutside(ref) {
    var onClickOutside = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $dbe0b2383da860c9$var$noop, _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, disabled = _ref.disabled, _ref_clickTrigger = _ref.clickTrigger, clickTrigger = _ref_clickTrigger === void 0 ? 'click' : _ref_clickTrigger;
    var preventMouseClickOutsideRef = (0, $lliNT.useRef)(false);
    var waitingForTrigger = (0, $lliNT.useRef)(false);
    var handleMouseCapture = (0, $lliNT.useCallback)(function(e) {
        var currentTarget = $dbe0b2383da860c9$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($7b1e807e6b1a71ff$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $dbe0b2383da860c9$var$isModifiedEvent(e) || !$dbe0b2383da860c9$var$isLeftClickEvent(e) || !!(0, $a784322fcbc350d7$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    var handleInitialMouse = (0, $5ec89db9ae56f810$export$2e2bcd8739ae039)(function(e) {
        var currentTarget = $dbe0b2383da860c9$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $a784322fcbc350d7$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
        else // When clicking on scrollbars within current target, click events are not triggered, so this ref
        // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
        // to close the overlay.
        waitingForTrigger.current = false;
    });
    var handleMouse = (0, $5ec89db9ae56f810$export$2e2bcd8739ae039)(function(e) {
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $lliNT.useEffect)(function() {
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        var doc = (0, $cb03b130654deaba$export$2e2bcd8739ae039)($dbe0b2383da860c9$export$347601c75fcd4732(ref));
        var ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        var currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        var removeInitialTriggerListener = null;
        if ($dbe0b2383da860c9$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(doc, $dbe0b2383da860c9$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        var removeMouseCaptureListener = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        var removeMouseListener = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(doc, clickTrigger, function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        var mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map(function(el) {
            return (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(el, 'mousemove', $dbe0b2383da860c9$var$noop);
        });
        return function() {
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach(function(remove) {
                return remove();
            });
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $dbe0b2383da860c9$export$2e2bcd8739ae039 = $dbe0b2383da860c9$var$useClickOutside;


function $8562e54403a994ca$export$ba6dad097c8f5c38(modifiers) {
    var result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach(function(m) {
        result[m.name] = m;
    });
    return result;
}
function $8562e54403a994ca$export$af3a999d4a134c86() {
    var map = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (Array.isArray(map)) return map;
    return Object.keys(map).map(function(k) {
        map[k].name = k;
        return map[k];
    });
}
function $8562e54403a994ca$export$2e2bcd8739ae039(param) {
    var enabled = param.enabled, enableEvents = param.enableEvents, placement = param.placement, flip = param.flip, offset = param.offset, fixed = param.fixed, containerPadding = param.containerPadding, arrowElement = param.arrowElement, _param_popperConfig = param.popperConfig, popperConfig = _param_popperConfig === void 0 ? {} : _param_popperConfig;
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    var modifiers = $8562e54403a994ca$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $8562e54403a994ca$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}



var $tLNoZ = parcelRequire("tLNoZ");
var $b8a05b7865c8348f$var$_excluded = [
    "children",
    "usePopper"
];
function $b8a05b7865c8348f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
var $b8a05b7865c8348f$var$noop = function() {};
function $b8a05b7865c8348f$export$133c4d08f3775d64() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var context = (0, $lliNT.useContext)((0, $a0823358c6520d01$export$2e2bcd8739ae039));
    var _useCallbackRef = (0, $f9AOD._)((0, $f77f18df0f494e37$export$2e2bcd8739ae039)(), 2), arrowElement = _useCallbackRef[0], attachArrowRef = _useCallbackRef[1];
    var hasShownRef = (0, $lliNT.useRef)(false);
    var flip = options.flip, offset = options.offset, rootCloseEvent = options.rootCloseEvent, _options_fixed = options.fixed, fixed = _options_fixed === void 0 ? false : _options_fixed, placementOverride = options.placement, _options_popperConfig = options.popperConfig, popperConfig = _options_popperConfig === void 0 ? {} : _options_popperConfig, _options_enableEventListeners = options.enableEventListeners, enableEventListeners = _options_enableEventListeners === void 0 ? true : _options_enableEventListeners, tmp = options.usePopper, shouldUsePopper = tmp === void 0 ? !!context : tmp;
    var show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    var handleClose = function(e) {
        context == null || context.toggle(false, e);
    };
    var _ref = context || {}, placement = _ref.placement, setMenu = _ref.setMenu, menuElement = _ref.menuElement, toggleElement = _ref.toggleElement;
    var popper = (0, $9390401862fca20b$export$2e2bcd8739ae039)(toggleElement, menuElement, (0, $8562e54403a994ca$export$2e2bcd8739ae039)({
        placement: placementOverride || placement || 'bottom-start',
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    var menuProps = Object.assign({
        ref: setMenu || $b8a05b7865c8348f$var$noop,
        'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    var metadata = {
        show: show,
        placement: placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $dbe0b2383da860c9$export$2e2bcd8739ae039)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $b8a05b7865c8348f$var$DropdownMenu(_ref) {
    var children = _ref.children, tmp = _ref.usePopper, usePopperProp = tmp === void 0 ? true : tmp, options = $b8a05b7865c8348f$var$_objectWithoutPropertiesLoose(_ref, $b8a05b7865c8348f$var$_excluded);
    var _useDropdownMenu = (0, $f9AOD._)($b8a05b7865c8348f$export$133c4d08f3775d64(Object.assign({}, options, {
        usePopper: usePopperProp
    })), 2), props = _useDropdownMenu[0], meta = _useDropdownMenu[1];
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $tLNoZ.Fragment), {
        children: children(props, meta)
    });
}
$b8a05b7865c8348f$var$DropdownMenu.displayName = 'DropdownMenu';
var /** @component */ $b8a05b7865c8348f$export$2e2bcd8739ae039 = $b8a05b7865c8348f$var$DropdownMenu;



var $f9AOD = parcelRequire("f9AOD");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

var $f9AOD = parcelRequire("f9AOD");

var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rsp-rules/use-layout-effect-rule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
var $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
var $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$SSRContext = (0, $1aLYV.default).createContext($554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$defaultContext);
var $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$IsSSRContext = (0, $1aLYV.default).createContext(false);
// This is only used in React < 18.
function $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$LegacySSRProvider(props) {
    var cur = (0, $lliNT.useContext)($554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$SSRContext);
    var counter = $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$useCounter(cur === $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$defaultContext);
    var _$bl59K$useState = (0, $f9AOD._)((0, $lliNT.useState)(true), 2), isSSR = _$bl59K$useState[0], setIsSSR = _$bl59K$useState[1];
    var value = (0, $lliNT.useMemo)(function() {
        return {
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$defaultContext ? '' : "".concat(cur.prefix, "-").concat(counter),
            current: 0
        };
    }, [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $lliNT.useLayoutEffect)(function() {
        setIsSSR(false);
    }, []);
    return (0, $1aLYV.default).createElement($554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$SSRContext.Provider, {
        value: value
    }, (0, $1aLYV.default).createElement($554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
var $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$warnedAboutSSRProvider = false;
function $554bd86e888ff29b$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, $1aLYV.default)['useId'] === 'function') return (0, $1aLYV.default).createElement((0, $1aLYV.default).Fragment, null, props.children);
    return (0, $1aLYV.default).createElement($554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$LegacySSRProvider, props);
}
var $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
var $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$componentIds = new WeakMap();
function $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$useCounter() {
    var isDisabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ctx = (0, $lliNT.useContext)($554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$SSRContext);
    var ref = (0, $lliNT.useRef)(null);
    // eslint-disable-next-line rsp-rules/pure-render
    if (ref.current === null && !isDisabled) {
        var _$bl59K$react___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _$bl59K$react___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        var currentOwner = (_$bl59K$react___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, $1aLYV.default).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _$bl59K$react___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_$bl59K$react___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _$bl59K$react___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _$bl59K$react___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _$bl59K$react___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            var prevComponentValue = $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rsp-rules/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rsp-rules/pure-render
    return ref.current;
}
function $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$useLegacySSRSafeId(defaultId) {
    var ctx = (0, $lliNT.useContext)($554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    ctx === $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$defaultContext && $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$canUseDOM;
    var counter = $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$useCounter(!!defaultId);
    var prefix = "react-aria".concat(ctx.prefix);
    return defaultId || "".concat(prefix, "-").concat(counter);
}
function $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$useModernSSRSafeId(defaultId) {
    var id = (0, $1aLYV.default).useId();
    var _$bl59K$useState = (0, $f9AOD._)((0, $lliNT.useState)($554bd86e888ff29b$export$535bd6ca7f90a273()), 1), didSSR = _$bl59K$useState[0];
    var prefix = didSSR || false ? 'react-aria' : "react-aria".concat($554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$defaultContext.prefix);
    return defaultId || "".concat(prefix, "-").concat(id);
}
var $554bd86e888ff29b$export$619500959fc48b26 = typeof (0, $1aLYV.default)['useId'] === 'function' ? $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$useModernSSRSafeId : $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$useLegacySSRSafeId;
function $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$getSnapshot() {
    return false;
}
function $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$subscribe(onStoreChange) {
    // noop
    return function() {};
}
function $554bd86e888ff29b$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, $1aLYV.default)['useSyncExternalStore'] === 'function') return (0, $1aLYV.default)['useSyncExternalStore']($554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$subscribe, $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$getSnapshot, $554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $lliNT.useContext)($554bd86e888ff29b$var$$c7eafbbe1ea5834e$var$IsSSRContext);
}




var $tLNoZ = parcelRequire("tLNoZ");
var $780000ecf2235f35$export$386b1213cf9779d8 = function(el) {
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute('role')) == null ? void 0 : _el$getAttribute.toLowerCase()) === 'menu';
};
var $780000ecf2235f35$var$noop = function() {};
function $780000ecf2235f35$export$96df6c7c5036b9a2() {
    var id = (0, $554bd86e888ff29b$export$619500959fc48b26)();
    var _ref = (0, $lliNT.useContext)((0, $a0823358c6520d01$export$2e2bcd8739ae039)) || {}, _ref_show = _ref.show, show = _ref_show === void 0 ? false : _ref_show, _ref_toggle = _ref.toggle, toggle = _ref_toggle === void 0 ? $780000ecf2235f35$var$noop : _ref_toggle, setToggle = _ref.setToggle, menuElement = _ref.menuElement;
    var handleClick = (0, $lliNT.useCallback)(function(e) {
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    var props = {
        id: id,
        ref: setToggle || $780000ecf2235f35$var$noop,
        onClick: handleClick,
        'aria-expanded': !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && $780000ecf2235f35$export$386b1213cf9779d8(menuElement)) props['aria-haspopup'] = true;
    return [
        props,
        {
            show: show,
            toggle: toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $780000ecf2235f35$var$DropdownToggle(param) {
    var children = param.children;
    var _useDropdownToggle = (0, $f9AOD._)($780000ecf2235f35$export$96df6c7c5036b9a2(), 2), props = _useDropdownToggle[0], meta = _useDropdownToggle[1];
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $tLNoZ.Fragment), {
        children: children(props, meta)
    });
}
$780000ecf2235f35$var$DropdownToggle.displayName = 'DropdownToggle';
var /** @component */ $780000ecf2235f35$export$2e2bcd8739ae039 = $780000ecf2235f35$var$DropdownToggle;



var $7Pjls = parcelRequire("7Pjls");

var $f9AOD = parcelRequire("f9AOD");

var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");
var $094e1eeba7f32a66$var$SelectableContext = /*#__PURE__*/ $tLNoZ.createContext(null);
var $094e1eeba7f32a66$export$eef49b42fde998a3 = function(eventKey) {
    var href = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $094e1eeba7f32a66$export$2e2bcd8739ae039 = $094e1eeba7f32a66$var$SelectableContext;


parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");
var $b7582afae5c2a995$var$NavContext = /*#__PURE__*/ $tLNoZ.createContext(null);
$b7582afae5c2a995$var$NavContext.displayName = 'NavContext';
var $b7582afae5c2a995$export$2e2bcd8739ae039 = $b7582afae5c2a995$var$NavContext;



var $188ebaeb1748f756$export$fd7bcb7e9bef4e8a = "data-rr-ui-";
var $188ebaeb1748f756$export$635202801f9383a0 = "rrUi";
function $188ebaeb1748f756$export$5cc3b7b83e34ade7(property) {
    return "".concat($188ebaeb1748f756$export$fd7bcb7e9bef4e8a).concat(property);
}
function $188ebaeb1748f756$export$7776c0a7cd2eb3e0(property) {
    return "".concat($188ebaeb1748f756$export$635202801f9383a0).concat(property);
}



var $ee078c9ee5c95ec0$var$_excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function $ee078c9ee5c95ec0$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $ee078c9ee5c95ec0$export$522d7e1e4e0e22b2(param) {
    var key = param.key, href = param.href, active = param.active, disabled = param.disabled, onClick = param.onClick;
    var onSelectCtx = (0, $lliNT.useContext)((0, $094e1eeba7f32a66$export$2e2bcd8739ae039));
    var navContext = (0, $lliNT.useContext)((0, $b7582afae5c2a995$export$2e2bcd8739ae039));
    var activeKey = (navContext || {}).activeKey;
    var eventKey = (0, $094e1eeba7f32a66$export$eef49b42fde998a3)(key, href);
    var isActive = active == null && key != null ? (0, $094e1eeba7f32a66$export$eef49b42fde998a3)(activeKey) === eventKey : active;
    var handleClick = (0, $5ec89db9ae56f810$export$2e2bcd8739ae039)(function(event) {
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        (0, $7Pjls._)({
            onClick: handleClick,
            'aria-disabled': disabled || undefined,
            'aria-selected': isActive
        }, (0, $188ebaeb1748f756$export$5cc3b7b83e34ade7)('dropdown-item'), ''),
        {
            isActive: isActive
        }
    ];
}
var $ee078c9ee5c95ec0$var$DropdownItem = /*#__PURE__*/ $1aLYV.forwardRef(function(_ref, ref) {
    var eventKey = _ref.eventKey, disabled = _ref.disabled, onClick = _ref.onClick, active = _ref.active, tmp = _ref.as, Component = tmp === void 0 ? (0, $a2ef149eb04c6f18$export$2e2bcd8739ae039) : tmp, props = $ee078c9ee5c95ec0$var$_objectWithoutPropertiesLoose(_ref, $ee078c9ee5c95ec0$var$_excluded);
    var _useDropdownItem = (0, $f9AOD._)($ee078c9ee5c95ec0$export$522d7e1e4e0e22b2({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    }), 1), dropdownItemProps = _useDropdownItem[0];
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
$ee078c9ee5c95ec0$var$DropdownItem.displayName = 'DropdownItem';
var $ee078c9ee5c95ec0$export$2e2bcd8739ae039 = $ee078c9ee5c95ec0$var$DropdownItem;




parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");
var $lliNT = parcelRequire("lliNT");

var $079709aedd6d46b7$var$Context = /*#__PURE__*/ (0, $tLNoZ.createContext)((0, $64f258eaaf92e603$export$2e2bcd8739ae039) ? window : undefined);
var $079709aedd6d46b7$export$f7d306aeb1cf5fbc = $079709aedd6d46b7$var$Context.Provider;
function $079709aedd6d46b7$export$2e2bcd8739ae039() {
    return (0, $lliNT.useContext)($079709aedd6d46b7$var$Context);
}



function $09b7993515dcca27$var$useRefWithUpdate() {
    var forceUpdate = (0, $de985634587468d0$export$2e2bcd8739ae039)();
    var ref = (0, $lliNT.useRef)(null);
    var attachRef = (0, $lliNT.useCallback)(function(element) {
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $09b7993515dcca27$var$Dropdown(param) {
    var defaultShow = param.defaultShow, rawShow = param.show, onSelect = param.onSelect, rawOnToggle = param.onToggle, _param_itemSelector = param.itemSelector, itemSelector = _param_itemSelector === void 0 ? "* [".concat((0, $188ebaeb1748f756$export$5cc3b7b83e34ade7)('dropdown-item'), "]") : _param_itemSelector, focusFirstItemOnShow = param.focusFirstItemOnShow, _param_placement = param.placement, placement = _param_placement === void 0 ? 'bottom-start' : _param_placement, children = param.children;
    var window = (0, $079709aedd6d46b7$export$2e2bcd8739ae039)();
    var _useUncontrolledProp = (0, $f9AOD._)((0, $04ea7b391e033f55$export$2ee51287a16ca325)(rawShow, defaultShow, rawOnToggle), 2), show = _useUncontrolledProp[0], onToggle = _useUncontrolledProp[1];
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    var _useRefWithUpdate = (0, $f9AOD._)($09b7993515dcca27$var$useRefWithUpdate(), 2), menuRef = _useRefWithUpdate[0], setMenu = _useRefWithUpdate[1];
    var menuElement = menuRef.current;
    var _useRefWithUpdate1 = (0, $f9AOD._)($09b7993515dcca27$var$useRefWithUpdate(), 2), toggleRef = _useRefWithUpdate1[0], setToggle = _useRefWithUpdate1[1];
    var toggleElement = toggleRef.current;
    var lastShow = (0, $26d665efc2403b23$export$2e2bcd8739ae039)(show);
    var lastSourceEvent = (0, $lliNT.useRef)(null);
    var focusInDropdown = (0, $lliNT.useRef)(false);
    var onSelectCtx = (0, $lliNT.useContext)((0, $094e1eeba7f32a66$export$2e2bcd8739ae039));
    var toggle = (0, $lliNT.useCallback)(function(nextShow, event) {
        var source = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : event == null ? void 0 : event.type;
        onToggle(nextShow, {
            originalEvent: event,
            source: source
        });
    }, [
        onToggle
    ]);
    var handleSelect = (0, $5ec89db9ae56f810$export$2e2bcd8739ae039)(function(key, event) {
        onSelect == null || onSelect(key, event);
        toggle(false, event, 'select');
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    var context = (0, $lliNT.useMemo)(function() {
        return {
            toggle: toggle,
            placement: placement,
            show: show,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        };
    }, [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    var focusToggle = (0, $5ec89db9ae56f810$export$2e2bcd8739ae039)(function() {
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    var maybeFocusFirst = (0, $5ec89db9ae56f810$export$2e2bcd8739ae039)(function() {
        var type = lastSourceEvent.current;
        var focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $780000ecf2235f35$export$386b1213cf9779d8)(menuRef.current) ? 'keyboard' : false;
        if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) return;
        var first = (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $lliNT.useEffect)(function() {
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $lliNT.useEffect)(function() {
        lastSourceEvent.current = null;
    });
    var getNextFocusedChild = function(current, offset) {
        if (!menuRef.current) return null;
        var items = (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(menuRef.current, itemSelector);
        var index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $e02dbeaef4c9770c$export$2e2bcd8739ae039)((0, $lliNT.useCallback)(function() {
        return window.document;
    }, [
        window
    ]), 'keydown', function(event) {
        var _menuRef$current, _toggleRef$current;
        var key = event.key;
        var target = event.target;
        var fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        var fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        var isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === ' ' || key !== 'Escape' && fromMenu || key === 'Escape' && target.type === 'search')) return;
        if (!fromMenu && !fromToggle) return;
        if (key === 'Tab' && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        var meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case 'ArrowUp':
                {
                    var next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case 'ArrowDown':
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    var next1 = getNextFocusedChild(target, 1);
                    if (next1 && next1.focus) next1.focus();
                }
                return;
            case 'Tab':
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $fe9809a8616a080a$export$2e2bcd8739ae039)(target.ownerDocument, 'keyup', function(e) {
                    var _menuRef$current2;
                    if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case 'Escape':
                if (key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $094e1eeba7f32a66$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $a0823358c6520d01$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: children
        })
    });
}
$09b7993515dcca27$var$Dropdown.displayName = 'Dropdown';
$09b7993515dcca27$var$Dropdown.Menu = (0, $b8a05b7865c8348f$export$2e2bcd8739ae039);
$09b7993515dcca27$var$Dropdown.Toggle = (0, $780000ecf2235f35$export$2e2bcd8739ae039);
$09b7993515dcca27$var$Dropdown.Item = (0, $ee078c9ee5c95ec0$export$2e2bcd8739ae039);
var $09b7993515dcca27$export$2e2bcd8739ae039 = $09b7993515dcca27$var$Dropdown;



var $7E0eS = parcelRequire("7E0eS");
function $239d3bb392cc23fe$export$2e2bcd8739ae039() {
    return $239d3bb392cc23fe$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $239d3bb392cc23fe$export$2e2bcd8739ae039.apply(null, arguments);
}


function $cfc42f224c20bf43$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
var $81648fdbf254d6a1$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $81648fdbf254d6a1$var$invariant = function invariant(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$81648fdbf254d6a1$exports = $81648fdbf254d6a1$var$invariant;


var $669115b93da62075$var$noop = function noop() {};
function $669115b93da62075$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $669115b93da62075$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $669115b93da62075$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$669115b93da62075$export$26cbf8c37e721e67(prop)] = $669115b93da62075$var$noop;
        var handler;
    });
    return propTypes;
}
function $669115b93da62075$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $669115b93da62075$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $669115b93da62075$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $5e3a44538f1f449f$var$_toPropertyKey(arg) {
    var key = $5e3a44538f1f449f$var$_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, $7E0eS._)(key)) === "symbol" ? key : String(key);
}
function $5e3a44538f1f449f$var$_toPrimitive(input, hint) {
    if ((typeof input === "undefined" ? "undefined" : (0, $7E0eS._)(input)) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((typeof res === "undefined" ? "undefined" : (0, $7E0eS._)(res)) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5e3a44538f1f449f$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $lliNT.useRef)(propValue !== undefined);
    var _useState = (0, $lliNT.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $lliNT.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $5e3a44538f1f449f$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$669115b93da62075$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $cfc42f224c20bf43$export$2e2bcd8739ae039)(_ref, [
            $669115b93da62075$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($5e3a44538f1f449f$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $5e3a44538f1f449f$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $239d3bb392cc23fe$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}




function $fee305cb83d84c44$export$2e2bcd8739ae039(t, e) {
    return $fee305cb83d84c44$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, $fee305cb83d84c44$export$2e2bcd8739ae039(t, e);
}


function $03628f39fad6f2ca$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $fee305cb83d84c44$export$2e2bcd8739ae039)(t, o);
}



var $1aLYV = parcelRequire("1aLYV");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $c235d951ddc27ab7$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $c235d951ddc27ab7$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $c235d951ddc27ab7$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$c235d951ddc27ab7$var$componentWillMount.__suppressDeprecationWarning = true;
$c235d951ddc27ab7$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$c235d951ddc27ab7$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $c235d951ddc27ab7$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $c235d951ddc27ab7$var$componentWillMount;
        prototype.componentWillReceiveProps = $c235d951ddc27ab7$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $c235d951ddc27ab7$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $f8f8febea11ad7c0$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $f8f8febea11ad7c0$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $669115b93da62075$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($669115b93da62075$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($81648fdbf254d6a1$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $03628f39fad6f2ca$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $239d3bb392cc23fe$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$669115b93da62075$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $239d3bb392cc23fe$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$669115b93da62075$export$12ae2baa35bd9b8b(props, key) && $669115b93da62075$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$669115b93da62075$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $cfc42f224c20bf43$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, $1aLYV.default).createElement(Component, (0, $239d3bb392cc23fe$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, $1aLYV.default).Component);
    (0, $c235d951ddc27ab7$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $239d3bb392cc23fe$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $669115b93da62075$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, $1aLYV.default).forwardRef) {
        WrappedComponent = (0, $1aLYV.default).forwardRef(function(props, ref) {
            return (0, $1aLYV.default).createElement(UncontrolledComponent, (0, $239d3bb392cc23fe$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $f8f8febea11ad7c0$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $f8f8febea11ad7c0$export$2e2bcd8739ae039(newComponent, (0, $239d3bb392cc23fe$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}





var $aUGqu = parcelRequire("aUGqu");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $506feae80911c3cb$var$useCommittedRef(value) {
    var ref = (0, $lliNT.useRef)(value);
    (0, $lliNT.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $506feae80911c3cb$export$2e2bcd8739ae039 = $506feae80911c3cb$var$useCommittedRef;


function $ddf2f427ad010346$export$2e2bcd8739ae039(fn) {
    var ref = (0, $506feae80911c3cb$export$2e2bcd8739ae039)(fn);
    return (0, $lliNT.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _ref;
        return ref.current && (_ref = ref).current.apply(_ref, (0, $aUGqu._)(args));
    }, [
        ref
    ]);
}


parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");
"use client";
var $32cae93c7ad390ad$var$DropdownContext = /*#__PURE__*/ $tLNoZ.createContext({});
$32cae93c7ad390ad$var$DropdownContext.displayName = 'DropdownContext';
var $32cae93c7ad390ad$export$2e2bcd8739ae039 = $32cae93c7ad390ad$var$DropdownContext;



var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");



"use client";
var $b30b546ece9275aa$var$DropdownDivider = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'hr' : tmp, _param_role = _param.role, role = _param_role === void 0 ? 'separator' : _param_role, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as",
        "role"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'dropdown-divider');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix),
        role: role
    }, props));
});
$b30b546ece9275aa$var$DropdownDivider.displayName = 'DropdownDivider';
var $b30b546ece9275aa$export$2e2bcd8739ae039 = $b30b546ece9275aa$var$DropdownDivider;



var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");



"use client";
var $cfc683e9d4d82eeb$var$DropdownHeader = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, _param_role = _param.role, role = _param_role === void 0 ? 'heading' : _param_role, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as",
        "role"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'dropdown-header');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix),
        role: role
    }, props));
});
$cfc683e9d4d82eeb$var$DropdownHeader.displayName = 'DropdownHeader';
var $cfc683e9d4d82eeb$export$2e2bcd8739ae039 = $cfc683e9d4d82eeb$var$DropdownHeader;



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");


var $1aLYV = parcelRequire("1aLYV");


var $f9AOD = parcelRequire("f9AOD");

var $1aLYV = parcelRequire("1aLYV");





parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
function $503c9a9578328245$export$2e2bcd8739ae039(event, handler) {
    var capture = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var documentTarget = (0, $lliNT.useCallback)(function() {
        return document;
    }, []);
    return (0, $e02dbeaef4c9770c$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}


parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $6fe10dd818f3d005$var$useInterval(fn, ms) {
    var paused = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, runImmediately = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var handle;
    var fnRef = (0, $bd6a6b6e866a8ae9$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    var pausedRef = (0, $bd6a6b6e866a8ae9$export$2e2bcd8739ae039)(paused);
    var tick = function() {
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    var schedule = function() {
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $lliNT.useEffect)(function() {
        if (runImmediately) tick();
        else schedule();
        return function() {
            return clearTimeout(handle);
        };
    }, [
        paused,
        runImmediately
    ]);
}
var $6fe10dd818f3d005$export$2e2bcd8739ae039 = $6fe10dd818f3d005$var$useInterval;


parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

function $f4e4e89314c80fac$var$useRafInterval(fn, ms) {
    var paused = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var handle;
    var start = new Date().getTime();
    var fnRef = (0, $bd6a6b6e866a8ae9$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    var pausedRef = (0, $bd6a6b6e866a8ae9$export$2e2bcd8739ae039)(paused);
    function loop() {
        var current = new Date().getTime();
        var delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $lliNT.useEffect)(function() {
        handle = requestAnimationFrame(loop);
        return function() {
            return cancelAnimationFrame(handle);
        };
    }, []);
}
var $f4e4e89314c80fac$export$2e2bcd8739ae039 = $f4e4e89314c80fac$var$useRafInterval;



var $f9AOD = parcelRequire("f9AOD");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
function $595db43b41356bbb$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $f9AOD._)((0, $lliNT.useState)(initialState), 2), state = _useState[0], setState = _useState[1];
    var updater = (0, $lliNT.useCallback)(function(update) {
        if (update === null) return;
        if (typeof update === 'function') setState(function(state) {
            var nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState(function(state) {
            return Object.assign({}, state, update);
        });
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



var $f9AOD = parcelRequire("f9AOD");

function $23b74b6d21cc23c8$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    var _useMergeState = (0, $f9AOD._)((0, $595db43b41356bbb$export$2e2bcd8739ae039)(initialState), 2), state = _useMergeState[0], setState = _useMergeState[1];
    var nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}





var $f9AOD = parcelRequire("f9AOD");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
function $ca51470304571cf5$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    var _useState = (0, $f9AOD._)((0, $lliNT.useState)({
        image: null,
        error: null
    }), 2), state = _useState[0], setState = _useState[1];
    (0, $lliNT.useEffect)(function() {
        if (!imageOrUrl) return undefined;
        var image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return function() {
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $f9AOD = parcelRequire("f9AOD");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
var $bf7c18d913deb9a3$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
var $bf7c18d913deb9a3$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $bf7c18d913deb9a3$export$2e2bcd8739ae039 = $bf7c18d913deb9a3$var$isDOM || $bf7c18d913deb9a3$var$isReactNative ? (0, $lliNT.useLayoutEffect) : (0, $lliNT.useEffect);


var $13e255c42b37db92$var$targetMap = new WeakMap();
var $13e255c42b37db92$var$resizeObserver;
function $13e255c42b37db92$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $13e255c42b37db92$var$resizeObserver = $13e255c42b37db92$var$resizeObserver || new window.ResizeObserver(function(entries) {
        entries.forEach(function(entry) {
            var handler = $13e255c42b37db92$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $13e255c42b37db92$export$2e2bcd8739ae039(element) {
    var _useState = (0, $f9AOD._)((0, $lliNT.useState)(null), 2), rect = _useState[0], setRect = _useState[1];
    (0, $bf7c18d913deb9a3$export$2e2bcd8739ae039)(function() {
        if (!element) return;
        $13e255c42b37db92$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $13e255c42b37db92$var$targetMap.set(element, function(rect) {
            setRect(rect);
        });
        return function() {
            $13e255c42b37db92$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






var $4ee4bd8500b08465$var$_excluded = [
    "onKeyDown"
];
function $4ee4bd8500b08465$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $4ee4bd8500b08465$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ var $4ee4bd8500b08465$var$Anchor = /*#__PURE__*/ $1aLYV.forwardRef(function(_ref, ref) {
    var onKeyDown = _ref.onKeyDown, props = $4ee4bd8500b08465$var$_objectWithoutPropertiesLoose(_ref, $4ee4bd8500b08465$var$_excluded);
    var _useButtonProps = (0, $f9AOD._)((0, $a2ef149eb04c6f18$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: 'a'
    }, props)), 1), buttonProps = _useButtonProps[0];
    var handleKeyDown = (0, $5ec89db9ae56f810$export$2e2bcd8739ae039)(function(e) {
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($4ee4bd8500b08465$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$4ee4bd8500b08465$var$Anchor.displayName = 'Anchor';
var $4ee4bd8500b08465$export$2e2bcd8739ae039 = $4ee4bd8500b08465$var$Anchor;




"use client";
var $e94d23e758431609$var$DropdownItem = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, eventKey = _param.eventKey, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, onClick = _param.onClick, active = _param.active, tmp = _param.as, Component = tmp === void 0 ? (0, $4ee4bd8500b08465$export$2e2bcd8739ae039) : tmp, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "eventKey",
        "disabled",
        "onClick",
        "active",
        "as"
    ]);
    var prefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item');
    var _useDropdownItem = (0, $f9AOD._)((0, $ee078c9ee5c95ec0$export$522d7e1e4e0e22b2)({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    }), 2), dropdownItemProps = _useDropdownItem[0], meta = _useDropdownItem[1];
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({}, props, dropdownItemProps), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, prefix, meta.isActive && 'active', disabled && 'disabled')
    }));
});
$e94d23e758431609$var$DropdownItem.displayName = 'DropdownItem';
var $e94d23e758431609$export$2e2bcd8739ae039 = $e94d23e758431609$var$DropdownItem;



var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");



"use client";
var $5a9091a1c43241cf$var$DropdownItemText = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'span' : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item-text');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$5a9091a1c43241cf$var$DropdownItemText.displayName = 'DropdownItemText';
var $5a9091a1c43241cf$export$2e2bcd8739ae039 = $5a9091a1c43241cf$var$DropdownItemText;



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");


var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
var $81a7cd9979579e44$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
var $81a7cd9979579e44$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $81a7cd9979579e44$export$2e2bcd8739ae039 = $81a7cd9979579e44$var$isDOM || $81a7cd9979579e44$var$isReactNative ? (0, $lliNT.useLayoutEffect) : (0, $lliNT.useEffect);


parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
var $d9cf73fca09b1f80$var$toFnRef = function(ref) {
    return !ref || typeof ref === 'function' ? ref : function(value) {
        ref.current = value;
    };
};
function $d9cf73fca09b1f80$export$c9058316764c140e(refA, refB) {
    var a = $d9cf73fca09b1f80$var$toFnRef(refA);
    var b = $d9cf73fca09b1f80$var$toFnRef(refB);
    return function(value) {
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $d9cf73fca09b1f80$var$useMergedRefs(refA, refB) {
    return (0, $lliNT.useMemo)(function() {
        return $d9cf73fca09b1f80$export$c9058316764c140e(refA, refB);
    }, [
        refA,
        refB
    ]);
}
var $d9cf73fca09b1f80$export$2e2bcd8739ae039 = $d9cf73fca09b1f80$var$useMergedRefs;




parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");
"use client";
var $b0277c37fa5cae1c$var$context = /*#__PURE__*/ $tLNoZ.createContext(null);
$b0277c37fa5cae1c$var$context.displayName = 'InputGroupContext';
var $b0277c37fa5cae1c$export$2e2bcd8739ae039 = $b0277c37fa5cae1c$var$context;


parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");
"use client";
// TODO: check
var $8dda86df8b6e7572$var$context = /*#__PURE__*/ $tLNoZ.createContext(null);
$8dda86df8b6e7572$var$context.displayName = 'NavbarContext';
var $8dda86df8b6e7572$export$2e2bcd8739ae039 = $8dda86df8b6e7572$var$context;




parcelRequire("1aLYV");

function $f356269aec380a78$export$2e2bcd8739ae039(ref, componentName) {
    return ref;
}




"use client";
function $670e3144289cdb56$export$a2c648e264f4a946(alignEnd, dropDirection, isRTL) {
    var topStart = isRTL ? 'top-end' : 'top-start';
    var topEnd = isRTL ? 'top-start' : 'top-end';
    var bottomStart = isRTL ? 'bottom-end' : 'bottom-start';
    var bottomEnd = isRTL ? 'bottom-start' : 'bottom-end';
    var leftStart = isRTL ? 'right-start' : 'left-start';
    var leftEnd = isRTL ? 'right-end' : 'left-end';
    var rightStart = isRTL ? 'left-start' : 'right-start';
    var rightEnd = isRTL ? 'left-end' : 'right-end';
    var placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === 'up') placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === 'end') placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === 'start') placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === 'down-centered') placement = 'bottom';
    else if (dropDirection === 'up-centered') placement = 'top';
    return placement;
}
var $670e3144289cdb56$var$DropdownMenu = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, align = _param.align, rootCloseEvent = _param.rootCloseEvent, _param_flip = _param.flip, flip = _param_flip === void 0 ? true : _param_flip, showProps = _param.show, renderOnMount = _param.renderOnMount, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, popperConfig = _param.popperConfig, variant = _param.variant, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "align",
        "rootCloseEvent",
        "flip",
        "show",
        "renderOnMount",
        "as",
        "popperConfig",
        "variant"
    ]);
    var alignEnd = false;
    var isNavbar = (0, $lliNT.useContext)((0, $8dda86df8b6e7572$export$2e2bcd8739ae039));
    var prefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'dropdown-menu');
    var _useContext = (0, $lliNT.useContext)((0, $32cae93c7ad390ad$export$2e2bcd8739ae039)), contextAlign = _useContext.align, drop = _useContext.drop, isRTL = _useContext.isRTL;
    align = align || contextAlign;
    var isInputGroup = (0, $lliNT.useContext)((0, $b0277c37fa5cae1c$export$2e2bcd8739ae039));
    var alignClasses = [];
    if (align) {
        if ((typeof align === "undefined" ? "undefined" : (0, $7E0eS._)(align)) === 'object') {
            var keys = Object.keys(align);
            if (keys.length) {
                var brkPoint = keys[0];
                var direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === 'start';
                alignClasses.push("".concat(prefix, "-").concat(brkPoint, "-").concat(direction));
            }
        } else if (align === 'end') alignEnd = true;
    }
    var placement = $670e3144289cdb56$export$a2c648e264f4a946(alignEnd, drop, isRTL);
    var _useDropdownMenu = (0, $f9AOD._)((0, $b8a05b7865c8348f$export$133c4d08f3775d64)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig: popperConfig,
        placement: placement
    }), 2), menuProps = _useDropdownMenu[0], _useDropdownMenu_ = _useDropdownMenu[1], hasShown = _useDropdownMenu_.hasShown, popper = _useDropdownMenu_.popper, show = _useDropdownMenu_.show, toggle = _useDropdownMenu_.toggle;
    menuProps.ref = (0, $d9cf73fca09b1f80$export$2e2bcd8739ae039)((0, $f356269aec380a78$export$2e2bcd8739ae039)(ref, 'DropdownMenu'), menuProps.ref);
    (0, $81a7cd9979579e44$export$2e2bcd8739ae039)(function() {
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== 'string') {
        menuProps.show = show;
        menuProps.close = function() {
            return toggle == null ? void 0 : toggle(false);
        };
        menuProps.align = align;
    }
    var style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = (0, $1XAnY._)({}, props.style, menuProps.style);
        props['x-placement'] = popper.placement;
    }
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)((0, $6fpqi._)((0, $1XAnY._)({}, props, menuProps), {
        style: style
    }), (alignClasses.length || isNavbar) && {
        'data-bs-popper': 'static'
    }), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports))).apply(void 0, [
            className,
            prefix,
            show && 'show',
            alignEnd && "".concat(prefix, "-end"),
            variant && "".concat(prefix, "-").concat(variant)
        ].concat((0, $aUGqu._)(alignClasses)))
    }));
});
$670e3144289cdb56$var$DropdownMenu.displayName = 'DropdownMenu';
var $670e3144289cdb56$export$2e2bcd8739ae039 = $670e3144289cdb56$var$DropdownMenu;



var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");





var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");




"use client";
var $26ec41aa2cfcab6f$var$DropdownToggle = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, split = _param.split, className = _param.className, childBsPrefix = _param.childBsPrefix, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? (0, $3a399bf6b2fd4261$export$2e2bcd8739ae039) : tmp, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "split",
        "className",
        "childBsPrefix",
        "as"
    ]);
    var prefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'dropdown-toggle');
    var dropdownContext = (0, $lliNT.useContext)((0, $a0823358c6520d01$export$2e2bcd8739ae039));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    var _useDropdownToggle = (0, $f9AOD._)((0, $780000ecf2235f35$export$96df6c7c5036b9a2)(), 1), toggleProps = _useDropdownToggle[0];
    toggleProps.ref = (0, $d9cf73fca09b1f80$export$2e2bcd8739ae039)(toggleProps.ref, (0, $f356269aec380a78$export$2e2bcd8739ae039)(ref, 'DropdownToggle'));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, prefix, split && "".concat(prefix, "-split"), (dropdownContext == null ? void 0 : dropdownContext.show) && 'show')
    }, toggleProps, props));
});
$26ec41aa2cfcab6f$var$DropdownToggle.displayName = 'DropdownToggle';
var $26ec41aa2cfcab6f$export$2e2bcd8739ae039 = $26ec41aa2cfcab6f$var$DropdownToggle;






"use client";
var $ba2b7961c23f1087$var$Dropdown = /*#__PURE__*/ $1aLYV.forwardRef(function(pProps, ref) {
    var _useUncontrolled = (0, $5e3a44538f1f449f$export$2e2bcd8739ae039)(pProps, {
        show: 'onToggle'
    }), bsPrefix = _useUncontrolled.bsPrefix, _useUncontrolled_drop = _useUncontrolled.drop, drop = _useUncontrolled_drop === void 0 ? 'down' : _useUncontrolled_drop, show = _useUncontrolled.show, className = _useUncontrolled.className, _useUncontrolled_align = _useUncontrolled.align, align = _useUncontrolled_align === void 0 ? 'start' : _useUncontrolled_align, onSelect = _useUncontrolled.onSelect, onToggle = _useUncontrolled.onToggle, focusFirstItemOnShow = _useUncontrolled.focusFirstItemOnShow, tmp = _useUncontrolled.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, _4 = _useUncontrolled.navbar, _useUncontrolled_autoClose = _useUncontrolled.autoClose, autoClose = _useUncontrolled_autoClose === void 0 ? true : _useUncontrolled_autoClose, props = (0, $6acIq._)(_useUncontrolled, [
        "bsPrefix",
        "drop",
        "show",
        "className",
        "align",
        "onSelect",
        "onToggle",
        "focusFirstItemOnShow",
        "as",
        "navbar",
        "autoClose"
    ]);
    var isInputGroup = (0, $lliNT.useContext)((0, $b0277c37fa5cae1c$export$2e2bcd8739ae039));
    var prefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'dropdown');
    var isRTL = (0, $86d2028892b8b8bc$export$35e511eefa30ac5a)();
    var isClosingPermitted = function(source) {
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === 'click';
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === 'inside') return source !== 'rootClose';
        // autoClose=outside doesn't permit close on select
        if (autoClose === 'outside') return source !== 'select';
        return true;
    };
    var handleToggle = (0, $ddf2f427ad010346$export$2e2bcd8739ae039)(function(nextShow, meta) {
        var _meta$originalEvent;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ var isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains('dropdown-toggle');
        if (isToggleButton && meta.source === 'mousedown') return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== 'keydown' || meta.originalEvent.key === 'Escape')) meta.source = 'rootClose';
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    var alignEnd = align === 'end';
    var placement = (0, $670e3144289cdb56$export$a2c648e264f4a946)(alignEnd, drop, isRTL);
    var contextValue = (0, $lliNT.useMemo)(function() {
        return {
            align: align,
            drop: drop,
            isRTL: isRTL
        };
    }, [
        align,
        drop,
        isRTL
    ]);
    var directionClasses = {
        down: prefix,
        'down-centered': "".concat(prefix, "-center"),
        up: 'dropup',
        'up-centered': 'dropup-center dropup',
        end: 'dropend',
        start: 'dropstart'
    };
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $32cae93c7ad390ad$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $09b7993515dcca27$export$2e2bcd8739ae039), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: ".".concat(prefix, "-item:not(.disabled):not(:disabled)"),
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({}, props), {
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, show && 'show', directionClasses[drop])
            }))
        })
    });
});
$ba2b7961c23f1087$var$Dropdown.displayName = 'Dropdown';
var $ba2b7961c23f1087$export$2e2bcd8739ae039 = Object.assign($ba2b7961c23f1087$var$Dropdown, {
    Toggle: (0, $26ec41aa2cfcab6f$export$2e2bcd8739ae039),
    Menu: (0, $670e3144289cdb56$export$2e2bcd8739ae039),
    Item: (0, $e94d23e758431609$export$2e2bcd8739ae039),
    ItemText: (0, $5a9091a1c43241cf$export$2e2bcd8739ae039),
    Divider: (0, $b30b546ece9275aa$export$2e2bcd8739ae039),
    Header: (0, $cfc683e9d4d82eeb$export$2e2bcd8739ae039)
});


var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");
var $dbf9032451b6d05a$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dbf9032451b6d05a$var$ReactIs, $dbf9032451b6d05a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$dbf9032451b6d05a$exports = (parcelRequire("dNvVv"))();




"use client";
var $9f5f1ff841daa39a$export$513805011eaa4892 = {
    /**
   * @default 'img'
   */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).string,
    /**
   * Sets image as fluid image.
   */ fluid: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool,
    /**
   * Sets image shape as rounded.
   */ rounded: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool,
    /**
   * Sets image shape as circle.
   */ roundedCircle: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool,
    /**
   * Sets image shape as thumbnail.
   */ thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool
};
var $9f5f1ff841daa39a$var$Image = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, _param_fluid = _param.fluid, fluid = _param_fluid === void 0 ? false : _param_fluid, _param_rounded = _param.rounded, rounded = _param_rounded === void 0 ? false : _param_rounded, _param_roundedCircle = _param.roundedCircle, roundedCircle = _param_roundedCircle === void 0 ? false : _param_roundedCircle, _param_thumbnail = _param.thumbnail, thumbnail = _param_thumbnail === void 0 ? false : _param_thumbnail, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "fluid",
        "rounded",
        "roundedCircle",
        "thumbnail"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'img');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("img", (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, fluid && "".concat(bsPrefix, "-fluid"), rounded && "rounded", roundedCircle && "rounded-circle", thumbnail && "".concat(bsPrefix, "-thumbnail"))
    }));
});
$9f5f1ff841daa39a$var$Image.displayName = 'Image';
var $9f5f1ff841daa39a$export$2e2bcd8739ae039 = $9f5f1ff841daa39a$var$Image;


var $7Pjls = parcelRequire("7Pjls");

var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");



var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
var $3459e60253622435$var$toFnRef = function(ref) {
    return !ref || typeof ref === 'function' ? ref : function(value) {
        ref.current = value;
    };
};
function $3459e60253622435$export$c9058316764c140e(refA, refB) {
    var a = $3459e60253622435$var$toFnRef(refA);
    var b = $3459e60253622435$var$toFnRef(refB);
    return function(value) {
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $3459e60253622435$var$useMergedRefs(refA, refB) {
    return (0, $lliNT.useMemo)(function() {
        return $3459e60253622435$export$c9058316764c140e(refA, refB);
    }, [
        refA,
        refB
    ]);
}
var $3459e60253622435$export$2e2bcd8739ae039 = $3459e60253622435$var$useMergedRefs;




parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");
var $4e0598df428c23ae$var$TabContext = /*#__PURE__*/ $tLNoZ.createContext(null);
var $4e0598df428c23ae$export$2e2bcd8739ae039 = $4e0598df428c23ae$var$TabContext;




var $f9AOD = parcelRequire("f9AOD");

var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");







var $5368ecd0a34b828d$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $5368ecd0a34b828d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $5368ecd0a34b828d$export$d7a68693710982a(param) {
    var key = param.key, onClick = param.onClick, active = param.active, id = param.id, role = param.role, disabled = param.disabled;
    var parentOnSelect = (0, $lliNT.useContext)((0, $094e1eeba7f32a66$export$2e2bcd8739ae039));
    var navContext = (0, $lliNT.useContext)((0, $b7582afae5c2a995$export$2e2bcd8739ae039));
    var tabContext = (0, $lliNT.useContext)((0, $4e0598df428c23ae$export$2e2bcd8739ae039));
    var isActive = active;
    var props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        var contextControllerId = navContext.getControllerId(key != null ? key : null);
        var contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $188ebaeb1748f756$export$5cc3b7b83e34ade7)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $5ec89db9ae56f810$export$2e2bcd8739ae039)(function(e) {
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
var $5368ecd0a34b828d$var$NavItem = /*#__PURE__*/ $1aLYV.forwardRef(function(_ref, ref) {
    var tmp = _ref.as, Component = tmp === void 0 ? (0, $a2ef149eb04c6f18$export$2e2bcd8739ae039) : tmp, active = _ref.active, eventKey = _ref.eventKey, options = $5368ecd0a34b828d$var$_objectWithoutPropertiesLoose(_ref, $5368ecd0a34b828d$var$_excluded);
    var _useNavItem = (0, $f9AOD._)($5368ecd0a34b828d$export$d7a68693710982a(Object.assign({
        key: (0, $094e1eeba7f32a66$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options)), 2), props = _useNavItem[0], meta = _useNavItem[1];
    // @ts-ignore
    props[(0, $188ebaeb1748f756$export$5cc3b7b83e34ade7)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$5368ecd0a34b828d$var$NavItem.displayName = 'NavItem';
var $5368ecd0a34b828d$export$2e2bcd8739ae039 = $5368ecd0a34b828d$var$NavItem;



var $bd6614cfa53ddf4a$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $bd6614cfa53ddf4a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
var $bd6614cfa53ddf4a$var$noop = function() {};
var $bd6614cfa53ddf4a$var$EVENT_KEY_ATTR = (0, $188ebaeb1748f756$export$5cc3b7b83e34ade7)('event-key');
var $bd6614cfa53ddf4a$var$Nav = /*#__PURE__*/ $1aLYV.forwardRef(function(_ref, ref) {
    var tmp = _ref.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, onSelect = _ref.onSelect, activeKey = _ref.activeKey, role = _ref.role, onKeyDown = _ref.onKeyDown, props = $bd6614cfa53ddf4a$var$_objectWithoutPropertiesLoose(_ref, $bd6614cfa53ddf4a$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    var forceUpdate = (0, $de985634587468d0$export$2e2bcd8739ae039)();
    var needsRefocusRef = (0, $lliNT.useRef)(false);
    var parentOnSelect = (0, $lliNT.useContext)((0, $094e1eeba7f32a66$export$2e2bcd8739ae039));
    var tabContext = (0, $lliNT.useContext)((0, $4e0598df428c23ae$export$2e2bcd8739ae039));
    var getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    var listNode = (0, $lliNT.useRef)(null);
    var getNextActiveTab = function(offset) {
        var currentListNode = listNode.current;
        if (!currentListNode) return null;
        var items = (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(currentListNode, "[".concat($bd6614cfa53ddf4a$var$EVENT_KEY_ATTR, "]:not([aria-disabled=true])"));
        var activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        var index = items.indexOf(activeChild);
        if (index === -1) return null;
        var nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    var handleSelect = function(key, event) {
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    var handleKeyDown = function(event) {
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        var nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $188ebaeb1748f756$export$7776c0a7cd2eb3e0)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $lliNT.useEffect)(function() {
        if (listNode.current && needsRefocusRef.current) {
            var activeChild = listNode.current.querySelector("[".concat($bd6614cfa53ddf4a$var$EVENT_KEY_ATTR, "][aria-selected=true]"));
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    var mergedRef = (0, $3459e60253622435$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $094e1eeba7f32a66$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $b7582afae5c2a995$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $094e1eeba7f32a66$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $bd6614cfa53ddf4a$var$noop,
                getControllerId: getControllerId || $bd6614cfa53ddf4a$var$noop
            },
            children: /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$bd6614cfa53ddf4a$var$Nav.displayName = 'Nav';
var $bd6614cfa53ddf4a$export$2e2bcd8739ae039 = Object.assign($bd6614cfa53ddf4a$var$Nav, {
    Item: (0, $5368ecd0a34b828d$export$2e2bcd8739ae039)
});






var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");



"use client";
var $bbae54e7316aab1f$var$NavItem = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$bbae54e7316aab1f$var$NavItem.displayName = 'NavItem';
var $bbae54e7316aab1f$export$2e2bcd8739ae039 = $bbae54e7316aab1f$var$NavItem;



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");


var $1aLYV = parcelRequire("1aLYV");





"use client";
var $22952fa7861d3676$var$NavLink = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, tmp = _param.as, Component = tmp === void 0 ? (0, $4ee4bd8500b08465$export$2e2bcd8739ae039) : tmp, active = _param.active, eventKey = _param.eventKey, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "as",
        "active",
        "eventKey",
        "disabled"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'nav-link');
    var _useNavItem = (0, $f9AOD._)((0, $5368ecd0a34b828d$export$d7a68693710982a)((0, $1XAnY._)({
        key: (0, $094e1eeba7f32a66$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled
    }, props)), 2), navItemProps = _useNavItem[0], meta = _useNavItem[1];
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({}, props, navItemProps), {
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    }));
});
$22952fa7861d3676$var$NavLink.displayName = 'NavLink';
var $22952fa7861d3676$export$2e2bcd8739ae039 = $22952fa7861d3676$var$NavLink;



"use client";
var $b36744b28a8e5731$var$Nav = /*#__PURE__*/ $1aLYV.forwardRef(function(uncontrolledProps, ref) {
    var _useUncontrolled = (0, $5e3a44538f1f449f$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: 'onSelect'
    }), _useUncontrolled_as = _useUncontrolled.as, as = _useUncontrolled_as === void 0 ? 'div' : _useUncontrolled_as, initialBsPrefix = _useUncontrolled.bsPrefix, variant = _useUncontrolled.variant, _useUncontrolled_fill = _useUncontrolled.fill, fill = _useUncontrolled_fill === void 0 ? false : _useUncontrolled_fill, _useUncontrolled_justify = _useUncontrolled.justify, justify = _useUncontrolled_justify === void 0 ? false : _useUncontrolled_justify, navbar = _useUncontrolled.navbar, navbarScroll = _useUncontrolled.navbarScroll, className = _useUncontrolled.className, activeKey = _useUncontrolled.activeKey, props = (0, $6acIq._)(_useUncontrolled, [
        "as",
        "bsPrefix",
        "variant",
        "fill",
        "justify",
        "navbar",
        "navbarScroll",
        "className",
        "activeKey"
    ]);
    var bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(initialBsPrefix, 'nav');
    var navbarBsPrefix;
    var cardHeaderBsPrefix;
    var isNavbar = false;
    var navbarContext = (0, $lliNT.useContext)((0, $8dda86df8b6e7572$export$2e2bcd8739ae039));
    var cardHeaderContext = (0, $lliNT.useContext)((0, $30bbb1217fcc28a5$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) cardHeaderBsPrefix = cardHeaderContext.cardHeaderBsPrefix;
    var _obj;
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $bd6614cfa53ddf4a$export$2e2bcd8739ae039), (0, $1XAnY._)({
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, (_obj = {}, (0, $7Pjls._)(_obj, bsPrefix, !isNavbar), (0, $7Pjls._)(_obj, "".concat(navbarBsPrefix, "-nav"), isNavbar), (0, $7Pjls._)(_obj, "".concat(navbarBsPrefix, "-nav-scroll"), isNavbar && navbarScroll), (0, $7Pjls._)(_obj, "".concat(cardHeaderBsPrefix, "-").concat(variant), !!cardHeaderBsPrefix), (0, $7Pjls._)(_obj, "".concat(bsPrefix, "-").concat(variant), !!variant), (0, $7Pjls._)(_obj, "".concat(bsPrefix, "-fill"), fill), (0, $7Pjls._)(_obj, "".concat(bsPrefix, "-justified"), justify), _obj))
    }, props));
});
$b36744b28a8e5731$var$Nav.displayName = 'Nav';
var $b36744b28a8e5731$export$2e2bcd8739ae039 = Object.assign($b36744b28a8e5731$var$Nav, {
    Item: (0, $bbae54e7316aab1f$export$2e2bcd8739ae039),
    Link: (0, $22952fa7861d3676$export$2e2bcd8739ae039)
});


var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");



var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
function $31155a7e1f6e8422$export$2e2bcd8739ae039() {
    var mounted = (0, $lliNT.useRef)(true);
    var isMounted = (0, $lliNT.useRef)(function() {
        return mounted.current;
    });
    (0, $lliNT.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}


parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
function $bd8ffe5b764a4e1f$export$2e2bcd8739ae039(value) {
    var valueRef = (0, $lliNT.useRef)(value);
    valueRef.current = value;
    return valueRef;
}


parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
function $869fff146bdda3b2$export$2e2bcd8739ae039(fn) {
    var onUnmount = (0, $bd8ffe5b764a4e1f$export$2e2bcd8739ae039)(fn);
    (0, $lliNT.useEffect)(function() {
        return function() {
            return onUnmount.current();
        };
    }, []);
}


/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ var $8c85993f098c3baa$var$MAX_DELAY_MS = Math.pow(2, 31) - 1;
function $8c85993f098c3baa$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    var delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $8c85993f098c3baa$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(function() {
        return $8c85993f098c3baa$var$setChainedTimeout(handleRef, fn, timeoutAtMs);
    }, $8c85993f098c3baa$var$MAX_DELAY_MS);
}
function $8c85993f098c3baa$export$2e2bcd8739ae039() {
    var isMounted = (0, $31155a7e1f6e8422$export$2e2bcd8739ae039)();
    // types are confused between node and web here IDK
    var handleRef = (0, $lliNT.useRef)();
    (0, $869fff146bdda3b2$export$2e2bcd8739ae039)(function() {
        return clearTimeout(handleRef.current);
    });
    return (0, $lliNT.useMemo)(function() {
        var clear = function() {
            return clearTimeout(handleRef.current);
        };
        function set(fn) {
            var delayMs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            if (!isMounted()) return;
            clear();
            if (delayMs <= $8c85993f098c3baa$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $8c85993f098c3baa$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear,
            handleRef: handleRef
        };
    }, []);
}






var $1aLYV = parcelRequire("1aLYV");
function $71a632d108d6b21a$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $71a632d108d6b21a$export$13e065f3a74cfe36() {
    var parts = $1aLYV.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $71a632d108d6b21a$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    var major = $71a632d108d6b21a$export$13e065f3a74cfe36().major;
    var childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");

var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");


var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

var $1aLYV = parcelRequire("1aLYV");





parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");



var $3577d4ac64860ca6$var$noop = function() {};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $3577d4ac64860ca6$var$useRootClose(ref, onRootClose) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, disabled = _ref.disabled, clickTrigger = _ref.clickTrigger;
    var onClose = onRootClose || $3577d4ac64860ca6$var$noop;
    (0, $dbe0b2383da860c9$export$2e2bcd8739ae039)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    var handleKeyUp = (0, $5ec89db9ae56f810$export$2e2bcd8739ae039)(function(e) {
        if ((0, $71a632d108d6b21a$export$806fcc22e55e107d)(e)) onClose(e);
    });
    (0, $lliNT.useEffect)(function() {
        if (disabled || ref == null) return undefined;
        var doc = (0, $cb03b130654deaba$export$2e2bcd8739ae039)((0, $dbe0b2383da860c9$export$347601c75fcd4732)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        var currentEvent = (doc.defaultView || window).event;
        var removeKeyupListener = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(doc, 'keyup', function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return function() {
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $3577d4ac64860ca6$export$2e2bcd8739ae039 = $3577d4ac64860ca6$var$useRootClose;



var $f9AOD = parcelRequire("f9AOD");


parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

var $3e4e7ed48ef00c3f$export$c91fd81e6d65f84a = function(ref, document) {
    if (!(0, $64f258eaaf92e603$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $cb03b130654deaba$export$2e2bcd8739ae039)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $3e4e7ed48ef00c3f$export$2e2bcd8739ae039(ref, onResolved) {
    var window = (0, $079709aedd6d46b7$export$2e2bcd8739ae039)();
    var _useState = (0, $f9AOD._)((0, $lliNT.useState)(function() {
        return $3e4e7ed48ef00c3f$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document);
    }), 2), resolvedRef = _useState[0], setRef = _useState[1];
    if (!resolvedRef) {
        var earlyRef = $3e4e7ed48ef00c3f$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $lliNT.useEffect)(function() {
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $lliNT.useEffect)(function() {
        var nextRef = $3e4e7ed48ef00c3f$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}




var $f9AOD = parcelRequire("f9AOD");




var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");



var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

function $7d9a698a1897acef$var$NoopTransition(param) {
    var children = param.children, inProp = param.in, onExited = param.onExited, mountOnEnter = param.mountOnEnter, unmountOnExit = param.unmountOnExit;
    var ref = (0, $lliNT.useRef)(null);
    var hasEnteredRef = (0, $lliNT.useRef)(inProp);
    var handleExited = (0, $5ec89db9ae56f810$export$2e2bcd8739ae039)(onExited);
    (0, $lliNT.useEffect)(function() {
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    var combinedRef = (0, $3459e60253622435$export$2e2bcd8739ae039)(ref, (0, $71a632d108d6b21a$export$87943f2672146d57)(children));
    var child = /*#__PURE__*/ (0, $1aLYV.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $7d9a698a1897acef$export$2e2bcd8739ae039 = $7d9a698a1897acef$var$NoopTransition;



var $1aLYV = parcelRequire("1aLYV");

var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");


var $2d753b9d39c936b0$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $2d753b9d39c936b0$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $2d753b9d39c936b0$export$2e2bcd8739ae039(_ref) {
    var onEnter = _ref.onEnter, onEntering = _ref.onEntering, onEntered = _ref.onEntered, onExit = _ref.onExit, onExiting = _ref.onExiting, onExited = _ref.onExited, addEndListener = _ref.addEndListener, children = _ref.children, props = $2d753b9d39c936b0$var$_objectWithoutPropertiesLoose(_ref, $2d753b9d39c936b0$var$_excluded);
    var nodeRef = (0, $lliNT.useRef)(null);
    var mergedRef = (0, $3459e60253622435$export$2e2bcd8739ae039)(nodeRef, (0, $71a632d108d6b21a$export$87943f2672146d57)(children));
    var normalize = function(callback) {
        return function(param) {
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    };
    /* eslint-disable react-hooks/exhaustive-deps */ var handleEnter = (0, $lliNT.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    var handleEntering = (0, $lliNT.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    var handleEntered = (0, $lliNT.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    var handleExit = (0, $lliNT.useCallback)(normalize(onExit), [
        onExit
    ]);
    var handleExiting = (0, $lliNT.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    var handleExited = (0, $lliNT.useCallback)(normalize(onExited), [
        onExited
    ]);
    var handleAddEndListener = (0, $lliNT.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? function(status, innerProps) {
            return(// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })));
        } : /*#__PURE__*/ (0, $1aLYV.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



var $0232b3d6f6973509$var$_excluded = [
    "component"
];
function $0232b3d6f6973509$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
var $0232b3d6f6973509$var$RTGTransition = /*#__PURE__*/ $1aLYV.forwardRef(function(_ref, ref) {
    var Component = _ref.component, props = $0232b3d6f6973509$var$_objectWithoutPropertiesLoose(_ref, $0232b3d6f6973509$var$_excluded);
    var transitionProps = (0, $2d753b9d39c936b0$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $0232b3d6f6973509$export$2e2bcd8739ae039 = $0232b3d6f6973509$var$RTGTransition;




function $1087e75f6d43f4d5$export$7b286972b8d8ccbf(param) {
    var inProp = param.in, onTransition = param.onTransition;
    var ref = (0, $lliNT.useRef)(null);
    var isInitialRef = (0, $lliNT.useRef)(true);
    var handleTransition = (0, $5ec89db9ae56f810$export$2e2bcd8739ae039)(onTransition);
    (0, $bf7c18d913deb9a3$export$2e2bcd8739ae039)(function() {
        if (!ref.current) return undefined;
        var stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: function() {
                return stale;
            }
        });
        return function() {
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $bf7c18d913deb9a3$export$2e2bcd8739ae039)(function() {
        isInitialRef.current = false;
        // this is for strict mode
        return function() {
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $1087e75f6d43f4d5$export$2e2bcd8739ae039(param) {
    var children = param.children, inProp = param.in, onExited = param.onExited, onEntered = param.onEntered, transition = param.transition;
    var _useState = (0, $f9AOD._)((0, $lliNT.useState)(!inProp), 2), exited = _useState[0], setExited = _useState[1];
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    var ref = $1087e75f6d43f4d5$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: function(options) {
            var onFinish = function() {
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, function(error) {
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    var combinedRef = (0, $3459e60253622435$export$2e2bcd8739ae039)(ref, (0, $71a632d108d6b21a$export$87943f2672146d57)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $1aLYV.cloneElement)(children, {
        ref: combinedRef
    });
}
function $1087e75f6d43f4d5$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $0232b3d6f6973509$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($1087e75f6d43f4d5$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $7d9a698a1897acef$export$2e2bcd8739ae039), Object.assign({}, props));
}


/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ var $f54e9d0794838e2d$var$Overlay = /*#__PURE__*/ $1aLYV.forwardRef(function(props, outerRef) {
    var flip = props.flip, offset = props.offset, placement = props.placement, containerPadding = props.containerPadding, _props_popperConfig = props.popperConfig, popperConfig = _props_popperConfig === void 0 ? {} : _props_popperConfig, Transition = props.transition, runTransition = props.runTransition;
    var _useCallbackRef = (0, $f9AOD._)((0, $f77f18df0f494e37$export$2e2bcd8739ae039)(), 2), rootElement = _useCallbackRef[0], attachRef = _useCallbackRef[1];
    var _useCallbackRef1 = (0, $f9AOD._)((0, $f77f18df0f494e37$export$2e2bcd8739ae039)(), 2), arrowElement = _useCallbackRef1[0], attachArrowRef = _useCallbackRef1[1];
    var mergedRef = (0, $3459e60253622435$export$2e2bcd8739ae039)(attachRef, outerRef);
    var container = (0, $3e4e7ed48ef00c3f$export$2e2bcd8739ae039)(props.container);
    var target = (0, $3e4e7ed48ef00c3f$export$2e2bcd8739ae039)(props.target);
    var _useState = (0, $f9AOD._)((0, $lliNT.useState)(!props.show), 2), exited = _useState[0], setExited = _useState[1];
    var popper = (0, $9390401862fca20b$export$2e2bcd8739ae039)(target, rootElement, (0, $8562e54403a994ca$export$2e2bcd8739ae039)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    var handleHidden = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _props;
        setExited(true);
        if (props.onExited) (_props = props).onExited.apply(_props, (0, $aUGqu._)(args));
    };
    // Don't un-render the overlay while it's transitioning out.
    var mountOverlay = props.show || !exited;
    (0, $3577d4ac64860ca6$export$2e2bcd8739ae039)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    var onExit = props.onExit, onExiting = props.onExiting, onEnter = props.onEnter, onEntering = props.onEntering, onEntered = props.onEntered;
    var child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper: popper,
        placement: placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, $1087e75f6d43f4d5$export$f41d64aae6d6dba5)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    });
    return container ? /*#__PURE__*/ (0, $1aLYV.default).createPortal(child, container) : null;
});
$f54e9d0794838e2d$var$Overlay.displayName = 'Overlay';
var $f54e9d0794838e2d$export$2e2bcd8739ae039 = $f54e9d0794838e2d$var$Overlay;





parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $00f98d1dc049abf7$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}




var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");


var $1aLYV = parcelRequire("1aLYV");


var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");



"use client";
var $cad8e1cb06ed9525$var$PopoverHeader = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'popover-header');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$cad8e1cb06ed9525$var$PopoverHeader.displayName = 'PopoverHeader';
var $cad8e1cb06ed9525$export$2e2bcd8739ae039 = $cad8e1cb06ed9525$var$PopoverHeader;



var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");



"use client";
var $52f068fe77b36e93$var$PopoverBody = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'popover-body');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$52f068fe77b36e93$var$PopoverBody.displayName = 'PopoverBody';
var $52f068fe77b36e93$export$2e2bcd8739ae039 = $52f068fe77b36e93$var$PopoverBody;



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $hdIku = parcelRequire("hdIku");
parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");
var $40a77d6b6c784015$export$34582a676b91ff07 = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $hdIku._)(BsPrefixComponent, _React_Component);
    function BsPrefixComponent() {
        (0, $173N4._)(this, BsPrefixComponent);
        return (0, $7qXGD._)(this, BsPrefixComponent, arguments);
    }
    return BsPrefixComponent;
}($tLNoZ.Component);
function $40a77d6b6c784015$export$c15856915a9b3464(placement, isRTL) {
    var bsDirection = placement;
    if (placement === 'left') bsDirection = isRTL ? 'end' : 'start';
    else if (placement === 'right') bsDirection = isRTL ? 'start' : 'end';
    return bsDirection;
}


function $eb72c99d6f65ddbc$export$2e2bcd8739ae039() {
    var position = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'absolute';
    return {
        position: position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
}



"use client";
var $3894e6db5e8cc0da$var$Popover = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, _param_placement = _param.placement, placement = _param_placement === void 0 ? 'right' : _param_placement, className = _param.className, style = _param.style, children = _param.children, body = _param.body, arrowProps = _param.arrowProps, hasDoneInitialMeasure = _param.hasDoneInitialMeasure, popper = _param.popper, show = _param.show, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "placement",
        "className",
        "style",
        "children",
        "body",
        "arrowProps",
        "hasDoneInitialMeasure",
        "popper",
        "show"
    ]);
    var decoratedBsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'popover');
    var isRTL = (0, $86d2028892b8b8bc$export$35e511eefa30ac5a)();
    var _ref = (0, $f9AOD._)((placement == null ? void 0 : placement.split('-')) || [], 1), primaryPlacement = _ref[0];
    var bsDirection = (0, $40a77d6b6c784015$export$c15856915a9b3464)(primaryPlacement, isRTL);
    var computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = (0, $1XAnY._)({}, style, (0, $eb72c99d6f65ddbc$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy));
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, decoratedBsPrefix, primaryPlacement && "bs-popover-".concat(bsDirection))
    }, props), {
        children: [
            /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", (0, $1XAnY._)({
                className: "popover-arrow"
            }, arrowProps)),
            body ? /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $52f068fe77b36e93$export$2e2bcd8739ae039), {
                children: children
            }) : children
        ]
    }));
});
$3894e6db5e8cc0da$var$Popover.displayName = 'Popover';
var $3894e6db5e8cc0da$export$2e2bcd8739ae039 = Object.assign($3894e6db5e8cc0da$var$Popover, {
    Header: (0, $cad8e1cb06ed9525$export$2e2bcd8739ae039),
    Body: (0, $52f068fe77b36e93$export$2e2bcd8739ae039),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");


var $1aLYV = parcelRequire("1aLYV");




"use client";
var $4777d7db4f8553f1$var$Tooltip = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, _param_placement = _param.placement, placement = _param_placement === void 0 ? 'right' : _param_placement, className = _param.className, style = _param.style, children = _param.children, arrowProps = _param.arrowProps, hasDoneInitialMeasure = _param.hasDoneInitialMeasure, popper = _param.popper, show = _param.show, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "placement",
        "className",
        "style",
        "children",
        "arrowProps",
        "hasDoneInitialMeasure",
        "popper",
        "show"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'tooltip');
    var isRTL = (0, $86d2028892b8b8bc$export$35e511eefa30ac5a)();
    var _ref = (0, $f9AOD._)((placement == null ? void 0 : placement.split('-')) || [], 1), primaryPlacement = _ref[0];
    var bsDirection = (0, $40a77d6b6c784015$export$c15856915a9b3464)(primaryPlacement, isRTL);
    var computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = (0, $1XAnY._)({}, style, (0, $eb72c99d6f65ddbc$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy));
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, "bs-tooltip-".concat(bsDirection))
    }, props), {
        children: [
            /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", (0, $1XAnY._)({
                className: "tooltip-arrow"
            }, arrowProps)),
            /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                className: "".concat(bsPrefix, "-inner"),
                children: children
            })
        ]
    }));
});
$4777d7db4f8553f1$var$Tooltip.displayName = 'Tooltip';
var $4777d7db4f8553f1$export$2e2bcd8739ae039 = Object.assign($4777d7db4f8553f1$var$Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});


"use client";
function $bdafe5a34e8c64ba$export$2e2bcd8739ae039(customOffset) {
    var overlayRef = (0, $lliNT.useRef)(null);
    var popoverClass = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(undefined, 'popover');
    var tooltipClass = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(undefined, 'tooltip');
    var offset = (0, $lliNT.useMemo)(function() {
        return {
            name: 'offset',
            options: {
                offset: function() {
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, $00f98d1dc049abf7$export$2e2bcd8739ae039)(overlayRef.current, popoverClass)) return (0, $3894e6db5e8cc0da$export$2e2bcd8739ae039).POPPER_OFFSET;
                        if ((0, $00f98d1dc049abf7$export$2e2bcd8739ae039)(overlayRef.current, tooltipClass)) return (0, $4777d7db4f8553f1$export$2e2bcd8739ae039).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        };
    }, [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}



var $7Pjls = parcelRequire("7Pjls");

var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");




var $1aLYV = parcelRequire("1aLYV");

var $1aLYV = parcelRequire("1aLYV");
var $164fd31de23ce069$export$2e2bcd8739ae039 = {
    disabled: false
};




var $1aLYV = parcelRequire("1aLYV");
var $e3c79cd5ab0d760e$export$2e2bcd8739ae039 = (0, $1aLYV.default).createContext(null);


var $d71c7449d8909c6d$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $496c06162fdc2120$export$bb38bb9a1161268 = 'unmounted';
var $496c06162fdc2120$export$84cbff306f539230 = 'exited';
var $496c06162fdc2120$export$df38205c966be359 = 'entering';
var $496c06162fdc2120$export$78e9e6e3e014d60a = 'entered';
var $496c06162fdc2120$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $496c06162fdc2120$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $03628f39fad6f2ca$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $496c06162fdc2120$export$84cbff306f539230;
                _this.appearStatus = $496c06162fdc2120$export$df38205c966be359;
            } else initialStatus = $496c06162fdc2120$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $496c06162fdc2120$export$bb38bb9a1161268;
        else initialStatus = $496c06162fdc2120$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $496c06162fdc2120$export$bb38bb9a1161268) return {
            status: $496c06162fdc2120$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $496c06162fdc2120$export$df38205c966be359 && status !== $496c06162fdc2120$export$78e9e6e3e014d60a) nextStatus = $496c06162fdc2120$export$df38205c966be359;
            } else if (status === $496c06162fdc2120$export$df38205c966be359 || status === $496c06162fdc2120$export$78e9e6e3e014d60a) nextStatus = $496c06162fdc2120$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $496c06162fdc2120$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, $1aLYV.default).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $d71c7449d8909c6d$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $496c06162fdc2120$export$84cbff306f539230) this.setState({
            status: $496c06162fdc2120$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, $1aLYV.default).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $164fd31de23ce069$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $496c06162fdc2120$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $496c06162fdc2120$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $496c06162fdc2120$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, $1aLYV.default).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $164fd31de23ce069$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $496c06162fdc2120$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $496c06162fdc2120$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $496c06162fdc2120$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, $1aLYV.default).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $496c06162fdc2120$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $cfc42f224c20bf43$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, $1aLYV.default).createElement((0, $e3c79cd5ab0d760e$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, $1aLYV.default).cloneElement((0, $1aLYV.default).Children.only(children), childProps)));
    };
    return Transition;
}((0, $1aLYV.default).Component);
$496c06162fdc2120$var$Transition.contextType = (0, $e3c79cd5ab0d760e$export$2e2bcd8739ae039);
$496c06162fdc2120$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $496c06162fdc2120$var$noop() {}
$496c06162fdc2120$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $496c06162fdc2120$var$noop,
    onEntering: $496c06162fdc2120$var$noop,
    onEntered: $496c06162fdc2120$var$noop,
    onExit: $496c06162fdc2120$var$noop,
    onExiting: $496c06162fdc2120$var$noop,
    onExited: $496c06162fdc2120$var$noop
};
$496c06162fdc2120$var$Transition.UNMOUNTED = $496c06162fdc2120$export$bb38bb9a1161268;
$496c06162fdc2120$var$Transition.EXITED = $496c06162fdc2120$export$84cbff306f539230;
$496c06162fdc2120$var$Transition.ENTERING = $496c06162fdc2120$export$df38205c966be359;
$496c06162fdc2120$var$Transition.ENTERED = $496c06162fdc2120$export$78e9e6e3e014d60a;
$496c06162fdc2120$var$Transition.EXITING = $496c06162fdc2120$export$4aacc83d4d59139f;
var $496c06162fdc2120$export$2e2bcd8739ae039 = $496c06162fdc2120$var$Transition;




function $a9aa5d166d13a472$export$2e2bcd8739ae039(node) {
    var doc = (0, $cb03b130654deaba$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $bb63774a12698c7f$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $a9aa5d166d13a472$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $f8efbd1b1d8a9be0$var$rUpper = /([A-Z])/g;
function $f8efbd1b1d8a9be0$export$2e2bcd8739ae039(string) {
    return string.replace($f8efbd1b1d8a9be0$var$rUpper, '-$1').toLowerCase();
}


var $f10058893718c5ed$var$msPattern = /^ms-/;
function $f10058893718c5ed$export$2e2bcd8739ae039(string) {
    return (0, $f8efbd1b1d8a9be0$export$2e2bcd8739ae039)(string).replace($f10058893718c5ed$var$msPattern, '-ms-');
}


var $edfb6b9719fedecb$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $edfb6b9719fedecb$export$2e2bcd8739ae039(value) {
    return !!(value && $edfb6b9719fedecb$var$supportedTransforms.test(value));
}


function $2743bc2e9a1bad0a$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $f10058893718c5ed$export$2e2bcd8739ae039)(property)) || (0, $bb63774a12698c7f$export$2e2bcd8739ae039)(node).getPropertyValue((0, $f10058893718c5ed$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $f10058893718c5ed$export$2e2bcd8739ae039)(key));
        else if ((0, $edfb6b9719fedecb$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $f10058893718c5ed$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $2743bc2e9a1bad0a$export$2e2bcd8739ae039 = $2743bc2e9a1bad0a$var$style;




/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $34f3e4134ad86d5e$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $eb2ed0bd2d792c29$var$parseDuration(node) {
    var str = (0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $eb2ed0bd2d792c29$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $34f3e4134ad86d5e$export$2e2bcd8739ae039)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $eb2ed0bd2d792c29$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $eb2ed0bd2d792c29$var$parseDuration(element) || 0;
    var removeEmulate = $eb2ed0bd2d792c29$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $d73a16aa7200b8d9$var$parseDuration(node, property) {
    var str = (0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(node, property) || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $d73a16aa7200b8d9$export$2e2bcd8739ae039(element, handler) {
    var duration = $d73a16aa7200b8d9$var$parseDuration(element, 'transitionDuration');
    var delay = $d73a16aa7200b8d9$var$parseDuration(element, 'transitionDelay');
    var remove = (0, $eb2ed0bd2d792c29$export$2e2bcd8739ae039)(element, function(e) {
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $5a6c417d2453080d$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");



var $1aLYV = parcelRequire("1aLYV");
function $92b13f75074b8567$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return (0, $1aLYV.default).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



"use client";
// Normalizes Transition callbacks when nodeRef is used.
var $9f13533ca2686d6e$var$TransitionWrapper = /*#__PURE__*/ (0, $1aLYV.default).forwardRef(function(_param, ref) {
    var onEnter = _param.onEnter, onEntering = _param.onEntering, onEntered = _param.onEntered, onExit = _param.onExit, onExiting = _param.onExiting, onExited = _param.onExited, addEndListener = _param.addEndListener, children = _param.children, childRef = _param.childRef, props = (0, $6acIq._)(_param, [
        "onEnter",
        "onEntering",
        "onEntered",
        "onExit",
        "onExiting",
        "onExited",
        "addEndListener",
        "children",
        "childRef"
    ]);
    var nodeRef = (0, $lliNT.useRef)(null);
    var mergedRef = (0, $d9cf73fca09b1f80$export$2e2bcd8739ae039)(nodeRef, childRef);
    var attachRef = function(r) {
        mergedRef((0, $92b13f75074b8567$export$2e2bcd8739ae039)(r));
    };
    var normalize = function(callback) {
        return function(param) {
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    };
    var handleEnter = (0, $lliNT.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    var handleEntering = (0, $lliNT.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    var handleEntered = (0, $lliNT.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    var handleExit = (0, $lliNT.useCallback)(normalize(onExit), [
        onExit
    ]);
    var handleExiting = (0, $lliNT.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    var handleExited = (0, $lliNT.useCallback)(normalize(onExited), [
        onExited
    ]);
    var handleAddEndListener = (0, $lliNT.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $496c06162fdc2120$export$2e2bcd8739ae039), (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref
    }, props), {
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? function(status, innerProps) {
            return(// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, (0, $6fpqi._)((0, $1XAnY._)({}, innerProps), {
                ref: attachRef
            })));
        } : /*#__PURE__*/ (0, $1aLYV.default).cloneElement(children, {
            ref: attachRef
        })
    }));
});
$9f13533ca2686d6e$var$TransitionWrapper.displayName = 'TransitionWrapper';
var $9f13533ca2686d6e$export$2e2bcd8739ae039 = $9f13533ca2686d6e$var$TransitionWrapper;



var $fad1b22621dd9d86$var$_obj;
var $fad1b22621dd9d86$var$fadeStyles = ($fad1b22621dd9d86$var$_obj = {}, (0, $7Pjls._)($fad1b22621dd9d86$var$_obj, (0, $496c06162fdc2120$export$df38205c966be359), 'show'), (0, $7Pjls._)($fad1b22621dd9d86$var$_obj, (0, $496c06162fdc2120$export$78e9e6e3e014d60a), 'show'), $fad1b22621dd9d86$var$_obj);
var $fad1b22621dd9d86$var$Fade = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, children = _param.children, _param_transitionClasses = _param.transitionClasses, transitionClasses = _param_transitionClasses === void 0 ? {} : _param_transitionClasses, onEnter = _param.onEnter, rest = (0, $6acIq._)(_param, [
        "className",
        "children",
        "transitionClasses",
        "onEnter"
    ]);
    var props = (0, $1XAnY._)({
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false
    }, rest);
    var handleEnter = (0, $lliNT.useCallback)(function(node, isAppearing) {
        (0, $5a6c417d2453080d$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $9f13533ca2686d6e$export$2e2bcd8739ae039), (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref,
        addEndListener: (0, $d73a16aa7200b8d9$export$2e2bcd8739ae039)
    }, props), {
        onEnter: handleEnter,
        childRef: (0, $71a632d108d6b21a$export$87943f2672146d57)(children),
        children: function(status, innerProps) {
            return /*#__PURE__*/ $1aLYV.cloneElement(children, (0, $6fpqi._)((0, $1XAnY._)({}, innerProps), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))('fade', className, children.props.className, $fad1b22621dd9d86$var$fadeStyles[status], transitionClasses[status])
            }));
        }
    }));
});
$fad1b22621dd9d86$var$Fade.displayName = 'Fade';
var $fad1b22621dd9d86$export$2e2bcd8739ae039 = $fad1b22621dd9d86$var$Fade;




"use client";
function $2657236e215a8e70$var$wrapRefs(props, arrowProps) {
    var ref = props.ref;
    var aRef = arrowProps.ref;
    props.ref = ref.__wrapped || (ref.__wrapped = function(r) {
        return ref((0, $92b13f75074b8567$export$2e2bcd8739ae039)(r));
    });
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = function(r) {
        return aRef((0, $92b13f75074b8567$export$2e2bcd8739ae039)(r));
    });
}
var $2657236e215a8e70$var$Overlay = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, outerRef) {
    var overlay = _param.children, _param_transition = _param.transition, transition = _param_transition === void 0 ? (0, $fad1b22621dd9d86$export$2e2bcd8739ae039) : _param_transition, _param_popperConfig = _param.popperConfig, popperConfig = _param_popperConfig === void 0 ? {} : _param_popperConfig, _param_rootClose = _param.rootClose, rootClose = _param_rootClose === void 0 ? false : _param_rootClose, _param_placement = _param.placement, placement = _param_placement === void 0 ? 'top' : _param_placement, tmp = _param.show, outerShow = tmp === void 0 ? false : tmp, outerProps = (0, $6acIq._)(_param, [
        "children",
        "transition",
        "popperConfig",
        "rootClose",
        "placement",
        "show"
    ]);
    var popperRef = (0, $lliNT.useRef)({});
    var _useState = (0, $f9AOD._)((0, $lliNT.useState)(null), 2), firstRenderedState = _useState[0], setFirstRenderedState = _useState[1];
    var _useOverlayOffset = (0, $f9AOD._)((0, $bdafe5a34e8c64ba$export$2e2bcd8739ae039)(outerProps.offset), 2), ref = _useOverlayOffset[0], modifiers = _useOverlayOffset[1];
    var mergedRef = (0, $d9cf73fca09b1f80$export$2e2bcd8739ae039)(outerRef, ref);
    var actualTransition = transition === true ? (0, $fad1b22621dd9d86$export$2e2bcd8739ae039) : transition || undefined;
    var handleFirstUpdate = (0, $ddf2f427ad010346$export$2e2bcd8739ae039)(function(state) {
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, $81a7cd9979579e44$export$2e2bcd8739ae039)(function() {
        if (firstRenderedState && outerProps.target) // Must wait for target element to resolve before updating popper.
        popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState,
        outerProps.target
    ]);
    (0, $lliNT.useEffect)(function() {
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $f54e9d0794838e2d$export$2e2bcd8739ae039), (0, $6fpqi._)((0, $1XAnY._)({}, outerProps), {
        ref: mergedRef,
        popperConfig: (0, $6fpqi._)((0, $1XAnY._)({}, popperConfig), {
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        }),
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: function(overlayProps, param) {
            var arrowProps = param.arrowProps, popperObj = param.popper, show = param.show;
            var _popperObj$state;
            $2657236e215a8e70$var$wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            var updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            var popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null || (_popperObj$state = popperObj.state) == null || (_popperObj$state = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            var hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === 'function') return overlay((0, $6fpqi._)((0, $1XAnY._)((0, $6fpqi._)((0, $1XAnY._)({}, overlayProps), {
                placement: updatedPlacement,
                show: show
            }), !transition && show && {
                className: 'show'
            }), {
                popper: popper,
                arrowProps: arrowProps,
                hasDoneInitialMeasure: hasDoneInitialMeasure
            }));
            return /*#__PURE__*/ $1aLYV.cloneElement(overlay, (0, $6fpqi._)((0, $1XAnY._)({}, overlayProps), {
                placement: updatedPlacement,
                arrowProps: arrowProps,
                popper: popper,
                hasDoneInitialMeasure: hasDoneInitialMeasure,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(overlay.props.className, !transition && show && 'show'),
                style: (0, $1XAnY._)({}, overlay.props.style, overlayProps.style)
            }));
        }
    }));
});
$2657236e215a8e70$var$Overlay.displayName = 'Overlay';
var $2657236e215a8e70$export$2e2bcd8739ae039 = $2657236e215a8e70$var$Overlay;




var $tLNoZ = parcelRequire("tLNoZ");
"use client";
function $f8d7cc80ecd48e37$var$normalizeDelay(delay) {
    return delay && (typeof delay === "undefined" ? "undefined" : (0, $7E0eS._)(delay)) === 'object' ? delay : {
        show: delay,
        hide: delay
    };
}
// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function $f8d7cc80ecd48e37$var$handleMouseOverOut(handler, args, relatedNative) {
    var _args = (0, $f9AOD._)(args, 1), e = _args[0];
    var target = e.currentTarget;
    var related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0, $a784322fcbc350d7$export$2e2bcd8739ae039)(target, related)) handler.apply(void 0, (0, $aUGqu._)(args));
}
var $f8d7cc80ecd48e37$var$triggerType = (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).oneOf([
    'click',
    'hover',
    'focus'
]);
var $f8d7cc80ecd48e37$var$OverlayTrigger = function(_param) {
    var _param_trigger = _param.trigger, trigger = _param_trigger === void 0 ? [
        'hover',
        'focus'
    ] : _param_trigger, overlay = _param.overlay, children = _param.children, _param_popperConfig = _param.popperConfig, popperConfig = _param_popperConfig === void 0 ? {} : _param_popperConfig, propsShow = _param.show, _param_defaultShow = _param.defaultShow, defaultShow = _param_defaultShow === void 0 ? false : _param_defaultShow, onToggle = _param.onToggle, propsDelay = _param.delay, placement = _param.placement, _param_flip = _param.flip, flip = _param_flip === void 0 ? placement && placement.indexOf('auto') !== -1 : _param_flip, props = (0, $6acIq._)(_param, [
        "trigger",
        "overlay",
        "children",
        "popperConfig",
        "show",
        "defaultShow",
        "onToggle",
        "delay",
        "placement",
        "flip"
    ]);
    var triggerNodeRef = (0, $lliNT.useRef)(null);
    var mergedRef = (0, $d9cf73fca09b1f80$export$2e2bcd8739ae039)(triggerNodeRef, (0, $71a632d108d6b21a$export$87943f2672146d57)(children));
    var timeout = (0, $8c85993f098c3baa$export$2e2bcd8739ae039)();
    var hoverStateRef = (0, $lliNT.useRef)('');
    var _useUncontrolledProp = (0, $f9AOD._)((0, $5e3a44538f1f449f$export$2ee51287a16ca325)(propsShow, defaultShow, onToggle), 2), show = _useUncontrolledProp[0], setShow = _useUncontrolledProp[1];
    var delay = $f8d7cc80ecd48e37$var$normalizeDelay(propsDelay);
    var _ref = typeof children !== 'function' ? $1aLYV.Children.only(children).props : {}, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onClick = _ref.onClick;
    var attachRef = function(r) {
        mergedRef((0, $92b13f75074b8567$export$2e2bcd8739ae039)(r));
    };
    var handleShow = (0, $lliNT.useCallback)(function() {
        timeout.clear();
        hoverStateRef.current = 'show';
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(function() {
            if (hoverStateRef.current === 'show') setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    var handleHide = (0, $lliNT.useCallback)(function() {
        timeout.clear();
        hoverStateRef.current = 'hide';
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(function() {
            if (hoverStateRef.current === 'hide') setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    var handleFocus = (0, $lliNT.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        handleShow();
        onFocus == null || onFocus.apply(void 0, (0, $aUGqu._)(args));
    }, [
        handleShow,
        onFocus
    ]);
    var handleBlur = (0, $lliNT.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        handleHide();
        onBlur == null || onBlur.apply(void 0, (0, $aUGqu._)(args));
    }, [
        handleHide,
        onBlur
    ]);
    var handleClick = (0, $lliNT.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        setShow(!show);
        onClick == null || onClick.apply(void 0, (0, $aUGqu._)(args));
    }, [
        onClick,
        setShow,
        show
    ]);
    var handleMouseOver = (0, $lliNT.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        $f8d7cc80ecd48e37$var$handleMouseOverOut(handleShow, args, 'fromElement');
    }, [
        handleShow
    ]);
    var handleMouseOut = (0, $lliNT.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        $f8d7cc80ecd48e37$var$handleMouseOverOut(handleHide, args, 'toElement');
    }, [
        handleHide
    ]);
    var triggers = trigger == null ? [] : [].concat(trigger);
    var triggerProps = {
        ref: attachRef
    };
    if (triggers.indexOf('click') !== -1) triggerProps.onClick = handleClick;
    if (triggers.indexOf('focus') !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf('hover') !== -1) {
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $tLNoZ.Fragment), {
        children: [
            typeof children === 'function' ? children(triggerProps) : /*#__PURE__*/ (0, $1aLYV.cloneElement)(children, triggerProps),
            /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $2657236e215a8e70$export$2e2bcd8739ae039), (0, $6fpqi._)((0, $1XAnY._)({}, props), {
                show: show,
                onHide: handleHide,
                flip: flip,
                placement: placement,
                popperConfig: popperConfig,
                target: triggerNodeRef.current,
                children: overlay
            }))
        ]
    });
};
var $f8d7cc80ecd48e37$export$2e2bcd8739ae039 = $f8d7cc80ecd48e37$var$OverlayTrigger;


var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");


var $1aLYV = parcelRequire("1aLYV");


"use client";
var $4a44c352fe7cf693$var$Row = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "as"
    ]);
    var decoratedBsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'row');
    var breakpoints = (0, $86d2028892b8b8bc$export$8970c8db816a5863)();
    var minBreakpoint = (0, $86d2028892b8b8bc$export$d926d6ef38f3fd32)();
    var sizePrefix = "".concat(decoratedBsPrefix, "-cols");
    var classes = [];
    breakpoints.forEach(function(brkPoint) {
        var propValue = props[brkPoint];
        delete props[brkPoint];
        var cols;
        if (propValue != null && (typeof propValue === "undefined" ? "undefined" : (0, $7E0eS._)(propValue)) === 'object') cols = propValue.cols;
        else cols = propValue;
        var infix = brkPoint !== minBreakpoint ? "-".concat(brkPoint) : '';
        if (cols != null) classes.push("".concat(sizePrefix).concat(infix, "-").concat(cols));
    });
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports))).apply(void 0, [
            className,
            decoratedBsPrefix
        ].concat((0, $aUGqu._)(classes)))
    }));
});
$4a44c352fe7cf693$var$Row.displayName = 'Row';
var $4a44c352fe7cf693$export$2e2bcd8739ae039 = $4a44c352fe7cf693$var$Row;


var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");


"use client";
var $d5fc9490b2821269$var$Spinner = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, variant = _param.variant, _param_animation = _param.animation, animation = _param_animation === void 0 ? 'border' : _param_animation, size = _param.size, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, className = _param.className, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "variant",
        "animation",
        "size",
        "as",
        "className"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'spinner');
    var bsSpinnerPrefix = "".concat(bsPrefix, "-").concat(animation);
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsSpinnerPrefix, size && "".concat(bsSpinnerPrefix, "-").concat(size), variant && "text-".concat(variant))
    }));
});
$d5fc9490b2821269$var$Spinner.displayName = 'Spinner';
var $d5fc9490b2821269$export$2e2bcd8739ae039 = $d5fc9490b2821269$var$Spinner;


var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");


"use client";
var $60566ee939038e24$var$Table = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, striped = _param.striped, bordered = _param.bordered, borderless = _param.borderless, hover = _param.hover, size = _param.size, variant = _param.variant, responsive = _param.responsive, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "striped",
        "bordered",
        "borderless",
        "hover",
        "size",
        "variant",
        "responsive"
    ]);
    var decoratedBsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'table');
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, decoratedBsPrefix, variant && "".concat(decoratedBsPrefix, "-").concat(variant), size && "".concat(decoratedBsPrefix, "-").concat(size), striped && "".concat(decoratedBsPrefix, "-").concat(typeof striped === 'string' ? "striped-".concat(striped) : 'striped'), bordered && "".concat(decoratedBsPrefix, "-bordered"), borderless && "".concat(decoratedBsPrefix, "-borderless"), hover && "".concat(decoratedBsPrefix, "-hover"));
    var table = /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("table", (0, $6fpqi._)((0, $1XAnY._)({}, props), {
        className: classes,
        ref: ref
    }));
    if (responsive) {
        var responsiveClass = "".concat(decoratedBsPrefix, "-responsive");
        if (typeof responsive === 'string') responsiveClass = "".concat(responsiveClass, "-").concat(responsive);
        return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
            className: responsiveClass,
            children: table
        });
    }
    return table;
});
$60566ee939038e24$var$Table.displayName = 'Table';
var $60566ee939038e24$export$2e2bcd8739ae039 = $60566ee939038e24$var$Table;


var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");



var $7Pjls = parcelRequire("7Pjls");

var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $1aLYV = parcelRequire("1aLYV");



var $919f9cb4dfdfdb1f$var$_obj;
var $919f9cb4dfdfdb1f$var$fadeStyles = ($919f9cb4dfdfdb1f$var$_obj = {}, (0, $7Pjls._)($919f9cb4dfdfdb1f$var$_obj, (0, $496c06162fdc2120$export$df38205c966be359), 'showing'), (0, $7Pjls._)($919f9cb4dfdfdb1f$var$_obj, (0, $496c06162fdc2120$export$4aacc83d4d59139f), 'showing show'), $919f9cb4dfdfdb1f$var$_obj);
var $919f9cb4dfdfdb1f$var$ToastFade = /*#__PURE__*/ $1aLYV.forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $fad1b22621dd9d86$export$2e2bcd8739ae039), (0, $6fpqi._)((0, $1XAnY._)({}, props), {
        ref: ref,
        transitionClasses: $919f9cb4dfdfdb1f$var$fadeStyles
    }));
});
$919f9cb4dfdfdb1f$var$ToastFade.displayName = 'ToastFade';
var $919f9cb4dfdfdb1f$export$2e2bcd8739ae039 = $919f9cb4dfdfdb1f$var$ToastFade;



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");



var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");


var $69561b249377d853$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).oneOf([
        'white'
    ])
};
var $69561b249377d853$var$CloseButton = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, variant = _param.variant, tmp = _param['aria-label'], ariaLabel = tmp === void 0 ? 'Close' : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "variant",
        'aria-label'
    ]);
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("button", (0, $1XAnY._)({
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))('btn-close', variant && "btn-close-".concat(variant), className),
        "aria-label": ariaLabel
    }, props));
});
$69561b249377d853$var$CloseButton.displayName = 'CloseButton';
$69561b249377d853$var$CloseButton.propTypes = $69561b249377d853$var$propTypes;
var $69561b249377d853$export$2e2bcd8739ae039 = $69561b249377d853$var$CloseButton;


parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");
"use client";
var $2dedcece076494a9$var$ToastContext = /*#__PURE__*/ $tLNoZ.createContext({
    onClose: function() {}
});
var $2dedcece076494a9$export$2e2bcd8739ae039 = $2dedcece076494a9$var$ToastContext;



"use client";
var $1d5bd2c6ac0b38fb$var$ToastHeader = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, _param_closeLabel = _param.closeLabel, closeLabel = _param_closeLabel === void 0 ? 'Close' : _param_closeLabel, closeVariant = _param.closeVariant, _param_closeButton = _param.closeButton, closeButton = _param_closeButton === void 0 ? true : _param_closeButton, className = _param.className, children = _param.children, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "closeLabel",
        "closeVariant",
        "closeButton",
        "className",
        "children"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'toast-header');
    var context = (0, $lliNT.useContext)((0, $2dedcece076494a9$export$2e2bcd8739ae039));
    var handleClick = (0, $ddf2f427ad010346$export$2e2bcd8739ae039)(function(e) {
        context == null || context.onClose == null || context.onClose(e);
    });
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(bsPrefix, className),
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $69561b249377d853$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick,
                "data-dismiss": "toast"
            })
        ]
    }));
});
$1d5bd2c6ac0b38fb$var$ToastHeader.displayName = 'ToastHeader';
var $1d5bd2c6ac0b38fb$export$2e2bcd8739ae039 = $1d5bd2c6ac0b38fb$var$ToastHeader;



var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");



"use client";
var $23e6f1182040e05c$var$ToastBody = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'toast-body');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$23e6f1182040e05c$var$ToastBody.displayName = 'ToastBody';
var $23e6f1182040e05c$export$2e2bcd8739ae039 = $23e6f1182040e05c$var$ToastBody;





"use client";
var $abe172a988ca91d0$var$Toast = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, tmp = _param.transition, Transition = tmp === void 0 ? (0, $919f9cb4dfdfdb1f$export$2e2bcd8739ae039) : tmp, _param_show = _param.show, show = _param_show === void 0 ? true : _param_show, _param_animation = _param.animation, animation = _param_animation === void 0 ? true : _param_animation, _param_delay = _param.delay, delay = _param_delay === void 0 ? 5000 : _param_delay, _param_autohide = _param.autohide, autohide = _param_autohide === void 0 ? false : _param_autohide, onClose = _param.onClose, onEntered = _param.onEntered, onExit = _param.onExit, onExiting = _param.onExiting, onEnter = _param.onEnter, onEntering = _param.onEntering, onExited = _param.onExited, bg = _param.bg, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "transition",
        "show",
        "animation",
        "delay",
        "autohide",
        "onClose",
        "onEntered",
        "onExit",
        "onExiting",
        "onEnter",
        "onEntering",
        "onExited",
        "bg"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'toast');
    // We use refs for these, because we don't want to restart the autohide
    // timer in case these values change.
    var delayRef = (0, $lliNT.useRef)(delay);
    var onCloseRef = (0, $lliNT.useRef)(onClose);
    (0, $lliNT.useEffect)(function() {
        delayRef.current = delay;
        onCloseRef.current = onClose;
    }, [
        delay,
        onClose
    ]);
    var autohideTimeout = (0, $8c85993f098c3baa$export$2e2bcd8739ae039)();
    var autohideToast = !!(autohide && show);
    var autohideFunc = (0, $lliNT.useCallback)(function() {
        if (autohideToast) onCloseRef.current == null || onCloseRef.current();
    }, [
        autohideToast
    ]);
    (0, $lliNT.useEffect)(function() {
        // Only reset timer if show or autohide changes.
        autohideTimeout.set(autohideFunc, delayRef.current);
    }, [
        autohideTimeout,
        autohideFunc
    ]);
    var toastContext = (0, $lliNT.useMemo)(function() {
        return {
            onClose: onClose
        };
    }, [
        onClose
    ]);
    var hasAnimation = !!(Transition && animation);
    var toast = /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", (0, $6fpqi._)((0, $1XAnY._)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(bsPrefix, className, bg && "bg-".concat(bg), !hasAnimation && (show ? 'show' : 'hide')),
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true"
    }));
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $2dedcece076494a9$export$2e2bcd8739ae039).Provider, {
        value: toastContext,
        children: hasAnimation && Transition ? /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Transition, {
            in: show,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited,
            unmountOnExit: true,
            children: toast
        }) : toast
    });
});
$abe172a988ca91d0$var$Toast.displayName = 'Toast';
var $abe172a988ca91d0$export$2e2bcd8739ae039 = Object.assign($abe172a988ca91d0$var$Toast, {
    Body: (0, $23e6f1182040e05c$export$2e2bcd8739ae039),
    Header: (0, $1d5bd2c6ac0b38fb$export$2e2bcd8739ae039)
});


var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");


"use client";
var $bc6d7551699f5264$var$positionClasses = {
    'top-start': 'top-0 start-0',
    'top-center': 'top-0 start-50 translate-middle-x',
    'top-end': 'top-0 end-0',
    'middle-start': 'top-50 start-0 translate-middle-y',
    'middle-center': 'top-50 start-50 translate-middle',
    'middle-end': 'top-50 end-0 translate-middle-y',
    'bottom-start': 'bottom-0 start-0',
    'bottom-center': 'bottom-0 start-50 translate-middle-x',
    'bottom-end': 'bottom-0 end-0'
};
var $bc6d7551699f5264$var$ToastContainer = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, position = _param.position, containerPosition = _param.containerPosition, className = _param.className, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "position",
        "containerPosition",
        "className",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'toast-container');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(bsPrefix, position && $bc6d7551699f5264$var$positionClasses[position], containerPosition && "position-".concat(containerPosition), className)
    }));
});
$bc6d7551699f5264$var$ToastContainer.displayName = 'ToastContainer';
var $bc6d7551699f5264$export$2e2bcd8739ae039 = $bc6d7551699f5264$var$ToastContainer;


var $b664ecd293cb806f$exports = {};

var $7E0eS = parcelRequire("7E0eS");
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    $b664ecd293cb806f$exports = factory();
})(undefined, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function __assign1() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function sent() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function parseBounds(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function parseDocumentSize(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function toCodePoints$1(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function fromCodePoint$1() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function decode$1(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function polyUint16Array$1(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function polyUint32Array$1(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function slice16$1(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function slice32$1(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function createTrieFromBase64$1(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = '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';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function codePointsToCharacterClasses(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function isAdjacentWithSpaceIgnored(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function previousNonSpaceClassType(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function _lineBreakAtIndex(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function cssFormattedClasses(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function LineBreaker(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function next() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function isDigit(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function isSurrogateCodePoint(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function isHex(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function isLowerCaseLetter(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function isUpperCaseLetter(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function isLetter(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function isNonASCIICodePoint(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function isWhiteSpace(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function isNameStartCodePoint(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function isNameCodePoint(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function isNonPrintableCodePoint(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function isValidEscape(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function isIdentifierStart(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function isNumberStart(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function stringToNumber(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ''
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = '';
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function isDimensionToken(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function isNumberToken(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function isIdentToken(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function isStringToken(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function isIdentWithValue(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function nonWhiteSpace(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function nonFunctionArgSeparator(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function parseFunctionArgs(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function isEndingTokenFor(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function isLength(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function isLengthPercentage(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function parseLengthPercentageTuple(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function getAbsoluteValueForTuple(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    var getAbsoluteValue = function getAbsoluteValue(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function parse(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function isAngle(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function parseNamedSide(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function deg(_deg) {
        return Math.PI * _deg / 180;
    };
    var color$1 = {
        name: 'color',
        parse: function parse(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function isTransparent(color) {
        return (0xff & color) === 0;
    };
    var asString = function asString(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function pack(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function getTokenColorValue(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function rgb(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function hsl(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function parseColor(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var parseColorStop = function parseColorStop(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function processColorStops(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function getAngleFromCorner(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function calculateGradientDirection(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function distance(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function findCorner(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function calculateRadius(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function linearGradient(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function prefixLinearGradient(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function webkitGradient(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function radialGradient(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function prefixRadialGradient(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function isLinearGradient(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function isRadialGradient(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: 'image',
        parse: function parse(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function parseBackgroundRepeat(value) {
        switch(value){
            case 'no-repeat':
                return 1 /* NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function isBackgroundSizeInfoToken(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function borderColorForSide(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');
    var borderRadiusForSide = function borderRadiusForSide(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function parse(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    var borderStyleForSide = function borderStyleForSide(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function parse(_context, style) {
                switch(style){
                    case 'none':
                        return 0 /* NONE */ ;
                    case 'dashed':
                        return 2 /* DASHED */ ;
                    case 'dotted':
                        return 3 /* DOTTED */ ;
                    case 'double':
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');
    var borderWidthForSide = function borderWidthForSide(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function parse(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');
    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, direction) {
            switch(direction){
                case 'rtl':
                    return 1 /* RTL */ ;
                case 'ltr':
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function parseDisplayValue(display) {
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */ ;
            case 'inline':
                return 4 /* INLINE */ ;
            case 'run-in':
                return 8 /* RUN_IN */ ;
            case 'flow':
                return 16 /* FLOW */ ;
            case 'flow-root':
                return 32 /* FLOW_ROOT */ ;
            case 'table':
                return 64 /* TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */ ;
            case 'ruby':
                return 512 /* RUBY */ ;
            case 'subgrid':
                return 1024 /* SUBGRID */ ;
            case 'list-item':
                return 2048 /* LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, float) {
            switch(float){
                case 'left':
                    return 1 /* LEFT */ ;
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'inline-start':
                    return 3 /* INLINE_START */ ;
                case 'inline-end':
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function parse(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, lineBreak) {
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function computeLineHeight(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function parse(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, position) {
            switch(position){
                case 'inside':
                    return 0 /* INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, type) {
            switch(type){
                case 'disc':
                    return 0 /* DISC */ ;
                case 'circle':
                    return 1 /* CIRCLE */ ;
                case 'square':
                    return 2 /* SQUARE */ ;
                case 'decimal':
                    return 3 /* DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* ARMENIAN */ ;
                case 'bengali':
                    return 13 /* BENGALI */ ;
                case 'cambodian':
                    return 14 /* CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */ ;
                case 'hebrew':
                    return 22 /* HEBREW */ ;
                case 'hiragana':
                    return 23 /* HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* KANNADA */ ;
                case 'katakana':
                    return 28 /* KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LAO */ ;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* MYANMAR */ ;
                case 'oriya':
                    return 39 /* ORIYA */ ;
                case 'persian':
                    return 40 /* PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* TAMIL */ ;
                case 'telugu':
                    return 44 /* TELUGU */ ;
                case 'thai':
                    return 45 /* THAI */ ;
                case 'tibetan':
                    return 46 /* TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function marginForSide(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* HIDDEN */ ;
                    case 'scroll':
                        return 2 /* SCROLL */ ;
                    case 'clip':
                        return 3 /* CLIP */ ;
                    case 'auto':
                        return 4 /* AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, overflow) {
            switch(overflow){
                case 'break-word':
                    return "break-word" /* BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function paddingForSide(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, textAlign) {
            switch(textAlign){
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */ ;
                case 'left':
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, position) {
            switch(position){
                case 'relative':
                    return 1 /* RELATIVE */ ;
                case 'absolute':
                    return 2 /* ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* FIXED */ ;
                case 'sticky':
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, textTransform) {
            switch(textTransform){
                case 'uppercase':
                    return 2 /* UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function parse(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function matrix(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function matrix3d(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, visibility) {
            switch(visibility){
                case 'hidden':
                    return 1 /* HIDDEN */ ;
                case 'collapse':
                    return 2 /* COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, wordBreak) {
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function parse(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: 'time',
        parse: function parse(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function parse(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case 'underline':
                        return 1 /* UNDERLINE */ ;
                    case 'overline':
                        return 2 /* OVERLINE */ ;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map(function(result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'length'
    };
    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function parse(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, overflow) {
            switch(overflow){
                case 'oblique':
                    return "oblique" /* OBLIQUE */ ;
                case 'italic':
                    return "italic" /* ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function contains(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function getQuote(quotes, depth, open) {
        if (!quotes) return '';
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function parse(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function parse(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function getElementDebugType(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* ALL */ ;
            case 'clone':
                return 2 /* CLONE */ ;
            case 'parse':
                return 3 /* PARSE */ ;
            case 'render':
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function isDebugging(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = '0s';
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = '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';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function decode(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function polyUint16Array(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function polyUint32Array(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function slice16(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function slice32(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function createTrieFromBase64(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function toCodePoints(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function fromCodePoint() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function codePointToClass(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function _graphemeBreakAtIndex(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function GraphemeBreaker(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function next() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function splitGraphemes(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function testRangeBounds(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function testIOSLineBreak(document1) {
        var testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function testCORS() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function testResponseType() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function testSVG(document1) {
        var img = new Image();
        var canvas = document1.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function isGreenPixel(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function testForeignObject(document1) {
        var canvas = document1.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function createForeignObjectSVG(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function loadSerializedSVG$1(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function parseTextBounds(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function getWrapperBounds(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function createRange(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function segmentGraphemes(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function segmentWords(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function breakText(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function breakWords(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function _loop_1() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function transform(text, _transform) {
        switch(_transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function capitalize(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function reformatInputBounds(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function getInputValue(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    var parseNodeTree = function parseNodeTree1(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function createContainer(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function parseTree(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function createsRealStackingContext(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function createsStackingContext(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function isTextNode(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function isElementNode(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function isHTMLElementNode(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function isSVGElementNode(element) {
        return (0, $7E0eS._)(element.className) === 'object';
    };
    var isLIElement = function isLIElement(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function isOLElement(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function isInputElement(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function isHTMLElement(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function isSVGElement(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function isBodyElement(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function isCanvasElement(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function isVideoElement(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function isImageElement(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function isIFrameElement(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function isStyleElement(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function isScriptElement(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function isTextareaElement(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function isSelectElement(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function isSlotElement(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function isCustomElement(node) {
        return node.tagName.indexOf('-') > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function createAdditiveCounter(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function createCounterStyleWithSymbolResolver(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function createCounterStyleFromRange(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function createCounterStyleFromSymbols(value, symbols, suffix) {
        if (suffix === void 0) suffix = '. ';
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function createCJKCounter(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function createCounterText(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? "\u3001" : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var _$window = node.ownerDocument.defaultView;
            if (_$window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = _$window.getComputedStyle(node);
                var styleBefore = _$window.getComputedStyle(node, ':before');
                var styleAfter = _$window.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var _$document = clone.ownerDocument;
            if (!_$document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = _$document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(_$document.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = _$document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(_$document.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(_$document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : '';
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(_$document.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(_$document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(_$document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(_$document.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function createIFrameContainer(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function imageReady(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function imagesReady(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function iframeLoader(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function copyCSSStyles(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function serializeDoctype(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += "\"" + doctype.publicId + "\"";
            if (doctype.systemId) str += "\"" + doctype.systemId + "\"";
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function restoreOwnerScroll(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function restoreNodeScroll(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function createPseudoHideStyles(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function createStyles(body, styles) {
        var _$document = body.ownerDocument;
        if (_$document) {
            var style = _$document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return 'about:blank';
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function isRenderable(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function isInlineImage(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function isInlineBase64Image(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function isBlobImage(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function isSVG(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function lerp(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function isBezierCurve(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function getCurvePoints(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function calculateBorderBoxPath(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function calculateContentBoxPath(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function calculatePaddingBoxPath(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function isTransformEffect(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function isClipEffect(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function isOpacityEffect(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function equalPath(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function transformPath(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function parseStackTree1(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function processListItems(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function parseStackingContexts(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function parsePathForBorder(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function parsePathForBorderDoubleOuter(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function parsePathForBorderDoubleInner(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function parsePathForBorderStroke(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function createStrokePathFromCurves(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function createPathFromCurves(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function paddingBox(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function contentBox(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function calculateBackgroundPositioningArea(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function calculateBackgroundPaintingArea(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function calculateBackgroundRendering(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function isAuto(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function hasIntrinsicValue(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function calculateBackgroundSize(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function getBackgroundValueForIndex(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function calculateBackgroundRepeatPath(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function _loop_1(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function isTextInputElement(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function calculateBackgroundCurvedPaintingArea(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function canvasTextAlign(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return 'center';
            case 2 /* RIGHT */ :
                return 'right';
            case 0 /* LEFT */ :
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    var fixIOSSystemFonts = function fixIOSSystemFonts(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function loadSerializedSVG(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function html2canvas(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') CacheStorage.setContext(window);
    var renderElement = function renderElement(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || (typeof element === "undefined" ? "undefined" : (0, $7E0eS._)(element)) !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('Invalid element provided as first argument')
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function parseBackgroundColor(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});


function $baaeda96f7555c00$var$$parcel$exportWildcard(e, t) {
    return Object.keys(t).forEach(function(r) {
        "default" === r || "__esModule" === r || Object.prototype.hasOwnProperty.call(e, r) || Object.defineProperty(e, r, {
            enumerable: !0,
            get: function get() {
                return t[r];
            }
        });
    }), e;
}
function $baaeda96f7555c00$var$$parcel$export(e, t, r, a) {
    Object.defineProperty(e, t, {
        get: r,
        set: a,
        enumerable: !0,
        configurable: !0
    });
}
function $baaeda96f7555c00$var$$parcel$interopDefault(e) {
    return e && e.__esModule ? e.default : e;
}
var $baaeda96f7555c00$var$$fd019656019bb4f3$exports = {};
function $baaeda96f7555c00$var$$fd019656019bb4f3$export$e3607ec2d7a891c4(e) {
    return function(t) {
        return t && new IntersectionObserver(function(t, r) {
            var a, c, n = (0, $83f83764f225915f$export$71511d61b312f219)(t, 1)[0], i = n.isIntersecting, o = n.target;
            if (i) {
                var s = [
                    "animate__animated",
                    "animate__".concat(e)
                ];
                (a = o.classList).add.apply(a, (0, $2b3349705fb2cb54$export$71511d61b312f219)(s)), o.addEventListener("animationend", function() {
                    return (c = o.classList).remove.apply(c, (0, $2b3349705fb2cb54$export$71511d61b312f219)(s));
                }, {
                    once: !0
                }), r.disconnect();
            }
        }).observe(t);
    };
}
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$fd019656019bb4f3$exports, "animate", function() {
    return $baaeda96f7555c00$var$$fd019656019bb4f3$export$e3607ec2d7a891c4;
});
var $baaeda96f7555c00$var$$757747c0209676cc$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$757747c0209676cc$exports, "Avatar", function() {
    return $baaeda96f7555c00$var$$757747c0209676cc$export$e2255cf6045e8d47;
});
var $baaeda96f7555c00$var$$757747c0209676cc$var$__rest = function $757747c0209676cc$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$757747c0209676cc$export$e2255cf6045e8d47 = function $757747c0209676cc$export$e2255cf6045e8d47(e) {
    var t = e.className, r = e.style, a = e.size, c = void 0 === a ? 3 : a, n = $baaeda96f7555c00$var$$757747c0209676cc$var$__rest(e, [
        "className",
        "style",
        "size"
    ]);
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("img", Object.assign({
        className: $baaeda96f7555c00$var$$parcel$interopDefault($8bd163097a5514bf$exports)("object-fit-cover rounded-circle", t),
        style: Object.assign({
            width: "".concat(c, "rem"),
            height: "".concat(c, "rem")
        }, r)
    }, n));
};
$baaeda96f7555c00$var$$757747c0209676cc$export$e2255cf6045e8d47.displayName = "Avatar";
var $baaeda96f7555c00$var$$a40a1c3d6dc84a7a$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$a40a1c3d6dc84a7a$exports, "ClickBoundary", function() {
    return $baaeda96f7555c00$var$$a40a1c3d6dc84a7a$export$707fce199b8e37aa;
});
var $baaeda96f7555c00$var$$a40a1c3d6dc84a7a$var$__rest = function $a40a1c3d6dc84a7a$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$a40a1c3d6dc84a7a$export$707fce199b8e37aa = function(e) {
    "use strict";
    function t() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(_$e, "root", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (0, $tLNoZ.createRef)()
        }), Object.defineProperty(_$e, "switchClick", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function value(t) {
                var r, a = _$e.props, c = a.onInnerClick, n = a.onOuterClick;
                (null == (r = _$e.root.current) ? void 0 : r.contains(t.target)) ? null == c || c(t) : null == n || n(t);
            }
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
        {
            key: "componentDidMount",
            value: function value() {
                window.addEventListener("click", this.switchClick, !0);
            }
        },
        {
            key: "componentWillUnmount",
            value: function value() {
                window.removeEventListener("click", this.switchClick, !0);
            }
        },
        {
            key: "render",
            value: function value() {
                var _$e = this.props, _$t = _$e.children, r = (_$e.onInnerClick, _$e.onOuterClick, $baaeda96f7555c00$var$$a40a1c3d6dc84a7a$var$__rest(_$e, [
                    "children",
                    "onInnerClick",
                    "onOuterClick"
                ]));
                return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", Object.assign({
                    ref: this.root
                }, r, {
                    children: _$t
                }));
            }
        }
    ]), t;
}($1aLYV.PureComponent), $baaeda96f7555c00$var$$89fa9a64cf869995$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$89fa9a64cf869995$exports, "CodeBlock", function() {
    return $baaeda96f7555c00$var$$89fa9a64cf869995$export$6c415d1fdae3dfdb;
});
var $baaeda96f7555c00$var$$89fa9a64cf869995$var$__rest = function $89fa9a64cf869995$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$89fa9a64cf869995$export$6c415d1fdae3dfdb = function $89fa9a64cf869995$export$6c415d1fdae3dfdb(e) {
    var t = e.className, r = e.language, a = e.children, c = $baaeda96f7555c00$var$$89fa9a64cf869995$var$__rest(e, [
        "className",
        "language",
        "children"
    ]), n = "string" == typeof a ? a : $baaeda96f7555c00$var$$parcel$interopDefault($37561f8b8d5393c0$exports)((0, $1aLYV.isValidElement)(a) ? a : (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($tLNoZ.Fragment, {
        children: a
    })), i = (0, $0e70cb6ccf37e2dd$exports.highlight)(n, $0e70cb6ccf37e2dd$exports.languages[r], r);
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("pre", Object.assign({
        className: "language-".concat(r, " ").concat(void 0 === t ? "" : t)
    }, c, {
        children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("code", {
            dangerouslySetInnerHTML: {
                __html: i
            },
            className: "language-".concat(r)
        })
    }));
}, $baaeda96f7555c00$var$$924d73683971f901$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$924d73683971f901$exports, "VariantColors", function() {
    return $baaeda96f7555c00$var$$924d73683971f901$export$50b010be9260e56b;
}), $baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$924d73683971f901$exports, "text2color", function() {
    return $baaeda96f7555c00$var$$924d73683971f901$export$b480d00b75c9ac2d;
});
var $baaeda96f7555c00$var$$924d73683971f901$export$50b010be9260e56b = [
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info",
    "dark",
    "light"
];
function $baaeda96f7555c00$var$$924d73683971f901$export$b480d00b75c9ac2d(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], r = t[0] ? $baaeda96f7555c00$var$$924d73683971f901$export$50b010be9260e56b.filter(function(e) {
        return !t.find(function(t) {
            return t === e;
        });
    }) : $baaeda96f7555c00$var$$924d73683971f901$export$50b010be9260e56b;
    return r[(0, $2b3349705fb2cb54$export$71511d61b312f219)(e).reduce(function(e, t) {
        return e + t.charCodeAt(0);
    }, 0) % r.length];
}
var $baaeda96f7555c00$var$$9dab2fd0b4033192$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$9dab2fd0b4033192$exports, "Countdown", function() {
    return $baaeda96f7555c00$var$$9dab2fd0b4033192$export$53819c0e58f98d49;
});
var $baaeda96f7555c00$var$$9dab2fd0b4033192$var$__runInitializers = function $9dab2fd0b4033192$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $baaeda96f7555c00$var$$9dab2fd0b4033192$var$__esDecorate = function $9dab2fd0b4033192$var$__esDecorate(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $baaeda96f7555c00$var$$9dab2fd0b4033192$var$__setFunctionName = function $9dab2fd0b4033192$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $baaeda96f7555c00$var$$9dab2fd0b4033192$var$__classPrivateFieldGet = function $9dab2fd0b4033192$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $baaeda96f7555c00$var$$9dab2fd0b4033192$var$__classPrivateFieldSet = function $9dab2fd0b4033192$var$__classPrivateFieldSet(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $baaeda96f7555c00$var$$9dab2fd0b4033192$var$__rest = function $9dab2fd0b4033192$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$9dab2fd0b4033192$export$53819c0e58f98d49 = function() {
    var e, t, r, a, c, n, i, o, s = [
        $e04d4b638436dc5e$export$b6ae1bc530f4c149
    ], l = [], $ = $524de0d5a72e1bc6$exports.ObservedComponent, u = [], d = [], f = [];
    return c = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), r.set(_$e, ($baaeda96f7555c00$var$$9dab2fd0b4033192$var$__runInitializers(_$e, u), $baaeda96f7555c00$var$$9dab2fd0b4033192$var$__runInitializers(_$e, d, 0))), Object.defineProperty(_$e, "timer", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($baaeda96f7555c00$var$$9dab2fd0b4033192$var$__runInitializers(_$e, f), 0)
            }), Object.defineProperty(_$e, "tick", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value() {
                    var _$t = _$e.props, r = _$t.onEnd, a = _$t.endTime, c = _$e.endTimestamp - Date.now();
                    c > 0 ? _$e.rest = c : (_$e.rest = 0, _$e.stop(), null == r || r(a));
                }
            }), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "rest",
                get: function get() {
                    return $baaeda96f7555c00$var$$9dab2fd0b4033192$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $baaeda96f7555c00$var$$9dab2fd0b4033192$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "endTimestamp",
                get: function get() {
                    return +new Date(this.props.endTime || Date.now());
                }
            },
            {
                key: "timeSections",
                get: function get() {
                    var _$e = this.observedProps.units, _$t = this.rest;
                    return _$e.reduce(function(r, a, c) {
                        var n = a.label, i = _$e.slice(c).map(function(e) {
                            return e.scale;
                        }).reduce(function(e, t) {
                            return e * t;
                        }, 1), o = ~~(_$t / i);
                        return _$t -= o * i, r.push({
                            value: o,
                            label: n
                        }), r;
                    }, []);
                }
            },
            {
                key: "stop",
                value: function value() {
                    this.timer && (window.clearInterval(this.timer), this.timer = 0);
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    (0, $57751a2649dd1683$export$71511d61b312f219)((0, $ae6313b3cbf000af$export$71511d61b312f219)(t.prototype), "componentDidMount", this).call(this), this.initTimer();
                }
            },
            {
                key: "initTimer",
                value: function value() {
                    this.stop(), this.tick(), this.timer = window.setInterval(this.tick, $lhPyT.Second);
                }
            },
            {
                key: "componentWillUnmount",
                value: function value() {
                    (0, $57751a2649dd1683$export$71511d61b312f219)((0, $ae6313b3cbf000af$export$71511d61b312f219)(t.prototype), "componentWillUnmount", this).call(this), this.stop();
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this.props, _$t = _$e.className, r = _$e.itemClassName, a = void 0 === r ? "border rounded px-4 py-3 d-flex flex-column justify-content-center align-items-center" : r, c = (_$e.units, _$e.endTime, _$e.onEnd, $baaeda96f7555c00$var$$9dab2fd0b4033192$var$__rest(_$e, [
                        "className",
                        "itemClassName",
                        "units",
                        "endTime",
                        "onEnd"
                    ])), n = this.timeSections;
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("ol", Object.assign({
                        className: "list-unstyled m-0 ".concat(void 0 === _$t ? "" : _$t)
                    }, c, {
                        children: n.map(function(e) {
                            var _$t = e.value, r = e.label;
                            return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("li", {
                                className: a,
                                children: [
                                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("strong", {
                                        children: (_$t + "").padStart(2, "0")
                                    }),
                                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("span", {
                                        children: r
                                    })
                                ]
                            }, r);
                        })
                    }));
                }
            }
        ]), t;
    }($), r = new WeakMap, $baaeda96f7555c00$var$$9dab2fd0b4033192$var$__setFunctionName(c, "Countdown"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, n = [
        $h2kUE.observable
    ], i = [
        $h2kUE.computed
    ], o = [
        (0, $524de0d5a72e1bc6$exports.reaction)(function(e) {
            return e.observedProps.endTime;
        })
    ], $baaeda96f7555c00$var$$9dab2fd0b4033192$var$__esDecorate(c, null, n, {
        kind: "accessor",
        name: "rest",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "rest" in e;
            },
            get: function get(e) {
                return e.rest;
            },
            set: function set(e, t) {
                e.rest = t;
            }
        },
        metadata: t
    }, d, f), $baaeda96f7555c00$var$$9dab2fd0b4033192$var$__esDecorate(c, null, i, {
        kind: "getter",
        name: "timeSections",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "timeSections" in e;
            },
            get: function get(e) {
                return e.timeSections;
            }
        },
        metadata: t
    }, null, u), $baaeda96f7555c00$var$$9dab2fd0b4033192$var$__esDecorate(c, null, o, {
        kind: "method",
        name: "initTimer",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "initTimer" in e;
            },
            get: function get(e) {
                return e.initTimer;
            }
        },
        metadata: t
    }, null, u), $baaeda96f7555c00$var$$9dab2fd0b4033192$var$__esDecorate(null, a = {
        value: c
    }, s, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, l), c = a.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "Countdown"
    }), $baaeda96f7555c00$var$$9dab2fd0b4033192$var$__runInitializers(c, l), c;
}(), $baaeda96f7555c00$var$$e308f4ff6755d29b$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$e308f4ff6755d29b$exports, "DialogClose", function() {
    return $baaeda96f7555c00$var$$e308f4ff6755d29b$export$fba2fb7cd781b7ac;
}), $baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$e308f4ff6755d29b$exports, "Dialog", function() {
    return $baaeda96f7555c00$var$$e308f4ff6755d29b$export$3ddf2d174ce01153;
});
var $baaeda96f7555c00$var$$e308f4ff6755d29b$var$__esDecorate = function $e308f4ff6755d29b$var$__esDecorate(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $baaeda96f7555c00$var$$e308f4ff6755d29b$var$__runInitializers = function $e308f4ff6755d29b$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $baaeda96f7555c00$var$$e308f4ff6755d29b$var$__classPrivateFieldGet = function $e308f4ff6755d29b$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $baaeda96f7555c00$var$$e308f4ff6755d29b$var$__classPrivateFieldSet = function $e308f4ff6755d29b$var$__classPrivateFieldSet(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $baaeda96f7555c00$var$$e308f4ff6755d29b$export$fba2fb7cd781b7ac = function(e) {
    "use strict";
    function t() {
        var _$e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "Dialog closed";
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, [
            _$e
        ]);
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), t;
}((0, $83c809b827209ab4$export$71511d61b312f219)(Error)), $baaeda96f7555c00$var$$e308f4ff6755d29b$export$3ddf2d174ce01153 = function() {
    var e, t, r, a, c, n, i = [], o = [], s = [], l = [];
    return t = function() {
        "use strict";
        function e(t) {
            var c = this;
            (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, e), r.set(this, $baaeda96f7555c00$var$$e308f4ff6755d29b$var$__runInitializers(this, i, {})), a.set(this, ($baaeda96f7555c00$var$$e308f4ff6755d29b$var$__runInitializers(this, o), $baaeda96f7555c00$var$$e308f4ff6755d29b$var$__runInitializers(this, s, void 0))), Object.defineProperty(this, "Component", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: $baaeda96f7555c00$var$$e308f4ff6755d29b$var$__runInitializers(this, l)
            }), this.Component = (0, $e04d4b638436dc5e$export$b6ae1bc530f4c149)(function(e) {
                return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(t, Object.assign({}, e, c.input, {
                    defer: c.defer
                }));
            }), this.Component.displayName = "DialogComponent";
        }
        return (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(e, [
            {
                key: "input",
                get: function get() {
                    return $baaeda96f7555c00$var$$e308f4ff6755d29b$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $baaeda96f7555c00$var$$e308f4ff6755d29b$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "defer",
                get: function get() {
                    return $baaeda96f7555c00$var$$e308f4ff6755d29b$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function set(e) {
                    $baaeda96f7555c00$var$$e308f4ff6755d29b$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "open",
                value: function value(e) {
                    var t = this;
                    return e && (this.input = e), this.defer = new $edbe2f6a95b5edf7$export$c7e91f8aec23ae14, this.defer.promise.finally(function() {
                        return t.defer = void 0;
                    }), this.defer.promise;
                }
            }
        ]), e;
    }(), r = new WeakMap, a = new WeakMap, e = "function" == typeof Symbol && Symbol.metadata ? Object.create(null) : void 0, c = [
        $h2kUE.observable
    ], n = [
        $h2kUE.observable
    ], $baaeda96f7555c00$var$$e308f4ff6755d29b$var$__esDecorate(t, null, c, {
        kind: "accessor",
        name: "input",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "input" in e;
            },
            get: function get(e) {
                return e.input;
            },
            set: function set(e, t) {
                e.input = t;
            }
        },
        metadata: e
    }, i, o), $baaeda96f7555c00$var$$e308f4ff6755d29b$var$__esDecorate(t, null, n, {
        kind: "accessor",
        name: "defer",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "defer" in e;
            },
            get: function get(e) {
                return e.defer;
            },
            set: function set(e, t) {
                e.defer = t;
            }
        },
        metadata: e
    }, s, l), e && Object.defineProperty(t, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }), t;
}(), $baaeda96f7555c00$var$$68aab1d0e8e5016c$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$68aab1d0e8e5016c$exports, "Editor", function() {
    return $baaeda96f7555c00$var$$68aab1d0e8e5016c$export$7cda8d932e2f33c0;
});
var $baaeda96f7555c00$var$$68aab1d0e8e5016c$var$__esDecorate = function $68aab1d0e8e5016c$var$__esDecorate(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $baaeda96f7555c00$var$$68aab1d0e8e5016c$var$__runInitializers = function $68aab1d0e8e5016c$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $baaeda96f7555c00$var$$68aab1d0e8e5016c$var$__awaiter = function $68aab1d0e8e5016c$var$__awaiter(e, t, r, a) {
    return new (r || (r = Promise))(function(c, n) {
        function i(e) {
            try {
                s(a.next(e));
            } catch (e) {
                n(e);
            }
        }
        function o(e) {
            try {
                s(a.throw(e));
            } catch (e) {
                n(e);
            }
        }
        function s(e) {
            var _$t;
            e.done ? c(e.value) : ((_$t = e.value) instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(i, o);
        }
        s((a = a.apply(e, t || [])).next());
    });
}, $baaeda96f7555c00$var$$68aab1d0e8e5016c$var$__setFunctionName = function $68aab1d0e8e5016c$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $baaeda96f7555c00$var$$68aab1d0e8e5016c$var$__classPrivateFieldGet = function $68aab1d0e8e5016c$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $baaeda96f7555c00$var$$68aab1d0e8e5016c$var$__classPrivateFieldSet = function $68aab1d0e8e5016c$var$__classPrivateFieldSet(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $baaeda96f7555c00$var$$68aab1d0e8e5016c$var$__rest = function $68aab1d0e8e5016c$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$68aab1d0e8e5016c$var$ReactEditorJS = (0, $6d65d154b3035a5c$export$da8ca15f4115b46e)(), $baaeda96f7555c00$var$$68aab1d0e8e5016c$export$7cda8d932e2f33c0 = function() {
    var e, t, r, a, c, n = [
        $e04d4b638436dc5e$export$b6ae1bc530f4c149
    ], i = [], o = $tLNoZ.Component, s = [], l = [];
    return c = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(_$e, "core", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: void 0
            }), r.set(_$e, $baaeda96f7555c00$var$$68aab1d0e8e5016c$var$__runInitializers(_$e, s, _$e.props.defaultValue)), Object.defineProperty(_$e, "save", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($baaeda96f7555c00$var$$68aab1d0e8e5016c$var$__runInitializers(_$e, l), function() {
                    return $baaeda96f7555c00$var$$68aab1d0e8e5016c$var$__awaiter(_$e, void 0, void 0, function() {
                        var _$e, _$t;
                        return (0, $ea05ccc2484f951f$export$71511d61b312f219)(this, function(r) {
                            switch(r.label){
                                case 0:
                                    if (!(_$e = this.core)) return [
                                        3,
                                        2
                                    ];
                                    return _$t = this, [
                                        4,
                                        this.core.save()
                                    ];
                                case 1:
                                    _$e = _$t.innerValue = r.sent(), r.label = 2;
                                case 2:
                                    return [
                                        2,
                                        _$e
                                    ];
                            }
                        });
                    });
                })
            }), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "innerValue",
                get: function get() {
                    return $baaeda96f7555c00$var$$68aab1d0e8e5016c$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $baaeda96f7555c00$var$$68aab1d0e8e5016c$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this, _$t = this.props, r = _$t.name, a = _$t.required, c = (_$t.children, $baaeda96f7555c00$var$$68aab1d0e8e5016c$var$__rest(_$t, [
                        "name",
                        "required",
                        "children"
                    ])), n = this.innerValue;
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                        className: "form-control",
                        tabIndex: -1,
                        onBlur: this.save,
                        children: [
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("input", {
                                hidden: !0,
                                name: r,
                                required: a,
                                value: JSON.stringify(n)
                            }),
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($baaeda96f7555c00$var$$68aab1d0e8e5016c$var$ReactEditorJS, Object.assign({}, c, {
                                onInitialize: function onInitialize(t) {
                                    var r;
                                    _$e.core = t, null == (r = c.onInitialize) || r.call(c, t);
                                }
                            }))
                        ]
                    });
                }
            }
        ]), t;
    }(o), r = new WeakMap, $baaeda96f7555c00$var$$68aab1d0e8e5016c$var$__setFunctionName(c, "Editor"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = o[Symbol.metadata]) ? e : null) : void 0, $baaeda96f7555c00$var$$68aab1d0e8e5016c$var$__esDecorate(c, null, [
        $h2kUE.observable
    ], {
        kind: "accessor",
        name: "innerValue",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "innerValue" in e;
            },
            get: function get(e) {
                return e.innerValue;
            },
            set: function set(e, t) {
                e.innerValue = t;
            }
        },
        metadata: t
    }, s, l), $baaeda96f7555c00$var$$68aab1d0e8e5016c$var$__esDecorate(null, a = {
        value: c
    }, n, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, i), c = a.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "Editor"
    }), $baaeda96f7555c00$var$$68aab1d0e8e5016c$var$__runInitializers(c, i), c;
}(), $baaeda96f7555c00$var$$db3d9d99c159855a$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$db3d9d99c159855a$exports, "parser", function() {
    return $baaeda96f7555c00$var$$db3d9d99c159855a$export$8f49e4af10703ce3;
}), $baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$db3d9d99c159855a$exports, "EditorHTML", function() {
    return $baaeda96f7555c00$var$$db3d9d99c159855a$export$f9c5335a01b13a5a;
});
var $baaeda96f7555c00$var$$db3d9d99c159855a$var$__rest = function $db3d9d99c159855a$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$db3d9d99c159855a$export$8f49e4af10703ce3 = $baaeda96f7555c00$var$$parcel$interopDefault($3e3a7251f1f53fd8$exports)({
    link: function link(e) {
        var t = e.data.link;
        return '<a href="'.concat(t, '">').concat(t, "</a>");
    }
}), $baaeda96f7555c00$var$$db3d9d99c159855a$export$f9c5335a01b13a5a = function $db3d9d99c159855a$export$f9c5335a01b13a5a(e) {
    var t = e.data, r = $baaeda96f7555c00$var$$db3d9d99c159855a$var$__rest(e, [
        "data"
    ]);
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("article", Object.assign({}, r, {
        dangerouslySetInnerHTML: {
            __html: $baaeda96f7555c00$var$$db3d9d99c159855a$export$8f49e4af10703ce3.parse(t)
        }
    }));
};
$baaeda96f7555c00$var$$db3d9d99c159855a$export$f9c5335a01b13a5a.displayName = "EditorHTML";
var $baaeda96f7555c00$var$$e400f030e8cea549$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$e400f030e8cea549$exports, "HorizontalMarquee", function() {
    return $baaeda96f7555c00$var$$e400f030e8cea549$export$4eb895ecfe5a67d5;
}), $baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$e400f030e8cea549$exports, "HorizontalMarqueeBox", function() {
    return $baaeda96f7555c00$var$$e400f030e8cea549$export$e22877062eb47c32;
}), $baaeda96f7555c00$var$$14c85ffeff1ab241$export$fad3c8302a7540c6 = "_4_3lnG_scrollContainer", $baaeda96f7555c00$var$$14c85ffeff1ab241$export$5f81b96ae5b0befd = "_4_3lnG_scrollHeightWrap", $baaeda96f7555c00$var$$14c85ffeff1ab241$export$1a22ace05a045e3f = "_4_3lnG_scrollItem", $baaeda96f7555c00$var$$14c85ffeff1ab241$export$c7aa240077ad8340 = "_4_3lnG_scrollWrap", $baaeda96f7555c00$var$$14c85ffeff1ab241$export$5add10f2a1e13991 = "_4_3lnG_unScrollItem";
var $baaeda96f7555c00$var$$e400f030e8cea549$var$__rest = function $e400f030e8cea549$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$e400f030e8cea549$export$4eb895ecfe5a67d5 = function $e400f030e8cea549$export$4eb895ecfe5a67d5(e) {
    var t = e.className, r = e.children, a = e.maxWidth, c = e.duration, n = e.height, i = $baaeda96f7555c00$var$$e400f030e8cea549$var$__rest(e, [
        "className",
        "children",
        "maxWidth",
        "duration",
        "height"
    ]);
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", Object.assign({
        className: "overflow-hidden mw-100 ".concat(void 0 === t ? "" : t)
    }, i, {
        children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
            className: "d-inline-block align-top text-nowrap ".concat($baaeda96f7555c00$var$$14c85ffeff1ab241$export$c7aa240077ad8340),
            style: {
                maxWidth: void 0 === a ? "100%" : a,
                animationDuration: c,
                height: n,
                lineHeight: n
            },
            children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                className: "d-inline-block ".concat($baaeda96f7555c00$var$$14c85ffeff1ab241$export$1a22ace05a045e3f),
                style: {
                    animationDuration: c
                },
                children: r
            })
        })
    }));
}, $baaeda96f7555c00$var$$e400f030e8cea549$export$e22877062eb47c32 = function $e400f030e8cea549$export$e22877062eb47c32(e) {
    var t = e.children, r = e.maxWidth, a = e.duration, c = e.height;
    return c ? (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
        className: "overflow-hidden ".concat($baaeda96f7555c00$var$$14c85ffeff1ab241$export$5f81b96ae5b0befd),
        style: {
            maxWidth: r,
            "--scroll-height": c
        },
        children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
            className: "d-inline-block overflow-hidden mw-100 ".concat($baaeda96f7555c00$var$$14c85ffeff1ab241$export$fad3c8302a7540c6),
            children: [
                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                    className: "d-block overflow-hidden text-wrap text-break ".concat($baaeda96f7555c00$var$$14c85ffeff1ab241$export$5add10f2a1e13991),
                    children: t
                }),
                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($baaeda96f7555c00$var$$e400f030e8cea549$export$4eb895ecfe5a67d5, {
                    duration: a,
                    children: t
                })
            ]
        })
    }) : (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($baaeda96f7555c00$var$$e400f030e8cea549$export$4eb895ecfe5a67d5, {
        maxWidth: r,
        duration: a,
        height: c,
        children: t
    });
};
$baaeda96f7555c00$var$$e400f030e8cea549$export$4eb895ecfe5a67d5.displayName = "HorizontalMarquee";
var $baaeda96f7555c00$var$$cf5cdc2ffed4bc45$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$cf5cdc2ffed4bc45$exports, "Icon", function() {
    return $baaeda96f7555c00$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f;
});
var $baaeda96f7555c00$var$$cf5cdc2ffed4bc45$var$__rest = function $cf5cdc2ffed4bc45$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f = function $cf5cdc2ffed4bc45$export$f04a61298a47a40f(e) {
    var t = e.className, r = e.style, a = e.name, c = e.size, n = $baaeda96f7555c00$var$$cf5cdc2ffed4bc45$var$__rest(e, [
        "className",
        "style",
        "name",
        "size"
    ]);
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("span", Object.assign({
        className: $baaeda96f7555c00$var$$parcel$interopDefault($8bd163097a5514bf$exports)("bi-".concat(a), t),
        style: Object.assign({
            fontSize: c && "".concat(c, "rem")
        }, r)
    }, n));
};
$baaeda96f7555c00$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f.displayName = "Icon";
var $baaeda96f7555c00$var$$44176234dcaa70a7$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$44176234dcaa70a7$exports, "LiveTSX", function() {
    return $baaeda96f7555c00$var$$44176234dcaa70a7$export$965592ed152e8e7f;
});
var $baaeda96f7555c00$var$$44176234dcaa70a7$export$965592ed152e8e7f = function $44176234dcaa70a7$export$965592ed152e8e7f(e) {
    var t = e.scope, r = e.children, a = (0, $1aLYV.isValidElement)(r) ? r : (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($tLNoZ.Fragment, {
        children: r
    }), c = "string" == typeof r ? r : $baaeda96f7555c00$var$$parcel$interopDefault($37561f8b8d5393c0$exports)(a);
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($d9ebcb6027e216ce$export$7f6f1b77ca3c3ed3, {
        code: c,
        scope: t,
        language: "tsx",
        children: [
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($d9ebcb6027e216ce$export$ba3ca6901d2e4f5f, {
                className: "mb-3"
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($d9ebcb6027e216ce$export$f8f60579bb81d0e5, {}),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($d9ebcb6027e216ce$export$1991b613205b2adc, {
                className: "text-danger small p-2"
            })
        ]
    });
}, $baaeda96f7555c00$var$$1f7252b8d0187295$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$1f7252b8d0187295$exports, "Loading", function() {
    return $baaeda96f7555c00$var$$1f7252b8d0187295$export$669f6ea7d267feaf;
});
var $baaeda96f7555c00$var$$1f7252b8d0187295$var$__rest = function $1f7252b8d0187295$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$1f7252b8d0187295$export$669f6ea7d267feaf = function $1f7252b8d0187295$export$669f6ea7d267feaf(e) {
    var t = e.className, r = e.children, a = $baaeda96f7555c00$var$$1f7252b8d0187295$var$__rest(e, [
        "className",
        "children"
    ]);
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", Object.assign({
        className: "fixed-top h-100 w-100 d-flex justify-content-center align-items-center opacity-25 bg-black ".concat(void 0 === t ? "" : t)
    }, a, {
        children: [
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($d5fc9490b2821269$export$2e2bcd8739ae039, {
                animation: "border",
                variant: "success"
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("span", {
                className: "ml-3 text-white",
                children: void 0 === r ? "Loading..." : r
            })
        ]
    }));
};
$baaeda96f7555c00$var$$1f7252b8d0187295$export$669f6ea7d267feaf.displayName = "Loading";
var $baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$exports, "MonthCalendar", function() {
    return $baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$export$d7a7c85c0f5afc4a;
});
var $baaeda96f7555c00$var$$a121893c5bead7fc$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$a121893c5bead7fc$exports, "OverlayBox", function() {
    return $baaeda96f7555c00$var$$a121893c5bead7fc$export$5169ff31790bf260;
});
var $baaeda96f7555c00$var$$a121893c5bead7fc$var$__rest = function $a121893c5bead7fc$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$a121893c5bead7fc$export$5169ff31790bf260 = function $a121893c5bead7fc$export$5169ff31790bf260(e) {
    var t = e.title, r = e.detail, a = e.children, c = $baaeda96f7555c00$var$$a121893c5bead7fc$var$__rest(e, [
        "title",
        "detail",
        "children"
    ]);
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($f8d7cc80ecd48e37$export$2e2bcd8739ae039, Object.assign({}, c, {
        overlay: r ? (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($3894e6db5e8cc0da$export$2e2bcd8739ae039, {
            children: [
                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($3894e6db5e8cc0da$export$2e2bcd8739ae039.Header, {
                    children: t
                }),
                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($3894e6db5e8cc0da$export$2e2bcd8739ae039.Body, {
                    children: r
                })
            ]
        }) : (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($4777d7db4f8553f1$export$2e2bcd8739ae039, {
            children: t
        }),
        children: a
    }));
};
$baaeda96f7555c00$var$$a121893c5bead7fc$export$5169ff31790bf260.displayName = "OverlayBox";
var $baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$var$__runInitializers = function $ec6e3ccd45c7b7c0$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$var$__esDecorate = function $ec6e3ccd45c7b7c0$var$__esDecorate(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$var$__setFunctionName = function $ec6e3ccd45c7b7c0$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$var$__classPrivateFieldGet = function $ec6e3ccd45c7b7c0$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$var$__classPrivateFieldSet = function $ec6e3ccd45c7b7c0$var$__classPrivateFieldSet(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$var$__rest = function $ec6e3ccd45c7b7c0$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$export$d7a7c85c0f5afc4a = function() {
    var e, t, r, a, c, n, i, o, s = [
        $e04d4b638436dc5e$export$b6ae1bc530f4c149
    ], l = [], $ = $524de0d5a72e1bc6$exports.ObservedComponent, u = [], d = [], f = [];
    return c = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), r.set(_$e, ($baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$var$__runInitializers(_$e, u), $baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$var$__runInitializers(_$e, d, new Date))), Object.defineProperty(_$e, "renderDate", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$var$__runInitializers(_$e, f), function(t) {
                    var r = _$e.observedProps, a = (r.variant, r.value), c = r.onSelect, n = (0, $lhPyT.formatDate)(t, "YYYY-MM-DD"), i = null == a ? void 0 : a.filter(function(e) {
                        var _$t = e.date;
                        return (0, $lhPyT.formatDate)(_$t, "YYYY-MM-DD") === n;
                    });
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("td", {
                        className: $baaeda96f7555c00$var$$parcel$interopDefault($8bd163097a5514bf$exports)({
                            "opacity-50": t.getMonth() !== _$e.currentDate.getMonth(),
                            "fw-bold": n === (0, $lhPyT.formatDate)(new Date, "YYYY-MM-DD")
                        }),
                        children: [
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("time", {
                                className: "d-block",
                                dateTime: t.toJSON(),
                                children: t.getDate()
                            }),
                            null == i ? void 0 : i.map(function(e) {
                                return "object" === (0, $823e69b1ff06d0bf$export$71511d61b312f219)(e.content) ? e.content : (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($baaeda96f7555c00$var$$a121893c5bead7fc$export$5169ff31790bf260, {
                                    title: e.content,
                                    children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($b4b154a3007acf25$export$2e2bcd8739ae039, {
                                        as: "a",
                                        className: "d-inline-block text-decoration-none w-100 text-truncate",
                                        bg: $baaeda96f7555c00$var$$924d73683971f901$export$b480d00b75c9ac2d(e.content + "", [
                                            "light"
                                        ]),
                                        href: e.link,
                                        onClick: function onClick() {
                                            return null == c ? void 0 : c(e);
                                        },
                                        children: e.content
                                    })
                                }, e.date + "");
                            })
                        ]
                    }, t + "");
                })
            }), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "weekFormatter",
                get: function get() {
                    var _$e, _$t = this.observedProps.locale, r = void 0 === _$t ? null == (_$e = globalThis.navigator) ? void 0 : _$e.language : _$t;
                    return new Intl.DateTimeFormat(r, {
                        weekday: "long"
                    });
                }
            },
            {
                key: "currentDate",
                get: function get() {
                    return $baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "dateGrid",
                get: function get() {
                    var _$e = new Date(this.currentDate);
                    _$e.setDate(1), _$e = new Date(_$e - _$e.getDay() * $lhPyT.Day);
                    var _$t = Array.from(Array(42), function(t, r) {
                        return new Date(+_$e + r * $lhPyT.Day);
                    });
                    return (0, $lhPyT.splitArray)(_$t, 7);
                }
            },
            {
                key: "changeMonth",
                value: function value(e) {
                    var _$t, r;
                    this.currentDate = (0, $lhPyT.changeMonth)(this.currentDate, e), null == (r = (_$t = this.props).onChange) || r.call(_$t, this.currentDate);
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this, _$t = this.weekFormatter, r = this.currentDate, a = this.dateGrid, c = this.observedProps, n = c.style, i = c.variant, o = void 0 === i ? "primary" : i, s = (c.onChange, c.onSelect, $baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$var$__rest(c, [
                        "style",
                        "variant",
                        "onChange",
                        "onSelect"
                    ]));
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($60566ee939038e24$export$2e2bcd8739ae039, Object.assign({}, s, {
                        style: Object.assign({
                            tableLayout: "fixed"
                        }, n),
                        children: [
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("caption", {
                                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                                    className: "d-flex justify-content-between align-items-center",
                                    children: [
                                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($3a399bf6b2fd4261$export$2e2bcd8739ae039, {
                                            variant: o,
                                            onClick: function onClick() {
                                                return _$e.changeMonth(-1);
                                            },
                                            children: "<"
                                        }),
                                        (0, $lhPyT.formatDate)(r, "YYYY-MM"),
                                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($3a399bf6b2fd4261$export$2e2bcd8739ae039, {
                                            variant: o,
                                            onClick: function onClick() {
                                                return _$e.changeMonth(1);
                                            },
                                            children: ">"
                                        })
                                    ]
                                })
                            }),
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("thead", {
                                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("tr", {
                                    children: a[0].map(function(e, r, a) {
                                        var c = a.length;
                                        return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("td", {
                                            className: "bg-".concat(o, " text-white"),
                                            style: {
                                                width: "calc(100% / ".concat(c, ")")
                                            },
                                            children: _$t.format(e)
                                        }, r);
                                    })
                                })
                            }),
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("tbody", {
                                children: a.map(function(t) {
                                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("tr", {
                                        children: t.map(_$e.renderDate)
                                    }, t[0] + "");
                                })
                            })
                        ]
                    }));
                }
            }
        ]), t;
    }($), r = new WeakMap, $baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$var$__setFunctionName(c, "MonthCalendar"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, n = [
        $h2kUE.computed
    ], i = [
        $h2kUE.observable
    ], o = [
        $h2kUE.computed
    ], $baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$var$__esDecorate(c, null, n, {
        kind: "getter",
        name: "weekFormatter",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "weekFormatter" in e;
            },
            get: function get(e) {
                return e.weekFormatter;
            }
        },
        metadata: t
    }, null, u), $baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$var$__esDecorate(c, null, i, {
        kind: "accessor",
        name: "currentDate",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "currentDate" in e;
            },
            get: function get(e) {
                return e.currentDate;
            },
            set: function set(e, t) {
                e.currentDate = t;
            }
        },
        metadata: t
    }, d, f), $baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$var$__esDecorate(c, null, o, {
        kind: "getter",
        name: "dateGrid",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "dateGrid" in e;
            },
            get: function get(e) {
                return e.dateGrid;
            }
        },
        metadata: t
    }, null, u), $baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$var$__esDecorate(null, a = {
        value: c
    }, s, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, l), c = a.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "MonthCalendar"
    }), $baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$var$__runInitializers(c, l), c;
}(), $baaeda96f7555c00$var$$4f69bf8d62d4bac9$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$4f69bf8d62d4bac9$exports, "Nameplate", function() {
    return $baaeda96f7555c00$var$$4f69bf8d62d4bac9$export$caa4d5435e8fb601;
});
var $baaeda96f7555c00$var$$4f69bf8d62d4bac9$export$caa4d5435e8fb601 = function $4f69bf8d62d4bac9$export$caa4d5435e8fb601(e) {
    var t = e.avatar, r = e.name;
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($tLNoZ.Fragment, {
        children: [
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($baaeda96f7555c00$var$$757747c0209676cc$export$e2255cf6045e8d47, {
                size: 2,
                style: {
                    marginRight: "0.5rem"
                },
                src: t
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("span", {
                className: "align-middle",
                children: r
            })
        ]
    });
};
$baaeda96f7555c00$var$$4f69bf8d62d4bac9$export$caa4d5435e8fb601.displayName = "Nameplate";
var $baaeda96f7555c00$var$$d78fd73e1713e936$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$d78fd73e1713e936$exports, "PageNav", function() {
    return $baaeda96f7555c00$var$$d78fd73e1713e936$export$f24150b9675a2c65;
});
var $baaeda96f7555c00$var$$d78fd73e1713e936$var$__runInitializers = function $d78fd73e1713e936$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $baaeda96f7555c00$var$$d78fd73e1713e936$var$__esDecorate = function $d78fd73e1713e936$var$__esDecorate(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $baaeda96f7555c00$var$$d78fd73e1713e936$var$__setFunctionName = function $d78fd73e1713e936$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $baaeda96f7555c00$var$$d78fd73e1713e936$var$__classPrivateFieldGet = function $d78fd73e1713e936$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $baaeda96f7555c00$var$$d78fd73e1713e936$var$__classPrivateFieldSet = function $d78fd73e1713e936$var$__classPrivateFieldSet(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $baaeda96f7555c00$var$$d78fd73e1713e936$var$__rest = function $d78fd73e1713e936$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$d78fd73e1713e936$var$HeadingSelector = Array.from(Array(6), function(e, t) {
    return "h".concat(++t);
}) + "", $baaeda96f7555c00$var$$d78fd73e1713e936$export$f24150b9675a2c65 = function() {
    var e, t, r, a, c, n, i, o, s, l = [
        $e04d4b638436dc5e$export$b6ae1bc530f4c149
    ], $ = [], u = $tLNoZ.Component, d = [], f = [], p = [], b = [], v = [];
    return n = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), r.set(_$e, ($baaeda96f7555c00$var$$d78fd73e1713e936$var$__runInitializers(_$e, d), $baaeda96f7555c00$var$$d78fd73e1713e936$var$__runInitializers(_$e, f, []))), a.set(_$e, ($baaeda96f7555c00$var$$d78fd73e1713e936$var$__runInitializers(_$e, p), $baaeda96f7555c00$var$$d78fd73e1713e936$var$__runInitializers(_$e, b, 0))), Object.defineProperty(_$e, "updateScrollY", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($baaeda96f7555c00$var$$d78fd73e1713e936$var$__runInitializers(_$e, v), function() {
                    return _$e.scrollY = window.scrollY;
                })
            }), Object.defineProperty(_$e, "scrollTo", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    return function() {
                        var r, a;
                        setTimeout(function() {
                            return (0, $lhPyT.scrollTo)('[id="'.concat(t.id, '"]'));
                        }), null == (a = (r = _$e.props).onItemClick) || a.call(r, t);
                    };
                }
            }), Object.defineProperty(_$e, "renderLink", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    var r = t.id, a = t.level, c = t.text, n = t.top, i = _$e.currentActiveId, o = _$e.props.depth;
                    return a <= (void 0 === o ? 1 / 0 : o) && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($b36744b28a8e5731$export$2e2bcd8739ae039.Item, {
                        style: {
                            textIndent: "".concat(a - 1, "rem")
                        },
                        children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($b36744b28a8e5731$export$2e2bcd8739ae039.Link, {
                            href: "#".concat(r),
                            active: i === r,
                            onClick: _$e.scrollTo({
                                id: r,
                                level: a,
                                text: c,
                                top: n
                            }),
                            children: c
                        })
                    }, r);
                }
            }), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "list",
                get: function get() {
                    return $baaeda96f7555c00$var$$d78fd73e1713e936$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $baaeda96f7555c00$var$$d78fd73e1713e936$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "scrollY",
                get: function get() {
                    return $baaeda96f7555c00$var$$d78fd73e1713e936$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function set(e) {
                    $baaeda96f7555c00$var$$d78fd73e1713e936$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "currentActiveId",
                get: function get() {
                    var _$e, _$t = this.list, r = this.scrollY, a = _$t.findIndex(function(e) {
                        return e.top > r;
                    });
                    return null == (_$e = _$t[a - 1]) ? void 0 : _$e.id;
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    globalThis.document && (window.addEventListener("scroll", this.updateScrollY), this.list = Array.from(document.querySelectorAll($baaeda96f7555c00$var$$d78fd73e1713e936$var$HeadingSelector), function(e) {
                        e.id || (e.id = (0, $lhPyT.uniqueID)());
                        var _$t = e.id, r = e.tagName, a = e.textContent, c = e.offsetTop;
                        return {
                            id: _$t,
                            level: +r[1],
                            text: a.trim(),
                            top: c
                        };
                    }));
                }
            },
            {
                key: "componentWillUnmount",
                value: function value() {
                    var _$e;
                    null == (_$e = globalThis.removeEventListener) || _$e.call(globalThis, "scroll", this.updateScrollY);
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this.list, _$t = this.props, r = _$t.style, a = _$t.variant, c = $baaeda96f7555c00$var$$d78fd73e1713e936$var$__rest(_$t, [
                        "style",
                        "variant"
                    ]);
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($b36744b28a8e5731$export$2e2bcd8739ae039, Object.assign({}, c, {
                        variant: void 0 === a ? "underline" : a,
                        style: Object.assign({
                            flexDirection: "column"
                        }, r),
                        children: _$e.map(this.renderLink)
                    }));
                }
            }
        ]), t;
    }(u), r = new WeakMap, a = new WeakMap, $baaeda96f7555c00$var$$d78fd73e1713e936$var$__setFunctionName(n, "PageNav"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = u[Symbol.metadata]) ? e : null) : void 0, i = [
        $h2kUE.observable
    ], o = [
        $h2kUE.observable
    ], s = [
        $h2kUE.computed
    ], $baaeda96f7555c00$var$$d78fd73e1713e936$var$__esDecorate(n, null, i, {
        kind: "accessor",
        name: "list",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "list" in e;
            },
            get: function get(e) {
                return e.list;
            },
            set: function set(e, t) {
                e.list = t;
            }
        },
        metadata: t
    }, f, p), $baaeda96f7555c00$var$$d78fd73e1713e936$var$__esDecorate(n, null, o, {
        kind: "accessor",
        name: "scrollY",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "scrollY" in e;
            },
            get: function get(e) {
                return e.scrollY;
            },
            set: function set(e, t) {
                e.scrollY = t;
            }
        },
        metadata: t
    }, b, v), $baaeda96f7555c00$var$$d78fd73e1713e936$var$__esDecorate(n, null, s, {
        kind: "getter",
        name: "currentActiveId",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "currentActiveId" in e;
            },
            get: function get(e) {
                return e.currentActiveId;
            }
        },
        metadata: t
    }, null, d), $baaeda96f7555c00$var$$d78fd73e1713e936$var$__esDecorate(null, c = {
        value: n
    }, l, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, $), n = c.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "PageNav"
    }), $baaeda96f7555c00$var$$d78fd73e1713e936$var$__runInitializers(n, $), n;
}(), $baaeda96f7555c00$var$$ce59ae9613bac5f2$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$ce59ae9613bac5f2$exports, "ScrollNav", function() {
    return $baaeda96f7555c00$var$$ce59ae9613bac5f2$export$c57977d1ebb6ef1d;
}), $baaeda96f7555c00$var$$cb8a09c271d9e2a2$export$70443d1bfecdb242 = "_1MZNfG_scrollButtonLeft", $baaeda96f7555c00$var$$cb8a09c271d9e2a2$export$a025291d1676ce41 = "_1MZNfG_scrollButtonRight", $baaeda96f7555c00$var$$cb8a09c271d9e2a2$export$2585081e06ef4cbf = "_1MZNfG_scrollerInner";
var $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__runInitializers = function $ce59ae9613bac5f2$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__esDecorate = function $ce59ae9613bac5f2$var$__esDecorate(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__setFunctionName = function $ce59ae9613bac5f2$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__classPrivateFieldGet = function $ce59ae9613bac5f2$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__classPrivateFieldSet = function $ce59ae9613bac5f2$var$__classPrivateFieldSet(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__rest = function $ce59ae9613bac5f2$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$ce59ae9613bac5f2$export$c57977d1ebb6ef1d = function() {
    var e, t, r, a, c, n, i, o, s, l, $, u, d = [
        $e04d4b638436dc5e$export$b6ae1bc530f4c149
    ], f = [], p = $tLNoZ.Component, b = [], v = [], m = [], h = [], x = [], _ = [], j = [];
    return i = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(_$e, "scrollerRef", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__runInitializers(_$e, b), (0, $tLNoZ.createRef)())
            }), r.set(_$e, $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__runInitializers(_$e, v, 0)), a.set(_$e, ($baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__runInitializers(_$e, m), $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__runInitializers(_$e, h, 0))), c.set(_$e, ($baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__runInitializers(_$e, x), $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__runInitializers(_$e, _, 0))), Object.defineProperty(_$e, "updateScroll", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__runInitializers(_$e, j), function() {
                    var _$t = _$e.scrollerRef.current;
                    return _$t && (_$e.scrollLeft = _$t.scrollLeft, _$e.scrollWidth = _$t.scrollWidth, _$e.clientWidth = _$t.clientWidth), _$t;
                })
            }), Object.defineProperty(_$e, "resizeObserver", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: void 0
            }), Object.defineProperty(_$e, "scrollBy", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    return function() {
                        var r = _$e.scrollerRef.current;
                        r && r.scrollBy({
                            left: t * r.clientWidth * .8,
                            behavior: "smooth"
                        });
                    };
                }
            }), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "scrollLeft",
                get: function get() {
                    return $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "scrollWidth",
                get: function get() {
                    return $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function set(e) {
                    $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "clientWidth",
                get: function get() {
                    return $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__classPrivateFieldGet(this, c, "f");
                },
                set: function set(e) {
                    $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__classPrivateFieldSet(this, c, e, "f");
                }
            },
            {
                key: "canScrollLeft",
                get: function get() {
                    return this.scrollLeft > 0;
                }
            },
            {
                key: "canScrollRight",
                get: function get() {
                    return this.scrollLeft + this.clientWidth < this.scrollWidth;
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    var _$e = this.updateScroll();
                    _$e && (_$e.addEventListener("scroll", this.updateScroll), this.resizeObserver = new ResizeObserver(this.updateScroll), this.resizeObserver.observe(_$e));
                }
            },
            {
                key: "componentWillUnmount",
                value: function value() {
                    var _$e, _$t;
                    null == (_$e = this.resizeObserver) || _$e.disconnect(), null == (_$t = this.scrollerRef.current) || _$t.removeEventListener("scroll", this.updateScroll);
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this.canScrollLeft, _$t = this.canScrollRight, r = this.props, a = r.className, c = r.children, n = $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__rest(r, [
                        "className",
                        "children"
                    ]);
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                        className: "position-relative overflow-y-hidden ".concat(void 0 === a ? "" : a),
                        children: [
                            _$e && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("button", {
                                type: "button",
                                className: "position-absolute top-0 bottom-0 start-0 z-1 border-0 px-2 ".concat($baaeda96f7555c00$var$$cb8a09c271d9e2a2$export$70443d1bfecdb242),
                                "aria-label": "Scroll left",
                                onClick: this.scrollBy(-1),
                                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($baaeda96f7555c00$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f, {
                                    name: "caret-left-fill"
                                })
                            }),
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                                ref: this.scrollerRef,
                                className: "overflow-x-auto ".concat($baaeda96f7555c00$var$$cb8a09c271d9e2a2$export$2585081e06ef4cbf),
                                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($b36744b28a8e5731$export$2e2bcd8739ae039, Object.assign({}, n, {
                                    className: "flex-nowrap",
                                    children: c
                                }))
                            }),
                            _$t && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("button", {
                                type: "button",
                                className: "position-absolute top-0 bottom-0 end-0 z-1 border-0 px-2 ".concat($baaeda96f7555c00$var$$cb8a09c271d9e2a2$export$a025291d1676ce41),
                                "aria-label": "Scroll right",
                                onClick: this.scrollBy(1),
                                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($baaeda96f7555c00$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f, {
                                    name: "caret-right-fill"
                                })
                            })
                        ]
                    });
                }
            }
        ]), t;
    }(p), r = new WeakMap, a = new WeakMap, c = new WeakMap, $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__setFunctionName(i, "ScrollNav"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = p[Symbol.metadata]) ? e : null) : void 0, o = [
        $h2kUE.observable
    ], s = [
        $h2kUE.observable
    ], l = [
        $h2kUE.observable
    ], $ = [
        $h2kUE.computed
    ], u = [
        $h2kUE.computed
    ], $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__esDecorate(i, null, o, {
        kind: "accessor",
        name: "scrollLeft",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "scrollLeft" in e;
            },
            get: function get(e) {
                return e.scrollLeft;
            },
            set: function set(e, t) {
                e.scrollLeft = t;
            }
        },
        metadata: t
    }, v, m), $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__esDecorate(i, null, s, {
        kind: "accessor",
        name: "scrollWidth",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "scrollWidth" in e;
            },
            get: function get(e) {
                return e.scrollWidth;
            },
            set: function set(e, t) {
                e.scrollWidth = t;
            }
        },
        metadata: t
    }, h, x), $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__esDecorate(i, null, l, {
        kind: "accessor",
        name: "clientWidth",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "clientWidth" in e;
            },
            get: function get(e) {
                return e.clientWidth;
            },
            set: function set(e, t) {
                e.clientWidth = t;
            }
        },
        metadata: t
    }, _, j), $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__esDecorate(i, null, $, {
        kind: "getter",
        name: "canScrollLeft",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "canScrollLeft" in e;
            },
            get: function get(e) {
                return e.canScrollLeft;
            }
        },
        metadata: t
    }, null, b), $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__esDecorate(i, null, u, {
        kind: "getter",
        name: "canScrollRight",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "canScrollRight" in e;
            },
            get: function get(e) {
                return e.canScrollRight;
            }
        },
        metadata: t
    }, null, b), $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__esDecorate(null, n = {
        value: i
    }, d, {
        kind: "class",
        name: i.name,
        metadata: t
    }, null, f), i = n.value, t && Object.defineProperty(i, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(i, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "ScrollNav"
    }), $baaeda96f7555c00$var$$ce59ae9613bac5f2$var$__runInitializers(i, f), i;
}(), $baaeda96f7555c00$var$$5d0c8d8af5c3c7e5$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$5d0c8d8af5c3c7e5$exports, "Option", function() {
    return $baaeda96f7555c00$var$$5d0c8d8af5c3c7e5$export$36d18380658d5d20;
}), $baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$5d0c8d8af5c3c7e5$exports, "Select", function() {
    return $baaeda96f7555c00$var$$5d0c8d8af5c3c7e5$export$ef9b1a59e592288f;
});
var $baaeda96f7555c00$var$$5d0c8d8af5c3c7e5$var$__rest = function $5d0c8d8af5c3c7e5$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$5d0c8d8af5c3c7e5$export$36d18380658d5d20 = function $5d0c8d8af5c3c7e5$export$36d18380658d5d20(e) {
    var t = e.value, r = e.children, a = $baaeda96f7555c00$var$$5d0c8d8af5c3c7e5$var$__rest(e, [
        "value",
        "children"
    ]);
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($ba2b7961c23f1087$export$2e2bcd8739ae039.Item, Object.assign({}, a, {
        "data-value": t,
        children: r
    }));
};
$baaeda96f7555c00$var$$5d0c8d8af5c3c7e5$export$36d18380658d5d20.displayName = "Option";
var $baaeda96f7555c00$var$$5d0c8d8af5c3c7e5$export$ef9b1a59e592288f = function $5d0c8d8af5c3c7e5$export$ef9b1a59e592288f(e) {
    var t = e.className, r = e.style, a = e.variant, c = e.menuVariant, n = e.children, i = e.value, o = e.onChange, s = e.valueRender, l = (0, $lhPyT.makeArray)(n).flat(1 / 0).find(function(e) {
        return (0, $1aLYV.isValidElement)(e) && e.type === $baaeda96f7555c00$var$$5d0c8d8af5c3c7e5$export$36d18380658d5d20 && e.props.value === i;
    });
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($ba2b7961c23f1087$export$2e2bcd8739ae039, {
        onClick: function onClick(e) {
            var t = e.target.closest(".dropdown-item");
            if (t) {
                var r = t.dataset.value;
                null == o || o(r);
            }
        },
        children: [
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($ba2b7961c23f1087$export$2e2bcd8739ae039.Toggle, {
                className: $baaeda96f7555c00$var$$parcel$interopDefault($8bd163097a5514bf$exports)("w-100", "d-flex", "justify-content-between", "align-items-center", !a && "bg-white text-dark", t),
                style: r,
                variant: a,
                children: (null == s ? void 0 : s(i)) || (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                    className: null == l ? void 0 : l.props.className,
                    children: null == l ? void 0 : l.props.children
                })
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($ba2b7961c23f1087$export$2e2bcd8739ae039.Menu, {
                variant: c,
                children: n
            })
        ]
    });
};
$baaeda96f7555c00$var$$5d0c8d8af5c3c7e5$export$ef9b1a59e592288f.displayName = "Select";
var $baaeda96f7555c00$var$$5c7497f9f3fe6432$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$5c7497f9f3fe6432$exports, "elementToImage", function() {
    return $baaeda96f7555c00$var$$5c7497f9f3fe6432$export$fefa3387c33a1dfc;
}), $baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$5c7497f9f3fe6432$exports, "ShareBox", function() {
    return $baaeda96f7555c00$var$$5c7497f9f3fe6432$export$e15a265ebbd5ca8c;
});
var $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__esDecorate = function $5c7497f9f3fe6432$var$__esDecorate(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__runInitializers = function $5c7497f9f3fe6432$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__awaiter = function $5c7497f9f3fe6432$var$__awaiter(e, t, r, a) {
    return new (r || (r = Promise))(function(c, n) {
        function i(e) {
            try {
                s(a.next(e));
            } catch (e) {
                n(e);
            }
        }
        function o(e) {
            try {
                s(a.throw(e));
            } catch (e) {
                n(e);
            }
        }
        function s(e) {
            var _$t;
            e.done ? c(e.value) : ((_$t = e.value) instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(i, o);
        }
        s((a = a.apply(e, t || [])).next());
    });
}, $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__setFunctionName = function $5c7497f9f3fe6432$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__classPrivateFieldGet = function $5c7497f9f3fe6432$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__classPrivateFieldSet = function $5c7497f9f3fe6432$var$__classPrivateFieldSet(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__rest = function $5c7497f9f3fe6432$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
};
function $baaeda96f7555c00$var$$5c7497f9f3fe6432$export$fefa3387c33a1dfc(e, t, r) {
    return $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__awaiter(this, void 0, void 0, function() {
        var a;
        return (0, $ea05ccc2484f951f$export$71511d61b312f219)(this, function(c) {
            switch(c.label){
                case 0:
                    return [
                        4,
                        $baaeda96f7555c00$var$$parcel$interopDefault($b664ecd293cb806f$exports)(e, {
                            useCORS: !0
                        })
                    ];
                case 1:
                    return a = c.sent(), [
                        2,
                        new Promise(function(e, c) {
                            return a.toBlob(function(t) {
                                return t ? e(URL.createObjectURL(t)) : c();
                            }, t, r);
                        })
                    ];
            }
        });
    });
}
var $baaeda96f7555c00$var$$5c7497f9f3fe6432$export$e15a265ebbd5ca8c = function() {
    var e, t, r, a, c, n, i, o, s = [
        $e04d4b638436dc5e$export$b6ae1bc530f4c149
    ], l = [], $ = $tLNoZ.Component, u = [], d = [], f = [], p = [];
    return n = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(_$e, "root", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: (0, $tLNoZ.createRef)()
            }), r.set(_$e, $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__runInitializers(_$e, u, !1)), a.set(_$e, ($baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__runInitializers(_$e, d), $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__runInitializers(_$e, f, ""))), Object.defineProperty(_$e, "generateImage", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__runInitializers(_$e, p), function() {
                    return $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__awaiter(_$e, void 0, void 0, function() {
                        var _$e;
                        return (0, $ea05ccc2484f951f$export$71511d61b312f219)(this, function(t) {
                            switch(t.label){
                                case 0:
                                    return this.imageURI && (URL.revokeObjectURL(this.imageURI), this.imageURI = ""), this.loading = !0, _$e = this, [
                                        4,
                                        $baaeda96f7555c00$var$$5c7497f9f3fe6432$export$fefa3387c33a1dfc(this.root.current)
                                    ];
                                case 1:
                                    return _$e.imageURI = t.sent(), this.loading = !1, [
                                        2
                                    ];
                            }
                        });
                    });
                })
            }), Object.defineProperty(_$e, "share", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    return $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__awaiter(_$e, void 0, void 0, function() {
                        var _$e, r, a;
                        return (0, $ea05ccc2484f951f$export$71511d61b312f219)(this, function(c) {
                            switch(c.label){
                                case 0:
                                    return t.stopPropagation(), [
                                        4,
                                        (0, $lhPyT.blobOf)(this.imageURI)
                                    ];
                                case 1:
                                    return a = new File([
                                        r = c.sent()
                                    ], "".concat(this.props.title, ".png"), {
                                        type: r.type
                                    }), [
                                        4,
                                        null == (_$e = navigator.share) ? void 0 : _$e.call(navigator, Object.assign({
                                            files: [
                                                a
                                            ]
                                        }, this.props))
                                    ];
                                case 2:
                                    return c.sent(), [
                                        2
                                    ];
                            }
                        });
                    });
                }
            }), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "loading",
                get: function get() {
                    return $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "imageURI",
                get: function get() {
                    return $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function set(e) {
                    $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    var _$e;
                    null == (_$e = globalThis.addEventListener) || _$e.call(globalThis, "resize", this.generateImage);
                }
            },
            {
                key: "componentWillUnmount",
                value: function value() {
                    var _$e;
                    null == (_$e = globalThis.removeEventListener) || _$e.call(globalThis, "resize", this.generateImage);
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this.props, _$t = _$e.className, r = _$e.children, a = $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__rest(_$e, [
                        "className",
                        "children"
                    ]), c = this.loading, n = this.imageURI;
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($tLNoZ.Fragment, {
                        children: [
                            c && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($baaeda96f7555c00$var$$1f7252b8d0187295$export$669f6ea7d267feaf, {}),
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", Object.assign({}, a, {
                                ref: this.root,
                                className: "position-relative ".concat(void 0 === _$t ? "" : _$t),
                                onMouseEnter: n ? void 0 : this.generateImage,
                                onTouchStart: n ? void 0 : this.generateImage,
                                children: [
                                    r,
                                    n && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($9f5f1ff841daa39a$export$2e2bcd8739ae039, {
                                        className: "position-absolute start-0 top-0 w-100 h-100",
                                        src: n,
                                        alt: "Share Image",
                                        fluid: !0,
                                        onClick: this.share
                                    })
                                ]
                            }))
                        ]
                    });
                }
            }
        ]), t;
    }($), r = new WeakMap, a = new WeakMap, $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__setFunctionName(n, "ShareBox"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, i = [
        $h2kUE.observable
    ], o = [
        $h2kUE.observable
    ], $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__esDecorate(n, null, i, {
        kind: "accessor",
        name: "loading",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "loading" in e;
            },
            get: function get(e) {
                return e.loading;
            },
            set: function set(e, t) {
                e.loading = t;
            }
        },
        metadata: t
    }, u, d), $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__esDecorate(n, null, o, {
        kind: "accessor",
        name: "imageURI",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "imageURI" in e;
            },
            get: function get(e) {
                return e.imageURI;
            },
            set: function set(e, t) {
                e.imageURI = t;
            }
        },
        metadata: t
    }, f, p), $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__esDecorate(null, c = {
        value: n
    }, s, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, l), n = c.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "ShareBox"
    }), $baaeda96f7555c00$var$$5c7497f9f3fe6432$var$__runInitializers(n, l), n;
}(), $baaeda96f7555c00$var$$ad4a2cea628613d5$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$ad4a2cea628613d5$exports, "SpinnerButton", function() {
    return $baaeda96f7555c00$var$$ad4a2cea628613d5$export$4cfabf47f4311ebb;
});
var $baaeda96f7555c00$var$$ad4a2cea628613d5$var$__rest = function $ad4a2cea628613d5$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$ad4a2cea628613d5$export$4cfabf47f4311ebb = function $ad4a2cea628613d5$export$4cfabf47f4311ebb(e) {
    var t = e.animation, r = e.loading, a = e.disabled, c = e.children, n = $baaeda96f7555c00$var$$ad4a2cea628613d5$var$__rest(e, [
        "animation",
        "loading",
        "disabled",
        "children"
    ]);
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($3a399bf6b2fd4261$export$2e2bcd8739ae039, Object.assign({}, n, {
        disabled: r || a,
        children: [
            r && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($tLNoZ.Fragment, {
                children: [
                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($d5fc9490b2821269$export$2e2bcd8739ae039, {
                        as: "span",
                        className: c ? "me-2" : "",
                        size: "sm",
                        animation: t,
                        role: "status",
                        "aria-hidden": "true"
                    }),
                    !c && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("span", {
                        className: "visually-hidden",
                        children: "Loading..."
                    })
                ]
            }),
            c
        ]
    }));
};
$baaeda96f7555c00$var$$ad4a2cea628613d5$export$4cfabf47f4311ebb.displayName = "SpinnerButton";
var $baaeda96f7555c00$var$$53fa7c21606566cb$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$53fa7c21606566cb$exports, "TableSpinner", function() {
    return $baaeda96f7555c00$var$$53fa7c21606566cb$export$4706ba151aa92b7e;
});
var $baaeda96f7555c00$var$$53fa7c21606566cb$var$__rest = function $53fa7c21606566cb$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$53fa7c21606566cb$export$4706ba151aa92b7e = function $53fa7c21606566cb$export$4706ba151aa92b7e(e) {
    var t = e.animation, r = e.variant, a = e.size, c = e.colSpan, n = $baaeda96f7555c00$var$$53fa7c21606566cb$var$__rest(e, [
        "animation",
        "variant",
        "size",
        "colSpan"
    ]);
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("tr", Object.assign({}, n, {
        children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("td", {
            className: "text-center p-4",
            colSpan: c,
            children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($d5fc9490b2821269$export$2e2bcd8739ae039, {
                animation: void 0 === t ? "border" : t,
                variant: void 0 === r ? "primary" : r,
                size: a
            })
        })
    }));
};
$baaeda96f7555c00$var$$53fa7c21606566cb$export$4706ba151aa92b7e.displayName = "TableSpinner";
var $baaeda96f7555c00$var$$295b3641db3d8c33$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$295b3641db3d8c33$exports, "TextTruncate", function() {
    return $baaeda96f7555c00$var$$295b3641db3d8c33$export$ee6221c372f955f;
});
var $baaeda96f7555c00$var$$295b3641db3d8c33$var$__esDecorate = function $295b3641db3d8c33$var$__esDecorate(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $baaeda96f7555c00$var$$295b3641db3d8c33$var$__runInitializers = function $295b3641db3d8c33$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $baaeda96f7555c00$var$$295b3641db3d8c33$var$__setFunctionName = function $295b3641db3d8c33$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $baaeda96f7555c00$var$$295b3641db3d8c33$var$__classPrivateFieldGet = function $295b3641db3d8c33$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $baaeda96f7555c00$var$$295b3641db3d8c33$var$__classPrivateFieldSet = function $295b3641db3d8c33$var$__classPrivateFieldSet(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $baaeda96f7555c00$var$$295b3641db3d8c33$var$__rest = function $295b3641db3d8c33$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$295b3641db3d8c33$export$ee6221c372f955f = function() {
    var e, t, r, a, c, n, i, o, s = [
        $e04d4b638436dc5e$export$b6ae1bc530f4c149
    ], l = [], $ = $tLNoZ.Component, u = [], d = [], f = [], p = [];
    return n = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), r.set(_$e, $baaeda96f7555c00$var$$295b3641db3d8c33$var$__runInitializers(_$e, u, !1)), a.set(_$e, ($baaeda96f7555c00$var$$295b3641db3d8c33$var$__runInitializers(_$e, d), $baaeda96f7555c00$var$$295b3641db3d8c33$var$__runInitializers(_$e, f, !1))), Object.defineProperty(_$e, "contentRef", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($baaeda96f7555c00$var$$295b3641db3d8c33$var$__runInitializers(_$e, p), (0, $tLNoZ.createRef)())
            }), Object.defineProperty(_$e, "checkOverflow", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value() {
                    var _$t = _$e.contentRef.current;
                    _$t && (_$e.overflowed = _$t.scrollHeight > _$t.clientHeight);
                }
            }), Object.defineProperty(_$e, "toggle", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value() {
                    _$e.expanded = !_$e.expanded, _$e.expanded || requestAnimationFrame(_$e.checkOverflow);
                }
            }), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "expanded",
                get: function get() {
                    return $baaeda96f7555c00$var$$295b3641db3d8c33$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $baaeda96f7555c00$var$$295b3641db3d8c33$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "overflowed",
                get: function get() {
                    return $baaeda96f7555c00$var$$295b3641db3d8c33$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function set(e) {
                    $baaeda96f7555c00$var$$295b3641db3d8c33$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    this.checkOverflow(), window.addEventListener("resize", this.checkOverflow);
                }
            },
            {
                key: "componentDidUpdate",
                value: function value(e) {
                    var _$t = e.rows, r = e.children;
                    this.expanded || r === this.props.children && _$t === this.props.rows || this.checkOverflow();
                }
            },
            {
                key: "componentWillUnmount",
                value: function value() {
                    window.removeEventListener("resize", this.checkOverflow);
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this.props, _$t = _$e.children, r = _$e.rows, a = _$e.expandText, c = _$e.collapseText, n = $baaeda96f7555c00$var$$295b3641db3d8c33$var$__rest(_$e, [
                        "children",
                        "rows",
                        "expandText",
                        "collapseText"
                    ]), i = this.expanded, o = this.overflowed;
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", Object.assign({}, n, {
                        children: [
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("p", {
                                ref: this.contentRef,
                                style: i ? void 0 : {
                                    overflow: "hidden",
                                    display: "-webkit-box",
                                    WebkitBoxOrient: "vertical",
                                    WebkitLineClamp: void 0 === r ? 3 : r
                                },
                                children: _$t
                            }),
                            (o || i) && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("button", {
                                type: "button",
                                className: "bg-transparent border-0 p-0",
                                "aria-expanded": i,
                                onClick: this.toggle,
                                children: i ? void 0 === c ? "\u23EB" : c : void 0 === a ? "\u23EC" : a
                            })
                        ]
                    }));
                }
            }
        ]), t;
    }($), r = new WeakMap, a = new WeakMap, $baaeda96f7555c00$var$$295b3641db3d8c33$var$__setFunctionName(n, "TextTruncate"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, i = [
        $h2kUE.observable
    ], o = [
        $h2kUE.observable
    ], $baaeda96f7555c00$var$$295b3641db3d8c33$var$__esDecorate(n, null, i, {
        kind: "accessor",
        name: "expanded",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "expanded" in e;
            },
            get: function get(e) {
                return e.expanded;
            },
            set: function set(e, t) {
                e.expanded = t;
            }
        },
        metadata: t
    }, u, d), $baaeda96f7555c00$var$$295b3641db3d8c33$var$__esDecorate(n, null, o, {
        kind: "accessor",
        name: "overflowed",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "overflowed" in e;
            },
            get: function get(e) {
                return e.overflowed;
            },
            set: function set(e, t) {
                e.overflowed = t;
            }
        },
        metadata: t
    }, f, p), $baaeda96f7555c00$var$$295b3641db3d8c33$var$__esDecorate(null, c = {
        value: n
    }, s, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, l), n = c.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "TextTruncate"
    }), $baaeda96f7555c00$var$$295b3641db3d8c33$var$__runInitializers(n, l), n;
}(), $baaeda96f7555c00$var$$03c0468daff9422a$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$03c0468daff9422a$exports, "Time", function() {
    return $baaeda96f7555c00$var$$03c0468daff9422a$export$680ea196effce5f;
});
var $baaeda96f7555c00$var$$03c0468daff9422a$var$__runInitializers = function $03c0468daff9422a$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $baaeda96f7555c00$var$$03c0468daff9422a$var$__esDecorate = function $03c0468daff9422a$var$__esDecorate(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $baaeda96f7555c00$var$$03c0468daff9422a$var$__setFunctionName = function $03c0468daff9422a$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $baaeda96f7555c00$var$$03c0468daff9422a$var$__classPrivateFieldGet = function $03c0468daff9422a$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $baaeda96f7555c00$var$$03c0468daff9422a$var$__classPrivateFieldSet = function $03c0468daff9422a$var$__classPrivateFieldSet(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $baaeda96f7555c00$var$$03c0468daff9422a$var$__rest = function $03c0468daff9422a$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$03c0468daff9422a$export$680ea196effce5f = function() {
    var e, t, r, a, c, n, i, o = [
        $e04d4b638436dc5e$export$b6ae1bc530f4c149
    ], s = [], l = $524de0d5a72e1bc6$exports.ObservedComponent, $ = [], u = [], d = [];
    return c = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), r.set(_$e, ($baaeda96f7555c00$var$$03c0468daff9422a$var$__runInitializers(_$e, $), $baaeda96f7555c00$var$$03c0468daff9422a$var$__runInitializers(_$e, u, _$e.updateText()))), $baaeda96f7555c00$var$$03c0468daff9422a$var$__runInitializers(_$e, d), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "updateText",
                value: function value() {
                    var _$e = this.props, _$t = _$e.dateTime, r = _$e.format;
                    return (0, $lhPyT.formatDate)(_$t, r);
                }
            },
            {
                key: "timeText",
                get: function get() {
                    return $baaeda96f7555c00$var$$03c0468daff9422a$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $baaeda96f7555c00$var$$03c0468daff9422a$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    (0, $57751a2649dd1683$export$71511d61b312f219)((0, $ae6313b3cbf000af$export$71511d61b312f219)(t.prototype), "componentDidMount", this).call(this), this.timeText = this.updateText();
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this.props, _$t = _$e.dateTime, r = $baaeda96f7555c00$var$$03c0468daff9422a$var$__rest(_$e, [
                        "dateTime"
                    ]);
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("time", Object.assign({
                        dateTime: new Date(_$t).toJSON()
                    }, r, {
                        children: this.timeText
                    }));
                }
            }
        ]), t;
    }(l), r = new WeakMap, $baaeda96f7555c00$var$$03c0468daff9422a$var$__setFunctionName(c, "Time"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = l[Symbol.metadata]) ? e : null) : void 0, n = [
        (0, $524de0d5a72e1bc6$exports.reaction)(function(e) {
            var t = e.observedProps;
            return t.dateTime + t.format;
        })
    ], i = [
        $h2kUE.observable
    ], $baaeda96f7555c00$var$$03c0468daff9422a$var$__esDecorate(c, null, n, {
        kind: "method",
        name: "updateText",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "updateText" in e;
            },
            get: function get(e) {
                return e.updateText;
            }
        },
        metadata: t
    }, null, $), $baaeda96f7555c00$var$$03c0468daff9422a$var$__esDecorate(c, null, i, {
        kind: "accessor",
        name: "timeText",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "timeText" in e;
            },
            get: function get(e) {
                return e.timeText;
            },
            set: function set(e, t) {
                e.timeText = t;
            }
        },
        metadata: t
    }, u, d), $baaeda96f7555c00$var$$03c0468daff9422a$var$__esDecorate(null, a = {
        value: c
    }, o, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, s), c = a.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "Time"
    }), $baaeda96f7555c00$var$$03c0468daff9422a$var$__runInitializers(c, s), c;
}(), $baaeda96f7555c00$var$$2f5f9093a9aac8ee$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$2f5f9093a9aac8ee$exports, "TimeDistance", function() {
    return $baaeda96f7555c00$var$$2f5f9093a9aac8ee$export$db3f63f9e19e5969;
});
var $baaeda96f7555c00$var$$2f5f9093a9aac8ee$var$__rest = function $2f5f9093a9aac8ee$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$2f5f9093a9aac8ee$var$UnitWords = {
    ms: "millisecond(s)",
    s: "second(s)",
    m: "minute(s)",
    H: "hour(s)",
    D: "day(s)",
    W: "week(s)",
    M: "month(s)",
    Y: "year(s)"
}, $baaeda96f7555c00$var$$2f5f9093a9aac8ee$export$db3f63f9e19e5969 = function $2f5f9093a9aac8ee$export$db3f63f9e19e5969(e) {
    var t = e.date, r = e.unitWords, a = e.beforeWord, c = e.afterWord, n = $baaeda96f7555c00$var$$2f5f9093a9aac8ee$var$__rest(e, [
        "date",
        "unitWords",
        "beforeWord",
        "afterWord"
    ]);
    t = new Date(t);
    var i = (0, $lhPyT.diffTime)(t), o = i.distance, s = i.unit;
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("time", Object.assign({}, n, {
        dateTime: t.toJSON(),
        title: t.toLocaleString(),
        children: [
            Math.abs(o),
            " ",
            (void 0 === r ? $baaeda96f7555c00$var$$2f5f9093a9aac8ee$var$UnitWords : r)[s],
            o < 0 ? void 0 === a ? " before" : a : void 0 === c ? " after" : c
        ]
    }));
};
$baaeda96f7555c00$var$$2f5f9093a9aac8ee$export$db3f63f9e19e5969.displayName = "TimeDistance";
var $baaeda96f7555c00$var$$31b55198d5058ded$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$31b55198d5058ded$exports, "Timeline", function() {
    return $baaeda96f7555c00$var$$31b55198d5058ded$export$e6a97ba2cae5bb94;
}), $baaeda96f7555c00$var$$4bfbcb67a3daf664$export$79ffe56a765070d2 = "TOztta_right", $baaeda96f7555c00$var$$4bfbcb67a3daf664$export$cddc5598d4bb8461 = "TOztta_timeline", $baaeda96f7555c00$var$$4bfbcb67a3daf664$export$73b7b5b52b6662d7 = "TOztta_timelineItem";
var $baaeda96f7555c00$var$$31b55198d5058ded$var$__rest = function $31b55198d5058ded$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$31b55198d5058ded$export$e6a97ba2cae5bb94 = function $31b55198d5058ded$export$e6a97ba2cae5bb94(e) {
    var t = e.className, r = e.events, a = e.timeFormat, c = $baaeda96f7555c00$var$$31b55198d5058ded$var$__rest(e, [
        "className",
        "events",
        "timeFormat"
    ]);
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("ol", Object.assign({
        className: "list-unstyled ".concat($baaeda96f7555c00$var$$4bfbcb67a3daf664$export$cddc5598d4bb8461, " ").concat(t)
    }, c, {
        children: r.map(function(e) {
            var t = e.title, r = e.summary, c = e.time, n = e.link, i = e.people;
            return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("li", {
                className: "position-relative ".concat($baaeda96f7555c00$var$$4bfbcb67a3daf664$export$73b7b5b52b6662d7, " ").concat($baaeda96f7555c00$var$$4bfbcb67a3daf664$export$79ffe56a765070d2),
                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($71075948dbe2717f$export$2e2bcd8739ae039, {
                    children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($71075948dbe2717f$export$2e2bcd8739ae039.Body, {
                        className: "p-4 d-flex flex-column gap-3 align-items-center",
                        children: [
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("h3", {
                                className: "h5 m-0",
                                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("a", {
                                    className: "text-decoration-none stretched-link",
                                    href: n,
                                    children: t
                                })
                            }),
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                                className: "small text-muted d-flex gap-2",
                                children: [
                                    "\u23F2\uFE0F",
                                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($baaeda96f7555c00$var$$03c0468daff9422a$export$680ea196effce5f, {
                                        dateTime: c[0],
                                        format: a
                                    }),
                                    c[1] && "~",
                                    c[1] && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($baaeda96f7555c00$var$$03c0468daff9422a$export$680ea196effce5f, {
                                        dateTime: c[1],
                                        format: a
                                    })
                                ]
                            }),
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("ul", {
                                className: "list-unstyled m-0 d-flex gap-2 flex-wrap justify-content-around",
                                children: null == i ? void 0 : i.map(function(e) {
                                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("li", {
                                        children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($baaeda96f7555c00$var$$4f69bf8d62d4bac9$export$caa4d5435e8fb601, Object.assign({}, e))
                                    }, e.name);
                                })
                            }),
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("p", {
                                className: "m-0",
                                children: r
                            })
                        ]
                    })
                })
            }, t);
        })
    }));
};
$baaeda96f7555c00$var$$31b55198d5058ded$export$e6a97ba2cae5bb94.displayName = "Timeline";
var $baaeda96f7555c00$var$$27e13b1ac3fbb57c$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$27e13b1ac3fbb57c$exports, "Toast", function() {
    return $baaeda96f7555c00$var$$27e13b1ac3fbb57c$export$8d8dc7d5f743331b;
});
var $baaeda96f7555c00$var$$27e13b1ac3fbb57c$var$__esDecorate = function $27e13b1ac3fbb57c$var$__esDecorate(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $baaeda96f7555c00$var$$27e13b1ac3fbb57c$var$__runInitializers = function $27e13b1ac3fbb57c$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $baaeda96f7555c00$var$$27e13b1ac3fbb57c$var$__classPrivateFieldGet = function $27e13b1ac3fbb57c$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $baaeda96f7555c00$var$$27e13b1ac3fbb57c$var$__classPrivateFieldSet = function $27e13b1ac3fbb57c$var$__classPrivateFieldSet(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $baaeda96f7555c00$var$$27e13b1ac3fbb57c$var$__rest = function $27e13b1ac3fbb57c$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$27e13b1ac3fbb57c$var$LIGHT_TEXT_VARIANTS = new Set([
    "warning",
    "info",
    "light"
]), $baaeda96f7555c00$var$$27e13b1ac3fbb57c$export$8d8dc7d5f743331b = function() {
    var e, t, r, a = [], c = [];
    return t = function() {
        "use strict";
        function e() {
            var t = this, n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : $lhPyT.Timestamp;
            (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, e), Object.defineProperty(this, "TimeScalar", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: n
            }), r.set(this, $baaeda96f7555c00$var$$27e13b1ac3fbb57c$var$__runInitializers(this, a, [])), Object.defineProperty(this, "Component", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($baaeda96f7555c00$var$$27e13b1ac3fbb57c$var$__runInitializers(this, c), (0, $e04d4b638436dc5e$export$b6ae1bc530f4c149)(function(e) {
                    var r = e.position;
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($bc6d7551699f5264$export$2e2bcd8739ae039, {
                        position: void 0 === r ? "top-end" : r,
                        className: "position-fixed p-3",
                        children: t.messages.map(t.renderMessage)
                    });
                }))
            }), Object.defineProperty(this, "renderMessage", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(e) {
                    var r = e.id, a = e.openedAt, c = e.title, n = e.body, i = e.variant, o = e.delay, s = void 0 === o ? 3e3 : o, l = i && !$baaeda96f7555c00$var$$27e13b1ac3fbb57c$var$LIGHT_TEXT_VARIANTS.has(i) ? "text-white" : void 0, $ = t.TimeScalar.distanceOf(Date.now(), a).toShortString();
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($abe172a988ca91d0$export$2e2bcd8739ae039, {
                        bg: i,
                        delay: s,
                        autohide: 0 !== s,
                        onClose: function onClose() {
                            return t.close(r);
                        },
                        children: [
                            (!!c || 0 === s) && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($abe172a988ca91d0$export$2e2bcd8739ae039.Header, {
                                children: [
                                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("strong", {
                                        className: "me-auto",
                                        children: c
                                    }),
                                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("small", {
                                        children: $
                                    })
                                ]
                            }),
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($abe172a988ca91d0$export$2e2bcd8739ae039.Body, {
                                className: l,
                                children: n
                            })
                        ]
                    }, r);
                }
            }), this.Component.displayName = "ToastComponent";
        }
        return (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(e, [
            {
                key: "messages",
                get: function get() {
                    return $baaeda96f7555c00$var$$27e13b1ac3fbb57c$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $baaeda96f7555c00$var$$27e13b1ac3fbb57c$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "open",
                value: function value(e) {
                    var t = (0, $lhPyT.uniqueID)(), r = Date.now(), a = Promise.withResolvers(), c = a.promise, n = a.resolve;
                    return this.messages = (0, $2b3349705fb2cb54$export$71511d61b312f219)(this.messages).concat([
                        Object.assign(Object.assign({
                            id: t
                        }, e), {
                            openedAt: r,
                            resolve: n
                        })
                    ]), c;
                }
            },
            {
                key: "close",
                value: function value(e) {
                    var t = this.messages.find(function(t) {
                        return t.id === e;
                    }) || {}, r = t.resolve, a = $baaeda96f7555c00$var$$27e13b1ac3fbb57c$var$__rest(t, [
                        "resolve"
                    ]);
                    null == r || r(Object.assign(Object.assign({}, a), {
                        closedAt: Date.now()
                    })), this.messages = this.messages.filter(function(t) {
                        return t.id !== e;
                    });
                }
            }
        ]), e;
    }(), r = new WeakMap, e = "function" == typeof Symbol && Symbol.metadata ? Object.create(null) : void 0, $baaeda96f7555c00$var$$27e13b1ac3fbb57c$var$__esDecorate(t, null, [
        $h2kUE.observable
    ], {
        kind: "accessor",
        name: "messages",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "messages" in e;
            },
            get: function get(e) {
                return e.messages;
            },
            set: function set(e, t) {
                e.messages = t;
            }
        },
        metadata: e
    }, a, c), e && Object.defineProperty(t, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }), t;
}(), $baaeda96f7555c00$var$$f4c02b33c4295ca8$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$f4c02b33c4295ca8$exports, "TypeEcho", function() {
    return $baaeda96f7555c00$var$$f4c02b33c4295ca8$export$2fe61c915a9818e6;
});
var $baaeda96f7555c00$var$$f4c02b33c4295ca8$var$__esDecorate = function $f4c02b33c4295ca8$var$__esDecorate(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $baaeda96f7555c00$var$$f4c02b33c4295ca8$var$__runInitializers = function $f4c02b33c4295ca8$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $baaeda96f7555c00$var$$f4c02b33c4295ca8$var$__awaiter = function $f4c02b33c4295ca8$var$__awaiter(e, t, r, a) {
    return new (r || (r = Promise))(function(c, n) {
        function i(e) {
            try {
                s(a.next(e));
            } catch (e) {
                n(e);
            }
        }
        function o(e) {
            try {
                s(a.throw(e));
            } catch (e) {
                n(e);
            }
        }
        function s(e) {
            var _$t;
            e.done ? c(e.value) : ((_$t = e.value) instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(i, o);
        }
        s((a = a.apply(e, t || [])).next());
    });
}, $baaeda96f7555c00$var$$f4c02b33c4295ca8$var$__setFunctionName = function $f4c02b33c4295ca8$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $baaeda96f7555c00$var$$f4c02b33c4295ca8$var$__classPrivateFieldGet = function $f4c02b33c4295ca8$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $baaeda96f7555c00$var$$f4c02b33c4295ca8$var$__classPrivateFieldSet = function $f4c02b33c4295ca8$var$__classPrivateFieldSet(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $baaeda96f7555c00$var$$f4c02b33c4295ca8$var$__rest = function $f4c02b33c4295ca8$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$f4c02b33c4295ca8$export$2fe61c915a9818e6 = function() {
    var e, t, r, a, c, n = [
        $e04d4b638436dc5e$export$b6ae1bc530f4c149
    ], i = [], o = $tLNoZ.Component, s = [], l = [];
    return c = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), r.set(_$e, $baaeda96f7555c00$var$$f4c02b33c4295ca8$var$__runInitializers(_$e, s, "")), Object.defineProperty(_$e, "init", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($baaeda96f7555c00$var$$f4c02b33c4295ca8$var$__runInitializers(_$e, l), function(t) {
                    return t && new IntersectionObserver(function(t, r) {
                        return $baaeda96f7555c00$var$$f4c02b33c4295ca8$var$__awaiter(_$e, [
                            t,
                            r
                        ], void 0, function(e, t) {
                            var _$r, a, c, n, i, o, s, l, $, u, d;
                            return (0, $ea05ccc2484f951f$export$71511d61b312f219)(this, function(f) {
                                switch(f.label){
                                    case 0:
                                        if (!(0, $83f83764f225915f$export$71511d61b312f219)(e, 1)[0].isIntersecting) return [
                                            2
                                        ];
                                        t.disconnect(), a = (_$r = this.props).text, n = void 0 === (c = _$r.intervals) ? 150 : c, i = !0, o = !1, s = void 0, f.label = 1;
                                    case 1:
                                        f.trys.push([
                                            1,
                                            6,
                                            7,
                                            8
                                        ]), l = a[Symbol.iterator](), f.label = 2;
                                    case 2:
                                        if (i = ($ = l.next()).done) return [
                                            3,
                                            5
                                        ];
                                        return u = $.value, [
                                            4,
                                            (0, $lhPyT.sleep)(n / 1e3)
                                        ];
                                    case 3:
                                        f.sent(), this.echoed += u, f.label = 4;
                                    case 4:
                                        return i = !0, [
                                            3,
                                            2
                                        ];
                                    case 5:
                                        return [
                                            3,
                                            8
                                        ];
                                    case 6:
                                        return d = f.sent(), o = !0, s = d, [
                                            3,
                                            8
                                        ];
                                    case 7:
                                        try {
                                            i || null == l.return || l.return();
                                        } finally{
                                            if (o) throw s;
                                        }
                                        return [
                                            7
                                        ];
                                    case 8:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }).observe(t);
                })
            }), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "echoed",
                get: function get() {
                    return $baaeda96f7555c00$var$$f4c02b33c4295ca8$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $baaeda96f7555c00$var$$f4c02b33c4295ca8$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this.props, _$t = _$e.className, r = _$e.text, a = $baaeda96f7555c00$var$$f4c02b33c4295ca8$var$__rest(_$e, [
                        "className",
                        "text"
                    ]), c = this.echoed;
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("pre", Object.assign({}, a, {
                        ref: this.init,
                        className: $baaeda96f7555c00$var$$parcel$interopDefault($8bd163097a5514bf$exports)("text-wrap", _$t),
                        children: c + (c === r ? "" : "_")
                    }));
                }
            }
        ]), t;
    }(o), r = new WeakMap, $baaeda96f7555c00$var$$f4c02b33c4295ca8$var$__setFunctionName(c, "TypeEcho"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = o[Symbol.metadata]) ? e : null) : void 0, $baaeda96f7555c00$var$$f4c02b33c4295ca8$var$__esDecorate(c, null, [
        $h2kUE.observable
    ], {
        kind: "accessor",
        name: "echoed",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "echoed" in e;
            },
            get: function get(e) {
                return e.echoed;
            },
            set: function set(e, t) {
                e.echoed = t;
            }
        },
        metadata: t
    }, s, l), $baaeda96f7555c00$var$$f4c02b33c4295ca8$var$__esDecorate(null, a = {
        value: c
    }, n, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, i), c = a.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "TypeEcho"
    }), $baaeda96f7555c00$var$$f4c02b33c4295ca8$var$__runInitializers(c, i), c;
}(), $baaeda96f7555c00$var$$77dc12b8e0b9d622$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$77dc12b8e0b9d622$exports, "UserRankView", function() {
    return $baaeda96f7555c00$var$$77dc12b8e0b9d622$export$4ed039229ec81818;
});
var $baaeda96f7555c00$var$$c5da9bad1903a67d$export$5f821f795e2d2901 = function $c5da9bad1903a67d$export$5f821f795e2d2901(e) {
    var t = e.email, r = e.website;
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("address", {
        className: "mb-0 d-flex justify-content-around gap-2",
        children: [
            t && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("a", {
                rel: "noreferrer",
                target: "_blank",
                href: "mailto:" + t,
                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($baaeda96f7555c00$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f, {
                    name: "envelope"
                })
            }),
            r && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("a", {
                rel: "noreferrer",
                target: "_blank",
                href: r,
                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($baaeda96f7555c00$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f, {
                    name: "globe2"
                })
            })
        ]
    });
};
$baaeda96f7555c00$var$$7d37db9df1578ff2$export$5c452ff88e35e47d = "WavURG_image", $baaeda96f7555c00$var$$7d37db9df1578ff2$export$30d389775d7a0f3c = "WavURG_medal", $baaeda96f7555c00$var$$7d37db9df1578ff2$export$a8ff84c12d48cfa6 = "WavURG_name", $baaeda96f7555c00$var$$7d37db9df1578ff2$export$896c314ae37c4db9 = "WavURG_rankBox", $baaeda96f7555c00$var$$7d37db9df1578ff2$export$717db1a952ac2d26 = "WavURG_restUsers", $baaeda96f7555c00$var$$7d37db9df1578ff2$export$74fdf2685172213b = "WavURG_suspension", $baaeda96f7555c00$var$$7d37db9df1578ff2$export$fb184b623420d9be = "WavURG_title", $baaeda96f7555c00$var$$7d37db9df1578ff2$export$ec176431609ba4c9 = "WavURG_topUser", $baaeda96f7555c00$var$$7d37db9df1578ff2$export$ea7c3e02973c1d5b = "WavURG_topUsers";
var $baaeda96f7555c00$var$$77dc12b8e0b9d622$var$__rest = function $77dc12b8e0b9d622$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$77dc12b8e0b9d622$export$4ed039229ec81818 = function(e) {
    "use strict";
    function t() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(_$e, "renderMedal", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function value(t) {
                var r, a;
                return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($bce75f99777ea046$export$2e2bcd8739ae039, {
                    as: "li",
                    children: [
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                            className: "shadow-lg overflow-hidden rounded-circle m-auto ".concat($baaeda96f7555c00$var$$7d37db9df1578ff2$export$5c452ff88e35e47d),
                            children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($9f5f1ff841daa39a$export$2e2bcd8739ae039, {
                                src: t.avatar,
                                alt: t.name,
                                loading: "lazy",
                                fluid: !0
                            })
                        }),
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                            className: "position-relative overflow-hidden ".concat($baaeda96f7555c00$var$$7d37db9df1578ff2$export$ec176431609ba4c9),
                            children: [
                                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                                    className: "position-relative",
                                    children: [
                                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("i", {
                                            className: "d-block overflow-hidden m-auto mb-1 rounded-circle"
                                        }),
                                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("a", {
                                            className: "d-block mb-0 stretched-link",
                                            href: (null == (a = (r = _$e.props).linkOf) ? void 0 : a.call(r, t)) || "#",
                                            children: t.name
                                        }),
                                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("strong", {
                                            children: t.score
                                        })
                                    ]
                                }),
                                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($baaeda96f7555c00$var$$c5da9bad1903a67d$export$5f821f795e2d2901, Object.assign({}, t))
                            ]
                        })
                    ]
                }, t.id);
            }
        }), Object.defineProperty(_$e, "renderRow", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function value(t, r, a) {
                var c, n, i = a.length;
                return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("tr", {
                    className: "position-relative",
                    children: [
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("td", {
                            className: "align-middle",
                            children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($b4b154a3007acf25$export$2e2bcd8739ae039, {
                                className: "fw-bold fst-italic",
                                children: (r + 4 + "").padStart((i + "").length, "0")
                            })
                        }),
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("td", {
                            className: "position-relative mw-50 text-truncate ".concat($baaeda96f7555c00$var$$7d37db9df1578ff2$export$a8ff84c12d48cfa6),
                            children: [
                                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                                    className: "d-inline-block overflow-hidden align-middle rounded-circle ".concat($baaeda96f7555c00$var$$7d37db9df1578ff2$export$5c452ff88e35e47d),
                                    children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($9f5f1ff841daa39a$export$2e2bcd8739ae039, {
                                        src: t.avatar,
                                        alt: t.name,
                                        loading: "lazy",
                                        fluid: !0
                                    })
                                }),
                                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("a", {
                                    className: "ms-2 d-inline-block align-middle stretched-link",
                                    style: {
                                        color: "rgb(248, ".concat((r + 2) * 15, ", ").concat((r + 2) * 35, ")")
                                    },
                                    href: (null == (n = (c = _$e.props).linkOf) ? void 0 : n.call(c, t)) || "#",
                                    children: t.name
                                })
                            ]
                        }),
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("td", {
                            className: "align-middle",
                            children: t.score
                        }),
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("td", {
                            className: "align-middle",
                            children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($baaeda96f7555c00$var$$c5da9bad1903a67d$export$5f821f795e2d2901, Object.assign({}, t))
                        })
                    ]
                }, t.id);
            }
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
        {
            key: "render",
            value: function value() {
                var _$e = this.props, _$t = _$e.className, r = _$e.title, a = _$e.rank, c = void 0 === a ? [] : a, n = (_$e.linkOf, $baaeda96f7555c00$var$$77dc12b8e0b9d622$var$__rest(_$e, [
                    "className",
                    "title",
                    "rank",
                    "linkOf"
                ]));
                return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($4a44c352fe7cf693$export$2e2bcd8739ae039, Object.assign({
                    className: "".concat($baaeda96f7555c00$var$$7d37db9df1578ff2$export$896c314ae37c4db9, " ").concat(void 0 === _$t ? "" : _$t)
                }, n, {
                    children: [
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($bce75f99777ea046$export$2e2bcd8739ae039, {
                            sm: 12,
                            xs: 12,
                            lg: 7,
                            children: [
                                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                                    className: "shadow rounded-3 ".concat($baaeda96f7555c00$var$$7d37db9df1578ff2$export$fb184b623420d9be),
                                    children: [
                                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                                            className: $baaeda96f7555c00$var$$7d37db9df1578ff2$export$30d389775d7a0f3c,
                                            children: [
                                                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("i", {
                                                    className: "d-inline-block ms-1 overflow-hidden rounded-circle"
                                                }),
                                                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("i", {
                                                    className: "d-inline-block ms-1 overflow-hidden rounded-circle"
                                                }),
                                                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("i", {
                                                    className: "d-inline-block ms-1 overflow-hidden rounded-circle"
                                                })
                                            ]
                                        }),
                                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("h3", {
                                            "data-text": r,
                                            className: "position-relative m-auto mb-0 fw-bold text-center",
                                            children: r
                                        })
                                    ]
                                }),
                                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($4a44c352fe7cf693$export$2e2bcd8739ae039, {
                                    as: "ul",
                                    className: "mt-2 g-0 align-items-end text-center ps-0 pt-2 list-unstyled ".concat($baaeda96f7555c00$var$$7d37db9df1578ff2$export$ea7c3e02973c1d5b),
                                    children: c.slice(0, 3).map(this.renderMedal)
                                })
                            ]
                        }),
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($bce75f99777ea046$export$2e2bcd8739ae039, {
                            xs: 12,
                            sm: 12,
                            lg: 5,
                            children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($60566ee939038e24$export$2e2bcd8739ae039, {
                                className: "my-3 pt-2 ".concat($baaeda96f7555c00$var$$7d37db9df1578ff2$export$717db1a952ac2d26),
                                responsive: !0,
                                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("tbody", {
                                    children: c.slice(3, 10).map(this.renderRow)
                                })
                            })
                        })
                    ]
                }));
            }
        }
    ]), t;
}($1aLYV.PureComponent);
Object.defineProperty($baaeda96f7555c00$var$$77dc12b8e0b9d622$export$4ed039229ec81818, "displayName", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "UserRankView"
});
var $baaeda96f7555c00$var$$42613c749094b4e3$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$42613c749094b4e3$exports, "VerticalMarquee", function() {
    return $baaeda96f7555c00$var$$42613c749094b4e3$export$125576d08e40b98f;
}), $baaeda96f7555c00$var$$c628d4ba96623bb8$export$1a22ace05a045e3f = "QSMqAq_scrollItem", $baaeda96f7555c00$var$$c628d4ba96623bb8$export$c7aa240077ad8340 = "QSMqAq_scrollWrap";
var $baaeda96f7555c00$var$$42613c749094b4e3$var$__rest = function $42613c749094b4e3$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$42613c749094b4e3$export$125576d08e40b98f = function $42613c749094b4e3$export$125576d08e40b98f(e) {
    var t = e.className, r = e.children, a = e.duration, c = $baaeda96f7555c00$var$$42613c749094b4e3$var$__rest(e, [
        "className",
        "children",
        "duration"
    ]);
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", Object.assign({
        className: "overflow-hidden ".concat(void 0 === t ? "" : t)
    }, c, {
        children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
            className: "d-inline-block mw-100 mh-100 ".concat($baaeda96f7555c00$var$$c628d4ba96623bb8$export$c7aa240077ad8340),
            style: {
                "--duration": a
            },
            children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                className: "d-inline-block ".concat($baaeda96f7555c00$var$$c628d4ba96623bb8$export$1a22ace05a045e3f),
                children: r
            })
        })
    }));
};
$baaeda96f7555c00$var$$42613c749094b4e3$export$125576d08e40b98f.displayName = "VerticalMarquee";
var $baaeda96f7555c00$var$$228d0ac8aef325ed$exports = {};
$baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$228d0ac8aef325ed$exports, "ZodiacSigns", function() {
    return $baaeda96f7555c00$var$$228d0ac8aef325ed$export$c0efdd35897a499c;
}), $baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$228d0ac8aef325ed$exports, "zodiacOf", function() {
    return $baaeda96f7555c00$var$$228d0ac8aef325ed$export$1ace452aebce17cb;
}), $baaeda96f7555c00$var$$parcel$export($baaeda96f7555c00$var$$228d0ac8aef325ed$exports, "ZodiacBar", function() {
    return $baaeda96f7555c00$var$$228d0ac8aef325ed$export$de26cde43ba4c348;
});
var $baaeda96f7555c00$var$$228d0ac8aef325ed$var$__rest = function $228d0ac8aef325ed$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $baaeda96f7555c00$var$$228d0ac8aef325ed$export$c0efdd35897a499c = [
    "\uD83D\uDC35",
    "\uD83D\uDC14",
    "\uD83D\uDC36",
    "\uD83D\uDC37",
    "\uD83D\uDC2D",
    "\uD83D\uDC2E",
    "\uD83D\uDC2F",
    "\uD83D\uDC30",
    "\uD83D\uDC32",
    "\uD83D\uDC0D",
    "\uD83D\uDC34",
    "\uD83D\uDC10"
], $baaeda96f7555c00$var$$228d0ac8aef325ed$export$1ace452aebce17cb = function $228d0ac8aef325ed$export$1ace452aebce17cb(e) {
    return $baaeda96f7555c00$var$$228d0ac8aef325ed$export$c0efdd35897a499c[((e < 0 ? e + 1 : e) % 12 + 12) % 12];
}, $baaeda96f7555c00$var$$228d0ac8aef325ed$export$de26cde43ba4c348 = function $228d0ac8aef325ed$export$de26cde43ba4c348(e) {
    var t = e.className, r = e.itemClassName, a = void 0 === r ? "border rounded px-4 py-3 d-flex flex-column justify-content-center align-items-center" : r, c = e.startYear, n = e.endYear, i = void 0 === n ? new Date().getFullYear() : n, o = e.itemOf, s = $baaeda96f7555c00$var$$228d0ac8aef325ed$var$__rest(e, [
        "className",
        "itemClassName",
        "startYear",
        "endYear",
        "itemOf"
    ]);
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("ol", Object.assign({
        className: "list-unstyled m-0 d-flex flex-wrap justify-content-center gap-3 ".concat(void 0 === t ? "" : t)
    }, s, {
        children: Array.from({
            length: i - c + 1
        }, function(e, t) {
            var r = i - t;
            if (0 === r) return null;
            var c = $baaeda96f7555c00$var$$228d0ac8aef325ed$export$1ace452aebce17cb(r), n = (null == o ? void 0 : o(r, c)) || {}, s = n.link, l = n.title;
            return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("li", {
                className: a,
                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("a", {
                    className: "d-inline-block p-3 text-decoration-none text-center",
                    href: void 0 === s ? "#" : s,
                    children: [
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                            className: "fs-1",
                            children: c
                        }),
                        l
                    ]
                })
            }, r);
        })
    }));
};
$baaeda96f7555c00$var$$228d0ac8aef325ed$export$de26cde43ba4c348.displayName = "ZodiacBar", $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$fd019656019bb4f3$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$757747c0209676cc$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$a40a1c3d6dc84a7a$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$89fa9a64cf869995$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$924d73683971f901$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$9dab2fd0b4033192$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$e308f4ff6755d29b$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$68aab1d0e8e5016c$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$db3d9d99c159855a$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$e400f030e8cea549$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$cf5cdc2ffed4bc45$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$44176234dcaa70a7$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$1f7252b8d0187295$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$ec6e3ccd45c7b7c0$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$4f69bf8d62d4bac9$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$a121893c5bead7fc$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$d78fd73e1713e936$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$ce59ae9613bac5f2$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$5d0c8d8af5c3c7e5$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$5c7497f9f3fe6432$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$ad4a2cea628613d5$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$53fa7c21606566cb$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$295b3641db3d8c33$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$03c0468daff9422a$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$2f5f9093a9aac8ee$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$31b55198d5058ded$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$27e13b1ac3fbb57c$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$f4c02b33c4295ca8$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$77dc12b8e0b9d622$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$42613c749094b4e3$exports), $baaeda96f7555c00$var$$parcel$exportWildcard($baaeda96f7555c00$exports, $baaeda96f7555c00$var$$228d0ac8aef325ed$exports); //# sourceMappingURL=index.js.map




var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $aUGqu = parcelRequire("aUGqu");


var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");


"use client";
var $292dfe981fa51abb$var$NavbarBrand = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, as = _param.as, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'navbar-brand');
    var Component = as || (props.href ? 'a' : 'span');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }));
});
$292dfe981fa51abb$var$NavbarBrand.displayName = 'NavbarBrand';
var $292dfe981fa51abb$export$2e2bcd8739ae039 = $292dfe981fa51abb$var$NavbarBrand;



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

var $7Pjls = parcelRequire("7Pjls");

var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");



var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");



/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $5a36515008381a50$var$createChainedFunction() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++){
        funcs[_key] = arguments[_key];
    }
    return funcs.filter(function(f) {
        return f != null;
    }).reduce(function(acc, f) {
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            // @ts-expect-error ignore "this" error
            acc.apply(this, args);
            // @ts-expect-error ignore "this" error
            f.apply(this, args);
        };
    }, null);
}
var $5a36515008381a50$export$2e2bcd8739ae039 = $5a36515008381a50$var$createChainedFunction;





var $aa537a27487a82d2$var$MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function $aa537a27487a82d2$var$getDefaultDimensionValue(dimension, elem) {
    var offset = "offset".concat(dimension[0].toUpperCase()).concat(dimension.slice(1));
    var value = elem[offset];
    var margins = $aa537a27487a82d2$var$MARGINS[dimension];
    return value + // @ts-expect-error TODO
    parseInt((0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-expect-error TODO
    parseInt((0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
var $aa537a27487a82d2$var$_obj;
var $aa537a27487a82d2$var$collapseStyles = ($aa537a27487a82d2$var$_obj = {}, (0, $7Pjls._)($aa537a27487a82d2$var$_obj, (0, $496c06162fdc2120$export$84cbff306f539230), 'collapse'), (0, $7Pjls._)($aa537a27487a82d2$var$_obj, (0, $496c06162fdc2120$export$4aacc83d4d59139f), 'collapsing'), (0, $7Pjls._)($aa537a27487a82d2$var$_obj, (0, $496c06162fdc2120$export$df38205c966be359), 'collapsing'), (0, $7Pjls._)($aa537a27487a82d2$var$_obj, (0, $496c06162fdc2120$export$78e9e6e3e014d60a), 'collapse show'), $aa537a27487a82d2$var$_obj);
var $aa537a27487a82d2$var$Collapse = /*#__PURE__*/ (0, $1aLYV.default).forwardRef(function(_param, ref) {
    var onEnter = _param.onEnter, onEntering = _param.onEntering, onEntered = _param.onEntered, onExit = _param.onExit, onExiting = _param.onExiting, className = _param.className, children = _param.children, _param_dimension = _param.dimension, dimension = _param_dimension === void 0 ? 'height' : _param_dimension, tmp = _param.in, inProp = tmp === void 0 ? false : tmp, _param_timeout = _param.timeout, timeout = _param_timeout === void 0 ? 300 : _param_timeout, _param_mountOnEnter = _param.mountOnEnter, mountOnEnter = _param_mountOnEnter === void 0 ? false : _param_mountOnEnter, _param_unmountOnExit = _param.unmountOnExit, unmountOnExit = _param_unmountOnExit === void 0 ? false : _param_unmountOnExit, _param_appear = _param.appear, appear = _param_appear === void 0 ? false : _param_appear, _param_getDimensionValue = _param.getDimensionValue, getDimensionValue = _param_getDimensionValue === void 0 ? $aa537a27487a82d2$var$getDefaultDimensionValue : _param_getDimensionValue, props = (0, $6acIq._)(_param, [
        "onEnter",
        "onEntering",
        "onEntered",
        "onExit",
        "onExiting",
        "className",
        "children",
        "dimension",
        "in",
        "timeout",
        "mountOnEnter",
        "unmountOnExit",
        "appear",
        "getDimensionValue"
    ]);
    /* Compute dimension */ var computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ var handleEnter = (0, $lliNT.useMemo)(function() {
        return (0, $5a36515008381a50$export$2e2bcd8739ae039)(function(elem) {
            elem.style[computedDimension] = '0';
        }, onEnter);
    }, [
        computedDimension,
        onEnter
    ]);
    var handleEntering = (0, $lliNT.useMemo)(function() {
        return (0, $5a36515008381a50$export$2e2bcd8739ae039)(function(elem) {
            var scroll = "scroll".concat(computedDimension[0].toUpperCase()).concat(computedDimension.slice(1));
            elem.style[computedDimension] = "".concat(elem[scroll], "px");
        }, onEntering);
    }, [
        computedDimension,
        onEntering
    ]);
    var handleEntered = (0, $lliNT.useMemo)(function() {
        return (0, $5a36515008381a50$export$2e2bcd8739ae039)(function(elem) {
            elem.style[computedDimension] = null;
        }, onEntered);
    }, [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ var handleExit = (0, $lliNT.useMemo)(function() {
        return (0, $5a36515008381a50$export$2e2bcd8739ae039)(function(elem) {
            elem.style[computedDimension] = "".concat(getDimensionValue(computedDimension, elem), "px");
            (0, $5a6c417d2453080d$export$2e2bcd8739ae039)(elem);
        }, onExit);
    }, [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    var handleExiting = (0, $lliNT.useMemo)(function() {
        return (0, $5a36515008381a50$export$2e2bcd8739ae039)(function(elem) {
            elem.style[computedDimension] = null;
        }, onExiting);
    }, [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $9f13533ca2686d6e$export$2e2bcd8739ae039), (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref,
        addEndListener: (0, $d73a16aa7200b8d9$export$2e2bcd8739ae039)
    }, props), {
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: (0, $71a632d108d6b21a$export$87943f2672146d57)(children),
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: function(state, innerProps) {
            return /*#__PURE__*/ (0, $1aLYV.default).cloneElement(children, (0, $6fpqi._)((0, $1XAnY._)({}, innerProps), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, children.props.className, $aa537a27487a82d2$var$collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            }));
        }
    }));
});
$aa537a27487a82d2$var$Collapse.displayName = 'Collapse';
var $aa537a27487a82d2$export$2e2bcd8739ae039 = $aa537a27487a82d2$var$Collapse;





"use client";
var $a5beff96d32f35c7$var$NavbarCollapse = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var children = _param.children, bsPrefix = _param.bsPrefix, props = (0, $6acIq._)(_param, [
        "children",
        "bsPrefix"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'navbar-collapse');
    var context = (0, $lliNT.useContext)((0, $8dda86df8b6e7572$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $aa537a27487a82d2$export$2e2bcd8739ae039), (0, $6fpqi._)((0, $1XAnY._)({
        in: !!(context && context.expanded)
    }, props), {
        children: /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    }));
});
$a5beff96d32f35c7$var$NavbarCollapse.displayName = 'NavbarCollapse';
var $a5beff96d32f35c7$export$2e2bcd8739ae039 = $a5beff96d32f35c7$var$NavbarCollapse;



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");




"use client";
var $dde15d8ee5e39768$var$NavbarToggle = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, children = _param.children, _param_label = _param.label, label = _param_label === void 0 ? 'Toggle navigation' : _param_label, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'button' : tmp, onClick = _param.onClick, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "children",
        "label",
        "as",
        "onClick"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'navbar-toggler');
    var _ref = (0, $lliNT.useContext)((0, $8dda86df8b6e7572$export$2e2bcd8739ae039)) || {}, onToggle = _ref.onToggle, expanded = _ref.expanded;
    var handleClick = (0, $ddf2f427ad010346$export$2e2bcd8739ae039)(function(e) {
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({}, props), {
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, !expanded && 'collapsed'),
        children: children || /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("span", {
            className: "".concat(bsPrefix, "-icon")
        })
    }));
});
$dde15d8ee5e39768$var$NavbarToggle.displayName = 'NavbarToggle';
var $dde15d8ee5e39768$export$2e2bcd8739ae039 = $dde15d8ee5e39768$var$NavbarToggle;



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");


var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");


var $7Pjls = parcelRequire("7Pjls");

var $f9AOD = parcelRequire("f9AOD");

var $7E0eS = parcelRequire("7E0eS");

var $f9AOD = parcelRequire("f9AOD");

parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
var $b515bb929cf930e6$var$matchersByWindow = new WeakMap();
var $b515bb929cf930e6$var$getMatcher = function(query, targetWindow) {
    if (!query || !targetWindow) return undefined;
    var matchers = $b515bb929cf930e6$var$matchersByWindow.get(targetWindow) || new Map();
    $b515bb929cf930e6$var$matchersByWindow.set(targetWindow, matchers);
    var mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $b515bb929cf930e6$export$2e2bcd8739ae039(query) {
    var targetWindow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : typeof window === 'undefined' ? undefined : window;
    var mql = $b515bb929cf930e6$var$getMatcher(query, targetWindow);
    var _useState = (0, $f9AOD._)((0, $lliNT.useState)(function() {
        return mql ? mql.matches : false;
    }), 2), matches = _useState[0], setMatches = _useState[1];
    (0, $81a7cd9979579e44$export$2e2bcd8739ae039)(function() {
        var mql = $b515bb929cf930e6$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        var matchers = $b515bb929cf930e6$var$matchersByWindow.get(targetWindow);
        var handleChange = function() {
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return function() {
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}


parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
function $b2f0c550ef75af04$export$9c6950edc251641e(breakpointValues) {
    var names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? "".concat(query, " and ").concat(next) : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        var next = getNext(breakpoint);
        var value = breakpointValues[next];
        if (typeof value === 'number') value = "".concat(value - 0.2, "px");
        else value = "calc(".concat(value, " - 0.2px)");
        return "(max-width: ".concat(value, ")");
    }
    function getMinQuery(breakpoint) {
        var value = breakpointValues[breakpoint];
        if (typeof value === 'number') value = "".concat(value, "px");
        return "(min-width: ".concat(value, ")");
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        var breakpointMap;
        if ((typeof breakpointOrMap === "undefined" ? "undefined" : (0, $7E0eS._)(breakpointOrMap)) === 'object') {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = (0, $7Pjls._)({}, breakpointOrMap, direction);
        }
        var query = (0, $lliNT.useMemo)(function() {
            return Object.entries(breakpointMap).reduce(function(query, param) {
                var _param = (0, $f9AOD._)(param, 2), key = _param[0], _$direction = _param[1];
                if (_$direction === 'up' || _$direction === true) query = and(query, getMinQuery(key));
                if (_$direction === 'down' || _$direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, '');
        }, [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $b515bb929cf930e6$export$2e2bcd8739ae039)(query, window);
    }
    return useBreakpoint;
}
var $b2f0c550ef75af04$var$useBreakpoint = $b2f0c550ef75af04$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $b2f0c550ef75af04$export$2e2bcd8739ae039 = $b2f0c550ef75af04$var$useBreakpoint;




var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

function $607d6e14baa19d0a$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $cb03b130654deaba$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}






var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

var $1aLYV = parcelRequire("1aLYV");

parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
function $6c19340e24a81bb3$export$2e2bcd8739ae039(value) {
    var valueRef = (0, $lliNT.useRef)(value);
    valueRef.current = value;
    return valueRef;
}


parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
function $91786060091dbd53$export$2e2bcd8739ae039(fn) {
    var onUnmount = (0, $6c19340e24a81bb3$export$2e2bcd8739ae039)(fn);
    (0, $lliNT.useEffect)(function() {
        return function() {
            return onUnmount.current();
        };
    }, []);
}





var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7Pjls = parcelRequire("7Pjls");

var $aUGqu = parcelRequire("aUGqu");


/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $dde4952c13e727dd$export$2e2bcd8739ae039() {
    var ownerDocument = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    var window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


var $954562d66e9dba2b$export$1a88c12b8b979fa0 = (0, $188ebaeb1748f756$export$5cc3b7b83e34ade7)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ var $954562d66e9dba2b$var$ModalManager = /*#__PURE__*/ function() {
    "use strict";
    function ModalManager() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ownerDocument = _ref.ownerDocument, _ref_handleContainerOverflow = _ref.handleContainerOverflow, handleContainerOverflow = _ref_handleContainerOverflow === void 0 ? true : _ref_handleContainerOverflow, _ref_isRTL = _ref.isRTL, isRTL = _ref_isRTL === void 0 ? false : _ref_isRTL;
        (0, $173N4._)(this, ModalManager);
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    (0, $cFHGC._)(ModalManager, [
        {
            key: "getScrollbarWidth",
            value: function getScrollbarWidth() {
                return (0, $dde4952c13e727dd$export$2e2bcd8739ae039)(this.ownerDocument);
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return (this.ownerDocument || document).body;
            }
        },
        {
            key: "setModalAttributes",
            value: function setModalAttributes(_modal) {
            // For overriding
            }
        },
        {
            key: "removeModalAttributes",
            value: function removeModalAttributes(_modal) {
            // For overriding
            }
        },
        {
            key: "setContainerStyle",
            value: function setContainerStyle(containerState) {
                var style = {
                    overflow: 'hidden'
                };
                // we are only interested in the actual `style` here
                // because we will override it
                var paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
                var container = this.getElement();
                containerState.style = (0, $7Pjls._)({
                    overflow: container.style.overflow
                }, paddingProp, container.style[paddingProp]);
                if (containerState.scrollBarWidth) // use computed style, here to get the real padding
                // to add our scrollbar width
                style[paddingProp] = "".concat(parseInt((0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth, "px");
                container.setAttribute($954562d66e9dba2b$export$1a88c12b8b979fa0, '');
                (0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(container, style);
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                (0, $aUGqu._)(this.modals).forEach(function(m) {
                    return _this.remove(m);
                });
            }
        },
        {
            key: "removeContainerStyle",
            value: function removeContainerStyle(containerState) {
                var container = this.getElement();
                container.removeAttribute($954562d66e9dba2b$export$1a88c12b8b979fa0);
                Object.assign(container.style, containerState.style);
            }
        },
        {
            key: "add",
            value: function add(modal) {
                var modalIdx = this.modals.indexOf(modal);
                if (modalIdx !== -1) return modalIdx;
                modalIdx = this.modals.length;
                this.modals.push(modal);
                this.setModalAttributes(modal);
                if (modalIdx !== 0) return modalIdx;
                this.state = {
                    scrollBarWidth: this.getScrollbarWidth(),
                    style: {}
                };
                if (this.handleContainerOverflow) this.setContainerStyle(this.state);
                return modalIdx;
            }
        },
        {
            key: "remove",
            value: function remove(modal) {
                var modalIdx = this.modals.indexOf(modal);
                if (modalIdx === -1) return;
                this.modals.splice(modalIdx, 1);
                // if that was the last modal in a container,
                // clean up the container
                if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
                this.removeModalAttributes(modal);
            }
        },
        {
            key: "isTopModal",
            value: function isTopModal(modal) {
                return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
            }
        }
    ]);
    return ModalManager;
}();
var $954562d66e9dba2b$export$2e2bcd8739ae039 = $954562d66e9dba2b$var$ModalManager;







var $tLNoZ = parcelRequire("tLNoZ");
var $05de7f34de43cf4e$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $05de7f34de43cf4e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
var $05de7f34de43cf4e$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $05de7f34de43cf4e$var$getManager(window) {
    if (!$05de7f34de43cf4e$var$manager) $05de7f34de43cf4e$var$manager = new (0, $954562d66e9dba2b$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $05de7f34de43cf4e$var$manager;
}
function $05de7f34de43cf4e$var$useModalManager(provided) {
    var window = (0, $079709aedd6d46b7$export$2e2bcd8739ae039)();
    var modalManager = provided || $05de7f34de43cf4e$var$getManager(window);
    var modal = (0, $lliNT.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: function() {
            return modalManager.add(modal.current);
        },
        remove: function() {
            return modalManager.remove(modal.current);
        },
        isTopModal: function() {
            return modalManager.isTopModal(modal.current);
        },
        setDialogRef: (0, $lliNT.useCallback)(function(ref) {
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $lliNT.useCallback)(function(ref) {
            modal.current.backdrop = ref;
        }, [])
    });
}
var $05de7f34de43cf4e$var$Modal = /*#__PURE__*/ (0, $1aLYV.forwardRef)(function(_ref, ref) {
    var _ref_show = _ref.show, show = _ref_show === void 0 ? false : _ref_show, _ref_role = _ref.role, role = _ref_role === void 0 ? 'dialog' : _ref_role, className = _ref.className, style = _ref.style, children = _ref.children, _ref_backdrop = _ref.backdrop, backdrop = _ref_backdrop === void 0 ? true : _ref_backdrop, _ref_keyboard = _ref.keyboard, keyboard = _ref_keyboard === void 0 ? true : _ref_keyboard, onBackdropClick = _ref.onBackdropClick, onEscapeKeyDown = _ref.onEscapeKeyDown, transition = _ref.transition, runTransition = _ref.runTransition, backdropTransition = _ref.backdropTransition, runBackdropTransition = _ref.runBackdropTransition, _ref_autoFocus = _ref.autoFocus, autoFocus = _ref_autoFocus === void 0 ? true : _ref_autoFocus, _ref_enforceFocus = _ref.enforceFocus, enforceFocus = _ref_enforceFocus === void 0 ? true : _ref_enforceFocus, _ref_restoreFocus = _ref.restoreFocus, restoreFocus = _ref_restoreFocus === void 0 ? true : _ref_restoreFocus, restoreFocusOptions = _ref.restoreFocusOptions, renderDialog = _ref.renderDialog, _ref_renderBackdrop = _ref.renderBackdrop, renderBackdrop = _ref_renderBackdrop === void 0 ? function(props) {
        return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", Object.assign({}, props));
    } : _ref_renderBackdrop, providedManager = _ref.manager, containerRef = _ref.container, onShow = _ref.onShow, _ref_onHide = _ref.onHide, onHide = _ref_onHide === void 0 ? function() {} : _ref_onHide, onExit = _ref.onExit, onExited = _ref.onExited, onExiting = _ref.onExiting, onEnter = _ref.onEnter, onEntering = _ref.onEntering, onEntered = _ref.onEntered, rest = $05de7f34de43cf4e$var$_objectWithoutPropertiesLoose(_ref, $05de7f34de43cf4e$var$_excluded);
    var ownerWindow = (0, $079709aedd6d46b7$export$2e2bcd8739ae039)();
    var container = (0, $3e4e7ed48ef00c3f$export$2e2bcd8739ae039)(containerRef);
    var modal = $05de7f34de43cf4e$var$useModalManager(providedManager);
    var isMounted = (0, $1b54fe6f859435c1$export$2e2bcd8739ae039)();
    var prevShow = (0, $26d665efc2403b23$export$2e2bcd8739ae039)(show);
    var _useState = (0, $f9AOD._)((0, $lliNT.useState)(!show), 2), exited = _useState[0], setExited = _useState[1];
    var lastFocusRef = (0, $lliNT.useRef)(null);
    (0, $lliNT.useImperativeHandle)(ref, function() {
        return modal;
    }, [
        modal
    ]);
    if ((0, $64f258eaaf92e603$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $607d6e14baa19d0a$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    var handleShow = (0, $5ec89db9ae56f810$export$2e2bcd8739ae039)(function() {
        modal.add();
        removeKeydownListenerRef.current = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        function() {
            return setTimeout(handleEnforceFocus);
        }, true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            var currentActiveElement = (0, $607d6e14baa19d0a$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $a784322fcbc350d7$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    var handleHide = (0, $5ec89db9ae56f810$export$2e2bcd8739ae039)(function() {
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $lliNT.useEffect)(function() {
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $lliNT.useEffect)(function() {
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $91786060091dbd53$export$2e2bcd8739ae039)(function() {
        handleHide();
    });
    // --------------------------------
    var handleEnforceFocus = (0, $5ec89db9ae56f810$export$2e2bcd8739ae039)(function() {
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        var currentActiveElement = (0, $607d6e14baa19d0a$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $a784322fcbc350d7$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    var handleBackdropClick = (0, $5ec89db9ae56f810$export$2e2bcd8739ae039)(function(e) {
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    var handleDocumentKeyDown = (0, $5ec89db9ae56f810$export$2e2bcd8739ae039)(function(e) {
        if (keyboard && (0, $71a632d108d6b21a$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    var removeFocusListenerRef = (0, $lliNT.useRef)();
    var removeKeydownListenerRef = (0, $lliNT.useRef)();
    var handleHidden = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        setExited(true);
        onExited == null || onExited.apply(void 0, (0, $aUGqu._)(args));
    };
    if (!container) return null;
    var dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    var dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $1aLYV.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, $1087e75f6d43f4d5$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    var backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $1087e75f6d43f4d5$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $tLNoZ.Fragment), {
        children: /*#__PURE__*/ (0, $1aLYV.default).createPortal(/*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $tLNoZ.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$05de7f34de43cf4e$var$Modal.displayName = 'Modal';
var $05de7f34de43cf4e$export$2e2bcd8739ae039 = Object.assign($05de7f34de43cf4e$var$Modal, {
    Manager: (0, $954562d66e9dba2b$export$2e2bcd8739ae039)
});




var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");



"use client";
var $341aa7ec18df675d$var$OffcanvasBody = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-body');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$341aa7ec18df675d$var$OffcanvasBody.displayName = 'OffcanvasBody';
var $341aa7ec18df675d$export$2e2bcd8739ae039 = $341aa7ec18df675d$var$OffcanvasBody;



var $7Pjls = parcelRequire("7Pjls");

var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");






"use client";
var $3b99042f0952ae6e$var$_obj;
var $3b99042f0952ae6e$var$transitionStyles = ($3b99042f0952ae6e$var$_obj = {}, (0, $7Pjls._)($3b99042f0952ae6e$var$_obj, (0, $496c06162fdc2120$export$df38205c966be359), 'show'), (0, $7Pjls._)($3b99042f0952ae6e$var$_obj, (0, $496c06162fdc2120$export$78e9e6e3e014d60a), 'show'), $3b99042f0952ae6e$var$_obj);
var $3b99042f0952ae6e$var$OffcanvasToggling = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, children = _param.children, tmp = _param.in, inProp = tmp === void 0 ? false : tmp, _param_mountOnEnter = _param.mountOnEnter, mountOnEnter = _param_mountOnEnter === void 0 ? false : _param_mountOnEnter, _param_unmountOnExit = _param.unmountOnExit, unmountOnExit = _param_unmountOnExit === void 0 ? false : _param_unmountOnExit, _param_appear = _param.appear, appear = _param_appear === void 0 ? false : _param_appear, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "children",
        "in",
        "mountOnEnter",
        "unmountOnExit",
        "appear"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $9f13533ca2686d6e$export$2e2bcd8739ae039), (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref,
        addEndListener: (0, $d73a16aa7200b8d9$export$2e2bcd8739ae039),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear
    }, props), {
        childRef: (0, $71a632d108d6b21a$export$87943f2672146d57)(children),
        children: function(status, innerProps) {
            return /*#__PURE__*/ $1aLYV.cloneElement(children, (0, $6fpqi._)((0, $1XAnY._)({}, innerProps), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, children.props.className, (status === (0, $496c06162fdc2120$export$df38205c966be359) || status === (0, $496c06162fdc2120$export$4aacc83d4d59139f)) && "".concat(bsPrefix, "-toggling"), $3b99042f0952ae6e$var$transitionStyles[status])
            }));
        }
    }));
});
$3b99042f0952ae6e$var$OffcanvasToggling.displayName = 'OffcanvasToggling';
var $3b99042f0952ae6e$export$2e2bcd8739ae039 = $3b99042f0952ae6e$var$OffcanvasToggling;


parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");
"use client";
var $1a48f96a46bf373a$var$ModalContext = /*#__PURE__*/ $tLNoZ.createContext({
    onHide: function() {}
});
var $1a48f96a46bf373a$export$2e2bcd8739ae039 = $1a48f96a46bf373a$var$ModalContext;



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");


var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");




"use client";
var $c361ae1a26c65942$var$AbstractModalHeader = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var _param_closeLabel = _param.closeLabel, closeLabel = _param_closeLabel === void 0 ? 'Close' : _param_closeLabel, closeVariant = _param.closeVariant, _param_closeButton = _param.closeButton, closeButton = _param_closeButton === void 0 ? false : _param_closeButton, onHide = _param.onHide, children = _param.children, props = (0, $6acIq._)(_param, [
        "closeLabel",
        "closeVariant",
        "closeButton",
        "onHide",
        "children"
    ]);
    var context = (0, $lliNT.useContext)((0, $1a48f96a46bf373a$export$2e2bcd8739ae039));
    var handleClick = (0, $ddf2f427ad010346$export$2e2bcd8739ae039)(function() {
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref
    }, props), {
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $69561b249377d853$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    }));
});
$c361ae1a26c65942$var$AbstractModalHeader.displayName = 'AbstractModalHeader';
var $c361ae1a26c65942$export$2e2bcd8739ae039 = $c361ae1a26c65942$var$AbstractModalHeader;



"use client";
var $718153435787edc0$var$OffcanvasHeader = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, _param_closeLabel = _param.closeLabel, closeLabel = _param_closeLabel === void 0 ? 'Close' : _param_closeLabel, _param_closeButton = _param.closeButton, closeButton = _param_closeButton === void 0 ? false : _param_closeButton, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "closeLabel",
        "closeButton"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-header');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $c361ae1a26c65942$export$2e2bcd8739ae039), (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    }));
});
$718153435787edc0$var$OffcanvasHeader.displayName = 'OffcanvasHeader';
var $718153435787edc0$export$2e2bcd8739ae039 = $718153435787edc0$var$OffcanvasHeader;



var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");




"use client";
var $ae1139f5266dd39b$var$DivStyledAsH5 = (0, $2dc371b22567e8b5$export$2e2bcd8739ae039)('h5');
var $ae1139f5266dd39b$var$OffcanvasTitle = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? $ae1139f5266dd39b$var$DivStyledAsH5 : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-title');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$ae1139f5266dd39b$var$OffcanvasTitle.displayName = 'OffcanvasTitle';
var $ae1139f5266dd39b$export$2e2bcd8739ae039 = $ae1139f5266dd39b$var$OffcanvasTitle;




var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7Pjls = parcelRequire("7Pjls");

var $dWsrg = parcelRequire("dWsrg");

var $kg0zo = parcelRequire("kg0zo");

var $hdIku = parcelRequire("hdIku");

function $238a4fd6ca67df0c$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $00f98d1dc049abf7$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}




function $62f26c8f9df85416$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $62f26c8f9df85416$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $62f26c8f9df85416$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $62f26c8f9df85416$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



var $26887413ddd3bac4$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
var $26887413ddd3bac4$var$BootstrapModalManager = /*#__PURE__*/ function(ModalManager) {
    "use strict";
    (0, $hdIku._)(BootstrapModalManager, ModalManager);
    function BootstrapModalManager() {
        (0, $173N4._)(this, BootstrapModalManager);
        return (0, $7qXGD._)(this, BootstrapModalManager, arguments);
    }
    (0, $cFHGC._)(BootstrapModalManager, [
        {
            key: "adjustAndStore",
            value: function adjustAndStore(prop, element, adjust) {
                var actual = element.style[prop];
                // @ts-expect-error TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
                element.dataset[prop] = actual;
                (0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(element, (0, $7Pjls._)({}, prop, "".concat(parseFloat((0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(element, prop)) + adjust, "px")));
            }
        },
        {
            key: "restore",
            value: function restore(prop, element) {
                var value = element.dataset[prop];
                if (value !== undefined) {
                    delete element.dataset[prop];
                    (0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(element, (0, $7Pjls._)({}, prop, value));
                }
            }
        },
        {
            key: "setContainerStyle",
            value: function setContainerStyle(containerState) {
                var _this = this;
                (0, $dWsrg._)((0, $kg0zo._)(BootstrapModalManager.prototype), "setContainerStyle", this).call(this, containerState);
                var container = this.getElement();
                (0, $238a4fd6ca67df0c$export$2e2bcd8739ae039)(container, 'modal-open');
                if (!containerState.scrollBarWidth) return;
                var paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
                var marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
                (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(container, $26887413ddd3bac4$var$Selector.FIXED_CONTENT).forEach(function(el) {
                    return _this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth);
                });
                (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(container, $26887413ddd3bac4$var$Selector.STICKY_CONTENT).forEach(function(el) {
                    return _this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth);
                });
                (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(container, $26887413ddd3bac4$var$Selector.NAVBAR_TOGGLER).forEach(function(el) {
                    return _this.adjustAndStore(marginProp, el, containerState.scrollBarWidth);
                });
            }
        },
        {
            key: "removeContainerStyle",
            value: function removeContainerStyle(containerState) {
                var _this = this;
                (0, $dWsrg._)((0, $kg0zo._)(BootstrapModalManager.prototype), "removeContainerStyle", this).call(this, containerState);
                var container = this.getElement();
                (0, $62f26c8f9df85416$export$2e2bcd8739ae039)(container, 'modal-open');
                var paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
                var marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
                (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(container, $26887413ddd3bac4$var$Selector.FIXED_CONTENT).forEach(function(el) {
                    return _this.restore(paddingProp, el);
                });
                (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(container, $26887413ddd3bac4$var$Selector.STICKY_CONTENT).forEach(function(el) {
                    return _this.restore(marginProp, el);
                });
                (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(container, $26887413ddd3bac4$var$Selector.NAVBAR_TOGGLER).forEach(function(el) {
                    return _this.restore(marginProp, el);
                });
            }
        }
    ]);
    return BootstrapModalManager;
}((0, $954562d66e9dba2b$export$2e2bcd8739ae039));
var $26887413ddd3bac4$var$sharedManager;
function $26887413ddd3bac4$export$a03641438014b436(options) {
    if (!$26887413ddd3bac4$var$sharedManager) $26887413ddd3bac4$var$sharedManager = new $26887413ddd3bac4$var$BootstrapModalManager(options);
    return $26887413ddd3bac4$var$sharedManager;
}
var $26887413ddd3bac4$export$2e2bcd8739ae039 = $26887413ddd3bac4$var$BootstrapModalManager;



var $tLNoZ = parcelRequire("tLNoZ");
"use client";
function $ceb4801f56d927a4$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $3b99042f0952ae6e$export$2e2bcd8739ae039), (0, $1XAnY._)({}, props));
}
function $ceb4801f56d927a4$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $fad1b22621dd9d86$export$2e2bcd8739ae039), (0, $1XAnY._)({}, props));
}
var $ceb4801f56d927a4$var$Offcanvas = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, children = _param.children, ariaLabelledby = _param['aria-labelledby'], _param_placement = _param.placement, placement = _param_placement === void 0 ? 'start' : _param_placement, responsive = _param.responsive, _param_show = _param./* BaseModal props */ show, show = _param_show === void 0 ? false : _param_show, _param_backdrop = _param.backdrop, backdrop = _param_backdrop === void 0 ? true : _param_backdrop, _param_keyboard = _param.keyboard, keyboard = _param_keyboard === void 0 ? true : _param_keyboard, _param_scroll = _param.scroll, scroll = _param_scroll === void 0 ? false : _param_scroll, onEscapeKeyDown = _param.onEscapeKeyDown, onShow = _param.onShow, onHide = _param.onHide, container = _param.container, _param_autoFocus = _param.autoFocus, autoFocus = _param_autoFocus === void 0 ? true : _param_autoFocus, _param_enforceFocus = _param.enforceFocus, enforceFocus = _param_enforceFocus === void 0 ? true : _param_enforceFocus, _param_restoreFocus = _param.restoreFocus, restoreFocus = _param_restoreFocus === void 0 ? true : _param_restoreFocus, restoreFocusOptions = _param.restoreFocusOptions, onEntered = _param.onEntered, onExit = _param.onExit, onExiting = _param.onExiting, onEnter = _param.onEnter, onEntering = _param.onEntering, onExited = _param.onExited, backdropClassName = _param.backdropClassName, propsManager = _param.manager, _param_renderStaticNode = _param.renderStaticNode, renderStaticNode = _param_renderStaticNode === void 0 ? false : _param_renderStaticNode, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "children",
        'aria-labelledby',
        "placement",
        "responsive",
        "show",
        "backdrop",
        "keyboard",
        "scroll",
        "onEscapeKeyDown",
        "onShow",
        "onHide",
        "container",
        "autoFocus",
        "enforceFocus",
        "restoreFocus",
        "restoreFocusOptions",
        "onEntered",
        "onExit",
        "onExiting",
        "onEnter",
        "onEntering",
        "onExited",
        "backdropClassName",
        "manager",
        "renderStaticNode"
    ]);
    var modalManager = (0, $lliNT.useRef)();
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    var _useState = (0, $f9AOD._)((0, $lliNT.useState)(false), 2), showOffcanvas = _useState[0], setShowOffcanvas = _useState[1];
    var handleHide = (0, $ddf2f427ad010346$export$2e2bcd8739ae039)(onHide);
    var hideResponsiveOffcanvas = (0, $b2f0c550ef75af04$export$2e2bcd8739ae039)(responsive || 'xs', 'up');
    (0, $lliNT.useEffect)(function() {
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    var modalContext = (0, $lliNT.useMemo)(function() {
        return {
            onHide: handleHide
        };
    }, [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $26887413ddd3bac4$export$2e2bcd8739ae039)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $26887413ddd3bac4$export$a03641438014b436)();
    }
    var handleEnter = function(node) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        if (node) node.style.visibility = 'visible';
        onEnter == null || onEnter.apply(void 0, [
            node
        ].concat((0, $aUGqu._)(args)));
    };
    var handleExited = function(node) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        if (node) node.style.visibility = '';
        onExited == null || onExited.apply(void 0, (0, $aUGqu._)(args));
    };
    var renderBackdrop = (0, $lliNT.useCallback)(function(backdropProps) {
        return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", (0, $6fpqi._)((0, $1XAnY._)({}, backdropProps), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("".concat(bsPrefix, "-backdrop"), backdropClassName)
        }));
    }, [
        backdropClassName,
        bsPrefix
    ]);
    var renderDialog = function(dialogProps) {
        return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", (0, $6fpqi._)((0, $1XAnY._)({}, dialogProps, props), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, responsive ? "".concat(bsPrefix, "-").concat(responsive) : bsPrefix, "".concat(bsPrefix, "-").concat(placement)),
            "aria-labelledby": ariaLabelledby,
            children: children
        }));
    };
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $tLNoZ.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $1a48f96a46bf373a$export$2e2bcd8739ae039).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $05de7f34de43cf4e$export$2e2bcd8739ae039), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $ceb4801f56d927a4$var$DialogTransition,
                    backdropTransition: $ceb4801f56d927a4$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$ceb4801f56d927a4$var$Offcanvas.displayName = 'Offcanvas';
var $ceb4801f56d927a4$export$2e2bcd8739ae039 = Object.assign($ceb4801f56d927a4$var$Offcanvas, {
    Body: (0, $341aa7ec18df675d$export$2e2bcd8739ae039),
    Header: (0, $718153435787edc0$export$2e2bcd8739ae039),
    Title: (0, $ae1139f5266dd39b$export$2e2bcd8739ae039)
});




"use client";
var $57ce7e122bc85ed8$var$NavbarOffcanvas = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var onHide = _param.onHide, props = (0, $6acIq._)(_param, [
        "onHide"
    ]);
    var context = (0, $lliNT.useContext)((0, $8dda86df8b6e7572$export$2e2bcd8739ae039));
    var handleHide = (0, $ddf2f427ad010346$export$2e2bcd8739ae039)(function() {
        context == null || context.onToggle == null || context.onToggle();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $ceb4801f56d927a4$export$2e2bcd8739ae039), (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref,
        show: !!(context != null && context.expanded)
    }, props), {
        renderStaticNode: true,
        onHide: handleHide
    }));
});
$57ce7e122bc85ed8$var$NavbarOffcanvas.displayName = 'NavbarOffcanvas';
var $57ce7e122bc85ed8$export$2e2bcd8739ae039 = $57ce7e122bc85ed8$var$NavbarOffcanvas;





var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");



"use client";
var $d188585762ac0253$var$NavbarText = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'span' : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'navbar-text');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$d188585762ac0253$var$NavbarText.displayName = 'NavbarText';
var $d188585762ac0253$export$2e2bcd8739ae039 = $d188585762ac0253$var$NavbarText;



"use client";
var $8a0fedff0064748a$var$Navbar = /*#__PURE__*/ $1aLYV.forwardRef(function(props, ref) {
    var _useUncontrolled = (0, $5e3a44538f1f449f$export$2e2bcd8739ae039)(props, {
        expanded: 'onToggle'
    }), initialBsPrefix = _useUncontrolled.bsPrefix, _useUncontrolled_expand = _useUncontrolled.expand, expand = _useUncontrolled_expand === void 0 ? true : _useUncontrolled_expand, _useUncontrolled_variant = _useUncontrolled.variant, variant = _useUncontrolled_variant === void 0 ? 'light' : _useUncontrolled_variant, bg = _useUncontrolled.bg, fixed = _useUncontrolled.fixed, sticky = _useUncontrolled.sticky, className = _useUncontrolled.className, tmp = _useUncontrolled.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'nav' : tmp, expanded = _useUncontrolled.expanded, onToggle = _useUncontrolled.onToggle, onSelect = _useUncontrolled.onSelect, _useUncontrolled_collapseOnSelect = _useUncontrolled.collapseOnSelect, collapseOnSelect = _useUncontrolled_collapseOnSelect === void 0 ? false : _useUncontrolled_collapseOnSelect, controlledProps = (0, $6acIq._)(_useUncontrolled, [
        "bsPrefix",
        "expand",
        "variant",
        "bg",
        "fixed",
        "sticky",
        "className",
        "as",
        "expanded",
        "onToggle",
        "onSelect",
        "collapseOnSelect"
    ]);
    var bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(initialBsPrefix, 'navbar');
    var handleCollapse = (0, $lliNT.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        onSelect == null || onSelect.apply(void 0, (0, $aUGqu._)(args));
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== 'nav') controlledProps.role = 'navigation';
    var expandClass = "".concat(bsPrefix, "-expand");
    if (typeof expand === 'string') expandClass = "".concat(expandClass, "-").concat(expand);
    var navbarContext = (0, $lliNT.useMemo)(function() {
        return {
            onToggle: function() {
                return onToggle == null ? void 0 : onToggle(!expanded);
            },
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        };
    }, [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $8dda86df8b6e7572$export$2e2bcd8739ae039).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $094e1eeba7f32a66$export$2e2bcd8739ae039).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({
                ref: ref
            }, controlledProps), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, expand && expandClass, variant && "".concat(bsPrefix, "-").concat(variant), bg && "bg-".concat(bg), sticky && "sticky-".concat(sticky), fixed && "fixed-".concat(fixed))
            }))
        })
    });
});
$8a0fedff0064748a$var$Navbar.displayName = 'Navbar';
var $8a0fedff0064748a$export$2e2bcd8739ae039 = Object.assign($8a0fedff0064748a$var$Navbar, {
    Brand: (0, $292dfe981fa51abb$export$2e2bcd8739ae039),
    Collapse: (0, $a5beff96d32f35c7$export$2e2bcd8739ae039),
    Offcanvas: (0, $57ce7e122bc85ed8$export$2e2bcd8739ae039),
    Text: (0, $d188585762ac0253$export$2e2bcd8739ae039),
    Toggle: (0, $dde15d8ee5e39768$export$2e2bcd8739ae039)
});



var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");

var $13u2V = parcelRequire("13u2V");

var $Csf8W = parcelRequire("Csf8W");

var $h2kUE = parcelRequire("h2kUE");

var $lhPyT = parcelRequire("lhPyT");
function $6ea25dc1c0b3fb2a$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $6ea25dc1c0b3fb2a$var$$c6af500b4433b08b$exports = {};
$6ea25dc1c0b3fb2a$var$$parcel$export($6ea25dc1c0b3fb2a$var$$c6af500b4433b08b$exports, "SpeechSynthesisState", function() {
    return $6ea25dc1c0b3fb2a$export$bf098d6e10b5582a;
});
$6ea25dc1c0b3fb2a$var$$parcel$export($6ea25dc1c0b3fb2a$var$$c6af500b4433b08b$exports, "SpeechSynthesisModel", function() {
    return $6ea25dc1c0b3fb2a$export$6c5d58455f3ab236;
});
var $6ea25dc1c0b3fb2a$var$$c6af500b4433b08b$var$__runInitializers = function $c6af500b4433b08b$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $6ea25dc1c0b3fb2a$var$$c6af500b4433b08b$var$__esDecorate = function $c6af500b4433b08b$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $7E0eS._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $6ea25dc1c0b3fb2a$var$$c6af500b4433b08b$var$__awaiter = function $c6af500b4433b08b$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6ea25dc1c0b3fb2a$var$$c6af500b4433b08b$var$__classPrivateFieldGet = function $c6af500b4433b08b$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $6ea25dc1c0b3fb2a$var$$c6af500b4433b08b$var$__classPrivateFieldSet = function $c6af500b4433b08b$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $6ea25dc1c0b3fb2a$export$bf098d6e10b5582a;
(function(SpeechSynthesisState) {
    SpeechSynthesisState[SpeechSynthesisState["Clear"] = 0] = "Clear";
    SpeechSynthesisState[SpeechSynthesisState["Speaking"] = 1] = "Speaking";
    SpeechSynthesisState[SpeechSynthesisState["Pause"] = 2] = "Pause";
})($6ea25dc1c0b3fb2a$export$bf098d6e10b5582a || ($6ea25dc1c0b3fb2a$export$bf098d6e10b5582a = {}));
var $6ea25dc1c0b3fb2a$export$6c5d58455f3ab236 = function() {
    var _a, _SpeechSynthesisModel_disposer, _SpeechSynthesisModel_state_accessor_storage;
    var _instanceExtraInitializers = [];
    var _state_decorators;
    var _state_initializers = [];
    var _state_extraInitializers = [];
    var _get_language_decorators;
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function SpeechSynthesisModel(i18n) {
            var _this = this;
            (0, $173N4._)(this, SpeechSynthesisModel);
            Object.defineProperty(this, "i18n", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($6ea25dc1c0b3fb2a$var$$c6af500b4433b08b$var$__runInitializers(this, _instanceExtraInitializers), i18n)
            });
            _SpeechSynthesisModel_state_accessor_storage.set(this, $6ea25dc1c0b3fb2a$var$$c6af500b4433b08b$var$__runInitializers(this, _state_initializers, $6ea25dc1c0b3fb2a$export$bf098d6e10b5582a.Clear));
            _SpeechSynthesisModel_disposer.set(this, $6ea25dc1c0b3fb2a$var$$c6af500b4433b08b$var$__runInitializers(this, _state_extraInitializers));
            Object.defineProperty(this, "clear", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function() {
                    var _b;
                    _this.state = $6ea25dc1c0b3fb2a$export$bf098d6e10b5582a.Clear;
                    (_b = $6ea25dc1c0b3fb2a$var$$c6af500b4433b08b$var$__classPrivateFieldGet(_this, _SpeechSynthesisModel_disposer, "f")) === null || _b === void 0 || _b.call(_this);
                    speechSynthesis.cancel();
                }
            });
            if (i18n) $6ea25dc1c0b3fb2a$var$$c6af500b4433b08b$var$__classPrivateFieldSet(this, _SpeechSynthesisModel_disposer, (0, $h2kUE.reaction)(function() {
                return i18n.currentLanguage;
            }, this.clear), "f");
            globalThis.addEventListener('unload', this.clear);
        }
        (0, $cFHGC._)(SpeechSynthesisModel, [
            {
                key: "state",
                get: function get() {
                    return $6ea25dc1c0b3fb2a$var$$c6af500b4433b08b$var$__classPrivateFieldGet(this, _SpeechSynthesisModel_state_accessor_storage, "f");
                },
                set: function set(value) {
                    $6ea25dc1c0b3fb2a$var$$c6af500b4433b08b$var$__classPrivateFieldSet(this, _SpeechSynthesisModel_state_accessor_storage, value, "f");
                }
            },
            {
                key: "language",
                get: function get() {
                    var _b, _c;
                    return ((_b = this.i18n) === null || _b === void 0 ? void 0 : _b.currentLanguage) || ((_c = globalThis.navigator) === null || _c === void 0 ? void 0 : _c.language);
                }
            },
            {
                key: "speak",
                value: function speak(text) {
                    return $6ea25dc1c0b3fb2a$var$$c6af500b4433b08b$var$__awaiter(this, void 0, void 0, function() {
                        var _this, language, content, voices, result;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this = this, language = _this.language, content = new SpeechSynthesisUtterance(text);
                                    return [
                                        4,
                                        _a.getVoices()
                                    ];
                                case 1:
                                    voices = _state.sent();
                                    content.voice = voices.find(function(param) {
                                        var localService = param.localService, lang = param.lang;
                                        return localService && lang === language;
                                    }) || voices.find(function(param) {
                                        var backup = param.default;
                                        return backup;
                                    });
                                    result = new Promise(function(resolve, reject) {
                                        content.onend = resolve;
                                        content.onerror = reject;
                                    });
                                    speechSynthesis.speak(content);
                                    this.state = $6ea25dc1c0b3fb2a$export$bf098d6e10b5582a.Speaking;
                                    _state.label = 2;
                                case 2:
                                    _state.trys.push([
                                        2,
                                        ,
                                        4,
                                        5
                                    ]);
                                    return [
                                        4,
                                        result
                                    ];
                                case 3:
                                    _state.sent();
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    this.clear();
                                    return [
                                        7
                                    ];
                                case 5:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "toggle",
                value: function toggle() {
                    if (this.state === $6ea25dc1c0b3fb2a$export$bf098d6e10b5582a.Speaking) {
                        speechSynthesis.pause();
                        this.state = $6ea25dc1c0b3fb2a$export$bf098d6e10b5582a.Pause;
                    } else {
                        speechSynthesis.resume();
                        this.state = $6ea25dc1c0b3fb2a$export$bf098d6e10b5582a.Speaking;
                    }
                }
            }
        ], [
            {
                key: "getVoices",
                value: function getVoices() {
                    var voices = speechSynthesis.getVoices();
                    return voices[0] ? Promise.resolve(voices) : new Promise(function(resolve) {
                        (0, $lhPyT.sleep)(1).then(function() {
                            return resolve([]);
                        });
                        speechSynthesis.onvoiceschanged = function() {
                            return resolve(speechSynthesis.getVoices());
                        };
                    });
                }
            },
            {
                key: "walk",
                value: function walk(range) {
                    var commonAncestorContainer, endContainer, walker, current;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                commonAncestorContainer = range.commonAncestorContainer, endContainer = range.endContainer;
                                walker = document.createNodeIterator(commonAncestorContainer);
                                _state.label = 1;
                            case 1:
                                if (!(current = walker.nextNode())) return [
                                    3,
                                    4
                                ];
                                if (!range.intersectsNode(current)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    current
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                if (commonAncestorContainer !== endContainer && current === endContainer) return [
                                    3,
                                    4
                                ];
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }
            },
            {
                key: "getSelectedText",
                value: function getSelectedText(box) {
                    var _b;
                    var range = (_b = getSelection()) === null || _b === void 0 ? void 0 : _b.getRangeAt(0);
                    if (!(range === null || range === void 0 ? void 0 : range.toString()) || !(box === null || box === void 0 ? void 0 : box.contains(range.commonAncestorContainer))) throw new RangeError('No text selected');
                    return (0, $aUGqu._)(this.walk(range)).filter(function(param) {
                        var nodeType = param.nodeType, parentNode = param.parentNode;
                        if (nodeType !== 3) return;
                        var _parentNode_getBoundingClientRect = parentNode.getBoundingClientRect(), width = _parentNode_getBoundingClientRect.width, height = _parentNode_getBoundingClientRect.height;
                        return width && height;
                    }).map(function(param, index, param1) {
                        var nodeValue = param.nodeValue, length = param1.length;
                        return nodeValue.slice(index === 0 ? range.startOffset : 0, index === length - 1 ? range.endOffset : Infinity);
                    }).filter(function(text) {
                        return text.trim();
                    }).join('').trim();
                }
            },
            {
                key: "getReadableText",
                value: function getReadableText(box) {
                    try {
                        return this.getSelectedText(box);
                    } catch (_b) {
                        return (0, $lhPyT.getVisibleText)(box);
                    }
                }
            }
        ]);
        return SpeechSynthesisModel;
    }(), _SpeechSynthesisModel_disposer = new WeakMap(), _SpeechSynthesisModel_state_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _state_decorators = [
            (0, $h2kUE.observable)
        ];
        _get_language_decorators = [
            (0, $h2kUE.computed)
        ];
        $6ea25dc1c0b3fb2a$var$$c6af500b4433b08b$var$__esDecorate(_a, null, _state_decorators, {
            kind: "accessor",
            name: "state",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "state" in obj;
                },
                get: function(obj) {
                    return obj.state;
                },
                set: function(obj, value) {
                    obj.state = value;
                }
            },
            metadata: _metadata
        }, _state_initializers, _state_extraInitializers);
        $6ea25dc1c0b3fb2a$var$$c6af500b4433b08b$var$__esDecorate(_a, null, _get_language_decorators, {
            kind: "getter",
            name: "language",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "language" in obj;
                },
                get: function(obj) {
                    return obj.language;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$exports = {};
$6ea25dc1c0b3fb2a$var$$parcel$export($6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$exports, "TranslationModel", function() {
    return $6ea25dc1c0b3fb2a$export$d91823dfc159395b;
});
$6ea25dc1c0b3fb2a$var$$parcel$export($6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$exports, "loadLanguageMap", function() {
    return $6ea25dc1c0b3fb2a$export$745e12634107cb52;
});
$6ea25dc1c0b3fb2a$var$$parcel$export($6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$exports, "loadLanguageMapFrom", function() {
    return $6ea25dc1c0b3fb2a$export$b9f85f5ba933b8e7;
});
var $6ea25dc1c0b3fb2a$var$$552a56cc5ff3f479$exports = {};
$6ea25dc1c0b3fb2a$var$$parcel$export($6ea25dc1c0b3fb2a$var$$552a56cc5ff3f479$exports, "isNumberLetter", function() {
    return $6ea25dc1c0b3fb2a$export$df0b442c7f8df5c1;
});
$6ea25dc1c0b3fb2a$var$$parcel$export($6ea25dc1c0b3fb2a$var$$552a56cc5ff3f479$exports, "textJoin", function() {
    return $6ea25dc1c0b3fb2a$export$d977f7cd0cb45fe1;
});
$6ea25dc1c0b3fb2a$var$$parcel$export($6ea25dc1c0b3fb2a$var$$552a56cc5ff3f479$exports, "parseLanguageHeader", function() {
    return $6ea25dc1c0b3fb2a$export$2557e81a557a81ea;
});
var $6ea25dc1c0b3fb2a$export$df0b442c7f8df5c1 = function() {
    var raw = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
    return new RegExp('\\p{N}', 'u').test(raw) || new RegExp('\\p{Ll}', 'u').test(raw.toLowerCase());
};
var $6ea25dc1c0b3fb2a$export$d977f7cd0cb45fe1 = function() {
    for(var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++){
        parts[_key] = arguments[_key];
    }
    return parts.map(function(raw, index) {
        var _a;
        var isNL = $6ea25dc1c0b3fb2a$export$df0b442c7f8df5c1(raw.slice(-1));
        if (index + 1 === parts.length) return raw;
        var diff = isNL !== $6ea25dc1c0b3fb2a$export$df0b442c7f8df5c1((_a = parts[index + 1]) === null || _a === void 0 ? void 0 : _a.trim()[0]);
        return raw + (diff || isNL ? ' ' : '');
    }).join('');
};
var $6ea25dc1c0b3fb2a$export$2557e81a557a81ea = function(value) {
    return value.split(',').map(function(language) {
        var _language_split = (0, $f9AOD._)(language.split(';'), 2), name = _language_split[0], tmp = _language_split[1], quantity = tmp === void 0 ? '' : tmp;
        var _quantity_split = (0, $f9AOD._)(quantity.split('='), 2), _ = _quantity_split[0], tmp1 = _quantity_split[1], _$value = tmp1 === void 0 ? '1' : tmp1;
        return [
            name.trim(),
            +_$value
        ];
    }).sort(function(param, param1) {
        var _param = (0, $f9AOD._)(param, 2), _ = _param[0], a = _param[1], _param1 = (0, $f9AOD._)(param1, 2), __ = _param1[0], b = _param1[1];
        return b - a;
    }).map(function(param) {
        var _param = (0, $f9AOD._)(param, 1), name = _param[0];
        return name;
    });
};
var $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__runInitializers = function $d1a4b21e19b1b67c$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__esDecorate = function $d1a4b21e19b1b67c$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $7E0eS._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__awaiter = function $d1a4b21e19b1b67c$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet = function $d1a4b21e19b1b67c$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet = function $d1a4b21e19b1b67c$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $6ea25dc1c0b3fb2a$export$d91823dfc159395b = function() {
    var _a, _TranslationModel_loading_accessor_storage, _TranslationModel_currentLanguage_accessor_storage, _TranslationModel_currentMap_accessor_storage;
    var _instanceExtraInitializers = [];
    var _loading_decorators;
    var _loading_initializers = [];
    var _loading_extraInitializers = [];
    var _currentLanguage_decorators;
    var _currentLanguage_initializers = [];
    var _currentLanguage_extraInitializers = [];
    var _currentMap_decorators;
    var _currentMap_initializers = [];
    var _currentMap_extraInitializers = [];
    var _get_defaultMap_decorators;
    var _loadLanguages_decorators;
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function TranslationModel(configuration) {
            var _this = this;
            (0, $173N4._)(this, TranslationModel);
            Object.defineProperty(this, "configuration", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _instanceExtraInitializers), configuration)
            });
            _TranslationModel_loading_accessor_storage.set(this, $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _loading_initializers, false));
            Object.defineProperty(this, "defaultLanguage", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _loading_extraInitializers)
            });
            _TranslationModel_currentLanguage_accessor_storage.set(this, $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentLanguage_initializers, ''));
            _TranslationModel_currentMap_accessor_storage.set(this, ($6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentLanguage_extraInitializers), $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentMap_initializers, {})));
            Object.defineProperty(this, "t", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentMap_extraInitializers), this.textOf.bind(this))
            });
            for(var name in configuration)if (typeof configuration[name] !== 'function') this.defaultLanguage = name;
            if (!this.defaultLanguage) throw ReferenceError('One static language map is required');
            if (!globalThis.window) return;
            var languages = [
                (0, $lhPyT.parseCookie)().language
            ].concat((0, $aUGqu._)(navigator.languages || [
                this.defaultLanguage
            ]), [
                document.documentElement.lang
            ]).filter(Boolean);
            this.loadLanguages.apply(this, (0, $aUGqu._)(languages));
            window.addEventListener('languagechange', function() {
                return _this.loadLanguages(navigator.language);
            });
        }
        (0, $cFHGC._)(TranslationModel, [
            {
                key: "loading",
                get: function get() {
                    return $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_loading_accessor_storage, "f");
                },
                set: function set(value) {
                    $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_loading_accessor_storage, value, "f");
                }
            },
            {
                key: "currentLanguage",
                get: function get() {
                    return $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_currentLanguage_accessor_storage, "f");
                },
                set: function set(value) {
                    $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_currentLanguage_accessor_storage, value, "f");
                }
            },
            {
                key: "currentMap",
                get: function get() {
                    return $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_currentMap_accessor_storage, "f");
                },
                set: function set(value) {
                    $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_currentMap_accessor_storage, value, "f");
                }
            },
            {
                key: "defaultMap",
                get: function get() {
                    return this.configuration[this.defaultLanguage];
                }
            },
            {
                key: "onLanguageChange",
                value: function onLanguageChange(handler) {
                    var _this = this;
                    (0, $h2kUE.reaction)(function() {
                        return _this.currentLanguage;
                    }, function(currentLanguage, lastLanguage) {
                        if (lastLanguage) handler.call(_this, currentLanguage);
                    });
                }
            },
            {
                key: "setLanguage",
                value: function setLanguage(name) {
                    var _b;
                    this.currentLanguage = name;
                    if ((_b = globalThis.document) === null || _b === void 0 ? void 0 : _b.documentElement) (0, $lhPyT.setCookie)('language', document.documentElement.lang = name, {
                        path: '/'
                    });
                }
            },
            {
                key: "loadLanguages",
                value: function loadLanguages() {
                    for(var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++){
                        names[_key] = arguments[_key];
                    }
                    return $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__awaiter(this, void 0, void 0, function() {
                        var _ref, tmp, language, tmp1, languageMap;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    this.loading = true;
                                    return [
                                        4,
                                        $6ea25dc1c0b3fb2a$export$745e12634107cb52(this.configuration, names)
                                    ];
                                case 1:
                                    _ref = _state.sent() || {}, tmp = _ref.language, language = tmp === void 0 ? this.defaultLanguage : tmp, tmp1 = _ref.languageMap, languageMap = tmp1 === void 0 ? this.configuration[this.defaultLanguage] : tmp1;
                                    this.loading = false;
                                    this.setLanguage(language);
                                    return [
                                        2,
                                        this.currentMap = languageMap
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "textOf",
                value: function textOf(key, data) {
                    var value = this.currentMap[key] || this.defaultMap[key];
                    if (typeof value !== 'function') return value;
                    if (!data) throw ReferenceError('Input data is required for Translation Resolver');
                    return value(data);
                }
            }
        ]);
        return TranslationModel;
    }(), _TranslationModel_loading_accessor_storage = new WeakMap(), _TranslationModel_currentLanguage_accessor_storage = new WeakMap(), _TranslationModel_currentMap_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _loading_decorators = [
            (0, $h2kUE.observable)
        ];
        _currentLanguage_decorators = [
            (0, $h2kUE.observable)
        ];
        _currentMap_decorators = [
            (0, $h2kUE.observable)
        ];
        _get_defaultMap_decorators = [
            (0, $h2kUE.computed)
        ];
        _loadLanguages_decorators = [
            (0, $h2kUE.action)
        ];
        $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _loading_decorators, {
            kind: "accessor",
            name: "loading",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "loading" in obj;
                },
                get: function(obj) {
                    return obj.loading;
                },
                set: function(obj, value) {
                    obj.loading = value;
                }
            },
            metadata: _metadata
        }, _loading_initializers, _loading_extraInitializers);
        $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _currentLanguage_decorators, {
            kind: "accessor",
            name: "currentLanguage",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "currentLanguage" in obj;
                },
                get: function(obj) {
                    return obj.currentLanguage;
                },
                set: function(obj, value) {
                    obj.currentLanguage = value;
                }
            },
            metadata: _metadata
        }, _currentLanguage_initializers, _currentLanguage_extraInitializers);
        $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _currentMap_decorators, {
            kind: "accessor",
            name: "currentMap",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "currentMap" in obj;
                },
                get: function(obj) {
                    return obj.currentMap;
                },
                set: function(obj, value) {
                    obj.currentMap = value;
                }
            },
            metadata: _metadata
        }, _currentMap_initializers, _currentMap_extraInitializers);
        $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _get_defaultMap_decorators, {
            kind: "getter",
            name: "defaultMap",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "defaultMap" in obj;
                },
                get: function(obj) {
                    return obj.defaultMap;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _loadLanguages_decorators, {
            kind: "method",
            name: "loadLanguages",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "loadLanguages" in obj;
                },
                get: function(obj) {
                    return obj.loadLanguages;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $6ea25dc1c0b3fb2a$export$745e12634107cb52 = function(configuration, names) {
    return $6ea25dc1c0b3fb2a$var$$d1a4b21e19b1b67c$var$__awaiter(void 0, void 0, void 0, function() {
        var languages, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, _ret, err;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    languages = Object.keys(configuration).sort(function(param, param1) {
                        var a = param.length, b = param1.length;
                        return b - a;
                    });
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _loop = function() {
                        var name, language, languageMap, _ref, data, _a;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    name = _step.value;
                                    language = languages.includes(name) ? name : languages.find(function(language) {
                                        return name.startsWith(language) || language.startsWith(name);
                                    });
                                    if (!language) return [
                                        2,
                                        "continue"
                                    ];
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    languageMap = configuration[language];
                                    if (typeof languageMap !== 'function') return [
                                        2,
                                        {
                                            v: {
                                                language: language,
                                                languageMap: languageMap
                                            }
                                        }
                                    ];
                                    return [
                                        4,
                                        languageMap()
                                    ];
                                case 2:
                                    _ref = _state.sent(), data = _ref.default;
                                    configuration[language] = data;
                                    return [
                                        2,
                                        {
                                            v: {
                                                language: language,
                                                languageMap: data
                                            }
                                        }
                                    ];
                                case 3:
                                    _a = _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    _iterator = names[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    return [
                        5,
                        (0, $Csf8W.__values)(_loop())
                    ];
                case 3:
                    _ret = _state.sent();
                    if ((0, $7E0eS._)(_ret) === "object") return [
                        2,
                        _ret.v
                    ];
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
};
var $6ea25dc1c0b3fb2a$export$b9f85f5ba933b8e7 = function(configuration, param) {
    var acceptLanguage = param['accept-language'], cookie = param.cookie;
    var _$42h8L$parseCookie = (0, $lhPyT.parseCookie)(cookie || ''), language = _$42h8L$parseCookie.language, languages = $6ea25dc1c0b3fb2a$export$2557e81a557a81ea(acceptLanguage || '');
    return $6ea25dc1c0b3fb2a$export$745e12634107cb52(configuration, [
        language
    ].concat((0, $aUGqu._)(languages)).filter(Boolean));
};


var $4f4598c544ae7941$export$2e2bcd8739ae039 = {
    welcome: "\u6B22\u8FCE",
    upstream_projects: "\u4E0A\u6E38\u9879\u76EE",
    home_page: "\u4E3B\u9875",
    source_code: "\u6E90\u4EE3\u7801",
    component: "\u7EC4\u4EF6",
    pagination: "\u5206\u9875",
    chart: "\u56FE\u8868",
    downloader: "\u4E0B\u8F7D\u5668",
    powered_by: "\u5F3A\u529B\u9A71\u52A8\u81EA",
    documentation: "\u6587\u6863",
    learn: "\u5B66\u4E60",
    examples: "\u793A\u4F8B",
    deploy: "\u90E8\u7F72",
    // REST table
    create: "\u65B0\u589E",
    submit: "\u63D0\u4EA4",
    cancel: "\u53D6\u6D88",
    edit: "\u7F16\u8F91",
    delete: "\u5220\u9664",
    total_x_rows: function(param) {
        var totalCount = param.totalCount;
        return "\u5171 ".concat(totalCount, " \u884C");
    },
    sure_to_delete_x: function(param) {
        var keys = param.keys;
        return "\u60A8\u786E\u5B9A\u5220\u9664 ".concat(keys.join("\u3001"), " \u5417\uFF1F");
    },
    repository_name: "\u4ED3\u5E93\u540D",
    programming_language: "\u7F16\u7A0B\u8BED\u8A00",
    topic: "\u8BDD\u9898",
    star_count: "\u661F\u6807\u6570",
    // Scroll List
    scroll_list: "\u6EDA\u52A8\u5217\u8868",
    load_more: "\u52A0\u8F7D\u66F4\u591A\u2026\u2026",
    no_more: "\u6CA1\u6709\u66F4\u591A"
};




var $50993b47476de2e7$export$a7357cdd1f0b0168 = new (0, $6ea25dc1c0b3fb2a$export$d91823dfc159395b)({
    'zh-CN': (0, $4f4598c544ae7941$export$2e2bcd8739ae039),
    'zh-TW': function() {
        return (parcelRequire("kh3Tr"));
    },
    'en-US': function() {
        return (parcelRequire("dM9eC"));
    }
});
var $50993b47476de2e7$export$4b3850bcaaad82f1 = {
    'zh-CN': "\u7B80\u4F53\u4E2D\u6587",
    'zh-TW': "\u7E41\u9AD4\u4E2D\u6587",
    'en-US': 'English'
};


var $bbbe91238a04fd85$var$t = (0, $50993b47476de2e7$export$a7357cdd1f0b0168).t;
var $bbbe91238a04fd85$export$3baea55415cc8bd1 = function() {
    return [
        {
            href: '#/',
            title: $bbbe91238a04fd85$var$t('home_page')
        },
        {
            href: '#/component',
            title: $bbbe91238a04fd85$var$t('component')
        },
        {
            href: '#/pagination',
            title: $bbbe91238a04fd85$var$t('pagination')
        },
        {
            href: '#/scroll-list',
            title: $bbbe91238a04fd85$var$t('scroll_list')
        },
        {
            href: '#/chart',
            title: $bbbe91238a04fd85$var$t('chart')
        },
        {
            href: '#/downloader',
            title: $bbbe91238a04fd85$var$t('downloader')
        },
        {
            href: 'https://github.com/idea2app/React-MobX-Bootstrap-ts',
            title: $bbbe91238a04fd85$var$t('source_code')
        }
    ];
};



var $d8891ad0958c2273$export$db3c28d99448dcff;
$d8891ad0958c2273$export$db3c28d99448dcff = "MgokeW_logo";


var $aca7ac1a0ae40101$export$8b543871300e74c2 = (0, $e04d4b638436dc5e$export$b6ae1bc530f4c149)(function() {
    var currentLanguage = (0, $50993b47476de2e7$export$a7357cdd1f0b0168).currentLanguage;
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $8a0fedff0064748a$export$2e2bcd8739ae039), {
        style: {
            zIndex: 1030
        },
        bg: "primary",
        variant: "dark",
        sticky: "top",
        expand: "lg",
        collapseOnSelect: true,
        children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $1a4cf9540da0f5bb$export$2e2bcd8739ae039), {
            children: [
                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $8a0fedff0064748a$export$2e2bcd8739ae039).Brand, {
                    href: ".",
                    children: [
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("img", {
                            className: "".concat($d8891ad0958c2273$export$db3c28d99448dcff, " me-2"),
                            src: "https://github.com/react-bootstrap.png"
                        }),
                        document.title
                    ]
                }),
                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $8a0fedff0064748a$export$2e2bcd8739ae039).Toggle, {
                    "aria-controls": "navbar-inner"
                }),
                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $8a0fedff0064748a$export$2e2bcd8739ae039).Collapse, {
                    id: "navbar-inner",
                    children: [
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $b36744b28a8e5731$export$2e2bcd8739ae039), {
                            className: "me-auto",
                            children: (0, $bbbe91238a04fd85$export$3baea55415cc8bd1)().map(function(param) {
                                var title = param.title, href = param.href;
                                return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $b36744b28a8e5731$export$2e2bcd8739ae039).Link, {
                                    className: "text-white",
                                    href: href,
                                    children: title
                                }, title);
                            })
                        }),
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $baaeda96f7555c00$exports.Select), {
                            value: currentLanguage,
                            onChange: function(key) {
                                return (0, $50993b47476de2e7$export$a7357cdd1f0b0168).loadLanguages(key);
                            },
                            children: Object.entries((0, $50993b47476de2e7$export$4b3850bcaaad82f1)).map(function(param) {
                                var _param = (0, $f9AOD._)(param, 2), key = _param[0], name = _param[1];
                                return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $baaeda96f7555c00$exports.Option), {
                                    value: key,
                                    children: name
                                }, key);
                            })
                        })
                    ]
                })
            ]
        })
    });
});



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $tLNoZ = parcelRequire("tLNoZ");

var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $hdIku = parcelRequire("hdIku");
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ 
var $7E0eS = parcelRequire("7E0eS");
var $3785de68a34a44e8$var$extendStatics = function extendStatics1(d, b) {
    $3785de68a34a44e8$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3785de68a34a44e8$var$extendStatics(d, b);
};
function $3785de68a34a44e8$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3785de68a34a44e8$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3785de68a34a44e8$export$18ce0697a983be9b = function __assign1() {
    $3785de68a34a44e8$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3785de68a34a44e8$export$18ce0697a983be9b.apply(this, arguments);
};
function $3785de68a34a44e8$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3785de68a34a44e8$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $7E0eS._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3785de68a34a44e8$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3785de68a34a44e8$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $7E0eS._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3785de68a34a44e8$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3785de68a34a44e8$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $3785de68a34a44e8$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $3785de68a34a44e8$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $3785de68a34a44e8$export$45d3717a4c69092e(o, m, p);
}
function $3785de68a34a44e8$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3785de68a34a44e8$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3785de68a34a44e8$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3785de68a34a44e8$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3785de68a34a44e8$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3785de68a34a44e8$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}
function $3785de68a34a44e8$export$10c90e4f7922046c(v) {
    return this instanceof $3785de68a34a44e8$export$10c90e4f7922046c ? (this.v = v, this) : new $3785de68a34a44e8$export$10c90e4f7922046c(v);
}
function $3785de68a34a44e8$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3785de68a34a44e8$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3785de68a34a44e8$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3785de68a34a44e8$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $3785de68a34a44e8$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3785de68a34a44e8$export$19a8beecd37a4c45 === "function" ? $3785de68a34a44e8$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3785de68a34a44e8$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $3785de68a34a44e8$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $3785de68a34a44e8$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3785de68a34a44e8$export$45d3717a4c69092e(result, mod, k);
    }
    $3785de68a34a44e8$var$__setModuleDefault(result, mod);
    return result;
}
function $3785de68a34a44e8$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3785de68a34a44e8$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3785de68a34a44e8$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}


/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE
*/ 
var $7E0eS = parcelRequire("7E0eS");
var $6d0397515b55cc48$var$Browser = function() {
    function Browser() {
        this.firefox = false;
        this.ie = false;
        this.edge = false;
        this.newEdge = false;
        this.weChat = false;
    }
    return Browser;
}();
var $6d0397515b55cc48$var$Env = function() {
    function Env() {
        this.browser = new $6d0397515b55cc48$var$Browser();
        this.node = false;
        this.wxa = false;
        this.worker = false;
        this.svgSupported = false;
        this.touchEventsSupported = false;
        this.pointerEventsSupported = false;
        this.domSupported = false;
        this.transformSupported = false;
        this.transform3dSupported = false;
        this.hasGlobalWindow = typeof window !== 'undefined';
    }
    return Env;
}();
var $6d0397515b55cc48$var$env = new $6d0397515b55cc48$var$Env();
if ((typeof wx === "undefined" ? "undefined" : (0, $7E0eS._)(wx)) === 'object' && typeof wx.getSystemInfoSync === 'function') {
    $6d0397515b55cc48$var$env.wxa = true;
    $6d0397515b55cc48$var$env.touchEventsSupported = true;
} else if (typeof document === 'undefined' && typeof self !== 'undefined') $6d0397515b55cc48$var$env.worker = true;
else if (!$6d0397515b55cc48$var$env.hasGlobalWindow || 'Deno' in window || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Node.js') > -1) {
    $6d0397515b55cc48$var$env.node = true;
    $6d0397515b55cc48$var$env.svgSupported = true;
} else $6d0397515b55cc48$var$detect(navigator.userAgent, $6d0397515b55cc48$var$env);
function $6d0397515b55cc48$var$detect(ua, env) {
    var browser = env.browser;
    var firefox = ua.match(/Firefox\/([\d.]+)/);
    var ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/.+?rv:(([\d.]+))/);
    var edge = ua.match(/Edge?\/([\d.]+)/);
    var weChat = /micromessenger/i.test(ua);
    if (firefox) {
        browser.firefox = true;
        browser.version = firefox[1];
    }
    if (ie) {
        browser.ie = true;
        browser.version = ie[1];
    }
    if (edge) {
        browser.edge = true;
        browser.version = edge[1];
        browser.newEdge = +edge[1].split('.')[0] > 18;
    }
    if (weChat) browser.weChat = true;
    env.svgSupported = typeof SVGRect !== 'undefined';
    env.touchEventsSupported = 'ontouchstart' in window && !browser.ie && !browser.edge;
    env.pointerEventsSupported = 'onpointerdown' in window && (browser.edge || browser.ie && +browser.version >= 11);
    var domSupported = env.domSupported = typeof document !== 'undefined';
    if (domSupported) {
        var style = document.documentElement.style;
        env.transform3dSupported = (browser.ie && 'transition' in style || browser.edge || 'WebKitCSSMatrix' in window && 'm11' in new WebKitCSSMatrix() || 'MozPerspective' in style) && !('OTransition' in style);
        env.transformSupported = env.transform3dSupported || browser.ie && +browser.version >= 9;
    }
}
var $6d0397515b55cc48$export$2e2bcd8739ae039 = $6d0397515b55cc48$var$env;



var $7E0eS = parcelRequire("7E0eS");
var $e4ffe803d17351c8$export$b1461457ea2c1179 = 12;
var $e4ffe803d17351c8$export$2653e0d5dd45b294 = 'sans-serif';
var $e4ffe803d17351c8$export$7d7a232b6d2cc80c = $e4ffe803d17351c8$export$b1461457ea2c1179 + "px " + $e4ffe803d17351c8$export$2653e0d5dd45b294;
var $e4ffe803d17351c8$var$OFFSET = 20;
var $e4ffe803d17351c8$var$SCALE = 100;
var $e4ffe803d17351c8$var$defaultWidthMapStr = "007LLmW'55;N0500LLLLLLLLLL00NNNLzWW\\\\WQb\\0FWLg\\bWb\\WQ\\WrWWQ000CL5LLFLL0LL**F*gLLLL5F0LF\\FFF5.5N";
function $e4ffe803d17351c8$var$getTextWidthMap(mapStr) {
    var map = {};
    if (typeof JSON === 'undefined') return map;
    for(var i = 0; i < mapStr.length; i++){
        var char = String.fromCharCode(i + 32);
        var size = (mapStr.charCodeAt(i) - $e4ffe803d17351c8$var$OFFSET) / $e4ffe803d17351c8$var$SCALE;
        map[char] = size;
    }
    return map;
}
var $e4ffe803d17351c8$export$69462fcc6bf851a4 = $e4ffe803d17351c8$var$getTextWidthMap($e4ffe803d17351c8$var$defaultWidthMapStr);
var $e4ffe803d17351c8$export$ef5e599365494451 = {
    createCanvas: function createCanvas() {
        return typeof document !== 'undefined' && document.createElement('canvas');
    },
    measureText: function() {
        var _ctx;
        var _cachedFont;
        return function(text, font) {
            if (!_ctx) {
                var canvas = $e4ffe803d17351c8$export$ef5e599365494451.createCanvas();
                _ctx = canvas && canvas.getContext('2d');
            }
            if (_ctx) {
                if (_cachedFont !== font) _cachedFont = _ctx.font = font || $e4ffe803d17351c8$export$7d7a232b6d2cc80c;
                return _ctx.measureText(text);
            } else {
                text = text || '';
                font = font || $e4ffe803d17351c8$export$7d7a232b6d2cc80c;
                var res = /((?:\d+)?\.?\d*)px/.exec(font);
                var fontSize = res && +res[1] || $e4ffe803d17351c8$export$b1461457ea2c1179;
                var width = 0;
                if (font.indexOf('mono') >= 0) width = fontSize * text.length;
                else for(var i = 0; i < text.length; i++){
                    var preCalcWidth = $e4ffe803d17351c8$export$69462fcc6bf851a4[text[i]];
                    width += preCalcWidth == null ? fontSize : preCalcWidth * fontSize;
                }
                return {
                    width: width
                };
            }
        };
    }(),
    loadImage: function loadImage(src, onload, onerror) {
        var image = new Image();
        image.onload = onload;
        image.onerror = onerror;
        image.src = src;
        return image;
    },
    getTime: function getTime() {
        return Date.now ? Date.now() : +new Date();
    }
};
function $e4ffe803d17351c8$export$61bcfd79465c1b7c(newPlatformApis) {
    for(var key in $e4ffe803d17351c8$export$ef5e599365494451)if ($e4ffe803d17351c8$export$ef5e599365494451.hasOwnProperty(key) && newPlatformApis[key]) $e4ffe803d17351c8$export$ef5e599365494451[key] = newPlatformApis[key];
}


var $f16f2994a32ad273$var$BUILTIN_OBJECT = $f16f2994a32ad273$export$533b26079ad0b4b([
    'Function',
    'RegExp',
    'Date',
    'Error',
    'CanvasGradient',
    'CanvasPattern',
    'Image',
    'Canvas'
], function(obj, val) {
    obj['[object ' + val + ']'] = true;
    return obj;
}, {});
var $f16f2994a32ad273$var$TYPED_ARRAY = $f16f2994a32ad273$export$533b26079ad0b4b([
    'Int8',
    'Uint8',
    'Uint8Clamped',
    'Int16',
    'Uint16',
    'Int32',
    'Uint32',
    'Float32',
    'Float64'
], function(obj, val) {
    obj['[object ' + val + 'Array]'] = true;
    return obj;
}, {});
var $f16f2994a32ad273$var$objToString = Object.prototype.toString;
var $f16f2994a32ad273$var$arrayProto = Array.prototype;
var $f16f2994a32ad273$var$nativeForEach = $f16f2994a32ad273$var$arrayProto.forEach;
var $f16f2994a32ad273$var$nativeFilter = $f16f2994a32ad273$var$arrayProto.filter;
var $f16f2994a32ad273$var$nativeSlice = $f16f2994a32ad273$var$arrayProto.slice;
var $f16f2994a32ad273$var$nativeMap = $f16f2994a32ad273$var$arrayProto.map;
var $f16f2994a32ad273$var$ctorFunction = (function ctorFunction() {}).constructor;
var $f16f2994a32ad273$var$protoFunction = $f16f2994a32ad273$var$ctorFunction ? $f16f2994a32ad273$var$ctorFunction.prototype : null;
var $f16f2994a32ad273$var$protoKey = '__proto__';
var $f16f2994a32ad273$var$idStart = 0x0907;
var $f16f2994a32ad273$var$MAX_SAFE_INTEGER = Math.pow(2, 53) - 1;
function $f16f2994a32ad273$export$46e8f25c7328f77e() {
    if ($f16f2994a32ad273$var$idStart >= $f16f2994a32ad273$var$MAX_SAFE_INTEGER) $f16f2994a32ad273$var$idStart = 0;
    return $f16f2994a32ad273$var$idStart++;
}
function $f16f2994a32ad273$export$58da9968c3170cb1() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (typeof console !== 'undefined') console.error.apply(console, args);
}
function $f16f2994a32ad273$export$9cd59f9826255e47(source) {
    if (source == null || (typeof source === "undefined" ? "undefined" : (0, $7E0eS._)(source)) !== 'object') return source;
    var result = source;
    var typeStr = $f16f2994a32ad273$var$objToString.call(source);
    if (typeStr === '[object Array]') {
        if (!$f16f2994a32ad273$export$c3825b437cbdea5c(source)) {
            result = [];
            for(var i = 0, len = source.length; i < len; i++)result[i] = $f16f2994a32ad273$export$9cd59f9826255e47(source[i]);
        }
    } else if ($f16f2994a32ad273$var$TYPED_ARRAY[typeStr]) {
        if (!$f16f2994a32ad273$export$c3825b437cbdea5c(source)) {
            var Ctor = source.constructor;
            if (Ctor.from) result = Ctor.from(source);
            else {
                result = new Ctor(source.length);
                for(var i = 0, len = source.length; i < len; i++)result[i] = source[i];
            }
        }
    } else if (!$f16f2994a32ad273$var$BUILTIN_OBJECT[typeStr] && !$f16f2994a32ad273$export$c3825b437cbdea5c(source) && !$f16f2994a32ad273$export$9f57505b7bd8dae(source)) {
        result = {};
        for(var key in source)if (source.hasOwnProperty(key) && key !== $f16f2994a32ad273$var$protoKey) result[key] = $f16f2994a32ad273$export$9cd59f9826255e47(source[key]);
    }
    return result;
}
function $f16f2994a32ad273$export$4950aa0f605343fb(target, source, overwrite) {
    if (!$f16f2994a32ad273$export$a6cdc56e425d0d0a(source) || !$f16f2994a32ad273$export$a6cdc56e425d0d0a(target)) return overwrite ? $f16f2994a32ad273$export$9cd59f9826255e47(source) : target;
    for(var key in source)if (source.hasOwnProperty(key) && key !== $f16f2994a32ad273$var$protoKey) {
        var targetProp = target[key];
        var sourceProp = source[key];
        if ($f16f2994a32ad273$export$a6cdc56e425d0d0a(sourceProp) && $f16f2994a32ad273$export$a6cdc56e425d0d0a(targetProp) && !$f16f2994a32ad273$export$43bee75e5e14138e(sourceProp) && !$f16f2994a32ad273$export$43bee75e5e14138e(targetProp) && !$f16f2994a32ad273$export$9f57505b7bd8dae(sourceProp) && !$f16f2994a32ad273$export$9f57505b7bd8dae(targetProp) && !$f16f2994a32ad273$export$fa523b2c4941fd4f(sourceProp) && !$f16f2994a32ad273$export$fa523b2c4941fd4f(targetProp) && !$f16f2994a32ad273$export$c3825b437cbdea5c(sourceProp) && !$f16f2994a32ad273$export$c3825b437cbdea5c(targetProp)) $f16f2994a32ad273$export$4950aa0f605343fb(targetProp, sourceProp, overwrite);
        else if (overwrite || !(key in target)) target[key] = $f16f2994a32ad273$export$9cd59f9826255e47(source[key]);
    }
    return target;
}
function $f16f2994a32ad273$export$18aef43295bbe906(targetAndSources, overwrite) {
    var result = targetAndSources[0];
    for(var i = 1, len = targetAndSources.length; i < len; i++)result = $f16f2994a32ad273$export$4950aa0f605343fb(result, targetAndSources[i], overwrite);
    return result;
}
function $f16f2994a32ad273$export$8b58be045bf06082(target, source) {
    if (Object.assign) Object.assign(target, source);
    else {
        for(var key in source)if (source.hasOwnProperty(key) && key !== $f16f2994a32ad273$var$protoKey) target[key] = source[key];
    }
    return target;
}
function $f16f2994a32ad273$export$2b3af8009eff404f(tar, src, props) {
    tar = tar || {};
    for(var idx = 0; idx < props.length; idx++){
        var prop = props[idx];
        tar[prop] = src[prop];
    }
    return tar;
}
function $f16f2994a32ad273$export$ebe90cb607ad99e(target, source, overlay) {
    var keysArr = $f16f2994a32ad273$export$ed97f33186d4b816(source);
    for(var i = 0, len = keysArr.length; i < len; i++){
        var key = keysArr[i];
        if (overlay ? source[key] != null : target[key] == null) target[key] = source[key];
    }
    return target;
}
var $f16f2994a32ad273$export$cd3d1f114b139967 = (0, $e4ffe803d17351c8$export$ef5e599365494451).createCanvas;
function $f16f2994a32ad273$export$305f7d4e9d4624f2(array, value) {
    if (array) {
        if (array.indexOf) return array.indexOf(value);
        for(var i = 0, len = array.length; i < len; i++){
            if (array[i] === value) return i;
        }
    }
    return -1;
}
function $f16f2994a32ad273$export$69f1b2dcda23c5f8(clazz, baseClazz) {
    var clazzPrototype = clazz.prototype;
    function F() {}
    F.prototype = baseClazz.prototype;
    clazz.prototype = new F();
    for(var prop in clazzPrototype)if (clazzPrototype.hasOwnProperty(prop)) clazz.prototype[prop] = clazzPrototype[prop];
    clazz.prototype.constructor = clazz;
    clazz.superClass = baseClazz;
}
function $f16f2994a32ad273$export$e36fc9d62a853069(target, source, override) {
    target = 'prototype' in target ? target.prototype : target;
    source = 'prototype' in source ? source.prototype : source;
    if (Object.getOwnPropertyNames) {
        var keyList = Object.getOwnPropertyNames(source);
        for(var i = 0; i < keyList.length; i++){
            var key = keyList[i];
            if (key !== 'constructor') {
                if (override ? source[key] != null : target[key] == null) target[key] = source[key];
            }
        }
    } else $f16f2994a32ad273$export$ebe90cb607ad99e(target, source, override);
}
function $f16f2994a32ad273$export$1e2f57719e155213(data) {
    if (!data) return false;
    if (typeof data === 'string') return false;
    return typeof data.length === 'number';
}
function $f16f2994a32ad273$export$79b2f7037acddd43(arr, cb, context) {
    if (!(arr && cb)) return;
    if (arr.forEach && arr.forEach === $f16f2994a32ad273$var$nativeForEach) arr.forEach(cb, context);
    else if (arr.length === +arr.length) for(var i = 0, len = arr.length; i < len; i++)cb.call(context, arr[i], i, arr);
    else {
        for(var key in arr)if (arr.hasOwnProperty(key)) cb.call(context, arr[key], key, arr);
    }
}
function $f16f2994a32ad273$export$871de8747c9eaa88(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $f16f2994a32ad273$export$58adb3bec8346d0f(arr);
    if (arr.map && arr.map === $f16f2994a32ad273$var$nativeMap) return arr.map(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)result.push(cb.call(context, arr[i], i, arr));
        return result;
    }
}
function $f16f2994a32ad273$export$533b26079ad0b4b(arr, cb, memo, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++)memo = cb.call(context, memo, arr[i], i, arr);
    return memo;
}
function $f16f2994a32ad273$export$3dea766d36a8935f(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $f16f2994a32ad273$export$58adb3bec8346d0f(arr);
    if (arr.filter && arr.filter === $f16f2994a32ad273$var$nativeFilter) return arr.filter(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)if (cb.call(context, arr[i], i, arr)) result.push(arr[i]);
        return result;
    }
}
function $f16f2994a32ad273$export$71aa6c912b956294(arr, cb, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++){
        if (cb.call(context, arr[i], i, arr)) return arr[i];
    }
}
function $f16f2994a32ad273$export$ed97f33186d4b816(obj) {
    if (!obj) return [];
    if (Object.keys) return Object.keys(obj);
    var keyList = [];
    for(var key in obj)if (obj.hasOwnProperty(key)) keyList.push(key);
    return keyList;
}
function $f16f2994a32ad273$var$bindPolyfill(func, context) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return function() {
        return func.apply(context, args.concat($f16f2994a32ad273$var$nativeSlice.call(arguments)));
    };
}
var $f16f2994a32ad273$export$2385a24977818dd0 = $f16f2994a32ad273$var$protoFunction && $f16f2994a32ad273$export$f6e2535fb5126e54($f16f2994a32ad273$var$protoFunction.bind) ? $f16f2994a32ad273$var$protoFunction.call.bind($f16f2994a32ad273$var$protoFunction.bind) : $f16f2994a32ad273$var$bindPolyfill;
function $f16f2994a32ad273$export$c3095a23b368d1f2(func) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return function() {
        return func.apply(this, args.concat($f16f2994a32ad273$var$nativeSlice.call(arguments)));
    };
}
function $f16f2994a32ad273$export$43bee75e5e14138e(value) {
    if (Array.isArray) return Array.isArray(value);
    return $f16f2994a32ad273$var$objToString.call(value) === '[object Array]';
}
function $f16f2994a32ad273$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $f16f2994a32ad273$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
function $f16f2994a32ad273$export$29d0bb2a4e07b252(value) {
    return $f16f2994a32ad273$var$objToString.call(value) === '[object String]';
}
function $f16f2994a32ad273$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}
function $f16f2994a32ad273$export$a6cdc56e425d0d0a(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value);
    return type === 'function' || !!value && type === 'object';
}
function $f16f2994a32ad273$export$fa523b2c4941fd4f(value) {
    return !!$f16f2994a32ad273$var$BUILTIN_OBJECT[$f16f2994a32ad273$var$objToString.call(value)];
}
function $f16f2994a32ad273$export$b119cc7e1840e59c(value) {
    return !!$f16f2994a32ad273$var$TYPED_ARRAY[$f16f2994a32ad273$var$objToString.call(value)];
}
function $f16f2994a32ad273$export$9f57505b7bd8dae(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) === 'object' && typeof value.nodeType === 'number' && (0, $7E0eS._)(value.ownerDocument) === 'object';
}
function $f16f2994a32ad273$export$fa2c283003ed971c(value) {
    return value.colorStops != null;
}
function $f16f2994a32ad273$export$a49bbf3a55dcef7b(value) {
    return value.image != null;
}
function $f16f2994a32ad273$export$49841c62b9eff15(value) {
    return $f16f2994a32ad273$var$objToString.call(value) === '[object RegExp]';
}
function $f16f2994a32ad273$export$7d667b9a0c48c975(value) {
    return value !== value;
}
function $f16f2994a32ad273$export$8a4d17b6e8486e66() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    for(var i = 0, len = args.length; i < len; i++){
        if (args[i] != null) return args[i];
    }
}
function $f16f2994a32ad273$export$995e01f2f5c9d030(value0, value1) {
    return value0 != null ? value0 : value1;
}
function $f16f2994a32ad273$export$2e94551289abb95b(value0, value1, value2) {
    return value0 != null ? value0 : value1 != null ? value1 : value2;
}
function $f16f2994a32ad273$export$58adb3bec8346d0f(arr) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $f16f2994a32ad273$var$nativeSlice.apply(arr, args);
}
function $f16f2994a32ad273$export$f3a38102c49f4268(val) {
    if (typeof val === 'number') return [
        val,
        val,
        val,
        val
    ];
    var len = val.length;
    if (len === 2) return [
        val[0],
        val[1],
        val[0],
        val[1]
    ];
    else if (len === 3) return [
        val[0],
        val[1],
        val[2],
        val[1]
    ];
    return val;
}
function $f16f2994a32ad273$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message);
}
function $f16f2994a32ad273$export$87c2784dc9fc4ab(str) {
    if (str == null) return null;
    else if (typeof str.trim === 'function') return str.trim();
    else return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}
var $f16f2994a32ad273$var$primitiveKey = '__ec_primitive__';
function $f16f2994a32ad273$export$112e66431016387b(obj) {
    obj[$f16f2994a32ad273$var$primitiveKey] = true;
}
function $f16f2994a32ad273$export$c3825b437cbdea5c(obj) {
    return obj[$f16f2994a32ad273$var$primitiveKey];
}
var $f16f2994a32ad273$var$MapPolyfill = function() {
    function MapPolyfill() {
        this.data = {};
    }
    MapPolyfill.prototype["delete"] = function(key) {
        var existed = this.has(key);
        if (existed) delete this.data[key];
        return existed;
    };
    MapPolyfill.prototype.has = function(key) {
        return this.data.hasOwnProperty(key);
    };
    MapPolyfill.prototype.get = function(key) {
        return this.data[key];
    };
    MapPolyfill.prototype.set = function(key, value) {
        this.data[key] = value;
        return this;
    };
    MapPolyfill.prototype.keys = function() {
        return $f16f2994a32ad273$export$ed97f33186d4b816(this.data);
    };
    MapPolyfill.prototype.forEach = function(callback) {
        var data = this.data;
        for(var key in data)if (data.hasOwnProperty(key)) callback(data[key], key);
    };
    return MapPolyfill;
}();
var $f16f2994a32ad273$var$isNativeMapSupported = typeof Map === 'function';
function $f16f2994a32ad273$var$maybeNativeMap() {
    return $f16f2994a32ad273$var$isNativeMapSupported ? new Map() : new $f16f2994a32ad273$var$MapPolyfill();
}
var $f16f2994a32ad273$export$60ef0b43d585640a = function() {
    function HashMap(obj) {
        var isArr = $f16f2994a32ad273$export$43bee75e5e14138e(obj);
        this.data = $f16f2994a32ad273$var$maybeNativeMap();
        var thisMap = this;
        obj instanceof HashMap ? obj.each(visit) : obj && $f16f2994a32ad273$export$79b2f7037acddd43(obj, visit);
        function visit(value, key) {
            isArr ? thisMap.set(value, key) : thisMap.set(key, value);
        }
    }
    HashMap.prototype.hasKey = function(key) {
        return this.data.has(key);
    };
    HashMap.prototype.get = function(key) {
        return this.data.get(key);
    };
    HashMap.prototype.set = function(key, value) {
        this.data.set(key, value);
        return value;
    };
    HashMap.prototype.each = function(cb, context) {
        this.data.forEach(function(value, key) {
            cb.call(context, value, key);
        });
    };
    HashMap.prototype.keys = function() {
        var keys = this.data.keys();
        return $f16f2994a32ad273$var$isNativeMapSupported ? Array.from(keys) : keys;
    };
    HashMap.prototype.removeKey = function(key) {
        this.data["delete"](key);
    };
    return HashMap;
}();
function $f16f2994a32ad273$export$55f8aa7ef875b0a4(obj) {
    return new $f16f2994a32ad273$export$60ef0b43d585640a(obj);
}
function $f16f2994a32ad273$export$4fd8af2c48c43416(a, b) {
    var newArray = new a.constructor(a.length + b.length);
    for(var i = 0; i < a.length; i++)newArray[i] = a[i];
    var offset = a.length;
    for(var i = 0; i < b.length; i++)newArray[i + offset] = b[i];
    return newArray;
}
function $f16f2994a32ad273$export$79c7e160a7743efd(proto, properties) {
    var obj;
    if (Object.create) obj = Object.create(proto);
    else {
        var StyleCtor = function StyleCtor() {};
        StyleCtor.prototype = proto;
        obj = new StyleCtor();
    }
    if (properties) $f16f2994a32ad273$export$8b58be045bf06082(obj, properties);
    return obj;
}
function $f16f2994a32ad273$export$23a5d775868fdd2c(dom) {
    var domStyle = dom.style;
    domStyle.webkitUserSelect = 'none';
    domStyle.userSelect = 'none';
    domStyle.webkitTapHighlightColor = 'rgba(0,0,0,0)';
    domStyle['-webkit-touch-callout'] = 'none';
}
function $f16f2994a32ad273$export$b5a638e9b3fff9f3(own, prop) {
    return own.hasOwnProperty(prop);
}
function $f16f2994a32ad273$export$8793edee2d425525() {}
var $f16f2994a32ad273$export$bce8e055322a0ce6 = 180 / Math.PI;
var $f16f2994a32ad273$export$fd293b15f47e270 = Number.EPSILON || Math.pow(2, -52);




function $f79ec7ea1294b339$export$185802fd694ee1f5(x, y) {
    if (x == null) x = 0;
    if (y == null) y = 0;
    return [
        x,
        y
    ];
}
function $f79ec7ea1294b339$export$784d13d8ee351f07(out, v) {
    out[0] = v[0];
    out[1] = v[1];
    return out;
}
function $f79ec7ea1294b339$export$9cd59f9826255e47(v) {
    return [
        v[0],
        v[1]
    ];
}
function $f79ec7ea1294b339$export$adaa4cf7ef1b65be(out, a, b) {
    out[0] = a;
    out[1] = b;
    return out;
}
function $f79ec7ea1294b339$export$e16d8520af44a096(out, v1, v2) {
    out[0] = v1[0] + v2[0];
    out[1] = v1[1] + v2[1];
    return out;
}
function $f79ec7ea1294b339$export$19cedf1da84ba854(out, v1, v2, a) {
    out[0] = v1[0] + v2[0] * a;
    out[1] = v1[1] + v2[1] * a;
    return out;
}
function $f79ec7ea1294b339$export$f93b5905241a7cca(out, v1, v2) {
    out[0] = v1[0] - v2[0];
    out[1] = v1[1] - v2[1];
    return out;
}
function $f79ec7ea1294b339$export$fc1400facf92c78(v) {
    return Math.sqrt($f79ec7ea1294b339$export$48e33bc611e4c25a(v));
}
var $f79ec7ea1294b339$export$f24224f1c91d8156 = $f79ec7ea1294b339$export$fc1400facf92c78;
function $f79ec7ea1294b339$export$48e33bc611e4c25a(v) {
    return v[0] * v[0] + v[1] * v[1];
}
var $f79ec7ea1294b339$export$2f106540dd9a5136 = $f79ec7ea1294b339$export$48e33bc611e4c25a;
function $f79ec7ea1294b339$export$6e3a27864ab166fe(out, v1, v2) {
    out[0] = v1[0] * v2[0];
    out[1] = v1[1] * v2[1];
    return out;
}
function $f79ec7ea1294b339$export$159d9494db57879b(out, v1, v2) {
    out[0] = v1[0] / v2[0];
    out[1] = v1[1] / v2[1];
    return out;
}
function $f79ec7ea1294b339$export$94132a0e348806d4(v1, v2) {
    return v1[0] * v2[0] + v1[1] * v2[1];
}
function $f79ec7ea1294b339$export$dcdf75081b88279d(out, v, s) {
    out[0] = v[0] * s;
    out[1] = v[1] * s;
    return out;
}
function $f79ec7ea1294b339$export$a3295358bff77e(out, v) {
    var d = $f79ec7ea1294b339$export$fc1400facf92c78(v);
    if (d === 0) {
        out[0] = 0;
        out[1] = 0;
    } else {
        out[0] = v[0] / d;
        out[1] = v[1] / d;
    }
    return out;
}
function $f79ec7ea1294b339$export$9f17032d917177de(v1, v2) {
    return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}
var $f79ec7ea1294b339$export$6c4a311cc157c764 = $f79ec7ea1294b339$export$9f17032d917177de;
function $f79ec7ea1294b339$export$137c0a69d1ff4a79(v1, v2) {
    return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}
var $f79ec7ea1294b339$export$c68db45a034c13b0 = $f79ec7ea1294b339$export$137c0a69d1ff4a79;
function $f79ec7ea1294b339$export$aef51622e549b8b0(out, v) {
    out[0] = -v[0];
    out[1] = -v[1];
    return out;
}
function $f79ec7ea1294b339$export$3a89f8d6f6bf6c9f(out, v1, v2, t) {
    out[0] = v1[0] + t * (v2[0] - v1[0]);
    out[1] = v1[1] + t * (v2[1] - v1[1]);
    return out;
}
function $f79ec7ea1294b339$export$9f9dcb98c894b623(out, v, m) {
    var x = v[0];
    var y = v[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $f79ec7ea1294b339$export$96ec731ed4dcb222(out, v1, v2) {
    out[0] = Math.min(v1[0], v2[0]);
    out[1] = Math.min(v1[1], v2[1]);
    return out;
}
function $f79ec7ea1294b339$export$8960430cfd85939f(out, v1, v2) {
    out[0] = Math.max(v1[0], v2[0]);
    out[1] = Math.max(v1[1], v2[1]);
    return out;
}


var $9cb82e9ada267fe7$var$Param = function() {
    function Param(target, e) {
        this.target = target;
        this.topTarget = e && e.topTarget;
    }
    return Param;
}();
var $9cb82e9ada267fe7$var$Draggable = function() {
    function Draggable(handler) {
        this.handler = handler;
        handler.on('mousedown', this._dragStart, this);
        handler.on('mousemove', this._drag, this);
        handler.on('mouseup', this._dragEnd, this);
    }
    Draggable.prototype._dragStart = function(e) {
        var draggingTarget = e.target;
        while(draggingTarget && !draggingTarget.draggable)draggingTarget = draggingTarget.parent || draggingTarget.__hostTarget;
        if (draggingTarget) {
            this._draggingTarget = draggingTarget;
            draggingTarget.dragging = true;
            this._x = e.offsetX;
            this._y = e.offsetY;
            this.handler.dispatchToElement(new $9cb82e9ada267fe7$var$Param(draggingTarget, e), 'dragstart', e.event);
        }
    };
    Draggable.prototype._drag = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) {
            var x = e.offsetX;
            var y = e.offsetY;
            var dx = x - this._x;
            var dy = y - this._y;
            this._x = x;
            this._y = y;
            draggingTarget.drift(dx, dy, e);
            this.handler.dispatchToElement(new $9cb82e9ada267fe7$var$Param(draggingTarget, e), 'drag', e.event);
            var dropTarget = this.handler.findHover(x, y, draggingTarget).target;
            var lastDropTarget = this._dropTarget;
            this._dropTarget = dropTarget;
            if (draggingTarget !== dropTarget) {
                if (lastDropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $9cb82e9ada267fe7$var$Param(lastDropTarget, e), 'dragleave', e.event);
                if (dropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $9cb82e9ada267fe7$var$Param(dropTarget, e), 'dragenter', e.event);
            }
        }
    };
    Draggable.prototype._dragEnd = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) draggingTarget.dragging = false;
        this.handler.dispatchToElement(new $9cb82e9ada267fe7$var$Param(draggingTarget, e), 'dragend', e.event);
        if (this._dropTarget) this.handler.dispatchToElement(new $9cb82e9ada267fe7$var$Param(this._dropTarget, e), 'drop', e.event);
        this._draggingTarget = null;
        this._dropTarget = null;
    };
    return Draggable;
}();
var $9cb82e9ada267fe7$export$2e2bcd8739ae039 = $9cb82e9ada267fe7$var$Draggable;


var $83f1d7c1143fe0f3$var$Eventful = function() {
    function Eventful(eventProcessors) {
        if (eventProcessors) this._$eventProcessor = eventProcessors;
    }
    Eventful.prototype.on = function(event, query, handler, context) {
        if (!this._$handlers) this._$handlers = {};
        var _h = this._$handlers;
        if (typeof query === 'function') {
            context = handler;
            handler = query;
            query = null;
        }
        if (!handler || !event) return this;
        var eventProcessor = this._$eventProcessor;
        if (query != null && eventProcessor && eventProcessor.normalizeQuery) query = eventProcessor.normalizeQuery(query);
        if (!_h[event]) _h[event] = [];
        for(var i = 0; i < _h[event].length; i++){
            if (_h[event][i].h === handler) return this;
        }
        var wrap = {
            h: handler,
            query: query,
            ctx: context || this,
            callAtLast: handler.zrEventfulCallAtLast
        };
        var lastIndex = _h[event].length - 1;
        var lastWrap = _h[event][lastIndex];
        lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
        return this;
    };
    Eventful.prototype.isSilent = function(eventName) {
        var _h = this._$handlers;
        return !_h || !_h[eventName] || !_h[eventName].length;
    };
    Eventful.prototype.off = function(eventType, handler) {
        var _h = this._$handlers;
        if (!_h) return this;
        if (!eventType) {
            this._$handlers = {};
            return this;
        }
        if (handler) {
            if (_h[eventType]) {
                var newList = [];
                for(var i = 0, l = _h[eventType].length; i < l; i++)if (_h[eventType][i].h !== handler) newList.push(_h[eventType][i]);
                _h[eventType] = newList;
            }
            if (_h[eventType] && _h[eventType].length === 0) delete _h[eventType];
        } else delete _h[eventType];
        return this;
    };
    Eventful.prototype.trigger = function(eventType) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[eventType];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(eventType, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(hItem.ctx);
                        break;
                    case 1:
                        hItem.h.call(hItem.ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(hItem.ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(hItem.ctx, args);
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(eventType);
        return this;
    };
    Eventful.prototype.triggerWithContext = function(type) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[type];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var ctx = args[argLen - 1];
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(ctx);
                        break;
                    case 1:
                        hItem.h.call(ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(ctx, args.slice(1, argLen - 1));
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
        return this;
    };
    return Eventful;
}();
var $83f1d7c1143fe0f3$export$2e2bcd8739ae039 = $83f1d7c1143fe0f3$var$Eventful;





var $75b15720cb251c43$var$LN2 = Math.log(2);
function $75b15720cb251c43$var$determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
    var cacheKey = rowMask + '-' + colMask;
    var fullRank = rows.length;
    if (detCache.hasOwnProperty(cacheKey)) return detCache[cacheKey];
    if (rank === 1) {
        var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / $75b15720cb251c43$var$LN2);
        return rows[rowStart][colStart];
    }
    var subRowMask = rowMask | 1 << rowStart;
    var subRowStart = rowStart + 1;
    while(rowMask & 1 << subRowStart)subRowStart++;
    var sum = 0;
    for(var j = 0, colLocalIdx = 0; j < fullRank; j++){
        var colTag = 1 << j;
        if (!(colTag & colMask)) {
            sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] * $75b15720cb251c43$var$determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
            colLocalIdx++;
        }
    }
    detCache[cacheKey] = sum;
    return sum;
}
function $75b15720cb251c43$export$fbdb2748a8171a7e(src, dest) {
    var mA = [
        [
            src[0],
            src[1],
            1,
            0,
            0,
            0,
            -dest[0] * src[0],
            -dest[0] * src[1]
        ],
        [
            0,
            0,
            0,
            src[0],
            src[1],
            1,
            -dest[1] * src[0],
            -dest[1] * src[1]
        ],
        [
            src[2],
            src[3],
            1,
            0,
            0,
            0,
            -dest[2] * src[2],
            -dest[2] * src[3]
        ],
        [
            0,
            0,
            0,
            src[2],
            src[3],
            1,
            -dest[3] * src[2],
            -dest[3] * src[3]
        ],
        [
            src[4],
            src[5],
            1,
            0,
            0,
            0,
            -dest[4] * src[4],
            -dest[4] * src[5]
        ],
        [
            0,
            0,
            0,
            src[4],
            src[5],
            1,
            -dest[5] * src[4],
            -dest[5] * src[5]
        ],
        [
            src[6],
            src[7],
            1,
            0,
            0,
            0,
            -dest[6] * src[6],
            -dest[6] * src[7]
        ],
        [
            0,
            0,
            0,
            src[6],
            src[7],
            1,
            -dest[7] * src[6],
            -dest[7] * src[7]
        ]
    ];
    var detCache = {};
    var det = $75b15720cb251c43$var$determinant(mA, 8, 0, 0, 0, detCache);
    if (det === 0) return;
    var vh = [];
    for(var i = 0; i < 8; i++)for(var j = 0; j < 8; j++){
        vh[j] == null && (vh[j] = 0);
        vh[j] += ((i + j) % 2 ? -1 : 1) * $75b15720cb251c43$var$determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
    }
    return function(out, srcPointX, srcPointY) {
        var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
        out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
        out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
    };
}



var $288857a46a8969d9$var$EVENT_SAVED_PROP = '___zrEVENTSAVED';
var $288857a46a8969d9$var$_calcOut = [];
function $288857a46a8969d9$export$8c5c02e118307e20(out, elFrom, elTarget, inX, inY) {
    return $288857a46a8969d9$export$1219648acc517df4($288857a46a8969d9$var$_calcOut, elFrom, inX, inY, true) && $288857a46a8969d9$export$1219648acc517df4(out, elTarget, $288857a46a8969d9$var$_calcOut[0], $288857a46a8969d9$var$_calcOut[1]);
}
function $288857a46a8969d9$export$a29dbe4b7d3cd586(elFrom, elTarget) {
    elFrom && dealClear(elFrom);
    elTarget && dealClear(elTarget);
    function dealClear(el) {
        var saved = el[$288857a46a8969d9$var$EVENT_SAVED_PROP];
        if (saved) {
            saved.clearMarkers && saved.clearMarkers();
            delete el[$288857a46a8969d9$var$EVENT_SAVED_PROP];
        }
    }
}
function $288857a46a8969d9$export$1219648acc517df4(out, el, inX, inY, inverse) {
    if (el.getBoundingClientRect && (0, $6d0397515b55cc48$export$2e2bcd8739ae039).domSupported && !$288857a46a8969d9$export$1b92e4fe606eff6d(el)) {
        var saved = el[$288857a46a8969d9$var$EVENT_SAVED_PROP] || (el[$288857a46a8969d9$var$EVENT_SAVED_PROP] = {});
        var markers = $288857a46a8969d9$var$prepareCoordMarkers(el, saved);
        var transformer = $288857a46a8969d9$var$preparePointerTransformer(markers, saved, inverse);
        if (transformer) {
            transformer(out, inX, inY);
            return true;
        }
    }
    return false;
}
function $288857a46a8969d9$var$prepareCoordMarkers(el, saved) {
    var markers = saved.markers;
    if (markers) return markers;
    markers = saved.markers = [];
    var propLR = [
        'left',
        'right'
    ];
    var propTB = [
        'top',
        'bottom'
    ];
    for(var i = 0; i < 4; i++){
        var marker = document.createElement('div');
        var stl = marker.style;
        var idxLR = i % 2;
        var idxTB = (i >> 1) % 2;
        stl.cssText = [
            'position: absolute',
            'visibility: hidden',
            'padding: 0',
            'margin: 0',
            'border-width: 0',
            'user-select: none',
            'width:0',
            'height:0',
            propLR[idxLR] + ':0',
            propTB[idxTB] + ':0',
            propLR[1 - idxLR] + ':auto',
            propTB[1 - idxTB] + ':auto',
            ''
        ].join('!important;');
        el.appendChild(marker);
        markers.push(marker);
    }
    saved.clearMarkers = function() {
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(markers, function(marker) {
            marker.parentNode && marker.parentNode.removeChild(marker);
        });
    };
    return markers;
}
function $288857a46a8969d9$var$preparePointerTransformer(markers, saved, inverse) {
    var transformerName = inverse ? 'invTrans' : 'trans';
    var transformer = saved[transformerName];
    var oldSrcCoords = saved.srcCoords;
    var srcCoords = [];
    var destCoords = [];
    var oldCoordTheSame = true;
    for(var i = 0; i < 4; i++){
        var rect = markers[i].getBoundingClientRect();
        var ii = 2 * i;
        var x = rect.left;
        var y = rect.top;
        srcCoords.push(x, y);
        oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
        destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
    }
    return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? (0, $75b15720cb251c43$export$fbdb2748a8171a7e)(destCoords, srcCoords) : (0, $75b15720cb251c43$export$fbdb2748a8171a7e)(srcCoords, destCoords));
}
function $288857a46a8969d9$export$1b92e4fe606eff6d(el) {
    return el.nodeName.toUpperCase() === 'CANVAS';
}
var $288857a46a8969d9$var$replaceReg = /([&<>"'])/g;
var $288857a46a8969d9$var$replaceMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#39;'
};
function $288857a46a8969d9$export$f9d6449b9af28dc1(source) {
    return source == null ? '' : (source + '').replace($288857a46a8969d9$var$replaceReg, function(str, c) {
        return $288857a46a8969d9$var$replaceMap[c];
    });
}


var $1f87c82830753703$var$MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
var $1f87c82830753703$var$_calcOut = [];
var $1f87c82830753703$var$firefoxNotSupportOffsetXY = (0, $6d0397515b55cc48$export$2e2bcd8739ae039).browser.firefox && +(0, $6d0397515b55cc48$export$2e2bcd8739ae039).browser.version.split('.')[0] < 39;
function $1f87c82830753703$export$7d5fecde839eee88(el, e, out, calculate) {
    out = out || {};
    if (calculate) $1f87c82830753703$var$calculateZrXY(el, e, out);
    else if ($1f87c82830753703$var$firefoxNotSupportOffsetXY && e.layerX != null && e.layerX !== e.offsetX) {
        out.zrX = e.layerX;
        out.zrY = e.layerY;
    } else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
    } else $1f87c82830753703$var$calculateZrXY(el, e, out);
    return out;
}
function $1f87c82830753703$var$calculateZrXY(el, e, out) {
    if ((0, $6d0397515b55cc48$export$2e2bcd8739ae039).domSupported && el.getBoundingClientRect) {
        var ex = e.clientX;
        var ey = e.clientY;
        if ((0, $288857a46a8969d9$export$1b92e4fe606eff6d)(el)) {
            var box = el.getBoundingClientRect();
            out.zrX = ex - box.left;
            out.zrY = ey - box.top;
            return;
        } else if ((0, $288857a46a8969d9$export$1219648acc517df4)($1f87c82830753703$var$_calcOut, el, ex, ey)) {
            out.zrX = $1f87c82830753703$var$_calcOut[0];
            out.zrY = $1f87c82830753703$var$_calcOut[1];
            return;
        }
    }
    out.zrX = out.zrY = 0;
}
function $1f87c82830753703$export$4abe0e945399ac1d(e) {
    return e || window.event;
}
function $1f87c82830753703$export$40fadb093aebad71(el, e, calculate) {
    e = $1f87c82830753703$export$4abe0e945399ac1d(e);
    if (e.zrX != null) return e;
    var eventType = e.type;
    var isTouch = eventType && eventType.indexOf('touch') >= 0;
    if (!isTouch) {
        $1f87c82830753703$export$7d5fecde839eee88(el, e, e, calculate);
        var wheelDelta = $1f87c82830753703$var$getWheelDeltaMayPolyfill(e);
        e.zrDelta = wheelDelta ? wheelDelta / 120 : -(e.detail || 0) / 3;
    } else {
        var touch = eventType !== 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
        touch && $1f87c82830753703$export$7d5fecde839eee88(el, touch, e, calculate);
    }
    var button = e.button;
    if (e.which == null && button !== undefined && $1f87c82830753703$var$MOUSE_EVENT_REG.test(e.type)) e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
    return e;
}
function $1f87c82830753703$var$getWheelDeltaMayPolyfill(e) {
    var rawWheelDelta = e.wheelDelta;
    if (rawWheelDelta) return rawWheelDelta;
    var deltaX = e.deltaX;
    var deltaY = e.deltaY;
    if (deltaX == null || deltaY == null) return rawWheelDelta;
    var delta = deltaY !== 0 ? Math.abs(deltaY) : Math.abs(deltaX);
    var sign = deltaY > 0 ? -1 : deltaY < 0 ? 1 : deltaX > 0 ? -1 : 1;
    return 3 * delta * sign;
}
function $1f87c82830753703$export$3f65cefe8380dbea(el, name, handler, opt) {
    el.addEventListener(name, handler, opt);
}
function $1f87c82830753703$export$8ff9f68337b520c0(el, name, handler, opt) {
    el.removeEventListener(name, handler, opt);
}
var $1f87c82830753703$export$fa6813432f753b0d = function stop(e) {
    e.preventDefault();
    e.stopPropagation();
    e.cancelBubble = true;
};
function $1f87c82830753703$export$b7ae4cded3e71bd2(e) {
    return e.which === 2 || e.which === 3;
}



var $0e178120f0acec06$export$f7557d6f27e9503 = function() {
    function GestureMgr() {
        this._track = [];
    }
    GestureMgr.prototype.recognize = function(event, target, root) {
        this._doTrack(event, target, root);
        return this._recognize(event);
    };
    GestureMgr.prototype.clear = function() {
        this._track.length = 0;
        return this;
    };
    GestureMgr.prototype._doTrack = function(event, target, root) {
        var touches = event.touches;
        if (!touches) return;
        var trackItem = {
            points: [],
            touches: [],
            target: target,
            event: event
        };
        for(var i = 0, len = touches.length; i < len; i++){
            var touch = touches[i];
            var pos = $1f87c82830753703$export$7d5fecde839eee88(root, touch, {});
            trackItem.points.push([
                pos.zrX,
                pos.zrY
            ]);
            trackItem.touches.push(touch);
        }
        this._track.push(trackItem);
    };
    GestureMgr.prototype._recognize = function(event) {
        for(var eventName in $0e178120f0acec06$var$recognizers)if ($0e178120f0acec06$var$recognizers.hasOwnProperty(eventName)) {
            var gestureInfo = $0e178120f0acec06$var$recognizers[eventName](this._track, event);
            if (gestureInfo) return gestureInfo;
        }
    };
    return GestureMgr;
}();
function $0e178120f0acec06$var$dist(pointPair) {
    var dx = pointPair[1][0] - pointPair[0][0];
    var dy = pointPair[1][1] - pointPair[0][1];
    return Math.sqrt(dx * dx + dy * dy);
}
function $0e178120f0acec06$var$center(pointPair) {
    return [
        (pointPair[0][0] + pointPair[1][0]) / 2,
        (pointPair[0][1] + pointPair[1][1]) / 2
    ];
}
var $0e178120f0acec06$var$recognizers = {
    pinch: function pinch(tracks, event) {
        var trackLen = tracks.length;
        if (!trackLen) return;
        var pinchEnd = (tracks[trackLen - 1] || {}).points;
        var pinchPre = (tracks[trackLen - 2] || {}).points || pinchEnd;
        if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
            var pinchScale = $0e178120f0acec06$var$dist(pinchEnd) / $0e178120f0acec06$var$dist(pinchPre);
            !isFinite(pinchScale) && (pinchScale = 1);
            event.pinchScale = pinchScale;
            var pinchCenter = $0e178120f0acec06$var$center(pinchEnd);
            event.pinchX = pinchCenter[0];
            event.pinchY = pinchCenter[1];
            return {
                type: 'pinch',
                target: tracks[0].target,
                event: event
            };
        }
    }
};


function $45a6d43b639a6412$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $45a6d43b639a6412$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
}
function $45a6d43b639a6412$export$784d13d8ee351f07(out, m) {
    out[0] = m[0];
    out[1] = m[1];
    out[2] = m[2];
    out[3] = m[3];
    out[4] = m[4];
    out[5] = m[5];
    return out;
}
function $45a6d43b639a6412$export$6e3a27864ab166fe(out, m1, m2) {
    var out0 = m1[0] * m2[0] + m1[2] * m2[1];
    var out1 = m1[1] * m2[0] + m1[3] * m2[1];
    var out2 = m1[0] * m2[2] + m1[2] * m2[3];
    var out3 = m1[1] * m2[2] + m1[3] * m2[3];
    var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
    var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = out3;
    out[4] = out4;
    out[5] = out5;
    return out;
}
function $45a6d43b639a6412$export$d73ee8ef04f5226a(out, a, v) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4] + v[0];
    out[5] = a[5] + v[1];
    return out;
}
function $45a6d43b639a6412$export$bb628a54ab399bc9(out, a, rad, pivot) {
    if (pivot === void 0) pivot = [
        0,
        0
    ];
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var st = Math.sin(rad);
    var ct = Math.cos(rad);
    out[0] = aa * ct + ab * st;
    out[1] = -aa * st + ab * ct;
    out[2] = ac * ct + ad * st;
    out[3] = -ac * st + ct * ad;
    out[4] = ct * (atx - pivot[0]) + st * (aty - pivot[1]) + pivot[0];
    out[5] = ct * (aty - pivot[1]) - st * (atx - pivot[0]) + pivot[1];
    return out;
}
function $45a6d43b639a6412$export$dcdf75081b88279d(out, a, v) {
    var vx = v[0];
    var vy = v[1];
    out[0] = a[0] * vx;
    out[1] = a[1] * vy;
    out[2] = a[2] * vx;
    out[3] = a[3] * vy;
    out[4] = a[4] * vx;
    out[5] = a[5] * vy;
    return out;
}
function $45a6d43b639a6412$export$6897c284b6f9f4dc(out, a) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var det = aa * ad - ab * ac;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
}
function $45a6d43b639a6412$export$9cd59f9826255e47(a) {
    var b = $45a6d43b639a6412$export$185802fd694ee1f5();
    $45a6d43b639a6412$export$784d13d8ee351f07(b, a);
    return b;
}



var $f82d35899f1caf18$var$Point = function() {
    function Point(x, y) {
        this.x = x || 0;
        this.y = y || 0;
    }
    Point.prototype.copy = function(other) {
        this.x = other.x;
        this.y = other.y;
        return this;
    };
    Point.prototype.clone = function() {
        return new Point(this.x, this.y);
    };
    Point.prototype.set = function(x, y) {
        this.x = x;
        this.y = y;
        return this;
    };
    Point.prototype.equal = function(other) {
        return other.x === this.x && other.y === this.y;
    };
    Point.prototype.add = function(other) {
        this.x += other.x;
        this.y += other.y;
        return this;
    };
    Point.prototype.scale = function(scalar) {
        this.x *= scalar;
        this.y *= scalar;
    };
    Point.prototype.scaleAndAdd = function(other, scalar) {
        this.x += other.x * scalar;
        this.y += other.y * scalar;
    };
    Point.prototype.sub = function(other) {
        this.x -= other.x;
        this.y -= other.y;
        return this;
    };
    Point.prototype.dot = function(other) {
        return this.x * other.x + this.y * other.y;
    };
    Point.prototype.len = function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    };
    Point.prototype.lenSquare = function() {
        return this.x * this.x + this.y * this.y;
    };
    Point.prototype.normalize = function() {
        var len = this.len();
        this.x /= len;
        this.y /= len;
        return this;
    };
    Point.prototype.distance = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    Point.prototype.distanceSquare = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return dx * dx + dy * dy;
    };
    Point.prototype.negate = function() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    };
    Point.prototype.transform = function(m) {
        if (!m) return;
        var x = this.x;
        var y = this.y;
        this.x = m[0] * x + m[2] * y + m[4];
        this.y = m[1] * x + m[3] * y + m[5];
        return this;
    };
    Point.prototype.toArray = function(out) {
        out[0] = this.x;
        out[1] = this.y;
        return out;
    };
    Point.prototype.fromArray = function(input) {
        this.x = input[0];
        this.y = input[1];
    };
    Point.set = function(p, x, y) {
        p.x = x;
        p.y = y;
    };
    Point.copy = function(p, p2) {
        p.x = p2.x;
        p.y = p2.y;
    };
    Point.len = function(p) {
        return Math.sqrt(p.x * p.x + p.y * p.y);
    };
    Point.lenSquare = function(p) {
        return p.x * p.x + p.y * p.y;
    };
    Point.dot = function(p0, p1) {
        return p0.x * p1.x + p0.y * p1.y;
    };
    Point.add = function(out, p0, p1) {
        out.x = p0.x + p1.x;
        out.y = p0.y + p1.y;
    };
    Point.sub = function(out, p0, p1) {
        out.x = p0.x - p1.x;
        out.y = p0.y - p1.y;
    };
    Point.scale = function(out, p0, scalar) {
        out.x = p0.x * scalar;
        out.y = p0.y * scalar;
    };
    Point.scaleAndAdd = function(out, p0, p1, scalar) {
        out.x = p0.x + p1.x * scalar;
        out.y = p0.y + p1.y * scalar;
    };
    Point.lerp = function(out, p0, p1, t) {
        var onet = 1 - t;
        out.x = onet * p0.x + t * p1.x;
        out.y = onet * p0.y + t * p1.y;
    };
    return Point;
}();
var $f82d35899f1caf18$export$2e2bcd8739ae039 = $f82d35899f1caf18$var$Point;


var $7456366ce379c42e$var$mathMin = Math.min;
var $7456366ce379c42e$var$mathMax = Math.max;
var $7456366ce379c42e$var$mathAbs = Math.abs;
var $7456366ce379c42e$var$XY = [
    'x',
    'y'
];
var $7456366ce379c42e$var$WH = [
    'width',
    'height'
];
var $7456366ce379c42e$var$lt = new (0, $f82d35899f1caf18$export$2e2bcd8739ae039)();
var $7456366ce379c42e$var$rb = new (0, $f82d35899f1caf18$export$2e2bcd8739ae039)();
var $7456366ce379c42e$var$lb = new (0, $f82d35899f1caf18$export$2e2bcd8739ae039)();
var $7456366ce379c42e$var$rt = new (0, $f82d35899f1caf18$export$2e2bcd8739ae039)();
var $7456366ce379c42e$var$_intersectCtx = $7456366ce379c42e$export$a0be2bdbd2369e0e();
var $7456366ce379c42e$var$_minTv = $7456366ce379c42e$var$_intersectCtx.minTv;
var $7456366ce379c42e$var$_maxTv = $7456366ce379c42e$var$_intersectCtx.maxTv;
var $7456366ce379c42e$var$_lenMinMax = [
    0,
    0
];
var $7456366ce379c42e$var$BoundingRect = function() {
    function BoundingRect(x, y, width, height) {
        $7456366ce379c42e$export$6bf07b1ffc18797f(this, x, y, width, height);
    }
    BoundingRect.set = function(target, x, y, width, height) {
        if (width < 0) {
            x = x + width;
            width = -width;
        }
        if (height < 0) {
            y = y + height;
            height = -height;
        }
        target.x = x;
        target.y = y;
        target.width = width;
        target.height = height;
        return target;
    };
    BoundingRect.prototype.union = function(other) {
        var x = $7456366ce379c42e$var$mathMin(other.x, this.x);
        var y = $7456366ce379c42e$var$mathMin(other.y, this.y);
        if (isFinite(this.x) && isFinite(this.width)) this.width = $7456366ce379c42e$var$mathMax(other.x + other.width, this.x + this.width) - x;
        else this.width = other.width;
        if (isFinite(this.y) && isFinite(this.height)) this.height = $7456366ce379c42e$var$mathMax(other.y + other.height, this.y + this.height) - y;
        else this.height = other.height;
        this.x = x;
        this.y = y;
    };
    BoundingRect.prototype.applyTransform = function(m) {
        BoundingRect.applyTransform(this, this, m);
    };
    BoundingRect.prototype.calculateTransform = function(b) {
        return $7456366ce379c42e$export$92d3eaad4f1a1f35($45a6d43b639a6412$export$185802fd694ee1f5(), this, b);
    };
    BoundingRect.prototype.intersect = function(b, mtv, opt) {
        return BoundingRect.intersect(this, b, mtv, opt);
    };
    BoundingRect.intersect = function(a, b, mtv, opt) {
        if (mtv) (0, $f82d35899f1caf18$export$2e2bcd8739ae039).set(mtv, 0, 0);
        var outIntersectRect = opt && opt.outIntersectRect || null;
        var clamp = opt && opt.clamp;
        if (outIntersectRect) outIntersectRect.x = outIntersectRect.y = outIntersectRect.width = outIntersectRect.height = NaN;
        if (!a || !b) return false;
        if (!(a instanceof BoundingRect)) a = $7456366ce379c42e$export$6bf07b1ffc18797f($7456366ce379c42e$var$_tmpIntersectA, a.x, a.y, a.width, a.height);
        if (!(b instanceof BoundingRect)) b = $7456366ce379c42e$export$6bf07b1ffc18797f($7456366ce379c42e$var$_tmpIntersectB, b.x, b.y, b.width, b.height);
        var useMTV = !!mtv;
        $7456366ce379c42e$var$_intersectCtx.reset(opt, useMTV);
        var touchThreshold = $7456366ce379c42e$var$_intersectCtx.touchThreshold;
        var ax0 = a.x + touchThreshold;
        var ax1 = a.x + a.width - touchThreshold;
        var ay0 = a.y + touchThreshold;
        var ay1 = a.y + a.height - touchThreshold;
        var bx0 = b.x + touchThreshold;
        var bx1 = b.x + b.width - touchThreshold;
        var by0 = b.y + touchThreshold;
        var by1 = b.y + b.height - touchThreshold;
        if (ax0 > ax1 || ay0 > ay1 || bx0 > bx1 || by0 > by1) return false;
        var overlap = !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
        if (useMTV || outIntersectRect) {
            $7456366ce379c42e$var$_lenMinMax[0] = Infinity;
            $7456366ce379c42e$var$_lenMinMax[1] = 0;
            $7456366ce379c42e$var$intersectOneDim(ax0, ax1, bx0, bx1, 0, useMTV, outIntersectRect, clamp);
            $7456366ce379c42e$var$intersectOneDim(ay0, ay1, by0, by1, 1, useMTV, outIntersectRect, clamp);
            if (useMTV) (0, $f82d35899f1caf18$export$2e2bcd8739ae039).copy(mtv, overlap ? $7456366ce379c42e$var$_intersectCtx.useDir ? $7456366ce379c42e$var$_intersectCtx.dirMinTv : $7456366ce379c42e$var$_minTv : $7456366ce379c42e$var$_maxTv);
        }
        return overlap;
    };
    BoundingRect.contain = function(rect, x, y) {
        return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
    };
    BoundingRect.prototype.contain = function(x, y) {
        return BoundingRect.contain(this, x, y);
    };
    BoundingRect.prototype.clone = function() {
        return new BoundingRect(this.x, this.y, this.width, this.height);
    };
    BoundingRect.prototype.copy = function(other) {
        $7456366ce379c42e$export$241114a7b05054e(this, other);
    };
    BoundingRect.prototype.plain = function() {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    };
    BoundingRect.prototype.isFinite = function() {
        return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
    };
    BoundingRect.prototype.isZero = function() {
        return this.width === 0 || this.height === 0;
    };
    BoundingRect.create = function(rect) {
        return new BoundingRect(rect ? rect.x : 0, rect ? rect.y : 0, rect ? rect.width : 0, rect ? rect.height : 0);
    };
    BoundingRect.copy = function(target, source) {
        target.x = source.x;
        target.y = source.y;
        target.width = source.width;
        target.height = source.height;
        return target;
    };
    BoundingRect.applyTransform = function(target, source, m) {
        if (!m) {
            if (target !== source) $7456366ce379c42e$export$241114a7b05054e(target, source);
            return;
        }
        if (m[1] < 1e-5 && m[1] > -0.00001 && m[2] < 1e-5 && m[2] > -0.00001) {
            var sx = m[0];
            var sy = m[3];
            var tx = m[4];
            var ty = m[5];
            target.x = source.x * sx + tx;
            target.y = source.y * sy + ty;
            target.width = source.width * sx;
            target.height = source.height * sy;
            if (target.width < 0) {
                target.x += target.width;
                target.width = -target.width;
            }
            if (target.height < 0) {
                target.y += target.height;
                target.height = -target.height;
            }
            return;
        }
        $7456366ce379c42e$var$lt.x = $7456366ce379c42e$var$lb.x = source.x;
        $7456366ce379c42e$var$lt.y = $7456366ce379c42e$var$rt.y = source.y;
        $7456366ce379c42e$var$rb.x = $7456366ce379c42e$var$rt.x = source.x + source.width;
        $7456366ce379c42e$var$rb.y = $7456366ce379c42e$var$lb.y = source.y + source.height;
        $7456366ce379c42e$var$lt.transform(m);
        $7456366ce379c42e$var$rt.transform(m);
        $7456366ce379c42e$var$rb.transform(m);
        $7456366ce379c42e$var$lb.transform(m);
        target.x = $7456366ce379c42e$var$mathMin($7456366ce379c42e$var$lt.x, $7456366ce379c42e$var$rb.x, $7456366ce379c42e$var$lb.x, $7456366ce379c42e$var$rt.x);
        target.y = $7456366ce379c42e$var$mathMin($7456366ce379c42e$var$lt.y, $7456366ce379c42e$var$rb.y, $7456366ce379c42e$var$lb.y, $7456366ce379c42e$var$rt.y);
        var maxX = $7456366ce379c42e$var$mathMax($7456366ce379c42e$var$lt.x, $7456366ce379c42e$var$rb.x, $7456366ce379c42e$var$lb.x, $7456366ce379c42e$var$rt.x);
        var maxY = $7456366ce379c42e$var$mathMax($7456366ce379c42e$var$lt.y, $7456366ce379c42e$var$rb.y, $7456366ce379c42e$var$lb.y, $7456366ce379c42e$var$rt.y);
        target.width = maxX - target.x;
        target.height = maxY - target.y;
    };
    BoundingRect.calculateTransform = function(out, a, b) {
        var sx = b.width / a.width;
        var sy = b.height / a.height;
        out = $45a6d43b639a6412$export$f0954fd7d5368655(out || []);
        $45a6d43b639a6412$export$d73ee8ef04f5226a(out, out, $f79ec7ea1294b339$export$adaa4cf7ef1b65be($7456366ce379c42e$var$_tmpCalcTrans, -a.x, -a.y));
        $45a6d43b639a6412$export$dcdf75081b88279d(out, out, $f79ec7ea1294b339$export$adaa4cf7ef1b65be($7456366ce379c42e$var$_tmpCalcTrans, sx, sy));
        $45a6d43b639a6412$export$d73ee8ef04f5226a(out, out, $f79ec7ea1294b339$export$adaa4cf7ef1b65be($7456366ce379c42e$var$_tmpCalcTrans, b.x, b.y));
        return out;
    };
    return BoundingRect;
}();
var $7456366ce379c42e$export$cd9abb76972ddc89 = $7456366ce379c42e$var$BoundingRect.create;
var $7456366ce379c42e$export$6bf07b1ffc18797f = $7456366ce379c42e$var$BoundingRect.set;
var $7456366ce379c42e$export$241114a7b05054e = $7456366ce379c42e$var$BoundingRect.copy;
var $7456366ce379c42e$export$92d3eaad4f1a1f35 = $7456366ce379c42e$var$BoundingRect.calculateTransform;
var $7456366ce379c42e$export$738b31304fd07ad0 = $7456366ce379c42e$var$BoundingRect.applyTransform;
var $7456366ce379c42e$export$39177876d76f05b = $7456366ce379c42e$var$BoundingRect.contain;
var $7456366ce379c42e$var$_tmpIntersectA = new $7456366ce379c42e$var$BoundingRect(0, 0, 0, 0);
var $7456366ce379c42e$var$_tmpIntersectB = new $7456366ce379c42e$var$BoundingRect(0, 0, 0, 0);
var $7456366ce379c42e$var$_tmpCalcTrans = [];
function $7456366ce379c42e$var$intersectOneDim(a0, a1, b0, b1, updateDimIdx, useMTV, outIntersectRect, clamp) {
    var d0 = $7456366ce379c42e$var$mathAbs(a1 - b0);
    var d1 = $7456366ce379c42e$var$mathAbs(b1 - a0);
    var d01min = $7456366ce379c42e$var$mathMin(d0, d1);
    var updateDim = $7456366ce379c42e$var$XY[updateDimIdx];
    var zeroDim = $7456366ce379c42e$var$XY[1 - updateDimIdx];
    var wh = $7456366ce379c42e$var$WH[updateDimIdx];
    if (a1 < b0 || b1 < a0) {
        if (d0 < d1) {
            if (useMTV) $7456366ce379c42e$var$_maxTv[updateDim] = -d0;
            if (clamp) {
                outIntersectRect[updateDim] = a1;
                outIntersectRect[wh] = 0;
            }
        } else {
            if (useMTV) $7456366ce379c42e$var$_maxTv[updateDim] = d1;
            if (clamp) {
                outIntersectRect[updateDim] = a0;
                outIntersectRect[wh] = 0;
            }
        }
    } else {
        if (outIntersectRect) {
            outIntersectRect[updateDim] = $7456366ce379c42e$var$mathMax(a0, b0);
            outIntersectRect[wh] = $7456366ce379c42e$var$mathMin(a1, b1) - outIntersectRect[updateDim];
        }
        if (useMTV) {
            if (d01min < $7456366ce379c42e$var$_lenMinMax[0] || $7456366ce379c42e$var$_intersectCtx.useDir) {
                $7456366ce379c42e$var$_lenMinMax[0] = $7456366ce379c42e$var$mathMin(d01min, $7456366ce379c42e$var$_lenMinMax[0]);
                if (d0 < d1 || !$7456366ce379c42e$var$_intersectCtx.bidirectional) {
                    $7456366ce379c42e$var$_minTv[updateDim] = d0;
                    $7456366ce379c42e$var$_minTv[zeroDim] = 0;
                    if ($7456366ce379c42e$var$_intersectCtx.useDir) $7456366ce379c42e$var$_intersectCtx.calcDirMTV();
                }
                if (d0 >= d1 || !$7456366ce379c42e$var$_intersectCtx.bidirectional) {
                    $7456366ce379c42e$var$_minTv[updateDim] = -d1;
                    $7456366ce379c42e$var$_minTv[zeroDim] = 0;
                    if ($7456366ce379c42e$var$_intersectCtx.useDir) $7456366ce379c42e$var$_intersectCtx.calcDirMTV();
                }
            }
        }
    }
}
function $7456366ce379c42e$export$a0be2bdbd2369e0e() {
    var _direction = 0;
    var _dirCheckVec = new (0, $f82d35899f1caf18$export$2e2bcd8739ae039)();
    var _dirTmp = new (0, $f82d35899f1caf18$export$2e2bcd8739ae039)();
    var _ctx = {
        minTv: new (0, $f82d35899f1caf18$export$2e2bcd8739ae039)(),
        maxTv: new (0, $f82d35899f1caf18$export$2e2bcd8739ae039)(),
        useDir: false,
        dirMinTv: new (0, $f82d35899f1caf18$export$2e2bcd8739ae039)(),
        touchThreshold: 0,
        bidirectional: true,
        negativeSize: false,
        reset: function reset(opt, useMTV) {
            _ctx.touchThreshold = 0;
            if (opt && opt.touchThreshold != null) _ctx.touchThreshold = $7456366ce379c42e$var$mathMax(0, opt.touchThreshold);
            _ctx.negativeSize = false;
            if (!useMTV) return;
            _ctx.minTv.set(Infinity, Infinity);
            _ctx.maxTv.set(0, 0);
            _ctx.useDir = false;
            if (opt && opt.direction != null) {
                _ctx.useDir = true;
                _ctx.dirMinTv.copy(_ctx.minTv);
                _dirTmp.copy(_ctx.minTv);
                _direction = opt.direction;
                _ctx.bidirectional = opt.bidirectional == null || !!opt.bidirectional;
                if (!_ctx.bidirectional) _dirCheckVec.set(Math.cos(_direction), Math.sin(_direction));
            }
        },
        calcDirMTV: function calcDirMTV() {
            var minTv = _ctx.minTv;
            var dirMinTv = _ctx.dirMinTv;
            var squareMag = minTv.y * minTv.y + minTv.x * minTv.x;
            var dirSin = Math.sin(_direction);
            var dirCos = Math.cos(_direction);
            var dotProd = dirSin * minTv.y + dirCos * minTv.x;
            if (nearZero(dotProd)) {
                if (nearZero(minTv.x) && nearZero(minTv.y)) dirMinTv.set(0, 0);
                return;
            }
            _dirTmp.x = squareMag * dirCos / dotProd;
            _dirTmp.y = squareMag * dirSin / dotProd;
            if (nearZero(_dirTmp.x) && nearZero(_dirTmp.y)) {
                dirMinTv.set(0, 0);
                return;
            }
            if ((_ctx.bidirectional || _dirCheckVec.dot(_dirTmp) > 0) && _dirTmp.len() < dirMinTv.len()) dirMinTv.copy(_dirTmp);
        }
    };
    function nearZero(val) {
        return $7456366ce379c42e$var$mathAbs(val) < 1e-10;
    }
    return _ctx;
}
var $7456366ce379c42e$export$2e2bcd8739ae039 = $7456366ce379c42e$var$BoundingRect;


var $e89fe1f53dad77d7$var$SILENT = 'silent';
function $e89fe1f53dad77d7$var$makeEventPacket(eveType, targetInfo, event) {
    return {
        type: eveType,
        event: event,
        target: targetInfo.target,
        topTarget: targetInfo.topTarget,
        cancelBubble: false,
        offsetX: event.zrX,
        offsetY: event.zrY,
        gestureEvent: event.gestureEvent,
        pinchX: event.pinchX,
        pinchY: event.pinchY,
        pinchScale: event.pinchScale,
        wheelDelta: event.zrDelta,
        zrByTouch: event.zrByTouch,
        which: event.which,
        stop: $e89fe1f53dad77d7$var$stopEvent
    };
}
function $e89fe1f53dad77d7$var$stopEvent() {
    $1f87c82830753703$export$fa6813432f753b0d(this.event);
}
var $e89fe1f53dad77d7$var$EmptyProxy = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(EmptyProxy, _super);
    function EmptyProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handler = null;
        return _this;
    }
    EmptyProxy.prototype.dispose = function() {};
    EmptyProxy.prototype.setCursor = function() {};
    return EmptyProxy;
}((0, $83f1d7c1143fe0f3$export$2e2bcd8739ae039));
var $e89fe1f53dad77d7$var$HoveredResult = function() {
    function HoveredResult(x, y) {
        this.x = x;
        this.y = y;
    }
    return HoveredResult;
}();
var $e89fe1f53dad77d7$var$handlerNames = [
    'click',
    'dblclick',
    'mousewheel',
    'mouseout',
    'mouseup',
    'mousedown',
    'mousemove',
    'contextmenu'
];
var $e89fe1f53dad77d7$var$tmpRect = new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $e89fe1f53dad77d7$var$Handler = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Handler, _super);
    function Handler(storage, painter, proxy, painterRoot, pointerSize) {
        var _this = _super.call(this) || this;
        _this._hovered = new $e89fe1f53dad77d7$var$HoveredResult(0, 0);
        _this.storage = storage;
        _this.painter = painter;
        _this.painterRoot = painterRoot;
        _this._pointerSize = pointerSize;
        proxy = proxy || new $e89fe1f53dad77d7$var$EmptyProxy();
        _this.proxy = null;
        _this.setHandlerProxy(proxy);
        _this._draggingMgr = new (0, $9cb82e9ada267fe7$export$2e2bcd8739ae039)(_this);
        return _this;
    }
    Handler.prototype.setHandlerProxy = function(proxy) {
        if (this.proxy) this.proxy.dispose();
        if (proxy) {
            $f16f2994a32ad273$export$79b2f7037acddd43($e89fe1f53dad77d7$var$handlerNames, function(name) {
                proxy.on && proxy.on(name, this[name], this);
            }, this);
            proxy.handler = this;
        }
        this.proxy = proxy;
    };
    Handler.prototype.mousemove = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $e89fe1f53dad77d7$var$isOutsideBoundary(this, x, y);
        var lastHovered = this._hovered;
        var lastHoveredTarget = lastHovered.target;
        if (lastHoveredTarget && !lastHoveredTarget.__zr) {
            lastHovered = this.findHover(lastHovered.x, lastHovered.y);
            lastHoveredTarget = lastHovered.target;
        }
        var hovered = this._hovered = isOutside ? new $e89fe1f53dad77d7$var$HoveredResult(x, y) : this.findHover(x, y);
        var hoveredTarget = hovered.target;
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default');
        if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(lastHovered, 'mouseout', event);
        this.dispatchToElement(hovered, 'mousemove', event);
        if (hoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(hovered, 'mouseover', event);
    };
    Handler.prototype.mouseout = function(event) {
        var eventControl = event.zrEventControl;
        if (eventControl !== 'only_globalout') this.dispatchToElement(this._hovered, 'mouseout', event);
        if (eventControl !== 'no_globalout') this.trigger('globalout', {
            type: 'globalout',
            event: event
        });
    };
    Handler.prototype.resize = function() {
        this._hovered = new $e89fe1f53dad77d7$var$HoveredResult(0, 0);
    };
    Handler.prototype.dispatch = function(eventName, eventArgs) {
        var handler = this[eventName];
        handler && handler.call(this, eventArgs);
    };
    Handler.prototype.dispose = function() {
        this.proxy.dispose();
        this.storage = null;
        this.proxy = null;
        this.painter = null;
    };
    Handler.prototype.setCursorStyle = function(cursorStyle) {
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(cursorStyle);
    };
    Handler.prototype.dispatchToElement = function(targetInfo, eventName, event) {
        targetInfo = targetInfo || {};
        var el = targetInfo.target;
        if (el && el.silent) return;
        var eventKey = 'on' + eventName;
        var eventPacket = $e89fe1f53dad77d7$var$makeEventPacket(eventName, targetInfo, event);
        while(el){
            el[eventKey] && (eventPacket.cancelBubble = !!el[eventKey].call(el, eventPacket));
            el.trigger(eventName, eventPacket);
            el = el.__hostTarget ? el.__hostTarget : el.parent;
            if (eventPacket.cancelBubble) break;
        }
        if (!eventPacket.cancelBubble) {
            this.trigger(eventName, eventPacket);
            if (this.painter && this.painter.eachOtherLayer) this.painter.eachOtherLayer(function(layer) {
                if (typeof layer[eventKey] === 'function') layer[eventKey].call(layer, eventPacket);
                if (layer.trigger) layer.trigger(eventName, eventPacket);
            });
        }
    };
    Handler.prototype.findHover = function(x, y, exclude) {
        var list = this.storage.getDisplayList();
        var out = new $e89fe1f53dad77d7$var$HoveredResult(x, y);
        $e89fe1f53dad77d7$var$setHoverTarget(list, out, x, y, exclude);
        if (this._pointerSize && !out.target) {
            var candidates = [];
            var pointerSize = this._pointerSize;
            var targetSizeHalf = pointerSize / 2;
            var pointerRect = new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(x - targetSizeHalf, y - targetSizeHalf, pointerSize, pointerSize);
            for(var i = list.length - 1; i >= 0; i--){
                var el = list[i];
                if (el !== exclude && !el.ignore && !el.ignoreCoarsePointer && (!el.parent || !el.parent.ignoreCoarsePointer)) {
                    $e89fe1f53dad77d7$var$tmpRect.copy(el.getBoundingRect());
                    if (el.transform) $e89fe1f53dad77d7$var$tmpRect.applyTransform(el.transform);
                    if ($e89fe1f53dad77d7$var$tmpRect.intersect(pointerRect)) candidates.push(el);
                }
            }
            if (candidates.length) {
                var rStep = 4;
                var thetaStep = Math.PI / 12;
                var PI2 = Math.PI * 2;
                for(var r = 0; r < targetSizeHalf; r += rStep)for(var theta = 0; theta < PI2; theta += thetaStep){
                    var x1 = x + r * Math.cos(theta);
                    var y1 = y + r * Math.sin(theta);
                    $e89fe1f53dad77d7$var$setHoverTarget(candidates, out, x1, y1, exclude);
                    if (out.target) return out;
                }
            }
        }
        return out;
    };
    Handler.prototype.processGesture = function(event, stage) {
        if (!this._gestureMgr) this._gestureMgr = new (0, $0e178120f0acec06$export$f7557d6f27e9503)();
        var gestureMgr = this._gestureMgr;
        stage === 'start' && gestureMgr.clear();
        var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
        stage === 'end' && gestureMgr.clear();
        if (gestureInfo) {
            var type = gestureInfo.type;
            event.gestureEvent = type;
            var res = new $e89fe1f53dad77d7$var$HoveredResult();
            res.target = gestureInfo.target;
            this.dispatchToElement(res, type, gestureInfo.event);
        }
    };
    return Handler;
}((0, $83f1d7c1143fe0f3$export$2e2bcd8739ae039));
$f16f2994a32ad273$export$79b2f7037acddd43([
    'click',
    'mousedown',
    'mouseup',
    'mousewheel',
    'dblclick',
    'contextmenu'
], function(name) {
    $e89fe1f53dad77d7$var$Handler.prototype[name] = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $e89fe1f53dad77d7$var$isOutsideBoundary(this, x, y);
        var hovered;
        var hoveredTarget;
        if (name !== 'mouseup' || !isOutside) {
            hovered = this.findHover(x, y);
            hoveredTarget = hovered.target;
        }
        if (name === 'mousedown') {
            this._downEl = hoveredTarget;
            this._downPoint = [
                event.zrX,
                event.zrY
            ];
            this._upEl = hoveredTarget;
        } else if (name === 'mouseup') this._upEl = hoveredTarget;
        else if (name === 'click') {
            if (this._downEl !== this._upEl || !this._downPoint || $f79ec7ea1294b339$export$6c4a311cc157c764(this._downPoint, [
                event.zrX,
                event.zrY
            ]) > 4) return;
            this._downPoint = null;
        }
        this.dispatchToElement(hovered, name, event);
    };
});
function $e89fe1f53dad77d7$var$isHover(displayable, x, y) {
    if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
        var el = displayable;
        var isSilent = void 0;
        var ignoreClip = false;
        while(el){
            if (el.ignoreClip) ignoreClip = true;
            if (!ignoreClip) {
                var clipPath = el.getClipPath();
                if (clipPath && !clipPath.contain(x, y)) return false;
            }
            if (el.silent) isSilent = true;
            var hostEl = el.__hostTarget;
            el = hostEl ? el.ignoreHostSilent ? null : hostEl : el.parent;
        }
        return isSilent ? $e89fe1f53dad77d7$var$SILENT : true;
    }
    return false;
}
function $e89fe1f53dad77d7$var$setHoverTarget(list, out, x, y, exclude) {
    for(var i = list.length - 1; i >= 0; i--){
        var el = list[i];
        var hoverCheckResult = void 0;
        if (el !== exclude && !el.ignore && (hoverCheckResult = $e89fe1f53dad77d7$var$isHover(el, x, y))) {
            !out.topTarget && (out.topTarget = el);
            if (hoverCheckResult !== $e89fe1f53dad77d7$var$SILENT) {
                out.target = el;
                break;
            }
        }
    }
}
function $e89fe1f53dad77d7$var$isOutsideBoundary(handlerInstance, x, y) {
    var painter = handlerInstance.painter;
    return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
}
var $e89fe1f53dad77d7$export$2e2bcd8739ae039 = $e89fe1f53dad77d7$var$Handler;



var $33b198fcd268be25$var$DEFAULT_MIN_MERGE = 32;
var $33b198fcd268be25$var$DEFAULT_MIN_GALLOPING = 7;
function $33b198fcd268be25$var$minRunLength(n) {
    var r = 0;
    while(n >= $33b198fcd268be25$var$DEFAULT_MIN_MERGE){
        r |= n & 1;
        n >>= 1;
    }
    return n + r;
}
function $33b198fcd268be25$var$makeAscendingRun(array, lo, hi, compare) {
    var runHi = lo + 1;
    if (runHi === hi) return 1;
    if (compare(array[runHi++], array[lo]) < 0) {
        while(runHi < hi && compare(array[runHi], array[runHi - 1]) < 0)runHi++;
        $33b198fcd268be25$var$reverseRun(array, lo, runHi);
    } else while(runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0)runHi++;
    return runHi - lo;
}
function $33b198fcd268be25$var$reverseRun(array, lo, hi) {
    hi--;
    while(lo < hi){
        var t = array[lo];
        array[lo++] = array[hi];
        array[hi--] = t;
    }
}
function $33b198fcd268be25$var$binaryInsertionSort(array, lo, hi, start, compare) {
    if (start === lo) start++;
    for(; start < hi; start++){
        var pivot = array[start];
        var left = lo;
        var right = start;
        var mid;
        while(left < right){
            mid = left + right >>> 1;
            if (compare(pivot, array[mid]) < 0) right = mid;
            else left = mid + 1;
        }
        var n = start - left;
        switch(n){
            case 3:
                array[left + 3] = array[left + 2];
            case 2:
                array[left + 2] = array[left + 1];
            case 1:
                array[left + 1] = array[left];
                break;
            default:
                while(n > 0){
                    array[left + n] = array[left + n - 1];
                    n--;
                }
        }
        array[left] = pivot;
    }
}
function $33b198fcd268be25$var$gallopLeft(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) > 0) {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) > 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    } else {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) <= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) > 0) lastOffset = m + 1;
        else offset = m;
    }
    return offset;
}
function $33b198fcd268be25$var$gallopRight(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) < 0) {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) < 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    } else {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) >= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) < 0) offset = m;
        else lastOffset = m + 1;
    }
    return offset;
}
function $33b198fcd268be25$var$TimSort(array, compare) {
    var minGallop = $33b198fcd268be25$var$DEFAULT_MIN_GALLOPING;
    var runStart;
    var runLength;
    var stackSize = 0;
    var tmp = [];
    runStart = [];
    runLength = [];
    function pushRun(_runStart, _runLength) {
        runStart[stackSize] = _runStart;
        runLength[stackSize] = _runLength;
        stackSize += 1;
    }
    function mergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
                if (runLength[n - 1] < runLength[n + 1]) n--;
            } else if (runLength[n] > runLength[n + 1]) break;
            mergeAt(n);
        }
    }
    function forceMergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n > 0 && runLength[n - 1] < runLength[n + 1]) n--;
            mergeAt(n);
        }
    }
    function mergeAt(i) {
        var start1 = runStart[i];
        var length1 = runLength[i];
        var start2 = runStart[i + 1];
        var length2 = runLength[i + 1];
        runLength[i] = length1 + length2;
        if (i === stackSize - 3) {
            runStart[i + 1] = runStart[i + 2];
            runLength[i + 1] = runLength[i + 2];
        }
        stackSize--;
        var k = $33b198fcd268be25$var$gallopRight(array[start2], array, start1, length1, 0, compare);
        start1 += k;
        length1 -= k;
        if (length1 === 0) return;
        length2 = $33b198fcd268be25$var$gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
        if (length2 === 0) return;
        if (length1 <= length2) mergeLow(start1, length1, start2, length2);
        else mergeHigh(start1, length1, start2, length2);
    }
    function mergeLow(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length1; i++)tmp[i] = array[start1 + i];
        var cursor1 = 0;
        var cursor2 = start2;
        var dest = start1;
        array[dest++] = array[cursor2++];
        if (--length2 === 0) {
            for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
            return;
        }
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
            return;
        }
        var _minGallop = minGallop;
        var count1;
        var count2;
        var exit;
        while(true){
            count1 = 0;
            count2 = 0;
            exit = false;
            do if (compare(array[cursor2], tmp[cursor1]) < 0) {
                array[dest++] = array[cursor2++];
                count2++;
                count1 = 0;
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest++] = tmp[cursor1++];
                count1++;
                count2 = 0;
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = $33b198fcd268be25$var$gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
                if (count1 !== 0) {
                    for(i = 0; i < count1; i++)array[dest + i] = tmp[cursor1 + i];
                    dest += count1;
                    cursor1 += count1;
                    length1 -= count1;
                    if (length1 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = array[cursor2++];
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
                count2 = $33b198fcd268be25$var$gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
                if (count2 !== 0) {
                    for(i = 0; i < count2; i++)array[dest + i] = array[cursor2 + i];
                    dest += count2;
                    cursor2 += count2;
                    length2 -= count2;
                    if (length2 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = tmp[cursor1++];
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $33b198fcd268be25$var$DEFAULT_MIN_GALLOPING || count2 >= $33b198fcd268be25$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        minGallop < 1 && (minGallop = 1);
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
        } else if (length1 === 0) throw new Error();
        else for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
    }
    function mergeHigh(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length2; i++)tmp[i] = array[start2 + i];
        var cursor1 = start1 + length1 - 1;
        var cursor2 = length2 - 1;
        var dest = start2 + length2 - 1;
        var customCursor = 0;
        var customDest = 0;
        array[dest--] = array[cursor1--];
        if (--length1 === 0) {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
            return;
        }
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
            return;
        }
        var _minGallop = minGallop;
        while(true){
            var count1 = 0;
            var count2 = 0;
            var exit = false;
            do if (compare(tmp[cursor2], array[cursor1]) < 0) {
                array[dest--] = array[cursor1--];
                count1++;
                count2 = 0;
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest--] = tmp[cursor2--];
                count2++;
                count1 = 0;
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = length1 - $33b198fcd268be25$var$gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
                if (count1 !== 0) {
                    dest -= count1;
                    cursor1 -= count1;
                    length1 -= count1;
                    customDest = dest + 1;
                    customCursor = cursor1 + 1;
                    for(i = count1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                    if (length1 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = tmp[cursor2--];
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
                count2 = length2 - $33b198fcd268be25$var$gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
                if (count2 !== 0) {
                    dest -= count2;
                    cursor2 -= count2;
                    length2 -= count2;
                    customDest = dest + 1;
                    customCursor = cursor2 + 1;
                    for(i = 0; i < count2; i++)array[customDest + i] = tmp[customCursor + i];
                    if (length2 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = array[cursor1--];
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $33b198fcd268be25$var$DEFAULT_MIN_GALLOPING || count2 >= $33b198fcd268be25$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        if (minGallop < 1) minGallop = 1;
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
        } else if (length2 === 0) throw new Error();
        else {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
        }
    }
    return {
        mergeRuns: mergeRuns,
        forceMergeRuns: forceMergeRuns,
        pushRun: pushRun
    };
}
function $33b198fcd268be25$export$2e2bcd8739ae039(array, compare, lo, hi) {
    if (!lo) lo = 0;
    if (!hi) hi = array.length;
    var remaining = hi - lo;
    if (remaining < 2) return;
    var runLength = 0;
    if (remaining < $33b198fcd268be25$var$DEFAULT_MIN_MERGE) {
        runLength = $33b198fcd268be25$var$makeAscendingRun(array, lo, hi, compare);
        $33b198fcd268be25$var$binaryInsertionSort(array, lo, hi, lo + runLength, compare);
        return;
    }
    var ts = $33b198fcd268be25$var$TimSort(array, compare);
    var minRun = $33b198fcd268be25$var$minRunLength(remaining);
    do {
        runLength = $33b198fcd268be25$var$makeAscendingRun(array, lo, hi, compare);
        if (runLength < minRun) {
            var force = remaining;
            if (force > minRun) force = minRun;
            $33b198fcd268be25$var$binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
            runLength = force;
        }
        ts.pushRun(lo, runLength);
        ts.mergeRuns();
        remaining -= runLength;
        lo += runLength;
    }while (remaining !== 0);
    ts.forceMergeRuns();
}


var $66869c587f14f122$export$a7b6db622c6c7dbd = 1;
var $66869c587f14f122$export$ada8b2beb3d76671 = 2;
var $66869c587f14f122$export$f75fe89a33ebe115 = 4;


var $6f9d2ba1879ab334$var$invalidZErrorLogged = false;
function $6f9d2ba1879ab334$var$logInvalidZError() {
    if ($6f9d2ba1879ab334$var$invalidZErrorLogged) return;
    $6f9d2ba1879ab334$var$invalidZErrorLogged = true;
    console.warn('z / z2 / zlevel of displayable is invalid, which may cause unexpected errors');
}
function $6f9d2ba1879ab334$var$shapeCompareFunc(a, b) {
    if (a.zlevel === b.zlevel) {
        if (a.z === b.z) return a.z2 - b.z2;
        return a.z - b.z;
    }
    return a.zlevel - b.zlevel;
}
var $6f9d2ba1879ab334$var$Storage = function() {
    function Storage() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        this.displayableSortFunc = $6f9d2ba1879ab334$var$shapeCompareFunc;
    }
    Storage.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._roots.length; i++)this._roots[i].traverse(cb, context);
    };
    Storage.prototype.getDisplayList = function(update, includeIgnore) {
        includeIgnore = includeIgnore || false;
        var displayList = this._displayList;
        if (update || !displayList.length) this.updateDisplayList(includeIgnore);
        return displayList;
    };
    Storage.prototype.updateDisplayList = function(includeIgnore) {
        this._displayListLen = 0;
        var roots = this._roots;
        var displayList = this._displayList;
        for(var i = 0, len = roots.length; i < len; i++)this._updateAndAddDisplayable(roots[i], null, includeIgnore);
        displayList.length = this._displayListLen;
        (0, $33b198fcd268be25$export$2e2bcd8739ae039)(displayList, $6f9d2ba1879ab334$var$shapeCompareFunc);
    };
    Storage.prototype._updateAndAddDisplayable = function(el, parentClipPaths, includeIgnore) {
        if (el.ignore && !includeIgnore) return;
        el.beforeUpdate();
        el.update();
        el.afterUpdate();
        var userSetClipPath = el.getClipPath();
        var parentHasClipPaths = parentClipPaths && parentClipPaths.length;
        var clipPathIdx = 0;
        var thisClipPaths = el.__clipPaths;
        if (!el.ignoreClip && (parentHasClipPaths || userSetClipPath)) {
            if (!thisClipPaths) thisClipPaths = el.__clipPaths = [];
            if (parentHasClipPaths) for(var idx = 0; idx < parentClipPaths.length; idx++)thisClipPaths[clipPathIdx++] = parentClipPaths[idx];
            var currentClipPath = userSetClipPath;
            var parentClipPath = el;
            while(currentClipPath){
                currentClipPath.parent = parentClipPath;
                currentClipPath.updateTransform();
                thisClipPaths[clipPathIdx++] = currentClipPath;
                parentClipPath = currentClipPath;
                currentClipPath = currentClipPath.getClipPath();
            }
        }
        if (thisClipPaths) thisClipPaths.length = clipPathIdx;
        if (el.childrenRef) {
            var children = el.childrenRef();
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (el.__dirty) child.__dirty |= (0, $66869c587f14f122$export$a7b6db622c6c7dbd);
                this._updateAndAddDisplayable(child, thisClipPaths, includeIgnore);
            }
            el.__dirty = 0;
        } else {
            var disp = el;
            if (isNaN(disp.z)) {
                $6f9d2ba1879ab334$var$logInvalidZError();
                disp.z = 0;
            }
            if (isNaN(disp.z2)) {
                $6f9d2ba1879ab334$var$logInvalidZError();
                disp.z2 = 0;
            }
            if (isNaN(disp.zlevel)) {
                $6f9d2ba1879ab334$var$logInvalidZError();
                disp.zlevel = 0;
            }
            this._displayList[this._displayListLen++] = disp;
        }
        var decalEl = el.getDecalElement && el.getDecalElement();
        if (decalEl) this._updateAndAddDisplayable(decalEl, thisClipPaths, includeIgnore);
        var textGuide = el.getTextGuideLine();
        if (textGuide) this._updateAndAddDisplayable(textGuide, thisClipPaths, includeIgnore);
        var textEl = el.getTextContent();
        if (textEl) this._updateAndAddDisplayable(textEl, thisClipPaths, includeIgnore);
    };
    Storage.prototype.addRoot = function(el) {
        if (el.__zr && el.__zr.storage === this) return;
        this._roots.push(el);
    };
    Storage.prototype.delRoot = function(el) {
        if (el instanceof Array) {
            for(var i = 0, l = el.length; i < l; i++)this.delRoot(el[i]);
            return;
        }
        var idx = $f16f2994a32ad273$export$305f7d4e9d4624f2(this._roots, el);
        if (idx >= 0) this._roots.splice(idx, 1);
    };
    Storage.prototype.delAllRoots = function() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        return;
    };
    Storage.prototype.getRoots = function() {
        return this._roots;
    };
    Storage.prototype.dispose = function() {
        this._displayList = null;
        this._roots = null;
    };
    return Storage;
}();
var $6f9d2ba1879ab334$export$2e2bcd8739ae039 = $6f9d2ba1879ab334$var$Storage;





var $0b01569dabcb06cc$var$requestAnimationFrame;
$0b01569dabcb06cc$var$requestAnimationFrame = (0, $6d0397515b55cc48$export$2e2bcd8739ae039).hasGlobalWindow && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function(func) {
    return setTimeout(func, 16);
};
var $0b01569dabcb06cc$export$2e2bcd8739ae039 = $0b01569dabcb06cc$var$requestAnimationFrame;


var $9cb73ed1c1ae6407$var$easingFuncs = {
    linear: function linear(k) {
        return k;
    },
    quadraticIn: function quadraticIn(k) {
        return k * k;
    },
    quadraticOut: function quadraticOut(k) {
        return k * (2 - k);
    },
    quadraticInOut: function quadraticInOut(k) {
        if ((k *= 2) < 1) return 0.5 * k * k;
        return -0.5 * (--k * (k - 2) - 1);
    },
    cubicIn: function cubicIn(k) {
        return k * k * k;
    },
    cubicOut: function cubicOut(k) {
        return --k * k * k + 1;
    },
    cubicInOut: function cubicInOut(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k;
        return 0.5 * ((k -= 2) * k * k + 2);
    },
    quarticIn: function quarticIn(k) {
        return k * k * k * k;
    },
    quarticOut: function quarticOut(k) {
        return 1 - --k * k * k * k;
    },
    quarticInOut: function quarticInOut(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k;
        return -0.5 * ((k -= 2) * k * k * k - 2);
    },
    quinticIn: function quinticIn(k) {
        return k * k * k * k * k;
    },
    quinticOut: function quinticOut(k) {
        return --k * k * k * k * k + 1;
    },
    quinticInOut: function quinticInOut(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k * k;
        return 0.5 * ((k -= 2) * k * k * k * k + 2);
    },
    sinusoidalIn: function sinusoidalIn(k) {
        return 1 - Math.cos(k * Math.PI / 2);
    },
    sinusoidalOut: function sinusoidalOut(k) {
        return Math.sin(k * Math.PI / 2);
    },
    sinusoidalInOut: function sinusoidalInOut(k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    },
    exponentialIn: function exponentialIn(k) {
        return k === 0 ? 0 : Math.pow(1024, k - 1);
    },
    exponentialOut: function exponentialOut(k) {
        return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
    },
    exponentialInOut: function exponentialInOut(k) {
        if (k === 0) return 0;
        if (k === 1) return 1;
        if ((k *= 2) < 1) return 0.5 * Math.pow(1024, k - 1);
        return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
    },
    circularIn: function circularIn(k) {
        return 1 - Math.sqrt(1 - k * k);
    },
    circularOut: function circularOut(k) {
        return Math.sqrt(1 - --k * k);
    },
    circularInOut: function circularInOut(k) {
        if ((k *= 2) < 1) return -0.5 * (Math.sqrt(1 - k * k) - 1);
        return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
    },
    elasticIn: function elasticIn(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
    },
    elasticOut: function elasticOut(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
    },
    elasticInOut: function elasticInOut(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        if ((k *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
        return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
    },
    backIn: function backIn(k) {
        var s = 1.70158;
        return k * k * ((s + 1) * k - s);
    },
    backOut: function backOut(k) {
        var s = 1.70158;
        return --k * k * ((s + 1) * k + s) + 1;
    },
    backInOut: function backInOut(k) {
        var s = 2.5949095;
        if ((k *= 2) < 1) return 0.5 * (k * k * ((s + 1) * k - s));
        return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
    },
    bounceIn: function bounceIn(k) {
        return 1 - $9cb73ed1c1ae6407$var$easingFuncs.bounceOut(1 - k);
    },
    bounceOut: function bounceOut(k) {
        if (k < 1 / 2.75) return 7.5625 * k * k;
        else if (k < 2 / 2.75) return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
        else if (k < 2.5 / 2.75) return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
        else return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    },
    bounceInOut: function bounceInOut(k) {
        if (k < 0.5) return $9cb73ed1c1ae6407$var$easingFuncs.bounceIn(k * 2) * 0.5;
        return $9cb73ed1c1ae6407$var$easingFuncs.bounceOut(k * 2 - 1) * 0.5 + 0.5;
    }
};
var $9cb73ed1c1ae6407$export$2e2bcd8739ae039 = $9cb73ed1c1ae6407$var$easingFuncs;




var $893961281ad1f27f$var$mathPow = Math.pow;
var $893961281ad1f27f$var$mathSqrt = Math.sqrt;
var $893961281ad1f27f$var$EPSILON = 1e-8;
var $893961281ad1f27f$var$EPSILON_NUMERIC = 1e-4;
var $893961281ad1f27f$var$THREE_SQRT = $893961281ad1f27f$var$mathSqrt(3);
var $893961281ad1f27f$var$ONE_THIRD = 1 / 3;
var $893961281ad1f27f$var$_v0 = (0, $f79ec7ea1294b339$export$185802fd694ee1f5)();
var $893961281ad1f27f$var$_v1 = (0, $f79ec7ea1294b339$export$185802fd694ee1f5)();
var $893961281ad1f27f$var$_v2 = (0, $f79ec7ea1294b339$export$185802fd694ee1f5)();
function $893961281ad1f27f$var$isAroundZero(val) {
    return val > -$893961281ad1f27f$var$EPSILON && val < $893961281ad1f27f$var$EPSILON;
}
function $893961281ad1f27f$var$isNotAroundZero(val) {
    return val > $893961281ad1f27f$var$EPSILON || val < -$893961281ad1f27f$var$EPSILON;
}
function $893961281ad1f27f$export$547c21de482bbcb2(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
}
function $893961281ad1f27f$export$55fce925c60b6271(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
}
function $893961281ad1f27f$export$ca5d13faa10b167e(p0, p1, p2, p3, val, roots) {
    var a = p3 + 3 * (p1 - p2) - p0;
    var b = 3 * (p2 - p1 * 2 + p0);
    var c = 3 * (p1 - p0);
    var d = p0 - val;
    var A = b * b - 3 * a * c;
    var B = b * c - 9 * a * d;
    var C = c * c - 3 * b * d;
    var n = 0;
    if ($893961281ad1f27f$var$isAroundZero(A) && $893961281ad1f27f$var$isAroundZero(B)) {
        if ($893961281ad1f27f$var$isAroundZero(b)) roots[0] = 0;
        else {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = B * B - 4 * A * C;
        if ($893961281ad1f27f$var$isAroundZero(disc)) {
            var K = B / A;
            var t1 = -b / a + K;
            var t2 = -K / 2;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        } else if (disc > 0) {
            var discSqrt = $893961281ad1f27f$var$mathSqrt(disc);
            var Y1 = A * b + 1.5 * a * (-B + discSqrt);
            var Y2 = A * b + 1.5 * a * (-B - discSqrt);
            if (Y1 < 0) Y1 = -$893961281ad1f27f$var$mathPow(-Y1, $893961281ad1f27f$var$ONE_THIRD);
            else Y1 = $893961281ad1f27f$var$mathPow(Y1, $893961281ad1f27f$var$ONE_THIRD);
            if (Y2 < 0) Y2 = -$893961281ad1f27f$var$mathPow(-Y2, $893961281ad1f27f$var$ONE_THIRD);
            else Y2 = $893961281ad1f27f$var$mathPow(Y2, $893961281ad1f27f$var$ONE_THIRD);
            var t1 = (-b - (Y1 + Y2)) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else {
            var T = (2 * A * b - 3 * a * B) / (2 * $893961281ad1f27f$var$mathSqrt(A * A * A));
            var theta = Math.acos(T) / 3;
            var ASqrt = $893961281ad1f27f$var$mathSqrt(A);
            var tmp = Math.cos(theta);
            var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
            var t2 = (-b + ASqrt * (tmp + $893961281ad1f27f$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            var t3 = (-b + ASqrt * (tmp - $893961281ad1f27f$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            if (t3 >= 0 && t3 <= 1) roots[n++] = t3;
        }
    }
    return n;
}
function $893961281ad1f27f$export$df1a172f100d0457(p0, p1, p2, p3, extrema) {
    var b = 6 * p2 - 12 * p1 + 6 * p0;
    var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
    var c = 3 * p1 - 3 * p0;
    var n = 0;
    if ($893961281ad1f27f$var$isAroundZero(a)) {
        if ($893961281ad1f27f$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($893961281ad1f27f$var$isAroundZero(disc)) extrema[0] = -b / (2 * a);
        else if (disc > 0) {
            var discSqrt = $893961281ad1f27f$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
            if (t2 >= 0 && t2 <= 1) extrema[n++] = t2;
        }
    }
    return n;
}
function $893961281ad1f27f$export$a2ee23a0567039da(p0, p1, p2, p3, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p23 = (p3 - p2) * t + p2;
    var p012 = (p12 - p01) * t + p01;
    var p123 = (p23 - p12) * t + p12;
    var p0123 = (p123 - p012) * t + p012;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p0123;
    out[4] = p0123;
    out[5] = p123;
    out[6] = p23;
    out[7] = p3;
}
function $893961281ad1f27f$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    var prev;
    var next;
    var d1;
    var d2;
    $893961281ad1f27f$var$_v0[0] = x;
    $893961281ad1f27f$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $893961281ad1f27f$var$_v1[0] = $893961281ad1f27f$export$547c21de482bbcb2(x0, x1, x2, x3, _t);
        $893961281ad1f27f$var$_v1[1] = $893961281ad1f27f$export$547c21de482bbcb2(y0, y1, y2, y3, _t);
        d1 = (0, $f79ec7ea1294b339$export$c68db45a034c13b0)($893961281ad1f27f$var$_v0, $893961281ad1f27f$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $893961281ad1f27f$var$EPSILON_NUMERIC) break;
        prev = t - interval;
        next = t + interval;
        $893961281ad1f27f$var$_v1[0] = $893961281ad1f27f$export$547c21de482bbcb2(x0, x1, x2, x3, prev);
        $893961281ad1f27f$var$_v1[1] = $893961281ad1f27f$export$547c21de482bbcb2(y0, y1, y2, y3, prev);
        d1 = (0, $f79ec7ea1294b339$export$c68db45a034c13b0)($893961281ad1f27f$var$_v1, $893961281ad1f27f$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $893961281ad1f27f$var$_v2[0] = $893961281ad1f27f$export$547c21de482bbcb2(x0, x1, x2, x3, next);
            $893961281ad1f27f$var$_v2[1] = $893961281ad1f27f$export$547c21de482bbcb2(y0, y1, y2, y3, next);
            d2 = (0, $f79ec7ea1294b339$export$c68db45a034c13b0)($893961281ad1f27f$var$_v2, $893961281ad1f27f$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $893961281ad1f27f$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        out[1] = $893961281ad1f27f$export$547c21de482bbcb2(y0, y1, y2, y3, t);
    }
    return $893961281ad1f27f$var$mathSqrt(d);
}
function $893961281ad1f27f$export$af1875d576f60d7c(x0, y0, x1, y1, x2, y2, x3, y3, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $893961281ad1f27f$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        var y = $893961281ad1f27f$export$547c21de482bbcb2(y0, y1, y2, y3, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}
function $893961281ad1f27f$export$af17094a950f5073(p0, p1, p2, t) {
    var onet = 1 - t;
    return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
function $893961281ad1f27f$export$7e161e77e6fff8cb(p0, p1, p2, t) {
    return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
function $893961281ad1f27f$export$fd895ac7ee764967(p0, p1, p2, val, roots) {
    var a = p0 - 2 * p1 + p2;
    var b = 2 * (p1 - p0);
    var c = p0 - val;
    var n = 0;
    if ($893961281ad1f27f$var$isAroundZero(a)) {
        if ($893961281ad1f27f$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($893961281ad1f27f$var$isAroundZero(disc)) {
            var t1 = -b / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else if (disc > 0) {
            var discSqrt = $893961281ad1f27f$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        }
    }
    return n;
}
function $893961281ad1f27f$export$752e1f8c6e7f7e11(p0, p1, p2) {
    var divider = p0 + p2 - 2 * p1;
    if (divider === 0) return 0.5;
    else return (p0 - p1) / divider;
}
function $893961281ad1f27f$export$117c659e21a7a060(p0, p1, p2, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p012 = (p12 - p01) * t + p01;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p012;
    out[4] = p12;
    out[5] = p2;
}
function $893961281ad1f27f$export$81915a594fe10dee(x0, y0, x1, y1, x2, y2, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    $893961281ad1f27f$var$_v0[0] = x;
    $893961281ad1f27f$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $893961281ad1f27f$var$_v1[0] = $893961281ad1f27f$export$af17094a950f5073(x0, x1, x2, _t);
        $893961281ad1f27f$var$_v1[1] = $893961281ad1f27f$export$af17094a950f5073(y0, y1, y2, _t);
        var d1 = (0, $f79ec7ea1294b339$export$c68db45a034c13b0)($893961281ad1f27f$var$_v0, $893961281ad1f27f$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $893961281ad1f27f$var$EPSILON_NUMERIC) break;
        var prev = t - interval;
        var next = t + interval;
        $893961281ad1f27f$var$_v1[0] = $893961281ad1f27f$export$af17094a950f5073(x0, x1, x2, prev);
        $893961281ad1f27f$var$_v1[1] = $893961281ad1f27f$export$af17094a950f5073(y0, y1, y2, prev);
        var d1 = (0, $f79ec7ea1294b339$export$c68db45a034c13b0)($893961281ad1f27f$var$_v1, $893961281ad1f27f$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $893961281ad1f27f$var$_v2[0] = $893961281ad1f27f$export$af17094a950f5073(x0, x1, x2, next);
            $893961281ad1f27f$var$_v2[1] = $893961281ad1f27f$export$af17094a950f5073(y0, y1, y2, next);
            var d2 = (0, $f79ec7ea1294b339$export$c68db45a034c13b0)($893961281ad1f27f$var$_v2, $893961281ad1f27f$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $893961281ad1f27f$export$af17094a950f5073(x0, x1, x2, t);
        out[1] = $893961281ad1f27f$export$af17094a950f5073(y0, y1, y2, t);
    }
    return $893961281ad1f27f$var$mathSqrt(d);
}
function $893961281ad1f27f$export$8a68adee46f3cf55(x0, y0, x1, y1, x2, y2, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $893961281ad1f27f$export$af17094a950f5073(x0, x1, x2, t);
        var y = $893961281ad1f27f$export$af17094a950f5073(y0, y1, y2, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}



var $335ff30ca4c291b4$var$regexp = /cubic-bezier\(([0-9,\.e ]+)\)/;
function $335ff30ca4c291b4$export$ec0863d806fd857e(cubicEasingStr) {
    var cubic = cubicEasingStr && $335ff30ca4c291b4$var$regexp.exec(cubicEasingStr);
    if (cubic) {
        var points = cubic[1].split(',');
        var a_1 = +(0, $f16f2994a32ad273$export$87c2784dc9fc4ab)(points[0]);
        var b_1 = +(0, $f16f2994a32ad273$export$87c2784dc9fc4ab)(points[1]);
        var c_1 = +(0, $f16f2994a32ad273$export$87c2784dc9fc4ab)(points[2]);
        var d_1 = +(0, $f16f2994a32ad273$export$87c2784dc9fc4ab)(points[3]);
        if (isNaN(a_1 + b_1 + c_1 + d_1)) return;
        var roots_1 = [];
        return function(p) {
            return p <= 0 ? 0 : p >= 1 ? 1 : (0, $893961281ad1f27f$export$ca5d13faa10b167e)(0, a_1, c_1, 1, p, roots_1) && (0, $893961281ad1f27f$export$547c21de482bbcb2)(0, b_1, d_1, 1, roots_1[0]);
        };
    }
}


var $19bf4030be565b69$var$Clip = function() {
    function Clip(opts) {
        this._inited = false;
        this._startTime = 0;
        this._pausedTime = 0;
        this._paused = false;
        this._life = opts.life || 1000;
        this._delay = opts.delay || 0;
        this.loop = opts.loop || false;
        this.onframe = opts.onframe || (0, $f16f2994a32ad273$export$8793edee2d425525);
        this.ondestroy = opts.ondestroy || (0, $f16f2994a32ad273$export$8793edee2d425525);
        this.onrestart = opts.onrestart || (0, $f16f2994a32ad273$export$8793edee2d425525);
        opts.easing && this.setEasing(opts.easing);
    }
    Clip.prototype.step = function(globalTime, deltaTime) {
        if (!this._inited) {
            this._startTime = globalTime + this._delay;
            this._inited = true;
        }
        if (this._paused) {
            this._pausedTime += deltaTime;
            return;
        }
        var life = this._life;
        var elapsedTime = globalTime - this._startTime - this._pausedTime;
        var percent = elapsedTime / life;
        if (percent < 0) percent = 0;
        percent = Math.min(percent, 1);
        var easingFunc = this.easingFunc;
        var schedule = easingFunc ? easingFunc(percent) : percent;
        this.onframe(schedule);
        if (percent === 1) {
            if (this.loop) {
                var remainder = elapsedTime % life;
                this._startTime = globalTime - remainder;
                this._pausedTime = 0;
                this.onrestart();
            } else return true;
        }
        return false;
    };
    Clip.prototype.pause = function() {
        this._paused = true;
    };
    Clip.prototype.resume = function() {
        this._paused = false;
    };
    Clip.prototype.setEasing = function(easing) {
        this.easing = easing;
        this.easingFunc = (0, $f16f2994a32ad273$export$f6e2535fb5126e54)(easing) ? easing : (0, $9cb73ed1c1ae6407$export$2e2bcd8739ae039)[easing] || (0, $335ff30ca4c291b4$export$ec0863d806fd857e)(easing);
    };
    return Clip;
}();
var $19bf4030be565b69$export$2e2bcd8739ae039 = $19bf4030be565b69$var$Clip;


var $5673a7dd695e5835$export$3bb977b3ba9d3b59 = function() {
    function Entry(val) {
        this.value = val;
    }
    return Entry;
}();
var $5673a7dd695e5835$export$f0ef28713f767754 = function() {
    function LinkedList() {
        this._len = 0;
    }
    LinkedList.prototype.insert = function(val) {
        var entry = new $5673a7dd695e5835$export$3bb977b3ba9d3b59(val);
        this.insertEntry(entry);
        return entry;
    };
    LinkedList.prototype.insertEntry = function(entry) {
        if (!this.head) this.head = this.tail = entry;
        else {
            this.tail.next = entry;
            entry.prev = this.tail;
            entry.next = null;
            this.tail = entry;
        }
        this._len++;
    };
    LinkedList.prototype.remove = function(entry) {
        var prev = entry.prev;
        var next = entry.next;
        if (prev) prev.next = next;
        else this.head = next;
        if (next) next.prev = prev;
        else this.tail = prev;
        entry.next = entry.prev = null;
        this._len--;
    };
    LinkedList.prototype.len = function() {
        return this._len;
    };
    LinkedList.prototype.clear = function() {
        this.head = this.tail = null;
        this._len = 0;
    };
    return LinkedList;
}();
var $5673a7dd695e5835$var$LRU = function() {
    function LRU(maxSize) {
        this._list = new $5673a7dd695e5835$export$f0ef28713f767754();
        this._maxSize = 10;
        this._map = {};
        this._maxSize = maxSize;
    }
    LRU.prototype.put = function(key, value) {
        var list = this._list;
        var map = this._map;
        var removed = null;
        if (map[key] == null) {
            var len = list.len();
            var entry = this._lastRemovedEntry;
            if (len >= this._maxSize && len > 0) {
                var leastUsedEntry = list.head;
                list.remove(leastUsedEntry);
                delete map[leastUsedEntry.key];
                removed = leastUsedEntry.value;
                this._lastRemovedEntry = leastUsedEntry;
            }
            if (entry) entry.value = value;
            else entry = new $5673a7dd695e5835$export$3bb977b3ba9d3b59(value);
            entry.key = key;
            list.insertEntry(entry);
            map[key] = entry;
        }
        return removed;
    };
    LRU.prototype.get = function(key) {
        var entry = this._map[key];
        var list = this._list;
        if (entry != null) {
            if (entry !== list.tail) {
                list.remove(entry);
                list.insertEntry(entry);
            }
            return entry.value;
        }
    };
    LRU.prototype.clear = function() {
        this._list.clear();
        this._map = {};
    };
    LRU.prototype.len = function() {
        return this._list.len();
    };
    return LRU;
}();
var $5673a7dd695e5835$export$2e2bcd8739ae039 = $5673a7dd695e5835$var$LRU;



var $83e50b4ee4d3c357$var$kCSSColorTable = {
    'transparent': [
        0,
        0,
        0,
        0
    ],
    'aliceblue': [
        240,
        248,
        255,
        1
    ],
    'antiquewhite': [
        250,
        235,
        215,
        1
    ],
    'aqua': [
        0,
        255,
        255,
        1
    ],
    'aquamarine': [
        127,
        255,
        212,
        1
    ],
    'azure': [
        240,
        255,
        255,
        1
    ],
    'beige': [
        245,
        245,
        220,
        1
    ],
    'bisque': [
        255,
        228,
        196,
        1
    ],
    'black': [
        0,
        0,
        0,
        1
    ],
    'blanchedalmond': [
        255,
        235,
        205,
        1
    ],
    'blue': [
        0,
        0,
        255,
        1
    ],
    'blueviolet': [
        138,
        43,
        226,
        1
    ],
    'brown': [
        165,
        42,
        42,
        1
    ],
    'burlywood': [
        222,
        184,
        135,
        1
    ],
    'cadetblue': [
        95,
        158,
        160,
        1
    ],
    'chartreuse': [
        127,
        255,
        0,
        1
    ],
    'chocolate': [
        210,
        105,
        30,
        1
    ],
    'coral': [
        255,
        127,
        80,
        1
    ],
    'cornflowerblue': [
        100,
        149,
        237,
        1
    ],
    'cornsilk': [
        255,
        248,
        220,
        1
    ],
    'crimson': [
        220,
        20,
        60,
        1
    ],
    'cyan': [
        0,
        255,
        255,
        1
    ],
    'darkblue': [
        0,
        0,
        139,
        1
    ],
    'darkcyan': [
        0,
        139,
        139,
        1
    ],
    'darkgoldenrod': [
        184,
        134,
        11,
        1
    ],
    'darkgray': [
        169,
        169,
        169,
        1
    ],
    'darkgreen': [
        0,
        100,
        0,
        1
    ],
    'darkgrey': [
        169,
        169,
        169,
        1
    ],
    'darkkhaki': [
        189,
        183,
        107,
        1
    ],
    'darkmagenta': [
        139,
        0,
        139,
        1
    ],
    'darkolivegreen': [
        85,
        107,
        47,
        1
    ],
    'darkorange': [
        255,
        140,
        0,
        1
    ],
    'darkorchid': [
        153,
        50,
        204,
        1
    ],
    'darkred': [
        139,
        0,
        0,
        1
    ],
    'darksalmon': [
        233,
        150,
        122,
        1
    ],
    'darkseagreen': [
        143,
        188,
        143,
        1
    ],
    'darkslateblue': [
        72,
        61,
        139,
        1
    ],
    'darkslategray': [
        47,
        79,
        79,
        1
    ],
    'darkslategrey': [
        47,
        79,
        79,
        1
    ],
    'darkturquoise': [
        0,
        206,
        209,
        1
    ],
    'darkviolet': [
        148,
        0,
        211,
        1
    ],
    'deeppink': [
        255,
        20,
        147,
        1
    ],
    'deepskyblue': [
        0,
        191,
        255,
        1
    ],
    'dimgray': [
        105,
        105,
        105,
        1
    ],
    'dimgrey': [
        105,
        105,
        105,
        1
    ],
    'dodgerblue': [
        30,
        144,
        255,
        1
    ],
    'firebrick': [
        178,
        34,
        34,
        1
    ],
    'floralwhite': [
        255,
        250,
        240,
        1
    ],
    'forestgreen': [
        34,
        139,
        34,
        1
    ],
    'fuchsia': [
        255,
        0,
        255,
        1
    ],
    'gainsboro': [
        220,
        220,
        220,
        1
    ],
    'ghostwhite': [
        248,
        248,
        255,
        1
    ],
    'gold': [
        255,
        215,
        0,
        1
    ],
    'goldenrod': [
        218,
        165,
        32,
        1
    ],
    'gray': [
        128,
        128,
        128,
        1
    ],
    'green': [
        0,
        128,
        0,
        1
    ],
    'greenyellow': [
        173,
        255,
        47,
        1
    ],
    'grey': [
        128,
        128,
        128,
        1
    ],
    'honeydew': [
        240,
        255,
        240,
        1
    ],
    'hotpink': [
        255,
        105,
        180,
        1
    ],
    'indianred': [
        205,
        92,
        92,
        1
    ],
    'indigo': [
        75,
        0,
        130,
        1
    ],
    'ivory': [
        255,
        255,
        240,
        1
    ],
    'khaki': [
        240,
        230,
        140,
        1
    ],
    'lavender': [
        230,
        230,
        250,
        1
    ],
    'lavenderblush': [
        255,
        240,
        245,
        1
    ],
    'lawngreen': [
        124,
        252,
        0,
        1
    ],
    'lemonchiffon': [
        255,
        250,
        205,
        1
    ],
    'lightblue': [
        173,
        216,
        230,
        1
    ],
    'lightcoral': [
        240,
        128,
        128,
        1
    ],
    'lightcyan': [
        224,
        255,
        255,
        1
    ],
    'lightgoldenrodyellow': [
        250,
        250,
        210,
        1
    ],
    'lightgray': [
        211,
        211,
        211,
        1
    ],
    'lightgreen': [
        144,
        238,
        144,
        1
    ],
    'lightgrey': [
        211,
        211,
        211,
        1
    ],
    'lightpink': [
        255,
        182,
        193,
        1
    ],
    'lightsalmon': [
        255,
        160,
        122,
        1
    ],
    'lightseagreen': [
        32,
        178,
        170,
        1
    ],
    'lightskyblue': [
        135,
        206,
        250,
        1
    ],
    'lightslategray': [
        119,
        136,
        153,
        1
    ],
    'lightslategrey': [
        119,
        136,
        153,
        1
    ],
    'lightsteelblue': [
        176,
        196,
        222,
        1
    ],
    'lightyellow': [
        255,
        255,
        224,
        1
    ],
    'lime': [
        0,
        255,
        0,
        1
    ],
    'limegreen': [
        50,
        205,
        50,
        1
    ],
    'linen': [
        250,
        240,
        230,
        1
    ],
    'magenta': [
        255,
        0,
        255,
        1
    ],
    'maroon': [
        128,
        0,
        0,
        1
    ],
    'mediumaquamarine': [
        102,
        205,
        170,
        1
    ],
    'mediumblue': [
        0,
        0,
        205,
        1
    ],
    'mediumorchid': [
        186,
        85,
        211,
        1
    ],
    'mediumpurple': [
        147,
        112,
        219,
        1
    ],
    'mediumseagreen': [
        60,
        179,
        113,
        1
    ],
    'mediumslateblue': [
        123,
        104,
        238,
        1
    ],
    'mediumspringgreen': [
        0,
        250,
        154,
        1
    ],
    'mediumturquoise': [
        72,
        209,
        204,
        1
    ],
    'mediumvioletred': [
        199,
        21,
        133,
        1
    ],
    'midnightblue': [
        25,
        25,
        112,
        1
    ],
    'mintcream': [
        245,
        255,
        250,
        1
    ],
    'mistyrose': [
        255,
        228,
        225,
        1
    ],
    'moccasin': [
        255,
        228,
        181,
        1
    ],
    'navajowhite': [
        255,
        222,
        173,
        1
    ],
    'navy': [
        0,
        0,
        128,
        1
    ],
    'oldlace': [
        253,
        245,
        230,
        1
    ],
    'olive': [
        128,
        128,
        0,
        1
    ],
    'olivedrab': [
        107,
        142,
        35,
        1
    ],
    'orange': [
        255,
        165,
        0,
        1
    ],
    'orangered': [
        255,
        69,
        0,
        1
    ],
    'orchid': [
        218,
        112,
        214,
        1
    ],
    'palegoldenrod': [
        238,
        232,
        170,
        1
    ],
    'palegreen': [
        152,
        251,
        152,
        1
    ],
    'paleturquoise': [
        175,
        238,
        238,
        1
    ],
    'palevioletred': [
        219,
        112,
        147,
        1
    ],
    'papayawhip': [
        255,
        239,
        213,
        1
    ],
    'peachpuff': [
        255,
        218,
        185,
        1
    ],
    'peru': [
        205,
        133,
        63,
        1
    ],
    'pink': [
        255,
        192,
        203,
        1
    ],
    'plum': [
        221,
        160,
        221,
        1
    ],
    'powderblue': [
        176,
        224,
        230,
        1
    ],
    'purple': [
        128,
        0,
        128,
        1
    ],
    'red': [
        255,
        0,
        0,
        1
    ],
    'rosybrown': [
        188,
        143,
        143,
        1
    ],
    'royalblue': [
        65,
        105,
        225,
        1
    ],
    'saddlebrown': [
        139,
        69,
        19,
        1
    ],
    'salmon': [
        250,
        128,
        114,
        1
    ],
    'sandybrown': [
        244,
        164,
        96,
        1
    ],
    'seagreen': [
        46,
        139,
        87,
        1
    ],
    'seashell': [
        255,
        245,
        238,
        1
    ],
    'sienna': [
        160,
        82,
        45,
        1
    ],
    'silver': [
        192,
        192,
        192,
        1
    ],
    'skyblue': [
        135,
        206,
        235,
        1
    ],
    'slateblue': [
        106,
        90,
        205,
        1
    ],
    'slategray': [
        112,
        128,
        144,
        1
    ],
    'slategrey': [
        112,
        128,
        144,
        1
    ],
    'snow': [
        255,
        250,
        250,
        1
    ],
    'springgreen': [
        0,
        255,
        127,
        1
    ],
    'steelblue': [
        70,
        130,
        180,
        1
    ],
    'tan': [
        210,
        180,
        140,
        1
    ],
    'teal': [
        0,
        128,
        128,
        1
    ],
    'thistle': [
        216,
        191,
        216,
        1
    ],
    'tomato': [
        255,
        99,
        71,
        1
    ],
    'turquoise': [
        64,
        224,
        208,
        1
    ],
    'violet': [
        238,
        130,
        238,
        1
    ],
    'wheat': [
        245,
        222,
        179,
        1
    ],
    'white': [
        255,
        255,
        255,
        1
    ],
    'whitesmoke': [
        245,
        245,
        245,
        1
    ],
    'yellow': [
        255,
        255,
        0,
        1
    ],
    'yellowgreen': [
        154,
        205,
        50,
        1
    ]
};
function $83e50b4ee4d3c357$var$clampCssByte(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 255 ? 255 : i;
}
function $83e50b4ee4d3c357$var$clampCssAngle(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 360 ? 360 : i;
}
function $83e50b4ee4d3c357$var$clampCssFloat(f) {
    return f < 0 ? 0 : f > 1 ? 1 : f;
}
function $83e50b4ee4d3c357$export$e6be818e738239a(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') return $83e50b4ee4d3c357$var$clampCssByte(parseFloat(str) / 100 * 255);
    return $83e50b4ee4d3c357$var$clampCssByte(parseInt(str, 10));
}
function $83e50b4ee4d3c357$export$7638a67891c3b497(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') return $83e50b4ee4d3c357$var$clampCssFloat(parseFloat(str) / 100);
    return $83e50b4ee4d3c357$var$clampCssFloat(parseFloat(str));
}
function $83e50b4ee4d3c357$var$cssHueToRgb(m1, m2, h) {
    if (h < 0) h += 1;
    else if (h > 1) h -= 1;
    if (h * 6 < 1) return m1 + (m2 - m1) * h * 6;
    if (h * 2 < 1) return m2;
    if (h * 3 < 2) return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    return m1;
}
function $83e50b4ee4d3c357$var$lerpNumber(a, b, p) {
    return a + (b - a) * p;
}
function $83e50b4ee4d3c357$var$setRgba(out, r, g, b, a) {
    out[0] = r;
    out[1] = g;
    out[2] = b;
    out[3] = a;
    return out;
}
function $83e50b4ee4d3c357$var$copyRgba(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
var $83e50b4ee4d3c357$var$colorCache = new (0, $5673a7dd695e5835$export$2e2bcd8739ae039)(20);
var $83e50b4ee4d3c357$var$lastRemovedArr = null;
function $83e50b4ee4d3c357$var$putToCache(colorStr, rgbaArr) {
    if ($83e50b4ee4d3c357$var$lastRemovedArr) $83e50b4ee4d3c357$var$copyRgba($83e50b4ee4d3c357$var$lastRemovedArr, rgbaArr);
    $83e50b4ee4d3c357$var$lastRemovedArr = $83e50b4ee4d3c357$var$colorCache.put(colorStr, $83e50b4ee4d3c357$var$lastRemovedArr || rgbaArr.slice());
}
function $83e50b4ee4d3c357$export$98e6a39c04603d36(colorStr, rgbaArr) {
    if (!colorStr) return;
    rgbaArr = rgbaArr || [];
    var cached = $83e50b4ee4d3c357$var$colorCache.get(colorStr);
    if (cached) return $83e50b4ee4d3c357$var$copyRgba(rgbaArr, cached);
    colorStr = colorStr + '';
    var str = colorStr.replace(/ /g, '').toLowerCase();
    if (str in $83e50b4ee4d3c357$var$kCSSColorTable) {
        $83e50b4ee4d3c357$var$copyRgba(rgbaArr, $83e50b4ee4d3c357$var$kCSSColorTable[str]);
        $83e50b4ee4d3c357$var$putToCache(colorStr, rgbaArr);
        return rgbaArr;
    }
    var strLen = str.length;
    if (str.charAt(0) === '#') {
        if (strLen === 4 || strLen === 5) {
            var iv = parseInt(str.slice(1, 4), 16);
            if (!(iv >= 0 && iv <= 0xfff)) {
                $83e50b4ee4d3c357$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $83e50b4ee4d3c357$var$setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, strLen === 5 ? parseInt(str.slice(4), 16) / 0xf : 1);
            $83e50b4ee4d3c357$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        } else if (strLen === 7 || strLen === 9) {
            var iv = parseInt(str.slice(1, 7), 16);
            if (!(iv >= 0 && iv <= 0xffffff)) {
                $83e50b4ee4d3c357$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $83e50b4ee4d3c357$var$setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, strLen === 9 ? parseInt(str.slice(7), 16) / 0xff : 1);
            $83e50b4ee4d3c357$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        return;
    }
    var op = str.indexOf('(');
    var ep = str.indexOf(')');
    if (op !== -1 && ep + 1 === strLen) {
        var fname = str.substr(0, op);
        var params = str.substr(op + 1, ep - (op + 1)).split(',');
        var alpha = 1;
        switch(fname){
            case 'rgba':
                if (params.length !== 4) return params.length === 3 ? $83e50b4ee4d3c357$var$setRgba(rgbaArr, +params[0], +params[1], +params[2], 1) : $83e50b4ee4d3c357$var$setRgba(rgbaArr, 0, 0, 0, 1);
                alpha = $83e50b4ee4d3c357$export$7638a67891c3b497(params.pop());
            case 'rgb':
                if (params.length >= 3) {
                    $83e50b4ee4d3c357$var$setRgba(rgbaArr, $83e50b4ee4d3c357$export$e6be818e738239a(params[0]), $83e50b4ee4d3c357$export$e6be818e738239a(params[1]), $83e50b4ee4d3c357$export$e6be818e738239a(params[2]), params.length === 3 ? alpha : $83e50b4ee4d3c357$export$7638a67891c3b497(params[3]));
                    $83e50b4ee4d3c357$var$putToCache(colorStr, rgbaArr);
                    return rgbaArr;
                } else {
                    $83e50b4ee4d3c357$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
            case 'hsla':
                if (params.length !== 4) {
                    $83e50b4ee4d3c357$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                params[3] = $83e50b4ee4d3c357$export$7638a67891c3b497(params[3]);
                $83e50b4ee4d3c357$var$hsla2rgba(params, rgbaArr);
                $83e50b4ee4d3c357$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case 'hsl':
                if (params.length !== 3) {
                    $83e50b4ee4d3c357$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $83e50b4ee4d3c357$var$hsla2rgba(params, rgbaArr);
                $83e50b4ee4d3c357$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            default:
                return;
        }
    }
    $83e50b4ee4d3c357$var$setRgba(rgbaArr, 0, 0, 0, 1);
    return;
}
function $83e50b4ee4d3c357$var$hsla2rgba(hsla, rgba) {
    var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360;
    var s = $83e50b4ee4d3c357$export$7638a67891c3b497(hsla[1]);
    var l = $83e50b4ee4d3c357$export$7638a67891c3b497(hsla[2]);
    var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
    var m1 = l * 2 - m2;
    rgba = rgba || [];
    $83e50b4ee4d3c357$var$setRgba(rgba, $83e50b4ee4d3c357$var$clampCssByte($83e50b4ee4d3c357$var$cssHueToRgb(m1, m2, h + 1 / 3) * 255), $83e50b4ee4d3c357$var$clampCssByte($83e50b4ee4d3c357$var$cssHueToRgb(m1, m2, h) * 255), $83e50b4ee4d3c357$var$clampCssByte($83e50b4ee4d3c357$var$cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
    if (hsla.length === 4) rgba[3] = hsla[3];
    return rgba;
}
function $83e50b4ee4d3c357$var$rgba2hsla(rgba) {
    if (!rgba) return;
    var R = rgba[0] / 255;
    var G = rgba[1] / 255;
    var B = rgba[2] / 255;
    var vMin = Math.min(R, G, B);
    var vMax = Math.max(R, G, B);
    var delta = vMax - vMin;
    var L = (vMax + vMin) / 2;
    var H;
    var S;
    if (delta === 0) {
        H = 0;
        S = 0;
    } else {
        if (L < 0.5) S = delta / (vMax + vMin);
        else S = delta / (2 - vMax - vMin);
        var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
        var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
        var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
        if (R === vMax) H = deltaB - deltaG;
        else if (G === vMax) H = 1 / 3 + deltaR - deltaB;
        else if (B === vMax) H = 2 / 3 + deltaG - deltaR;
        if (H < 0) H += 1;
        if (H > 1) H -= 1;
    }
    var hsla = [
        H * 360,
        S,
        L
    ];
    if (rgba[3] != null) hsla.push(rgba[3]);
    return hsla;
}
function $83e50b4ee4d3c357$export$590e8b2c435046d9(color, level) {
    var colorArr = $83e50b4ee4d3c357$export$98e6a39c04603d36(color);
    if (colorArr) {
        for(var i = 0; i < 3; i++){
            if (level < 0) colorArr[i] = colorArr[i] * (1 - level) | 0;
            else colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
            if (colorArr[i] > 255) colorArr[i] = 255;
            else if (colorArr[i] < 0) colorArr[i] = 0;
        }
        return $83e50b4ee4d3c357$export$fac44ee5b035f737(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
    }
}
function $83e50b4ee4d3c357$export$7ea66e3774a60b67(color) {
    var colorArr = $83e50b4ee4d3c357$export$98e6a39c04603d36(color);
    if (colorArr) return (16777216 + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
}
function $83e50b4ee4d3c357$export$66cb3c0e9efc61c8(normalizedValue, colors, out) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    out = out || [];
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = colors[leftIndex];
    var rightColor = colors[rightIndex];
    var dv = value - leftIndex;
    out[0] = $83e50b4ee4d3c357$var$clampCssByte($83e50b4ee4d3c357$var$lerpNumber(leftColor[0], rightColor[0], dv));
    out[1] = $83e50b4ee4d3c357$var$clampCssByte($83e50b4ee4d3c357$var$lerpNumber(leftColor[1], rightColor[1], dv));
    out[2] = $83e50b4ee4d3c357$var$clampCssByte($83e50b4ee4d3c357$var$lerpNumber(leftColor[2], rightColor[2], dv));
    out[3] = $83e50b4ee4d3c357$var$clampCssFloat($83e50b4ee4d3c357$var$lerpNumber(leftColor[3], rightColor[3], dv));
    return out;
}
var $83e50b4ee4d3c357$export$daa5a65daad5df58 = $83e50b4ee4d3c357$export$66cb3c0e9efc61c8;
function $83e50b4ee4d3c357$export$3a89f8d6f6bf6c9f(normalizedValue, colors, fullOutput) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = $83e50b4ee4d3c357$export$98e6a39c04603d36(colors[leftIndex]);
    var rightColor = $83e50b4ee4d3c357$export$98e6a39c04603d36(colors[rightIndex]);
    var dv = value - leftIndex;
    var color = $83e50b4ee4d3c357$export$fac44ee5b035f737([
        $83e50b4ee4d3c357$var$clampCssByte($83e50b4ee4d3c357$var$lerpNumber(leftColor[0], rightColor[0], dv)),
        $83e50b4ee4d3c357$var$clampCssByte($83e50b4ee4d3c357$var$lerpNumber(leftColor[1], rightColor[1], dv)),
        $83e50b4ee4d3c357$var$clampCssByte($83e50b4ee4d3c357$var$lerpNumber(leftColor[2], rightColor[2], dv)),
        $83e50b4ee4d3c357$var$clampCssFloat($83e50b4ee4d3c357$var$lerpNumber(leftColor[3], rightColor[3], dv))
    ], 'rgba');
    return fullOutput ? {
        color: color,
        leftIndex: leftIndex,
        rightIndex: rightIndex,
        value: value
    } : color;
}
var $83e50b4ee4d3c357$export$296e08242b78a3ec = $83e50b4ee4d3c357$export$3a89f8d6f6bf6c9f;
function $83e50b4ee4d3c357$export$d898ae866e27bf18(color, h, s, l) {
    var colorArr = $83e50b4ee4d3c357$export$98e6a39c04603d36(color);
    if (color) {
        colorArr = $83e50b4ee4d3c357$var$rgba2hsla(colorArr);
        h != null && (colorArr[0] = $83e50b4ee4d3c357$var$clampCssAngle((0, $f16f2994a32ad273$export$f6e2535fb5126e54)(h) ? h(colorArr[0]) : h));
        s != null && (colorArr[1] = $83e50b4ee4d3c357$export$7638a67891c3b497((0, $f16f2994a32ad273$export$f6e2535fb5126e54)(s) ? s(colorArr[1]) : s));
        l != null && (colorArr[2] = $83e50b4ee4d3c357$export$7638a67891c3b497((0, $f16f2994a32ad273$export$f6e2535fb5126e54)(l) ? l(colorArr[2]) : l));
        return $83e50b4ee4d3c357$export$fac44ee5b035f737($83e50b4ee4d3c357$var$hsla2rgba(colorArr), 'rgba');
    }
}
function $83e50b4ee4d3c357$export$ab4754bf42583a26(color, alpha) {
    var colorArr = $83e50b4ee4d3c357$export$98e6a39c04603d36(color);
    if (colorArr && alpha != null) {
        colorArr[3] = $83e50b4ee4d3c357$var$clampCssFloat(alpha);
        return $83e50b4ee4d3c357$export$fac44ee5b035f737(colorArr, 'rgba');
    }
}
function $83e50b4ee4d3c357$export$fac44ee5b035f737(arrColor, type) {
    if (!arrColor || !arrColor.length) return;
    var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
    if (type === 'rgba' || type === 'hsva' || type === 'hsla') colorStr += ',' + arrColor[3];
    return type + '(' + colorStr + ')';
}
function $83e50b4ee4d3c357$export$16c0ec21a6f9ef95(color, backgroundLum) {
    var arr = $83e50b4ee4d3c357$export$98e6a39c04603d36(color);
    return arr ? (0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2]) * arr[3] / 255 + (1 - arr[3]) * backgroundLum : 0;
}
function $83e50b4ee4d3c357$export$4385e60b38654f68() {
    return $83e50b4ee4d3c357$export$fac44ee5b035f737([
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255)
    ], 'rgb');
}
var $83e50b4ee4d3c357$var$liftedColorCache = new (0, $5673a7dd695e5835$export$2e2bcd8739ae039)(100);
function $83e50b4ee4d3c357$export$2b47e247dfb87a73(color) {
    if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(color)) {
        var liftedColor = $83e50b4ee4d3c357$var$liftedColorCache.get(color);
        if (!liftedColor) {
            liftedColor = $83e50b4ee4d3c357$export$590e8b2c435046d9(color, -0.1);
            $83e50b4ee4d3c357$var$liftedColorCache.put(color, liftedColor);
        }
        return liftedColor;
    } else if ((0, $f16f2994a32ad273$export$fa2c283003ed971c)(color)) {
        var ret = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, color);
        ret.colorStops = (0, $f16f2994a32ad273$export$871de8747c9eaa88)(color.colorStops, function(stop) {
            return {
                offset: stop.offset,
                color: $83e50b4ee4d3c357$export$590e8b2c435046d9(stop.color, -0.1)
            };
        });
        return ret;
    }
    return color;
}








var $9iKK3 = parcelRequire("9iKK3");
var $6e7232f7ffc8c94f$require$Buffer = $9iKK3.Buffer;
var $6e7232f7ffc8c94f$var$mathRound = Math.round;
function $6e7232f7ffc8c94f$export$4cde5df63f53f473(color) {
    var opacity;
    if (!color || color === 'transparent') color = 'none';
    else if (typeof color === 'string' && color.indexOf('rgba') > -1) {
        var arr = (0, $83e50b4ee4d3c357$export$98e6a39c04603d36)(color);
        if (arr) {
            color = 'rgb(' + arr[0] + ',' + arr[1] + ',' + arr[2] + ')';
            opacity = arr[3];
        }
    }
    return {
        color: color,
        opacity: opacity == null ? 1 : opacity
    };
}
var $6e7232f7ffc8c94f$var$EPSILON = 1e-4;
function $6e7232f7ffc8c94f$export$4701367f5b4de464(transform) {
    return transform < $6e7232f7ffc8c94f$var$EPSILON && transform > -$6e7232f7ffc8c94f$var$EPSILON;
}
function $6e7232f7ffc8c94f$export$4b9074ac37ee5a23(transform) {
    return $6e7232f7ffc8c94f$var$mathRound(transform * 1e3) / 1e3;
}
function $6e7232f7ffc8c94f$export$52bfc6d3e2ff0fc2(transform) {
    return $6e7232f7ffc8c94f$var$mathRound(transform * 1e4) / 1e4;
}
function $6e7232f7ffc8c94f$export$19676ab5cb1de150(transform) {
    return $6e7232f7ffc8c94f$var$mathRound(transform * 10) / 10;
}
function $6e7232f7ffc8c94f$export$f29a4456cf56ff21(m) {
    return 'matrix(' + $6e7232f7ffc8c94f$export$4b9074ac37ee5a23(m[0]) + ',' + $6e7232f7ffc8c94f$export$4b9074ac37ee5a23(m[1]) + ',' + $6e7232f7ffc8c94f$export$4b9074ac37ee5a23(m[2]) + ',' + $6e7232f7ffc8c94f$export$4b9074ac37ee5a23(m[3]) + ',' + $6e7232f7ffc8c94f$export$52bfc6d3e2ff0fc2(m[4]) + ',' + $6e7232f7ffc8c94f$export$52bfc6d3e2ff0fc2(m[5]) + ')';
}
var $6e7232f7ffc8c94f$export$4062150f0600d971 = {
    left: 'start',
    right: 'end',
    center: 'middle',
    middle: 'middle'
};
function $6e7232f7ffc8c94f$export$bf7d6802d2badd9(y, lineHeight, textBaseline) {
    if (textBaseline === 'top') y += lineHeight / 2;
    else if (textBaseline === 'bottom') y -= lineHeight / 2;
    return y;
}
function $6e7232f7ffc8c94f$export$c62076b3a966c94b(style) {
    return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY);
}
function $6e7232f7ffc8c94f$export$9e4c657be710688a(displayable) {
    var style = displayable.style;
    var globalScale = displayable.getGlobalScale();
    return [
        style.shadowColor,
        (style.shadowBlur || 0).toFixed(2),
        (style.shadowOffsetX || 0).toFixed(2),
        (style.shadowOffsetY || 0).toFixed(2),
        globalScale[0],
        globalScale[1]
    ].join(',');
}
function $6e7232f7ffc8c94f$export$8abc07640cab0527(clipPaths) {
    var key = [];
    if (clipPaths) for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        key.push(clipPath.id);
    }
    return key.join(',');
}
function $6e7232f7ffc8c94f$export$2ade673ac4f85dfe(val) {
    return val && !!val.image;
}
function $6e7232f7ffc8c94f$export$30352f47600a13cd(val) {
    return val && !!val.svgElement;
}
function $6e7232f7ffc8c94f$export$41a28f5a000a9d0f(val) {
    return $6e7232f7ffc8c94f$export$2ade673ac4f85dfe(val) || $6e7232f7ffc8c94f$export$30352f47600a13cd(val);
}
function $6e7232f7ffc8c94f$export$7d961bca9d3b47d0(val) {
    return val.type === 'linear';
}
function $6e7232f7ffc8c94f$export$2a9cca6692a0ce3a(val) {
    return val.type === 'radial';
}
function $6e7232f7ffc8c94f$export$545e02bbd5f8fe95(val) {
    return val && (val.type === 'linear' || val.type === 'radial');
}
function $6e7232f7ffc8c94f$export$bb094196179998a5(id) {
    return "url(#" + id + ")";
}
function $6e7232f7ffc8c94f$export$93fa1ae8a509371c(el) {
    var scale = el.getGlobalScale();
    var size = Math.max(scale[0], scale[1]);
    return Math.max(Math.ceil(Math.log(size) / Math.log(10)), 1);
}
function $6e7232f7ffc8c94f$export$3fe07c0888ff6164(transform) {
    var x = transform.x || 0;
    var y = transform.y || 0;
    var rotation = (transform.rotation || 0) * (0, $f16f2994a32ad273$export$bce8e055322a0ce6);
    var scaleX = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(transform.scaleX, 1);
    var scaleY = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(transform.scaleY, 1);
    var skewX = transform.skewX || 0;
    var skewY = transform.skewY || 0;
    var res = [];
    if (x || y) res.push("translate(" + x + "px," + y + "px)");
    if (rotation) res.push("rotate(" + rotation + ")");
    if (scaleX !== 1 || scaleY !== 1) res.push("scale(" + scaleX + "," + scaleY + ")");
    if (skewX || skewY) res.push("skew(" + $6e7232f7ffc8c94f$var$mathRound(skewX * (0, $f16f2994a32ad273$export$bce8e055322a0ce6)) + "deg, " + $6e7232f7ffc8c94f$var$mathRound(skewY * (0, $f16f2994a32ad273$export$bce8e055322a0ce6)) + "deg)");
    return res.join(' ');
}
var $6e7232f7ffc8c94f$export$8fb536984ec8b4d7 = function() {
    if (typeof $6e7232f7ffc8c94f$require$Buffer !== 'undefined' && typeof $6e7232f7ffc8c94f$require$Buffer.from === 'function') return function(str) {
        return $6e7232f7ffc8c94f$require$Buffer.from(str).toString('base64');
    };
    if (typeof btoa === 'function' && typeof unescape === 'function' && typeof encodeURIComponent === 'function') return function(str) {
        return btoa(unescape(encodeURIComponent(str)));
    };
    return function(str) {
        return null;
    };
}();


var $6b46db59980e54a6$var$arraySlice = Array.prototype.slice;
function $6b46db59980e54a6$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
function $6b46db59980e54a6$var$interpolate1DArray(out, p0, p1, percent) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = $6b46db59980e54a6$var$interpolateNumber(p0[i], p1[i], percent);
    return out;
}
function $6b46db59980e54a6$var$interpolate2DArray(out, p0, p1, percent) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = $6b46db59980e54a6$var$interpolateNumber(p0[i][j], p1[i][j], percent);
    }
    return out;
}
function $6b46db59980e54a6$var$add1DArray(out, p0, p1, sign) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = p0[i] + p1[i] * sign;
    return out;
}
function $6b46db59980e54a6$var$add2DArray(out, p0, p1, sign) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = p0[i][j] + p1[i][j] * sign;
    }
    return out;
}
function $6b46db59980e54a6$var$fillColorStops(val0, val1) {
    var len0 = val0.length;
    var len1 = val1.length;
    var shorterArr = len0 > len1 ? val1 : val0;
    var shorterLen = Math.min(len0, len1);
    var last = shorterArr[shorterLen - 1] || {
        color: [
            0,
            0,
            0,
            0
        ],
        offset: 0
    };
    for(var i = shorterLen; i < Math.max(len0, len1); i++)shorterArr.push({
        offset: last.offset,
        color: last.color.slice()
    });
}
function $6b46db59980e54a6$var$fillArray(val0, val1, arrDim) {
    var arr0 = val0;
    var arr1 = val1;
    if (!arr0.push || !arr1.push) return;
    var arr0Len = arr0.length;
    var arr1Len = arr1.length;
    if (arr0Len !== arr1Len) {
        var isPreviousLarger = arr0Len > arr1Len;
        if (isPreviousLarger) arr0.length = arr1Len;
        else for(var i = arr0Len; i < arr1Len; i++)arr0.push(arrDim === 1 ? arr1[i] : $6b46db59980e54a6$var$arraySlice.call(arr1[i]));
    }
    var len2 = arr0[0] && arr0[0].length;
    for(var i = 0; i < arr0.length; i++){
        if (arrDim === 1) {
            if (isNaN(arr0[i])) arr0[i] = arr1[i];
        } else {
            for(var j = 0; j < len2; j++)if (isNaN(arr0[i][j])) arr0[i][j] = arr1[i][j];
        }
    }
}
function $6b46db59980e54a6$export$c5e92b7f105af84e(value) {
    if ((0, $f16f2994a32ad273$export$1e2f57719e155213)(value)) {
        var len = value.length;
        if ((0, $f16f2994a32ad273$export$1e2f57719e155213)(value[0])) {
            var ret = [];
            for(var i = 0; i < len; i++)ret.push($6b46db59980e54a6$var$arraySlice.call(value[i]));
            return ret;
        }
        return $6b46db59980e54a6$var$arraySlice.call(value);
    }
    return value;
}
function $6b46db59980e54a6$var$rgba2String(rgba) {
    rgba[0] = Math.floor(rgba[0]) || 0;
    rgba[1] = Math.floor(rgba[1]) || 0;
    rgba[2] = Math.floor(rgba[2]) || 0;
    rgba[3] = rgba[3] == null ? 1 : rgba[3];
    return 'rgba(' + rgba.join(',') + ')';
}
function $6b46db59980e54a6$var$guessArrayDim(value) {
    return (0, $f16f2994a32ad273$export$1e2f57719e155213)(value && value[0]) ? 2 : 1;
}
var $6b46db59980e54a6$var$VALUE_TYPE_NUMBER = 0;
var $6b46db59980e54a6$var$VALUE_TYPE_1D_ARRAY = 1;
var $6b46db59980e54a6$var$VALUE_TYPE_2D_ARRAY = 2;
var $6b46db59980e54a6$var$VALUE_TYPE_COLOR = 3;
var $6b46db59980e54a6$var$VALUE_TYPE_LINEAR_GRADIENT = 4;
var $6b46db59980e54a6$var$VALUE_TYPE_RADIAL_GRADIENT = 5;
var $6b46db59980e54a6$var$VALUE_TYPE_UNKOWN = 6;
function $6b46db59980e54a6$var$isGradientValueType(valType) {
    return valType === $6b46db59980e54a6$var$VALUE_TYPE_LINEAR_GRADIENT || valType === $6b46db59980e54a6$var$VALUE_TYPE_RADIAL_GRADIENT;
}
function $6b46db59980e54a6$var$isArrayValueType(valType) {
    return valType === $6b46db59980e54a6$var$VALUE_TYPE_1D_ARRAY || valType === $6b46db59980e54a6$var$VALUE_TYPE_2D_ARRAY;
}
var $6b46db59980e54a6$var$tmpRgba = [
    0,
    0,
    0,
    0
];
var $6b46db59980e54a6$var$Track = function() {
    function Track(propName) {
        this.keyframes = [];
        this.discrete = false;
        this._invalid = false;
        this._needsSort = false;
        this._lastFr = 0;
        this._lastFrP = 0;
        this.propName = propName;
    }
    Track.prototype.isFinished = function() {
        return this._finished;
    };
    Track.prototype.setFinished = function() {
        this._finished = true;
        if (this._additiveTrack) this._additiveTrack.setFinished();
    };
    Track.prototype.needsAnimate = function() {
        return this.keyframes.length >= 1;
    };
    Track.prototype.getAdditiveTrack = function() {
        return this._additiveTrack;
    };
    Track.prototype.addKeyframe = function(time, rawValue, easing) {
        this._needsSort = true;
        var keyframes = this.keyframes;
        var len = keyframes.length;
        var discrete = false;
        var valType = $6b46db59980e54a6$var$VALUE_TYPE_UNKOWN;
        var value = rawValue;
        if ((0, $f16f2994a32ad273$export$1e2f57719e155213)(rawValue)) {
            var arrayDim = $6b46db59980e54a6$var$guessArrayDim(rawValue);
            valType = arrayDim;
            if (arrayDim === 1 && !(0, $f16f2994a32ad273$export$7e4aa119212bc614)(rawValue[0]) || arrayDim === 2 && !(0, $f16f2994a32ad273$export$7e4aa119212bc614)(rawValue[0][0])) discrete = true;
        } else {
            if ((0, $f16f2994a32ad273$export$7e4aa119212bc614)(rawValue) && !(0, $f16f2994a32ad273$export$7d667b9a0c48c975)(rawValue)) valType = $6b46db59980e54a6$var$VALUE_TYPE_NUMBER;
            else if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(rawValue)) {
                if (!isNaN(+rawValue)) valType = $6b46db59980e54a6$var$VALUE_TYPE_NUMBER;
                else {
                    var colorArray = $83e50b4ee4d3c357$export$98e6a39c04603d36(rawValue);
                    if (colorArray) {
                        value = colorArray;
                        valType = $6b46db59980e54a6$var$VALUE_TYPE_COLOR;
                    }
                }
            } else if ((0, $f16f2994a32ad273$export$fa2c283003ed971c)(rawValue)) {
                var parsedGradient = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, value);
                parsedGradient.colorStops = (0, $f16f2994a32ad273$export$871de8747c9eaa88)(rawValue.colorStops, function(colorStop) {
                    return {
                        offset: colorStop.offset,
                        color: $83e50b4ee4d3c357$export$98e6a39c04603d36(colorStop.color)
                    };
                });
                if ((0, $6e7232f7ffc8c94f$export$7d961bca9d3b47d0)(rawValue)) valType = $6b46db59980e54a6$var$VALUE_TYPE_LINEAR_GRADIENT;
                else if ((0, $6e7232f7ffc8c94f$export$2a9cca6692a0ce3a)(rawValue)) valType = $6b46db59980e54a6$var$VALUE_TYPE_RADIAL_GRADIENT;
                value = parsedGradient;
            }
        }
        if (len === 0) this.valType = valType;
        else if (valType !== this.valType || valType === $6b46db59980e54a6$var$VALUE_TYPE_UNKOWN) discrete = true;
        this.discrete = this.discrete || discrete;
        var kf = {
            time: time,
            value: value,
            rawValue: rawValue,
            percent: 0
        };
        if (easing) {
            kf.easing = easing;
            kf.easingFunc = (0, $f16f2994a32ad273$export$f6e2535fb5126e54)(easing) ? easing : (0, $9cb73ed1c1ae6407$export$2e2bcd8739ae039)[easing] || (0, $335ff30ca4c291b4$export$ec0863d806fd857e)(easing);
        }
        keyframes.push(kf);
        return kf;
    };
    Track.prototype.prepare = function(maxTime, additiveTrack) {
        var kfs = this.keyframes;
        if (this._needsSort) kfs.sort(function(a, b) {
            return a.time - b.time;
        });
        var valType = this.valType;
        var kfsLen = kfs.length;
        var lastKf = kfs[kfsLen - 1];
        var isDiscrete = this.discrete;
        var isArr = $6b46db59980e54a6$var$isArrayValueType(valType);
        var isGradient = $6b46db59980e54a6$var$isGradientValueType(valType);
        for(var i = 0; i < kfsLen; i++){
            var kf = kfs[i];
            var value = kf.value;
            var lastValue = lastKf.value;
            kf.percent = kf.time / maxTime;
            if (!isDiscrete) {
                if (isArr && i !== kfsLen - 1) $6b46db59980e54a6$var$fillArray(value, lastValue, valType);
                else if (isGradient) $6b46db59980e54a6$var$fillColorStops(value.colorStops, lastValue.colorStops);
            }
        }
        if (!isDiscrete && valType !== $6b46db59980e54a6$var$VALUE_TYPE_RADIAL_GRADIENT && additiveTrack && this.needsAnimate() && additiveTrack.needsAnimate() && valType === additiveTrack.valType && !additiveTrack._finished) {
            this._additiveTrack = additiveTrack;
            var startValue = kfs[0].value;
            for(var i = 0; i < kfsLen; i++){
                if (valType === $6b46db59980e54a6$var$VALUE_TYPE_NUMBER) kfs[i].additiveValue = kfs[i].value - startValue;
                else if (valType === $6b46db59980e54a6$var$VALUE_TYPE_COLOR) kfs[i].additiveValue = $6b46db59980e54a6$var$add1DArray([], kfs[i].value, startValue, -1);
                else if ($6b46db59980e54a6$var$isArrayValueType(valType)) kfs[i].additiveValue = valType === $6b46db59980e54a6$var$VALUE_TYPE_1D_ARRAY ? $6b46db59980e54a6$var$add1DArray([], kfs[i].value, startValue, -1) : $6b46db59980e54a6$var$add2DArray([], kfs[i].value, startValue, -1);
            }
        }
    };
    Track.prototype.step = function(target, percent) {
        if (this._finished) return;
        if (this._additiveTrack && this._additiveTrack._finished) this._additiveTrack = null;
        var isAdditive = this._additiveTrack != null;
        var valueKey = isAdditive ? 'additiveValue' : 'value';
        var valType = this.valType;
        var keyframes = this.keyframes;
        var kfsNum = keyframes.length;
        var propName = this.propName;
        var isValueColor = valType === $6b46db59980e54a6$var$VALUE_TYPE_COLOR;
        var frameIdx;
        var lastFrame = this._lastFr;
        var mathMin = Math.min;
        var frame;
        var nextFrame;
        if (kfsNum === 1) frame = nextFrame = keyframes[0];
        else {
            if (percent < 0) frameIdx = 0;
            else if (percent < this._lastFrP) {
                var start = mathMin(lastFrame + 1, kfsNum - 1);
                for(frameIdx = start; frameIdx >= 0; frameIdx--){
                    if (keyframes[frameIdx].percent <= percent) break;
                }
                frameIdx = mathMin(frameIdx, kfsNum - 2);
            } else {
                for(frameIdx = lastFrame; frameIdx < kfsNum; frameIdx++){
                    if (keyframes[frameIdx].percent > percent) break;
                }
                frameIdx = mathMin(frameIdx - 1, kfsNum - 2);
            }
            nextFrame = keyframes[frameIdx + 1];
            frame = keyframes[frameIdx];
        }
        if (!(frame && nextFrame)) return;
        this._lastFr = frameIdx;
        this._lastFrP = percent;
        var interval = nextFrame.percent - frame.percent;
        var w = interval === 0 ? 1 : mathMin((percent - frame.percent) / interval, 1);
        if (nextFrame.easingFunc) w = nextFrame.easingFunc(w);
        var targetArr = isAdditive ? this._additiveValue : isValueColor ? $6b46db59980e54a6$var$tmpRgba : target[propName];
        if (($6b46db59980e54a6$var$isArrayValueType(valType) || isValueColor) && !targetArr) targetArr = this._additiveValue = [];
        if (this.discrete) target[propName] = w < 1 ? frame.rawValue : nextFrame.rawValue;
        else if ($6b46db59980e54a6$var$isArrayValueType(valType)) valType === $6b46db59980e54a6$var$VALUE_TYPE_1D_ARRAY ? $6b46db59980e54a6$var$interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w) : $6b46db59980e54a6$var$interpolate2DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
        else if ($6b46db59980e54a6$var$isGradientValueType(valType)) {
            var val = frame[valueKey];
            var nextVal_1 = nextFrame[valueKey];
            var isLinearGradient_1 = valType === $6b46db59980e54a6$var$VALUE_TYPE_LINEAR_GRADIENT;
            target[propName] = {
                type: isLinearGradient_1 ? 'linear' : 'radial',
                x: $6b46db59980e54a6$var$interpolateNumber(val.x, nextVal_1.x, w),
                y: $6b46db59980e54a6$var$interpolateNumber(val.y, nextVal_1.y, w),
                colorStops: (0, $f16f2994a32ad273$export$871de8747c9eaa88)(val.colorStops, function(colorStop, idx) {
                    var nextColorStop = nextVal_1.colorStops[idx];
                    return {
                        offset: $6b46db59980e54a6$var$interpolateNumber(colorStop.offset, nextColorStop.offset, w),
                        color: $6b46db59980e54a6$var$rgba2String($6b46db59980e54a6$var$interpolate1DArray([], colorStop.color, nextColorStop.color, w))
                    };
                }),
                global: nextVal_1.global
            };
            if (isLinearGradient_1) {
                target[propName].x2 = $6b46db59980e54a6$var$interpolateNumber(val.x2, nextVal_1.x2, w);
                target[propName].y2 = $6b46db59980e54a6$var$interpolateNumber(val.y2, nextVal_1.y2, w);
            } else target[propName].r = $6b46db59980e54a6$var$interpolateNumber(val.r, nextVal_1.r, w);
        } else if (isValueColor) {
            $6b46db59980e54a6$var$interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
            if (!isAdditive) target[propName] = $6b46db59980e54a6$var$rgba2String(targetArr);
        } else {
            var value = $6b46db59980e54a6$var$interpolateNumber(frame[valueKey], nextFrame[valueKey], w);
            if (isAdditive) this._additiveValue = value;
            else target[propName] = value;
        }
        if (isAdditive) this._addToTarget(target);
    };
    Track.prototype._addToTarget = function(target) {
        var valType = this.valType;
        var propName = this.propName;
        var additiveValue = this._additiveValue;
        if (valType === $6b46db59980e54a6$var$VALUE_TYPE_NUMBER) target[propName] = target[propName] + additiveValue;
        else if (valType === $6b46db59980e54a6$var$VALUE_TYPE_COLOR) {
            $83e50b4ee4d3c357$export$98e6a39c04603d36(target[propName], $6b46db59980e54a6$var$tmpRgba);
            $6b46db59980e54a6$var$add1DArray($6b46db59980e54a6$var$tmpRgba, $6b46db59980e54a6$var$tmpRgba, additiveValue, 1);
            target[propName] = $6b46db59980e54a6$var$rgba2String($6b46db59980e54a6$var$tmpRgba);
        } else if (valType === $6b46db59980e54a6$var$VALUE_TYPE_1D_ARRAY) $6b46db59980e54a6$var$add1DArray(target[propName], target[propName], additiveValue, 1);
        else if (valType === $6b46db59980e54a6$var$VALUE_TYPE_2D_ARRAY) $6b46db59980e54a6$var$add2DArray(target[propName], target[propName], additiveValue, 1);
    };
    return Track;
}();
var $6b46db59980e54a6$var$Animator = function() {
    function Animator(target, loop, allowDiscreteAnimation, additiveTo) {
        this._tracks = {};
        this._trackKeys = [];
        this._maxTime = 0;
        this._started = 0;
        this._clip = null;
        this._target = target;
        this._loop = loop;
        if (loop && additiveTo) {
            (0, $f16f2994a32ad273$export$58da9968c3170cb1)('Can\' use additive animation on looped animation.');
            return;
        }
        this._additiveAnimators = additiveTo;
        this._allowDiscrete = allowDiscreteAnimation;
    }
    Animator.prototype.getMaxTime = function() {
        return this._maxTime;
    };
    Animator.prototype.getDelay = function() {
        return this._delay;
    };
    Animator.prototype.getLoop = function() {
        return this._loop;
    };
    Animator.prototype.getTarget = function() {
        return this._target;
    };
    Animator.prototype.changeTarget = function(target) {
        this._target = target;
    };
    Animator.prototype.when = function(time, props, easing) {
        return this.whenWithKeys(time, props, (0, $f16f2994a32ad273$export$ed97f33186d4b816)(props), easing);
    };
    Animator.prototype.whenWithKeys = function(time, props, propNames, easing) {
        var tracks = this._tracks;
        for(var i = 0; i < propNames.length; i++){
            var propName = propNames[i];
            var track = tracks[propName];
            if (!track) {
                track = tracks[propName] = new $6b46db59980e54a6$var$Track(propName);
                var initialValue = void 0;
                var additiveTrack = this._getAdditiveTrack(propName);
                if (additiveTrack) {
                    var addtiveTrackKfs = additiveTrack.keyframes;
                    var lastFinalKf = addtiveTrackKfs[addtiveTrackKfs.length - 1];
                    initialValue = lastFinalKf && lastFinalKf.value;
                    if (additiveTrack.valType === $6b46db59980e54a6$var$VALUE_TYPE_COLOR && initialValue) initialValue = $6b46db59980e54a6$var$rgba2String(initialValue);
                } else initialValue = this._target[propName];
                if (initialValue == null) continue;
                if (time > 0) track.addKeyframe(0, $6b46db59980e54a6$export$c5e92b7f105af84e(initialValue), easing);
                this._trackKeys.push(propName);
            }
            track.addKeyframe(time, $6b46db59980e54a6$export$c5e92b7f105af84e(props[propName]), easing);
        }
        this._maxTime = Math.max(this._maxTime, time);
        return this;
    };
    Animator.prototype.pause = function() {
        this._clip.pause();
        this._paused = true;
    };
    Animator.prototype.resume = function() {
        this._clip.resume();
        this._paused = false;
    };
    Animator.prototype.isPaused = function() {
        return !!this._paused;
    };
    Animator.prototype.duration = function(duration) {
        this._maxTime = duration;
        this._force = true;
        return this;
    };
    Animator.prototype._doneCallback = function() {
        this._setTracksFinished();
        this._clip = null;
        var doneList = this._doneCbs;
        if (doneList) {
            var len = doneList.length;
            for(var i = 0; i < len; i++)doneList[i].call(this);
        }
    };
    Animator.prototype._abortedCallback = function() {
        this._setTracksFinished();
        var animation = this.animation;
        var abortedList = this._abortedCbs;
        if (animation) animation.removeClip(this._clip);
        this._clip = null;
        if (abortedList) for(var i = 0; i < abortedList.length; i++)abortedList[i].call(this);
    };
    Animator.prototype._setTracksFinished = function() {
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < tracksKeys.length; i++)tracks[tracksKeys[i]].setFinished();
    };
    Animator.prototype._getAdditiveTrack = function(trackName) {
        var additiveTrack;
        var additiveAnimators = this._additiveAnimators;
        if (additiveAnimators) for(var i = 0; i < additiveAnimators.length; i++){
            var track = additiveAnimators[i].getTrack(trackName);
            if (track) additiveTrack = track;
        }
        return additiveTrack;
    };
    Animator.prototype.start = function(easing) {
        if (this._started > 0) return;
        this._started = 1;
        var self = this;
        var tracks = [];
        var maxTime = this._maxTime || 0;
        for(var i = 0; i < this._trackKeys.length; i++){
            var propName = this._trackKeys[i];
            var track = this._tracks[propName];
            var additiveTrack = this._getAdditiveTrack(propName);
            var kfs = track.keyframes;
            var kfsNum = kfs.length;
            track.prepare(maxTime, additiveTrack);
            if (track.needsAnimate()) {
                if (!this._allowDiscrete && track.discrete) {
                    var lastKf = kfs[kfsNum - 1];
                    if (lastKf) self._target[track.propName] = lastKf.rawValue;
                    track.setFinished();
                } else tracks.push(track);
            }
        }
        if (tracks.length || this._force) {
            var clip = new (0, $19bf4030be565b69$export$2e2bcd8739ae039)({
                life: maxTime,
                loop: this._loop,
                delay: this._delay || 0,
                onframe: function onframe(percent) {
                    self._started = 2;
                    var additiveAnimators = self._additiveAnimators;
                    if (additiveAnimators) {
                        var stillHasAdditiveAnimator = false;
                        for(var i = 0; i < additiveAnimators.length; i++)if (additiveAnimators[i]._clip) {
                            stillHasAdditiveAnimator = true;
                            break;
                        }
                        if (!stillHasAdditiveAnimator) self._additiveAnimators = null;
                    }
                    for(var i = 0; i < tracks.length; i++)tracks[i].step(self._target, percent);
                    var onframeList = self._onframeCbs;
                    if (onframeList) for(var i = 0; i < onframeList.length; i++)onframeList[i](self._target, percent);
                },
                ondestroy: function ondestroy() {
                    self._doneCallback();
                }
            });
            this._clip = clip;
            if (this.animation) this.animation.addClip(clip);
            if (easing) clip.setEasing(easing);
        } else this._doneCallback();
        return this;
    };
    Animator.prototype.stop = function(forwardToLast) {
        if (!this._clip) return;
        var clip = this._clip;
        if (forwardToLast) clip.onframe(1);
        this._abortedCallback();
    };
    Animator.prototype.delay = function(time) {
        this._delay = time;
        return this;
    };
    Animator.prototype.during = function(cb) {
        if (cb) {
            if (!this._onframeCbs) this._onframeCbs = [];
            this._onframeCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.done = function(cb) {
        if (cb) {
            if (!this._doneCbs) this._doneCbs = [];
            this._doneCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.aborted = function(cb) {
        if (cb) {
            if (!this._abortedCbs) this._abortedCbs = [];
            this._abortedCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.getClip = function() {
        return this._clip;
    };
    Animator.prototype.getTrack = function(propName) {
        return this._tracks[propName];
    };
    Animator.prototype.getTracks = function() {
        var _this = this;
        return (0, $f16f2994a32ad273$export$871de8747c9eaa88)(this._trackKeys, function(key) {
            return _this._tracks[key];
        });
    };
    Animator.prototype.stopTracks = function(propNames, forwardToLast) {
        if (!propNames.length || !this._clip) return true;
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < propNames.length; i++){
            var track = tracks[propNames[i]];
            if (track && !track.isFinished()) {
                if (forwardToLast) track.step(this._target, 1);
                else if (this._started === 1) track.step(this._target, 0);
                track.setFinished();
            }
        }
        var allAborted = true;
        for(var i = 0; i < tracksKeys.length; i++)if (!tracks[tracksKeys[i]].isFinished()) {
            allAborted = false;
            break;
        }
        if (allAborted) this._abortedCallback();
        return allAborted;
    };
    Animator.prototype.saveTo = function(target, trackKeys, firstOrLast) {
        if (!target) return;
        trackKeys = trackKeys || this._trackKeys;
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track || track.isFinished()) continue;
            var kfs = track.keyframes;
            var kf = kfs[firstOrLast ? 0 : kfs.length - 1];
            if (kf) target[propName] = $6b46db59980e54a6$export$c5e92b7f105af84e(kf.rawValue);
        }
    };
    Animator.prototype.__changeFinalValue = function(finalProps, trackKeys) {
        trackKeys = trackKeys || (0, $f16f2994a32ad273$export$ed97f33186d4b816)(finalProps);
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track) continue;
            var kfs = track.keyframes;
            if (kfs.length > 1) {
                var lastKf = kfs.pop();
                track.addKeyframe(lastKf.time, finalProps[propName]);
                track.prepare(this._maxTime, track.getAdditiveTrack());
            }
        }
    };
    return Animator;
}();
var $6b46db59980e54a6$export$2e2bcd8739ae039 = $6b46db59980e54a6$var$Animator;


function $7485e39c88b6e9be$export$1428f42a7de81803() {
    return new Date().getTime();
}
var $7485e39c88b6e9be$var$Animation = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Animation, _super);
    function Animation(opts) {
        var _this = _super.call(this) || this;
        _this._running = false;
        _this._time = 0;
        _this._pausedTime = 0;
        _this._pauseStart = 0;
        _this._paused = false;
        opts = opts || {};
        _this.stage = opts.stage || {};
        return _this;
    }
    Animation.prototype.addClip = function(clip) {
        if (clip.animation) this.removeClip(clip);
        if (!this._head) this._head = this._tail = clip;
        else {
            this._tail.next = clip;
            clip.prev = this._tail;
            clip.next = null;
            this._tail = clip;
        }
        clip.animation = this;
    };
    Animation.prototype.addAnimator = function(animator) {
        animator.animation = this;
        var clip = animator.getClip();
        if (clip) this.addClip(clip);
    };
    Animation.prototype.removeClip = function(clip) {
        if (!clip.animation) return;
        var prev = clip.prev;
        var next = clip.next;
        if (prev) prev.next = next;
        else this._head = next;
        if (next) next.prev = prev;
        else this._tail = prev;
        clip.next = clip.prev = clip.animation = null;
    };
    Animation.prototype.removeAnimator = function(animator) {
        var clip = animator.getClip();
        if (clip) this.removeClip(clip);
        animator.animation = null;
    };
    Animation.prototype.update = function(notTriggerFrameAndStageUpdate) {
        var time = $7485e39c88b6e9be$export$1428f42a7de81803() - this._pausedTime;
        var delta = time - this._time;
        var clip = this._head;
        while(clip){
            var nextClip = clip.next;
            var finished = clip.step(time, delta);
            if (finished) {
                clip.ondestroy();
                this.removeClip(clip);
                clip = nextClip;
            } else clip = nextClip;
        }
        this._time = time;
        if (!notTriggerFrameAndStageUpdate) {
            this.trigger('frame', delta);
            this.stage.update && this.stage.update();
        }
    };
    Animation.prototype._startLoop = function() {
        var self = this;
        this._running = true;
        function step() {
            if (self._running) {
                (0, $0b01569dabcb06cc$export$2e2bcd8739ae039)(step);
                !self._paused && self.update();
            }
        }
        (0, $0b01569dabcb06cc$export$2e2bcd8739ae039)(step);
    };
    Animation.prototype.start = function() {
        if (this._running) return;
        this._time = $7485e39c88b6e9be$export$1428f42a7de81803();
        this._pausedTime = 0;
        this._startLoop();
    };
    Animation.prototype.stop = function() {
        this._running = false;
    };
    Animation.prototype.pause = function() {
        if (!this._paused) {
            this._pauseStart = $7485e39c88b6e9be$export$1428f42a7de81803();
            this._paused = true;
        }
    };
    Animation.prototype.resume = function() {
        if (this._paused) {
            this._pausedTime += $7485e39c88b6e9be$export$1428f42a7de81803() - this._pauseStart;
            this._paused = false;
        }
    };
    Animation.prototype.clear = function() {
        var clip = this._head;
        while(clip){
            var nextClip = clip.next;
            clip.prev = clip.next = clip.animation = null;
            clip = nextClip;
        }
        this._head = this._tail = null;
    };
    Animation.prototype.isFinished = function() {
        return this._head == null;
    };
    Animation.prototype.animate = function(target, options) {
        options = options || {};
        this.start();
        var animator = new (0, $6b46db59980e54a6$export$2e2bcd8739ae039)(target, options.loop);
        this.addAnimator(animator);
        return animator;
    };
    return Animation;
}((0, $83f1d7c1143fe0f3$export$2e2bcd8739ae039));
var $7485e39c88b6e9be$export$2e2bcd8739ae039 = $7485e39c88b6e9be$var$Animation;







var $649730adabee4714$var$TOUCH_CLICK_DELAY = 300;
var $649730adabee4714$var$globalEventSupported = (0, $6d0397515b55cc48$export$2e2bcd8739ae039).domSupported;
var $649730adabee4714$var$localNativeListenerNames = function() {
    var mouseHandlerNames = [
        'click',
        'dblclick',
        'mousewheel',
        'wheel',
        'mouseout',
        'mouseup',
        'mousedown',
        'mousemove',
        'contextmenu'
    ];
    var touchHandlerNames = [
        'touchstart',
        'touchend',
        'touchmove'
    ];
    var pointerEventNameMap = {
        pointerdown: 1,
        pointerup: 1,
        pointermove: 1,
        pointerout: 1
    };
    var pointerHandlerNames = $f16f2994a32ad273$export$871de8747c9eaa88(mouseHandlerNames, function(name) {
        var nm = name.replace('mouse', 'pointer');
        return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
    });
    return {
        mouse: mouseHandlerNames,
        touch: touchHandlerNames,
        pointer: pointerHandlerNames
    };
}();
var $649730adabee4714$var$globalNativeListenerNames = {
    mouse: [
        'mousemove',
        'mouseup'
    ],
    pointer: [
        'pointermove',
        'pointerup'
    ]
};
var $649730adabee4714$var$wheelEventSupported = false;
function $649730adabee4714$var$isPointerFromTouch(event) {
    var pointerType = event.pointerType;
    return pointerType === 'pen' || pointerType === 'touch';
}
function $649730adabee4714$var$setTouchTimer(scope) {
    scope.touching = true;
    if (scope.touchTimer != null) {
        clearTimeout(scope.touchTimer);
        scope.touchTimer = null;
    }
    scope.touchTimer = setTimeout(function() {
        scope.touching = false;
        scope.touchTimer = null;
    }, 700);
}
function $649730adabee4714$var$markTouch(event) {
    event && (event.zrByTouch = true);
}
function $649730adabee4714$var$normalizeGlobalEvent(instance, event) {
    return (0, $1f87c82830753703$export$40fadb093aebad71)(instance.dom, new $649730adabee4714$var$FakeGlobalEvent(instance, event), true);
}
function $649730adabee4714$var$isLocalEl(instance, el) {
    var elTmp = el;
    var isLocal = false;
    while(elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot))elTmp = elTmp.parentNode;
    return isLocal;
}
var $649730adabee4714$var$FakeGlobalEvent = function() {
    function FakeGlobalEvent(instance, event) {
        this.stopPropagation = $f16f2994a32ad273$export$8793edee2d425525;
        this.stopImmediatePropagation = $f16f2994a32ad273$export$8793edee2d425525;
        this.preventDefault = $f16f2994a32ad273$export$8793edee2d425525;
        this.type = event.type;
        this.target = this.currentTarget = instance.dom;
        this.pointerType = event.pointerType;
        this.clientX = event.clientX;
        this.clientY = event.clientY;
    }
    return FakeGlobalEvent;
}();
var $649730adabee4714$var$localDOMHandlers = {
    mousedown: function mousedown(event) {
        event = (0, $1f87c82830753703$export$40fadb093aebad71)(this.dom, event);
        this.__mayPointerCapture = [
            event.zrX,
            event.zrY
        ];
        this.trigger('mousedown', event);
    },
    mousemove: function mousemove(event) {
        event = (0, $1f87c82830753703$export$40fadb093aebad71)(this.dom, event);
        var downPoint = this.__mayPointerCapture;
        if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) this.__togglePointerCapture(true);
        this.trigger('mousemove', event);
    },
    mouseup: function mouseup(event) {
        event = (0, $1f87c82830753703$export$40fadb093aebad71)(this.dom, event);
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
    },
    mouseout: function mouseout(event) {
        event = (0, $1f87c82830753703$export$40fadb093aebad71)(this.dom, event);
        var element = event.toElement || event.relatedTarget;
        if (!$649730adabee4714$var$isLocalEl(this, element)) {
            if (this.__pointerCapturing) event.zrEventControl = 'no_globalout';
            this.trigger('mouseout', event);
        }
    },
    wheel: function wheel(event) {
        $649730adabee4714$var$wheelEventSupported = true;
        event = (0, $1f87c82830753703$export$40fadb093aebad71)(this.dom, event);
        this.trigger('mousewheel', event);
    },
    mousewheel: function mousewheel(event) {
        if ($649730adabee4714$var$wheelEventSupported) return;
        event = (0, $1f87c82830753703$export$40fadb093aebad71)(this.dom, event);
        this.trigger('mousewheel', event);
    },
    touchstart: function touchstart(event) {
        event = (0, $1f87c82830753703$export$40fadb093aebad71)(this.dom, event);
        $649730adabee4714$var$markTouch(event);
        this.__lastTouchMoment = new Date();
        this.handler.processGesture(event, 'start');
        $649730adabee4714$var$localDOMHandlers.mousemove.call(this, event);
        $649730adabee4714$var$localDOMHandlers.mousedown.call(this, event);
    },
    touchmove: function touchmove(event) {
        event = (0, $1f87c82830753703$export$40fadb093aebad71)(this.dom, event);
        $649730adabee4714$var$markTouch(event);
        this.handler.processGesture(event, 'change');
        $649730adabee4714$var$localDOMHandlers.mousemove.call(this, event);
    },
    touchend: function touchend(event) {
        event = (0, $1f87c82830753703$export$40fadb093aebad71)(this.dom, event);
        $649730adabee4714$var$markTouch(event);
        this.handler.processGesture(event, 'end');
        $649730adabee4714$var$localDOMHandlers.mouseup.call(this, event);
        if (+new Date() - +this.__lastTouchMoment < $649730adabee4714$var$TOUCH_CLICK_DELAY) $649730adabee4714$var$localDOMHandlers.click.call(this, event);
    },
    pointerdown: function pointerdown(event) {
        $649730adabee4714$var$localDOMHandlers.mousedown.call(this, event);
    },
    pointermove: function pointermove(event) {
        if (!$649730adabee4714$var$isPointerFromTouch(event)) $649730adabee4714$var$localDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function pointerup(event) {
        $649730adabee4714$var$localDOMHandlers.mouseup.call(this, event);
    },
    pointerout: function pointerout(event) {
        if (!$649730adabee4714$var$isPointerFromTouch(event)) $649730adabee4714$var$localDOMHandlers.mouseout.call(this, event);
    }
};
$f16f2994a32ad273$export$79b2f7037acddd43([
    'click',
    'dblclick',
    'contextmenu'
], function(name) {
    $649730adabee4714$var$localDOMHandlers[name] = function(event) {
        event = (0, $1f87c82830753703$export$40fadb093aebad71)(this.dom, event);
        this.trigger(name, event);
    };
});
var $649730adabee4714$var$globalDOMHandlers = {
    pointermove: function pointermove(event) {
        if (!$649730adabee4714$var$isPointerFromTouch(event)) $649730adabee4714$var$globalDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function pointerup(event) {
        $649730adabee4714$var$globalDOMHandlers.mouseup.call(this, event);
    },
    mousemove: function mousemove(event) {
        this.trigger('mousemove', event);
    },
    mouseup: function mouseup(event) {
        var pointerCaptureReleasing = this.__pointerCapturing;
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
        if (pointerCaptureReleasing) {
            event.zrEventControl = 'only_globalout';
            this.trigger('mouseout', event);
        }
    }
};
function $649730adabee4714$var$mountLocalDOMEventListeners(instance, scope) {
    var domHandlers = scope.domHandlers;
    if ((0, $6d0397515b55cc48$export$2e2bcd8739ae039).pointerEventsSupported) $f16f2994a32ad273$export$79b2f7037acddd43($649730adabee4714$var$localNativeListenerNames.pointer, function(nativeEventName) {
        $649730adabee4714$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
            domHandlers[nativeEventName].call(instance, event);
        });
    });
    else {
        if ((0, $6d0397515b55cc48$export$2e2bcd8739ae039).touchEventsSupported) $f16f2994a32ad273$export$79b2f7037acddd43($649730adabee4714$var$localNativeListenerNames.touch, function(nativeEventName) {
            $649730adabee4714$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                domHandlers[nativeEventName].call(instance, event);
                $649730adabee4714$var$setTouchTimer(scope);
            });
        });
        $f16f2994a32ad273$export$79b2f7037acddd43($649730adabee4714$var$localNativeListenerNames.mouse, function(nativeEventName) {
            $649730adabee4714$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                event = (0, $1f87c82830753703$export$4abe0e945399ac1d)(event);
                if (!scope.touching) domHandlers[nativeEventName].call(instance, event);
            });
        });
    }
}
function $649730adabee4714$var$mountGlobalDOMEventListeners(instance, scope) {
    if ((0, $6d0397515b55cc48$export$2e2bcd8739ae039).pointerEventsSupported) $f16f2994a32ad273$export$79b2f7037acddd43($649730adabee4714$var$globalNativeListenerNames.pointer, mount);
    else if (!(0, $6d0397515b55cc48$export$2e2bcd8739ae039).touchEventsSupported) $f16f2994a32ad273$export$79b2f7037acddd43($649730adabee4714$var$globalNativeListenerNames.mouse, mount);
    function mount(nativeEventName) {
        function nativeEventListener(event) {
            event = (0, $1f87c82830753703$export$4abe0e945399ac1d)(event);
            if (!$649730adabee4714$var$isLocalEl(instance, event.target)) {
                event = $649730adabee4714$var$normalizeGlobalEvent(instance, event);
                scope.domHandlers[nativeEventName].call(instance, event);
            }
        }
        $649730adabee4714$var$mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
            capture: true
        });
    }
}
function $649730adabee4714$var$mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
    scope.mounted[nativeEventName] = listener;
    scope.listenerOpts[nativeEventName] = opt;
    (0, $1f87c82830753703$export$3f65cefe8380dbea)(scope.domTarget, nativeEventName, listener, opt);
}
function $649730adabee4714$var$unmountDOMEventListeners(scope) {
    var mounted = scope.mounted;
    for(var nativeEventName in mounted)if (mounted.hasOwnProperty(nativeEventName)) (0, $1f87c82830753703$export$8ff9f68337b520c0)(scope.domTarget, nativeEventName, mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
    scope.mounted = {};
}
var $649730adabee4714$var$DOMHandlerScope = function() {
    function DOMHandlerScope(domTarget, domHandlers) {
        this.mounted = {};
        this.listenerOpts = {};
        this.touching = false;
        this.domTarget = domTarget;
        this.domHandlers = domHandlers;
    }
    return DOMHandlerScope;
}();
var $649730adabee4714$var$HandlerDomProxy = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(HandlerDomProxy, _super);
    function HandlerDomProxy(dom, painterRoot) {
        var _this = _super.call(this) || this;
        _this.__pointerCapturing = false;
        _this.dom = dom;
        _this.painterRoot = painterRoot;
        _this._localHandlerScope = new $649730adabee4714$var$DOMHandlerScope(dom, $649730adabee4714$var$localDOMHandlers);
        if ($649730adabee4714$var$globalEventSupported) _this._globalHandlerScope = new $649730adabee4714$var$DOMHandlerScope(document, $649730adabee4714$var$globalDOMHandlers);
        $649730adabee4714$var$mountLocalDOMEventListeners(_this, _this._localHandlerScope);
        return _this;
    }
    HandlerDomProxy.prototype.dispose = function() {
        $649730adabee4714$var$unmountDOMEventListeners(this._localHandlerScope);
        if ($649730adabee4714$var$globalEventSupported) $649730adabee4714$var$unmountDOMEventListeners(this._globalHandlerScope);
    };
    HandlerDomProxy.prototype.setCursor = function(cursorStyle) {
        this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
    };
    HandlerDomProxy.prototype.__togglePointerCapture = function(isPointerCapturing) {
        this.__mayPointerCapture = null;
        if ($649730adabee4714$var$globalEventSupported && +this.__pointerCapturing ^ +isPointerCapturing) {
            this.__pointerCapturing = isPointerCapturing;
            var globalHandlerScope = this._globalHandlerScope;
            isPointerCapturing ? $649730adabee4714$var$mountGlobalDOMEventListeners(this, globalHandlerScope) : $649730adabee4714$var$unmountDOMEventListeners(globalHandlerScope);
        }
    };
    return HandlerDomProxy;
}((0, $83f1d7c1143fe0f3$export$2e2bcd8739ae039));
var $649730adabee4714$export$2e2bcd8739ae039 = $649730adabee4714$var$HandlerDomProxy;




var $e374994bc8dfd1f0$var$dpr = 1;
if ((0, $6d0397515b55cc48$export$2e2bcd8739ae039).hasGlobalWindow) $e374994bc8dfd1f0$var$dpr = Math.max(window.devicePixelRatio || window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI || 1, 1);
var $e374994bc8dfd1f0$export$7cdcde344c85339c = 0;
var $e374994bc8dfd1f0$export$508f096bfcdaac40 = $e374994bc8dfd1f0$var$dpr;
var $e374994bc8dfd1f0$export$fd81e7ebc7dae256 = 0.4;
var $e374994bc8dfd1f0$export$f8ce94761f39398d = '#333';
var $e374994bc8dfd1f0$export$3c6e95f318c8369b = '#ccc';
var $e374994bc8dfd1f0$export$27682248795c3c6b = '#eee';







var $ad30ab15d8ed0f32$var$mIdentity = $45a6d43b639a6412$export$f0954fd7d5368655;
var $ad30ab15d8ed0f32$var$EPSILON = 5e-5;
function $ad30ab15d8ed0f32$var$isNotAroundZero(val) {
    return val > $ad30ab15d8ed0f32$var$EPSILON || val < -$ad30ab15d8ed0f32$var$EPSILON;
}
var $ad30ab15d8ed0f32$var$scaleTmp = [];
var $ad30ab15d8ed0f32$var$tmpTransform = [];
var $ad30ab15d8ed0f32$var$originTransform = $45a6d43b639a6412$export$185802fd694ee1f5();
var $ad30ab15d8ed0f32$var$abs = Math.abs;
var $ad30ab15d8ed0f32$var$Transformable = function() {
    function Transformable() {}
    Transformable.prototype.getLocalTransform = function(m) {
        return $ad30ab15d8ed0f32$export$1157cd5386cdcc1b(this, m);
    };
    Transformable.prototype.setPosition = function(arr) {
        this.x = arr[0];
        this.y = arr[1];
    };
    Transformable.prototype.setScale = function(arr) {
        this.scaleX = arr[0];
        this.scaleY = arr[1];
    };
    Transformable.prototype.setSkew = function(arr) {
        this.skewX = arr[0];
        this.skewY = arr[1];
    };
    Transformable.prototype.setOrigin = function(arr) {
        this.originX = arr[0];
        this.originY = arr[1];
    };
    Transformable.prototype.needLocalTransform = function() {
        return $ad30ab15d8ed0f32$var$isNotAroundZero(this.rotation) || $ad30ab15d8ed0f32$var$isNotAroundZero(this.x) || $ad30ab15d8ed0f32$var$isNotAroundZero(this.y) || $ad30ab15d8ed0f32$var$isNotAroundZero(this.scaleX - 1) || $ad30ab15d8ed0f32$var$isNotAroundZero(this.scaleY - 1) || $ad30ab15d8ed0f32$var$isNotAroundZero(this.skewX) || $ad30ab15d8ed0f32$var$isNotAroundZero(this.skewY);
    };
    Transformable.prototype.updateTransform = function() {
        var parentTransform = this.parent && this.parent.transform;
        var needLocalTransform = this.needLocalTransform();
        var m = this.transform;
        if (!(needLocalTransform || parentTransform)) {
            if (m) {
                $ad30ab15d8ed0f32$var$mIdentity(m);
                this.invTransform = null;
            }
            return;
        }
        m = m || $45a6d43b639a6412$export$185802fd694ee1f5();
        if (needLocalTransform) this.getLocalTransform(m);
        else $ad30ab15d8ed0f32$var$mIdentity(m);
        if (parentTransform) {
            if (needLocalTransform) $45a6d43b639a6412$export$6e3a27864ab166fe(m, parentTransform, m);
            else $45a6d43b639a6412$export$784d13d8ee351f07(m, parentTransform);
        }
        this.transform = m;
        this._resolveGlobalScaleRatio(m);
        this.invTransform = this.invTransform || $45a6d43b639a6412$export$185802fd694ee1f5();
        $45a6d43b639a6412$export$6897c284b6f9f4dc(this.invTransform, m);
    };
    Transformable.prototype._resolveGlobalScaleRatio = function(m) {
        var globalScaleRatio = this.globalScaleRatio;
        if (globalScaleRatio != null && globalScaleRatio !== 1) {
            this.getGlobalScale($ad30ab15d8ed0f32$var$scaleTmp);
            var relX = $ad30ab15d8ed0f32$var$scaleTmp[0] < 0 ? -1 : 1;
            var relY = $ad30ab15d8ed0f32$var$scaleTmp[1] < 0 ? -1 : 1;
            var sx = (($ad30ab15d8ed0f32$var$scaleTmp[0] - relX) * globalScaleRatio + relX) / $ad30ab15d8ed0f32$var$scaleTmp[0] || 0;
            var sy = (($ad30ab15d8ed0f32$var$scaleTmp[1] - relY) * globalScaleRatio + relY) / $ad30ab15d8ed0f32$var$scaleTmp[1] || 0;
            m[0] *= sx;
            m[1] *= sx;
            m[2] *= sy;
            m[3] *= sy;
        }
    };
    Transformable.prototype.getComputedTransform = function() {
        var transformNode = this;
        var ancestors = [];
        while(transformNode){
            ancestors.push(transformNode);
            transformNode = transformNode.parent;
        }
        while(transformNode = ancestors.pop())transformNode.updateTransform();
        return this.transform;
    };
    Transformable.prototype.setLocalTransform = function(m) {
        if (!m) return;
        var sx = m[0] * m[0] + m[1] * m[1];
        var sy = m[2] * m[2] + m[3] * m[3];
        var rotation = Math.atan2(m[1], m[0]);
        var shearX = Math.PI / 2 + rotation - Math.atan2(m[3], m[2]);
        sy = Math.sqrt(sy) * Math.cos(shearX);
        sx = Math.sqrt(sx);
        this.skewX = shearX;
        this.skewY = 0;
        this.rotation = -rotation;
        this.x = +m[4];
        this.y = +m[5];
        this.scaleX = sx;
        this.scaleY = sy;
        this.originX = 0;
        this.originY = 0;
    };
    Transformable.prototype.decomposeTransform = function() {
        if (!this.transform) return;
        var parent = this.parent;
        var m = this.transform;
        if (parent && parent.transform) {
            parent.invTransform = parent.invTransform || $45a6d43b639a6412$export$185802fd694ee1f5();
            $45a6d43b639a6412$export$6e3a27864ab166fe($ad30ab15d8ed0f32$var$tmpTransform, parent.invTransform, m);
            m = $ad30ab15d8ed0f32$var$tmpTransform;
        }
        var ox = this.originX;
        var oy = this.originY;
        if (ox || oy) {
            $ad30ab15d8ed0f32$var$originTransform[4] = ox;
            $ad30ab15d8ed0f32$var$originTransform[5] = oy;
            $45a6d43b639a6412$export$6e3a27864ab166fe($ad30ab15d8ed0f32$var$tmpTransform, m, $ad30ab15d8ed0f32$var$originTransform);
            $ad30ab15d8ed0f32$var$tmpTransform[4] -= ox;
            $ad30ab15d8ed0f32$var$tmpTransform[5] -= oy;
            m = $ad30ab15d8ed0f32$var$tmpTransform;
        }
        this.setLocalTransform(m);
    };
    Transformable.prototype.getGlobalScale = function(out) {
        var m = this.transform;
        out = out || [];
        if (!m) {
            out[0] = 1;
            out[1] = 1;
            return out;
        }
        out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
        out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
        if (m[0] < 0) out[0] = -out[0];
        if (m[3] < 0) out[1] = -out[1];
        return out;
    };
    Transformable.prototype.transformCoordToLocal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var invTransform = this.invTransform;
        if (invTransform) $f79ec7ea1294b339$export$9f9dcb98c894b623(v2, v2, invTransform);
        return v2;
    };
    Transformable.prototype.transformCoordToGlobal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var transform = this.transform;
        if (transform) $f79ec7ea1294b339$export$9f9dcb98c894b623(v2, v2, transform);
        return v2;
    };
    Transformable.prototype.getLineScale = function() {
        var m = this.transform;
        return m && $ad30ab15d8ed0f32$var$abs(m[0] - 1) > 1e-10 && $ad30ab15d8ed0f32$var$abs(m[3] - 1) > 1e-10 ? Math.sqrt($ad30ab15d8ed0f32$var$abs(m[0] * m[3] - m[2] * m[1])) : 1;
    };
    Transformable.prototype.copyTransform = function(source) {
        $ad30ab15d8ed0f32$export$234b1c16dfa57d6a(this, source);
    };
    Transformable.getLocalTransform = function(target, m) {
        m = m || [];
        var ox = target.originX || 0;
        var oy = target.originY || 0;
        var sx = target.scaleX;
        var sy = target.scaleY;
        var ax = target.anchorX;
        var ay = target.anchorY;
        var rotation = target.rotation || 0;
        var x = target.x;
        var y = target.y;
        var skewX = target.skewX ? Math.tan(target.skewX) : 0;
        var skewY = target.skewY ? Math.tan(-target.skewY) : 0;
        if (ox || oy || ax || ay) {
            var dx = ox + ax;
            var dy = oy + ay;
            m[4] = -dx * sx - skewX * dy * sy;
            m[5] = -dy * sy - skewY * dx * sx;
        } else m[4] = m[5] = 0;
        m[0] = sx;
        m[3] = sy;
        m[1] = skewY * sx;
        m[2] = skewX * sy;
        rotation && $45a6d43b639a6412$export$bb628a54ab399bc9(m, m, rotation);
        m[4] += ox + x;
        m[5] += oy + y;
        return m;
    };
    Transformable.initDefaultProps = function() {
        var proto = Transformable.prototype;
        proto.scaleX = proto.scaleY = proto.globalScaleRatio = 1;
        proto.x = proto.y = proto.originX = proto.originY = proto.skewX = proto.skewY = proto.rotation = proto.anchorX = proto.anchorY = 0;
    }();
    return Transformable;
}();
var $ad30ab15d8ed0f32$export$1157cd5386cdcc1b = $ad30ab15d8ed0f32$var$Transformable.getLocalTransform;
function $ad30ab15d8ed0f32$export$b78f9cf796c6d361() {
    return new $ad30ab15d8ed0f32$var$Transformable();
}
var $ad30ab15d8ed0f32$export$98ab6203ec3396e2 = [
    'x',
    'y',
    'originX',
    'originY',
    'anchorX',
    'anchorY',
    'rotation',
    'scaleX',
    'scaleY',
    'skewX',
    'skewY'
];
function $ad30ab15d8ed0f32$export$234b1c16dfa57d6a(target, source) {
    return (0, $f16f2994a32ad273$export$2b3af8009eff404f)(target, source, $ad30ab15d8ed0f32$export$98ab6203ec3396e2);
}
var $ad30ab15d8ed0f32$export$2e2bcd8739ae039 = $ad30ab15d8ed0f32$var$Transformable;








function $3ad1e5e308f2a981$export$3c49c185de0c2bfc(text, font) {
    return $3ad1e5e308f2a981$export$e6849d91c2a0b61f($3ad1e5e308f2a981$export$23ef3ef10b010856(font), text);
}
function $3ad1e5e308f2a981$export$23ef3ef10b010856(font) {
    if (!$3ad1e5e308f2a981$var$_fontMeasureInfoCache) $3ad1e5e308f2a981$var$_fontMeasureInfoCache = new (0, $5673a7dd695e5835$export$2e2bcd8739ae039)(100);
    font = font || (0, $e4ffe803d17351c8$export$7d7a232b6d2cc80c);
    var measureInfo = $3ad1e5e308f2a981$var$_fontMeasureInfoCache.get(font);
    if (!measureInfo) {
        measureInfo = {
            font: font,
            strWidthCache: new (0, $5673a7dd695e5835$export$2e2bcd8739ae039)(500),
            asciiWidthMap: null,
            asciiWidthMapTried: false,
            stWideCharWidth: (0, $e4ffe803d17351c8$export$ef5e599365494451).measureText("\u56FD", font).width,
            asciiCharWidth: (0, $e4ffe803d17351c8$export$ef5e599365494451).measureText('a', font).width
        };
        $3ad1e5e308f2a981$var$_fontMeasureInfoCache.put(font, measureInfo);
    }
    return measureInfo;
}
var $3ad1e5e308f2a981$var$_fontMeasureInfoCache;
function $3ad1e5e308f2a981$var$tryCreateASCIIWidthMap(font) {
    if ($3ad1e5e308f2a981$var$_getASCIIWidthMapLongCount >= $3ad1e5e308f2a981$var$GET_ASCII_WIDTH_LONG_COUNT_MAX) return;
    font = font || (0, $e4ffe803d17351c8$export$7d7a232b6d2cc80c);
    var asciiWidthMap = [];
    var start = +new Date();
    for(var code = 0; code <= 127; code++)asciiWidthMap[code] = (0, $e4ffe803d17351c8$export$ef5e599365494451).measureText(String.fromCharCode(code), font).width;
    var cost = +new Date() - start;
    if (cost > 16) $3ad1e5e308f2a981$var$_getASCIIWidthMapLongCount = $3ad1e5e308f2a981$var$GET_ASCII_WIDTH_LONG_COUNT_MAX;
    else if (cost > 2) $3ad1e5e308f2a981$var$_getASCIIWidthMapLongCount++;
    return asciiWidthMap;
}
var $3ad1e5e308f2a981$var$_getASCIIWidthMapLongCount = 0;
var $3ad1e5e308f2a981$var$GET_ASCII_WIDTH_LONG_COUNT_MAX = 5;
function $3ad1e5e308f2a981$export$4e92f5603b5c7bb3(fontMeasureInfo, charCode) {
    if (!fontMeasureInfo.asciiWidthMapTried) {
        fontMeasureInfo.asciiWidthMap = $3ad1e5e308f2a981$var$tryCreateASCIIWidthMap(fontMeasureInfo.font);
        fontMeasureInfo.asciiWidthMapTried = true;
    }
    return 0 <= charCode && charCode <= 127 ? fontMeasureInfo.asciiWidthMap != null ? fontMeasureInfo.asciiWidthMap[charCode] : fontMeasureInfo.asciiCharWidth : fontMeasureInfo.stWideCharWidth;
}
function $3ad1e5e308f2a981$export$e6849d91c2a0b61f(fontMeasureInfo, text) {
    var strWidthCache = fontMeasureInfo.strWidthCache;
    var width = strWidthCache.get(text);
    if (width == null) {
        width = (0, $e4ffe803d17351c8$export$ef5e599365494451).measureText(text, fontMeasureInfo.font).width;
        strWidthCache.put(text, width);
    }
    return width;
}
function $3ad1e5e308f2a981$export$85aabf24202fbe9b(text, font, textAlign, textBaseline) {
    var width = $3ad1e5e308f2a981$export$e6849d91c2a0b61f($3ad1e5e308f2a981$export$23ef3ef10b010856(font), text);
    var height = $3ad1e5e308f2a981$export$56204a27a2958a55(font);
    var x = $3ad1e5e308f2a981$export$eb5a525ef00ef9a4(0, width, textAlign);
    var y = $3ad1e5e308f2a981$export$bf7d6802d2badd9(0, height, textBaseline);
    var rect = new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(x, y, width, height);
    return rect;
}
function $3ad1e5e308f2a981$export$c381147bfed79d9f(text, font, textAlign, textBaseline) {
    var textLines = ((text || '') + '').split('\n');
    var len = textLines.length;
    if (len === 1) return $3ad1e5e308f2a981$export$85aabf24202fbe9b(textLines[0], font, textAlign, textBaseline);
    else {
        var uniondRect = new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(0, 0, 0, 0);
        for(var i = 0; i < textLines.length; i++){
            var rect = $3ad1e5e308f2a981$export$85aabf24202fbe9b(textLines[i], font, textAlign, textBaseline);
            i === 0 ? uniondRect.copy(rect) : uniondRect.union(rect);
        }
        return uniondRect;
    }
}
function $3ad1e5e308f2a981$export$eb5a525ef00ef9a4(x, width, textAlign, inverse) {
    if (textAlign === 'right') !inverse ? x -= width : x += width;
    else if (textAlign === 'center') !inverse ? x -= width / 2 : x += width / 2;
    return x;
}
function $3ad1e5e308f2a981$export$bf7d6802d2badd9(y, height, verticalAlign, inverse) {
    if (verticalAlign === 'middle') !inverse ? y -= height / 2 : y += height / 2;
    else if (verticalAlign === 'bottom') !inverse ? y -= height : y += height;
    return y;
}
function $3ad1e5e308f2a981$export$56204a27a2958a55(font) {
    return $3ad1e5e308f2a981$export$23ef3ef10b010856(font).stWideCharWidth;
}
function $3ad1e5e308f2a981$export$866cc30a33805630(text, font) {
    return (0, $e4ffe803d17351c8$export$ef5e599365494451).measureText(text, font);
}
function $3ad1e5e308f2a981$export$e8514cb5a5e2b40f(value, maxValue) {
    if (typeof value === 'string') {
        if (value.lastIndexOf('%') >= 0) return parseFloat(value) / 100 * maxValue;
        return parseFloat(value);
    }
    return value;
}
function $3ad1e5e308f2a981$export$eee3603b512feab7(out, opts, rect) {
    var textPosition = opts.position || 'inside';
    var distance = opts.distance != null ? opts.distance : 5;
    var height = rect.height;
    var width = rect.width;
    var halfHeight = height / 2;
    var x = rect.x;
    var y = rect.y;
    var textAlign = 'left';
    var textVerticalAlign = 'top';
    if (textPosition instanceof Array) {
        x += $3ad1e5e308f2a981$export$e8514cb5a5e2b40f(textPosition[0], rect.width);
        y += $3ad1e5e308f2a981$export$e8514cb5a5e2b40f(textPosition[1], rect.height);
        textAlign = null;
        textVerticalAlign = null;
    } else switch(textPosition){
        case 'left':
            x -= distance;
            y += halfHeight;
            textAlign = 'right';
            textVerticalAlign = 'middle';
            break;
        case 'right':
            x += distance + width;
            y += halfHeight;
            textVerticalAlign = 'middle';
            break;
        case 'top':
            x += width / 2;
            y -= distance;
            textAlign = 'center';
            textVerticalAlign = 'bottom';
            break;
        case 'bottom':
            x += width / 2;
            y += height + distance;
            textAlign = 'center';
            break;
        case 'inside':
            x += width / 2;
            y += halfHeight;
            textAlign = 'center';
            textVerticalAlign = 'middle';
            break;
        case 'insideLeft':
            x += distance;
            y += halfHeight;
            textVerticalAlign = 'middle';
            break;
        case 'insideRight':
            x += width - distance;
            y += halfHeight;
            textAlign = 'right';
            textVerticalAlign = 'middle';
            break;
        case 'insideTop':
            x += width / 2;
            y += distance;
            textAlign = 'center';
            break;
        case 'insideBottom':
            x += width / 2;
            y += height - distance;
            textAlign = 'center';
            textVerticalAlign = 'bottom';
            break;
        case 'insideTopLeft':
            x += distance;
            y += distance;
            break;
        case 'insideTopRight':
            x += width - distance;
            y += distance;
            textAlign = 'right';
            break;
        case 'insideBottomLeft':
            x += distance;
            y += height - distance;
            textVerticalAlign = 'bottom';
            break;
        case 'insideBottomRight':
            x += width - distance;
            y += height - distance;
            textAlign = 'right';
            textVerticalAlign = 'bottom';
            break;
    }
    out = out || {};
    out.x = x;
    out.y = y;
    out.align = textAlign;
    out.verticalAlign = textVerticalAlign;
    return out;
}







var $05d7569c5e654d58$export$97b5e845c7286801 = '__zr_normal__';
var $05d7569c5e654d58$var$PRIMARY_STATES_KEYS = (0, $ad30ab15d8ed0f32$export$98ab6203ec3396e2).concat([
    'ignore'
]);
var $05d7569c5e654d58$var$DEFAULT_ANIMATABLE_MAP = (0, $f16f2994a32ad273$export$533b26079ad0b4b)((0, $ad30ab15d8ed0f32$export$98ab6203ec3396e2), function(obj, key) {
    obj[key] = true;
    return obj;
}, {
    ignore: false
});
var $05d7569c5e654d58$var$tmpTextPosCalcRes = {};
var $05d7569c5e654d58$var$tmpBoundingRect = new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $05d7569c5e654d58$var$tmpInnerTextTrans = [];
var $05d7569c5e654d58$export$afb92d844f688c8d = 0;
var $05d7569c5e654d58$export$f5347ae640a7f0d0 = 1;
var $05d7569c5e654d58$var$Element = function() {
    function Element(props) {
        this.id = (0, $f16f2994a32ad273$export$46e8f25c7328f77e)();
        this.animators = [];
        this.currentStates = [];
        this.states = {};
        this._init(props);
    }
    Element.prototype._init = function(props) {
        this.attr(props);
    };
    Element.prototype.drift = function(dx, dy, e) {
        switch(this.draggable){
            case 'horizontal':
                dy = 0;
                break;
            case 'vertical':
                dx = 0;
                break;
        }
        var m = this.transform;
        if (!m) m = this.transform = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        m[4] += dx;
        m[5] += dy;
        this.decomposeTransform();
        this.markRedraw();
    };
    Element.prototype.beforeUpdate = function() {};
    Element.prototype.afterUpdate = function() {};
    Element.prototype.update = function() {
        this.updateTransform();
        if (this.__dirty) this.updateInnerText();
    };
    Element.prototype.updateInnerText = function(forceUpdate) {
        var textEl = this._textContent;
        if (textEl && (!textEl.ignore || forceUpdate)) {
            if (!this.textConfig) this.textConfig = {};
            var textConfig = this.textConfig;
            var isLocal = textConfig.local;
            var innerTransformable = textEl.innerTransformable;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var textStyleChanged = false;
            innerTransformable.parent = isLocal ? this : null;
            var innerOrigin = false;
            innerTransformable.copyTransform(textEl);
            var hasPosition = textConfig.position != null;
            var autoOverflowArea = textConfig.autoOverflowArea;
            var layoutRect = void 0;
            if (autoOverflowArea || hasPosition) {
                layoutRect = $05d7569c5e654d58$var$tmpBoundingRect;
                if (textConfig.layoutRect) layoutRect.copy(textConfig.layoutRect);
                else layoutRect.copy(this.getBoundingRect());
                if (!isLocal) layoutRect.applyTransform(this.transform);
            }
            if (hasPosition) {
                if (this.calculateTextPosition) this.calculateTextPosition($05d7569c5e654d58$var$tmpTextPosCalcRes, textConfig, layoutRect);
                else (0, $3ad1e5e308f2a981$export$eee3603b512feab7)($05d7569c5e654d58$var$tmpTextPosCalcRes, textConfig, layoutRect);
                innerTransformable.x = $05d7569c5e654d58$var$tmpTextPosCalcRes.x;
                innerTransformable.y = $05d7569c5e654d58$var$tmpTextPosCalcRes.y;
                textAlign = $05d7569c5e654d58$var$tmpTextPosCalcRes.align;
                textVerticalAlign = $05d7569c5e654d58$var$tmpTextPosCalcRes.verticalAlign;
                var textOrigin = textConfig.origin;
                if (textOrigin && textConfig.rotation != null) {
                    var relOriginX = void 0;
                    var relOriginY = void 0;
                    if (textOrigin === 'center') {
                        relOriginX = layoutRect.width * 0.5;
                        relOriginY = layoutRect.height * 0.5;
                    } else {
                        relOriginX = (0, $3ad1e5e308f2a981$export$e8514cb5a5e2b40f)(textOrigin[0], layoutRect.width);
                        relOriginY = (0, $3ad1e5e308f2a981$export$e8514cb5a5e2b40f)(textOrigin[1], layoutRect.height);
                    }
                    innerOrigin = true;
                    innerTransformable.originX = -innerTransformable.x + relOriginX + (isLocal ? 0 : layoutRect.x);
                    innerTransformable.originY = -innerTransformable.y + relOriginY + (isLocal ? 0 : layoutRect.y);
                }
            }
            if (textConfig.rotation != null) innerTransformable.rotation = textConfig.rotation;
            var textOffset = textConfig.offset;
            if (textOffset) {
                innerTransformable.x += textOffset[0];
                innerTransformable.y += textOffset[1];
                if (!innerOrigin) {
                    innerTransformable.originX = -textOffset[0];
                    innerTransformable.originY = -textOffset[1];
                }
            }
            var innerTextDefaultStyle = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {});
            if (autoOverflowArea) {
                var overflowRect = innerTextDefaultStyle.overflowRect = innerTextDefaultStyle.overflowRect || new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(0, 0, 0, 0);
                innerTransformable.getLocalTransform($05d7569c5e654d58$var$tmpInnerTextTrans);
                (0, $45a6d43b639a6412$export$6897c284b6f9f4dc)($05d7569c5e654d58$var$tmpInnerTextTrans, $05d7569c5e654d58$var$tmpInnerTextTrans);
                (0, $7456366ce379c42e$export$2e2bcd8739ae039).copy(overflowRect, layoutRect);
                overflowRect.applyTransform($05d7569c5e654d58$var$tmpInnerTextTrans);
            } else innerTextDefaultStyle.overflowRect = null;
            var isInside = textConfig.inside == null ? typeof textConfig.position === 'string' && textConfig.position.indexOf('inside') >= 0 : textConfig.inside;
            var textFill = void 0;
            var textStroke = void 0;
            var autoStroke = void 0;
            if (isInside && this.canBeInsideText()) {
                textFill = textConfig.insideFill;
                textStroke = textConfig.insideStroke;
                if (textFill == null || textFill === 'auto') textFill = this.getInsideTextFill();
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getInsideTextStroke(textFill);
                    autoStroke = true;
                }
            } else {
                textFill = textConfig.outsideFill;
                textStroke = textConfig.outsideStroke;
                if (textFill == null || textFill === 'auto') textFill = this.getOutsideFill();
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getOutsideStroke(textFill);
                    autoStroke = true;
                }
            }
            textFill = textFill || '#000';
            if (textFill !== innerTextDefaultStyle.fill || textStroke !== innerTextDefaultStyle.stroke || autoStroke !== innerTextDefaultStyle.autoStroke || textAlign !== innerTextDefaultStyle.align || textVerticalAlign !== innerTextDefaultStyle.verticalAlign) {
                textStyleChanged = true;
                innerTextDefaultStyle.fill = textFill;
                innerTextDefaultStyle.stroke = textStroke;
                innerTextDefaultStyle.autoStroke = autoStroke;
                innerTextDefaultStyle.align = textAlign;
                innerTextDefaultStyle.verticalAlign = textVerticalAlign;
                textEl.setDefaultTextStyle(innerTextDefaultStyle);
            }
            textEl.__dirty |= (0, $66869c587f14f122$export$a7b6db622c6c7dbd);
            if (textStyleChanged) textEl.dirtyStyle(true);
        }
    };
    Element.prototype.canBeInsideText = function() {
        return true;
    };
    Element.prototype.getInsideTextFill = function() {
        return '#fff';
    };
    Element.prototype.getInsideTextStroke = function(textFill) {
        return '#000';
    };
    Element.prototype.getOutsideFill = function() {
        return this.__zr && this.__zr.isDarkMode() ? (0, $e374994bc8dfd1f0$export$3c6e95f318c8369b) : (0, $e374994bc8dfd1f0$export$f8ce94761f39398d);
    };
    Element.prototype.getOutsideStroke = function(textFill) {
        var backgroundColor = this.__zr && this.__zr.getBackgroundColor();
        var colorArr = typeof backgroundColor === 'string' && (0, $83e50b4ee4d3c357$export$98e6a39c04603d36)(backgroundColor);
        if (!colorArr) colorArr = [
            255,
            255,
            255,
            1
        ];
        var alpha = colorArr[3];
        var isDark = this.__zr.isDarkMode();
        for(var i = 0; i < 3; i++)colorArr[i] = colorArr[i] * alpha + (isDark ? 0 : 255) * (1 - alpha);
        colorArr[3] = 1;
        return (0, $83e50b4ee4d3c357$export$fac44ee5b035f737)(colorArr, 'rgba');
    };
    Element.prototype.traverse = function(cb, context) {};
    Element.prototype.attrKV = function(key, value) {
        if (key === 'textConfig') this.setTextConfig(value);
        else if (key === 'textContent') this.setTextContent(value);
        else if (key === 'clipPath') this.setClipPath(value);
        else if (key === 'extra') {
            this.extra = this.extra || {};
            (0, $f16f2994a32ad273$export$8b58be045bf06082)(this.extra, value);
        } else this[key] = value;
    };
    Element.prototype.hide = function() {
        this.ignore = true;
        this.markRedraw();
    };
    Element.prototype.show = function() {
        this.ignore = false;
        this.markRedraw();
    };
    Element.prototype.attr = function(keyOrObj, value) {
        if (typeof keyOrObj === 'string') this.attrKV(keyOrObj, value);
        else if ((0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(keyOrObj)) {
            var obj = keyOrObj;
            var keysArr = (0, $f16f2994a32ad273$export$ed97f33186d4b816)(obj);
            for(var i = 0; i < keysArr.length; i++){
                var key = keysArr[i];
                this.attrKV(key, keyOrObj[key]);
            }
        }
        this.markRedraw();
        return this;
    };
    Element.prototype.saveCurrentToNormalState = function(toState) {
        this._innerSaveToNormal(toState);
        var normalState = this._normalState;
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var fromStateTransition = animator.__fromStateTransition;
            if (animator.getLoop() || fromStateTransition && fromStateTransition !== $05d7569c5e654d58$export$97b5e845c7286801) continue;
            var targetName = animator.targetName;
            var target = targetName ? normalState[targetName] : normalState;
            animator.saveTo(target);
        }
    };
    Element.prototype._innerSaveToNormal = function(toState) {
        var normalState = this._normalState;
        if (!normalState) normalState = this._normalState = {};
        if (toState.textConfig && !normalState.textConfig) normalState.textConfig = this.textConfig;
        this._savePrimaryToNormal(toState, normalState, $05d7569c5e654d58$var$PRIMARY_STATES_KEYS);
    };
    Element.prototype._savePrimaryToNormal = function(toState, normalState, primaryKeys) {
        for(var i = 0; i < primaryKeys.length; i++){
            var key = primaryKeys[i];
            if (toState[key] != null && !(key in normalState)) normalState[key] = this[key];
        }
    };
    Element.prototype.hasState = function() {
        return this.currentStates.length > 0;
    };
    Element.prototype.getState = function(name) {
        return this.states[name];
    };
    Element.prototype.ensureState = function(name) {
        var states = this.states;
        if (!states[name]) states[name] = {};
        return states[name];
    };
    Element.prototype.clearStates = function(noAnimation) {
        this.useState($05d7569c5e654d58$export$97b5e845c7286801, false, noAnimation);
    };
    Element.prototype.useState = function(stateName, keepCurrentStates, noAnimation, forceUseHoverLayer) {
        var toNormalState = stateName === $05d7569c5e654d58$export$97b5e845c7286801;
        var hasStates = this.hasState();
        if (!hasStates && toNormalState) return;
        var currentStates = this.currentStates;
        var animationCfg = this.stateTransition;
        if ((0, $f16f2994a32ad273$export$305f7d4e9d4624f2)(currentStates, stateName) >= 0 && (keepCurrentStates || currentStates.length === 1)) return;
        var state;
        if (this.stateProxy && !toNormalState) state = this.stateProxy(stateName);
        if (!state) state = this.states && this.states[stateName];
        if (!state && !toNormalState) {
            (0, $f16f2994a32ad273$export$58da9968c3170cb1)("State " + stateName + " not exists.");
            return;
        }
        if (!toNormalState) this.saveCurrentToNormalState(state);
        var textContent = this._textContent;
        var useHoverLayer = $05d7569c5e654d58$var$shouldUseHoverLayer(this, textContent, state, forceUseHoverLayer);
        if (useHoverLayer && !this.__inHover) this.__inHover = useHoverLayer;
        this._applyStateObj(stateName, state, this._normalState, keepCurrentStates, $05d7569c5e654d58$var$canTransition(this, noAnimation, animationCfg), animationCfg);
        var textGuide = this._textGuide;
        if (textContent) textContent.useState(stateName, keepCurrentStates, noAnimation, !!useHoverLayer);
        if (textGuide) textGuide.useState(stateName, keepCurrentStates, noAnimation, !!useHoverLayer);
        if (toNormalState) {
            this.currentStates = [];
            this._normalState = {};
        } else if (!keepCurrentStates) this.currentStates = [
            stateName
        ];
        else this.currentStates.push(stateName);
        this._updateAnimationTargets();
        this.markRedraw();
        if (!useHoverLayer && this.__inHover) {
            this.__inHover = $05d7569c5e654d58$export$afb92d844f688c8d;
            this.__dirty &= ~(0, $66869c587f14f122$export$a7b6db622c6c7dbd);
        }
        return state;
    };
    Element.prototype.useStates = function(states, noAnimation, forceUseHoverLayer) {
        if (!states.length) this.clearStates();
        else {
            var stateObjects = [];
            var currentStates = this.currentStates;
            var len = states.length;
            var notChange = len === currentStates.length;
            if (notChange) {
                for(var i = 0; i < len; i++)if (states[i] !== currentStates[i]) {
                    notChange = false;
                    break;
                }
            }
            if (notChange) return;
            for(var i = 0; i < len; i++){
                var stateName = states[i];
                var stateObj = void 0;
                if (this.stateProxy) stateObj = this.stateProxy(stateName, states);
                if (!stateObj) stateObj = this.states[stateName];
                if (stateObj) stateObjects.push(stateObj);
            }
            var lastStateObj = stateObjects[len - 1];
            var textContent = this._textContent;
            var useHoverLayer = $05d7569c5e654d58$var$shouldUseHoverLayer(this, textContent, lastStateObj, forceUseHoverLayer);
            if (useHoverLayer && !this.__inHover) this.__inHover = useHoverLayer;
            var mergedState = this._mergeStates(stateObjects);
            var animationCfg = this.stateTransition;
            this.saveCurrentToNormalState(mergedState);
            this._applyStateObj(states.join(','), mergedState, this._normalState, false, $05d7569c5e654d58$var$canTransition(this, noAnimation, animationCfg), animationCfg);
            var textGuide = this._textGuide;
            if (textContent) textContent.useStates(states, noAnimation, !!useHoverLayer);
            if (textGuide) textGuide.useStates(states, noAnimation, !!useHoverLayer);
            this._updateAnimationTargets();
            this.currentStates = states.slice();
            this.markRedraw();
            if (!useHoverLayer && this.__inHover) {
                this.__inHover = $05d7569c5e654d58$export$afb92d844f688c8d;
                this.__dirty &= ~(0, $66869c587f14f122$export$a7b6db622c6c7dbd);
            }
        }
    };
    Element.prototype.isSilent = function() {
        var el = this;
        while(el){
            if (el.silent) return true;
            var hostEl = el.__hostTarget;
            el = hostEl ? el.ignoreHostSilent ? null : hostEl : el.parent;
        }
        return false;
    };
    Element.prototype._updateAnimationTargets = function() {
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            if (animator.targetName) animator.changeTarget(this[animator.targetName]);
        }
    };
    Element.prototype.removeState = function(state) {
        var idx = (0, $f16f2994a32ad273$export$305f7d4e9d4624f2)(this.currentStates, state);
        if (idx >= 0) {
            var currentStates = this.currentStates.slice();
            currentStates.splice(idx, 1);
            this.useStates(currentStates);
        }
    };
    Element.prototype.replaceState = function(oldState, newState, forceAdd) {
        var currentStates = this.currentStates.slice();
        var idx = (0, $f16f2994a32ad273$export$305f7d4e9d4624f2)(currentStates, oldState);
        var newStateExists = (0, $f16f2994a32ad273$export$305f7d4e9d4624f2)(currentStates, newState) >= 0;
        if (idx >= 0) {
            if (!newStateExists) currentStates[idx] = newState;
            else currentStates.splice(idx, 1);
        } else if (forceAdd && !newStateExists) currentStates.push(newState);
        this.useStates(currentStates);
    };
    Element.prototype.toggleState = function(state, enable) {
        if (enable) this.useState(state, true);
        else this.removeState(state);
    };
    Element.prototype._mergeStates = function(states) {
        var mergedState = {};
        var mergedTextConfig;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            (0, $f16f2994a32ad273$export$8b58be045bf06082)(mergedState, state);
            if (state.textConfig) {
                mergedTextConfig = mergedTextConfig || {};
                (0, $f16f2994a32ad273$export$8b58be045bf06082)(mergedTextConfig, state.textConfig);
            }
        }
        if (mergedTextConfig) mergedState.textConfig = mergedTextConfig;
        return mergedState;
    };
    Element.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        if (this.__inHover === $05d7569c5e654d58$export$f5347ae640a7f0d0) return;
        var needsRestoreToNormal = !(state && keepCurrentStates);
        if (state && state.textConfig) {
            this.textConfig = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, keepCurrentStates ? this.textConfig : normalState.textConfig);
            (0, $f16f2994a32ad273$export$8b58be045bf06082)(this.textConfig, state.textConfig);
        } else if (needsRestoreToNormal) {
            if (normalState.textConfig) this.textConfig = normalState.textConfig;
        }
        var transitionTarget = {};
        var hasTransition = false;
        for(var i = 0; i < $05d7569c5e654d58$var$PRIMARY_STATES_KEYS.length; i++){
            var key = $05d7569c5e654d58$var$PRIMARY_STATES_KEYS[i];
            var propNeedsTransition = transition && $05d7569c5e654d58$var$DEFAULT_ANIMATABLE_MAP[key];
            if (state && state[key] != null) {
                if (propNeedsTransition) {
                    hasTransition = true;
                    transitionTarget[key] = state[key];
                } else this[key] = state[key];
            } else if (needsRestoreToNormal) {
                if (normalState[key] != null) {
                    if (propNeedsTransition) {
                        hasTransition = true;
                        transitionTarget[key] = normalState[key];
                    } else this[key] = normalState[key];
                }
            }
        }
        if (!transition) for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var targetName = animator.targetName;
            if (!animator.getLoop()) animator.__changeFinalValue(targetName ? (state || normalState)[targetName] : state || normalState);
        }
        if (hasTransition) this._transitionState(stateName, transitionTarget, animationCfg);
    };
    Element.prototype._attachComponent = function(componentEl) {
        if (componentEl.__zr && !componentEl.__hostTarget) return;
        if (componentEl === this) return;
        var zr = this.__zr;
        if (zr) componentEl.addSelfToZr(zr);
        componentEl.__zr = zr;
        componentEl.__hostTarget = this;
    };
    Element.prototype._detachComponent = function(componentEl) {
        if (componentEl.__zr) componentEl.removeSelfFromZr(componentEl.__zr);
        componentEl.__zr = null;
        componentEl.__hostTarget = null;
    };
    Element.prototype.getClipPath = function() {
        return this._clipPath;
    };
    Element.prototype.setClipPath = function(clipPath) {
        if (this._clipPath && this._clipPath !== clipPath) this.removeClipPath();
        this._attachComponent(clipPath);
        this._clipPath = clipPath;
        this.markRedraw();
    };
    Element.prototype.removeClipPath = function() {
        var clipPath = this._clipPath;
        if (clipPath) {
            this._detachComponent(clipPath);
            this._clipPath = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextContent = function() {
        return this._textContent;
    };
    Element.prototype.setTextContent = function(textEl) {
        var previousTextContent = this._textContent;
        if (previousTextContent === textEl) return;
        if (previousTextContent && previousTextContent !== textEl) this.removeTextContent();
        textEl.innerTransformable = new (0, $ad30ab15d8ed0f32$export$2e2bcd8739ae039)();
        this._attachComponent(textEl);
        this._textContent = textEl;
        this.markRedraw();
    };
    Element.prototype.setTextConfig = function(cfg) {
        if (!this.textConfig) this.textConfig = {};
        (0, $f16f2994a32ad273$export$8b58be045bf06082)(this.textConfig, cfg);
        this.markRedraw();
    };
    Element.prototype.removeTextConfig = function() {
        this.textConfig = null;
        this.markRedraw();
    };
    Element.prototype.removeTextContent = function() {
        var textEl = this._textContent;
        if (textEl) {
            textEl.innerTransformable = null;
            this._detachComponent(textEl);
            this._textContent = null;
            this._innerTextDefaultStyle = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextGuideLine = function() {
        return this._textGuide;
    };
    Element.prototype.setTextGuideLine = function(guideLine) {
        if (this._textGuide && this._textGuide !== guideLine) this.removeTextGuideLine();
        this._attachComponent(guideLine);
        this._textGuide = guideLine;
        this.markRedraw();
    };
    Element.prototype.removeTextGuideLine = function() {
        var textGuide = this._textGuide;
        if (textGuide) {
            this._detachComponent(textGuide);
            this._textGuide = null;
            this.markRedraw();
        }
    };
    Element.prototype.markRedraw = function() {
        this.__dirty |= (0, $66869c587f14f122$export$a7b6db622c6c7dbd);
        var zr = this.__zr;
        if (zr) {
            if (this.__inHover) zr.refreshHover();
            else zr.refresh();
        }
        if (this.__hostTarget) this.__hostTarget.markRedraw();
    };
    Element.prototype.dirty = function() {
        this.markRedraw();
    };
    Element.prototype.addSelfToZr = function(zr) {
        if (this.__zr === zr) return;
        this.__zr = zr;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.addAnimator(animators[i]);
        if (this._clipPath) this._clipPath.addSelfToZr(zr);
        if (this._textContent) this._textContent.addSelfToZr(zr);
        if (this._textGuide) this._textGuide.addSelfToZr(zr);
    };
    Element.prototype.removeSelfFromZr = function(zr) {
        if (!this.__zr) return;
        this.__zr = null;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.removeAnimator(animators[i]);
        if (this._clipPath) this._clipPath.removeSelfFromZr(zr);
        if (this._textContent) this._textContent.removeSelfFromZr(zr);
        if (this._textGuide) this._textGuide.removeSelfFromZr(zr);
    };
    Element.prototype.animate = function(key, loop, allowDiscreteAnimation) {
        var target = key ? this[key] : this;
        var animator = new (0, $6b46db59980e54a6$export$2e2bcd8739ae039)(target, loop, allowDiscreteAnimation);
        key && (animator.targetName = key);
        this.addAnimator(animator, key);
        return animator;
    };
    Element.prototype.addAnimator = function(animator, key) {
        var zr = this.__zr;
        var el = this;
        animator.during(function() {
            el.updateDuringAnimation(key);
        }).done(function() {
            var animators = el.animators;
            var idx = (0, $f16f2994a32ad273$export$305f7d4e9d4624f2)(animators, animator);
            if (idx >= 0) animators.splice(idx, 1);
        });
        this.animators.push(animator);
        if (zr) zr.animation.addAnimator(animator);
        zr && zr.wakeUp();
    };
    Element.prototype.updateDuringAnimation = function(key) {
        this.markRedraw();
    };
    Element.prototype.stopAnimation = function(scope, forwardToLast) {
        var animators = this.animators;
        var len = animators.length;
        var leftAnimators = [];
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            if (!scope || scope === animator.scope) animator.stop(forwardToLast);
            else leftAnimators.push(animator);
        }
        this.animators = leftAnimators;
        return this;
    };
    Element.prototype.animateTo = function(target, cfg, animationProps) {
        $05d7569c5e654d58$var$animateTo(this, target, cfg, animationProps);
    };
    Element.prototype.animateFrom = function(target, cfg, animationProps) {
        $05d7569c5e654d58$var$animateTo(this, target, cfg, animationProps, true);
    };
    Element.prototype._transitionState = function(stateName, target, cfg, animationProps) {
        var animators = $05d7569c5e654d58$var$animateTo(this, target, cfg, animationProps);
        for(var i = 0; i < animators.length; i++)animators[i].__fromStateTransition = stateName;
    };
    Element.prototype.getBoundingRect = function() {
        return null;
    };
    Element.prototype.getPaintRect = function() {
        return null;
    };
    Element.initDefaultProps = function() {
        var elProto = Element.prototype;
        elProto.type = 'element';
        elProto.name = '';
        elProto.ignore = elProto.silent = elProto.ignoreHostSilent = elProto.isGroup = elProto.draggable = elProto.dragging = elProto.ignoreClip = false;
        elProto.__inHover = $05d7569c5e654d58$export$afb92d844f688c8d;
        elProto.__dirty = (0, $66869c587f14f122$export$a7b6db622c6c7dbd);
        var logs = {};
        function logDeprecatedError(key, xKey, yKey) {
            if (!logs[key + xKey + yKey]) {
                console.warn("DEPRECATED: '" + key + "' has been deprecated. use '" + xKey + "', '" + yKey + "' instead");
                logs[key + xKey + yKey] = true;
            }
        }
        function createLegacyProperty(key, privateKey, xKey, yKey) {
            Object.defineProperty(elProto, key, {
                get: function get() {
                    if (!this[privateKey]) {
                        var pos = this[privateKey] = [];
                        enhanceArray(this, pos);
                    }
                    return this[privateKey];
                },
                set: function set(pos) {
                    this[xKey] = pos[0];
                    this[yKey] = pos[1];
                    this[privateKey] = pos;
                    enhanceArray(this, pos);
                }
            });
            function enhanceArray(self, pos) {
                Object.defineProperty(pos, 0, {
                    get: function get() {
                        return self[xKey];
                    },
                    set: function set(val) {
                        self[xKey] = val;
                    }
                });
                Object.defineProperty(pos, 1, {
                    get: function get() {
                        return self[yKey];
                    },
                    set: function set(val) {
                        self[yKey] = val;
                    }
                });
            }
        }
        if (Object.defineProperty) {
            createLegacyProperty('position', '_legacyPos', 'x', 'y');
            createLegacyProperty('scale', '_legacyScale', 'scaleX', 'scaleY');
            createLegacyProperty('origin', '_legacyOrigin', 'originX', 'originY');
        }
    }();
    return Element;
}();
(0, $f16f2994a32ad273$export$e36fc9d62a853069)($05d7569c5e654d58$var$Element, (0, $83f1d7c1143fe0f3$export$2e2bcd8739ae039));
(0, $f16f2994a32ad273$export$e36fc9d62a853069)($05d7569c5e654d58$var$Element, (0, $ad30ab15d8ed0f32$export$2e2bcd8739ae039));
function $05d7569c5e654d58$var$animateTo(animatable, target, cfg, animationProps, reverse) {
    cfg = cfg || {};
    var animators = [];
    $05d7569c5e654d58$var$animateToShallow(animatable, '', animatable, target, cfg, animationProps, animators, reverse);
    var finishCount = animators.length;
    var doneHappened = false;
    var cfgDone = cfg.done;
    var cfgAborted = cfg.aborted;
    var doneCb = function doneCb() {
        doneHappened = true;
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    var abortedCb = function abortedCb() {
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    if (!finishCount) cfgDone && cfgDone();
    if (animators.length > 0 && cfg.during) animators[0].during(function(target, percent) {
        cfg.during(percent);
    });
    for(var i = 0; i < animators.length; i++){
        var animator = animators[i];
        if (doneCb) animator.done(doneCb);
        if (abortedCb) animator.aborted(abortedCb);
        if (cfg.force) animator.duration(cfg.duration);
        animator.start(cfg.easing);
    }
    return animators;
}
function $05d7569c5e654d58$var$copyArrShallow(source, target, len) {
    for(var i = 0; i < len; i++)source[i] = target[i];
}
function $05d7569c5e654d58$var$is2DArray(value) {
    return (0, $f16f2994a32ad273$export$1e2f57719e155213)(value[0]);
}
function $05d7569c5e654d58$var$copyValue(target, source, key) {
    if ((0, $f16f2994a32ad273$export$1e2f57719e155213)(source[key])) {
        if (!(0, $f16f2994a32ad273$export$1e2f57719e155213)(target[key])) target[key] = [];
        if ((0, $f16f2994a32ad273$export$b119cc7e1840e59c)(source[key])) {
            var len = source[key].length;
            if (target[key].length !== len) {
                target[key] = new source[key].constructor(len);
                $05d7569c5e654d58$var$copyArrShallow(target[key], source[key], len);
            }
        } else {
            var sourceArr = source[key];
            var targetArr = target[key];
            var len0 = sourceArr.length;
            if ($05d7569c5e654d58$var$is2DArray(sourceArr)) {
                var len1 = sourceArr[0].length;
                for(var i = 0; i < len0; i++)if (!targetArr[i]) targetArr[i] = Array.prototype.slice.call(sourceArr[i]);
                else $05d7569c5e654d58$var$copyArrShallow(targetArr[i], sourceArr[i], len1);
            } else $05d7569c5e654d58$var$copyArrShallow(targetArr, sourceArr, len0);
            targetArr.length = sourceArr.length;
        }
    } else target[key] = source[key];
}
function $05d7569c5e654d58$var$isValueSame(val1, val2) {
    return val1 === val2 || (0, $f16f2994a32ad273$export$1e2f57719e155213)(val1) && (0, $f16f2994a32ad273$export$1e2f57719e155213)(val2) && $05d7569c5e654d58$var$is1DArraySame(val1, val2);
}
function $05d7569c5e654d58$var$is1DArraySame(arr0, arr1) {
    var len = arr0.length;
    if (len !== arr1.length) return false;
    for(var i = 0; i < len; i++){
        if (arr0[i] !== arr1[i]) return false;
    }
    return true;
}
function $05d7569c5e654d58$var$animateToShallow(animatable, topKey, animateObj, target, cfg, animationProps, animators, reverse) {
    var targetKeys = (0, $f16f2994a32ad273$export$ed97f33186d4b816)(target);
    var duration = cfg.duration;
    var delay = cfg.delay;
    var additive = cfg.additive;
    var setToFinal = cfg.setToFinal;
    var animateAll = !(0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(animationProps);
    var existsAnimators = animatable.animators;
    var animationKeys = [];
    for(var k = 0; k < targetKeys.length; k++){
        var innerKey = targetKeys[k];
        var targetVal = target[innerKey];
        if (targetVal != null && animateObj[innerKey] != null && (animateAll || animationProps[innerKey])) {
            if ((0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(targetVal) && !(0, $f16f2994a32ad273$export$1e2f57719e155213)(targetVal) && !(0, $f16f2994a32ad273$export$fa2c283003ed971c)(targetVal)) {
                if (topKey) {
                    if (!reverse) {
                        animateObj[innerKey] = targetVal;
                        animatable.updateDuringAnimation(topKey);
                    }
                    continue;
                }
                $05d7569c5e654d58$var$animateToShallow(animatable, innerKey, animateObj[innerKey], targetVal, cfg, animationProps && animationProps[innerKey], animators, reverse);
            } else animationKeys.push(innerKey);
        } else if (!reverse) {
            animateObj[innerKey] = targetVal;
            animatable.updateDuringAnimation(topKey);
            animationKeys.push(innerKey);
        }
    }
    var keyLen = animationKeys.length;
    if (!additive && keyLen) for(var i = 0; i < existsAnimators.length; i++){
        var animator = existsAnimators[i];
        if (animator.targetName === topKey) {
            var allAborted = animator.stopTracks(animationKeys);
            if (allAborted) {
                var idx = (0, $f16f2994a32ad273$export$305f7d4e9d4624f2)(existsAnimators, animator);
                existsAnimators.splice(idx, 1);
            }
        }
    }
    if (!cfg.force) {
        animationKeys = (0, $f16f2994a32ad273$export$3dea766d36a8935f)(animationKeys, function(key) {
            return !$05d7569c5e654d58$var$isValueSame(target[key], animateObj[key]);
        });
        keyLen = animationKeys.length;
    }
    if (keyLen > 0 || cfg.force && !animators.length) {
        var revertedSource = void 0;
        var reversedTarget = void 0;
        var sourceClone = void 0;
        if (reverse) {
            reversedTarget = {};
            if (setToFinal) revertedSource = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animationKeys[i];
                reversedTarget[innerKey] = animateObj[innerKey];
                if (setToFinal) revertedSource[innerKey] = target[innerKey];
                else animateObj[innerKey] = target[innerKey];
            }
        } else if (setToFinal) {
            sourceClone = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animationKeys[i];
                sourceClone[innerKey] = (0, $6b46db59980e54a6$export$c5e92b7f105af84e)(animateObj[innerKey]);
                $05d7569c5e654d58$var$copyValue(animateObj, target, innerKey);
            }
        }
        var animator = new (0, $6b46db59980e54a6$export$2e2bcd8739ae039)(animateObj, false, false, additive ? (0, $f16f2994a32ad273$export$3dea766d36a8935f)(existsAnimators, function(animator) {
            return animator.targetName === topKey;
        }) : null);
        animator.targetName = topKey;
        if (cfg.scope) animator.scope = cfg.scope;
        if (setToFinal && revertedSource) animator.whenWithKeys(0, revertedSource, animationKeys);
        if (sourceClone) animator.whenWithKeys(0, sourceClone, animationKeys);
        animator.whenWithKeys(duration == null ? 500 : duration, reverse ? reversedTarget : target, animationKeys).delay(delay || 0);
        animatable.addAnimator(animator, topKey);
        animators.push(animator);
    }
}
function $05d7569c5e654d58$var$shouldUseHoverLayer(el, textContent, nextState, forceUseHoverLayer) {
    return !(nextState && nextState.hoverLayer || forceUseHoverLayer) || $05d7569c5e654d58$var$isTextRelatedEl(el) || textContent && $05d7569c5e654d58$var$isTextRelatedEl(textContent) ? $05d7569c5e654d58$export$afb92d844f688c8d : $05d7569c5e654d58$export$f5347ae640a7f0d0;
}
function $05d7569c5e654d58$var$isTextRelatedEl(el) {
    return el.type === 'text' || el.type === 'tspan';
}
function $05d7569c5e654d58$var$canTransition(el, noAnimation, animationCfg) {
    return !noAnimation && !el.__inHover && animationCfg && animationCfg.duration > 0;
}
var $05d7569c5e654d58$export$2e2bcd8739ae039 = $05d7569c5e654d58$var$Element;



var $ac4abc1f547da31a$var$Group = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Group, _super);
    function Group(opts) {
        var _this = _super.call(this) || this;
        _this.isGroup = true;
        _this._children = [];
        _this.attr(opts);
        return _this;
    }
    Group.prototype.childrenRef = function() {
        return this._children;
    };
    Group.prototype.children = function() {
        return this._children.slice();
    };
    Group.prototype.childAt = function(idx) {
        return this._children[idx];
    };
    Group.prototype.childOfName = function(name) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            if (children[i].name === name) return children[i];
        }
    };
    Group.prototype.childCount = function() {
        return this._children.length;
    };
    Group.prototype.add = function(child) {
        if (child) {
            if (child !== this && child.parent !== this) {
                this._children.push(child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.addBefore = function(child, nextSibling) {
        if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
            var children = this._children;
            var idx = children.indexOf(nextSibling);
            if (idx >= 0) {
                children.splice(idx, 0, child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.replace = function(oldChild, newChild) {
        var idx = $f16f2994a32ad273$export$305f7d4e9d4624f2(this._children, oldChild);
        if (idx >= 0) this.replaceAt(newChild, idx);
        return this;
    };
    Group.prototype.replaceAt = function(child, index) {
        var children = this._children;
        var old = children[index];
        if (child && child !== this && child.parent !== this && child !== old) {
            children[index] = child;
            old.parent = null;
            var zr = this.__zr;
            if (zr) old.removeSelfFromZr(zr);
            this._doAdd(child);
        }
        return this;
    };
    Group.prototype._doAdd = function(child) {
        if (child.parent) child.parent.remove(child);
        child.parent = this;
        var zr = this.__zr;
        if (zr && zr !== child.__zr) child.addSelfToZr(zr);
        zr && zr.refresh();
    };
    Group.prototype.remove = function(child) {
        var zr = this.__zr;
        var children = this._children;
        var idx = $f16f2994a32ad273$export$305f7d4e9d4624f2(children, child);
        if (idx < 0) return this;
        children.splice(idx, 1);
        child.parent = null;
        if (zr) child.removeSelfFromZr(zr);
        zr && zr.refresh();
        return this;
    };
    Group.prototype.removeAll = function() {
        var children = this._children;
        var zr = this.__zr;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (zr) child.removeSelfFromZr(zr);
            child.parent = null;
        }
        children.length = 0;
        return this;
    };
    Group.prototype.eachChild = function(cb, context) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            cb.call(context, child, i);
        }
        return this;
    };
    Group.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            var stopped = cb.call(context, child);
            if (child.isGroup && !stopped) child.traverse(cb, context);
        }
        return this;
    };
    Group.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.addSelfToZr(zr);
        }
    };
    Group.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.removeSelfFromZr(zr);
        }
    };
    Group.prototype.getBoundingRect = function(includeChildren) {
        var tmpRect = new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(0, 0, 0, 0);
        var children = includeChildren || this._children;
        var tmpMat = [];
        var rect = null;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (child.ignore || child.invisible) continue;
            var childRect = child.getBoundingRect();
            var transform = child.getLocalTransform(tmpMat);
            if (transform) {
                (0, $7456366ce379c42e$export$2e2bcd8739ae039).applyTransform(tmpRect, childRect, transform);
                rect = rect || tmpRect.clone();
                rect.union(tmpRect);
            } else {
                rect = rect || childRect.clone();
                rect.union(childRect);
            }
        }
        return rect || tmpRect;
    };
    return Group;
}((0, $05d7569c5e654d58$export$2e2bcd8739ae039));
$ac4abc1f547da31a$var$Group.prototype.type = 'group';
var $ac4abc1f547da31a$export$2e2bcd8739ae039 = $ac4abc1f547da31a$var$Group;


var $85632cfbb825ab09$var$painterCtors = {};
var $85632cfbb825ab09$var$instances = {};
function $85632cfbb825ab09$var$delInstance(id) {
    delete $85632cfbb825ab09$var$instances[id];
}
function $85632cfbb825ab09$var$isDarkMode(backgroundColor) {
    if (!backgroundColor) return false;
    if (typeof backgroundColor === 'string') return (0, $83e50b4ee4d3c357$export$16c0ec21a6f9ef95)(backgroundColor, 1) < (0, $e374994bc8dfd1f0$export$fd81e7ebc7dae256);
    else if (backgroundColor.colorStops) {
        var colorStops = backgroundColor.colorStops;
        var totalLum = 0;
        var len = colorStops.length;
        for(var i = 0; i < len; i++)totalLum += (0, $83e50b4ee4d3c357$export$16c0ec21a6f9ef95)(colorStops[i].color, 1);
        totalLum /= len;
        return totalLum < (0, $e374994bc8dfd1f0$export$fd81e7ebc7dae256);
    }
    return false;
}
var $85632cfbb825ab09$var$ZRender = function() {
    function ZRender(id, dom, opts) {
        var _this = this;
        this._sleepAfterStill = 10;
        this._stillFrameAccum = 0;
        this._needsRefresh = true;
        this._needsRefreshHover = false;
        this._darkMode = false;
        opts = opts || {};
        this.dom = dom;
        this.id = id;
        var storage = new (0, $6f9d2ba1879ab334$export$2e2bcd8739ae039)();
        var rendererType = opts.renderer || 'canvas';
        if (!$85632cfbb825ab09$var$painterCtors[rendererType]) rendererType = $f16f2994a32ad273$export$ed97f33186d4b816($85632cfbb825ab09$var$painterCtors)[0];
        opts.useDirtyRect = opts.useDirtyRect == null ? false : opts.useDirtyRect;
        var painter = new $85632cfbb825ab09$var$painterCtors[rendererType](dom, storage, opts, id);
        var ssrMode = opts.ssr || painter.ssrOnly;
        this.storage = storage;
        this.painter = painter;
        var handlerProxy = !(0, $6d0397515b55cc48$export$2e2bcd8739ae039).node && !(0, $6d0397515b55cc48$export$2e2bcd8739ae039).worker && !ssrMode ? new (0, $649730adabee4714$export$2e2bcd8739ae039)(painter.getViewportRoot(), painter.root) : null;
        var useCoarsePointer = opts.useCoarsePointer;
        var usePointerSize = useCoarsePointer == null || useCoarsePointer === 'auto' ? (0, $6d0397515b55cc48$export$2e2bcd8739ae039).touchEventsSupported : !!useCoarsePointer;
        var defaultPointerSize = 44;
        var pointerSize;
        if (usePointerSize) pointerSize = $f16f2994a32ad273$export$995e01f2f5c9d030(opts.pointerSize, defaultPointerSize);
        this.handler = new (0, $e89fe1f53dad77d7$export$2e2bcd8739ae039)(storage, painter, handlerProxy, painter.root, pointerSize);
        this.animation = new (0, $7485e39c88b6e9be$export$2e2bcd8739ae039)({
            stage: {
                update: ssrMode ? null : function() {
                    return _this._flush(false);
                }
            }
        });
        if (!ssrMode) this.animation.start();
    }
    ZRender.prototype.add = function(el) {
        if (this._disposed || !el) return;
        this.storage.addRoot(el);
        el.addSelfToZr(this);
        this.refresh();
    };
    ZRender.prototype.remove = function(el) {
        if (this._disposed || !el) return;
        this.storage.delRoot(el);
        el.removeSelfFromZr(this);
        this.refresh();
    };
    ZRender.prototype.configLayer = function(zLevel, config) {
        if (this._disposed) return;
        if (this.painter.configLayer) this.painter.configLayer(zLevel, config);
        this.refresh();
    };
    ZRender.prototype.setBackgroundColor = function(backgroundColor) {
        if (this._disposed) return;
        if (this.painter.setBackgroundColor) this.painter.setBackgroundColor(backgroundColor);
        this.refresh();
        this._backgroundColor = backgroundColor;
        this._darkMode = $85632cfbb825ab09$var$isDarkMode(backgroundColor);
    };
    ZRender.prototype.getBackgroundColor = function() {
        return this._backgroundColor;
    };
    ZRender.prototype.setDarkMode = function(darkMode) {
        this._darkMode = darkMode;
    };
    ZRender.prototype.isDarkMode = function() {
        return this._darkMode;
    };
    ZRender.prototype.refreshImmediately = function(noAnimationUpdate) {
        if (this._disposed) return;
        this._refresh({
            animUpdate: !noAnimationUpdate,
            refresh: true,
            refreshHover: false
        });
    };
    ZRender.prototype._refresh = function(opt) {
        if (opt.animUpdate) this.animation.update(true);
        this._needsRefresh = this._needsRefreshHover = false;
        this.painter.refresh({
            refresh: opt.refresh,
            refreshHover: opt.refreshHover
        });
        this._needsRefresh = this._needsRefreshHover = false;
    };
    ZRender.prototype.refresh = function() {
        if (this._disposed) return;
        this._needsRefresh = true;
        this.animation.start();
    };
    ZRender.prototype.flush = function() {
        if (this._disposed) return;
        this._flush(true);
    };
    ZRender.prototype._flush = function(animationUpdate) {
        var triggerRendered;
        var start = (0, $7485e39c88b6e9be$export$1428f42a7de81803)();
        var needsRefresh = this._needsRefresh;
        var needsRefreshHover = this._needsRefreshHover;
        if (needsRefresh || needsRefreshHover) {
            triggerRendered = true;
            this._refresh({
                animUpdate: animationUpdate,
                refresh: needsRefresh,
                refreshHover: needsRefreshHover
            });
        }
        var end = (0, $7485e39c88b6e9be$export$1428f42a7de81803)();
        if (triggerRendered) {
            this._stillFrameAccum = 0;
            this.trigger('rendered', {
                elapsedTime: end - start
            });
        } else if (this._sleepAfterStill > 0) {
            this._stillFrameAccum++;
            if (this._stillFrameAccum > this._sleepAfterStill) this.animation.stop();
        }
    };
    ZRender.prototype.setSleepAfterStill = function(stillFramesCount) {
        this._sleepAfterStill = stillFramesCount;
    };
    ZRender.prototype.wakeUp = function() {
        if (this._disposed) return;
        this.animation.start();
        this._stillFrameAccum = 0;
    };
    ZRender.prototype.refreshHover = function() {
        this._needsRefreshHover = true;
    };
    ZRender.prototype.refreshHoverImmediately = function() {
        if (this._disposed) return;
        this._refresh({
            animUpdate: false,
            refresh: false,
            refreshHover: true
        });
    };
    ZRender.prototype.resize = function(opts) {
        if (this._disposed) return;
        opts = opts || {};
        this.painter.resize(opts.width, opts.height);
        this.handler.resize();
    };
    ZRender.prototype.clearAnimation = function() {
        if (this._disposed) return;
        this.animation.clear();
    };
    ZRender.prototype.getWidth = function() {
        if (this._disposed) return;
        return this.painter.getWidth();
    };
    ZRender.prototype.getHeight = function() {
        if (this._disposed) return;
        return this.painter.getHeight();
    };
    ZRender.prototype.setCursorStyle = function(cursorStyle) {
        if (this._disposed) return;
        this.handler.setCursorStyle(cursorStyle);
    };
    ZRender.prototype.findHover = function(x, y) {
        if (this._disposed) return;
        return this.handler.findHover(x, y);
    };
    ZRender.prototype.on = function(eventName, eventHandler, context) {
        if (!this._disposed) this.handler.on(eventName, eventHandler, context);
        return this;
    };
    ZRender.prototype.off = function(eventName, eventHandler) {
        if (this._disposed) return;
        this.handler.off(eventName, eventHandler);
    };
    ZRender.prototype.trigger = function(eventName, event) {
        if (this._disposed) return;
        this.handler.trigger(eventName, event);
    };
    ZRender.prototype.clear = function() {
        if (this._disposed) return;
        var roots = this.storage.getRoots();
        for(var i = 0; i < roots.length; i++)if (roots[i] instanceof (0, $ac4abc1f547da31a$export$2e2bcd8739ae039)) roots[i].removeSelfFromZr(this);
        this.storage.delAllRoots();
        this.painter.clear();
    };
    ZRender.prototype.dispose = function() {
        if (this._disposed) return;
        this.animation.stop();
        this.clear();
        this.storage.dispose();
        this.painter.dispose();
        this.handler.dispose();
        this.animation = this.storage = this.painter = this.handler = null;
        this._disposed = true;
        $85632cfbb825ab09$var$delInstance(this.id);
    };
    return ZRender;
}();
function $85632cfbb825ab09$export$2cd8252107eb640b(dom, opts) {
    var zr = new $85632cfbb825ab09$var$ZRender($f16f2994a32ad273$export$46e8f25c7328f77e(), dom, opts);
    $85632cfbb825ab09$var$instances[zr.id] = zr;
    return zr;
}
function $85632cfbb825ab09$export$fcfbbcec2cb820d5(zr) {
    zr.dispose();
}
function $85632cfbb825ab09$export$825f692fb04800ef() {
    for(var key in $85632cfbb825ab09$var$instances)if ($85632cfbb825ab09$var$instances.hasOwnProperty(key)) $85632cfbb825ab09$var$instances[key].dispose();
    $85632cfbb825ab09$var$instances = {};
}
function $85632cfbb825ab09$export$8bedcca5bbd73999(id) {
    return $85632cfbb825ab09$var$instances[id];
}
function $85632cfbb825ab09$export$a3e793ccb11823a5(name, Ctor) {
    $85632cfbb825ab09$var$painterCtors[name] = Ctor;
}
var $85632cfbb825ab09$var$ssrDataGetter;
function $85632cfbb825ab09$export$dd7015a5412ca583(el) {
    if (typeof $85632cfbb825ab09$var$ssrDataGetter === 'function') return $85632cfbb825ab09$var$ssrDataGetter(el);
}
function $85632cfbb825ab09$export$e7a09d7fe68a4f7(getter) {
    $85632cfbb825ab09$var$ssrDataGetter = getter;
}
var $85632cfbb825ab09$export$83d89fbfd8236492 = '6.1.0';






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $7E0eS = parcelRequire("7E0eS");


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* The method "quantile" was copied from "d3.js".
* (See more details in the comment of the method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $104896d282bd296f$var$RADIAN_EPSILON = 1e-4;
// A `RangeError` may be thrown if `n` is out of this range when calling `toFixed(n)`.
// Although Chrome and ES2017+ have enlarged this number to 100, but we sill follow
// the ES3~ES6 spec (0 <= n <= 20) for backward and cross-platform compatibility.
var $104896d282bd296f$var$TO_FIXED_SUPPORTED_PRECISION_MAX = 20;
var $104896d282bd296f$export$8ba97c21efb02ba7 = 14;
function $104896d282bd296f$var$_trim(str) {
    return str.replace(/^\s+|\s+$/g, '');
}
var $104896d282bd296f$export$e411eeaf23dccbe8 = Math.min;
var $104896d282bd296f$export$2ca8010d037f830f = Math.max;
var $104896d282bd296f$export$5860c226b237d9a6 = Math.abs;
var $104896d282bd296f$export$42cacde8c45786ff = Math.round;
var $104896d282bd296f$export$c6301bc99a7f80a7 = Math.floor;
var $104896d282bd296f$export$cf129980c996e186 = Math.ceil;
var $104896d282bd296f$export$858b42c97efc7084 = Math.pow;
var $104896d282bd296f$export$f0e980411e05f912 = Math.log;
var $104896d282bd296f$export$37fe35d0539e4a76 = Math.LN10;
var $104896d282bd296f$export$14727c6ff83b55d = Math.PI;
var $104896d282bd296f$export$9b2865e267c5db1d = Math.random;
function $104896d282bd296f$export$d3f68fbaa670562(val, domain, range, clamp) {
    var d0 = domain[0];
    var d1 = domain[1];
    var r0 = range[0];
    var r1 = range[1];
    var subDomain = d1 - d0;
    var subRange = r1 - r0;
    if (subDomain === 0) return subRange === 0 ? r0 : (r0 + r1) / 2;
    // Avoid accuracy problem in edge, such as
    // 146.39 - 62.83 === 83.55999999999999.
    // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
    // It is a little verbose for efficiency considering this method
    // is a hotspot.
    if (clamp) {
        if (subDomain > 0) {
            if (val <= d0) return r0;
            else if (val >= d1) return r1;
        } else {
            if (val >= d0) return r0;
            else if (val <= d1) return r1;
        }
    } else {
        if (val === d0) return r0;
        if (val === d1) return r1;
    }
    return (val - d0) / subDomain * subRange + r0;
}
var $104896d282bd296f$export$e8514cb5a5e2b40f = $104896d282bd296f$export$249e1c100b47bcef;
function $104896d282bd296f$export$249e1c100b47bcef(option, percentBase, percentOffset) {
    switch(option){
        case 'center':
        case 'middle':
            option = '50%';
            break;
        case 'left':
        case 'top':
            option = '0%';
            break;
        case 'right':
        case 'bottom':
            option = '100%';
            break;
    }
    return $104896d282bd296f$export$6b392db7c2374a1a(option, percentBase, percentOffset);
}
function $104896d282bd296f$export$6b392db7c2374a1a(option, percentBase, // Typical usage of `percentOffset`: percent value is based on an specific rect rather than canvas viewport:
//  `parsePercent(percentOrAbsoluteLeft, rect.width, rect.x)`
percentOffset) {
    if ($f16f2994a32ad273$export$844ec244b1367d54(option)) {
        if ($104896d282bd296f$var$isOptionStringPercent(option)) return parseFloat(option) / 100 * percentBase + (percentOffset || 0);
        return parseFloat(option);
    }
    // Allow flexible input due to backward compatibility.
    return option == null ? NaN : +option;
}
function $104896d282bd296f$export$44c0eb10d342c176(option) {
    return $f16f2994a32ad273$export$844ec244b1367d54(option) && $104896d282bd296f$var$isOptionStringPercent(option);
}
function $104896d282bd296f$var$isOptionStringPercent(option) {
    return !!$104896d282bd296f$var$_trim(option).match(/%$/);
}
function $104896d282bd296f$export$2077e0241d6afd3c(x, precision, returnStr) {
    if (isNaN(precision)) // precision utils (such as getAcceptableTickPrecision) may return NaN.
    return returnStr ? '' + x : +x;
    // Avoid range error
    precision = $104896d282bd296f$export$e411eeaf23dccbe8($104896d282bd296f$export$2ca8010d037f830f(0, precision), $104896d282bd296f$var$TO_FIXED_SUPPORTED_PRECISION_MAX);
    // PENDING: 1.005.toFixed(2) is '1.00' rather than '1.01'
    x = (+x).toFixed(precision);
    return returnStr ? x : +x;
}
function $104896d282bd296f$export$d6af03b9b5dd06d7(x, precision, returnStr) {
    if (precision == null) precision = 10;
    return $104896d282bd296f$export$2077e0241d6afd3c(x, precision, returnStr);
}
function $104896d282bd296f$export$debe6e778e0a6d32(arr) {
    arr.sort(function(a, b) {
        return a - b;
    });
    return arr;
}
function $104896d282bd296f$export$e0c74b50bbd10f68(val) {
    val = +val;
    if (isNaN(val)) return 0;
    // It is much faster than methods converting number to string as follows
    //      let tmp = val.toString();
    //      return tmp.length - 1 - tmp.indexOf('.');
    // especially when precision is low
    // Notice:
    // (1) If the loop count is over about 20, it is slower than `getPrecisionSafe`.
    //     (see https://jsbench.me/2vkpcekkvw/1)
    // (2) If the val is less than for example 1e-15, the result may be incorrect.
    //     (see test/ut/spec/util/number.test.ts `getPrecision_equal_random`)
    if (val > 1e-14) {
        var e = 1;
        for(var i = 0; i < 15; i++, e *= 10){
            if ($104896d282bd296f$export$42cacde8c45786ff(val * e) / e === val) return i;
        }
    }
    return $104896d282bd296f$export$6d86ba4ca4984d31(val);
}
function $104896d282bd296f$export$6d86ba4ca4984d31(val) {
    // toLowerCase for: '3.4E-12'
    var str = val.toString().toLowerCase();
    // Consider scientific notation: '3.4e-12' '3.4e+12'
    var eIndex = str.indexOf('e');
    var exp = eIndex > 0 ? +str.slice(eIndex + 1) : 0;
    var significandPartLen = eIndex > 0 ? eIndex : str.length;
    var dotIndex = str.indexOf('.');
    var decimalPartLen = dotIndex < 0 ? 0 : significandPartLen - 1 - dotIndex;
    return $104896d282bd296f$export$2ca8010d037f830f(0, decimalPartLen - exp);
}
function $104896d282bd296f$export$666260d9a2dda8a7(dataExtent, pixelExtent) {
    var dataQuantity = $104896d282bd296f$export$c6301bc99a7f80a7($104896d282bd296f$export$f0e980411e05f912(dataExtent[1] - dataExtent[0]) / $104896d282bd296f$export$37fe35d0539e4a76);
    var sizeQuantity = $104896d282bd296f$export$42cacde8c45786ff($104896d282bd296f$export$f0e980411e05f912($104896d282bd296f$export$5860c226b237d9a6(pixelExtent[1] - pixelExtent[0])) / $104896d282bd296f$export$37fe35d0539e4a76);
    // toFixed() digits argument must be between 0 and 20.
    var precision = $104896d282bd296f$export$e411eeaf23dccbe8($104896d282bd296f$export$2ca8010d037f830f(-dataQuantity + sizeQuantity, 0), $104896d282bd296f$var$TO_FIXED_SUPPORTED_PRECISION_MAX);
    return !isFinite(precision) ? $104896d282bd296f$var$TO_FIXED_SUPPORTED_PRECISION_MAX : precision;
}
function $104896d282bd296f$export$de3fddfc2aec84e4(dataExtent, // Typically, `Math.abs(pixelExtent[1] - pixelExtent[0])`.
pxSpan, // By default, `1`.
pxDiffAcceptable) {
    var dataSpan = $104896d282bd296f$export$5860c226b237d9a6(dataExtent[1] - dataExtent[0]);
    if (!isFinite(dataSpan) || dataSpan === 0) return NaN;
    // Formula for choosing an acceptable precision:
    //  Let `pxDiff = abs(dataSpan - round(dataSpan, precision))`.
    //  We require `pxDiff <= dataSpan * pxDiffAcceptable / pxSpan`.
    //  Consider the nature of "round", the max `pxDiff` is: `pow(10, -precision) / 2`,
    //  Hence: `pow(10, -precision) / 2 <= dataSpan * pxDiffAcceptable / pxSpan`
    //  Hence: `precision >= -log10(2 * dataSpan * pxDiffAcceptable / pxSpan)`
    var dataExp2 = $104896d282bd296f$export$f0e980411e05f912(2 * $104896d282bd296f$export$5860c226b237d9a6(pxDiffAcceptable || 1) * $104896d282bd296f$export$5860c226b237d9a6(dataSpan)) / $104896d282bd296f$export$37fe35d0539e4a76;
    var pxExp = $104896d282bd296f$export$f0e980411e05f912($104896d282bd296f$export$5860c226b237d9a6(pxSpan)) / $104896d282bd296f$export$37fe35d0539e4a76;
    // PENDING: Rounding error generally does not matter; do not fix it before `Math.ceil`
    // until bad case occur.
    var precision = $104896d282bd296f$export$2ca8010d037f830f(0, $104896d282bd296f$export$cf129980c996e186(-dataExp2 + pxExp));
    if (!isFinite(precision)) // If dataSpan is near `0`, the result should not be too big or even `Infinity`.
    precision = NaN;
    return precision;
}
function $104896d282bd296f$export$70cc11b075afeb90(valueList, idx, precision) {
    if (!valueList[idx]) return 0;
    var seats = $104896d282bd296f$export$222dabb13d5320df(valueList, precision);
    return seats[idx] || 0;
}
function $104896d282bd296f$export$222dabb13d5320df(valueList, precision) {
    var sum = $f16f2994a32ad273$export$533b26079ad0b4b(valueList, function(acc, val) {
        return acc + (isNaN(val) ? 0 : val);
    }, 0);
    if (sum === 0) return [];
    var digits = $104896d282bd296f$export$858b42c97efc7084(10, precision);
    var votesPerQuota = $f16f2994a32ad273$export$871de8747c9eaa88(valueList, function(val) {
        return (isNaN(val) ? 0 : val) / sum * digits * 100;
    });
    var targetSeats = digits * 100;
    var seats = $f16f2994a32ad273$export$871de8747c9eaa88(votesPerQuota, function(votes) {
        // Assign automatic seats.
        return $104896d282bd296f$export$c6301bc99a7f80a7(votes);
    });
    var currentSum = $f16f2994a32ad273$export$533b26079ad0b4b(seats, function(acc, val) {
        return acc + val;
    }, 0);
    var remainder = $f16f2994a32ad273$export$871de8747c9eaa88(votesPerQuota, function(votes, idx) {
        return votes - seats[idx];
    });
    // Has remainding votes.
    while(currentSum < targetSeats){
        // Find next largest remainder.
        var max = Number.NEGATIVE_INFINITY;
        var maxId = null;
        for(var i = 0, len = remainder.length; i < len; ++i)if (remainder[i] > max) {
            max = remainder[i];
            maxId = i;
        }
        // Add a vote to max remainder.
        ++seats[maxId];
        remainder[maxId] = 0;
        ++currentSum;
    }
    return $f16f2994a32ad273$export$871de8747c9eaa88(seats, function(seat) {
        return seat / digits;
    });
}
function $104896d282bd296f$export$d3389a301c3a5706(val0, val1) {
    var maxPrecision = $104896d282bd296f$export$2ca8010d037f830f($104896d282bd296f$export$e0c74b50bbd10f68(val0), $104896d282bd296f$export$e0c74b50bbd10f68(val1));
    // const multiplier = Math.pow(10, maxPrecision);
    // return (mathRound(val0 * multiplier) + mathRound(val1 * multiplier)) / multiplier;
    var sum = val0 + val1;
    // // PENDING: support more?
    return maxPrecision > $104896d282bd296f$var$TO_FIXED_SUPPORTED_PRECISION_MAX ? sum : $104896d282bd296f$export$2077e0241d6afd3c(sum, maxPrecision);
}
var $104896d282bd296f$export$18510406f204a1b9 = $104896d282bd296f$export$858b42c97efc7084(2, 53) - 1;
function $104896d282bd296f$export$2ca6dd70a288b1c3(radian) {
    var pi2 = $104896d282bd296f$export$14727c6ff83b55d * 2;
    return (radian % pi2 + pi2) % pi2;
}
function $104896d282bd296f$export$d1df570aea2868f(val) {
    return val > -$104896d282bd296f$var$RADIAN_EPSILON && val < $104896d282bd296f$var$RADIAN_EPSILON;
}
// eslint-disable-next-line
var $104896d282bd296f$var$TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
function $104896d282bd296f$export$6b862160d295c8e(value) {
    if (value instanceof Date) return value;
    else if ($f16f2994a32ad273$export$844ec244b1367d54(value)) {
        // Different browsers parse date in different way, so we parse it manually.
        // Some other issues:
        // new Date('1970-01-01') is UTC,
        // new Date('1970/01/01') and new Date('1970-1-01') is local.
        // See issue #3623
        var match = $104896d282bd296f$var$TIME_REG.exec(value);
        if (!match) // return Invalid Date.
        return new Date(NaN);
        // Use local time when no timezone offset is specified.
        if (!match[8]) // match[n] can only be string or undefined.
        // But take care of '12' + 1 => '121'.
        return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0);
        else {
            var hour = +match[4] || 0;
            if (match[8].toUpperCase() !== 'Z') hour -= +match[8].slice(0, 3);
            return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0));
        }
    } else if (value == null) return new Date(NaN);
    return new Date($104896d282bd296f$export$42cacde8c45786ff(value));
}
function $104896d282bd296f$export$82dd68b83a44b253(val) {
    return $104896d282bd296f$export$858b42c97efc7084(10, $104896d282bd296f$export$97256a17b20a0c24(val));
}
function $104896d282bd296f$export$97256a17b20a0c24(val) {
    if (val === 0) // PENDING: like IEEE754 use exponent `0` in this case.
    // but methematically, exponent of zero is `-Infinity`.
    return 0;
    var exp = $104896d282bd296f$export$c6301bc99a7f80a7($104896d282bd296f$export$f0e980411e05f912(val) / $104896d282bd296f$export$37fe35d0539e4a76);
    /**
   * exp is expected to be the rounded-down result of the base-10 log of val.
   * But due to the precision loss with Math.log(val), we need to restore it
   * using 10^exp to make sure we can get val back from exp. #11249
   */ if (val / $104896d282bd296f$export$858b42c97efc7084(10, exp) >= 10) exp++;
    return exp;
}
var $104896d282bd296f$export$50cf7838cdf68969 = 1;
var $104896d282bd296f$export$492adb595f875f4e = 2;
function $104896d282bd296f$export$7a695fe44258210b(val, // All non-`NICE_MODE_MIN`-truthy values means `NICE_MODE_ROUND`, for backward compatibility.
mode) {
    // Consider the scientific notation of `val`:
    //  - `exponent` is its exponent.
    //  - `f` is its coefficient. `1 <= f < 10`.
    //  e.g., if `val` is `0.0054321`, `exponent` is `-3`, `f` is `5.4321`,
    //      The result is `0.005` on NICE_MODE_ROUND.
    //  e.g., if `val` is `987.12345`, `exponent` is `2`, `f` is `9.8712345`,
    //      The result is `1000` on NICE_MODE_ROUND.
    //  e.g., if `val` is `0`,
    //      The result is `1`.
    var exponent = $104896d282bd296f$export$97256a17b20a0c24(val);
    // No rounding error in Math.pow(10, integer).
    var exp10 = $104896d282bd296f$export$858b42c97efc7084(10, exponent);
    var f = val / exp10;
    var nf;
    if (mode === $104896d282bd296f$export$492adb595f875f4e) nf = 1;
    else if (mode) {
        if (f < 1.5) nf = 1;
        else if (f < 2.5) nf = 2;
        else if (f < 4) nf = 3;
        else if (f < 7) nf = 5;
        else nf = 10;
    } else {
        if (f < 1) nf = 1;
        else if (f < 2) nf = 2;
        else if (f < 3) nf = 3;
        else if (f < 5) nf = 5;
        else nf = 10;
    }
    val = nf * exp10;
    // Fix IEEE 754 float rounding error
    return $104896d282bd296f$export$2077e0241d6afd3c(val, -exponent);
}
function $104896d282bd296f$export$651fb4afdb6caa4b(ascArr, p) {
    var H = (ascArr.length - 1) * p + 1;
    var h = $104896d282bd296f$export$c6301bc99a7f80a7(H);
    var v = +ascArr[h - 1];
    var e = H - h;
    return e ? v + e * (ascArr[h] - v) : v;
}
function $104896d282bd296f$export$12f7386070bc380a(list) {
    list.sort(function(a, b) {
        return littleThan(a, b, 0) ? -1 : 1;
    });
    var curr = -Infinity;
    var currClose = 1;
    for(var i = 0; i < list.length;){
        var interval = list[i].interval;
        var close_1 = list[i].close;
        for(var lg = 0; lg < 2; lg++){
            if (interval[lg] <= curr) {
                interval[lg] = curr;
                close_1[lg] = !lg ? 1 - currClose : 1;
            }
            curr = interval[lg];
            currClose = close_1[lg];
        }
        if (interval[0] === interval[1] && close_1[0] * close_1[1] !== 1) list.splice(i, 1);
        else i++;
    }
    return list;
    function littleThan(a, b, lg) {
        return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
    }
}
function $104896d282bd296f$export$8b4007b942b45a96(val) {
    var valFloat = parseFloat(val);
    return valFloat == val // eslint-disable-line eqeqeq
     && (valFloat !== 0 || !$f16f2994a32ad273$export$844ec244b1367d54(val) || val.indexOf('x') <= 0 // For case ' 0x0 '.
    ) ? valFloat : NaN;
}
function $104896d282bd296f$export$e90fb89750dba83f(val) {
    return !isNaN($104896d282bd296f$export$8b4007b942b45a96(val));
}
function $104896d282bd296f$export$474d2ec9aa44a22() {
    return $104896d282bd296f$export$42cacde8c45786ff($104896d282bd296f$export$9b2865e267c5db1d() * 9);
}
function $104896d282bd296f$export$a368fd580c0d0fe4(a, b) {
    if (b === 0) return a;
    return $104896d282bd296f$export$a368fd580c0d0fe4(b, a % b);
}
function $104896d282bd296f$export$680a45b749323f49(a, b) {
    if (a == null) return b;
    if (b == null) return a;
    return a * b / $104896d282bd296f$export$a368fd580c0d0fe4(a, b);
}
function $104896d282bd296f$export$b5c30d4208814a65(val) {
    return val != null && isFinite(val);
}



function $3fa81475350067fd$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
/**
 * Make the name displayable. But we should
 * make sure it is not duplicated with user
 * specified name, so use '\0';
 */ var $3fa81475350067fd$var$DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
var $3fa81475350067fd$var$INTERNAL_COMPONENT_ID_PREFIX = '\0_ec_\0';
function $3fa81475350067fd$export$4f07b212a02c8051(value) {
    return value instanceof Array ? value : value == null ? [] : [
        value
    ];
}
function $3fa81475350067fd$export$abdcc6a26372f94b(opt, key, subOpts) {
    // Caution: performance sensitive.
    if (opt) {
        opt[key] = opt[key] || {};
        opt.emphasis = opt.emphasis || {};
        opt.emphasis[key] = opt.emphasis[key] || {};
        // Default emphasis option from normal
        for(var i = 0, len = subOpts.length; i < len; i++){
            var subOptName = subOpts[i];
            if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) opt.emphasis[key][subOptName] = opt[key][subOptName];
        }
    }
}
var $3fa81475350067fd$export$df45610347a602ad = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'rich',
    'tag',
    'color',
    'textBorderColor',
    'textBorderWidth',
    'width',
    'height',
    'lineHeight',
    'align',
    'verticalAlign',
    'baseline',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'textShadowColor',
    'textShadowBlur',
    'textShadowOffsetX',
    'textShadowOffsetY',
    'backgroundColor',
    'borderColor',
    'borderWidth',
    'borderRadius',
    'padding'
];
function $3fa81475350067fd$export$2c944e12edb48d4b(dataItem) {
    return (0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(dataItem) && !(0, $f16f2994a32ad273$export$43bee75e5e14138e)(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
}
function $3fa81475350067fd$export$3e1a543f33ef6883(dataItem) {
    return (0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(dataItem) && !(dataItem instanceof Array);
// // markLine data can be array
// && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
function $3fa81475350067fd$export$574f818966e4da87(existings, newCmptOptions, mode) {
    var isNormalMergeMode = mode === 'normalMerge';
    var isReplaceMergeMode = mode === 'replaceMerge';
    var isReplaceAllMode = mode === 'replaceAll';
    existings = existings || [];
    newCmptOptions = (newCmptOptions || []).slice();
    var existingIdIdxMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
    // Validate id and name on user input option.
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!(0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(cmptOption)) {
            newCmptOptions[index] = null;
            return;
        }
    });
    var result = $3fa81475350067fd$var$prepareResult(existings, existingIdIdxMap, mode);
    if (isNormalMergeMode || isReplaceMergeMode) $3fa81475350067fd$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions);
    if (isNormalMergeMode) $3fa81475350067fd$var$mappingByName(result, newCmptOptions);
    if (isNormalMergeMode || isReplaceMergeMode) $3fa81475350067fd$var$mappingByIndex(result, newCmptOptions, isReplaceMergeMode);
    else if (isReplaceAllMode) $3fa81475350067fd$var$mappingInReplaceAllMode(result, newCmptOptions);
    $3fa81475350067fd$var$makeIdAndName(result);
    // The array `result` MUST NOT contain elided items, otherwise the
    // forEach will omit those items and result in incorrect result.
    return result;
}
function $3fa81475350067fd$var$prepareResult(existings, existingIdIdxMap, mode) {
    var result = [];
    if (mode === 'replaceAll') return result;
    // Do not use native `map` to in case that the array `existings`
    // contains elided items, which will be omitted.
    for(var index = 0; index < existings.length; index++){
        var existing = existings[index];
        // Because of replaceMerge, `existing` may be null/undefined.
        if (existing && existing.id != null) existingIdIdxMap.set(existing.id, index);
        // For non-internal-componnets:
        //     Mode "normalMerge": all existings kept.
        //     Mode "replaceMerge": all existing removed unless mapped by id.
        // For internal-components:
        //     go with "replaceMerge" approach in both mode.
        result.push({
            existing: mode === 'replaceMerge' || $3fa81475350067fd$export$feece3e7d52a102b(existing) ? null : existing,
            newOption: null,
            keyInfo: null,
            brandNew: null
        });
    }
    return result;
}
function $3fa81475350067fd$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions) {
    // Mapping by id if specified.
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.id == null) return;
        var optionId = $3fa81475350067fd$var$makeComparableKey(cmptOption.id);
        var existingIdx = existingIdIdxMap.get(optionId);
        if (existingIdx != null) {
            var resultItem = result[existingIdx];
            (0, $f16f2994a32ad273$export$a7a9523472993e97)(!resultItem.newOption, 'Duplicated option on id "' + optionId + '".');
            resultItem.newOption = cmptOption;
            // In both mode, if id matched, new option will be merged to
            // the existings rather than creating new component model.
            resultItem.existing = existings[existingIdx];
            newCmptOptions[index] = null;
        }
    });
}
function $3fa81475350067fd$var$mappingByName(result, newCmptOptions) {
    // Mapping by name if specified.
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.name == null) return;
        for(var i = 0; i < result.length; i++){
            var existing = result[i].existing;
            if (!result[i].newOption // Consider name: two map to one.
             && existing && (existing.id == null || cmptOption.id == null) && !$3fa81475350067fd$export$feece3e7d52a102b(cmptOption) && !$3fa81475350067fd$export$feece3e7d52a102b(existing) && $3fa81475350067fd$var$keyExistAndEqual('name', existing, cmptOption)) {
                result[i].newOption = cmptOption;
                newCmptOptions[index] = null;
                return;
            }
        }
    });
}
function $3fa81475350067fd$var$mappingByIndex(result, newCmptOptions, brandNew) {
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption) {
        if (!cmptOption) return;
        // Find the first place that not mapped by id and not internal component (consider the "hole").
        var resultItem;
        var nextIdx = 0;
        while(// Be `!resultItem` only when `nextIdx >= result.length`.
        (resultItem = result[nextIdx]) && (resultItem.newOption || $3fa81475350067fd$export$feece3e7d52a102b(resultItem.existing) || // In mode "replaceMerge", here no not-mapped-non-internal-existing.
        resultItem.existing && cmptOption.id != null && !$3fa81475350067fd$var$keyExistAndEqual('id', cmptOption, resultItem.existing)))nextIdx++;
        if (resultItem) {
            resultItem.newOption = cmptOption;
            resultItem.brandNew = brandNew;
        } else result.push({
            newOption: cmptOption,
            brandNew: brandNew,
            existing: null,
            keyInfo: null
        });
        nextIdx++;
    });
}
function $3fa81475350067fd$var$mappingInReplaceAllMode(result, newCmptOptions) {
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption) {
        // The feature "reproduce" requires "hole" will also reproduced
        // in case that component index referring are broken.
        result.push({
            newOption: cmptOption,
            brandNew: true,
            existing: null,
            keyInfo: null
        });
    });
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 */ function $3fa81475350067fd$var$makeIdAndName(mapResult) {
    // We use this id to hash component models and view instances
    // in echarts. id can be specified by user, or auto generated.
    // The id generation rule ensures new view instance are able
    // to mapped to old instance when setOption are called in
    // no-merge mode. So we generate model id by name and plus
    // type in view id.
    // name can be duplicated among components, which is convenient
    // to specify multi components (like series) by one name.
    // Ensure that each id is distinct.
    var idMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(mapResult, function(item) {
        var existing = item.existing;
        existing && idMap.set(existing.id, item);
    });
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(mapResult, function(item) {
        var opt = item.newOption;
        // Force ensure id not duplicated.
        (0, $f16f2994a32ad273$export$a7a9523472993e97)(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
        opt && opt.id != null && idMap.set(opt.id, item);
        !item.keyInfo && (item.keyInfo = {});
    });
    // Make name and id.
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(mapResult, function(item, index) {
        var existing = item.existing;
        var opt = item.newOption;
        var keyInfo = item.keyInfo;
        if (!(0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(opt)) return;
        // Name can be overwritten. Consider case: axis.name = '20km'.
        // But id generated by name will not be changed, which affect
        // only in that case: setOption with 'not merge mode' and view
        // instance will be recreated, which can be accepted.
        keyInfo.name = opt.name != null ? $3fa81475350067fd$var$makeComparableKey(opt.name) : existing ? existing.name : $3fa81475350067fd$var$DUMMY_COMPONENT_NAME_PREFIX + index;
        if (existing) keyInfo.id = $3fa81475350067fd$var$makeComparableKey(existing.id);
        else if (opt.id != null) keyInfo.id = $3fa81475350067fd$var$makeComparableKey(opt.id);
        else {
            // Consider this situatoin:
            //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
            //  optionB [{..}, {name: 'a'}, {name: 'a'}]
            // Series with the same name between optionA and optionB
            // should be mapped.
            var idNum = 0;
            do keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
            while (idMap.get(keyInfo.id));
        }
        idMap.set(keyInfo.id, item);
    });
}
function $3fa81475350067fd$var$keyExistAndEqual(attr, obj1, obj2) {
    var key1 = $3fa81475350067fd$export$fb1a222ba5dd6e51(obj1[attr], null);
    var key2 = $3fa81475350067fd$export$fb1a222ba5dd6e51(obj2[attr], null);
    // See `MappingExistingItem`. `id` and `name` trade string equals to number.
    return key1 != null && key2 != null && key1 === key2;
}
/**
 * @return return null if not exist.
 */ function $3fa81475350067fd$var$makeComparableKey(val) {
    return $3fa81475350067fd$export$fb1a222ba5dd6e51(val, '');
}
function $3fa81475350067fd$export$fb1a222ba5dd6e51(idOrName, defaultValue) {
    if (idOrName == null) return defaultValue;
    return (0, $f16f2994a32ad273$export$844ec244b1367d54)(idOrName) ? idOrName : (0, $f16f2994a32ad273$export$7e4aa119212bc614)(idOrName) || (0, $f16f2994a32ad273$export$29d0bb2a4e07b252)(idOrName) ? idOrName + '' : defaultValue;
}
function $3fa81475350067fd$var$warnInvalidateIdOrName(idOrName) {}
function $3fa81475350067fd$var$isValidIdOrName(idOrName) {
    return (0, $f16f2994a32ad273$export$29d0bb2a4e07b252)(idOrName) || (0, $104896d282bd296f$export$e90fb89750dba83f)(idOrName);
}
function $3fa81475350067fd$export$beae19a2652b3368(componentModel) {
    var name = componentModel.name;
    // Is specified when `indexOf` get -1 or > 0.
    return !!(name && name.indexOf($3fa81475350067fd$var$DUMMY_COMPONENT_NAME_PREFIX));
}
function $3fa81475350067fd$export$feece3e7d52a102b(cmptOption) {
    return cmptOption && cmptOption.id != null && $3fa81475350067fd$var$makeComparableKey(cmptOption.id).indexOf($3fa81475350067fd$var$INTERNAL_COMPONENT_ID_PREFIX) === 0;
}
function $3fa81475350067fd$export$1753133c42e665e8(idSuffix) {
    return $3fa81475350067fd$var$INTERNAL_COMPONENT_ID_PREFIX + idSuffix;
}
function $3fa81475350067fd$export$5ac61aca2ba0282d(mappingResult, mainType, componentModelCtor) {
    // Set mainType and complete subType.
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(mappingResult, function(item) {
        var newOption = item.newOption;
        if ((0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(newOption)) {
            item.keyInfo.mainType = mainType;
            item.keyInfo.subType = $3fa81475350067fd$var$determineSubType(mainType, newOption, item.existing, componentModelCtor);
        }
    });
}
function $3fa81475350067fd$var$determineSubType(mainType, newCmptOption, existComponent, componentModelCtor) {
    var subType = newCmptOption.type ? newCmptOption.type : existComponent ? existComponent.subType : componentModelCtor.determineSubType(mainType, newCmptOption);
    // tooltip, markline, markpoint may always has no subType
    return subType;
}
function $3fa81475350067fd$export$6d12cabb0c9bf8e3(batchA, batchB) {
    var mapA = {};
    var mapB = {};
    makeMap(batchA || [], mapA);
    makeMap(batchB || [], mapB, mapA);
    return [
        mapToArray(mapA),
        mapToArray(mapB)
    ];
    function makeMap(sourceBatch, map, otherMap) {
        for(var i = 0, len = sourceBatch.length; i < len; i++){
            var seriesId = $3fa81475350067fd$export$fb1a222ba5dd6e51(sourceBatch[i].seriesId, null);
            if (seriesId == null) return;
            var dataIndices = $3fa81475350067fd$export$4f07b212a02c8051(sourceBatch[i].dataIndex);
            var otherDataIndices = otherMap && otherMap[seriesId];
            for(var j = 0, lenj = dataIndices.length; j < lenj; j++){
                var dataIndex = dataIndices[j];
                if (otherDataIndices && otherDataIndices[dataIndex]) otherDataIndices[dataIndex] = null;
                else (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
            }
        }
    }
    function mapToArray(map, isData) {
        var result = [];
        for(var i in map)if (map.hasOwnProperty(i) && map[i] != null) {
            if (isData) result.push(+i);
            else {
                var dataIndices = mapToArray(map[i], true);
                dataIndices.length && result.push({
                    seriesId: i,
                    dataIndex: dataIndices
                });
            }
        }
        return result;
    }
}
function $3fa81475350067fd$export$42b26cae8b8d10(data, payload) {
    if (payload.dataIndexInside != null) return payload.dataIndexInside;
    else if (payload.dataIndex != null) return (0, $f16f2994a32ad273$export$43bee75e5e14138e)(payload.dataIndex) ? (0, $f16f2994a32ad273$export$871de8747c9eaa88)(payload.dataIndex, function(value) {
        return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
    else if (payload.name != null) return (0, $f16f2994a32ad273$export$43bee75e5e14138e)(payload.name) ? (0, $f16f2994a32ad273$export$871de8747c9eaa88)(payload.name, function(value) {
        return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
}
function $3fa81475350067fd$export$64df9f8d92ae083f() {
    var key = '__ec_inner_' + $3fa81475350067fd$var$innerUniqueIndex++;
    return function(hostObj) {
        return hostObj[key] || (hostObj[key] = {});
    };
}
var $3fa81475350067fd$var$innerUniqueIndex = (0, $104896d282bd296f$export$474d2ec9aa44a22)();
function $3fa81475350067fd$export$95de80076abac814(ecModel, finderInput, opt) {
    var _a = $3fa81475350067fd$export$fe600815775d9400(finderInput, opt), mainTypeSpecified = _a.mainTypeSpecified, queryOptionMap = _a.queryOptionMap, others = _a.others;
    var result = others;
    var defaultMainType = opt ? opt.defaultMainType : null;
    if (!mainTypeSpecified && defaultMainType) queryOptionMap.set(defaultMainType, {});
    queryOptionMap.each(function(queryOption, mainType) {
        var queryResult = $3fa81475350067fd$export$dc741340f7e5f186(ecModel, mainType, queryOption, {
            useDefault: defaultMainType === mainType,
            enableAll: opt && opt.enableAll != null ? opt.enableAll : true,
            enableNone: opt && opt.enableNone != null ? opt.enableNone : true
        });
        result[mainType + 'Models'] = queryResult.models;
        result[mainType + 'Model'] = queryResult.models[0];
    });
    return result;
}
function $3fa81475350067fd$export$fe600815775d9400(finderInput, opt) {
    var finder;
    if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(finderInput)) {
        var obj = {};
        obj[finderInput + 'Index'] = 0;
        finder = obj;
    } else finder = finderInput;
    var queryOptionMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
    var others = {};
    var mainTypeSpecified = false;
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(finder, function(value, key) {
        // Exclude 'dataIndex' and other illegal keys.
        if (key === 'dataIndex' || key === 'dataIndexInside') {
            others[key] = value;
            return;
        }
        var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
        var mainType = parsedKey[1];
        var queryType = (parsedKey[2] || '').toLowerCase();
        if (!mainType || !queryType || opt && opt.includeMainTypes && (0, $f16f2994a32ad273$export$305f7d4e9d4624f2)(opt.includeMainTypes, mainType) < 0) return;
        mainTypeSpecified = mainTypeSpecified || !!mainType;
        var queryOption = queryOptionMap.get(mainType) || queryOptionMap.set(mainType, {});
        queryOption[queryType] = value;
    });
    return {
        mainTypeSpecified: mainTypeSpecified,
        queryOptionMap: queryOptionMap,
        others: others
    };
}
var $3fa81475350067fd$export$f076738ec84e693c = {
    useDefault: true,
    enableAll: false,
    enableNone: false
};
var $3fa81475350067fd$export$48d598924ce4892c = {
    useDefault: false,
    enableAll: true,
    enableNone: true
};
function $3fa81475350067fd$export$dc741340f7e5f186(ecModel, mainType, userOption, opt) {
    opt = opt || $3fa81475350067fd$export$f076738ec84e693c;
    var indexOption = userOption.index;
    var idOption = userOption.id;
    var nameOption = userOption.name;
    var result = {
        models: null,
        specified: indexOption != null || idOption != null || nameOption != null
    };
    if (!result.specified) {
        // Use the first as default if `useDefault`.
        var firstCmpt = void 0;
        result.models = opt.useDefault && (firstCmpt = ecModel.getComponent(mainType)) ? [
            firstCmpt
        ] : [];
        return result;
    }
    if (indexOption === 'none' || indexOption === false) {
        if (opt.enableNone) {
            result.models = [];
            return result;
        } else indexOption = -1; // Can not query by index but may still query by id/name if specified.
    }
    // `queryComponents` will return all components if
    // both all of index/id/name are null/undefined.
    if (indexOption === 'all') {
        if (opt.enableAll) indexOption = idOption = nameOption = null;
        else indexOption = -1;
    }
    result.models = ecModel.queryComponents({
        mainType: mainType,
        index: indexOption,
        id: idOption,
        name: nameOption
    });
    return result;
}
function $3fa81475350067fd$export$c064a542e5272c93(payload, // `mainType` is mandatory to restrict the range of query,
// since `payload` in an user input.
mainType, // subType may be '' by `parseClassType`
subType) {
    var query = {};
    query[mainType + 'Id'] = payload[mainType + 'Id'];
    query[mainType + 'Index'] = payload[mainType + 'Index'];
    query[mainType + 'Name'] = payload[mainType + 'Name'];
    var condition = {
        mainType: mainType,
        query: query
    };
    subType && (condition.subType = subType); // subType is determined by `hasOwnProperty`.
    return condition;
}
function $3fa81475350067fd$export$9fec4d97f1922e0b(dom, key, value) {
    dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
}
function $3fa81475350067fd$export$735ee1799fd02602(dom, key) {
    return dom.getAttribute ? dom.getAttribute(key) : dom[key];
}
function $3fa81475350067fd$export$cc0a17a5d27b4e17(renderModeOption) {
    if (renderModeOption === 'auto') // Using html when `document` exists, use richText otherwise
    return (0, $6d0397515b55cc48$export$2e2bcd8739ae039).domSupported ? 'html' : 'richText';
    else return renderModeOption || 'html';
}
function $3fa81475350067fd$export$7ab5bda43e13168f(array, getKey // return key
) {
    var buckets = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
    var keys = [];
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(array, function(item) {
        var key = getKey(item);
        (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
    });
    return {
        keys: keys,
        buckets: buckets
    };
}
function $3fa81475350067fd$export$bd0439821a1869f3(data, precision, sourceValue, targetValue, percent) {
    var isAutoPrecision = precision == null || precision === 'auto';
    if (targetValue == null) return targetValue;
    if ((0, $f16f2994a32ad273$export$7e4aa119212bc614)(targetValue)) {
        var value = $3fa81475350067fd$var$interpolateNumber(sourceValue || 0, targetValue, percent);
        return (0, $104896d282bd296f$export$2077e0241d6afd3c)(value, isAutoPrecision ? Math.max((0, $104896d282bd296f$export$e0c74b50bbd10f68)(sourceValue || 0), (0, $104896d282bd296f$export$e0c74b50bbd10f68)(targetValue)) : precision);
    } else if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(targetValue)) return percent < 1 ? sourceValue : targetValue;
    else {
        var interpolated = [];
        var leftArr = sourceValue;
        var rightArr = targetValue;
        var length_1 = Math.max(leftArr ? leftArr.length : 0, rightArr.length);
        for(var i = 0; i < length_1; ++i){
            var info = data.getDimensionInfo(i);
            // Don't interpolate ordinal dims
            if (info && info.type === 'ordinal') // In init, there is no `sourceValue`, but should better not to get undefined result.
            interpolated[i] = (percent < 1 && leftArr ? leftArr : rightArr)[i];
            else {
                var leftVal = leftArr && leftArr[i] ? leftArr[i] : 0;
                var rightVal = rightArr[i];
                var value = $3fa81475350067fd$var$interpolateNumber(leftVal, rightVal, percent);
                interpolated[i] = (0, $104896d282bd296f$export$2077e0241d6afd3c)(value, isAutoPrecision ? Math.max((0, $104896d282bd296f$export$e0c74b50bbd10f68)(leftVal), (0, $104896d282bd296f$export$e0c74b50bbd10f68)(rightVal)) : precision);
            }
        }
        return interpolated;
    }
}
/**
 * Use an iterator to avoid exposing the internal list or duplicating it
 * for the outside traveller, and no extra heap allocation.
 * @usage
 *  for (const it = resetIterator(); it.next();) {
 *      const item = it.item;
 *      const key = it.key;
 *      const itIdx = it.itIdx;
 *      // ...
 *  }
 * @usage
 *  const it = resetIterator();
 *  while (it.next()) { ... }
 * @usage
 *  for (resetIterator(it); it.next();) { ... }
 */ var $3fa81475350067fd$export$4e38036c4470d56c = /** @class */ function() {
    function ListIterator() {}
    /**
   * The loop condition is `idx < end` if `step > 0`;
   * The loop condition is `idx >= end` if `step < 0`.
   *
   * @param end By default `list.length` if `step > 0`; `0` if `step < 0`.
   * @param step By default `1`.
   */ ListIterator.prototype.reset = function(list, start, end, step) {
        this._list = list;
        this._step = step = step || 1;
        this._idx = start;
        this._end = end != null ? end : step > 0 ? list.length : 0;
        this.item = null;
        this.key = NaN;
        return this;
    };
    ListIterator.prototype.next = function() {
        if (this._step > 0 ? this._idx < this._end : this._idx >= this._end) {
            this.item = this._list[this._idx];
            this.key = this._idx = this._idx + this._step;
            return true;
        }
        return false;
    };
    return ListIterator;
}();
function $3fa81475350067fd$export$be44d6593b016f3e(model) {
    // Clear to avoid memory leak.
    model.option = model.parentModel = model.ecModel = null;
}
function $3fa81475350067fd$export$62e5f07ab009f3b() {
    return [
        Infinity,
        -Infinity
    ];
}
function $3fa81475350067fd$export$c28a8a63acb35a19(extent, val) {
    if ($3fa81475350067fd$export$5af06089290883e2(val)) {
        val < extent[0] && (extent[0] = val);
        val > extent[1] && (extent[1] = val);
    }
}
function $3fa81475350067fd$export$a7951d5427fae7a0(extent, val) {
    if ($3fa81475350067fd$export$5af06089290883e2(val) && val < extent[0]) extent[0] = val;
}
function $3fa81475350067fd$export$707ef09fb8bbaa0e(extent, val) {
    if ($3fa81475350067fd$export$5af06089290883e2(val) && val > extent[1]) extent[1] = val;
}
function $3fa81475350067fd$export$380d5a0634ac86f8(tarExtent, srcExtent) {
    // Accept both or neither.
    if ($3fa81475350067fd$export$d386653f29930adb(srcExtent[0], srcExtent[1])) {
        srcExtent[0] < tarExtent[0] && (tarExtent[0] = srcExtent[0]);
        srcExtent[1] > tarExtent[1] && (tarExtent[1] = srcExtent[1]);
    }
}
function $3fa81475350067fd$export$5af06089290883e2(val) {
    // Considered that number could be `NaN` and `Infinity` and should not write into the extent.
    // Note that `Infinity` is the initialized value from `initExtentForUnion` and may be inputted.
    return val != null && isFinite(val);
}
function $3fa81475350067fd$export$d386653f29930adb(start, end) {
    return $3fa81475350067fd$export$5af06089290883e2(start) && $3fa81475350067fd$export$5af06089290883e2(end) && start <= end;
}
function $3fa81475350067fd$export$622ca7efe3351d22(extent) {
    // Also considered extent may have `NaN` and `Infinity`.
    var span = extent[1] - extent[0];
    return isFinite(span) && span >= 0;
}
function $3fa81475350067fd$export$fca8d858e99f6a42(extent) {
    if ($3fa81475350067fd$export$d386653f29930adb(extent[0], extent[1]) && extent[0] > extent[1]) extent[0] = extent[1];
}
function $3fa81475350067fd$export$a305e9b27fd23ae3() {
    var hiddenKey = '__ec_once_' + $3fa81475350067fd$var$onceUniqueIndex++;
    return function(hostObj, cb) {
        if (!(0, $f16f2994a32ad273$export$b5a638e9b3fff9f3)(hostObj, hiddenKey)) {
            hostObj[hiddenKey] = 1;
            cb();
        }
    };
}
var $3fa81475350067fd$var$onceUniqueIndex = (0, $104896d282bd296f$export$474d2ec9aa44a22)();
function $3fa81475350067fd$export$2e2262a44ac61957(arr, getKey, // `existingCount`: the count before this item is added.
resolve) {
    var dupMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
    var writeIdx = 0;
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(arr, function(item) {
        var key = getKey(item);
        var count = dupMap.get(key) || 0;
        if (resolve) resolve(item, count);
        if (!count && !resolve) arr[writeIdx++] = item;
        dupMap.set(key, count + 1);
    });
    if (!resolve) arr.length = writeIdx;
}
function $3fa81475350067fd$export$605c429b4975bbd7(item) {
    return item.value + '';
}
function $3fa81475350067fd$export$fec5e8fdd97d769b(item) {
    return item + '';
}
function $3fa81475350067fd$export$4496820b7f3d3e98(seriesModel, useIncremental) {
    // 0 means disable incremental.
    // 1 is preserved for backward compatibility.
    return (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(useIncremental, true) ? seriesModel.seriesIndex + 2 : 0;
}
function $3fa81475350067fd$export$3b33f7e0868ca070(seriesModel, view, pipeline) {
    var dataLen = seriesModel.getData().count();
    return {
        progressiveRender: pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold,
        large: seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold'),
        // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
        // see `test/candlestick-large3.html`
        modDataCount: seriesModel.get('progressiveChunkMode') === 'mod' ? seriesModel.getData().count() : null
    };
}
function $3fa81475350067fd$export$e9d2910fc7a89b3c(// null/undefined is not allowed, otherwise bug-prone.
upstreamOutputRange, thisTaskPlannedRange) {
    (0, $f16f2994a32ad273$export$a7a9523472993e97)(upstreamOutputRange.start === thisTaskPlannedRange.start && upstreamOutputRange.end === thisTaskPlannedRange.end);
}
function $3fa81475350067fd$export$c635911e41d20ada(seriesType, overallReset) {
    return {
        seriesType: seriesType,
        overallReset: overallReset
    };
}
function $3fa81475350067fd$export$d62c61cad9d1ab83(overallReset) {
    return {
        overallReset: overallReset
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $7E0eS = parcelRequire("7E0eS");

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $7904d4b709390668$var$TYPE_DELIMITER = '.';
var $7904d4b709390668$var$IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
var $7904d4b709390668$var$IS_EXTENDED_CLASS = '___EC__EXTENDED_CLASS___';
function $7904d4b709390668$export$fbe18865d303bf01(componentType) {
    var ret = {
        main: '',
        sub: ''
    };
    if (componentType) {
        var typeArr = componentType.split($7904d4b709390668$var$TYPE_DELIMITER);
        ret.main = typeArr[0] || '';
        ret.sub = typeArr[1] || '';
    }
    return ret;
}
/**
 * @public
 */ function $7904d4b709390668$var$checkClassType(componentType) {
    $f16f2994a32ad273$export$a7a9523472993e97(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}
function $7904d4b709390668$export$4f3b818f3dd2d182(clz) {
    return !!(clz && clz[$7904d4b709390668$var$IS_EXTENDED_CLASS]);
}
function $7904d4b709390668$export$cd4c3a4dca301c70(rootClz, mandatoryMethods) {
    rootClz.$constructor = rootClz; // FIXME: not necessary?
    rootClz.extend = function(proto) {
        var superClass = this;
        var ExtendedClass;
        if ($7904d4b709390668$var$isESClass(superClass)) ExtendedClass = /** @class */ function(_super) {
            (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(class_1, _super);
            function class_1() {
                return _super.apply(this, arguments) || this;
            }
            return class_1;
        }(superClass);
        else {
            // For backward compat, we both support ts class inheritance and this
            // "extend" approach.
            // The constructor should keep the same behavior as ts class inheritance:
            // If this constructor/$constructor is not declared, auto invoke the super
            // constructor.
            // If this constructor/$constructor is declared, it is responsible for
            // calling the super constructor.
            ExtendedClass = function ExtendedClass() {
                (proto.$constructor || superClass).apply(this, arguments);
            };
            $f16f2994a32ad273$export$69f1b2dcda23c5f8(ExtendedClass, this);
        }
        $f16f2994a32ad273$export$8b58be045bf06082(ExtendedClass.prototype, proto);
        ExtendedClass[$7904d4b709390668$var$IS_EXTENDED_CLASS] = true;
        ExtendedClass.extend = this.extend;
        ExtendedClass.superCall = $7904d4b709390668$var$superCall;
        ExtendedClass.superApply = $7904d4b709390668$var$superApply;
        ExtendedClass.superClass = superClass;
        return ExtendedClass;
    };
}
function $7904d4b709390668$var$isESClass(fn) {
    return $f16f2994a32ad273$export$f6e2535fb5126e54(fn) && /^class\s/.test(Function.prototype.toString.call(fn));
}
function $7904d4b709390668$export$c9c2d87774f1275d(SubClz, SupperClz) {
    SubClz.extend = SupperClz.extend;
}
// A random offset.
var $7904d4b709390668$var$classBase = Math.round(Math.random() * 10);
function $7904d4b709390668$export$e1aac4552ae82081(target) {
    var classAttr = [
        '__\0is_clz',
        $7904d4b709390668$var$classBase++
    ].join('_');
    target.prototype[classAttr] = true;
    target.isInstance = function(obj) {
        return !!(obj && obj[classAttr]);
    };
}
// superCall should have class info, which can not be fetched from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, does not override method f,
// then when method of class C is called, dead loop occurred.
function $7904d4b709390668$var$superCall(context, methodName) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return this.superClass.prototype[methodName].apply(context, args);
}
function $7904d4b709390668$var$superApply(context, methodName, args) {
    return this.superClass.prototype[methodName].apply(context, args);
}
function $7904d4b709390668$export$241315e45585454d(target) {
    /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'a'
   *     or Object.<subKey, componentClass>, when componentType is 'a.b'
   */ var storage = {};
    target.registerClass = function(clz) {
        // `type` should not be a "instance member".
        // If using TS class, should better declared as `static type = 'series.pie'`.
        // otherwise users have to mount `type` on prototype manually.
        // For backward compat and enable instance visit type via `this.type`,
        // we still support fetch `type` from prototype.
        var componentFullType = clz.type || clz.prototype.type;
        if (componentFullType) {
            $7904d4b709390668$var$checkClassType(componentFullType);
            // If only static type declared, we assign it to prototype mandatorily.
            clz.prototype.type = componentFullType;
            var componentTypeInfo = $7904d4b709390668$export$fbe18865d303bf01(componentFullType);
            if (!componentTypeInfo.sub) storage[componentTypeInfo.main] = clz;
            else if (componentTypeInfo.sub !== $7904d4b709390668$var$IS_CONTAINER) {
                var container = makeContainer(componentTypeInfo);
                container[componentTypeInfo.sub] = clz;
            }
        }
        return clz;
    };
    target.getClass = function(mainType, subType, throwWhenNotFound) {
        var clz = storage[mainType];
        if (clz && clz[$7904d4b709390668$var$IS_CONTAINER]) clz = subType ? clz[subType] : null;
        if (throwWhenNotFound && !clz) throw new Error(!subType ? mainType + '.' + 'type should be specified.' : 'Component ' + mainType + '.' + (subType || '') + ' is used but not imported.');
        return clz;
    };
    target.getClassesByMainType = function(componentType) {
        var componentTypeInfo = $7904d4b709390668$export$fbe18865d303bf01(componentType);
        var result = [];
        var obj = storage[componentTypeInfo.main];
        if (obj && obj[$7904d4b709390668$var$IS_CONTAINER]) $f16f2994a32ad273$export$79b2f7037acddd43(obj, function(o, type) {
            type !== $7904d4b709390668$var$IS_CONTAINER && result.push(o);
        });
        else result.push(obj);
        return result;
    };
    target.hasClass = function(componentType) {
        // Just consider componentType.main.
        var componentTypeInfo = $7904d4b709390668$export$fbe18865d303bf01(componentType);
        return !!storage[componentTypeInfo.main];
    };
    /**
   * @return Like ['aa', 'bb'], but can not be ['aa.xx']
   */ target.getAllClassMainTypes = function() {
        var types = [];
        $f16f2994a32ad273$export$79b2f7037acddd43(storage, function(obj, type) {
            types.push(type);
        });
        return types;
    };
    /**
   * If a main type is container and has sub types
   */ target.hasSubTypes = function(componentType) {
        var componentTypeInfo = $7904d4b709390668$export$fbe18865d303bf01(componentType);
        var obj = storage[componentTypeInfo.main];
        return obj && obj[$7904d4b709390668$var$IS_CONTAINER];
    };
    function makeContainer(componentTypeInfo) {
        var container = storage[componentTypeInfo.main];
        if (!container || !container[$7904d4b709390668$var$IS_CONTAINER]) {
            container = storage[componentTypeInfo.main] = {};
            container[$7904d4b709390668$var$IS_CONTAINER] = true;
        }
        return container;
    }
} // /**
 //  * @param {string|Array.<string>} properties
 //  */
 // export function setReadOnly(obj, properties) {
 // FIXME It seems broken in IE8 simulation of IE11
 // if (!zrUtil.isArray(properties)) {
 //     properties = properties != null ? [properties] : [];
 // }
 // zrUtil.each(properties, function (prop) {
 //     let value = obj[prop];
 //     Object.defineProperty
 //         && Object.defineProperty(obj, prop, {
 //             value: value, writable: false
 //         });
 //     zrUtil.isArray(obj[prop])
 //         && Object.freeze
 //         && Object.freeze(obj[prop]);
 // });
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Parse shadow style
// TODO Only shallow path support

function $77cc5e805eb51edf$export$2e2bcd8739ae039(properties, ignoreParent) {
    // Normalize
    for(var i = 0; i < properties.length; i++)if (!properties[i][1]) properties[i][1] = properties[i][0];
    ignoreParent = ignoreParent || false;
    return function(model, excludes, includes) {
        var style = {};
        for(var i = 0; i < properties.length; i++){
            var propName = properties[i][1];
            if (excludes && $f16f2994a32ad273$export$305f7d4e9d4624f2(excludes, propName) >= 0 || includes && $f16f2994a32ad273$export$305f7d4e9d4624f2(includes, propName) < 0) continue;
            var val = model.getShallow(propName, ignoreParent);
            if (val != null) style[properties[i][0]] = val;
        }
        // TODO Text or image?
        return style;
    };
}


var $8abdbeda94795c36$export$52de6e304d934d85 = [
    [
        'fill',
        'color'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'opacity'
    ],
    [
        'shadowColor'
    ]
];
var $8abdbeda94795c36$var$getAreaStyle = (0, $77cc5e805eb51edf$export$2e2bcd8739ae039)($8abdbeda94795c36$export$52de6e304d934d85);
var $8abdbeda94795c36$export$a3a0ed7e2dd84c9e = /** @class */ function() {
    function AreaStyleMixin() {}
    AreaStyleMixin.prototype.getAreaStyle = function(excludes, includes) {
        return $8abdbeda94795c36$var$getAreaStyle(this, excludes, includes);
    };
    return AreaStyleMixin;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $3e20f9b845f6268e$var$globalImageCache = new (0, $5673a7dd695e5835$export$2e2bcd8739ae039)(50);
function $3e20f9b845f6268e$export$1b614f30ac2c8867(newImageOrSrc) {
    if (typeof newImageOrSrc === 'string') {
        var cachedImgObj = $3e20f9b845f6268e$var$globalImageCache.get(newImageOrSrc);
        return cachedImgObj && cachedImgObj.image;
    } else return newImageOrSrc;
}
function $3e20f9b845f6268e$export$46c791b69ff9a0f(newImageOrSrc, image, hostEl, onload, cbPayload) {
    if (!newImageOrSrc) return image;
    else if (typeof newImageOrSrc === 'string') {
        if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) return image;
        var cachedImgObj = $3e20f9b845f6268e$var$globalImageCache.get(newImageOrSrc);
        var pendingWrap = {
            hostEl: hostEl,
            cb: onload,
            cbPayload: cbPayload
        };
        if (cachedImgObj) {
            image = cachedImgObj.image;
            !$3e20f9b845f6268e$export$37ca7dd901d0236d(image) && cachedImgObj.pending.push(pendingWrap);
        } else {
            image = (0, $e4ffe803d17351c8$export$ef5e599365494451).loadImage(newImageOrSrc, $3e20f9b845f6268e$var$imageOnLoad, $3e20f9b845f6268e$var$imageOnLoad);
            image.__zrImageSrc = newImageOrSrc;
            $3e20f9b845f6268e$var$globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
                image: image,
                pending: [
                    pendingWrap
                ]
            });
        }
        return image;
    } else return newImageOrSrc;
}
function $3e20f9b845f6268e$var$imageOnLoad() {
    var cachedImgObj = this.__cachedImgObj;
    this.onload = this.onerror = this.__cachedImgObj = null;
    for(var i = 0; i < cachedImgObj.pending.length; i++){
        var pendingWrap = cachedImgObj.pending[i];
        var cb = pendingWrap.cb;
        cb && cb(this, pendingWrap.cbPayload);
        pendingWrap.hostEl.dirty();
    }
    cachedImgObj.pending.length = 0;
}
function $3e20f9b845f6268e$export$37ca7dd901d0236d(image) {
    return image && image.width && image.height;
}





var $a12266b0d5b7d162$var$STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
function $a12266b0d5b7d162$export$59a943b34a82e690(text, containerWidth, font, ellipsis, options) {
    var out = {};
    $a12266b0d5b7d162$var$truncateText2(out, text, containerWidth, font, ellipsis, options);
    return out.text;
}
function $a12266b0d5b7d162$var$truncateText2(out, text, containerWidth, font, ellipsis, options) {
    if (!containerWidth) {
        out.text = '';
        out.isTruncated = false;
        return;
    }
    var textLines = (text + '').split('\n');
    options = $a12266b0d5b7d162$var$prepareTruncateOptions(containerWidth, font, ellipsis, options);
    var isTruncated = false;
    var truncateOut = {};
    for(var i = 0, len = textLines.length; i < len; i++){
        $a12266b0d5b7d162$var$truncateSingleLine(truncateOut, textLines[i], options);
        textLines[i] = truncateOut.textLine;
        isTruncated = isTruncated || truncateOut.isTruncated;
    }
    out.text = textLines.join('\n');
    out.isTruncated = isTruncated;
}
function $a12266b0d5b7d162$var$prepareTruncateOptions(containerWidth, font, ellipsis, options) {
    options = options || {};
    var preparedOpts = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, options);
    ellipsis = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(ellipsis, '...');
    preparedOpts.maxIterations = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(options.maxIterations, 2);
    var minChar = preparedOpts.minChar = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(options.minChar, 0);
    var fontMeasureInfo = preparedOpts.fontMeasureInfo = (0, $3ad1e5e308f2a981$export$23ef3ef10b010856)(font);
    var ascCharWidth = fontMeasureInfo.asciiCharWidth;
    preparedOpts.placeholder = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(options.placeholder, '');
    var contentWidth = containerWidth = Math.max(0, containerWidth - 1);
    for(var i = 0; i < minChar && contentWidth >= ascCharWidth; i++)contentWidth -= ascCharWidth;
    var ellipsisWidth = (0, $3ad1e5e308f2a981$export$e6849d91c2a0b61f)(fontMeasureInfo, ellipsis);
    if (ellipsisWidth > contentWidth) {
        ellipsis = '';
        ellipsisWidth = 0;
    }
    contentWidth = containerWidth - ellipsisWidth;
    preparedOpts.ellipsis = ellipsis;
    preparedOpts.ellipsisWidth = ellipsisWidth;
    preparedOpts.contentWidth = contentWidth;
    preparedOpts.containerWidth = containerWidth;
    return preparedOpts;
}
function $a12266b0d5b7d162$var$truncateSingleLine(out, textLine, options) {
    var containerWidth = options.containerWidth;
    var contentWidth = options.contentWidth;
    var fontMeasureInfo = options.fontMeasureInfo;
    if (!containerWidth) {
        out.textLine = '';
        out.isTruncated = false;
        return;
    }
    var lineWidth = (0, $3ad1e5e308f2a981$export$e6849d91c2a0b61f)(fontMeasureInfo, textLine);
    if (lineWidth <= containerWidth) {
        out.textLine = textLine;
        out.isTruncated = false;
        return;
    }
    for(var j = 0;; j++){
        if (lineWidth <= contentWidth || j >= options.maxIterations) {
            textLine += options.ellipsis;
            break;
        }
        var subLength = j === 0 ? $a12266b0d5b7d162$var$estimateLength(textLine, contentWidth, fontMeasureInfo) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
        textLine = textLine.substr(0, subLength);
        lineWidth = (0, $3ad1e5e308f2a981$export$e6849d91c2a0b61f)(fontMeasureInfo, textLine);
    }
    if (textLine === '') textLine = options.placeholder;
    out.textLine = textLine;
    out.isTruncated = true;
}
function $a12266b0d5b7d162$var$estimateLength(text, contentWidth, fontMeasureInfo) {
    var width = 0;
    var i = 0;
    for(var len = text.length; i < len && width < contentWidth; i++)width += (0, $3ad1e5e308f2a981$export$4e92f5603b5c7bb3)(fontMeasureInfo, text.charCodeAt(i));
    return i;
}
function $a12266b0d5b7d162$export$5772575e34ef80f9(rawText, style, defaultOuterWidth, defaultOuterHeight) {
    var text = $a12266b0d5b7d162$var$formatText(rawText);
    var overflow = style.overflow;
    var padding = style.padding;
    var paddingH = padding ? padding[1] + padding[3] : 0;
    var paddingV = padding ? padding[0] + padding[2] : 0;
    var font = style.font;
    var truncate = overflow === 'truncate';
    var calculatedLineHeight = (0, $3ad1e5e308f2a981$export$56204a27a2958a55)(font);
    var lineHeight = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(style.lineHeight, calculatedLineHeight);
    var truncateLineOverflow = style.lineOverflow === 'truncate';
    var isTruncated = false;
    var width = style.width;
    if (width == null && defaultOuterWidth != null) width = defaultOuterWidth - paddingH;
    var height = style.height;
    if (height == null && defaultOuterHeight != null) height = defaultOuterHeight - paddingV;
    var lines;
    if (width != null && (overflow === 'break' || overflow === 'breakAll')) lines = text ? $a12266b0d5b7d162$var$wrapText(text, style.font, width, overflow === 'breakAll', 0).lines : [];
    else lines = text ? text.split('\n') : [];
    var contentHeight = lines.length * lineHeight;
    if (height == null) height = contentHeight;
    if (contentHeight > height && truncateLineOverflow) {
        var lineCount = Math.floor(height / lineHeight);
        isTruncated = isTruncated || lines.length > lineCount;
        lines = lines.slice(0, lineCount);
        contentHeight = lines.length * lineHeight;
    }
    if (text && truncate && width != null) {
        var options = $a12266b0d5b7d162$var$prepareTruncateOptions(width, font, style.ellipsis, {
            minChar: style.truncateMinChar,
            placeholder: style.placeholder
        });
        var singleOut = {};
        for(var i = 0; i < lines.length; i++){
            $a12266b0d5b7d162$var$truncateSingleLine(singleOut, lines[i], options);
            lines[i] = singleOut.textLine;
            isTruncated = isTruncated || singleOut.isTruncated;
        }
    }
    var outerHeight = height;
    var contentWidth = 0;
    var fontMeasureInfo = (0, $3ad1e5e308f2a981$export$23ef3ef10b010856)(font);
    for(var i = 0; i < lines.length; i++)contentWidth = Math.max((0, $3ad1e5e308f2a981$export$e6849d91c2a0b61f)(fontMeasureInfo, lines[i]), contentWidth);
    if (width == null) width = contentWidth;
    var outerWidth = width;
    outerHeight += paddingV;
    outerWidth += paddingH;
    return {
        lines: lines,
        height: height,
        outerWidth: outerWidth,
        outerHeight: outerHeight,
        lineHeight: lineHeight,
        calculatedLineHeight: calculatedLineHeight,
        contentWidth: contentWidth,
        contentHeight: contentHeight,
        width: width,
        isTruncated: isTruncated
    };
}
var $a12266b0d5b7d162$var$RichTextToken = function() {
    function RichTextToken() {}
    return RichTextToken;
}();
var $a12266b0d5b7d162$var$RichTextLine = function() {
    function RichTextLine(tokens) {
        this.tokens = [];
        if (tokens) this.tokens = tokens;
    }
    return RichTextLine;
}();
var $a12266b0d5b7d162$export$ca607d3c98caaf7e = function() {
    function RichTextContentBlock() {
        this.width = 0;
        this.height = 0;
        this.contentWidth = 0;
        this.contentHeight = 0;
        this.outerWidth = 0;
        this.outerHeight = 0;
        this.lines = [];
        this.isTruncated = false;
    }
    return RichTextContentBlock;
}();
function $a12266b0d5b7d162$export$15ec9472ff2d721(rawText, style, defaultOuterWidth, defaultOuterHeight, topTextAlign) {
    var contentBlock = new $a12266b0d5b7d162$export$ca607d3c98caaf7e();
    var text = $a12266b0d5b7d162$var$formatText(rawText);
    if (!text) return contentBlock;
    var stlPadding = style.padding;
    var stlPaddingH = stlPadding ? stlPadding[1] + stlPadding[3] : 0;
    var stlPaddingV = stlPadding ? stlPadding[0] + stlPadding[2] : 0;
    var topWidth = style.width;
    if (topWidth == null && defaultOuterWidth != null) topWidth = defaultOuterWidth - stlPaddingH;
    var topHeight = style.height;
    if (topHeight == null && defaultOuterHeight != null) topHeight = defaultOuterHeight - stlPaddingV;
    var overflow = style.overflow;
    var wrapInfo = (overflow === 'break' || overflow === 'breakAll') && topWidth != null ? {
        width: topWidth,
        accumWidth: 0,
        breakAll: overflow === 'breakAll'
    } : null;
    var lastIndex = $a12266b0d5b7d162$var$STYLE_REG.lastIndex = 0;
    var result;
    while((result = $a12266b0d5b7d162$var$STYLE_REG.exec(text)) != null){
        var matchedIndex = result.index;
        if (matchedIndex > lastIndex) $a12266b0d5b7d162$var$pushTokens(contentBlock, text.substring(lastIndex, matchedIndex), style, wrapInfo);
        $a12266b0d5b7d162$var$pushTokens(contentBlock, result[2], style, wrapInfo, result[1]);
        lastIndex = $a12266b0d5b7d162$var$STYLE_REG.lastIndex;
    }
    if (lastIndex < text.length) $a12266b0d5b7d162$var$pushTokens(contentBlock, text.substring(lastIndex, text.length), style, wrapInfo);
    var pendingList = [];
    var calculatedHeight = 0;
    var calculatedWidth = 0;
    var truncate = overflow === 'truncate';
    var truncateLine = style.lineOverflow === 'truncate';
    var tmpTruncateOut = {};
    function finishLine(line, lineWidth, lineHeight) {
        line.width = lineWidth;
        line.lineHeight = lineHeight;
        calculatedHeight += lineHeight;
        calculatedWidth = Math.max(calculatedWidth, lineWidth);
    }
    outer: for(var i = 0; i < contentBlock.lines.length; i++){
        var line = contentBlock.lines[i];
        var lineHeight = 0;
        var lineWidth = 0;
        for(var j = 0; j < line.tokens.length; j++){
            var token = line.tokens[j];
            var tokenStyle = token.styleName && style.rich[token.styleName] || {};
            var textPadding = token.textPadding = tokenStyle.padding;
            var paddingH = textPadding ? textPadding[1] + textPadding[3] : 0;
            var font = token.font = tokenStyle.font || style.font;
            token.contentHeight = (0, $3ad1e5e308f2a981$export$56204a27a2958a55)(font);
            var tokenHeight = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(tokenStyle.height, token.contentHeight);
            token.innerHeight = tokenHeight;
            textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
            token.height = tokenHeight;
            token.lineHeight = (0, $f16f2994a32ad273$export$2e94551289abb95b)(tokenStyle.lineHeight, style.lineHeight, tokenHeight);
            token.align = tokenStyle && tokenStyle.align || topTextAlign;
            token.verticalAlign = tokenStyle && tokenStyle.verticalAlign || 'middle';
            if (truncateLine && topHeight != null && calculatedHeight + token.lineHeight > topHeight) {
                var originalLength = contentBlock.lines.length;
                if (j > 0) {
                    line.tokens = line.tokens.slice(0, j);
                    finishLine(line, lineWidth, lineHeight);
                    contentBlock.lines = contentBlock.lines.slice(0, i + 1);
                } else contentBlock.lines = contentBlock.lines.slice(0, i);
                contentBlock.isTruncated = contentBlock.isTruncated || contentBlock.lines.length < originalLength;
                break outer;
            }
            var styleTokenWidth = tokenStyle.width;
            var tokenWidthNotSpecified = styleTokenWidth == null || styleTokenWidth === 'auto';
            if (typeof styleTokenWidth === 'string' && styleTokenWidth.charAt(styleTokenWidth.length - 1) === '%') {
                token.percentWidth = styleTokenWidth;
                pendingList.push(token);
                token.contentWidth = (0, $3ad1e5e308f2a981$export$e6849d91c2a0b61f)((0, $3ad1e5e308f2a981$export$23ef3ef10b010856)(font), token.text);
            } else {
                if (tokenWidthNotSpecified) {
                    var textBackgroundColor = tokenStyle.backgroundColor;
                    var bgImg = textBackgroundColor && textBackgroundColor.image;
                    if (bgImg) {
                        bgImg = $3e20f9b845f6268e$export$1b614f30ac2c8867(bgImg);
                        if ($3e20f9b845f6268e$export$37ca7dd901d0236d(bgImg)) token.width = Math.max(token.width, bgImg.width * tokenHeight / bgImg.height);
                    }
                }
                var remainTruncWidth = truncate && topWidth != null ? topWidth - lineWidth : null;
                if (remainTruncWidth != null && remainTruncWidth < token.width) {
                    if (!tokenWidthNotSpecified || remainTruncWidth < paddingH) {
                        token.text = '';
                        token.width = token.contentWidth = 0;
                    } else {
                        $a12266b0d5b7d162$var$truncateText2(tmpTruncateOut, token.text, remainTruncWidth - paddingH, font, style.ellipsis, {
                            minChar: style.truncateMinChar
                        });
                        token.text = tmpTruncateOut.text;
                        contentBlock.isTruncated = contentBlock.isTruncated || tmpTruncateOut.isTruncated;
                        token.width = token.contentWidth = (0, $3ad1e5e308f2a981$export$e6849d91c2a0b61f)((0, $3ad1e5e308f2a981$export$23ef3ef10b010856)(font), token.text);
                    }
                } else token.contentWidth = (0, $3ad1e5e308f2a981$export$e6849d91c2a0b61f)((0, $3ad1e5e308f2a981$export$23ef3ef10b010856)(font), token.text);
            }
            token.width += paddingH;
            lineWidth += token.width;
            tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
        }
        finishLine(line, lineWidth, lineHeight);
    }
    contentBlock.outerWidth = contentBlock.width = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(topWidth, calculatedWidth);
    contentBlock.outerHeight = contentBlock.height = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(topHeight, calculatedHeight);
    contentBlock.contentHeight = calculatedHeight;
    contentBlock.contentWidth = calculatedWidth;
    contentBlock.outerWidth += stlPaddingH;
    contentBlock.outerHeight += stlPaddingV;
    for(var i = 0; i < pendingList.length; i++){
        var token = pendingList[i];
        var percentWidth = token.percentWidth;
        token.width = parseInt(percentWidth, 10) / 100 * contentBlock.width;
    }
    return contentBlock;
}
function $a12266b0d5b7d162$var$pushTokens(block, str, style, wrapInfo, styleName) {
    var isEmptyStr = str === '';
    var tokenStyle = styleName && style.rich[styleName] || {};
    var lines = block.lines;
    var font = tokenStyle.font || style.font;
    var newLine = false;
    var strLines;
    var linesWidths;
    if (wrapInfo) {
        var tokenPadding = tokenStyle.padding;
        var tokenPaddingH = tokenPadding ? tokenPadding[1] + tokenPadding[3] : 0;
        if (tokenStyle.width != null && tokenStyle.width !== 'auto') {
            var outerWidth_1 = (0, $3ad1e5e308f2a981$export$e8514cb5a5e2b40f)(tokenStyle.width, wrapInfo.width) + tokenPaddingH;
            if (lines.length > 0) {
                if (outerWidth_1 + wrapInfo.accumWidth > wrapInfo.width) {
                    strLines = str.split('\n');
                    newLine = true;
                }
            }
            wrapInfo.accumWidth = outerWidth_1;
        } else {
            var res = $a12266b0d5b7d162$var$wrapText(str, font, wrapInfo.width, wrapInfo.breakAll, wrapInfo.accumWidth);
            wrapInfo.accumWidth = res.accumWidth + tokenPaddingH;
            linesWidths = res.linesWidths;
            strLines = res.lines;
        }
    }
    if (!strLines) strLines = str.split('\n');
    var fontMeasureInfo = (0, $3ad1e5e308f2a981$export$23ef3ef10b010856)(font);
    for(var i = 0; i < strLines.length; i++){
        var text = strLines[i];
        var token = new $a12266b0d5b7d162$var$RichTextToken();
        token.styleName = styleName;
        token.text = text;
        token.isLineHolder = !text && !isEmptyStr;
        if (typeof tokenStyle.width === 'number') token.width = tokenStyle.width;
        else token.width = linesWidths ? linesWidths[i] : (0, $3ad1e5e308f2a981$export$e6849d91c2a0b61f)(fontMeasureInfo, text);
        if (!i && !newLine) {
            var tokens = (lines[lines.length - 1] || (lines[0] = new $a12266b0d5b7d162$var$RichTextLine())).tokens;
            var tokensLen = tokens.length;
            tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : (text || !tokensLen || isEmptyStr) && tokens.push(token);
        } else lines.push(new $a12266b0d5b7d162$var$RichTextLine([
            token
        ]));
    }
}
function $a12266b0d5b7d162$var$isAlphabeticLetter(ch) {
    var code = ch.charCodeAt(0);
    return code >= 0x20 && code <= 0x24F || code >= 0x370 && code <= 0x10FF || code >= 0x1200 && code <= 0x13FF || code >= 0x1E00 && code <= 0x206F;
}
var $a12266b0d5b7d162$var$breakCharMap = (0, $f16f2994a32ad273$export$533b26079ad0b4b)(',&?/;] '.split(''), function(obj, ch) {
    obj[ch] = true;
    return obj;
}, {});
function $a12266b0d5b7d162$var$isWordBreakChar(ch) {
    if ($a12266b0d5b7d162$var$isAlphabeticLetter(ch)) {
        if ($a12266b0d5b7d162$var$breakCharMap[ch]) return true;
        return false;
    }
    return true;
}
function $a12266b0d5b7d162$var$wrapText(text, font, lineWidth, isBreakAll, lastAccumWidth) {
    var lines = [];
    var linesWidths = [];
    var line = '';
    var currentWord = '';
    var currentWordWidth = 0;
    var accumWidth = 0;
    var fontMeasureInfo = (0, $3ad1e5e308f2a981$export$23ef3ef10b010856)(font);
    for(var i = 0; i < text.length; i++){
        var ch = text.charAt(i);
        if (ch === '\n') {
            if (currentWord) {
                line += currentWord;
                accumWidth += currentWordWidth;
            }
            lines.push(line);
            linesWidths.push(accumWidth);
            line = '';
            currentWord = '';
            currentWordWidth = 0;
            accumWidth = 0;
            continue;
        }
        var chWidth = (0, $3ad1e5e308f2a981$export$4e92f5603b5c7bb3)(fontMeasureInfo, ch.charCodeAt(0));
        var inWord = isBreakAll ? false : !$a12266b0d5b7d162$var$isWordBreakChar(ch);
        if (!lines.length ? lastAccumWidth + accumWidth + chWidth > lineWidth : accumWidth + chWidth > lineWidth) {
            if (!accumWidth) {
                if (inWord) {
                    lines.push(currentWord);
                    linesWidths.push(currentWordWidth);
                    currentWord = ch;
                    currentWordWidth = chWidth;
                } else {
                    lines.push(ch);
                    linesWidths.push(chWidth);
                }
            } else if (line || currentWord) {
                if (inWord) {
                    if (!line) {
                        line = currentWord;
                        currentWord = '';
                        currentWordWidth = 0;
                        accumWidth = currentWordWidth;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth - currentWordWidth);
                    currentWord += ch;
                    currentWordWidth += chWidth;
                    line = '';
                    accumWidth = currentWordWidth;
                } else {
                    if (currentWord) {
                        line += currentWord;
                        currentWord = '';
                        currentWordWidth = 0;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth);
                    line = ch;
                    accumWidth = chWidth;
                }
            }
            continue;
        }
        accumWidth += chWidth;
        if (inWord) {
            currentWord += ch;
            currentWordWidth += chWidth;
        } else {
            if (currentWord) {
                line += currentWord;
                currentWord = '';
                currentWordWidth = 0;
            }
            line += ch;
        }
    }
    if (currentWord) line += currentWord;
    if (line) {
        lines.push(line);
        linesWidths.push(accumWidth);
    }
    if (lines.length === 1) accumWidth += lastAccumWidth;
    return {
        accumWidth: accumWidth,
        lines: lines,
        linesWidths: linesWidths
    };
}
function $a12266b0d5b7d162$export$9a4428591d825b14(out, overflowRect, baseX, baseY, textAlign, textVerticalAlign) {
    out.baseX = baseX;
    out.baseY = baseY;
    out.outerWidth = out.outerHeight = null;
    if (!overflowRect) return;
    var textWidth = overflowRect.width * 2;
    var textHeight = overflowRect.height * 2;
    (0, $7456366ce379c42e$export$2e2bcd8739ae039).set($a12266b0d5b7d162$var$tmpCITCTextRect, (0, $3ad1e5e308f2a981$export$eb5a525ef00ef9a4)(baseX, textWidth, textAlign), (0, $3ad1e5e308f2a981$export$bf7d6802d2badd9)(baseY, textHeight, textVerticalAlign), textWidth, textHeight);
    (0, $7456366ce379c42e$export$2e2bcd8739ae039).intersect(overflowRect, $a12266b0d5b7d162$var$tmpCITCTextRect, null, $a12266b0d5b7d162$var$tmpCITCIntersectRectOpt);
    var outIntersectRect = $a12266b0d5b7d162$var$tmpCITCIntersectRectOpt.outIntersectRect;
    out.outerWidth = outIntersectRect.width;
    out.outerHeight = outIntersectRect.height;
    out.baseX = (0, $3ad1e5e308f2a981$export$eb5a525ef00ef9a4)(outIntersectRect.x, outIntersectRect.width, textAlign, true);
    out.baseY = (0, $3ad1e5e308f2a981$export$bf7d6802d2badd9)(outIntersectRect.y, outIntersectRect.height, textVerticalAlign, true);
}
var $a12266b0d5b7d162$var$tmpCITCTextRect = new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $a12266b0d5b7d162$var$tmpCITCIntersectRectOpt = {
    outIntersectRect: {},
    clamp: true
};
function $a12266b0d5b7d162$var$formatText(text) {
    return text != null ? text += '' : text = '';
}
function $a12266b0d5b7d162$export$d79289ac0f53b974(style) {
    var text = $a12266b0d5b7d162$var$formatText(style.text);
    var font = style.font;
    var contentWidth = (0, $3ad1e5e308f2a981$export$e6849d91c2a0b61f)((0, $3ad1e5e308f2a981$export$23ef3ef10b010856)(font), text);
    var contentHeight = (0, $3ad1e5e308f2a981$export$56204a27a2958a55)(font);
    return $a12266b0d5b7d162$export$bd5d12d7bf7c9027(style, contentWidth, contentHeight, null);
}
function $a12266b0d5b7d162$export$bd5d12d7bf7c9027(style, contentWidth, contentHeight, forceLineWidth) {
    var rect = new (0, $7456366ce379c42e$export$2e2bcd8739ae039)((0, $3ad1e5e308f2a981$export$eb5a525ef00ef9a4)(style.x || 0, contentWidth, style.textAlign), (0, $3ad1e5e308f2a981$export$bf7d6802d2badd9)(style.y || 0, contentHeight, style.textBaseline), contentWidth, contentHeight);
    var lineWidth = forceLineWidth != null ? forceLineWidth : $a12266b0d5b7d162$export$c7aae0ffd99a8643(style) ? style.lineWidth : 0;
    if (lineWidth > 0) {
        rect.x -= lineWidth / 2;
        rect.y -= lineWidth / 2;
        rect.width += lineWidth;
        rect.height += lineWidth;
    }
    return rect;
}
function $a12266b0d5b7d162$export$c7aae0ffd99a8643(style) {
    var stroke = style.stroke;
    return stroke != null && stroke !== 'none' && style.lineWidth > 0;
}








var $0a0ef4888a4b4e90$var$STYLE_MAGIC_KEY = '__zr_style_' + Math.round(Math.random() * 10);
var $0a0ef4888a4b4e90$export$737672163db00fe3 = {
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: '#000',
    opacity: 1,
    blend: 'source-over'
};
var $0a0ef4888a4b4e90$export$9908943fb57fbe51 = {
    style: {
        shadowBlur: true,
        shadowOffsetX: true,
        shadowOffsetY: true,
        shadowColor: true,
        opacity: true
    }
};
$0a0ef4888a4b4e90$export$737672163db00fe3[$0a0ef4888a4b4e90$var$STYLE_MAGIC_KEY] = true;
var $0a0ef4888a4b4e90$var$PRIMARY_STATES_KEYS = [
    'z',
    'z2',
    'invisible'
];
var $0a0ef4888a4b4e90$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER = [
    'invisible'
];
var $0a0ef4888a4b4e90$var$Displayable = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Displayable, _super);
    function Displayable(props) {
        return _super.call(this, props) || this;
    }
    Displayable.prototype._init = function(props) {
        var keysArr = (0, $f16f2994a32ad273$export$ed97f33186d4b816)(props);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            if (key === 'style') this.useStyle(props[key]);
            else _super.prototype.attrKV.call(this, key, props[key]);
        }
        if (!this.style) this.useStyle({});
    };
    Displayable.prototype.beforeBrush = function(param) {};
    Displayable.prototype.afterBrush = function() {};
    Displayable.prototype.innerBeforeBrush = function() {};
    Displayable.prototype.innerAfterBrush = function() {};
    Displayable.prototype.shouldBePainted = function(viewWidth, viewHeight, considerClipPath, considerAncestors) {
        var m = this.transform;
        if (this.ignore || this.invisible || this.style.opacity === 0 || this.culling && $0a0ef4888a4b4e90$var$isDisplayableCulled(this, viewWidth, viewHeight) || m && !m[0] && !m[3]) return false;
        if (considerClipPath && this.__clipPaths && this.__clipPaths.length) for(var i = 0; i < this.__clipPaths.length; ++i){
            if (this.__clipPaths[i].isZeroArea()) return false;
        }
        if (considerAncestors && this.parent) {
            var parent_1 = this.parent;
            while(parent_1){
                if (parent_1.ignore) return false;
                parent_1 = parent_1.parent;
            }
        }
        return true;
    };
    Displayable.prototype.contain = function(x, y) {
        return this.rectContain(x, y);
    };
    Displayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    Displayable.prototype.rectContain = function(x, y) {
        var coord = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        return rect.contain(coord[0], coord[1]);
    };
    Displayable.prototype.getPaintRect = function() {
        var rect = this._paintRect;
        if (!this._paintRect || this.__dirty) {
            var transform = this.transform;
            var elRect = this.getBoundingRect();
            var style = this.style;
            var shadowSize = style.shadowBlur || 0;
            var shadowOffsetX = style.shadowOffsetX || 0;
            var shadowOffsetY = style.shadowOffsetY || 0;
            rect = this._paintRect || (this._paintRect = new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(0, 0, 0, 0));
            if (transform) (0, $7456366ce379c42e$export$2e2bcd8739ae039).applyTransform(rect, elRect, transform);
            else rect.copy(elRect);
            if (shadowSize || shadowOffsetX || shadowOffsetY) {
                rect.width += shadowSize * 2 + Math.abs(shadowOffsetX);
                rect.height += shadowSize * 2 + Math.abs(shadowOffsetY);
                rect.x = Math.min(rect.x, rect.x + shadowOffsetX - shadowSize);
                rect.y = Math.min(rect.y, rect.y + shadowOffsetY - shadowSize);
            }
            var tolerance = this.dirtyRectTolerance;
            if (!rect.isZero()) {
                rect.x = Math.floor(rect.x - tolerance);
                rect.y = Math.floor(rect.y - tolerance);
                rect.width = Math.ceil(rect.width + 1 + tolerance * 2);
                rect.height = Math.ceil(rect.height + 1 + tolerance * 2);
            }
        }
        return rect;
    };
    Displayable.prototype.setPrevPaintRect = function(paintRect) {
        if (paintRect) {
            this._prevPaintRect = this._prevPaintRect || new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(0, 0, 0, 0);
            this._prevPaintRect.copy(paintRect);
        } else this._prevPaintRect = null;
    };
    Displayable.prototype.getPrevPaintRect = function() {
        return this._prevPaintRect;
    };
    Displayable.prototype.animateStyle = function(loop) {
        return this.animate('style', loop);
    };
    Displayable.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === 'style') this.dirtyStyle();
        else this.markRedraw();
    };
    Displayable.prototype.attrKV = function(key, value) {
        if (key !== 'style') _super.prototype.attrKV.call(this, key, value);
        else if (!this.style) this.useStyle(value);
        else this.setStyle(value);
    };
    Displayable.prototype.setStyle = function(keyOrObj, value) {
        if (typeof keyOrObj === 'string') this.style[keyOrObj] = value;
        else (0, $f16f2994a32ad273$export$8b58be045bf06082)(this.style, keyOrObj);
        this.dirtyStyle();
        return this;
    };
    Displayable.prototype.dirtyStyle = function(notRedraw) {
        if (!notRedraw) this.markRedraw();
        this.__dirty |= (0, $66869c587f14f122$export$ada8b2beb3d76671);
        if (this._rect) this._rect = null;
    };
    Displayable.prototype.dirty = function() {
        this.dirtyStyle();
    };
    Displayable.prototype.styleChanged = function() {
        return !!(this.__dirty & (0, $66869c587f14f122$export$ada8b2beb3d76671));
    };
    Displayable.prototype.styleUpdated = function() {
        this.__dirty &= ~(0, $66869c587f14f122$export$ada8b2beb3d76671);
    };
    Displayable.prototype.createStyle = function(obj) {
        return (0, $f16f2994a32ad273$export$79c7e160a7743efd)($0a0ef4888a4b4e90$export$737672163db00fe3, obj);
    };
    Displayable.prototype.useStyle = function(obj) {
        if (!obj[$0a0ef4888a4b4e90$var$STYLE_MAGIC_KEY]) obj = this.createStyle(obj);
        this.style = obj;
        this.dirtyStyle();
    };
    Displayable.prototype._useHoverStyle = function(obj) {
        this.__hoverStyle = obj;
    };
    Displayable.prototype.isStyleObject = function(obj) {
        return obj[$0a0ef4888a4b4e90$var$STYLE_MAGIC_KEY];
    };
    Displayable.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.style && !normalState.style) normalState.style = this._mergeStyle(this.createStyle(), this.style);
        this._savePrimaryToNormal(toState, normalState, $0a0ef4888a4b4e90$var$PRIMARY_STATES_KEYS);
    };
    Displayable.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var inHoverOnlyStyleChange = this.__inHover === (0, $05d7569c5e654d58$export$f5347ae640a7f0d0);
        var targetStyle;
        if (state && state.style) {
            if (transition) {
                if (keepCurrentStates) targetStyle = state.style;
                else {
                    targetStyle = this._mergeStyle(this.createStyle(), normalState.style);
                    this._mergeStyle(targetStyle, state.style);
                }
            } else {
                targetStyle = this._mergeStyle(this.createStyle(), keepCurrentStates ? this.style : normalState.style);
                this._mergeStyle(targetStyle, state.style);
            }
        } else if (needsRestoreToNormal) targetStyle = normalState.style;
        if (targetStyle) {
            if (transition) {
                var sourceStyle = this.style;
                this.style = this.createStyle(needsRestoreToNormal ? {} : sourceStyle);
                if (needsRestoreToNormal) {
                    var changedKeys = (0, $f16f2994a32ad273$export$ed97f33186d4b816)(sourceStyle);
                    for(var i = 0; i < changedKeys.length; i++){
                        var key = changedKeys[i];
                        if (key in targetStyle) {
                            targetStyle[key] = targetStyle[key];
                            this.style[key] = sourceStyle[key];
                        }
                    }
                }
                var targetKeys = (0, $f16f2994a32ad273$export$ed97f33186d4b816)(targetStyle);
                for(var i = 0; i < targetKeys.length; i++){
                    var key = targetKeys[i];
                    this.style[key] = this.style[key];
                }
                this._transitionState(stateName, {
                    style: targetStyle
                }, animationCfg, this.getAnimationStyleProps());
            } else if (inHoverOnlyStyleChange) this._useHoverStyle(targetStyle);
            else this.useStyle(targetStyle);
        }
        if (!inHoverOnlyStyleChange) {
            var statesKeys = this.__inHover ? $0a0ef4888a4b4e90$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER : $0a0ef4888a4b4e90$var$PRIMARY_STATES_KEYS;
            for(var i = 0; i < statesKeys.length; i++){
                var key = statesKeys[i];
                if (state && state[key] != null) this[key] = state[key];
                else if (needsRestoreToNormal) {
                    if (normalState[key] != null) this[key] = normalState[key];
                }
            }
        }
    };
    Displayable.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedStyle;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.style) {
                mergedStyle = mergedStyle || {};
                this._mergeStyle(mergedStyle, state.style);
            }
        }
        if (mergedStyle) mergedState.style = mergedStyle;
        return mergedState;
    };
    Displayable.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        (0, $f16f2994a32ad273$export$8b58be045bf06082)(targetStyle, sourceStyle);
        return targetStyle;
    };
    Displayable.prototype.getAnimationStyleProps = function() {
        return $0a0ef4888a4b4e90$export$9908943fb57fbe51;
    };
    Displayable.initDefaultProps = function() {
        var dispProto = Displayable.prototype;
        dispProto.type = 'displayable';
        dispProto.invisible = false;
        dispProto.z = 0;
        dispProto.z2 = 0;
        dispProto.zlevel = 0;
        dispProto.culling = false;
        dispProto.cursor = 'pointer';
        dispProto.rectHover = false;
        dispProto.incremental = 0;
        dispProto._rect = null;
        dispProto.dirtyRectTolerance = 0;
        dispProto.__dirty = (0, $66869c587f14f122$export$a7b6db622c6c7dbd) | (0, $66869c587f14f122$export$ada8b2beb3d76671);
    }();
    return Displayable;
}((0, $05d7569c5e654d58$export$2e2bcd8739ae039));
var $0a0ef4888a4b4e90$var$tmpRect = new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $0a0ef4888a4b4e90$var$viewRect = new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(0, 0, 0, 0);
function $0a0ef4888a4b4e90$var$isDisplayableCulled(el, width, height) {
    $0a0ef4888a4b4e90$var$tmpRect.copy(el.getBoundingRect());
    if (el.transform) $0a0ef4888a4b4e90$var$tmpRect.applyTransform(el.transform);
    $0a0ef4888a4b4e90$var$viewRect.width = width;
    $0a0ef4888a4b4e90$var$viewRect.height = height;
    return !$0a0ef4888a4b4e90$var$tmpRect.intersect($0a0ef4888a4b4e90$var$viewRect);
}
var $0a0ef4888a4b4e90$export$2e2bcd8739ae039 = $0a0ef4888a4b4e90$var$Displayable;



var $7E0eS = parcelRequire("7E0eS");








var $478cede95f7b1a8f$var$mathMin = Math.min;
var $478cede95f7b1a8f$var$mathMax = Math.max;
var $478cede95f7b1a8f$var$mathSin = Math.sin;
var $478cede95f7b1a8f$var$mathCos = Math.cos;
var $478cede95f7b1a8f$var$PI2 = Math.PI * 2;
var $478cede95f7b1a8f$var$start = $f79ec7ea1294b339$export$185802fd694ee1f5();
var $478cede95f7b1a8f$var$end = $f79ec7ea1294b339$export$185802fd694ee1f5();
var $478cede95f7b1a8f$var$extremity = $f79ec7ea1294b339$export$185802fd694ee1f5();
function $478cede95f7b1a8f$export$188c3cd07b4129dd(points, min, max) {
    if (points.length === 0) return;
    var p = points[0];
    var left = p[0];
    var right = p[0];
    var top = p[1];
    var bottom = p[1];
    for(var i = 1; i < points.length; i++){
        p = points[i];
        left = $478cede95f7b1a8f$var$mathMin(left, p[0]);
        right = $478cede95f7b1a8f$var$mathMax(right, p[0]);
        top = $478cede95f7b1a8f$var$mathMin(top, p[1]);
        bottom = $478cede95f7b1a8f$var$mathMax(bottom, p[1]);
    }
    min[0] = left;
    min[1] = top;
    max[0] = right;
    max[1] = bottom;
}
function $478cede95f7b1a8f$export$d2b1491e4450bf2c(x0, y0, x1, y1, min, max) {
    min[0] = $478cede95f7b1a8f$var$mathMin(x0, x1);
    min[1] = $478cede95f7b1a8f$var$mathMin(y0, y1);
    max[0] = $478cede95f7b1a8f$var$mathMax(x0, x1);
    max[1] = $478cede95f7b1a8f$var$mathMax(y0, y1);
}
var $478cede95f7b1a8f$var$xDim = [];
var $478cede95f7b1a8f$var$yDim = [];
function $478cede95f7b1a8f$export$c1bc6be456bb6609(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
    var cubicExtrema = $893961281ad1f27f$export$df1a172f100d0457;
    var cubicAt = $893961281ad1f27f$export$547c21de482bbcb2;
    var n = cubicExtrema(x0, x1, x2, x3, $478cede95f7b1a8f$var$xDim);
    min[0] = Infinity;
    min[1] = Infinity;
    max[0] = -Infinity;
    max[1] = -Infinity;
    for(var i = 0; i < n; i++){
        var x = cubicAt(x0, x1, x2, x3, $478cede95f7b1a8f$var$xDim[i]);
        min[0] = $478cede95f7b1a8f$var$mathMin(x, min[0]);
        max[0] = $478cede95f7b1a8f$var$mathMax(x, max[0]);
    }
    n = cubicExtrema(y0, y1, y2, y3, $478cede95f7b1a8f$var$yDim);
    for(var i = 0; i < n; i++){
        var y = cubicAt(y0, y1, y2, y3, $478cede95f7b1a8f$var$yDim[i]);
        min[1] = $478cede95f7b1a8f$var$mathMin(y, min[1]);
        max[1] = $478cede95f7b1a8f$var$mathMax(y, max[1]);
    }
    min[0] = $478cede95f7b1a8f$var$mathMin(x0, min[0]);
    max[0] = $478cede95f7b1a8f$var$mathMax(x0, max[0]);
    min[0] = $478cede95f7b1a8f$var$mathMin(x3, min[0]);
    max[0] = $478cede95f7b1a8f$var$mathMax(x3, max[0]);
    min[1] = $478cede95f7b1a8f$var$mathMin(y0, min[1]);
    max[1] = $478cede95f7b1a8f$var$mathMax(y0, max[1]);
    min[1] = $478cede95f7b1a8f$var$mathMin(y3, min[1]);
    max[1] = $478cede95f7b1a8f$var$mathMax(y3, max[1]);
}
function $478cede95f7b1a8f$export$16fbe795323a1f4c(x0, y0, x1, y1, x2, y2, min, max) {
    var quadraticExtremum = $893961281ad1f27f$export$752e1f8c6e7f7e11;
    var quadraticAt = $893961281ad1f27f$export$af17094a950f5073;
    var tx = $478cede95f7b1a8f$var$mathMax($478cede95f7b1a8f$var$mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
    var ty = $478cede95f7b1a8f$var$mathMax($478cede95f7b1a8f$var$mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
    var x = quadraticAt(x0, x1, x2, tx);
    var y = quadraticAt(y0, y1, y2, ty);
    min[0] = $478cede95f7b1a8f$var$mathMin(x0, x2, x);
    min[1] = $478cede95f7b1a8f$var$mathMin(y0, y2, y);
    max[0] = $478cede95f7b1a8f$var$mathMax(x0, x2, x);
    max[1] = $478cede95f7b1a8f$var$mathMax(y0, y2, y);
}
function $478cede95f7b1a8f$export$161c8bb0e1d9ef49(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
    var vec2Min = $f79ec7ea1294b339$export$96ec731ed4dcb222;
    var vec2Max = $f79ec7ea1294b339$export$8960430cfd85939f;
    var diff = Math.abs(startAngle - endAngle);
    if (diff % $478cede95f7b1a8f$var$PI2 < 1e-4 && diff > 1e-4) {
        min[0] = x - rx;
        min[1] = y - ry;
        max[0] = x + rx;
        max[1] = y + ry;
        return;
    }
    $478cede95f7b1a8f$var$start[0] = $478cede95f7b1a8f$var$mathCos(startAngle) * rx + x;
    $478cede95f7b1a8f$var$start[1] = $478cede95f7b1a8f$var$mathSin(startAngle) * ry + y;
    $478cede95f7b1a8f$var$end[0] = $478cede95f7b1a8f$var$mathCos(endAngle) * rx + x;
    $478cede95f7b1a8f$var$end[1] = $478cede95f7b1a8f$var$mathSin(endAngle) * ry + y;
    vec2Min(min, $478cede95f7b1a8f$var$start, $478cede95f7b1a8f$var$end);
    vec2Max(max, $478cede95f7b1a8f$var$start, $478cede95f7b1a8f$var$end);
    startAngle = startAngle % $478cede95f7b1a8f$var$PI2;
    if (startAngle < 0) startAngle = startAngle + $478cede95f7b1a8f$var$PI2;
    endAngle = endAngle % $478cede95f7b1a8f$var$PI2;
    if (endAngle < 0) endAngle = endAngle + $478cede95f7b1a8f$var$PI2;
    if (startAngle > endAngle && !anticlockwise) endAngle += $478cede95f7b1a8f$var$PI2;
    else if (startAngle < endAngle && anticlockwise) startAngle += $478cede95f7b1a8f$var$PI2;
    if (anticlockwise) {
        var tmp = endAngle;
        endAngle = startAngle;
        startAngle = tmp;
    }
    for(var angle = 0; angle < endAngle; angle += Math.PI / 2)if (angle > startAngle) {
        $478cede95f7b1a8f$var$extremity[0] = $478cede95f7b1a8f$var$mathCos(angle) * rx + x;
        $478cede95f7b1a8f$var$extremity[1] = $478cede95f7b1a8f$var$mathSin(angle) * ry + y;
        vec2Min(min, $478cede95f7b1a8f$var$extremity, min);
        vec2Max(max, $478cede95f7b1a8f$var$extremity, max);
    }
}



var $af4d02a47e9b6a35$var$CMD = {
    M: 1,
    L: 2,
    C: 3,
    Q: 4,
    A: 5,
    Z: 6,
    R: 7
};
var $af4d02a47e9b6a35$var$tmpOutX = [];
var $af4d02a47e9b6a35$var$tmpOutY = [];
var $af4d02a47e9b6a35$var$min = [];
var $af4d02a47e9b6a35$var$max = [];
var $af4d02a47e9b6a35$var$min2 = [];
var $af4d02a47e9b6a35$var$max2 = [];
var $af4d02a47e9b6a35$var$mathMin = Math.min;
var $af4d02a47e9b6a35$var$mathMax = Math.max;
var $af4d02a47e9b6a35$var$mathCos = Math.cos;
var $af4d02a47e9b6a35$var$mathSin = Math.sin;
var $af4d02a47e9b6a35$var$mathAbs = Math.abs;
var $af4d02a47e9b6a35$var$PI = Math.PI;
var $af4d02a47e9b6a35$var$PI2 = $af4d02a47e9b6a35$var$PI * 2;
var $af4d02a47e9b6a35$var$hasTypedArray = typeof Float32Array !== 'undefined';
var $af4d02a47e9b6a35$var$tmpAngles = [];
function $af4d02a47e9b6a35$var$modPI2(radian) {
    var n = Math.round(radian / $af4d02a47e9b6a35$var$PI * 1e8) / 1e8;
    return n % 2 * $af4d02a47e9b6a35$var$PI;
}
function $af4d02a47e9b6a35$export$bc668021e937022a(angles, anticlockwise) {
    var newStartAngle = $af4d02a47e9b6a35$var$modPI2(angles[0]);
    if (newStartAngle < 0) newStartAngle += $af4d02a47e9b6a35$var$PI2;
    var delta = newStartAngle - angles[0];
    var newEndAngle = angles[1];
    newEndAngle += delta;
    if (!anticlockwise && newEndAngle - newStartAngle >= $af4d02a47e9b6a35$var$PI2) newEndAngle = newStartAngle + $af4d02a47e9b6a35$var$PI2;
    else if (anticlockwise && newStartAngle - newEndAngle >= $af4d02a47e9b6a35$var$PI2) newEndAngle = newStartAngle - $af4d02a47e9b6a35$var$PI2;
    else if (!anticlockwise && newStartAngle > newEndAngle) newEndAngle = newStartAngle + ($af4d02a47e9b6a35$var$PI2 - $af4d02a47e9b6a35$var$modPI2(newStartAngle - newEndAngle));
    else if (anticlockwise && newStartAngle < newEndAngle) newEndAngle = newStartAngle - ($af4d02a47e9b6a35$var$PI2 - $af4d02a47e9b6a35$var$modPI2(newEndAngle - newStartAngle));
    angles[0] = newStartAngle;
    angles[1] = newEndAngle;
}
var $af4d02a47e9b6a35$var$PathProxy = function() {
    function PathProxy(notSaveData) {
        this.dpr = 1;
        this._xi = 0;
        this._yi = 0;
        this._x0 = 0;
        this._y0 = 0;
        this._len = 0;
        if (notSaveData) this._saveData = false;
        if (this._saveData) this.data = [];
    }
    PathProxy.prototype.increaseVersion = function() {
        this._version++;
    };
    PathProxy.prototype.getVersion = function() {
        return this._version;
    };
    PathProxy.prototype.setScale = function(sx, sy, segmentIgnoreThreshold) {
        segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
        if (segmentIgnoreThreshold > 0) {
            this._ux = $af4d02a47e9b6a35$var$mathAbs(segmentIgnoreThreshold / (0, $e374994bc8dfd1f0$export$508f096bfcdaac40) / sx) || 0;
            this._uy = $af4d02a47e9b6a35$var$mathAbs(segmentIgnoreThreshold / (0, $e374994bc8dfd1f0$export$508f096bfcdaac40) / sy) || 0;
        }
    };
    PathProxy.prototype.setDPR = function(dpr) {
        this.dpr = dpr;
    };
    PathProxy.prototype.setContext = function(ctx) {
        this._ctx = ctx;
    };
    PathProxy.prototype.getContext = function() {
        return this._ctx;
    };
    PathProxy.prototype.beginPath = function() {
        this._ctx && this._ctx.beginPath();
        this.reset();
        return this;
    };
    PathProxy.prototype.reset = function() {
        if (this._saveData) this._len = 0;
        if (this._pathSegLen) {
            this._pathSegLen = null;
            this._pathLen = 0;
        }
        this._version++;
    };
    PathProxy.prototype.moveTo = function(x, y) {
        this._drawPendingPt();
        this.addData($af4d02a47e9b6a35$var$CMD.M, x, y);
        this._ctx && this._ctx.moveTo(x, y);
        this._x0 = x;
        this._y0 = y;
        this._xi = x;
        this._yi = y;
        return this;
    };
    PathProxy.prototype.lineTo = function(x, y) {
        var dx = $af4d02a47e9b6a35$var$mathAbs(x - this._xi);
        var dy = $af4d02a47e9b6a35$var$mathAbs(y - this._yi);
        var exceedUnit = dx > this._ux || dy > this._uy;
        this.addData($af4d02a47e9b6a35$var$CMD.L, x, y);
        if (this._ctx && exceedUnit) this._ctx.lineTo(x, y);
        if (exceedUnit) {
            this._xi = x;
            this._yi = y;
            this._pendingPtDist = 0;
        } else {
            var d2 = dx * dx + dy * dy;
            if (d2 > this._pendingPtDist) {
                this._pendingPtX = x;
                this._pendingPtY = y;
                this._pendingPtDist = d2;
            }
        }
        return this;
    };
    PathProxy.prototype.bezierCurveTo = function(x1, y1, x2, y2, x3, y3) {
        this._drawPendingPt();
        this.addData($af4d02a47e9b6a35$var$CMD.C, x1, y1, x2, y2, x3, y3);
        if (this._ctx) this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
        this._xi = x3;
        this._yi = y3;
        return this;
    };
    PathProxy.prototype.quadraticCurveTo = function(x1, y1, x2, y2) {
        this._drawPendingPt();
        this.addData($af4d02a47e9b6a35$var$CMD.Q, x1, y1, x2, y2);
        if (this._ctx) this._ctx.quadraticCurveTo(x1, y1, x2, y2);
        this._xi = x2;
        this._yi = y2;
        return this;
    };
    PathProxy.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this._drawPendingPt();
        $af4d02a47e9b6a35$var$tmpAngles[0] = startAngle;
        $af4d02a47e9b6a35$var$tmpAngles[1] = endAngle;
        $af4d02a47e9b6a35$export$bc668021e937022a($af4d02a47e9b6a35$var$tmpAngles, anticlockwise);
        startAngle = $af4d02a47e9b6a35$var$tmpAngles[0];
        endAngle = $af4d02a47e9b6a35$var$tmpAngles[1];
        var delta = endAngle - startAngle;
        this.addData($af4d02a47e9b6a35$var$CMD.A, cx, cy, r, r, startAngle, delta, 0, anticlockwise ? 0 : 1);
        this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
        this._xi = $af4d02a47e9b6a35$var$mathCos(endAngle) * r + cx;
        this._yi = $af4d02a47e9b6a35$var$mathSin(endAngle) * r + cy;
        return this;
    };
    PathProxy.prototype.arcTo = function(x1, y1, x2, y2, radius) {
        this._drawPendingPt();
        if (this._ctx) this._ctx.arcTo(x1, y1, x2, y2, radius);
        return this;
    };
    PathProxy.prototype.rect = function(x, y, w, h) {
        this._drawPendingPt();
        this._ctx && this._ctx.rect(x, y, w, h);
        this.addData($af4d02a47e9b6a35$var$CMD.R, x, y, w, h);
        return this;
    };
    PathProxy.prototype.closePath = function() {
        this._drawPendingPt();
        this.addData($af4d02a47e9b6a35$var$CMD.Z);
        var ctx = this._ctx;
        var x0 = this._x0;
        var y0 = this._y0;
        if (ctx) ctx.closePath();
        this._xi = x0;
        this._yi = y0;
        return this;
    };
    PathProxy.prototype.fill = function(ctx) {
        ctx && ctx.fill();
        this.toStatic();
    };
    PathProxy.prototype.stroke = function(ctx) {
        ctx && ctx.stroke();
        this.toStatic();
    };
    PathProxy.prototype.len = function() {
        return this._len;
    };
    PathProxy.prototype.setData = function(data) {
        if (!this._saveData) return;
        var len = data.length;
        if (!(this.data && this.data.length === len) && $af4d02a47e9b6a35$var$hasTypedArray) this.data = new Float32Array(len);
        for(var i = 0; i < len; i++)this.data[i] = data[i];
        this._len = len;
    };
    PathProxy.prototype.appendPath = function(path) {
        if (!this._saveData) return;
        if (!(path instanceof Array)) path = [
            path
        ];
        var len = path.length;
        var appendSize = 0;
        var offset = this._len;
        for(var i = 0; i < len; i++)appendSize += path[i].len();
        var oldData = this.data;
        if ($af4d02a47e9b6a35$var$hasTypedArray && (oldData instanceof Float32Array || !oldData)) {
            this.data = new Float32Array(offset + appendSize);
            if (offset > 0 && oldData) for(var k = 0; k < offset; k++)this.data[k] = oldData[k];
        }
        for(var i = 0; i < len; i++){
            var appendPathData = path[i].data;
            for(var k = 0; k < appendPathData.length; k++)this.data[offset++] = appendPathData[k];
        }
        this._len = offset;
    };
    PathProxy.prototype.addData = function(cmd, a, b, c, d, e, f, g, h) {
        if (!this._saveData) return;
        var data = this.data;
        if (this._len + arguments.length > data.length) {
            this._expandData();
            data = this.data;
        }
        for(var i = 0; i < arguments.length; i++)data[this._len++] = arguments[i];
    };
    PathProxy.prototype._drawPendingPt = function() {
        if (this._pendingPtDist > 0) {
            this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY);
            this._pendingPtDist = 0;
        }
    };
    PathProxy.prototype._expandData = function() {
        if (!(this.data instanceof Array)) {
            var newData = [];
            for(var i = 0; i < this._len; i++)newData[i] = this.data[i];
            this.data = newData;
        }
    };
    PathProxy.prototype.toStatic = function() {
        if (!this._saveData) return;
        this._drawPendingPt();
        var data = this.data;
        if (data instanceof Array) {
            data.length = this._len;
            if ($af4d02a47e9b6a35$var$hasTypedArray && this._len > 11) this.data = new Float32Array(data);
        }
    };
    PathProxy.prototype.getBoundingRect = function() {
        $af4d02a47e9b6a35$var$min[0] = $af4d02a47e9b6a35$var$min[1] = $af4d02a47e9b6a35$var$min2[0] = $af4d02a47e9b6a35$var$min2[1] = Number.MAX_VALUE;
        $af4d02a47e9b6a35$var$max[0] = $af4d02a47e9b6a35$var$max[1] = $af4d02a47e9b6a35$var$max2[0] = $af4d02a47e9b6a35$var$max2[1] = -Number.MAX_VALUE;
        var data = this.data;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var i;
        for(i = 0; i < this._len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch(cmd){
                case $af4d02a47e9b6a35$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    $af4d02a47e9b6a35$var$min2[0] = x0;
                    $af4d02a47e9b6a35$var$min2[1] = y0;
                    $af4d02a47e9b6a35$var$max2[0] = x0;
                    $af4d02a47e9b6a35$var$max2[1] = y0;
                    break;
                case $af4d02a47e9b6a35$var$CMD.L:
                    (0, $478cede95f7b1a8f$export$d2b1491e4450bf2c)(xi, yi, data[i], data[i + 1], $af4d02a47e9b6a35$var$min2, $af4d02a47e9b6a35$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $af4d02a47e9b6a35$var$CMD.C:
                    (0, $478cede95f7b1a8f$export$c1bc6be456bb6609)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], $af4d02a47e9b6a35$var$min2, $af4d02a47e9b6a35$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $af4d02a47e9b6a35$var$CMD.Q:
                    (0, $478cede95f7b1a8f$export$16fbe795323a1f4c)(xi, yi, data[i++], data[i++], data[i], data[i + 1], $af4d02a47e9b6a35$var$min2, $af4d02a47e9b6a35$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $af4d02a47e9b6a35$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var endAngle = data[i++] + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = $af4d02a47e9b6a35$var$mathCos(startAngle) * rx + cx;
                        y0 = $af4d02a47e9b6a35$var$mathSin(startAngle) * ry + cy;
                    }
                    (0, $478cede95f7b1a8f$export$161c8bb0e1d9ef49)(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, $af4d02a47e9b6a35$var$min2, $af4d02a47e9b6a35$var$max2);
                    xi = $af4d02a47e9b6a35$var$mathCos(endAngle) * rx + cx;
                    yi = $af4d02a47e9b6a35$var$mathSin(endAngle) * ry + cy;
                    break;
                case $af4d02a47e9b6a35$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    (0, $478cede95f7b1a8f$export$d2b1491e4450bf2c)(x0, y0, x0 + width, y0 + height, $af4d02a47e9b6a35$var$min2, $af4d02a47e9b6a35$var$max2);
                    break;
                case $af4d02a47e9b6a35$var$CMD.Z:
                    xi = x0;
                    yi = y0;
                    break;
            }
            $f79ec7ea1294b339$export$96ec731ed4dcb222($af4d02a47e9b6a35$var$min, $af4d02a47e9b6a35$var$min, $af4d02a47e9b6a35$var$min2);
            $f79ec7ea1294b339$export$8960430cfd85939f($af4d02a47e9b6a35$var$max, $af4d02a47e9b6a35$var$max, $af4d02a47e9b6a35$var$max2);
        }
        if (i === 0) $af4d02a47e9b6a35$var$min[0] = $af4d02a47e9b6a35$var$min[1] = $af4d02a47e9b6a35$var$max[0] = $af4d02a47e9b6a35$var$max[1] = 0;
        return new (0, $7456366ce379c42e$export$2e2bcd8739ae039)($af4d02a47e9b6a35$var$min[0], $af4d02a47e9b6a35$var$min[1], $af4d02a47e9b6a35$var$max[0] - $af4d02a47e9b6a35$var$min[0], $af4d02a47e9b6a35$var$max[1] - $af4d02a47e9b6a35$var$min[1]);
    };
    PathProxy.prototype._calculateLength = function() {
        var data = this.data;
        var len = this._len;
        var ux = this._ux;
        var uy = this._uy;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        if (!this._pathSegLen) this._pathSegLen = [];
        var pathSegLen = this._pathSegLen;
        var pathTotalLen = 0;
        var segCount = 0;
        for(var i = 0; i < len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            var l = -1;
            switch(cmd){
                case $af4d02a47e9b6a35$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    break;
                case $af4d02a47e9b6a35$var$CMD.L:
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var dx = x2 - xi;
                    var dy = y2 - yi;
                    if ($af4d02a47e9b6a35$var$mathAbs(dx) > ux || $af4d02a47e9b6a35$var$mathAbs(dy) > uy || i === len - 1) {
                        l = Math.sqrt(dx * dx + dy * dy);
                        xi = x2;
                        yi = y2;
                    }
                    break;
                case $af4d02a47e9b6a35$var$CMD.C:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var x3 = data[i++];
                    var y3 = data[i++];
                    l = (0, $893961281ad1f27f$export$af1875d576f60d7c)(xi, yi, x1, y1, x2, y2, x3, y3, 10);
                    xi = x3;
                    yi = y3;
                    break;
                case $af4d02a47e9b6a35$var$CMD.Q:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    l = (0, $893961281ad1f27f$export$8a68adee46f3cf55)(xi, yi, x1, y1, x2, y2, 10);
                    xi = x2;
                    yi = y2;
                    break;
                case $af4d02a47e9b6a35$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var delta = data[i++];
                    var endAngle = delta + startAngle;
                    i += 1;
                    if (isFirst) {
                        x0 = $af4d02a47e9b6a35$var$mathCos(startAngle) * rx + cx;
                        y0 = $af4d02a47e9b6a35$var$mathSin(startAngle) * ry + cy;
                    }
                    l = $af4d02a47e9b6a35$var$mathMax(rx, ry) * $af4d02a47e9b6a35$var$mathMin($af4d02a47e9b6a35$var$PI2, Math.abs(delta));
                    xi = $af4d02a47e9b6a35$var$mathCos(endAngle) * rx + cx;
                    yi = $af4d02a47e9b6a35$var$mathSin(endAngle) * ry + cy;
                    break;
                case $af4d02a47e9b6a35$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    l = width * 2 + height * 2;
                    break;
                case $af4d02a47e9b6a35$var$CMD.Z:
                    var dx = x0 - xi;
                    var dy = y0 - yi;
                    l = Math.sqrt(dx * dx + dy * dy);
                    xi = x0;
                    yi = y0;
                    break;
            }
            if (l >= 0) {
                pathSegLen[segCount++] = l;
                pathTotalLen += l;
            }
        }
        this._pathLen = pathTotalLen;
        return pathTotalLen;
    };
    PathProxy.prototype.rebuildPath = function(ctx, percent) {
        var d = this.data;
        var ux = this._ux;
        var uy = this._uy;
        var len = this._len;
        var x0;
        var y0;
        var xi;
        var yi;
        var x;
        var y;
        var drawPart = percent < 1;
        var pathSegLen;
        var pathTotalLen;
        var accumLength = 0;
        var segCount = 0;
        var displayedLength;
        var pendingPtDist = 0;
        var pendingPtX;
        var pendingPtY;
        if (drawPart) {
            if (!this._pathSegLen) this._calculateLength();
            pathSegLen = this._pathSegLen;
            pathTotalLen = this._pathLen;
            displayedLength = percent * pathTotalLen;
            if (!displayedLength) return;
        }
        lo: for(var i = 0; i < len;){
            var cmd = d[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = d[i];
                yi = d[i + 1];
                x0 = xi;
                y0 = yi;
            }
            if (cmd !== $af4d02a47e9b6a35$var$CMD.L && pendingPtDist > 0) {
                ctx.lineTo(pendingPtX, pendingPtY);
                pendingPtDist = 0;
            }
            switch(cmd){
                case $af4d02a47e9b6a35$var$CMD.M:
                    x0 = xi = d[i++];
                    y0 = yi = d[i++];
                    ctx.moveTo(xi, yi);
                    break;
                case $af4d02a47e9b6a35$var$CMD.L:
                    x = d[i++];
                    y = d[i++];
                    var dx = $af4d02a47e9b6a35$var$mathAbs(x - xi);
                    var dy = $af4d02a47e9b6a35$var$mathAbs(y - yi);
                    if (dx > ux || dy > uy) {
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                ctx.lineTo(xi * (1 - t) + x * t, yi * (1 - t) + y * t);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.lineTo(x, y);
                        xi = x;
                        yi = y;
                        pendingPtDist = 0;
                    } else {
                        var d2 = dx * dx + dy * dy;
                        if (d2 > pendingPtDist) {
                            pendingPtX = x;
                            pendingPtY = y;
                            pendingPtDist = d2;
                        }
                    }
                    break;
                case $af4d02a47e9b6a35$var$CMD.C:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    var x3 = d[i++];
                    var y3 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $893961281ad1f27f$export$a2ee23a0567039da)(xi, x1, x2, x3, t, $af4d02a47e9b6a35$var$tmpOutX);
                            (0, $893961281ad1f27f$export$a2ee23a0567039da)(yi, y1, y2, y3, t, $af4d02a47e9b6a35$var$tmpOutY);
                            ctx.bezierCurveTo($af4d02a47e9b6a35$var$tmpOutX[1], $af4d02a47e9b6a35$var$tmpOutY[1], $af4d02a47e9b6a35$var$tmpOutX[2], $af4d02a47e9b6a35$var$tmpOutY[2], $af4d02a47e9b6a35$var$tmpOutX[3], $af4d02a47e9b6a35$var$tmpOutY[3]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    xi = x3;
                    yi = y3;
                    break;
                case $af4d02a47e9b6a35$var$CMD.Q:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $893961281ad1f27f$export$117c659e21a7a060)(xi, x1, x2, t, $af4d02a47e9b6a35$var$tmpOutX);
                            (0, $893961281ad1f27f$export$117c659e21a7a060)(yi, y1, y2, t, $af4d02a47e9b6a35$var$tmpOutY);
                            ctx.quadraticCurveTo($af4d02a47e9b6a35$var$tmpOutX[1], $af4d02a47e9b6a35$var$tmpOutY[1], $af4d02a47e9b6a35$var$tmpOutX[2], $af4d02a47e9b6a35$var$tmpOutY[2]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.quadraticCurveTo(x1, y1, x2, y2);
                    xi = x2;
                    yi = y2;
                    break;
                case $af4d02a47e9b6a35$var$CMD.A:
                    var cx = d[i++];
                    var cy = d[i++];
                    var rx = d[i++];
                    var ry = d[i++];
                    var startAngle = d[i++];
                    var delta = d[i++];
                    var psi = d[i++];
                    var anticlockwise = !d[i++];
                    var r = rx > ry ? rx : ry;
                    var isEllipse = $af4d02a47e9b6a35$var$mathAbs(rx - ry) > 1e-3;
                    var endAngle = startAngle + delta;
                    var breakBuild = false;
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            endAngle = startAngle + delta * (displayedLength - accumLength) / l;
                            breakBuild = true;
                        }
                        accumLength += l;
                    }
                    if (isEllipse && ctx.ellipse) ctx.ellipse(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise);
                    else ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
                    if (breakBuild) break lo;
                    if (isFirst) {
                        x0 = $af4d02a47e9b6a35$var$mathCos(startAngle) * rx + cx;
                        y0 = $af4d02a47e9b6a35$var$mathSin(startAngle) * ry + cy;
                    }
                    xi = $af4d02a47e9b6a35$var$mathCos(endAngle) * rx + cx;
                    yi = $af4d02a47e9b6a35$var$mathSin(endAngle) * ry + cy;
                    break;
                case $af4d02a47e9b6a35$var$CMD.R:
                    x0 = xi = d[i];
                    y0 = yi = d[i + 1];
                    x = d[i++];
                    y = d[i++];
                    var width = d[i++];
                    var height = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var d_1 = displayedLength - accumLength;
                            ctx.moveTo(x, y);
                            ctx.lineTo(x + $af4d02a47e9b6a35$var$mathMin(d_1, width), y);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x + width, y + $af4d02a47e9b6a35$var$mathMin(d_1, height));
                            d_1 -= height;
                            if (d_1 > 0) ctx.lineTo(x + $af4d02a47e9b6a35$var$mathMax(width - d_1, 0), y + height);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x, y + $af4d02a47e9b6a35$var$mathMax(height - d_1, 0));
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.rect(x, y, width, height);
                    break;
                case $af4d02a47e9b6a35$var$CMD.Z:
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            ctx.lineTo(xi * (1 - t) + x0 * t, yi * (1 - t) + y0 * t);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.closePath();
                    xi = x0;
                    yi = y0;
            }
        }
    };
    PathProxy.prototype.clone = function() {
        var newProxy = new PathProxy();
        var data = this.data;
        newProxy.data = data.slice ? data.slice() : Array.prototype.slice.call(data);
        newProxy._len = this._len;
        return newProxy;
    };
    PathProxy.prototype.canSave = function() {
        return !!this._saveData;
    };
    PathProxy.CMD = $af4d02a47e9b6a35$var$CMD;
    PathProxy.initDefaultProps = function() {
        var proto = PathProxy.prototype;
        proto._saveData = true;
        proto._ux = 0;
        proto._uy = 0;
        proto._pendingPtDist = 0;
        proto._version = 0;
    }();
    return PathProxy;
}();
var $af4d02a47e9b6a35$export$2e2bcd8739ae039 = $af4d02a47e9b6a35$var$PathProxy;



function $1b8a3b6d00d4b101$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    var _a = 0;
    var _b = x0;
    if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) return false;
    if (x0 !== x1) {
        _a = (y0 - y1) / (x0 - x1);
        _b = (x0 * y1 - x1 * y0) / (x0 - x1);
    } else return Math.abs(x - x0) <= _l / 2;
    var tmp = _a * x - y + _b;
    var _s = tmp * tmp / (_a * _a + 1);
    return _s <= _l / 2 * _l / 2;
}



function $5ac5c2b3fd53f965$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) return false;
    var d = $893961281ad1f27f$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
    return d <= _l / 2;
}



function $79369ec7c41caa1d$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) return false;
    var d = (0, $893961281ad1f27f$export$81915a594fe10dee)(x0, y0, x1, y1, x2, y2, x, y, null);
    return d <= _l / 2;
}


var $af99d1810d04418e$var$PI2 = Math.PI * 2;
function $af99d1810d04418e$export$d44861331f213635(angle) {
    angle %= $af99d1810d04418e$var$PI2;
    if (angle < 0) angle += $af99d1810d04418e$var$PI2;
    return angle;
}


var $e46961d56549c575$var$PI2 = Math.PI * 2;
function $e46961d56549c575$export$8d36b1b5d19157c5(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    if (d - _l > r || d + _l < r) return false;
    if (Math.abs(startAngle - endAngle) % $e46961d56549c575$var$PI2 < 1e-4) return true;
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $af99d1810d04418e$export$d44861331f213635)(endAngle);
        endAngle = (0, $af99d1810d04418e$export$d44861331f213635)(tmp);
    } else {
        startAngle = (0, $af99d1810d04418e$export$d44861331f213635)(startAngle);
        endAngle = (0, $af99d1810d04418e$export$d44861331f213635)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $e46961d56549c575$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $e46961d56549c575$var$PI2;
    return angle >= startAngle && angle <= endAngle || angle + $e46961d56549c575$var$PI2 >= startAngle && angle + $e46961d56549c575$var$PI2 <= endAngle;
}



function $60ba2e40a14a1c35$export$2e2bcd8739ae039(x0, y0, x1, y1, x, y) {
    if (y > y0 && y > y1 || y < y0 && y < y1) return 0;
    if (y1 === y0) return 0;
    var t = (y - y0) / (y1 - y0);
    var dir = y1 < y0 ? 1 : -1;
    if (t === 1 || t === 0) dir = y1 < y0 ? 0.5 : -0.5;
    var x_ = t * (x1 - x0) + x0;
    return x_ === x ? Infinity : x_ > x ? dir : 0;
}


var $9601505d1dece229$var$CMD = (0, $af4d02a47e9b6a35$export$2e2bcd8739ae039).CMD;
var $9601505d1dece229$var$PI2 = Math.PI * 2;
var $9601505d1dece229$var$EPSILON = 1e-4;
function $9601505d1dece229$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $9601505d1dece229$var$EPSILON;
}
var $9601505d1dece229$var$roots = [
    -1,
    -1,
    -1
];
var $9601505d1dece229$var$extrema = [
    -1,
    -1
];
function $9601505d1dece229$var$swapExtrema() {
    var tmp = $9601505d1dece229$var$extrema[0];
    $9601505d1dece229$var$extrema[0] = $9601505d1dece229$var$extrema[1];
    $9601505d1dece229$var$extrema[1] = tmp;
}
function $9601505d1dece229$var$windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
    if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) return 0;
    var nRoots = $893961281ad1f27f$export$ca5d13faa10b167e(y0, y1, y2, y3, y, $9601505d1dece229$var$roots);
    if (nRoots === 0) return 0;
    else {
        var w = 0;
        var nExtrema = -1;
        var y0_ = void 0;
        var y1_ = void 0;
        for(var i = 0; i < nRoots; i++){
            var t = $9601505d1dece229$var$roots[i];
            var unit = t === 0 || t === 1 ? 0.5 : 1;
            var x_ = $893961281ad1f27f$export$547c21de482bbcb2(x0, x1, x2, x3, t);
            if (x_ < x) continue;
            if (nExtrema < 0) {
                nExtrema = $893961281ad1f27f$export$df1a172f100d0457(y0, y1, y2, y3, $9601505d1dece229$var$extrema);
                if ($9601505d1dece229$var$extrema[1] < $9601505d1dece229$var$extrema[0] && nExtrema > 1) $9601505d1dece229$var$swapExtrema();
                y0_ = $893961281ad1f27f$export$547c21de482bbcb2(y0, y1, y2, y3, $9601505d1dece229$var$extrema[0]);
                if (nExtrema > 1) y1_ = $893961281ad1f27f$export$547c21de482bbcb2(y0, y1, y2, y3, $9601505d1dece229$var$extrema[1]);
            }
            if (nExtrema === 2) {
                if (t < $9601505d1dece229$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                else if (t < $9601505d1dece229$var$extrema[1]) w += y1_ < y0_ ? unit : -unit;
                else w += y3 < y1_ ? unit : -unit;
            } else if (t < $9601505d1dece229$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
            else w += y3 < y0_ ? unit : -unit;
        }
        return w;
    }
}
function $9601505d1dece229$var$windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
    if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) return 0;
    var nRoots = $893961281ad1f27f$export$fd895ac7ee764967(y0, y1, y2, y, $9601505d1dece229$var$roots);
    if (nRoots === 0) return 0;
    else {
        var t = $893961281ad1f27f$export$752e1f8c6e7f7e11(y0, y1, y2);
        if (t >= 0 && t <= 1) {
            var w = 0;
            var y_ = $893961281ad1f27f$export$af17094a950f5073(y0, y1, y2, t);
            for(var i = 0; i < nRoots; i++){
                var unit = $9601505d1dece229$var$roots[i] === 0 || $9601505d1dece229$var$roots[i] === 1 ? 0.5 : 1;
                var x_ = $893961281ad1f27f$export$af17094a950f5073(x0, x1, x2, $9601505d1dece229$var$roots[i]);
                if (x_ < x) continue;
                if ($9601505d1dece229$var$roots[i] < t) w += y_ < y0 ? unit : -unit;
                else w += y2 < y_ ? unit : -unit;
            }
            return w;
        } else {
            var unit = $9601505d1dece229$var$roots[0] === 0 || $9601505d1dece229$var$roots[0] === 1 ? 0.5 : 1;
            var x_ = $893961281ad1f27f$export$af17094a950f5073(x0, x1, x2, $9601505d1dece229$var$roots[0]);
            if (x_ < x) return 0;
            return y2 < y0 ? unit : -unit;
        }
    }
}
function $9601505d1dece229$var$windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
    y -= cy;
    if (y > r || y < -r) return 0;
    var tmp = Math.sqrt(r * r - y * y);
    $9601505d1dece229$var$roots[0] = -tmp;
    $9601505d1dece229$var$roots[1] = tmp;
    var dTheta = Math.abs(startAngle - endAngle);
    if (dTheta < 1e-4) return 0;
    if (dTheta >= $9601505d1dece229$var$PI2 - 1e-4) {
        startAngle = 0;
        endAngle = $9601505d1dece229$var$PI2;
        var dir = anticlockwise ? 1 : -1;
        if (x >= $9601505d1dece229$var$roots[0] + cx && x <= $9601505d1dece229$var$roots[1] + cx) return dir;
        else return 0;
    }
    if (startAngle > endAngle) {
        var tmp_1 = startAngle;
        startAngle = endAngle;
        endAngle = tmp_1;
    }
    if (startAngle < 0) {
        startAngle += $9601505d1dece229$var$PI2;
        endAngle += $9601505d1dece229$var$PI2;
    }
    var w = 0;
    for(var i = 0; i < 2; i++){
        var x_ = $9601505d1dece229$var$roots[i];
        if (x_ + cx > x) {
            var angle = Math.atan2(y, x_);
            var dir = anticlockwise ? 1 : -1;
            if (angle < 0) angle = $9601505d1dece229$var$PI2 + angle;
            if (angle >= startAngle && angle <= endAngle || angle + $9601505d1dece229$var$PI2 >= startAngle && angle + $9601505d1dece229$var$PI2 <= endAngle) {
                if (angle > Math.PI / 2 && angle < Math.PI * 1.5) dir = -dir;
                w += dir;
            }
        }
    }
    return w;
}
function $9601505d1dece229$var$containPath(path, lineWidth, isStroke, x, y) {
    var data = path.data;
    var len = path.len();
    var w = 0;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    for(var i = 0; i < len;){
        var cmd = data[i++];
        var isFirst = i === 1;
        if (cmd === $9601505d1dece229$var$CMD.M && i > 1) {
            if (!isStroke) w += (0, $60ba2e40a14a1c35$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y);
        }
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        switch(cmd){
            case $9601505d1dece229$var$CMD.M:
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $9601505d1dece229$var$CMD.L:
                if (isStroke) {
                    if ($1b8a3b6d00d4b101$export$8d36b1b5d19157c5(xi, yi, data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += (0, $60ba2e40a14a1c35$export$2e2bcd8739ae039)(xi, yi, data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $9601505d1dece229$var$CMD.C:
                if (isStroke) {
                    if ($5ac5c2b3fd53f965$export$8d36b1b5d19157c5(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $9601505d1dece229$var$windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $9601505d1dece229$var$CMD.Q:
                if (isStroke) {
                    if ($79369ec7c41caa1d$export$8d36b1b5d19157c5(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $9601505d1dece229$var$windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $9601505d1dece229$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                if (!isFirst) w += (0, $60ba2e40a14a1c35$export$2e2bcd8739ae039)(xi, yi, x1, y1, x, y);
                else {
                    x0 = x1;
                    y0 = y1;
                }
                var _x = (x - cx) * ry / rx + cx;
                if (isStroke) {
                    if ($e46961d56549c575$export$8d36b1b5d19157c5(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) return true;
                } else w += $9601505d1dece229$var$windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $9601505d1dece229$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                x1 = x0 + width;
                y1 = y0 + height;
                if (isStroke) {
                    if ($1b8a3b6d00d4b101$export$8d36b1b5d19157c5(x0, y0, x1, y0, lineWidth, x, y) || $1b8a3b6d00d4b101$export$8d36b1b5d19157c5(x1, y0, x1, y1, lineWidth, x, y) || $1b8a3b6d00d4b101$export$8d36b1b5d19157c5(x1, y1, x0, y1, lineWidth, x, y) || $1b8a3b6d00d4b101$export$8d36b1b5d19157c5(x0, y1, x0, y0, lineWidth, x, y)) return true;
                } else {
                    w += (0, $60ba2e40a14a1c35$export$2e2bcd8739ae039)(x1, y0, x1, y1, x, y);
                    w += (0, $60ba2e40a14a1c35$export$2e2bcd8739ae039)(x0, y1, x0, y0, x, y);
                }
                break;
            case $9601505d1dece229$var$CMD.Z:
                if (isStroke) {
                    if ($1b8a3b6d00d4b101$export$8d36b1b5d19157c5(xi, yi, x0, y0, lineWidth, x, y)) return true;
                } else w += (0, $60ba2e40a14a1c35$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (!isStroke && !$9601505d1dece229$var$isAroundEqual(yi, y0)) w += (0, $60ba2e40a14a1c35$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y) || 0;
    return w !== 0;
}
function $9601505d1dece229$export$8893e2b90ba10d92(pathProxy, x, y) {
    return $9601505d1dece229$var$containPath(pathProxy, 0, false, x, y);
}
function $9601505d1dece229$export$8d36b1b5d19157c5(pathProxy, lineWidth, x, y) {
    return $9601505d1dece229$var$containPath(pathProxy, lineWidth, true, x, y);
}







var $340211037b56ba3f$export$deade517576e293a = (0, $f16f2994a32ad273$export$ebe90cb607ad99e)({
    fill: '#000',
    stroke: null,
    strokePercent: 1,
    fillOpacity: 1,
    strokeOpacity: 1,
    lineDashOffset: 0,
    lineWidth: 1,
    lineCap: 'butt',
    miterLimit: 10,
    strokeNoScale: false,
    strokeFirst: false
}, (0, $0a0ef4888a4b4e90$export$737672163db00fe3));
var $340211037b56ba3f$export$71bb6c3c6862c6a5 = {
    style: (0, $f16f2994a32ad273$export$ebe90cb607ad99e)({
        fill: true,
        stroke: true,
        strokePercent: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineDashOffset: true,
        lineWidth: true,
        miterLimit: true
    }, (0, $0a0ef4888a4b4e90$export$9908943fb57fbe51).style)
};
var $340211037b56ba3f$var$pathCopyParams = (0, $ad30ab15d8ed0f32$export$98ab6203ec3396e2).concat([
    'invisible',
    'culling',
    'z',
    'z2',
    'zlevel',
    'parent'
]);
var $340211037b56ba3f$var$Path = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Path, _super);
    function Path(opts) {
        return _super.call(this, opts) || this;
    }
    Path.prototype.update = function() {
        var _this = this;
        _super.prototype.update.call(this);
        var style = this.style;
        if (style.decal) {
            var decalEl = this._decalEl = this._decalEl || new Path();
            if (decalEl.buildPath === Path.prototype.buildPath) decalEl.buildPath = function(ctx) {
                _this.buildPath(ctx, _this.shape);
            };
            decalEl.silent = true;
            var decalElStyle = decalEl.style;
            for(var key in style)if (decalElStyle[key] !== style[key]) decalElStyle[key] = style[key];
            decalElStyle.fill = style.fill ? style.decal : null;
            decalElStyle.decal = null;
            decalElStyle.shadowColor = null;
            style.strokeFirst && (decalElStyle.stroke = null);
            for(var i = 0; i < $340211037b56ba3f$var$pathCopyParams.length; ++i)decalEl[$340211037b56ba3f$var$pathCopyParams[i]] = this[$340211037b56ba3f$var$pathCopyParams[i]];
            decalEl.__dirty |= (0, $66869c587f14f122$export$a7b6db622c6c7dbd);
        } else if (this._decalEl) this._decalEl = null;
    };
    Path.prototype.getDecalElement = function() {
        return this._decalEl;
    };
    Path.prototype._init = function(props) {
        var keysArr = (0, $f16f2994a32ad273$export$ed97f33186d4b816)(props);
        this.shape = this.getDefaultShape();
        var defaultStyle = this.getDefaultStyle();
        if (defaultStyle) this.useStyle(defaultStyle);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            var value = props[key];
            if (key === 'style') {
                if (!this.style) this.useStyle(value);
                else (0, $f16f2994a32ad273$export$8b58be045bf06082)(this.style, value);
            } else if (key === 'shape') (0, $f16f2994a32ad273$export$8b58be045bf06082)(this.shape, value);
            else _super.prototype.attrKV.call(this, key, value);
        }
        if (!this.style) this.useStyle({});
    };
    Path.prototype.getDefaultStyle = function() {
        return null;
    };
    Path.prototype.getDefaultShape = function() {
        return {};
    };
    Path.prototype.canBeInsideText = function() {
        return this.hasFill();
    };
    Path.prototype.getInsideTextFill = function() {
        var pathFill = this.style.fill;
        if (pathFill !== 'none') {
            if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(pathFill)) {
                var fillLum = (0, $83e50b4ee4d3c357$export$16c0ec21a6f9ef95)(pathFill, 0);
                if (fillLum > 0.5) return 0, $e374994bc8dfd1f0$export$f8ce94761f39398d;
                else if (fillLum > 0.2) return 0, $e374994bc8dfd1f0$export$27682248795c3c6b;
                return 0, $e374994bc8dfd1f0$export$3c6e95f318c8369b;
            } else if (pathFill) return 0, $e374994bc8dfd1f0$export$3c6e95f318c8369b;
        }
        return 0, $e374994bc8dfd1f0$export$f8ce94761f39398d;
    };
    Path.prototype.getInsideTextStroke = function(textFill) {
        var pathFill = this.style.fill;
        if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(pathFill)) {
            var zr = this.__zr;
            var isDarkMode = !!(zr && zr.isDarkMode());
            var isDarkLabel = (0, $83e50b4ee4d3c357$export$16c0ec21a6f9ef95)(textFill, 0) < (0, $e374994bc8dfd1f0$export$fd81e7ebc7dae256);
            if (isDarkMode === isDarkLabel) return pathFill;
        }
    };
    Path.prototype.buildPath = function(ctx, shapeCfg, inBatch) {};
    Path.prototype.pathUpdated = function() {
        this.__dirty &= ~(0, $66869c587f14f122$export$f75fe89a33ebe115);
    };
    Path.prototype.getUpdatedPathProxy = function(inBatch) {
        !this.path && this.createPathProxy();
        this.path.beginPath();
        this.buildPath(this.path, this.shape, inBatch);
        return this.path;
    };
    Path.prototype.createPathProxy = function() {
        this.path = new (0, $af4d02a47e9b6a35$export$2e2bcd8739ae039)(false);
    };
    Path.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
    };
    Path.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    Path.prototype.getBoundingRect = function() {
        var rect = this._rect;
        var style = this.style;
        var needsUpdateRect = !rect;
        if (needsUpdateRect) {
            var firstInvoke = false;
            if (!this.path) {
                firstInvoke = true;
                this.createPathProxy();
            }
            var path = this.path;
            if (firstInvoke || this.__dirty & (0, $66869c587f14f122$export$f75fe89a33ebe115)) {
                path.beginPath();
                this.buildPath(path, this.shape, false);
                this.pathUpdated();
            }
            rect = path.getBoundingRect();
        }
        this._rect = rect;
        if (this.hasStroke() && this.path && this.path.len() > 0) {
            var rectStroke = this._rectStroke || (this._rectStroke = rect.clone());
            if (this.__dirty || needsUpdateRect) {
                rectStroke.copy(rect);
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                var w = style.lineWidth;
                if (!this.hasFill()) {
                    var strokeContainThreshold = this.strokeContainThreshold;
                    w = Math.max(w, strokeContainThreshold == null ? 4 : strokeContainThreshold);
                }
                if (lineScale > 1e-10) {
                    rectStroke.width += w / lineScale;
                    rectStroke.height += w / lineScale;
                    rectStroke.x -= w / lineScale / 2;
                    rectStroke.y -= w / lineScale / 2;
                }
            }
            return rectStroke;
        }
        return rect;
    };
    Path.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        var style = this.style;
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            var pathProxy = this.path;
            if (this.hasStroke()) {
                var lineWidth = style.lineWidth;
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                if (lineScale > 1e-10) {
                    if (!this.hasFill()) lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
                    if ($9601505d1dece229$export$8d36b1b5d19157c5(pathProxy, lineWidth / lineScale, x, y)) return true;
                }
            }
            if (this.hasFill()) return $9601505d1dece229$export$8893e2b90ba10d92(pathProxy, x, y);
        }
        return false;
    };
    Path.prototype.dirtyShape = function() {
        this.__dirty |= (0, $66869c587f14f122$export$f75fe89a33ebe115);
        if (this._rect) this._rect = null;
        if (this._decalEl) this._decalEl.dirtyShape();
        this.markRedraw();
    };
    Path.prototype.dirty = function() {
        this.dirtyStyle();
        this.dirtyShape();
    };
    Path.prototype.animateShape = function(loop) {
        return this.animate('shape', loop);
    };
    Path.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === 'style') this.dirtyStyle();
        else if (targetKey === 'shape') this.dirtyShape();
        else this.markRedraw();
    };
    Path.prototype.attrKV = function(key, value) {
        if (key === 'shape') this.setShape(value);
        else _super.prototype.attrKV.call(this, key, value);
    };
    Path.prototype.setShape = function(keyOrObj, value) {
        var shape = this.shape;
        if (!shape) shape = this.shape = {};
        if (typeof keyOrObj === 'string') shape[keyOrObj] = value;
        else (0, $f16f2994a32ad273$export$8b58be045bf06082)(shape, keyOrObj);
        this.dirtyShape();
        return this;
    };
    Path.prototype.shapeChanged = function() {
        return !!(this.__dirty & (0, $66869c587f14f122$export$f75fe89a33ebe115));
    };
    Path.prototype.createStyle = function(obj) {
        return (0, $f16f2994a32ad273$export$79c7e160a7743efd)($340211037b56ba3f$export$deade517576e293a, obj);
    };
    Path.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.shape && !normalState.shape) normalState.shape = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, this.shape);
    };
    Path.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        if (this.__inHover === (0, $05d7569c5e654d58$export$f5347ae640a7f0d0)) return;
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetShape;
        if (state && state.shape) {
            if (transition) {
                if (keepCurrentStates) targetShape = state.shape;
                else {
                    targetShape = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, normalState.shape);
                    (0, $f16f2994a32ad273$export$8b58be045bf06082)(targetShape, state.shape);
                }
            } else {
                targetShape = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, keepCurrentStates ? this.shape : normalState.shape);
                (0, $f16f2994a32ad273$export$8b58be045bf06082)(targetShape, state.shape);
            }
        } else if (needsRestoreToNormal) targetShape = normalState.shape;
        if (targetShape) {
            if (transition) {
                this.shape = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, this.shape);
                var targetShapePrimaryProps = {};
                var shapeKeys = (0, $f16f2994a32ad273$export$ed97f33186d4b816)(targetShape);
                for(var i = 0; i < shapeKeys.length; i++){
                    var key = shapeKeys[i];
                    if ((0, $7E0eS._)(targetShape[key]) === 'object') this.shape[key] = targetShape[key];
                    else targetShapePrimaryProps[key] = targetShape[key];
                }
                this._transitionState(stateName, {
                    shape: targetShapePrimaryProps
                }, animationCfg);
            } else {
                this.shape = targetShape;
                this.dirtyShape();
            }
        }
    };
    Path.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedShape;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.shape) {
                mergedShape = mergedShape || {};
                this._mergeStyle(mergedShape, state.shape);
            }
        }
        if (mergedShape) mergedState.shape = mergedShape;
        return mergedState;
    };
    Path.prototype.getAnimationStyleProps = function() {
        return $340211037b56ba3f$export$71bb6c3c6862c6a5;
    };
    Path.prototype.isZeroArea = function() {
        return false;
    };
    Path.extend = function(defaultProps) {
        var Sub = function(_super) {
            (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Sub, _super);
            function Sub(opts) {
                var _this = _super.call(this, opts) || this;
                defaultProps.init && defaultProps.init.call(_this, opts);
                return _this;
            }
            Sub.prototype.getDefaultStyle = function() {
                return (0, $f16f2994a32ad273$export$9cd59f9826255e47)(defaultProps.style);
            };
            Sub.prototype.getDefaultShape = function() {
                return (0, $f16f2994a32ad273$export$9cd59f9826255e47)(defaultProps.shape);
            };
            return Sub;
        }(Path);
        for(var key in defaultProps)if (typeof defaultProps[key] === 'function') Sub.prototype[key] = defaultProps[key];
        return Sub;
    };
    Path.initDefaultProps = function() {
        var pathProto = Path.prototype;
        pathProto.type = 'path';
        pathProto.strokeContainThreshold = 5;
        pathProto.segmentIgnoreThreshold = 0;
        pathProto.subPixelOptimize = false;
        pathProto.autoBatch = false;
        pathProto.__dirty = (0, $66869c587f14f122$export$a7b6db622c6c7dbd) | (0, $66869c587f14f122$export$ada8b2beb3d76671) | (0, $66869c587f14f122$export$f75fe89a33ebe115);
    }();
    return Path;
}((0, $0a0ef4888a4b4e90$export$2e2bcd8739ae039));
var $340211037b56ba3f$export$2e2bcd8739ae039 = $340211037b56ba3f$var$Path;





var $df36fca73018b9d2$export$5fbb6d98091bcb56 = (0, $f16f2994a32ad273$export$ebe90cb607ad99e)({
    strokeFirst: true,
    font: (0, $e4ffe803d17351c8$export$7d7a232b6d2cc80c),
    x: 0,
    y: 0,
    textAlign: 'left',
    textBaseline: 'top',
    miterLimit: 2
}, (0, $340211037b56ba3f$export$deade517576e293a));
var $df36fca73018b9d2$var$TSpan = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(TSpan, _super);
    function TSpan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TSpan.prototype.hasStroke = function() {
        return (0, $a12266b0d5b7d162$export$c7aae0ffd99a8643)(this.style);
    };
    TSpan.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    TSpan.prototype.createStyle = function(obj) {
        return (0, $f16f2994a32ad273$export$79c7e160a7743efd)($df36fca73018b9d2$export$5fbb6d98091bcb56, obj);
    };
    TSpan.prototype.setBoundingRect = function(rect) {
        this._rect = rect;
    };
    TSpan.prototype.getBoundingRect = function() {
        if (!this._rect) this._rect = (0, $a12266b0d5b7d162$export$d79289ac0f53b974)(this.style);
        return this._rect;
    };
    TSpan.initDefaultProps = function() {
        var tspanProto = TSpan.prototype;
        tspanProto.dirtyRectTolerance = 10;
    }();
    return TSpan;
}((0, $0a0ef4888a4b4e90$export$2e2bcd8739ae039));
$df36fca73018b9d2$var$TSpan.prototype.type = 'tspan';
var $df36fca73018b9d2$export$2e2bcd8739ae039 = $df36fca73018b9d2$var$TSpan;








var $0eafea320dbd53c3$export$8993f922aeeac642 = (0, $f16f2994a32ad273$export$ebe90cb607ad99e)({
    x: 0,
    y: 0
}, (0, $0a0ef4888a4b4e90$export$737672163db00fe3));
var $0eafea320dbd53c3$export$4aba8ad70847a488 = {
    style: (0, $f16f2994a32ad273$export$ebe90cb607ad99e)({
        x: true,
        y: true,
        width: true,
        height: true,
        sx: true,
        sy: true,
        sWidth: true,
        sHeight: true
    }, (0, $0a0ef4888a4b4e90$export$9908943fb57fbe51).style)
};
function $0eafea320dbd53c3$var$isImageLike(source) {
    return !!(source && typeof source !== 'string' && source.width && source.height);
}
var $0eafea320dbd53c3$var$ZRImage = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(ZRImage, _super);
    function ZRImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ZRImage.prototype.createStyle = function(obj) {
        return (0, $f16f2994a32ad273$export$79c7e160a7743efd)($0eafea320dbd53c3$export$8993f922aeeac642, obj);
    };
    ZRImage.prototype._getSize = function(dim) {
        var style = this.style;
        var size = style[dim];
        if (size != null) return size;
        var imageSource = $0eafea320dbd53c3$var$isImageLike(style.image) ? style.image : this.__image;
        if (!imageSource) return 0;
        var otherDim = dim === 'width' ? 'height' : 'width';
        var otherDimSize = style[otherDim];
        if (otherDimSize == null) return imageSource[dim];
        else return imageSource[dim] / imageSource[otherDim] * otherDimSize;
    };
    ZRImage.prototype.getWidth = function() {
        return this._getSize('width');
    };
    ZRImage.prototype.getHeight = function() {
        return this._getSize('height');
    };
    ZRImage.prototype.getAnimationStyleProps = function() {
        return $0eafea320dbd53c3$export$4aba8ad70847a488;
    };
    ZRImage.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) this._rect = new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(style.x || 0, style.y || 0, this.getWidth(), this.getHeight());
        return this._rect;
    };
    return ZRImage;
}((0, $0a0ef4888a4b4e90$export$2e2bcd8739ae039));
$0eafea320dbd53c3$var$ZRImage.prototype.type = 'image';
var $0eafea320dbd53c3$export$2e2bcd8739ae039 = $0eafea320dbd53c3$var$ZRImage;




function $6da72b9ec54ca878$export$5cc7f731b5937e99(ctx, shape) {
    var x = shape.x;
    var y = shape.y;
    var width = shape.width;
    var height = shape.height;
    var r = shape.r;
    var r1;
    var r2;
    var r3;
    var r4;
    if (width < 0) {
        x = x + width;
        width = -width;
    }
    if (height < 0) {
        y = y + height;
        height = -height;
    }
    if (typeof r === 'number') r1 = r2 = r3 = r4 = r;
    else if (r instanceof Array) {
        if (r.length === 1) r1 = r2 = r3 = r4 = r[0];
        else if (r.length === 2) {
            r1 = r3 = r[0];
            r2 = r4 = r[1];
        } else if (r.length === 3) {
            r1 = r[0];
            r2 = r4 = r[1];
            r3 = r[2];
        } else {
            r1 = r[0];
            r2 = r[1];
            r3 = r[2];
            r4 = r[3];
        }
    } else r1 = r2 = r3 = r4 = 0;
    var total;
    if (r1 + r2 > width) {
        total = r1 + r2;
        r1 *= width / total;
        r2 *= width / total;
    }
    if (r3 + r4 > width) {
        total = r3 + r4;
        r3 *= width / total;
        r4 *= width / total;
    }
    if (r2 + r3 > height) {
        total = r2 + r3;
        r2 *= height / total;
        r3 *= height / total;
    }
    if (r1 + r4 > height) {
        total = r1 + r4;
        r1 *= height / total;
        r4 *= height / total;
    }
    ctx.moveTo(x + r1, y);
    ctx.lineTo(x + width - r2, y);
    r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
    ctx.lineTo(x + width, y + height - r3);
    r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
    ctx.lineTo(x + r4, y + height);
    r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
    ctx.lineTo(x, y + r1);
    r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
    ctx.closePath();
}


var $df42d3963fd014cb$var$round = Math.round;
function $df42d3963fd014cb$export$8b4b620d7f4aad1b(outputShape, inputShape, style) {
    if (!inputShape) return;
    var x1 = inputShape.x1;
    var x2 = inputShape.x2;
    var y1 = inputShape.y1;
    var y2 = inputShape.y2;
    outputShape.x1 = x1;
    outputShape.x2 = x2;
    outputShape.y1 = y1;
    outputShape.y2 = y2;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    if ($df42d3963fd014cb$var$round(x1 * 2) === $df42d3963fd014cb$var$round(x2 * 2)) outputShape.x1 = outputShape.x2 = $df42d3963fd014cb$export$72c4fd4c1b8fcb10(x1, lineWidth, true);
    if ($df42d3963fd014cb$var$round(y1 * 2) === $df42d3963fd014cb$var$round(y2 * 2)) outputShape.y1 = outputShape.y2 = $df42d3963fd014cb$export$72c4fd4c1b8fcb10(y1, lineWidth, true);
    return outputShape;
}
function $df42d3963fd014cb$export$60e2aa74957d0b9d(outputShape, inputShape, style) {
    if (!inputShape) return;
    var originX = inputShape.x;
    var originY = inputShape.y;
    var originWidth = inputShape.width;
    var originHeight = inputShape.height;
    outputShape.x = originX;
    outputShape.y = originY;
    outputShape.width = originWidth;
    outputShape.height = originHeight;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    outputShape.x = $df42d3963fd014cb$export$72c4fd4c1b8fcb10(originX, lineWidth, true);
    outputShape.y = $df42d3963fd014cb$export$72c4fd4c1b8fcb10(originY, lineWidth, true);
    outputShape.width = Math.max($df42d3963fd014cb$export$72c4fd4c1b8fcb10(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
    outputShape.height = Math.max($df42d3963fd014cb$export$72c4fd4c1b8fcb10(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
    return outputShape;
}
function $df42d3963fd014cb$export$72c4fd4c1b8fcb10(position, lineWidth, positiveOrNegative) {
    if (!lineWidth) return position;
    var doubledPosition = $df42d3963fd014cb$var$round(position * 2);
    return (doubledPosition + $df42d3963fd014cb$var$round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}


var $dbd6d77105f10fb2$export$51140d6b71bb4ed5 = function() {
    function RectShape() {
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
    }
    return RectShape;
}();
var $dbd6d77105f10fb2$var$subPixelOptimizeOutputShape = {};
var $dbd6d77105f10fb2$var$Rect = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Rect, _super);
    function Rect(opts) {
        return _super.call(this, opts) || this;
    }
    Rect.prototype.getDefaultShape = function() {
        return new $dbd6d77105f10fb2$export$51140d6b71bb4ed5();
    };
    Rect.prototype.buildPath = function(ctx, shape) {
        var x;
        var y;
        var width;
        var height;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $df42d3963fd014cb$export$60e2aa74957d0b9d)($dbd6d77105f10fb2$var$subPixelOptimizeOutputShape, shape, this.style);
            x = optimizedShape.x;
            y = optimizedShape.y;
            width = optimizedShape.width;
            height = optimizedShape.height;
            optimizedShape.r = shape.r;
            shape = optimizedShape;
        } else {
            x = shape.x;
            y = shape.y;
            width = shape.width;
            height = shape.height;
        }
        if (!shape.r) ctx.rect(x, y, width, height);
        else $6da72b9ec54ca878$export$5cc7f731b5937e99(ctx, shape);
    };
    Rect.prototype.isZeroArea = function() {
        return !this.shape.width || !this.shape.height;
    };
    return Rect;
}((0, $340211037b56ba3f$export$2e2bcd8739ae039));
$dbd6d77105f10fb2$var$Rect.prototype.type = 'rect';
var $dbd6d77105f10fb2$export$2e2bcd8739ae039 = $dbd6d77105f10fb2$var$Rect;





var $7d5e7dc1581f8c9a$var$DEFAULT_RICH_TEXT_COLOR = {
    fill: '#000'
};
var $7d5e7dc1581f8c9a$var$DEFAULT_STROKE_LINE_WIDTH = 2;
var $7d5e7dc1581f8c9a$var$tmpCITOverflowAreaOut = {};
var $7d5e7dc1581f8c9a$export$21aaaa0607ee0e2b = {
    style: (0, $f16f2994a32ad273$export$ebe90cb607ad99e)({
        fill: true,
        stroke: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineWidth: true,
        fontSize: true,
        lineHeight: true,
        width: true,
        height: true,
        textShadowColor: true,
        textShadowBlur: true,
        textShadowOffsetX: true,
        textShadowOffsetY: true,
        backgroundColor: true,
        padding: true,
        borderColor: true,
        borderWidth: true,
        borderRadius: true
    }, (0, $0a0ef4888a4b4e90$export$9908943fb57fbe51).style)
};
var $7d5e7dc1581f8c9a$var$ZRText = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(ZRText, _super);
    function ZRText(opts) {
        var _this = _super.call(this) || this;
        _this.type = 'text';
        _this._children = [];
        _this._defaultStyle = $7d5e7dc1581f8c9a$var$DEFAULT_RICH_TEXT_COLOR;
        _this.attr(opts);
        return _this;
    }
    ZRText.prototype.childrenRef = function() {
        return this._children;
    };
    ZRText.prototype.update = function() {
        _super.prototype.update.call(this);
        if (this.styleChanged()) this._updateSubTexts();
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.zlevel = this.zlevel;
            child.z = this.z;
            child.z2 = this.z2;
            child.culling = this.culling;
            child.cursor = this.cursor;
            child.invisible = this.invisible;
        }
    };
    ZRText.prototype.updateTransform = function() {
        var innerTransformable = this.innerTransformable;
        if (innerTransformable) {
            innerTransformable.updateTransform();
            if (innerTransformable.transform) this.transform = innerTransformable.transform;
        } else _super.prototype.updateTransform.call(this);
    };
    ZRText.prototype.getLocalTransform = function(m) {
        var innerTransformable = this.innerTransformable;
        return innerTransformable ? innerTransformable.getLocalTransform(m) : _super.prototype.getLocalTransform.call(this, m);
    };
    ZRText.prototype.getComputedTransform = function() {
        if (this.__hostTarget) {
            this.__hostTarget.getComputedTransform();
            this.__hostTarget.updateInnerText(true);
        }
        return _super.prototype.getComputedTransform.call(this);
    };
    ZRText.prototype._updateSubTexts = function() {
        this._childCursor = 0;
        $7d5e7dc1581f8c9a$export$176336068cc5371f(this.style);
        this.style.rich ? this._updateRichTexts() : this._updatePlainTexts();
        this._children.length = this._childCursor;
        this.styleUpdated();
    };
    ZRText.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = zr;
    };
    ZRText.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = null;
    };
    ZRText.prototype.getBoundingRect = function() {
        if (this.styleChanged()) this._updateSubTexts();
        if (!this._rect) {
            var tmpRect = new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(0, 0, 0, 0);
            var children = this._children;
            var tmpMat = [];
            var rect = null;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                var childRect = child.getBoundingRect();
                var transform = child.getLocalTransform(tmpMat);
                if (transform) {
                    tmpRect.copy(childRect);
                    tmpRect.applyTransform(transform);
                    rect = rect || tmpRect.clone();
                    rect.union(tmpRect);
                } else {
                    rect = rect || childRect.clone();
                    rect.union(childRect);
                }
            }
            this._rect = rect || tmpRect;
        }
        return this._rect;
    };
    ZRText.prototype.setDefaultTextStyle = function(defaultTextStyle) {
        this._defaultStyle = defaultTextStyle || $7d5e7dc1581f8c9a$var$DEFAULT_RICH_TEXT_COLOR;
    };
    ZRText.prototype.setTextContent = function(textContent) {};
    ZRText.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        if (!sourceStyle) return targetStyle;
        var sourceRich = sourceStyle.rich;
        var targetRich = targetStyle.rich || sourceRich && {};
        (0, $f16f2994a32ad273$export$8b58be045bf06082)(targetStyle, sourceStyle);
        if (sourceRich && targetRich) {
            this._mergeRich(targetRich, sourceRich);
            targetStyle.rich = targetRich;
        } else if (targetRich) targetStyle.rich = targetRich;
        return targetStyle;
    };
    ZRText.prototype._mergeRich = function(targetRich, sourceRich) {
        var richNames = (0, $f16f2994a32ad273$export$ed97f33186d4b816)(sourceRich);
        for(var i = 0; i < richNames.length; i++){
            var richName = richNames[i];
            targetRich[richName] = targetRich[richName] || {};
            (0, $f16f2994a32ad273$export$8b58be045bf06082)(targetRich[richName], sourceRich[richName]);
        }
    };
    ZRText.prototype.getAnimationStyleProps = function() {
        return $7d5e7dc1581f8c9a$export$21aaaa0607ee0e2b;
    };
    ZRText.prototype._getOrCreateChild = function(Ctor) {
        var child = this._children[this._childCursor];
        if (!child || !(child instanceof Ctor)) child = new Ctor();
        this._children[this._childCursor++] = child;
        child.__zr = this.__zr;
        child.parent = this;
        return child;
    };
    ZRText.prototype._updatePlainTexts = function() {
        var style = this.style;
        var textFont = style.font || (0, $e4ffe803d17351c8$export$7d7a232b6d2cc80c);
        var textPadding = style.padding;
        var defaultStyle = this._defaultStyle;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var textAlign = style.align || defaultStyle.align || 'left';
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign || 'top';
        (0, $a12266b0d5b7d162$export$9a4428591d825b14)($7d5e7dc1581f8c9a$var$tmpCITOverflowAreaOut, defaultStyle.overflowRect, baseX, baseY, textAlign, verticalAlign);
        baseX = $7d5e7dc1581f8c9a$var$tmpCITOverflowAreaOut.baseX;
        baseY = $7d5e7dc1581f8c9a$var$tmpCITOverflowAreaOut.baseY;
        var text = $7d5e7dc1581f8c9a$var$getStyleText(style);
        var contentBlock = (0, $a12266b0d5b7d162$export$5772575e34ef80f9)(text, style, $7d5e7dc1581f8c9a$var$tmpCITOverflowAreaOut.outerWidth, $7d5e7dc1581f8c9a$var$tmpCITOverflowAreaOut.outerHeight);
        var needDrawBg = $7d5e7dc1581f8c9a$var$needDrawBackground(style);
        var bgColorDrawn = !!style.backgroundColor;
        var outerHeight = contentBlock.outerHeight;
        var outerWidth = contentBlock.outerWidth;
        var textLines = contentBlock.lines;
        var lineHeight = contentBlock.lineHeight;
        this.isTruncated = !!contentBlock.isTruncated;
        var textX = baseX;
        var textY = (0, $3ad1e5e308f2a981$export$bf7d6802d2badd9)(baseY, contentBlock.contentHeight, verticalAlign);
        if (needDrawBg || textPadding) {
            var boxX = (0, $3ad1e5e308f2a981$export$eb5a525ef00ef9a4)(baseX, outerWidth, textAlign);
            var boxY = (0, $3ad1e5e308f2a981$export$bf7d6802d2badd9)(baseY, outerHeight, verticalAlign);
            needDrawBg && this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        }
        textY += lineHeight / 2;
        if (textPadding) {
            textX = $7d5e7dc1581f8c9a$var$getTextXForPadding(baseX, textAlign, textPadding);
            if (verticalAlign === 'top') textY += textPadding[0];
            else if (verticalAlign === 'bottom') textY -= textPadding[2];
        }
        var defaultLineWidth = 0;
        var usingDefaultStroke = false;
        var useDefaultFill = false;
        var textFill = $7d5e7dc1581f8c9a$var$getFill('fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $7d5e7dc1581f8c9a$var$getStroke('stroke' in style ? style.stroke : !bgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $7d5e7dc1581f8c9a$var$DEFAULT_STROKE_LINE_WIDTH, usingDefaultStroke = true, defaultStyle.stroke) : null);
        var hasShadow = style.textShadowBlur > 0;
        for(var i = 0; i < textLines.length; i++){
            var el = this._getOrCreateChild((0, $df36fca73018b9d2$export$2e2bcd8739ae039));
            var subElStyle = el.createStyle();
            el.useStyle(subElStyle);
            subElStyle.text = textLines[i];
            subElStyle.x = textX;
            subElStyle.y = textY;
            if (textAlign) subElStyle.textAlign = textAlign;
            subElStyle.textBaseline = 'middle';
            subElStyle.opacity = style.opacity;
            subElStyle.strokeFirst = true;
            if (hasShadow) {
                subElStyle.shadowBlur = style.textShadowBlur || 0;
                subElStyle.shadowColor = style.textShadowColor || 'transparent';
                subElStyle.shadowOffsetX = style.textShadowOffsetX || 0;
                subElStyle.shadowOffsetY = style.textShadowOffsetY || 0;
            }
            subElStyle.stroke = textStroke;
            subElStyle.fill = textFill;
            if (textStroke) {
                subElStyle.lineWidth = style.lineWidth || defaultLineWidth;
                subElStyle.lineDash = style.lineDash;
                subElStyle.lineDashOffset = style.lineDashOffset || 0;
            }
            subElStyle.font = textFont;
            $7d5e7dc1581f8c9a$var$setSeparateFont(subElStyle, style);
            textY += lineHeight;
            el.setBoundingRect((0, $a12266b0d5b7d162$export$bd5d12d7bf7c9027)(subElStyle, contentBlock.contentWidth, contentBlock.calculatedLineHeight, usingDefaultStroke ? 0 : null));
        }
    };
    ZRText.prototype._updateRichTexts = function() {
        var style = this.style;
        var defaultStyle = this._defaultStyle;
        var textAlign = style.align || defaultStyle.align;
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        (0, $a12266b0d5b7d162$export$9a4428591d825b14)($7d5e7dc1581f8c9a$var$tmpCITOverflowAreaOut, defaultStyle.overflowRect, baseX, baseY, textAlign, verticalAlign);
        baseX = $7d5e7dc1581f8c9a$var$tmpCITOverflowAreaOut.baseX;
        baseY = $7d5e7dc1581f8c9a$var$tmpCITOverflowAreaOut.baseY;
        var text = $7d5e7dc1581f8c9a$var$getStyleText(style);
        var contentBlock = (0, $a12266b0d5b7d162$export$15ec9472ff2d721)(text, style, $7d5e7dc1581f8c9a$var$tmpCITOverflowAreaOut.outerWidth, $7d5e7dc1581f8c9a$var$tmpCITOverflowAreaOut.outerHeight, textAlign);
        var contentWidth = contentBlock.width;
        var outerWidth = contentBlock.outerWidth;
        var outerHeight = contentBlock.outerHeight;
        var textPadding = style.padding;
        this.isTruncated = !!contentBlock.isTruncated;
        var boxX = (0, $3ad1e5e308f2a981$export$eb5a525ef00ef9a4)(baseX, outerWidth, textAlign);
        var boxY = (0, $3ad1e5e308f2a981$export$bf7d6802d2badd9)(baseY, outerHeight, verticalAlign);
        var xLeft = boxX;
        var lineTop = boxY;
        if (textPadding) {
            xLeft += textPadding[3];
            lineTop += textPadding[0];
        }
        var xRight = xLeft + contentWidth;
        if ($7d5e7dc1581f8c9a$var$needDrawBackground(style)) this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        var bgColorDrawn = !!style.backgroundColor;
        for(var i = 0; i < contentBlock.lines.length; i++){
            var line = contentBlock.lines[i];
            var tokens = line.tokens;
            var tokenCount = tokens.length;
            var lineHeight = line.lineHeight;
            var remainedWidth = line.width;
            var leftIndex = 0;
            var lineXLeft = xLeft;
            var lineXRight = xRight;
            var rightIndex = tokenCount - 1;
            var token = void 0;
            while(leftIndex < tokenCount && (token = tokens[leftIndex], !token.align || token.align === 'left')){
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft, 'left', bgColorDrawn);
                remainedWidth -= token.width;
                lineXLeft += token.width;
                leftIndex++;
            }
            while(rightIndex >= 0 && (token = tokens[rightIndex], token.align === 'right')){
                this._placeToken(token, style, lineHeight, lineTop, lineXRight, 'right', bgColorDrawn);
                remainedWidth -= token.width;
                lineXRight -= token.width;
                rightIndex--;
            }
            lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - remainedWidth) / 2;
            while(leftIndex <= rightIndex){
                token = tokens[leftIndex];
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center', bgColorDrawn);
                lineXLeft += token.width;
                leftIndex++;
            }
            lineTop += lineHeight;
        }
    };
    ZRText.prototype._placeToken = function(token, style, lineHeight, lineTop, x, textAlign, parentBgColorDrawn) {
        var tokenStyle = style.rich[token.styleName] || {};
        tokenStyle.text = token.text;
        var verticalAlign = token.verticalAlign;
        var y = lineTop + lineHeight / 2;
        if (verticalAlign === 'top') y = lineTop + token.height / 2;
        else if (verticalAlign === 'bottom') y = lineTop + lineHeight - token.height / 2;
        var needDrawBg = !token.isLineHolder && $7d5e7dc1581f8c9a$var$needDrawBackground(tokenStyle);
        needDrawBg && this._renderBackground(tokenStyle, style, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
        var bgColorDrawn = !!tokenStyle.backgroundColor;
        var textPadding = token.textPadding;
        if (textPadding) {
            x = $7d5e7dc1581f8c9a$var$getTextXForPadding(x, textAlign, textPadding);
            y -= token.height / 2 - textPadding[0] - token.innerHeight / 2;
        }
        var el = this._getOrCreateChild((0, $df36fca73018b9d2$export$2e2bcd8739ae039));
        var subElStyle = el.createStyle();
        el.useStyle(subElStyle);
        var defaultStyle = this._defaultStyle;
        var useDefaultFill = false;
        var defaultLineWidth = 0;
        var usingDefaultStroke = false;
        var textFill = $7d5e7dc1581f8c9a$var$getFill('fill' in tokenStyle ? tokenStyle.fill : 'fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $7d5e7dc1581f8c9a$var$getStroke('stroke' in tokenStyle ? tokenStyle.stroke : 'stroke' in style ? style.stroke : !bgColorDrawn && !parentBgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $7d5e7dc1581f8c9a$var$DEFAULT_STROKE_LINE_WIDTH, usingDefaultStroke = true, defaultStyle.stroke) : null);
        var hasShadow = tokenStyle.textShadowBlur > 0 || style.textShadowBlur > 0;
        subElStyle.text = token.text;
        subElStyle.x = x;
        subElStyle.y = y;
        if (hasShadow) {
            subElStyle.shadowBlur = tokenStyle.textShadowBlur || style.textShadowBlur || 0;
            subElStyle.shadowColor = tokenStyle.textShadowColor || style.textShadowColor || 'transparent';
            subElStyle.shadowOffsetX = tokenStyle.textShadowOffsetX || style.textShadowOffsetX || 0;
            subElStyle.shadowOffsetY = tokenStyle.textShadowOffsetY || style.textShadowOffsetY || 0;
        }
        subElStyle.textAlign = textAlign;
        subElStyle.textBaseline = 'middle';
        subElStyle.font = token.font || (0, $e4ffe803d17351c8$export$7d7a232b6d2cc80c);
        subElStyle.opacity = (0, $f16f2994a32ad273$export$2e94551289abb95b)(tokenStyle.opacity, style.opacity, 1);
        $7d5e7dc1581f8c9a$var$setSeparateFont(subElStyle, tokenStyle);
        if (textStroke) {
            subElStyle.lineWidth = (0, $f16f2994a32ad273$export$2e94551289abb95b)(tokenStyle.lineWidth, style.lineWidth, defaultLineWidth);
            subElStyle.lineDash = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(tokenStyle.lineDash, style.lineDash);
            subElStyle.lineDashOffset = style.lineDashOffset || 0;
            subElStyle.stroke = textStroke;
        }
        if (textFill) subElStyle.fill = textFill;
        el.setBoundingRect((0, $a12266b0d5b7d162$export$bd5d12d7bf7c9027)(subElStyle, token.contentWidth, token.contentHeight, usingDefaultStroke ? 0 : null));
    };
    ZRText.prototype._renderBackground = function(style, topStyle, x, y, width, height) {
        var textBackgroundColor = style.backgroundColor;
        var textBorderWidth = style.borderWidth;
        var textBorderColor = style.borderColor;
        var isImageBg = textBackgroundColor && textBackgroundColor.image;
        var isPlainOrGradientBg = textBackgroundColor && !isImageBg;
        var textBorderRadius = style.borderRadius;
        var self = this;
        var rectEl;
        var imgEl;
        if (isPlainOrGradientBg || style.lineHeight || textBorderWidth && textBorderColor) {
            rectEl = this._getOrCreateChild((0, $dbd6d77105f10fb2$export$2e2bcd8739ae039));
            rectEl.useStyle(rectEl.createStyle());
            rectEl.style.fill = null;
            var rectShape = rectEl.shape;
            rectShape.x = x;
            rectShape.y = y;
            rectShape.width = width;
            rectShape.height = height;
            rectShape.r = textBorderRadius;
            rectEl.dirtyShape();
        }
        if (isPlainOrGradientBg) {
            var rectStyle = rectEl.style;
            rectStyle.fill = textBackgroundColor || null;
            rectStyle.fillOpacity = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(style.fillOpacity, 1);
        } else if (isImageBg) {
            imgEl = this._getOrCreateChild((0, $0eafea320dbd53c3$export$2e2bcd8739ae039));
            imgEl.onload = function() {
                self.dirtyStyle();
            };
            var imgStyle = imgEl.style;
            imgStyle.image = textBackgroundColor.image;
            imgStyle.x = x;
            imgStyle.y = y;
            imgStyle.width = width;
            imgStyle.height = height;
        }
        if (textBorderWidth && textBorderColor) {
            var rectStyle = rectEl.style;
            rectStyle.lineWidth = textBorderWidth;
            rectStyle.stroke = textBorderColor;
            rectStyle.strokeOpacity = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(style.strokeOpacity, 1);
            rectStyle.lineDash = style.borderDash;
            rectStyle.lineDashOffset = style.borderDashOffset || 0;
            rectEl.strokeContainThreshold = 0;
            if (rectEl.hasFill() && rectEl.hasStroke()) {
                rectStyle.strokeFirst = true;
                rectStyle.lineWidth *= 2;
            }
        }
        var commonStyle = (rectEl || imgEl).style;
        commonStyle.shadowBlur = style.shadowBlur || 0;
        commonStyle.shadowColor = style.shadowColor || 'transparent';
        commonStyle.shadowOffsetX = style.shadowOffsetX || 0;
        commonStyle.shadowOffsetY = style.shadowOffsetY || 0;
        commonStyle.opacity = (0, $f16f2994a32ad273$export$2e94551289abb95b)(style.opacity, topStyle.opacity, 1);
    };
    ZRText.makeFont = function(style) {
        var font = '';
        if ($7d5e7dc1581f8c9a$export$4685c95d5118e76a(style)) font = [
            style.fontStyle,
            style.fontWeight,
            $7d5e7dc1581f8c9a$export$51b066d9cfc2578e(style.fontSize),
            style.fontFamily || 'sans-serif'
        ].join(' ');
        return font && (0, $f16f2994a32ad273$export$87c2784dc9fc4ab)(font) || style.textFont || style.font;
    };
    return ZRText;
}((0, $0a0ef4888a4b4e90$export$2e2bcd8739ae039));
var $7d5e7dc1581f8c9a$var$VALID_TEXT_ALIGN = {
    left: true,
    right: 1,
    center: 1
};
var $7d5e7dc1581f8c9a$var$VALID_TEXT_VERTICAL_ALIGN = {
    top: 1,
    bottom: 1,
    middle: 1
};
var $7d5e7dc1581f8c9a$var$FONT_PARTS = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily'
];
function $7d5e7dc1581f8c9a$export$51b066d9cfc2578e(fontSize) {
    if (typeof fontSize === 'string' && (fontSize.indexOf('px') !== -1 || fontSize.indexOf('rem') !== -1 || fontSize.indexOf('em') !== -1)) return fontSize;
    else if (!isNaN(+fontSize)) return fontSize + 'px';
    else return (0, $e4ffe803d17351c8$export$b1461457ea2c1179) + 'px';
}
function $7d5e7dc1581f8c9a$var$setSeparateFont(targetStyle, sourceStyle) {
    for(var i = 0; i < $7d5e7dc1581f8c9a$var$FONT_PARTS.length; i++){
        var fontProp = $7d5e7dc1581f8c9a$var$FONT_PARTS[i];
        var val = sourceStyle[fontProp];
        if (val != null) targetStyle[fontProp] = val;
    }
}
function $7d5e7dc1581f8c9a$export$4685c95d5118e76a(style) {
    return style.fontSize != null || style.fontFamily || style.fontWeight;
}
function $7d5e7dc1581f8c9a$export$176336068cc5371f(style) {
    $7d5e7dc1581f8c9a$var$normalizeStyle(style);
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(style.rich, $7d5e7dc1581f8c9a$var$normalizeStyle);
    return style;
}
function $7d5e7dc1581f8c9a$var$normalizeStyle(style) {
    if (style) {
        style.font = $7d5e7dc1581f8c9a$var$ZRText.makeFont(style);
        var textAlign = style.align;
        textAlign === 'middle' && (textAlign = 'center');
        style.align = textAlign == null || $7d5e7dc1581f8c9a$var$VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left';
        var verticalAlign = style.verticalAlign;
        verticalAlign === 'center' && (verticalAlign = 'middle');
        style.verticalAlign = verticalAlign == null || $7d5e7dc1581f8c9a$var$VALID_TEXT_VERTICAL_ALIGN[verticalAlign] ? verticalAlign : 'top';
        var textPadding = style.padding;
        if (textPadding) style.padding = (0, $f16f2994a32ad273$export$f3a38102c49f4268)(style.padding);
    }
}
function $7d5e7dc1581f8c9a$var$getStroke(stroke, lineWidth) {
    return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null : stroke.image || stroke.colorStops ? '#000' : stroke;
}
function $7d5e7dc1581f8c9a$var$getFill(fill) {
    return fill == null || fill === 'none' ? null : fill.image || fill.colorStops ? '#000' : fill;
}
function $7d5e7dc1581f8c9a$var$getTextXForPadding(x, textAlign, textPadding) {
    return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}
function $7d5e7dc1581f8c9a$var$getStyleText(style) {
    var text = style.text;
    text != null && (text += '');
    return text;
}
function $7d5e7dc1581f8c9a$var$needDrawBackground(style) {
    return !!(style.backgroundColor || style.lineHeight || style.borderWidth && style.borderColor);
}
var $7d5e7dc1581f8c9a$export$2e2bcd8739ae039 = $7d5e7dc1581f8c9a$var$ZRText;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $813d173718eca8f1$export$b1c39b2bacd1ddc2 = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
var $813d173718eca8f1$export$30d6736ebb8e18d5 = function setCommonECData(seriesIndex, dataType, dataIdx, el) {
    if (el) {
        var ecData = $813d173718eca8f1$export$b1c39b2bacd1ddc2(el);
        // Add data index and series index for indexing the data by element
        // Useful in tooltip
        ecData.dataIndex = dataIdx;
        ecData.dataType = dataType;
        ecData.seriesIndex = seriesIndex;
        ecData.ssrType = 'chart';
        // TODO: not store dataIndex on children.
        if (el.type === 'group') el.traverse(function(child) {
            var childECData = $813d173718eca8f1$export$b1c39b2bacd1ddc2(child);
            childECData.seriesIndex = seriesIndex;
            childECData.dataIndex = dataIdx;
            childECData.dataType = dataType;
            childECData.ssrType = 'chart';
        });
    }
};





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $c870d17359cdf008$export$5ba2cba1cb566d7a = 'undefined';
var $c870d17359cdf008$export$68ebcbce21494007 = 'series';
var $c870d17359cdf008$export$cd51b5ca77f6f0e4 = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)([
    'tooltip',
    'label',
    'itemName',
    'itemId',
    'itemGroupId',
    'itemChildGroupId',
    'seriesName'
]);
var $c870d17359cdf008$export$2823037fb9d8f0c6 = 'original';
var $c870d17359cdf008$export$fcd62ebf51387903 = 'arrayRows';
var $c870d17359cdf008$export$703ae8a2d83f441 = 'objectRows';
var $c870d17359cdf008$export$6a32b42c754a3cb8 = 'keyedColumns';
var $c870d17359cdf008$export$a918cb016a382d45 = 'typedArray';
var $c870d17359cdf008$export$c78f1330778d30d = 'unknown';
var $c870d17359cdf008$export$7b3f3c6551b4949b = 'column';
var $c870d17359cdf008$export$d55da1467cdf7804 = 'row';
var $c870d17359cdf008$export$4ca176c09704a32 = 'Roam';


var $d64c00067dc939f7$var$availableMethods = [
    'getDom',
    'getZr',
    'getWidth',
    'getHeight',
    'getDevicePixelRatio',
    'dispatchAction',
    'isSSR',
    'isDisposed',
    'on',
    'off',
    'getDataURL',
    'getConnectedDataURL',
    // 'getModel',
    'getOption',
    // 'getViewOfComponentModel',
    // 'getViewOfSeriesModel',
    'getId',
    'updateLabelLayout'
];
var $d64c00067dc939f7$var$ExtensionAPI = /** @class */ function() {
    function ExtensionAPI(ecInstance) {
        $f16f2994a32ad273$export$79b2f7037acddd43($d64c00067dc939f7$var$availableMethods, function(methodName) {
            this[methodName] = $f16f2994a32ad273$export$2385a24977818dd0(ecInstance[methodName], ecInstance);
        }, this);
    }
    return ExtensionAPI;
}();
function $d64c00067dc939f7$export$2b32bcfeffd624a6(api, componentOrSeries) {
    return componentOrSeries.mainType === (0, $c870d17359cdf008$export$68ebcbce21494007) ? api.getViewOfSeriesModel(componentOrSeries) : api.getViewOfComponentModel(componentOrSeries);
}
var $d64c00067dc939f7$export$2e2bcd8739ae039 = $d64c00067dc939f7$var$ExtensionAPI;



// Reserve 0 as default.
var $1f99b77b45f30655$var$_highlightNextDigit = 1;
var $1f99b77b45f30655$var$_highlightKeyMap = {};
var $1f99b77b45f30655$var$getSavedStates = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
var $1f99b77b45f30655$var$getComponentStates = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
var $1f99b77b45f30655$export$5542daa30722333e = 0;
var $1f99b77b45f30655$export$1307d6a87d56baa = 1;
var $1f99b77b45f30655$export$f0f2bee145debb31 = 2;
var $1f99b77b45f30655$export$151308dceb52d5b = [
    'emphasis',
    'blur',
    'select'
];
var $1f99b77b45f30655$export$57ee5306b85ad7d5 = [
    'normal',
    'emphasis',
    'blur',
    'select'
];
var $1f99b77b45f30655$export$1cb9fc6ed5b9836c = 10;
var $1f99b77b45f30655$export$3a2f97d39514bbc = 9;
var $1f99b77b45f30655$export$df035d873a9de64f = 'highlight';
var $1f99b77b45f30655$export$f8a2f7807cc185ea = 'downplay';
var $1f99b77b45f30655$export$89616263e7d38fe9 = 'select';
var $1f99b77b45f30655$export$7636ad95c0f68a79 = 'unselect';
var $1f99b77b45f30655$export$1e90ed8a25542516 = 'toggleSelect';
var $1f99b77b45f30655$export$67f8c62bcdfbd39f = 'selectchanged';
function $1f99b77b45f30655$var$hasFillOrStroke(fillOrStroke) {
    return fillOrStroke != null && fillOrStroke !== 'none';
}
function $1f99b77b45f30655$var$doChangeHoverState(el, stateName, hoverStateEnum) {
    if (el.onHoverStateChange && (el.hoverState || 0) !== hoverStateEnum) el.onHoverStateChange(stateName);
    el.hoverState = hoverStateEnum;
}
function $1f99b77b45f30655$var$singleEnterEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    $1f99b77b45f30655$var$doChangeHoverState(el, 'emphasis', $1f99b77b45f30655$export$f0f2bee145debb31);
}
function $1f99b77b45f30655$var$singleLeaveEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    if (el.hoverState === $1f99b77b45f30655$export$f0f2bee145debb31) $1f99b77b45f30655$var$doChangeHoverState(el, 'normal', $1f99b77b45f30655$export$5542daa30722333e);
}
function $1f99b77b45f30655$var$singleEnterBlur(el) {
    $1f99b77b45f30655$var$doChangeHoverState(el, 'blur', $1f99b77b45f30655$export$1307d6a87d56baa);
}
function $1f99b77b45f30655$var$singleLeaveBlur(el) {
    if (el.hoverState === $1f99b77b45f30655$export$1307d6a87d56baa) $1f99b77b45f30655$var$doChangeHoverState(el, 'normal', $1f99b77b45f30655$export$5542daa30722333e);
}
function $1f99b77b45f30655$var$singleEnterSelect(el) {
    el.selected = true;
}
function $1f99b77b45f30655$var$singleLeaveSelect(el) {
    el.selected = false;
}
function $1f99b77b45f30655$var$updateElementState(el, updater, commonParam) {
    updater(el, commonParam);
}
function $1f99b77b45f30655$var$traverseUpdateState(el, updater, commonParam) {
    $1f99b77b45f30655$var$updateElementState(el, updater, commonParam);
    el.isGroup && el.traverse(function(child) {
        $1f99b77b45f30655$var$updateElementState(child, updater, commonParam);
    });
}
function $1f99b77b45f30655$export$868ba38adffa9e39(el, stateName) {
    switch(stateName){
        case 'emphasis':
            el.hoverState = $1f99b77b45f30655$export$f0f2bee145debb31;
            break;
        case 'normal':
            el.hoverState = $1f99b77b45f30655$export$5542daa30722333e;
            break;
        case 'blur':
            el.hoverState = $1f99b77b45f30655$export$1307d6a87d56baa;
            break;
        case 'select':
            el.selected = true;
    }
}
function $1f99b77b45f30655$export$35330f949342a669(el) {
    if (el.isGroup) el.traverse(function(child) {
        child.clearStates();
    });
    else el.clearStates();
}
function $1f99b77b45f30655$var$getFromStateStyle(el, props, toStateName, defaultValue) {
    var style = el.style;
    var fromState = {};
    for(var i = 0; i < props.length; i++){
        var propName = props[i];
        var val = style[propName];
        fromState[propName] = val == null ? defaultValue && defaultValue[propName] : val;
    }
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.__fromStateTransition && animator.__fromStateTransition.indexOf(toStateName) < 0 && animator.targetName === 'style') animator.saveTo(fromState, props);
    }
    return fromState;
}
function $1f99b77b45f30655$var$createEmphasisDefaultState(el, stateName, targetStates, state) {
    var hasSelect = targetStates && (0, $f16f2994a32ad273$export$305f7d4e9d4624f2)(targetStates, 'select') >= 0;
    var cloned = false;
    if (el instanceof (0, $340211037b56ba3f$export$2e2bcd8739ae039)) {
        var store = $1f99b77b45f30655$var$getSavedStates(el);
        var fromFill = hasSelect ? store.selectFill || store.normalFill : store.normalFill;
        var fromStroke = hasSelect ? store.selectStroke || store.normalStroke : store.normalStroke;
        if ($1f99b77b45f30655$var$hasFillOrStroke(fromFill) || $1f99b77b45f30655$var$hasFillOrStroke(fromStroke)) {
            state = state || {};
            var emphasisStyle = state.style || {};
            // inherit case
            if (emphasisStyle.fill === 'inherit') {
                cloned = true;
                state = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, state);
                emphasisStyle = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, emphasisStyle);
                emphasisStyle.fill = fromFill;
            } else if (!$1f99b77b45f30655$var$hasFillOrStroke(emphasisStyle.fill) && $1f99b77b45f30655$var$hasFillOrStroke(fromFill)) {
                cloned = true;
                // Not modify the original value.
                state = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, state);
                emphasisStyle = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, emphasisStyle);
                // Already being applied 'emphasis'. DON'T lift color multiple times.
                emphasisStyle.fill = (0, $83e50b4ee4d3c357$export$2b47e247dfb87a73)(fromFill);
            } else if (!$1f99b77b45f30655$var$hasFillOrStroke(emphasisStyle.stroke) && $1f99b77b45f30655$var$hasFillOrStroke(fromStroke)) {
                if (!cloned) {
                    state = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, state);
                    emphasisStyle = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, emphasisStyle);
                }
                emphasisStyle.stroke = (0, $83e50b4ee4d3c357$export$2b47e247dfb87a73)(fromStroke);
            }
            state.style = emphasisStyle;
        }
    }
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            if (!cloned) state = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, state);
            var z2EmphasisLift = el.z2EmphasisLift;
            state.z2 = el.z2 + (z2EmphasisLift != null ? z2EmphasisLift : $1f99b77b45f30655$export$1cb9fc6ed5b9836c);
        }
    }
    return state;
}
function $1f99b77b45f30655$var$createSelectDefaultState(el, stateName, state) {
    // const hasSelect = indexOf(el.currentStates, stateName) >= 0;
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            state = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, state);
            var z2SelectLift = el.z2SelectLift;
            state.z2 = el.z2 + (z2SelectLift != null ? z2SelectLift : $1f99b77b45f30655$export$3a2f97d39514bbc);
        }
    }
    return state;
}
function $1f99b77b45f30655$var$createBlurDefaultState(el, stateName, state) {
    var hasBlur = (0, $f16f2994a32ad273$export$305f7d4e9d4624f2)(el.currentStates, stateName) >= 0;
    var currentOpacity = el.style.opacity;
    var fromState = !hasBlur ? $1f99b77b45f30655$var$getFromStateStyle(el, [
        'opacity'
    ], stateName, {
        opacity: 1
    }) : null;
    state = state || {};
    var blurStyle = state.style || {};
    if (blurStyle.opacity == null) {
        // clone state
        state = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, state);
        blurStyle = (0, $f16f2994a32ad273$export$8b58be045bf06082)({
            // Already being applied 'emphasis'. DON'T mul opacity multiple times.
            opacity: hasBlur ? currentOpacity : fromState.opacity * 0.1
        }, blurStyle);
        state.style = blurStyle;
    }
    return state;
}
function $1f99b77b45f30655$var$elementStateProxy(stateName, targetStates) {
    var state = this.states[stateName];
    if (this.style) {
        if (stateName === 'emphasis') return $1f99b77b45f30655$var$createEmphasisDefaultState(this, stateName, targetStates, state);
        else if (stateName === 'blur') return $1f99b77b45f30655$var$createBlurDefaultState(this, stateName, state);
        else if (stateName === 'select') return $1f99b77b45f30655$var$createSelectDefaultState(this, stateName, state);
    }
    return state;
}
function $1f99b77b45f30655$export$20f39bbe322fb9ab(el) {
    el.stateProxy = $1f99b77b45f30655$var$elementStateProxy;
    var textContent = el.getTextContent();
    var textGuide = el.getTextGuideLine();
    if (textContent) textContent.stateProxy = $1f99b77b45f30655$var$elementStateProxy;
    if (textGuide) textGuide.stateProxy = $1f99b77b45f30655$var$elementStateProxy;
}
function $1f99b77b45f30655$export$d899507e2598e4ae(el, e) {
    !$1f99b77b45f30655$var$shouldSilent(el, e) && !el.__highByOuter && $1f99b77b45f30655$var$traverseUpdateState(el, $1f99b77b45f30655$var$singleEnterEmphasis);
}
function $1f99b77b45f30655$export$784cba1f7fe58cca(el, e) {
    !$1f99b77b45f30655$var$shouldSilent(el, e) && !el.__highByOuter && $1f99b77b45f30655$var$traverseUpdateState(el, $1f99b77b45f30655$var$singleLeaveEmphasis);
}
function $1f99b77b45f30655$export$b2d02638cc34c042(el, highlightDigit) {
    el.__highByOuter |= 1 << (highlightDigit || 0);
    $1f99b77b45f30655$var$traverseUpdateState(el, $1f99b77b45f30655$var$singleEnterEmphasis);
}
function $1f99b77b45f30655$export$11be6f716239ac55(el, highlightDigit) {
    !(el.__highByOuter &= ~(1 << (highlightDigit || 0))) && $1f99b77b45f30655$var$traverseUpdateState(el, $1f99b77b45f30655$var$singleLeaveEmphasis);
}
function $1f99b77b45f30655$export$207f9cb3e1099375(el) {
    $1f99b77b45f30655$var$traverseUpdateState(el, $1f99b77b45f30655$var$singleEnterBlur);
}
function $1f99b77b45f30655$export$fd4a9ec75456d3c1(el) {
    $1f99b77b45f30655$var$traverseUpdateState(el, $1f99b77b45f30655$var$singleLeaveBlur);
}
function $1f99b77b45f30655$export$252d028dda8ef765(el) {
    $1f99b77b45f30655$var$traverseUpdateState(el, $1f99b77b45f30655$var$singleEnterSelect);
}
function $1f99b77b45f30655$export$ea9a904bd6e32bd3(el) {
    $1f99b77b45f30655$var$traverseUpdateState(el, $1f99b77b45f30655$var$singleLeaveSelect);
}
function $1f99b77b45f30655$var$shouldSilent(el, e) {
    return el.__highDownSilentOnTouch && e.zrByTouch;
}
function $1f99b77b45f30655$export$b2a593c7b5243584(api) {
    var model = api.getModel();
    var leaveBlurredSeries = [];
    var allComponentViews = [];
    model.eachComponent(function(componentType, componentModel) {
        var componentStates = $1f99b77b45f30655$var$getComponentStates(componentModel);
        var view = (0, $d64c00067dc939f7$export$2b32bcfeffd624a6)(api, componentModel);
        var isSeries = componentType === 'series';
        !isSeries && allComponentViews.push(view);
        if (componentStates.isBlured) {
            // Leave blur anyway
            view.group.traverse(function(child) {
                $1f99b77b45f30655$var$singleLeaveBlur(child);
            });
            isSeries && leaveBlurredSeries.push(componentModel);
        }
        componentStates.isBlured = false;
    });
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(allComponentViews, function(view) {
        if (view && view.toggleBlurSeries) view.toggleBlurSeries(leaveBlurredSeries, false, model);
    });
}
function $1f99b77b45f30655$export$7d399e067d6552e3(targetSeriesIndex, focus, blurScope, api) {
    var ecModel = api.getModel();
    blurScope = blurScope || 'coordinateSystem';
    function leaveBlurOfIndices(data, dataIndices) {
        for(var i = 0; i < dataIndices.length; i++){
            var itemEl = data.getItemGraphicEl(dataIndices[i]);
            itemEl && $1f99b77b45f30655$export$fd4a9ec75456d3c1(itemEl);
        }
    }
    if (targetSeriesIndex == null) return;
    if (!focus || focus === 'none') return;
    var targetSeriesModel = ecModel.getSeriesByIndex(targetSeriesIndex);
    var targetCoordSys = targetSeriesModel.coordinateSystem;
    if (targetCoordSys && targetCoordSys.master) targetCoordSys = targetCoordSys.master;
    var blurredSeries = [];
    ecModel.eachSeries(function(seriesModel) {
        var sameSeries = targetSeriesModel === seriesModel;
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.master) coordSys = coordSys.master;
        var sameCoordSys = coordSys && targetCoordSys ? coordSys === targetCoordSys : sameSeries; // If there is no coordinate system. use sameSeries instead.
        if (!// Not blur other series if blurScope series
        (blurScope === 'series' && !sameSeries || blurScope === 'coordinateSystem' && !sameCoordSys || focus === 'series' && sameSeries)) {
            var view = api.getViewOfSeriesModel(seriesModel);
            view.group.traverse(function(child) {
                // For the elements that have been triggered by other components,
                // and are still required to be highlighted,
                // because the current is directly forced to blur the element,
                // it will cause the focus self to be unable to highlight, so skip the blur of this element.
                if (child.__highByOuter && sameSeries && focus === 'self') return;
                $1f99b77b45f30655$var$singleEnterBlur(child);
            });
            if ((0, $f16f2994a32ad273$export$1e2f57719e155213)(focus)) leaveBlurOfIndices(seriesModel.getData(), focus);
            else if ((0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(focus)) {
                var dataTypes = (0, $f16f2994a32ad273$export$ed97f33186d4b816)(focus);
                for(var d = 0; d < dataTypes.length; d++)leaveBlurOfIndices(seriesModel.getData(dataTypes[d]), focus[dataTypes[d]]);
            }
            blurredSeries.push(seriesModel);
            $1f99b77b45f30655$var$getComponentStates(seriesModel).isBlured = true;
        }
    });
    ecModel.eachComponent(function(componentType, componentModel) {
        if (componentType === 'series') return;
        var view = api.getViewOfComponentModel(componentModel);
        if (view && view.toggleBlurSeries) view.toggleBlurSeries(blurredSeries, true, ecModel);
    });
}
function $1f99b77b45f30655$export$569da03256c8a55f(componentMainType, componentIndex, api) {
    if (componentMainType == null || componentIndex == null) return;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return;
    $1f99b77b45f30655$var$getComponentStates(componentModel).isBlured = true;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.focusBlurEnabled) return;
    view.group.traverse(function(child) {
        $1f99b77b45f30655$var$singleEnterBlur(child);
    });
}
function $1f99b77b45f30655$export$64f1fd4daefef21b(seriesModel, payload, api) {
    var seriesIndex = seriesModel.seriesIndex;
    var data = seriesModel.getData(payload.dataType);
    if (!data) return;
    var dataIndex = (0, $3fa81475350067fd$export$42b26cae8b8d10)(data, payload);
    // Pick the first one if there is multiple/none exists.
    dataIndex = ((0, $f16f2994a32ad273$export$43bee75e5e14138e)(dataIndex) ? dataIndex[0] : dataIndex) || 0;
    var el = data.getItemGraphicEl(dataIndex);
    if (!el) {
        var count = data.count();
        var current = 0;
        // If data on dataIndex is NaN.
        while(!el && current < count)el = data.getItemGraphicEl(current++);
    }
    if (el) {
        var ecData = (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(el);
        $1f99b77b45f30655$export$7d399e067d6552e3(seriesIndex, ecData.focus, ecData.blurScope, api);
    } else {
        // If there is no element put on the data. Try getting it from raw option
        // TODO Should put it on seriesModel?
        var focus_1 = seriesModel.get([
            'emphasis',
            'focus'
        ]);
        var blurScope = seriesModel.get([
            'emphasis',
            'blurScope'
        ]);
        if (focus_1 != null) $1f99b77b45f30655$export$7d399e067d6552e3(seriesIndex, focus_1, blurScope, api);
    }
}
function $1f99b77b45f30655$export$f31a644ccca0ef23(componentMainType, componentIndex, name, api) {
    var ret = {
        focusSelf: false,
        dispatchers: null
    };
    if (componentMainType == null || componentMainType === 'series' || componentIndex == null || name == null) return ret;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return ret;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.findHighDownDispatchers) return ret;
    var dispatchers = view.findHighDownDispatchers(name);
    // At presnet, the component (like Geo) only blur inside itself.
    // So we do not use `blurScope` in component.
    var focusSelf;
    for(var i = 0; i < dispatchers.length; i++)if ((0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(dispatchers[i]).focus === 'self') {
        focusSelf = true;
        break;
    }
    return {
        focusSelf: focusSelf,
        dispatchers: dispatchers
    };
}
function $1f99b77b45f30655$export$416765b6198234ff(dispatcher, e, api) {
    var ecData = (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(dispatcher);
    var _a = $1f99b77b45f30655$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api), dispatchers = _a.dispatchers, focusSelf = _a.focusSelf;
    // If `findHighDownDispatchers` is supported on the component,
    // highlight/downplay elements with the same name.
    if (dispatchers) {
        if (focusSelf) $1f99b77b45f30655$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
            return $1f99b77b45f30655$export$d899507e2598e4ae(dispatcher, e);
        });
    } else {
        // Try blur all in the related series. Then emphasis the hoverred.
        // TODO. progressive mode.
        $1f99b77b45f30655$export$7d399e067d6552e3(ecData.seriesIndex, ecData.focus, ecData.blurScope, api);
        if (ecData.focus === 'self') $1f99b77b45f30655$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        // Other than series, component that not support `findHighDownDispatcher` will
        // also use it. But in this case, highlight/downplay are only supported in
        // mouse hover but not in dispatchAction.
        $1f99b77b45f30655$export$d899507e2598e4ae(dispatcher, e);
    }
}
function $1f99b77b45f30655$export$bb1c7b62436282a(dispatcher, e, api) {
    $1f99b77b45f30655$export$b2a593c7b5243584(api);
    var ecData = (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(dispatcher);
    var dispatchers = $1f99b77b45f30655$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api).dispatchers;
    if (dispatchers) (0, $f16f2994a32ad273$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
        return $1f99b77b45f30655$export$784cba1f7fe58cca(dispatcher, e);
    });
    else $1f99b77b45f30655$export$784cba1f7fe58cca(dispatcher, e);
}
function $1f99b77b45f30655$export$1c7d489f62372d73(seriesModel, payload, api) {
    if (!$1f99b77b45f30655$export$72aea10e60e45351(payload)) return;
    var dataType = payload.dataType;
    var data = seriesModel.getData(dataType);
    var dataIndex = (0, $3fa81475350067fd$export$42b26cae8b8d10)(data, payload);
    if (!(0, $f16f2994a32ad273$export$43bee75e5e14138e)(dataIndex)) dataIndex = [
        dataIndex
    ];
    seriesModel[payload.type === $1f99b77b45f30655$export$1e90ed8a25542516 ? 'toggleSelect' : payload.type === $1f99b77b45f30655$export$89616263e7d38fe9 ? 'select' : 'unselect'](dataIndex, dataType);
}
function $1f99b77b45f30655$export$e4ea08ef52e0a73(seriesModel) {
    var allData = seriesModel.getAllData();
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(allData, function(_a) {
        var data = _a.data, type = _a.type;
        data.eachItemGraphicEl(function(el, idx) {
            seriesModel.isSelected(idx, type) ? $1f99b77b45f30655$export$252d028dda8ef765(el) : $1f99b77b45f30655$export$ea9a904bd6e32bd3(el);
        });
    });
}
function $1f99b77b45f30655$export$c529643b619af6b3(ecModel) {
    var ret = [];
    ecModel.eachSeries(function(seriesModel) {
        var allData = seriesModel.getAllData();
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(allData, function(_a) {
            var data = _a.data, type = _a.type;
            var dataIndices = seriesModel.getSelectedDataIndices();
            if (dataIndices.length > 0) {
                var item = {
                    dataIndex: dataIndices,
                    seriesIndex: seriesModel.seriesIndex
                };
                if (type != null) item.dataType = type;
                ret.push(item);
            }
        });
    });
    return ret;
}
function $1f99b77b45f30655$export$5f393df0b5aee2e7(el, focus, blurScope) {
    $1f99b77b45f30655$export$9ba15aea1e048d48(el, true);
    $1f99b77b45f30655$var$traverseUpdateState(el, $1f99b77b45f30655$export$20f39bbe322fb9ab);
    $1f99b77b45f30655$export$24972466b2b62ac2(el, focus, blurScope);
}
function $1f99b77b45f30655$export$912cae7b47c8e437(el) {
    $1f99b77b45f30655$export$9ba15aea1e048d48(el, false);
}
function $1f99b77b45f30655$export$e51187539ff11209(el, focus, blurScope, isDisabled) {
    isDisabled ? $1f99b77b45f30655$export$912cae7b47c8e437(el) : $1f99b77b45f30655$export$5f393df0b5aee2e7(el, focus, blurScope);
}
function $1f99b77b45f30655$export$24972466b2b62ac2(el, focus, blurScope) {
    var ecData = (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(el);
    if (focus != null) {
        // TODO dataIndex may be set after this function. This check is not useful.
        // if (ecData.dataIndex == null) {
        //     if (__DEV__) {
        //         console.warn('focus can only been set on element with dataIndex');
        //     }
        // }
        // else {
        ecData.focus = focus;
        ecData.blurScope = blurScope;
    // }
    } else if (ecData.focus) ecData.focus = null;
}
var $1f99b77b45f30655$var$OTHER_STATES = [
    'emphasis',
    'blur',
    'select'
];
var $1f99b77b45f30655$var$defaultStyleGetterMap = {
    itemStyle: 'getItemStyle',
    lineStyle: 'getLineStyle',
    areaStyle: 'getAreaStyle'
};
function $1f99b77b45f30655$export$48b68047d330bbc9(el, itemModel, styleType, // default itemStyle
getter) {
    styleType = styleType || 'itemStyle';
    for(var i = 0; i < $1f99b77b45f30655$var$OTHER_STATES.length; i++){
        var stateName = $1f99b77b45f30655$var$OTHER_STATES[i];
        var model = itemModel.getModel([
            stateName,
            styleType
        ]);
        var state = el.ensureState(stateName);
        // Let it throw error if getterType is not found.
        state.style = getter ? getter(model) : model[$1f99b77b45f30655$var$defaultStyleGetterMap[styleType]]();
    }
}
function $1f99b77b45f30655$export$9ba15aea1e048d48(el, asDispatcher) {
    var disable = asDispatcher === false;
    var extendedEl = el;
    // Make `highDownSilentOnTouch` and `onStateChange` only work after
    // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.
    if (el.highDownSilentOnTouch) extendedEl.__highDownSilentOnTouch = el.highDownSilentOnTouch;
    // Simple optimize, since this method might be
    // called for each elements of a group in some cases.
    if (!disable || extendedEl.__highDownDispatcher) {
        // Emphasis, normal can be triggered manually by API or other components like hover link.
        // el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent);
        // Also keep previous record.
        extendedEl.__highByOuter = extendedEl.__highByOuter || 0;
        extendedEl.__highDownDispatcher = !disable;
    }
}
function $1f99b77b45f30655$export$77d1445f699c58b5(el) {
    return !!(el && el.__highDownDispatcher);
}
function $1f99b77b45f30655$export$4da05a9639f01954(el, componentModel, componentHighDownName) {
    var ecData = (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(el);
    ecData.componentMainType = componentModel.mainType;
    ecData.componentIndex = componentModel.componentIndex;
    ecData.componentHighDownName = componentHighDownName;
}
function $1f99b77b45f30655$export$824af40eb714530d(highlightKey) {
    var highlightDigit = $1f99b77b45f30655$var$_highlightKeyMap[highlightKey];
    if (highlightDigit == null && $1f99b77b45f30655$var$_highlightNextDigit <= 32) highlightDigit = $1f99b77b45f30655$var$_highlightKeyMap[highlightKey] = $1f99b77b45f30655$var$_highlightNextDigit++;
    return highlightDigit;
}
function $1f99b77b45f30655$export$72aea10e60e45351(payload) {
    var payloadType = payload.type;
    return payloadType === $1f99b77b45f30655$export$89616263e7d38fe9 || payloadType === $1f99b77b45f30655$export$7636ad95c0f68a79 || payloadType === $1f99b77b45f30655$export$1e90ed8a25542516;
}
function $1f99b77b45f30655$export$aebe71265c1b77bf(payload) {
    var payloadType = payload.type;
    return payloadType === $1f99b77b45f30655$export$df035d873a9de64f || payloadType === $1f99b77b45f30655$export$f8a2f7807cc185ea;
}
function $1f99b77b45f30655$export$9fe78019e6f395b6(el) {
    var store = $1f99b77b45f30655$var$getSavedStates(el);
    store.normalFill = el.style.fill;
    store.normalStroke = el.style.stroke;
    var selectState = el.states.select || {};
    store.selectFill = selectState.style && selectState.style.fill || null;
    store.selectStroke = selectState.style && selectState.style.stroke || null;
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $d2a962ec0ef14a79$export$ae7433df314f6ec3 = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
function $d2a962ec0ef14a79$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, // Extra opts can override the option in animatable model.
extraOpts, // TODO It's only for pictorial bar now.
extraDelayParams) {
    var animationPayload;
    // Check if there is global animation configuration from dataZoom/resize can override the config in option.
    // If animation is enabled. Will use this animation config in payload.
    // If animation is disabled. Just ignore it.
    if (animatableModel && animatableModel.ecModel) {
        var updatePayload = animatableModel.ecModel.getUpdatePayload();
        animationPayload = updatePayload && updatePayload.animation;
    }
    var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
    var isUpdate = animationType === 'update';
    if (animationEnabled) {
        var duration = void 0;
        var easing = void 0;
        var delay = void 0;
        if (extraOpts) {
            duration = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(extraOpts.duration, 200);
            easing = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(extraOpts.easing, 'cubicOut');
            delay = 0;
        } else {
            duration = animatableModel.getShallow(isUpdate ? 'animationDurationUpdate' : 'animationDuration');
            easing = animatableModel.getShallow(isUpdate ? 'animationEasingUpdate' : 'animationEasing');
            delay = animatableModel.getShallow(isUpdate ? 'animationDelayUpdate' : 'animationDelay');
        }
        // animation from payload has highest priority.
        if (animationPayload) {
            animationPayload.duration != null && (duration = animationPayload.duration);
            animationPayload.easing != null && (easing = animationPayload.easing);
            animationPayload.delay != null && (delay = animationPayload.delay);
        }
        if ((0, $f16f2994a32ad273$export$f6e2535fb5126e54)(delay)) delay = delay(dataIndex, extraDelayParams);
        if ((0, $f16f2994a32ad273$export$f6e2535fb5126e54)(duration)) duration = duration(dataIndex);
        var config = {
            duration: duration || 0,
            delay: delay,
            easing: easing
        };
        return config;
    } else return null;
}
function $d2a962ec0ef14a79$var$animateOrSetProps(animationType, el, props, animatableModel, dataIndex, cb, during) {
    var isFrom = false;
    var removeOpt;
    if ((0, $f16f2994a32ad273$export$f6e2535fb5126e54)(dataIndex)) {
        during = cb;
        cb = dataIndex;
        dataIndex = null;
    } else if ((0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(dataIndex)) {
        cb = dataIndex.cb;
        during = dataIndex.during;
        isFrom = dataIndex.isFrom;
        removeOpt = dataIndex.removeOpt;
        dataIndex = dataIndex.dataIndex;
    }
    var isRemove = animationType === 'leave';
    if (!isRemove) // Must stop the remove animation.
    el.stopAnimation('leave');
    var animationConfig = $d2a962ec0ef14a79$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, isRemove ? removeOpt || {} : null, animatableModel && animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
    if (animationConfig && animationConfig.duration > 0) {
        var duration = animationConfig.duration;
        var animationDelay = animationConfig.delay;
        var animationEasing = animationConfig.easing;
        var animateConfig = {
            duration: duration,
            delay: animationDelay || 0,
            easing: animationEasing,
            done: cb,
            force: !!cb || !!during,
            // Set to final state in update/init animation.
            // So the post processing based on the path shape can be done correctly.
            setToFinal: !isRemove,
            scope: animationType,
            during: during
        };
        isFrom ? el.animateFrom(props, animateConfig) : el.animateTo(props, animateConfig);
    } else {
        el.stopAnimation();
        // If `isFrom`, the props is the "from" props.
        !isFrom && el.attr(props);
        // Call during at least once.
        during && during(1);
        cb && cb();
    }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */ function $d2a962ec0ef14a79$export$c8dce3c08436e91e(el, props, // TODO: TYPE AnimatableModel
animatableModel, dataIndex, cb, during) {
    $d2a962ec0ef14a79$var$animateOrSetProps('update', el, props, animatableModel, dataIndex, cb, during);
}
function $d2a962ec0ef14a79$export$a121566aadcfe021(el, props, animatableModel, dataIndex, cb, during) {
    $d2a962ec0ef14a79$var$animateOrSetProps('enter', el, props, animatableModel, dataIndex, cb, during);
}
function $d2a962ec0ef14a79$export$5b89d4b643713034(el) {
    if (!el.__zr) return true;
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.scope === 'leave') return true;
    }
    return false;
}
function $d2a962ec0ef14a79$export$f883456a56996078(el, props, animatableModel, dataIndex, cb, during) {
    // Don't do remove animation twice.
    if ($d2a962ec0ef14a79$export$5b89d4b643713034(el)) return;
    $d2a962ec0ef14a79$var$animateOrSetProps('leave', el, props, animatableModel, dataIndex, cb, during);
}
function $d2a962ec0ef14a79$var$fadeOutDisplayable(el, animatableModel, dataIndex, done) {
    el.removeTextContent();
    el.removeTextGuideLine();
    $d2a962ec0ef14a79$export$f883456a56996078(el, {
        style: {
            opacity: 0
        }
    }, animatableModel, dataIndex, done);
}
function $d2a962ec0ef14a79$export$6d0fd725cb4aee8a(el, animatableModel, dataIndex) {
    function doRemove() {
        el.parent && el.parent.remove(el);
    }
    // Hide label and labelLine first
    // TODO Also use fade out animation?
    if (!el.isGroup) $d2a962ec0ef14a79$var$fadeOutDisplayable(el, animatableModel, dataIndex, doRemove);
    else el.traverse(function(disp) {
        if (!disp.isGroup) // Can invoke doRemove multiple times.
        $d2a962ec0ef14a79$var$fadeOutDisplayable(disp, animatableModel, dataIndex, doRemove);
    });
}
function $d2a962ec0ef14a79$export$bca7290a9faf0ec9(el) {
    $d2a962ec0ef14a79$export$ae7433df314f6ec3(el).oldStyle = el.style;
}
function $d2a962ec0ef14a79$export$ccb1f1e4d2fa86ac(el) {
    return $d2a962ec0ef14a79$export$ae7433df314f6ec3(el).oldStyle;
}

var $bce1f681c7fb2581$exports = {};

$parcel$export($bce1f681c7fb2581$exports, "XY", function () { return $bce1f681c7fb2581$export$cb4c12294149dd2d; });
$parcel$export($bce1f681c7fb2581$exports, "WH", function () { return $bce1f681c7fb2581$export$a3fe6d967173a3ac; });
$parcel$export($bce1f681c7fb2581$exports, "HOVER_LAYER_NO", function () { return $bce1f681c7fb2581$export$3e67317617241636; });
$parcel$export($bce1f681c7fb2581$exports, "HOVER_LAYER_FROM_THRESHOLD", function () { return $bce1f681c7fb2581$export$3c339ce201e4ce4d; });
$parcel$export($bce1f681c7fb2581$exports, "HOVER_LAYER_FOR_INCREMENTAL", function () { return $bce1f681c7fb2581$export$2ed770cec6ef78e8; });
$parcel$export($bce1f681c7fb2581$exports, "extendShape", function () { return $bce1f681c7fb2581$export$d0d5398c9d612037; });
$parcel$export($bce1f681c7fb2581$exports, "extendPath", function () { return $bce1f681c7fb2581$export$53b54a3137026af0; });
$parcel$export($bce1f681c7fb2581$exports, "registerShape", function () { return $bce1f681c7fb2581$export$2b95b62e3aaf6fdd; });
$parcel$export($bce1f681c7fb2581$exports, "getShapeClass", function () { return $bce1f681c7fb2581$export$51df4b5565a58189; });
$parcel$export($bce1f681c7fb2581$exports, "makePath", function () { return $bce1f681c7fb2581$export$aa9bab72412f5613; });
$parcel$export($bce1f681c7fb2581$exports, "resizePath", function () { return $bce1f681c7fb2581$export$566dbf1c62b04fc7; });
$parcel$export($bce1f681c7fb2581$exports, "makeImage", function () { return $bce1f681c7fb2581$export$7a2bdede98851ac5; });
$parcel$export($bce1f681c7fb2581$exports, "mergePath", function () { return $bce1f681c7fb2581$export$7b1dd269fbc4e903; });
$parcel$export($bce1f681c7fb2581$exports, "subPixelOptimizeLine", function () { return $bce1f681c7fb2581$export$8b4b620d7f4aad1b; });
$parcel$export($bce1f681c7fb2581$exports, "subPixelOptimizeRect", function () { return $bce1f681c7fb2581$export$60e2aa74957d0b9d; });
$parcel$export($bce1f681c7fb2581$exports, "subPixelOptimize", function () { return $bce1f681c7fb2581$export$72c4fd4c1b8fcb10; });
$parcel$export($bce1f681c7fb2581$exports, "getTransform", function () { return $bce1f681c7fb2581$export$fce0c6cfca85ed96; });
$parcel$export($bce1f681c7fb2581$exports, "applyTransform", function () { return $bce1f681c7fb2581$export$9f9dcb98c894b623; });
$parcel$export($bce1f681c7fb2581$exports, "transformDirection", function () { return $bce1f681c7fb2581$export$fff94e9792354cfa; });
$parcel$export($bce1f681c7fb2581$exports, "groupTransition", function () { return $bce1f681c7fb2581$export$64fcab7860c216ae; });
$parcel$export($bce1f681c7fb2581$exports, "clipPointsByRect", function () { return $bce1f681c7fb2581$export$e2f409471bbbc1dc; });
$parcel$export($bce1f681c7fb2581$exports, "clipRectByRect", function () { return $bce1f681c7fb2581$export$d0d3709202b8b2a; });
$parcel$export($bce1f681c7fb2581$exports, "createIcon", function () { return $bce1f681c7fb2581$export$274edc73af1ae9c8; });
$parcel$export($bce1f681c7fb2581$exports, "linePolygonIntersect", function () { return $bce1f681c7fb2581$export$4f47c855a5e9ae9; });
$parcel$export($bce1f681c7fb2581$exports, "lineLineIntersect", function () { return $bce1f681c7fb2581$export$6c0a70ea1d8d158b; });
$parcel$export($bce1f681c7fb2581$exports, "expandOrShrinkRect", function () { return $bce1f681c7fb2581$export$81ed941fdeb91c7c; });
$parcel$export($bce1f681c7fb2581$exports, "setTooltipConfig", function () { return $bce1f681c7fb2581$export$fc6410d97fab306c; });
$parcel$export($bce1f681c7fb2581$exports, "traverseElements", function () { return $bce1f681c7fb2581$export$3e564442729bf048; });
$parcel$export($bce1f681c7fb2581$exports, "isBoundingRectAxisAligned", function () { return $bce1f681c7fb2581$export$576610ccf2234b72; });
$parcel$export($bce1f681c7fb2581$exports, "ensureCopyRect", function () { return $bce1f681c7fb2581$export$38128dfd9a498e1; });
$parcel$export($bce1f681c7fb2581$exports, "ensureCopyTransform", function () { return $bce1f681c7fb2581$export$4d61283a070e0362; });
$parcel$export($bce1f681c7fb2581$exports, "retrieveZInfo", function () { return $bce1f681c7fb2581$export$1500a631bea5adda; });
$parcel$export($bce1f681c7fb2581$exports, "calcZ2Range", function () { return $bce1f681c7fb2581$export$8215ea00957327f2; });
$parcel$export($bce1f681c7fb2581$exports, "traverseUpdateZ", function () { return $bce1f681c7fb2581$export$d31cf465bf5e8879; });
$parcel$export($bce1f681c7fb2581$exports, "payloadDisableAnimation", function () { return $bce1f681c7fb2581$export$6f963a8600ad6f65; });
$parcel$export($bce1f681c7fb2581$exports, "decomposeTransform", function () { return $bce1f681c7fb2581$export$31f224ae9d6cf05; });
$parcel$export($bce1f681c7fb2581$exports, "getCurrentCanvasPainter", function () { return $bce1f681c7fb2581$export$e8e725f22cc8ef79; });
$parcel$export($bce1f681c7fb2581$exports, "updateProps", function () { return $d2a962ec0ef14a79$export$c8dce3c08436e91e; });
$parcel$export($bce1f681c7fb2581$exports, "initProps", function () { return $d2a962ec0ef14a79$export$a121566aadcfe021; });
$parcel$export($bce1f681c7fb2581$exports, "removeElement", function () { return $d2a962ec0ef14a79$export$f883456a56996078; });
$parcel$export($bce1f681c7fb2581$exports, "removeElementWithFadeOut", function () { return $d2a962ec0ef14a79$export$6d0fd725cb4aee8a; });
$parcel$export($bce1f681c7fb2581$exports, "isElementRemoved", function () { return $d2a962ec0ef14a79$export$5b89d4b643713034; });
$parcel$export($bce1f681c7fb2581$exports, "Group", function () { return $ac4abc1f547da31a$export$2e2bcd8739ae039; });
$parcel$export($bce1f681c7fb2581$exports, "Image", function () { return $0eafea320dbd53c3$export$2e2bcd8739ae039; });
$parcel$export($bce1f681c7fb2581$exports, "Text", function () { return $7d5e7dc1581f8c9a$export$2e2bcd8739ae039; });
$parcel$export($bce1f681c7fb2581$exports, "Circle", function () { return $f13962e4d5359f74$export$2e2bcd8739ae039; });
$parcel$export($bce1f681c7fb2581$exports, "Ellipse", function () { return $e7be948e8683a5c2$export$2e2bcd8739ae039; });
$parcel$export($bce1f681c7fb2581$exports, "Sector", function () { return $ace53cc79acf5001$export$2e2bcd8739ae039; });
$parcel$export($bce1f681c7fb2581$exports, "Ring", function () { return $c9630773534abab3$export$2e2bcd8739ae039; });
$parcel$export($bce1f681c7fb2581$exports, "Polygon", function () { return $a1bff28286a546ce$export$2e2bcd8739ae039; });
$parcel$export($bce1f681c7fb2581$exports, "Polyline", function () { return $481bc99c69021e4e$export$2e2bcd8739ae039; });
$parcel$export($bce1f681c7fb2581$exports, "Rect", function () { return $dbd6d77105f10fb2$export$2e2bcd8739ae039; });
$parcel$export($bce1f681c7fb2581$exports, "Line", function () { return $b37b447960e3414d$export$2e2bcd8739ae039; });
$parcel$export($bce1f681c7fb2581$exports, "BezierCurve", function () { return $d2a6ba6dfef20f23$export$2e2bcd8739ae039; });
$parcel$export($bce1f681c7fb2581$exports, "Arc", function () { return $770c52e9ca54b6a3$export$2e2bcd8739ae039; });
$parcel$export($bce1f681c7fb2581$exports, "IncrementalDisplayable", function () { return $4242d9412345c769$export$2e2bcd8739ae039; });
$parcel$export($bce1f681c7fb2581$exports, "CompoundPath", function () { return $9a457b474ed23e1f$export$2e2bcd8739ae039; });
$parcel$export($bce1f681c7fb2581$exports, "LinearGradient", function () { return $25727ffd7c1a8e5b$export$2e2bcd8739ae039; });
$parcel$export($bce1f681c7fb2581$exports, "RadialGradient", function () { return $c65f9ddf1d9009ee$export$2e2bcd8739ae039; });
$parcel$export($bce1f681c7fb2581$exports, "BoundingRect", function () { return $7456366ce379c42e$export$2e2bcd8739ae039; });
$parcel$export($bce1f681c7fb2581$exports, "OrientedBoundingRect", function () { return $4498ebf6c695fdf7$export$2e2bcd8739ae039; });
$parcel$export($bce1f681c7fb2581$exports, "Point", function () { return $f82d35899f1caf18$export$2e2bcd8739ae039; });
$parcel$export($bce1f681c7fb2581$exports, "Path", function () { return $340211037b56ba3f$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $864310290a3fabca$var$CMD = (0, $af4d02a47e9b6a35$export$2e2bcd8739ae039).CMD;
var $864310290a3fabca$var$points = [
    [],
    [],
    []
];
var $864310290a3fabca$var$mathSqrt = Math.sqrt;
var $864310290a3fabca$var$mathAtan2 = Math.atan2;
function $864310290a3fabca$export$2e2bcd8739ae039(path, m) {
    if (!m) return;
    var data = path.data;
    var len = path.len();
    var cmd;
    var nPoint;
    var i;
    var j;
    var k;
    var p;
    var M = $864310290a3fabca$var$CMD.M;
    var C = $864310290a3fabca$var$CMD.C;
    var L = $864310290a3fabca$var$CMD.L;
    var R = $864310290a3fabca$var$CMD.R;
    var A = $864310290a3fabca$var$CMD.A;
    var Q = $864310290a3fabca$var$CMD.Q;
    for(i = 0, j = 0; i < len;){
        cmd = data[i++];
        j = i;
        nPoint = 0;
        switch(cmd){
            case M:
                nPoint = 1;
                break;
            case L:
                nPoint = 1;
                break;
            case C:
                nPoint = 3;
                break;
            case Q:
                nPoint = 2;
                break;
            case A:
                var x = m[4];
                var y = m[5];
                var sx = $864310290a3fabca$var$mathSqrt(m[0] * m[0] + m[1] * m[1]);
                var sy = $864310290a3fabca$var$mathSqrt(m[2] * m[2] + m[3] * m[3]);
                var angle = $864310290a3fabca$var$mathAtan2(-m[1] / sy, m[0] / sx);
                data[i] *= sx;
                data[i++] += x;
                data[i] *= sy;
                data[i++] += y;
                data[i++] *= sx;
                data[i++] *= sy;
                data[i++] += angle;
                data[i++] += angle;
                i += 2;
                j = i;
                break;
            case R:
                p[0] = data[i++];
                p[1] = data[i++];
                (0, $f79ec7ea1294b339$export$9f9dcb98c894b623)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
                p[0] += data[i++];
                p[1] += data[i++];
                (0, $f79ec7ea1294b339$export$9f9dcb98c894b623)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
        }
        for(k = 0; k < nPoint; k++){
            var p_1 = $864310290a3fabca$var$points[k];
            p_1[0] = data[i++];
            p_1[1] = data[i++];
            (0, $f79ec7ea1294b339$export$9f9dcb98c894b623)(p_1, p_1, m);
            data[j++] = p_1[0];
            data[j++] = p_1[1];
        }
    }
    path.increaseVersion();
}



var $3b24c4cdba9faafa$var$mathSqrt = Math.sqrt;
var $3b24c4cdba9faafa$var$mathSin = Math.sin;
var $3b24c4cdba9faafa$var$mathCos = Math.cos;
var $3b24c4cdba9faafa$var$PI = Math.PI;
function $3b24c4cdba9faafa$var$vMag(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
}
function $3b24c4cdba9faafa$var$vRatio(u, v) {
    return (u[0] * v[0] + u[1] * v[1]) / ($3b24c4cdba9faafa$var$vMag(u) * $3b24c4cdba9faafa$var$vMag(v));
}
function $3b24c4cdba9faafa$var$vAngle(u, v) {
    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos($3b24c4cdba9faafa$var$vRatio(u, v));
}
function $3b24c4cdba9faafa$var$processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
    var psi = psiDeg * ($3b24c4cdba9faafa$var$PI / 180.0);
    var xp = $3b24c4cdba9faafa$var$mathCos(psi) * (x1 - x2) / 2.0 + $3b24c4cdba9faafa$var$mathSin(psi) * (y1 - y2) / 2.0;
    var yp = -1 * $3b24c4cdba9faafa$var$mathSin(psi) * (x1 - x2) / 2.0 + $3b24c4cdba9faafa$var$mathCos(psi) * (y1 - y2) / 2.0;
    var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
    if (lambda > 1) {
        rx *= $3b24c4cdba9faafa$var$mathSqrt(lambda);
        ry *= $3b24c4cdba9faafa$var$mathSqrt(lambda);
    }
    var f = (fa === fs ? -1 : 1) * $3b24c4cdba9faafa$var$mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
    var cxp = f * rx * yp / ry;
    var cyp = f * -ry * xp / rx;
    var cx = (x1 + x2) / 2.0 + $3b24c4cdba9faafa$var$mathCos(psi) * cxp - $3b24c4cdba9faafa$var$mathSin(psi) * cyp;
    var cy = (y1 + y2) / 2.0 + $3b24c4cdba9faafa$var$mathSin(psi) * cxp + $3b24c4cdba9faafa$var$mathCos(psi) * cyp;
    var theta = $3b24c4cdba9faafa$var$vAngle([
        1,
        0
    ], [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ]);
    var u = [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ];
    var v = [
        (-1 * xp - cxp) / rx,
        (-1 * yp - cyp) / ry
    ];
    var dTheta = $3b24c4cdba9faafa$var$vAngle(u, v);
    if ($3b24c4cdba9faafa$var$vRatio(u, v) <= -1) dTheta = $3b24c4cdba9faafa$var$PI;
    if ($3b24c4cdba9faafa$var$vRatio(u, v) >= 1) dTheta = 0;
    if (dTheta < 0) {
        var n = Math.round(dTheta / $3b24c4cdba9faafa$var$PI * 1e6) / 1e6;
        dTheta = $3b24c4cdba9faafa$var$PI * 2 + n % 2 * $3b24c4cdba9faafa$var$PI;
    }
    path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}
var $3b24c4cdba9faafa$var$commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig;
var $3b24c4cdba9faafa$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $3b24c4cdba9faafa$var$createPathProxyFromString(data) {
    var path = new (0, $af4d02a47e9b6a35$export$2e2bcd8739ae039)();
    if (!data) return path;
    var cpx = 0;
    var cpy = 0;
    var subpathX = cpx;
    var subpathY = cpy;
    var prevCmd;
    var CMD = (0, $af4d02a47e9b6a35$export$2e2bcd8739ae039).CMD;
    var cmdList = data.match($3b24c4cdba9faafa$var$commandReg);
    if (!cmdList) return path;
    for(var l = 0; l < cmdList.length; l++){
        var cmdText = cmdList[l];
        var cmdStr = cmdText.charAt(0);
        var cmd = void 0;
        var p = cmdText.match($3b24c4cdba9faafa$var$numberReg) || [];
        var pLen = p.length;
        for(var i = 0; i < pLen; i++)p[i] = parseFloat(p[i]);
        var off = 0;
        while(off < pLen){
            var ctlPtx = void 0;
            var ctlPty = void 0;
            var rx = void 0;
            var ry = void 0;
            var psi = void 0;
            var fa = void 0;
            var fs = void 0;
            var x1 = cpx;
            var y1 = cpy;
            var len = void 0;
            var pathData = void 0;
            switch(cmdStr){
                case 'l':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'L':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'm':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'l';
                    break;
                case 'M':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'L';
                    break;
                case 'h':
                    cpx += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'H':
                    cpx = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'v':
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'V':
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'C':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
                    cpx = p[off - 2];
                    cpy = p[off - 1];
                    break;
                case 'c':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
                    cpx += p[off - 2];
                    cpy += p[off - 1];
                    break;
                case 'S':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 's':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = cpx + p[off++];
                    y1 = cpy + p[off++];
                    cpx += p[off++];
                    cpy += p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 'Q':
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'q':
                    x1 = p[off++] + cpx;
                    y1 = p[off++] + cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'T':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 't':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 'A':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.A;
                    $3b24c4cdba9faafa$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
                case 'a':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.A;
                    $3b24c4cdba9faafa$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
            }
        }
        if (cmdStr === 'z' || cmdStr === 'Z') {
            cmd = CMD.Z;
            path.addData(cmd);
            cpx = subpathX;
            cpy = subpathY;
        }
        prevCmd = cmd;
    }
    path.toStatic();
    return path;
}
var $3b24c4cdba9faafa$var$SVGPath = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(SVGPath, _super);
    function SVGPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGPath.prototype.applyTransform = function(m) {};
    return SVGPath;
}((0, $340211037b56ba3f$export$2e2bcd8739ae039));
function $3b24c4cdba9faafa$var$isPathProxy(path) {
    return path.setData != null;
}
function $3b24c4cdba9faafa$var$createPathOptions(str, opts) {
    var pathProxy = $3b24c4cdba9faafa$var$createPathProxyFromString(str);
    var innerOpts = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, opts);
    innerOpts.buildPath = function(path) {
        var beProxy = $3b24c4cdba9faafa$var$isPathProxy(path);
        if (beProxy && path.canSave()) {
            path.appendPath(pathProxy);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        } else {
            var ctx = beProxy ? path.getContext() : path;
            if (ctx) pathProxy.rebuildPath(ctx, 1);
        }
    };
    innerOpts.applyTransform = function(m) {
        (0, $864310290a3fabca$export$2e2bcd8739ae039)(pathProxy, m);
        this.dirtyShape();
    };
    return innerOpts;
}
function $3b24c4cdba9faafa$export$ae5b259626f00aeb(str, opts) {
    return new $3b24c4cdba9faafa$var$SVGPath($3b24c4cdba9faafa$var$createPathOptions(str, opts));
}
function $3b24c4cdba9faafa$export$68e3a51ba2ed417c(str, defaultOpts) {
    var innerOpts = $3b24c4cdba9faafa$var$createPathOptions(str, defaultOpts);
    var Sub = function(_super) {
        (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Sub, _super);
        function Sub(opts) {
            var _this = _super.call(this, opts) || this;
            _this.applyTransform = innerOpts.applyTransform;
            _this.buildPath = innerOpts.buildPath;
            return _this;
        }
        return Sub;
    }($3b24c4cdba9faafa$var$SVGPath);
    return Sub;
}
function $3b24c4cdba9faafa$export$7b1dd269fbc4e903(pathEls, opts) {
    var pathList = [];
    var len = pathEls.length;
    for(var i = 0; i < len; i++){
        var pathEl = pathEls[i];
        pathList.push(pathEl.getUpdatedPathProxy(true));
    }
    var pathBundle = new (0, $340211037b56ba3f$export$2e2bcd8739ae039)(opts);
    pathBundle.createPathProxy();
    pathBundle.buildPath = function(path) {
        if ($3b24c4cdba9faafa$var$isPathProxy(path)) {
            path.appendPath(pathList);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        }
    };
    return pathBundle;
}
function $3b24c4cdba9faafa$export$18711d956bf1c3eb(sourcePath, opts) {
    opts = opts || {};
    var path = new (0, $340211037b56ba3f$export$2e2bcd8739ae039)();
    if (sourcePath.shape) path.setShape(sourcePath.shape);
    path.setStyle(sourcePath.style);
    if (opts.bakeTransform) (0, $864310290a3fabca$export$2e2bcd8739ae039)(path.path, sourcePath.getComputedTransform());
    else if (opts.toLocal) path.setLocalTransform(sourcePath.getComputedTransform());
    else path.copyTransform(sourcePath);
    path.buildPath = sourcePath.buildPath;
    path.applyTransform = path.applyTransform;
    path.z = sourcePath.z;
    path.z2 = sourcePath.z2;
    path.zlevel = sourcePath.zlevel;
    return path;
}











var $f13962e4d5359f74$export$2c0b65c9c7b57845 = function() {
    function CircleShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
    }
    return CircleShape;
}();
var $f13962e4d5359f74$var$Circle = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Circle, _super);
    function Circle(opts) {
        return _super.call(this, opts) || this;
    }
    Circle.prototype.getDefaultShape = function() {
        return new $f13962e4d5359f74$export$2c0b65c9c7b57845();
    };
    Circle.prototype.buildPath = function(ctx, shape) {
        ctx.moveTo(shape.cx + shape.r, shape.cy);
        ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2);
    };
    return Circle;
}((0, $340211037b56ba3f$export$2e2bcd8739ae039));
$f13962e4d5359f74$var$Circle.prototype.type = 'circle';
var $f13962e4d5359f74$export$2e2bcd8739ae039 = $f13962e4d5359f74$var$Circle;




var $e7be948e8683a5c2$export$817919dfe2806d31 = function() {
    function EllipseShape() {
        this.cx = 0;
        this.cy = 0;
        this.rx = 0;
        this.ry = 0;
    }
    return EllipseShape;
}();
var $e7be948e8683a5c2$var$Ellipse = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Ellipse, _super);
    function Ellipse(opts) {
        return _super.call(this, opts) || this;
    }
    Ellipse.prototype.getDefaultShape = function() {
        return new $e7be948e8683a5c2$export$817919dfe2806d31();
    };
    Ellipse.prototype.buildPath = function(ctx, shape) {
        var k = 0.5522848;
        var x = shape.cx;
        var y = shape.cy;
        var a = shape.rx;
        var b = shape.ry;
        var ox = a * k;
        var oy = b * k;
        ctx.moveTo(x - a, y);
        ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
        ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
        ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
        ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
        ctx.closePath();
    };
    return Ellipse;
}((0, $340211037b56ba3f$export$2e2bcd8739ae039));
$e7be948e8683a5c2$var$Ellipse.prototype.type = 'ellipse';
var $e7be948e8683a5c2$export$2e2bcd8739ae039 = $e7be948e8683a5c2$var$Ellipse;





var $52e5993aebe2f2b8$var$PI = Math.PI;
var $52e5993aebe2f2b8$var$PI2 = $52e5993aebe2f2b8$var$PI * 2;
var $52e5993aebe2f2b8$var$mathSin = Math.sin;
var $52e5993aebe2f2b8$var$mathCos = Math.cos;
var $52e5993aebe2f2b8$var$mathACos = Math.acos;
var $52e5993aebe2f2b8$var$mathATan2 = Math.atan2;
var $52e5993aebe2f2b8$var$mathAbs = Math.abs;
var $52e5993aebe2f2b8$var$mathSqrt = Math.sqrt;
var $52e5993aebe2f2b8$var$mathMax = Math.max;
var $52e5993aebe2f2b8$var$mathMin = Math.min;
var $52e5993aebe2f2b8$var$e = 1e-4;
function $52e5993aebe2f2b8$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var dx10 = x1 - x0;
    var dy10 = y1 - y0;
    var dx32 = x3 - x2;
    var dy32 = y3 - y2;
    var t = dy32 * dx10 - dx32 * dy10;
    if (t * t < $52e5993aebe2f2b8$var$e) return;
    t = (dx32 * (y0 - y2) - dy32 * (x0 - x2)) / t;
    return [
        x0 + t * dx10,
        y0 + t * dy10
    ];
}
function $52e5993aebe2f2b8$var$computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
    var x01 = x0 - x1;
    var y01 = y0 - y1;
    var lo = (clockwise ? cr : -cr) / $52e5993aebe2f2b8$var$mathSqrt(x01 * x01 + y01 * y01);
    var ox = lo * y01;
    var oy = -lo * x01;
    var x11 = x0 + ox;
    var y11 = y0 + oy;
    var x10 = x1 + ox;
    var y10 = y1 + oy;
    var x00 = (x11 + x10) / 2;
    var y00 = (y11 + y10) / 2;
    var dx = x10 - x11;
    var dy = y10 - y11;
    var d2 = dx * dx + dy * dy;
    var r = radius - cr;
    var s = x11 * y10 - x10 * y11;
    var d = (dy < 0 ? -1 : 1) * $52e5993aebe2f2b8$var$mathSqrt($52e5993aebe2f2b8$var$mathMax(0, r * r * d2 - s * s));
    var cx0 = (s * dy - dx * d) / d2;
    var cy0 = (-s * dx - dy * d) / d2;
    var cx1 = (s * dy + dx * d) / d2;
    var cy1 = (-s * dx + dy * d) / d2;
    var dx0 = cx0 - x00;
    var dy0 = cy0 - y00;
    var dx1 = cx1 - x00;
    var dy1 = cy1 - y00;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
        cx0 = cx1;
        cy0 = cy1;
    }
    return {
        cx: cx0,
        cy: cy0,
        x0: -ox,
        y0: -oy,
        x1: cx0 * (radius / r - 1),
        y1: cy0 * (radius / r - 1)
    };
}
function $52e5993aebe2f2b8$var$normalizeCornerRadius(cr) {
    var arr;
    if ((0, $f16f2994a32ad273$export$43bee75e5e14138e)(cr)) {
        var len = cr.length;
        if (!len) return cr;
        if (len === 1) arr = [
            cr[0],
            cr[0],
            0,
            0
        ];
        else if (len === 2) arr = [
            cr[0],
            cr[0],
            cr[1],
            cr[1]
        ];
        else if (len === 3) arr = cr.concat(cr[2]);
        else arr = cr;
    } else arr = [
        cr,
        cr,
        cr,
        cr
    ];
    return arr;
}
function $52e5993aebe2f2b8$export$5cc7f731b5937e99(ctx, shape) {
    var _a;
    var radius = $52e5993aebe2f2b8$var$mathMax(shape.r, 0);
    var innerRadius = $52e5993aebe2f2b8$var$mathMax(shape.r0 || 0, 0);
    var hasRadius = radius > 0;
    var hasInnerRadius = innerRadius > 0;
    if (!hasRadius && !hasInnerRadius) return;
    if (!hasRadius) {
        radius = innerRadius;
        innerRadius = 0;
    }
    if (innerRadius > radius) {
        var tmp = radius;
        radius = innerRadius;
        innerRadius = tmp;
    }
    var startAngle = shape.startAngle, endAngle = shape.endAngle;
    if (isNaN(startAngle) || isNaN(endAngle)) return;
    var cx = shape.cx, cy = shape.cy;
    var clockwise = !!shape.clockwise;
    var arc = $52e5993aebe2f2b8$var$mathAbs(endAngle - startAngle);
    var mod = arc > $52e5993aebe2f2b8$var$PI2 && arc % $52e5993aebe2f2b8$var$PI2;
    mod > $52e5993aebe2f2b8$var$e && (arc = mod);
    if (!(radius > $52e5993aebe2f2b8$var$e)) ctx.moveTo(cx, cy);
    else if (arc > $52e5993aebe2f2b8$var$PI2 - $52e5993aebe2f2b8$var$e) {
        ctx.moveTo(cx + radius * $52e5993aebe2f2b8$var$mathCos(startAngle), cy + radius * $52e5993aebe2f2b8$var$mathSin(startAngle));
        ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        if (innerRadius > $52e5993aebe2f2b8$var$e) {
            ctx.moveTo(cx + innerRadius * $52e5993aebe2f2b8$var$mathCos(endAngle), cy + innerRadius * $52e5993aebe2f2b8$var$mathSin(endAngle));
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    } else {
        var icrStart = void 0;
        var icrEnd = void 0;
        var ocrStart = void 0;
        var ocrEnd = void 0;
        var ocrs = void 0;
        var ocre = void 0;
        var icrs = void 0;
        var icre = void 0;
        var ocrMax = void 0;
        var icrMax = void 0;
        var limitedOcrMax = void 0;
        var limitedIcrMax = void 0;
        var xre = void 0;
        var yre = void 0;
        var xirs = void 0;
        var yirs = void 0;
        var xrs = radius * $52e5993aebe2f2b8$var$mathCos(startAngle);
        var yrs = radius * $52e5993aebe2f2b8$var$mathSin(startAngle);
        var xire = innerRadius * $52e5993aebe2f2b8$var$mathCos(endAngle);
        var yire = innerRadius * $52e5993aebe2f2b8$var$mathSin(endAngle);
        var hasArc = arc > $52e5993aebe2f2b8$var$e;
        if (hasArc) {
            var cornerRadius = shape.cornerRadius;
            if (cornerRadius) _a = $52e5993aebe2f2b8$var$normalizeCornerRadius(cornerRadius), icrStart = _a[0], icrEnd = _a[1], ocrStart = _a[2], ocrEnd = _a[3];
            var halfRd = $52e5993aebe2f2b8$var$mathAbs(radius - innerRadius) / 2;
            ocrs = $52e5993aebe2f2b8$var$mathMin(halfRd, ocrStart);
            ocre = $52e5993aebe2f2b8$var$mathMin(halfRd, ocrEnd);
            icrs = $52e5993aebe2f2b8$var$mathMin(halfRd, icrStart);
            icre = $52e5993aebe2f2b8$var$mathMin(halfRd, icrEnd);
            limitedOcrMax = ocrMax = $52e5993aebe2f2b8$var$mathMax(ocrs, ocre);
            limitedIcrMax = icrMax = $52e5993aebe2f2b8$var$mathMax(icrs, icre);
            if (ocrMax > $52e5993aebe2f2b8$var$e || icrMax > $52e5993aebe2f2b8$var$e) {
                xre = radius * $52e5993aebe2f2b8$var$mathCos(endAngle);
                yre = radius * $52e5993aebe2f2b8$var$mathSin(endAngle);
                xirs = innerRadius * $52e5993aebe2f2b8$var$mathCos(startAngle);
                yirs = innerRadius * $52e5993aebe2f2b8$var$mathSin(startAngle);
                if (arc < $52e5993aebe2f2b8$var$PI) {
                    var it_1 = $52e5993aebe2f2b8$var$intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
                    if (it_1) {
                        var x0 = xrs - it_1[0];
                        var y0 = yrs - it_1[1];
                        var x1 = xre - it_1[0];
                        var y1 = yre - it_1[1];
                        var a = 1 / $52e5993aebe2f2b8$var$mathSin($52e5993aebe2f2b8$var$mathACos((x0 * x1 + y0 * y1) / ($52e5993aebe2f2b8$var$mathSqrt(x0 * x0 + y0 * y0) * $52e5993aebe2f2b8$var$mathSqrt(x1 * x1 + y1 * y1))) / 2);
                        var b = $52e5993aebe2f2b8$var$mathSqrt(it_1[0] * it_1[0] + it_1[1] * it_1[1]);
                        limitedOcrMax = $52e5993aebe2f2b8$var$mathMin(ocrMax, (radius - b) / (a + 1));
                        limitedIcrMax = $52e5993aebe2f2b8$var$mathMin(icrMax, (innerRadius - b) / (a - 1));
                    }
                }
            }
        }
        if (!hasArc) ctx.moveTo(cx + xrs, cy + yrs);
        else if (limitedOcrMax > $52e5993aebe2f2b8$var$e) {
            var crStart = $52e5993aebe2f2b8$var$mathMin(ocrStart, limitedOcrMax);
            var crEnd = $52e5993aebe2f2b8$var$mathMin(ocrEnd, limitedOcrMax);
            var ct0 = $52e5993aebe2f2b8$var$computeCornerTangents(xirs, yirs, xrs, yrs, radius, crStart, clockwise);
            var ct1 = $52e5993aebe2f2b8$var$computeCornerTangents(xre, yre, xire, yire, radius, crEnd, clockwise);
            ctx.moveTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedOcrMax < ocrMax && crStart === crEnd) ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedOcrMax, $52e5993aebe2f2b8$var$mathATan2(ct0.y0, ct0.x0), $52e5993aebe2f2b8$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            else {
                crStart > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crStart, $52e5993aebe2f2b8$var$mathATan2(ct0.y0, ct0.x0), $52e5993aebe2f2b8$var$mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, radius, $52e5993aebe2f2b8$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), $52e5993aebe2f2b8$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), !clockwise);
                crEnd > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crEnd, $52e5993aebe2f2b8$var$mathATan2(ct1.y1, ct1.x1), $52e5993aebe2f2b8$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        } else {
            ctx.moveTo(cx + xrs, cy + yrs);
            ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        }
        if (!(innerRadius > $52e5993aebe2f2b8$var$e) || !hasArc) ctx.lineTo(cx + xire, cy + yire);
        else if (limitedIcrMax > $52e5993aebe2f2b8$var$e) {
            var crStart = $52e5993aebe2f2b8$var$mathMin(icrStart, limitedIcrMax);
            var crEnd = $52e5993aebe2f2b8$var$mathMin(icrEnd, limitedIcrMax);
            var ct0 = $52e5993aebe2f2b8$var$computeCornerTangents(xire, yire, xre, yre, innerRadius, -crEnd, clockwise);
            var ct1 = $52e5993aebe2f2b8$var$computeCornerTangents(xrs, yrs, xirs, yirs, innerRadius, -crStart, clockwise);
            ctx.lineTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedIcrMax < icrMax && crStart === crEnd) ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedIcrMax, $52e5993aebe2f2b8$var$mathATan2(ct0.y0, ct0.x0), $52e5993aebe2f2b8$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            else {
                crEnd > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crEnd, $52e5993aebe2f2b8$var$mathATan2(ct0.y0, ct0.x0), $52e5993aebe2f2b8$var$mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, innerRadius, $52e5993aebe2f2b8$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), $52e5993aebe2f2b8$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), clockwise);
                crStart > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crStart, $52e5993aebe2f2b8$var$mathATan2(ct1.y1, ct1.x1), $52e5993aebe2f2b8$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        } else {
            ctx.lineTo(cx + xire, cy + yire);
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    }
    ctx.closePath();
}


var $ace53cc79acf5001$export$98af62de8a972c99 = function() {
    function SectorShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
        this.cornerRadius = 0;
    }
    return SectorShape;
}();
var $ace53cc79acf5001$var$Sector = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Sector, _super);
    function Sector(opts) {
        return _super.call(this, opts) || this;
    }
    Sector.prototype.getDefaultShape = function() {
        return new $ace53cc79acf5001$export$98af62de8a972c99();
    };
    Sector.prototype.buildPath = function(ctx, shape) {
        $52e5993aebe2f2b8$export$5cc7f731b5937e99(ctx, shape);
    };
    Sector.prototype.isZeroArea = function() {
        return this.shape.startAngle === this.shape.endAngle || this.shape.r === this.shape.r0;
    };
    return Sector;
}((0, $340211037b56ba3f$export$2e2bcd8739ae039));
$ace53cc79acf5001$var$Sector.prototype.type = 'sector';
var $ace53cc79acf5001$export$2e2bcd8739ae039 = $ace53cc79acf5001$var$Sector;




var $c9630773534abab3$export$4a506b3cd4ea73db = function() {
    function RingShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.r0 = 0;
    }
    return RingShape;
}();
var $c9630773534abab3$var$Ring = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Ring, _super);
    function Ring(opts) {
        return _super.call(this, opts) || this;
    }
    Ring.prototype.getDefaultShape = function() {
        return new $c9630773534abab3$export$4a506b3cd4ea73db();
    };
    Ring.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var PI2 = Math.PI * 2;
        ctx.moveTo(x + shape.r, y);
        ctx.arc(x, y, shape.r, 0, PI2, false);
        ctx.moveTo(x + shape.r0, y);
        ctx.arc(x, y, shape.r0, 0, PI2, true);
    };
    return Ring;
}((0, $340211037b56ba3f$export$2e2bcd8739ae039));
$c9630773534abab3$var$Ring.prototype.type = 'ring';
var $c9630773534abab3$export$2e2bcd8739ae039 = $c9630773534abab3$var$Ring;





function $585f493f3260e585$export$2e2bcd8739ae039(points, smooth, isLoop, constraint) {
    var cps = [];
    var v = [];
    var v1 = [];
    var v2 = [];
    var prevPoint;
    var nextPoint;
    var min;
    var max;
    if (constraint) {
        min = [
            Infinity,
            Infinity
        ];
        max = [
            -Infinity,
            -Infinity
        ];
        for(var i = 0, len = points.length; i < len; i++){
            (0, $f79ec7ea1294b339$export$96ec731ed4dcb222)(min, min, points[i]);
            (0, $f79ec7ea1294b339$export$8960430cfd85939f)(max, max, points[i]);
        }
        (0, $f79ec7ea1294b339$export$96ec731ed4dcb222)(min, min, constraint[0]);
        (0, $f79ec7ea1294b339$export$8960430cfd85939f)(max, max, constraint[1]);
    }
    for(var i = 0, len = points.length; i < len; i++){
        var point = points[i];
        if (isLoop) {
            prevPoint = points[i ? i - 1 : len - 1];
            nextPoint = points[(i + 1) % len];
        } else if (i === 0 || i === len - 1) {
            cps.push((0, $f79ec7ea1294b339$export$9cd59f9826255e47)(points[i]));
            continue;
        } else {
            prevPoint = points[i - 1];
            nextPoint = points[i + 1];
        }
        (0, $f79ec7ea1294b339$export$f93b5905241a7cca)(v, nextPoint, prevPoint);
        (0, $f79ec7ea1294b339$export$dcdf75081b88279d)(v, v, smooth);
        var d0 = (0, $f79ec7ea1294b339$export$9f17032d917177de)(point, prevPoint);
        var d1 = (0, $f79ec7ea1294b339$export$9f17032d917177de)(point, nextPoint);
        var sum = d0 + d1;
        if (sum !== 0) {
            d0 /= sum;
            d1 /= sum;
        }
        (0, $f79ec7ea1294b339$export$dcdf75081b88279d)(v1, v, -d0);
        (0, $f79ec7ea1294b339$export$dcdf75081b88279d)(v2, v, d1);
        var cp0 = (0, $f79ec7ea1294b339$export$e16d8520af44a096)([], point, v1);
        var cp1 = (0, $f79ec7ea1294b339$export$e16d8520af44a096)([], point, v2);
        if (constraint) {
            (0, $f79ec7ea1294b339$export$8960430cfd85939f)(cp0, cp0, min);
            (0, $f79ec7ea1294b339$export$96ec731ed4dcb222)(cp0, cp0, max);
            (0, $f79ec7ea1294b339$export$8960430cfd85939f)(cp1, cp1, min);
            (0, $f79ec7ea1294b339$export$96ec731ed4dcb222)(cp1, cp1, max);
        }
        cps.push(cp0);
        cps.push(cp1);
    }
    if (isLoop) cps.push(cps.shift());
    return cps;
}


function $a25111627a10dbe6$export$5cc7f731b5937e99(ctx, shape, closePath) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (points && points.length >= 2) {
        if (smooth) {
            var controlPoints = (0, $585f493f3260e585$export$2e2bcd8739ae039)(points, smooth, closePath, shape.smoothConstraint);
            ctx.moveTo(points[0][0], points[0][1]);
            var len = points.length;
            for(var i = 0; i < (closePath ? len : len - 1); i++){
                var cp1 = controlPoints[i * 2];
                var cp2 = controlPoints[i * 2 + 1];
                var p = points[(i + 1) % len];
                ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
            }
        } else {
            ctx.moveTo(points[0][0], points[0][1]);
            for(var i = 1, l = points.length; i < l; i++)ctx.lineTo(points[i][0], points[i][1]);
        }
        closePath && ctx.closePath();
    }
}


var $a1bff28286a546ce$export$a34d87b9aaeedd46 = function() {
    function PolygonShape() {
        this.points = null;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolygonShape;
}();
var $a1bff28286a546ce$var$Polygon = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Polygon, _super);
    function Polygon(opts) {
        return _super.call(this, opts) || this;
    }
    Polygon.prototype.getDefaultShape = function() {
        return new $a1bff28286a546ce$export$a34d87b9aaeedd46();
    };
    Polygon.prototype.buildPath = function(ctx, shape) {
        $a25111627a10dbe6$export$5cc7f731b5937e99(ctx, shape, true);
    };
    return Polygon;
}((0, $340211037b56ba3f$export$2e2bcd8739ae039));
$a1bff28286a546ce$var$Polygon.prototype.type = 'polygon';
var $a1bff28286a546ce$export$2e2bcd8739ae039 = $a1bff28286a546ce$var$Polygon;





var $481bc99c69021e4e$export$e9e5cc3985e19d11 = function() {
    function PolylineShape() {
        this.points = null;
        this.percent = 1;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolylineShape;
}();
var $481bc99c69021e4e$var$Polyline = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Polyline, _super);
    function Polyline(opts) {
        return _super.call(this, opts) || this;
    }
    Polyline.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Polyline.prototype.getDefaultShape = function() {
        return new $481bc99c69021e4e$export$e9e5cc3985e19d11();
    };
    Polyline.prototype.buildPath = function(ctx, shape) {
        $a25111627a10dbe6$export$5cc7f731b5937e99(ctx, shape, false);
    };
    return Polyline;
}((0, $340211037b56ba3f$export$2e2bcd8739ae039));
$481bc99c69021e4e$var$Polyline.prototype.type = 'polyline';
var $481bc99c69021e4e$export$2e2bcd8739ae039 = $481bc99c69021e4e$var$Polyline;






var $b37b447960e3414d$var$subPixelOptimizeOutputShape = {};
var $b37b447960e3414d$export$64b674d0815308 = function() {
    function LineShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return LineShape;
}();
var $b37b447960e3414d$var$Line = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Line, _super);
    function Line(opts) {
        return _super.call(this, opts) || this;
    }
    Line.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Line.prototype.getDefaultShape = function() {
        return new $b37b447960e3414d$export$64b674d0815308();
    };
    Line.prototype.buildPath = function(ctx, shape) {
        var x1;
        var y1;
        var x2;
        var y2;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $df42d3963fd014cb$export$8b4b620d7f4aad1b)($b37b447960e3414d$var$subPixelOptimizeOutputShape, shape, this.style);
            x1 = optimizedShape.x1;
            y1 = optimizedShape.y1;
            x2 = optimizedShape.x2;
            y2 = optimizedShape.y2;
        } else {
            x1 = shape.x1;
            y1 = shape.y1;
            x2 = shape.x2;
            y2 = shape.y2;
        }
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (percent < 1) {
            x2 = x1 * (1 - percent) + x2 * percent;
            y2 = y1 * (1 - percent) + y2 * percent;
        }
        ctx.lineTo(x2, y2);
    };
    Line.prototype.pointAt = function(p) {
        var shape = this.shape;
        return [
            shape.x1 * (1 - p) + shape.x2 * p,
            shape.y1 * (1 - p) + shape.y2 * p
        ];
    };
    return Line;
}((0, $340211037b56ba3f$export$2e2bcd8739ae039));
$b37b447960e3414d$var$Line.prototype.type = 'line';
var $b37b447960e3414d$export$2e2bcd8739ae039 = $b37b447960e3414d$var$Line;






var $d2a6ba6dfef20f23$var$out = [];
var $d2a6ba6dfef20f23$export$e10089729fef29aa = function() {
    function BezierCurveShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.percent = 1;
    }
    return BezierCurveShape;
}();
function $d2a6ba6dfef20f23$var$someVectorAt(shape, t, isTangent) {
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    if (cpx2 != null || cpy2 != null) return [
        (isTangent ? (0, $893961281ad1f27f$export$55fce925c60b6271) : (0, $893961281ad1f27f$export$547c21de482bbcb2))(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
        (isTangent ? (0, $893961281ad1f27f$export$55fce925c60b6271) : (0, $893961281ad1f27f$export$547c21de482bbcb2))(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
    ];
    else return [
        (isTangent ? (0, $893961281ad1f27f$export$7e161e77e6fff8cb) : (0, $893961281ad1f27f$export$af17094a950f5073))(shape.x1, shape.cpx1, shape.x2, t),
        (isTangent ? (0, $893961281ad1f27f$export$7e161e77e6fff8cb) : (0, $893961281ad1f27f$export$af17094a950f5073))(shape.y1, shape.cpy1, shape.y2, t)
    ];
}
var $d2a6ba6dfef20f23$var$BezierCurve = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(BezierCurve, _super);
    function BezierCurve(opts) {
        return _super.call(this, opts) || this;
    }
    BezierCurve.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    BezierCurve.prototype.getDefaultShape = function() {
        return new $d2a6ba6dfef20f23$export$e10089729fef29aa();
    };
    BezierCurve.prototype.buildPath = function(ctx, shape) {
        var x1 = shape.x1;
        var y1 = shape.y1;
        var x2 = shape.x2;
        var y2 = shape.y2;
        var cpx1 = shape.cpx1;
        var cpy1 = shape.cpy1;
        var cpx2 = shape.cpx2;
        var cpy2 = shape.cpy2;
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (cpx2 == null || cpy2 == null) {
            if (percent < 1) {
                (0, $893961281ad1f27f$export$117c659e21a7a060)(x1, cpx1, x2, percent, $d2a6ba6dfef20f23$var$out);
                cpx1 = $d2a6ba6dfef20f23$var$out[1];
                x2 = $d2a6ba6dfef20f23$var$out[2];
                (0, $893961281ad1f27f$export$117c659e21a7a060)(y1, cpy1, y2, percent, $d2a6ba6dfef20f23$var$out);
                cpy1 = $d2a6ba6dfef20f23$var$out[1];
                y2 = $d2a6ba6dfef20f23$var$out[2];
            }
            ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
        } else {
            if (percent < 1) {
                (0, $893961281ad1f27f$export$a2ee23a0567039da)(x1, cpx1, cpx2, x2, percent, $d2a6ba6dfef20f23$var$out);
                cpx1 = $d2a6ba6dfef20f23$var$out[1];
                cpx2 = $d2a6ba6dfef20f23$var$out[2];
                x2 = $d2a6ba6dfef20f23$var$out[3];
                (0, $893961281ad1f27f$export$a2ee23a0567039da)(y1, cpy1, cpy2, y2, percent, $d2a6ba6dfef20f23$var$out);
                cpy1 = $d2a6ba6dfef20f23$var$out[1];
                cpy2 = $d2a6ba6dfef20f23$var$out[2];
                y2 = $d2a6ba6dfef20f23$var$out[3];
            }
            ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
        }
    };
    BezierCurve.prototype.pointAt = function(t) {
        return $d2a6ba6dfef20f23$var$someVectorAt(this.shape, t, false);
    };
    BezierCurve.prototype.tangentAt = function(t) {
        var p = $d2a6ba6dfef20f23$var$someVectorAt(this.shape, t, true);
        return $f79ec7ea1294b339$export$a3295358bff77e(p, p);
    };
    return BezierCurve;
}((0, $340211037b56ba3f$export$2e2bcd8739ae039));
$d2a6ba6dfef20f23$var$BezierCurve.prototype.type = 'bezier-curve';
var $d2a6ba6dfef20f23$export$2e2bcd8739ae039 = $d2a6ba6dfef20f23$var$BezierCurve;




var $770c52e9ca54b6a3$export$a259dbdc51948277 = function() {
    function ArcShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return ArcShape;
}();
var $770c52e9ca54b6a3$var$Arc = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Arc, _super);
    function Arc(opts) {
        return _super.call(this, opts) || this;
    }
    Arc.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Arc.prototype.getDefaultShape = function() {
        return new $770c52e9ca54b6a3$export$a259dbdc51948277();
    };
    Arc.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r = Math.max(shape.r, 0);
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitX = Math.cos(startAngle);
        var unitY = Math.sin(startAngle);
        ctx.moveTo(unitX * r + x, unitY * r + y);
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    };
    return Arc;
}((0, $340211037b56ba3f$export$2e2bcd8739ae039));
$770c52e9ca54b6a3$var$Arc.prototype.type = 'arc';
var $770c52e9ca54b6a3$export$2e2bcd8739ae039 = $770c52e9ca54b6a3$var$Arc;




var $9a457b474ed23e1f$var$CompoundPath = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(CompoundPath, _super);
    function CompoundPath() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'compound';
        return _this;
    }
    CompoundPath.prototype._updatePathDirty = function() {
        var paths = this.shape.paths;
        var dirtyPath = this.shapeChanged();
        for(var i = 0; i < paths.length; i++)dirtyPath = dirtyPath || paths[i].shapeChanged();
        if (dirtyPath) this.dirtyShape();
    };
    CompoundPath.prototype.beforeBrush = function() {
        this._updatePathDirty();
        var paths = this.shape.paths || [];
        var scale = this.getGlobalScale();
        for(var i = 0; i < paths.length; i++){
            if (!paths[i].path) paths[i].createPathProxy();
            paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
        }
    };
    CompoundPath.prototype.buildPath = function(ctx, shape) {
        var paths = shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].buildPath(ctx, paths[i].shape, true);
    };
    CompoundPath.prototype.afterBrush = function() {
        var paths = this.shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].pathUpdated();
    };
    CompoundPath.prototype.getBoundingRect = function() {
        this._updatePathDirty.call(this);
        return (0, $340211037b56ba3f$export$2e2bcd8739ae039).prototype.getBoundingRect.call(this);
    };
    return CompoundPath;
}((0, $340211037b56ba3f$export$2e2bcd8739ae039));
var $9a457b474ed23e1f$export$2e2bcd8739ae039 = $9a457b474ed23e1f$var$CompoundPath;



var $01e99751e00ac42b$var$Gradient = function() {
    function Gradient(colorStops) {
        this.colorStops = colorStops || [];
    }
    Gradient.prototype.addColorStop = function(offset, color) {
        this.colorStops.push({
            offset: offset,
            color: color
        });
    };
    return Gradient;
}();
var $01e99751e00ac42b$export$2e2bcd8739ae039 = $01e99751e00ac42b$var$Gradient;


var $25727ffd7c1a8e5b$var$LinearGradient = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(LinearGradient, _super);
    function LinearGradient(x, y, x2, y2, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0 : x;
        _this.y = y == null ? 0 : y;
        _this.x2 = x2 == null ? 1 : x2;
        _this.y2 = y2 == null ? 0 : y2;
        _this.type = 'linear';
        _this.global = globalCoord || false;
        return _this;
    }
    return LinearGradient;
}((0, $01e99751e00ac42b$export$2e2bcd8739ae039));
var $25727ffd7c1a8e5b$export$2e2bcd8739ae039 = $25727ffd7c1a8e5b$var$LinearGradient;




var $c65f9ddf1d9009ee$var$RadialGradient = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(RadialGradient, _super);
    function RadialGradient(x, y, r, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0.5 : x;
        _this.y = y == null ? 0.5 : y;
        _this.r = r == null ? 0.5 : r;
        _this.type = 'radial';
        _this.global = globalCoord || false;
        return _this;
    }
    return RadialGradient;
}((0, $01e99751e00ac42b$export$2e2bcd8739ae039));
var $c65f9ddf1d9009ee$export$2e2bcd8739ae039 = $c65f9ddf1d9009ee$var$RadialGradient;





var $4498ebf6c695fdf7$var$mathMin = Math.min;
var $4498ebf6c695fdf7$var$mathMax = Math.max;
var $4498ebf6c695fdf7$var$mathAbs = Math.abs;
var $4498ebf6c695fdf7$var$_extent = [
    0,
    0
];
var $4498ebf6c695fdf7$var$_extent2 = [
    0,
    0
];
var $4498ebf6c695fdf7$var$_intersectCtx = (0, $7456366ce379c42e$export$a0be2bdbd2369e0e)();
var $4498ebf6c695fdf7$var$_minTv = $4498ebf6c695fdf7$var$_intersectCtx.minTv;
var $4498ebf6c695fdf7$var$_maxTv = $4498ebf6c695fdf7$var$_intersectCtx.maxTv;
var $4498ebf6c695fdf7$var$OrientedBoundingRect = function() {
    function OrientedBoundingRect(rect, transform) {
        this._corners = [];
        this._axes = [];
        this._origin = [
            0,
            0
        ];
        for(var i = 0; i < 4; i++)this._corners[i] = new (0, $f82d35899f1caf18$export$2e2bcd8739ae039)();
        for(var i = 0; i < 2; i++)this._axes[i] = new (0, $f82d35899f1caf18$export$2e2bcd8739ae039)();
        if (rect) this.fromBoundingRect(rect, transform);
    }
    OrientedBoundingRect.prototype.fromBoundingRect = function(rect, transform) {
        var corners = this._corners;
        var axes = this._axes;
        var x = rect.x;
        var y = rect.y;
        var x2 = x + rect.width;
        var y2 = y + rect.height;
        corners[0].set(x, y);
        corners[1].set(x2, y);
        corners[2].set(x2, y2);
        corners[3].set(x, y2);
        if (transform) for(var i = 0; i < 4; i++)corners[i].transform(transform);
        (0, $f82d35899f1caf18$export$2e2bcd8739ae039).sub(axes[0], corners[1], corners[0]);
        (0, $f82d35899f1caf18$export$2e2bcd8739ae039).sub(axes[1], corners[3], corners[0]);
        axes[0].normalize();
        axes[1].normalize();
        for(var i = 0; i < 2; i++)this._origin[i] = axes[i].dot(corners[0]);
    };
    OrientedBoundingRect.prototype.intersect = function(other, mtv, opt) {
        var overlapped = true;
        var noMtv = !mtv;
        if (mtv) (0, $f82d35899f1caf18$export$2e2bcd8739ae039).set(mtv, 0, 0);
        $4498ebf6c695fdf7$var$_intersectCtx.reset(opt, !noMtv);
        if (!this._intersectCheckOneSide(this, other, noMtv, 1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!this._intersectCheckOneSide(other, this, noMtv, -1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!noMtv && !$4498ebf6c695fdf7$var$_intersectCtx.negativeSize) (0, $f82d35899f1caf18$export$2e2bcd8739ae039).copy(mtv, overlapped ? $4498ebf6c695fdf7$var$_intersectCtx.useDir ? $4498ebf6c695fdf7$var$_intersectCtx.dirMinTv : $4498ebf6c695fdf7$var$_minTv : $4498ebf6c695fdf7$var$_maxTv);
        return overlapped;
    };
    OrientedBoundingRect.prototype._intersectCheckOneSide = function(self, other, noMtv, inverse) {
        var overlapped = true;
        for(var i = 0; i < 2; i++){
            var axis = self._axes[i];
            self._getProjMinMaxOnAxis(i, self._corners, $4498ebf6c695fdf7$var$_extent);
            self._getProjMinMaxOnAxis(i, other._corners, $4498ebf6c695fdf7$var$_extent2);
            if ($4498ebf6c695fdf7$var$_intersectCtx.negativeSize || $4498ebf6c695fdf7$var$_extent[1] < $4498ebf6c695fdf7$var$_extent2[0] || $4498ebf6c695fdf7$var$_extent[0] > $4498ebf6c695fdf7$var$_extent2[1]) {
                overlapped = false;
                if ($4498ebf6c695fdf7$var$_intersectCtx.negativeSize || noMtv) return overlapped;
                var dist0 = $4498ebf6c695fdf7$var$mathAbs($4498ebf6c695fdf7$var$_extent2[0] - $4498ebf6c695fdf7$var$_extent[1]);
                var dist1 = $4498ebf6c695fdf7$var$mathAbs($4498ebf6c695fdf7$var$_extent[0] - $4498ebf6c695fdf7$var$_extent2[1]);
                if ($4498ebf6c695fdf7$var$mathMin(dist0, dist1) > $4498ebf6c695fdf7$var$_maxTv.len()) {
                    if (dist0 < dist1) (0, $f82d35899f1caf18$export$2e2bcd8739ae039).scale($4498ebf6c695fdf7$var$_maxTv, axis, -dist0 * inverse);
                    else (0, $f82d35899f1caf18$export$2e2bcd8739ae039).scale($4498ebf6c695fdf7$var$_maxTv, axis, dist1 * inverse);
                }
            } else if (!noMtv) {
                var dist0 = $4498ebf6c695fdf7$var$mathAbs($4498ebf6c695fdf7$var$_extent2[0] - $4498ebf6c695fdf7$var$_extent[1]);
                var dist1 = $4498ebf6c695fdf7$var$mathAbs($4498ebf6c695fdf7$var$_extent[0] - $4498ebf6c695fdf7$var$_extent2[1]);
                if ($4498ebf6c695fdf7$var$_intersectCtx.useDir || $4498ebf6c695fdf7$var$mathMin(dist0, dist1) < $4498ebf6c695fdf7$var$_minTv.len()) {
                    if (dist0 < dist1 || !$4498ebf6c695fdf7$var$_intersectCtx.bidirectional) {
                        (0, $f82d35899f1caf18$export$2e2bcd8739ae039).scale($4498ebf6c695fdf7$var$_minTv, axis, dist0 * inverse);
                        if ($4498ebf6c695fdf7$var$_intersectCtx.useDir) $4498ebf6c695fdf7$var$_intersectCtx.calcDirMTV();
                    }
                    if (dist0 >= dist1 || !$4498ebf6c695fdf7$var$_intersectCtx.bidirectional) {
                        (0, $f82d35899f1caf18$export$2e2bcd8739ae039).scale($4498ebf6c695fdf7$var$_minTv, axis, -dist1 * inverse);
                        if ($4498ebf6c695fdf7$var$_intersectCtx.useDir) $4498ebf6c695fdf7$var$_intersectCtx.calcDirMTV();
                    }
                }
            }
        }
        return overlapped;
    };
    OrientedBoundingRect.prototype._getProjMinMaxOnAxis = function(dim, corners, out) {
        var axis = this._axes[dim];
        var origin = this._origin;
        var proj = corners[0].dot(axis) + origin[dim];
        var min = proj;
        var max = proj;
        for(var i = 1; i < corners.length; i++){
            var proj_1 = corners[i].dot(axis) + origin[dim];
            min = $4498ebf6c695fdf7$var$mathMin(proj_1, min);
            max = $4498ebf6c695fdf7$var$mathMax(proj_1, max);
        }
        out[0] = min + $4498ebf6c695fdf7$var$_intersectCtx.touchThreshold;
        out[1] = max - $4498ebf6c695fdf7$var$_intersectCtx.touchThreshold;
        $4498ebf6c695fdf7$var$_intersectCtx.negativeSize = out[1] < out[0];
    };
    return OrientedBoundingRect;
}();
var $4498ebf6c695fdf7$export$2e2bcd8739ae039 = $4498ebf6c695fdf7$var$OrientedBoundingRect;






var $ba82da7f67316de6$export$2dc95e9f4fd018cd = 0;
var $ba82da7f67316de6$export$a0377e544ceae7da = 1;
var $ba82da7f67316de6$export$f2b95933e1444751 = 2;
var $ba82da7f67316de6$export$5bf503311eda4292 = 1;
var $ba82da7f67316de6$export$63f5564428138c5e = 0;


var $4242d9412345c769$var$m = [];
var $4242d9412345c769$var$IncrementalDisplayable = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(IncrementalDisplayable, _super);
    function IncrementalDisplayable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notClear = true;
        _this.incremental = (0, $ba82da7f67316de6$export$a0377e544ceae7da);
        _this._displayables = [];
        _this._temporaryDisplayables = [];
        _this._cursor = 0;
        return _this;
    }
    IncrementalDisplayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    IncrementalDisplayable.prototype.useStyle = function() {
        this.style = {};
    };
    IncrementalDisplayable.prototype._useHoverStyle = function() {
        this.__hoverStyle = null;
    };
    IncrementalDisplayable.prototype.getCursor = function() {
        return this._cursor;
    };
    IncrementalDisplayable.prototype.innerAfterBrush = function() {
        this._cursor = this._displayables.length;
    };
    IncrementalDisplayable.prototype.clearDisplaybles = function() {
        this._displayables = [];
        this._temporaryDisplayables = [];
        this._cursor = 0;
        this.markRedraw();
        this.notClear = false;
    };
    IncrementalDisplayable.prototype.clearTemporalDisplayables = function() {
        this._temporaryDisplayables = [];
    };
    IncrementalDisplayable.prototype.addDisplayable = function(displayable, notPersistent) {
        if (notPersistent) this._temporaryDisplayables.push(displayable);
        else this._displayables.push(displayable);
        this.markRedraw();
    };
    IncrementalDisplayable.prototype.addDisplayables = function(displayables, notPersistent) {
        notPersistent = notPersistent || false;
        for(var i = 0; i < displayables.length; i++)this.addDisplayable(displayables[i], notPersistent);
    };
    IncrementalDisplayable.prototype.getDisplayables = function() {
        return this._displayables;
    };
    IncrementalDisplayable.prototype.getTemporalDisplayables = function() {
        return this._temporaryDisplayables;
    };
    IncrementalDisplayable.prototype.eachPendingDisplayable = function(cb) {
        for(var i = this._cursor; i < this._displayables.length; i++)cb && cb(this._displayables[i]);
        for(var i = 0; i < this._temporaryDisplayables.length; i++)cb && cb(this._temporaryDisplayables[i]);
    };
    IncrementalDisplayable.prototype.update = function() {
        this.updateTransform();
        for(var i = this._cursor; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
        for(var i = 0; i < this._temporaryDisplayables.length; i++){
            var displayable = this._temporaryDisplayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
    };
    IncrementalDisplayable.prototype.getBoundingRect = function() {
        if (!this._rect) {
            var rect = new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(Infinity, Infinity, -Infinity, -Infinity);
            for(var i = 0; i < this._displayables.length; i++){
                var displayable = this._displayables[i];
                var childRect = displayable.getBoundingRect().clone();
                if (displayable.needLocalTransform()) childRect.applyTransform(displayable.getLocalTransform($4242d9412345c769$var$m));
                rect.union(childRect);
            }
            this._rect = rect;
        }
        return this._rect;
    };
    IncrementalDisplayable.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        if (rect.contain(localPos[0], localPos[1])) for(var i = 0; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            if (displayable.contain(x, y)) return true;
        }
        return false;
    };
    return IncrementalDisplayable;
}((0, $0a0ef4888a4b4e90$export$2e2bcd8739ae039));
var $4242d9412345c769$export$2e2bcd8739ae039 = $4242d9412345c769$var$IncrementalDisplayable;







var $bce1f681c7fb2581$var$_customShapeMap = {};
var $bce1f681c7fb2581$export$cb4c12294149dd2d = [
    'x',
    'y'
];
var $bce1f681c7fb2581$export$a3fe6d967173a3ac = [
    'width',
    'height'
];
var $bce1f681c7fb2581$export$3e67317617241636 = 0;
var $bce1f681c7fb2581$export$3c339ce201e4ce4d = 1;
var $bce1f681c7fb2581$export$2ed770cec6ef78e8 = 2;
function $bce1f681c7fb2581$export$d0d5398c9d612037(opts) {
    return (0, $340211037b56ba3f$export$2e2bcd8739ae039).extend(opts);
}
var $bce1f681c7fb2581$var$extendPathFromString = $3b24c4cdba9faafa$export$68e3a51ba2ed417c;
function $bce1f681c7fb2581$export$53b54a3137026af0(pathData, opts) {
    return $bce1f681c7fb2581$var$extendPathFromString(pathData, opts);
}
function $bce1f681c7fb2581$export$2b95b62e3aaf6fdd(name, ShapeClass) {
    $bce1f681c7fb2581$var$_customShapeMap[name] = ShapeClass;
}
function $bce1f681c7fb2581$export$51df4b5565a58189(name) {
    if ($bce1f681c7fb2581$var$_customShapeMap.hasOwnProperty(name)) return $bce1f681c7fb2581$var$_customShapeMap[name];
}
function $bce1f681c7fb2581$export$aa9bab72412f5613(pathData, opts, rect, layout) {
    var path = $3b24c4cdba9faafa$export$ae5b259626f00aeb(pathData, opts);
    if (rect) {
        if (layout === 'center') rect = $bce1f681c7fb2581$var$centerGraphic(rect, path.getBoundingRect());
        $bce1f681c7fb2581$export$566dbf1c62b04fc7(path, rect);
    }
    return path;
}
function $bce1f681c7fb2581$export$7a2bdede98851ac5(imageUrl, rect, layout) {
    var zrImg = new (0, $0eafea320dbd53c3$export$2e2bcd8739ae039)({
        style: {
            image: imageUrl,
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        onload: function onload(img) {
            if (layout === 'center') {
                var boundingRect = {
                    width: img.width,
                    height: img.height
                };
                zrImg.setStyle($bce1f681c7fb2581$var$centerGraphic(rect, boundingRect));
            }
        }
    });
    return zrImg;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  rect         element local bounding box
 * @param  boundingRect constraint bounding box
 * @return element position containing x, y, width, and height
 */ function $bce1f681c7fb2581$var$centerGraphic(rect, boundingRect) {
    // Set rect to center, keep width / height ratio.
    var aspect = boundingRect.width / boundingRect.height;
    var width = rect.height * aspect;
    var height;
    if (width <= rect.width) height = rect.height;
    else {
        width = rect.width;
        height = width / aspect;
    }
    var cx = rect.x + rect.width / 2;
    var cy = rect.y + rect.height / 2;
    return {
        x: cx - width / 2,
        y: cy - height / 2,
        width: width,
        height: height
    };
}
var $bce1f681c7fb2581$export$7b1dd269fbc4e903 = $3b24c4cdba9faafa$export$7b1dd269fbc4e903;
function $bce1f681c7fb2581$export$566dbf1c62b04fc7(path, rect) {
    if (!path.applyTransform) return;
    var pathRect = path.getBoundingRect();
    var m = pathRect.calculateTransform(rect);
    path.applyTransform(m);
}
function $bce1f681c7fb2581$export$8b4b620d7f4aad1b(shape, lineWidth) {
    $df42d3963fd014cb$export$8b4b620d7f4aad1b(shape, shape, {
        lineWidth: lineWidth
    });
    return shape;
}
function $bce1f681c7fb2581$export$60e2aa74957d0b9d(shape, style) {
    $df42d3963fd014cb$export$60e2aa74957d0b9d(shape, shape, style);
    return shape;
}
var $bce1f681c7fb2581$export$72c4fd4c1b8fcb10 = $df42d3963fd014cb$export$72c4fd4c1b8fcb10;
function $bce1f681c7fb2581$export$fce0c6cfca85ed96(target, ancestor) {
    var mat = $45a6d43b639a6412$export$f0954fd7d5368655([]);
    while(target && target !== ancestor){
        $45a6d43b639a6412$export$6e3a27864ab166fe(mat, target.getLocalTransform(), mat);
        target = target.parent;
    }
    return mat;
}
function $bce1f681c7fb2581$export$9f9dcb98c894b623(target, transform, invert) {
    if (transform && !(0, $f16f2994a32ad273$export$1e2f57719e155213)(transform)) transform = (0, $ad30ab15d8ed0f32$export$2e2bcd8739ae039).getLocalTransform(transform);
    if (invert) transform = $45a6d43b639a6412$export$6897c284b6f9f4dc([], transform);
    return $f79ec7ea1294b339$export$9f9dcb98c894b623([], target, transform);
}
function $bce1f681c7fb2581$export$fff94e9792354cfa(direction, transform, invert) {
    // Pick a base, ensure that transform result will not be (0, 0).
    var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : (0, $104896d282bd296f$export$5860c226b237d9a6)(2 * transform[4] / transform[0]);
    var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : (0, $104896d282bd296f$export$5860c226b237d9a6)(2 * transform[4] / transform[2]);
    var vertex = [
        direction === 'left' ? -hBase : direction === 'right' ? hBase : 0,
        direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0
    ];
    vertex = $bce1f681c7fb2581$export$9f9dcb98c894b623(vertex, transform, invert);
    return (0, $104896d282bd296f$export$5860c226b237d9a6)(vertex[0]) > (0, $104896d282bd296f$export$5860c226b237d9a6)(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
}
function $bce1f681c7fb2581$var$isNotGroup(el) {
    return !el.isGroup;
}
function $bce1f681c7fb2581$var$isPath(el) {
    return el.shape != null;
}
function $bce1f681c7fb2581$export$64fcab7860c216ae(g1, g2, animatableModel) {
    if (!g1 || !g2) return;
    function getElMap(g) {
        var elMap = {};
        g.traverse(function(el) {
            if ($bce1f681c7fb2581$var$isNotGroup(el) && el.anid) elMap[el.anid] = el;
        });
        return elMap;
    }
    function getAnimatableProps(el) {
        var obj = {
            x: el.x,
            y: el.y,
            rotation: el.rotation
        };
        if ($bce1f681c7fb2581$var$isPath(el)) obj.shape = (0, $f16f2994a32ad273$export$9cd59f9826255e47)(el.shape);
        return obj;
    }
    var elMap1 = getElMap(g1);
    g2.traverse(function(el) {
        if ($bce1f681c7fb2581$var$isNotGroup(el) && el.anid) {
            var oldEl = elMap1[el.anid];
            if (oldEl) {
                var newProp = getAnimatableProps(el);
                el.attr(getAnimatableProps(oldEl));
                (0, $d2a962ec0ef14a79$export$c8dce3c08436e91e)(el, newProp, animatableModel, (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(el).dataIndex);
            }
        }
    });
}
function $bce1f681c7fb2581$export$e2f409471bbbc1dc(points, rect) {
    // FIXME: This way might be incorrect when graphic clipped by a corner
    // and when element has a border.
    return (0, $f16f2994a32ad273$export$871de8747c9eaa88)(points, function(point) {
        var x = point[0];
        x = (0, $104896d282bd296f$export$2ca8010d037f830f)(x, rect.x);
        x = (0, $104896d282bd296f$export$e411eeaf23dccbe8)(x, rect.x + rect.width);
        var y = point[1];
        y = (0, $104896d282bd296f$export$2ca8010d037f830f)(y, rect.y);
        y = (0, $104896d282bd296f$export$e411eeaf23dccbe8)(y, rect.y + rect.height);
        return [
            x,
            y
        ];
    });
}
function $bce1f681c7fb2581$export$d0d3709202b8b2a(targetRect, rect) {
    var x = (0, $104896d282bd296f$export$2ca8010d037f830f)(targetRect.x, rect.x);
    var x2 = (0, $104896d282bd296f$export$e411eeaf23dccbe8)(targetRect.x + targetRect.width, rect.x + rect.width);
    var y = (0, $104896d282bd296f$export$2ca8010d037f830f)(targetRect.y, rect.y);
    var y2 = (0, $104896d282bd296f$export$e411eeaf23dccbe8)(targetRect.y + targetRect.height, rect.y + rect.height);
    // If the total rect is cliped, nothing, including the border,
    // should be painted. So return undefined.
    if (x2 >= x && y2 >= y) return {
        x: x,
        y: y,
        width: x2 - x,
        height: y2 - y
    };
}
function $bce1f681c7fb2581$export$274edc73af1ae9c8(iconStr, // Support 'image://' or 'path://' or direct svg path.
opt, rect) {
    var innerOpts = (0, $f16f2994a32ad273$export$8b58be045bf06082)({
        rectHover: true
    }, opt);
    var style = innerOpts.style = {
        strokeNoScale: true
    };
    rect = rect || {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    };
    if (iconStr) return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), (0, $f16f2994a32ad273$export$ebe90cb607ad99e)(style, rect), new (0, $0eafea320dbd53c3$export$2e2bcd8739ae039)(innerOpts)) : $bce1f681c7fb2581$export$aa9bab72412f5613(iconStr.replace('path://', ''), innerOpts, rect, 'center');
}
function $bce1f681c7fb2581$export$4f47c855a5e9ae9(a1x, a1y, a2x, a2y, points) {
    for(var i = 0, p2 = points[points.length - 1]; i < points.length; i++){
        var p = points[i];
        if ($bce1f681c7fb2581$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) return true;
        p2 = p;
    }
}
function $bce1f681c7fb2581$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y;
    // `vec_m` and `vec_n` are parallel iff
    //     existing `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.
    var nmCrossProduct = $bce1f681c7fb2581$var$crossProduct2d(nx, ny, mx, my);
    if ($bce1f681c7fb2581$var$nearZero(nmCrossProduct)) return false;
    // `vec_m` and `vec_n` are intersect iff
    //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
    //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
    //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var q = $bce1f681c7fb2581$var$crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
    if (q < 0 || q > 1) return false;
    var p = $bce1f681c7fb2581$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return false;
    return true;
}
/**
 * Cross product of 2-dimension vector.
 */ function $bce1f681c7fb2581$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $bce1f681c7fb2581$var$nearZero(val) {
    return val <= 1e-6 && val >= -0.000001;
}
function $bce1f681c7fb2581$export$81ed941fdeb91c7c(rect, delta, shrinkOrExpand, noNegative, minSize // by default [0, 0].
) {
    if (delta == null) return rect;
    else if ((0, $f16f2994a32ad273$export$7e4aa119212bc614)(delta)) $bce1f681c7fb2581$var$_tmpExpandRectDelta[0] = $bce1f681c7fb2581$var$_tmpExpandRectDelta[1] = $bce1f681c7fb2581$var$_tmpExpandRectDelta[2] = $bce1f681c7fb2581$var$_tmpExpandRectDelta[3] = delta;
    else {
        $bce1f681c7fb2581$var$_tmpExpandRectDelta[0] = delta[0];
        $bce1f681c7fb2581$var$_tmpExpandRectDelta[1] = delta[1];
        $bce1f681c7fb2581$var$_tmpExpandRectDelta[2] = delta[2];
        $bce1f681c7fb2581$var$_tmpExpandRectDelta[3] = delta[3];
    }
    if (noNegative) {
        $bce1f681c7fb2581$var$_tmpExpandRectDelta[0] = (0, $104896d282bd296f$export$2ca8010d037f830f)(0, $bce1f681c7fb2581$var$_tmpExpandRectDelta[0]);
        $bce1f681c7fb2581$var$_tmpExpandRectDelta[1] = (0, $104896d282bd296f$export$2ca8010d037f830f)(0, $bce1f681c7fb2581$var$_tmpExpandRectDelta[1]);
        $bce1f681c7fb2581$var$_tmpExpandRectDelta[2] = (0, $104896d282bd296f$export$2ca8010d037f830f)(0, $bce1f681c7fb2581$var$_tmpExpandRectDelta[2]);
        $bce1f681c7fb2581$var$_tmpExpandRectDelta[3] = (0, $104896d282bd296f$export$2ca8010d037f830f)(0, $bce1f681c7fb2581$var$_tmpExpandRectDelta[3]);
    }
    if (shrinkOrExpand) {
        $bce1f681c7fb2581$var$_tmpExpandRectDelta[0] = -$bce1f681c7fb2581$var$_tmpExpandRectDelta[0];
        $bce1f681c7fb2581$var$_tmpExpandRectDelta[1] = -$bce1f681c7fb2581$var$_tmpExpandRectDelta[1];
        $bce1f681c7fb2581$var$_tmpExpandRectDelta[2] = -$bce1f681c7fb2581$var$_tmpExpandRectDelta[2];
        $bce1f681c7fb2581$var$_tmpExpandRectDelta[3] = -$bce1f681c7fb2581$var$_tmpExpandRectDelta[3];
    }
    $bce1f681c7fb2581$var$expandRectOnOneDimension(rect, $bce1f681c7fb2581$var$_tmpExpandRectDelta, 'x', 'width', 3, 1, minSize && minSize[0] || 0);
    $bce1f681c7fb2581$var$expandRectOnOneDimension(rect, $bce1f681c7fb2581$var$_tmpExpandRectDelta, 'y', 'height', 0, 2, minSize && minSize[1] || 0);
    return rect;
}
var $bce1f681c7fb2581$var$_tmpExpandRectDelta = [
    0,
    0,
    0,
    0
];
function $bce1f681c7fb2581$var$expandRectOnOneDimension(rect, delta, xy, wh, ltIdx, rbIdx, minSize) {
    var deltaSum = delta[rbIdx] + delta[ltIdx];
    var oldSize = rect[wh];
    rect[wh] += deltaSum;
    minSize = (0, $104896d282bd296f$export$2ca8010d037f830f)(0, (0, $104896d282bd296f$export$e411eeaf23dccbe8)(minSize, oldSize));
    if (rect[wh] < minSize) {
        rect[wh] = minSize;
        // Try to make the position of the zero rect reasonable in most visual cases.
        rect[xy] += delta[ltIdx] >= 0 ? -delta[ltIdx] : delta[rbIdx] >= 0 ? oldSize + delta[rbIdx] : (0, $104896d282bd296f$export$5860c226b237d9a6)(deltaSum) > 1e-8 ? (oldSize - minSize) * delta[ltIdx] / deltaSum : 0;
    } else rect[xy] -= delta[ltIdx];
}
function $bce1f681c7fb2581$export$fc6410d97fab306c(opt) {
    var itemTooltipOption = opt.itemTooltipOption;
    var componentModel = opt.componentModel;
    var itemName = opt.itemName;
    var itemTooltipOptionObj = (0, $f16f2994a32ad273$export$844ec244b1367d54)(itemTooltipOption) ? {
        formatter: itemTooltipOption
    } : itemTooltipOption;
    var mainType = componentModel.mainType;
    var componentIndex = componentModel.componentIndex;
    var formatterParams = {
        componentType: mainType,
        name: itemName,
        $vars: [
            'name'
        ]
    };
    formatterParams[mainType + 'Index'] = componentIndex;
    var formatterParamsExtra = opt.formatterParamsExtra;
    if (formatterParamsExtra) (0, $f16f2994a32ad273$export$79b2f7037acddd43)((0, $f16f2994a32ad273$export$ed97f33186d4b816)(formatterParamsExtra), function(key) {
        if (!(0, $f16f2994a32ad273$export$b5a638e9b3fff9f3)(formatterParams, key)) {
            formatterParams[key] = formatterParamsExtra[key];
            formatterParams.$vars.push(key);
        }
    });
    var ecData = (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(opt.el);
    ecData.componentMainType = mainType;
    ecData.componentIndex = componentIndex;
    ecData.tooltipConfig = {
        name: itemName,
        option: (0, $f16f2994a32ad273$export$ebe90cb607ad99e)({
            content: itemName,
            encodeHTMLContent: true,
            formatterParams: formatterParams
        }, itemTooltipOptionObj)
    };
}
function $bce1f681c7fb2581$var$traverseElement(el, cb) {
    var stopped;
    // TODO
    // Polyfill for fixing zrender group traverse don't visit it's root issue.
    if (el.isGroup) stopped = cb(el);
    if (!stopped) el.traverse(cb);
}
function $bce1f681c7fb2581$export$3e564442729bf048(els, cb) {
    if (els) {
        if ((0, $f16f2994a32ad273$export$43bee75e5e14138e)(els)) for(var i = 0; i < els.length; i++)$bce1f681c7fb2581$var$traverseElement(els[i], cb);
        else $bce1f681c7fb2581$var$traverseElement(els, cb);
    }
}
function $bce1f681c7fb2581$export$576610ccf2234b72(transform) {
    return !transform || (0, $104896d282bd296f$export$5860c226b237d9a6)(transform[1]) < $bce1f681c7fb2581$var$AXIS_ALIGN_EPSILON && (0, $104896d282bd296f$export$5860c226b237d9a6)(transform[2]) < $bce1f681c7fb2581$var$AXIS_ALIGN_EPSILON || (0, $104896d282bd296f$export$5860c226b237d9a6)(transform[0]) < $bce1f681c7fb2581$var$AXIS_ALIGN_EPSILON && (0, $104896d282bd296f$export$5860c226b237d9a6)(transform[3]) < $bce1f681c7fb2581$var$AXIS_ALIGN_EPSILON;
}
var $bce1f681c7fb2581$var$AXIS_ALIGN_EPSILON = 1e-5;
function $bce1f681c7fb2581$export$38128dfd9a498e1(target, source) {
    return target ? (0, $7456366ce379c42e$export$2e2bcd8739ae039).copy(target, source) : source.clone();
}
function $bce1f681c7fb2581$export$4d61283a070e0362(target, source) {
    return source ? $45a6d43b639a6412$export$784d13d8ee351f07(target || $45a6d43b639a6412$export$185802fd694ee1f5(), source) : undefined;
}
function $bce1f681c7fb2581$export$1500a631bea5adda(model) {
    return {
        z: model.get('z') || 0,
        zlevel: model.get('zlevel') || 0
    };
}
function $bce1f681c7fb2581$export$8215ea00957327f2(el) {
    var max = -Infinity;
    var min = Infinity;
    $bce1f681c7fb2581$var$traverseElement(el, function(el) {
        visitEl(el);
        visitEl(el.getTextContent());
        visitEl(el.getTextGuideLine());
    });
    function visitEl(el) {
        if (!el || el.isGroup) return;
        var currentStates = el.currentStates;
        if (currentStates.length) for(var idx = 0; idx < currentStates.length; idx++)calcZ2(el.states[currentStates[idx]]);
        calcZ2(el);
    }
    function calcZ2(entity) {
        if (entity) {
            var z2 = entity.z2;
            // Consider z2 may be NullUndefined
            if (z2 > max) max = z2;
            if (z2 < min) min = z2;
        }
    }
    if (min > max) min = max = 0;
    return {
        min: min,
        max: max
    };
}
function $bce1f681c7fb2581$export$d31cf465bf5e8879(el, z, zlevel) {
    $bce1f681c7fb2581$var$doUpdateZ(el, z, zlevel, -Infinity);
}
function $bce1f681c7fb2581$var$doUpdateZ(el, z, zlevel, // FIXME: Ideally all the labels should be above all the glyphs by default,
//  e.g. in graph, edge labels should be above node elements.
//  Currently impl does not guarantee that.
maxZ2) {
    // `ignoreModelZ` is used to intentionally lift elements to cover other elements,
    // where maxZ2 (for label.z2) should also not be counted for its parents.
    if (el.ignoreModelZ) return maxZ2;
    // Group may also have textContent
    var label = el.getTextContent();
    var labelLine = el.getTextGuideLine();
    var isGroup = el.isGroup;
    if (isGroup) {
        // set z & zlevel of children elements of Group
        var children = el.childrenRef();
        for(var i = 0; i < children.length; i++)maxZ2 = (0, $104896d282bd296f$export$2ca8010d037f830f)($bce1f681c7fb2581$var$doUpdateZ(children[i], z, zlevel, maxZ2), maxZ2);
    } else {
        // not Group
        el.z = z;
        el.zlevel = zlevel;
        maxZ2 = (0, $104896d282bd296f$export$2ca8010d037f830f)(el.z2 || 0, maxZ2);
    }
    // NOTICE: Do not call any method that can set REDRAW_BIT,
    // otherwise progressive rendering is broken.
    // always set z and zlevel if label/labelLine exists
    if (label) {
        label.z = z;
        label.zlevel = zlevel;
        // lift z2 of text content
        // TODO if el.emphasis.z2 is spcefied, what about textContent.
        isFinite(maxZ2) && (label.z2 = maxZ2 + 2);
    }
    if (labelLine) {
        var textGuideLineConfig = el.textGuideLineConfig;
        labelLine.z = z;
        labelLine.zlevel = zlevel;
        isFinite(maxZ2) && (labelLine.z2 = maxZ2 + (textGuideLineConfig && textGuideLineConfig.showAbove ? 1 : -1));
    }
    return maxZ2;
}
function $bce1f681c7fb2581$export$6f963a8600ad6f65(payload) {
    // Disable animation in `updateProps` of `graphic.ts`.
    payload.animation = {
        duration: 0
    };
    return payload;
}
function $bce1f681c7fb2581$export$31f224ae9d6cf05(out, mt) {
    mt ? $45a6d43b639a6412$export$784d13d8ee351f07($bce1f681c7fb2581$var$tmpDTR.transform, mt) : $45a6d43b639a6412$export$f0954fd7d5368655($bce1f681c7fb2581$var$tmpDTR.transform);
    // Use a tmp transformable to avoid effects from parent.
    $bce1f681c7fb2581$var$tmpDTR.decomposeTransform();
    (0, $ad30ab15d8ed0f32$export$234b1c16dfa57d6a)(out, $bce1f681c7fb2581$var$tmpDTR);
    return out;
}
var $bce1f681c7fb2581$var$tmpDTR = new (0, $ad30ab15d8ed0f32$export$2e2bcd8739ae039)();
$bce1f681c7fb2581$var$tmpDTR.transform = $45a6d43b639a6412$export$185802fd694ee1f5();
function $bce1f681c7fb2581$export$e8e725f22cc8ef79(api) {
    var painter = api.getZr().painter;
    return painter.getType() === 'canvas' ? painter : null;
}
// Register built-in shapes. These shapes might be overwritten
// by users, although we do not recommend that.
$bce1f681c7fb2581$export$2b95b62e3aaf6fdd('circle', (0, $f13962e4d5359f74$export$2e2bcd8739ae039));
$bce1f681c7fb2581$export$2b95b62e3aaf6fdd('ellipse', (0, $e7be948e8683a5c2$export$2e2bcd8739ae039));
$bce1f681c7fb2581$export$2b95b62e3aaf6fdd('sector', (0, $ace53cc79acf5001$export$2e2bcd8739ae039));
$bce1f681c7fb2581$export$2b95b62e3aaf6fdd('ring', (0, $c9630773534abab3$export$2e2bcd8739ae039));
$bce1f681c7fb2581$export$2b95b62e3aaf6fdd('polygon', (0, $a1bff28286a546ce$export$2e2bcd8739ae039));
$bce1f681c7fb2581$export$2b95b62e3aaf6fdd('polyline', (0, $481bc99c69021e4e$export$2e2bcd8739ae039));
$bce1f681c7fb2581$export$2b95b62e3aaf6fdd('rect', (0, $dbd6d77105f10fb2$export$2e2bcd8739ae039));
$bce1f681c7fb2581$export$2b95b62e3aaf6fdd('line', (0, $b37b447960e3414d$export$2e2bcd8739ae039));
$bce1f681c7fb2581$export$2b95b62e3aaf6fdd('bezierCurve', (0, $d2a6ba6dfef20f23$export$2e2bcd8739ae039));
$bce1f681c7fb2581$export$2b95b62e3aaf6fdd('arc', (0, $770c52e9ca54b6a3$export$2e2bcd8739ae039));


var $1ee9c8b909b7ca82$var$EMPTY_OBJ = {};
function $1ee9c8b909b7ca82$export$b533918394a58529(label, labelTexts) {
    for(var i = 0; i < (0, $1f99b77b45f30655$export$151308dceb52d5b).length; i++){
        var stateName = (0, $1f99b77b45f30655$export$151308dceb52d5b)[i];
        var text = labelTexts[stateName];
        var state = label.ensureState(stateName);
        state.style = state.style || {};
        state.style.text = text;
    }
    var oldStates = label.currentStates.slice();
    label.clearStates(true);
    label.setStyle({
        text: labelTexts.normal
    });
    label.useStates(oldStates, true);
}
function $1ee9c8b909b7ca82$var$getLabelText(opt, stateModels, interpolatedValue) {
    var labelFetcher = opt.labelFetcher;
    var labelDataIndex = opt.labelDataIndex;
    var labelDimIndex = opt.labelDimIndex;
    var normalModel = stateModels.normal;
    var baseText;
    if (labelFetcher) baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, normalModel && normalModel.get('formatter'), interpolatedValue != null ? {
        interpolatedValue: interpolatedValue
    } : null);
    if (baseText == null) baseText = (0, $f16f2994a32ad273$export$f6e2535fb5126e54)(opt.defaultText) ? opt.defaultText(labelDataIndex, opt, interpolatedValue) : opt.defaultText;
    var statesText = {
        normal: baseText
    };
    for(var i = 0; i < (0, $1f99b77b45f30655$export$151308dceb52d5b).length; i++){
        var stateName = (0, $1f99b77b45f30655$export$151308dceb52d5b)[i];
        var stateModel = stateModels[stateName];
        statesText[stateName] = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, stateName, null, labelDimIndex, stateModel && stateModel.get('formatter')) : null, baseText);
    }
    return statesText;
}
function $1ee9c8b909b7ca82$export$9a13992917966657(targetEl, labelStatesModels, opt, stateSpecified) {
    opt = opt || $1ee9c8b909b7ca82$var$EMPTY_OBJ;
    var isSetOnText = targetEl instanceof (0, $7d5e7dc1581f8c9a$export$2e2bcd8739ae039);
    var needsCreateText = false;
    for(var i = 0; i < (0, $1f99b77b45f30655$export$57ee5306b85ad7d5).length; i++){
        var stateModel = labelStatesModels[(0, $1f99b77b45f30655$export$57ee5306b85ad7d5)[i]];
        if (stateModel && stateModel.getShallow('show')) {
            needsCreateText = true;
            break;
        }
    }
    var textContent = isSetOnText ? targetEl : targetEl.getTextContent();
    if (needsCreateText) {
        if (!isSetOnText) {
            // Reuse the previous
            if (!textContent) {
                textContent = new (0, $7d5e7dc1581f8c9a$export$2e2bcd8739ae039)();
                targetEl.setTextContent(textContent);
            }
            // Use same state proxy
            if (targetEl.stateProxy) textContent.stateProxy = targetEl.stateProxy;
        }
        var labelStatesTexts = $1ee9c8b909b7ca82$var$getLabelText(opt, labelStatesModels);
        var normalModel = labelStatesModels.normal;
        var showNormal = !!normalModel.getShallow('show');
        var normalStyle = $1ee9c8b909b7ca82$export$f8998c3d0a13de59(normalModel, stateSpecified && stateSpecified.normal, opt, false, !isSetOnText);
        normalStyle.text = labelStatesTexts.normal;
        if (!isSetOnText) // Always create new
        targetEl.setTextConfig($1ee9c8b909b7ca82$export$e149afab8df6e053(normalModel, opt, false));
        for(var i = 0; i < (0, $1f99b77b45f30655$export$151308dceb52d5b).length; i++){
            var stateName = (0, $1f99b77b45f30655$export$151308dceb52d5b)[i];
            var stateModel = labelStatesModels[stateName];
            if (stateModel) {
                var stateObj = textContent.ensureState(stateName);
                var stateShow = !!(0, $f16f2994a32ad273$export$995e01f2f5c9d030)(stateModel.getShallow('show'), showNormal);
                if (stateShow !== showNormal) stateObj.ignore = !stateShow;
                stateObj.style = $1ee9c8b909b7ca82$export$f8998c3d0a13de59(stateModel, stateSpecified && stateSpecified[stateName], opt, true, !isSetOnText);
                stateObj.style.text = labelStatesTexts[stateName];
                if (!isSetOnText) {
                    var targetElEmphasisState = targetEl.ensureState(stateName);
                    targetElEmphasisState.textConfig = $1ee9c8b909b7ca82$export$e149afab8df6e053(stateModel, opt, true);
                }
            }
        }
        // PENDING: if there is many requirements that emphasis position
        // need to be different from normal position, we might consider
        // auto silent is those cases.
        textContent.silent = !!normalModel.getShallow('silent');
        // Keep x and y
        if (textContent.style.x != null) normalStyle.x = textContent.style.x;
        if (textContent.style.y != null) normalStyle.y = textContent.style.y;
        textContent.ignore = !showNormal;
        // Always create new style.
        textContent.useStyle(normalStyle);
        textContent.dirty();
        if (opt.enableTextSetter) $1ee9c8b909b7ca82$export$f62786d3261ab0f4(textContent).setLabelText = function(interpolatedValue) {
            var labelStatesTexts = $1ee9c8b909b7ca82$var$getLabelText(opt, labelStatesModels, interpolatedValue);
            $1ee9c8b909b7ca82$export$b533918394a58529(textContent, labelStatesTexts);
        };
    } else if (textContent) // Not display rich text.
    textContent.ignore = true;
    targetEl.dirty();
}
function $1ee9c8b909b7ca82$export$9739a32674be5893(itemModel, labelName) {
    labelName = labelName || 'label';
    var statesModels = {
        normal: itemModel.getModel(labelName)
    };
    for(var i = 0; i < (0, $1f99b77b45f30655$export$151308dceb52d5b).length; i++){
        var stateName = (0, $1f99b77b45f30655$export$151308dceb52d5b)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelName
        ]);
    }
    return statesModels;
}
function $1ee9c8b909b7ca82$export$f8998c3d0a13de59(textStyleModel, specifiedTextStyle, // Fixed style in the code. Can't be set by model.
opt, isNotNormal, isAttached // If text is attached on an element. If so, auto color will handling in zrender.
) {
    var textStyle = {};
    $1ee9c8b909b7ca82$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached);
    specifiedTextStyle && (0, $f16f2994a32ad273$export$8b58be045bf06082)(textStyle, specifiedTextStyle);
    // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
    return textStyle;
}
function $1ee9c8b909b7ca82$export$e149afab8df6e053(textStyleModel, opt, isNotNormal) {
    opt = opt || {};
    var textConfig = {};
    var labelPosition;
    var labelRotate = textStyleModel.getShallow('rotate');
    var labelDistance = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(textStyleModel.getShallow('distance'), isNotNormal ? null : 5);
    var labelOffset = textStyleModel.getShallow('offset');
    labelPosition = textStyleModel.getShallow('position') || (isNotNormal ? null : 'inside');
    // 'outside' is not a valid zr textPostion value, but used
    // in bar series, and magic type should be considered.
    labelPosition === 'outside' && (labelPosition = opt.defaultOutsidePosition || 'top');
    if (labelPosition != null) textConfig.position = labelPosition;
    if (labelOffset != null) textConfig.offset = labelOffset;
    if (labelRotate != null) {
        labelRotate *= Math.PI / 180;
        textConfig.rotation = labelRotate;
    }
    if (labelDistance != null) textConfig.distance = labelDistance;
    // fill and auto is determined by the color of path fill if it's not specified by developers.
    textConfig.outsideFill = textStyleModel.get('color') === 'inherit' ? opt.inheritColor || null : 'auto';
    if (opt.autoOverflowArea != null) textConfig.autoOverflowArea = opt.autoOverflowArea;
    if (opt.layoutRect != null) textConfig.layoutRect = opt.layoutRect;
    return textConfig;
}
/**
 * The uniform entry of set text style, that is, retrieve style definitions
 * from `model` and set to `textStyle` object.
 *
 * Never in merge mode, but in overwrite mode, that is, all of the text style
 * properties will be set. (Consider the states of normal and emphasis and
 * default value can be adopted, merge would make the logic too complicated
 * to manage.)
 */ function $1ee9c8b909b7ca82$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached) {
    // Consider there will be abnormal when merge hover style to normal style if given default value.
    opt = opt || $1ee9c8b909b7ca82$var$EMPTY_OBJ;
    var ecModel = textStyleModel.ecModel;
    var globalTextStyle = ecModel && ecModel.option.textStyle;
    // Consider case:
    // {
    //     data: [{
    //         value: 12,
    //         label: {
    //             rich: {
    //                 // no 'a' here but using parent 'a'.
    //             }
    //         }
    //     }],
    //     rich: {
    //         a: { ... }
    //     }
    // }
    var richItemNames = $1ee9c8b909b7ca82$var$getRichItemNames(textStyleModel);
    var richResult;
    if (richItemNames) {
        richResult = {};
        var richInheritPlainLabelOptionName = 'richInheritPlainLabel';
        var richInheritPlainLabel = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(textStyleModel.get(richInheritPlainLabelOptionName), ecModel ? ecModel.get(richInheritPlainLabelOptionName) : undefined);
        for(var name_1 in richItemNames)if (richItemNames.hasOwnProperty(name_1)) {
            // Cascade is supported in rich.
            var richTextStyle = textStyleModel.getModel([
                'rich',
                name_1
            ]);
            // In rich, never `disableBox`.
            // consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
            // the default color `'blue'` will not be adopted if no color declared in `rich`.
            // That might confuses users. So probably we should put `textStyleModel` as the
            // root ancestor of the `richTextStyle`. But that would be a break change.
            // Since v6, the rich style inherits plain label by default
            // but this behavior can be disabled by setting `richInheritPlainLabel` to `false`.
            $1ee9c8b909b7ca82$var$setTokenTextStyle(richResult[name_1] = {}, richTextStyle, globalTextStyle, textStyleModel, richInheritPlainLabel, opt, isNotNormal, isAttached, false, true);
        }
    }
    if (richResult) textStyle.rich = richResult;
    var overflow = textStyleModel.get('overflow');
    if (overflow) textStyle.overflow = overflow;
    var lineOverflow = textStyleModel.get('lineOverflow');
    if (lineOverflow) textStyle.lineOverflow = lineOverflow;
    var labelTextStyle = textStyle;
    // `minMargin` has a higher precedence than `textMargin`, because `textMargin` is allowed
    // to be set in `defaultOption`.
    var minMargin = textStyleModel.get('minMargin');
    if (minMargin != null) {
        // `minMargin` only support number value.
        minMargin = !(0, $f16f2994a32ad273$export$7e4aa119212bc614)(minMargin) ? 0 : minMargin / 2;
        labelTextStyle.margin = [
            minMargin,
            minMargin,
            minMargin,
            minMargin
        ];
        labelTextStyle.__marginType = $1ee9c8b909b7ca82$export$2b18df2bc75ae422.minMargin;
    } else {
        var textMargin = textStyleModel.get('textMargin');
        if (textMargin != null) {
            labelTextStyle.margin = (0, $f16f2994a32ad273$export$f3a38102c49f4268)(textMargin);
            labelTextStyle.__marginType = $1ee9c8b909b7ca82$export$2b18df2bc75ae422.textMargin;
        }
    }
    $1ee9c8b909b7ca82$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, null, null, opt, isNotNormal, isAttached, true, false);
}
// Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }
// TODO TextStyleModel
function $1ee9c8b909b7ca82$var$getRichItemNames(textStyleModel) {
    // Use object to remove duplicated names.
    var richItemNameMap;
    while(textStyleModel && textStyleModel !== textStyleModel.ecModel){
        var rich = (textStyleModel.option || $1ee9c8b909b7ca82$var$EMPTY_OBJ).rich;
        if (rich) {
            richItemNameMap = richItemNameMap || {};
            var richKeys = (0, $f16f2994a32ad273$export$ed97f33186d4b816)(rich);
            for(var i = 0; i < richKeys.length; i++){
                var richKey = richKeys[i];
                richItemNameMap[richKey] = 1;
            }
        }
        textStyleModel = textStyleModel.parentModel;
    }
    return richItemNameMap;
}
var $1ee9c8b909b7ca82$var$TEXT_PROPS_WITH_GLOBAL = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'textShadowColor',
    'textShadowBlur',
    'textShadowOffsetX',
    'textShadowOffsetY'
];
var $1ee9c8b909b7ca82$var$TEXT_PROPS_SELF = [
    'align',
    'lineHeight',
    'width',
    'height',
    'tag',
    'verticalAlign',
    'ellipsis'
];
var $1ee9c8b909b7ca82$var$TEXT_PROPS_BOX = [
    'padding',
    'borderWidth',
    'borderRadius',
    'borderDashOffset',
    'backgroundColor',
    'borderColor',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
function $1ee9c8b909b7ca82$var$setTokenTextStyle(textStyle, // FIXME: check/refactor for ellipsis handling of rich text.
textStyleModel, globalTextStyle, plainTextModel, richInheritPlainLabel, opt, isNotNormal, isAttached, isBlock, inRich) {
    // In merge mode, default value should not be given.
    globalTextStyle = !isNotNormal && globalTextStyle || $1ee9c8b909b7ca82$var$EMPTY_OBJ;
    var inheritColor = opt && opt.inheritColor;
    var fillColor = textStyleModel.getShallow('color');
    var strokeColor = textStyleModel.getShallow('textBorderColor');
    var opacity = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(textStyleModel.getShallow('opacity'), globalTextStyle.opacity);
    if (fillColor === 'inherit' || fillColor === 'auto') {
        if (inheritColor) fillColor = inheritColor;
        else fillColor = null;
    }
    if (strokeColor === 'inherit' || strokeColor === 'auto') {
        if (inheritColor) strokeColor = inheritColor;
        else strokeColor = null;
    }
    if (!isAttached) {
        // Only use default global textStyle.color if text is individual.
        // Otherwise it will use the strategy of attached text color because text may be on a path.
        fillColor = fillColor || globalTextStyle.color;
        strokeColor = strokeColor || globalTextStyle.textBorderColor;
    }
    if (fillColor != null) // Might not be a string, e.g, it's a function in axisLabel case; but assume that it will
    // be erased by a correct value outside.
    textStyle.fill = fillColor;
    if (strokeColor != null) textStyle.stroke = strokeColor;
    var textBorderWidth = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);
    if (textBorderWidth != null) textStyle.lineWidth = textBorderWidth;
    var textBorderType = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(textStyleModel.getShallow('textBorderType'), globalTextStyle.textBorderType);
    if (textBorderType != null) textStyle.lineDash = textBorderType;
    var textBorderDashOffset = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(textStyleModel.getShallow('textBorderDashOffset'), globalTextStyle.textBorderDashOffset);
    if (textBorderDashOffset != null) textStyle.lineDashOffset = textBorderDashOffset;
    if (!isNotNormal && opacity == null && !inRich) opacity = opt && opt.defaultOpacity;
    if (opacity != null) textStyle.opacity = opacity;
    // TODO
    if (!isNotNormal && !isAttached) // Set default finally.
    {
        if (textStyle.fill == null && opt.inheritColor) textStyle.fill = opt.inheritColor;
    }
    // Do not use `getFont` here, because merge should be supported, where
    // part of these properties may be changed in emphasis style, and the
    // others should remain their original value got from normal style.
    for(var i = 0; i < $1ee9c8b909b7ca82$var$TEXT_PROPS_WITH_GLOBAL.length; i++){
        var key = $1ee9c8b909b7ca82$var$TEXT_PROPS_WITH_GLOBAL[i];
        // props width, height, padding, margin, tag, backgroundColor, borderColor,
        // borderWidth, borderRadius, shadowColor, shadowBlur, shadowOffsetX, shadowOffsetY
        // may inappropriate to inherit from plainTextStyle.
        // And if some props is specified in default options, users may have to reset them one by one.
        // Therefore, we only allow these props to inherit from plainTextStyle.
        // `richInheritPlainLabel` is switch for backward compatibility
        var val = richInheritPlainLabel !== false && plainTextModel ? (0, $f16f2994a32ad273$export$2e94551289abb95b)(textStyleModel.getShallow(key), plainTextModel.getShallow(key), globalTextStyle[key]) : (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(textStyleModel.getShallow(key), globalTextStyle[key]);
        if (val != null) textStyle[key] = val;
    }
    for(var i = 0; i < $1ee9c8b909b7ca82$var$TEXT_PROPS_SELF.length; i++){
        var key = $1ee9c8b909b7ca82$var$TEXT_PROPS_SELF[i];
        var val = textStyleModel.getShallow(key);
        if (val != null) textStyle[key] = val;
    }
    if (textStyle.verticalAlign == null) {
        var baseline = textStyleModel.getShallow('baseline');
        if (baseline != null) textStyle.verticalAlign = baseline;
    }
    if (!isBlock || !opt.disableBox) {
        for(var i = 0; i < $1ee9c8b909b7ca82$var$TEXT_PROPS_BOX.length; i++){
            var key = $1ee9c8b909b7ca82$var$TEXT_PROPS_BOX[i];
            var val = textStyleModel.getShallow(key);
            if (val != null) textStyle[key] = val;
        }
        var borderType = textStyleModel.getShallow('borderType');
        if (borderType != null) textStyle.borderDash = borderType;
        if ((textStyle.backgroundColor === 'auto' || textStyle.backgroundColor === 'inherit') && inheritColor) textStyle.backgroundColor = inheritColor;
        if ((textStyle.borderColor === 'auto' || textStyle.borderColor === 'inherit') && inheritColor) textStyle.borderColor = inheritColor;
    }
}
function $1ee9c8b909b7ca82$export$155316a870a9d61e(opt, ecModel) {
    var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
    return (0, $f16f2994a32ad273$export$87c2784dc9fc4ab)([
        // FIXME in node-canvas fontWeight is before fontStyle
        opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '',
        opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '',
        (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px',
        opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'
    ].join(' '));
}
var $1ee9c8b909b7ca82$export$f62786d3261ab0f4 = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
function $1ee9c8b909b7ca82$export$7bdbceaf9ab378f2(label, labelStatesModels, value, getDefaultText) {
    if (!label) return;
    var obj = $1ee9c8b909b7ca82$export$f62786d3261ab0f4(label);
    obj.prevValue = obj.value;
    obj.value = value;
    var normalLabelModel = labelStatesModels.normal;
    obj.valueAnimation = normalLabelModel.get('valueAnimation');
    if (obj.valueAnimation) {
        obj.precision = normalLabelModel.get('precision');
        obj.defaultInterpolatedText = getDefaultText;
        obj.statesModels = labelStatesModels;
    }
}
function $1ee9c8b909b7ca82$export$dd6101605f5c186(textEl, dataIndex, data, animatableModel, labelFetcher) {
    var labelInnerStore = $1ee9c8b909b7ca82$export$f62786d3261ab0f4(textEl);
    if (!labelInnerStore.valueAnimation || labelInnerStore.prevValue === labelInnerStore.value) // Value not changed, no new label animation
    return;
    var defaultInterpolatedText = labelInnerStore.defaultInterpolatedText;
    // Consider the case that being animating, do not use the `obj.value`,
    // Otherwise it will jump to the `obj.value` when this new animation started.
    var currValue = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(labelInnerStore.interpolatedValue, labelInnerStore.prevValue);
    var targetValue = labelInnerStore.value;
    function during(percent) {
        var interpolated = (0, $3fa81475350067fd$export$bd0439821a1869f3)(data, labelInnerStore.precision, currValue, targetValue, percent);
        labelInnerStore.interpolatedValue = percent === 1 ? null : interpolated;
        var labelText = $1ee9c8b909b7ca82$var$getLabelText({
            labelDataIndex: dataIndex,
            labelFetcher: labelFetcher,
            defaultText: defaultInterpolatedText ? defaultInterpolatedText(interpolated) : interpolated + ''
        }, labelInnerStore.statesModels, interpolated);
        $1ee9c8b909b7ca82$export$b533918394a58529(textEl, labelText);
    }
    textEl.percent = 0;
    (labelInnerStore.prevValue == null ? (0, $d2a962ec0ef14a79$export$a121566aadcfe021) : (0, $d2a962ec0ef14a79$export$c8dce3c08436e91e))(textEl, {
        // percent is used to prevent animation from being aborted #15916
        percent: 1
    }, animatableModel, dataIndex, null, during);
}
var $1ee9c8b909b7ca82$export$2b18df2bc75ae422 = {
    minMargin: 1,
    textMargin: 2
};



var $f109fe2b5275e67f$var$PATH_COLOR = [
    'textStyle',
    'color'
];
var $f109fe2b5275e67f$var$textStyleParams = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'padding',
    'lineHeight',
    'rich',
    'width',
    'height',
    'overflow'
];
// TODO Performance improvement?
var $f109fe2b5275e67f$var$tmpText = new (0, $7d5e7dc1581f8c9a$export$2e2bcd8739ae039)();
var $f109fe2b5275e67f$var$TextStyleMixin = /** @class */ function() {
    function TextStyleMixin() {}
    /**
   * Get color property or get color from option.textStyle.color
   */ // TODO Callback
    TextStyleMixin.prototype.getTextColor = function(isEmphasis) {
        var ecModel = this.ecModel;
        return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get($f109fe2b5275e67f$var$PATH_COLOR) : null);
    };
    /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */ TextStyleMixin.prototype.getFont = function() {
        return (0, $1ee9c8b909b7ca82$export$155316a870a9d61e)({
            fontStyle: this.getShallow('fontStyle'),
            fontWeight: this.getShallow('fontWeight'),
            fontSize: this.getShallow('fontSize'),
            fontFamily: this.getShallow('fontFamily')
        }, this.ecModel);
    };
    TextStyleMixin.prototype.getTextRect = function(text) {
        var style = {
            text: text,
            verticalAlign: this.getShallow('verticalAlign') || this.getShallow('baseline')
        };
        for(var i = 0; i < $f109fe2b5275e67f$var$textStyleParams.length; i++)style[$f109fe2b5275e67f$var$textStyleParams[i]] = this.getShallow($f109fe2b5275e67f$var$textStyleParams[i]);
        $f109fe2b5275e67f$var$tmpText.useStyle(style);
        $f109fe2b5275e67f$var$tmpText.update();
        return $f109fe2b5275e67f$var$tmpText.getBoundingRect();
    };
    return TextStyleMixin;
}();
var $f109fe2b5275e67f$export$2e2bcd8739ae039 = $f109fe2b5275e67f$var$TextStyleMixin;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $339315a7b49b0f01$export$9f34de5b59222949 = [
    [
        'lineWidth',
        'width'
    ],
    [
        'stroke',
        'color'
    ],
    [
        'opacity'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ],
    [
        'lineDash',
        'type'
    ],
    [
        'lineDashOffset',
        'dashOffset'
    ],
    [
        'lineCap',
        'cap'
    ],
    [
        'lineJoin',
        'join'
    ],
    [
        'miterLimit'
    ]
];
var $339315a7b49b0f01$var$getLineStyle = (0, $77cc5e805eb51edf$export$2e2bcd8739ae039)($339315a7b49b0f01$export$9f34de5b59222949);
var $339315a7b49b0f01$export$91eeeeed4a69a7e7 = /** @class */ function() {
    function LineStyleMixin() {}
    LineStyleMixin.prototype.getLineStyle = function(excludes) {
        return $339315a7b49b0f01$var$getLineStyle(this, excludes);
    };
    return LineStyleMixin;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $d6d3c4b634b15028$export$ffb0bba5dde0130b = [
    [
        'fill',
        'color'
    ],
    [
        'stroke',
        'borderColor'
    ],
    [
        'lineWidth',
        'borderWidth'
    ],
    [
        'opacity'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ],
    [
        'lineDash',
        'borderType'
    ],
    [
        'lineDashOffset',
        'borderDashOffset'
    ],
    [
        'lineCap',
        'borderCap'
    ],
    [
        'lineJoin',
        'borderJoin'
    ],
    [
        'miterLimit',
        'borderMiterLimit'
    ]
];
var $d6d3c4b634b15028$var$getItemStyle = (0, $77cc5e805eb51edf$export$2e2bcd8739ae039)($d6d3c4b634b15028$export$ffb0bba5dde0130b);
var $d6d3c4b634b15028$export$e4f01e48d6fda412 = /** @class */ function() {
    function ItemStyleMixin() {}
    ItemStyleMixin.prototype.getItemStyle = function(excludes, includes) {
        return $d6d3c4b634b15028$var$getItemStyle(this, excludes, includes);
    };
    return ItemStyleMixin;
}();



var $37821cf56da37613$var$Model = /** @class */ function() {
    function Model(option, parentModel, ecModel) {
        this.parentModel = parentModel;
        this.ecModel = ecModel;
        this.option = option;
    // Simple optimization
    // if (this.init) {
    //     if (arguments.length <= 4) {
    //         this.init(option, parentModel, ecModel, extraOpt);
    //     }
    //     else {
    //         this.init.apply(this, arguments);
    //     }
    // }
    }
    Model.prototype.init = function(option, parentModel, ecModel) {
        var rest = [];
        for(var _i = 3; _i < arguments.length; _i++)rest[_i - 3] = arguments[_i];
    };
    /**
   * Merge the input option to me.
   */ Model.prototype.mergeOption = function(option, ecModel) {
        (0, $f16f2994a32ad273$export$4950aa0f605343fb)(this.option, option, true);
    };
    // `path` can be 'a.b.c', so the return value type have to be `ModelOption`
    // TODO: TYPE strict key check?
    // get(path: string | string[], ignoreParent?: boolean): ModelOption;
    Model.prototype.get = function(path, ignoreParent) {
        if (path == null) return this.option;
        return this._doGet(this.parsePath(path), !ignoreParent && this.parentModel);
    };
    Model.prototype.getShallow = function(key, ignoreParent) {
        var option = this.option;
        var val = option == null ? option : option[key];
        if (val == null && !ignoreParent) {
            var parentModel = this.parentModel;
            if (parentModel) // FIXME:TS do not know how to make it works
            val = parentModel.getShallow(key);
        }
        return val;
    };
    // `path` can be 'a.b.c', so the return value type have to be `Model<ModelOption>`
    // getModel(path: string | string[], parentModel?: Model): Model;
    // TODO 'a.b.c' is deprecated
    Model.prototype.getModel = function(path, parentModel) {
        var hasPath = path != null;
        var pathFinal = hasPath ? this.parsePath(path) : null;
        var obj = hasPath ? this._doGet(pathFinal) : this.option;
        parentModel = parentModel || this.parentModel && this.parentModel.getModel(this.resolveParentPath(pathFinal));
        return new Model(obj, parentModel, this.ecModel);
    };
    /**
   * If model has option
   */ Model.prototype.isEmpty = function() {
        return this.option == null;
    };
    Model.prototype.restoreData = function() {};
    // Pending
    Model.prototype.clone = function() {
        var Ctor = this.constructor;
        return new Ctor((0, $f16f2994a32ad273$export$9cd59f9826255e47)(this.option));
    };
    // setReadOnly(properties): void {
    // clazzUtil.setReadOnly(this, properties);
    // }
    // If path is null/undefined, return null/undefined.
    Model.prototype.parsePath = function(path) {
        if (typeof path === 'string') return path.split('.');
        return path;
    };
    // Resolve path for parent. Perhaps useful when parent use a different property.
    // Default to be a identity resolver.
    // Can be modified to a different resolver.
    Model.prototype.resolveParentPath = function(path) {
        return path;
    };
    // FIXME:TS check whether put this method here
    Model.prototype.isAnimationEnabled = function() {
        if (!(0, $6d0397515b55cc48$export$2e2bcd8739ae039).node && this.option) {
            if (this.option.animation != null) return !!this.option.animation;
            else if (this.parentModel) return this.parentModel.isAnimationEnabled();
        }
    };
    Model.prototype._doGet = function(pathArr, parentModel) {
        var obj = this.option;
        if (!pathArr) return obj;
        for(var i = 0; i < pathArr.length; i++){
            // Ignore empty
            if (!pathArr[i]) continue;
            // obj could be number/string/... (like 0)
            obj = obj && (typeof obj === "undefined" ? "undefined" : (0, $7E0eS._)(obj)) === 'object' ? obj[pathArr[i]] : null;
            if (obj == null) break;
        }
        if (obj == null && parentModel) obj = parentModel._doGet(this.resolveParentPath(pathArr), parentModel.parentModel);
        return obj;
    };
    return Model;
}();
// Enable Model.extend.
(0, $7904d4b709390668$export$cd4c3a4dca301c70)($37821cf56da37613$var$Model);
(0, $7904d4b709390668$export$e1aac4552ae82081)($37821cf56da37613$var$Model);
(0, $f16f2994a32ad273$export$e36fc9d62a853069)($37821cf56da37613$var$Model, (0, $339315a7b49b0f01$export$91eeeeed4a69a7e7));
(0, $f16f2994a32ad273$export$e36fc9d62a853069)($37821cf56da37613$var$Model, (0, $d6d3c4b634b15028$export$e4f01e48d6fda412));
(0, $f16f2994a32ad273$export$e36fc9d62a853069)($37821cf56da37613$var$Model, (0, $8abdbeda94795c36$export$a3a0ed7e2dd84c9e));
(0, $f16f2994a32ad273$export$e36fc9d62a853069)($37821cf56da37613$var$Model, (0, $f109fe2b5275e67f$export$2e2bcd8739ae039));
var $37821cf56da37613$export$2e2bcd8739ae039 = $37821cf56da37613$var$Model;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


// A random offset
var $b2c0501cd47c18d8$var$base = Math.round(Math.random() * 10);
function $b2c0501cd47c18d8$export$6d2b3473b0986646(type) {
    // Considering the case of crossing js context,
    // use Math.random to make id as unique as possible.
    return [
        type || '',
        $b2c0501cd47c18d8$var$base++
    ].join('_');
}
function $b2c0501cd47c18d8$export$b9faf30b7d655a6f(target) {
    var subTypeDefaulters = {};
    target.registerSubTypeDefaulter = function(componentType, defaulter) {
        var componentTypeInfo = (0, $7904d4b709390668$export$fbe18865d303bf01)(componentType);
        subTypeDefaulters[componentTypeInfo.main] = defaulter;
    };
    target.determineSubType = function(componentType, option) {
        var type = option.type;
        if (!type) {
            var componentTypeMain = (0, $7904d4b709390668$export$fbe18865d303bf01)(componentType).main;
            if (target.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) type = subTypeDefaulters[componentTypeMain](option);
        }
        return type;
    };
}
function $b2c0501cd47c18d8$export$ce592d345a3ec040(entity, dependencyGetter) {
    /**
   * @param targetNameList Target Component type list.
   *                       Can be ['aa', 'bb', 'aa.xx']
   * @param fullNameList By which we can build dependency graph.
   * @param callback Params: componentType, dependencies.
   * @param context Scope of callback.
   */ entity.topologicalTravel = function(targetNameList, fullNameList, callback, context) {
        if (!targetNameList.length) return;
        var result = makeDepndencyGraph(fullNameList);
        var graph = result.graph;
        var noEntryList = result.noEntryList;
        var targetNameSet = {};
        $f16f2994a32ad273$export$79b2f7037acddd43(targetNameList, function(name) {
            targetNameSet[name] = true;
        });
        while(noEntryList.length){
            var currComponentType = noEntryList.pop();
            var currVertex = graph[currComponentType];
            var isInTargetNameSet = !!targetNameSet[currComponentType];
            if (isInTargetNameSet) {
                callback.call(context, currComponentType, currVertex.originalDeps.slice());
                delete targetNameSet[currComponentType];
            }
            $f16f2994a32ad273$export$79b2f7037acddd43(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
        }
        $f16f2994a32ad273$export$79b2f7037acddd43(targetNameSet, function() {
            var errMsg = '';
            throw new Error(errMsg);
        });
        function removeEdge(succComponentType) {
            graph[succComponentType].entryCount--;
            if (graph[succComponentType].entryCount === 0) noEntryList.push(succComponentType);
        }
        // Consider this case: legend depends on series, and we call
        // chart.setOption({series: [...]}), where only series is in option.
        // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
        // not be called, but only sereis.mergeOption is called. Thus legend
        // have no chance to update its local record about series (like which
        // name of series is available in legend).
        function removeEdgeAndAdd(succComponentType) {
            targetNameSet[succComponentType] = true;
            removeEdge(succComponentType);
        }
    };
    function makeDepndencyGraph(fullNameList) {
        var graph = {};
        var noEntryList = [];
        $f16f2994a32ad273$export$79b2f7037acddd43(fullNameList, function(name) {
            var thisItem = createDependencyGraphItem(graph, name);
            var originalDeps = thisItem.originalDeps = dependencyGetter(name);
            var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
            thisItem.entryCount = availableDeps.length;
            if (thisItem.entryCount === 0) noEntryList.push(name);
            $f16f2994a32ad273$export$79b2f7037acddd43(availableDeps, function(dependentName) {
                if ($f16f2994a32ad273$export$305f7d4e9d4624f2(thisItem.predecessor, dependentName) < 0) thisItem.predecessor.push(dependentName);
                var thatItem = createDependencyGraphItem(graph, dependentName);
                if ($f16f2994a32ad273$export$305f7d4e9d4624f2(thatItem.successor, dependentName) < 0) thatItem.successor.push(name);
            });
        });
        return {
            graph: graph,
            noEntryList: noEntryList
        };
    }
    function createDependencyGraphItem(graph, name) {
        if (!graph[name]) graph[name] = {
            predecessor: [],
            successor: []
        };
        return graph[name];
    }
    function getAvailableDependencies(originalDeps, fullNameList) {
        var availableDeps = [];
        $f16f2994a32ad273$export$79b2f7037acddd43(originalDeps, function(dep) {
            $f16f2994a32ad273$export$305f7d4e9d4624f2(fullNameList, dep) >= 0 && availableDeps.push(dep);
        });
        return availableDeps;
    }
}
function $b2c0501cd47c18d8$export$68acc510e46fef2(superOption, subOption) {
    // See also `model/Component.ts#getDefaultOption`
    return $f16f2994a32ad273$export$4950aa0f605343fb($f16f2994a32ad273$export$4950aa0f605343fb({}, superOption, true), subOption, true);
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Layout helpers for each component positioning



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ /**
 * Language: English.
 */ var $61a350be6a82db39$export$2e2bcd8739ae039 = {
    time: {
        month: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        monthAbbr: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        dayOfWeek: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],
        dayOfWeekAbbr: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ]
    },
    legend: {
        selector: {
            all: 'All',
            inverse: 'Inv'
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: 'Box Select',
                polygon: 'Lasso Select',
                lineX: 'Horizontally Select',
                lineY: 'Vertically Select',
                keep: 'Keep Selections',
                clear: 'Clear Selections'
            }
        },
        dataView: {
            title: 'Data View',
            lang: [
                'Data View',
                'Close',
                'Refresh'
            ]
        },
        dataZoom: {
            title: {
                zoom: 'Zoom',
                back: 'Zoom Reset'
            }
        },
        magicType: {
            title: {
                line: 'Switch to Line Chart',
                bar: 'Switch to Bar Chart',
                stack: 'Stack',
                tiled: 'Tile'
            }
        },
        restore: {
            title: 'Restore'
        },
        saveAsImage: {
            title: 'Save as Image',
            lang: [
                'Right Click to Save Image'
            ]
        }
    },
    series: {
        typeNames: {
            pie: 'Pie chart',
            bar: 'Bar chart',
            line: 'Line chart',
            scatter: 'Scatter plot',
            effectScatter: 'Ripple scatter plot',
            radar: 'Radar chart',
            tree: 'Tree',
            treemap: 'Treemap',
            boxplot: 'Boxplot',
            candlestick: 'Candlestick',
            k: 'K line chart',
            heatmap: 'Heat map',
            map: 'Map',
            parallel: 'Parallel coordinate map',
            lines: 'Line graph',
            graph: 'Relationship graph',
            sankey: 'Sankey diagram',
            funnel: 'Funnel chart',
            gauge: 'Gauge',
            pictorialBar: 'Pictorial bar',
            themeRiver: 'Theme River Map',
            sunburst: 'Sunburst',
            custom: 'Custom chart',
            chart: 'Chart'
        }
    },
    aria: {
        general: {
            withTitle: 'This is a chart about "{title}"',
            withoutTitle: 'This is a chart'
        },
        series: {
            single: {
                prefix: '',
                withName: ' with type {seriesType} named {seriesName}.',
                withoutName: ' with type {seriesType}.'
            },
            multiple: {
                prefix: '. It consists of {seriesCount} series count.',
                withName: ' The {seriesId} series is a {seriesType} representing {seriesName}.',
                withoutName: ' The {seriesId} series is a {seriesType}.',
                separator: {
                    middle: '',
                    end: ''
                }
            }
        },
        data: {
            allData: 'The data is as follows: ',
            partialData: 'The first {displayCnt} items are: ',
            withName: 'the data for {name} is {value}',
            withoutName: '{value}',
            separator: {
                middle: ', ',
                end: '. '
            }
        }
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ var $9d135da5bd402ad5$export$2e2bcd8739ae039 = {
    time: {
        month: [
            "\u4E00\u6708",
            "\u4E8C\u6708",
            "\u4E09\u6708",
            "\u56DB\u6708",
            "\u4E94\u6708",
            "\u516D\u6708",
            "\u4E03\u6708",
            "\u516B\u6708",
            "\u4E5D\u6708",
            "\u5341\u6708",
            "\u5341\u4E00\u6708",
            "\u5341\u4E8C\u6708"
        ],
        monthAbbr: [
            "1\u6708",
            "2\u6708",
            "3\u6708",
            "4\u6708",
            "5\u6708",
            "6\u6708",
            "7\u6708",
            "8\u6708",
            "9\u6708",
            "10\u6708",
            "11\u6708",
            "12\u6708"
        ],
        dayOfWeek: [
            "\u661F\u671F\u65E5",
            "\u661F\u671F\u4E00",
            "\u661F\u671F\u4E8C",
            "\u661F\u671F\u4E09",
            "\u661F\u671F\u56DB",
            "\u661F\u671F\u4E94",
            "\u661F\u671F\u516D"
        ],
        dayOfWeekAbbr: [
            "\u65E5",
            "\u4E00",
            "\u4E8C",
            "\u4E09",
            "\u56DB",
            "\u4E94",
            "\u516D"
        ]
    },
    legend: {
        selector: {
            all: "\u5168\u9009",
            inverse: "\u53CD\u9009"
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: "\u77E9\u5F62\u9009\u62E9",
                polygon: "\u5708\u9009",
                lineX: "\u6A2A\u5411\u9009\u62E9",
                lineY: "\u7EB5\u5411\u9009\u62E9",
                keep: "\u4FDD\u6301\u9009\u62E9",
                clear: "\u6E05\u9664\u9009\u62E9"
            }
        },
        dataView: {
            title: "\u6570\u636E\u89C6\u56FE",
            lang: [
                "\u6570\u636E\u89C6\u56FE",
                "\u5173\u95ED",
                "\u5237\u65B0"
            ]
        },
        dataZoom: {
            title: {
                zoom: "\u533A\u57DF\u7F29\u653E",
                back: "\u533A\u57DF\u7F29\u653E\u8FD8\u539F"
            }
        },
        magicType: {
            title: {
                line: "\u5207\u6362\u4E3A\u6298\u7EBF\u56FE",
                bar: "\u5207\u6362\u4E3A\u67F1\u72B6\u56FE",
                stack: "\u5207\u6362\u4E3A\u5806\u53E0",
                tiled: "\u5207\u6362\u4E3A\u5E73\u94FA"
            }
        },
        restore: {
            title: "\u8FD8\u539F"
        },
        saveAsImage: {
            title: "\u4FDD\u5B58\u4E3A\u56FE\u7247",
            lang: [
                "\u53F3\u952E\u53E6\u5B58\u4E3A\u56FE\u7247"
            ]
        }
    },
    series: {
        typeNames: {
            pie: "\u997C\u56FE",
            bar: "\u67F1\u72B6\u56FE",
            line: "\u6298\u7EBF\u56FE",
            scatter: "\u6563\u70B9\u56FE",
            effectScatter: "\u6D9F\u6F2A\u6563\u70B9\u56FE",
            radar: "\u96F7\u8FBE\u56FE",
            tree: "\u6811\u56FE",
            treemap: "\u77E9\u5F62\u6811\u56FE",
            boxplot: "\u7BB1\u578B\u56FE",
            candlestick: "K\u7EBF\u56FE",
            k: "K\u7EBF\u56FE",
            heatmap: "\u70ED\u529B\u56FE",
            map: "\u5730\u56FE",
            parallel: "\u5E73\u884C\u5750\u6807\u56FE",
            lines: "\u7EBF\u56FE",
            graph: "\u5173\u7CFB\u56FE",
            sankey: "\u6851\u57FA\u56FE",
            funnel: "\u6F0F\u6597\u56FE",
            gauge: "\u4EEA\u8868\u76D8\u56FE",
            pictorialBar: "\u8C61\u5F62\u67F1\u56FE",
            themeRiver: "\u4E3B\u9898\u6CB3\u6D41\u56FE",
            sunburst: "\u65ED\u65E5\u56FE",
            custom: "\u81EA\u5B9A\u4E49\u56FE\u8868",
            chart: "\u56FE\u8868"
        }
    },
    aria: {
        general: {
            withTitle: "\u8FD9\u662F\u4E00\u4E2A\u5173\u4E8E\u201C{title}\u201D\u7684\u56FE\u8868\u3002",
            withoutTitle: "\u8FD9\u662F\u4E00\u4E2A\u56FE\u8868\uFF0C"
        },
        series: {
            single: {
                prefix: '',
                withName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\uFF0C\u8868\u793A{seriesName}\u3002",
                withoutName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\u3002"
            },
            multiple: {
                prefix: "\u5B83\u7531{seriesCount}\u4E2A\u56FE\u8868\u7CFB\u5217\u7EC4\u6210\u3002",
                withName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A\u8868\u793A{seriesName}\u7684{seriesType}\uFF0C",
                withoutName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A{seriesType}\uFF0C",
                separator: {
                    middle: "\uFF1B",
                    end: "\u3002"
                }
            }
        },
        data: {
            allData: "\u5176\u6570\u636E\u662F\u2014\u2014",
            partialData: "\u5176\u4E2D\uFF0C\u524D{displayCnt}\u9879\u662F\u2014\u2014",
            withName: "{name}\u7684\u6570\u636E\u662F{value}",
            withoutName: '{value}',
            separator: {
                middle: "\uFF0C",
                end: ''
            }
        }
    }
};



var $79b0d3d61f36c1fa$var$LOCALE_ZH = 'ZH';
var $79b0d3d61f36c1fa$var$LOCALE_EN = 'EN';
var $79b0d3d61f36c1fa$var$DEFAULT_LOCALE = $79b0d3d61f36c1fa$var$LOCALE_EN;
var $79b0d3d61f36c1fa$var$localeStorage = {};
var $79b0d3d61f36c1fa$var$localeModels = {};
var $79b0d3d61f36c1fa$export$9a2147b3808d4c6b = !(0, $6d0397515b55cc48$export$2e2bcd8739ae039).domSupported ? $79b0d3d61f36c1fa$var$DEFAULT_LOCALE : function() {
    var langStr = (document.documentElement.lang || navigator.language || navigator.browserLanguage || $79b0d3d61f36c1fa$var$DEFAULT_LOCALE).toUpperCase();
    return langStr.indexOf($79b0d3d61f36c1fa$var$LOCALE_ZH) > -1 ? $79b0d3d61f36c1fa$var$LOCALE_ZH : $79b0d3d61f36c1fa$var$DEFAULT_LOCALE;
}();
function $79b0d3d61f36c1fa$export$bab6a7822cc1e2cd(locale, localeObj) {
    locale = locale.toUpperCase();
    $79b0d3d61f36c1fa$var$localeModels[locale] = new (0, $37821cf56da37613$export$2e2bcd8739ae039)(localeObj);
    $79b0d3d61f36c1fa$var$localeStorage[locale] = localeObj;
}
function $79b0d3d61f36c1fa$export$ddc371781a6af754(locale) {
    if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(locale)) {
        var localeObj = $79b0d3d61f36c1fa$var$localeStorage[locale.toUpperCase()] || {};
        if (locale === $79b0d3d61f36c1fa$var$LOCALE_ZH || locale === $79b0d3d61f36c1fa$var$LOCALE_EN) return (0, $f16f2994a32ad273$export$9cd59f9826255e47)(localeObj);
        else return (0, $f16f2994a32ad273$export$4950aa0f605343fb)((0, $f16f2994a32ad273$export$9cd59f9826255e47)(localeObj), (0, $f16f2994a32ad273$export$9cd59f9826255e47)($79b0d3d61f36c1fa$var$localeStorage[$79b0d3d61f36c1fa$var$DEFAULT_LOCALE]), false);
    } else return (0, $f16f2994a32ad273$export$4950aa0f605343fb)((0, $f16f2994a32ad273$export$9cd59f9826255e47)(locale), (0, $f16f2994a32ad273$export$9cd59f9826255e47)($79b0d3d61f36c1fa$var$localeStorage[$79b0d3d61f36c1fa$var$DEFAULT_LOCALE]), false);
}
function $79b0d3d61f36c1fa$export$37cc638e0e11865f(lang) {
    return $79b0d3d61f36c1fa$var$localeModels[lang];
}
function $79b0d3d61f36c1fa$export$1188f179b2597821() {
    return $79b0d3d61f36c1fa$var$localeModels[$79b0d3d61f36c1fa$var$DEFAULT_LOCALE];
}
// Default locale
$79b0d3d61f36c1fa$export$bab6a7822cc1e2cd($79b0d3d61f36c1fa$var$LOCALE_EN, (0, $61a350be6a82db39$export$2e2bcd8739ae039));
$79b0d3d61f36c1fa$export$bab6a7822cc1e2cd($79b0d3d61f36c1fa$var$LOCALE_ZH, (0, $9d135da5bd402ad5$export$2e2bcd8739ae039));



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $cf43ca9fea251347$var$_impl = null;
function $cf43ca9fea251347$export$11977f1e90ef55cf(impl) {
    if (!$cf43ca9fea251347$var$_impl) $cf43ca9fea251347$var$_impl = impl;
}
function $cf43ca9fea251347$export$e79b20ac82c2d660() {
    return $cf43ca9fea251347$var$_impl;
}
function $cf43ca9fea251347$export$770ec3eb53b5689b(scale, opt) {
    var scaleBreakHelper = $cf43ca9fea251347$export$e79b20ac82c2d660();
    var breakOption = opt.breakOption;
    var breakParsed = opt.breakParsed;
    if (!breakParsed && scaleBreakHelper) breakParsed = scaleBreakHelper.parseAxisBreakOption(breakOption, scale);
    return breakParsed;
}
function $cf43ca9fea251347$export$20734ee5f1d5720f(scale) {
    var brk = scale.brk;
    return brk ? brk.breaks : [];
}
function $cf43ca9fea251347$export$fec008222a1db2dc(scale) {
    var brk = scale.brk;
    return brk ? brk.hasBreaks() : false;
}


var $8a51e097d5164103$export$32c0454ceff7f92d = 1000;
var $8a51e097d5164103$export$35acaebf644db34e = $8a51e097d5164103$export$32c0454ceff7f92d * 60;
var $8a51e097d5164103$export$82541edf19e5e3b0 = $8a51e097d5164103$export$35acaebf644db34e * 60;
var $8a51e097d5164103$export$a97a1358cbb650ab = $8a51e097d5164103$export$82541edf19e5e3b0 * 24;
var $8a51e097d5164103$export$99cafda57477293d = $8a51e097d5164103$export$a97a1358cbb650ab * 365;
var $8a51e097d5164103$var$primaryTimeUnitFormatterMatchers = {
    year: /({yyyy}|{yy})/,
    month: /({MMMM}|{MMM}|{MM}|{M})/,
    day: /({dd}|{d})/,
    hour: /({HH}|{H}|{hh}|{h})/,
    minute: /({mm}|{m})/,
    second: /({ss}|{s})/,
    millisecond: /({SSS}|{S})/
};
var $8a51e097d5164103$var$defaultFormatterSeed = {
    year: '{yyyy}',
    month: '{MMM}',
    day: '{d}',
    hour: '{HH}:{mm}',
    minute: '{HH}:{mm}',
    second: '{HH}:{mm}:{ss}',
    millisecond: '{HH}:{mm}:{ss} {SSS}'
};
var $8a51e097d5164103$var$defaultFullFormatter = '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}';
var $8a51e097d5164103$var$fullDayFormatter = '{yyyy}-{MM}-{dd}';
var $8a51e097d5164103$export$445bdbd8d2334e40 = {
    year: '{yyyy}',
    month: '{yyyy}-{MM}',
    day: $8a51e097d5164103$var$fullDayFormatter,
    hour: $8a51e097d5164103$var$fullDayFormatter + ' ' + $8a51e097d5164103$var$defaultFormatterSeed.hour,
    minute: $8a51e097d5164103$var$fullDayFormatter + ' ' + $8a51e097d5164103$var$defaultFormatterSeed.minute,
    second: $8a51e097d5164103$var$fullDayFormatter + ' ' + $8a51e097d5164103$var$defaultFormatterSeed.second,
    millisecond: $8a51e097d5164103$var$defaultFullFormatter
};
var $8a51e097d5164103$export$87100da04d711986 = [
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
var $8a51e097d5164103$export$833c398a55654bb7 = [
    'year',
    'half-year',
    'quarter',
    'month',
    'week',
    'half-week',
    'day',
    'half-day',
    'quarter-day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
function $8a51e097d5164103$export$f16a827770bdffb5(formatter) {
    // Keep the logic the same with function `leveledFormat`.
    return !$f16f2994a32ad273$export$844ec244b1367d54(formatter) && !$f16f2994a32ad273$export$f6e2535fb5126e54(formatter) ? $8a51e097d5164103$var$parseTimeAxisLabelFormatterDictionary(formatter) : formatter;
}
/**
 * The final generated dictionary is like:
 *  generated_dict = {
 *      year: {
 *          year: ['{yyyy}', ...<higher_levels_if_any>]
 *      },
 *      month: {
 *          year: ['{yyyy} {MMM}', ...<higher_levels_if_any>],
 *          month: ['{MMM}', ...<higher_levels_if_any>]
 *      },
 *      day: {
 *          year: ['{yyyy} {MMM} {d}', ...<higher_levels_if_any>],
 *          month: ['{MMM} {d}', ...<higher_levels_if_any>],
 *          day: ['{d}', ...<higher_levels_if_any>]
 *      },
 *      ...
 *  }
 *
 * In echarts option, users can specify the entire dictionary or typically just:
 *  {formatter: {
 *      year: '{yyyy}', // Or an array of leveled templates: `['{yyyy}', '{bold1|{yyyy}}', ...]`,
 *                      // corresponding to `[level0, level1, level2, ...]`.
 *      month: '{MMM}',
 *      day: '{d}',
 *      hour: '{HH}:{mm}',
 *      second: '{HH}:{mm}',
 *      ...
 *  }}
 *  If any time unit is not specified in echarts option, the default template is used,
 *  such as `['{yyyy}', {primary|{yyyy}']`.
 *
 * The `tick.level` is only used to read string from each array, meaning the style type.
 *
 * Let `lowerUnit = getUnitFromValue(tick.value)`.
 * The non-break axis ticks only use `generated_dict[lowerUnit][lowerUnit][level]`.
 * The break axis ticks may use `generated_dict[lowerUnit][upperUnit][level]`, because:
 *  Consider the case: the non-break ticks are `16th, 23th, Feb, 7th, ...`, where `Feb` is in the break
 *  range and pruned by breaks, and the break ends might be in lower time unit than day. e.g., break start
 *  is `Jan 25th 18:00`(in unit `hour`) and break end is `Feb 6th 18:30` (in unit `minute`). Thus the break
 *  label prefers `Jan 25th 18:00` and `Feb 6th 18:30` rather than only `18:00` and `18:30`, otherwise it
 *  causes misleading.
 *  In this case, the tick of the break start and end will both be:
 *      `{level: 1, lowerTimeUnit: 'minute', upperTimeUnit: 'month'}`
 *  And get the final template by `generated_dict[lowerTimeUnit][upperTimeUnit][level]`.
 *  Note that the time unit can not be calculated directly by a single tick value, since the two breaks have
 *  to be at the same time unit to avoid awkward appearance. i.e., `Jan 25th 18:00` is in the time unit "hour"
 *  but we need it to be "minute", following `Feb 6th 18:30`.
 */ function $8a51e097d5164103$var$parseTimeAxisLabelFormatterDictionary(dictOption) {
    dictOption = dictOption || {};
    var dict = {};
    // Currently if any template is specified by user, it may contain rich text tag,
    // such as `'{my_bold|{YYYY}}'`, thus we do add highlight style to it.
    // (Note that nested tag (`'{some|{some2|xxx}}'`) in rich text is not supported yet.)
    var canAddHighlight = true;
    $f16f2994a32ad273$export$79b2f7037acddd43($8a51e097d5164103$export$87100da04d711986, function(lowestUnit) {
        canAddHighlight && (canAddHighlight = dictOption[lowestUnit] == null);
    });
    $f16f2994a32ad273$export$79b2f7037acddd43($8a51e097d5164103$export$87100da04d711986, function(lowestUnit, lowestUnitIdx) {
        var upperDictOption = dictOption[lowestUnit];
        dict[lowestUnit] = {};
        var lowerTpl = null;
        for(var upperUnitIdx = lowestUnitIdx; upperUnitIdx >= 0; upperUnitIdx--){
            var upperUnit = $8a51e097d5164103$export$87100da04d711986[upperUnitIdx];
            var upperDictItemOption = $f16f2994a32ad273$export$a6cdc56e425d0d0a(upperDictOption) && !$f16f2994a32ad273$export$43bee75e5e14138e(upperDictOption) ? upperDictOption[upperUnit] : upperDictOption;
            var tplArr = void 0;
            if ($f16f2994a32ad273$export$43bee75e5e14138e(upperDictItemOption)) {
                tplArr = upperDictItemOption.slice();
                lowerTpl = tplArr[0] || '';
            } else if ($f16f2994a32ad273$export$844ec244b1367d54(upperDictItemOption)) {
                lowerTpl = upperDictItemOption;
                tplArr = [
                    lowerTpl
                ];
            } else {
                if (lowerTpl == null) lowerTpl = $8a51e097d5164103$var$defaultFormatterSeed[lowestUnit];
                else if (!$8a51e097d5164103$var$primaryTimeUnitFormatterMatchers[upperUnit].test(lowerTpl)) lowerTpl = dict[upperUnit][upperUnit][0] + " " + lowerTpl;
                tplArr = [
                    lowerTpl
                ];
                if (canAddHighlight) tplArr[1] = "{primary|" + lowerTpl + "}";
            }
            dict[lowestUnit][upperUnit] = tplArr;
        }
    });
    return dict;
}
function $8a51e097d5164103$export$5d04458e2a6c373e(str, len) {
    str += '';
    return '0000'.substr(0, len - str.length) + str;
}
function $8a51e097d5164103$export$1da4b91a25d7e1c8(timeUnit) {
    switch(timeUnit){
        case 'half-year':
        case 'quarter':
            return 'month';
        case 'week':
        case 'half-week':
            return 'day';
        case 'half-day':
        case 'quarter-day':
            return 'hour';
        default:
            // year, minutes, second, milliseconds
            return timeUnit;
    }
}
function $8a51e097d5164103$export$beb5920b69c13da(timeUnit) {
    return timeUnit === $8a51e097d5164103$export$1da4b91a25d7e1c8(timeUnit);
}
function $8a51e097d5164103$export$124c820721c4f66b(timeUnit) {
    switch(timeUnit){
        case 'year':
        case 'month':
            return 'day';
        case 'millisecond':
            return 'millisecond';
        default:
            // Also for day, hour, minute, second
            return 'second';
    }
}
function $8a51e097d5164103$export$d9468344d3651243(// Note: The result based on `isUTC` are totally different, which can not be just simply
// substituted by the result without `isUTC`. So we make the param `isUTC` mandatory.
time, template, isUTC, lang) {
    var date = $104896d282bd296f$export$6b862160d295c8e(time);
    var y = date[$8a51e097d5164103$export$8d046fefed9a548e(isUTC)]();
    var M = date[$8a51e097d5164103$export$5c242a801a23eec7(isUTC)]() + 1;
    var q = Math.floor((M - 1) / 3) + 1;
    var d = date[$8a51e097d5164103$export$4189e6cbc9753260(isUTC)]();
    var e = date['get' + (isUTC ? 'UTC' : '') + 'Day']();
    var H = date[$8a51e097d5164103$export$8b40b55b3c06cbe2(isUTC)]();
    var h = (H - 1) % 12 + 1;
    var m = date[$8a51e097d5164103$export$8807847c5c71eded(isUTC)]();
    var s = date[$8a51e097d5164103$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$8a51e097d5164103$export$312207a92d041116(isUTC)]();
    var a = H >= 12 ? 'pm' : 'am';
    var A = a.toUpperCase();
    var localeModel = lang instanceof (0, $37821cf56da37613$export$2e2bcd8739ae039) ? lang : (0, $79b0d3d61f36c1fa$export$37cc638e0e11865f)(lang || (0, $79b0d3d61f36c1fa$export$9a2147b3808d4c6b)) || (0, $79b0d3d61f36c1fa$export$1188f179b2597821)();
    var timeModel = localeModel.getModel('time');
    var month = timeModel.get('month');
    var monthAbbr = timeModel.get('monthAbbr');
    var dayOfWeek = timeModel.get('dayOfWeek');
    var dayOfWeekAbbr = timeModel.get('dayOfWeekAbbr');
    return (template || '').replace(/{a}/g, a + '').replace(/{A}/g, A + '').replace(/{yyyy}/g, y + '').replace(/{yy}/g, $8a51e097d5164103$export$5d04458e2a6c373e(y % 100 + '', 2)).replace(/{Q}/g, q + '').replace(/{MMMM}/g, month[M - 1]).replace(/{MMM}/g, monthAbbr[M - 1]).replace(/{MM}/g, $8a51e097d5164103$export$5d04458e2a6c373e(M, 2)).replace(/{M}/g, M + '').replace(/{dd}/g, $8a51e097d5164103$export$5d04458e2a6c373e(d, 2)).replace(/{d}/g, d + '').replace(/{eeee}/g, dayOfWeek[e]).replace(/{ee}/g, dayOfWeekAbbr[e]).replace(/{e}/g, e + '').replace(/{HH}/g, $8a51e097d5164103$export$5d04458e2a6c373e(H, 2)).replace(/{H}/g, H + '').replace(/{hh}/g, $8a51e097d5164103$export$5d04458e2a6c373e(h + '', 2)).replace(/{h}/g, h + '').replace(/{mm}/g, $8a51e097d5164103$export$5d04458e2a6c373e(m, 2)).replace(/{m}/g, m + '').replace(/{ss}/g, $8a51e097d5164103$export$5d04458e2a6c373e(s, 2)).replace(/{s}/g, s + '').replace(/{SSS}/g, $8a51e097d5164103$export$5d04458e2a6c373e(S, 3)).replace(/{S}/g, S + '');
}
function $8a51e097d5164103$export$fe777b6293828b5d(tick, idx, formatter, lang, isUTC) {
    var template = null;
    if ($f16f2994a32ad273$export$844ec244b1367d54(formatter)) // Single formatter for all units at all levels
    template = formatter;
    else if ($f16f2994a32ad273$export$f6e2535fb5126e54(formatter)) {
        var extra = {
            time: tick.time,
            level: tick.time ? tick.time.level : 0
        };
        var scaleBreakHelper = (0, $cf43ca9fea251347$export$e79b20ac82c2d660)();
        if (scaleBreakHelper) scaleBreakHelper.makeAxisLabelFormatterParamBreak(extra, tick["break"]);
        template = formatter(tick.value, idx, extra);
    } else {
        var tickTime = tick.time;
        if (tickTime) {
            var leveledTplArr = formatter[tickTime.lowerTimeUnit][tickTime.upperTimeUnit];
            template = leveledTplArr[Math.min(tickTime.level, leveledTplArr.length - 1)] || '';
        } else {
            // tick may be from customTicks or timeline therefore no tick.time.
            var unit = $8a51e097d5164103$export$4dfb0417ad6555b7(tick.value, isUTC);
            template = formatter[unit][unit][0];
        }
    }
    return $8a51e097d5164103$export$d9468344d3651243(new Date(tick.value), template, isUTC, lang);
}
function $8a51e097d5164103$export$4dfb0417ad6555b7(value, isUTC) {
    var date = $104896d282bd296f$export$6b862160d295c8e(value);
    var M = date[$8a51e097d5164103$export$5c242a801a23eec7(isUTC)]() + 1;
    var d = date[$8a51e097d5164103$export$4189e6cbc9753260(isUTC)]();
    var h = date[$8a51e097d5164103$export$8b40b55b3c06cbe2(isUTC)]();
    var m = date[$8a51e097d5164103$export$8807847c5c71eded(isUTC)]();
    var s = date[$8a51e097d5164103$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$8a51e097d5164103$export$312207a92d041116(isUTC)]();
    var isSecond = S === 0;
    var isMinute = isSecond && s === 0;
    var isHour = isMinute && m === 0;
    var isDay = isHour && h === 0;
    var isMonth = isDay && d === 1;
    var isYear = isMonth && M === 1;
    if (isYear) return 'year';
    else if (isMonth) return 'month';
    else if (isDay) return 'day';
    else if (isHour) return 'hour';
    else if (isMinute) return 'minute';
    else if (isSecond) return 'second';
    else return 'millisecond';
}
function $8a51e097d5164103$export$2ed3384313b02c28(date, timeUnit, isUTC) {
    switch(timeUnit){
        case 'year':
            date[$8a51e097d5164103$export$233f59998ed71c09(isUTC)](0);
        case 'month':
            date[$8a51e097d5164103$export$82fd379a67f37fa0(isUTC)](1);
        case 'day':
            date[$8a51e097d5164103$export$b6f943e8d23c15bb(isUTC)](0);
        case 'hour':
            date[$8a51e097d5164103$export$50303078793fc7d(isUTC)](0);
        case 'minute':
            date[$8a51e097d5164103$export$a4a908acda9c3118(isUTC)](0);
        case 'second':
            date[$8a51e097d5164103$export$c047afab75f6d84(isUTC)](0);
    }
    return date;
}
function $8a51e097d5164103$export$8d046fefed9a548e(isUTC) {
    return isUTC ? 'getUTCFullYear' : 'getFullYear';
}
function $8a51e097d5164103$export$5c242a801a23eec7(isUTC) {
    return isUTC ? 'getUTCMonth' : 'getMonth';
}
function $8a51e097d5164103$export$4189e6cbc9753260(isUTC) {
    return isUTC ? 'getUTCDate' : 'getDate';
}
function $8a51e097d5164103$export$8b40b55b3c06cbe2(isUTC) {
    return isUTC ? 'getUTCHours' : 'getHours';
}
function $8a51e097d5164103$export$8807847c5c71eded(isUTC) {
    return isUTC ? 'getUTCMinutes' : 'getMinutes';
}
function $8a51e097d5164103$export$8f49e73e2eebd168(isUTC) {
    return isUTC ? 'getUTCSeconds' : 'getSeconds';
}
function $8a51e097d5164103$export$312207a92d041116(isUTC) {
    return isUTC ? 'getUTCMilliseconds' : 'getMilliseconds';
}
function $8a51e097d5164103$export$43fbeac90913b151(isUTC) {
    return isUTC ? 'setUTCFullYear' : 'setFullYear';
}
function $8a51e097d5164103$export$233f59998ed71c09(isUTC) {
    return isUTC ? 'setUTCMonth' : 'setMonth';
}
function $8a51e097d5164103$export$82fd379a67f37fa0(isUTC) {
    return isUTC ? 'setUTCDate' : 'setDate';
}
function $8a51e097d5164103$export$b6f943e8d23c15bb(isUTC) {
    return isUTC ? 'setUTCHours' : 'setHours';
}
function $8a51e097d5164103$export$50303078793fc7d(isUTC) {
    return isUTC ? 'setUTCMinutes' : 'setMinutes';
}
function $8a51e097d5164103$export$a4a908acda9c3118(isUTC) {
    return isUTC ? 'setUTCSeconds' : 'setSeconds';
}
function $8a51e097d5164103$export$c047afab75f6d84(isUTC) {
    return isUTC ? 'setUTCMilliseconds' : 'setMilliseconds';
}





function $04bb9ff155ec4ccd$export$b6fe44657ce35c42(x) {
    if (!(0, $104896d282bd296f$export$e90fb89750dba83f)(x)) return $f16f2994a32ad273$export$844ec244b1367d54(x) ? x : '-';
    var parts = (x + '').split('.');
    return parts[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (parts.length > 1 ? '.' + parts[1] : '');
}
function $04bb9ff155ec4ccd$export$86f54f62aa7a7514(str, upperCaseFirst) {
    str = (str || '').toLowerCase().replace(/-(.)/g, function(match, group1) {
        return group1.toUpperCase();
    });
    if (upperCaseFirst && str) str = str.charAt(0).toUpperCase() + str.slice(1);
    return str;
}
var $04bb9ff155ec4ccd$export$f3a38102c49f4268 = $f16f2994a32ad273$export$f3a38102c49f4268;
function $04bb9ff155ec4ccd$export$3cd8db88714decfc(value, valueType, useUTC) {
    var USER_READABLE_DEFUALT_TIME_PATTERN = '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss}';
    function stringToUserReadable(str) {
        return str && $f16f2994a32ad273$export$87c2784dc9fc4ab(str) ? str : '-';
    }
    function isNumberUserReadable(num) {
        return (0, $104896d282bd296f$export$b5c30d4208814a65)(num);
    }
    var isTypeTime = valueType === 'time';
    var isValueDate = value instanceof Date;
    if (isTypeTime || isValueDate) {
        var date = isTypeTime ? (0, $104896d282bd296f$export$6b862160d295c8e)(value) : value;
        if (!isNaN(+date)) return (0, $8a51e097d5164103$export$d9468344d3651243)(date, USER_READABLE_DEFUALT_TIME_PATTERN, useUTC);
        else if (isValueDate) return '-';
    // In other cases, continue to try to display the value in the following code.
    }
    if (valueType === 'ordinal') return $f16f2994a32ad273$export$29d0bb2a4e07b252(value) ? stringToUserReadable(value) : $f16f2994a32ad273$export$7e4aa119212bc614(value) ? isNumberUserReadable(value) ? value + '' : '-' : '-';
    // By default.
    var numericResult = (0, $104896d282bd296f$export$8b4007b942b45a96)(value);
    return isNumberUserReadable(numericResult) ? $04bb9ff155ec4ccd$export$b6fe44657ce35c42(numericResult) : $f16f2994a32ad273$export$29d0bb2a4e07b252(value) ? stringToUserReadable(value) : typeof value === 'boolean' ? value + '' : '-';
}
var $04bb9ff155ec4ccd$var$TPL_VAR_ALIAS = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g'
];
var $04bb9ff155ec4ccd$var$wrapVar = function wrapVar(varName, seriesIdx) {
    return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
};
function $04bb9ff155ec4ccd$export$2028496a35766e41(tpl, paramsList, encode) {
    if (!$f16f2994a32ad273$export$43bee75e5e14138e(paramsList)) paramsList = [
        paramsList
    ];
    var seriesLen = paramsList.length;
    if (!seriesLen) return '';
    var $vars = paramsList[0].$vars || [];
    for(var i = 0; i < $vars.length; i++){
        var alias = $04bb9ff155ec4ccd$var$TPL_VAR_ALIAS[i];
        tpl = tpl.replace($04bb9ff155ec4ccd$var$wrapVar(alias), $04bb9ff155ec4ccd$var$wrapVar(alias, 0));
    }
    for(var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++)for(var k = 0; k < $vars.length; k++){
        var val = paramsList[seriesIdx][$vars[k]];
        tpl = tpl.replace($04bb9ff155ec4ccd$var$wrapVar($04bb9ff155ec4ccd$var$TPL_VAR_ALIAS[k], seriesIdx), encode ? (0, $288857a46a8969d9$export$f9d6449b9af28dc1)(val) : val);
    }
    return tpl;
}
function $04bb9ff155ec4ccd$export$2fa08233ee42f8e1(tpl, param, encode) {
    $f16f2994a32ad273$export$79b2f7037acddd43(param, function(value, key) {
        tpl = tpl.replace('{' + key + '}', encode ? (0, $288857a46a8969d9$export$f9d6449b9af28dc1)(value) : value);
    });
    return tpl;
}
function $04bb9ff155ec4ccd$export$1987a3dbdf3c45ca(inOpt, extraCssText) {
    var opt = $f16f2994a32ad273$export$844ec244b1367d54(inOpt) ? {
        color: inOpt,
        extraCssText: extraCssText
    } : inOpt || {};
    var color = opt.color;
    var type = opt.type;
    extraCssText = opt.extraCssText;
    var renderMode = opt.renderMode || 'html';
    if (!color) return '';
    if (renderMode === 'html') return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' + (0, $288857a46a8969d9$export$f9d6449b9af28dc1)(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + (0, $288857a46a8969d9$export$f9d6449b9af28dc1)(color) + ';' + (extraCssText || '') + '"></span>';
    else {
        // Should better not to auto generate style name by auto-increment number here.
        // Because this util is usually called in tooltip formatter, which is probably
        // called repeatedly when mouse move and the auto-increment number increases fast.
        // Users can make their own style name by theirselves, make it unique and readable.
        var markerId = opt.markerId || 'markerX';
        return {
            renderMode: renderMode,
            content: '{' + markerId + '|}  ',
            style: type === 'subItem' ? {
                width: 4,
                height: 4,
                borderRadius: 2,
                backgroundColor: color
            } : {
                width: 10,
                height: 10,
                borderRadius: 5,
                backgroundColor: color
            }
        };
    }
}
function $04bb9ff155ec4ccd$export$3203edd9e5edd663(tpl, value, isUTC) {
    if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') tpl = 'MM-dd\nyyyy';
    var date = (0, $104896d282bd296f$export$6b862160d295c8e)(value);
    var getUTC = isUTC ? 'getUTC' : 'get';
    var y = date[getUTC + 'FullYear']();
    var M = date[getUTC + 'Month']() + 1;
    var d = date[getUTC + 'Date']();
    var h = date[getUTC + 'Hours']();
    var m = date[getUTC + 'Minutes']();
    var s = date[getUTC + 'Seconds']();
    var S = date[getUTC + 'Milliseconds']();
    tpl = tpl.replace('MM', (0, $8a51e097d5164103$export$5d04458e2a6c373e)(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', (0, $8a51e097d5164103$export$5d04458e2a6c373e)(y % 100 + '', 2)).replace('dd', (0, $8a51e097d5164103$export$5d04458e2a6c373e)(d, 2)).replace('d', d).replace('hh', (0, $8a51e097d5164103$export$5d04458e2a6c373e)(h, 2)).replace('h', h).replace('mm', (0, $8a51e097d5164103$export$5d04458e2a6c373e)(m, 2)).replace('m', m).replace('ss', (0, $8a51e097d5164103$export$5d04458e2a6c373e)(s, 2)).replace('s', s).replace('SSS', (0, $8a51e097d5164103$export$5d04458e2a6c373e)(S, 3));
    return tpl;
}
function $04bb9ff155ec4ccd$export$38a1e7552f497c0e(str) {
    return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}
function $04bb9ff155ec4ccd$export$cda04d03233e5555(color, defaultColor) {
    defaultColor = defaultColor || 'transparent';
    return $f16f2994a32ad273$export$844ec244b1367d54(color) ? color : $f16f2994a32ad273$export$a6cdc56e425d0d0a(color) ? color.colorStops && (color.colorStops[0] || {}).color || defaultColor : defaultColor;
}
function $04bb9ff155ec4ccd$export$13e13f9b96dbe8fa(link, target) {
    /* global window */ if (target === '_blank' || target === 'blank') {
        var blank = window.open();
        blank.opener = null;
        blank.location.href = link;
    } else window.open(link, target);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/**
 * FIXME:
 * `nonSeriesBoxCoordSysCreators` and `_nonSeriesBoxMasterList` are hardcoded implementations.
 * Regarding "coord sys layout based on another coord sys", currently we only experimentally support one level
 * dependency, such as, "grid(cartesian)s can be laid out based on matrix/calendar coord sys."
 * But a comprehensive implementation may need to support:
 *  - Recursive dependencies. e.g., a matrix coord sys lays out based on another matrix coord sys.
 *    That requires in the implementation `create` and `update` of coord sys are called by a dependency graph.
 *    (@see enableTopologicalTravel in `util/component.ts`)
 */ var $d1c2b348f154f767$var$nonSeriesBoxCoordSysCreators = {};
var $d1c2b348f154f767$var$normalCoordSysCreators = {};
var $d1c2b348f154f767$var$CoordinateSystemManager = /** @class */ function() {
    function CoordinateSystemManager() {
        this._normalMasterList = [];
        this._nonSeriesBoxMasterList = [];
    }
    /**
   * Typically,
   *  - in `create`, a coord sys lays out based on a given rect;
   *  - in `update`, update the pixel and data extent of there axes (if any) based on processed `series.data`.
   * After that, a coord sys can serve (typically by `dataToPoint`/`dataToLayout`/`pointToData`).
   * If the coordinate system do not lay out based on `series.data`, `update` is not needed.
   */ CoordinateSystemManager.prototype.create = function(ecModel, api) {
        this._nonSeriesBoxMasterList = dealCreate($d1c2b348f154f767$var$nonSeriesBoxCoordSysCreators, true);
        this._normalMasterList = dealCreate($d1c2b348f154f767$var$normalCoordSysCreators, false);
        function dealCreate(creatorMap, canBeNonSeriesBox) {
            var coordinateSystems = [];
            $f16f2994a32ad273$export$79b2f7037acddd43(creatorMap, function(creator, type) {
                var list = creator.create(ecModel, api);
                coordinateSystems = coordinateSystems.concat(list || []);
            });
            return coordinateSystems;
        }
    };
    /**
   * @see CoordinateSystem['create']
   */ CoordinateSystemManager.prototype.update = function(ecModel, api) {
        $f16f2994a32ad273$export$79b2f7037acddd43(this._normalMasterList, function(coordSys) {
            coordSys.update && coordSys.update(ecModel, api);
        });
    };
    CoordinateSystemManager.prototype.getCoordinateSystems = function() {
        return this._normalMasterList.concat(this._nonSeriesBoxMasterList);
    };
    CoordinateSystemManager.register = function(type, creator) {
        if (type === 'matrix' || type === 'calendar') {
            // FIXME: hardcode, @see nonSeriesBoxCoordSysCreators
            $d1c2b348f154f767$var$nonSeriesBoxCoordSysCreators[type] = creator;
            return;
        }
        $d1c2b348f154f767$var$normalCoordSysCreators[type] = creator;
    };
    CoordinateSystemManager.get = function(type) {
        return $d1c2b348f154f767$var$normalCoordSysCreators[type] || $d1c2b348f154f767$var$nonSeriesBoxCoordSysCreators[type];
    };
    return CoordinateSystemManager;
}();
function $d1c2b348f154f767$var$canBeNonSeriesBoxCoordSys(coordSysType) {
    return !!$d1c2b348f154f767$var$nonSeriesBoxCoordSysCreators[coordSysType];
}
var $d1c2b348f154f767$export$6755bb1cf0b796be = 1;
var $d1c2b348f154f767$export$d88bf84633e72240 = 2;
function $d1c2b348f154f767$export$b8fb890203e861d5(opt) {
    $d1c2b348f154f767$var$coordSysUseMap.set(opt.fullType, {
        getCoord2: undefined
    }).getCoord2 = opt.getCoord2;
}
var $d1c2b348f154f767$var$coordSysUseMap = $f16f2994a32ad273$export$55f8aa7ef875b0a4();
function $d1c2b348f154f767$export$4818264084d885e(model) {
    var coord = model.getShallow('coord', true);
    var from = $d1c2b348f154f767$export$6755bb1cf0b796be;
    if (coord == null) {
        var store = $d1c2b348f154f767$var$coordSysUseMap.get(model.type);
        if (store && store.getCoord2) {
            from = $d1c2b348f154f767$export$d88bf84633e72240;
            coord = store.getCoord2(model);
        }
    }
    return {
        coord: coord,
        from: from
    };
}
var $d1c2b348f154f767$export$bd9a7aa65874feb1 = 0;
var $d1c2b348f154f767$export$87a00611f63b7e87 = 1;
var $d1c2b348f154f767$export$e670080ba75bc9e9 = 2;
function $d1c2b348f154f767$export$29cb72d70b6b3a71(// Component or series
model, printError) {
    // For backward compat, still not use `true` in model.get.
    var coordSysType = model.getShallow('coordinateSystem');
    var coordSysUsageOption = model.getShallow('coordinateSystemUsage', true);
    var isDeclaredExplicitly = coordSysUsageOption != null;
    var kind = $d1c2b348f154f767$export$bd9a7aa65874feb1;
    if (coordSysType) {
        var isSeries = model.mainType === 'series';
        if (coordSysUsageOption == null) coordSysUsageOption = isSeries ? 'data' : 'box';
        if (coordSysUsageOption === 'data') {
            kind = $d1c2b348f154f767$export$87a00611f63b7e87;
            if (!isSeries) kind = $d1c2b348f154f767$export$bd9a7aa65874feb1;
        } else if (coordSysUsageOption === 'box') {
            kind = $d1c2b348f154f767$export$e670080ba75bc9e9;
            if (!isSeries && !$d1c2b348f154f767$var$canBeNonSeriesBoxCoordSys(coordSysType)) kind = $d1c2b348f154f767$export$bd9a7aa65874feb1;
        }
    }
    return {
        coordSysType: coordSysType,
        kind: kind
    };
}
function $d1c2b348f154f767$export$7ed0c09d4f5c932e(opt) {
    var targetModel = opt.targetModel, coordSysType = opt.coordSysType, coordSysProvider = opt.coordSysProvider, isDefaultDataCoordSys = opt.isDefaultDataCoordSys, allowNotFound = opt.allowNotFound;
    var _a = $d1c2b348f154f767$export$29cb72d70b6b3a71(targetModel, true), kind = _a.kind, declaredType = _a.coordSysType;
    if (isDefaultDataCoordSys && kind !== $d1c2b348f154f767$export$87a00611f63b7e87) {
        // If both `COORD_SYS_USAGE_KIND_DATA` and `COORD_SYS_USAGE_KIND_BOX` declared in one model.
        // There is the only case in series-graph, and no other cases yet.
        kind = $d1c2b348f154f767$export$87a00611f63b7e87;
        declaredType = coordSysType;
    }
    if (kind === $d1c2b348f154f767$export$bd9a7aa65874feb1 || declaredType !== coordSysType) return $d1c2b348f154f767$export$bd9a7aa65874feb1;
    var coordSys = coordSysProvider(coordSysType, targetModel);
    if (!coordSys) return $d1c2b348f154f767$export$bd9a7aa65874feb1;
    if (kind === $d1c2b348f154f767$export$87a00611f63b7e87) targetModel.coordinateSystem = coordSys;
    else // kind === COORD_SYS_USAGE_KIND_BOX
    targetModel.boxCoordinateSystem = coordSys;
    return kind;
}
var $d1c2b348f154f767$export$33b06c851894cd19 = function simpleCoordSysInjectionProvider(coordSysType, injectTargetModel) {
    var coordSysModel = injectTargetModel.getReferringComponents(coordSysType, (0, $3fa81475350067fd$export$f076738ec84e693c)).models[0];
    return coordSysModel && coordSysModel.coordinateSystem;
};
var $d1c2b348f154f767$export$2e2bcd8739ae039 = $d1c2b348f154f767$var$CoordinateSystemManager;


var $6b64c78bf98fea85$var$each = $f16f2994a32ad273$export$79b2f7037acddd43;
var $6b64c78bf98fea85$export$a9aa2cc018afbed = [
    'left',
    'right',
    'top',
    'bottom',
    'width',
    'height'
];
var $6b64c78bf98fea85$export$d7fd4338c7b20804 = [
    [
        'width',
        'left',
        'right'
    ],
    [
        'height',
        'top',
        'bottom'
    ]
];
function $6b64c78bf98fea85$var$boxLayout(orient, group, gap, maxWidth, maxHeight) {
    var x = 0;
    var y = 0;
    if (maxWidth == null) maxWidth = Infinity;
    if (maxHeight == null) maxHeight = Infinity;
    var currentLineMaxSize = 0;
    group.eachChild(function(child, idx) {
        var rect = child.getBoundingRect();
        var nextChild = group.childAt(idx + 1);
        var nextChildRect = nextChild && nextChild.getBoundingRect();
        var nextX;
        var nextY;
        if (orient === 'horizontal') {
            var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
            nextX = x + moveX;
            // Wrap when width exceeds maxWidth or meet a `newline` group
            // FIXME compare before adding gap?
            if (nextX > maxWidth || child.newline) {
                x = 0;
                nextX = moveX;
                y += currentLineMaxSize + gap;
                currentLineMaxSize = rect.height;
            } else // FIXME: consider rect.y is not `0`?
            currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
        } else {
            var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
            nextY = y + moveY;
            // Wrap when width exceeds maxHeight or meet a `newline` group
            if (nextY > maxHeight || child.newline) {
                x += currentLineMaxSize + gap;
                y = 0;
                nextY = moveY;
                currentLineMaxSize = rect.width;
            } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
        }
        if (child.newline) return;
        child.x = x;
        child.y = y;
        child.markRedraw();
        orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
    });
}
var $6b64c78bf98fea85$export$827f4ee28efc37 = $6b64c78bf98fea85$var$boxLayout;
var $6b64c78bf98fea85$export$be20d9158c17374c = $f16f2994a32ad273$export$c3095a23b368d1f2($6b64c78bf98fea85$var$boxLayout, 'vertical');
var $6b64c78bf98fea85$export$ae65a483d943e7a7 = $f16f2994a32ad273$export$c3095a23b368d1f2($6b64c78bf98fea85$var$boxLayout, 'horizontal');
function $6b64c78bf98fea85$export$22344244a123da8(boxLayoutModel, ignoreParent) {
    return {
        left: boxLayoutModel.getShallow('left', ignoreParent),
        top: boxLayoutModel.getShallow('top', ignoreParent),
        right: boxLayoutModel.getShallow('right', ignoreParent),
        bottom: boxLayoutModel.getShallow('bottom', ignoreParent),
        width: boxLayoutModel.getShallow('width', ignoreParent),
        height: boxLayoutModel.getShallow('height', ignoreParent)
    };
}
function $6b64c78bf98fea85$var$getViewRectAndCenterForCircleLayout(seriesModel, api) {
    var layoutRef = $6b64c78bf98fea85$export$5aec1e94f566e59f(seriesModel, api, {
        enableLayoutOnlyByCenter: true
    });
    var boxLayoutParams = seriesModel.getBoxLayoutParams();
    var viewRect;
    var center;
    if (layoutRef.type === $6b64c78bf98fea85$export$953b11ffc6912560.point) {
        center = layoutRef.refPoint;
        // `viewRect` is required in `pie/labelLayout.ts`.
        viewRect = $6b64c78bf98fea85$export$4517a5ca639a7293(boxLayoutParams, {
            width: api.getWidth(),
            height: api.getHeight()
        });
    } else {
        // layoutRef.type === layout.BoxLayoutReferenceType.rect
        var centerOption = seriesModel.get('center');
        var centerOptionArr = $f16f2994a32ad273$export$43bee75e5e14138e(centerOption) ? centerOption : [
            centerOption,
            centerOption
        ];
        viewRect = $6b64c78bf98fea85$export$4517a5ca639a7293(boxLayoutParams, layoutRef.refContainer);
        center = layoutRef.boxCoordFrom === (0, $d1c2b348f154f767$export$d88bf84633e72240) ? layoutRef.refPoint // option `series.center` has been used as coord.
         : [
            (0, $104896d282bd296f$export$e8514cb5a5e2b40f)(centerOptionArr[0], viewRect.width) + viewRect.x,
            (0, $104896d282bd296f$export$e8514cb5a5e2b40f)(centerOptionArr[1], viewRect.height) + viewRect.y
        ];
    }
    return {
        viewRect: viewRect,
        center: center
    };
}
function $6b64c78bf98fea85$export$3101c00baac0ee1f(seriesModel, api) {
    // center can be string or number when coordinateSystem is specified
    var _a = $6b64c78bf98fea85$var$getViewRectAndCenterForCircleLayout(seriesModel, api), viewRect = _a.viewRect, center = _a.center;
    var radius = seriesModel.get('radius');
    if (!$f16f2994a32ad273$export$43bee75e5e14138e(radius)) radius = [
        0,
        radius
    ];
    var width = (0, $104896d282bd296f$export$e8514cb5a5e2b40f)(viewRect.width, api.getWidth());
    var height = (0, $104896d282bd296f$export$e8514cb5a5e2b40f)(viewRect.height, api.getHeight());
    var size = Math.min(width, height);
    var r0 = (0, $104896d282bd296f$export$e8514cb5a5e2b40f)(radius[0], size / 2);
    var r = (0, $104896d282bd296f$export$e8514cb5a5e2b40f)(radius[1], size / 2);
    return {
        cx: center[0],
        cy: center[1],
        r0: r0,
        r: r,
        viewRect: viewRect
    };
}
function $6b64c78bf98fea85$export$4517a5ca639a7293(positionInfo, containerRect, // This is the space from the `containerRect` to the returned bounding rect.
// Commonly used in option `legend.padding`, `timeline.padding`, `title.padding`,
//  `visualMap.padding`, ...
// [NOTICE]:
//  It's named `margin`, because it's the space that outside the bounding rect. But from
//  the perspective of the the caller, it's commonly used as the `padding` of a component,
//  because conventionally background color covers this space.
// [BEHAVIOR]:
//  - If width/height is specified, `margin` does not effect them.
//  - Otherwise, they are calculated based on the rect that `containerRect` shrinked by `margin`.
//  - left/right/top/bottom are based on the rect that `containerRect` shrinked by `margin`.
margin) {
    margin = $04bb9ff155ec4ccd$export$f3a38102c49f4268(margin || 0);
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var left = (0, $104896d282bd296f$export$e8514cb5a5e2b40f)(positionInfo.left, containerWidth);
    var top = (0, $104896d282bd296f$export$e8514cb5a5e2b40f)(positionInfo.top, containerHeight);
    var right = (0, $104896d282bd296f$export$e8514cb5a5e2b40f)(positionInfo.right, containerWidth);
    var bottom = (0, $104896d282bd296f$export$e8514cb5a5e2b40f)(positionInfo.bottom, containerHeight);
    var width = (0, $104896d282bd296f$export$e8514cb5a5e2b40f)(positionInfo.width, containerWidth);
    var height = (0, $104896d282bd296f$export$e8514cb5a5e2b40f)(positionInfo.height, containerHeight);
    var verticalMargin = margin[2] + margin[0];
    var horizontalMargin = margin[1] + margin[3];
    var aspect = positionInfo.aspect;
    // If width is not specified, calculate width from left and right
    if (isNaN(width)) width = containerWidth - right - horizontalMargin - left;
    if (isNaN(height)) height = containerHeight - bottom - verticalMargin - top;
    if (aspect != null) {
        // If width and height are not given
        // 1. Graph should not exceeds the container
        // 2. Aspect must be keeped
        // 3. Graph should take the space as more as possible
        // FIXME
        // Margin is not considered, because there is no case that both
        // using margin and aspect so far.
        if (isNaN(width) && isNaN(height)) {
            // PENDING: if only `left` or `right` is defined, perhaps it's more preferable to
            // calculate size based on `containerWidth - left` or `containerWidth - left` here,
            // but for backward compatibility we do not change it.
            if (aspect > containerWidth / containerHeight) width = containerWidth * 0.8;
            else height = containerHeight * 0.8;
        }
        // Calculate width or height with given aspect
        if (isNaN(width)) width = aspect * height;
        if (isNaN(height)) height = width / aspect;
    }
    // If left is not specified, calculate left from right and width
    if (isNaN(left)) left = containerWidth - right - width - horizontalMargin;
    if (isNaN(top)) top = containerHeight - bottom - height - verticalMargin;
    // Align left and top
    switch(positionInfo.left || positionInfo.right){
        case 'center':
            left = containerWidth / 2 - width / 2 - margin[3];
            break;
        case 'right':
            left = containerWidth - width - horizontalMargin;
            break;
    }
    switch(positionInfo.top || positionInfo.bottom){
        case 'middle':
        case 'center':
            top = containerHeight / 2 - height / 2 - margin[0];
            break;
        case 'bottom':
            top = containerHeight - height - verticalMargin;
            break;
    }
    // If something is wrong and left, top, width, height are calculated as NaN
    left = left || 0;
    top = top || 0;
    if (isNaN(width)) // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
    if (isNaN(height)) // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
    var rect = new (0, $7456366ce379c42e$export$2e2bcd8739ae039)((containerRect.x || 0) + left + margin[3], (containerRect.y || 0) + top + margin[0], width, height);
    rect.margin = margin;
    return rect;
}
function $6b64c78bf98fea85$export$9fec79e40d579ea7(component, layoutRect, // That is, `width / height`.
// Assume `aspect` is positive.
aspect) {
    var preserveAspect = component.getShallow('preserveAspect', true);
    if (!preserveAspect) return layoutRect;
    var actualAspect = layoutRect.width / layoutRect.height;
    if (Math.abs(Math.atan(aspect) - Math.atan(actualAspect)) < 1e-9) return layoutRect;
    var preserveAspectAlign = component.getShallow('preserveAspectAlign', true);
    var preserveAspectVerticalAlign = component.getShallow('preserveAspectVerticalAlign', true);
    var layoutOptInner = {
        width: layoutRect.width,
        height: layoutRect.height
    };
    var isCover = preserveAspect === 'cover';
    if (actualAspect > aspect && !isCover || actualAspect < aspect && isCover) {
        layoutOptInner.width = layoutRect.height * aspect;
        preserveAspectAlign === 'left' ? layoutOptInner.left = 0 : preserveAspectAlign === 'right' ? layoutOptInner.right = 0 : layoutOptInner.left = 'center';
    } else {
        layoutOptInner.height = layoutRect.width / aspect;
        preserveAspectVerticalAlign === 'top' ? layoutOptInner.top = 0 : preserveAspectVerticalAlign === 'bottom' ? layoutOptInner.bottom = 0 : layoutOptInner.top = 'middle';
    }
    return $6b64c78bf98fea85$export$4517a5ca639a7293(layoutOptInner, layoutRect);
}
var $6b64c78bf98fea85$export$953b11ffc6912560 = {
    rect: 1,
    point: 2
};
function $6b64c78bf98fea85$export$5aec1e94f566e59f(model, api, opt) {
    var refContainer;
    var refPoint;
    var layoutRefType;
    var boxCoordSys = model.boxCoordinateSystem;
    var boxCoordFrom;
    if (boxCoordSys) {
        var _a = (0, $d1c2b348f154f767$export$4818264084d885e)(model), coord = _a.coord, from = _a.from;
        // Do not use `clamp` in `dataToLayout` and `dataToPoint`, because:
        //  1. Should support overflow (such as, by dataZoom), where NaN should be in the result.
        //  2. Be consistent with the way used in `series.data`
        if (boxCoordSys.dataToLayout) {
            layoutRefType = $6b64c78bf98fea85$export$953b11ffc6912560.rect;
            boxCoordFrom = from;
            var result = boxCoordSys.dataToLayout(coord);
            refContainer = result.contentRect || result.rect;
        } else if (opt && opt.enableLayoutOnlyByCenter && boxCoordSys.dataToPoint) {
            layoutRefType = $6b64c78bf98fea85$export$953b11ffc6912560.point;
            boxCoordFrom = from;
            refPoint = boxCoordSys.dataToPoint(coord);
        }
    }
    if (layoutRefType == null) layoutRefType = $6b64c78bf98fea85$export$953b11ffc6912560.rect;
    if (layoutRefType === $6b64c78bf98fea85$export$953b11ffc6912560.rect) {
        if (!refContainer) refContainer = {
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        };
        refPoint = [
            refContainer.x + refContainer.width / 2,
            refContainer.y + refContainer.height / 2
        ];
    }
    return {
        type: layoutRefType,
        refContainer: refContainer,
        refPoint: refPoint,
        boxCoordFrom: boxCoordFrom
    };
}
function $6b64c78bf98fea85$export$74054bd96b5eeef1(el, positionInfo, containerRect, margin, opt, out) {
    var h = !opt || !opt.hv || opt.hv[0];
    var v = !opt || !opt.hv || opt.hv[1];
    var boundingMode = opt && opt.boundingMode || 'all';
    out = out || el;
    out.x = el.x;
    out.y = el.y;
    if (!h && !v) return false;
    var rect;
    if (boundingMode === 'raw') rect = el.type === 'group' ? new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
    else {
        rect = el.getBoundingRect();
        if (el.needLocalTransform()) {
            var transform = el.getLocalTransform();
            // Notice: raw rect may be inner object of el,
            // which should not be modified.
            rect = rect.clone();
            rect.applyTransform(transform);
        }
    }
    // The real width and height can not be specified but calculated by the given el.
    var layoutRect = $6b64c78bf98fea85$export$4517a5ca639a7293($f16f2994a32ad273$export$ebe90cb607ad99e({
        width: rect.width,
        height: rect.height
    }, positionInfo), containerRect, margin);
    // Because 'tranlate' is the last step in transform
    // (see zrender/core/Transformable#getLocalTransform),
    // we can just only modify el.position to get final result.
    var dx = h ? layoutRect.x - rect.x : 0;
    var dy = v ? layoutRect.y - rect.y : 0;
    if (boundingMode === 'raw') {
        out.x = dx;
        out.y = dy;
    } else {
        out.x += dx;
        out.y += dy;
    }
    if (out === el) el.markRedraw();
    return true;
}
function $6b64c78bf98fea85$export$7ede609e8ebc9650(option, hvIdx) {
    return option[$6b64c78bf98fea85$export$d7fd4338c7b20804[hvIdx][0]] != null || option[$6b64c78bf98fea85$export$d7fd4338c7b20804[hvIdx][1]] != null && option[$6b64c78bf98fea85$export$d7fd4338c7b20804[hvIdx][2]] != null;
}
function $6b64c78bf98fea85$export$3968a28a7cbd6063(ins) {
    var layoutMode = ins.layoutMode || ins.constructor.layoutMode;
    return $f16f2994a32ad273$export$a6cdc56e425d0d0a(layoutMode) ? layoutMode : layoutMode ? {
        type: layoutMode
    } : null;
}
function $6b64c78bf98fea85$export$1754cb91f16ca028(targetOption, newOption, opt) {
    var ignoreSize = opt && opt.ignoreSize;
    !$f16f2994a32ad273$export$43bee75e5e14138e(ignoreSize) && (ignoreSize = [
        ignoreSize,
        ignoreSize
    ]);
    var hResult = merge($6b64c78bf98fea85$export$d7fd4338c7b20804[0], 0);
    var vResult = merge($6b64c78bf98fea85$export$d7fd4338c7b20804[1], 1);
    copy($6b64c78bf98fea85$export$d7fd4338c7b20804[0], targetOption, hResult);
    copy($6b64c78bf98fea85$export$d7fd4338c7b20804[1], targetOption, vResult);
    function merge(names, hvIdx) {
        var newParams = {};
        var newValueCount = 0;
        var merged = {};
        var mergedValueCount = 0;
        var enoughParamNumber = 2;
        $6b64c78bf98fea85$var$each(names, function(name) {
            merged[name] = targetOption[name];
        });
        $6b64c78bf98fea85$var$each(names, function(name) {
            // Consider case: newOption.width is null, which is
            // set by user for removing width setting.
            $f16f2994a32ad273$export$b5a638e9b3fff9f3(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
            hasValue(newParams, name) && newValueCount++;
            hasValue(merged, name) && mergedValueCount++;
        });
        if (ignoreSize[hvIdx]) {
            // Only one of left/right is premitted to exist.
            if (hasValue(newOption, names[1])) merged[names[2]] = null;
            else if (hasValue(newOption, names[2])) merged[names[1]] = null;
            return merged;
        }
        // Case: newOption: {width: ..., right: ...},
        // or targetOption: {right: ...} and newOption: {width: ...},
        // There is no conflict when merged only has params count
        // little than enoughParamNumber.
        if (mergedValueCount === enoughParamNumber || !newValueCount) return merged;
        else if (newValueCount >= enoughParamNumber) return newParams;
        else {
            // Chose another param from targetOption by priority.
            for(var i = 0; i < names.length; i++){
                var name_1 = names[i];
                if (!$f16f2994a32ad273$export$b5a638e9b3fff9f3(newParams, name_1) && $f16f2994a32ad273$export$b5a638e9b3fff9f3(targetOption, name_1)) {
                    newParams[name_1] = targetOption[name_1];
                    break;
                }
            }
            return newParams;
        }
    }
    function hasValue(obj, name) {
        return obj[name] != null && obj[name] !== 'auto';
    }
    function copy(names, target, source) {
        $6b64c78bf98fea85$var$each(names, function(name) {
            target[name] = source[name];
        });
    }
}
function $6b64c78bf98fea85$export$4b0d20af19c9875e(source) {
    return $6b64c78bf98fea85$export$7438999faea9b6cc({}, source);
}
function $6b64c78bf98fea85$export$7438999faea9b6cc(target, source) {
    source && target && $6b64c78bf98fea85$var$each($6b64c78bf98fea85$export$a9aa2cc018afbed, function(name) {
        $f16f2994a32ad273$export$b5a638e9b3fff9f3(source, name) && (target[name] = source[name]);
    });
    return target;
}


var $c418de54527e13f3$var$inner = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
var $c418de54527e13f3$var$ComponentModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(ComponentModel, _super);
    function ComponentModel(option, parentModel, ecModel) {
        var _this = _super.call(this, option, parentModel, ecModel) || this;
        _this.uid = $b2c0501cd47c18d8$export$6d2b3473b0986646('ec_cpt_model');
        return _this;
    }
    ComponentModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    ComponentModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = $6b64c78bf98fea85$export$3968a28a7cbd6063(this);
        var inputPositionParams = layoutMode ? $6b64c78bf98fea85$export$4b0d20af19c9875e(option) : {};
        var themeModel = ecModel.getTheme();
        $f16f2994a32ad273$export$4950aa0f605343fb(option, themeModel.get(this.mainType));
        $f16f2994a32ad273$export$4950aa0f605343fb(option, this.getDefaultOption());
        if (layoutMode) $6b64c78bf98fea85$export$1754cb91f16ca028(option, inputPositionParams, layoutMode);
    };
    ComponentModel.prototype.mergeOption = function(option, ecModel) {
        $f16f2994a32ad273$export$4950aa0f605343fb(this.option, option, true);
        var layoutMode = $6b64c78bf98fea85$export$3968a28a7cbd6063(this);
        if (layoutMode) $6b64c78bf98fea85$export$1754cb91f16ca028(this.option, option, layoutMode);
    };
    /**
   * Called immediately after `init` or `mergeOption` of this instance called.
   */ ComponentModel.prototype.optionUpdated = function(newCptOption, isInit) {
    // MUST NOT do anything here.
    };
    /**
   * [How to declare defaultOption]:
   *
   * (A) If using class declaration in typescript (since echarts 5):
   * ```ts
   * import {ComponentOption} from '../model/option.js';
   * export interface XxxOption extends ComponentOption {
   *     aaa: number
   * }
   * export class XxxModel extends Component {
   *     static type = 'xxx';
   *     static defaultOption: XxxOption = {
   *         aaa: 123
   *     }
   * }
   * Component.registerClass(XxxModel);
   * ```
   * ```ts
   * import {inheritDefaultOption} from '../util/component.js';
   * import {XxxModel, XxxOption} from './XxxModel.js';
   * export interface XxxSubOption extends XxxOption {
   *     bbb: number
   * }
   * class XxxSubModel extends XxxModel {
   *     static defaultOption: XxxSubOption = inheritDefaultOption(XxxModel.defaultOption, {
   *         bbb: 456
   *     })
   *     fn() {
   *         let opt = this.getDefaultOption();
   *         // opt is {aaa: 123, bbb: 456}
   *     }
   * }
   * ```
   *
   * (B) If using class extend (previous approach in echarts 3 & 4):
   * ```js
   * let XxxComponent = Component.extend({
   *     defaultOption: {
   *         xx: 123
   *     }
   * })
   * ```
   * ```js
   * let XxxSubComponent = XxxComponent.extend({
   *     defaultOption: {
   *         yy: 456
   *     },
   *     fn: function () {
   *         let opt = this.getDefaultOption();
   *         // opt is {xx: 123, yy: 456}
   *     }
   * })
   * ```
   */ ComponentModel.prototype.getDefaultOption = function() {
        var ctor = this.constructor;
        if (!(0, $7904d4b709390668$export$4f3b818f3dd2d182)(ctor)) // When using ES class declaration, defaultOption must be declared as static.
        // And manually inherit the defaultOption from its parent class if needed, such as,
        //  ```ts
        //  static defaultOption = inheritDefaultOption(ParentModel.defaultOption, {...});
        //  ```
        return ctor.defaultOption;
        // FIXME: remove this approach?
        // Legacy: auto merge defaultOption from ancestor classes if using ParentClass.extend(subProto)
        var fields = $c418de54527e13f3$var$inner(this);
        if (!fields.defaultOption) {
            var optList = [];
            var clz = ctor;
            while(clz){
                var opt = clz.prototype.defaultOption;
                opt && optList.push(opt);
                clz = clz.superClass;
            }
            var defaultOption = {};
            for(var i = optList.length - 1; i >= 0; i--)defaultOption = $f16f2994a32ad273$export$4950aa0f605343fb(defaultOption, optList[i], true);
            fields.defaultOption = defaultOption;
        }
        return fields.defaultOption;
    };
    /**
   * Notice: always force to input param `useDefault` in case that forget to consider it.
   * The same behavior as `modelUtil.parseFinder`.
   *
   * @param useDefault In many cases like series refer axis and axis refer grid,
   *        If axis index / axis id not specified, use the first target as default.
   *        In other cases like dataZoom refer axis, if not specified, measn no refer.
   */ ComponentModel.prototype.getReferringComponents = function(mainType, opt) {
        var indexKey = mainType + 'Index';
        var idKey = mainType + 'Id';
        return (0, $3fa81475350067fd$export$dc741340f7e5f186)(this.ecModel, mainType, {
            index: this.get(indexKey, true),
            id: this.get(idKey, true)
        }, opt);
    };
    ComponentModel.prototype.getBoxLayoutParams = function() {
        // Consider itself having box layout configs.
        // For backward compatibility, by default do not `ignoreParent`.
        return $6b64c78bf98fea85$export$22344244a123da8(this, false);
    };
    /**
   * If developers don't configure zlevel. We will assign zlevel to series based on the key, if provided.
   * For example, lines with trail effect is expected to be in an individual zlevel.
   *
   * @tutorial [GET_ZLEVEL_KEY_FOR_PROGRESSIVE]
   * Regarding "progressive rendering", zrender can automatically assign a dedicated "incremental layer"
   * for `el.incremental` per zlevel. But there is a trade-off:
   *  - If we do not provide different zlevelKey for different series here, all incremental elements from
   *    different series will be assigned to one incremental layer, which causes them to cover each other
   *    in an order depending on progressive steps.
   *      i.e., seriesA_el1 -covered_by-> seriesB_el1 -covered_by-> seriesC_el1 -> seriesA_el2 -> seriesB_el2 ...
   *    This order may causes an unexpected visual result: series with small data are likely to be completely
   *    covered by series with large data. (like in test/scatter-weibo.html)
   *  - If we assign a different zlevelKey to each series, the "covering issue" above can be resolved,
   *    but having one HTML Canvas per series may be excessively memory-consuming.
   *  Therefore, we only automatically assign zlevelKey on `ScatterSeries` and `LinesSeries` for backward
   *  compatibility, and not to other series. Users can explicitly assign zlevel if they encouter above
   *  "covering issue".
   */ ComponentModel.prototype.getZLevelKey = function() {
        return '';
    };
    ComponentModel.prototype.setZLevel = function(zlevel) {
        this.option.zlevel = zlevel;
    };
    ComponentModel.protoInitialize = function() {
        var proto = ComponentModel.prototype;
        proto.type = 'component';
        proto.id = '';
        proto.name = '';
        proto.mainType = '';
        proto.subType = '';
        proto.componentIndex = 0;
    }();
    return ComponentModel;
}((0, $37821cf56da37613$export$2e2bcd8739ae039));
(0, $7904d4b709390668$export$c9c2d87774f1275d)($c418de54527e13f3$var$ComponentModel, (0, $37821cf56da37613$export$2e2bcd8739ae039));
(0, $7904d4b709390668$export$241315e45585454d)($c418de54527e13f3$var$ComponentModel);
$b2c0501cd47c18d8$export$b9faf30b7d655a6f($c418de54527e13f3$var$ComponentModel);
$b2c0501cd47c18d8$export$ce592d345a3ec040($c418de54527e13f3$var$ComponentModel, $c418de54527e13f3$var$getDependencies);
function $c418de54527e13f3$var$getDependencies(componentType) {
    var deps = [];
    $f16f2994a32ad273$export$79b2f7037acddd43($c418de54527e13f3$var$ComponentModel.getClassesByMainType(componentType), function(clz) {
        deps = deps.concat(clz.dependencies || clz.prototype.dependencies || []);
    });
    // Ensure main type.
    deps = $f16f2994a32ad273$export$871de8747c9eaa88(deps, function(type) {
        return (0, $7904d4b709390668$export$fbe18865d303bf01)(type).main;
    });
    // Hack dataset for convenience.
    if (componentType !== 'dataset' && $f16f2994a32ad273$export$305f7d4e9d4624f2(deps, 'dataset') <= 0) deps.unshift('dataset');
    return deps;
}
var $c418de54527e13f3$export$2e2bcd8739ae039 = $c418de54527e13f3$var$ComponentModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $97f8a9a255c2d778$var$tokens = {
    color: {},
    darkColor: {},
    size: {}
};
var $97f8a9a255c2d778$var$color = $97f8a9a255c2d778$var$tokens.color = {
    theme: [
        '#5070dd',
        '#b6d634',
        '#505372',
        '#ff994d',
        '#0ca8df',
        '#ffd10a',
        '#fb628b',
        '#785db0',
        '#3fbe95'
    ],
    neutral00: '#fff',
    neutral05: '#f4f7fd',
    neutral10: '#e8ebf0',
    neutral15: '#dbdee4',
    neutral20: '#cfd2d7',
    neutral25: '#c3c5cb',
    neutral30: '#b7b9be',
    neutral35: '#aaacb2',
    neutral40: '#9ea0a5',
    neutral45: '#929399',
    neutral50: '#86878c',
    neutral55: '#797b7f',
    neutral60: '#6d6e73',
    neutral65: '#616266',
    neutral70: '#54555a',
    neutral75: '#48494d',
    neutral80: '#3c3c41',
    neutral85: '#303034',
    neutral90: '#232328',
    neutral95: '#17171b',
    neutral99: '#000',
    accent05: '#eff1f9',
    accent10: '#e0e4f2',
    accent15: '#d0d6ec',
    accent20: '#c0c9e6',
    accent25: '#b1bbdf',
    accent30: '#a1aed9',
    accent35: '#91a0d3',
    accent40: '#8292cc',
    accent45: '#7285c6',
    accent50: '#6578ba',
    accent55: '#5c6da9',
    accent60: '#536298',
    accent65: '#4a5787',
    accent70: '#404c76',
    accent75: '#374165',
    accent80: '#2e3654',
    accent85: '#252b43',
    accent90: '#1b2032',
    accent95: '#121521',
    transparent: 'rgba(0,0,0,0)',
    highlight: 'rgba(255,231,130,0.8)'
};
(0, $f16f2994a32ad273$export$8b58be045bf06082)($97f8a9a255c2d778$var$color, {
    primary: $97f8a9a255c2d778$var$color.neutral80,
    secondary: $97f8a9a255c2d778$var$color.neutral70,
    tertiary: $97f8a9a255c2d778$var$color.neutral60,
    quaternary: $97f8a9a255c2d778$var$color.neutral50,
    disabled: $97f8a9a255c2d778$var$color.neutral20,
    border: $97f8a9a255c2d778$var$color.neutral30,
    borderTint: $97f8a9a255c2d778$var$color.neutral20,
    borderShade: $97f8a9a255c2d778$var$color.neutral40,
    background: $97f8a9a255c2d778$var$color.neutral05,
    backgroundTint: 'rgba(234,237,245,0.5)',
    backgroundTransparent: 'rgba(255,255,255,0)',
    backgroundShade: $97f8a9a255c2d778$var$color.neutral10,
    shadow: 'rgba(0,0,0,0.2)',
    shadowTint: 'rgba(129,130,136,0.2)',
    axisLine: $97f8a9a255c2d778$var$color.neutral70,
    axisLineTint: $97f8a9a255c2d778$var$color.neutral40,
    axisTick: $97f8a9a255c2d778$var$color.neutral70,
    axisTickMinor: $97f8a9a255c2d778$var$color.neutral60,
    axisLabel: $97f8a9a255c2d778$var$color.neutral70,
    axisSplitLine: $97f8a9a255c2d778$var$color.neutral15,
    axisMinorSplitLine: $97f8a9a255c2d778$var$color.neutral05
});
for(var $97f8a9a255c2d778$var$key in $97f8a9a255c2d778$var$color)if ($97f8a9a255c2d778$var$color.hasOwnProperty($97f8a9a255c2d778$var$key)) {
    var $97f8a9a255c2d778$var$hex = $97f8a9a255c2d778$var$color[$97f8a9a255c2d778$var$key];
    if ($97f8a9a255c2d778$var$key === 'theme') // Don't modify theme colors.
    $97f8a9a255c2d778$var$tokens.darkColor.theme = $97f8a9a255c2d778$var$color.theme.slice();
    else if ($97f8a9a255c2d778$var$key === 'highlight') $97f8a9a255c2d778$var$tokens.darkColor.highlight = 'rgba(255,231,130,0.4)';
    else if ($97f8a9a255c2d778$var$key.indexOf('accent') === 0) // Desaturate and lighten accent colors.
    $97f8a9a255c2d778$var$tokens.darkColor[$97f8a9a255c2d778$var$key] = (0, $83e50b4ee4d3c357$export$d898ae866e27bf18)($97f8a9a255c2d778$var$hex, null, function(s) {
        return s * 0.5;
    }, function(l) {
        return Math.min(1, 1.3 - l);
    });
    else $97f8a9a255c2d778$var$tokens.darkColor[$97f8a9a255c2d778$var$key] = (0, $83e50b4ee4d3c357$export$d898ae866e27bf18)($97f8a9a255c2d778$var$hex, null, function(s) {
        return s * 0.9;
    }, function(l) {
        return 1 - Math.pow(l, 1.5);
    });
}
$97f8a9a255c2d778$var$tokens.size = {
    xxs: 2,
    xs: 5,
    s: 10,
    m: 15,
    l: 20,
    xl: 30,
    xxl: 40,
    xxxl: 50
};
var $97f8a9a255c2d778$export$2e2bcd8739ae039 = $97f8a9a255c2d778$var$tokens;


var $4aa180a54348b454$var$platform = '';
// Navigator not exists in node
if (typeof navigator !== 'undefined') $4aa180a54348b454$var$platform = navigator.platform || '';
var $4aa180a54348b454$var$decalColor = 'rgba(0, 0, 0, 0.2)';
var $4aa180a54348b454$var$themeColor = (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.theme[0];
var $4aa180a54348b454$var$lightThemeColor = (0, $83e50b4ee4d3c357$export$d898ae866e27bf18)($4aa180a54348b454$var$themeColor, null, null, 0.9);
var $4aa180a54348b454$export$2e2bcd8739ae039 = {
    darkMode: 'auto',
    // backgroundColor: 'rgba(0,0,0,0)',
    colorBy: 'series',
    color: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.theme,
    gradientColor: [
        $4aa180a54348b454$var$lightThemeColor,
        $4aa180a54348b454$var$themeColor
    ],
    aria: {
        decal: {
            decals: [
                {
                    color: $4aa180a54348b454$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        2,
                        5
                    ],
                    symbolSize: 1,
                    rotation: Math.PI / 6
                },
                {
                    color: $4aa180a54348b454$var$decalColor,
                    symbol: 'circle',
                    dashArrayX: [
                        [
                            8,
                            8
                        ],
                        [
                            0,
                            8,
                            8,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ],
                    symbolSize: 0.8
                },
                {
                    color: $4aa180a54348b454$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        4,
                        3
                    ],
                    rotation: -Math.PI / 4
                },
                {
                    color: $4aa180a54348b454$var$decalColor,
                    dashArrayX: [
                        [
                            6,
                            6
                        ],
                        [
                            0,
                            6,
                            6,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ]
                },
                {
                    color: $4aa180a54348b454$var$decalColor,
                    dashArrayX: [
                        [
                            1,
                            0
                        ],
                        [
                            1,
                            6
                        ]
                    ],
                    dashArrayY: [
                        1,
                        0,
                        6,
                        0
                    ],
                    rotation: Math.PI / 4
                },
                {
                    color: $4aa180a54348b454$var$decalColor,
                    symbol: 'triangle',
                    dashArrayX: [
                        [
                            9,
                            9
                        ],
                        [
                            0,
                            9,
                            9,
                            0
                        ]
                    ],
                    dashArrayY: [
                        7,
                        2
                    ],
                    symbolSize: 0.75
                }
            ]
        }
    },
    // If xAxis and yAxis declared, grid is created by default.
    // grid: {},
    textStyle: {
        // color: '#000',
        // decoration: 'none',
        // PENDING
        fontFamily: $4aa180a54348b454$var$platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
        // fontFamily: 'Arial, Verdana, sans-serif',
        fontSize: 12,
        fontStyle: 'normal',
        fontWeight: 'normal'
    },
    // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
    // Default is source-over
    blendMode: null,
    stateAnimation: {
        duration: 300,
        easing: 'cubicOut'
    },
    animation: 'auto',
    animationDuration: 1000,
    animationDurationUpdate: 500,
    animationEasing: 'cubicInOut',
    animationEasingUpdate: 'cubicInOut',
    animationThreshold: 2000,
    // Configuration for progressive/incremental rendering
    progressiveThreshold: 3000,
    progressive: 400,
    // Threshold of if use single hover layer to optimize.
    // It is recommended that `hoverLayerThreshold` is equivalent to or less than
    // `progressiveThreshold`, otherwise hover will cause restart of progressive,
    // which is unexpected.
    // see example <echarts/test/heatmap-large.html>.
    hoverLayerThreshold: 3000,
    // See: module:echarts/scale/Time
    useUTC: false
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $0988ea9c84ff78f2$export$328749e9c5b40760 = {
    Must: 1,
    Might: 2,
    Not: 3 // Other cases
};
var $0988ea9c84ff78f2$var$innerGlobalModel = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
function $0988ea9c84ff78f2$export$b30cdea50aa00e6(ecModel) {
    // `datasetMap` is used to make default encode.
    $0988ea9c84ff78f2$var$innerGlobalModel(ecModel).datasetMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
}
function $0988ea9c84ff78f2$export$37682b8fdd2e83d(coordDimensions, seriesModel, source) {
    var encode = {};
    var datasetModel = $0988ea9c84ff78f2$export$8da66f73a1eda454(seriesModel);
    // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel || !coordDimensions) return encode;
    var encodeItemName = [];
    var encodeSeriesName = [];
    var ecModel = seriesModel.ecModel;
    var datasetMap = $0988ea9c84ff78f2$var$innerGlobalModel(ecModel).datasetMap;
    var key = datasetModel.uid + '_' + source.seriesLayoutBy;
    var baseCategoryDimIndex;
    var categoryWayValueDimStart;
    coordDimensions = coordDimensions.slice();
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(coordDimensions, function(coordDimInfoLoose, coordDimIdx) {
        var coordDimInfo = (0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(coordDimInfoLoose) ? coordDimInfoLoose : coordDimensions[coordDimIdx] = {
            name: coordDimInfoLoose
        };
        if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
            baseCategoryDimIndex = coordDimIdx;
            categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimInfo);
        }
        encode[coordDimInfo.name] = [];
    });
    var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
        categoryWayDim: categoryWayValueDimStart,
        valueWayDim: 0
    });
    // TODO
    // Auto detect first time axis and do arrangement.
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(coordDimensions, function(coordDimInfo, coordDimIdx) {
        var coordDimName = coordDimInfo.name;
        var count = getDataDimCountOnCoordDim(coordDimInfo);
        // In value way.
        if (baseCategoryDimIndex == null) {
            var start = datasetRecord.valueWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.valueWayDim += count;
        // ??? TODO give a better default series name rule?
        // especially when encode x y specified.
        // consider: when multiple series share one dimension
        // category axis, series name should better use
        // the other dimension name. On the other hand, use
        // both dimensions name.
        } else if (baseCategoryDimIndex === coordDimIdx) {
            pushDim(encode[coordDimName], 0, count);
            pushDim(encodeItemName, 0, count);
        } else {
            var start = datasetRecord.categoryWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.categoryWayDim += count;
        }
    });
    function pushDim(dimIdxArr, idxFrom, idxCount) {
        for(var i = 0; i < idxCount; i++)dimIdxArr.push(idxFrom + i);
    }
    function getDataDimCountOnCoordDim(coordDimInfo) {
        var dimsDef = coordDimInfo.dimsDef;
        return dimsDef ? dimsDef.length : 1;
    }
    encodeItemName.length && (encode.itemName = encodeItemName);
    encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
    return encode;
}
function $0988ea9c84ff78f2$export$60b8a57d1f2fed26(seriesModel, source, dimCount) {
    var encode = {};
    var datasetModel = $0988ea9c84ff78f2$export$8da66f73a1eda454(seriesModel);
    // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel) return encode;
    var sourceFormat = source.sourceFormat;
    var dimensionsDefine = source.dimensionsDefine;
    var potentialNameDimIndex;
    if (sourceFormat === (0, $c870d17359cdf008$export$703ae8a2d83f441) || sourceFormat === (0, $c870d17359cdf008$export$6a32b42c754a3cb8)) (0, $f16f2994a32ad273$export$79b2f7037acddd43)(dimensionsDefine, function(dim, idx) {
        if (((0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(dim) ? dim.name : dim) === 'name') potentialNameDimIndex = idx;
    });
    var idxResult = function() {
        var idxRes0 = {};
        var idxRes1 = {};
        var guessRecords = [];
        // 5 is an experience value.
        for(var i = 0, len = Math.min(5, dimCount); i < len; i++){
            var guessResult = $0988ea9c84ff78f2$var$doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
            guessRecords.push(guessResult);
            var isPureNumber = guessResult === $0988ea9c84ff78f2$export$328749e9c5b40760.Not;
            // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
            // and then find a name dim with the priority:
            // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".
            if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) idxRes0.v = i;
            if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === $0988ea9c84ff78f2$export$328749e9c5b40760.Not) idxRes0.n = i;
            if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== $0988ea9c84ff78f2$export$328749e9c5b40760.Not) return idxRes0;
            // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
            // find the first BE_ORDINAL.Might as the value dim,
            // and then find a name dim with the priority:
            // "other dim" > "the value dim itself".
            // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
            // treated as number.
            if (!isPureNumber) {
                if (guessResult === $0988ea9c84ff78f2$export$328749e9c5b40760.Might && idxRes1.v == null && i !== potentialNameDimIndex) idxRes1.v = i;
                if (idxRes1.n == null || idxRes1.n === idxRes1.v) idxRes1.n = i;
            }
        }
        function fulfilled(idxResult) {
            return idxResult.v != null && idxResult.n != null;
        }
        return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
    }();
    if (idxResult) {
        encode.value = [
            idxResult.v
        ];
        // `potentialNameDimIndex` has highest priority.
        var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n;
        // By default, label uses itemName in charts.
        // So we don't set encodeLabel here.
        encode.itemName = [
            nameDimIndex
        ];
        encode.seriesName = [
            nameDimIndex
        ];
    }
    return encode;
}
function $0988ea9c84ff78f2$export$8da66f73a1eda454(seriesModel) {
    // Caution: consider the scenario:
    // A dataset is declared and a series is not expected to use the dataset,
    // and at the beginning `setOption({series: { noData })` (just prepare other
    // option but no data), then `setOption({series: {data: [...]}); In this case,
    // the user should set an empty array to avoid that dataset is used by default.
    var thisData = seriesModel.get('data', true);
    if (!thisData) return (0, $3fa81475350067fd$export$dc741340f7e5f186)(seriesModel.ecModel, 'dataset', {
        index: seriesModel.get('datasetIndex', true),
        id: seriesModel.get('datasetId', true)
    }, (0, $3fa81475350067fd$export$f076738ec84e693c)).models[0];
}
function $0988ea9c84ff78f2$export$397ba553479711e7(datasetModel) {
    // Only these attributes declared, we by default reference to `datasetIndex: 0`.
    // Otherwise, no reference.
    if (!datasetModel.get('transform', true) && !datasetModel.get('fromTransformResult', true)) return [];
    return (0, $3fa81475350067fd$export$dc741340f7e5f186)(datasetModel.ecModel, 'dataset', {
        index: datasetModel.get('fromDatasetIndex', true),
        id: datasetModel.get('fromDatasetId', true)
    }, (0, $3fa81475350067fd$export$f076738ec84e693c)).models;
}
function $0988ea9c84ff78f2$export$c51adf1a2be01b9c(source, dimIndex) {
    return $0988ea9c84ff78f2$var$doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
}
// dimIndex may be overflow source data.
// return {BE_ORDINAL}
function $0988ea9c84ff78f2$var$doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
    var result;
    // Experience value.
    var maxLoop = 5;
    if ((0, $f16f2994a32ad273$export$b119cc7e1840e59c)(data)) return $0988ea9c84ff78f2$export$328749e9c5b40760.Not;
    // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
    // always exists in source.
    var dimName;
    var dimType;
    if (dimensionsDefine) {
        var dimDefItem = dimensionsDefine[dimIndex];
        if ((0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(dimDefItem)) {
            dimName = dimDefItem.name;
            dimType = dimDefItem.type;
        } else if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(dimDefItem)) dimName = dimDefItem;
    }
    if (dimType != null) return dimType === 'ordinal' ? $0988ea9c84ff78f2$export$328749e9c5b40760.Must : $0988ea9c84ff78f2$export$328749e9c5b40760.Not;
    if (sourceFormat === (0, $c870d17359cdf008$export$fcd62ebf51387903)) {
        var dataArrayRows = data;
        if (seriesLayoutBy === (0, $c870d17359cdf008$export$d55da1467cdf7804)) {
            var sample = dataArrayRows[dimIndex];
            for(var i = 0; i < (sample || []).length && i < maxLoop; i++){
                if ((result = detectValue(sample[startIndex + i])) != null) return result;
            }
        } else for(var i = 0; i < dataArrayRows.length && i < maxLoop; i++){
            var row = dataArrayRows[startIndex + i];
            if (row && (result = detectValue(row[dimIndex])) != null) return result;
        }
    } else if (sourceFormat === (0, $c870d17359cdf008$export$703ae8a2d83f441)) {
        var dataObjectRows = data;
        if (!dimName) return $0988ea9c84ff78f2$export$328749e9c5b40760.Not;
        for(var i = 0; i < dataObjectRows.length && i < maxLoop; i++){
            var item = dataObjectRows[i];
            if (item && (result = detectValue(item[dimName])) != null) return result;
        }
    } else if (sourceFormat === (0, $c870d17359cdf008$export$6a32b42c754a3cb8)) {
        var dataKeyedColumns = data;
        if (!dimName) return $0988ea9c84ff78f2$export$328749e9c5b40760.Not;
        var sample = dataKeyedColumns[dimName];
        if (!sample || (0, $f16f2994a32ad273$export$b119cc7e1840e59c)(sample)) return $0988ea9c84ff78f2$export$328749e9c5b40760.Not;
        for(var i = 0; i < sample.length && i < maxLoop; i++){
            if ((result = detectValue(sample[i])) != null) return result;
        }
    } else if (sourceFormat === (0, $c870d17359cdf008$export$2823037fb9d8f0c6)) {
        var dataOriginal = data;
        for(var i = 0; i < dataOriginal.length && i < maxLoop; i++){
            var item = dataOriginal[i];
            var val = (0, $3fa81475350067fd$export$2c944e12edb48d4b)(item);
            if (!(0, $f16f2994a32ad273$export$43bee75e5e14138e)(val)) return $0988ea9c84ff78f2$export$328749e9c5b40760.Not;
            if ((result = detectValue(val[dimIndex])) != null) return result;
        }
    }
    function detectValue(val) {
        var beStr = (0, $f16f2994a32ad273$export$844ec244b1367d54)(val);
        // Consider usage convenience, '1', '2' will be treated as "number".
        // `Number('')` (or any whitespace) is `0`.
        // `Number(val)` prevents error for BigInt.
        if (val != null && isFinite(Number(val)) && val !== '') return beStr ? $0988ea9c84ff78f2$export$328749e9c5b40760.Might : $0988ea9c84ff78f2$export$328749e9c5b40760.Not;
        else if (beStr && val !== '-') return $0988ea9c84ff78f2$export$328749e9c5b40760.Must;
    }
    return $0988ea9c84ff78f2$export$328749e9c5b40760.Not;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $ad16011a125e93f2$var$internalOptionCreatorMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
function $ad16011a125e93f2$export$5a90be4668898d38(mainType, creator) {
    (0, $f16f2994a32ad273$export$a7a9523472993e97)($ad16011a125e93f2$var$internalOptionCreatorMap.get(mainType) == null && creator);
    $ad16011a125e93f2$var$internalOptionCreatorMap.set(mainType, creator);
}
function $ad16011a125e93f2$export$c713a6a3b43f401d(ecModel, mainType, newCmptOptionList) {
    var internalOptionCreator = $ad16011a125e93f2$var$internalOptionCreatorMap.get(mainType);
    if (!internalOptionCreator) return newCmptOptionList;
    var internalOptions = internalOptionCreator(ecModel);
    if (!internalOptions) return newCmptOptionList;
    var i;
    return newCmptOptionList.concat(internalOptions);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $a38f59c4bc389a29$var$innerColor = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
var $a38f59c4bc389a29$var$innerDecal = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
var $a38f59c4bc389a29$export$55a3c39e852b90f4 = /** @class */ function() {
    function PaletteMixin() {}
    PaletteMixin.prototype.getColorFromPalette = function(name, scope, requestNum) {
        var defaultPalette = (0, $3fa81475350067fd$export$4f07b212a02c8051)(this.get('color', true));
        var layeredPalette = this.get('colorLayer', true);
        return $a38f59c4bc389a29$var$getFromPalette(this, $a38f59c4bc389a29$var$innerColor, defaultPalette, layeredPalette, name, scope, requestNum);
    };
    PaletteMixin.prototype.clearColorPalette = function() {
        $a38f59c4bc389a29$var$clearPalette(this, $a38f59c4bc389a29$var$innerColor);
    };
    return PaletteMixin;
}();
function $a38f59c4bc389a29$export$e4d892222945a227(ecModel, name, scope, requestNum) {
    var defaultDecals = (0, $3fa81475350067fd$export$4f07b212a02c8051)(ecModel.get([
        'aria',
        'decal',
        'decals'
    ]));
    return $a38f59c4bc389a29$var$getFromPalette(ecModel, $a38f59c4bc389a29$var$innerDecal, defaultDecals, null, name, scope, requestNum);
}
function $a38f59c4bc389a29$var$getNearestPalette(palettes, requestColorNum) {
    var paletteNum = palettes.length;
    // TODO palettes must be in order
    for(var i = 0; i < paletteNum; i++){
        if (palettes[i].length > requestColorNum) return palettes[i];
    }
    return palettes[paletteNum - 1];
}
/**
 * @param name MUST NOT be null/undefined. Otherwise call this function
 *             twise with the same parameters will get different result.
 * @param scope default this.
 * @return Can be null/undefined
 */ function $a38f59c4bc389a29$var$getFromPalette(that, inner, defaultPalette, layeredPalette, name, scope, requestNum) {
    scope = scope || that;
    var scopeFields = inner(scope);
    var paletteIdx = scopeFields.paletteIdx || 0;
    var paletteNameMap = scopeFields.paletteNameMap = scopeFields.paletteNameMap || {};
    // Use `hasOwnProperty` to avoid conflict with Object.prototype.
    if (paletteNameMap.hasOwnProperty(name)) return paletteNameMap[name];
    var palette = requestNum == null || !layeredPalette ? defaultPalette : $a38f59c4bc389a29$var$getNearestPalette(layeredPalette, requestNum);
    // In case can't find in layered color palette.
    palette = palette || defaultPalette;
    if (!palette || !palette.length) return;
    var pickedPaletteItem = palette[paletteIdx];
    if (name) paletteNameMap[name] = pickedPaletteItem;
    scopeFields.paletteIdx = (paletteIdx + 1) % palette.length;
    return pickedPaletteItem;
}
function $a38f59c4bc389a29$var$clearPalette(that, inner) {
    inner(that).paletteIdx = 0;
    inner(that).paletteNameMap = {};
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ec53fe68074e6f74$var$ECHARTS_PREFIX = '[ECharts] ';
var $ec53fe68074e6f74$var$storedLogs = {};
var $ec53fe68074e6f74$var$hasConsole = typeof console !== 'undefined' && console.warn && console.log;
function $ec53fe68074e6f74$var$outputLog(type, str, onlyOnce) {
    if ($ec53fe68074e6f74$var$hasConsole) {
        if (onlyOnce) {
            if ($ec53fe68074e6f74$var$storedLogs[str]) return;
            $ec53fe68074e6f74$var$storedLogs[str] = true;
        }
        // eslint-disable-next-line
        console[type]($ec53fe68074e6f74$var$ECHARTS_PREFIX + str);
    }
}
function $ec53fe68074e6f74$export$bef1f36f5486a6a3(str, onlyOnce) {
    $ec53fe68074e6f74$var$outputLog('log', str, onlyOnce);
}
function $ec53fe68074e6f74$export$c106dd0671a0fc2d(str, onlyOnce) {
    $ec53fe68074e6f74$var$outputLog('warn', str, onlyOnce);
}
function $ec53fe68074e6f74$export$a3bc9b8ed74fc(str, onlyOnce) {
    $ec53fe68074e6f74$var$outputLog('error', str, onlyOnce);
}
function $ec53fe68074e6f74$export$4a9c0b74eb885aa1(str) {}
function $ec53fe68074e6f74$export$bbd91d66002c4ea6(oldOpt, newOpt, scope) {}
function $ec53fe68074e6f74$export$a68bb8b222a6bd43() {
    var hintInfo = [];
    for(var _i = 0; _i < arguments.length; _i++)hintInfo[_i] = arguments[_i];
    var msg = '';
    var makePrintableStringIfPossible_1;
    return msg;
}
function $ec53fe68074e6f74$export$8bf7aba4a9e09055(msg) {
    throw new Error(msg);
}


// -----------------------
// Internal method names:
// -----------------------
var $5fcc33310122e6f0$var$reCreateSeriesIndices;
var $5fcc33310122e6f0$var$assertSeriesInitialized;
var $5fcc33310122e6f0$var$initBase;
var $5fcc33310122e6f0$var$OPTION_INNER_KEY = '\0_ec_inner';
var $5fcc33310122e6f0$var$OPTION_INNER_VALUE = 1;
var $5fcc33310122e6f0$var$BUITIN_COMPONENTS_MAP = {
    grid: 'GridComponent',
    polar: 'PolarComponent',
    geo: 'GeoComponent',
    singleAxis: 'SingleAxisComponent',
    parallel: 'ParallelComponent',
    calendar: 'CalendarComponent',
    matrix: 'MatrixComponent',
    graphic: 'GraphicComponent',
    toolbox: 'ToolboxComponent',
    tooltip: 'TooltipComponent',
    axisPointer: 'AxisPointerComponent',
    brush: 'BrushComponent',
    title: 'TitleComponent',
    timeline: 'TimelineComponent',
    markPoint: 'MarkPointComponent',
    markLine: 'MarkLineComponent',
    markArea: 'MarkAreaComponent',
    legend: 'LegendComponent',
    dataZoom: 'DataZoomComponent',
    visualMap: 'VisualMapComponent',
    // aria: 'AriaComponent',
    // dataset: 'DatasetComponent',
    // Dependencies
    xAxis: 'GridComponent',
    yAxis: 'GridComponent',
    angleAxis: 'PolarComponent',
    radiusAxis: 'PolarComponent'
};
var $5fcc33310122e6f0$var$BUILTIN_CHARTS_MAP = {
    line: 'LineChart',
    bar: 'BarChart',
    pie: 'PieChart',
    scatter: 'ScatterChart',
    radar: 'RadarChart',
    map: 'MapChart',
    tree: 'TreeChart',
    treemap: 'TreemapChart',
    graph: 'GraphChart',
    chord: 'ChordChart',
    gauge: 'GaugeChart',
    funnel: 'FunnelChart',
    parallel: 'ParallelChart',
    sankey: 'SankeyChart',
    boxplot: 'BoxplotChart',
    candlestick: 'CandlestickChart',
    effectScatter: 'EffectScatterChart',
    lines: 'LinesChart',
    heatmap: 'HeatmapChart',
    pictorialBar: 'PictorialBarChart',
    themeRiver: 'ThemeRiverChart',
    sunburst: 'SunburstChart',
    custom: 'CustomChart'
};
var $5fcc33310122e6f0$var$componetsMissingLogPrinted = {};
function $5fcc33310122e6f0$var$checkMissingComponents(option) {
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(option, function(componentOption, mainType) {
        if (!(0, $c418de54527e13f3$export$2e2bcd8739ae039).hasClass(mainType)) {
            var componentImportName = $5fcc33310122e6f0$var$BUITIN_COMPONENTS_MAP[mainType];
            if (componentImportName && !$5fcc33310122e6f0$var$componetsMissingLogPrinted[componentImportName]) {
                (0, $ec53fe68074e6f74$export$a3bc9b8ed74fc)("Component " + mainType + " is used but not imported.\nimport { " + componentImportName + " } from 'echarts/components';\necharts.use([" + componentImportName + "]);");
                $5fcc33310122e6f0$var$componetsMissingLogPrinted[componentImportName] = true;
            }
        }
    });
}
var $5fcc33310122e6f0$var$GlobalModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(GlobalModel, _super);
    function GlobalModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalModel.prototype.init = function(option, parentModel, ecModel, theme, locale, optionManager) {
        theme = theme || {};
        this.option = null; // Mark as not initialized.
        this._theme = new (0, $37821cf56da37613$export$2e2bcd8739ae039)(theme);
        this._locale = new (0, $37821cf56da37613$export$2e2bcd8739ae039)(locale);
        this._optionManager = optionManager;
    };
    GlobalModel.prototype.setOption = function(option, opts, optionPreprocessorFuncs) {
        var innerOpt = $5fcc33310122e6f0$var$normalizeSetOptionInput(opts);
        this._optionManager.setOption(option, optionPreprocessorFuncs, innerOpt);
        this._resetOption(null, innerOpt);
    };
    /**
   * @param type null/undefined: reset all.
   *        'recreate': force recreate all.
   *        'timeline': only reset timeline option
   *        'media': only reset media query option
   * @return Whether option changed.
   */ GlobalModel.prototype.resetOption = function(type, opt) {
        return this._resetOption(type, $5fcc33310122e6f0$var$normalizeSetOptionInput(opt));
    };
    GlobalModel.prototype._resetOption = function(type, opt) {
        var optionChanged = false;
        var optionManager = this._optionManager;
        if (!type || type === 'recreate') {
            var baseOption = optionManager.mountOption(type === 'recreate');
            if (!this.option || type === 'recreate') $5fcc33310122e6f0$var$initBase(this, baseOption);
            else {
                this.restoreData();
                this._mergeOption(baseOption, opt);
            }
            optionChanged = true;
        }
        if (type === 'timeline' || type === 'media') this.restoreData();
        // By design, if `setOption(option2)` at the second time, and `option2` is a `ECUnitOption`,
        // it should better not have the same props with `MediaUnit['option']`.
        // Because either `option2` or `MediaUnit['option']` will be always merged to "current option"
        // rather than original "baseOption". If they both override a prop, the result might be
        // unexpected when media state changed after `setOption` called.
        // If we really need to modify a props in each `MediaUnit['option']`, use the full version
        // (`{baseOption, media}`) in `setOption`.
        // For `timeline`, the case is the same.
        if (!type || type === 'recreate' || type === 'timeline') {
            var timelineOption = optionManager.getTimelineOption(this);
            if (timelineOption) {
                optionChanged = true;
                this._mergeOption(timelineOption, opt);
            }
        }
        if (!type || type === 'recreate' || type === 'media') {
            var mediaOptions = optionManager.getMediaOption(this);
            if (mediaOptions.length) (0, $f16f2994a32ad273$export$79b2f7037acddd43)(mediaOptions, function(mediaOption) {
                optionChanged = true;
                this._mergeOption(mediaOption, opt);
            }, this);
        }
        return optionChanged;
    };
    GlobalModel.prototype.mergeOption = function(option) {
        this._mergeOption(option, null);
    };
    GlobalModel.prototype._mergeOption = function(newOption, opt) {
        var option = this.option;
        var componentsMap = this._componentsMap;
        var componentsCount = this._componentsCount;
        var newCmptTypes = [];
        var newCmptTypeMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
        var replaceMergeMainTypeMap = opt && opt.replaceMergeMainTypeMap;
        (0, $0988ea9c84ff78f2$export$b30cdea50aa00e6)(this);
        // If no component class, merge directly.
        // For example: color, animaiton options, etc.
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(newOption, function(componentOption, mainType) {
            if (componentOption == null) return;
            if (!(0, $c418de54527e13f3$export$2e2bcd8739ae039).hasClass(mainType)) // globalSettingTask.dirty();
            option[mainType] = option[mainType] == null ? (0, $f16f2994a32ad273$export$9cd59f9826255e47)(componentOption) : (0, $f16f2994a32ad273$export$4950aa0f605343fb)(option[mainType], componentOption, true);
            else if (mainType) {
                newCmptTypes.push(mainType);
                newCmptTypeMap.set(mainType, true);
            }
        });
        if (replaceMergeMainTypeMap) // If there is a mainType `xxx` in `replaceMerge` but not declared in option,
        // we trade it as it is declared in option as `{xxx: []}`. Because:
        // (1) for normal merge, `{xxx: null/undefined}` are the same meaning as `{xxx: []}`.
        // (2) some preprocessor may convert some of `{xxx: null/undefined}` to `{xxx: []}`.
        replaceMergeMainTypeMap.each(function(val, mainTypeInReplaceMerge) {
            if ((0, $c418de54527e13f3$export$2e2bcd8739ae039).hasClass(mainTypeInReplaceMerge) && !newCmptTypeMap.get(mainTypeInReplaceMerge)) {
                newCmptTypes.push(mainTypeInReplaceMerge);
                newCmptTypeMap.set(mainTypeInReplaceMerge, true);
            }
        });
        (0, $c418de54527e13f3$export$2e2bcd8739ae039).topologicalTravel(newCmptTypes, (0, $c418de54527e13f3$export$2e2bcd8739ae039).getAllClassMainTypes(), visitComponent, this);
        function visitComponent(mainType) {
            var newCmptOptionList = (0, $ad16011a125e93f2$export$c713a6a3b43f401d)(this, mainType, $3fa81475350067fd$export$4f07b212a02c8051(newOption[mainType]));
            var oldCmptList = componentsMap.get(mainType);
            var mergeMode = // `!oldCmptList` means init. See the comment in `mappingToExists`
            !oldCmptList ? 'replaceAll' : replaceMergeMainTypeMap && replaceMergeMainTypeMap.get(mainType) ? 'replaceMerge' : 'normalMerge';
            var mappingResult = $3fa81475350067fd$export$574f818966e4da87(oldCmptList, newCmptOptionList, mergeMode);
            // Set mainType and complete subType.
            $3fa81475350067fd$export$5ac61aca2ba0282d(mappingResult, mainType, (0, $c418de54527e13f3$export$2e2bcd8739ae039));
            // Empty it before the travel, in order to prevent `this._componentsMap`
            // from being used in the `init`/`mergeOption`/`optionUpdated` of some
            // components, which is probably incorrect logic.
            option[mainType] = null;
            componentsMap.set(mainType, null);
            componentsCount.set(mainType, 0);
            var optionsByMainType = [];
            var cmptsByMainType = [];
            var cmptsCountByMainType = 0;
            var tooltipExists;
            var tooltipWarningLogged;
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)(mappingResult, function(resultItem, index) {
                var componentModel = resultItem.existing;
                var newCmptOption = resultItem.newOption;
                if (!newCmptOption) {
                    if (componentModel) {
                        // Consider where is no new option and should be merged using {},
                        // see removeEdgeAndAdd in topologicalTravel and
                        // ComponentModel.getAllClassMainTypes.
                        componentModel.mergeOption({}, this);
                        componentModel.optionUpdated({}, false);
                    }
                } else {
                    var isSeriesType = mainType === 'series';
                    var ComponentModelClass = (0, $c418de54527e13f3$export$2e2bcd8739ae039).getClass(mainType, resultItem.keyInfo.subType, !isSeriesType // Give a more detailed warn later if series don't exists
                    );
                    if (!ComponentModelClass) {
                        var subType, seriesImportName;
                        return;
                    }
                    // TODO Before multiple tooltips get supported, we do this check to avoid unexpected exception.
                    if (mainType === 'tooltip') {
                        if (tooltipExists) return;
                        tooltipExists = true;
                    }
                    if (componentModel && componentModel.constructor === ComponentModelClass) {
                        componentModel.name = resultItem.keyInfo.name;
                        // componentModel.settingTask && componentModel.settingTask.dirty();
                        componentModel.mergeOption(newCmptOption, this);
                        componentModel.optionUpdated(newCmptOption, false);
                    } else {
                        // PENDING Global as parent ?
                        var extraOpt = (0, $f16f2994a32ad273$export$8b58be045bf06082)({
                            componentIndex: index
                        }, resultItem.keyInfo);
                        componentModel = new ComponentModelClass(newCmptOption, this, this, extraOpt);
                        // Assign `keyInfo`
                        (0, $f16f2994a32ad273$export$8b58be045bf06082)(componentModel, extraOpt);
                        if (resultItem.brandNew) componentModel.__requireNewView = true;
                        componentModel.init(newCmptOption, this, this);
                        // Call optionUpdated after init.
                        // newCmptOption has been used as componentModel.option
                        // and may be merged with theme and default, so pass null
                        // to avoid confusion.
                        componentModel.optionUpdated(null, true);
                    }
                }
                if (componentModel) {
                    optionsByMainType.push(componentModel.option);
                    cmptsByMainType.push(componentModel);
                    cmptsCountByMainType++;
                } else {
                    // Always do assign to avoid elided item in array.
                    optionsByMainType.push(void 0);
                    cmptsByMainType.push(void 0);
                }
            }, this);
            option[mainType] = optionsByMainType;
            componentsMap.set(mainType, cmptsByMainType);
            componentsCount.set(mainType, cmptsCountByMainType);
            // Backup series for filtering.
            if (mainType === 'series') $5fcc33310122e6f0$var$reCreateSeriesIndices(this);
        }
        // If no series declared, ensure `_seriesIndices` initialized.
        if (!this._seriesIndices) $5fcc33310122e6f0$var$reCreateSeriesIndices(this);
    };
    /**
   * Get option for output (cloned option and inner info removed)
   */ GlobalModel.prototype.getOption = function() {
        var option = (0, $f16f2994a32ad273$export$9cd59f9826255e47)(this.option);
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(option, function(optInMainType, mainType) {
            if ((0, $c418de54527e13f3$export$2e2bcd8739ae039).hasClass(mainType)) {
                var opts = $3fa81475350067fd$export$4f07b212a02c8051(optInMainType);
                // Inner cmpts need to be removed.
                // Inner cmpts might not be at last since ec5.0, but still
                // compatible for users: if inner cmpt at last, splice the returned array.
                var realLen = opts.length;
                var metNonInner = false;
                for(var i = realLen - 1; i >= 0; i--)// Remove options with inner id.
                if (opts[i] && !$3fa81475350067fd$export$feece3e7d52a102b(opts[i])) metNonInner = true;
                else {
                    opts[i] = null;
                    !metNonInner && realLen--;
                }
                opts.length = realLen;
                option[mainType] = opts;
            }
        });
        delete option[$5fcc33310122e6f0$var$OPTION_INNER_KEY];
        return option;
    };
    GlobalModel.prototype.setTheme = function(theme) {
        this._theme = new (0, $37821cf56da37613$export$2e2bcd8739ae039)(theme);
        this._resetOption('recreate', null);
    };
    GlobalModel.prototype.getTheme = function() {
        return this._theme;
    };
    GlobalModel.prototype.getLocaleModel = function() {
        return this._locale;
    };
    GlobalModel.prototype.setUpdatePayload = function(payload) {
        this._payload = payload;
    };
    GlobalModel.prototype.getUpdatePayload = function() {
        return this._payload;
    };
    /**
   * @param idx If not specified, return the first one.
   */ GlobalModel.prototype.getComponent = function(mainType, idx) {
        var list = this._componentsMap.get(mainType);
        if (list) {
            var cmpt = list[idx || 0];
            if (cmpt) return cmpt;
            else if (idx == null) for(var i = 0; i < list.length; i++){
                if (list[i]) return list[i];
            }
        }
    };
    /**
   * @return Never be null/undefined.
   */ GlobalModel.prototype.queryComponents = function(condition) {
        var mainType = condition.mainType;
        if (!mainType) return [];
        var index = condition.index;
        var id = condition.id;
        var name = condition.name;
        var cmpts = this._componentsMap.get(mainType);
        if (!cmpts || !cmpts.length) return [];
        var result;
        if (index != null) {
            result = [];
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)($3fa81475350067fd$export$4f07b212a02c8051(index), function(idx) {
                cmpts[idx] && result.push(cmpts[idx]);
            });
        } else if (id != null) result = $5fcc33310122e6f0$var$queryByIdOrName('id', id, cmpts);
        else if (name != null) result = $5fcc33310122e6f0$var$queryByIdOrName('name', name, cmpts);
        else // Return all non-empty components in that mainType
        result = (0, $f16f2994a32ad273$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return !!cmpt;
        });
        return $5fcc33310122e6f0$var$filterBySubType(result, condition);
    };
    /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * let result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series',
   *     filter: function (model, index) {...}}
   * );
   * // result like [component0, component1, ...]
   */ GlobalModel.prototype.findComponents = function(condition) {
        var query = condition.query;
        var mainType = condition.mainType;
        var queryCond = getQueryCond(query);
        var result = queryCond ? this.queryComponents(queryCond) : (0, $f16f2994a32ad273$export$3dea766d36a8935f)(this._componentsMap.get(mainType), function(cmpt) {
            return !!cmpt;
        });
        return doFilter($5fcc33310122e6f0$var$filterBySubType(result, condition));
        function getQueryCond(q) {
            var indexAttr = mainType + 'Index';
            var idAttr = mainType + 'Id';
            var nameAttr = mainType + 'Name';
            return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
                mainType: mainType,
                // subType will be filtered finally.
                index: q[indexAttr],
                id: q[idAttr],
                name: q[nameAttr]
            } : null;
        }
        function doFilter(res) {
            return condition.filter ? (0, $f16f2994a32ad273$export$3dea766d36a8935f)(res, condition.filter) : res;
        }
    };
    GlobalModel.prototype.eachComponent = function(mainType, cb, context) {
        var componentsMap = this._componentsMap;
        if ((0, $f16f2994a32ad273$export$f6e2535fb5126e54)(mainType)) {
            var ctxForAll_1 = cb;
            var cbForAll_1 = mainType;
            componentsMap.each(function(cmpts, componentType) {
                for(var i = 0; cmpts && i < cmpts.length; i++){
                    var cmpt = cmpts[i];
                    cmpt && cbForAll_1.call(ctxForAll_1, componentType, cmpt, cmpt.componentIndex);
                }
            });
        } else {
            var cmpts = (0, $f16f2994a32ad273$export$844ec244b1367d54)(mainType) ? componentsMap.get(mainType) : (0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(mainType) ? this.findComponents(mainType) : null;
            for(var i = 0; cmpts && i < cmpts.length; i++){
                var cmpt = cmpts[i];
                cmpt && cb.call(context, cmpt, cmpt.componentIndex);
            }
        }
    };
    /**
   * Get series list before filtered by name.
   */ GlobalModel.prototype.getSeriesByName = function(name) {
        var nameStr = $3fa81475350067fd$export$fb1a222ba5dd6e51(name, null);
        return (0, $f16f2994a32ad273$export$3dea766d36a8935f)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries && nameStr != null && oneSeries.name === nameStr;
        });
    };
    /**
   * Get series list before filtered by index.
   */ GlobalModel.prototype.getSeriesByIndex = function(seriesIndex) {
        return this._componentsMap.get('series')[seriesIndex];
    };
    /**
   * Get series list before filtered by type.
   * FIXME: rename to getRawSeriesByType?
   */ GlobalModel.prototype.getSeriesByType = function(subType) {
        return (0, $f16f2994a32ad273$export$3dea766d36a8935f)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries && oneSeries.subType === subType;
        });
    };
    /**
   * Get all series before filtered.
   */ GlobalModel.prototype.getSeries = function() {
        return (0, $f16f2994a32ad273$export$3dea766d36a8935f)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries;
        });
    };
    /**
   * Count series before filtered.
   */ GlobalModel.prototype.getSeriesCount = function() {
        return this._componentsCount.get('series');
    };
    /**
   * After filtering, series may be different
   * from raw series.
   */ GlobalModel.prototype.eachSeries = function(cb, context) {
        $5fcc33310122e6f0$var$assertSeriesInitialized(this);
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get('series')[rawSeriesIndex];
            cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered.
   */ GlobalModel.prototype.eachRawSeries = function(cb, context) {
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(this._componentsMap.get('series'), function(series) {
            series && cb.call(context, series, series.componentIndex);
        });
    };
    /**
   * After filtering, series may be different.
   * from raw series.
   */ GlobalModel.prototype.eachSeriesByType = function(subType, cb, context) {
        $5fcc33310122e6f0$var$assertSeriesInitialized(this);
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get('series')[rawSeriesIndex];
            if (series.subType === subType) cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered of given type.
   */ GlobalModel.prototype.eachRawSeriesByType = function(subType, cb, context) {
        return (0, $f16f2994a32ad273$export$79b2f7037acddd43)(this.getSeriesByType(subType), cb, context);
    };
    /**
   * It means "filtered out".
   */ GlobalModel.prototype.isSeriesFiltered = function(seriesModel) {
        $5fcc33310122e6f0$var$assertSeriesInitialized(this);
        return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
    };
    GlobalModel.prototype.getCurrentSeriesIndices = function() {
        return (this._seriesIndices || []).slice();
    };
    GlobalModel.prototype.filterSeries = function(cb, context) {
        $5fcc33310122e6f0$var$assertSeriesInitialized(this);
        var newSeriesIndices = [];
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(this._seriesIndices, function(seriesRawIdx) {
            var series = this._componentsMap.get('series')[seriesRawIdx];
            cb.call(context, series, seriesRawIdx) && newSeriesIndices.push(seriesRawIdx);
        }, this);
        this._seriesIndices = newSeriesIndices;
        this._seriesIndicesMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)(newSeriesIndices);
    };
    GlobalModel.prototype.restoreData = function(payload) {
        $5fcc33310122e6f0$var$reCreateSeriesIndices(this);
        var componentsMap = this._componentsMap;
        var componentTypes = [];
        componentsMap.each(function(components, componentType) {
            if ((0, $c418de54527e13f3$export$2e2bcd8739ae039).hasClass(componentType)) componentTypes.push(componentType);
        });
        (0, $c418de54527e13f3$export$2e2bcd8739ae039).topologicalTravel(componentTypes, (0, $c418de54527e13f3$export$2e2bcd8739ae039).getAllClassMainTypes(), function(componentType) {
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)(componentsMap.get(componentType), function(component) {
                if (component && (componentType !== 'series' || !$5fcc33310122e6f0$var$isNotTargetSeries(component, payload))) component.restoreData();
            });
        });
    };
    GlobalModel.internalField = function() {
        $5fcc33310122e6f0$var$reCreateSeriesIndices = function reCreateSeriesIndices(ecModel) {
            var seriesIndices = ecModel._seriesIndices = [];
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)(ecModel._componentsMap.get('series'), function(series) {
                // series may have been removed by `replaceMerge`.
                series && seriesIndices.push(series.componentIndex);
            });
            ecModel._seriesIndicesMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)(seriesIndices);
        };
        $5fcc33310122e6f0$var$assertSeriesInitialized = function assertSeriesInitialized(ecModel) {};
        $5fcc33310122e6f0$var$initBase = function initBase(ecModel, baseOption) {
            // Using OPTION_INNER_KEY to mark that this option cannot be used outside,
            // i.e. `chart.setOption(chart.getModel().option);` is forbidden.
            ecModel.option = {};
            ecModel.option[$5fcc33310122e6f0$var$OPTION_INNER_KEY] = $5fcc33310122e6f0$var$OPTION_INNER_VALUE;
            // Init with series: [], in case of calling findSeries method
            // before series initialized.
            ecModel._componentsMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)({
                series: []
            });
            ecModel._componentsCount = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
            // If user spefied `option.aria`, aria will be enable. This detection should be
            // performed before theme and globalDefault merge.
            var airaOption = baseOption.aria;
            if ((0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(airaOption) && airaOption.enabled == null) airaOption.enabled = true;
            $5fcc33310122e6f0$var$mergeTheme(baseOption, ecModel._theme.option);
            // TODO Needs clone when merging to the unexisted property
            (0, $f16f2994a32ad273$export$4950aa0f605343fb)(baseOption, (0, $4aa180a54348b454$export$2e2bcd8739ae039), false);
            ecModel._mergeOption(baseOption, null);
        };
    }();
    return GlobalModel;
}((0, $37821cf56da37613$export$2e2bcd8739ae039));
function $5fcc33310122e6f0$var$isNotTargetSeries(seriesModel, payload) {
    if (payload) {
        var index = payload.seriesIndex;
        var id = payload.seriesId;
        var name_1 = payload.seriesName;
        return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name_1 != null && seriesModel.name !== name_1;
    }
}
function $5fcc33310122e6f0$var$mergeTheme(option, theme) {
    // PENDING
    // NOT use `colorLayer` in theme if option has `color`
    var notMergeColorLayer = option.color && !option.colorLayer;
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(theme, function(themeItem, name) {
        if (name === 'colorLayer' && notMergeColorLayer || name === 'color' && option.color) return;
        // If it is component model mainType, the model handles that merge later.
        // otherwise, merge them here.
        if (!(0, $c418de54527e13f3$export$2e2bcd8739ae039).hasClass(name)) {
            if ((typeof themeItem === "undefined" ? "undefined" : (0, $7E0eS._)(themeItem)) === 'object') option[name] = !option[name] ? (0, $f16f2994a32ad273$export$9cd59f9826255e47)(themeItem) : (0, $f16f2994a32ad273$export$4950aa0f605343fb)(option[name], themeItem, false);
            else if (option[name] == null) option[name] = themeItem;
        }
    });
}
function $5fcc33310122e6f0$var$queryByIdOrName(attr, idOrName, cmpts) {
    // Here is a break from echarts4: string and number are
    // treated as equal.
    if ((0, $f16f2994a32ad273$export$43bee75e5e14138e)(idOrName)) {
        var keyMap_1 = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(idOrName, function(idOrNameItem) {
            if (idOrNameItem != null) {
                var idName = $3fa81475350067fd$export$fb1a222ba5dd6e51(idOrNameItem, null);
                idName != null && keyMap_1.set(idOrNameItem, true);
            }
        });
        return (0, $f16f2994a32ad273$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return cmpt && keyMap_1.get(cmpt[attr]);
        });
    } else {
        var idName_1 = $3fa81475350067fd$export$fb1a222ba5dd6e51(idOrName, null);
        return (0, $f16f2994a32ad273$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return cmpt && idName_1 != null && cmpt[attr] === idName_1;
        });
    }
}
function $5fcc33310122e6f0$var$filterBySubType(components, condition) {
    // Using hasOwnProperty for restrict. Consider
    // subType is undefined in user payload.
    return condition.hasOwnProperty('subType') ? (0, $f16f2994a32ad273$export$3dea766d36a8935f)(components, function(cmpt) {
        return cmpt && cmpt.subType === condition.subType;
    }) : components;
}
function $5fcc33310122e6f0$var$normalizeSetOptionInput(opts) {
    var replaceMergeMainTypeMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
    opts && (0, $f16f2994a32ad273$export$79b2f7037acddd43)($3fa81475350067fd$export$4f07b212a02c8051(opts.replaceMerge), function(mainType) {
        replaceMergeMainTypeMap.set(mainType, true);
    });
    return {
        replaceMergeMainTypeMap: replaceMergeMainTypeMap
    };
}
(0, $f16f2994a32ad273$export$e36fc9d62a853069)($5fcc33310122e6f0$var$GlobalModel, (0, $a38f59c4bc389a29$export$55a3c39e852b90f4));
var $5fcc33310122e6f0$export$2e2bcd8739ae039 = $5fcc33310122e6f0$var$GlobalModel;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $76e6337c900a327f$var$QUERY_REG = /^(min|max)?(.+)$/;
// Key: mainType
// type FakeComponentsMap = HashMap<(MappingExistingItem & { subType: string })[]>;
/**
 * TERM EXPLANATIONS:
 * See `ECOption` and `ECUnitOption` in `src/util/types.ts`.
 */ var $76e6337c900a327f$var$OptionManager = /** @class */ function() {
    // timeline.notMerge is not supported in ec3. Firstly there is rearly
    // case that notMerge is needed. Secondly supporting 'notMerge' requires
    // rawOption cloned and backuped when timeline changed, which does no
    // good to performance. What's more, that both timeline and setOption
    // method supply 'notMerge' brings complex and some problems.
    // Consider this case:
    // (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
    // (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
    function OptionManager(api) {
        this._timelineOptions = [];
        this._mediaList = [];
        /**
     * -1, means default.
     * empty means no media.
     */ this._currentMediaIndices = [];
        this._api = api;
    }
    OptionManager.prototype.setOption = function(rawOption, optionPreprocessorFuncs, opt) {
        if (rawOption) {
            // That set dat primitive is dangerous if user reuse the data when setOption again.
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)((0, $3fa81475350067fd$export$4f07b212a02c8051)(rawOption.series), function(series) {
                series && series.data && (0, $f16f2994a32ad273$export$b119cc7e1840e59c)(series.data) && (0, $f16f2994a32ad273$export$112e66431016387b)(series.data);
            });
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)((0, $3fa81475350067fd$export$4f07b212a02c8051)(rawOption.dataset), function(dataset) {
                dataset && dataset.source && (0, $f16f2994a32ad273$export$b119cc7e1840e59c)(dataset.source) && (0, $f16f2994a32ad273$export$112e66431016387b)(dataset.source);
            });
        }
        // Caution: some series modify option data, if do not clone,
        // it should ensure that the repeat modify correctly
        // (create a new object when modify itself).
        rawOption = (0, $f16f2994a32ad273$export$9cd59f9826255e47)(rawOption);
        // FIXME
        // If some property is set in timeline options or media option but
        // not set in baseOption, a warning should be given.
        var optionBackup = this._optionBackup;
        var newParsedOption = $76e6337c900a327f$var$parseRawOption(rawOption, optionPreprocessorFuncs, !optionBackup);
        this._newBaseOption = newParsedOption.baseOption;
        // For setOption at second time (using merge mode);
        if (optionBackup) {
            // FIXME
            // the restore merge solution is essentially incorrect.
            // the mapping can not be 100% consistent with ecModel, which probably brings
            // potential bug!
            // The first merge is delayed, because in most cases, users do not call `setOption` twice.
            // let fakeCmptsMap = this._fakeCmptsMap;
            // if (!fakeCmptsMap) {
            //     fakeCmptsMap = this._fakeCmptsMap = createHashMap();
            //     mergeToBackupOption(fakeCmptsMap, null, optionBackup.baseOption, null);
            // }
            // mergeToBackupOption(
            //     fakeCmptsMap, optionBackup.baseOption, newParsedOption.baseOption, opt
            // );
            // For simplicity, timeline options and media options do not support merge,
            // that is, if you `setOption` twice and both has timeline options, the latter
            // timeline options will not be merged to the former, but just substitute them.
            if (newParsedOption.timelineOptions.length) optionBackup.timelineOptions = newParsedOption.timelineOptions;
            if (newParsedOption.mediaList.length) optionBackup.mediaList = newParsedOption.mediaList;
            if (newParsedOption.mediaDefault) optionBackup.mediaDefault = newParsedOption.mediaDefault;
        } else this._optionBackup = newParsedOption;
    };
    OptionManager.prototype.mountOption = function(isRecreate) {
        var optionBackup = this._optionBackup;
        this._timelineOptions = optionBackup.timelineOptions;
        this._mediaList = optionBackup.mediaList;
        this._mediaDefault = optionBackup.mediaDefault;
        this._currentMediaIndices = [];
        return (0, $f16f2994a32ad273$export$9cd59f9826255e47)(isRecreate ? optionBackup.baseOption : this._newBaseOption);
    };
    OptionManager.prototype.getTimelineOption = function(ecModel) {
        var option;
        var timelineOptions = this._timelineOptions;
        if (timelineOptions.length) {
            // getTimelineOption can only be called after ecModel inited,
            // so we can get currentIndex from timelineModel.
            var timelineModel = ecModel.getComponent('timeline');
            if (timelineModel) option = (0, $f16f2994a32ad273$export$9cd59f9826255e47)(// FIXME:TS as TimelineModel or quivlant interface
            timelineOptions[timelineModel.getCurrentIndex()]);
        }
        return option;
    };
    OptionManager.prototype.getMediaOption = function(ecModel) {
        var ecWidth = this._api.getWidth();
        var ecHeight = this._api.getHeight();
        var mediaList = this._mediaList;
        var mediaDefault = this._mediaDefault;
        var indices = [];
        var result = [];
        // No media defined.
        if (!mediaList.length && !mediaDefault) return result;
        // Multi media may be applied, the latter defined media has higher priority.
        for(var i = 0, len = mediaList.length; i < len; i++)if ($76e6337c900a327f$var$applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) indices.push(i);
        // FIXME
        // Whether mediaDefault should force users to provide? Otherwise
        // the change by media query can not be recorvered.
        if (!indices.length && mediaDefault) indices = [
            -1
        ];
        if (indices.length && !$76e6337c900a327f$var$indicesEquals(indices, this._currentMediaIndices)) result = (0, $f16f2994a32ad273$export$871de8747c9eaa88)(indices, function(index) {
            return (0, $f16f2994a32ad273$export$9cd59f9826255e47)(index === -1 ? mediaDefault.option : mediaList[index].option);
        });
        // Otherwise return nothing.
        this._currentMediaIndices = indices;
        return result;
    };
    return OptionManager;
}();
/**
 * [RAW_OPTION_PATTERNS]
 * (Note: "series: []" represents all other props in `ECUnitOption`)
 *
 * (1) No prop "baseOption" declared:
 * Root option is used as "baseOption" (except prop "options" and "media").
 * ```js
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 * };
 * option = {
 *     series: [],
 *     media: {},
 * };
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 *     media: {},
 * }
 * ```
 *
 * (2) Prop "baseOption" declared:
 * If "baseOption" declared, `ECUnitOption` props can only be declared
 * inside "baseOption" except prop "timeline" (compat ec2).
 * ```js
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 * };
 * option = {
 *     baseOption: {
 *         series: [],
 *     },
 *     media: []
 * };
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 *     media: []
 * };
 * option = {
 *     // ec3 compat ec2: allow (only) `timeline` declared
 *     // outside baseOption. Keep this setting for compat.
 *     timeline: {},
 *     baseOption: {
 *         series: [],
 *     },
 *     options: [],
 *     media: []
 * };
 * ```
 */ function $76e6337c900a327f$var$parseRawOption(// `rawOption` May be modified
rawOption, optionPreprocessorFuncs, isNew) {
    var mediaList = [];
    var mediaDefault;
    var baseOption;
    var declaredBaseOption = rawOption.baseOption;
    // Compatible with ec2, [RAW_OPTION_PATTERNS] above.
    var timelineOnRoot = rawOption.timeline;
    var timelineOptionsOnRoot = rawOption.options;
    var mediaOnRoot = rawOption.media;
    var hasMedia = !!rawOption.media;
    var hasTimeline = !!(timelineOptionsOnRoot || timelineOnRoot || declaredBaseOption && declaredBaseOption.timeline);
    if (declaredBaseOption) {
        baseOption = declaredBaseOption;
        // For merge option.
        if (!baseOption.timeline) baseOption.timeline = timelineOnRoot;
    } else {
        if (hasTimeline || hasMedia) rawOption.options = rawOption.media = null;
        baseOption = rawOption;
    }
    if (hasMedia) {
        if ((0, $f16f2994a32ad273$export$43bee75e5e14138e)(mediaOnRoot)) (0, $f16f2994a32ad273$export$79b2f7037acddd43)(mediaOnRoot, function(singleMedia) {
            if (singleMedia && singleMedia.option) {
                if (singleMedia.query) mediaList.push(singleMedia);
                else if (!mediaDefault) // Use the first media default.
                mediaDefault = singleMedia;
            }
        });
    }
    doPreprocess(baseOption);
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(timelineOptionsOnRoot, function(option) {
        return doPreprocess(option);
    });
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(mediaList, function(media) {
        return doPreprocess(media.option);
    });
    function doPreprocess(option) {
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(optionPreprocessorFuncs, function(preProcess) {
            preProcess(option, isNew);
        });
    }
    return {
        baseOption: baseOption,
        timelineOptions: timelineOptionsOnRoot || [],
        mediaDefault: mediaDefault,
        mediaList: mediaList
    };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */ function $76e6337c900a327f$var$applyMediaQuery(query, ecWidth, ecHeight) {
    var realMap = {
        width: ecWidth,
        height: ecHeight,
        aspectratio: ecWidth / ecHeight // lower case for convenience.
    };
    var applicable = true;
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(query, function(value, attr) {
        var matched = attr.match($76e6337c900a327f$var$QUERY_REG);
        if (!matched || !matched[1] || !matched[2]) return;
        var operator = matched[1];
        var realAttr = matched[2].toLowerCase();
        if (!$76e6337c900a327f$var$compare(realMap[realAttr], value, operator)) applicable = false;
    });
    return applicable;
}
function $76e6337c900a327f$var$compare(real, expect, operator) {
    if (operator === 'min') return real >= expect;
    else if (operator === 'max') return real <= expect;
    else // Equals
    return real === expect;
}
function $76e6337c900a327f$var$indicesEquals(indices1, indices2) {
    // indices is always order by asc and has only finite number.
    return indices1.join(',') === indices2.join(',');
}
var /**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handles its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performance expensive)
 *
 * FIXME: A possible solution:
 * Add a extra level of model for each component model. The inheritance chain would be:
 * ecModel <- componentModel <- componentActionModel <- dataItemModel
 * And all of the actions can only modify the `componentActionModel` rather than
 * `componentModel`. `setOption` will only modify the `ecModel` and `componentModel`.
 * When "resotre" action triggered, model from `componentActionModel` will be discarded
 * instead of recreating the "ecModel" from the "_optionBackup".
 */ // function mergeToBackupOption(
//     fakeCmptsMap: FakeComponentsMap,
//     // `tarOption` Can be null/undefined, means init
//     tarOption: ECUnitOption,
//     newOption: ECUnitOption,
//     // Can be null/undefined
//     opt: InnerSetOptionOpts
// ): void {
//     newOption = newOption || {} as ECUnitOption;
//     const notInit = !!tarOption;
//     each(newOption, function (newOptsInMainType, mainType) {
//         if (newOptsInMainType == null) {
//             return;
//         }
//         if (!ComponentModel.hasClass(mainType)) {
//             if (tarOption) {
//                 tarOption[mainType] = merge(tarOption[mainType], newOptsInMainType, true);
//             }
//         }
//         else {
//             const oldTarOptsInMainType = notInit ? normalizeToArray(tarOption[mainType]) : null;
//             const oldFakeCmptsInMainType = fakeCmptsMap.get(mainType) || [];
//             const resultTarOptsInMainType = notInit ? (tarOption[mainType] = [] as ComponentOption[]) : null;
//             const resultFakeCmptsInMainType = fakeCmptsMap.set(mainType, []);
//             const mappingResult = mappingToExists(
//                 oldFakeCmptsInMainType,
//                 normalizeToArray(newOptsInMainType),
//                 (opt && opt.replaceMergeMainTypeMap.get(mainType)) ? 'replaceMerge' : 'normalMerge'
//             );
//             setComponentTypeToKeyInfo(mappingResult, mainType, ComponentModel as ComponentModelConstructor);
//             each(mappingResult, function (resultItem, index) {
//                 // The same logic as `Global.ts#_mergeOption`.
//                 let fakeCmpt = resultItem.existing;
//                 const newOption = resultItem.newOption;
//                 const keyInfo = resultItem.keyInfo;
//                 let fakeCmptOpt;
//                 if (!newOption) {
//                     fakeCmptOpt = oldTarOptsInMainType[index];
//                 }
//                 else {
//                     if (fakeCmpt && fakeCmpt.subType === keyInfo.subType) {
//                         fakeCmpt.name = keyInfo.name;
//                         if (notInit) {
//                             fakeCmptOpt = merge(oldTarOptsInMainType[index], newOption, true);
//                         }
//                     }
//                     else {
//                         fakeCmpt = extend({}, keyInfo);
//                         if (notInit) {
//                             fakeCmptOpt = clone(newOption);
//                         }
//                     }
//                 }
//                 if (fakeCmpt) {
//                     notInit && resultTarOptsInMainType.push(fakeCmptOpt);
//                     resultFakeCmptsInMainType.push(fakeCmpt);
//                 }
//                 else {
//                     notInit && resultTarOptsInMainType.push(void 0);
//                     resultFakeCmptsInMainType.push(void 0);
//                 }
//             });
//         }
//     });
// }
$76e6337c900a327f$export$2e2bcd8739ae039 = $76e6337c900a327f$var$OptionManager;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $7E0eS = parcelRequire("7E0eS");

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $a00f28c4adbb5b70$var$each = $f16f2994a32ad273$export$79b2f7037acddd43;
var $a00f28c4adbb5b70$var$isObject = $f16f2994a32ad273$export$a6cdc56e425d0d0a;
var $a00f28c4adbb5b70$var$POSSIBLE_STYLES = [
    'areaStyle',
    'lineStyle',
    'nodeStyle',
    'linkStyle',
    'chordStyle',
    'label',
    'labelLine'
];
function $a00f28c4adbb5b70$var$compatEC2ItemStyle(opt) {
    var itemStyleOpt = opt && opt.itemStyle;
    if (!itemStyleOpt) return;
    for(var i = 0, len = $a00f28c4adbb5b70$var$POSSIBLE_STYLES.length; i < len; i++){
        var styleName = $a00f28c4adbb5b70$var$POSSIBLE_STYLES[i];
        var normalItemStyleOpt = itemStyleOpt.normal;
        var emphasisItemStyleOpt = itemStyleOpt.emphasis;
        if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].normal) opt[styleName].normal = normalItemStyleOpt[styleName];
            else $f16f2994a32ad273$export$4950aa0f605343fb(opt[styleName].normal, normalItemStyleOpt[styleName]);
            normalItemStyleOpt[styleName] = null;
        }
        if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].emphasis) opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
            else $f16f2994a32ad273$export$4950aa0f605343fb(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
            emphasisItemStyleOpt[styleName] = null;
        }
    }
}
function $a00f28c4adbb5b70$var$convertNormalEmphasis(opt, optType, useExtend) {
    if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
        var normalOpt = opt[optType].normal;
        var emphasisOpt = opt[optType].emphasis;
        if (normalOpt) {
            // Timeline controlStyle has other properties besides normal and emphasis
            if (useExtend) {
                opt[optType].normal = opt[optType].emphasis = null;
                $f16f2994a32ad273$export$ebe90cb607ad99e(opt[optType], normalOpt);
            } else opt[optType] = normalOpt;
        }
        if (emphasisOpt) {
            opt.emphasis = opt.emphasis || {};
            opt.emphasis[optType] = emphasisOpt;
            // Also compat the case user mix the style and focus together in ec3 style
            // for example: { itemStyle: { normal: {}, emphasis: {focus, shadowBlur} } }
            if (emphasisOpt.focus) opt.emphasis.focus = emphasisOpt.focus;
            if (emphasisOpt.blurScope) opt.emphasis.blurScope = emphasisOpt.blurScope;
        }
    }
}
function $a00f28c4adbb5b70$var$removeEC3NormalStatus(opt) {
    $a00f28c4adbb5b70$var$convertNormalEmphasis(opt, 'itemStyle');
    $a00f28c4adbb5b70$var$convertNormalEmphasis(opt, 'lineStyle');
    $a00f28c4adbb5b70$var$convertNormalEmphasis(opt, 'areaStyle');
    $a00f28c4adbb5b70$var$convertNormalEmphasis(opt, 'label');
    $a00f28c4adbb5b70$var$convertNormalEmphasis(opt, 'labelLine');
    // treemap
    $a00f28c4adbb5b70$var$convertNormalEmphasis(opt, 'upperLabel');
    // graph
    $a00f28c4adbb5b70$var$convertNormalEmphasis(opt, 'edgeLabel');
}
function $a00f28c4adbb5b70$var$compatTextStyle(opt, propName) {
    // Check whether is not object (string\null\undefined ...)
    var labelOptSingle = $a00f28c4adbb5b70$var$isObject(opt) && opt[propName];
    var textStyle = $a00f28c4adbb5b70$var$isObject(labelOptSingle) && labelOptSingle.textStyle;
    if (textStyle) for(var i = 0, len = $3fa81475350067fd$export$df45610347a602ad.length; i < len; i++){
        var textPropName = $3fa81475350067fd$export$df45610347a602ad[i];
        if (textStyle.hasOwnProperty(textPropName)) labelOptSingle[textPropName] = textStyle[textPropName];
    }
}
function $a00f28c4adbb5b70$var$compatEC3CommonStyles(opt) {
    if (opt) {
        $a00f28c4adbb5b70$var$removeEC3NormalStatus(opt);
        $a00f28c4adbb5b70$var$compatTextStyle(opt, 'label');
        opt.emphasis && $a00f28c4adbb5b70$var$compatTextStyle(opt.emphasis, 'label');
    }
}
function $a00f28c4adbb5b70$var$processSeries(seriesOpt) {
    if (!$a00f28c4adbb5b70$var$isObject(seriesOpt)) return;
    $a00f28c4adbb5b70$var$compatEC2ItemStyle(seriesOpt);
    $a00f28c4adbb5b70$var$removeEC3NormalStatus(seriesOpt);
    $a00f28c4adbb5b70$var$compatTextStyle(seriesOpt, 'label');
    // treemap
    $a00f28c4adbb5b70$var$compatTextStyle(seriesOpt, 'upperLabel');
    // graph
    $a00f28c4adbb5b70$var$compatTextStyle(seriesOpt, 'edgeLabel');
    if (seriesOpt.emphasis) {
        $a00f28c4adbb5b70$var$compatTextStyle(seriesOpt.emphasis, 'label');
        // treemap
        $a00f28c4adbb5b70$var$compatTextStyle(seriesOpt.emphasis, 'upperLabel');
        // graph
        $a00f28c4adbb5b70$var$compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
    }
    var markPoint = seriesOpt.markPoint;
    if (markPoint) {
        $a00f28c4adbb5b70$var$compatEC2ItemStyle(markPoint);
        $a00f28c4adbb5b70$var$compatEC3CommonStyles(markPoint);
    }
    var markLine = seriesOpt.markLine;
    if (markLine) {
        $a00f28c4adbb5b70$var$compatEC2ItemStyle(markLine);
        $a00f28c4adbb5b70$var$compatEC3CommonStyles(markLine);
    }
    var markArea = seriesOpt.markArea;
    if (markArea) $a00f28c4adbb5b70$var$compatEC3CommonStyles(markArea);
    var data = seriesOpt.data;
    // Break with ec3: if `setOption` again, there may be no `type` in option,
    // then the backward compat based on option type will not be performed.
    if (seriesOpt.type === 'graph') {
        data = data || seriesOpt.nodes;
        var edgeData = seriesOpt.links || seriesOpt.edges;
        if (edgeData && !$f16f2994a32ad273$export$b119cc7e1840e59c(edgeData)) for(var i = 0; i < edgeData.length; i++)$a00f28c4adbb5b70$var$compatEC3CommonStyles(edgeData[i]);
        $f16f2994a32ad273$export$79b2f7037acddd43(seriesOpt.categories, function(opt) {
            $a00f28c4adbb5b70$var$removeEC3NormalStatus(opt);
        });
    }
    if (data && !$f16f2994a32ad273$export$b119cc7e1840e59c(data)) for(var i = 0; i < data.length; i++)$a00f28c4adbb5b70$var$compatEC3CommonStyles(data[i]);
    // mark point data
    markPoint = seriesOpt.markPoint;
    if (markPoint && markPoint.data) {
        var mpData = markPoint.data;
        for(var i = 0; i < mpData.length; i++)$a00f28c4adbb5b70$var$compatEC3CommonStyles(mpData[i]);
    }
    // mark line data
    markLine = seriesOpt.markLine;
    if (markLine && markLine.data) {
        var mlData = markLine.data;
        for(var i = 0; i < mlData.length; i++)if ($f16f2994a32ad273$export$43bee75e5e14138e(mlData[i])) {
            $a00f28c4adbb5b70$var$compatEC3CommonStyles(mlData[i][0]);
            $a00f28c4adbb5b70$var$compatEC3CommonStyles(mlData[i][1]);
        } else $a00f28c4adbb5b70$var$compatEC3CommonStyles(mlData[i]);
    }
    // Series
    if (seriesOpt.type === 'gauge') {
        $a00f28c4adbb5b70$var$compatTextStyle(seriesOpt, 'axisLabel');
        $a00f28c4adbb5b70$var$compatTextStyle(seriesOpt, 'title');
        $a00f28c4adbb5b70$var$compatTextStyle(seriesOpt, 'detail');
    } else if (seriesOpt.type === 'treemap') {
        $a00f28c4adbb5b70$var$convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
        $f16f2994a32ad273$export$79b2f7037acddd43(seriesOpt.levels, function(opt) {
            $a00f28c4adbb5b70$var$removeEC3NormalStatus(opt);
        });
    } else if (seriesOpt.type === 'tree') $a00f28c4adbb5b70$var$removeEC3NormalStatus(seriesOpt.leaves);
// sunburst starts from ec4, so it does not need to compat levels.
}
function $a00f28c4adbb5b70$var$toArr(o) {
    return $f16f2994a32ad273$export$43bee75e5e14138e(o) ? o : o ? [
        o
    ] : [];
}
function $a00f28c4adbb5b70$var$toObj(o) {
    return ($f16f2994a32ad273$export$43bee75e5e14138e(o) ? o[0] : o) || {};
}
function $a00f28c4adbb5b70$export$2e2bcd8739ae039(option, isTheme) {
    $a00f28c4adbb5b70$var$each($a00f28c4adbb5b70$var$toArr(option.series), function(seriesOpt) {
        $a00f28c4adbb5b70$var$isObject(seriesOpt) && $a00f28c4adbb5b70$var$processSeries(seriesOpt);
    });
    var axes = [
        'xAxis',
        'yAxis',
        'radiusAxis',
        'angleAxis',
        'singleAxis',
        'parallelAxis',
        'radar'
    ];
    isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
    $a00f28c4adbb5b70$var$each(axes, function(axisName) {
        $a00f28c4adbb5b70$var$each($a00f28c4adbb5b70$var$toArr(option[axisName]), function(axisOpt) {
            if (axisOpt) {
                $a00f28c4adbb5b70$var$compatTextStyle(axisOpt, 'axisLabel');
                $a00f28c4adbb5b70$var$compatTextStyle(axisOpt.axisPointer, 'label');
            }
        });
    });
    $a00f28c4adbb5b70$var$each($a00f28c4adbb5b70$var$toArr(option.parallel), function(parallelOpt) {
        var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
        $a00f28c4adbb5b70$var$compatTextStyle(parallelAxisDefault, 'axisLabel');
        $a00f28c4adbb5b70$var$compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
    });
    $a00f28c4adbb5b70$var$each($a00f28c4adbb5b70$var$toArr(option.calendar), function(calendarOpt) {
        $a00f28c4adbb5b70$var$convertNormalEmphasis(calendarOpt, 'itemStyle');
        $a00f28c4adbb5b70$var$compatTextStyle(calendarOpt, 'dayLabel');
        $a00f28c4adbb5b70$var$compatTextStyle(calendarOpt, 'monthLabel');
        $a00f28c4adbb5b70$var$compatTextStyle(calendarOpt, 'yearLabel');
    });
    // radar.name.textStyle
    $a00f28c4adbb5b70$var$each($a00f28c4adbb5b70$var$toArr(option.radar), function(radarOpt) {
        $a00f28c4adbb5b70$var$compatTextStyle(radarOpt, 'name');
        // Use axisName instead of name because component has name property
        if (radarOpt.name && radarOpt.axisName == null) {
            radarOpt.axisName = radarOpt.name;
            delete radarOpt.name;
        }
        if (radarOpt.nameGap != null && radarOpt.axisNameGap == null) {
            radarOpt.axisNameGap = radarOpt.nameGap;
            delete radarOpt.nameGap;
        }
    });
    $a00f28c4adbb5b70$var$each($a00f28c4adbb5b70$var$toArr(option.geo), function(geoOpt) {
        if ($a00f28c4adbb5b70$var$isObject(geoOpt)) {
            $a00f28c4adbb5b70$var$compatEC3CommonStyles(geoOpt);
            $a00f28c4adbb5b70$var$each($a00f28c4adbb5b70$var$toArr(geoOpt.regions), function(regionObj) {
                $a00f28c4adbb5b70$var$compatEC3CommonStyles(regionObj);
            });
        }
    });
    $a00f28c4adbb5b70$var$each($a00f28c4adbb5b70$var$toArr(option.timeline), function(timelineOpt) {
        $a00f28c4adbb5b70$var$compatEC3CommonStyles(timelineOpt);
        $a00f28c4adbb5b70$var$convertNormalEmphasis(timelineOpt, 'label');
        $a00f28c4adbb5b70$var$convertNormalEmphasis(timelineOpt, 'itemStyle');
        $a00f28c4adbb5b70$var$convertNormalEmphasis(timelineOpt, 'controlStyle', true);
        var data = timelineOpt.data;
        $f16f2994a32ad273$export$43bee75e5e14138e(data) && $f16f2994a32ad273$export$79b2f7037acddd43(data, function(item) {
            if ($f16f2994a32ad273$export$a6cdc56e425d0d0a(item)) {
                $a00f28c4adbb5b70$var$convertNormalEmphasis(item, 'label');
                $a00f28c4adbb5b70$var$convertNormalEmphasis(item, 'itemStyle');
            }
        });
    });
    $a00f28c4adbb5b70$var$each($a00f28c4adbb5b70$var$toArr(option.toolbox), function(toolboxOpt) {
        $a00f28c4adbb5b70$var$convertNormalEmphasis(toolboxOpt, 'iconStyle');
        $a00f28c4adbb5b70$var$each(toolboxOpt.feature, function(featureOpt) {
            $a00f28c4adbb5b70$var$convertNormalEmphasis(featureOpt, 'iconStyle');
        });
    });
    $a00f28c4adbb5b70$var$compatTextStyle($a00f28c4adbb5b70$var$toObj(option.axisPointer), 'label');
    $a00f28c4adbb5b70$var$compatTextStyle($a00f28c4adbb5b70$var$toObj(option.tooltip).axisPointer, 'label');
// Clean logs
// storedLogs = {};
}




function $5489e37b9bdb0718$var$get(opt, path) {
    var pathArr = path.split(',');
    var obj = opt;
    for(var i = 0; i < pathArr.length; i++){
        obj = obj && obj[pathArr[i]];
        if (obj == null) break;
    }
    return obj;
}
function $5489e37b9bdb0718$var$set(opt, path, val, overwrite) {
    var pathArr = path.split(',');
    var obj = opt;
    var key;
    var i = 0;
    for(; i < pathArr.length - 1; i++){
        key = pathArr[i];
        if (obj[key] == null) obj[key] = {};
        obj = obj[key];
    }
    if (overwrite || obj[pathArr[i]] == null) obj[pathArr[i]] = val;
}
function $5489e37b9bdb0718$var$compatLayoutProperties(option) {
    option && (0, $f16f2994a32ad273$export$79b2f7037acddd43)($5489e37b9bdb0718$var$LAYOUT_PROPERTIES, function(prop) {
        if (prop[0] in option && !(prop[1] in option)) option[prop[1]] = option[prop[0]];
    });
}
var $5489e37b9bdb0718$var$LAYOUT_PROPERTIES = [
    [
        'x',
        'left'
    ],
    [
        'y',
        'top'
    ],
    [
        'x2',
        'right'
    ],
    [
        'y2',
        'bottom'
    ]
];
var $5489e37b9bdb0718$var$COMPATITABLE_COMPONENTS = [
    'grid',
    'geo',
    'parallel',
    'legend',
    'toolbox',
    'title',
    'visualMap',
    'dataZoom',
    'timeline'
];
var $5489e37b9bdb0718$var$BAR_ITEM_STYLE_MAP = [
    [
        'borderRadius',
        'barBorderRadius'
    ],
    [
        'borderColor',
        'barBorderColor'
    ],
    [
        'borderWidth',
        'barBorderWidth'
    ]
];
function $5489e37b9bdb0718$var$compatBarItemStyle(option) {
    var itemStyle = option && option.itemStyle;
    if (itemStyle) for(var i = 0; i < $5489e37b9bdb0718$var$BAR_ITEM_STYLE_MAP.length; i++){
        var oldName = $5489e37b9bdb0718$var$BAR_ITEM_STYLE_MAP[i][1];
        var newName = $5489e37b9bdb0718$var$BAR_ITEM_STYLE_MAP[i][0];
        if (itemStyle[oldName] != null) itemStyle[newName] = itemStyle[oldName];
    }
}
function $5489e37b9bdb0718$var$compatPieLabel(option) {
    if (!option) return;
    if (option.alignTo === 'edge' && option.margin != null && option.edgeDistance == null) option.edgeDistance = option.margin;
}
function $5489e37b9bdb0718$var$compatSunburstState(option) {
    if (!option) return;
    if (option.downplay && !option.blur) option.blur = option.downplay;
}
function $5489e37b9bdb0718$var$compatGraphFocus(option) {
    if (!option) return;
    if (option.focusNodeAdjacency != null) {
        option.emphasis = option.emphasis || {};
        if (option.emphasis.focus == null) option.emphasis.focus = 'adjacency';
    }
}
function $5489e37b9bdb0718$var$traverseTree(data, cb) {
    if (data) for(var i = 0; i < data.length; i++){
        cb(data[i]);
        data[i] && $5489e37b9bdb0718$var$traverseTree(data[i].children, cb);
    }
}
function $5489e37b9bdb0718$export$2e2bcd8739ae039(option, isTheme) {
    (0, $a00f28c4adbb5b70$export$2e2bcd8739ae039)(option, isTheme);
    // Make sure series array for model initialization.
    option.series = (0, $3fa81475350067fd$export$4f07b212a02c8051)(option.series);
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(option.series, function(seriesOpt) {
        if (!(0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(seriesOpt)) return;
        var seriesType = seriesOpt.type;
        if (seriesType === 'line') {
            if (seriesOpt.clipOverflow != null) seriesOpt.clip = seriesOpt.clipOverflow;
        } else if (seriesType === 'pie' || seriesType === 'gauge') {
            if (seriesOpt.clockWise != null) seriesOpt.clockwise = seriesOpt.clockWise;
            $5489e37b9bdb0718$var$compatPieLabel(seriesOpt.label);
            var data = seriesOpt.data;
            if (data && !(0, $f16f2994a32ad273$export$b119cc7e1840e59c)(data)) for(var i = 0; i < data.length; i++)$5489e37b9bdb0718$var$compatPieLabel(data[i]);
            if (seriesOpt.hoverOffset != null) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                seriesOpt.emphasis.scaleSize = null;
            }
        } else if (seriesType === 'gauge') {
            var pointerColor = $5489e37b9bdb0718$var$get(seriesOpt, 'pointer.color');
            pointerColor != null && $5489e37b9bdb0718$var$set(seriesOpt, 'itemStyle.color', pointerColor);
        } else if (seriesType === 'bar') {
            $5489e37b9bdb0718$var$compatBarItemStyle(seriesOpt);
            $5489e37b9bdb0718$var$compatBarItemStyle(seriesOpt.backgroundStyle);
            $5489e37b9bdb0718$var$compatBarItemStyle(seriesOpt.emphasis);
            var data = seriesOpt.data;
            if (data && !(0, $f16f2994a32ad273$export$b119cc7e1840e59c)(data)) {
                for(var i = 0; i < data.length; i++)if ((0, $7E0eS._)(data[i]) === 'object') {
                    $5489e37b9bdb0718$var$compatBarItemStyle(data[i]);
                    $5489e37b9bdb0718$var$compatBarItemStyle(data[i] && data[i].emphasis);
                }
            }
        } else if (seriesType === 'sunburst') {
            var highlightPolicy = seriesOpt.highlightPolicy;
            if (highlightPolicy) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                if (!seriesOpt.emphasis.focus) seriesOpt.emphasis.focus = highlightPolicy;
            }
            $5489e37b9bdb0718$var$compatSunburstState(seriesOpt);
            $5489e37b9bdb0718$var$traverseTree(seriesOpt.data, $5489e37b9bdb0718$var$compatSunburstState);
        } else if (seriesType === 'graph' || seriesType === 'sankey') $5489e37b9bdb0718$var$compatGraphFocus(seriesOpt);
        else if (seriesType === 'map') {
            if (seriesOpt.mapType && !seriesOpt.map) seriesOpt.map = seriesOpt.mapType;
            if (seriesOpt.mapLocation) (0, $f16f2994a32ad273$export$ebe90cb607ad99e)(seriesOpt, seriesOpt.mapLocation);
        }
        if (seriesOpt.hoverAnimation != null) {
            seriesOpt.emphasis = seriesOpt.emphasis || {};
            if (seriesOpt.emphasis && seriesOpt.emphasis.scale == null) seriesOpt.emphasis.scale = seriesOpt.hoverAnimation;
        }
        $5489e37b9bdb0718$var$compatLayoutProperties(seriesOpt);
    });
    // dataRange has changed to visualMap
    if (option.dataRange) option.visualMap = option.dataRange;
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)($5489e37b9bdb0718$var$COMPATITABLE_COMPONENTS, function(componentName) {
        var options = option[componentName];
        if (options) {
            if (!(0, $f16f2994a32ad273$export$43bee75e5e14138e)(options)) options = [
                options
            ];
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)(options, function(option) {
                $5489e37b9bdb0718$var$compatLayoutProperties(option);
            });
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $8bcda5b0a988ff47$export$dc018729d9e78c17 = (0, $3fa81475350067fd$export$d62c61cad9d1ab83)($8bcda5b0a988ff47$var$dataStack);
// (1) [Caution]: the logic is correct based on the premises:
//     data processing stage is blocked in stream.
//     See <module:echarts/stream/Scheduler#performDataProcessorTasks>
// (2) Only register once when import repeatedly.
//     Should be executed after series is filtered and before stack calculation.
function $8bcda5b0a988ff47$var$dataStack(ecModel) {
    var stackInfoMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
    ecModel.eachSeries(function(seriesModel) {
        var stack = seriesModel.get('stack');
        // Compatible: when `stack` is set as '', do not stack.
        if (stack) {
            var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
            var data = seriesModel.getData();
            var stackInfo = {
                // Used for calculate axis extent automatically.
                // TODO: Type getCalculationInfo return more specific type?
                stackResultDimension: data.getCalculationInfo('stackResultDimension'),
                stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
                stackedDimension: data.getCalculationInfo('stackedDimension'),
                stackedByDimension: data.getCalculationInfo('stackedByDimension'),
                isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
                data: data,
                seriesModel: seriesModel
            };
            // If stacked on axis that do not support data stack.
            if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) return;
            stackInfoList.push(stackInfo);
        }
    });
    // Process each stack group
    stackInfoMap.each(function(stackInfoList) {
        if (stackInfoList.length === 0) return;
        // Check if stack order needs to be reversed
        var firstSeries = stackInfoList[0].seriesModel;
        var stackOrder = firstSeries.get('stackOrder') || 'seriesAsc';
        if (stackOrder === 'seriesDesc') stackInfoList.reverse();
        // Set stackedOnSeries for each series in the final order
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(stackInfoList, function(stackInfo, index) {
            stackInfo.data.setCalculationInfo('stackedOnSeries', index > 0 ? stackInfoList[index - 1].seriesModel : null);
        });
        // Calculate stack values
        $8bcda5b0a988ff47$var$calculateStack(stackInfoList);
    });
}
function $8bcda5b0a988ff47$var$calculateStack(stackInfoList) {
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(stackInfoList, function(targetStackInfo, idxInStack) {
        var resultVal = [];
        var resultNaN = [
            NaN,
            NaN
        ];
        var dims = [
            targetStackInfo.stackResultDimension,
            targetStackInfo.stackedOverDimension
        ];
        var targetData = targetStackInfo.data;
        var isStackedByIndex = targetStackInfo.isStackedByIndex;
        var stackStrategy = targetStackInfo.seriesModel.get('stackStrategy') || 'samesign';
        // Should not write on raw data, because stack series model list changes
        // depending on legend selection.
        targetData.modify(dims, function(v0, v1, dataIndex) {
            var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex);
            // Consider `connectNulls` of line area, if value is NaN, stackedOver
            // should also be NaN, to draw a appropriate belt area.
            if (isNaN(sum)) return resultNaN;
            var byValue;
            var stackedDataRawIndex;
            if (isStackedByIndex) stackedDataRawIndex = targetData.getRawIndex(dataIndex);
            else byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
            // If stackOver is NaN, chart view will render point on value start.
            var stackedOver = NaN;
            for(var j = idxInStack - 1; j >= 0; j--){
                var stackInfo = stackInfoList[j];
                // Has been optimized by inverted indices on `stackedByDimension`.
                if (!isStackedByIndex) stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
                if (stackedDataRawIndex >= 0) {
                    var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex);
                    // Considering positive stack, negative stack and empty data
                    if (stackStrategy === 'all' // single stack group
                     || stackStrategy === 'positive' && val > 0 || stackStrategy === 'negative' && val < 0 || stackStrategy === 'samesign' && sum >= 0 && val > 0 // All positive stack
                     || stackStrategy === 'samesign' && sum <= 0 && val < 0 // All negative stack
                    ) {
                        // The sum has to be very small to be affected by the
                        // floating arithmetic problem. An incorrect result will probably
                        // cause axis min/max to be filtered incorrectly.
                        sum = (0, $104896d282bd296f$export$d3389a301c3a5706)(sum, val);
                        stackedOver = val;
                        break;
                    }
                }
            }
            resultVal[0] = sum;
            resultVal[1] = stackedOver;
            return resultVal;
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



// @inner
var $9cad8a8849680580$var$SourceImpl = /** @class */ function() {
    function SourceImpl(fields) {
        this.data = fields.data || (fields.sourceFormat === (0, $c870d17359cdf008$export$6a32b42c754a3cb8) ? {} : []);
        this.sourceFormat = fields.sourceFormat || (0, $c870d17359cdf008$export$c78f1330778d30d);
        // Visit config
        this.seriesLayoutBy = fields.seriesLayoutBy || (0, $c870d17359cdf008$export$7b3f3c6551b4949b);
        this.startIndex = fields.startIndex || 0;
        this.dimensionsDetectedCount = fields.dimensionsDetectedCount;
        this.metaRawOption = fields.metaRawOption;
        var dimensionsDefine = this.dimensionsDefine = fields.dimensionsDefine;
        if (dimensionsDefine) for(var i = 0; i < dimensionsDefine.length; i++){
            var dim = dimensionsDefine[i];
            if (dim.type == null) {
                if ((0, $0988ea9c84ff78f2$export$c51adf1a2be01b9c)(this, i) === (0, $0988ea9c84ff78f2$export$328749e9c5b40760).Must) dim.type = 'ordinal';
            }
        }
    }
    return SourceImpl;
}();
function $9cad8a8849680580$export$22b808bc02a60488(val) {
    return val instanceof $9cad8a8849680580$var$SourceImpl;
}
function $9cad8a8849680580$export$1921362e86c73c88(sourceData, thisMetaRawOption, // can be null. If not provided, auto detect it from `sourceData`.
sourceFormat) {
    sourceFormat = sourceFormat || $9cad8a8849680580$export$52a469afa4653e57(sourceData);
    var seriesLayoutBy = thisMetaRawOption.seriesLayoutBy;
    var determined = $9cad8a8849680580$var$determineSourceDimensions(sourceData, sourceFormat, seriesLayoutBy, thisMetaRawOption.sourceHeader, thisMetaRawOption.dimensions);
    var source = new $9cad8a8849680580$var$SourceImpl({
        data: sourceData,
        sourceFormat: sourceFormat,
        seriesLayoutBy: seriesLayoutBy,
        dimensionsDefine: determined.dimensionsDefine,
        startIndex: determined.startIndex,
        dimensionsDetectedCount: determined.dimensionsDetectedCount,
        metaRawOption: (0, $f16f2994a32ad273$export$9cd59f9826255e47)(thisMetaRawOption)
    });
    return source;
}
function $9cad8a8849680580$export$75aef3f97c0a5edf(data) {
    return new $9cad8a8849680580$var$SourceImpl({
        data: data,
        sourceFormat: (0, $f16f2994a32ad273$export$b119cc7e1840e59c)(data) ? (0, $c870d17359cdf008$export$a918cb016a382d45) : (0, $c870d17359cdf008$export$2823037fb9d8f0c6)
    });
}
function $9cad8a8849680580$export$e0365e7e3555ddd4(source) {
    return new $9cad8a8849680580$var$SourceImpl({
        data: source.data,
        sourceFormat: source.sourceFormat,
        seriesLayoutBy: source.seriesLayoutBy,
        dimensionsDefine: (0, $f16f2994a32ad273$export$9cd59f9826255e47)(source.dimensionsDefine),
        startIndex: source.startIndex,
        dimensionsDetectedCount: source.dimensionsDetectedCount
    });
}
function $9cad8a8849680580$export$52a469afa4653e57(data) {
    var sourceFormat = (0, $c870d17359cdf008$export$c78f1330778d30d);
    if ((0, $f16f2994a32ad273$export$b119cc7e1840e59c)(data)) sourceFormat = (0, $c870d17359cdf008$export$a918cb016a382d45);
    else if ((0, $f16f2994a32ad273$export$43bee75e5e14138e)(data)) {
        // FIXME Whether tolerate null in top level array?
        if (data.length === 0) sourceFormat = (0, $c870d17359cdf008$export$fcd62ebf51387903);
        for(var i = 0, len = data.length; i < len; i++){
            var item = data[i];
            if (item == null) continue;
            else if ((0, $f16f2994a32ad273$export$43bee75e5e14138e)(item) || (0, $f16f2994a32ad273$export$b119cc7e1840e59c)(item)) {
                sourceFormat = (0, $c870d17359cdf008$export$fcd62ebf51387903);
                break;
            } else if ((0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(item)) {
                sourceFormat = (0, $c870d17359cdf008$export$703ae8a2d83f441);
                break;
            }
        }
    } else if ((0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(data)) {
        for(var key in data)if ((0, $f16f2994a32ad273$export$b5a638e9b3fff9f3)(data, key) && (0, $f16f2994a32ad273$export$1e2f57719e155213)(data[key])) {
            sourceFormat = (0, $c870d17359cdf008$export$6a32b42c754a3cb8);
            break;
        }
    }
    return sourceFormat;
}
/**
 * Determine the source definitions from data standalone dimensions definitions
 * are not specified.
 */ function $9cad8a8849680580$var$determineSourceDimensions(data, sourceFormat, seriesLayoutBy, sourceHeader, // standalone raw dimensions definition, like:
// {
//     dimensions: ['aa', 'bb', { name: 'cc', type: 'time' }]
// }
// in `dataset` or `series`
dimensionsDefine) {
    var dimensionsDetectedCount;
    var startIndex;
    // PENDING: Could data be null/undefined here?
    // currently, if `dataset.source` not specified, error thrown.
    // if `series.data` not specified, nothing rendered without error thrown.
    // Should test these cases.
    if (!data) return {
        dimensionsDefine: $9cad8a8849680580$var$normalizeDimensionsOption(dimensionsDefine),
        startIndex: startIndex,
        dimensionsDetectedCount: dimensionsDetectedCount
    };
    if (sourceFormat === (0, $c870d17359cdf008$export$fcd62ebf51387903)) {
        var dataArrayRows = data;
        // Rule: Most of the first line are string: it is header.
        // Caution: consider a line with 5 string and 1 number,
        // it still can not be sure it is a head, because the
        // 5 string may be 5 values of category columns.
        if (sourceHeader === 'auto' || sourceHeader == null) $9cad8a8849680580$var$arrayRowsTravelFirst(function(val) {
            // '-' is regarded as null/undefined.
            if (val != null && val !== '-') {
                if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(val)) startIndex == null && (startIndex = 1);
                else startIndex = 0;
            }
        // 10 is an experience number, avoid long loop.
        }, seriesLayoutBy, dataArrayRows, 10);
        else startIndex = (0, $f16f2994a32ad273$export$7e4aa119212bc614)(sourceHeader) ? sourceHeader : sourceHeader ? 1 : 0;
        if (!dimensionsDefine && startIndex === 1) {
            dimensionsDefine = [];
            $9cad8a8849680580$var$arrayRowsTravelFirst(function(val, index) {
                dimensionsDefine[index] = val != null ? val + '' : '';
            }, seriesLayoutBy, dataArrayRows, Infinity);
        }
        dimensionsDetectedCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === (0, $c870d17359cdf008$export$d55da1467cdf7804) ? dataArrayRows.length : dataArrayRows[0] ? dataArrayRows[0].length : null;
    } else if (sourceFormat === (0, $c870d17359cdf008$export$703ae8a2d83f441)) {
        if (!dimensionsDefine) dimensionsDefine = $9cad8a8849680580$var$objectRowsCollectDimensions(data);
    } else if (sourceFormat === (0, $c870d17359cdf008$export$6a32b42c754a3cb8)) {
        if (!dimensionsDefine) {
            dimensionsDefine = [];
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)(data, function(colArr, key) {
                dimensionsDefine.push(key);
            });
        }
    } else if (sourceFormat === (0, $c870d17359cdf008$export$2823037fb9d8f0c6)) {
        var value0 = (0, $3fa81475350067fd$export$2c944e12edb48d4b)(data[0]);
        dimensionsDetectedCount = (0, $f16f2994a32ad273$export$43bee75e5e14138e)(value0) && value0.length || 1;
    }
    return {
        startIndex: startIndex,
        dimensionsDefine: $9cad8a8849680580$var$normalizeDimensionsOption(dimensionsDefine),
        dimensionsDetectedCount: dimensionsDetectedCount
    };
}
function $9cad8a8849680580$var$objectRowsCollectDimensions(data) {
    var firstIndex = 0;
    var obj;
    while(firstIndex < data.length && !(obj = data[firstIndex++])); // jshint ignore: line
    if (obj) return (0, $f16f2994a32ad273$export$ed97f33186d4b816)(obj);
}
// Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
// which is reasonable. But dimension name is duplicated.
// Returns undefined or an array contains only object without null/undefined or string.
function $9cad8a8849680580$var$normalizeDimensionsOption(dimensionsDefine) {
    if (!dimensionsDefine) // The meaning of null/undefined is different from empty array.
    return;
    var nameMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
    return (0, $f16f2994a32ad273$export$871de8747c9eaa88)(dimensionsDefine, function(rawItem, index) {
        rawItem = (0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(rawItem) ? rawItem : {
            name: rawItem
        };
        // Other fields will be discarded.
        var item = {
            name: rawItem.name,
            displayName: rawItem.displayName,
            type: rawItem.type
        };
        // User can set null in dimensions.
        // We don't auto specify name, otherwise a given name may
        // cause it to be referred unexpectedly.
        if (item.name == null) return item;
        // Also consider number form like 2012.
        item.name += '';
        // User may also specify displayName.
        // displayName will always exists except user not
        // specified or dim name is not specified or detected.
        // (A auto generated dim name will not be used as
        // displayName).
        if (item.displayName == null) item.displayName = item.name;
        var exist = nameMap.get(item.name);
        if (!exist) nameMap.set(item.name, {
            count: 1
        });
        else item.name += '-' + exist.count++;
        return item;
    });
}
function $9cad8a8849680580$var$arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
    if (seriesLayoutBy === (0, $c870d17359cdf008$export$d55da1467cdf7804)) for(var i = 0; i < data.length && i < maxLoop; i++)cb(data[i] ? data[i][0] : null, i);
    else {
        var value0 = data[0] || [];
        for(var i = 0; i < value0.length && i < maxLoop; i++)cb(value0[i], i);
    }
}
function $9cad8a8849680580$export$8911336b527f8517(source) {
    var sourceFormat = source.sourceFormat;
    return sourceFormat === (0, $c870d17359cdf008$export$703ae8a2d83f441) || sourceFormat === (0, $c870d17359cdf008$export$6a32b42c754a3cb8);
}




var $64e5bb47dc44a160$var$_a, $64e5bb47dc44a160$var$_b, $64e5bb47dc44a160$var$_c, $64e5bb47dc44a160$var$_d;
var $64e5bb47dc44a160$var$providerMethods;
var $64e5bb47dc44a160$var$mountMethods;
/**
 * If normal array used, mutable chunk size is supported.
 * If typed array used, chunk size must be fixed.
 */ var $64e5bb47dc44a160$export$b900d7c4c3952a40 = /** @class */ function() {
    function DefaultDataProvider(sourceParam, dimSize) {
        // let source: Source;
        var source = !(0, $9cad8a8849680580$export$22b808bc02a60488)(sourceParam) ? (0, $9cad8a8849680580$export$75aef3f97c0a5edf)(sourceParam) : sourceParam;
        // declare source is Source;
        this._source = source;
        var data = this._data = source.data;
        var sourceFormat = source.sourceFormat;
        var seriesLayoutBy = source.seriesLayoutBy;
        // Typed array. TODO IE10+?
        if (sourceFormat === (0, $c870d17359cdf008$export$a918cb016a382d45)) {
            this._offset = 0;
            this._dimSize = dimSize;
            this._data = data;
        }
        var validator;
        $64e5bb47dc44a160$var$mountMethods(this, data, source);
    }
    DefaultDataProvider.prototype.getSource = function() {
        return this._source;
    };
    DefaultDataProvider.prototype.count = function() {
        return 0;
    };
    DefaultDataProvider.prototype.getItem = function(idx, out) {
        return;
    };
    DefaultDataProvider.prototype.appendData = function(newData) {};
    DefaultDataProvider.prototype.clean = function() {};
    DefaultDataProvider.protoInitialize = function() {
        // PENDING: To avoid potential incompat (e.g., prototype
        // is visited somewhere), still init them on prototype.
        var proto = DefaultDataProvider.prototype;
        proto.pure = false;
        proto.persistent = true;
    }();
    DefaultDataProvider.internalField = function() {
        var _a;
        $64e5bb47dc44a160$var$mountMethods = function mountMethods(provider, data, source) {
            var sourceFormat = source.sourceFormat;
            var seriesLayoutBy = source.seriesLayoutBy;
            var startIndex = source.startIndex;
            var dimsDef = source.dimensionsDefine;
            var methods = $64e5bb47dc44a160$var$providerMethods[$64e5bb47dc44a160$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
            (0, $f16f2994a32ad273$export$8b58be045bf06082)(provider, methods);
            if (sourceFormat === (0, $c870d17359cdf008$export$a918cb016a382d45)) {
                provider.getItem = getItemForTypedArray;
                provider.count = countForTypedArray;
                provider.fillStorage = fillStorageForTypedArray;
            } else {
                var rawItemGetter = $64e5bb47dc44a160$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy);
                provider.getItem = (0, $f16f2994a32ad273$export$2385a24977818dd0)(rawItemGetter, null, data, startIndex, dimsDef);
                var rawCounter = $64e5bb47dc44a160$export$803742e832f4b52c(sourceFormat, seriesLayoutBy);
                provider.count = (0, $f16f2994a32ad273$export$2385a24977818dd0)(rawCounter, null, data, startIndex, dimsDef);
            }
        };
        var getItemForTypedArray = function getItemForTypedArray(idx, out) {
            idx = idx - this._offset;
            out = out || [];
            var data = this._data;
            var dimSize = this._dimSize;
            var offset = dimSize * idx;
            for(var i = 0; i < dimSize; i++)out[i] = data[offset + i];
            return out;
        };
        var fillStorageForTypedArray = function fillStorageForTypedArray(start, end, storage, extent) {
            var data = this._data;
            var dimSize = this._dimSize;
            for(var dim = 0; dim < dimSize; dim++){
                var dimExtent = extent[dim];
                var min = dimExtent[0] == null ? Infinity : dimExtent[0];
                var max = dimExtent[1] == null ? -Infinity : dimExtent[1];
                var count = end - start;
                var arr = storage[dim];
                for(var i = 0; i < count; i++){
                    // appendData with TypedArray will always do replace in provider.
                    var val = data[i * dimSize + dim];
                    arr[start + i] = val;
                    val < min && (min = val);
                    val > max && (max = val);
                }
                dimExtent[0] = min;
                dimExtent[1] = max;
            }
        };
        var countForTypedArray = function countForTypedArray() {
            return this._data ? this._data.length / this._dimSize : 0;
        };
        $64e5bb47dc44a160$var$providerMethods = (_a = {}, _a[(0, $c870d17359cdf008$export$fcd62ebf51387903) + '_' + (0, $c870d17359cdf008$export$7b3f3c6551b4949b)] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[(0, $c870d17359cdf008$export$fcd62ebf51387903) + '_' + (0, $c870d17359cdf008$export$d55da1467cdf7804)] = {
            pure: true,
            appendData: function appendData() {
                throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
            }
        }, _a[0, $c870d17359cdf008$export$703ae8a2d83f441] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[0, $c870d17359cdf008$export$6a32b42c754a3cb8] = {
            pure: true,
            appendData: function appendData(newData) {
                var data = this._data;
                (0, $f16f2994a32ad273$export$79b2f7037acddd43)(newData, function(newCol, key) {
                    var oldCol = data[key] || (data[key] = []);
                    for(var i = 0; i < (newCol || []).length; i++)oldCol.push(newCol[i]);
                });
            }
        }, _a[0, $c870d17359cdf008$export$2823037fb9d8f0c6] = {
            appendData: appendDataSimply
        }, _a[0, $c870d17359cdf008$export$a918cb016a382d45] = {
            persistent: false,
            pure: true,
            appendData: function appendData(newData) {
                this._data = newData;
            },
            // Clean self if data is already used.
            clean: function clean() {
                // PENDING
                this._offset += this.count();
                this._data = null;
            }
        }, _a);
        function appendDataSimply(newData) {
            for(var i = 0; i < newData.length; i++)this._data.push(newData[i]);
        }
    }();
    return DefaultDataProvider;
}();
var $64e5bb47dc44a160$var$validateSimply = function validateSimply(rawData) {
    if (!(0, $f16f2994a32ad273$export$43bee75e5e14138e)(rawData)) (0, $ec53fe68074e6f74$export$a3bc9b8ed74fc)('series.data or dataset.source must be an array.');
};
/**
 * Only run in dev mode - hint users for debug.
 */ var $64e5bb47dc44a160$var$rawSourceDataValidatorMap = ($64e5bb47dc44a160$var$_a = {}, $64e5bb47dc44a160$var$_a[(0, $c870d17359cdf008$export$fcd62ebf51387903) + '_' + (0, $c870d17359cdf008$export$7b3f3c6551b4949b)] = $64e5bb47dc44a160$var$validateSimply, $64e5bb47dc44a160$var$_a[(0, $c870d17359cdf008$export$fcd62ebf51387903) + '_' + (0, $c870d17359cdf008$export$d55da1467cdf7804)] = $64e5bb47dc44a160$var$validateSimply, $64e5bb47dc44a160$var$_a[0, $c870d17359cdf008$export$703ae8a2d83f441] = $64e5bb47dc44a160$var$validateSimply, $64e5bb47dc44a160$var$_a[0, $c870d17359cdf008$export$6a32b42c754a3cb8] = function rawSourceDataValidatorMap(rawData, dimsDef) {
    for(var i = 0; i < dimsDef.length; i++){
        var dimName = dimsDef[i].name;
        if (dimName == null) (0, $ec53fe68074e6f74$export$a3bc9b8ed74fc)('dimension name must not be null/undefined.');
    }
}, $64e5bb47dc44a160$var$_a[0, $c870d17359cdf008$export$2823037fb9d8f0c6] = $64e5bb47dc44a160$var$validateSimply, $64e5bb47dc44a160$var$_a);
var $64e5bb47dc44a160$var$getItemSimply = function getItemSimply(rawData, startIndex, dimsDef, idx) {
    return rawData[idx];
};
var $64e5bb47dc44a160$var$rawSourceItemGetterMap = ($64e5bb47dc44a160$var$_b = {}, $64e5bb47dc44a160$var$_b[(0, $c870d17359cdf008$export$fcd62ebf51387903) + '_' + (0, $c870d17359cdf008$export$7b3f3c6551b4949b)] = function rawSourceItemGetterMap(rawData, startIndex, dimsDef, idx) {
    return rawData[idx + startIndex];
}, $64e5bb47dc44a160$var$_b[(0, $c870d17359cdf008$export$fcd62ebf51387903) + '_' + (0, $c870d17359cdf008$export$d55da1467cdf7804)] = function(rawData, startIndex, dimsDef, idx, out) {
    idx += startIndex;
    var item = out || [];
    var data = rawData;
    for(var i = 0; i < data.length; i++){
        var row = data[i];
        item[i] = row ? row[idx] : null;
    }
    return item;
}, $64e5bb47dc44a160$var$_b[0, $c870d17359cdf008$export$703ae8a2d83f441] = $64e5bb47dc44a160$var$getItemSimply, $64e5bb47dc44a160$var$_b[0, $c870d17359cdf008$export$6a32b42c754a3cb8] = function(rawData, startIndex, dimsDef, idx, out) {
    var item = out || [];
    for(var i = 0; i < dimsDef.length; i++){
        var dimName = dimsDef[i].name;
        var col = dimName != null ? rawData[dimName] : null;
        item[i] = col ? col[idx] : null;
    }
    return item;
}, $64e5bb47dc44a160$var$_b[0, $c870d17359cdf008$export$2823037fb9d8f0c6] = $64e5bb47dc44a160$var$getItemSimply, $64e5bb47dc44a160$var$_b);
function $64e5bb47dc44a160$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy) {
    var method = $64e5bb47dc44a160$var$rawSourceItemGetterMap[$64e5bb47dc44a160$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $64e5bb47dc44a160$var$countSimply = function countSimply(rawData, startIndex, dimsDef) {
    return rawData.length;
};
var $64e5bb47dc44a160$var$rawSourceDataCounterMap = ($64e5bb47dc44a160$var$_c = {}, $64e5bb47dc44a160$var$_c[(0, $c870d17359cdf008$export$fcd62ebf51387903) + '_' + (0, $c870d17359cdf008$export$7b3f3c6551b4949b)] = function rawSourceDataCounterMap(rawData, startIndex, dimsDef) {
    return Math.max(0, rawData.length - startIndex);
}, $64e5bb47dc44a160$var$_c[(0, $c870d17359cdf008$export$fcd62ebf51387903) + '_' + (0, $c870d17359cdf008$export$d55da1467cdf7804)] = function(rawData, startIndex, dimsDef) {
    var row = rawData[0];
    return row ? Math.max(0, row.length - startIndex) : 0;
}, $64e5bb47dc44a160$var$_c[0, $c870d17359cdf008$export$703ae8a2d83f441] = $64e5bb47dc44a160$var$countSimply, $64e5bb47dc44a160$var$_c[0, $c870d17359cdf008$export$6a32b42c754a3cb8] = function(rawData, startIndex, dimsDef) {
    var dimName = dimsDef[0].name;
    var col = dimName != null ? rawData[dimName] : null;
    return col ? col.length : 0;
}, $64e5bb47dc44a160$var$_c[0, $c870d17359cdf008$export$2823037fb9d8f0c6] = $64e5bb47dc44a160$var$countSimply, $64e5bb47dc44a160$var$_c);
function $64e5bb47dc44a160$export$803742e832f4b52c(sourceFormat, seriesLayoutBy) {
    var method = $64e5bb47dc44a160$var$rawSourceDataCounterMap[$64e5bb47dc44a160$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $64e5bb47dc44a160$var$getRawValueSimply = function getRawValueSimply(dataItem, dimIndex, property) {
    return dataItem[dimIndex];
};
var $64e5bb47dc44a160$var$rawSourceValueGetterMap = ($64e5bb47dc44a160$var$_d = {}, $64e5bb47dc44a160$var$_d[0, $c870d17359cdf008$export$fcd62ebf51387903] = $64e5bb47dc44a160$var$getRawValueSimply, $64e5bb47dc44a160$var$_d[0, $c870d17359cdf008$export$703ae8a2d83f441] = function rawSourceValueGetterMap(dataItem, dimIndex, property) {
    return dataItem[property];
}, $64e5bb47dc44a160$var$_d[0, $c870d17359cdf008$export$6a32b42c754a3cb8] = $64e5bb47dc44a160$var$getRawValueSimply, $64e5bb47dc44a160$var$_d[0, $c870d17359cdf008$export$2823037fb9d8f0c6] = function(dataItem, dimIndex, property) {
    // FIXME: In some case (markpoint in geo (geo-map.html)),
    // dataItem is {coord: [...]}
    var value = (0, $3fa81475350067fd$export$2c944e12edb48d4b)(dataItem);
    return !(value instanceof Array) ? value : value[dimIndex];
}, $64e5bb47dc44a160$var$_d[0, $c870d17359cdf008$export$a918cb016a382d45] = $64e5bb47dc44a160$var$getRawValueSimply, $64e5bb47dc44a160$var$_d);
function $64e5bb47dc44a160$export$1752de8084789a14(sourceFormat) {
    var method = $64e5bb47dc44a160$var$rawSourceValueGetterMap[sourceFormat];
    return method;
}
function $64e5bb47dc44a160$var$getMethodMapKey(sourceFormat, seriesLayoutBy) {
    return sourceFormat === (0, $c870d17359cdf008$export$fcd62ebf51387903) ? sourceFormat + '_' + seriesLayoutBy : sourceFormat;
}
function $64e5bb47dc44a160$export$cde9373da9aad801(data, dataIndex, // If dimIndex is null/undefined, return OptionDataItem.
// Otherwise, return OptionDataValue.
dim) {
    if (!data) return;
    // Consider data may be not persistent.
    var dataItem = data.getRawDataItem(dataIndex);
    if (dataItem == null) return;
    var store = data.getStore();
    var sourceFormat = store.getSource().sourceFormat;
    if (dim != null) {
        var dimIndex = data.getDimensionIndex(dim);
        var property = store.getDimensionProperty(dimIndex);
        return $64e5bb47dc44a160$export$1752de8084789a14(sourceFormat)(dataItem, dimIndex, property);
    } else {
        var result = dataItem;
        if (sourceFormat === (0, $c870d17359cdf008$export$2823037fb9d8f0c6)) result = (0, $3fa81475350067fd$export$2c944e12edb48d4b)(dataItem);
        return result;
    }
}
function $64e5bb47dc44a160$export$c8ae9e77e0ddc42a(data, dataIndex, attr) {
    if (!data) return;
    var sourceFormat = data.getStore().getSource().sourceFormat;
    if (sourceFormat !== (0, $c870d17359cdf008$export$2823037fb9d8f0c6) && sourceFormat !== (0, $c870d17359cdf008$export$703ae8a2d83f441)) return;
    var dataItem = data.getRawDataItem(dataIndex);
    if (sourceFormat === (0, $c870d17359cdf008$export$2823037fb9d8f0c6) && !(0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(dataItem)) dataItem = null;
    if (dataItem) return dataItem[attr];
}




var $dae8b98b5424425d$var$DIMENSION_LABEL_REG = /\{@(.+?)\}/g;
var $dae8b98b5424425d$export$f23396ae04ea95a7 = /** @class */ function() {
    function DataFormatMixin() {}
    /**
   * Get params for formatter
   */ DataFormatMixin.prototype.getDataParams = function(dataIndex, dataType) {
        var data = this.getData(dataType);
        var rawValue = this.getRawValue(dataIndex, dataType);
        var rawDataIndex = data.getRawIndex(dataIndex);
        var name = data.getName(dataIndex);
        var itemOpt = data.getRawDataItem(dataIndex);
        var style = data.getItemVisual(dataIndex, 'style');
        var color = style && style[data.getItemVisual(dataIndex, 'drawType') || 'fill'];
        var borderColor = style && style.stroke;
        var mainType = this.mainType;
        var isSeries = mainType === 'series';
        var userOutput = data.userOutput && data.userOutput.get();
        return {
            componentType: mainType,
            componentSubType: this.subType,
            componentIndex: this.componentIndex,
            seriesType: isSeries ? this.subType : null,
            seriesIndex: this.seriesIndex,
            seriesId: isSeries ? this.id : null,
            seriesName: isSeries ? this.name : null,
            name: name,
            dataIndex: rawDataIndex,
            data: itemOpt,
            dataType: dataType,
            value: rawValue,
            color: color,
            borderColor: borderColor,
            dimensionNames: userOutput ? userOutput.fullDimensions : null,
            encode: userOutput ? userOutput.encode : null,
            // Param name list for mapping `a`, `b`, `c`, `d`, `e`
            $vars: [
                'seriesName',
                'name',
                'value'
            ]
        };
    };
    /**
   * Format label
   * @param dataIndex
   * @param status 'normal' by default
   * @param dataType
   * @param labelDimIndex Only used in some chart that
   *        use formatter in different dimensions, like radar.
   * @param formatter Formatter given outside.
   * @return return null/undefined if no formatter
   */ DataFormatMixin.prototype.getFormattedLabel = function(dataIndex, status, dataType, labelDimIndex, formatter, extendParams) {
        status = status || 'normal';
        var data = this.getData(dataType);
        var params = this.getDataParams(dataIndex, dataType);
        if (extendParams) params.value = extendParams.interpolatedValue;
        if (labelDimIndex != null && $f16f2994a32ad273$export$43bee75e5e14138e(params.value)) params.value = params.value[labelDimIndex];
        if (!formatter) {
            var itemModel = data.getItemModel(dataIndex);
            // @ts-ignore
            formatter = itemModel.get(status === 'normal' ? [
                'label',
                'formatter'
            ] : [
                status,
                'label',
                'formatter'
            ]);
        }
        if ($f16f2994a32ad273$export$f6e2535fb5126e54(formatter)) {
            params.status = status;
            params.dimensionIndex = labelDimIndex;
            return formatter(params);
        } else if ($f16f2994a32ad273$export$844ec244b1367d54(formatter)) {
            var str = (0, $04bb9ff155ec4ccd$export$2028496a35766e41)(formatter, params);
            // Support 'aaa{@[3]}bbb{@product}ccc'.
            // Do not support '}' in dim name util have to.
            return str.replace($dae8b98b5424425d$var$DIMENSION_LABEL_REG, function(origin, dimStr) {
                var len = dimStr.length;
                var dimLoose = dimStr;
                if (dimLoose.charAt(0) === '[' && dimLoose.charAt(len - 1) === ']') dimLoose = +dimLoose.slice(1, len - 1); // Also support: '[]' => 0
                var val = (0, $64e5bb47dc44a160$export$cde9373da9aad801)(data, dataIndex, dimLoose);
                if (extendParams && $f16f2994a32ad273$export$43bee75e5e14138e(extendParams.interpolatedValue)) {
                    var dimIndex = data.getDimensionIndex(dimLoose);
                    if (dimIndex >= 0) val = extendParams.interpolatedValue[dimIndex];
                }
                return val != null ? val + '' : '';
            });
        }
    };
    /**
   * Get raw value in option
   */ DataFormatMixin.prototype.getRawValue = function(idx, dataType) {
        return (0, $64e5bb47dc44a160$export$cde9373da9aad801)(this.getData(dataType), idx);
    };
    /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {string} [dataType]
   */ DataFormatMixin.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        // Empty function
        return;
    };
    return DataFormatMixin;
}();
function $dae8b98b5424425d$export$2d16fa82a50c4741(result) {
    var markupText;
    // let markers: Dictionary<ColorString>;
    var markupFragment;
    if ($f16f2994a32ad273$export$a6cdc56e425d0d0a(result)) {
        if (result.type) markupFragment = result;
    } else markupText = result;
    return {
        text: markupText,
        // markers: markers || markersExisting,
        frag: markupFragment
    };
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $4dfdfd6db5b461c6$export$f7292ab7796be73c(define) {
    return new $4dfdfd6db5b461c6$export$2dea7024bcdd7731(define);
}
var $4dfdfd6db5b461c6$export$2dea7024bcdd7731 = /** @class */ function() {
    function Task(define) {
        define = define || {};
        this._reset = define.reset;
        this._plan = define.plan;
        this._count = define.count;
        this._onDirty = define.onDirty;
        this._dirty = true;
    }
    /**
   * @param step Specified step.
   * @param skip Skip customer perform call.
   * @param modBy Sampling window size.
   * @param modDataCount Sampling count.
   * @return whether unfinished.
   */ Task.prototype.perform = function(performArgs) {
        var upTask = this._upstream;
        var skip = performArgs && performArgs.skip;
        // TODO some refactor.
        // Pull data. Must pull data each time, because context.data
        // may be updated by Series.setData.
        if (this._dirty && upTask) {
            var context = this.context;
            context.data = context.outputData = upTask.context.outputData;
        }
        if (this.__pipeline) this.__pipeline.currentTask = this;
        var planResult;
        if (this._plan && !skip) planResult = this._plan(this.context);
        // Support sharding by mod, which changes the render sequence and makes the rendered graphic
        // elements uniformed distributed when progress, especially when moving or zooming.
        var lastModBy = normalizeModBy(this._modBy);
        var lastModDataCount = this._modDataCount || 0;
        var modBy = normalizeModBy(performArgs && performArgs.modBy);
        var modDataCount = performArgs && performArgs.modDataCount || 0;
        if (lastModBy !== modBy || lastModDataCount !== modDataCount) planResult = 'reset';
        function normalizeModBy(val) {
            !(val >= 1) && (val = 1); // jshint ignore:line
            return val;
        }
        var forceFirstProgress;
        if (this._dirty || planResult === 'reset') {
            this._dirty = false;
            forceFirstProgress = this._doReset(skip);
        }
        this._modBy = modBy;
        this._modDataCount = modDataCount;
        var step = performArgs && performArgs.step;
        if (upTask) this._dueEnd = upTask._outputDueEnd;
        else this._dueEnd = this._count ? this._count(this.context) : Infinity;
        // Note: Stubs, that its host overall task let it has progress, has progress.
        // If no progress, pass index from upstream to downstream each time plan called.
        if (this._progress) {
            var start = this._dueIndex;
            var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
            if (!skip && (forceFirstProgress || start < end)) {
                var progress = this._progress;
                if ((0, $f16f2994a32ad273$export$43bee75e5e14138e)(progress)) for(var i = 0; i < progress.length; i++)this._doProgress(progress[i], start, end, modBy, modDataCount);
                else this._doProgress(progress, start, end, modBy, modDataCount);
            }
            this._dueIndex = end;
            // If no `outputDueEnd`, assume that output data and
            // input data is the same, so use `dueIndex` as `outputDueEnd`.
            var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
            this._outputDueEnd = outputDueEnd;
        } else // (1) Some overall task has no progress.
        // (2) Stubs, that its host overall task do not let it has progress, has no progress.
        // This should always be performed so it can be passed to downstream.
        this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
        return this.unfinished();
    };
    /**
   * @tutorial [EC_TASK_DIRTY]
   *  Task `dirty()` calls typically originate from a trigger of EC_FULL_UPDATE_CYCLE and
   *  EC_PARTIAL_UPDATE_CYCLE) (See comments in EC_CYCLE. Generally, task dirty propagates
   *  to downstream tasks.
   *  Task dirty leads to the `StageHandler['reset']` or `StageHandler['overallReset']` call,
   *  which discards the previous result and starts over the processing.
   */ Task.prototype.dirty = function() {
        this._dirty = true;
        this._onDirty && this._onDirty(this.context);
    };
    Task.prototype._doProgress = function(progress, start, end, modBy, modDataCount) {
        $4dfdfd6db5b461c6$var$iterator.reset(start, end, modBy, modDataCount);
        this._callingProgress = progress;
        this._callingProgress({
            start: start,
            end: end,
            count: end - start,
            next: $4dfdfd6db5b461c6$var$iterator.next
        }, this.context);
    };
    Task.prototype._doReset = function(skip) {
        this._dueIndex = this._outputDueEnd = this._dueEnd = 0;
        this._settedOutputEnd = null;
        var progress;
        var forceFirstProgress;
        if (!skip && this._reset) {
            progress = this._reset(this.context);
            if (progress && progress.progress) {
                forceFirstProgress = progress.forceFirstProgress;
                progress = progress.progress;
            }
            // To simplify no progress checking, array must has item.
            if ((0, $f16f2994a32ad273$export$43bee75e5e14138e)(progress) && !progress.length) progress = null;
        }
        this._progress = progress;
        this._modBy = this._modDataCount = null;
        var downstream = this._downstream;
        downstream && downstream.dirty();
        return forceFirstProgress;
    };
    Task.prototype.unfinished = function() {
        return this._progress && this._dueIndex < this._dueEnd;
    };
    /**
   * @param downTask The downstream task.
   * @return The downstream task.
   */ Task.prototype.pipe = function(downTask) {
        // If already downstream, do not dirty downTask.
        if (this._downstream !== downTask || this._dirty) {
            this._downstream = downTask;
            downTask._upstream = this;
            downTask.dirty();
        }
    };
    Task.prototype.dispose = function() {
        if (this._disposed) return;
        this._upstream && (this._upstream._downstream = null);
        this._downstream && (this._downstream._upstream = null);
        this._dirty = false;
        this._disposed = true;
    };
    Task.prototype.getUpstream = function() {
        return this._upstream;
    };
    Task.prototype.getDownstream = function() {
        return this._downstream;
    };
    Task.prototype.setOutputEnd = function(end) {
        // This only happens in dataTask, dataZoom, map, currently.
        // where dataZoom do not set end each time, but only set
        // when reset. So we should record the set end, in case
        // that the stub of dataZoom perform again and earse the
        // set end by upstream.
        this._outputDueEnd = this._settedOutputEnd = end;
    };
    return Task;
}();
var $4dfdfd6db5b461c6$var$iterator = function() {
    var end;
    var current;
    var modBy;
    var modDataCount;
    var winCount;
    var it = {
        reset: function reset(s, e, sStep, sCount) {
            current = s;
            end = e;
            modBy = sStep;
            modDataCount = sCount;
            winCount = Math.ceil(modDataCount / modBy);
            it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
        }
    };
    return it;
    function sequentialNext() {
        return current < end ? current++ : null;
    }
    function modNext() {
        var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
        var result = current >= end ? null : dataIndex < modDataCount ? dataIndex : current;
        current++;
        return result;
    }
}(); // -----------------------------------------------------------------------------
 // For stream debug (Should be commented out after used!)
 // @usage: printTask(this, 'begin');
 // @usage: printTask(this, null, {someExtraProp});
 // @usage: Use `__idxInPipeline` as conditional breakpiont.
 //
 // window.printTask = function (task: any, prefix: string, extra: { [key: string]: unknown }): void {
 //     window.ecTaskUID == null && (window.ecTaskUID = 0);
 //     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
 //     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
 //     let props = [];
 //     if (task.__pipeline) {
 //         let val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
 //         props.push({text: '__idxInPipeline/total', value: val});
 //     } else {
 //         let stubCount = 0;
 //         task.agentStubMap.each(() => stubCount++);
 //         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
 //     }
 //     props.push({text: 'uid', value: task.uidDebug});
 //     if (task.__pipeline) {
 //         props.push({text: 'pipelineId', value: task.__pipeline.id});
 //         task.agent && props.push(
 //             {text: 'stubFor', value: task.agent.uidDebug}
 //         );
 //     }
 //     props.push(
 //         {text: 'dirty', value: task._dirty},
 //         {text: 'dueIndex', value: task._dueIndex},
 //         {text: 'dueEnd', value: task._dueEnd},
 //         {text: 'outputDueEnd', value: task._outputDueEnd}
 //     );
 //     if (extra) {
 //         Object.keys(extra).forEach(key => {
 //             props.push({text: key, value: extra[key]});
 //         });
 //     }
 //     let args = ['color: blue'];
 //     let msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
 //         args.push('color: green', 'color: red'),
 //         `${item.text}: %c${item.value}`
 //     )).join('%c, ');
 //     console.log.apply(console, [msg].concat(args));
 //     // console.log(this);
 // };
 // window.printPipeline = function (task: any, prefix: string) {
 //     const pipeline = task.__pipeline;
 //     let currTask = pipeline.head;
 //     while (currTask) {
 //         window.printTask(currTask, prefix);
 //         currTask = currTask._downstream;
 //     }
 // };
 // window.showChain = function (chainHeadTask) {
 //     var chain = [];
 //     var task = chainHeadTask;
 //     while (task) {
 //         chain.push({
 //             task: task,
 //             up: task._upstream,
 //             down: task._downstream,
 //             idxInPipeline: task.__idxInPipeline
 //         });
 //         task = task._downstream;
 //     }
 //     return chain;
 // };
 // window.findTaskInChain = function (task, chainHeadTask) {
 //     let chain = window.showChain(chainHeadTask);
 //     let result = [];
 //     for (let i = 0; i < chain.length; i++) {
 //         let chainItem = chain[i];
 //         if (chainItem.task === task) {
 //             result.push(i);
 //         }
 //     }
 //     return result;
 // };
 // window.printChainAEachInChainB = function (chainHeadTaskA, chainHeadTaskB) {
 //     let chainA = window.showChain(chainHeadTaskA);
 //     for (let i = 0; i < chainA.length; i++) {
 //         console.log('chainAIdx:', i, 'inChainB:', window.findTaskInChain(chainA[i].task, chainHeadTaskB));
 //     }
 // };



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $7E0eS = parcelRequire("7E0eS");



function $722bed231f2dca45$export$cc7175145baad076(value, // For high performance, do not omit the second param.
opt) {
    // Performance sensitive.
    var dimType = opt && opt.type;
    if (dimType === 'ordinal') // If given value is a category string
    return value;
    if (dimType === 'time' && !(0, $f16f2994a32ad273$export$7e4aa119212bc614)(value) && value != null && value !== '-') value = +(0, $104896d282bd296f$export$6b862160d295c8e)(value);
    // dimType defaults 'number'.
    // If dimType is not ordinal and value is null or undefined or NaN or '-',
    // parse to NaN.
    // number-like string (like ' 123 ') can be converted to a number.
    // where null/undefined or other string will be converted to NaN.
    return value == null || value === '' ? NaN : Number(value);
}
var $722bed231f2dca45$var$valueParserMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)({
    'number': function(val) {
        // Do not use `numericToNumber` here. We have `numericToNumber` by default.
        // Here the number parser can have loose rule:
        // enable to cut suffix: "120px" => 120, "14%" => 14.
        return parseFloat(val);
    },
    'time': function(val) {
        // return timestamp.
        return +(0, $104896d282bd296f$export$6b862160d295c8e)(val);
    },
    'trim': function(val) {
        return (0, $f16f2994a32ad273$export$844ec244b1367d54)(val) ? (0, $f16f2994a32ad273$export$87c2784dc9fc4ab)(val) : val;
    }
});
function $722bed231f2dca45$export$c88237b7c265b36b(type) {
    return $722bed231f2dca45$var$valueParserMap.get(type);
}
var $722bed231f2dca45$var$ORDER_COMPARISON_OP_MAP = {
    lt: function lt(lval, rval) {
        return lval < rval;
    },
    lte: function lte(lval, rval) {
        return lval <= rval;
    },
    gt: function gt(lval, rval) {
        return lval > rval;
    },
    gte: function gte(lval, rval) {
        return lval >= rval;
    }
};
var $722bed231f2dca45$var$FilterOrderComparator = /** @class */ function() {
    function FilterOrderComparator(op, rval) {
        if (!(0, $f16f2994a32ad273$export$7e4aa119212bc614)(rval)) {
            var errMsg = '';
            (0, $ec53fe68074e6f74$export$8bf7aba4a9e09055)(errMsg);
        }
        this._opFn = $722bed231f2dca45$var$ORDER_COMPARISON_OP_MAP[op];
        this._rvalFloat = (0, $104896d282bd296f$export$8b4007b942b45a96)(rval);
    }
    // Performance sensitive.
    FilterOrderComparator.prototype.evaluate = function(lval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        return (0, $f16f2994a32ad273$export$7e4aa119212bc614)(lval) ? this._opFn(lval, this._rvalFloat) : this._opFn((0, $104896d282bd296f$export$8b4007b942b45a96)(lval), this._rvalFloat);
    };
    return FilterOrderComparator;
}();
var $722bed231f2dca45$export$ed75a5d7b0144167 = /** @class */ function() {
    /**
   * @param order by default: 'asc'
   * @param incomparable by default: Always on the tail.
   *        That is, if 'asc' => 'max', if 'desc' => 'min'
   *        See the definition of "incomparable" in [SORT_COMPARISON_RULE].
   */ function SortOrderComparator(order, incomparable) {
        var isDesc = order === 'desc';
        this._resultLT = isDesc ? 1 : -1;
        if (incomparable == null) incomparable = isDesc ? 'min' : 'max';
        this._incomparable = incomparable === 'min' ? -Infinity : Infinity;
    }
    // See [SORT_COMPARISON_RULE].
    // Performance sensitive.
    SortOrderComparator.prototype.evaluate = function(lval, rval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        var lvalFloat = (0, $f16f2994a32ad273$export$7e4aa119212bc614)(lval) ? lval : (0, $104896d282bd296f$export$8b4007b942b45a96)(lval);
        var rvalFloat = (0, $f16f2994a32ad273$export$7e4aa119212bc614)(rval) ? rval : (0, $104896d282bd296f$export$8b4007b942b45a96)(rval);
        var lvalNotNumeric = isNaN(lvalFloat);
        var rvalNotNumeric = isNaN(rvalFloat);
        if (lvalNotNumeric) lvalFloat = this._incomparable;
        if (rvalNotNumeric) rvalFloat = this._incomparable;
        if (lvalNotNumeric && rvalNotNumeric) {
            var lvalIsStr = (0, $f16f2994a32ad273$export$844ec244b1367d54)(lval);
            var rvalIsStr = (0, $f16f2994a32ad273$export$844ec244b1367d54)(rval);
            if (lvalIsStr) lvalFloat = rvalIsStr ? lval : 0;
            if (rvalIsStr) rvalFloat = lvalIsStr ? rval : 0;
        }
        return lvalFloat < rvalFloat ? this._resultLT : lvalFloat > rvalFloat ? -this._resultLT : 0;
    };
    return SortOrderComparator;
}();
var $722bed231f2dca45$var$FilterEqualityComparator = /** @class */ function() {
    function FilterEqualityComparator(isEq, rval) {
        this._rval = rval;
        this._isEQ = isEq;
        this._rvalTypeof = typeof rval === "undefined" ? "undefined" : (0, $7E0eS._)(rval);
        this._rvalFloat = (0, $104896d282bd296f$export$8b4007b942b45a96)(rval);
    }
    // Performance sensitive.
    FilterEqualityComparator.prototype.evaluate = function(lval) {
        var eqResult = lval === this._rval;
        if (!eqResult) {
            var lvalTypeof = typeof lval === "undefined" ? "undefined" : (0, $7E0eS._)(lval);
            if (lvalTypeof !== this._rvalTypeof && (lvalTypeof === 'number' || this._rvalTypeof === 'number')) eqResult = (0, $104896d282bd296f$export$8b4007b942b45a96)(lval) === this._rvalFloat;
        }
        return this._isEQ ? eqResult : !eqResult;
    };
    return FilterEqualityComparator;
}();
function $722bed231f2dca45$export$f2644c3485f94c4e(op, rval) {
    return op === 'eq' || op === 'ne' ? new $722bed231f2dca45$var$FilterEqualityComparator(op === 'eq', rval) : (0, $f16f2994a32ad273$export$b5a638e9b3fff9f3)($722bed231f2dca45$var$ORDER_COMPARISON_OP_MAP, op) ? new $722bed231f2dca45$var$FilterOrderComparator(op, rval) : null;
}
function $722bed231f2dca45$export$1b2aa782dfdf5700(filter) {
    var filterKey = '';
    var filterG = -Infinity;
    var filterGE = -Infinity;
    var filterL = Infinity;
    var filterLE = Infinity;
    if (filter) {
        if (filter.g != null) {
            filterKey += 'G' + filter.g;
            filterG = filter.g;
        }
        if (filter.ge != null) {
            filterKey += 'GE' + filter.ge;
            filterGE = filter.ge;
        }
        if (filter.l != null) {
            filterKey += 'L' + filter.l;
            filterL = filter.l;
        }
        if (filter.le != null) {
            filterKey += 'LE' + filter.le;
            filterLE = filter.le;
        }
    }
    return {
        key: filterKey,
        g: filterG,
        ge: filterGE,
        l: filterL,
        le: filterLE
    };
}
function $722bed231f2dca45$export$49bf74cb3f1b6c80(filterParsed, value) {
    return value > filterParsed.g && value >= filterParsed.ge && value < filterParsed.l && value <= filterParsed.le;
} // --------- END: Data store sanitization filters ---------




/**
 * TODO: disable writable.
 * This structure will be exposed to users.
 */ var $6b1c7afb889b71f1$export$ffc19e40a21f08eb = /** @class */ function() {
    function ExternalSource() {}
    ExternalSource.prototype.getRawData = function() {
        // Only built-in transform available.
        throw new Error('not supported');
    };
    ExternalSource.prototype.getRawDataItem = function(dataIndex) {
        // Only built-in transform available.
        throw new Error('not supported');
    };
    ExternalSource.prototype.cloneRawData = function() {
        return;
    };
    /**
   * @return If dimension not found, return null/undefined.
   */ ExternalSource.prototype.getDimensionInfo = function(dim) {
        return;
    };
    /**
   * dimensions defined if and only if either:
   * (a) dataset.dimensions are declared.
   * (b) dataset data include dimensions definitions in data (detected or via specified `sourceHeader`).
   * If dimensions are defined, `dimensionInfoAll` is corresponding to
   * the defined dimensions.
   * Otherwise, `dimensionInfoAll` is determined by data columns.
   * @return Always return an array (even empty array).
   */ ExternalSource.prototype.cloneAllDimensionInfo = function() {
        return;
    };
    ExternalSource.prototype.count = function() {
        return;
    };
    /**
   * Only support by dimension index.
   * No need to support by dimension name in transform function,
   * because transform function is not case-specific, no need to use name literally.
   */ ExternalSource.prototype.retrieveValue = function(dataIndex, dimIndex) {
        return;
    };
    ExternalSource.prototype.retrieveValueFromItem = function(dataItem, dimIndex) {
        return;
    };
    ExternalSource.prototype.convertValue = function(rawVal, dimInfo) {
        return (0, $722bed231f2dca45$export$cc7175145baad076)(rawVal, dimInfo);
    };
    return ExternalSource;
}();
function $6b1c7afb889b71f1$var$createExternalSource(internalSource, externalTransform) {
    var extSource = new $6b1c7afb889b71f1$export$ffc19e40a21f08eb();
    var data = internalSource.data;
    var sourceFormat = extSource.sourceFormat = internalSource.sourceFormat;
    var sourceHeaderCount = internalSource.startIndex;
    var errMsg = '';
    if (internalSource.seriesLayoutBy !== (0, $c870d17359cdf008$export$7b3f3c6551b4949b)) (0, $ec53fe68074e6f74$export$8bf7aba4a9e09055)(errMsg);
    // [MEMO]
    // Create a new dimensions structure for exposing.
    // Do not expose all dimension info to users directly.
    // Because the dimension is probably auto detected from data and not might reliable.
    // Should not lead the transformers to think that is reliable and return it.
    // See [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
    var dimensions = [];
    var dimsByName = {};
    var dimsDef = internalSource.dimensionsDefine;
    if (dimsDef) (0, $f16f2994a32ad273$export$79b2f7037acddd43)(dimsDef, function(dimDef, idx) {
        var name = dimDef.name;
        var dimDefExt = {
            index: idx,
            name: name,
            displayName: dimDef.displayName
        };
        dimensions.push(dimDefExt);
        // Users probably do not specify dimension name. For simplicity, data transform
        // does not generate dimension name.
        if (name != null) {
            // Dimension name should not be duplicated.
            // For simplicity, data transform forbids name duplication, do not generate
            // new name like module `completeDimensions.ts` did, but just tell users.
            var errMsg_1 = '';
            if ((0, $f16f2994a32ad273$export$b5a638e9b3fff9f3)(dimsByName, name)) (0, $ec53fe68074e6f74$export$8bf7aba4a9e09055)(errMsg_1);
            dimsByName[name] = dimDefExt;
        }
    });
    else for(var i = 0; i < internalSource.dimensionsDetectedCount || 0; i++)// Do not generete name or anything others. The consequence process in
    // `transform` or `series` probably have there own name generation strategry.
    dimensions.push({
        index: i
    });
    // Implement public methods:
    var rawItemGetter = (0, $64e5bb47dc44a160$export$92c8ea8642b3957d)(sourceFormat, (0, $c870d17359cdf008$export$7b3f3c6551b4949b));
    if (externalTransform.__isBuiltIn) {
        extSource.getRawDataItem = function(dataIndex) {
            return rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        };
        extSource.getRawData = (0, $f16f2994a32ad273$export$2385a24977818dd0)($6b1c7afb889b71f1$var$getRawData, null, internalSource);
    }
    extSource.cloneRawData = (0, $f16f2994a32ad273$export$2385a24977818dd0)($6b1c7afb889b71f1$var$cloneRawData, null, internalSource);
    var rawCounter = (0, $64e5bb47dc44a160$export$803742e832f4b52c)(sourceFormat, (0, $c870d17359cdf008$export$7b3f3c6551b4949b));
    extSource.count = (0, $f16f2994a32ad273$export$2385a24977818dd0)(rawCounter, null, data, sourceHeaderCount, dimensions);
    var rawValueGetter = (0, $64e5bb47dc44a160$export$1752de8084789a14)(sourceFormat);
    extSource.retrieveValue = function(dataIndex, dimIndex) {
        var rawItem = rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        return retrieveValueFromItem(rawItem, dimIndex);
    };
    var retrieveValueFromItem = extSource.retrieveValueFromItem = function retrieveValueFromItem(dataItem, dimIndex) {
        if (dataItem == null) return;
        var dimDef = dimensions[dimIndex];
        // When `dimIndex` is `null`, `rawValueGetter` return the whole item.
        if (dimDef) return rawValueGetter(dataItem, dimIndex, dimDef.name);
    };
    extSource.getDimensionInfo = (0, $f16f2994a32ad273$export$2385a24977818dd0)($6b1c7afb889b71f1$var$getDimensionInfo, null, dimensions, dimsByName);
    extSource.cloneAllDimensionInfo = (0, $f16f2994a32ad273$export$2385a24977818dd0)($6b1c7afb889b71f1$var$cloneAllDimensionInfo, null, dimensions);
    return extSource;
}
function $6b1c7afb889b71f1$var$getRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    if (!$6b1c7afb889b71f1$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = '';
        (0, $ec53fe68074e6f74$export$8bf7aba4a9e09055)(errMsg);
    }
    return upstream.data;
}
function $6b1c7afb889b71f1$var$cloneRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    var data = upstream.data;
    if (!$6b1c7afb889b71f1$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = '';
        (0, $ec53fe68074e6f74$export$8bf7aba4a9e09055)(errMsg);
    }
    if (sourceFormat === (0, $c870d17359cdf008$export$fcd62ebf51387903)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push(data[i].slice());
        return result;
    } else if (sourceFormat === (0, $c870d17359cdf008$export$703ae8a2d83f441)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push((0, $f16f2994a32ad273$export$8b58be045bf06082)({}, data[i]));
        return result;
    }
}
function $6b1c7afb889b71f1$var$getDimensionInfo(dimensions, dimsByName, dim) {
    if (dim == null) return;
    // Keep the same logic as `List::getDimension` did.
    if ((0, $f16f2994a32ad273$export$7e4aa119212bc614)(dim) || !isNaN(dim) && !(0, $f16f2994a32ad273$export$b5a638e9b3fff9f3)(dimsByName, dim)) return dimensions[dim];
    else if ((0, $f16f2994a32ad273$export$b5a638e9b3fff9f3)(dimsByName, dim)) return dimsByName[dim];
}
function $6b1c7afb889b71f1$var$cloneAllDimensionInfo(dimensions) {
    return (0, $f16f2994a32ad273$export$9cd59f9826255e47)(dimensions);
}
var $6b1c7afb889b71f1$var$externalTransformMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
function $6b1c7afb889b71f1$export$92c96c6d8b255b7d(externalTransform) {
    externalTransform = (0, $f16f2994a32ad273$export$9cd59f9826255e47)(externalTransform);
    var type = externalTransform.type;
    var errMsg = '';
    if (!type) (0, $ec53fe68074e6f74$export$8bf7aba4a9e09055)(errMsg);
    var typeParsed = type.split(':');
    if (typeParsed.length !== 2) (0, $ec53fe68074e6f74$export$8bf7aba4a9e09055)(errMsg);
    // Namespace 'echarts:xxx' is official namespace, where the transforms should
    // be called directly via 'xxx' rather than 'echarts:xxx'.
    var isBuiltIn = false;
    if (typeParsed[0] === 'echarts') {
        type = typeParsed[1];
        isBuiltIn = true;
    }
    externalTransform.__isBuiltIn = isBuiltIn;
    $6b1c7afb889b71f1$var$externalTransformMap.set(type, externalTransform);
}
function $6b1c7afb889b71f1$export$42a68f09db16803f(rawTransOption, sourceList, infoForPrint) {
    var pipedTransOption = (0, $3fa81475350067fd$export$4f07b212a02c8051)(rawTransOption);
    var pipeLen = pipedTransOption.length;
    var errMsg = '';
    if (!pipeLen) (0, $ec53fe68074e6f74$export$8bf7aba4a9e09055)(errMsg);
    for(var i = 0, len = pipeLen; i < len; i++){
        var transOption = pipedTransOption[i];
        sourceList = $6b1c7afb889b71f1$var$applySingleDataTransform(transOption, sourceList, infoForPrint, pipeLen === 1 ? null : i);
        // piped transform only support single input, except the fist one.
        // piped transform only support single output, except the last one.
        if (i !== len - 1) sourceList.length = Math.max(sourceList.length, 1);
    }
    return sourceList;
}
function $6b1c7afb889b71f1$var$applySingleDataTransform(transOption, upSourceList, infoForPrint, // If `pipeIndex` is null/undefined, no piped transform.
pipeIndex) {
    var errMsg = '';
    if (!upSourceList.length) (0, $ec53fe68074e6f74$export$8bf7aba4a9e09055)(errMsg);
    if (!(0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(transOption)) (0, $ec53fe68074e6f74$export$8bf7aba4a9e09055)(errMsg);
    var transType = transOption.type;
    var externalTransform = $6b1c7afb889b71f1$var$externalTransformMap.get(transType);
    if (!externalTransform) (0, $ec53fe68074e6f74$export$8bf7aba4a9e09055)(errMsg);
    // Prepare source
    var extUpSourceList = (0, $f16f2994a32ad273$export$871de8747c9eaa88)(upSourceList, function(upSource) {
        return $6b1c7afb889b71f1$var$createExternalSource(upSource, externalTransform);
    });
    var resultList = (0, $3fa81475350067fd$export$4f07b212a02c8051)(externalTransform.transform({
        upstream: extUpSourceList[0],
        upstreamList: extUpSourceList,
        config: (0, $f16f2994a32ad273$export$9cd59f9826255e47)(transOption.config)
    }));
    var printStrArr;
    return (0, $f16f2994a32ad273$export$871de8747c9eaa88)(resultList, function(result, resultIndex) {
        var errMsg = '';
        if (!(0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(result)) (0, $ec53fe68074e6f74$export$8bf7aba4a9e09055)(errMsg);
        if (!result.data) (0, $ec53fe68074e6f74$export$8bf7aba4a9e09055)(errMsg);
        var sourceFormat = (0, $9cad8a8849680580$export$52a469afa4653e57)(result.data);
        if (!$6b1c7afb889b71f1$var$isSupportedSourceFormat(sourceFormat)) (0, $ec53fe68074e6f74$export$8bf7aba4a9e09055)(errMsg);
        var resultMetaRawOption;
        var firstUpSource = upSourceList[0];
        /**
     * Intuitively, the end users known the content of the original `dataset.source`,
     * calucating the transform result in mind.
     * Suppose the original `dataset.source` is:
     * ```js
     * [
     *     ['product', '2012', '2013', '2014', '2015'],
     *     ['AAA', 41.1, 30.4, 65.1, 53.3],
     *     ['BBB', 86.5, 92.1, 85.7, 83.1],
     *     ['CCC', 24.1, 67.2, 79.5, 86.4]
     * ]
     * ```
     * The dimension info have to be detected from the source data.
     * Some of the transformers (like filter, sort) will follow the dimension info
     * of upstream, while others use new dimensions (like aggregate).
     * Transformer can output a field `dimensions` to define the its own output dimensions.
     * We also allow transformers to ignore the output `dimensions` field, and
     * inherit the upstream dimensions definition. It can reduce the burden of handling
     * dimensions in transformers.
     *
     * See also [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
     */ if (firstUpSource && resultIndex === 0 && !result.dimensions) {
            var startIndex = firstUpSource.startIndex;
            // We copy the header of upstream to the result, because:
            // (1) The returned data always does not contain header line and can not be used
            // as dimension-detection. In this case we can not use "detected dimensions" of
            // upstream directly, because it might be detected based on different `seriesLayoutBy`.
            // (2) We should support that the series read the upstream source in `seriesLayoutBy: 'row'`.
            // So the original detected header should be add to the result, otherwise they can not be read.
            if (startIndex) result.data = firstUpSource.data.slice(0, startIndex).concat(result.data);
            resultMetaRawOption = {
                seriesLayoutBy: (0, $c870d17359cdf008$export$7b3f3c6551b4949b),
                sourceHeader: startIndex,
                dimensions: firstUpSource.metaRawOption.dimensions
            };
        } else resultMetaRawOption = {
            seriesLayoutBy: (0, $c870d17359cdf008$export$7b3f3c6551b4949b),
            sourceHeader: 0,
            dimensions: result.dimensions
        };
        return (0, $9cad8a8849680580$export$1921362e86c73c88)(result.data, resultMetaRawOption, null);
    });
}
function $6b1c7afb889b71f1$var$isSupportedSourceFormat(sourceFormat) {
    return sourceFormat === (0, $c870d17359cdf008$export$fcd62ebf51387903) || sourceFormat === (0, $c870d17359cdf008$export$703ae8a2d83f441);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $7E0eS = parcelRequire("7E0eS");






var $e2e44dba229a928c$export$859a1fa4f1106aa0 = (typeof Uint32Array === "undefined" ? "undefined" : (0, $7E0eS._)(Uint32Array)) === (0, $c870d17359cdf008$export$5ba2cba1cb566d7a) ? Array : Uint32Array;
var $e2e44dba229a928c$export$78cf73566f32c185 = (typeof Uint16Array === "undefined" ? "undefined" : (0, $7E0eS._)(Uint16Array)) === (0, $c870d17359cdf008$export$5ba2cba1cb566d7a) ? Array : Uint16Array;
var $e2e44dba229a928c$export$b60d945128546f53 = (typeof Int32Array === "undefined" ? "undefined" : (0, $7E0eS._)(Int32Array)) === (0, $c870d17359cdf008$export$5ba2cba1cb566d7a) ? Array : Int32Array;
var $e2e44dba229a928c$export$365b104db51a490a = (typeof Float64Array === "undefined" ? "undefined" : (0, $7E0eS._)(Float64Array)) === (0, $c870d17359cdf008$export$5ba2cba1cb566d7a) ? Array : Float64Array;
/**
 * Multi dimensional data store
 */ var $e2e44dba229a928c$var$dataCtors = {
    'float': $e2e44dba229a928c$export$365b104db51a490a,
    'int': $e2e44dba229a928c$export$b60d945128546f53,
    // Ordinal data type can be string or int
    'ordinal': Array,
    'number': Array,
    'time': $e2e44dba229a928c$export$365b104db51a490a
};
var $e2e44dba229a928c$var$defaultDimValueGetters;
function $e2e44dba229a928c$var$getIndicesCtor(rawCount) {
    // The possible max value in this._indicies is always this._rawCount despite of filtering.
    return rawCount > 65535 ? $e2e44dba229a928c$export$859a1fa4f1106aa0 : $e2e44dba229a928c$export$78cf73566f32c185;
}
function $e2e44dba229a928c$var$cloneChunk(originalChunk) {
    var Ctor = originalChunk.constructor;
    // Only shallow clone is enough when Array.
    return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
}
function $e2e44dba229a928c$var$prepareStore(store, dimIdx, dimType, end, append) {
    var DataCtor = $e2e44dba229a928c$var$dataCtors[dimType || 'float'];
    if (append) {
        var oldStore = store[dimIdx];
        var oldLen = oldStore && oldStore.length;
        if (!(oldLen === end)) {
            var newStore = new DataCtor(end);
            // The cost of the copy is probably inconsiderable
            // within the initial chunkSize.
            for(var j = 0; j < oldLen; j++)newStore[j] = oldStore[j];
            store[dimIdx] = newStore;
        }
    } else store[dimIdx] = new DataCtor(end);
}
/**
 * Basically, DataStore API keep immutable.
 */ var $e2e44dba229a928c$var$DataStore = /** @class */ function() {
    function DataStore() {
        this._chunks = [];
        // It will not be calculated until needed.
        this._rawExtent = [];
        // structure:
        //  `const extentOnFilterOnDimension = this._extent[dim][extentFilterKey]`
        this._extent = [];
        // Count after filtered.
        this._count = 0;
        this._rawCount = 0;
        this._calcDimNameToIdx = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
    }
    /**
   * Initialize from data
   */ DataStore.prototype.initData = function(provider, inputDimensions, dimValueGetter) {
        this._provider = provider;
        // Clear
        this._chunks = [];
        this._indices = null;
        this.getRawIndex = this._getRawIdxIdentity;
        var source = provider.getSource();
        var defaultGetter = this.defaultDimValueGetter = $e2e44dba229a928c$var$defaultDimValueGetters[source.sourceFormat];
        // Default dim value getter
        this._dimValueGetter = dimValueGetter || defaultGetter;
        // Reset raw extent.
        this._rawExtent = [];
        var willRetrieveDataByName = (0, $9cad8a8849680580$export$8911336b527f8517)(source);
        this._dimensions = (0, $f16f2994a32ad273$export$871de8747c9eaa88)(inputDimensions, function(dim) {
            return {
                // Only pick these two props. Not leak other properties like orderMeta.
                type: dim.type,
                property: dim.property
            };
        });
        this._initDataFromProvider(0, provider.count());
    };
    DataStore.prototype.getProvider = function() {
        return this._provider;
    };
    /**
   * Caution: even when a `source` instance owned by a series, the created data store
   * may still be shared by different sereis (the source hash does not use all `source`
   * props, see `sourceManager`). In this case, the `source` props that are not used in
   * hash (like `source.dimensionDefine`) probably only belongs to a certain series and
   * thus should not be fetch here.
   */ DataStore.prototype.getSource = function() {
        return this._provider.getSource();
    };
    /**
   * @caution Only used in dataStack.
   */ DataStore.prototype.ensureCalculationDimension = function(dimName, type) {
        var calcDimNameToIdx = this._calcDimNameToIdx;
        var dimensions = this._dimensions;
        var calcDimIdx = calcDimNameToIdx.get(dimName);
        if (calcDimIdx != null) {
            if (dimensions[calcDimIdx].type === type) return calcDimIdx;
        } else calcDimIdx = dimensions.length;
        dimensions[calcDimIdx] = {
            type: type
        };
        calcDimNameToIdx.set(dimName, calcDimIdx);
        this._chunks[calcDimIdx] = new $e2e44dba229a928c$var$dataCtors[type || 'float'](this._rawCount);
        this._rawExtent[calcDimIdx] = (0, $3fa81475350067fd$export$62e5f07ab009f3b)();
        return calcDimIdx;
    };
    DataStore.prototype.collectOrdinalMeta = function(dimIdx, ordinalMeta) {
        var chunk = this._chunks[dimIdx];
        var dim = this._dimensions[dimIdx];
        var rawExtents = this._rawExtent;
        var offset = dim.ordinalOffset || 0;
        var len = chunk.length;
        if (offset === 0) // We need to reset the rawExtent if collect is from start.
        // Because this dimension may be guessed as number and calcuating a wrong extent.
        rawExtents[dimIdx] = (0, $3fa81475350067fd$export$62e5f07ab009f3b)();
        var dimRawExtent = rawExtents[dimIdx];
        // Parse from previous data offset. len may be changed after appendData
        for(var i = offset; i < len; i++){
            // See also CATEGORY_AXIS_MODEL_DATA_IS_EMPTY_ARRAY.
            var val = chunk[i] = ordinalMeta.parseAndCollect(chunk[i]);
            if (!isNaN(val)) {
                dimRawExtent[0] = Math.min(val, dimRawExtent[0]);
                dimRawExtent[1] = Math.max(val, dimRawExtent[1]);
            }
        }
        dim.ordinalMeta = ordinalMeta;
        dim.ordinalOffset = len;
        dim.type = 'ordinal'; // Force to be ordinal
    };
    DataStore.prototype.getOrdinalMeta = function(dimIdx) {
        var dimInfo = this._dimensions[dimIdx];
        var ordinalMeta = dimInfo.ordinalMeta;
        return ordinalMeta;
    };
    DataStore.prototype.getDimensionProperty = function(dimIndex) {
        var item = this._dimensions[dimIndex];
        return item && item.property;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ DataStore.prototype.appendData = function(data) {
        var provider = this._provider;
        var start = this.count();
        provider.appendData(data);
        var end = provider.count();
        if (!provider.persistent) end += start;
        if (start < end) this._initDataFromProvider(start, end, true);
        return [
            start,
            end
        ];
    };
    DataStore.prototype.appendValues = function(values, minFillLen) {
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var start = this.count();
        var end = start + Math.max(values.length, minFillLen || 0);
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            $e2e44dba229a928c$var$prepareStore(chunks, i, dim.type, end, true);
        }
        var emptyDataItem = [];
        for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            // Store the data by dimensions
            for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                var dim = dimensions[dimIdx];
                var val = $e2e44dba229a928c$var$defaultDimValueGetters.arrayRows.call(this, values[sourceIdx] || emptyDataItem, dim.property, sourceIdx, dimIdx);
                chunks[dimIdx][idx] = val;
                var dimRawExtent = rawExtent[dimIdx];
                val < dimRawExtent[0] && (dimRawExtent[0] = val);
                val > dimRawExtent[1] && (dimRawExtent[1] = val);
            }
        }
        this._rawCount = this._count = end;
        return {
            start: start,
            end: end
        };
    };
    DataStore.prototype._initDataFromProvider = function(start, end, append) {
        var provider = this._provider;
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var dimNames = (0, $f16f2994a32ad273$export$871de8747c9eaa88)(dimensions, function(dim) {
            return dim.property;
        });
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            if (!rawExtent[i]) rawExtent[i] = (0, $3fa81475350067fd$export$62e5f07ab009f3b)();
            $e2e44dba229a928c$var$prepareStore(chunks, i, dim.type, end, append);
        }
        if (provider.fillStorage) provider.fillStorage(start, end, chunks, rawExtent);
        else {
            var dataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                dataItem = provider.getItem(idx, dataItem);
                // Each data item is value
                // [1, 2]
                // 2
                // Bar chart, line chart which uses category axis
                // only gives the 'y' value. 'x' value is the indices of category
                // Use a tempValue to normalize the value to be a (x, y) value
                // Store the data by dimensions
                for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                    var dimStorage = chunks[dimIdx];
                    // PENDING NULL is empty or zero
                    var val = this._dimValueGetter(dataItem, dimNames[dimIdx], idx, dimIdx);
                    dimStorage[idx] = val;
                    var dimRawExtent = rawExtent[dimIdx];
                    val < dimRawExtent[0] && (dimRawExtent[0] = val);
                    val > dimRawExtent[1] && (dimRawExtent[1] = val);
                }
            }
        }
        if (!provider.persistent && provider.clean) // Clean unused data if data source is typed array.
        provider.clean();
        this._rawCount = this._count = end;
        // Reset data extent
        this._extent = [];
    };
    DataStore.prototype.count = function() {
        return this._count;
    };
    /**
   * Get value. Return NaN if idx is out of range.
   */ DataStore.prototype.get = function(dim, idx) {
        if (!(idx >= 0 && idx < this._count)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[this.getRawIndex(idx)] : NaN;
    };
    DataStore.prototype.getValues = function(dimensions, idx) {
        var values = [];
        var dimArr = [];
        if (idx == null) {
            idx = dimensions;
            // TODO get all from store?
            dimensions = [];
            // All dimensions
            for(var i = 0; i < this._dimensions.length; i++)dimArr.push(i);
        } else dimArr = dimensions;
        for(var i = 0, len = dimArr.length; i < len; i++)values.push(this.get(dimArr[i], idx));
        return values;
    };
    /**
   * @param dim concrete dim
   */ DataStore.prototype.getByRawIndex = function(dim, rawIdx) {
        if (!(rawIdx >= 0 && rawIdx < this._rawCount)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[rawIdx] : NaN;
    };
    /**
   * Get sum of data in one dimension
   */ DataStore.prototype.getSum = function(dim) {
        var dimData = this._chunks[dim];
        var sum = 0;
        if (dimData) for(var i = 0, len = this.count(); i < len; i++){
            var value = this.get(dim, i);
            if (!isNaN(value)) sum += value;
        }
        return sum;
    };
    /**
   * Get median of data in one dimension
   */ DataStore.prototype.getMedian = function(dim) {
        var dimDataArray = [];
        // map all data of one dimension
        this.each([
            dim
        ], function(val) {
            if (!isNaN(val)) dimDataArray.push(val);
        });
        // TODO
        // Use quick select?
        (0, $104896d282bd296f$export$debe6e778e0a6d32)(dimDataArray);
        var len = this.count();
        // calculate median
        return len === 0 ? 0 : len % 2 === 1 ? dimDataArray[(len - 1) / 2] : (dimDataArray[len / 2] + dimDataArray[len / 2 - 1]) / 2;
    };
    /**
   * Retrieve the index with given raw data index.
   */ DataStore.prototype.indexOfRawIndex = function(rawIndex) {
        if (rawIndex >= this._rawCount || rawIndex < 0) return -1;
        if (!this._indices) return rawIndex;
        // Indices are ascending
        var indices = this._indices;
        // If rawIndex === dataIndex
        var rawDataIndex = indices[rawIndex];
        if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) return rawIndex;
        var left = 0;
        var right = this._count - 1;
        while(left <= right){
            var mid = (left + right) / 2 | 0;
            if (indices[mid] < rawIndex) left = mid + 1;
            else if (indices[mid] > rawIndex) right = mid - 1;
            else return mid;
        }
        return -1;
    };
    DataStore.prototype.getIndices = function() {
        var newIndices;
        var indices = this._indices;
        if (indices) {
            var Ctor = indices.constructor;
            var thisCount = this._count;
            // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
            if (Ctor === Array) {
                newIndices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)newIndices[i] = indices[i];
            } else newIndices = new Ctor(indices.buffer, 0, thisCount);
        } else {
            var Ctor = $e2e44dba229a928c$var$getIndicesCtor(this._rawCount);
            newIndices = new Ctor(this.count());
            for(var i = 0; i < newIndices.length; i++)newIndices[i] = i;
        }
        return newIndices;
    };
    /**
   * [NOTICE]: Performance-sensitive for large data.
   */ DataStore.prototype.filter = function(dims, cb) {
        if (!this._count) return this;
        var newStore = this.clone();
        var count = newStore.count();
        var Ctor = $e2e44dba229a928c$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(count);
        var value = [];
        var dimSize = dims.length;
        var offset = 0;
        var dim0 = dims[0];
        var chunks = newStore._chunks;
        for(var i = 0; i < count; i++){
            var keep = void 0;
            var rawIdx = newStore.getRawIndex(i);
            // Simple optimization
            if (dimSize === 0) keep = cb(i);
            else if (dimSize === 1) {
                var val = chunks[dim0][rawIdx];
                keep = cb(val, i);
            } else {
                var k = 0;
                for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                value[k] = i;
                keep = cb.apply(null, value);
            }
            if (keep) newIndices[offset++] = rawIdx;
        }
        // Set indices after filtered.
        if (offset < count) newStore._indices = newIndices;
        newStore._count = offset;
        // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ DataStore.prototype.selectRange = function(range) {
        var newStore = this.clone();
        var len = newStore._count;
        if (!len) return this;
        var dims = (0, $f16f2994a32ad273$export$ed97f33186d4b816)(range);
        var dimSize = dims.length;
        if (!dimSize) return this;
        var originalCount = newStore.count();
        var Ctor = $e2e44dba229a928c$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(originalCount);
        var offset = 0;
        var dim0 = dims[0];
        var min = range[dim0][0];
        var max = range[dim0][1];
        var storeArr = newStore._chunks;
        var quickFinished = false;
        if (!newStore._indices) {
            // Extreme optimization for common case. About 2x faster in chrome.
            var idx = 0;
            if (dimSize === 1) {
                var dimStorage = storeArr[dims[0]];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    // NaN will not be filtered. Consider the case, in line chart, empty
                    // value indicates the line should be broken. But for the case like
                    // scatter plot, a data item with empty value will not be rendered,
                    // but the axis extent may be effected if some other dim of the data
                    // item has value. Fortunately it is not a significant negative effect.
                    if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            } else if (dimSize === 2) {
                var dimStorage = storeArr[dims[0]];
                var dimStorage2 = storeArr[dims[1]];
                var min2 = range[dims[1]][0];
                var max2 = range[dims[1]][1];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    var val2 = dimStorage2[i];
                    // Do not filter NaN, see comment above.
                    if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            }
        }
        if (!quickFinished) {
            if (dimSize === 1) for(var i = 0; i < originalCount; i++){
                var rawIndex = newStore.getRawIndex(i);
                var val = storeArr[dims[0]][rawIndex];
                // Do not filter NaN, see comment above.
                if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = rawIndex;
            }
            else for(var i = 0; i < originalCount; i++){
                var keep = true;
                var rawIndex = newStore.getRawIndex(i);
                for(var k = 0; k < dimSize; k++){
                    var dimk = dims[k];
                    var val = storeArr[dimk][rawIndex];
                    // Do not filter NaN, see comment above.
                    if (val < range[dimk][0] || val > range[dimk][1]) keep = false;
                }
                if (keep) newIndices[offset++] = newStore.getRawIndex(i);
            }
        }
        // Set indices after filtered.
        if (offset < originalCount) newStore._indices = newIndices;
        newStore._count = offset;
        // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    // /**
    //  * Data mapping to a plain array
    //  */
    // mapArray(dims: DimensionIndex[], cb: MapArrayCb): any[] {
    //     const result: any[] = [];
    //     this.each(dims, function () {
    //         result.push(cb && (cb as MapArrayCb).apply(null, arguments));
    //     });
    //     return result;
    // }
    /**
   * Data mapping to a new List with given dimensions
   */ DataStore.prototype.map = function(dims, cb) {
        // TODO only clone picked chunks.
        var target = this.clone(dims);
        this._updateDims(target, dims, cb);
        return target;
    };
    /**
   * @caution Danger!! Only used in dataStack.
   */ DataStore.prototype.modify = function(dims, cb) {
        this._updateDims(this, dims, cb);
    };
    DataStore.prototype._updateDims = function(target, dims, cb) {
        var targetChunks = target._chunks;
        var tmpRetValue = [];
        var dimSize = dims.length;
        var dataCount = target.count();
        var values = [];
        var rawExtent = target._rawExtent;
        for(var i = 0; i < dims.length; i++)rawExtent[dims[i]] = (0, $3fa81475350067fd$export$62e5f07ab009f3b)();
        for(var dataIndex = 0; dataIndex < dataCount; dataIndex++){
            var rawIndex = target.getRawIndex(dataIndex);
            for(var k = 0; k < dimSize; k++)values[k] = targetChunks[dims[k]][rawIndex];
            values[dimSize] = dataIndex;
            var retValue = cb && cb.apply(null, values);
            if (retValue != null) {
                // a number or string (in ordinal dimension)?
                if ((typeof retValue === "undefined" ? "undefined" : (0, $7E0eS._)(retValue)) !== 'object') {
                    tmpRetValue[0] = retValue;
                    retValue = tmpRetValue;
                }
                for(var i = 0; i < retValue.length; i++){
                    var dim = dims[i];
                    var val = retValue[i];
                    var rawExtentOnDim = rawExtent[dim];
                    var dimStore = targetChunks[dim];
                    if (dimStore) dimStore[rawIndex] = val;
                    if (val < rawExtentOnDim[0]) rawExtentOnDim[0] = val;
                    if (val > rawExtentOnDim[1]) rawExtentOnDim[1] = val;
                }
            }
        }
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ DataStore.prototype.lttbDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        var sampledIndex = 0;
        var frameSize = Math.floor(1 / rate);
        var currentRawIndex = this.getRawIndex(0);
        var maxArea;
        var area;
        var nextRawIndex;
        var newIndices = new ($e2e44dba229a928c$var$getIndicesCtor(this._rawCount))(Math.min((Math.ceil(len / frameSize) + 2) * 2, len));
        // First frame use the first data.
        newIndices[sampledIndex++] = currentRawIndex;
        for(var i = 1; i < len - 1; i += frameSize){
            var nextFrameStart = Math.min(i + frameSize, len - 1);
            var nextFrameEnd = Math.min(i + frameSize * 2, len);
            var avgX = (nextFrameEnd + nextFrameStart) / 2;
            var avgY = 0;
            for(var idx = nextFrameStart; idx < nextFrameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) continue;
                avgY += y;
            }
            avgY /= nextFrameEnd - nextFrameStart;
            var frameStart = i;
            var frameEnd = Math.min(i + frameSize, len);
            var pointAX = i - 1;
            var pointAY = dimStore[currentRawIndex];
            maxArea = -1;
            nextRawIndex = frameStart;
            var firstNaNIndex = -1;
            var countNaN = 0;
            // Find a point from current frame that construct a triangle with largest area with previous selected point
            // And the average of next frame.
            for(var idx = frameStart; idx < frameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) {
                    countNaN++;
                    if (firstNaNIndex < 0) firstNaNIndex = rawIndex;
                    continue;
                }
                // Calculate triangle area over three buckets
                area = Math.abs((pointAX - avgX) * (y - pointAY) - (pointAX - idx) * (avgY - pointAY));
                if (area > maxArea) {
                    maxArea = area;
                    nextRawIndex = rawIndex; // Next a is this b
                }
            }
            if (countNaN > 0 && countNaN < frameEnd - frameStart) {
                // Append first NaN point in every bucket.
                // It is necessary to ensure the correct order of indices.
                newIndices[sampledIndex++] = Math.min(firstNaNIndex, nextRawIndex);
                nextRawIndex = Math.max(firstNaNIndex, nextRawIndex);
            }
            newIndices[sampledIndex++] = nextRawIndex;
            currentRawIndex = nextRawIndex; // This a is the next a (chosen b)
        }
        // First frame use the last data.
        newIndices[sampledIndex++] = this.getRawIndex(len - 1);
        target._count = sampledIndex;
        target._indices = newIndices;
        target.getRawIndex = this._getRawIdx;
        return target;
    };
    /**
   * Large data down sampling using min-max
   * @param {string} valueDimension
   * @param {number} rate
   */ DataStore.prototype.minmaxDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        // Each frame results in 2 data points, one for min and one for max
        var newIndices = new ($e2e44dba229a928c$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize) * 2);
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            var minIndex = i;
            var minValue = dimStore[this.getRawIndex(minIndex)];
            var maxIndex = i;
            var maxValue = dimStore[this.getRawIndex(maxIndex)];
            var thisFrameSize = frameSize;
            // Handle final smaller frame
            if (i + frameSize > len) thisFrameSize = len - i;
            // Determine min and max within the current frame
            for(var k = 0; k < thisFrameSize; k++){
                var rawIndex = this.getRawIndex(i + k);
                var value = dimStore[rawIndex];
                if (value < minValue) {
                    minValue = value;
                    minIndex = i + k;
                }
                if (value > maxValue) {
                    maxValue = value;
                    maxIndex = i + k;
                }
            }
            var rawMinIndex = this.getRawIndex(minIndex);
            var rawMaxIndex = this.getRawIndex(maxIndex);
            // Set the order of the min and max values, based on their ordering in the frame
            if (minIndex < maxIndex) {
                newIndices[offset++] = rawMinIndex;
                newIndices[offset++] = rawMaxIndex;
            } else {
                newIndices[offset++] = rawMaxIndex;
                newIndices[offset++] = rawMinIndex;
            }
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ DataStore.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var target = this.clone([
            dimension
        ], true);
        var targetStorage = target._chunks;
        var frameValues = [];
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[dimension];
        var len = this.count();
        var rawExtentOnDim = target._rawExtent[dimension] = (0, $3fa81475350067fd$export$62e5f07ab009f3b)();
        var newIndices = new ($e2e44dba229a928c$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize));
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            // Last frame
            if (frameSize > len - i) {
                frameSize = len - i;
                frameValues.length = frameSize;
            }
            for(var k = 0; k < frameSize; k++){
                var dataIdx = this.getRawIndex(i + k);
                frameValues[k] = dimStore[dataIdx];
            }
            var value = sampleValue(frameValues);
            var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
            // Only write value on the filtered data
            dimStore[sampleFrameIdx] = value;
            if (value < rawExtentOnDim[0]) rawExtentOnDim[0] = value;
            if (value > rawExtentOnDim[1]) rawExtentOnDim[1] = value;
            newIndices[offset++] = sampleFrameIdx;
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Data iteration
   * @param ctx default this
   * @example
   *  list.each(0, function (x, idx) {});
   *  list.each([0, 1], function (x, y, idx) {});
   *  list.each(function (idx) {})
   */ DataStore.prototype.each = function(dims, cb) {
        if (!this._count) return;
        var dimSize = dims.length;
        var chunks = this._chunks;
        for(var i = 0, len = this.count(); i < len; i++){
            var rawIdx = this.getRawIndex(i);
            // Simple optimization
            switch(dimSize){
                case 0:
                    cb(i);
                    break;
                case 1:
                    cb(chunks[dims[0]][rawIdx], i);
                    break;
                case 2:
                    cb(chunks[dims[0]][rawIdx], chunks[dims[1]][rawIdx], i);
                    break;
                default:
                    var k = 0;
                    var value = [];
                    for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                    // Index
                    value[k] = i;
                    cb.apply(null, value);
            }
        }
    };
    DataStore.prototype.getDataExtent = function(dim, filter) {
        // Make sure use concrete dim as cache name.
        var dimData = this._chunks[dim];
        var initialExtent = (0, $3fa81475350067fd$export$62e5f07ab009f3b)();
        if (!dimData) return initialExtent;
        // Make more strict checkings to ensure hitting cache.
        var currEnd = this.count();
        // Consider the most cases when using data zoom, `getDataExtent`
        // happened before filtering. We cache raw extent, which is not
        // necessary to be cleared and recalculated when restore data.
        var useRaw = !this._indices && !filter;
        if (useRaw) return this._rawExtent[dim].slice();
        // NOTE:
        //  - In logarithm axis, zero should be excluded, therefore the `extent[0]` should be less or equal
        //    than the min positive data item, which requires the special handling here.
        //  - "Filter non-positive values for logarithm axis" can also be implemented in a data processor
        //    but that requires more complicated code to not break all streams under the current architecture,
        //    therefore we simply implement it here.
        //  - Performance is sensitive for large data, therefore inline filters rather than cb is used here.
        var thisExtent = this._extent;
        var dimExtentRecord = thisExtent[dim] || (thisExtent[dim] = {});
        var filterParsed = (0, $722bed231f2dca45$export$1b2aa782dfdf5700)(filter);
        var filterKey = filterParsed.key;
        var dimExtent = dimExtentRecord[filterKey];
        if (dimExtent) return dimExtent.slice();
        var min = initialExtent[0];
        var max = initialExtent[1];
        for(var i = 0; i < currEnd; i++){
            // NOTICE: Manually inline some code for performance of large data.
            var rawIdx = this.getRawIndex(i);
            var value = dimData[rawIdx];
            // NOTE: in most cases, filter does not exist.
            if (!filter || (0, $722bed231f2dca45$export$49bf74cb3f1b6c80)(filterParsed, value)) {
                if (value < min) min = value;
                if (value > max) max = value;
            }
        }
        return dimExtentRecord[filterKey] = [
            min,
            max
        ];
    };
    /**
   * Get raw data item
   */ DataStore.prototype.getRawDataItem = function(idx) {
        var rawIdx = this.getRawIndex(idx);
        if (!this._provider.persistent) {
            var val = [];
            var chunks = this._chunks;
            for(var i = 0; i < chunks.length; i++)val.push(chunks[i][rawIdx]);
            return val;
        } else return this._provider.getItem(rawIdx);
    };
    /**
   * Clone shallow.
   *
   * @param clonedDims Determine which dims to clone. Will share the data if not specified.
   */ DataStore.prototype.clone = function(clonedDims, ignoreIndices) {
        var target = new DataStore();
        var chunks = this._chunks;
        var clonedDimsMap = clonedDims && (0, $f16f2994a32ad273$export$533b26079ad0b4b)(clonedDims, function(obj, dimIdx) {
            obj[dimIdx] = true;
            return obj;
        }, {});
        if (clonedDimsMap) for(var i = 0; i < chunks.length; i++)// Not clone if dim is not picked.
        target._chunks[i] = !clonedDimsMap[i] ? chunks[i] : $e2e44dba229a928c$var$cloneChunk(chunks[i]);
        else target._chunks = chunks;
        this._copyCommonProps(target);
        if (!ignoreIndices) target._indices = this._cloneIndices();
        target._updateGetRawIdx();
        return target;
    };
    DataStore.prototype._copyCommonProps = function(target) {
        target._count = this._count;
        target._rawCount = this._rawCount;
        target._provider = this._provider;
        target._dimensions = this._dimensions;
        target._extent = (0, $f16f2994a32ad273$export$9cd59f9826255e47)(this._extent);
        target._rawExtent = (0, $f16f2994a32ad273$export$9cd59f9826255e47)(this._rawExtent);
    };
    DataStore.prototype._cloneIndices = function() {
        if (this._indices) {
            var Ctor = this._indices.constructor;
            var indices = void 0;
            if (Ctor === Array) {
                var thisCount = this._indices.length;
                indices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)indices[i] = this._indices[i];
            } else indices = new Ctor(this._indices);
            return indices;
        }
        return null;
    };
    DataStore.prototype._getRawIdxIdentity = function(idx) {
        return idx;
    };
    DataStore.prototype._getRawIdx = function(idx) {
        if (idx < this._count && idx >= 0) return this._indices[idx];
        return -1;
    };
    DataStore.prototype._updateGetRawIdx = function() {
        this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
    };
    DataStore.internalField = function() {
        function getDimValueSimply(dataItem, property, dataIndex, dimIndex) {
            return (0, $722bed231f2dca45$export$cc7175145baad076)(dataItem[dimIndex], this._dimensions[dimIndex]);
        }
        $e2e44dba229a928c$var$defaultDimValueGetters = {
            arrayRows: getDimValueSimply,
            objectRows: function objectRows(dataItem, property, dataIndex, dimIndex) {
                return (0, $722bed231f2dca45$export$cc7175145baad076)(dataItem[property], this._dimensions[dimIndex]);
            },
            keyedColumns: getDimValueSimply,
            original: function original(dataItem, property, dataIndex, dimIndex) {
                // Performance sensitive, do not use modelUtil.getDataItemValue.
                // If dataItem is an plain object with no value field, the let `value`
                // will be assigned with the object, but it will be tread correctly
                // in the `convertValue`.
                var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value);
                return (0, $722bed231f2dca45$export$cc7175145baad076)(value instanceof Array ? value[dimIndex] : value, this._dimensions[dimIndex]);
            },
            typedArray: function typedArray(dataItem, property, dataIndex, dimIndex) {
                return dataItem[dimIndex];
            }
        };
    }();
    return DataStore;
}();
var $e2e44dba229a928c$export$2e2bcd8739ae039 = $e2e44dba229a928c$var$DataStore;



/**
 * [REQUIREMENT_MEMO]:
 * (0) `metaRawOption` means `dimensions`/`sourceHeader`/`seriesLayoutBy` in raw option.
 * (1) Keep support the feature: `metaRawOption` can be specified both on `series` and
 * `root-dataset`. Them on `series` has higher priority.
 * (2) Do not support to set `metaRawOption` on a `non-root-dataset`, because it might
 * confuse users: whether those props indicate how to visit the upstream source or visit
 * the transform result source, and some transforms has nothing to do with these props,
 * and some transforms might have multiple upstream.
 * (3) Transforms should specify `metaRawOption` in each output, just like they can be
 * declared in `root-dataset`.
 * (4) At present only support visit source in `SERIES_LAYOUT_BY_COLUMN` in transforms.
 * That is for reducing complexity in transforms.
 * PENDING: Whether to provide transposition transform?
 *
 * [IMPLEMENTAION_MEMO]:
 * "sourceVisitConfig" are calculated from `metaRawOption` and `data`.
 * They will not be calculated until `source` is about to be visited (to prevent from
 * duplicate calcuation). `source` is visited only in series and input to transforms.
 *
 * [DIMENSION_INHERIT_RULE]:
 * By default the dimensions are inherited from ancestors, unless a transform return
 * a new dimensions definition.
 * Consider the case:
 * ```js
 * dataset: [{
 *     source: [ ['Product', 'Sales', 'Prise'], ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * dataset: [{
 *     dimension: ['Product', 'Sales', 'Prise'],
 *     source: [ ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * ```
 * The two types of option should have the same behavior after transform.
 *
 *
 * [SCENARIO]:
 * (1) Provide source data directly:
 * ```js
 * series: {
 *     encode: {...},
 *     dimensions: [...]
 *     seriesLayoutBy: 'row',
 *     data: [[...]]
 * }
 * ```
 * (2) Series refer to dataset.
 * ```js
 * series: [{
 *     encode: {...}
 *     // Ignore datasetIndex means `datasetIndex: 0`
 *     // and the dimensions defination in dataset is used
 * }, {
 *     encode: {...},
 *     seriesLayoutBy: 'column',
 *     datasetIndex: 1
 * }]
 * ```
 * (3) dataset transform
 * ```js
 * dataset: [{
 *     source: [...]
 * }, {
 *     source: [...]
 * }, {
 *     // By default from 0.
 *     transform: { type: 'filter', config: {...} }
 * }, {
 *     // Piped.
 *     transform: [
 *         { type: 'filter', config: {...} },
 *         { type: 'sort', config: {...} }
 *     ]
 * }, {
 *     id: 'regressionData',
 *     fromDatasetIndex: 1,
 *     // Third-party transform
 *     transform: { type: 'ecStat:regression', config: {...} }
 * }, {
 *     // retrieve the extra result.
 *     id: 'regressionFormula',
 *     fromDatasetId: 'regressionData',
 *     fromTransformResult: 1
 * }]
 * ```
 */ var $3c0d4b63a900c3f4$export$af4db9ec7e200ea2 = /** @class */ function() {
    function SourceManager(sourceHost) {
        // Cached source. Do not repeat calculating if not dirty.
        this._sourceList = [];
        this._storeList = [];
        // version sign of each upstream source manager.
        this._upstreamSignList = [];
        this._versionSignBase = 0;
        this._dirty = true;
        this._sourceHost = sourceHost;
    }
    /**
   * Mark dirty.
   */ SourceManager.prototype.dirty = function() {
        this._setLocalSource([], []);
        this._storeList = [];
        this._dirty = true;
    };
    SourceManager.prototype._setLocalSource = function(sourceList, upstreamSignList) {
        this._sourceList = sourceList;
        this._upstreamSignList = upstreamSignList;
        this._versionSignBase++;
        if (this._versionSignBase > 9e10) this._versionSignBase = 0;
    };
    /**
   * For detecting whether the upstream source is dirty, so that
   * the local cached source (in `_sourceList`) should be discarded.
   */ SourceManager.prototype._getVersionSign = function() {
        return this._sourceHost.uid + '_' + this._versionSignBase;
    };
    /**
   * Always return a source instance. Otherwise throw error.
   */ SourceManager.prototype.prepareSource = function() {
        // For the case that call `setOption` multiple time but no data changed,
        // cache the result source to prevent from repeating transform.
        if (this._isDirty()) {
            this._createSource();
            this._dirty = false;
        }
    };
    SourceManager.prototype._createSource = function() {
        this._setLocalSource([], []);
        var sourceHost = this._sourceHost;
        var upSourceMgrList = this._getUpstreamSourceManagers();
        var hasUpstream = !!upSourceMgrList.length;
        var resultSourceList;
        var upstreamSignList;
        if ($3c0d4b63a900c3f4$var$isSeries(sourceHost)) {
            var seriesModel = sourceHost;
            var data = void 0;
            var sourceFormat = void 0;
            var upSource = void 0;
            // Has upstream dataset
            if (hasUpstream) {
                var upSourceMgr = upSourceMgrList[0];
                upSourceMgr.prepareSource();
                upSource = upSourceMgr.getSource();
                data = upSource.data;
                sourceFormat = upSource.sourceFormat;
                upstreamSignList = [
                    upSourceMgr._getVersionSign()
                ];
            } else {
                data = seriesModel.get('data', true);
                sourceFormat = (0, $f16f2994a32ad273$export$b119cc7e1840e59c)(data) ? (0, $c870d17359cdf008$export$a918cb016a382d45) : (0, $c870d17359cdf008$export$2823037fb9d8f0c6);
                upstreamSignList = [];
            }
            // See [REQUIREMENT_MEMO], merge settings on series and parent dataset if it is root.
            var newMetaRawOption = this._getSourceMetaRawOption() || {};
            var upMetaRawOption = upSource && upSource.metaRawOption || {};
            var seriesLayoutBy = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(newMetaRawOption.seriesLayoutBy, upMetaRawOption.seriesLayoutBy) || null;
            var sourceHeader = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(newMetaRawOption.sourceHeader, upMetaRawOption.sourceHeader);
            // Note here we should not use `upSource.dimensionsDefine`. Consider the case:
            // `upSource.dimensionsDefine` is detected by `seriesLayoutBy: 'column'`,
            // but series need `seriesLayoutBy: 'row'`.
            var dimensions = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(newMetaRawOption.dimensions, upMetaRawOption.dimensions);
            // We share source with dataset as much as possible
            // to avoid extra memory cost of high dimensional data.
            var needsCreateSource = seriesLayoutBy !== upMetaRawOption.seriesLayoutBy || !!sourceHeader !== !!upMetaRawOption.sourceHeader || dimensions;
            resultSourceList = needsCreateSource ? [
                (0, $9cad8a8849680580$export$1921362e86c73c88)(data, {
                    seriesLayoutBy: seriesLayoutBy,
                    sourceHeader: sourceHeader,
                    dimensions: dimensions
                }, sourceFormat)
            ] : [];
        } else {
            var datasetModel = sourceHost;
            // Has upstream dataset.
            if (hasUpstream) {
                var result = this._applyTransform(upSourceMgrList);
                resultSourceList = result.sourceList;
                upstreamSignList = result.upstreamSignList;
            } else {
                var sourceData = datasetModel.get('source', true);
                resultSourceList = [
                    (0, $9cad8a8849680580$export$1921362e86c73c88)(sourceData, this._getSourceMetaRawOption(), null)
                ];
                upstreamSignList = [];
            }
        }
        this._setLocalSource(resultSourceList, upstreamSignList);
    };
    SourceManager.prototype._applyTransform = function(upMgrList) {
        var datasetModel = this._sourceHost;
        var transformOption = datasetModel.get('transform', true);
        var fromTransformResult = datasetModel.get('fromTransformResult', true);
        if (fromTransformResult != null) {
            var errMsg = '';
            if (upMgrList.length !== 1) $3c0d4b63a900c3f4$var$doThrow(errMsg);
        }
        var sourceList;
        var upSourceList = [];
        var upstreamSignList = [];
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(upMgrList, function(upMgr) {
            upMgr.prepareSource();
            var upSource = upMgr.getSource(fromTransformResult || 0);
            var errMsg = '';
            if (fromTransformResult != null && !upSource) $3c0d4b63a900c3f4$var$doThrow(errMsg);
            upSourceList.push(upSource);
            upstreamSignList.push(upMgr._getVersionSign());
        });
        if (transformOption) sourceList = (0, $6b1c7afb889b71f1$export$42a68f09db16803f)(transformOption, upSourceList, {
            datasetIndex: datasetModel.componentIndex
        });
        else if (fromTransformResult != null) sourceList = [
            (0, $9cad8a8849680580$export$e0365e7e3555ddd4)(upSourceList[0])
        ];
        return {
            sourceList: sourceList,
            upstreamSignList: upstreamSignList
        };
    };
    SourceManager.prototype._isDirty = function() {
        if (this._dirty) return true;
        // All sourceList is from the some upstream.
        var upSourceMgrList = this._getUpstreamSourceManagers();
        for(var i = 0; i < upSourceMgrList.length; i++){
            var upSrcMgr = upSourceMgrList[i];
            if (// Consider the case that there is ancestor diry, call it recursively.
            // The performance is probably not an issue because usually the chain is not long.
            upSrcMgr._isDirty() || this._upstreamSignList[i] !== upSrcMgr._getVersionSign()) return true;
        }
    };
    /**
   * @param sourceIndex By default 0, means "main source".
   *                    In most cases there is only one source.
   */ SourceManager.prototype.getSource = function(sourceIndex) {
        sourceIndex = sourceIndex || 0;
        var source = this._sourceList[sourceIndex];
        if (!source) {
            // Series may share source instance with dataset.
            var upSourceMgrList = this._getUpstreamSourceManagers();
            return upSourceMgrList[0] && upSourceMgrList[0].getSource(sourceIndex);
        }
        return source;
    };
    /**
   *
   * Get a data store which can be shared across series.
   * Only available for series.
   *
   * @param seriesDimRequest Dimensions that are generated in series.
   *        Should have been sorted by `storeDimIndex` asc.
   */ SourceManager.prototype.getSharedDataStore = function(seriesDimRequest) {
        var schema = seriesDimRequest.makeStoreSchema();
        return this._innerGetDataStore(schema.dimensions, seriesDimRequest.source, schema.hash);
    };
    SourceManager.prototype._innerGetDataStore = function(storeDims, seriesSource, sourceReadKey) {
        // TODO Can use other sourceIndex?
        var sourceIndex = 0;
        var storeList = this._storeList;
        var cachedStoreMap = storeList[sourceIndex];
        if (!cachedStoreMap) cachedStoreMap = storeList[sourceIndex] = {};
        var cachedStore = cachedStoreMap[sourceReadKey];
        if (!cachedStore) {
            var upSourceMgr = this._getUpstreamSourceManagers()[0];
            if ($3c0d4b63a900c3f4$var$isSeries(this._sourceHost) && upSourceMgr) cachedStore = upSourceMgr._innerGetDataStore(storeDims, seriesSource, sourceReadKey);
            else {
                cachedStore = new (0, $e2e44dba229a928c$export$2e2bcd8739ae039)();
                // Always create store from source of series.
                cachedStore.initData(new (0, $64e5bb47dc44a160$export$b900d7c4c3952a40)(seriesSource, storeDims.length), storeDims);
            }
            cachedStoreMap[sourceReadKey] = cachedStore;
        }
        return cachedStore;
    };
    /**
   * PENDING: Is it fast enough?
   * If no upstream, return empty array.
   */ SourceManager.prototype._getUpstreamSourceManagers = function() {
        // Always get the relationship from the raw option.
        // Do not cache the link of the dependency graph, so that
        // there is no need to update them when change happens.
        var sourceHost = this._sourceHost;
        if ($3c0d4b63a900c3f4$var$isSeries(sourceHost)) {
            var datasetModel = (0, $0988ea9c84ff78f2$export$8da66f73a1eda454)(sourceHost);
            return !datasetModel ? [] : [
                datasetModel.getSourceManager()
            ];
        } else return (0, $f16f2994a32ad273$export$871de8747c9eaa88)((0, $0988ea9c84ff78f2$export$397ba553479711e7)(sourceHost), function(datasetModel) {
            return datasetModel.getSourceManager();
        });
    };
    SourceManager.prototype._getSourceMetaRawOption = function() {
        var sourceHost = this._sourceHost;
        var seriesLayoutBy;
        var sourceHeader;
        var dimensions;
        if ($3c0d4b63a900c3f4$var$isSeries(sourceHost)) {
            seriesLayoutBy = sourceHost.get('seriesLayoutBy', true);
            sourceHeader = sourceHost.get('sourceHeader', true);
            dimensions = sourceHost.get('dimensions', true);
        } else if (!this._getUpstreamSourceManagers().length) {
            var model = sourceHost;
            seriesLayoutBy = model.get('seriesLayoutBy', true);
            sourceHeader = model.get('sourceHeader', true);
            dimensions = model.get('dimensions', true);
        }
        return {
            seriesLayoutBy: seriesLayoutBy,
            sourceHeader: sourceHeader,
            dimensions: dimensions
        };
    };
    return SourceManager;
}();
function $3c0d4b63a900c3f4$export$9451f4e9047441ec(datasetModel) {
    var transformOption = datasetModel.option.transform;
    transformOption && (0, $f16f2994a32ad273$export$112e66431016387b)(datasetModel.option.transform);
}
function $3c0d4b63a900c3f4$var$isSeries(sourceHost) {
    // Avoid circular dependency with Series.ts
    return sourceHost.mainType === 'series';
}
function $3c0d4b63a900c3f4$var$doThrow(errMsg) {
    throw new Error(errMsg);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $9aca68165c7dc447$var$TOOLTIP_LINE_HEIGHT_CSS = 'line-height:1';
function $9aca68165c7dc447$var$getTooltipLineHeight(textStyle) {
    var lineHeight = textStyle.lineHeight;
    if (lineHeight == null) return $9aca68165c7dc447$var$TOOLTIP_LINE_HEIGHT_CSS;
    else return "line-height:" + (0, $288857a46a8969d9$export$f9d6449b9af28dc1)(lineHeight + '') + "px";
}
// TODO: more textStyle option
function $9aca68165c7dc447$var$getTooltipTextStyle(textStyle, renderMode) {
    var nameFontColor = textStyle.color || (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.tertiary;
    var nameFontSize = textStyle.fontSize || 12;
    var nameFontWeight = textStyle.fontWeight || '400';
    var valueFontColor = textStyle.color || (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.secondary;
    var valueFontSize = textStyle.fontSize || 14;
    var valueFontWeight = textStyle.fontWeight || '900';
    if (renderMode === 'html') // `textStyle` is probably from user input, should be encoded to reduce security risk.
    return {
        // eslint-disable-next-line max-len
        nameStyle: "font-size:" + (0, $288857a46a8969d9$export$f9d6449b9af28dc1)(nameFontSize + '') + "px;color:" + (0, $288857a46a8969d9$export$f9d6449b9af28dc1)(nameFontColor) + ";font-weight:" + (0, $288857a46a8969d9$export$f9d6449b9af28dc1)(nameFontWeight + ''),
        // eslint-disable-next-line max-len
        valueStyle: "font-size:" + (0, $288857a46a8969d9$export$f9d6449b9af28dc1)(valueFontSize + '') + "px;color:" + (0, $288857a46a8969d9$export$f9d6449b9af28dc1)(valueFontColor) + ";font-weight:" + (0, $288857a46a8969d9$export$f9d6449b9af28dc1)(valueFontWeight + '')
    };
    else return {
        nameStyle: {
            fontSize: nameFontSize,
            fill: nameFontColor,
            fontWeight: nameFontWeight
        },
        valueStyle: {
            fontSize: valueFontSize,
            fill: valueFontColor,
            fontWeight: valueFontWeight
        }
    };
}
// See `TooltipMarkupLayoutIntent['innerGapLevel']`.
// (value from UI design)
var $9aca68165c7dc447$var$HTML_GAPS = [
    0,
    10,
    20,
    30
];
var $9aca68165c7dc447$var$RICH_TEXT_GAPS = [
    '',
    '\n',
    '\n\n',
    '\n\n\n'
];
function $9aca68165c7dc447$export$cf63b23ce77d1921(type, option) {
    option.type = type;
    return option;
}
function $9aca68165c7dc447$var$isSectionFragment(frag) {
    return frag.type === 'section';
}
function $9aca68165c7dc447$var$getBuilder(frag) {
    return $9aca68165c7dc447$var$isSectionFragment(frag) ? $9aca68165c7dc447$var$buildSection : $9aca68165c7dc447$var$buildNameValue;
}
function $9aca68165c7dc447$var$getBlockGapLevel(frag) {
    if ($9aca68165c7dc447$var$isSectionFragment(frag)) {
        var gapLevel_1 = 0;
        var subBlockLen = frag.blocks.length;
        var hasInnerGap_1 = subBlockLen > 1 || subBlockLen > 0 && !frag.noHeader;
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(frag.blocks, function(subBlock) {
            var subGapLevel = $9aca68165c7dc447$var$getBlockGapLevel(subBlock);
            // If the some of the sub-blocks have some gaps (like 10px) inside, this block
            // should use a larger gap (like 20px) to distinguish those sub-blocks.
            if (subGapLevel >= gapLevel_1) gapLevel_1 = subGapLevel + +(hasInnerGap_1 && // 0 always can not be readable gap level.
            (!subGapLevel || $9aca68165c7dc447$var$isSectionFragment(subBlock) && !subBlock.noHeader));
        });
        return gapLevel_1;
    }
    return 0;
}
function $9aca68165c7dc447$var$buildSection(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
    var noHeader = fragment.noHeader;
    var gaps = $9aca68165c7dc447$var$getGap($9aca68165c7dc447$var$getBlockGapLevel(fragment));
    var subMarkupTextList = [];
    var subBlocks = fragment.blocks || [];
    (0, $f16f2994a32ad273$export$a7a9523472993e97)(!subBlocks || (0, $f16f2994a32ad273$export$43bee75e5e14138e)(subBlocks));
    subBlocks = subBlocks || [];
    var orderMode = ctx.orderMode;
    if (fragment.sortBlocks && orderMode) {
        subBlocks = subBlocks.slice();
        var orderMap = {
            valueAsc: 'asc',
            valueDesc: 'desc'
        };
        if ((0, $f16f2994a32ad273$export$b5a638e9b3fff9f3)(orderMap, orderMode)) {
            var comparator_1 = new (0, $722bed231f2dca45$export$ed75a5d7b0144167)(orderMap[orderMode], null);
            subBlocks.sort(function(a, b) {
                return comparator_1.evaluate(a.sortParam, b.sortParam);
            });
        } else if (orderMode === 'seriesDesc') subBlocks.reverse();
    }
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(subBlocks, function(subBlock, idx) {
        var valueFormatter = fragment.valueFormatter;
        var subMarkupText = $9aca68165c7dc447$var$getBuilder(subBlock)(// Inherit valueFormatter
        valueFormatter ? (0, $f16f2994a32ad273$export$8b58be045bf06082)((0, $f16f2994a32ad273$export$8b58be045bf06082)({}, ctx), {
            valueFormatter: valueFormatter
        }) : ctx, subBlock, idx > 0 ? gaps.html : 0, toolTipTextStyle);
        subMarkupText != null && subMarkupTextList.push(subMarkupText);
    });
    var subMarkupText = ctx.renderMode === 'richText' ? subMarkupTextList.join(gaps.richText) : $9aca68165c7dc447$var$wrapBlockHTML(toolTipTextStyle, subMarkupTextList.join(''), noHeader ? topMarginForOuterGap : gaps.html);
    if (noHeader) return subMarkupText;
    var displayableHeader = (0, $04bb9ff155ec4ccd$export$3cd8db88714decfc)(fragment.header, 'ordinal', ctx.useUTC);
    var nameStyle = $9aca68165c7dc447$var$getTooltipTextStyle(toolTipTextStyle, ctx.renderMode).nameStyle;
    var tooltipLineHeight = $9aca68165c7dc447$var$getTooltipLineHeight(toolTipTextStyle);
    if (ctx.renderMode === 'richText') return $9aca68165c7dc447$var$wrapInlineNameRichText(ctx, displayableHeader, nameStyle) + gaps.richText + subMarkupText;
    else return $9aca68165c7dc447$var$wrapBlockHTML(toolTipTextStyle, "<div style=\"" + nameStyle + ";" + tooltipLineHeight + ";\">" + (0, $288857a46a8969d9$export$f9d6449b9af28dc1)(displayableHeader) + '</div>' + subMarkupText, topMarginForOuterGap);
}
function $9aca68165c7dc447$var$buildNameValue(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
    var renderMode = ctx.renderMode;
    var noName = fragment.noName;
    var noValue = fragment.noValue;
    var noMarker = !fragment.markerType;
    var name = fragment.name;
    var useUTC = ctx.useUTC;
    var valueFormatter = fragment.valueFormatter || ctx.valueFormatter || function(value) {
        value = (0, $f16f2994a32ad273$export$43bee75e5e14138e)(value) ? value : [
            value
        ];
        return (0, $f16f2994a32ad273$export$871de8747c9eaa88)(value, function(val, idx) {
            return (0, $04bb9ff155ec4ccd$export$3cd8db88714decfc)(val, (0, $f16f2994a32ad273$export$43bee75e5e14138e)(valueTypeOption) ? valueTypeOption[idx] : valueTypeOption, useUTC);
        });
    };
    if (noName && noValue) return;
    var markerStr = noMarker ? '' : ctx.markupStyleCreator.makeTooltipMarker(fragment.markerType, fragment.markerColor || (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.secondary, renderMode);
    var readableName = noName ? '' : (0, $04bb9ff155ec4ccd$export$3cd8db88714decfc)(name, 'ordinal', useUTC);
    var valueTypeOption = fragment.valueType;
    var readableValueList = noValue ? [] : valueFormatter(fragment.value, fragment.rawDataIndex);
    var valueAlignRight = !noMarker || !noName;
    // It little weird if only value next to marker but far from marker.
    var valueCloseToMarker = !noMarker && noName;
    var _a = $9aca68165c7dc447$var$getTooltipTextStyle(toolTipTextStyle, renderMode), nameStyle = _a.nameStyle, valueStyle = _a.valueStyle;
    return renderMode === 'richText' ? (noMarker ? '' : markerStr) + (noName ? '' : $9aca68165c7dc447$var$wrapInlineNameRichText(ctx, readableName, nameStyle)) + (noValue ? '' : $9aca68165c7dc447$var$wrapInlineValueRichText(ctx, readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)) : $9aca68165c7dc447$var$wrapBlockHTML(toolTipTextStyle, (noMarker ? '' : markerStr) + (noName ? '' : $9aca68165c7dc447$var$wrapInlineNameHTML(readableName, !noMarker, nameStyle)) + (noValue ? '' : $9aca68165c7dc447$var$wrapInlineValueHTML(readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)), topMarginForOuterGap);
}
function $9aca68165c7dc447$export$6969ffb02c1cb49a(fragment, markupStyleCreator, renderMode, orderMode, useUTC, toolTipTextStyle) {
    if (!fragment) return;
    var builder = $9aca68165c7dc447$var$getBuilder(fragment);
    var ctx = {
        useUTC: useUTC,
        renderMode: renderMode,
        orderMode: orderMode,
        markupStyleCreator: markupStyleCreator,
        valueFormatter: fragment.valueFormatter
    };
    return builder(ctx, fragment, 0, toolTipTextStyle);
}
function $9aca68165c7dc447$var$getGap(gapLevel) {
    return {
        html: $9aca68165c7dc447$var$HTML_GAPS[gapLevel],
        richText: $9aca68165c7dc447$var$RICH_TEXT_GAPS[gapLevel]
    };
}
function $9aca68165c7dc447$var$wrapBlockHTML(textStyle, encodedContent, topGap) {
    var clearfix = '<div style="clear:both"></div>';
    var marginCSS = "margin: " + topGap + "px 0 0";
    var tooltipLineHeight = $9aca68165c7dc447$var$getTooltipLineHeight(textStyle);
    return "<div style=\"" + marginCSS + ";" + tooltipLineHeight + ";\">" + encodedContent + clearfix + '</div>';
}
function $9aca68165c7dc447$var$wrapInlineNameHTML(name, leftHasMarker, style) {
    var marginCss = leftHasMarker ? 'margin-left:2px' : '';
    return "<span style=\"" + style + ";" + marginCss + "\">" + (0, $288857a46a8969d9$export$f9d6449b9af28dc1)(name) + '</span>';
}
function $9aca68165c7dc447$var$wrapInlineValueHTML(valueList, alignRight, valueCloseToMarker, style) {
    // Do not too close to marker, considering there are multiple values separated by spaces.
    var paddingStr = valueCloseToMarker ? '10px' : '20px';
    var alignCSS = alignRight ? "float:right;margin-left:" + paddingStr : '';
    valueList = (0, $f16f2994a32ad273$export$43bee75e5e14138e)(valueList) ? valueList : [
        valueList
    ];
    return "<span style=\"" + alignCSS + ";" + style + "\">" + (0, $f16f2994a32ad273$export$871de8747c9eaa88)(valueList, function(value) {
        return (0, $288857a46a8969d9$export$f9d6449b9af28dc1)(value);
    }).join('&nbsp;&nbsp;') + '</span>';
}
function $9aca68165c7dc447$var$wrapInlineNameRichText(ctx, name, style) {
    return ctx.markupStyleCreator.wrapRichTextStyle(name, style);
}
function $9aca68165c7dc447$var$wrapInlineValueRichText(ctx, values, alignRight, valueCloseToMarker, style) {
    var styles = [
        style
    ];
    var paddingLeft = valueCloseToMarker ? 10 : 20;
    alignRight && styles.push({
        padding: [
            0,
            0,
            0,
            paddingLeft
        ],
        align: 'right'
    });
    // Value has commas inside, so use '  ' as delimiter for multiple values.
    return ctx.markupStyleCreator.wrapRichTextStyle((0, $f16f2994a32ad273$export$43bee75e5e14138e)(values) ? values.join('  ') : values, styles);
}
function $9aca68165c7dc447$export$ea15628039c0fa93(series, dataIndex) {
    var style = series.getData().getItemVisual(dataIndex, 'style');
    var color = style[series.visualDrawType];
    return (0, $04bb9ff155ec4ccd$export$cda04d03233e5555)(color);
}
function $9aca68165c7dc447$export$3048212c802df496(model, renderMode) {
    var padding = model.get('padding');
    return padding != null ? padding : renderMode === 'richText' ? [
        8,
        10
    ] : 10;
}
/**
 * The major feature is generate styles for `renderMode: 'richText'`.
 * But it also serves `renderMode: 'html'` to provide
 * "renderMode-independent" API.
 */ var $9aca68165c7dc447$export$2fba3afbcdcf3e18 = /** @class */ function() {
    function TooltipMarkupStyleCreator() {
        this.richTextStyles = {};
        // Notice that "generate a style name" usually happens repeatedly when mouse is moving and
        // a tooltip is displayed. So we put the `_nextStyleNameId` as a member of each creator
        // rather than static shared by all creators (which will cause it increase to fast).
        this._nextStyleNameId = (0, $104896d282bd296f$export$474d2ec9aa44a22)();
    }
    TooltipMarkupStyleCreator.prototype._generateStyleName = function() {
        return '__EC_aUTo_' + this._nextStyleNameId++;
    };
    TooltipMarkupStyleCreator.prototype.makeTooltipMarker = function(markerType, colorStr, renderMode) {
        var markerId = renderMode === 'richText' ? this._generateStyleName() : null;
        var marker = (0, $04bb9ff155ec4ccd$export$1987a3dbdf3c45ca)({
            color: colorStr,
            type: markerType,
            renderMode: renderMode,
            markerId: markerId
        });
        if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(marker)) return marker;
        else {
            this.richTextStyles[markerId] = marker.style;
            return marker.content;
        }
    };
    /**
   * @usage
   * ```ts
   * const styledText = markupStyleCreator.wrapRichTextStyle([
   *     // The styles will be auto merged.
   *     {
   *         fontSize: 12,
   *         color: 'blue'
   *     },
   *     {
   *         padding: 20
   *     }
   * ]);
   * ```
   */ TooltipMarkupStyleCreator.prototype.wrapRichTextStyle = function(text, styles) {
        var finalStl = {};
        if ((0, $f16f2994a32ad273$export$43bee75e5e14138e)(styles)) (0, $f16f2994a32ad273$export$79b2f7037acddd43)(styles, function(stl) {
            return (0, $f16f2994a32ad273$export$8b58be045bf06082)(finalStl, stl);
        });
        else (0, $f16f2994a32ad273$export$8b58be045bf06082)(finalStl, styles);
        var styleName = this._generateStyleName();
        this.richTextStyles[styleName] = finalStl;
        return "{" + styleName + "|" + text + "}";
    };
    return TooltipMarkupStyleCreator;
}();




function $caf8a82394ba62c1$export$3a110b9fb5c88b34(opt) {
    var series = opt.series;
    var dataIndex = opt.dataIndex;
    var multipleSeries = opt.multipleSeries;
    var data = series.getData();
    var tooltipDims = data.mapDimensionsAll('defaultedTooltip');
    var tooltipDimLen = tooltipDims.length;
    var value = series.getRawValue(dataIndex);
    var isValueArr = (0, $f16f2994a32ad273$export$43bee75e5e14138e)(value);
    var markerColor = (0, $9aca68165c7dc447$export$ea15628039c0fa93)(series, dataIndex);
    // Complicated rule for pretty tooltip.
    var inlineValue;
    var inlineValueType;
    var subBlocks;
    var sortParam;
    if (tooltipDimLen > 1 || isValueArr && !tooltipDimLen) {
        var formatArrResult = $caf8a82394ba62c1$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, markerColor);
        inlineValue = formatArrResult.inlineValues;
        inlineValueType = formatArrResult.inlineValueTypes;
        subBlocks = formatArrResult.blocks;
        // Only support tooltip sort by the first inline value. It's enough in most cases.
        sortParam = formatArrResult.inlineValues[0];
    } else if (tooltipDimLen) {
        var dimInfo = data.getDimensionInfo(tooltipDims[0]);
        sortParam = inlineValue = (0, $64e5bb47dc44a160$export$cde9373da9aad801)(data, dataIndex, tooltipDims[0]);
        inlineValueType = dimInfo.type;
    } else sortParam = inlineValue = isValueArr ? value[0] : value;
    // Do not show generated series name. It might not be readable.
    var seriesNameSpecified = (0, $3fa81475350067fd$export$beae19a2652b3368)(series);
    var seriesName = seriesNameSpecified && series.name || '';
    var itemName = data.getName(dataIndex);
    var inlineName = multipleSeries ? seriesName : itemName;
    return (0, $9aca68165c7dc447$export$cf63b23ce77d1921)('section', {
        header: seriesName,
        // When series name is not specified, do not show a header line with only '-'.
        // This case always happens in tooltip.trigger: 'item'.
        noHeader: multipleSeries || !seriesNameSpecified,
        sortParam: sortParam,
        blocks: [
            (0, $9aca68165c7dc447$export$cf63b23ce77d1921)('nameValue', {
                markerType: 'item',
                markerColor: markerColor,
                // Do not mix display seriesName and itemName in one tooltip,
                // which might confuses users.
                name: inlineName,
                // name dimension might be auto assigned, where the name might
                // be not readable. So we check trim here.
                noName: !(0, $f16f2994a32ad273$export$87c2784dc9fc4ab)(inlineName),
                value: inlineValue,
                valueType: inlineValueType,
                rawDataIndex: data.getRawIndex(dataIndex)
            })
        ].concat(subBlocks || [])
    });
}
function $caf8a82394ba62c1$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, colorStr) {
    // check: category-no-encode-has-axis-data in dataset.html
    var data = series.getData();
    var isValueMultipleLine = (0, $f16f2994a32ad273$export$533b26079ad0b4b)(value, function(isValueMultipleLine, val, idx) {
        var dimItem = data.getDimensionInfo(idx);
        return isValueMultipleLine = isValueMultipleLine || dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
    }, false);
    var inlineValues = [];
    var inlineValueTypes = [];
    var blocks = [];
    tooltipDims.length ? (0, $f16f2994a32ad273$export$79b2f7037acddd43)(tooltipDims, function(dim) {
        setEachItem((0, $64e5bb47dc44a160$export$cde9373da9aad801)(data, dataIndex, dim), dim);
    }) : (0, $f16f2994a32ad273$export$79b2f7037acddd43)(value, setEachItem);
    function setEachItem(val, dim) {
        var dimInfo = data.getDimensionInfo(dim);
        // If `dimInfo.tooltip` is not set, show tooltip.
        if (!dimInfo || dimInfo.otherDims.tooltip === false) return;
        if (isValueMultipleLine) blocks.push((0, $9aca68165c7dc447$export$cf63b23ce77d1921)('nameValue', {
            markerType: 'subItem',
            markerColor: colorStr,
            name: dimInfo.displayName,
            value: val,
            valueType: dimInfo.type
        }));
        else {
            inlineValues.push(val);
            inlineValueTypes.push(dimInfo.type);
        }
    }
    return {
        inlineValues: inlineValues,
        inlineValueTypes: inlineValueTypes,
        blocks: blocks
    };
}


var $80ec9a06634f90ca$var$inner = $3fa81475350067fd$export$64df9f8d92ae083f();
function $80ec9a06634f90ca$var$getSelectionKey(data, dataIndex) {
    return data.getName(dataIndex) || data.getId(dataIndex);
}
var $80ec9a06634f90ca$export$e960441116ae2799 = '__universalTransitionEnabled';
var $80ec9a06634f90ca$var$SeriesModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(SeriesModel, _super);
    function SeriesModel() {
        // [Caution]: Because this class or desecendants can be used as `XXX.extend(subProto)`,
        // the class members must not be initialized in constructor or declaration place.
        // Otherwise there is bad case:
        //   class A {xxx = 1;}
        //   enableClassExtend(A);
        //   class B extends A {}
        //   var C = B.extend({xxx: 5});
        //   var c = new C();
        //   console.log(c.xxx); // expect 5 but always 1.
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // ---------------------------------------
        // Props about data selection
        // ---------------------------------------
        _this._selectedDataIndicesMap = {};
        return _this;
    }
    SeriesModel.prototype.init = function(option, parentModel, ecModel) {
        this.seriesIndex = this.componentIndex;
        this.dataTask = (0, $4dfdfd6db5b461c6$export$f7292ab7796be73c)({
            count: $80ec9a06634f90ca$var$dataTaskCount,
            reset: $80ec9a06634f90ca$var$dataTaskReset
        });
        this.dataTask.context = {
            model: this
        };
        this.mergeDefaultAndTheme(option, ecModel);
        var sourceManager = $80ec9a06634f90ca$var$inner(this).sourceManager = new (0, $3c0d4b63a900c3f4$export$af4db9ec7e200ea2)(this);
        sourceManager.prepareSource();
        var data = this.getInitialData(option, ecModel);
        $80ec9a06634f90ca$var$wrapData(data, this);
        this.dataTask.context.data = data;
        $80ec9a06634f90ca$var$inner(this).dataBeforeProcessed = data;
        // If we reverse the order (make data firstly, and then make
        // dataBeforeProcessed by cloneShallow), cloneShallow will
        // cause data.graph.data !== data when using
        // module:echarts/data/Graph or module:echarts/data/Tree.
        // See module:echarts/data/helper/linkSeriesData
        // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
        // init or merge stage, because the data can be restored. So we do not `restoreData`
        // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
        // Call `seriesModel.getRawData()` instead.
        // this.restoreData();
        $80ec9a06634f90ca$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    /**
   * Util for merge default and theme to option
   */ SeriesModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = (0, $6b64c78bf98fea85$export$3968a28a7cbd6063)(this);
        var inputPositionParams = layoutMode ? (0, $6b64c78bf98fea85$export$4b0d20af19c9875e)(option) : {};
        // Backward compat: using subType on theme.
        // But if name duplicate between series subType
        // (for example: parallel) add component mainType,
        // add suffix 'Series'.
        var themeSubType = this.subType;
        if ((0, $c418de54527e13f3$export$2e2bcd8739ae039).hasClass(themeSubType)) themeSubType += 'Series';
        $f16f2994a32ad273$export$4950aa0f605343fb(option, ecModel.getTheme().get(this.subType));
        $f16f2994a32ad273$export$4950aa0f605343fb(option, this.getDefaultOption());
        // Default label emphasis `show`
        $3fa81475350067fd$export$abdcc6a26372f94b(option, 'label', [
            'show'
        ]);
        this.fillDataTextStyle(option.data);
        if (layoutMode) (0, $6b64c78bf98fea85$export$1754cb91f16ca028)(option, inputPositionParams, layoutMode);
    };
    SeriesModel.prototype.mergeOption = function(newSeriesOption, ecModel) {
        // this.settingTask.dirty();
        newSeriesOption = $f16f2994a32ad273$export$4950aa0f605343fb(this.option, newSeriesOption, true);
        this.fillDataTextStyle(newSeriesOption.data);
        var layoutMode = (0, $6b64c78bf98fea85$export$3968a28a7cbd6063)(this);
        if (layoutMode) (0, $6b64c78bf98fea85$export$1754cb91f16ca028)(this.option, newSeriesOption, layoutMode);
        var sourceManager = $80ec9a06634f90ca$var$inner(this).sourceManager;
        sourceManager.dirty();
        sourceManager.prepareSource();
        var data = this.getInitialData(newSeriesOption, ecModel);
        $80ec9a06634f90ca$var$wrapData(data, this);
        this.dataTask.dirty();
        this.dataTask.context.data = data;
        $80ec9a06634f90ca$var$inner(this).dataBeforeProcessed = data;
        $80ec9a06634f90ca$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    SeriesModel.prototype.fillDataTextStyle = function(data) {
        // Default data label emphasis `show`
        // FIXME Tree structure data ?
        // FIXME Performance ?
        if (data && !$f16f2994a32ad273$export$b119cc7e1840e59c(data)) {
            var props = [
                'show'
            ];
            for(var i = 0; i < data.length; i++)if (data[i] && data[i].label) $3fa81475350067fd$export$abdcc6a26372f94b(data[i], 'label', props);
        }
    };
    /**
   * Init a data structure from data related option in series
   * Must be overridden.
   */ SeriesModel.prototype.getInitialData = function(option, ecModel) {
        return;
    };
    /**
   * Append data to list
   */ SeriesModel.prototype.appendData = function(params) {
        // FIXME ???
        // (1) If data from dataset, forbidden append.
        // (2) support append data of dataset.
        var data = this.getRawData();
        data.appendData(params.data);
    };
    /**
   * Consider some method like `filter`, `map` need make new data,
   * We should make sure that `seriesModel.getData()` get correct
   * data in the stream procedure. So we fetch data from upstream
   * each time `task.perform` called.
   */ SeriesModel.prototype.getData = function(dataType) {
        var task = $80ec9a06634f90ca$var$getCurrentTask(this);
        if (task) {
            var data = task.context.data;
            return dataType == null || !data.getLinkedData ? data : data.getLinkedData(dataType);
        } else // When series is not alive (that may happen when click toolbox
        // restore or setOption with not merge mode), series data may
        // be still need to judge animation or something when graphic
        // elements want to know whether fade out.
        return $80ec9a06634f90ca$var$inner(this).data;
    };
    SeriesModel.prototype.getAllData = function() {
        var mainData = this.getData();
        return mainData && mainData.getLinkedDataAll ? mainData.getLinkedDataAll() : [
            {
                data: mainData
            }
        ];
    };
    SeriesModel.prototype.setData = function(data) {
        var task = $80ec9a06634f90ca$var$getCurrentTask(this);
        if (task) {
            var context = task.context;
            // Consider case: filter, data sample.
            // FIXME:TS never used, so comment it
            // if (context.data !== data && task.modifyOutputEnd) {
            //     task.setOutputEnd(data.count());
            // }
            context.outputData = data;
            // Caution: setData should update context.data,
            // Because getData may be called multiply in a
            // single stage and expect to get the data just
            // set. (For example, AxisProxy, x y both call
            // getData and setDate sequentially).
            // So the context.data should be fetched from
            // upstream each time when a stage starts to be
            // performed.
            if (task !== this.dataTask) context.data = data;
        }
        $80ec9a06634f90ca$var$inner(this).data = data;
    };
    SeriesModel.prototype.getEncode = function() {
        var encode = this.get('encode', true);
        if (encode) return $f16f2994a32ad273$export$55f8aa7ef875b0a4(encode);
    };
    SeriesModel.prototype.getSourceManager = function() {
        return $80ec9a06634f90ca$var$inner(this).sourceManager;
    };
    SeriesModel.prototype.getSource = function() {
        return this.getSourceManager().getSource();
    };
    /**
   * Get data before processed
   */ SeriesModel.prototype.getRawData = function() {
        return $80ec9a06634f90ca$var$inner(this).dataBeforeProcessed;
    };
    SeriesModel.prototype.getColorBy = function() {
        var colorBy = this.get('colorBy');
        return colorBy || 'series';
    };
    SeriesModel.prototype.isColorBySeries = function() {
        return this.getColorBy() === 'series';
    };
    /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overridden for some chart.
   * @return {type} description
   */ SeriesModel.prototype.getBaseAxis = function() {
        var coordSys = this.coordinateSystem;
        return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
    };
    /**
   * Retrieve the index of nearest value in the view coordinate.
   * Data position is compared with each axis's dataToCoord.
   *
   * @param axisDim axis dimension
   * @param dim data dimension
   * @param value
   * @param [maxDistance=Infinity] The maximum distance in view coordinate space
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */ SeriesModel.prototype.indicesOfNearest = function(axisDim, dim, value, maxDistance) {
        var data = this.getData();
        var coordSys = this.coordinateSystem;
        var axis = coordSys && coordSys.getAxis(axisDim);
        if (!coordSys || !axis) return [];
        var targetCoord = axis.dataToCoord(value);
        if (maxDistance == null) maxDistance = Infinity;
        var nearestIndices = [];
        var minDist = Infinity;
        var minDiff = -1;
        var nearestIndicesLen = 0;
        // Performance-sensitive on large data (triggered by `tooltip`/`axisPointer` frequently).
        var dimIdx = data.getDimensionIndex(dim);
        var store = data.getStore();
        for(var idx = 0, len = store.count(); idx < len; idx++){
            var dimValue = store.get(dimIdx, idx);
            var dataCoord = axis.dataToCoord(dimValue);
            var diff = targetCoord - dataCoord;
            var dist = Math.abs(diff);
            if (dist <= maxDistance) {
                // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
                // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
                // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
                // So we choose the one that `diff >= 0` in this case.
                // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
                // should be push to `nearestIndices`.
                if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
                    minDist = dist;
                    minDiff = diff;
                    nearestIndicesLen = 0;
                }
                if (diff === minDiff) nearestIndices[nearestIndicesLen++] = idx;
            }
        }
        nearestIndices.length = nearestIndicesLen;
        return nearestIndices;
    };
    /**
   * Default tooltip formatter
   *
   * @param dataIndex
   * @param multipleSeries
   * @param dataType
   * @param renderMode valid values: 'html'(by default) and 'richText'.
   *        'html' is used for rendering tooltip in extra DOM form, and the result
   *        string is used as DOM HTML content.
   *        'richText' is used for rendering tooltip in rich text form, for those where
   *        DOM operation is not supported.
   * @return formatted tooltip with `html` and `markers`
   *        Notice: The override method can also return string
   */ SeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        return (0, $caf8a82394ba62c1$export$3a110b9fb5c88b34)({
            series: this,
            dataIndex: dataIndex,
            multipleSeries: multipleSeries
        });
    };
    SeriesModel.prototype.isAnimationEnabled = function() {
        var ecModel = this.ecModel;
        // Disable animation if using echarts in node but not give ssr flag.
        // In ssr mode, renderToString will generate svg with css animation.
        if ((0, $6d0397515b55cc48$export$2e2bcd8739ae039).node && !(ecModel && ecModel.ssr)) return false;
        var animationEnabled = this.getShallow('animation');
        if (animationEnabled) {
            if (this.getData().count() > this.getShallow('animationThreshold')) animationEnabled = false;
        }
        return !!animationEnabled;
    };
    SeriesModel.prototype.restoreData = function() {
        // See `dataTaskReset`.
        this.dataTask.dirty();
    };
    SeriesModel.prototype.getColorFromPalette = function(name, scope, requestColorNum) {
        var ecModel = this.ecModel;
        // PENDING
        var color = (0, $a38f59c4bc389a29$export$55a3c39e852b90f4).prototype.getColorFromPalette.call(this, name, scope, requestColorNum);
        if (!color) color = ecModel.getColorFromPalette(name, scope, requestColorNum);
        return color;
    };
    /**
   * Use `data.mapDimensionsAll(coordDim)` instead.
   * @deprecated
   */ SeriesModel.prototype.coordDimToDataDim = function(coordDim) {
        return this.getRawData().mapDimensionsAll(coordDim);
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressive = function() {
        return this.get('progressive');
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressiveThreshold = function() {
        return this.get('progressiveThreshold');
    };
    // PENGING If selectedMode is null ?
    SeriesModel.prototype.select = function(innerDataIndices, dataType) {
        this._innerSelect(this.getData(dataType), innerDataIndices);
    };
    SeriesModel.prototype.unselect = function(innerDataIndices, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return;
        var selectedMode = this.option.selectedMode;
        var data = this.getData(dataType);
        if (selectedMode === 'series' || selectedMap === 'all') {
            this.option.selectedMap = {};
            this._selectedDataIndicesMap = {};
            return;
        }
        for(var i = 0; i < innerDataIndices.length; i++){
            var dataIndex = innerDataIndices[i];
            var nameOrId = $80ec9a06634f90ca$var$getSelectionKey(data, dataIndex);
            selectedMap[nameOrId] = false;
            this._selectedDataIndicesMap[nameOrId] = -1;
        }
    };
    SeriesModel.prototype.toggleSelect = function(innerDataIndices, dataType) {
        var tmpArr = [];
        for(var i = 0; i < innerDataIndices.length; i++){
            tmpArr[0] = innerDataIndices[i];
            this.isSelected(innerDataIndices[i], dataType) ? this.unselect(tmpArr, dataType) : this.select(tmpArr, dataType);
        }
    };
    SeriesModel.prototype.getSelectedDataIndices = function() {
        if (this.option.selectedMap === 'all') return [].slice.call(this.getData().getIndices());
        var selectedDataIndicesMap = this._selectedDataIndicesMap;
        var nameOrIds = $f16f2994a32ad273$export$ed97f33186d4b816(selectedDataIndicesMap);
        var dataIndices = [];
        for(var i = 0; i < nameOrIds.length; i++){
            var dataIndex = selectedDataIndicesMap[nameOrIds[i]];
            if (dataIndex >= 0) dataIndices.push(dataIndex);
        }
        return dataIndices;
    };
    SeriesModel.prototype.isSelected = function(dataIndex, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return false;
        var data = this.getData(dataType);
        return (selectedMap === 'all' || selectedMap[$80ec9a06634f90ca$var$getSelectionKey(data, dataIndex)]) && !data.getItemModel(dataIndex).get([
            'select',
            'disabled'
        ]);
    };
    SeriesModel.prototype.isUniversalTransitionEnabled = function() {
        if (this[$80ec9a06634f90ca$export$e960441116ae2799]) return true;
        var universalTransitionOpt = this.option.universalTransition;
        // Quick reject
        if (!universalTransitionOpt) return false;
        if (universalTransitionOpt === true) return true;
        // Can be simply 'universalTransition: true'
        return universalTransitionOpt && universalTransitionOpt.enabled;
    };
    SeriesModel.prototype._innerSelect = function(data, innerDataIndices) {
        var _a, _b;
        var option = this.option;
        var selectedMode = option.selectedMode;
        var len = innerDataIndices.length;
        if (!selectedMode || !len) return;
        if (selectedMode === 'series') option.selectedMap = 'all';
        else if (selectedMode === 'multiple') {
            if (!$f16f2994a32ad273$export$a6cdc56e425d0d0a(option.selectedMap)) option.selectedMap = {};
            var selectedMap = option.selectedMap;
            for(var i = 0; i < len; i++){
                var dataIndex = innerDataIndices[i];
                // TODO different types of data share same object.
                var nameOrId = $80ec9a06634f90ca$var$getSelectionKey(data, dataIndex);
                selectedMap[nameOrId] = true;
                this._selectedDataIndicesMap[nameOrId] = data.getRawIndex(dataIndex);
            }
        } else if (selectedMode === 'single' || selectedMode === true) {
            var lastDataIndex = innerDataIndices[len - 1];
            var nameOrId = $80ec9a06634f90ca$var$getSelectionKey(data, lastDataIndex);
            option.selectedMap = (_a = {}, _a[nameOrId] = true, _a);
            this._selectedDataIndicesMap = (_b = {}, _b[nameOrId] = data.getRawIndex(lastDataIndex), _b);
        }
    };
    SeriesModel.prototype._initSelectedMapFromData = function(data) {
        // Ignore select info in data if selectedMap exists.
        // NOTE It's only for legacy usage. edge data is not supported.
        if (this.option.selectedMap) return;
        var dataIndices = [];
        if (data.hasItemOption) data.each(function(idx) {
            var rawItem = data.getRawDataItem(idx);
            if (rawItem && rawItem.selected) dataIndices.push(idx);
        });
        if (dataIndices.length > 0) this._innerSelect(data, dataIndices);
    };
    // /**
    //  * @see {module:echarts/stream/Scheduler}
    //  */
    // abstract pipeTask: null
    SeriesModel.registerClass = function(clz) {
        return (0, $c418de54527e13f3$export$2e2bcd8739ae039).registerClass(clz);
    };
    SeriesModel.protoInitialize = function() {
        var proto = SeriesModel.prototype;
        proto.type = 'series.__base__';
        proto.seriesIndex = 0;
        proto.ignoreStyleOnData = false;
        proto.hasSymbolVisual = false;
        proto.defaultSymbol = 'circle';
        // Make sure the values can be accessed!
        proto.visualStyleAccessPath = 'itemStyle';
        proto.visualDrawType = 'fill';
    }();
    return SeriesModel;
}((0, $c418de54527e13f3$export$2e2bcd8739ae039));
$f16f2994a32ad273$export$e36fc9d62a853069($80ec9a06634f90ca$var$SeriesModel, (0, $dae8b98b5424425d$export$f23396ae04ea95a7));
$f16f2994a32ad273$export$e36fc9d62a853069($80ec9a06634f90ca$var$SeriesModel, (0, $a38f59c4bc389a29$export$55a3c39e852b90f4));
(0, $7904d4b709390668$export$c9c2d87774f1275d)($80ec9a06634f90ca$var$SeriesModel, (0, $c418de54527e13f3$export$2e2bcd8739ae039));
/**
 * MUST be called after `prepareSource` called
 * Here we need to make auto series, especially for auto legend. But we
 * do not modify series.name in option to avoid side effects.
 */ function $80ec9a06634f90ca$var$autoSeriesName(seriesModel) {
    // User specified name has higher priority, otherwise it may cause
    // series can not be queried unexpectedly.
    var name = seriesModel.name;
    if (!$3fa81475350067fd$export$beae19a2652b3368(seriesModel)) seriesModel.name = $80ec9a06634f90ca$var$getSeriesAutoName(seriesModel) || name;
}
function $80ec9a06634f90ca$var$getSeriesAutoName(seriesModel) {
    var data = seriesModel.getRawData();
    var dataDims = data.mapDimensionsAll('seriesName');
    var nameArr = [];
    $f16f2994a32ad273$export$79b2f7037acddd43(dataDims, function(dataDim) {
        var dimInfo = data.getDimensionInfo(dataDim);
        dimInfo.displayName && nameArr.push(dimInfo.displayName);
    });
    return nameArr.join(' ');
}
function $80ec9a06634f90ca$var$dataTaskCount(context) {
    return context.model.getRawData().count();
}
function $80ec9a06634f90ca$var$dataTaskReset(context) {
    var seriesModel = context.model;
    seriesModel.setData(seriesModel.getRawData().cloneShallow());
    return $80ec9a06634f90ca$var$dataTaskProgress;
}
function $80ec9a06634f90ca$var$dataTaskProgress(param, context) {
    // Avoid repeat cloneShallow when data just created in reset.
    if (context.outputData && param.end > context.outputData.count()) context.model.getRawData().cloneShallow(context.outputData);
}
// TODO refactor
function $80ec9a06634f90ca$var$wrapData(data, seriesModel) {
    $f16f2994a32ad273$export$79b2f7037acddd43($f16f2994a32ad273$export$4fd8af2c48c43416(data.CHANGABLE_METHODS, data.DOWNSAMPLE_METHODS), function(methodName) {
        data.wrapMethod(methodName, $f16f2994a32ad273$export$c3095a23b368d1f2($80ec9a06634f90ca$var$onDataChange, seriesModel));
    });
}
function $80ec9a06634f90ca$var$onDataChange(seriesModel, newList) {
    var task = $80ec9a06634f90ca$var$getCurrentTask(seriesModel);
    if (task) // Consider case: filter, selectRange
    task.setOutputEnd((newList || this).count());
    return newList;
}
function $80ec9a06634f90ca$var$getCurrentTask(seriesModel) {
    var scheduler = (seriesModel.ecModel || {}).scheduler;
    var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
    if (pipeline) {
        // When pipline finished, the currrentTask keep the last
        // task (renderTask).
        var task = pipeline.currentTask;
        if (task) {
            var agentStubMap = task.agentStubMap;
            if (agentStubMap) task = agentStubMap.get(seriesModel.uid);
        }
        return task;
    }
}
var $80ec9a06634f90ca$export$2e2bcd8739ae039 = $80ec9a06634f90ca$var$SeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $091798b5bbee0498$var$ComponentView = /** @class */ function() {
    function ComponentView() {
        this.group = new (0, $ac4abc1f547da31a$export$2e2bcd8739ae039)();
        this.uid = $b2c0501cd47c18d8$export$6d2b3473b0986646('viewComponent');
    }
    ComponentView.prototype.init = function(ecModel, api) {};
    ComponentView.prototype.render = function(model, ecModel, api, payload) {};
    ComponentView.prototype.dispose = function(ecModel, api) {};
    ComponentView.prototype.updateView = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    ComponentView.prototype.updateLayout = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    ComponentView.prototype.updateVisual = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    /**
   * Hook for toggle blur target series.
   * Can be used in marker for blur or leave blur the markers
   */ ComponentView.prototype.toggleBlurSeries = function(seriesModels, isBlur, ecModel) {
    // Do nothing;
    };
    /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */ ComponentView.prototype.eachRendered = function(cb) {
        var group = this.group;
        if (group) group.traverse(cb);
    };
    return ComponentView;
}();
$7904d4b709390668$export$cd4c3a4dca301c70($091798b5bbee0498$var$ComponentView);
$7904d4b709390668$export$241315e45585454d($091798b5bbee0498$var$ComponentView);
var $091798b5bbee0498$export$2e2bcd8739ae039 = $091798b5bbee0498$var$ComponentView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $790e5363756df266$export$2e2bcd8739ae039() {
    var inner = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
    return function(seriesModel) {
        var fields = inner(seriesModel);
        var pipelineContext = seriesModel.pipelineContext;
        var originalLarge = !!fields.large;
        var originalProgressive = !!fields.progressiveRender;
        // FIXME: if the planner works on a filtered series, `pipelineContext` does not
        // exists. See #11611 . Probably we need to modify this structure, see the comment
        // on `performRawSeries` in `Schedular.js`.
        var large = fields.large = !!(pipelineContext && pipelineContext.large);
        var progressive = fields.progressiveRender = !!(pipelineContext && pipelineContext.progressiveRender);
        return !!(originalLarge !== large || originalProgressive !== progressive) && 'reset';
    };
}




var $3644e1b3c8e5afa0$var$inner = $3fa81475350067fd$export$64df9f8d92ae083f();
var $3644e1b3c8e5afa0$var$renderPlanner = (0, $790e5363756df266$export$2e2bcd8739ae039)();
var $3644e1b3c8e5afa0$var$ChartView = /** @class */ function() {
    function ChartView() {
        this.group = new (0, $ac4abc1f547da31a$export$2e2bcd8739ae039)();
        this.uid = $b2c0501cd47c18d8$export$6d2b3473b0986646('viewChart');
        this.renderTask = (0, $4dfdfd6db5b461c6$export$f7292ab7796be73c)({
            plan: $3644e1b3c8e5afa0$var$renderTaskPlan,
            reset: $3644e1b3c8e5afa0$var$renderTaskReset
        });
        this.renderTask.context = {
            view: this
        };
    }
    ChartView.prototype.init = function(ecModel, api) {};
    ChartView.prototype.render = function(seriesModel, ecModel, api, payload) {};
    /**
   * Highlight series or specified data item.
   */ ChartView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData(payload && payload.dataType);
        if (!data) return;
        $3644e1b3c8e5afa0$var$toggleHighlight(data, payload, 'emphasis');
    };
    /**
   * Downplay series or specified data item.
   */ ChartView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData(payload && payload.dataType);
        if (!data) return;
        $3644e1b3c8e5afa0$var$toggleHighlight(data, payload, 'normal');
    };
    /**
   * `remove` only occurs when series is filtered out, typically by legend.
   * And theirafter the view can only be rendered again via
   * `ChartView['render']` or `ChartView['incrementalPrepareRender']`.
   */ ChartView.prototype.remove = function(ecModel, api) {
        this.group.removeAll();
    };
    /**
   * Dispose self.
   */ ChartView.prototype.dispose = function(ecModel, api) {};
    ChartView.prototype.updateView = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    // FIXME never used?
    // updateLayout(seriesModel: SeriesModel, ecModel: GlobalModel, api: ExtensionAPI, payload: Payload): void {
    //     this.render(seriesModel, ecModel, api, payload);
    // }
    // FIXME never used?
    ChartView.prototype.updateVisual = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */ ChartView.prototype.eachRendered = function(cb) {
        (0, $bce1f681c7fb2581$export$3e564442729bf048)(this.group, cb);
    };
    ChartView.markUpdateMethod = function(payload, methodName) {
        $3644e1b3c8e5afa0$var$inner(payload).updateMethod = methodName;
    };
    ChartView.protoInitialize = function() {
        var proto = ChartView.prototype;
        proto.type = 'chart';
    }();
    return ChartView;
}();
/**
 * Set state of single element
 */ function $3644e1b3c8e5afa0$var$elSetState(el, state, highlightDigit) {
    if (el && (0, $1f99b77b45f30655$export$77d1445f699c58b5)(el)) (state === 'emphasis' ? (0, $1f99b77b45f30655$export$b2d02638cc34c042) : (0, $1f99b77b45f30655$export$11be6f716239ac55))(el, highlightDigit);
}
function $3644e1b3c8e5afa0$var$toggleHighlight(data, payload, state) {
    var dataIndex = $3fa81475350067fd$export$42b26cae8b8d10(data, payload);
    var highlightDigit = payload && payload.highlightKey != null ? (0, $1f99b77b45f30655$export$824af40eb714530d)(payload.highlightKey) : null;
    if (dataIndex != null) (0, $f16f2994a32ad273$export$79b2f7037acddd43)($3fa81475350067fd$export$4f07b212a02c8051(dataIndex), function(dataIdx) {
        $3644e1b3c8e5afa0$var$elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
    });
    else // In progressive mode, `data._graphicEls` has typically no items,
    // thereby skipping this hover style changing.
    // PENDING: more robust approaches?
    data.eachItemGraphicEl(function(el) {
        $3644e1b3c8e5afa0$var$elSetState(el, state, highlightDigit);
    });
}
$7904d4b709390668$export$cd4c3a4dca301c70($3644e1b3c8e5afa0$var$ChartView, [
    'dispose'
]);
$7904d4b709390668$export$241315e45585454d($3644e1b3c8e5afa0$var$ChartView);
function $3644e1b3c8e5afa0$var$renderTaskPlan(context) {
    return $3644e1b3c8e5afa0$var$renderPlanner(context.model);
}
function $3644e1b3c8e5afa0$var$renderTaskReset(context) {
    var seriesModel = context.model;
    var ecModel = context.ecModel;
    var api = context.api;
    var payload = context.payload;
    // FIXME: remove updateView updateVisual
    var progressiveRender = seriesModel.pipelineContext.progressiveRender;
    var view = context.view;
    var updateMethod = payload && $3644e1b3c8e5afa0$var$inner(payload).updateMethod;
    var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod : 'render';
    if (methodName !== 'render') view[methodName](seriesModel, ecModel, api, payload);
    return $3644e1b3c8e5afa0$var$progressMethodMap[methodName];
}
var $3644e1b3c8e5afa0$var$progressMethodMap = {
    incrementalPrepareRender: {
        progress: function progress(params, context) {
            context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
        }
    },
    render: {
        // Put view.render in `progress` to support appendData. But in this case
        // view.render should not be called in reset, otherwise it will be called
        // twise. Use `forceFirstProgress` to make sure that view.render is called
        // in any cases.
        forceFirstProgress: true,
        progress: function progress(params, context) {
            context.view.render(context.model, context.ecModel, context.api, context.payload);
        }
    }
};
var $3644e1b3c8e5afa0$export$2e2bcd8739ae039 = $3644e1b3c8e5afa0$var$ChartView;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $fcd7567e9010c0f5$var$ORIGIN_METHOD = '\0__throttleOriginMethod';
var $fcd7567e9010c0f5$var$RATE = '\0__throttleRate';
var $fcd7567e9010c0f5$var$THROTTLE_TYPE = '\0__throttleType';
function $fcd7567e9010c0f5$export$de363e709c412c8a(fn, delay, debounce) {
    var currCall;
    var lastCall = 0;
    var lastExec = 0;
    var timer = null;
    var diff;
    var scope;
    var args;
    var debounceNextCall;
    delay = delay || 0;
    function exec() {
        lastExec = new Date().getTime();
        timer = null;
        fn.apply(scope, args || []);
    }
    var cb = function cb() {
        var cbArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)cbArgs[_i] = arguments[_i];
        currCall = new Date().getTime();
        scope = this;
        args = cbArgs;
        var thisDelay = debounceNextCall || delay;
        var thisDebounce = debounceNextCall || debounce;
        debounceNextCall = null;
        diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
        clearTimeout(timer);
        // Here we should make sure that: the `exec` SHOULD NOT be called later
        // than a new call of `cb`, that is, preserving the command order. Consider
        // calculating "scale rate" when roaming as an example. When a call of `cb`
        // happens, either the `exec` is called dierectly, or the call is delayed.
        // But the delayed call should never be later than next call of `cb`. Under
        // this assurance, we can simply update view state each time `dispatchAction`
        // triggered by user roaming, but not need to add extra code to avoid the
        // state being "rolled-back".
        if (thisDebounce) timer = setTimeout(exec, thisDelay);
        else if (diff >= 0) exec();
        else timer = setTimeout(exec, -diff);
        lastCall = currCall;
    };
    /**
   * Clear throttle.
   * @public
   */ cb.clear = function() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };
    /**
   * Enable debounce once.
   */ cb.debounceNextCall = function(debounceDelay) {
        debounceNextCall = debounceDelay;
    };
    return cb;
}
function $fcd7567e9010c0f5$export$958e3e1a02eac4b6(obj, fnAttr, rate, throttleType) {
    var fn = obj[fnAttr];
    if (!fn) return;
    var originFn = fn[$fcd7567e9010c0f5$var$ORIGIN_METHOD] || fn;
    var lastThrottleType = fn[$fcd7567e9010c0f5$var$THROTTLE_TYPE];
    var lastRate = fn[$fcd7567e9010c0f5$var$RATE];
    if (lastRate !== rate || lastThrottleType !== throttleType) {
        if (rate == null || !throttleType) return obj[fnAttr] = originFn;
        fn = obj[fnAttr] = $fcd7567e9010c0f5$export$de363e709c412c8a(originFn, rate, throttleType === 'debounce');
        fn[$fcd7567e9010c0f5$var$ORIGIN_METHOD] = originFn;
        fn[$fcd7567e9010c0f5$var$THROTTLE_TYPE] = throttleType;
        fn[$fcd7567e9010c0f5$var$RATE] = rate;
    }
    return fn;
}
function $fcd7567e9010c0f5$export$42ffd38884aecdac(obj, fnAttr) {
    var fn = obj[fnAttr];
    if (fn && fn[$fcd7567e9010c0f5$var$ORIGIN_METHOD]) {
        // Clear throttle
        fn.clear && fn.clear();
        obj[fnAttr] = fn[$fcd7567e9010c0f5$var$ORIGIN_METHOD];
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $c2d6379aa2d37c3a$var$inner = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
var $c2d6379aa2d37c3a$var$defaultStyleMappers = {
    itemStyle: (0, $77cc5e805eb51edf$export$2e2bcd8739ae039)((0, $d6d3c4b634b15028$export$ffb0bba5dde0130b), true),
    lineStyle: (0, $77cc5e805eb51edf$export$2e2bcd8739ae039)((0, $339315a7b49b0f01$export$9f34de5b59222949), true)
};
var $c2d6379aa2d37c3a$var$defaultColorKey = {
    lineStyle: 'stroke',
    itemStyle: 'fill'
};
function $c2d6379aa2d37c3a$var$getStyleMapper(seriesModel, stylePath) {
    var styleMapper = seriesModel.visualStyleMapper || $c2d6379aa2d37c3a$var$defaultStyleMappers[stylePath];
    if (!styleMapper) {
        console.warn("Unknown style type '" + stylePath + "'.");
        return $c2d6379aa2d37c3a$var$defaultStyleMappers.itemStyle;
    }
    return styleMapper;
}
function $c2d6379aa2d37c3a$var$getDefaultColorKey(seriesModel, stylePath) {
    // return defaultColorKey[stylePath] ||
    var colorKey = seriesModel.visualDrawType || $c2d6379aa2d37c3a$var$defaultColorKey[stylePath];
    if (!colorKey) {
        console.warn("Unknown style type '" + stylePath + "'.");
        return 'fill';
    }
    return colorKey;
}
var $c2d6379aa2d37c3a$export$7ce4d65f9b69240 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function reset(seriesModel, ecModel) {
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
        // Set in itemStyle
        var styleModel = seriesModel.getModel(stylePath);
        var getStyle = $c2d6379aa2d37c3a$var$getStyleMapper(seriesModel, stylePath);
        var globalStyle = getStyle(styleModel);
        var decalOption = styleModel.getShallow('decal');
        if (decalOption) {
            data.setVisual('decal', decalOption);
            decalOption.dirty = true;
        }
        // TODO
        var colorKey = $c2d6379aa2d37c3a$var$getDefaultColorKey(seriesModel, stylePath);
        var color = globalStyle[colorKey];
        // TODO style callback
        var colorCallback = (0, $f16f2994a32ad273$export$f6e2535fb5126e54)(color) ? color : null;
        var hasAutoColor = globalStyle.fill === 'auto' || globalStyle.stroke === 'auto';
        // Get from color palette by default.
        if (!globalStyle[colorKey] || colorCallback || hasAutoColor) {
            // Note: If some series has color specified (e.g., by itemStyle.color), we DO NOT
            // make it effect palette. Because some scenarios users need to make some series
            // transparent or as background, which should better not effect the palette.
            var colorPalette = seriesModel.getColorFromPalette(// TODO series count changed.
            seriesModel.name, null, ecModel.getSeriesCount());
            if (!globalStyle[colorKey]) {
                globalStyle[colorKey] = colorPalette;
                data.setVisual('colorFromPalette', true);
            }
            globalStyle.fill = globalStyle.fill === 'auto' || (0, $f16f2994a32ad273$export$f6e2535fb5126e54)(globalStyle.fill) ? colorPalette : globalStyle.fill;
            globalStyle.stroke = globalStyle.stroke === 'auto' || (0, $f16f2994a32ad273$export$f6e2535fb5126e54)(globalStyle.stroke) ? colorPalette : globalStyle.stroke;
        }
        data.setVisual('style', globalStyle);
        data.setVisual('drawType', colorKey);
        // Only visible series has each data be visual encoded
        if (!ecModel.isSeriesFiltered(seriesModel) && colorCallback) {
            data.setVisual('colorFromPalette', false);
            return {
                dataEach: function dataEach(data, idx) {
                    var dataParams = seriesModel.getDataParams(idx);
                    var itemStyle = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, globalStyle);
                    itemStyle[colorKey] = colorCallback(dataParams);
                    data.setItemVisual(idx, 'style', itemStyle);
                }
            };
        }
    }
};
var $c2d6379aa2d37c3a$var$sharedModel = new (0, $37821cf56da37613$export$2e2bcd8739ae039)();
var $c2d6379aa2d37c3a$export$f7dcb66a065003d1 = {
    createOnAllSeries: true,
    reset: function reset(seriesModel, ecModel) {
        if (seriesModel.ignoreStyleOnData) return;
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
        // Set in itemStyle
        var getStyle = $c2d6379aa2d37c3a$var$getStyleMapper(seriesModel, stylePath);
        var colorKey = data.getVisual('drawType');
        return {
            dataEach: data.hasItemOption ? function(data, idx) {
                // Not use getItemModel for performance considuration
                var rawItem = data.getRawDataItem(idx);
                if (rawItem && rawItem[stylePath]) {
                    $c2d6379aa2d37c3a$var$sharedModel.option = rawItem[stylePath];
                    var style = getStyle($c2d6379aa2d37c3a$var$sharedModel);
                    var existsStyle = data.ensureUniqueItemVisual(idx, 'style');
                    (0, $f16f2994a32ad273$export$8b58be045bf06082)(existsStyle, style);
                    if ($c2d6379aa2d37c3a$var$sharedModel.option.decal) {
                        data.setItemVisual(idx, 'decal', $c2d6379aa2d37c3a$var$sharedModel.option.decal);
                        $c2d6379aa2d37c3a$var$sharedModel.option.decal.dirty = true;
                    }
                    if (colorKey in style) data.setItemVisual(idx, 'colorFromPalette', false);
                }
            } : null
        };
    }
};
// Pick color from palette for the data which has not been set with color yet.
// Note: do not support stream rendering. No such cases yet.
var $c2d6379aa2d37c3a$export$cf9758b0d6dc0aa9 = {
    performRawSeries: true,
    overallReset: function overallReset(ecModel) {
        // Each type of series uses one scope.
        // Pie and funnel are using different scopes.
        var paletteScopeGroupByType = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
        ecModel.eachSeries(function(seriesModel) {
            if (!seriesModel.isColorBySeries()) {
                var key = seriesModel.type + '-' + seriesModel.getColorBy();
                $c2d6379aa2d37c3a$var$inner(seriesModel).scope = paletteScopeGroupByType.get(key) || paletteScopeGroupByType.set(key, {});
            }
        });
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.isColorBySeries()) return;
            var dataAll = seriesModel.getRawData();
            var idxMap = {};
            var data = seriesModel.getData();
            var colorScope = $c2d6379aa2d37c3a$var$inner(seriesModel).scope;
            var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
            var colorKey = $c2d6379aa2d37c3a$var$getDefaultColorKey(seriesModel, stylePath);
            data.each(function(idx) {
                var rawIdx = data.getRawIndex(idx);
                idxMap[rawIdx] = idx;
            });
            // Iterate on data before filtered. To make sure color from palette can be
            // Consistent when toggling legend.
            dataAll.each(function(rawIdx) {
                var idx = idxMap[rawIdx];
                var fromPalette = data.getItemVisual(idx, 'colorFromPalette');
                // Get color from palette for each data only when the color is inherited from series color, which is
                // also picked from color palette. So following situation is not in the case:
                // 1. series.itemStyle.color is set
                // 2. color is encoded by visualMap
                if (fromPalette) {
                    var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                    var name_1 = dataAll.getName(rawIdx) || rawIdx + '';
                    var dataCount = dataAll.count();
                    itemStyle[colorKey] = seriesModel.getColorFromPalette(name_1, colorScope, dataCount);
                }
            });
        });
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $02c296a9317c442e$var$PI = Math.PI;
function $02c296a9317c442e$export$2e2bcd8739ae039(api, opts) {
    opts = opts || {};
    $f16f2994a32ad273$export$ebe90cb607ad99e(opts, {
        text: 'loading',
        textColor: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.primary,
        fontSize: 12,
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontFamily: 'sans-serif',
        maskColor: 'rgba(255,255,255,0.8)',
        showSpinner: true,
        color: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.theme[0],
        spinnerRadius: 10,
        lineWidth: 5,
        zlevel: 0
    });
    var group = new $ac4abc1f547da31a$export$2e2bcd8739ae039();
    var mask = new $dbd6d77105f10fb2$export$2e2bcd8739ae039({
        style: {
            fill: opts.maskColor
        },
        zlevel: opts.zlevel,
        z: 10000
    });
    group.add(mask);
    var textContent = new $7d5e7dc1581f8c9a$export$2e2bcd8739ae039({
        style: {
            text: opts.text,
            fill: opts.textColor,
            fontSize: opts.fontSize,
            fontWeight: opts.fontWeight,
            fontStyle: opts.fontStyle,
            fontFamily: opts.fontFamily
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    var labelRect = new $dbd6d77105f10fb2$export$2e2bcd8739ae039({
        style: {
            fill: 'none'
        },
        textContent: textContent,
        textConfig: {
            position: 'right',
            distance: 10
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    group.add(labelRect);
    var arc;
    if (opts.showSpinner) {
        arc = new $770c52e9ca54b6a3$export$2e2bcd8739ae039({
            shape: {
                startAngle: -$02c296a9317c442e$var$PI / 2,
                endAngle: -$02c296a9317c442e$var$PI / 2 + 0.1,
                r: opts.spinnerRadius
            },
            style: {
                stroke: opts.color,
                lineCap: 'round',
                lineWidth: opts.lineWidth
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        arc.animateShape(true).when(1000, {
            endAngle: $02c296a9317c442e$var$PI * 3 / 2
        }).start('circularInOut');
        arc.animateShape(true).when(1000, {
            startAngle: $02c296a9317c442e$var$PI * 3 / 2
        }).delay(300).start('circularInOut');
        group.add(arc);
    }
    // Inject resize
    group.resize = function() {
        var textWidth = textContent.getBoundingRect().width;
        var r = opts.showSpinner ? opts.spinnerRadius : 0;
        // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
        // textDistance needs to be calculated when both animation and text exist
        var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 - (opts.showSpinner && textWidth ? 0 : 5 + textWidth / 2) + (opts.showSpinner ? 0 : textWidth / 2) + (textWidth ? 0 : r);
        var cy = api.getHeight() / 2;
        opts.showSpinner && arc.setShape({
            cx: cx,
            cy: cy
        });
        labelRect.setShape({
            x: cx - r,
            y: cy - r,
            width: r * 2,
            height: r * 2
        });
        mask.setShape({
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        });
    };
    group.resize();
    return group;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $fe0278d7cd20db39$var$Scheduler = /** @class */ function() {
    function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
        // key: handlerUID
        this._stageTaskMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
        this.ecInstance = ecInstance;
        this.api = api;
        // Fix current processors in case that in some rear cases that
        // processors might be registered after echarts instance created.
        // Register processors incrementally for a echarts instance is
        // not supported by this stream architecture.
        dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
        visualHandlers = this._visualHandlers = visualHandlers.slice();
        this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
    }
    Scheduler.prototype.restoreData = function(ecModel, payload) {
        // TODO: Only restore needed series and components, but not all components.
        // Currently `restoreData` of all of the series and component will be called.
        // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
        // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
        // and some components like coordinate system, axes, dataZoom, visualMap only
        // need their target series refresh.
        // (1) If we are implementing this feature some day, we should consider these cases:
        // if a data processor depends on a component (e.g., dataZoomProcessor depends
        // on the settings of `dataZoom`), it should be re-performed if the component
        // is modified by `setOption`.
        // (2) If a processor depends on several series, specified by its `getTargetSeries`,
        // it should be re-performed when the result array of `getTargetSeries` changed.
        // We use `dependencies` to cover these issues.
        // (3) How to update target series when coordinate system related components modified.
        // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
        // and this case all of the tasks will be set as dirty.
        ecModel.restoreData(payload);
        // Theoretically an overall task not only depends on each of its target series, but also
        // depends on all of the series.
        // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
        // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
        // that the overall task is set as dirty and to be performed, otherwise it probably cause
        // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
        // probably cause state chaos (consider `dataZoomProcessor`).
        this._stageTaskMap.each(function(taskRecord) {
            var overallTask = taskRecord.overallTask;
            overallTask && overallTask.dirty();
        });
    };
    // If seriesModel provided, incremental threshold is check by series data.
    Scheduler.prototype.getPerformArgs = function(task, isBlock) {
        // For overall task
        if (!task.__pipeline) return;
        var pipeline = this._pipelineMap.get(task.__pipeline.id);
        var pCtx = pipeline.context;
        var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
        var step = incremental ? pipeline.step : null;
        var modDataCount = pCtx && pCtx.modDataCount;
        var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
        return {
            step: step,
            modBy: modBy,
            modDataCount: modDataCount
        };
    };
    Scheduler.prototype.getPipeline = function(pipelineId) {
        return this._pipelineMap.get(pipelineId);
    };
    /**
   * Current, progressive rendering starts from visual and layout.
   * Always detect render mode in the same stage, avoiding that incorrect
   * detection caused by data filtering.
   * Caution:
   * `updateStreamModes` use `seriesModel.getData()`.
   */ Scheduler.prototype.updateStreamModes = function(seriesModel, view) {
        var pipeline = this._pipelineMap.get(seriesModel.uid);
        // `progressiveRender` means that can render progressively in each
        // animation frame. Note that some types of series do not provide
        // `view.incrementalPrepareRender` but support `chart.appendData`. We
        // use the term `incremental` but not `progressive` to describe the
        // case `chart.appendData`.
        // Regarding zrender, both echarts "progressive" and "incremental" use `el.incremental: true`.
        var context = seriesModel.__preparePipelineContext ? seriesModel.__preparePipelineContext(view, pipeline) : (0, $3fa81475350067fd$export$3b33f7e0868ca070)(seriesModel, view, pipeline);
        seriesModel.pipelineContext = pipeline.context = context;
    };
    Scheduler.prototype.restorePipelines = function(zr, ecModel) {
        var scheduler = this;
        var pipelineMap = scheduler._pipelineMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
        ecModel.eachSeries(function(seriesModel) {
            var progressive = zr.painter.type === 'canvas' && seriesModel.getProgressive();
            var pipelineId = seriesModel.uid;
            pipelineMap.set(pipelineId, {
                id: pipelineId,
                head: null,
                tail: null,
                threshold: seriesModel.getProgressiveThreshold(),
                progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
                blockIndex: -1,
                step: Math.round(progressive || 700),
                count: 0
            });
            scheduler._pipe(seriesModel, seriesModel.dataTask);
        });
    };
    Scheduler.prototype.prepareStageTasks = function() {
        var stageTaskMap = this._stageTaskMap;
        var ecModel = this.api.getModel();
        var api = this.api;
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(this._allHandlers, function(handler) {
            var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, {});
            var errMsg = '';
            (0, $f16f2994a32ad273$export$a7a9523472993e97)(!(handler.reset && handler.overallReset), errMsg);
            handler.reset && this._createSeriesStageTask(handler, record, ecModel, api);
            handler.overallReset && this._createOverallStageTask(handler, record, ecModel, api);
        }, this);
    };
    Scheduler.prototype.prepareView = function(view, model, ecModel, api) {
        var renderTask = view.renderTask;
        var context = renderTask.context;
        context.model = model;
        context.ecModel = ecModel;
        context.api = api;
        renderTask.__block = !view.incrementalPrepareRender;
        this._pipe(model, renderTask);
    };
    Scheduler.prototype.performDataProcessorTasks = function(ecModel, payload) {
        // If we do not use `block` here, it should be considered when to update modes.
        this._performStageTasks(this._dataProcessorHandlers, ecModel, payload, {
            block: true
        });
    };
    Scheduler.prototype.performVisualTasks = function(ecModel, payload, opt) {
        this._performStageTasks(this._visualHandlers, ecModel, payload, opt);
    };
    Scheduler.prototype._performStageTasks = function(stageHandlers, ecModel, payload, opt) {
        opt = opt || {};
        var unfinished = false;
        var scheduler = this;
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(stageHandlers, function(stageHandler, idx) {
            if (opt.visualType && opt.visualType !== stageHandler.visualType) return;
            var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
            var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
            var overallTask = stageHandlerRecord.overallTask;
            if (overallTask) {
                var overallNeedDirty_1;
                var agentStubMap = overallTask.agentStubMap;
                agentStubMap.each(function(stub) {
                    if (needSetDirty(opt, stub)) {
                        stub.dirty();
                        overallNeedDirty_1 = true;
                    }
                });
                overallNeedDirty_1 && overallTask.dirty();
                scheduler.updatePayload(overallTask, payload);
                var performArgs_1 = scheduler.getPerformArgs(overallTask, opt.block);
                // Execute stubs firstly, which may set the overall task dirty,
                // then execute the overall task. And stub will call seriesModel.setData,
                // which ensures that in the overallTask seriesModel.getData() will not
                // return incorrect data.
                agentStubMap.each(function(stub) {
                    stub.perform(performArgs_1);
                });
                if (overallTask.perform(performArgs_1)) unfinished = true;
            } else if (seriesTaskMap) seriesTaskMap.each(function(task, pipelineId) {
                if (needSetDirty(opt, task)) task.dirty();
                var performArgs = scheduler.getPerformArgs(task, opt.block);
                // FIXME
                // if intending to declare `performRawSeries` in handlers, only
                // stream-independent (specifically, data item independent) operations can be
                // performed. Because if a series is filtered, most of the tasks will not
                // be performed. A stream-dependent operation probably cause wrong biz logic.
                // Perhaps we should not provide a separate callback for this case instead
                // of providing the config `performRawSeries`. The stream-dependent operations
                // and stream-independent operations should better not be mixed.
                performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
                scheduler.updatePayload(task, payload);
                if (task.perform(performArgs)) unfinished = true;
            });
        });
        function needSetDirty(opt, task) {
            return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
        }
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.performSeriesTasks = function(ecModel) {
        var unfinished;
        ecModel.eachSeries(function(seriesModel) {
            // Progress to the end for dataInit and dataRestore.
            unfinished = seriesModel.dataTask.perform() || unfinished;
        });
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.plan = function() {
        // Travel pipelines, check block.
        this._pipelineMap.each(function(pipeline) {
            var task = pipeline.tail;
            do {
                if (task.__block) {
                    pipeline.blockIndex = task.__idxInPipeline;
                    break;
                }
                task = task.getUpstream();
            }while (task);
        });
    };
    Scheduler.prototype.updatePayload = function(task, payload) {
        payload !== 'remain' && (task.context.payload = payload);
    };
    Scheduler.prototype._createSeriesStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var oldSeriesTaskMap = stageHandlerRecord.seriesTaskMap;
        // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newSeriesTaskMap = stageHandlerRecord.seriesTaskMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
        // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
        // it works but it may cause other irrelevant charts blocked.
        if (stageHandler.createOnAllSeries) ecModel.eachRawSeries(create);
        else if (seriesType) ecModel.eachRawSeriesByType(seriesType, create);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(create);
        function create(seriesModel) {
            var pipelineId = seriesModel.uid;
            // Init tasks for each seriesModel only once.
            // Reuse original task instance.
            var task = newSeriesTaskMap.set(pipelineId, oldSeriesTaskMap && oldSeriesTaskMap.get(pipelineId) || (0, $4dfdfd6db5b461c6$export$f7292ab7796be73c)({
                plan: $fe0278d7cd20db39$var$seriesTaskPlan,
                reset: $fe0278d7cd20db39$var$seriesTaskReset,
                count: $fe0278d7cd20db39$var$seriesTaskCount
            }));
            task.context = {
                model: seriesModel,
                ecModel: ecModel,
                api: api,
                // PENDING: `useClearVisual` not used?
                useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
                plan: stageHandler.plan,
                reset: stageHandler.reset,
                scheduler: scheduler
            };
            scheduler._pipe(seriesModel, task);
        }
    };
    Scheduler.prototype._createOverallStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask || (0, $4dfdfd6db5b461c6$export$f7292ab7796be73c)({
            reset: $fe0278d7cd20db39$var$overallTaskReset
        });
        overallTask.context = {
            ecModel: ecModel,
            api: api,
            overallReset: stageHandler.overallReset,
            scheduler: scheduler
        };
        var oldAgentStubMap = overallTask.agentStubMap;
        // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newAgentStubMap = overallTask.agentStubMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        var dirtyOnOverallProgress = stageHandler.dirtyOnOverallProgress;
        var shouldOverallTaskDirty = false;
        // FIXME:TS never used, so comment it
        // let modifyOutputEnd = stageHandler.modifyOutputEnd;
        // An overall task with seriesType detected or has `getTargetSeries`, we add
        // stub in each pipelines to receive dirty info from upstream.
        var errMsg = '';
        (0, $f16f2994a32ad273$export$a7a9523472993e97)(!stageHandler.createOnAllSeries, errMsg);
        if (seriesType) ecModel.eachRawSeriesByType(seriesType, createStub);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(createStub);
        else (0, $f16f2994a32ad273$export$79b2f7037acddd43)(ecModel.getSeries(), createStub);
        function createStub(seriesModel) {
            var pipelineId = seriesModel.uid;
            var stub = newAgentStubMap.set(pipelineId, oldAgentStubMap && oldAgentStubMap.get(pipelineId) || // When the result of `getTargetSeries` changed, the overallTask
            // should be set as dirty and re-performed.
            (shouldOverallTaskDirty = true, (0, $4dfdfd6db5b461c6$export$f7292ab7796be73c)({
                reset: $fe0278d7cd20db39$var$stubReset,
                onDirty: $fe0278d7cd20db39$var$stubOnDirty
            })));
            stub.context = {
                model: seriesModel,
                dirtyOnOverallProgress: dirtyOnOverallProgress
            };
            stub.agent = overallTask;
            stub.__block = dirtyOnOverallProgress;
            scheduler._pipe(seriesModel, stub);
        }
        if (shouldOverallTaskDirty) overallTask.dirty();
    };
    Scheduler.prototype._pipe = function(seriesModel, task) {
        var pipelineId = seriesModel.uid;
        var pipeline = this._pipelineMap.get(pipelineId);
        !pipeline.head && (pipeline.head = task);
        pipeline.tail && pipeline.tail.pipe(task);
        pipeline.tail = task;
        task.__idxInPipeline = pipeline.count++;
        task.__pipeline = pipeline;
    };
    Scheduler.wrapStageHandler = function(stageHandler, visualType) {
        if ((0, $f16f2994a32ad273$export$f6e2535fb5126e54)(stageHandler)) stageHandler = {
            overallReset: stageHandler,
            seriesType: $fe0278d7cd20db39$var$detectSeriseType(stageHandler)
        };
        stageHandler.uid = (0, $b2c0501cd47c18d8$export$6d2b3473b0986646)('stageHandler');
        visualType && (stageHandler.visualType = visualType);
        return stageHandler;
    };
    return Scheduler;
}();
function $fe0278d7cd20db39$var$overallTaskReset(context) {
    context.overallReset(context.ecModel, context.api, context.payload);
}
function $fe0278d7cd20db39$var$stubReset(context) {
    return context.dirtyOnOverallProgress && $fe0278d7cd20db39$var$stubProgress;
}
function $fe0278d7cd20db39$var$stubProgress() {
    this.agent.dirty();
    this.getDownstream().dirty();
}
function $fe0278d7cd20db39$var$stubOnDirty() {
    this.agent && this.agent.dirty();
}
function $fe0278d7cd20db39$var$seriesTaskPlan(context) {
    return context.plan ? context.plan(context.model, context.ecModel, context.api, context.payload) : null;
}
function $fe0278d7cd20db39$var$seriesTaskReset(context) {
    if (context.useClearVisual) context.data.clearAllVisual();
    var resetDefines = context.resetDefines = (0, $3fa81475350067fd$export$4f07b212a02c8051)(context.reset(context.model, context.ecModel, context.api, context.payload));
    return resetDefines.length > 1 ? (0, $f16f2994a32ad273$export$871de8747c9eaa88)(resetDefines, function(v, idx) {
        return $fe0278d7cd20db39$var$makeSeriesTaskProgress(idx);
    }) : $fe0278d7cd20db39$var$singleSeriesTaskProgress;
}
var $fe0278d7cd20db39$var$singleSeriesTaskProgress = $fe0278d7cd20db39$var$makeSeriesTaskProgress(0);
function $fe0278d7cd20db39$var$makeSeriesTaskProgress(resetDefineIdx) {
    return function(params, context) {
        var data = context.data;
        var resetDefine = context.resetDefines[resetDefineIdx];
        if (resetDefine && resetDefine.dataEach) for(var i = params.start; i < params.end; i++)resetDefine.dataEach(data, i);
        else if (resetDefine && resetDefine.progress) resetDefine.progress(params, data);
    };
}
function $fe0278d7cd20db39$var$seriesTaskCount(context) {
    return context.data.count();
}
/**
 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
 * To ensure that they can work normally, they should work in block mode, that is,
 * they should not be started util the previous tasks finished. So they cause the
 * progressive rendering disabled. We try to detect the series type, to narrow down
 * the block range to only the series type they concern, but not all series.
 */ function $fe0278d7cd20db39$var$detectSeriseType(legacyFunc) {
    $fe0278d7cd20db39$var$seriesType = null;
    try {
        // Assume there is no async when calling `eachSeriesByType`.
        legacyFunc($fe0278d7cd20db39$var$ecModelMock, $fe0278d7cd20db39$var$apiMock);
    } catch (e) {}
    return $fe0278d7cd20db39$var$seriesType;
}
var $fe0278d7cd20db39$var$ecModelMock = {};
var $fe0278d7cd20db39$var$apiMock = {};
var $fe0278d7cd20db39$var$seriesType;
$fe0278d7cd20db39$var$mockMethods($fe0278d7cd20db39$var$ecModelMock, (0, $5fcc33310122e6f0$export$2e2bcd8739ae039));
$fe0278d7cd20db39$var$mockMethods($fe0278d7cd20db39$var$apiMock, (0, $d64c00067dc939f7$export$2e2bcd8739ae039));
$fe0278d7cd20db39$var$ecModelMock.eachSeriesByType = $fe0278d7cd20db39$var$ecModelMock.eachRawSeriesByType = function(type) {
    $fe0278d7cd20db39$var$seriesType = type;
};
$fe0278d7cd20db39$var$ecModelMock.eachComponent = function(cond) {
    if (cond.mainType === 'series' && cond.subType) $fe0278d7cd20db39$var$seriesType = cond.subType;
};
function $fe0278d7cd20db39$var$mockMethods(target, Clz) {
    /* eslint-disable */ for(var name_1 in Clz.prototype)// Do not use hasOwnProperty
    target[name_1] = (0, $f16f2994a32ad273$export$8793edee2d425525);
/* eslint-enable */ }
var $fe0278d7cd20db39$export$2e2bcd8739ae039 = $fe0278d7cd20db39$var$Scheduler;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $7f979ae857090a6c$var$color = (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).darkColor;
var $7f979ae857090a6c$var$backgroundColor = $7f979ae857090a6c$var$color.background;
var $7f979ae857090a6c$var$axisCommon = function axisCommon() {
    return {
        axisLine: {
            lineStyle: {
                color: $7f979ae857090a6c$var$color.axisLine
            }
        },
        splitLine: {
            lineStyle: {
                color: $7f979ae857090a6c$var$color.axisSplitLine
            }
        },
        splitArea: {
            areaStyle: {
                color: [
                    $7f979ae857090a6c$var$color.backgroundTint,
                    $7f979ae857090a6c$var$color.backgroundTransparent
                ]
            }
        },
        minorSplitLine: {
            lineStyle: {
                color: $7f979ae857090a6c$var$color.axisMinorSplitLine
            }
        },
        axisLabel: {
            color: $7f979ae857090a6c$var$color.axisLabel
        },
        axisName: {}
    };
};
var $7f979ae857090a6c$var$matrixAxis = {
    label: {
        color: $7f979ae857090a6c$var$color.secondary
    },
    itemStyle: {
        borderColor: $7f979ae857090a6c$var$color.borderTint
    },
    dividerLineStyle: {
        color: $7f979ae857090a6c$var$color.border
    }
};
var $7f979ae857090a6c$var$theme = {
    darkMode: true,
    color: $7f979ae857090a6c$var$color.theme,
    backgroundColor: $7f979ae857090a6c$var$backgroundColor,
    axisPointer: {
        lineStyle: {
            color: $7f979ae857090a6c$var$color.border
        },
        crossStyle: {
            color: $7f979ae857090a6c$var$color.borderShade
        },
        label: {
            color: $7f979ae857090a6c$var$color.tertiary
        }
    },
    legend: {
        textStyle: {
            color: $7f979ae857090a6c$var$color.secondary
        },
        pageTextStyle: {
            color: $7f979ae857090a6c$var$color.tertiary
        }
    },
    textStyle: {
        color: $7f979ae857090a6c$var$color.secondary
    },
    title: {
        textStyle: {
            color: $7f979ae857090a6c$var$color.primary
        },
        subtextStyle: {
            color: $7f979ae857090a6c$var$color.quaternary
        }
    },
    toolbox: {
        iconStyle: {
            borderColor: $7f979ae857090a6c$var$color.accent50
        },
        feature: {
            dataView: {
                backgroundColor: $7f979ae857090a6c$var$backgroundColor,
                textColor: $7f979ae857090a6c$var$color.primary,
                textareaColor: $7f979ae857090a6c$var$color.background,
                textareaBorderColor: $7f979ae857090a6c$var$color.border,
                buttonColor: $7f979ae857090a6c$var$color.accent50,
                buttonTextColor: $7f979ae857090a6c$var$color.neutral00
            }
        }
    },
    tooltip: {
        backgroundColor: $7f979ae857090a6c$var$color.neutral20,
        defaultBorderColor: $7f979ae857090a6c$var$color.border,
        textStyle: {
            color: $7f979ae857090a6c$var$color.tertiary
        }
    },
    dataZoom: {
        borderColor: $7f979ae857090a6c$var$color.accent10,
        textStyle: {
            color: $7f979ae857090a6c$var$color.tertiary
        },
        brushStyle: {
            color: $7f979ae857090a6c$var$color.backgroundTint
        },
        handleStyle: {
            color: $7f979ae857090a6c$var$color.neutral00,
            borderColor: $7f979ae857090a6c$var$color.accent20
        },
        moveHandleStyle: {
            color: $7f979ae857090a6c$var$color.accent40
        },
        emphasis: {
            handleStyle: {
                borderColor: $7f979ae857090a6c$var$color.accent50
            }
        },
        dataBackground: {
            lineStyle: {
                color: $7f979ae857090a6c$var$color.accent30
            },
            areaStyle: {
                color: $7f979ae857090a6c$var$color.accent20
            }
        },
        selectedDataBackground: {
            lineStyle: {
                color: $7f979ae857090a6c$var$color.accent50
            },
            areaStyle: {
                color: $7f979ae857090a6c$var$color.accent30
            }
        }
    },
    visualMap: {
        textStyle: {
            color: $7f979ae857090a6c$var$color.secondary
        },
        handleStyle: {
            borderColor: $7f979ae857090a6c$var$color.neutral30
        }
    },
    timeline: {
        lineStyle: {
            color: $7f979ae857090a6c$var$color.accent10
        },
        label: {
            color: $7f979ae857090a6c$var$color.tertiary
        },
        controlStyle: {
            color: $7f979ae857090a6c$var$color.accent30,
            borderColor: $7f979ae857090a6c$var$color.accent30
        }
    },
    calendar: {
        itemStyle: {
            color: $7f979ae857090a6c$var$color.neutral00,
            borderColor: $7f979ae857090a6c$var$color.neutral20
        },
        dayLabel: {
            color: $7f979ae857090a6c$var$color.tertiary
        },
        monthLabel: {
            color: $7f979ae857090a6c$var$color.secondary
        },
        yearLabel: {
            color: $7f979ae857090a6c$var$color.secondary
        }
    },
    matrix: {
        x: $7f979ae857090a6c$var$matrixAxis,
        y: $7f979ae857090a6c$var$matrixAxis,
        backgroundColor: {
            borderColor: $7f979ae857090a6c$var$color.axisLine
        },
        body: {
            itemStyle: {
                borderColor: $7f979ae857090a6c$var$color.borderTint
            }
        }
    },
    timeAxis: $7f979ae857090a6c$var$axisCommon(),
    logAxis: $7f979ae857090a6c$var$axisCommon(),
    valueAxis: $7f979ae857090a6c$var$axisCommon(),
    categoryAxis: $7f979ae857090a6c$var$axisCommon(),
    line: {
        symbol: 'circle'
    },
    graph: {
        color: $7f979ae857090a6c$var$color.theme
    },
    gauge: {
        title: {
            color: $7f979ae857090a6c$var$color.secondary
        },
        axisLine: {
            lineStyle: {
                color: [
                    [
                        1,
                        $7f979ae857090a6c$var$color.neutral05
                    ]
                ]
            }
        },
        axisLabel: {
            color: $7f979ae857090a6c$var$color.axisLabel
        },
        detail: {
            color: $7f979ae857090a6c$var$color.primary
        }
    },
    candlestick: {
        itemStyle: {
            color: '#f64e56',
            color0: '#54ea92',
            borderColor: '#f64e56',
            borderColor0: '#54ea92'
        }
    },
    funnel: {
        itemStyle: {
            borderColor: $7f979ae857090a6c$var$color.background
        }
    },
    radar: function() {
        var radar = $7f979ae857090a6c$var$axisCommon();
        radar.axisName = {
            color: $7f979ae857090a6c$var$color.axisLabel
        };
        radar.axisLine.lineStyle.color = $7f979ae857090a6c$var$color.neutral20;
        return radar;
    }(),
    treemap: {
        breadcrumb: {
            itemStyle: {
                color: $7f979ae857090a6c$var$color.neutral20,
                textStyle: {
                    color: $7f979ae857090a6c$var$color.secondary
                }
            },
            emphasis: {
                itemStyle: {
                    color: $7f979ae857090a6c$var$color.neutral30
                }
            }
        }
    },
    sunburst: {
        itemStyle: {
            borderColor: $7f979ae857090a6c$var$color.background
        }
    },
    map: {
        itemStyle: {
            borderColor: $7f979ae857090a6c$var$color.border,
            areaColor: $7f979ae857090a6c$var$color.neutral10
        },
        label: {
            color: $7f979ae857090a6c$var$color.tertiary
        },
        emphasis: {
            label: {
                color: $7f979ae857090a6c$var$color.primary
            },
            itemStyle: {
                areaColor: $7f979ae857090a6c$var$color.highlight
            }
        },
        select: {
            label: {
                color: $7f979ae857090a6c$var$color.primary
            },
            itemStyle: {
                areaColor: $7f979ae857090a6c$var$color.highlight
            }
        }
    },
    geo: {
        itemStyle: {
            borderColor: $7f979ae857090a6c$var$color.border,
            areaColor: $7f979ae857090a6c$var$color.neutral10
        },
        emphasis: {
            label: {
                color: $7f979ae857090a6c$var$color.primary
            },
            itemStyle: {
                areaColor: $7f979ae857090a6c$var$color.highlight
            }
        },
        select: {
            label: {
                color: $7f979ae857090a6c$var$color.primary
            },
            itemStyle: {
                color: $7f979ae857090a6c$var$color.highlight
            }
        }
    }
};
$7f979ae857090a6c$var$theme.categoryAxis.splitLine.show = false;
var $7f979ae857090a6c$export$2e2bcd8739ae039 = $7f979ae857090a6c$var$theme;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Usage of query:
 * `chart.on('click', query, handler);`
 * The `query` can be:
 * + The component type query string, only `mainType` or `mainType.subType`,
 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
 * + The component query object, like:
 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
 * + The data query object, like:
 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
 * + The other query object (cmponent customized query), like:
 *   `{element: 'some'}` (only available in custom series).
 *
 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
 * same as there is no such prop in the `query` object.
 */ var $1d241d8a3709ec94$export$d0fd09f950257b52 = /** @class */ function() {
    function ECEventProcessor() {}
    ECEventProcessor.prototype.normalizeQuery = function(query) {
        var cptQuery = {};
        var dataQuery = {};
        var otherQuery = {};
        // `query` is `mainType` or `mainType.subType` of component.
        if ($f16f2994a32ad273$export$844ec244b1367d54(query)) {
            var condCptType = (0, $7904d4b709390668$export$fbe18865d303bf01)(query);
            // `.main` and `.sub` may be ''.
            cptQuery.mainType = condCptType.main || null;
            cptQuery.subType = condCptType.sub || null;
        } else {
            // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
            // can not be used in `compomentModel.filterForExposedEvent`.
            var suffixes_1 = [
                'Index',
                'Name',
                'Id'
            ];
            var dataKeys_1 = {
                name: 1,
                dataIndex: 1,
                dataType: 1
            };
            $f16f2994a32ad273$export$79b2f7037acddd43(query, function(val, key) {
                var reserved = false;
                for(var i = 0; i < suffixes_1.length; i++){
                    var propSuffix = suffixes_1[i];
                    var suffixPos = key.lastIndexOf(propSuffix);
                    if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
                        var mainType = key.slice(0, suffixPos);
                        // Consider `dataIndex`.
                        if (mainType !== 'data') {
                            cptQuery.mainType = mainType;
                            cptQuery[propSuffix.toLowerCase()] = val;
                            reserved = true;
                        }
                    }
                }
                if (dataKeys_1.hasOwnProperty(key)) {
                    dataQuery[key] = val;
                    reserved = true;
                }
                if (!reserved) otherQuery[key] = val;
            });
        }
        return {
            cptQuery: cptQuery,
            dataQuery: dataQuery,
            otherQuery: otherQuery
        };
    };
    ECEventProcessor.prototype.filter = function(eventType, query) {
        // They should be assigned before each trigger call.
        var eventInfo = this.eventInfo;
        if (!eventInfo) return true;
        var targetEl = eventInfo.targetEl;
        var packedEvent = eventInfo.packedEvent;
        var model = eventInfo.model;
        var view = eventInfo.view;
        // For event like 'globalout'.
        if (!model || !view) return true;
        var cptQuery = query.cptQuery;
        var dataQuery = query.dataQuery;
        return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
        function check(query, host, prop, propOnHost) {
            return query[prop] == null || host[propOnHost || prop] === query[prop];
        }
    };
    ECEventProcessor.prototype.afterTrigger = function() {
        // Make sure the eventInfo won't be used in next trigger.
        this.eventInfo = null;
    };
    return ECEventProcessor;
}();



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $14ec89f6ed8380f9$var$SYMBOL_PROPS_WITH_CB = [
    'symbol',
    'symbolSize',
    'symbolRotate',
    'symbolOffset'
];
var $14ec89f6ed8380f9$var$SYMBOL_PROPS = $14ec89f6ed8380f9$var$SYMBOL_PROPS_WITH_CB.concat([
    'symbolKeepAspect'
]);
// Encoding visual for all series include which is filtered for legend drawing
var $14ec89f6ed8380f9$export$144ac3beded415d9 = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function reset(seriesModel, ecModel) {
        var data = seriesModel.getData();
        if (seriesModel.legendIcon) data.setVisual('legendIcon', seriesModel.legendIcon);
        if (!seriesModel.hasSymbolVisual) return;
        var symbolOptions = {};
        var symbolOptionsCb = {};
        var hasCallback = false;
        for(var i = 0; i < $14ec89f6ed8380f9$var$SYMBOL_PROPS_WITH_CB.length; i++){
            var symbolPropName = $14ec89f6ed8380f9$var$SYMBOL_PROPS_WITH_CB[i];
            var val = seriesModel.get(symbolPropName);
            if ((0, $f16f2994a32ad273$export$f6e2535fb5126e54)(val)) {
                hasCallback = true;
                symbolOptionsCb[symbolPropName] = val;
            } else symbolOptions[symbolPropName] = val;
        }
        symbolOptions.symbol = symbolOptions.symbol || seriesModel.defaultSymbol;
        data.setVisual((0, $f16f2994a32ad273$export$8b58be045bf06082)({
            legendIcon: seriesModel.legendIcon || symbolOptions.symbol,
            symbolKeepAspect: seriesModel.get('symbolKeepAspect')
        }, symbolOptions));
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var symbolPropsCb = (0, $f16f2994a32ad273$export$ed97f33186d4b816)(symbolOptionsCb);
        function dataEach(data, idx) {
            var rawValue = seriesModel.getRawValue(idx);
            var params = seriesModel.getDataParams(idx);
            for(var i = 0; i < symbolPropsCb.length; i++){
                var symbolPropName = symbolPropsCb[i];
                data.setItemVisual(idx, symbolPropName, symbolOptionsCb[symbolPropName](rawValue, params));
            }
        }
        return {
            dataEach: hasCallback ? dataEach : null
        };
    }
};
var $14ec89f6ed8380f9$export$435b956f7f1071fb = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function reset(seriesModel, ecModel) {
        if (!seriesModel.hasSymbolVisual) return;
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            for(var i = 0; i < $14ec89f6ed8380f9$var$SYMBOL_PROPS.length; i++){
                var symbolPropName = $14ec89f6ed8380f9$var$SYMBOL_PROPS[i];
                var val = itemModel.getShallow(symbolPropName, true);
                if (val != null) data.setItemVisual(idx, symbolPropName, val);
            }
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $1b1e2db17dfc2a59$export$91d919a86b2df624(data, dataIndex, key) {
    switch(key){
        case 'color':
            var style = data.getItemVisual(dataIndex, 'style');
            return style[data.getVisual('drawType')];
        case 'opacity':
            return data.getItemVisual(dataIndex, 'style').opacity;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            return data.getItemVisual(dataIndex, key);
        default:
    }
}
function $1b1e2db17dfc2a59$export$d76e333a86ea1a2(data, key) {
    switch(key){
        case 'color':
            var style = data.getVisual('style');
            return style[data.getVisual('drawType')];
        case 'opacity':
            return data.getVisual('style').opacity;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            return data.getVisual(key);
        default:
    }
}
function $1b1e2db17dfc2a59$export$3aab879e9d0e7c75(data, dataIndex, key, value) {
    switch(key){
        case 'color':
            // Make sure not sharing style object.
            var style = data.ensureUniqueItemVisual(dataIndex, 'style');
            style[data.getVisual('drawType')] = value;
            // Mark the color has been changed, not from palette anymore
            data.setItemVisual(dataIndex, 'colorFromPalette', false);
            break;
        case 'opacity':
            data.ensureUniqueItemVisual(dataIndex, 'style').opacity = value;
            break;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            data.setItemVisual(dataIndex, key, value);
            break;
        default:
    }
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $e898649850ed5916$export$62942ba95693dbfc(seriesType, ecRegisterAction) {
    function getSeriesIndices(ecModel, payload) {
        var seriesIndices = [];
        ecModel.eachComponent({
            mainType: 'series',
            subType: seriesType,
            query: payload
        }, function(seriesModel) {
            seriesIndices.push(seriesModel.seriesIndex);
        });
        return seriesIndices;
    }
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)([
        [
            seriesType + 'ToggleSelect',
            'toggleSelect'
        ],
        [
            seriesType + 'Select',
            'select'
        ],
        [
            seriesType + 'UnSelect',
            'unselect'
        ]
    ], function(eventsMap) {
        ecRegisterAction(eventsMap[0], function(payload, ecModel, api) {
            payload = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, payload);
            api.dispatchAction((0, $f16f2994a32ad273$export$8b58be045bf06082)(payload, {
                type: eventsMap[1],
                seriesIndex: getSeriesIndices(ecModel, payload)
            }));
        });
    });
}
function $e898649850ed5916$var$handleSeriesLegacySelectEvents(type, eventPostfix, ecIns, ecModel, payload) {
    var legacyEventName = type + eventPostfix;
    if (!ecIns.isSilent(legacyEventName)) ecModel.eachComponent({
        mainType: 'series',
        subType: 'pie'
    }, function(seriesModel) {
        var seriesIndex = seriesModel.seriesIndex;
        var selectedMap = seriesModel.option.selectedMap;
        var selected = payload.selected;
        for(var i = 0; i < selected.length; i++)if (selected[i].seriesIndex === seriesIndex) {
            var data = seriesModel.getData();
            var dataIndex = (0, $3fa81475350067fd$export$42b26cae8b8d10)(data, payload.fromActionPayload);
            ecIns.trigger(legacyEventName, {
                type: legacyEventName,
                seriesId: seriesModel.id,
                name: (0, $f16f2994a32ad273$export$43bee75e5e14138e)(dataIndex) ? data.getName(dataIndex[0]) : data.getName(dataIndex),
                selected: (0, $f16f2994a32ad273$export$844ec244b1367d54)(selectedMap) ? selectedMap : (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, selectedMap)
            });
        }
    });
}
function $e898649850ed5916$export$2575c83262e49d0c(messageCenter, ecIns, api) {
    messageCenter.on('selectchanged', function(params) {
        var ecModel = api.getModel();
        if (params.isFromClick) {
            $e898649850ed5916$var$handleSeriesLegacySelectEvents('map', 'selectchanged', ecIns, ecModel, params);
            $e898649850ed5916$var$handleSeriesLegacySelectEvents('pie', 'selectchanged', ecIns, ecModel, params);
        } else if (params.fromAction === 'select') {
            $e898649850ed5916$var$handleSeriesLegacySelectEvents('map', 'selected', ecIns, ecModel, params);
            $e898649850ed5916$var$handleSeriesLegacySelectEvents('pie', 'selected', ecIns, ecModel, params);
        } else if (params.fromAction === 'unselect') {
            $e898649850ed5916$var$handleSeriesLegacySelectEvents('map', 'unselected', ecIns, ecModel, params);
            $e898649850ed5916$var$handleSeriesLegacySelectEvents('pie', 'unselected', ecIns, ecModel, params);
        }
    });
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $c30ebd75483299c9$export$8a4fca9e04eb4df6(target, det, returnFirstMatch) {
    var found;
    while(target){
        if (det(target)) {
            found = target;
            if (returnFirstMatch) break;
        }
        target = target.__hostTarget || target.parent;
    }
    return found;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $a4a481f8e97330f1$var$lifecycle = new (0, $83f1d7c1143fe0f3$export$2e2bcd8739ae039)();
var $a4a481f8e97330f1$export$2e2bcd8739ae039 = $a4a481f8e97330f1$var$lifecycle;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// Implementation of exported APIs. For example registerMap, getMap.
// The implementations will be registered when installing the component.
// Avoid these code being bundled to the core module.
var $61724d3be20b47ac$var$implsStore = {};
function $61724d3be20b47ac$export$9b808fd12256ddd3(name, impl) {
    $61724d3be20b47ac$var$implsStore[name] = impl;
}
function $61724d3be20b47ac$export$73333eb8a09d5f61(name) {
    return $61724d3be20b47ac$var$implsStore[name];
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $2525bf86f8f37ab9$var$customRenderers = {};
function $2525bf86f8f37ab9$export$c3e61191887968da(type, renderItem) {
    $2525bf86f8f37ab9$var$customRenderers[type] = renderItem;
}
function $2525bf86f8f37ab9$export$2b5db8e5650e8d15(type) {
    return $2525bf86f8f37ab9$var$customRenderers[type];
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $31b4a1aa189576ea$var$ecModelCacheInner = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
function $31b4a1aa189576ea$export$54b70eb74482271e(ecModel) {
    $31b4a1aa189576ea$var$ecModelCacheInner(ecModel).prepare = {};
}
function $31b4a1aa189576ea$export$7a0372e5df3ca6f4(ecModel) {
    $31b4a1aa189576ea$var$ecModelCacheInner(ecModel).fullUpdate = {};
}
function $31b4a1aa189576ea$export$67fb26d0f4e31b9e(ecModel) {
    return $31b4a1aa189576ea$var$ecModelCacheInner(ecModel).prepare;
}
function $31b4a1aa189576ea$export$14434b56aab40385(ecModel) {
    return $31b4a1aa189576ea$var$ecModelCacheInner(ecModel).fullUpdate;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $7E0eS = parcelRequire("7E0eS");
var $009163b5f902e248$var$wmUniqueIndex = Math.round(Math.random() * 9);
var $009163b5f902e248$var$supportDefineProperty = typeof Object.defineProperty === 'function';
var $009163b5f902e248$var$WeakMap = function() {
    function WeakMap() {
        this._id = '__ec_inner_' + $009163b5f902e248$var$wmUniqueIndex++;
    }
    WeakMap.prototype.get = function(key) {
        return this._guard(key)[this._id];
    };
    WeakMap.prototype.set = function(key, value) {
        var target = this._guard(key);
        if ($009163b5f902e248$var$supportDefineProperty) Object.defineProperty(target, this._id, {
            value: value,
            enumerable: false,
            configurable: true
        });
        else target[this._id] = value;
        return this;
    };
    WeakMap.prototype["delete"] = function(key) {
        if (this.has(key)) {
            delete this._guard(key)[this._id];
            return true;
        }
        return false;
    };
    WeakMap.prototype.has = function(key) {
        return !!this._guard(key)[this._id];
    };
    WeakMap.prototype._guard = function(key) {
        if (key !== Object(key)) throw TypeError('Value of WeakMap is not a non-null object.');
        return key;
    };
    return WeakMap;
}();
var $009163b5f902e248$export$2e2bcd8739ae039 = $009163b5f902e248$var$WeakMap;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Symbol factory






/**
 * Triangle shape
 * @inner
 */ var $ea44e91fc072e728$var$Triangle = $340211037b56ba3f$export$2e2bcd8739ae039.extend({
    type: 'triangle',
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function buildPath(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy + height);
        path.lineTo(cx - width, cy + height);
        path.closePath();
    }
});
/**
 * Diamond shape
 * @inner
 */ var $ea44e91fc072e728$var$Diamond = $340211037b56ba3f$export$2e2bcd8739ae039.extend({
    type: 'diamond',
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function buildPath(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy);
        path.lineTo(cx, cy + height);
        path.lineTo(cx - width, cy);
        path.closePath();
    }
});
/**
 * Pin shape
 * @inner
 */ var $ea44e91fc072e728$var$Pin = $340211037b56ba3f$export$2e2bcd8739ae039.extend({
    type: 'pin',
    shape: {
        // x, y on the cusp
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function buildPath(path, shape) {
        var x = shape.x;
        var y = shape.y;
        var w = shape.width / 5 * 3;
        // Height must be larger than width
        var h = Math.max(w, shape.height);
        var r = w / 2;
        // Dist on y with tangent point and circle center
        var dy = r * r / (h - r);
        var cy = y - h + r + dy;
        var angle = Math.asin(dy / r);
        // Dist on x with tangent point and circle center
        var dx = Math.cos(angle) * r;
        var tanX = Math.sin(angle);
        var tanY = Math.cos(angle);
        var cpLen = r * 0.6;
        var cpLen2 = r * 0.7;
        path.moveTo(x - dx, cy + dy);
        path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
        path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
        path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
        path.closePath();
    }
});
/**
 * Arrow shape
 * @inner
 */ var $ea44e91fc072e728$var$Arrow = $340211037b56ba3f$export$2e2bcd8739ae039.extend({
    type: 'arrow',
    shape: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function buildPath(ctx, shape) {
        var height = shape.height;
        var width = shape.width;
        var x = shape.x;
        var y = shape.y;
        var dx = width / 3 * 2;
        ctx.moveTo(x, y);
        ctx.lineTo(x + dx, y + height);
        ctx.lineTo(x, y + height / 4 * 3);
        ctx.lineTo(x - dx, y + height);
        ctx.lineTo(x, y);
        ctx.closePath();
    }
});
/**
 * Map of path constructors
 */ // TODO Use function to build symbol path.
var $ea44e91fc072e728$var$symbolCtors = {
    line: $b37b447960e3414d$export$2e2bcd8739ae039,
    rect: $dbd6d77105f10fb2$export$2e2bcd8739ae039,
    roundRect: $dbd6d77105f10fb2$export$2e2bcd8739ae039,
    square: $dbd6d77105f10fb2$export$2e2bcd8739ae039,
    circle: $f13962e4d5359f74$export$2e2bcd8739ae039,
    diamond: $ea44e91fc072e728$var$Diamond,
    pin: $ea44e91fc072e728$var$Pin,
    arrow: $ea44e91fc072e728$var$Arrow,
    triangle: $ea44e91fc072e728$var$Triangle
};
var $ea44e91fc072e728$var$symbolShapeMakers = {
    line: function line(x, y, w, h, shape) {
        shape.x1 = x;
        shape.y1 = y + h / 2;
        shape.x2 = x + w;
        shape.y2 = y + h / 2;
    },
    rect: function rect(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
    },
    roundRect: function roundRect(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
        shape.r = Math.min(w, h) / 4;
    },
    square: function square(x, y, w, h, shape) {
        var size = Math.min(w, h);
        shape.x = x;
        shape.y = y;
        shape.width = size;
        shape.height = size;
    },
    circle: function circle(x, y, w, h, shape) {
        // Put circle in the center of square
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.r = Math.min(w, h) / 2;
    },
    diamond: function diamond(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    pin: function pin(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    arrow: function arrow(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    triangle: function triangle(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    }
};
var $ea44e91fc072e728$export$33fc3b478d332725 = {};
(0, $f16f2994a32ad273$export$79b2f7037acddd43)($ea44e91fc072e728$var$symbolCtors, function(Ctor, name) {
    $ea44e91fc072e728$export$33fc3b478d332725[name] = new Ctor();
});
var $ea44e91fc072e728$var$SymbolClz = $340211037b56ba3f$export$2e2bcd8739ae039.extend({
    type: 'symbol',
    shape: {
        symbolType: '',
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    calculateTextPosition: function calculateTextPosition1(out, config, rect) {
        var res = (0, $3ad1e5e308f2a981$export$eee3603b512feab7)(out, config, rect);
        var shape = this.shape;
        if (shape && shape.symbolType === 'pin' && config.position === 'inside') res.y = rect.y + rect.height * 0.4;
        return res;
    },
    buildPath: function buildPath(ctx, shape, inBundle) {
        var symbolType = shape.symbolType;
        if (symbolType !== 'none') {
            var proxySymbol = $ea44e91fc072e728$export$33fc3b478d332725[symbolType];
            if (!proxySymbol) {
                // Default rect
                symbolType = 'rect';
                proxySymbol = $ea44e91fc072e728$export$33fc3b478d332725[symbolType];
            }
            $ea44e91fc072e728$var$symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
            proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
        }
    }
});
// Provide setColor helper method to avoid determine if set the fill or stroke outside
function $ea44e91fc072e728$var$symbolPathSetColor(color, innerColor) {
    if (this.type !== 'image') {
        var symbolStyle = this.style;
        if (this.__isEmptyBrush) {
            symbolStyle.stroke = color;
            symbolStyle.fill = innerColor || (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.neutral00;
            // TODO Same width with lineStyle in LineView
            symbolStyle.lineWidth = 2;
        } else if (this.shape.symbolType === 'line') symbolStyle.stroke = color;
        else symbolStyle.fill = color;
        this.markRedraw();
    }
}
function $ea44e91fc072e728$export$af050e04da3a02e8(symbolType, x, y, w, h, color, // whether to keep the ratio of w/h,
keepAspect) {
    // TODO Support image object, DynamicImage.
    var isEmpty = symbolType.indexOf('empty') === 0;
    if (isEmpty) symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
    var symbolPath;
    if (symbolType.indexOf('image://') === 0) symbolPath = $bce1f681c7fb2581$export$7a2bdede98851ac5(symbolType.slice(8), new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(x, y, w, h), keepAspect ? 'center' : 'cover');
    else if (symbolType.indexOf('path://') === 0) symbolPath = $bce1f681c7fb2581$export$aa9bab72412f5613(symbolType.slice(7), {}, new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(x, y, w, h), keepAspect ? 'center' : 'cover');
    else symbolPath = new $ea44e91fc072e728$var$SymbolClz({
        shape: {
            symbolType: symbolType,
            x: x,
            y: y,
            width: w,
            height: h
        }
    });
    symbolPath.__isEmptyBrush = isEmpty;
    // TODO Should deprecate setColor
    symbolPath.setColor = $ea44e91fc072e728$var$symbolPathSetColor;
    if (color) symbolPath.setColor(color);
    return symbolPath;
}
function $ea44e91fc072e728$export$a84524f03e8e8dfb(symbolSize) {
    if (!(0, $f16f2994a32ad273$export$43bee75e5e14138e)(symbolSize)) symbolSize = [
        +symbolSize,
        +symbolSize
    ];
    return [
        symbolSize[0] || 0,
        symbolSize[1] || 0
    ];
}
function $ea44e91fc072e728$export$e3e292895c033f6d(symbolOffset, symbolSize) {
    if (symbolOffset == null) return;
    if (!(0, $f16f2994a32ad273$export$43bee75e5e14138e)(symbolOffset)) symbolOffset = [
        symbolOffset,
        symbolOffset
    ];
    return [
        (0, $104896d282bd296f$export$e8514cb5a5e2b40f)(symbolOffset[0], symbolSize[0]) || 0,
        (0, $104896d282bd296f$export$e8514cb5a5e2b40f)((0, $f16f2994a32ad273$export$995e01f2f5c9d030)(symbolOffset[1], symbolOffset[0]), symbolSize[1]) || 0
    ];
}





function $c0cbdbca9100c9b3$var$isSafeNum(num) {
    return isFinite(num);
}
function $c0cbdbca9100c9b3$export$235c7ac50fe1db0a(ctx, obj, rect) {
    var x = obj.x == null ? 0 : obj.x;
    var x2 = obj.x2 == null ? 1 : obj.x2;
    var y = obj.y == null ? 0 : obj.y;
    var y2 = obj.y2 == null ? 0 : obj.y2;
    if (!obj.global) {
        x = x * rect.width + rect.x;
        x2 = x2 * rect.width + rect.x;
        y = y * rect.height + rect.y;
        y2 = y2 * rect.height + rect.y;
    }
    x = $c0cbdbca9100c9b3$var$isSafeNum(x) ? x : 0;
    x2 = $c0cbdbca9100c9b3$var$isSafeNum(x2) ? x2 : 1;
    y = $c0cbdbca9100c9b3$var$isSafeNum(y) ? y : 0;
    y2 = $c0cbdbca9100c9b3$var$isSafeNum(y2) ? y2 : 0;
    var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
    return canvasGradient;
}
function $c0cbdbca9100c9b3$export$57f098206d57a443(ctx, obj, rect) {
    var width = rect.width;
    var height = rect.height;
    var min = Math.min(width, height);
    var x = obj.x == null ? 0.5 : obj.x;
    var y = obj.y == null ? 0.5 : obj.y;
    var r = obj.r == null ? 0.5 : obj.r;
    if (!obj.global) {
        x = x * width + rect.x;
        y = y * height + rect.y;
        r = r * min;
    }
    x = $c0cbdbca9100c9b3$var$isSafeNum(x) ? x : 0.5;
    y = $c0cbdbca9100c9b3$var$isSafeNum(y) ? y : 0.5;
    r = r >= 0 && $c0cbdbca9100c9b3$var$isSafeNum(r) ? r : 0.5;
    var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
    return canvasGradient;
}
function $c0cbdbca9100c9b3$export$3dab6afd018d48c7(ctx, obj, rect) {
    var canvasGradient = obj.type === 'radial' ? $c0cbdbca9100c9b3$export$57f098206d57a443(ctx, obj, rect) : $c0cbdbca9100c9b3$export$235c7ac50fe1db0a(ctx, obj, rect);
    var colorStops = obj.colorStops;
    for(var i = 0; i < colorStops.length; i++)canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
    return canvasGradient;
}
function $c0cbdbca9100c9b3$export$beeddc5150cb2e83(clipPaths, prevClipPaths) {
    if (clipPaths === prevClipPaths || !clipPaths && !prevClipPaths) return false;
    if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) return true;
    for(var i = 0; i < clipPaths.length; i++){
        if (clipPaths[i] !== prevClipPaths[i]) return true;
    }
    return false;
}
function $c0cbdbca9100c9b3$var$parseInt10(val) {
    return parseInt(val, 10);
}
function $c0cbdbca9100c9b3$export$31b21d0167753bb4(root, whIdx, opts) {
    var wh = [
        'width',
        'height'
    ][whIdx];
    var cwh = [
        'clientWidth',
        'clientHeight'
    ][whIdx];
    var plt = [
        'paddingLeft',
        'paddingTop'
    ][whIdx];
    var prb = [
        'paddingRight',
        'paddingBottom'
    ][whIdx];
    if (opts[wh] != null && opts[wh] !== 'auto') return parseFloat(opts[wh]);
    var stl = document.defaultView.getComputedStyle(root);
    return (root[cwh] || $c0cbdbca9100c9b3$var$parseInt10(stl[wh]) || $c0cbdbca9100c9b3$var$parseInt10(root.style[wh])) - ($c0cbdbca9100c9b3$var$parseInt10(stl[plt]) || 0) - ($c0cbdbca9100c9b3$var$parseInt10(stl[prb]) || 0) || 0;
}







function $aad4ef1417b2b108$export$9efb2ae8a603855d(lineType, lineWidth) {
    if (!lineType || lineType === 'solid' || !(lineWidth > 0)) return null;
    return lineType === 'dashed' ? [
        4 * lineWidth,
        2 * lineWidth
    ] : lineType === 'dotted' ? [
        lineWidth
    ] : (0, $f16f2994a32ad273$export$7e4aa119212bc614)(lineType) ? [
        lineType
    ] : (0, $f16f2994a32ad273$export$43bee75e5e14138e)(lineType) ? lineType : null;
}
function $aad4ef1417b2b108$export$9d315911f153b3b2(el) {
    var style = el.style;
    var lineDash = style.lineDash && style.lineWidth > 0 && $aad4ef1417b2b108$export$9efb2ae8a603855d(style.lineDash, style.lineWidth);
    var lineDashOffset = style.lineDashOffset;
    if (lineDash) {
        var lineScale_1 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
        if (lineScale_1 && lineScale_1 !== 1) {
            lineDash = (0, $f16f2994a32ad273$export$871de8747c9eaa88)(lineDash, function(rawVal) {
                return rawVal / lineScale_1;
            });
            lineDashOffset /= lineScale_1;
        }
    }
    return [
        lineDash,
        lineDashOffset
    ];
}




var $831f6464611da010$var$pathProxyForDraw = new (0, $af4d02a47e9b6a35$export$2e2bcd8739ae039)(true);
function $831f6464611da010$var$styleHasStroke(style) {
    var stroke = style.stroke;
    return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
}
function $831f6464611da010$var$isValidStrokeFillStyle(strokeOrFill) {
    return typeof strokeOrFill === 'string' && strokeOrFill !== 'none';
}
function $831f6464611da010$var$styleHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== 'none';
}
function $831f6464611da010$var$doFillPath(ctx, style) {
    if (style.fillOpacity != null && style.fillOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.fillOpacity * style.opacity;
        ctx.fill();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.fill();
}
function $831f6464611da010$var$doStrokePath(ctx, style) {
    if (style.strokeOpacity != null && style.strokeOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.strokeOpacity * style.opacity;
        ctx.stroke();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.stroke();
}
function $831f6464611da010$export$8eb5db6b7bc27903(ctx, pattern, el) {
    var image = (0, $3e20f9b845f6268e$export$46c791b69ff9a0f)(pattern.image, pattern.__image, el);
    if ((0, $3e20f9b845f6268e$export$37ca7dd901d0236d)(image)) {
        var canvasPattern = ctx.createPattern(image, pattern.repeat || 'repeat');
        if (typeof DOMMatrix === 'function' && canvasPattern && canvasPattern.setTransform) {
            var matrix = new DOMMatrix();
            matrix.translateSelf(pattern.x || 0, pattern.y || 0);
            matrix.rotateSelf(0, 0, (pattern.rotation || 0) * (0, $f16f2994a32ad273$export$bce8e055322a0ce6));
            matrix.scaleSelf(pattern.scaleX || 1, pattern.scaleY || 1);
            canvasPattern.setTransform(matrix);
        }
        return canvasPattern;
    }
}
function $831f6464611da010$var$brushPath(ctx, el, style, canBatch, scope) {
    var _a;
    var hasStroke = $831f6464611da010$var$styleHasStroke(style);
    var hasFill = $831f6464611da010$var$styleHasFill(style);
    var strokePercent = style.strokePercent;
    var strokePart = strokePercent < 1;
    var firstDraw = !el.path;
    if ((!el.silent || strokePart) && firstDraw) el.createPathProxy();
    var path = el.path || $831f6464611da010$var$pathProxyForDraw;
    var dirtyFlag = el.__dirty;
    if (!canBatch) {
        var fill = style.fill;
        var stroke = style.stroke;
        var hasFillGradient = hasFill && !!fill.colorStops;
        var hasStrokeGradient = hasStroke && !!stroke.colorStops;
        var hasFillPattern = hasFill && !!fill.image;
        var hasStrokePattern = hasStroke && !!stroke.image;
        var fillGradient = void 0;
        var strokeGradient = void 0;
        var fillPattern = void 0;
        var strokePattern = void 0;
        var rect = void 0;
        if (hasFillGradient || hasStrokeGradient) rect = el.getBoundingRect();
        if (hasFillGradient) {
            fillGradient = dirtyFlag ? (0, $c0cbdbca9100c9b3$export$3dab6afd018d48c7)(ctx, fill, rect) : el.__canvasFillGradient;
            el.__canvasFillGradient = fillGradient;
        }
        if (hasStrokeGradient) {
            strokeGradient = dirtyFlag ? (0, $c0cbdbca9100c9b3$export$3dab6afd018d48c7)(ctx, stroke, rect) : el.__canvasStrokeGradient;
            el.__canvasStrokeGradient = strokeGradient;
        }
        if (hasFillPattern) {
            fillPattern = dirtyFlag || !el.__canvasFillPattern ? $831f6464611da010$export$8eb5db6b7bc27903(ctx, fill, el) : el.__canvasFillPattern;
            el.__canvasFillPattern = fillPattern;
        }
        if (hasStrokePattern) {
            strokePattern = dirtyFlag || !el.__canvasStrokePattern ? $831f6464611da010$export$8eb5db6b7bc27903(ctx, stroke, el) : el.__canvasStrokePattern;
            el.__canvasStrokePattern = strokePattern;
        }
        if (hasFillGradient) ctx.fillStyle = fillGradient;
        else if (hasFillPattern) {
            if (fillPattern) ctx.fillStyle = fillPattern;
            else hasFill = false;
        }
        if (hasStrokeGradient) ctx.strokeStyle = strokeGradient;
        else if (hasStrokePattern) {
            if (strokePattern) ctx.strokeStyle = strokePattern;
            else hasStroke = false;
        }
    }
    var scale = el.getGlobalScale();
    path.setScale(scale[0], scale[1], el.segmentIgnoreThreshold);
    var lineDash;
    var lineDashOffset;
    if (ctx.setLineDash && style.lineDash) _a = (0, $aad4ef1417b2b108$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
    var needsRebuild = true;
    if (firstDraw || dirtyFlag & (0, $66869c587f14f122$export$f75fe89a33ebe115)) {
        path.setDPR(ctx.dpr);
        if (strokePart) path.setContext(null);
        else {
            path.setContext(ctx);
            needsRebuild = false;
        }
        path.reset();
        el.buildPath(path, el.shape, canBatch);
        path.toStatic();
        el.pathUpdated();
    }
    if (needsRebuild) path.rebuildPath(ctx, strokePart ? strokePercent : 1);
    if (lineDash) {
        ctx.setLineDash(lineDash);
        ctx.lineDashOffset = lineDashOffset;
    }
    if (!canBatch) {
        if (style.strokeFirst) {
            if (hasStroke) $831f6464611da010$var$doStrokePath(ctx, style);
            if (hasFill) $831f6464611da010$var$doFillPath(ctx, style);
        } else {
            if (hasFill) $831f6464611da010$var$doFillPath(ctx, style);
            if (hasStroke) $831f6464611da010$var$doStrokePath(ctx, style);
        }
    } else {
        scope.batchFill = hasFill;
        scope.batchStroke = hasStroke;
    }
    if (lineDash) ctx.setLineDash([]);
}
function $831f6464611da010$var$brushImage(ctx, el, style) {
    var image = el.__image = (0, $3e20f9b845f6268e$export$46c791b69ff9a0f)(style.image, el.__image, el, el.onload);
    if (!image || !(0, $3e20f9b845f6268e$export$37ca7dd901d0236d)(image)) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var width = el.getWidth();
    var height = el.getHeight();
    var aspect = image.width / image.height;
    if (width == null && height != null) width = height * aspect;
    else if (height == null && width != null) height = width / aspect;
    else if (width == null && height == null) {
        width = image.width;
        height = image.height;
    }
    if (style.sWidth && style.sHeight) {
        var sx = style.sx || 0;
        var sy = style.sy || 0;
        ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
    } else if (style.sx && style.sy) {
        var sx = style.sx;
        var sy = style.sy;
        var sWidth = width - sx;
        var sHeight = height - sy;
        ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
    } else ctx.drawImage(image, x, y, width, height);
}
function $831f6464611da010$var$brushText(ctx, el, style) {
    var _a;
    var text = style.text;
    text != null && (text += '');
    if (text) {
        ctx.font = style.font || (0, $e4ffe803d17351c8$export$7d7a232b6d2cc80c);
        ctx.textAlign = style.textAlign;
        ctx.textBaseline = style.textBaseline;
        var lineDash = void 0;
        var lineDashOffset = void 0;
        if (ctx.setLineDash && style.lineDash) _a = (0, $aad4ef1417b2b108$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
        if (lineDash) {
            ctx.setLineDash(lineDash);
            ctx.lineDashOffset = lineDashOffset;
        }
        if (style.strokeFirst) {
            if ($831f6464611da010$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
            if ($831f6464611da010$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
        } else {
            if ($831f6464611da010$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
            if ($831f6464611da010$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
        }
        if (lineDash) ctx.setLineDash([]);
    }
}
var $831f6464611da010$var$SHADOW_NUMBER_PROPS = [
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
var $831f6464611da010$var$STROKE_PROPS = [
    [
        'lineCap',
        'butt'
    ],
    [
        'lineJoin',
        'miter'
    ],
    [
        'miterLimit',
        10
    ]
];
function $831f6464611da010$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope) {
    var styleChanged = false;
    if (!forceSetAll) {
        prevStyle = prevStyle || {};
        if (style === prevStyle) return false;
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        $831f6464611da010$var$flushPathDrawn(ctx, scope);
        styleChanged = true;
        var opacity = Math.max(Math.min(style.opacity, 1), 0);
        ctx.globalAlpha = isNaN(opacity) ? (0, $0a0ef4888a4b4e90$export$737672163db00fe3).opacity : opacity;
    }
    if (forceSetAll || style.blend !== prevStyle.blend) {
        if (!styleChanged) {
            $831f6464611da010$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalCompositeOperation = style.blend || (0, $0a0ef4888a4b4e90$export$737672163db00fe3).blend;
    }
    for(var i = 0; i < $831f6464611da010$var$SHADOW_NUMBER_PROPS.length; i++){
        var propName = $831f6464611da010$var$SHADOW_NUMBER_PROPS[i];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $831f6464611da010$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = ctx.dpr * (style[propName] || 0);
        }
    }
    if (forceSetAll || style.shadowColor !== prevStyle.shadowColor) {
        if (!styleChanged) {
            $831f6464611da010$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.shadowColor = style.shadowColor || (0, $0a0ef4888a4b4e90$export$737672163db00fe3).shadowColor;
    }
    return styleChanged;
}
function $831f6464611da010$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetAll, scope) {
    var style = el.style;
    var prevStyle = forceSetAll ? null : prevEl && prevEl.style || {};
    if (style === prevStyle) return false;
    var styleChanged = $831f6464611da010$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope);
    if (forceSetAll || style.fill !== prevStyle.fill) {
        if (!styleChanged) {
            $831f6464611da010$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $831f6464611da010$var$isValidStrokeFillStyle(style.fill) && (ctx.fillStyle = style.fill);
    }
    if (forceSetAll || style.stroke !== prevStyle.stroke) {
        if (!styleChanged) {
            $831f6464611da010$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $831f6464611da010$var$isValidStrokeFillStyle(style.stroke) && (ctx.strokeStyle = style.stroke);
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        if (!styleChanged) {
            $831f6464611da010$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
    }
    if (el.hasStroke()) {
        var lineWidth = style.lineWidth;
        var newLineWidth = lineWidth / (style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1);
        if (ctx.lineWidth !== newLineWidth) {
            if (!styleChanged) {
                $831f6464611da010$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.lineWidth = newLineWidth;
        }
    }
    for(var i = 0; i < $831f6464611da010$var$STROKE_PROPS.length; i++){
        var prop = $831f6464611da010$var$STROKE_PROPS[i];
        var propName = prop[0];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $831f6464611da010$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = style[propName] || prop[1];
        }
    }
    return styleChanged;
}
function $831f6464611da010$var$bindImageStyle(ctx, el, prevEl, forceSetAll, scope) {
    return $831f6464611da010$var$bindCommonProps(ctx, el.style, prevEl && prevEl.style, forceSetAll, scope);
}
function $831f6464611da010$var$setContextTransform(ctx, el) {
    var m = el.transform;
    var dpr = ctx.dpr || 1;
    if (m) ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
    else ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
}
function $831f6464611da010$var$updateClipStatus(clipPaths, ctx, scope) {
    var allClipped = false;
    for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        allClipped = allClipped || clipPath.isZeroArea();
        $831f6464611da010$var$setContextTransform(ctx, clipPath);
        ctx.beginPath();
        clipPath.buildPath(ctx, clipPath.shape);
        ctx.clip();
    }
    scope.allClipped = allClipped;
}
function $831f6464611da010$var$isTransformChanged(m0, m1) {
    if (m0 && m1) return m0[0] !== m1[0] || m0[1] !== m1[1] || m0[2] !== m1[2] || m0[3] !== m1[3] || m0[4] !== m1[4] || m0[5] !== m1[5];
    else if (!m0 && !m1) return false;
    return true;
}
var $831f6464611da010$var$DRAW_TYPE_PATH = 1;
var $831f6464611da010$var$DRAW_TYPE_IMAGE = 2;
var $831f6464611da010$var$DRAW_TYPE_TEXT = 3;
var $831f6464611da010$var$DRAW_TYPE_INCREMENTAL = 4;
function $831f6464611da010$var$canPathBatch(style) {
    var hasFill = $831f6464611da010$var$styleHasFill(style);
    var hasStroke = $831f6464611da010$var$styleHasStroke(style);
    return !(style.lineDash || !(+hasFill ^ +hasStroke) || hasFill && typeof style.fill !== 'string' || hasStroke && typeof style.stroke !== 'string' || style.strokePercent < 1 || style.strokeOpacity < 1 || style.fillOpacity < 1);
}
function $831f6464611da010$var$flushPathDrawn(ctx, scope) {
    if (scope.batchFill) {
        scope.batchFill = false;
        ctx.fill();
    }
    if (scope.batchStroke) {
        scope.batchStroke = false;
        ctx.stroke();
    }
}
function $831f6464611da010$export$567881adfc3eb7f3(ctx, el) {
    var scope = {
        inHover: false,
        viewWidth: 0,
        viewHeight: 0,
        beforeBrushParam: {}
    };
    $831f6464611da010$export$da5d6544e8c27bc1(ctx, el, scope);
    $831f6464611da010$export$aa9c98b43779289a(ctx, scope);
}
function $831f6464611da010$export$da5d6544e8c27bc1(ctx, el, scope) {
    var m = el.transform;
    if (!el.shouldBePainted(scope.viewWidth, scope.viewHeight, false, false)) {
        el.__dirty &= ~(0, $66869c587f14f122$export$a7b6db622c6c7dbd);
        el.__isRendered = false;
        return;
    }
    var clipPaths = el.__clipPaths;
    var prevElClipPaths = scope.prevElClipPaths;
    var style = el.style;
    var forceSetTransform = false;
    var forceSetStyle = false;
    if (!prevElClipPaths || (0, $c0cbdbca9100c9b3$export$beeddc5150cb2e83)(clipPaths, prevElClipPaths)) {
        if (prevElClipPaths) {
            $831f6464611da010$var$flushPathDrawn(ctx, scope);
            ctx.restore();
            forceSetStyle = forceSetTransform = true;
            scope.prevElClipPaths = null;
            scope.allClipped = false;
            scope.prevEl = null;
        }
        if (clipPaths && clipPaths.length) {
            $831f6464611da010$var$flushPathDrawn(ctx, scope);
            ctx.save();
            $831f6464611da010$var$updateClipStatus(clipPaths, ctx, scope);
            forceSetTransform = true;
            scope.prevElClipPaths = clipPaths;
        }
    }
    if (scope.allClipped) {
        el.__dirty &= ~(0, $66869c587f14f122$export$a7b6db622c6c7dbd);
        el.__isRendered = false;
        return;
    }
    el.beforeBrush && el.beforeBrush(scope.beforeBrushParam);
    el.innerBeforeBrush();
    var prevEl = scope.prevEl;
    if (!prevEl) forceSetStyle = forceSetTransform = true;
    var canBatchPath = el instanceof (0, $340211037b56ba3f$export$2e2bcd8739ae039) && el.autoBatch && $831f6464611da010$var$canPathBatch(style);
    if (forceSetTransform || $831f6464611da010$var$isTransformChanged(m, prevEl.transform)) {
        $831f6464611da010$var$flushPathDrawn(ctx, scope);
        $831f6464611da010$var$setContextTransform(ctx, el);
    } else if (!canBatchPath) $831f6464611da010$var$flushPathDrawn(ctx, scope);
    if (el instanceof (0, $340211037b56ba3f$export$2e2bcd8739ae039)) {
        if (scope.lastDrawType !== $831f6464611da010$var$DRAW_TYPE_PATH) {
            forceSetStyle = true;
            scope.lastDrawType = $831f6464611da010$var$DRAW_TYPE_PATH;
        }
        $831f6464611da010$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
        if (!canBatchPath || !scope.batchFill && !scope.batchStroke) ctx.beginPath();
        $831f6464611da010$var$brushPath(ctx, el, style, canBatchPath, scope);
    } else {
        if (el instanceof (0, $df36fca73018b9d2$export$2e2bcd8739ae039)) {
            if (scope.lastDrawType !== $831f6464611da010$var$DRAW_TYPE_TEXT) {
                forceSetStyle = true;
                scope.lastDrawType = $831f6464611da010$var$DRAW_TYPE_TEXT;
            }
            $831f6464611da010$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
            $831f6464611da010$var$brushText(ctx, el, style);
        } else if (el instanceof (0, $0eafea320dbd53c3$export$2e2bcd8739ae039)) {
            if (scope.lastDrawType !== $831f6464611da010$var$DRAW_TYPE_IMAGE) {
                forceSetStyle = true;
                scope.lastDrawType = $831f6464611da010$var$DRAW_TYPE_IMAGE;
            }
            $831f6464611da010$var$bindImageStyle(ctx, el, prevEl, forceSetStyle, scope);
            $831f6464611da010$var$brushImage(ctx, el, style);
        } else if (el.getTemporalDisplayables) {
            if (scope.lastDrawType !== $831f6464611da010$var$DRAW_TYPE_INCREMENTAL) {
                forceSetStyle = true;
                scope.lastDrawType = $831f6464611da010$var$DRAW_TYPE_INCREMENTAL;
            }
            $831f6464611da010$var$brushIncremental(ctx, el, scope);
        }
    }
    el.innerAfterBrush();
    if (el.afterBrush) {
        if (canBatchPath) $831f6464611da010$var$flushPathDrawn(ctx, scope);
        el.afterBrush();
    }
    scope.prevEl = el;
    el.__dirty = 0;
    el.__isRendered = true;
}
function $831f6464611da010$export$aa9c98b43779289a(ctx, scope) {
    $831f6464611da010$var$flushPathDrawn(ctx, scope);
    if (scope.prevElClipPaths) ctx.restore();
}
function $831f6464611da010$var$brushIncremental(ctx, el, scope) {
    var displayables = el.getDisplayables();
    var temporalDisplayables = el.getTemporalDisplayables();
    ctx.save();
    var innerScope = {
        prevElClipPaths: null,
        prevEl: null,
        allClipped: false,
        viewWidth: scope.viewWidth,
        viewHeight: scope.viewHeight,
        inHover: scope.inHover,
        beforeBrushParam: {}
    };
    var i;
    var len;
    for(i = el.getCursor(), len = displayables.length; i < len; i++){
        var displayable = displayables[i];
        displayable.beforeBrush && displayable.beforeBrush(scope.beforeBrushParam);
        displayable.innerBeforeBrush();
        $831f6464611da010$export$da5d6544e8c27bc1(ctx, displayable, innerScope);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    $831f6464611da010$export$aa9c98b43779289a(ctx, innerScope);
    for(var i_1 = 0, len_1 = temporalDisplayables.length; i_1 < len_1; i_1++){
        var displayable = temporalDisplayables[i_1];
        displayable.beforeBrush && displayable.beforeBrush(scope.beforeBrushParam);
        displayable.innerBeforeBrush();
        $831f6464611da010$export$da5d6544e8c27bc1(ctx, displayable, innerScope);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    $831f6464611da010$export$aa9c98b43779289a(ctx, innerScope);
    el.clearTemporalDisplayables();
    el.notClear = true;
    ctx.restore();
}



var $f7e596ba18057d67$var$decalMap = new (0, $009163b5f902e248$export$2e2bcd8739ae039)();
var $f7e596ba18057d67$var$decalCache = new (0, $5673a7dd695e5835$export$2e2bcd8739ae039)(100);
var $f7e596ba18057d67$var$decalKeys = [
    'symbol',
    'symbolSize',
    'symbolKeepAspect',
    'color',
    'backgroundColor',
    'dashArrayX',
    'dashArrayY',
    'maxTileWidth',
    'maxTileHeight'
];
function $f7e596ba18057d67$export$a3ba048e1a648972(decalObject, api) {
    if (decalObject === 'none') return null;
    var dpr = api.getDevicePixelRatio();
    var zr = api.getZr();
    var isSVG = zr.painter.type === 'svg';
    if (decalObject.dirty) $f7e596ba18057d67$var$decalMap["delete"](decalObject);
    var oldPattern = $f7e596ba18057d67$var$decalMap.get(decalObject);
    if (oldPattern) return oldPattern;
    var decalOpt = (0, $f16f2994a32ad273$export$ebe90cb607ad99e)(decalObject, {
        symbol: 'rect',
        symbolSize: 1,
        symbolKeepAspect: true,
        color: 'rgba(0, 0, 0, 0.2)',
        backgroundColor: null,
        dashArrayX: 5,
        dashArrayY: 5,
        rotation: 0,
        maxTileWidth: 512,
        maxTileHeight: 512
    });
    if (decalOpt.backgroundColor === 'none') decalOpt.backgroundColor = null;
    var pattern = {
        repeat: 'repeat'
    };
    setPatternnSource(pattern);
    pattern.rotation = decalOpt.rotation;
    pattern.scaleX = pattern.scaleY = isSVG ? 1 : 1 / dpr;
    $f7e596ba18057d67$var$decalMap.set(decalObject, pattern);
    decalObject.dirty = false;
    return pattern;
    function setPatternnSource(pattern) {
        var keys = [
            dpr
        ];
        var isValidKey = true;
        for(var i = 0; i < $f7e596ba18057d67$var$decalKeys.length; ++i){
            var value = decalOpt[$f7e596ba18057d67$var$decalKeys[i]];
            if (value != null && !(0, $f16f2994a32ad273$export$43bee75e5e14138e)(value) && !(0, $f16f2994a32ad273$export$844ec244b1367d54)(value) && !(0, $f16f2994a32ad273$export$7e4aa119212bc614)(value) && typeof value !== 'boolean') {
                isValidKey = false;
                break;
            }
            keys.push(value);
        }
        var cacheKey;
        if (isValidKey) {
            cacheKey = keys.join(',') + (isSVG ? '-svg' : '');
            var cache = $f7e596ba18057d67$var$decalCache.get(cacheKey);
            if (cache) isSVG ? pattern.svgElement = cache : pattern.image = cache;
        }
        var dashArrayX = $f7e596ba18057d67$var$normalizeDashArrayX(decalOpt.dashArrayX);
        var dashArrayY = $f7e596ba18057d67$var$normalizeDashArrayY(decalOpt.dashArrayY);
        var symbolArray = $f7e596ba18057d67$var$normalizeSymbolArray(decalOpt.symbol);
        var lineBlockLengthsX = $f7e596ba18057d67$var$getLineBlockLengthX(dashArrayX);
        var lineBlockLengthY = $f7e596ba18057d67$var$getLineBlockLengthY(dashArrayY);
        var canvas = !isSVG && (0, $e4ffe803d17351c8$export$ef5e599365494451).createCanvas();
        var svgRoot = isSVG && {
            tag: 'g',
            attrs: {},
            key: 'dcl',
            children: []
        };
        var pSize = getPatternSize();
        var ctx;
        if (canvas) {
            canvas.width = pSize.width * dpr;
            canvas.height = pSize.height * dpr;
            ctx = canvas.getContext('2d');
        }
        brushDecal();
        if (isValidKey) $f7e596ba18057d67$var$decalCache.put(cacheKey, canvas || svgRoot);
        pattern.image = canvas;
        pattern.svgElement = svgRoot;
        pattern.svgWidth = pSize.width;
        pattern.svgHeight = pSize.height;
        /**
     * Get minimum length that can make a repeatable pattern.
     *
     * @return {Object} pattern width and height
     */ function getPatternSize() {
            /**
       * For example, if dash is [[3, 2], [2, 1]] for X, it looks like
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * So the minimum length of X is 15,
       * which is the least common multiple of `3 + 2` and `2 + 1`
       * |---  ---  ---  |---  --- ...
       * |-- -- -- -- -- |-- -- -- ...
       */ var width = 1;
            for(var i = 0, xlen = lineBlockLengthsX.length; i < xlen; ++i)width = (0, $104896d282bd296f$export$680a45b749323f49)(width, lineBlockLengthsX[i]);
            var symbolRepeats = 1;
            for(var i = 0, xlen = symbolArray.length; i < xlen; ++i)symbolRepeats = (0, $104896d282bd296f$export$680a45b749323f49)(symbolRepeats, symbolArray[i].length);
            width *= symbolRepeats;
            var height = lineBlockLengthY * lineBlockLengthsX.length * symbolArray.length;
            var warn;
            return {
                width: Math.max(1, Math.min(width, decalOpt.maxTileWidth)),
                height: Math.max(1, Math.min(height, decalOpt.maxTileHeight))
            };
        }
        function brushDecal() {
            if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                if (decalOpt.backgroundColor) {
                    ctx.fillStyle = decalOpt.backgroundColor;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                }
            }
            var ySum = 0;
            for(var i = 0; i < dashArrayY.length; ++i)ySum += dashArrayY[i];
            if (ySum <= 0) // dashArrayY is 0, draw nothing
            return;
            var y = -lineBlockLengthY;
            var yId = 0;
            var yIdTotal = 0;
            var xId0 = 0;
            while(y < pSize.height){
                if (yId % 2 === 0) {
                    var symbolYId = yIdTotal / 2 % symbolArray.length;
                    var x = 0;
                    var xId1 = 0;
                    var xId1Total = 0;
                    while(x < pSize.width * 2){
                        var xSum = 0;
                        for(var i = 0; i < dashArrayX[xId0].length; ++i)xSum += dashArrayX[xId0][i];
                        if (xSum <= 0) break;
                        // E.g., [15, 5, 20, 5] draws only for 15 and 20
                        if (xId1 % 2 === 0) {
                            var size = (1 - decalOpt.symbolSize) * 0.5;
                            var left = x + dashArrayX[xId0][xId1] * size;
                            var top_1 = y + dashArrayY[yId] * size;
                            var width = dashArrayX[xId0][xId1] * decalOpt.symbolSize;
                            var height = dashArrayY[yId] * decalOpt.symbolSize;
                            var symbolXId = xId1Total / 2 % symbolArray[symbolYId].length;
                            brushSymbol(left, top_1, width, height, symbolArray[symbolYId][symbolXId]);
                        }
                        x += dashArrayX[xId0][xId1];
                        ++xId1Total;
                        ++xId1;
                        if (xId1 === dashArrayX[xId0].length) xId1 = 0;
                    }
                    ++xId0;
                    if (xId0 === dashArrayX.length) xId0 = 0;
                }
                y += dashArrayY[yId];
                ++yIdTotal;
                ++yId;
                if (yId === dashArrayY.length) yId = 0;
            }
            function brushSymbol(x, y, width, height, symbolType) {
                var scale = isSVG ? 1 : dpr;
                var symbol = (0, $ea44e91fc072e728$export$af050e04da3a02e8)(symbolType, x * scale, y * scale, width * scale, height * scale, decalOpt.color, decalOpt.symbolKeepAspect);
                if (isSVG) {
                    var symbolVNode = zr.painter.renderOneToVNode(symbol);
                    if (symbolVNode) svgRoot.children.push(symbolVNode);
                } else // Paint to canvas for all other renderers.
                (0, $831f6464611da010$export$567881adfc3eb7f3)(ctx, symbol);
            }
        }
    }
}
/**
 * Convert symbol array into normalized array
 *
 * @param {string | (string | string[])[]} symbol symbol input
 * @return {string[][]} normolized symbol array
 */ function $f7e596ba18057d67$var$normalizeSymbolArray(symbol) {
    if (!symbol || symbol.length === 0) return [
        [
            'rect'
        ]
    ];
    if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(symbol)) return [
        [
            symbol
        ]
    ];
    var isAllString = true;
    for(var i = 0; i < symbol.length; ++i)if (!(0, $f16f2994a32ad273$export$844ec244b1367d54)(symbol[i])) {
        isAllString = false;
        break;
    }
    if (isAllString) return $f7e596ba18057d67$var$normalizeSymbolArray([
        symbol
    ]);
    var result = [];
    for(var i = 0; i < symbol.length; ++i)if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(symbol[i])) result.push([
        symbol[i]
    ]);
    else result.push(symbol[i]);
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayX} dash dash input
 * @return {number[][]} normolized dash array
 */ function $f7e596ba18057d67$var$normalizeDashArrayX(dash) {
    if (!dash || dash.length === 0) return [
        [
            0,
            0
        ]
    ];
    if ((0, $f16f2994a32ad273$export$7e4aa119212bc614)(dash)) {
        var dashValue = Math.ceil(dash);
        return [
            [
                dashValue,
                dashValue
            ]
        ];
    }
    /**
   * [20, 5] should be normalized into [[20, 5]],
   * while [20, [5, 10]] should be normalized into [[20, 20], [5, 10]]
   */ var isAllNumber = true;
    for(var i = 0; i < dash.length; ++i)if (!(0, $f16f2994a32ad273$export$7e4aa119212bc614)(dash[i])) {
        isAllNumber = false;
        break;
    }
    if (isAllNumber) return $f7e596ba18057d67$var$normalizeDashArrayX([
        dash
    ]);
    var result = [];
    for(var i = 0; i < dash.length; ++i)if ((0, $f16f2994a32ad273$export$7e4aa119212bc614)(dash[i])) {
        var dashValue = Math.ceil(dash[i]);
        result.push([
            dashValue,
            dashValue
        ]);
    } else {
        var dashValue = (0, $f16f2994a32ad273$export$871de8747c9eaa88)(dash[i], function(n) {
            return Math.ceil(n);
        });
        if (dashValue.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
        // so normalize it to be [4, 2, 1, 4, 2, 1]
        result.push(dashValue.concat(dashValue));
        else result.push(dashValue);
    }
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayY} dash dash input
 * @return {number[]} normolized dash array
 */ function $f7e596ba18057d67$var$normalizeDashArrayY(dash) {
    if (!dash || (typeof dash === "undefined" ? "undefined" : (0, $7E0eS._)(dash)) === 'object' && dash.length === 0) return [
        0,
        0
    ];
    if ((0, $f16f2994a32ad273$export$7e4aa119212bc614)(dash)) {
        var dashValue_1 = Math.ceil(dash);
        return [
            dashValue_1,
            dashValue_1
        ];
    }
    var dashValue = (0, $f16f2994a32ad273$export$871de8747c9eaa88)(dash, function(n) {
        return Math.ceil(n);
    });
    return dash.length % 2 ? dashValue.concat(dashValue) : dashValue;
}
/**
 * Get block length of each line. A block is the length of dash line and space.
 * For example, a line with [4, 1] has a dash line of 4 and a space of 1 after
 * that, so the block length of this line is 5.
 *
 * @param {number[][]} dash dash array of X or Y
 * @return {number[]} block length of each line
 */ function $f7e596ba18057d67$var$getLineBlockLengthX(dash) {
    return (0, $f16f2994a32ad273$export$871de8747c9eaa88)(dash, function(line) {
        return $f7e596ba18057d67$var$getLineBlockLengthY(line);
    });
}
function $f7e596ba18057d67$var$getLineBlockLengthY(dash) {
    var blockLength = 0;
    for(var i = 0; i < dash.length; ++i)blockLength += dash[i];
    if (dash.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
    // So total length is (4 + 2 + 1) * 2
    return blockLength * 2;
    return blockLength;
}



var $c75a18ad5ca7e90c$export$218eea02a2a96fb4 = (0, $3fa81475350067fd$export$d62c61cad9d1ab83)($c75a18ad5ca7e90c$var$decalVisual);
function $c75a18ad5ca7e90c$var$decalVisual(ecModel, api) {
    ecModel.eachRawSeries(function(seriesModel) {
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        if (data.hasItemVisual()) data.each(function(idx) {
            var decal = data.getItemVisual(idx, 'decal');
            if (decal) {
                var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                itemStyle.decal = (0, $f7e596ba18057d67$export$a3ba048e1a648972)(decal, api);
            }
        });
        var decal = data.getVisual('decal');
        if (decal) {
            var style = data.getVisual('style');
            style.decal = (0, $f7e596ba18057d67$export$a3ba048e1a648972)(decal, api);
        }
    });
}


var $ef39f475dab603c1$export$83d89fbfd8236492 = '6.1.0';
var $ef39f475dab603c1$export$b74ff737e0e298b5 = {
    zrender: '6.1.0'
};
var $ef39f475dab603c1$var$TEST_FRAME_REMAIN_TIME = 1;
var $ef39f475dab603c1$var$PRIORITY_PROCESSOR_SERIES_FILTER = 800;
// In the current impl, "data stack" will modifies the original "series data extent". Some data
// processors rely on the stack result dimension to calculate extents. So data stack
// should be in front of other data processors.
var $ef39f475dab603c1$var$PRIORITY_PROCESSOR_DATASTACK = 900;
// AXIS_STATISTICS should be after SERIES_FILTER, as it may change the statistics result (like min gap).
// AXIS_STATISTICS should be before filter (dataZoom), as dataZoom require the result in "containShape" calculation.
var $ef39f475dab603c1$var$PRIORITY_PROCESSOR_AXIS_STATISTICS = 920;
// `PRIORITY_PROCESSOR_FILTER` is typically used by `dataZoom` (see `AxisProxy`), which relies
// on the initialized "axis extent".
var $ef39f475dab603c1$var$PRIORITY_PROCESSOR_FILTER = 1000;
var $ef39f475dab603c1$var$PRIORITY_PROCESSOR_DEFAULT = 2000;
var $ef39f475dab603c1$var$PRIORITY_PROCESSOR_STATISTICS = 5000;
// NOTICE: Data processors above block the stream (especially time-consuming processors like data filters).
var $ef39f475dab603c1$var$PRIORITY_VISUAL_LAYOUT = 1000;
var $ef39f475dab603c1$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
var $ef39f475dab603c1$var$PRIORITY_VISUAL_GLOBAL = 2000;
var $ef39f475dab603c1$var$PRIORITY_VISUAL_CHART = 3000;
var $ef39f475dab603c1$var$PRIORITY_VISUAL_COMPONENT = 4000;
// Visual property in data. Greater than `PRIORITY_VISUAL_COMPONENT` to enable to
// overwrite the visual result of component (like `visualMap`)
// using data item specific setting (like itemStyle.xxx on data item)
var $ef39f475dab603c1$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM = 4500;
// Greater than `PRIORITY_VISUAL_CHART_DATA_CUSTOM` to enable to layout based on
// visual result like `symbolSize`.
var $ef39f475dab603c1$var$PRIORITY_VISUAL_POST_CHART_LAYOUT = 4600;
var $ef39f475dab603c1$var$PRIORITY_VISUAL_BRUSH = 5000;
var $ef39f475dab603c1$var$PRIORITY_VISUAL_ARIA = 6000;
var $ef39f475dab603c1$var$PRIORITY_VISUAL_DECAL = 7000;
var $ef39f475dab603c1$export$bb34f3538ba26c7e = {
    PROCESSOR: {
        SERIES_FILTER: $ef39f475dab603c1$var$PRIORITY_PROCESSOR_SERIES_FILTER,
        AXIS_STATISTICS: $ef39f475dab603c1$var$PRIORITY_PROCESSOR_AXIS_STATISTICS,
        FILTER: $ef39f475dab603c1$var$PRIORITY_PROCESSOR_FILTER,
        STATISTIC: $ef39f475dab603c1$var$PRIORITY_PROCESSOR_STATISTICS,
        STATISTICS: $ef39f475dab603c1$var$PRIORITY_PROCESSOR_STATISTICS
    },
    VISUAL: {
        LAYOUT: $ef39f475dab603c1$var$PRIORITY_VISUAL_LAYOUT,
        PROGRESSIVE_LAYOUT: $ef39f475dab603c1$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
        GLOBAL: $ef39f475dab603c1$var$PRIORITY_VISUAL_GLOBAL,
        CHART: $ef39f475dab603c1$var$PRIORITY_VISUAL_CHART,
        POST_CHART_LAYOUT: $ef39f475dab603c1$var$PRIORITY_VISUAL_POST_CHART_LAYOUT,
        COMPONENT: $ef39f475dab603c1$var$PRIORITY_VISUAL_COMPONENT,
        BRUSH: $ef39f475dab603c1$var$PRIORITY_VISUAL_BRUSH,
        CHART_ITEM: $ef39f475dab603c1$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM,
        ARIA: $ef39f475dab603c1$var$PRIORITY_VISUAL_ARIA,
        DECAL: $ef39f475dab603c1$var$PRIORITY_VISUAL_DECAL
    }
};
/**
 * @tutorial [EC_CYCLE] (ec updating/rendering cycles):
 *
 *  - Common Rules:
 *    - Nested entry is not allowed. If triggering a new run of EC_CYCLE during a
 *      unfinished run, the new run will be delayed until the current run finishes
 *      (if triggered by `dispatchAction`), or throw error (if triggered by other API calls).
 *    - All user-visible ec events are triggered outside EC_CYCLE.
 *      (i.e. be triggered after `this[IN_EC_CYCLE_KEY]` becoming `false`).
 *
 *  - [EC_FULL_UPDATE_CYCLE]:
 *    - It designates a run of a series of processing/updating/rendering.
 *    - It is triggered by:
 *      - `setOption`
 *      - `dispatchAction`
 *        (It is typically internally triggered by user inputs; but can also an explicit API call.)
 *      - `resize`
 *      - The next "animation frame" if in `lazyMode: true`.
 *    - A run of EC_FULL_UPDATE_CYCLE comprises:
 *      - EC_PREPARE (may be absent)
 *      - EC_FULL_UPDATE:
 *        - CoordinateSystem['create']
 *        - Data processing (may be absent) (see `registerProcessor`)
 *        - CoordinateSystem['update'] (may be absent)
 *        - Visual encoding (may be absent) (see `registerVisual`)
 *        - Layout (may be absent) (see `registerLayout`)
 *        - Rendering (`ComponentView` or `SeriesView`)
 *
 *  - [EC_PARTIAL_UPDATE_CYCLE]s:
 *      - They are shortcuts for performance.
 *      - They are triggered by:
 *        - `dispatchAction`
 *      - These steps are typically omitted:
 *        - No EC_PREPARE
 *        - No CoordinateSystem['create'] and CoordinateSystem['update']
 *      - They require careful implementation, otherwise inconsistency may be introduced.
 *
 *  - [EC_PROGRESSIVE_CYCLE]:
 *    - It also carries out a series of processing/updating/rendering.
 *    - It is performed in each subsequent "animation frame" until finished.
 *    - It can be triggered by EC_FULL_UPDATE_CYCLE, EC_PARTIAL_UPDATE_CYCLE or EC_APPEND_DATA_CYCLE.
 *    - A run of EC_PROGRESSIVE_CYCLE comprises:
 *      - Data processing (may be absent) (see `registerProcessor`)
 *      - Visual encoding (may be absent) (see `registerVisual`)
 *      - Layout (may be absent) (see `registerLayout`)
 *      - Rendering (`ComponentView` or `SeriesView`)
 *    - PENDING: currently all data processing tasks (via `registerProcessor`) run in "block" mode.
 *      (see `performDataProcessorTasks`).
 *
 *  - [EC_APPEND_DATA_CYCLE]:
 *    - See `appendData`. It is only supported for some special cases.
 *
 *  - [SERIES_SPECIFIC_CYCLE]s:
 *    - Series may have specific update/render cycles. For example, graph force layout performs
 *      layout and rendering in each "animation frame".
 *
 *  - Model updating:
 *    - Model can only be modified at the beginning of ec cycles, including only:
 *      - EC_PREPARE (see method `prepare()`) in `setOption` call.
 *      - EC action handlers in `dispatchAction` call.
 *      - `appendData` (a special case, where only data can be modified).
 *
 *  - The lifetime of CoordinateSystem/Axis/Scale instances:
 *    - They are only re-created per run of EC_FULL_UPDATE_CYCLE.
 *
 *  - Global caches: see `cycleCache.ts`
 */ // See comments in EC_CYCLE.
var $ef39f475dab603c1$var$IN_EC_CYCLE_KEY = '__flagInMainProcess';
// Useful for detecting outdated rendering results for the following scenarios:
//  - In EC_PARTIAL_UPDATE_CYCLE, some rendering may be skipped.
//  - Asynchronously update rendered view (e.g., graph force layout).
//  - Multiple ChartView/ComponentView render to one group cooperatively.
var $ef39f475dab603c1$var$EC_UPDATE_CYCLE_VERSION_KEY = '__mainProcessVersion';
var $ef39f475dab603c1$var$PENDING_UPDATE = '__pendingUpdate';
var $ef39f475dab603c1$var$STATUS_NEEDS_UPDATE_KEY = '__needsUpdateStatus';
var $ef39f475dab603c1$var$ACTION_REG = /^[a-zA-Z0-9_]+$/;
var $ef39f475dab603c1$var$CONNECT_STATUS_KEY = '__connectUpdateStatus';
var $ef39f475dab603c1$var$CONNECT_STATUS_PENDING = 0;
var $ef39f475dab603c1$var$CONNECT_STATUS_UPDATING = 1;
var $ef39f475dab603c1$var$CONNECT_STATUS_UPDATED = 2;
function $ef39f475dab603c1$var$createRegisterEventWithLowercaseECharts(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.isDisposed()) {
            $ef39f475dab603c1$var$disposedWarning(this.id);
            return;
        }
        return $ef39f475dab603c1$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $ef39f475dab603c1$var$createRegisterEventWithLowercaseMessageCenter(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $ef39f475dab603c1$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $ef39f475dab603c1$var$toLowercaseNameAndCallEventful(host, method, args) {
    // `args[0]` is event name. Event name is all lowercase.
    args[0] = args[0] && args[0].toLowerCase();
    return (0, $83f1d7c1143fe0f3$export$2e2bcd8739ae039).prototype[method].apply(host, args);
}
var $ef39f475dab603c1$var$MessageCenter = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(MessageCenter, _super);
    function MessageCenter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MessageCenter;
}((0, $83f1d7c1143fe0f3$export$2e2bcd8739ae039));
var $ef39f475dab603c1$var$messageCenterProto = $ef39f475dab603c1$var$MessageCenter.prototype;
$ef39f475dab603c1$var$messageCenterProto.on = $ef39f475dab603c1$var$createRegisterEventWithLowercaseMessageCenter('on');
$ef39f475dab603c1$var$messageCenterProto.off = $ef39f475dab603c1$var$createRegisterEventWithLowercaseMessageCenter('off');
// ---------------------------------------
// Internal method names for class ECharts
// ---------------------------------------
// This is [EC_PREPARE].
var $ef39f475dab603c1$var$prepare;
var $ef39f475dab603c1$var$prepareView;
var $ef39f475dab603c1$var$updateDirectly;
var $ef39f475dab603c1$var$updateMethods;
var $ef39f475dab603c1$var$doConvertPixel;
var $ef39f475dab603c1$var$updateStreamModes;
var $ef39f475dab603c1$var$doDispatchAction;
var $ef39f475dab603c1$var$flushPendingActions;
var $ef39f475dab603c1$var$triggerUpdatedEvent;
var $ef39f475dab603c1$var$bindRenderedEvent;
var $ef39f475dab603c1$var$bindMouseEvent;
var $ef39f475dab603c1$var$render;
var $ef39f475dab603c1$var$renderComponents;
var $ef39f475dab603c1$var$renderSeries;
var $ef39f475dab603c1$var$createExtensionAPI;
var $ef39f475dab603c1$var$enableConnect;
var $ef39f475dab603c1$var$markStatusToUpdate;
var $ef39f475dab603c1$var$applyChangedStates;
var $ef39f475dab603c1$var$updateECUpdateCycleVersion;
var $ef39f475dab603c1$var$ECharts = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(ECharts, _super);
    function ECharts(dom, // Theme name or themeOption.
    theme, opts) {
        var _this = _super.call(this, new (0, $1d241d8a3709ec94$export$d0fd09f950257b52)()) || this;
        _this._chartsViews = [];
        _this._chartsMap = {};
        _this._componentsViews = [];
        _this._componentsMap = {};
        // Can't dispatch action during rendering procedure
        _this._pendingActions = [];
        opts = opts || {};
        // mark the echarts instance as raw in Vue 3 to prevent the object being converted to be a proxy.
        _this.__v_skip = true;
        _this._dom = dom;
        var defaultRenderer = 'canvas';
        var defaultCoarsePointer = 'auto';
        var defaultUseDirtyRect = false;
        _this[$ef39f475dab603c1$var$EC_UPDATE_CYCLE_VERSION_KEY] = 1;
        var root;
        if (opts.ssr) $85632cfbb825ab09$export$e7a09d7fe68a4f7(function(el) {
            var ecData = (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(el);
            var dataIndex = ecData.dataIndex;
            if (dataIndex == null) return;
            var hashMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
            hashMap.set('series_index', ecData.seriesIndex);
            hashMap.set('data_index', dataIndex);
            ecData.ssrType && hashMap.set('ssr_type', ecData.ssrType);
            return hashMap;
        });
        var zr = _this._zr = $85632cfbb825ab09$export$2cd8252107eb640b(dom, {
            renderer: opts.renderer || defaultRenderer,
            devicePixelRatio: opts.devicePixelRatio,
            width: opts.width,
            height: opts.height,
            ssr: opts.ssr,
            useDirtyRect: (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(opts.useDirtyRect, defaultUseDirtyRect),
            useCoarsePointer: (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(opts.useCoarsePointer, defaultCoarsePointer),
            pointerSize: opts.pointerSize
        });
        _this._ssr = opts.ssr;
        // Expect 60 fps.
        _this._throttledZrFlush = (0, $fcd7567e9010c0f5$export$de363e709c412c8a)((0, $f16f2994a32ad273$export$2385a24977818dd0)(zr.flush, zr), 17);
        _this._updateTheme(theme);
        _this._locale = (0, $79b0d3d61f36c1fa$export$ddc371781a6af754)(opts.locale || (0, $79b0d3d61f36c1fa$export$9a2147b3808d4c6b));
        _this._coordSysMgr = new (0, $d1c2b348f154f767$export$2e2bcd8739ae039)();
        var api = _this._api = $ef39f475dab603c1$var$createExtensionAPI(_this);
        // Sort on demand
        function prioritySortFunc(a, b) {
            return a.__prio - b.__prio;
        }
        (0, $33b198fcd268be25$export$2e2bcd8739ae039)($ef39f475dab603c1$var$visualFuncs, prioritySortFunc);
        (0, $33b198fcd268be25$export$2e2bcd8739ae039)($ef39f475dab603c1$var$dataProcessorFuncs, prioritySortFunc);
        _this._scheduler = new (0, $fe0278d7cd20db39$export$2e2bcd8739ae039)(_this, api, $ef39f475dab603c1$var$dataProcessorFuncs, $ef39f475dab603c1$var$visualFuncs);
        _this._messageCenter = new $ef39f475dab603c1$var$MessageCenter();
        // Init mouse events
        _this._initEvents();
        // In case some people write `window.onresize = chart.resize`
        _this.resize = (0, $f16f2994a32ad273$export$2385a24977818dd0)(_this.resize, _this);
        zr.animation.on('frame', _this._onframe, _this);
        $ef39f475dab603c1$var$bindRenderedEvent(zr, _this);
        $ef39f475dab603c1$var$bindMouseEvent(zr, _this);
        // ECharts instance can be used as value.
        (0, $f16f2994a32ad273$export$112e66431016387b)(_this);
        return _this;
    }
    ECharts.prototype._onframe = function() {
        if (this._disposed) return;
        var scheduler = this._scheduler;
        var ecModel = this._model;
        var api = this._api;
        $ef39f475dab603c1$var$applyChangedStates(this);
        // Lazy update
        if (this[$ef39f475dab603c1$var$PENDING_UPDATE]) {
            var silent = this[$ef39f475dab603c1$var$PENDING_UPDATE].silent;
            this[$ef39f475dab603c1$var$IN_EC_CYCLE_KEY] = true;
            $ef39f475dab603c1$var$updateECUpdateCycleVersion(this);
            try {
                $ef39f475dab603c1$var$prepare(this);
                $ef39f475dab603c1$var$updateMethods.update.call(this, null, this[$ef39f475dab603c1$var$PENDING_UPDATE].updateParams);
            } catch (e) {
                this[$ef39f475dab603c1$var$IN_EC_CYCLE_KEY] = false;
                this[$ef39f475dab603c1$var$PENDING_UPDATE] = null;
                throw e;
            }
            // At present, in each frame, zrender performs:
            //   (1) animation step forward.
            //   (2) trigger('frame') (where this `_onframe` is called)
            //   (3) zrender flush (render).
            // If we do nothing here, since we use `setToFinal: true`, the step (3) above
            // will render the final state of the elements before the real animation started.
            this._zr.flush();
            this[$ef39f475dab603c1$var$IN_EC_CYCLE_KEY] = false;
            this[$ef39f475dab603c1$var$PENDING_UPDATE] = null;
            $ef39f475dab603c1$var$flushPendingActions.call(this, silent);
            $ef39f475dab603c1$var$triggerUpdatedEvent.call(this, silent);
        } else if (scheduler.unfinished) {
            // Stream progress.
            var remainTime = $ef39f475dab603c1$var$TEST_FRAME_REMAIN_TIME;
            // PENDING: guard the following by `this[IN_EC_CYCLE_KEY] = true`?
            do {
                // Reset to false per iteration. Otherwise the last zr.flush
                // can not be triggered and 'finish' event can not be triggered.
                scheduler.unfinished = false;
                var startTime = (0, $e4ffe803d17351c8$export$ef5e599365494451).getTime();
                scheduler.performSeriesTasks(ecModel);
                // Currently dataProcessorFuncs do not check threshold.
                scheduler.performDataProcessorTasks(ecModel);
                $ef39f475dab603c1$var$updateStreamModes(this, ecModel);
                // Do not update coordinate system here. Because that coord system update in
                // each frame is not a good user experience. So we follow the rule that
                // the extent of the coordinate system is determined in the first frame (the
                // frame is executed immediately after task reset.
                // this._coordSysMgr.update(ecModel, api);
                // console.log('--- ec frame visual ---', remainTime);
                scheduler.performVisualTasks(ecModel);
                $ef39f475dab603c1$var$renderSeries(this, this._model, api, 'remain', {});
                remainTime -= (0, $e4ffe803d17351c8$export$ef5e599365494451).getTime() - startTime;
            }while (remainTime > 0 && scheduler.unfinished);
            // Call flush explicitly for trigger finished event.
            if (!scheduler.unfinished) this._zr.flush();
        // Else, zr flushing be ensue within the same frame,
        // because zr flushing is after onframe event.
        }
    };
    ECharts.prototype.getDom = function() {
        return this._dom;
    };
    ECharts.prototype.getId = function() {
        return this.id;
    };
    ECharts.prototype.getZr = function() {
        return this._zr;
    };
    ECharts.prototype.isSSR = function() {
        return this._ssr;
    };
    /* eslint-disable-next-line */ ECharts.prototype.setOption = function(option, notMerge, lazyUpdate) {
        if (this[$ef39f475dab603c1$var$IN_EC_CYCLE_KEY]) return;
        if (this._disposed) {
            $ef39f475dab603c1$var$disposedWarning(this.id);
            return;
        }
        var silent;
        var replaceMerge;
        var transitionOpt;
        if ((0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(notMerge)) {
            lazyUpdate = notMerge.lazyUpdate;
            silent = notMerge.silent;
            replaceMerge = notMerge.replaceMerge;
            transitionOpt = notMerge.transition;
            notMerge = notMerge.notMerge;
        }
        this[$ef39f475dab603c1$var$IN_EC_CYCLE_KEY] = true;
        $ef39f475dab603c1$var$updateECUpdateCycleVersion(this);
        if (!this._model || notMerge) {
            var optionManager = new (0, $76e6337c900a327f$export$2e2bcd8739ae039)(this._api);
            var theme = this._theme;
            var ecModel = this._model = new (0, $5fcc33310122e6f0$export$2e2bcd8739ae039)();
            ecModel.scheduler = this._scheduler;
            ecModel.ssr = this._ssr;
            ecModel.init(null, null, null, theme, this._locale, optionManager);
        }
        this._model.setOption(option, {
            replaceMerge: replaceMerge
        }, $ef39f475dab603c1$var$optionPreprocessorFuncs);
        var updateParams = {
            seriesTransition: transitionOpt,
            optionChanged: true
        };
        if (lazyUpdate) {
            this[$ef39f475dab603c1$var$PENDING_UPDATE] = {
                silent: silent,
                updateParams: updateParams
            };
            this[$ef39f475dab603c1$var$IN_EC_CYCLE_KEY] = false;
            // `setOption(option, {lazyMode: true})` may be called when zrender has been slept.
            // It should wake it up to make sure zrender start to render at the next frame.
            this.getZr().wakeUp();
        } else {
            try {
                $ef39f475dab603c1$var$prepare(this);
                $ef39f475dab603c1$var$updateMethods.update.call(this, null, updateParams);
            } catch (e) {
                this[$ef39f475dab603c1$var$PENDING_UPDATE] = null;
                this[$ef39f475dab603c1$var$IN_EC_CYCLE_KEY] = false;
                throw e;
            }
            // Ensure zr refresh sychronously, and then pixel in canvas can be
            // fetched after `setOption`.
            if (!this._ssr) // not use flush when using ssr mode.
            this._zr.flush();
            this[$ef39f475dab603c1$var$PENDING_UPDATE] = null;
            this[$ef39f475dab603c1$var$IN_EC_CYCLE_KEY] = false;
            $ef39f475dab603c1$var$flushPendingActions.call(this, silent);
            $ef39f475dab603c1$var$triggerUpdatedEvent.call(this, silent);
        }
    };
    /**
   * Update theme with name or theme option and repaint the chart.
   * @param theme Theme name or theme option.
   * @param opts Optional settings
   */ ECharts.prototype.setTheme = function(theme, opts) {
        if (this[$ef39f475dab603c1$var$IN_EC_CYCLE_KEY]) return;
        if (this._disposed) {
            $ef39f475dab603c1$var$disposedWarning(this.id);
            return;
        }
        var ecModel = this._model;
        if (!ecModel) return;
        var silent = opts && opts.silent;
        var updateParams = null;
        if (this[$ef39f475dab603c1$var$PENDING_UPDATE]) {
            if (silent == null) silent = this[$ef39f475dab603c1$var$PENDING_UPDATE].silent;
            updateParams = this[$ef39f475dab603c1$var$PENDING_UPDATE].updateParams;
            this[$ef39f475dab603c1$var$PENDING_UPDATE] = null;
        }
        this[$ef39f475dab603c1$var$IN_EC_CYCLE_KEY] = true;
        $ef39f475dab603c1$var$updateECUpdateCycleVersion(this);
        try {
            this._updateTheme(theme);
            ecModel.setTheme(this._theme);
            $ef39f475dab603c1$var$prepare(this);
            $ef39f475dab603c1$var$updateMethods.update.call(this, {
                type: 'setTheme'
            }, updateParams);
        } catch (e) {
            this[$ef39f475dab603c1$var$IN_EC_CYCLE_KEY] = false;
            throw e;
        }
        this[$ef39f475dab603c1$var$IN_EC_CYCLE_KEY] = false;
        $ef39f475dab603c1$var$flushPendingActions.call(this, silent);
        $ef39f475dab603c1$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype._updateTheme = function(theme) {
        if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(theme)) theme = $ef39f475dab603c1$var$themeStorage[theme];
        if (theme) {
            theme = (0, $f16f2994a32ad273$export$9cd59f9826255e47)(theme);
            theme && (0, $5489e37b9bdb0718$export$2e2bcd8739ae039)(theme, true);
            this._theme = theme;
        }
    };
    // We don't want developers to use getModel directly.
    ECharts.prototype.getModel = function() {
        return this._model;
    };
    ECharts.prototype.getOption = function() {
        return this._model && this._model.getOption();
    };
    ECharts.prototype.getWidth = function() {
        return this._zr.getWidth();
    };
    ECharts.prototype.getHeight = function() {
        return this._zr.getHeight();
    };
    ECharts.prototype.getDevicePixelRatio = function() {
        return this._zr.painter.dpr || (0, $6d0397515b55cc48$export$2e2bcd8739ae039).hasGlobalWindow && window.devicePixelRatio || 1;
    };
    /**
   * Get canvas which has all thing rendered
   * @deprecated Use renderToCanvas instead.
   */ ECharts.prototype.getRenderedCanvas = function(opts) {
        return this.renderToCanvas(opts);
    };
    ECharts.prototype.renderToCanvas = function(opts) {
        opts = opts || {};
        var painter = this._zr.painter;
        return painter.getRenderedCanvas({
            backgroundColor: opts.backgroundColor || this._model.get('backgroundColor'),
            pixelRatio: opts.pixelRatio || this.getDevicePixelRatio()
        });
    };
    ECharts.prototype.renderToSVGString = function(opts) {
        opts = opts || {};
        var painter = this._zr.painter;
        return painter.renderToString({
            useViewBox: opts.useViewBox
        });
    };
    /**
   * Get svg data url
   */ ECharts.prototype.getSvgDataURL = function() {
        var zr = this._zr;
        var list = zr.storage.getDisplayList();
        // Stop animations
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(list, function(el) {
            el.stopAnimation(null, true);
        });
        return zr.painter.toDataURL();
    };
    ECharts.prototype.getDataURL = function(opts) {
        if (this._disposed) {
            $ef39f475dab603c1$var$disposedWarning(this.id);
            return;
        }
        opts = opts || {};
        var excludeComponents = opts.excludeComponents;
        var ecModel = this._model;
        var excludesComponentViews = [];
        var self = this;
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(excludeComponents, function(componentType) {
            ecModel.eachComponent({
                mainType: componentType
            }, function(component) {
                var view = self._componentsMap[component.__viewId];
                if (!view.group.ignore) {
                    excludesComponentViews.push(view);
                    view.group.ignore = true;
                }
            });
        });
        var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.renderToCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(excludesComponentViews, function(view) {
            view.group.ignore = false;
        });
        return url;
    };
    ECharts.prototype.getConnectedDataURL = function(opts) {
        if (this._disposed) {
            $ef39f475dab603c1$var$disposedWarning(this.id);
            return;
        }
        var isSvg = opts.type === 'svg';
        var groupId = this.group;
        var mathMin = Math.min;
        var mathMax = Math.max;
        var MAX_NUMBER = Infinity;
        if ($ef39f475dab603c1$var$connectedGroups[groupId]) {
            var left_1 = MAX_NUMBER;
            var top_1 = MAX_NUMBER;
            var right_1 = -MAX_NUMBER;
            var bottom_1 = -MAX_NUMBER;
            var canvasList_1 = [];
            var dpr_1 = opts && opts.pixelRatio || this.getDevicePixelRatio();
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)($ef39f475dab603c1$var$instances, function(chart, id) {
                if (chart.group === groupId) {
                    var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.renderToCanvas((0, $f16f2994a32ad273$export$9cd59f9826255e47)(opts));
                    var boundingRect = chart.getDom().getBoundingClientRect();
                    left_1 = mathMin(boundingRect.left, left_1);
                    top_1 = mathMin(boundingRect.top, top_1);
                    right_1 = mathMax(boundingRect.right, right_1);
                    bottom_1 = mathMax(boundingRect.bottom, bottom_1);
                    canvasList_1.push({
                        dom: canvas,
                        left: boundingRect.left,
                        top: boundingRect.top
                    });
                }
            });
            left_1 *= dpr_1;
            top_1 *= dpr_1;
            right_1 *= dpr_1;
            bottom_1 *= dpr_1;
            var width = right_1 - left_1;
            var height = bottom_1 - top_1;
            var targetCanvas = (0, $e4ffe803d17351c8$export$ef5e599365494451).createCanvas();
            var zr_1 = $85632cfbb825ab09$export$2cd8252107eb640b(targetCanvas, {
                renderer: isSvg ? 'svg' : 'canvas'
            });
            zr_1.resize({
                width: width,
                height: height
            });
            if (isSvg) {
                var content_1 = '';
                (0, $f16f2994a32ad273$export$79b2f7037acddd43)(canvasList_1, function(item) {
                    var x = item.left - left_1;
                    var y = item.top - top_1;
                    content_1 += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
                });
                zr_1.painter.getSvgRoot().innerHTML = content_1;
                if (opts.connectedBackgroundColor) zr_1.painter.setBackgroundColor(opts.connectedBackgroundColor);
                zr_1.refreshImmediately();
                return zr_1.painter.toDataURL();
            } else {
                // Background between the charts
                if (opts.connectedBackgroundColor) zr_1.add(new $dbd6d77105f10fb2$export$2e2bcd8739ae039({
                    shape: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    },
                    style: {
                        fill: opts.connectedBackgroundColor
                    }
                }));
                (0, $f16f2994a32ad273$export$79b2f7037acddd43)(canvasList_1, function(item) {
                    var img = new $0eafea320dbd53c3$export$2e2bcd8739ae039({
                        style: {
                            x: item.left * dpr_1 - left_1,
                            y: item.top * dpr_1 - top_1,
                            image: item.dom
                        }
                    });
                    zr_1.add(img);
                });
                zr_1.refreshImmediately();
                return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
            }
        } else return this.getDataURL(opts);
    };
    ECharts.prototype.convertToPixel = function(finder, value, opt) {
        return $ef39f475dab603c1$var$doConvertPixel(this, 'convertToPixel', finder, value, opt);
    };
    /**
   * Convert from logical coordinate system to pixel coordinate system.
   * See CoordinateSystem#convertToPixel.
   *
   * @see CoordinateSystem['dataToLayout'] for parameters and return.
   * @see CoordinateSystemDataCoord
   */ ECharts.prototype.convertToLayout = function(finder, value, opt) {
        return $ef39f475dab603c1$var$doConvertPixel(this, 'convertToLayout', finder, value, opt);
    };
    // The above are signatures from before v6, thus they should be preserved for backward compat.
    ECharts.prototype.convertFromPixel = function(finder, value, opt) {
        return $ef39f475dab603c1$var$doConvertPixel(this, 'convertFromPixel', finder, value, opt);
    };
    /**
   * Is the specified coordinate systems or components contain the given pixel point.
   * @param {Array|number} value
   * @return {boolean} result
   */ ECharts.prototype.containPixel = function(finder, value) {
        if (this._disposed) {
            $ef39f475dab603c1$var$disposedWarning(this.id);
            return;
        }
        var ecModel = this._model;
        var result;
        var findResult = $3fa81475350067fd$export$95de80076abac814(ecModel, finder);
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(findResult, function(models, key) {
            key.indexOf('Models') >= 0 && (0, $f16f2994a32ad273$export$79b2f7037acddd43)(models, function(model) {
                var coordSys = model.coordinateSystem;
                if (coordSys && coordSys.containPoint) result = result || !!coordSys.containPoint(value);
                else if (key === 'seriesModels') {
                    var view = this._chartsMap[model.__viewId];
                    if (view && view.containPoint) result = result || view.containPoint(value, model);
                }
            }, this);
        }, this);
        return !!result;
    };
    /**
   * Get visual from series or data.
   * @param finder
   *        If string, e.g., 'series', means {seriesIndex: 0}.
   *        If Object, could contain some of these properties below:
   *        {
   *            seriesIndex / seriesId / seriesName,
   *            dataIndex / dataIndexInside
   *        }
   *        If dataIndex is not specified, series visual will be fetched,
   *        but not data item visual.
   *        If all of seriesIndex, seriesId, seriesName are not specified,
   *        visual will be fetched from first series.
   * @param visualType 'color', 'symbol', 'symbolSize'
   */ ECharts.prototype.getVisual = function(finder, visualType) {
        var ecModel = this._model;
        var parsedFinder = $3fa81475350067fd$export$95de80076abac814(ecModel, finder, {
            defaultMainType: 'series'
        });
        var seriesModel = parsedFinder.seriesModel;
        var data = seriesModel.getData();
        var dataIndexInside = parsedFinder.hasOwnProperty('dataIndexInside') ? parsedFinder.dataIndexInside : parsedFinder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(parsedFinder.dataIndex) : null;
        return dataIndexInside != null ? (0, $1b1e2db17dfc2a59$export$91d919a86b2df624)(data, dataIndexInside, visualType) : (0, $1b1e2db17dfc2a59$export$d76e333a86ea1a2)(data, visualType);
    };
    /**
   * Get view of corresponding component model
   */ ECharts.prototype.getViewOfComponentModel = function(componentModel) {
        return this._componentsMap[componentModel.__viewId];
    };
    /**
   * Get view of corresponding series model
   */ ECharts.prototype.getViewOfSeriesModel = function(seriesModel) {
        return this._chartsMap[seriesModel.__viewId];
    };
    ECharts.prototype._initEvents = function() {
        var _this = this;
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)($ef39f475dab603c1$var$MOUSE_EVENT_NAMES, function(eveName) {
            var handler = function handler(e) {
                var ecModel = _this.getModel();
                var el = e.target;
                var params;
                var isGlobalOut = eveName === 'globalout';
                // no e.target when 'globalout'.
                if (isGlobalOut) params = {};
                else el && (0, $c30ebd75483299c9$export$8a4fca9e04eb4df6)(el, function(parent) {
                    var ecData = (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(parent);
                    if (ecData && ecData.dataIndex != null) {
                        var dataModel = ecData.dataModel || ecModel.getSeriesByIndex(ecData.seriesIndex);
                        params = dataModel && dataModel.getDataParams(ecData.dataIndex, ecData.dataType, el) || {};
                        return true;
                    } else if (ecData.eventData) {
                        params = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, ecData.eventData);
                        return true;
                    }
                }, true);
                // Contract: if params prepared in mouse event,
                // these properties must be specified:
                // {
                //    componentType: string (component main type)
                //    componentIndex: number
                // }
                // Otherwise event query can not work.
                if (params) {
                    var componentType = params.componentType;
                    var componentIndex = params.componentIndex;
                    // Special handling for historic reason: when trigger by
                    // markLine/markPoint/markArea, the componentType is
                    // 'markLine'/'markPoint'/'markArea', but we should better
                    // enable them to be queried by seriesIndex, since their
                    // option is set in each series.
                    if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
                        componentType = 'series';
                        componentIndex = params.seriesIndex;
                    }
                    var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
                    var view = model && _this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
                    params.event = e;
                    params.type = eveName;
                    _this._$eventProcessor.eventInfo = {
                        targetEl: el,
                        packedEvent: params,
                        model: model,
                        view: view
                    };
                    _this.trigger(eveName, params);
                }
            };
            // Consider that some component (like tooltip, brush, ...)
            // register zr event handler, but user event handler might
            // do anything, such as call `setOption` or `dispatchAction`,
            // which probably update any of the content and probably
            // cause problem if it is called previous other inner handlers.
            handler.zrEventfulCallAtLast = true;
            _this._zr.on(eveName, handler, _this);
        });
        var messageCenter = this._messageCenter;
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)($ef39f475dab603c1$var$publicEventTypeMap, function(_, eventType) {
            messageCenter.on(eventType, function(event) {
                _this.trigger(eventType, event);
            });
        });
        (0, $e898649850ed5916$export$2575c83262e49d0c)(messageCenter, this, this._api);
    };
    ECharts.prototype.isDisposed = function() {
        return this._disposed;
    };
    ECharts.prototype.clear = function() {
        if (this._disposed) {
            $ef39f475dab603c1$var$disposedWarning(this.id);
            return;
        }
        this.setOption({
            series: []
        }, true);
    };
    ECharts.prototype.dispose = function() {
        if (this._disposed) {
            $ef39f475dab603c1$var$disposedWarning(this.id);
            return;
        }
        this._disposed = true;
        var dom = this.getDom();
        if (dom) $3fa81475350067fd$export$9fec4d97f1922e0b(this.getDom(), $ef39f475dab603c1$var$DOM_ATTRIBUTE_KEY, '');
        var chart = this;
        var api = chart._api;
        var ecModel = chart._model;
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(chart._componentsViews, function(component) {
            component.dispose(ecModel, api);
        });
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(chart._chartsViews, function(chart) {
            chart.dispose(ecModel, api);
        });
        // Dispose after all views disposed
        chart._zr.dispose();
        // Set properties to null.
        // To reduce the memory cost in case the top code still holds this instance unexpectedly.
        chart._dom = chart._model = chart._chartsMap = chart._componentsMap = chart._chartsViews = chart._componentsViews = chart._scheduler = chart._api = chart._zr = chart._throttledZrFlush = chart._theme = chart._coordSysMgr = chart._messageCenter = null;
        delete $ef39f475dab603c1$var$instances[chart.id];
    };
    /**
   * Resize the chart
   */ ECharts.prototype.resize = function(opts) {
        if (this[$ef39f475dab603c1$var$IN_EC_CYCLE_KEY]) return;
        if (this._disposed) {
            $ef39f475dab603c1$var$disposedWarning(this.id);
            return;
        }
        this._zr.resize(opts);
        var ecModel = this._model;
        // Resize loading effect
        this._loadingFX && this._loadingFX.resize();
        if (!ecModel) return;
        var needPrepare = ecModel.resetOption('media');
        var silent = opts && opts.silent;
        // There is some real cases that:
        // chart.setOption(option, { lazyUpdate: true });
        // chart.resize();
        if (this[$ef39f475dab603c1$var$PENDING_UPDATE]) {
            if (silent == null) silent = this[$ef39f475dab603c1$var$PENDING_UPDATE].silent;
            needPrepare = true;
            this[$ef39f475dab603c1$var$PENDING_UPDATE] = null;
        }
        this[$ef39f475dab603c1$var$IN_EC_CYCLE_KEY] = true;
        $ef39f475dab603c1$var$updateECUpdateCycleVersion(this);
        try {
            needPrepare && $ef39f475dab603c1$var$prepare(this);
            $ef39f475dab603c1$var$updateMethods.update.call(this, {
                type: 'resize',
                animation: (0, $f16f2994a32ad273$export$8b58be045bf06082)({
                    // Disable animation
                    duration: 0
                }, opts && opts.animation)
            });
        } catch (e) {
            this[$ef39f475dab603c1$var$IN_EC_CYCLE_KEY] = false;
            throw e;
        }
        this[$ef39f475dab603c1$var$IN_EC_CYCLE_KEY] = false;
        $ef39f475dab603c1$var$flushPendingActions.call(this, silent);
        $ef39f475dab603c1$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.showLoading = function(name, cfg) {
        if (this._disposed) {
            $ef39f475dab603c1$var$disposedWarning(this.id);
            return;
        }
        if ((0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(name)) {
            cfg = name;
            name = '';
        }
        name = name || 'default';
        this.hideLoading();
        if (!$ef39f475dab603c1$var$loadingEffects[name]) return;
        var el = $ef39f475dab603c1$var$loadingEffects[name](this._api, cfg);
        var zr = this._zr;
        this._loadingFX = el;
        zr.add(el);
    };
    /**
   * Hide loading effect
   */ ECharts.prototype.hideLoading = function() {
        if (this._disposed) {
            $ef39f475dab603c1$var$disposedWarning(this.id);
            return;
        }
        this._loadingFX && this._zr.remove(this._loadingFX);
        this._loadingFX = null;
    };
    ECharts.prototype.makeActionFromEvent = function(eventObj) {
        var payload = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, eventObj);
        payload.type = $ef39f475dab603c1$var$connectionEventRevertMap[eventObj.type];
        return payload;
    };
    /**
   * @param opt If pass boolean, means opt.silent
   * @param opt.silent Default `false`. Whether trigger events.
   * @param opt.flush Default `undefined`.
   *        true: Flush immediately, and then pixel in canvas can be fetched
   *            immediately. Caution: it might affect performance.
   *        false: Not flush.
   *        undefined: Auto decide whether perform flush.
   */ ECharts.prototype.dispatchAction = function(payload, opt) {
        if (this._disposed) {
            $ef39f475dab603c1$var$disposedWarning(this.id);
            return;
        }
        if (!(0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(opt)) opt = {
            silent: !!opt
        };
        if (!$ef39f475dab603c1$var$actions[payload.type]) return;
        // Avoid dispatch action before setOption. Especially in `connect`.
        if (!this._model) return;
        // May dispatchAction in rendering procedure
        if (this[$ef39f475dab603c1$var$IN_EC_CYCLE_KEY]) {
            this._pendingActions.push(payload);
            return;
        }
        var silent = opt.silent;
        $ef39f475dab603c1$var$doDispatchAction.call(this, payload, silent);
        var flush = opt.flush;
        if (flush) this._zr.flush();
        else if (flush !== false && (0, $6d0397515b55cc48$export$2e2bcd8739ae039).browser.weChat) // In WeChat embedded browser, `requestAnimationFrame` and `setInterval`
        // hang when sliding page (on touch event), which cause that zr does not
        // refresh until user interaction finished, which is not expected.
        // But `dispatchAction` may be called too frequently when pan on touch
        // screen, which impacts performance if do not throttle them.
        this._throttledZrFlush();
        $ef39f475dab603c1$var$flushPendingActions.call(this, silent);
        $ef39f475dab603c1$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.updateLabelLayout = function() {
        (0, $a4a481f8e97330f1$export$2e2bcd8739ae039).trigger('series:layoutlabels', this._model, this._api, {
            // Not adding series labels.
            // TODO
            updatedSeries: []
        });
    };
    ECharts.prototype.appendData = function(params) {
        if (this._disposed) {
            $ef39f475dab603c1$var$disposedWarning(this.id);
            return;
        }
        var seriesIndex = params.seriesIndex;
        var ecModel = this.getModel();
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        seriesModel.appendData(params);
        // NOTICE:
        // `appendData` does not support to update axis scale extent of coordinate
        // systems. In the expected usage of `appendData`, the initial extent of
        // coordinate system should be explicitly specified (by `xxxAxis.data` for
        // 'category' axis or by `xxxAxis.min/max` for other axes). Otherwise, if
        // the extent keep changing while `appendData`, the location of the painted
        // graphic elements have to be changed frequently.
        this._scheduler.unfinished = true;
        this.getZr().wakeUp();
    };
    // A work around for no `internal` modifier in ts yet but
    // need to strictly hide private methods to JS users.
    ECharts.internalField = function() {
        $ef39f475dab603c1$var$prepare = function prepare(ecIns) {
            (0, $31b4a1aa189576ea$export$54b70eb74482271e)(ecIns._model);
            var scheduler = ecIns._scheduler;
            scheduler.restorePipelines(ecIns._zr, ecIns._model);
            scheduler.prepareStageTasks();
            $ef39f475dab603c1$var$prepareView(ecIns, true);
            $ef39f475dab603c1$var$prepareView(ecIns, false);
            scheduler.plan();
        };
        /**
     * Prepare view instances of charts and components
     */ $ef39f475dab603c1$var$prepareView = function prepareView(ecIns, isComponent) {
            var ecModel = ecIns._model;
            var scheduler = ecIns._scheduler;
            var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
            var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
            var zr = ecIns._zr;
            var api = ecIns._api;
            for(var i = 0; i < viewList.length; i++)viewList[i].__alive = false;
            isComponent ? ecModel.eachComponent(function(componentType, model) {
                componentType !== 'series' && doPrepare(model);
            }) : ecModel.eachSeries(doPrepare);
            function doPrepare(model) {
                // By default view will be reused if possible for the case that `setOption` with "notMerge"
                // mode and need to enable transition animation. (Usually, when they have the same id, or
                // especially no id but have the same type & name & index. See the `model.id` generation
                // rule in `makeIdAndName` and `viewId` generation rule here).
                // But in `replaceMerge` mode, this feature should be able to disabled when it is clear that
                // the new model has nothing to do with the old model.
                var requireNewView = model.__requireNewView;
                // This command should not work twice.
                model.__requireNewView = false;
                // Consider: id same and type changed.
                var viewId = '_ec_' + model.id + '_' + model.type;
                var view = !requireNewView && viewMap[viewId];
                if (!view) {
                    var classType = (0, $7904d4b709390668$export$fbe18865d303bf01)(model.type);
                    var Clazz = isComponent ? (0, $091798b5bbee0498$export$2e2bcd8739ae039).getClass(classType.main, classType.sub) : // FIXME:TS
                    // (ChartView as ChartViewConstructor).getClass('series', classType.sub)
                    // For backward compat, still support a chart type declared as only subType
                    // like "liquidfill", but recommend "series.liquidfill"
                    // But need a base class to make a type series.
                    (0, $3644e1b3c8e5afa0$export$2e2bcd8739ae039).getClass(classType.sub);
                    view = new Clazz();
                    view.init(ecModel, api);
                    viewMap[viewId] = view;
                    viewList.push(view);
                    zr.add(view.group);
                }
                model.__viewId = view.__id = viewId;
                view.__alive = true;
                view.__model = model;
                view.group.__ecComponentInfo = {
                    mainType: model.mainType,
                    index: model.componentIndex
                };
                !isComponent && scheduler.prepareView(view, model, ecModel, api);
            }
            for(var i = 0; i < viewList.length;){
                var view = viewList[i];
                if (!view.__alive) {
                    !isComponent && view.renderTask.dispose();
                    zr.remove(view.group);
                    view.dispose(ecModel, api);
                    viewList.splice(i, 1);
                    if (viewMap[view.__id] === view) delete viewMap[view.__id];
                    view.__id = view.group.__ecComponentInfo = null;
                } else i++;
            }
        };
        $ef39f475dab603c1$var$updateDirectly = function updateDirectly(ecIns, method, payload, mainType, subType) {
            var ecModel = ecIns._model;
            ecModel.setUpdatePayload(payload);
            // broadcast (e.g., for ':updateAxisPointer')
            if (!mainType) {
                // FIXME
                // Chart will not be update directly here, except set dirty.
                // But there is no such scenario now.
                (0, $f16f2994a32ad273$export$79b2f7037acddd43)([].concat(ecIns._componentsViews).concat(ecIns._chartsViews), callView);
                return;
            }
            var condition = $3fa81475350067fd$export$c064a542e5272c93(payload, mainType, subType);
            var excludeSeriesId = payload.excludeSeriesId;
            var excludeSeriesIdMap;
            if (excludeSeriesId != null) {
                excludeSeriesIdMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
                (0, $f16f2994a32ad273$export$79b2f7037acddd43)($3fa81475350067fd$export$4f07b212a02c8051(excludeSeriesId), function(id) {
                    var modelId = $3fa81475350067fd$export$fb1a222ba5dd6e51(id, null);
                    if (modelId != null) excludeSeriesIdMap.set(modelId, true);
                });
            }
            // If dispatchAction before setOption, do nothing.
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
                if (isExcluded) return;
                if ((0, $1f99b77b45f30655$export$aebe71265c1b77bf)(payload)) {
                    if (model instanceof (0, $80ec9a06634f90ca$export$2e2bcd8739ae039)) {
                        if (payload.type === (0, $1f99b77b45f30655$export$df035d873a9de64f) && !payload.notBlur && !model.get([
                            'emphasis',
                            'disabled'
                        ])) (0, $1f99b77b45f30655$export$64f1fd4daefef21b)(model, payload, ecIns._api);
                    } else {
                        var _a = (0, $1f99b77b45f30655$export$f31a644ccca0ef23)(model.mainType, model.componentIndex, payload.name, ecIns._api), focusSelf = _a.focusSelf, dispatchers = _a.dispatchers;
                        if (payload.type === (0, $1f99b77b45f30655$export$df035d873a9de64f) && focusSelf && !payload.notBlur) (0, $1f99b77b45f30655$export$569da03256c8a55f)(model.mainType, model.componentIndex, ecIns._api);
                        // PENDING:
                        // Whether to put this "enter emphasis" code in `ComponentView`,
                        // which will be the same as `ChartView` but might be not necessary
                        // and will be far from this logic.
                        if (dispatchers) (0, $f16f2994a32ad273$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
                            payload.type === (0, $1f99b77b45f30655$export$df035d873a9de64f) ? (0, $1f99b77b45f30655$export$b2d02638cc34c042)(dispatcher) : (0, $1f99b77b45f30655$export$11be6f716239ac55)(dispatcher);
                        });
                    }
                } else if ((0, $1f99b77b45f30655$export$72aea10e60e45351)(payload)) // TODO geo
                {
                    if (model instanceof (0, $80ec9a06634f90ca$export$2e2bcd8739ae039)) {
                        (0, $1f99b77b45f30655$export$1c7d489f62372d73)(model, payload, ecIns._api);
                        (0, $1f99b77b45f30655$export$e4ea08ef52e0a73)(model);
                        $ef39f475dab603c1$var$markStatusToUpdate(ecIns);
                    }
                }
            }, ecIns);
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
                if (isExcluded) return;
                callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
            }, ecIns);
            function callView(view) {
                view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
            }
        };
        $ef39f475dab603c1$var$updateMethods = {
            prepareAndUpdate: function prepareAndUpdate(payload) {
                $ef39f475dab603c1$var$prepare(this);
                $ef39f475dab603c1$var$updateMethods.update.call(this, payload, payload && {
                    // Needs to mark option changed if newOption is given.
                    // It's from MagicType.
                    // TODO If use a separate flag optionChanged in payload?
                    optionChanged: payload.newOption != null
                });
            },
            update: function update(payload, updateParams) {
                var ecModel = this._model;
                var api = this._api;
                var zr = this._zr;
                var coordSysMgr = this._coordSysMgr;
                var scheduler = this._scheduler;
                // update before setOption
                if (!ecModel) return;
                (0, $31b4a1aa189576ea$export$7a0372e5df3ca6f4)(ecModel);
                ecModel.setUpdatePayload(payload);
                scheduler.restoreData(ecModel, payload);
                scheduler.performSeriesTasks(ecModel);
                // TODO
                // Save total ecModel here for undo/redo (after restoring data and before processing data).
                // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
                // Create new coordinate system each update
                // In LineView may save the old coordinate system and use it to get the original point.
                coordSysMgr.create(ecModel, api);
                (0, $a4a481f8e97330f1$export$2e2bcd8739ae039).trigger('coordsys:aftercreate', ecModel, api);
                scheduler.performDataProcessorTasks(ecModel, payload);
                // Current stream render is not supported in data process. So we can update
                // stream modes after data processing, where the filtered data is used to
                // determine whether to use progressive rendering.
                $ef39f475dab603c1$var$updateStreamModes(this, ecModel);
                // We update stream modes before coordinate system updated, then the modes info
                // can be fetched when coord sys updating (consider the barGrid extent fix). But
                // the drawback is the full coord info can not be fetched. Fortunately this full
                // coord is not required in stream mode updater currently.
                coordSysMgr.update(ecModel, api);
                clearColorPalette(ecModel);
                scheduler.performVisualTasks(ecModel, payload);
                // Set background and dark mode before rendering, because they affect auto-color-determination
                // in zrender Text, and consequently affect the bounding rect if stroke is added.
                var backgroundColor = ecModel.get('backgroundColor') || 'transparent';
                zr.setBackgroundColor(backgroundColor);
                // Force set dark mode.
                var darkMode = ecModel.get('darkMode');
                if (darkMode != null && darkMode !== 'auto') zr.setDarkMode(darkMode);
                $ef39f475dab603c1$var$render(this, ecModel, api, payload, updateParams);
                (0, $a4a481f8e97330f1$export$2e2bcd8739ae039).trigger('afterupdate', ecModel, api);
            },
            /**
       * PENDING: See INCONSISTENCY_OF_BRUSH_SELECTED_EVENT_IN_UPDATE_TRANSFORM
       */ updateTransform: function updateTransform(payload) {
                var ecIns = this;
                var ecModel = ecIns._model;
                var api = ecIns._api;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                // ChartView.markUpdateMethod(payload, 'updateTransform');
                var componentDirtyList = [];
                ecModel.eachComponent(function(mainType, componentModel) {
                    if (mainType === (0, $c870d17359cdf008$export$68ebcbce21494007)) return;
                    var componentView = ecIns.getViewOfComponentModel(componentModel);
                    if (componentView && componentView.__alive) {
                        if (componentView.updateTransform) {
                            var result = componentView.updateTransform(componentModel, ecModel, api, payload);
                            result && result.update && componentDirtyList.push(componentView);
                        } else componentDirtyList.push(componentView);
                    }
                });
                var seriesDirtyMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = ecIns._chartsMap[seriesModel.__viewId];
                    var pipelineContext = seriesModel.pipelineContext;
                    if (chartView.updateTransform && !pipelineContext.progressiveRender) {
                        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
                        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
                    } else seriesDirtyMap.set(seriesModel.uid, 1);
                });
                // Palette should not be cleared, otherwise the variation of dirty series
                // can cause color change unexpectedly.
                // clearColorPalette(ecModel);
                // NOTICE: series data tasks must NOT be dirty, otherwise series data will be recreated.
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
                ecIns._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true,
                    dirtyMap: seriesDirtyMap
                });
                // Currently, not call render of components. Geo render cost a lot.
                // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
                $ef39f475dab603c1$var$renderSeries(ecIns, ecModel, api, payload, {}, seriesDirtyMap);
                (0, $a4a481f8e97330f1$export$2e2bcd8739ae039).trigger('afterupdate', ecModel, api);
            },
            updateView: function updateView(payload) {
                var ecModel = this._model;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                (0, $3644e1b3c8e5afa0$export$2e2bcd8739ae039).markUpdateMethod(payload, 'updateView');
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true
                });
                $ef39f475dab603c1$var$render(this, ecModel, this._api, payload, {});
                (0, $a4a481f8e97330f1$export$2e2bcd8739ae039).trigger('afterupdate', ecModel, this._api);
            },
            updateVisual: function updateVisual(payload) {
                var _this = this;
                var ecModel = this._model;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                // clear all visual
                ecModel.eachSeries(function(seriesModel) {
                    seriesModel.getData().clearAllVisual();
                });
                // Perform visual
                (0, $3644e1b3c8e5afa0$export$2e2bcd8739ae039).markUpdateMethod(payload, 'updateVisual');
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    visualType: 'visual',
                    setDirty: true
                });
                // FIXME: `visualType` may be removed, since it conflicts with `priority` of task. `updateVisual`
                // can be altered to start the pipeline with a certain priority, rather than only execute tasks
                // with `visualType: 'visual'`, otherwise, PRIORITY_VISUAL_POST_CHART_LAYOUT is omitted in this
                // case. Currently, only "brush" uses `updateVisual`, and it works by coincidence.
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType !== 'series') {
                        var componentView = _this.getViewOfComponentModel(componentModel);
                        componentView && componentView.__alive && componentView.updateVisual(componentModel, ecModel, _this._api, payload);
                    }
                });
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    chartView.updateVisual(seriesModel, ecModel, _this._api, payload);
                });
                (0, $a4a481f8e97330f1$export$2e2bcd8739ae039).trigger('afterupdate', ecModel, this._api);
            },
            /**
       * @deprecated
       */ updateLayout: function updateLayout(payload) {
                $ef39f475dab603c1$var$updateMethods.update.call(this, payload);
            }
        };
        function doConvertPixelImpl(ecIns, methodName, finder, value, opt) {
            if (ecIns._disposed) {
                $ef39f475dab603c1$var$disposedWarning(ecIns.id);
                return;
            }
            var ecModel = ecIns._model;
            var coordSysList = ecIns._coordSysMgr.getCoordinateSystems();
            var result;
            var parsedFinder = $3fa81475350067fd$export$95de80076abac814(ecModel, finder);
            for(var i = 0; i < coordSysList.length; i++){
                var coordSys = coordSysList[i];
                if (coordSys[methodName] && (result = coordSys[methodName](ecModel, parsedFinder, value, opt)) != null) return result;
            }
        }
        $ef39f475dab603c1$var$doConvertPixel = doConvertPixelImpl;
        $ef39f475dab603c1$var$updateStreamModes = function updateStreamModes(ecIns, ecModel) {
            var chartsMap = ecIns._chartsMap;
            var scheduler = ecIns._scheduler;
            ecModel.eachSeries(function(seriesModel) {
                scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
            });
        };
        $ef39f475dab603c1$var$doDispatchAction = function doDispatchAction(payload, silent) {
            var _this = this;
            var ecModel = this.getModel();
            var payloadType = payload.type;
            var escapeConnect = payload.escapeConnect;
            var actionInfo = $ef39f475dab603c1$var$actions[payloadType];
            var cptTypeTmp = (actionInfo.update || 'update').split(':');
            var updateMethod = cptTypeTmp.pop();
            var cptType = cptTypeTmp[0] != null && (0, $7904d4b709390668$export$fbe18865d303bf01)(cptTypeTmp[0]);
            this[$ef39f475dab603c1$var$IN_EC_CYCLE_KEY] = true;
            $ef39f475dab603c1$var$updateECUpdateCycleVersion(this);
            var payloads = [
                payload
            ];
            var batched = false;
            // Batch action
            if (payload.batch) {
                batched = true;
                payloads = (0, $f16f2994a32ad273$export$871de8747c9eaa88)(payload.batch, function(item) {
                    item = (0, $f16f2994a32ad273$export$ebe90cb607ad99e)((0, $f16f2994a32ad273$export$8b58be045bf06082)({}, item), payload);
                    item.batch = null;
                    return item;
                });
            }
            var eventObjBatch = [];
            var eventObj;
            var actionResultBatch = [];
            var nonRefinedEventType = actionInfo.nonRefinedEventType;
            var isSelectChange = (0, $1f99b77b45f30655$export$72aea10e60e45351)(payload);
            var isHighDown = (0, $1f99b77b45f30655$export$aebe71265c1b77bf)(payload);
            // Only leave blur once if there are multiple batches.
            if (isHighDown) (0, $1f99b77b45f30655$export$b2a593c7b5243584)(this._api);
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)(payloads, function(batchItem) {
                // Action can specify the event by return it.
                var actionResult = actionInfo.action(batchItem, ecModel, _this._api);
                if (actionInfo.refineEvent) actionResultBatch.push(actionResult);
                else eventObj = actionResult;
                eventObj = eventObj || (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, batchItem);
                eventObj.type = nonRefinedEventType;
                eventObjBatch.push(eventObj);
                // light update does not perform data process, layout and visual.
                if (isHighDown) {
                    var _a = $3fa81475350067fd$export$fe600815775d9400(payload), queryOptionMap = _a.queryOptionMap, mainTypeSpecified = _a.mainTypeSpecified;
                    var componentMainType = mainTypeSpecified ? queryOptionMap.keys()[0] : 'series';
                    $ef39f475dab603c1$var$updateDirectly(_this, updateMethod, batchItem, componentMainType);
                    $ef39f475dab603c1$var$markStatusToUpdate(_this);
                } else if (isSelectChange) {
                    // At present `dispatchAction({ type: 'select', ... })` is not supported on components.
                    // geo still use 'geoselect'.
                    $ef39f475dab603c1$var$updateDirectly(_this, updateMethod, batchItem, 'series');
                    $ef39f475dab603c1$var$markStatusToUpdate(_this);
                } else if (cptType) $ef39f475dab603c1$var$updateDirectly(_this, updateMethod, batchItem, cptType.main, cptType.sub);
            });
            if (updateMethod !== 'none' && !isHighDown && !isSelectChange && !cptType) try {
                // Still dirty
                if (this[$ef39f475dab603c1$var$PENDING_UPDATE]) {
                    $ef39f475dab603c1$var$prepare(this);
                    $ef39f475dab603c1$var$updateMethods.update.call(this, payload);
                    this[$ef39f475dab603c1$var$PENDING_UPDATE] = null;
                } else $ef39f475dab603c1$var$updateMethods[updateMethod].call(this, payload);
            } catch (e) {
                this[$ef39f475dab603c1$var$IN_EC_CYCLE_KEY] = false;
                throw e;
            }
            // Follow the rule of action batch
            if (batched) eventObj = {
                type: nonRefinedEventType,
                escapeConnect: escapeConnect,
                batch: eventObjBatch
            };
            else eventObj = eventObjBatch[0];
            this[$ef39f475dab603c1$var$IN_EC_CYCLE_KEY] = false;
            if (!silent) {
                var refinedEvent = void 0;
                if (actionInfo.refineEvent) {
                    var eventContent = actionInfo.refineEvent(actionResultBatch, payload, ecModel, this._api).eventContent;
                    (0, $f16f2994a32ad273$export$a7a9523472993e97)((0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(eventContent));
                    refinedEvent = (0, $f16f2994a32ad273$export$ebe90cb607ad99e)({
                        type: actionInfo.refinedEventType
                    }, eventContent);
                    refinedEvent.fromAction = payload.type;
                    refinedEvent.fromActionPayload = payload;
                    refinedEvent.escapeConnect = true;
                }
                var messageCenter = this._messageCenter;
                // - If `refineEvent` created a `refinedEvent`, `eventObj` (replicated from the original payload)
                //  is still needed to be triggered for the feature `connect`. But it will not be triggered to
                //  users in this case.
                // - If no `refineEvent` used, `eventObj` will be triggered for both `connect` and users.
                messageCenter.trigger(eventObj.type, eventObj);
                if (refinedEvent) messageCenter.trigger(refinedEvent.type, refinedEvent);
            }
        };
        $ef39f475dab603c1$var$flushPendingActions = function flushPendingActions(silent) {
            var pendingActions = this._pendingActions;
            while(pendingActions.length){
                var payload = pendingActions.shift();
                $ef39f475dab603c1$var$doDispatchAction.call(this, payload, silent);
            }
        };
        $ef39f475dab603c1$var$triggerUpdatedEvent = function triggerUpdatedEvent(silent) {
            !silent && this.trigger('updated');
        };
        /**
     * Event `rendered` is triggered when zr
     * rendered. It is useful for realtime
     * snapshot (reflect animation).
     *
     * Event `finished` is triggered when:
     * (1) zrender rendering finished.
     * (2) initial animation finished.
     * (3) progressive rendering finished.
     * (4) no pending action.
     * (5) no delayed setOption needs to be processed.
     */ $ef39f475dab603c1$var$bindRenderedEvent = function bindRenderedEvent(zr, ecIns) {
            zr.on('rendered', function(params) {
                ecIns.trigger('rendered', params);
                // The `finished` event should not be triggered repeatedly,
                // so it should only be triggered when rendering indeed happens
                // in zrender. (Consider the case that dispatchAction is keep
                // triggering when mouse move).
                if (// Although zr is dirty if initial animation is not finished
                // and this checking is called on frame, we also check
                // animation finished for robustness.
                zr.animation.isFinished() && !ecIns[$ef39f475dab603c1$var$PENDING_UPDATE] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) ecIns.trigger('finished');
                else // Make sure this method can be entered again in next frames.
                zr.refresh();
            });
        };
        $ef39f475dab603c1$var$bindMouseEvent = function bindMouseEvent(zr, ecIns) {
            zr.on('mouseover', function(e) {
                var el = e.target;
                var dispatcher = (0, $c30ebd75483299c9$export$8a4fca9e04eb4df6)(el, (0, $1f99b77b45f30655$export$77d1445f699c58b5));
                if (dispatcher) {
                    (0, $1f99b77b45f30655$export$416765b6198234ff)(dispatcher, e, ecIns._api);
                    $ef39f475dab603c1$var$markStatusToUpdate(ecIns);
                }
            }).on('mouseout', function(e) {
                var el = e.target;
                var dispatcher = (0, $c30ebd75483299c9$export$8a4fca9e04eb4df6)(el, (0, $1f99b77b45f30655$export$77d1445f699c58b5));
                if (dispatcher) {
                    (0, $1f99b77b45f30655$export$bb1c7b62436282a)(dispatcher, e, ecIns._api);
                    $ef39f475dab603c1$var$markStatusToUpdate(ecIns);
                }
            }).on('click', function(e) {
                var el = e.target;
                var dispatcher = (0, $c30ebd75483299c9$export$8a4fca9e04eb4df6)(el, function(target) {
                    return (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(target).dataIndex != null;
                }, true);
                if (dispatcher) {
                    var actionType = dispatcher.selected ? 'unselect' : 'select';
                    var ecData = (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(dispatcher);
                    ecIns._api.dispatchAction({
                        type: actionType,
                        dataType: ecData.dataType,
                        dataIndexInside: ecData.dataIndex,
                        seriesIndex: ecData.seriesIndex,
                        isFromClick: true
                    });
                }
            });
        };
        function clearColorPalette(ecModel) {
            ecModel.clearColorPalette();
            ecModel.eachSeries(function(seriesModel) {
                seriesModel.clearColorPalette();
            });
        }
        // Allocate zlevels for series and components
        function allocateZlevels(ecModel) {
            var componentZLevels = [];
            var seriesZLevels = [];
            var hasSeparateZLevel = false;
            ecModel.eachComponent(function(componentType, componentModel) {
                var zlevel = componentModel.get('zlevel') || 0;
                var z = componentModel.get('z') || 0;
                var zlevelKey = componentModel.getZLevelKey();
                hasSeparateZLevel = hasSeparateZLevel || !!zlevelKey;
                (componentType === 'series' ? seriesZLevels : componentZLevels).push({
                    zlevel: zlevel,
                    z: z,
                    idx: componentModel.componentIndex,
                    type: componentType,
                    key: zlevelKey
                });
            });
            if (hasSeparateZLevel) {
                // Series after component
                var zLevels = componentZLevels.concat(seriesZLevels);
                var lastSeriesZLevel_1;
                var lastSeriesKey_1;
                (0, $33b198fcd268be25$export$2e2bcd8739ae039)(zLevels, function(a, b) {
                    if (a.zlevel === b.zlevel) return a.z - b.z;
                    return a.zlevel - b.zlevel;
                });
                (0, $f16f2994a32ad273$export$79b2f7037acddd43)(zLevels, function(item) {
                    var componentModel = ecModel.getComponent(item.type, item.idx);
                    var zlevel = item.zlevel;
                    var key = item.key;
                    if (lastSeriesZLevel_1 != null) zlevel = Math.max(lastSeriesZLevel_1, zlevel);
                    if (key) {
                        if (zlevel === lastSeriesZLevel_1 && key !== lastSeriesKey_1) zlevel++;
                        lastSeriesKey_1 = key;
                    } else if (lastSeriesKey_1) {
                        if (zlevel === lastSeriesZLevel_1) zlevel++;
                        lastSeriesKey_1 = '';
                    }
                    lastSeriesZLevel_1 = zlevel;
                    componentModel.setZLevel(zlevel);
                });
            }
        }
        $ef39f475dab603c1$var$render = function render(ecIns, ecModel, api, payload, updateParams) {
            allocateZlevels(ecModel);
            $ef39f475dab603c1$var$renderComponents(ecIns, ecModel, api, payload, updateParams);
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)(ecIns._chartsViews, function(chart) {
                chart.__alive = false;
            });
            $ef39f475dab603c1$var$renderSeries(ecIns, ecModel, api, payload, updateParams);
            // Remove groups of unrendered charts
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)(ecIns._chartsViews, function(chart) {
                if (!chart.__alive) chart.remove(ecModel, api);
            });
        };
        $ef39f475dab603c1$var$renderComponents = function renderComponents(ecIns, ecModel, api, payload, updateParams, dirtyList) {
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)(dirtyList || ecIns._componentsViews, function(componentView) {
                var componentModel = componentView.__model;
                clearStates(componentModel, componentView);
                componentView.render(componentModel, ecModel, api, payload);
                updateZ(componentModel, componentView);
                updateStates(componentModel, componentView);
            });
        };
        /**
     * Render each chart and component
     */ $ef39f475dab603c1$var$renderSeries = function renderSeries(ecIns, ecModel, api, payload, updateParams, dirtyMap) {
            // Render all charts
            var scheduler = ecIns._scheduler;
            updateParams = (0, $f16f2994a32ad273$export$8b58be045bf06082)(updateParams || {}, {
                updatedSeries: ecModel.getSeries()
            });
            // TODO progressive?
            (0, $a4a481f8e97330f1$export$2e2bcd8739ae039).trigger('series:beforeupdate', ecModel, api, updateParams);
            var unfinished = false;
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                chartView.__alive = true;
                var renderTask = chartView.renderTask;
                scheduler.updatePayload(renderTask, payload);
                // TODO states on marker.
                clearStates(seriesModel, chartView);
                if (dirtyMap && dirtyMap.get(seriesModel.uid)) renderTask.dirty();
                if (renderTask.perform(scheduler.getPerformArgs(renderTask))) unfinished = true;
                chartView.group.silent = !!seriesModel.get('silent');
                // Should not call markRedraw on group, because it will disable zrender
                // incremental render (always render from the __startIndex each frame)
                // chartView.group.markRedraw();
                updateBlend(seriesModel, chartView);
                (0, $1f99b77b45f30655$export$e4ea08ef52e0a73)(seriesModel);
            });
            scheduler.unfinished = unfinished || scheduler.unfinished;
            (0, $a4a481f8e97330f1$export$2e2bcd8739ae039).trigger('series:layoutlabels', ecModel, api, updateParams);
            // transition after label is layouted.
            (0, $a4a481f8e97330f1$export$2e2bcd8739ae039).trigger('series:transition', ecModel, api, updateParams);
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                // Update Z after labels updated. Before applying states.
                updateZ(seriesModel, chartView);
                // NOTE: Update states after label is updated.
                // label should be in normal status when layouting.
                updateStates(seriesModel, chartView);
            });
            // If use hover layer
            updateHoverLayerStatus(ecIns, ecModel);
            (0, $a4a481f8e97330f1$export$2e2bcd8739ae039).trigger('series:afterupdate', ecModel, api, updateParams);
        };
        $ef39f475dab603c1$var$markStatusToUpdate = function markStatusToUpdate(ecIns) {
            ecIns[$ef39f475dab603c1$var$STATUS_NEEDS_UPDATE_KEY] = true;
            // Wake up zrender if it's sleep. Let it update states in the next frame.
            ecIns.getZr().wakeUp();
        };
        $ef39f475dab603c1$var$updateECUpdateCycleVersion = function updateECUpdateCycleVersion(ecIns) {
            ecIns[$ef39f475dab603c1$var$EC_UPDATE_CYCLE_VERSION_KEY] = (ecIns[$ef39f475dab603c1$var$EC_UPDATE_CYCLE_VERSION_KEY] + 1) % 1e6;
        };
        $ef39f475dab603c1$var$applyChangedStates = function applyChangedStates(ecIns) {
            if (!ecIns[$ef39f475dab603c1$var$STATUS_NEEDS_UPDATE_KEY]) return;
            ecIns.getZr().storage.traverse(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($d2a962ec0ef14a79$export$5b89d4b643713034(el)) return;
                applyElementStates(el);
            });
            ecIns[$ef39f475dab603c1$var$STATUS_NEEDS_UPDATE_KEY] = false;
        };
        function applyElementStates(el) {
            var newStates = [];
            var oldStates = el.currentStates;
            // Keep other states.
            for(var i = 0; i < oldStates.length; i++){
                var stateName = oldStates[i];
                if (!(stateName === 'emphasis' || stateName === 'blur' || stateName === 'select')) newStates.push(stateName);
            }
            // Only use states when it's exists.
            if (el.selected && el.states.select) newStates.push('select');
            if (el.hoverState === (0, $1f99b77b45f30655$export$f0f2bee145debb31) && el.states.emphasis) newStates.push('emphasis');
            else if (el.hoverState === (0, $1f99b77b45f30655$export$1307d6a87d56baa) && el.states.blur) newStates.push('blur');
            el.useStates(newStates);
        }
        function updateHoverLayerStatus(ecIns, ecModel) {
            var zr = ecIns._zr;
            if (zr.painter.type !== 'canvas') return;
            var storage = zr.storage;
            var elCount = 0;
            storage.traverse(function(el) {
                if (!el.isGroup) elCount++;
            });
            var shouldUseHoverLayer = elCount > (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(ecModel.get('hoverLayerThreshold'), (0, $4aa180a54348b454$export$2e2bcd8739ae039).hoverLayerThreshold) && !(0, $6d0397515b55cc48$export$2e2bcd8739ae039).node && !(0, $6d0397515b55cc48$export$2e2bcd8739ae039).worker;
            if (ecIns._usingTHL || shouldUseHoverLayer) {
                ecModel.eachSeries(function(seriesModel) {
                    if (seriesModel.preventUsingHoverLayer) return;
                    var chartView = ecIns._chartsMap[seriesModel.__viewId];
                    if (chartView.__alive) chartView.eachRendered(function(el) {
                        // NOTICE: Do not call any method that can set REDRAW_BIT,
                        // otherwise progressive rendering is broken.
                        var emphasis = el.states.emphasis;
                        if (emphasis && emphasis.hoverLayer !== $bce1f681c7fb2581$export$2ed770cec6ef78e8) emphasis.hoverLayer = shouldUseHoverLayer ? $bce1f681c7fb2581$export$3c339ce201e4ce4d : $bce1f681c7fb2581$export$3e67317617241636;
                    });
                });
                ecIns._usingTHL = shouldUseHoverLayer;
            }
        }
        /**
     * Update chart and blend.
     */ function updateBlend(seriesModel, chartView) {
            var blendMode = seriesModel.get('blendMode') || null;
            chartView.eachRendered(function(el) {
                // NOTICE: Do not call any method that can set REDRAW_BIT,
                // otherwise progressive rendering is broken.
                // FIXME marker and other components
                if (!el.isGroup) // DON'T mark the element dirty. In case element is incremental and don't want to rerender.
                el.style.blend = blendMode;
            });
        }
        function updateZ(model, view) {
            if (model.preventAutoZ) return;
            var zInfo = $bce1f681c7fb2581$export$1500a631bea5adda(model);
            // Set z and zlevel
            view.eachRendered(function(el) {
                $bce1f681c7fb2581$export$d31cf465bf5e8879(el, zInfo.z, zInfo.zlevel);
                // Don't traverse the children because it has been traversed in _updateZ.
                return true;
            });
        }
        // Clear states without animation.
        // TODO States on component.
        function clearStates(model, view) {
            view.eachRendered(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($d2a962ec0ef14a79$export$5b89d4b643713034(el)) return;
                var textContent = el.getTextContent();
                var textGuide = el.getTextGuideLine();
                if (el.stateTransition) el.stateTransition = null;
                if (textContent && textContent.stateTransition) textContent.stateTransition = null;
                if (textGuide && textGuide.stateTransition) textGuide.stateTransition = null;
                // TODO If el is incremental.
                if (el.hasState()) {
                    el.prevStates = el.currentStates;
                    el.clearStates();
                } else if (el.prevStates) el.prevStates = null;
            });
        }
        function updateStates(model, view) {
            var stateAnimationModel = model.getModel('stateAnimation');
            var enableAnimation = model.isAnimationEnabled();
            var duration = stateAnimationModel.get('duration');
            var stateTransition = duration > 0 ? {
                duration: duration,
                delay: stateAnimationModel.get('delay'),
                easing: stateAnimationModel.get('easing')
            } : null;
            view.eachRendered(function(el) {
                if (el.states && el.states.emphasis) {
                    // Not applied on removed elements, it may still in fading.
                    if ($d2a962ec0ef14a79$export$5b89d4b643713034(el)) return;
                    if (el instanceof $340211037b56ba3f$export$2e2bcd8739ae039) (0, $1f99b77b45f30655$export$9fe78019e6f395b6)(el);
                    // Only updated on changed element. In case element is incremental and don't want to rerender.
                    // TODO, a more proper way?
                    if (el.__dirty) {
                        var prevStates = el.prevStates;
                        // Restore states without animation
                        if (prevStates) el.useStates(prevStates);
                    }
                    // Update state transition and enable animation again.
                    if (enableAnimation) {
                        el.stateTransition = stateTransition;
                        var textContent = el.getTextContent();
                        var textGuide = el.getTextGuideLine();
                        // TODO Is it necessary to animate label?
                        if (textContent) textContent.stateTransition = stateTransition;
                        if (textGuide) textGuide.stateTransition = stateTransition;
                    }
                    // Use highlighted and selected flag to toggle states.
                    if (el.__dirty) applyElementStates(el);
                }
            });
        }
        $ef39f475dab603c1$var$createExtensionAPI = function createExtensionAPI(ecIns) {
            return new /** @class */ (function(_super) {
                (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(class_1, _super);
                function class_1() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                class_1.prototype.getCoordinateSystems = function() {
                    return ecIns._coordSysMgr.getCoordinateSystems();
                };
                class_1.prototype.getComponentByElement = function(el) {
                    while(el){
                        var modelInfo = el.__ecComponentInfo;
                        if (modelInfo != null) return ecIns._model.getComponent(modelInfo.mainType, modelInfo.index);
                        el = el.parent;
                    }
                };
                class_1.prototype.enterEmphasis = function(el, highlightDigit) {
                    (0, $1f99b77b45f30655$export$b2d02638cc34c042)(el, highlightDigit);
                    $ef39f475dab603c1$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveEmphasis = function(el, highlightDigit) {
                    (0, $1f99b77b45f30655$export$11be6f716239ac55)(el, highlightDigit);
                    $ef39f475dab603c1$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterBlur = function(el) {
                    (0, $1f99b77b45f30655$export$207f9cb3e1099375)(el);
                    $ef39f475dab603c1$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveBlur = function(el) {
                    (0, $1f99b77b45f30655$export$fd4a9ec75456d3c1)(el);
                    $ef39f475dab603c1$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterSelect = function(el) {
                    (0, $1f99b77b45f30655$export$252d028dda8ef765)(el);
                    $ef39f475dab603c1$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveSelect = function(el) {
                    (0, $1f99b77b45f30655$export$ea9a904bd6e32bd3)(el);
                    $ef39f475dab603c1$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.getModel = function() {
                    return ecIns.getModel();
                };
                class_1.prototype.getViewOfComponentModel = function(componentModel) {
                    return ecIns.getViewOfComponentModel(componentModel);
                };
                class_1.prototype.getViewOfSeriesModel = function(seriesModel) {
                    return ecIns.getViewOfSeriesModel(seriesModel);
                };
                class_1.prototype.getECUpdateCycleVersion = function() {
                    return ecIns[$ef39f475dab603c1$var$EC_UPDATE_CYCLE_VERSION_KEY];
                };
                class_1.prototype.usingTHL = function() {
                    return ecIns._usingTHL;
                };
                return class_1;
            }((0, $d64c00067dc939f7$export$2e2bcd8739ae039)))(ecIns);
        };
        $ef39f475dab603c1$var$enableConnect = function enableConnect(chart) {
            function updateConnectedChartsStatus(charts, status) {
                for(var i = 0; i < charts.length; i++){
                    var otherChart = charts[i];
                    otherChart[$ef39f475dab603c1$var$CONNECT_STATUS_KEY] = status;
                }
            }
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)($ef39f475dab603c1$var$connectionEventRevertMap, function(_, eventType) {
                chart._messageCenter.on(eventType, function(event) {
                    if ($ef39f475dab603c1$var$connectedGroups[chart.group] && chart[$ef39f475dab603c1$var$CONNECT_STATUS_KEY] !== $ef39f475dab603c1$var$CONNECT_STATUS_PENDING) {
                        if (event && event.escapeConnect) return;
                        var action_1 = chart.makeActionFromEvent(event);
                        var otherCharts_1 = [];
                        (0, $f16f2994a32ad273$export$79b2f7037acddd43)($ef39f475dab603c1$var$instances, function(otherChart) {
                            if (otherChart !== chart && otherChart.group === chart.group) otherCharts_1.push(otherChart);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $ef39f475dab603c1$var$CONNECT_STATUS_PENDING);
                        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(otherCharts_1, function(otherChart) {
                            if (otherChart[$ef39f475dab603c1$var$CONNECT_STATUS_KEY] !== $ef39f475dab603c1$var$CONNECT_STATUS_UPDATING) otherChart.dispatchAction(action_1);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $ef39f475dab603c1$var$CONNECT_STATUS_UPDATED);
                    }
                });
            });
        };
    }();
    return ECharts;
}((0, $83f1d7c1143fe0f3$export$2e2bcd8739ae039));
var $ef39f475dab603c1$var$echartsProto = $ef39f475dab603c1$var$ECharts.prototype;
$ef39f475dab603c1$var$echartsProto.on = $ef39f475dab603c1$var$createRegisterEventWithLowercaseECharts('on');
$ef39f475dab603c1$var$echartsProto.off = $ef39f475dab603c1$var$createRegisterEventWithLowercaseECharts('off');
/**
 * @deprecated
 */ // @ts-ignore
$ef39f475dab603c1$var$echartsProto.one = function(eventName, cb, ctx) {
    var self = this;
    (0, $ec53fe68074e6f74$export$4a9c0b74eb885aa1)('ECharts#one is deprecated.');
    function wrapped() {
        var args2 = [];
        for(var _i = 0; _i < arguments.length; _i++)args2[_i] = arguments[_i];
        cb && cb.apply && cb.apply(this, args2);
        // @ts-ignore
        self.off(eventName, wrapped);
    }
    // @ts-ignore
    this.on.call(this, eventName, wrapped, ctx);
};
var $ef39f475dab603c1$var$MOUSE_EVENT_NAMES = [
    'click',
    'dblclick',
    'mouseover',
    'mouseout',
    'mousemove',
    'mousedown',
    'mouseup',
    'globalout',
    'contextmenu'
];
function $ef39f475dab603c1$var$disposedWarning(id) {}
var $ef39f475dab603c1$var$actions = {};
/**
 * Map event type to action type for reproducing action from event for `connect`.
 */ var $ef39f475dab603c1$var$connectionEventRevertMap = {};
/**
 * To remove duplication.
 */ var $ef39f475dab603c1$var$publicEventTypeMap = {};
var $ef39f475dab603c1$var$dataProcessorFuncs = [];
var $ef39f475dab603c1$var$optionPreprocessorFuncs = [];
var $ef39f475dab603c1$var$visualFuncs = [];
var $ef39f475dab603c1$var$themeStorage = {};
var $ef39f475dab603c1$var$loadingEffects = {};
var $ef39f475dab603c1$var$instances = {};
var $ef39f475dab603c1$var$connectedGroups = {};
var $ef39f475dab603c1$var$idBase = +new Date() - 0;
var $ef39f475dab603c1$var$groupIdBase = +new Date() - 0;
var $ef39f475dab603c1$var$DOM_ATTRIBUTE_KEY = '_echarts_instance_';
function $ef39f475dab603c1$export$2cd8252107eb640b(dom, theme, opts) {
    var isClient = !(opts && opts.ssr);
    if (isClient) {
        var existInstance = $ef39f475dab603c1$export$33b6fbccd4f643f8(dom);
        if (existInstance) return existInstance;
    }
    var chart = new $ef39f475dab603c1$var$ECharts(dom, theme, opts);
    chart.id = 'ec_' + $ef39f475dab603c1$var$idBase++;
    $ef39f475dab603c1$var$instances[chart.id] = chart;
    isClient && $3fa81475350067fd$export$9fec4d97f1922e0b(dom, $ef39f475dab603c1$var$DOM_ATTRIBUTE_KEY, chart.id);
    $ef39f475dab603c1$var$enableConnect(chart);
    (0, $a4a481f8e97330f1$export$2e2bcd8739ae039).trigger('afterinit', chart);
    return chart;
}
function $ef39f475dab603c1$export$64605811ab45167f(groupId) {
    // Is array of charts
    if ((0, $f16f2994a32ad273$export$43bee75e5e14138e)(groupId)) {
        var charts = groupId;
        groupId = null;
        // If any chart has group
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(charts, function(chart) {
            if (chart.group != null) groupId = chart.group;
        });
        groupId = groupId || 'g_' + $ef39f475dab603c1$var$groupIdBase++;
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(charts, function(chart) {
            chart.group = groupId;
        });
    }
    $ef39f475dab603c1$var$connectedGroups[groupId] = true;
    return groupId;
}
function $ef39f475dab603c1$export$37dfea93db2e14ed(groupId) {
    $ef39f475dab603c1$var$connectedGroups[groupId] = false;
}
var $ef39f475dab603c1$export$87cd6834112ecb52 = $ef39f475dab603c1$export$37dfea93db2e14ed;
function $ef39f475dab603c1$export$fcfbbcec2cb820d5(chart) {
    if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(chart)) chart = $ef39f475dab603c1$var$instances[chart];
    else if (!(chart instanceof $ef39f475dab603c1$var$ECharts)) // Try to treat as dom
    chart = $ef39f475dab603c1$export$33b6fbccd4f643f8(chart);
    if (chart instanceof $ef39f475dab603c1$var$ECharts && !chart.isDisposed()) chart.dispose();
}
function $ef39f475dab603c1$export$33b6fbccd4f643f8(dom) {
    return $ef39f475dab603c1$var$instances[$3fa81475350067fd$export$735ee1799fd02602(dom, $ef39f475dab603c1$var$DOM_ATTRIBUTE_KEY)];
}
function $ef39f475dab603c1$export$89b4be35062c4a3f(key) {
    return $ef39f475dab603c1$var$instances[key];
}
function $ef39f475dab603c1$export$f9c59eed5de5ff80(name, theme) {
    $ef39f475dab603c1$var$themeStorage[name] = theme;
}
function $ef39f475dab603c1$export$77095792a057b768(preprocessorFunc) {
    if ((0, $f16f2994a32ad273$export$305f7d4e9d4624f2)($ef39f475dab603c1$var$optionPreprocessorFuncs, preprocessorFunc) < 0) $ef39f475dab603c1$var$optionPreprocessorFuncs.push(preprocessorFunc);
}
function $ef39f475dab603c1$export$d575e6557ac1729f(priority, processor) {
    $ef39f475dab603c1$var$normalizeRegister($ef39f475dab603c1$var$dataProcessorFuncs, priority, processor, $ef39f475dab603c1$var$PRIORITY_PROCESSOR_DEFAULT);
}
function $ef39f475dab603c1$export$c8c249911ee8c1ed(postInitFunc) {
    $ef39f475dab603c1$export$c9ec4b5faef04865('afterinit', postInitFunc);
}
function $ef39f475dab603c1$export$99560909c18c76bb(postUpdateFunc) {
    $ef39f475dab603c1$export$c9ec4b5faef04865('afterupdate', postUpdateFunc);
}
function $ef39f475dab603c1$export$c9ec4b5faef04865(name, cb) {
    (0, $a4a481f8e97330f1$export$2e2bcd8739ae039).on(name, cb);
}
function $ef39f475dab603c1$export$408c24786cd729c6(arg0, arg1, action) {
    var actionType;
    var publicEventType;
    var refineEvent;
    var update;
    var publishNonRefinedEvent;
    if ((0, $f16f2994a32ad273$export$f6e2535fb5126e54)(arg1)) {
        action = arg1;
        arg1 = '';
    }
    if ((0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(arg0)) {
        actionType = arg0.type;
        publicEventType = arg0.event;
        update = arg0.update;
        publishNonRefinedEvent = arg0.publishNonRefinedEvent;
        if (!action) action = arg0.action;
        refineEvent = arg0.refineEvent;
    } else {
        actionType = arg0;
        publicEventType = arg1;
    }
    function createEventType(actionOrEventType) {
        // Event type should be all lowercase
        return actionOrEventType.toLowerCase();
    }
    publicEventType = createEventType(publicEventType || actionType);
    // See comments on {ActionInfo} for the reason.
    var nonRefinedEventType = refineEvent ? createEventType(actionType) : publicEventType;
    // Support calling `registerAction` multiple times with the same action
    // type; subsequent calls have no effect.
    if ($ef39f475dab603c1$var$actions[actionType]) return;
    // Validate action type and event name.
    (0, $f16f2994a32ad273$export$a7a9523472993e97)($ef39f475dab603c1$var$ACTION_REG.test(actionType) && $ef39f475dab603c1$var$ACTION_REG.test(publicEventType));
    if (refineEvent) // An event replicated from the action will be triggered internally for `connect` in this case.
    (0, $f16f2994a32ad273$export$a7a9523472993e97)(publicEventType !== actionType);
    $ef39f475dab603c1$var$actions[actionType] = {
        actionType: actionType,
        refinedEventType: publicEventType,
        nonRefinedEventType: nonRefinedEventType,
        update: update,
        action: action,
        refineEvent: refineEvent
    };
    $ef39f475dab603c1$var$publicEventTypeMap[publicEventType] = 1;
    if (refineEvent && publishNonRefinedEvent) $ef39f475dab603c1$var$publicEventTypeMap[nonRefinedEventType] = 1;
    $ef39f475dab603c1$var$connectionEventRevertMap[nonRefinedEventType] = actionType;
}
function $ef39f475dab603c1$export$1dd5e025a8a37dd(type, coordSysCreator) {
    (0, $d1c2b348f154f767$export$2e2bcd8739ae039).register(type, coordSysCreator);
}
function $ef39f475dab603c1$export$fc2638719e4159b9(type) {
    var coordSysCreator = (0, $d1c2b348f154f767$export$2e2bcd8739ae039).get(type);
    if (coordSysCreator) return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
}
function $ef39f475dab603c1$export$c3e61191887968da(seriesType, renderItem) {
    (0, $2525bf86f8f37ab9$export$c3e61191887968da)(seriesType, renderItem);
}
function $ef39f475dab603c1$export$d768f97700ca6bea(priority, layoutTask) {
    $ef39f475dab603c1$var$normalizeRegister($ef39f475dab603c1$var$visualFuncs, priority, layoutTask, $ef39f475dab603c1$var$PRIORITY_VISUAL_LAYOUT, 'layout', true);
}
function $ef39f475dab603c1$export$5f32c1eb94c381bb(priority, visualTask) {
    $ef39f475dab603c1$var$normalizeRegister($ef39f475dab603c1$var$visualFuncs, priority, visualTask, $ef39f475dab603c1$var$PRIORITY_VISUAL_CHART, 'visual', true);
}
var $ef39f475dab603c1$var$registeredTasks = [];
function $ef39f475dab603c1$var$normalizeRegister(targetList, priority, fn, defaultPriority, visualType, checkBlock) {
    if ((0, $f16f2994a32ad273$export$f6e2535fb5126e54)(priority) || (0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(priority)) {
        fn = priority;
        priority = defaultPriority;
    }
    // Already registered
    if ((0, $f16f2994a32ad273$export$305f7d4e9d4624f2)($ef39f475dab603c1$var$registeredTasks, fn) >= 0) return;
    $ef39f475dab603c1$var$registeredTasks.push(fn);
    var stageHandler = (0, $fe0278d7cd20db39$export$2e2bcd8739ae039).wrapStageHandler(fn, visualType);
    stageHandler.__prio = priority;
    stageHandler.__raw = fn;
    targetList.push(stageHandler);
}
function $ef39f475dab603c1$export$e06b68a82007c015(name, loadingFx) {
    $ef39f475dab603c1$var$loadingEffects[name] = loadingFx;
}
function $ef39f475dab603c1$export$10425ea7a243b114(creator) {
    (0, $e4ffe803d17351c8$export$61bcfd79465c1b7c)({
        createCanvas: creator
    });
}
function $ef39f475dab603c1$export$d456de060be2dba1(mapName, geoJson, specialAreas) {
    var registerMap = (0, $61724d3be20b47ac$export$73333eb8a09d5f61)('registerMap');
    registerMap && registerMap(mapName, geoJson, specialAreas);
}
function $ef39f475dab603c1$export$b8586192aead8a7e(mapName) {
    var getMap = (0, $61724d3be20b47ac$export$73333eb8a09d5f61)('getMap');
    return getMap && getMap(mapName);
}
var $ef39f475dab603c1$export$f01d71dd0389d7e4 = (0, $6b1c7afb889b71f1$export$92c96c6d8b255b7d);
/**
 * Global dispatchAction to a specified chart instance.
 */ // export function dispatchAction(payload: { chartId: string } & Payload, opt?: Parameters<ECharts['dispatchAction']>[1]) {
//     if (!payload || !payload.chartId) {
//         // Must have chartId to find chart
//         return;
//     }
//     const chart = instances[payload.chartId];
//     if (chart) {
//         chart.dispatchAction(payload, opt);
//     }
// }
// Builtin global visual
$ef39f475dab603c1$export$5f32c1eb94c381bb($ef39f475dab603c1$var$PRIORITY_VISUAL_GLOBAL, (0, $c2d6379aa2d37c3a$export$7ce4d65f9b69240));
$ef39f475dab603c1$export$5f32c1eb94c381bb($ef39f475dab603c1$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $c2d6379aa2d37c3a$export$f7dcb66a065003d1));
$ef39f475dab603c1$export$5f32c1eb94c381bb($ef39f475dab603c1$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $c2d6379aa2d37c3a$export$cf9758b0d6dc0aa9));
$ef39f475dab603c1$export$5f32c1eb94c381bb($ef39f475dab603c1$var$PRIORITY_VISUAL_GLOBAL, (0, $14ec89f6ed8380f9$export$144ac3beded415d9));
$ef39f475dab603c1$export$5f32c1eb94c381bb($ef39f475dab603c1$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $14ec89f6ed8380f9$export$435b956f7f1071fb));
$ef39f475dab603c1$export$5f32c1eb94c381bb($ef39f475dab603c1$var$PRIORITY_VISUAL_DECAL, (0, $c75a18ad5ca7e90c$export$218eea02a2a96fb4));
$ef39f475dab603c1$export$77095792a057b768((0, $5489e37b9bdb0718$export$2e2bcd8739ae039));
$ef39f475dab603c1$export$d575e6557ac1729f($ef39f475dab603c1$var$PRIORITY_PROCESSOR_DATASTACK, (0, $8bcda5b0a988ff47$export$dc018729d9e78c17));
$ef39f475dab603c1$export$e06b68a82007c015('default', (0, $02c296a9317c442e$export$2e2bcd8739ae039));
// Default actions
$ef39f475dab603c1$export$408c24786cd729c6({
    type: (0, $1f99b77b45f30655$export$df035d873a9de64f),
    event: (0, $1f99b77b45f30655$export$df035d873a9de64f),
    update: (0, $1f99b77b45f30655$export$df035d873a9de64f)
}, (0, $f16f2994a32ad273$export$8793edee2d425525));
$ef39f475dab603c1$export$408c24786cd729c6({
    type: (0, $1f99b77b45f30655$export$f8a2f7807cc185ea),
    event: (0, $1f99b77b45f30655$export$f8a2f7807cc185ea),
    update: (0, $1f99b77b45f30655$export$f8a2f7807cc185ea)
}, (0, $f16f2994a32ad273$export$8793edee2d425525));
$ef39f475dab603c1$export$408c24786cd729c6({
    type: (0, $1f99b77b45f30655$export$89616263e7d38fe9),
    event: (0, $1f99b77b45f30655$export$67f8c62bcdfbd39f),
    update: (0, $1f99b77b45f30655$export$89616263e7d38fe9),
    action: (0, $f16f2994a32ad273$export$8793edee2d425525),
    refineEvent: $ef39f475dab603c1$var$makeSelectChangedEvent,
    publishNonRefinedEvent: true
});
$ef39f475dab603c1$export$408c24786cd729c6({
    type: (0, $1f99b77b45f30655$export$7636ad95c0f68a79),
    event: (0, $1f99b77b45f30655$export$67f8c62bcdfbd39f),
    update: (0, $1f99b77b45f30655$export$7636ad95c0f68a79),
    action: (0, $f16f2994a32ad273$export$8793edee2d425525),
    refineEvent: $ef39f475dab603c1$var$makeSelectChangedEvent,
    publishNonRefinedEvent: true
});
$ef39f475dab603c1$export$408c24786cd729c6({
    type: (0, $1f99b77b45f30655$export$1e90ed8a25542516),
    event: (0, $1f99b77b45f30655$export$67f8c62bcdfbd39f),
    update: (0, $1f99b77b45f30655$export$1e90ed8a25542516),
    action: (0, $f16f2994a32ad273$export$8793edee2d425525),
    refineEvent: $ef39f475dab603c1$var$makeSelectChangedEvent,
    publishNonRefinedEvent: true
});
function $ef39f475dab603c1$var$makeSelectChangedEvent(actionResultBatch, payload, ecModel, api) {
    return {
        eventContent: {
            selected: (0, $1f99b77b45f30655$export$c529643b619af6b3)(ecModel),
            isFromClick: payload.isFromClick || false
        }
    };
}
// Default theme, so that we can use `chart.setTheme('default')` to revert to
// the default theme after changing to other themes.
$ef39f475dab603c1$export$f9c59eed5de5ff80('default', {});
$ef39f475dab603c1$export$f9c59eed5de5ff80('dark', (0, $7f979ae857090a6c$export$2e2bcd8739ae039));
var $ef39f475dab603c1$export$73cae5e090579589 = {};










var $5b64c22a7e1cb8f6$var$extensions = [];
var $5b64c22a7e1cb8f6$var$extensionRegisters = {
    registerPreprocessor: (0, $ef39f475dab603c1$export$77095792a057b768),
    registerProcessor: (0, $ef39f475dab603c1$export$d575e6557ac1729f),
    registerPostInit: (0, $ef39f475dab603c1$export$c8c249911ee8c1ed),
    registerPostUpdate: (0, $ef39f475dab603c1$export$99560909c18c76bb),
    registerUpdateLifecycle: (0, $ef39f475dab603c1$export$c9ec4b5faef04865),
    registerAction: (0, $ef39f475dab603c1$export$408c24786cd729c6),
    registerCoordinateSystem: (0, $ef39f475dab603c1$export$1dd5e025a8a37dd),
    registerLayout: (0, $ef39f475dab603c1$export$d768f97700ca6bea),
    registerVisual: (0, $ef39f475dab603c1$export$5f32c1eb94c381bb),
    registerTransform: (0, $ef39f475dab603c1$export$f01d71dd0389d7e4),
    registerLoading: (0, $ef39f475dab603c1$export$e06b68a82007c015),
    registerMap: (0, $ef39f475dab603c1$export$d456de060be2dba1),
    registerImpl: (0, $61724d3be20b47ac$export$9b808fd12256ddd3),
    PRIORITY: (0, $ef39f475dab603c1$export$bb34f3538ba26c7e),
    ComponentModel: (0, $c418de54527e13f3$export$2e2bcd8739ae039),
    ComponentView: (0, $091798b5bbee0498$export$2e2bcd8739ae039),
    SeriesModel: (0, $80ec9a06634f90ca$export$2e2bcd8739ae039),
    ChartView: (0, $3644e1b3c8e5afa0$export$2e2bcd8739ae039),
    // TODO Use ComponentModel and SeriesModel instead of Constructor
    registerComponentModel: function registerComponentModel(ComponentModelClass) {
        (0, $c418de54527e13f3$export$2e2bcd8739ae039).registerClass(ComponentModelClass);
    },
    registerComponentView: function registerComponentView(ComponentViewClass) {
        (0, $091798b5bbee0498$export$2e2bcd8739ae039).registerClass(ComponentViewClass);
    },
    registerSeriesModel: function registerSeriesModel(SeriesModelClass) {
        (0, $80ec9a06634f90ca$export$2e2bcd8739ae039).registerClass(SeriesModelClass);
    },
    registerChartView: function registerChartView(ChartViewClass) {
        (0, $3644e1b3c8e5afa0$export$2e2bcd8739ae039).registerClass(ChartViewClass);
    },
    registerCustomSeries: function registerCustomSeries1(seriesType, renderItem) {
        (0, $2525bf86f8f37ab9$export$c3e61191887968da)(seriesType, renderItem);
    },
    registerSubTypeDefaulter: function registerSubTypeDefaulter(componentType, defaulter) {
        (0, $c418de54527e13f3$export$2e2bcd8739ae039).registerSubTypeDefaulter(componentType, defaulter);
    },
    registerPainter: function registerPainter1(painterType, PainterCtor) {
        (0, $85632cfbb825ab09$export$a3e793ccb11823a5)(painterType, PainterCtor);
    }
};
function $5b64c22a7e1cb8f6$export$1f96ae73734a86cc(ext) {
    if ((0, $f16f2994a32ad273$export$43bee75e5e14138e)(ext)) {
        // use([ChartLine, ChartBar]);
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(ext, function(singleExt) {
            $5b64c22a7e1cb8f6$export$1f96ae73734a86cc(singleExt);
        });
        return;
    }
    if ((0, $f16f2994a32ad273$export$305f7d4e9d4624f2)($5b64c22a7e1cb8f6$var$extensions, ext) >= 0) return;
    $5b64c22a7e1cb8f6$var$extensions.push(ext);
    if ((0, $f16f2994a32ad273$export$f6e2535fb5126e54)(ext)) ext = {
        install: ext
    };
    ext.install($5b64c22a7e1cb8f6$var$extensionRegisters);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $b1b0f95f08e89ae1$var$mathSin = Math.sin;
var $b1b0f95f08e89ae1$var$mathCos = Math.cos;
var $b1b0f95f08e89ae1$var$PI = Math.PI;
var $b1b0f95f08e89ae1$var$PI2 = Math.PI * 2;
var $b1b0f95f08e89ae1$var$degree = 180 / $b1b0f95f08e89ae1$var$PI;
var $b1b0f95f08e89ae1$var$SVGPathRebuilder = function() {
    function SVGPathRebuilder() {}
    SVGPathRebuilder.prototype.reset = function(precision) {
        this._start = true;
        this._d = [];
        this._str = '';
        this._p = Math.pow(10, precision || 4);
    };
    SVGPathRebuilder.prototype.moveTo = function(x, y) {
        this._add('M', x, y);
    };
    SVGPathRebuilder.prototype.lineTo = function(x, y) {
        this._add('L', x, y);
    };
    SVGPathRebuilder.prototype.bezierCurveTo = function(x, y, x2, y2, x3, y3) {
        this._add('C', x, y, x2, y2, x3, y3);
    };
    SVGPathRebuilder.prototype.quadraticCurveTo = function(x, y, x2, y2) {
        this._add('Q', x, y, x2, y2);
    };
    SVGPathRebuilder.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this.ellipse(cx, cy, r, r, 0, startAngle, endAngle, anticlockwise);
    };
    SVGPathRebuilder.prototype.ellipse = function(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise) {
        var dTheta = endAngle - startAngle;
        var clockwise = !anticlockwise;
        var dThetaPositive = Math.abs(dTheta);
        var isCircle = (0, $6e7232f7ffc8c94f$export$4701367f5b4de464)(dThetaPositive - $b1b0f95f08e89ae1$var$PI2) || (clockwise ? dTheta >= $b1b0f95f08e89ae1$var$PI2 : -dTheta >= $b1b0f95f08e89ae1$var$PI2);
        var unifiedTheta = dTheta > 0 ? dTheta % $b1b0f95f08e89ae1$var$PI2 : dTheta % $b1b0f95f08e89ae1$var$PI2 + $b1b0f95f08e89ae1$var$PI2;
        var large = false;
        if (isCircle) large = true;
        else if ((0, $6e7232f7ffc8c94f$export$4701367f5b4de464)(dThetaPositive)) large = false;
        else large = unifiedTheta >= $b1b0f95f08e89ae1$var$PI === !!clockwise;
        var x0 = cx + rx * $b1b0f95f08e89ae1$var$mathCos(startAngle);
        var y0 = cy + ry * $b1b0f95f08e89ae1$var$mathSin(startAngle);
        if (this._start) this._add('M', x0, y0);
        var xRot = Math.round(psi * $b1b0f95f08e89ae1$var$degree);
        if (isCircle) {
            var p = 1 / this._p;
            var dTheta_1 = (clockwise ? 1 : -1) * ($b1b0f95f08e89ae1$var$PI2 - p);
            this._add('A', rx, ry, xRot, 1, +clockwise, cx + rx * $b1b0f95f08e89ae1$var$mathCos(startAngle + dTheta_1), cy + ry * $b1b0f95f08e89ae1$var$mathSin(startAngle + dTheta_1));
            if (p > 1e-2) this._add('A', rx, ry, xRot, 0, +clockwise, x0, y0);
        } else {
            var x = cx + rx * $b1b0f95f08e89ae1$var$mathCos(endAngle);
            var y = cy + ry * $b1b0f95f08e89ae1$var$mathSin(endAngle);
            this._add('A', rx, ry, xRot, +large, +clockwise, x, y);
        }
    };
    SVGPathRebuilder.prototype.rect = function(x, y, w, h) {
        this._add('M', x, y);
        this._add('l', w, 0);
        this._add('l', 0, h);
        this._add('l', -w, 0);
        this._add('Z');
    };
    SVGPathRebuilder.prototype.closePath = function() {
        if (this._d.length > 0) this._add('Z');
    };
    SVGPathRebuilder.prototype._add = function(cmd, a, b, c, d, e, f, g, h) {
        var vals = [];
        var p = this._p;
        for(var i = 1; i < arguments.length; i++){
            var val = arguments[i];
            if (isNaN(val)) {
                this._invalid = true;
                return;
            }
            vals.push(Math.round(val * p) / p);
        }
        this._d.push(cmd + vals.join(' '));
        this._start = cmd === 'Z';
    };
    SVGPathRebuilder.prototype.generateStr = function() {
        this._str = this._invalid ? '' : this._d.join('');
        this._d = [];
    };
    SVGPathRebuilder.prototype.getStr = function() {
        return this._str;
    };
    return SVGPathRebuilder;
}();
var $b1b0f95f08e89ae1$export$2e2bcd8739ae039 = $b1b0f95f08e89ae1$var$SVGPathRebuilder;







var $79277f1445e31766$var$NONE = 'none';
var $79277f1445e31766$var$mathRound = Math.round;
function $79277f1445e31766$var$pathHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== $79277f1445e31766$var$NONE;
}
function $79277f1445e31766$var$pathHasStroke(style) {
    var stroke = style.stroke;
    return stroke != null && stroke !== $79277f1445e31766$var$NONE;
}
var $79277f1445e31766$var$strokeProps = [
    'lineCap',
    'miterLimit',
    'lineJoin'
];
var $79277f1445e31766$var$svgStrokeProps = (0, $f16f2994a32ad273$export$871de8747c9eaa88)($79277f1445e31766$var$strokeProps, function(prop) {
    return "stroke-" + prop.toLowerCase();
});
function $79277f1445e31766$export$2e2bcd8739ae039(updateAttr, style, el, forceUpdate) {
    var opacity = style.opacity == null ? 1 : style.opacity;
    if (el instanceof (0, $0eafea320dbd53c3$export$2e2bcd8739ae039)) {
        updateAttr('opacity', opacity);
        return;
    }
    if ($79277f1445e31766$var$pathHasFill(style)) {
        var fill = (0, $6e7232f7ffc8c94f$export$4cde5df63f53f473)(style.fill);
        updateAttr('fill', fill.color);
        var fillOpacity = style.fillOpacity != null ? style.fillOpacity * fill.opacity * opacity : fill.opacity * opacity;
        if (forceUpdate || fillOpacity < 1) updateAttr('fill-opacity', fillOpacity);
    } else updateAttr('fill', $79277f1445e31766$var$NONE);
    if ($79277f1445e31766$var$pathHasStroke(style)) {
        var stroke = (0, $6e7232f7ffc8c94f$export$4cde5df63f53f473)(style.stroke);
        updateAttr('stroke', stroke.color);
        var strokeScale = style.strokeNoScale ? el.getLineScale() : 1;
        var strokeWidth = strokeScale ? (style.lineWidth || 0) / strokeScale : 0;
        var strokeOpacity = style.strokeOpacity != null ? style.strokeOpacity * stroke.opacity * opacity : stroke.opacity * opacity;
        var strokeFirst = style.strokeFirst;
        if (forceUpdate || strokeWidth !== 1) updateAttr('stroke-width', strokeWidth);
        if (forceUpdate || strokeFirst) updateAttr('paint-order', strokeFirst ? 'stroke' : 'fill');
        if (forceUpdate || strokeOpacity < 1) updateAttr('stroke-opacity', strokeOpacity);
        if (style.lineDash) {
            var _a = (0, $aad4ef1417b2b108$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
            if (lineDash) {
                lineDashOffset = $79277f1445e31766$var$mathRound(lineDashOffset || 0);
                updateAttr('stroke-dasharray', lineDash.join(','));
                if (lineDashOffset || forceUpdate) updateAttr('stroke-dashoffset', lineDashOffset);
            }
        } else if (forceUpdate) updateAttr('stroke-dasharray', $79277f1445e31766$var$NONE);
        for(var i = 0; i < $79277f1445e31766$var$strokeProps.length; i++){
            var propName = $79277f1445e31766$var$strokeProps[i];
            if (forceUpdate || style[propName] !== (0, $340211037b56ba3f$export$deade517576e293a)[propName]) {
                var val = style[propName] || (0, $340211037b56ba3f$export$deade517576e293a)[propName];
                val && updateAttr($79277f1445e31766$var$svgStrokeProps[i], val);
            }
        }
    } else if (forceUpdate) updateAttr('stroke', $79277f1445e31766$var$NONE);
}




var $4621cba181046b2d$export$a690ad4c9a38f86e = 'http://www.w3.org/2000/svg';
var $4621cba181046b2d$export$b22c6da1792ecec8 = 'http://www.w3.org/1999/xlink';
var $4621cba181046b2d$export$fac09d762d15fa3b = 'http://www.w3.org/2000/xmlns/';
var $4621cba181046b2d$export$ad4c4fdecd3b4156 = 'http://www.w3.org/XML/1998/namespace';
var $4621cba181046b2d$export$d3f79611f155197c = 'ecmeta_';
function $4621cba181046b2d$export$c8a8987d4410bf2d(name) {
    return document.createElementNS($4621cba181046b2d$export$a690ad4c9a38f86e, name);
}
function $4621cba181046b2d$export$bf5c4cf060303d58(tag, key, attrs, children, text) {
    return {
        tag: tag,
        attrs: attrs || {},
        children: children,
        text: text,
        key: key
    };
}
function $4621cba181046b2d$var$createElementOpen(name, attrs) {
    var attrsStr = [];
    if (attrs) for(var key in attrs){
        var val = attrs[key];
        var part = key;
        if (val === false) continue;
        else if (val !== true && val != null) part += "=\"" + val + "\"";
        attrsStr.push(part);
    }
    return "<" + name + " " + attrsStr.join(' ') + ">";
}
function $4621cba181046b2d$var$createElementClose(name) {
    return "</" + name + ">";
}
function $4621cba181046b2d$export$f5c4a9a0e027f2b(el, opts) {
    opts = opts || {};
    var S = opts.newline ? '\n' : '';
    function convertElToString(el) {
        var children = el.children, tag = el.tag, attrs = el.attrs, text = el.text;
        return $4621cba181046b2d$var$createElementOpen(tag, attrs) + (tag !== 'style' ? (0, $288857a46a8969d9$export$f9d6449b9af28dc1)(text) : text || '') + (children ? "" + S + (0, $f16f2994a32ad273$export$871de8747c9eaa88)(children, function(child) {
            return convertElToString(child);
        }).join(S) + S : '') + $4621cba181046b2d$var$createElementClose(tag);
    }
    return convertElToString(el);
}
function $4621cba181046b2d$export$e2b4f3597c7a7dcb(selectorNodes, animationNodes, opts) {
    opts = opts || {};
    var S = opts.newline ? '\n' : '';
    var bracketBegin = " {" + S;
    var bracketEnd = S + "}";
    var selectors = (0, $f16f2994a32ad273$export$871de8747c9eaa88)((0, $f16f2994a32ad273$export$ed97f33186d4b816)(selectorNodes), function(className) {
        return className + bracketBegin + (0, $f16f2994a32ad273$export$871de8747c9eaa88)((0, $f16f2994a32ad273$export$ed97f33186d4b816)(selectorNodes[className]), function(attrName) {
            return attrName + ":" + selectorNodes[className][attrName] + ";";
        }).join(S) + bracketEnd;
    }).join(S);
    var animations = (0, $f16f2994a32ad273$export$871de8747c9eaa88)((0, $f16f2994a32ad273$export$ed97f33186d4b816)(animationNodes), function(animationName) {
        return "@keyframes " + animationName + bracketBegin + (0, $f16f2994a32ad273$export$871de8747c9eaa88)((0, $f16f2994a32ad273$export$ed97f33186d4b816)(animationNodes[animationName]), function(percent) {
            return percent + bracketBegin + (0, $f16f2994a32ad273$export$871de8747c9eaa88)((0, $f16f2994a32ad273$export$ed97f33186d4b816)(animationNodes[animationName][percent]), function(attrName) {
                var val = animationNodes[animationName][percent][attrName];
                if (attrName === 'd') val = "path(\"" + val + "\")";
                return attrName + ":" + val + ";";
            }).join(S) + bracketEnd;
        }).join(S) + bracketEnd;
    }).join(S);
    if (!selectors && !animations) return '';
    return [
        '<![CDATA[',
        selectors,
        animations,
        ']]>'
    ].join(S);
}
function $4621cba181046b2d$export$96fee5f38ed01741(zrId) {
    return {
        zrId: zrId,
        shadowCache: {},
        patternCache: {},
        gradientCache: {},
        clipPathCache: {},
        defs: {},
        cssNodes: {},
        cssAnims: {},
        cssStyleCache: {},
        cssAnimIdx: 0,
        shadowIdx: 0,
        gradientIdx: 0,
        patternIdx: 0,
        clipPathIdx: 0
    };
}
function $4621cba181046b2d$export$5529a6aad332ee75(width, height, children, useViewBox) {
    return $4621cba181046b2d$export$bf5c4cf060303d58('svg', 'root', {
        'width': width,
        'height': height,
        'xmlns': $4621cba181046b2d$export$a690ad4c9a38f86e,
        'xmlns:xlink': $4621cba181046b2d$export$b22c6da1792ecec8,
        'version': '1.1',
        'baseProfile': 'full',
        'viewBox': useViewBox ? "0 0 " + width + " " + height : false
    }, children);
}












var $e0a57109f64ae41e$var$cssClassIdx = 0;
function $e0a57109f64ae41e$export$9c80c36b7367fb56() {
    return $e0a57109f64ae41e$var$cssClassIdx++;
}


var $5159e0e8fc6398c7$export$54ee1847795bcf37 = {
    cubicIn: '0.32,0,0.67,0',
    cubicOut: '0.33,1,0.68,1',
    cubicInOut: '0.65,0,0.35,1',
    quadraticIn: '0.11,0,0.5,0',
    quadraticOut: '0.5,1,0.89,1',
    quadraticInOut: '0.45,0,0.55,1',
    quarticIn: '0.5,0,0.75,0',
    quarticOut: '0.25,1,0.5,1',
    quarticInOut: '0.76,0,0.24,1',
    quinticIn: '0.64,0,0.78,0',
    quinticOut: '0.22,1,0.36,1',
    quinticInOut: '0.83,0,0.17,1',
    sinusoidalIn: '0.12,0,0.39,0',
    sinusoidalOut: '0.61,1,0.88,1',
    sinusoidalInOut: '0.37,0,0.63,1',
    exponentialIn: '0.7,0,0.84,0',
    exponentialOut: '0.16,1,0.3,1',
    exponentialInOut: '0.87,0,0.13,1',
    circularIn: '0.55,0,1,0.45',
    circularOut: '0,0.55,0.45,1',
    circularInOut: '0.85,0,0.15,1'
};
var $5159e0e8fc6398c7$var$transformOriginKey = 'transform-origin';
function $5159e0e8fc6398c7$var$buildPathString(el, kfShape, path) {
    var shape = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, el.shape);
    (0, $f16f2994a32ad273$export$8b58be045bf06082)(shape, kfShape);
    el.buildPath(path, shape);
    var svgPathBuilder = new (0, $b1b0f95f08e89ae1$export$2e2bcd8739ae039)();
    svgPathBuilder.reset((0, $6e7232f7ffc8c94f$export$93fa1ae8a509371c)(el));
    path.rebuildPath(svgPathBuilder, 1);
    svgPathBuilder.generateStr();
    return svgPathBuilder.getStr();
}
function $5159e0e8fc6398c7$var$setTransformOrigin(target, transform) {
    var originX = transform.originX, originY = transform.originY;
    if (originX || originY) target[$5159e0e8fc6398c7$var$transformOriginKey] = originX + "px " + originY + "px";
}
var $5159e0e8fc6398c7$export$f0dede2064ee89d7 = {
    fill: 'fill',
    opacity: 'opacity',
    lineWidth: 'stroke-width',
    lineDashOffset: 'stroke-dashoffset'
};
function $5159e0e8fc6398c7$var$addAnimation(cssAnim, scope) {
    var animationName = scope.zrId + '-ani-' + scope.cssAnimIdx++;
    scope.cssAnims[animationName] = cssAnim;
    return animationName;
}
function $5159e0e8fc6398c7$var$createCompoundPathCSSAnimation(el, attrs, scope) {
    var paths = el.shape.paths;
    var composedAnim = {};
    var cssAnimationCfg;
    var cssAnimationName;
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(paths, function(path) {
        var subScope = (0, $4621cba181046b2d$export$96fee5f38ed01741)(scope.zrId);
        subScope.animation = true;
        $5159e0e8fc6398c7$export$dc9722e37397d426(path, {}, subScope, true);
        var cssAnims = subScope.cssAnims;
        var cssNodes = subScope.cssNodes;
        var animNames = (0, $f16f2994a32ad273$export$ed97f33186d4b816)(cssAnims);
        var len = animNames.length;
        if (!len) return;
        cssAnimationName = animNames[len - 1];
        var lastAnim = cssAnims[cssAnimationName];
        for(var percent in lastAnim){
            var kf = lastAnim[percent];
            composedAnim[percent] = composedAnim[percent] || {
                d: ''
            };
            composedAnim[percent].d += kf.d || '';
        }
        for(var className in cssNodes){
            var val = cssNodes[className].animation;
            if (val.indexOf(cssAnimationName) >= 0) cssAnimationCfg = val;
        }
    });
    if (!cssAnimationCfg) return;
    attrs.d = false;
    var animationName = $5159e0e8fc6398c7$var$addAnimation(composedAnim, scope);
    return cssAnimationCfg.replace(cssAnimationName, animationName);
}
function $5159e0e8fc6398c7$var$getEasingFunc(easing) {
    return (0, $f16f2994a32ad273$export$844ec244b1367d54)(easing) ? $5159e0e8fc6398c7$export$54ee1847795bcf37[easing] ? "cubic-bezier(" + $5159e0e8fc6398c7$export$54ee1847795bcf37[easing] + ")" : (0, $335ff30ca4c291b4$export$ec0863d806fd857e)(easing) ? easing : '' : '';
}
function $5159e0e8fc6398c7$export$dc9722e37397d426(el, attrs, scope, onlyShape) {
    var animators = el.animators;
    var len = animators.length;
    var cssAnimations = [];
    if (el instanceof (0, $9a457b474ed23e1f$export$2e2bcd8739ae039)) {
        var animationCfg = $5159e0e8fc6398c7$var$createCompoundPathCSSAnimation(el, attrs, scope);
        if (animationCfg) cssAnimations.push(animationCfg);
        else if (!len) return;
    } else if (!len) return;
    var groupAnimators = {};
    for(var i = 0; i < len; i++){
        var animator = animators[i];
        var cfgArr = [
            animator.getMaxTime() / 1000 + 's'
        ];
        var easing = $5159e0e8fc6398c7$var$getEasingFunc(animator.getClip().easing);
        var delay = animator.getDelay();
        if (easing) cfgArr.push(easing);
        else cfgArr.push('linear');
        if (delay) cfgArr.push(delay / 1000 + 's');
        if (animator.getLoop()) cfgArr.push('infinite');
        var cfg = cfgArr.join(' ');
        groupAnimators[cfg] = groupAnimators[cfg] || [
            cfg,
            []
        ];
        groupAnimators[cfg][1].push(animator);
    }
    function createSingleCSSAnimation(groupAnimator) {
        var animators = groupAnimator[1];
        var len = animators.length;
        var transformKfs = {};
        var shapeKfs = {};
        var finalKfs = {};
        var animationTimingFunctionAttrName = 'animation-timing-function';
        function saveAnimatorTrackToCssKfs(animator, cssKfs, toCssAttrName) {
            var tracks = animator.getTracks();
            var maxTime = animator.getMaxTime();
            for(var k = 0; k < tracks.length; k++){
                var track = tracks[k];
                if (track.needsAnimate()) {
                    var kfs = track.keyframes;
                    var attrName = track.propName;
                    toCssAttrName && (attrName = toCssAttrName(attrName));
                    if (attrName) for(var i = 0; i < kfs.length; i++){
                        var kf = kfs[i];
                        var percent = Math.round(kf.time / maxTime * 100) + '%';
                        var kfEasing = $5159e0e8fc6398c7$var$getEasingFunc(kf.easing);
                        var rawValue = kf.rawValue;
                        if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(rawValue) || (0, $f16f2994a32ad273$export$7e4aa119212bc614)(rawValue)) {
                            cssKfs[percent] = cssKfs[percent] || {};
                            cssKfs[percent][attrName] = kf.rawValue;
                            if (kfEasing) cssKfs[percent][animationTimingFunctionAttrName] = kfEasing;
                        }
                    }
                }
            }
        }
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            var targetProp = animator.targetName;
            if (!targetProp) !onlyShape && saveAnimatorTrackToCssKfs(animator, transformKfs);
            else if (targetProp === 'shape') saveAnimatorTrackToCssKfs(animator, shapeKfs);
        }
        for(var percent in transformKfs){
            var transform = {};
            (0, $ad30ab15d8ed0f32$export$234b1c16dfa57d6a)(transform, el);
            (0, $f16f2994a32ad273$export$8b58be045bf06082)(transform, transformKfs[percent]);
            var str = (0, $6e7232f7ffc8c94f$export$3fe07c0888ff6164)(transform);
            var timingFunction = transformKfs[percent][animationTimingFunctionAttrName];
            finalKfs[percent] = str ? {
                transform: str
            } : {};
            $5159e0e8fc6398c7$var$setTransformOrigin(finalKfs[percent], transform);
            if (timingFunction) finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
        }
        var path;
        var canAnimateShape = true;
        for(var percent in shapeKfs){
            finalKfs[percent] = finalKfs[percent] || {};
            var isFirst = !path;
            var timingFunction = shapeKfs[percent][animationTimingFunctionAttrName];
            if (isFirst) path = new (0, $af4d02a47e9b6a35$export$2e2bcd8739ae039)();
            var len_1 = path.len();
            path.reset();
            finalKfs[percent].d = $5159e0e8fc6398c7$var$buildPathString(el, shapeKfs[percent], path);
            var newLen = path.len();
            if (!isFirst && len_1 !== newLen) {
                canAnimateShape = false;
                break;
            }
            if (timingFunction) finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
        }
        if (!canAnimateShape) for(var percent in finalKfs)delete finalKfs[percent].d;
        if (!onlyShape) for(var i = 0; i < len; i++){
            var animator = animators[i];
            var targetProp = animator.targetName;
            if (targetProp === 'style') saveAnimatorTrackToCssKfs(animator, finalKfs, function(propName) {
                return $5159e0e8fc6398c7$export$f0dede2064ee89d7[propName];
            });
        }
        var percents = (0, $f16f2994a32ad273$export$ed97f33186d4b816)(finalKfs);
        var allTransformOriginSame = true;
        var transformOrigin;
        for(var i = 1; i < percents.length; i++){
            var p0 = percents[i - 1];
            var p1 = percents[i];
            if (finalKfs[p0][$5159e0e8fc6398c7$var$transformOriginKey] !== finalKfs[p1][$5159e0e8fc6398c7$var$transformOriginKey]) {
                allTransformOriginSame = false;
                break;
            }
            transformOrigin = finalKfs[p0][$5159e0e8fc6398c7$var$transformOriginKey];
        }
        if (allTransformOriginSame && transformOrigin) {
            for(var percent in finalKfs)if (finalKfs[percent][$5159e0e8fc6398c7$var$transformOriginKey]) delete finalKfs[percent][$5159e0e8fc6398c7$var$transformOriginKey];
            attrs[$5159e0e8fc6398c7$var$transformOriginKey] = transformOrigin;
        }
        if ((0, $f16f2994a32ad273$export$3dea766d36a8935f)(percents, function(percent) {
            return (0, $f16f2994a32ad273$export$ed97f33186d4b816)(finalKfs[percent]).length > 0;
        }).length) {
            var animationName = $5159e0e8fc6398c7$var$addAnimation(finalKfs, scope);
            return animationName + " " + groupAnimator[0] + " both";
        }
    }
    for(var key in groupAnimators){
        var animationCfg = createSingleCSSAnimation(groupAnimators[key]);
        if (animationCfg) cssAnimations.push(animationCfg);
    }
    if (cssAnimations.length) {
        var className = scope.zrId + '-cls-' + (0, $e0a57109f64ae41e$export$9c80c36b7367fb56)();
        scope.cssNodes['.' + className] = {
            animation: cssAnimations.join(',')
        };
        attrs["class"] = className;
    }
}






function $97e047c275f979c4$export$b4c8f742d3cb22ba(el, attrs, scope) {
    if (!el.ignore) {
        if (el.isSilent()) {
            var style = {
                'pointer-events': 'none'
            };
            $97e047c275f979c4$var$setClassAttribute(style, attrs, scope, true);
        } else {
            var emphasisStyle = el.states.emphasis && el.states.emphasis.style ? el.states.emphasis.style : {};
            var fill = emphasisStyle.fill;
            if (!fill) {
                var normalFill = el.style && el.style.fill;
                var selectFill = el.states.select && el.states.select.style && el.states.select.style.fill;
                var fromFill = el.currentStates.indexOf('select') >= 0 ? selectFill || normalFill : normalFill;
                if (fromFill) fill = (0, $83e50b4ee4d3c357$export$2b47e247dfb87a73)(fromFill);
            }
            var lineWidth = emphasisStyle.lineWidth;
            if (lineWidth) {
                var scaleX = !emphasisStyle.strokeNoScale && el.transform ? el.transform[0] : 1;
                lineWidth = lineWidth / scaleX;
            }
            var style = {
                cursor: 'pointer'
            };
            if (fill) style.fill = fill;
            if (emphasisStyle.stroke) style.stroke = emphasisStyle.stroke;
            if (lineWidth) style['stroke-width'] = lineWidth;
            $97e047c275f979c4$var$setClassAttribute(style, attrs, scope, true);
        }
    }
}
function $97e047c275f979c4$var$setClassAttribute(style, attrs, scope, withHover) {
    var styleKey = JSON.stringify(style);
    var className = scope.cssStyleCache[styleKey];
    if (!className) {
        className = scope.zrId + '-cls-' + (0, $e0a57109f64ae41e$export$9c80c36b7367fb56)();
        scope.cssStyleCache[styleKey] = className;
        scope.cssNodes['.' + className + (withHover ? ':hover' : '')] = style;
    }
    attrs["class"] = attrs["class"] ? attrs["class"] + ' ' + className : className;
}



var $52191fe33e71397c$var$round = Math.round;
function $52191fe33e71397c$var$isImageLike(val) {
    return val && (0, $f16f2994a32ad273$export$844ec244b1367d54)(val.src);
}
function $52191fe33e71397c$var$isCanvasLike(val) {
    return val && (0, $f16f2994a32ad273$export$f6e2535fb5126e54)(val.toDataURL);
}
function $52191fe33e71397c$var$setStyleAttrs(attrs, style, el, scope) {
    (0, $79277f1445e31766$export$2e2bcd8739ae039)(function(key, val) {
        var isFillStroke = key === 'fill' || key === 'stroke';
        if (isFillStroke && (0, $6e7232f7ffc8c94f$export$545e02bbd5f8fe95)(val)) $52191fe33e71397c$export$afaa8352c6a43a44(style, attrs, key, scope);
        else if (isFillStroke && (0, $6e7232f7ffc8c94f$export$41a28f5a000a9d0f)(val)) $52191fe33e71397c$export$faed90dbedc3b6d5(el, attrs, key, scope);
        else attrs[key] = val;
        if (isFillStroke && scope.ssr && val === 'none') attrs['pointer-events'] = 'visible';
    }, style, el, false);
    $52191fe33e71397c$var$setShadow(el, attrs, scope);
}
function $52191fe33e71397c$var$setMetaData(attrs, el) {
    var metaData = (0, $85632cfbb825ab09$export$dd7015a5412ca583)(el);
    if (metaData) {
        metaData.each(function(val, key) {
            val != null && (attrs[((0, $4621cba181046b2d$export$d3f79611f155197c) + key).toLowerCase()] = val + '');
        });
        if (el.isSilent()) attrs[(0, $4621cba181046b2d$export$d3f79611f155197c) + 'silent'] = 'true';
    }
}
function $52191fe33e71397c$var$noRotateScale(m) {
    return (0, $6e7232f7ffc8c94f$export$4701367f5b4de464)(m[0] - 1) && (0, $6e7232f7ffc8c94f$export$4701367f5b4de464)(m[1]) && (0, $6e7232f7ffc8c94f$export$4701367f5b4de464)(m[2]) && (0, $6e7232f7ffc8c94f$export$4701367f5b4de464)(m[3] - 1);
}
function $52191fe33e71397c$var$noTranslate(m) {
    return (0, $6e7232f7ffc8c94f$export$4701367f5b4de464)(m[4]) && (0, $6e7232f7ffc8c94f$export$4701367f5b4de464)(m[5]);
}
function $52191fe33e71397c$var$setTransform(attrs, m, compress) {
    if (m && !($52191fe33e71397c$var$noTranslate(m) && $52191fe33e71397c$var$noRotateScale(m))) {
        var mul = compress ? 10 : 1e4;
        attrs.transform = $52191fe33e71397c$var$noRotateScale(m) ? "translate(" + $52191fe33e71397c$var$round(m[4] * mul) / mul + " " + $52191fe33e71397c$var$round(m[5] * mul) / mul + ")" : (0, $6e7232f7ffc8c94f$export$f29a4456cf56ff21)(m);
    }
}
function $52191fe33e71397c$var$convertPolyShape(shape, attrs, mul) {
    var points = shape.points;
    var strArr = [];
    for(var i = 0; i < points.length; i++){
        strArr.push($52191fe33e71397c$var$round(points[i][0] * mul) / mul);
        strArr.push($52191fe33e71397c$var$round(points[i][1] * mul) / mul);
    }
    attrs.points = strArr.join(' ');
}
function $52191fe33e71397c$var$validatePolyShape(shape) {
    return !shape.smooth;
}
function $52191fe33e71397c$var$createAttrsConvert(desc) {
    var normalizedDesc = (0, $f16f2994a32ad273$export$871de8747c9eaa88)(desc, function(item) {
        return typeof item === 'string' ? [
            item,
            item
        ] : item;
    });
    return function(shape, attrs, mul) {
        for(var i = 0; i < normalizedDesc.length; i++){
            var item = normalizedDesc[i];
            var val = shape[item[0]];
            if (val != null) attrs[item[1]] = $52191fe33e71397c$var$round(val * mul) / mul;
        }
    };
}
var $52191fe33e71397c$var$builtinShapesDef = {
    circle: [
        $52191fe33e71397c$var$createAttrsConvert([
            'cx',
            'cy',
            'r'
        ])
    ],
    polyline: [
        $52191fe33e71397c$var$convertPolyShape,
        $52191fe33e71397c$var$validatePolyShape
    ],
    polygon: [
        $52191fe33e71397c$var$convertPolyShape,
        $52191fe33e71397c$var$validatePolyShape
    ]
};
function $52191fe33e71397c$var$hasShapeAnimation(el) {
    var animators = el.animators;
    for(var i = 0; i < animators.length; i++){
        if (animators[i].targetName === 'shape') return true;
    }
    return false;
}
function $52191fe33e71397c$export$1dc017d31b76c55b(el, scope) {
    var style = el.style;
    var shape = el.shape;
    var builtinShpDef = $52191fe33e71397c$var$builtinShapesDef[el.type];
    var attrs = {};
    var needsAnimate = scope.animation;
    var svgElType = 'path';
    var strokePercent = el.style.strokePercent;
    var precision = scope.compress && (0, $6e7232f7ffc8c94f$export$93fa1ae8a509371c)(el) || 4;
    if (builtinShpDef && !scope.willUpdate && !(builtinShpDef[1] && !builtinShpDef[1](shape)) && !(needsAnimate && $52191fe33e71397c$var$hasShapeAnimation(el)) && !(strokePercent < 1)) {
        svgElType = el.type;
        var mul = Math.pow(10, precision);
        builtinShpDef[0](shape, attrs, mul);
    } else {
        var needBuildPath = !el.path || el.shapeChanged();
        if (!el.path) el.createPathProxy();
        var path = el.path;
        if (needBuildPath) {
            path.beginPath();
            el.buildPath(path, el.shape);
            el.pathUpdated();
        }
        var pathVersion = path.getVersion();
        var elExt = el;
        var svgPathBuilder = elExt.__svgPathBuilder;
        if (elExt.__svgPathVersion !== pathVersion || !svgPathBuilder || strokePercent !== elExt.__svgPathStrokePercent) {
            if (!svgPathBuilder) svgPathBuilder = elExt.__svgPathBuilder = new (0, $b1b0f95f08e89ae1$export$2e2bcd8739ae039)();
            svgPathBuilder.reset(precision);
            path.rebuildPath(svgPathBuilder, strokePercent);
            svgPathBuilder.generateStr();
            elExt.__svgPathVersion = pathVersion;
            elExt.__svgPathStrokePercent = strokePercent;
        }
        attrs.d = svgPathBuilder.getStr();
    }
    $52191fe33e71397c$var$setTransform(attrs, el.transform);
    $52191fe33e71397c$var$setStyleAttrs(attrs, style, el, scope);
    $52191fe33e71397c$var$setMetaData(attrs, el);
    scope.animation && (0, $5159e0e8fc6398c7$export$dc9722e37397d426)(el, attrs, scope);
    scope.emphasis && (0, $97e047c275f979c4$export$b4c8f742d3cb22ba)(el, attrs, scope);
    return (0, $4621cba181046b2d$export$bf5c4cf060303d58)(svgElType, el.id + '', attrs);
}
function $52191fe33e71397c$export$a35ef46dc8240635(el, scope) {
    var style = el.style;
    var image = style.image;
    if (image && !(0, $f16f2994a32ad273$export$844ec244b1367d54)(image)) {
        if ($52191fe33e71397c$var$isImageLike(image)) image = image.src;
        else if ($52191fe33e71397c$var$isCanvasLike(image)) image = image.toDataURL();
    }
    if (!image) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var dw = style.width;
    var dh = style.height;
    var attrs = {
        href: image,
        width: dw,
        height: dh
    };
    if (x) attrs.x = x;
    if (y) attrs.y = y;
    $52191fe33e71397c$var$setTransform(attrs, el.transform);
    $52191fe33e71397c$var$setStyleAttrs(attrs, style, el, scope);
    $52191fe33e71397c$var$setMetaData(attrs, el);
    scope.animation && (0, $5159e0e8fc6398c7$export$dc9722e37397d426)(el, attrs, scope);
    return (0, $4621cba181046b2d$export$bf5c4cf060303d58)('image', el.id + '', attrs);
}
function $52191fe33e71397c$export$d506f5385e62a84a(el, scope) {
    var style = el.style;
    var text = style.text;
    text != null && (text += '');
    if (!text || isNaN(style.x) || isNaN(style.y)) return;
    var font = style.font || (0, $e4ffe803d17351c8$export$7d7a232b6d2cc80c);
    var x = style.x || 0;
    var y = (0, $6e7232f7ffc8c94f$export$bf7d6802d2badd9)(style.y || 0, (0, $3ad1e5e308f2a981$export$56204a27a2958a55)(font), style.textBaseline);
    var textAlign = (0, $6e7232f7ffc8c94f$export$4062150f0600d971)[style.textAlign] || style.textAlign;
    var attrs = {
        'dominant-baseline': 'central',
        'text-anchor': textAlign
    };
    if ((0, $7d5e7dc1581f8c9a$export$4685c95d5118e76a)(style)) {
        var separatedFontStr = '';
        var fontStyle = style.fontStyle;
        var fontSize = (0, $7d5e7dc1581f8c9a$export$51b066d9cfc2578e)(style.fontSize);
        if (!parseFloat(fontSize)) return;
        var fontFamily = style.fontFamily || (0, $e4ffe803d17351c8$export$2653e0d5dd45b294);
        var fontWeight = style.fontWeight;
        separatedFontStr += "font-size:" + fontSize + ";font-family:" + fontFamily + ";";
        if (fontStyle && fontStyle !== 'normal') separatedFontStr += "font-style:" + fontStyle + ";";
        if (fontWeight && fontWeight !== 'normal') separatedFontStr += "font-weight:" + fontWeight + ";";
        attrs.style = separatedFontStr;
    } else attrs.style = "font: " + font;
    if (text.match(/\s/)) attrs['xml:space'] = 'preserve';
    if (x) attrs.x = x;
    if (y) attrs.y = y;
    $52191fe33e71397c$var$setTransform(attrs, el.transform);
    $52191fe33e71397c$var$setStyleAttrs(attrs, style, el, scope);
    $52191fe33e71397c$var$setMetaData(attrs, el);
    scope.animation && (0, $5159e0e8fc6398c7$export$dc9722e37397d426)(el, attrs, scope);
    return (0, $4621cba181046b2d$export$bf5c4cf060303d58)('text', el.id + '', attrs, undefined, text);
}
function $52191fe33e71397c$export$da5d6544e8c27bc1(el, scope) {
    if (el instanceof (0, $340211037b56ba3f$export$2e2bcd8739ae039)) return $52191fe33e71397c$export$1dc017d31b76c55b(el, scope);
    else if (el instanceof (0, $0eafea320dbd53c3$export$2e2bcd8739ae039)) return $52191fe33e71397c$export$a35ef46dc8240635(el, scope);
    else if (el instanceof (0, $df36fca73018b9d2$export$2e2bcd8739ae039)) return $52191fe33e71397c$export$d506f5385e62a84a(el, scope);
}
function $52191fe33e71397c$var$setShadow(el, attrs, scope) {
    var style = el.style;
    if ((0, $6e7232f7ffc8c94f$export$c62076b3a966c94b)(style)) {
        var shadowKey = (0, $6e7232f7ffc8c94f$export$9e4c657be710688a)(el);
        var shadowCache = scope.shadowCache;
        var shadowId = shadowCache[shadowKey];
        if (!shadowId) {
            var globalScale = el.getGlobalScale();
            var scaleX = globalScale[0];
            var scaleY = globalScale[1];
            if (!scaleX || !scaleY) return;
            var offsetX = style.shadowOffsetX || 0;
            var offsetY = style.shadowOffsetY || 0;
            var blur_1 = style.shadowBlur;
            var _a = (0, $6e7232f7ffc8c94f$export$4cde5df63f53f473)(style.shadowColor), opacity = _a.opacity, color = _a.color;
            var stdDx = blur_1 / 2 / scaleX;
            var stdDy = blur_1 / 2 / scaleY;
            var stdDeviation = stdDx + ' ' + stdDy;
            shadowId = scope.zrId + '-s' + scope.shadowIdx++;
            scope.defs[shadowId] = (0, $4621cba181046b2d$export$bf5c4cf060303d58)('filter', shadowId, {
                'id': shadowId,
                'x': '-100%',
                'y': '-100%',
                'width': '300%',
                'height': '300%'
            }, [
                (0, $4621cba181046b2d$export$bf5c4cf060303d58)('feDropShadow', '', {
                    'dx': offsetX / scaleX,
                    'dy': offsetY / scaleY,
                    'stdDeviation': stdDeviation,
                    'flood-color': color,
                    'flood-opacity': opacity
                })
            ]);
            shadowCache[shadowKey] = shadowId;
        }
        attrs.filter = (0, $6e7232f7ffc8c94f$export$bb094196179998a5)(shadowId);
    }
}
function $52191fe33e71397c$export$afaa8352c6a43a44(style, attrs, target, scope) {
    var val = style[target];
    var gradientTag;
    var gradientAttrs = {
        'gradientUnits': val.global ? 'userSpaceOnUse' : 'objectBoundingBox'
    };
    if ((0, $6e7232f7ffc8c94f$export$7d961bca9d3b47d0)(val)) {
        gradientTag = 'linearGradient';
        gradientAttrs.x1 = val.x;
        gradientAttrs.y1 = val.y;
        gradientAttrs.x2 = val.x2;
        gradientAttrs.y2 = val.y2;
    } else if ((0, $6e7232f7ffc8c94f$export$2a9cca6692a0ce3a)(val)) {
        gradientTag = 'radialGradient';
        gradientAttrs.cx = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(val.x, 0.5);
        gradientAttrs.cy = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(val.y, 0.5);
        gradientAttrs.r = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(val.r, 0.5);
    } else return;
    var colors = val.colorStops;
    var colorStops = [];
    for(var i = 0, len = colors.length; i < len; ++i){
        var offset = (0, $6e7232f7ffc8c94f$export$52bfc6d3e2ff0fc2)(colors[i].offset) * 100 + '%';
        var stopColor = colors[i].color;
        var _a = (0, $6e7232f7ffc8c94f$export$4cde5df63f53f473)(stopColor), color = _a.color, opacity = _a.opacity;
        var stopsAttrs = {
            'offset': offset
        };
        stopsAttrs['stop-color'] = color;
        if (opacity < 1) stopsAttrs['stop-opacity'] = opacity;
        colorStops.push((0, $4621cba181046b2d$export$bf5c4cf060303d58)('stop', i + '', stopsAttrs));
    }
    var gradientVNode = (0, $4621cba181046b2d$export$bf5c4cf060303d58)(gradientTag, '', gradientAttrs, colorStops);
    var gradientKey = (0, $4621cba181046b2d$export$f5c4a9a0e027f2b)(gradientVNode);
    var gradientCache = scope.gradientCache;
    var gradientId = gradientCache[gradientKey];
    if (!gradientId) {
        gradientId = scope.zrId + '-g' + scope.gradientIdx++;
        gradientCache[gradientKey] = gradientId;
        gradientAttrs.id = gradientId;
        scope.defs[gradientId] = (0, $4621cba181046b2d$export$bf5c4cf060303d58)(gradientTag, gradientId, gradientAttrs, colorStops);
    }
    attrs[target] = (0, $6e7232f7ffc8c94f$export$bb094196179998a5)(gradientId);
}
function $52191fe33e71397c$export$faed90dbedc3b6d5(el, attrs, target, scope) {
    var val = el.style[target];
    var boundingRect = el.getBoundingRect();
    var patternAttrs = {};
    var repeat = val.repeat;
    var noRepeat = repeat === 'no-repeat';
    var repeatX = repeat === 'repeat-x';
    var repeatY = repeat === 'repeat-y';
    var child;
    if ((0, $6e7232f7ffc8c94f$export$2ade673ac4f85dfe)(val)) {
        var imageWidth_1 = val.imageWidth;
        var imageHeight_1 = val.imageHeight;
        var imageSrc = void 0;
        var patternImage = val.image;
        if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(patternImage)) imageSrc = patternImage;
        else if ($52191fe33e71397c$var$isImageLike(patternImage)) imageSrc = patternImage.src;
        else if ($52191fe33e71397c$var$isCanvasLike(patternImage)) imageSrc = patternImage.toDataURL();
        if (typeof Image === 'undefined') {
            var errMsg = 'Image width/height must been given explictly in svg-ssr renderer.';
            (0, $f16f2994a32ad273$export$a7a9523472993e97)(imageWidth_1, errMsg);
            (0, $f16f2994a32ad273$export$a7a9523472993e97)(imageHeight_1, errMsg);
        } else if (imageWidth_1 == null || imageHeight_1 == null) {
            var setSizeToVNode_1 = function setSizeToVNode_1(vNode, img) {
                if (vNode) {
                    var svgEl = vNode.elm;
                    var width = imageWidth_1 || img.width;
                    var height = imageHeight_1 || img.height;
                    if (vNode.tag === 'pattern') {
                        if (repeatX) {
                            height = 1;
                            width /= boundingRect.width;
                        } else if (repeatY) {
                            width = 1;
                            height /= boundingRect.height;
                        }
                    }
                    vNode.attrs.width = width;
                    vNode.attrs.height = height;
                    if (svgEl) {
                        svgEl.setAttribute('width', width);
                        svgEl.setAttribute('height', height);
                    }
                }
            };
            var createdImage = (0, $3e20f9b845f6268e$export$46c791b69ff9a0f)(imageSrc, null, el, function(img) {
                noRepeat || setSizeToVNode_1(patternVNode, img);
                setSizeToVNode_1(child, img);
            });
            if (createdImage && createdImage.width && createdImage.height) {
                imageWidth_1 = imageWidth_1 || createdImage.width;
                imageHeight_1 = imageHeight_1 || createdImage.height;
            }
        }
        child = (0, $4621cba181046b2d$export$bf5c4cf060303d58)('image', 'img', {
            href: imageSrc,
            width: imageWidth_1,
            height: imageHeight_1
        });
        patternAttrs.width = imageWidth_1;
        patternAttrs.height = imageHeight_1;
    } else if (val.svgElement) {
        child = (0, $f16f2994a32ad273$export$9cd59f9826255e47)(val.svgElement);
        patternAttrs.width = val.svgWidth;
        patternAttrs.height = val.svgHeight;
    }
    if (!child) return;
    var patternWidth;
    var patternHeight;
    if (noRepeat) patternWidth = patternHeight = 1;
    else if (repeatX) {
        patternHeight = 1;
        patternWidth = patternAttrs.width / boundingRect.width;
    } else if (repeatY) {
        patternWidth = 1;
        patternHeight = patternAttrs.height / boundingRect.height;
    } else patternAttrs.patternUnits = 'userSpaceOnUse';
    if (patternWidth != null && !isNaN(patternWidth)) patternAttrs.width = patternWidth;
    if (patternHeight != null && !isNaN(patternHeight)) patternAttrs.height = patternHeight;
    var patternTransform = (0, $6e7232f7ffc8c94f$export$3fe07c0888ff6164)(val);
    patternTransform && (patternAttrs.patternTransform = patternTransform);
    var patternVNode = (0, $4621cba181046b2d$export$bf5c4cf060303d58)('pattern', '', patternAttrs, [
        child
    ]);
    var patternKey = (0, $4621cba181046b2d$export$f5c4a9a0e027f2b)(patternVNode);
    var patternCache = scope.patternCache;
    var patternId = patternCache[patternKey];
    if (!patternId) {
        patternId = scope.zrId + '-p' + scope.patternIdx++;
        patternCache[patternKey] = patternId;
        patternAttrs.id = patternId;
        patternVNode = scope.defs[patternId] = (0, $4621cba181046b2d$export$bf5c4cf060303d58)('pattern', patternId, patternAttrs, [
            child
        ]);
    }
    attrs[target] = (0, $6e7232f7ffc8c94f$export$bb094196179998a5)(patternId);
}
function $52191fe33e71397c$export$8f1d80b445d4fc(clipPath, attrs, scope) {
    var clipPathCache = scope.clipPathCache, defs = scope.defs;
    var clipPathId = clipPathCache[clipPath.id];
    if (!clipPathId) {
        clipPathId = scope.zrId + '-c' + scope.clipPathIdx++;
        var clipPathAttrs = {
            id: clipPathId
        };
        clipPathCache[clipPath.id] = clipPathId;
        defs[clipPathId] = (0, $4621cba181046b2d$export$bf5c4cf060303d58)('clipPath', clipPathId, clipPathAttrs, [
            $52191fe33e71397c$export$1dc017d31b76c55b(clipPath, scope)
        ]);
    }
    attrs['clip-path'] = (0, $6e7232f7ffc8c94f$export$bb094196179998a5)(clipPathId);
}







function $671e0eafbdf68ef7$export$b2ce9ad90858ed7a(text) {
    return document.createTextNode(text);
}
function $671e0eafbdf68ef7$export$2a15b079e3f46654(text) {
    return document.createComment(text);
}
function $671e0eafbdf68ef7$export$86b68c7dbeb53c22(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function $671e0eafbdf68ef7$export$7ae609f7af59e4f7(node, child) {
    node.removeChild(child);
}
function $671e0eafbdf68ef7$export$1b8e57c9ea42f1d2(node, child) {
    node.appendChild(child);
}
function $671e0eafbdf68ef7$export$b54be7ce267a037b(node) {
    return node.parentNode;
}
function $671e0eafbdf68ef7$export$335219007e689d29(node) {
    return node.nextSibling;
}
function $671e0eafbdf68ef7$export$45e0b80f1e500bd4(elm) {
    return elm.tagName;
}
function $671e0eafbdf68ef7$export$94b0296cab6203e(node, text) {
    node.textContent = text;
}
function $671e0eafbdf68ef7$export$132e79e4118a78e0(node) {
    return node.textContent;
}
function $671e0eafbdf68ef7$export$45a5e7f76e0caa8d(node) {
    return node.nodeType === 1;
}
function $671e0eafbdf68ef7$export$1879817ac5c922b7(node) {
    return node.nodeType === 3;
}
function $671e0eafbdf68ef7$export$3ab01370f5e64ac8(node) {
    return node.nodeType === 8;
}


var $054154052397c15b$var$colonChar = 58;
var $054154052397c15b$var$xChar = 120;
var $054154052397c15b$var$emptyNode = (0, $4621cba181046b2d$export$bf5c4cf060303d58)('', '');
function $054154052397c15b$var$isUndef(s) {
    return s === undefined;
}
function $054154052397c15b$var$isDef(s) {
    return s !== undefined;
}
function $054154052397c15b$var$createKeyToOldIdx(children, beginIdx, endIdx) {
    var map = {};
    for(var i = beginIdx; i <= endIdx; ++i){
        var key = children[i].key;
        if (key !== undefined) map[key] = i;
    }
    return map;
}
function $054154052397c15b$var$sameVnode(vnode1, vnode2) {
    var isSameKey = vnode1.key === vnode2.key;
    var isSameTag = vnode1.tag === vnode2.tag;
    return isSameTag && isSameKey;
}
function $054154052397c15b$var$createElm(vnode) {
    var i;
    var children = vnode.children;
    var tag = vnode.tag;
    if ($054154052397c15b$var$isDef(tag)) {
        var elm = vnode.elm = (0, $4621cba181046b2d$export$c8a8987d4410bf2d)(tag);
        $054154052397c15b$export$277dcc6f06048f24($054154052397c15b$var$emptyNode, vnode);
        if ((0, $f16f2994a32ad273$export$43bee75e5e14138e)(children)) for(i = 0; i < children.length; ++i){
            var ch = children[i];
            if (ch != null) $671e0eafbdf68ef7$export$1b8e57c9ea42f1d2(elm, $054154052397c15b$var$createElm(ch));
        }
        else if ($054154052397c15b$var$isDef(vnode.text) && !(0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(vnode.text)) $671e0eafbdf68ef7$export$1b8e57c9ea42f1d2(elm, $671e0eafbdf68ef7$export$b2ce9ad90858ed7a(vnode.text));
    } else vnode.elm = $671e0eafbdf68ef7$export$b2ce9ad90858ed7a(vnode.text);
    return vnode.elm;
}
function $054154052397c15b$var$addVnodes(parentElm, before, vnodes, startIdx, endIdx) {
    for(; startIdx <= endIdx; ++startIdx){
        var ch = vnodes[startIdx];
        if (ch != null) $671e0eafbdf68ef7$export$86b68c7dbeb53c22(parentElm, $054154052397c15b$var$createElm(ch), before);
    }
}
function $054154052397c15b$var$removeVnodes(parentElm, vnodes, startIdx, endIdx) {
    for(; startIdx <= endIdx; ++startIdx){
        var ch = vnodes[startIdx];
        if (ch != null) {
            if ($054154052397c15b$var$isDef(ch.tag)) {
                var parent_1 = $671e0eafbdf68ef7$export$b54be7ce267a037b(ch.elm);
                $671e0eafbdf68ef7$export$7ae609f7af59e4f7(parent_1, ch.elm);
            } else $671e0eafbdf68ef7$export$7ae609f7af59e4f7(parentElm, ch.elm);
        }
    }
}
function $054154052397c15b$export$277dcc6f06048f24(oldVnode, vnode) {
    var key;
    var elm = vnode.elm;
    var oldAttrs = oldVnode && oldVnode.attrs || {};
    var attrs = vnode.attrs || {};
    if (oldAttrs === attrs) return;
    for(key in attrs){
        var cur = attrs[key];
        var old = oldAttrs[key];
        if (old !== cur) {
            if (cur === true) elm.setAttribute(key, '');
            else if (cur === false) elm.removeAttribute(key);
            else {
                if (key === 'style') elm.style.cssText = cur;
                else if (key.charCodeAt(0) !== $054154052397c15b$var$xChar) elm.setAttribute(key, cur);
                else if (key === 'xmlns:xlink' || key === 'xmlns') elm.setAttributeNS((0, $4621cba181046b2d$export$fac09d762d15fa3b), key, cur);
                else if (key.charCodeAt(3) === $054154052397c15b$var$colonChar) elm.setAttributeNS((0, $4621cba181046b2d$export$ad4c4fdecd3b4156), key, cur);
                else if (key.charCodeAt(5) === $054154052397c15b$var$colonChar) elm.setAttributeNS((0, $4621cba181046b2d$export$b22c6da1792ecec8), key, cur);
                else elm.setAttribute(key, cur);
            }
        }
    }
    for(key in oldAttrs)if (!(key in attrs)) elm.removeAttribute(key);
}
function $054154052397c15b$var$updateChildren(parentElm, oldCh, newCh) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx;
    var idxInOld;
    var elmToMove;
    var before;
    while(oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx){
        if (oldStartVnode == null) oldStartVnode = oldCh[++oldStartIdx];
        else if (oldEndVnode == null) oldEndVnode = oldCh[--oldEndIdx];
        else if (newStartVnode == null) newStartVnode = newCh[++newStartIdx];
        else if (newEndVnode == null) newEndVnode = newCh[--newEndIdx];
        else if ($054154052397c15b$var$sameVnode(oldStartVnode, newStartVnode)) {
            $054154052397c15b$var$patchVnode(oldStartVnode, newStartVnode);
            oldStartVnode = oldCh[++oldStartIdx];
            newStartVnode = newCh[++newStartIdx];
        } else if ($054154052397c15b$var$sameVnode(oldEndVnode, newEndVnode)) {
            $054154052397c15b$var$patchVnode(oldEndVnode, newEndVnode);
            oldEndVnode = oldCh[--oldEndIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($054154052397c15b$var$sameVnode(oldStartVnode, newEndVnode)) {
            $054154052397c15b$var$patchVnode(oldStartVnode, newEndVnode);
            $671e0eafbdf68ef7$export$86b68c7dbeb53c22(parentElm, oldStartVnode.elm, $671e0eafbdf68ef7$export$335219007e689d29(oldEndVnode.elm));
            oldStartVnode = oldCh[++oldStartIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($054154052397c15b$var$sameVnode(oldEndVnode, newStartVnode)) {
            $054154052397c15b$var$patchVnode(oldEndVnode, newStartVnode);
            $671e0eafbdf68ef7$export$86b68c7dbeb53c22(parentElm, oldEndVnode.elm, oldStartVnode.elm);
            oldEndVnode = oldCh[--oldEndIdx];
            newStartVnode = newCh[++newStartIdx];
        } else {
            if ($054154052397c15b$var$isUndef(oldKeyToIdx)) oldKeyToIdx = $054154052397c15b$var$createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
            idxInOld = oldKeyToIdx[newStartVnode.key];
            if ($054154052397c15b$var$isUndef(idxInOld)) $671e0eafbdf68ef7$export$86b68c7dbeb53c22(parentElm, $054154052397c15b$var$createElm(newStartVnode), oldStartVnode.elm);
            else {
                elmToMove = oldCh[idxInOld];
                if (elmToMove.tag !== newStartVnode.tag) $671e0eafbdf68ef7$export$86b68c7dbeb53c22(parentElm, $054154052397c15b$var$createElm(newStartVnode), oldStartVnode.elm);
                else {
                    $054154052397c15b$var$patchVnode(elmToMove, newStartVnode);
                    oldCh[idxInOld] = undefined;
                    $671e0eafbdf68ef7$export$86b68c7dbeb53c22(parentElm, elmToMove.elm, oldStartVnode.elm);
                }
            }
            newStartVnode = newCh[++newStartIdx];
        }
    }
    if (oldStartIdx <= oldEndIdx || newStartIdx <= newEndIdx) {
        if (oldStartIdx > oldEndIdx) {
            before = newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].elm;
            $054154052397c15b$var$addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx);
        } else $054154052397c15b$var$removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
}
function $054154052397c15b$var$patchVnode(oldVnode, vnode) {
    var elm = vnode.elm = oldVnode.elm;
    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (oldVnode === vnode) return;
    $054154052397c15b$export$277dcc6f06048f24(oldVnode, vnode);
    if ($054154052397c15b$var$isUndef(vnode.text)) {
        if ($054154052397c15b$var$isDef(oldCh) && $054154052397c15b$var$isDef(ch)) {
            if (oldCh !== ch) $054154052397c15b$var$updateChildren(elm, oldCh, ch);
        } else if ($054154052397c15b$var$isDef(ch)) {
            if ($054154052397c15b$var$isDef(oldVnode.text)) $671e0eafbdf68ef7$export$94b0296cab6203e(elm, '');
            $054154052397c15b$var$addVnodes(elm, null, ch, 0, ch.length - 1);
        } else if ($054154052397c15b$var$isDef(oldCh)) $054154052397c15b$var$removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        else if ($054154052397c15b$var$isDef(oldVnode.text)) $671e0eafbdf68ef7$export$94b0296cab6203e(elm, '');
    } else if (oldVnode.text !== vnode.text) {
        if ($054154052397c15b$var$isDef(oldCh)) $054154052397c15b$var$removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        $671e0eafbdf68ef7$export$94b0296cab6203e(elm, vnode.text);
    }
}
function $054154052397c15b$export$2e2bcd8739ae039(oldVnode, vnode) {
    if ($054154052397c15b$var$sameVnode(oldVnode, vnode)) $054154052397c15b$var$patchVnode(oldVnode, vnode);
    else {
        var elm = oldVnode.elm;
        var parent_2 = $671e0eafbdf68ef7$export$b54be7ce267a037b(elm);
        $054154052397c15b$var$createElm(vnode);
        if (parent_2 !== null) {
            $671e0eafbdf68ef7$export$86b68c7dbeb53c22(parent_2, vnode.elm, $671e0eafbdf68ef7$export$335219007e689d29(elm));
            $054154052397c15b$var$removeVnodes(parent_2, [
                oldVnode
            ], 0, 0);
        }
    }
    return vnode;
}



var $e61aea308985948d$var$svgId = 0;
var $e61aea308985948d$var$SVGPainter = function() {
    function SVGPainter(root, storage, opts) {
        this.type = 'svg';
        this.configLayer = $e61aea308985948d$var$createMethodNotSupport('configLayer');
        this.storage = storage;
        this._opts = opts = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, opts);
        this.root = root;
        this._id = 'zr' + $e61aea308985948d$var$svgId++;
        this._oldVNode = (0, $4621cba181046b2d$export$5529a6aad332ee75)(opts.width, opts.height);
        if (root && !opts.ssr) {
            var viewport = this._viewport = document.createElement('div');
            viewport.style.cssText = 'position:relative;overflow:hidden';
            var svgDom = this._svgDom = this._oldVNode.elm = (0, $4621cba181046b2d$export$c8a8987d4410bf2d)('svg');
            (0, $054154052397c15b$export$277dcc6f06048f24)(null, this._oldVNode);
            viewport.appendChild(svgDom);
            root.appendChild(viewport);
        }
        this.resize(opts.width, opts.height);
    }
    SVGPainter.prototype.getType = function() {
        return this.type;
    };
    SVGPainter.prototype.getViewportRoot = function() {
        return this._viewport;
    };
    SVGPainter.prototype.getViewportRootOffset = function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    };
    SVGPainter.prototype.getSvgDom = function() {
        return this._svgDom;
    };
    SVGPainter.prototype.refresh = function() {
        if (this.root) {
            var vnode = this.renderToVNode({
                willUpdate: true
            });
            vnode.attrs.style = 'position:absolute;left:0;top:0;user-select:none';
            (0, $054154052397c15b$export$2e2bcd8739ae039)(this._oldVNode, vnode);
            this._oldVNode = vnode;
        }
    };
    SVGPainter.prototype.renderOneToVNode = function(el) {
        return (0, $52191fe33e71397c$export$da5d6544e8c27bc1)(el, (0, $4621cba181046b2d$export$96fee5f38ed01741)(this._id));
    };
    SVGPainter.prototype.renderToVNode = function(opts) {
        opts = opts || {};
        var list = this.storage.getDisplayList(true);
        var width = this._width;
        var height = this._height;
        var scope = (0, $4621cba181046b2d$export$96fee5f38ed01741)(this._id);
        scope.animation = opts.animation;
        scope.willUpdate = opts.willUpdate;
        scope.compress = opts.compress;
        scope.emphasis = opts.emphasis;
        scope.ssr = this._opts.ssr;
        var children = [];
        var bgVNode = this._bgVNode = $e61aea308985948d$var$createBackgroundVNode(width, height, this._backgroundColor, scope);
        bgVNode && children.push(bgVNode);
        var mainVNode = !opts.compress ? this._mainVNode = (0, $4621cba181046b2d$export$bf5c4cf060303d58)('g', 'main', {}, []) : null;
        this._paintList(list, scope, mainVNode ? mainVNode.children : children);
        mainVNode && children.push(mainVNode);
        var defs = (0, $f16f2994a32ad273$export$871de8747c9eaa88)((0, $f16f2994a32ad273$export$ed97f33186d4b816)(scope.defs), function(id) {
            return scope.defs[id];
        });
        if (defs.length) children.push((0, $4621cba181046b2d$export$bf5c4cf060303d58)('defs', 'defs', {}, defs));
        if (opts.animation) {
            var animationCssStr = (0, $4621cba181046b2d$export$e2b4f3597c7a7dcb)(scope.cssNodes, scope.cssAnims, {
                newline: true
            });
            if (animationCssStr) {
                var styleNode = (0, $4621cba181046b2d$export$bf5c4cf060303d58)('style', 'stl', {}, [], animationCssStr);
                children.push(styleNode);
            }
        }
        return (0, $4621cba181046b2d$export$5529a6aad332ee75)(width, height, children, opts.useViewBox);
    };
    SVGPainter.prototype.renderToString = function(opts) {
        opts = opts || {};
        return (0, $4621cba181046b2d$export$f5c4a9a0e027f2b)(this.renderToVNode({
            animation: (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(opts.cssAnimation, true),
            emphasis: (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(opts.cssEmphasis, true),
            willUpdate: false,
            compress: true,
            useViewBox: (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(opts.useViewBox, true)
        }), {
            newline: true
        });
    };
    SVGPainter.prototype.setBackgroundColor = function(backgroundColor) {
        this._backgroundColor = backgroundColor;
    };
    SVGPainter.prototype.getSvgRoot = function() {
        return this._mainVNode && this._mainVNode.elm;
    };
    SVGPainter.prototype._paintList = function(list, scope, out) {
        var listLen = list.length;
        var clipPathsGroupsStack = [];
        var clipPathsGroupsStackDepth = 0;
        var currentClipPathGroup;
        var prevClipPaths;
        var clipGroupNodeIdx = 0;
        for(var i = 0; i < listLen; i++){
            var displayable = list[i];
            if (!displayable.invisible) {
                var clipPaths = displayable.__clipPaths;
                var len = clipPaths && clipPaths.length || 0;
                var prevLen = prevClipPaths && prevClipPaths.length || 0;
                var lca = void 0;
                for(lca = Math.max(len - 1, prevLen - 1); lca >= 0; lca--){
                    if (clipPaths && prevClipPaths && clipPaths[lca] === prevClipPaths[lca]) break;
                }
                for(var i_1 = prevLen - 1; i_1 > lca; i_1--){
                    clipPathsGroupsStackDepth--;
                    currentClipPathGroup = clipPathsGroupsStack[clipPathsGroupsStackDepth - 1];
                }
                for(var i_2 = lca + 1; i_2 < len; i_2++){
                    var groupAttrs = {};
                    (0, $52191fe33e71397c$export$8f1d80b445d4fc)(clipPaths[i_2], groupAttrs, scope);
                    var g = (0, $4621cba181046b2d$export$bf5c4cf060303d58)('g', 'clip-g-' + clipGroupNodeIdx++, groupAttrs, []);
                    (currentClipPathGroup ? currentClipPathGroup.children : out).push(g);
                    clipPathsGroupsStack[clipPathsGroupsStackDepth++] = g;
                    currentClipPathGroup = g;
                }
                prevClipPaths = clipPaths;
                var ret = (0, $52191fe33e71397c$export$da5d6544e8c27bc1)(displayable, scope);
                if (ret) (currentClipPathGroup ? currentClipPathGroup.children : out).push(ret);
            }
        }
    };
    SVGPainter.prototype.resize = function(width, height) {
        var opts = this._opts;
        var root = this.root;
        var viewport = this._viewport;
        width != null && (opts.width = width);
        height != null && (opts.height = height);
        if (root && viewport) {
            viewport.style.display = 'none';
            width = (0, $c0cbdbca9100c9b3$export$31b21d0167753bb4)(root, 0, opts);
            height = (0, $c0cbdbca9100c9b3$export$31b21d0167753bb4)(root, 1, opts);
            viewport.style.display = '';
        }
        if (this._width !== width || this._height !== height) {
            this._width = width;
            this._height = height;
            if (viewport) {
                var viewportStyle = viewport.style;
                viewportStyle.width = width + 'px';
                viewportStyle.height = height + 'px';
            }
            if (!(0, $6e7232f7ffc8c94f$export$41a28f5a000a9d0f)(this._backgroundColor)) {
                var svgDom = this._svgDom;
                if (svgDom) {
                    svgDom.setAttribute('width', width);
                    svgDom.setAttribute('height', height);
                }
                var bgEl = this._bgVNode && this._bgVNode.elm;
                if (bgEl) {
                    bgEl.setAttribute('width', width);
                    bgEl.setAttribute('height', height);
                }
            } else this.refresh();
        }
    };
    SVGPainter.prototype.getWidth = function() {
        return this._width;
    };
    SVGPainter.prototype.getHeight = function() {
        return this._height;
    };
    SVGPainter.prototype.dispose = function() {
        if (this.root) this.root.innerHTML = '';
        this._svgDom = this._viewport = this.storage = this._oldVNode = this._bgVNode = this._mainVNode = null;
    };
    SVGPainter.prototype.clear = function() {
        if (this._svgDom) this._svgDom.innerHTML = null;
        this._oldVNode = null;
    };
    SVGPainter.prototype.toDataURL = function(base64) {
        var str = this.renderToString();
        var prefix = 'data:image/svg+xml;';
        if (base64) {
            str = (0, $6e7232f7ffc8c94f$export$8fb536984ec8b4d7)(str);
            return str && prefix + 'base64,' + str;
        }
        return prefix + 'charset=UTF-8,' + encodeURIComponent(str);
    };
    return SVGPainter;
}();
function $e61aea308985948d$var$createMethodNotSupport(method) {
    return function() {};
}
function $e61aea308985948d$var$createBackgroundVNode(width, height, backgroundColor, scope) {
    var bgVNode;
    if (backgroundColor && backgroundColor !== 'none') {
        bgVNode = (0, $4621cba181046b2d$export$bf5c4cf060303d58)('rect', 'bg', {
            width: width,
            height: height,
            x: '0',
            y: '0'
        });
        if ((0, $6e7232f7ffc8c94f$export$545e02bbd5f8fe95)(backgroundColor)) (0, $52191fe33e71397c$export$afaa8352c6a43a44)({
            fill: backgroundColor
        }, bgVNode.attrs, 'fill', scope);
        else if ((0, $6e7232f7ffc8c94f$export$41a28f5a000a9d0f)(backgroundColor)) (0, $52191fe33e71397c$export$faed90dbedc3b6d5)({
            style: {
                fill: backgroundColor
            },
            dirty: (0, $f16f2994a32ad273$export$8793edee2d425525),
            getBoundingRect: function getBoundingRect() {
                return {
                    width: width,
                    height: height
                };
            }
        }, bgVNode.attrs, 'fill', scope);
        else {
            var _a = (0, $6e7232f7ffc8c94f$export$4cde5df63f53f473)(backgroundColor), color = _a.color, opacity = _a.opacity;
            bgVNode.attrs.fill = color;
            opacity < 1 && (bgVNode.attrs['fill-opacity'] = opacity);
        }
    }
    return bgVNode;
}
var $e61aea308985948d$export$2e2bcd8739ae039 = $e61aea308985948d$var$SVGPainter;


function $b6eb72d440acb22b$export$4b3e715f166fdd78(registers) {
    registers.registerPainter('svg', (0, $e61aea308985948d$export$2e2bcd8739ae039));
}



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $dWsrg = parcelRequire("dWsrg");

var $kg0zo = parcelRequire("kg0zo");

var $hdIku = parcelRequire("hdIku");

var $f9AOD = parcelRequire("f9AOD");

var $13u2V = parcelRequire("13u2V");


var $hDKce = parcelRequire("hDKce");

var $lhPyT = parcelRequire("lhPyT");

var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $dWsrg = parcelRequire("dWsrg");

var $kg0zo = parcelRequire("kg0zo");

var $hdIku = parcelRequire("hdIku");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");

var $1SdK7 = parcelRequire("1SdK7");

var $lhPyT = parcelRequire("lhPyT");

var $318vE = parcelRequire("318vE");
function $2159b752ecc26024$export$99096e10de875468() {
    var handler;
    var stream = new (0, $318vE.ReadableStream)({
        start: function(controller) {
            handler = controller;
        }
    });
    function call() {
        for(var _len = arguments.length, input = new Array(_len), _key = 0; _key < _len; _key++){
            input[_key] = arguments[_key];
        }
        var request = {
            context: this,
            input: input,
            output: Promise.withResolvers()
        };
        handler.enqueue(request);
        return request.output.promise;
    }
    return Object.assign(call, {
        stream: stream
    });
}
var $2159b752ecc26024$export$db26ce94c7abc843 = /^on(\w+)/;
var $2159b752ecc26024$var$EventHandlerMap = new WeakMap();
function $2159b752ecc26024$export$d09f5504a38c35a6(name, handler) {
    var _this = this;
    var wrapper = function(detail) {
        var event = new CustomEvent(name, {
            detail: detail
        }), meta = {
            enumerable: true,
            value: _this
        };
        Object.defineProperties(event, {
            eventPhase: Object.assign(Object.assign({}, meta), {
                value: Event.AT_TARGET
            }),
            srcElement: meta,
            target: meta,
            currentTarget: meta
        });
        handler.call(_this, event);
    };
    $2159b752ecc26024$var$EventHandlerMap.set(handler, wrapper);
    return wrapper;
}
var $2159b752ecc26024$export$7c4c84635886a982 = function(handler) {
    return $2159b752ecc26024$var$EventHandlerMap.get(handler);
};


var $3703681daa9862d5$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $3703681daa9862d5$var$_ProxyElement_data;
var $3703681daa9862d5$export$dfca55cafbce2a44 = /*#__PURE__*/ function(HTMLElement1) {
    "use strict";
    (0, $hdIku._)(ProxyElement, HTMLElement1);
    function ProxyElement() {
        (0, $173N4._)(this, ProxyElement);
        var _this;
        _this = (0, $7qXGD._)(this, ProxyElement);
        $3703681daa9862d5$var$_ProxyElement_data.set(_this, {});
        (0, $lhPyT.proxyPrototype)(_this, $3703681daa9862d5$var$__classPrivateFieldGet(_this, $3703681daa9862d5$var$_ProxyElement_data, "f"), function(key, value) {
            return _this.setProperty(key.toString(), value);
        });
        return _this;
    }
    (0, $cFHGC._)(ProxyElement, [
        {
            key: "toJSON",
            value: function toJSON() {
                return Object.fromEntries(Object.entries($3703681daa9862d5$var$__classPrivateFieldGet(this, $3703681daa9862d5$var$_ProxyElement_data, "f")).filter(function(param) {
                    var _param = (0, $f9AOD._)(param, 2), key = _param[0], value = _param[1];
                    return typeof value !== 'function' && !key.startsWith('__react');
                }));
            }
        },
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var prototype = Object.getPrototypeOf(this);
                var customAttributes = (0, $aUGqu._)(this.attributes).filter(function(param) {
                    var name = param.name;
                    return !(name in prototype);
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (customAttributes[0] && !Object.keys(this.toJSON())[0]) try {
                    for(var _iterator = customAttributes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _step.value, name = _step_value.name, value = _step_value.value;
                        this.setAttribute(name, value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "setProperty",
            value: function setProperty(key, value) {
                var oldValue = $3703681daa9862d5$var$__classPrivateFieldGet(this, $3703681daa9862d5$var$_ProxyElement_data, "f")[key], name = (0, $lhPyT.toHyphenCase)(key), eventName = key.slice(2);
                $3703681daa9862d5$var$__classPrivateFieldGet(this, $3703681daa9862d5$var$_ProxyElement_data, "f")[key] = value;
                switch(typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)){
                    case 'boolean':
                        if (value) (0, $dWsrg._)((0, $kg0zo._)(ProxyElement.prototype), "setAttribute", this).call(this, name, name + '');
                        else (0, $dWsrg._)((0, $kg0zo._)(ProxyElement.prototype), "removeAttribute", this).call(this, name);
                        break;
                    case 'function':
                        if ((0, $2159b752ecc26024$export$db26ce94c7abc843).test(key)) {
                            this.removeEventListener(eventName, oldValue);
                            this.addEventListener(eventName, value);
                        }
                        break;
                    default:
                        if (value != null) (0, $dWsrg._)((0, $kg0zo._)(ProxyElement.prototype), "setAttribute", this).call(this, name, (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) === 'object' ? JSON.stringify(value) : value);
                        else if ((0, $2159b752ecc26024$export$db26ce94c7abc843).test(key) && typeof oldValue === 'function') this.removeEventListener(eventName, value);
                        else (0, $dWsrg._)((0, $kg0zo._)(ProxyElement.prototype), "removeAttribute", this).call(this, name);
                }
            }
        },
        {
            key: "setAttribute",
            value: function setAttribute(name, value) {
                (0, $dWsrg._)((0, $kg0zo._)(ProxyElement.prototype), "setAttribute", this).call(this, name, value);
                var key = (0, $lhPyT.toCamelCase)(name);
                if (key in Object.getPrototypeOf(this)) return;
                this[key] = name === value || (0, $lhPyT.parseJSON)(value);
            }
        }
    ]);
    return ProxyElement;
}((0, $1SdK7._)(HTMLElement));
$3703681daa9862d5$var$_ProxyElement_data = new WeakMap();



var $7e446be072ac3937$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7e446be072ac3937$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $7e446be072ac3937$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $7e446be072ac3937$var$__asyncValues = undefined && undefined.__asyncValues || function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $7e446be072ac3937$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7e446be072ac3937$var$_EChartsElement_instances, $7e446be072ac3937$var$_EChartsElement_core, $7e446be072ac3937$var$_EChartsElement_coreDefer, $7e446be072ac3937$var$_EChartsElement_init;
var $7e446be072ac3937$export$653143645409d056 = /*#__PURE__*/ function(ProxyElement) {
    "use strict";
    (0, $hdIku._)(EChartsElement, ProxyElement);
    function EChartsElement() {
        (0, $173N4._)(this, EChartsElement);
        var _this;
        _this = (0, $7qXGD._)(this, EChartsElement);
        $7e446be072ac3937$var$_EChartsElement_instances.add(_this);
        $7e446be072ac3937$var$_EChartsElement_core.set(_this, void 0);
        $7e446be072ac3937$var$_EChartsElement_coreDefer.set(_this, Promise.withResolvers());
        Object.defineProperty(_this, "setOption", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $2159b752ecc26024$export$99096e10de875468)()
        });
        Object.defineProperty(_this, "connectOption", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _this.connectChildStream(function(option) {
                return _this.setOption(option);
            })
        });
        Object.defineProperty(_this, "connectAddListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _this.connectChildStream(function(event, selector, handler) {
                $7e446be072ac3937$var$__classPrivateFieldGet(_this, $7e446be072ac3937$var$_EChartsElement_core, "f").on(event, selector, handler);
            })
        });
        Object.defineProperty(_this, "connectRemoveListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _this.connectChildStream(function(event, handler) {
                $7e446be072ac3937$var$__classPrivateFieldGet(_this, $7e446be072ac3937$var$_EChartsElement_core, "f").off(event, handler);
            })
        });
        Object.defineProperty(_this, "addEventListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $2159b752ecc26024$export$99096e10de875468)()
        });
        Object.defineProperty(_this, "removeEventListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $2159b752ecc26024$export$99096e10de875468)()
        });
        Object.defineProperty(_this, "handleResize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $hDKce.debounce)(function() {
                return $7e446be072ac3937$var$__classPrivateFieldGet(_this, $7e446be072ac3937$var$_EChartsElement_core, "f").resize(_this.toJSON().resizeOptions);
            })
        });
        _this.attachShadow({
            mode: 'open'
        }).append((0, $lhPyT.parseDOM)('<div style="height: 100%" />')[0]);
        return _this;
    }
    (0, $cFHGC._)(EChartsElement, [
        {
            key: "renderer",
            get: function get() {
                var _this_tagName_toLowerCase_split = (0, $f9AOD._)(this.tagName.toLowerCase().split('-'), 2), _ = _this_tagName_toLowerCase_split[0], type = _this_tagName_toLowerCase_split[1];
                return type;
            }
        },
        {
            key: "options",
            get: function get() {
                return $7e446be072ac3937$var$__classPrivateFieldGet(this, $7e446be072ac3937$var$_EChartsElement_core, "f").getOption();
            }
        },
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var _a;
                if ($7e446be072ac3937$var$__classPrivateFieldGet(this, $7e446be072ac3937$var$_EChartsElement_core, "f")) return;
                (0, $dWsrg._)((0, $kg0zo._)(EChartsElement.prototype), "connectedCallback", this).call(this);
                this.style.display = 'block';
                $7e446be072ac3937$var$__classPrivateFieldGet(this, $7e446be072ac3937$var$_EChartsElement_instances, "m", $7e446be072ac3937$var$_EChartsElement_init).call(this);
                (_a = globalThis.addEventListener) === null || _a === void 0 || _a.call(globalThis, 'resize', this.handleResize);
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                var _a, _b;
                (_a = globalThis.removeEventListener) === null || _a === void 0 || _a.call(globalThis, 'resize', this.handleResize);
                (_b = $7e446be072ac3937$var$__classPrivateFieldGet(this, $7e446be072ac3937$var$_EChartsElement_core, "f")) === null || _b === void 0 || _b.dispose();
                $7e446be072ac3937$var$__classPrivateFieldSet(this, $7e446be072ac3937$var$_EChartsElement_core, undefined, "f");
            }
        },
        {
            key: "setProperty",
            value: function setProperty(key, value) {
                (0, $dWsrg._)((0, $kg0zo._)(EChartsElement.prototype), "setProperty", this).call(this, key, value);
                this.setOption(this.toJSON());
            }
        },
        {
            key: "processStream",
            value: function processStream(stream, executor, context) {
                return $7e446be072ac3937$var$__awaiter(this, void 0, void 0, function() {
                    var _a, stream_1, stream_1_1, _b, e_1, _c, _d, request, input, output, data, e_1_1;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $7e446be072ac3937$var$__classPrivateFieldGet(this, $7e446be072ac3937$var$_EChartsElement_coreDefer, "f").promise
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    13
                                ]);
                                _a = true, stream_1 = $7e446be072ac3937$var$__asyncValues(stream);
                                _state.label = 3;
                            case 3:
                                return [
                                    4,
                                    stream_1.next()
                                ];
                            case 4:
                                if (!(stream_1_1 = _state.sent(), _b = stream_1_1.done, !_b)) return [
                                    3,
                                    6
                                ];
                                _d = stream_1_1.value;
                                _a = false;
                                request = _d;
                                input = request.input, output = request.output;
                                try {
                                    data = executor.apply(context, input);
                                    output.resolve(data);
                                } catch (error) {
                                    output.reject(error);
                                }
                                _state.label = 5;
                            case 5:
                                _a = true;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                e_1_1 = _state.sent();
                                e_1 = {
                                    error: e_1_1
                                };
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(!_a && !_b && (_c = stream_1.return))) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _c.call(stream_1)
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (e_1) throw e_1.error;
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "connectChildStream",
            value: function connectChildStream(executor) {
                var that = this;
                return function(stream) {
                    return that.processStream(stream, executor, this);
                };
            }
        }
    ]);
    return EChartsElement;
}((0, $3703681daa9862d5$export$dfca55cafbce2a44));
$7e446be072ac3937$var$_EChartsElement_core = new WeakMap(), $7e446be072ac3937$var$_EChartsElement_coreDefer = new WeakMap(), $7e446be072ac3937$var$_EChartsElement_instances = new WeakSet(), $7e446be072ac3937$var$_EChartsElement_init = function _EChartsElement_init() {
    var _this = this;
    var _a = this.toJSON(), theme = _a.theme, initOptions = _a.initOptions, setOptions = _a.setOptions, props = $7e446be072ac3937$var$__rest(_a, [
        "theme",
        "initOptions",
        "setOptions"
    ]);
    $7e446be072ac3937$var$__classPrivateFieldSet(this, $7e446be072ac3937$var$_EChartsElement_core, (0, $ef39f475dab603c1$export$2cd8252107eb640b)(this.shadowRoot.firstElementChild, theme, Object.assign(Object.assign({}, initOptions), {
        renderer: this.renderer
    })), "f");
    $7e446be072ac3937$var$__classPrivateFieldGet(this, $7e446be072ac3937$var$_EChartsElement_coreDefer, "f").resolve();
    // @ts-ignore
    this.setOption(Object.assign({
        grid: {}
    }, props));
    this.processStream(this.setOption.stream, function(data) {
        $7e446be072ac3937$var$__classPrivateFieldGet(_this, $7e446be072ac3937$var$_EChartsElement_core, "f").setOption(data, Object.assign({
            notMerge: false,
            lazyUpdate: true
        }, setOptions));
    });
    this.processStream(this.removeEventListener.stream, function(event, handler) {
        $7e446be072ac3937$var$__classPrivateFieldGet(_this, $7e446be072ac3937$var$_EChartsElement_core, "f").getZr().off(event, (0, $2159b752ecc26024$export$7c4c84635886a982)(handler));
    });
    this.processStream(this.addEventListener.stream, function(name, handler) {
        $7e446be072ac3937$var$__classPrivateFieldGet(_this, $7e446be072ac3937$var$_EChartsElement_core, "f").getZr().on(name, (0, $2159b752ecc26024$export$d09f5504a38c35a6).call(_this, name, handler));
    });
};


var $bf4993a4cb76e3b2$var$_a;
(0, $5b64c22a7e1cb8f6$export$1f96ae73734a86cc)((0, $b6eb72d440acb22b$export$4b3e715f166fdd78));
var $bf4993a4cb76e3b2$export$14625ca68d894a68 = /*#__PURE__*/ function(EChartsElement) {
    "use strict";
    (0, $hdIku._)(ECSVGRenderer, EChartsElement);
    function ECSVGRenderer() {
        (0, $173N4._)(this, ECSVGRenderer);
        return (0, $7qXGD._)(this, ECSVGRenderer, arguments);
    }
    return ECSVGRenderer;
}((0, $7e446be072ac3937$export$653143645409d056));
($bf4993a4cb76e3b2$var$_a = globalThis.customElements) === null || $bf4993a4cb76e3b2$var$_a === void 0 || $bf4993a4cb76e3b2$var$_a.define('ec-svg-renderer', $bf4993a4cb76e3b2$export$14625ca68d894a68);



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $hdIku = parcelRequire("hdIku");
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









var $572f1fae724df0fe$var$TitleModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(TitleModel, _super);
    function TitleModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TitleModel.type;
        _this.layoutMode = {
            type: 'box',
            ignoreSize: true
        };
        return _this;
    }
    TitleModel.type = 'title';
    TitleModel.defaultOption = {
        // zlevel: 0,
        z: 6,
        show: true,
        text: '',
        target: 'blank',
        subtext: '',
        subtarget: 'blank',
        left: 'center',
        top: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).size.m,
        backgroundColor: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.transparent,
        borderColor: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.primary,
        borderWidth: 0,
        padding: 5,
        itemGap: 10,
        textStyle: {
            fontSize: 18,
            fontWeight: 'bold',
            color: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.primary
        },
        subtextStyle: {
            fontSize: 12,
            color: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.quaternary
        }
    };
    return TitleModel;
}((0, $c418de54527e13f3$export$2e2bcd8739ae039));
// View
var $572f1fae724df0fe$var$TitleView = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(TitleView, _super);
    function TitleView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TitleView.type;
        return _this;
    }
    TitleView.prototype.render = function(titleModel, ecModel, api) {
        this.group.removeAll();
        if (!titleModel.get('show')) return;
        var group = this.group;
        var textStyleModel = titleModel.getModel('textStyle');
        var subtextStyleModel = titleModel.getModel('subtextStyle');
        var textAlign = titleModel.get('textAlign');
        var textVerticalAlign = $f16f2994a32ad273$export$995e01f2f5c9d030(titleModel.get('textBaseline'), titleModel.get('textVerticalAlign'));
        var textEl = new $7d5e7dc1581f8c9a$export$2e2bcd8739ae039({
            style: (0, $1ee9c8b909b7ca82$export$f8998c3d0a13de59)(textStyleModel, {
                text: titleModel.get('text'),
                fill: textStyleModel.getTextColor()
            }, {
                disableBox: true
            }),
            z2: 10
        });
        var textRect = textEl.getBoundingRect();
        var subText = titleModel.get('subtext');
        var subTextEl = new $7d5e7dc1581f8c9a$export$2e2bcd8739ae039({
            style: (0, $1ee9c8b909b7ca82$export$f8998c3d0a13de59)(subtextStyleModel, {
                text: subText,
                fill: subtextStyleModel.getTextColor(),
                y: textRect.height + titleModel.get('itemGap'),
                verticalAlign: 'top'
            }, {
                disableBox: true
            }),
            z2: 10
        });
        var link = titleModel.get('link');
        var sublink = titleModel.get('sublink');
        var triggerEvent = titleModel.get('triggerEvent', true);
        textEl.silent = !link && !triggerEvent;
        subTextEl.silent = !sublink && !triggerEvent;
        if (link) textEl.on('click', function() {
            (0, $04bb9ff155ec4ccd$export$13e13f9b96dbe8fa)(link, '_' + titleModel.get('target'));
        });
        if (sublink) subTextEl.on('click', function() {
            (0, $04bb9ff155ec4ccd$export$13e13f9b96dbe8fa)(sublink, '_' + titleModel.get('subtarget'));
        });
        (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(textEl).eventData = (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(subTextEl).eventData = triggerEvent ? {
            componentType: 'title',
            componentIndex: titleModel.componentIndex
        } : null;
        group.add(textEl);
        subText && group.add(subTextEl);
        // If no subText, but add subTextEl, there will be an empty line.
        var groupRect = group.getBoundingRect();
        var layoutOption = titleModel.getBoxLayoutParams();
        layoutOption.width = groupRect.width;
        layoutOption.height = groupRect.height;
        var layoutRef = (0, $6b64c78bf98fea85$export$5aec1e94f566e59f)(titleModel, api);
        var layoutRect = (0, $6b64c78bf98fea85$export$4517a5ca639a7293)(layoutOption, layoutRef.refContainer, titleModel.get('padding'));
        // Adjust text align based on position
        if (!textAlign) {
            // Align left if title is on the left. center and right is same
            textAlign = titleModel.get('left') || titleModel.get('right');
            // @ts-ignore
            if (textAlign === 'middle') textAlign = 'center';
            // Adjust layout by text align
            if (textAlign === 'right') layoutRect.x += layoutRect.width;
            else if (textAlign === 'center') layoutRect.x += layoutRect.width / 2;
        }
        if (!textVerticalAlign) {
            textVerticalAlign = titleModel.get('top') || titleModel.get('bottom');
            // @ts-ignore
            if (textVerticalAlign === 'center') textVerticalAlign = 'middle';
            if (textVerticalAlign === 'bottom') layoutRect.y += layoutRect.height;
            else if (textVerticalAlign === 'middle') layoutRect.y += layoutRect.height / 2;
            textVerticalAlign = textVerticalAlign || 'top';
        }
        group.x = layoutRect.x;
        group.y = layoutRect.y;
        group.markRedraw();
        var alignStyle = {
            align: textAlign,
            verticalAlign: textVerticalAlign
        };
        textEl.setStyle(alignStyle);
        subTextEl.setStyle(alignStyle);
        // Render background
        // Get groupRect again because textAlign has been changed
        groupRect = group.getBoundingRect();
        var padding = layoutRect.margin;
        var style = titleModel.getItemStyle([
            'color',
            'opacity'
        ]);
        style.fill = titleModel.get('backgroundColor');
        var rect = new $dbd6d77105f10fb2$export$2e2bcd8739ae039({
            shape: {
                x: groupRect.x - padding[3],
                y: groupRect.y - padding[0],
                width: groupRect.width + padding[1] + padding[3],
                height: groupRect.height + padding[0] + padding[2],
                r: titleModel.get('borderRadius')
            },
            style: style,
            subPixelOptimize: true,
            silent: true
        });
        group.add(rect);
    };
    TitleView.type = 'title';
    return TitleView;
}((0, $091798b5bbee0498$export$2e2bcd8739ae039));
function $572f1fae724df0fe$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel($572f1fae724df0fe$var$TitleModel);
    registers.registerComponentView($572f1fae724df0fe$var$TitleView);
}




var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7Pjls = parcelRequire("7Pjls");

var $dWsrg = parcelRequire("dWsrg");

var $kg0zo = parcelRequire("kg0zo");

var $hdIku = parcelRequire("hdIku");

var $lhPyT = parcelRequire("lhPyT");



var $6f6095288b1fca4a$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $6f6095288b1fca4a$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $6f6095288b1fca4a$var$_ECOptionElement_id, $6f6095288b1fca4a$var$_ECOptionElement_renderer, $6f6095288b1fca4a$var$_ECOptionElement_nextTick;
var $6f6095288b1fca4a$export$37de6f71bb86a769 = /*#__PURE__*/ function(ProxyElement) {
    "use strict";
    (0, $hdIku._)(ECOptionElement, ProxyElement);
    function ECOptionElement() {
        (0, $173N4._)(this, ECOptionElement);
        var _this;
        _this = (0, $7qXGD._)(this, ECOptionElement, arguments);
        $6f6095288b1fca4a$var$_ECOptionElement_id.set(_this, (0, $lhPyT.uniqueID)());
        $6f6095288b1fca4a$var$_ECOptionElement_renderer.set(_this, void 0);
        $6f6095288b1fca4a$var$_ECOptionElement_nextTick.set(_this, void 0);
        Object.defineProperty(_this, "emitOption", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $2159b752ecc26024$export$99096e10de875468)()
        });
        Object.defineProperty(_this, "emitAddListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $2159b752ecc26024$export$99096e10de875468)()
        });
        Object.defineProperty(_this, "emitRemoveListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $2159b752ecc26024$export$99096e10de875468)()
        });
        return _this;
    }
    (0, $cFHGC._)(ECOptionElement, [
        {
            key: "chartTagName",
            get: function get() {
                return (0, $lhPyT.toCamelCase)(this.tagName.replace(/^ec-/i, '').toLowerCase());
            }
        },
        {
            key: "isSeries",
            get: function get() {
                return this.chartTagName.endsWith('Chart');
            }
        },
        {
            key: "chartName",
            get: function get() {
                return this.isSeries ? this.chartTagName.replace(/Chart$/, '') : null;
            }
        },
        {
            key: "eventSelector",
            get: function get() {
                return [
                    this.isSeries && 'series',
                    this.chartName || this.chartTagName,
                    this['type']
                ].filter(Boolean).join('.');
            }
        },
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                if ($6f6095288b1fca4a$var$__classPrivateFieldGet(this, $6f6095288b1fca4a$var$_ECOptionElement_renderer, "f")) return;
                (0, $dWsrg._)((0, $kg0zo._)(ECOptionElement.prototype), "connectedCallback", this).call(this);
                if (!this.attributes[0]) this.updateOption();
                for(var parent = this.parentElement; parent; parent = parent.parentElement)if (parent instanceof (0, $7e446be072ac3937$export$653143645409d056)) $6f6095288b1fca4a$var$__classPrivateFieldSet(this, $6f6095288b1fca4a$var$_ECOptionElement_renderer, parent, "f");
                if (!$6f6095288b1fca4a$var$__classPrivateFieldGet(this, $6f6095288b1fca4a$var$_ECOptionElement_renderer, "f")) throw new ReferenceError("<".concat(this.tagName.toLowerCase(), " /> should be append to a DOM tree within <ec-svg-renderer /> or <ec-canvas-renderer />"));
                $6f6095288b1fca4a$var$__classPrivateFieldGet(this, $6f6095288b1fca4a$var$_ECOptionElement_renderer, "f").connectOption(this.emitOption.stream);
                $6f6095288b1fca4a$var$__classPrivateFieldGet(this, $6f6095288b1fca4a$var$_ECOptionElement_renderer, "f").connectRemoveListener(this.emitRemoveListener.stream);
                $6f6095288b1fca4a$var$__classPrivateFieldGet(this, $6f6095288b1fca4a$var$_ECOptionElement_renderer, "f").connectAddListener(this.emitAddListener.stream);
            }
        },
        {
            key: "setProperty",
            value: function setProperty(key, value) {
                var _this = this;
                var _a;
                (0, $dWsrg._)((0, $kg0zo._)(ECOptionElement.prototype), "setProperty", this).call(this, key, value);
                $6f6095288b1fca4a$var$__classPrivateFieldSet(this, $6f6095288b1fca4a$var$_ECOptionElement_nextTick, (_a = $6f6095288b1fca4a$var$__classPrivateFieldGet(this, $6f6095288b1fca4a$var$_ECOptionElement_nextTick, "f")) !== null && _a !== void 0 ? _a : Promise.resolve().then(function() {
                    _this.updateOption();
                    $6f6095288b1fca4a$var$__classPrivateFieldSet(_this, $6f6095288b1fca4a$var$_ECOptionElement_nextTick, null, "f");
                }), "f");
            }
        },
        {
            key: "updateOption",
            value: function updateOption() {
                var data = this.toJSON(), formatter = this.formatter;
                var option = this.isSeries ? {
                    series: [
                        Object.assign(Object.assign({
                            id: $6f6095288b1fca4a$var$__classPrivateFieldGet(this, $6f6095288b1fca4a$var$_ECOptionElement_id, "f")
                        }, data), {
                            type: this.chartName
                        })
                    ]
                } : (0, $7Pjls._)({}, this.chartTagName, Object.assign(Object.assign({}, data), {
                    formatter: formatter
                }));
                return this.emitOption(option);
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(name, handler) {
                return this.emitAddListener(name, this.eventSelector, (0, $2159b752ecc26024$export$d09f5504a38c35a6).call(this, name, handler));
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(event, handler) {
                return this.emitRemoveListener(event, (0, $2159b752ecc26024$export$7c4c84635886a982)(handler));
            }
        }
    ]);
    return ECOptionElement;
}((0, $3703681daa9862d5$export$dfca55cafbce2a44));
$6f6095288b1fca4a$var$_ECOptionElement_id = new WeakMap(), $6f6095288b1fca4a$var$_ECOptionElement_renderer = new WeakMap(), $6f6095288b1fca4a$var$_ECOptionElement_nextTick = new WeakMap();


var $f9b6fc07bbb8b781$var$_a;
(0, $5b64c22a7e1cb8f6$export$1f96ae73734a86cc)((0, $572f1fae724df0fe$export$4b3e715f166fdd78));
var $f9b6fc07bbb8b781$export$a07c56df7267ad6f = /*#__PURE__*/ function(ECOptionElement) {
    "use strict";
    (0, $hdIku._)(ECTitleComponent, ECOptionElement);
    function ECTitleComponent() {
        (0, $173N4._)(this, ECTitleComponent);
        return (0, $7qXGD._)(this, ECTitleComponent, arguments);
    }
    return ECTitleComponent;
}((0, $6f6095288b1fca4a$export$37de6f71bb86a769));
($f9b6fc07bbb8b781$var$_a = globalThis.customElements) === null || $f9b6fc07bbb8b781$var$_a === void 0 || $f9b6fc07bbb8b781$var$_a.define('ec-title', $f9b6fc07bbb8b781$export$a07c56df7267ad6f);



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $hdIku = parcelRequire("hdIku");
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $c6522e530e49638b$var$getDefaultSelectorOptions = function getDefaultSelectorOptions(ecModel, type) {
    if (type === 'all') return {
        type: 'all',
        title: ecModel.getLocaleModel().get([
            'legend',
            'selector',
            'all'
        ])
    };
    else if (type === 'inverse') return {
        type: 'inverse',
        title: ecModel.getLocaleModel().get([
            'legend',
            'selector',
            'inverse'
        ])
    };
};
var $c6522e530e49638b$var$LegendModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(LegendModel, _super);
    function LegendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LegendModel.type;
        _this.layoutMode = {
            type: 'box',
            // legend.width/height are maxWidth/maxHeight actually,
            // whereas real width/height is calculated by its content.
            // (Setting {left: 10, right: 10} does not make sense).
            // So consider the case:
            // `setOption({legend: {left: 10});`
            // then `setOption({legend: {right: 10});`
            // The previous `left` should be cleared by setting `ignoreSize`.
            ignoreSize: true
        };
        return _this;
    }
    LegendModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        option.selected = option.selected || {};
        this._updateSelector(option);
    };
    LegendModel.prototype.mergeOption = function(option, ecModel) {
        _super.prototype.mergeOption.call(this, option, ecModel);
        this._updateSelector(option);
    };
    LegendModel.prototype._updateSelector = function(option) {
        var selector = option.selector;
        var ecModel = this.ecModel;
        if (selector === true) selector = option.selector = [
            'all',
            'inverse'
        ];
        if ($f16f2994a32ad273$export$43bee75e5e14138e(selector)) $f16f2994a32ad273$export$79b2f7037acddd43(selector, function(item, index) {
            $f16f2994a32ad273$export$844ec244b1367d54(item) && (item = {
                type: item
            });
            selector[index] = $f16f2994a32ad273$export$4950aa0f605343fb(item, $c6522e530e49638b$var$getDefaultSelectorOptions(ecModel, item.type));
        });
    };
    LegendModel.prototype.optionUpdated = function() {
        this._updateData(this.ecModel);
        var legendData = this._data;
        // If selectedMode is single, try to select one
        if (legendData[0] && this.get('selectedMode') === 'single') {
            var hasSelected = false;
            // If has any selected in option.selected
            for(var i = 0; i < legendData.length; i++){
                var name_1 = legendData[i].get('name');
                if (this.isSelected(name_1)) {
                    // Force to unselect others
                    this.select(name_1);
                    hasSelected = true;
                    break;
                }
            }
            // Try select the first if selectedMode is single
            !hasSelected && this.select(legendData[0].get('name'));
        }
    };
    LegendModel.prototype._updateData = function(ecModel) {
        var potentialData = [];
        var availableNames = [];
        ecModel.eachRawSeries(function(seriesModel) {
            var seriesName = seriesModel.name;
            availableNames.push(seriesName);
            var isPotential;
            if (seriesModel.legendVisualProvider) {
                var provider = seriesModel.legendVisualProvider;
                var names = provider.getAllNames();
                if (!ecModel.isSeriesFiltered(seriesModel)) availableNames = availableNames.concat(names);
                if (names.length) potentialData = potentialData.concat(names);
                else isPotential = true;
            } else isPotential = true;
            if (isPotential && (0, $3fa81475350067fd$export$beae19a2652b3368)(seriesModel)) potentialData.push(seriesModel.name);
        });
        /**
     * @type {Array.<string>}
     * @private
     */ this._availableNames = availableNames;
        // If legend.data is not specified in option, use availableNames as data,
        // which is convenient for user preparing option.
        var rawData = this.get('data') || potentialData;
        var legendNameMap = $f16f2994a32ad273$export$55f8aa7ef875b0a4();
        var legendData = $f16f2994a32ad273$export$871de8747c9eaa88(rawData, function(dataItem) {
            // Can be string or number
            if ($f16f2994a32ad273$export$844ec244b1367d54(dataItem) || $f16f2994a32ad273$export$7e4aa119212bc614(dataItem)) dataItem = {
                name: dataItem
            };
            if (legendNameMap.get(dataItem.name)) // remove legend name duplicate
            return null;
            legendNameMap.set(dataItem.name, true);
            return new (0, $37821cf56da37613$export$2e2bcd8739ae039)(dataItem, this, this.ecModel);
        }, this);
        /**
     * @type {Array.<module:echarts/model/Model>}
     * @private
     */ this._data = $f16f2994a32ad273$export$3dea766d36a8935f(legendData, function(item) {
            return !!item;
        });
    };
    LegendModel.prototype.getData = function() {
        return this._data;
    };
    LegendModel.prototype.select = function(name) {
        var selected = this.option.selected;
        var selectedMode = this.get('selectedMode');
        if (selectedMode === 'single') {
            var data = this._data;
            $f16f2994a32ad273$export$79b2f7037acddd43(data, function(dataItem) {
                selected[dataItem.get('name')] = false;
            });
        }
        selected[name] = true;
    };
    LegendModel.prototype.unSelect = function(name) {
        if (this.get('selectedMode') !== 'single') this.option.selected[name] = false;
    };
    LegendModel.prototype.toggleSelected = function(name) {
        var selected = this.option.selected;
        // Default is true
        if (!selected.hasOwnProperty(name)) selected[name] = true;
        this[selected[name] ? 'unSelect' : 'select'](name);
    };
    LegendModel.prototype.allSelect = function() {
        var data = this._data;
        var selected = this.option.selected;
        $f16f2994a32ad273$export$79b2f7037acddd43(data, function(dataItem) {
            selected[dataItem.get('name', true)] = true;
        });
    };
    LegendModel.prototype.inverseSelect = function() {
        var data = this._data;
        var selected = this.option.selected;
        $f16f2994a32ad273$export$79b2f7037acddd43(data, function(dataItem) {
            var name = dataItem.get('name', true);
            // Initially, default value is true
            if (!selected.hasOwnProperty(name)) selected[name] = true;
            selected[name] = !selected[name];
        });
    };
    LegendModel.prototype.isSelected = function(name) {
        var selected = this.option.selected;
        return !(selected.hasOwnProperty(name) && !selected[name]) && $f16f2994a32ad273$export$305f7d4e9d4624f2(this._availableNames, name) >= 0;
    };
    LegendModel.prototype.getOrient = function() {
        return this.get('orient') === 'vertical' ? {
            index: 1,
            name: 'vertical'
        } : {
            index: 0,
            name: 'horizontal'
        };
    };
    LegendModel.type = 'legend.plain';
    LegendModel.dependencies = [
        'series'
    ];
    LegendModel.defaultOption = {
        // zlevel: 0,
        z: 4,
        show: true,
        orient: 'horizontal',
        left: 'center',
        // right: 'center',
        // top: 0,
        bottom: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).size.m,
        align: 'auto',
        backgroundColor: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.transparent,
        borderColor: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.border,
        borderRadius: 0,
        borderWidth: 0,
        padding: 5,
        itemGap: 8,
        itemWidth: 25,
        itemHeight: 14,
        symbolRotate: 'inherit',
        symbolKeepAspect: true,
        inactiveColor: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.disabled,
        inactiveBorderColor: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.disabled,
        inactiveBorderWidth: 'auto',
        itemStyle: {
            color: 'inherit',
            opacity: 'inherit',
            borderColor: 'inherit',
            borderWidth: 'auto',
            borderCap: 'inherit',
            borderJoin: 'inherit',
            borderDashOffset: 'inherit',
            borderMiterLimit: 'inherit'
        },
        lineStyle: {
            width: 'auto',
            color: 'inherit',
            inactiveColor: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.disabled,
            inactiveWidth: 2,
            opacity: 'inherit',
            type: 'inherit',
            cap: 'inherit',
            join: 'inherit',
            dashOffset: 'inherit',
            miterLimit: 'inherit'
        },
        textStyle: {
            color: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.secondary
        },
        selectedMode: true,
        selector: false,
        selectorLabel: {
            show: true,
            borderRadius: 10,
            padding: [
                3,
                5,
                3,
                5
            ],
            fontSize: 12,
            fontFamily: 'sans-serif',
            color: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.tertiary,
            borderWidth: 1,
            borderColor: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.border
        },
        emphasis: {
            selectorLabel: {
                show: true,
                color: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.quaternary
            }
        },
        selectorPosition: 'auto',
        selectorItemGap: 7,
        selectorButtonGap: 10,
        tooltip: {
            show: false
        },
        triggerEvent: false
    };
    return LegendModel;
}((0, $c418de54527e13f3$export$2e2bcd8739ae039));
var $c6522e530e49638b$export$2e2bcd8739ae039 = $c6522e530e49638b$var$LegendModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $42570c37db9655c8$export$fae23936eedfad4f(rect, componentModel) {
    var padding = $04bb9ff155ec4ccd$export$f3a38102c49f4268(componentModel.get('padding'));
    var style = componentModel.getItemStyle([
        'color',
        'opacity'
    ]);
    style.fill = componentModel.get('backgroundColor');
    var bgRect = new $dbd6d77105f10fb2$export$2e2bcd8739ae039({
        shape: {
            x: rect.x - padding[3],
            y: rect.y - padding[0],
            width: rect.width + padding[1] + padding[3],
            height: rect.height + padding[0] + padding[2],
            r: componentModel.get('borderRadius')
        },
        style: style,
        silent: true,
        z2: -1
    });
    // FIXME
    // `subPixelOptimizeRect` may bring some gap between edge of viewpart
    // and background rect when setting like `left: 0`, `top: 0`.
    // graphic.subPixelOptimizeRect(rect);
    return bgRect;
}








var $b9465e8e1dcaac5c$var$curry = $f16f2994a32ad273$export$c3095a23b368d1f2;
var $b9465e8e1dcaac5c$var$each = $f16f2994a32ad273$export$79b2f7037acddd43;
var $b9465e8e1dcaac5c$var$Group = $ac4abc1f547da31a$export$2e2bcd8739ae039;
var $b9465e8e1dcaac5c$var$LegendView = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(LegendView, _super);
    function LegendView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LegendView.type;
        _this.newlineDisabled = false;
        return _this;
    }
    LegendView.prototype.init = function() {
        this.group.add(this._contentGroup = new $b9465e8e1dcaac5c$var$Group());
        this.group.add(this._selectorGroup = new $b9465e8e1dcaac5c$var$Group());
        this._isFirstRender = true;
    };
    /**
   * @protected
   */ LegendView.prototype.getContentGroup = function() {
        return this._contentGroup;
    };
    /**
   * @protected
   */ LegendView.prototype.getSelectorGroup = function() {
        return this._selectorGroup;
    };
    /**
   * @override
   */ LegendView.prototype.render = function(legendModel, ecModel, api) {
        var isFirstRender = this._isFirstRender;
        this._isFirstRender = false;
        this.resetInner();
        if (!legendModel.get('show', true)) return;
        var itemAlign = legendModel.get('align');
        var orient = legendModel.get('orient');
        if (!itemAlign || itemAlign === 'auto') itemAlign = legendModel.get('left') === 'right' && orient === 'vertical' ? 'right' : 'left';
        // selector has been normalized to an array in model
        var selector = legendModel.get('selector', true);
        var selectorPosition = legendModel.get('selectorPosition', true);
        if (selector && (!selectorPosition || selectorPosition === 'auto')) selectorPosition = orient === 'horizontal' ? 'end' : 'start';
        this.renderInner(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        // Perform layout.
        var refContainer = $6b64c78bf98fea85$export$5aec1e94f566e59f(legendModel, api).refContainer;
        var positionInfo = legendModel.getBoxLayoutParams();
        var padding = legendModel.get('padding');
        var maxSize = $6b64c78bf98fea85$export$4517a5ca639a7293(positionInfo, refContainer, padding);
        var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition);
        // Place mainGroup, based on the calculated `mainRect`.
        var layoutRect = $6b64c78bf98fea85$export$4517a5ca639a7293($f16f2994a32ad273$export$ebe90cb607ad99e({
            width: mainRect.width,
            height: mainRect.height
        }, positionInfo), refContainer, padding);
        this.group.x = layoutRect.x - mainRect.x;
        this.group.y = layoutRect.y - mainRect.y;
        this.group.markRedraw();
        // Render background after group is layout.
        this.group.add(this._backgroundEl = (0, $42570c37db9655c8$export$fae23936eedfad4f)(mainRect, // FXIME: most itemStyle options does not work in background because inherit is not handled yet.
        legendModel));
    };
    LegendView.prototype.resetInner = function() {
        this.getContentGroup().removeAll();
        this._backgroundEl && this.group.remove(this._backgroundEl);
        this.getSelectorGroup().removeAll();
    };
    LegendView.prototype.renderInner = function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var legendDrawnMap = $f16f2994a32ad273$export$55f8aa7ef875b0a4();
        var selectMode = legendModel.get('selectedMode');
        var triggerEvent = legendModel.get('triggerEvent');
        var excludeSeriesId = [];
        ecModel.eachRawSeries(function(seriesModel) {
            !seriesModel.get('legendHoverLink') && excludeSeriesId.push(seriesModel.id);
        });
        $b9465e8e1dcaac5c$var$each(legendModel.getData(), function(legendItemModel, dataIndex) {
            var _this = this;
            var name = legendItemModel.get('name');
            // Use empty string or \n as a newline string
            if (!this.newlineDisabled && (name === '' || name === '\n')) {
                var g = new $b9465e8e1dcaac5c$var$Group();
                // @ts-ignore
                g.newline = true;
                contentGroup.add(g);
                return;
            }
            // Representitive series.
            var seriesModel = ecModel.getSeriesByName(name)[0];
            if (legendDrawnMap.get(name)) // Have been drawn
            return;
            // Legend to control series.
            if (seriesModel) {
                var data = seriesModel.getData();
                var lineVisualStyle = data.getVisual('legendLineStyle') || {};
                var legendIcon = data.getVisual('legendIcon');
                /**
         * `data.getVisual('style')` may be the color from the register
         * in series. For example, for line series,
         */ var style = data.getVisual('style');
                var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, style, legendIcon, selectMode, api);
                itemGroup.on('click', $b9465e8e1dcaac5c$var$curry($b9465e8e1dcaac5c$var$dispatchSelectAction, name, null, api, excludeSeriesId)).on('mouseover', $b9465e8e1dcaac5c$var$curry($b9465e8e1dcaac5c$var$dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on('mouseout', $b9465e8e1dcaac5c$var$curry($b9465e8e1dcaac5c$var$dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
                if (ecModel.ssr) itemGroup.eachChild(function(child) {
                    var ecData = (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(child);
                    ecData.seriesIndex = seriesModel.seriesIndex;
                    ecData.dataIndex = dataIndex;
                    ecData.ssrType = 'legend';
                });
                if (triggerEvent) itemGroup.eachChild(function(child) {
                    _this.packEventData(child, legendModel, seriesModel, dataIndex, name);
                });
                legendDrawnMap.set(name, true);
            } else // Legend to control data. In pie and funnel.
            ecModel.eachRawSeries(function(seriesModel) {
                var _this = this;
                // In case multiple series has same data name
                if (legendDrawnMap.get(name)) return;
                if (seriesModel.legendVisualProvider) {
                    var provider = seriesModel.legendVisualProvider;
                    if (!provider.containName(name)) return;
                    var idx = provider.indexOfName(name);
                    var style = provider.getItemVisual(idx, 'style');
                    var legendIcon = provider.getItemVisual(idx, 'legendIcon');
                    var colorArr = (0, $83e50b4ee4d3c357$export$98e6a39c04603d36)(style.fill);
                    // Color may be set to transparent in visualMap when data is out of range.
                    // Do not show nothing.
                    if (colorArr && colorArr[3] === 0) {
                        colorArr[3] = 0.2;
                        // TODO color is set to 0, 0, 0, 0. Should show correct RGBA
                        style = $f16f2994a32ad273$export$8b58be045bf06082($f16f2994a32ad273$export$8b58be045bf06082({}, style), {
                            fill: (0, $83e50b4ee4d3c357$export$fac44ee5b035f737)(colorArr, 'rgba')
                        });
                    }
                    var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, {}, style, legendIcon, selectMode, api);
                    // FIXME: consider different series has items with the same name.
                    itemGroup.on('click', $b9465e8e1dcaac5c$var$curry($b9465e8e1dcaac5c$var$dispatchSelectAction, null, name, api, excludeSeriesId))// Should not specify the series name, consider legend controls
                    // more than one pie series.
                    .on('mouseover', $b9465e8e1dcaac5c$var$curry($b9465e8e1dcaac5c$var$dispatchHighlightAction, null, name, api, excludeSeriesId)).on('mouseout', $b9465e8e1dcaac5c$var$curry($b9465e8e1dcaac5c$var$dispatchDownplayAction, null, name, api, excludeSeriesId));
                    if (ecModel.ssr) itemGroup.eachChild(function(child) {
                        var ecData = (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(child);
                        ecData.seriesIndex = seriesModel.seriesIndex;
                        ecData.dataIndex = dataIndex;
                        ecData.ssrType = 'legend';
                    });
                    if (triggerEvent) itemGroup.eachChild(function(child) {
                        _this.packEventData(child, legendModel, seriesModel, dataIndex, name);
                    });
                    legendDrawnMap.set(name, true);
                }
            }, this);
        }, this);
        if (selector) this._createSelector(selector, legendModel, api, orient, selectorPosition);
    };
    LegendView.prototype.packEventData = function(el, legendModel, seriesModel, dataIndex, name) {
        var eventData = {
            componentType: 'legend',
            componentIndex: legendModel.componentIndex,
            dataIndex: dataIndex,
            value: name,
            seriesIndex: seriesModel.seriesIndex
        };
        (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(el).eventData = eventData;
    };
    LegendView.prototype._createSelector = function(selector, legendModel, api, orient, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        $b9465e8e1dcaac5c$var$each(selector, function createSelectorButton(selectorItem) {
            var type = selectorItem.type;
            var labelText = new $7d5e7dc1581f8c9a$export$2e2bcd8739ae039({
                style: {
                    x: 0,
                    y: 0,
                    align: 'center',
                    verticalAlign: 'middle'
                },
                onclick: function onclick() {
                    api.dispatchAction({
                        type: type === 'all' ? 'legendAllSelect' : 'legendInverseSelect',
                        legendId: legendModel.id
                    });
                }
            });
            selectorGroup.add(labelText);
            var labelModel = legendModel.getModel('selectorLabel');
            var emphasisLabelModel = legendModel.getModel([
                'emphasis',
                'selectorLabel'
            ]);
            (0, $1ee9c8b909b7ca82$export$9a13992917966657)(labelText, {
                normal: labelModel,
                emphasis: emphasisLabelModel
            }, {
                defaultText: selectorItem.title
            });
            (0, $1f99b77b45f30655$export$5f393df0b5aee2e7)(labelText);
        });
    };
    LegendView.prototype._createItem = function(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, itemVisualStyle, legendIcon, selectMode, api) {
        var drawType = seriesModel.visualDrawType;
        var itemWidth = legendModel.get('itemWidth');
        var itemHeight = legendModel.get('itemHeight');
        var isSelected = legendModel.isSelected(name);
        var iconRotate = legendItemModel.get('symbolRotate');
        var symbolKeepAspect = legendItemModel.get('symbolKeepAspect');
        var legendIconType = legendItemModel.get('icon');
        legendIcon = legendIconType || legendIcon || 'roundRect';
        var style = $b9465e8e1dcaac5c$var$getLegendStyle(legendIcon, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api);
        var itemGroup = new $b9465e8e1dcaac5c$var$Group();
        var textStyleModel = legendItemModel.getModel('textStyle');
        if ($f16f2994a32ad273$export$f6e2535fb5126e54(seriesModel.getLegendIcon) && (!legendIconType || legendIconType === 'inherit')) // Series has specific way to define legend icon
        itemGroup.add(seriesModel.getLegendIcon({
            itemWidth: itemWidth,
            itemHeight: itemHeight,
            icon: legendIcon,
            iconRotate: iconRotate,
            itemStyle: style.itemStyle,
            lineStyle: style.lineStyle,
            symbolKeepAspect: symbolKeepAspect
        }));
        else {
            // Use default legend icon policy for most series
            var rotate = legendIconType === 'inherit' && seriesModel.getData().getVisual('symbol') ? iconRotate === 'inherit' ? seriesModel.getData().getVisual('symbolRotate') : iconRotate : 0; // No rotation for no icon
            itemGroup.add($b9465e8e1dcaac5c$var$getDefaultLegendIcon({
                itemWidth: itemWidth,
                itemHeight: itemHeight,
                icon: legendIcon,
                iconRotate: rotate,
                itemStyle: style.itemStyle,
                lineStyle: style.lineStyle,
                symbolKeepAspect: symbolKeepAspect
            }));
        }
        var textX = itemAlign === 'left' ? itemWidth + 5 : -5;
        var textAlign = itemAlign;
        var formatter = legendModel.get('formatter');
        var content = name;
        if ($f16f2994a32ad273$export$844ec244b1367d54(formatter) && formatter) content = formatter.replace('{name}', name != null ? name : '');
        else if ($f16f2994a32ad273$export$f6e2535fb5126e54(formatter)) content = formatter(name);
        var textColor = isSelected ? textStyleModel.getTextColor() : legendItemModel.get('inactiveColor');
        itemGroup.add(new $7d5e7dc1581f8c9a$export$2e2bcd8739ae039({
            style: (0, $1ee9c8b909b7ca82$export$f8998c3d0a13de59)(textStyleModel, {
                text: content,
                x: textX,
                y: itemHeight / 2,
                fill: textColor,
                align: textAlign,
                verticalAlign: 'middle'
            }, {
                inheritColor: textColor
            })
        }));
        // Add a invisible rect to increase the area of mouse hover
        var hitRect = new $dbd6d77105f10fb2$export$2e2bcd8739ae039({
            shape: itemGroup.getBoundingRect(),
            style: {
                // Cannot use 'invisible' because SVG SSR will miss the node
                fill: 'transparent'
            }
        });
        var tooltipModel = legendItemModel.getModel('tooltip');
        if (tooltipModel.get('show')) $bce1f681c7fb2581$export$fc6410d97fab306c({
            el: hitRect,
            componentModel: legendModel,
            itemName: name,
            itemTooltipOption: tooltipModel.option
        });
        itemGroup.add(hitRect);
        itemGroup.eachChild(function(child) {
            child.silent = true;
        });
        hitRect.silent = !selectMode;
        this.getContentGroup().add(itemGroup);
        (0, $1f99b77b45f30655$export$5f393df0b5aee2e7)(itemGroup);
        // @ts-ignore
        itemGroup.__legendDataIndex = dataIndex;
        return itemGroup;
    };
    LegendView.prototype.layoutInner = function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var selectorGroup = this.getSelectorGroup();
        // Place items in contentGroup.
        $6b64c78bf98fea85$export$827f4ee28efc37(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), maxSize.width, maxSize.height);
        var contentRect = contentGroup.getBoundingRect();
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        selectorGroup.markRedraw();
        contentGroup.markRedraw();
        if (selector) {
            // Place buttons in selectorGroup
            $6b64c78bf98fea85$export$827f4ee28efc37(// Buttons in selectorGroup always layout horizontally
            'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
            var selectorRect = selectorGroup.getBoundingRect();
            var selectorPos = [
                -selectorRect.x,
                -selectorRect.y
            ];
            var selectorButtonGap = legendModel.get('selectorButtonGap', true);
            var orientIdx = legendModel.getOrient().index;
            var wh = orientIdx === 0 ? 'width' : 'height';
            var hw = orientIdx === 0 ? 'height' : 'width';
            var yx = orientIdx === 0 ? 'y' : 'x';
            if (selectorPosition === 'end') selectorPos[orientIdx] += contentRect[wh] + selectorButtonGap;
            else contentPos[orientIdx] += selectorRect[wh] + selectorButtonGap;
            // Always align selector to content as 'middle'
            selectorPos[1 - orientIdx] += contentRect[hw] / 2 - selectorRect[hw] / 2;
            selectorGroup.x = selectorPos[0];
            selectorGroup.y = selectorPos[1];
            contentGroup.x = contentPos[0];
            contentGroup.y = contentPos[1];
            var mainRect = {
                x: 0,
                y: 0
            };
            mainRect[wh] = contentRect[wh] + selectorButtonGap + selectorRect[wh];
            mainRect[hw] = Math.max(contentRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(0, selectorRect[yx] + selectorPos[1 - orientIdx]);
            return mainRect;
        } else {
            contentGroup.x = contentPos[0];
            contentGroup.y = contentPos[1];
            return this.group.getBoundingRect();
        }
    };
    /**
   * @protected
   */ LegendView.prototype.remove = function() {
        this.getContentGroup().removeAll();
        this._isFirstRender = true;
    };
    LegendView.type = 'legend.plain';
    return LegendView;
}((0, $091798b5bbee0498$export$2e2bcd8739ae039));
function $b9465e8e1dcaac5c$var$getLegendStyle(iconType, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api) {
    /**
   * Use series style if is inherit;
   * elsewise, use legend style
   */ function handleCommonProps(style, visualStyle) {
        // If lineStyle.width is 'auto', it is set to be 2 if series has border
        if (style.lineWidth === 'auto') style.lineWidth = visualStyle.lineWidth > 0 ? 2 : 0;
        $b9465e8e1dcaac5c$var$each(style, function(propVal, propName) {
            style[propName] === 'inherit' && (style[propName] = visualStyle[propName]);
        });
    }
    // itemStyle
    var itemStyleModel = legendItemModel.getModel('itemStyle');
    var itemStyle = itemStyleModel.getItemStyle();
    var iconBrushType = iconType.lastIndexOf('empty', 0) === 0 ? 'fill' : 'stroke';
    var decalStyle = itemStyleModel.getShallow('decal');
    itemStyle.decal = !decalStyle || decalStyle === 'inherit' ? itemVisualStyle.decal : (0, $f7e596ba18057d67$export$a3ba048e1a648972)(decalStyle, api);
    if (itemStyle.fill === 'inherit') /**
     * Series with visualDrawType as 'stroke' should have
     * series stroke as legend fill
     */ itemStyle.fill = itemVisualStyle[drawType];
    if (itemStyle.stroke === 'inherit') /**
     * icon type with "emptyXXX" should use fill color
     * in visual style
     */ itemStyle.stroke = itemVisualStyle[iconBrushType];
    if (itemStyle.opacity === 'inherit') /**
     * Use lineStyle.opacity if drawType is stroke
     */ itemStyle.opacity = (drawType === 'fill' ? itemVisualStyle : lineVisualStyle).opacity;
    handleCommonProps(itemStyle, itemVisualStyle);
    // lineStyle
    var legendLineModel = legendItemModel.getModel('lineStyle');
    var lineStyle = legendLineModel.getLineStyle();
    handleCommonProps(lineStyle, lineVisualStyle);
    // Fix auto color to real color
    itemStyle.fill === 'auto' && (itemStyle.fill = itemVisualStyle.fill);
    itemStyle.stroke === 'auto' && (itemStyle.stroke = itemVisualStyle.fill);
    lineStyle.stroke === 'auto' && (lineStyle.stroke = itemVisualStyle.fill);
    if (!isSelected) {
        var borderWidth = legendItemModel.get('inactiveBorderWidth');
        /**
     * Since stroke is set to be inactiveBorderColor, it may occur that
     * there is no border in series but border in legend, so we need to
     * use border only when series has border if is set to be auto
     */ var visualHasBorder = itemStyle[iconBrushType];
        itemStyle.lineWidth = borderWidth === 'auto' ? itemVisualStyle.lineWidth > 0 && visualHasBorder ? 2 : 0 : itemStyle.lineWidth;
        itemStyle.fill = legendItemModel.get('inactiveColor');
        itemStyle.stroke = legendItemModel.get('inactiveBorderColor');
        lineStyle.stroke = legendLineModel.get('inactiveColor');
        lineStyle.lineWidth = legendLineModel.get('inactiveWidth');
    }
    return {
        itemStyle: itemStyle,
        lineStyle: lineStyle
    };
}
function $b9465e8e1dcaac5c$var$getDefaultLegendIcon(opt) {
    var symboType = opt.icon || 'roundRect';
    var icon = (0, $ea44e91fc072e728$export$af050e04da3a02e8)(symboType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill, opt.symbolKeepAspect);
    icon.setStyle(opt.itemStyle);
    icon.rotation = (opt.iconRotate || 0) * Math.PI / 180;
    icon.setOrigin([
        opt.itemWidth / 2,
        opt.itemHeight / 2
    ]);
    if (symboType.indexOf('empty') > -1) {
        icon.style.stroke = icon.style.fill;
        icon.style.fill = (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.neutral00;
        icon.style.lineWidth = 2;
    }
    return icon;
}
function $b9465e8e1dcaac5c$var$dispatchSelectAction(seriesName, dataName, api, excludeSeriesId) {
    // downplay before unselect
    $b9465e8e1dcaac5c$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId);
    api.dispatchAction({
        type: 'legendToggleSelect',
        name: seriesName != null ? seriesName : dataName
    });
    // highlight after select
    // TODO highlight immediately may cause animation loss.
    $b9465e8e1dcaac5c$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId);
}
function $b9465e8e1dcaac5c$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
    if (!api.usingTHL()) api.dispatchAction({
        type: 'highlight',
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
function $b9465e8e1dcaac5c$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
    if (!api.usingTHL()) api.dispatchAction({
        type: 'downplay',
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
var $b9465e8e1dcaac5c$export$2e2bcd8739ae039 = $b9465e8e1dcaac5c$var$LegendView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $661cf0e873683314$var$legendSelectActionHandler(methodName, payload, ecModel) {
    var isAllSelect = methodName === 'allSelect' || methodName === 'inverseSelect';
    var selectedMap = {};
    var actionLegendIndices = [];
    ecModel.eachComponent({
        mainType: 'legend',
        query: payload
    }, function(legendModel) {
        if (isAllSelect) legendModel[methodName]();
        else legendModel[methodName](payload.name);
        $661cf0e873683314$var$makeSelectedMap(legendModel, selectedMap);
        actionLegendIndices.push(legendModel.componentIndex);
    });
    var allSelectedMap = {};
    // make selectedMap from all legend components
    ecModel.eachComponent('legend', function(legendModel) {
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(selectedMap, function(isSelected, name) {
            // Force other legend has same selected status
            // Or the first is toggled to true and other are toggled to false
            // In the case one legend has some item unSelected in option. And if other legend
            // doesn't has the item, they will assume it is selected.
            legendModel[isSelected ? 'select' : 'unSelect'](name);
        });
        $661cf0e873683314$var$makeSelectedMap(legendModel, allSelectedMap);
    });
    // Return the event explicitly
    return isAllSelect ? {
        selected: allSelectedMap,
        // return legendIndex array to tell the developers which legends are allSelect / inverseSelect
        legendIndex: actionLegendIndices
    } : {
        name: payload.name,
        selected: allSelectedMap
    };
}
function $661cf0e873683314$var$makeSelectedMap(legendModel, out) {
    var selectedMap = out || {};
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(legendModel.getData(), function(model) {
        var name = model.get('name');
        // Wrap element
        if (name === '\n' || name === '') return;
        var isItemSelected = legendModel.isSelected(name);
        if ((0, $f16f2994a32ad273$export$b5a638e9b3fff9f3)(selectedMap, name)) // Unselected if any legend is unselected
        selectedMap[name] = selectedMap[name] && isItemSelected;
        else selectedMap[name] = isItemSelected;
    });
    return selectedMap;
}
function $661cf0e873683314$export$139982ea529c452f(registers) {
    /**
   * @event legendToggleSelect
   * @type {Object}
   * @property {string} type 'legendToggleSelect'
   * @property {string} [from]
   * @property {string} name Series name or data item name
   */ registers.registerAction('legendToggleSelect', 'legendselectchanged', (0, $f16f2994a32ad273$export$c3095a23b368d1f2)($661cf0e873683314$var$legendSelectActionHandler, 'toggleSelected'));
    registers.registerAction('legendAllSelect', 'legendselectall', (0, $f16f2994a32ad273$export$c3095a23b368d1f2)($661cf0e873683314$var$legendSelectActionHandler, 'allSelect'));
    registers.registerAction('legendInverseSelect', 'legendinverseselect', (0, $f16f2994a32ad273$export$c3095a23b368d1f2)($661cf0e873683314$var$legendSelectActionHandler, 'inverseSelect'));
    /**
   * @event legendSelect
   * @type {Object}
   * @property {string} type 'legendSelect'
   * @property {string} name Series name or data item name
   */ registers.registerAction('legendSelect', 'legendselected', (0, $f16f2994a32ad273$export$c3095a23b368d1f2)($661cf0e873683314$var$legendSelectActionHandler, 'select'));
    /**
   * @event legendUnSelect
   * @type {Object}
   * @property {string} type 'legendUnSelect'
   * @property {string} name Series name or data item name
   */ registers.registerAction('legendUnSelect', 'legendunselected', (0, $f16f2994a32ad273$export$c3095a23b368d1f2)($661cf0e873683314$var$legendSelectActionHandler, 'unSelect'));
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2dff2f50c8c60a98$export$93f5c873e193c7e3 = (0, $3fa81475350067fd$export$d62c61cad9d1ab83)($2dff2f50c8c60a98$var$legendFilter);
function $2dff2f50c8c60a98$var$legendFilter(ecModel) {
    var legendModels = ecModel.findComponents({
        mainType: 'legend'
    });
    if (legendModels && legendModels.length) ecModel.filterSeries(function(series) {
        // If in any legend component the status is not selected.
        // Because in legend series is assumed selected when it is not in the legend data.
        for(var i = 0; i < legendModels.length; i++){
            if (!legendModels[i].isSelected(series.name)) return false;
        }
        return true;
    });
}


function $3a3ae8ad26565944$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $c6522e530e49638b$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $b9465e8e1dcaac5c$export$2e2bcd8739ae039));
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.SERIES_FILTER, (0, $2dff2f50c8c60a98$export$93f5c873e193c7e3));
    registers.registerSubTypeDefaulter('legend', function() {
        return 'plain';
    });
    (0, $661cf0e873683314$export$139982ea529c452f)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $7e974701deac08af$var$ScrollableLegendModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(ScrollableLegendModel, _super);
    function ScrollableLegendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScrollableLegendModel.type;
        return _this;
    }
    /**
   * @param {number} scrollDataIndex
   */ ScrollableLegendModel.prototype.setScrollDataIndex = function(scrollDataIndex) {
        this.option.scrollDataIndex = scrollDataIndex;
    };
    ScrollableLegendModel.prototype.init = function(option, parentModel, ecModel) {
        var inputPositionParams = (0, $6b64c78bf98fea85$export$4b0d20af19c9875e)(option);
        _super.prototype.init.call(this, option, parentModel, ecModel);
        $7e974701deac08af$var$mergeAndNormalizeLayoutParams(this, option, inputPositionParams);
    };
    /**
   * @override
   */ ScrollableLegendModel.prototype.mergeOption = function(option, ecModel) {
        _super.prototype.mergeOption.call(this, option, ecModel);
        $7e974701deac08af$var$mergeAndNormalizeLayoutParams(this, this.option, option);
    };
    ScrollableLegendModel.type = 'legend.scroll';
    ScrollableLegendModel.defaultOption = (0, $b2c0501cd47c18d8$export$68acc510e46fef2)((0, $c6522e530e49638b$export$2e2bcd8739ae039).defaultOption, {
        scrollDataIndex: 0,
        pageButtonItemGap: 5,
        pageButtonGap: null,
        pageButtonPosition: 'end',
        pageFormatter: '{current}/{total}',
        pageIcons: {
            horizontal: [
                'M0,0L12,-10L12,10z',
                'M0,0L-12,-10L-12,10z'
            ],
            vertical: [
                'M0,0L20,0L10,-20z',
                'M0,0L20,0L10,20z'
            ]
        },
        pageIconColor: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.accent50,
        pageIconInactiveColor: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.accent10,
        pageIconSize: 15,
        pageTextStyle: {
            color: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.tertiary
        },
        animationDurationUpdate: 800
    });
    return ScrollableLegendModel;
}((0, $c6522e530e49638b$export$2e2bcd8739ae039));
// Do not `ignoreSize` to enable setting {left: 10, right: 10}.
function $7e974701deac08af$var$mergeAndNormalizeLayoutParams(legendModel, target, raw) {
    var orient = legendModel.getOrient();
    var ignoreSize = [
        1,
        1
    ];
    ignoreSize[orient.index] = 0;
    (0, $6b64c78bf98fea85$export$1754cb91f16ca028)(target, raw, {
        type: 'box',
        ignoreSize: !!ignoreSize
    });
}
var $7e974701deac08af$export$2e2bcd8739ae039 = $7e974701deac08af$var$ScrollableLegendModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $4433b5346a419ac2$var$Group = $ac4abc1f547da31a$export$2e2bcd8739ae039;
var $4433b5346a419ac2$var$WH = [
    'width',
    'height'
];
var $4433b5346a419ac2$var$XY = [
    'x',
    'y'
];
var $4433b5346a419ac2$var$ScrollableLegendView = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(ScrollableLegendView, _super);
    function ScrollableLegendView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScrollableLegendView.type;
        _this.newlineDisabled = true;
        _this._currentIndex = 0;
        return _this;
    }
    ScrollableLegendView.prototype.init = function() {
        _super.prototype.init.call(this);
        this.group.add(this._containerGroup = new $4433b5346a419ac2$var$Group());
        this._containerGroup.add(this.getContentGroup());
        this.group.add(this._controllerGroup = new $4433b5346a419ac2$var$Group());
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.resetInner = function() {
        _super.prototype.resetInner.call(this);
        this._controllerGroup.removeAll();
        this._containerGroup.removeClipPath();
        this._containerGroup.__rectSize = null;
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.renderInner = function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var self = this;
        // Render content items.
        _super.prototype.renderInner.call(this, itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        var controllerGroup = this._controllerGroup;
        // FIXME: support be 'auto' adapt to size number text length,
        // e.g., '3/12345' should not overlap with the control arrow button.
        var pageIconSize = legendModel.get('pageIconSize', true);
        var pageIconSizeArr = $f16f2994a32ad273$export$43bee75e5e14138e(pageIconSize) ? pageIconSize : [
            pageIconSize,
            pageIconSize
        ];
        createPageButton('pagePrev', 0);
        var pageTextStyleModel = legendModel.getModel('pageTextStyle');
        controllerGroup.add(new $7d5e7dc1581f8c9a$export$2e2bcd8739ae039({
            name: 'pageText',
            style: {
                // Placeholder to calculate a proper layout.
                text: 'xx/xx',
                fill: pageTextStyleModel.getTextColor(),
                font: pageTextStyleModel.getFont(),
                verticalAlign: 'middle',
                align: 'center'
            },
            silent: true
        }));
        createPageButton('pageNext', 1);
        function createPageButton(name, iconIdx) {
            var pageDataIndexName = name + 'DataIndex';
            var icon = $bce1f681c7fb2581$export$274edc73af1ae9c8(legendModel.get('pageIcons', true)[legendModel.getOrient().name][iconIdx], {
                // Buttons will be created in each render, so we do not need
                // to worry about avoiding using legendModel kept in scope.
                onclick: $f16f2994a32ad273$export$2385a24977818dd0(self._pageGo, self, pageDataIndexName, legendModel, api)
            }, {
                x: -pageIconSizeArr[0] / 2,
                y: -pageIconSizeArr[1] / 2,
                width: pageIconSizeArr[0],
                height: pageIconSizeArr[1]
            });
            icon.name = name;
            controllerGroup.add(icon);
        }
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.layoutInner = function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        var orientIdx = legendModel.getOrient().index;
        var wh = $4433b5346a419ac2$var$WH[orientIdx];
        var xy = $4433b5346a419ac2$var$XY[orientIdx];
        var hw = $4433b5346a419ac2$var$WH[1 - orientIdx];
        var yx = $4433b5346a419ac2$var$XY[1 - orientIdx];
        selector && $6b64c78bf98fea85$export$827f4ee28efc37(// Buttons in selectorGroup always layout horizontally
        'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
        var selectorButtonGap = legendModel.get('selectorButtonGap', true);
        var selectorRect = selectorGroup.getBoundingRect();
        var selectorPos = [
            -selectorRect.x,
            -selectorRect.y
        ];
        var processMaxSize = $f16f2994a32ad273$export$9cd59f9826255e47(maxSize);
        selector && (processMaxSize[wh] = maxSize[wh] - selectorRect[wh] - selectorButtonGap);
        var mainRect = this._layoutContentAndController(legendModel, isFirstRender, processMaxSize, orientIdx, wh, hw, yx, xy);
        if (selector) {
            if (selectorPosition === 'end') selectorPos[orientIdx] += mainRect[wh] + selectorButtonGap;
            else {
                var offset = selectorRect[wh] + selectorButtonGap;
                selectorPos[orientIdx] -= offset;
                mainRect[xy] -= offset;
            }
            mainRect[wh] += selectorRect[wh] + selectorButtonGap;
            selectorPos[1 - orientIdx] += mainRect[yx] + mainRect[hw] / 2 - selectorRect[hw] / 2;
            mainRect[hw] = Math.max(mainRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(mainRect[yx], selectorRect[yx] + selectorPos[1 - orientIdx]);
            selectorGroup.x = selectorPos[0];
            selectorGroup.y = selectorPos[1];
            selectorGroup.markRedraw();
        }
        return mainRect;
    };
    ScrollableLegendView.prototype._layoutContentAndController = function(legendModel, isFirstRender, maxSize, orientIdx, wh, hw, yx, xy) {
        var contentGroup = this.getContentGroup();
        var containerGroup = this._containerGroup;
        var controllerGroup = this._controllerGroup;
        // Place items in contentGroup.
        $6b64c78bf98fea85$export$827f4ee28efc37(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
        $6b64c78bf98fea85$export$827f4ee28efc37(// Buttons in controller are layout always horizontally.
        'horizontal', controllerGroup, legendModel.get('pageButtonItemGap', true));
        var contentRect = contentGroup.getBoundingRect();
        var controllerRect = controllerGroup.getBoundingRect();
        var showController = this._showController = contentRect[wh] > maxSize[wh];
        // In case that the inner elements of contentGroup layout do not based on [0, 0]
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        // Remain contentPos when scroll animation perfroming.
        // If first rendering, `contentGroup.position` is [0, 0], which
        // does not make sense and may cause unexepcted animation if adopted.
        if (!isFirstRender) contentPos[orientIdx] = contentGroup[xy];
        // Layout container group based on 0.
        var containerPos = [
            0,
            0
        ];
        var controllerPos = [
            -controllerRect.x,
            -controllerRect.y
        ];
        var pageButtonGap = $f16f2994a32ad273$export$995e01f2f5c9d030(legendModel.get('pageButtonGap', true), legendModel.get('itemGap', true));
        // Place containerGroup and controllerGroup and contentGroup.
        if (showController) {
            var pageButtonPosition = legendModel.get('pageButtonPosition', true);
            // controller is on the right / bottom.
            if (pageButtonPosition === 'end') controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
            else containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
        }
        // Always align controller to content as 'middle'.
        controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
        contentGroup.setPosition(contentPos);
        containerGroup.setPosition(containerPos);
        controllerGroup.setPosition(controllerPos);
        // Calculate `mainRect` and set `clipPath`.
        // mainRect should not be calculated by `this.group.getBoundingRect()`
        // for sake of the overflow.
        var mainRect = {
            x: 0,
            y: 0
        };
        // Consider content may be overflow (should be clipped).
        mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
        mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]);
        // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.
        mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
        containerGroup.__rectSize = maxSize[wh];
        if (showController) {
            var clipShape = {
                x: 0,
                y: 0
            };
            clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
            clipShape[hw] = mainRect[hw];
            containerGroup.setClipPath(new $dbd6d77105f10fb2$export$2e2bcd8739ae039({
                shape: clipShape
            }));
            // Consider content may be larger than container, container rect
            // can not be obtained from `containerGroup.getBoundingRect()`.
            containerGroup.__rectSize = clipShape[wh];
        } else // Do not remove or ignore controller. Keep them set as placeholders.
        controllerGroup.eachChild(function(child) {
            child.attr({
                invisible: true,
                silent: true
            });
        });
        // Content translate animation.
        var pageInfo = this._getPageInfo(legendModel);
        pageInfo.pageIndex != null && $d2a962ec0ef14a79$export$c8dce3c08436e91e(contentGroup, {
            x: pageInfo.contentPosition[0],
            y: pageInfo.contentPosition[1]
        }, // When switch from "show controller" to "not show controller", view should be
        // updated immediately without animation, otherwise causes weird effect.
        showController ? legendModel : null);
        this._updatePageInfoView(legendModel, pageInfo);
        return mainRect;
    };
    ScrollableLegendView.prototype._pageGo = function(to, legendModel, api) {
        var scrollDataIndex = this._getPageInfo(legendModel)[to];
        scrollDataIndex != null && api.dispatchAction({
            type: 'legendScroll',
            scrollDataIndex: scrollDataIndex,
            legendId: legendModel.id
        });
    };
    ScrollableLegendView.prototype._updatePageInfoView = function(legendModel, pageInfo) {
        var controllerGroup = this._controllerGroup;
        $f16f2994a32ad273$export$79b2f7037acddd43([
            'pagePrev',
            'pageNext'
        ], function(name) {
            var key = name + 'DataIndex';
            var canJump = pageInfo[key] != null;
            var icon = controllerGroup.childOfName(name);
            if (icon) {
                icon.setStyle('fill', canJump ? legendModel.get('pageIconColor', true) : legendModel.get('pageIconInactiveColor', true));
                icon.cursor = canJump ? 'pointer' : 'default';
            }
        });
        var pageText = controllerGroup.childOfName('pageText');
        var pageFormatter = legendModel.get('pageFormatter');
        var pageIndex = pageInfo.pageIndex;
        var current = pageIndex != null ? pageIndex + 1 : 0;
        var total = pageInfo.pageCount;
        pageText && pageFormatter && pageText.setStyle('text', $f16f2994a32ad273$export$844ec244b1367d54(pageFormatter) ? pageFormatter.replace('{current}', current == null ? '' : current + '').replace('{total}', total == null ? '' : total + '') : pageFormatter({
            current: current,
            total: total
        }));
    };
    /**
   *  contentPosition: Array.<number>, null when data item not found.
   *  pageIndex: number, null when data item not found.
   *  pageCount: number, always be a number, can be 0.
   *  pagePrevDataIndex: number, null when no previous page.
   *  pageNextDataIndex: number, null when no next page.
   * }
   */ ScrollableLegendView.prototype._getPageInfo = function(legendModel) {
        var scrollDataIndex = legendModel.get('scrollDataIndex', true);
        var contentGroup = this.getContentGroup();
        var containerRectSize = this._containerGroup.__rectSize;
        var orientIdx = legendModel.getOrient().index;
        var wh = $4433b5346a419ac2$var$WH[orientIdx];
        var xy = $4433b5346a419ac2$var$XY[orientIdx];
        var targetItemIndex = this._findTargetItemIndex(scrollDataIndex);
        var children = contentGroup.children();
        var targetItem = children[targetItemIndex];
        var itemCount = children.length;
        var pCount = !itemCount ? 0 : 1;
        var result = {
            contentPosition: [
                contentGroup.x,
                contentGroup.y
            ],
            pageCount: pCount,
            pageIndex: pCount - 1,
            pagePrevDataIndex: null,
            pageNextDataIndex: null
        };
        if (!targetItem) return result;
        var targetItemInfo = getItemInfo(targetItem);
        result.contentPosition[orientIdx] = -targetItemInfo.s;
        // Strategy:
        // (1) Always align based on the left/top most item.
        // (2) It is user-friendly that the last item shown in the
        // current window is shown at the begining of next window.
        // Otherwise if half of the last item is cut by the window,
        // it will have no chance to display entirely.
        // (3) Consider that item size probably be different, we
        // have calculate pageIndex by size rather than item index,
        // and we can not get page index directly by division.
        // (4) The window is to narrow to contain more than
        // one item, we should make sure that the page can be fliped.
        for(var i = targetItemIndex + 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i <= itemCount; ++i){
            currItemInfo = getItemInfo(children[i]);
            if (// Half of the last item is out of the window.
            !currItemInfo && winEndItemInfo.e > winStartItemInfo.s + containerRectSize || currItemInfo && !intersect(currItemInfo, winStartItemInfo.s)) {
                if (winEndItemInfo.i > winStartItemInfo.i) winStartItemInfo = winEndItemInfo;
                else // e.g., when page size is smaller than item size.
                winStartItemInfo = currItemInfo;
                if (winStartItemInfo) {
                    if (result.pageNextDataIndex == null) result.pageNextDataIndex = winStartItemInfo.i;
                    ++result.pageCount;
                }
            }
            winEndItemInfo = currItemInfo;
        }
        for(var i = targetItemIndex - 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i >= -1; --i){
            currItemInfo = getItemInfo(children[i]);
            if (// If the the end item does not intersect with the window started
            // from the current item, a page can be settled.
            (!currItemInfo || !intersect(winEndItemInfo, currItemInfo.s)) && winStartItemInfo.i < winEndItemInfo.i) {
                winEndItemInfo = winStartItemInfo;
                if (result.pagePrevDataIndex == null) result.pagePrevDataIndex = winStartItemInfo.i;
                ++result.pageCount;
                ++result.pageIndex;
            }
            winStartItemInfo = currItemInfo;
        }
        return result;
        function getItemInfo(el) {
            if (el) {
                var itemRect = el.getBoundingRect();
                var start = itemRect[xy] + el[xy];
                return {
                    s: start,
                    e: start + itemRect[wh],
                    i: el.__legendDataIndex
                };
            }
        }
        function intersect(itemInfo, winStart) {
            return itemInfo.e >= winStart && itemInfo.s <= winStart + containerRectSize;
        }
    };
    ScrollableLegendView.prototype._findTargetItemIndex = function(targetDataIndex) {
        if (!this._showController) return 0;
        var index;
        var contentGroup = this.getContentGroup();
        var defaultIndex;
        contentGroup.eachChild(function(child, idx) {
            var legendDataIdx = child.__legendDataIndex;
            // FIXME
            // If the given targetDataIndex (from model) is illegal,
            // we use defaultIndex. But the index on the legend model and
            // action payload is still illegal. That case will not be
            // changed until some scenario requires.
            if (defaultIndex == null && legendDataIdx != null) defaultIndex = idx;
            if (legendDataIdx === targetDataIndex) index = idx;
        });
        return index != null ? index : defaultIndex;
    };
    ScrollableLegendView.type = 'legend.scroll';
    return ScrollableLegendView;
}((0, $b9465e8e1dcaac5c$export$2e2bcd8739ae039));
var $4433b5346a419ac2$export$2e2bcd8739ae039 = $4433b5346a419ac2$var$ScrollableLegendView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $34078c79f18c6cec$export$2e2bcd8739ae039(registers) {
    /**
   * @event legendScroll
   * @type {Object}
   * @property {string} type 'legendScroll'
   * @property {string} scrollDataIndex
   */ registers.registerAction('legendScroll', 'legendscroll', function(payload, ecModel) {
        var scrollDataIndex = payload.scrollDataIndex;
        scrollDataIndex != null && ecModel.eachComponent({
            mainType: 'legend',
            subType: 'scroll',
            query: payload
        }, function(legendModel) {
            legendModel.setScrollDataIndex(scrollDataIndex);
        });
    });
}


function $4a10895a7b53d9ae$export$4b3e715f166fdd78(registers) {
    (0, $5b64c22a7e1cb8f6$export$1f96ae73734a86cc)((0, $3a3ae8ad26565944$export$4b3e715f166fdd78));
    registers.registerComponentModel((0, $7e974701deac08af$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $4433b5346a419ac2$export$2e2bcd8739ae039));
    (0, $34078c79f18c6cec$export$2e2bcd8739ae039)(registers);
}


function $9b3c7e78ffbd70ca$export$4b3e715f166fdd78(registers) {
    (0, $5b64c22a7e1cb8f6$export$1f96ae73734a86cc)((0, $3a3ae8ad26565944$export$4b3e715f166fdd78));
    (0, $5b64c22a7e1cb8f6$export$1f96ae73734a86cc)((0, $4a10895a7b53d9ae$export$4b3e715f166fdd78));
}




var $9f01206b7394f2b7$var$_a;
(0, $5b64c22a7e1cb8f6$export$1f96ae73734a86cc)((0, $9b3c7e78ffbd70ca$export$4b3e715f166fdd78));
var $9f01206b7394f2b7$export$daedb98adc4e100e = /*#__PURE__*/ function(ECOptionElement) {
    "use strict";
    (0, $hdIku._)(ECLegendComponent, ECOptionElement);
    function ECLegendComponent() {
        (0, $173N4._)(this, ECLegendComponent);
        return (0, $7qXGD._)(this, ECLegendComponent, arguments);
    }
    return ECLegendComponent;
}((0, $6f6095288b1fca4a$export$37de6f71bb86a769));
($9f01206b7394f2b7$var$_a = globalThis.customElements) === null || $9f01206b7394f2b7$var$_a === void 0 || $9f01206b7394f2b7$var$_a.define('ec-legend', $9f01206b7394f2b7$export$daedb98adc4e100e);



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $hdIku = parcelRequire("hdIku");
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $5ce9db76a341a244$export$bb44f104e3c54dae(ecModel, api) {
    var result = {
        /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      triggerEmphasis,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */ axesInfo: {},
        seriesInvolved: false,
        /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */ coordSysAxesInfo: {},
        coordSysMap: {}
    };
    $5ce9db76a341a244$var$collectAxesInfo(result, ecModel, api);
    // Check seriesInvolved for performance, in case too many series in some chart.
    result.seriesInvolved && $5ce9db76a341a244$var$collectSeriesInfo(result, ecModel);
    return result;
}
function $5ce9db76a341a244$var$collectAxesInfo(result, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent('tooltip');
    var globalAxisPointerModel = ecModel.getComponent('axisPointer');
    // links can only be set on global.
    var linksOption = globalAxisPointerModel.get('link', true) || [];
    var linkGroups = [];
    // Collect axes info.
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(api.getCoordinateSystems(), function(coordSys) {
        // Some coordinate system do not support axes, like geo.
        if (!coordSys.axisPointerEnabled) return;
        var coordSysKey = $5ce9db76a341a244$export$d01b444bafb1a792(coordSys.model);
        var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
        result.coordSysMap[coordSysKey] = coordSys;
        // Set tooltip (like 'cross') is a convenient way to show axisPointer
        // for user. So we enable setting tooltip on coordSys model.
        var coordSysModel = coordSys.model;
        var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(coordSys.getAxes(), (0, $f16f2994a32ad273$export$c3095a23b368d1f2)(saveTooltipAxisInfo, false, null));
        // If axis tooltip used, choose tooltip axis for each coordSys.
        // Notice this case: coordSys is `grid` but not `cartesian2D` here.
        if (coordSys.getTooltipAxes && globalTooltipModel && baseTooltipModel.get('show')) {
            // Compatible with previous logic. But series.tooltip.trigger: 'axis'
            // or series.data[n].tooltip.trigger: 'axis' are not support any more.
            var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
            var cross = baseTooltipModel.get([
                'axisPointer',
                'type'
            ]) === 'cross';
            var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get([
                'axisPointer',
                'axis'
            ]));
            if (triggerAxis || cross) (0, $f16f2994a32ad273$export$79b2f7037acddd43)(tooltipAxes.baseAxes, (0, $f16f2994a32ad273$export$c3095a23b368d1f2)(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
            if (cross) (0, $f16f2994a32ad273$export$79b2f7037acddd43)(tooltipAxes.otherAxes, (0, $f16f2994a32ad273$export$c3095a23b368d1f2)(saveTooltipAxisInfo, 'cross', false));
        }
        // fromTooltip: true | false | 'cross'
        // triggerTooltip: true | false | null
        function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
            var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
            var axisPointerShow = axisPointerModel.get('show');
            if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !$5ce9db76a341a244$var$isHandleTrigger(axisPointerModel)) return;
            if (triggerTooltip == null) triggerTooltip = axisPointerModel.get('triggerTooltip');
            axisPointerModel = fromTooltip ? $5ce9db76a341a244$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
            var snap = axisPointerModel.get('snap');
            var triggerEmphasis = axisPointerModel.get('triggerEmphasis');
            var axisKey = $5ce9db76a341a244$export$d01b444bafb1a792(axis.model);
            var involveSeries = triggerTooltip || snap || axis.type === 'category';
            // If result.axesInfo[key] exist, override it (tooltip has higher priority).
            var axisInfo = result.axesInfo[axisKey] = {
                key: axisKey,
                axis: axis,
                coordSys: coordSys,
                axisPointerModel: axisPointerModel,
                triggerTooltip: triggerTooltip,
                triggerEmphasis: triggerEmphasis,
                involveSeries: involveSeries,
                snap: snap,
                useHandle: $5ce9db76a341a244$var$isHandleTrigger(axisPointerModel),
                seriesModels: [],
                linkGroup: null
            };
            axesInfoInCoordSys[axisKey] = axisInfo;
            result.seriesInvolved = result.seriesInvolved || involveSeries;
            var groupIndex = $5ce9db76a341a244$var$getLinkGroupIndex(linksOption, axis);
            if (groupIndex != null) {
                var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
                    axesInfo: {}
                });
                linkGroup.axesInfo[axisKey] = axisInfo;
                linkGroup.mapper = linksOption[groupIndex].mapper;
                axisInfo.linkGroup = linkGroup;
            }
        }
    });
}
function $5ce9db76a341a244$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
    var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
    var fields = [
        'type',
        'snap',
        'lineStyle',
        'shadowStyle',
        'label',
        'animation',
        'animationDurationUpdate',
        'animationEasingUpdate',
        'z'
    ];
    var volatileOption = {};
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(fields, function(field) {
        volatileOption[field] = (0, $f16f2994a32ad273$export$9cd59f9826255e47)(tooltipAxisPointerModel.get(field));
    });
    // category axis do not auto snap, otherwise some tick that do not
    // has value can not be hovered. value/time/log axis default snap if
    // triggered from tooltip and trigger tooltip.
    volatileOption.snap = axis.type !== 'category' && !!triggerTooltip;
    // Compatible with previous behavior, tooltip axis does not show label by default.
    // Only these properties can be overridden from tooltip to axisPointer.
    if (tooltipAxisPointerModel.get('type') === 'cross') volatileOption.type = 'line';
    var labelOption = volatileOption.label || (volatileOption.label = {});
    // Follow the convention, do not show label when triggered by tooltip by default.
    labelOption.show == null && (labelOption.show = false);
    if (fromTooltip === 'cross') {
        // When 'cross', both axes show labels.
        var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get([
            'label',
            'show'
        ]);
        labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true;
        // If triggerTooltip, this is a base axis, which should better not use cross style
        // (cross style is dashed by default)
        if (!triggerTooltip) {
            var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
            crossStyle && (0, $f16f2994a32ad273$export$ebe90cb607ad99e)(labelOption, crossStyle.textStyle);
        }
    }
    return axis.model.getModel('axisPointer', new (0, $37821cf56da37613$export$2e2bcd8739ae039)(volatileOption, globalAxisPointerModel, ecModel));
}
function $5ce9db76a341a244$var$collectSeriesInfo(result, ecModel) {
    // Prepare data for axis trigger
    ecModel.eachSeries(function(seriesModel) {
        // Notice this case: this coordSys is `cartesian2D` but not `grid`.
        var coordSys = seriesModel.coordinateSystem;
        var seriesTooltipTrigger = seriesModel.get([
            'tooltip',
            'trigger'
        ], true);
        var seriesTooltipShow = seriesModel.get([
            'tooltip',
            'show'
        ], true);
        if (!coordSys || !coordSys.model // PENDING: radar do not have a model.
         || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get([
            'axisPointer',
            'show'
        ], true) === false) return;
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(result.coordSysAxesInfo[$5ce9db76a341a244$export$d01b444bafb1a792(coordSys.model)], function(axisInfo) {
            var axis = axisInfo.axis;
            if (coordSys.getAxis(axis.dim) === axis) {
                axisInfo.seriesModels.push(seriesModel);
                axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
                axisInfo.seriesDataCount += seriesModel.getData().count();
            }
        });
    });
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */ function $5ce9db76a341a244$var$getLinkGroupIndex(linksOption, axis) {
    var axisModel = axis.model;
    var dim = axis.dim;
    for(var i = 0; i < linksOption.length; i++){
        var linkOption = linksOption[i] || {};
        if ($5ce9db76a341a244$var$checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || $5ce9db76a341a244$var$checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || $5ce9db76a341a244$var$checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) return i;
    }
}
function $5ce9db76a341a244$var$checkPropInLink(linkPropValue, axisPropValue) {
    return linkPropValue === 'all' || (0, $f16f2994a32ad273$export$43bee75e5e14138e)(linkPropValue) && (0, $f16f2994a32ad273$export$305f7d4e9d4624f2)(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}
function $5ce9db76a341a244$export$f5ea32e3629d8043(axisModel) {
    var axisInfo = $5ce9db76a341a244$export$bd39458db76002ab(axisModel);
    if (!axisInfo) return;
    var axisPointerModel = axisInfo.axisPointerModel;
    var scale = axisInfo.axis.scale;
    var option = axisPointerModel.option;
    var status = axisPointerModel.get('status');
    var value = axisPointerModel.get('value');
    // Parse init value for category and time axis.
    if (value != null) value = scale.parse(value);
    var useHandle = $5ce9db76a341a244$var$isHandleTrigger(axisPointerModel);
    // If `handle` used, `axisPointer` will always be displayed, so value
    // and status should be initialized.
    if (status == null) option.status = useHandle ? 'show' : 'hide';
    var extent = scale.getExtent();
    if (// Pick a value on axis when initializing.
    value == null || value > extent[1]) // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
    if (value < extent[0]) value = extent[0];
    option.value = value;
    if (useHandle) option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
}
function $5ce9db76a341a244$export$bd39458db76002ab(axisModel) {
    var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
    return coordSysAxesInfo && coordSysAxesInfo.axesInfo[$5ce9db76a341a244$export$d01b444bafb1a792(axisModel)];
}
function $5ce9db76a341a244$export$3b06fce3f68b734(axisModel) {
    var axisInfo = $5ce9db76a341a244$export$bd39458db76002ab(axisModel);
    return axisInfo && axisInfo.axisPointerModel;
}
function $5ce9db76a341a244$var$isHandleTrigger(axisPointerModel) {
    return !!axisPointerModel.get([
        'handle',
        'show'
    ]);
}
function $5ce9db76a341a244$export$d01b444bafb1a792(model) {
    return model.type + '||' + model.id;
}



var $c5863ebf1b74fa5e$var$axisPointerClazz = {};
/**
 * Base class of AxisView.
 */ var $c5863ebf1b74fa5e$var$AxisView = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(AxisView, _super);
    function AxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisView.type;
        return _this;
    }
    /**
   * @override
   */ AxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        // FIXME
        // This process should proformed after coordinate systems updated
        // (axis scale updated), and should be performed each time update.
        // So put it here temporarily, although it is not appropriate to
        // put a model-writing procedure in `view`.
        this.axisPointerClass && $5ce9db76a341a244$export$f5ea32e3629d8043(axisModel);
        _super.prototype.render.apply(this, arguments);
        this._doUpdateAxisPointerClass(axisModel, api, true);
    };
    /**
   * Action handler.
   */ AxisView.prototype.updateAxisPointer = function(axisModel, ecModel, api, payload) {
        this._doUpdateAxisPointerClass(axisModel, api, false);
    };
    /**
   * @override
   */ AxisView.prototype.remove = function(ecModel, api) {
        var axisPointer = this._axisPointer;
        axisPointer && axisPointer.remove(api);
    };
    /**
   * @override
   */ AxisView.prototype.dispose = function(ecModel, api) {
        this._disposeAxisPointer(api);
        _super.prototype.dispose.apply(this, arguments);
    };
    AxisView.prototype._doUpdateAxisPointerClass = function(axisModel, api, forceRender) {
        var Clazz = AxisView.getAxisPointerClass(this.axisPointerClass);
        if (!Clazz) return;
        var axisPointerModel = $5ce9db76a341a244$export$3b06fce3f68b734(axisModel);
        axisPointerModel ? (this._axisPointer || (this._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : this._disposeAxisPointer(api);
    };
    AxisView.prototype._disposeAxisPointer = function(api) {
        this._axisPointer && this._axisPointer.dispose(api);
        this._axisPointer = null;
    };
    AxisView.registerAxisPointerClass = function(type, clazz) {
        $c5863ebf1b74fa5e$var$axisPointerClazz[type] = clazz;
    };
    AxisView.getAxisPointerClass = function(type) {
        return type && $c5863ebf1b74fa5e$var$axisPointerClazz[type];
    };
    AxisView.type = 'axis';
    return AxisView;
}((0, $091798b5bbee0498$export$2e2bcd8739ae039));
var $c5863ebf1b74fa5e$export$2e2bcd8739ae039 = $c5863ebf1b74fa5e$var$AxisView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $fbe267606846f86c$export$c884056e529a2c7a = 0;
var $fbe267606846f86c$export$a9efb7aa6faff3f6 = 1;
var $fbe267606846f86c$var$SCALE_MAPPER_METHOD_NAMES_MAP = {
    needTransform: 1,
    normalize: 1,
    scale: 1,
    transformIn: 1,
    transformOut: 1,
    contain: 1,
    getExtent: 1,
    getExtentUnsafe: 1,
    setExtent: 1,
    setExtent2: 1,
    getFilter: 1,
    sanitize: 1,
    getDefaultStartValue: 1,
    freeze: 1
};
var $fbe267606846f86c$var$SCALE_MAPPER_METHOD_NAMES = (0, $f16f2994a32ad273$export$ed97f33186d4b816)($fbe267606846f86c$var$SCALE_MAPPER_METHOD_NAMES_MAP);
var $fbe267606846f86c$export$2734d952320c7be9 = 2;
var $fbe267606846f86c$export$64ac424f47d39348 = 3;
function $fbe267606846f86c$export$acfc4e2d986326b7(// If input `null/undefined`, a mapper will be created.
mapper, breakParsed, initialExtent) {
    var brk;
    mapper = mapper || {};
    var scaleBreakHelper = (0, $cf43ca9fea251347$export$e79b20ac82c2d660)();
    if (scaleBreakHelper) {
        var brkMapper_1 = scaleBreakHelper.createBreakScaleMapper(breakParsed, initialExtent);
        if (brkMapper_1.hasBreaks()) {
            // Some `ScaleMapper` methods (such as `normalize`) needs to be fast for large data
            // when no breaks, so mount break methods only when breaks really exist.
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)($fbe267606846f86c$var$SCALE_MAPPER_METHOD_NAMES, function(methodName) {
                if (brkMapper_1[methodName]) mapper[methodName] = (0, $f16f2994a32ad273$export$2385a24977818dd0)(brkMapper_1[methodName], brkMapper_1);
            });
            brk = brkMapper_1;
        }
    }
    if (brk == null) $fbe267606846f86c$export$e394430c37f37688(mapper, initialExtent);
    return {
        brk: brk,
        mapper: mapper
    };
}
function $fbe267606846f86c$export$994b6d163a064f23(host, decoratedMapperMethods) {
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)($fbe267606846f86c$var$SCALE_MAPPER_METHOD_NAMES, function(methodName) {
        host[methodName] = decoratedMapperMethods[methodName];
    });
}
function $fbe267606846f86c$export$85c5c680f14cd13c(host, subMapper) {
    host.freeze = (0, $f16f2994a32ad273$export$8793edee2d425525);
}
function $fbe267606846f86c$export$87f6c9bc988c4378(mapper) {
    return mapper.getExtentUnsafe($fbe267606846f86c$export$c884056e529a2c7a, $fbe267606846f86c$export$2734d952320c7be9);
}
function $fbe267606846f86c$export$e182c528b7826102(mapper, // NullUndefined means the outermost space.
depth) {
    return mapper.getExtentUnsafe($fbe267606846f86c$export$a9efb7aa6faff3f6, depth) || mapper.getExtentUnsafe($fbe267606846f86c$export$c884056e529a2c7a, depth);
}
function $fbe267606846f86c$export$285c6793ade939bf(mapper) {
    var extent = $fbe267606846f86c$export$e182c528b7826102(mapper, $fbe267606846f86c$export$64ac424f47d39348);
    return extent[1] - extent[0];
}
function $fbe267606846f86c$export$9a49fe71267af794(mapper) {
    var extent = mapper.getExtentUnsafe($fbe267606846f86c$export$c884056e529a2c7a, $fbe267606846f86c$export$64ac424f47d39348);
    return extent[1] - extent[0];
}
function $fbe267606846f86c$export$e394430c37f37688(// If input `null/undefined`, a mapper will be created.
mapper, initialExtent) {
    var linearMapper = mapper || {};
    var extendList = [];
    // @ts-ignore
    linearMapper._extents = extendList;
    extendList[$fbe267606846f86c$export$c884056e529a2c7a] = initialExtent ? initialExtent.slice() : (0, $3fa81475350067fd$export$62e5f07ab009f3b)();
    (0, $f16f2994a32ad273$export$8b58be045bf06082)(linearMapper, $fbe267606846f86c$var$linearScaleMapperMethods);
    return linearMapper;
}
var $fbe267606846f86c$var$linearScaleMapperMethods = {
    needTransform: function needTransform() {
        return false;
    },
    normalize: function normalize(val) {
        var extent = this._extents[$fbe267606846f86c$export$a9efb7aa6faff3f6] || this._extents[$fbe267606846f86c$export$c884056e529a2c7a];
        if (extent[1] === extent[0]) return 0.5;
        return (val - extent[0]) / (extent[1] - extent[0]);
    },
    scale: function scale(val) {
        var extent = this._extents[$fbe267606846f86c$export$a9efb7aa6faff3f6] || this._extents[$fbe267606846f86c$export$c884056e529a2c7a];
        return val * (extent[1] - extent[0]) + extent[0];
    },
    transformIn: function transformIn(val) {
        return val;
    },
    transformOut: function transformOut(val) {
        return val;
    },
    contain: function contain(val) {
        // This method is typically used in axis trigger and markers.
        // Users may be confused if the extent is restricted to `SCALE_EXTENT_KIND_EFFECTIVE`.
        var extent = $fbe267606846f86c$export$e182c528b7826102(this, null);
        return val >= extent[0] && val <= extent[1];
    },
    getExtent: function getExtent() {
        return this._extents[$fbe267606846f86c$export$c884056e529a2c7a].slice();
    },
    getExtentUnsafe: function getExtentUnsafe(kind) {
        return this._extents[kind];
    },
    setExtent: function setExtent(start, end) {
        $fbe267606846f86c$var$writeExtent(this._extents, $fbe267606846f86c$export$c884056e529a2c7a, start, end);
    },
    setExtent2: function setExtent2(kind, start, end) {
        var extentList = this._extents;
        if (!extentList[kind]) extentList[kind] = extentList[$fbe267606846f86c$export$c884056e529a2c7a].slice();
        $fbe267606846f86c$var$writeExtent(extentList, kind, start, end);
    },
    freeze: function freeze() {}
};
function $fbe267606846f86c$var$writeExtent(extentList, kind, start, end) {
    // NOTE: `NaN` should be excluded. e.g., `scaleRawExtentInfo.resultMinMax` may be `[NaN, NaN]`.
    if ((0, $3fa81475350067fd$export$d386653f29930adb)(start, end)) {
        extentList[kind][0] = start;
        extentList[kind][1] = end;
    }
} // ------ END: Linear Scale Mapper ------


function $f976678a0ff027db$export$dfc8cd28ed7b22a0(scale) {
    return $f976678a0ff027db$export$ba0fcad386c5c7e6(scale) || $f976678a0ff027db$export$8b1d8a59aa13c502(scale);
}
function $f976678a0ff027db$export$cd3b833884a8d62c(scale) {
    return $f976678a0ff027db$export$ba0fcad386c5c7e6(scale) || $f976678a0ff027db$export$c9b71a3750db342f(scale);
}
function $f976678a0ff027db$export$ba0fcad386c5c7e6(scale) {
    return scale.type === 'interval';
}
function $f976678a0ff027db$export$c9b71a3750db342f(scale) {
    return scale.type === 'time';
}
function $f976678a0ff027db$export$8b1d8a59aa13c502(scale) {
    return scale.type === 'log';
}
function $f976678a0ff027db$export$61579433626afe87(scale) {
    return scale.type === 'ordinal';
}
function $f976678a0ff027db$export$eeea879a611eb991(extent, spanWithBreaks, splitNumber, minInterval, maxInterval) {
    var result = {};
    var interval = result.interval = (0, $104896d282bd296f$export$7a695fe44258210b)(spanWithBreaks / splitNumber, true);
    if (minInterval != null && interval < minInterval) interval = result.interval = minInterval;
    if (maxInterval != null && interval > maxInterval) interval = result.interval = maxInterval;
    var precision = result.intervalPrecision = $f976678a0ff027db$export$86a060b060d3d31a(interval);
    // Niced extent inside original extent
    result.niceTickExtent = [
        (0, $104896d282bd296f$export$2077e0241d6afd3c)((0, $104896d282bd296f$export$cf129980c996e186)(extent[0] / interval) * interval, precision),
        (0, $104896d282bd296f$export$2077e0241d6afd3c)((0, $104896d282bd296f$export$c6301bc99a7f80a7)(extent[1] / interval) * interval, precision)
    ];
    return result;
}
function $f976678a0ff027db$export$f39031e8422f329d(niceInterval) {
    var exponent = (0, $104896d282bd296f$export$97256a17b20a0c24)(niceInterval);
    // No rounding error in Math.pow(10, integer).
    var exp10 = (0, $104896d282bd296f$export$858b42c97efc7084)(10, exponent);
    // Fix IEEE 754 float rounding error
    var f = (0, $104896d282bd296f$export$42cacde8c45786ff)(niceInterval / exp10);
    if (!f) f = 1;
    else if (f === 2) f = 3;
    else if (f === 3) f = 5;
    else // f is 1 or 5
    f *= 2;
    // Fix IEEE 754 float rounding error
    return (0, $104896d282bd296f$export$2077e0241d6afd3c)(f * exp10, -exponent);
}
function $f976678a0ff027db$export$86a060b060d3d31a(niceInterval) {
    // Tow more digital for tick.
    // NOTE: `2` was introduced in commit `af2a2a9f6303081d7c3b52f0a38add07b4c6e0c7`;
    // it works on "nice" interval, but seems not necessarily mathematically required.
    return (0, $104896d282bd296f$export$e0c74b50bbd10f68)(niceInterval) + 2;
}
function $f976678a0ff027db$export$7854dd225b5d5704(val, base) {
    // NOTE:
    //  - rounding error may happen above, typically expecting `log10(1000)` but actually
    //    getting `2.9999999999999996`, but generally it does not matter since they are not
    //    used to display.
    //  - Consider backward compatibility and other log bases, do not use `Math.log10`.
    return (0, $104896d282bd296f$export$f0e980411e05f912)(val) / (0, $104896d282bd296f$export$f0e980411e05f912)(base);
}
function $f976678a0ff027db$export$73e21863d9c0dcd3(// `tickVal` should be in the linear space.
linearTickVal, base, opt) {
    var lookup = opt && opt.lookup;
    if (lookup) for(var i = 0; i < lookup.from.length; i++){
        if (linearTickVal === lookup.from[i]) return lookup.to[i];
    }
    return (0, $104896d282bd296f$export$858b42c97efc7084)(base, linearTickVal);
}
function $f976678a0ff027db$export$e279d7ed1695209d(rawExtent, fixMinMax, rawExtentResult) {
    var extent = rawExtent.slice();
    // PENDING:
    //  This implementation is not rigorous, but has long been in use.
    // If extent start and end are same, expand them
    if (extent[0] === extent[1]) {
        // If `containShape`, the extent must be evenly distributed to both sides;
        // otherwise, shape (e.g., bars) may be overflow and clipped.
        var containShapeRequired = rawExtentResult && rawExtentResult.ctnShp;
        if (extent[0] !== 0) {
            // Expand extent
            // Note that extents can be both negative. See #13154
            var expandSize = (0, $104896d282bd296f$export$5860c226b237d9a6)(extent[0]);
            // In the fowllowing case
            //      Axis has been fixed max 100
            //      Plus data are all 100 and axis extent are [100, 100].
            // Extend to the both side will cause expanded max is larger than fixed max.
            // So only expand to the smaller side.
            if (!fixMinMax[1]) {
                extent[1] += expandSize / 2;
                extent[0] -= expandSize / 2;
            } else extent[0] -= expandSize / 2;
        } else if (containShapeRequired) {
            extent[0] = -1;
            extent[1] = 1;
        } else extent[1] = 1;
    }
    // For example, if there are no series data, extent may be `[Infinity, -Infinity]` here.
    if (!(0, $3fa81475350067fd$export$5af06089290883e2)(extent[0]) || !(0, $3fa81475350067fd$export$5af06089290883e2)(extent[1])) {
        extent[0] = 0;
        extent[1] = 1;
    }
    if (extent[1] < extent[0]) extent.reverse();
    return extent;
}
function $f976678a0ff027db$export$2b240c817ac5c4f(extent1, extent2) {
    return [
        extent1[0] !== extent2[0],
        extent1[1] !== extent2[1]
    ];
}
function $f976678a0ff027db$export$b801ba4e5ad70a4a(rawSplitNumber, defaultSplitNumber) {
    rawSplitNumber = rawSplitNumber || defaultSplitNumber;
    return (0, $104896d282bd296f$export$42cacde8c45786ff)((0, $104896d282bd296f$export$2ca8010d037f830f)(rawSplitNumber, 1));
}
function $f976678a0ff027db$export$1039c7e66c46a7fd(ordinalScale, // `categoryInterval` is the number part of `CategoryTickLabelSplitIntervalOption`.
categoryInterval, addItem) {
    var extent = (0, $fbe267606846f86c$export$87f6c9bc988c4378)(ordinalScale);
    var startTick = extent[0];
    var tickCount = ordinalScale.count();
    var step = Math.max((categoryInterval || 0) + 1, 1);
    // Calculate start tick based on zero if possible to keep label consistent
    // while zooming and moving while interval > 0. Otherwise the selection
    // of displayable ticks and symbols probably keep changing.
    if (startTick !== 0 && step > 1 && tickCount / step > 2) startTick = Math.round(Math.ceil(startTick / step) * step);
    // min max labels may be excluded if `startTick > 0`, but they should be always
    // included and the label display strategy is adopted uniformly later in `AxisBuilder`.
    if (startTick !== extent[0]) addItemInternally(extent[0], true, true);
    var tickValue = startTick;
    for(; tickValue <= extent[1]; tickValue += step)addItemInternally(tickValue, false, tickValue === extent[0] || tickValue === extent[1]);
    if (tickValue - step !== extent[1]) addItemInternally(extent[1], true, true);
    function addItemInternally(tickValue, offInterval, isExtentBoundary) {
        addItem({
            value: tickValue,
            offInterval: offInterval
        }, isExtentBoundary);
    }
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $b3d1594b84705f7d$var$callOnlyOnce = (0, $3fa81475350067fd$export$a305e9b27fd23ae3)();
var $b3d1594b84705f7d$export$ba567ca71745149b = '|&';
var $b3d1594b84705f7d$var$ecModelCacheFullUpdateInner = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
var $b3d1594b84705f7d$export$3faff2d166c13471 = -2;
var $b3d1594b84705f7d$export$5e218fe556c51ff0 = -1;
var $b3d1594b84705f7d$var$ecModelCachePrepareInner = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
var $b3d1594b84705f7d$var$validateInputAxis;
function $b3d1594b84705f7d$var$getAxisStatPerKeyPerAxis(axis, axisStatKey) {
    var axisModel = axis.model;
    var keyed = $b3d1594b84705f7d$var$ecModelCacheFullUpdateInner((0, $31b4a1aa189576ea$export$14434b56aab40385)(axisModel.ecModel)).keyed;
    var perKey = keyed && keyed.get(axisStatKey);
    return perKey && perKey.get(axisModel.uid);
}
function $b3d1594b84705f7d$export$bf9727b05f222b53(axis, axisStatKey) {
    return $b3d1594b84705f7d$var$wrapStatResult($b3d1594b84705f7d$var$getAxisStatPerKeyPerAxis(axis, axisStatKey));
}
function $b3d1594b84705f7d$export$89af6c808d6573fd(axis, seriesList) {
    var result = [];
    $b3d1594b84705f7d$var$eachKeyEachAxis(axis.model.ecModel, function(perKeyPerAxis) {
        for(var idx = 0; idx < seriesList.length; idx++)if (seriesList[idx] && perKeyPerAxis.serByIdx[seriesList[idx].seriesIndex]) result.push($b3d1594b84705f7d$var$wrapStatResult(perKeyPerAxis));
    });
    return result;
}
function $b3d1594b84705f7d$var$eachKeyEachAxis(ecModel, cb) {
    var keyed = $b3d1594b84705f7d$var$ecModelCacheFullUpdateInner((0, $31b4a1aa189576ea$export$14434b56aab40385)(ecModel)).keyed;
    keyed && keyed.each(function(perKey, axisStatKey) {
        perKey.each(function(perKeyPerAxis, axisModelUid) {
            cb(perKeyPerAxis, axisStatKey, axisModelUid);
        });
    });
}
function $b3d1594b84705f7d$var$wrapStatResult(record) {
    return {
        liPosMinGap: record ? record.liPosMinGap : undefined
    };
}
function $b3d1594b84705f7d$export$cee01bd2e39d754e(axis, cb) {
    var ecModel = axis.model.ecModel;
    var seriesOnAxisMap = $b3d1594b84705f7d$var$ecModelCacheFullUpdateInner((0, $31b4a1aa189576ea$export$14434b56aab40385)(ecModel)).axSer;
    seriesOnAxisMap && $b3d1594b84705f7d$export$bf07bebae360b2fc(ecModel, seriesOnAxisMap.get(axis.model.uid), cb);
}
function $b3d1594b84705f7d$export$ef6bd388c274421f(axis, axisStatKey, cb) {
    var perKeyPerAxis = $b3d1594b84705f7d$var$getAxisStatPerKeyPerAxis(axis, axisStatKey);
    perKeyPerAxis && $b3d1594b84705f7d$export$bf07bebae360b2fc(axis.model.ecModel, perKeyPerAxis.sers, cb);
}
function $b3d1594b84705f7d$export$bf07bebae360b2fc(ecModel, seriesList, cb) {
    if (!seriesList) return;
    for(var i = 0; i < seriesList.length; i++){
        var seriesModel = seriesList[i];
        // Legend-filtered series need to be ignored since series are registered before `legendFilter`.
        if (!ecModel.isSeriesFiltered(seriesModel)) cb(seriesModel);
    }
}
function $b3d1594b84705f7d$export$5351a7fee08ae808(axis, axisStatKey) {
    var perKeyPerAxis = $b3d1594b84705f7d$var$getAxisStatPerKeyPerAxis(axis, axisStatKey);
    if (!perKeyPerAxis || !perKeyPerAxis.sers.length) return 0;
    var count = 0;
    $b3d1594b84705f7d$export$bf07bebae360b2fc(axis.model.ecModel, perKeyPerAxis.sers, function() {
        count++;
    });
    return count;
}
function $b3d1594b84705f7d$export$37f432351be0ca61(ecModel, axisStatKey, cb) {
    var keyed = $b3d1594b84705f7d$var$ecModelCacheFullUpdateInner((0, $31b4a1aa189576ea$export$14434b56aab40385)(ecModel)).keyed;
    var perKey = keyed && keyed.get(axisStatKey);
    perKey && perKey.each(function(perKeyPerAxis) {
        cb(perKeyPerAxis.axis);
    });
}
function $b3d1594b84705f7d$export$21f2993d5751eb66(axis, cb) {
    var model = axis.model;
    var keysByAxisModelUid = $b3d1594b84705f7d$var$ecModelCacheFullUpdateInner((0, $31b4a1aa189576ea$export$14434b56aab40385)(model.ecModel)).keys;
    keysByAxisModelUid && (0, $f16f2994a32ad273$export$79b2f7037acddd43)(keysByAxisModelUid.get(model.uid), function(axisStatKey) {
        var stat;
        cb(axisStatKey);
    });
}
/**
 * NOTICE: this processor may be omitted - it is registered only if required.
 */ function $b3d1594b84705f7d$var$performAxisStatisticsOnOverallReset(ecModel) {
    var ecPrepareCache = $b3d1594b84705f7d$var$ecModelCachePrepareInner((0, $31b4a1aa189576ea$export$67fb26d0f4e31b9e)(ecModel));
    var ecPrepareCacheKeyed = ecPrepareCache.keyed || (ecPrepareCache.keyed = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)());
    $b3d1594b84705f7d$var$eachKeyEachAxis(ecModel, function(perKeyPerAxis, axisStatKey, axisModelUid) {
        var ecPrepareCachePerKey = ecPrepareCacheKeyed.get(axisStatKey) || ecPrepareCacheKeyed.set(axisStatKey, (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)());
        var ecPreparePerKeyPerAxis = ecPrepareCachePerKey.get(axisModelUid) || ecPrepareCachePerKey.set(axisModelUid, {});
        if (perKeyPerAxis.metrics.liPosMinGap) // We should assert the impl exists -- fail-fast if missing `registerMetricImpl`.
        $b3d1594b84705f7d$var$_metricImpl.liPosMinGap(ecModel, perKeyPerAxis, ecPreparePerKeyPerAxis);
    });
}
function $b3d1594b84705f7d$export$5ce2ad54acb7c055(metricType, impl) {
    $b3d1594b84705f7d$var$_metricImpl[metricType] = impl;
}
var $b3d1594b84705f7d$var$_metricImpl = {};
function $b3d1594b84705f7d$export$48507d392d1d4894(axis, seriesModel, coordSysType) {
    if (!axis) return;
    var ecModel = seriesModel.ecModel;
    var ecFullUpdateCache = $b3d1594b84705f7d$var$ecModelCacheFullUpdateInner((0, $31b4a1aa189576ea$export$14434b56aab40385)(ecModel));
    var axisModelUid = axis.model.uid;
    var axSerPairCheck, pairKey;
    var seriesOnAxisMap = ecFullUpdateCache.axSer || (ecFullUpdateCache.axSer = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)());
    var seriesListPerAxis = seriesOnAxisMap.get(axisModelUid) || seriesOnAxisMap.set(axisModelUid, []);
    var lastSeries;
    seriesListPerAxis.push(seriesModel);
    var seriesType = seriesModel.subType;
    var isBaseAxis = seriesModel.getBaseAxis() === axis;
    var client = $b3d1594b84705f7d$var$clientsForLookup.get($b3d1594b84705f7d$var$makeClientLookupKey(seriesType, isBaseAxis, coordSysType)) || $b3d1594b84705f7d$var$clientsForLookup.get($b3d1594b84705f7d$var$makeClientLookupKey(seriesType, isBaseAxis, null));
    if (!client) return;
    var keyed = ecFullUpdateCache.keyed || (ecFullUpdateCache.keyed = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)());
    var keys = ecFullUpdateCache.keys || (ecFullUpdateCache.keys = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)());
    var axisStatKey = client.key;
    var perKey = keyed.get(axisStatKey) || keyed.set(axisStatKey, (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)());
    var perKeyPerAxis = perKey.get(axisModelUid);
    if (!perKeyPerAxis) {
        perKeyPerAxis = perKey.set(axisModelUid, {
            axis: axis,
            sers: [],
            serByIdx: []
        });
        // They should only be executed for each <key, axis> pair once:
        perKeyPerAxis.metrics = client.getMetrics(axis);
        (keys.get(axisModelUid) || keys.set(axisModelUid, [])).push(axisStatKey);
    }
    // series order should respect to the input order.
    perKeyPerAxis.sers.push(seriesModel);
    perKeyPerAxis.serByIdx[seriesModel.seriesIndex] = seriesModel;
}
/**
 * NOTE: Currently, the scenario is simple enough to look up clients by hash map.
 * Otherwise, a caller-provided `filter` may be an alternative if more complex requirements arise.
 */ function $b3d1594b84705f7d$var$makeClientLookupKey(seriesType, isBaseAxis, coordSysType) {
    return seriesType + $b3d1594b84705f7d$export$ba567ca71745149b + (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(isBaseAxis, true) + $b3d1594b84705f7d$export$ba567ca71745149b + (coordSysType || '');
}
function $b3d1594b84705f7d$export$ad2364183e23f875(registers, client) {
    var clientKey = $b3d1594b84705f7d$var$makeClientLookupKey(client.seriesType, client.baseAxis, client.coordSysType);
    $b3d1594b84705f7d$var$clientsForLookup.set(clientKey, client);
    $b3d1594b84705f7d$var$callOnlyOnce(registers, function() {
        registers.registerProcessor(registers.PRIORITY.PROCESSOR.AXIS_STATISTICS, {
            // NOTE: Theoretically, `appendData` requires `dirtyOnOverallProgress: true` here to re-calculate them.
            // But this OVERALL_STAGE_TASK is applied to all series (no `getTargetSeries` specified),
            // `dirtyOnOverallProgress: true` can cause irrelevant series (e.g., series on geo)
            // to be re-rendered when `appendData` is called, which cause `appendData` meaningless,
            // thereby not setting `dirtyOnOverallProgress: true`.
            overallReset: $b3d1594b84705f7d$var$performAxisStatisticsOnOverallReset
        });
    });
}
var $b3d1594b84705f7d$var$clientsForCheckingStatKey;
var $b3d1594b84705f7d$var$clientsForLookup = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();



// Arbitrary, leave some space to avoid overflowing when dataZoom moving.
var $4f7015271e7d3825$var$FALLBACK_BAND_WIDTH_RATIO = 0.8;
function $4f7015271e7d3825$export$141021262b29d96e(axis, opt) {
    opt = opt || {};
    var out = {
        w: NaN,
        w2: NaN
    };
    var scale = axis.scale;
    var fromStat = opt.fromStat;
    var min = opt.min;
    // [BAND_WIDTH_USED_SCALE_LINEAR_SPAN]
    //  - Band width should always respect to the currently specified extent, and `SCALE_EXTENT_KIND_MAPPING`
    //    should be used if specified.
    //    Otherwise, the result may incorrect, especially when data count is small.
    //    For example, when "containShape" is calculating, no `SCALE_EXTENT_KIND_MAPPING` is set, so here only
    //    `SCALE_EXTENT_KIND_EFFECTIVE` is returned, say, `[3, 5]`, based on which a `SCALE_EXTENT_KIND_MAPPING`
    //    is calculated, say `[2.5, 5.5]` (expanded by `0.5`). Then when rendering, that `SCALE_EXTENT_KIND_MAPPING`
    //    is returned here.
    //    See AXIS_CONTAIN_SHAPE_COMMON_STRATEGY for more details.
    //  - The span should be in the linear space (typically, the innermost space).
    //  - We use the scale extent after being zoommed and `intervalScaleEnsureValidExtent`-ish applied and
    //    "nice"/"align" applied, because:
    //    - For OrdinalScale, fine;
    //    - For numeric scale, `scaleLinearSpan` is normally not used for a consistent result when `dataZoom`
    //      is applied, but used when none or single data item case.
    var scaleLinearSpan = (0, $fbe267606846f86c$export$285c6793ade939bf)(scale);
    if (!(0, $104896d282bd296f$export$b5c30d4208814a65)(scaleLinearSpan)) // scale may be `[Infinity, -Infinity]`.
    scaleLinearSpan = NaN;
    var axisExtent = axis.getExtent();
    // Always use a new pxSpan because it may be changed in `grid` contain label calculation.
    var pxSpan = (0, $104896d282bd296f$export$5860c226b237d9a6)(axisExtent[1] - axisExtent[0]);
    if ((0, $f976678a0ff027db$export$61579433626afe87)(scale)) $4f7015271e7d3825$var$calcBandWidthForCategoryAxis(out, axis, scaleLinearSpan, pxSpan);
    else if (fromStat) $4f7015271e7d3825$var$calcBandWidthForNumericAxis(out, axis, scaleLinearSpan, pxSpan, fromStat);
    else min;
    if (min != null) out.w = (0, $104896d282bd296f$export$b5c30d4208814a65)(out.w) ? (0, $104896d282bd296f$export$2ca8010d037f830f)(min, out.w) : min;
    return out;
}
function $4f7015271e7d3825$var$calcBandWidthForCategoryAxis(out, axis, scaleLinearSpan, pxSpan) {
    var onBand = axis.onBand;
    var len = scaleLinearSpan + (onBand ? 1 : 0);
    // Fix #2728, avoid NaN when only one data.
    len === 0 && (len = 1);
    out.w = pxSpan / len;
    // NOTE:
    //  - When `scaleLinearSpan === 0`, no need to expand extent.
    //  - `onBand: true` (`boundaryGap: true`) does not need to support `containShape`,
    //    thereby no `invRatio`.
    if (!onBand && scaleLinearSpan && pxSpan) out.w2 = out.w * scaleLinearSpan / pxSpan;
}
function $4f7015271e7d3825$var$calcBandWidthForNumericAxis(out, axis, scaleLinearSpan, pxSpan, fromStat) {
    var onlySingular = false;
    var bandWidthInData = -Infinity;
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(fromStat.key ? [
        (0, $b3d1594b84705f7d$export$bf9727b05f222b53)(axis, fromStat.key)
    ] : (0, $b3d1594b84705f7d$export$89af6c808d6573fd)(axis, fromStat.sers || []), function(stat) {
        var liPosMinGap = stat.liPosMinGap;
        // NOTE: `liPosMinGap == null` may indicate that `requireAxisStatistics`
        // is not used by any series on this axis. We should not make `bandWidth`
        // for this case.
        if (liPosMinGap != null) {
            if (liPosMinGap > 0) {
                if (liPosMinGap > bandWidthInData) bandWidthInData = liPosMinGap;
                onlySingular = false;
            } else if (liPosMinGap === (0, $b3d1594b84705f7d$export$3faff2d166c13471)) onlySingular = true;
        }
    });
    if ((0, $104896d282bd296f$export$b5c30d4208814a65)(scaleLinearSpan) && scaleLinearSpan > 0 && (0, $104896d282bd296f$export$b5c30d4208814a65)(bandWidthInData)) {
        out.w = pxSpan / scaleLinearSpan * bandWidthInData;
        out.w2 = bandWidthInData;
    } else if (onlySingular) {
        // This is the special handing for single value case, where min gap can not
        // be calculated, but `w` and `w2` (for "containShape") are still needed.
        out.w = pxSpan * $4f7015271e7d3825$var$FALLBACK_BAND_WIDTH_RATIO;
        out.w2 = out.w * scaleLinearSpan / pxSpan;
    // Consider an axis has both candlestick and bar series, where candlestick has multiple data
    // but the bar series has no data. In this case, that bar series should be ignored; otherwise,
    // the axis will be significantly expanded by "containShape" but no bar shape displayed.
    }
}


var $c3b912bf0217d820$var$inner = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
var $c3b912bf0217d820$var$clone = $f16f2994a32ad273$export$9cd59f9826255e47;
var $c3b912bf0217d820$var$bind = $f16f2994a32ad273$export$2385a24977818dd0;
/**
 * Base axis pointer class in 2D.
 */ var $c3b912bf0217d820$var$BaseAxisPointer = /** @class */ function() {
    function BaseAxisPointer() {
        this._dragging = false;
        /**
     * In px, arbitrary value. Do not set too small,
     * no animation is ok for most cases.
     */ this.animationThreshold = 15;
    }
    /**
   * @implement
   */ BaseAxisPointer.prototype.render = function(axisModel, axisPointerModel, api, forceRender) {
        var value = axisPointerModel.get('value');
        var status = axisPointerModel.get('status');
        // Bind them to `this`, not in closure, otherwise they will not
        // be replaced when user calling setOption in not merge mode.
        this._axisModel = axisModel;
        this._axisPointerModel = axisPointerModel;
        this._api = api;
        // Optimize: `render` will be called repeatedly during mouse move.
        // So it is power consuming if performing `render` each time,
        // especially on mobile device.
        if (!forceRender && this._lastValue === value && this._lastStatus === status) return;
        this._lastValue = value;
        this._lastStatus = status;
        var group = this._group;
        var handle = this._handle;
        if (!status || status === 'hide') {
            // Do not clear here, for animation better.
            group && group.hide();
            handle && handle.hide();
            return;
        }
        group && group.show();
        handle && handle.show();
        // Otherwise status is 'show'
        var elOption = {};
        this.makeElOption(elOption, value, axisModel, axisPointerModel, api);
        // Enable change axis pointer type.
        var graphicKey = elOption.graphicKey;
        if (graphicKey !== this._lastGraphicKey) this.clear(api);
        this._lastGraphicKey = graphicKey;
        var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
        if (!group) {
            group = this._group = new $bce1f681c7fb2581$exports.Group();
            this.createPointerEl(group, elOption, axisModel, axisPointerModel);
            this.createLabelEl(group, elOption, axisModel, axisPointerModel);
            api.getZr().add(group);
        } else {
            var doUpdateProps = $f16f2994a32ad273$export$c3095a23b368d1f2($c3b912bf0217d820$var$updateProps, axisPointerModel, moveAnimation);
            this.updatePointerEl(group, elOption, doUpdateProps);
            this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
        }
        $c3b912bf0217d820$var$updateMandatoryProps(group, axisPointerModel, true);
        this._renderHandle(value);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.remove = function(api) {
        this.clear(api);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.dispose = function(api) {
        this.clear(api);
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.determineAnimation = function(axisModel, axisPointerModel) {
        var animation = axisPointerModel.get('animation');
        var axis = axisModel.axis;
        var isCategoryAxis = axis.type === 'category';
        var useSnap = axisPointerModel.get('snap');
        // Value axis without snap always do not snap.
        if (!useSnap && !isCategoryAxis) return false;
        if (animation === 'auto' || animation == null) {
            var animationThreshold = this.animationThreshold;
            if (isCategoryAxis && (0, $4f7015271e7d3825$export$141021262b29d96e)(axis).w > animationThreshold) return true;
            // It is important to auto animation when snap used. Consider if there is
            // a dataZoom, animation will be disabled when too many points exist, while
            // it will be enabled for better visual effect when little points exist.
            if (useSnap) {
                var seriesDataCount = $5ce9db76a341a244$export$bd39458db76002ab(axisModel).seriesDataCount;
                var axisExtent = axis.getExtent();
                // Approximate band width
                return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
            }
            return false;
        }
        return animation === true;
    };
    /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */ BaseAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
    // Should be implemented by sub-class.
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createPointerEl = function(group, elOption, axisModel, axisPointerModel) {
        var pointerOption = elOption.pointer;
        if (pointerOption) {
            var pointerEl = $c3b912bf0217d820$var$inner(group).pointerEl = new $bce1f681c7fb2581$exports[pointerOption.type]($c3b912bf0217d820$var$clone(elOption.pointer));
            group.add(pointerEl);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createLabelEl = function(group, elOption, axisModel, axisPointerModel) {
        if (elOption.label) {
            var labelEl = $c3b912bf0217d820$var$inner(group).labelEl = new $bce1f681c7fb2581$exports.Text($c3b912bf0217d820$var$clone(elOption.label));
            group.add(labelEl);
            $c3b912bf0217d820$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updatePointerEl = function(group, elOption, updateProps) {
        var pointerEl = $c3b912bf0217d820$var$inner(group).pointerEl;
        if (pointerEl && elOption.pointer) {
            pointerEl.setStyle(elOption.pointer.style);
            updateProps(pointerEl, {
                shape: elOption.pointer.shape
            });
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updateLabelEl = function(group, elOption, updateProps, axisPointerModel) {
        var labelEl = $c3b912bf0217d820$var$inner(group).labelEl;
        if (labelEl) {
            labelEl.setStyle(elOption.label.style);
            updateProps(labelEl, {
                // Consider text length change in vertical axis, animation should
                // be used on shape, otherwise the effect will be weird.
                // TODOTODO
                // shape: elOption.label.shape,
                x: elOption.label.x,
                y: elOption.label.y
            });
            $c3b912bf0217d820$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @private
   */ BaseAxisPointer.prototype._renderHandle = function(value) {
        if (this._dragging || !this.updateHandleTransform) return;
        var axisPointerModel = this._axisPointerModel;
        var zr = this._api.getZr();
        var handle = this._handle;
        var handleModel = axisPointerModel.getModel('handle');
        var status = axisPointerModel.get('status');
        if (!handleModel.get('show') || !status || status === 'hide') {
            handle && zr.remove(handle);
            this._handle = null;
            return;
        }
        var isInit;
        if (!this._handle) {
            isInit = true;
            handle = this._handle = $bce1f681c7fb2581$exports.createIcon(handleModel.get('icon'), {
                cursor: 'move',
                draggable: true,
                onmousemove: function onmousemove(e) {
                    // For mobile device, prevent screen slider on the button.
                    $1f87c82830753703$export$fa6813432f753b0d(e.event);
                },
                onmousedown: $c3b912bf0217d820$var$bind(this._onHandleDragMove, this, 0, 0),
                drift: $c3b912bf0217d820$var$bind(this._onHandleDragMove, this),
                ondragend: $c3b912bf0217d820$var$bind(this._onHandleDragEnd, this)
            });
            zr.add(handle);
        }
        $c3b912bf0217d820$var$updateMandatoryProps(handle, axisPointerModel, false);
        // update style
        handle.setStyle(handleModel.getItemStyle(null, [
            'color',
            'borderColor',
            'borderWidth',
            'opacity',
            'shadowColor',
            'shadowBlur',
            'shadowOffsetX',
            'shadowOffsetY'
        ]));
        // update position
        var handleSize = handleModel.get('size');
        if (!$f16f2994a32ad273$export$43bee75e5e14138e(handleSize)) handleSize = [
            handleSize,
            handleSize
        ];
        handle.scaleX = handleSize[0] / 2;
        handle.scaleY = handleSize[1] / 2;
        $fcd7567e9010c0f5$export$958e3e1a02eac4b6(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');
        this._moveHandleToValue(value, isInit);
    };
    BaseAxisPointer.prototype._moveHandleToValue = function(value, isInit) {
        $c3b912bf0217d820$var$updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, $c3b912bf0217d820$var$getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
    };
    BaseAxisPointer.prototype._onHandleDragMove = function(dx, dy) {
        var handle = this._handle;
        if (!handle) return;
        this._dragging = true;
        // Persistent for throttle.
        var trans = this.updateHandleTransform($c3b912bf0217d820$var$getHandleTransProps(handle), [
            dx,
            dy
        ], this._axisModel, this._axisPointerModel);
        this._payloadInfo = trans;
        handle.stopAnimation();
        handle.attr($c3b912bf0217d820$var$getHandleTransProps(trans));
        $c3b912bf0217d820$var$inner(handle).lastProp = null;
        this._doDispatchAxisPointer();
    };
    /**
   * Throttled method.
   */ BaseAxisPointer.prototype._doDispatchAxisPointer = function() {
        var handle = this._handle;
        if (!handle) return;
        var payloadInfo = this._payloadInfo;
        var axisModel = this._axisModel;
        this._api.dispatchAction({
            type: 'updateAxisPointer',
            x: payloadInfo.cursorPoint[0],
            y: payloadInfo.cursorPoint[1],
            tooltipOption: payloadInfo.tooltipOption,
            axesInfo: [
                {
                    axisDim: axisModel.axis.dim,
                    axisIndex: axisModel.componentIndex
                }
            ]
        });
    };
    BaseAxisPointer.prototype._onHandleDragEnd = function() {
        this._dragging = false;
        var handle = this._handle;
        if (!handle) return;
        var value = this._axisPointerModel.get('value');
        // Consider snap or categroy axis, handle may be not consistent with
        // axisPointer. So move handle to align the exact value position when
        // drag ended.
        this._moveHandleToValue(value);
        // For the effect: tooltip will be shown when finger holding on handle
        // button, and will be hidden after finger left handle button.
        this._api.dispatchAction({
            type: 'hideTip'
        });
    };
    /**
   * @private
   */ BaseAxisPointer.prototype.clear = function(api) {
        this._lastValue = null;
        this._lastStatus = null;
        var zr = api.getZr();
        var group = this._group;
        var handle = this._handle;
        if (zr && group) {
            this._lastGraphicKey = null;
            group && zr.remove(group);
            handle && zr.remove(handle);
            this._group = null;
            this._handle = null;
            this._payloadInfo = null;
        }
        $fcd7567e9010c0f5$export$42ffd38884aecdac(this, '_doDispatchAxisPointer');
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.doClear = function() {
    // Implemented by sub-class if necessary.
    };
    BaseAxisPointer.prototype.buildLabel = function(xy, wh, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x: xy[xDimIndex],
            y: xy[1 - xDimIndex],
            width: wh[xDimIndex],
            height: wh[1 - xDimIndex]
        };
    };
    return BaseAxisPointer;
}();
function $c3b912bf0217d820$var$updateProps(animationModel, moveAnimation, el, props) {
    // Animation optimize.
    if (!$c3b912bf0217d820$var$propsEqual($c3b912bf0217d820$var$inner(el).lastProp, props)) {
        $c3b912bf0217d820$var$inner(el).lastProp = props;
        moveAnimation ? $bce1f681c7fb2581$exports.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
    }
}
function $c3b912bf0217d820$var$propsEqual(lastProps, newProps) {
    if ($f16f2994a32ad273$export$a6cdc56e425d0d0a(lastProps) && $f16f2994a32ad273$export$a6cdc56e425d0d0a(newProps)) {
        var equals_1 = true;
        $f16f2994a32ad273$export$79b2f7037acddd43(newProps, function(item, key) {
            equals_1 = equals_1 && $c3b912bf0217d820$var$propsEqual(lastProps[key], item);
        });
        return !!equals_1;
    } else return lastProps === newProps;
}
function $c3b912bf0217d820$var$updateLabelShowHide(labelEl, axisPointerModel) {
    labelEl[axisPointerModel.get([
        'label',
        'show'
    ]) ? 'show' : 'hide']();
}
function $c3b912bf0217d820$var$getHandleTransProps(trans) {
    return {
        x: trans.x || 0,
        y: trans.y || 0,
        rotation: trans.rotation || 0
    };
}
function $c3b912bf0217d820$var$updateMandatoryProps(group, axisPointerModel, silent) {
    var z = axisPointerModel.get('z');
    var zlevel = axisPointerModel.get('zlevel');
    group && group.traverse(function(el) {
        if (el.type !== 'group') {
            z != null && (el.z = z);
            zlevel != null && (el.zlevel = zlevel);
            el.silent = silent;
        }
    });
}
var $c3b912bf0217d820$export$2e2bcd8739ae039 = $c3b912bf0217d820$var$BaseAxisPointer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $312aa5860ca73489$var$Scale = /** @class */ function() {
    function Scale() {}
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   *
   * @final NEVER override!
   */ Scale.prototype.isBlank = function() {
        return this._isBlank;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   *
   * @final NEVER override!
   */ Scale.prototype.setBlank = function(isBlank) {
        this._isBlank = isBlank;
    };
    return Scale;
}();
$7904d4b709390668$export$241315e45585454d($312aa5860ca73489$var$Scale);
var $312aa5860ca73489$export$2e2bcd8739ae039 = $312aa5860ca73489$var$Scale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $71fd5e79a240d0ee$var$uidBase = 0;
var $71fd5e79a240d0ee$var$OrdinalMeta = /** @class */ function() {
    /**
   * PENDING - Regarding forcibly converting to string:
   *  In the early days, the underlying hash map impl used JS plain object and converted the key to
   *  string; later in https://github.com/ecomfe/zrender/pull/966 it was changed to a JS Map (in supported
   *  platforms), which does not require string keys. But consider any input that `scale/Ordinal['parse']`
   *  is involved, a number input represents an `OrdinalNumber` (i.e., an index), and affect the query
   *  behavior:
   *    - If forcbily converting to string:
   *      pros: users can use numeric string (such as, '123') to query the raw data (123), tho it's probably
   *      still confusing.
   *      cons: NaN/null/undefined in data will be equals to 'NaN'/'null'/'undefined', if simply using
   *      `val + ''` to convert them, like currently `getName` does.
   *    - Otherwise:
   *      pros: see NaN/null/undefined case above.
   *      cons: users cannot query the raw data (123) any more.
   *  There are two inconsistent behaviors in the current impl:
   *    - Force conversion is applied on the case `xAxis{data: ['aaa', 'bbb', ...]}`,
   *      but no conversion applied to the case `xAxis{data: [{value: 'aaa'}, ...]}` and
   *      the case `dataset: {source: [['aaa', 123], ['bbb', 234], ...]}`.
   *    - behaves differently according to whether JS Map is supported (the polyfill is simply using JS
   *      plain object) (tho it seems rare platform that do not support it).
   *  Since there's no sufficient good solution to offset cost of the breaking change, we preserve the
   *  current behavior, until real issues is reported.
   */ function OrdinalMeta(opt) {
        this.categories = opt.categories || [];
        this._needCollect = opt.needCollect;
        this._deduplication = opt.deduplication;
        this.uid = ++$71fd5e79a240d0ee$var$uidBase;
        this._onCollect = opt.onCollect;
    }
    OrdinalMeta.createByAxisModel = function(axisModel) {
        var option = axisModel.option;
        var data = option.data;
        var categories = data && (0, $f16f2994a32ad273$export$871de8747c9eaa88)(data, $71fd5e79a240d0ee$var$getName);
        return new OrdinalMeta({
            categories: categories,
            needCollect: !categories,
            // deduplication is default in axis.
            deduplication: option.dedplication !== false
        });
    };
    OrdinalMeta.prototype.getOrdinal = function(category) {
        return this._getOrCreateMap().get(category);
    };
    /**
   * @return The ordinal. If not found, return NaN.
   */ OrdinalMeta.prototype.parseAndCollect = function(category) {
        var index;
        var needCollect = this._needCollect;
        // The value of category dim can be the index of the given category set.
        // This feature is only supported when !needCollect, because we should
        // consider a common case: a value is 2017, which is a number but is
        // expected to be tread as a category. This case usually happen in dataset,
        // where it happent to be no need of the index feature.
        if (!(0, $f16f2994a32ad273$export$844ec244b1367d54)(category) && !needCollect) return category;
        // Optimize for the scenario:
        // category is ['2012-01-01', '2012-01-02', ...], where the input
        // data has been ensured not duplicate and is large data.
        // Notice, if a dataset dimension provide categroies, usually echarts
        // should remove duplication except user tell echarts dont do that
        // (set axis.deduplication = false), because echarts do not know whether
        // the values in the category dimension has duplication (consider the
        // parallel-aqi example)
        if (needCollect && !this._deduplication) {
            index = this.categories.length;
            this.categories[index] = category;
            this._onCollect && this._onCollect(category, index);
            return index;
        }
        var map = this._getOrCreateMap();
        index = map.get(category);
        if (index == null) {
            if (needCollect) {
                index = this.categories.length;
                this.categories[index] = category;
                map.set(category, index);
                this._onCollect && this._onCollect(category, index);
            } else index = NaN;
        }
        return index;
    };
    // Consider big data, do not create map until needed.
    OrdinalMeta.prototype._getOrCreateMap = function() {
        return this._map || (this._map = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)(this.categories));
    };
    return OrdinalMeta;
}();
function $71fd5e79a240d0ee$var$getName(obj) {
    if ((0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(obj) && obj.value != null) return obj.value;
    else return obj + '';
}
var $71fd5e79a240d0ee$export$2e2bcd8739ae039 = $71fd5e79a240d0ee$var$OrdinalMeta;






var $2fa2d25936823f26$var$OrdinalScale = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(OrdinalScale, _super);
    function OrdinalScale(setting) {
        var _this = _super.call(this) || this;
        _this.type = 'ordinal';
        _this.parse = OrdinalScale.parse;
        (0, $fbe267606846f86c$export$994b6d163a064f23)(_this, OrdinalScale.decoratedMethods);
        var ordinalMeta = setting.ordinalMeta;
        // Caution: Should not use instanceof, consider ec-extensions using
        // import approach to get OrdinalMeta class.
        if (!ordinalMeta) ordinalMeta = new (0, $71fd5e79a240d0ee$export$2e2bcd8739ae039)({});
        if ((0, $f16f2994a32ad273$export$43bee75e5e14138e)(ordinalMeta)) ordinalMeta = new (0, $71fd5e79a240d0ee$export$2e2bcd8739ae039)({
            categories: (0, $f16f2994a32ad273$export$871de8747c9eaa88)(ordinalMeta, function(item) {
                return (0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(item) ? item.value : item;
            })
        });
        _this._ordinalMeta = ordinalMeta;
        // Create an interval LinearScaleMapper, and decorate it.
        var res = (0, $fbe267606846f86c$export$acfc4e2d986326b7)(null, null, // Do not support break in OrdinalScale yet.
        setting.extent || [
            0,
            ordinalMeta.categories.length - 1
        ]);
        _this._mapper = res.mapper;
        (0, $fbe267606846f86c$export$85c5c680f14cd13c)(_this, res.mapper);
        return _this;
    }
    OrdinalScale.parse = function(val) {
        // Caution: Math.round(null) will return `0` rather than `NaN`
        if (val == null) val = NaN;
        else if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(val)) {
            val = this._ordinalMeta.getOrdinal(val);
            if (val == null) val = NaN;
        } else // The val from user input might be float.
        val = (0, $104896d282bd296f$export$42cacde8c45786ff)(val);
        return val;
    };
    /**
   * PENDING: currently this method is not used.
   * `makeCategoryTicks` is effectively used.
   */ OrdinalScale.prototype.getTicks = function() {
        var ticks = [];
        (0, $f976678a0ff027db$export$1039c7e66c46a7fd)(this, 0, function(tick) {
            ticks.push(tick);
        });
        return ticks;
    };
    OrdinalScale.prototype.getMinorTicks = function(splitNumber) {
        // Not support.
        return;
    };
    /**
   * @see `Ordinal['_ordinalNumbersByTick']`
   */ OrdinalScale.prototype.setSortInfo = function(info) {
        if (info == null) {
            this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
            return;
        }
        var infoOrdinalNumbers = info.ordinalNumbers;
        var ordinalsByTick = this._ordinalNumbersByTick = [];
        var ticksByOrdinal = this._ticksByOrdinalNumber = [];
        // Unnecessary support negative tick in `realtimeSort`.
        var tickNum = 0;
        var allCategoryLen = this._ordinalMeta.categories.length;
        for(var len = (0, $104896d282bd296f$export$e411eeaf23dccbe8)(allCategoryLen, infoOrdinalNumbers.length); tickNum < len; ++tickNum){
            var ordinalNumber = ordinalsByTick[tickNum] = infoOrdinalNumbers[tickNum];
            ticksByOrdinal[ordinalNumber] = tickNum;
        }
        // Handle that `series.data` only covers part of the `axis.category.data`.
        var unusedOrdinal = 0;
        for(; tickNum < allCategoryLen; ++tickNum){
            while(ticksByOrdinal[unusedOrdinal] != null)unusedOrdinal++;
            ordinalsByTick[tickNum] = unusedOrdinal;
            ticksByOrdinal[unusedOrdinal] = tickNum;
        }
    };
    OrdinalScale.prototype._getTickNumber = function(ordinal) {
        var ticksByOrdinalNumber = this._ticksByOrdinalNumber;
        // also support ordinal out of range of `ordinalMeta.categories.length`,
        // where ordinal numbers are used as tick value directly.
        return ticksByOrdinalNumber && ordinal >= 0 && ordinal < ticksByOrdinalNumber.length ? ticksByOrdinalNumber[ordinal] : ordinal;
    };
    /**
   * @usage
   * ```js
   * const ordinalNumber = ordinalScale.getRawOrdinalNumber(tick.value);
   * // case0
   * const rawOrdinalValue = axisModel.getCategories()[ordinalNumber];
   * // case1
   * const rawOrdinalValue = this._ordinalMeta.categories[ordinalNumber];
   * // case2
   * const coord = axis.dataToCoord(ordinalNumber);
   * ```
   *
   * value may be out of range, e.g., when axis max is larger than `ordinalMeta.categories.length`,
   * where ordinal numbers are used as tick value directly.
   */ OrdinalScale.prototype.getRawOrdinalNumber = function(tickValue) {
        var ordinalNumbersByTick = this._ordinalNumbersByTick;
        return ordinalNumbersByTick && tickValue >= 0 && tickValue < ordinalNumbersByTick.length ? ordinalNumbersByTick[tickValue] : tickValue;
    };
    /**
   * Get item on tick
   */ OrdinalScale.prototype.getLabel = function(tick) {
        if (!this.isBlank()) {
            var ordinalNumber = this.getRawOrdinalNumber(tick.value);
            var category = this._ordinalMeta.categories[ordinalNumber];
            // Note that if no data, ordinalMeta.categories is an empty array.
            // Return empty if it's not exist.
            return category == null ? '' : category + '';
        }
    };
    /**
   * NOTICE: This is different from `.getOrdinalMeta().length` when extent
   * is specified by `xxxAxis.min/max` or by `dataZoom`.
   */ OrdinalScale.prototype.count = function() {
        var extent = (0, $fbe267606846f86c$export$87f6c9bc988c4378)(this._mapper);
        return extent[1] - extent[0] + 1;
    };
    OrdinalScale.prototype.getOrdinalMeta = function() {
        return this._ordinalMeta;
    };
    OrdinalScale.type = 'ordinal';
    OrdinalScale.decoratedMethods = {
        needTransform: function needTransform() {
            return this._mapper.needTransform();
        },
        contain: function contain(val) {
            return this._mapper.contain(this._getTickNumber(val)) && val >= 0 && val < this._ordinalMeta.categories.length;
        },
        normalize: function normalize(val) {
            return this._mapper.normalize(this._getTickNumber(val));
        },
        scale: function scale(val) {
            return this.getRawOrdinalNumber((0, $104896d282bd296f$export$42cacde8c45786ff)(this._mapper.scale(val)));
        },
        transformIn: function transformIn(val, opt) {
            return this._mapper.transformIn(this._getTickNumber(val), opt);
        },
        transformOut: function transformOut(val, opt) {
            return this.getRawOrdinalNumber(this._mapper.transformOut(val, opt));
        },
        getExtent: function getExtent() {
            return this._mapper.getExtent();
        },
        getExtentUnsafe: function getExtentUnsafe(kind, depth) {
            return this._mapper.getExtentUnsafe(kind, depth);
        },
        /**
     * NOTICE: OrdinalScale extent should always originates from
     * `[0, ordinalMeta.categories.length - 1]`, regardless of min/max of `series.data`.
     * But settings like `xxxAxis.min/max` can still modify the extent.
     * It is handled by constructor of `ScaleRawExtentInfo`.
     */ setExtent: function setExtent(start, end) {
            return this._mapper.setExtent(start, end);
        },
        setExtent2: function setExtent2(kind, start, end) {
            return this._mapper.setExtent2(kind, start, end);
        }
    };
    return OrdinalScale;
}((0, $312aa5860ca73489$export$2e2bcd8739ae039));
(0, $312aa5860ca73489$export$2e2bcd8739ae039).registerClass($2fa2d25936823f26$var$OrdinalScale);
var $2fa2d25936823f26$export$2e2bcd8739ae039 = $2fa2d25936823f26$var$OrdinalScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $8429d6fe2076bff1$export$e2d43952c5db22bb(scale, splitNumber, breaks, scaleInterval) {
    var ticks = scale.getTicks({
        expandToNicedExtent: true
    });
    // NOTE: In log-scale, do not support minor ticks when breaks exist.
    //  because currently log-scale minor ticks is calculated based on raw values
    //  rather than log-transformed value, due to an odd effect when breaks exist.
    var minorTicks = [];
    var extent = scale.getExtent();
    for(var i = 1; i < ticks.length; i++){
        var nextTick = ticks[i];
        var prevTick = ticks[i - 1];
        if (prevTick["break"] || nextTick["break"]) continue;
        var count = 0;
        var minorTicksGroup = [];
        var interval = nextTick.value - prevTick.value;
        var minorInterval = interval / splitNumber;
        var minorIntervalPrecision = (0, $f976678a0ff027db$export$86a060b060d3d31a)(minorInterval);
        while(count < splitNumber - 1){
            var minorTick = (0, $104896d282bd296f$export$2077e0241d6afd3c)(prevTick.value + (count + 1) * minorInterval, minorIntervalPrecision);
            // For the first and last interval. The count may be less than splitNumber.
            if (minorTick > extent[0] && minorTick < extent[1]) minorTicksGroup.push(minorTick);
            count++;
        }
        var scaleBreakHelper = (0, $cf43ca9fea251347$export$e79b20ac82c2d660)();
        scaleBreakHelper && scaleBreakHelper.pruneTicksByBreak('auto', minorTicksGroup, breaks, function(value) {
            return value;
        }, scaleInterval, extent);
        minorTicks.push(minorTicksGroup);
    }
    return minorTicks;
}




var $9fa621e57136ea9d$var$IntervalScale = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(IntervalScale, _super);
    function IntervalScale(setting) {
        var _this = _super.call(this) || this;
        _this.type = 'interval';
        _this.parse = IntervalScale.parse;
        setting = setting || {};
        var breakParsed = (0, $cf43ca9fea251347$export$770ec3eb53b5689b)(_this, setting);
        var res = (0, $fbe267606846f86c$export$acfc4e2d986326b7)(_this, breakParsed, null);
        // @ts-ignore
        _this.brk = res.brk;
        _this._cfg = {
            interval: 0,
            intervalPrecision: 2,
            intervalCount: undefined,
            niceExtent: undefined
        };
        return _this;
    }
    IntervalScale.parse = function(val) {
        // `Scale#parse` (and its overrids) are typically applied at the axis values input
        // in echarts option. e.g., `axis.min/max`, `dataZoom.min/max`, etc.
        // but `series.data` is not included, which uses `dataValueHelper.ts`#`parseDataValue`.
        // `Scale#parse` originally introduced in fb8c813215098b9d2458966229bb95c510883d5e
        // at 2016 for dataZoom start/end settings (See `parseAxisModelMinMax`).
        //
        // Historically `scale/Interval.ts` returns the input value directly. But numeric
        // values (such as a number-like string '123') effectively passed through here and
        // were involved in calculations, which was error-prone and inconsistent with the
        // declared TS return type. Previously such issues are fixed separately in different
        // places case by case (such as #2475).
        //
        // Now, we perform actual parse to ensure its `number` type here. The parsing rule
        // follows the series data parsing rule (`dataValueHelper.ts`#`parseDataValue`)
        // and maintains compatibility as much as possible (thus a more strict parsing
        // `number.ts`#`numericToNumber` is not used here.)
        //
        // FIXME: `ScaleDataValue` also need to be modified to include numeric string type,
        //  since it effectively does.
        return val == null || val === '' ? NaN : Number(val);
    };
    IntervalScale.prototype.getConfig = function() {
        return (0, $f16f2994a32ad273$export$9cd59f9826255e47)(this._cfg);
    };
    IntervalScale.prototype.setConfig = function(cfg) {
        var extent = (0, $fbe267606846f86c$export$87f6c9bc988c4378)(this);
        // Reset all.
        this._cfg = cfg = (0, $f16f2994a32ad273$export$9cd59f9826255e47)(cfg);
        if (cfg.niceExtent == null) // Dropped the auto calculated niceExtent and use user-set extent.
        // We assume users want to set both interval and extent to get a better result.
        cfg.niceExtent = extent.slice();
        if (cfg.intervalPrecision == null) cfg.intervalPrecision = (0, $f976678a0ff027db$export$86a060b060d3d31a)(cfg.interval);
    };
    /**
   * In ascending order.
   */ IntervalScale.prototype.getTicks = function(opt) {
        opt = opt || {};
        var cfg = this._cfg;
        var interval = cfg.interval;
        var extent = (0, $fbe267606846f86c$export$87f6c9bc988c4378)(this);
        var niceExtent = cfg.niceExtent;
        var intervalPrecision = cfg.intervalPrecision;
        var scaleBreakHelper = (0, $cf43ca9fea251347$export$e79b20ac82c2d660)();
        var brk = this.brk;
        var brkAvailable = scaleBreakHelper && brk;
        var ticks = [];
        // If interval is 0, return [];
        if (!interval) return ticks;
        if (opt.breakTicks === 'only_break' && brkAvailable) {
            scaleBreakHelper.addBreaksToTicks(ticks, brk.breaks, extent);
            return ticks;
        }
        // [CAVEAT]: If changing this logic, must sync it to `axisAlignTicks.ts`.
        // A fail-safe is required since `interval` can be user specified, or for the case
        // that using dataZoom toolbox and zoom repeatedly.
        var safeLimit = 3000;
        if (extent[0] < niceExtent[0]) ticks.push({
            value: opt.expandToNicedExtent ? (0, $104896d282bd296f$export$2077e0241d6afd3c)(niceExtent[0] - interval, intervalPrecision) : extent[0]
        });
        var estimateNiceMultiple = function estimateNiceMultiple(tickVal, targetTick) {
            return (0, $104896d282bd296f$export$42cacde8c45786ff)((targetTick - tickVal) / interval);
        };
        var intervalCount = cfg.intervalCount;
        for(var tick = niceExtent[0], niceTickIdx = 0;; niceTickIdx++){
            // Consider case `_extent: [5.2, 5.8], _niceExtent: [6, 5], interval: 1`,
            //  `_intervalCount` makes sense iff `-1`.
            // Consider case `_extent: [5, 5.8], _niceExtent: [5, 5], interval: 1`,
            //  `_intervalCount` makes sense iff `0`.
            if (intervalCount == null) {
                if (tick > niceExtent[1] || !isFinite(tick) || !isFinite(niceExtent[1])) break;
            } else {
                if (niceTickIdx > intervalCount) break;
                // Consider cumulative error, especially caused by rounding, the last nice
                // `tick` may be less than or greater than `niceExtent[1]` slightly.
                tick = (0, $104896d282bd296f$export$e411eeaf23dccbe8)(tick, niceExtent[1]);
                if (niceTickIdx === intervalCount) tick = niceExtent[1];
            }
            ticks.push({
                value: tick
            });
            // Avoid rounding error
            tick = (0, $104896d282bd296f$export$2077e0241d6afd3c)(tick + interval, intervalPrecision);
            if (brk) {
                var moreMultiple = brk.calcNiceTickMultiple(tick, estimateNiceMultiple);
                if (moreMultiple >= 0) tick = (0, $104896d282bd296f$export$2077e0241d6afd3c)(tick + moreMultiple * interval, intervalPrecision);
            }
            if (ticks.length > 0 && tick === ticks[ticks.length - 1].value) break;
            if (ticks.length > safeLimit) return [];
        }
        // Consider this case: the last item of ticks is smaller
        // than niceExtent[1] and niceExtent[1] === extent[1].
        var lastNiceTick = ticks.length ? ticks[ticks.length - 1].value : niceExtent[1];
        if (extent[1] > lastNiceTick) ticks.push({
            value: opt.expandToNicedExtent ? (0, $104896d282bd296f$export$2077e0241d6afd3c)(lastNiceTick + interval, intervalPrecision) : extent[1]
        });
        if (brkAvailable) scaleBreakHelper.pruneTicksByBreak(opt.pruneByBreak, ticks, brk.breaks, function(item) {
            return item.value;
        }, cfg.interval, extent);
        if (brkAvailable && opt.breakTicks !== 'none') scaleBreakHelper.addBreaksToTicks(ticks, brk.breaks, extent);
        return ticks;
    };
    IntervalScale.prototype.getMinorTicks = function(splitNumber) {
        return (0, $8429d6fe2076bff1$export$e2d43952c5db22bb)(this, splitNumber, (0, $cf43ca9fea251347$export$20734ee5f1d5720f)(this), this._cfg.interval);
    };
    IntervalScale.prototype.getLabel = function(tick, opt) {
        if (tick == null) return '';
        var precision = opt && opt.precision;
        if (precision == null) precision = (0, $104896d282bd296f$export$e0c74b50bbd10f68)(tick.value) || 0;
        else if (precision === 'auto') // Should be more precise then tick.
        precision = this._cfg.intervalPrecision;
        // (1) If `precision` is set, 12.005 should be display as '12.00500'.
        // (2) Use `round` (toFixed) to avoid scientific notation like '3.5e-7'.
        var dataNum = (0, $104896d282bd296f$export$2077e0241d6afd3c)(tick.value, precision, true);
        return (0, $04bb9ff155ec4ccd$export$b6fe44657ce35c42)(dataNum);
    };
    IntervalScale.type = 'interval';
    return IntervalScale;
}((0, $312aa5860ca73489$export$2e2bcd8739ae039));
(0, $312aa5860ca73489$export$2e2bcd8739ae039).registerClass($9fa621e57136ea9d$var$IntervalScale);
var $9fa621e57136ea9d$export$2e2bcd8739ae039 = $9fa621e57136ea9d$var$IntervalScale;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 










// FIXME 公用？
var $8aa741ffc5165c6e$var$bisect = function bisect(a, x, lo, hi) {
    while(lo < hi){
        var mid = lo + hi >>> 1;
        if (a[mid][1] < x) lo = mid + 1;
        else hi = mid;
    }
    return lo;
};
var $8aa741ffc5165c6e$var$TimeScale = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(TimeScale, _super);
    function TimeScale(setting) {
        var _this = _super.call(this) || this;
        _this.type = 'time';
        _this.parse = TimeScale.parse;
        _this._locale = setting.locale;
        _this._useUTC = setting.useUTC;
        _this._interval = 0;
        var breakParsed = (0, $cf43ca9fea251347$export$770ec3eb53b5689b)(_this, setting);
        var res = (0, $fbe267606846f86c$export$acfc4e2d986326b7)(_this, breakParsed, null);
        // @ts-ignore
        _this.brk = res.brk;
        return _this;
    }
    /**
   * Get label is mainly for other components like dataZoom, tooltip.
   */ TimeScale.prototype.getLabel = function(tick) {
        return (0, $8a51e097d5164103$export$d9468344d3651243)(tick.value, (0, $8a51e097d5164103$export$445bdbd8d2334e40)[(0, $8a51e097d5164103$export$124c820721c4f66b)((0, $8a51e097d5164103$export$1da4b91a25d7e1c8)(this._minLevelUnit))] || (0, $8a51e097d5164103$export$445bdbd8d2334e40).second, this._useUTC, this._locale);
    };
    TimeScale.prototype.getFormattedLabel = function(tick, idx, labelFormatter) {
        return (0, $8a51e097d5164103$export$fe777b6293828b5d)(tick, idx, labelFormatter, this._locale, this._useUTC);
    };
    TimeScale.prototype.getTicks = function(opt) {
        opt = opt || {};
        var interval = this._interval;
        var extent = (0, $fbe267606846f86c$export$87f6c9bc988c4378)(this);
        var scaleBreakHelper = (0, $cf43ca9fea251347$export$e79b20ac82c2d660)();
        var brk = this.brk;
        var brkAvailable = scaleBreakHelper && brk;
        var ticks = [];
        // If interval is 0, return [];
        if (!interval) return ticks;
        var useUTC = this._useUTC;
        if (brkAvailable && opt.breakTicks === 'only_break') {
            (0, $cf43ca9fea251347$export$e79b20ac82c2d660)().addBreaksToTicks(ticks, brk.breaks, extent);
            return ticks;
        }
        ticks = $8aa741ffc5165c6e$var$createIntervalTicks(this._minLevelUnit, this._approxInterval, useUTC, extent, (0, $fbe267606846f86c$export$9a49fe71267af794)(this), brk);
        var upperUnitIndex = (0, $8a51e097d5164103$export$87100da04d711986).length - 1;
        var maxLevel = 0;
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(ticks, function(tick) {
            if (tick.time) {
                upperUnitIndex = Math.min(upperUnitIndex, (0, $f16f2994a32ad273$export$305f7d4e9d4624f2)((0, $8a51e097d5164103$export$87100da04d711986), tick.time.upperTimeUnit));
                maxLevel = Math.max(maxLevel, tick.time.level);
            }
        });
        if (brkAvailable) (0, $cf43ca9fea251347$export$e79b20ac82c2d660)().pruneTicksByBreak(opt.pruneByBreak, ticks, brk.breaks, function(item) {
            return item.value;
        }, this._approxInterval, extent);
        if (brkAvailable && opt.breakTicks !== 'none') (0, $cf43ca9fea251347$export$e79b20ac82c2d660)().addBreaksToTicks(ticks, brk.breaks, extent, function(trimmedBrk) {
            // @see `parseTimeAxisLabelFormatterDictionary`.
            var lowerBrkUnitIndex = Math.max((0, $f16f2994a32ad273$export$305f7d4e9d4624f2)((0, $8a51e097d5164103$export$87100da04d711986), (0, $8a51e097d5164103$export$4dfb0417ad6555b7)(trimmedBrk.vmin, useUTC)), (0, $f16f2994a32ad273$export$305f7d4e9d4624f2)((0, $8a51e097d5164103$export$87100da04d711986), (0, $8a51e097d5164103$export$4dfb0417ad6555b7)(trimmedBrk.vmax, useUTC)));
            var upperBrkUnitIndex = 0;
            for(var unitIdx = 0; unitIdx < (0, $8a51e097d5164103$export$87100da04d711986).length; unitIdx++)if (!$8aa741ffc5165c6e$var$isPrimaryUnitValueAndGreaterSame((0, $8a51e097d5164103$export$87100da04d711986)[unitIdx], trimmedBrk.vmin, trimmedBrk.vmax, useUTC)) {
                upperBrkUnitIndex = unitIdx;
                break;
            }
            var upperIdx = Math.min(upperBrkUnitIndex, upperUnitIndex);
            var lowerIdx = Math.max(upperIdx, lowerBrkUnitIndex);
            return {
                level: maxLevel,
                lowerTimeUnit: (0, $8a51e097d5164103$export$87100da04d711986)[lowerIdx],
                upperTimeUnit: (0, $8a51e097d5164103$export$87100da04d711986)[upperIdx]
            };
        });
        return ticks;
    };
    TimeScale.prototype.getMinorTicks = function(splitNumber) {
        return (0, $8429d6fe2076bff1$export$e2d43952c5db22bb)(this, splitNumber, (0, $cf43ca9fea251347$export$20734ee5f1d5720f)(this), this._interval);
    };
    TimeScale.prototype.setTimeInterval = function(opt) {
        this._interval = opt.interval;
        this._approxInterval = opt.approxInterval;
        this._minLevelUnit = opt.minLevelUnit;
    };
    TimeScale.parse = function(val) {
        // `val` might be a float (e.g., calculated from percent), so call `round`.
        return (0, $f16f2994a32ad273$export$7e4aa119212bc614)(val) ? Math.round(val) : +$104896d282bd296f$export$6b862160d295c8e(val);
    };
    TimeScale.type = 'time';
    return TimeScale;
}((0, $312aa5860ca73489$export$2e2bcd8739ae039));
/**
 * This implementation was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ var $8aa741ffc5165c6e$var$scaleIntervals = [
    // Format                           interval
    [
        'second',
        (0, $8a51e097d5164103$export$32c0454ceff7f92d)
    ],
    [
        'minute',
        (0, $8a51e097d5164103$export$35acaebf644db34e)
    ],
    [
        'hour',
        (0, $8a51e097d5164103$export$82541edf19e5e3b0)
    ],
    [
        'quarter-day',
        (0, $8a51e097d5164103$export$82541edf19e5e3b0) * 6
    ],
    [
        'half-day',
        (0, $8a51e097d5164103$export$82541edf19e5e3b0) * 12
    ],
    [
        'day',
        (0, $8a51e097d5164103$export$a97a1358cbb650ab) * 1.2
    ],
    [
        'half-week',
        (0, $8a51e097d5164103$export$a97a1358cbb650ab) * 3.5
    ],
    [
        'week',
        (0, $8a51e097d5164103$export$a97a1358cbb650ab) * 7
    ],
    [
        'month',
        (0, $8a51e097d5164103$export$a97a1358cbb650ab) * 31
    ],
    [
        'quarter',
        (0, $8a51e097d5164103$export$a97a1358cbb650ab) * 95
    ],
    [
        'half-year',
        (0, $8a51e097d5164103$export$99cafda57477293d) / 2
    ],
    [
        'year',
        (0, $8a51e097d5164103$export$99cafda57477293d)
    ] // 1Y
];
function $8aa741ffc5165c6e$var$isPrimaryUnitValueAndGreaterSame(unit, valueA, valueB, isUTC) {
    return (0, $8a51e097d5164103$export$2ed3384313b02c28)(new Date(valueA), unit, isUTC).getTime() === (0, $8a51e097d5164103$export$2ed3384313b02c28)(new Date(valueB), unit, isUTC).getTime();
}
// function isUnitValueSame(
//     unit: PrimaryTimeUnit,
//     valueA: number,
//     valueB: number,
//     isUTC: boolean
// ): boolean {
//     const dateA = numberUtil.parseDate(valueA) as any;
//     const dateB = numberUtil.parseDate(valueB) as any;
//     const isSame = (unit: PrimaryTimeUnit) => {
//         return getUnitValue(dateA, unit, isUTC)
//             === getUnitValue(dateB, unit, isUTC);
//     };
//     const isSameYear = () => isSame('year');
//     // const isSameHalfYear = () => isSameYear() && isSame('half-year');
//     // const isSameQuater = () => isSameYear() && isSame('quarter');
//     const isSameMonth = () => isSameYear() && isSame('month');
//     const isSameDay = () => isSameMonth() && isSame('day');
//     // const isSameHalfDay = () => isSameDay() && isSame('half-day');
//     const isSameHour = () => isSameDay() && isSame('hour');
//     const isSameMinute = () => isSameHour() && isSame('minute');
//     const isSameSecond = () => isSameMinute() && isSame('second');
//     const isSameMilliSecond = () => isSameSecond() && isSame('millisecond');
//     switch (unit) {
//         case 'year':
//             return isSameYear();
//         case 'month':
//             return isSameMonth();
//         case 'day':
//             return isSameDay();
//         case 'hour':
//             return isSameHour();
//         case 'minute':
//             return isSameMinute();
//         case 'second':
//             return isSameSecond();
//         case 'millisecond':
//             return isSameMilliSecond();
//     }
// }
// const primaryUnitGetters = {
//     year: fullYearGetterName(),
//     month: monthGetterName(),
//     day: dateGetterName(),
//     hour: hoursGetterName(),
//     minute: minutesGetterName(),
//     second: secondsGetterName(),
//     millisecond: millisecondsGetterName()
// };
// const primaryUnitUTCGetters = {
//     year: fullYearGetterName(true),
//     month: monthGetterName(true),
//     day: dateGetterName(true),
//     hour: hoursGetterName(true),
//     minute: minutesGetterName(true),
//     second: secondsGetterName(true),
//     millisecond: millisecondsGetterName(true)
// };
// function moveTick(date: Date, unitName: TimeUnit, step: number, isUTC: boolean) {
//     step = step || 1;
//     switch (getPrimaryTimeUnit(unitName)) {
//         case 'year':
//             date[fullYearSetterName(isUTC)](date[fullYearGetterName(isUTC)]() + step);
//             break;
//         case 'month':
//             date[monthSetterName(isUTC)](date[monthGetterName(isUTC)]() + step);
//             break;
//         case 'day':
//             date[dateSetterName(isUTC)](date[dateGetterName(isUTC)]() + step);
//             break;
//         case 'hour':
//             date[hoursSetterName(isUTC)](date[hoursGetterName(isUTC)]() + step);
//             break;
//         case 'minute':
//             date[minutesSetterName(isUTC)](date[minutesGetterName(isUTC)]() + step);
//             break;
//         case 'second':
//             date[secondsSetterName(isUTC)](date[secondsGetterName(isUTC)]() + step);
//             break;
//         case 'millisecond':
//             date[millisecondsSetterName(isUTC)](date[millisecondsGetterName(isUTC)]() + step);
//             break;
//     }
//     return date.getTime();
// }
// const DATE_INTERVALS = [[8, 7.5], [4, 3.5], [2, 1.5]];
// const MONTH_INTERVALS = [[6, 5.5], [3, 2.5], [2, 1.5]];
// const MINUTES_SECONDS_INTERVALS = [[30, 30], [20, 20], [15, 15], [10, 10], [5, 5], [2, 2]];
function $8aa741ffc5165c6e$var$getDateInterval(approxInterval, daysInMonth) {
    approxInterval /= (0, $8a51e097d5164103$export$a97a1358cbb650ab);
    return approxInterval > 16 ? 16 : approxInterval > 7.5 ? 7 // TODO week 7 or day 8?
     : approxInterval > 3.5 ? 4 : approxInterval > 1.5 ? 2 : 1;
}
function $8aa741ffc5165c6e$var$getMonthInterval(approxInterval) {
    var APPROX_ONE_MONTH = 30 * (0, $8a51e097d5164103$export$a97a1358cbb650ab);
    approxInterval /= APPROX_ONE_MONTH;
    return approxInterval > 6 ? 6 : approxInterval > 3 ? 3 : approxInterval > 2 ? 2 : 1;
}
function $8aa741ffc5165c6e$var$getHourInterval(approxInterval) {
    approxInterval /= (0, $8a51e097d5164103$export$82541edf19e5e3b0);
    return approxInterval > 12 ? 12 : approxInterval > 6 ? 6 : approxInterval > 3.5 ? 4 : approxInterval > 2 ? 2 : 1;
}
function $8aa741ffc5165c6e$var$getMinutesAndSecondsInterval(approxInterval, isMinutes) {
    approxInterval /= isMinutes ? (0, $8a51e097d5164103$export$35acaebf644db34e) : (0, $8a51e097d5164103$export$32c0454ceff7f92d);
    return approxInterval > 30 ? 30 : approxInterval > 20 ? 20 : approxInterval > 15 ? 15 : approxInterval > 10 ? 10 : approxInterval > 5 ? 5 : approxInterval > 2 ? 2 : 1;
}
function $8aa741ffc5165c6e$var$getMillisecondsInterval(approxInterval) {
    // If less than 1, the getTicks loop will inevitably deed loop and read safeLimit.
    return $104896d282bd296f$export$2ca8010d037f830f($104896d282bd296f$export$7a695fe44258210b(approxInterval, true), 1);
}
// e.g., if the input unit is 'day', start calculate ticks from the first day of
// that month to make ticks "nice".
function $8aa741ffc5165c6e$var$getFirstTimestampOfUnit(timestamp, unitName, isUTC) {
    var upperUnitIdx = Math.max(0, (0, $f16f2994a32ad273$export$305f7d4e9d4624f2)((0, $8a51e097d5164103$export$87100da04d711986), unitName) - 1);
    return (0, $8a51e097d5164103$export$2ed3384313b02c28)(new Date(timestamp), (0, $8a51e097d5164103$export$87100da04d711986)[upperUnitIdx], isUTC).getTime();
}
function $8aa741ffc5165c6e$var$createEstimateNiceMultiple(setMethodName, dateMethodInterval) {
    var tmpDate = new Date(0);
    tmpDate[setMethodName](1);
    var tmpTime = tmpDate.getTime();
    tmpDate[setMethodName](1 + dateMethodInterval);
    var approxTimeInterval = tmpDate.getTime() - tmpTime;
    return function(tickVal, targetValue) {
        // Only in month that accurate result can not get by division of
        // timestamp interval, but no need accurate here.
        return Math.max(0, Math.round((targetValue - tickVal) / approxTimeInterval));
    };
}
function $8aa741ffc5165c6e$var$createIntervalTicks(bottomUnitName, approxInterval, isUTC, extent, innermostSpan, brk) {
    // A fail-safe is required since `interval` can be user specified, or for the case
    // that using dataZoom toolbox and zoom repeatedly.
    var safeLimit = 3000;
    var unitNames = (0, $8a51e097d5164103$export$833c398a55654bb7);
    var iter = 0;
    function addTicksInSpan(interval, minTimestamp, maxTimestamp, getMethodName, setMethodName, isDate, out) {
        var estimateNiceMultiple = $8aa741ffc5165c6e$var$createEstimateNiceMultiple(setMethodName, interval);
        var dateTime = minTimestamp;
        var date = new Date(dateTime);
        // if (isDate) {
        //     d -= 1; // Starts with 0;   PENDING
        // }
        while(dateTime < maxTimestamp && dateTime <= extent[1]){
            out.push({
                value: dateTime
            });
            if (iter++ > safeLimit) break;
            date[setMethodName](date[getMethodName]() + interval);
            dateTime = date.getTime();
            if (brk) {
                var moreMultiple = brk.calcNiceTickMultiple(dateTime, estimateNiceMultiple);
                if (moreMultiple > 0) {
                    date[setMethodName](date[getMethodName]() + moreMultiple * interval);
                    dateTime = date.getTime();
                }
            }
        }
        // This extra tick is for calculating ticks of next level. Will not been added to the final result
        out.push({
            value: dateTime,
            // extent[1] should be added; deduplication will be performed later.
            notAdd: dateTime > extent[1]
        });
    }
    function addLevelTicks(unitName, lastLevelTicks, levelTicks) {
        var newAddedTicks = [];
        var isFirstLevel = !lastLevelTicks.length;
        if ($8aa741ffc5165c6e$var$isPrimaryUnitValueAndGreaterSame((0, $8a51e097d5164103$export$1da4b91a25d7e1c8)(unitName), extent[0], extent[1], isUTC)) return;
        if (isFirstLevel) lastLevelTicks = [
            {
                value: $8aa741ffc5165c6e$var$getFirstTimestampOfUnit(extent[0], unitName, isUTC)
            },
            {
                value: extent[1]
            }
        ];
        for(var i = 0; i < lastLevelTicks.length - 1; i++){
            var startTick = lastLevelTicks[i].value;
            var endTick = lastLevelTicks[i + 1].value;
            if (startTick === endTick) continue;
            var interval = void 0;
            var getterName = void 0;
            var setterName = void 0;
            var isDate = false;
            switch(unitName){
                case 'year':
                    interval = Math.max(1, Math.round(approxInterval / (0, $8a51e097d5164103$export$a97a1358cbb650ab) / 365));
                    getterName = (0, $8a51e097d5164103$export$8d046fefed9a548e)(isUTC);
                    setterName = (0, $8a51e097d5164103$export$43fbeac90913b151)(isUTC);
                    break;
                case 'half-year':
                case 'quarter':
                case 'month':
                    interval = $8aa741ffc5165c6e$var$getMonthInterval(approxInterval);
                    getterName = (0, $8a51e097d5164103$export$5c242a801a23eec7)(isUTC);
                    setterName = (0, $8a51e097d5164103$export$233f59998ed71c09)(isUTC);
                    break;
                case 'week':
                case 'half-week':
                case 'day':
                    interval = $8aa741ffc5165c6e$var$getDateInterval(approxInterval, 31); // Use 32 days and let interval been 16
                    getterName = (0, $8a51e097d5164103$export$4189e6cbc9753260)(isUTC);
                    setterName = (0, $8a51e097d5164103$export$82fd379a67f37fa0)(isUTC);
                    isDate = true;
                    break;
                case 'half-day':
                case 'quarter-day':
                case 'hour':
                    interval = $8aa741ffc5165c6e$var$getHourInterval(approxInterval);
                    getterName = (0, $8a51e097d5164103$export$8b40b55b3c06cbe2)(isUTC);
                    setterName = (0, $8a51e097d5164103$export$b6f943e8d23c15bb)(isUTC);
                    break;
                case 'minute':
                    interval = $8aa741ffc5165c6e$var$getMinutesAndSecondsInterval(approxInterval, true);
                    getterName = (0, $8a51e097d5164103$export$8807847c5c71eded)(isUTC);
                    setterName = (0, $8a51e097d5164103$export$50303078793fc7d)(isUTC);
                    break;
                case 'second':
                    interval = $8aa741ffc5165c6e$var$getMinutesAndSecondsInterval(approxInterval, false);
                    getterName = (0, $8a51e097d5164103$export$8f49e73e2eebd168)(isUTC);
                    setterName = (0, $8a51e097d5164103$export$a4a908acda9c3118)(isUTC);
                    break;
                case 'millisecond':
                    interval = $8aa741ffc5165c6e$var$getMillisecondsInterval(approxInterval);
                    getterName = (0, $8a51e097d5164103$export$312207a92d041116)(isUTC);
                    setterName = (0, $8a51e097d5164103$export$c047afab75f6d84)(isUTC);
                    break;
            }
            // Notice: This expansion by `getFirstTimestampOfUnit` may cause too many ticks and
            // iteration. e.g., when three levels of ticks is displayed, which can be caused by
            // data zoom and axis breaks. Thus trim them here.
            if (endTick >= extent[0] && startTick <= extent[1]) addTicksInSpan(interval, startTick, endTick, getterName, setterName, isDate, newAddedTicks);
            if (unitName === 'year' && levelTicks.length > 1 && i === 0) // Add nearest years to the left extent.
            levelTicks.unshift({
                value: levelTicks[0].value - interval
            });
        }
        for(var i = 0; i < newAddedTicks.length; i++)levelTicks.push(newAddedTicks[i]);
    }
    var levelsTicks = [];
    var currentLevelTicks = [];
    var tickCount = 0;
    var lastLevelTickCount = 0;
    for(var i = 0; i < unitNames.length; ++i){
        var primaryTimeUnit = (0, $8a51e097d5164103$export$1da4b91a25d7e1c8)(unitNames[i]);
        if (!(0, $8a51e097d5164103$export$beb5920b69c13da)(unitNames[i])) continue;
        addLevelTicks(unitNames[i], levelsTicks[levelsTicks.length - 1] || [], currentLevelTicks);
        var nextPrimaryTimeUnit = unitNames[i + 1] ? (0, $8a51e097d5164103$export$1da4b91a25d7e1c8)(unitNames[i + 1]) : null;
        if (primaryTimeUnit !== nextPrimaryTimeUnit) {
            if (currentLevelTicks.length) {
                lastLevelTickCount = tickCount;
                // Remove the duplicate so the tick count can be precisely.
                currentLevelTicks.sort(function(a, b) {
                    return a.value - b.value;
                });
                var levelTicksRemoveDuplicated = [];
                for(var i_1 = 0; i_1 < currentLevelTicks.length; ++i_1){
                    var tickValue = currentLevelTicks[i_1].value;
                    if (i_1 === 0 || currentLevelTicks[i_1 - 1].value !== tickValue) {
                        levelTicksRemoveDuplicated.push(currentLevelTicks[i_1]);
                        if (tickValue >= extent[0] && tickValue <= extent[1]) tickCount++;
                    }
                }
                var targetTickNum = innermostSpan / approxInterval;
                // Added too much in this level and not too less in last level
                if (tickCount > targetTickNum * 1.5 && lastLevelTickCount > targetTickNum / 1.5) break;
                // Only treat primary time unit as one level.
                levelsTicks.push(levelTicksRemoveDuplicated);
                if (tickCount > targetTickNum || bottomUnitName === unitNames[i]) break;
            }
            // Reset if next unitName is primary
            currentLevelTicks = [];
        }
    }
    var levelsTicksInExtent = (0, $f16f2994a32ad273$export$3dea766d36a8935f)((0, $f16f2994a32ad273$export$871de8747c9eaa88)(levelsTicks, function(levelTicks) {
        return (0, $f16f2994a32ad273$export$3dea766d36a8935f)(levelTicks, function(tick) {
            return tick.value >= extent[0] && tick.value <= extent[1] && !tick.notAdd;
        });
    }), function(levelTicks) {
        return levelTicks.length > 0;
    });
    var maxLevel = levelsTicksInExtent.length - 1;
    var ticks = [];
    for(var i = 0; i < levelsTicksInExtent.length; ++i){
        var levelTicks = levelsTicksInExtent[i];
        for(var k = 0; k < levelTicks.length; ++k){
            var unit = (0, $8a51e097d5164103$export$4dfb0417ad6555b7)(levelTicks[k].value, isUTC);
            ticks.push({
                value: levelTicks[k].value,
                time: {
                    level: maxLevel - i,
                    upperTimeUnit: unit,
                    lowerTimeUnit: unit
                }
            });
        }
    }
    // Remove duplicates, which may cause jitter of `splitArea` and other bad cases.
    (0, $3fa81475350067fd$export$2e2262a44ac61957)(ticks, (0, $3fa81475350067fd$export$605c429b4975bbd7), null);
    ticks.sort(function(a, b) {
        return a.value - b.value;
    });
    var currMinTick = ticks[0];
    var currMaxTick = ticks[ticks.length - 1];
    var extent0Unit = (0, $8a51e097d5164103$export$4dfb0417ad6555b7)(extent[0], isUTC);
    var extent1Unit = (0, $8a51e097d5164103$export$4dfb0417ad6555b7)(extent[1], isUTC);
    if (!currMinTick || currMinTick.value > extent[0]) ticks.unshift({
        value: extent[0],
        time: {
            level: 0,
            upperTimeUnit: extent0Unit,
            lowerTimeUnit: extent0Unit
        },
        notNice: true
    });
    if (!currMaxTick || currMaxTick.value < extent[1]) ticks.push({
        value: extent[1],
        time: {
            level: 0,
            upperTimeUnit: extent1Unit,
            lowerTimeUnit: extent1Unit
        },
        notNice: true
    });
    return ticks;
}
var $8aa741ffc5165c6e$export$b0ab84ebd823da11 = function calcNiceForTimeScale(scale, opt) {
    var extent = scale.getExtent();
    // If extent start and end are same, expand them
    if (extent[0] === extent[1]) {
        // Expand extent
        extent[0] -= (0, $8a51e097d5164103$export$a97a1358cbb650ab);
        extent[1] += (0, $8a51e097d5164103$export$a97a1358cbb650ab);
    }
    // If there are no data and extent are [Infinity, -Infinity]
    if (extent[1] === -Infinity && extent[0] === Infinity) {
        var d = new Date();
        extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
        extent[0] = extent[1] - (0, $8a51e097d5164103$export$a97a1358cbb650ab);
    }
    scale.setExtent(extent[0], extent[1]);
    var splitNumber = (0, $f976678a0ff027db$export$b801ba4e5ad70a4a)(opt.splitNumber, 10);
    var approxInterval = (0, $fbe267606846f86c$export$9a49fe71267af794)(scale) / splitNumber;
    var minInterval = opt.minInterval;
    var maxInterval = opt.maxInterval;
    if (minInterval != null && approxInterval < minInterval) approxInterval = minInterval;
    if (maxInterval != null && approxInterval > maxInterval) approxInterval = maxInterval;
    var scaleIntervalsLen = $8aa741ffc5165c6e$var$scaleIntervals.length;
    var idx = Math.min($8aa741ffc5165c6e$var$bisect($8aa741ffc5165c6e$var$scaleIntervals, approxInterval, 0, scaleIntervalsLen), scaleIntervalsLen - 1);
    // Interval that can be used to calculate ticks
    var interval = $8aa741ffc5165c6e$var$scaleIntervals[idx][1];
    // Min level used when picking ticks from top down.
    // We check one more level to avoid the ticks are to sparse in some case.
    var minLevelUnit = $8aa741ffc5165c6e$var$scaleIntervals[Math.max(idx - 1, 0)][0];
    scale.setTimeInterval({
        approxInterval: approxInterval,
        interval: interval,
        minLevelUnit: minLevelUnit
    });
};
(0, $312aa5860ca73489$export$2e2bcd8739ae039).registerClass($8aa741ffc5165c6e$var$TimeScale);
var $8aa741ffc5165c6e$export$2e2bcd8739ae039 = $8aa741ffc5165c6e$var$TimeScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









var $dd7d73555eef9265$var$LOOKUP_IDX_EXTENT_START = 0;
var $dd7d73555eef9265$var$LOOKUP_IDX_EXTENT_END = 1;
var $dd7d73555eef9265$var$LOOKUP_IDX_BREAK_START = 2;
/**
 * @final NEVER inherit me!
 */ var $dd7d73555eef9265$var$LogScale = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(LogScale, _super);
    function LogScale(setting) {
        var _this = _super.call(this) || this;
        _this.type = 'log';
        _this.parse = (0, $9fa621e57136ea9d$export$2e2bcd8739ae039).parse;
        _this.base = setting.logBase || 10;
        var lookupFrom = [];
        var lookupTo = [];
        var lookup = _this._lookup = {
            from: lookupFrom,
            to: lookupTo
        };
        lookupFrom[$dd7d73555eef9265$var$LOOKUP_IDX_EXTENT_START] = lookupFrom[$dd7d73555eef9265$var$LOOKUP_IDX_EXTENT_END] = lookupTo[$dd7d73555eef9265$var$LOOKUP_IDX_EXTENT_START] = lookupTo[$dd7d73555eef9265$var$LOOKUP_IDX_EXTENT_END] = NaN;
        (0, $fbe267606846f86c$export$994b6d163a064f23)(_this, LogScale.mapperMethods);
        var scaleBreakHelper = (0, $cf43ca9fea251347$export$e79b20ac82c2d660)();
        var breakOption = setting.breakOption;
        var out = {
            lookup: lookup
        };
        if (scaleBreakHelper) scaleBreakHelper.parseAxisBreakOptionInwardTransform(breakOption, _this, {
            noNegative: true
        }, $dd7d73555eef9265$var$LOOKUP_IDX_BREAK_START, out);
        _this.powStub = new (0, $9fa621e57136ea9d$export$2e2bcd8739ae039)({
            breakParsed: out.original
        });
        _this.intervalStub = new (0, $9fa621e57136ea9d$export$2e2bcd8739ae039)({
            breakParsed: out.transformed
        });
        (0, $fbe267606846f86c$export$85c5c680f14cd13c)(_this, _this.intervalStub);
        return _this;
    }
    LogScale.prototype.getTicks = function(opt) {
        var base = this.base;
        var powStub = this.powStub;
        var scaleBreakHelper = (0, $cf43ca9fea251347$export$e79b20ac82c2d660)();
        var intervalStub = this.intervalStub;
        var intervalExtent = intervalStub.getExtent();
        var powExtent = powStub.getExtent();
        var powOpt = {
            lookup: {
                from: intervalExtent,
                to: powExtent
            }
        };
        return (0, $f16f2994a32ad273$export$871de8747c9eaa88)(intervalStub.getTicks(opt || {}), function(tick) {
            var val = tick.value;
            var powVal = (0, $f976678a0ff027db$export$73e21863d9c0dcd3)(val, base, powOpt);
            var vBreak;
            if (scaleBreakHelper) {
                var brkPowResult = scaleBreakHelper.getTicksBreakOutwardTransform(this, tick, (0, $cf43ca9fea251347$export$20734ee5f1d5720f)(powStub), this._lookup);
                if (brkPowResult) {
                    vBreak = brkPowResult.vBreak;
                    powVal = brkPowResult.tickVal;
                }
            }
            return {
                value: powVal,
                "break": vBreak
            };
        }, this);
    };
    LogScale.prototype.getMinorTicks = function(splitNumber) {
        return (0, $8429d6fe2076bff1$export$e2d43952c5db22bb)(this, splitNumber, (0, $cf43ca9fea251347$export$20734ee5f1d5720f)(this.powStub), // NOTE: minor ticks are in the log scale value to visually hint users "logarithm".
        this.intervalStub.getConfig().interval);
    };
    LogScale.prototype.getLabel = function(data, opt) {
        return this.intervalStub.getLabel(data, opt);
    };
    LogScale.type = 'log';
    LogScale.mapperMethods = {
        needTransform: function needTransform() {
            return true;
        },
        normalize: function normalize(val) {
            return this.intervalStub.normalize((0, $f976678a0ff027db$export$7854dd225b5d5704)(val, this.base));
        },
        scale: function scale(val) {
            // PENDING: Input `intervalStub.getExtent()` and `powStub.getExtent()` may
            // break monotonicity. Do not do it until real problems found.
            return (0, $f976678a0ff027db$export$73e21863d9c0dcd3)(this.intervalStub.scale(val), this.base, null);
        },
        transformIn: function transformIn(val, opt) {
            val = (0, $f976678a0ff027db$export$7854dd225b5d5704)(val, this.base);
            return opt && opt.depth === (0, $fbe267606846f86c$export$2734d952320c7be9) ? val : this.intervalStub.transformIn(val, opt);
        },
        transformOut: function transformOut(val, opt) {
            var depth = opt ? opt.depth : null;
            $dd7d73555eef9265$var$tmpTransformOutOpt1.depth = depth;
            $dd7d73555eef9265$var$tmpTransformOutOpt2.lookup = this._lookup;
            return (0, $f976678a0ff027db$export$73e21863d9c0dcd3)(depth === (0, $fbe267606846f86c$export$2734d952320c7be9) ? val : this.intervalStub.transformOut(val, $dd7d73555eef9265$var$tmpTransformOutOpt1), this.base, $dd7d73555eef9265$var$tmpTransformOutOpt2);
        },
        contain: function contain(val) {
            return this.powStub.contain(val);
        },
        /**
     * NOTICE: The caller should ensure `start` and `end` are both non-negative.
     */ setExtent: function setExtent(start, end) {
            this.setExtent2((0, $fbe267606846f86c$export$c884056e529a2c7a), start, end);
        },
        setExtent2: function setExtent2(kind, start, end) {
            if (!(0, $3fa81475350067fd$export$d386653f29930adb)(start, end) || start <= 0 || end <= 0) return;
            var lookupTo = $dd7d73555eef9265$var$tmpNotUsedArr;
            var lookupFrom = $dd7d73555eef9265$var$tmpNotUsedArr;
            if (kind === (0, $fbe267606846f86c$export$c884056e529a2c7a)) {
                var lookup = this._lookup;
                lookupTo = lookup.to;
                lookupFrom = lookup.from;
            }
            this.powStub.setExtent2(kind, lookupTo[$dd7d73555eef9265$var$LOOKUP_IDX_EXTENT_START] = start, lookupTo[$dd7d73555eef9265$var$LOOKUP_IDX_EXTENT_END] = end);
            var base = this.base;
            this.intervalStub.setExtent2(kind, lookupFrom[$dd7d73555eef9265$var$LOOKUP_IDX_EXTENT_START] = (0, $f976678a0ff027db$export$7854dd225b5d5704)(start, base), lookupFrom[$dd7d73555eef9265$var$LOOKUP_IDX_EXTENT_END] = (0, $f976678a0ff027db$export$7854dd225b5d5704)(end, base));
        },
        getFilter: function getFilter() {
            return {
                g: 0
            };
        },
        sanitize: function sanitize(value, dataExtent) {
            // Conservative - if dataExtent is invalid, do not sanitize.
            if ((0, $3fa81475350067fd$export$d386653f29930adb)(dataExtent[0], dataExtent[1]) && (0, $104896d282bd296f$export$b5c30d4208814a65)(value) && value <= 0) // `DataStore` has ensured that `dataExtent` is valid for LogScale.
            value = dataExtent[0];
            return value;
        },
        getDefaultStartValue: function getDefaultStartValue() {
            return 1;
        },
        getExtent: function getExtent() {
            return this.powStub.getExtent();
        },
        getExtentUnsafe: function getExtentUnsafe(kind, depth) {
            return depth === null ? this.powStub.getExtentUnsafe(kind, null) : this.intervalStub.getExtentUnsafe(kind, depth);
        }
    };
    return LogScale;
}((0, $312aa5860ca73489$export$2e2bcd8739ae039));
(0, $312aa5860ca73489$export$2e2bcd8739ae039).registerClass($dd7d73555eef9265$var$LogScale);
var $dd7d73555eef9265$var$tmpTransformOutOpt1 = {};
var $dd7d73555eef9265$var$tmpTransformOutOpt2 = {};
var $dd7d73555eef9265$var$tmpNotUsedArr = [];
var $dd7d73555eef9265$export$2e2bcd8739ae039 = $dd7d73555eef9265$var$LogScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $843eb76b26b69cec$export$2e0057d176d6f690 = {
    value: 1,
    category: 1,
    time: 1,
    log: 1
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $af0b4b5988d2bf1e$var$inner = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
var $af0b4b5988d2bf1e$var$dimTypeShort = {
    float: 'f',
    int: 'i',
    ordinal: 'o',
    number: 'n',
    time: 't'
};
/**
 * Represents the dimension requirement of a series.
 *
 * NOTICE:
 * When there are too many dimensions in dataset and many series, only the used dimensions
 * (i.e., used by coord sys and declared in `series.encode`) are add to `dimensionDefineList`.
 * But users may query data by other unused dimension names.
 * In this case, users can only query data if and only if they have defined dimension names
 * via ec option, so we provide `getDimensionIndexFromSource`, which only query them from
 * `source` dimensions.
 */ var $af0b4b5988d2bf1e$export$a1ef064685775f3e = /** @class */ function() {
    function SeriesDataSchema(opt) {
        this.dimensions = opt.dimensions;
        this._dimOmitted = opt.dimensionOmitted;
        this.source = opt.source;
        this._fullDimCount = opt.fullDimensionCount;
        this._updateDimOmitted(opt.dimensionOmitted);
    }
    SeriesDataSchema.prototype.isDimensionOmitted = function() {
        return this._dimOmitted;
    };
    SeriesDataSchema.prototype._updateDimOmitted = function(dimensionOmitted) {
        this._dimOmitted = dimensionOmitted;
        if (!dimensionOmitted) return;
        if (!this._dimNameMap) this._dimNameMap = $af0b4b5988d2bf1e$export$be39ae17310c33f7(this.source);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Get index by user defined dimension name (i.e., not internal generate name).
   * That is, get index from `dimensionsDefine`.
   * If no `dimensionsDefine`, or no name get, return -1.
   */ SeriesDataSchema.prototype.getSourceDimensionIndex = function(dimName) {
        return (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(this._dimNameMap.get(dimName), -1);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Notice: may return `null`/`undefined` if user not specify dimension names.
   */ SeriesDataSchema.prototype.getSourceDimension = function(dimIndex) {
        var dimensionsDefine = this.source.dimensionsDefine;
        if (dimensionsDefine) return dimensionsDefine[dimIndex];
    };
    SeriesDataSchema.prototype.makeStoreSchema = function() {
        var dimCount = this._fullDimCount;
        var willRetrieveDataByName = (0, $9cad8a8849680580$export$8911336b527f8517)(this.source);
        var makeHashStrict = !$af0b4b5988d2bf1e$export$238b87930d825d87(dimCount);
        // If source don't have dimensions or series don't omit unsed dimensions.
        // Generate from seriesDimList directly
        var dimHash = '';
        var dims = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < dimCount; fullDimIdx++){
            var property = void 0;
            var type = void 0;
            var ordinalMeta = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx];
            // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                property = willRetrieveDataByName ? seriesDimDef.name : null;
                type = seriesDimDef.type;
                ordinalMeta = seriesDimDef.ordinalMeta;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) {
                    property = willRetrieveDataByName ? sourceDimDef.name : null;
                    type = sourceDimDef.type;
                }
            }
            dims.push({
                property: property,
                type: type,
                ordinalMeta: ordinalMeta
            });
            // If retrieving data by index,
            //   use <index, type, ordinalMeta> to determine whether data can be shared.
            //   (Because in this case there might be no dimension name defined in dataset, but indices always exists).
            //   (Indices are always 0, 1, 2, ..., so we can ignore them to shorten the hash).
            // Otherwise if retrieving data by property name (like `data: [{aa: 123, bb: 765}, ...]`),
            //   use <property, type, ordinalMeta> in hash.
            if (willRetrieveDataByName && property != null && (!seriesDimDef || !seriesDimDef.isCalculationCoord)) dimHash += makeHashStrict ? property.replace(/\`/g, '`1').replace(/\$/g, '`2') : property;
            dimHash += '$';
            dimHash += $af0b4b5988d2bf1e$var$dimTypeShort[type] || 'f';
            if (ordinalMeta) dimHash += ordinalMeta.uid;
            dimHash += '$';
        }
        // Source from endpoint(usually series) will be read differently
        // when seriesLayoutBy or startIndex(which is affected by sourceHeader) are different.
        // So we use this three props as key.
        var source = this.source;
        var hash = [
            source.seriesLayoutBy,
            source.startIndex,
            dimHash
        ].join('$$');
        return {
            dimensions: dims,
            hash: hash
        };
    };
    SeriesDataSchema.prototype.makeOutputDimensionNames = function() {
        var result = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < this._fullDimCount; fullDimIdx++){
            var name_1 = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx];
            // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                if (!seriesDimDef.isCalculationCoord) name_1 = seriesDimDef.name;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) name_1 = sourceDimDef.name;
            }
            result.push(name_1);
        }
        return result;
    };
    SeriesDataSchema.prototype.appendCalculationDimension = function(dimDef) {
        this.dimensions.push(dimDef);
        dimDef.isCalculationCoord = true;
        this._fullDimCount++;
        // If append dimension on a data store, consider the store
        // might be shared by different series, series dimensions not
        // really map to store dimensions.
        this._updateDimOmitted(true);
    };
    return SeriesDataSchema;
}();
function $af0b4b5988d2bf1e$export$fafbc856132a3a0e(schema) {
    return schema instanceof $af0b4b5988d2bf1e$export$a1ef064685775f3e;
}
function $af0b4b5988d2bf1e$export$a477f5bebfd07944(dimsDef) {
    var dataDimNameMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
    for(var i = 0; i < (dimsDef || []).length; i++){
        var dimDefItemRaw = dimsDef[i];
        var userDimName = (0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(dimDefItemRaw) ? dimDefItemRaw.name : dimDefItemRaw;
        if (userDimName != null && dataDimNameMap.get(userDimName) == null) dataDimNameMap.set(userDimName, i);
    }
    return dataDimNameMap;
}
function $af0b4b5988d2bf1e$export$be39ae17310c33f7(source) {
    var innerSource = $af0b4b5988d2bf1e$var$inner(source);
    return innerSource.dimNameMap || (innerSource.dimNameMap = $af0b4b5988d2bf1e$export$a477f5bebfd07944(source.dimensionsDefine));
}
function $af0b4b5988d2bf1e$export$238b87930d825d87(dimCount) {
    return dimCount > 30;
}


function $eb1b70ae9d7aaef4$export$f2165f9e8499b278(seriesModel, dimensionsInput, opt) {
    opt = opt || {};
    var byIndex = opt.byIndex;
    var stackedCoordDimension = opt.stackedCoordDimension;
    var dimensionDefineList;
    var schema;
    var store;
    if ($eb1b70ae9d7aaef4$var$isLegacyDimensionsInput(dimensionsInput)) dimensionDefineList = dimensionsInput;
    else {
        schema = dimensionsInput.schema;
        dimensionDefineList = schema.dimensions;
        store = dimensionsInput.store;
    }
    // compatible: when `stack` is set as '', do not stack.
    var mayStack = !!(seriesModel && seriesModel.get('stack'));
    var stackedByDimInfo;
    var stackedDimInfo;
    var stackResultDimension;
    var stackedOverDimension;
    var allDimTypesAreNotOrdinalAndTime = true;
    function dimTypeIsNotOrdinalAndTime(dimensionInfo) {
        return dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time';
    }
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo, index) {
        if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(dimensionInfo)) dimensionDefineList[index] = dimensionInfo = {
            name: dimensionInfo
        };
        if (!dimTypeIsNotOrdinalAndTime(dimensionInfo)) allDimTypesAreNotOrdinalAndTime = false;
    });
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo, index) {
        if (mayStack && !dimensionInfo.isExtraCoord) {
            // Find the first ordinal dimension as the stackedByDimInfo.
            if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) stackedByDimInfo = dimensionInfo;
            // Find the first stackable dimension as the stackedDimInfo.
            if (!stackedDimInfo && dimTypeIsNotOrdinalAndTime(dimensionInfo) && (!allDimTypesAreNotOrdinalAndTime || dimensionInfo.coordDim !== 'x' && dimensionInfo.coordDim !== 'angle') && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) stackedDimInfo = dimensionInfo;
        }
    });
    if (stackedDimInfo && !byIndex && !stackedByDimInfo) // "Stack by data index" makes sense only if users provide carefully constructed data - any
    // mismatch or absence of data items can cause incorrect results. By "Stack by data index"
    // is more performant - no hashmap is required.
    // PENDING:
    //  Compatible with previous design, non-category axis ("value"/"log"/"time" axis) can only
    //  stack by index. "Stack by value" will not be supported until concrete requirements arise.
    byIndex = true;
    if (stackedDimInfo) {
        // Use a weird name that not duplicated with other names.
        // Also need to use seriesModel.id as postfix because different
        // series may share same data store. The stack dimension needs to be distinguished.
        stackResultDimension = '__\0ecstackresult_' + seriesModel.id;
        stackedOverDimension = '__\0ecstackedover_' + seriesModel.id;
        // Create inverted index to fast query index by value.
        if (stackedByDimInfo) stackedByDimInfo.createInvertedIndices = true;
        var stackedDimCoordDim_1 = stackedDimInfo.coordDim;
        var stackedDimType = stackedDimInfo.type;
        var stackedDimCoordIndex_1 = 0;
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo) {
            if (dimensionInfo.coordDim === stackedDimCoordDim_1) stackedDimCoordIndex_1++;
        });
        var stackedOverDimensionDefine = {
            name: stackResultDimension,
            coordDim: stackedDimCoordDim_1,
            coordDimIndex: stackedDimCoordIndex_1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length
        };
        var stackResultDimensionDefine = {
            name: stackedOverDimension,
            // This dimension contains stack base (generally, 0), so do not set it as
            // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
            coordDim: stackedOverDimension,
            coordDimIndex: stackedDimCoordIndex_1 + 1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length + 1
        };
        if (schema) {
            if (store) {
                stackedOverDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackedOverDimension, stackedDimType);
                stackResultDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackResultDimension, stackedDimType);
            }
            schema.appendCalculationDimension(stackedOverDimensionDefine);
            schema.appendCalculationDimension(stackResultDimensionDefine);
        } else {
            dimensionDefineList.push(stackedOverDimensionDefine);
            dimensionDefineList.push(stackResultDimensionDefine);
        }
    }
    return {
        stackedDimension: stackedDimInfo && stackedDimInfo.name,
        stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
        isStackedByIndex: byIndex,
        stackedOverDimension: stackedOverDimension,
        stackResultDimension: stackResultDimension
    };
}
function $eb1b70ae9d7aaef4$var$isLegacyDimensionsInput(dimensionsInput) {
    return !(0, $af0b4b5988d2bf1e$export$fafbc856132a3a0e)(dimensionsInput.schema);
}
function $eb1b70ae9d7aaef4$export$1dedc39359ae35c(data, stackedDim) {
    // Each single series only maps to one pair of axis. So we do not need to
    // check stackByDim, whatever stacked by a dimension or stacked by index.
    return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension');
}
function $eb1b70ae9d7aaef4$export$909db2be4938fbdf(data, targetDim) {
    return $eb1b70ae9d7aaef4$export$1dedc39359ae35c(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
}









var $5197eaeff9ee5dfb$var$axisInner = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
function $5197eaeff9ee5dfb$export$a0edf4de19b45ee7(model) {
    var type = model.get('type');
    if (// In ec option, `xxxAxis.type` may be undefined.
    type == null || !$f16f2994a32ad273$export$b5a638e9b3fff9f3((0, $843eb76b26b69cec$export$2e0057d176d6f690), type) && !(0, $312aa5860ca73489$export$2e2bcd8739ae039).getClass(type)) type = 'value';
    return type;
}
function $5197eaeff9ee5dfb$export$8941c4cacdc8f5a5(model, type, coordSysSupportAxisBreaks) {
    var breakHelper = (0, $cf43ca9fea251347$export$e79b20ac82c2d660)();
    var breakOption;
    if (breakHelper) breakOption = $5197eaeff9ee5dfb$export$8094779d9b724f85(model, type, coordSysSupportAxisBreaks);
    switch(type){
        case 'category':
            return new (0, $2fa2d25936823f26$export$2e2bcd8739ae039)({
                ordinalMeta: model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(),
                extent: (0, $3fa81475350067fd$export$62e5f07ab009f3b)()
            });
        case 'time':
            return new (0, $8aa741ffc5165c6e$export$2e2bcd8739ae039)({
                locale: model.ecModel.getLocaleModel(),
                useUTC: model.ecModel.get('useUTC'),
                breakOption: breakOption
            });
        case 'log':
            // See also #3749
            return new (0, $dd7d73555eef9265$export$2e2bcd8739ae039)({
                logBase: model.get('logBase'),
                breakOption: breakOption
            });
        case 'value':
            return new (0, $9fa621e57136ea9d$export$2e2bcd8739ae039)({
                breakOption: breakOption
            });
        default:
            // case others.
            return new ((0, $312aa5860ca73489$export$2e2bcd8739ae039).getClass(type) || (0, $9fa621e57136ea9d$export$2e2bcd8739ae039))({});
    }
}
function $5197eaeff9ee5dfb$export$99e0963eefdef8b2(scale, value, considerMappingExtent) {
    var dataExtent = considerMappingExtent ? (0, $fbe267606846f86c$export$e182c528b7826102)(scale, null) : scale.getExtentUnsafe((0, $fbe267606846f86c$export$c884056e529a2c7a), null);
    var min = dataExtent[0];
    var max = dataExtent[1];
    return !(0, $3fa81475350067fd$export$d386653f29930adb)(min, max) ? $5197eaeff9ee5dfb$export$8b1206c1406788fd : min === value || max === value ? $5197eaeff9ee5dfb$export$d0bab53331033bdf : min < value && max > value ? $5197eaeff9ee5dfb$export$18028792a61d93c4 : $5197eaeff9ee5dfb$export$8b1206c1406788fd;
}
var $5197eaeff9ee5dfb$export$18028792a61d93c4 = 1;
var $5197eaeff9ee5dfb$export$d0bab53331033bdf = 2;
var $5197eaeff9ee5dfb$export$8b1206c1406788fd = 3;
function $5197eaeff9ee5dfb$export$3a3942ca9637d423(axis) {
    $5197eaeff9ee5dfb$var$axisInner(axis).noOnMyZero = true;
}
function $5197eaeff9ee5dfb$export$2204fb02f43463b7(axis) {
    return $5197eaeff9ee5dfb$var$axisInner(axis).noOnMyZero;
}
function $5197eaeff9ee5dfb$export$742f19a75415b2ae(axis) {
    var labelFormatter = axis.getLabelModel().get('formatter');
    if (axis.type === 'time') {
        var parsed_1 = (0, $8a51e097d5164103$export$f16a827770bdffb5)(labelFormatter);
        return function(tick, idx) {
            return axis.scale.getFormattedLabel(tick, idx, parsed_1);
        };
    } else if ($f16f2994a32ad273$export$844ec244b1367d54(labelFormatter)) return function(tick) {
        // For category axis, get raw value; for numeric axis,
        // get formatted label like '1,333,444'.
        var label = axis.scale.getLabel(tick);
        var text = labelFormatter.replace('{value}', label != null ? label : '');
        return text;
    };
    else if ($f16f2994a32ad273$export$f6e2535fb5126e54(labelFormatter)) {
        if (axis.type === 'category') return function(tick, idx) {
            // The original intention of `idx` is "the index of the tick in all ticks".
            // But the previous implementation of category axis do not consider the
            // `axisLabel.interval`, which cause that, for example, the `interval` is
            // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
            // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
            // the definition here for back compatibility.
            return labelFormatter($5197eaeff9ee5dfb$export$a5a32f324c1fa457(axis, tick), tick.value - axis.scale.getExtent()[0], null // Using `null` just for backward compat.
            );
        };
        var scaleBreakHelper_1 = (0, $cf43ca9fea251347$export$e79b20ac82c2d660)();
        return function(tick, idx) {
            // Using `null` just for backward compat. It's been found that in the `test/axis-customTicks.html`,
            // there is a formatter `function (value, index, revers = true) { ... }`. Although the third param
            // `revers` is incorrect and always `null`, changing it might introduce a breaking change.
            var extra = null;
            if (scaleBreakHelper_1) extra = scaleBreakHelper_1.makeAxisLabelFormatterParamBreak(extra, tick["break"]);
            return labelFormatter($5197eaeff9ee5dfb$export$a5a32f324c1fa457(axis, tick), idx, extra);
        };
    } else return function(tick) {
        return axis.scale.getLabel(tick);
    };
}
function $5197eaeff9ee5dfb$export$a5a32f324c1fa457(axis, tick) {
    // In category axis with data zoom, tick is not the original
    // index of axis.data. So tick should not be exposed to user
    // in category axis.
    var scale = axis.scale;
    return (0, $f976678a0ff027db$export$61579433626afe87)(scale) ? scale.getLabel(tick) : tick.value;
}
function $5197eaeff9ee5dfb$export$6d0bc2429155c088(model) {
    var interval = model.get('interval');
    return interval == null ? 'auto' : interval;
}
function $5197eaeff9ee5dfb$export$c2911c025243d6a6(axis) {
    return axis.type === 'category' && $5197eaeff9ee5dfb$export$6d0bc2429155c088(axis.getLabelModel()) === 0;
}
function $5197eaeff9ee5dfb$export$e4cf30b1e74cd69d(data, axisDim) {
    // Remove duplicated dat dimensions caused by `getStackedDimension`.
    var dataDimMap = {};
    // Currently `mapDimensionsAll` will contain stack result dimension ('__\0ecstackresult').
    // PENDING: is it reasonable? Do we need to remove the original dim from "coord dim" since
    // there has been stacked result dim?
    $f16f2994a32ad273$export$79b2f7037acddd43(data.mapDimensionsAll(axisDim), function(dataDim) {
        // For example, the extent of the original dimension
        // is [0.1, 0.5], the extent of the `stackResultDimension`
        // is [7, 9], the final extent should NOT include [0.1, 0.5],
        // because there is no graphic corresponding to [0.1, 0.5].
        // See the case in `test/area-stack.html` `main1`, where area line
        // stack needs `yAxis` not start from 0.
        dataDimMap[(0, $eb1b70ae9d7aaef4$export$909db2be4938fbdf)(data, dataDim)] = true;
    });
    return $f16f2994a32ad273$export$ed97f33186d4b816(dataDimMap);
}
function $5197eaeff9ee5dfb$export$c06aa22293dea9d2(nameLocation) {
    return nameLocation === 'middle' || nameLocation === 'center';
}
function $5197eaeff9ee5dfb$export$75b737736393e03c(axisModel) {
    return axisModel.getShallow('show');
}
function $5197eaeff9ee5dfb$export$8094779d9b724f85(model, axisType, coordSysSupportAxisBreaks) {
    var option = model.get('breaks', true);
    if (option != null) {
        if (!(0, $cf43ca9fea251347$export$e79b20ac82c2d660)()) return undefined;
        if (!coordSysSupportAxisBreaks || !$5197eaeff9ee5dfb$var$isAxisTypeSupportAxisBreak(axisType)) {
            var axisInfo;
            return undefined;
        }
        return option;
    }
}
function $5197eaeff9ee5dfb$var$isAxisTypeSupportAxisBreak(axisType) {
    return axisType !== 'category';
}
function $5197eaeff9ee5dfb$export$8135db7762247d65(scale, fixMinMax, oldIntervalExtent, newIntervalExtent, oldOutermostExtent, cfg) {
    var isTargetLogScale = (0, $f976678a0ff027db$export$8b1d8a59aa13c502)(scale);
    var intervalStub = isTargetLogScale ? scale.intervalStub : scale;
    intervalStub.setExtent(newIntervalExtent[0], newIntervalExtent[1]);
    if (isTargetLogScale) {
        // Sync intervalStub extent to the outermost extent (i.e., `powStub` for `LogScale`).
        var powStub = scale.powStub;
        var opt = {
            depth: (0, $fbe267606846f86c$export$2734d952320c7be9)
        };
        var minPow = scale.transformOut(newIntervalExtent[0], opt);
        var maxPow = scale.transformOut(newIntervalExtent[1], opt);
        // Log transform is probably not inversible by rounding error, which causes min/max tick may be
        // displayed as `5.999999999999999` unexpectedly when min/max are required to be fixed (specified
        // by users or by dataZoom). Therefore we set `powStub` with respect to `oldOutermostExtent` if
        // interval extent is not changed. But `intervalStub` should not be inversely changed by this
        // handling, otherwise its monotonicity between `niceExtent` and `extent` may be broken and cause
        // unexpected ticks generation.
        var extentChanged = (0, $f976678a0ff027db$export$2b240c817ac5c4f)(oldIntervalExtent, newIntervalExtent);
        // NOTE: extent may still be changed even when min/max are required to be fixed,
        // e.g., by `intervalScaleEnsureValidExtent`.
        if (fixMinMax[0] && !extentChanged[0]) minPow = oldOutermostExtent[0];
        if (fixMinMax[1] && !extentChanged[1]) maxPow = oldOutermostExtent[1];
        powStub.setExtent(minPow, maxPow);
    }
    intervalStub.setConfig(cfg);
}
function $5197eaeff9ee5dfb$export$889d2956111fd257(scale, tick) {
    return (0, $f976678a0ff027db$export$61579433626afe87)(scale) ? scale.getRawOrdinalNumber(tick.value) : tick.value;
}
function $5197eaeff9ee5dfb$export$43d51f65881fb080(scale, axisModel) {
    return (0, $f976678a0ff027db$export$61579433626afe87)(scale) && !!axisModel.get('boundaryGap');
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $49e8be5a460de8c7$var$LABEL_LAYOUT_BASE_PROPS = [
    'label',
    'labelLine',
    'layoutOption',
    'priority',
    'defaultAttr',
    'marginForce',
    'minMarginForce',
    'marginDefault',
    'suggestIgnore'
];
var $49e8be5a460de8c7$var$LABEL_LAYOUT_DIRTY_BIT_OTHERS = 1;
var $49e8be5a460de8c7$var$LABEL_LAYOUT_DIRTY_BIT_OBB = 2;
var $49e8be5a460de8c7$var$LABEL_LAYOUT_DIRTY_ALL = $49e8be5a460de8c7$var$LABEL_LAYOUT_DIRTY_BIT_OTHERS | $49e8be5a460de8c7$var$LABEL_LAYOUT_DIRTY_BIT_OBB;
function $49e8be5a460de8c7$export$1551ece3f059eafb(labelGeometry, dirtyOrClear, dirtyBits) {
    dirtyBits = dirtyBits || $49e8be5a460de8c7$var$LABEL_LAYOUT_DIRTY_ALL;
    dirtyOrClear ? labelGeometry.dirty |= dirtyBits : labelGeometry.dirty &= ~dirtyBits;
}
function $49e8be5a460de8c7$var$isLabelLayoutDirty(labelGeometry, dirtyBits) {
    dirtyBits = dirtyBits || $49e8be5a460de8c7$var$LABEL_LAYOUT_DIRTY_ALL;
    return labelGeometry.dirty == null || !!(labelGeometry.dirty & dirtyBits);
}
function $49e8be5a460de8c7$export$471916f4e89eb5da(labelLayout) {
    if (!labelLayout) return;
    if ($49e8be5a460de8c7$var$isLabelLayoutDirty(labelLayout)) $49e8be5a460de8c7$export$af9bffc2d00de2cc(labelLayout, labelLayout.label, labelLayout);
    return labelLayout;
}
function $49e8be5a460de8c7$export$af9bffc2d00de2cc(out, label, opt) {
    // [CAUTION] These props may be modified directly for performance consideration,
    //  therefore, do not output the internal data structure of zrender Element.
    var rawTransform = label.getComputedTransform();
    out.transform = (0, $bce1f681c7fb2581$export$4d61283a070e0362)(out.transform, rawTransform);
    // NOTE: should call `getBoundingRect` after `getComputedTransform`, or may get an inaccurate bounding rect.
    //  The reason is that `getComputedTransform` calls `__host.updateInnerText()` internally, which updates the label
    //  by `textConfig` mounted on the host.
    // PENDING: add a dirty bit for that in zrender?
    var outLocalRect = out.localRect = (0, $bce1f681c7fb2581$export$38128dfd9a498e1)(out.localRect, label.getBoundingRect());
    var labelStyleExt = label.style;
    var margin = labelStyleExt.margin;
    var marginForce = opt && opt.marginForce;
    var minMarginForce = opt && opt.minMarginForce;
    var marginDefault = opt && opt.marginDefault;
    var marginType = labelStyleExt.__marginType;
    if (marginType == null && marginDefault) {
        margin = marginDefault;
        marginType = (0, $1ee9c8b909b7ca82$export$2b18df2bc75ae422).textMargin;
    }
    // `textMargin` and `minMargin` can not exist both.
    for(var i = 0; i < 4; i++)$49e8be5a460de8c7$var$_tmpLabelMargin[i] = marginType === (0, $1ee9c8b909b7ca82$export$2b18df2bc75ae422).minMargin && minMarginForce && minMarginForce[i] != null ? minMarginForce[i] : marginForce && marginForce[i] != null ? marginForce[i] : margin ? margin[i] : 0;
    if (marginType === (0, $1ee9c8b909b7ca82$export$2b18df2bc75ae422).textMargin) (0, $bce1f681c7fb2581$export$81ed941fdeb91c7c)(outLocalRect, $49e8be5a460de8c7$var$_tmpLabelMargin, false, false);
    var outGlobalRect = out.rect = (0, $bce1f681c7fb2581$export$38128dfd9a498e1)(out.rect, outLocalRect);
    if (rawTransform) outGlobalRect.applyTransform(rawTransform);
    // Notice: label.style.margin is actually `minMargin / 2`, handled by `setTextStyleCommon`.
    if (marginType === (0, $1ee9c8b909b7ca82$export$2b18df2bc75ae422).minMargin) (0, $bce1f681c7fb2581$export$81ed941fdeb91c7c)(outGlobalRect, $49e8be5a460de8c7$var$_tmpLabelMargin, false, false);
    out.axisAligned = (0, $bce1f681c7fb2581$export$576610ccf2234b72)(rawTransform);
    (out.label = out.label || {}).ignore = label.ignore;
    $49e8be5a460de8c7$export$1551ece3f059eafb(out, false);
    $49e8be5a460de8c7$export$1551ece3f059eafb(out, true, $49e8be5a460de8c7$var$LABEL_LAYOUT_DIRTY_BIT_OBB);
    // Do not remove `obb` (if existing) for reuse, just reset the dirty bit.
    return out;
}
var $49e8be5a460de8c7$var$_tmpLabelMargin = [
    0,
    0,
    0,
    0
];
function $49e8be5a460de8c7$export$bc37ae3f8412d105(out, rawLocalRect, rawTransform) {
    out.transform = (0, $bce1f681c7fb2581$export$4d61283a070e0362)(out.transform, rawTransform);
    out.localRect = (0, $bce1f681c7fb2581$export$38128dfd9a498e1)(out.localRect, rawLocalRect);
    out.rect = (0, $bce1f681c7fb2581$export$38128dfd9a498e1)(out.rect, rawLocalRect);
    if (rawTransform) out.rect.applyTransform(rawTransform);
    out.axisAligned = (0, $bce1f681c7fb2581$export$576610ccf2234b72)(rawTransform);
    out.obb = undefined; // Reset to undefined, will be created by `ensureOBB` when using.
    (out.label = out.label || {}).ignore = false;
    return out;
}
function $49e8be5a460de8c7$export$91f733c27ab0712f(labelLayout, offset) {
    if (!labelLayout) return;
    labelLayout.label.x += offset.x;
    labelLayout.label.y += offset.y;
    labelLayout.label.markRedraw();
    var transform = labelLayout.transform;
    if (transform) {
        transform[4] += offset.x;
        transform[5] += offset.y;
    }
    var globalRect = labelLayout.rect;
    if (globalRect) {
        globalRect.x += offset.x;
        globalRect.y += offset.y;
    }
    var obb = labelLayout.obb;
    if (obb) obb.fromBoundingRect(labelLayout.localRect, transform);
}
function $49e8be5a460de8c7$export$a1cfd37e9b88106b(newBaseWithDefaults, source) {
    for(var i = 0; i < $49e8be5a460de8c7$var$LABEL_LAYOUT_BASE_PROPS.length; i++){
        var prop = $49e8be5a460de8c7$var$LABEL_LAYOUT_BASE_PROPS[i];
        if (newBaseWithDefaults[prop] == null) newBaseWithDefaults[prop] = source[prop];
    }
    return $49e8be5a460de8c7$export$471916f4e89eb5da(newBaseWithDefaults);
}
/**
 * Create obb if no one, can cache it.
 */ function $49e8be5a460de8c7$var$ensureOBB(labelGeometry) {
    var obb = labelGeometry.obb;
    if (!obb || $49e8be5a460de8c7$var$isLabelLayoutDirty(labelGeometry, $49e8be5a460de8c7$var$LABEL_LAYOUT_DIRTY_BIT_OBB)) {
        labelGeometry.obb = obb = obb || new (0, $4498ebf6c695fdf7$export$2e2bcd8739ae039)();
        obb.fromBoundingRect(labelGeometry.localRect, labelGeometry.transform);
        $49e8be5a460de8c7$export$1551ece3f059eafb(labelGeometry, false, $49e8be5a460de8c7$var$LABEL_LAYOUT_DIRTY_BIT_OBB);
    }
    return obb;
}
function $49e8be5a460de8c7$export$73ee08bc808f6f3f(list, xyDimIdx, // 0 for x, 1 for y
minBound, // for x, leftBound; for y, topBound
maxBound, // for x, rightBound; for y, bottomBound
// If average the shifts on all labels and add them to 0
// TODO: Not sure if should enable it.
// Pros: The angle of lines will distribute more equally
// Cons: In some layout. It may not what user wanted. like in pie. the label of last sector is usually changed unexpectedly.
balanceShift) {
    var len = list.length;
    var xyDim = (0, $bce1f681c7fb2581$export$cb4c12294149dd2d)[xyDimIdx];
    var sizeDim = (0, $bce1f681c7fb2581$export$a3fe6d967173a3ac)[xyDimIdx];
    if (len < 2) return false;
    list.sort(function(a, b) {
        return a.rect[xyDim] - b.rect[xyDim];
    });
    var lastPos = 0;
    var delta;
    var adjusted = false;
    // const shifts = [];
    var totalShifts = 0;
    for(var i = 0; i < len; i++){
        var item = list[i];
        var rect = item.rect;
        delta = rect[xyDim] - lastPos;
        if (delta < 0) {
            // shiftForward(i, len, -delta);
            rect[xyDim] -= delta;
            item.label[xyDim] -= delta;
            adjusted = true;
        }
        var shift = Math.max(-delta, 0);
        // shifts.push(shift);
        totalShifts += shift;
        lastPos = rect[xyDim] + rect[sizeDim];
    }
    if (totalShifts > 0 && balanceShift) // Shift back to make the distribution more equally.
    shiftList(-totalShifts / len, 0, len);
    // TODO bleedMargin?
    var first = list[0];
    var last = list[len - 1];
    var minGap;
    var maxGap;
    updateMinMaxGap();
    // If ends exceed two bounds, squeeze at most 80%, then take the gap of two bounds.
    minGap < 0 && squeezeGaps(-minGap, 0.8);
    maxGap < 0 && squeezeGaps(maxGap, 0.8);
    updateMinMaxGap();
    takeBoundsGap(minGap, maxGap, 1);
    takeBoundsGap(maxGap, minGap, -1);
    // Handle bailout when there is not enough space.
    updateMinMaxGap();
    if (minGap < 0) squeezeWhenBailout(-minGap);
    if (maxGap < 0) squeezeWhenBailout(maxGap);
    function updateMinMaxGap() {
        minGap = first.rect[xyDim] - minBound;
        maxGap = maxBound - last.rect[xyDim] - last.rect[sizeDim];
    }
    function takeBoundsGap(gapThisBound, gapOtherBound, moveDir) {
        if (gapThisBound < 0) {
            // Move from other gap if can.
            var moveFromMaxGap = Math.min(gapOtherBound, -gapThisBound);
            if (moveFromMaxGap > 0) {
                shiftList(moveFromMaxGap * moveDir, 0, len);
                var remained = moveFromMaxGap + gapThisBound;
                if (remained < 0) squeezeGaps(-remained * moveDir, 1);
            } else squeezeGaps(-gapThisBound * moveDir, 1);
        }
    }
    function shiftList(delta, start, end) {
        if (delta !== 0) adjusted = true;
        for(var i = start; i < end; i++){
            var item = list[i];
            var rect = item.rect;
            rect[xyDim] += delta;
            item.label[xyDim] += delta;
        }
    }
    // Squeeze gaps if the labels exceed margin.
    function squeezeGaps(delta, maxSqeezePercent) {
        var gaps = [];
        var totalGaps = 0;
        for(var i = 1; i < len; i++){
            var prevItemRect = list[i - 1].rect;
            var gap = Math.max(list[i].rect[xyDim] - prevItemRect[xyDim] - prevItemRect[sizeDim], 0);
            gaps.push(gap);
            totalGaps += gap;
        }
        if (!totalGaps) return;
        var squeezePercent = Math.min(Math.abs(delta) / totalGaps, maxSqeezePercent);
        if (delta > 0) for(var i = 0; i < len - 1; i++){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i] * squeezePercent;
            // Forward
            shiftList(movement, 0, i + 1);
        }
        else // Backward
        for(var i = len - 1; i > 0; i--){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i - 1] * squeezePercent;
            shiftList(-movement, i, len);
        }
    }
    /**
   * Squeeze to allow overlap if there is no more space available.
   * Let other overlapping strategy like hideOverlap do the job instead of keep exceeding the bounds.
   */ function squeezeWhenBailout(delta) {
        var dir = delta < 0 ? -1 : 1;
        delta = Math.abs(delta);
        var moveForEachLabel = Math.ceil(delta / (len - 1));
        for(var i = 0; i < len - 1; i++){
            if (dir > 0) // Forward
            shiftList(moveForEachLabel, 0, i + 1);
            else // Backward
            shiftList(-moveForEachLabel, len - i - 1, len);
            delta -= moveForEachLabel;
            if (delta <= 0) return;
        }
    }
    return adjusted;
}
function $49e8be5a460de8c7$export$ff775ae4fbb23435(labelList) {
    for(var i = 0; i < labelList.length; i++){
        var labelItem = labelList[i];
        var defaultAttr = labelItem.defaultAttr;
        var labelLine = labelItem.labelLine;
        labelItem.label.attr('ignore', defaultAttr.ignore);
        labelLine && labelLine.attr('ignore', defaultAttr.labelGuideIgnore);
    }
}
function $49e8be5a460de8c7$export$8ce774e164a49410(labelList) {
    var displayedLabels = [];
    // TODO, render overflow visible first, put in the displayedLabels.
    labelList.sort(function(a, b) {
        return (b.suggestIgnore ? 1 : 0) - (a.suggestIgnore ? 1 : 0) || b.priority - a.priority;
    });
    function hideEl(el) {
        if (!el.ignore) {
            // Show on emphasis.
            var emphasisState = el.ensureState('emphasis');
            if (emphasisState.ignore == null) emphasisState.ignore = false;
        }
        el.ignore = true;
    }
    for(var i = 0; i < labelList.length; i++){
        var labelItem = $49e8be5a460de8c7$export$471916f4e89eb5da(labelList[i]);
        // The current `el.ignore` is involved, since some previous overlap
        // resolving strategies may have set `el.ignore` to true.
        if (labelItem.label.ignore) continue;
        var label = labelItem.label;
        var labelLine = labelItem.labelLine;
        // NOTICE: even when the with/height of globalRect of a label is 0, the label line should
        // still be displayed, since we should follow the concept of "truncation", meaning that
        // something exists even if it cannot be fully displayed. A visible label line is necessary
        // to allow users to get a tooltip with label info on hover.
        var overlapped = false;
        for(var j = 0; j < displayedLabels.length; j++)if ($49e8be5a460de8c7$export$f28bfabef115ba96(labelItem, displayedLabels[j], null, {
            touchThreshold: 0.05
        })) {
            overlapped = true;
            break;
        }
        // TODO Callback to determine if this overlap should be handled?
        if (overlapped) {
            hideEl(label);
            labelLine && hideEl(labelLine);
        } else displayedLabels.push(labelItem);
    }
}
function $49e8be5a460de8c7$export$f28bfabef115ba96(baseLayoutInfo, targetLayoutInfo, mtv, intersectOpt) {
    if (!baseLayoutInfo || !targetLayoutInfo) return false;
    if (baseLayoutInfo.label && baseLayoutInfo.label.ignore || targetLayoutInfo.label && targetLayoutInfo.label.ignore) return false;
    // Fast rejection.
    if (!baseLayoutInfo.rect.intersect(targetLayoutInfo.rect, mtv, intersectOpt)) return false;
    if (baseLayoutInfo.axisAligned && targetLayoutInfo.axisAligned) return true; // obb is the same as the normal bounding rect.
    return $49e8be5a460de8c7$var$ensureOBB(baseLayoutInfo).intersect($49e8be5a460de8c7$var$ensureOBB(targetLayoutInfo), mtv, intersectOpt);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $fc815de52b491ed4$var$_impl = null;
function $fc815de52b491ed4$export$f5ec8c7ef7a59f4c(impl) {
    if (!$fc815de52b491ed4$var$_impl) $fc815de52b491ed4$var$_impl = impl;
}
function $fc815de52b491ed4$export$c1d9b2cc33e7e5e() {
    return $fc815de52b491ed4$var$_impl;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $1365515cace27ec6$export$12319e2083cd71ce = 'expandAxisBreak';
var $1365515cace27ec6$export$8ba710d11f5d9b28 = 'collapseAxisBreak';
var $1365515cace27ec6$export$cfaa507333440c5e = 'toggleAxisBreak';
var $1365515cace27ec6$var$AXIS_BREAK_CHANGED_EVENT_TYPE = 'axisbreakchanged';
var $1365515cace27ec6$var$expandAxisBreakActionInfo = {
    type: $1365515cace27ec6$export$12319e2083cd71ce,
    event: $1365515cace27ec6$var$AXIS_BREAK_CHANGED_EVENT_TYPE,
    update: 'update',
    refineEvent: $1365515cace27ec6$var$refineAxisBreakChangeEvent
};
var $1365515cace27ec6$var$collapseAxisBreakActionInfo = {
    type: $1365515cace27ec6$export$8ba710d11f5d9b28,
    event: $1365515cace27ec6$var$AXIS_BREAK_CHANGED_EVENT_TYPE,
    update: 'update',
    refineEvent: $1365515cace27ec6$var$refineAxisBreakChangeEvent
};
var $1365515cace27ec6$var$toggleAxisBreakActionInfo = {
    type: $1365515cace27ec6$export$cfaa507333440c5e,
    event: $1365515cace27ec6$var$AXIS_BREAK_CHANGED_EVENT_TYPE,
    update: 'update',
    refineEvent: $1365515cace27ec6$var$refineAxisBreakChangeEvent
};
function $1365515cace27ec6$var$refineAxisBreakChangeEvent(actionResultBatch, payload, ecModel, api) {
    var breaks = [];
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(actionResultBatch, function(actionResult) {
        breaks = breaks.concat(actionResult.eventBreaks);
    });
    return {
        eventContent: {
            breaks: breaks
        }
    };
}
function $1365515cace27ec6$export$408c24786cd729c6(registers) {
    registers.registerAction($1365515cace27ec6$var$expandAxisBreakActionInfo, actionHandler);
    registers.registerAction($1365515cace27ec6$var$collapseAxisBreakActionInfo, actionHandler);
    registers.registerAction($1365515cace27ec6$var$toggleAxisBreakActionInfo, actionHandler);
    function actionHandler(payload, ecModel) {
        var eventBreaks = [];
        var finderResult = (0, $3fa81475350067fd$export$95de80076abac814)(ecModel, payload);
        function dealUpdate(modelProp, indexProp) {
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)(finderResult[modelProp], function(axisModel) {
                var result = axisModel.updateAxisBreaks(payload);
                (0, $f16f2994a32ad273$export$79b2f7037acddd43)(result.breaks, function(item) {
                    var _a;
                    eventBreaks.push((0, $f16f2994a32ad273$export$ebe90cb607ad99e)((_a = {}, _a[indexProp] = axisModel.componentIndex, _a), item));
                });
            });
        }
        dealUpdate('xAxisModels', 'xAxisIndex');
        dealUpdate('yAxisModels', 'yAxisIndex');
        dealUpdate('singleAxisModels', 'singleAxisIndex');
        return {
            eventBreaks: eventBreaks
        };
    }
}






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $08a2e2b0d4c9ee4c$var$modelInner = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
var $08a2e2b0d4c9ee4c$var$axisInner = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
var $08a2e2b0d4c9ee4c$export$31cba7db0a663292 = {
    estimate: 1,
    determine: 2
};
function $08a2e2b0d4c9ee4c$export$12d6ac38274c43e7(kind) {
    return {
        out: {
            noPxChangeTryDetermine: []
        },
        kind: kind
    };
}
function $08a2e2b0d4c9ee4c$export$10216ebd3e3e485e(axis, ctx) {
    var custom = axis.getLabelModel().get('customValues');
    if (custom) {
        var scale_1 = axis.scale;
        return {
            labels: $f16f2994a32ad273$export$871de8747c9eaa88($08a2e2b0d4c9ee4c$var$parseTickLabelCustomValues(custom, scale_1), function(tick, index) {
                return {
                    formattedLabel: (0, $5197eaeff9ee5dfb$export$742f19a75415b2ae)(axis)(tick, index),
                    rawLabel: scale_1.getLabel(tick),
                    tick: tick
                };
            })
        };
    }
    // Only ordinal scale support tick interval
    return axis.type === 'category' ? $08a2e2b0d4c9ee4c$var$makeCategoryLabels(axis, ctx) : $08a2e2b0d4c9ee4c$var$makeRealNumberLabels(axis);
}
function $08a2e2b0d4c9ee4c$export$7cccf6836ae8323c(axis, tickModel, opt) {
    var scale = axis.scale;
    var custom = axis.getTickModel().get('customValues');
    if (custom) return {
        ticks: $08a2e2b0d4c9ee4c$var$parseTickLabelCustomValues(custom, scale)
    };
    // Only ordinal scale support tick interval
    return axis.type === 'category' ? $08a2e2b0d4c9ee4c$var$makeCategoryTicks(axis, tickModel) : {
        ticks: scale.getTicks(opt)
    };
}
function $08a2e2b0d4c9ee4c$var$parseTickLabelCustomValues(customValues, scale) {
    var extent = scale.getExtent();
    var tickNumbers = [];
    $f16f2994a32ad273$export$79b2f7037acddd43(customValues, function(val) {
        val = scale.parse(val);
        if (val >= extent[0] && val <= extent[1]) tickNumbers.push(val);
    });
    (0, $3fa81475350067fd$export$2e2262a44ac61957)(tickNumbers, (0, $3fa81475350067fd$export$fec5e8fdd97d769b), null);
    (0, $104896d282bd296f$export$debe6e778e0a6d32)(tickNumbers);
    return $f16f2994a32ad273$export$871de8747c9eaa88(tickNumbers, function(tickVal) {
        return {
            value: tickVal
        };
    });
}
function $08a2e2b0d4c9ee4c$var$makeCategoryLabels(axis, ctx) {
    var labelModel = axis.getLabelModel();
    var result = $08a2e2b0d4c9ee4c$var$makeCategoryLabelsActually(axis, labelModel, ctx);
    return !labelModel.get('show') || axis.scale.isBlank() ? {
        labels: []
    } : result;
}
function $08a2e2b0d4c9ee4c$var$makeCategoryLabelsActually(axis, labelModel, ctx) {
    var labelsCache = $08a2e2b0d4c9ee4c$var$ensureCategoryLabelCache(axis);
    var optionLabelInterval = (0, $5197eaeff9ee5dfb$export$6d0bc2429155c088)(labelModel);
    var isEstimate = ctx.kind === $08a2e2b0d4c9ee4c$export$31cba7db0a663292.estimate;
    // In AxisTickLabelComputingKind.estimate, the result likely varies during a single
    // pass of ec main process,due to the change of axisExtent, and will not be shared with
    // splitLine. Therefore no cache is used.
    if (!isEstimate) {
        // PENDING: check necessary?
        var result_1 = $08a2e2b0d4c9ee4c$var$axisCacheGet(labelsCache, optionLabelInterval);
        if (result_1) return result_1;
    }
    var labels;
    var numericLabelInterval;
    if ($f16f2994a32ad273$export$f6e2535fb5126e54(optionLabelInterval)) labels = $08a2e2b0d4c9ee4c$var$makeTicksLabelsByCategoryIntervalNumOrCb(axis, optionLabelInterval, false);
    else {
        numericLabelInterval = optionLabelInterval === 'auto' ? $08a2e2b0d4c9ee4c$var$makeAutoCategoryInterval(axis, ctx) : optionLabelInterval;
        labels = $08a2e2b0d4c9ee4c$var$makeTicksLabelsByCategoryIntervalNumOrCb(axis, numericLabelInterval, false);
    }
    var result = {
        labels: labels,
        labelCategoryInterval: numericLabelInterval
    };
    if (!isEstimate) $08a2e2b0d4c9ee4c$var$axisCacheSet(labelsCache, optionLabelInterval, result);
    else ctx.out.noPxChangeTryDetermine.push(function() {
        $08a2e2b0d4c9ee4c$var$axisCacheSet(labelsCache, optionLabelInterval, result);
        return true;
    });
    return result;
}
function $08a2e2b0d4c9ee4c$var$makeCategoryTicks(axis, tickModel) {
    var ticksCache = $08a2e2b0d4c9ee4c$var$ensureCategoryTickCache(axis);
    var optionTickInterval = (0, $5197eaeff9ee5dfb$export$6d0bc2429155c088)(tickModel);
    var result = $08a2e2b0d4c9ee4c$var$axisCacheGet(ticksCache, optionTickInterval);
    if (result) return result;
    var ticks;
    var tickCategoryInterval;
    // Optimize for the case that large category data and no label displayed,
    // we should not return all ticks.
    if (!tickModel.get('show') || axis.scale.isBlank()) ticks = [];
    if ($f16f2994a32ad273$export$f6e2535fb5126e54(optionTickInterval)) ticks = $08a2e2b0d4c9ee4c$var$makeTicksLabelsByCategoryIntervalNumOrCb(axis, optionTickInterval, true);
    else if (optionTickInterval === 'auto') {
        var labelsResult = $08a2e2b0d4c9ee4c$var$makeCategoryLabelsActually(axis, axis.getLabelModel(), $08a2e2b0d4c9ee4c$export$12d6ac38274c43e7($08a2e2b0d4c9ee4c$export$31cba7db0a663292.determine));
        tickCategoryInterval = labelsResult.labelCategoryInterval;
        ticks = $f16f2994a32ad273$export$871de8747c9eaa88(labelsResult.labels, function(labelItem) {
            return labelItem.tick;
        });
    } else {
        tickCategoryInterval = optionTickInterval;
        ticks = $08a2e2b0d4c9ee4c$var$makeTicksLabelsByCategoryIntervalNumOrCb(axis, tickCategoryInterval, true);
    }
    // Cache to avoid calling interval function repeatedly.
    return $08a2e2b0d4c9ee4c$var$axisCacheSet(ticksCache, optionTickInterval, {
        ticks: ticks,
        tickCategoryInterval: tickCategoryInterval
    });
}
function $08a2e2b0d4c9ee4c$var$makeRealNumberLabels(axis) {
    var ticks = axis.scale.getTicks();
    var labelFormatter = (0, $5197eaeff9ee5dfb$export$742f19a75415b2ae)(axis);
    return {
        labels: $f16f2994a32ad273$export$871de8747c9eaa88(ticks, function(tick, idx) {
            return {
                formattedLabel: labelFormatter(tick, idx),
                rawLabel: axis.scale.getLabel(tick),
                tick: tick
            };
        })
    };
}
// Large category data calculation is performance sensitive, and ticks and label probably will
// be fetched multiple times (e.g. shared by splitLine and axisTick). So we cache the result.
// axis is created each time during a ec process, so we do not need to clear cache.
var $08a2e2b0d4c9ee4c$var$ensureCategoryTickCache = $08a2e2b0d4c9ee4c$var$initAxisCacheMethod('axisTick');
var $08a2e2b0d4c9ee4c$var$ensureCategoryLabelCache = $08a2e2b0d4c9ee4c$var$initAxisCacheMethod('axisLabel');
/**
 * PENDING: refactor to JS Map? Because key can be a function or more complicated object, and
 * cache size always is small, and currently no JS Map object key polyfill, we use a simple
 * array cache instead of plain object hash.
 */ function $08a2e2b0d4c9ee4c$var$initAxisCacheMethod(prop) {
    return function ensureCache(axis) {
        return $08a2e2b0d4c9ee4c$var$axisInner(axis)[prop] || ($08a2e2b0d4c9ee4c$var$axisInner(axis)[prop] = {
            list: []
        });
    };
}
function $08a2e2b0d4c9ee4c$var$axisCacheGet(cache, key) {
    for(var i = 0; i < cache.list.length; i++){
        if (cache.list[i].key === key) return cache.list[i].value;
    }
}
function $08a2e2b0d4c9ee4c$var$axisCacheSet(cache, key, value) {
    cache.list.push({
        key: key,
        value: value
    });
    return value;
}
function $08a2e2b0d4c9ee4c$var$makeAutoCategoryInterval(axis, ctx) {
    if (ctx.kind === $08a2e2b0d4c9ee4c$export$31cba7db0a663292.estimate) {
        // Currently axisTick is not involved in estimate kind, and the result likely varies during a
        // single pass of ec main process, due to the change of axisExtent. Therefore no cache is used.
        var result_2 = axis.calculateCategoryInterval(ctx);
        ctx.out.noPxChangeTryDetermine.push(function() {
            $08a2e2b0d4c9ee4c$var$axisInner(axis).autoInterval = result_2;
            return true;
        });
        return result_2;
    }
    // Both tick and label uses this result, cacah it to avoid recompute.
    var result = $08a2e2b0d4c9ee4c$var$axisInner(axis).autoInterval;
    return result != null ? result : $08a2e2b0d4c9ee4c$var$axisInner(axis).autoInterval = axis.calculateCategoryInterval(ctx);
}
function $08a2e2b0d4c9ee4c$export$9ea1d3f146a5a65f(axis, ctx) {
    var kind = ctx.kind;
    var params = $08a2e2b0d4c9ee4c$var$fetchAutoCategoryIntervalCalculationParams(axis);
    var labelFormatter = (0, $5197eaeff9ee5dfb$export$742f19a75415b2ae)(axis);
    var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    // Providing this method is for optimization:
    // avoid generating a long array by `getTicks`
    // in large category data case.
    var tickCount = ordinalScale.count();
    if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
    var step = 1;
    // Simple optimization. Arbitrary value.
    var maxCount = 40;
    if (tickCount > maxCount) step = Math.max(1, Math.floor(tickCount / maxCount));
    var tickValue = ordinalExtent[0];
    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
    var unitW = Math.abs(unitSpan * Math.cos(rotation));
    var unitH = Math.abs(unitSpan * Math.sin(rotation));
    var maxW = 0;
    var maxH = 0;
    // Caution: Performance sensitive for large category data.
    // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
    for(; tickValue <= ordinalExtent[1]; tickValue += step){
        var width = 0;
        var height = 0;
        // Not precise, do not consider align and vertical align
        // and each distance from axis line yet.
        var rect = $3ad1e5e308f2a981$export$c381147bfed79d9f(labelFormatter({
            value: tickValue
        }), params.font, 'center', 'top');
        // Magic number
        width = rect.width * 1.3;
        height = rect.height * 1.3;
        // Min size, void long loop.
        maxW = Math.max(maxW, width, 7);
        maxH = Math.max(maxH, height, 7);
    }
    var dw = maxW / unitW;
    var dh = maxH / unitH;
    // 0/0 is NaN, 1/0 is Infinity.
    isNaN(dw) && (dw = Infinity);
    isNaN(dh) && (dh = Infinity);
    var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
    if (kind === $08a2e2b0d4c9ee4c$export$31cba7db0a663292.estimate) {
        // In estimate kind, the inteval likely varies, thus do not erase the cache.
        ctx.out.noPxChangeTryDetermine.push($f16f2994a32ad273$export$2385a24977818dd0($08a2e2b0d4c9ee4c$var$calculateCategoryIntervalTryDetermine, null, axis, interval, tickCount));
        return interval;
    }
    var lastInterval = $08a2e2b0d4c9ee4c$var$calculateCategoryIntervalDealCache(axis, interval, tickCount);
    return lastInterval != null ? lastInterval : interval;
}
function $08a2e2b0d4c9ee4c$var$calculateCategoryIntervalTryDetermine(axis, interval, tickCount) {
    return $08a2e2b0d4c9ee4c$var$calculateCategoryIntervalDealCache(axis, interval, tickCount) == null;
}
// Return the lastInterval if need to use it, otherwise return NullUndefined and save cache.
function $08a2e2b0d4c9ee4c$var$calculateCategoryIntervalDealCache(axis, interval, tickCount) {
    var cache = $08a2e2b0d4c9ee4c$var$modelInner(axis.model);
    var axisExtent = axis.getExtent();
    var lastAutoInterval = cache.lastAutoInterval;
    var lastTickCount = cache.lastTickCount;
    // Use cache to keep interval stable while moving zoom window,
    // otherwise the calculated interval might jitter when the zoom
    // window size is close to the interval-changing size.
    // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
    // The jitter will cause that sometimes the displayed labels are
    // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).
    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 && lastAutoInterval > interval && cache.axisExtent0 === axisExtent[0] && cache.axisExtent1 === axisExtent[1]) return lastAutoInterval;
    else {
        cache.lastTickCount = tickCount;
        cache.lastAutoInterval = interval;
        cache.axisExtent0 = axisExtent[0];
        cache.axisExtent1 = axisExtent[1];
    }
}
function $08a2e2b0d4c9ee4c$var$fetchAutoCategoryIntervalCalculationParams(axis) {
    var labelModel = axis.getLabelModel();
    return {
        axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
        labelRotate: labelModel.get('rotate') || 0,
        font: labelModel.getFont()
    };
}
function $08a2e2b0d4c9ee4c$var$makeTicksLabelsByCategoryIntervalNumOrCb(axis, categoryInterval, onlyTick) {
    var labelFormatter = (0, $5197eaeff9ee5dfb$export$742f19a75415b2ae)(axis);
    var ordinalScale = axis.scale;
    var result = [];
    var categoryIntervalIsCb = $f16f2994a32ad273$export$f6e2535fb5126e54(categoryInterval);
    (0, $f976678a0ff027db$export$1039c7e66c46a7fd)(ordinalScale, categoryIntervalIsCb ? 0 : categoryInterval, function(tickObj, isExtentBoundary) {
        var tickLabel = ordinalScale.getLabel(tickObj);
        if (categoryIntervalIsCb) {
            // When interval is function, a falsy return means ignore the tick.
            // It is time consuming for large category data.
            var isOnInterval = !!categoryInterval(tickObj.value, tickLabel);
            tickObj.offInterval = !isOnInterval;
            // axis extent min max labels should be always included and the display strategy
            // is adopted uniformly later in `AxisBuilder`.
            if (!isOnInterval && !isExtentBoundary) return;
        }
        result.push(onlyTick ? tickObj : {
            formattedLabel: labelFormatter(tickObj),
            rawLabel: tickLabel,
            tick: tickObj
        });
    });
    return result;
}



var $f026cfe0f7218100$var$PI = Math.PI;
var $f026cfe0f7218100$var$DEFAULT_CENTER_NAME_MARGIN_LEVELS = [
    [
        1,
        2,
        1,
        2
    ],
    [
        5,
        3,
        5,
        3
    ],
    [
        8,
        3,
        8,
        3
    ]
];
var $f026cfe0f7218100$var$DEFAULT_ENDS_NAME_MARGIN_LEVELS = [
    [
        0,
        1,
        0,
        1
    ],
    [
        0,
        3,
        0,
        3
    ],
    [
        0,
        3,
        0,
        3
    ]
];
var $f026cfe0f7218100$export$c392b818a26a879e = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
var $f026cfe0f7218100$var$getTickInner = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
/**
 * A context shared by difference axisBuilder instances.
 * For cross-axes overlap resolving.
 *
 * Lifecycle constraint: should not over a pass of ec main process.
 *  If model is changed, the context must be disposed.
 *
 * @see AxisBuilderLocalContext
 */ var $f026cfe0f7218100$export$f2e237206f7393f5 = /** @class */ function() {
    function AxisBuilderSharedContext(resolveAxisNameOverlap) {
        /**
     * [CAUTION] Do not modify this data structure outside this class.
     */ this.recordMap = {};
        this.resolveAxisNameOverlap = resolveAxisNameOverlap;
    }
    AxisBuilderSharedContext.prototype.ensureRecord = function(axisModel) {
        var dim = axisModel.axis.dim;
        var idx = axisModel.componentIndex;
        var recordMap = this.recordMap;
        var records = recordMap[dim] || (recordMap[dim] = []);
        return records[idx] || (records[idx] = {
            ready: {}
        });
    };
    return AxisBuilderSharedContext;
}();
/**
 * [CAUTION]
 *  1. The call of this function must be after axisLabel overlap handlings
 *     (such as `hideOverlap`, `fixMinMaxLabelShow`) and after transform calculating.
 *  2. Can be called multiple times and should be idempotent.
 */ function $f026cfe0f7218100$var$resetOverlapRecordToShared(cfg, shared, axisModel, labelLayoutList) {
    var axis = axisModel.axis;
    var record = shared.ensureRecord(axisModel);
    var labelInfoList = [];
    var stOccupiedRect;
    var useStOccupiedRect = $f026cfe0f7218100$var$hasAxisName(cfg.axisName) && (0, $5197eaeff9ee5dfb$export$c06aa22293dea9d2)(cfg.nameLocation);
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(labelLayoutList, function(layout) {
        var layoutInfo = (0, $49e8be5a460de8c7$export$471916f4e89eb5da)(layout);
        if (!layoutInfo || layoutInfo.label.ignore) return;
        labelInfoList.push(layoutInfo);
        var transGroup = record.transGroup;
        if (useStOccupiedRect) {
            // Transform to "standard axis" for creating stOccupiedRect (the label rects union).
            transGroup.transform ? $45a6d43b639a6412$export$6897c284b6f9f4dc($f026cfe0f7218100$var$_stTransTmp, transGroup.transform) : $45a6d43b639a6412$export$f0954fd7d5368655($f026cfe0f7218100$var$_stTransTmp);
            if (layoutInfo.transform) $45a6d43b639a6412$export$6e3a27864ab166fe($f026cfe0f7218100$var$_stTransTmp, $f026cfe0f7218100$var$_stTransTmp, layoutInfo.transform);
            (0, $7456366ce379c42e$export$2e2bcd8739ae039).copy($f026cfe0f7218100$var$_stLabelRectTmp, layoutInfo.localRect);
            $f026cfe0f7218100$var$_stLabelRectTmp.applyTransform($f026cfe0f7218100$var$_stTransTmp);
            stOccupiedRect ? stOccupiedRect.union($f026cfe0f7218100$var$_stLabelRectTmp) : (0, $7456366ce379c42e$export$2e2bcd8739ae039).copy(stOccupiedRect = new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(0, 0, 0, 0), $f026cfe0f7218100$var$_stLabelRectTmp);
        }
    });
    var sortByDim = Math.abs(record.dirVec.x) > 0.1 ? 'x' : 'y';
    var sortByValue = record.transGroup[sortByDim];
    labelInfoList.sort(function(info1, info2) {
        return Math.abs(info1.label[sortByDim] - sortByValue) - Math.abs(info2.label[sortByDim] - sortByValue);
    });
    if (useStOccupiedRect && stOccupiedRect) {
        var extent = axis.getExtent();
        var axisLineX = Math.min(extent[0], extent[1]);
        var axisLineWidth = Math.max(extent[0], extent[1]) - axisLineX;
        // If `nameLocation` is 'middle', enlarge axis labels boundingRect to axisLine to avoid bad
        //  case like that axis name is placed in the gap between axis labels and axis line.
        // If only one label exists, the entire band should be occupied for
        // visual consistency, so extent it to [0, canvas width].
        stOccupiedRect.union(new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(axisLineX, 0, axisLineWidth, 1));
    }
    record.stOccupiedRect = stOccupiedRect;
    record.labelInfoList = labelInfoList;
}
var $f026cfe0f7218100$var$_stTransTmp = $45a6d43b639a6412$export$185802fd694ee1f5();
var $f026cfe0f7218100$var$_stLabelRectTmp = new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $f026cfe0f7218100$export$7fcb8742f5816cae = function resolveAxisNameOverlapDefault(cfg, ctx, axisModel, nameLayoutInfo, nameMoveDirVec, thisRecord) {
    if ((0, $5197eaeff9ee5dfb$export$c06aa22293dea9d2)(cfg.nameLocation)) {
        var stOccupiedRect = thisRecord.stOccupiedRect;
        if (stOccupiedRect) $f026cfe0f7218100$var$moveIfOverlap((0, $49e8be5a460de8c7$export$bc37ae3f8412d105)({}, stOccupiedRect, thisRecord.transGroup.transform), nameLayoutInfo, nameMoveDirVec);
    } else $f026cfe0f7218100$export$e033c6449cc6f6a1(thisRecord.labelInfoList, thisRecord.dirVec, nameLayoutInfo, nameMoveDirVec);
};
// [NOTICE] not consider ignore.
function $f026cfe0f7218100$var$moveIfOverlap(basedLayoutInfo, movableLayoutInfo, moveDirVec) {
    var mtv = new (0, $f82d35899f1caf18$export$2e2bcd8739ae039)();
    if ((0, $49e8be5a460de8c7$export$f28bfabef115ba96)(basedLayoutInfo, movableLayoutInfo, mtv, {
        direction: Math.atan2(moveDirVec.y, moveDirVec.x),
        bidirectional: false,
        touchThreshold: 0.05
    })) (0, $49e8be5a460de8c7$export$91f733c27ab0712f)(movableLayoutInfo, mtv);
}
function $f026cfe0f7218100$export$e033c6449cc6f6a1(baseLayoutInfoList, baseDirVec, movableLayoutInfo, moveDirVec) {
    // Detect and move from far to close.
    var sameDir = (0, $f82d35899f1caf18$export$2e2bcd8739ae039).dot(moveDirVec, baseDirVec) >= 0;
    for(var idx = 0, len = baseLayoutInfoList.length; idx < len; idx++){
        var labelInfo = baseLayoutInfoList[sameDir ? idx : len - 1 - idx];
        if (!labelInfo.label.ignore) $f026cfe0f7218100$var$moveIfOverlap(labelInfo, movableLayoutInfo, moveDirVec);
    }
}
/**
 * @caution
 * - Ensure it is called after the data processing stage finished.
 * - It might be called before `CahrtView#render`, sush as called at `CoordinateSystem#update`,
 *  thus ensure the result the same whenever it is called.
 *
 * A builder for a straight-line axis.
 *
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A "standard axis" is the axis [0,0]-->[abs(axisExtent[1]-axisExtent[0]),0]
 * for example: [0,0]-->[50,0]
 */ var $f026cfe0f7218100$var$AxisBuilder = /** @class */ function() {
    /**
   * [CAUTION]: axisModel.axis.extent/scale must be ready to use.
   */ function AxisBuilder(axisModel, api, opt, shared) {
        this.group = new $ac4abc1f547da31a$export$2e2bcd8739ae039();
        this._axisModel = axisModel;
        this._api = api;
        this._local = {};
        this._shared = shared || new $f026cfe0f7218100$export$f2e237206f7393f5($f026cfe0f7218100$export$7fcb8742f5816cae);
        this._resetCfgDetermined(opt);
    }
    /**
   * Regarding axis label related configurations, only the change of label.x/y is supported; other
   * changes are not necessary and not performant. To be specific, only `axis.position`
   * (and consequently `labelOffset`) and `axis.extent` can be changed, and assume everything in
   * `axisModel` are not changed.
   * Axis line related configurations can be changed since this method can only be called
   * before they are created.
   */ AxisBuilder.prototype.updateCfg = function(opt) {
        var ready;
        var raw = this._cfg.raw;
        raw.position = opt.position;
        raw.labelOffset = opt.labelOffset;
        this._resetCfgDetermined(raw);
    };
    /**
   * [CAUTION] For debug usage. Never change it outside!
   */ AxisBuilder.prototype.__getRawCfg = function() {
        return this._cfg.raw;
    };
    AxisBuilder.prototype._resetCfgDetermined = function(raw) {
        var axisModel = this._axisModel;
        // FIXME:
        //  Currently there is no uniformed way to set default values if an option
        //  is specified null/undefined by user (intentionally or unintentionally),
        //  e.g. null/undefined is not a illegal value for `nameLocation`.
        //  Try to use `getDefaultOption` to address it. But radar has no `getDefaultOption`.
        var axisModelDefaultOption = axisModel.getDefaultOption ? axisModel.getDefaultOption() : {};
        // Default value
        var axisName = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(raw.axisName, axisModel.get('name'));
        var nameMoveOverlapOption = axisModel.get('nameMoveOverlap');
        if (nameMoveOverlapOption == null || nameMoveOverlapOption === 'auto') nameMoveOverlapOption = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(raw.defaultNameMoveOverlap, true);
        var cfg = {
            raw: raw,
            position: raw.position,
            rotation: raw.rotation,
            nameDirection: (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(raw.nameDirection, 1),
            tickDirection: (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(raw.tickDirection, 1),
            labelDirection: (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(raw.labelDirection, 1),
            labelOffset: (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(raw.labelOffset, 0),
            silent: (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(raw.silent, true),
            axisName: axisName,
            nameLocation: (0, $f16f2994a32ad273$export$2e94551289abb95b)(axisModel.get('nameLocation'), axisModelDefaultOption.nameLocation, 'end'),
            shouldNameMoveOverlap: $f026cfe0f7218100$var$hasAxisName(axisName) && nameMoveOverlapOption,
            optionHideOverlap: axisModel.get([
                'axisLabel',
                'hideOverlap'
            ]),
            showMinorTicks: axisModel.get([
                'minorTick',
                'show'
            ])
        };
        this._cfg = cfg;
        // FIXME Not use a separate text group?
        var transformGroup = new $ac4abc1f547da31a$export$2e2bcd8739ae039({
            x: cfg.position[0],
            y: cfg.position[1],
            rotation: cfg.rotation
        });
        transformGroup.updateTransform();
        this._transformGroup = transformGroup;
        var record = this._shared.ensureRecord(axisModel);
        record.transGroup = this._transformGroup;
        record.dirVec = new (0, $f82d35899f1caf18$export$2e2bcd8739ae039)(Math.cos(-cfg.rotation), Math.sin(-cfg.rotation));
    };
    AxisBuilder.prototype.build = function(axisPartNameMap, extraParams) {
        var _this = this;
        if (!axisPartNameMap) axisPartNameMap = {
            axisLine: true,
            axisTickLabelEstimate: false,
            axisTickLabelDetermine: true,
            axisName: true
        };
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)($f026cfe0f7218100$var$AXIS_BUILDER_AXIS_PART_NAMES, function(partName) {
            if (axisPartNameMap[partName]) $f026cfe0f7218100$var$builders[partName](_this._cfg, _this._local, _this._shared, _this._axisModel, _this.group, _this._transformGroup, _this._api, extraParams || {});
        });
        return this;
    };
    /**
   * Currently only get text align/verticalAlign by rotation.
   * NO `position` is involved, otherwise it have to be performed for each `updateAxisLabelChangableProps`.
   */ AxisBuilder.innerTextLayout = function(axisRotation, textRotation, direction) {
        var rotationDiff = (0, $104896d282bd296f$export$2ca6dd70a288b1c3)(textRotation - axisRotation);
        var textAlign;
        var textVerticalAlign;
        if ((0, $104896d282bd296f$export$d1df570aea2868f)(rotationDiff)) {
            // Label is parallel with axis line.
            textVerticalAlign = direction > 0 ? 'top' : 'bottom';
            textAlign = 'center';
        } else if ((0, $104896d282bd296f$export$d1df570aea2868f)(rotationDiff - $f026cfe0f7218100$var$PI)) {
            // Label is inverse parallel with axis line.
            textVerticalAlign = direction > 0 ? 'bottom' : 'top';
            textAlign = 'center';
        } else {
            textVerticalAlign = 'middle';
            if (rotationDiff > 0 && rotationDiff < $f026cfe0f7218100$var$PI) textAlign = direction > 0 ? 'right' : 'left';
            else textAlign = direction > 0 ? 'left' : 'right';
        }
        return {
            rotation: rotationDiff,
            textAlign: textAlign,
            textVerticalAlign: textVerticalAlign
        };
    };
    AxisBuilder.makeAxisEventDataBase = function(axisModel) {
        var eventData = {
            componentType: axisModel.mainType,
            componentIndex: axisModel.componentIndex
        };
        eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
        return eventData;
    };
    AxisBuilder.isLabelSilent = function(axisModel) {
        var tooltipOpt = axisModel.get('tooltip');
        return axisModel.get('silent') || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
    };
    return AxisBuilder;
}();
// Sorted by dependency order.
var $f026cfe0f7218100$var$AXIS_BUILDER_AXIS_PART_NAMES = [
    'axisLine',
    'axisTickLabelEstimate',
    'axisTickLabelDetermine',
    'axisName'
];
var $f026cfe0f7218100$var$builders = {
    axisLine: function axisLine(cfg, local, shared, axisModel, group, transformGroup, api) {
        var ready;
        var shown = axisModel.get([
            'axisLine',
            'show'
        ]);
        if (shown === 'auto') {
            shown = true;
            if (cfg.raw.axisLineAutoShow != null) shown = !!cfg.raw.axisLineAutoShow;
        }
        if (!shown) return;
        var extent = axisModel.axis.getExtent();
        var matrix = transformGroup.transform;
        var pt1 = [
            extent[0],
            0
        ];
        var pt2 = [
            extent[1],
            0
        ];
        var inverse = pt1[0] > pt2[0];
        if (matrix) {
            (0, $f79ec7ea1294b339$export$9f9dcb98c894b623)(pt1, pt1, matrix);
            (0, $f79ec7ea1294b339$export$9f9dcb98c894b623)(pt2, pt2, matrix);
        }
        var lineStyle = (0, $f16f2994a32ad273$export$8b58be045bf06082)({
            lineCap: 'round'
        }, axisModel.getModel([
            'axisLine',
            'lineStyle'
        ]).getLineStyle());
        var pathBaseProp = {
            strokeContainThreshold: cfg.raw.strokeContainThreshold || 5,
            silent: true,
            z2: 1,
            style: lineStyle
        };
        if (axisModel.get([
            'axisLine',
            'breakLine'
        ]) && (0, $cf43ca9fea251347$export$fec008222a1db2dc)(axisModel.axis.scale)) (0, $fc815de52b491ed4$export$c1d9b2cc33e7e5e)().buildAxisBreakLine(axisModel, group, transformGroup, pathBaseProp);
        else {
            var line = new $b37b447960e3414d$export$2e2bcd8739ae039((0, $f16f2994a32ad273$export$8b58be045bf06082)({
                shape: {
                    x1: pt1[0],
                    y1: pt1[1],
                    x2: pt2[0],
                    y2: pt2[1]
                }
            }, pathBaseProp));
            $bce1f681c7fb2581$export$8b4b620d7f4aad1b(line.shape, line.style.lineWidth);
            line.anid = 'line';
            group.add(line);
        }
        var arrows = axisModel.get([
            'axisLine',
            'symbol'
        ]);
        if (arrows != null) {
            var arrowSize = axisModel.get([
                'axisLine',
                'symbolSize'
            ]);
            if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(arrows)) // Use the same arrow for start and end point
            arrows = [
                arrows,
                arrows
            ];
            if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(arrowSize) || (0, $f16f2994a32ad273$export$7e4aa119212bc614)(arrowSize)) // Use the same size for width and height
            arrowSize = [
                arrowSize,
                arrowSize
            ];
            var arrowOffset = (0, $ea44e91fc072e728$export$e3e292895c033f6d)(axisModel.get([
                'axisLine',
                'symbolOffset'
            ]) || 0, arrowSize);
            var symbolWidth_1 = arrowSize[0];
            var symbolHeight_1 = arrowSize[1];
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)([
                {
                    rotate: cfg.rotation + Math.PI / 2,
                    offset: arrowOffset[0],
                    r: 0
                },
                {
                    rotate: cfg.rotation - Math.PI / 2,
                    offset: arrowOffset[1],
                    r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
                }
            ], function(point, index) {
                if (arrows[index] !== 'none' && arrows[index] != null) {
                    var symbol = (0, $ea44e91fc072e728$export$af050e04da3a02e8)(arrows[index], -symbolWidth_1 / 2, -symbolHeight_1 / 2, symbolWidth_1, symbolHeight_1, lineStyle.stroke, true);
                    // Calculate arrow position with offset
                    var r = point.r + point.offset;
                    var pt = inverse ? pt2 : pt1;
                    symbol.attr({
                        rotation: point.rotate,
                        x: pt[0] + r * Math.cos(cfg.rotation),
                        y: pt[1] - r * Math.sin(cfg.rotation),
                        silent: true,
                        z2: 11
                    });
                    group.add(symbol);
                }
            });
        }
    },
    /**
   * [CAUTION] This method can be called multiple times, following the change due to `resetCfg` called
   *  in size measurement. Thus this method should be idempotent, and should be performant.
   */ axisTickLabelEstimate: function axisTickLabelEstimate(cfg, local, shared, axisModel, group, transformGroup, api, extraParams) {
        var ready;
        var needCallLayout = $f026cfe0f7218100$var$dealLastTickLabelResultReusable(local, group, extraParams);
        if (needCallLayout) $f026cfe0f7218100$var$layOutAxisTickLabel(cfg, local, shared, axisModel, group, transformGroup, api, (0, $08a2e2b0d4c9ee4c$export$31cba7db0a663292).estimate);
    },
    /**
   * Finish axis tick label build.
   * Can be only called once.
   */ axisTickLabelDetermine: function axisTickLabelDetermine(cfg, local, shared, axisModel, group, transformGroup, api, extraParams) {
        var ready;
        var needCallLayout = $f026cfe0f7218100$var$dealLastTickLabelResultReusable(local, group, extraParams);
        if (needCallLayout) $f026cfe0f7218100$var$layOutAxisTickLabel(cfg, local, shared, axisModel, group, transformGroup, api, (0, $08a2e2b0d4c9ee4c$export$31cba7db0a663292).determine);
        var ticksEls = $f026cfe0f7218100$var$buildAxisMajorTicks(cfg, group, transformGroup, axisModel);
        $f026cfe0f7218100$var$syncLabelIgnoreToMajorTicks(cfg, local.labelLayoutList, ticksEls);
        $f026cfe0f7218100$var$buildAxisMinorTicks(cfg, group, transformGroup, axisModel, cfg.tickDirection);
    },
    /**
   * [CAUTION] This method can be called multiple times, following the change due to `resetCfg` called
   *  in size measurement. Thus this method should be idempotent, and should be performant.
   */ axisName: function axisName(cfg, local, shared, axisModel, group, transformGroup, api, extraParams) {
        var sharedRecord = shared.ensureRecord(axisModel);
        var ready;
        // Remove the existing name result created in estimation phase.
        if (local.nameEl) {
            group.remove(local.nameEl);
            local.nameEl = sharedRecord.nameLayout = sharedRecord.nameLocation = null;
        }
        var name = cfg.axisName;
        if (!$f026cfe0f7218100$var$hasAxisName(name)) return;
        var nameLocation = cfg.nameLocation;
        var nameDirection = cfg.nameDirection;
        var textStyleModel = axisModel.getModel('nameTextStyle');
        var gap = axisModel.get('nameGap') || 0;
        var extent = axisModel.axis.getExtent();
        var gapStartEndSignal = axisModel.axis.inverse ? -1 : 1;
        var pos = new (0, $f82d35899f1caf18$export$2e2bcd8739ae039)(0, 0);
        var nameMoveDirVec = new (0, $f82d35899f1caf18$export$2e2bcd8739ae039)(0, 0);
        if (nameLocation === 'start') {
            pos.x = extent[0] - gapStartEndSignal * gap;
            nameMoveDirVec.x = -gapStartEndSignal;
        } else if (nameLocation === 'end') {
            pos.x = extent[1] + gapStartEndSignal * gap;
            nameMoveDirVec.x = gapStartEndSignal;
        } else {
            // 'middle' or 'center'
            pos.x = (extent[0] + extent[1]) / 2;
            pos.y = cfg.labelOffset + nameDirection * gap;
            nameMoveDirVec.y = nameDirection;
        }
        var mt = $45a6d43b639a6412$export$185802fd694ee1f5();
        nameMoveDirVec.transform($45a6d43b639a6412$export$bb628a54ab399bc9(mt, mt, cfg.rotation));
        var nameRotation = axisModel.get('nameRotate');
        if (nameRotation != null) nameRotation = nameRotation * $f026cfe0f7218100$var$PI / 180; // To radian.
        var labelLayout;
        var axisNameAvailableWidth;
        if ((0, $5197eaeff9ee5dfb$export$c06aa22293dea9d2)(nameLocation)) labelLayout = $f026cfe0f7218100$var$AxisBuilder.innerTextLayout(cfg.rotation, nameRotation != null ? nameRotation : cfg.rotation, // Adapt to axis.
        nameDirection);
        else {
            labelLayout = $f026cfe0f7218100$var$endTextLayout(cfg.rotation, nameLocation, nameRotation || 0, extent);
            axisNameAvailableWidth = cfg.raw.axisNameAvailableWidth;
            if (axisNameAvailableWidth != null) {
                axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
                !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
            }
        }
        var textFont = textStyleModel.getFont();
        var truncateOpt = axisModel.get('nameTruncate', true) || {};
        var ellipsis = truncateOpt.ellipsis;
        var maxWidth = (0, $f16f2994a32ad273$export$8a4d17b6e8486e66)(cfg.raw.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth);
        var nameMarginLevel = extraParams.nameMarginLevel || 0;
        var textEl = new $7d5e7dc1581f8c9a$export$2e2bcd8739ae039({
            x: pos.x,
            y: pos.y,
            rotation: labelLayout.rotation,
            silent: $f026cfe0f7218100$var$AxisBuilder.isLabelSilent(axisModel),
            style: (0, $1ee9c8b909b7ca82$export$f8998c3d0a13de59)(textStyleModel, {
                text: name,
                font: textFont,
                overflow: 'truncate',
                width: maxWidth,
                ellipsis: ellipsis,
                fill: textStyleModel.getTextColor() || axisModel.get([
                    'axisLine',
                    'lineStyle',
                    'color'
                ]),
                align: textStyleModel.get('align') || labelLayout.textAlign,
                verticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
            }),
            z2: 1
        });
        $bce1f681c7fb2581$export$fc6410d97fab306c({
            el: textEl,
            componentModel: axisModel,
            itemName: name
        });
        textEl.__fullText = name;
        // Id for animation
        textEl.anid = 'name';
        if (axisModel.get('triggerEvent')) {
            var eventData = $f026cfe0f7218100$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = 'axisName';
            eventData.name = name;
            (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
        }
        transformGroup.add(textEl);
        textEl.updateTransform();
        local.nameEl = textEl;
        var nameLayout = sharedRecord.nameLayout = (0, $49e8be5a460de8c7$export$471916f4e89eb5da)({
            label: textEl,
            priority: textEl.z2,
            defaultAttr: {
                ignore: textEl.ignore
            },
            marginDefault: (0, $5197eaeff9ee5dfb$export$c06aa22293dea9d2)(nameLocation) ? $f026cfe0f7218100$var$DEFAULT_CENTER_NAME_MARGIN_LEVELS[nameMarginLevel] : $f026cfe0f7218100$var$DEFAULT_ENDS_NAME_MARGIN_LEVELS[nameMarginLevel]
        });
        sharedRecord.nameLocation = nameLocation;
        group.add(textEl);
        textEl.decomposeTransform();
        if (cfg.shouldNameMoveOverlap && nameLayout) {
            var record = shared.ensureRecord(axisModel);
            shared.resolveAxisNameOverlap(cfg, shared, axisModel, nameLayout, nameMoveDirVec, record);
        }
    }
};
function $f026cfe0f7218100$var$layOutAxisTickLabel(cfg, local, shared, axisModel, group, transformGroup, api, kind) {
    if (!$f026cfe0f7218100$var$axisLabelBuildResultExists(local)) $f026cfe0f7218100$var$buildAxisLabel(cfg, local, group, kind, axisModel, api);
    var labelLayoutList = local.labelLayoutList;
    $f026cfe0f7218100$var$updateAxisLabelChangableProps(cfg, axisModel, labelLayoutList, transformGroup);
    $f026cfe0f7218100$var$adjustBreakLabels(axisModel, cfg.rotation, labelLayoutList);
    var optionHideOverlap = cfg.optionHideOverlap;
    $f026cfe0f7218100$var$fixMinMaxLabelShow(axisModel, labelLayoutList, optionHideOverlap);
    if (optionHideOverlap) // This bit fixes the label overlap issue for the time chart.
    // See https://github.com/apache/echarts/issues/14266 for more.
    (0, $49e8be5a460de8c7$export$8ce774e164a49410)(// Filter the already ignored labels by the previous overlap resolving methods.
    (0, $f16f2994a32ad273$export$3dea766d36a8935f)(labelLayoutList, function(layout) {
        return layout && !layout.label.ignore;
    }));
    // Always call it even this axis has no name, since it serves in overlapping detection
    // and grid outerBounds on other axis.
    $f026cfe0f7218100$var$resetOverlapRecordToShared(cfg, shared, axisModel, labelLayoutList);
}
function $f026cfe0f7218100$var$endTextLayout(rotation, textPosition, textRotate, extent) {
    var rotationDiff = (0, $104896d282bd296f$export$2ca6dd70a288b1c3)(textRotate - rotation);
    var textAlign;
    var textVerticalAlign;
    var inverse = extent[0] > extent[1];
    var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;
    if ((0, $104896d282bd296f$export$d1df570aea2868f)(rotationDiff - $f026cfe0f7218100$var$PI / 2)) {
        textVerticalAlign = onLeft ? 'bottom' : 'top';
        textAlign = 'center';
    } else if ((0, $104896d282bd296f$export$d1df570aea2868f)(rotationDiff - $f026cfe0f7218100$var$PI * 1.5)) {
        textVerticalAlign = onLeft ? 'top' : 'bottom';
        textAlign = 'center';
    } else {
        textVerticalAlign = 'middle';
        if (rotationDiff < $f026cfe0f7218100$var$PI * 1.5 && rotationDiff > $f026cfe0f7218100$var$PI / 2) textAlign = onLeft ? 'left' : 'right';
        else textAlign = onLeft ? 'right' : 'left';
    }
    return {
        rotation: rotationDiff,
        textAlign: textAlign,
        textVerticalAlign: textVerticalAlign
    };
}
/**
 * Assume `labelLayoutList` has no `label.ignore: true`.
 * Assume `labelLayoutList` have been sorted by value ascending order.
 */ function $f026cfe0f7218100$var$fixMinMaxLabelShow(axisModel, labelLayoutList, optionHideOverlap) {
    var axis = axisModel.axis;
    var customValuesOption = axisModel.get([
        'axisLabel',
        'customValues'
    ]);
    if ((0, $5197eaeff9ee5dfb$export$c2911c025243d6a6)(axis)) return;
    // FIXME
    // Have not consider onBand yet, where tick els is more than label els.
    // Assert no ignore in labels.
    function deal(showMinMaxLabelOption, outmostLabelIdx, innerLabelIdx) {
        var outmostLabelLayout = (0, $49e8be5a460de8c7$export$471916f4e89eb5da)(labelLayoutList[outmostLabelIdx]);
        var innerLabelLayout = (0, $49e8be5a460de8c7$export$471916f4e89eb5da)(labelLayoutList[innerLabelIdx]);
        var scale = axis.scale;
        if (!outmostLabelLayout || !innerLabelLayout) return;
        if (showMinMaxLabelOption == null) {
            if (!optionHideOverlap && customValuesOption) // In this case, users are unlikely to expect labels to be hidden.
            return;
            var tick = $f026cfe0f7218100$export$c392b818a26a879e(outmostLabelLayout.label).labelInfo.tick;
            if (// TimeScale does not expand extent to "nice", so eliminate labels that are not nice.
            (0, $f976678a0ff027db$export$c9b71a3750db342f)(scale) && tick.notNice || (0, $f976678a0ff027db$export$61579433626afe87)(scale) && tick.offInterval) {
                $f026cfe0f7218100$var$ignoreEl(outmostLabelLayout.label);
                return;
            }
        }
        if (showMinMaxLabelOption === false || outmostLabelLayout.suggestIgnore) {
            $f026cfe0f7218100$var$ignoreEl(outmostLabelLayout.label);
            return;
        }
        if (innerLabelLayout.suggestIgnore) {
            $f026cfe0f7218100$var$ignoreEl(innerLabelLayout.label);
            return;
        }
        // PENDING: Originally we thought `optionHideOverlap === false` means do not hide anything,
        //  since currently the bounding rect of text might not accurate enough and might slightly bigger,
        //  which causes false positive. But `optionHideOverlap: null/undfined` is falsy and likely
        //  be treated as false.
        // In most fonts the glyph does not reach the boundary of the bounding rect.
        // This is needed to avoid too aggressive to hide two elements that meet at the edge
        // due to compact layout by the same bounding rect or OBB.
        var touchThreshold = 0.1;
        // This treatment is for backward compatibility. And `!optionHideOverlap` implies that
        // the user accepts the visual touch between adjacent labels, thus "hide min/max label"
        // should be conservative, since the space might be sufficient in this case.
        if (!optionHideOverlap) {
            var marginForce = [
                0,
                0,
                0,
                0
            ];
            // Make a copy to apply `ignoreMargin`.
            outmostLabelLayout = (0, $49e8be5a460de8c7$export$a1cfd37e9b88106b)({
                marginForce: marginForce
            }, outmostLabelLayout);
            innerLabelLayout = (0, $49e8be5a460de8c7$export$a1cfd37e9b88106b)({
                marginForce: marginForce
            }, innerLabelLayout);
        }
        if ((0, $49e8be5a460de8c7$export$f28bfabef115ba96)(outmostLabelLayout, innerLabelLayout, null, {
            touchThreshold: touchThreshold
        })) {
            if (showMinMaxLabelOption) $f026cfe0f7218100$var$ignoreEl(innerLabelLayout.label);
            else $f026cfe0f7218100$var$ignoreEl(outmostLabelLayout.label);
        }
    }
    // If min or max are user set, we need to check
    // If the tick on min(max) are overlap on their neighbour tick
    // If they are overlapped, we need to hide the min(max) tick label
    var showMinLabelOption = axisModel.get([
        'axisLabel',
        'showMinLabel'
    ]);
    var showMaxLabelOption = axisModel.get([
        'axisLabel',
        'showMaxLabel'
    ]);
    var labelsLen = labelLayoutList.length;
    deal(showMinLabelOption, 0, 1);
    deal(showMaxLabelOption, labelsLen - 1, labelsLen - 2);
}
// Under default settings, it is visually odd to display a tick without its label,
// since ticks extend from axis line towards labels and serve as visual guide.
// PENDING: Is there opposite cases?
function $f026cfe0f7218100$var$syncLabelIgnoreToMajorTicks(cfg, labelLayoutList, tickEls) {
    if (cfg.showMinorTicks) // It probably unreasonable to hide major ticks when show minor ticks.
    return;
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(labelLayoutList, function(labelLayout) {
        if (labelLayout && labelLayout.label.ignore) for(var idx = 0; idx < tickEls.length; idx++){
            var tickEl = tickEls[idx];
            // Assume small array, linear search is fine for performance.
            // PENDING: measure?
            var tickInner = $f026cfe0f7218100$var$getTickInner(tickEl);
            var labelInner = $f026cfe0f7218100$export$c392b818a26a879e(labelLayout.label);
            if (tickInner.tickValue != null && !tickInner.onBand && tickInner.tickValue === labelInner.labelInfo.tick.value) {
                $f026cfe0f7218100$var$ignoreEl(tickEl);
                return;
            }
        }
    });
}
function $f026cfe0f7218100$var$ignoreEl(el) {
    el && (el.ignore = true);
}
function $f026cfe0f7218100$var$createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, anidPrefix) {
    var tickEls = [];
    var pt1 = [];
    var pt2 = [];
    for(var i = 0; i < ticksCoords.length; i++){
        var tickCoord = ticksCoords[i].coord;
        pt1[0] = tickCoord;
        pt1[1] = 0;
        pt2[0] = tickCoord;
        pt2[1] = tickEndCoord;
        if (tickTransform) {
            (0, $f79ec7ea1294b339$export$9f9dcb98c894b623)(pt1, pt1, tickTransform);
            (0, $f79ec7ea1294b339$export$9f9dcb98c894b623)(pt2, pt2, tickTransform);
        }
        // Tick line, Not use group transform to have better line draw
        var tickEl = new $b37b447960e3414d$export$2e2bcd8739ae039({
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: tickLineStyle,
            z2: 2,
            autoBatch: true,
            silent: true
        });
        $bce1f681c7fb2581$export$8b4b620d7f4aad1b(tickEl.shape, tickEl.style.lineWidth);
        tickEl.anid = anidPrefix + '_' + ticksCoords[i].tickValue;
        tickEls.push(tickEl);
        var inner = $f026cfe0f7218100$var$getTickInner(tickEl);
        inner.onBand = !!ticksCoords[i].onBand;
        inner.tickValue = ticksCoords[i].tickValue;
    }
    return tickEls;
}
function $f026cfe0f7218100$var$buildAxisMajorTicks(cfg, group, transformGroup, axisModel) {
    var axis = axisModel.axis;
    var tickModel = axisModel.getModel('axisTick');
    var shown = tickModel.get('show');
    if (shown === 'auto') {
        shown = true;
        if (cfg.raw.axisTickAutoShow != null) shown = !!cfg.raw.axisTickAutoShow;
    }
    if (!shown || axis.scale.isBlank()) return [];
    var lineStyleModel = tickModel.getModel('lineStyle');
    var tickEndCoord = cfg.tickDirection * tickModel.get('length');
    var ticksCoords = axis.getTicksCoords();
    var ticksEls = $f026cfe0f7218100$var$createTicks(ticksCoords, transformGroup.transform, tickEndCoord, (0, $f16f2994a32ad273$export$ebe90cb607ad99e)(lineStyleModel.getLineStyle(), {
        stroke: axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ])
    }), 'ticks');
    for(var i = 0; i < ticksEls.length; i++)group.add(ticksEls[i]);
    return ticksEls;
}
function $f026cfe0f7218100$var$buildAxisMinorTicks(cfg, group, transformGroup, axisModel, tickDirection) {
    var axis = axisModel.axis;
    var minorTickModel = axisModel.getModel('minorTick');
    if (!cfg.showMinorTicks || axis.scale.isBlank()) return;
    var minorTicksCoords = axis.getMinorTicksCoords();
    if (!minorTicksCoords.length) return;
    var lineStyleModel = minorTickModel.getModel('lineStyle');
    var tickEndCoord = tickDirection * minorTickModel.get('length');
    var minorTickLineStyle = (0, $f16f2994a32ad273$export$ebe90cb607ad99e)(lineStyleModel.getLineStyle(), (0, $f16f2994a32ad273$export$ebe90cb607ad99e)(axisModel.getModel('axisTick').getLineStyle(), {
        stroke: axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ])
    }));
    for(var i = 0; i < minorTicksCoords.length; i++){
        var minorTicksEls = $f026cfe0f7218100$var$createTicks(minorTicksCoords[i], transformGroup.transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);
        for(var k = 0; k < minorTicksEls.length; k++)group.add(minorTicksEls[k]);
    }
}
// Return whether need to call `layOutAxisTickLabel` again.
function $f026cfe0f7218100$var$dealLastTickLabelResultReusable(local, group, extraParams) {
    if ($f026cfe0f7218100$var$axisLabelBuildResultExists(local)) {
        var axisLabelsCreationContext = local.axisLabelsCreationContext;
        var noPxChangeTryDetermine = axisLabelsCreationContext.out.noPxChangeTryDetermine;
        if (extraParams.noPxChange) {
            var canDetermine = true;
            for(var idx = 0; idx < noPxChangeTryDetermine.length; idx++)canDetermine = canDetermine && noPxChangeTryDetermine[idx]();
            if (canDetermine) return false;
        }
        if (noPxChangeTryDetermine.length) {
            // Remove the result of `buildAxisLabel`
            group.remove(local.labelGroup);
            $f026cfe0f7218100$var$axisLabelBuildResultSet(local, null, null, null);
        }
    }
    return true;
}
function $f026cfe0f7218100$var$buildAxisLabel(cfg, local, group, kind, axisModel, api) {
    var axis = axisModel.axis;
    var show = (0, $f16f2994a32ad273$export$8a4d17b6e8486e66)(cfg.raw.axisLabelShow, axisModel.get([
        'axisLabel',
        'show'
    ]));
    var labelGroup = new $ac4abc1f547da31a$export$2e2bcd8739ae039();
    group.add(labelGroup);
    var axisLabelCreationCtx = (0, $08a2e2b0d4c9ee4c$export$12d6ac38274c43e7)(kind);
    if (!show || axis.scale.isBlank()) {
        $f026cfe0f7218100$var$axisLabelBuildResultSet(local, [], labelGroup, axisLabelCreationCtx);
        return;
    }
    var labelModel = axisModel.getModel('axisLabel');
    var labels = axis.getViewLabels(axisLabelCreationCtx);
    // Special label rotate.
    var labelRotation = ((0, $f16f2994a32ad273$export$8a4d17b6e8486e66)(cfg.raw.labelRotate, labelModel.get('rotate')) || 0) * $f026cfe0f7218100$var$PI / 180;
    var labelLayout = $f026cfe0f7218100$var$AxisBuilder.innerTextLayout(cfg.rotation, labelRotation, cfg.labelDirection);
    var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
    var labelEls = [];
    var triggerEvent = axisModel.get('triggerEvent');
    var z2Min = Infinity;
    var z2Max = -Infinity;
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(labels, function(labelItem, index) {
        var _a;
        var labelItemTick = labelItem.tick;
        var formattedLabel = labelItem.formattedLabel;
        var rawLabel = labelItem.rawLabel;
        var itemLabelModel = labelModel;
        var tickValue = (0, $5197eaeff9ee5dfb$export$889d2956111fd257)(axis.scale, labelItemTick);
        if (rawCategoryData && rawCategoryData[tickValue]) {
            var rawCategoryItem = rawCategoryData[tickValue];
            if ((0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(rawCategoryItem) && rawCategoryItem.textStyle) itemLabelModel = new (0, $37821cf56da37613$export$2e2bcd8739ae039)(rawCategoryItem.textStyle, labelModel, axisModel.ecModel);
        }
        var textColor = itemLabelModel.getTextColor() || axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ]);
        var align = itemLabelModel.getShallow('align', true) || labelLayout.textAlign;
        var alignMin = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(itemLabelModel.getShallow('alignMinLabel', true), align);
        var alignMax = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(itemLabelModel.getShallow('alignMaxLabel', true), align);
        var verticalAlign = itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign;
        var verticalAlignMin = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(itemLabelModel.getShallow('verticalAlignMinLabel', true), verticalAlign);
        var verticalAlignMax = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(itemLabelModel.getShallow('verticalAlignMaxLabel', true), verticalAlign);
        var z2 = 10 + (((_a = labelItemTick.time) === null || _a === void 0 ? void 0 : _a.level) || 0);
        z2Min = Math.min(z2Min, z2);
        z2Max = Math.max(z2Max, z2);
        var textEl = new $7d5e7dc1581f8c9a$export$2e2bcd8739ae039({
            // --- transform props start ---
            // All of the transform props MUST not be set here, but should be set in
            // `updateAxisLabelChangableProps`, because they may change in estimation,
            // and need to calculate based on global coord sys by `decomposeTransform`.
            x: 0,
            y: 0,
            rotation: 0,
            // --- transform props end ---
            silent: $f026cfe0f7218100$var$AxisBuilder.isLabelSilent(axisModel),
            z2: z2,
            style: (0, $1ee9c8b909b7ca82$export$f8998c3d0a13de59)(itemLabelModel, {
                text: formattedLabel,
                align: index === 0 ? alignMin : index === labels.length - 1 ? alignMax : align,
                verticalAlign: index === 0 ? verticalAlignMin : index === labels.length - 1 ? verticalAlignMax : verticalAlign,
                fill: (0, $f16f2994a32ad273$export$f6e2535fb5126e54)(textColor) ? textColor(// (1) In category axis with data zoom, tick is not the original
                // index of axis.data. So tick should not be exposed to user
                // in category axis.
                // (2) Compatible with previous version, which always use formatted label as
                // input. But in interval scale the formatted label is like '223,445', which
                // maked user replace ','. So we modify it to return original val but remain
                // it as 'string' to avoid error in replacing.
                axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
            })
        });
        textEl.anid = 'label_' + tickValue;
        var inner = $f026cfe0f7218100$export$c392b818a26a879e(textEl);
        inner.labelInfo = labelItem;
        inner.layoutRotation = labelLayout.rotation;
        $bce1f681c7fb2581$export$fc6410d97fab306c({
            el: textEl,
            componentModel: axisModel,
            itemName: formattedLabel,
            formatterParamsExtra: {
                isTruncated: function isTruncated() {
                    return textEl.isTruncated;
                },
                value: rawLabel,
                tickIndex: index
            }
        });
        // Pack data for mouse event
        if (triggerEvent) {
            var eventData = $f026cfe0f7218100$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = 'axisLabel';
            eventData.value = rawLabel;
            eventData.tickIndex = index;
            var labelItemTickBreak = labelItem.tick["break"];
            if (labelItemTickBreak) {
                var labelItemTickBreakParsedBreak = labelItemTickBreak.parsedBreak;
                eventData["break"] = {
                    // type: labelItem.break.type,
                    start: labelItemTickBreakParsedBreak.vmin,
                    end: labelItemTickBreakParsedBreak.vmax
                };
            }
            if (axis.type === 'category') eventData.dataIndex = tickValue;
            (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
            if (labelItemTickBreak) $f026cfe0f7218100$var$addBreakEventHandler(axisModel, api, textEl, labelItemTickBreak);
        }
        labelEls.push(textEl);
        labelGroup.add(textEl);
    });
    var labelLayoutList = (0, $f16f2994a32ad273$export$871de8747c9eaa88)(labelEls, function(label) {
        return {
            label: label,
            priority: $f026cfe0f7218100$export$c392b818a26a879e(label).labelInfo.tick["break"] ? label.z2 + (z2Max - z2Min + 1 // Make break labels be highest priority.
            ) : label.z2,
            defaultAttr: {
                ignore: label.ignore
            }
        };
    });
    $f026cfe0f7218100$var$axisLabelBuildResultSet(local, labelLayoutList, labelGroup, axisLabelCreationCtx);
}
// Indicate that `layOutAxisTickLabel` has been called.
function $f026cfe0f7218100$var$axisLabelBuildResultExists(local) {
    return !!local.labelLayoutList;
}
function $f026cfe0f7218100$var$axisLabelBuildResultSet(local, labelLayoutList, labelGroup, axisLabelsCreationContext) {
    // Ensure the same lifetime.
    local.labelLayoutList = labelLayoutList;
    local.labelGroup = labelGroup;
    local.axisLabelsCreationContext = axisLabelsCreationContext;
}
function $f026cfe0f7218100$var$updateAxisLabelChangableProps(cfg, axisModel, labelLayoutList, transformGroup) {
    var labelMargin = axisModel.get([
        'axisLabel',
        'margin'
    ]);
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(labelLayoutList, function(layout, idx) {
        var geometry = (0, $49e8be5a460de8c7$export$471916f4e89eb5da)(layout);
        if (!geometry) return;
        var labelEl = geometry.label;
        var inner = $f026cfe0f7218100$export$c392b818a26a879e(labelEl);
        // See the comment in `suggestIgnore`.
        geometry.suggestIgnore = labelEl.ignore;
        // Currently no `ignore:true` is set in `buildAxisLabel`
        // But `ignore:true` may be set subsequently for overlap handling, thus reset it here.
        labelEl.ignore = false;
        (0, $ad30ab15d8ed0f32$export$234b1c16dfa57d6a)($f026cfe0f7218100$var$_tmpLayoutEl, $f026cfe0f7218100$var$_tmpLayoutElReset);
        var axis = axisModel.axis;
        $f026cfe0f7218100$var$_tmpLayoutEl.x = axis.dataToCoord((0, $5197eaeff9ee5dfb$export$889d2956111fd257)(axis.scale, inner.labelInfo.tick));
        $f026cfe0f7218100$var$_tmpLayoutEl.y = cfg.labelOffset + cfg.labelDirection * labelMargin;
        $f026cfe0f7218100$var$_tmpLayoutEl.rotation = inner.layoutRotation;
        transformGroup.add($f026cfe0f7218100$var$_tmpLayoutEl);
        $f026cfe0f7218100$var$_tmpLayoutEl.updateTransform();
        transformGroup.remove($f026cfe0f7218100$var$_tmpLayoutEl);
        $f026cfe0f7218100$var$_tmpLayoutEl.decomposeTransform();
        (0, $ad30ab15d8ed0f32$export$234b1c16dfa57d6a)(labelEl, $f026cfe0f7218100$var$_tmpLayoutEl);
        labelEl.markRedraw();
        (0, $49e8be5a460de8c7$export$1551ece3f059eafb)(geometry, true);
        (0, $49e8be5a460de8c7$export$471916f4e89eb5da)(geometry);
    });
}
var $f026cfe0f7218100$var$_tmpLayoutEl = new $dbd6d77105f10fb2$export$2e2bcd8739ae039();
var $f026cfe0f7218100$var$_tmpLayoutElReset = new $dbd6d77105f10fb2$export$2e2bcd8739ae039();
function $f026cfe0f7218100$var$hasAxisName(axisName) {
    return !!axisName;
}
function $f026cfe0f7218100$var$addBreakEventHandler(axisModel, api, textEl, visualBreak) {
    textEl.on('click', function(params) {
        var payload = {
            type: (0, $1365515cace27ec6$export$12319e2083cd71ce),
            breaks: [
                {
                    start: visualBreak.parsedBreak.breakOption.start,
                    end: visualBreak.parsedBreak.breakOption.end
                }
            ]
        };
        payload[axisModel.axis.dim + "AxisIndex"] = axisModel.componentIndex;
        api.dispatchAction(payload);
    });
}
function $f026cfe0f7218100$var$adjustBreakLabels(axisModel, axisRotation, labelLayoutList) {
    var scaleBreakHelper = (0, $cf43ca9fea251347$export$e79b20ac82c2d660)();
    if (!scaleBreakHelper) return;
    var breakLabelIndexPairs = scaleBreakHelper.retrieveAxisBreakPairs(labelLayoutList, function(layoutInfo) {
        return layoutInfo && $f026cfe0f7218100$export$c392b818a26a879e(layoutInfo.label).labelInfo.tick["break"];
    }, true);
    var moveOverlap = axisModel.get([
        'breakLabelLayout',
        'moveOverlap'
    ], true);
    if (moveOverlap === true || moveOverlap === 'auto') (0, $f16f2994a32ad273$export$79b2f7037acddd43)(breakLabelIndexPairs, function(idxPair) {
        (0, $fc815de52b491ed4$export$c1d9b2cc33e7e5e)().adjustBreakLabelPair(axisModel.axis.inverse, axisRotation, [
            (0, $49e8be5a460de8c7$export$471916f4e89eb5da)(labelLayoutList[idxPair[0]]),
            (0, $49e8be5a460de8c7$export$471916f4e89eb5da)(labelLayoutList[idxPair[1]])
        ]);
    });
}
var $f026cfe0f7218100$export$2e2bcd8739ae039 = $f026cfe0f7218100$var$AxisBuilder;





function $6e388b4363a8baf1$export$b7fe459c7cc50060(axisPointerModel) {
    var axisPointerType = axisPointerModel.get('type');
    var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
    var style;
    if (axisPointerType === 'line') {
        style = styleModel.getLineStyle();
        style.fill = null;
    } else if (axisPointerType === 'shadow') {
        style = styleModel.getAreaStyle();
        style.stroke = null;
    }
    return style;
}
function $6e388b4363a8baf1$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos) {
    var value = axisPointerModel.get('value');
    var text = $6e388b4363a8baf1$export$7cffee0f9aed39d0(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
        precision: axisPointerModel.get([
            'label',
            'precision'
        ]),
        formatter: axisPointerModel.get([
            'label',
            'formatter'
        ])
    });
    var labelModel = axisPointerModel.getModel('label');
    var paddings = $04bb9ff155ec4ccd$export$f3a38102c49f4268(labelModel.get('padding') || 0);
    var font = labelModel.getFont();
    var textRect = $3ad1e5e308f2a981$export$c381147bfed79d9f(text, font);
    var position = labelPos.position;
    var width = textRect.width + paddings[1] + paddings[3];
    var height = textRect.height + paddings[0] + paddings[2];
    // Adjust by align.
    var align = labelPos.align;
    align === 'right' && (position[0] -= width);
    align === 'center' && (position[0] -= width / 2);
    var verticalAlign = labelPos.verticalAlign;
    verticalAlign === 'bottom' && (position[1] -= height);
    verticalAlign === 'middle' && (position[1] -= height / 2);
    // Not overflow ec container
    $6e388b4363a8baf1$var$confineInContainer(position, width, height, api);
    var bgColor = labelModel.get('backgroundColor');
    if (!bgColor || bgColor === 'auto') bgColor = axisModel.get([
        'axisLine',
        'lineStyle',
        'color'
    ]);
    elOption.label = {
        // shape: {x: 0, y: 0, width: width, height: height, r: labelModel.get('borderRadius')},
        x: position[0],
        y: position[1],
        style: (0, $1ee9c8b909b7ca82$export$f8998c3d0a13de59)(labelModel, {
            text: text,
            font: font,
            fill: labelModel.getTextColor(),
            padding: paddings,
            backgroundColor: bgColor
        }),
        // Label should be over axisPointer.
        z2: 10
    };
}
// Do not overflow ec container
function $6e388b4363a8baf1$var$confineInContainer(position, width, height, api) {
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    position[0] = Math.min(position[0] + width, viewWidth) - width;
    position[1] = Math.min(position[1] + height, viewHeight) - height;
    position[0] = Math.max(position[0], 0);
    position[1] = Math.max(position[1], 0);
}
function $6e388b4363a8baf1$export$7cffee0f9aed39d0(value, axis, ecModel, seriesDataIndices, opt) {
    value = axis.scale.parse(value);
    var text = axis.scale.getLabel({
        value: value
    }, {
        // If `precision` is set, width can be fixed (like '12.00500'), which
        // helps to debounce when when moving label.
        precision: opt.precision
    });
    var formatter = opt.formatter;
    if (formatter) {
        var params_1 = {
            value: $5197eaeff9ee5dfb$export$a5a32f324c1fa457(axis, {
                value: value
            }),
            axisDimension: axis.dim,
            axisIndex: axis.index,
            seriesData: []
        };
        $f16f2994a32ad273$export$79b2f7037acddd43(seriesDataIndices, function(idxItem) {
            var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
            var dataIndex = idxItem.dataIndexInside;
            var dataParams = series && series.getDataParams(dataIndex);
            dataParams && params_1.seriesData.push(dataParams);
        });
        if ($f16f2994a32ad273$export$844ec244b1367d54(formatter)) text = formatter.replace('{value}', text);
        else if ($f16f2994a32ad273$export$f6e2535fb5126e54(formatter)) text = formatter(params_1);
    }
    return text;
}
function $6e388b4363a8baf1$export$4bb66440324c3a3d(axis, value, layoutInfo) {
    var transform = $45a6d43b639a6412$export$185802fd694ee1f5();
    $45a6d43b639a6412$export$bb628a54ab399bc9(transform, transform, layoutInfo.rotation);
    $45a6d43b639a6412$export$d73ee8ef04f5226a(transform, transform, layoutInfo.position);
    return $bce1f681c7fb2581$export$9f9dcb98c894b623([
        axis.dataToCoord(value),
        (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)
    ], transform);
}
function $6e388b4363a8baf1$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
    var textLayout = (0, $f026cfe0f7218100$export$2e2bcd8739ae039).innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
    layoutInfo.labelMargin = axisPointerModel.get([
        'label',
        'margin'
    ]);
    $6e388b4363a8baf1$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, {
        position: $6e388b4363a8baf1$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo),
        align: textLayout.textAlign,
        verticalAlign: textLayout.textVerticalAlign
    });
}
function $6e388b4363a8baf1$export$885fa0ad5a826207(p1, p2, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x1: p1[xDimIndex],
        y1: p1[1 - xDimIndex],
        x2: p2[xDimIndex],
        y2: p2[1 - xDimIndex]
    };
}
function $6e388b4363a8baf1$export$a8b35248bcc02756(xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x: xy[xDimIndex],
        y: xy[1 - xDimIndex],
        width: wh[xDimIndex],
        height: wh[1 - xDimIndex]
    };
}
function $6e388b4363a8baf1$export$b0cf82e7ebc0d7d0(cx, cy, r0, r, startAngle, endAngle) {
    return {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r,
        startAngle: startAngle,
        endAngle: endAngle,
        clockwise: true
    };
}
function $6e388b4363a8baf1$export$19cae73ec299246f(axis, seriesDataIndices, ecModel) {
    return (0, $4f7015271e7d3825$export$141021262b29d96e)(axis, {
        fromStat: {
            sers: $f16f2994a32ad273$export$871de8747c9eaa88(seriesDataIndices, function(item) {
                return ecModel.getSeriesByIndex(item.seriesIndex);
            })
        },
        min: 1
    }).w;
}
function $6e388b4363a8baf1$export$a1c116ca0a73a1a2(val, axisExtent, bandWidth) {
    return [
        (0, $104896d282bd296f$export$2ca8010d037f830f)((0, $104896d282bd296f$export$e411eeaf23dccbe8)(axisExtent[0], axisExtent[1]), val - bandWidth / 2),
        (0, $104896d282bd296f$export$e411eeaf23dccbe8)(val + bandWidth / 2, (0, $104896d282bd296f$export$2ca8010d037f830f)(axisExtent[0], axisExtent[1]))
    ];
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



function $d0095b1b8a21cc3f$export$b3219800bda33a1f(rect, axisModel, opt) {
    opt = opt || {};
    var axis = axisModel.axis;
    var layout = {};
    var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
    var rawAxisPosition = axis.position;
    var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
    var axisDim = axis.dim;
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var idx = {
        left: 0,
        right: 1,
        top: 0,
        bottom: 1,
        onZero: 2
    };
    var axisOffset = axisModel.get('offset') || 0;
    var posBound = axisDim === 'x' ? [
        rectBound[2] - axisOffset,
        rectBound[3] + axisOffset
    ] : [
        rectBound[0] - axisOffset,
        rectBound[1] + axisOffset
    ];
    if (otherAxisOnZeroOf) {
        var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
        posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
    }
    // Axis position
    layout.position = [
        axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0],
        axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]
    ];
    // Axis rotation
    layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1);
    // Tick and label direction, x y is axisDim
    var dirMap = {
        top: -1,
        bottom: 1,
        left: -1,
        right: 1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
    layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
    if (axisModel.get([
        'axisTick',
        'inside'
    ])) layout.tickDirection = -layout.tickDirection;
    if ($f16f2994a32ad273$export$8a4d17b6e8486e66(opt.labelInside, axisModel.get([
        'axisLabel',
        'inside'
    ]))) layout.labelDirection = -layout.labelDirection;
    // Special label rotation
    var labelRotate = axisModel.get([
        'axisLabel',
        'rotate'
    ]);
    layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate;
    // Over splitLine and splitArea
    layout.z2 = 1;
    return layout;
}
function $d0095b1b8a21cc3f$export$1a2a248dbebc52b5(seriesModel) {
    return seriesModel.get('coordinateSystem') === 'cartesian2d';
}
function $d0095b1b8a21cc3f$export$e447722773749af(seriesModel) {
    return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
}
function $d0095b1b8a21cc3f$export$8220131ac1d61d28(seriesModel) {
    var axisModelMap = {
        xAxisModel: null,
        yAxisModel: null
    };
    $f16f2994a32ad273$export$79b2f7037acddd43(axisModelMap, function(v, key) {
        var axisType = key.replace(/Model$/, '');
        var axisModel = seriesModel.getReferringComponents(axisType, (0, $3fa81475350067fd$export$f076738ec84e693c)).models[0];
        axisModelMap[key] = axisModel;
    });
    return axisModelMap;
}
function $d0095b1b8a21cc3f$export$2b2ce820c3e1e776(gridRect, cartesians, axisModel, api, ctx, defaultNameMoveOverlap) {
    var layoutResult = $d0095b1b8a21cc3f$export$b3219800bda33a1f(gridRect, axisModel);
    var axisLineAutoShow = false;
    var axisTickAutoShow = false;
    // Not show axisTick or axisLine if other axis is category / time
    for(var i = 0; i < cartesians.length; i++)if ((0, $f976678a0ff027db$export$dfc8cd28ed7b22a0)(cartesians[i].getOtherAxis(axisModel.axis).scale)) {
        // Still show axis tick or axisLine if other axis is value / log
        axisLineAutoShow = axisTickAutoShow = true;
        if (axisModel.axis.type === 'category' && axisModel.axis.onBand) axisTickAutoShow = false;
    }
    layoutResult.axisLineAutoShow = axisLineAutoShow;
    layoutResult.axisTickAutoShow = axisTickAutoShow;
    layoutResult.defaultNameMoveOverlap = defaultNameMoveOverlap;
    return new (0, $f026cfe0f7218100$export$2e2bcd8739ae039)(axisModel, api, layoutResult, ctx);
}
function $d0095b1b8a21cc3f$export$3e8d41f03e1a6a39(axisBuilder, gridRect, axisModel) {
    var newRaw = $d0095b1b8a21cc3f$export$b3219800bda33a1f(gridRect, axisModel);
    var oldRaw_1;
    axisBuilder.updateCfg(newRaw);
}
function $d0095b1b8a21cc3f$export$3fa527f4e8efeff2(axis) {
    return axis.dim + '_' + axis.index;
}



var $c39488f411b881cf$var$CartesianAxisPointer = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(CartesianAxisPointer, _super);
    function CartesianAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ CartesianAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisPointerType = axisPointerModel.get('type');
        var thisExtent = axis.getGlobalExtent();
        var otherExtent = $c39488f411b881cf$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
        if (axisPointerType && axisPointerType !== 'none') {
            var elStyle = $6e388b4363a8baf1$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $c39488f411b881cf$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, thisExtent, otherExtent, axisPointerModel.get('seriesDataIndices'), axisPointerModel.ecModel);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $d0095b1b8a21cc3f$export$b3219800bda33a1f(grid.getRect(), axisModel);
        $6e388b4363a8baf1$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
        var layoutInfo = $d0095b1b8a21cc3f$export$b3219800bda33a1f(axisModel.axis.grid.getRect(), axisModel, {
            labelInside: false
        });
        layoutInfo.labelMargin = axisPointerModel.get([
            'handle',
            'margin'
        ]);
        var pos = $6e388b4363a8baf1$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo);
        return {
            x: pos[0],
            y: pos[1],
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisExtent = axis.getGlobalExtent(true);
        var otherExtent = $c39488f411b881cf$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var dimIndex = axis.dim === 'x' ? 0 : 1;
        var currPosition = [
            transform.x,
            transform.y
        ];
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = (0, $104896d282bd296f$export$e411eeaf23dccbe8)(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = (0, $104896d282bd296f$export$2ca8010d037f830f)(axisExtent[0], currPosition[dimIndex]);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex];
        // Make tooltip do not overlap axisPointer and in the middle of the grid.
        var tooltipOptions = [
            {
                verticalAlign: 'middle'
            },
            {
                align: 'center'
            }
        ];
        return {
            x: currPosition[0],
            y: currPosition[1],
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: tooltipOptions[dimIndex]
        };
    };
    return CartesianAxisPointer;
}((0, $c3b912bf0217d820$export$2e2bcd8739ae039));
function $c39488f411b881cf$var$getCartesian(grid, axis) {
    var opt = {};
    opt[axis.dim + 'AxisIndex'] = axis.index;
    return grid.getCartesian(opt);
}
var $c39488f411b881cf$var$pointerShapeBuilder = {
    line: function line(axis, pixelValue, thisExtent, otherExtent) {
        var targetShape = $6e388b4363a8baf1$export$885fa0ad5a826207([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $c39488f411b881cf$var$getAxisDimIndex(axis));
        return {
            type: 'Line',
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function shadow(axis, pixelValue, thisExtent, otherExtent, seriesDataIndices, ecModel) {
        var bandWidth = $6e388b4363a8baf1$export$19cae73ec299246f(axis, seriesDataIndices, ecModel);
        var otherSpan = otherExtent[1] - otherExtent[0];
        var _a = $6e388b4363a8baf1$export$a1c116ca0a73a1a2(pixelValue, thisExtent, bandWidth), min = _a[0], max = _a[1];
        return {
            type: 'Rect',
            shape: $6e388b4363a8baf1$export$a8b35248bcc02756([
                min,
                otherExtent[0]
            ], [
                max - min,
                otherSpan
            ], $c39488f411b881cf$var$getAxisDimIndex(axis))
        };
    }
};
function $c39488f411b881cf$var$getAxisDimIndex(axis) {
    return axis.dim === 'x' ? 0 : 1;
}
var $c39488f411b881cf$export$2e2bcd8739ae039 = $c39488f411b881cf$var$CartesianAxisPointer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $ec589b0802763b2b$var$AxisPointerModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(AxisPointerModel, _super);
    function AxisPointerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerModel.type;
        return _this;
    }
    AxisPointerModel.type = 'axisPointer';
    AxisPointerModel.defaultOption = {
        // 'auto' means that show when triggered by tooltip or handle.
        show: 'auto',
        // zlevel: 0,
        z: 50,
        type: 'line',
        // axispointer triggered by tootip determine snap automatically,
        // see `modelHelper`.
        snap: false,
        triggerTooltip: true,
        triggerEmphasis: true,
        value: null,
        status: null,
        link: [],
        // Do not set 'auto' here, otherwise global animation: false
        // will not effect at this axispointer.
        animation: null,
        animationDurationUpdate: 200,
        lineStyle: {
            color: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.border,
            width: 1,
            type: 'dashed'
        },
        shadowStyle: {
            color: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.shadowTint
        },
        label: {
            show: true,
            formatter: null,
            precision: 'auto',
            margin: 3,
            color: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.neutral00,
            padding: [
                5,
                7,
                5,
                7
            ],
            backgroundColor: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.accent60,
            borderColor: null,
            borderWidth: 0,
            borderRadius: 3
        },
        handle: {
            show: false,
            // eslint-disable-next-line
            icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
            size: 45,
            // handle margin is from symbol center to axis, which is stable when circular move.
            margin: 50,
            // color: '#1b8bbd'
            // color: '#2f4554'
            color: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.accent40,
            // For mobile performance
            throttle: 40
        }
    };
    return AxisPointerModel;
}((0, $c418de54527e13f3$export$2e2bcd8739ae039));
var $ec589b0802763b2b$export$2e2bcd8739ae039 = $ec589b0802763b2b$var$AxisPointerModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $4e1f584bde7bfd0c$var$inner = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
var $4e1f584bde7bfd0c$var$each = $f16f2994a32ad273$export$79b2f7037acddd43;
function $4e1f584bde7bfd0c$export$6503ec6e8aabbaf(key, api, handler) {
    if ((0, $6d0397515b55cc48$export$2e2bcd8739ae039).node) return;
    var zr = api.getZr();
    $4e1f584bde7bfd0c$var$inner(zr).records || ($4e1f584bde7bfd0c$var$inner(zr).records = {});
    $4e1f584bde7bfd0c$var$initGlobalListeners(zr, api);
    var record = $4e1f584bde7bfd0c$var$inner(zr).records[key] || ($4e1f584bde7bfd0c$var$inner(zr).records[key] = {});
    record.handler = handler;
}
function $4e1f584bde7bfd0c$var$initGlobalListeners(zr, api) {
    if ($4e1f584bde7bfd0c$var$inner(zr).initialized) return;
    $4e1f584bde7bfd0c$var$inner(zr).initialized = true;
    useHandler('click', $f16f2994a32ad273$export$c3095a23b368d1f2($4e1f584bde7bfd0c$var$doEnter, 'click'));
    useHandler('mousemove', $f16f2994a32ad273$export$c3095a23b368d1f2($4e1f584bde7bfd0c$var$doEnter, 'mousemove'));
    // For example, dataZoom may update series layout while mousewheel,
    // axisPointer and tooltip need to follow that updates, otherwise,
    // highlighted items (by axisPointer) may have no chance to downplay.
    useHandler('mousewheel', $f16f2994a32ad273$export$c3095a23b368d1f2($4e1f584bde7bfd0c$var$doEnter, 'mousewheel'));
    // useHandler('mouseout', onLeave);
    useHandler('globalout', $4e1f584bde7bfd0c$var$onLeave);
    function useHandler(eventType, cb) {
        zr.on(eventType, function(e) {
            var dis = $4e1f584bde7bfd0c$var$makeDispatchAction(api);
            $4e1f584bde7bfd0c$var$each($4e1f584bde7bfd0c$var$inner(zr).records, function(record) {
                record && cb(record, e, dis.dispatchAction);
            });
            $4e1f584bde7bfd0c$var$dispatchTooltipFinally(dis.pendings, api);
        });
    }
}
function $4e1f584bde7bfd0c$var$dispatchTooltipFinally(pendings, api) {
    var showLen = pendings.showTip.length;
    var hideLen = pendings.hideTip.length;
    var actuallyPayload;
    if (showLen) actuallyPayload = pendings.showTip[showLen - 1];
    else if (hideLen) actuallyPayload = pendings.hideTip[hideLen - 1];
    if (actuallyPayload) {
        actuallyPayload.dispatchAction = null;
        api.dispatchAction(actuallyPayload);
    }
}
function $4e1f584bde7bfd0c$var$onLeave(record, e, dispatchAction) {
    record.handler('leave', null, dispatchAction);
}
function $4e1f584bde7bfd0c$var$doEnter(currTrigger, record, e, dispatchAction) {
    record.handler(currTrigger, e, dispatchAction);
}
function $4e1f584bde7bfd0c$var$makeDispatchAction(api) {
    var pendings = {
        showTip: [],
        hideTip: []
    };
    // FIXME
    // better approach?
    // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
    // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
    // So we have to add "final stage" to merge those dispatched actions.
    var dispatchAction = function dispatchAction1(payload) {
        var pendingList = pendings[payload.type];
        if (pendingList) pendingList.push(payload);
        else {
            payload.dispatchAction = dispatchAction;
            api.dispatchAction(payload);
        }
    };
    return {
        dispatchAction: dispatchAction,
        pendings: pendings
    };
}
function $4e1f584bde7bfd0c$export$d07f55d4c15c0440(key, api) {
    if ((0, $6d0397515b55cc48$export$2e2bcd8739ae039).node) return;
    var zr = api.getZr();
    var record = ($4e1f584bde7bfd0c$var$inner(zr).records || {})[key];
    if (record) $4e1f584bde7bfd0c$var$inner(zr).records[key] = null;
}



var $45d3d5823a3c70d7$var$AxisPointerView = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(AxisPointerView, _super);
    function AxisPointerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerView.type;
        return _this;
    }
    AxisPointerView.prototype.render = function(globalAxisPointerModel, ecModel, api) {
        var globalTooltipModel = ecModel.getComponent('tooltip');
        var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click|mousewheel';
        // Register global listener in AxisPointerView to enable
        // AxisPointerView to be independent to Tooltip.
        $4e1f584bde7bfd0c$export$6503ec6e8aabbaf('axisPointer', api, function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) dispatchAction({
                type: 'updateAxisPointer',
                currTrigger: currTrigger,
                x: e && e.offsetX,
                y: e && e.offsetY
            });
        });
    };
    AxisPointerView.prototype.remove = function(ecModel, api) {
        $4e1f584bde7bfd0c$export$d07f55d4c15c0440('axisPointer', api);
    };
    AxisPointerView.prototype.dispose = function(ecModel, api) {
        $4e1f584bde7bfd0c$export$d07f55d4c15c0440('axisPointer', api);
    };
    AxisPointerView.type = 'axisPointer';
    return AxisPointerView;
}((0, $091798b5bbee0498$export$2e2bcd8739ae039));
var $45d3d5823a3c70d7$export$2e2bcd8739ae039 = $45d3d5823a3c70d7$var$AxisPointerView;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $30e0c6b3134c4dc5$export$2e2bcd8739ae039(finder, ecModel) {
    var point = [];
    var seriesIndex = finder.seriesIndex;
    var seriesModel;
    if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) return {
        point: []
    };
    var data = seriesModel.getData();
    var dataIndex = $3fa81475350067fd$export$42b26cae8b8d10(data, finder);
    if (dataIndex == null || dataIndex < 0 || $f16f2994a32ad273$export$43bee75e5e14138e(dataIndex)) return {
        point: []
    };
    var el = data.getItemGraphicEl(dataIndex);
    var coordSys = seriesModel.coordinateSystem;
    if (seriesModel.getTooltipPosition) point = seriesModel.getTooltipPosition(dataIndex) || [];
    else if (coordSys && coordSys.dataToPoint) {
        if (finder.isStacked) {
            var baseAxis = coordSys.getBaseAxis();
            var valueAxis = coordSys.getOtherAxis(baseAxis);
            var valueAxisDim = valueAxis.dim;
            var baseAxisDim = baseAxis.dim;
            var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
            var baseDim = data.mapDimension(baseAxisDim);
            var stackedData = [];
            stackedData[baseDataOffset] = data.get(baseDim, dataIndex);
            stackedData[1 - baseDataOffset] = data.get(data.getCalculationInfo('stackResultDimension'), dataIndex);
            point = coordSys.dataToPoint(stackedData) || [];
        } else point = coordSys.dataToPoint(data.getValues($f16f2994a32ad273$export$871de8747c9eaa88(coordSys.dimensions, function(dim) {
            return data.mapDimension(dim);
        }), dataIndex)) || [];
    } else if (el) {
        // Use graphic bounding rect
        var rect = el.getBoundingRect().clone();
        rect.applyTransform(el.transform);
        point = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    }
    return {
        point: point,
        el: el
    };
}




var $07160a7fd5ef0de9$var$inner = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
function $07160a7fd5ef0de9$export$2e2bcd8739ae039(payload, ecModel, api) {
    var currTrigger = payload.currTrigger;
    var point = [
        payload.x,
        payload.y
    ];
    var finder = payload;
    var dispatchAction = payload.dispatchAction || (0, $f16f2994a32ad273$export$2385a24977818dd0)(api.dispatchAction, api);
    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
    // Pending
    // See #6121. But we are not able to reproduce it yet.
    if (!coordSysAxesInfo) return;
    if ($07160a7fd5ef0de9$var$illegalPoint(point)) // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = (0, $30e0c6b3134c4dc5$export$2e2bcd8739ae039)({
        seriesIndex: finder.seriesIndex,
        // Do not use dataIndexInside from other ec instance.
        // FIXME: auto detect it?
        dataIndex: finder.dataIndex
    }, ecModel).point;
    var isIllegalPoint = $07160a7fd5ef0de9$var$illegalPoint(point);
    // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
    // Notice: In this case, it is difficult to get the `point` (which is necessary to show
    // tooltip, so if point is not given, we just use the point found by sample seriesIndex
    // and dataIndex.
    var inputAxesInfo = finder.axesInfo;
    var axesInfo = coordSysAxesInfo.axesInfo;
    var shouldHide = currTrigger === 'leave' || $07160a7fd5ef0de9$var$illegalPoint(point);
    var outputPayload = {};
    var showValueMap = {};
    var dataByCoordSys = {
        list: [],
        map: {}
    };
    var updaters = {
        showPointer: (0, $f16f2994a32ad273$export$c3095a23b368d1f2)($07160a7fd5ef0de9$var$showPointer, showValueMap),
        showTooltip: (0, $f16f2994a32ad273$export$c3095a23b368d1f2)($07160a7fd5ef0de9$var$showTooltip, dataByCoordSys)
    };
    // Process for triggered axes.
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(coordSysAxesInfo.coordSysMap, function(coordSys, coordSysKey) {
        // If a point given, it must be contained by the coordinate system.
        var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function(axisInfo, key) {
            var axis = axisInfo.axis;
            var inputAxisInfo = $07160a7fd5ef0de9$var$findInputAxisInfo(inputAxesInfo, axisInfo);
            // If no inputAxesInfo, no axis is restricted.
            if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
                var val = inputAxisInfo && inputAxisInfo.value;
                if (val == null && !isIllegalPoint) val = axis.pointToData(point);
                val != null && $07160a7fd5ef0de9$var$processOnAxis(axisInfo, val, updaters, false, outputPayload);
            }
        });
    });
    // Process for linked axes.
    var linkTriggers = {};
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(axesInfo, function(tarAxisInfo, tarKey) {
        var linkGroup = tarAxisInfo.linkGroup;
        // If axis has been triggered in the previous stage, it should not be triggered by link.
        if (linkGroup && !showValueMap[tarKey]) (0, $f16f2994a32ad273$export$79b2f7037acddd43)(linkGroup.axesInfo, function(srcAxisInfo, srcKey) {
            var srcValItem = showValueMap[srcKey];
            // If srcValItem exist, source axis is triggered, so link to target axis.
            if (srcAxisInfo !== tarAxisInfo && srcValItem) {
                var val = srcValItem.value;
                linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, $07160a7fd5ef0de9$var$makeMapperParam(srcAxisInfo), $07160a7fd5ef0de9$var$makeMapperParam(tarAxisInfo))));
                linkTriggers[tarAxisInfo.key] = val;
            }
        });
    });
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(linkTriggers, function(val, tarKey) {
        $07160a7fd5ef0de9$var$processOnAxis(axesInfo[tarKey], val, updaters, true, outputPayload);
    });
    $07160a7fd5ef0de9$var$updateModelActually(showValueMap, axesInfo, outputPayload);
    $07160a7fd5ef0de9$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
    $07160a7fd5ef0de9$var$dispatchHighDownActually(axesInfo, dispatchAction, api);
    return outputPayload;
}
function $07160a7fd5ef0de9$var$processOnAxis(axisInfo, newValue, updaters, noSnap, outputFinder) {
    var axis = axisInfo.axis;
    if (axis.scale.isBlank() || !axis.containData(newValue)) return;
    if (!axisInfo.involveSeries) {
        updaters.showPointer(axisInfo, newValue);
        return;
    }
    // Heavy calculation. So put it after axis.containData checking.
    var payloadInfo = $07160a7fd5ef0de9$var$buildPayloadsBySeries(newValue, axisInfo);
    var payloadBatch = payloadInfo.payloadBatch;
    var snapToValue = payloadInfo.snapToValue;
    // Fill content of event obj for echarts.connect.
    // By default use the first involved series data as a sample to connect.
    if (payloadBatch[0] && outputFinder.seriesIndex == null) (0, $f16f2994a32ad273$export$8b58be045bf06082)(outputFinder, payloadBatch[0]);
    // If no linkSource input, this process is for collecting link
    // target, where snap should not be accepted.
    if (!noSnap && axisInfo.snap) {
        if (axis.containData(snapToValue) && snapToValue != null) newValue = snapToValue;
    }
    updaters.showPointer(axisInfo, newValue, payloadBatch);
    // Tooltip should always be snapToValue, otherwise there will be
    // incorrect "axis value ~ series value" mapping displayed in tooltip.
    updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}
function $07160a7fd5ef0de9$var$buildPayloadsBySeries(value, axisInfo) {
    var axis = axisInfo.axis;
    var dim = axis.dim;
    var snapToValue = value;
    var payloadBatch = [];
    var minDist = Number.MAX_VALUE;
    var minDiff = -1;
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(axisInfo.seriesModels, function(series, idx) {
        var dataDim = series.getData().mapDimensionsAll(dim);
        var seriesNestestValue;
        var dataIndices;
        if (series.getAxisTooltipData) {
            var result = series.getAxisTooltipData(dataDim, value, axis);
            dataIndices = result.dataIndices;
            seriesNestestValue = result.nestestValue;
        } else {
            dataIndices = series.indicesOfNearest(dim, dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
            // when data length is not same.
            // false,
            axis.type === 'category' ? 0.5 : null);
            if (!dataIndices.length) return;
            seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
        }
        if (!(0, $104896d282bd296f$export$b5c30d4208814a65)(seriesNestestValue)) return;
        var diff = value - seriesNestestValue;
        var dist = Math.abs(diff);
        // Consider category case
        if (dist <= minDist) {
            if (dist < minDist || diff >= 0 && minDiff < 0) {
                minDist = dist;
                minDiff = diff;
                snapToValue = seriesNestestValue;
                payloadBatch.length = 0;
            }
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)(dataIndices, function(dataIndex) {
                payloadBatch.push({
                    seriesIndex: series.seriesIndex,
                    dataIndexInside: dataIndex,
                    dataIndex: series.getData().getRawIndex(dataIndex)
                });
            });
        }
    });
    return {
        payloadBatch: payloadBatch,
        snapToValue: snapToValue
    };
}
function $07160a7fd5ef0de9$var$showPointer(showValueMap, axisInfo, value, payloadBatch) {
    showValueMap[axisInfo.key] = {
        value: value,
        payloadBatch: payloadBatch
    };
}
function $07160a7fd5ef0de9$var$showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
    var payloadBatch = payloadInfo.payloadBatch;
    var axis = axisInfo.axis;
    var axisModel = axis.model;
    var axisPointerModel = axisInfo.axisPointerModel;
    // If no data, do not create anything in dataByCoordSys,
    // whose length will be used to judge whether dispatch action.
    if (!axisInfo.triggerTooltip || !payloadBatch.length) return;
    var coordSysModel = axisInfo.coordSys.model;
    var coordSysKey = $5ce9db76a341a244$export$d01b444bafb1a792(coordSysModel);
    var coordSysItem = dataByCoordSys.map[coordSysKey];
    if (!coordSysItem) {
        coordSysItem = dataByCoordSys.map[coordSysKey] = {
            coordSysId: coordSysModel.id,
            coordSysIndex: coordSysModel.componentIndex,
            coordSysType: coordSysModel.type,
            coordSysMainType: coordSysModel.mainType,
            dataByAxis: []
        };
        dataByCoordSys.list.push(coordSysItem);
    }
    coordSysItem.dataByAxis.push({
        axisDim: axis.dim,
        axisIndex: axisModel.componentIndex,
        axisType: axisModel.type,
        axisId: axisModel.id,
        value: value,
        // Caution: viewHelper.getValueLabel is actually on "view stage", which
        // depends that all models have been updated. So it should not be performed
        // here. Considering axisPointerModel used here is volatile, which is hard
        // to be retrieve in TooltipView, we prepare parameters here.
        valueLabelOpt: {
            precision: axisPointerModel.get([
                'label',
                'precision'
            ]),
            formatter: axisPointerModel.get([
                'label',
                'formatter'
            ])
        },
        seriesDataIndices: payloadBatch.slice()
    });
}
function $07160a7fd5ef0de9$var$updateModelActually(showValueMap, axesInfo, outputPayload) {
    var outputAxesInfo = outputPayload.axesInfo = [];
    // Basic logic: If no 'show' required, 'hide' this axisPointer.
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        var valItem = showValueMap[key];
        if (valItem) {
            !axisInfo.useHandle && (option.status = 'show');
            option.value = valItem.value;
            // For label formatter param and highlight.
            option.seriesDataIndices = (valItem.payloadBatch || []).slice();
        } else // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = 'hide');
        // If status is 'hide', should be no info in payload.
        option.status === 'show' && outputAxesInfo.push({
            axisDim: axisInfo.axis.dim,
            axisIndex: axisInfo.axis.model.componentIndex,
            value: option.value
        });
    });
}
function $07160a7fd5ef0de9$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
    // Basic logic: If no showTip required, hideTip will be dispatched.
    if ($07160a7fd5ef0de9$var$illegalPoint(point) || !dataByCoordSys.list.length) {
        dispatchAction({
            type: 'hideTip'
        });
        return;
    }
    // In most case only one axis (or event one series is used). It is
    // convenient to fetch payload.seriesIndex and payload.dataIndex
    // directly. So put the first seriesIndex and dataIndex of the first
    // axis on the payload.
    var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
    dispatchAction({
        type: 'showTip',
        escapeConnect: true,
        x: point[0],
        y: point[1],
        tooltipOption: payload.tooltipOption,
        position: payload.position,
        dataIndexInside: sampleItem.dataIndexInside,
        dataIndex: sampleItem.dataIndex,
        seriesIndex: sampleItem.seriesIndex,
        dataByCoordSys: dataByCoordSys.list
    });
}
function $07160a7fd5ef0de9$var$dispatchHighDownActually(axesInfo, dispatchAction, api) {
    // FIXME
    // highlight status modification should be a stage of main process?
    // (Consider conflict (e.g., legend and axisPointer) and setOption)
    var zr = api.getZr();
    var highDownKey = 'axisPointerLastHighlights';
    var lastHighlights = $07160a7fd5ef0de9$var$inner(zr)[highDownKey] || {};
    var newHighlights = $07160a7fd5ef0de9$var$inner(zr)[highDownKey] = {};
    // Update highlight/downplay status according to axisPointer model.
    // Build hash map and remove duplicate incidentally.
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        option.status === 'show' && axisInfo.triggerEmphasis && (0, $f16f2994a32ad273$export$79b2f7037acddd43)(option.seriesDataIndices, function(batchItem) {
            newHighlights[batchItem.seriesIndex + '|' + batchItem.dataIndex] = batchItem;
        });
    });
    // Diff.
    var toHighlight = [];
    var toDownplay = [];
    function makeHighDownItem(batchItem) {
        // `dataIndexInside` should be removed, since the last recorded `dataIndexInside` may have
        // been changed if `dataZoomInside` changed the view. Only `dataIndex` will suffice.
        return {
            seriesIndex: batchItem.seriesIndex,
            dataIndex: batchItem.dataIndex
        };
    }
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(lastHighlights, function(batchItem, key) {
        !newHighlights[key] && toDownplay.push(makeHighDownItem(batchItem));
    });
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(newHighlights, function(batchItem, key) {
        !lastHighlights[key] && toHighlight.push(makeHighDownItem(batchItem));
    });
    toDownplay.length && api.dispatchAction({
        type: 'downplay',
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toDownplay
    });
    toHighlight.length && api.dispatchAction({
        type: 'highlight',
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toHighlight
    });
}
function $07160a7fd5ef0de9$var$findInputAxisInfo(inputAxesInfo, axisInfo) {
    for(var i = 0; i < (inputAxesInfo || []).length; i++){
        var inputAxisInfo = inputAxesInfo[i];
        if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) return inputAxisInfo;
    }
}
function $07160a7fd5ef0de9$var$makeMapperParam(axisInfo) {
    var axisModel = axisInfo.axis.model;
    var item = {};
    var dim = item.axisDim = axisInfo.axis.dim;
    item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
    item.axisName = item[dim + 'AxisName'] = axisModel.name;
    item.axisId = item[dim + 'AxisId'] = axisModel.id;
    return item;
}
function $07160a7fd5ef0de9$var$illegalPoint(point) {
    return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}


function $6bef08f2ff097566$export$4b3e715f166fdd78(registers) {
    // CartesianAxisPointer is not supposed to be required here. But consider
    // echarts.simple.js and online build tooltip, which only require gridSimple,
    // CartesianAxisPointer should be able to required somewhere.
    (0, $c5863ebf1b74fa5e$export$2e2bcd8739ae039).registerAxisPointerClass('CartesianAxisPointer', (0, $c39488f411b881cf$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $ec589b0802763b2b$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $45d3d5823a3c70d7$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(option) {
        // Always has a global axisPointerModel for default setting.
        if (option) {
            (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
            var link = option.axisPointer.link;
            // Normalize to array to avoid object mergin. But if link
            // is not set, remain null/undefined, otherwise it will
            // override existent link setting.
            if (link && !(0, $f16f2994a32ad273$export$43bee75e5e14138e)(link)) option.axisPointer.link = [
                link
            ];
        }
    });
    // This process should proformed after coordinate systems created
    // and series data processed. So put it on statistic processing stage.
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, {
        overallReset: function overallReset(ecModel, api) {
            // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
            // allAxesInfo should be updated when setOption performed.
            ecModel.getComponent('axisPointer').coordSysAxesInfo = (0, $5ce9db76a341a244$export$bb44f104e3c54dae)(ecModel, api);
        }
    });
    // Broadcast to all views.
    registers.registerAction({
        type: 'updateAxisPointer',
        event: 'updateAxisPointer',
        update: ':updateAxisPointer'
    }, (0, $07160a7fd5ef0de9$export$2e2bcd8739ae039));
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $1d1dfcaf34692a51$var$TooltipModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(TooltipModel, _super);
    function TooltipModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipModel.type;
        return _this;
    }
    TooltipModel.type = 'tooltip';
    TooltipModel.dependencies = [
        'axisPointer'
    ];
    TooltipModel.defaultOption = {
        // zlevel: 0,
        z: 60,
        show: true,
        // tooltip main content
        showContent: true,
        // 'trigger' only works on coordinate system.
        // 'item' | 'axis' | 'none'
        trigger: 'item',
        // 'click' | 'mousemove' | 'none'
        triggerOn: 'mousemove|click|mousewheel',
        alwaysShowContent: false,
        renderMode: 'auto',
        // whether restraint content inside viewRect.
        // If renderMode: 'richText', default true.
        // If renderMode: 'html', defaults to `false` (for backward compat).
        confine: null,
        showDelay: 0,
        hideDelay: 100,
        // Animation transition time, unit is second
        transitionDuration: 0.4,
        displayTransition: true,
        enterable: false,
        backgroundColor: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.neutral00,
        // box shadow
        shadowBlur: 10,
        shadowColor: 'rgba(0, 0, 0, .2)',
        shadowOffsetX: 1,
        shadowOffsetY: 2,
        // tooltip border radius, unit is px, default is 4
        borderRadius: 4,
        // tooltip border width, unit is px, default is 0 (no border)
        borderWidth: 1,
        defaultBorderColor: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.border,
        // Tooltip inside padding, default is 5 for all direction
        // Array is allowed to set up, right, bottom, left, same with css
        // The default value: See `tooltip/tooltipMarkup.ts#getPaddingFromTooltipModel`.
        padding: null,
        // Extra css text
        extraCssText: '',
        // axis indicator, trigger by axis
        axisPointer: {
            // default is line
            // legal values: 'line' | 'shadow' | 'cross'
            type: 'line',
            // Valid when type is line, appoint tooltip line locate on which line. Optional
            // legal values: 'x' | 'y' | 'angle' | 'radius' | 'auto'
            // default is 'auto', chose the axis which type is category.
            // for multiply y axis, cartesian coord chose x axis, polar chose angle axis
            axis: 'auto',
            animation: 'auto',
            animationDurationUpdate: 200,
            animationEasingUpdate: 'exponentialOut',
            crossStyle: {
                color: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.borderShade,
                width: 1,
                type: 'dashed',
                // TODO formatter
                textStyle: {}
            }
        },
        textStyle: {
            color: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.tertiary,
            fontSize: 14
        }
    };
    return TooltipModel;
}((0, $c418de54527e13f3$export$2e2bcd8739ae039));
var $1d1dfcaf34692a51$export$2e2bcd8739ae039 = $1d1dfcaf34692a51$var$TooltipModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $b2e0644c27f4064f$export$a309528050824ba4(tooltipModel) {
    var confineOption = tooltipModel.get('confine');
    return confineOption != null ? !!confineOption : tooltipModel.get('renderMode') === 'richText';
}
function $b2e0644c27f4064f$var$testStyle(styleProps) {
    if (!(0, $6d0397515b55cc48$export$2e2bcd8739ae039).domSupported) return;
    var style = document.documentElement.style;
    for(var i = 0, len = styleProps.length; i < len; i++){
        if (styleProps[i] in style) return styleProps[i];
    }
}
var $b2e0644c27f4064f$export$7b4286b1e4a23439 = $b2e0644c27f4064f$var$testStyle([
    'transform',
    'webkitTransform',
    'OTransform',
    'MozTransform',
    'msTransform'
]);
var $b2e0644c27f4064f$export$70a631ae991b5e76 = $b2e0644c27f4064f$var$testStyle([
    'webkitTransition',
    'transition',
    'OTransition',
    'MozTransition',
    'msTransition'
]);
function $b2e0644c27f4064f$export$5886acafe29a08d1(styleVendor, styleProp) {
    if (!styleVendor) return styleProp;
    styleProp = (0, $04bb9ff155ec4ccd$export$86f54f62aa7a7514)(styleProp, true);
    var idx = styleVendor.indexOf(styleProp);
    styleVendor = idx === -1 ? styleProp : "-" + styleVendor.slice(0, idx) + "-" + styleProp;
    return styleVendor.toLowerCase();
}
function $b2e0644c27f4064f$export$3735103072e4a80(el, style) {
    var stl = el.currentStyle || document.defaultView && document.defaultView.getComputedStyle(el);
    return stl ? style ? stl[style] : stl : null;
}



/* global document, window */ var $62a6c7ade47f11e1$var$CSS_TRANSITION_VENDOR = (0, $b2e0644c27f4064f$export$5886acafe29a08d1)((0, $b2e0644c27f4064f$export$70a631ae991b5e76), 'transition');
var $62a6c7ade47f11e1$var$CSS_TRANSFORM_VENDOR = (0, $b2e0644c27f4064f$export$5886acafe29a08d1)((0, $b2e0644c27f4064f$export$7b4286b1e4a23439), 'transform');
// eslint-disable-next-line
var $62a6c7ade47f11e1$var$gCssText = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + ((0, $6d0397515b55cc48$export$2e2bcd8739ae039).transform3dSupported ? 'will-change:transform;' : '');
function $62a6c7ade47f11e1$var$mirrorPos(pos) {
    pos = pos === 'left' ? 'right' : pos === 'right' ? 'left' : pos === 'top' ? 'bottom' : 'top';
    return pos;
}
function $62a6c7ade47f11e1$var$assembleArrow(tooltipModel, borderColor, arrowPosition) {
    if (!(0, $f16f2994a32ad273$export$844ec244b1367d54)(arrowPosition) || arrowPosition === 'inside') return '';
    var backgroundColor = tooltipModel.get('backgroundColor');
    var borderWidth = tooltipModel.get('borderWidth');
    borderColor = (0, $04bb9ff155ec4ccd$export$cda04d03233e5555)(borderColor);
    var arrowPos = $62a6c7ade47f11e1$var$mirrorPos(arrowPosition);
    var arrowSize = Math.max(Math.round(borderWidth) * 1.5, 6);
    var positionStyle = '';
    var transformStyle = $62a6c7ade47f11e1$var$CSS_TRANSFORM_VENDOR + ':';
    var rotateDeg;
    if ((0, $f16f2994a32ad273$export$305f7d4e9d4624f2)([
        'left',
        'right'
    ], arrowPos) > -1) {
        positionStyle += 'top:50%';
        transformStyle += "translateY(-50%) rotate(" + (rotateDeg = arrowPos === 'left' ? -225 : -45) + "deg)";
    } else {
        positionStyle += 'left:50%';
        transformStyle += "translateX(-50%) rotate(" + (rotateDeg = arrowPos === 'top' ? 225 : 45) + "deg)";
    }
    var rotateRadian = rotateDeg * Math.PI / 180;
    var arrowWH = arrowSize + borderWidth;
    var rotatedWH = arrowWH * Math.abs(Math.cos(rotateRadian)) + arrowWH * Math.abs(Math.sin(rotateRadian));
    var arrowOffset = Math.round(((rotatedWH - Math.SQRT2 * borderWidth) / 2 + Math.SQRT2 * borderWidth - (rotatedWH - arrowWH) / 2) * 100) / 100;
    positionStyle += ";" + arrowPos + ":-" + arrowOffset + "px";
    var borderStyle = borderColor + " solid " + borderWidth + "px;";
    var styleCss = [
        "position:absolute;width:" + arrowSize + "px;height:" + arrowSize + "px;z-index:-1;",
        positionStyle + ";" + transformStyle + ";",
        "border-bottom:" + borderStyle,
        "border-right:" + borderStyle,
        "background-color:" + backgroundColor + ";"
    ];
    return "<div style=\"" + styleCss.join('') + "\"></div>";
}
function $62a6c7ade47f11e1$var$assembleTransition(duration, onlyFadeTransition, enableDisplayTransition) {
    var transitionCurve = 'cubic-bezier(0.23,1,0.32,1)';
    var transitionOption = '';
    var transitionText = '';
    if (enableDisplayTransition) {
        transitionOption = " " + duration / 2 + "s " + transitionCurve;
        transitionText = "opacity" + transitionOption + ",visibility" + transitionOption;
    }
    if (!onlyFadeTransition) {
        transitionOption = " " + duration + "s " + transitionCurve;
        transitionText += (transitionText.length ? ',' : '') + ((0, $6d0397515b55cc48$export$2e2bcd8739ae039).transformSupported ? "" + $62a6c7ade47f11e1$var$CSS_TRANSFORM_VENDOR + transitionOption : ",left" + transitionOption + ",top" + transitionOption);
    }
    return $62a6c7ade47f11e1$var$CSS_TRANSITION_VENDOR + ':' + transitionText;
}
function $62a6c7ade47f11e1$var$assembleTransform(x, y, toString) {
    // If using float on style, the final width of the dom might
    // keep changing slightly while mouse move. So `toFixed(0)` them.
    var x0 = x.toFixed(0) + 'px';
    var y0 = y.toFixed(0) + 'px';
    // not support transform, use `left` and `top` instead.
    if (!(0, $6d0397515b55cc48$export$2e2bcd8739ae039).transformSupported) return toString ? "top:" + y0 + ";left:" + x0 + ";" : [
        [
            'top',
            y0
        ],
        [
            'left',
            x0
        ]
    ];
    // support transform
    var is3d = (0, $6d0397515b55cc48$export$2e2bcd8739ae039).transform3dSupported;
    var translate = "translate" + (is3d ? '3d' : '') + "(" + x0 + "," + y0 + (is3d ? ',0' : '') + ")";
    return toString ? 'top:0;left:0;' + $62a6c7ade47f11e1$var$CSS_TRANSFORM_VENDOR + ':' + translate + ';' : [
        [
            'top',
            0
        ],
        [
            'left',
            0
        ],
        [
            (0, $b2e0644c27f4064f$export$7b4286b1e4a23439),
            translate
        ]
    ];
}
/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */ function $62a6c7ade47f11e1$var$assembleFont(textStyleModel) {
    var cssText = [];
    var fontSize = textStyleModel.get('fontSize');
    var color = textStyleModel.getTextColor();
    color && cssText.push('color:' + color);
    cssText.push('font:' + textStyleModel.getFont());
    // @ts-ignore, leave it to the tooltip refactor.
    var lineHeight = (0, $f16f2994a32ad273$export$995e01f2f5c9d030)(textStyleModel.get('lineHeight'), Math.round(fontSize * 3 / 2));
    fontSize && cssText.push('line-height:' + lineHeight + 'px');
    var shadowColor = textStyleModel.get('textShadowColor');
    var shadowBlur = textStyleModel.get('textShadowBlur') || 0;
    var shadowOffsetX = textStyleModel.get('textShadowOffsetX') || 0;
    var shadowOffsetY = textStyleModel.get('textShadowOffsetY') || 0;
    shadowColor && shadowBlur && cssText.push('text-shadow:' + shadowOffsetX + 'px ' + shadowOffsetY + 'px ' + shadowBlur + 'px ' + shadowColor);
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)([
        'decoration',
        'align'
    ], function(name) {
        var val = textStyleModel.get(name);
        val && cssText.push('text-' + name + ':' + val);
    });
    return cssText.join(';');
}
function $62a6c7ade47f11e1$var$assembleCssText(tooltipModel, enableTransition, onlyFadeTransition, enableDisplayTransition) {
    var cssText = [];
    var transitionDuration = tooltipModel.get('transitionDuration');
    var backgroundColor = tooltipModel.get('backgroundColor');
    var shadowBlur = tooltipModel.get('shadowBlur');
    var shadowColor = tooltipModel.get('shadowColor');
    var shadowOffsetX = tooltipModel.get('shadowOffsetX');
    var shadowOffsetY = tooltipModel.get('shadowOffsetY');
    var textStyleModel = tooltipModel.getModel('textStyle');
    var padding = (0, $9aca68165c7dc447$export$3048212c802df496)(tooltipModel, 'html');
    var boxShadow = shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor;
    cssText.push('box-shadow:' + boxShadow);
    // Animation transition. Do not animate when transitionDuration <= 0.
    enableTransition && transitionDuration > 0 && cssText.push($62a6c7ade47f11e1$var$assembleTransition(transitionDuration, onlyFadeTransition, enableDisplayTransition));
    if (backgroundColor) cssText.push('background-color:' + backgroundColor);
    // Border style
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)([
        'width',
        'color',
        'radius'
    ], function(name) {
        var borderName = 'border-' + name;
        var camelCase = (0, $04bb9ff155ec4ccd$export$86f54f62aa7a7514)(borderName);
        var val = tooltipModel.get(camelCase);
        val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
    });
    // Text style
    cssText.push($62a6c7ade47f11e1$var$assembleFont(textStyleModel));
    // Padding
    if (padding != null) cssText.push('padding:' + (0, $04bb9ff155ec4ccd$export$f3a38102c49f4268)(padding).join('px ') + 'px');
    return cssText.join(';') + ';';
}
// If not able to make, do not modify the input `out`.
function $62a6c7ade47f11e1$var$makeStyleCoord(out, zr, container, zrX, zrY) {
    var zrPainter = zr && zr.painter;
    if (container) {
        var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
        if (zrViewportRoot) // Some APPs might use scale on body, so we support CSS transform here.
        (0, $288857a46a8969d9$export$8c5c02e118307e20)(out, zrViewportRoot, container, zrX, zrY);
    } else {
        out[0] = zrX;
        out[1] = zrY;
        // xy should be based on canvas root. But tooltipContent is
        // the sibling of canvas root. So padding of ec container
        // should be considered here.
        var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
        if (viewportRootOffset) {
            out[0] += viewportRootOffset.offsetLeft;
            out[1] += viewportRootOffset.offsetTop;
        }
    }
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $62a6c7ade47f11e1$var$TooltipHTMLContent = /** @class */ function() {
    function TooltipHTMLContent(api, opt) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._enterable = true;
        this._alwaysShowContent = false;
        this._firstShow = true;
        this._longHide = true;
        if ((0, $6d0397515b55cc48$export$2e2bcd8739ae039).wxa) return null;
        var el = document.createElement('div');
        // TODO: TYPE
        el.domBelongToZr = true;
        this.el = el;
        var zr = this._zr = api.getZr();
        var appendTo = opt.appendTo;
        var container = appendTo && ((0, $f16f2994a32ad273$export$844ec244b1367d54)(appendTo) ? document.querySelector(appendTo) : (0, $f16f2994a32ad273$export$9f57505b7bd8dae)(appendTo) ? appendTo : (0, $f16f2994a32ad273$export$f6e2535fb5126e54)(appendTo) && appendTo(api.getDom()));
        $62a6c7ade47f11e1$var$makeStyleCoord(this._styleCoord, zr, container, api.getWidth() / 2, api.getHeight() / 2);
        (container || api.getDom()).appendChild(el);
        this._api = api;
        this._container = container;
        // FIXME
        // Is it needed to trigger zr event manually if
        // the browser do not support `pointer-events: none`.
        var self = this;
        el.onmouseenter = function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        };
        el.onmousemove = function(e) {
            e = e || window.event;
            if (!self._enterable) {
                // `pointer-events: none` is set to tooltip content div
                // if `enterable` is set as `false`, and `el.onmousemove`
                // can not be triggered. But in browser that do not
                // support `pointer-events`, we need to do this:
                // Try trigger zrender event to avoid mouse
                // in and out shape too frequently
                var handler = zr.handler;
                var zrViewportRoot = zr.painter.getViewportRoot();
                (0, $1f87c82830753703$export$40fadb093aebad71)(zrViewportRoot, e, true);
                handler.dispatch('mousemove', e);
            }
        };
        el.onmouseleave = function() {
            // set `_inContent` to `false` before `hideLater`
            self._inContent = false;
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
        };
    }
    /**
   * Update when tooltip is rendered
   */ TooltipHTMLContent.prototype.update = function(tooltipModel) {
        // FIXME
        // Move this logic to ec main?
        if (!this._container) {
            var container = this._api.getDom();
            var position = (0, $b2e0644c27f4064f$export$3735103072e4a80)(container, 'position');
            var domStyle = container.style;
            if (domStyle.position !== 'absolute' && position !== 'absolute') domStyle.position = 'relative';
        }
        // move tooltip if chart resized
        var alwaysShowContent = tooltipModel.get('alwaysShowContent');
        alwaysShowContent && this._moveIfResized();
        // update alwaysShowContent
        this._alwaysShowContent = alwaysShowContent;
        this._enableDisplayTransition = tooltipModel.get('displayTransition') && tooltipModel.get('transitionDuration') > 0;
        // update className
        this.el.className = tooltipModel.get('className') || '';
    // Hide the tooltip
    // PENDING
    // this.hide();
    };
    TooltipHTMLContent.prototype.show = function(tooltipModel, nearPointColor) {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var el = this.el;
        var style = el.style;
        var styleCoord = this._styleCoord;
        if (!el.innerHTML) style.display = 'none';
        else style.cssText = $62a6c7ade47f11e1$var$gCssText + $62a6c7ade47f11e1$var$assembleCssText(tooltipModel, !this._firstShow, this._longHide, this._enableDisplayTransition) + $62a6c7ade47f11e1$var$assembleTransform(styleCoord[0], styleCoord[1], true) + ("border-color:" + (0, $04bb9ff155ec4ccd$export$cda04d03233e5555)(nearPointColor) + ";") + (tooltipModel.get('extraCssText') || '') + (";pointer-events:" + (this._enterable ? 'auto' : 'none'));
        this._show = true;
        this._firstShow = false;
        this._longHide = false;
    };
    TooltipHTMLContent.prototype.setContent = function(content, markers, tooltipModel, borderColor, arrowPosition) {
        var el = this.el;
        if (content == null) {
            el.innerHTML = '';
            return;
        }
        var arrow = '';
        if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(arrowPosition) && tooltipModel.get('trigger') === 'item' && !(0, $b2e0644c27f4064f$export$a309528050824ba4)(tooltipModel)) arrow = $62a6c7ade47f11e1$var$assembleArrow(tooltipModel, borderColor, arrowPosition);
        if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(content)) el.innerHTML = content + arrow;
        else if (content) {
            // Clear previous
            el.innerHTML = '';
            if (!(0, $f16f2994a32ad273$export$43bee75e5e14138e)(content)) content = [
                content
            ];
            for(var i = 0; i < content.length; i++)if ((0, $f16f2994a32ad273$export$9f57505b7bd8dae)(content[i]) && content[i].parentNode !== el) el.appendChild(content[i]);
            // no arrow if empty
            if (arrow && el.childNodes.length) {
                // no need to create a new parent element, but it's not supported by IE 10 and older.
                // const arrowEl = document.createRange().createContextualFragment(arrow);
                var arrowEl = document.createElement('div');
                arrowEl.innerHTML = arrow;
                el.appendChild(arrowEl);
            }
        }
    };
    TooltipHTMLContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipHTMLContent.prototype.getSize = function() {
        var el = this.el;
        return el ? [
            el.offsetWidth,
            el.offsetHeight
        ] : [
            0,
            0
        ];
    };
    TooltipHTMLContent.prototype.moveTo = function(zrX, zrY) {
        if (!this.el) return;
        var styleCoord = this._styleCoord;
        $62a6c7ade47f11e1$var$makeStyleCoord(styleCoord, this._zr, this._container, zrX, zrY);
        if (styleCoord[0] != null && styleCoord[1] != null) {
            var style_1 = this.el.style;
            var transforms = $62a6c7ade47f11e1$var$assembleTransform(styleCoord[0], styleCoord[1]);
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)(transforms, function(transform) {
                style_1[transform[0]] = transform[1];
            });
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipHTMLContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2];
        // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipHTMLContent.prototype.hide = function() {
        var _this = this;
        var style = this.el.style;
        if (this._enableDisplayTransition) {
            style.visibility = 'hidden';
            style.opacity = '0';
        } else style.display = 'none';
        (0, $6d0397515b55cc48$export$2e2bcd8739ae039).transform3dSupported && (style.willChange = '');
        this._show = false;
        this._longHideTimeout = setTimeout(function() {
            return _this._longHide = true;
        }, 500);
    };
    TooltipHTMLContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
            if (time) {
                this._hideDelay = time;
                // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout((0, $f16f2994a32ad273$export$2385a24977818dd0)(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipHTMLContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipHTMLContent.prototype.dispose = function() {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var zr = this._zr;
        (0, $288857a46a8969d9$export$a29dbe4b7d3cd586)(zr && zr.painter && zr.painter.getViewportRoot(), this._container);
        var el = this.el;
        if (el) {
            el.onmouseenter = el.onmousemove = el.onmouseleave = null;
            var parentNode = el.parentNode;
            parentNode && parentNode.removeChild(el);
        }
        this.el = this._container = null;
    };
    return TooltipHTMLContent;
}();
var $62a6c7ade47f11e1$export$2e2bcd8739ae039 = $62a6c7ade47f11e1$var$TooltipHTMLContent;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $ef80910df77a5941$var$TooltipRichContent = /** @class */ function() {
    function TooltipRichContent(api) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._alwaysShowContent = false;
        this._enterable = true;
        this._zr = api.getZr();
        $ef80910df77a5941$var$makeStyleCoord(this._styleCoord, this._zr, api.getWidth() / 2, api.getHeight() / 2);
    }
    /**
   * Update when tooltip is rendered
   */ TooltipRichContent.prototype.update = function(tooltipModel) {
        var alwaysShowContent = tooltipModel.get('alwaysShowContent');
        alwaysShowContent && this._moveIfResized();
        // update alwaysShowContent
        this._alwaysShowContent = alwaysShowContent;
    };
    TooltipRichContent.prototype.show = function() {
        if (this._hideTimeout) clearTimeout(this._hideTimeout);
        this.el.show();
        this._show = true;
    };
    /**
   * Set tooltip content
   */ TooltipRichContent.prototype.setContent = function(content, markupStyleCreator, tooltipModel, borderColor, arrowPosition) {
        var _this = this;
        if ($f16f2994a32ad273$export$a6cdc56e425d0d0a(content)) (0, $ec53fe68074e6f74$export$8bf7aba4a9e09055)('');
        if (this.el) this._zr.remove(this.el);
        var textStyleModel = tooltipModel.getModel('textStyle');
        this.el = new (0, $7d5e7dc1581f8c9a$export$2e2bcd8739ae039)({
            style: {
                rich: markupStyleCreator.richTextStyles,
                text: content,
                lineHeight: 22,
                borderWidth: 1,
                borderColor: borderColor,
                textShadowColor: textStyleModel.get('textShadowColor'),
                fill: tooltipModel.get([
                    'textStyle',
                    'color'
                ]),
                padding: (0, $9aca68165c7dc447$export$3048212c802df496)(tooltipModel, 'richText'),
                verticalAlign: 'top',
                align: 'left'
            },
            z: tooltipModel.get('z')
        });
        $f16f2994a32ad273$export$79b2f7037acddd43([
            'backgroundColor',
            'borderRadius',
            'shadowColor',
            'shadowBlur',
            'shadowOffsetX',
            'shadowOffsetY'
        ], function(propName) {
            _this.el.style[propName] = tooltipModel.get(propName);
        });
        $f16f2994a32ad273$export$79b2f7037acddd43([
            'textShadowBlur',
            'textShadowOffsetX',
            'textShadowOffsetY'
        ], function(propName) {
            _this.el.style[propName] = textStyleModel.get(propName) || 0;
        });
        this._zr.add(this.el);
        var self = this;
        this.el.on('mouseover', function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        });
        this.el.on('mouseout', function() {
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
            self._inContent = false;
        });
    };
    TooltipRichContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipRichContent.prototype.getSize = function() {
        var el = this.el;
        var bounding = this.el.getBoundingRect();
        // bounding rect does not include shadow. For renderMode richText,
        // if overflow, it will be cut. So calculate them accurately.
        var shadowOuterSize = $ef80910df77a5941$var$calcShadowOuterSize(el.style);
        return [
            bounding.width + shadowOuterSize.left + shadowOuterSize.right,
            bounding.height + shadowOuterSize.top + shadowOuterSize.bottom
        ];
    };
    TooltipRichContent.prototype.moveTo = function(x, y) {
        var el = this.el;
        if (el) {
            var styleCoord = this._styleCoord;
            $ef80910df77a5941$var$makeStyleCoord(styleCoord, this._zr, x, y);
            x = styleCoord[0];
            y = styleCoord[1];
            var style = el.style;
            var borderWidth = $ef80910df77a5941$var$mathMaxWith0(style.borderWidth || 0);
            var shadowOuterSize = $ef80910df77a5941$var$calcShadowOuterSize(style);
            // rich text x, y do not include border.
            el.x = x + borderWidth + shadowOuterSize.left;
            el.y = y + borderWidth + shadowOuterSize.top;
            el.markRedraw();
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipRichContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2];
        // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipRichContent.prototype.hide = function() {
        if (this.el) this.el.hide();
        this._show = false;
    };
    TooltipRichContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
            if (time) {
                this._hideDelay = time;
                // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout($f16f2994a32ad273$export$2385a24977818dd0(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipRichContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipRichContent.prototype.dispose = function() {
        this._zr.remove(this.el);
    };
    return TooltipRichContent;
}();
function $ef80910df77a5941$var$mathMaxWith0(val) {
    return Math.max(0, val);
}
function $ef80910df77a5941$var$calcShadowOuterSize(style) {
    var shadowBlur = $ef80910df77a5941$var$mathMaxWith0(style.shadowBlur || 0);
    var shadowOffsetX = $ef80910df77a5941$var$mathMaxWith0(style.shadowOffsetX || 0);
    var shadowOffsetY = $ef80910df77a5941$var$mathMaxWith0(style.shadowOffsetY || 0);
    return {
        left: $ef80910df77a5941$var$mathMaxWith0(shadowBlur - shadowOffsetX),
        right: $ef80910df77a5941$var$mathMaxWith0(shadowBlur + shadowOffsetX),
        top: $ef80910df77a5941$var$mathMaxWith0(shadowBlur - shadowOffsetY),
        bottom: $ef80910df77a5941$var$mathMaxWith0(shadowBlur + shadowOffsetY)
    };
}
function $ef80910df77a5941$var$makeStyleCoord(out, zr, zrX, zrY) {
    out[0] = zrX;
    out[1] = zrY;
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $ef80910df77a5941$export$2e2bcd8739ae039 = $ef80910df77a5941$var$TooltipRichContent;




















var $b293eb3c71b1373a$var$proxyRect = new (0, $dbd6d77105f10fb2$export$2e2bcd8739ae039)({
    shape: {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    }
});
var $b293eb3c71b1373a$var$TooltipView = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(TooltipView, _super);
    function TooltipView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipView.type;
        return _this;
    }
    TooltipView.prototype.init = function(ecModel, api) {
        if ((0, $6d0397515b55cc48$export$2e2bcd8739ae039).node || !api.getDom()) return;
        var tooltipModel = ecModel.getComponent('tooltip');
        var renderMode = this._renderMode = (0, $3fa81475350067fd$export$cc0a17a5d27b4e17)(tooltipModel.get('renderMode'));
        this._tooltipContent = renderMode === 'richText' ? new (0, $ef80910df77a5941$export$2e2bcd8739ae039)(api) : new (0, $62a6c7ade47f11e1$export$2e2bcd8739ae039)(api, {
            appendTo: tooltipModel.get('appendToBody', true) ? 'body' : tooltipModel.get('appendTo', true)
        });
    };
    TooltipView.prototype.render = function(tooltipModel, ecModel, api) {
        if ((0, $6d0397515b55cc48$export$2e2bcd8739ae039).node || !api.getDom()) return;
        // Reset
        this.group.removeAll();
        this._tooltipModel = tooltipModel;
        this._ecModel = ecModel;
        this._api = api;
        var tooltipContent = this._tooltipContent;
        tooltipContent.update(tooltipModel);
        tooltipContent.setEnterable(tooltipModel.get('enterable'));
        this._initGlobalListener();
        this._keepShow();
        // PENDING
        // `mousemove` event will be triggered very frequently when the mouse moves fast,
        // which causes that the `updatePosition` function was also called frequently.
        // In Chrome with devtools open and Firefox, tooltip looks laggy and shakes. See #14695 #16101
        // To avoid frequent triggering,
        // consider throttling it in 50ms when transition is enabled
        if (this._renderMode !== 'richText' && tooltipModel.get('transitionDuration')) (0, $fcd7567e9010c0f5$export$958e3e1a02eac4b6)(this, '_updatePosition', 50, 'fixRate');
        else (0, $fcd7567e9010c0f5$export$42ffd38884aecdac)(this, '_updatePosition');
    };
    TooltipView.prototype._initGlobalListener = function() {
        var tooltipModel = this._tooltipModel;
        var triggerOn = tooltipModel.get('triggerOn');
        $4e1f584bde7bfd0c$export$6503ec6e8aabbaf('itemTooltip', this._api, (0, $f16f2994a32ad273$export$2385a24977818dd0)(function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== 'none') {
                if (triggerOn.indexOf(currTrigger) >= 0) this._tryShow(e, dispatchAction);
                else if (currTrigger === 'leave') this._hide(dispatchAction);
            }
        }, this));
    };
    TooltipView.prototype._keepShow = function() {
        var tooltipModel = this._tooltipModel;
        var ecModel = this._ecModel;
        var api = this._api;
        var triggerOn = tooltipModel.get('triggerOn');
        if (tooltipModel.get('trigger') !== 'axis') {
            // _lastDataByCoordSys and _cbParamsList are used for axis tooltip only.
            this._lastDataByCoordSys = null;
            this._cbParamsList = null;
        }
        // Try to keep the tooltip show when refreshing
        if (this._lastX != null && this._lastY != null && triggerOn !== 'none' && triggerOn !== 'click') {
            var self_1 = this;
            clearTimeout(this._refreshUpdateTimeout);
            this._refreshUpdateTimeout = setTimeout(function() {
                // Show tip next tick after other charts are rendered
                // In case highlight action has wrong result
                // FIXME
                !api.isDisposed() && self_1.manuallyShowTip(tooltipModel, ecModel, api, {
                    x: self_1._lastX,
                    y: self_1._lastY,
                    dataByCoordSys: self_1._lastDataByCoordSys
                });
            });
        }
    };
    /**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */ TooltipView.prototype.manuallyShowTip = function(tooltipModel, ecModel, api, payload) {
        if (payload.from === this.uid || (0, $6d0397515b55cc48$export$2e2bcd8739ae039).node || !api.getDom()) return;
        var dispatchAction = $b293eb3c71b1373a$var$makeDispatchAction(payload, api);
        // Reset ticket
        this._ticket = '';
        // When triggered from axisPointer.
        var dataByCoordSys = payload.dataByCoordSys;
        var cmptRef = $b293eb3c71b1373a$var$findComponentReference(payload, ecModel, api);
        if (cmptRef) {
            var rect = cmptRef.el.getBoundingRect().clone();
            rect.applyTransform(cmptRef.el.transform);
            this._tryShow({
                offsetX: rect.x + rect.width / 2,
                offsetY: rect.y + rect.height / 2,
                target: cmptRef.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: 'bottom'
            }, dispatchAction);
        } else if (payload.tooltip && payload.x != null && payload.y != null) {
            var el = $b293eb3c71b1373a$var$proxyRect;
            el.x = payload.x;
            el.y = payload.y;
            el.update();
            (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(el).tooltipConfig = {
                name: null,
                option: payload.tooltip
            };
            // Manually show tooltip while view is not using zrender elements.
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                target: el
            }, dispatchAction);
        } else if (dataByCoordSys) this._tryShow({
            offsetX: payload.x,
            offsetY: payload.y,
            position: payload.position,
            dataByCoordSys: dataByCoordSys,
            tooltipOption: payload.tooltipOption
        }, dispatchAction);
        else if (payload.seriesIndex != null) {
            if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) return;
            var pointInfo = (0, $30e0c6b3134c4dc5$export$2e2bcd8739ae039)(payload, ecModel);
            var cx = pointInfo.point[0];
            var cy = pointInfo.point[1];
            if (cx != null && cy != null) this._tryShow({
                offsetX: cx,
                offsetY: cy,
                target: pointInfo.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: 'bottom'
            }, dispatchAction);
        } else if (payload.x != null && payload.y != null) {
            // FIXME
            // should wrap dispatchAction like `axisPointer/globalListener` ?
            api.dispatchAction({
                type: 'updateAxisPointer',
                x: payload.x,
                y: payload.y
            });
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                position: payload.position,
                target: api.getZr().findHover(payload.x, payload.y).target
            }, dispatchAction);
        }
    };
    TooltipView.prototype.manuallyHideTip = function(tooltipModel, ecModel, api, payload) {
        var tooltipContent = this._tooltipContent;
        if (this._tooltipModel) tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
        this._lastX = this._lastY = this._lastDataByCoordSys = null;
        this._cbParamsList = null;
        if (payload.from !== this.uid) this._hide($b293eb3c71b1373a$var$makeDispatchAction(payload, api));
    };
    // Be compatible with previous design, that is, when tooltip.type is 'axis' and
    // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
    // and tooltip.
    TooltipView.prototype._manuallyAxisShowTip = function(tooltipModel, ecModel, api, payload) {
        var seriesIndex = payload.seriesIndex;
        var dataIndex = payload.dataIndex;
        // @ts-ignore
        var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
        if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) return;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        if (!seriesModel) return;
        var data = seriesModel.getData();
        var tooltipCascadedModel = $b293eb3c71b1373a$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            seriesModel,
            (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel);
        if (tooltipCascadedModel.get('trigger') !== 'axis') return;
        api.dispatchAction({
            type: 'updateAxisPointer',
            seriesIndex: seriesIndex,
            dataIndex: dataIndex,
            position: payload.position
        });
        return true;
    };
    TooltipView.prototype._tryShow = function(e, dispatchAction) {
        var el = e.target;
        var tooltipModel = this._tooltipModel;
        if (!tooltipModel) return;
        // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
        this._lastX = e.offsetX;
        this._lastY = e.offsetY;
        var dataByCoordSys = e.dataByCoordSys;
        if (dataByCoordSys && dataByCoordSys.length) this._showAxisTooltip(dataByCoordSys, e);
        else if (el) {
            var ecData = (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(el);
            if (ecData.ssrType === 'legend') // Don't trigger tooltip for legend tooltip item
            return;
            this._lastDataByCoordSys = null;
            this._cbParamsList = null;
            var seriesDispatcher_1;
            var cmptDispatcher_1;
            (0, $c30ebd75483299c9$export$8a4fca9e04eb4df6)(el, function(target) {
                if (target.tooltipDisabled) {
                    seriesDispatcher_1 = cmptDispatcher_1 = null;
                    return true;
                }
                if (seriesDispatcher_1 || cmptDispatcher_1) return;
                // Always show item tooltip if mouse is on the element with dataIndex
                if ((0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(target).dataIndex != null) seriesDispatcher_1 = target;
                else if ((0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(target).tooltipConfig != null) cmptDispatcher_1 = target;
            }, true);
            if (seriesDispatcher_1) this._showSeriesItemTooltip(e, seriesDispatcher_1, dispatchAction);
            else if (cmptDispatcher_1) this._showComponentItemTooltip(e, cmptDispatcher_1, dispatchAction);
            else this._hide(dispatchAction);
        } else {
            this._lastDataByCoordSys = null;
            this._cbParamsList = null;
            this._hide(dispatchAction);
        }
    };
    TooltipView.prototype._showOrMove = function(tooltipModel, cb) {
        // showDelay is used in this case: tooltip.enterable is set
        // as true. User intent to move mouse into tooltip and click
        // something. `showDelay` makes it easier to enter the content
        // but tooltip do not move immediately.
        var delay = tooltipModel.get('showDelay');
        cb = (0, $f16f2994a32ad273$export$2385a24977818dd0)(cb, this);
        clearTimeout(this._showTimout);
        delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
    };
    TooltipView.prototype._showAxisTooltip = function(dataByCoordSys, e) {
        var ecModel = this._ecModel;
        var globalTooltipModel = this._tooltipModel;
        var point = [
            e.offsetX,
            e.offsetY
        ];
        var singleTooltipModel = $b293eb3c71b1373a$var$buildTooltipModel([
            e.tooltipOption
        ], globalTooltipModel);
        var renderMode = this._renderMode;
        var cbParamsList = [];
        var articleMarkup = (0, $9aca68165c7dc447$export$cf63b23ce77d1921)('section', {
            blocks: [],
            noHeader: true
        });
        // Only for legacy: `Serise['formatTooltip']` returns a string.
        var markupTextArrLegacy = [];
        var markupStyleCreator = new (0, $9aca68165c7dc447$export$2fba3afbcdcf3e18)();
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(dataByCoordSys, function(itemCoordSys) {
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)(itemCoordSys.dataByAxis, function(axisItem) {
                var axisModel = ecModel.getComponent(axisItem.axisDim + 'Axis', axisItem.axisIndex);
                var axisValue = axisItem.value;
                var axis = axisModel.axis;
                var axisValueParsed = axis.scale.parse(axisValue);
                if (!axisModel || axisValue == null) return;
                // FIXME: when using `tooltip.trigger: 'axis'`, the precision of the axis value displayed in tooltip
                //  should match the original series values rather than using the default strategy in Interval.ts
                //  (getPrecision(interval) + 2); otherwise it may cause confusion.
                var axisValueLabel = $6e388b4363a8baf1$export$7cffee0f9aed39d0(axisValue, axis, ecModel, axisItem.seriesDataIndices, axisItem.valueLabelOpt);
                var axisSectionMarkup = (0, $9aca68165c7dc447$export$cf63b23ce77d1921)('section', {
                    header: axisValueLabel,
                    noHeader: !(0, $f16f2994a32ad273$export$87c2784dc9fc4ab)(axisValueLabel),
                    sortBlocks: true,
                    blocks: []
                });
                articleMarkup.blocks.push(axisSectionMarkup);
                (0, $f16f2994a32ad273$export$79b2f7037acddd43)(axisItem.seriesDataIndices, function(idxItem) {
                    var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
                    var dataIndex = idxItem.dataIndexInside;
                    var cbParams = series.getDataParams(dataIndex);
                    // Can't find data.
                    if (cbParams.dataIndex < 0) return;
                    cbParams.axisDim = axisItem.axisDim;
                    cbParams.axisIndex = axisItem.axisIndex;
                    cbParams.axisType = axisItem.axisType;
                    cbParams.axisId = axisItem.axisId;
                    cbParams.axisValue = $5197eaeff9ee5dfb$export$a5a32f324c1fa457(axisModel.axis, {
                        value: axisValueParsed
                    });
                    cbParams.axisValueLabel = axisValueLabel;
                    // Pre-create marker style for makers. Users can assemble richText
                    // text in `formatter` callback and use those markers style.
                    cbParams.marker = markupStyleCreator.makeTooltipMarker('item', (0, $04bb9ff155ec4ccd$export$cda04d03233e5555)(cbParams.color), renderMode);
                    var seriesTooltipResult = (0, $dae8b98b5424425d$export$2d16fa82a50c4741)(series.formatTooltip(dataIndex, true, null));
                    var frag = seriesTooltipResult.frag;
                    if (frag) {
                        var valueFormatter = $b293eb3c71b1373a$var$buildTooltipModel([
                            series
                        ], globalTooltipModel).get('valueFormatter');
                        axisSectionMarkup.blocks.push(valueFormatter ? (0, $f16f2994a32ad273$export$8b58be045bf06082)({
                            valueFormatter: valueFormatter
                        }, frag) : frag);
                    }
                    if (seriesTooltipResult.text) markupTextArrLegacy.push(seriesTooltipResult.text);
                    cbParamsList.push(cbParams);
                });
            });
        });
        // In most cases, the second axis is displays upper on the first one.
        // So we reverse it to look better.
        articleMarkup.blocks.reverse();
        markupTextArrLegacy.reverse();
        var positionExpr = e.position;
        var orderMode = singleTooltipModel.get('order');
        var builtMarkupText = (0, $9aca68165c7dc447$export$6969ffb02c1cb49a)(articleMarkup, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), singleTooltipModel.get('textStyle'));
        builtMarkupText && markupTextArrLegacy.unshift(builtMarkupText);
        var blockBreak = renderMode === 'richText' ? '\n\n' : '<br/>';
        var allMarkupText = markupTextArrLegacy.join(blockBreak);
        this._showOrMove(singleTooltipModel, function() {
            if (this._updateContentNotChangedOnAxis(dataByCoordSys, cbParamsList)) this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, cbParamsList);
            else this._showTooltipContent(singleTooltipModel, allMarkupText, cbParamsList, Math.random() + '', point[0], point[1], positionExpr, null, markupStyleCreator);
        });
    // Do not trigger events here, because this branch only be entered
    // from dispatchAction.
    };
    TooltipView.prototype._showSeriesItemTooltip = function(e, dispatcher, dispatchAction) {
        var ecModel = this._ecModel;
        var ecData = (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(dispatcher);
        // Use dataModel in element if possible
        // Used when mouseover on a element like markPoint or edge
        // In which case, the data is not main data in series.
        var seriesIndex = ecData.seriesIndex;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        // For example, graph link.
        var dataModel = ecData.dataModel || seriesModel;
        var dataIndex = ecData.dataIndex;
        var dataType = ecData.dataType;
        var data = dataModel.getData(dataType);
        var renderMode = this._renderMode;
        var positionDefault = e.positionDefault;
        var tooltipModel = $b293eb3c71b1373a$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            dataModel,
            seriesModel && (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var tooltipTrigger = tooltipModel.get('trigger');
        if (tooltipTrigger != null && tooltipTrigger !== 'item') return;
        var params = dataModel.getDataParams(dataIndex, dataType);
        var markupStyleCreator = new (0, $9aca68165c7dc447$export$2fba3afbcdcf3e18)();
        // Pre-create marker style for makers. Users can assemble richText
        // text in `formatter` callback and use those markers style.
        params.marker = markupStyleCreator.makeTooltipMarker('item', (0, $04bb9ff155ec4ccd$export$cda04d03233e5555)(params.color), renderMode);
        var seriesTooltipResult = (0, $dae8b98b5424425d$export$2d16fa82a50c4741)(dataModel.formatTooltip(dataIndex, false, dataType));
        var orderMode = tooltipModel.get('order');
        var valueFormatter = tooltipModel.get('valueFormatter');
        var frag = seriesTooltipResult.frag;
        var markupText = frag ? (0, $9aca68165c7dc447$export$6969ffb02c1cb49a)(valueFormatter ? (0, $f16f2994a32ad273$export$8b58be045bf06082)({
            valueFormatter: valueFormatter
        }, frag) : frag, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), tooltipModel.get('textStyle')) : seriesTooltipResult.text;
        var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;
        this._showOrMove(tooltipModel, function() {
            this._showTooltipContent(tooltipModel, markupText, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markupStyleCreator);
        });
        // FIXME
        // duplicated showtip if manuallyShowTip is called from dispatchAction.
        dispatchAction({
            type: 'showTip',
            dataIndexInside: dataIndex,
            dataIndex: data.getRawIndex(dataIndex),
            seriesIndex: seriesIndex,
            from: this.uid
        });
    };
    TooltipView.prototype._showComponentItemTooltip = function(e, el, dispatchAction) {
        var isHTMLRenderMode = this._renderMode === 'html';
        var ecData = (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(el);
        var tooltipConfig = ecData.tooltipConfig;
        var tooltipOpt = tooltipConfig.option || {};
        var encodeHTMLContent = tooltipOpt.encodeHTMLContent;
        if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(tooltipOpt)) {
            var content = tooltipOpt;
            tooltipOpt = {
                content: content,
                // Fixed formatter
                formatter: content
            };
            // when `tooltipConfig.option` is a string rather than an object,
            // we can't know if the content needs to be encoded
            // for the sake of security, encode it by default.
            encodeHTMLContent = true;
        }
        if (encodeHTMLContent && isHTMLRenderMode && tooltipOpt.content) {
            // clone might be unnecessary?
            tooltipOpt = (0, $f16f2994a32ad273$export$9cd59f9826255e47)(tooltipOpt);
            tooltipOpt.content = (0, $288857a46a8969d9$export$f9d6449b9af28dc1)(tooltipOpt.content);
        }
        var tooltipModelCascade = [
            tooltipOpt
        ];
        var cmpt = this._ecModel.getComponent(ecData.componentMainType, ecData.componentIndex);
        if (cmpt) tooltipModelCascade.push(cmpt);
        // In most cases, component tooltip formatter has different params with series tooltip formatter,
        // so that they cannot share the same formatter. Since the global tooltip formatter is used for series
        // by convention, we do not use it as the default formatter for component.
        tooltipModelCascade.push({
            formatter: tooltipOpt.content
        });
        var positionDefault = e.positionDefault;
        var subTooltipModel = $b293eb3c71b1373a$var$buildTooltipModel(tooltipModelCascade, this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var defaultHtml = subTooltipModel.get('content');
        var asyncTicket = Math.random() + '';
        // PENDING: this case do not support richText style yet.
        var markupStyleCreator = new (0, $9aca68165c7dc447$export$2fba3afbcdcf3e18)();
        // Do not check whether `trigger` is 'none' here, because `trigger`
        // only works on coordinate system. In fact, we have not found case
        // that requires setting `trigger` nothing on component yet.
        this._showOrMove(subTooltipModel, function() {
            // Use formatterParams from element defined in component
            // Avoid users modify it.
            var formatterParams = (0, $f16f2994a32ad273$export$9cd59f9826255e47)(subTooltipModel.get('formatterParams') || {});
            this._showTooltipContent(subTooltipModel, defaultHtml, formatterParams, asyncTicket, e.offsetX, e.offsetY, e.position, el, markupStyleCreator);
        });
        // If not dispatch showTip, tip may be hide triggered by axis.
        dispatchAction({
            type: 'showTip',
            from: this.uid
        });
    };
    TooltipView.prototype._showTooltipContent = function(// Use Model<TooltipOption> instead of TooltipModel because this model may be from series or other options.
    // Instead of top level tooltip.
    tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markupStyleCreator) {
        // Reset ticket
        this._ticket = '';
        if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) return;
        var tooltipContent = this._tooltipContent;
        tooltipContent.setEnterable(tooltipModel.get('enterable'));
        var formatter = tooltipModel.get('formatter');
        positionExpr = positionExpr || tooltipModel.get('position');
        var html = defaultHtml;
        var nearPoint = this._getNearestPoint([
            x,
            y
        ], params, tooltipModel.get('trigger'), tooltipModel.get('borderColor'), tooltipModel.get('defaultBorderColor', true));
        var nearPointColor = nearPoint.color;
        if (formatter) {
            if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(formatter)) {
                var useUTC = tooltipModel.ecModel.get('useUTC');
                var params0 = (0, $f16f2994a32ad273$export$43bee75e5e14138e)(params) ? params[0] : params;
                var isTimeAxis = params0 && params0.axisType && params0.axisType.indexOf('time') >= 0;
                html = formatter;
                if (isTimeAxis) html = (0, $8a51e097d5164103$export$d9468344d3651243)(params0.axisValue, html, useUTC);
                html = (0, $04bb9ff155ec4ccd$export$2028496a35766e41)(html, params, true);
            } else if ((0, $f16f2994a32ad273$export$f6e2535fb5126e54)(formatter)) {
                var callback = (0, $f16f2994a32ad273$export$2385a24977818dd0)(function(cbTicket, html) {
                    if (cbTicket === this._ticket) {
                        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
                        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
                    }
                }, this);
                this._ticket = asyncTicket;
                html = formatter(params, asyncTicket, callback);
            } else html = formatter;
        }
        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
        tooltipContent.show(tooltipModel, nearPointColor);
        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
    };
    TooltipView.prototype._getNearestPoint = function(point, tooltipDataParams, trigger, borderColor, defaultBorderColor) {
        if (trigger === 'axis' || (0, $f16f2994a32ad273$export$43bee75e5e14138e)(tooltipDataParams)) return {
            color: borderColor || defaultBorderColor
        };
        if (!(0, $f16f2994a32ad273$export$43bee75e5e14138e)(tooltipDataParams)) return {
            color: borderColor || tooltipDataParams.color || tooltipDataParams.borderColor
        };
    };
    TooltipView.prototype._updatePosition = function(tooltipModel, positionExpr, x, // Mouse x
    y, // Mouse y
    content, params, el) {
        var viewWidth = this._api.getWidth();
        var viewHeight = this._api.getHeight();
        positionExpr = positionExpr || tooltipModel.get('position');
        var contentSize = content.getSize();
        var align = tooltipModel.get('align');
        var vAlign = tooltipModel.get('verticalAlign');
        var rect = el && el.getBoundingRect().clone();
        el && rect.applyTransform(el.transform);
        if ((0, $f16f2994a32ad273$export$f6e2535fb5126e54)(positionExpr)) // Callback of position can be an array or a string specify the position
        positionExpr = positionExpr([
            x,
            y
        ], params, content.el, rect, {
            viewSize: [
                viewWidth,
                viewHeight
            ],
            contentSize: contentSize.slice()
        });
        if ((0, $f16f2994a32ad273$export$43bee75e5e14138e)(positionExpr)) {
            x = (0, $104896d282bd296f$export$e8514cb5a5e2b40f)(positionExpr[0], viewWidth);
            y = (0, $104896d282bd296f$export$e8514cb5a5e2b40f)(positionExpr[1], viewHeight);
        } else if ((0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(positionExpr)) {
            var boxLayoutPosition = positionExpr;
            boxLayoutPosition.width = contentSize[0];
            boxLayoutPosition.height = contentSize[1];
            var layoutRect = (0, $6b64c78bf98fea85$export$4517a5ca639a7293)(boxLayoutPosition, {
                width: viewWidth,
                height: viewHeight
            });
            x = layoutRect.x;
            y = layoutRect.y;
            align = null;
            // When positionExpr is left/top/right/bottom,
            // align and verticalAlign will not work.
            vAlign = null;
        } else if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(positionExpr) && el) {
            var pos = $b293eb3c71b1373a$var$calcTooltipPosition(positionExpr, rect, contentSize, tooltipModel.get('borderWidth'));
            x = pos[0];
            y = pos[1];
        } else {
            var pos = $b293eb3c71b1373a$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
            x = pos[0];
            y = pos[1];
        }
        align && (x -= $b293eb3c71b1373a$var$isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
        vAlign && (y -= $b293eb3c71b1373a$var$isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);
        if ((0, $b2e0644c27f4064f$export$a309528050824ba4)(tooltipModel)) {
            var pos = $b293eb3c71b1373a$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight);
            x = pos[0];
            y = pos[1];
        }
        content.moveTo(x, y);
    };
    // FIXME
    // Should we remove this but leave this to user?
    TooltipView.prototype._updateContentNotChangedOnAxis = function(dataByCoordSys, cbParamsList) {
        var lastCoordSys = this._lastDataByCoordSys;
        var lastCbParamsList = this._cbParamsList;
        var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
        contentNotChanged && (0, $f16f2994a32ad273$export$79b2f7037acddd43)(lastCoordSys, function(lastItemCoordSys, indexCoordSys) {
            var lastDataByAxis = lastItemCoordSys.dataByAxis || [];
            var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
            var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
            contentNotChanged = contentNotChanged && lastDataByAxis.length === thisDataByAxis.length;
            contentNotChanged && (0, $f16f2994a32ad273$export$79b2f7037acddd43)(lastDataByAxis, function(lastItem, indexAxis) {
                var thisItem = thisDataByAxis[indexAxis] || {};
                var lastIndices = lastItem.seriesDataIndices || [];
                var newIndices = thisItem.seriesDataIndices || [];
                contentNotChanged = contentNotChanged && lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
                contentNotChanged && (0, $f16f2994a32ad273$export$79b2f7037acddd43)(lastIndices, function(lastIdxItem, j) {
                    var newIdxItem = newIndices[j];
                    contentNotChanged = contentNotChanged && lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
                });
                // check is cbParams data value changed
                lastCbParamsList && (0, $f16f2994a32ad273$export$79b2f7037acddd43)(lastItem.seriesDataIndices, function(idxItem) {
                    var seriesIdx = idxItem.seriesIndex;
                    var cbParams = cbParamsList[seriesIdx];
                    var lastCbParams = lastCbParamsList[seriesIdx];
                    if (cbParams && lastCbParams && lastCbParams.data !== cbParams.data) contentNotChanged = false;
                });
            });
        });
        this._lastDataByCoordSys = dataByCoordSys;
        this._cbParamsList = cbParamsList;
        return !!contentNotChanged;
    };
    TooltipView.prototype._hide = function(dispatchAction) {
        // Do not directly hideLater here, because this behavior may be prevented
        // in dispatchAction when showTip is dispatched.
        // FIXME
        // duplicated hideTip if manuallyHideTip is called from dispatchAction.
        this._lastDataByCoordSys = null;
        this._cbParamsList = null;
        dispatchAction({
            type: 'hideTip',
            from: this.uid
        });
    };
    TooltipView.prototype.dispose = function(ecModel, api) {
        if ((0, $6d0397515b55cc48$export$2e2bcd8739ae039).node || !api.getDom()) return;
        (0, $fcd7567e9010c0f5$export$42ffd38884aecdac)(this, '_updatePosition');
        this._tooltipContent.dispose();
        $4e1f584bde7bfd0c$export$d07f55d4c15c0440('itemTooltip', api);
        this._tooltipContent = null;
        this._tooltipModel = null;
        this._lastDataByCoordSys = null;
        this._cbParamsList = null;
    };
    TooltipView.type = 'tooltip';
    return TooltipView;
}((0, $091798b5bbee0498$export$2e2bcd8739ae039));
/**
 * From top to bottom. (the last one should be globalTooltipModel);
 */ function $b293eb3c71b1373a$var$buildTooltipModel(modelCascade, globalTooltipModel, defaultTooltipOption) {
    // Last is always tooltip model.
    var ecModel = globalTooltipModel.ecModel;
    var resultModel;
    if (defaultTooltipOption) {
        resultModel = new (0, $37821cf56da37613$export$2e2bcd8739ae039)(defaultTooltipOption, ecModel, ecModel);
        resultModel = new (0, $37821cf56da37613$export$2e2bcd8739ae039)(globalTooltipModel.option, resultModel, ecModel);
    } else resultModel = globalTooltipModel;
    for(var i = modelCascade.length - 1; i >= 0; i--){
        var tooltipOpt = modelCascade[i];
        if (tooltipOpt) {
            if (tooltipOpt instanceof (0, $37821cf56da37613$export$2e2bcd8739ae039)) tooltipOpt = tooltipOpt.get('tooltip', true);
            // In each data item tooltip can be simply write:
            // {
            //  value: 10,
            //  tooltip: 'Something you need to know'
            // }
            if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(tooltipOpt)) tooltipOpt = {
                formatter: tooltipOpt
            };
            if (tooltipOpt) resultModel = new (0, $37821cf56da37613$export$2e2bcd8739ae039)(tooltipOpt, resultModel, ecModel);
        }
    }
    return resultModel;
}
function $b293eb3c71b1373a$var$makeDispatchAction(payload, api) {
    return payload.dispatchAction || (0, $f16f2994a32ad273$export$2385a24977818dd0)(api.dispatchAction, api);
}
function $b293eb3c71b1373a$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    if (gapH != null) {
        // Add extra 2 pixels for this case:
        // At present the "values" in default tooltip are using CSS `float: right`.
        // When the right edge of the tooltip box is on the right side of the
        // viewport, the `float` layout might push the "values" to the second line.
        if (x + width + gapH + 2 > viewWidth) x -= width + gapH;
        else x += gapH;
    }
    if (gapV != null) {
        if (y + height + gapV > viewHeight) y -= height + gapV;
        else y += gapV;
    }
    return [
        x,
        y
    ];
}
function $b293eb3c71b1373a$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    x = Math.min(x + width, viewWidth) - width;
    y = Math.min(y + height, viewHeight) - height;
    x = Math.max(x, 0);
    y = Math.max(y, 0);
    return [
        x,
        y
    ];
}
function $b293eb3c71b1373a$var$calcTooltipPosition(position, rect, contentSize, borderWidth) {
    var domWidth = contentSize[0];
    var domHeight = contentSize[1];
    var offset = Math.ceil(Math.SQRT2 * borderWidth) + 8;
    var x = 0;
    var y = 0;
    var rectWidth = rect.width;
    var rectHeight = rect.height;
    switch(position){
        case 'inside':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case 'top':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y - domHeight - offset;
            break;
        case 'bottom':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight + offset;
            break;
        case 'left':
            x = rect.x - domWidth - offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case 'right':
            x = rect.x + rectWidth + offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
    }
    return [
        x,
        y
    ];
}
function $b293eb3c71b1373a$var$isCenterAlign(align) {
    return align === 'center' || align === 'middle';
}
/**
 * Find target component by payload like:
 * ```js
 * { legendId: 'some_id', name: 'xxx' }
 * { toolboxIndex: 1, name: 'xxx' }
 * { geoName: 'some_name', name: 'xxx' }
 * ```
 * PENDING: at present only
 *
 * If not found, return null/undefined.
 */ function $b293eb3c71b1373a$var$findComponentReference(payload, ecModel, api) {
    var queryOptionMap = (0, $3fa81475350067fd$export$fe600815775d9400)(payload).queryOptionMap;
    var componentMainType = queryOptionMap.keys()[0];
    if (!componentMainType || componentMainType === 'series') return;
    var queryResult = (0, $3fa81475350067fd$export$dc741340f7e5f186)(ecModel, componentMainType, queryOptionMap.get(componentMainType), {
        useDefault: false,
        enableAll: false,
        enableNone: false
    });
    var model = queryResult.models[0];
    if (!model) return;
    var view = api.getViewOfComponentModel(model);
    var el;
    view.group.traverse(function(subEl) {
        var tooltipConfig = (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(subEl).tooltipConfig;
        if (tooltipConfig && tooltipConfig.name === payload.name) {
            el = subEl;
            return true; // stop
        }
    });
    if (el) return {
        componentMainType: componentMainType,
        componentIndex: model.componentIndex,
        el: el
    };
}
var $b293eb3c71b1373a$export$2e2bcd8739ae039 = $b293eb3c71b1373a$var$TooltipView;



function $b2ed8f1c7d9fe449$export$4b3e715f166fdd78(registers) {
    (0, $5b64c22a7e1cb8f6$export$1f96ae73734a86cc)((0, $6bef08f2ff097566$export$4b3e715f166fdd78));
    registers.registerComponentModel((0, $1d1dfcaf34692a51$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $b293eb3c71b1373a$export$2e2bcd8739ae039));
    /**
   * @action
   * @property {string} type
   * @property {number} seriesIndex
   * @property {number} dataIndex
   * @property {number} [x]
   * @property {number} [y]
   */ registers.registerAction({
        type: 'showTip',
        event: 'showTip',
        update: 'tooltip:manuallyShowTip'
    }, (0, $f16f2994a32ad273$export$8793edee2d425525));
    registers.registerAction({
        type: 'hideTip',
        event: 'hideTip',
        update: 'tooltip:manuallyHideTip'
    }, (0, $f16f2994a32ad273$export$8793edee2d425525));
}




var $a534c0c1c8c0b730$var$_a;
(0, $5b64c22a7e1cb8f6$export$1f96ae73734a86cc)((0, $b2ed8f1c7d9fe449$export$4b3e715f166fdd78));
var $a534c0c1c8c0b730$export$639fd784fb67c186 = /*#__PURE__*/ function(ECOptionElement) {
    "use strict";
    (0, $hdIku._)(ECTooltipComponent, ECOptionElement);
    function ECTooltipComponent() {
        (0, $173N4._)(this, ECTooltipComponent);
        return (0, $7qXGD._)(this, ECTooltipComponent, arguments);
    }
    return ECTooltipComponent;
}((0, $6f6095288b1fca4a$export$37de6f71bb86a769));
($a534c0c1c8c0b730$var$_a = globalThis.customElements) === null || $a534c0c1c8c0b730$var$_a === void 0 || $a534c0c1c8c0b730$var$_a.define('ec-tooltip', $a534c0c1c8c0b730$export$639fd784fb67c186);



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $hdIku = parcelRequire("hdIku");
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $a52c3079a78f555c$export$57b4bb4ff2a0950c = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
};
var $a52c3079a78f555c$export$e78e6bf4dcc3e485 = [
    '25%',
    '25%'
];
var $a52c3079a78f555c$export$d0b4e8fdb7a13c60 = 'cartesian2d';
var $a52c3079a78f555c$var$GridModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(GridModel, _super);
    function GridModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var outerBoundsCp = (0, $6b64c78bf98fea85$export$4b0d20af19c9875e)(option.outerBounds);
        _super.prototype.mergeDefaultAndTheme.apply(this, arguments);
        if (outerBoundsCp && option.outerBounds) (0, $6b64c78bf98fea85$export$1754cb91f16ca028)(option.outerBounds, outerBoundsCp);
    };
    GridModel.prototype.mergeOption = function(newOption, ecModel) {
        _super.prototype.mergeOption.apply(this, arguments);
        if (this.option.outerBounds && newOption.outerBounds) (0, $6b64c78bf98fea85$export$1754cb91f16ca028)(this.option.outerBounds, newOption.outerBounds);
    };
    GridModel.type = 'grid';
    GridModel.dependencies = [
        'xAxis',
        'yAxis'
    ];
    GridModel.layoutMode = 'box';
    GridModel.defaultOption = {
        show: false,
        // zlevel: 0,
        z: 0,
        left: '15%',
        top: 65,
        right: '10%',
        bottom: 80,
        // If grid size contain label
        containLabel: false,
        outerBoundsMode: 'auto',
        outerBounds: $a52c3079a78f555c$export$57b4bb4ff2a0950c,
        outerBoundsContain: 'all',
        outerBoundsClampWidth: $a52c3079a78f555c$export$e78e6bf4dcc3e485[0],
        outerBoundsClampHeight: $a52c3079a78f555c$export$e78e6bf4dcc3e485[1],
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        backgroundColor: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.transparent,
        borderWidth: 1,
        borderColor: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.neutral30
    };
    return GridModel;
}((0, $c418de54527e13f3$export$2e2bcd8739ae039));
var $a52c3079a78f555c$export$2e2bcd8739ae039 = $a52c3079a78f555c$var$GridModel;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
var $efba222fbc9a9724$export$5c54b224726edb5a = /** @class */ function() {
    function AxisModelCommonMixin() {}
    AxisModelCommonMixin.prototype.needIncludeZero = function() {
        return !this.option.scale;
    };
    /**
   * Should be implemented by each axis model if necessary.
   * @return coordinate system model
   */ AxisModelCommonMixin.prototype.getCoordSysModel = function() {
        return;
    };
    return AxisModelCommonMixin;
}();



var $51812b97bcb3beb5$export$483dc37e6ad83a3c = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(CartesianAxisModel, _super);
    function CartesianAxisModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartesianAxisModel.prototype.getCoordSysModel = function() {
        return this.getReferringComponents('grid', (0, $3fa81475350067fd$export$f076738ec84e693c)).models[0];
    };
    CartesianAxisModel.type = 'cartesian2dAxis';
    return CartesianAxisModel;
}((0, $c418de54527e13f3$export$2e2bcd8739ae039));
$f16f2994a32ad273$export$e36fc9d62a853069($51812b97bcb3beb5$export$483dc37e6ad83a3c, (0, $efba222fbc9a9724$export$5c54b224726edb5a));
var $51812b97bcb3beb5$export$2e2bcd8739ae039 = $51812b97bcb3beb5$export$483dc37e6ad83a3c;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $734808612480a632$var$defaultOption = {
    show: true,
    // zlevel: 0,
    z: 0,
    // Inverse the axis.
    inverse: false,
    // Axis name displayed.
    name: '',
    // 'start' | 'middle' | 'end'
    nameLocation: 'end',
    // By degree. By default auto rotate by nameLocation.
    nameRotate: null,
    nameTruncate: {
        maxWidth: null,
        ellipsis: '...',
        placeholder: '.'
    },
    // Use global text style by default.
    nameTextStyle: {
    },
    // The gap between axisName and axisLine.
    nameGap: 15,
    // Default `false` to support tooltip.
    silent: false,
    // Default `false` to avoid legacy user event listener fail.
    triggerEvent: false,
    tooltip: {
        show: false
    },
    axisPointer: {},
    axisLine: {
        show: true,
        onZero: 'auto',
        onZeroAxisIndex: null,
        lineStyle: {
            color: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.axisLine,
            width: 1,
            type: 'solid'
        },
        // The arrow at both ends the the axis.
        symbol: [
            'none',
            'none'
        ],
        symbolSize: [
            10,
            15
        ],
        breakLine: true
    },
    axisTick: {
        show: true,
        // Whether axisTick is inside the grid or outside the grid.
        inside: false,
        // The length of axisTick.
        length: 5,
        lineStyle: {
            width: 1
        }
    },
    axisLabel: {
        show: true,
        // Whether axisLabel is inside the grid or outside the grid.
        inside: false,
        rotate: 0,
        // true | false | null/undefined (auto)
        showMinLabel: null,
        // true | false | null/undefined (auto)
        showMaxLabel: null,
        margin: 8,
        // formatter: null,
        fontSize: 12,
        color: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.axisLabel,
        // In scenarios like axis labels, when labels text's progression direction matches the label
        // layout direction (e.g., when all letters are in a single line), extra start/end margin is
        // needed to prevent the text from appearing visually joined. In the other case, when lables
        // are stacked (e.g., having rotation or horizontal labels on yAxis), the layout needs to be
        // compact, so NO extra top/bottom margin should be applied.
        textMargin: [
            0,
            3
        ]
    },
    splitLine: {
        show: true,
        showMinLine: true,
        showMaxLine: true,
        lineStyle: {
            color: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.axisSplitLine,
            width: 1,
            type: 'solid'
        }
    },
    splitArea: {
        show: false,
        areaStyle: {
            color: [
                (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.backgroundTint,
                (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.backgroundTransparent
            ]
        }
    },
    breakArea: {
        show: true,
        itemStyle: {
            color: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.neutral00,
            // Break border color should be darker than the splitLine
            // because it has opacity and should be more prominent
            borderColor: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.border,
            borderWidth: 1,
            borderType: [
                3,
                3
            ],
            opacity: 0.6
        },
        zigzagAmplitude: 4,
        zigzagMinSpan: 4,
        zigzagMaxSpan: 20,
        zigzagZ: 100,
        expandOnClick: true
    },
    breakLabelLayout: {
        moveOverlap: 'auto'
    }
};
var $734808612480a632$var$categoryAxis = $f16f2994a32ad273$export$4950aa0f605343fb({
    // The gap at both ends of the axis. For categoryAxis, boolean.
    boundaryGap: true,
    // Set false to faster category collection.
    deduplication: null,
    jitter: 0,
    jitterOverlap: true,
    jitterMargin: 2,
    // splitArea: {
    // show: false
    // },
    splitLine: {
        show: false
    },
    axisTick: {
        // If tick is align with label when boundaryGap is true
        alignWithLabel: false,
        interval: 'auto',
        show: 'auto'
    },
    axisLabel: {
        interval: 'auto'
    }
}, $734808612480a632$var$defaultOption);
var $734808612480a632$var$valueAxis = $f16f2994a32ad273$export$4950aa0f605343fb({
    boundaryGap: [
        0,
        0
    ],
    axisLine: {
        // Not shown when other axis is categoryAxis in cartesian
        show: 'auto'
    },
    axisTick: {
        // Not shown when other axis is categoryAxis in cartesian
        show: 'auto'
    },
    // TODO
    // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
    splitNumber: 5,
    minorTick: {
        // Minor tick, not available for cateogry axis.
        show: false,
        // Split number of minor ticks. The value should be in range of (0, 100)
        splitNumber: 5,
        // Length of minor tick
        length: 3,
        // Line style
        lineStyle: {
        }
    },
    minorSplitLine: {
        show: false,
        lineStyle: {
            color: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.axisMinorSplitLine,
            width: 1
        }
    }
}, $734808612480a632$var$defaultOption);
var $734808612480a632$var$timeAxis = $f16f2994a32ad273$export$4950aa0f605343fb({
    splitNumber: 6,
    axisLabel: {
        // The default value of TimeScale is determined in `AxisBuilder`
        // showMinLabel: false,
        // showMaxLabel: false,
        rich: {
            primary: {
                fontWeight: 'bold'
            }
        }
    },
    splitLine: {
        show: false
    }
}, $734808612480a632$var$valueAxis);
var $734808612480a632$var$logAxis = $f16f2994a32ad273$export$ebe90cb607ad99e({
    logBase: 10
}, $734808612480a632$var$valueAxis);
var $734808612480a632$export$2e2bcd8739ae039 = {
    category: $734808612480a632$var$categoryAxis,
    value: $734808612480a632$var$valueAxis,
    time: $734808612480a632$var$timeAxis,
    log: $734808612480a632$var$logAxis
};







function $6cb0bc2c2c1e2f13$export$2e2bcd8739ae039(registers, axisName, BaseAxisModelClass, extraDefaultOption) {
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)((0, $843eb76b26b69cec$export$2e0057d176d6f690), function(v, axisType) {
        var defaultOption = (0, $f16f2994a32ad273$export$4950aa0f605343fb)((0, $f16f2994a32ad273$export$4950aa0f605343fb)({}, (0, $734808612480a632$export$2e2bcd8739ae039)[axisType], true), extraDefaultOption, true);
        var AxisModel = /** @class */ function(_super) {
            (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(AxisModel, _super);
            function AxisModel() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.type = axisName + 'Axis.' + axisType;
                return _this;
            }
            AxisModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
                var layoutMode = (0, $6b64c78bf98fea85$export$3968a28a7cbd6063)(this);
                var inputPositionParams = layoutMode ? (0, $6b64c78bf98fea85$export$4b0d20af19c9875e)(option) : {};
                var themeModel = ecModel.getTheme();
                (0, $f16f2994a32ad273$export$4950aa0f605343fb)(option, themeModel.get(axisType + 'Axis'));
                (0, $f16f2994a32ad273$export$4950aa0f605343fb)(option, this.getDefaultOption());
                option.type = $6cb0bc2c2c1e2f13$var$getAxisType(option);
                if (layoutMode) (0, $6b64c78bf98fea85$export$1754cb91f16ca028)(option, inputPositionParams, layoutMode);
            };
            AxisModel.prototype.optionUpdated = function() {
                var thisOption = this.option;
                if (thisOption.type === 'category') this.__ordinalMeta = (0, $71fd5e79a240d0ee$export$2e2bcd8739ae039).createByAxisModel(this);
            };
            /**
       * Should not be called before all of 'getInitailData' finished.
       * Because categories are collected during initializing data.
       */ AxisModel.prototype.getCategories = function(rawData) {
                var option = this.option;
                // FIXME
                // warning if called before all of 'getInitailData' finished.
                if (option.type === 'category') {
                    if (rawData) // NOTICE: return the raw data even if not existing; never use a fallback like `[]`;
                    // Its existence matters in some legacy cases.
                    return option.data;
                    return this.__ordinalMeta.categories;
                }
            };
            AxisModel.prototype.getOrdinalMeta = function() {
                return this.__ordinalMeta;
            };
            AxisModel.prototype.updateAxisBreaks = function(payload) {
                var axisBreakHelper = (0, $fc815de52b491ed4$export$c1d9b2cc33e7e5e)();
                return axisBreakHelper ? axisBreakHelper.updateModelAxisBreak(this, payload) : {
                    breaks: []
                };
            };
            AxisModel.type = axisName + 'Axis.' + axisType;
            AxisModel.defaultOption = defaultOption;
            return AxisModel;
        }(BaseAxisModelClass);
        registers.registerComponentModel(AxisModel);
    });
    registers.registerSubTypeDefaulter(axisName + 'Axis', $6cb0bc2c2c1e2f13$var$getAxisType);
}
function $6cb0bc2c2c1e2f13$var$getAxisType(option) {
    // Default axis with data is category axis
    return option.type || (option.data ? 'category' : 'value');
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 */ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $7a3340e4370b5c7e$var$Cartesian = /** @class */ function() {
    function Cartesian(name) {
        this.type = 'cartesian';
        this._dimList = [];
        this._axes = {};
        this.name = name || '';
    }
    Cartesian.prototype.getAxis = function(dim) {
        return this._axes[dim];
    };
    Cartesian.prototype.getAxes = function() {
        return $f16f2994a32ad273$export$871de8747c9eaa88(this._dimList, function(dim) {
            return this._axes[dim];
        }, this);
    };
    Cartesian.prototype.getAxesByScale = function(scaleType) {
        scaleType = scaleType.toLowerCase();
        return $f16f2994a32ad273$export$3dea766d36a8935f(this.getAxes(), function(axis) {
            return axis.scale.type === scaleType;
        });
    };
    Cartesian.prototype.addAxis = function(axis) {
        var dim = axis.dim;
        this._axes[dim] = axis;
        this._dimList.push(dim);
    };
    return Cartesian;
}();
var $7a3340e4370b5c7e$export$2e2bcd8739ae039 = $7a3340e4370b5c7e$var$Cartesian;







var $91da0e4d87ac2c8f$export$988a008d2b9120f4 = [
    'x',
    'y'
];
function $91da0e4d87ac2c8f$var$canCalculateAffineTransform(scale) {
    // Only supported on linear space.
    return (scale.type === 'interval' || scale.type === 'time') && !(0, $cf43ca9fea251347$export$fec008222a1db2dc)(scale);
}
var $91da0e4d87ac2c8f$var$Cartesian2D = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Cartesian2D, _super);
    function Cartesian2D() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = (0, $a52c3079a78f555c$export$d0b4e8fdb7a13c60);
        _this.dimensions = $91da0e4d87ac2c8f$export$988a008d2b9120f4;
        return _this;
    }
    /**
   * Calculate an affine transform matrix if two axes are time or value.
   * It's mainly for accelartion on the large time series data.
   */ Cartesian2D.prototype.calcAffineTransform = function() {
        this._transform = this._invTransform = null;
        var xAxisScale = this.getAxis('x').scale;
        var yAxisScale = this.getAxis('y').scale;
        if (!$91da0e4d87ac2c8f$var$canCalculateAffineTransform(xAxisScale) || !$91da0e4d87ac2c8f$var$canCalculateAffineTransform(yAxisScale)) return;
        var xScaleExtent = (0, $fbe267606846f86c$export$e182c528b7826102)(xAxisScale, null);
        var yScaleExtent = (0, $fbe267606846f86c$export$e182c528b7826102)(yAxisScale, null);
        var start = this.dataToPoint([
            xScaleExtent[0],
            yScaleExtent[0]
        ]);
        var end = this.dataToPoint([
            xScaleExtent[1],
            yScaleExtent[1]
        ]);
        var xScaleSpan = xScaleExtent[1] - xScaleExtent[0];
        var yScaleSpan = yScaleExtent[1] - yScaleExtent[0];
        if (!xScaleSpan || !yScaleSpan) return;
        // Accelerate data to point calculation on the special large time series data.
        var scaleX = (end[0] - start[0]) / xScaleSpan;
        var scaleY = (end[1] - start[1]) / yScaleSpan;
        var translateX = start[0] - xScaleExtent[0] * scaleX;
        var translateY = start[1] - yScaleExtent[0] * scaleY;
        var m = this._transform = [
            scaleX,
            0,
            0,
            scaleY,
            translateX,
            translateY
        ];
        this._invTransform = (0, $45a6d43b639a6412$export$6897c284b6f9f4dc)([], m);
    };
    /**
   * Base axis will be used on stacking and series such as 'bar', 'pictorialBar', etc.
   */ Cartesian2D.prototype.getBaseAxis = function() {
        // FIXME:
        //  (1) We should allow series (e.g., bar) to specify a base axis when
        //      both axes are type "value", rather than force to xAxis or angleAxis.
        //      NOTE: At present BoxplotSeries has its own overide `getBaseAxis`.
        //      `CoordinateSystem['getBaseAxis']` probably should not exist, since it
        //      may introduce inconsistency with `Series['getBaseAxis']`.
        //  (2) "base axis" info is required in "createSeriesData" stage for "stack",
        //      (see `dataStackHelper.ts` for details). Currently it is hard coded there.
        return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
    };
    Cartesian2D.prototype.containPoint = function(point) {
        var axisX = this.getAxis('x');
        var axisY = this.getAxis('y');
        return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
    };
    Cartesian2D.prototype.containData = function(data) {
        return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
    };
    Cartesian2D.prototype.containZone = function(data1, data2) {
        var zoneDiag1 = this.dataToPoint(data1);
        var zoneDiag2 = this.dataToPoint(data2);
        var area = this.getArea();
        var zone = new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(zoneDiag1[0], zoneDiag1[1], zoneDiag2[0] - zoneDiag1[0], zoneDiag2[1] - zoneDiag1[1]);
        return area.intersect(zone);
    };
    Cartesian2D.prototype.dataToPoint = function(data, clamp, out) {
        out = out || [];
        var xVal = data[0];
        var yVal = data[1];
        // [CAVEAT]: Do not add time consuming operation within and before fast path.
        // Fast path.
        if (this._transform && xVal != null && isFinite(xVal) && yVal != null && isFinite(yVal)) return (0, $f79ec7ea1294b339$export$9f9dcb98c894b623)(out, data, this._transform);
        var xAxis = this.getAxis('x');
        var yAxis = this.getAxis('y');
        out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(xVal, clamp));
        out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(yVal, clamp));
        return out;
    };
    Cartesian2D.prototype.clampData = function(data, out) {
        var xScale = this.getAxis('x').scale;
        var yScale = this.getAxis('y').scale;
        var xAxisExtent = xScale.getExtent();
        var yAxisExtent = yScale.getExtent();
        var x = xScale.parse(data[0]);
        var y = yScale.parse(data[1]);
        out = out || [];
        out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
        out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
        return out;
    };
    Cartesian2D.prototype.pointToData = function(point, clamp, out) {
        out = out || [];
        if (this._invTransform) return (0, $f79ec7ea1294b339$export$9f9dcb98c894b623)(out, point, this._invTransform);
        var xAxis = this.getAxis('x');
        var yAxis = this.getAxis('y');
        out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp);
        out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp);
        return out;
    };
    Cartesian2D.prototype.getOtherAxis = function(axis) {
        return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
    };
    /**
   * Get rect area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */ Cartesian2D.prototype.getArea = function(tolerance) {
        tolerance = tolerance || 0;
        var xExtent = this.getAxis('x').getGlobalExtent();
        var yExtent = this.getAxis('y').getGlobalExtent();
        var x = Math.min(xExtent[0], xExtent[1]) - tolerance;
        var y = Math.min(yExtent[0], yExtent[1]) - tolerance;
        var width = Math.max(xExtent[0], xExtent[1]) - x + tolerance;
        var height = Math.max(yExtent[0], yExtent[1]) - y + tolerance;
        return new (0, $7456366ce379c42e$export$2e2bcd8739ae039)(x, y, width, height);
    };
    return Cartesian2D;
}((0, $7a3340e4370b5c7e$export$2e2bcd8739ae039));
var $91da0e4d87ac2c8f$export$2e2bcd8739ae039 = $91da0e4d87ac2c8f$var$Cartesian2D;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $e89f5f075c53507e$var$NORMALIZED_EXTENT = [
    0,
    1
];
/**
 * Base class of Axis.
 *
 * Lifetime: recreate for each main process.
 * [NOTICE]: Some caches is stored on the axis instance (e.g., `axisTickLabelBuilder.ts`, `scaleRawExtentInfo.ts`),
 *  which is based on this lifetime.
 */ var $e89f5f075c53507e$var$Axis = /** @class */ function() {
    function Axis(dim, scale, extent) {
        // NOTICE: Must ensure `true` is only available on 'category' axis.
        this.onBand = false;
        // Make sure that `extent[0] > extent[1]` only if `inverse: true`.
        // `inverse` can be inferred by `extent` unless `extent[0] === extent[1]`.
        this.inverse = false;
        this.dim = dim;
        this.scale = scale;
        this._extent = extent || [
            0,
            0
        ];
    }
    /**
   * If axis extent contain given coord
   */ Axis.prototype.contain = function(coord) {
        var extent = this._extent;
        var min = Math.min(extent[0], extent[1]);
        var max = Math.max(extent[0], extent[1]);
        return coord >= min && coord <= max;
    };
    /**
   * If axis extent contain given data
   */ Axis.prototype.containData = function(data) {
        return this.scale.contain(this.scale.parse(data));
    };
    /**
   * Get coord extent.
   */ Axis.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Set coord extent
   */ Axis.prototype.setExtent = function(start, end) {
        var extent = this._extent;
        extent[0] = start;
        extent[1] = end;
    };
    /**
   * Convert data to coord. Data is the rank if it has an ordinal scale
   */ Axis.prototype.dataToCoord = function(data, clamp) {
        var scale = this.scale;
        data = scale.normalize(scale.parse(data));
        return (0, $104896d282bd296f$export$d3f68fbaa670562)(data, $e89f5f075c53507e$var$NORMALIZED_EXTENT, $e89f5f075c53507e$var$makeExtentWithBands(this), clamp);
    };
    /**
   * Convert coord to data. Data is the rank if it has an ordinal scale
   */ Axis.prototype.coordToData = function(coord, clamp) {
        var t = (0, $104896d282bd296f$export$d3f68fbaa670562)(coord, $e89f5f075c53507e$var$makeExtentWithBands(this), $e89f5f075c53507e$var$NORMALIZED_EXTENT, clamp);
        return this.scale.scale(t);
    };
    /**
   * Convert pixel point to data in axis
   */ Axis.prototype.pointToData = function(point, clamp) {
        // Should be implemented in derived class if necessary.
        return;
    };
    /**
   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
   * `axis.getTicksCoords` considers `onBand`, which is used by
   * `boundaryGap:true` of category axis and splitLine and splitArea.
   * @param opt.tickModel default: axis.model.getModel('axisTick')
   */ Axis.prototype.getTicksCoords = function(opt) {
        opt = opt || {};
        var tickModel = opt.tickModel || this.getTickModel();
        var result = (0, $08a2e2b0d4c9ee4c$export$7cccf6836ae8323c)(this, tickModel, {
            breakTicks: opt.breakTicks,
            pruneByBreak: opt.pruneByBreak
        });
        var preTicksCoords = (0, $f16f2994a32ad273$export$871de8747c9eaa88)(result.ticks, function(tick) {
            return {
                coord: this.dataToCoord((0, $5197eaeff9ee5dfb$export$889d2956111fd257)(this.scale, tick)),
                tick: tick
            };
        }, this);
        var alignWithLabel = tickModel.get('alignWithLabel');
        var onBandModified = $e89f5f075c53507e$var$fixOnBandTicksCoords(this, preTicksCoords, alignWithLabel);
        return (0, $f16f2994a32ad273$export$871de8747c9eaa88)(preTicksCoords, function(item) {
            return {
                coord: item.coord,
                tickValue: item.tick.value,
                onBand: onBandModified
            };
        });
    };
    Axis.prototype.getMinorTicksCoords = function() {
        if ((0, $f976678a0ff027db$export$61579433626afe87)(this.scale)) // Category axis doesn't support minor ticks
        return [];
        var minorTickModel = this.model.getModel('minorTick');
        var splitNumber = minorTickModel.get('splitNumber');
        // Protection.
        if (!(splitNumber > 0 && splitNumber < 100)) splitNumber = 5;
        var minorTicks = this.scale.getMinorTicks(splitNumber);
        var minorTicksCoords = (0, $f16f2994a32ad273$export$871de8747c9eaa88)(minorTicks, function(minorTicksGroup) {
            return (0, $f16f2994a32ad273$export$871de8747c9eaa88)(minorTicksGroup, function(minorTick) {
                return {
                    coord: this.dataToCoord(minorTick),
                    tickValue: minorTick
                };
            }, this);
        }, this);
        return minorTicksCoords;
    };
    Axis.prototype.getViewLabels = function(ctx) {
        ctx = ctx || (0, $08a2e2b0d4c9ee4c$export$12d6ac38274c43e7)((0, $08a2e2b0d4c9ee4c$export$31cba7db0a663292).determine);
        return (0, $08a2e2b0d4c9ee4c$export$10216ebd3e3e485e)(this, ctx).labels;
    };
    Axis.prototype.getLabelModel = function() {
        return this.model.getModel('axisLabel');
    };
    /**
   * Notice here we only get the default tick model. For splitLine
   * or splitArea, we should pass the splitLineModel or splitAreaModel
   * manually when calling `getTicksCoords`.
   * In GL, this method may be overridden to:
   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
   */ Axis.prototype.getTickModel = function() {
        return this.model.getModel('axisTick');
    };
    /**
   * @deprecated Use `calcBandWidth` instead.
   */ Axis.prototype.getBandWidth = function() {
        return (0, $4f7015271e7d3825$export$141021262b29d96e)(this, {
            min: 1
        }).w;
    // NOTICE: Do not add logic here. Implement everthing in `calcBandWidth`.
    };
    /**
   * Only be called in category axis.
   * Can be overridden, consider other axes like in 3D.
   * @return Auto interval for category axis tick and label
   */ Axis.prototype.calculateCategoryInterval = function(ctx) {
        ctx = ctx || (0, $08a2e2b0d4c9ee4c$export$12d6ac38274c43e7)((0, $08a2e2b0d4c9ee4c$export$31cba7db0a663292).determine);
        return (0, $08a2e2b0d4c9ee4c$export$9ea1d3f146a5a65f)(this, ctx);
    };
    return Axis;
}();
function $e89f5f075c53507e$var$makeExtentWithBands(axis) {
    var extent = axis.getExtent();
    if (axis.onBand) {
        var size = extent[1] - extent[0];
        var margin = size / axis.scale.count() / 2;
        extent[0] += margin;
        extent[1] -= margin;
    }
    return extent;
}
/**
 * `axis.onBand: true` (i.e., `boundaryGap: true` in ec option) and `CategoryTickLabelSplitIntervalOption`
 *  affects `axisTick`/`axisLabel`/`splitLine`/`splitArea`.
 *
 * Currently, the visual result is best only when `axisTick/splitLine/splitArea.interval === 0`.
 * The typical case is:
 *      |---|---|---|     <= This is the input `preTicksCoords`
 *      0   1   2   3        (having been added half band width by `makeExtentWithBands`).
 *    |---|---|---|---|  <= This is the result.
 *      0   1   2   3
 *
 * When `interval > 0`, the visual result may be odd for `axisLabel` and `customValues`, but acceptable
 * for `axisTick` `splitLine` and `splitArea`:
 *      |---~---|---~---~---|---|    <= This is the input `preTicksCoords`; `interval: 2; min: 1; max: 7`.
 *      ₁   ₂   3   ₄   ₅   6   ₇       Subscript numbers (`₀`, `₁`, `₃`) indicate axis labels are hidden
 *                                      (by default settings) due to off-interval.
 *                                      A tilde (`~`) indicates a tick ignored due to off-interval.
 *    |---~---|---~---~---|---~---|  <= This is the result.
 *      ₁   ₂   3   ₄   ₅   6   ₇
 *
 * NOTE:
 *  - A inappropriate result may cause misleading (e.g., split 2 bars of a single data item when there
 *    are two bar series).
 *  - See also #11176 #11186 .
 * PENDING:
 *  - The show/hide of `axisLabel` may be optimized when `interval > 1 and be an even number`,
 *    but that may introduce complex and still not perfect in odd number, and may not necessary if
 *    `axisTick: {show: false}` and `axisLabel` can auto hidden when overlapping.
 */ function $e89f5f075c53507e$var$fixOnBandTicksCoords(axis, preTicksCoords, alignWithLabel) {
    var ticksLen = preTicksCoords.length;
    if (!axis.onBand || alignWithLabel || !ticksLen) return false;
    // Assume:
    //  - If `onBand: true`, `bandWidth` has been calculated by `ticksLen + 1` rather than `ticksLen`.
    //  - If `interval > 0`, some ticks may be ignored, but `ticksCoords` has always included boundary
    //    ticks of axis extent, and be `offInterval: true` if off-interval.
    //  - No need to consider breaks, since axis break is not supported in category axis.
    var bandWidth = (0, $4f7015271e7d3825$export$141021262b29d96e)(axis).w;
    if (!bandWidth) return false;
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(preTicksCoords, function(ticksItem) {
        ticksItem.coord -= bandWidth / 2;
    });
    var dataExtent = axis.scale.getExtent();
    var oldLast = preTicksCoords[ticksLen - 1];
    if (oldLast.tick.offInterval) preTicksCoords.pop();
    preTicksCoords.push({
        coord: oldLast.coord + bandWidth,
        tick: {
            value: dataExtent[1] + 1
        }
    });
    return true;
}
var $e89f5f075c53507e$export$2e2bcd8739ae039 = $e89f5f075c53507e$var$Axis;


var $36dcf220d42ccdfa$var$Axis2D = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Axis2D, _super);
    function Axis2D(dim, scale, coordExtent, axisType, position) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        /**
     * Index of axis, can be used as key
     * Injected outside.
     */ _this.index = 0;
        _this.type = axisType || 'value';
        _this.position = position || 'bottom';
        return _this;
    }
    Axis2D.prototype.isHorizontal = function() {
        var position = this.position;
        return position === 'top' || position === 'bottom';
    };
    /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */ Axis2D.prototype.getGlobalExtent = function(asc) {
        var ret = this.getExtent();
        ret[0] = this.toGlobalCoord(ret[0]);
        ret[1] = this.toGlobalCoord(ret[1]);
        asc && ret[0] > ret[1] && ret.reverse();
        return ret;
    };
    Axis2D.prototype.pointToData = function(point, clamp) {
        return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
    };
    /**
   * Set ordinalSortInfo
   * @param info new OrdinalSortInfo
   */ Axis2D.prototype.setCategorySortInfo = function(info) {
        if (this.type !== 'category') return false;
        this.model.option.categorySortInfo = info;
        this.scale.setSortInfo(info);
    };
    return Axis2D;
}((0, $e89f5f075c53507e$export$2e2bcd8739ae039));
var $36dcf220d42ccdfa$export$2e2bcd8739ae039 = $36dcf220d42ccdfa$var$Axis2D;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









/**
 * NOTICE: Can be only used in `ensureScaleStore(axisLike)`.
 *
 * In most cases the instances of `Axis` and `Scale` are one-to-one mapping and share the same lifecycle.
 * But in some external usage (such as echarts-gl), axis instance does not necessarily exist, and only
 * scale instance and axisModel are used. Therefore we store the internal info on scale instance directly.
 */ var $6b680e8b1e09fdd5$var$scaleInner = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
var $6b680e8b1e09fdd5$export$c4999badb722a7d7 = 1;
var $6b680e8b1e09fdd5$export$f9ee28ea7363d798 = 2;
var $6b680e8b1e09fdd5$var$AXIS_EXTENT_INFO_BUILD_FROM_EMPTY = 3;
var $6b680e8b1e09fdd5$export$c35454f678e99c82 = /** @class */ function() {
    function ScaleRawExtentInfo(scale, model, // Typically: data extent from all series on this axis.
    dataExtent, requireStartValue, requireContainShape) {
        var isOrdinal = (0, $f976678a0ff027db$export$61579433626afe87)(scale);
        var axisDataLen = isOrdinal ? model.getCategories().length : null;
        // [CATEGORY_AXIS_MODEL_DATA_IS_EMPTY_ARRAY]:
        // This is only for backward compatibility - `xxxAxis: {data: []}` can declare this axis as
        // a "category" axis and use `series.data` to determine its extent but the axis is blank - only
        // axis line is displayed. This is a conincidence, but it is used in some cases.
        var categoryAxisModelDataIsEmptyArray;
        if (isOrdinal) {
            var axisModelDataArray = model.getCategories(true);
            categoryAxisModelDataIsEmptyArray = axisModelDataArray && !axisModelDataArray.length;
        }
        // NOTE: also considered the input dataExtent may be still in the initialized state `[Infinity, -Infinity]`.
        var dataMM = dataExtent.slice();
        // custom dataMin/dataMax.
        // Also considered `modelDataMinMax[0] > modelDataMinMax[1]` may occur.
        if ((0, $f976678a0ff027db$export$ba0fcad386c5c7e6)(scale) || (0, $f976678a0ff027db$export$8b1d8a59aa13c502)(scale) || (0, $f976678a0ff027db$export$c9b71a3750db342f)(scale)) {
            (0, $3fa81475350067fd$export$a7951d5427fae7a0)(dataMM, $6b680e8b1e09fdd5$var$parseAxisModelMinMax(scale, model.get('dataMin', true)));
            (0, $3fa81475350067fd$export$707ef09fb8bbaa0e)(dataMM, $6b680e8b1e09fdd5$var$parseAxisModelMinMax(scale, model.get('dataMax', true)));
        }
        if (!(0, $3fa81475350067fd$export$622ca7efe3351d22)(dataMM)) // dataMM may be still `[Infinity, -Infinity]`, we use `NaN` on the subsequent calculations
        // to force the `noZoomEffMM` to be `[NaN, NaN]` if needed.
        dataMM[0] = dataMM[1] = NaN;
        var noZoomEffMM = [];
        var fixMM = [
            false,
            false
        ];
        // Notice: When min/max is not set (that is, when there are null/undefined,
        // which is the most common case), these cases should be ensured:
        // (1) For 'ordinal', show all axis.data.
        // (2) For others:
        //      + `boundaryGap` is applied (if min/max set, boundaryGap is
        //      disabled).
        //      + If `needIncludeZero`, min/max should be zero, otherwise, min/max should
        //      be the result that originalExtent enlarged by boundaryGap.
        // (3) If no data, it should be ensured that `scale.setBlank` is set.
        var modelMinRaw = model.get('min', true);
        if (modelMinRaw === 'dataMin') {
            noZoomEffMM[0] = dataMM[0];
            fixMM[0] = true;
        } else {
            noZoomEffMM[0] = $6b680e8b1e09fdd5$var$parseAxisModelMinMax(scale, (0, $f16f2994a32ad273$export$f6e2535fb5126e54)(modelMinRaw) ? modelMinRaw({
                min: dataMM[0],
                max: dataMM[1]
            }) : modelMinRaw);
            // If `xxxAxis.min: null/undefined`, min should not be fixed.
            fixMM[0] = noZoomEffMM[0] != null;
        }
        var modelMaxRaw = model.get('max', true);
        if (modelMaxRaw === 'dataMax') {
            noZoomEffMM[1] = dataMM[1];
            fixMM[1] = true;
        } else {
            noZoomEffMM[1] = $6b680e8b1e09fdd5$var$parseAxisModelMinMax(scale, (0, $f16f2994a32ad273$export$f6e2535fb5126e54)(modelMaxRaw) ? modelMaxRaw({
                min: dataMM[0],
                max: dataMM[1]
            }) : modelMaxRaw);
            // If `xxxAxis.max: null/undefined`, max should not be fixed.
            fixMM[1] = noZoomEffMM[1] != null;
        }
        var boundaryGap = $6b680e8b1e09fdd5$var$parseBoundaryGapOption(scale, model);
        var span = !isOrdinal ? dataMM[1] - dataMM[0] || Math.abs(dataMM[0]) : null;
        // NOTE: If a numeric axis min/max is specified as 'dataMin'/'dataMax',
        // `boundaryGap` will not be used.
        if (noZoomEffMM[0] == null) noZoomEffMM[0] = isOrdinal ? categoryAxisModelDataIsEmptyArray ? dataMM[0] : axisDataLen ? 0 : NaN : dataMM[0] - boundaryGap[0] * span;
        if (noZoomEffMM[1] == null) noZoomEffMM[1] = isOrdinal ? categoryAxisModelDataIsEmptyArray ? dataMM[1] : axisDataLen ? axisDataLen - 1 : NaN : dataMM[1] + boundaryGap[1] * span;
        // Normalize to `NaN` if invalid; e.g., this may occur when `dataMM` has Infinity.
        !(0, $3fa81475350067fd$export$5af06089290883e2)(noZoomEffMM[0]) && (noZoomEffMM[0] = NaN);
        !(0, $3fa81475350067fd$export$5af06089290883e2)(noZoomEffMM[1]) && (noZoomEffMM[1] = NaN);
        var isBlank = categoryAxisModelDataIsEmptyArray || (0, $f16f2994a32ad273$export$7d667b9a0c48c975)(noZoomEffMM[0]) || (0, $f16f2994a32ad273$export$7d667b9a0c48c975)(noZoomEffMM[1]) || isOrdinal && !axisDataLen;
        // NOTE: `needIncludeZero` is not applicable to LogScale, TimeScale, OrdinalScale.
        var needIncludeZeroApplicable = (0, $f976678a0ff027db$export$ba0fcad386c5c7e6)(scale);
        var needIncludeZero = needIncludeZeroApplicable && model.needIncludeZero && model.needIncludeZero();
        if (needIncludeZero) {
            if (noZoomEffMM[0] > 0 && noZoomEffMM[1] > 0 && !fixMM[0]) noZoomEffMM[0] = 0;
            if (noZoomEffMM[0] < 0 && noZoomEffMM[1] < 0 && !fixMM[1]) noZoomEffMM[1] = 0;
        }
        var needToggleAxisInverse = false;
        if (noZoomEffMM[0] > noZoomEffMM[1]) {
            // Historically, if users set `xxxAxis.min > xxxAxis.max`, or `xxxAxis.max < dataExtent[0]`,
            // or `xxxAxis.min > dataExtent[1]` the behavior is sometimes like `xxxAxis.inverse = true`,
            // sometimes abnormal. We remain backward compatible with the former one, though this feature
            // may not be reasonable.
            // And handle it after "needIncludeZero" is also for backward compatibility.
            noZoomEffMM.reverse();
            needToggleAxisInverse = true;
        }
        var startValue = $6b680e8b1e09fdd5$var$parseAxisModelMinMax(scale, model.get('startValue', true));
        var startValueSpecified = startValue != null;
        if (!(0, $104896d282bd296f$export$b5c30d4208814a65)(startValue) && requireStartValue) startValue = scale.getDefaultStartValue ? scale.getDefaultStartValue() : 0;
        if ((0, $104896d282bd296f$export$b5c30d4208814a65)(startValue) && (startValueSpecified || !needIncludeZeroApplicable || needIncludeZero)) {
            if (startValue < noZoomEffMM[0] && !fixMM[0]) {
                noZoomEffMM[0] = startValue;
                fixMM[0] = true;
            } else if (startValue > noZoomEffMM[1] && !fixMM[1]) {
                noZoomEffMM[1] = startValue;
                fixMM[1] = true;
            }
        }
        var internal = this._i = {
            scale: scale,
            dataMM: dataMM,
            noZoomEffMM: noZoomEffMM,
            zoomMM: [],
            fixMM: fixMM,
            zoomFixMM: [
                false,
                false
            ],
            startValue: startValue,
            isBlank: isBlank,
            incl0: needIncludeZero,
            tggAxInv: needToggleAxisInverse,
            ctnShp: requireContainShape
        };
        $6b680e8b1e09fdd5$var$sanitizeExtent(internal, noZoomEffMM);
    }
    ScaleRawExtentInfo.prototype.makeNoZoom = function() {
        return this._i.noZoomEffMM.slice();
    };
    ScaleRawExtentInfo.prototype.makeFinal = function() {
        var internal = this._i;
        var zoomMM = internal.zoomMM;
        var noZoomEffMM = internal.noZoomEffMM;
        var zoomFixMM = internal.zoomFixMM;
        var fixMM = internal.fixMM;
        var result = {
            fixMM: fixMM,
            zoomFixMM: zoomFixMM,
            isBlank: internal.isBlank,
            incl0: internal.incl0,
            tggAxInv: internal.tggAxInv,
            ctnShp: internal.ctnShp,
            effMM: noZoomEffMM.slice()
        };
        var effMM = result.effMM;
        // NOTE: Switching `fixMM` probably leads to abrupt extent changes when draging a `dataZoom`
        //  handle, since `fixMM` impact the "nice extent" and "nice ticks" calculation.
        //  Consider a case:
        //    dataZoom `start` is 2% but its `end` is 100%, (or vice versa), we currently only set `fixMM[0]`
        //    as `true` but remain `fixMM[1]` as `false` for this case to avoid unnecessary abrupt change.
        //    Incidentally, the effect is not unacceptable if we set both `fixMM[0]/[1]` as `true`.
        if (zoomMM[0] != null) {
            effMM[0] = zoomMM[0];
            fixMM[0] = zoomFixMM[0] = true;
        }
        if (zoomMM[1] != null) {
            effMM[1] = zoomMM[1];
            fixMM[1] = zoomFixMM[1] = true;
        }
        $6b680e8b1e09fdd5$var$sanitizeExtent(internal, effMM);
        return result;
    };
    ScaleRawExtentInfo.prototype.makeRenderInfo = function() {
        return {
            startValue: this._i.startValue
        };
    };
    /**
   * NOTICE:
   *  - Do not set them if the percent are 0% or 100%. (See `AxisProxy['reset']`.)
   *  - The caller must ensure `start <= end` and the range is equal or less then `noZoomEffMM`.
   *    (See `AxisProxy['calculateDataWindow']`.)
   *  - The outcome `_zoomMM` may have both `NullUndefined` and a finite value, like `[undefined, 123]`.
   */ ScaleRawExtentInfo.prototype.setZoomMM = function(idxMinMax, val) {
        this._i.zoomMM[idxMinMax] = val;
    };
    return ScaleRawExtentInfo;
}();
/**
 * Should be called when a new extent is created or modified.
 */ function $6b680e8b1e09fdd5$var$sanitizeExtent(internal, mm) {
    var scale = internal.scale;
    var dataMM = internal.dataMM;
    if (scale.sanitize) {
        mm[0] = scale.sanitize(mm[0], dataMM);
        mm[1] = scale.sanitize(mm[1], dataMM);
        (0, $3fa81475350067fd$export$fca8d858e99f6a42)(mm);
    }
}
function $6b680e8b1e09fdd5$var$parseAxisModelMinMax(scale, minMax) {
    return minMax == null ? null // null/undefined means not specified and other default values can be applied.
     : (0, $f16f2994a32ad273$export$7d667b9a0c48c975)(minMax) ? NaN // NaN means a deliberate invalid number.
     : scale.parse(minMax);
}
function $6b680e8b1e09fdd5$var$parseBoundaryGapOption(scale, model) {
    var boundaryGapOptionArr;
    if ((0, $f976678a0ff027db$export$61579433626afe87)(scale)) boundaryGapOptionArr = [
        0,
        0
    ];
    else {
        var boundaryGap = model.get('boundaryGap');
        if (typeof boundaryGap === 'boolean') boundaryGap = null;
        boundaryGapOptionArr = (0, $f16f2994a32ad273$export$43bee75e5e14138e)(boundaryGap) ? boundaryGap : [
            boundaryGap,
            boundaryGap
        ];
    }
    return [
        $6b680e8b1e09fdd5$var$parseBoundaryGapOptionItem(boundaryGapOptionArr[0]),
        $6b680e8b1e09fdd5$var$parseBoundaryGapOptionItem(boundaryGapOptionArr[1])
    ];
}
function $6b680e8b1e09fdd5$var$parseBoundaryGapOptionItem(opt) {
    return (0, $3ad1e5e308f2a981$export$e8514cb5a5e2b40f)(typeof opt === 'boolean' ? 0 : opt, 1) || 0;
}
/**
 * NOTE: `associateSeriesWithAxis` is not necessarily called, e.g., when
 * an axis is not used by any series.
 */ function $6b680e8b1e09fdd5$var$ensureScaleStore(axisLike) {
    var store = $6b680e8b1e09fdd5$var$scaleInner(axisLike.scale);
    if (!store.extent) store.extent = (0, $3fa81475350067fd$export$62e5f07ab009f3b)();
    return store;
}
function $6b680e8b1e09fdd5$export$710d8a038761b881(axisLike, coordSysDimIdxMap) {
    $6b680e8b1e09fdd5$var$ensureScaleStore(axisLike).dimIdxInCoord = coordSysDimIdxMap.get(axisLike.dim);
}
function $6b680e8b1e09fdd5$export$113bceb7edf323a4(axis, from) {
    var scale = axis.scale;
    var model = axis.model;
    var axisDim = axis.dim;
    if (scale.rawExtentInfo) return;
    $6b680e8b1e09fdd5$var$scaleRawExtentInfoCreateDeal(scale, axis, axisDim, model, from);
}
function $6b680e8b1e09fdd5$var$scaleRawExtentInfoCreateDeal(scale, axis, axisDim, model, from) {
    var scaleStore = $6b680e8b1e09fdd5$var$ensureScaleStore(axis);
    var extent = scaleStore.extent;
    var requireStartValue = false;
    (0, $b3d1594b84705f7d$export$cee01bd2e39d754e)(axis, function(seriesModel) {
        if (seriesModel.boxCoordinateSystem) {
            // This supports union extent on case like: pie (or other similar series)
            // lays out on cartesian2d.
            var coord = (0, $d1c2b348f154f767$export$4818264084d885e)(seriesModel).coord;
            var dimIdx = scaleStore.dimIdxInCoord;
            if (!(dimIdx >= 0)) ;
            else if ((0, $f16f2994a32ad273$export$43bee75e5e14138e)(coord)) {
                var coordItem = coord[dimIdx];
                if (coordItem != null && !(0, $f16f2994a32ad273$export$43bee75e5e14138e)(coordItem)) (0, $3fa81475350067fd$export$c28a8a63acb35a19)(extent, scale.parse(coordItem));
            }
        } else if (seriesModel.coordinateSystem) {
            // NOTE: This data may have been filtered by dataZoom on orthogonal axes.
            var data_1 = seriesModel.getData();
            if (data_1) {
                var filter_1 = scale.getFilter ? scale.getFilter() : null;
                (0, $f16f2994a32ad273$export$79b2f7037acddd43)((0, $5197eaeff9ee5dfb$export$e4cf30b1e74cd69d)(data_1, axisDim), function(dim) {
                    (0, $3fa81475350067fd$export$380d5a0634ac86f8)(extent, data_1.getApproximateExtent(dim, filter_1));
                });
            }
            if (seriesModel.__requireStartValue && seriesModel.__requireStartValue(axis)) requireStartValue = true;
        }
    });
    var requireContainShape = $6b680e8b1e09fdd5$var$determineRequireContainShape(scale, axis, model);
    var rawExtentInfo = new $6b680e8b1e09fdd5$export$c35454f678e99c82(scale, model, extent, requireStartValue, requireContainShape);
    $6b680e8b1e09fdd5$var$injectScaleRawExtentInfo(scale, rawExtentInfo, from);
    scaleStore.extent = null; // Clean up
}
/**
 * `rawExtentInfo` may not be created in some cases, such as no series declared or extra useless
 * axes declared in ec option. In this case we still create a default one for that empty axis.
 */ function $6b680e8b1e09fdd5$var$scaleRawExtentInfoBuildDefault(axisLike, dataExtent) {
    var scale = axisLike.scale;
    $6b680e8b1e09fdd5$var$injectScaleRawExtentInfo(scale, new $6b680e8b1e09fdd5$export$c35454f678e99c82(scale, axisLike.model, dataExtent, false, false), $6b680e8b1e09fdd5$var$AXIS_EXTENT_INFO_BUILD_FROM_EMPTY);
}
function $6b680e8b1e09fdd5$var$injectScaleRawExtentInfo(scale, scaleRawExtentInfo, from) {
    // @ts-ignore
    scale.rawExtentInfo = scaleRawExtentInfo;
    // @ts-ignore
    scaleRawExtentInfo.from = from;
}
function $6b680e8b1e09fdd5$export$7b3647d53bcfcf4e(// `axisStatKey` is used to quickly omit irrelevant handlers,
// since handlers need to be iterated per axis.
axisStatKey, handler) {
    $6b680e8b1e09fdd5$var$axisContainShapeHandlerMap.set(axisStatKey, handler);
}
var $6b680e8b1e09fdd5$var$axisContainShapeHandlerMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
function $6b680e8b1e09fdd5$export$b9937565663b5dda(scale, model, ecModel, axis, externalDataExtent) {
    if (!scale.rawExtentInfo) $6b680e8b1e09fdd5$var$scaleRawExtentInfoBuildDefault({
        scale: scale,
        model: model
    }, externalDataExtent || (0, $3fa81475350067fd$export$62e5f07ab009f3b)());
    var rawExtentResult = scale.rawExtentInfo.makeFinal();
    // NOTE: This `scale.setExtent()` is required by:
    //  - `axisNiceTicks.ts` and `axisAlignTicks.ts`, where the internal `scaleMapper` may be required.
    var effectiveMinMax = rawExtentResult.effMM;
    scale.setExtent(effectiveMinMax[0], effectiveMinMax[1]);
    scale.setBlank(rawExtentResult.isBlank);
    if (axis && rawExtentResult.tggAxInv && ecModel && !ecModel.get('legacyMinMaxDontInverseAxis')) axis.inverse = !axis.inverse;
    return rawExtentResult;
}
function $6b680e8b1e09fdd5$var$determineRequireContainShape(scale, axis, model) {
    var onBand = (0, $5197eaeff9ee5dfb$export$43d51f65881fb080)(scale, model);
    var modelContainShape = model.get('containShape', true);
    if (modelContainShape == null && !onBand) modelContainShape = true;
    if (!modelContainShape) return false;
    var requireContainShape = false;
    (0, $b3d1594b84705f7d$export$21f2993d5751eb66)(axis, function(axisStatKey) {
        requireContainShape = !!$6b680e8b1e09fdd5$var$axisContainShapeHandlerMap.get(axisStatKey) || requireContainShape;
    });
    return requireContainShape;
}
function $6b680e8b1e09fdd5$export$922e3b0bde7215c8(axis, scale, rawExtentResult, ecModel) {
    if (!rawExtentResult.ctnShp) return;
    var linearSupplement;
    (0, $b3d1594b84705f7d$export$21f2993d5751eb66)(axis, function(axisStatKey) {
        var handler = $6b680e8b1e09fdd5$var$axisContainShapeHandlerMap.get(axisStatKey);
        if (handler) {
            // This feature can be implemented by either expanding axis extent or scale extent. The choice depends
            // on whether series shape sizes are defined in pixels or data space. For example, scatter series glyph
            // sizes is mainly defined in pixel, while bar series `bandWidth` is mainly determined by given percents
            // of data scale. Since currently scatter does not require this feature, we implement it only on the
            // data scale.
            var singleLinearSupplement = handler(axis, ecModel);
            if (singleLinearSupplement) {
                linearSupplement = linearSupplement || [
                    0,
                    0
                ];
                (0, $3fa81475350067fd$export$a7951d5427fae7a0)(linearSupplement, singleLinearSupplement[0]);
                (0, $3fa81475350067fd$export$707ef09fb8bbaa0e)(linearSupplement, singleLinearSupplement[1]);
                // Consider the consistency of `onZero` behavior (not varying by series data; otherwise error-prone
                // to users), if any `containShape` really performed on this axis, discourage `onZero`.
                (0, $5197eaeff9ee5dfb$export$3a3942ca9637d423)(axis);
            }
        }
    });
    if (!linearSupplement) return;
    var scaleExtent = scale.getExtent();
    if ((0, $f976678a0ff027db$export$61579433626afe87)(scale)) {
        if (!axis.onBand) // - Zooming on `OrdinalScale` auto "snaps" to integer ticks, which causes edge shapes to
        //   always overlap and be clipped at the boundaries. Therefore we always supplement it with
        //   half bandWith to avoid that overlapping.
        // - `linearSupplement` is typically [-0.5, 0.5] in this case. `linearSupplement` exists only
        //   if any series call `registerAxisContainShapeHandler`.
        // - PENDING: For historical reason, `onBand: true` has another implementation to handle
        //   this case. Merge them to this?
        scale.setExtent2((0, $fbe267606846f86c$export$a9efb7aa6faff3f6), (0, $104896d282bd296f$export$e411eeaf23dccbe8)(scaleExtent[0], scaleExtent[0] + linearSupplement[0]), (0, $104896d282bd296f$export$2ca8010d037f830f)(scaleExtent[1], scaleExtent[1] + linearSupplement[1]));
    } else {
        // For other cases, `SCALE_EXTENT_KIND_MAPPING` is only used on the full window of `dataZoom`,
        // where the visual result is more intuitive when zooming: when dataZoom is applied and its ends
        // (i.e., `zoomMM`) do not reach 0% or 100%, the axis ends should exactly respect to the dataZoom
        // ends, and shapes are clipped if overflowing.
        var scaleExtentExpanded = scaleExtent.slice();
        if (!rawExtentResult.zoomFixMM[0]) scaleExtentExpanded[0] = (0, $104896d282bd296f$export$e411eeaf23dccbe8)(scaleExtentExpanded[0], scale.transformOut(scale.transformIn(scaleExtentExpanded[0], null) + linearSupplement[0], null));
        if (!rawExtentResult.zoomFixMM[1]) scaleExtentExpanded[1] = (0, $104896d282bd296f$export$2ca8010d037f830f)(scaleExtentExpanded[1], scale.transformOut(scale.transformIn(scaleExtentExpanded[1], null) + linearSupplement[1], null));
        if (scaleExtentExpanded[0] < scaleExtent[0] || scaleExtentExpanded[1] > scaleExtent[1]) scale.setExtent2((0, $fbe267606846f86c$export$a9efb7aa6faff3f6), scaleExtentExpanded[0], scaleExtentExpanded[1]);
    }
// NOTE: since currently `SCALE_EXTENT_KIND_MAPPING` is never required to be displayed, we
// do not need to find a proper precision for that. But if it is required in the future, We
// can use `getAcceptableTickPrecision` to find a proper precision.
}



function $f1396ac24169329d$export$a54aa0aabf394e1b(targetAxis, alignToScale) {
    var targetScale = targetAxis.scale;
    var targetAxisModel = targetAxis.model;
    var targetExtentInfo = (0, $6b680e8b1e09fdd5$export$b9937565663b5dda)(targetScale, targetAxisModel, targetAxisModel.ecModel, targetAxis, null);
    // FIXME:
    //  (1) Axis inverse is not considered yet.
    //  (2) `SCALE_EXTENT_KIND_MAPPING` is not considered yet.
    var isTargetLogScale = (0, $f976678a0ff027db$export$8b1d8a59aa13c502)(targetScale);
    var alignToScaleLinear = (0, $f976678a0ff027db$export$8b1d8a59aa13c502)(alignToScale) ? alignToScale.intervalStub : alignToScale;
    var targetIntervalStub = isTargetLogScale ? targetScale.intervalStub : targetScale;
    var targetLogScaleBase = targetScale.base;
    var alignToTicks = alignToScaleLinear.getTicks();
    var alignToExpNiceTicks = alignToScaleLinear.getTicks({
        expandToNicedExtent: true
    });
    var alignToSegCount = alignToTicks.length - 1;
    // The Current strategy: Find a proper interval and an extent for the target scale to derive ticks
    // matching exactly to ticks of `alignTo` scale.
    // Adjust min, max based on the extent of alignTo. When min or max is set in alignTo scale
    var t0; // diff ratio on min not-nice segment. 0 <= t0 < 1
    var t1; // diff ratio on max not-nice segment. 0 <= t1 < 1
    var alignToNiceSegCount; // >= 1
    // Consider ticks of `alignTo`, only these cases below may occur:
    if (alignToSegCount === 1) {
        // `alignToTicks` is like:
        //  |--|
        // In this case, we make the corresponding 2 target ticks "nice".
        t0 = t1 = 0;
        alignToNiceSegCount = 1;
    } else if (alignToSegCount === 2) {
        // `alignToTicks` is like:
        //  |-|-----| or
        //  |-----|-| or
        //  |-----|-----|
        // Notices that nice ticks do not necessarily exist in this case.
        // In this case, we choose the larger segment as the "nice segment" and
        // the corresponding target ticks are made "nice".
        var interval0 = (0, $104896d282bd296f$export$5860c226b237d9a6)(alignToTicks[0].value - alignToTicks[1].value);
        var interval1 = (0, $104896d282bd296f$export$5860c226b237d9a6)(alignToTicks[1].value - alignToTicks[2].value);
        t0 = t1 = 0;
        if (interval0 === interval1) alignToNiceSegCount = 2;
        else {
            alignToNiceSegCount = 1;
            if (interval0 < interval1) t0 = interval0 / interval1;
            else t1 = interval1 / interval0;
        }
    } else {
        // alignToSegCount >= 3
        // `alignToTicks` is like:
        //  |-|-----|-----|-| or
        //  |-----|-----|-| or
        //  |-|-----|-----| or ...
        // At least one nice segment is present, and not-nice segments are only present on
        // the start and/or the end.
        // In this case, ticks corresponding to nice segments are made "nice".
        var alignToInterval = alignToScaleLinear.getConfig().interval;
        t0 = (1 - (alignToTicks[0].value - alignToExpNiceTicks[0].value) / alignToInterval) % 1;
        t1 = (1 - (alignToExpNiceTicks[alignToSegCount].value - alignToTicks[alignToSegCount].value) / alignToInterval) % 1;
        alignToNiceSegCount = alignToSegCount - (t0 ? 1 : 0) - (t1 ? 1 : 0);
    }
    // NOTE:
    //  Consider a case:
    //    dataZoom controls all Y axes;
    //    dataZoom end is 90% (maxFixed: true, dataZoomFixMinMax[0]: true);
    //    but dataZoom start is 0% (minFixed: false, dataZoomFixMinMax[1]: false);
    //  In this case,
    //    - `Interval#calcNiceTicks` only uses `targetExtentInfo.max` as the upper bound, but expand the
    //      lower bound to a "nice" tick and can get an acceptable result.
    //    - `scaleCalcAlign` has to use both `targetExtentInfo.min/max` as the bounds without any expansion,
    //      otherwise the lower bound may become negative unexpectedly, especially for all positive series data.
    var dataZoomFixMinMax = targetExtentInfo.zoomFixMM;
    var hasDataZoomFixMinMax = dataZoomFixMinMax[0] || dataZoomFixMinMax[1];
    var targetMinMaxFixed = [
        targetExtentInfo.fixMM[0] || hasDataZoomFixMinMax,
        targetExtentInfo.fixMM[1] || hasDataZoomFixMinMax
    ];
    // MEMO: When only `xxxAxis.min` or `xxxAxis.max` is fixed,
    //  - Even a "nice" interval can be calculated, ticks accumulated based on `min`/`max` can be "nice" only if
    //    `min` or `max` is a "nice" number.
    //  - Generating a "nice" interval may cause the extent have both positive and negative ticks, which may be
    //    not preferable for all positive (very common) or all negative series data. But it can be simply resolved
    //    by specifying `xxxAxis.min: 0`/`xxxAxis.max: 0`, so we do not specially handle this case here.
    //  Therefore, we prioritize generating "nice" interval over preventing from crossing zero.
    //  e.g., if series data are all positive and the max data is `11739`,
    //      If setting `yAxis.max: 'dataMax'`, ticks may be like:
    //          `11739, 8739, 5739, 2739, -1739` (not "nice" enough)
    //      If setting `yAxis.max: 'dataMax', yAxis.min: 0`, ticks may be like:
    //          `11739, 8805, 5870, 2935, 0` (not "nice" enough but may be acceptable)
    //      If setting `yAxis.max: 12000, yAxis.min: 0`, ticks may be like:
    //          `12000, 9000, 6000, 3000, 0` ("nice")
    var targetOldOutermostExtent = targetScale.getExtent();
    var targetOldIntervalExtent = targetIntervalStub.getExtent();
    var targetExtent = (0, $f976678a0ff027db$export$e279d7ed1695209d)(targetOldIntervalExtent, targetMinMaxFixed);
    var min;
    var max;
    var interval;
    var intervalPrecision;
    var maxNice;
    var minNice;
    function loopIncreaseInterval(cb) {
        // Typically this loop runs less than 5 times. But we still
        // use a fail-safe for future changes.
        var LOOP_MAX = 50;
        var loopGuard = 0;
        for(; loopGuard < LOOP_MAX; loopGuard++){
            if (cb()) break;
            interval = isTargetLogScale ? interval * (0, $104896d282bd296f$export$2ca8010d037f830f)(targetLogScaleBase, 2) : (0, $f976678a0ff027db$export$f39031e8422f329d)(interval);
            intervalPrecision = (0, $f976678a0ff027db$export$86a060b060d3d31a)(interval);
        }
    }
    function updateMinFromMinNice() {
        min = (0, $104896d282bd296f$export$2077e0241d6afd3c)(minNice - interval * t0, intervalPrecision);
    }
    function updateMaxFromMaxNice() {
        max = (0, $104896d282bd296f$export$2077e0241d6afd3c)(maxNice + interval * t1, intervalPrecision);
    }
    function updateMinNiceFromMinT0Interval() {
        minNice = t0 ? (0, $104896d282bd296f$export$2077e0241d6afd3c)(min + interval * t0, intervalPrecision) : min;
    }
    function updateMaxNiceFromMaxT1Interval() {
        maxNice = t1 ? (0, $104896d282bd296f$export$2077e0241d6afd3c)(max - interval * t1, intervalPrecision) : max;
    }
    // NOTE: The new calculated `min`/`max` must NOT shrink the original extent; otherwise some series
    // data may be outside of the extent. They can expand the original extent slightly to align with
    // ticks of `alignTo`. In this case, more blank space is added but visually fine.
    if (targetMinMaxFixed[0] && targetMinMaxFixed[1]) {
        // Both `min` and `max` are specified (via dataZoom or ec option; consider both Cartesian, radar and
        // other possible axes). In this case, "nice" ticks can hardly be calculated, but reasonable ticks should
        // still be calculated whenever possible, especially `intervalPrecision` should be tuned for better
        // appearance and lower cumulative error.
        min = targetExtent[0];
        max = targetExtent[1];
        interval = (max - min) / (alignToNiceSegCount + t0 + t1);
        // Typically axis pixel extent is ready here. See `create` in `Grid.ts`.
        var axisPxExtent = targetAxis.getExtent();
        // NOTICE: this pxSpan may be not accurate yet due to "outerBounds" logic, but acceptable so far.
        var pxSpan = (0, $104896d282bd296f$export$5860c226b237d9a6)(axisPxExtent[1] - axisPxExtent[0]);
        // We imperically choose `pxDiffAcceptable` as `0.5 / alignToNiceSegCount` for reduce cumulative
        // error, otherwise a discernible misalign (> 1px) may occur.
        // PENDING: We do not find a acceptable precision for LogScale here.
        //  Theoretically it can be addressed but introduce more complexity. Is it necessary?
        intervalPrecision = (0, $104896d282bd296f$export$de3fddfc2aec84e4)([
            max,
            min
        ], pxSpan, 0.5 / alignToNiceSegCount);
        updateMinNiceFromMinT0Interval();
        updateMaxNiceFromMaxT1Interval();
        if ((0, $104896d282bd296f$export$b5c30d4208814a65)(intervalPrecision)) interval = (0, $104896d282bd296f$export$2077e0241d6afd3c)(interval, intervalPrecision);
    } else {
        // Make a minimal enough `interval`, increase it later.
        // It is a similar logic as `IntervalScale#calcNiceTicks` and `LogScale#calcNiceTicks`.
        // Axis break is not supported, which is guranteed by the caller of this function.
        var targetSpan = targetExtent[1] - targetExtent[0];
        interval = isTargetLogScale ? (0, $104896d282bd296f$export$2ca8010d037f830f)((0, $104896d282bd296f$export$82dd68b83a44b253)(targetSpan), 1) : (0, $104896d282bd296f$export$7a695fe44258210b)(targetSpan / alignToNiceSegCount, (0, $104896d282bd296f$export$492adb595f875f4e));
        intervalPrecision = (0, $f976678a0ff027db$export$86a060b060d3d31a)(interval);
        if (targetMinMaxFixed[0]) {
            min = targetExtent[0];
            loopIncreaseInterval(function() {
                updateMinNiceFromMinT0Interval();
                maxNice = (0, $104896d282bd296f$export$2077e0241d6afd3c)(minNice + interval * alignToNiceSegCount, intervalPrecision);
                updateMaxFromMaxNice();
                if (max >= targetExtent[1]) return true;
            });
        } else if (targetMinMaxFixed[1]) {
            max = targetExtent[1];
            loopIncreaseInterval(function() {
                updateMaxNiceFromMaxT1Interval();
                minNice = (0, $104896d282bd296f$export$2077e0241d6afd3c)(maxNice - interval * alignToNiceSegCount, intervalPrecision);
                updateMinFromMinNice();
                if (min <= targetExtent[0]) return true;
            });
        } else loopIncreaseInterval(function() {
            minNice = (0, $104896d282bd296f$export$2077e0241d6afd3c)((0, $104896d282bd296f$export$cf129980c996e186)(targetExtent[0] / interval) * interval, intervalPrecision);
            maxNice = (0, $104896d282bd296f$export$2077e0241d6afd3c)((0, $104896d282bd296f$export$c6301bc99a7f80a7)(targetExtent[1] / interval) * interval, intervalPrecision);
            // NOTE:
            //  - `maxNice - minNice >= -interval` here.
            //  - While `interval` increases, `currIntervalCount` decreases, minimum `-1`.
            var currIntervalCount = (0, $104896d282bd296f$export$42cacde8c45786ff)((maxNice - minNice) / interval);
            if (currIntervalCount <= alignToNiceSegCount) {
                var moreCount = alignToNiceSegCount - currIntervalCount;
                // Consider cases that negative tick do not make sense (or vice versa), users can simply
                // specify `xxxAxis.min/max: 0` to avoid negative. But we still automatically handle it
                // for some common cases whenever possible:
                //  - When ec option is `xxxAxis.scale: false` (the default), it is usually unexpected if
                //    negative (or positive) ticks are introduced.
                //  - In LogScale, series data are usually either all > 1 or all < 1, rather than both,
                //    that is, logarithm result is typically either all positive or all negative.
                var moreCountPair = void 0;
                var mayEnhanceZero = targetExtentInfo.incl0 || isTargetLogScale;
                // `bounds < 0` or `bounds > 0` may require more complex handling, so we only auto handle
                // `bounds === 0`.
                if (mayEnhanceZero && targetExtent[0] === 0) // 0 has been included in extent and all positive.
                moreCountPair = [
                    0,
                    moreCount
                ];
                else if (mayEnhanceZero && targetExtent[1] === 0) // 0 has been included in extent and all negative.
                moreCountPair = [
                    moreCount,
                    0
                ];
                else {
                    // Try to center ticks in axis space whenever possible, which is especially preferable
                    // in `LogScale`.
                    var lessHalfCount = (0, $104896d282bd296f$export$c6301bc99a7f80a7)(moreCount / 2);
                    moreCountPair = moreCount % 2 === 0 ? [
                        lessHalfCount,
                        lessHalfCount
                    ] : min + max < targetExtent[0] + targetExtent[1] ? [
                        lessHalfCount,
                        lessHalfCount + 1
                    ] : [
                        lessHalfCount + 1,
                        lessHalfCount
                    ];
                }
                minNice = (0, $104896d282bd296f$export$2077e0241d6afd3c)(minNice - interval * moreCountPair[0], intervalPrecision);
                maxNice = (0, $104896d282bd296f$export$2077e0241d6afd3c)(maxNice + interval * moreCountPair[1], intervalPrecision);
                updateMinFromMinNice();
                updateMaxFromMaxNice();
                if (min <= targetExtent[0] && max >= targetExtent[1]) return true;
            }
        });
    }
    (0, $5197eaeff9ee5dfb$export$8135db7762247d65)(targetScale, targetMinMaxFixed, targetOldIntervalExtent, [
        min,
        max
    ], targetOldOutermostExtent, {
        // NOTE: Even in LogScale, `interval` should not be in log space.
        interval: interval,
        // Force ticks count, otherwise cumulative error may cause more unexpected ticks to be generated.
        // Though the overlapping tick labels may be auto-ignored, but probably unexpected, e.g., the min
        // tick label is ignored but the secondary min tick label is shown, which is unexpected when
        // `axis.min` is user-specified or dataZoom-specified.
        intervalCount: alignToNiceSegCount,
        intervalPrecision: intervalPrecision,
        niceExtent: [
            minNice,
            maxNice
        ]
    });
}








/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






// ------ START: LinearIntervalScaleStub Nice ------
function $221137ef11fb33f3$var$calcNiceForIntervalOrLogScale(scale, opt) {
    // [CAVEAT]: If updating this impl, need to sync it to `axisAlignTicks.ts`.
    var isTargetLogScale = (0, $f976678a0ff027db$export$8b1d8a59aa13c502)(scale);
    var intervalStub = isTargetLogScale ? scale.intervalStub : scale;
    var fixMinMax = opt.fixMinMax || [];
    var oldOutermostExtent = isTargetLogScale ? scale.getExtent() : null;
    var oldIntervalExtent = intervalStub.getExtent();
    var newIntervalExtent = (0, $f976678a0ff027db$export$e279d7ed1695209d)(oldIntervalExtent, fixMinMax, opt.rawExtentResult);
    intervalStub.setExtent(newIntervalExtent[0], newIntervalExtent[1]);
    newIntervalExtent = intervalStub.getExtent();
    var config = isTargetLogScale ? $221137ef11fb33f3$var$logScaleCalcNiceTicks(intervalStub, opt) : $221137ef11fb33f3$var$intervalScaleCalcNiceTicks(intervalStub, opt);
    var autoIntervalPrecision = config.intervalPrecision;
    var autoInterval = config.interval;
    // When auto calculated interval is not preferable, users are allowed to explicity specify
    // `interval`, `min`, `max` to customize the axis. A typical case is, in angle axis with angle
    // 0 - 360, where the internally calculated interval is not 60-based.
    // NOTICE:
    //  - In `xxxAxis.type: 'log'`, ec option `xxxAxis.interval` requires a logarithm-applied
    //    value rather than a value in the raw scale.
    //  - Follow the historical behavior:
    //    - even `interval` is specified, the scale extent is still expanded based on the auto-calculated
    //      interval.
    //    - No validation to the specified `interval`.
    var userInterval = opt.userInterval;
    if (userInterval != null) {
        config.interval = userInterval;
        config.intervalPrecision = (0, $f976678a0ff027db$export$86a060b060d3d31a)(userInterval);
    }
    if (!fixMinMax[0]) newIntervalExtent[0] = (0, $104896d282bd296f$export$2077e0241d6afd3c)((0, $104896d282bd296f$export$c6301bc99a7f80a7)(newIntervalExtent[0] / autoInterval) * autoInterval, autoIntervalPrecision);
    if (!fixMinMax[1]) newIntervalExtent[1] = (0, $104896d282bd296f$export$2077e0241d6afd3c)((0, $104896d282bd296f$export$cf129980c996e186)(newIntervalExtent[1] / autoInterval) * autoInterval, autoIntervalPrecision);
    if (userInterval != null) // Historical behavior.
    config.niceExtent = newIntervalExtent.slice();
    (0, $5197eaeff9ee5dfb$export$8135db7762247d65)(scale, fixMinMax, oldIntervalExtent, newIntervalExtent, oldOutermostExtent, config);
}
// ------ END: LinearIntervalScaleStub Nice ------
// ------ START: IntervalScale Nice ------
function $221137ef11fb33f3$var$intervalScaleCalcNiceTicks(scale, opt) {
    var splitNumber = (0, $f976678a0ff027db$export$b801ba4e5ad70a4a)(opt.splitNumber, 5);
    // Use the span in the innermost linear space to calculate nice ticks.
    var span = (0, $fbe267606846f86c$export$9a49fe71267af794)(scale);
    var minInterval = opt.minInterval;
    var maxInterval = opt.maxInterval;
    var interval = (0, $104896d282bd296f$export$7a695fe44258210b)(span / splitNumber, true);
    if (minInterval != null && interval < minInterval) interval = minInterval;
    if (maxInterval != null && interval > maxInterval) interval = maxInterval;
    var intervalPrecision = (0, $f976678a0ff027db$export$86a060b060d3d31a)(interval);
    var extent = scale.getExtent();
    // By design, the `niceExtent` is inside the original extent
    var niceExtent = [
        (0, $104896d282bd296f$export$2077e0241d6afd3c)((0, $104896d282bd296f$export$cf129980c996e186)(extent[0] / interval) * interval, intervalPrecision),
        (0, $104896d282bd296f$export$2077e0241d6afd3c)((0, $104896d282bd296f$export$c6301bc99a7f80a7)(extent[1] / interval) * interval, intervalPrecision)
    ];
    return {
        interval: interval,
        intervalPrecision: intervalPrecision,
        niceExtent: niceExtent
    };
}
// ------ END: IntervalScale Nice ------
// ------ START: LogScale Nice ------
function $221137ef11fb33f3$var$logScaleCalcNiceTicks(intervalStub, opt) {
    // [CAVEAT]: If updating this impl, need to sync it to `axisAlignTicks.ts`.
    var splitNumber = (0, $f976678a0ff027db$export$b801ba4e5ad70a4a)(opt.splitNumber, 10);
    // Find nice ticks in the "logarithmic space". Notice that "logarithmic space" is a middle space
    // rather than the innermost linear space when axis breaks exist.
    var intervalExtent = intervalStub.getExtent();
    // But use the span in the innermost linear space to calculate nice ticks.
    var span = (0, $fbe267606846f86c$export$9a49fe71267af794)(intervalStub);
    // Interval should be integer
    var interval = (0, $104896d282bd296f$export$2ca8010d037f830f)((0, $104896d282bd296f$export$82dd68b83a44b253)(span), 1);
    var err = splitNumber / span * interval;
    // Filter ticks to get closer to the desired count.
    if (err <= 0.5) // TODO: support other bases other than 10?
    interval *= 10;
    var intervalPrecision = (0, $f976678a0ff027db$export$86a060b060d3d31a)(interval);
    // For LogScale, we use a `niceExtent` in the "logarithmic space" rather than
    // the original "pow space", because it is used in `intervalStub.getTicks()` thereafter.
    var niceExtent = [
        (0, $104896d282bd296f$export$2077e0241d6afd3c)((0, $104896d282bd296f$export$cf129980c996e186)(intervalExtent[0] / interval) * interval, intervalPrecision),
        (0, $104896d282bd296f$export$2077e0241d6afd3c)((0, $104896d282bd296f$export$c6301bc99a7f80a7)(intervalExtent[1] / interval) * interval, intervalPrecision)
    ];
    return {
        intervalPrecision: intervalPrecision,
        interval: interval,
        niceExtent: niceExtent
    };
}
function $221137ef11fb33f3$export$6aaaea8da7d6b895(axisLike) {
    var scale = axisLike.scale;
    var model = axisLike.model;
    var axis = model.axis;
    var ecModel = model.ecModel;
    $221137ef11fb33f3$export$35f94b1dd0b73915(scale, model, axis, ecModel, null);
}
function $221137ef11fb33f3$export$35f94b1dd0b73915(scale, model, // Some call from external source, such as echarts-gl, may have no `axis` and `ecModel`,
// but has `externalDataExtent`.
axis, ecModel, externalDataExtent) {
    var rawExtentResult = (0, $6b680e8b1e09fdd5$export$b9937565663b5dda)(scale, model, ecModel, axis, externalDataExtent);
    var isIntervalOrTime = (0, $f976678a0ff027db$export$ba0fcad386c5c7e6)(scale) || (0, $f976678a0ff027db$export$c9b71a3750db342f)(scale);
    $221137ef11fb33f3$export$1b1041112fbfff22(scale, {
        splitNumber: model.get('splitNumber'),
        fixMinMax: rawExtentResult.fixMM,
        userInterval: model.get('interval'),
        minInterval: isIntervalOrTime ? model.get('minInterval') : null,
        maxInterval: isIntervalOrTime ? model.get('maxInterval') : null,
        rawExtentResult: rawExtentResult
    });
    if (axis && ecModel) (0, $6b680e8b1e09fdd5$export$922e3b0bde7215c8)(axis, scale, rawExtentResult, ecModel);
}
function $221137ef11fb33f3$export$1b1041112fbfff22(scale, opt) {
    $221137ef11fb33f3$var$scaleCalcNiceMethods[scale.type](scale, opt);
}
var $221137ef11fb33f3$var$scaleCalcNiceMethods = {
    interval: $221137ef11fb33f3$var$calcNiceForIntervalOrLogScale,
    log: $221137ef11fb33f3$var$calcNiceForIntervalOrLogScale,
    time: (0, $8aa741ffc5165c6e$export$b0ab84ebd823da11),
    ordinal: (0, $f16f2994a32ad273$export$8793edee2d425525)
}; // ------ END: scaleCalcNice Entry ------






// margin is [top, right, bottom, left]
var $a99cfa19e72005cb$var$XY_TO_MARGIN_IDX = [
    [
        3,
        1
    ],
    [
        0,
        2
    ] // xyIdx 1 => 'y'
];
var $a99cfa19e72005cb$var$Grid = /** @class */ function() {
    function Grid(gridModel, ecModel, api) {
        // FIXME:TS where used (different from registered type 'cartesian2d')?
        this.type = 'grid';
        this._coordsMap = {};
        this._coordsList = [];
        this._axesMap = {};
        this._axesList = [];
        this.axisPointerEnabled = true;
        this.dimensions = (0, $91da0e4d87ac2c8f$export$988a008d2b9120f4);
        this._initCartesian(gridModel, ecModel, api);
        this.model = gridModel;
    }
    Grid.prototype.getRect = function() {
        return this._rect;
    };
    Grid.prototype.update = function(ecModel, api) {
        var axesMap = this._axesMap;
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(this._axesList, function(axis) {
            (0, $6b680e8b1e09fdd5$export$113bceb7edf323a4)(axis, (0, $6b680e8b1e09fdd5$export$c4999badb722a7d7));
            var scale = axis.scale;
            if ((0, $f976678a0ff027db$export$61579433626afe87)(scale)) scale.setSortInfo(axis.model.get('categorySortInfo'));
        });
        function updateAxisTicks(axes) {
            // Axis is added in order of axisIndex.
            var axesIndices = (0, $f16f2994a32ad273$export$ed97f33186d4b816)(axes);
            var axisNeedsAlign = [];
            for(var i = axesIndices.length - 1; i >= 0; i--){
                // Reverse order
                var axis = axes[+axesIndices[i]];
                if (axis.__alignTo) axisNeedsAlign.push(axis);
                else (0, $221137ef11fb33f3$export$6aaaea8da7d6b895)(axis);
            }
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)(axisNeedsAlign, function(axis) {
                if ($a99cfa19e72005cb$var$incapableOfAlignNeedFallback(axis, axis.__alignTo)) (0, $221137ef11fb33f3$export$6aaaea8da7d6b895)(axis);
                else (0, $f1396ac24169329d$export$a54aa0aabf394e1b)(axis, axis.__alignTo.scale);
            });
        }
        updateAxisTicks(axesMap.x);
        updateAxisTicks(axesMap.y);
        // Key: axisDim_axisIndex, value: boolean, whether onZero target.
        var onZeroRecords = {};
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(axesMap.x, function(xAxis) {
            $a99cfa19e72005cb$var$fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
        });
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(axesMap.y, function(yAxis) {
            $a99cfa19e72005cb$var$fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
        });
        // Resize again if containLabel is enabled
        // FIXME It may cause getting wrong grid size in data processing stage
        this.resize(this.model, api);
    };
    /**
   * Resize the grid.
   *
   * [NOTE]
   * If both "grid.containLabel/grid.contain" and pixel-required-data-processing (such as, "dataSampling")
   * exist, circular dependency occurs in logic.
   * The final compromised sequence is:
   *  1. Calculate "axis.extent" (pixel extent) and AffineTransform based on only "grid layout options".
   *      Not accurate if "grid.containLabel/grid.contain" is required, but it is a compromise to avoid
   *      circular dependency.
   *  2. Perform "series data processing" (where "dataSampling" requires "axis.extent").
   *  3. Calculate "scale.extent" (data extent) based on "processed series data".
   *  4. Modify "axis.extent" for "grid.containLabel/grid.contain":
   *      4.1. Calculate "axis labels" based on "scale.extent".
   *      4.2. Modify "axis.extent" by the bounding rects of "axis labels and names".
   */ Grid.prototype.resize = function(gridModel, api, beforeDataProcessing) {
        var layoutRef = (0, $6b64c78bf98fea85$export$5aec1e94f566e59f)(gridModel, api);
        var gridRect = this._rect = (0, $6b64c78bf98fea85$export$4517a5ca639a7293)(gridModel.getBoxLayoutParams(), layoutRef.refContainer);
        // PENDING: whether to support that if the input `coord` is out of the base coord sys,
        //  do not render anything. At present, the behavior is undefined.
        var axesMap = this._axesMap;
        var coordsList = this._coordsList;
        var optionContainLabel = gridModel.get('containLabel'); // No `.get(, true)` for backward compat.
        // NOTE: The axis pixel extent is also required by some estimation, e.g., in coord sys update stage,
        // bars on 'time'/'value' axis need it to calculate the supplementary scale extent to avoid edge bars
        // overflowing the axis (see `barGrid.ts`). Therefore, axis pixel extent need to be set early, even
        // may not be accurate.
        $a99cfa19e72005cb$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect);
        if (!beforeDataProcessing) {
            var axisBuilderSharedCtx = $a99cfa19e72005cb$var$createAxisBiulders(gridRect, coordsList, axesMap, optionContainLabel, api);
            var noPxChange = void 0;
            if (optionContainLabel) {
                if ($a99cfa19e72005cb$var$legacyLayOutGridByContainLabel) {
                    // console.time('legacyLayOutGridByContainLabel');
                    $a99cfa19e72005cb$var$legacyLayOutGridByContainLabel(this._axesList, gridRect);
                    $a99cfa19e72005cb$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect);
                // console.timeEnd('legacyLayOutGridByContainLabel');
                } else noPxChange = $a99cfa19e72005cb$var$layOutGridByOuterBounds(gridRect.clone(), 'axisLabel', null, gridRect, axesMap, axisBuilderSharedCtx, layoutRef);
            } else {
                var _a = $a99cfa19e72005cb$var$prepareOuterBounds(gridModel, gridRect, layoutRef), outerBoundsRect = _a.outerBoundsRect, parsedOuterBoundsContain = _a.parsedOuterBoundsContain, outerBoundsClamp = _a.outerBoundsClamp;
                if (outerBoundsRect) // console.time('layOutGridByOuterBounds');
                noPxChange = $a99cfa19e72005cb$var$layOutGridByOuterBounds(outerBoundsRect, parsedOuterBoundsContain, outerBoundsClamp, gridRect, axesMap, axisBuilderSharedCtx, layoutRef);
            }
            // console.time('buildAxesView_determine');
            $a99cfa19e72005cb$var$createOrUpdateAxesView(gridRect, axesMap, (0, $08a2e2b0d4c9ee4c$export$31cba7db0a663292).determine, null, noPxChange, layoutRef);
            // console.timeEnd('buildAxesView_determine');
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)(this._coordsList, function(coord) {
                // Calculate affine matrix to accelerate the data to point transform.
                // If all the axes scales are time or value.
                coord.calcAffineTransform();
            });
        } // End of beforeDataProcessing
    };
    Grid.prototype.getAxis = function(dim, axisIndex) {
        var axesMapOnDim = this._axesMap[dim];
        if (axesMapOnDim != null) return axesMapOnDim[axisIndex || 0];
    };
    Grid.prototype.getAxes = function() {
        return this._axesList.slice();
    };
    Grid.prototype.getCartesian = function(xAxisIndex, yAxisIndex) {
        if (xAxisIndex != null && yAxisIndex != null) {
            var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
            return this._coordsMap[key];
        }
        if ((0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(xAxisIndex)) {
            yAxisIndex = xAxisIndex.yAxisIndex;
            xAxisIndex = xAxisIndex.xAxisIndex;
        }
        for(var i = 0, coordList = this._coordsList; i < coordList.length; i++){
            if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) return coordList[i];
        }
    };
    Grid.prototype.getCartesians = function() {
        return this._coordsList.slice();
    };
    /**
   * @implements
   */ Grid.prototype.convertToPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
    };
    /**
   * @implements
   */ Grid.prototype.convertFromPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
    };
    Grid.prototype._findConvertTarget = function(finder) {
        var seriesModel = finder.seriesModel;
        var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis', (0, $3fa81475350067fd$export$f076738ec84e693c)).models[0];
        var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis', (0, $3fa81475350067fd$export$f076738ec84e693c)).models[0];
        var gridModel = finder.gridModel;
        var coordsList = this._coordsList;
        var cartesian;
        var axis;
        if (seriesModel) {
            cartesian = seriesModel.coordinateSystem;
            (0, $f16f2994a32ad273$export$305f7d4e9d4624f2)(coordsList, cartesian) < 0 && (cartesian = null);
        } else if (xAxisModel && yAxisModel) cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        else if (xAxisModel) axis = this.getAxis('x', xAxisModel.componentIndex);
        else if (yAxisModel) axis = this.getAxis('y', yAxisModel.componentIndex);
        else if (gridModel) {
            var grid = gridModel.coordinateSystem;
            if (grid === this) cartesian = this._coordsList[0];
        }
        return {
            cartesian: cartesian,
            axis: axis
        };
    };
    /**
   * @implements
   */ Grid.prototype.containPoint = function(point) {
        var coord = this._coordsList[0];
        if (coord) return coord.containPoint(point);
    };
    /**
   * Initialize cartesian coordinate systems
   */ Grid.prototype._initCartesian = function(gridModel, ecModel, api) {
        var _this = this;
        var grid = this;
        var axisPositionUsed = {
            left: false,
            right: false,
            top: false,
            bottom: false
        };
        var axesMap = {
            x: {},
            y: {}
        };
        var axesCount = {
            x: 0,
            y: 0
        };
        // Create axis
        ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
        ecModel.eachComponent('yAxis', createAxisCreator('y'), this);
        if (!axesCount.x || !axesCount.y) {
            // Roll back when there no either x or y axis
            this._axesMap = {};
            this._axesList = [];
            return;
        }
        this._axesMap = axesMap;
        // Create cartesian2d
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(axesMap.x, function(xAxis, xAxisIndex) {
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)(axesMap.y, function(yAxis, yAxisIndex) {
                var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
                var cartesian = new (0, $91da0e4d87ac2c8f$export$2e2bcd8739ae039)(key);
                cartesian.master = _this;
                cartesian.model = gridModel;
                _this._coordsMap[key] = cartesian;
                _this._coordsList.push(cartesian);
                cartesian.addAxis(xAxis);
                cartesian.addAxis(yAxis);
            });
        });
        $a99cfa19e72005cb$var$prepareAlignToInCoordSysCreate(axesMap.x);
        $a99cfa19e72005cb$var$prepareAlignToInCoordSysCreate(axesMap.y);
        function createAxisCreator(dimName) {
            return function(axisModel, idx) {
                if (!$a99cfa19e72005cb$var$isAxisUsedInTheGrid(axisModel, gridModel)) return;
                var axisPosition = axisModel.get('position');
                if (dimName === 'x') // Fix position
                {
                    if (axisPosition !== 'top' && axisPosition !== 'bottom') // Default bottom of X
                    axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
                } else // Fix position
                if (axisPosition !== 'left' && axisPosition !== 'right') // Default left of Y
                axisPosition = axisPositionUsed.left ? 'right' : 'left';
                axisPositionUsed[axisPosition] = true;
                var axisType = (0, $5197eaeff9ee5dfb$export$a0edf4de19b45ee7)(axisModel);
                var axis = new (0, $36dcf220d42ccdfa$export$2e2bcd8739ae039)(dimName, (0, $5197eaeff9ee5dfb$export$8941c4cacdc8f5a5)(axisModel, axisType, true), [
                    0,
                    0
                ], axisType, axisPosition);
                axis.onBand = (0, $5197eaeff9ee5dfb$export$43d51f65881fb080)(axis.scale, axisModel);
                axis.inverse = axisModel.get('inverse');
                // Inject axis into axisModel
                axisModel.axis = axis;
                // Inject axisModel into axis
                axis.model = axisModel;
                // Inject grid info axis
                axis.grid = grid;
                // Index of axis, can be used as key
                axis.index = idx;
                grid._axesList.push(axis);
                axesMap[dimName][idx] = axis;
                axesCount[dimName]++;
            };
        }
    };
    /**
   * @param dim 'x' or 'y' or 'auto' or null/undefined
   */ Grid.prototype.getTooltipAxes = function(dim) {
        var baseAxes = [];
        var otherAxes = [];
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(this.getCartesians(), function(cartesian) {
            var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
            var otherAxis = cartesian.getOtherAxis(baseAxis);
            (0, $f16f2994a32ad273$export$305f7d4e9d4624f2)(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
            (0, $f16f2994a32ad273$export$305f7d4e9d4624f2)(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
        });
        return {
            baseAxes: baseAxes,
            otherAxes: otherAxes
        };
    };
    Grid.create = function(ecModel, api) {
        var grids = [];
        ecModel.eachComponent('grid', function(gridModel, idx) {
            var grid = new Grid(gridModel, ecModel, api);
            grid.name = 'grid_' + idx;
            // dataSampling requires axis extent, so resize
            // should be performed in create stage.
            grid.resize(gridModel, api, true);
            gridModel.coordinateSystem = grid;
            grids.push(grid);
            (0, $f16f2994a32ad273$export$79b2f7037acddd43)(grid._axesList, function(axis) {
                (0, $6b680e8b1e09fdd5$export$710d8a038761b881)(axis, Grid.dimIdxMap);
            });
        });
        // Inject the coordinateSystems into seriesModel
        ecModel.eachSeries(function(seriesModel) {
            var xAxis;
            var yAxis;
            (0, $d1c2b348f154f767$export$7ed0c09d4f5c932e)({
                targetModel: seriesModel,
                coordSysType: (0, $a52c3079a78f555c$export$d0b4e8fdb7a13c60),
                coordSysProvider: coordSysProvider
            });
            function coordSysProvider() {
                var axesModelMap = (0, $d0095b1b8a21cc3f$export$8220131ac1d61d28)(seriesModel);
                var xAxisModel = axesModelMap.xAxisModel;
                var yAxisModel = axesModelMap.yAxisModel;
                xAxis = xAxisModel.axis;
                yAxis = yAxisModel.axis;
                var gridModel = xAxisModel.getCoordSysModel();
                var grid = gridModel.coordinateSystem;
                return grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
            }
            if (xAxis && yAxis) {
                (0, $b3d1594b84705f7d$export$48507d392d1d4894)(xAxis, seriesModel, (0, $a52c3079a78f555c$export$d0b4e8fdb7a13c60));
                (0, $b3d1594b84705f7d$export$48507d392d1d4894)(yAxis, seriesModel, (0, $a52c3079a78f555c$export$d0b4e8fdb7a13c60));
            }
        }, this);
        return grids;
    };
    // For deciding which dimensions to use when creating list data
    Grid.dimensions = (0, $91da0e4d87ac2c8f$export$988a008d2b9120f4);
    Grid.dimIdxMap = (0, $af0b4b5988d2bf1e$export$a477f5bebfd07944)((0, $91da0e4d87ac2c8f$export$988a008d2b9120f4));
    return Grid;
}();
/**
 * Check if the axis is used in the specified grid.
 */ function $a99cfa19e72005cb$var$isAxisUsedInTheGrid(axisModel, gridModel) {
    return axisModel.getCoordSysModel() === gridModel;
}
function $a99cfa19e72005cb$var$fixAxisOnZero(axesMap, otherAxisDim, axis, // Key: see `getOnZeroRecordKey`
onZeroRecords) {
    axis.getAxesOnZeroOf = function() {
        // TODO: onZero of multiple axes.
        return otherAxisOnZeroOf ? [
            otherAxisOnZeroOf
        ] : [];
    };
    // onZero can not be enabled in these two situations:
    // 1. When any other axis is a category axis.
    // 2. When no axis is cross 0 point.
    var otherAxes = axesMap[otherAxisDim];
    var otherAxisOnZeroOf;
    var axisModel = axis.model;
    var onZero = axisModel.get([
        'axisLine',
        'onZero'
    ]);
    var onZeroAxisIndex = axisModel.get([
        'axisLine',
        'onZeroAxisIndex'
    ]);
    // For historical reason, ec option `axisLine.onZero: undefined` leads to "not on zero"
    // while leaving `axisLine.onZero` unspecified causes "on zero". This inconsistency goes
    // against common sense, but is preserved for backward compatibility.
    if (!onZero) return;
    // If target axis is specified.
    if (onZeroAxisIndex != null) {
        if ($a99cfa19e72005cb$var$canOnZeroToAxis(onZero, otherAxes[onZeroAxisIndex])) otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
    } else {
        // Find the first available other axis.
        for(var idx in otherAxes)if ((0, $f16f2994a32ad273$export$b5a638e9b3fff9f3)(otherAxes, idx) && $a99cfa19e72005cb$var$canOnZeroToAxis(onZero, otherAxes[idx]) && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
            otherAxisOnZeroOf = otherAxes[idx];
            break;
        }
    }
    if (otherAxisOnZeroOf) onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
    function getOnZeroRecordKey(axis) {
        return axis.dim + '_' + axis.index;
    }
}
/**
 * CAVEAT: Must not be called before `CoordinateSystem#update` due to `__dontOnMyZero`.
 */ function $a99cfa19e72005cb$var$canOnZeroToAxis(onZeroOption, axis) {
    if (!axis) return false;
    var scale = axis.scale;
    var kindEffective = (0, $5197eaeff9ee5dfb$export$99e0963eefdef8b2)(scale, 0, false);
    var can = axis && axis.type !== 'category' && axis.type !== 'time' && kindEffective !== (0, $5197eaeff9ee5dfb$export$8b1206c1406788fd);
    if (can && onZeroOption === 'auto' && (0, $5197eaeff9ee5dfb$export$2204fb02f43463b7)(axis)) can = false;
    // falsy value of `onZeroOption` has been handled in the previous logic.
    return can;
}
/**
 * [CAVEAT] This method is called before data processing stage.
 *  Do not rely on any info that is determined afterward.
 */ function $a99cfa19e72005cb$var$prepareAlignToInCoordSysCreate(axes) {
    // Axis is added in order of axisIndex.
    var axesIndices = (0, $f16f2994a32ad273$export$ed97f33186d4b816)(axes);
    var alignTo;
    var axisNeedsAlign = [];
    for(var i = axesIndices.length - 1; i >= 0; i--){
        // Reverse order
        var axis = axes[+axesIndices[i]];
        if ((0, $f976678a0ff027db$export$dfc8cd28ed7b22a0)(axis.scale) && (0, $5197eaeff9ee5dfb$export$8094779d9b724f85)(axis.model, axis.type, true) == null) {
            // Request `alignTicks`.
            if (axis.model.get('alignTicks') && axis.model.get('interval') == null) axisNeedsAlign.push(axis);
            else // `alignTo` the last one that does not request `alignTicks`
            // (This rule is retained for backward compat).
            alignTo = axis;
        }
    }
    // If all axes has set alignTicks, pick the first one as alignTo.
    // PENDING. Should we find the axis that both set interval, min, max and align to this one?
    // PENDING. Should we allow specifying alignTo via ec option?
    if (!alignTo) alignTo = axisNeedsAlign.pop();
    if (alignTo) (0, $f16f2994a32ad273$export$79b2f7037acddd43)(axisNeedsAlign, function(axis) {
        axis.__alignTo = alignTo;
    });
}
/**
 * This is just a defence code. They are unlikely to be actually `true`,
 * since these cases have been addressed in `prepareAlignToInCoordSysCreate`.
 *
 * Can not be called BEFORE "nice" performed.
 */ function $a99cfa19e72005cb$var$incapableOfAlignNeedFallback(targetAxis, alignTo) {
    return (0, $cf43ca9fea251347$export$fec008222a1db2dc)(targetAxis.scale) || (0, $cf43ca9fea251347$export$fec008222a1db2dc)(alignTo.scale) || alignTo.scale.getTicks().length < 2;
}
function $a99cfa19e72005cb$var$updateAxisTransform(axis, coordBase) {
    var axisExtent = axis.getExtent();
    var axisExtentSum = axisExtent[0] + axisExtent[1];
    // Fast transform
    axis.toGlobalCoord = axis.dim === 'x' ? function(coord) {
        return coord + coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
    axis.toLocalCoord = axis.dim === 'x' ? function(coord) {
        return coord - coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
}
function $a99cfa19e72005cb$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect) {
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(axesMap.x, function(axis) {
        return $a99cfa19e72005cb$var$updateAxisExtentTransByGridRect(axis, gridRect.x, gridRect.width);
    });
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(axesMap.y, function(axis) {
        return $a99cfa19e72005cb$var$updateAxisExtentTransByGridRect(axis, gridRect.y, gridRect.height);
    });
}
function $a99cfa19e72005cb$var$updateAxisExtentTransByGridRect(axis, gridXY, gridWH) {
    var extent = [
        0,
        gridWH
    ];
    var idx = axis.inverse ? 1 : 0;
    axis.setExtent(extent[idx], extent[1 - idx]);
    $a99cfa19e72005cb$var$updateAxisTransform(axis, gridXY);
}
var $a99cfa19e72005cb$var$legacyLayOutGridByContainLabel;
function $a99cfa19e72005cb$export$9da5287b2e41f334(impl) {
    $a99cfa19e72005cb$var$legacyLayOutGridByContainLabel = impl;
}
// Return noPxChange.
function $a99cfa19e72005cb$var$layOutGridByOuterBounds(outerBoundsRect, outerBoundsContain, outerBoundsClamp, gridRect, axesMap, axisBuilderSharedCtx, layoutRef) {
    // Assume `updateAllAxisExtentTransByGridRect` has been performed once before this call.
    // [NOTE]:
    // - The bounding rect of the axis elements might be sensitve to variations in `axis.extent` due to strategies
    //  like hideOverlap/moveOverlap. @see the comment in `LabelLayoutBase['suggestIgnore']`.
    // - The final `gridRect` might be slightly smaller than the ideally expected result if labels are giant and
    //  get hidden due to overlapping. More iterations could improve precision, but not performant. We consider
    //  the current result acceptable, since no alignment among charts can be guaranteed when using this feature.
    $a99cfa19e72005cb$var$createOrUpdateAxesView(gridRect, axesMap, (0, $08a2e2b0d4c9ee4c$export$31cba7db0a663292).estimate, outerBoundsContain, false, layoutRef);
    var margin = [
        0,
        0,
        0,
        0
    ];
    fillLabelNameOverflowOnOneDimension(0);
    fillLabelNameOverflowOnOneDimension(1);
    // If axis is blank, no label can be used to detect overflow.
    // gridRect itself should not overflow.
    fillMarginOnOneDimension(gridRect, 0, NaN);
    fillMarginOnOneDimension(gridRect, 1, NaN);
    var noPxChange = (0, $f16f2994a32ad273$export$71aa6c912b956294)(margin, function(item) {
        return item > 0;
    }) == null;
    (0, $bce1f681c7fb2581$export$81ed941fdeb91c7c)(gridRect, margin, true, true, outerBoundsClamp);
    $a99cfa19e72005cb$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect);
    return noPxChange;
    function fillLabelNameOverflowOnOneDimension(xyIdx) {
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(axesMap[(0, $bce1f681c7fb2581$export$cb4c12294149dd2d)[xyIdx]], function(axis) {
            if (!(0, $5197eaeff9ee5dfb$export$75b737736393e03c)(axis.model)) return;
            // FIXME: zr Group.union may wrongly union (0, 0, 0, 0) and not performant.
            // unionRect.union(axis.axisBuilder.group.getBoundingRect());
            // If ussing Group.getBoundingRect to calculate shrink space, it is not strictly accurate when
            // the outermost label is ignored and the secondary label is very long and contribute to the
            // union extension:
            //      -|---|---|---|
            //         1,000,000,000
            // Therefore we calculate them one by one.
            // Also considered axis may be blank or no labels.
            var sharedRecord = axisBuilderSharedCtx.ensureRecord(axis.model);
            var labelInfoList = sharedRecord.labelInfoList;
            if (labelInfoList) for(var idx = 0; idx < labelInfoList.length; idx++){
                var labelInfo = labelInfoList[idx];
                var proportion = axis.scale.normalize((0, $5197eaeff9ee5dfb$export$889d2956111fd257)(axis.scale, (0, $f026cfe0f7218100$export$c392b818a26a879e)(labelInfo.label).labelInfo.tick));
                proportion = xyIdx === 1 ? 1 - proportion : proportion;
                // xAxis use proportion on x, yAxis use proprotion on y, otherwise not.
                fillMarginOnOneDimension(labelInfo.rect, xyIdx, proportion);
                fillMarginOnOneDimension(labelInfo.rect, 1 - xyIdx, NaN);
            }
            var nameLayout = sharedRecord.nameLayout;
            if (nameLayout) {
                var proportion = (0, $5197eaeff9ee5dfb$export$c06aa22293dea9d2)(sharedRecord.nameLocation) ? 0.5 : NaN;
                fillMarginOnOneDimension(nameLayout.rect, xyIdx, proportion);
                fillMarginOnOneDimension(nameLayout.rect, 1 - xyIdx, NaN);
            }
        });
    }
    function fillMarginOnOneDimension(itemRect, xyIdx, proportion // NaN mean no use proportion
    ) {
        var overflow1 = outerBoundsRect[(0, $bce1f681c7fb2581$export$cb4c12294149dd2d)[xyIdx]] - itemRect[(0, $bce1f681c7fb2581$export$cb4c12294149dd2d)[xyIdx]];
        var overflow2 = itemRect[(0, $bce1f681c7fb2581$export$a3fe6d967173a3ac)[xyIdx]] + itemRect[(0, $bce1f681c7fb2581$export$cb4c12294149dd2d)[xyIdx]] - (outerBoundsRect[(0, $bce1f681c7fb2581$export$a3fe6d967173a3ac)[xyIdx]] + outerBoundsRect[(0, $bce1f681c7fb2581$export$cb4c12294149dd2d)[xyIdx]]);
        overflow1 = applyProportion(overflow1, 1 - proportion);
        overflow2 = applyProportion(overflow2, proportion);
        var minIdx = $a99cfa19e72005cb$var$XY_TO_MARGIN_IDX[xyIdx][0];
        var maxIdx = $a99cfa19e72005cb$var$XY_TO_MARGIN_IDX[xyIdx][1];
        margin[minIdx] = (0, $104896d282bd296f$export$2ca8010d037f830f)(margin[minIdx], overflow1);
        margin[maxIdx] = (0, $104896d282bd296f$export$2ca8010d037f830f)(margin[maxIdx], overflow2);
    }
    function applyProportion(overflow, proportion) {
        // proportion is not likely to near zero. If so, give up shrink
        if (overflow > 0 && !(0, $f16f2994a32ad273$export$7d667b9a0c48c975)(proportion) && proportion > 1e-4) overflow /= proportion;
        return overflow;
    }
}
function $a99cfa19e72005cb$var$createAxisBiulders(gridRect, cartesians, axesMap, optionContainLabel, api) {
    var axisBuilderSharedCtx = new (0, $f026cfe0f7218100$export$f2e237206f7393f5)($a99cfa19e72005cb$var$resolveAxisNameOverlapForGrid);
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(axesMap, function(axisList) {
        return (0, $f16f2994a32ad273$export$79b2f7037acddd43)(axisList, function(axis) {
            if ((0, $5197eaeff9ee5dfb$export$75b737736393e03c)(axis.model)) {
                // See `AxisBaseOptionCommon['nameMoveOverlap']`.
                var defaultNameMoveOverlap = !optionContainLabel;
                axis.axisBuilder = (0, $d0095b1b8a21cc3f$export$2b2ce820c3e1e776)(gridRect, cartesians, axis.model, api, axisBuilderSharedCtx, defaultNameMoveOverlap);
            }
        });
    });
    return axisBuilderSharedCtx;
}
/**
 * Promote the axis-elements-building from "view render" stage to "coordinate system resize" stage.
 * This is aimed to resovle overlap across multiple axes, since currently it's hard to reconcile
 * multiple axes in "view render" stage.
 *
 * [CAUTION] But this promotion assumes that the subsequent "visual mapping" stage does not affect
 * this axis-elements-building; otherwise we have to refactor it again.
 */ function $a99cfa19e72005cb$var$createOrUpdateAxesView(gridRect, axesMap, kind, outerBoundsContain, noPxChange, layoutRef) {
    var isDetermine = kind === (0, $08a2e2b0d4c9ee4c$export$31cba7db0a663292).determine;
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(axesMap, function(axisList) {
        return (0, $f16f2994a32ad273$export$79b2f7037acddd43)(axisList, function(axis) {
            if ((0, $5197eaeff9ee5dfb$export$75b737736393e03c)(axis.model)) {
                (0, $d0095b1b8a21cc3f$export$3e8d41f03e1a6a39)(axis.axisBuilder, gridRect, axis.model);
                axis.axisBuilder.build(isDetermine ? {
                    axisTickLabelDetermine: true
                } : {
                    axisTickLabelEstimate: true
                }, {
                    noPxChange: noPxChange
                });
            }
        });
    });
    var nameMarginLevelMap = {
        x: 0,
        y: 0
    };
    calcNameMarginLevel(0);
    calcNameMarginLevel(1);
    function calcNameMarginLevel(xyIdx) {
        nameMarginLevelMap[(0, $bce1f681c7fb2581$export$cb4c12294149dd2d)[1 - xyIdx]] = gridRect[(0, $bce1f681c7fb2581$export$a3fe6d967173a3ac)[xyIdx]] <= layoutRef.refContainer[(0, $bce1f681c7fb2581$export$a3fe6d967173a3ac)[xyIdx]] * 0.5 ? 0 : 1 - xyIdx === 1 ? 2 : 1;
    }
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(axesMap, function(axisList, xy) {
        return (0, $f16f2994a32ad273$export$79b2f7037acddd43)(axisList, function(axis) {
            if ((0, $5197eaeff9ee5dfb$export$75b737736393e03c)(axis.model)) {
                if (outerBoundsContain === 'all' || isDetermine) // To resolve overlap, `axisName` layout depends on `axisTickLabel` layout result
                // (all of the axes of the same `grid`; consider multiple x or y axes).
                axis.axisBuilder.build({
                    axisName: true
                }, {
                    nameMarginLevel: nameMarginLevelMap[xy]
                });
                if (isDetermine) axis.axisBuilder.build({
                    axisLine: true
                });
            }
        });
    });
}
function $a99cfa19e72005cb$var$prepareOuterBounds(gridModel, rawGridRect, layoutRef) {
    var outerBoundsRect;
    var optionOuterBoundsMode = gridModel.get('outerBoundsMode', true);
    if (optionOuterBoundsMode === 'same') outerBoundsRect = rawGridRect.clone();
    else if (optionOuterBoundsMode == null || optionOuterBoundsMode === 'auto') outerBoundsRect = (0, $6b64c78bf98fea85$export$4517a5ca639a7293)(gridModel.get('outerBounds', true) || (0, $a52c3079a78f555c$export$57b4bb4ff2a0950c), layoutRef.refContainer);
    else optionOuterBoundsMode;
    var optionOuterBoundsContain = gridModel.get('outerBoundsContain', true);
    var parsedOuterBoundsContain;
    if (optionOuterBoundsContain == null || optionOuterBoundsContain === 'auto') parsedOuterBoundsContain = 'all';
    else if ((0, $f16f2994a32ad273$export$305f7d4e9d4624f2)([
        'all',
        'axisLabel'
    ], optionOuterBoundsContain) < 0) parsedOuterBoundsContain = 'all';
    else parsedOuterBoundsContain = optionOuterBoundsContain;
    var outerBoundsClamp = [
        (0, $104896d282bd296f$export$6b392db7c2374a1a)((0, $f16f2994a32ad273$export$995e01f2f5c9d030)(gridModel.get('outerBoundsClampWidth', true), (0, $a52c3079a78f555c$export$e78e6bf4dcc3e485)[0]), rawGridRect.width),
        (0, $104896d282bd296f$export$6b392db7c2374a1a)((0, $f16f2994a32ad273$export$995e01f2f5c9d030)(gridModel.get('outerBoundsClampHeight', true), (0, $a52c3079a78f555c$export$e78e6bf4dcc3e485)[1]), rawGridRect.height)
    ];
    return {
        outerBoundsRect: outerBoundsRect,
        parsedOuterBoundsContain: parsedOuterBoundsContain,
        outerBoundsClamp: outerBoundsClamp
    };
}
var $a99cfa19e72005cb$var$resolveAxisNameOverlapForGrid = function resolveAxisNameOverlapForGrid(cfg, ctx, axisModel, nameLayoutInfo, nameMoveDirVec, thisRecord) {
    var perpendicularDim = axisModel.axis.dim === 'x' ? 'y' : 'x';
    (0, $f026cfe0f7218100$export$7fcb8742f5816cae)(cfg, ctx, axisModel, nameLayoutInfo, nameMoveDirVec, thisRecord);
    // If nameLocation 'center', and there are multiple axes parallel to this axis, do not adjust by
    //  other axes, because the axis name should be close to its axis line as much as possible even
    //  if overlapping; otherwise it might cause misleading.
    // If nameLocation 'center', do not adjust by perpendicular axes, since they are not likely to overlap.
    // If nameLocation 'start'/'end', move name within the same direction to escape overlap with the
    //  perpendicular axes.
    if (!(0, $5197eaeff9ee5dfb$export$c06aa22293dea9d2)(cfg.nameLocation)) (0, $f16f2994a32ad273$export$79b2f7037acddd43)(ctx.recordMap[perpendicularDim], function(perpenRecord) {
        // perpendicular axis may be no name.
        if (perpenRecord && perpenRecord.labelInfoList && perpenRecord.dirVec) (0, $f026cfe0f7218100$export$e033c6449cc6f6a1)(perpenRecord.labelInfoList, perpenRecord.dirVec, nameLayoutInfo, nameMoveDirVec);
    });
};
var $a99cfa19e72005cb$export$2e2bcd8739ae039 = $a99cfa19e72005cb$var$Grid;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $dae56e8274678bf8$var$inner = (0, $3fa81475350067fd$export$64df9f8d92ae083f)();
function $dae56e8274678bf8$export$c80b7ef1527ec8c9(axisView, axisGroup, axisModel, gridModel) {
    var axis = axisModel.axis;
    if (axis.scale.isBlank()) return;
    var splitAreaModel = axisModel.getModel('splitArea');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var areaColors = areaStyleModel.get('color');
    var gridRect = gridModel.coordinateSystem.getRect();
    var ticksCoords = axis.getTicksCoords({
        tickModel: splitAreaModel,
        breakTicks: 'none',
        pruneByBreak: 'preserve_extent_bound'
    });
    if (!ticksCoords.length) return;
    // For Making appropriate splitArea animation, the color and anid
    // should be corresponding to previous one if possible.
    var areaColorsLen = areaColors.length;
    var lastSplitAreaColors = $dae56e8274678bf8$var$inner(axisView).splitAreaColors;
    var newSplitAreaColors = $f16f2994a32ad273$export$55f8aa7ef875b0a4();
    var colorIndex = 0;
    if (lastSplitAreaColors) for(var i = 0; i < ticksCoords.length; i++){
        var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
        if (cIndex != null) {
            colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
            break;
        }
    }
    var prev = axis.toGlobalCoord(ticksCoords[0].coord);
    var areaStyle = areaStyleModel.getAreaStyle();
    areaColors = $f16f2994a32ad273$export$43bee75e5e14138e(areaColors) ? areaColors : [
        areaColors
    ];
    for(var i = 1; i < ticksCoords.length; i++){
        var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
        var x = void 0;
        var y = void 0;
        var width = void 0;
        var height = void 0;
        if (axis.isHorizontal()) {
            x = prev;
            y = gridRect.y;
            width = tickCoord - x;
            height = gridRect.height;
            prev = x + width;
        } else {
            x = gridRect.x;
            y = prev;
            width = gridRect.width;
            height = tickCoord - y;
            prev = y + height;
        }
        var tickValue = ticksCoords[i - 1].tickValue;
        tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
        axisGroup.add(new $dbd6d77105f10fb2$export$2e2bcd8739ae039({
            anid: tickValue != null ? 'area_' + tickValue : null,
            shape: {
                x: x,
                y: y,
                width: width,
                height: height
            },
            style: $f16f2994a32ad273$export$ebe90cb607ad99e({
                fill: areaColors[colorIndex]
            }, areaStyle),
            autoBatch: true,
            silent: true
        }));
        colorIndex = (colorIndex + 1) % areaColorsLen;
    }
    $dae56e8274678bf8$var$inner(axisView).splitAreaColors = newSplitAreaColors;
}
function $dae56e8274678bf8$export$48ebf2d6ce8ad076(axisView) {
    $dae56e8274678bf8$var$inner(axisView).splitAreaColors = null;
}




var $e03442cd570bfb1a$var$selfBuilderAttrs = [
    'splitArea',
    'splitLine',
    'minorSplitLine',
    'breakArea'
];
var $e03442cd570bfb1a$var$CartesianAxisView = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(CartesianAxisView, _super);
    function CartesianAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianAxisView.type;
        _this.axisPointerClass = 'CartesianAxisPointer';
        return _this;
    }
    /**
   * @override
   */ CartesianAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $ac4abc1f547da31a$export$2e2bcd8739ae039();
        this.group.add(this._axisGroup);
        if (!(0, $5197eaeff9ee5dfb$export$75b737736393e03c)(axisModel)) return;
        this._axisGroup.add(axisModel.axis.axisBuilder.group);
        $f16f2994a32ad273$export$79b2f7037acddd43($e03442cd570bfb1a$var$selfBuilderAttrs, function(name) {
            if (axisModel.get([
                name,
                'show'
            ])) $e03442cd570bfb1a$var$axisElementBuilders[name](this, this._axisGroup, axisModel, axisModel.getCoordSysModel(), api);
        }, this);
        // THIS is a special case for bar racing chart.
        // Update the axis label from the natural initial layout to
        // sorted layout should has no animation.
        var isInitialSortFromBarRacing = payload && payload.type === 'changeAxisOrder' && payload.isInitSort;
        if (!isInitialSortFromBarRacing) $bce1f681c7fb2581$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
    };
    CartesianAxisView.prototype.remove = function() {
        (0, $dae56e8274678bf8$export$48ebf2d6ce8ad076)(this);
    };
    CartesianAxisView.type = 'cartesianAxis';
    return CartesianAxisView;
}((0, $c5863ebf1b74fa5e$export$2e2bcd8739ae039));
var $e03442cd570bfb1a$var$axisElementBuilders = {
    splitLine: function splitLine(axisView, axisGroup, axisModel, gridModel, api) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel('splitLine');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var lineColors = lineStyleModel.get('color');
        var showMinLine = splitLineModel.get('showMinLine') !== false;
        var showMaxLine = splitLineModel.get('showMaxLine') !== false;
        lineColors = $f16f2994a32ad273$export$43bee75e5e14138e(lineColors) ? lineColors : [
            lineColors
        ];
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel,
            breakTicks: 'none',
            pruneByBreak: 'preserve_extent_bound'
        });
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < ticksCoords.length; i++){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (i === 0 && !showMinLine || i === ticksCoords.length - 1 && !showMaxLine) continue;
            var tickValue = ticksCoords[i].tickValue;
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var colorIndex = lineCount++ % lineColors.length;
            var line = new $b37b447960e3414d$export$2e2bcd8739ae039({
                anid: tickValue != null ? 'line_' + tickValue : null,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: $f16f2994a32ad273$export$ebe90cb607ad99e({
                    stroke: lineColors[colorIndex]
                }, lineStyle),
                silent: true
            });
            $bce1f681c7fb2581$export$8b4b620d7f4aad1b(line.shape, lineStyle.lineWidth);
            axisGroup.add(line);
        }
    },
    minorSplitLine: function minorSplitLine(axisView, axisGroup, axisModel, gridModel, api) {
        var axis = axisModel.axis;
        var minorSplitLineModel = axisModel.getModel('minorSplitLine');
        var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var minorTicksCoords = axis.getMinorTicksCoords();
        if (!minorTicksCoords.length) return;
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++){
            var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var line = new $b37b447960e3414d$export$2e2bcd8739ae039({
                anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: lineStyle,
                silent: true
            });
            $bce1f681c7fb2581$export$8b4b620d7f4aad1b(line.shape, lineStyle.lineWidth);
            axisGroup.add(line);
        }
    },
    splitArea: function splitArea(axisView, axisGroup, axisModel, gridModel, api) {
        (0, $dae56e8274678bf8$export$c80b7ef1527ec8c9)(axisView, axisGroup, axisModel, gridModel);
    },
    breakArea: function breakArea(axisView, axisGroup, axisModel, gridModel, api) {
        var axisBreakHelper = (0, $fc815de52b491ed4$export$c1d9b2cc33e7e5e)();
        var scale = axisModel.axis.scale;
        if (axisBreakHelper && scale.type !== 'ordinal') axisBreakHelper.rectCoordBuildBreakAxis(axisGroup, axisView, axisModel, gridModel.coordinateSystem.getRect(), api);
    }
};
var $e03442cd570bfb1a$export$b6d40cd875b8a1c8 = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(CartesianXAxisView, _super);
    function CartesianXAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianXAxisView.type;
        return _this;
    }
    CartesianXAxisView.type = 'xAxis';
    return CartesianXAxisView;
}($e03442cd570bfb1a$var$CartesianAxisView);
var $e03442cd570bfb1a$export$417e1bdd0616e0dc = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(CartesianYAxisView, _super);
    function CartesianYAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $e03442cd570bfb1a$export$b6d40cd875b8a1c8.type;
        return _this;
    }
    CartesianYAxisView.type = 'yAxis';
    return CartesianYAxisView;
}($e03442cd570bfb1a$var$CartesianAxisView);
var $e03442cd570bfb1a$export$2e2bcd8739ae039 = $e03442cd570bfb1a$var$CartesianAxisView;


// Grid view
var $c0d741a8b7d405d1$var$GridView = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(GridView, _super);
    function GridView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'grid';
        return _this;
    }
    GridView.prototype.render = function(gridModel, ecModel) {
        this.group.removeAll();
        if (gridModel.get('show')) this.group.add(new (0, $dbd6d77105f10fb2$export$2e2bcd8739ae039)({
            shape: gridModel.coordinateSystem.getRect(),
            style: (0, $f16f2994a32ad273$export$ebe90cb607ad99e)({
                fill: gridModel.get('backgroundColor')
            }, gridModel.getItemStyle()),
            silent: true,
            z2: -1
        }));
    };
    GridView.type = 'grid';
    return GridView;
}((0, $091798b5bbee0498$export$2e2bcd8739ae039));
var $c0d741a8b7d405d1$var$extraOption = {
    // gridIndex: 0,
    // gridId: '',
    offset: 0
};
function $c0d741a8b7d405d1$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView($c0d741a8b7d405d1$var$GridView);
    registers.registerComponentModel((0, $a52c3079a78f555c$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem('cartesian2d', (0, $a99cfa19e72005cb$export$2e2bcd8739ae039));
    (0, $6cb0bc2c2c1e2f13$export$2e2bcd8739ae039)(registers, 'x', (0, $51812b97bcb3beb5$export$483dc37e6ad83a3c), $c0d741a8b7d405d1$var$extraOption);
    (0, $6cb0bc2c2c1e2f13$export$2e2bcd8739ae039)(registers, 'y', (0, $51812b97bcb3beb5$export$483dc37e6ad83a3c), $c0d741a8b7d405d1$var$extraOption);
    registers.registerComponentView((0, $e03442cd570bfb1a$export$b6d40cd875b8a1c8));
    registers.registerComponentView((0, $e03442cd570bfb1a$export$417e1bdd0616e0dc));
    registers.registerPreprocessor(function(option) {
        // Only create grid when need
        if (option.xAxis && option.yAxis && !option.grid) option.grid = {};
    });
}




function $17d7cacd40714b71$export$4b3e715f166fdd78(registers) {
    (0, $5b64c22a7e1cb8f6$export$1f96ae73734a86cc)((0, $c0d741a8b7d405d1$export$4b3e715f166fdd78));
    (0, $5b64c22a7e1cb8f6$export$1f96ae73734a86cc)((0, $6bef08f2ff097566$export$4b3e715f166fdd78));
}




var $3ebea454486cd0b1$var$_a;
(0, $5b64c22a7e1cb8f6$export$1f96ae73734a86cc)((0, $17d7cacd40714b71$export$4b3e715f166fdd78));
var $3ebea454486cd0b1$export$7f67bc504bca3675 = /*#__PURE__*/ function(ECOptionElement) {
    "use strict";
    (0, $hdIku._)(ECXAxisComponent, ECOptionElement);
    function ECXAxisComponent() {
        (0, $173N4._)(this, ECXAxisComponent);
        return (0, $7qXGD._)(this, ECXAxisComponent, arguments);
    }
    return ECXAxisComponent;
}((0, $6f6095288b1fca4a$export$37de6f71bb86a769));
($3ebea454486cd0b1$var$_a = globalThis.customElements) === null || $3ebea454486cd0b1$var$_a === void 0 || $3ebea454486cd0b1$var$_a.define('ec-x-axis', $3ebea454486cd0b1$export$7f67bc504bca3675);



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $hdIku = parcelRequire("hdIku");



var $ccb1f2ca897483af$var$_a;
(0, $5b64c22a7e1cb8f6$export$1f96ae73734a86cc)((0, $17d7cacd40714b71$export$4b3e715f166fdd78));
var $ccb1f2ca897483af$export$6c73b4102a25a459 = /*#__PURE__*/ function(ECOptionElement) {
    "use strict";
    (0, $hdIku._)(ECYAxisComponent, ECOptionElement);
    function ECYAxisComponent() {
        (0, $173N4._)(this, ECYAxisComponent);
        return (0, $7qXGD._)(this, ECYAxisComponent, arguments);
    }
    return ECYAxisComponent;
}((0, $6f6095288b1fca4a$export$37de6f71bb86a769));
($ccb1f2ca897483af$var$_a = globalThis.customElements) === null || $ccb1f2ca897483af$var$_a === void 0 || $ccb1f2ca897483af$var$_a.define('ec-y-axis', $ccb1f2ca897483af$export$6c73b4102a25a459);



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $hdIku = parcelRequire("hdIku");
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $7E0eS = parcelRequire("7E0eS");




var $ad7d9044a6be6c49$export$4c40490832d9cdb0 = (typeof Int8Array === "undefined" ? "undefined" : (0, $7E0eS._)(Int8Array)) !== (0, $c870d17359cdf008$export$5ba2cba1cb566d7a) ? Int8Array : undefined;
var $ad7d9044a6be6c49$export$111fe31494f58dc3 = (typeof Int16Array === "undefined" ? "undefined" : (0, $7E0eS._)(Int16Array)) !== (0, $c870d17359cdf008$export$5ba2cba1cb566d7a) ? Int16Array : undefined;
var $ad7d9044a6be6c49$export$b18d4ae90391caf = (typeof Int32Array === "undefined" ? "undefined" : (0, $7E0eS._)(Int32Array)) !== (0, $c870d17359cdf008$export$5ba2cba1cb566d7a) ? Int32Array : undefined;
var $ad7d9044a6be6c49$export$14996b0f94ec6069 = (typeof Uint8Array === "undefined" ? "undefined" : (0, $7E0eS._)(Uint8Array)) !== (0, $c870d17359cdf008$export$5ba2cba1cb566d7a) ? Uint8Array : undefined;
var $ad7d9044a6be6c49$export$3899859b7677d71 = (typeof Uint16Array === "undefined" ? "undefined" : (0, $7E0eS._)(Uint16Array)) !== (0, $c870d17359cdf008$export$5ba2cba1cb566d7a) ? Uint16Array : undefined;
var $ad7d9044a6be6c49$export$f46ab92cd13bdf8 = (typeof Uint32Array === "undefined" ? "undefined" : (0, $7E0eS._)(Uint32Array)) !== (0, $c870d17359cdf008$export$5ba2cba1cb566d7a) ? Uint32Array : undefined;
var $ad7d9044a6be6c49$export$9f6b2141b0069558 = (typeof Uint8ClampedArray === "undefined" ? "undefined" : (0, $7E0eS._)(Uint8ClampedArray)) !== (0, $c870d17359cdf008$export$5ba2cba1cb566d7a) ? Uint8ClampedArray : undefined;
var $ad7d9044a6be6c49$export$e39334316500bbe = (typeof Float32Array === "undefined" ? "undefined" : (0, $7E0eS._)(Float32Array)) !== (0, $c870d17359cdf008$export$5ba2cba1cb566d7a) ? Float32Array : undefined;
var $ad7d9044a6be6c49$export$8b884c4a18b44713 = (typeof Float64Array === "undefined" ? "undefined" : (0, $7E0eS._)(Float64Array)) !== (0, $c870d17359cdf008$export$5ba2cba1cb566d7a) ? Float64Array : undefined;
function $ad7d9044a6be6c49$export$21d2298f3f56bbaf(capacity) {
    return $ad7d9044a6be6c49$export$d47152ac0737a5e9({
        ctor: $ad7d9044a6be6c49$export$e39334316500bbe
    }, capacity).arr;
}
function $ad7d9044a6be6c49$export$d47152ac0737a5e9(tyArr, // Can add more types if needed.
// NOTICE: Callers need to manage data length themselves.
// Do not consider `capacity` as the data length.
capacity) {
    var existingArr = tyArr.arr;
    var ctor = tyArr.ctor;
    if (capacity > (0, $104896d282bd296f$export$18510406f204a1b9)) capacity = (0, $104896d282bd296f$export$18510406f204a1b9);
    if (!existingArr || tyArr.typed && existingArr.length < capacity) {
        var nextArr = void 0;
        if (ctor) try {
            // A large contiguous memory allocation may cause OOM.
            nextArr = new ctor(capacity);
            tyArr.typed = true;
            existingArr && nextArr.set(existingArr);
        } catch (e) {}
        if (!nextArr) {
            nextArr = [];
            tyArr.typed = false;
            if (existingArr) for(var i = 0, len = existingArr.length; i < len; i++)nextArr[i] = existingArr[i];
        }
        tyArr.arr = nextArr;
    }
    return tyArr;
}








/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




function $64c83a6aa1decd0d$export$303243915ac59737() {
    (0, $b3d1594b84705f7d$export$5ce2ad54acb7c055)('liPosMinGap', $64c83a6aa1decd0d$var$metricLiPosMinGapImpl);
}
function $64c83a6aa1decd0d$var$metricLiPosMinGapImpl(ecModel, perKeyPerAxis, ecPreparePerKeyPerAxis) {
    var newSerUids = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
    var ecPrepareSerUids = ecPreparePerKeyPerAxis.serUids;
    var ecPrepareLiPosMinGap = ecPreparePerKeyPerAxis.liPosMinGap;
    var ecPrepareCacheMiss;
    var axis = perKeyPerAxis.axis;
    var scale = axis.scale;
    // const linearValueExtent = initExtentForUnion();
    var needTransform = scale.needTransform();
    var filter = scale.getFilter ? scale.getFilter() : null;
    var filterParsed = (0, $722bed231f2dca45$export$1b2aa782dfdf5700)(filter);
    // const timeRetrieve: number[] = []; // _EC_PERF_
    // const timeSort: number[] = []; // _EC_PERF_
    // const timeAll: number[] = []; // _EC_PERF_
    // timeAll[0] = Date.now(); // _EC_PERF_
    function eachSeries(cb) {
        (0, $b3d1594b84705f7d$export$bf07bebae360b2fc)(ecModel, perKeyPerAxis.sers, function(seriesModel) {
            var rawData = seriesModel.getRawData();
            // NOTE: Currently there is no series that a "base axis" can map to multiple dimensions.
            var dimStoreIdx = rawData.getDimensionIndex(rawData.mapDimension(axis.dim));
            if (dimStoreIdx >= 0) cb(dimStoreIdx, seriesModel, rawData.getStore());
        });
    }
    var bufferCapacity = 0;
    eachSeries(function(dimStoreIdx, seriesModel, rawDataStore) {
        newSerUids.set(seriesModel.uid, 1);
        if (!ecPrepareSerUids || !ecPrepareSerUids.hasKey(seriesModel.uid)) ecPrepareCacheMiss = true;
        bufferCapacity += rawDataStore.count();
    });
    if (!ecPrepareSerUids || ecPrepareSerUids.keys().length !== newSerUids.keys().length) ecPrepareCacheMiss = true;
    if (!ecPrepareCacheMiss && ecPrepareLiPosMinGap != null) {
        // Consider the fact in practice:
        //  - Series data can only be changed in EC_PREPARE.
        //  - The relationship between series and axes can only be changed in EC_PREPARE and
        //    SERIES_FILTER.
        //  (See EC_CYCLE for more info)
        // Therefore, some statistics results can be cached in `GlobalModelCachePerECPrepare` to avoid
        // repeated time-consuming calculation for large data (e.g., over 1e5 data items).
        perKeyPerAxis.liPosMinGap = ecPrepareLiPosMinGap;
        return;
    }
    (0, $ad7d9044a6be6c49$export$d47152ac0737a5e9)($64c83a6aa1decd0d$var$tmpValueBuffer, bufferCapacity);
    // timeRetrieve[0] = Date.now(); // _EC_PERF_
    var writeIdx = 0;
    eachSeries(function(dimStoreIdx, seriesModel, store) {
        // NOTE: It appears to be optimized by traveling only in a specific window (e.g., the current window)
        // instead of the entire data, but that would likely generate inconsistent result and bring
        // jitter when dataZoom roaming.
        for(var i = 0, cnt = store.count(); i < cnt; ++i){
            // Manually inline some code for performance, since no other optimization
            // (such as, progressive) can be applied here.
            var val = store.get(dimStoreIdx, i);
            // NOTE: in most cases, filter does not exist.
            if (isFinite(val) && (!filter || (0, $722bed231f2dca45$export$49bf74cb3f1b6c80)(filterParsed, val))) {
                if (needTransform) // PENDING: time-consuming if axis break is applied.
                val = scale.transformIn(val, null);
                $64c83a6aa1decd0d$var$tmpValueBuffer.arr[writeIdx++] = val;
            // val < linearValueExtent[0] && (linearValueExtent[0] = val);
            // val > linearValueExtent[1] && (linearValueExtent[1] = val);
            }
        }
    });
    // Indicatively, retrieving values above costs 40ms for 1e6 values in a certain platform.
    // timeRetrieve[1] = Date.now(); // _EC_PERF_
    var tmpValueBufferView = $64c83a6aa1decd0d$var$tmpValueBuffer.typed ? $64c83a6aa1decd0d$var$tmpValueBuffer.arr.subarray(0, writeIdx) : ($64c83a6aa1decd0d$var$tmpValueBuffer.arr.length = writeIdx, $64c83a6aa1decd0d$var$tmpValueBuffer.arr);
    // timeSort[0] = Date.now(); // _EC_PERF_
    // Sort axis values into ascending order to calculate gaps.
    if ($64c83a6aa1decd0d$var$tmpValueBuffer.typed) // Indicatively, 5ms for 1e6 values in a certain platform.
    tmpValueBufferView.sort();
    else (0, $104896d282bd296f$export$debe6e778e0a6d32)(tmpValueBufferView);
    // timeAll[1] = timeSort[1] = Date.now(); // _EC_PERF_
    // console.log('axisStatistics_minGap_retrieve', timeRetrieve[1] - timeRetrieve[0]); // _EC_PERF_
    // console.log('axisStatistics_minGap_sort', timeSort[1] - timeSort[0]); // _EC_PERF_
    // console.log('axisStatistics_minGap_all', timeAll[1] - timeAll[0]); // _EC_PERF_
    var min = Infinity;
    for(var j = 1; j < writeIdx; ++j){
        var delta = tmpValueBufferView[j] - tmpValueBufferView[j - 1];
        if (// - Different series normally have the same values (e.g., barA, barB, barC),
        //   which should be ignored.
        // - A single series with multiple same values is often not meaningful to
        //   create `bandWidth`, so it is also ignored.
        delta > 0 && delta < min) min = delta;
    }
    ecPreparePerKeyPerAxis.liPosMinGap = perKeyPerAxis.liPosMinGap = (0, $104896d282bd296f$export$b5c30d4208814a65)(min) ? min : writeIdx > 0 ? (0, $b3d1594b84705f7d$export$3faff2d166c13471) : (0, $b3d1594b84705f7d$export$5e218fe556c51ff0);
    ecPreparePerKeyPerAxis.serUids = newSerUids;
}
// For performance optimization.
var $64c83a6aa1decd0d$var$tmpValueBuffer = (0, $ad7d9044a6be6c49$export$d47152ac0737a5e9)({
    ctor: (0, $ad7d9044a6be6c49$export$8b884c4a18b44713)
}, 50 // An arbitrary initial capability.
);




function $7c545d8beb47d2c1$export$a8febf733c5b3d4e(axisStatKey) {
    // [AXIS_CONTAIN_SHAPE_COMMON_STRATEGY]:
    //  The calculation below is based on a proportion mapping
    //  from `[barsBoundVal[0], barsBoundVal[1]]` to `[minValNew, maxValNew]`:
    //                  |------|------------------------------|---|
    //     barsBoundVal[0]   minValOld                 maxValOld barsBoundVal[1]
    //                         |----|----------------------|--|
    //                  minValNew    minValOld     maxValOld maxValNew
    //     (Note: `|---|` above represents "pixels" rather than "data".)
    return function(axis, ecModel) {
        var bandWidthResult = (0, $4f7015271e7d3825$export$141021262b29d96e)(axis, {
            fromStat: {
                key: axisStatKey
            }
        });
        if ((0, $104896d282bd296f$export$b5c30d4208814a65)(bandWidthResult.w2)) return [
            -bandWidthResult.w2 / 2,
            bandWidthResult.w2 / 2
        ];
    };
}
function $7c545d8beb47d2c1$export$e42e3d4e9c56410(seriesType) {
    return seriesType + (0, $b3d1594b84705f7d$export$ba567ca71745149b);
}
function $7c545d8beb47d2c1$export$6e465398bf63b595(seriesType, coordSysType) {
    return seriesType + (0, $b3d1594b84705f7d$export$ba567ca71745149b) + coordSysType;
}
function $7c545d8beb47d2c1$export$7a00bf58e60fc739(axis) {
    (0, $64c83a6aa1decd0d$export$303243915ac59737)();
    return {
        // non-category scale do not use `liPosMinGap` to calculate `bandWidth`.
        liPosMinGap: !(0, $f976678a0ff027db$export$61579433626afe87)(axis.scale)
    };
}




var $1d243d9d64281796$export$c34a2bf62ca07d83 = 'bar';
var $1d243d9d64281796$export$4d5ca1757c2395af = 'pictorialBar';
function $1d243d9d64281796$export$7374d3b28c4a7327(registers, axisStatKey, seriesType, coordSysType) {
    (0, $b3d1594b84705f7d$export$ad2364183e23f875)(registers, {
        key: axisStatKey,
        seriesType: seriesType,
        coordSysType: coordSysType,
        getMetrics: (0, $7c545d8beb47d2c1$export$7a00bf58e60fc739)
    });
}
function $1d243d9d64281796$export$e2d7eaa2ea5b61c4(baseAxis) {
    var val = baseAxis.scale.rawExtentInfo.makeRenderInfo().startValue;
    return val;
}




var $c6c6cd7fb79dc955$var$callOnlyOnce = (0, $3fa81475350067fd$export$a305e9b27fd23ae3)();
var $c6c6cd7fb79dc955$var$STACK_PREFIX = '__ec_stack_';
function $c6c6cd7fb79dc955$var$getSeriesStackId(seriesModel) {
    return seriesModel.get('stack') || $c6c6cd7fb79dc955$var$STACK_PREFIX + seriesModel.seriesIndex;
}
function $c6c6cd7fb79dc955$export$20316ec86014c315(opt) {
    if (!(0, $f976678a0ff027db$export$61579433626afe87)(opt.axis.scale)) return;
    var bandWidthResult = (0, $4f7015271e7d3825$export$141021262b29d96e)(opt.axis);
    var params = [];
    for(var i = 0; i < opt.count || 0; i++)params.push((0, $f16f2994a32ad273$export$ebe90cb607ad99e)({
        stackId: $c6c6cd7fb79dc955$var$STACK_PREFIX + i
    }, opt));
    var widthAndOffsets = $c6c6cd7fb79dc955$var$calcBarWidthAndOffset({
        bandWidthResult: bandWidthResult,
        seriesInfo: params
    });
    var result = [];
    for(var i = 0; i < opt.count; i++){
        var item = widthAndOffsets[$c6c6cd7fb79dc955$var$STACK_PREFIX + i];
        item.offsetCenter = item.offset + item.width / 2;
        result.push(item);
    }
    return result;
}
/**
 * NOTICE: This layout is based on axis pixel extent and scale extent.
 *  It may be used on estimation, where axis pixel extent and scale extent
 *  are approximately set. But the result should not be cached since the
 *  axis pixel extent and scale extent may be changed finally.
 */ function $c6c6cd7fb79dc955$var$makeColumnLayoutOnAxisReal(baseAxis, seriesType) {
    var seriesInfoListOnAxis = $c6c6cd7fb79dc955$var$createLayoutInfoListOnAxis(baseAxis, seriesType);
    seriesInfoListOnAxis.columnMap = $c6c6cd7fb79dc955$var$calcBarWidthAndOffset(seriesInfoListOnAxis);
    return seriesInfoListOnAxis;
}
function $c6c6cd7fb79dc955$var$createLayoutInfoListOnAxis(baseAxis, seriesType) {
    var axisStatKey = (0, $7c545d8beb47d2c1$export$6e465398bf63b595)(seriesType, (0, $a52c3079a78f555c$export$d0b4e8fdb7a13c60));
    var seriesInfoOnAxis = [];
    var bandWidthResult = (0, $4f7015271e7d3825$export$141021262b29d96e)(baseAxis, {
        fromStat: {
            key: axisStatKey
        },
        min: 1
    });
    (0, $b3d1594b84705f7d$export$ef6bd388c274421f)(baseAxis, axisStatKey, function(seriesModel) {
        seriesInfoOnAxis.push({
            barWidth: (0, $104896d282bd296f$export$e8514cb5a5e2b40f)(seriesModel.get('barWidth'), bandWidthResult.w),
            barMaxWidth: (0, $104896d282bd296f$export$e8514cb5a5e2b40f)(seriesModel.get('barMaxWidth'), bandWidthResult.w),
            barMinWidth: (0, $104896d282bd296f$export$e8514cb5a5e2b40f)(// barMinWidth by default is 0.5 / 1 in cartesian. Because in value axis,
            // the auto-calculated bar width might be less than 0.5 / 1.
            seriesModel.get('barMinWidth') || ($c6c6cd7fb79dc955$var$isInLargeMode(seriesModel) ? 0.5 : 1), bandWidthResult.w),
            barGap: seriesModel.get('barGap'),
            barCategoryGap: seriesModel.get('barCategoryGap'),
            defaultBarGap: seriesModel.get('defaultBarGap'),
            stackId: $c6c6cd7fb79dc955$var$getSeriesStackId(seriesModel)
        });
    });
    return {
        bandWidthResult: bandWidthResult,
        seriesInfo: seriesInfoOnAxis
    };
}
/**
 * CAUTION: When multiple series are laid out on one axis, relevant ec options effect all series.
 * But for historical reason, these options are configured on each series option, which may
 * introduce confliction. The legacy implementation uses some options (e.g., `defaultBarGap`)
 * from the first declared series, and other options (e.g., `barGap`, `barCategoryGap`) from the last declared
 * series. Nevertheless, We remain this design to avoid breaking change.
 */ function $c6c6cd7fb79dc955$var$calcBarWidthAndOffset(seriesInfoOnAxis) {
    var bandWidth = seriesInfoOnAxis.bandWidthResult.w;
    var remainedWidth = bandWidth;
    var autoWidthCount = 0;
    var barCategoryGapOption;
    var barGapOption;
    var stackIdList = [];
    var stackMap = {};
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(seriesInfoOnAxis.seriesInfo, function(seriesInfo, idx) {
        if (!idx) barGapOption = seriesInfo.defaultBarGap || 0;
        var stackId = seriesInfo.stackId;
        if (!(0, $f16f2994a32ad273$export$b5a638e9b3fff9f3)(stackMap, stackId)) autoWidthCount++;
        var stackItem = stackMap[stackId];
        if (!stackItem) {
            stackItem = stackMap[stackId] = {
                width: 0,
                maxWidth: 0
            };
            stackIdList.push(stackId);
        }
        var barWidth = seriesInfo.barWidth;
        if (barWidth && !stackItem.width) {
            // See #6312, do not restrict width.
            stackItem.width = barWidth;
            barWidth = (0, $104896d282bd296f$export$e411eeaf23dccbe8)(remainedWidth, barWidth);
            remainedWidth -= barWidth;
        }
        var barMaxWidth = seriesInfo.barMaxWidth;
        barMaxWidth && (stackItem.maxWidth = barMaxWidth);
        var barMinWidth = seriesInfo.barMinWidth;
        barMinWidth && (stackItem.minWidth = barMinWidth);
        var barGap = seriesInfo.barGap;
        barGap != null && (barGapOption = barGap);
        var barCategoryGap = seriesInfo.barCategoryGap;
        barCategoryGap != null && (barCategoryGapOption = barCategoryGap);
    });
    if (barCategoryGapOption == null) // More columns in one group
    // the spaces between group is smaller. Or the column will be too thin.
    barCategoryGapOption = (0, $104896d282bd296f$export$2ca8010d037f830f)(35 - stackIdList.length * 4, 15) + '%';
    var barCategoryGapNum = (0, $104896d282bd296f$export$e8514cb5a5e2b40f)(barCategoryGapOption, bandWidth);
    var barGapPercent = (0, $104896d282bd296f$export$e8514cb5a5e2b40f)(barGapOption, 1);
    var autoWidth = (remainedWidth - barCategoryGapNum) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = (0, $104896d282bd296f$export$2ca8010d037f830f)(autoWidth, 0);
    // Find if any auto calculated bar exceeded maxBarWidth
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(stackIdList, function(stackId) {
        var column = stackMap[stackId];
        var maxWidth = column.maxWidth;
        var minWidth = column.minWidth;
        if (!column.width) {
            var finalWidth = autoWidth;
            if (maxWidth && maxWidth < finalWidth) finalWidth = (0, $104896d282bd296f$export$e411eeaf23dccbe8)(maxWidth, remainedWidth);
            // `minWidth` has higher priority. `minWidth` decide that whether the
            // bar is able to be visible. So `minWidth` should not be restricted
            // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
            // the extreme cases for `value` axis, bars are allowed to overlap
            // with each other if `minWidth` specified.
            if (minWidth && minWidth > finalWidth) finalWidth = minWidth;
            if (finalWidth !== autoWidth) {
                column.width = finalWidth;
                remainedWidth -= finalWidth + barGapPercent * finalWidth;
                autoWidthCount--;
            }
        } else {
            // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
            // CSS does. Because barWidth can be a percent value, where
            // `barMaxWidth` can be used to restrict the final width.
            var finalWidth = column.width;
            if (maxWidth) finalWidth = (0, $104896d282bd296f$export$e411eeaf23dccbe8)(finalWidth, maxWidth);
            // `minWidth` has higher priority, as described above
            if (minWidth) finalWidth = (0, $104896d282bd296f$export$2ca8010d037f830f)(finalWidth, minWidth);
            column.width = finalWidth;
            remainedWidth -= finalWidth + barGapPercent * finalWidth;
            autoWidthCount--;
        }
    });
    // Recalculate width again
    autoWidth = (remainedWidth - barCategoryGapNum) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = (0, $104896d282bd296f$export$2ca8010d037f830f)(autoWidth, 0);
    var widthSum = 0;
    var lastColumn;
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(stackIdList, function(stackId) {
        var column = stackMap[stackId];
        if (!column.width) column.width = autoWidth;
        lastColumn = column;
        widthSum += column.width * (1 + barGapPercent);
    });
    if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
    var result = {};
    var offset = -widthSum / 2;
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(stackIdList, function(stackId) {
        var column = stackMap[stackId];
        result[stackId] = result[stackId] || {
            bandWidth: bandWidth,
            offset: offset,
            width: column.width
        };
        offset += column.width * (1 + barGapPercent);
    });
    return result;
}
function $c6c6cd7fb79dc955$export$13922fb2a9d75502(seriesType) {
    return {
        seriesType: seriesType,
        overallReset: function overallReset(ecModel) {
            var axisStatKey = (0, $7c545d8beb47d2c1$export$6e465398bf63b595)(seriesType, (0, $a52c3079a78f555c$export$d0b4e8fdb7a13c60));
            (0, $b3d1594b84705f7d$export$37f432351be0ca61)(ecModel, axisStatKey, function(axis) {
                var columnLayout = $c6c6cd7fb79dc955$var$makeColumnLayoutOnAxisReal(axis, seriesType);
                (0, $b3d1594b84705f7d$export$ef6bd388c274421f)(axis, axisStatKey, function(seriesModel) {
                    var columnLayoutInfo = columnLayout.columnMap[$c6c6cd7fb79dc955$var$getSeriesStackId(seriesModel)];
                    seriesModel.getData().setLayout({
                        bandWidth: columnLayoutInfo.bandWidth,
                        offset: columnLayoutInfo.offset,
                        size: columnLayoutInfo.width
                    });
                });
            });
        }
    };
}
function $c6c6cd7fb79dc955$export$16e8685758531cb6(seriesType) {
    return {
        seriesType: seriesType,
        plan: (0, $790e5363756df266$export$2e2bcd8739ae039)(),
        reset: function reset(seriesModel) {
            if (!(0, $d0095b1b8a21cc3f$export$e447722773749af)(seriesModel)) return;
            var data = seriesModel.getData();
            var cartesian = seriesModel.coordinateSystem;
            var baseAxis = cartesian.getBaseAxis();
            var valueAxis = cartesian.getOtherAxis(baseAxis);
            var valueDimIdx = data.getDimensionIndex(data.mapDimension(valueAxis.dim));
            var baseDimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
            var drawBackground = seriesModel.get('showBackground', true);
            var valueDim = data.mapDimension(valueAxis.dim);
            var stackResultDim = data.getCalculationInfo('stackResultDimension');
            var stacked = (0, $eb1b70ae9d7aaef4$export$1dedc39359ae35c)(data, valueDim) && !!data.getCalculationInfo('stackedOnSeries');
            var isValueAxisH = valueAxis.isHorizontal();
            var valueAxisStart = valueAxis.toGlobalCoord(valueAxis.dataToCoord((0, $1d243d9d64281796$export$e2d7eaa2ea5b61c4)(valueAxis)));
            var isLarge = $c6c6cd7fb79dc955$var$isInLargeMode(seriesModel);
            var barMinHeight = seriesModel.get('barMinHeight') || 0;
            var stackedDimIdx = stackResultDim && data.getDimensionIndex(stackResultDim);
            // Layout info.
            var columnWidth = data.getLayout('size');
            var columnOffset = data.getLayout('offset');
            return {
                progress: function progress(params, data) {
                    var count = params.count;
                    var largePoints = isLarge && (0, $ad7d9044a6be6c49$export$21d2298f3f56bbaf)(count * 3);
                    var largeBackgroundPoints = isLarge && drawBackground && (0, $ad7d9044a6be6c49$export$21d2298f3f56bbaf)(count * 3);
                    var largeDataIndices = isLarge && (0, $ad7d9044a6be6c49$export$21d2298f3f56bbaf)(count);
                    var coordLayout = cartesian.master.getRect();
                    var bgSize = isValueAxisH ? coordLayout.width : coordLayout.height;
                    var dataIndex;
                    var store = data.getStore();
                    var idxOffset = 0;
                    while((dataIndex = params.next()) != null){
                        var value = store.get(stacked ? stackedDimIdx : valueDimIdx, dataIndex);
                        var baseValue = store.get(baseDimIdx, dataIndex);
                        var baseCoord = valueAxisStart;
                        var stackStartValue = void 0;
                        // Because of the barMinHeight, we can not use the value in
                        // stackResultDimension directly.
                        if (stacked) stackStartValue = +value - store.get(valueDimIdx, dataIndex);
                        var x = void 0;
                        var y = void 0;
                        var width = void 0;
                        var height = void 0;
                        if (isValueAxisH) {
                            var coord = cartesian.dataToPoint([
                                value,
                                baseValue
                            ]);
                            if (stacked) baseCoord = cartesian.dataToPoint([
                                stackStartValue,
                                baseValue
                            ])[0];
                            x = baseCoord;
                            y = coord[1] + columnOffset;
                            width = coord[0] - baseCoord;
                            height = columnWidth;
                            if ((0, $104896d282bd296f$export$5860c226b237d9a6)(width) < barMinHeight) width = (width < 0 ? -1 : 1) * barMinHeight;
                        } else {
                            var coord = cartesian.dataToPoint([
                                baseValue,
                                value
                            ]);
                            if (stacked) baseCoord = cartesian.dataToPoint([
                                baseValue,
                                stackStartValue
                            ])[1];
                            x = coord[0] + columnOffset;
                            y = baseCoord;
                            width = columnWidth;
                            height = coord[1] - baseCoord;
                            if ((0, $104896d282bd296f$export$5860c226b237d9a6)(height) < barMinHeight) // Include zero to has a positive bar
                            height = (height <= 0 ? -1 : 1) * barMinHeight;
                        }
                        if (!isLarge) data.setItemLayout(dataIndex, {
                            x: x,
                            y: y,
                            width: width,
                            height: height
                        });
                        else {
                            largePoints[idxOffset] = x;
                            largePoints[idxOffset + 1] = y;
                            largePoints[idxOffset + 2] = isValueAxisH ? width : height;
                            if (largeBackgroundPoints) {
                                largeBackgroundPoints[idxOffset] = isValueAxisH ? coordLayout.x : x;
                                largeBackgroundPoints[idxOffset + 1] = isValueAxisH ? y : coordLayout.y;
                                largeBackgroundPoints[idxOffset + 2] = bgSize;
                            }
                            largeDataIndices[dataIndex] = dataIndex;
                        }
                        idxOffset += 3;
                    }
                    if (isLarge) data.setLayout({
                        largePoints: largePoints,
                        largeDataIndices: largeDataIndices,
                        largeBackgroundPoints: largeBackgroundPoints,
                        valueAxisHorizontal: isValueAxisH
                    });
                }
            };
        }
    };
}
function $c6c6cd7fb79dc955$var$isInLargeMode(seriesModel) {
    return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
}
function $c6c6cd7fb79dc955$var$barGridCreateAxisContainShapeHandler(seriesType) {
    // See also #6728, #4862, `test/bar-overflow-time-plot.html` `test/bar-overflow-plot2.html`
    // NOTE:
    //  Series shapes may overflow `bandWidth` when ec option is set like:
    //    - `barWidth` > 100%.
    //    - `barWidth` is set as absolute pixel values and `dataZoom` is used, since `bandWidth` is
    //      calculated on data space rather than pixel space.
    //  We originally used `calcShapeOverflowSupplement` to cover this case, but it still can not
    //  resolve pixel `barWidth` case perfectly. A thorough solution may introduce considerable complex,
    //  but may not necessary, since users can avoid it by proper ec option settings.
    //  Therefore, we use simply `createBandWidthBasedAxisContainShapeHandler` to calculate "containShape"
    //  only based on `bandWidth`.
    return (0, $7c545d8beb47d2c1$export$a8febf733c5b3d4e)((0, $7c545d8beb47d2c1$export$6e465398bf63b595)(seriesType, (0, $a52c3079a78f555c$export$d0b4e8fdb7a13c60)));
// return function (axis, scale, ecModel) {
//     if (!countSeriesOnAxisOnKey(axis, makeAxisStatKey2(seriesType, COORD_SYS_TYPE_CARTESIAN_2D))) {
//         return; // Quick path - in most cases there is no bar on non-ordinal axis.
//     }
//     const columnLayout = makeColumnLayoutOnAxisReal(axis, seriesType);
//     return calcShapeOverflowSupplement(columnLayout);
// };
}
function $c6c6cd7fb79dc955$export$f94e305d0960f41c(registers) {
    $c6c6cd7fb79dc955$var$callOnlyOnce(registers, function() {
        function register(seriesType) {
            var axisStatKey = (0, $7c545d8beb47d2c1$export$6e465398bf63b595)(seriesType, (0, $a52c3079a78f555c$export$d0b4e8fdb7a13c60));
            (0, $1d243d9d64281796$export$7374d3b28c4a7327)(registers, axisStatKey, seriesType, (0, $a52c3079a78f555c$export$d0b4e8fdb7a13c60));
            (0, $6b680e8b1e09fdd5$export$7b3647d53bcfcf4e)(axisStatKey, $c6c6cd7fb79dc955$var$barGridCreateAxisContainShapeHandler(seriesType));
        }
        register('bar');
        register('pictorialBar');
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $197506e926d2cf99$var$samplers = {
    average: function average(frame) {
        var sum = 0;
        var count = 0;
        for(var i = 0; i < frame.length; i++)if (!isNaN(frame[i])) {
            sum += frame[i];
            count++;
        }
        // Return NaN if count is 0
        return count === 0 ? NaN : sum / count;
    },
    sum: function sum(frame) {
        var sum = 0;
        for(var i = 0; i < frame.length; i++)// Ignore NaN
        sum += frame[i] || 0;
        return sum;
    },
    max: function max(frame) {
        var max = -Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] > max && (max = frame[i]);
        // NaN will cause illegal axis extent.
        return isFinite(max) ? max : NaN;
    },
    min: function min(frame) {
        var min = Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] < min && (min = frame[i]);
        // NaN will cause illegal axis extent.
        return isFinite(min) ? min : NaN;
    },
    // TODO
    // Median
    nearest: function nearest(frame) {
        return frame[0];
    }
};
var $197506e926d2cf99$var$indexSampler = function indexSampler(frame) {
    return Math.round(frame.length / 2);
};
function $197506e926d2cf99$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        // FIXME:TS never used, so comment it
        // modifyOutputEnd: true,
        reset: function reset(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            var sampling = seriesModel.get('sampling');
            var coordSys = seriesModel.coordinateSystem;
            var count = data.count();
            // Only cartesian2d support down sampling. Disable it when there is few data.
            if (count > 10 && coordSys.type === 'cartesian2d' && sampling) {
                var baseAxis = coordSys.getBaseAxis();
                var valueAxis = coordSys.getOtherAxis(baseAxis);
                var extent = baseAxis.getExtent();
                var dpr = api.getDevicePixelRatio();
                // Coordinste system has been resized
                var size = Math.abs(extent[1] - extent[0]) * (dpr || 1);
                var rate = Math.round(count / size);
                if (isFinite(rate) && rate > 1) {
                    if (sampling === 'lttb') seriesModel.setData(data.lttbDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    else if (sampling === 'minmax') seriesModel.setData(data.minmaxDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    var sampler = void 0;
                    if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(sampling)) sampler = $197506e926d2cf99$var$samplers[sampling];
                    else if ((0, $f16f2994a32ad273$export$f6e2535fb5126e54)(sampling)) sampler = sampling;
                    if (sampler) // Only support sample the first dim mapped from value axis.
                    seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, $197506e926d2cf99$var$indexSampler));
                }
            }
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Int32Array */ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $cbf1299a28660b2c$var$dataIndexMapValueLength(valNumOrArrLengthMoreThan2) {
    return valNumOrArrLengthMoreThan2 == null ? 0 : valNumOrArrLengthMoreThan2.length || 1;
}
function $cbf1299a28660b2c$var$defaultKeyGetter(item) {
    return item;
}
var $cbf1299a28660b2c$var$DataDiffer = /** @class */ function() {
    /**
   * @param context Can be visited by this.context in callback.
   */ function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context, // By default: 'oneToOne'.
    diffMode) {
        this._old = oldArr;
        this._new = newArr;
        this._oldKeyGetter = oldKeyGetter || $cbf1299a28660b2c$var$defaultKeyGetter;
        this._newKeyGetter = newKeyGetter || $cbf1299a28660b2c$var$defaultKeyGetter;
        // Visible in callback via `this.context`;
        this.context = context;
        this._diffModeMultiple = diffMode === 'multiple';
    }
    /**
   * Callback function when add a data
   */ DataDiffer.prototype.add = function(func) {
        this._add = func;
        return this;
    };
    /**
   * Callback function when update a data
   */ DataDiffer.prototype.update = function(func) {
        this._update = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToOne = function(func) {
        this._updateManyToOne = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateOneToMany = function(func) {
        this._updateOneToMany = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToMany = function(func) {
        this._updateManyToMany = func;
        return this;
    };
    /**
   * Callback function when remove a data
   */ DataDiffer.prototype.remove = function(func) {
        this._remove = func;
        return this;
    };
    DataDiffer.prototype.execute = function() {
        this[this._diffModeMultiple ? '_executeMultiple' : '_executeOneToOne']();
    };
    DataDiffer.prototype._executeOneToOne = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var newDataIndexMap = {};
        var oldDataKeyArr = new Array(oldArr.length);
        var newDataKeyArr = new Array(newArr.length);
        this._initIndexMap(oldArr, null, oldDataKeyArr, '_oldKeyGetter');
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
        for(var i = 0; i < oldArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var newIdxMapValLen = $cbf1299a28660b2c$var$dataIndexMapValueLength(newIdxMapVal);
            // idx can never be empty array here. see 'set null' logic below.
            if (newIdxMapValLen > 1) {
                // Consider there is duplicate key (for example, use dataItem.name as key).
                // We should make sure every item in newArr and oldArr can be visited.
                var newIdx = newIdxMapVal.shift();
                if (newIdxMapVal.length === 1) newDataIndexMap[oldKey] = newIdxMapVal[0];
                this._update && this._update(newIdx, i);
            } else if (newIdxMapValLen === 1) {
                newDataIndexMap[oldKey] = null;
                this._update && this._update(newIdxMapVal, i);
            } else this._remove && this._remove(i);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    /**
   * For example, consider the case:
   * oldData: [o0, o1, o2, o3, o4, o5, o6, o7],
   * newData: [n0, n1, n2, n3, n4, n5, n6, n7, n8],
   * Where:
   *     o0, o1, n0 has key 'a' (many to one)
   *     o5, n4, n5, n6 has key 'b' (one to many)
   *     o2, n1 has key 'c' (one to one)
   *     n2, n3 has key 'd' (add)
   *     o3, o4 has key 'e' (remove)
   *     o6, o7, n7, n8 has key 'f' (many to many, treated as add and remove)
   * Then:
   *     (The order of the following directives are not ensured.)
   *     this._updateManyToOne(n0, [o0, o1]);
   *     this._updateOneToMany([n4, n5, n6], o5);
   *     this._update(n1, o2);
   *     this._remove(o3);
   *     this._remove(o4);
   *     this._remove(o6);
   *     this._remove(o7);
   *     this._add(n2);
   *     this._add(n3);
   *     this._add(n7);
   *     this._add(n8);
   */ DataDiffer.prototype._executeMultiple = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var oldDataIndexMap = {};
        var newDataIndexMap = {};
        var oldDataKeyArr = [];
        var newDataKeyArr = [];
        this._initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter');
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
        for(var i = 0; i < oldDataKeyArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var oldIdxMapVal = oldDataIndexMap[oldKey];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var oldIdxMapValLen = $cbf1299a28660b2c$var$dataIndexMapValueLength(oldIdxMapVal);
            var newIdxMapValLen = $cbf1299a28660b2c$var$dataIndexMapValueLength(newIdxMapVal);
            if (oldIdxMapValLen > 1 && newIdxMapValLen === 1) {
                this._updateManyToOne && this._updateManyToOne(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen > 1) {
                this._updateOneToMany && this._updateOneToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen === 1) {
                this._update && this._update(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1 && newIdxMapValLen > 1) {
                this._updateManyToMany && this._updateManyToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1) for(var i_1 = 0; i_1 < oldIdxMapValLen; i_1++)this._remove && this._remove(oldIdxMapVal[i_1]);
            else this._remove && this._remove(oldIdxMapVal);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    DataDiffer.prototype._performRestAdd = function(newDataKeyArr, newDataIndexMap) {
        for(var i = 0; i < newDataKeyArr.length; i++){
            var newKey = newDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[newKey];
            var idxMapValLen = $cbf1299a28660b2c$var$dataIndexMapValueLength(newIdxMapVal);
            if (idxMapValLen > 1) for(var j = 0; j < idxMapValLen; j++)this._add && this._add(newIdxMapVal[j]);
            else if (idxMapValLen === 1) this._add && this._add(newIdxMapVal);
            // Support both `newDataKeyArr` are duplication removed or not removed.
            newDataIndexMap[newKey] = null;
        }
    };
    DataDiffer.prototype._initIndexMap = function(arr, // Can be null.
    map, // In 'byKey', the output `keyArr` is duplication removed.
    // In 'byIndex', the output `keyArr` is not duplication removed and
    //     its indices are accurately corresponding to `arr`.
    keyArr, keyGetterName) {
        var cbModeMultiple = this._diffModeMultiple;
        for(var i = 0; i < arr.length; i++){
            // Add prefix to avoid conflict with Object.prototype.
            var key = '_ec_' + this[keyGetterName](arr[i], i);
            if (!cbModeMultiple) keyArr[i] = key;
            if (!map) continue;
            var idxMapVal = map[key];
            var idxMapValLen = $cbf1299a28660b2c$var$dataIndexMapValueLength(idxMapVal);
            if (idxMapValLen === 0) {
                // Simple optimize: in most cases, one index has one key,
                // do not need array.
                map[key] = i;
                if (cbModeMultiple) keyArr.push(key);
            } else if (idxMapValLen === 1) map[key] = [
                idxMapVal,
                i
            ];
            else idxMapVal.push(i);
        }
    };
    return DataDiffer;
}();
var $cbf1299a28660b2c$export$2e2bcd8739ae039 = $cbf1299a28660b2c$var$DataDiffer;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $cb767aa9bf020b98$var$DimensionUserOuput = /** @class */ function() {
    function DimensionUserOuput(encode, dimRequest) {
        this._encode = encode;
        this._schema = dimRequest;
    }
    DimensionUserOuput.prototype.get = function() {
        return {
            // Do not generate full dimension name until fist used.
            fullDimensions: this._getFullDimensionNames(),
            encode: this._encode
        };
    };
    /**
   * Get all data store dimension names.
   * Theoretically a series data store is defined both by series and used dataset (if any).
   * If some dimensions are omitted for performance reason in `this.dimensions`,
   * the dimension name may not be auto-generated if user does not specify a dimension name.
   * In this case, the dimension name is `null`/`undefined`.
   */ DimensionUserOuput.prototype._getFullDimensionNames = function() {
        if (!this._cachedDimNames) this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : [];
        return this._cachedDimNames;
    };
    return DimensionUserOuput;
}();
function $cb767aa9bf020b98$export$505a22c3734846f1(data, schema) {
    var summary = {};
    var encode = summary.encode = {};
    var notExtraCoordDimMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
    var defaultedLabel = [];
    var defaultedTooltip = [];
    var userOutputEncode = {};
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(data.dimensions, function(dimName) {
        var dimItem = data.getDimensionInfo(dimName);
        var coordDim = dimItem.coordDim;
        if (coordDim) {
            var coordDimIndex = dimItem.coordDimIndex;
            $cb767aa9bf020b98$var$getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
            if (!dimItem.isExtraCoord) {
                notExtraCoordDimMap.set(coordDim, 1);
                // Use the last coord dim (and label friendly) as default label,
                // because when dataset is used, it is hard to guess which dimension
                // can be value dimension. If both show x, y on label is not look good,
                // and conventionally y axis is focused more.
                if ($cb767aa9bf020b98$var$mayLabelDimType(dimItem.type)) defaultedLabel[0] = dimName;
                // User output encode do not contain generated coords.
                // And it only has index. User can use index to retrieve value from the raw item array.
                $cb767aa9bf020b98$var$getOrCreateEncodeArr(userOutputEncode, coordDim)[coordDimIndex] = data.getDimensionIndex(dimItem.name);
            }
            if (dimItem.defaultTooltip) defaultedTooltip.push(dimName);
        }
        (0, $c870d17359cdf008$export$cd51b5ca77f6f0e4).each(function(v, otherDim) {
            var encodeArr = $cb767aa9bf020b98$var$getOrCreateEncodeArr(encode, otherDim);
            var dimIndex = dimItem.otherDims[otherDim];
            if (dimIndex != null && dimIndex !== false) encodeArr[dimIndex] = dimItem.name;
        });
    });
    var dataDimsOnCoord = [];
    var encodeFirstDimNotExtra = {};
    notExtraCoordDimMap.each(function(v, coordDim) {
        var dimArr = encode[coordDim];
        encodeFirstDimNotExtra[coordDim] = dimArr[0];
        // Not necessary to remove duplicate, because a data
        // dim canot on more than one coordDim.
        dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
    });
    summary.dataDimsOnCoord = dataDimsOnCoord;
    summary.dataDimIndicesOnCoord = (0, $f16f2994a32ad273$export$871de8747c9eaa88)(dataDimsOnCoord, function(dimName) {
        return data.getDimensionInfo(dimName).storeDimIndex;
    });
    summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
    var encodeLabel = encode.label;
    // FIXME `encode.label` is not recommended, because formatter cannot be set
    // in this way. Use label.formatter instead. Maybe remove this approach someday.
    if (encodeLabel && encodeLabel.length) defaultedLabel = encodeLabel.slice();
    var encodeTooltip = encode.tooltip;
    if (encodeTooltip && encodeTooltip.length) defaultedTooltip = encodeTooltip.slice();
    else if (!defaultedTooltip.length) defaultedTooltip = defaultedLabel.slice();
    encode.defaultedLabel = defaultedLabel;
    encode.defaultedTooltip = defaultedTooltip;
    summary.userOutput = new $cb767aa9bf020b98$var$DimensionUserOuput(userOutputEncode, schema);
    return summary;
}
function $cb767aa9bf020b98$var$getOrCreateEncodeArr(encode, dim) {
    if (!encode.hasOwnProperty(dim)) encode[dim] = [];
    return encode[dim];
}
function $cb767aa9bf020b98$export$af1622903e71278e(axisType) {
    return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
}
function $cb767aa9bf020b98$var$mayLabelDimType(dimType) {
    // In most cases, ordinal and time do not suitable for label.
    // Ordinal info can be displayed on axis. Time is too long.
    return !(dimType === 'ordinal' || dimType === 'time');
} // function findTheLastDimMayLabel(data) {
 //     // Get last value dim
 //     let dimensions = data.dimensions.slice();
 //     let valueType;
 //     let valueDim;
 //     while (dimensions.length && (
 //         valueDim = dimensions.pop(),
 //         valueType = data.getDimensionInfo(valueDim).type,
 //         valueType === 'ordinal' || valueType === 'time'
 //     )) {} // jshint ignore:line
 //     return valueDim;
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $41c6664c7c2abbca$var$SeriesDimensionDefine = /** @class */ function() {
    /**
   * @param opt All of the fields will be shallow copied.
   */ function SeriesDimensionDefine(opt) {
        /**
     * The term "other" means "other than coord".
     * The format of `otherDims` is:
     * ```js
     * {
     *     tooltip?: number
     *     label?: number
     *     itemName?: number
     *     seriesName?: number
     * }
     * ```
     *
     * A `series.encode` can specified these fields:
     * ```js
     * encode: {
     *     // "3, 1, 5" is the index of data dimension.
     *     tooltip: [3, 1, 5],
     *     label: [0, 3],
     *     ...
     * }
     * ```
     * `otherDims` is the parse result of the `series.encode` above, like:
     * ```js
     * // Suppose the index of this data dimension is `3`.
     * this.otherDims = {
     *     // `3` is at the index `0` of the `encode.tooltip`
     *     tooltip: 0,
     *     // `3` is at the index `1` of the `encode.label`
     *     label: 1
     * };
     * ```
     *
     * This prop should never be `null`/`undefined` after initialized.
     */ this.otherDims = {};
        if (opt != null) $f16f2994a32ad273$export$8b58be045bf06082(this, opt);
    }
    return SeriesDimensionDefine;
}();
var $41c6664c7c2abbca$export$2e2bcd8739ae039 = $41c6664c7c2abbca$var$SeriesDimensionDefine;








var $5e1317c5ed21cc39$var$isObject = $f16f2994a32ad273$export$a6cdc56e425d0d0a;
var $5e1317c5ed21cc39$var$map = $f16f2994a32ad273$export$871de8747c9eaa88;
var $5e1317c5ed21cc39$var$CtorInt32Array = typeof Int32Array === 'undefined' ? Array : Int32Array;
// Use prefix to avoid index to be the same as otherIdList[idx],
// which will cause weird update animation.
var $5e1317c5ed21cc39$var$ID_PREFIX = 'e\0\0';
var $5e1317c5ed21cc39$var$INDEX_NOT_FOUND = -1;
// type SeriesDimensionIndex = DimensionIndex;
var $5e1317c5ed21cc39$var$TRANSFERABLE_PROPERTIES = [
    'hasItemOption',
    '_nameList',
    '_idList',
    '_invertedIndicesMap',
    '_dimSummary',
    'userOutput',
    '_rawData',
    '_dimValueGetter',
    '_nameDimIdx',
    '_idDimIdx',
    '_nameRepeatCount'
];
var $5e1317c5ed21cc39$var$CLONE_PROPERTIES = [
    '_approximateExtent'
];
// -----------------------------
// Internal method declarations:
// -----------------------------
var $5e1317c5ed21cc39$var$prepareInvertedIndex;
var $5e1317c5ed21cc39$var$getId;
var $5e1317c5ed21cc39$var$getIdNameFromStore;
var $5e1317c5ed21cc39$var$normalizeDimensions;
var $5e1317c5ed21cc39$var$transferProperties;
var $5e1317c5ed21cc39$var$cloneListForMapAndSample;
var $5e1317c5ed21cc39$var$makeIdFromName;
var $5e1317c5ed21cc39$var$SeriesData = /** @class */ function() {
    /**
   * @param dimensionsInput.dimensions
   *        For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
   *        Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
   */ function SeriesData(dimensionsInput, hostModel) {
        this.type = 'list';
        this._dimOmitted = false;
        this._nameList = [];
        this._idList = [];
        // Models of data option is stored sparse for optimizing memory cost
        // Never used yet (not used yet).
        // private _optionModels: Model[] = [];
        // Global visual properties after visual coding
        this._visual = {};
        // Global layout properties.
        this._layout = {};
        // Item visual properties after visual coding
        this._itemVisuals = [];
        // Item layout properties after layout
        this._itemLayouts = [];
        // Graphic elements
        this._graphicEls = [];
        // key: dim, value: extent
        this._approximateExtent = {};
        this._calculationInfo = {};
        // Having detected that there is data item is non primitive type
        // (in type `OptionDataItemObject`).
        // Like `data: [ { value: xx, itemStyle: {...} }, ...]`
        // At present it only happen in `SOURCE_FORMAT_ORIGINAL`.
        this.hasItemOption = false;
        // Methods that create a new list based on this list should be listed here.
        // Notice that those method should `RETURN` the new list.
        this.TRANSFERABLE_METHODS = [
            'cloneShallow',
            'downSample',
            'minmaxDownSample',
            'lttbDownSample',
            'map'
        ];
        // Methods that change indices of this list should be listed here.
        this.CHANGABLE_METHODS = [
            'filterSelf',
            'selectRange'
        ];
        this.DOWNSAMPLE_METHODS = [
            'downSample',
            'minmaxDownSample',
            'lttbDownSample'
        ];
        var dimensions;
        var assignStoreDimIdx = false;
        if ((0, $af0b4b5988d2bf1e$export$fafbc856132a3a0e)(dimensionsInput)) {
            dimensions = dimensionsInput.dimensions;
            this._dimOmitted = dimensionsInput.isDimensionOmitted();
            this._schema = dimensionsInput;
        } else {
            assignStoreDimIdx = true;
            dimensions = dimensionsInput;
        }
        dimensions = dimensions || [
            'x',
            'y'
        ];
        var dimensionInfos = {};
        var dimensionNames = [];
        var invertedIndicesMap = {};
        var needsHasOwn = false;
        var emptyObj = {};
        for(var i = 0; i < dimensions.length; i++){
            // Use the original dimensions[i], where other flag props may exists.
            var dimInfoInput = dimensions[i];
            var dimensionInfo = $f16f2994a32ad273$export$844ec244b1367d54(dimInfoInput) ? new (0, $41c6664c7c2abbca$export$2e2bcd8739ae039)({
                name: dimInfoInput
            }) : !(dimInfoInput instanceof (0, $41c6664c7c2abbca$export$2e2bcd8739ae039)) ? new (0, $41c6664c7c2abbca$export$2e2bcd8739ae039)(dimInfoInput) : dimInfoInput;
            var dimensionName = dimensionInfo.name;
            dimensionInfo.type = dimensionInfo.type || 'float';
            if (!dimensionInfo.coordDim) {
                dimensionInfo.coordDim = dimensionName;
                dimensionInfo.coordDimIndex = 0;
            }
            var otherDims = dimensionInfo.otherDims = dimensionInfo.otherDims || {};
            dimensionNames.push(dimensionName);
            dimensionInfos[dimensionName] = dimensionInfo;
            if (emptyObj[dimensionName] != null) needsHasOwn = true;
            if (dimensionInfo.createInvertedIndices) invertedIndicesMap[dimensionName] = [];
            if (assignStoreDimIdx) dimensionInfo.storeDimIndex = i;
            if (otherDims.itemName === 0) this._nameDimIdx = dimensionInfo.storeDimIndex;
            if (otherDims.itemId === 0) this._idDimIdx = dimensionInfo.storeDimIndex;
        }
        this.dimensions = dimensionNames;
        this._dimInfos = dimensionInfos;
        this._initGetDimensionInfo(needsHasOwn);
        this.hostModel = hostModel;
        this._invertedIndicesMap = invertedIndicesMap;
        if (this._dimOmitted) {
            var dimIdxToName_1 = this._dimIdxToName = $f16f2994a32ad273$export$55f8aa7ef875b0a4();
            $f16f2994a32ad273$export$79b2f7037acddd43(dimensionNames, function(dimName) {
                dimIdxToName_1.set(dimensionInfos[dimName].storeDimIndex, dimName);
            });
        }
    }
    /**
   *
   * Get concrete dimension name by dimension name or dimension index.
   * If input a dimension name, do not validate whether the dimension name exits.
   *
   * @caution
   * @param dim Must make sure the dimension is `SeriesDimensionLoose`.
   * Because only those dimensions will have auto-generated dimension names if not
   * have a user-specified name, and other dimensions will get a return of null/undefined.
   *
   * @notice Because of this reason, should better use `getDimensionIndex` instead, for examples:
   * ```js
   * const val = data.getStore().get(data.getDimensionIndex(dim), dataIdx);
   * ```
   *
   * @return Concrete dim name.
   */ SeriesData.prototype.getDimension = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx == null) return dim;
        dimIdx = dim;
        if (!this._dimOmitted) return this.dimensions[dimIdx];
        // Retrieve from series dimension definition because it probably contains
        // generated dimension name (like 'x', 'y').
        var dimName = this._dimIdxToName.get(dimIdx);
        if (dimName != null) return dimName;
        var sourceDimDef = this._schema.getSourceDimension(dimIdx);
        if (sourceDimDef) return sourceDimDef.name;
    };
    /**
   * Get dimension index in data store. Return -1 if not found.
   * Can be used to index value from getRawValue.
   */ SeriesData.prototype.getDimensionIndex = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx != null) return dimIdx;
        if (dim == null) return -1;
        var dimInfo = this._getDimInfo(dim);
        return dimInfo ? dimInfo.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(dim) : -1;
    };
    /**
   * The meanings of the input parameter `dim`:
   *
   * + If dim is a number (e.g., `1`), it means the index of the dimension.
   *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
   * + If dim is a number-like string (e.g., `"1"`):
   *     + If there is the same concrete dim name defined in `series.dimensions` or `dataset.dimensions`,
   *        it means that concrete name.
   *     + If not, it will be converted to a number, which means the index of the dimension.
   *        (why? because of the backward compatibility. We have been tolerating number-like string in
   *        dimension setting, although now it seems that it is not a good idea.)
   *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
   *     if no dimension name is defined as `"1"`.
   * + If dim is a not-number-like string, it means the concrete dim name.
   *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
   *   or customized in `dimensions` property of option like `"age"`.
   *
   * @return recognized `DimensionIndex`. Otherwise return null/undefined (means that dim is `DimensionName`).
   */ SeriesData.prototype._recognizeDimIndex = function(dim) {
        if ($f16f2994a32ad273$export$7e4aa119212bc614(dim) || dim != null && !isNaN(dim) && !this._getDimInfo(dim) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(dim) < 0)) return +dim;
    };
    SeriesData.prototype._getStoreDimIndex = function(dim) {
        var dimIdx = this.getDimensionIndex(dim);
        return dimIdx;
    };
    /**
   * Get type and calculation info of particular dimension
   * @param dim
   *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
   *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
   */ SeriesData.prototype.getDimensionInfo = function(dim) {
        // Do not clone, because there may be categories in dimInfo.
        return this._getDimInfo(this.getDimension(dim));
    };
    SeriesData.prototype._initGetDimensionInfo = function(needsHasOwn) {
        var dimensionInfos = this._dimInfos;
        this._getDimInfo = needsHasOwn ? function(dimName) {
            return dimensionInfos.hasOwnProperty(dimName) ? dimensionInfos[dimName] : undefined;
        } : function(dimName) {
            return dimensionInfos[dimName];
        };
    };
    /**
   * concrete dimension name list on coord.
   */ SeriesData.prototype.getDimensionsOnCoord = function() {
        return this._dimSummary.dataDimsOnCoord.slice();
    };
    SeriesData.prototype.mapDimension = function(coordDim, idx) {
        var dimensionsSummary = this._dimSummary;
        if (idx == null) return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
        var dims = dimensionsSummary.encode[coordDim];
        return dims ? dims[idx] : null;
    };
    SeriesData.prototype.mapDimensionsAll = function(coordDim) {
        var dimensionsSummary = this._dimSummary;
        var dims = dimensionsSummary.encode[coordDim];
        return (dims || []).slice();
    };
    SeriesData.prototype.getStore = function() {
        return this._store;
    };
    /**
   * Initialize from data
   * @param data source or data or data store.
   * @param nameList The name of a datum is used on data diff and
   *        default label/tooltip.
   *        A name can be specified in encode.itemName,
   *        or dataItem.name (only for series option data),
   *        or provided in nameList from outside.
   */ SeriesData.prototype.initData = function(data, nameList, dimValueGetter) {
        var _this = this;
        var store;
        if (data instanceof (0, $e2e44dba229a928c$export$2e2bcd8739ae039)) store = data;
        if (!store) {
            var dimensions = this.dimensions;
            var provider = (0, $9cad8a8849680580$export$22b808bc02a60488)(data) || $f16f2994a32ad273$export$1e2f57719e155213(data) ? new (0, $64e5bb47dc44a160$export$b900d7c4c3952a40)(data, dimensions.length) : data;
            store = new (0, $e2e44dba229a928c$export$2e2bcd8739ae039)();
            var dimensionInfos = $5e1317c5ed21cc39$var$map(dimensions, function(dimName) {
                return {
                    type: _this._dimInfos[dimName].type,
                    property: dimName
                };
            });
            store.initData(provider, dimensionInfos, dimValueGetter);
        }
        this._store = store;
        // Reset
        this._nameList = (nameList || []).slice();
        this._idList = [];
        this._nameRepeatCount = {};
        this._doInit(0, store.count());
        // Cache summary info for fast visit. See "dimensionHelper".
        // Needs to be initialized after store is prepared.
        this._dimSummary = (0, $cb767aa9bf020b98$export$505a22c3734846f1)(this, this._schema);
        this.userOutput = this._dimSummary.userOutput;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ SeriesData.prototype.appendData = function(data) {
        var range = this._store.appendData(data);
        this._doInit(range[0], range[1]);
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   * This method does not modify `rawData` (`dataProvider`), but only
   * add values to store.
   *
   * The final count will be increased by `Math.max(values.length, names.length)`.
   *
   * @param values That is the SourceType: 'arrayRows', like
   *        [
   *            [12, 33, 44],
   *            [NaN, 43, 1],
   *            ['-', 'asdf', 0]
   *        ]
   *        Each item is exactly corresponding to a dimension.
   */ SeriesData.prototype.appendValues = function(values, names) {
        var _a = this._store.appendValues(values, names && names.length), start = _a.start, end = _a.end;
        var shouldMakeIdFromName = this._shouldMakeIdFromName();
        this._updateOrdinalMeta();
        if (names) for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            this._nameList[idx] = names[sourceIdx];
            if (shouldMakeIdFromName) $5e1317c5ed21cc39$var$makeIdFromName(this, idx);
        }
    };
    SeriesData.prototype._updateOrdinalMeta = function() {
        var store = this._store;
        var dimensions = this.dimensions;
        for(var i = 0; i < dimensions.length; i++){
            var dimInfo = this._dimInfos[dimensions[i]];
            if (dimInfo.ordinalMeta) store.collectOrdinalMeta(dimInfo.storeDimIndex, dimInfo.ordinalMeta);
        }
    };
    SeriesData.prototype._shouldMakeIdFromName = function() {
        var provider = this._store.getProvider();
        return this._idDimIdx == null && provider.getSource().sourceFormat !== (0, $c870d17359cdf008$export$a918cb016a382d45) && !provider.fillStorage;
    };
    SeriesData.prototype._doInit = function(start, end) {
        if (start >= end) return;
        var store = this._store;
        var provider = store.getProvider();
        this._updateOrdinalMeta();
        var nameList = this._nameList;
        var idList = this._idList;
        var sourceFormat = provider.getSource().sourceFormat;
        var isFormatOriginal = sourceFormat === (0, $c870d17359cdf008$export$2823037fb9d8f0c6);
        // Each data item is value
        // [1, 2]
        // 2
        // Bar chart, line chart which uses category axis
        // only gives the 'y' value. 'x' value is the indices of category
        // Use a tempValue to normalize the value to be a (x, y) value
        // If dataItem is {name: ...} or {id: ...}, it has highest priority.
        // This kind of ids and names are always stored `_nameList` and `_idList`.
        if (isFormatOriginal && !provider.pure) {
            var sharedDataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                var dataItem = provider.getItem(idx, sharedDataItem);
                if (!this.hasItemOption && (0, $3fa81475350067fd$export$3e1a543f33ef6883)(dataItem)) this.hasItemOption = true;
                if (dataItem) {
                    var itemName = dataItem.name;
                    if (nameList[idx] == null && itemName != null) nameList[idx] = (0, $3fa81475350067fd$export$fb1a222ba5dd6e51)(itemName, null);
                    var itemId = dataItem.id;
                    if (idList[idx] == null && itemId != null) idList[idx] = (0, $3fa81475350067fd$export$fb1a222ba5dd6e51)(itemId, null);
                }
            }
        }
        if (this._shouldMakeIdFromName()) for(var idx = start; idx < end; idx++)$5e1317c5ed21cc39$var$makeIdFromName(this, idx);
        $5e1317c5ed21cc39$var$prepareInvertedIndex(this);
    };
    /**
   * Optimize for the scenario that data is filtered by a given extent.
   * Consider that if data amount is more than hundreds of thousand,
   * extent calculation will cost more than 10ms and the cache will
   * be erased because of the filtering.
   */ SeriesData.prototype.getApproximateExtent = function(dim, filter) {
        return this._approximateExtent[dim] || this._store.getDataExtent(this._getStoreDimIndex(dim), filter);
    };
    /**
   * NOTICE: `_approximateExtent` does not support filter. Callers must ensure the input extent
   * to be handled by `scale.sanitizeExtent`.
   *
   * Calculate extent on a filtered data might be time consuming.
   * Approximate extent is only used for: calculate extent of filtered data outside.
   */ SeriesData.prototype.setApproximateExtent = function(extent, dim) {
        dim = this.getDimension(dim);
        this._approximateExtent[dim] = extent.slice();
    };
    SeriesData.prototype.getCalculationInfo = function(key) {
        return this._calculationInfo[key];
    };
    SeriesData.prototype.setCalculationInfo = function(key, value) {
        $5e1317c5ed21cc39$var$isObject(key) ? $f16f2994a32ad273$export$8b58be045bf06082(this._calculationInfo, key) : this._calculationInfo[key] = value;
    };
    /**
   * @return Never be null/undefined. `number` will be converted to string. Because:
   * In most cases, name is used in display, where returning a string is more convenient.
   * In other cases, name is used in query (see `indexOfName`), where we can keep the
   * rule that name `2` equals to name `'2'`.
   */ SeriesData.prototype.getName = function(idx) {
        var rawIndex = this.getRawIndex(idx);
        var name = this._nameList[rawIndex];
        if (name == null && this._nameDimIdx != null) name = $5e1317c5ed21cc39$var$getIdNameFromStore(this, this._nameDimIdx, rawIndex);
        if (name == null) name = '';
        return name;
    };
    SeriesData.prototype._getCategory = function(dimIdx, idx) {
        var ordinal = this._store.get(dimIdx, idx);
        var ordinalMeta = this._store.getOrdinalMeta(dimIdx);
        if (ordinalMeta) return ordinalMeta.categories[ordinal];
        return ordinal;
    };
    /**
   * @return Never null/undefined. `number` will be converted to string. Because:
   * In all cases having encountered at present, id is used in making diff comparison, which
   * are usually based on hash map. We can keep the rule that the internal id are always string
   * (treat `2` is the same as `'2'`) to make the related logic simple.
   */ SeriesData.prototype.getId = function(idx) {
        return $5e1317c5ed21cc39$var$getId(this, this.getRawIndex(idx));
    };
    SeriesData.prototype.count = function() {
        return this._store.count();
    };
    /**
   * Get value. Return NaN if idx is out of range.
   *
   * @notice Should better to use `data.getStore().get(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.get = function(dim, idx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.get(dimInfo.storeDimIndex, idx);
    };
    /**
   * @notice Should better to use `data.getStore().getByRawIndex(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.getByRawIndex = function(dim, rawIdx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.getByRawIndex(dimInfo.storeDimIndex, rawIdx);
    };
    SeriesData.prototype.getIndices = function() {
        return this._store.getIndices();
    };
    SeriesData.prototype.getDataExtent = function(dim) {
        return this._store.getDataExtent(this._getStoreDimIndex(dim), null);
    };
    SeriesData.prototype.getSum = function(dim) {
        return this._store.getSum(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getMedian = function(dim) {
        return this._store.getMedian(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getValues = function(dimensions, idx) {
        var _this = this;
        var store = this._store;
        return $f16f2994a32ad273$export$43bee75e5e14138e(dimensions) ? store.getValues($5e1317c5ed21cc39$var$map(dimensions, function(dim) {
            return _this._getStoreDimIndex(dim);
        }), idx) : store.getValues(dimensions);
    };
    /**
   * If value is NaN. Including '-'
   * Only check the coord dimensions.
   */ SeriesData.prototype.hasValue = function(idx) {
        var dataDimIndicesOnCoord = this._dimSummary.dataDimIndicesOnCoord;
        for(var i = 0, len = dataDimIndicesOnCoord.length; i < len; i++){
            // Ordinal type originally can be string or number.
            // But when an ordinal type is used on coord, it can
            // not be string but only number. So we can also use isNaN.
            if (isNaN(this._store.get(dataDimIndicesOnCoord[i], idx))) return false;
        }
        return true;
    };
    /**
   * Retrieve the index with given name
   */ SeriesData.prototype.indexOfName = function(name) {
        for(var i = 0, len = this._store.count(); i < len; i++){
            if (this.getName(i) === name) return i;
        }
        return -1;
    };
    SeriesData.prototype.getRawIndex = function(idx) {
        return this._store.getRawIndex(idx);
    };
    SeriesData.prototype.indexOfRawIndex = function(rawIndex) {
        return this._store.indexOfRawIndex(rawIndex);
    };
    /**
   * Only support the dimension which inverted index created.
   * Do not support other cases until required.
   * @param dim concrete dim
   * @param value ordinal index
   * @return rawIndex
   */ SeriesData.prototype.rawIndexOf = function(dim, value) {
        var invertedIndices = dim && this._invertedIndicesMap[dim];
        var rawIndex = invertedIndices && invertedIndices[value];
        if (rawIndex == null || isNaN(rawIndex)) return $5e1317c5ed21cc39$var$INDEX_NOT_FOUND;
        return rawIndex;
    };
    SeriesData.prototype.each = function(dims, cb, ctx) {
        'use strict';
        if ($f16f2994a32ad273$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $5e1317c5ed21cc39$var$map($5e1317c5ed21cc39$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store.each(dimIndices, fCtx ? $f16f2994a32ad273$export$2385a24977818dd0(cb, fCtx) : cb);
    };
    SeriesData.prototype.filterSelf = function(dims, cb, ctx) {
        'use strict';
        if ($f16f2994a32ad273$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $5e1317c5ed21cc39$var$map($5e1317c5ed21cc39$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store = this._store.filter(dimIndices, fCtx ? $f16f2994a32ad273$export$2385a24977818dd0(cb, fCtx) : cb);
        return this;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ SeriesData.prototype.selectRange = function(range) {
        'use strict';
        var _this = this;
        var innerRange = {};
        var dims = $f16f2994a32ad273$export$ed97f33186d4b816(range);
        var dimIndices = [];
        $f16f2994a32ad273$export$79b2f7037acddd43(dims, function(dim) {
            var dimIdx = _this._getStoreDimIndex(dim);
            innerRange[dimIdx] = range[dim];
            dimIndices.push(dimIdx);
        });
        this._store = this._store.selectRange(innerRange);
        return this;
    };
    /* eslint-enable max-len */ SeriesData.prototype.mapArray = function(dims, cb, ctx) {
        'use strict';
        if ($f16f2994a32ad273$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        ctx = ctx || this;
        var result = [];
        this.each(dims, function() {
            result.push(cb && cb.apply(this, arguments));
        }, ctx);
        return result;
    };
    SeriesData.prototype.map = function(dims, cb, ctx, ctxCompat) {
        'use strict';
        // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $5e1317c5ed21cc39$var$map($5e1317c5ed21cc39$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        var list = $5e1317c5ed21cc39$var$cloneListForMapAndSample(this);
        list._store = this._store.map(dimIndices, fCtx ? $f16f2994a32ad273$export$2385a24977818dd0(cb, fCtx) : cb);
        return list;
    };
    SeriesData.prototype.modify = function(dims, cb, ctx, ctxCompat) {
        var _this = this;
        // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $5e1317c5ed21cc39$var$map($5e1317c5ed21cc39$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        // If do shallow clone here, if there are too many stacked series,
        // it still cost lots of memory, because `_store.dimensions` are not shared.
        // We should consider there probably be shallow clone happen in each series
        // in consequent filter/map.
        this._store.modify(dimIndices, fCtx ? $f16f2994a32ad273$export$2385a24977818dd0(cb, fCtx) : cb);
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ SeriesData.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var list = $5e1317c5ed21cc39$var$cloneListForMapAndSample(this);
        list._store = this._store.downSample(this._getStoreDimIndex(dimension), rate, sampleValue, sampleIndex);
        return list;
    };
    /**
   * Large data down sampling using min-max
   * @param {string} valueDimension
   * @param {number} rate
   */ SeriesData.prototype.minmaxDownSample = function(valueDimension, rate) {
        var list = $5e1317c5ed21cc39$var$cloneListForMapAndSample(this);
        list._store = this._store.minmaxDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ SeriesData.prototype.lttbDownSample = function(valueDimension, rate) {
        var list = $5e1317c5ed21cc39$var$cloneListForMapAndSample(this);
        list._store = this._store.lttbDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    SeriesData.prototype.getRawDataItem = function(idx) {
        return this._store.getRawDataItem(idx);
    };
    /**
   * Get model of one data item.
   */ // TODO: Type of data item
    SeriesData.prototype.getItemModel = function(idx) {
        var hostModel = this.hostModel;
        var dataItem = this.getRawDataItem(idx);
        return new (0, $37821cf56da37613$export$2e2bcd8739ae039)(dataItem, hostModel, hostModel && hostModel.ecModel);
    };
    /**
   * Create a data differ
   */ SeriesData.prototype.diff = function(otherList) {
        var thisList = this;
        return new (0, $cbf1299a28660b2c$export$2e2bcd8739ae039)(otherList ? otherList.getStore().getIndices() : [], this.getStore().getIndices(), function(idx) {
            return $5e1317c5ed21cc39$var$getId(otherList, idx);
        }, function(idx) {
            return $5e1317c5ed21cc39$var$getId(thisList, idx);
        });
    };
    /**
   * Get visual property.
   */ SeriesData.prototype.getVisual = function(key) {
        var visual = this._visual;
        return visual && visual[key];
    };
    SeriesData.prototype.setVisual = function(kvObj, val) {
        this._visual = this._visual || {};
        if ($5e1317c5ed21cc39$var$isObject(kvObj)) $f16f2994a32ad273$export$8b58be045bf06082(this._visual, kvObj);
        else this._visual[kvObj] = val;
    };
    /**
   * Get visual property of single data item
   */ // eslint-disable-next-line
    SeriesData.prototype.getItemVisual = function(idx, key) {
        var itemVisual = this._itemVisuals[idx];
        var val = itemVisual && itemVisual[key];
        if (val == null) // Use global visual property
        return this.getVisual(key);
        return val;
    };
    /**
   * If exists visual property of single data item
   */ SeriesData.prototype.hasItemVisual = function() {
        return this._itemVisuals.length > 0;
    };
    /**
   * Make sure itemVisual property is unique
   */ // TODO: use key to save visual to reduce memory.
    SeriesData.prototype.ensureUniqueItemVisual = function(idx, key) {
        var itemVisuals = this._itemVisuals;
        var itemVisual = itemVisuals[idx];
        if (!itemVisual) itemVisual = itemVisuals[idx] = {};
        var val = itemVisual[key];
        if (val == null) {
            val = this.getVisual(key);
            // TODO Performance?
            if ($f16f2994a32ad273$export$43bee75e5e14138e(val)) val = val.slice();
            else if ($5e1317c5ed21cc39$var$isObject(val)) val = $f16f2994a32ad273$export$8b58be045bf06082({}, val);
            itemVisual[key] = val;
        }
        return val;
    };
    // eslint-disable-next-line
    SeriesData.prototype.setItemVisual = function(idx, key, value) {
        var itemVisual = this._itemVisuals[idx] || {};
        this._itemVisuals[idx] = itemVisual;
        if ($5e1317c5ed21cc39$var$isObject(key)) $f16f2994a32ad273$export$8b58be045bf06082(itemVisual, key);
        else itemVisual[key] = value;
    };
    /**
   * Clear itemVisuals and list visual.
   */ SeriesData.prototype.clearAllVisual = function() {
        this._visual = {};
        this._itemVisuals = [];
    };
    SeriesData.prototype.setLayout = function(key, val) {
        $5e1317c5ed21cc39$var$isObject(key) ? $f16f2994a32ad273$export$8b58be045bf06082(this._layout, key) : this._layout[key] = val;
    };
    /**
   * Get layout property.
   */ SeriesData.prototype.getLayout = function(key) {
        return this._layout[key];
    };
    /**
   * Get layout of single data item
   */ SeriesData.prototype.getItemLayout = function(idx) {
        return this._itemLayouts[idx];
    };
    /**
   * Set layout of single data item
   */ SeriesData.prototype.setItemLayout = function(idx, layout, merge) {
        this._itemLayouts[idx] = merge ? $f16f2994a32ad273$export$8b58be045bf06082(this._itemLayouts[idx] || {}, layout) : layout;
    };
    /**
   * Clear all layout of single data item
   */ SeriesData.prototype.clearItemLayouts = function() {
        this._itemLayouts.length = 0;
    };
    /**
   * Set graphic element relative to data. It can be set as null
   */ SeriesData.prototype.setItemGraphicEl = function(idx, el) {
        var seriesIndex = this.hostModel && this.hostModel.seriesIndex;
        (0, $813d173718eca8f1$export$30d6736ebb8e18d5)(seriesIndex, this.dataType, idx, el);
        this._graphicEls[idx] = el;
    };
    SeriesData.prototype.getItemGraphicEl = function(idx) {
        return this._graphicEls[idx];
    };
    SeriesData.prototype.eachItemGraphicEl = function(cb, context) {
        $f16f2994a32ad273$export$79b2f7037acddd43(this._graphicEls, function(el, idx) {
            if (el) cb && cb.call(context, el, idx);
        });
    };
    /**
   * Shallow clone a new list except visual and layout properties, and graph elements.
   * New list only change the indices.
   */ SeriesData.prototype.cloneShallow = function(list) {
        if (!list) list = new SeriesData(this._schema ? this._schema : $5e1317c5ed21cc39$var$map(this.dimensions, this._getDimInfo, this), this.hostModel);
        $5e1317c5ed21cc39$var$transferProperties(list, this);
        list._store = this._store;
        return list;
    };
    /**
   * Wrap some method to add more feature
   */ SeriesData.prototype.wrapMethod = function(methodName, injectFunction) {
        var originalMethod = this[methodName];
        if (!$f16f2994a32ad273$export$f6e2535fb5126e54(originalMethod)) return;
        this.__wrappedMethods = this.__wrappedMethods || [];
        this.__wrappedMethods.push(methodName);
        this[methodName] = function() {
            var res = originalMethod.apply(this, arguments);
            return injectFunction.apply(this, [
                res
            ].concat($f16f2994a32ad273$export$58adb3bec8346d0f(arguments)));
        };
    };
    // ----------------------------------------------------------
    // A work around for internal method visiting private member.
    // ----------------------------------------------------------
    SeriesData.internalField = function() {
        $5e1317c5ed21cc39$var$prepareInvertedIndex = function prepareInvertedIndex(data) {
            var invertedIndicesMap = data._invertedIndicesMap;
            $f16f2994a32ad273$export$79b2f7037acddd43(invertedIndicesMap, function(invertedIndices, dim) {
                var dimInfo = data._dimInfos[dim];
                // Currently, only dimensions that has ordinalMeta can create inverted indices.
                var ordinalMeta = dimInfo.ordinalMeta;
                var store = data._store;
                if (ordinalMeta) {
                    invertedIndices = invertedIndicesMap[dim] = new $5e1317c5ed21cc39$var$CtorInt32Array(ordinalMeta.categories.length);
                    // The default value of TypedArray is 0. To avoid miss
                    // mapping to 0, we should set it as INDEX_NOT_FOUND.
                    for(var i = 0; i < invertedIndices.length; i++)invertedIndices[i] = $5e1317c5ed21cc39$var$INDEX_NOT_FOUND;
                    for(var i = 0; i < store.count(); i++)// Only support the case that all values are distinct.
                    invertedIndices[store.get(dimInfo.storeDimIndex, i)] = i;
                }
            });
        };
        $5e1317c5ed21cc39$var$getIdNameFromStore = function getIdNameFromStore(data, dimIdx, idx) {
            return (0, $3fa81475350067fd$export$fb1a222ba5dd6e51)(data._getCategory(dimIdx, idx), null);
        };
        /**
     * @see the comment of `List['getId']`.
     */ $5e1317c5ed21cc39$var$getId = function getId(data, rawIndex) {
            var id = data._idList[rawIndex];
            if (id == null && data._idDimIdx != null) id = $5e1317c5ed21cc39$var$getIdNameFromStore(data, data._idDimIdx, rawIndex);
            if (id == null) id = $5e1317c5ed21cc39$var$ID_PREFIX + rawIndex;
            return id;
        };
        $5e1317c5ed21cc39$var$normalizeDimensions = function normalizeDimensions(dimensions) {
            if (!$f16f2994a32ad273$export$43bee75e5e14138e(dimensions)) dimensions = dimensions != null ? [
                dimensions
            ] : [];
            return dimensions;
        };
        /**
     * Data in excludeDimensions is copied, otherwise transferred.
     */ $5e1317c5ed21cc39$var$cloneListForMapAndSample = function cloneListForMapAndSample(original) {
            var list = new SeriesData(original._schema ? original._schema : $5e1317c5ed21cc39$var$map(original.dimensions, original._getDimInfo, original), original.hostModel);
            // FIXME If needs stackedOn, value may already been stacked
            $5e1317c5ed21cc39$var$transferProperties(list, original);
            return list;
        };
        $5e1317c5ed21cc39$var$transferProperties = function transferProperties(target, source) {
            $f16f2994a32ad273$export$79b2f7037acddd43($5e1317c5ed21cc39$var$TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function(propName) {
                if (source.hasOwnProperty(propName)) target[propName] = source[propName];
            });
            target.__wrappedMethods = source.__wrappedMethods;
            $f16f2994a32ad273$export$79b2f7037acddd43($5e1317c5ed21cc39$var$CLONE_PROPERTIES, function(propName) {
                target[propName] = $f16f2994a32ad273$export$9cd59f9826255e47(source[propName]);
            });
            target._calculationInfo = $f16f2994a32ad273$export$8b58be045bf06082({}, source._calculationInfo);
        };
        $5e1317c5ed21cc39$var$makeIdFromName = function makeIdFromName(data, idx) {
            var nameList = data._nameList;
            var idList = data._idList;
            var nameDimIdx = data._nameDimIdx;
            var idDimIdx = data._idDimIdx;
            var name = nameList[idx];
            var id = idList[idx];
            if (name == null && nameDimIdx != null) nameList[idx] = name = $5e1317c5ed21cc39$var$getIdNameFromStore(data, nameDimIdx, idx);
            if (id == null && idDimIdx != null) idList[idx] = id = $5e1317c5ed21cc39$var$getIdNameFromStore(data, idDimIdx, idx);
            if (id == null && name != null) {
                var nameRepeatCount = data._nameRepeatCount;
                var nmCnt = nameRepeatCount[name] = (nameRepeatCount[name] || 0) + 1;
                id = name;
                if (nmCnt > 1) id += '__ec__' + nmCnt;
                idList[idx] = id;
            }
        };
    }();
    return SeriesData;
}();
var $5e1317c5ed21cc39$export$2e2bcd8739ae039 = $5e1317c5ed21cc39$var$SeriesData;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







function $dad74d7b925f39e3$export$8066c1b52b2e9504(source, opt) {
    return $dad74d7b925f39e3$export$2e2bcd8739ae039(source, opt).dimensions;
}
function $dad74d7b925f39e3$export$2e2bcd8739ae039(// TODO: TYPE completeDimensions type
source, opt) {
    if (!(0, $9cad8a8849680580$export$22b808bc02a60488)(source)) source = (0, $9cad8a8849680580$export$75aef3f97c0a5edf)(source);
    opt = opt || {};
    var sysDims = opt.coordDimensions || [];
    var dimsDef = opt.dimensionsDefine || source.dimensionsDefine || [];
    var coordDimNameMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
    var resultList = [];
    var dimCount = $dad74d7b925f39e3$var$getDimCount(source, sysDims, dimsDef, opt.dimensionsCount);
    // Try to ignore unused dimensions if sharing a high dimension datastore
    // 30 is an experience value.
    var omitUnusedDimensions = opt.canOmitUnusedDimensions && (0, $af0b4b5988d2bf1e$export$238b87930d825d87)(dimCount);
    var isUsingSourceDimensionsDef = dimsDef === source.dimensionsDefine;
    var dataDimNameMap = isUsingSourceDimensionsDef ? (0, $af0b4b5988d2bf1e$export$be39ae17310c33f7)(source) : (0, $af0b4b5988d2bf1e$export$a477f5bebfd07944)(dimsDef);
    var encodeDef = opt.encodeDefine;
    if (!encodeDef && opt.encodeDefaulter) encodeDef = opt.encodeDefaulter(source, dimCount);
    var encodeDefMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)(encodeDef);
    var indicesMap = new (0, $e2e44dba229a928c$export$b60d945128546f53)(dimCount);
    for(var i = 0; i < indicesMap.length; i++)indicesMap[i] = -1;
    function getResultItem(dimIdx) {
        var idx = indicesMap[dimIdx];
        if (idx < 0) {
            var dimDefItemRaw = dimsDef[dimIdx];
            var dimDefItem = (0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(dimDefItemRaw) ? dimDefItemRaw : {
                name: dimDefItemRaw
            };
            var resultItem = new (0, $41c6664c7c2abbca$export$2e2bcd8739ae039)();
            var userDimName = dimDefItem.name;
            if (userDimName != null && dataDimNameMap.get(userDimName) != null) // Only if `series.dimensions` is defined in option
            // displayName, will be set, and dimension will be displayed vertically in
            // tooltip by default.
            resultItem.name = resultItem.displayName = userDimName;
            dimDefItem.type != null && (resultItem.type = dimDefItem.type);
            dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
            var newIdx = resultList.length;
            indicesMap[dimIdx] = newIdx;
            resultItem.storeDimIndex = dimIdx;
            resultList.push(resultItem);
            return resultItem;
        }
        return resultList[idx];
    }
    if (!omitUnusedDimensions) for(var i = 0; i < dimCount; i++)getResultItem(i);
    // Set `coordDim` and `coordDimIndex` by `encodeDefMap` and normalize `encodeDefMap`.
    encodeDefMap.each(function(dataDimsRaw, coordDim) {
        var dataDims = (0, $3fa81475350067fd$export$4f07b212a02c8051)(dataDimsRaw).slice();
        // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
        // `{encode: {x: -1, y: 1}}`. Should not filter anything in
        // this case.
        if (dataDims.length === 1 && !(0, $f16f2994a32ad273$export$844ec244b1367d54)(dataDims[0]) && dataDims[0] < 0) {
            encodeDefMap.set(coordDim, false);
            return;
        }
        var validDataDims = encodeDefMap.set(coordDim, []);
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(dataDims, function(resultDimIdxOrName, idx) {
            // The input resultDimIdx can be dim name or index.
            var resultDimIdx = (0, $f16f2994a32ad273$export$844ec244b1367d54)(resultDimIdxOrName) ? dataDimNameMap.get(resultDimIdxOrName) : resultDimIdxOrName;
            if (resultDimIdx != null && resultDimIdx < dimCount) {
                validDataDims[idx] = resultDimIdx;
                applyDim(getResultItem(resultDimIdx), coordDim, idx);
            }
        });
    });
    // Apply templates and default order from `sysDims`.
    var availDimIdx = 0;
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(sysDims, function(sysDimItemRaw) {
        var coordDim;
        var sysDimItemDimsDef;
        var sysDimItemOtherDims;
        var sysDimItem;
        if ((0, $f16f2994a32ad273$export$844ec244b1367d54)(sysDimItemRaw)) {
            coordDim = sysDimItemRaw;
            sysDimItem = {};
        } else {
            sysDimItem = sysDimItemRaw;
            coordDim = sysDimItem.name;
            var ordinalMeta = sysDimItem.ordinalMeta;
            sysDimItem.ordinalMeta = null;
            sysDimItem = (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, sysDimItem);
            sysDimItem.ordinalMeta = ordinalMeta;
            // `coordDimIndex` should not be set directly.
            sysDimItemDimsDef = sysDimItem.dimsDef;
            sysDimItemOtherDims = sysDimItem.otherDims;
            sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
        }
        var dataDims = encodeDefMap.get(coordDim);
        // negative resultDimIdx means no need to mapping.
        if (dataDims === false) return;
        dataDims = (0, $3fa81475350067fd$export$4f07b212a02c8051)(dataDims);
        // dimensions provides default dim sequences.
        if (!dataDims.length) for(var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++){
            while(availDimIdx < dimCount && getResultItem(availDimIdx).coordDim != null)availDimIdx++;
            availDimIdx < dimCount && dataDims.push(availDimIdx++);
        }
        // Apply templates.
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(dataDims, function(resultDimIdx, coordDimIndex) {
            var resultItem = getResultItem(resultDimIdx);
            // Coordinate system has a higher priority on dim type than source.
            if (isUsingSourceDimensionsDef && sysDimItem.type != null) resultItem.type = sysDimItem.type;
            applyDim((0, $f16f2994a32ad273$export$ebe90cb607ad99e)(resultItem, sysDimItem), coordDim, coordDimIndex);
            if (resultItem.name == null && sysDimItemDimsDef) {
                var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
                !(0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
                    name: sysDimItemDimsDefItem
                });
                resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
                resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
            }
            // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
            sysDimItemOtherDims && (0, $f16f2994a32ad273$export$ebe90cb607ad99e)(resultItem.otherDims, sysDimItemOtherDims);
        });
    });
    function applyDim(resultItem, coordDim, coordDimIndex) {
        if ((0, $c870d17359cdf008$export$cd51b5ca77f6f0e4).get(coordDim) != null) resultItem.otherDims[coordDim] = coordDimIndex;
        else {
            resultItem.coordDim = coordDim;
            resultItem.coordDimIndex = coordDimIndex;
            coordDimNameMap.set(coordDim, true);
        }
    }
    // Make sure the first extra dim is 'value'.
    var generateCoord = opt.generateCoord;
    var generateCoordCount = opt.generateCoordCount;
    var fromZero = generateCoordCount != null;
    generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
    var extra = generateCoord || 'value';
    function ifNoNameFillWithCoordName(resultItem) {
        if (resultItem.name == null) // Duplication will be removed in the next step.
        resultItem.name = resultItem.coordDim;
    }
    // Set dim `name` and other `coordDim` and other props.
    if (!omitUnusedDimensions) for(var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++){
        var resultItem = getResultItem(resultDimIdx);
        var coordDim = resultItem.coordDim;
        if (coordDim == null) {
            // TODO no need to generate coordDim for isExtraCoord?
            resultItem.coordDim = $dad74d7b925f39e3$var$genCoordDimName(extra, coordDimNameMap, fromZero);
            resultItem.coordDimIndex = 0;
            // Series specified generateCoord is using out.
            if (!generateCoord || generateCoordCount <= 0) resultItem.isExtraCoord = true;
            generateCoordCount--;
        }
        ifNoNameFillWithCoordName(resultItem);
        if (resultItem.type == null && ((0, $0988ea9c84ff78f2$export$c51adf1a2be01b9c)(source, resultDimIdx) === (0, $0988ea9c84ff78f2$export$328749e9c5b40760).Must || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) resultItem.type = 'ordinal';
    }
    else {
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(resultList, function(resultItem) {
            // PENDING: guessOrdinal or let user specify type: 'ordinal' manually?
            ifNoNameFillWithCoordName(resultItem);
        });
        // Sort dimensions: there are some rule that use the last dim as label,
        // and for some latter travel process easier.
        resultList.sort(function(item0, item1) {
            return item0.storeDimIndex - item1.storeDimIndex;
        });
    }
    (0, $3fa81475350067fd$export$2e2262a44ac61957)(resultList, function(item) {
        return item.name;
    }, function(item, existingCount) {
        if (existingCount > 0) // Starts from 0.
        item.name = item.name + (existingCount - 1);
    });
    return new (0, $af0b4b5988d2bf1e$export$a1ef064685775f3e)({
        source: source,
        dimensions: resultList,
        fullDimensionCount: dimCount,
        dimensionOmitted: omitUnusedDimensions
    });
}
// ??? TODO
// Originally detect dimCount by data[0]. Should we
// optimize it to only by sysDims and dimensions and encode.
// So only necessary dims will be initialized.
// But
// (1) custom series should be considered. where other dims
// may be visited.
// (2) sometimes user need to calculate bubble size or use visualMap
// on other dimensions besides coordSys needed.
// So, dims that is not used by system, should be shared in data store?
function $dad74d7b925f39e3$var$getDimCount(source, sysDims, dimsDef, optDimCount) {
    // Note that the result dimCount should not small than columns count
    // of data, otherwise `dataDimNameMap` checking will be incorrect.
    var dimCount = Math.max(source.dimensionsDetectedCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
    (0, $f16f2994a32ad273$export$79b2f7037acddd43)(sysDims, function(sysDimItem) {
        var sysDimItemDimsDef;
        if ((0, $f16f2994a32ad273$export$a6cdc56e425d0d0a)(sysDimItem) && (sysDimItemDimsDef = sysDimItem.dimsDef)) dimCount = Math.max(dimCount, sysDimItemDimsDef.length);
    });
    return dimCount;
}
function $dad74d7b925f39e3$var$genCoordDimName(name, map, fromZero) {
    if (fromZero || map.hasKey(name)) {
        var i = 0;
        while(map.hasKey(name + i))i++;
        name += i;
    }
    map.set(name, true);
    return name;
}





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Helper for model references.
 * There are many manners to refer axis/coordSys.
 */ // TODO
// merge relevant logic to this file?
// check: "modelHelper" of tooltip and "BrushTargetManager".


/**
 * @class
 * For example:
 * {
 *     coordSysName: 'cartesian2d',
 *     coordSysDims: ['x', 'y', ...],
 *     axisMap: HashMap({
 *         x: xAxisModel,
 *         y: yAxisModel
 *     }),
 *     categoryAxisMap: HashMap({
 *         x: xAxisModel,
 *         y: undefined
 *     }),
 *     // The index of the first category axis in `coordSysDims`.
 *     // `null/undefined` means no category axis exists.
 *     firstCategoryDimIndex: 1,
 *     // To replace user specified encode.
 * }
 */ var $11d8dbe7f25b1bef$export$7c29393272d112a1 = /** @class */ function() {
    function SeriesModelCoordSysInfo(coordSysName) {
        this.coordSysDims = [];
        this.axisMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
        this.categoryAxisMap = (0, $f16f2994a32ad273$export$55f8aa7ef875b0a4)();
        this.coordSysName = coordSysName;
    }
    return SeriesModelCoordSysInfo;
}();
function $11d8dbe7f25b1bef$export$f2befeb2f4933656(seriesModel) {
    var coordSysName = seriesModel.get('coordinateSystem');
    var result = new $11d8dbe7f25b1bef$export$7c29393272d112a1(coordSysName);
    var fetch = $11d8dbe7f25b1bef$var$fetchers[coordSysName];
    if (fetch) {
        fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
        return result;
    }
}
// TODO: refactor them to static member of each coord sys, rather than hard code here.
var $11d8dbe7f25b1bef$var$fetchers = {
    cartesian2d: function cartesian2d(seriesModel, result, axisMap, categoryAxisMap) {
        var xAxisModel = seriesModel.getReferringComponents('xAxis', (0, $3fa81475350067fd$export$f076738ec84e693c)).models[0];
        var yAxisModel = seriesModel.getReferringComponents('yAxis', (0, $3fa81475350067fd$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            'x',
            'y'
        ];
        axisMap.set('x', xAxisModel);
        axisMap.set('y', yAxisModel);
        if ($11d8dbe7f25b1bef$var$isCategory(xAxisModel)) {
            categoryAxisMap.set('x', xAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($11d8dbe7f25b1bef$var$isCategory(yAxisModel)) {
            categoryAxisMap.set('y', yAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    singleAxis: function singleAxis(seriesModel, result, axisMap, categoryAxisMap) {
        var singleAxisModel = seriesModel.getReferringComponents('singleAxis', (0, $3fa81475350067fd$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            'single'
        ];
        axisMap.set('single', singleAxisModel);
        if ($11d8dbe7f25b1bef$var$isCategory(singleAxisModel)) {
            categoryAxisMap.set('single', singleAxisModel);
            result.firstCategoryDimIndex = 0;
        }
    },
    polar: function polar(seriesModel, result, axisMap, categoryAxisMap) {
        var polarModel = seriesModel.getReferringComponents('polar', (0, $3fa81475350067fd$export$f076738ec84e693c)).models[0];
        var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
        var angleAxisModel = polarModel.findAxisModel('angleAxis');
        result.coordSysDims = [
            'radius',
            'angle'
        ];
        axisMap.set('radius', radiusAxisModel);
        axisMap.set('angle', angleAxisModel);
        if ($11d8dbe7f25b1bef$var$isCategory(radiusAxisModel)) {
            categoryAxisMap.set('radius', radiusAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($11d8dbe7f25b1bef$var$isCategory(angleAxisModel)) {
            categoryAxisMap.set('angle', angleAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    geo: function geo(seriesModel, result, axisMap, categoryAxisMap) {
        result.coordSysDims = [
            'lng',
            'lat'
        ];
    },
    parallel: function parallel(seriesModel, result, axisMap, categoryAxisMap) {
        var ecModel = seriesModel.ecModel;
        var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
        var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(parallelModel.parallelAxisIndex, function(axisIndex, index) {
            var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
            var axisDim = coordSysDims[index];
            axisMap.set(axisDim, axisModel);
            if ($11d8dbe7f25b1bef$var$isCategory(axisModel)) {
                categoryAxisMap.set(axisDim, axisModel);
                if (result.firstCategoryDimIndex == null) result.firstCategoryDimIndex = index;
            }
        });
    },
    matrix: function matrix(seriesModel, result, axisMap, categoryAxisMap) {
        var matrixModel = seriesModel.getReferringComponents('matrix', (0, $3fa81475350067fd$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            'x',
            'y'
        ];
        var xModel = matrixModel.getDimensionModel('x');
        var yModel = matrixModel.getDimensionModel('y');
        axisMap.set('x', xModel);
        axisMap.set('y', yModel);
        categoryAxisMap.set('x', xModel);
        categoryAxisMap.set('y', yModel);
    }
};
function $11d8dbe7f25b1bef$var$isCategory(axisModel) {
    return axisModel.get('type') === 'category';
}






function $85ec97b3aa0e62ee$var$getCoordSysDimDefs(seriesModel, coordSysInfo) {
    var coordSysName = seriesModel.get('coordinateSystem');
    var registeredCoordSys = (0, $d1c2b348f154f767$export$2e2bcd8739ae039).get(coordSysName);
    var coordSysDimDefs;
    if (coordSysInfo && coordSysInfo.coordSysDims) coordSysDimDefs = $f16f2994a32ad273$export$871de8747c9eaa88(coordSysInfo.coordSysDims, function(dim) {
        var dimInfo = {
            name: dim
        };
        var axisModel = coordSysInfo.axisMap.get(dim);
        if (axisModel) {
            var axisType = axisModel.get('type');
            dimInfo.type = (0, $cb767aa9bf020b98$export$af1622903e71278e)(axisType);
        }
        return dimInfo;
    });
    if (!coordSysDimDefs) // Get dimensions from registered coordinate system
    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || [
        'x',
        'y'
    ];
    return coordSysDimDefs;
}
function $85ec97b3aa0e62ee$var$injectOrdinalMeta(dimInfoList, createInvertedIndices, coordSysInfo) {
    var firstCategoryDimIndex;
    var hasNameEncode;
    coordSysInfo && $f16f2994a32ad273$export$79b2f7037acddd43(dimInfoList, function(dimInfo, dimIndex) {
        var coordDim = dimInfo.coordDim;
        var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
        if (categoryAxisModel) {
            if (firstCategoryDimIndex == null) firstCategoryDimIndex = dimIndex;
            dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
            if (createInvertedIndices) dimInfo.createInvertedIndices = true;
        }
        if (dimInfo.otherDims.itemName != null) hasNameEncode = true;
    });
    if (!hasNameEncode && firstCategoryDimIndex != null) dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
    return firstCategoryDimIndex;
}
/**
 * Caution: there are side effects to `sourceManager` in this method.
 * Should better only be called in `Series['getInitialData']`.
 */ function $85ec97b3aa0e62ee$var$createSeriesData(sourceRaw, seriesModel, opt) {
    opt = opt || {};
    var sourceManager = seriesModel.getSourceManager();
    var source;
    var isOriginalSource = false;
    if (sourceRaw) {
        isOriginalSource = true;
        source = (0, $9cad8a8849680580$export$75aef3f97c0a5edf)(sourceRaw);
    } else {
        source = sourceManager.getSource();
        // Is series.data. not dataset.
        isOriginalSource = source.sourceFormat === (0, $c870d17359cdf008$export$2823037fb9d8f0c6);
    }
    var coordSysInfo = (0, $11d8dbe7f25b1bef$export$f2befeb2f4933656)(seriesModel);
    var coordSysDimDefs = $85ec97b3aa0e62ee$var$getCoordSysDimDefs(seriesModel, coordSysInfo);
    var useEncodeDefaulter = opt.useEncodeDefaulter;
    var encodeDefaulter = $f16f2994a32ad273$export$f6e2535fb5126e54(useEncodeDefaulter) ? useEncodeDefaulter : useEncodeDefaulter ? $f16f2994a32ad273$export$c3095a23b368d1f2((0, $0988ea9c84ff78f2$export$37682b8fdd2e83d), coordSysDimDefs, seriesModel) : null;
    var createDimensionOptions = {
        coordDimensions: coordSysDimDefs,
        generateCoord: opt.generateCoord,
        encodeDefine: seriesModel.getEncode(),
        encodeDefaulter: encodeDefaulter,
        canOmitUnusedDimensions: !isOriginalSource
    };
    var schema = (0, $dad74d7b925f39e3$export$2e2bcd8739ae039)(source, createDimensionOptions);
    var firstCategoryDimIndex = $85ec97b3aa0e62ee$var$injectOrdinalMeta(schema.dimensions, opt.createInvertedIndices, coordSysInfo);
    var store = !isOriginalSource ? sourceManager.getSharedDataStore(schema) : null;
    var stackCalculationInfo = (0, $eb1b70ae9d7aaef4$export$f2165f9e8499b278)(seriesModel, {
        schema: schema,
        store: store
    });
    var data = new (0, $5e1317c5ed21cc39$export$2e2bcd8739ae039)(schema, seriesModel);
    data.setCalculationInfo(stackCalculationInfo);
    var dimValueGetter = firstCategoryDimIndex != null && $85ec97b3aa0e62ee$var$isNeedCompleteOrdinalData(source) ? function dimValueGetter(itemOpt, dimName, dataIndex, dimIndex) {
        // Use dataIndex as ordinal value in categoryAxis
        return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
    } : null;
    data.hasItemOption = false;
    data.initData(// Try to reuse the data store in sourceManager if using dataset.
    isOriginalSource ? source : store, null, dimValueGetter);
    return data;
}
function $85ec97b3aa0e62ee$var$isNeedCompleteOrdinalData(source) {
    if (source.sourceFormat === (0, $c870d17359cdf008$export$2823037fb9d8f0c6)) {
        var sampleItem = $85ec97b3aa0e62ee$var$firstDataNotNull(source.data || []);
        return !$f16f2994a32ad273$export$43bee75e5e14138e((0, $3fa81475350067fd$export$2c944e12edb48d4b)(sampleItem));
    }
}
function $85ec97b3aa0e62ee$var$firstDataNotNull(arr) {
    var i = 0;
    while(i < arr.length && arr[i] == null)i++;
    return arr[i];
}
var $85ec97b3aa0e62ee$export$2e2bcd8739ae039 = $85ec97b3aa0e62ee$var$createSeriesData;



var $bf48465196152d92$var$BaseBarSeriesModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(BaseBarSeriesModel, _super);
    function BaseBarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BaseBarSeriesModel.type;
        return _this;
    }
    BaseBarSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $85ec97b3aa0e62ee$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    BaseBarSeriesModel.prototype.getMarkerPosition = function(value, dims, startingAtTick) {
        var coordSys = this.coordinateSystem;
        if (coordSys && coordSys.clampData) {
            // PENDING if clamp ?
            var clampData_1 = coordSys.clampData(value);
            var pt_1 = coordSys.dataToPoint(clampData_1);
            if (startingAtTick) (0, $f16f2994a32ad273$export$79b2f7037acddd43)(coordSys.getAxes(), function(axis, idx) {
                // If axis type is category, use tick coords instead
                if (axis.type === 'category' && dims != null) {
                    var tickCoords = axis.getTicksCoords();
                    var alignTicksWithLabel = axis.getTickModel().get('alignWithLabel');
                    var targetTickId = clampData_1[idx];
                    // The index of rightmost tick of markArea is 1 larger than x1/y1 index
                    var isEnd = dims[idx] === 'x1' || dims[idx] === 'y1';
                    if (isEnd && !alignTicksWithLabel) targetTickId += 1;
                    // The only contains one tick, tickCoords is
                    // like [{coord: 0, tickValue: 0}, {coord: 0}]
                    // to the length should always be larger than 1
                    if (tickCoords.length < 2) return;
                    else if (tickCoords.length === 2) {
                        // The left value and right value of the axis are
                        // the same. coord is 0 in both items. Use the max
                        // value of the axis as the coord
                        pt_1[idx] = axis.toGlobalCoord(axis.getExtent()[isEnd ? 1 : 0]);
                        return;
                    }
                    var leftCoord = void 0;
                    var coord = void 0;
                    var stepTickValue = 1;
                    for(var i = 0; i < tickCoords.length; i++){
                        var tickCoord = tickCoords[i].coord;
                        // The last item of tickCoords doesn't contain
                        // tickValue
                        var tickValue = i === tickCoords.length - 1 ? tickCoords[i - 1].tickValue + stepTickValue : tickCoords[i].tickValue;
                        if (tickValue === targetTickId) {
                            coord = tickCoord;
                            break;
                        } else if (tickValue < targetTickId) leftCoord = tickCoord;
                        else if (leftCoord != null && tickValue > targetTickId) {
                            coord = (tickCoord + leftCoord) / 2;
                            break;
                        }
                        if (i === 1) // Here we assume the step of category axes is
                        // the same
                        stepTickValue = tickValue - tickCoords[0].tickValue;
                    }
                    if (coord == null) {
                        if (!leftCoord) // targetTickId is smaller than all tick ids in the
                        // visible area, use the leftmost tick coord
                        coord = tickCoords[0].coord;
                        else if (leftCoord) // targetTickId is larger than all tick ids in the
                        // visible area, use the rightmost tick coord
                        coord = tickCoords[tickCoords.length - 1].coord;
                    }
                    pt_1[idx] = axis.toGlobalCoord(coord);
                }
            });
            else {
                var data = this.getData();
                var offset = data.getLayout('offset');
                var size = data.getLayout('size');
                var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
                pt_1[offsetIndex] += offset + size / 2;
            }
            return pt_1;
        }
        return [
            NaN,
            NaN
        ];
    };
    /**
   * @implements
   */ BaseBarSeriesModel.prototype.__requireStartValue = function(axis) {
        return this.getBaseAxis() !== axis;
    };
    BaseBarSeriesModel.type = 'series.__base_bar__';
    BaseBarSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        // stack: null
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        barMinHeight: 0,
        barMinAngle: 0,
        // cursor: null,
        large: false,
        largeThreshold: 400,
        progressive: 3e3,
        progressiveChunkMode: 'mod',
        defaultBarGap: '10%'
    };
    return BaseBarSeriesModel;
}((0, $80ec9a06634f90ca$export$2e2bcd8739ae039));
(0, $80ec9a06634f90ca$export$2e2bcd8739ae039).registerClass($bf48465196152d92$var$BaseBarSeriesModel);
var $bf48465196152d92$export$2e2bcd8739ae039 = $bf48465196152d92$var$BaseBarSeriesModel;







var $52a29a39e7d43a81$var$BarSeriesModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(BarSeriesModel, _super);
    function BarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BarSeriesModel.type;
        return _this;
    }
    BarSeriesModel.prototype.getInitialData = function() {
        return (0, $85ec97b3aa0e62ee$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true,
            createInvertedIndices: !!this.get('realtimeSort', true) || null
        });
    };
    /**
   * @override
   */ BarSeriesModel.prototype.getProgressive = function() {
        // Do not support progressive in normal mode.
        return this.get('large') ? this.get('progressive') : false;
    };
    /**
   * @implement
   */ BarSeriesModel.prototype.__preparePipelineContext = function(view, pipeline) {
        var context = (0, $3fa81475350067fd$export$3b33f7e0868ca070)(this, view, pipeline);
        // Do not support progressive in normal mode.
        if (context.progressiveRender) context.large = true;
        return context;
    };
    BarSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.rect(data.getItemLayout(dataIndex));
    };
    BarSeriesModel.type = 'series.' + (0, $1d243d9d64281796$export$c34a2bf62ca07d83);
    BarSeriesModel.dependencies = [
        'grid',
        'polar'
    ];
    BarSeriesModel.defaultOption = (0, $b2c0501cd47c18d8$export$68acc510e46fef2)((0, $bf48465196152d92$export$2e2bcd8739ae039).defaultOption, {
        // If clipped
        // Only available on cartesian2d
        clip: true,
        roundCap: false,
        showBackground: false,
        backgroundStyle: {
            color: 'rgba(180, 180, 180, 0.2)',
            borderColor: null,
            borderWidth: 0,
            borderType: 'solid',
            borderRadius: 0,
            shadowBlur: 0,
            shadowColor: null,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            opacity: 1
        },
        select: {
            itemStyle: {
                borderColor: (0, $97f8a9a255c2d778$export$2e2bcd8739ae039).color.primary,
                borderWidth: 2
            }
        },
        realtimeSort: false
    });
    return BarSeriesModel;
}((0, $bf48465196152d92$export$2e2bcd8739ae039));
var $52a29a39e7d43a81$export$2e2bcd8739ae039 = $52a29a39e7d43a81$var$BarSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $dcdbcc2842504ab5$export$83958787eb658d14(cartesian, hasAnimation, seriesModel, done, during) {
    var rect = cartesian.getArea();
    var x = rect.x;
    var y = rect.y;
    var width = rect.width;
    var height = rect.height;
    var lineWidth = seriesModel.get([
        'lineStyle',
        'width'
    ]) || 0;
    // Expand the clip path a bit to avoid the border is clipped and looks thinner
    x -= lineWidth / 2;
    y -= lineWidth / 2;
    width += lineWidth;
    height += lineWidth;
    // fix: https://github.com/apache/incubator-echarts/issues/11369
    width = Math.ceil(width);
    if (x !== Math.floor(x)) {
        x = Math.floor(x);
        // if no extra 1px on `width`, it will still be clipped since `x` is floored
        width++;
    }
    var clipPath = new $dbd6d77105f10fb2$export$2e2bcd8739ae039({
        shape: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    });
    if (hasAnimation) {
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var isAxisInversed = baseAxis.inverse;
        if (isHorizontal) {
            if (isAxisInversed) clipPath.shape.x += width;
            clipPath.shape.width = 0;
        } else {
            if (!isAxisInversed) clipPath.shape.y += height;
            clipPath.shape.height = 0;
        }
        var duringCb = (0, $f16f2994a32ad273$export$f6e2535fb5126e54)(during) ? function duringCb(percent) {
            during(percent, clipPath);
        } : null;
        $d2a962ec0ef14a79$export$a121566aadcfe021(clipPath, {
            shape: {
                width: width,
                height: height,
                x: x,
                y: y
            }
        }, seriesModel, null, done, duringCb);
    }
    return clipPath;
}
function $dcdbcc2842504ab5$export$13dc2b2230df3cb5(polar, hasAnimation, seriesModel) {
    var sectorArea = polar.getArea();
    // Avoid float number rounding error for symbol on the edge of axis extent.
    var r0 = (0, $104896d282bd296f$export$2077e0241d6afd3c)(sectorArea.r0, 1);
    var r = (0, $104896d282bd296f$export$2077e0241d6afd3c)(sectorArea.r, 1);
    var clipPath = new $ace53cc79acf5001$export$2e2bcd8739ae039({
        shape: {
            cx: (0, $104896d282bd296f$export$2077e0241d6afd3c)(polar.cx, 1),
            cy: (0, $104896d282bd296f$export$2077e0241d6afd3c)(polar.cy, 1),
            r0: r0,
            r: r,
            startAngle: sectorArea.startAngle,
            endAngle: sectorArea.endAngle,
            clockwise: sectorArea.clockwise
        }
    });
    if (hasAnimation) {
        var isRadial = polar.getBaseAxis().dim === 'angle';
        if (isRadial) clipPath.shape.endAngle = sectorArea.startAngle;
        else clipPath.shape.r = r0;
        $d2a962ec0ef14a79$export$a121566aadcfe021(clipPath, {
            shape: {
                endAngle: sectorArea.endAngle,
                r: r
            }
        }, seriesModel);
    }
    return clipPath;
}
function $dcdbcc2842504ab5$export$e0fe5081209d01c9(coordSys, hasAnimation, seriesModel, done, during) {
    if (!coordSys) return null;
    else if (coordSys.type === 'polar') return $dcdbcc2842504ab5$export$13dc2b2230df3cb5(coordSys, hasAnimation, seriesModel);
    else if (coordSys.type === 'cartesian2d') return $dcdbcc2842504ab5$export$83958787eb658d14(coordSys, hasAnimation, seriesModel, done, during);
    return null;
}
var $dcdbcc2842504ab5$export$50eaf45b617b77da = 0;
var $dcdbcc2842504ab5$export$36c0f03caa6071e6 = 1;
var $dcdbcc2842504ab5$export$6b0aed6da8ae4f2e = 2;
function $dcdbcc2842504ab5$export$e01c1b2ba9fe13e9(clip, symbolEl, clipPath) {
    if (clip) symbolEl.setClipPath(clipPath);
    else symbolEl.removeClipPath();
}
function $dcdbcc2842504ab5$export$dd44d434645865fc(seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    if (seriesModel.get('clip', true) && coordSys && (!coordSys.shouldClip || coordSys.shouldClip())) // PENDING make `0.1` configurable, for example, `clipTolerance`?
    return coordSys.getArea && coordSys.getArea(.1);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Sausage: similar to sector, but have half circle on both sides
 */ var $21bba6d0cd83301a$var$SausageShape = /** @class */ function() {
    function SausageShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return SausageShape;
}();
var $21bba6d0cd83301a$var$SausagePath = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(SausagePath, _super);
    function SausagePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'sausage';
        return _this;
    }
    SausagePath.prototype.getDefaultShape = function() {
        return new $21bba6d0cd83301a$var$SausageShape();
    };
    SausagePath.prototype.buildPath = function(ctx, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var r0 = Math.max(shape.r0 || 0, 0);
        var r = Math.max(shape.r, 0);
        var dr = (r - r0) * 0.5;
        var rCenter = r0 + dr;
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var PI2 = Math.PI * 2;
        var lessThanCircle = clockwise ? endAngle - startAngle < PI2 : startAngle - endAngle < PI2;
        if (!lessThanCircle) // Normalize angles
        startAngle = endAngle - (clockwise ? PI2 : -PI2);
        var unitStartX = Math.cos(startAngle);
        var unitStartY = Math.sin(startAngle);
        var unitEndX = Math.cos(endAngle);
        var unitEndY = Math.sin(endAngle);
        if (lessThanCircle) {
            ctx.moveTo(unitStartX * r0 + cx, unitStartY * r0 + cy);
            ctx.arc(unitStartX * rCenter + cx, unitStartY * rCenter + cy, dr, -Math.PI + startAngle, startAngle, !clockwise);
        } else ctx.moveTo(unitStartX * r + cx, unitStartY * r + cy);
        ctx.arc(cx, cy, r, startAngle, endAngle, !clockwise);
        ctx.arc(unitEndX * rCenter + cx, unitEndY * rCenter + cy, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);
        if (r0 !== 0) ctx.arc(cx, cy, r0, endAngle, startAngle, clockwise);
    // ctx.closePath();
    };
    return SausagePath;
}((0, $340211037b56ba3f$export$2e2bcd8739ae039));
var $21bba6d0cd83301a$export$2e2bcd8739ae039 = $21bba6d0cd83301a$var$SausagePath;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $5456f1f0fd55689a$export$8567506e6336616(coordSys, type) {
    return coordSys.type === type;
}
function $5456f1f0fd55689a$export$d3269a273c05cc72(coordSys) {
    var dimensions = coordSys.dimensions;
    // Not use coordSys.type === 'geo' because coordSys maybe extended
    return dimensions[0] === 'lng' && dimensions[1] === 'lat' && !!coordSys.getViewRect;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $31fd0a507fb966a7$export$5ff20667590927ed(data, dataIndex) {
    var labelDims = data.mapDimensionsAll('defaultedLabel');
    var len = labelDims.length;
    // Simple optimization (in lots of cases, label dims length is 1)
    if (len === 1) {
        var rawVal = (0, $64e5bb47dc44a160$export$cde9373da9aad801)(data, dataIndex, labelDims[0]);
        return rawVal != null ? rawVal + '' : null;
    } else if (len) {
        var vals = [];
        for(var i = 0; i < labelDims.length; i++)vals.push((0, $64e5bb47dc44a160$export$cde9373da9aad801)(data, dataIndex, labelDims[i]));
        return vals.join(' ');
    }
}
function $31fd0a507fb966a7$export$5f84815e91ca6775(data, interpolatedValue) {
    var labelDims = data.mapDimensionsAll('defaultedLabel');
    if (!(0, $f16f2994a32ad273$export$43bee75e5e14138e)(interpolatedValue)) return interpolatedValue + '';
    var vals = [];
    for(var i = 0; i < labelDims.length; i++){
        var dimIndex = data.getDimensionIndex(labelDims[i]);
        if (dimIndex >= 0) vals.push(interpolatedValue[dimIndex]);
    }
    return vals.join(' ');
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $65a8dd0571c641ba$export$359a1e2d210ed734(positionMapping, opts) {
    opts = opts || {};
    var isRoundCap = opts.isRoundCap;
    return function(out, opts, boundingRect) {
        var textPosition = opts.position;
        if (!textPosition || textPosition instanceof Array) return (0, $3ad1e5e308f2a981$export$eee3603b512feab7)(out, opts, boundingRect);
        var mappedSectorPosition = positionMapping(textPosition);
        var distance = opts.distance != null ? opts.distance : 5;
        var sector = this.shape;
        var cx = sector.cx;
        var cy = sector.cy;
        var r = sector.r;
        var r0 = sector.r0;
        var middleR = (r + r0) / 2;
        var startAngle = sector.startAngle;
        var endAngle = sector.endAngle;
        var middleAngle = (startAngle + endAngle) / 2;
        var extraDist = isRoundCap ? Math.abs(r - r0) / 2 : 0;
        var mathCos = Math.cos;
        var mathSin = Math.sin;
        // base position: top-left
        var x = cx + r * mathCos(startAngle);
        var y = cy + r * mathSin(startAngle);
        var textAlign = 'left';
        var textVerticalAlign = 'top';
        switch(mappedSectorPosition){
            case 'startArc':
                x = cx + (r0 - distance) * mathCos(middleAngle);
                y = cy + (r0 - distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'top';
                break;
            case 'insideStartArc':
                x = cx + (r0 + distance) * mathCos(middleAngle);
                y = cy + (r0 + distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'startAngle':
                x = cx + middleR * mathCos(startAngle) + $65a8dd0571c641ba$var$adjustAngleDistanceX(startAngle, distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $65a8dd0571c641ba$var$adjustAngleDistanceY(startAngle, distance + extraDist, false);
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            case 'insideStartAngle':
                x = cx + middleR * mathCos(startAngle) + $65a8dd0571c641ba$var$adjustAngleDistanceX(startAngle, -distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $65a8dd0571c641ba$var$adjustAngleDistanceY(startAngle, -distance + extraDist, false);
                textAlign = 'left';
                textVerticalAlign = 'middle';
                break;
            case 'middle':
                x = cx + middleR * mathCos(middleAngle);
                y = cy + middleR * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'middle';
                break;
            case 'endArc':
                x = cx + (r + distance) * mathCos(middleAngle);
                y = cy + (r + distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'insideEndArc':
                x = cx + (r - distance) * mathCos(middleAngle);
                y = cy + (r - distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'top';
                break;
            case 'endAngle':
                x = cx + middleR * mathCos(endAngle) + $65a8dd0571c641ba$var$adjustAngleDistanceX(endAngle, distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $65a8dd0571c641ba$var$adjustAngleDistanceY(endAngle, distance + extraDist, true);
                textAlign = 'left';
                textVerticalAlign = 'middle';
                break;
            case 'insideEndAngle':
                x = cx + middleR * mathCos(endAngle) + $65a8dd0571c641ba$var$adjustAngleDistanceX(endAngle, -distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $65a8dd0571c641ba$var$adjustAngleDistanceY(endAngle, -distance + extraDist, true);
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            default:
                return (0, $3ad1e5e308f2a981$export$eee3603b512feab7)(out, opts, boundingRect);
        }
        out = out || {};
        out.x = x;
        out.y = y;
        out.align = textAlign;
        out.verticalAlign = textVerticalAlign;
        return out;
    };
}
function $65a8dd0571c641ba$export$672ce504c0db395a(sector, textPosition, positionMapping, rotateType) {
    if ((0, $f16f2994a32ad273$export$7e4aa119212bc614)(rotateType)) {
        // user-set rotation
        sector.setTextConfig({
            rotation: rotateType
        });
        return;
    } else if ((0, $f16f2994a32ad273$export$43bee75e5e14138e)(textPosition)) {
        // user-set position, use 0 as auto rotation
        sector.setTextConfig({
            rotation: 0
        });
        return;
    }
    var shape = sector.shape;
    var startAngle = shape.clockwise ? shape.startAngle : shape.endAngle;
    var endAngle = shape.clockwise ? shape.endAngle : shape.startAngle;
    var middleAngle = (startAngle + endAngle) / 2;
    var anchorAngle;
    var mappedSectorPosition = positionMapping(textPosition);
    switch(mappedSectorPosition){
        case 'startArc':
        case 'insideStartArc':
        case 'middle':
        case 'insideEndArc':
        case 'endArc':
            anchorAngle = middleAngle;
            break;
        case 'startAngle':
        case 'insideStartAngle':
            anchorAngle = startAngle;
            break;
        case 'endAngle':
        case 'insideEndAngle':
            anchorAngle = endAngle;
            break;
        default:
            sector.setTextConfig({
                rotation: 0
            });
            return;
    }
    var rotate = Math.PI * 1.5 - anchorAngle;
    /**
   * TODO: labels with rotate > Math.PI / 2 should be rotate another
   * half round flipped to increase readability. However, only middle
   * position supports this for now, because in other positions, the
   * anchor point is not at the center of the text, so the positions
   * after rotating is not as expected.
   */ if (mappedSectorPosition === 'middle' && rotate > Math.PI / 2 && rotate < Math.PI * 1.5) rotate -= Math.PI;
    sector.setTextConfig({
        rotation: rotate
    });
}
function $65a8dd0571c641ba$var$adjustAngleDistanceX(angle, distance, isEnd) {
    return distance * Math.sin(angle) * (isEnd ? -1 : 1);
}
function $65a8dd0571c641ba$var$adjustAngleDistanceY(angle, distance, isEnd) {
    return distance * Math.cos(angle) * (isEnd ? 1 : -1);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $52dd02ed38778bb0$export$b395eeeb2ad7cce5(model, shape, zeroIfNull) {
    var cornerRadius = model.get('borderRadius');
    if (cornerRadius == null) return zeroIfNull ? {
        cornerRadius: 0
    } : null;
    if (!(0, $f16f2994a32ad273$export$43bee75e5e14138e)(cornerRadius)) cornerRadius = [
        cornerRadius,
        cornerRadius,
        cornerRadius,
        cornerRadius
    ];
    var dr = Math.abs(shape.r || 0 - shape.r0 || 0);
    return {
        cornerRadius: (0, $f16f2994a32ad273$export$871de8747c9eaa88)(cornerRadius, function(cr) {
            return (0, $3ad1e5e308f2a981$export$e8514cb5a5e2b40f)(cr, dr);
        })
    };
}




var $1e2677a56204a10c$var$mathMax = Math.max;
var $1e2677a56204a10c$var$mathMin = Math.min;
var $1e2677a56204a10c$var$BarView = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(BarView, _super);
    function BarView() {
        var _this = _super.call(this) || this;
        _this.type = (0, $1d243d9d64281796$export$c34a2bf62ca07d83);
        _this._isFirstFrame = true;
        return _this;
    }
    BarView.prototype.render = function(seriesModel, ecModel, api, payload) {
        this._model = seriesModel;
        this._removeOnRenderedListener(api);
        this._updateDrawMode(seriesModel);
        var coordinateSystemType = seriesModel.get('coordinateSystem');
        if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') {
            // Clear previously rendered progressive elements.
            this._progressiveEls = null;
            this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api, payload);
        }
    };
    BarView.prototype.incrementalPrepareRender = function(seriesModel) {
        this._clear();
        this._updateDrawMode(seriesModel);
        // incremental also need to clip, otherwise might be overlow.
        // But must not set clip in each frame, otherwise all of the children will be marked redraw.
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype.incrementalRender = function(params, seriesModel) {
        // Reset for eachRendered
        this._progressiveEls = [];
        // Do not support progressive in normal mode.
        this._incrementalRenderLarge(params, seriesModel);
    };
    BarView.prototype.eachRendered = function(cb) {
        (0, $bce1f681c7fb2581$export$3e564442729bf048)(this._progressiveEls || this.group, cb);
    };
    BarView.prototype._updateDrawMode = function(seriesModel) {
        var isLargeDraw = seriesModel.pipelineContext.large;
        if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
            this._isLargeDraw = isLargeDraw;
            this._clear();
        }
    };
    BarView.prototype._renderNormal = function(seriesModel, ecModel, api, payload) {
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        var coord = seriesModel.coordinateSystem;
        var baseAxis = coord.getBaseAxis();
        var isHorizontalOrRadial;
        if (coord.type === 'cartesian2d') isHorizontalOrRadial = baseAxis.isHorizontal();
        else if (coord.type === 'polar') isHorizontalOrRadial = baseAxis.dim === 'angle';
        var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
        var realtimeSortCfg = $1e2677a56204a10c$var$shouldRealtimeSort(seriesModel, coord);
        if (realtimeSortCfg) this._enableRealtimeSort(realtimeSortCfg, data, api);
        var needsClip = seriesModel.get('clip', true) || realtimeSortCfg;
        // Both `cartesian2d` and `polar` has `getArea()`.
        var coordSysClipArea = coord.getArea();
        // If there is clipPath created in large mode. Remove it.
        group.removeClipPath();
        // We don't use clipPath in normal mode because we needs a perfect animation
        // And don't want the label are clipped.
        // Instead, `Clipper` is used in normal mode.
        var roundCap = seriesModel.get('roundCap', true);
        var drawBackground = seriesModel.get('showBackground', true);
        var backgroundModel = seriesModel.getModel('backgroundStyle');
        var barBorderRadius = backgroundModel.get('borderRadius') || 0;
        var bgEls = [];
        var oldBgEls = this._backgroundEls;
        var isInitSort = payload && payload.isInitSort;
        var isChangeOrder = payload && payload.type === 'changeAxisOrder';
        function createBackground(dataIndex) {
            var bgLayout = $1e2677a56204a10c$var$getLayout[coord.type](data, dataIndex);
            if (!bgLayout) return null;
            var bgEl = $1e2677a56204a10c$var$createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
            bgEl.useStyle(backgroundModel.getItemStyle());
            // Only cartesian2d support borderRadius.
            if (coord.type === 'cartesian2d') bgEl.setShape('r', barBorderRadius);
            else bgEl.setShape('cornerRadius', barBorderRadius);
            bgEls[dataIndex] = bgEl;
            return bgEl;
        }
        data.diff(oldData).add(function(dataIndex) {
            var itemModel = data.getItemModel(dataIndex);
            var layout = $1e2677a56204a10c$var$getLayout[coord.type](data, dataIndex, itemModel);
            if (!layout) return;
            if (drawBackground) createBackground(dataIndex);
            // If dataZoom in filteMode: 'empty', the baseValue can be set as NaN in "axisProxy".
            if (!data.hasValue(dataIndex) || !$1e2677a56204a10c$var$isValidLayout[coord.type](layout)) return;
            var isClipped = false;
            if (needsClip) // Clip will modify the layout params.
            // And return a boolean to determine if the shape are fully clipped.
            isClipped = $1e2677a56204a10c$var$clip[coord.type](coordSysClipArea, layout);
            var el = $1e2677a56204a10c$var$elementCreator[coord.type](seriesModel, data, dataIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, false, roundCap);
            if (realtimeSortCfg) /**
         * Force label animation because even if the element is
         * ignored because it's clipped, it may not be clipped after
         * changing order. Then, if not using forceLabelAnimation,
         * the label animation was never started, in which case,
         * the label will be the final value and doesn't have label
         * animation.
         */ el.forceLabelAnimation = true;
            $1e2677a56204a10c$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $1e2677a56204a10c$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, dataIndex, isHorizontalOrRadial, false, false);
            else (0, $d2a962ec0ef14a79$export$a121566aadcfe021)(el, {
                shape: layout
            }, seriesModel, dataIndex);
            data.setItemGraphicEl(dataIndex, el);
            group.add(el);
            el.ignore = isClipped;
        }).update(function(newIndex, oldIndex) {
            var itemModel = data.getItemModel(newIndex);
            var layout = $1e2677a56204a10c$var$getLayout[coord.type](data, newIndex, itemModel);
            if (!layout) return;
            if (drawBackground) {
                var bgEl = void 0;
                if (oldBgEls.length === 0) bgEl = createBackground(oldIndex);
                else {
                    bgEl = oldBgEls[oldIndex];
                    bgEl.useStyle(backgroundModel.getItemStyle());
                    // Only cartesian2d support borderRadius.
                    if (coord.type === 'cartesian2d') bgEl.setShape('r', barBorderRadius);
                    else bgEl.setShape('cornerRadius', barBorderRadius);
                    bgEls[newIndex] = bgEl;
                }
                var bgLayout = $1e2677a56204a10c$var$getLayout[coord.type](data, newIndex);
                var shape = $1e2677a56204a10c$var$createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
                (0, $d2a962ec0ef14a79$export$c8dce3c08436e91e)(bgEl, {
                    shape: shape
                }, animationModel, newIndex);
            }
            var el = oldData.getItemGraphicEl(oldIndex);
            if (!data.hasValue(newIndex) || !$1e2677a56204a10c$var$isValidLayout[coord.type](layout)) {
                group.remove(el);
                return;
            }
            var isClipped = false;
            if (needsClip) {
                isClipped = $1e2677a56204a10c$var$clip[coord.type](coordSysClipArea, layout);
                if (isClipped) group.remove(el);
            }
            var roundCapChanged = el && (el.type === 'sector' && roundCap || el.type === 'sausage' && !roundCap);
            if (roundCapChanged) {
                // roundCap changed, there is no way to use animation from a `sector` to a `sausage` shape,
                // so remove the old one and create a new shape
                el && (0, $d2a962ec0ef14a79$export$6d0fd725cb4aee8a)(el, seriesModel, oldIndex);
                el = null;
            }
            if (!el) el = $1e2677a56204a10c$var$elementCreator[coord.type](seriesModel, data, newIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, true, roundCap);
            else (0, $d2a962ec0ef14a79$export$bca7290a9faf0ec9)(el);
            if (realtimeSortCfg) el.forceLabelAnimation = true;
            if (isChangeOrder) {
                var textEl = el.getTextContent();
                if (textEl) {
                    var labelInnerStore = (0, $1ee9c8b909b7ca82$export$f62786d3261ab0f4)(textEl);
                    if (labelInnerStore.prevValue != null) /**
             * Set preValue to be value so that no new label
             * should be started, otherwise, it will take a full
             * `animationDurationUpdate` time to finish the
             * animation, which is not expected.
             */ labelInnerStore.prevValue = labelInnerStore.value;
                }
            } else $1e2677a56204a10c$var$updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $1e2677a56204a10c$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, newIndex, isHorizontalOrRadial, true, isChangeOrder);
            else (0, $d2a962ec0ef14a79$export$c8dce3c08436e91e)(el, {
                shape: layout
            }, seriesModel, newIndex, null);
            data.setItemGraphicEl(newIndex, el);
            el.ignore = isClipped;
            group.add(el);
        }).remove(function(dataIndex) {
            var el = oldData.getItemGraphicEl(dataIndex);
            el && (0, $d2a962ec0ef14a79$export$6d0fd725cb4aee8a)(el, seriesModel, dataIndex);
        }).execute();
        var bgGroup = this._backgroundGroup || (this._backgroundGroup = new (0, $ac4abc1f547da31a$export$2e2bcd8739ae039)());
        bgGroup.removeAll();
        for(var i = 0; i < bgEls.length; ++i)bgGroup.add(bgEls[i]);
        group.add(bgGroup);
        this._backgroundEls = bgEls;
        this._data = data;
    };
    BarView.prototype._renderLarge = function(seriesModel, ecModel, api) {
        this._clear();
        $1e2677a56204a10c$var$createLarge(seriesModel, this.group);
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype._incrementalRenderLarge = function(params, seriesModel) {
        this._removeBackground();
        $1e2677a56204a10c$var$createLarge(seriesModel, this.group, this._progressiveEls, true);
    };
    BarView.prototype._updateLargeClip = function(seriesModel) {
        // Use clipPath in large mode.
        var clipPath = seriesModel.get('clip', true) && (0, $dcdbcc2842504ab5$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel);
        var group = this.group;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
    };
    BarView.prototype._enableRealtimeSort = function(realtimeSortCfg, data, api) {
        var _this = this;
        // If no data in the first frame, wait for data to initSort
        if (!data.count()) return;
        var baseAxis = realtimeSortCfg.baseAxis;
        if (this._isFirstFrame) {
            this._dispatchInitSort(data, realtimeSortCfg, api);
            this._isFirstFrame = false;
        } else {
            var orderMapping_1 = function orderMapping_1(idx) {
                var el = data.getItemGraphicEl(idx);
                var shape = el && el.shape;
                return shape && // The result should be consistent with the initial sort by data value.
                // Do not support the case that both positive and negative exist.
                Math.abs(baseAxis.isHorizontal() ? shape.height : shape.width) || 0;
            };
            this._onRendered = function() {
                _this._updateSortWithinSameData(data, orderMapping_1, baseAxis, api);
            };
            api.getZr().on('rendered', this._onRendered);
        }
    };
    BarView.prototype._dataSort = function(data, baseAxis, orderMapping) {
        var info = [];
        data.each(data.mapDimension(baseAxis.dim), function(ordinalNumber, dataIdx) {
            var mappedValue = orderMapping(dataIdx);
            mappedValue = mappedValue == null ? NaN : mappedValue;
            info.push({
                dataIndex: dataIdx,
                mappedValue: mappedValue,
                ordinalNumber: ordinalNumber
            });
        });
        info.sort(function(a, b) {
            // If NaN, it will be treated as min val.
            return b.mappedValue - a.mappedValue;
        });
        return {
            ordinalNumbers: (0, $f16f2994a32ad273$export$871de8747c9eaa88)(info, function(item) {
                return item.ordinalNumber;
            })
        };
    };
    BarView.prototype._isOrderChangedWithinSameData = function(data, orderMapping, baseAxis) {
        var scale = baseAxis.scale;
        var ordinalDataDim = data.mapDimension(baseAxis.dim);
        var lastValue = Number.MAX_VALUE;
        for(var tickNum = 0, len = scale.getOrdinalMeta().categories.length; tickNum < len; ++tickNum){
            var rawIdx = data.rawIndexOf(ordinalDataDim, scale.getRawOrdinalNumber(tickNum));
            var value = rawIdx < 0 ? Number.MIN_VALUE : orderMapping(data.indexOfRawIndex(rawIdx));
            if (value > lastValue) return true;
            lastValue = value;
        }
        return false;
    };
    /*
   * Consider the case when A and B changed order, whose representing
   * bars are both out of sight, we don't wish to trigger reorder action
   * as long as the order in the view doesn't change.
   */ BarView.prototype._isOrderDifferentInView = function(orderInfo, baseAxis) {
        var scale = baseAxis.scale;
        var extent = scale.getExtent();
        var tickNum = Math.max(0, extent[0]);
        var tickMax = Math.min(extent[1], scale.getOrdinalMeta().categories.length - 1);
        for(; tickNum <= tickMax; ++tickNum){
            if (orderInfo.ordinalNumbers[tickNum] !== scale.getRawOrdinalNumber(tickNum)) return true;
        }
    };
    BarView.prototype._updateSortWithinSameData = function(data, orderMapping, baseAxis, api) {
        if (!this._isOrderChangedWithinSameData(data, orderMapping, baseAxis)) return;
        var sortInfo = this._dataSort(data, baseAxis, orderMapping);
        if (this._isOrderDifferentInView(sortInfo, baseAxis)) {
            this._removeOnRenderedListener(api);
            api.dispatchAction({
                type: 'changeAxisOrder',
                componentType: baseAxis.dim + 'Axis',
                axisId: baseAxis.index,
                sortInfo: sortInfo
            });
        }
    };
    BarView.prototype._dispatchInitSort = function(data, realtimeSortCfg, api) {
        var baseAxis = realtimeSortCfg.baseAxis;
        var sortResult = this._dataSort(data, baseAxis, function(dataIdx) {
            return data.get(data.mapDimension(realtimeSortCfg.otherAxis.dim), dataIdx);
        });
        api.dispatchAction({
            type: 'changeAxisOrder',
            componentType: baseAxis.dim + 'Axis',
            isInitSort: true,
            axisId: baseAxis.index,
            sortInfo: sortResult
        });
    };
    BarView.prototype.remove = function(ecModel, api) {
        this._clear(this._model);
        this._removeOnRenderedListener(api);
    };
    BarView.prototype.dispose = function(ecModel, api) {
        this._removeOnRenderedListener(api);
    };
    BarView.prototype._removeOnRenderedListener = function(api) {
        if (this._onRendered) {
            api.getZr().off('rendered', this._onRendered);
            this._onRendered = null;
        }
    };
    BarView.prototype._clear = function(model) {
        var group = this.group;
        var data = this._data;
        if (model && model.isAnimationEnabled() && data && !this._isLargeDraw) {
            this._removeBackground();
            this._backgroundEls = [];
            data.eachItemGraphicEl(function(el) {
                (0, $d2a962ec0ef14a79$export$6d0fd725cb4aee8a)(el, model, (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(el).dataIndex);
            });
        } else group.removeAll();
        this._data = null;
        this._isFirstFrame = true;
    };
    BarView.prototype._removeBackground = function() {
        this.group.remove(this._backgroundGroup);
        this._backgroundGroup = null;
    };
    BarView.type = (0, $1d243d9d64281796$export$c34a2bf62ca07d83);
    return BarView;
}((0, $3644e1b3c8e5afa0$export$2e2bcd8739ae039));
var $1e2677a56204a10c$var$clip = {
    cartesian2d: function cartesian2d(coordSysClipArea, layout) {
        var signWidth = layout.width < 0 ? -1 : 1;
        var signHeight = layout.height < 0 ? -1 : 1;
        // Needs positive width and height
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        var coordSysX2 = coordSysClipArea.x + coordSysClipArea.width;
        var coordSysY2 = coordSysClipArea.y + coordSysClipArea.height;
        var x = $1e2677a56204a10c$var$mathMax(layout.x, coordSysClipArea.x);
        var x2 = $1e2677a56204a10c$var$mathMin(layout.x + layout.width, coordSysX2);
        var y = $1e2677a56204a10c$var$mathMax(layout.y, coordSysClipArea.y);
        var y2 = $1e2677a56204a10c$var$mathMin(layout.y + layout.height, coordSysY2);
        var xClipped = x2 < x;
        var yClipped = y2 < y;
        // When xClipped or yClipped, the element will be marked as `ignore`.
        // But we should also place the element at the edge of the coord sys bounding rect.
        // Because if data changed and the bar shows again, its transition animation
        // will begin at this place.
        layout.x = xClipped && x > coordSysX2 ? x2 : x;
        layout.y = yClipped && y > coordSysY2 ? y2 : y;
        layout.width = xClipped ? 0 : x2 - x;
        layout.height = yClipped ? 0 : y2 - y;
        // Reverse back
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        return xClipped || yClipped;
    },
    polar: function polar(coordSysClipArea, layout) {
        var signR = layout.r0 <= layout.r ? 1 : -1;
        // Make sure r is larger than r0
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        var r = $1e2677a56204a10c$var$mathMin(layout.r, coordSysClipArea.r);
        var r0 = $1e2677a56204a10c$var$mathMax(layout.r0, coordSysClipArea.r0);
        layout.r = r;
        layout.r0 = r0;
        var clipped = r - r0 < 0;
        // Reverse back
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        return clipped;
    }
};
var $1e2677a56204a10c$var$elementCreator = {
    cartesian2d: function cartesian2d(seriesModel, data, newIndex, layout, isHorizontal, animationModel, axisModel, isUpdate, roundCap) {
        var rect = new (0, $dbd6d77105f10fb2$export$2e2bcd8739ae039)({
            shape: (0, $f16f2994a32ad273$export$8b58be045bf06082)({}, layout),
            z2: 1
        });
        rect.__dataIndex = newIndex;
        rect.name = 'item';
        if (animationModel) {
            var rectShape = rect.shape;
            var animateProperty = isHorizontal ? 'height' : 'width';
            rectShape[animateProperty] = 0;
        }
        return rect;
    },
    polar: function polar(seriesModel, data, newIndex, layout, isRadial, animationModel, axisModel, isUpdate, roundCap) {
        var ShapeClass = !isRadial && roundCap ? (0, $21bba6d0cd83301a$export$2e2bcd8739ae039) : (0, $ace53cc79acf5001$export$2e2bcd8739ae039);
        var sector = new ShapeClass({
            shape: layout,
            z2: 1
        });
        sector.name = 'item';
        var positionMap = $1e2677a56204a10c$var$createPolarPositionMapping(isRadial);
        sector.calculateTextPosition = (0, $65a8dd0571c641ba$export$359a1e2d210ed734)(positionMap, {
            isRoundCap: ShapeClass === (0, $21bba6d0cd83301a$export$2e2bcd8739ae039)
        });
        // Animation
        if (animationModel) {
            var sectorShape = sector.shape;
            var animateProperty = isRadial ? 'r' : 'endAngle';
            var animateTarget = {};
            sectorShape[animateProperty] = isRadial ? layout.r0 : layout.startAngle;
            animateTarget[animateProperty] = layout[animateProperty];
            (isUpdate ? (0, $d2a962ec0ef14a79$export$c8dce3c08436e91e) : (0, $d2a962ec0ef14a79$export$a121566aadcfe021))(sector, {
                shape: animateTarget
            }, animationModel);
        }
        return sector;
    }
};
function $1e2677a56204a10c$var$shouldRealtimeSort(seriesModel, coordSys) {
    var realtimeSortOption = seriesModel.get('realtimeSort', true);
    var baseAxis = coordSys.getBaseAxis();
    if (realtimeSortOption && baseAxis.type === 'category' && coordSys.type === 'cartesian2d') return {
        baseAxis: baseAxis,
        otherAxis: coordSys.getOtherAxis(baseAxis)
    };
}
function $1e2677a56204a10c$var$updateRealtimeAnimation(realtimeSortCfg, seriesAnimationModel, el, layout, newIndex, isHorizontal, isUpdate, isChangeOrder) {
    var seriesTarget;
    var axisTarget;
    if (isHorizontal) {
        axisTarget = {
            x: layout.x,
            width: layout.width
        };
        seriesTarget = {
            y: layout.y,
            height: layout.height
        };
    } else {
        axisTarget = {
            y: layout.y,
            height: layout.height
        };
        seriesTarget = {
            x: layout.x,
            width: layout.width
        };
    }
    if (!isChangeOrder) // Keep the original growth animation if only axis order changed.
    // Not start a new animation.
    (isUpdate ? (0, $d2a962ec0ef14a79$export$c8dce3c08436e91e) : (0, $d2a962ec0ef14a79$export$a121566aadcfe021))(el, {
        shape: seriesTarget
    }, seriesAnimationModel, newIndex, null);
    var axisAnimationModel = seriesAnimationModel ? realtimeSortCfg.baseAxis.model : null;
    (isUpdate ? (0, $d2a962ec0ef14a79$export$c8dce3c08436e91e) : (0, $d2a962ec0ef14a79$export$a121566aadcfe021))(el, {
        shape: axisTarget
    }, axisAnimationModel, newIndex);
}
function $1e2677a56204a10c$var$checkPropertiesNotValid(obj, props) {
    for(var i = 0; i < props.length; i++){
        if (!isFinite(obj[props[i]])) return true;
    }
    return false;
}
var $1e2677a56204a10c$var$rectPropties = [
    'x',
    'y',
    'width',
    'height'
];
var $1e2677a56204a10c$var$polarPropties = [
    'cx',
    'cy',
    'r',
    'startAngle',
    'endAngle'
];
var $1e2677a56204a10c$var$isValidLayout = {
    cartesian2d: function cartesian2d(layout) {
        return !$1e2677a56204a10c$var$checkPropertiesNotValid(layout, $1e2677a56204a10c$var$rectPropties);
    },
    polar: function polar(layout) {
        return !$1e2677a56204a10c$var$checkPropertiesNotValid(layout, $1e2677a56204a10c$var$polarPropties);
    }
};
var $1e2677a56204a10c$var$getLayout = {
    // itemModel is only used to get borderWidth, which is not needed
    // when calculating bar background layout.
    cartesian2d: function cartesian2d(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        if (!layout) return null;
        var fixedLineWidth = itemModel ? $1e2677a56204a10c$var$getLineWidth(itemModel, layout) : 0;
        // fix layout with lineWidth
        var signX = layout.width > 0 ? 1 : -1;
        var signY = layout.height > 0 ? 1 : -1;
        return {
            x: layout.x + signX * fixedLineWidth / 2,
            y: layout.y + signY * fixedLineWidth / 2,
            width: layout.width - signX * fixedLineWidth,
            height: layout.height - signY * fixedLineWidth
        };
    },
    polar: function polar(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        return {
            cx: layout.cx,
            cy: layout.cy,
            r0: layout.r0,
            r: layout.r,
            startAngle: layout.startAngle,
            endAngle: layout.endAngle,
            clockwise: layout.clockwise
        };
    }
};
function $1e2677a56204a10c$var$isZeroOnPolar(layout) {
    return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
}
function $1e2677a56204a10c$var$createPolarPositionMapping(isRadial) {
    return function(isRadial) {
        var arcOrAngle = isRadial ? 'Arc' : 'Angle';
        return function(position) {
            switch(position){
                case 'start':
                case 'insideStart':
                case 'end':
                case 'insideEnd':
                    return position + arcOrAngle;
                default:
                    return position;
            }
        };
    }(isRadial);
}
function $1e2677a56204a10c$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, isPolar) {
    var style = data.getItemVisual(dataIndex, 'style');
    if (!isPolar) {
        var borderRadius = itemModel.get([
            'itemStyle',
            'borderRadius'
        ]) || 0;
        el.setShape('r', borderRadius);
    } else if (!seriesModel.get('roundCap')) {
        var sectorShape = el.shape;
        var cornerRadius = (0, $52dd02ed38778bb0$export$b395eeeb2ad7cce5)(itemModel.getModel('itemStyle'), sectorShape, true);
        (0, $f16f2994a32ad273$export$8b58be045bf06082)(sectorShape, cornerRadius);
        el.setShape(sectorShape);
    }
    el.useStyle(style);
    var cursorStyle = itemModel.getShallow('cursor');
    cursorStyle && el.attr('cursor', cursorStyle);
    var labelPositionOutside = isPolar ? isHorizontalOrRadial ? layout.r >= layout.r0 ? 'endArc' : 'startArc' : layout.endAngle >= layout.startAngle ? 'endAngle' : 'startAngle' : isHorizontalOrRadial ? $1e2677a56204a10c$var$getLabelPositionForHorizontal(layout, seriesModel.coordinateSystem) : $1e2677a56204a10c$var$getLabelPositionForVertical(layout, seriesModel.coordinateSystem);
    var labelStatesModels = (0, $1ee9c8b909b7ca82$export$9739a32674be5893)(itemModel);
    (0, $1ee9c8b909b7ca82$export$9a13992917966657)(el, labelStatesModels, {
        labelFetcher: seriesModel,
        labelDataIndex: dataIndex,
        defaultText: (0, $31fd0a507fb966a7$export$5ff20667590927ed)(seriesModel.getData(), dataIndex),
        inheritColor: style.fill,
        defaultOpacity: style.opacity,
        defaultOutsidePosition: labelPositionOutside
    });
    var label = el.getTextContent();
    if (isPolar && label) {
        var position = itemModel.get([
            'label',
            'position'
        ]);
        el.textConfig.inside = position === 'middle' ? true : null;
        (0, $65a8dd0571c641ba$export$672ce504c0db395a)(el, position === 'outside' ? labelPositionOutside : position, $1e2677a56204a10c$var$createPolarPositionMapping(isHorizontalOrRadial), itemModel.get([
            'label',
            'rotate'
        ]));
    }
    (0, $1ee9c8b909b7ca82$export$7bdbceaf9ab378f2)(label, labelStatesModels, seriesModel.getRawValue(dataIndex), function(value) {
        return (0, $31fd0a507fb966a7$export$5f84815e91ca6775)(data, value);
    });
    var emphasisModel = itemModel.getModel([
        'emphasis'
    ]);
    (0, $1f99b77b45f30655$export$e51187539ff11209)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    (0, $1f99b77b45f30655$export$48b68047d330bbc9)(el, itemModel);
    if ($1e2677a56204a10c$var$isZeroOnPolar(layout)) {
        el.style.fill = 'none';
        el.style.stroke = 'none';
        (0, $f16f2994a32ad273$export$79b2f7037acddd43)(el.states, function(state) {
            if (state.style) state.style.fill = state.style.stroke = 'none';
        });
    }
}
// In case width or height are too small.
function $1e2677a56204a10c$var$getLineWidth(itemModel, rawLayout) {
    // Has no border.
    var borderColor = itemModel.get([
        'itemStyle',
        'borderColor'
    ]);
    if (!borderColor || borderColor === 'none') return 0;
    var lineWidth = itemModel.get([
        'itemStyle',
        'borderWidth'
    ]) || 0;
    // width or height may be NaN for empty data
    var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
    var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
    return Math.min(lineWidth, width, height);
}
var $1e2677a56204a10c$var$LagePathShape = /** @class */ function() {
    function LagePathShape() {}
    return LagePathShape;
}();
var $1e2677a56204a10c$var$LargePath = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(LargePath, _super);
    function LargePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'largeBar';
        return _this;
    }
    LargePath.prototype.getDefaultShape = function() {
        return new $1e2677a56204a10c$var$LagePathShape();
    };
    LargePath.prototype.buildPath = function(ctx, shape) {
        // Drawing lines is more efficient than drawing
        // a whole line or drawing rects.
        var points = shape.points;
        var baseDimIdx = this.baseDimIdx;
        var valueDimIdx = 1 - this.baseDimIdx;
        var startPoint = [];
        var size = [];
        var barWidth = this.barWidth;
        for(var i = 0; i < points.length; i += 3){
            size[baseDimIdx] = barWidth;
            size[valueDimIdx] = points[i + 2];
            startPoint[baseDimIdx] = points[i + baseDimIdx];
            startPoint[valueDimIdx] = points[i + valueDimIdx];
            ctx.rect(startPoint[0], startPoint[1], size[0], size[1]);
        }
    };
    return LargePath;
}((0, $340211037b56ba3f$export$2e2bcd8739ae039));
function $1e2677a56204a10c$var$createLarge(seriesModel, group, progressiveEls, incremental) {
    // TODO support polar
    var data = seriesModel.getData();
    var baseDimIdx = data.getLayout('valueAxisHorizontal') ? 1 : 0;
    var largeDataIndices = data.getLayout('largeDataIndices');
    var barWidth = data.getLayout('size');
    var backgroundModel = seriesModel.getModel('backgroundStyle');
    var bgPoints = data.getLayout('largeBackgroundPoints');
    var incrementalId = incremental ? (0, $3fa81475350067fd$export$4496820b7f3d3e98)(seriesModel) : 0;
    if (bgPoints) {
        var bgEl = new $1e2677a56204a10c$var$LargePath({
            shape: {
                points: bgPoints
            },
            incremental: incrementalId,
            silent: true,
            z2: 0
        });
        bgEl.baseDimIdx = baseDimIdx;
        bgEl.largeDataIndices = largeDataIndices;
        bgEl.barWidth = barWidth;
        bgEl.useStyle(backgroundModel.getItemStyle());
        group.add(bgEl);
        progressiveEls && progressiveEls.push(bgEl);
    }
    var el = new $1e2677a56204a10c$var$LargePath({
        shape: {
            points: data.getLayout('largePoints')
        },
        incremental: incrementalId,
        ignoreCoarsePointer: true,
        z2: 1
    });
    el.baseDimIdx = baseDimIdx;
    el.largeDataIndices = largeDataIndices;
    el.barWidth = barWidth;
    group.add(el);
    el.useStyle(data.getVisual('style'));
    // Stroke is rendered first to avoid overlapping with fill. See #20465
    el.style.stroke = null;
    // Enable tooltip and user mouse/touch event handlers.
    (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(el).seriesIndex = seriesModel.seriesIndex;
    if (!seriesModel.get('silent')) {
        el.on('mousedown', $1e2677a56204a10c$var$largePathUpdateDataIndex);
        el.on('mousemove', $1e2677a56204a10c$var$largePathUpdateDataIndex);
    }
    progressiveEls && progressiveEls.push(el);
}
// Use throttle to avoid frequently traverse to find dataIndex.
var $1e2677a56204a10c$var$largePathUpdateDataIndex = (0, $fcd7567e9010c0f5$export$de363e709c412c8a)(function(event) {
    var largePath = this;
    var dataIndex = $1e2677a56204a10c$var$largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
    (0, $813d173718eca8f1$export$b1c39b2bacd1ddc2)(largePath).dataIndex = dataIndex >= 0 ? dataIndex : null;
}, 30, false);
function $1e2677a56204a10c$var$largePathFindDataIndex(largePath, x, y) {
    var baseDimIdx = largePath.baseDimIdx;
    var valueDimIdx = 1 - baseDimIdx;
    var points = largePath.shape.points;
    var largeDataIndices = largePath.largeDataIndices;
    var startPoint = [];
    var size = [];
    var barWidth = largePath.barWidth;
    for(var i = 0, len = points.length / 3; i < len; i++){
        var ii = i * 3;
        size[baseDimIdx] = barWidth;
        size[valueDimIdx] = points[ii + 2];
        startPoint[baseDimIdx] = points[ii + baseDimIdx];
        startPoint[valueDimIdx] = points[ii + valueDimIdx];
        if (size[valueDimIdx] < 0) {
            startPoint[valueDimIdx] += size[valueDimIdx];
            size[valueDimIdx] = -size[valueDimIdx];
        }
        if (x >= startPoint[0] && x <= startPoint[0] + size[0] && y >= startPoint[1] && y <= startPoint[1] + size[1]) return largeDataIndices[i];
    }
    return -1;
}
function $1e2677a56204a10c$var$createBackgroundShape(isHorizontalOrRadial, layout, coord) {
    if ((0, $5456f1f0fd55689a$export$8567506e6336616)(coord, 'cartesian2d')) {
        var rectShape = layout;
        var coordLayout = coord.getArea();
        return {
            x: isHorizontalOrRadial ? rectShape.x : coordLayout.x,
            y: isHorizontalOrRadial ? coordLayout.y : rectShape.y,
            width: isHorizontalOrRadial ? rectShape.width : coordLayout.width,
            height: isHorizontalOrRadial ? coordLayout.height : rectShape.height
        };
    } else {
        var coordLayout = coord.getArea();
        var sectorShape = layout;
        return {
            cx: coordLayout.cx,
            cy: coordLayout.cy,
            r0: isHorizontalOrRadial ? coordLayout.r0 : sectorShape.r0,
            r: isHorizontalOrRadial ? coordLayout.r : sectorShape.r,
            startAngle: isHorizontalOrRadial ? sectorShape.startAngle : 0,
            endAngle: isHorizontalOrRadial ? sectorShape.endAngle : Math.PI * 2
        };
    }
}
function $1e2677a56204a10c$var$createBackgroundEl(coord, isHorizontalOrRadial, layout) {
    var ElementClz = coord.type === 'polar' ? (0, $ace53cc79acf5001$export$2e2bcd8739ae039) : (0, $dbd6d77105f10fb2$export$2e2bcd8739ae039);
    return new ElementClz({
        shape: $1e2677a56204a10c$var$createBackgroundShape(isHorizontalOrRadial, layout, coord),
        silent: true,
        z2: 0
    });
}
function $1e2677a56204a10c$var$getLabelPositionForHorizontal(layout, coordSys) {
    if (layout.height === 0) {
        // For zero height, determine position based on axis inverse status
        var valueAxis = coordSys.getOtherAxis(coordSys.getBaseAxis());
        return valueAxis.inverse ? 'bottom' : 'top';
    }
    return layout.height > 0 ? 'bottom' : 'top';
}
function $1e2677a56204a10c$var$getLabelPositionForVertical(layout, coordSys) {
    if (layout.width === 0) {
        // For zero width, determine position based on axis inverse status
        var valueAxis = coordSys.getOtherAxis(coordSys.getBaseAxis());
        return valueAxis.inverse ? 'left' : 'right';
    }
    return layout.width >= 0 ? 'right' : 'left';
}
var $1e2677a56204a10c$export$2e2bcd8739ae039 = $1e2677a56204a10c$var$BarView;



function $ed9b0f7b1a5629ab$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $1e2677a56204a10c$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $52a29a39e7d43a81$export$2e2bcd8739ae039));
    registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, (0, $c6c6cd7fb79dc955$export$13922fb2a9d75502)((0, $1d243d9d64281796$export$c34a2bf62ca07d83)));
    // Do layout after other overall layout, which can prepare some information.
    registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, (0, $c6c6cd7fb79dc955$export$16e8685758531cb6)((0, $1d243d9d64281796$export$c34a2bf62ca07d83)));
    // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $197506e926d2cf99$export$2e2bcd8739ae039)((0, $1d243d9d64281796$export$c34a2bf62ca07d83)));
    /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */ registers.registerAction({
        type: 'changeAxisOrder',
        event: 'changeAxisOrder',
        update: 'update'
    }, function(payload, ecModel) {
        var componentType = payload.componentType || 'series';
        ecModel.eachComponent({
            mainType: componentType,
            query: payload
        }, function(componentModel) {
            if (payload.sortInfo) componentModel.axis.setCategorySortInfo(payload.sortInfo);
        });
    });
    (0, $c6c6cd7fb79dc955$export$f94e305d0960f41c)(registers);
}




var $33a5652a9cc9c0d3$var$_a;
(0, $5b64c22a7e1cb8f6$export$1f96ae73734a86cc)((0, $ed9b0f7b1a5629ab$export$4b3e715f166fdd78));
var $33a5652a9cc9c0d3$export$66307e3e8fac7e52 = /*#__PURE__*/ function(ECOptionElement) {
    "use strict";
    (0, $hdIku._)(ECBarChart, ECOptionElement);
    function ECBarChart() {
        (0, $173N4._)(this, ECBarChart);
        return (0, $7qXGD._)(this, ECBarChart, arguments);
    }
    return ECBarChart;
}((0, $6f6095288b1fca4a$export$37de6f71bb86a769));
($33a5652a9cc9c0d3$var$_a = globalThis.customElements) === null || $33a5652a9cc9c0d3$var$_a === void 0 || $33a5652a9cc9c0d3$var$_a.define('ec-bar-chart', $33a5652a9cc9c0d3$export$66307e3e8fac7e52);



var $tLNoZ = parcelRequire("tLNoZ");
parcelRequire("2ZsbG");
parcelRequire("knnJU");
parcelRequire("3RSag");
parcelRequire("fHM7w");

var $cc348b2c5175bcb1$export$c489dd2bd24850e4 = function(param) {
    var title = param.title, children = param.children;
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $tLNoZ.Fragment), {
        children: [
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("h2", {
                className: "mt-3",
                children: title
            }),
            children,
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $baaeda96f7555c00$exports.CodeBlock), {
                language: "tsx",
                children: children
            })
        ]
    });
};


var $2e53d2ece788bedf$export$200ed0c9cbeb911a = undefined;
function $2e53d2ece788bedf$var$_createMdxContent(props) {
    var _components = (0, $1XAnY._)({
        a: "a",
        h1: "h1",
        p: "p"
    }, props.components);
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $tLNoZ.Fragment), {
        children: [
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(_components.h1, {
                children: "Charts in Markdown"
            }),
            "\n",
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(_components.p, {
                children: [
                    "This example is based on ",
                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(_components.a, {
                        href: "https://github.com/idea2app/ECharts-JSX",
                        children: "ECharts-JSX"
                    }),
                    " & ",
                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(_components.a, {
                        href: "https://github.com/EasyWebApp/Parcel-transformer-MDX",
                        children: "Parcel-transformer-MDX"
                    }),
                    "."
                ]
            }),
            "\n",
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $cc348b2c5175bcb1$export$c489dd2bd24850e4), {
                title: "ECharts example",
                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("ec-svg-renderer", {
                    style: {
                        height: '80vh'
                    },
                    onClick: console.log,
                    children: [
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("ec-title", {
                            text: "ECharts example"
                        }),
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("ec-legend", {
                            data: [
                                'sales'
                            ]
                        }),
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("ec-tooltip", {}),
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("ec-x-axis", {
                            data: [
                                'Shirts',
                                'Cardigans',
                                'Chiffons',
                                'Pants',
                                'Heels',
                                'Socks'
                            ]
                        }),
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("ec-y-axis", {}),
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("ec-bar-chart", {
                            name: "sales",
                            data: [
                                5,
                                20,
                                36,
                                10,
                                10,
                                20
                            ],
                            onClick: console.log
                        })
                    ]
                })
            })
        ]
    });
}
function $2e53d2ece788bedf$export$2e2bcd8739ae039() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _ref = props.components || {}, MDXLayout = _ref.wrapper;
    return MDXLayout ? (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(MDXLayout, (0, $6fpqi._)((0, $1XAnY._)({}, props), {
        children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($2e53d2ece788bedf$var$_createMdxContent, (0, $1XAnY._)({}, props))
    })) : $2e53d2ece788bedf$var$_createMdxContent(props);
}






var $d1b3805234fdf37f$exports = {};

var $tLNoZ = parcelRequire("tLNoZ");





var $3gP77 = parcelRequire("3gP77");

var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7Pjls = parcelRequire("7Pjls");

var $dWsrg = parcelRequire("dWsrg");

var $kg0zo = parcelRequire("kg0zo");

var $hdIku = parcelRequire("hdIku");


var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $13u2V = parcelRequire("13u2V");

var $3gP77 = parcelRequire("3gP77");

var $aUGqu = parcelRequire("aUGqu");

var $13u2V = parcelRequire("13u2V");
var $e0062df735681f1b$export$5f747a46dc0eb6ee = function() {
    if ("undefined" == typeof self) return !1;
    if ("top" in self && self !== top) try {
        top.window.document._ = 0;
    } catch (e) {
        return !1;
    }
    return "showOpenFilePicker" in self;
}(), $e0062df735681f1b$var$t = $e0062df735681f1b$export$5f747a46dc0eb6ee ? Promise.resolve().then(function() {
    return $e0062df735681f1b$var$c;
}) : Promise.resolve().then(function() {
    return $e0062df735681f1b$var$h;
});
function $e0062df735681f1b$export$c1bd535e520dbbc3() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var _instance;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $e0062df735681f1b$var$t
                    ];
                case 1:
                    return [
                        2,
                        (_instance = _state.sent()).default.apply(_instance, (0, $aUGqu._)(e))
                    ];
            }
        });
    })();
}
var $e0062df735681f1b$var$r = $e0062df735681f1b$export$5f747a46dc0eb6ee ? Promise.resolve().then(function() {
    return $e0062df735681f1b$var$y;
}) : Promise.resolve().then(function() {
    return $e0062df735681f1b$var$b;
});
function $e0062df735681f1b$export$270aed3754275094() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var _instance;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $e0062df735681f1b$var$r
                    ];
                case 1:
                    return [
                        2,
                        (_instance = _state.sent()).default.apply(_instance, (0, $aUGqu._)(e))
                    ];
            }
        });
    })();
}
var $e0062df735681f1b$var$a = $e0062df735681f1b$export$5f747a46dc0eb6ee ? Promise.resolve().then(function() {
    return $e0062df735681f1b$var$m;
}) : Promise.resolve().then(function() {
    return $e0062df735681f1b$var$_;
});
function $e0062df735681f1b$export$cf414c79194c40b9() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var _instance;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $e0062df735681f1b$var$a
                    ];
                case 1:
                    return [
                        2,
                        (_instance = _state.sent()).default.apply(_instance, (0, $aUGqu._)(e))
                    ];
            }
        });
    })();
}
var $e0062df735681f1b$var$s = function(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var t;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        e.getFile()
                    ];
                case 1:
                    t = _state.sent();
                    return [
                        2,
                        (t.handle = e, t)
                    ];
            }
        });
    })();
};
var $e0062df735681f1b$export$73dd4a3df259d52 = function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
        {}
    ];
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var t, n, r;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    Array.isArray(e) || (e = [
                        e
                    ]);
                    t = [];
                    e.forEach(function(e, n) {
                        t[n] = {
                            description: e.description || "Files",
                            accept: {}
                        }, e.mimeTypes ? e.mimeTypes.map(function(r) {
                            t[n].accept[r] = e.extensions || [];
                        }) : t[n].accept["*/*"] = e.extensions || [];
                    });
                    return [
                        4,
                        window.showOpenFilePicker({
                            id: e[0].id,
                            startIn: e[0].startIn,
                            types: t,
                            multiple: e[0].multiple || !1,
                            excludeAcceptAllOption: e[0].excludeAcceptAllOption || !1
                        })
                    ];
                case 1:
                    n = _state.sent();
                    return [
                        4,
                        Promise.all(n.map($e0062df735681f1b$var$s))
                    ];
                case 2:
                    r = _state.sent();
                    return [
                        2,
                        e[0].multiple ? r : r[0]
                    ];
            }
        });
    })();
}, $e0062df735681f1b$var$c = {
    __proto__: null,
    default: $e0062df735681f1b$export$73dd4a3df259d52
};
function $e0062df735681f1b$var$u(e) {
    function t(e) {
        if (Object(e) !== e) return Promise.reject(new TypeError(e + " is not an object."));
        var t = e.done;
        return Promise.resolve(e.value).then(function(e) {
            return {
                value: e,
                done: t
            };
        });
    }
    return $e0062df735681f1b$var$u = function u(e) {
        this.s = e, this.n = e.next;
    }, $e0062df735681f1b$var$u.prototype = {
        s: null,
        n: null,
        next: function next() {
            return t(this.n.apply(this.s, arguments));
        },
        return: function _return(e) {
            var n = this.s.return;
            return void 0 === n ? Promise.resolve({
                value: e,
                done: !0
            }) : t(n.apply(this.s, arguments));
        },
        throw: function _throw(e) {
            var n = this.s.return;
            return void 0 === n ? Promise.reject(e) : t(n.apply(this.s, arguments));
        }
    }, new $e0062df735681f1b$var$u(e);
}
var $e0062df735681f1b$var$p = function(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e.name, r = arguments.length > 3 ? arguments[3] : void 0;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var i, a, o, s, l, _loop, c, d, e1, _tmp, _, _1;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    i = [], a = [];
                    s = !1, l = !1;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _loop = function() {
                        var o = c.value, s = "".concat(n, "/").concat(o.name);
                        "file" === o.kind ? a.push(o.getFile().then(function(t) {
                            return t.directoryHandle = e, t.handle = o, Object.defineProperty(t, "webkitRelativePath", {
                                configurable: !0,
                                enumerable: !0,
                                get: function() {
                                    return s;
                                }
                            });
                        })) : "directory" !== o.kind || !t || r && r(o) || i.push($e0062df735681f1b$var$p(o, t, s, r));
                    };
                    d = function(e) {
                        var _$t, n, r, i = 2;
                        for("undefined" != typeof Symbol && (n = Symbol.asyncIterator, r = Symbol.iterator); i--;){
                            if (n && null != (_$t = e[n])) return _$t.call(e);
                            if (r && null != (_$t = e[r])) return new $e0062df735681f1b$var$u(_$t.call(e));
                            n = "@@asyncIterator", r = "@@iterator";
                        }
                        throw new TypeError("Object is not async iterable");
                    }(e.values());
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        d.next()
                    ];
                case 3:
                    if (!(s = !(c = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _loop();
                    _state.label = 4;
                case 4:
                    s = !1;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    e1 = _state.sent();
                    l = !0, o = e1;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    _tmp = s && null != d.return;
                    if (!_tmp) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        d.return()
                    ];
                case 8:
                    _tmp = _state.sent();
                    _state.label = 9;
                case 9:
                    _tmp;
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (l) throw o;
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        4,
                        Promise.all(i)
                    ];
                case 13:
                    _1 = (_ = (0, $aUGqu._).apply(void 0, [
                        _state.sent().flat()
                    ])).concat;
                    return [
                        4,
                        Promise.all(a)
                    ];
                case 14:
                    return [
                        2,
                        _1.apply(_, [
                            (0, $aUGqu._).apply(void 0, [
                                _state.sent()
                            ])
                        ])
                    ];
            }
        });
    })();
};
var $e0062df735681f1b$export$aeb41617a6d6e89 = function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var t;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.recursive = e.recursive || !1, e.mode = e.mode || "read";
                    return [
                        4,
                        window.showDirectoryPicker({
                            id: e.id,
                            startIn: e.startIn,
                            mode: e.mode
                        })
                    ];
                case 1:
                    t = _state.sent();
                    return [
                        4,
                        t.values()
                    ];
                case 2:
                    return [
                        4,
                        _state.sent().next()
                    ];
                case 3:
                    return [
                        2,
                        _state.sent().done ? [
                            t
                        ] : $e0062df735681f1b$var$p(t, e.recursive, void 0, e.skipDirectory)
                    ];
            }
        });
    })();
}, $e0062df735681f1b$var$y = {
    __proto__: null,
    default: $e0062df735681f1b$export$aeb41617a6d6e89
}, $e0062df735681f1b$export$ff17ca902e7337af = function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
        {}
    ], n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var a, o, e1, s, _tmp, l, t1, _tmp1, _;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    Array.isArray(t) || (t = [
                        t
                    ]), t[0].fileName = t[0].fileName || "Untitled";
                    a = [];
                    o = null;
                    if (!(e instanceof Blob && e.type ? o = e.type : e.headers && e.headers.get("content-type") && (o = e.headers.get("content-type")), t.forEach(function(e, t) {
                        a[t] = {
                            description: e.description || "Files",
                            accept: {}
                        }, e.mimeTypes ? (0 === t && o && e.mimeTypes.push(o), e.mimeTypes.map(function(n) {
                            a[t].accept[n] = e.extensions || [];
                        })) : o ? a[t].accept[o] = e.extensions || [] : a[t].accept["*/*"] = e.extensions || [];
                    }), n)) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        n.getFile()
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e1 = _state.sent();
                    if (n = null, r) throw e1;
                    return [
                        3,
                        4
                    ];
                case 4:
                    _tmp = n;
                    if (_tmp) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        window.showSaveFilePicker({
                            suggestedName: t[0].fileName,
                            id: t[0].id,
                            startIn: t[0].startIn,
                            types: a,
                            excludeAcceptAllOption: t[0].excludeAcceptAllOption || !1
                        })
                    ];
                case 5:
                    _tmp = _state.sent();
                    _state.label = 6;
                case 6:
                    s = _tmp;
                    !n && i && i(s);
                    return [
                        4,
                        s.createWritable()
                    ];
                case 7:
                    l = _state.sent();
                    if (!("stream" in e)) return [
                        3,
                        9
                    ];
                    t1 = e.stream();
                    return [
                        4,
                        t1.pipeTo(l)
                    ];
                case 8:
                    return [
                        2,
                        (_state.sent(), s)
                    ];
                case 9:
                    if (!("body" in e)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        e.body.pipeTo(l)
                    ];
                case 10:
                    _tmp1 = (_state.sent(), s);
                    return [
                        3,
                        15
                    ];
                case 11:
                    _ = l.write;
                    return [
                        4,
                        e
                    ];
                case 12:
                    return [
                        4,
                        _.apply(l, [
                            _state.sent()
                        ])
                    ];
                case 13:
                    _state.sent();
                    return [
                        4,
                        l.close()
                    ];
                case 14:
                    _tmp1 = (_state.sent(), s);
                    _state.label = 15;
                case 15:
                    return [
                        2,
                        _tmp1
                    ];
            }
        });
    })();
}, $e0062df735681f1b$var$m = {
    __proto__: null,
    default: $e0062df735681f1b$export$ff17ca902e7337af
}, $e0062df735681f1b$export$f1c676766788056a = function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
        {}
    ];
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        return (0, $13u2V._)(this, function(_state) {
            return [
                2,
                (Array.isArray(e) || (e = [
                    e
                ]), new Promise(function(t, n) {
                    var r = document.createElement("input");
                    r.type = "file";
                    var i = (0, $aUGqu._)(e.map(function(e) {
                        return e.mimeTypes || [];
                    })).concat((0, $aUGqu._)(e.map(function(e) {
                        return e.extensions || [];
                    }))).join();
                    r.multiple = e[0].multiple || !1, r.accept = i || "", r.style.display = "none", document.body.append(r), r.addEventListener("cancel", function() {
                        r.remove(), n(new DOMException("The user aborted a request.", "AbortError"));
                    }), r.addEventListener("change", function() {
                        r.remove(), t(r.multiple ? Array.from(r.files) : r.files[0]);
                    }), "showPicker" in HTMLInputElement.prototype ? r.showPicker() : r.click();
                }))
            ];
        });
    })();
}, $e0062df735681f1b$var$h = {
    __proto__: null,
    default: $e0062df735681f1b$export$f1c676766788056a
}, $e0062df735681f1b$export$14ab45eaad58ab5 = function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
        {}
    ];
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        return (0, $13u2V._)(this, function(_state) {
            return [
                2,
                (Array.isArray(e) || (e = [
                    e
                ]), e[0].recursive = e[0].recursive || !1, new Promise(function(t, n) {
                    var r = document.createElement("input");
                    r.type = "file", r.webkitdirectory = !0, r.style.display = "none", document.body.append(r), r.addEventListener("cancel", function() {
                        r.remove(), n(new DOMException("The user aborted a request.", "AbortError"));
                    }), r.addEventListener("change", function() {
                        r.remove();
                        var n = Array.from(r.files);
                        e[0].recursive ? e[0].recursive && e[0].skipDirectory && (n = n.filter(function(t) {
                            return t.webkitRelativePath.split("/").every(function(t) {
                                return !e[0].skipDirectory({
                                    name: t,
                                    kind: "directory"
                                });
                            });
                        })) : n = n.filter(function(e) {
                            return 2 === e.webkitRelativePath.split("/").length;
                        }), t(n);
                    }), "showPicker" in HTMLInputElement.prototype ? r.showPicker() : r.click();
                }))
            ];
        });
    })();
}, $e0062df735681f1b$var$b = {
    __proto__: null,
    default: $e0062df735681f1b$export$14ab45eaad58ab5
}, $e0062df735681f1b$export$19f956f8dbe9df86 = function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var n, r, _tmp, _, i, a;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    Array.isArray(t) && (t = t[0]);
                    n = document.createElement("a");
                    r = e;
                    _tmp = "body" in e;
                    if (!_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        function(e, t) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                var n, r, i, a;
                                return (0, $13u2V._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            n = e.getReader(), r = new ReadableStream({
                                                start: function(e) {
                                                    return function t() {
                                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                                            return (0, $13u2V._)(this, function(_state) {
                                                                return [
                                                                    2,
                                                                    n.read().then(function(param) {
                                                                        var n = param.done, r = param.value;
                                                                        if (!n) return e.enqueue(r), t();
                                                                        e.close();
                                                                    })
                                                                ];
                                                            });
                                                        })();
                                                    }();
                                                }
                                            }), i = new Response(r);
                                            return [
                                                4,
                                                i.blob()
                                            ];
                                        case 1:
                                            a = _state.sent();
                                            return [
                                                2,
                                                (n.releaseLock(), new Blob([
                                                    a
                                                ], {
                                                    type: t
                                                }))
                                            ];
                                    }
                                });
                            })();
                        }(e.body, e.headers.get("content-type"))
                    ];
                case 1:
                    _tmp = r = _state.sent();
                    _state.label = 2;
                case 2:
                    _tmp, n.download = t.fileName || "Untitled";
                    _ = URL.createObjectURL;
                    return [
                        4,
                        r
                    ];
                case 3:
                    n.href = _.apply(URL, [
                        _state.sent()
                    ]);
                    i = function() {
                        "function" == typeof a && a();
                    }, a = t.legacySetup && t.legacySetup(i, function() {
                        return a();
                    }, n);
                    return [
                        2,
                        (n.addEventListener("click", function() {
                            setTimeout(function() {
                                return URL.revokeObjectURL(n.href);
                            }, 3e4), i();
                        }), n.click(), null)
                    ];
            }
        });
    })();
}, $e0062df735681f1b$var$_ = {
    __proto__: null,
    default: $e0062df735681f1b$export$19f956f8dbe9df86
};


function $075446ebf04f5e91$var$extend(destination) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) destination[key] = source[key];
    }
    return destination;
}
function $075446ebf04f5e91$var$repeat(character, count) {
    return Array(count + 1).join(character);
}
function $075446ebf04f5e91$var$trimLeadingNewlines(string) {
    return string.replace(/^\n*/, '');
}
function $075446ebf04f5e91$var$trimTrailingNewlines(string) {
    // avoid match-at-end regexp bottleneck, see #370
    var indexEnd = string.length;
    while(indexEnd > 0 && string[indexEnd - 1] === '\n')indexEnd--;
    return string.substring(0, indexEnd);
}
function $075446ebf04f5e91$var$trimNewlines(string) {
    return $075446ebf04f5e91$var$trimTrailingNewlines($075446ebf04f5e91$var$trimLeadingNewlines(string));
}
var $075446ebf04f5e91$var$blockElements = [
    'ADDRESS',
    'ARTICLE',
    'ASIDE',
    'AUDIO',
    'BLOCKQUOTE',
    'BODY',
    'CANVAS',
    'CENTER',
    'DD',
    'DIR',
    'DIV',
    'DL',
    'DT',
    'FIELDSET',
    'FIGCAPTION',
    'FIGURE',
    'FOOTER',
    'FORM',
    'FRAMESET',
    'H1',
    'H2',
    'H3',
    'H4',
    'H5',
    'H6',
    'HEADER',
    'HGROUP',
    'HR',
    'HTML',
    'ISINDEX',
    'LI',
    'MAIN',
    'MENU',
    'NAV',
    'NOFRAMES',
    'NOSCRIPT',
    'OL',
    'OUTPUT',
    'P',
    'PRE',
    'SECTION',
    'TABLE',
    'TBODY',
    'TD',
    'TFOOT',
    'TH',
    'THEAD',
    'TR',
    'UL'
];
function $075446ebf04f5e91$var$isBlock(node) {
    return $075446ebf04f5e91$var$is(node, $075446ebf04f5e91$var$blockElements);
}
var $075446ebf04f5e91$var$voidElements = [
    'AREA',
    'BASE',
    'BR',
    'COL',
    'COMMAND',
    'EMBED',
    'HR',
    'IMG',
    'INPUT',
    'KEYGEN',
    'LINK',
    'META',
    'PARAM',
    'SOURCE',
    'TRACK',
    'WBR'
];
function $075446ebf04f5e91$var$isVoid(node) {
    return $075446ebf04f5e91$var$is(node, $075446ebf04f5e91$var$voidElements);
}
function $075446ebf04f5e91$var$hasVoid(node) {
    return $075446ebf04f5e91$var$has(node, $075446ebf04f5e91$var$voidElements);
}
var $075446ebf04f5e91$var$meaningfulWhenBlankElements = [
    'A',
    'TABLE',
    'THEAD',
    'TBODY',
    'TFOOT',
    'TH',
    'TD',
    'IFRAME',
    'SCRIPT',
    'AUDIO',
    'VIDEO'
];
function $075446ebf04f5e91$var$isMeaningfulWhenBlank(node) {
    return $075446ebf04f5e91$var$is(node, $075446ebf04f5e91$var$meaningfulWhenBlankElements);
}
function $075446ebf04f5e91$var$hasMeaningfulWhenBlank(node) {
    return $075446ebf04f5e91$var$has(node, $075446ebf04f5e91$var$meaningfulWhenBlankElements);
}
function $075446ebf04f5e91$var$is(node, tagNames) {
    return tagNames.indexOf(node.nodeName) >= 0;
}
function $075446ebf04f5e91$var$has(node, tagNames) {
    return node.getElementsByTagName && tagNames.some(function(tagName) {
        return node.getElementsByTagName(tagName).length;
    });
}
var $075446ebf04f5e91$var$markdownEscapes = [
    [
        /\\/g,
        '\\\\'
    ],
    [
        /\*/g,
        '\\*'
    ],
    [
        /^-/g,
        '\\-'
    ],
    [
        /^\+ /g,
        '\\+ '
    ],
    [
        /^(=+)/g,
        '\\$1'
    ],
    [
        /^(#{1,6}) /g,
        '\\$1 '
    ],
    [
        /`/g,
        '\\`'
    ],
    [
        /^~~~/g,
        '\\~~~'
    ],
    [
        /\[/g,
        '\\['
    ],
    [
        /\]/g,
        '\\]'
    ],
    [
        /^>/g,
        '\\>'
    ],
    [
        /_/g,
        '\\_'
    ],
    [
        /^(\d+)\. /g,
        '$1\\. '
    ]
];
function $075446ebf04f5e91$var$escapeMarkdown(string) {
    return $075446ebf04f5e91$var$markdownEscapes.reduce(function(accumulator, escape) {
        return accumulator.replace(escape[0], escape[1]);
    }, string);
}
var $075446ebf04f5e91$var$rules = {};
$075446ebf04f5e91$var$rules.paragraph = {
    filter: 'p',
    replacement: function replacement(content) {
        return '\n\n' + content + '\n\n';
    }
};
$075446ebf04f5e91$var$rules.lineBreak = {
    filter: 'br',
    replacement: function replacement(content, node, options) {
        return options.br + '\n';
    }
};
$075446ebf04f5e91$var$rules.heading = {
    filter: [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6'
    ],
    replacement: function replacement(content, node, options) {
        var hLevel = Number(node.nodeName.charAt(1));
        if (options.headingStyle === 'setext' && hLevel < 3) {
            var underline = $075446ebf04f5e91$var$repeat(hLevel === 1 ? '=' : '-', content.length);
            return '\n\n' + content + '\n' + underline + '\n\n';
        } else return '\n\n' + $075446ebf04f5e91$var$repeat('#', hLevel) + ' ' + content + '\n\n';
    }
};
$075446ebf04f5e91$var$rules.blockquote = {
    filter: 'blockquote',
    replacement: function replacement(content) {
        content = $075446ebf04f5e91$var$trimNewlines(content).replace(/^/gm, '> ');
        return '\n\n' + content + '\n\n';
    }
};
$075446ebf04f5e91$var$rules.list = {
    filter: [
        'ul',
        'ol'
    ],
    replacement: function replacement(content, node) {
        var parent = node.parentNode;
        if (parent.nodeName === 'LI' && parent.lastElementChild === node) return '\n' + content;
        else return '\n\n' + content + '\n\n';
    }
};
$075446ebf04f5e91$var$rules.listItem = {
    filter: 'li',
    replacement: function replacement(content, node, options) {
        var prefix = options.bulletListMarker + '   ';
        var parent = node.parentNode;
        if (parent.nodeName === 'OL') {
            var start = parent.getAttribute('start');
            var index = Array.prototype.indexOf.call(parent.children, node);
            prefix = (start ? Number(start) + index : index + 1) + '.  ';
        }
        var isParagraph = /\n$/.test(content);
        content = $075446ebf04f5e91$var$trimNewlines(content) + (isParagraph ? '\n' : '');
        content = content.replace(/\n/gm, '\n' + ' '.repeat(prefix.length)); // indent
        return prefix + content + (node.nextSibling ? '\n' : '');
    }
};
$075446ebf04f5e91$var$rules.indentedCodeBlock = {
    filter: function filter(node, options) {
        return options.codeBlockStyle === 'indented' && node.nodeName === 'PRE' && node.firstChild && node.firstChild.nodeName === 'CODE';
    },
    replacement: function replacement(content, node, options) {
        return '\n\n    ' + node.firstChild.textContent.replace(/\n/g, '\n    ') + '\n\n';
    }
};
$075446ebf04f5e91$var$rules.fencedCodeBlock = {
    filter: function filter(node, options) {
        return options.codeBlockStyle === 'fenced' && node.nodeName === 'PRE' && node.firstChild && node.firstChild.nodeName === 'CODE';
    },
    replacement: function replacement(content, node, options) {
        var className = node.firstChild.getAttribute('class') || '';
        var language = (className.match(/language-(\S+)/) || [
            null,
            ''
        ])[1];
        var code = node.firstChild.textContent;
        var fenceChar = options.fence.charAt(0);
        var fenceSize = 3;
        var fenceInCodeRegex = new RegExp('^' + fenceChar + '{3,}', 'gm');
        var match;
        while(match = fenceInCodeRegex.exec(code))if (match[0].length >= fenceSize) fenceSize = match[0].length + 1;
        var fence = $075446ebf04f5e91$var$repeat(fenceChar, fenceSize);
        return '\n\n' + fence + language + '\n' + code.replace(/\n$/, '') + '\n' + fence + '\n\n';
    }
};
$075446ebf04f5e91$var$rules.horizontalRule = {
    filter: 'hr',
    replacement: function replacement(content, node, options) {
        return '\n\n' + options.hr + '\n\n';
    }
};
$075446ebf04f5e91$var$rules.inlineLink = {
    filter: function filter(node, options) {
        return options.linkStyle === 'inlined' && node.nodeName === 'A' && node.getAttribute('href');
    },
    replacement: function replacement(content, node) {
        var href = $075446ebf04f5e91$var$escapeLinkDestination(node.getAttribute('href'));
        var title = $075446ebf04f5e91$var$escapeLinkTitle($075446ebf04f5e91$var$cleanAttribute(node.getAttribute('title')));
        var titlePart = title ? ' "' + title + '"' : '';
        return '[' + content + '](' + href + titlePart + ')';
    }
};
$075446ebf04f5e91$var$rules.referenceLink = {
    filter: function filter(node, options) {
        return options.linkStyle === 'referenced' && node.nodeName === 'A' && node.getAttribute('href');
    },
    replacement: function replacement(content, node, options) {
        var href = $075446ebf04f5e91$var$escapeLinkDestination(node.getAttribute('href'));
        var title = $075446ebf04f5e91$var$cleanAttribute(node.getAttribute('title'));
        if (title) title = ' "' + $075446ebf04f5e91$var$escapeLinkTitle(title) + '"';
        var replacement;
        var reference;
        switch(options.linkReferenceStyle){
            case 'collapsed':
                replacement = '[' + content + '][]';
                reference = '[' + content + ']: ' + href + title;
                break;
            case 'shortcut':
                replacement = '[' + content + ']';
                reference = '[' + content + ']: ' + href + title;
                break;
            default:
                var id = this.references.length + 1;
                replacement = '[' + content + '][' + id + ']';
                reference = '[' + id + ']: ' + href + title;
        }
        this.references.push(reference);
        return replacement;
    },
    references: [],
    append: function append(options) {
        var references = '';
        if (this.references.length) {
            references = '\n\n' + this.references.join('\n') + '\n\n';
            this.references = []; // Reset references
        }
        return references;
    }
};
$075446ebf04f5e91$var$rules.emphasis = {
    filter: [
        'em',
        'i'
    ],
    replacement: function replacement(content, node, options) {
        if (!content.trim()) return '';
        return options.emDelimiter + content + options.emDelimiter;
    }
};
$075446ebf04f5e91$var$rules.strong = {
    filter: [
        'strong',
        'b'
    ],
    replacement: function replacement(content, node, options) {
        if (!content.trim()) return '';
        return options.strongDelimiter + content + options.strongDelimiter;
    }
};
$075446ebf04f5e91$var$rules.code = {
    filter: function filter(node) {
        var hasSiblings = node.previousSibling || node.nextSibling;
        var isCodeBlock = node.parentNode.nodeName === 'PRE' && !hasSiblings;
        return node.nodeName === 'CODE' && !isCodeBlock;
    },
    replacement: function replacement(content) {
        if (!content) return '';
        content = content.replace(/\r?\n|\r/g, ' ');
        var extraSpace = /^`|^ .*?[^ ].* $|`$/.test(content) ? ' ' : '';
        var delimiter = '`';
        var matches = content.match(/`+/gm) || [];
        while(matches.indexOf(delimiter) !== -1)delimiter = delimiter + '`';
        return delimiter + extraSpace + content + extraSpace + delimiter;
    }
};
$075446ebf04f5e91$var$rules.image = {
    filter: 'img',
    replacement: function replacement(content, node) {
        var alt = $075446ebf04f5e91$var$escapeMarkdown($075446ebf04f5e91$var$cleanAttribute(node.getAttribute('alt')));
        var src = $075446ebf04f5e91$var$escapeLinkDestination(node.getAttribute('src') || '');
        var title = $075446ebf04f5e91$var$cleanAttribute(node.getAttribute('title'));
        var titlePart = title ? ' "' + $075446ebf04f5e91$var$escapeLinkTitle(title) + '"' : '';
        return src ? '![' + alt + ']' + '(' + src + titlePart + ')' : '';
    }
};
function $075446ebf04f5e91$var$cleanAttribute(attribute) {
    return attribute ? attribute.replace(/(\n+\s*)+/g, '\n') : '';
}
function $075446ebf04f5e91$var$escapeLinkDestination(destination) {
    var escaped = destination.replace(/([<>()])/g, '\\$1');
    return escaped.indexOf(' ') >= 0 ? '<' + escaped + '>' : escaped;
}
function $075446ebf04f5e91$var$escapeLinkTitle(title) {
    return title.replace(/"/g, '\\"');
}
/**
 * Manages a collection of rules used to convert HTML to Markdown
 */ function $075446ebf04f5e91$var$Rules(options) {
    this.options = options;
    this._keep = [];
    this._remove = [];
    this.blankRule = {
        replacement: options.blankReplacement
    };
    this.keepReplacement = options.keepReplacement;
    this.defaultRule = {
        replacement: options.defaultReplacement
    };
    this.array = [];
    for(var key in options.rules)this.array.push(options.rules[key]);
}
$075446ebf04f5e91$var$Rules.prototype = {
    add: function add(key, rule) {
        this.array.unshift(rule);
    },
    keep: function keep(filter) {
        this._keep.unshift({
            filter: filter,
            replacement: this.keepReplacement
        });
    },
    remove: function remove(filter) {
        this._remove.unshift({
            filter: filter,
            replacement: function replacement() {
                return '';
            }
        });
    },
    forNode: function forNode(node) {
        if (node.isBlank) return this.blankRule;
        var rule;
        if (rule = $075446ebf04f5e91$var$findRule(this.array, node, this.options)) return rule;
        if (rule = $075446ebf04f5e91$var$findRule(this._keep, node, this.options)) return rule;
        if (rule = $075446ebf04f5e91$var$findRule(this._remove, node, this.options)) return rule;
        return this.defaultRule;
    },
    forEach: function forEach(fn) {
        for(var i = 0; i < this.array.length; i++)fn(this.array[i], i);
    }
};
function $075446ebf04f5e91$var$findRule(rules, node, options) {
    for(var i = 0; i < rules.length; i++){
        var rule = rules[i];
        if ($075446ebf04f5e91$var$filterValue(rule, node, options)) return rule;
    }
    return undefined;
}
function $075446ebf04f5e91$var$filterValue(rule, node, options) {
    var filter = rule.filter;
    if (typeof filter === 'string') {
        if (filter === node.nodeName.toLowerCase()) return true;
    } else if (Array.isArray(filter)) {
        if (filter.indexOf(node.nodeName.toLowerCase()) > -1) return true;
    } else if (typeof filter === 'function') {
        if (filter.call(rule, node, options)) return true;
    } else throw new TypeError('`filter` needs to be a string, array, or function');
}
/**
 * The collapseWhitespace function is adapted from collapse-whitespace
 * by Luc Thevenard.
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Luc Thevenard <lucthevenard@gmail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * collapseWhitespace(options) removes extraneous whitespace from an the given element.
 *
 * @param {Object} options
 */ function $075446ebf04f5e91$var$collapseWhitespace(options) {
    var element = options.element;
    var isBlock = options.isBlock;
    var isVoid = options.isVoid;
    var isPre = options.isPre || function(node) {
        return node.nodeName === 'PRE';
    };
    if (!element.firstChild || isPre(element)) return;
    var prevText = null;
    var keepLeadingWs = false;
    var prev = null;
    var node = $075446ebf04f5e91$var$next(prev, element, isPre);
    while(node !== element){
        if (node.nodeType === 3 || node.nodeType === 4) {
            // Node.TEXT_NODE or Node.CDATA_SECTION_NODE
            var text = node.data.replace(/[ \r\n\t]+/g, ' ');
            if ((!prevText || / $/.test(prevText.data)) && !keepLeadingWs && text[0] === ' ') text = text.substr(1);
            // `text` might be empty at this point.
            if (!text) {
                node = $075446ebf04f5e91$var$remove(node);
                continue;
            }
            node.data = text;
            prevText = node;
        } else if (node.nodeType === 1) {
            // Node.ELEMENT_NODE
            if (isBlock(node) || node.nodeName === 'BR') {
                if (prevText) prevText.data = prevText.data.replace(/ $/, '');
                prevText = null;
                keepLeadingWs = false;
            } else if (isVoid(node) || isPre(node)) {
                // Avoid trimming space around non-block, non-BR void elements and inline PRE.
                prevText = null;
                keepLeadingWs = true;
            } else if (prevText) // Drop protection if set previously.
            keepLeadingWs = false;
        } else {
            node = $075446ebf04f5e91$var$remove(node);
            continue;
        }
        var nextNode = $075446ebf04f5e91$var$next(prev, node, isPre);
        prev = node;
        node = nextNode;
    }
    if (prevText) {
        prevText.data = prevText.data.replace(/ $/, '');
        if (!prevText.data) $075446ebf04f5e91$var$remove(prevText);
    }
}
/**
 * remove(node) removes the given node from the DOM and returns the
 * next node in the sequence.
 *
 * @param {Node} node
 * @return {Node} node
 */ function $075446ebf04f5e91$var$remove(node) {
    var next = node.nextSibling || node.parentNode;
    node.parentNode.removeChild(node);
    return next;
}
/**
 * next(prev, current, isPre) returns the next node in the sequence, given the
 * current and previous nodes.
 *
 * @param {Node} prev
 * @param {Node} current
 * @param {Function} isPre
 * @return {Node}
 */ function $075446ebf04f5e91$var$next(prev, current, isPre) {
    if (prev && prev.parentNode === current || isPre(current)) return current.nextSibling || current.parentNode;
    return current.firstChild || current.nextSibling || current.parentNode;
}
/*
 * Set up window for Node.js
 */ var $075446ebf04f5e91$var$root = typeof window !== 'undefined' ? window : {};
/*
 * Parsing HTML strings
 */ function $075446ebf04f5e91$var$canParseHTMLNatively() {
    var Parser = $075446ebf04f5e91$var$root.DOMParser;
    var canParse = false;
    // Adapted from https://gist.github.com/1129031
    // Firefox/Opera/IE throw errors on unsupported types
    try {
        // WebKit returns null on unsupported types
        if (new Parser().parseFromString('', 'text/html')) canParse = true;
    } catch (e) {}
    return canParse;
}
function $075446ebf04f5e91$var$createHTMLParser() {
    var Parser = function Parser() {};
    if ($075446ebf04f5e91$var$shouldUseActiveX()) Parser.prototype.parseFromString = function(string) {
        var doc = new window.ActiveXObject('htmlfile');
        doc.designMode = 'on'; // disable on-page scripts
        doc.open();
        doc.write(string);
        doc.close();
        return doc;
    };
    else Parser.prototype.parseFromString = function(string) {
        var doc = document.implementation.createHTMLDocument('');
        doc.open();
        doc.write(string);
        doc.close();
        return doc;
    };
    return Parser;
}
function $075446ebf04f5e91$var$shouldUseActiveX() {
    var useActiveX = false;
    try {
        document.implementation.createHTMLDocument('').open();
    } catch (e) {
        if ($075446ebf04f5e91$var$root.ActiveXObject) useActiveX = true;
    }
    return useActiveX;
}
var $075446ebf04f5e91$var$HTMLParser = $075446ebf04f5e91$var$canParseHTMLNatively() ? $075446ebf04f5e91$var$root.DOMParser : $075446ebf04f5e91$var$createHTMLParser();
function $075446ebf04f5e91$var$RootNode(input, options) {
    var root;
    if (typeof input === 'string') {
        var doc = $075446ebf04f5e91$var$htmlParser().parseFromString(// DOM parsers arrange elements in the <head> and <body>.
        // Wrapping in a custom element ensures elements are reliably arranged in
        // a single element.
        '<x-turndown id="turndown-root">' + input + '</x-turndown>', 'text/html');
        root = doc.getElementById('turndown-root');
    } else root = input.cloneNode(true);
    $075446ebf04f5e91$var$collapseWhitespace({
        element: root,
        isBlock: $075446ebf04f5e91$var$isBlock,
        isVoid: $075446ebf04f5e91$var$isVoid,
        isPre: options.preformattedCode ? $075446ebf04f5e91$var$isPreOrCode : null
    });
    return root;
}
var $075446ebf04f5e91$var$_htmlParser;
function $075446ebf04f5e91$var$htmlParser() {
    $075446ebf04f5e91$var$_htmlParser = $075446ebf04f5e91$var$_htmlParser || new $075446ebf04f5e91$var$HTMLParser();
    return $075446ebf04f5e91$var$_htmlParser;
}
function $075446ebf04f5e91$var$isPreOrCode(node) {
    return node.nodeName === 'PRE' || node.nodeName === 'CODE';
}
function $075446ebf04f5e91$var$Node(node, options) {
    node.isBlock = $075446ebf04f5e91$var$isBlock(node);
    node.isCode = node.nodeName === 'CODE' || node.parentNode.isCode;
    node.isBlank = $075446ebf04f5e91$var$isBlank(node);
    node.flankingWhitespace = $075446ebf04f5e91$var$flankingWhitespace(node, options);
    return node;
}
function $075446ebf04f5e91$var$isBlank(node) {
    return !$075446ebf04f5e91$var$isVoid(node) && !$075446ebf04f5e91$var$isMeaningfulWhenBlank(node) && /^\s*$/i.test(node.textContent) && !$075446ebf04f5e91$var$hasVoid(node) && !$075446ebf04f5e91$var$hasMeaningfulWhenBlank(node);
}
function $075446ebf04f5e91$var$flankingWhitespace(node, options) {
    if (node.isBlock || options.preformattedCode && node.isCode) return {
        leading: '',
        trailing: ''
    };
    var edges = $075446ebf04f5e91$var$edgeWhitespace(node.textContent);
    // abandon leading ASCII WS if left-flanked by ASCII WS
    if (edges.leadingAscii && $075446ebf04f5e91$var$isFlankedByWhitespace('left', node, options)) edges.leading = edges.leadingNonAscii;
    // abandon trailing ASCII WS if right-flanked by ASCII WS
    if (edges.trailingAscii && $075446ebf04f5e91$var$isFlankedByWhitespace('right', node, options)) edges.trailing = edges.trailingNonAscii;
    return {
        leading: edges.leading,
        trailing: edges.trailing
    };
}
function $075446ebf04f5e91$var$edgeWhitespace(string) {
    var m = string.match(/^(([ \t\r\n]*)(\s*))(?:(?=\S)[\s\S]*\S)?((\s*?)([ \t\r\n]*))$/);
    return {
        leading: m[1],
        // whole string for whitespace-only strings
        leadingAscii: m[2],
        leadingNonAscii: m[3],
        trailing: m[4],
        // empty for whitespace-only strings
        trailingNonAscii: m[5],
        trailingAscii: m[6]
    };
}
function $075446ebf04f5e91$var$isFlankedByWhitespace(side, node, options) {
    var sibling;
    var regExp;
    var isFlanked;
    if (side === 'left') {
        sibling = node.previousSibling;
        regExp = / $/;
    } else {
        sibling = node.nextSibling;
        regExp = /^ /;
    }
    if (sibling) {
        if (sibling.nodeType === 3) isFlanked = regExp.test(sibling.nodeValue);
        else if (options.preformattedCode && sibling.nodeName === 'CODE') isFlanked = false;
        else if (sibling.nodeType === 1 && !$075446ebf04f5e91$var$isBlock(sibling)) isFlanked = regExp.test(sibling.textContent);
    }
    return isFlanked;
}
var $075446ebf04f5e91$var$reduce = Array.prototype.reduce;
function $075446ebf04f5e91$export$2e2bcd8739ae039(options) {
    if (!(this instanceof $075446ebf04f5e91$export$2e2bcd8739ae039)) return new $075446ebf04f5e91$export$2e2bcd8739ae039(options);
    var defaults = {
        rules: $075446ebf04f5e91$var$rules,
        headingStyle: 'setext',
        hr: '* * *',
        bulletListMarker: '*',
        codeBlockStyle: 'indented',
        fence: '```',
        emDelimiter: '_',
        strongDelimiter: '**',
        linkStyle: 'inlined',
        linkReferenceStyle: 'full',
        br: '  ',
        preformattedCode: false,
        blankReplacement: function blankReplacement(content, node) {
            return node.isBlock ? '\n\n' : '';
        },
        keepReplacement: function keepReplacement(content, node) {
            return node.isBlock ? '\n\n' + node.outerHTML + '\n\n' : node.outerHTML;
        },
        defaultReplacement: function defaultReplacement(content, node) {
            return node.isBlock ? '\n\n' + content + '\n\n' : content;
        }
    };
    this.options = $075446ebf04f5e91$var$extend({}, defaults, options);
    this.rules = new $075446ebf04f5e91$var$Rules(this.options);
}
$075446ebf04f5e91$export$2e2bcd8739ae039.prototype = {
    /**
   * The entry point for converting a string or DOM node to Markdown
   * @public
   * @param {String|HTMLElement} input The string or DOM node to convert
   * @returns A Markdown representation of the input
   * @type String
   */ turndown: function turndown(input) {
        if (!$075446ebf04f5e91$var$canConvert(input)) throw new TypeError(input + ' is not a string, or an element/document/fragment node.');
        if (input === '') return '';
        var output = $075446ebf04f5e91$var$process.call(this, new $075446ebf04f5e91$var$RootNode(input, this.options));
        return $075446ebf04f5e91$var$postProcess.call(this, output);
    },
    /**
   * Add one or more plugins
   * @public
   * @param {Function|Array} plugin The plugin or array of plugins to add
   * @returns The Turndown instance for chaining
   * @type Object
   */ use: function use(plugin) {
        if (Array.isArray(plugin)) for(var i = 0; i < plugin.length; i++)this.use(plugin[i]);
        else if (typeof plugin === 'function') plugin(this);
        else throw new TypeError('plugin must be a Function or an Array of Functions');
        return this;
    },
    /**
   * Adds a rule
   * @public
   * @param {String} key The unique key of the rule
   * @param {Object} rule The rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ addRule: function addRule(key, rule) {
        this.rules.add(key, rule);
        return this;
    },
    /**
   * Keep a node (as HTML) that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ keep: function keep(filter) {
        this.rules.keep(filter);
        return this;
    },
    /**
   * Remove a node that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ remove: function remove(filter) {
        this.rules.remove(filter);
        return this;
    },
    /**
   * Escapes Markdown syntax
   * @public
   * @param {String} string The string to escape
   * @returns A string with Markdown syntax escaped
   * @type String
   */ escape: function escape(string) {
        return $075446ebf04f5e91$var$escapeMarkdown(string);
    }
};
/**
 * Reduces a DOM node down to its Markdown string equivalent
 * @private
 * @param {HTMLElement} parentNode The node to convert
 * @returns A Markdown representation of the node
 * @type String
 */ function $075446ebf04f5e91$var$process(parentNode) {
    var self = this;
    return $075446ebf04f5e91$var$reduce.call(parentNode.childNodes, function(output, node) {
        node = new $075446ebf04f5e91$var$Node(node, self.options);
        var replacement = '';
        if (node.nodeType === 3) replacement = node.isCode ? node.nodeValue : self.escape(node.nodeValue);
        else if (node.nodeType === 1) replacement = $075446ebf04f5e91$var$replacementForNode.call(self, node);
        return $075446ebf04f5e91$var$join(output, replacement);
    }, '');
}
/**
 * Appends strings as each rule requires and trims the output
 * @private
 * @param {String} output The conversion output
 * @returns A trimmed version of the ouput
 * @type String
 */ function $075446ebf04f5e91$var$postProcess(output) {
    var self = this;
    this.rules.forEach(function(rule) {
        if (typeof rule.append === 'function') output = $075446ebf04f5e91$var$join(output, rule.append(self.options));
    });
    return output.replace(/^[\t\r\n]+/, '').replace(/[\t\r\n\s]+$/, '');
}
/**
 * Converts an element node to its Markdown equivalent
 * @private
 * @param {HTMLElement} node The node to convert
 * @returns A Markdown representation of the node
 * @type String
 */ function $075446ebf04f5e91$var$replacementForNode(node) {
    var rule = this.rules.forNode(node);
    var content = $075446ebf04f5e91$var$process.call(this, node);
    var whitespace = node.flankingWhitespace;
    if (whitespace.leading || whitespace.trailing) content = content.trim();
    return whitespace.leading + rule.replacement(content, node, this.options) + whitespace.trailing;
}
/**
 * Joins replacement to the current output with appropriate number of new lines
 * @private
 * @param {String} output The current conversion output
 * @param {String} replacement The string to append to the output
 * @returns Joined output
 * @type String
 */ function $075446ebf04f5e91$var$join(output, replacement) {
    var s1 = $075446ebf04f5e91$var$trimTrailingNewlines(output);
    var s2 = $075446ebf04f5e91$var$trimLeadingNewlines(replacement);
    var nls = Math.max(output.length - s1.length, replacement.length - s2.length);
    var separator = '\n\n'.substring(0, nls);
    return s1 + separator + s2;
}
/**
 * Determines whether an input can be converted
 * @private
 * @param {String|HTMLElement} input Describe this parameter
 * @returns Describe what it returns
 * @type String|Object|Array|Boolean|Number
 */ function $075446ebf04f5e91$var$canConvert(input) {
    return input != null && (typeof input === 'string' || input.nodeType && (input.nodeType === 1 || input.nodeType === 9 || input.nodeType === 11));
}


var $7d59e34d58a0f292$var$highlightRegExp = /highlight-(?:text|source)-([a-z0-9]+)/;
function $7d59e34d58a0f292$export$c359330ed80b1889(turndownService) {
    turndownService.addRule('highlightedCodeBlock', {
        filter: function filter(node) {
            var firstChild = node.firstChild;
            return node.nodeName === 'DIV' && $7d59e34d58a0f292$var$highlightRegExp.test(node.className) && firstChild && firstChild.nodeName === 'PRE';
        },
        replacement: function replacement(content, node, options) {
            var className = node.className || '';
            var language = (className.match($7d59e34d58a0f292$var$highlightRegExp) || [
                null,
                ''
            ])[1];
            return '\n\n' + options.fence + language + '\n' + node.firstChild.textContent + '\n' + options.fence + '\n\n';
        }
    });
}
function $7d59e34d58a0f292$export$19426ff118fe8be(turndownService) {
    turndownService.addRule('strikethrough', {
        filter: [
            'del',
            's',
            'strike'
        ],
        replacement: function replacement(content) {
            return '~' + content + '~';
        }
    });
}
var $7d59e34d58a0f292$var$indexOf = Array.prototype.indexOf;
var $7d59e34d58a0f292$var$every = Array.prototype.every;
var $7d59e34d58a0f292$var$rules = {};
$7d59e34d58a0f292$var$rules.tableCell = {
    filter: [
        'th',
        'td'
    ],
    replacement: function replacement(content, node) {
        return $7d59e34d58a0f292$var$cell(content, node);
    }
};
$7d59e34d58a0f292$var$rules.tableRow = {
    filter: 'tr',
    replacement: function replacement(content, node) {
        var borderCells = '';
        var alignMap = {
            left: ':--',
            right: '--:',
            center: ':-:'
        };
        if ($7d59e34d58a0f292$var$isHeadingRow(node)) for(var i = 0; i < node.childNodes.length; i++){
            var border = '---';
            var align = (node.childNodes[i].getAttribute('align') || '').toLowerCase();
            if (align) border = alignMap[align] || border;
            borderCells += $7d59e34d58a0f292$var$cell(border, node.childNodes[i]);
        }
        return '\n' + content + (borderCells ? '\n' + borderCells : '');
    }
};
$7d59e34d58a0f292$var$rules.table = {
    // Only convert tables with a heading row.
    // Tables with no heading row are kept using `keep` (see below).
    filter: function filter(node) {
        return node.nodeName === 'TABLE' && $7d59e34d58a0f292$var$isHeadingRow(node.rows[0]);
    },
    replacement: function replacement(content) {
        // Ensure there are no blank lines
        content = content.replace('\n\n', '\n');
        return '\n\n' + content + '\n\n';
    }
};
$7d59e34d58a0f292$var$rules.tableSection = {
    filter: [
        'thead',
        'tbody',
        'tfoot'
    ],
    replacement: function replacement(content) {
        return content;
    }
};
// A tr is a heading row if:
// - the parent is a THEAD
// - or if its the first child of the TABLE or the first TBODY (possibly
//   following a blank THEAD)
// - and every cell is a TH
function $7d59e34d58a0f292$var$isHeadingRow(tr) {
    var parentNode = tr.parentNode;
    return parentNode.nodeName === 'THEAD' || parentNode.firstChild === tr && (parentNode.nodeName === 'TABLE' || $7d59e34d58a0f292$var$isFirstTbody(parentNode)) && $7d59e34d58a0f292$var$every.call(tr.childNodes, function(n) {
        return n.nodeName === 'TH';
    });
}
function $7d59e34d58a0f292$var$isFirstTbody(element) {
    var previousSibling = element.previousSibling;
    return element.nodeName === 'TBODY' && (!previousSibling || previousSibling.nodeName === 'THEAD' && /^\s*$/i.test(previousSibling.textContent));
}
function $7d59e34d58a0f292$var$cell(content, node) {
    var index = $7d59e34d58a0f292$var$indexOf.call(node.parentNode.childNodes, node);
    var prefix = ' ';
    if (index === 0) prefix = '| ';
    return prefix + content + ' |';
}
function $7d59e34d58a0f292$export$cc4ff83fc7bd256e(turndownService) {
    turndownService.keep(function(node) {
        return node.nodeName === 'TABLE' && !$7d59e34d58a0f292$var$isHeadingRow(node.rows[0]);
    });
    for(var key in $7d59e34d58a0f292$var$rules)turndownService.addRule(key, $7d59e34d58a0f292$var$rules[key]);
}
function $7d59e34d58a0f292$export$1f0c2747e2ba0b8d(turndownService) {
    turndownService.addRule('taskListItems', {
        filter: function filter(node) {
            return node.type === 'checkbox' && node.parentNode.nodeName === 'LI';
        },
        replacement: function replacement(content, node) {
            return (node.checked ? '[x]' : '[ ]') + ' ';
        }
    });
}
function $7d59e34d58a0f292$export$59ffe8c4d7a4aab2(turndownService) {
    turndownService.use([
        $7d59e34d58a0f292$export$c359330ed80b1889,
        $7d59e34d58a0f292$export$19426ff118fe8be,
        $7d59e34d58a0f292$export$cc4ff83fc7bd256e,
        $7d59e34d58a0f292$export$1f0c2747e2ba0b8d
    ]);
}



var $lhPyT = parcelRequire("lhPyT");

var $l5IE3 = parcelRequire("l5IE3");
function $ec0d3058e92a8855$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $ec0d3058e92a8855$var$$57ba63c17513cbba$exports = {};
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$57ba63c17513cbba$exports, "getAnchorElement", function() {
    return $ec0d3058e92a8855$export$ac81f1ba58a5f363;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$57ba63c17513cbba$exports, "Tool", function() {
    return $ec0d3058e92a8855$export$724f6b867059ef5f;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$57ba63c17513cbba$exports, "FileTool", function() {
    return $ec0d3058e92a8855$export$de3122b2484864a7;
});
function $ec0d3058e92a8855$export$ac81f1ba58a5f363() {
    var _globalThis_getSelection, _globalThis;
    var _ref = ((_globalThis_getSelection = (_globalThis = globalThis).getSelection) === null || _globalThis_getSelection === void 0 ? void 0 : _globalThis_getSelection.call(_globalThis)) || {}, anchorNode = _ref.anchorNode;
    if (anchorNode) return anchorNode.parentElement;
}
var $ec0d3058e92a8855$export$724f6b867059ef5f = /*#__PURE__*/ function() {
    "use strict";
    function $57ba63c17513cbba$export$724f6b867059ef5f() {
        (0, $173N4._)(this, $57ba63c17513cbba$export$724f6b867059ef5f);
    }
    (0, $cFHGC._)($57ba63c17513cbba$export$724f6b867059ef5f, [
        {
            key: "usable",
            get: function get() {
                var _this = this, command = _this.command;
                return !command || !globalThis.document || document.queryCommandSupported(command) || document.queryCommandEnabled(command);
            }
        },
        {
            key: "getActive",
            value: function getActive() {
                var _this = this, command = _this.command, tags = _this.tags;
                if (tags) {
                    var box = $ec0d3058e92a8855$export$ac81f1ba58a5f363();
                    return !!box && box.matches(tags.map(function(tag) {
                        return "".concat(tag, ", ").concat(tag, " *");
                    }).join(', '));
                }
                if (command) return !!globalThis.document && document.queryCommandState(command);
                return false;
            }
        },
        {
            key: "active",
            get: function get() {
                return this.getActive();
            }
        },
        {
            key: "title",
            get: function get() {
                var _this = this, name = _this.name, keys = _this.keys, usable = _this.usable;
                return "".concat(name).concat(usable ? keys ? "\n(".concat(keys.join(' + '), ")") : '' : '\n(not supported)');
            }
        },
        {
            key: "edit",
            value: function edit(editor) {
                for(var _len = arguments.length, data = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    data[_key - 1] = arguments[_key];
                }
                var _document;
                editor.focus();
                (_document = document).execCommand.apply(_document, [
                    this.command,
                    null
                ].concat((0, $aUGqu._)(data)));
            }
        },
        {
            key: "execute",
            value: function execute(editor) {
                for(var _len = arguments.length, data = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    data[_key - 1] = arguments[_key];
                }
                var _this = this, inputs = _this.inputs, values = [];
                if (inputs) {
                    var data1 = inputs.map(function(input) {
                        return self.prompt(input);
                    });
                    if (!data1.filter(Boolean)[0]) return;
                    values = data1;
                }
                this.edit.apply(this, [
                    editor
                ].concat((0, $aUGqu._)(values)));
            }
        }
    ]);
    return $57ba63c17513cbba$export$724f6b867059ef5f;
}();
var $ec0d3058e92a8855$export$de3122b2484864a7 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($57ba63c17513cbba$export$de3122b2484864a7, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $57ba63c17513cbba$export$de3122b2484864a7() {
        (0, $173N4._)(this, $57ba63c17513cbba$export$de3122b2484864a7);
        return (0, $7qXGD._)(this, $57ba63c17513cbba$export$de3122b2484864a7, arguments);
    }
    (0, $cFHGC._)($57ba63c17513cbba$export$de3122b2484864a7, [
        {
            key: "save",
            value: function save(data) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    return (0, $13u2V._)(this, function(_state) {
                        return [
                            2,
                            URL.createObjectURL(data)
                        ];
                    });
                })();
            }
        },
        {
            key: "codeOf",
            value: function codeOf(path) {
                return path;
            }
        },
        {
            key: "execute",
            value: function execute(editor) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var path, _, _1, e, path;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                _1 = (_ = this).save;
                                return [
                                    4,
                                    (0, $e0062df735681f1b$export$c1bd535e520dbbc3)()
                                ];
                            case 1:
                                return [
                                    4,
                                    _1.apply(_, [
                                        _state.sent()
                                    ])
                                ];
                            case 2:
                                path = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                path = self.prompt('No file uploaded, please input an URL');
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                if (path) this.edit(editor, this.codeOf(path));
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return $57ba63c17513cbba$export$de3122b2484864a7;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$var$$761e5fca3dae08eb$exports = {};
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "BoldTool", function() {
    return $ec0d3058e92a8855$export$10056a49e3b218eb;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "ItalicTool", function() {
    return $ec0d3058e92a8855$export$edf99d0f51bacb1e;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "UnderlineTool", function() {
    return $ec0d3058e92a8855$export$4b6d9c17188960d2;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "StrikeThroughTool", function() {
    return $ec0d3058e92a8855$export$a35bffaeae8fdda0;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "HeadingTool", function() {
    return $ec0d3058e92a8855$export$85cf7848e2652151;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "H1Tool", function() {
    return $ec0d3058e92a8855$export$30e8c6b428f8749f;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "H2Tool", function() {
    return $ec0d3058e92a8855$export$58443375efa91029;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "H3Tool", function() {
    return $ec0d3058e92a8855$export$75d24d6b8b747307;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "FontSizeDownTool", function() {
    return $ec0d3058e92a8855$export$a20806c6ef6938f8;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "FontSizeUpTool", function() {
    return $ec0d3058e92a8855$export$744da7e24e4a7382;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "SubscriptTool", function() {
    return $ec0d3058e92a8855$export$6137518b4e998008;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "SuperscriptTool", function() {
    return $ec0d3058e92a8855$export$7217f06c61ebd4fc;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "LinkTool", function() {
    return $ec0d3058e92a8855$export$f6c54364b5332e66;
});
var $ec0d3058e92a8855$export$10056a49e3b218eb = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($761e5fca3dae08eb$export$10056a49e3b218eb, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $761e5fca3dae08eb$export$10056a49e3b218eb() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $761e5fca3dae08eb$export$10056a49e3b218eb);
        var _this;
        _this = (0, $7qXGD._)(this, $761e5fca3dae08eb$export$10056a49e3b218eb, (0, $aUGqu._)(args)), _this.name = 'Bold', _this.tags = [
            'b',
            'strong'
        ], _this.keys = [
            'Ctrl',
            'B'
        ], _this.command = 'bold';
        return _this;
    }
    return $761e5fca3dae08eb$export$10056a49e3b218eb;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$edf99d0f51bacb1e = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($761e5fca3dae08eb$export$edf99d0f51bacb1e, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $761e5fca3dae08eb$export$edf99d0f51bacb1e() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $761e5fca3dae08eb$export$edf99d0f51bacb1e);
        var _this;
        _this = (0, $7qXGD._)(this, $761e5fca3dae08eb$export$edf99d0f51bacb1e, (0, $aUGqu._)(args)), _this.name = 'Italic', _this.tags = [
            'i',
            'em'
        ], _this.keys = [
            'Ctrl',
            'I'
        ], _this.command = 'italic';
        return _this;
    }
    return $761e5fca3dae08eb$export$edf99d0f51bacb1e;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$4b6d9c17188960d2 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($761e5fca3dae08eb$export$4b6d9c17188960d2, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $761e5fca3dae08eb$export$4b6d9c17188960d2() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $761e5fca3dae08eb$export$4b6d9c17188960d2);
        var _this;
        _this = (0, $7qXGD._)(this, $761e5fca3dae08eb$export$4b6d9c17188960d2, (0, $aUGqu._)(args)), _this.name = 'Underline', _this.tags = [
            'u'
        ], _this.keys = [
            'Ctrl',
            'U'
        ], _this.command = 'underline';
        return _this;
    }
    return $761e5fca3dae08eb$export$4b6d9c17188960d2;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$a35bffaeae8fdda0 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($761e5fca3dae08eb$export$a35bffaeae8fdda0, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $761e5fca3dae08eb$export$a35bffaeae8fdda0() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $761e5fca3dae08eb$export$a35bffaeae8fdda0);
        var _this;
        _this = (0, $7qXGD._)(this, $761e5fca3dae08eb$export$a35bffaeae8fdda0, (0, $aUGqu._)(args)), _this.name = 'Strike through', _this.tags = [
            's',
            'del',
            'strike'
        ], _this.command = 'strikeThrough';
        return _this;
    }
    return $761e5fca3dae08eb$export$a35bffaeae8fdda0;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$85cf7848e2652151 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($761e5fca3dae08eb$export$85cf7848e2652151, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $761e5fca3dae08eb$export$85cf7848e2652151() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $761e5fca3dae08eb$export$85cf7848e2652151);
        var _this;
        var _globalThis_document;
        _this = (0, $7qXGD._)(this, $761e5fca3dae08eb$export$85cf7848e2652151, (0, $aUGqu._)(args)), _this.command = ((_globalThis_document = globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.queryCommandSupported('heading')) ? 'heading' : 'formatBlock';
        return _this;
    }
    (0, $cFHGC._)($761e5fca3dae08eb$export$85cf7848e2652151, [
        {
            key: "execute",
            value: function execute(editor) {
                this.edit(editor, this.name);
            }
        }
    ]);
    return $761e5fca3dae08eb$export$85cf7848e2652151;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$30e8c6b428f8749f = /*#__PURE__*/ function($761e5fca3dae08eb$export$85cf7848e2652151) {
    "use strict";
    (0, $hdIku._)($761e5fca3dae08eb$export$30e8c6b428f8749f, $761e5fca3dae08eb$export$85cf7848e2652151);
    function $761e5fca3dae08eb$export$30e8c6b428f8749f() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $761e5fca3dae08eb$export$30e8c6b428f8749f);
        var _this;
        _this = (0, $7qXGD._)(this, $761e5fca3dae08eb$export$30e8c6b428f8749f, (0, $aUGqu._)(args)), _this.name = 'H1', _this.tags = [
            'h1'
        ];
        return _this;
    }
    return $761e5fca3dae08eb$export$30e8c6b428f8749f;
}($ec0d3058e92a8855$export$85cf7848e2652151);
var $ec0d3058e92a8855$export$58443375efa91029 = /*#__PURE__*/ function($761e5fca3dae08eb$export$85cf7848e2652151) {
    "use strict";
    (0, $hdIku._)($761e5fca3dae08eb$export$58443375efa91029, $761e5fca3dae08eb$export$85cf7848e2652151);
    function $761e5fca3dae08eb$export$58443375efa91029() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $761e5fca3dae08eb$export$58443375efa91029);
        var _this;
        _this = (0, $7qXGD._)(this, $761e5fca3dae08eb$export$58443375efa91029, (0, $aUGqu._)(args)), _this.name = 'H2', _this.tags = [
            'h2'
        ];
        return _this;
    }
    return $761e5fca3dae08eb$export$58443375efa91029;
}($ec0d3058e92a8855$export$85cf7848e2652151);
var $ec0d3058e92a8855$export$75d24d6b8b747307 = /*#__PURE__*/ function($761e5fca3dae08eb$export$85cf7848e2652151) {
    "use strict";
    (0, $hdIku._)($761e5fca3dae08eb$export$75d24d6b8b747307, $761e5fca3dae08eb$export$85cf7848e2652151);
    function $761e5fca3dae08eb$export$75d24d6b8b747307() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $761e5fca3dae08eb$export$75d24d6b8b747307);
        var _this;
        _this = (0, $7qXGD._)(this, $761e5fca3dae08eb$export$75d24d6b8b747307, (0, $aUGqu._)(args)), _this.name = 'H3', _this.tags = [
            'h3'
        ];
        return _this;
    }
    return $761e5fca3dae08eb$export$75d24d6b8b747307;
}($ec0d3058e92a8855$export$85cf7848e2652151);
var $ec0d3058e92a8855$export$a20806c6ef6938f8 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($761e5fca3dae08eb$export$a20806c6ef6938f8, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $761e5fca3dae08eb$export$a20806c6ef6938f8() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $761e5fca3dae08eb$export$a20806c6ef6938f8);
        var _this;
        _this = (0, $7qXGD._)(this, $761e5fca3dae08eb$export$a20806c6ef6938f8, (0, $aUGqu._)(args)), _this.name = 'Font Size down', _this.tags = [
            'small'
        ], _this.command = 'decreaseFontSize';
        return _this;
    }
    return $761e5fca3dae08eb$export$a20806c6ef6938f8;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$744da7e24e4a7382 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($761e5fca3dae08eb$export$744da7e24e4a7382, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $761e5fca3dae08eb$export$744da7e24e4a7382() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $761e5fca3dae08eb$export$744da7e24e4a7382);
        var _this;
        _this = (0, $7qXGD._)(this, $761e5fca3dae08eb$export$744da7e24e4a7382, (0, $aUGqu._)(args)), _this.name = 'Font Size up', _this.tags = [
            'big'
        ], _this.command = 'increaseFontSize';
        return _this;
    }
    return $761e5fca3dae08eb$export$744da7e24e4a7382;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$6137518b4e998008 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($761e5fca3dae08eb$export$6137518b4e998008, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $761e5fca3dae08eb$export$6137518b4e998008() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $761e5fca3dae08eb$export$6137518b4e998008);
        var _this;
        _this = (0, $7qXGD._)(this, $761e5fca3dae08eb$export$6137518b4e998008, (0, $aUGqu._)(args)), _this.name = 'Subscript', _this.tags = [
            'sub'
        ], _this.command = 'subscript';
        return _this;
    }
    return $761e5fca3dae08eb$export$6137518b4e998008;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$7217f06c61ebd4fc = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($761e5fca3dae08eb$export$7217f06c61ebd4fc, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $761e5fca3dae08eb$export$7217f06c61ebd4fc() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $761e5fca3dae08eb$export$7217f06c61ebd4fc);
        var _this;
        _this = (0, $7qXGD._)(this, $761e5fca3dae08eb$export$7217f06c61ebd4fc, (0, $aUGqu._)(args)), _this.name = 'Superscript', _this.tags = [
            'sup'
        ], _this.command = 'superscript';
        return _this;
    }
    return $761e5fca3dae08eb$export$7217f06c61ebd4fc;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$f6c54364b5332e66 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($761e5fca3dae08eb$export$f6c54364b5332e66, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $761e5fca3dae08eb$export$f6c54364b5332e66() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $761e5fca3dae08eb$export$f6c54364b5332e66);
        var _this;
        _this = (0, $7qXGD._)(this, $761e5fca3dae08eb$export$f6c54364b5332e66, (0, $aUGqu._)(args)), _this.name = 'Link', _this.tags = [
            'a'
        ], _this.inputs = [
            'Path'
        ], _this.command = 'createLink';
        return _this;
    }
    return $761e5fca3dae08eb$export$f6c54364b5332e66;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$var$$e999eec76d3b8abe$exports = {};
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$e999eec76d3b8abe$exports, "ColorTool", function() {
    return $ec0d3058e92a8855$export$ba9bbe5370f1bf2f;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$e999eec76d3b8abe$exports, "ForeColorTool", function() {
    return $ec0d3058e92a8855$export$cab0e15cfb8489d7;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$e999eec76d3b8abe$exports, "BackColorTool", function() {
    return $ec0d3058e92a8855$export$92bb6183e7459be2;
});
var $ec0d3058e92a8855$export$ba9bbe5370f1bf2f = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($e999eec76d3b8abe$export$ba9bbe5370f1bf2f, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $e999eec76d3b8abe$export$ba9bbe5370f1bf2f() {
        (0, $173N4._)(this, $e999eec76d3b8abe$export$ba9bbe5370f1bf2f);
        return (0, $7qXGD._)(this, $e999eec76d3b8abe$export$ba9bbe5370f1bf2f, arguments);
    }
    (0, $cFHGC._)($e999eec76d3b8abe$export$ba9bbe5370f1bf2f, [
        (0, $7Pjls._)({
            key: "getColor"
        }, "value", function getColor() {
            var box = $ec0d3058e92a8855$export$ac81f1ba58a5f363(), _this = this, colorName = _this.colorName;
            if (!box) return colorName === 'color' ? '#000000' : '#ffffff';
            var _getComputedStyle = getComputedStyle(box), color = _getComputedStyle[colorName];
            var _color_match = (0, $f9AOD._)(color.match(/\d+/g), 3), red = _color_match[0], green = _color_match[1], blue = _color_match[2];
            return '#' + (+red).toString(16).padStart(2, '0') + (+green).toString(16).padStart(2, '0') + (+blue).toString(16).padStart(2, '0');
        }),
        {
            key: "active",
            get: function get() {
                return !!this.getColor();
            }
        },
        {
            key: "execute",
            value: function execute(editor, color) {
                this.edit(editor, color);
            }
        }
    ]);
    return $e999eec76d3b8abe$export$ba9bbe5370f1bf2f;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$cab0e15cfb8489d7 = /*#__PURE__*/ function($e999eec76d3b8abe$export$ba9bbe5370f1bf2f) {
    "use strict";
    (0, $hdIku._)($e999eec76d3b8abe$export$cab0e15cfb8489d7, $e999eec76d3b8abe$export$ba9bbe5370f1bf2f);
    function $e999eec76d3b8abe$export$cab0e15cfb8489d7() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $e999eec76d3b8abe$export$cab0e15cfb8489d7);
        var _this;
        _this = (0, $7qXGD._)(this, $e999eec76d3b8abe$export$cab0e15cfb8489d7, (0, $aUGqu._)(args)), _this.name = 'Fore Color', _this.command = 'foreColor', _this.colorName = 'color';
        return _this;
    }
    return $e999eec76d3b8abe$export$cab0e15cfb8489d7;
}($ec0d3058e92a8855$export$ba9bbe5370f1bf2f);
var $ec0d3058e92a8855$export$92bb6183e7459be2 = /*#__PURE__*/ function($e999eec76d3b8abe$export$ba9bbe5370f1bf2f) {
    "use strict";
    (0, $hdIku._)($e999eec76d3b8abe$export$92bb6183e7459be2, $e999eec76d3b8abe$export$ba9bbe5370f1bf2f);
    function $e999eec76d3b8abe$export$92bb6183e7459be2() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $e999eec76d3b8abe$export$92bb6183e7459be2);
        var _this;
        _this = (0, $7qXGD._)(this, $e999eec76d3b8abe$export$92bb6183e7459be2, (0, $aUGqu._)(args)), _this.name = 'Back Color', _this.command = 'backColor', _this.colorName = 'backgroundColor';
        return _this;
    }
    return $e999eec76d3b8abe$export$92bb6183e7459be2;
}($ec0d3058e92a8855$export$ba9bbe5370f1bf2f);
var $ec0d3058e92a8855$var$$258f24df7a3cbf67$exports = {};
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$258f24df7a3cbf67$exports, "AlignTool", function() {
    return $ec0d3058e92a8855$export$6c1211091eb3b68f;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$258f24df7a3cbf67$exports, "AlignLeftTool", function() {
    return $ec0d3058e92a8855$export$42a444ebfdcfe7b9;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$258f24df7a3cbf67$exports, "AlignCenterTool", function() {
    return $ec0d3058e92a8855$export$9a2e6e0294a984eb;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$258f24df7a3cbf67$exports, "AlignRightTool", function() {
    return $ec0d3058e92a8855$export$22363f91860fc258;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$258f24df7a3cbf67$exports, "AlignFullTool", function() {
    return $ec0d3058e92a8855$export$42827b1362fed748;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$258f24df7a3cbf67$exports, "OrderedListTool", function() {
    return $ec0d3058e92a8855$export$faf4e70f09f43a15;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$258f24df7a3cbf67$exports, "UnorderedListTool", function() {
    return $ec0d3058e92a8855$export$cf4030b57a3fbe37;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$258f24df7a3cbf67$exports, "HorizontalRuleTool", function() {
    return $ec0d3058e92a8855$export$dce8a7d6279fc201;
});
var $ec0d3058e92a8855$export$6c1211091eb3b68f = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($258f24df7a3cbf67$export$6c1211091eb3b68f, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $258f24df7a3cbf67$export$6c1211091eb3b68f() {
        (0, $173N4._)(this, $258f24df7a3cbf67$export$6c1211091eb3b68f);
        return (0, $7qXGD._)(this, $258f24df7a3cbf67$export$6c1211091eb3b68f, arguments);
    }
    (0, $cFHGC._)($258f24df7a3cbf67$export$6c1211091eb3b68f, [
        {
            key: "active",
            get: function get() {
                if ((0, $dWsrg._)((0, $kg0zo._)($258f24df7a3cbf67$export$6c1211091eb3b68f.prototype), "getActive", this).call(this)) return true;
                var box = $ec0d3058e92a8855$export$ac81f1ba58a5f363();
                return !!box && getComputedStyle(box).textAlign === this.align;
            }
        }
    ]);
    return $258f24df7a3cbf67$export$6c1211091eb3b68f;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$42a444ebfdcfe7b9 = /*#__PURE__*/ function($258f24df7a3cbf67$export$6c1211091eb3b68f) {
    "use strict";
    (0, $hdIku._)($258f24df7a3cbf67$export$42a444ebfdcfe7b9, $258f24df7a3cbf67$export$6c1211091eb3b68f);
    function $258f24df7a3cbf67$export$42a444ebfdcfe7b9() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $258f24df7a3cbf67$export$42a444ebfdcfe7b9);
        var _this;
        _this = (0, $7qXGD._)(this, $258f24df7a3cbf67$export$42a444ebfdcfe7b9, (0, $aUGqu._)(args)), _this.name = 'Align Left', _this.command = 'justifyLeft', _this.align = 'left';
        return _this;
    }
    return $258f24df7a3cbf67$export$42a444ebfdcfe7b9;
}($ec0d3058e92a8855$export$6c1211091eb3b68f);
var $ec0d3058e92a8855$export$9a2e6e0294a984eb = /*#__PURE__*/ function($258f24df7a3cbf67$export$6c1211091eb3b68f) {
    "use strict";
    (0, $hdIku._)($258f24df7a3cbf67$export$9a2e6e0294a984eb, $258f24df7a3cbf67$export$6c1211091eb3b68f);
    function $258f24df7a3cbf67$export$9a2e6e0294a984eb() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $258f24df7a3cbf67$export$9a2e6e0294a984eb);
        var _this;
        _this = (0, $7qXGD._)(this, $258f24df7a3cbf67$export$9a2e6e0294a984eb, (0, $aUGqu._)(args)), _this.name = 'Align Center', _this.command = 'justifyCenter', _this.align = 'center';
        return _this;
    }
    return $258f24df7a3cbf67$export$9a2e6e0294a984eb;
}($ec0d3058e92a8855$export$6c1211091eb3b68f);
var $ec0d3058e92a8855$export$22363f91860fc258 = /*#__PURE__*/ function($258f24df7a3cbf67$export$6c1211091eb3b68f) {
    "use strict";
    (0, $hdIku._)($258f24df7a3cbf67$export$22363f91860fc258, $258f24df7a3cbf67$export$6c1211091eb3b68f);
    function $258f24df7a3cbf67$export$22363f91860fc258() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $258f24df7a3cbf67$export$22363f91860fc258);
        var _this;
        _this = (0, $7qXGD._)(this, $258f24df7a3cbf67$export$22363f91860fc258, (0, $aUGqu._)(args)), _this.name = 'Align Right', _this.command = 'justifyRight', _this.align = 'right';
        return _this;
    }
    return $258f24df7a3cbf67$export$22363f91860fc258;
}($ec0d3058e92a8855$export$6c1211091eb3b68f);
var $ec0d3058e92a8855$export$42827b1362fed748 = /*#__PURE__*/ function($258f24df7a3cbf67$export$6c1211091eb3b68f) {
    "use strict";
    (0, $hdIku._)($258f24df7a3cbf67$export$42827b1362fed748, $258f24df7a3cbf67$export$6c1211091eb3b68f);
    function $258f24df7a3cbf67$export$42827b1362fed748() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $258f24df7a3cbf67$export$42827b1362fed748);
        var _this;
        _this = (0, $7qXGD._)(this, $258f24df7a3cbf67$export$42827b1362fed748, (0, $aUGqu._)(args)), _this.name = 'Align Full', _this.command = 'justifyFull', _this.align = 'justify';
        return _this;
    }
    return $258f24df7a3cbf67$export$42827b1362fed748;
}($ec0d3058e92a8855$export$6c1211091eb3b68f);
var $ec0d3058e92a8855$export$faf4e70f09f43a15 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($258f24df7a3cbf67$export$faf4e70f09f43a15, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $258f24df7a3cbf67$export$faf4e70f09f43a15() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $258f24df7a3cbf67$export$faf4e70f09f43a15);
        var _this;
        _this = (0, $7qXGD._)(this, $258f24df7a3cbf67$export$faf4e70f09f43a15, (0, $aUGqu._)(args)), _this.name = 'Ordered list', _this.tags = [
            'ol'
        ], _this.command = 'insertOrderedList';
        return _this;
    }
    return $258f24df7a3cbf67$export$faf4e70f09f43a15;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$cf4030b57a3fbe37 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($258f24df7a3cbf67$export$cf4030b57a3fbe37, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $258f24df7a3cbf67$export$cf4030b57a3fbe37() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $258f24df7a3cbf67$export$cf4030b57a3fbe37);
        var _this;
        _this = (0, $7qXGD._)(this, $258f24df7a3cbf67$export$cf4030b57a3fbe37, (0, $aUGqu._)(args)), _this.name = 'Unordered list', _this.tags = [
            'ul'
        ], _this.command = 'insertUnorderedList';
        return _this;
    }
    return $258f24df7a3cbf67$export$cf4030b57a3fbe37;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$dce8a7d6279fc201 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($258f24df7a3cbf67$export$dce8a7d6279fc201, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $258f24df7a3cbf67$export$dce8a7d6279fc201() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $258f24df7a3cbf67$export$dce8a7d6279fc201);
        var _this;
        _this = (0, $7qXGD._)(this, $258f24df7a3cbf67$export$dce8a7d6279fc201, (0, $aUGqu._)(args)), _this.name = 'Horizontal rule', _this.tags = [
            'hr'
        ], _this.command = 'insertHorizontalRule';
        return _this;
    }
    return $258f24df7a3cbf67$export$dce8a7d6279fc201;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$var$$0769f8c709024b7a$exports = {};
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$0769f8c709024b7a$exports, "IFrameTool", function() {
    return $ec0d3058e92a8855$export$3e557574863db086;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$0769f8c709024b7a$exports, "ImageTool", function() {
    return $ec0d3058e92a8855$export$982f47444a2f88da;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$0769f8c709024b7a$exports, "AudioTool", function() {
    return $ec0d3058e92a8855$export$6024938f37e646f8;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$0769f8c709024b7a$exports, "VideoTool", function() {
    return $ec0d3058e92a8855$export$932111b8028f79ed;
});
var $ec0d3058e92a8855$export$3e557574863db086 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($0769f8c709024b7a$export$3e557574863db086, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $0769f8c709024b7a$export$3e557574863db086() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $0769f8c709024b7a$export$3e557574863db086);
        var _this;
        _this = (0, $7qXGD._)(this, $0769f8c709024b7a$export$3e557574863db086, (0, $aUGqu._)(args)), _this.name = 'Embed Web page', _this.tags = [
            'iframe'
        ], _this.command = 'insertHTML';
        return _this;
    }
    (0, $cFHGC._)($0769f8c709024b7a$export$3e557574863db086, [
        {
            key: "execute",
            value: function execute(editor) {
                var path = self.prompt('Path');
                if (path) this.edit(editor, '<iframe style="width: 100%; height: 50vh; border: none" src="'.concat(path, '"></iframe>'));
            }
        }
    ]);
    return $0769f8c709024b7a$export$3e557574863db086;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$982f47444a2f88da = /*#__PURE__*/ function($57ba63c17513cbba$export$de3122b2484864a7) {
    "use strict";
    (0, $hdIku._)($0769f8c709024b7a$export$982f47444a2f88da, $57ba63c17513cbba$export$de3122b2484864a7);
    function $0769f8c709024b7a$export$982f47444a2f88da() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $0769f8c709024b7a$export$982f47444a2f88da);
        var _this;
        _this = (0, $7qXGD._)(this, $0769f8c709024b7a$export$982f47444a2f88da, (0, $aUGqu._)(args)), _this.name = 'Image', _this.tags = [
            'img'
        ], _this.command = 'insertHTML';
        return _this;
    }
    (0, $cFHGC._)($0769f8c709024b7a$export$982f47444a2f88da, [
        {
            key: "codeOf",
            value: function codeOf(path) {
                return '<img style="max-width: 100%; height: auto" src="'.concat(path, '"/>');
            }
        }
    ]);
    return $0769f8c709024b7a$export$982f47444a2f88da;
}($ec0d3058e92a8855$export$de3122b2484864a7);
var $ec0d3058e92a8855$export$6024938f37e646f8 = /*#__PURE__*/ function($57ba63c17513cbba$export$de3122b2484864a7) {
    "use strict";
    (0, $hdIku._)($0769f8c709024b7a$export$6024938f37e646f8, $57ba63c17513cbba$export$de3122b2484864a7);
    function $0769f8c709024b7a$export$6024938f37e646f8() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $0769f8c709024b7a$export$6024938f37e646f8);
        var _this;
        _this = (0, $7qXGD._)(this, $0769f8c709024b7a$export$6024938f37e646f8, (0, $aUGqu._)(args)), _this.name = 'Audio', _this.tags = [
            'audio'
        ], _this.command = 'insertHTML';
        return _this;
    }
    (0, $cFHGC._)($0769f8c709024b7a$export$6024938f37e646f8, [
        {
            key: "codeOf",
            value: function codeOf(path) {
                return '<audio controls src="'.concat(path, '"></audio>');
            }
        }
    ]);
    return $0769f8c709024b7a$export$6024938f37e646f8;
}($ec0d3058e92a8855$export$de3122b2484864a7);
var $ec0d3058e92a8855$export$932111b8028f79ed = /*#__PURE__*/ function($57ba63c17513cbba$export$de3122b2484864a7) {
    "use strict";
    (0, $hdIku._)($0769f8c709024b7a$export$932111b8028f79ed, $57ba63c17513cbba$export$de3122b2484864a7);
    function $0769f8c709024b7a$export$932111b8028f79ed() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $0769f8c709024b7a$export$932111b8028f79ed);
        var _this;
        _this = (0, $7qXGD._)(this, $0769f8c709024b7a$export$932111b8028f79ed, (0, $aUGqu._)(args)), _this.name = 'Video', _this.tags = [
            'video'
        ], _this.command = 'insertHTML';
        return _this;
    }
    (0, $cFHGC._)($0769f8c709024b7a$export$932111b8028f79ed, [
        {
            key: "codeOf",
            value: function codeOf(path) {
                return '<video controls src="'.concat(path, '"></video>');
            }
        }
    ]);
    return $0769f8c709024b7a$export$932111b8028f79ed;
}($ec0d3058e92a8855$export$de3122b2484864a7);
var $ec0d3058e92a8855$var$$2c12cf671c105d76$exports = {};
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$2c12cf671c105d76$exports, "UndoTool", function() {
    return $ec0d3058e92a8855$export$65235875731ff287;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$2c12cf671c105d76$exports, "RedoTool", function() {
    return $ec0d3058e92a8855$export$b60f30d254d1e1a6;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$2c12cf671c105d76$exports, "ResetTool", function() {
    return $ec0d3058e92a8855$export$6f46dc3d81fbb4bd;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$2c12cf671c105d76$exports, "ClearTool", function() {
    return $ec0d3058e92a8855$export$25eb377ce1feaada;
});
var $ec0d3058e92a8855$export$65235875731ff287 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($2c12cf671c105d76$export$65235875731ff287, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $2c12cf671c105d76$export$65235875731ff287() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $2c12cf671c105d76$export$65235875731ff287);
        var _this;
        _this = (0, $7qXGD._)(this, $2c12cf671c105d76$export$65235875731ff287, (0, $aUGqu._)(args)), _this.name = 'Undo', _this.command = 'undo';
        return _this;
    }
    return $2c12cf671c105d76$export$65235875731ff287;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$b60f30d254d1e1a6 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($2c12cf671c105d76$export$b60f30d254d1e1a6, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $2c12cf671c105d76$export$b60f30d254d1e1a6() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $2c12cf671c105d76$export$b60f30d254d1e1a6);
        var _this;
        _this = (0, $7qXGD._)(this, $2c12cf671c105d76$export$b60f30d254d1e1a6, (0, $aUGqu._)(args)), _this.name = 'Redo', _this.command = 'redo';
        return _this;
    }
    return $2c12cf671c105d76$export$b60f30d254d1e1a6;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$6f46dc3d81fbb4bd = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($2c12cf671c105d76$export$6f46dc3d81fbb4bd, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $2c12cf671c105d76$export$6f46dc3d81fbb4bd() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $2c12cf671c105d76$export$6f46dc3d81fbb4bd);
        var _this;
        _this = (0, $7qXGD._)(this, $2c12cf671c105d76$export$6f46dc3d81fbb4bd, (0, $aUGqu._)(args)), _this.name = 'Reset', _this.command = 'removeFormat';
        return _this;
    }
    return $2c12cf671c105d76$export$6f46dc3d81fbb4bd;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$25eb377ce1feaada = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($2c12cf671c105d76$export$25eb377ce1feaada, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $2c12cf671c105d76$export$25eb377ce1feaada() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $2c12cf671c105d76$export$25eb377ce1feaada);
        var _this;
        _this = (0, $7qXGD._)(this, $2c12cf671c105d76$export$25eb377ce1feaada, (0, $aUGqu._)(args)), _this.name = 'Clear';
        return _this;
    }
    (0, $cFHGC._)($2c12cf671c105d76$export$25eb377ce1feaada, [
        {
            key: "execute",
            value: function execute(editor) {
                editor.focus();
                document.execCommand('selectAll');
                document.execCommand('delete');
            }
        }
    ]);
    return $2c12cf671c105d76$export$25eb377ce1feaada;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$var$$6e883fb0ea04260a$exports = {};
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$6e883fb0ea04260a$exports, "turndown", function() {
    return $ec0d3058e92a8855$export$48d4d6bf65314082;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$6e883fb0ea04260a$exports, "CopyMarkdownTool", function() {
    return $ec0d3058e92a8855$export$4b13df0a6effdd72;
});
var $ec0d3058e92a8855$var$$6e883fb0ea04260a$var$Empty_HREF = /^(#|javascript:\s*void\(0\);?\s*)$/;
var $ec0d3058e92a8855$export$48d4d6bf65314082 = new (0, $075446ebf04f5e91$export$2e2bcd8739ae039)({
    hr: '---',
    linkStyle: 'referenced',
    headingStyle: 'atx',
    bulletListMarker: '-',
    codeBlockStyle: 'fenced'
}).use((0, $7d59e34d58a0f292$export$19426ff118fe8be)).use((0, $7d59e34d58a0f292$export$cc4ff83fc7bd256e)).use((0, $7d59e34d58a0f292$export$1f0c2747e2ba0b8d)).use((0, $7d59e34d58a0f292$export$59ffe8c4d7a4aab2)).addRule('non_url', {
    filter: function(node) {
        return [
            'a',
            'area'
        ].includes(node.nodeName.toLowerCase()) && $ec0d3058e92a8855$var$$6e883fb0ea04260a$var$Empty_HREF.test(node.getAttribute('href') || '');
    },
    replacement: function() {
        return '';
    }
}).addRule('img-srcset', {
    filter: [
        'img'
    ],
    replacement: function(_, param) {
        var alt = param.alt, title = param.title, src = param.src, srcset = param.srcset;
        var _srcset_split_;
        var _ref = (0, $f9AOD._)(((_srcset_split_ = srcset.split(',')[0]) === null || _srcset_split_ === void 0 ? void 0 : _srcset_split_.split(/\s+/)) || [], 1), firstSet = _ref[0];
        var content = [
            src || firstSet,
            title && JSON.stringify(title)
        ].filter(Boolean);
        return "![".concat(alt, "](").concat(content.join(' '), ")");
    }
}).addRule('source-srcset', {
    filter: [
        'picture'
    ],
    replacement: function(_, node) {
        var _sources_;
        var _ref = node.querySelector('img') || {}, src = _ref.src, alt = _ref.alt, title = _ref.title;
        var sourceList = (0, $aUGqu._)(node.querySelectorAll('source')).map(function(param) {
            var sizes = param.sizes, srcset = param.srcset;
            var _Math;
            var _srcset_split_;
            var size = (_Math = Math).max.apply(_Math, (0, $aUGqu._)(sizes.split(/,|\)/).map(function(pixel) {
                return parseFloat(pixel.trim());
            }).filter(Boolean)));
            var _ref = (0, $f9AOD._)(((_srcset_split_ = srcset.split(',')[0]) === null || _srcset_split_ === void 0 ? void 0 : _srcset_split_.split(/\s+/)) || [], 1), src = _ref[0];
            return {
                size: size,
                src: src
            };
        });
        var sources = sourceList.sort(function(param, param1) {
            var a = param.size, b = param1.size;
            return b - a;
        });
        var content = [
            src || ((_sources_ = sources[0]) === null || _sources_ === void 0 ? void 0 : _sources_.src),
            title && JSON.stringify(title)
        ].filter(Boolean);
        return "![".concat(alt, "](").concat(content.join(' '), ")");
    }
}).remove(function(node) {
    return node.matches('style, script, aside, form, [class*="ads" i]');
}).keep(function(node) {
    return node.matches('kbd, iframe');
});
var $ec0d3058e92a8855$export$4b13df0a6effdd72 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $hdIku._)($6e883fb0ea04260a$export$4b13df0a6effdd72, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $6e883fb0ea04260a$export$4b13df0a6effdd72() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $6e883fb0ea04260a$export$4b13df0a6effdd72);
        var _this;
        _this = (0, $7qXGD._)(this, $6e883fb0ea04260a$export$4b13df0a6effdd72, (0, $aUGqu._)(args)), _this.name = 'Copy Markdown';
        return _this;
    }
    (0, $cFHGC._)($6e883fb0ea04260a$export$4b13df0a6effdd72, [
        {
            key: "execute",
            value: function execute(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function(param) {
                    var innerHTML, markdown;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                innerHTML = param.innerHTML;
                                markdown = $ec0d3058e92a8855$export$48d4d6bf65314082.turndown(innerHTML);
                                return [
                                    4,
                                    navigator.clipboard.writeText(markdown)
                                ];
                            case 1:
                                _state.sent();
                                alert('Markdown copied to clipboard');
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        }
    ]);
    return $6e883fb0ea04260a$export$4b13df0a6effdd72;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$var$$b738b8c7b1139833$exports = {};
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$b738b8c7b1139833$exports, "editor", function() {
    return $ec0d3058e92a8855$export$b5d042d2b680aed6;
});
var $ec0d3058e92a8855$export$b5d042d2b680aed6 = function(Class, param) {
    var ref = (0, $64559a1d4554a279$export$71511d61b312f219)(param);
    var EditorTrait = /*#__PURE__*/ function(Class) {
        "use strict";
        (0, $hdIku._)(EditorTrait, Class);
        function EditorTrait() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $173N4._)(this, EditorTrait);
            var _this;
            var _this1;
            _this = (0, $7qXGD._)(this, EditorTrait, (0, $aUGqu._)(args)), _this1 = _this, _this1.handlePasteDrop = function(event) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var root, list, _list_filter, plainText, htmlText, _iteratorNormalCompletion, _didIteratorError, _iteratorError, raw, _iterator, _step, item, err;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                event.preventDefault();
                                root = event.currentTarget;
                                list = event.type === 'paste' ? (0, $aUGqu._)(event.clipboardData.items) : (0, $aUGqu._)(event.dataTransfer.items);
                                root.focus();
                                _list_filter = (0, $f9AOD._)(list.filter(function(param) {
                                    var type = param.type;
                                    return type.startsWith('text/');
                                }), 2), plainText = _list_filter[0], htmlText = _list_filter[1];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (!(!htmlText && plainText.type === 'text/plain')) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        return plainText.getAsString(resolve);
                                    })
                                ];
                            case 1:
                                raw = _state.sent();
                                return [
                                    4,
                                    _this1.clearHTML((0, $l5IE3.marked)(raw))
                                ];
                            case 2:
                                (0, $lhPyT.insertToCursor).apply(void 0, [
                                    _state.sent()
                                ]);
                                return [
                                    3,
                                    10
                                ];
                            case 3:
                                _state.trys.push([
                                    3,
                                    8,
                                    9,
                                    10
                                ]);
                                _iterator = list[Symbol.iterator]();
                                _state.label = 4;
                            case 4:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    7
                                ];
                                item = _step.value;
                                return [
                                    4,
                                    _this1.transferMedia(item)
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    4
                                ];
                            case 7:
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 10:
                                _this1.updateValue(root.innerHTML);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            return _this;
        }
        (0, $cFHGC._)(EditorTrait, [
            {
                key: "uploadFile",
                value: function uploadFile(tool, data) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                        var _, _tmp, error;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (typeof data === 'string' && !/^(data|blob):/.test(data)) return [
                                        2,
                                        data
                                    ];
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        6,
                                        ,
                                        7
                                    ]);
                                    _ = tool.save;
                                    if (!(typeof data === 'string')) return [
                                        3,
                                        3
                                    ];
                                    return [
                                        4,
                                        (0, $lhPyT.blobOf)(data)
                                    ];
                                case 2:
                                    _tmp = _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 3:
                                    _tmp = data;
                                    _state.label = 4;
                                case 4:
                                    return [
                                        4,
                                        _.apply(tool, [
                                            _tmp
                                        ])
                                    ];
                                case 5:
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                                case 6:
                                    error = _state.sent();
                                    console.error(error);
                                    if (typeof data === 'string') return [
                                        2,
                                        data
                                    ];
                                    return [
                                        3,
                                        7
                                    ];
                                case 7:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            },
            {
                key: "clearHTML",
                value: function clearHTML(markup) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                        var _fragment, _this, imageTool, audioTool, videoTool, fragment, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, style, dataset, key, err;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this = this, imageTool = _this.imageTool, audioTool = _this.audioTool, videoTool = _this.videoTool, fragment = document.createDocumentFragment();
                                    (_fragment = fragment).append.apply(_fragment, (0, $aUGqu._)((0, $lhPyT.parseDOM)(markup)));
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        10,
                                        11,
                                        12
                                    ]);
                                    _iterator = (0, $lhPyT.walkDOM)(fragment, Node.ELEMENT_NODE)[Symbol.iterator]();
                                    _state.label = 2;
                                case 2:
                                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                        3,
                                        9
                                    ];
                                    element = _step.value;
                                    style = element.style, dataset = element.dataset;
                                    if ([
                                        'nowrap',
                                        'pre'
                                    ].includes(style.whiteSpace)) style.whiteSpace = 'normal';
                                    for(var key in dataset)delete dataset[key];
                                    if (!(element instanceof HTMLImageElement && imageTool)) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        this.uploadFile(imageTool, element.src)
                                    ];
                                case 3:
                                    element.src = _state.sent();
                                    return [
                                        3,
                                        8
                                    ];
                                case 4:
                                    if (!(element instanceof HTMLAudioElement && audioTool)) return [
                                        3,
                                        6
                                    ];
                                    return [
                                        4,
                                        this.uploadFile(audioTool, element.src)
                                    ];
                                case 5:
                                    element.src = _state.sent();
                                    return [
                                        3,
                                        8
                                    ];
                                case 6:
                                    if (!(element instanceof HTMLVideoElement && videoTool)) return [
                                        3,
                                        8
                                    ];
                                    return [
                                        4,
                                        this.uploadFile(videoTool, element.src)
                                    ];
                                case 7:
                                    element.src = _state.sent();
                                    _state.label = 8;
                                case 8:
                                    _iteratorNormalCompletion = true;
                                    return [
                                        3,
                                        2
                                    ];
                                case 9:
                                    return [
                                        3,
                                        12
                                    ];
                                case 10:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        12
                                    ];
                                case 11:
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                    return [
                                        7
                                    ];
                                case 12:
                                    return [
                                        2,
                                        fragment
                                    ];
                            }
                        });
                    }).call(this);
                }
            },
            {
                key: "transferMedia",
                value: function transferMedia(item) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                        var _this, imageTool, audioTool, videoTool, raw, URI, URI1, URI2;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this = this, imageTool = _this.imageTool, audioTool = _this.audioTool, videoTool = _this.videoTool;
                                    if (!(item.type === 'text/html')) return [
                                        3,
                                        3
                                    ];
                                    return [
                                        4,
                                        new Promise(function(resolve) {
                                            return item.getAsString(resolve);
                                        })
                                    ];
                                case 1:
                                    raw = _state.sent();
                                    return [
                                        4,
                                        this.clearHTML(raw)
                                    ];
                                case 2:
                                    (0, $lhPyT.insertToCursor).apply(void 0, [
                                        _state.sent()
                                    ]);
                                    return [
                                        3,
                                        9
                                    ];
                                case 3:
                                    if (!(item.type.startsWith('image/') && imageTool)) return [
                                        3,
                                        5
                                    ];
                                    return [
                                        4,
                                        this.uploadFile(imageTool, item.getAsFile())
                                    ];
                                case 4:
                                    URI = _state.sent();
                                    if (URI) (0, $lhPyT.insertToCursor)((0, $lhPyT.parseDOM)('<img src="'.concat(URI, '" />'))[0]);
                                    return [
                                        3,
                                        9
                                    ];
                                case 5:
                                    if (!(item.type.startsWith('audio/') && audioTool)) return [
                                        3,
                                        7
                                    ];
                                    return [
                                        4,
                                        this.uploadFile(audioTool, item.getAsFile())
                                    ];
                                case 6:
                                    URI1 = _state.sent();
                                    if (URI1) (0, $lhPyT.insertToCursor)((0, $lhPyT.parseDOM)('<audio src="'.concat(URI1, '" />'))[0]);
                                    return [
                                        3,
                                        9
                                    ];
                                case 7:
                                    if (!(item.type.startsWith('video/') && videoTool)) return [
                                        3,
                                        9
                                    ];
                                    return [
                                        4,
                                        this.uploadFile(videoTool, item.getAsFile())
                                    ];
                                case 8:
                                    URI2 = _state.sent();
                                    if (URI2) (0, $lhPyT.insertToCursor)((0, $lhPyT.parseDOM)('<video src="'.concat(URI2, '" />'))[0]);
                                    _state.label = 9;
                                case 9:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }).call(this);
                }
            }
        ]);
        return EditorTrait;
    }(Class);
    return EditorTrait;
};







var $h2kUE = parcelRequire("h2kUE");

var $79525742a8ef3cf9$exports = {};








var $cInIr = parcelRequire("cInIr");

var $h2kUE = parcelRequire("h2kUE");
parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");

var $lhPyT = parcelRequire("lhPyT");
function $79525742a8ef3cf9$var$$parcel$exportWildcard(e, t) {
    return Object.keys(t).forEach(function(r) {
        "default" === r || "__esModule" === r || Object.prototype.hasOwnProperty.call(e, r) || Object.defineProperty(e, r, {
            enumerable: !0,
            get: function get() {
                return t[r];
            }
        });
    }), e;
}
function $79525742a8ef3cf9$var$$parcel$interopDefault(e) {
    return e && e.__esModule ? e.default : e;
}
function $79525742a8ef3cf9$var$$parcel$export(e, t, r, a) {
    Object.defineProperty(e, t, {
        get: r,
        set: a,
        enumerable: !0,
        configurable: !0
    });
}
var $79525742a8ef3cf9$var$$0172b398bee57f0a$exports = {};
$79525742a8ef3cf9$var$$parcel$export($79525742a8ef3cf9$var$$0172b398bee57f0a$exports, "isEqualProps", function() {
    return $79525742a8ef3cf9$var$$0172b398bee57f0a$export$7112c88e033533b8;
}), $79525742a8ef3cf9$var$$parcel$export($79525742a8ef3cf9$var$$0172b398bee57f0a$exports, "ObservedComponent", function() {
    return $79525742a8ef3cf9$var$$0172b398bee57f0a$export$bf180ef329d1efd8;
});
var $79525742a8ef3cf9$var$$0172b398bee57f0a$var$__esDecorate = function $0172b398bee57f0a$var$__esDecorate(e, t, r, a, s, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, $ = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), f = !1, d = r.length - 1; d >= 0; d--){
        var b = {};
        for(var p in a)b[p] = "access" === p ? {} : a[p];
        for(var p in a.access)b.access[p] = a.access[p];
        b.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[d])("accessor" === o ? {
            get: $.get,
            set: $.set
        } : $[l], b);
        if ("accessor" === o) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (c = i(v.get)) && ($.get = c), (c = i(v.set)) && ($.set = c), (c = i(v.init)) && s.unshift(c);
        } else (c = i(v)) && ("field" === o ? s.unshift(c) : $[l] = c);
    }
    u && Object.defineProperty(u, a.name, $), f = !0;
}, $79525742a8ef3cf9$var$$0172b398bee57f0a$var$__runInitializers = function $0172b398bee57f0a$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, s = 0; s < t.length; s++)r = a ? t[s].call(e, r) : t[s].call(e);
    return a ? r : void 0;
}, $79525742a8ef3cf9$var$$0172b398bee57f0a$var$__classPrivateFieldGet = function $0172b398bee57f0a$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $79525742a8ef3cf9$var$$0172b398bee57f0a$var$__classPrivateFieldSet = function $0172b398bee57f0a$var$__classPrivateFieldSet(e, t, r, a, s) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !s) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !s : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? s.call(e, r) : s ? s.value = r : t.set(e, r), r;
}, $79525742a8ef3cf9$var$$0172b398bee57f0a$export$7112c88e033533b8 = function $0172b398bee57f0a$export$7112c88e033533b8(e, t) {
    return $79525742a8ef3cf9$var$$parcel$interopDefault($cInIr)(e, t, function(e, t, r) {
        return [
            "_owner",
            "$$typeof"
        ].includes(r) || void 0;
    });
}, $79525742a8ef3cf9$var$$0172b398bee57f0a$export$bf180ef329d1efd8 = function() {
    var e, t, r, a, s, n, i, c, o, l, u, $ = $tLNoZ.Component, f = [], d = [], b = [], p = [], v = [], _ = [];
    return r = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), a.set(_$e, $79525742a8ef3cf9$var$$0172b398bee57f0a$var$__runInitializers(_$e, f, _$e.props)), s.set(_$e, ($79525742a8ef3cf9$var$$0172b398bee57f0a$var$__runInitializers(_$e, d), $79525742a8ef3cf9$var$$0172b398bee57f0a$var$__runInitializers(_$e, b, _$e.state))), n.set(_$e, ($79525742a8ef3cf9$var$$0172b398bee57f0a$var$__runInitializers(_$e, p), $79525742a8ef3cf9$var$$0172b398bee57f0a$var$__runInitializers(_$e, v, _$e.context))), $79525742a8ef3cf9$var$$0172b398bee57f0a$var$__runInitializers(_$e, _), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "observedProps",
                get: function get() {
                    return $79525742a8ef3cf9$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function set(e) {
                    $79525742a8ef3cf9$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "observedState",
                get: function get() {
                    return $79525742a8ef3cf9$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, s, "f");
                },
                set: function set(e) {
                    $79525742a8ef3cf9$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, s, e, "f");
                }
            },
            {
                key: "observedContext",
                get: function get() {
                    return $79525742a8ef3cf9$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, n, "f");
                },
                set: function set(e) {
                    $79525742a8ef3cf9$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, n, e, "f");
                }
            },
            {
                key: "componentDidUpdate",
                value: function value(e, r, a) {
                    var s;
                    $79525742a8ef3cf9$var$$0172b398bee57f0a$export$7112c88e033533b8(e, this.props) || (this.observedProps = Object.assign({}, this.props)), $79525742a8ef3cf9$var$$0172b398bee57f0a$export$7112c88e033533b8(r, this.state) || (this.observedState = Object.assign({}, this.state)), null == (s = (0, $57751a2649dd1683$export$71511d61b312f219)((0, $ae6313b3cbf000af$export$71511d61b312f219)(t.prototype), "componentDidUpdate", this)) || s.call(this, e, r, a);
                }
            }
        ]), t;
    }($), a = new WeakMap, s = new WeakMap, n = new WeakMap, t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, o = [
        (e = $h2kUE.observable).shallow.bind(e)
    ], l = [
        (i = $h2kUE.observable).shallow.bind(i)
    ], u = [
        (c = $h2kUE.observable).shallow.bind(c)
    ], $79525742a8ef3cf9$var$$0172b398bee57f0a$var$__esDecorate(r, null, o, {
        kind: "accessor",
        name: "observedProps",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "observedProps" in e;
            },
            get: function get(e) {
                return e.observedProps;
            },
            set: function set(e, t) {
                e.observedProps = t;
            }
        },
        metadata: t
    }, f, d), $79525742a8ef3cf9$var$$0172b398bee57f0a$var$__esDecorate(r, null, l, {
        kind: "accessor",
        name: "observedState",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "observedState" in e;
            },
            get: function get(e) {
                return e.observedState;
            },
            set: function set(e, t) {
                e.observedState = t;
            }
        },
        metadata: t
    }, b, p), $79525742a8ef3cf9$var$$0172b398bee57f0a$var$__esDecorate(r, null, u, {
        kind: "accessor",
        name: "observedContext",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "observedContext" in e;
            },
            get: function get(e) {
                return e.observedContext;
            },
            set: function set(e, t) {
                e.observedContext = t;
            }
        },
        metadata: t
    }, v, _), t && Object.defineProperty(r, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), r;
}(), $79525742a8ef3cf9$var$$621b7277d4dc39e9$exports = {};
$79525742a8ef3cf9$var$$parcel$export($79525742a8ef3cf9$var$$621b7277d4dc39e9$exports, "FormComponent", function() {
    return $79525742a8ef3cf9$var$$621b7277d4dc39e9$export$cec7cafc710f5d68;
});
var $79525742a8ef3cf9$var$$621b7277d4dc39e9$var$__runInitializers = function $621b7277d4dc39e9$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, s = 0; s < t.length; s++)r = a ? t[s].call(e, r) : t[s].call(e);
    return a ? r : void 0;
}, $79525742a8ef3cf9$var$$621b7277d4dc39e9$var$__esDecorate = function $621b7277d4dc39e9$var$__esDecorate(e, t, r, a, s, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, $ = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), f = !1, d = r.length - 1; d >= 0; d--){
        var b = {};
        for(var p in a)b[p] = "access" === p ? {} : a[p];
        for(var p in a.access)b.access[p] = a.access[p];
        b.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[d])("accessor" === o ? {
            get: $.get,
            set: $.set
        } : $[l], b);
        if ("accessor" === o) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (c = i(v.get)) && ($.get = c), (c = i(v.set)) && ($.set = c), (c = i(v.init)) && s.unshift(c);
        } else (c = i(v)) && ("field" === o ? s.unshift(c) : $[l] = c);
    }
    u && Object.defineProperty(u, a.name, $), f = !0;
}, $79525742a8ef3cf9$var$$621b7277d4dc39e9$var$__classPrivateFieldGet = function $621b7277d4dc39e9$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $79525742a8ef3cf9$var$$621b7277d4dc39e9$var$__classPrivateFieldSet = function $621b7277d4dc39e9$var$__classPrivateFieldSet(e, t, r, a, s) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !s) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !s : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? s.call(e, r) : s ? s.value = r : t.set(e, r), r;
}, $79525742a8ef3cf9$var$$621b7277d4dc39e9$export$cec7cafc710f5d68 = function() {
    var e, t, r, a, s, n, i, c, o, l = [], u = [], $ = [];
    return e = function(e) {
        "use strict";
        function n() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, n), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, n, arguments), Object.defineProperty(_$e, "ref", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($79525742a8ef3cf9$var$$621b7277d4dc39e9$var$__runInitializers(_$e, l), (0, $tLNoZ.createRef)())
            }), s.set(_$e, $79525742a8ef3cf9$var$$621b7277d4dc39e9$var$__runInitializers(_$e, u, _$e.props.defaultValue)), t.set(_$e, $79525742a8ef3cf9$var$$621b7277d4dc39e9$var$__runInitializers(_$e, $)), r.set(_$e, void 0), a.set(_$e, function(t) {
                !(0, $lhPyT.isEmpty)(t) && (0, $lhPyT.isEmpty)(_$e.innerValue) && (_$e.innerValue = t);
            }), Object.defineProperty(_$e, "emitValue", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    var r, a;
                    return null == (a = (r = _$e.observedProps).onChange) ? void 0 : a.call(r, t && (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "object" ? (0, $h2kUE.toJS)(t) : t);
                }
            }), Object.defineProperty(_$e, "reset", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value() {
                    return _$e.innerValue = _$e.props.defaultValue;
                }
            }), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(n, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(n, [
            {
                key: "innerValue",
                get: function get() {
                    return $79525742a8ef3cf9$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, s, "f");
                },
                set: function set(e) {
                    $79525742a8ef3cf9$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, s, e, "f");
                }
            },
            {
                key: "value",
                get: function get() {
                    var _$e;
                    return null != (_$e = this.observedProps.value) ? _$e : this.innerValue;
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    var _$e, s, _$n = this;
                    $79525742a8ef3cf9$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, t, (0, $h2kUE.reaction)(function() {
                        return _$n.observedProps.defaultValue;
                    }, $79525742a8ef3cf9$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, a, "f")), "f"), $79525742a8ef3cf9$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, r, (0, $h2kUE.reaction)(function() {
                        return _$n.innerValue;
                    }, this.emitValue), "f"), null == (s = null == (_$e = this.ref.current) ? void 0 : _$e.form) || s.addEventListener("reset", this.reset);
                }
            },
            {
                key: "componentWillUnmount",
                value: function value() {
                    var _$e, a, s, _$n;
                    null == (_$e = $79525742a8ef3cf9$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, t, "f")) || _$e.call(this), $79525742a8ef3cf9$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, t, void 0, "f"), null == (a = $79525742a8ef3cf9$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, r, "f")) || a.call(this), $79525742a8ef3cf9$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, r, void 0, "f"), null == (_$n = null == (s = this.ref.current) ? void 0 : s.form) || _$n.removeEventListener("reset", this.reset);
                }
            }
        ]), n;
    }($79525742a8ef3cf9$var$$0172b398bee57f0a$export$bf180ef329d1efd8), t = new WeakMap, r = new WeakMap, a = new WeakMap, s = new WeakMap, o = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (c = $79525742a8ef3cf9$var$$0172b398bee57f0a$export$bf180ef329d1efd8[Symbol.metadata]) ? c : null) : void 0, n = [
        $h2kUE.observable
    ], i = [
        $h2kUE.computed
    ], $79525742a8ef3cf9$var$$621b7277d4dc39e9$var$__esDecorate(e, null, n, {
        kind: "accessor",
        name: "innerValue",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "innerValue" in e;
            },
            get: function get(e) {
                return e.innerValue;
            },
            set: function set(e, t) {
                e.innerValue = t;
            }
        },
        metadata: o
    }, u, $), $79525742a8ef3cf9$var$$621b7277d4dc39e9$var$__esDecorate(e, null, i, {
        kind: "getter",
        name: "value",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "value" in e;
            },
            get: function get(e) {
                return e.value;
            }
        },
        metadata: o
    }, null, l), o && Object.defineProperty(e, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: o
    }), e;
}();
$79525742a8ef3cf9$var$$parcel$exportWildcard($79525742a8ef3cf9$exports, $79525742a8ef3cf9$var$$0172b398bee57f0a$exports), $79525742a8ef3cf9$var$$parcel$exportWildcard($79525742a8ef3cf9$exports, $79525742a8ef3cf9$var$$621b7277d4dc39e9$exports);


parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");
function $d1b3805234fdf37f$var$$parcel$exportWildcard(e, r) {
    return Object.keys(r).forEach(function(c) {
        "default" === c || "__esModule" === c || Object.prototype.hasOwnProperty.call(e, c) || Object.defineProperty(e, c, {
            enumerable: !0,
            get: function get() {
                return r[c];
            }
        });
    }), e;
}
function $d1b3805234fdf37f$var$$parcel$export(e, r, c, t) {
    Object.defineProperty(e, r, {
        get: c,
        set: t,
        enumerable: !0,
        configurable: !0
    });
}
var $d1b3805234fdf37f$var$$73a8882fd67c0324$exports = {};
function $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363(e) {
    var r = this, c = this.title, t = this.active, a = this.icon, $ = this.usable;
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("button", {
        type: "button",
        title: c,
        className: "btn btn-".concat((t ? "" : "outline-") + "secondary", " me-2 mb-2"),
        style: {
            cursor: $ ? "pointer" : "not-allowed"
        },
        disabled: !$,
        onClick: function onClick(c) {
            c.preventDefault(), e.current && r.execute(e.current);
        },
        children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("i", {
            className: "bi-".concat(a)
        })
    }, a);
}
$d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$73a8882fd67c0324$exports, "renderTool", function() {
    return $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363;
});
var $d1b3805234fdf37f$var$$a01145bb2edfc771$exports = {};
$d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$a01145bb2edfc771$exports, "TextTools", function() {
    return $d1b3805234fdf37f$var$$a01145bb2edfc771$export$e252ba763eff5cdc;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$a01145bb2edfc771$exports, "ColorTools", function() {
    return $d1b3805234fdf37f$var$$a01145bb2edfc771$export$bdef6e97a10dbad4;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$a01145bb2edfc771$exports, "LayoutTools", function() {
    return $d1b3805234fdf37f$var$$a01145bb2edfc771$export$145c1b37c0810d7;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$a01145bb2edfc771$exports, "MediaTools", function() {
    return $d1b3805234fdf37f$var$$a01145bb2edfc771$export$999636c6e25075fb;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$a01145bb2edfc771$exports, "ControlTools", function() {
    return $d1b3805234fdf37f$var$$a01145bb2edfc771$export$f35db4b82786c3a4;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$a01145bb2edfc771$exports, "ExtraTools", function() {
    return $d1b3805234fdf37f$var$$a01145bb2edfc771$export$b8ecf7d74432d529;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$a01145bb2edfc771$exports, "OriginalTools", function() {
    return $d1b3805234fdf37f$var$$a01145bb2edfc771$export$9ddb256264948609;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$a01145bb2edfc771$exports, "DefaultTools", function() {
    return $d1b3805234fdf37f$var$$a01145bb2edfc771$export$aa718db1466ce312;
});
var $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$exports = {};
$d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$fe2cab60e3c7ea35$exports, "BoldTool", function() {
    return $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$10056a49e3b218eb;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$fe2cab60e3c7ea35$exports, "ItalicTool", function() {
    return $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$edf99d0f51bacb1e;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$fe2cab60e3c7ea35$exports, "UnderlineTool", function() {
    return $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$4b6d9c17188960d2;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$fe2cab60e3c7ea35$exports, "StrikeThroughTool", function() {
    return $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$a35bffaeae8fdda0;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$fe2cab60e3c7ea35$exports, "H1Tool", function() {
    return $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$30e8c6b428f8749f;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$fe2cab60e3c7ea35$exports, "H2Tool", function() {
    return $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$58443375efa91029;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$fe2cab60e3c7ea35$exports, "H3Tool", function() {
    return $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$75d24d6b8b747307;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$fe2cab60e3c7ea35$exports, "FontSizeDownTool", function() {
    return $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$a20806c6ef6938f8;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$fe2cab60e3c7ea35$exports, "FontSizeUpTool", function() {
    return $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$744da7e24e4a7382;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$fe2cab60e3c7ea35$exports, "SubscriptTool", function() {
    return $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$6137518b4e998008;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$fe2cab60e3c7ea35$exports, "SuperscriptTool", function() {
    return $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$7217f06c61ebd4fc;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$fe2cab60e3c7ea35$exports, "LinkTool", function() {
    return $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$f6c54364b5332e66;
});
var $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$10056a49e3b218eb = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-bold"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$10056a49e3b218eb), $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$edf99d0f51bacb1e = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-italic"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$edf99d0f51bacb1e), $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$4b6d9c17188960d2 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-underline"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$4b6d9c17188960d2), $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$a35bffaeae8fdda0 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-strikethrough"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$a35bffaeae8fdda0), $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$30e8c6b428f8749f = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-h1"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$30e8c6b428f8749f), $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$58443375efa91029 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-h2"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$58443375efa91029), $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$75d24d6b8b747307 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-h3"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$75d24d6b8b747307), $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$a20806c6ef6938f8 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "sort-alpha-down"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$a20806c6ef6938f8), $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$744da7e24e4a7382 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "sort-alpha-up"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$744da7e24e4a7382), $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$6137518b4e998008 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "box-arrow-down-right"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$6137518b4e998008), $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$7217f06c61ebd4fc = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "box-arrow-up-right"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$7217f06c61ebd4fc), $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$f6c54364b5332e66 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "link"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$f6c54364b5332e66), $d1b3805234fdf37f$var$$b1f503bd59fa3427$exports = {};
$d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$b1f503bd59fa3427$exports, "ColorSelector", function() {
    return $d1b3805234fdf37f$var$$b1f503bd59fa3427$export$9012acaf449cdfcb;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$b1f503bd59fa3427$exports, "renderColorTool", function() {
    return $d1b3805234fdf37f$var$$b1f503bd59fa3427$export$e913fac2ab7b6f29;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$b1f503bd59fa3427$exports, "ForeColorTool", function() {
    return $d1b3805234fdf37f$var$$b1f503bd59fa3427$export$cab0e15cfb8489d7;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$b1f503bd59fa3427$exports, "BackColorTool", function() {
    return $d1b3805234fdf37f$var$$b1f503bd59fa3427$export$92bb6183e7459be2;
});
var $d1b3805234fdf37f$var$$b1f503bd59fa3427$export$9012acaf449cdfcb = function $b1f503bd59fa3427$export$9012acaf449cdfcb(e) {
    var r = e.className, c = e.title, t = e.type, a = e.value, $ = e.onChange, o = e.icon;
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("span", {
        className: "d-inline-block align-middle position-relative ".concat(void 0 === r ? "" : r),
        title: c,
        children: [
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("input", {
                className: "position-absolute w-100 h-100 start-0 top-0 z-n1 rounded-3",
                type: "color",
                value: a,
                onChange: function onChange(e) {
                    var r = e.target.value;
                    return null == $ ? void 0 : $(r);
                }
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("button", {
                className: "btn",
                style: {
                    color: "color" === t ? a : "lightgray",
                    backgroundColor: "color" === t ? "white" : a,
                    borderColor: a
                },
                onClick: function onClick(e) {
                    e.preventDefault(), e.currentTarget.previousElementSibling.click();
                },
                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("i", {
                    className: "bi-".concat(o)
                })
            })
        ]
    });
};
function $d1b3805234fdf37f$var$$b1f503bd59fa3427$export$e913fac2ab7b6f29(e) {
    var r = this, c = this.icon, t = this.name, a = this.colorName;
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($d1b3805234fdf37f$var$$b1f503bd59fa3427$export$9012acaf449cdfcb, {
        className: "me-2 mb-2",
        title: t,
        icon: c,
        type: a,
        value: this.getColor(),
        onChange: function onChange(c) {
            return e.current && r.execute(e.current, c);
        }
    }, c);
}
var $d1b3805234fdf37f$var$$b1f503bd59fa3427$export$cab0e15cfb8489d7 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "file-earmark-font"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$b1f503bd59fa3427$export$e913fac2ab7b6f29
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$cab0e15cfb8489d7), $d1b3805234fdf37f$var$$b1f503bd59fa3427$export$92bb6183e7459be2 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "file-earmark-font-fill"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$b1f503bd59fa3427$export$e913fac2ab7b6f29
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$92bb6183e7459be2), $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$exports = {};
$d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$eb30d0fbb9378b9a$exports, "AlignLeftTool", function() {
    return $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$42a444ebfdcfe7b9;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$eb30d0fbb9378b9a$exports, "AlignCenterTool", function() {
    return $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$9a2e6e0294a984eb;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$eb30d0fbb9378b9a$exports, "AlignRightTool", function() {
    return $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$22363f91860fc258;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$eb30d0fbb9378b9a$exports, "AlignFullTool", function() {
    return $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$42827b1362fed748;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$eb30d0fbb9378b9a$exports, "OrderedListTool", function() {
    return $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$faf4e70f09f43a15;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$eb30d0fbb9378b9a$exports, "UnorderedListTool", function() {
    return $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$cf4030b57a3fbe37;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$eb30d0fbb9378b9a$exports, "HorizontalRuleTool", function() {
    return $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$dce8a7d6279fc201;
});
var $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$42a444ebfdcfe7b9 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "text-left"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$42a444ebfdcfe7b9), $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$9a2e6e0294a984eb = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "text-center"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$9a2e6e0294a984eb), $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$22363f91860fc258 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "text-right"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$22363f91860fc258), $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$42827b1362fed748 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "justify"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$42827b1362fed748), $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$faf4e70f09f43a15 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "list-ol"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$faf4e70f09f43a15), $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$cf4030b57a3fbe37 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "list-ul"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$cf4030b57a3fbe37), $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$dce8a7d6279fc201 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "reception-0"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$dce8a7d6279fc201), $d1b3805234fdf37f$var$$345f51138f435756$exports = {};
$d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$345f51138f435756$exports, "IFrameTool", function() {
    return $d1b3805234fdf37f$var$$345f51138f435756$export$3e557574863db086;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$345f51138f435756$exports, "ImageTool", function() {
    return $d1b3805234fdf37f$var$$345f51138f435756$export$982f47444a2f88da;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$345f51138f435756$exports, "AudioTool", function() {
    return $d1b3805234fdf37f$var$$345f51138f435756$export$6024938f37e646f8;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$345f51138f435756$exports, "VideoTool", function() {
    return $d1b3805234fdf37f$var$$345f51138f435756$export$932111b8028f79ed;
});
var $d1b3805234fdf37f$var$$345f51138f435756$export$3e557574863db086 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "window"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$3e557574863db086), $d1b3805234fdf37f$var$$345f51138f435756$export$982f47444a2f88da = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "image"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$982f47444a2f88da), $d1b3805234fdf37f$var$$345f51138f435756$export$6024938f37e646f8 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "voicemail"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$6024938f37e646f8), $d1b3805234fdf37f$var$$345f51138f435756$export$932111b8028f79ed = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "camera-video"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$932111b8028f79ed), $d1b3805234fdf37f$var$$15eac7d4db191f2f$exports = {};
$d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$15eac7d4db191f2f$exports, "UndoTool", function() {
    return $d1b3805234fdf37f$var$$15eac7d4db191f2f$export$65235875731ff287;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$15eac7d4db191f2f$exports, "RedoTool", function() {
    return $d1b3805234fdf37f$var$$15eac7d4db191f2f$export$b60f30d254d1e1a6;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$15eac7d4db191f2f$exports, "ResetTool", function() {
    return $d1b3805234fdf37f$var$$15eac7d4db191f2f$export$6f46dc3d81fbb4bd;
}), $d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$15eac7d4db191f2f$exports, "ClearTool", function() {
    return $d1b3805234fdf37f$var$$15eac7d4db191f2f$export$25eb377ce1feaada;
});
var $d1b3805234fdf37f$var$$15eac7d4db191f2f$export$65235875731ff287 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "arrow-counterclockwise"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$65235875731ff287), $d1b3805234fdf37f$var$$15eac7d4db191f2f$export$b60f30d254d1e1a6 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "arrow-clockwise"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$b60f30d254d1e1a6), $d1b3805234fdf37f$var$$15eac7d4db191f2f$export$6f46dc3d81fbb4bd = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "eraser"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$6f46dc3d81fbb4bd), $d1b3805234fdf37f$var$$15eac7d4db191f2f$export$25eb377ce1feaada = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "file-earmark-x"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$25eb377ce1feaada), $d1b3805234fdf37f$var$$b9bef41109a8f18c$exports = {};
$d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$b9bef41109a8f18c$exports, "CopyMarkdownTool", function() {
    return $d1b3805234fdf37f$var$$b9bef41109a8f18c$export$4b13df0a6effdd72;
});
var $d1b3805234fdf37f$var$$b9bef41109a8f18c$export$4b13df0a6effdd72 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "markdown"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d1b3805234fdf37f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$4b13df0a6effdd72), $d1b3805234fdf37f$var$$a01145bb2edfc771$export$e252ba763eff5cdc = [
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$10056a49e3b218eb,
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$edf99d0f51bacb1e,
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$4b6d9c17188960d2,
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$a35bffaeae8fdda0,
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$30e8c6b428f8749f,
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$58443375efa91029,
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$75d24d6b8b747307,
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$a20806c6ef6938f8,
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$744da7e24e4a7382,
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$6137518b4e998008,
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$7217f06c61ebd4fc,
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$f6c54364b5332e66
], $d1b3805234fdf37f$var$$a01145bb2edfc771$export$bdef6e97a10dbad4 = [
    $d1b3805234fdf37f$var$$b1f503bd59fa3427$export$cab0e15cfb8489d7,
    $d1b3805234fdf37f$var$$b1f503bd59fa3427$export$92bb6183e7459be2
], $d1b3805234fdf37f$var$$a01145bb2edfc771$export$145c1b37c0810d7 = [
    $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$42a444ebfdcfe7b9,
    $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$9a2e6e0294a984eb,
    $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$22363f91860fc258,
    $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$42827b1362fed748,
    $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$faf4e70f09f43a15,
    $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$cf4030b57a3fbe37,
    $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$dce8a7d6279fc201
], $d1b3805234fdf37f$var$$a01145bb2edfc771$export$999636c6e25075fb = [
    $d1b3805234fdf37f$var$$345f51138f435756$export$3e557574863db086,
    $d1b3805234fdf37f$var$$345f51138f435756$export$982f47444a2f88da,
    $d1b3805234fdf37f$var$$345f51138f435756$export$6024938f37e646f8,
    $d1b3805234fdf37f$var$$345f51138f435756$export$932111b8028f79ed
], $d1b3805234fdf37f$var$$a01145bb2edfc771$export$f35db4b82786c3a4 = [
    $d1b3805234fdf37f$var$$15eac7d4db191f2f$export$65235875731ff287,
    $d1b3805234fdf37f$var$$15eac7d4db191f2f$export$b60f30d254d1e1a6,
    $d1b3805234fdf37f$var$$15eac7d4db191f2f$export$6f46dc3d81fbb4bd,
    $d1b3805234fdf37f$var$$15eac7d4db191f2f$export$25eb377ce1feaada
], $d1b3805234fdf37f$var$$a01145bb2edfc771$export$b8ecf7d74432d529 = [
    $d1b3805234fdf37f$var$$b9bef41109a8f18c$export$4b13df0a6effdd72
], $d1b3805234fdf37f$var$$a01145bb2edfc771$export$9ddb256264948609 = (0, $2b3349705fb2cb54$export$71511d61b312f219)($d1b3805234fdf37f$var$$a01145bb2edfc771$export$e252ba763eff5cdc).concat((0, $2b3349705fb2cb54$export$71511d61b312f219)($d1b3805234fdf37f$var$$a01145bb2edfc771$export$bdef6e97a10dbad4), (0, $2b3349705fb2cb54$export$71511d61b312f219)($d1b3805234fdf37f$var$$a01145bb2edfc771$export$145c1b37c0810d7), (0, $2b3349705fb2cb54$export$71511d61b312f219)($d1b3805234fdf37f$var$$a01145bb2edfc771$export$999636c6e25075fb), (0, $2b3349705fb2cb54$export$71511d61b312f219)($d1b3805234fdf37f$var$$a01145bb2edfc771$export$f35db4b82786c3a4)), $d1b3805234fdf37f$var$$a01145bb2edfc771$export$aa718db1466ce312 = [
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$10056a49e3b218eb,
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$edf99d0f51bacb1e,
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$4b6d9c17188960d2,
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$a35bffaeae8fdda0,
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$30e8c6b428f8749f,
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$58443375efa91029,
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$75d24d6b8b747307,
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$6137518b4e998008,
    $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$export$7217f06c61ebd4fc,
    $d1b3805234fdf37f$var$$b1f503bd59fa3427$export$cab0e15cfb8489d7,
    $d1b3805234fdf37f$var$$b1f503bd59fa3427$export$92bb6183e7459be2,
    $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$42a444ebfdcfe7b9,
    $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$9a2e6e0294a984eb,
    $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$22363f91860fc258,
    $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$42827b1362fed748,
    $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$faf4e70f09f43a15,
    $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$cf4030b57a3fbe37,
    $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$export$dce8a7d6279fc201,
    $d1b3805234fdf37f$var$$345f51138f435756$export$982f47444a2f88da,
    $d1b3805234fdf37f$var$$15eac7d4db191f2f$export$65235875731ff287,
    $d1b3805234fdf37f$var$$15eac7d4db191f2f$export$b60f30d254d1e1a6,
    $d1b3805234fdf37f$var$$15eac7d4db191f2f$export$25eb377ce1feaada
];
$d1b3805234fdf37f$var$$parcel$exportWildcard($d1b3805234fdf37f$var$$a01145bb2edfc771$exports, $d1b3805234fdf37f$var$$fe2cab60e3c7ea35$exports), $d1b3805234fdf37f$var$$parcel$exportWildcard($d1b3805234fdf37f$var$$a01145bb2edfc771$exports, $d1b3805234fdf37f$var$$b1f503bd59fa3427$exports), $d1b3805234fdf37f$var$$parcel$exportWildcard($d1b3805234fdf37f$var$$a01145bb2edfc771$exports, $d1b3805234fdf37f$var$$eb30d0fbb9378b9a$exports), $d1b3805234fdf37f$var$$parcel$exportWildcard($d1b3805234fdf37f$var$$a01145bb2edfc771$exports, $d1b3805234fdf37f$var$$345f51138f435756$exports), $d1b3805234fdf37f$var$$parcel$exportWildcard($d1b3805234fdf37f$var$$a01145bb2edfc771$exports, $d1b3805234fdf37f$var$$15eac7d4db191f2f$exports), $d1b3805234fdf37f$var$$parcel$exportWildcard($d1b3805234fdf37f$var$$a01145bb2edfc771$exports, $d1b3805234fdf37f$var$$b9bef41109a8f18c$exports);
var $d1b3805234fdf37f$var$$68aab1d0e8e5016c$exports = {};
$d1b3805234fdf37f$var$$parcel$export($d1b3805234fdf37f$var$$68aab1d0e8e5016c$exports, "Editor", function() {
    return $d1b3805234fdf37f$var$$68aab1d0e8e5016c$export$7cda8d932e2f33c0;
});
var $d1b3805234fdf37f$var$$68aab1d0e8e5016c$var$__runInitializers = function $68aab1d0e8e5016c$var$__runInitializers(e, r, c) {
    for(var t = arguments.length > 2, a = 0; a < r.length; a++)c = t ? r[a].call(e, c) : r[a].call(e);
    return t ? c : void 0;
}, $d1b3805234fdf37f$var$$68aab1d0e8e5016c$var$__esDecorate = function $68aab1d0e8e5016c$var$__esDecorate(e, r, c, t, a, $) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var s, n = t.kind, l = "getter" === n ? "get" : "setter" === n ? "set" : "value", i = !r && e ? t.static ? e : e.prototype : null, u = r || (i ? Object.getOwnPropertyDescriptor(i, t.name) : {}), b = !1, p = c.length - 1; p >= 0; p--){
        var f = {};
        for(var d in t)f[d] = "access" === d ? {} : t[d];
        for(var d in t.access)f.access[d] = t.access[d];
        f.addInitializer = function(e) {
            if (b) throw TypeError("Cannot add initializers after decoration has completed");
            $.push(o(e || null));
        };
        var _ = (0, c[p])("accessor" === n ? {
            get: u.get,
            set: u.set
        } : u[l], f);
        if ("accessor" === n) {
            if (void 0 === _) continue;
            if (null === _ || (void 0 === _ ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(_)) !== "object") throw TypeError("Object expected");
            (s = o(_.get)) && (u.get = s), (s = o(_.set)) && (u.set = s), (s = o(_.init)) && a.unshift(s);
        } else (s = o(_)) && ("field" === n ? a.unshift(s) : u[l] = s);
    }
    i && Object.defineProperty(i, t.name, u), b = !0;
}, $d1b3805234fdf37f$var$$68aab1d0e8e5016c$var$__setFunctionName = function $68aab1d0e8e5016c$var$__setFunctionName(e, r, c) {
    return (void 0 === r ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(r)) === "symbol" && (r = r.description ? "[".concat(r.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: c ? "".concat(c, " ", r) : r
    });
}, $d1b3805234fdf37f$var$$68aab1d0e8e5016c$var$__classPrivateFieldGet = function $68aab1d0e8e5016c$var$__classPrivateFieldGet(e, r, c, t) {
    if ("a" === c && !t) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof r ? e !== r || !t : !r.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === c ? t : "a" === c ? t.call(e) : t ? t.value : r.get(e);
}, $d1b3805234fdf37f$var$$68aab1d0e8e5016c$var$__classPrivateFieldSet = function $68aab1d0e8e5016c$var$__classPrivateFieldSet(e, r, c, t, a) {
    if ("m" === t) throw TypeError("Private method is not writable");
    if ("a" === t && !a) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof r ? e !== r || !a : !r.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === t ? a.call(e, c) : a ? a.value = c : r.set(e, c), c;
}, $d1b3805234fdf37f$var$$68aab1d0e8e5016c$export$7cda8d932e2f33c0 = function() {
    var e, r, c, t, a, $, o, s, n, l, i = [
        $e04d4b638436dc5e$export$b6ae1bc530f4c149,
        $ec0d3058e92a8855$export$b5d042d2b680aed6
    ], u = [], b = $79525742a8ef3cf9$exports.FormComponent, p = [], f = [], d = [];
    return a = function(e) {
        "use strict";
        function r() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, r), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "box", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($d1b3805234fdf37f$var$$68aab1d0e8e5016c$var$__runInitializers(_$e, p), (0, $tLNoZ.createRef)())
            }), c.set(_$e, $d1b3805234fdf37f$var$$68aab1d0e8e5016c$var$__runInitializers(_$e, f, "")), Object.defineProperty(_$e, "updateTools", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($d1b3805234fdf37f$var$$68aab1d0e8e5016c$var$__runInitializers(_$e, d), function() {
                    if (_$e.box.current === document.activeElement) {
                        var _$r, c = (getSelection().getRangeAt(0) || {}).endContainer, t = (null == (_$r = c instanceof Element ? c : c.parentElement) ? void 0 : _$r.getBoundingClientRect()) || {};
                        _$e.cursorPoint = [
                            t.x,
                            t.y
                        ] + "";
                    }
                })
            }), Object.defineProperty(_$e, "updateValue", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(r) {
                    return _$e.innerValue = r.trim();
                }
            }), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(r, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(r, [
            {
                key: "cursorPoint",
                get: function get() {
                    return $d1b3805234fdf37f$var$$68aab1d0e8e5016c$var$__classPrivateFieldGet(this, c, "f");
                },
                set: function set(e) {
                    $d1b3805234fdf37f$var$$68aab1d0e8e5016c$var$__classPrivateFieldSet(this, c, e, "f");
                }
            },
            {
                key: "toolList",
                get: function get() {
                    return (this.observedProps.tools || $d1b3805234fdf37f$var$$a01145bb2edfc771$export$aa718db1466ce312).map(function(e) {
                        return new e;
                    });
                }
            },
            {
                key: "imageTool",
                get: function get() {
                    return this.toolList.find(function(e) {
                        return e instanceof $ec0d3058e92a8855$export$982f47444a2f88da;
                    });
                }
            },
            {
                key: "audioTool",
                get: function get() {
                    return this.toolList.find(function(e) {
                        return e instanceof $d1b3805234fdf37f$var$$345f51138f435756$export$6024938f37e646f8;
                    });
                }
            },
            {
                key: "videoTool",
                get: function get() {
                    return this.toolList.find(function(e) {
                        return e instanceof $d1b3805234fdf37f$var$$345f51138f435756$export$932111b8028f79ed;
                    });
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    (0, $57751a2649dd1683$export$71511d61b312f219)((0, $ae6313b3cbf000af$export$71511d61b312f219)(r.prototype), "componentDidMount", this).call(this);
                    var _$e = this.props.defaultValue;
                    null != _$e && (this.box.current.innerHTML = _$e), document.addEventListener("selectionchange", this.updateTools);
                }
            },
            {
                key: "componentWillUnmount",
                value: function value() {
                    (0, $57751a2649dd1683$export$71511d61b312f219)((0, $ae6313b3cbf000af$export$71511d61b312f219)(r.prototype), "componentWillUnmount", this).call(this), document.removeEventListener("selectionchange", this.updateTools);
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this;
                    this.cursorPoint;
                    var _$r = this.toolList, c = this.innerValue, t = this.props.name;
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($tLNoZ.Fragment, {
                        children: [
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("header", {
                                children: _$r.map(function(r) {
                                    return r.render(_$e.box);
                                })
                            }),
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                                ref: this.box,
                                className: "form-control h-auto",
                                contentEditable: !0,
                                onInput: function onInput(r) {
                                    var c = r.currentTarget.innerHTML;
                                    return _$e.updateValue(c);
                                },
                                onPaste: this.handlePasteDrop,
                                onDrop: this.handlePasteDrop
                            }),
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("input", {
                                type: "hidden",
                                name: t,
                                value: c
                            })
                        ]
                    });
                }
            }
        ]), r;
    }(b), c = new WeakMap, $d1b3805234fdf37f$var$$68aab1d0e8e5016c$var$__setFunctionName(a, "Editor"), r = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = b[Symbol.metadata]) ? e : null) : void 0, $ = [
        $h2kUE.observable
    ], o = [
        $h2kUE.computed
    ], s = [
        $h2kUE.computed
    ], n = [
        $h2kUE.computed
    ], l = [
        $h2kUE.computed
    ], $d1b3805234fdf37f$var$$68aab1d0e8e5016c$var$__esDecorate(a, null, $, {
        kind: "accessor",
        name: "cursorPoint",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "cursorPoint" in e;
            },
            get: function get(e) {
                return e.cursorPoint;
            },
            set: function set(e, r) {
                e.cursorPoint = r;
            }
        },
        metadata: r
    }, f, d), $d1b3805234fdf37f$var$$68aab1d0e8e5016c$var$__esDecorate(a, null, o, {
        kind: "getter",
        name: "toolList",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "toolList" in e;
            },
            get: function get(e) {
                return e.toolList;
            }
        },
        metadata: r
    }, null, p), $d1b3805234fdf37f$var$$68aab1d0e8e5016c$var$__esDecorate(a, null, s, {
        kind: "getter",
        name: "imageTool",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "imageTool" in e;
            },
            get: function get(e) {
                return e.imageTool;
            }
        },
        metadata: r
    }, null, p), $d1b3805234fdf37f$var$$68aab1d0e8e5016c$var$__esDecorate(a, null, n, {
        kind: "getter",
        name: "audioTool",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "audioTool" in e;
            },
            get: function get(e) {
                return e.audioTool;
            }
        },
        metadata: r
    }, null, p), $d1b3805234fdf37f$var$$68aab1d0e8e5016c$var$__esDecorate(a, null, l, {
        kind: "getter",
        name: "videoTool",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "videoTool" in e;
            },
            get: function get(e) {
                return e.videoTool;
            }
        },
        metadata: r
    }, null, p), $d1b3805234fdf37f$var$$68aab1d0e8e5016c$var$__esDecorate(null, t = {
        value: a
    }, i, {
        kind: "class",
        name: a.name,
        metadata: r
    }, null, u), a = t.value, r && Object.defineProperty(a, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }), Object.defineProperty(a, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "Editor"
    }), $d1b3805234fdf37f$var$$68aab1d0e8e5016c$var$__runInitializers(a, u), a;
}();
$d1b3805234fdf37f$var$$parcel$exportWildcard($d1b3805234fdf37f$exports, $d1b3805234fdf37f$var$$73a8882fd67c0324$exports), $d1b3805234fdf37f$var$$parcel$exportWildcard($d1b3805234fdf37f$exports, $d1b3805234fdf37f$var$$a01145bb2edfc771$exports), $d1b3805234fdf37f$var$$parcel$exportWildcard($d1b3805234fdf37f$exports, $d1b3805234fdf37f$var$$68aab1d0e8e5016c$exports);




var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7E0eS = parcelRequire("7E0eS");
(function() {
    "use strict";
    try {
        if ((typeof document === "undefined" ? "undefined" : (0, $7E0eS._)(document)) < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-code__textarea{min-height:200px;font-family:Menlo,Monaco,Consolas,Courier New,monospace;color:#41314e;line-height:1.6em;font-size:12px;background:#f8f7fa;border:1px solid #f1f1f4;box-shadow:none;white-space:pre;word-wrap:normal;overflow-x:auto;resize:vertical}")), document.head.appendChild(e);
        }
    } catch (o) {
        console.error("vite-plugin-css-injected-by-js", o);
    }
})();
function $57cf0d4d83444770$var$c(l, t) {
    var a = "";
    for(; a !== "\n" && t > 0;)t = t - 1, a = l.substr(t, 1);
    return a === "\n" && (t += 1), t;
}
var $57cf0d4d83444770$var$h = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 8L5 12L9 16"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 8L19 12L15 16"/></svg>';
/**
 * CodeTool for Editor.js
 * @version 2.0.0
 * @license MIT
 */ var $57cf0d4d83444770$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function d(param) {
        var t = param.data, e = param.config, a = param.api, s = param.readOnly;
        (0, $173N4._)(this, d);
        var _t_code;
        this.api = a, this.readOnly = s, this.placeholder = this.api.i18n.t(e.placeholder || d.DEFAULT_PLACEHOLDER), this.CSS = {
            baseClass: this.api.styles.block,
            input: this.api.styles.input,
            wrapper: "ce-code",
            textarea: "ce-code__textarea"
        }, this.nodes = {
            holder: null,
            textarea: null
        }, this.data = {
            code: (_t_code = t.code) !== null && _t_code !== void 0 ? _t_code : ""
        }, this.nodes.holder = this.drawView();
    }
    (0, $cFHGC._)(d, [
        {
            /**
   * Return Tool's view
   * @returns this.nodes.holder - Code's wrapper
   */ key: "render",
            value: function render() {
                return this.nodes.holder;
            }
        },
        {
            /**
   * Extract Tool's data from the view
   * @param codeWrapper - CodeTool's wrapper, containing textarea with code
   * @returns - saved plugin code
   */ key: "save",
            value: function save(t) {
                return {
                    code: t.querySelector("textarea").value
                };
            }
        },
        {
            /**
   * onPaste callback fired from Editor`s core
   * @param event - event with pasted content
   */ key: "onPaste",
            value: function onPaste(t) {
                switch(t.type){
                    case "tag":
                        {
                            var e = t.detail.data;
                            this.handleHTMLPaste(e);
                            break;
                        }
                }
            }
        },
        {
            key: "data",
            get: /**
   * Returns Tool`s data from private property
   * @returns
   */ function get() {
                return this._data;
            },
            set: /**
   * Set Tool`s data to private property and update view
   * @param data - saved tool data
   */ function set(t) {
                this._data = t, this.nodes.textarea && (this.nodes.textarea.value = t.code);
            }
        },
        {
            /**
   * Handles Tab key pressing (adds/removes indentations)
   * @param event - keydown
   */ key: "tabHandler",
            value: function tabHandler(t) {
                t.stopPropagation(), t.preventDefault();
                var e = t.target, a = t.shiftKey, s = e.selectionStart, r = e.value, n = "  ";
                var i;
                if (!a) i = s + n.length, e.value = r.substring(0, s) + n + r.substring(s);
                else {
                    var o = $57cf0d4d83444770$var$c(r, s);
                    if (r.substr(o, n.length) !== n) return;
                    e.value = r.substring(0, o) + r.substring(o + n.length), i = s - n.length;
                }
                e.setSelectionRange(i, i);
            }
        },
        {
            /**
   * Create Tool's view
   * @returns
   */ key: "drawView",
            value: function drawView() {
                var _this = this;
                var t = document.createElement("div"), e = document.createElement("textarea");
                return t.classList.add(this.CSS.baseClass, this.CSS.wrapper), e.classList.add(this.CSS.textarea, this.CSS.input), e.value = this.data.code, e.placeholder = this.placeholder, this.readOnly && (e.disabled = !0), t.appendChild(e), e.addEventListener("keydown", function(a) {
                    switch(a.code){
                        case "Tab":
                            _this.tabHandler(a);
                            break;
                    }
                }), this.nodes.textarea = e, t;
            }
        },
        {
            /**
   * Extracts the code content from the pasted element's innerHTML and populates the tool's data.
   * @param element - pasted HTML element
   */ key: "handleHTMLPaste",
            value: function handleHTMLPaste(t) {
                this.data = {
                    code: t.innerHTML
                };
            }
        }
    ], [
        {
            key: "isReadOnlySupported",
            get: /**
   * Notify core that read-only mode is supported
   * @returns true if read-only mode is supported
   */ function get() {
                return !0;
            }
        },
        {
            key: "enableLineBreaks",
            get: /**
   * Allows pressing Enter key to create line breaks inside the CodeTool textarea
   * This enables multi-line input within the code editor.
   * @returns true if line breaks are allowed in the textarea
   */ function get() {
                return !0;
            }
        },
        {
            key: "toolbox",
            get: /**
   * Get Tool toolbox settings.
   * Provides the icon and title to display in the toolbox for the CodeTool.
   * @returns An object containing:
   * - icon: SVG representation of the Tool's icon
   * - title: Title to show in the toolbox
   */ function get() {
                return {
                    icon: $57cf0d4d83444770$var$h,
                    title: "Code"
                };
            }
        },
        {
            key: "DEFAULT_PLACEHOLDER",
            get: /**
   * Default placeholder for CodeTool's textarea
   * @returns
   */ function get() {
                return "Enter a code";
            }
        },
        {
            key: "pasteConfig",
            get: /**
   *  Used by Editor.js paste handling API.
   *  Provides configuration to handle CODE tag.
   * @returns
   */ function get() {
                return {
                    tags: [
                        "pre"
                    ]
                };
            }
        },
        {
            key: "sanitize",
            get: /**
   * Automatic sanitize config
   * @returns
   */ function get() {
                return {
                    code: !0
                };
            }
        }
    ]);
    return d;
}();



var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7E0eS = parcelRequire("7E0eS");
(function() {
    "use strict";
    try {
        if ((typeof document === "undefined" ? "undefined" : (0, $7E0eS._)(document)) < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-header{padding:.6em 0 3px;margin:0;line-height:1.25em;outline:none}.ce-header p,.ce-header div{padding:0!important;margin:0!important}")), document.head.appendChild(e);
        }
    } catch (n) {
        console.error("vite-plugin-css-injected-by-js", n);
    }
})();
var $b4cc5177a40da62d$var$a = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6 7L6 12M6 17L6 12M6 12L12 12M12 7V12M12 17L12 12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M19 17V10.2135C19 10.1287 18.9011 10.0824 18.836 10.1367L16 12.5"/></svg>', $b4cc5177a40da62d$var$h = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6 7L6 12M6 17L6 12M6 12L12 12M12 7V12M12 17L12 12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16 11C16 10 19 9.5 19 12C19 13.9771 16.0684 13.9997 16.0012 16.8981C15.9999 16.9533 16.0448 17 16.1 17L19.3 17"/></svg>', $b4cc5177a40da62d$var$d = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6 7L6 12M6 17L6 12M6 12L12 12M12 7V12M12 17L12 12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16 11C16 10.5 16.8323 10 17.6 10C18.3677 10 19.5 10.311 19.5 11.5C19.5 12.5315 18.7474 12.9022 18.548 12.9823C18.5378 12.9864 18.5395 13.0047 18.5503 13.0063C18.8115 13.0456 20 13.3065 20 14.8C20 16 19.5 17 17.8 17C17.8 17 16 17 16 16.3"/></svg>', $b4cc5177a40da62d$var$c = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6 7L6 12M6 17L6 12M6 12L12 12M12 7V12M12 17L12 12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M18 10L15.2834 14.8511C15.246 14.9178 15.294 15 15.3704 15C16.8489 15 18.7561 15 20.2 15M19 17C19 15.7187 19 14.8813 19 13.6"/></svg>', $b4cc5177a40da62d$var$u = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6 7L6 12M6 17L6 12M6 12L12 12M12 7V12M12 17L12 12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16 15.9C16 15.9 16.3768 17 17.8 17C19.5 17 20 15.6199 20 14.7C20 12.7323 17.6745 12.0486 16.1635 12.9894C16.094 13.0327 16 12.9846 16 12.9027V10.1C16 10.0448 16.0448 10 16.1 10H19.8"/></svg>', $b4cc5177a40da62d$var$g = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6 7L6 12M6 17L6 12M6 12L12 12M12 7V12M12 17L12 12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M19.5 10C16.5 10.5 16 13.3285 16 15M16 15V15C16 16.1046 16.8954 17 18 17H18.3246C19.3251 17 20.3191 16.3492 20.2522 15.3509C20.0612 12.4958 16 12.6611 16 15Z"/></svg>', $b4cc5177a40da62d$var$v = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9 7L9 12M9 17V12M9 12L15 12M15 7V12M15 17L15 12"/></svg>';
/**
 * Header block for the Editor.js.
 *
 * @author CodeX (team@ifmo.su)
 * @copyright CodeX 2018
 * @license MIT
 * @version 2.0.0
 */ var $b4cc5177a40da62d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function p(param) {
        var e = param.data, t = param.config, s = param.api, r = param.readOnly;
        (0, $173N4._)(this, p);
        this.api = s, this.readOnly = r, this._config = t !== null && t !== void 0 ? t : null, this._data = this.normalizeData(e), this._element = this.getTag();
    }
    (0, $cFHGC._)(p, [
        {
            key: "_CSS",
            get: /**
   * Styles
   */ function get() {
                return {
                    block: this.api.styles.block,
                    wrapper: "ce-header"
                };
            }
        },
        {
            /**
   * Check if data is valid
   * 
   * @param {any} data - data to check
   * @returns {data is HeaderData}
   * @private
   */ key: "isHeaderData",
            value: function isHeaderData(e) {
                return e.text !== void 0;
            }
        },
        {
            /**
   * Normalize input data
   *
   * @param {HeaderData} data - saved data to process
   *
   * @returns {HeaderData}
   * @private
   */ key: "normalizeData",
            value: function normalizeData(e) {
                var t = {
                    text: "",
                    level: this.defaultLevel.number
                };
                return this.isHeaderData(e) && (t.text = e.text || "", e.level !== void 0 && !isNaN(parseInt(e.level.toString())) && (t.level = parseInt(e.level.toString()))), t;
            }
        },
        {
            /**
   * Return Tool's view
   *
   * @returns {HTMLHeadingElement}
   * @public
   */ key: "render",
            value: function render() {
                return this._element;
            }
        },
        {
            /**
   * Returns header block tunes config
   *
   * @returns {Array}
   */ key: "renderSettings",
            value: function renderSettings() {
                var _this = this;
                return this.levels.map(function(e) {
                    return {
                        icon: e.svg,
                        label: _this.api.i18n.t("Heading ".concat(e.number)),
                        onActivate: function() {
                            return _this.setLevel(e.number);
                        },
                        closeOnActivate: !0,
                        isActive: _this.currentLevel.number === e.number,
                        render: function() {
                            return document.createElement("div");
                        }
                    };
                });
            }
        },
        {
            /**
   * Callback for Block's settings buttons
   *
   * @param {number} level - level to set
   */ key: "setLevel",
            value: function setLevel(e) {
                this.data = {
                    level: e,
                    text: this.data.text
                };
            }
        },
        {
            /**
   * Method that specified how to merge two Text blocks.
   * Called by Editor.js by backspace at the beginning of the Block
   *
   * @param {HeaderData} data - saved data to merger with current block
   * @public
   */ key: "merge",
            value: function merge(e) {
                this._element.insertAdjacentHTML("beforeend", e.text);
            }
        },
        {
            /**
   * Validate Text block data:
   * - check for emptiness
   *
   * @param {HeaderData} blockData — data received after saving
   * @returns {boolean} false if saved data is not correct, otherwise true
   * @public
   */ key: "validate",
            value: function validate(e) {
                return e.text.trim() !== "";
            }
        },
        {
            /**
   * Extract Tool's data from the view
   *
   * @param {HTMLHeadingElement} toolsContent - Text tools rendered view
   * @returns {HeaderData} - saved data
   * @public
   */ key: "save",
            value: function save(e) {
                return {
                    text: e.innerHTML,
                    level: this.currentLevel.number
                };
            }
        },
        {
            key: "data",
            get: /**
   * Get current Tools`s data
   *
   * @returns {HeaderData} Current data
   * @private
   */ function get() {
                return this._data.text = this._element.innerHTML, this._data.level = this.currentLevel.number, this._data;
            },
            set: /**
   * Store data in plugin:
   * - at the this._data property
   * - at the HTML
   *
   * @param {HeaderData} data — data to set
   * @private
   */ function set(e) {
                if (this._data = this.normalizeData(e), e.level !== void 0 && this._element.parentNode) {
                    var t = this.getTag();
                    t.innerHTML = this._element.innerHTML, this._element.parentNode.replaceChild(t, this._element), this._element = t;
                }
                e.text !== void 0 && (this._element.innerHTML = this._data.text || "");
            }
        },
        {
            /**
   * Get tag for target level
   * By default returns second-leveled header
   *
   * @returns {HTMLElement}
   */ key: "getTag",
            value: function getTag() {
                var t;
                var e = document.createElement(this.currentLevel.tag);
                return e.innerHTML = this._data.text || "", e.classList.add(this._CSS.wrapper), e.contentEditable = this.readOnly ? "false" : "true", e.dataset.placeholder = this.api.i18n.t(((t = this._config) == null ? void 0 : t.placeholder) || ""), e;
            }
        },
        {
            key: "currentLevel",
            get: /**
   * Get current level
   *
   * @returns {level}
   */ function get() {
                var _this = this;
                var e = this.levels.find(function(t) {
                    return t.number === _this._data.level;
                });
                return e || (e = this.defaultLevel), e;
            }
        },
        {
            key: "defaultLevel",
            get: /**
   * Return default level
   *
   * @returns {level}
   */ function get() {
                var _this = this;
                var e;
                if ((e = this._config) != null && e.defaultLevel) {
                    var t = this.levels.find(function(s) {
                        var r;
                        return s.number === ((r = _this._config) == null ? void 0 : r.defaultLevel);
                    });
                    if (t) return t;
                    console.warn("(\u0E07'\u0300-'\u0301)\u0E07 Heading Tool: the default level specified was not found in available levels");
                }
                return this.levels[1];
            }
        },
        {
            key: "levels",
            get: /**
   * @typedef {object} level
   * @property {number} number - level number
   * @property {string} tag - tag corresponds with level number
   * @property {string} svg - icon
   */ /**
   * Available header levels
   *
   * @returns {level[]}
   */ function get() {
                var _this = this;
                var t;
                var e = [
                    {
                        number: 1,
                        tag: "H1",
                        svg: $b4cc5177a40da62d$var$a
                    },
                    {
                        number: 2,
                        tag: "H2",
                        svg: $b4cc5177a40da62d$var$h
                    },
                    {
                        number: 3,
                        tag: "H3",
                        svg: $b4cc5177a40da62d$var$d
                    },
                    {
                        number: 4,
                        tag: "H4",
                        svg: $b4cc5177a40da62d$var$c
                    },
                    {
                        number: 5,
                        tag: "H5",
                        svg: $b4cc5177a40da62d$var$u
                    },
                    {
                        number: 6,
                        tag: "H6",
                        svg: $b4cc5177a40da62d$var$g
                    }
                ];
                return (t = this._config) != null && t.levels ? e.filter(function(s) {
                    var r;
                    return (r = _this._config) == null ? void 0 : r.levels.includes(s.number);
                }) : e;
            }
        },
        {
            /**
   * Handle H1-H6 tags on paste to substitute it with header Tool
   *
   * @param {PasteEvent} event - event with pasted content
   */ key: "onPaste",
            value: function onPaste(e) {
                var s, r;
                var t = e.detail;
                if ("data" in t) {
                    var i = t.data;
                    var n = this.defaultLevel.number;
                    switch(i.tagName){
                        case "H1":
                            n = 1;
                            break;
                        case "H2":
                            n = 2;
                            break;
                        case "H3":
                            n = 3;
                            break;
                        case "H4":
                            n = 4;
                            break;
                        case "H5":
                            n = 5;
                            break;
                        case "H6":
                            n = 6;
                            break;
                    }
                    (s = this._config) != null && s.levels && (n = (r = this._config) == null ? void 0 : r.levels.reduce(function(o, l) {
                        return Math.abs(l - n) < Math.abs(o - n) ? l : o;
                    })), this.data = {
                        level: n,
                        text: i.innerHTML
                    };
                }
            }
        }
    ], [
        {
            key: "conversionConfig",
            get: /**
   * Allow Header to be converted to/from other blocks
   */ function get() {
                return {
                    export: "text",
                    // use 'text' property for other blocks
                    import: "text"
                };
            }
        },
        {
            key: "sanitize",
            get: /**
   * Sanitizer Rules
   */ function get() {
                return {
                    level: !1,
                    text: {}
                };
            }
        },
        {
            key: "isReadOnlySupported",
            get: /**
   * Returns true to notify core that read-only is supported
   *
   * @returns {boolean}
   */ function get() {
                return !0;
            }
        },
        {
            key: "pasteConfig",
            get: /**
   * Used by Editor.js paste handling API.
   * Provides configuration to handle H1-H6 tags.
   *
   * @returns {{handler: (function(HTMLElement): {text: string}), tags: string[]}}
   */ function get() {
                return {
                    tags: [
                        "H1",
                        "H2",
                        "H3",
                        "H4",
                        "H5",
                        "H6"
                    ]
                };
            }
        },
        {
            key: "toolbox",
            get: /**
   * Get Tool toolbox settings
   * icon - Tool icon's SVG
   * title - title to show in toolbox
   *
   * @returns {{icon: string, title: string}}
   */ function get() {
                return {
                    icon: $b4cc5177a40da62d$var$v,
                    title: "Heading"
                };
            }
        }
    ]);
    return p;
}();



var $3gP77 = parcelRequire("3gP77");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");

var $13u2V = parcelRequire("13u2V");
(function() {
    "use strict";
    try {
        if ((typeof document === "undefined" ? "undefined" : (0, $7E0eS._)(document)) < "u") {
            var o = document.createElement("style");
            o.appendChild(document.createTextNode('.image-tool{--bg-color: #cdd1e0;--front-color: #388ae5;--border-color: #e8e8eb}.image-tool__image{border-radius:3px;overflow:hidden;margin-bottom:10px;padding-bottom:0}.image-tool__image-picture{max-width:100%;vertical-align:bottom;display:block}.image-tool__image-preloader{width:50px;height:50px;border-radius:50%;background-size:cover;margin:auto;position:relative;background-color:var(--bg-color);background-position:center center}.image-tool__image-preloader:after{content:"";position:absolute;z-index:3;width:60px;height:60px;border-radius:50%;border:2px solid var(--bg-color);border-top-color:var(--front-color);left:50%;top:50%;margin-top:-30px;margin-left:-30px;animation:image-preloader-spin 2s infinite linear;box-sizing:border-box}.image-tool__caption{visibility:hidden;position:absolute;bottom:0;left:0;margin-bottom:10px}.image-tool__caption[contentEditable=true][data-placeholder]:before{position:absolute!important;content:attr(data-placeholder);color:#707684;font-weight:400;display:none}.image-tool__caption[contentEditable=true][data-placeholder]:empty:before{display:block}.image-tool__caption[contentEditable=true][data-placeholder]:empty:focus:before{display:none}.image-tool--empty .image-tool__image,.image-tool--empty .image-tool__image-preloader{display:none}.image-tool--empty .image-tool__caption,.image-tool--uploading .image-tool__caption{visibility:hidden!important}.image-tool .cdx-button{display:flex;align-items:center;justify-content:center}.image-tool .cdx-button svg{height:auto;margin:0 6px 0 0}.image-tool--filled .cdx-button,.image-tool--filled .image-tool__image-preloader{display:none}.image-tool--uploading .image-tool__image{min-height:200px;display:flex;border:1px solid var(--border-color);background-color:#fff}.image-tool--uploading .image-tool__image-picture,.image-tool--uploading .cdx-button{display:none}.image-tool--withBorder .image-tool__image{border:1px solid var(--border-color)}.image-tool--withBackground .image-tool__image{padding:15px;background:var(--bg-color)}.image-tool--withBackground .image-tool__image-picture{max-width:60%;margin:0 auto}.image-tool--stretched .image-tool__image-picture{width:100%}.image-tool--caption .image-tool__caption{visibility:visible}.image-tool--caption{padding-bottom:50px}@keyframes image-preloader-spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}')), document.head.appendChild(o);
        }
    } catch (e) {
        console.error("vite-plugin-css-injected-by-js", e);
    }
})();
var $40e8656eff946dc6$var$R = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 19V19C9.13623 19 8.20435 19 7.46927 18.6955C6.48915 18.2895 5.71046 17.5108 5.30448 16.5307C5 15.7956 5 14.8638 5 13V12C5 9.19108 5 7.78661 5.67412 6.77772C5.96596 6.34096 6.34096 5.96596 6.77772 5.67412C7.78661 5 9.19108 5 12 5H13.5C14.8956 5 15.5933 5 16.1611 5.17224C17.4395 5.56004 18.44 6.56046 18.8278 7.83886C19 8.40666 19 9.10444 19 10.5V10.5"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16 13V16M16 19V16M19 16H16M16 16H13"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6.5 17.5L17.5 6.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.9919 10.5H19.0015"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.9919 19H11.0015"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13L13 5"/></svg>', $40e8656eff946dc6$var$I = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.9919 9.5H19.0015"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.5 5H14.5096"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.625 5H15C17.2091 5 19 6.79086 19 9V9.375"/><path stroke="currentColor" stroke-width="2" d="M9.375 5L9 5C6.79086 5 5 6.79086 5 9V9.375"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.3725 5H9.38207"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 9.5H5.00957"/><path stroke="currentColor" stroke-width="2" d="M9.375 19H9C6.79086 19 5 17.2091 5 15V14.625"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.3725 19H9.38207"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 14.55H5.00957"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16 13V16M16 19V16M19 16H16M16 16H13"/></svg>', $40e8656eff946dc6$var$L = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><rect width="14" height="14" x="5" y="5" stroke="currentColor" stroke-width="2" rx="4"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.13968 15.32L8.69058 11.5661C9.02934 11.2036 9.48873 11 9.96774 11C10.4467 11 10.9061 11.2036 11.2449 11.5661L15.3871 16M13.5806 14.0664L15.0132 12.533C15.3519 12.1705 15.8113 11.9668 16.2903 11.9668C16.7693 11.9668 17.2287 12.1705 17.5675 12.533L18.841 13.9634"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.7778 9.33331H13.7867"/></svg>', $40e8656eff946dc6$var$x = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9L20 12L17 15"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 12H20"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 9L4 12L7 15"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 12H10"/></svg>', $40e8656eff946dc6$var$B = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 9V7.2C8 7.08954 8.08954 7 8.2 7L12 7M16 9V7.2C16 7.08954 15.9105 7 15.8 7L12 7M12 7L12 17M12 17H10M12 17H14"/></svg>';
function $40e8656eff946dc6$var$S(C) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _s_classList;
    var s = document.createElement(C);
    Array.isArray(i) ? (_s_classList = s.classList).add.apply(_s_classList, (0, $aUGqu._)(i)) : i !== null && s.classList.add(i);
    for(var r in a)a.hasOwnProperty(r) && (s[r] = a[r]);
    return s;
}
var $40e8656eff946dc6$var$_ = /* @__PURE__ */ function(C) {
    return C.Empty = "empty", C.Uploading = "uploading", C.Filled = "filled", C;
}($40e8656eff946dc6$var$_ || {});
var $40e8656eff946dc6$var$D = /*#__PURE__*/ function() {
    "use strict";
    function D(param) {
        var i = param.api, a = param.config, s = param.onSelectFile, r = param.readOnly;
        (0, $173N4._)(this, D);
        this.api = i, this.config = a, this.onSelectFile = s, this.readOnly = r, this.nodes = {
            wrapper: $40e8656eff946dc6$var$S("div", [
                this.CSS.baseClass,
                this.CSS.wrapper
            ]),
            imageContainer: $40e8656eff946dc6$var$S("div", [
                this.CSS.imageContainer
            ]),
            fileButton: this.createFileButton(),
            imageEl: void 0,
            imagePreloader: $40e8656eff946dc6$var$S("div", this.CSS.imagePreloader),
            caption: $40e8656eff946dc6$var$S("div", [
                this.CSS.input,
                this.CSS.caption
            ], {
                contentEditable: !this.readOnly
            })
        }, this.nodes.caption.dataset.placeholder = this.config.captionPlaceholder, this.nodes.imageContainer.appendChild(this.nodes.imagePreloader), this.nodes.wrapper.appendChild(this.nodes.imageContainer), this.nodes.wrapper.appendChild(this.nodes.caption), this.nodes.wrapper.appendChild(this.nodes.fileButton);
    }
    (0, $cFHGC._)(D, [
        {
            /**
   * Apply visual representation of activated tune
   * @param tuneName - one of available tunes {@link Tunes.tunes}
   * @param status - true for enable, false for disable
   */ key: "applyTune",
            value: function applyTune(i, a) {
                this.nodes.wrapper.classList.toggle("".concat(this.CSS.wrapper, "--").concat(i), a);
            }
        },
        {
            /**
   * Renders tool UI
   */ key: "render",
            value: function render() {
                return this.toggleStatus("empty"), this.nodes.wrapper;
            }
        },
        {
            /**
   * Shows uploading preloader
   * @param src - preview source
   */ key: "showPreloader",
            value: function showPreloader(i) {
                this.nodes.imagePreloader.style.backgroundImage = "url(".concat(i, ")"), this.toggleStatus("uploading");
            }
        },
        {
            /**
   * Hide uploading preloader
   */ key: "hidePreloader",
            value: function hidePreloader() {
                this.nodes.imagePreloader.style.backgroundImage = "", this.toggleStatus("empty");
            }
        },
        {
            /**
   * Shows an image
   * @param url - image source
   */ key: "fillImage",
            value: function fillImage(i) {
                var _this = this;
                var a = /\.mp4$/.test(i) ? "VIDEO" : "IMG", s = {
                    src: i
                };
                var r = "load";
                a === "VIDEO" && (s.autoplay = !0, s.loop = !0, s.muted = !0, s.playsinline = !0, r = "loadeddata"), this.nodes.imageEl = $40e8656eff946dc6$var$S(a, this.CSS.imageEl, s), this.nodes.imageEl.addEventListener(r, function() {
                    _this.toggleStatus("filled"), _this.nodes.imagePreloader !== void 0 && (_this.nodes.imagePreloader.style.backgroundImage = "");
                }), this.nodes.imageContainer.appendChild(this.nodes.imageEl);
            }
        },
        {
            /**
   * Shows caption input
   * @param text - caption content text
   */ key: "fillCaption",
            value: function fillCaption(i) {
                this.nodes.caption !== void 0 && (this.nodes.caption.innerHTML = i);
            }
        },
        {
            /**
   * Changes UI status
   * @param status - see {@link Ui.status} constants
   */ key: "toggleStatus",
            value: function toggleStatus(i) {
                for(var a in $40e8656eff946dc6$var$_)if (Object.prototype.hasOwnProperty.call($40e8656eff946dc6$var$_, a)) {
                    var s = $40e8656eff946dc6$var$_[a];
                    this.nodes.wrapper.classList.toggle("".concat(this.CSS.wrapper, "--").concat(s), s === i);
                }
            }
        },
        {
            key: "CSS",
            get: /**
   * CSS classes
   */ function get() {
                return {
                    baseClass: this.api.styles.block,
                    loading: this.api.styles.loader,
                    input: this.api.styles.input,
                    button: this.api.styles.button,
                    /**
       * Tool's classes
       */ wrapper: "image-tool",
                    imageContainer: "image-tool__image",
                    imagePreloader: "image-tool__image-preloader",
                    imageEl: "image-tool__image-picture",
                    caption: "image-tool__caption"
                };
            }
        },
        {
            /**
   * Creates upload-file button
   */ key: "createFileButton",
            value: function createFileButton() {
                var _this = this;
                var i = $40e8656eff946dc6$var$S("div", [
                    this.CSS.button
                ]);
                var _this_config_buttonContent;
                return i.innerHTML = (_this_config_buttonContent = this.config.buttonContent) !== null && _this_config_buttonContent !== void 0 ? _this_config_buttonContent : "".concat($40e8656eff946dc6$var$L, " ").concat(this.api.i18n.t("Select an Image")), i.addEventListener("click", function() {
                    _this.onSelectFile();
                }), i;
            }
        }
    ]);
    return D;
}();
function $40e8656eff946dc6$var$U(C) {
    return C && C.__esModule && Object.prototype.hasOwnProperty.call(C, "default") ? C.default : C;
}
var $40e8656eff946dc6$var$H = {
    exports: {}
};
(function(C, i) {
    (function(a, s) {
        C.exports = s();
    })(window, function() {
        return function(a) {
            var s = {};
            function r(o) {
                if (s[o]) return s[o].exports;
                var e = s[o] = {
                    i: o,
                    l: !1,
                    exports: {}
                };
                return a[o].call(e.exports, e, e.exports, r), e.l = !0, e.exports;
            }
            return r.m = a, r.c = s, r.d = function(o, e, d) {
                r.o(o, e) || Object.defineProperty(o, e, {
                    enumerable: !0,
                    get: d
                });
            }, r.r = function(o) {
                (typeof Symbol === "undefined" ? "undefined" : (0, $7E0eS._)(Symbol)) < "u" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(o, "__esModule", {
                    value: !0
                });
            }, r.t = function(o, e) {
                if (1 & e && (o = r(o)), 8 & e || 4 & e && (typeof o === "undefined" ? "undefined" : (0, $7E0eS._)(o)) == "object" && o && o.__esModule) return o;
                var d = /* @__PURE__ */ Object.create(null);
                if (r.r(d), Object.defineProperty(d, "default", {
                    enumerable: !0,
                    value: o
                }), 2 & e && typeof o != "string") for(var v in o)r.d(d, v, (function(l) {
                    return o[l];
                }).bind(null, v));
                return d;
            }, r.n = function(o) {
                var e = o && o.__esModule ? function e() {
                    return o.default;
                } : function() {
                    return o;
                };
                return r.d(e, "a", e), e;
            }, r.o = function(o, e) {
                return Object.prototype.hasOwnProperty.call(o, e);
            }, r.p = "", r(r.s = 3);
        }([
            function(a, s) {
                var r;
                r = /* @__PURE__ */ function() {
                    return this;
                }();
                try {
                    r = r || new Function("return this")();
                } catch (e) {
                    (typeof window === "undefined" ? "undefined" : (0, $7E0eS._)(window)) == "object" && (r = window);
                }
                a.exports = r;
            },
            function(a, s, r) {
                (function(o) {
                    var e = r(2), d = setTimeout;
                    function v() {}
                    function l(n) {
                        if (!(this instanceof l)) throw new TypeError("Promises must be constructed via new");
                        if (typeof n != "function") throw new TypeError("not a function");
                        this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], t(n, this);
                    }
                    function f(n, c) {
                        for(; n._state === 3;)n = n._value;
                        n._state !== 0 ? (n._handled = !0, l._immediateFn(function() {
                            var u = n._state === 1 ? c.onFulfilled : c.onRejected;
                            if (u !== null) {
                                var g;
                                try {
                                    g = u(n._value);
                                } catch (m) {
                                    return void y(c.promise, m);
                                }
                                p(c.promise, g);
                            } else (n._state === 1 ? p : y)(c.promise, n._value);
                        })) : n._deferreds.push(c);
                    }
                    function p(n, c) {
                        try {
                            if (c === n) throw new TypeError("A promise cannot be resolved with itself.");
                            if (c && ((typeof c === "undefined" ? "undefined" : (0, $7E0eS._)(c)) == "object" || typeof c == "function")) {
                                var u = c.then;
                                if (c instanceof l) return n._state = 3, n._value = c, void w(n);
                                if (typeof u == "function") return void t((g = u, m = c, function() {
                                    g.apply(m, arguments);
                                }), n);
                            }
                            n._state = 1, n._value = c, w(n);
                        } catch (h) {
                            y(n, h);
                        }
                        var g, m;
                    }
                    function y(n, c) {
                        n._state = 2, n._value = c, w(n);
                    }
                    function w(n) {
                        n._state === 2 && n._deferreds.length === 0 && l._immediateFn(function() {
                            n._handled || l._unhandledRejectionFn(n._value);
                        });
                        for(var c = 0, u = n._deferreds.length; c < u; c++)f(n, n._deferreds[c]);
                        n._deferreds = null;
                    }
                    function b(n, c, u) {
                        this.onFulfilled = typeof n == "function" ? n : null, this.onRejected = typeof c == "function" ? c : null, this.promise = u;
                    }
                    function t(n, c) {
                        var u = !1;
                        try {
                            n(function(g) {
                                u || (u = !0, p(c, g));
                            }, function(g) {
                                u || (u = !0, y(c, g));
                            });
                        } catch (g) {
                            if (u) return;
                            u = !0, y(c, g);
                        }
                    }
                    l.prototype.catch = function(n) {
                        return this.then(null, n);
                    }, l.prototype.then = function(n, c) {
                        var u = new this.constructor(v);
                        return f(this, new b(n, c, u)), u;
                    }, l.prototype.finally = e.a, l.all = function(n) {
                        return new l(function(c, u) {
                            if (!n || n.length === void 0) throw new TypeError("Promise.all accepts an array");
                            var g = Array.prototype.slice.call(n);
                            if (g.length === 0) return c([]);
                            var m = g.length;
                            function h(T, E) {
                                try {
                                    if (E && ((typeof E === "undefined" ? "undefined" : (0, $7E0eS._)(E)) == "object" || typeof E == "function")) {
                                        var M = E.then;
                                        if (typeof M == "function") return void M.call(E, function(F) {
                                            h(T, F);
                                        }, u);
                                    }
                                    g[T] = E, --m == 0 && c(g);
                                } catch (F) {
                                    u(F);
                                }
                            }
                            for(var k = 0; k < g.length; k++)h(k, g[k]);
                        });
                    }, l.resolve = function(n) {
                        return n && (typeof n === "undefined" ? "undefined" : (0, $7E0eS._)(n)) == "object" && n.constructor === l ? n : new l(function(c) {
                            c(n);
                        });
                    }, l.reject = function(n) {
                        return new l(function(c, u) {
                            u(n);
                        });
                    }, l.race = function(n) {
                        return new l(function(c, u) {
                            for(var g = 0, m = n.length; g < m; g++)n[g].then(c, u);
                        });
                    }, l._immediateFn = typeof o == "function" && function(n) {
                        o(n);
                    } || function(n) {
                        d(n, 0);
                    }, l._unhandledRejectionFn = function(n) {
                        (typeof console === "undefined" ? "undefined" : (0, $7E0eS._)(console)) < "u" && console && console.warn("Possible Unhandled Promise Rejection:", n);
                    }, s.a = l;
                }).call(this, r(5).setImmediate);
            },
            function(a, s, r) {
                s.a = function(o) {
                    var e = this.constructor;
                    return this.then(function(d) {
                        return e.resolve(o()).then(function() {
                            return d;
                        });
                    }, function(d) {
                        return e.resolve(o()).then(function() {
                            return e.reject(d);
                        });
                    });
                };
            },
            function(a, s, r) {
                function o(t) {
                    return (o = typeof Symbol == "function" && (0, $7E0eS._)(Symbol.iterator) == "symbol" ? function o(n) {
                        return typeof n === "undefined" ? "undefined" : (0, $7E0eS._)(n);
                    } : function(n) {
                        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n === "undefined" ? "undefined" : (0, $7E0eS._)(n);
                    })(t);
                }
                r(4);
                var e, d, v, l, f, p, y, w = r(8), b = (d = function d(t) {
                    return new Promise(function(n, c) {
                        t = l(t), (t = f(t)).beforeSend && t.beforeSend();
                        var u = window.XMLHttpRequest ? new window.XMLHttpRequest() : new window.ActiveXObject("Microsoft.XMLHTTP");
                        u.open(t.method, t.url), u.setRequestHeader("X-Requested-With", "XMLHttpRequest"), Object.keys(t.headers).forEach(function(m) {
                            var h = t.headers[m];
                            u.setRequestHeader(m, h);
                        });
                        var g = t.ratio;
                        u.upload.addEventListener("progress", function(m) {
                            var h = Math.round(m.loaded / m.total * 100), k = Math.ceil(h * g / 100);
                            t.progress(Math.min(k, 100));
                        }, !1), u.addEventListener("progress", function(m) {
                            var h = Math.round(m.loaded / m.total * 100), k = Math.ceil(h * (100 - g) / 100) + g;
                            t.progress(Math.min(k, 100));
                        }, !1), u.onreadystatechange = function() {
                            if (u.readyState === 4) {
                                var m = u.response;
                                try {
                                    m = JSON.parse(m);
                                } catch (e) {}
                                var h = w.parseHeaders(u.getAllResponseHeaders()), k = {
                                    body: m,
                                    code: u.status,
                                    headers: h
                                };
                                y(u.status) ? n(k) : c(k);
                            }
                        }, u.send(t.data);
                    });
                }, v = function v(t) {
                    return t.method = "POST", d(t);
                }, l = function l() {
                    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    if (t.url && typeof t.url != "string") throw new Error("Url must be a string");
                    if (t.url = t.url || "", t.method && typeof t.method != "string") throw new Error("`method` must be a string or null");
                    if (t.method = t.method ? t.method.toUpperCase() : "GET", t.headers && o(t.headers) !== "object") throw new Error("`headers` must be an object or null");
                    if (t.headers = t.headers || {}, t.type && (typeof t.type != "string" || !Object.values(e).includes(t.type))) throw new Error("`type` must be taken from module's \xabcontentType\xbb library");
                    if (t.progress && typeof t.progress != "function") throw new Error("`progress` must be a function or null");
                    if (t.progress = t.progress || function(n) {}, t.beforeSend = t.beforeSend || function(n) {}, t.ratio && typeof t.ratio != "number") throw new Error("`ratio` must be a number");
                    if (t.ratio < 0 || t.ratio > 100) throw new Error("`ratio` must be in a 0-100 interval");
                    if (t.ratio = t.ratio || 90, t.accept && typeof t.accept != "string") throw new Error("`accept` must be a string with a list of allowed mime-types");
                    if (t.accept = t.accept || "*/*", t.multiple && typeof t.multiple != "boolean") throw new Error("`multiple` must be a true or false");
                    if (t.multiple = t.multiple || !1, t.fieldName && typeof t.fieldName != "string") throw new Error("`fieldName` must be a string");
                    return t.fieldName = t.fieldName || "files", t;
                }, f = function f(t) {
                    switch(t.method){
                        case "GET":
                            var n = p(t.data, e.URLENCODED);
                            delete t.data, t.url = /\?/.test(t.url) ? t.url + "&" + n : t.url + "?" + n;
                            break;
                        case "POST":
                        case "PUT":
                        case "DELETE":
                        case "UPDATE":
                            var c = function() {
                                return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).type || e.JSON;
                            }(t);
                            (w.isFormData(t.data) || w.isFormElement(t.data)) && (c = e.FORM), t.data = p(t.data, c), c !== b.contentType.FORM && (t.headers["content-type"] = c);
                    }
                    return t;
                }, p = function p() {
                    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    switch(arguments.length > 1 ? arguments[1] : void 0){
                        case e.URLENCODED:
                            return w.urlEncode(t);
                        case e.JSON:
                            return w.jsonEncode(t);
                        case e.FORM:
                            return w.formEncode(t);
                        default:
                            return t;
                    }
                }, y = function y(t) {
                    return t >= 200 && t < 300;
                }, {
                    contentType: e = {
                        URLENCODED: "application/x-www-form-urlencoded; charset=utf-8",
                        FORM: "multipart/form-data",
                        JSON: "application/json; charset=utf-8"
                    },
                    request: d,
                    get: function get(t) {
                        return t.method = "GET", d(t);
                    },
                    post: v,
                    transport: function transport(t) {
                        return t = l(t), w.selectFiles(t).then(function(n) {
                            for(var c = new FormData(), u = 0; u < n.length; u++)c.append(t.fieldName, n[u], n[u].name);
                            w.isObject(t.data) && Object.keys(t.data).forEach(function(m) {
                                var h = t.data[m];
                                c.append(m, h);
                            });
                            var g = t.beforeSend;
                            return t.beforeSend = function() {
                                return g(n);
                            }, t.data = c, v(t);
                        });
                    },
                    selectFiles: function selectFiles(t) {
                        return delete (t = l(t)).beforeSend, w.selectFiles(t);
                    }
                });
                a.exports = b;
            },
            function(a, s, r) {
                r.r(s);
                var o = r(1);
                window.Promise = window.Promise || o.a;
            },
            function(a, s, r) {
                (function(o) {
                    var e = o !== void 0 && o || (typeof self === "undefined" ? "undefined" : (0, $7E0eS._)(self)) < "u" && self || window, d = Function.prototype.apply;
                    function v(l, f) {
                        this._id = l, this._clearFn = f;
                    }
                    s.setTimeout = function() {
                        return new v(d.call(setTimeout, e, arguments), clearTimeout);
                    }, s.setInterval = function() {
                        return new v(d.call(setInterval, e, arguments), clearInterval);
                    }, s.clearTimeout = s.clearInterval = function(l) {
                        l && l.close();
                    }, v.prototype.unref = v.prototype.ref = function() {}, v.prototype.close = function() {
                        this._clearFn.call(e, this._id);
                    }, s.enroll = function(l, f) {
                        clearTimeout(l._idleTimeoutId), l._idleTimeout = f;
                    }, s.unenroll = function(l) {
                        clearTimeout(l._idleTimeoutId), l._idleTimeout = -1;
                    }, s._unrefActive = s.active = function(l) {
                        clearTimeout(l._idleTimeoutId);
                        var f = l._idleTimeout;
                        f >= 0 && (l._idleTimeoutId = setTimeout(function() {
                            l._onTimeout && l._onTimeout();
                        }, f));
                    }, r(6), s.setImmediate = (typeof self === "undefined" ? "undefined" : (0, $7E0eS._)(self)) < "u" && self.setImmediate || o !== void 0 && o.setImmediate || this && this.setImmediate, s.clearImmediate = (typeof self === "undefined" ? "undefined" : (0, $7E0eS._)(self)) < "u" && self.clearImmediate || o !== void 0 && o.clearImmediate || this && this.clearImmediate;
                }).call(this, r(0));
            },
            function(a, s, r) {
                (function(o, e) {
                    (function(d, v) {
                        if (!d.setImmediate) {
                            var l, f, p, y, w, b = 1, t = {}, n = !1, c = d.document, u = Object.getPrototypeOf && Object.getPrototypeOf(d);
                            u = u && u.setTimeout ? u : d, ({}).toString.call(d.process) === "[object process]" ? l = function l(h) {
                                e.nextTick(function() {
                                    m(h);
                                });
                            } : function() {
                                if (d.postMessage && !d.importScripts) {
                                    var h = !0, k = d.onmessage;
                                    return d.onmessage = function() {
                                        h = !1;
                                    }, d.postMessage("", "*"), d.onmessage = k, h;
                                }
                            }() ? (y = "setImmediate$" + Math.random() + "$", w = function w(h) {
                                h.source === d && typeof h.data == "string" && h.data.indexOf(y) === 0 && m(+h.data.slice(y.length));
                            }, d.addEventListener ? d.addEventListener("message", w, !1) : d.attachEvent("onmessage", w), l = function l(h) {
                                d.postMessage(y + h, "*");
                            }) : d.MessageChannel ? ((p = new MessageChannel()).port1.onmessage = function(h) {
                                m(h.data);
                            }, l = function l(h) {
                                p.port2.postMessage(h);
                            }) : c && "onreadystatechange" in c.createElement("script") ? (f = c.documentElement, l = function l(h) {
                                var k = c.createElement("script");
                                k.onreadystatechange = function() {
                                    m(h), k.onreadystatechange = null, f.removeChild(k), k = null;
                                }, f.appendChild(k);
                            }) : l = function l(h) {
                                setTimeout(m, 0, h);
                            }, u.setImmediate = function(h) {
                                typeof h != "function" && (h = new Function("" + h));
                                for(var k = new Array(arguments.length - 1), T = 0; T < k.length; T++)k[T] = arguments[T + 1];
                                var E = {
                                    callback: h,
                                    args: k
                                };
                                return t[b] = E, l(b), b++;
                            }, u.clearImmediate = g;
                        }
                        function g(h) {
                            delete t[h];
                        }
                        function m(h) {
                            if (n) setTimeout(m, 0, h);
                            else {
                                var k = t[h];
                                if (k) {
                                    n = !0;
                                    try {
                                        (function(T) {
                                            var E = T.callback, M = T.args;
                                            switch(M.length){
                                                case 0:
                                                    E();
                                                    break;
                                                case 1:
                                                    E(M[0]);
                                                    break;
                                                case 2:
                                                    E(M[0], M[1]);
                                                    break;
                                                case 3:
                                                    E(M[0], M[1], M[2]);
                                                    break;
                                                default:
                                                    E.apply(v, M);
                                            }
                                        })(k);
                                    } finally{
                                        g(h), n = !1;
                                    }
                                }
                            }
                        }
                    })((typeof self === "undefined" ? "undefined" : (0, $7E0eS._)(self)) > "u" ? o === void 0 ? this : o : self);
                }).call(this, r(0), r(7));
            },
            function(a, s) {
                var r, o, e = a.exports = {};
                function d() {
                    throw new Error("setTimeout has not been defined");
                }
                function v() {
                    throw new Error("clearTimeout has not been defined");
                }
                function l(u) {
                    if (r === setTimeout) return setTimeout(u, 0);
                    if ((r === d || !r) && setTimeout) return r = setTimeout, setTimeout(u, 0);
                    try {
                        return r(u, 0);
                    } catch (e) {
                        try {
                            return r.call(null, u, 0);
                        } catch (e) {
                            return r.call(this, u, 0);
                        }
                    }
                }
                (function() {
                    try {
                        r = typeof setTimeout == "function" ? setTimeout : d;
                    } catch (e) {
                        r = d;
                    }
                    try {
                        o = typeof clearTimeout == "function" ? clearTimeout : v;
                    } catch (e) {
                        o = v;
                    }
                })();
                var f, p = [], y = !1, w = -1;
                function b() {
                    y && f && (y = !1, f.length ? p = f.concat(p) : w = -1, p.length && t());
                }
                function t() {
                    if (!y) {
                        var u = l(b);
                        y = !0;
                        for(var g = p.length; g;){
                            for(f = p, p = []; ++w < g;)f && f[w].run();
                            w = -1, g = p.length;
                        }
                        f = null, y = !1, function(m) {
                            if (o === clearTimeout) return clearTimeout(m);
                            if ((o === v || !o) && clearTimeout) return o = clearTimeout, clearTimeout(m);
                            try {
                                o(m);
                            } catch (e) {
                                try {
                                    return o.call(null, m);
                                } catch (e) {
                                    return o.call(this, m);
                                }
                            }
                        }(u);
                    }
                }
                function n(u, g) {
                    this.fun = u, this.array = g;
                }
                function c() {}
                e.nextTick = function(u) {
                    var g = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var m = 1; m < arguments.length; m++)g[m - 1] = arguments[m];
                    p.push(new n(u, g)), p.length !== 1 || y || l(t);
                }, n.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, e.title = "browser", e.browser = !0, e.env = {}, e.argv = [], e.version = "", e.versions = {}, e.on = c, e.addListener = c, e.once = c, e.off = c, e.removeListener = c, e.removeAllListeners = c, e.emit = c, e.prependListener = c, e.prependOnceListener = c, e.listeners = function(u) {
                    return [];
                }, e.binding = function(u) {
                    throw new Error("process.binding is not supported");
                }, e.cwd = function() {
                    return "/";
                }, e.chdir = function(u) {
                    throw new Error("process.chdir is not supported");
                }, e.umask = function() {
                    return 0;
                };
            },
            function(a, s, r) {
                function o(d, v) {
                    for(var l = 0; l < v.length; l++){
                        var f = v[l];
                        f.enumerable = f.enumerable || !1, f.configurable = !0, "value" in f && (f.writable = !0), Object.defineProperty(d, f.key, f);
                    }
                }
                var e = r(9);
                a.exports = function() {
                    function d() {
                        (function(p, y) {
                            if (!(p instanceof y)) throw new TypeError("Cannot call a class as a function");
                        })(this, d);
                    }
                    var v, l, f;
                    return v = d, f = [
                        {
                            key: "urlEncode",
                            value: function value(p) {
                                return e(p);
                            }
                        },
                        {
                            key: "jsonEncode",
                            value: function value(p) {
                                return JSON.stringify(p);
                            }
                        },
                        {
                            key: "formEncode",
                            value: function value(p) {
                                if (this.isFormData(p)) return p;
                                if (this.isFormElement(p)) return new FormData(p);
                                if (this.isObject(p)) {
                                    var y = new FormData();
                                    return Object.keys(p).forEach(function(w) {
                                        var b = p[w];
                                        y.append(w, b);
                                    }), y;
                                }
                                throw new Error("`data` must be an instance of Object, FormData or <FORM> HTMLElement");
                            }
                        },
                        {
                            key: "isObject",
                            value: function value(p) {
                                return Object.prototype.toString.call(p) === "[object Object]";
                            }
                        },
                        {
                            key: "isFormData",
                            value: function value(p) {
                                return p instanceof FormData;
                            }
                        },
                        {
                            key: "isFormElement",
                            value: function value(p) {
                                return p instanceof HTMLFormElement;
                            }
                        },
                        {
                            key: "selectFiles",
                            value: function value() {
                                var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                                return new Promise(function(y, w) {
                                    var b = document.createElement("INPUT");
                                    b.type = "file", p.multiple && b.setAttribute("multiple", "multiple"), p.accept && b.setAttribute("accept", p.accept), b.style.display = "none", document.body.appendChild(b), b.addEventListener("change", function(t) {
                                        var n = t.target.files;
                                        y(n), document.body.removeChild(b);
                                    }, !1), b.click();
                                });
                            }
                        },
                        {
                            key: "parseHeaders",
                            value: function value(p) {
                                var y = p.trim().split(/[\r\n]+/), w = {};
                                return y.forEach(function(b) {
                                    var t = b.split(": "), n = t.shift(), c = t.join(": ");
                                    n && (w[n] = c);
                                }), w;
                            }
                        }
                    ], l = null, f && o(v, f), d;
                }();
            },
            function(a, s) {
                var r = function r(e) {
                    return encodeURIComponent(e).replace(/[!'()*]/g, escape).replace(/%20/g, "+");
                }, o = function o1(e, d, v, l) {
                    return d = d || null, v = v || "&", l = l || null, e ? (function(f) {
                        for(var p = new Array(), y = 0; y < f.length; y++)f[y] && p.push(f[y]);
                        return p;
                    })(Object.keys(e).map(function(f) {
                        var p, y, w = f;
                        if (l && (w = l + "[" + w + "]"), (0, $7E0eS._)(e[f]) == "object" && e[f] !== null) p = o(e[f], null, v, w);
                        else {
                            d && (y = w, w = !isNaN(parseFloat(y)) && isFinite(y) ? d + Number(w) : w);
                            var b = e[f];
                            b = (b = (b = (b = b === !0 ? "1" : b) === !1 ? "0" : b) === 0 ? "0" : b) || "", p = r(w) + "=" + r(b);
                        }
                        return p;
                    })).join(v).replace(/[!'()*]/g, "") : "";
                };
                a.exports = o;
            }
        ]);
    });
})($40e8656eff946dc6$var$H);
var $40e8656eff946dc6$var$q = $40e8656eff946dc6$var$H.exports;
var $40e8656eff946dc6$var$j = /* @__PURE__ */ $40e8656eff946dc6$var$U($40e8656eff946dc6$var$q);
function $40e8656eff946dc6$var$O(C) {
    return C !== void 0 && typeof C.then == "function";
}
var $40e8656eff946dc6$var$A = /*#__PURE__*/ function() {
    "use strict";
    function A(param) {
        var i = param.config, a = param.onUpload, s = param.onError;
        (0, $173N4._)(this, A);
        this.config = i, this.onUpload = a, this.onError = s;
    }
    (0, $cFHGC._)(A, [
        {
            /**
   * Handle clicks on the upload file button
   * Fires ajax.transport()
   * @param onPreview - callback fired when preview is ready
   */ key: "uploadSelectedFile",
            value: function uploadSelectedFile(param) {
                var _this = this;
                var i = param.onPreview;
                var a = function a(r) {
                    var o = new FileReader();
                    o.readAsDataURL(r), o.onload = function(e) {
                        i(e.target.result);
                    };
                };
                var s;
                var _this_config_types, _this_config_field;
                if (this.config.uploader && typeof this.config.uploader.uploadByFile == "function") {
                    var r = this.config.uploader.uploadByFile;
                    var _this_config_types1;
                    s = $40e8656eff946dc6$var$j.selectFiles({
                        accept: (_this_config_types1 = this.config.types) !== null && _this_config_types1 !== void 0 ? _this_config_types1 : "image/*"
                    }).then(function(o) {
                        a(o[0]);
                        var e = r(o[0]);
                        return $40e8656eff946dc6$var$O(e) || console.warn("Custom uploader method uploadByFile should return a Promise"), e;
                    });
                } else s = $40e8656eff946dc6$var$j.transport({
                    url: this.config.endpoints.byFile,
                    data: this.config.additionalRequestData,
                    accept: (_this_config_types = this.config.types) !== null && _this_config_types !== void 0 ? _this_config_types : "image/*",
                    headers: this.config.additionalRequestHeaders,
                    beforeSend: function(r) {
                        a(r[0]);
                    },
                    fieldName: (_this_config_field = this.config.field) !== null && _this_config_field !== void 0 ? _this_config_field : "image"
                }).then(function(r) {
                    return r.body;
                });
                s.then(function(r) {
                    _this.onUpload(r);
                }).catch(function(r) {
                    _this.onError(r);
                });
            }
        },
        {
            /**
   * Handle clicks on the upload file button
   * Fires ajax.post()
   * @param url - image source url
   */ key: "uploadByUrl",
            value: function uploadByUrl(i) {
                var _this = this;
                var a;
                this.config.uploader && typeof this.config.uploader.uploadByUrl == "function" ? (a = this.config.uploader.uploadByUrl(i), $40e8656eff946dc6$var$O(a) || console.warn("Custom uploader method uploadByUrl should return a Promise")) : a = $40e8656eff946dc6$var$j.post({
                    url: this.config.endpoints.byUrl,
                    data: Object.assign({
                        url: i
                    }, this.config.additionalRequestData),
                    type: $40e8656eff946dc6$var$j.contentType.JSON,
                    headers: this.config.additionalRequestHeaders
                }).then(function(s) {
                    return s.body;
                }), a.then(function(s) {
                    _this.onUpload(s);
                }).catch(function(s) {
                    _this.onError(s);
                });
            }
        },
        {
            /**
   * Handle clicks on the upload file button
   * Fires ajax.post()
   * @param file - file pasted by drag-n-drop
   * @param onPreview - file pasted by drag-n-drop
   */ key: "uploadByFile",
            value: function uploadByFile(i, param) {
                var _this = this;
                var a = param.onPreview;
                var s = new FileReader();
                s.readAsDataURL(i), s.onload = function(o) {
                    a(o.target.result);
                };
                var r;
                if (this.config.uploader && typeof this.config.uploader.uploadByFile == "function") r = this.config.uploader.uploadByFile(i), $40e8656eff946dc6$var$O(r) || console.warn("Custom uploader method uploadByFile should return a Promise");
                else {
                    var o = new FormData();
                    var _this_config_field;
                    o.append((_this_config_field = this.config.field) !== null && _this_config_field !== void 0 ? _this_config_field : "image", i), this.config.additionalRequestData && Object.keys(this.config.additionalRequestData).length && Object.entries(this.config.additionalRequestData).forEach(function(param) {
                        var _param = (0, $f9AOD._)(param, 2), e = _param[0], d = _param[1];
                        o.append(e, d);
                    }), r = $40e8656eff946dc6$var$j.post({
                        url: this.config.endpoints.byFile,
                        data: o,
                        type: $40e8656eff946dc6$var$j.contentType.JSON,
                        headers: this.config.additionalRequestHeaders
                    }).then(function(e) {
                        return e.body;
                    });
                }
                r.then(function(o) {
                    _this.onUpload(o);
                }).catch(function(o) {
                    _this.onError(o);
                });
            }
        }
    ]);
    return A;
}();
/**
 * Image Tool for the Editor.js
 * @author CodeX <team@codex.so>
 * @license MIT
 * @see {@link https://github.com/editor-js/image}
 *
 * To developers.
 * To simplify Tool structure, we split it to 4 parts:
 *  1) index.ts — main Tool's interface, public API and methods for working with data
 *  2) uploader.ts — module that has methods for sending files via AJAX: from device, by URL or File pasting
 *  3) ui.ts — module for UI manipulations: render, showing preloader, etc
 *
 * For debug purposes there is a testing server
 * that can save uploaded files and return a Response {@link UploadResponseFormat}
 *
 *       $ node dev/server.js
 *
 * It will expose 8008 port, so you can pass http://localhost:8008 with the Tools config:
 *
 * image: {
 *   class: ImageTool,
 *   config: {
 *     endpoints: {
 *       byFile: 'http://localhost:8008/uploadFile',
 *       byUrl: 'http://localhost:8008/fetchUrl',
 *     }
 *   },
 * },
 */ var $40e8656eff946dc6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function P(param) {
        var _this = this;
        var i = param.data, a = param.config, s = param.api, r = param.readOnly, o = param.block;
        (0, $173N4._)(this, P);
        var _a_captionPlaceholder;
        this.isCaptionEnabled = null, this.api = s, this.block = o, this.config = {
            endpoints: a.endpoints,
            additionalRequestData: a.additionalRequestData,
            additionalRequestHeaders: a.additionalRequestHeaders,
            field: a.field,
            types: a.types,
            captionPlaceholder: this.api.i18n.t((_a_captionPlaceholder = a.captionPlaceholder) !== null && _a_captionPlaceholder !== void 0 ? _a_captionPlaceholder : "Caption"),
            buttonContent: a.buttonContent,
            uploader: a.uploader,
            actions: a.actions,
            features: a.features || {}
        }, this.uploader = new $40e8656eff946dc6$var$A({
            config: this.config,
            onUpload: function(e) {
                return _this.onUpload(e);
            },
            onError: function(e) {
                return _this.uploadingFailed(e);
            }
        }), this.ui = new $40e8656eff946dc6$var$D({
            api: s,
            config: this.config,
            onSelectFile: function() {
                _this.uploader.uploadSelectedFile({
                    onPreview: function(e) {
                        _this.ui.showPreloader(e);
                    }
                });
            },
            readOnly: r
        }), this._data = {
            caption: "",
            withBorder: !1,
            withBackground: !1,
            stretched: !1,
            file: {
                url: ""
            }
        }, this.data = i;
    }
    (0, $cFHGC._)(P, [
        {
            /**
   * Renders Block content
   */ key: "render",
            value: function render() {
                var i, a, s;
                return (((i = this.config.features) == null ? void 0 : i.caption) === !0 || ((a = this.config.features) == null ? void 0 : a.caption) === void 0 || ((s = this.config.features) == null ? void 0 : s.caption) === "optional" && this.data.caption) && (this.isCaptionEnabled = !0, this.ui.applyTune("caption", !0)), this.ui.render();
            }
        },
        {
            /**
   * Validate data: check if Image exists
   * @param savedData — data received after saving
   * @returns false if saved data is not correct, otherwise true
   */ key: "validate",
            value: function validate(i) {
                return !!i.file.url;
            }
        },
        {
            /**
   * Return Block data
   */ key: "save",
            value: function save() {
                var i = this.ui.nodes.caption;
                return this._data.caption = i.innerHTML, this.data;
            }
        },
        {
            /**
   * Returns configuration for block tunes: add background, add border, stretch image
   * @returns TunesMenuConfig
   */ key: "renderSettings",
            value: function renderSettings() {
                var _this = this;
                var o;
                var i = P.tunes.concat(this.config.actions || []), a = {
                    border: "withBorder",
                    background: "withBackground",
                    stretch: "stretched",
                    caption: "caption"
                };
                ((o = this.config.features) == null ? void 0 : o.caption) === "optional" && i.push({
                    name: "caption",
                    icon: $40e8656eff946dc6$var$B,
                    title: "With caption",
                    toggle: !0
                });
                var s = i.filter(function(e) {
                    var v, l;
                    var d = Object.keys(a).find(function(f) {
                        return a[f] === e.name;
                    });
                    return d === "caption" ? ((v = _this.config.features) == null ? void 0 : v.caption) !== !1 : d == null || ((l = _this.config.features) == null ? void 0 : l[d]) !== !1;
                }), r = function(e) {
                    var d = _this.data[e.name];
                    var _this_isCaptionEnabled;
                    return e.name === "caption" && (d = (_this_isCaptionEnabled = _this.isCaptionEnabled) !== null && _this_isCaptionEnabled !== void 0 ? _this_isCaptionEnabled : d), d;
                };
                return s.map(function(e) {
                    return {
                        icon: e.icon,
                        label: _this.api.i18n.t(e.title),
                        name: e.name,
                        toggle: e.toggle,
                        isActive: r(e),
                        onActivate: function() {
                            if (typeof e.action == "function") {
                                e.action(e.name);
                                return;
                            }
                            var d = !r(e);
                            var _this_isCaptionEnabled;
                            e.name === "caption" && (_this.isCaptionEnabled = !((_this_isCaptionEnabled = _this.isCaptionEnabled) !== null && _this_isCaptionEnabled !== void 0 ? _this_isCaptionEnabled : !1), d = _this.isCaptionEnabled), _this.tuneToggled(e.name, d);
                        }
                    };
                });
            }
        },
        {
            /**
   * Fires after clicks on the Toolbox Image Icon
   * Initiates click on the Select File button
   */ key: "appendCallback",
            value: function appendCallback() {
                this.ui.nodes.fileButton.click();
            }
        },
        {
            key: "onPaste",
            value: /**
   * Specify paste handlers
   * @see {@link https://github.com/codex-team/editor.js/blob/master/docs/tools.md#paste-handling}
   * @param event - editor.js custom paste event
   *                              {@link https://github.com/codex-team/editor.js/blob/master/types/tools/paste-events.d.ts}
   */ function onPaste(i) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _, a, r, a1, a2;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = i.type;
                                switch(_){
                                    case "tag":
                                        return [
                                            3,
                                            1
                                        ];
                                    case "pattern":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "file":
                                        return [
                                            3,
                                            6
                                        ];
                                }
                                return [
                                    3,
                                    7
                                ];
                            case 1:
                                a = i.detail.data;
                                if (!/^blob:/.test(a.src)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    fetch(a.src)
                                ];
                            case 2:
                                return [
                                    4,
                                    _state.sent().blob()
                                ];
                            case 3:
                                r = _state.sent();
                                this.uploadFile(r);
                                return [
                                    3,
                                    7
                                ];
                            case 4:
                                this.uploadUrl(a.src);
                                return [
                                    3,
                                    7
                                ];
                            case 5:
                                {
                                    a1 = i.detail.data;
                                    this.uploadUrl(a1);
                                    return [
                                        3,
                                        7
                                    ];
                                }
                                _state.label = 6;
                            case 6:
                                {
                                    a2 = i.detail.file;
                                    this.uploadFile(a2);
                                    return [
                                        3,
                                        7
                                    ];
                                }
                                _state.label = 7;
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "data",
            get: /**
   * Return Tool data
   */ function get() {
                return this._data;
            },
            set: /**
   * Private methods
   * ̿̿ ̿̿ ̿̿ ̿'̿'\̵͇̿̿\з= ( ▀ ͜͞ʖ▀) =ε/̵͇̿̿/’̿’̿ ̿ ̿̿ ̿̿ ̿̿
   */ /**
   * Stores all Tool's data
   * @param data - data in Image Tool format
   */ function set(i) {
                var _this = this;
                var a;
                this.image = i.file, this._data.caption = i.caption || "", this.ui.fillCaption(this._data.caption), P.tunes.forEach(function(param) {
                    var s = param.name;
                    var r = (0, $7E0eS._)(i[s]) < "u" ? i[s] === !0 || i[s] === "true" : !1;
                    _this.setTune(s, r);
                }), i.caption ? this.setTune("caption", !0) : ((a = this.config.features) == null ? void 0 : a.caption) === !0 && this.setTune("caption", !0);
            }
        },
        {
            key: "image",
            set: /**
   * Set new image file
   * @param file - uploaded file data
   */ function set(i) {
                this._data.file = i || {
                    url: ""
                }, i && i.url && this.ui.fillImage(i.url);
            }
        },
        {
            /**
   * File uploading callback
   * @param response - uploading server response
   */ key: "onUpload",
            value: function onUpload(i) {
                i.success && i.file ? this.image = i.file : this.uploadingFailed("incorrect response: " + JSON.stringify(i));
            }
        },
        {
            /**
   * Handle uploader errors
   * @param errorText - uploading error info
   */ key: "uploadingFailed",
            value: function uploadingFailed(i) {
                console.log("Image Tool: uploading failed because of", i), this.api.notifier.show({
                    message: this.api.i18n.t("Couldn\u2019t upload image. Please try another."),
                    style: "error"
                }), this.ui.hidePreloader();
            }
        },
        {
            /**
   * Callback fired when Block Tune is activated
   * @param tuneName - tune that has been clicked
   * @param state - new state
   */ key: "tuneToggled",
            value: function tuneToggled(i, a) {
                i === "caption" ? (this.ui.applyTune(i, a), a == !1 && (this._data.caption = "", this.ui.fillCaption(""))) : this.setTune(i, a);
            }
        },
        {
            /**
   * Set one tune
   * @param tuneName - {@link Tunes.tunes}
   * @param value - tune state
   */ key: "setTune",
            value: function setTune(i, a) {
                var _this = this;
                this._data[i] = a, this.ui.applyTune(i, a), i === "stretched" && Promise.resolve().then(function() {
                    _this.block.stretched = a;
                }).catch(function(s) {
                    console.error(s);
                });
            }
        },
        {
            /**
   * Show preloader and upload image file
   * @param file - file that is currently uploading (from paste)
   */ key: "uploadFile",
            value: function uploadFile(i) {
                var _this = this;
                this.uploader.uploadByFile(i, {
                    onPreview: function(a) {
                        _this.ui.showPreloader(a);
                    }
                });
            }
        },
        {
            /**
   * Show preloader and upload image by target url
   * @param url - url pasted
   */ key: "uploadUrl",
            value: function uploadUrl(i) {
                this.ui.showPreloader(i), this.uploader.uploadByUrl(i);
            }
        }
    ], [
        {
            key: "isReadOnlySupported",
            get: /**
   * Notify core that read-only mode is supported
   */ function get() {
                return !0;
            }
        },
        {
            key: "toolbox",
            get: /**
   * Get Tool toolbox settings
   * icon - Tool icon's SVG
   * title - title to show in toolbox
   */ function get() {
                return {
                    icon: $40e8656eff946dc6$var$L,
                    title: "Image"
                };
            }
        },
        {
            key: "tunes",
            get: /**
   * Available image tools
   */ function get() {
                return [
                    {
                        name: "withBorder",
                        icon: $40e8656eff946dc6$var$I,
                        title: "With border",
                        toggle: !0
                    },
                    {
                        name: "stretched",
                        icon: $40e8656eff946dc6$var$x,
                        title: "Stretch image",
                        toggle: !0
                    },
                    {
                        name: "withBackground",
                        icon: $40e8656eff946dc6$var$R,
                        title: "With background",
                        toggle: !0
                    }
                ];
            }
        },
        {
            key: "pasteConfig",
            get: /**
   * Specify paste substitutes
   * @see {@link https://github.com/codex-team/editor.js/blob/master/docs/tools.md#paste-handling}
   */ function get() {
                return {
                    /**
       * Paste HTML into Editor
       */ tags: [
                        {
                            img: {
                                src: !0
                            }
                        }
                    ],
                    /**
       * Paste URL of image into the Editor
       */ patterns: {
                        image: /https?:\/\/\S+\.(gif|jpe?g|tiff|png|svg|webp)(\?[a-z0-9=]*)?$/i
                    },
                    /**
       * Drag n drop file from into the Editor
       */ files: {
                        mimeTypes: [
                            "image/*"
                        ]
                    }
                };
            }
        }
    ]);
    return P;
}();



var $3gP77 = parcelRequire("3gP77");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");

var $13u2V = parcelRequire("13u2V");
(function() {
    "use strict";
    try {
        if ((typeof document === "undefined" ? "undefined" : (0, $7E0eS._)(document)) < "u") {
            var o = document.createElement("style");
            o.appendChild(document.createTextNode(".link-tool{position:relative}.link-tool__input{padding-left:38px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath stroke='%23707684' stroke-linecap='round' stroke-width='2' d='m7.7 12.6-.021.02a2.795 2.795 0 0 0-.044 4.005v0a2.795 2.795 0 0 0 3.936.006l1.455-1.438a3 3 0 0 0 .34-3.866l-.146-.207'/%3E%3Cpath stroke='%23707684' stroke-linecap='round' stroke-width='2' d='m16.22 11.12.136-.14c.933-.954.992-2.46.135-3.483v0a2.597 2.597 0 0 0-3.664-.32L11.39 8.386a3 3 0 0 0-.301 4.3l.031.034'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:10px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.link-tool__input-holder{position:relative}.link-tool__input-holder--error .link-tool__input{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath stroke='rgb(224, 147, 147)' stroke-linecap='round' stroke-width='2' d='m7.7 12.6-.021.02a2.795 2.795 0 0 0-.044 4.005v0a2.795 2.795 0 0 0 3.936.006l1.455-1.438a3 3 0 0 0 .34-3.866l-.146-.207'/%3E%3Cpath stroke='rgb(224, 147, 147)' stroke-linecap='round' stroke-width='2' d='m16.22 11.12.136-.14c.933-.954.992-2.46.135-3.483v0a2.597 2.597 0 0 0-3.664-.32L11.39 8.386a3 3 0 0 0-.301 4.3l.031.034'/%3E%3C/svg%3E\");background-color:#fff3f6;border-color:#f3e0e0;color:#a95a5a;box-shadow:inset 0 1px 3px #923e3e0d}.link-tool__input[contentEditable=true][data-placeholder]:before{position:absolute;content:attr(data-placeholder);color:#707684;font-weight:400;opacity:0}.link-tool__input[contentEditable=true][data-placeholder]:empty:before{opacity:1}.link-tool__input[contentEditable=true][data-placeholder]:empty:focus:before{opacity:0}.link-tool__progress{position:absolute;box-shadow:inset 0 1px 3px #66556b0a;height:100%;width:0;background-color:#f4f5f7;z-index:-1}.link-tool__progress--loading{-webkit-animation:progress .5s ease-in;-webkit-animation-fill-mode:forwards}.link-tool__progress--loaded{width:100%}.link-tool__content{display:block;padding:25px;border-radius:2px;box-shadow:0 0 0 2px #fff;color:initial!important;text-decoration:none!important}.link-tool__content:after{content:\"\";clear:both;display:table}.link-tool__content--rendered{background:#fff;border:1px solid rgba(201,201,204,.48);box-shadow:0 1px 3px #0000001a;border-radius:6px;will-change:filter;animation:link-in .45s 1 cubic-bezier(.215,.61,.355,1)}.link-tool__content--rendered:hover{box-shadow:0 0 3px #00000029}.link-tool__image{background-position:center center;background-repeat:no-repeat;background-size:cover;margin:0 0 0 30px;width:65px;height:65px;border-radius:3px;float:right}.link-tool__title{font-size:17px;font-weight:600;line-height:1.5em;margin:0 0 10px}.link-tool__title+.link-tool__anchor{margin-top:25px}.link-tool__description{margin:0 0 20px;font-size:15px;line-height:1.55em;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}.link-tool__anchor{display:block;font-size:15px;line-height:1em;color:#888!important;border:0!important;padding:0!important}@keyframes link-in{0%{filter:blur(5px)}to{filter:none}}.codex-editor--narrow .link-tool__image{display:none}@-webkit-keyframes progress{0%{width:0}to{width:85%}}")), document.head.appendChild(o);
        }
    } catch (t) {
        console.error("vite-plugin-css-injected-by-js", t);
    }
})();
var $dd43b7a78f9ce268$var$C = (typeof globalThis === "undefined" ? "undefined" : (0, $7E0eS._)(globalThis)) < "u" ? globalThis : (typeof window === "undefined" ? "undefined" : (0, $7E0eS._)(window)) < "u" ? window : (typeof $parcel$global === "undefined" ? "undefined" : (0, $7E0eS._)($parcel$global)) < "u" ? $parcel$global : (typeof self === "undefined" ? "undefined" : (0, $7E0eS._)(self)) < "u" ? self : {};
function $dd43b7a78f9ce268$var$O(k) {
    return k && k.__esModule && Object.prototype.hasOwnProperty.call(k, "default") ? k.default : k;
}
(function(k) {
    var w = function w() {
        try {
            return !!Symbol.iterator;
        } catch (e) {
            return !1;
        }
    }, d = w(), v = function v(n) {
        var o = {
            next: function next() {
                var e = n.shift();
                return {
                    done: e === void 0,
                    value: e
                };
            }
        };
        return d && (o[Symbol.iterator] = function() {
            return o;
        }), o;
    }, c = function c(n) {
        return encodeURIComponent(n).replace(/%20/g, "+");
    }, i = function i(n) {
        return decodeURIComponent(String(n).replace(/\+/g, " "));
    }, a = function a() {
        var n = function n1(e) {
            Object.defineProperty(this, "_entries", {
                writable: !0,
                value: {}
            });
            var s = typeof e === "undefined" ? "undefined" : (0, $7E0eS._)(e);
            if (s !== "undefined") {
                if (s === "string") e !== "" && this._fromString(e);
                else if (e instanceof n) {
                    var h = this;
                    e.forEach(function(u, f) {
                        h.append(f, u);
                    });
                } else if (e !== null && s === "object") {
                    if (Object.prototype.toString.call(e) === "[object Array]") for(var t = 0; t < e.length; t++){
                        var y = e[t];
                        if (Object.prototype.toString.call(y) === "[object Array]" || y.length !== 2) this.append(y[0], y[1]);
                        else throw new TypeError("Expected [string, any] as entry at index " + t + " of URLSearchParams's input");
                    }
                    else for(var r in e)e.hasOwnProperty(r) && this.append(r, e[r]);
                } else throw new TypeError("Unsupported input's type for URLSearchParams");
            }
        }, o = n.prototype;
        o.append = function(e, s) {
            e in this._entries ? this._entries[e].push(String(s)) : this._entries[e] = [
                String(s)
            ];
        }, o.delete = function(e) {
            delete this._entries[e];
        }, o.get = function(e) {
            return e in this._entries ? this._entries[e][0] : null;
        }, o.getAll = function(e) {
            return e in this._entries ? this._entries[e].slice(0) : [];
        }, o.has = function(e) {
            return e in this._entries;
        }, o.set = function(e, s) {
            this._entries[e] = [
                String(s)
            ];
        }, o.forEach = function(e, s) {
            var h;
            for(var t in this._entries)if (this._entries.hasOwnProperty(t)) {
                h = this._entries[t];
                for(var y = 0; y < h.length; y++)e.call(s, h[y], t, this);
            }
        }, o.keys = function() {
            var e = [];
            return this.forEach(function(s, h) {
                e.push(h);
            }), v(e);
        }, o.values = function() {
            var e = [];
            return this.forEach(function(s) {
                e.push(s);
            }), v(e);
        }, o.entries = function() {
            var e = [];
            return this.forEach(function(s, h) {
                e.push([
                    h,
                    s
                ]);
            }), v(e);
        }, d && (o[Symbol.iterator] = o.entries), o.toString = function() {
            var e = [];
            return this.forEach(function(s, h) {
                e.push(c(h) + "=" + c(s));
            }), e.join("&");
        }, k.URLSearchParams = n;
    }, p = function p() {
        try {
            var n = k.URLSearchParams;
            return new n("?a=1").toString() === "a=1" && typeof n.prototype.set == "function";
        } catch (e) {
            return !1;
        }
    };
    p() || a();
    var l = k.URLSearchParams.prototype;
    typeof l.sort != "function" && (l.sort = function() {
        var n = this, o = [];
        this.forEach(function(s, h) {
            o.push([
                h,
                s
            ]), n._entries || n.delete(h);
        }), o.sort(function(s, h) {
            return s[0] < h[0] ? -1 : s[0] > h[0] ? 1 : 0;
        }), n._entries && (n._entries = {});
        for(var e = 0; e < o.length; e++)this.append(o[e][0], o[e][1]);
    }), typeof l._fromString != "function" && Object.defineProperty(l, "_fromString", {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: function value(n) {
            if (this._entries) this._entries = {};
            else {
                var o = [];
                this.forEach(function(t, y) {
                    o.push(y);
                });
                for(var e = 0; e < o.length; e++)this.delete(o[e]);
            }
            n = n.replace(/^\?/, "");
            for(var s = n.split("&"), h, e = 0; e < s.length; e++)h = s[e].split("="), this.append(i(h[0]), h.length > 1 ? i(h[1]) : "");
        }
    });
})((typeof $dd43b7a78f9ce268$var$C === "undefined" ? "undefined" : (0, $7E0eS._)($dd43b7a78f9ce268$var$C)) < "u" ? $dd43b7a78f9ce268$var$C : (typeof window === "undefined" ? "undefined" : (0, $7E0eS._)(window)) < "u" ? window : (typeof self === "undefined" ? "undefined" : (0, $7E0eS._)(self)) < "u" ? self : $dd43b7a78f9ce268$var$C);
(function(k) {
    var w = function w() {
        try {
            var c = new k.URL("b", "http://a");
            return c.pathname = "c d", c.href === "http://a/c%20d" && c.searchParams;
        } catch (e) {
            return !1;
        }
    }, d = function d() {
        var c = k.URL, i = function i(l, n) {
            typeof l != "string" && (l = String(l));
            var o = document, e;
            if (n && (k.location === void 0 || n !== k.location.href)) {
                o = document.implementation.createHTMLDocument(""), e = o.createElement("base"), e.href = n, o.head.appendChild(e);
                try {
                    if (e.href.indexOf(n) !== 0) throw new Error(e.href);
                } catch (m) {
                    throw new Error("URL unable to set base " + n + " due to " + m);
                }
            }
            var s = o.createElement("a");
            s.href = l, e && (o.body.appendChild(s), s.href = s.href);
            var h = o.createElement("input");
            if (h.type = "url", h.value = l, s.protocol === ":" || !/:/.test(s.href) || !h.checkValidity() && !n) throw new TypeError("Invalid URL");
            Object.defineProperty(this, "_anchorElement", {
                value: s
            });
            var t = new k.URLSearchParams(this.search), y = !0, r = !0, u = this;
            [
                "append",
                "delete",
                "set"
            ].forEach(function(m) {
                var b = t[m];
                t[m] = function() {
                    b.apply(t, arguments), y && (r = !1, u.search = t.toString(), r = !0);
                };
            }), Object.defineProperty(this, "searchParams", {
                value: t,
                enumerable: !0
            });
            var f = void 0;
            Object.defineProperty(this, "_updateSearchParams", {
                enumerable: !1,
                configurable: !1,
                writable: !1,
                value: function value() {
                    this.search !== f && (f = this.search, r && (y = !1, this.searchParams._fromString(this.search), y = !0));
                }
            });
        }, a = i.prototype, p = function p(l) {
            Object.defineProperty(a, l, {
                get: function get() {
                    return this._anchorElement[l];
                },
                set: function set(n) {
                    this._anchorElement[l] = n;
                },
                enumerable: !0
            });
        };
        [
            "hash",
            "host",
            "hostname",
            "port",
            "protocol"
        ].forEach(function(l) {
            p(l);
        }), Object.defineProperty(a, "search", {
            get: function get() {
                return this._anchorElement.search;
            },
            set: function set(l) {
                this._anchorElement.search = l, this._updateSearchParams();
            },
            enumerable: !0
        }), Object.defineProperties(a, {
            toString: {
                get: function get() {
                    var l = this;
                    return function() {
                        return l.href;
                    };
                }
            },
            href: {
                get: function get() {
                    return this._anchorElement.href.replace(/\?$/, "");
                },
                set: function set(l) {
                    this._anchorElement.href = l, this._updateSearchParams();
                },
                enumerable: !0
            },
            pathname: {
                get: function get() {
                    return this._anchorElement.pathname.replace(/(^\/?)/, "/");
                },
                set: function set(l) {
                    this._anchorElement.pathname = l;
                },
                enumerable: !0
            },
            origin: {
                get: function get() {
                    var l = {
                        "http:": 80,
                        "https:": 443,
                        "ftp:": 21
                    }[this._anchorElement.protocol], n = this._anchorElement.port != l && this._anchorElement.port !== "";
                    return this._anchorElement.protocol + "//" + this._anchorElement.hostname + (n ? ":" + this._anchorElement.port : "");
                },
                enumerable: !0
            },
            password: {
                // TODO
                get: function get() {
                    return "";
                },
                set: function set(l) {},
                enumerable: !0
            },
            username: {
                // TODO
                get: function get() {
                    return "";
                },
                set: function set(l) {},
                enumerable: !0
            }
        }), i.createObjectURL = function(l) {
            return c.createObjectURL.apply(c, arguments);
        }, i.revokeObjectURL = function(l) {
            return c.revokeObjectURL.apply(c, arguments);
        }, k.URL = i;
    };
    if (w() || d(), k.location !== void 0 && !("origin" in k.location)) {
        var v = function v() {
            return k.location.protocol + "//" + k.location.hostname + (k.location.port ? ":" + k.location.port : "");
        };
        try {
            Object.defineProperty(k.location, "origin", {
                get: v,
                enumerable: !0
            });
        } catch (e) {
            setInterval(function() {
                k.location.origin = v();
            }, 100);
        }
    }
})((typeof $dd43b7a78f9ce268$var$C === "undefined" ? "undefined" : (0, $7E0eS._)($dd43b7a78f9ce268$var$C)) < "u" ? $dd43b7a78f9ce268$var$C : (typeof window === "undefined" ? "undefined" : (0, $7E0eS._)(window)) < "u" ? window : (typeof self === "undefined" ? "undefined" : (0, $7E0eS._)(self)) < "u" ? self : $dd43b7a78f9ce268$var$C);
var $dd43b7a78f9ce268$var$j = {
    exports: {}
};
(function(k, w) {
    (function(d, v) {
        k.exports = v();
    })(window, function() {
        return function(d) {
            var v = {};
            function c(i) {
                if (v[i]) return v[i].exports;
                var a = v[i] = {
                    i: i,
                    l: !1,
                    exports: {}
                };
                return d[i].call(a.exports, a, a.exports, c), a.l = !0, a.exports;
            }
            return c.m = d, c.c = v, c.d = function(i, a, p) {
                c.o(i, a) || Object.defineProperty(i, a, {
                    enumerable: !0,
                    get: p
                });
            }, c.r = function(i) {
                (typeof Symbol === "undefined" ? "undefined" : (0, $7E0eS._)(Symbol)) < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(i, "__esModule", {
                    value: !0
                });
            }, c.t = function(i, a) {
                if (1 & a && (i = c(i)), 8 & a || 4 & a && (typeof i === "undefined" ? "undefined" : (0, $7E0eS._)(i)) == "object" && i && i.__esModule) return i;
                var p = /* @__PURE__ */ Object.create(null);
                if (c.r(p), Object.defineProperty(p, "default", {
                    enumerable: !0,
                    value: i
                }), 2 & a && typeof i != "string") for(var l in i)c.d(p, l, (function(n) {
                    return i[n];
                }).bind(null, l));
                return p;
            }, c.n = function(i) {
                var a = i && i.__esModule ? function a() {
                    return i.default;
                } : function() {
                    return i;
                };
                return c.d(a, "a", a), a;
            }, c.o = function(i, a) {
                return Object.prototype.hasOwnProperty.call(i, a);
            }, c.p = "", c(c.s = 3);
        }([
            function(d, v) {
                var c;
                c = function() {
                    return this;
                }();
                try {
                    c = c || new Function("return this")();
                } catch (e) {
                    (typeof window === "undefined" ? "undefined" : (0, $7E0eS._)(window)) == "object" && (c = window);
                }
                d.exports = c;
            },
            function(d, v, c) {
                (function(i) {
                    var a = c(2), p = setTimeout;
                    function l() {}
                    function n(r) {
                        if (!(this instanceof n)) throw new TypeError("Promises must be constructed via new");
                        if (typeof r != "function") throw new TypeError("not a function");
                        this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], y(r, this);
                    }
                    function o(r, u) {
                        for(; r._state === 3;)r = r._value;
                        r._state !== 0 ? (r._handled = !0, n._immediateFn(function() {
                            var f = r._state === 1 ? u.onFulfilled : u.onRejected;
                            if (f !== null) {
                                var m;
                                try {
                                    m = f(r._value);
                                } catch (b) {
                                    return void s(u.promise, b);
                                }
                                e(u.promise, m);
                            } else (r._state === 1 ? e : s)(u.promise, r._value);
                        })) : r._deferreds.push(u);
                    }
                    function e(r, u) {
                        try {
                            if (u === r) throw new TypeError("A promise cannot be resolved with itself.");
                            if (u && ((typeof u === "undefined" ? "undefined" : (0, $7E0eS._)(u)) == "object" || typeof u == "function")) {
                                var f = u.then;
                                if (u instanceof n) return r._state = 3, r._value = u, void h(r);
                                if (typeof f == "function") return void y((m = f, b = u, function() {
                                    m.apply(b, arguments);
                                }), r);
                            }
                            r._state = 1, r._value = u, h(r);
                        } catch (g) {
                            s(r, g);
                        }
                        var m, b;
                    }
                    function s(r, u) {
                        r._state = 2, r._value = u, h(r);
                    }
                    function h(r) {
                        r._state === 2 && r._deferreds.length === 0 && n._immediateFn(function() {
                            r._handled || n._unhandledRejectionFn(r._value);
                        });
                        for(var u = 0, f = r._deferreds.length; u < f; u++)o(r, r._deferreds[u]);
                        r._deferreds = null;
                    }
                    function t(r, u, f) {
                        this.onFulfilled = typeof r == "function" ? r : null, this.onRejected = typeof u == "function" ? u : null, this.promise = f;
                    }
                    function y(r, u) {
                        var f = !1;
                        try {
                            r(function(m) {
                                f || (f = !0, e(u, m));
                            }, function(m) {
                                f || (f = !0, s(u, m));
                            });
                        } catch (m) {
                            if (f) return;
                            f = !0, s(u, m);
                        }
                    }
                    n.prototype.catch = function(r) {
                        return this.then(null, r);
                    }, n.prototype.then = function(r, u) {
                        var f = new this.constructor(l);
                        return o(this, new t(r, u, f)), f;
                    }, n.prototype.finally = a.a, n.all = function(r) {
                        return new n(function(u, f) {
                            if (!r || r.length === void 0) throw new TypeError("Promise.all accepts an array");
                            var m = Array.prototype.slice.call(r);
                            if (m.length === 0) return u([]);
                            var b = m.length;
                            function g(T, E) {
                                try {
                                    if (E && ((typeof E === "undefined" ? "undefined" : (0, $7E0eS._)(E)) == "object" || typeof E == "function")) {
                                        var S = E.then;
                                        if (typeof S == "function") return void S.call(E, function(L) {
                                            g(T, L);
                                        }, f);
                                    }
                                    m[T] = E, --b == 0 && u(m);
                                } catch (L) {
                                    f(L);
                                }
                            }
                            for(var _ = 0; _ < m.length; _++)g(_, m[_]);
                        });
                    }, n.resolve = function(r) {
                        return r && (typeof r === "undefined" ? "undefined" : (0, $7E0eS._)(r)) == "object" && r.constructor === n ? r : new n(function(u) {
                            u(r);
                        });
                    }, n.reject = function(r) {
                        return new n(function(u, f) {
                            f(r);
                        });
                    }, n.race = function(r) {
                        return new n(function(u, f) {
                            for(var m = 0, b = r.length; m < b; m++)r[m].then(u, f);
                        });
                    }, n._immediateFn = typeof i == "function" && function(r) {
                        i(r);
                    } || function(r) {
                        p(r, 0);
                    }, n._unhandledRejectionFn = function(r) {
                        (typeof console === "undefined" ? "undefined" : (0, $7E0eS._)(console)) < "u" && console && console.warn("Possible Unhandled Promise Rejection:", r);
                    }, v.a = n;
                }).call(this, c(5).setImmediate);
            },
            function(d, v, c) {
                v.a = function(i) {
                    var a = this.constructor;
                    return this.then(function(p) {
                        return a.resolve(i()).then(function() {
                            return p;
                        });
                    }, function(p) {
                        return a.resolve(i()).then(function() {
                            return a.reject(p);
                        });
                    });
                };
            },
            function(d, v, c) {
                function i(t) {
                    return (i = typeof Symbol == "function" && (0, $7E0eS._)(Symbol.iterator) == "symbol" ? function i(y) {
                        return typeof y === "undefined" ? "undefined" : (0, $7E0eS._)(y);
                    } : function(y) {
                        return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y === "undefined" ? "undefined" : (0, $7E0eS._)(y);
                    })(t);
                }
                c(4);
                var a, p, l, n, o, e, s = c(8), h = (p = function p(t) {
                    return new Promise(function(y, r) {
                        t = n(t), t = o(t);
                        var u = window.XMLHttpRequest ? new window.XMLHttpRequest() : new window.ActiveXObject("Microsoft.XMLHTTP");
                        u.open(t.method, t.url), u.setRequestHeader("X-Requested-With", "XMLHttpRequest"), Object.keys(t.headers).forEach(function(m) {
                            var b = t.headers[m];
                            u.setRequestHeader(m, b);
                        });
                        var f = t.ratio;
                        u.upload.addEventListener("progress", function(m) {
                            var b = Math.round(m.loaded / m.total * 100), g = Math.ceil(b * f / 100);
                            t.progress(g);
                        }, !1), u.addEventListener("progress", function(m) {
                            var b = Math.round(m.loaded / m.total * 100), g = Math.ceil(b * (100 - f) / 100) + f;
                            t.progress(g);
                        }, !1), u.onreadystatechange = function() {
                            if (u.readyState === 4) {
                                var m = u.response;
                                try {
                                    m = JSON.parse(m);
                                } catch (e) {}
                                var b = s.parseHeaders(u.getAllResponseHeaders()), g = {
                                    body: m,
                                    code: u.status,
                                    headers: b
                                };
                                u.status === 200 ? y(g) : r(g);
                            }
                        }, u.send(t.data);
                    });
                }, l = function l(t) {
                    return t.method = "POST", p(t);
                }, n = function n() {
                    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    if (t.url && typeof t.url != "string") throw new Error("Url must be a string");
                    if (t.url = t.url || "", t.method && typeof t.method != "string") throw new Error("`method` must be a string or null");
                    if (t.method = t.method ? t.method.toUpperCase() : "GET", t.headers && i(t.headers) !== "object") throw new Error("`headers` must be an object or null");
                    if (t.headers = t.headers || {}, t.type && (typeof t.type != "string" || !Object.values(a).includes(t.type))) throw new Error("`type` must be taken from module's \xabcontentType\xbb library");
                    if (t.progress && typeof t.progress != "function") throw new Error("`progress` must be a function or null");
                    if (t.progress = t.progress || function(y) {}, t.beforeSend = t.beforeSend || function(y) {}, t.ratio && typeof t.ratio != "number") throw new Error("`ratio` must be a number");
                    if (t.ratio < 0 || t.ratio > 100) throw new Error("`ratio` must be in a 0-100 interval");
                    if (t.ratio = t.ratio || 90, t.accept && typeof t.accept != "string") throw new Error("`accept` must be a string with a list of allowed mime-types");
                    if (t.accept = t.accept || "*/*", t.multiple && typeof t.multiple != "boolean") throw new Error("`multiple` must be a true or false");
                    if (t.multiple = t.multiple || !1, t.fieldName && typeof t.fieldName != "string") throw new Error("`fieldName` must be a string");
                    return t.fieldName = t.fieldName || "files", t;
                }, o = function o(t) {
                    switch(t.method){
                        case "GET":
                            var y = e(t.data, a.URLENCODED);
                            delete t.data, t.url = /\?/.test(t.url) ? t.url + "&" + y : t.url + "?" + y;
                            break;
                        case "POST":
                        case "PUT":
                        case "DELETE":
                        case "UPDATE":
                            var r = function() {
                                return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).type || a.JSON;
                            }(t);
                            (s.isFormData(t.data) || s.isFormElement(t.data)) && (r = a.FORM), t.data = e(t.data, r), r !== h.contentType.FORM && (t.headers["content-type"] = r);
                    }
                    return t;
                }, e = function e() {
                    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    switch(arguments.length > 1 ? arguments[1] : void 0){
                        case a.URLENCODED:
                            return s.urlEncode(t);
                        case a.JSON:
                            return s.jsonEncode(t);
                        case a.FORM:
                            return s.formEncode(t);
                        default:
                            return t;
                    }
                }, {
                    contentType: a = {
                        URLENCODED: "application/x-www-form-urlencoded; charset=utf-8",
                        FORM: "multipart/form-data",
                        JSON: "application/json; charset=utf-8"
                    },
                    request: p,
                    get: function get(t) {
                        return t.method = "GET", p(t);
                    },
                    post: l,
                    transport: function transport(t) {
                        return t = n(t), s.selectFiles(t).then(function(y) {
                            for(var r = new FormData(), u = 0; u < y.length; u++)r.append(t.fieldName, y[u], y[u].name);
                            return s.isObject(t.data) && Object.keys(t.data).forEach(function(f) {
                                var m = t.data[f];
                                r.append(f, m);
                            }), t.beforeSend && t.beforeSend(y), t.data = r, l(t);
                        });
                    },
                    selectFiles: function selectFiles(t) {
                        return delete (t = n(t)).beforeSend, s.selectFiles(t);
                    }
                });
                d.exports = h;
            },
            function(d, v, c) {
                c.r(v);
                var i = c(1);
                window.Promise = window.Promise || i.a;
            },
            function(d, v, c) {
                (function(i) {
                    var a = i !== void 0 && i || (typeof self === "undefined" ? "undefined" : (0, $7E0eS._)(self)) < "u" && self || window, p = Function.prototype.apply;
                    function l(n, o) {
                        this._id = n, this._clearFn = o;
                    }
                    v.setTimeout = function() {
                        return new l(p.call(setTimeout, a, arguments), clearTimeout);
                    }, v.setInterval = function() {
                        return new l(p.call(setInterval, a, arguments), clearInterval);
                    }, v.clearTimeout = v.clearInterval = function(n) {
                        n && n.close();
                    }, l.prototype.unref = l.prototype.ref = function() {}, l.prototype.close = function() {
                        this._clearFn.call(a, this._id);
                    }, v.enroll = function(n, o) {
                        clearTimeout(n._idleTimeoutId), n._idleTimeout = o;
                    }, v.unenroll = function(n) {
                        clearTimeout(n._idleTimeoutId), n._idleTimeout = -1;
                    }, v._unrefActive = v.active = function(n) {
                        clearTimeout(n._idleTimeoutId);
                        var o = n._idleTimeout;
                        o >= 0 && (n._idleTimeoutId = setTimeout(function() {
                            n._onTimeout && n._onTimeout();
                        }, o));
                    }, c(6), v.setImmediate = (typeof self === "undefined" ? "undefined" : (0, $7E0eS._)(self)) < "u" && self.setImmediate || i !== void 0 && i.setImmediate || this && this.setImmediate, v.clearImmediate = (typeof self === "undefined" ? "undefined" : (0, $7E0eS._)(self)) < "u" && self.clearImmediate || i !== void 0 && i.clearImmediate || this && this.clearImmediate;
                }).call(this, c(0));
            },
            function(d, v, c) {
                (function(i, a) {
                    (function(p, l) {
                        if (!p.setImmediate) {
                            var n, o, e, s, h, t = 1, y = {}, r = !1, u = p.document, f = Object.getPrototypeOf && Object.getPrototypeOf(p);
                            f = f && f.setTimeout ? f : p, ({}).toString.call(p.process) === "[object process]" ? n = function n(g) {
                                a.nextTick(function() {
                                    b(g);
                                });
                            } : function() {
                                if (p.postMessage && !p.importScripts) {
                                    var g = !0, _ = p.onmessage;
                                    return p.onmessage = function() {
                                        g = !1;
                                    }, p.postMessage("", "*"), p.onmessage = _, g;
                                }
                            }() ? (s = "setImmediate$" + Math.random() + "$", h = function h(g) {
                                g.source === p && typeof g.data == "string" && g.data.indexOf(s) === 0 && b(+g.data.slice(s.length));
                            }, p.addEventListener ? p.addEventListener("message", h, !1) : p.attachEvent("onmessage", h), n = function n(g) {
                                p.postMessage(s + g, "*");
                            }) : p.MessageChannel ? ((e = new MessageChannel()).port1.onmessage = function(g) {
                                b(g.data);
                            }, n = function n(g) {
                                e.port2.postMessage(g);
                            }) : u && "onreadystatechange" in u.createElement("script") ? (o = u.documentElement, n = function n(g) {
                                var _ = u.createElement("script");
                                _.onreadystatechange = function() {
                                    b(g), _.onreadystatechange = null, o.removeChild(_), _ = null;
                                }, o.appendChild(_);
                            }) : n = function n(g) {
                                setTimeout(b, 0, g);
                            }, f.setImmediate = function(g) {
                                typeof g != "function" && (g = new Function("" + g));
                                for(var _ = new Array(arguments.length - 1), T = 0; T < _.length; T++)_[T] = arguments[T + 1];
                                var E = {
                                    callback: g,
                                    args: _
                                };
                                return y[t] = E, n(t), t++;
                            }, f.clearImmediate = m;
                        }
                        function m(g) {
                            delete y[g];
                        }
                        function b(g) {
                            if (r) setTimeout(b, 0, g);
                            else {
                                var _ = y[g];
                                if (_) {
                                    r = !0;
                                    try {
                                        (function(T) {
                                            var E = T.callback, S = T.args;
                                            switch(S.length){
                                                case 0:
                                                    E();
                                                    break;
                                                case 1:
                                                    E(S[0]);
                                                    break;
                                                case 2:
                                                    E(S[0], S[1]);
                                                    break;
                                                case 3:
                                                    E(S[0], S[1], S[2]);
                                                    break;
                                                default:
                                                    E.apply(l, S);
                                            }
                                        })(_);
                                    } finally{
                                        m(g), r = !1;
                                    }
                                }
                            }
                        }
                    })((typeof self === "undefined" ? "undefined" : (0, $7E0eS._)(self)) > "u" ? i === void 0 ? this : i : self);
                }).call(this, c(0), c(7));
            },
            function(d, v) {
                var c, i, a = d.exports = {};
                function p() {
                    throw new Error("setTimeout has not been defined");
                }
                function l() {
                    throw new Error("clearTimeout has not been defined");
                }
                function n(f) {
                    if (c === setTimeout) return setTimeout(f, 0);
                    if ((c === p || !c) && setTimeout) return c = setTimeout, setTimeout(f, 0);
                    try {
                        return c(f, 0);
                    } catch (e) {
                        try {
                            return c.call(null, f, 0);
                        } catch (e) {
                            return c.call(this, f, 0);
                        }
                    }
                }
                (function() {
                    try {
                        c = typeof setTimeout == "function" ? setTimeout : p;
                    } catch (e) {
                        c = p;
                    }
                    try {
                        i = typeof clearTimeout == "function" ? clearTimeout : l;
                    } catch (e) {
                        i = l;
                    }
                })();
                var o, e = [], s = !1, h = -1;
                function t() {
                    s && o && (s = !1, o.length ? e = o.concat(e) : h = -1, e.length && y());
                }
                function y() {
                    if (!s) {
                        var f = n(t);
                        s = !0;
                        for(var m = e.length; m;){
                            for(o = e, e = []; ++h < m;)o && o[h].run();
                            h = -1, m = e.length;
                        }
                        o = null, s = !1, function(b) {
                            if (i === clearTimeout) return clearTimeout(b);
                            if ((i === l || !i) && clearTimeout) return i = clearTimeout, clearTimeout(b);
                            try {
                                i(b);
                            } catch (e) {
                                try {
                                    return i.call(null, b);
                                } catch (e) {
                                    return i.call(this, b);
                                }
                            }
                        }(f);
                    }
                }
                function r(f, m) {
                    this.fun = f, this.array = m;
                }
                function u() {}
                a.nextTick = function(f) {
                    var m = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var b = 1; b < arguments.length; b++)m[b - 1] = arguments[b];
                    e.push(new r(f, m)), e.length !== 1 || s || n(y);
                }, r.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, a.title = "browser", a.browser = !0, a.env = {}, a.argv = [], a.version = "", a.versions = {}, a.on = u, a.addListener = u, a.once = u, a.off = u, a.removeListener = u, a.removeAllListeners = u, a.emit = u, a.prependListener = u, a.prependOnceListener = u, a.listeners = function(f) {
                    return [];
                }, a.binding = function(f) {
                    throw new Error("process.binding is not supported");
                }, a.cwd = function() {
                    return "/";
                }, a.chdir = function(f) {
                    throw new Error("process.chdir is not supported");
                }, a.umask = function() {
                    return 0;
                };
            },
            function(d, v, c) {
                function i(p, l) {
                    for(var n = 0; n < l.length; n++){
                        var o = l[n];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(p, o.key, o);
                    }
                }
                var a = c(9);
                d.exports = function() {
                    function p() {
                        (function(e, s) {
                            if (!(e instanceof s)) throw new TypeError("Cannot call a class as a function");
                        })(this, p);
                    }
                    var l, n, o;
                    return l = p, o = [
                        {
                            key: "urlEncode",
                            value: function value(e) {
                                return a(e);
                            }
                        },
                        {
                            key: "jsonEncode",
                            value: function value(e) {
                                return JSON.stringify(e);
                            }
                        },
                        {
                            key: "formEncode",
                            value: function value(e) {
                                if (this.isFormData(e)) return e;
                                if (this.isFormElement(e)) return new FormData(e);
                                if (this.isObject(e)) {
                                    var s = new FormData();
                                    return Object.keys(e).forEach(function(h) {
                                        var t = e[h];
                                        s.append(h, t);
                                    }), s;
                                }
                                throw new Error("`data` must be an instance of Object, FormData or <FORM> HTMLElement");
                            }
                        },
                        {
                            key: "isObject",
                            value: function value(e) {
                                return Object.prototype.toString.call(e) === "[object Object]";
                            }
                        },
                        {
                            key: "isFormData",
                            value: function value(e) {
                                return e instanceof FormData;
                            }
                        },
                        {
                            key: "isFormElement",
                            value: function value(e) {
                                return e instanceof HTMLFormElement;
                            }
                        },
                        {
                            key: "selectFiles",
                            value: function value() {
                                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                                return new Promise(function(s, h) {
                                    var t = document.createElement("INPUT");
                                    t.type = "file", e.multiple && t.setAttribute("multiple", "multiple"), e.accept && t.setAttribute("accept", e.accept), t.style.display = "none", document.body.appendChild(t), t.addEventListener("change", function(y) {
                                        var r = y.target.files;
                                        s(r), document.body.removeChild(t);
                                    }, !1), t.click();
                                });
                            }
                        },
                        {
                            key: "parseHeaders",
                            value: function value(e) {
                                var s = e.trim().split(/[\r\n]+/), h = {};
                                return s.forEach(function(t) {
                                    var y = t.split(": "), r = y.shift(), u = y.join(": ");
                                    r && (h[r] = u);
                                }), h;
                            }
                        }
                    ], n = null, o && i(l, o), p;
                }();
            },
            function(d, v) {
                var c = function c(a) {
                    return encodeURIComponent(a).replace(/[!'()*]/g, escape).replace(/%20/g, "+");
                }, i = function i1(a, p, l, n) {
                    return p = p || null, l = l || "&", n = n || null, a ? (function(o) {
                        for(var e = new Array(), s = 0; s < o.length; s++)o[s] && e.push(o[s]);
                        return e;
                    })(Object.keys(a).map(function(o) {
                        var e, s, h = o;
                        if (n && (h = n + "[" + h + "]"), (0, $7E0eS._)(a[o]) == "object" && a[o] !== null) e = i(a[o], null, l, h);
                        else {
                            p && (s = h, h = !isNaN(parseFloat(s)) && isFinite(s) ? p + Number(h) : h);
                            var t = a[o];
                            t = (t = (t = (t = t === !0 ? "1" : t) === !1 ? "0" : t) === 0 ? "0" : t) || "", e = c(h) + "=" + c(t);
                        }
                        return e;
                    })).join(l).replace(/[!'()*]/g, "") : "";
                };
                d.exports = i;
            }
        ]);
    });
})($dd43b7a78f9ce268$var$j);
var $dd43b7a78f9ce268$var$P = $dd43b7a78f9ce268$var$j.exports;
var $dd43b7a78f9ce268$var$R = /* @__PURE__ */ $dd43b7a78f9ce268$var$O($dd43b7a78f9ce268$var$P), $dd43b7a78f9ce268$var$F = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7.69998 12.6L7.67896 12.62C6.53993 13.7048 6.52012 15.5155 7.63516 16.625V16.625C8.72293 17.7073 10.4799 17.7102 11.5712 16.6314L13.0263 15.193C14.0703 14.1609 14.2141 12.525 13.3662 11.3266L13.22 11.12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16.22 11.12L16.3564 10.9805C17.2895 10.0265 17.3478 8.5207 16.4914 7.49733V7.49733C15.569 6.39509 13.9269 6.25143 12.8271 7.17675L11.39 8.38588C10.0935 9.47674 9.95704 11.4241 11.0887 12.6852L11.12 12.72"/></svg>';
var $dd43b7a78f9ce268$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function I(param) {
        var w = param.data, d = param.config, v = param.api, c = param.readOnly;
        (0, $173N4._)(this, I);
        this.api = v, this.readOnly = c, this.config = {
            endpoint: d.endpoint || "",
            headers: d.headers || {}
        }, this.nodes = {
            wrapper: null,
            container: null,
            progress: null,
            input: null,
            inputHolder: null,
            linkContent: null,
            linkImage: null,
            linkTitle: null,
            linkDescription: null,
            linkText: null
        }, this._data = {
            link: "",
            meta: {}
        }, this.data = w;
    }
    (0, $cFHGC._)(I, [
        {
            /**
   * Renders Block content
   *
   * @public
   *
   * @returns {HTMLDivElement}
   */ key: "render",
            value: function render() {
                return this.nodes.wrapper = this.make("div", this.CSS.baseClass), this.nodes.container = this.make("div", this.CSS.container), this.nodes.inputHolder = this.makeInputHolder(), this.nodes.linkContent = this.prepareLinkPreview(), Object.keys(this.data.meta).length ? (this.nodes.container.appendChild(this.nodes.linkContent), this.showLinkPreview(this.data.meta)) : this.nodes.container.appendChild(this.nodes.inputHolder), this.nodes.wrapper.appendChild(this.nodes.container), this.nodes.wrapper;
            }
        },
        {
            /**
   * Return Block data
   *
   * @public
   *
   * @returns {LinkToolData}
   */ key: "save",
            value: function save() {
                return this.data;
            }
        },
        {
            /**
   * Validate Block data
   * - check if given link is an empty string or not.
   *
   * @public
   *
   * @returns {boolean} false if saved data is incorrect, otherwise true
   */ key: "validate",
            value: function validate() {
                return this.data.link.trim() !== "";
            }
        },
        {
            key: "data",
            get: /**
   * Return Tool data
   *
   * @returns {LinkToolData}
   */ function get() {
                return this._data;
            },
            set: /**
   * Stores all Tool's data
   *
   * @param {LinkToolData} data - data to store
   */ function set(w) {
                this._data = Object.assign({}, {
                    link: w.link || this._data.link,
                    meta: w.meta || this._data.meta
                });
            }
        },
        {
            key: "CSS",
            get: /**
   * @returns {object} - Link Tool styles
   */ function get() {
                return {
                    baseClass: this.api.styles.block,
                    input: this.api.styles.input,
                    /**
       * Tool's classes
       */ container: "link-tool",
                    inputEl: "link-tool__input",
                    inputHolder: "link-tool__input-holder",
                    inputError: "link-tool__input-holder--error",
                    linkContent: "link-tool__content",
                    linkContentRendered: "link-tool__content--rendered",
                    linkImage: "link-tool__image",
                    linkTitle: "link-tool__title",
                    linkDescription: "link-tool__description",
                    linkText: "link-tool__anchor",
                    progress: "link-tool__progress",
                    progressLoading: "link-tool__progress--loading",
                    progressLoaded: "link-tool__progress--loaded"
                };
            }
        },
        {
            /**
   * Prepare input holder
   *
   * @returns {HTMLElement}
   */ key: "makeInputHolder",
            value: function makeInputHolder() {
                var _this = this;
                var w = this.make("div", this.CSS.inputHolder);
                return this.nodes.progress = this.make("label", this.CSS.progress), this.nodes.input = this.make("div", [
                    this.CSS.input,
                    this.CSS.inputEl
                ], {
                    contentEditable: !this.readOnly
                }), this.nodes.input.dataset.placeholder = this.api.i18n.t("Link"), this.readOnly || (this.nodes.input.addEventListener("paste", function(d) {
                    _this.startFetching(d);
                }), this.nodes.input.addEventListener("keydown", function(d) {
                    var v = 13, c = 65, i = d.ctrlKey || d.metaKey;
                    switch(d.keyCode){
                        case v:
                            d.preventDefault(), d.stopPropagation(), _this.startFetching(d);
                            break;
                        case c:
                            i && _this.selectLinkUrl(d);
                            break;
                    }
                })), w.appendChild(this.nodes.progress), w.appendChild(this.nodes.input), w;
            }
        },
        {
            /**
   * Activates link data fetching by url
   *
   * @param {PasteEvent|KeyboardEvent} event - fetching could be fired by a pase or keydown events
   */ key: "startFetching",
            value: function startFetching(w) {
                var d = this.nodes.input.textContent;
                w.type === "paste" && (d = (w.clipboardData || window.clipboardData).getData("text")), this.removeErrorStyle(), this.fetchLinkData(d);
            }
        },
        {
            /**
   * If previous link data fetching failed, remove error styles
   */ key: "removeErrorStyle",
            value: function removeErrorStyle() {
                this.nodes.inputHolder.classList.remove(this.CSS.inputError), this.nodes.inputHolder.insertBefore(this.nodes.progress, this.nodes.input);
            }
        },
        {
            /**
   * Select LinkTool input content by CMD+A
   *
   * @param {KeyboardEvent} event - keydown
   */ key: "selectLinkUrl",
            value: function selectLinkUrl(w) {
                w.preventDefault(), w.stopPropagation();
                var d = window.getSelection(), v = new Range(), a = d.anchorNode.parentNode.closest(".".concat(this.CSS.inputHolder)).querySelector(".".concat(this.CSS.inputEl));
                v.selectNodeContents(a), d.removeAllRanges(), d.addRange(v);
            }
        },
        {
            /**
   * Prepare link preview holder
   *
   * @returns {HTMLElement}
   */ key: "prepareLinkPreview",
            value: function prepareLinkPreview() {
                var w = this.make("a", this.CSS.linkContent, {
                    target: "_blank",
                    rel: "nofollow noindex noreferrer"
                });
                return this.nodes.linkImage = this.make("div", this.CSS.linkImage), this.nodes.linkTitle = this.make("div", this.CSS.linkTitle), this.nodes.linkDescription = this.make("p", this.CSS.linkDescription), this.nodes.linkText = this.make("span", this.CSS.linkText), w;
            }
        },
        {
            /**
   * Compose link preview from fetched data
   *
   * @param {metaData} meta - link meta data
   */ key: "showLinkPreview",
            value: function showLinkPreview(param) {
                var w = param.image, d = param.title, v = param.description;
                this.nodes.container.appendChild(this.nodes.linkContent), w && w.url && (this.nodes.linkImage.style.backgroundImage = "url(" + w.url + ")", this.nodes.linkContent.appendChild(this.nodes.linkImage)), d && (this.nodes.linkTitle.textContent = d, this.nodes.linkContent.appendChild(this.nodes.linkTitle)), v && (this.nodes.linkDescription.textContent = v, this.nodes.linkContent.appendChild(this.nodes.linkDescription)), this.nodes.linkContent.classList.add(this.CSS.linkContentRendered), this.nodes.linkContent.setAttribute("href", this.data.link), this.nodes.linkContent.appendChild(this.nodes.linkText);
                try {
                    this.nodes.linkText.textContent = new URL(this.data.link).hostname;
                } catch (e) {
                    this.nodes.linkText.textContent = this.data.link;
                }
            }
        },
        {
            /**
   * Show loading progress bar
   */ key: "showProgress",
            value: function showProgress() {
                this.nodes.progress.classList.add(this.CSS.progressLoading);
            }
        },
        {
            /**
   * Hide loading progress bar
   *
   * @returns {Promise<void>}
   */ key: "hideProgress",
            value: function hideProgress() {
                var _this = this;
                return new Promise(function(w) {
                    _this.nodes.progress.classList.remove(_this.CSS.progressLoading), _this.nodes.progress.classList.add(_this.CSS.progressLoaded), setTimeout(w, 500);
                });
            }
        },
        {
            /**
   * If data fetching failed, set input error style
   */ key: "applyErrorStyle",
            value: function applyErrorStyle() {
                this.nodes.inputHolder.classList.add(this.CSS.inputError), this.nodes.progress.remove();
            }
        },
        {
            key: "fetchLinkData",
            value: /**
   * Sends to backend pasted url and receives link data
   *
   * @param {string} url - link source url
   */ function fetchLinkData(w) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _ref, d, e;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this.showProgress(), this.data = {
                                    link: w
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    $dd43b7a78f9ce268$var$R.get({
                                        url: this.config.endpoint,
                                        headers: this.config.headers,
                                        data: {
                                            url: w
                                        }
                                    })
                                ];
                            case 2:
                                _ref = _state.sent(), d = _ref.body;
                                this.onFetch(d);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                this.fetchingFailed(this.api.i18n.t("Couldn't fetch the link data"));
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Link data fetching callback
   *
   * @param {UploadResponseFormat} response - backend response
   */ key: "onFetch",
            value: function onFetch(w) {
                var _this = this;
                if (!w || !w.success) {
                    this.fetchingFailed(this.api.i18n.t("Couldn't get this link data, try the other one"));
                    return;
                }
                var d = w.meta, v = w.link || this.data.link;
                if (this.data = {
                    meta: d,
                    link: v
                }, !d) {
                    this.fetchingFailed(this.api.i18n.t("Wrong response format from the server"));
                    return;
                }
                this.hideProgress().then(function() {
                    _this.nodes.inputHolder.remove(), _this.showLinkPreview(d);
                });
            }
        },
        {
            /**
   * Handle link fetching errors
   *
   * @private
   *
   * @param {string} errorMessage - message to explain user what he should do
   */ key: "fetchingFailed",
            value: function fetchingFailed(w) {
                this.api.notifier.show({
                    message: w,
                    style: "error"
                }), this.applyErrorStyle();
            }
        },
        {
            /**
   * Helper method for elements creation
   *
   * @param {string} tagName - name of creating element
   * @param {string|string[]} [classNames] - list of CSS classes to add
   * @param {object} [attributes] - object with attributes to add
   * @returns {HTMLElement}
   */ key: "make",
            value: function make(w) {
                var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, v = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _c_classList;
                var c = document.createElement(w);
                Array.isArray(d) ? (_c_classList = c.classList).add.apply(_c_classList, (0, $aUGqu._)(d)) : d && c.classList.add(d);
                for(var i in v)c[i] = v[i];
                return c;
            }
        }
    ], [
        {
            key: "isReadOnlySupported",
            get: /**
   * Notify core that read-only mode supported
   *
   * @returns {boolean}
   */ function get() {
                return !0;
            }
        },
        {
            key: "toolbox",
            get: /**
   * Get Tool toolbox settings
   * icon - Tool icon's SVG
   * title - title to show in toolbox
   *
   * @returns {{icon: string, title: string}}
   */ function get() {
                return {
                    icon: $dd43b7a78f9ce268$var$F,
                    title: "Link"
                };
            }
        },
        {
            key: "enableLineBreaks",
            get: /**
   * Allow to press Enter inside the LinkTool input
   *
   * @returns {boolean}
   * @public
   */ function get() {
                return !0;
            }
        }
    ]);
    return I;
}();



var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7Pjls = parcelRequire("7Pjls");

var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");
(function() {
    "use strict";
    try {
        if ((typeof document === "undefined" ? "undefined" : (0, $7E0eS._)(document)) < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode('.cdx-list{margin:0;padding:0;outline:none;display:grid;counter-reset:item;gap:var(--spacing-s);padding:var(--spacing-xs);--spacing-s: 8px;--spacing-xs: 6px;--list-counter-type: numeric;--radius-border: 5px;--checkbox-background: #fff;--color-border: #C9C9C9;--color-bg-checked: #369FFF;--line-height: 1.45em;--color-bg-checked-hover: #0059AB;--color-tick: #fff;--size-checkbox: 1.2em}.cdx-list__item{line-height:var(--line-height);display:grid;grid-template-columns:auto 1fr;grid-template-rows:auto auto;grid-template-areas:"checkbox content" ". child"}.cdx-list__item-children{display:grid;grid-area:child;gap:var(--spacing-s);padding-top:var(--spacing-s)}.cdx-list__item [contenteditable]{outline:none}.cdx-list__item-content{word-break:break-word;white-space:pre-wrap;grid-area:content;padding-left:var(--spacing-s)}.cdx-list__item:before{counter-increment:item;white-space:nowrap}.cdx-list-ordered .cdx-list__item:before{content:counters(item,".",var(--list-counter-type)) "."}.cdx-list-ordered{counter-reset:item}.cdx-list-unordered .cdx-list__item:before{content:"\u2022"}.cdx-list-checklist .cdx-list__item:before{content:""}.cdx-list__settings .cdx-settings-button{width:50%}.cdx-list__checkbox{padding-top:calc((var(--line-height) - var(--size-checkbox)) / 2);grid-area:checkbox;width:var(--size-checkbox);height:var(--size-checkbox);display:flex;cursor:pointer}.cdx-list__checkbox svg{opacity:0;height:var(--size-checkbox);width:var(--size-checkbox);left:-1px;top:-1px;position:absolute}@media (hover: hover){.cdx-list__checkbox:not(.cdx-list__checkbox--no-hover):hover .cdx-list__checkbox-check svg{opacity:1}}.cdx-list__checkbox--checked{line-height:var(--line-height)}@media (hover: hover){.cdx-list__checkbox--checked:not(.cdx-list__checkbox--checked--no-hover):hover .cdx-checklist__checkbox-check{background:var(--color-bg-checked-hover);border-color:var(--color-bg-checked-hover)}}.cdx-list__checkbox--checked .cdx-list__checkbox-check{background:var(--color-bg-checked);border-color:var(--color-bg-checked)}.cdx-list__checkbox--checked .cdx-list__checkbox-check svg{opacity:1}.cdx-list__checkbox--checked .cdx-list__checkbox-check svg path{stroke:var(--color-tick)}.cdx-list__checkbox--checked .cdx-list__checkbox-check:before{opacity:0;visibility:visible;transform:scale(2.5)}.cdx-list__checkbox-check{cursor:pointer;display:inline-block;position:relative;margin:0 auto;width:var(--size-checkbox);height:var(--size-checkbox);box-sizing:border-box;border-radius:var(--radius-border);border:1px solid var(--color-border);background:var(--checkbox-background)}.cdx-list__checkbox-check:before{content:"";position:absolute;top:0;right:0;bottom:0;left:0;border-radius:100%;background-color:var(--color-bg-checked);visibility:hidden;pointer-events:none;transform:scale(1);transition:transform .4s ease-out,opacity .4s}.cdx-list__checkbox-check--disabled{pointer-events:none}.cdx-list-start-with-field{background:#F8F8F8;border:1px solid rgba(226,226,229,.2);border-radius:6px;padding:2px;display:grid;grid-template-columns:auto auto 1fr;grid-template-rows:auto}.cdx-list-start-with-field--invalid{background:#FFECED;border:1px solid #E13F3F}.cdx-list-start-with-field--invalid .cdx-list-start-with-field__input{color:#e13f3f}.cdx-list-start-with-field__input{font-size:14px;outline:none;font-weight:500;font-family:inherit;border:0;background:transparent;margin:0;padding:0;line-height:22px;min-width:calc(100% - var(--toolbox-buttons-size) - var(--icon-margin-right))}.cdx-list-start-with-field__input::placeholder{color:var(--grayText);font-weight:500}')), document.head.appendChild(e);
        }
    } catch (c) {
        console.error("vite-plugin-css-injected-by-js", c);
    }
})();
var $4fb7d97cf6fbcc21$var$Ct = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 12L10.4884 15.8372C10.5677 15.9245 10.705 15.9245 10.7844 15.8372L17 9"/></svg>', $4fb7d97cf6fbcc21$var$Ae = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9.2 12L11.0586 13.8586C11.1367 13.9367 11.2633 13.9367 11.3414 13.8586L14.7 10.5"/><rect width="14" height="14" x="5" y="5" stroke="currentColor" stroke-width="2" rx="4"/></svg>', $4fb7d97cf6fbcc21$var$$e = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><line x1="9" x2="19" y1="7" y2="7" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><line x1="9" x2="19" y1="12" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><line x1="9" x2="19" y1="17" y2="17" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5.00001 17H4.99002"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5.00001 12H4.99002"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5.00001 7H4.99002"/></svg>', $4fb7d97cf6fbcc21$var$Be = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><line x1="12" x2="19" y1="7" y2="7" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><line x1="12" x2="19" y1="12" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><line x1="12" x2="19" y1="17" y2="17" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7.79999 14L7.79999 7.2135C7.79999 7.12872 7.7011 7.0824 7.63597 7.13668L4.79999 9.5"/></svg>', $4fb7d97cf6fbcc21$var$St = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 14.2L10 7.4135C10 7.32872 9.90111 7.28241 9.83598 7.33668L7 9.7" stroke="black" stroke-width="1.6" stroke-linecap="round"/><path d="M13.2087 14.2H13.2" stroke="black" stroke-width="1.6" stroke-linecap="round"/></svg>', $4fb7d97cf6fbcc21$var$Ot = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.2087 14.2H13.2" stroke="black" stroke-width="1.6" stroke-linecap="round"/><path d="M10 14.2L10 9.5" stroke="black" stroke-width="1.6" stroke-linecap="round"/><path d="M10 7.01L10 7" stroke="black" stroke-width="1.8" stroke-linecap="round"/></svg>', $4fb7d97cf6fbcc21$var$kt = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.2087 14.2H13.2" stroke="black" stroke-width="1.6" stroke-linecap="round"/><path d="M10 14.2L10 7.2" stroke="black" stroke-width="1.6" stroke-linecap="round"/></svg>', $4fb7d97cf6fbcc21$var$_t = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.0087 14.2H16" stroke="black" stroke-width="1.6" stroke-linecap="round"/><path d="M7 14.2L7.78865 12M13 14.2L12.1377 12M7.78865 12C7.78865 12 9.68362 7 10 7C10.3065 7 12.1377 12 12.1377 12M7.78865 12L12.1377 12" stroke="black" stroke-width="1.6" stroke-linecap="round"/></svg>', $4fb7d97cf6fbcc21$var$Et = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.2087 14.2H14.2" stroke="black" stroke-width="1.6" stroke-linecap="round"/><path d="M11.5 14.5C11.5 14.5 11 13.281 11 12.5M7 9.5C7 9.5 7.5 8.5 9 8.5C10.5 8.5 11 9.5 11 10.5L11 11.5M11 11.5L11 12.5M11 11.5C11 11.5 7 11 7 13C7 15.3031 11 15 11 12.5" stroke="black" stroke-width="1.6" stroke-linecap="round"/></svg>', $4fb7d97cf6fbcc21$var$It = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 14.2L8 7.4135C8 7.32872 7.90111 7.28241 7.83598 7.33668L5 9.7" stroke="black" stroke-width="1.6" stroke-linecap="round"/><path d="M14 13L16.4167 10.7778M16.4167 10.7778L14 8.5M16.4167 10.7778H11.6562" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
var $4fb7d97cf6fbcc21$var$A = (typeof globalThis === "undefined" ? "undefined" : (0, $7E0eS._)(globalThis)) < "u" ? globalThis : (typeof window === "undefined" ? "undefined" : (0, $7E0eS._)(window)) < "u" ? window : (typeof $parcel$global === "undefined" ? "undefined" : (0, $7E0eS._)($parcel$global)) < "u" ? $parcel$global : (typeof self === "undefined" ? "undefined" : (0, $7E0eS._)(self)) < "u" ? self : {};
function $4fb7d97cf6fbcc21$var$wt(e) {
    if (e.__esModule) return e;
    var t = e.default;
    if (typeof t == "function") {
        var n = function r() {
            return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
        };
        n.prototype = t.prototype;
    } else n = {};
    return Object.defineProperty(n, "__esModule", {
        value: !0
    }), Object.keys(e).forEach(function(r) {
        var i = Object.getOwnPropertyDescriptor(e, r);
        Object.defineProperty(n, r, i.get ? i : {
            enumerable: !0,
            get: function get() {
                return e[r];
            }
        });
    }), n;
}
var $4fb7d97cf6fbcc21$var$c = {}, $4fb7d97cf6fbcc21$var$V = {}, $4fb7d97cf6fbcc21$var$Y = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$Y, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$Y.allInputsSelector = $4fb7d97cf6fbcc21$var$Pt;
function $4fb7d97cf6fbcc21$var$Pt() {
    var e = [
        "text",
        "password",
        "email",
        "number",
        "search",
        "tel",
        "url"
    ];
    return "[contenteditable=true], textarea, input:not([type]), " + e.map(function(t) {
        return 'input[type="'.concat(t, '"]');
    }).join(", ");
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.allInputsSelector = void 0;
    var t = $4fb7d97cf6fbcc21$var$Y;
    Object.defineProperty(e, "allInputsSelector", {
        enumerable: !0,
        get: function get() {
            return t.allInputsSelector;
        }
    });
})($4fb7d97cf6fbcc21$var$V);
var $4fb7d97cf6fbcc21$var$k = {}, $4fb7d97cf6fbcc21$var$J = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$J, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$J.isNativeInput = $4fb7d97cf6fbcc21$var$jt;
function $4fb7d97cf6fbcc21$var$jt(e) {
    var t = [
        "INPUT",
        "TEXTAREA"
    ];
    return e && e.tagName ? t.includes(e.tagName) : !1;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isNativeInput = void 0;
    var t = $4fb7d97cf6fbcc21$var$J;
    Object.defineProperty(e, "isNativeInput", {
        enumerable: !0,
        get: function get() {
            return t.isNativeInput;
        }
    });
})($4fb7d97cf6fbcc21$var$k);
var $4fb7d97cf6fbcc21$var$Fe = {}, $4fb7d97cf6fbcc21$var$Q = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$Q, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$Q.append = $4fb7d97cf6fbcc21$var$Tt;
function $4fb7d97cf6fbcc21$var$Tt(e, t) {
    Array.isArray(t) ? t.forEach(function(n) {
        e.appendChild(n);
    }) : e.appendChild(t);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.append = void 0;
    var t = $4fb7d97cf6fbcc21$var$Q;
    Object.defineProperty(e, "append", {
        enumerable: !0,
        get: function get() {
            return t.append;
        }
    });
})($4fb7d97cf6fbcc21$var$Fe);
var $4fb7d97cf6fbcc21$var$Z = {}, $4fb7d97cf6fbcc21$var$x = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$x, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$x.blockElements = $4fb7d97cf6fbcc21$var$Lt;
function $4fb7d97cf6fbcc21$var$Lt() {
    return [
        "address",
        "article",
        "aside",
        "blockquote",
        "canvas",
        "div",
        "dl",
        "dt",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "hgroup",
        "hr",
        "li",
        "main",
        "nav",
        "noscript",
        "ol",
        "output",
        "p",
        "pre",
        "ruby",
        "section",
        "table",
        "tbody",
        "thead",
        "tr",
        "tfoot",
        "ul",
        "video"
    ];
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.blockElements = void 0;
    var t = $4fb7d97cf6fbcc21$var$x;
    Object.defineProperty(e, "blockElements", {
        enumerable: !0,
        get: function get() {
            return t.blockElements;
        }
    });
})($4fb7d97cf6fbcc21$var$Z);
var $4fb7d97cf6fbcc21$var$Re = {}, $4fb7d97cf6fbcc21$var$ee = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$ee, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$ee.calculateBaseline = $4fb7d97cf6fbcc21$var$Mt;
function $4fb7d97cf6fbcc21$var$Mt(e) {
    var t = window.getComputedStyle(e), n = parseFloat(t.fontSize), r = parseFloat(t.lineHeight) || n * 1.2, i = parseFloat(t.paddingTop), a = parseFloat(t.borderTopWidth), l = parseFloat(t.marginTop), s = n * 0.8, o = (r - n) / 2, d = l + a + i + o + s;
    return d;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.calculateBaseline = void 0;
    var t = $4fb7d97cf6fbcc21$var$ee;
    Object.defineProperty(e, "calculateBaseline", {
        enumerable: !0,
        get: function get() {
            return t.calculateBaseline;
        }
    });
})($4fb7d97cf6fbcc21$var$Re);
var $4fb7d97cf6fbcc21$var$qe = {}, $4fb7d97cf6fbcc21$var$te = {}, $4fb7d97cf6fbcc21$var$ne = {}, $4fb7d97cf6fbcc21$var$re = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$re, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$re.isContentEditable = $4fb7d97cf6fbcc21$var$Nt;
function $4fb7d97cf6fbcc21$var$Nt(e) {
    return e.contentEditable === "true";
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isContentEditable = void 0;
    var t = $4fb7d97cf6fbcc21$var$re;
    Object.defineProperty(e, "isContentEditable", {
        enumerable: !0,
        get: function get() {
            return t.isContentEditable;
        }
    });
})($4fb7d97cf6fbcc21$var$ne);
Object.defineProperty($4fb7d97cf6fbcc21$var$te, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$te.canSetCaret = $4fb7d97cf6fbcc21$var$Bt;
var $4fb7d97cf6fbcc21$var$At = $4fb7d97cf6fbcc21$var$k, $4fb7d97cf6fbcc21$var$$t = $4fb7d97cf6fbcc21$var$ne;
function $4fb7d97cf6fbcc21$var$Bt(e) {
    var t = !0;
    if ((0, $4fb7d97cf6fbcc21$var$At.isNativeInput)(e)) switch(e.type){
        case "file":
        case "checkbox":
        case "radio":
        case "hidden":
        case "submit":
        case "button":
        case "image":
        case "reset":
            t = !1;
            break;
    }
    else t = (0, $4fb7d97cf6fbcc21$var$$t.isContentEditable)(e);
    return t;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.canSetCaret = void 0;
    var t = $4fb7d97cf6fbcc21$var$te;
    Object.defineProperty(e, "canSetCaret", {
        enumerable: !0,
        get: function get() {
            return t.canSetCaret;
        }
    });
})($4fb7d97cf6fbcc21$var$qe);
var $4fb7d97cf6fbcc21$var$$ = {}, $4fb7d97cf6fbcc21$var$ie = {};
function $4fb7d97cf6fbcc21$var$Wt(e, t, n) {
    var r = n.value !== void 0 ? "value" : "get", i = n[r], a = "#".concat(t, "Cache");
    if (n[r] = function() {
        for(var _len = arguments.length, l = new Array(_len), _key = 0; _key < _len; _key++){
            l[_key] = arguments[_key];
        }
        return this[a] === void 0 && (this[a] = i.apply(this, l)), this[a];
    }, r === "get" && n.set) {
        var l = n.set;
        n.set = function(s) {
            delete e[a], l.apply(this, s);
        };
    }
    return n;
}
function $4fb7d97cf6fbcc21$var$Ue() {
    var e = {
        win: !1,
        mac: !1,
        x11: !1,
        linux: !1
    }, t = Object.keys(e).find(function(n) {
        return window.navigator.appVersion.toLowerCase().indexOf(n) !== -1;
    });
    return t !== void 0 && (e[t] = !0), e;
}
function $4fb7d97cf6fbcc21$var$ae(e) {
    return e != null && e !== "" && ((typeof e === "undefined" ? "undefined" : (0, $7E0eS._)(e)) != "object" || Object.keys(e).length > 0);
}
function $4fb7d97cf6fbcc21$var$Dt(e) {
    return !$4fb7d97cf6fbcc21$var$ae(e);
}
var $4fb7d97cf6fbcc21$var$Ht = function() {
    return (typeof window === "undefined" ? "undefined" : (0, $7E0eS._)(window)) < "u" && window.navigator !== null && $4fb7d97cf6fbcc21$var$ae(window.navigator.platform) && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
};
function $4fb7d97cf6fbcc21$var$Ft(e) {
    var t = $4fb7d97cf6fbcc21$var$Ue();
    return e = e.replace(/shift/gi, "\u21E7").replace(/backspace/gi, "\u232B").replace(/enter/gi, "\u23CE").replace(/up/gi, "\u2191").replace(/left/gi, "\u2192").replace(/down/gi, "\u2193").replace(/right/gi, "\u2190").replace(/escape/gi, "\u238B").replace(/insert/gi, "Ins").replace(/delete/gi, "\u2421").replace(/\+/gi, "+"), t.mac ? e = e.replace(/ctrl|cmd/gi, "\u2318").replace(/alt/gi, "\u2325") : e = e.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), e;
}
function $4fb7d97cf6fbcc21$var$Rt(e) {
    return e[0].toUpperCase() + e.slice(1);
}
function $4fb7d97cf6fbcc21$var$qt(e) {
    var t = document.createElement("div");
    t.style.position = "absolute", t.style.left = "-999px", t.style.bottom = "-999px", t.innerHTML = e, document.body.appendChild(t);
    var n = window.getSelection(), r = document.createRange();
    if (r.selectNode(t), n === null) throw new Error("Cannot copy text to clipboard");
    n.removeAllRanges(), n.addRange(r), document.execCommand("copy"), document.body.removeChild(t);
}
function $4fb7d97cf6fbcc21$var$Ut(e, t, n) {
    var _this = this;
    var r;
    return function() {
        for(var _len = arguments.length, i = new Array(_len), _key = 0; _key < _len; _key++){
            i[_key] = arguments[_key];
        }
        var a = _this, l = function() {
            r = void 0, n !== !0 && e.apply(a, i);
        }, s = n === !0 && r !== void 0;
        window.clearTimeout(r), r = window.setTimeout(l, t), s && e.apply(a, i);
    };
}
function $4fb7d97cf6fbcc21$var$S(e) {
    return Object.prototype.toString.call(e).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $4fb7d97cf6fbcc21$var$Kt(e) {
    return $4fb7d97cf6fbcc21$var$S(e) === "boolean";
}
function $4fb7d97cf6fbcc21$var$Ke(e) {
    return $4fb7d97cf6fbcc21$var$S(e) === "function" || $4fb7d97cf6fbcc21$var$S(e) === "asyncfunction";
}
function $4fb7d97cf6fbcc21$var$zt(e) {
    return $4fb7d97cf6fbcc21$var$Ke(e) && /^\s*class\s+/.test(e.toString());
}
function $4fb7d97cf6fbcc21$var$Xt(e) {
    return $4fb7d97cf6fbcc21$var$S(e) === "number";
}
function $4fb7d97cf6fbcc21$var$M(e) {
    return $4fb7d97cf6fbcc21$var$S(e) === "object";
}
function $4fb7d97cf6fbcc21$var$Gt(e) {
    return Promise.resolve(e) === e;
}
function $4fb7d97cf6fbcc21$var$Vt(e) {
    return $4fb7d97cf6fbcc21$var$S(e) === "string";
}
function $4fb7d97cf6fbcc21$var$Yt(e) {
    return $4fb7d97cf6fbcc21$var$S(e) === "undefined";
}
function $4fb7d97cf6fbcc21$var$X(e) {
    for(var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        t[_key - 1] = arguments[_key];
    }
    if (!t.length) return e;
    var n = t.shift();
    if ($4fb7d97cf6fbcc21$var$M(e) && $4fb7d97cf6fbcc21$var$M(n)) for(var r in n)$4fb7d97cf6fbcc21$var$M(n[r]) ? (e[r] === void 0 && Object.assign(e, (0, $7Pjls._)({}, r, {})), $4fb7d97cf6fbcc21$var$X(e[r], n[r])) : Object.assign(e, (0, $7Pjls._)({}, r, n[r]));
    return $4fb7d97cf6fbcc21$var$X.apply(void 0, [
        e
    ].concat((0, $aUGqu._)(t)));
}
function $4fb7d97cf6fbcc21$var$Jt(e, t, n) {
    var r = "\xab".concat(t, "\xbb is deprecated and will be removed in the next major release. Please use the \xab").concat(n, "\xbb instead.");
    e && console.warn(r);
}
function $4fb7d97cf6fbcc21$var$Qt(e) {
    try {
        return new URL(e).href;
    } catch (e) {}
    return e.substring(0, 2) === "//" ? window.location.protocol + e : window.location.origin + e;
}
function $4fb7d97cf6fbcc21$var$Zt(e) {
    return e > 47 && e < 58 || e === 32 || e === 13 || e === 229 || e > 64 && e < 91 || e > 95 && e < 112 || e > 185 && e < 193 || e > 218 && e < 223;
}
var $4fb7d97cf6fbcc21$var$xt = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    DELETE: 46,
    META: 91,
    SLASH: 191
}, $4fb7d97cf6fbcc21$var$en = {
    LEFT: 0,
    WHEEL: 1,
    RIGHT: 2,
    BACKWARD: 3,
    FORWARD: 4
};
var $4fb7d97cf6fbcc21$var$tn = /*#__PURE__*/ function() {
    "use strict";
    function tn() {
        (0, $173N4._)(this, tn);
        this.completed = Promise.resolve();
    }
    (0, $cFHGC._)(tn, [
        {
            /**
   * Add new promise to queue
   * @param operation - promise should be added to queue
   */ key: "add",
            value: function add(t) {
                var _this = this;
                return new Promise(function(n, r) {
                    _this.completed = _this.completed.then(t).then(n).catch(r);
                });
            }
        }
    ]);
    return tn;
}();
function $4fb7d97cf6fbcc21$var$nn(e, t, n) {
    var r, i, a, l = null, s = 0;
    n || (n = {});
    var o = function o() {
        s = n.leading === !1 ? 0 : Date.now(), l = null, a = e.apply(r, i), l === null && (r = i = null);
    };
    return function() {
        var d = Date.now();
        !s && n.leading === !1 && (s = d);
        var u = t - (d - s);
        return r = this, i = arguments, u <= 0 || u > t ? (l && (clearTimeout(l), l = null), s = d, a = e.apply(r, i), l === null && (r = i = null)) : !l && n.trailing !== !1 && (l = setTimeout(o, u)), a;
    };
}
var $4fb7d97cf6fbcc21$var$rn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    PromiseQueue: $4fb7d97cf6fbcc21$var$tn,
    beautifyShortcut: $4fb7d97cf6fbcc21$var$Ft,
    cacheable: $4fb7d97cf6fbcc21$var$Wt,
    capitalize: $4fb7d97cf6fbcc21$var$Rt,
    copyTextToClipboard: $4fb7d97cf6fbcc21$var$qt,
    debounce: $4fb7d97cf6fbcc21$var$Ut,
    deepMerge: $4fb7d97cf6fbcc21$var$X,
    deprecationAssert: $4fb7d97cf6fbcc21$var$Jt,
    getUserOS: $4fb7d97cf6fbcc21$var$Ue,
    getValidUrl: $4fb7d97cf6fbcc21$var$Qt,
    isBoolean: $4fb7d97cf6fbcc21$var$Kt,
    isClass: $4fb7d97cf6fbcc21$var$zt,
    isEmpty: $4fb7d97cf6fbcc21$var$Dt,
    isFunction: $4fb7d97cf6fbcc21$var$Ke,
    isIosDevice: $4fb7d97cf6fbcc21$var$Ht,
    isNumber: $4fb7d97cf6fbcc21$var$Xt,
    isObject: $4fb7d97cf6fbcc21$var$M,
    isPrintableKey: $4fb7d97cf6fbcc21$var$Zt,
    isPromise: $4fb7d97cf6fbcc21$var$Gt,
    isString: $4fb7d97cf6fbcc21$var$Vt,
    isUndefined: $4fb7d97cf6fbcc21$var$Yt,
    keyCodes: $4fb7d97cf6fbcc21$var$xt,
    mouseButtons: $4fb7d97cf6fbcc21$var$en,
    notEmpty: $4fb7d97cf6fbcc21$var$ae,
    throttle: $4fb7d97cf6fbcc21$var$nn,
    typeOf: $4fb7d97cf6fbcc21$var$S
}, Symbol.toStringTag, {
    value: "Module"
})), $4fb7d97cf6fbcc21$var$le = /* @__PURE__ */ $4fb7d97cf6fbcc21$var$wt($4fb7d97cf6fbcc21$var$rn);
Object.defineProperty($4fb7d97cf6fbcc21$var$ie, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$ie.containsOnlyInlineElements = $4fb7d97cf6fbcc21$var$sn;
var $4fb7d97cf6fbcc21$var$an = $4fb7d97cf6fbcc21$var$le, $4fb7d97cf6fbcc21$var$ln = $4fb7d97cf6fbcc21$var$Z;
function $4fb7d97cf6fbcc21$var$sn(e) {
    var t;
    (0, $4fb7d97cf6fbcc21$var$an.isString)(e) ? (t = document.createElement("div"), t.innerHTML = e) : t = e;
    var n = function n1(r) {
        return !(0, $4fb7d97cf6fbcc21$var$ln.blockElements)().includes(r.tagName.toLowerCase()) && Array.from(r.children).every(n);
    };
    return Array.from(t.children).every(n);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.containsOnlyInlineElements = void 0;
    var t = $4fb7d97cf6fbcc21$var$ie;
    Object.defineProperty(e, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function get() {
            return t.containsOnlyInlineElements;
        }
    });
})($4fb7d97cf6fbcc21$var$$);
var $4fb7d97cf6fbcc21$var$ze = {}, $4fb7d97cf6fbcc21$var$se = {}, $4fb7d97cf6fbcc21$var$B = {}, $4fb7d97cf6fbcc21$var$oe = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$oe, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$oe.make = $4fb7d97cf6fbcc21$var$on;
function $4fb7d97cf6fbcc21$var$on(e, t, n) {
    var r;
    t === void 0 && (t = null), n === void 0 && (n = {});
    var i = document.createElement(e);
    if (Array.isArray(t)) {
        var a = t.filter(function(s) {
            return s !== void 0;
        });
        (r = i.classList).add.apply(r, a);
    } else t !== null && i.classList.add(t);
    for(var l in n)Object.prototype.hasOwnProperty.call(n, l) && (i[l] = n[l]);
    return i;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.make = void 0;
    var t = $4fb7d97cf6fbcc21$var$oe;
    Object.defineProperty(e, "make", {
        enumerable: !0,
        get: function get() {
            return t.make;
        }
    });
})($4fb7d97cf6fbcc21$var$B);
Object.defineProperty($4fb7d97cf6fbcc21$var$se, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$se.fragmentToString = $4fb7d97cf6fbcc21$var$cn;
var $4fb7d97cf6fbcc21$var$un = $4fb7d97cf6fbcc21$var$B;
function $4fb7d97cf6fbcc21$var$cn(e) {
    var t = (0, $4fb7d97cf6fbcc21$var$un.make)("div");
    return t.appendChild(e), t.innerHTML;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.fragmentToString = void 0;
    var t = $4fb7d97cf6fbcc21$var$se;
    Object.defineProperty(e, "fragmentToString", {
        enumerable: !0,
        get: function get() {
            return t.fragmentToString;
        }
    });
})($4fb7d97cf6fbcc21$var$ze);
var $4fb7d97cf6fbcc21$var$Xe = {}, $4fb7d97cf6fbcc21$var$ue = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$ue, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$ue.getContentLength = $4fb7d97cf6fbcc21$var$fn;
var $4fb7d97cf6fbcc21$var$dn = $4fb7d97cf6fbcc21$var$k;
function $4fb7d97cf6fbcc21$var$fn(e) {
    var t, n;
    return (0, $4fb7d97cf6fbcc21$var$dn.isNativeInput)(e) ? e.value.length : e.nodeType === Node.TEXT_NODE ? e.length : (n = (t = e.textContent) === null || t === void 0 ? void 0 : t.length) !== null && n !== void 0 ? n : 0;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getContentLength = void 0;
    var t = $4fb7d97cf6fbcc21$var$ue;
    Object.defineProperty(e, "getContentLength", {
        enumerable: !0,
        get: function get() {
            return t.getContentLength;
        }
    });
})($4fb7d97cf6fbcc21$var$Xe);
var $4fb7d97cf6fbcc21$var$ce = {}, $4fb7d97cf6fbcc21$var$de = {}, $4fb7d97cf6fbcc21$var$We = $4fb7d97cf6fbcc21$var$A && $4fb7d97cf6fbcc21$var$A.__spreadArray || function(e, t, n) {
    if (n || arguments.length === 2) for(var r = 0, i = t.length, a; r < i; r++)(a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
    return e.concat(a || Array.prototype.slice.call(t));
};
Object.defineProperty($4fb7d97cf6fbcc21$var$de, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$de.getDeepestBlockElements = $4fb7d97cf6fbcc21$var$Ge;
var $4fb7d97cf6fbcc21$var$pn = $4fb7d97cf6fbcc21$var$$;
function $4fb7d97cf6fbcc21$var$Ge(e) {
    return (0, $4fb7d97cf6fbcc21$var$pn.containsOnlyInlineElements)(e) ? [
        e
    ] : Array.from(e.children).reduce(function(t, n) {
        return $4fb7d97cf6fbcc21$var$We($4fb7d97cf6fbcc21$var$We([], t, !0), $4fb7d97cf6fbcc21$var$Ge(n), !0);
    }, []);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getDeepestBlockElements = void 0;
    var t = $4fb7d97cf6fbcc21$var$de;
    Object.defineProperty(e, "getDeepestBlockElements", {
        enumerable: !0,
        get: function get() {
            return t.getDeepestBlockElements;
        }
    });
})($4fb7d97cf6fbcc21$var$ce);
var $4fb7d97cf6fbcc21$var$Ve = {}, $4fb7d97cf6fbcc21$var$fe = {}, $4fb7d97cf6fbcc21$var$W = {}, $4fb7d97cf6fbcc21$var$pe = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$pe, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$pe.isLineBreakTag = $4fb7d97cf6fbcc21$var$hn;
function $4fb7d97cf6fbcc21$var$hn(e) {
    return [
        "BR",
        "WBR"
    ].includes(e.tagName);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isLineBreakTag = void 0;
    var t = $4fb7d97cf6fbcc21$var$pe;
    Object.defineProperty(e, "isLineBreakTag", {
        enumerable: !0,
        get: function get() {
            return t.isLineBreakTag;
        }
    });
})($4fb7d97cf6fbcc21$var$W);
var $4fb7d97cf6fbcc21$var$D = {}, $4fb7d97cf6fbcc21$var$he = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$he, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$he.isSingleTag = $4fb7d97cf6fbcc21$var$mn;
function $4fb7d97cf6fbcc21$var$mn(e) {
    return [
        "AREA",
        "BASE",
        "BR",
        "COL",
        "COMMAND",
        "EMBED",
        "HR",
        "IMG",
        "INPUT",
        "KEYGEN",
        "LINK",
        "META",
        "PARAM",
        "SOURCE",
        "TRACK",
        "WBR"
    ].includes(e.tagName);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isSingleTag = void 0;
    var t = $4fb7d97cf6fbcc21$var$he;
    Object.defineProperty(e, "isSingleTag", {
        enumerable: !0,
        get: function get() {
            return t.isSingleTag;
        }
    });
})($4fb7d97cf6fbcc21$var$D);
Object.defineProperty($4fb7d97cf6fbcc21$var$fe, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$fe.getDeepestNode = $4fb7d97cf6fbcc21$var$Ye;
var $4fb7d97cf6fbcc21$var$gn = $4fb7d97cf6fbcc21$var$k, $4fb7d97cf6fbcc21$var$vn = $4fb7d97cf6fbcc21$var$W, $4fb7d97cf6fbcc21$var$bn = $4fb7d97cf6fbcc21$var$D;
function $4fb7d97cf6fbcc21$var$Ye(e, t) {
    t === void 0 && (t = !1);
    var n = t ? "lastChild" : "firstChild", r = t ? "previousSibling" : "nextSibling";
    if (e.nodeType === Node.ELEMENT_NODE && e[n]) {
        var i = e[n];
        if ((0, $4fb7d97cf6fbcc21$var$bn.isSingleTag)(i) && !(0, $4fb7d97cf6fbcc21$var$gn.isNativeInput)(i) && !(0, $4fb7d97cf6fbcc21$var$vn.isLineBreakTag)(i)) {
            if (i[r]) i = i[r];
            else if (i.parentNode !== null && i.parentNode[r]) i = i.parentNode[r];
            else return i.parentNode;
        }
        return $4fb7d97cf6fbcc21$var$Ye(i, t);
    }
    return e;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getDeepestNode = void 0;
    var t = $4fb7d97cf6fbcc21$var$fe;
    Object.defineProperty(e, "getDeepestNode", {
        enumerable: !0,
        get: function get() {
            return t.getDeepestNode;
        }
    });
})($4fb7d97cf6fbcc21$var$Ve);
var $4fb7d97cf6fbcc21$var$Je = {}, $4fb7d97cf6fbcc21$var$me = {}, $4fb7d97cf6fbcc21$var$T = $4fb7d97cf6fbcc21$var$A && $4fb7d97cf6fbcc21$var$A.__spreadArray || function(e, t, n) {
    if (n || arguments.length === 2) for(var r = 0, i = t.length, a; r < i; r++)(a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
    return e.concat(a || Array.prototype.slice.call(t));
};
Object.defineProperty($4fb7d97cf6fbcc21$var$me, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$me.findAllInputs = $4fb7d97cf6fbcc21$var$kn;
var $4fb7d97cf6fbcc21$var$yn = $4fb7d97cf6fbcc21$var$$, $4fb7d97cf6fbcc21$var$Cn = $4fb7d97cf6fbcc21$var$ce, $4fb7d97cf6fbcc21$var$Sn = $4fb7d97cf6fbcc21$var$V, $4fb7d97cf6fbcc21$var$On = $4fb7d97cf6fbcc21$var$k;
function $4fb7d97cf6fbcc21$var$kn(e) {
    return Array.from(e.querySelectorAll((0, $4fb7d97cf6fbcc21$var$Sn.allInputsSelector)())).reduce(function(t, n) {
        return (0, $4fb7d97cf6fbcc21$var$On.isNativeInput)(n) || (0, $4fb7d97cf6fbcc21$var$yn.containsOnlyInlineElements)(n) ? $4fb7d97cf6fbcc21$var$T($4fb7d97cf6fbcc21$var$T([], t, !0), [
            n
        ], !1) : $4fb7d97cf6fbcc21$var$T($4fb7d97cf6fbcc21$var$T([], t, !0), (0, $4fb7d97cf6fbcc21$var$Cn.getDeepestBlockElements)(n), !0);
    }, []);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.findAllInputs = void 0;
    var t = $4fb7d97cf6fbcc21$var$me;
    Object.defineProperty(e, "findAllInputs", {
        enumerable: !0,
        get: function get() {
            return t.findAllInputs;
        }
    });
})($4fb7d97cf6fbcc21$var$Je);
var $4fb7d97cf6fbcc21$var$Qe = {}, $4fb7d97cf6fbcc21$var$ge = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$ge, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$ge.isCollapsedWhitespaces = $4fb7d97cf6fbcc21$var$_n;
function $4fb7d97cf6fbcc21$var$_n(e) {
    return !/[^\t\n\r ]/.test(e);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isCollapsedWhitespaces = void 0;
    var t = $4fb7d97cf6fbcc21$var$ge;
    Object.defineProperty(e, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function get() {
            return t.isCollapsedWhitespaces;
        }
    });
})($4fb7d97cf6fbcc21$var$Qe);
var $4fb7d97cf6fbcc21$var$ve = {}, $4fb7d97cf6fbcc21$var$be = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$be, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$be.isElement = $4fb7d97cf6fbcc21$var$In;
var $4fb7d97cf6fbcc21$var$En = $4fb7d97cf6fbcc21$var$le;
function $4fb7d97cf6fbcc21$var$In(e) {
    return (0, $4fb7d97cf6fbcc21$var$En.isNumber)(e) ? !1 : !!e && !!e.nodeType && e.nodeType === Node.ELEMENT_NODE;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isElement = void 0;
    var t = $4fb7d97cf6fbcc21$var$be;
    Object.defineProperty(e, "isElement", {
        enumerable: !0,
        get: function get() {
            return t.isElement;
        }
    });
})($4fb7d97cf6fbcc21$var$ve);
var $4fb7d97cf6fbcc21$var$Ze = {}, $4fb7d97cf6fbcc21$var$ye = {}, $4fb7d97cf6fbcc21$var$Ce = {}, $4fb7d97cf6fbcc21$var$Se = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$Se, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$Se.isLeaf = $4fb7d97cf6fbcc21$var$wn;
function $4fb7d97cf6fbcc21$var$wn(e) {
    return e === null ? !1 : e.childNodes.length === 0;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isLeaf = void 0;
    var t = $4fb7d97cf6fbcc21$var$Se;
    Object.defineProperty(e, "isLeaf", {
        enumerable: !0,
        get: function get() {
            return t.isLeaf;
        }
    });
})($4fb7d97cf6fbcc21$var$Ce);
var $4fb7d97cf6fbcc21$var$Oe = {}, $4fb7d97cf6fbcc21$var$ke = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$ke, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$ke.isNodeEmpty = $4fb7d97cf6fbcc21$var$Mn;
var $4fb7d97cf6fbcc21$var$Pn = $4fb7d97cf6fbcc21$var$W, $4fb7d97cf6fbcc21$var$jn = $4fb7d97cf6fbcc21$var$ve, $4fb7d97cf6fbcc21$var$Tn = $4fb7d97cf6fbcc21$var$k, $4fb7d97cf6fbcc21$var$Ln = $4fb7d97cf6fbcc21$var$D;
function $4fb7d97cf6fbcc21$var$Mn(e, t) {
    var n = "";
    return (0, $4fb7d97cf6fbcc21$var$Ln.isSingleTag)(e) && !(0, $4fb7d97cf6fbcc21$var$Pn.isLineBreakTag)(e) ? !1 : ((0, $4fb7d97cf6fbcc21$var$jn.isElement)(e) && (0, $4fb7d97cf6fbcc21$var$Tn.isNativeInput)(e) ? n = e.value : e.textContent !== null && (n = e.textContent.replace("\u200B", "")), t !== void 0 && (n = n.replace(new RegExp(t, "g"), "")), n.trim().length === 0);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isNodeEmpty = void 0;
    var t = $4fb7d97cf6fbcc21$var$ke;
    Object.defineProperty(e, "isNodeEmpty", {
        enumerable: !0,
        get: function get() {
            return t.isNodeEmpty;
        }
    });
})($4fb7d97cf6fbcc21$var$Oe);
Object.defineProperty($4fb7d97cf6fbcc21$var$ye, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$ye.isEmpty = $4fb7d97cf6fbcc21$var$$n;
var $4fb7d97cf6fbcc21$var$Nn = $4fb7d97cf6fbcc21$var$Ce, $4fb7d97cf6fbcc21$var$An = $4fb7d97cf6fbcc21$var$Oe;
function $4fb7d97cf6fbcc21$var$$n(e, t) {
    e.normalize();
    for(var n = [
        e
    ]; n.length > 0;){
        var r = n.shift();
        if (r) {
            if (e = r, (0, $4fb7d97cf6fbcc21$var$Nn.isLeaf)(e) && !(0, $4fb7d97cf6fbcc21$var$An.isNodeEmpty)(e, t)) return !1;
            n.push.apply(n, Array.from(e.childNodes));
        }
    }
    return !0;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isEmpty = void 0;
    var t = $4fb7d97cf6fbcc21$var$ye;
    Object.defineProperty(e, "isEmpty", {
        enumerable: !0,
        get: function get() {
            return t.isEmpty;
        }
    });
})($4fb7d97cf6fbcc21$var$Ze);
var $4fb7d97cf6fbcc21$var$xe = {}, $4fb7d97cf6fbcc21$var$_e = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$_e, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$_e.isFragment = $4fb7d97cf6fbcc21$var$Wn;
var $4fb7d97cf6fbcc21$var$Bn = $4fb7d97cf6fbcc21$var$le;
function $4fb7d97cf6fbcc21$var$Wn(e) {
    return (0, $4fb7d97cf6fbcc21$var$Bn.isNumber)(e) ? !1 : !!e && !!e.nodeType && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isFragment = void 0;
    var t = $4fb7d97cf6fbcc21$var$_e;
    Object.defineProperty(e, "isFragment", {
        enumerable: !0,
        get: function get() {
            return t.isFragment;
        }
    });
})($4fb7d97cf6fbcc21$var$xe);
var $4fb7d97cf6fbcc21$var$et = {}, $4fb7d97cf6fbcc21$var$Ee = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$Ee, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$Ee.isHTMLString = $4fb7d97cf6fbcc21$var$Hn;
var $4fb7d97cf6fbcc21$var$Dn = $4fb7d97cf6fbcc21$var$B;
function $4fb7d97cf6fbcc21$var$Hn(e) {
    var t = (0, $4fb7d97cf6fbcc21$var$Dn.make)("div");
    return t.innerHTML = e, t.childElementCount > 0;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isHTMLString = void 0;
    var t = $4fb7d97cf6fbcc21$var$Ee;
    Object.defineProperty(e, "isHTMLString", {
        enumerable: !0,
        get: function get() {
            return t.isHTMLString;
        }
    });
})($4fb7d97cf6fbcc21$var$et);
var $4fb7d97cf6fbcc21$var$tt = {}, $4fb7d97cf6fbcc21$var$Ie = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$Ie, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$Ie.offset = $4fb7d97cf6fbcc21$var$Fn;
function $4fb7d97cf6fbcc21$var$Fn(e) {
    var t = e.getBoundingClientRect(), n = window.pageXOffset || document.documentElement.scrollLeft, r = window.pageYOffset || document.documentElement.scrollTop, i = t.top + r, a = t.left + n;
    return {
        top: i,
        left: a,
        bottom: i + t.height,
        right: a + t.width
    };
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.offset = void 0;
    var t = $4fb7d97cf6fbcc21$var$Ie;
    Object.defineProperty(e, "offset", {
        enumerable: !0,
        get: function get() {
            return t.offset;
        }
    });
})($4fb7d97cf6fbcc21$var$tt);
var $4fb7d97cf6fbcc21$var$nt = {}, $4fb7d97cf6fbcc21$var$we = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$we, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$we.prepend = $4fb7d97cf6fbcc21$var$Rn;
function $4fb7d97cf6fbcc21$var$Rn(e, t) {
    Array.isArray(t) ? (t = t.reverse(), t.forEach(function(n) {
        return e.prepend(n);
    })) : e.prepend(t);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.prepend = void 0;
    var t = $4fb7d97cf6fbcc21$var$we;
    Object.defineProperty(e, "prepend", {
        enumerable: !0,
        get: function get() {
            return t.prepend;
        }
    });
})($4fb7d97cf6fbcc21$var$nt);
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.prepend = e.offset = e.make = e.isLineBreakTag = e.isSingleTag = e.isNodeEmpty = e.isLeaf = e.isHTMLString = e.isFragment = e.isEmpty = e.isElement = e.isContentEditable = e.isCollapsedWhitespaces = e.findAllInputs = e.isNativeInput = e.allInputsSelector = e.getDeepestNode = e.getDeepestBlockElements = e.getContentLength = e.fragmentToString = e.containsOnlyInlineElements = e.canSetCaret = e.calculateBaseline = e.blockElements = e.append = void 0;
    var t = $4fb7d97cf6fbcc21$var$V;
    Object.defineProperty(e, "allInputsSelector", {
        enumerable: !0,
        get: function get() {
            return t.allInputsSelector;
        }
    });
    var n = $4fb7d97cf6fbcc21$var$k;
    Object.defineProperty(e, "isNativeInput", {
        enumerable: !0,
        get: function get() {
            return n.isNativeInput;
        }
    });
    var r = $4fb7d97cf6fbcc21$var$Fe;
    Object.defineProperty(e, "append", {
        enumerable: !0,
        get: function get() {
            return r.append;
        }
    });
    var i = $4fb7d97cf6fbcc21$var$Z;
    Object.defineProperty(e, "blockElements", {
        enumerable: !0,
        get: function get() {
            return i.blockElements;
        }
    });
    var a = $4fb7d97cf6fbcc21$var$Re;
    Object.defineProperty(e, "calculateBaseline", {
        enumerable: !0,
        get: function get() {
            return a.calculateBaseline;
        }
    });
    var l = $4fb7d97cf6fbcc21$var$qe;
    Object.defineProperty(e, "canSetCaret", {
        enumerable: !0,
        get: function get() {
            return l.canSetCaret;
        }
    });
    var s = $4fb7d97cf6fbcc21$var$$;
    Object.defineProperty(e, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function get() {
            return s.containsOnlyInlineElements;
        }
    });
    var o = $4fb7d97cf6fbcc21$var$ze;
    Object.defineProperty(e, "fragmentToString", {
        enumerable: !0,
        get: function get() {
            return o.fragmentToString;
        }
    });
    var d = $4fb7d97cf6fbcc21$var$Xe;
    Object.defineProperty(e, "getContentLength", {
        enumerable: !0,
        get: function get() {
            return d.getContentLength;
        }
    });
    var u = $4fb7d97cf6fbcc21$var$ce;
    Object.defineProperty(e, "getDeepestBlockElements", {
        enumerable: !0,
        get: function get() {
            return u.getDeepestBlockElements;
        }
    });
    var p = $4fb7d97cf6fbcc21$var$Ve;
    Object.defineProperty(e, "getDeepestNode", {
        enumerable: !0,
        get: function get() {
            return p.getDeepestNode;
        }
    });
    var g = $4fb7d97cf6fbcc21$var$Je;
    Object.defineProperty(e, "findAllInputs", {
        enumerable: !0,
        get: function get() {
            return g.findAllInputs;
        }
    });
    var w = $4fb7d97cf6fbcc21$var$Qe;
    Object.defineProperty(e, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function get() {
            return w.isCollapsedWhitespaces;
        }
    });
    var _ = $4fb7d97cf6fbcc21$var$ne;
    Object.defineProperty(e, "isContentEditable", {
        enumerable: !0,
        get: function get() {
            return _.isContentEditable;
        }
    });
    var ut = $4fb7d97cf6fbcc21$var$ve;
    Object.defineProperty(e, "isElement", {
        enumerable: !0,
        get: function get() {
            return ut.isElement;
        }
    });
    var ct = $4fb7d97cf6fbcc21$var$Ze;
    Object.defineProperty(e, "isEmpty", {
        enumerable: !0,
        get: function get() {
            return ct.isEmpty;
        }
    });
    var dt = $4fb7d97cf6fbcc21$var$xe;
    Object.defineProperty(e, "isFragment", {
        enumerable: !0,
        get: function get() {
            return dt.isFragment;
        }
    });
    var ft = $4fb7d97cf6fbcc21$var$et;
    Object.defineProperty(e, "isHTMLString", {
        enumerable: !0,
        get: function get() {
            return ft.isHTMLString;
        }
    });
    var pt = $4fb7d97cf6fbcc21$var$Ce;
    Object.defineProperty(e, "isLeaf", {
        enumerable: !0,
        get: function get() {
            return pt.isLeaf;
        }
    });
    var ht = $4fb7d97cf6fbcc21$var$Oe;
    Object.defineProperty(e, "isNodeEmpty", {
        enumerable: !0,
        get: function get() {
            return ht.isNodeEmpty;
        }
    });
    var mt = $4fb7d97cf6fbcc21$var$W;
    Object.defineProperty(e, "isLineBreakTag", {
        enumerable: !0,
        get: function get() {
            return mt.isLineBreakTag;
        }
    });
    var gt = $4fb7d97cf6fbcc21$var$D;
    Object.defineProperty(e, "isSingleTag", {
        enumerable: !0,
        get: function get() {
            return gt.isSingleTag;
        }
    });
    var vt = $4fb7d97cf6fbcc21$var$B;
    Object.defineProperty(e, "make", {
        enumerable: !0,
        get: function get() {
            return vt.make;
        }
    });
    var bt = $4fb7d97cf6fbcc21$var$tt;
    Object.defineProperty(e, "offset", {
        enumerable: !0,
        get: function get() {
            return bt.offset;
        }
    });
    var yt = $4fb7d97cf6fbcc21$var$nt;
    Object.defineProperty(e, "prepend", {
        enumerable: !0,
        get: function get() {
            return yt.prepend;
        }
    });
})($4fb7d97cf6fbcc21$var$c);
var $4fb7d97cf6fbcc21$var$m = "cdx-list", $4fb7d97cf6fbcc21$var$h = {
    wrapper: $4fb7d97cf6fbcc21$var$m,
    item: "".concat($4fb7d97cf6fbcc21$var$m, "__item"),
    itemContent: "".concat($4fb7d97cf6fbcc21$var$m, "__item-content"),
    itemChildren: "".concat($4fb7d97cf6fbcc21$var$m, "__item-children")
};
var $4fb7d97cf6fbcc21$var$v = /*#__PURE__*/ function() {
    "use strict";
    function v(t, n) {
        (0, $173N4._)(this, v);
        this.config = n, this.readOnly = t;
    }
    (0, $cFHGC._)(v, [
        {
            /**
   * Renders ol wrapper for list
   * @param isRoot - boolean variable that represents level of the wrappre (root or childList)
   * @returns - created html ol element
   */ key: "renderWrapper",
            value: function renderWrapper(t) {
                var n;
                return t === !0 ? n = $4fb7d97cf6fbcc21$var$c.make("ol", [
                    v.CSS.wrapper,
                    v.CSS.orderedList
                ]) : n = $4fb7d97cf6fbcc21$var$c.make("ol", [
                    v.CSS.orderedList,
                    v.CSS.itemChildren
                ]), n;
            }
        },
        {
            /**
   * Redners list item element
   * @param content - content used in list item rendering
   * @param _meta - meta of the list item unused in rendering of the ordered list
   * @returns - created html list item element
   */ key: "renderItem",
            value: function renderItem(t, n) {
                var r = $4fb7d97cf6fbcc21$var$c.make("li", v.CSS.item), i = $4fb7d97cf6fbcc21$var$c.make("div", v.CSS.itemContent, {
                    innerHTML: t,
                    contentEditable: (!this.readOnly).toString()
                });
                return r.appendChild(i), r;
            }
        },
        {
            /**
   * Return the item content
   * @param item - item wrapper (<li>)
   * @returns - item content string
   */ key: "getItemContent",
            value: function getItemContent(t) {
                var n = t.querySelector(".".concat(v.CSS.itemContent));
                return !n || $4fb7d97cf6fbcc21$var$c.isEmpty(n) ? "" : n.innerHTML;
            }
        },
        {
            /**
   * Returns item meta, for ordered list
   * @returns item meta object
   */ key: "getItemMeta",
            value: function getItemMeta() {
                return {};
            }
        },
        {
            /**
   * Returns default item meta used on creation of the new item
   */ key: "composeDefaultMeta",
            value: function composeDefaultMeta() {
                return {};
            }
        }
    ], [
        {
            key: "CSS",
            get: /**
   * Getter for all CSS classes used in unordered list rendering
   */ function get() {
                return (0, $6fpqi._)((0, $1XAnY._)({}, $4fb7d97cf6fbcc21$var$h), {
                    orderedList: "".concat($4fb7d97cf6fbcc21$var$m, "-ordered")
                });
            }
        }
    ]);
    return v;
}();
var $4fb7d97cf6fbcc21$var$b = /*#__PURE__*/ function() {
    "use strict";
    function b(t, n) {
        (0, $173N4._)(this, b);
        this.config = n, this.readOnly = t;
    }
    (0, $cFHGC._)(b, [
        {
            /**
   * Renders ol wrapper for list
   * @param isRoot - boolean variable that represents level of the wrappre (root or childList)
   * @returns - created html ul element
   */ key: "renderWrapper",
            value: function renderWrapper(t) {
                var n;
                return t === !0 ? n = $4fb7d97cf6fbcc21$var$c.make("ul", [
                    b.CSS.wrapper,
                    b.CSS.unorderedList
                ]) : n = $4fb7d97cf6fbcc21$var$c.make("ul", [
                    b.CSS.unorderedList,
                    b.CSS.itemChildren
                ]), n;
            }
        },
        {
            /**
   * Redners list item element
   * @param content - content used in list item rendering
   * @param _meta - meta of the list item unused in rendering of the unordered list
   * @returns - created html list item element
   */ key: "renderItem",
            value: function renderItem(t, n) {
                var r = $4fb7d97cf6fbcc21$var$c.make("li", b.CSS.item), i = $4fb7d97cf6fbcc21$var$c.make("div", b.CSS.itemContent, {
                    innerHTML: t,
                    contentEditable: (!this.readOnly).toString()
                });
                return r.appendChild(i), r;
            }
        },
        {
            /**
   * Return the item content
   * @param item - item wrapper (<li>)
   * @returns - item content string
   */ key: "getItemContent",
            value: function getItemContent(t) {
                var n = t.querySelector(".".concat(b.CSS.itemContent));
                return !n || $4fb7d97cf6fbcc21$var$c.isEmpty(n) ? "" : n.innerHTML;
            }
        },
        {
            /**
   * Returns item meta, for unordered list
   * @returns Item meta object
   */ key: "getItemMeta",
            value: function getItemMeta() {
                return {};
            }
        },
        {
            /**
   * Returns default item meta used on creation of the new item
   */ key: "composeDefaultMeta",
            value: function composeDefaultMeta() {
                return {};
            }
        }
    ], [
        {
            key: "CSS",
            get: /**
   * Getter for all CSS classes used in unordered list rendering
   */ function get() {
                return (0, $6fpqi._)((0, $1XAnY._)({}, $4fb7d97cf6fbcc21$var$h), {
                    unorderedList: "".concat($4fb7d97cf6fbcc21$var$m, "-unordered")
                });
            }
        }
    ]);
    return b;
}();
function $4fb7d97cf6fbcc21$var$O(e) {
    return e.nodeType === Node.ELEMENT_NODE;
}
var $4fb7d97cf6fbcc21$var$j = {}, $4fb7d97cf6fbcc21$var$Pe = {}, $4fb7d97cf6fbcc21$var$H = {}, $4fb7d97cf6fbcc21$var$F = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$F, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$F.getContenteditableSlice = $4fb7d97cf6fbcc21$var$Un;
var $4fb7d97cf6fbcc21$var$qn = $4fb7d97cf6fbcc21$var$c;
function $4fb7d97cf6fbcc21$var$Un(e, t, n, r, i) {
    var a;
    i === void 0 && (i = !1);
    var l = document.createRange();
    if (r === "left" ? (l.setStart(e, 0), l.setEnd(t, n)) : (l.setStart(t, n), l.setEnd(e, e.childNodes.length)), i === !0) {
        var s = l.extractContents();
        return (0, $4fb7d97cf6fbcc21$var$qn.fragmentToString)(s);
    }
    var o = l.cloneContents(), d = document.createElement("div");
    d.appendChild(o);
    var u = (a = d.textContent) !== null && a !== void 0 ? a : "";
    return u;
}
Object.defineProperty($4fb7d97cf6fbcc21$var$H, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$H.checkContenteditableSliceForEmptiness = $4fb7d97cf6fbcc21$var$Xn;
var $4fb7d97cf6fbcc21$var$Kn = $4fb7d97cf6fbcc21$var$c, $4fb7d97cf6fbcc21$var$zn = $4fb7d97cf6fbcc21$var$F;
function $4fb7d97cf6fbcc21$var$Xn(e, t, n, r) {
    var i = (0, $4fb7d97cf6fbcc21$var$zn.getContenteditableSlice)(e, t, n, r);
    return (0, $4fb7d97cf6fbcc21$var$Kn.isCollapsedWhitespaces)(i);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.checkContenteditableSliceForEmptiness = void 0;
    var t = $4fb7d97cf6fbcc21$var$H;
    Object.defineProperty(e, "checkContenteditableSliceForEmptiness", {
        enumerable: !0,
        get: function get() {
            return t.checkContenteditableSliceForEmptiness;
        }
    });
})($4fb7d97cf6fbcc21$var$Pe);
var $4fb7d97cf6fbcc21$var$rt = {};
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getContenteditableSlice = void 0;
    var t = $4fb7d97cf6fbcc21$var$F;
    Object.defineProperty(e, "getContenteditableSlice", {
        enumerable: !0,
        get: function get() {
            return t.getContenteditableSlice;
        }
    });
})($4fb7d97cf6fbcc21$var$rt);
var $4fb7d97cf6fbcc21$var$it = {}, $4fb7d97cf6fbcc21$var$je = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$je, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$je.focus = $4fb7d97cf6fbcc21$var$Vn;
var $4fb7d97cf6fbcc21$var$Gn = $4fb7d97cf6fbcc21$var$c;
function $4fb7d97cf6fbcc21$var$Vn(e, t) {
    var n, r;
    if (t === void 0 && (t = !0), (0, $4fb7d97cf6fbcc21$var$Gn.isNativeInput)(e)) {
        e.focus();
        var i = t ? 0 : e.value.length;
        e.setSelectionRange(i, i);
    } else {
        var a = document.createRange(), l = window.getSelection();
        if (!l) return;
        var s = function s(g, w) {
            w === void 0 && (w = !1);
            var _ = document.createTextNode("");
            w ? g.insertBefore(_, g.firstChild) : g.appendChild(_), a.setStart(_, 0), a.setEnd(_, 0);
        }, o = function o(g) {
            return g != null;
        }, d = e.childNodes, u = t ? d[0] : d[d.length - 1];
        if (o(u)) {
            for(; o(u) && u.nodeType !== Node.TEXT_NODE;)u = t ? u.firstChild : u.lastChild;
            if (o(u) && u.nodeType === Node.TEXT_NODE) {
                var p = (r = (n = u.textContent) === null || n === void 0 ? void 0 : n.length) !== null && r !== void 0 ? r : 0, i = t ? 0 : p;
                a.setStart(u, i), a.setEnd(u, i);
            } else s(e, t);
        } else s(e);
        l.removeAllRanges(), l.addRange(a);
    }
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.focus = void 0;
    var t = $4fb7d97cf6fbcc21$var$je;
    Object.defineProperty(e, "focus", {
        enumerable: !0,
        get: function get() {
            return t.focus;
        }
    });
})($4fb7d97cf6fbcc21$var$it);
var $4fb7d97cf6fbcc21$var$Te = {}, $4fb7d97cf6fbcc21$var$R = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$R, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$R.getCaretNodeAndOffset = $4fb7d97cf6fbcc21$var$Yn;
function $4fb7d97cf6fbcc21$var$Yn() {
    var e = window.getSelection();
    if (e === null) return [
        null,
        0
    ];
    var t = e.focusNode, n = e.focusOffset;
    return t === null ? [
        null,
        0
    ] : (t.nodeType !== Node.TEXT_NODE && t.childNodes.length > 0 && (t.childNodes[n] !== void 0 ? (t = t.childNodes[n], n = 0) : (t = t.childNodes[n - 1], t.textContent !== null && (n = t.textContent.length))), [
        t,
        n
    ]);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getCaretNodeAndOffset = void 0;
    var t = $4fb7d97cf6fbcc21$var$R;
    Object.defineProperty(e, "getCaretNodeAndOffset", {
        enumerable: !0,
        get: function get() {
            return t.getCaretNodeAndOffset;
        }
    });
})($4fb7d97cf6fbcc21$var$Te);
var $4fb7d97cf6fbcc21$var$at = {}, $4fb7d97cf6fbcc21$var$q = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$q, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$q.getRange = $4fb7d97cf6fbcc21$var$Jn;
function $4fb7d97cf6fbcc21$var$Jn() {
    var e = window.getSelection();
    return e && e.rangeCount ? e.getRangeAt(0) : null;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getRange = void 0;
    var t = $4fb7d97cf6fbcc21$var$q;
    Object.defineProperty(e, "getRange", {
        enumerable: !0,
        get: function get() {
            return t.getRange;
        }
    });
})($4fb7d97cf6fbcc21$var$at);
var $4fb7d97cf6fbcc21$var$lt = {}, $4fb7d97cf6fbcc21$var$Le = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$Le, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$Le.isCaretAtEndOfInput = $4fb7d97cf6fbcc21$var$xn;
var $4fb7d97cf6fbcc21$var$De = $4fb7d97cf6fbcc21$var$c, $4fb7d97cf6fbcc21$var$Qn = $4fb7d97cf6fbcc21$var$Te, $4fb7d97cf6fbcc21$var$Zn = $4fb7d97cf6fbcc21$var$Pe;
function $4fb7d97cf6fbcc21$var$xn(e) {
    var t = (0, $4fb7d97cf6fbcc21$var$De.getDeepestNode)(e, !0);
    if (t === null) return !0;
    if ((0, $4fb7d97cf6fbcc21$var$De.isNativeInput)(t)) return t.selectionEnd === t.value.length;
    var n = (0, $4fb7d97cf6fbcc21$var$Qn.getCaretNodeAndOffset)(), r = n[0], i = n[1];
    return r === null ? !1 : (0, $4fb7d97cf6fbcc21$var$Zn.checkContenteditableSliceForEmptiness)(e, r, i, "right");
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isCaretAtEndOfInput = void 0;
    var t = $4fb7d97cf6fbcc21$var$Le;
    Object.defineProperty(e, "isCaretAtEndOfInput", {
        enumerable: !0,
        get: function get() {
            return t.isCaretAtEndOfInput;
        }
    });
})($4fb7d97cf6fbcc21$var$lt);
var $4fb7d97cf6fbcc21$var$st = {}, $4fb7d97cf6fbcc21$var$Me = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$Me, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$Me.isCaretAtStartOfInput = $4fb7d97cf6fbcc21$var$nr;
var $4fb7d97cf6fbcc21$var$L = $4fb7d97cf6fbcc21$var$c, $4fb7d97cf6fbcc21$var$er = $4fb7d97cf6fbcc21$var$R, $4fb7d97cf6fbcc21$var$tr = $4fb7d97cf6fbcc21$var$H;
function $4fb7d97cf6fbcc21$var$nr(e) {
    var t = (0, $4fb7d97cf6fbcc21$var$L.getDeepestNode)(e);
    if (t === null || (0, $4fb7d97cf6fbcc21$var$L.isEmpty)(e)) return !0;
    if ((0, $4fb7d97cf6fbcc21$var$L.isNativeInput)(t)) return t.selectionEnd === 0;
    if ((0, $4fb7d97cf6fbcc21$var$L.isEmpty)(e)) return !0;
    var n = (0, $4fb7d97cf6fbcc21$var$er.getCaretNodeAndOffset)(), r = n[0], i = n[1];
    return r === null ? !1 : (0, $4fb7d97cf6fbcc21$var$tr.checkContenteditableSliceForEmptiness)(e, r, i, "left");
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isCaretAtStartOfInput = void 0;
    var t = $4fb7d97cf6fbcc21$var$Me;
    Object.defineProperty(e, "isCaretAtStartOfInput", {
        enumerable: !0,
        get: function get() {
            return t.isCaretAtStartOfInput;
        }
    });
})($4fb7d97cf6fbcc21$var$st);
var $4fb7d97cf6fbcc21$var$ot = {}, $4fb7d97cf6fbcc21$var$Ne = {};
Object.defineProperty($4fb7d97cf6fbcc21$var$Ne, "__esModule", {
    value: !0
});
$4fb7d97cf6fbcc21$var$Ne.save = $4fb7d97cf6fbcc21$var$ar;
var $4fb7d97cf6fbcc21$var$rr = $4fb7d97cf6fbcc21$var$c, $4fb7d97cf6fbcc21$var$ir = $4fb7d97cf6fbcc21$var$q;
function $4fb7d97cf6fbcc21$var$ar() {
    var e = (0, $4fb7d97cf6fbcc21$var$ir.getRange)(), t = (0, $4fb7d97cf6fbcc21$var$rr.make)("span");
    if (t.id = "cursor", t.hidden = !0, !!e) return e.insertNode(t), function() {
        var r = window.getSelection();
        r && (e.setStartAfter(t), e.setEndAfter(t), r.removeAllRanges(), r.addRange(e), setTimeout(function() {
            t.remove();
        }, 150));
    };
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.save = void 0;
    var t = $4fb7d97cf6fbcc21$var$Ne;
    Object.defineProperty(e, "save", {
        enumerable: !0,
        get: function get() {
            return t.save;
        }
    });
})($4fb7d97cf6fbcc21$var$ot);
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.save = e.isCaretAtStartOfInput = e.isCaretAtEndOfInput = e.getRange = e.getCaretNodeAndOffset = e.focus = e.getContenteditableSlice = e.checkContenteditableSliceForEmptiness = void 0;
    var t = $4fb7d97cf6fbcc21$var$Pe;
    Object.defineProperty(e, "checkContenteditableSliceForEmptiness", {
        enumerable: !0,
        get: function get() {
            return t.checkContenteditableSliceForEmptiness;
        }
    });
    var n = $4fb7d97cf6fbcc21$var$rt;
    Object.defineProperty(e, "getContenteditableSlice", {
        enumerable: !0,
        get: function get() {
            return n.getContenteditableSlice;
        }
    });
    var r = $4fb7d97cf6fbcc21$var$it;
    Object.defineProperty(e, "focus", {
        enumerable: !0,
        get: function get() {
            return r.focus;
        }
    });
    var i = $4fb7d97cf6fbcc21$var$Te;
    Object.defineProperty(e, "getCaretNodeAndOffset", {
        enumerable: !0,
        get: function get() {
            return i.getCaretNodeAndOffset;
        }
    });
    var a = $4fb7d97cf6fbcc21$var$at;
    Object.defineProperty(e, "getRange", {
        enumerable: !0,
        get: function get() {
            return a.getRange;
        }
    });
    var l = $4fb7d97cf6fbcc21$var$lt;
    Object.defineProperty(e, "isCaretAtEndOfInput", {
        enumerable: !0,
        get: function get() {
            return l.isCaretAtEndOfInput;
        }
    });
    var s = $4fb7d97cf6fbcc21$var$st;
    Object.defineProperty(e, "isCaretAtStartOfInput", {
        enumerable: !0,
        get: function get() {
            return s.isCaretAtStartOfInput;
        }
    });
    var o = $4fb7d97cf6fbcc21$var$ot;
    Object.defineProperty(e, "save", {
        enumerable: !0,
        get: function get() {
            return o.save;
        }
    });
})($4fb7d97cf6fbcc21$var$j);
var $4fb7d97cf6fbcc21$var$f = /*#__PURE__*/ function() {
    "use strict";
    function f(t, n) {
        (0, $173N4._)(this, f);
        this.config = n, this.readOnly = t;
    }
    (0, $cFHGC._)(f, [
        {
            /**
   * Renders ul wrapper for list
   * @param isRoot - boolean variable that represents level of the wrappre (root or childList)
   * @returns - created html ul element
   */ key: "renderWrapper",
            value: function renderWrapper(t) {
                var _this = this;
                var n;
                return t === !0 ? (n = $4fb7d97cf6fbcc21$var$c.make("ul", [
                    f.CSS.wrapper,
                    f.CSS.checklist
                ]), n.addEventListener("click", function(r) {
                    var i = r.target;
                    if (i) {
                        var a = i.closest(".".concat(f.CSS.checkboxContainer));
                        a && a.contains(i) && _this.toggleCheckbox(a);
                    }
                })) : n = $4fb7d97cf6fbcc21$var$c.make("ul", [
                    f.CSS.checklist,
                    f.CSS.itemChildren
                ]), n;
            }
        },
        {
            /**
   * Redners list item element
   * @param content - content used in list item rendering
   * @param meta - meta of the list item used in rendering of the checklist
   * @returns - created html list item element
   */ key: "renderItem",
            value: function renderItem(t, n) {
                var r = $4fb7d97cf6fbcc21$var$c.make("li", [
                    f.CSS.item,
                    f.CSS.item
                ]), i = $4fb7d97cf6fbcc21$var$c.make("div", f.CSS.itemContent, {
                    innerHTML: t,
                    contentEditable: (!this.readOnly).toString()
                }), a = $4fb7d97cf6fbcc21$var$c.make("span", f.CSS.checkbox), l = $4fb7d97cf6fbcc21$var$c.make("div", f.CSS.checkboxContainer);
                return n.checked === !0 && l.classList.add(f.CSS.itemChecked), this.readOnly && l.classList.add(f.CSS.checkboxCheckDisabled), a.innerHTML = $4fb7d97cf6fbcc21$var$Ct, l.appendChild(a), r.appendChild(l), r.appendChild(i), r;
            }
        },
        {
            /**
   * Return the item content
   * @param item - item wrapper (<li>)
   * @returns - item content string
   */ key: "getItemContent",
            value: function getItemContent(t) {
                var n = t.querySelector(".".concat(f.CSS.itemContent));
                return !n || $4fb7d97cf6fbcc21$var$c.isEmpty(n) ? "" : n.innerHTML;
            }
        },
        {
            /**
   * Return meta object of certain element
   * @param item - will be returned meta information of this item
   * @returns Item meta object
   */ key: "getItemMeta",
            value: function getItemMeta(t) {
                var n = t.querySelector(".".concat(f.CSS.checkboxContainer));
                return {
                    checked: n ? n.classList.contains(f.CSS.itemChecked) : !1
                };
            }
        },
        {
            /**
   * Returns default item meta used on creation of the new item
   */ key: "composeDefaultMeta",
            value: function composeDefaultMeta() {
                return {
                    checked: !1
                };
            }
        },
        {
            /**
   * Toggle checklist item state
   * @param checkbox - checkbox element to be toggled
   */ key: "toggleCheckbox",
            value: function toggleCheckbox(t) {
                var _this = this;
                t.classList.toggle(f.CSS.itemChecked), t.classList.add(f.CSS.noHover), t.addEventListener("mouseleave", function() {
                    return _this.removeSpecialHoverBehavior(t);
                }, {
                    once: !0
                });
            }
        },
        {
            /**
   * Removes class responsible for special hover behavior on an item
   * @param el - item wrapper
   */ key: "removeSpecialHoverBehavior",
            value: function removeSpecialHoverBehavior(t) {
                t.classList.remove(f.CSS.noHover);
            }
        }
    ], [
        {
            key: "CSS",
            get: /**
   * Getter for all CSS classes used in unordered list rendering
   */ function get() {
                return (0, $6fpqi._)((0, $1XAnY._)({}, $4fb7d97cf6fbcc21$var$h), {
                    checklist: "".concat($4fb7d97cf6fbcc21$var$m, "-checklist"),
                    itemChecked: "".concat($4fb7d97cf6fbcc21$var$m, "__checkbox--checked"),
                    noHover: "".concat($4fb7d97cf6fbcc21$var$m, "__checkbox--no-hover"),
                    checkbox: "".concat($4fb7d97cf6fbcc21$var$m, "__checkbox-check"),
                    checkboxContainer: "".concat($4fb7d97cf6fbcc21$var$m, "__checkbox"),
                    checkboxCheckDisabled: "".concat($4fb7d97cf6fbcc21$var$m, "__checkbox-check--disabled")
                });
            }
        }
    ]);
    return f;
}();
function $4fb7d97cf6fbcc21$var$U(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "after";
    var n = [];
    var r;
    function i(a) {
        switch(t){
            case "after":
                return a.nextElementSibling;
            case "before":
                return a.previousElementSibling;
        }
    }
    for(r = i(e); r !== null;)n.push(r), r = i(r);
    return n.length !== 0 ? n : null;
}
function $4fb7d97cf6fbcc21$var$y(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    var n = e;
    return e.classList.contains($4fb7d97cf6fbcc21$var$h.item) && (n = e.querySelector(".".concat($4fb7d97cf6fbcc21$var$h.itemChildren))), n === null ? [] : t ? Array.from(n.querySelectorAll(":scope > .".concat($4fb7d97cf6fbcc21$var$h.item))) : Array.from(n.querySelectorAll(".".concat($4fb7d97cf6fbcc21$var$h.item)));
}
function $4fb7d97cf6fbcc21$var$lr(e) {
    return e.nextElementSibling === null;
}
function $4fb7d97cf6fbcc21$var$sr(e) {
    return e.querySelector(".".concat($4fb7d97cf6fbcc21$var$h.itemChildren)) !== null;
}
function $4fb7d97cf6fbcc21$var$C(e) {
    return e.querySelector(".".concat($4fb7d97cf6fbcc21$var$h.itemChildren));
}
function $4fb7d97cf6fbcc21$var$K(e) {
    var t = e;
    e.classList.contains($4fb7d97cf6fbcc21$var$h.item) && (t = $4fb7d97cf6fbcc21$var$C(e)), t !== null && $4fb7d97cf6fbcc21$var$y(t).length === 0 && t.remove();
}
function $4fb7d97cf6fbcc21$var$N(e) {
    return e.querySelector(".".concat($4fb7d97cf6fbcc21$var$h.itemContent));
}
function $4fb7d97cf6fbcc21$var$E(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    var n = $4fb7d97cf6fbcc21$var$N(e);
    n && $4fb7d97cf6fbcc21$var$j.focus(n, t);
}
var $4fb7d97cf6fbcc21$var$z = /*#__PURE__*/ function() {
    "use strict";
    function z(param, l) {
        var t = param.data, n = param.config, r = param.api, i = param.readOnly, a = param.block;
        (0, $173N4._)(this, z);
        this.config = n, this.data = t, this.readOnly = i, this.api = r, this.block = a, this.renderer = l;
    }
    (0, $cFHGC._)(z, [
        {
            key: "currentItem",
            get: /**
   * Getter method to get current item
   * @returns current list item or null if caret position is not undefined
   */ function get() {
                var t = window.getSelection();
                if (!t) return null;
                var n = t.anchorNode;
                return !n || ($4fb7d97cf6fbcc21$var$O(n) || (n = n.parentNode), !n) || !$4fb7d97cf6fbcc21$var$O(n) ? null : n.closest(".".concat($4fb7d97cf6fbcc21$var$h.item));
            }
        },
        {
            key: "currentItemLevel",
            get: /**
   * Method that returns nesting level of the current item, null if there is no selection
   */ function get() {
                var t = this.currentItem;
                if (t === null) return null;
                var n = t.parentNode, r = 0;
                for(; n !== null && n !== this.listWrapper;)$4fb7d97cf6fbcc21$var$O(n) && n.classList.contains($4fb7d97cf6fbcc21$var$h.item) && (r += 1), n = n.parentNode;
                return r + 1;
            }
        },
        {
            /**
   * Function that is responsible for rendering list with contents
   * @returns Filled with content wrapper element of the list
   */ key: "render",
            value: function render() {
                var _this = this;
                return this.listWrapper = this.renderer.renderWrapper(!0), this.data.items.length ? this.appendItems(this.data.items, this.listWrapper) : this.appendItems([
                    {
                        content: "",
                        meta: {},
                        items: []
                    }
                ], this.listWrapper), this.readOnly || this.listWrapper.addEventListener("keydown", function(t) {
                    switch(t.key){
                        case "Enter":
                            t.shiftKey || _this.enterPressed(t);
                            break;
                        case "Backspace":
                            _this.backspace(t);
                            break;
                        case "Tab":
                            t.shiftKey ? _this.shiftTab(t) : _this.addTab(t);
                            break;
                    }
                }, !1), "start" in this.data.meta && this.data.meta.start !== void 0 && this.changeStartWith(this.data.meta.start), "counterType" in this.data.meta && this.data.meta.counterType !== void 0 && this.changeCounters(this.data.meta.counterType), this.listWrapper;
            }
        },
        {
            /**
   * Function that is responsible for list content saving
   * @param wrapper - optional argument wrapper
   * @returns whole list saved data if wrapper not passes, otherwise will return data of the passed wrapper
   */ key: "save",
            value: function save(t) {
                var _this = this;
                var n = t !== null && t !== void 0 ? t : this.listWrapper, r = function(l) {
                    return $4fb7d97cf6fbcc21$var$y(l).map(function(o) {
                        var d = $4fb7d97cf6fbcc21$var$C(o), u = _this.renderer.getItemContent(o), p = _this.renderer.getItemMeta(o), g = d ? r(d) : [];
                        return {
                            content: u,
                            meta: p,
                            items: g
                        };
                    });
                }, i = n ? r(n) : [];
                var a = {
                    style: this.data.style,
                    meta: {},
                    items: i
                };
                return this.data.style === "ordered" && (a.meta = {
                    start: this.data.meta.start,
                    counterType: this.data.meta.counterType
                }), a;
            }
        },
        {
            /**
   * Method that specified hot to merge two List blocks.
   * Called by Editor.js by backspace at the beginning of the Block
   *
   * Content of the first item of the next List would be merged with deepest item in current list
   * Other items of the next List would be appended to the current list without any changes in nesting levels
   * @param data - data of the second list to be merged with current
   */ key: "merge",
            value: function merge(t) {
                var n = this.block.holder.querySelectorAll(".".concat($4fb7d97cf6fbcc21$var$h.item)), r = n[n.length - 1], i = $4fb7d97cf6fbcc21$var$N(r);
                if (r === null || i === null || (i.insertAdjacentHTML("beforeend", t.items[0].content), this.listWrapper === void 0)) return;
                var a = $4fb7d97cf6fbcc21$var$y(this.listWrapper);
                if (a.length === 0) return;
                var l = a[a.length - 1];
                var s = $4fb7d97cf6fbcc21$var$C(l);
                var o = t.items.shift();
                o !== void 0 && (o.items.length !== 0 && (s === null && (s = this.renderer.renderWrapper(!1)), this.appendItems(o.items, s)), t.items.length > 0 && this.appendItems(t.items, this.listWrapper));
            }
        },
        {
            /**
   * On paste callback that is fired from Editor.
   * @param event - event with pasted data
   * @todo - refactor and move to list instance
   */ key: "onPaste",
            value: function onPaste(t) {
                var n = t.detail.data;
                this.data = this.pasteHandler(n);
                var r = this.listWrapper;
                r && r.parentNode && r.parentNode.replaceChild(this.render(), r);
            }
        },
        {
            /**
   * Handle UL, OL and LI tags paste and returns List data
   * @param element - html element that contains whole list
   * @todo - refactor and move to list instance
   */ key: "pasteHandler",
            value: function pasteHandler(t) {
                var n = t.tagName;
                var r = "unordered", i;
                switch(n){
                    case "OL":
                        r = "ordered", i = "ol";
                        break;
                    case "UL":
                    case "LI":
                        r = "unordered", i = "ul";
                }
                var a = {
                    style: r,
                    meta: {},
                    items: []
                };
                r === "ordered" && (this.data.meta.counterType = "numeric", this.data.meta.start = 1);
                var l = function(s) {
                    return Array.from(s.querySelectorAll(":scope > li")).map(function(d) {
                        var u = d.querySelector(":scope > ".concat(i)), p = u ? l(u) : [];
                        var _d_innerHTML;
                        return {
                            content: (_d_innerHTML = d.innerHTML) !== null && _d_innerHTML !== void 0 ? _d_innerHTML : "",
                            meta: {},
                            items: p
                        };
                    });
                };
                return a.items = l(t), a;
            }
        },
        {
            /**
   * Changes ordered list start property value
   * @param index - new value of the start property
   */ key: "changeStartWith",
            value: function changeStartWith(t) {
                this.listWrapper.style.setProperty("counter-reset", "item ".concat(t - 1)), this.data.meta.start = t;
            }
        },
        {
            /**
   * Changes ordered list counterType property value
   * @param counterType - new value of the counterType value
   */ key: "changeCounters",
            value: function changeCounters(t) {
                this.listWrapper.style.setProperty("--list-counter-type", t), this.data.meta.counterType = t;
            }
        },
        {
            /**
   * Handles Enter keypress
   * @param event - keydown
   */ key: "enterPressed",
            value: function enterPressed(t) {
                var s;
                var n = this.currentItem;
                if (t.stopPropagation(), t.preventDefault(), t.isComposing || n === null) return;
                var r = ((s = this.renderer) == null ? void 0 : s.getItemContent(n).trim().length) === 0, i = n.parentNode === this.listWrapper, a = n.previousElementSibling === null, l = this.api.blocks.getCurrentBlockIndex();
                if (i && r) {
                    if ($4fb7d97cf6fbcc21$var$lr(n) && !$4fb7d97cf6fbcc21$var$sr(n)) {
                        a ? this.convertItemToDefaultBlock(l, !0) : this.convertItemToDefaultBlock();
                        return;
                    } else {
                        this.splitList(n);
                        return;
                    }
                } else if (r) {
                    this.unshiftItem(n);
                    return;
                } else this.splitItem(n);
            }
        },
        {
            /**
   * Handle backspace
   * @param event - keydown
   */ key: "backspace",
            value: function backspace(t) {
                var r;
                var n = this.currentItem;
                if (n !== null && $4fb7d97cf6fbcc21$var$j.isCaretAtStartOfInput(n) && ((r = window.getSelection()) == null ? void 0 : r.isCollapsed) !== !1) {
                    if (t.stopPropagation(), n.parentNode === this.listWrapper && n.previousElementSibling === null) {
                        this.convertFirstItemToDefaultBlock();
                        return;
                    }
                    t.preventDefault(), this.mergeItemWithPrevious(n);
                }
            }
        },
        {
            /**
   * Reduce indentation for current item
   * @param event - keydown
   */ key: "shiftTab",
            value: function shiftTab(t) {
                t.stopPropagation(), t.preventDefault(), this.currentItem !== null && this.unshiftItem(this.currentItem);
            }
        },
        {
            /**
   * Decrease indentation of the passed item
   * @param item - list item to be unshifted
   */ key: "unshiftItem",
            value: function unshiftItem(t) {
                if (!t.parentNode || !$4fb7d97cf6fbcc21$var$O(t.parentNode)) return;
                var n = t.parentNode.closest(".".concat($4fb7d97cf6fbcc21$var$h.item));
                if (!n) return;
                var r = $4fb7d97cf6fbcc21$var$C(t);
                if (t.parentElement === null) return;
                var i = $4fb7d97cf6fbcc21$var$U(t);
                i !== null && (r === null && (r = this.renderer.renderWrapper(!1)), i.forEach(function(a) {
                    r.appendChild(a);
                }), t.appendChild(r)), n.after(t), $4fb7d97cf6fbcc21$var$E(t, !1), $4fb7d97cf6fbcc21$var$K(n);
            }
        },
        {
            /**
   * Method that is used for list splitting and moving trailing items to the new separated list
   * @param item - current item html element
   */ key: "splitList",
            value: function splitList(t) {
                var n = $4fb7d97cf6fbcc21$var$y(t), r = this.block, i = this.api.blocks.getCurrentBlockIndex();
                if (n.length !== 0) {
                    var o = n[0];
                    this.unshiftItem(o), $4fb7d97cf6fbcc21$var$E(t, !1);
                }
                if (t.previousElementSibling === null && t.parentNode === this.listWrapper) {
                    this.convertItemToDefaultBlock(i);
                    return;
                }
                var a = $4fb7d97cf6fbcc21$var$U(t);
                if (a === null) return;
                var l = this.renderer.renderWrapper(!0);
                a.forEach(function(o) {
                    l.appendChild(o);
                });
                var s = this.save(l);
                s.meta.start = this.data.style == "ordered" ? 1 : void 0, this.api.blocks.insert(r == null ? void 0 : r.name, s, this.config, i + 1), this.convertItemToDefaultBlock(i + 1), l.remove();
            }
        },
        {
            /**
   * Method that is used for splitting item content and moving trailing content to the new sibling item
   * @param currentItem - current item html element
   */ key: "splitItem",
            value: function splitItem(t) {
                var _j_getCaretNodeAndOffset = (0, $f9AOD._)($4fb7d97cf6fbcc21$var$j.getCaretNodeAndOffset(), 2), n = _j_getCaretNodeAndOffset[0], r = _j_getCaretNodeAndOffset[1];
                if (n === null) return;
                var i = $4fb7d97cf6fbcc21$var$N(t);
                var a;
                i === null ? a = "" : a = $4fb7d97cf6fbcc21$var$j.getContenteditableSlice(i, n, r, "right", !0);
                var l = $4fb7d97cf6fbcc21$var$C(t), s = this.renderItem(a);
                t == null || t.after(s), l && s.appendChild(l), $4fb7d97cf6fbcc21$var$E(s);
            }
        },
        {
            /**
   * Method that is used for merging current item with previous one
   * Content of the current item would be appended to the previous item
   * Current item children would not change nesting level
   * @param item - current item html element
   */ key: "mergeItemWithPrevious",
            value: function mergeItemWithPrevious(t) {
                var n = t.previousElementSibling, r = t.parentNode;
                if (r === null || !$4fb7d97cf6fbcc21$var$O(r)) return;
                var i = r.closest(".".concat($4fb7d97cf6fbcc21$var$h.item));
                if (!n && !i || n && !$4fb7d97cf6fbcc21$var$O(n)) return;
                var a;
                if (n) {
                    var p = $4fb7d97cf6fbcc21$var$y(n, !1);
                    p.length !== 0 && p.length !== 0 ? a = p[p.length - 1] : a = n;
                } else a = i;
                var l = this.renderer.getItemContent(t);
                if (!a) return;
                $4fb7d97cf6fbcc21$var$E(a, !1);
                var s = $4fb7d97cf6fbcc21$var$N(a);
                if (s === null) return;
                s.insertAdjacentHTML("beforeend", l);
                var o = $4fb7d97cf6fbcc21$var$y(t);
                if (o.length === 0) {
                    t.remove(), $4fb7d97cf6fbcc21$var$K(a);
                    return;
                }
                var _C;
                var d = n || i, u = (_C = $4fb7d97cf6fbcc21$var$C(d)) !== null && _C !== void 0 ? _C : this.renderer.renderWrapper(!1);
                n ? o.forEach(function(p) {
                    u.appendChild(p);
                }) : o.forEach(function(p) {
                    u.prepend(p);
                }), $4fb7d97cf6fbcc21$var$C(d) === null && a.appendChild(u), t.remove();
            }
        },
        {
            /**
   * Add indentation to current item
   * @param event - keydown
   */ key: "addTab",
            value: function addTab(t) {
                var a;
                t.stopPropagation(), t.preventDefault();
                var n = this.currentItem;
                if (!n) return;
                if (((a = this.config) == null ? void 0 : a.maxLevel) !== void 0) {
                    var l = this.currentItemLevel;
                    if (l !== null && l === this.config.maxLevel) return;
                }
                var r = n.previousSibling;
                if (r === null || !$4fb7d97cf6fbcc21$var$O(r)) return;
                var i = $4fb7d97cf6fbcc21$var$C(r);
                if (i) i.appendChild(n), $4fb7d97cf6fbcc21$var$y(n).forEach(function(s) {
                    i.appendChild(s);
                });
                else {
                    var l1 = this.renderer.renderWrapper(!1);
                    l1.appendChild(n), $4fb7d97cf6fbcc21$var$y(n).forEach(function(o) {
                        l1.appendChild(o);
                    }), r.appendChild(l1);
                }
                $4fb7d97cf6fbcc21$var$K(n), $4fb7d97cf6fbcc21$var$E(n, !1);
            }
        },
        {
            /**
   * Convert current item to default block with passed index
   * @param newBloxkIndex - optional parameter represents index, where would be inseted default block
   * @param removeList - optional parameter, that represents condition, if List should be removed
   */ key: "convertItemToDefaultBlock",
            value: function convertItemToDefaultBlock(t, n) {
                var r;
                var i = this.currentItem, a = i !== null ? this.renderer.getItemContent(i) : "";
                n === !0 && this.api.blocks.delete(), t !== void 0 ? r = this.api.blocks.insert(void 0, {
                    text: a
                }, void 0, t) : r = this.api.blocks.insert(), i == null || i.remove(), this.api.caret.setToBlock(r, "start");
            }
        },
        {
            /**
   * Convert first item of the list to default block
   * This method could be called when backspace button pressed at start of the first item of the list
   * First item of the list would be converted to the paragraph and first item children would be unshifted
   */ key: "convertFirstItemToDefaultBlock",
            value: function convertFirstItemToDefaultBlock() {
                var t = this.currentItem;
                if (t === null) return;
                var n = $4fb7d97cf6fbcc21$var$y(t);
                if (n.length !== 0) {
                    var l = n[0];
                    this.unshiftItem(l), $4fb7d97cf6fbcc21$var$E(t);
                }
                var r = $4fb7d97cf6fbcc21$var$U(t), i = this.api.blocks.getCurrentBlockIndex(), a = r === null;
                this.convertItemToDefaultBlock(i, a);
            }
        },
        {
            /**
   * Method that calls render function of the renderer with a necessary item meta cast
   * @param itemContent - content to be rendered in new item
   * @param meta - meta used in list item rendering
   * @returns html element of the rendered item
   */ key: "renderItem",
            value: function renderItem(t, n) {
                var r = n !== null && n !== void 0 ? n : this.renderer.composeDefaultMeta();
                switch(!0){
                    case this.renderer instanceof $4fb7d97cf6fbcc21$var$v:
                        return this.renderer.renderItem(t, r);
                    case this.renderer instanceof $4fb7d97cf6fbcc21$var$b:
                        return this.renderer.renderItem(t, r);
                    default:
                        return this.renderer.renderItem(t, r);
                }
            }
        },
        {
            /**
   * Renders children list
   * @param items - list data used in item rendering
   * @param parentElement - where to append passed items
   */ key: "appendItems",
            value: function appendItems(t, n) {
                var _this = this;
                t.forEach(function(r) {
                    var a;
                    var i = _this.renderItem(r.content, r.meta);
                    if (n.appendChild(i), r.items.length) {
                        var l = (a = _this.renderer) == null ? void 0 : a.renderWrapper(!1);
                        _this.appendItems(r.items, l), i.appendChild(l);
                    }
                });
            }
        }
    ], [
        {
            key: "pasteConfig",
            get: /**
   * On paste sanitzation config. Allow only tags that are allowed in the Tool.
   * @returns - config that determines tags supposted by paste handler
   * @todo - refactor and move to list instance
   */ function get() {
                return {
                    tags: [
                        "OL",
                        "UL",
                        "LI"
                    ]
                };
            }
        }
    ]);
    return z;
}();
var $4fb7d97cf6fbcc21$var$I = {
    wrapper: "".concat($4fb7d97cf6fbcc21$var$m, "-start-with-field"),
    input: "".concat($4fb7d97cf6fbcc21$var$m, "-start-with-field__input"),
    startWithElementWrapperInvalid: "".concat($4fb7d97cf6fbcc21$var$m, "-start-with-field--invalid")
};
function $4fb7d97cf6fbcc21$var$or(e, param) {
    var t = param.value, n = param.placeholder, r = param.attributes, i = param.sanitize;
    var a = $4fb7d97cf6fbcc21$var$c.make("div", $4fb7d97cf6fbcc21$var$I.wrapper), l = $4fb7d97cf6fbcc21$var$c.make("input", $4fb7d97cf6fbcc21$var$I.input, {
        placeholder: n,
        /**
     * Used to prevent focusing on the input by Tab key
     * (Popover in the Toolbar lays below the blocks,
     * so Tab in the last block will focus this hidden input if this property is not set)
     */ tabIndex: -1,
        /**
     * Value of the start property, if it is not specified, then it is set to one
     */ value: t
    });
    for(var s in r)l.setAttribute(s, r[s]);
    return a.appendChild(l), l.addEventListener("input", function() {
        i !== void 0 && (l.value = i(l.value));
        var s = l.checkValidity();
        !s && !a.classList.contains($4fb7d97cf6fbcc21$var$I.startWithElementWrapperInvalid) && a.classList.add($4fb7d97cf6fbcc21$var$I.startWithElementWrapperInvalid), s && a.classList.contains($4fb7d97cf6fbcc21$var$I.startWithElementWrapperInvalid) && a.classList.remove($4fb7d97cf6fbcc21$var$I.startWithElementWrapperInvalid), s && e(l.value);
    }), a;
}
var $4fb7d97cf6fbcc21$var$P = /* @__PURE__ */ new Map([
    /**
   * Value that represents default arabic numbers for counters
   */ [
        "Numeric",
        "numeric"
    ],
    /**
   * Value that represents lower roman numbers for counteres
   */ [
        "Lower Roman",
        "lower-roman"
    ],
    /**
   * Value that represents upper roman numbers for counters
   */ [
        "Upper Roman",
        "upper-roman"
    ],
    /**
   * Value that represents lower alpha characters for counters
   */ [
        "Lower Alpha",
        "lower-alpha"
    ],
    /**
   * Value that represents upper alpha characters for counters
   */ [
        "Upper Alpha",
        "upper-alpha"
    ]
]), $4fb7d97cf6fbcc21$var$He = /* @__PURE__ */ new Map([
    /**
   * Value that represents Icon for Numeric counter type
   */ [
        "numeric",
        $4fb7d97cf6fbcc21$var$St
    ],
    /**
   * Value that represents Icon for Lower Roman counter type
   */ [
        "lower-roman",
        $4fb7d97cf6fbcc21$var$Ot
    ],
    /**
   * Value that represents Icon for Upper Roman counter type
   */ [
        "upper-roman",
        $4fb7d97cf6fbcc21$var$kt
    ],
    /**
   * Value that represents Icon for Lower Alpha counter type
   */ [
        "lower-alpha",
        $4fb7d97cf6fbcc21$var$Et
    ],
    /**
   * Value that represents Icon for Upper Alpha counter type
   */ [
        "upper-alpha",
        $4fb7d97cf6fbcc21$var$_t
    ]
]);
function $4fb7d97cf6fbcc21$var$ur(e) {
    return e.replace(/\D+/g, "");
}
function $4fb7d97cf6fbcc21$var$cr(e) {
    return typeof e.items[0] == "string";
}
function $4fb7d97cf6fbcc21$var$dr(e) {
    return !("meta" in e);
}
function $4fb7d97cf6fbcc21$var$fr(e) {
    return typeof e.items[0] != "string" && "text" in e.items[0] && "checked" in e.items[0] && typeof e.items[0].text == "string" && typeof e.items[0].checked == "boolean";
}
function $4fb7d97cf6fbcc21$var$pr(e) {
    var t = [];
    return $4fb7d97cf6fbcc21$var$cr(e) ? (e.items.forEach(function(n) {
        t.push({
            content: n,
            meta: {},
            items: []
        });
    }), {
        style: e.style,
        meta: {},
        items: t
    }) : $4fb7d97cf6fbcc21$var$fr(e) ? (e.items.forEach(function(n) {
        t.push({
            content: n.text,
            meta: {
                checked: n.checked
            },
            items: []
        });
    }), {
        style: "checklist",
        meta: {},
        items: t
    }) : $4fb7d97cf6fbcc21$var$dr(e) ? {
        style: e.style,
        meta: {},
        items: e.items
    } : structuredClone(e);
}
var $4fb7d97cf6fbcc21$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function G(param) {
        var t = param.data, n = param.config, r = param.api, i = param.readOnly, a = param.block;
        (0, $173N4._)(this, G);
        var s;
        this.api = r, this.readOnly = i, this.config = n, this.block = a, this.defaultListStyle = ((s = this.config) == null ? void 0 : s.defaultStyle) || "unordered", this.defaultCounterTypes = this.config.counterTypes || Array.from($4fb7d97cf6fbcc21$var$P.values());
        var l = {
            style: this.defaultListStyle,
            meta: {},
            items: []
        };
        this.data = Object.keys(t).length ? $4fb7d97cf6fbcc21$var$pr(t) : l, this.listStyle === "ordered" && this.data.meta.counterType === void 0 && (this.data.meta.counterType = "numeric"), this.changeTabulatorByStyle();
    }
    (0, $cFHGC._)(G, [
        {
            key: "listStyle",
            get: /**
   * Get list style name
   */ function get() {
                return this.data.style || this.defaultListStyle;
            },
            set: /**
   * Set list style
   * @param style - new style to set
   */ function set(t) {
                var r;
                this.data.style = t, this.changeTabulatorByStyle();
                var n = this.list.render();
                (r = this.listElement) == null || r.replaceWith(n), this.listElement = n;
            }
        },
        {
            /**
   * Function that is responsible for content rendering
   * @returns rendered list wrapper with all contents
   */ key: "render",
            value: function render() {
                return this.listElement = this.list.render(), this.listElement;
            }
        },
        {
            /**
   * Function that is responsible for content saving
   * @returns formatted content used in editor
   */ key: "save",
            value: function save() {
                return this.data = this.list.save(), this.data;
            }
        },
        {
            /**
   * Function that is responsible for mergind two lists into one
   * @param data - data of the next standing list, that should be merged with current
   */ key: "merge",
            value: function merge(t) {
                this.list.merge(t);
            }
        },
        {
            /**
   * Creates Block Tune allowing to change the list style
   * @returns array of tune configs
   */ key: "renderSettings",
            value: function renderSettings() {
                var _this = this;
                var t = [
                    {
                        label: this.api.i18n.t("Unordered"),
                        icon: $4fb7d97cf6fbcc21$var$$e,
                        closeOnActivate: !0,
                        isActive: this.listStyle == "unordered",
                        onActivate: function() {
                            _this.listStyle = "unordered";
                        }
                    },
                    {
                        label: this.api.i18n.t("Ordered"),
                        icon: $4fb7d97cf6fbcc21$var$Be,
                        closeOnActivate: !0,
                        isActive: this.listStyle == "ordered",
                        onActivate: function() {
                            _this.listStyle = "ordered";
                        }
                    },
                    {
                        label: this.api.i18n.t("Checklist"),
                        icon: $4fb7d97cf6fbcc21$var$Ae,
                        closeOnActivate: !0,
                        isActive: this.listStyle == "checklist",
                        onActivate: function() {
                            _this.listStyle = "checklist";
                        }
                    }
                ];
                if (this.listStyle === "ordered") {
                    var _t;
                    var _this_data_meta_start;
                    var n = $4fb7d97cf6fbcc21$var$or(function(a) {
                        return _this.changeStartWith(Number(a));
                    }, {
                        value: String((_this_data_meta_start = this.data.meta.start) !== null && _this_data_meta_start !== void 0 ? _this_data_meta_start : 1),
                        placeholder: "",
                        attributes: {
                            required: "true"
                        },
                        sanitize: function(a) {
                            return $4fb7d97cf6fbcc21$var$ur(a);
                        }
                    }), r = [
                        {
                            label: this.api.i18n.t("Start with"),
                            icon: $4fb7d97cf6fbcc21$var$It,
                            children: {
                                items: [
                                    {
                                        element: n,
                                        // @ts-expect-error ts(2820) can not use PopoverItem enum from editor.js types
                                        type: "html"
                                    }
                                ]
                            }
                        }
                    ], i = {
                        label: this.api.i18n.t("Counter type"),
                        icon: $4fb7d97cf6fbcc21$var$He.get(this.data.meta.counterType),
                        children: {
                            items: []
                        }
                    };
                    $4fb7d97cf6fbcc21$var$P.forEach(function(a, l) {
                        var s = $4fb7d97cf6fbcc21$var$P.get(l);
                        _this.defaultCounterTypes.includes(s) && i.children.items.push({
                            title: _this.api.i18n.t(l),
                            icon: $4fb7d97cf6fbcc21$var$He.get(s),
                            isActive: _this.data.meta.counterType === $4fb7d97cf6fbcc21$var$P.get(l),
                            closeOnActivate: !0,
                            onActivate: function() {
                                _this.changeCounters($4fb7d97cf6fbcc21$var$P.get(l));
                            }
                        });
                    }), i.children.items.length > 1 && r.push(i), (_t = t).push.apply(_t, [
                        {
                            type: "separator"
                        }
                    ].concat((0, $aUGqu._)(r)));
                }
                return t;
            }
        },
        {
            /**
   * On paste callback that is fired from Editor.
   * @param event - event with pasted data
   */ key: "onPaste",
            value: function onPaste(t) {
                var _t_detail_data = t.detail.data, n = _t_detail_data.tagName;
                switch(n){
                    case "OL":
                        this.listStyle = "ordered";
                        break;
                    case "UL":
                    case "LI":
                        this.listStyle = "unordered";
                }
                this.list.onPaste(t);
            }
        },
        {
            /**
   * Handle UL, OL and LI tags paste and returns List data
   * @param element - html element that contains whole list
   */ key: "pasteHandler",
            value: function pasteHandler(t) {
                return this.list.pasteHandler(t);
            }
        },
        {
            /**
   * Changes ordered list counterType property value
   * @param counterType - new value of the counterType value
   */ key: "changeCounters",
            value: function changeCounters(t) {
                var n;
                (n = this.list) == null || n.changeCounters(t), this.data.meta.counterType = t;
            }
        },
        {
            /**
   * Changes ordered list start property value
   * @param index - new value of the start property
   */ key: "changeStartWith",
            value: function changeStartWith(t) {
                var n;
                (n = this.list) == null || n.changeStartWith(t), this.data.meta.start = t;
            }
        },
        {
            /**
   * This method allows changing tabulator respectfully to passed style
   */ key: "changeTabulatorByStyle",
            value: function changeTabulatorByStyle() {
                switch(this.listStyle){
                    case "ordered":
                        this.list = new $4fb7d97cf6fbcc21$var$z({
                            data: this.data,
                            readOnly: this.readOnly,
                            api: this.api,
                            config: this.config,
                            block: this.block
                        }, new $4fb7d97cf6fbcc21$var$v(this.readOnly, this.config));
                        break;
                    case "unordered":
                        this.list = new $4fb7d97cf6fbcc21$var$z({
                            data: this.data,
                            readOnly: this.readOnly,
                            api: this.api,
                            config: this.config,
                            block: this.block
                        }, new $4fb7d97cf6fbcc21$var$b(this.readOnly, this.config));
                        break;
                    case "checklist":
                        this.list = new $4fb7d97cf6fbcc21$var$z({
                            data: this.data,
                            readOnly: this.readOnly,
                            api: this.api,
                            config: this.config,
                            block: this.block
                        }, new $4fb7d97cf6fbcc21$var$f(this.readOnly, this.config));
                        break;
                }
            }
        }
    ], [
        {
            key: "isReadOnlySupported",
            get: /**
   * Notify core that read-only mode is supported
   */ function get() {
                return !0;
            }
        },
        {
            key: "enableLineBreaks",
            get: /**
   * Allow to use native Enter behaviour
   */ function get() {
                return !0;
            }
        },
        {
            key: "toolbox",
            get: /**
   * Get Tool toolbox settings
   * icon - Tool icon's SVG
   * title - title to show in toolbox
   */ function get() {
                return [
                    {
                        icon: $4fb7d97cf6fbcc21$var$$e,
                        title: "Unordered List",
                        data: {
                            style: "unordered"
                        }
                    },
                    {
                        icon: $4fb7d97cf6fbcc21$var$Be,
                        title: "Ordered List",
                        data: {
                            style: "ordered"
                        }
                    },
                    {
                        icon: $4fb7d97cf6fbcc21$var$Ae,
                        title: "Checklist",
                        data: {
                            style: "checklist"
                        }
                    }
                ];
            }
        },
        {
            key: "pasteConfig",
            get: /**
   * On paste sanitzation config. Allow only tags that are allowed in the Tool.
   * @returns - paste config object used in editor
   */ function get() {
                return {
                    tags: [
                        "OL",
                        "UL",
                        "LI"
                    ]
                };
            }
        },
        {
            key: "conversionConfig",
            get: /**
   * Convert from text to list with import and export list to text
   */ function get() {
                return {
                    export: function(t) {
                        return G.joinRecursive(t);
                    },
                    import: function(t, n) {
                        return {
                            meta: {},
                            items: [
                                {
                                    content: t,
                                    meta: {},
                                    items: []
                                }
                            ],
                            style: (n == null ? void 0 : n.defaultStyle) !== void 0 ? n.defaultStyle : "unordered"
                        };
                    }
                };
            }
        },
        {
            key: "joinRecursive",
            value: /**
   * Convert from list to text for conversionConfig
   * @param data - current data of the list
   * @returns - string of the recursively merged contents of the items of the list
   */ function joinRecursive(t) {
                return t.items.map(function(n) {
                    return "".concat(n.content, " ").concat(G.joinRecursive(n));
                }).join("");
            }
        }
    ]);
    return G;
}();



var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7Pjls = parcelRequire("7Pjls");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");
(function() {
    "use strict";
    try {
        if ((typeof document === "undefined" ? "undefined" : (0, $7E0eS._)(document)) < "u") {
            var t = document.createElement("style");
            t.appendChild(document.createTextNode(".cdx-quote-icon svg{transform:rotate(180deg)}.cdx-quote{margin:0}.cdx-quote__text{min-height:158px;margin-bottom:10px}.cdx-quote [contentEditable=true][data-placeholder]:before{position:absolute;content:attr(data-placeholder);color:#707684;font-weight:400;opacity:0}.cdx-quote [contentEditable=true][data-placeholder]:empty:before{opacity:1}.cdx-quote [contentEditable=true][data-placeholder]:empty:focus:before{opacity:0}.cdx-quote-settings{display:flex}.cdx-quote-settings .cdx-settings-button{width:50%}")), document.head.appendChild(t);
        }
    } catch (e) {
        console.error("vite-plugin-css-injected-by-js", e);
    }
})();
var $37cba7abb96b869a$var$De = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M18 7L6 7"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M18 17H6"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16 12L8 12"/></svg>', $37cba7abb96b869a$var$He = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M17 7L5 7"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M17 17H5"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M13 12L5 12"/></svg>', $37cba7abb96b869a$var$Re = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 10.8182L9 10.8182C8.80222 10.8182 8.60888 10.7649 8.44443 10.665C8.27998 10.5651 8.15181 10.4231 8.07612 10.257C8.00043 10.0909 7.98063 9.90808 8.01922 9.73174C8.0578 9.55539 8.15304 9.39341 8.29289 9.26627C8.43275 9.13913 8.61093 9.05255 8.80491 9.01747C8.99889 8.98239 9.19996 9.00039 9.38268 9.0692C9.56541 9.13801 9.72159 9.25453 9.83147 9.40403C9.94135 9.55353 10 9.72929 10 9.90909L10 12.1818C10 12.664 9.78929 13.1265 9.41421 13.4675C9.03914 13.8084 8.53043 14 8 14"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 10.8182L15 10.8182C14.8022 10.8182 14.6089 10.7649 14.4444 10.665C14.28 10.5651 14.1518 10.4231 14.0761 10.257C14.0004 10.0909 13.9806 9.90808 14.0192 9.73174C14.0578 9.55539 14.153 9.39341 14.2929 9.26627C14.4327 9.13913 14.6109 9.05255 14.8049 9.01747C14.9989 8.98239 15.2 9.00039 15.3827 9.0692C15.5654 9.13801 15.7216 9.25453 15.8315 9.40403C15.9414 9.55353 16 9.72929 16 9.90909L16 12.1818C16 12.664 15.7893 13.1265 15.4142 13.4675C15.0391 13.8084 14.5304 14 14 14"/></svg>';
var $37cba7abb96b869a$var$b = (typeof globalThis === "undefined" ? "undefined" : (0, $7E0eS._)(globalThis)) < "u" ? globalThis : (typeof window === "undefined" ? "undefined" : (0, $7E0eS._)(window)) < "u" ? window : (typeof $parcel$global === "undefined" ? "undefined" : (0, $7E0eS._)($parcel$global)) < "u" ? $parcel$global : (typeof self === "undefined" ? "undefined" : (0, $7E0eS._)(self)) < "u" ? self : {};
function $37cba7abb96b869a$var$Fe(e) {
    if (e.__esModule) return e;
    var t = e.default;
    if (typeof t == "function") {
        var n = function r() {
            return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
        };
        n.prototype = t.prototype;
    } else n = {};
    return Object.defineProperty(n, "__esModule", {
        value: !0
    }), Object.keys(e).forEach(function(r) {
        var i = Object.getOwnPropertyDescriptor(e, r);
        Object.defineProperty(n, r, i.get ? i : {
            enumerable: !0,
            get: function get() {
                return e[r];
            }
        });
    }), n;
}
var $37cba7abb96b869a$var$v = {}, $37cba7abb96b869a$var$P = {}, $37cba7abb96b869a$var$j = {};
Object.defineProperty($37cba7abb96b869a$var$j, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$j.allInputsSelector = $37cba7abb96b869a$var$We;
function $37cba7abb96b869a$var$We() {
    var e = [
        "text",
        "password",
        "email",
        "number",
        "search",
        "tel",
        "url"
    ];
    return "[contenteditable=true], textarea, input:not([type]), " + e.map(function(t) {
        return 'input[type="'.concat(t, '"]');
    }).join(", ");
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.allInputsSelector = void 0;
    var t = $37cba7abb96b869a$var$j;
    Object.defineProperty(e, "allInputsSelector", {
        enumerable: !0,
        get: function get() {
            return t.allInputsSelector;
        }
    });
})($37cba7abb96b869a$var$P);
var $37cba7abb96b869a$var$c = {}, $37cba7abb96b869a$var$T = {};
Object.defineProperty($37cba7abb96b869a$var$T, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$T.isNativeInput = $37cba7abb96b869a$var$Ue;
function $37cba7abb96b869a$var$Ue(e) {
    var t = [
        "INPUT",
        "TEXTAREA"
    ];
    return e && e.tagName ? t.includes(e.tagName) : !1;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isNativeInput = void 0;
    var t = $37cba7abb96b869a$var$T;
    Object.defineProperty(e, "isNativeInput", {
        enumerable: !0,
        get: function get() {
            return t.isNativeInput;
        }
    });
})($37cba7abb96b869a$var$c);
var $37cba7abb96b869a$var$ie = {}, $37cba7abb96b869a$var$C = {};
Object.defineProperty($37cba7abb96b869a$var$C, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$C.append = $37cba7abb96b869a$var$qe;
function $37cba7abb96b869a$var$qe(e, t) {
    Array.isArray(t) ? t.forEach(function(n) {
        e.appendChild(n);
    }) : e.appendChild(t);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.append = void 0;
    var t = $37cba7abb96b869a$var$C;
    Object.defineProperty(e, "append", {
        enumerable: !0,
        get: function get() {
            return t.append;
        }
    });
})($37cba7abb96b869a$var$ie);
var $37cba7abb96b869a$var$L = {}, $37cba7abb96b869a$var$S = {};
Object.defineProperty($37cba7abb96b869a$var$S, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$S.blockElements = $37cba7abb96b869a$var$ze;
function $37cba7abb96b869a$var$ze() {
    return [
        "address",
        "article",
        "aside",
        "blockquote",
        "canvas",
        "div",
        "dl",
        "dt",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "hgroup",
        "hr",
        "li",
        "main",
        "nav",
        "noscript",
        "ol",
        "output",
        "p",
        "pre",
        "ruby",
        "section",
        "table",
        "tbody",
        "thead",
        "tr",
        "tfoot",
        "ul",
        "video"
    ];
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.blockElements = void 0;
    var t = $37cba7abb96b869a$var$S;
    Object.defineProperty(e, "blockElements", {
        enumerable: !0,
        get: function get() {
            return t.blockElements;
        }
    });
})($37cba7abb96b869a$var$L);
var $37cba7abb96b869a$var$ae = {}, $37cba7abb96b869a$var$M = {};
Object.defineProperty($37cba7abb96b869a$var$M, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$M.calculateBaseline = $37cba7abb96b869a$var$Ge;
function $37cba7abb96b869a$var$Ge(e) {
    var t = window.getComputedStyle(e), n = parseFloat(t.fontSize), r = parseFloat(t.lineHeight) || n * 1.2, i = parseFloat(t.paddingTop), a = parseFloat(t.borderTopWidth), l = parseFloat(t.marginTop), u = n * 0.8, d = (r - n) / 2, s = l + a + i + d + u;
    return s;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.calculateBaseline = void 0;
    var t = $37cba7abb96b869a$var$M;
    Object.defineProperty(e, "calculateBaseline", {
        enumerable: !0,
        get: function get() {
            return t.calculateBaseline;
        }
    });
})($37cba7abb96b869a$var$ae);
var $37cba7abb96b869a$var$le = {}, $37cba7abb96b869a$var$k = {}, $37cba7abb96b869a$var$w = {}, $37cba7abb96b869a$var$N = {};
Object.defineProperty($37cba7abb96b869a$var$N, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$N.isContentEditable = $37cba7abb96b869a$var$Ke;
function $37cba7abb96b869a$var$Ke(e) {
    return e.contentEditable === "true";
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isContentEditable = void 0;
    var t = $37cba7abb96b869a$var$N;
    Object.defineProperty(e, "isContentEditable", {
        enumerable: !0,
        get: function get() {
            return t.isContentEditable;
        }
    });
})($37cba7abb96b869a$var$w);
Object.defineProperty($37cba7abb96b869a$var$k, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$k.canSetCaret = $37cba7abb96b869a$var$Qe;
var $37cba7abb96b869a$var$Xe = $37cba7abb96b869a$var$c, $37cba7abb96b869a$var$Ye = $37cba7abb96b869a$var$w;
function $37cba7abb96b869a$var$Qe(e) {
    var t = !0;
    if ((0, $37cba7abb96b869a$var$Xe.isNativeInput)(e)) switch(e.type){
        case "file":
        case "checkbox":
        case "radio":
        case "hidden":
        case "submit":
        case "button":
        case "image":
        case "reset":
            t = !1;
            break;
    }
    else t = (0, $37cba7abb96b869a$var$Ye.isContentEditable)(e);
    return t;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.canSetCaret = void 0;
    var t = $37cba7abb96b869a$var$k;
    Object.defineProperty(e, "canSetCaret", {
        enumerable: !0,
        get: function get() {
            return t.canSetCaret;
        }
    });
})($37cba7abb96b869a$var$le);
var $37cba7abb96b869a$var$y = {}, $37cba7abb96b869a$var$I = {};
function $37cba7abb96b869a$var$Ve(e, t, n) {
    var r = n.value !== void 0 ? "value" : "get", i = n[r], a = "#".concat(t, "Cache");
    if (n[r] = function() {
        for(var _len = arguments.length, l = new Array(_len), _key = 0; _key < _len; _key++){
            l[_key] = arguments[_key];
        }
        return this[a] === void 0 && (this[a] = i.apply(this, l)), this[a];
    }, r === "get" && n.set) {
        var l = n.set;
        n.set = function(u) {
            delete e[a], l.apply(this, u);
        };
    }
    return n;
}
function $37cba7abb96b869a$var$ue() {
    var e = {
        win: !1,
        mac: !1,
        x11: !1,
        linux: !1
    }, t = Object.keys(e).find(function(n) {
        return window.navigator.appVersion.toLowerCase().indexOf(n) !== -1;
    });
    return t !== void 0 && (e[t] = !0), e;
}
function $37cba7abb96b869a$var$A(e) {
    return e != null && e !== "" && ((typeof e === "undefined" ? "undefined" : (0, $7E0eS._)(e)) != "object" || Object.keys(e).length > 0);
}
function $37cba7abb96b869a$var$Ze(e) {
    return !$37cba7abb96b869a$var$A(e);
}
var $37cba7abb96b869a$var$Je = function() {
    return (typeof window === "undefined" ? "undefined" : (0, $7E0eS._)(window)) < "u" && window.navigator !== null && $37cba7abb96b869a$var$A(window.navigator.platform) && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
};
function $37cba7abb96b869a$var$xe(e) {
    var t = $37cba7abb96b869a$var$ue();
    return e = e.replace(/shift/gi, "\u21E7").replace(/backspace/gi, "\u232B").replace(/enter/gi, "\u23CE").replace(/up/gi, "\u2191").replace(/left/gi, "\u2192").replace(/down/gi, "\u2193").replace(/right/gi, "\u2190").replace(/escape/gi, "\u238B").replace(/insert/gi, "Ins").replace(/delete/gi, "\u2421").replace(/\+/gi, "+"), t.mac ? e = e.replace(/ctrl|cmd/gi, "\u2318").replace(/alt/gi, "\u2325") : e = e.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), e;
}
function $37cba7abb96b869a$var$et(e) {
    return e[0].toUpperCase() + e.slice(1);
}
function $37cba7abb96b869a$var$tt(e) {
    var t = document.createElement("div");
    t.style.position = "absolute", t.style.left = "-999px", t.style.bottom = "-999px", t.innerHTML = e, document.body.appendChild(t);
    var n = window.getSelection(), r = document.createRange();
    if (r.selectNode(t), n === null) throw new Error("Cannot copy text to clipboard");
    n.removeAllRanges(), n.addRange(r), document.execCommand("copy"), document.body.removeChild(t);
}
function $37cba7abb96b869a$var$nt(e, t, n) {
    var _this = this;
    var r;
    return function() {
        for(var _len = arguments.length, i = new Array(_len), _key = 0; _key < _len; _key++){
            i[_key] = arguments[_key];
        }
        var a = _this, l = function() {
            r = void 0, n !== !0 && e.apply(a, i);
        }, u = n === !0 && r !== void 0;
        window.clearTimeout(r), r = window.setTimeout(l, t), u && e.apply(a, i);
    };
}
function $37cba7abb96b869a$var$o(e) {
    return Object.prototype.toString.call(e).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $37cba7abb96b869a$var$rt(e) {
    return $37cba7abb96b869a$var$o(e) === "boolean";
}
function $37cba7abb96b869a$var$oe(e) {
    return $37cba7abb96b869a$var$o(e) === "function" || $37cba7abb96b869a$var$o(e) === "asyncfunction";
}
function $37cba7abb96b869a$var$it(e) {
    return $37cba7abb96b869a$var$oe(e) && /^\s*class\s+/.test(e.toString());
}
function $37cba7abb96b869a$var$at(e) {
    return $37cba7abb96b869a$var$o(e) === "number";
}
function $37cba7abb96b869a$var$g(e) {
    return $37cba7abb96b869a$var$o(e) === "object";
}
function $37cba7abb96b869a$var$lt(e) {
    return Promise.resolve(e) === e;
}
function $37cba7abb96b869a$var$ut(e) {
    return $37cba7abb96b869a$var$o(e) === "string";
}
function $37cba7abb96b869a$var$ot(e) {
    return $37cba7abb96b869a$var$o(e) === "undefined";
}
function $37cba7abb96b869a$var$O(e) {
    for(var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        t[_key - 1] = arguments[_key];
    }
    if (!t.length) return e;
    var n = t.shift();
    if ($37cba7abb96b869a$var$g(e) && $37cba7abb96b869a$var$g(n)) for(var r in n)$37cba7abb96b869a$var$g(n[r]) ? (e[r] === void 0 && Object.assign(e, (0, $7Pjls._)({}, r, {})), $37cba7abb96b869a$var$O(e[r], n[r])) : Object.assign(e, (0, $7Pjls._)({}, r, n[r]));
    return $37cba7abb96b869a$var$O.apply(void 0, [
        e
    ].concat((0, $aUGqu._)(t)));
}
function $37cba7abb96b869a$var$st(e, t, n) {
    var r = "\xab".concat(t, "\xbb is deprecated and will be removed in the next major release. Please use the \xab").concat(n, "\xbb instead.");
    e && console.warn(r);
}
function $37cba7abb96b869a$var$ct(e) {
    try {
        return new URL(e).href;
    } catch (e) {}
    return e.substring(0, 2) === "//" ? window.location.protocol + e : window.location.origin + e;
}
function $37cba7abb96b869a$var$dt(e) {
    return e > 47 && e < 58 || e === 32 || e === 13 || e === 229 || e > 64 && e < 91 || e > 95 && e < 112 || e > 185 && e < 193 || e > 218 && e < 223;
}
var $37cba7abb96b869a$var$ft = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    DELETE: 46,
    META: 91,
    SLASH: 191
}, $37cba7abb96b869a$var$pt = {
    LEFT: 0,
    WHEEL: 1,
    RIGHT: 2,
    BACKWARD: 3,
    FORWARD: 4
};
var $37cba7abb96b869a$var$vt = /*#__PURE__*/ function() {
    "use strict";
    function vt() {
        (0, $173N4._)(this, vt);
        this.completed = Promise.resolve();
    }
    (0, $cFHGC._)(vt, [
        {
            /**
   * Add new promise to queue
   * @param operation - promise should be added to queue
   */ key: "add",
            value: function add(t) {
                var _this = this;
                return new Promise(function(n, r) {
                    _this.completed = _this.completed.then(t).then(n).catch(r);
                });
            }
        }
    ]);
    return vt;
}();
function $37cba7abb96b869a$var$gt(e, t, n) {
    var r, i, a, l = null, u = 0;
    n || (n = {});
    var d = function d() {
        u = n.leading === !1 ? 0 : Date.now(), l = null, a = e.apply(r, i), l === null && (r = i = null);
    };
    return function() {
        var s = Date.now();
        !u && n.leading === !1 && (u = s);
        var f = t - (s - u);
        return r = this, i = arguments, f <= 0 || f > t ? (l && (clearTimeout(l), l = null), u = s, a = e.apply(r, i), l === null && (r = i = null)) : !l && n.trailing !== !1 && (l = setTimeout(d, f)), a;
    };
}
var $37cba7abb96b869a$var$mt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    PromiseQueue: $37cba7abb96b869a$var$vt,
    beautifyShortcut: $37cba7abb96b869a$var$xe,
    cacheable: $37cba7abb96b869a$var$Ve,
    capitalize: $37cba7abb96b869a$var$et,
    copyTextToClipboard: $37cba7abb96b869a$var$tt,
    debounce: $37cba7abb96b869a$var$nt,
    deepMerge: $37cba7abb96b869a$var$O,
    deprecationAssert: $37cba7abb96b869a$var$st,
    getUserOS: $37cba7abb96b869a$var$ue,
    getValidUrl: $37cba7abb96b869a$var$ct,
    isBoolean: $37cba7abb96b869a$var$rt,
    isClass: $37cba7abb96b869a$var$it,
    isEmpty: $37cba7abb96b869a$var$Ze,
    isFunction: $37cba7abb96b869a$var$oe,
    isIosDevice: $37cba7abb96b869a$var$Je,
    isNumber: $37cba7abb96b869a$var$at,
    isObject: $37cba7abb96b869a$var$g,
    isPrintableKey: $37cba7abb96b869a$var$dt,
    isPromise: $37cba7abb96b869a$var$lt,
    isString: $37cba7abb96b869a$var$ut,
    isUndefined: $37cba7abb96b869a$var$ot,
    keyCodes: $37cba7abb96b869a$var$ft,
    mouseButtons: $37cba7abb96b869a$var$pt,
    notEmpty: $37cba7abb96b869a$var$A,
    throttle: $37cba7abb96b869a$var$gt,
    typeOf: $37cba7abb96b869a$var$o
}, Symbol.toStringTag, {
    value: "Module"
})), $37cba7abb96b869a$var$$ = /* @__PURE__ */ $37cba7abb96b869a$var$Fe($37cba7abb96b869a$var$mt);
Object.defineProperty($37cba7abb96b869a$var$I, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$I.containsOnlyInlineElements = $37cba7abb96b869a$var$_t;
var $37cba7abb96b869a$var$bt = $37cba7abb96b869a$var$$, $37cba7abb96b869a$var$yt = $37cba7abb96b869a$var$L;
function $37cba7abb96b869a$var$_t(e) {
    var t;
    (0, $37cba7abb96b869a$var$bt.isString)(e) ? (t = document.createElement("div"), t.innerHTML = e) : t = e;
    var n = function n1(r) {
        return !(0, $37cba7abb96b869a$var$yt.blockElements)().includes(r.tagName.toLowerCase()) && Array.from(r.children).every(n);
    };
    return Array.from(t.children).every(n);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.containsOnlyInlineElements = void 0;
    var t = $37cba7abb96b869a$var$I;
    Object.defineProperty(e, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function get() {
            return t.containsOnlyInlineElements;
        }
    });
})($37cba7abb96b869a$var$y);
var $37cba7abb96b869a$var$se = {}, $37cba7abb96b869a$var$B = {}, $37cba7abb96b869a$var$_ = {}, $37cba7abb96b869a$var$D = {};
Object.defineProperty($37cba7abb96b869a$var$D, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$D.make = $37cba7abb96b869a$var$ht;
function $37cba7abb96b869a$var$ht(e, t, n) {
    var r;
    t === void 0 && (t = null), n === void 0 && (n = {});
    var i = document.createElement(e);
    if (Array.isArray(t)) {
        var a = t.filter(function(u) {
            return u !== void 0;
        });
        (r = i.classList).add.apply(r, a);
    } else t !== null && i.classList.add(t);
    for(var l in n)Object.prototype.hasOwnProperty.call(n, l) && (i[l] = n[l]);
    return i;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.make = void 0;
    var t = $37cba7abb96b869a$var$D;
    Object.defineProperty(e, "make", {
        enumerable: !0,
        get: function get() {
            return t.make;
        }
    });
})($37cba7abb96b869a$var$_);
Object.defineProperty($37cba7abb96b869a$var$B, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$B.fragmentToString = $37cba7abb96b869a$var$Ot;
var $37cba7abb96b869a$var$Et = $37cba7abb96b869a$var$_;
function $37cba7abb96b869a$var$Ot(e) {
    var t = (0, $37cba7abb96b869a$var$Et.make)("div");
    return t.appendChild(e), t.innerHTML;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.fragmentToString = void 0;
    var t = $37cba7abb96b869a$var$B;
    Object.defineProperty(e, "fragmentToString", {
        enumerable: !0,
        get: function get() {
            return t.fragmentToString;
        }
    });
})($37cba7abb96b869a$var$se);
var $37cba7abb96b869a$var$ce = {}, $37cba7abb96b869a$var$H = {};
Object.defineProperty($37cba7abb96b869a$var$H, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$H.getContentLength = $37cba7abb96b869a$var$jt;
var $37cba7abb96b869a$var$Pt = $37cba7abb96b869a$var$c;
function $37cba7abb96b869a$var$jt(e) {
    var t, n;
    return (0, $37cba7abb96b869a$var$Pt.isNativeInput)(e) ? e.value.length : e.nodeType === Node.TEXT_NODE ? e.length : (n = (t = e.textContent) === null || t === void 0 ? void 0 : t.length) !== null && n !== void 0 ? n : 0;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getContentLength = void 0;
    var t = $37cba7abb96b869a$var$H;
    Object.defineProperty(e, "getContentLength", {
        enumerable: !0,
        get: function get() {
            return t.getContentLength;
        }
    });
})($37cba7abb96b869a$var$ce);
var $37cba7abb96b869a$var$R = {}, $37cba7abb96b869a$var$F = {}, $37cba7abb96b869a$var$re = $37cba7abb96b869a$var$b && $37cba7abb96b869a$var$b.__spreadArray || function(e, t, n) {
    if (n || arguments.length === 2) for(var r = 0, i = t.length, a; r < i; r++)(a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
    return e.concat(a || Array.prototype.slice.call(t));
};
Object.defineProperty($37cba7abb96b869a$var$F, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$F.getDeepestBlockElements = $37cba7abb96b869a$var$de;
var $37cba7abb96b869a$var$Tt = $37cba7abb96b869a$var$y;
function $37cba7abb96b869a$var$de(e) {
    return (0, $37cba7abb96b869a$var$Tt.containsOnlyInlineElements)(e) ? [
        e
    ] : Array.from(e.children).reduce(function(t, n) {
        return $37cba7abb96b869a$var$re($37cba7abb96b869a$var$re([], t, !0), $37cba7abb96b869a$var$de(n), !0);
    }, []);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getDeepestBlockElements = void 0;
    var t = $37cba7abb96b869a$var$F;
    Object.defineProperty(e, "getDeepestBlockElements", {
        enumerable: !0,
        get: function get() {
            return t.getDeepestBlockElements;
        }
    });
})($37cba7abb96b869a$var$R);
var $37cba7abb96b869a$var$fe = {}, $37cba7abb96b869a$var$W = {}, $37cba7abb96b869a$var$h = {}, $37cba7abb96b869a$var$U = {};
Object.defineProperty($37cba7abb96b869a$var$U, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$U.isLineBreakTag = $37cba7abb96b869a$var$Ct;
function $37cba7abb96b869a$var$Ct(e) {
    return [
        "BR",
        "WBR"
    ].includes(e.tagName);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isLineBreakTag = void 0;
    var t = $37cba7abb96b869a$var$U;
    Object.defineProperty(e, "isLineBreakTag", {
        enumerable: !0,
        get: function get() {
            return t.isLineBreakTag;
        }
    });
})($37cba7abb96b869a$var$h);
var $37cba7abb96b869a$var$E = {}, $37cba7abb96b869a$var$q = {};
Object.defineProperty($37cba7abb96b869a$var$q, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$q.isSingleTag = $37cba7abb96b869a$var$Lt;
function $37cba7abb96b869a$var$Lt(e) {
    return [
        "AREA",
        "BASE",
        "BR",
        "COL",
        "COMMAND",
        "EMBED",
        "HR",
        "IMG",
        "INPUT",
        "KEYGEN",
        "LINK",
        "META",
        "PARAM",
        "SOURCE",
        "TRACK",
        "WBR"
    ].includes(e.tagName);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isSingleTag = void 0;
    var t = $37cba7abb96b869a$var$q;
    Object.defineProperty(e, "isSingleTag", {
        enumerable: !0,
        get: function get() {
            return t.isSingleTag;
        }
    });
})($37cba7abb96b869a$var$E);
Object.defineProperty($37cba7abb96b869a$var$W, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$W.getDeepestNode = $37cba7abb96b869a$var$pe;
var $37cba7abb96b869a$var$St = $37cba7abb96b869a$var$c, $37cba7abb96b869a$var$Mt = $37cba7abb96b869a$var$h, $37cba7abb96b869a$var$kt = $37cba7abb96b869a$var$E;
function $37cba7abb96b869a$var$pe(e, t) {
    t === void 0 && (t = !1);
    var n = t ? "lastChild" : "firstChild", r = t ? "previousSibling" : "nextSibling";
    if (e.nodeType === Node.ELEMENT_NODE && e[n]) {
        var i = e[n];
        if ((0, $37cba7abb96b869a$var$kt.isSingleTag)(i) && !(0, $37cba7abb96b869a$var$St.isNativeInput)(i) && !(0, $37cba7abb96b869a$var$Mt.isLineBreakTag)(i)) {
            if (i[r]) i = i[r];
            else if (i.parentNode !== null && i.parentNode[r]) i = i.parentNode[r];
            else return i.parentNode;
        }
        return $37cba7abb96b869a$var$pe(i, t);
    }
    return e;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getDeepestNode = void 0;
    var t = $37cba7abb96b869a$var$W;
    Object.defineProperty(e, "getDeepestNode", {
        enumerable: !0,
        get: function get() {
            return t.getDeepestNode;
        }
    });
})($37cba7abb96b869a$var$fe);
var $37cba7abb96b869a$var$ve = {}, $37cba7abb96b869a$var$z = {}, $37cba7abb96b869a$var$p = $37cba7abb96b869a$var$b && $37cba7abb96b869a$var$b.__spreadArray || function(e, t, n) {
    if (n || arguments.length === 2) for(var r = 0, i = t.length, a; r < i; r++)(a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
    return e.concat(a || Array.prototype.slice.call(t));
};
Object.defineProperty($37cba7abb96b869a$var$z, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$z.findAllInputs = $37cba7abb96b869a$var$$t;
var $37cba7abb96b869a$var$wt = $37cba7abb96b869a$var$y, $37cba7abb96b869a$var$Nt = $37cba7abb96b869a$var$R, $37cba7abb96b869a$var$It = $37cba7abb96b869a$var$P, $37cba7abb96b869a$var$At = $37cba7abb96b869a$var$c;
function $37cba7abb96b869a$var$$t(e) {
    return Array.from(e.querySelectorAll((0, $37cba7abb96b869a$var$It.allInputsSelector)())).reduce(function(t, n) {
        return (0, $37cba7abb96b869a$var$At.isNativeInput)(n) || (0, $37cba7abb96b869a$var$wt.containsOnlyInlineElements)(n) ? $37cba7abb96b869a$var$p($37cba7abb96b869a$var$p([], t, !0), [
            n
        ], !1) : $37cba7abb96b869a$var$p($37cba7abb96b869a$var$p([], t, !0), (0, $37cba7abb96b869a$var$Nt.getDeepestBlockElements)(n), !0);
    }, []);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.findAllInputs = void 0;
    var t = $37cba7abb96b869a$var$z;
    Object.defineProperty(e, "findAllInputs", {
        enumerable: !0,
        get: function get() {
            return t.findAllInputs;
        }
    });
})($37cba7abb96b869a$var$ve);
var $37cba7abb96b869a$var$ge = {}, $37cba7abb96b869a$var$G = {};
Object.defineProperty($37cba7abb96b869a$var$G, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$G.isCollapsedWhitespaces = $37cba7abb96b869a$var$Bt;
function $37cba7abb96b869a$var$Bt(e) {
    return !/[^\t\n\r ]/.test(e);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isCollapsedWhitespaces = void 0;
    var t = $37cba7abb96b869a$var$G;
    Object.defineProperty(e, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function get() {
            return t.isCollapsedWhitespaces;
        }
    });
})($37cba7abb96b869a$var$ge);
var $37cba7abb96b869a$var$K = {}, $37cba7abb96b869a$var$X = {};
Object.defineProperty($37cba7abb96b869a$var$X, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$X.isElement = $37cba7abb96b869a$var$Ht;
var $37cba7abb96b869a$var$Dt = $37cba7abb96b869a$var$$;
function $37cba7abb96b869a$var$Ht(e) {
    return (0, $37cba7abb96b869a$var$Dt.isNumber)(e) ? !1 : !!e && !!e.nodeType && e.nodeType === Node.ELEMENT_NODE;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isElement = void 0;
    var t = $37cba7abb96b869a$var$X;
    Object.defineProperty(e, "isElement", {
        enumerable: !0,
        get: function get() {
            return t.isElement;
        }
    });
})($37cba7abb96b869a$var$K);
var $37cba7abb96b869a$var$me = {}, $37cba7abb96b869a$var$Y = {}, $37cba7abb96b869a$var$Q = {}, $37cba7abb96b869a$var$V = {};
Object.defineProperty($37cba7abb96b869a$var$V, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$V.isLeaf = $37cba7abb96b869a$var$Rt;
function $37cba7abb96b869a$var$Rt(e) {
    return e === null ? !1 : e.childNodes.length === 0;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isLeaf = void 0;
    var t = $37cba7abb96b869a$var$V;
    Object.defineProperty(e, "isLeaf", {
        enumerable: !0,
        get: function get() {
            return t.isLeaf;
        }
    });
})($37cba7abb96b869a$var$Q);
var $37cba7abb96b869a$var$Z = {}, $37cba7abb96b869a$var$J = {};
Object.defineProperty($37cba7abb96b869a$var$J, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$J.isNodeEmpty = $37cba7abb96b869a$var$zt;
var $37cba7abb96b869a$var$Ft = $37cba7abb96b869a$var$h, $37cba7abb96b869a$var$Wt = $37cba7abb96b869a$var$K, $37cba7abb96b869a$var$Ut = $37cba7abb96b869a$var$c, $37cba7abb96b869a$var$qt = $37cba7abb96b869a$var$E;
function $37cba7abb96b869a$var$zt(e, t) {
    var n = "";
    return (0, $37cba7abb96b869a$var$qt.isSingleTag)(e) && !(0, $37cba7abb96b869a$var$Ft.isLineBreakTag)(e) ? !1 : ((0, $37cba7abb96b869a$var$Wt.isElement)(e) && (0, $37cba7abb96b869a$var$Ut.isNativeInput)(e) ? n = e.value : e.textContent !== null && (n = e.textContent.replace("\u200B", "")), t !== void 0 && (n = n.replace(new RegExp(t, "g"), "")), n.trim().length === 0);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isNodeEmpty = void 0;
    var t = $37cba7abb96b869a$var$J;
    Object.defineProperty(e, "isNodeEmpty", {
        enumerable: !0,
        get: function get() {
            return t.isNodeEmpty;
        }
    });
})($37cba7abb96b869a$var$Z);
Object.defineProperty($37cba7abb96b869a$var$Y, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$Y.isEmpty = $37cba7abb96b869a$var$Xt;
var $37cba7abb96b869a$var$Gt = $37cba7abb96b869a$var$Q, $37cba7abb96b869a$var$Kt = $37cba7abb96b869a$var$Z;
function $37cba7abb96b869a$var$Xt(e, t) {
    e.normalize();
    for(var n = [
        e
    ]; n.length > 0;){
        var r = n.shift();
        if (r) {
            if (e = r, (0, $37cba7abb96b869a$var$Gt.isLeaf)(e) && !(0, $37cba7abb96b869a$var$Kt.isNodeEmpty)(e, t)) return !1;
            n.push.apply(n, Array.from(e.childNodes));
        }
    }
    return !0;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isEmpty = void 0;
    var t = $37cba7abb96b869a$var$Y;
    Object.defineProperty(e, "isEmpty", {
        enumerable: !0,
        get: function get() {
            return t.isEmpty;
        }
    });
})($37cba7abb96b869a$var$me);
var $37cba7abb96b869a$var$be = {}, $37cba7abb96b869a$var$x = {};
Object.defineProperty($37cba7abb96b869a$var$x, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$x.isFragment = $37cba7abb96b869a$var$Qt;
var $37cba7abb96b869a$var$Yt = $37cba7abb96b869a$var$$;
function $37cba7abb96b869a$var$Qt(e) {
    return (0, $37cba7abb96b869a$var$Yt.isNumber)(e) ? !1 : !!e && !!e.nodeType && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isFragment = void 0;
    var t = $37cba7abb96b869a$var$x;
    Object.defineProperty(e, "isFragment", {
        enumerable: !0,
        get: function get() {
            return t.isFragment;
        }
    });
})($37cba7abb96b869a$var$be);
var $37cba7abb96b869a$var$ye = {}, $37cba7abb96b869a$var$ee = {};
Object.defineProperty($37cba7abb96b869a$var$ee, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$ee.isHTMLString = $37cba7abb96b869a$var$Zt;
var $37cba7abb96b869a$var$Vt = $37cba7abb96b869a$var$_;
function $37cba7abb96b869a$var$Zt(e) {
    var t = (0, $37cba7abb96b869a$var$Vt.make)("div");
    return t.innerHTML = e, t.childElementCount > 0;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isHTMLString = void 0;
    var t = $37cba7abb96b869a$var$ee;
    Object.defineProperty(e, "isHTMLString", {
        enumerable: !0,
        get: function get() {
            return t.isHTMLString;
        }
    });
})($37cba7abb96b869a$var$ye);
var $37cba7abb96b869a$var$_e = {}, $37cba7abb96b869a$var$te = {};
Object.defineProperty($37cba7abb96b869a$var$te, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$te.offset = $37cba7abb96b869a$var$Jt;
function $37cba7abb96b869a$var$Jt(e) {
    var t = e.getBoundingClientRect(), n = window.pageXOffset || document.documentElement.scrollLeft, r = window.pageYOffset || document.documentElement.scrollTop, i = t.top + r, a = t.left + n;
    return {
        top: i,
        left: a,
        bottom: i + t.height,
        right: a + t.width
    };
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.offset = void 0;
    var t = $37cba7abb96b869a$var$te;
    Object.defineProperty(e, "offset", {
        enumerable: !0,
        get: function get() {
            return t.offset;
        }
    });
})($37cba7abb96b869a$var$_e);
var $37cba7abb96b869a$var$he = {}, $37cba7abb96b869a$var$ne = {};
Object.defineProperty($37cba7abb96b869a$var$ne, "__esModule", {
    value: !0
});
$37cba7abb96b869a$var$ne.prepend = $37cba7abb96b869a$var$xt;
function $37cba7abb96b869a$var$xt(e, t) {
    Array.isArray(t) ? (t = t.reverse(), t.forEach(function(n) {
        return e.prepend(n);
    })) : e.prepend(t);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.prepend = void 0;
    var t = $37cba7abb96b869a$var$ne;
    Object.defineProperty(e, "prepend", {
        enumerable: !0,
        get: function get() {
            return t.prepend;
        }
    });
})($37cba7abb96b869a$var$he);
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.prepend = e.offset = e.make = e.isLineBreakTag = e.isSingleTag = e.isNodeEmpty = e.isLeaf = e.isHTMLString = e.isFragment = e.isEmpty = e.isElement = e.isContentEditable = e.isCollapsedWhitespaces = e.findAllInputs = e.isNativeInput = e.allInputsSelector = e.getDeepestNode = e.getDeepestBlockElements = e.getContentLength = e.fragmentToString = e.containsOnlyInlineElements = e.canSetCaret = e.calculateBaseline = e.blockElements = e.append = void 0;
    var t = $37cba7abb96b869a$var$P;
    Object.defineProperty(e, "allInputsSelector", {
        enumerable: !0,
        get: function get() {
            return t.allInputsSelector;
        }
    });
    var n = $37cba7abb96b869a$var$c;
    Object.defineProperty(e, "isNativeInput", {
        enumerable: !0,
        get: function get() {
            return n.isNativeInput;
        }
    });
    var r = $37cba7abb96b869a$var$ie;
    Object.defineProperty(e, "append", {
        enumerable: !0,
        get: function get() {
            return r.append;
        }
    });
    var i = $37cba7abb96b869a$var$L;
    Object.defineProperty(e, "blockElements", {
        enumerable: !0,
        get: function get() {
            return i.blockElements;
        }
    });
    var a = $37cba7abb96b869a$var$ae;
    Object.defineProperty(e, "calculateBaseline", {
        enumerable: !0,
        get: function get() {
            return a.calculateBaseline;
        }
    });
    var l = $37cba7abb96b869a$var$le;
    Object.defineProperty(e, "canSetCaret", {
        enumerable: !0,
        get: function get() {
            return l.canSetCaret;
        }
    });
    var u = $37cba7abb96b869a$var$y;
    Object.defineProperty(e, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function get() {
            return u.containsOnlyInlineElements;
        }
    });
    var d = $37cba7abb96b869a$var$se;
    Object.defineProperty(e, "fragmentToString", {
        enumerable: !0,
        get: function get() {
            return d.fragmentToString;
        }
    });
    var s = $37cba7abb96b869a$var$ce;
    Object.defineProperty(e, "getContentLength", {
        enumerable: !0,
        get: function get() {
            return s.getContentLength;
        }
    });
    var f = $37cba7abb96b869a$var$R;
    Object.defineProperty(e, "getDeepestBlockElements", {
        enumerable: !0,
        get: function get() {
            return f.getDeepestBlockElements;
        }
    });
    var Oe = $37cba7abb96b869a$var$fe;
    Object.defineProperty(e, "getDeepestNode", {
        enumerable: !0,
        get: function get() {
            return Oe.getDeepestNode;
        }
    });
    var Pe = $37cba7abb96b869a$var$ve;
    Object.defineProperty(e, "findAllInputs", {
        enumerable: !0,
        get: function get() {
            return Pe.findAllInputs;
        }
    });
    var je = $37cba7abb96b869a$var$ge;
    Object.defineProperty(e, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function get() {
            return je.isCollapsedWhitespaces;
        }
    });
    var Te = $37cba7abb96b869a$var$w;
    Object.defineProperty(e, "isContentEditable", {
        enumerable: !0,
        get: function get() {
            return Te.isContentEditable;
        }
    });
    var Ce = $37cba7abb96b869a$var$K;
    Object.defineProperty(e, "isElement", {
        enumerable: !0,
        get: function get() {
            return Ce.isElement;
        }
    });
    var Le = $37cba7abb96b869a$var$me;
    Object.defineProperty(e, "isEmpty", {
        enumerable: !0,
        get: function get() {
            return Le.isEmpty;
        }
    });
    var Se = $37cba7abb96b869a$var$be;
    Object.defineProperty(e, "isFragment", {
        enumerable: !0,
        get: function get() {
            return Se.isFragment;
        }
    });
    var Me = $37cba7abb96b869a$var$ye;
    Object.defineProperty(e, "isHTMLString", {
        enumerable: !0,
        get: function get() {
            return Me.isHTMLString;
        }
    });
    var ke = $37cba7abb96b869a$var$Q;
    Object.defineProperty(e, "isLeaf", {
        enumerable: !0,
        get: function get() {
            return ke.isLeaf;
        }
    });
    var we = $37cba7abb96b869a$var$Z;
    Object.defineProperty(e, "isNodeEmpty", {
        enumerable: !0,
        get: function get() {
            return we.isNodeEmpty;
        }
    });
    var Ne = $37cba7abb96b869a$var$h;
    Object.defineProperty(e, "isLineBreakTag", {
        enumerable: !0,
        get: function get() {
            return Ne.isLineBreakTag;
        }
    });
    var Ie = $37cba7abb96b869a$var$E;
    Object.defineProperty(e, "isSingleTag", {
        enumerable: !0,
        get: function get() {
            return Ie.isSingleTag;
        }
    });
    var Ae = $37cba7abb96b869a$var$_;
    Object.defineProperty(e, "make", {
        enumerable: !0,
        get: function get() {
            return Ae.make;
        }
    });
    var $e = $37cba7abb96b869a$var$_e;
    Object.defineProperty(e, "offset", {
        enumerable: !0,
        get: function get() {
            return $e.offset;
        }
    });
    var Be = $37cba7abb96b869a$var$he;
    Object.defineProperty(e, "prepend", {
        enumerable: !0,
        get: function get() {
            return Be.prepend;
        }
    });
})($37cba7abb96b869a$var$v);
var $37cba7abb96b869a$var$Ee = /* @__PURE__ */ function(e) {
    return e.Left = "left", e.Center = "center", e;
}($37cba7abb96b869a$var$Ee || {});
var $37cba7abb96b869a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function m(param) {
        var t = param.data, n = param.config, r = param.api, i = param.readOnly, a = param.block;
        (0, $173N4._)(this, m);
        var l = m.DEFAULT_ALIGNMENT;
        var _ref, _ref1, _ref2;
        this.api = r, this.readOnly = i, this.quotePlaceholder = r.i18n.t((_ref = n == null ? void 0 : n.quotePlaceholder) !== null && _ref !== void 0 ? _ref : m.DEFAULT_QUOTE_PLACEHOLDER), this.captionPlaceholder = r.i18n.t((_ref1 = n == null ? void 0 : n.captionPlaceholder) !== null && _ref1 !== void 0 ? _ref1 : m.DEFAULT_CAPTION_PLACEHOLDER), this.data = {
            text: t.text || "",
            caption: t.caption || "",
            alignment: Object.values($37cba7abb96b869a$var$Ee).includes(t.alignment) ? t.alignment : (_ref2 = n == null ? void 0 : n.defaultAlignment) !== null && _ref2 !== void 0 ? _ref2 : l
        }, this.css = {
            baseClass: this.api.styles.block,
            wrapper: "cdx-quote",
            text: "cdx-quote__text",
            input: this.api.styles.input,
            caption: "cdx-quote__caption"
        }, this.block = a;
    }
    (0, $cFHGC._)(m, [
        {
            key: "CSS",
            get: /**
   * Tool`s styles
   * @returns CSS classes names
   */ function get() {
                return {
                    baseClass: this.api.styles.block,
                    wrapper: "cdx-quote",
                    text: "cdx-quote__text",
                    input: this.api.styles.input,
                    caption: "cdx-quote__caption"
                };
            }
        },
        {
            key: "settings",
            get: /**
   * Tool`s settings properties
   * @returns settings properties
   */ function get() {
                return [
                    {
                        name: "left",
                        icon: $37cba7abb96b869a$var$He
                    },
                    {
                        name: "center",
                        icon: $37cba7abb96b869a$var$De
                    }
                ];
            }
        },
        {
            /**
   * Create Quote Tool container with inputs
   * @returns blockquote DOM element - Quote Tool container
   */ key: "render",
            value: function render() {
                var t = $37cba7abb96b869a$var$v.make("blockquote", [
                    this.css.baseClass,
                    this.css.wrapper
                ]), n = $37cba7abb96b869a$var$v.make("div", [
                    this.css.input,
                    this.css.text
                ], {
                    contentEditable: !this.readOnly,
                    innerHTML: this.data.text
                }), r = $37cba7abb96b869a$var$v.make("div", [
                    this.css.input,
                    this.css.caption
                ], {
                    contentEditable: !this.readOnly,
                    innerHTML: this.data.caption
                });
                return n.dataset.placeholder = this.quotePlaceholder, r.dataset.placeholder = this.captionPlaceholder, t.appendChild(n), t.appendChild(r), t;
            }
        },
        {
            /**
   * Extract Quote data from Quote Tool element
   * @param quoteElement - Quote DOM element to save
   * @returns Quote data object
   */ key: "save",
            value: function save(t) {
                var n = t.querySelector(".".concat(this.css.text)), r = t.querySelector(".".concat(this.css.caption));
                var _ref, _ref1;
                return Object.assign(this.data, {
                    text: (_ref = n == null ? void 0 : n.innerHTML) !== null && _ref !== void 0 ? _ref : "",
                    caption: (_ref1 = r == null ? void 0 : r.innerHTML) !== null && _ref1 !== void 0 ? _ref1 : ""
                });
            }
        },
        {
            /**
   * Create wrapper for Tool`s settings buttons:
   * 1. Left alignment
   * 2. Center alignment
   * @returns settings menu
   */ key: "renderSettings",
            value: function renderSettings() {
                var _this = this;
                var t = function(n) {
                    return n && n[0].toUpperCase() + n.slice(1);
                };
                return this.settings.map(function(n) {
                    return {
                        icon: n.icon,
                        label: _this.api.i18n.t("Align ".concat(t(n.name))),
                        onActivate: function() {
                            return _this._toggleTune(n.name);
                        },
                        isActive: _this.data.alignment === n.name,
                        closeOnActivate: !0
                    };
                });
            }
        },
        {
            /**
   * Toggle quote`s alignment
   * @param tune - alignment
   */ key: "_toggleTune",
            value: function _toggleTune(t) {
                this.data.alignment = t, this.block.dispatchChange();
            }
        }
    ], [
        {
            key: "isReadOnlySupported",
            get: /**
   * Notify core that read-only mode is supported
   * @returns true
   */ function get() {
                return !0;
            }
        },
        {
            key: "toolbox",
            get: /**
   * Get Tool toolbox settings
   * icon - Tool icon's SVG
   * title - title to show in toolbox
   * @returns icon and title of the toolbox
   */ function get() {
                return {
                    icon: $37cba7abb96b869a$var$Re,
                    title: "Quote"
                };
            }
        },
        {
            key: "contentless",
            get: /**
   * Empty Quote is not empty Block
   * @returns true
   */ function get() {
                return !0;
            }
        },
        {
            key: "enableLineBreaks",
            get: /**
   * Allow to press Enter inside the Quote
   * @returns true
   */ function get() {
                return !0;
            }
        },
        {
            key: "DEFAULT_QUOTE_PLACEHOLDER",
            get: /**
   * Default placeholder for quote text
   * @returns 'Enter a quote'
   */ function get() {
                return "Enter a quote";
            }
        },
        {
            key: "DEFAULT_CAPTION_PLACEHOLDER",
            get: /**
   * Default placeholder for quote caption
   * @returns 'Enter a caption'
   */ function get() {
                return "Enter a caption";
            }
        },
        {
            key: "DEFAULT_ALIGNMENT",
            get: /**
   * Default quote alignment
   * @returns Alignment.Left
   */ function get() {
                return "left";
            }
        },
        {
            key: "conversionConfig",
            get: /**
   * Allow Quote to be converted to/from other blocks
   * @returns conversion config object
   */ function get() {
                return {
                    /**
       * To create Quote data from string, simple fill 'text' property
       */ import: "text",
                    /**
       * To create string from Quote data, concatenate text and caption
       * @param quoteData - Quote data object
       * @returns string
       */ export: function _export(t) {
                        return t.caption ? "".concat(t.text, " \u2014 ").concat(t.caption) : t.text;
                    }
                };
            }
        },
        {
            key: "sanitize",
            get: /**
   * Sanitizer rules
   * @returns sanitizer rules
   */ function get() {
                return {
                    text: {
                        br: !0
                    },
                    caption: {
                        br: !0
                    },
                    alignment: {}
                };
            }
        }
    ]);
    return m;
}();



var $769164dd9f885174$var$Tools = {
    list: (0, $4fb7d97cf6fbcc21$export$2e2bcd8739ae039),
    code: (0, $57cf0d4d83444770$export$2e2bcd8739ae039),
    linkTool: (0, $dd43b7a78f9ce268$export$2e2bcd8739ae039),
    image: (0, $40e8656eff946dc6$export$2e2bcd8739ae039),
    header: (0, $b4cc5177a40da62d$export$2e2bcd8739ae039),
    quote: (0, $37cba7abb96b869a$export$2e2bcd8739ae039)
};
var $769164dd9f885174$export$7e39a007f70d82e4 = function(props) {
    return(// @ts-expect-error: https://github.com/editor-js/link/issues/88
    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $baaeda96f7555c00$exports.Editor), Object.assign({
        tools: $769164dd9f885174$var$Tools
    }, props)));
};



var $ce8a9af87356b9f2$exports = {};
$ce8a9af87356b9f2$exports = JSON.parse('{"version":"2.22.2","time":1640560412325,"blocks":[{"id":"-dav4FSc-x","type":"header","data":{"text":"\u7F16\u8F91\u6F14\u793A","level":2}},{"id":"-rN-eVAbuC","type":"paragraph","data":{"text":"something awesome..."}}]}');



(0, $60566ee939038e24$export$2e2bcd8739ae039).displayName = 'Table';
var $00200ebe4eb3ad76$var$t = (0, $50993b47476de2e7$export$a7357cdd1f0b0168).t;
var $00200ebe4eb3ad76$export$46af595855840602 = (0, $e04d4b638436dc5e$export$b6ae1bc530f4c149)(function() {
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $1a4cf9540da0f5bb$export$2e2bcd8739ae039), {
        className: "my-3",
        fluid: "md",
        children: [
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("h1", {
                children: $00200ebe4eb3ad76$var$t('component')
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $cc348b2c5175bcb1$export$c489dd2bd24850e4), {
                title: "Time Distance",
                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $baaeda96f7555c00$exports.TimeDistance), {
                    date: "1989-06-04"
                })
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $cc348b2c5175bcb1$export$c489dd2bd24850e4), {
                title: "Icon",
                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $baaeda96f7555c00$exports.Icon), {
                    name: "bootstrap",
                    size: 2
                })
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $cc348b2c5175bcb1$export$c489dd2bd24850e4), {
                title: "Avatar",
                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $baaeda96f7555c00$exports.Avatar), {
                    src: "https://github.com/idea2app.png"
                })
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $cc348b2c5175bcb1$export$c489dd2bd24850e4), {
                title: "Nameplate",
                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $baaeda96f7555c00$exports.Nameplate), {
                    avatar: "https://github.com/idea2app.png",
                    name: "idea2app"
                })
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $cc348b2c5175bcb1$export$c489dd2bd24850e4), {
                title: "Table spinner",
                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $60566ee939038e24$export$2e2bcd8739ae039), {
                    className: "text-center",
                    striped: true,
                    hover: true,
                    children: [
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("thead", {
                            children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("tr", {
                                children: [
                                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("th", {
                                        children: "#"
                                    }),
                                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("th", {
                                        children: "Content"
                                    })
                                ]
                            })
                        }),
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("tbody", {
                            children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $baaeda96f7555c00$exports.TableSpinner), {
                                colSpan: 2
                            })
                        })
                    ]
                })
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $cc348b2c5175bcb1$export$c489dd2bd24850e4), {
                title: "Rich-text editor (HTML)",
                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $d1b3805234fdf37f$exports.Editor), {
                    defaultValue: "<p>test</p>",
                    onChange: console.log
                })
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $cc348b2c5175bcb1$export$c489dd2bd24850e4), {
                title: "Rich-text editor (JSON)",
                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $769164dd9f885174$export$7e39a007f70d82e4), {
                    name: "content",
                    defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($ce8a9af87356b9f2$exports)))
                })
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $cc348b2c5175bcb1$export$c489dd2bd24850e4), {
                title: "Editor HTML",
                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $baaeda96f7555c00$exports.EditorHTML), {
                    data: (0, (/*@__PURE__*/$parcel$interopDefault($ce8a9af87356b9f2$exports)))
                })
            })
        ]
    });
});



var $13u2V = parcelRequire("13u2V");




var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");

var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");
"use client";
// TODO
var $1d01af5d20296ff9$var$FormContext = /*#__PURE__*/ $tLNoZ.createContext({});
var $1d01af5d20296ff9$export$2e2bcd8739ae039 = $1d01af5d20296ff9$var$FormContext;



var $9c8ea36a07a0a289$var$FormGroup = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var controlId = _param.controlId, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $6acIq._)(_param, [
        "controlId",
        "as"
    ]);
    var context = (0, $lliNT.useMemo)(function() {
        return {
            controlId: controlId
        };
    }, [
        controlId
    ]);
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $1d01af5d20296ff9$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({}, props), {
            ref: ref
        }))
    });
});
$9c8ea36a07a0a289$var$FormGroup.displayName = 'FormGroup';
var $9c8ea36a07a0a289$export$2e2bcd8739ae039 = $9c8ea36a07a0a289$var$FormGroup;




"use client";
var $5dbdbcea25a917f7$var$FloatingLabel = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, children = _param.children, controlId = _param.controlId, label = _param.label, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "children",
        "controlId",
        "label"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $9c8ea36a07a0a289$export$2e2bcd8739ae039), (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix),
        controlId: controlId
    }, props), {
        children: [
            children,
            /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    }));
});
$5dbdbcea25a917f7$var$FloatingLabel.displayName = 'FloatingLabel';
var $5dbdbcea25a917f7$export$2e2bcd8739ae039 = $5dbdbcea25a917f7$var$FloatingLabel;


var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");



var $1aLYV = parcelRequire("1aLYV");

var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");

var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");


var $6f43e845a677181b$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).elementType
};
var $6f43e845a677181b$var$Feedback = /*#__PURE__*/ $1aLYV.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function(_param, ref) {
    var tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, className = _param.className, _param_type = _param.type, type = _param_type === void 0 ? 'valid' : _param_type, _param_tooltip = _param.tooltip, tooltip = _param_tooltip === void 0 ? false : _param_tooltip, props = (0, $6acIq._)(_param, [
        "as",
        "className",
        "type",
        "tooltip"
    ]);
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, "".concat(type, "-").concat(tooltip ? 'tooltip' : 'feedback'))
    }));
});
$6f43e845a677181b$var$Feedback.displayName = 'Feedback';
$6f43e845a677181b$var$Feedback.propTypes = $6f43e845a677181b$var$propTypes;
var $6f43e845a677181b$export$2e2bcd8739ae039 = $6f43e845a677181b$var$Feedback;



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");



"use client";
var $0152eaf5470e6a52$var$FormCheckInput = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var id = _param.id, bsPrefix = _param.bsPrefix, className = _param.className, _param_type = _param.type, type = _param_type === void 0 ? 'checkbox' : _param_type, _param_isValid = _param.isValid, isValid = _param_isValid === void 0 ? false : _param_isValid, _param_isInvalid = _param.isInvalid, isInvalid = _param_isInvalid === void 0 ? false : _param_isInvalid, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'input' : tmp, props = (0, $6acIq._)(_param, [
        "id",
        "bsPrefix",
        "className",
        "type",
        "isValid",
        "isInvalid",
        "as"
    ]);
    var controlId = (0, $lliNT.useContext)((0, $1d01af5d20296ff9$export$2e2bcd8739ae039)).controlId;
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({}, props), {
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    }));
});
$0152eaf5470e6a52$var$FormCheckInput.displayName = 'FormCheckInput';
var $0152eaf5470e6a52$export$2e2bcd8739ae039 = $0152eaf5470e6a52$var$FormCheckInput;



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");



"use client";
var $a12f072f0b80d17d$var$FormCheckLabel = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, htmlFor = _param.htmlFor, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "htmlFor"
    ]);
    var controlId = (0, $lliNT.useContext)((0, $1d01af5d20296ff9$export$2e2bcd8739ae039)).controlId;
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("label", (0, $6fpqi._)((0, $1XAnY._)({}, props), {
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }));
});
$a12f072f0b80d17d$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $a12f072f0b80d17d$export$2e2bcd8739ae039 = $a12f072f0b80d17d$var$FormCheckLabel;





var $1aLYV = parcelRequire("1aLYV");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $3fcc9f67bbcb4246$export$871de8747c9eaa88(children, func) {
    var index = 0;
    return $1aLYV.Children.map(children, function(child) {
        return /*#__PURE__*/ $1aLYV.isValidElement(child) ? func(child, index++) : child;
    });
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $3fcc9f67bbcb4246$export$4b80e395e36b5a56(children, func) {
    var index = 0;
    $1aLYV.Children.forEach(children, function(child) {
        if (/*#__PURE__*/ $1aLYV.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $3fcc9f67bbcb4246$export$500fd6099226ffae(children, type) {
    return $1aLYV.Children.toArray(children).some(function(child) {
        return /*#__PURE__*/ $1aLYV.isValidElement(child) && child.type === type;
    });
}



var $tLNoZ = parcelRequire("tLNoZ");
"use client";
var $d736e4da0bd16034$var$FormCheck = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var id = _param.id, bsPrefix = _param.bsPrefix, bsSwitchPrefix = _param.bsSwitchPrefix, _param_inline = _param.inline, inline = _param_inline === void 0 ? false : _param_inline, _param_reverse = _param.reverse, reverse = _param_reverse === void 0 ? false : _param_reverse, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_isValid = _param.isValid, isValid = _param_isValid === void 0 ? false : _param_isValid, _param_isInvalid = _param.isInvalid, isInvalid = _param_isInvalid === void 0 ? false : _param_isInvalid, _param_feedbackTooltip = _param.feedbackTooltip, feedbackTooltip = _param_feedbackTooltip === void 0 ? false : _param_feedbackTooltip, feedback = _param.feedback, feedbackType = _param.feedbackType, className = _param.className, style = _param.style, _param_title = _param.title, title = _param_title === void 0 ? '' : _param_title, _param_type = _param.type, type = _param_type === void 0 ? 'checkbox' : _param_type, label = _param.label, children = _param.children, _param_as = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, as = _param_as === void 0 ? 'input' : _param_as, props = (0, $6acIq._)(_param, [
        "id",
        "bsPrefix",
        "bsSwitchPrefix",
        "inline",
        "reverse",
        "disabled",
        "isValid",
        "isInvalid",
        "feedbackTooltip",
        "feedback",
        "feedbackType",
        "className",
        "style",
        "title",
        "type",
        "label",
        "children",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsSwitchPrefix, 'form-switch');
    var controlId = (0, $lliNT.useContext)((0, $1d01af5d20296ff9$export$2e2bcd8739ae039)).controlId;
    var innerFormContext = (0, $lliNT.useMemo)(function() {
        return {
            controlId: id || controlId
        };
    }, [
        controlId,
        id
    ]);
    var hasLabel = !children && label != null && label !== false || (0, $3fcc9f67bbcb4246$export$500fd6099226ffae)(children, (0, $a12f072f0b80d17d$export$2e2bcd8739ae039));
    var input = /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $0152eaf5470e6a52$export$2e2bcd8739ae039), (0, $6fpqi._)((0, $1XAnY._)({}, props), {
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    }));
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $1d01af5d20296ff9$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, hasLabel && bsPrefix, inline && "".concat(bsPrefix, "-inline"), reverse && "".concat(bsPrefix, "-reverse"), type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $tLNoZ.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $a12f072f0b80d17d$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $6f43e845a677181b$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$d736e4da0bd16034$var$FormCheck.displayName = 'FormCheck';
var $d736e4da0bd16034$export$2e2bcd8739ae039 = Object.assign($d736e4da0bd16034$var$FormCheck, {
    Input: (0, $0152eaf5470e6a52$export$2e2bcd8739ae039),
    Label: (0, $a12f072f0b80d17d$export$2e2bcd8739ae039)
});



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");





"use client";
var $df2fb2b62ca20a78$var$FormControl = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, type = _param.type, size = _param.size, htmlSize = _param.htmlSize, id = _param.id, className = _param.className, _param_isValid = _param.isValid, isValid = _param_isValid === void 0 ? false : _param_isValid, _param_isInvalid = _param.isInvalid, isInvalid = _param_isInvalid === void 0 ? false : _param_isInvalid, plaintext = _param.plaintext, readOnly = _param.readOnly, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'input' : tmp, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "type",
        "size",
        "htmlSize",
        "id",
        "className",
        "isValid",
        "isInvalid",
        "plaintext",
        "readOnly",
        "as"
    ]);
    var controlId = (0, $lliNT.useContext)((0, $1d01af5d20296ff9$export$2e2bcd8739ae039)).controlId;
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'form-control');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({}, props), {
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, plaintext ? "".concat(bsPrefix, "-plaintext") : bsPrefix, size && "".concat(bsPrefix, "-").concat(size), type === 'color' && "".concat(bsPrefix, "-color"), isValid && 'is-valid', isInvalid && 'is-invalid')
    }));
});
$df2fb2b62ca20a78$var$FormControl.displayName = 'FormControl';
var $df2fb2b62ca20a78$export$2e2bcd8739ae039 = Object.assign($df2fb2b62ca20a78$var$FormControl, {
    Feedback: (0, $6f43e845a677181b$export$2e2bcd8739ae039)
});



var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");



"use client";
var $d1e1baf0e563d14d$var$FormFloating = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$d1e1baf0e563d14d$var$FormFloating.displayName = 'FormFloating';
var $d1e1baf0e563d14d$export$2e2bcd8739ae039 = $d1e1baf0e563d14d$var$FormFloating;




var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");





"use client";
var $d7071c204253afec$var$FormLabel = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'label' : tmp, bsPrefix = _param.bsPrefix, _param_column = _param.column, column = _param_column === void 0 ? false : _param_column, _param_visuallyHidden = _param.visuallyHidden, visuallyHidden = _param_visuallyHidden === void 0 ? false : _param_visuallyHidden, className = _param.className, htmlFor = _param.htmlFor, props = (0, $6acIq._)(_param, [
        "as",
        "bsPrefix",
        "column",
        "visuallyHidden",
        "className",
        "htmlFor"
    ]);
    var controlId = (0, $lliNT.useContext)((0, $1d01af5d20296ff9$export$2e2bcd8739ae039)).controlId;
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'form-label');
    var columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = "".concat(columnClass, " ").concat(columnClass, "-").concat(column);
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $bce75f99777ea046$export$2e2bcd8739ae039), (0, $1XAnY._)({
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor
    }, props));
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: classes,
        htmlFor: htmlFor
    }, props));
});
$d7071c204253afec$var$FormLabel.displayName = 'FormLabel';
var $d7071c204253afec$export$2e2bcd8739ae039 = $d7071c204253afec$var$FormLabel;



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");



"use client";
var $48a3b1317abedd95$var$FormRange = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, id = _param.id, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "id"
    ]);
    var controlId = (0, $lliNT.useContext)((0, $1d01af5d20296ff9$export$2e2bcd8739ae039)).controlId;
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("input", (0, $6fpqi._)((0, $1XAnY._)({}, props), {
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix),
        id: id || controlId
    }));
});
$48a3b1317abedd95$var$FormRange.displayName = 'FormRange';
var $48a3b1317abedd95$export$2e2bcd8739ae039 = $48a3b1317abedd95$var$FormRange;



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");



"use client";
var $4ac7fd64590f0d98$var$FormSelect = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, size = _param.size, htmlSize = _param.htmlSize, className = _param.className, _param_isValid = _param.isValid, isValid = _param_isValid === void 0 ? false : _param_isValid, _param_isInvalid = _param.isInvalid, isInvalid = _param_isInvalid === void 0 ? false : _param_isInvalid, id = _param.id, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "size",
        "htmlSize",
        "className",
        "isValid",
        "isInvalid",
        "id"
    ]);
    var controlId = (0, $lliNT.useContext)((0, $1d01af5d20296ff9$export$2e2bcd8739ae039)).controlId;
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("select", (0, $6fpqi._)((0, $1XAnY._)({}, props), {
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, size && "".concat(bsPrefix, "-").concat(size), isValid && "is-valid", isInvalid && "is-invalid"),
        id: id || controlId
    }));
});
$4ac7fd64590f0d98$var$FormSelect.displayName = 'FormSelect';
var $4ac7fd64590f0d98$export$2e2bcd8739ae039 = $4ac7fd64590f0d98$var$FormSelect;



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");


"use client";
var $24ea94d203010da9$var$FormText = /*#__PURE__*/ $1aLYV.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, tmp = _param.as, Component = tmp === void 0 ? 'small' : tmp, muted = _param.muted, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "as",
        "muted"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, muted && 'text-muted')
    }));
});
$24ea94d203010da9$var$FormText.displayName = 'FormText';
var $24ea94d203010da9$export$2e2bcd8739ae039 = $24ea94d203010da9$var$FormText;



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $1aLYV = parcelRequire("1aLYV");


var $0f2d42a33148a80b$var$Switch = /*#__PURE__*/ $1aLYV.forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $d736e4da0bd16034$export$2e2bcd8739ae039), (0, $6fpqi._)((0, $1XAnY._)({}, props), {
        ref: ref,
        type: "switch"
    }));
});
$0f2d42a33148a80b$var$Switch.displayName = 'Switch';
var $0f2d42a33148a80b$export$2e2bcd8739ae039 = Object.assign($0f2d42a33148a80b$var$Switch, {
    Input: (0, $d736e4da0bd16034$export$2e2bcd8739ae039).Input,
    Label: (0, $d736e4da0bd16034$export$2e2bcd8739ae039).Label
});




var $fd86a401760e34c7$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).elementType
};
var $fd86a401760e34c7$var$Form = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, validated = _param.validated, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'form' : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "validated",
        "as"
    ]);
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, validated && 'was-validated')
    }));
});
$fd86a401760e34c7$var$Form.displayName = 'Form';
$fd86a401760e34c7$var$Form.propTypes = $fd86a401760e34c7$var$propTypes;
var $fd86a401760e34c7$export$2e2bcd8739ae039 = Object.assign($fd86a401760e34c7$var$Form, {
    Group: (0, $9c8ea36a07a0a289$export$2e2bcd8739ae039),
    Control: (0, $df2fb2b62ca20a78$export$2e2bcd8739ae039),
    Floating: (0, $d1e1baf0e563d14d$export$2e2bcd8739ae039),
    Check: (0, $d736e4da0bd16034$export$2e2bcd8739ae039),
    Switch: (0, $0f2d42a33148a80b$export$2e2bcd8739ae039),
    Label: (0, $d7071c204253afec$export$2e2bcd8739ae039),
    Text: (0, $24ea94d203010da9$export$2e2bcd8739ae039),
    Range: (0, $48a3b1317abedd95$export$2e2bcd8739ae039),
    Select: (0, $4ac7fd64590f0d98$export$2e2bcd8739ae039),
    FloatingLabel: (0, $5dbdbcea25a917f7$export$2e2bcd8739ae039)
});



var $lhPyT = parcelRequire("lhPyT");




var $7Pjls = parcelRequire("7Pjls");

var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");



"use client";
var $ccaf8835ae74c4d6$var$ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `ProgressBar`.
 */ function $ccaf8835ae74c4d6$var$onlyProgressBar(props, propName, componentName) {
    var children = props[propName];
    if (!children) return null;
    var error = null;
    $1aLYV.Children.forEach(children, function(child) {
        if (error) return;
        /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */ var element = /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($ccaf8835ae74c4d6$var$ProgressBar, {});
        if (child.type === element.type) return;
        var childType = child.type;
        var childIdentifier = /*#__PURE__*/ $1aLYV.isValidElement(child) ? childType.displayName || childType.name || childType : child;
        error = new Error("Children of ".concat(componentName, " can contain only ProgressBar ") + "components. Found ".concat(childIdentifier, "."));
    });
    return error;
}
function $ccaf8835ae74c4d6$var$getPercentage(now, min, max) {
    var percentage = (now - min) / (max - min) * 100;
    return Math.round(percentage * $ccaf8835ae74c4d6$var$ROUND_PRECISION) / $ccaf8835ae74c4d6$var$ROUND_PRECISION;
}
function $ccaf8835ae74c4d6$var$renderProgressBar(_param, ref) {
    var min = _param.min, now = _param.now, max = _param.max, label = _param.label, visuallyHidden = _param.visuallyHidden, striped = _param.striped, animated = _param.animated, className = _param.className, style = _param.style, variant = _param.variant, bsPrefix = _param.bsPrefix, props = (0, $6acIq._)(_param, [
        "min",
        "now",
        "max",
        "label",
        "visuallyHidden",
        "striped",
        "animated",
        "className",
        "style",
        "variant",
        "bsPrefix"
    ]);
    var _obj;
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref
    }, props), {
        role: "progressbar",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, "".concat(bsPrefix, "-bar"), (_obj = {}, (0, $7Pjls._)(_obj, "bg-".concat(variant), variant), (0, $7Pjls._)(_obj, "".concat(bsPrefix, "-bar-animated"), animated), (0, $7Pjls._)(_obj, "".concat(bsPrefix, "-bar-striped"), animated || striped), _obj)),
        style: (0, $1XAnY._)({
            width: "".concat($ccaf8835ae74c4d6$var$getPercentage(now, min, max), "%")
        }, style),
        "aria-valuenow": now,
        "aria-valuemin": min,
        "aria-valuemax": max,
        children: visuallyHidden ? /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("span", {
            className: "visually-hidden",
            children: label
        }) : label
    }));
}
var $ccaf8835ae74c4d6$var$ProgressBar = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var _param_isChild = _param.isChild, isChild = _param_isChild === void 0 ? false : _param_isChild, rest = (0, $6acIq._)(_param, [
        "isChild"
    ]);
    var props = (0, $1XAnY._)({
        min: 0,
        max: 100,
        animated: false,
        visuallyHidden: false,
        striped: false
    }, rest);
    props.bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(props.bsPrefix, 'progress');
    if (isChild) return $ccaf8835ae74c4d6$var$renderProgressBar(props, ref);
    var min = props.min, now = props.now, max = props.max, label = props.label, visuallyHidden = props.visuallyHidden, striped = props.striped, animated = props.animated, bsPrefix = props.bsPrefix, variant = props.variant, className = props.className, children = props.children, wrapperProps = (0, $6acIq._)(props, [
        "min",
        "now",
        "max",
        "label",
        "visuallyHidden",
        "striped",
        "animated",
        "bsPrefix",
        "variant",
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref
    }, wrapperProps), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix),
        children: children ? (0, $3fcc9f67bbcb4246$export$871de8747c9eaa88)(children, function(child) {
            return /*#__PURE__*/ (0, $1aLYV.cloneElement)(child, {
                isChild: true
            });
        }) : $ccaf8835ae74c4d6$var$renderProgressBar({
            min: min,
            now: now,
            max: max,
            label: label,
            visuallyHidden: visuallyHidden,
            striped: striped,
            animated: animated,
            bsPrefix: bsPrefix,
            variant: variant
        }, ref)
    }));
});
$ccaf8835ae74c4d6$var$ProgressBar.displayName = 'ProgressBar';
var $ccaf8835ae74c4d6$export$2e2bcd8739ae039 = $ccaf8835ae74c4d6$var$ProgressBar;



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");

var $13u2V = parcelRequire("13u2V");

var $h2kUE = parcelRequire("h2kUE");

var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7Pjls = parcelRequire("7Pjls");

var $dWsrg = parcelRequire("dWsrg");

var $kg0zo = parcelRequire("kg0zo");

var $hdIku = parcelRequire("hdIku");


var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");

var $13u2V = parcelRequire("13u2V");

var $Csf8W = parcelRequire("Csf8W");

var $h2kUE = parcelRequire("h2kUE");

var $lhPyT = parcelRequire("lhPyT");
var $70b3f58cd0fdbfe7$exports = {};

$parcel$export($70b3f58cd0fdbfe7$exports, "promisifyRequest", function () { return $70b3f58cd0fdbfe7$export$b327150396135fe7; });
$parcel$export($70b3f58cd0fdbfe7$exports, "createStore", function () { return $70b3f58cd0fdbfe7$export$f51a9068ac82ea43; });
$parcel$export($70b3f58cd0fdbfe7$exports, "get", function () { return $70b3f58cd0fdbfe7$export$3988ae62b71be9a3; });
$parcel$export($70b3f58cd0fdbfe7$exports, "set", function () { return $70b3f58cd0fdbfe7$export$adaa4cf7ef1b65be; });
$parcel$export($70b3f58cd0fdbfe7$exports, "setMany", function () { return $70b3f58cd0fdbfe7$export$daa0a5170277c7a8; });
$parcel$export($70b3f58cd0fdbfe7$exports, "getMany", function () { return $70b3f58cd0fdbfe7$export$5df405cccea42673; });
$parcel$export($70b3f58cd0fdbfe7$exports, "update", function () { return $70b3f58cd0fdbfe7$export$722fbec263ad908a; });
$parcel$export($70b3f58cd0fdbfe7$exports, "del", function () { return $70b3f58cd0fdbfe7$export$1d2f21e549771e67; });
$parcel$export($70b3f58cd0fdbfe7$exports, "delMany", function () { return $70b3f58cd0fdbfe7$export$c8aa84257229cac8; });
$parcel$export($70b3f58cd0fdbfe7$exports, "clear", function () { return $70b3f58cd0fdbfe7$export$42ffd38884aecdac; });
$parcel$export($70b3f58cd0fdbfe7$exports, "keys", function () { return $70b3f58cd0fdbfe7$export$ed97f33186d4b816; });
$parcel$export($70b3f58cd0fdbfe7$exports, "values", function () { return $70b3f58cd0fdbfe7$export$68c286be0e7e55b7; });
$parcel$export($70b3f58cd0fdbfe7$exports, "entries", function () { return $70b3f58cd0fdbfe7$export$3e9f948b41964866; });

var $f9AOD = parcelRequire("f9AOD");
function $70b3f58cd0fdbfe7$export$b327150396135fe7(request) {
    return new Promise(function(resolve, reject) {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        };
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
function $70b3f58cd0fdbfe7$export$f51a9068ac82ea43(dbName, storeName) {
    var dbp;
    var getDB = function() {
        if (dbp) return dbp;
        var request = indexedDB.open(dbName);
        request.onupgradeneeded = function() {
            return request.result.createObjectStore(storeName);
        };
        dbp = $70b3f58cd0fdbfe7$export$b327150396135fe7(request);
        dbp.then(function(db) {
            // It seems like Safari sometimes likes to just close the connection.
            // It's supposed to fire this event when that happens. Let's hope it does!
            db.onclose = function() {
                return dbp = undefined;
            };
        }, function() {});
        return dbp;
    };
    return function(txMode, callback) {
        return getDB().then(function(db) {
            return callback(db.transaction(storeName, txMode).objectStore(storeName));
        });
    };
}
var $70b3f58cd0fdbfe7$var$defaultGetStoreFunc;
function $70b3f58cd0fdbfe7$var$defaultGetStore() {
    if (!$70b3f58cd0fdbfe7$var$defaultGetStoreFunc) $70b3f58cd0fdbfe7$var$defaultGetStoreFunc = $70b3f58cd0fdbfe7$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $70b3f58cd0fdbfe7$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $70b3f58cd0fdbfe7$export$3988ae62b71be9a3(key) {
    var customStore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $70b3f58cd0fdbfe7$var$defaultGetStore();
    return customStore('readonly', function(store) {
        return $70b3f58cd0fdbfe7$export$b327150396135fe7(store.get(key));
    });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $70b3f58cd0fdbfe7$export$adaa4cf7ef1b65be(key, value) {
    var customStore = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $70b3f58cd0fdbfe7$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.put(value, key);
        return $70b3f58cd0fdbfe7$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $70b3f58cd0fdbfe7$export$daa0a5170277c7a8(entries) {
    var customStore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $70b3f58cd0fdbfe7$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        entries.forEach(function(entry) {
            return store.put(entry[1], entry[0]);
        });
        return $70b3f58cd0fdbfe7$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $70b3f58cd0fdbfe7$export$5df405cccea42673(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $70b3f58cd0fdbfe7$var$defaultGetStore();
    return customStore('readonly', function(store) {
        return Promise.all(keys.map(function(key) {
            return $70b3f58cd0fdbfe7$export$b327150396135fe7(store.get(key));
        }));
    });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $70b3f58cd0fdbfe7$export$722fbec263ad908a(key, updater) {
    var customStore = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $70b3f58cd0fdbfe7$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        return(// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise(function(resolve, reject) {
            var req = store.get(key);
            req.onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($70b3f58cd0fdbfe7$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
            req.onerror = function() {
                return reject(req.error);
            };
        }));
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $70b3f58cd0fdbfe7$export$1d2f21e549771e67(key) {
    var customStore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $70b3f58cd0fdbfe7$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.delete(key);
        return $70b3f58cd0fdbfe7$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $70b3f58cd0fdbfe7$export$c8aa84257229cac8(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $70b3f58cd0fdbfe7$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        keys.forEach(function(key) {
            return store.delete(key);
        });
        return $70b3f58cd0fdbfe7$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $70b3f58cd0fdbfe7$export$42ffd38884aecdac() {
    var customStore = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $70b3f58cd0fdbfe7$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.clear();
        return $70b3f58cd0fdbfe7$export$b327150396135fe7(store.transaction);
    });
}
function $70b3f58cd0fdbfe7$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $70b3f58cd0fdbfe7$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $70b3f58cd0fdbfe7$export$ed97f33186d4b816() {
    var customStore = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $70b3f58cd0fdbfe7$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        if (store.getAllKeys) return $70b3f58cd0fdbfe7$export$b327150396135fe7(store.getAllKeys());
        var items = [];
        return $70b3f58cd0fdbfe7$var$eachCursor(store, function(cursor) {
            return items.push(cursor.key);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $70b3f58cd0fdbfe7$export$68c286be0e7e55b7() {
    var customStore = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $70b3f58cd0fdbfe7$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        if (store.getAll) return $70b3f58cd0fdbfe7$export$b327150396135fe7(store.getAll());
        var items = [];
        return $70b3f58cd0fdbfe7$var$eachCursor(store, function(cursor) {
            return items.push(cursor.value);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $70b3f58cd0fdbfe7$export$3e9f948b41964866() {
    var customStore = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $70b3f58cd0fdbfe7$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $70b3f58cd0fdbfe7$export$b327150396135fe7(store.getAllKeys()),
            $70b3f58cd0fdbfe7$export$b327150396135fe7(store.getAll())
        ]).then(function(param) {
            var _param = (0, $f9AOD._)(param, 2), keys = _param[0], values = _param[1];
            return keys.map(function(key, i) {
                return [
                    key,
                    values[i]
                ];
            });
        });
        var items = [];
        return $70b3f58cd0fdbfe7$var$eachCursor(store, function(cursor) {
            return items.push([
                cursor.key,
                cursor.value
            ]);
        }).then(function() {
            return items;
        });
    });
}


function $6515720bcd6dbf2b$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $6515720bcd6dbf2b$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $6515720bcd6dbf2b$var$$082ef78710a13331$exports = {};
var $6515720bcd6dbf2b$var$$80184bab4212ab17$exports = {};
var $6515720bcd6dbf2b$var$$400caf514fe4dd82$exports = {};
$6515720bcd6dbf2b$var$$parcel$export($6515720bcd6dbf2b$var$$400caf514fe4dd82$exports, "toggle", function() {
    return $6515720bcd6dbf2b$export$e03c1c3201ee8bb7;
});
$6515720bcd6dbf2b$var$$parcel$export($6515720bcd6dbf2b$var$$400caf514fe4dd82$exports, "toggleNotification", function() {
    return $6515720bcd6dbf2b$export$6287f85d0f6a9342;
});
$6515720bcd6dbf2b$var$$parcel$export($6515720bcd6dbf2b$var$$400caf514fe4dd82$exports, "PersistNode", function() {
    return $6515720bcd6dbf2b$export$d1e7755b007c0847;
});
$6515720bcd6dbf2b$var$$parcel$export($6515720bcd6dbf2b$var$$400caf514fe4dd82$exports, "persist", function() {
    return $6515720bcd6dbf2b$export$9a6132153fba2e0;
});
$6515720bcd6dbf2b$var$$parcel$export($6515720bcd6dbf2b$var$$400caf514fe4dd82$exports, "restore", function() {
    return $6515720bcd6dbf2b$export$db239ef39aadc7fe;
});
$6515720bcd6dbf2b$var$$parcel$export($6515720bcd6dbf2b$var$$400caf514fe4dd82$exports, "destroy", function() {
    return $6515720bcd6dbf2b$export$b1fb4cac938035f7;
});
$6515720bcd6dbf2b$var$$parcel$export($6515720bcd6dbf2b$var$$400caf514fe4dd82$exports, "persistList", function() {
    return $6515720bcd6dbf2b$export$8001d3a0cfa5d8fd;
});
var $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__esDecorate = function $400caf514fe4dd82$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $7E0eS._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__runInitializers = function $400caf514fe4dd82$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__awaiter = function $400caf514fe4dd82$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__classPrivateFieldGet = function $400caf514fe4dd82$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__classPrivateFieldSet = function $400caf514fe4dd82$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__rest = function $400caf514fe4dd82$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $6515720bcd6dbf2b$export$e03c1c3201ee8bb7(property) {
    return function(origin, param) {
        var ref = (0, $64559a1d4554a279$export$71511d61b312f219)(param);
        return function() {
            for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
                data[_key] = arguments[_key];
            }
            return $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function() {
                var value;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            value = Reflect.get(this, property);
                            Reflect.set(this, property, typeof value === 'number' ? ++value : true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                ,
                                3,
                                4
                            ]);
                            return [
                                4,
                                origin.apply(this, data)
                            ];
                        case 2:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 3:
                            value = Reflect.get(this, property);
                            Reflect.set(this, property, typeof value === 'number' ? --value : false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
        };
    };
}
function $6515720bcd6dbf2b$export$6287f85d0f6a9342(message) {
    return function(origin, param) {
        var ref = (0, $64559a1d4554a279$export$71511d61b312f219)(param);
        return function() {
            for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
                data[_key] = arguments[_key];
            }
            return $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function() {
                var _this, notification;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this = this;
                            notification = Notification.requestPermission().then(function(permission) {
                                if (permission === 'granted') return new Notification(typeof message === 'function' ? message(_this) : message);
                            });
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                ,
                                3,
                                4
                            ]);
                            return [
                                4,
                                origin.apply(this, data)
                            ];
                        case 2:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 3:
                            notification.then(function(notification) {
                                return notification === null || notification === void 0 ? void 0 : notification.close();
                            });
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
        };
    };
}
var $6515720bcd6dbf2b$export$d1e7755b007c0847 = /*#__PURE__*/ function() {
    "use strict";
    function $400caf514fe4dd82$export$d1e7755b007c0847(meta) {
        (0, $173N4._)(this, $400caf514fe4dd82$export$d1e7755b007c0847);
        Object.defineProperty(this, "key", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "set", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "get", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "expireIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disposer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.assign(this, meta);
    }
    (0, $cFHGC._)($400caf514fe4dd82$export$d1e7755b007c0847, [
        {
            key: "save",
            value: function save(storeKey, value) {
                return $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function() {
                    var _a, _b, _, _ref, set, data;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(value != null)) return [
                                    3,
                                    2
                                ];
                                _ = this;
                                return [
                                    4,
                                    (_a = this.set) === null || _a === void 0 ? void 0 : _a.call(this, value)
                                ];
                            case 1:
                                _.value = (0, $h2kUE.toJS).apply(void 0, [
                                    (_b = _state.sent()) !== null && _b !== void 0 ? _b : value
                                ]);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    $70b3f58cd0fdbfe7$exports
                                ];
                            case 3:
                                _ref = _state.sent(), set = _ref.set, data = {
                                    value: this.value,
                                    expireAt: this.expireIn + Date.now()
                                };
                                return [
                                    2,
                                    set("".concat(storeKey, "-").concat(this.key), data)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "load",
            value: function load(storeKey) {
                return $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function() {
                    var _a, _b, _c, _ref, get, del, _ref1, value, expireAt, _tmp;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $70b3f58cd0fdbfe7$exports
                                ];
                            case 1:
                                _ref = _state.sent(), get = _ref.get, del = _ref.del;
                                storeKey += "-".concat(this.key);
                                return [
                                    4,
                                    get(storeKey)
                                ];
                            case 2:
                                _ref1 = (_a = _state.sent()) !== null && _a !== void 0 ? _a : {}, value = _ref1.value, expireAt = _ref1.expireAt;
                                if (expireAt && expireAt < Date.now()) {
                                    delete this.value;
                                    return [
                                        2,
                                        del(storeKey)
                                    ];
                                }
                                this.value = value;
                                if (!(value != null)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    (_b = this.get) === null || _b === void 0 ? void 0 : _b.call(this, value)
                                ];
                            case 3:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                _tmp = value;
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    (_c = _tmp) !== null && _c !== void 0 ? _c : value
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "destroy",
            value: function destroy(storeKey) {
                return $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function() {
                    var _a, _ref, del;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (_a = this.disposer) === null || _a === void 0 || _a.call(this);
                                return [
                                    4,
                                    $70b3f58cd0fdbfe7$exports
                                ];
                            case 1:
                                _ref = _state.sent(), del = _ref.del;
                                return [
                                    2,
                                    del("".concat(storeKey, "-").concat(this.key))
                                ];
                        }
                    });
                });
            }
        }
    ], [
        {
            key: "detectIDB",
            value: function detectIDB() {
                return $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function() {
                    var _ref, get;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (this.readyIDB) return [
                                    2,
                                    this.readyIDB
                                ];
                                return [
                                    4,
                                    $70b3f58cd0fdbfe7$exports
                                ];
                            case 1:
                                _ref = _state.sent(), get = _ref.get;
                                return [
                                    2,
                                    this.readyIDB = get('ready')
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return $400caf514fe4dd82$export$d1e7755b007c0847;
}();
var $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$PersistNodes = new WeakMap();
function $6515720bcd6dbf2b$export$9a6132153fba2e0() {
    var _a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var tmp = _a.expireIn, expireIn = tmp === void 0 ? Infinity : tmp, meta = $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__rest(_a, [
        "expireIn"
    ]);
    return function(param, param1) {
        var ref = (0, $64559a1d4554a279$export$71511d61b312f219)(param), name = param1.name, addInitializer = param1.addInitializer;
        addInitializer(function() {
            var list = $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$PersistNodes.get(this) || [];
            list.push(new $6515720bcd6dbf2b$export$d1e7755b007c0847(Object.assign(Object.assign({}, meta), {
                key: name.toString(),
                expireIn: expireIn
            })));
            $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$PersistNodes.set(this, list);
        });
    };
}
function $6515720bcd6dbf2b$export$db239ef39aadc7fe(classInstance, storeKey) {
    return $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function() {
        var _a, list, restoredData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, err;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $6515720bcd6dbf2b$export$d1e7755b007c0847.detectIDB()
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    _a = _state.sent();
                    return [
                        2,
                        console.warn('IndexedDB or its polyfill is not found in this runtime engine, MobX-RESTful persistence is disabled.')
                    ];
                case 3:
                    list = $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$PersistNodes.get(classInstance) || [], restoredData = {};
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        9,
                        10,
                        11
                    ]);
                    _loop = function() {
                        var item, key, value;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    item = _step.value;
                                    key = item.key;
                                    return [
                                        4,
                                        item.load(storeKey)
                                    ];
                                case 1:
                                    value = _state.sent();
                                    if (value != null) {
                                        Reflect.set(classInstance, key, value);
                                        restoredData[key] = value;
                                    }
                                    item.disposer = (0, $h2kUE.reaction)(function() {
                                        return classInstance[key];
                                    }, function(value) {
                                        return item.save(storeKey, value);
                                    });
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    _iterator = list[Symbol.iterator]();
                    _state.label = 5;
                case 5:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        8
                    ];
                    return [
                        5,
                        (0, $Csf8W.__values)(_loop())
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        5
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        11
                    ];
                case 10:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 11:
                    if ((0, $lhPyT.isEmpty)(restoredData)) return [
                        2
                    ];
                    console.group("Restored ".concat(storeKey));
                    console.table(restoredData);
                    console.groupEnd();
                    return [
                        2
                    ];
            }
        });
    });
}
function $6515720bcd6dbf2b$export$b1fb4cac938035f7(classInstance, storeKey) {
    return $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function() {
        var list, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, node, err;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    list = $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$PersistNodes.get(classInstance) || [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = list[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    node = _step.value;
                    return [
                        4,
                        node.destroy(storeKey)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
}
function $6515720bcd6dbf2b$export$8001d3a0cfa5d8fd() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, storeKey = _ref.storeKey, tmp = _ref.expireIn, expireIn = tmp === void 0 ? Infinity : tmp;
    return function(Super, param) {
        var ref = (0, $64559a1d4554a279$export$71511d61b312f219)(param);
        return function() {
            var _a, _PersistListModel_pageIndex_accessor_storage, _PersistListModel_pageSize_accessor_storage, _PersistListModel_filter_accessor_storage, _PersistListModel_totalCount_accessor_storage, _PersistListModel_pageList_accessor_storage;
            var _classSuper = Super;
            var _pageIndex_decorators;
            var _pageIndex_initializers = [];
            var _pageIndex_extraInitializers = [];
            var _pageSize_decorators;
            var _pageSize_initializers = [];
            var _pageSize_extraInitializers = [];
            var _filter_decorators;
            var _filter_initializers = [];
            var _filter_extraInitializers = [];
            var _totalCount_decorators;
            var _totalCount_initializers = [];
            var _totalCount_extraInitializers = [];
            var _pageList_decorators;
            var _pageList_initializers = [];
            var _pageList_extraInitializers = [];
            return _a = /*#__PURE__*/ function(_classSuper) {
                "use strict";
                (0, $hdIku._)(PersistListModel, _classSuper);
                function PersistListModel() {
                    (0, $173N4._)(this, PersistListModel);
                    var _this;
                    _this = (0, $7qXGD._)(this, PersistListModel, arguments);
                    _PersistListModel_pageIndex_accessor_storage.set(_this, $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__runInitializers(_this, _pageIndex_initializers, 0));
                    _PersistListModel_pageSize_accessor_storage.set(_this, ($6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__runInitializers(_this, _pageIndex_extraInitializers), $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__runInitializers(_this, _pageSize_initializers, 10)));
                    _PersistListModel_filter_accessor_storage.set(_this, ($6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__runInitializers(_this, _pageSize_extraInitializers), $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__runInitializers(_this, _filter_initializers, {})));
                    _PersistListModel_totalCount_accessor_storage.set(_this, ($6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__runInitializers(_this, _filter_extraInitializers), $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__runInitializers(_this, _totalCount_initializers, undefined)));
                    _PersistListModel_pageList_accessor_storage.set(_this, ($6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__runInitializers(_this, _totalCount_extraInitializers), $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__runInitializers(_this, _pageList_initializers, [])));
                    Object.defineProperty(_this, "restored", {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: ($6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__runInitializers(_this, _pageList_extraInitializers), globalThis.indexedDB && $6515720bcd6dbf2b$export$db239ef39aadc7fe(_this, typeof storeKey === 'function' ? storeKey(_this) : storeKey))
                    });
                    return _this;
                }
                (0, $cFHGC._)(PersistListModel, [
                    {
                        key: "pageIndex",
                        get: function get() {
                            return $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageIndex_accessor_storage, "f");
                        },
                        set: function set(value) {
                            $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageIndex_accessor_storage, value, "f");
                        }
                    },
                    {
                        key: "pageSize",
                        get: function get() {
                            return $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageSize_accessor_storage, "f");
                        },
                        set: function set(value) {
                            $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageSize_accessor_storage, value, "f");
                        }
                    },
                    {
                        key: "filter",
                        get: function get() {
                            return $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_filter_accessor_storage, "f");
                        },
                        set: function set(value) {
                            $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_filter_accessor_storage, value, "f");
                        }
                    },
                    {
                        key: "totalCount",
                        get: function get() {
                            return $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_totalCount_accessor_storage, "f");
                        },
                        set: function set(value) {
                            $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_totalCount_accessor_storage, value, "f");
                        }
                    },
                    {
                        key: "pageList",
                        get: function get() {
                            return $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageList_accessor_storage, "f");
                        },
                        set: function set(value) {
                            $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageList_accessor_storage, value, "f");
                        }
                    }
                ]);
                return PersistListModel;
            }(_classSuper), _PersistListModel_pageIndex_accessor_storage = new WeakMap(), _PersistListModel_pageSize_accessor_storage = new WeakMap(), _PersistListModel_filter_accessor_storage = new WeakMap(), _PersistListModel_totalCount_accessor_storage = new WeakMap(), _PersistListModel_pageList_accessor_storage = new WeakMap(), function() {
                var _b;
                var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
                _pageIndex_decorators = [
                    $6515720bcd6dbf2b$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $h2kUE.observable)
                ];
                _pageSize_decorators = [
                    $6515720bcd6dbf2b$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $h2kUE.observable)
                ];
                _filter_decorators = [
                    $6515720bcd6dbf2b$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $h2kUE.observable)
                ];
                _totalCount_decorators = [
                    $6515720bcd6dbf2b$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $h2kUE.observable)
                ];
                _pageList_decorators = [
                    $6515720bcd6dbf2b$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $h2kUE.observable)
                ];
                $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageIndex_decorators, {
                    kind: "accessor",
                    name: "pageIndex",
                    static: false,
                    private: false,
                    access: {
                        has: function(obj) {
                            return "pageIndex" in obj;
                        },
                        get: function(obj) {
                            return obj.pageIndex;
                        },
                        set: function(obj, value) {
                            obj.pageIndex = value;
                        }
                    },
                    metadata: _metadata
                }, _pageIndex_initializers, _pageIndex_extraInitializers);
                $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageSize_decorators, {
                    kind: "accessor",
                    name: "pageSize",
                    static: false,
                    private: false,
                    access: {
                        has: function(obj) {
                            return "pageSize" in obj;
                        },
                        get: function(obj) {
                            return obj.pageSize;
                        },
                        set: function(obj, value) {
                            obj.pageSize = value;
                        }
                    },
                    metadata: _metadata
                }, _pageSize_initializers, _pageSize_extraInitializers);
                $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _filter_decorators, {
                    kind: "accessor",
                    name: "filter",
                    static: false,
                    private: false,
                    access: {
                        has: function(obj) {
                            return "filter" in obj;
                        },
                        get: function(obj) {
                            return obj.filter;
                        },
                        set: function(obj, value) {
                            obj.filter = value;
                        }
                    },
                    metadata: _metadata
                }, _filter_initializers, _filter_extraInitializers);
                $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _totalCount_decorators, {
                    kind: "accessor",
                    name: "totalCount",
                    static: false,
                    private: false,
                    access: {
                        has: function(obj) {
                            return "totalCount" in obj;
                        },
                        get: function(obj) {
                            return obj.totalCount;
                        },
                        set: function(obj, value) {
                            obj.totalCount = value;
                        }
                    },
                    metadata: _metadata
                }, _totalCount_initializers, _totalCount_extraInitializers);
                $6515720bcd6dbf2b$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageList_decorators, {
                    kind: "accessor",
                    name: "pageList",
                    static: false,
                    private: false,
                    access: {
                        has: function(obj) {
                            return "pageList" in obj;
                        },
                        get: function(obj) {
                            return obj.pageList;
                        },
                        set: function(obj, value) {
                            obj.pageList = value;
                        }
                    },
                    metadata: _metadata
                }, _pageList_initializers, _pageList_extraInitializers);
                if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: _metadata
                });
            }(), _a;
        }();
    };
}
$6515720bcd6dbf2b$var$$parcel$exportWildcard($6515720bcd6dbf2b$var$$082ef78710a13331$exports, $6515720bcd6dbf2b$var$$80184bab4212ab17$exports);
$6515720bcd6dbf2b$var$$parcel$exportWildcard($6515720bcd6dbf2b$var$$082ef78710a13331$exports, $6515720bcd6dbf2b$var$$400caf514fe4dd82$exports);
var $6515720bcd6dbf2b$var$$16892940cfb7bd51$exports = {};
$6515720bcd6dbf2b$var$$parcel$export($6515720bcd6dbf2b$var$$16892940cfb7bd51$exports, "BaseModel", function() {
    return $6515720bcd6dbf2b$export$d12e20a4eec10acf;
});
$6515720bcd6dbf2b$var$$parcel$export($6515720bcd6dbf2b$var$$16892940cfb7bd51$exports, "BaseListModel", function() {
    return $6515720bcd6dbf2b$export$673dbc4a8d0cb20a;
});
var $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__runInitializers = function $16892940cfb7bd51$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__esDecorate = function $16892940cfb7bd51$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $7E0eS._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__awaiter = function $16892940cfb7bd51$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__classPrivateFieldGet = function $16892940cfb7bd51$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__classPrivateFieldSet = function $16892940cfb7bd51$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $6515720bcd6dbf2b$export$d12e20a4eec10acf = function() {
    var _a, _BaseModel_downloading_accessor_storage, _BaseModel_uploading_accessor_storage;
    var _instanceExtraInitializers = [];
    var _downloading_decorators;
    var _downloading_initializers = [];
    var _downloading_extraInitializers = [];
    var _uploading_decorators;
    var _uploading_initializers = [];
    var _uploading_extraInitializers = [];
    var _clear_decorators;
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function BaseModel() {
            (0, $173N4._)(this, BaseModel);
            _BaseModel_downloading_accessor_storage.set(this, ($6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__runInitializers(this, _instanceExtraInitializers), $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__runInitializers(this, _downloading_initializers, 0)));
            _BaseModel_uploading_accessor_storage.set(this, ($6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__runInitializers(this, _downloading_extraInitializers), $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__runInitializers(this, _uploading_initializers, 0)));
            $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__runInitializers(this, _uploading_extraInitializers);
        }
        (0, $cFHGC._)(BaseModel, [
            {
                key: "downloading",
                get: function get() {
                    return $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseModel_downloading_accessor_storage, "f");
                },
                set: function set(value) {
                    $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseModel_downloading_accessor_storage, value, "f");
                }
            },
            {
                key: "uploading",
                get: function get() {
                    return $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseModel_uploading_accessor_storage, "f");
                },
                set: function set(value) {
                    $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseModel_uploading_accessor_storage, value, "f");
                }
            },
            {
                key: "clear",
                value: function clear() {
                    this.downloading = this.uploading = 0;
                }
            }
        ]);
        return BaseModel;
    }(), _BaseModel_downloading_accessor_storage = new WeakMap(), _BaseModel_uploading_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _downloading_decorators = [
            (0, $h2kUE.observable)
        ];
        _uploading_decorators = [
            (0, $h2kUE.observable)
        ];
        _clear_decorators = [
            (0, $h2kUE.action)
        ];
        $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _downloading_decorators, {
            kind: "accessor",
            name: "downloading",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "downloading" in obj;
                },
                get: function(obj) {
                    return obj.downloading;
                },
                set: function(obj, value) {
                    obj.downloading = value;
                }
            },
            metadata: _metadata
        }, _downloading_initializers, _downloading_extraInitializers);
        $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _uploading_decorators, {
            kind: "accessor",
            name: "uploading",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "uploading" in obj;
                },
                get: function(obj) {
                    return obj.uploading;
                },
                set: function(obj, value) {
                    obj.uploading = value;
                }
            },
            metadata: _metadata
        }, _uploading_initializers, _uploading_extraInitializers);
        $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _clear_decorators, {
            kind: "method",
            name: "clear",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "clear" in obj;
                },
                get: function(obj) {
                    return obj.clear;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
/**
 * This basic class is a middle class, which isn't for direct using
 */ var $6515720bcd6dbf2b$export$673dbc4a8d0cb20a = function() {
    var _a, _BaseListModel_currentOne_accessor_storage;
    var _classSuper = $6515720bcd6dbf2b$export$d12e20a4eec10acf;
    var _instanceExtraInitializers = [];
    var _currentOne_decorators;
    var _currentOne_initializers = [];
    var _currentOne_extraInitializers = [];
    var _clearCurrent_decorators;
    var _updateOne_decorators;
    var _getOne_decorators;
    var _deleteOne_decorators;
    return _a = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $hdIku._)(BaseListModel, _classSuper);
        function BaseListModel() {
            (0, $173N4._)(this, BaseListModel);
            var _this;
            _this = (0, $7qXGD._)(this, BaseListModel, arguments);
            Object.defineProperty(_this, "indexKey", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__runInitializers(_this, _instanceExtraInitializers), 'id')
            });
            _BaseListModel_currentOne_accessor_storage.set(_this, $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__runInitializers(_this, _currentOne_initializers, {}));
            $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__runInitializers(_this, _currentOne_extraInitializers);
            return _this;
        }
        (0, $cFHGC._)(BaseListModel, [
            {
                key: "currentOne",
                get: function get() {
                    return $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseListModel_currentOne_accessor_storage, "f");
                },
                set: function set(value) {
                    $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseListModel_currentOne_accessor_storage, value, "f");
                }
            },
            {
                key: "clearCurrent",
                value: function clearCurrent() {
                    this.currentOne = {};
                // this.validity = {};
                }
            },
            {
                key: "clear",
                value: function clear() {
                    (0, $dWsrg._)((0, $kg0zo._)(BaseListModel.prototype), "clear", this).call(this);
                    this.clearCurrent();
                }
            },
            {
                key: "updateOne",
                value: function updateOne(data, id) {
                    return $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function() {
                        var _ref, body;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        id ? this.client.patch("".concat(this.baseURI, "/").concat(id), data) : this.client.post(this.baseURI, data)
                                    ];
                                case 1:
                                    _ref = _state.sent(), body = _ref.body;
                                    return [
                                        2,
                                        this.currentOne = body
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "getOne",
                value: function getOne(id) {
                    return $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function() {
                        var _ref, body;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.client.get("".concat(this.baseURI, "/").concat(id))
                                    ];
                                case 1:
                                    _ref = _state.sent(), body = _ref.body;
                                    return [
                                        2,
                                        this.currentOne = body
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "deleteOne",
                value: function deleteOne(id) {
                    return $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function() {
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.client.delete("".concat(this.baseURI, "/").concat(id))
                                    ];
                                case 1:
                                    _state.sent();
                                    if (this.currentOne[this.indexKey] === id) this.clearCurrent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            }
        ], [
            {
                key: "createNested",
                value: // @observable
                // validity: InvalidMessage<D> = {};
                function createNested(parentId) {
                    var Model = this;
                    var store = new Model();
                    store.baseURI = store.baseURI.replace(/:\w+/, parentId + '');
                    return store;
                }
            }
        ]);
        return BaseListModel;
    }(_classSuper), _BaseListModel_currentOne_accessor_storage = new WeakMap(), function() {
        var _b;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _currentOne_decorators = [
            (0, $h2kUE.observable)
        ];
        _clearCurrent_decorators = [
            (0, $h2kUE.action)
        ];
        _updateOne_decorators = [
            $6515720bcd6dbf2b$export$e03c1c3201ee8bb7('uploading')
        ];
        _getOne_decorators = [
            $6515720bcd6dbf2b$export$e03c1c3201ee8bb7('downloading')
        ];
        _deleteOne_decorators = [
            $6515720bcd6dbf2b$export$e03c1c3201ee8bb7('uploading')
        ];
        $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _currentOne_decorators, {
            kind: "accessor",
            name: "currentOne",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "currentOne" in obj;
                },
                get: function(obj) {
                    return obj.currentOne;
                },
                set: function(obj, value) {
                    obj.currentOne = value;
                }
            },
            metadata: _metadata
        }, _currentOne_initializers, _currentOne_extraInitializers);
        $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _clearCurrent_decorators, {
            kind: "method",
            name: "clearCurrent",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "clearCurrent" in obj;
                },
                get: function(obj) {
                    return obj.clearCurrent;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _updateOne_decorators, {
            kind: "method",
            name: "updateOne",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "updateOne" in obj;
                },
                get: function(obj) {
                    return obj.updateOne;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "getOne" in obj;
                },
                get: function(obj) {
                    return obj.getOne;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $6515720bcd6dbf2b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _deleteOne_decorators, {
            kind: "method",
            name: "deleteOne",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "deleteOne" in obj;
                },
                get: function(obj) {
                    return obj.deleteOne;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$exports = {};
$6515720bcd6dbf2b$var$$parcel$export($6515720bcd6dbf2b$var$$5766c49bacaeb5b8$exports, "ListModel", function() {
    return $6515720bcd6dbf2b$export$36e5777a1ba4b7c3;
});
$6515720bcd6dbf2b$var$$parcel$export($6515720bcd6dbf2b$var$$5766c49bacaeb5b8$exports, "Buffer", function() {
    return $6515720bcd6dbf2b$export$a143d493d941bafc;
});
$6515720bcd6dbf2b$var$$parcel$export($6515720bcd6dbf2b$var$$5766c49bacaeb5b8$exports, "Stream", function() {
    return $6515720bcd6dbf2b$export$6a4eb2e7fc9e8903;
});
var $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__runInitializers = function $5766c49bacaeb5b8$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__esDecorate = function $5766c49bacaeb5b8$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $7E0eS._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__awaiter = function $5766c49bacaeb5b8$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet = function $5766c49bacaeb5b8$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet = function $5766c49bacaeb5b8$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__await = function $5766c49bacaeb5b8$var$__await1(v) {
    return this instanceof $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__await ? (this.v = v, this) : new $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__await(v);
};
var $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__asyncValues = function $5766c49bacaeb5b8$var$__asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__asyncDelegator = function $5766c49bacaeb5b8$var$__asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__asyncGenerator = function $5766c49bacaeb5b8$var$__asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $6515720bcd6dbf2b$export$36e5777a1ba4b7c3 = function() {
    var _a, _ListModel_pageIndex_accessor_storage, _ListModel_pageSize_accessor_storage, _ListModel_filter_accessor_storage, _ListModel_totalCount_accessor_storage, _ListModel_pageList_accessor_storage, _ListModel_statistic_accessor_storage, _b;
    var _classSuper = $6515720bcd6dbf2b$export$673dbc4a8d0cb20a;
    var _instanceExtraInitializers = [];
    var _pageIndex_decorators;
    var _pageIndex_initializers = [];
    var _pageIndex_extraInitializers = [];
    var _pageSize_decorators;
    var _pageSize_initializers = [];
    var _pageSize_extraInitializers = [];
    var _filter_decorators;
    var _filter_initializers = [];
    var _filter_extraInitializers = [];
    var _totalCount_decorators;
    var _totalCount_initializers = [];
    var _totalCount_extraInitializers = [];
    var _pageList_decorators;
    var _pageList_initializers = [];
    var _pageList_extraInitializers = [];
    var _get_currentPage_decorators;
    var _get_pageCount_decorators;
    var _get_allItems_decorators;
    var _get_noMore_decorators;
    var _statistic_decorators;
    var _statistic_initializers = [];
    var _statistic_extraInitializers = [];
    var _clearList_decorators;
    var _restoreList_decorators;
    var _turnTo_decorators;
    var _getList_decorators;
    var _deleteOne_decorators;
    return _a = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $hdIku._)(ListModel, _classSuper);
        function ListModel() {
            (0, $173N4._)(this, ListModel);
            var _this;
            _this = (0, $7qXGD._)(this, ListModel, arguments);
            _ListModel_pageIndex_accessor_storage.set(_this, ($6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _instanceExtraInitializers), $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _pageIndex_initializers, 0)));
            _ListModel_pageSize_accessor_storage.set(_this, ($6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _pageIndex_extraInitializers), $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _pageSize_initializers, 10)));
            _ListModel_filter_accessor_storage.set(_this, ($6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _pageSize_extraInitializers), $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _filter_initializers, {})));
            _ListModel_totalCount_accessor_storage.set(_this, ($6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _filter_extraInitializers), $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _totalCount_initializers, void 0)));
            _ListModel_pageList_accessor_storage.set(_this, ($6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _totalCount_extraInitializers), $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _pageList_initializers, [])));
            _ListModel_statistic_accessor_storage.set(_this, ($6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _pageList_extraInitializers), $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _statistic_initializers, {})));
            Object.defineProperty(_this, _b, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _statistic_extraInitializers), _this.getAllInStream)
            });
            return _this;
        }
        (0, $cFHGC._)(ListModel, [
            {
                key: "pageIndex",
                get: function get() {
                    return $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageIndex_accessor_storage, "f");
                },
                set: function set(value) {
                    $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageIndex_accessor_storage, value, "f");
                }
            },
            {
                key: "pageSize",
                get: function get() {
                    return $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageSize_accessor_storage, "f");
                },
                set: function set(value) {
                    $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageSize_accessor_storage, value, "f");
                }
            },
            {
                key: "filter",
                get: function get() {
                    return $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_filter_accessor_storage, "f");
                },
                set: function set(value) {
                    $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_filter_accessor_storage, value, "f");
                }
            },
            {
                key: "totalCount",
                get: function get() {
                    return $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_totalCount_accessor_storage, "f");
                },
                set: function set(value) {
                    $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_totalCount_accessor_storage, value, "f");
                }
            },
            {
                key: "pageList",
                get: function get() {
                    return $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageList_accessor_storage, "f");
                },
                set: function set(value) {
                    $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageList_accessor_storage, value, "f");
                }
            },
            {
                key: "currentPage",
                get: function get() {
                    return this.pageList[this.pageIndex - 1] || [];
                }
            },
            {
                key: "pageCount",
                get: function get() {
                    return Math.ceil(this.totalCount / this.pageSize) || this.pageList.length;
                }
            },
            {
                key: "allItems",
                get: function get() {
                    var pageList = (0, $h2kUE.toJS)(this.pageList), _this = this, pageSize = _this.pageSize, totalCount = _this.totalCount;
                    var index = (0, $aUGqu._)(pageList).reverse().findIndex(function(item) {
                        return (item === null || item === void 0 ? void 0 : item[0]) != null;
                    });
                    return Array.from(pageList.slice(0, -index || Infinity), function(page) {
                        return (page === null || page === void 0 ? void 0 : page[0]) ? page : new Array(pageSize).fill({});
                    }).flat().slice(0, totalCount || 0);
                }
            },
            {
                key: "noMore",
                get: function get() {
                    return this.pageIndex * this.pageSize >= this.totalCount;
                }
            },
            {
                key: "statistic",
                get: function get() {
                    return $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_statistic_accessor_storage, "f");
                },
                set: function set(value) {
                    $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_statistic_accessor_storage, value, "f");
                }
            },
            {
                key: "clearList",
                value: function clearList() {
                    this.pageIndex = 0;
                    this.pageSize = 10;
                    this.filter = {};
                    this.pageList = [];
                    this.totalCount = undefined;
                }
            },
            {
                key: "clear",
                value: function clear() {
                    (0, $dWsrg._)((0, $kg0zo._)(ListModel.prototype), "clear", this).call(this);
                    this.clearList();
                }
            },
            {
                key: "restoreList",
                value: function restoreList() {
                    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, tmp = _ref.pageIndex, pageIndex = tmp === void 0 ? this.pageIndex + 1 : tmp, tmp1 = _ref.pageSize, pageSize = tmp1 === void 0 ? this.pageSize : tmp1, tmp2 = _ref.allItems, allItems = tmp2 === void 0 ? this.allItems : tmp2, tmp3 = _ref.totalCount, totalCount = tmp3 === void 0 ? Infinity : tmp3;
                    if (!allItems.length) return;
                    this.pageList = (0, $lhPyT.splitArray)(allItems, pageSize);
                    this.pageIndex = pageIndex;
                    this.pageSize = pageSize;
                    this.totalCount = totalCount;
                }
            },
            {
                key: "turnTo",
                value: function turnTo(pageIndex) {
                    var pageSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.pageSize;
                    this.pageIndex = pageIndex;
                    if (this.pageSize !== pageSize) this.pageList = (0, $lhPyT.splitArray)(this.allItems, this.pageSize = pageSize);
                    return this;
                }
            },
            {
                /**
             * @protected
             */ key: "loadNewPage",
                value: function loadNewPage(pageIndex, pageSize, filter) {
                    return $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function() {
                        var _ref, pageData, totalCount, list;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.loadPage(pageIndex, pageSize, filter)
                                    ];
                                case 1:
                                    _ref = _state.sent(), pageData = _ref.pageData, totalCount = _ref.totalCount;
                                    this.pageSize = pageSize;
                                    list = (0, $aUGqu._)(this.pageList);
                                    list[pageIndex - 1] = pageData;
                                    this.pageList = list;
                                    this.totalCount = totalCount != null ? isNaN(totalCount) || totalCount < 0 ? Infinity : totalCount : Infinity;
                                    return [
                                        2,
                                        {
                                            pageData: pageData,
                                            totalCount: totalCount
                                        }
                                    ];
                            }
                        });
                    });
                }
            },
            {
                // @action  // disabled for @override bug of MobX 6
                key: "getList",
                value: function getList() {
                    return $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function() {
                        var filter, pageIndex, pageSize, _ref, pageData;
                        var _arguments = arguments;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    filter = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : this.filter, pageIndex = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : this.pageIndex + 1, pageSize = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : this.pageSize;
                                    return [
                                        4,
                                        this.loadNewPage(pageIndex, pageSize, filter)
                                    ];
                                case 1:
                                    _ref = _state.sent(), pageData = _ref.pageData;
                                    this.filter = filter;
                                    this.turnTo(pageIndex, pageSize);
                                    return [
                                        2,
                                        pageData
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "refreshList",
                value: function refreshList() {
                    var _this = this, filter = _this.filter, pageSize = _this.pageSize;
                    this.clearList();
                    return this.getList(filter, 1, pageSize);
                }
            },
            {
                key: "getAllInStream",
                value: function getAllInStream() {
                    return $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__asyncGenerator(this, arguments, function getAllInStream_1() {
                        var filter, pageSize;
                        var _arguments = arguments;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    filter = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : this.filter, pageSize = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : this.pageSize;
                                    this.pageIndex = 0;
                                    _state.label = 1;
                                case 1:
                                    if (!!this.noMore) return [
                                        3,
                                        5
                                    ];
                                    return [
                                        4,
                                        $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__await(this.getList(filter, undefined, pageSize))
                                    ];
                                case 2:
                                    return [
                                        5,
                                        (0, $Csf8W.__values)($6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__asyncDelegator.apply(void 0, [
                                            $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__asyncValues.apply(void 0, [
                                                _state.sent()
                                            ])
                                        ]))
                                    ];
                                case 3:
                                    return [
                                        4,
                                        $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__await.apply(void 0, [
                                            _state.sent()
                                        ])
                                    ];
                                case 4:
                                    _state.sent();
                                    return [
                                        3,
                                        1
                                    ];
                                case 5:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "getAll",
                value: function getAll() {
                    var filter = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.filter, pageSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.pageSize;
                    return Array.fromAsync(this.getAllInStream(filter, pageSize));
                }
            },
            {
                key: "countAll",
                value: function countAll(keys_1) {
                    return $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function(keys) {
                        var filter, pageSize, allItems, statistic;
                        var _arguments = arguments;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    filter = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : this.filter, pageSize = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : this.pageSize;
                                    return [
                                        4,
                                        this.getAll(filter, pageSize)
                                    ];
                                case 1:
                                    allItems = _state.sent();
                                    statistic = Object.fromEntries(keys.map(function(key) {
                                        return [
                                            key,
                                            (0, $lhPyT.countBy)(allItems, key)
                                        ];
                                    }));
                                    return [
                                        2,
                                        this.statistic = statistic
                                    ];
                            }
                        });
                    });
                }
            },
            (0, $7Pjls._)({
                key: "indexOf"
            }, "value", function indexOf(id) {
                var _this = this, indexKey = _this.indexKey, allItems = _this.allItems;
                return allItems.findIndex(function(param) {
                    var ID = param[indexKey];
                    return ID === id;
                });
            }),
            {
                key: "changeOne",
                value: function changeOne(data, id) {
                    var patch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                    var _this = this, pageIndex = _this.pageIndex, allItems = _this.allItems, totalCount = _this.totalCount, index = this.indexOf(id);
                    if (index > -1) this.restoreList({
                        pageIndex: pageIndex,
                        allItems: (0, $aUGqu._)(allItems.slice(0, index)).concat([
                            patch ? Object.assign(Object.assign({}, allItems[index]), data) : data
                        ], (0, $aUGqu._)(allItems.slice(index + 1))),
                        totalCount: totalCount
                    });
                }
            },
            {
                key: "updateOne",
                value: function updateOne(data, id) {
                    var _this = this;
                    var _super = Object.create(null, {
                        updateOne: {
                            get: function() {
                                return (0, $dWsrg._)((0, $kg0zo._)(ListModel.prototype), "updateOne", _this);
                            }
                        }
                    });
                    return $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function() {
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        _super.updateOne.call(this, data, id)
                                    ];
                                case 1:
                                    _state.sent();
                                    if (id) this.changeOne(this.currentOne, id);
                                    return [
                                        2,
                                        this.currentOne
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "removeOne",
                value: function removeOne(id) {
                    return $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function() {
                        var _this, filter, pageIndex, allItems, index, _ref, pageData;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this = this, filter = _this.filter, pageIndex = _this.pageIndex, allItems = _this.allItems, index = this.indexOf(id);
                                    return [
                                        4,
                                        this.loadPage(allItems.length + 1, 1, filter)
                                    ];
                                case 1:
                                    _ref = _state.sent(), pageData = _ref.pageData;
                                    return [
                                        2,
                                        this.restoreList({
                                            pageIndex: pageIndex,
                                            allItems: (0, $aUGqu._)(allItems.slice(0, index)).concat((0, $aUGqu._)(allItems.slice(index + 1)), (0, $aUGqu._)(pageData)),
                                            totalCount: this.totalCount--
                                        })
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "deleteOne",
                value: function deleteOne(id) {
                    var _this = this;
                    var _super = Object.create(null, {
                        deleteOne: {
                            get: function() {
                                return (0, $dWsrg._)((0, $kg0zo._)(ListModel.prototype), "deleteOne", _this);
                            }
                        }
                    });
                    return $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function() {
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        _super.deleteOne.call(this, id)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        4,
                                        this.removeOne(id)
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            }
        ]);
        return ListModel;
    }(_classSuper), _ListModel_pageIndex_accessor_storage = new WeakMap(), _ListModel_pageSize_accessor_storage = new WeakMap(), _ListModel_filter_accessor_storage = new WeakMap(), _ListModel_totalCount_accessor_storage = new WeakMap(), _ListModel_pageList_accessor_storage = new WeakMap(), _ListModel_statistic_accessor_storage = new WeakMap(), _b = (_pageIndex_decorators = [
        (0, $h2kUE.observable)
    ], _pageSize_decorators = [
        (0, $h2kUE.observable)
    ], _filter_decorators = [
        (0, $h2kUE.observable)
    ], _totalCount_decorators = [
        (0, $h2kUE.observable)
    ], _pageList_decorators = [
        (0, $h2kUE.observable)
    ], _get_currentPage_decorators = [
        (0, $h2kUE.computed)
    ], _get_pageCount_decorators = [
        (0, $h2kUE.computed)
    ], _get_allItems_decorators = [
        (0, $h2kUE.computed)
    ], _get_noMore_decorators = [
        (0, $h2kUE.computed)
    ], _statistic_decorators = [
        (0, $h2kUE.observable)
    ], _clearList_decorators = [
        (0, $h2kUE.action)
    ], _restoreList_decorators = [
        (0, $h2kUE.action)
    ], _turnTo_decorators = [
        (0, $h2kUE.action)
    ], _getList_decorators = [
        $6515720bcd6dbf2b$export$e03c1c3201ee8bb7('downloading')
    ], Symbol.asyncIterator), function() {
        var _c;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_c = _classSuper[Symbol.metadata]) !== null && _c !== void 0 ? _c : null) : void 0;
        _deleteOne_decorators = [
            $6515720bcd6dbf2b$export$e03c1c3201ee8bb7('uploading')
        ];
        $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageIndex_decorators, {
            kind: "accessor",
            name: "pageIndex",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "pageIndex" in obj;
                },
                get: function(obj) {
                    return obj.pageIndex;
                },
                set: function(obj, value) {
                    obj.pageIndex = value;
                }
            },
            metadata: _metadata
        }, _pageIndex_initializers, _pageIndex_extraInitializers);
        $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageSize_decorators, {
            kind: "accessor",
            name: "pageSize",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "pageSize" in obj;
                },
                get: function(obj) {
                    return obj.pageSize;
                },
                set: function(obj, value) {
                    obj.pageSize = value;
                }
            },
            metadata: _metadata
        }, _pageSize_initializers, _pageSize_extraInitializers);
        $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _filter_decorators, {
            kind: "accessor",
            name: "filter",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "filter" in obj;
                },
                get: function(obj) {
                    return obj.filter;
                },
                set: function(obj, value) {
                    obj.filter = value;
                }
            },
            metadata: _metadata
        }, _filter_initializers, _filter_extraInitializers);
        $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _totalCount_decorators, {
            kind: "accessor",
            name: "totalCount",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "totalCount" in obj;
                },
                get: function(obj) {
                    return obj.totalCount;
                },
                set: function(obj, value) {
                    obj.totalCount = value;
                }
            },
            metadata: _metadata
        }, _totalCount_initializers, _totalCount_extraInitializers);
        $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageList_decorators, {
            kind: "accessor",
            name: "pageList",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "pageList" in obj;
                },
                get: function(obj) {
                    return obj.pageList;
                },
                set: function(obj, value) {
                    obj.pageList = value;
                }
            },
            metadata: _metadata
        }, _pageList_initializers, _pageList_extraInitializers);
        $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_currentPage_decorators, {
            kind: "getter",
            name: "currentPage",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "currentPage" in obj;
                },
                get: function(obj) {
                    return obj.currentPage;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_pageCount_decorators, {
            kind: "getter",
            name: "pageCount",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "pageCount" in obj;
                },
                get: function(obj) {
                    return obj.pageCount;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_allItems_decorators, {
            kind: "getter",
            name: "allItems",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "allItems" in obj;
                },
                get: function(obj) {
                    return obj.allItems;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_noMore_decorators, {
            kind: "getter",
            name: "noMore",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "noMore" in obj;
                },
                get: function(obj) {
                    return obj.noMore;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _statistic_decorators, {
            kind: "accessor",
            name: "statistic",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "statistic" in obj;
                },
                get: function(obj) {
                    return obj.statistic;
                },
                set: function(obj, value) {
                    obj.statistic = value;
                }
            },
            metadata: _metadata
        }, _statistic_initializers, _statistic_extraInitializers);
        $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _clearList_decorators, {
            kind: "method",
            name: "clearList",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "clearList" in obj;
                },
                get: function(obj) {
                    return obj.clearList;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _restoreList_decorators, {
            kind: "method",
            name: "restoreList",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "restoreList" in obj;
                },
                get: function(obj) {
                    return obj.restoreList;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _turnTo_decorators, {
            kind: "method",
            name: "turnTo",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "turnTo" in obj;
                },
                get: function(obj) {
                    return obj.turnTo;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _getList_decorators, {
            kind: "method",
            name: "getList",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "getList" in obj;
                },
                get: function(obj) {
                    return obj.getList;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _deleteOne_decorators, {
            kind: "method",
            name: "deleteOne",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "deleteOne" in obj;
                },
                get: function(obj) {
                    return obj.deleteOne;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
function $6515720bcd6dbf2b$export$a143d493d941bafc(Super) {
    var BufferListMixin = function() {
        var _a;
        var _classSuper = Super;
        var _instanceExtraInitializers = [];
        var _getList_decorators;
        return _a = /*#__PURE__*/ function(_classSuper) {
            "use strict";
            (0, $hdIku._)(BufferListMixin, _classSuper);
            function BufferListMixin() {
                (0, $173N4._)(this, BufferListMixin);
                var _this;
                _this = (0, $7qXGD._)(this, BufferListMixin, arguments);
                Object.defineProperty(_this, "pendingList", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: ($6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _instanceExtraInitializers), [])
                });
                return _this;
            }
            (0, $cFHGC._)(BufferListMixin, [
                {
                    key: "clearList",
                    value: function clearList() {
                        (0, $dWsrg._)((0, $kg0zo._)(BufferListMixin.prototype), "clearList", this).call(this);
                        this.pendingList = [];
                    }
                },
                {
                    key: "clear",
                    value: function clear() {
                        (0, $dWsrg._)((0, $kg0zo._)(BufferListMixin.prototype), "clear", this).call(this);
                        this.clearList();
                    }
                },
                {
                    key: "getList",
                    value: function getList() {
                        var _this = this;
                        var _super = Object.create(null, {
                            getList: {
                                get: function() {
                                    return (0, $dWsrg._)((0, $kg0zo._)(BufferListMixin.prototype), "getList", _this);
                                }
                            }
                        });
                        return $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function() {
                            var _this, filter, pageIndex, pageSize, currentIndex, _ref, pageData, list, nextIndex;
                            var _arguments = arguments;
                            return (0, $13u2V._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _this = this;
                                        filter = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : this.filter, pageIndex = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : this.pageIndex + 1, pageSize = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : this.pageSize;
                                        currentIndex = pageIndex - 1;
                                        if (!this.pendingList[currentIndex]) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            this.pendingList[currentIndex]
                                        ];
                                    case 1:
                                        _ref = _state.sent(), pageData = _ref.pageData;
                                        this.turnTo(pageIndex, pageSize);
                                        return [
                                            2,
                                            pageData
                                        ];
                                    case 2:
                                        if (!this.pageList[currentIndex]) return [
                                            3,
                                            3
                                        ];
                                        this.turnTo(pageIndex, pageSize);
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        return [
                                            4,
                                            _super.getList.call(this, filter, pageIndex, pageSize)
                                        ];
                                    case 4:
                                        list = _state.sent();
                                        _state.label = 5;
                                    case 5:
                                        nextIndex = pageIndex + 1;
                                        this.pendingList[nextIndex] = this.loadNewPage(nextIndex, pageSize, filter).then(function(data) {
                                            _this.pendingList[nextIndex] = undefined;
                                            return data;
                                        });
                                        return [
                                            2,
                                            list
                                        ];
                                }
                            });
                        });
                    }
                }
            ]);
            return BufferListMixin;
        }(_classSuper), function() {
            var _b;
            var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _getList_decorators = [
                (0, $h2kUE.action),
                $6515720bcd6dbf2b$export$e03c1c3201ee8bb7('downloading')
            ];
            $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _getList_decorators, {
                kind: "method",
                name: "getList",
                static: false,
                private: false,
                access: {
                    has: function(obj) {
                        return "getList" in obj;
                    },
                    get: function(obj) {
                        return obj.getList;
                    }
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        }(), _a;
    }();
    return BufferListMixin;
}
function $6515720bcd6dbf2b$export$6a4eb2e7fc9e8903(Super) {
    var StreamListMixin = function() {
        var _a;
        var _classSuper = Super;
        var _instanceExtraInitializers = [];
        var _restoreList_decorators;
        return _a = /*#__PURE__*/ function(_classSuper) {
            "use strict";
            (0, $hdIku._)(StreamListMixin, _classSuper);
            function StreamListMixin() {
                (0, $173N4._)(this, StreamListMixin);
                var _this;
                _this = (0, $7qXGD._)(this, StreamListMixin, arguments);
                Object.defineProperty(_this, "stream", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _instanceExtraInitializers)
                });
                return _this;
            }
            (0, $cFHGC._)(StreamListMixin, [
                {
                    key: "clearList",
                    value: function clearList() {
                        (0, $dWsrg._)((0, $kg0zo._)(StreamListMixin.prototype), "clearList", this).call(this);
                        this.stream = undefined;
                    }
                },
                {
                    key: "clear",
                    value: function clear() {
                        (0, $dWsrg._)((0, $kg0zo._)(StreamListMixin.prototype), "clear", this).call(this);
                        this.clearList();
                    }
                },
                {
                    key: "restoreList",
                    value: function restoreList() {
                        var _this = this;
                        var _super = Object.create(null, {
                            restoreList: {
                                get: function() {
                                    return (0, $dWsrg._)((0, $kg0zo._)(StreamListMixin.prototype), "restoreList", _this);
                                }
                            }
                        });
                        return $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function() {
                            var _ref, tmp, filter, tmp1, pageIndex, tmp2, pageSize, tmp3, allItems, tmp4, totalCount;
                            var _arguments = arguments;
                            return (0, $13u2V._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, tmp = _ref.filter, filter = tmp === void 0 ? this.filter : tmp, tmp1 = _ref.pageIndex, pageIndex = tmp1 === void 0 ? this.pageIndex + 1 : tmp1, tmp2 = _ref.pageSize, pageSize = tmp2 === void 0 ? this.pageSize : tmp2, tmp3 = _ref.allItems, allItems = tmp3 === void 0 ? this.allItems : tmp3, tmp4 = _ref.totalCount, totalCount = tmp4 === void 0 ? Infinity : tmp4;
                                        _super.restoreList.call(this, {
                                            pageIndex: pageIndex,
                                            pageSize: pageSize,
                                            allItems: allItems,
                                            totalCount: totalCount
                                        });
                                        if (!allItems.length) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            this.loadStream(filter, allItems.length)
                                        ];
                                    case 1:
                                        _state.sent();
                                        _state.label = 2;
                                    case 2:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    /**
                 * @protected
                 */ key: "loadStream",
                    value: function loadStream(filter, newCount) {
                        return $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function() {
                            var newList, stream, i, _ref, done, value;
                            return (0, $13u2V._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        newList = [];
                                        stream = this.stream || (this.stream = this.openStream(filter));
                                        i = 0;
                                        _state.label = 1;
                                    case 1:
                                        if (!(i < newCount)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            stream.next()
                                        ];
                                    case 2:
                                        _ref = _state.sent(), done = _ref.done, value = _ref.value;
                                        if (done) return [
                                            3,
                                            4
                                        ];
                                        newList.push(value);
                                        _state.label = 3;
                                    case 3:
                                        i++;
                                        return [
                                            3,
                                            1
                                        ];
                                    case 4:
                                        return [
                                            2,
                                            newList
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    /**
                 * @protected
                 */ key: "loadPage",
                    value: function loadPage(pageIndex, pageSize, filter) {
                        return $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function() {
                            var _this, totalCount, allItems, requiredCount, newCount, newList;
                            return (0, $13u2V._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _this = this, totalCount = _this.totalCount, allItems = _this.allItems, requiredCount = pageIndex * pageSize;
                                        newCount = (totalCount ? Math.min(totalCount, requiredCount) : requiredCount) - allItems.length;
                                        return [
                                            4,
                                            this.loadStream(filter, newCount)
                                        ];
                                    case 1:
                                        newList = _state.sent();
                                        this.pageList = (0, $lhPyT.splitArray)((0, $aUGqu._)(this.allItems).concat((0, $aUGqu._)(newList)), pageSize);
                                        return [
                                            2,
                                            {
                                                pageData: this.pageList[pageIndex - 1] || [],
                                                totalCount: this.totalCount
                                            }
                                        ];
                                }
                            });
                        });
                    }
                }
            ]);
            return StreamListMixin;
        }(_classSuper), function() {
            var _b;
            var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _restoreList_decorators = [
                $6515720bcd6dbf2b$export$e03c1c3201ee8bb7('downloading')
            ];
            $6515720bcd6dbf2b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _restoreList_decorators, {
                kind: "method",
                name: "restoreList",
                static: false,
                private: false,
                access: {
                    has: function(obj) {
                        return "restoreList" in obj;
                    },
                    get: function(obj) {
                        return obj.restoreList;
                    }
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        }(), _a;
    }();
    return StreamListMixin;
}



var $c9Z2T = parcelRequire("c9Z2T");
var $9d06fb8ddddd1436$exports = {};

$parcel$export($9d06fb8ddddd1436$exports, "FileSystemDirectoryHandle", function () { return (parcelRequire("k2i9B")).default; });
$parcel$export($9d06fb8ddddd1436$exports, "FileSystemFileHandle", function () { return (parcelRequire("ZBaWG")).default; });
$parcel$export($9d06fb8ddddd1436$exports, "FileSystemHandle", function () { return (parcelRequire("33uF2")).default; });
$parcel$export($9d06fb8ddddd1436$exports, "FileSystemWritableFileStream", function () { return (parcelRequire("9CUQs")).default; });
$parcel$export($9d06fb8ddddd1436$exports, "getOriginPrivateDirectory", function () { return $93a5f9cbf5cbb2da$export$2e2bcd8739ae039; });
$parcel$export($9d06fb8ddddd1436$exports, "showDirectoryPicker", function () { return $1718abfaf44025bf$export$2e2bcd8739ae039; });
$parcel$export($9d06fb8ddddd1436$exports, "showOpenFilePicker", function () { return $df3fefb26bbafced$export$2e2bcd8739ae039; });
$parcel$export($9d06fb8ddddd1436$exports, "showSaveFilePicker", function () { return $d6e20a8e2d11644e$export$2e2bcd8739ae039; });
/** @typedef {import('./FileSystemDirectoryHandle.js').default} FileSystemDirectoryHandle */ 
var $3gP77 = parcelRequire("3gP77");

var $13u2V = parcelRequire("13u2V");
var $1718abfaf44025bf$var$native = globalThis.showDirectoryPicker;

/**
 * @param {Object} [options]
 * @param {boolean} [options._preferPolyfill] If you rather want to use the polyfill instead of the native
 * @returns {Promise<FileSystemDirectoryHandle>}
 */ function $1718abfaf44025bf$export$6030ffa7b5d2eb28() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var options, input, p;
        var _arguments = arguments;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    if ($1718abfaf44025bf$var$native && !options._preferPolyfill) return [
                        2,
                        $1718abfaf44025bf$var$native(options)
                    ];
                    input = document.createElement('input');
                    input.type = 'file';
                    input.webkitdirectory = true;
                    // Fallback to multiple files input for iOS Safari
                    input.multiple = true;
                    // See https://stackoverflow.com/questions/47664777/javascript-file-input-onchange-not-working-ios-safari-only
                    input.style.position = 'fixed';
                    input.style.top = '-100000px';
                    input.style.left = '-100000px';
                    document.body.appendChild(input);
                    // Lazy load while the user is choosing the directory
                    p = Promise.resolve((parcelRequire("2taKJ")));
                    return [
                        4,
                        new Promise(function(resolve) {
                            input.addEventListener('change', resolve);
                            input.click();
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        p.then(function(mod) {
                            return mod.getDirHandlesFromInput(input);
                        })
                    ];
            }
        });
    }).apply(this, arguments);
}
var $1718abfaf44025bf$export$2e2bcd8739ae039 = $1718abfaf44025bf$export$6030ffa7b5d2eb28;


/** @typedef {import('./FileSystemFileHandle.js').default} FileSystemFileHandle */ 
var $3gP77 = parcelRequire("3gP77");

var $1XAnY = parcelRequire("1XAnY");

var $aUGqu = parcelRequire("aUGqu");

var $13u2V = parcelRequire("13u2V");
var $df3fefb26bbafced$var$def = {
    accepts: []
};
var $df3fefb26bbafced$var$native = globalThis.showOpenFilePicker;

/**
 * @param {Object} [options]
 * @param {boolean} [options.multiple] If you want to allow more than one file
 * @param {boolean} [options.excludeAcceptAllOption=false] Prevent user for selecting any
 * @param {Object[]} [options.accepts] Files you want to accept
 * @param {boolean} [options._preferPolyfill] If you rather want to use the polyfill instead of the native
 * @returns {Promise<FileSystemFileHandle[]>}
 */ function $df3fefb26bbafced$export$9a17f2258b27c445() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var options, opts, input, p;
        var _arguments = arguments;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    opts = (0, $1XAnY._)({}, $df3fefb26bbafced$var$def, options);
                    if ($df3fefb26bbafced$var$native && !options._preferPolyfill) return [
                        2,
                        $df3fefb26bbafced$var$native(opts)
                    ];
                    input = document.createElement('input');
                    input.type = 'file';
                    input.multiple = opts.multiple;
                    input.accept = (opts.accepts || []).map(function(e) {
                        return (0, $aUGqu._)((e.extensions || []).map(function(e) {
                            return '.' + e;
                        })).concat((0, $aUGqu._)(e.mimeTypes || []));
                    }).flat().join(',');
                    // See https://stackoverflow.com/questions/47664777/javascript-file-input-onchange-not-working-ios-safari-only
                    Object.assign(input.style, {
                        position: 'fixed',
                        top: '-100000px',
                        left: '-100000px'
                    });
                    document.body.appendChild(input);
                    // Lazy load while the user is choosing the directory
                    p = Promise.resolve((parcelRequire("2taKJ")));
                    return [
                        4,
                        new Promise(function(resolve) {
                            input.addEventListener('change', resolve, {
                                once: true
                            });
                            input.click();
                        })
                    ];
                case 1:
                    _state.sent();
                    input.remove();
                    return [
                        2,
                        p.then(function(m) {
                            return m.getFileHandlesFromInput(input);
                        })
                    ];
            }
        });
    }).apply(this, arguments);
}
var $df3fefb26bbafced$export$2e2bcd8739ae039 = $df3fefb26bbafced$export$9a17f2258b27c445;


/** @typedef {import('./FileSystemFileHandle.js').default} FileSystemFileHandle */ 
var $3gP77 = parcelRequire("3gP77");

var $13u2V = parcelRequire("13u2V");
var $d6e20a8e2d11644e$var$native = globalThis.showSaveFilePicker;


/**
 * @param {Object} [options]
 * @param {boolean} [options.excludeAcceptAllOption=false] Prevent user for selecting any
 * @param {Object[]} [options.types] Files you want to accept
 * @param {string} [options.suggestedName] the name to fall back to when using polyfill
 * @param {string} [options._name] the name to fall back to when using polyfill
 * @param {boolean} [options._preferPolyfill] If you rather want to use the polyfill instead of the native
 * @return {Promise<FileSystemFileHandle>}
 */ function $d6e20a8e2d11644e$export$f8b17fb0c2d91989() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var options, FileSystemFileHandle, FileHandle;
        var _arguments = arguments;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    if ($d6e20a8e2d11644e$var$native && !options._preferPolyfill) return [
                        2,
                        $d6e20a8e2d11644e$var$native(options)
                    ];
                    if (options._name) {
                        console.warn('deprecated _name, spec now have `suggestedName`');
                        options.suggestedName = options._name;
                    }
                    return [
                        4,
                        Promise.resolve((parcelRequire("ZBaWG")))
                    ];
                case 1:
                    FileSystemFileHandle = _state.sent().FileSystemFileHandle;
                    return [
                        4,
                        (parcelRequire("glFKd"))
                    ];
                case 2:
                    FileHandle = _state.sent().FileHandle;
                    return [
                        2,
                        new FileSystemFileHandle(new FileHandle(options.suggestedName))
                    ];
            }
        });
    }).apply(this, arguments);
}
var $d6e20a8e2d11644e$export$2e2bcd8739ae039 = $d6e20a8e2d11644e$export$f8b17fb0c2d91989;


/** @typedef {import('./FileSystemDirectoryHandle.js').default} FileSystemDirectoryHandle */ 
var $3gP77 = parcelRequire("3gP77");

var $f9AOD = parcelRequire("f9AOD");

var $13u2V = parcelRequire("13u2V");



if (globalThis.DataTransferItem && !DataTransferItem.prototype.getAsFileSystemHandle) DataTransferItem.prototype.getAsFileSystemHandle = function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var entry, _ref, _ref_, FileHandle, FolderHandle, FileSystemDirectoryHandle, FileSystemFileHandle;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    entry = this.webkitGetAsEntry();
                    return [
                        4,
                        Promise.all([
                            (parcelRequire("9xvOC")),
                            Promise.resolve((parcelRequire("k2i9B"))),
                            Promise.resolve((parcelRequire("ZBaWG")))
                        ])
                    ];
                case 1:
                    _ref = (0, $f9AOD._).apply(void 0, [
                        _state.sent(),
                        3
                    ]), _ref_ = _ref[0], FileHandle = _ref_.FileHandle, FolderHandle = _ref_.FolderHandle, FileSystemDirectoryHandle = _ref[1].FileSystemDirectoryHandle, FileSystemFileHandle = _ref[2].FileSystemFileHandle;
                    return [
                        2,
                        entry.isFile ? new FileSystemFileHandle(new FileHandle(entry, false)) : new FileSystemDirectoryHandle(new FolderHandle(entry, false))
                    ];
            }
        });
    }).call(this);
};

/**
 * @param {object=} driver
 * @return {Promise<FileSystemDirectoryHandle>}
 */ function $93a5f9cbf5cbb2da$var$getOriginPrivateDirectory(_0) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function(driver) {
        var options, _globalThis_navigator_storage, _globalThis_navigator, FileSystemDirectoryHandle, module, sandbox;
        var _arguments = arguments;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    if (!driver) return [
                        2,
                        ((_globalThis_navigator = globalThis.navigator) === null || _globalThis_navigator === void 0 ? void 0 : (_globalThis_navigator_storage = _globalThis_navigator.storage) === null || _globalThis_navigator_storage === void 0 ? void 0 : _globalThis_navigator_storage.getDirectory()) || globalThis.getOriginPrivateDirectory()
                    ];
                    return [
                        4,
                        Promise.resolve((parcelRequire("k2i9B")))
                    ];
                case 1:
                    FileSystemDirectoryHandle = _state.sent().FileSystemDirectoryHandle;
                    return [
                        4,
                        driver
                    ];
                case 2:
                    module = _state.sent();
                    return [
                        4,
                        module.default ? module.default(options) : module(options)
                    ];
                case 3:
                    sandbox = _state.sent();
                    return [
                        2,
                        new FileSystemDirectoryHandle(sandbox)
                    ];
            }
        });
    }).apply(this, arguments);
}
var $93a5f9cbf5cbb2da$export$2e2bcd8739ae039 = $93a5f9cbf5cbb2da$var$getOriginPrivateDirectory;



var $9CUQs = parcelRequire("9CUQs");

var $k2i9B = parcelRequire("k2i9B");

var $ZBaWG = parcelRequire("ZBaWG");

var $33uF2 = parcelRequire("33uF2");



var $lhPyT = parcelRequire("lhPyT");

var $318vE = parcelRequire("318vE");
function $60166336233982b2$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $60166336233982b2$var$$eaae1d79f358eeb1$exports = {};
$60166336233982b2$var$$parcel$export($60166336233982b2$var$$eaae1d79f358eeb1$exports, "HTTPDownloadTask", function() {
    return $60166336233982b2$export$54a5aef4e85ae85;
});
var $60166336233982b2$var$$2305cbd960c24ac6$exports = {};
$60166336233982b2$var$$parcel$export($60166336233982b2$var$$2305cbd960c24ac6$exports, "DownloadTask", function() {
    return $60166336233982b2$export$e9ba70c733fe1cb8;
});
var $60166336233982b2$var$$2305cbd960c24ac6$var$__runInitializers = function $2305cbd960c24ac6$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $60166336233982b2$var$$2305cbd960c24ac6$var$__esDecorate = function $2305cbd960c24ac6$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $7E0eS._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $60166336233982b2$var$$2305cbd960c24ac6$var$__awaiter = function $2305cbd960c24ac6$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $60166336233982b2$var$$2305cbd960c24ac6$var$__classPrivateFieldGet = function $2305cbd960c24ac6$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $60166336233982b2$var$$2305cbd960c24ac6$var$__classPrivateFieldSet = function $2305cbd960c24ac6$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $60166336233982b2$var$$2305cbd960c24ac6$var$__rest = function $2305cbd960c24ac6$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $60166336233982b2$var$$2305cbd960c24ac6$var$__asyncValues = function $2305cbd960c24ac6$var$__asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $60166336233982b2$export$e9ba70c733fe1cb8 = function() {
    var _a, _DownloadTask_id_accessor_storage, _DownloadTask_name_accessor_storage, _DownloadTask_path_accessor_storage, _DownloadTask_fsHandle_accessor_storage, _DownloadTask_total_accessor_storage, _DownloadTask_loaded_accessor_storage, _DownloadTask_percent_accessor_storage, _DownloadTask_executing_accessor_storage, _DownloadTask_options_accessor_storage;
    var _b;
    var _instanceExtraInitializers = [];
    var _id_decorators;
    var _id_initializers = [];
    var _id_extraInitializers = [];
    var _name_decorators;
    var _name_initializers = [];
    var _name_extraInitializers = [];
    var _path_decorators;
    var _path_initializers = [];
    var _path_extraInitializers = [];
    var _fsHandle_decorators;
    var _fsHandle_initializers = [];
    var _fsHandle_extraInitializers = [];
    var _total_decorators;
    var _total_initializers = [];
    var _total_extraInitializers = [];
    var _loaded_decorators;
    var _loaded_initializers = [];
    var _loaded_extraInitializers = [];
    var _percent_decorators;
    var _percent_initializers = [];
    var _percent_extraInitializers = [];
    var _executing_decorators;
    var _executing_initializers = [];
    var _executing_extraInitializers = [];
    var _options_decorators;
    var _options_initializers = [];
    var _options_extraInitializers = [];
    var _get_totalSize_decorators;
    var _get_loadedSize_decorators;
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function DownloadTask(path) {
            var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _a.nameOf(path);
            (0, $173N4._)(this, DownloadTask);
            _DownloadTask_id_accessor_storage.set(this, ($60166336233982b2$var$$2305cbd960c24ac6$var$__runInitializers(this, _instanceExtraInitializers), $60166336233982b2$var$$2305cbd960c24ac6$var$__runInitializers(this, _id_initializers, '')));
            _DownloadTask_name_accessor_storage.set(this, ($60166336233982b2$var$$2305cbd960c24ac6$var$__runInitializers(this, _id_extraInitializers), $60166336233982b2$var$$2305cbd960c24ac6$var$__runInitializers(this, _name_initializers, '')));
            _DownloadTask_path_accessor_storage.set(this, ($60166336233982b2$var$$2305cbd960c24ac6$var$__runInitializers(this, _name_extraInitializers), $60166336233982b2$var$$2305cbd960c24ac6$var$__runInitializers(this, _path_initializers, '')));
            _DownloadTask_fsHandle_accessor_storage.set(this, ($60166336233982b2$var$$2305cbd960c24ac6$var$__runInitializers(this, _path_extraInitializers), $60166336233982b2$var$$2305cbd960c24ac6$var$__runInitializers(this, _fsHandle_initializers, void 0)));
            _DownloadTask_total_accessor_storage.set(this, ($60166336233982b2$var$$2305cbd960c24ac6$var$__runInitializers(this, _fsHandle_extraInitializers), $60166336233982b2$var$$2305cbd960c24ac6$var$__runInitializers(this, _total_initializers, 0)));
            _DownloadTask_loaded_accessor_storage.set(this, ($60166336233982b2$var$$2305cbd960c24ac6$var$__runInitializers(this, _total_extraInitializers), $60166336233982b2$var$$2305cbd960c24ac6$var$__runInitializers(this, _loaded_initializers, 0)));
            _DownloadTask_percent_accessor_storage.set(this, ($60166336233982b2$var$$2305cbd960c24ac6$var$__runInitializers(this, _loaded_extraInitializers), $60166336233982b2$var$$2305cbd960c24ac6$var$__runInitializers(this, _percent_initializers, 0)));
            _DownloadTask_executing_accessor_storage.set(this, ($60166336233982b2$var$$2305cbd960c24ac6$var$__runInitializers(this, _percent_extraInitializers), $60166336233982b2$var$$2305cbd960c24ac6$var$__runInitializers(this, _executing_initializers, false)));
            _DownloadTask_options_accessor_storage.set(this, ($60166336233982b2$var$$2305cbd960c24ac6$var$__runInitializers(this, _executing_extraInitializers), $60166336233982b2$var$$2305cbd960c24ac6$var$__runInitializers(this, _options_initializers, void 0)));
            Object.defineProperty(this, "stream", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $60166336233982b2$var$$2305cbd960c24ac6$var$__runInitializers(this, _options_extraInitializers)
            });
            this.path = path;
            this.name = name;
        }
        (0, $cFHGC._)(DownloadTask, [
            {
                key: "id",
                get: function get() {
                    return $60166336233982b2$var$$2305cbd960c24ac6$var$__classPrivateFieldGet(this, _DownloadTask_id_accessor_storage, "f");
                },
                set: function set(value) {
                    $60166336233982b2$var$$2305cbd960c24ac6$var$__classPrivateFieldSet(this, _DownloadTask_id_accessor_storage, value, "f");
                }
            },
            {
                key: "name",
                get: function get() {
                    return $60166336233982b2$var$$2305cbd960c24ac6$var$__classPrivateFieldGet(this, _DownloadTask_name_accessor_storage, "f");
                },
                set: function set(value) {
                    $60166336233982b2$var$$2305cbd960c24ac6$var$__classPrivateFieldSet(this, _DownloadTask_name_accessor_storage, value, "f");
                }
            },
            {
                key: "path",
                get: function get() {
                    return $60166336233982b2$var$$2305cbd960c24ac6$var$__classPrivateFieldGet(this, _DownloadTask_path_accessor_storage, "f");
                },
                set: function set(value) {
                    $60166336233982b2$var$$2305cbd960c24ac6$var$__classPrivateFieldSet(this, _DownloadTask_path_accessor_storage, value, "f");
                }
            },
            {
                key: "fsHandle",
                get: function get() {
                    return $60166336233982b2$var$$2305cbd960c24ac6$var$__classPrivateFieldGet(this, _DownloadTask_fsHandle_accessor_storage, "f");
                },
                set: function set(value) {
                    $60166336233982b2$var$$2305cbd960c24ac6$var$__classPrivateFieldSet(this, _DownloadTask_fsHandle_accessor_storage, value, "f");
                }
            },
            {
                key: "total",
                get: function get() {
                    return $60166336233982b2$var$$2305cbd960c24ac6$var$__classPrivateFieldGet(this, _DownloadTask_total_accessor_storage, "f");
                },
                set: function set(value) {
                    $60166336233982b2$var$$2305cbd960c24ac6$var$__classPrivateFieldSet(this, _DownloadTask_total_accessor_storage, value, "f");
                }
            },
            {
                key: "loaded",
                get: function get() {
                    return $60166336233982b2$var$$2305cbd960c24ac6$var$__classPrivateFieldGet(this, _DownloadTask_loaded_accessor_storage, "f");
                },
                set: function set(value) {
                    $60166336233982b2$var$$2305cbd960c24ac6$var$__classPrivateFieldSet(this, _DownloadTask_loaded_accessor_storage, value, "f");
                }
            },
            {
                key: "percent",
                get: function get() {
                    return $60166336233982b2$var$$2305cbd960c24ac6$var$__classPrivateFieldGet(this, _DownloadTask_percent_accessor_storage, "f");
                },
                set: function set(value) {
                    $60166336233982b2$var$$2305cbd960c24ac6$var$__classPrivateFieldSet(this, _DownloadTask_percent_accessor_storage, value, "f");
                }
            },
            {
                key: "executing",
                get: function get() {
                    return $60166336233982b2$var$$2305cbd960c24ac6$var$__classPrivateFieldGet(this, _DownloadTask_executing_accessor_storage, "f");
                },
                set: function set(value) {
                    $60166336233982b2$var$$2305cbd960c24ac6$var$__classPrivateFieldSet(this, _DownloadTask_executing_accessor_storage, value, "f");
                }
            },
            {
                key: "options",
                get: function get() {
                    return $60166336233982b2$var$$2305cbd960c24ac6$var$__classPrivateFieldGet(this, _DownloadTask_options_accessor_storage, "f");
                },
                set: function set(value) {
                    $60166336233982b2$var$$2305cbd960c24ac6$var$__classPrivateFieldSet(this, _DownloadTask_options_accessor_storage, value, "f");
                }
            },
            {
                key: "totalSize",
                get: function get() {
                    return new (0, $lhPyT.ByteSize)(this.total);
                }
            },
            {
                key: "loadedSize",
                get: function get() {
                    return new (0, $lhPyT.ByteSize)(this.loaded);
                }
            },
            {
                key: "toJSON",
                value: function toJSON() {
                    var _this = this, id = _this.id, name = _this.name, path = _this.path, fsHandle = _this.fsHandle, total = _this.total, loaded = _this.loaded, percent = _this.percent, options = _this.options;
                    return Object.assign({
                        id: id,
                        name: name,
                        path: path,
                        fsHandle: fsHandle,
                        options: options
                    }, {
                        total: total,
                        loaded: loaded,
                        percent: percent
                    });
                }
            },
            {
                key: "saveMeta",
                value: function saveMeta() {
                    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    var buffer = data.buffer, progress = $60166336233982b2$var$$2305cbd960c24ac6$var$__rest(data, [
                        "buffer"
                    ]);
                    Object.assign(this, progress);
                    return data;
                }
            },
            {
                key: "start",
                value: function start() {
                    return $60166336233982b2$var$$2305cbd960c24ac6$var$__awaiter(this, arguments, void 0, function() {
                        var _this, options, started, _ReadableStream_from_tee, innerStream, outerStream;
                        var _arguments = arguments;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this = this;
                                    options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : this.options;
                                    this.options = options;
                                    started = Promise.withResolvers();
                                    return [
                                        4,
                                        $318vE
                                    ];
                                case 1:
                                    _ReadableStream_from_tee = (0, $f9AOD._).apply(void 0, [
                                        _state.sent().ReadableStream.from(this.loadStream(options)).tee(),
                                        2
                                    ]), innerStream = _ReadableStream_from_tee[0], outerStream = _ReadableStream_from_tee[1];
                                    (function() {
                                        return $60166336233982b2$var$$2305cbd960c24ac6$var$__awaiter(_this, void 0, void 0, function() {
                                            var _b, e_1, _c, _d, _e, innerStream_1, innerStream_1_1, chunk, e_1_1, error;
                                            return (0, $13u2V._)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _state.trys.push([
                                                            0,
                                                            13,
                                                            ,
                                                            14
                                                        ]);
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            6,
                                                            7,
                                                            12
                                                        ]);
                                                        _e = true, innerStream_1 = $60166336233982b2$var$$2305cbd960c24ac6$var$__asyncValues(innerStream);
                                                        _state.label = 2;
                                                    case 2:
                                                        return [
                                                            4,
                                                            innerStream_1.next()
                                                        ];
                                                    case 3:
                                                        if (!(innerStream_1_1 = _state.sent(), _b = innerStream_1_1.done, !_b)) return [
                                                            3,
                                                            5
                                                        ];
                                                        _d = innerStream_1_1.value;
                                                        _e = false;
                                                        chunk = _d;
                                                        started.resolve();
                                                        console.table(chunk);
                                                        _state.label = 4;
                                                    case 4:
                                                        _e = true;
                                                        return [
                                                            3,
                                                            2
                                                        ];
                                                    case 5:
                                                        return [
                                                            3,
                                                            12
                                                        ];
                                                    case 6:
                                                        e_1_1 = _state.sent();
                                                        e_1 = {
                                                            error: e_1_1
                                                        };
                                                        return [
                                                            3,
                                                            12
                                                        ];
                                                    case 7:
                                                        _state.trys.push([
                                                            7,
                                                            ,
                                                            10,
                                                            11
                                                        ]);
                                                        if (!(!_e && !_b && (_c = innerStream_1.return))) return [
                                                            3,
                                                            9
                                                        ];
                                                        return [
                                                            4,
                                                            _c.call(innerStream_1)
                                                        ];
                                                    case 8:
                                                        _state.sent();
                                                        _state.label = 9;
                                                    case 9:
                                                        return [
                                                            3,
                                                            11
                                                        ];
                                                    case 10:
                                                        if (e_1) throw e_1.error;
                                                        return [
                                                            7
                                                        ];
                                                    case 11:
                                                        return [
                                                            7
                                                        ];
                                                    case 12:
                                                        return [
                                                            3,
                                                            14
                                                        ];
                                                    case 13:
                                                        error = _state.sent();
                                                        started.reject(error);
                                                        return [
                                                            3,
                                                            14
                                                        ];
                                                    case 14:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                    })();
                                    return [
                                        4,
                                        started.promise
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        2,
                                        this.stream = outerStream
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "pause",
                value: function pause() {
                    return $60166336233982b2$var$$2305cbd960c24ac6$var$__awaiter(this, void 0, void 0, function() {
                        return (0, $13u2V._)(this, function(_state) {
                            this.executing = false;
                            return [
                                2
                            ];
                        });
                    });
                }
            },
            {
                key: "destroy",
                value: function destroy() {
                    return $60166336233982b2$var$$2305cbd960c24ac6$var$__awaiter(this, void 0, void 0, function() {
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.pause()
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2,
                                        (0, $6515720bcd6dbf2b$export$b1fb4cac938035f7)(this, this.id)
                                    ];
                            }
                        });
                    });
                }
            }
        ], [
            {
                key: "nameOf",
                value: function nameOf(URI) {
                    return decodeURI(new URL(URI).pathname.split('/').filter(Boolean).at(-1));
                }
            }
        ]);
        return DownloadTask;
    }(), _DownloadTask_id_accessor_storage = new WeakMap(), _DownloadTask_name_accessor_storage = new WeakMap(), _DownloadTask_path_accessor_storage = new WeakMap(), _DownloadTask_fsHandle_accessor_storage = new WeakMap(), _DownloadTask_total_accessor_storage = new WeakMap(), _DownloadTask_loaded_accessor_storage = new WeakMap(), _DownloadTask_percent_accessor_storage = new WeakMap(), _DownloadTask_executing_accessor_storage = new WeakMap(), _DownloadTask_options_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _id_decorators = [
            (0, $6515720bcd6dbf2b$export$9a6132153fba2e0)(),
            (0, $h2kUE.observable)
        ];
        _name_decorators = [
            (0, $6515720bcd6dbf2b$export$9a6132153fba2e0)(),
            (0, $h2kUE.observable)
        ];
        _path_decorators = [
            (0, $6515720bcd6dbf2b$export$9a6132153fba2e0)(),
            (0, $h2kUE.observable)
        ];
        _fsHandle_decorators = [
            (0, $6515720bcd6dbf2b$export$9a6132153fba2e0)(),
            (_b = (0, $h2kUE.observable)).ref.bind(_b)
        ];
        _total_decorators = [
            (0, $6515720bcd6dbf2b$export$9a6132153fba2e0)(),
            (0, $h2kUE.observable)
        ];
        _loaded_decorators = [
            (0, $6515720bcd6dbf2b$export$9a6132153fba2e0)(),
            (0, $h2kUE.observable)
        ];
        _percent_decorators = [
            (0, $6515720bcd6dbf2b$export$9a6132153fba2e0)(),
            (0, $h2kUE.observable)
        ];
        _executing_decorators = [
            (0, $h2kUE.observable)
        ];
        _options_decorators = [
            (0, $6515720bcd6dbf2b$export$9a6132153fba2e0)(),
            (0, $h2kUE.observable)
        ];
        _get_totalSize_decorators = [
            (0, $h2kUE.computed)
        ];
        _get_loadedSize_decorators = [
            (0, $h2kUE.computed)
        ];
        $60166336233982b2$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _id_decorators, {
            kind: "accessor",
            name: "id",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "id" in obj;
                },
                get: function(obj) {
                    return obj.id;
                },
                set: function(obj, value) {
                    obj.id = value;
                }
            },
            metadata: _metadata
        }, _id_initializers, _id_extraInitializers);
        $60166336233982b2$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _name_decorators, {
            kind: "accessor",
            name: "name",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "name" in obj;
                },
                get: function(obj) {
                    return obj.name;
                },
                set: function(obj, value) {
                    obj.name = value;
                }
            },
            metadata: _metadata
        }, _name_initializers, _name_extraInitializers);
        $60166336233982b2$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _path_decorators, {
            kind: "accessor",
            name: "path",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "path" in obj;
                },
                get: function(obj) {
                    return obj.path;
                },
                set: function(obj, value) {
                    obj.path = value;
                }
            },
            metadata: _metadata
        }, _path_initializers, _path_extraInitializers);
        $60166336233982b2$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _fsHandle_decorators, {
            kind: "accessor",
            name: "fsHandle",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "fsHandle" in obj;
                },
                get: function(obj) {
                    return obj.fsHandle;
                },
                set: function(obj, value) {
                    obj.fsHandle = value;
                }
            },
            metadata: _metadata
        }, _fsHandle_initializers, _fsHandle_extraInitializers);
        $60166336233982b2$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _total_decorators, {
            kind: "accessor",
            name: "total",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "total" in obj;
                },
                get: function(obj) {
                    return obj.total;
                },
                set: function(obj, value) {
                    obj.total = value;
                }
            },
            metadata: _metadata
        }, _total_initializers, _total_extraInitializers);
        $60166336233982b2$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _loaded_decorators, {
            kind: "accessor",
            name: "loaded",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "loaded" in obj;
                },
                get: function(obj) {
                    return obj.loaded;
                },
                set: function(obj, value) {
                    obj.loaded = value;
                }
            },
            metadata: _metadata
        }, _loaded_initializers, _loaded_extraInitializers);
        $60166336233982b2$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _percent_decorators, {
            kind: "accessor",
            name: "percent",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "percent" in obj;
                },
                get: function(obj) {
                    return obj.percent;
                },
                set: function(obj, value) {
                    obj.percent = value;
                }
            },
            metadata: _metadata
        }, _percent_initializers, _percent_extraInitializers);
        $60166336233982b2$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _executing_decorators, {
            kind: "accessor",
            name: "executing",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "executing" in obj;
                },
                get: function(obj) {
                    return obj.executing;
                },
                set: function(obj, value) {
                    obj.executing = value;
                }
            },
            metadata: _metadata
        }, _executing_initializers, _executing_extraInitializers);
        $60166336233982b2$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _options_decorators, {
            kind: "accessor",
            name: "options",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "options" in obj;
                },
                get: function(obj) {
                    return obj.options;
                },
                set: function(obj, value) {
                    obj.options = value;
                }
            },
            metadata: _metadata
        }, _options_initializers, _options_extraInitializers);
        $60166336233982b2$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _get_totalSize_decorators, {
            kind: "getter",
            name: "totalSize",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "totalSize" in obj;
                },
                get: function(obj) {
                    return obj.totalSize;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $60166336233982b2$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _get_loadedSize_decorators, {
            kind: "getter",
            name: "loadedSize",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "loadedSize" in obj;
                },
                get: function(obj) {
                    return obj.loadedSize;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $60166336233982b2$var$$eaae1d79f358eeb1$var$__await = function $eaae1d79f358eeb1$var$__await1(v) {
    return this instanceof $60166336233982b2$var$$eaae1d79f358eeb1$var$__await ? (this.v = v, this) : new $60166336233982b2$var$$eaae1d79f358eeb1$var$__await(v);
};
var $60166336233982b2$var$$eaae1d79f358eeb1$var$__asyncValues = function $eaae1d79f358eeb1$var$__asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $60166336233982b2$var$$eaae1d79f358eeb1$var$__asyncGenerator = function $eaae1d79f358eeb1$var$__asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $60166336233982b2$var$$eaae1d79f358eeb1$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $60166336233982b2$export$54a5aef4e85ae85 = /*#__PURE__*/ function($2305cbd960c24ac6$export$e9ba70c733fe1cb81) {
    "use strict";
    (0, $hdIku._)($eaae1d79f358eeb1$export$54a5aef4e85ae85, $2305cbd960c24ac6$export$e9ba70c733fe1cb81);
    function $eaae1d79f358eeb1$export$54a5aef4e85ae85(path, name) {
        (0, $173N4._)(this, $eaae1d79f358eeb1$export$54a5aef4e85ae85);
        var _this;
        _this = (0, $7qXGD._)(this, $eaae1d79f358eeb1$export$54a5aef4e85ae85, [
            path,
            name
        ]);
        Object.defineProperty(_this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new (0, $c9Z2T.HTTPClient)({
                responseType: 'arraybuffer'
            })
        });
        _this.id = "http-download-task-".concat(_this.name);
        (0, $6515720bcd6dbf2b$export$db239ef39aadc7fe)(_this, _this.id);
        return _this;
    }
    (0, $cFHGC._)($eaae1d79f358eeb1$export$54a5aef4e85ae85, [
        {
            key: "loadStream",
            value: function loadStream(options) {
                return $60166336233982b2$var$$eaae1d79f358eeb1$var$__asyncGenerator(this, arguments, function loadStream_1() {
                    var _a, e_1, _b, _c, _this, path, suggestedName, _tmp, _, writer, stream, _d, stream_1, stream_1_1, chunk, e_1_1;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this, path = _this.path;
                                suggestedName = $60166336233982b2$export$e9ba70c733fe1cb8.nameOf(path);
                                _tmp = this.fsHandle;
                                if (_tmp) return [
                                    3,
                                    3
                                ];
                                _ = this;
                                return [
                                    4,
                                    $60166336233982b2$var$$eaae1d79f358eeb1$var$__await($9d06fb8ddddd1436$exports)
                                ];
                            case 1:
                                return [
                                    4,
                                    $60166336233982b2$var$$eaae1d79f358eeb1$var$__await.apply(void 0, [
                                        _state.sent().showSaveFilePicker({
                                            suggestedName: suggestedName
                                        })
                                    ])
                                ];
                            case 2:
                                _tmp = _.fsHandle = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    4,
                                    $60166336233982b2$var$$eaae1d79f358eeb1$var$__await(this.fsHandle.createWritable({
                                        keepExistingData: true
                                    }))
                                ];
                            case 4:
                                writer = _state.sent(), stream = this.client.download(path, Object.assign({
                                    range: [
                                        this.loaded
                                    ]
                                }, options));
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    ,
                                    21,
                                    23
                                ]);
                                this.executing = true;
                                _state.label = 6;
                            case 6:
                                _state.trys.push([
                                    6,
                                    14,
                                    15,
                                    20
                                ]);
                                _d = true, stream_1 = $60166336233982b2$var$$eaae1d79f358eeb1$var$__asyncValues(stream);
                                _state.label = 7;
                            case 7:
                                return [
                                    4,
                                    $60166336233982b2$var$$eaae1d79f358eeb1$var$__await(stream_1.next())
                                ];
                            case 8:
                                if (!(stream_1_1 = _state.sent(), _a = stream_1_1.done, !_a)) return [
                                    3,
                                    13
                                ];
                                _c = stream_1_1.value;
                                _d = false;
                                chunk = _c;
                                return [
                                    4,
                                    $60166336233982b2$var$$eaae1d79f358eeb1$var$__await(writer.write({
                                        type: 'write',
                                        position: this.loaded,
                                        data: chunk.buffer
                                    }))
                                ];
                            case 9:
                                _state.sent();
                                return [
                                    4,
                                    $60166336233982b2$var$$eaae1d79f358eeb1$var$__await(this.saveMeta(chunk))
                                ];
                            case 10:
                                return [
                                    4,
                                    _state.sent()
                                ];
                            case 11:
                                _state.sent();
                                if (!this.executing) return [
                                    3,
                                    13
                                ];
                                _state.label = 12;
                            case 12:
                                _d = true;
                                return [
                                    3,
                                    7
                                ];
                            case 13:
                                return [
                                    3,
                                    20
                                ];
                            case 14:
                                e_1_1 = _state.sent();
                                e_1 = {
                                    error: e_1_1
                                };
                                return [
                                    3,
                                    20
                                ];
                            case 15:
                                _state.trys.push([
                                    15,
                                    ,
                                    18,
                                    19
                                ]);
                                if (!(!_d && !_a && (_b = stream_1.return))) return [
                                    3,
                                    17
                                ];
                                return [
                                    4,
                                    $60166336233982b2$var$$eaae1d79f358eeb1$var$__await(_b.call(stream_1))
                                ];
                            case 16:
                                _state.sent();
                                _state.label = 17;
                            case 17:
                                return [
                                    3,
                                    19
                                ];
                            case 18:
                                if (e_1) throw e_1.error;
                                return [
                                    7
                                ];
                            case 19:
                                return [
                                    7
                                ];
                            case 20:
                                return [
                                    3,
                                    23
                                ];
                            case 21:
                                return [
                                    4,
                                    $60166336233982b2$var$$eaae1d79f358eeb1$var$__await(writer.close())
                                ];
                            case 22:
                                _state.sent();
                                this.executing = false;
                                return [
                                    7
                                ];
                            case 23:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return $eaae1d79f358eeb1$export$54a5aef4e85ae85;
}($60166336233982b2$export$e9ba70c733fe1cb8);
var $60166336233982b2$var$$53eb72fe5615c114$var$__runInitializers = function $53eb72fe5615c114$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $60166336233982b2$var$$53eb72fe5615c114$var$__esDecorate = function $53eb72fe5615c114$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $7E0eS._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $60166336233982b2$var$$53eb72fe5615c114$var$__awaiter = function $53eb72fe5615c114$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $60166336233982b2$var$$53eb72fe5615c114$var$__classPrivateFieldGet = function $53eb72fe5615c114$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $60166336233982b2$var$$53eb72fe5615c114$var$__classPrivateFieldSet = function $53eb72fe5615c114$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $60166336233982b2$export$ef06e7620d37c296 = function() {
    var _a, _Downloader_tasks_accessor_storage;
    var _instanceExtraInitializers = [];
    var _tasks_decorators;
    var _tasks_initializers = [];
    var _tasks_extraInitializers = [];
    var _get_unfinishedCount_decorators;
    var _get_executingCount_decorators;
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function Downloader() {
            (0, $173N4._)(this, Downloader);
            _Downloader_tasks_accessor_storage.set(this, ($60166336233982b2$var$$53eb72fe5615c114$var$__runInitializers(this, _instanceExtraInitializers), $60166336233982b2$var$$53eb72fe5615c114$var$__runInitializers(this, _tasks_initializers, [])));
            $60166336233982b2$var$$53eb72fe5615c114$var$__runInitializers(this, _tasks_extraInitializers);
            (0, $6515720bcd6dbf2b$export$db239ef39aadc7fe)(this, 'downloader');
        }
        (0, $cFHGC._)(Downloader, [
            {
                key: "tasks",
                get: function get() {
                    return $60166336233982b2$var$$53eb72fe5615c114$var$__classPrivateFieldGet(this, _Downloader_tasks_accessor_storage, "f");
                },
                set: function set(value) {
                    $60166336233982b2$var$$53eb72fe5615c114$var$__classPrivateFieldSet(this, _Downloader_tasks_accessor_storage, value, "f");
                }
            },
            {
                key: "unfinishedCount",
                get: function get() {
                    return this.tasks.filter(function(param) {
                        var percent = param.percent;
                        return percent < 100;
                    }).length;
                }
            },
            {
                key: "executingCount",
                get: function get() {
                    return this.tasks.filter(function(param) {
                        var executing = param.executing;
                        return executing;
                    }).length;
                }
            },
            {
                key: "createTask",
                value: function createTask(path, name) {
                    var _this = this, tasks = _this.tasks;
                    var sameTask = tasks.find(function(task) {
                        return task.path === path;
                    });
                    if (sameTask) return sameTask;
                    var task = _a.createTask(path, name);
                    this.tasks = (0, $aUGqu._)(tasks).concat([
                        task
                    ]);
                    return task;
                }
            },
            {
                key: "destroyTask",
                value: function destroyTask(name) {
                    return $60166336233982b2$var$$53eb72fe5615c114$var$__awaiter(this, void 0, void 0, function() {
                        var _this, tasks, index;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this = this, tasks = _this.tasks;
                                    index = tasks.findIndex(function(param) {
                                        var N = param.name;
                                        return N === name;
                                    });
                                    if (index < 0) throw new ReferenceError("".concat(name, " isn't found"));
                                    return [
                                        4,
                                        tasks[index].destroy()
                                    ];
                                case 1:
                                    _state.sent();
                                    this.tasks = (0, $aUGqu._)(tasks.slice(0, index)).concat((0, $aUGqu._)(tasks.slice(index + 1)));
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            }
        ], [
            {
                key: "createTask",
                value: function createTask(path, name) {
                    var _path_split = (0, $f9AOD._)(path.split(':'), 1), protocol = _path_split[0];
                    var ProtocolTask = _a.protocolMap[protocol];
                    if (!ProtocolTask) throw new URIError('Protocol "'.concat(protocol, ' has not been registered"'));
                    return new ProtocolTask(path, name);
                }
            }
        ]);
        return Downloader;
    }(), _Downloader_tasks_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _tasks_decorators = [
            (0, $6515720bcd6dbf2b$export$9a6132153fba2e0)({
                set: function(tasks) {
                    return tasks.map(function(param) {
                        var name = param.name, path = param.path;
                        return {
                            name: name,
                            path: path
                        };
                    });
                },
                get: function(list) {
                    return list === null || list === void 0 ? void 0 : list.map(function(param) {
                        var name = param.name, path = param.path;
                        return $60166336233982b2$export$ef06e7620d37c296.createTask(path, name);
                    });
                }
            }),
            (0, $h2kUE.observable)
        ];
        _get_unfinishedCount_decorators = [
            (0, $h2kUE.computed)
        ];
        _get_executingCount_decorators = [
            (0, $h2kUE.computed)
        ];
        $60166336233982b2$var$$53eb72fe5615c114$var$__esDecorate(_a, null, _tasks_decorators, {
            kind: "accessor",
            name: "tasks",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "tasks" in obj;
                },
                get: function(obj) {
                    return obj.tasks;
                },
                set: function(obj, value) {
                    obj.tasks = value;
                }
            },
            metadata: _metadata
        }, _tasks_initializers, _tasks_extraInitializers);
        $60166336233982b2$var$$53eb72fe5615c114$var$__esDecorate(_a, null, _get_unfinishedCount_decorators, {
            kind: "getter",
            name: "unfinishedCount",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "unfinishedCount" in obj;
                },
                get: function(obj) {
                    return obj.unfinishedCount;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $60166336233982b2$var$$53eb72fe5615c114$var$__esDecorate(_a, null, _get_executingCount_decorators, {
            kind: "getter",
            name: "executingCount",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "executingCount" in obj;
                },
                get: function(obj) {
                    return obj.executingCount;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), Object.defineProperty(_a, "protocolMap", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            http: $60166336233982b2$export$54a5aef4e85ae85,
            https: $60166336233982b2$export$54a5aef4e85ae85
        }
    }), _a;
}();



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $dWsrg = parcelRequire("dWsrg");

var $kg0zo = parcelRequire("kg0zo");

var $hdIku = parcelRequire("hdIku");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");

var $13u2V = parcelRequire("13u2V");

var $Csf8W = parcelRequire("Csf8W");

var $c9Z2T = parcelRequire("c9Z2T");

var $h2kUE = parcelRequire("h2kUE");


var $lhPyT = parcelRequire("lhPyT");

var $hDKce = parcelRequire("hDKce");
function $d8fd2ad62cb9db0f$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $d8fd2ad62cb9db0f$var$$d2c94808ccfae153$exports = {};
$d8fd2ad62cb9db0f$var$$parcel$export($d8fd2ad62cb9db0f$var$$d2c94808ccfae153$exports, "githubClient", function() {
    return $d8fd2ad62cb9db0f$export$660e113192f74c8f;
});
var $d8fd2ad62cb9db0f$export$660e113192f74c8f = new (0, $c9Z2T.HTTPClient)({
    baseURI: 'https://api.github.com',
    responseType: 'json'
});
var $d8fd2ad62cb9db0f$var$$e6ce8158e203b92f$exports = {};
$d8fd2ad62cb9db0f$var$$parcel$export($d8fd2ad62cb9db0f$var$$e6ce8158e203b92f$exports, "UserModel", function() {
    return $d8fd2ad62cb9db0f$export$621c2e9225361608;
});
var $d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$exports = {};
$d8fd2ad62cb9db0f$var$$parcel$export($d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$exports, "OrganizationModel", function() {
    return $d8fd2ad62cb9db0f$export$28c8139b720f2aa8;
});
var $d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$var$__runInitializers = function $59c6fc29dfdfac1b$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$var$__esDecorate = function $59c6fc29dfdfac1b$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $7E0eS._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$var$__awaiter = function $59c6fc29dfdfac1b$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$var$__await = function $59c6fc29dfdfac1b$var$__await1(v) {
    return this instanceof $d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$var$__await ? (this.v = v, this) : new $d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$var$__await(v);
};
var $d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$var$__asyncValues = function $59c6fc29dfdfac1b$var$__asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$var$__asyncDelegator = function $59c6fc29dfdfac1b$var$__asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$var$__asyncGenerator = function $59c6fc29dfdfac1b$var$__asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $d8fd2ad62cb9db0f$export$28c8139b720f2aa8 = function() {
    var _a;
    var _classSuper = (0, $6515720bcd6dbf2b$export$6a4eb2e7fc9e8903)((0, $6515720bcd6dbf2b$export$36e5777a1ba4b7c3));
    var _instanceExtraInitializers = [];
    var _getOne_decorators;
    return _a = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $hdIku._)(OrganizationModel, _classSuper);
        function OrganizationModel() {
            var user = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
            (0, $173N4._)(this, OrganizationModel);
            var _this;
            _this = (0, $7qXGD._)(this, OrganizationModel);
            Object.defineProperty(_this, "user", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$var$__runInitializers(_this, _instanceExtraInitializers), user)
            });
            Object.defineProperty(_this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $d8fd2ad62cb9db0f$export$660e113192f74c8f
            });
            Object.defineProperty(_this, "baseURI", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'orgs'
            });
            return _this;
        }
        (0, $cFHGC._)(OrganizationModel, [
            {
                key: "openStream",
                value: function openStream() {
                    return $d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$var$__asyncGenerator(this, arguments, function openStream_1() {
                        var _b, per_page, since, count, baseURI, page, _ref, body;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    per_page = this.pageSize, count = 0;
                                    baseURI = this.user ? "users/".concat(this.user, "/") : '';
                                    page = 1;
                                    _state.label = 1;
                                case 1:
                                    return [
                                        4,
                                        $d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$var$__await(this.client.get("".concat(baseURI, "orgs?").concat((0, $lhPyT.buildURLData)({
                                            per_page: per_page,
                                            page: page,
                                            since: since
                                        }))))
                                    ];
                                case 2:
                                    _ref = _state.sent(), body = _ref.body;
                                    if (!body[0]) return [
                                        3,
                                        6
                                    ];
                                    since = (_b = body.at(-1)) === null || _b === void 0 ? void 0 : _b.id;
                                    count += body.length;
                                    return [
                                        5,
                                        (0, $Csf8W.__values)($d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$var$__asyncDelegator($d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$var$__asyncValues(body)))
                                    ];
                                case 3:
                                    return [
                                        4,
                                        $d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$var$__await.apply(void 0, [
                                            _state.sent()
                                        ])
                                    ];
                                case 4:
                                    _state.sent();
                                    if (body.length < this.pageSize) return [
                                        3,
                                        6
                                    ];
                                    _state.label = 5;
                                case 5:
                                    page++;
                                    return [
                                        3,
                                        1
                                    ];
                                case 6:
                                    this.totalCount = count;
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "getOne",
                value: function getOne(name) {
                    var _this = this;
                    var _super = Object.create(null, {
                        getOne: {
                            get: function() {
                                return (0, $dWsrg._)((0, $kg0zo._)(OrganizationModel.prototype), "getOne", _this);
                            }
                        }
                    });
                    return $d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$var$__awaiter(this, void 0, void 0, function() {
                        return (0, $13u2V._)(this, function(_state) {
                            return [
                                2,
                                this.currentOne.login === name ? this.currentOne : _super.getOne.call(this, name)
                            ];
                        });
                    });
                }
            }
        ]);
        return OrganizationModel;
    }(_classSuper), function() {
        var _b;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _getOne_decorators = [
            (0, $6515720bcd6dbf2b$export$e03c1c3201ee8bb7)('downloading')
        ];
        $d8fd2ad62cb9db0f$var$$59c6fc29dfdfac1b$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "getOne" in obj;
                },
                get: function(obj) {
                    return obj.getOne;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $d8fd2ad62cb9db0f$var$$e6ce8158e203b92f$var$__runInitializers = function $e6ce8158e203b92f$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $d8fd2ad62cb9db0f$var$$e6ce8158e203b92f$var$__esDecorate = function $e6ce8158e203b92f$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $7E0eS._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $d8fd2ad62cb9db0f$var$$e6ce8158e203b92f$var$__awaiter = function $e6ce8158e203b92f$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d8fd2ad62cb9db0f$var$$e6ce8158e203b92f$var$__classPrivateFieldGet = function $e6ce8158e203b92f$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $d8fd2ad62cb9db0f$var$$e6ce8158e203b92f$var$__classPrivateFieldSet = function $e6ce8158e203b92f$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $d8fd2ad62cb9db0f$export$621c2e9225361608 = function() {
    var _a, _UserModel_session_accessor_storage;
    var _classSuper = (0, $6515720bcd6dbf2b$export$d12e20a4eec10acf);
    var _instanceExtraInitializers = [];
    var _session_decorators;
    var _session_initializers = [];
    var _session_extraInitializers = [];
    var _get_organizationStore_decorators;
    var _get_namespaces_decorators;
    var _getSession_decorators;
    return _a = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $hdIku._)(UserModel, _classSuper);
        function UserModel() {
            (0, $173N4._)(this, UserModel);
            var _this;
            _this = (0, $7qXGD._)(this, UserModel, arguments);
            Object.defineProperty(_this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($d8fd2ad62cb9db0f$var$$e6ce8158e203b92f$var$__runInitializers(_this, _instanceExtraInitializers), $d8fd2ad62cb9db0f$export$660e113192f74c8f)
            });
            _UserModel_session_accessor_storage.set(_this, $d8fd2ad62cb9db0f$var$$e6ce8158e203b92f$var$__runInitializers(_this, _session_initializers, void 0));
            $d8fd2ad62cb9db0f$var$$e6ce8158e203b92f$var$__runInitializers(_this, _session_extraInitializers);
            return _this;
        }
        (0, $cFHGC._)(UserModel, [
            {
                key: "session",
                get: function get() {
                    return $d8fd2ad62cb9db0f$var$$e6ce8158e203b92f$var$__classPrivateFieldGet(this, _UserModel_session_accessor_storage, "f");
                },
                set: function set(value) {
                    $d8fd2ad62cb9db0f$var$$e6ce8158e203b92f$var$__classPrivateFieldSet(this, _UserModel_session_accessor_storage, value, "f");
                }
            },
            {
                key: "organizationStore",
                get: function get() {
                    var _b;
                    return new $d8fd2ad62cb9db0f$export$28c8139b720f2aa8((_b = this.session) === null || _b === void 0 ? void 0 : _b.login);
                }
            },
            {
                key: "namespaces",
                get: function get() {
                    return [
                        this.session
                    ].concat((0, $aUGqu._)(this.organizationStore.allItems)).filter(Boolean);
                }
            },
            {
                key: "getSession",
                value: function getSession() {
                    return $d8fd2ad62cb9db0f$var$$e6ce8158e203b92f$var$__awaiter(this, void 0, void 0, function() {
                        var _ref, body;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (this.session) return [
                                        2,
                                        this.session
                                    ];
                                    return [
                                        4,
                                        this.client.get('user')
                                    ];
                                case 1:
                                    _ref = _state.sent(), body = _ref.body;
                                    this.session = body;
                                    return [
                                        4,
                                        this.organizationStore.getAll()
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        2,
                                        body
                                    ];
                            }
                        });
                    });
                }
            }
        ]);
        return UserModel;
    }(_classSuper), _UserModel_session_accessor_storage = new WeakMap(), function() {
        var _b;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _session_decorators = [
            (0, $h2kUE.observable)
        ];
        _get_organizationStore_decorators = [
            (0, $h2kUE.computed)
        ];
        _get_namespaces_decorators = [
            (0, $h2kUE.computed)
        ];
        _getSession_decorators = [
            (0, $6515720bcd6dbf2b$export$e03c1c3201ee8bb7)('downloading')
        ];
        $d8fd2ad62cb9db0f$var$$e6ce8158e203b92f$var$__esDecorate(_a, null, _session_decorators, {
            kind: "accessor",
            name: "session",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "session" in obj;
                },
                get: function(obj) {
                    return obj.session;
                },
                set: function(obj, value) {
                    obj.session = value;
                }
            },
            metadata: _metadata
        }, _session_initializers, _session_extraInitializers);
        $d8fd2ad62cb9db0f$var$$e6ce8158e203b92f$var$__esDecorate(_a, null, _get_organizationStore_decorators, {
            kind: "getter",
            name: "organizationStore",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "organizationStore" in obj;
                },
                get: function(obj) {
                    return obj.organizationStore;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $d8fd2ad62cb9db0f$var$$e6ce8158e203b92f$var$__esDecorate(_a, null, _get_namespaces_decorators, {
            kind: "getter",
            name: "namespaces",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "namespaces" in obj;
                },
                get: function(obj) {
                    return obj.namespaces;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $d8fd2ad62cb9db0f$var$$e6ce8158e203b92f$var$__esDecorate(_a, null, _getSession_decorators, {
            kind: "method",
            name: "getSession",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "getSession" in obj;
                },
                get: function(obj) {
                    return obj.getSession;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $d8fd2ad62cb9db0f$var$$d3130a010a88f771$exports = {};
$d8fd2ad62cb9db0f$var$$parcel$export($d8fd2ad62cb9db0f$var$$d3130a010a88f771$exports, "RepositoryModel", function() {
    return $d8fd2ad62cb9db0f$export$e2c4c3b5712a2495;
});
var $d8fd2ad62cb9db0f$var$$dfa451c8fd878073$exports = {};
$d8fd2ad62cb9db0f$var$$parcel$export($d8fd2ad62cb9db0f$var$$dfa451c8fd878073$exports, "ContributorModel", function() {
    return $d8fd2ad62cb9db0f$export$ebe1058377a924a;
});
var $d8fd2ad62cb9db0f$var$$dfa451c8fd878073$var$__await = function $dfa451c8fd878073$var$__await1(v) {
    return this instanceof $d8fd2ad62cb9db0f$var$$dfa451c8fd878073$var$__await ? (this.v = v, this) : new $d8fd2ad62cb9db0f$var$$dfa451c8fd878073$var$__await(v);
};
var $d8fd2ad62cb9db0f$var$$dfa451c8fd878073$var$__asyncValues = function $dfa451c8fd878073$var$__asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $d8fd2ad62cb9db0f$var$$dfa451c8fd878073$var$__asyncDelegator = function $dfa451c8fd878073$var$__asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d8fd2ad62cb9db0f$var$$dfa451c8fd878073$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $d8fd2ad62cb9db0f$var$$dfa451c8fd878073$var$__asyncGenerator = function $dfa451c8fd878073$var$__asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d8fd2ad62cb9db0f$var$$dfa451c8fd878073$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $d8fd2ad62cb9db0f$export$ebe1058377a924a = /*#__PURE__*/ function(_$42h8L$Stream) {
    "use strict";
    (0, $hdIku._)($dfa451c8fd878073$export$ebe1058377a924a, _$42h8L$Stream);
    function $dfa451c8fd878073$export$ebe1058377a924a(owner, repository) {
        (0, $173N4._)(this, $dfa451c8fd878073$export$ebe1058377a924a);
        var _this;
        _this = (0, $7qXGD._)(this, $dfa451c8fd878073$export$ebe1058377a924a);
        Object.defineProperty(_this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(_this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(_this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $d8fd2ad62cb9db0f$export$660e113192f74c8f
        });
        _this.baseURI = "repos/".concat(owner, "/").concat(repository, "/contributors");
        return _this;
    }
    (0, $cFHGC._)($dfa451c8fd878073$export$ebe1058377a924a, [
        {
            key: "openStream",
            value: function openStream(filter) {
                return $d8fd2ad62cb9db0f$var$$dfa451c8fd878073$var$__asyncGenerator(this, arguments, function openStream_1() {
                    var _this, client, baseURI, per_page, count, page, _ref, body;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this, client = _this.client, baseURI = _this.baseURI, per_page = _this.pageSize;
                                count = 0;
                                page = 1;
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    $d8fd2ad62cb9db0f$var$$dfa451c8fd878073$var$__await(client.get("".concat(baseURI, "?").concat((0, $lhPyT.buildURLData)(Object.assign({
                                        per_page: per_page,
                                        page: page
                                    }, filter)))))
                                ];
                            case 2:
                                _ref = _state.sent(), body = _ref.body;
                                if (!body[0]) return [
                                    3,
                                    6
                                ];
                                count += body.length;
                                return [
                                    5,
                                    (0, $Csf8W.__values)($d8fd2ad62cb9db0f$var$$dfa451c8fd878073$var$__asyncDelegator($d8fd2ad62cb9db0f$var$$dfa451c8fd878073$var$__asyncValues(body)))
                                ];
                            case 3:
                                return [
                                    4,
                                    $d8fd2ad62cb9db0f$var$$dfa451c8fd878073$var$__await.apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                            case 4:
                                _state.sent();
                                if (body.length < this.pageSize) return [
                                    3,
                                    6
                                ];
                                _state.label = 5;
                            case 5:
                                page++;
                                return [
                                    3,
                                    1
                                ];
                            case 6:
                                this.totalCount = count;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return $dfa451c8fd878073$export$ebe1058377a924a;
}((0, $6515720bcd6dbf2b$export$6a4eb2e7fc9e8903)((0, $6515720bcd6dbf2b$export$36e5777a1ba4b7c3)));
var $d8fd2ad62cb9db0f$var$$e610a99570571b98$exports = {};
$d8fd2ad62cb9db0f$var$$parcel$export($d8fd2ad62cb9db0f$var$$e610a99570571b98$exports, "IssueModel", function() {
    return $d8fd2ad62cb9db0f$export$5f96977bde248fb7;
});
$d8fd2ad62cb9db0f$var$$parcel$export($d8fd2ad62cb9db0f$var$$e610a99570571b98$exports, "IssueCommentModel", function() {
    return $d8fd2ad62cb9db0f$export$3bba9992a4d664e6;
});
var $d8fd2ad62cb9db0f$var$$985c3e5be67a4078$exports = {};
$d8fd2ad62cb9db0f$var$$parcel$export($d8fd2ad62cb9db0f$var$$985c3e5be67a4078$exports, "PullRequestModel", function() {
    return $d8fd2ad62cb9db0f$export$8b5593d82c2e1a5;
});
var $d8fd2ad62cb9db0f$var$$985c3e5be67a4078$var$__await = function $985c3e5be67a4078$var$__await1(v) {
    return this instanceof $d8fd2ad62cb9db0f$var$$985c3e5be67a4078$var$__await ? (this.v = v, this) : new $d8fd2ad62cb9db0f$var$$985c3e5be67a4078$var$__await(v);
};
var $d8fd2ad62cb9db0f$var$$985c3e5be67a4078$var$__asyncValues = function $985c3e5be67a4078$var$__asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $d8fd2ad62cb9db0f$var$$985c3e5be67a4078$var$__asyncDelegator = function $985c3e5be67a4078$var$__asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d8fd2ad62cb9db0f$var$$985c3e5be67a4078$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $d8fd2ad62cb9db0f$var$$985c3e5be67a4078$var$__asyncGenerator = function $985c3e5be67a4078$var$__asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d8fd2ad62cb9db0f$var$$985c3e5be67a4078$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $d8fd2ad62cb9db0f$export$8b5593d82c2e1a5 = /*#__PURE__*/ function(_$42h8L$Stream) {
    "use strict";
    (0, $hdIku._)($985c3e5be67a4078$export$8b5593d82c2e1a5, _$42h8L$Stream);
    function $985c3e5be67a4078$export$8b5593d82c2e1a5(owner, repository) {
        (0, $173N4._)(this, $985c3e5be67a4078$export$8b5593d82c2e1a5);
        var _this;
        _this = (0, $7qXGD._)(this, $985c3e5be67a4078$export$8b5593d82c2e1a5);
        Object.defineProperty(_this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(_this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(_this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $d8fd2ad62cb9db0f$export$660e113192f74c8f
        });
        _this.baseURI = "repos/".concat(owner, "/").concat(repository, "/pulls");
        return _this;
    }
    (0, $cFHGC._)($985c3e5be67a4078$export$8b5593d82c2e1a5, [
        {
            key: "openStream",
            value: function openStream(filter) {
                return $d8fd2ad62cb9db0f$var$$985c3e5be67a4078$var$__asyncGenerator(this, arguments, function openStream_1() {
                    var _this, client, baseURI, per_page, count, page, _ref, body;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this, client = _this.client, baseURI = _this.baseURI, per_page = _this.pageSize;
                                count = 0;
                                page = 1;
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    $d8fd2ad62cb9db0f$var$$985c3e5be67a4078$var$__await(client.get("".concat(baseURI, "?").concat((0, $lhPyT.buildURLData)(Object.assign({
                                        per_page: per_page,
                                        page: page
                                    }, filter)))))
                                ];
                            case 2:
                                _ref = _state.sent(), body = _ref.body;
                                if (!body[0]) return [
                                    3,
                                    6
                                ];
                                count += body.length;
                                return [
                                    5,
                                    (0, $Csf8W.__values)($d8fd2ad62cb9db0f$var$$985c3e5be67a4078$var$__asyncDelegator($d8fd2ad62cb9db0f$var$$985c3e5be67a4078$var$__asyncValues(body)))
                                ];
                            case 3:
                                return [
                                    4,
                                    $d8fd2ad62cb9db0f$var$$985c3e5be67a4078$var$__await.apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                            case 4:
                                _state.sent();
                                if (body.length < this.pageSize) return [
                                    3,
                                    6
                                ];
                                _state.label = 5;
                            case 5:
                                page++;
                                return [
                                    3,
                                    1
                                ];
                            case 6:
                                this.totalCount = count;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return $985c3e5be67a4078$export$8b5593d82c2e1a5;
}((0, $6515720bcd6dbf2b$export$6a4eb2e7fc9e8903)((0, $6515720bcd6dbf2b$export$36e5777a1ba4b7c3)));
var $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__runInitializers = function $e610a99570571b98$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__esDecorate = function $e610a99570571b98$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $7E0eS._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__awaiter = function $e610a99570571b98$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__await = function $e610a99570571b98$var$__await1(v) {
    return this instanceof $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__await ? (this.v = v, this) : new $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__await(v);
};
var $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__asyncValues = function $e610a99570571b98$var$__asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__asyncDelegator = function $e610a99570571b98$var$__asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__asyncGenerator = function $e610a99570571b98$var$__asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__rest = function $e610a99570571b98$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d8fd2ad62cb9db0f$export$5f96977bde248fb7 = function() {
    var _a;
    var _classSuper = (0, $6515720bcd6dbf2b$export$6a4eb2e7fc9e8903)((0, $6515720bcd6dbf2b$export$36e5777a1ba4b7c3));
    var _instanceExtraInitializers = [];
    var _assignOneToCopilot_decorators;
    var _getLinkedPRs_decorators;
    return _a = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $hdIku._)(IssueModel, _classSuper);
        function IssueModel(owner, repository) {
            (0, $173N4._)(this, IssueModel);
            var _this;
            _this = (0, $7qXGD._)(this, IssueModel);
            Object.defineProperty(_this, "owner", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__runInitializers(_this, _instanceExtraInitializers), owner)
            });
            Object.defineProperty(_this, "repository", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: repository
            });
            Object.defineProperty(_this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $d8fd2ad62cb9db0f$export$660e113192f74c8f
            });
            _this.baseURI = "repos/".concat(owner, "/").concat(repository, "/issues");
            return _this;
        }
        (0, $cFHGC._)(IssueModel, [
            {
                key: "openStream",
                value: function openStream(filter) {
                    return $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__asyncGenerator(this, arguments, function openStream_1() {
                        var per_page, count, page, _ref, body, list;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    per_page = this.pageSize, count = 0;
                                    page = 1;
                                    _state.label = 1;
                                case 1:
                                    return [
                                        4,
                                        $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__await(this.client.get("".concat(this.baseURI, "?").concat((0, $lhPyT.buildURLData)(Object.assign({
                                            per_page: per_page,
                                            page: page
                                        }, filter)))))
                                    ];
                                case 2:
                                    _ref = _state.sent(), body = _ref.body;
                                    list = body.filter(function(param) {
                                        var pull_request = param.pull_request;
                                        return !pull_request;
                                    });
                                    if (!body[0]) return [
                                        3,
                                        6
                                    ];
                                    count += list.length;
                                    return [
                                        5,
                                        (0, $Csf8W.__values)($d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__asyncDelegator($d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__asyncValues(list)))
                                    ];
                                case 3:
                                    return [
                                        4,
                                        $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__await.apply(void 0, [
                                            _state.sent()
                                        ])
                                    ];
                                case 4:
                                    _state.sent();
                                    if (body.length < this.pageSize) return [
                                        3,
                                        6
                                    ];
                                    _state.label = 5;
                                case 5:
                                    page++;
                                    return [
                                        3,
                                        1
                                    ];
                                case 6:
                                    this.totalCount = count;
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                /**
             * Create or update an issue, with support for Copilot assignee
             *
             * @see {@link https://docs.github.com/en/rest/issues/issues#create-an-issue}
             * @see {@link https://docs.github.com/en/rest/issues/issues#update-an-issue}
             */ key: "updateOne",
                value: function updateOne(_b, id) {
                    var _this = this;
                    var _super = Object.create(null, {
                        updateOne: {
                            get: function() {
                                return (0, $dWsrg._)((0, $kg0zo._)(IssueModel.prototype), "updateOne", _this);
                            }
                        }
                    });
                    return $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__awaiter(this, void 0, void 0, function() {
                        var tmp, assignees, rest, assigneeList, humanAssignees, hasCopilotAssignee, issueData, issue;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    tmp = _b.assignees, assignees = tmp === void 0 ? [] : tmp, rest = $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__rest(_b, [
                                        "assignees"
                                    ]);
                                    assigneeList = assignees;
                                    humanAssignees = assigneeList.filter(function(login) {
                                        return login !== 'copilot-swe-agent';
                                    });
                                    hasCopilotAssignee = assigneeList.length !== humanAssignees.length;
                                    issueData = Object.assign(Object.assign({}, rest), humanAssignees && {
                                        assignees: humanAssignees
                                    });
                                    return [
                                        4,
                                        _super.updateOne.call(this, issueData, id)
                                    ];
                                case 1:
                                    issue = _state.sent();
                                    if (!hasCopilotAssignee) return [
                                        3,
                                        3
                                    ];
                                    return [
                                        4,
                                        this.assignOneToCopilot(issue)
                                    ];
                                case 2:
                                    _state.sent();
                                    _state.label = 3;
                                case 3:
                                    return [
                                        2,
                                        issue
                                    ];
                            }
                        });
                    });
                }
            },
            {
                /**
             * Assign Copilot bot to an issue using GitHub GraphQL API
             *
             * @see {@link https://docs.github.com/en/copilot/how-tos/use-copilot-agents/coding-agent/create-a-pr#assigning-an-existing-issue}
             * @see {@link https://github.com/orgs/community/discussions/164267}
             */ key: "assignOneToCopilot",
                value: function assignOneToCopilot(issue) {
                    return $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__awaiter(this, void 0, void 0, function() {
                        var getUserQuery, _ref, userResult, userId, assignMutation, _ref1, assignResult;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    getUserQuery = '\n            query ($owner: String!, $name: String!) {\n                repository(owner: $owner, name: $name) {\n                    suggestedActors(\n                        loginNames: "copilot"\n                        capabilities: [CAN_BE_ASSIGNED]\n                        first: 1\n                    ) {\n                        nodes {\n                            login\n                            __typename\n                            ... on Bot { id }\n                        }\n                    }\n                }\n            }';
                                    return [
                                        4,
                                        this.client.post('https://api.github.com/graphql', {
                                            query: getUserQuery,
                                            variables: {
                                                owner: this.owner,
                                                name: this.repository
                                            }
                                        })
                                    ];
                                case 1:
                                    _ref = _state.sent(), userResult = _ref.body;
                                    userId = userResult.data.repository.suggestedActors.nodes[0].id;
                                    assignMutation = "\n            mutation ($issueId: ID!, $userId: ID!) {\n                replaceActorsForAssignable(input: {assignableId: $issueId, actorIds: [$userId]}) {\n                    assignable {\n                        ... on Issue {\n                            id\n                            title\n                            assignees(first: 10) {\n                                nodes { login }\n                            }\n                        }\n                    }\n                }\n            }";
                                    return [
                                        4,
                                        this.client.post('https://api.github.com/graphql', {
                                            query: assignMutation,
                                            variables: {
                                                issueId: issue.id,
                                                userId: userId
                                            }
                                        })
                                    ];
                                case 2:
                                    _ref1 = _state.sent(), assignResult = _ref1.body;
                                    return [
                                        2,
                                        assignResult
                                    ];
                            }
                        });
                    });
                }
            },
            {
                /**
             * Get pull requests that close an issue using GraphQL
             *
             * @see {@link https://docs.github.com/en/graphql/reference/objects#pullrequest}
             */ key: "getLinkedPRs",
                value: function getLinkedPRs(issueNumber_1) {
                    return $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__awaiter(this, arguments, void 0, function(issueNumber) {
                        var maxCount, prNumbers, prModel;
                        var _arguments = arguments;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    maxCount = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 10;
                                    return [
                                        4,
                                        this.getLinkedPRNumbers(issueNumber, maxCount)
                                    ];
                                case 1:
                                    prNumbers = _state.sent();
                                    prModel = new $d8fd2ad62cb9db0f$export$8b5593d82c2e1a5(this.owner, this.repository);
                                    return [
                                        2,
                                        Promise.all(prNumbers.map(function(number) {
                                            return prModel.getOne(number);
                                        }))
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "getLinkedPRNumbers",
                value: function getLinkedPRNumbers(issueNumber_1) {
                    return $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__awaiter(this, arguments, void 0, function(issueNumber) {
                        var maxCount, query, _ref, body;
                        var _arguments = arguments;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    maxCount = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 10;
                                    query = "\n            query ($owner: String!, $name: String!, $number: Int!, $maxCount: Int!) {\n                repository(owner: $owner, name: $name) {\n                    issue(number: $number) {\n                        closedByPullRequestsReferences(first: $maxCount) {\n                            nodes {\n                                number\n                            }\n                        }\n                    }\n                }\n            }";
                                    return [
                                        4,
                                        this.client.post("https://api.github.com/graphql", {
                                            query: query,
                                            variables: {
                                                owner: this.owner,
                                                name: this.repository,
                                                number: issueNumber,
                                                maxCount: maxCount
                                            }
                                        })
                                    ];
                                case 1:
                                    _ref = _state.sent(), body = _ref.body;
                                    return [
                                        2,
                                        body.data.repository.issue.closedByPullRequestsReferences.nodes.map(function(param) {
                                            var number = param.number;
                                            return number;
                                        })
                                    ];
                            }
                        });
                    });
                }
            }
        ]);
        return IssueModel;
    }(_classSuper), function() {
        var _b;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _assignOneToCopilot_decorators = [
            (0, $6515720bcd6dbf2b$export$e03c1c3201ee8bb7)('uploading')
        ];
        _getLinkedPRs_decorators = [
            (0, $6515720bcd6dbf2b$export$e03c1c3201ee8bb7)('downloading')
        ];
        $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__esDecorate(_a, null, _assignOneToCopilot_decorators, {
            kind: "method",
            name: "assignOneToCopilot",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "assignOneToCopilot" in obj;
                },
                get: function(obj) {
                    return obj.assignOneToCopilot;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__esDecorate(_a, null, _getLinkedPRs_decorators, {
            kind: "method",
            name: "getLinkedPRs",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "getLinkedPRs" in obj;
                },
                get: function(obj) {
                    return obj.getLinkedPRs;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $d8fd2ad62cb9db0f$export$3bba9992a4d664e6 = /*#__PURE__*/ function(_$42h8L$Stream) {
    "use strict";
    (0, $hdIku._)($e610a99570571b98$export$3bba9992a4d664e6, _$42h8L$Stream);
    function $e610a99570571b98$export$3bba9992a4d664e6(owner, repository, issue) {
        (0, $173N4._)(this, $e610a99570571b98$export$3bba9992a4d664e6);
        var _this;
        _this = (0, $7qXGD._)(this, $e610a99570571b98$export$3bba9992a4d664e6);
        Object.defineProperty(_this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(_this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(_this, "issue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: issue
        });
        Object.defineProperty(_this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $d8fd2ad62cb9db0f$export$660e113192f74c8f
        });
        _this.baseURI = "repos/".concat(owner, "/").concat(repository, "/issues/").concat(issue, "/comments");
        return _this;
    }
    (0, $cFHGC._)($e610a99570571b98$export$3bba9992a4d664e6, [
        {
            key: "openStream",
            value: function openStream(filter) {
                return $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__asyncGenerator(this, arguments, function openStream_2() {
                    var _this, client, baseURI, per_page, count, page, _ref, body;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this, client = _this.client, baseURI = _this.baseURI, per_page = _this.pageSize;
                                count = 0;
                                page = 1;
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__await(client.get("".concat(baseURI, "?").concat((0, $lhPyT.buildURLData)(Object.assign(Object.assign({}, filter), {
                                        per_page: per_page,
                                        page: page
                                    })))))
                                ];
                            case 2:
                                _ref = _state.sent(), body = _ref.body;
                                if (!body[0]) return [
                                    3,
                                    6
                                ];
                                count += body.length;
                                return [
                                    5,
                                    (0, $Csf8W.__values)($d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__asyncDelegator($d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__asyncValues(body)))
                                ];
                            case 3:
                                return [
                                    4,
                                    $d8fd2ad62cb9db0f$var$$e610a99570571b98$var$__await.apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                            case 4:
                                _state.sent();
                                if (body.length < per_page) return [
                                    3,
                                    6
                                ];
                                _state.label = 5;
                            case 5:
                                page++;
                                return [
                                    3,
                                    1
                                ];
                            case 6:
                                this.totalCount = count;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return $e610a99570571b98$export$3bba9992a4d664e6;
}((0, $6515720bcd6dbf2b$export$6a4eb2e7fc9e8903)((0, $6515720bcd6dbf2b$export$36e5777a1ba4b7c3)));
var $d8fd2ad62cb9db0f$var$$d3130a010a88f771$var$__runInitializers = function $d3130a010a88f771$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $d8fd2ad62cb9db0f$var$$d3130a010a88f771$var$__esDecorate = function $d3130a010a88f771$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $7E0eS._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $d8fd2ad62cb9db0f$var$$d3130a010a88f771$var$__awaiter = function $d3130a010a88f771$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d8fd2ad62cb9db0f$export$e2c4c3b5712a2495 = function() {
    var _a;
    var _classSuper = (0, $6515720bcd6dbf2b$export$36e5777a1ba4b7c3);
    var _instanceExtraInitializers = [];
    var _getOne_decorators;
    return _a = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $hdIku._)(RepositoryModel, _classSuper);
        function RepositoryModel() {
            var owner = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
            (0, $173N4._)(this, RepositoryModel);
            var _this;
            _this = (0, $7qXGD._)(this, RepositoryModel);
            Object.defineProperty(_this, "owner", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($d8fd2ad62cb9db0f$var$$d3130a010a88f771$var$__runInitializers(_this, _instanceExtraInitializers), owner)
            });
            Object.defineProperty(_this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $d8fd2ad62cb9db0f$export$660e113192f74c8f
            });
            Object.defineProperty(_this, "baseURI", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ''
            });
            Object.defineProperty(_this, "indexKey", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'full_name'
            });
            Object.defineProperty(_this, "organizationStore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new $d8fd2ad62cb9db0f$export$28c8139b720f2aa8()
            });
            Object.defineProperty(_this, "relation", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: {
                    contributors: (0, $hDKce.memoize)(function(URI) {
                        return $d8fd2ad62cb9db0f$var$$d3130a010a88f771$var$__awaiter(_this, void 0, void 0, function() {
                            var _URI_split, owner, repository, body;
                            return (0, $13u2V._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _URI_split = (0, $f9AOD._)(URI.split('/'), 2), owner = _URI_split[0], repository = _URI_split[1];
                                        return [
                                            4,
                                            new $d8fd2ad62cb9db0f$export$ebe1058377a924a(owner, repository).getAll()
                                        ];
                                    case 1:
                                        body = _state.sent();
                                        return [
                                            2,
                                            body.sort(function(a, b) {
                                                return b.contributions - a.contributions;
                                            }) || []
                                        ];
                                }
                            });
                        });
                    }),
                    issues: (0, $hDKce.memoize)(function(URI) {
                        var _URI_split = (0, $f9AOD._)(URI.split('/'), 2), owner = _URI_split[0], repository = _URI_split[1];
                        return new $d8fd2ad62cb9db0f$export$5f96977bde248fb7(owner, repository).getAll();
                    }),
                    languages: (0, $hDKce.memoize)(function(URI) {
                        return $d8fd2ad62cb9db0f$var$$d3130a010a88f771$var$__awaiter(_this, void 0, void 0, function() {
                            var _ref, languageCount, languageAverage, languageList;
                            return (0, $13u2V._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            this.client.get("repos/".concat(URI, "/languages"))
                                        ];
                                    case 1:
                                        _ref = _state.sent(), languageCount = _ref.body;
                                        languageAverage = (0, $lhPyT.averageOf).apply(void 0, (0, $aUGqu._)(Object.values(languageCount)));
                                        languageList = Object.entries(languageCount).filter(function(param) {
                                            var _param = (0, $f9AOD._)(param, 2), _ = _param[0], score = _param[1];
                                            return score >= languageAverage;
                                        }).sort(function(param, param1) {
                                            var _param = (0, $f9AOD._)(param, 2), _ = _param[0], a = _param[1], _param1 = (0, $f9AOD._)(param1, 2), __ = _param1[0], b = _param1[1];
                                            return b - a;
                                        });
                                        return [
                                            2,
                                            languageList.map(function(param) {
                                                var _param = (0, $f9AOD._)(param, 1), name = _param[0];
                                                return name;
                                            })
                                        ];
                                }
                            });
                        });
                    })
                }
            });
            _this.baseURI = owner ? "orgs/".concat(owner, "/repos") : 'user/repos';
            return _this;
        }
        (0, $cFHGC._)(RepositoryModel, [
            {
                key: "getOneRelation",
                value: function getOneRelation(URI_1) {
                    return $d8fd2ad62cb9db0f$var$$d3130a010a88f771$var$__awaiter(this, arguments, void 0, function(URI) {
                        var _this, relation, relationData;
                        var _arguments = arguments;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this = this;
                                    relation = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : [];
                                    return [
                                        4,
                                        Promise.all(relation.map(function(key) {
                                            return $d8fd2ad62cb9db0f$var$$d3130a010a88f771$var$__awaiter(_this, void 0, void 0, function() {
                                                var value;
                                                return (0, $13u2V._)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                this.relation[key](URI)
                                                            ];
                                                        case 1:
                                                            value = _state.sent();
                                                            return [
                                                                2,
                                                                [
                                                                    key,
                                                                    value
                                                                ]
                                                            ];
                                                    }
                                                });
                                            });
                                        }))
                                    ];
                                case 1:
                                    relationData = _state.sent();
                                    return [
                                        2,
                                        Object.fromEntries(relationData)
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "getOne",
                value: function getOne(URI_1) {
                    return $d8fd2ad62cb9db0f$var$$d3130a010a88f771$var$__awaiter(this, arguments, void 0, function(URI) {
                        var relation, _ref, body, _, _1, _tmp;
                        var _arguments = arguments;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    relation = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : [];
                                    return [
                                        4,
                                        this.client.get("repos/".concat(URI))
                                    ];
                                case 1:
                                    _ref = _state.sent(), body = _ref.body;
                                    _ = this;
                                    _1 = Object.assign;
                                    _tmp = [
                                        Object.assign({}, body)
                                    ];
                                    return [
                                        4,
                                        this.getOneRelation(URI, relation)
                                    ];
                                case 2:
                                    return [
                                        2,
                                        _.currentOne = _1.apply(Object, _tmp.concat([
                                            _state.sent()
                                        ]))
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "loadPage",
                value: function loadPage(page_1, per_page_1, _b) {
                    return $d8fd2ad62cb9db0f$var$$d3130a010a88f771$var$__awaiter(this, arguments, void 0, function(page, per_page, param) {
                        var _this, relation, _this_baseURI_split, kind, namespace, isUser, _ref, list, pageData, _this1, totalCount, ref, _ref1, body;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this = this;
                                    relation = param.relation;
                                    _this_baseURI_split = (0, $f9AOD._)(this.baseURI.split('/'), 2), kind = _this_baseURI_split[0], namespace = _this_baseURI_split[1], isUser = kind === 'user';
                                    return [
                                        4,
                                        this.client.get("".concat(this.baseURI, "?").concat((0, $lhPyT.buildURLData)({
                                            type: isUser ? 'owner' : 'public',
                                            sort: 'pushed',
                                            page: page,
                                            per_page: per_page
                                        })))
                                    ];
                                case 1:
                                    _ref = _state.sent(), list = _ref.body;
                                    return [
                                        4,
                                        Promise.all(list.map(function(item) {
                                            return $d8fd2ad62cb9db0f$var$$d3130a010a88f771$var$__awaiter(_this, void 0, void 0, function() {
                                                var _, _tmp;
                                                return (0, $13u2V._)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            _ = Object.assign;
                                                            _tmp = [
                                                                Object.assign({}, item)
                                                            ];
                                                            return [
                                                                4,
                                                                this.getOneRelation(item.full_name, relation)
                                                            ];
                                                        case 1:
                                                            return [
                                                                2,
                                                                _.apply(Object, _tmp.concat([
                                                                    _state.sent()
                                                                ]))
                                                            ];
                                                    }
                                                });
                                            });
                                        }))
                                    ];
                                case 2:
                                    pageData = _state.sent();
                                    _this1 = this, totalCount = _this1.totalCount;
                                    if (!!this.totalCount) return [
                                        3,
                                        6
                                    ];
                                    if (!!isUser) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        this.organizationStore.getOne(namespace)
                                    ];
                                case 3:
                                    ref = _state.sent(), totalCount = ref.public_repos, ref;
                                    return [
                                        3,
                                        6
                                    ];
                                case 4:
                                    return [
                                        4,
                                        this.client.get('user')
                                    ];
                                case 5:
                                    _ref1 = _state.sent(), body = _ref1.body;
                                    totalCount = body.public_repos + (body.total_private_repos || 0);
                                    _state.label = 6;
                                case 6:
                                    return [
                                        2,
                                        {
                                            pageData: pageData,
                                            totalCount: totalCount
                                        }
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "getAllContributors",
                value: function getAllContributors() {
                    return $d8fd2ad62cb9db0f$var$$d3130a010a88f771$var$__awaiter(this, void 0, void 0, function() {
                        var repositories, contributors, userGroup;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.getAll({
                                            relation: [
                                                'contributors'
                                            ]
                                        })
                                    ];
                                case 1:
                                    repositories = _state.sent();
                                    contributors = repositories.filter(function(param) {
                                        var fork = param.fork, archived = param.archived;
                                        return !archived && !fork;
                                    }).flatMap(function(param) {
                                        var contributors = param.contributors;
                                        return contributors;
                                    }).filter(function(param) {
                                        var type = param.type;
                                        return type === 'User';
                                    });
                                    userGroup = (0, $lhPyT.groupBy)(contributors, 'login');
                                    return [
                                        2,
                                        Object.entries(userGroup).map(function(param) {
                                            var _param = (0, $f9AOD._)(param, 2), login = _param[0], list = _param[1];
                                            return Object.assign(Object.assign({}, list[0]), {
                                                contributions: list.reduce(function(sum, param) {
                                                    var contributions = param.contributions;
                                                    return sum + contributions;
                                                }, 0)
                                            });
                                        }).sort(function(a, b) {
                                            return b.contributions - a.contributions;
                                        })
                                    ];
                            }
                        });
                    });
                }
            }
        ]);
        return RepositoryModel;
    }(_classSuper), function() {
        var _b;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _getOne_decorators = [
            (0, $6515720bcd6dbf2b$export$e03c1c3201ee8bb7)('downloading')
        ];
        $d8fd2ad62cb9db0f$var$$d3130a010a88f771$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "getOne" in obj;
                },
                get: function(obj) {
                    return obj.getOne;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $d8fd2ad62cb9db0f$var$$88356f023569df5f$exports = {};
$d8fd2ad62cb9db0f$var$$parcel$export($d8fd2ad62cb9db0f$var$$88356f023569df5f$exports, "ContentModel", function() {
    return $d8fd2ad62cb9db0f$export$5b988c733cc838bb;
});
var $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__runInitializers = function $88356f023569df5f$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__esDecorate = function $88356f023569df5f$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $7E0eS._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__awaiter = function $88356f023569df5f$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__asyncValues = function $88356f023569df5f$var$__asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__await = function $88356f023569df5f$var$__await1(v) {
    return this instanceof $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__await ? (this.v = v, this) : new $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__await(v);
};
var $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__asyncGenerator = function $88356f023569df5f$var$__asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__asyncDelegator = function $88356f023569df5f$var$__asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $d8fd2ad62cb9db0f$export$5b988c733cc838bb = function() {
    var _a;
    var _classSuper = (0, $6515720bcd6dbf2b$export$6a4eb2e7fc9e8903)((0, $6515720bcd6dbf2b$export$36e5777a1ba4b7c3));
    var _instanceExtraInitializers = [];
    var _getOne_decorators;
    var _updateOne_decorators;
    return _a = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $hdIku._)(ContentModel, _classSuper);
        function ContentModel(owner, repository) {
            (0, $173N4._)(this, ContentModel);
            var _this;
            _this = (0, $7qXGD._)(this, ContentModel);
            Object.defineProperty(_this, "owner", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__runInitializers(_this, _instanceExtraInitializers), owner)
            });
            Object.defineProperty(_this, "repository", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: repository
            });
            Object.defineProperty(_this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $d8fd2ad62cb9db0f$export$660e113192f74c8f
            });
            _this.baseURI = "repos/".concat(owner, "/").concat(repository, "/contents");
            return _this;
        }
        (0, $cFHGC._)(ContentModel, [
            {
                /**
             * Get repository content at a specific path
             *
             * @see {@link https://docs.github.com/en/rest/repos/contents#get-repository-content}
             */ key: "getOne",
                value: function getOne(path) {
                    return $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__awaiter(this, void 0, void 0, function() {
                        var _ref, body;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.client.get("".concat(this.baseURI, "/").concat(path))
                                    ];
                                case 1:
                                    _ref = _state.sent(), body = _ref.body;
                                    return [
                                        2,
                                        Array.isArray(body) ? body[0] : body
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "updateOne",
                value: function updateOne(_b, path_1) {
                    return $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__awaiter(this, arguments, void 0, function(param, path) {
                        var content, message, _ref, sha, _c, _ref1, body;
                        var _arguments = arguments;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    content = param.content, message = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "[update] ".concat(path);
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        this.getOne(path)
                                    ];
                                case 2:
                                    _ref = _state.sent(), sha = _ref.sha;
                                    return [
                                        3,
                                        4
                                    ];
                                case 3:
                                    _c = _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        4,
                                        this.client.put("".concat(this.baseURI, "/").concat(path), {
                                            sha: sha,
                                            message: message,
                                            content: (0, $lhPyT.encodeBase64)(content)
                                        })
                                    ];
                                case 5:
                                    _ref1 = _state.sent(), body = _ref1.body;
                                    return [
                                        2,
                                        body.content
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "openStream",
                value: function openStream(_b) {
                    return $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__asyncGenerator(this, arguments, function openStream_1(param) {
                        var _this, path, name, _c, e_1, _d, _e, setCount, namePattern, stream, _f, stream_1, stream_1_1, content, e_1_1;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this = this;
                                    path = param.path, name = param.name;
                                    setCount = function(total) {
                                        return _this.totalCount = total;
                                    };
                                    namePattern = name && new RegExp(name);
                                    stream = path ? this.traverseChildren(path, setCount) : this.traverseTree(undefined, setCount);
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        8,
                                        9,
                                        14
                                    ]);
                                    _f = true, stream_1 = $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__asyncValues(stream);
                                    _state.label = 2;
                                case 2:
                                    return [
                                        4,
                                        $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__await(stream_1.next())
                                    ];
                                case 3:
                                    if (!(stream_1_1 = _state.sent(), _c = stream_1_1.done, !_c)) return [
                                        3,
                                        7
                                    ];
                                    _e = stream_1_1.value;
                                    _f = false;
                                    content = _e;
                                    if (!(!namePattern || namePattern.test(content.name))) return [
                                        3,
                                        6
                                    ];
                                    return [
                                        4,
                                        $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__await(content)
                                    ];
                                case 4:
                                    return [
                                        4,
                                        _state.sent()
                                    ];
                                case 5:
                                    _state.sent();
                                    _state.label = 6;
                                case 6:
                                    _f = true;
                                    return [
                                        3,
                                        2
                                    ];
                                case 7:
                                    return [
                                        3,
                                        14
                                    ];
                                case 8:
                                    e_1_1 = _state.sent();
                                    e_1 = {
                                        error: e_1_1
                                    };
                                    return [
                                        3,
                                        14
                                    ];
                                case 9:
                                    _state.trys.push([
                                        9,
                                        ,
                                        12,
                                        13
                                    ]);
                                    if (!(!_f && !_c && (_d = stream_1.return))) return [
                                        3,
                                        11
                                    ];
                                    return [
                                        4,
                                        $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__await(_d.call(stream_1))
                                    ];
                                case 10:
                                    _state.sent();
                                    _state.label = 11;
                                case 11:
                                    return [
                                        3,
                                        13
                                    ];
                                case 12:
                                    if (e_1) throw e_1.error;
                                    return [
                                        7
                                    ];
                                case 13:
                                    return [
                                        7
                                    ];
                                case 14:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                /**
             * Get direct children of a directory
             */ key: "traverseChildren",
                value: function traverseChildren() {
                    return $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__asyncGenerator(this, arguments, function traverseChildren_1() {
                        var parentPath, onCount, _ref, body, contents, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, content, err;
                        var _arguments = arguments;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    parentPath = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : '', onCount = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : function() {};
                                    return [
                                        4,
                                        $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__await(this.client.get("".concat(this.baseURI, "/").concat(parentPath)))
                                    ];
                                case 1:
                                    _ref = _state.sent(), body = _ref.body;
                                    contents = (0, $lhPyT.makeArray)(body);
                                    onCount(contents.length);
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    _state.label = 2;
                                case 2:
                                    _state.trys.push([
                                        2,
                                        8,
                                        9,
                                        10
                                    ]);
                                    _iterator = contents[Symbol.iterator]();
                                    _state.label = 3;
                                case 3:
                                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                        3,
                                        7
                                    ];
                                    content = _step.value;
                                    content.parent_path = parentPath;
                                    return [
                                        4,
                                        $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__await(content)
                                    ];
                                case 4:
                                    return [
                                        4,
                                        _state.sent()
                                    ];
                                case 5:
                                    _state.sent();
                                    _state.label = 6;
                                case 6:
                                    _iteratorNormalCompletion = true;
                                    return [
                                        3,
                                        3
                                    ];
                                case 7:
                                    return [
                                        3,
                                        10
                                    ];
                                case 8:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        10
                                    ];
                                case 9:
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                    return [
                                        7
                                    ];
                                case 10:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                /**
             * Recursively traverse the entire file tree
             */ key: "traverseTree",
                value: function traverseTree(parentContent, onCount) {
                    return $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__asyncGenerator(this, arguments, function traverseTree_1() {
                        var _b, e_2, _c, _d, totalCount, addCount, stream, _e, stream_2, stream_2_1, content, e_2_1;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    totalCount = 0;
                                    addCount = function(total) {
                                        return totalCount += total;
                                    };
                                    stream = this.traverseChildren((parentContent === null || parentContent === void 0 ? void 0 : parentContent.path) || '', addCount);
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        10,
                                        11,
                                        16
                                    ]);
                                    _e = true, stream_2 = $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__asyncValues(stream);
                                    _state.label = 2;
                                case 2:
                                    return [
                                        4,
                                        $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__await(stream_2.next())
                                    ];
                                case 3:
                                    if (!(stream_2_1 = _state.sent(), _b = stream_2_1.done, !_b)) return [
                                        3,
                                        9
                                    ];
                                    _d = stream_2_1.value;
                                    _e = false;
                                    content = _d;
                                    return [
                                        4,
                                        $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__await(content)
                                    ];
                                case 4:
                                    return [
                                        4,
                                        _state.sent()
                                    ];
                                case 5:
                                    _state.sent();
                                    if (!(content.type === 'dir')) return [
                                        3,
                                        8
                                    ];
                                    return [
                                        5,
                                        (0, $Csf8W.__values)($d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__asyncDelegator($d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__asyncValues(this.traverseTree(content, addCount))))
                                    ];
                                case 6:
                                    return [
                                        4,
                                        $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__await.apply(void 0, [
                                            _state.sent()
                                        ])
                                    ];
                                case 7:
                                    _state.sent();
                                    _state.label = 8;
                                case 8:
                                    _e = true;
                                    return [
                                        3,
                                        2
                                    ];
                                case 9:
                                    return [
                                        3,
                                        16
                                    ];
                                case 10:
                                    e_2_1 = _state.sent();
                                    e_2 = {
                                        error: e_2_1
                                    };
                                    return [
                                        3,
                                        16
                                    ];
                                case 11:
                                    _state.trys.push([
                                        11,
                                        ,
                                        14,
                                        15
                                    ]);
                                    if (!(!_e && !_b && (_c = stream_2.return))) return [
                                        3,
                                        13
                                    ];
                                    return [
                                        4,
                                        $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__await(_c.call(stream_2))
                                    ];
                                case 12:
                                    _state.sent();
                                    _state.label = 13;
                                case 13:
                                    return [
                                        3,
                                        15
                                    ];
                                case 14:
                                    if (e_2) throw e_2.error;
                                    return [
                                        7
                                    ];
                                case 15:
                                    return [
                                        7
                                    ];
                                case 16:
                                    onCount === null || onCount === void 0 || onCount(totalCount);
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            }
        ]);
        return ContentModel;
    }(_classSuper), function() {
        var _b;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _getOne_decorators = [
            (0, $6515720bcd6dbf2b$export$e03c1c3201ee8bb7)('downloading')
        ];
        _updateOne_decorators = [
            (0, $6515720bcd6dbf2b$export$e03c1c3201ee8bb7)('uploading')
        ];
        $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "getOne" in obj;
                },
                get: function(obj) {
                    return obj.getOne;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $d8fd2ad62cb9db0f$var$$88356f023569df5f$var$__esDecorate(_a, null, _updateOne_decorators, {
            kind: "method",
            name: "updateOne",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "updateOne" in obj;
                },
                get: function(obj) {
                    return obj.updateOne;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$exports = {};
$d8fd2ad62cb9db0f$var$$parcel$export($d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$exports, "DiscussionModel", function() {
    return $d8fd2ad62cb9db0f$export$ea22e9ea45676ee3;
});
$d8fd2ad62cb9db0f$var$$parcel$export($d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$exports, "DiscussionCommentModel", function() {
    return $d8fd2ad62cb9db0f$export$76e6d9690e198c8f;
});
var $d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$var$__await = function $8f8defdf9fc6f2e7$var$__await1(v) {
    return this instanceof $d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$var$__await ? (this.v = v, this) : new $d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$var$__await(v);
};
var $d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$var$__asyncValues = function $8f8defdf9fc6f2e7$var$__asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$var$__asyncDelegator = function $8f8defdf9fc6f2e7$var$__asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$var$__asyncGenerator = function $8f8defdf9fc6f2e7$var$__asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $d8fd2ad62cb9db0f$export$ea22e9ea45676ee3 = /*#__PURE__*/ function(_$42h8L$Stream) {
    "use strict";
    (0, $hdIku._)($8f8defdf9fc6f2e7$export$ea22e9ea45676ee3, _$42h8L$Stream);
    function $8f8defdf9fc6f2e7$export$ea22e9ea45676ee3(owner, repository) {
        (0, $173N4._)(this, $8f8defdf9fc6f2e7$export$ea22e9ea45676ee3);
        var _this;
        _this = (0, $7qXGD._)(this, $8f8defdf9fc6f2e7$export$ea22e9ea45676ee3);
        Object.defineProperty(_this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(_this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(_this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $d8fd2ad62cb9db0f$export$660e113192f74c8f
        });
        _this.baseURI = "repos/".concat(owner, "/").concat(repository, "/discussions");
        return _this;
    }
    (0, $cFHGC._)($8f8defdf9fc6f2e7$export$ea22e9ea45676ee3, [
        {
            key: "openStream",
            value: function openStream(filter) {
                return $d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$var$__asyncGenerator(this, arguments, function openStream_1() {
                    var _this, client, baseURI, per_page, count, page, _ref, body;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this, client = _this.client, baseURI = _this.baseURI, per_page = _this.pageSize;
                                count = 0;
                                page = 1;
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    $d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$var$__await(client.get("".concat(baseURI, "?").concat((0, $lhPyT.buildURLData)(Object.assign({
                                        per_page: per_page,
                                        page: page
                                    }, filter)))))
                                ];
                            case 2:
                                _ref = _state.sent(), body = _ref.body;
                                if (!body[0]) return [
                                    3,
                                    6
                                ];
                                count += body.length;
                                return [
                                    5,
                                    (0, $Csf8W.__values)($d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$var$__asyncDelegator($d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$var$__asyncValues(body)))
                                ];
                            case 3:
                                return [
                                    4,
                                    $d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$var$__await.apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                            case 4:
                                _state.sent();
                                if (body.length < this.pageSize) return [
                                    3,
                                    6
                                ];
                                _state.label = 5;
                            case 5:
                                page++;
                                return [
                                    3,
                                    1
                                ];
                            case 6:
                                this.totalCount = count;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return $8f8defdf9fc6f2e7$export$ea22e9ea45676ee3;
}((0, $6515720bcd6dbf2b$export$6a4eb2e7fc9e8903)((0, $6515720bcd6dbf2b$export$36e5777a1ba4b7c3)));
var $d8fd2ad62cb9db0f$export$76e6d9690e198c8f = /*#__PURE__*/ function(_$42h8L$Stream) {
    "use strict";
    (0, $hdIku._)($8f8defdf9fc6f2e7$export$76e6d9690e198c8f, _$42h8L$Stream);
    function $8f8defdf9fc6f2e7$export$76e6d9690e198c8f(owner, repository, discussion) {
        (0, $173N4._)(this, $8f8defdf9fc6f2e7$export$76e6d9690e198c8f);
        var _this;
        _this = (0, $7qXGD._)(this, $8f8defdf9fc6f2e7$export$76e6d9690e198c8f);
        Object.defineProperty(_this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(_this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(_this, "discussion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: discussion
        });
        Object.defineProperty(_this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $d8fd2ad62cb9db0f$export$660e113192f74c8f
        });
        _this.baseURI = "repos/".concat(owner, "/").concat(repository, "/discussions/").concat(discussion, "/comments");
        return _this;
    }
    (0, $cFHGC._)($8f8defdf9fc6f2e7$export$76e6d9690e198c8f, [
        {
            key: "openStream",
            value: function openStream(filter) {
                return $d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$var$__asyncGenerator(this, arguments, function openStream_2() {
                    var _this, client, baseURI, per_page, _ref, body, page, _ref1, body1;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this, client = _this.client, baseURI = _this.baseURI, per_page = _this.pageSize;
                                return [
                                    4,
                                    $d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$var$__await(client.get(baseURI.split('/').slice(0, -1).join('/')))
                                ];
                            case 1:
                                _ref = _state.sent(), body = _ref.body;
                                this.totalCount = body.comments;
                                if (!!this.totalCount) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    $d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$var$__await(void 0)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                page = 1;
                                _state.label = 4;
                            case 4:
                                return [
                                    4,
                                    $d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$var$__await(client.get("".concat(baseURI, "?").concat((0, $lhPyT.buildURLData)(Object.assign({
                                        per_page: per_page,
                                        page: page
                                    }, filter)))))
                                ];
                            case 5:
                                _ref1 = _state.sent(), body1 = _ref1.body;
                                if (!body1[0]) return [
                                    3,
                                    9
                                ];
                                return [
                                    5,
                                    (0, $Csf8W.__values)($d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$var$__asyncDelegator($d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$var$__asyncValues(body1)))
                                ];
                            case 6:
                                return [
                                    4,
                                    $d8fd2ad62cb9db0f$var$$8f8defdf9fc6f2e7$var$__await.apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                            case 7:
                                _state.sent();
                                if (body1.length < this.pageSize) return [
                                    3,
                                    9
                                ];
                                _state.label = 8;
                            case 8:
                                page++;
                                return [
                                    3,
                                    4
                                ];
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return $8f8defdf9fc6f2e7$export$76e6d9690e198c8f;
}((0, $6515720bcd6dbf2b$export$6a4eb2e7fc9e8903)((0, $6515720bcd6dbf2b$export$36e5777a1ba4b7c3)));
var $d8fd2ad62cb9db0f$var$$131e71a4048073f6$exports = {};
$d8fd2ad62cb9db0f$var$$parcel$export($d8fd2ad62cb9db0f$var$$131e71a4048073f6$exports, "CheckRunModel", function() {
    return $d8fd2ad62cb9db0f$export$3e1022bc3f07e26a;
});
var $d8fd2ad62cb9db0f$var$$131e71a4048073f6$var$__awaiter = function $131e71a4048073f6$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d8fd2ad62cb9db0f$var$$131e71a4048073f6$var$__rest = function $131e71a4048073f6$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d8fd2ad62cb9db0f$export$3e1022bc3f07e26a = /*#__PURE__*/ function($42h8L$ListModel) {
    "use strict";
    (0, $hdIku._)($131e71a4048073f6$export$3e1022bc3f07e26a, $42h8L$ListModel);
    function $131e71a4048073f6$export$3e1022bc3f07e26a(owner, repository, ref) {
        (0, $173N4._)(this, $131e71a4048073f6$export$3e1022bc3f07e26a);
        var _this;
        _this = (0, $7qXGD._)(this, $131e71a4048073f6$export$3e1022bc3f07e26a);
        Object.defineProperty(_this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(_this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(_this, "ref", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ref
        });
        Object.defineProperty(_this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $d8fd2ad62cb9db0f$export$660e113192f74c8f
        });
        Object.defineProperty(_this, "baseURI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        _this.baseURI = "repos/".concat(owner, "/").concat(repository, "/commits/").concat(ref, "/check-runs");
        return _this;
    }
    (0, $cFHGC._)($131e71a4048073f6$export$3e1022bc3f07e26a, [
        {
            key: "loadPage",
            value: function loadPage(page, per_page, _a) {
                return $d8fd2ad62cb9db0f$var$$131e71a4048073f6$var$__awaiter(this, void 0, void 0, function() {
                    var check_name, tmp, filter, restFilter, _ref, body;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                check_name = _a.name, tmp = _a.filter, filter = tmp === void 0 ? 'latest' : tmp, restFilter = $d8fd2ad62cb9db0f$var$$131e71a4048073f6$var$__rest(_a, [
                                    "name",
                                    "filter"
                                ]);
                                return [
                                    4,
                                    this.client.get("".concat(this.baseURI, "?").concat((0, $lhPyT.buildURLData)(Object.assign(Object.assign({
                                        check_name: check_name,
                                        filter: filter
                                    }, restFilter), {
                                        per_page: per_page,
                                        page: page
                                    }))))
                                ];
                            case 1:
                                _ref = _state.sent(), body = _ref.body;
                                return [
                                    2,
                                    {
                                        pageData: body.check_runs,
                                        totalCount: body.total_count
                                    }
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return $131e71a4048073f6$export$3e1022bc3f07e26a;
}((0, $6515720bcd6dbf2b$export$36e5777a1ba4b7c3));
var $d8fd2ad62cb9db0f$var$$0ae0bbd5d9d96cbc$exports = {};
$d8fd2ad62cb9db0f$var$$parcel$export($d8fd2ad62cb9db0f$var$$0ae0bbd5d9d96cbc$exports, "WorkflowRunModel", function() {
    return $d8fd2ad62cb9db0f$export$ba933b122214fc50;
});
var $d8fd2ad62cb9db0f$var$$0ae0bbd5d9d96cbc$var$__awaiter = function $0ae0bbd5d9d96cbc$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d8fd2ad62cb9db0f$var$$0ae0bbd5d9d96cbc$var$__rest = function $0ae0bbd5d9d96cbc$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d8fd2ad62cb9db0f$export$ba933b122214fc50 = /*#__PURE__*/ function($42h8L$ListModel) {
    "use strict";
    (0, $hdIku._)($0ae0bbd5d9d96cbc$export$ba933b122214fc50, $42h8L$ListModel);
    function $0ae0bbd5d9d96cbc$export$ba933b122214fc50(owner, repository) {
        (0, $173N4._)(this, $0ae0bbd5d9d96cbc$export$ba933b122214fc50);
        var _this;
        _this = (0, $7qXGD._)(this, $0ae0bbd5d9d96cbc$export$ba933b122214fc50);
        Object.defineProperty(_this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(_this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(_this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $d8fd2ad62cb9db0f$export$660e113192f74c8f
        });
        Object.defineProperty(_this, "baseURI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        _this.baseURI = "repos/".concat(owner, "/").concat(repository, "/actions/runs");
        return _this;
    }
    (0, $cFHGC._)($0ae0bbd5d9d96cbc$export$ba933b122214fc50, [
        {
            key: "loadPage",
            value: function loadPage(page, per_page, _a) {
                return $d8fd2ad62cb9db0f$var$$0ae0bbd5d9d96cbc$var$__awaiter(this, void 0, void 0, function() {
                    var branch, actor, restFilter, _ref, body;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                branch = _a.head_branch, actor = _a.actor, restFilter = $d8fd2ad62cb9db0f$var$$0ae0bbd5d9d96cbc$var$__rest(_a, [
                                    "head_branch",
                                    "actor"
                                ]);
                                return [
                                    4,
                                    this.client.get("".concat(this.baseURI, "?").concat((0, $lhPyT.buildURLData)(Object.assign(Object.assign({
                                        branch: branch,
                                        actor: actor
                                    }, restFilter), {
                                        per_page: per_page,
                                        page: page
                                    }))))
                                ];
                            case 1:
                                _ref = _state.sent(), body = _ref.body;
                                return [
                                    2,
                                    {
                                        pageData: body.workflow_runs,
                                        totalCount: body.total_count
                                    }
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return $0ae0bbd5d9d96cbc$export$ba933b122214fc50;
}((0, $6515720bcd6dbf2b$export$36e5777a1ba4b7c3));


var $1eb99b7ce60db007$var$GithubToken = undefined;
(0, $d8fd2ad62cb9db0f$export$660e113192f74c8f).use(function(param, next) {
    var request = param.request;
    if ($1eb99b7ce60db007$var$GithubToken) request.headers = Object.assign(Object.assign({}, request.headers), {
        Authorization: "Bearer ".concat($1eb99b7ce60db007$var$GithubToken)
    });
    return next();
});
var $1eb99b7ce60db007$export$8701c19c4b8c549b = new (0, $d8fd2ad62cb9db0f$export$e2c4c3b5712a2495)('idea2app');
var $1eb99b7ce60db007$export$76ffa78e7c88f946 = new (0, $60166336233982b2$export$ef06e7620d37c296)();


var $6a755942d3d53a73$export$ea3d6d720b5c931d = (0, $e04d4b638436dc5e$export$b6ae1bc530f4c149)(function(param) {
    var task = param.task;
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $71075948dbe2717f$export$2e2bcd8739ae039), {
        children: [
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $71075948dbe2717f$export$2e2bcd8739ae039).Body, {
                children: [
                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $71075948dbe2717f$export$2e2bcd8739ae039).Title, {
                        children: task.name
                    }),
                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $ccaf8835ae74c4d6$export$2e2bcd8739ae039), {
                        striped: task.percent < 100,
                        animated: task.executing,
                        now: task.percent,
                        label: "".concat(task.percent, "%")
                    })
                ]
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $71075948dbe2717f$export$2e2bcd8739ae039).Footer, {
                className: "d-flex justify-content-between align-items-center",
                children: [
                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("small", {
                        children: [
                            task.loadedSize.toShortString(),
                            " /",
                            ' ',
                            task.totalSize.toShortString()
                        ]
                    }),
                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                        className: "d-flex gap-3",
                        children: [
                            task.percent < 100 && (task.executing ? (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $3a399bf6b2fd4261$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "warning",
                                onClick: function() {
                                    return task.pause();
                                },
                                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $baaeda96f7555c00$exports.Icon), {
                                    name: "pause"
                                })
                            }) : (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $3a399bf6b2fd4261$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "success",
                                onClick: function() {
                                    return task.start();
                                },
                                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $baaeda96f7555c00$exports.Icon), {
                                    name: "play"
                                })
                            })),
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $3a399bf6b2fd4261$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "danger",
                                disabled: task.executing,
                                onClick: function() {
                                    return (0, $1eb99b7ce60db007$export$76ffa78e7c88f946).destroyTask(task.name);
                                },
                                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $baaeda96f7555c00$exports.Icon), {
                                    name: "trash"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
var $6a755942d3d53a73$export$ef06e7620d37c296 = (0, $e04d4b638436dc5e$export$b6ae1bc530f4c149)(function() {
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("ol", {
        className: "list-unstyled d-flex flex-column gap-3",
        children: (0, $1eb99b7ce60db007$export$76ffa78e7c88f946).tasks.map(function(task) {
            return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("li", {
                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($6a755942d3d53a73$export$ea3d6d720b5c931d, {
                    task: task
                })
            }, task.id);
        })
    });
});




var $62d578fe5a9fbe1c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $62d578fe5a9fbe1c$var$t = (0, $50993b47476de2e7$export$a7357cdd1f0b0168).t;
var $62d578fe5a9fbe1c$var$addTask = function(event) {
    return $62d578fe5a9fbe1c$var$__awaiter(void 0, void 0, void 0, function() {
        var form, path;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    event.preventDefault();
                    form = event.currentTarget;
                    path = (0, $lhPyT.formToJSON)(form).path;
                    return [
                        4,
                        (0, $1eb99b7ce60db007$export$76ffa78e7c88f946).createTask(path).start({
                            chunkSize: Math.pow(1024, 2) / 2
                        })
                    ];
                case 1:
                    _state.sent();
                    form.reset();
                    return [
                        2
                    ];
            }
        });
    });
};
var $62d578fe5a9fbe1c$export$2ad2ffac2ac2ce65 = (0, $e04d4b638436dc5e$export$b6ae1bc530f4c149)(function() {
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $1a4cf9540da0f5bb$export$2e2bcd8739ae039), {
        children: [
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("h1", {
                className: "my-4",
                children: (0, $6ea25dc1c0b3fb2a$export$d977f7cd0cb45fe1)($62d578fe5a9fbe1c$var$t('downloader'), $62d578fe5a9fbe1c$var$t('examples'))
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $fd86a401760e34c7$export$2e2bcd8739ae039), {
                className: "d-flex align-items-center gap-3 mb-3",
                onSubmit: $62d578fe5a9fbe1c$var$addTask,
                children: [
                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $5dbdbcea25a917f7$export$2e2bcd8739ae039), {
                        className: "flex-fill",
                        label: "URL",
                        children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $fd86a401760e34c7$export$2e2bcd8739ae039).Control, {
                            placeholder: "URL",
                            type: "url",
                            name: "path",
                            required: true
                        })
                    }),
                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $3a399bf6b2fd4261$export$2e2bcd8739ae039), {
                        type: "submit",
                        children: "+"
                    })
                ]
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $6a755942d3d53a73$export$ef06e7620d37c296), {})
        ]
    });
});



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");

var $7E0eS = parcelRequire("7E0eS");


parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");


var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");

var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $aUGqu = parcelRequire("aUGqu");


var $lhPyT = parcelRequire("lhPyT");

var $6rymm = parcelRequire("6rymm");
var $747ebf21472fd5d3$var$$ed859e9f463198da$var$HooksWrapper = function(_param) {
    var ClassComponent = _param.ClassComponent, props = (0, $6acIq._)(_param, [
        "ClassComponent"
    ]);
    var location = (0, $6rymm.useLocation)(), params = (0, $6rymm.useParams)();
    var tmp = location.pathname, pathname = tmp === void 0 ? '/' : tmp, tmp1 = location.search, search = tmp1 === void 0 ? '' : tmp1, tmp2 = location.hash, hash = tmp2 === void 0 ? '' : tmp2;
    var path = pathname + search + hash;
    var match = {
        url: globalThis.location.origin + path,
        path: path,
        params: params
    }, query = (0, $lhPyT.parseURLData)(search);
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(ClassComponent, (0, $1XAnY._)({
        location: location,
        match: match,
        query: query
    }, props));
};
var $747ebf21472fd5d3$export$369b6b2b30582e8e = function(Class, context) {
    // which is required for Semantic & Performance Optimization of JS runtimes,
    // and React lifecycle methods should be disabled to avoid duplicated calls.
    var ComponentWithRouter = /*#__PURE__*/ function(Class1) {
        "use strict";
        (0, $hdIku._)(ComponentWithRouter, Class1);
        function ComponentWithRouter() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $173N4._)(this, ComponentWithRouter);
            var _this;
            _this = (0, $7qXGD._)(this, ComponentWithRouter, (0, $aUGqu._)(args)), _this.state = {};
            return _this;
        }
        (0, $cFHGC._)(ComponentWithRouter, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {}
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {}
            },
            {
                key: "shouldComponentUpdate",
                value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
                    return true;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps, prevState, snapshot) {}
            },
            {
                key: "componentDidCatch",
                value: function componentDidCatch(error, errorInfo) {}
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {}
            },
            {
                key: "render",
                value: function render() {
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($747ebf21472fd5d3$var$$ed859e9f463198da$var$HooksWrapper, (0, $1XAnY._)({
                        ClassComponent: Class
                    }, this.props));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(nextProps, prevState) {
                    return {};
                }
            },
            {
                key: "getDerivedStateFromError",
                value: function getDerivedStateFromError(error) {}
            }
        ]);
        return ComponentWithRouter;
    }(Class);
    ComponentWithRouter.WrappedComponent = Class;
    ComponentWithRouter.displayName = "withRouter(".concat(Class.displayName || Class.name, ")");
    return ComponentWithRouter;
};



var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7E0eS = parcelRequire("7E0eS");

var $13u2V = parcelRequire("13u2V");

var $h2kUE = parcelRequire("h2kUE");

var $506de4b41e8d7f39$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $7E0eS._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $506de4b41e8d7f39$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $506de4b41e8d7f39$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $506de4b41e8d7f39$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $506de4b41e8d7f39$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $506de4b41e8d7f39$export$e94ab112fc249792 = function() {
    var _a, _ProjectModel_list_accessor_storage;
    var _list_decorators;
    var _list_initializers = [];
    var _list_extraInitializers = [];
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function ProjectModel() {
            (0, $173N4._)(this, ProjectModel);
            _ProjectModel_list_accessor_storage.set(this, $506de4b41e8d7f39$var$__runInitializers(this, _list_initializers, []));
            $506de4b41e8d7f39$var$__runInitializers(this, _list_extraInitializers);
        }
        (0, $cFHGC._)(ProjectModel, [
            {
                key: "list",
                get: function get() {
                    return $506de4b41e8d7f39$var$__classPrivateFieldGet(this, _ProjectModel_list_accessor_storage, "f");
                },
                set: function set(value) {
                    $506de4b41e8d7f39$var$__classPrivateFieldSet(this, _ProjectModel_list_accessor_storage, value, "f");
                }
            },
            {
                key: "clearList",
                value: function clearList() {
                    this.list = [];
                    (0, $1eb99b7ce60db007$export$8701c19c4b8c549b).clear();
                }
            },
            {
                key: "getList",
                value: function getList() {
                    for(var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++){
                        names[_key] = arguments[_key];
                    }
                    return $506de4b41e8d7f39$var$__awaiter(this, void 0, void 0, function() {
                        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, name, body, logo, err;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        7,
                                        8,
                                        9
                                    ]);
                                    _iterator = names[Symbol.iterator]();
                                    _state.label = 2;
                                case 2:
                                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                        3,
                                        6
                                    ];
                                    name = _step.value;
                                    return [
                                        4,
                                        (0, $1eb99b7ce60db007$export$8701c19c4b8c549b).getOne(name)
                                    ];
                                case 3:
                                    body = _state.sent();
                                    return [
                                        4,
                                        _a.getLogo(body.owner.login, body.name)
                                    ];
                                case 4:
                                    logo = _state.sent();
                                    this.list.push(Object.assign(Object.assign({}, body), {
                                        logo: logo
                                    }));
                                    _state.label = 5;
                                case 5:
                                    _iteratorNormalCompletion = true;
                                    return [
                                        3,
                                        2
                                    ];
                                case 6:
                                    return [
                                        3,
                                        9
                                    ];
                                case 7:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        9
                                    ];
                                case 8:
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                    return [
                                        7
                                    ];
                                case 9:
                                    return [
                                        2,
                                        this.list
                                    ];
                            }
                        });
                    });
                }
            }
        ], [
            {
                key: "getLogo",
                value: function getLogo(owner, repo) {
                    return $506de4b41e8d7f39$var$__awaiter(this, void 0, void 0, function() {
                        var _b;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    repo = repo.toLowerCase();
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        new Promise(function(resolve, reject) {
                                            var image = new Image();
                                            image.onload = function() {
                                                return resolve(image.src);
                                            };
                                            image.onerror = reject;
                                            image.src = "https://raw.githubusercontent.com/github/explore/master/topics/".concat(repo, "/").concat(repo, ".png");
                                        })
                                    ];
                                case 2:
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                                case 3:
                                    _b = _state.sent();
                                    return [
                                        2,
                                        "https://github.com/".concat(owner, ".png")
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            }
        ]);
        return ProjectModel;
    }(), _ProjectModel_list_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _list_decorators = [
            (0, $h2kUE.observable)
        ];
        $506de4b41e8d7f39$var$__esDecorate(_a, null, _list_decorators, {
            kind: "accessor",
            name: "list",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "list" in obj;
                },
                get: function(obj) {
                    return obj.list;
                },
                set: function(obj, value) {
                    obj.list = value;
                }
            },
            metadata: _metadata
        }, _list_initializers, _list_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $506de4b41e8d7f39$export$2e2bcd8739ae039 = new $506de4b41e8d7f39$export$e94ab112fc249792();



var $ca93ea259ddc746f$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $7E0eS._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ca93ea259ddc746f$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ca93ea259ddc746f$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $7E0eS._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $ca93ea259ddc746f$var$t = (0, $50993b47476de2e7$export$a7357cdd1f0b0168).t;
var $ca93ea259ddc746f$export$36d69433c4f81145 = function() {
    var _classDecorators = [
        (0, $747ebf21472fd5d3$export$369b6b2b30582e8e),
        (0, $e04d4b638436dc5e$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $tLNoZ.Component);
    var HomePage = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $hdIku._)(_classThis, _classSuper);
        function _classThis() {
            (0, $173N4._)(this, _classThis);
            var _this;
            _this = (0, $7qXGD._)(this, _classThis, arguments);
            Object.defineProperty(_this, "renderProject", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(param) {
                    var id = param.id, name = param.name, logo = param.logo, description = param.description, homepage = param.homepage, html_url = param.html_url;
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $bce75f99777ea046$export$2e2bcd8739ae039), {
                        className: "mb-3",
                        children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $71075948dbe2717f$export$2e2bcd8739ae039), {
                            className: "h-100",
                            children: [
                                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $71075948dbe2717f$export$2e2bcd8739ae039).Img, {
                                    variant: "top",
                                    src: logo
                                }),
                                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $71075948dbe2717f$export$2e2bcd8739ae039).Body, {
                                    children: [
                                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $71075948dbe2717f$export$2e2bcd8739ae039).Title, {
                                            children: name
                                        }),
                                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $71075948dbe2717f$export$2e2bcd8739ae039).Text, {
                                            children: description
                                        })
                                    ]
                                }),
                                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $71075948dbe2717f$export$2e2bcd8739ae039).Footer, {
                                    className: "d-flex justify-content-between",
                                    children: [
                                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $3a399bf6b2fd4261$export$2e2bcd8739ae039), {
                                            variant: "primary",
                                            size: "sm",
                                            target: "_blank",
                                            href: homepage,
                                            children: $ca93ea259ddc746f$var$t('home_page')
                                        }),
                                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $3a399bf6b2fd4261$export$2e2bcd8739ae039), {
                                            variant: "success",
                                            size: "sm",
                                            target: "_blank",
                                            href: html_url,
                                            children: $ca93ea259ddc746f$var$t('source_code')
                                        })
                                    ]
                                })
                            ]
                        })
                    }, id);
                }
            });
            return _this;
        }
        (0, $cFHGC._)(_classThis, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    (0, $506de4b41e8d7f39$export$2e2bcd8739ae039).getList('facebook/react', 'microsoft/TypeScript', 'mobxjs/mobx', 'react-bootstrap/react-bootstrap', 'EasyWebApp/KoAJAX', 'idea2app/ECharts-JSX');
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    (0, $506de4b41e8d7f39$export$2e2bcd8739ae039).clearList();
                }
            },
            {
                key: "render",
                value: function render() {
                    var guest = this.props.query.guest, list = (0, $506de4b41e8d7f39$export$2e2bcd8739ae039).list;
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $1a4cf9540da0f5bb$export$2e2bcd8739ae039), {
                        fluid: "md",
                        children: [
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("h1", {
                                className: "my-4",
                                children: $ca93ea259ddc746f$var$t('upstream_projects')
                            }),
                            guest && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("h2", {
                                children: [
                                    $ca93ea259ddc746f$var$t('welcome'),
                                    " ",
                                    guest,
                                    "!"
                                ]
                            }),
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $4a44c352fe7cf693$export$2e2bcd8739ae039), {
                                xs: 1,
                                sm: 2,
                                lg: 4,
                                children: list.map(this.renderProject)
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    $ca93ea259ddc746f$var$__setFunctionName(_classThis, "HomePage");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $ca93ea259ddc746f$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        HomePage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $ca93ea259ddc746f$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return HomePage = _classThis;
}();



var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");

var $7E0eS = parcelRequire("7E0eS");

var $tLNoZ = parcelRequire("tLNoZ");


var $h2kUE = parcelRequire("h2kUE");

var $e38fa592e8b33da5$exports = {};
var $e38fa592e8b33da5$var$$aac96070b6d8b41d$export$5eeb11949c905cc1;


var $tLNoZ = parcelRequire("tLNoZ");

var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");


"use client";
var $3dfaeff39cd5f1c6$var$ButtonGroup = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, size = _param.size, _param_vertical = _param.vertical, vertical = _param_vertical === void 0 ? false : _param_vertical, className = _param.className, _param_role = _param.role, role = _param_role === void 0 ? 'group' : _param_role, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, rest = (0, $6acIq._)(_param, [
        "bsPrefix",
        "size",
        "vertical",
        "className",
        "role",
        "as"
    ]);
    var prefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'btn-group');
    var baseClass = prefix;
    if (vertical) baseClass = "".concat(prefix, "-vertical");
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({}, rest), {
        ref: ref,
        role: role,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, baseClass, size && "".concat(prefix, "-").concat(size))
    }));
});
$3dfaeff39cd5f1c6$var$ButtonGroup.displayName = 'ButtonGroup';
var $3dfaeff39cd5f1c6$export$2e2bcd8739ae039 = $3dfaeff39cd5f1c6$var$ButtonGroup;


var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");




var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");



"use client";
var $c5bfe8e4423c8e16$var$InputGroupText = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'span' : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'input-group-text');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$c5bfe8e4423c8e16$var$InputGroupText.displayName = 'InputGroupText';
var $c5bfe8e4423c8e16$export$2e2bcd8739ae039 = $c5bfe8e4423c8e16$var$InputGroupText;



"use client";
var $d8869262459b9d45$var$InputGroupCheckbox = function(props) {
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $c5bfe8e4423c8e16$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $0152eaf5470e6a52$export$2e2bcd8739ae039), (0, $1XAnY._)({
            type: "checkbox"
        }, props))
    });
};
var $d8869262459b9d45$var$InputGroupRadio = function(props) {
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $c5bfe8e4423c8e16$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $0152eaf5470e6a52$export$2e2bcd8739ae039), (0, $1XAnY._)({
            type: "radio"
        }, props))
    });
};
var $d8869262459b9d45$var$InputGroup = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, size = _param.size, hasValidation = _param.hasValidation, className = _param.className, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "size",
        "hasValidation",
        "className",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'input-group');
    // Intentionally an empty object. Used in detecting if a dropdown
    // exists under an input group.
    var contextValue = (0, $lliNT.useMemo)(function() {
        return {};
    }, []);
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $b0277c37fa5cae1c$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({
            ref: ref
        }, props), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, size && "".concat(bsPrefix, "-").concat(size), hasValidation && 'has-validation')
        }))
    });
});
$d8869262459b9d45$var$InputGroup.displayName = 'InputGroup';
var $d8869262459b9d45$export$2e2bcd8739ae039 = Object.assign($d8869262459b9d45$var$InputGroup, {
    Text: (0, $c5bfe8e4423c8e16$export$2e2bcd8739ae039),
    Radio: $d8869262459b9d45$var$InputGroupRadio,
    Checkbox: $d8869262459b9d45$var$InputGroupCheckbox
});


var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");





var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");


var $1aLYV = parcelRequire("1aLYV");






"use client";
var $0de2699266839646$var$ListGroupItem = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, active = _param.active, disabled = _param.disabled, eventKey = _param.eventKey, className = _param.className, variant = _param.variant, action = _param.action, as = _param.as, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "active",
        "disabled",
        "eventKey",
        "className",
        "variant",
        "action",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'list-group-item');
    var _useNavItem = (0, $f9AOD._)((0, $5368ecd0a34b828d$export$d7a68693710982a)((0, $1XAnY._)({
        key: (0, $094e1eeba7f32a66$export$eef49b42fde998a3)(eventKey, props.href),
        active: active
    }, props)), 2), navItemProps = _useNavItem[0], meta = _useNavItem[1];
    var handleClick = (0, $ddf2f427ad010346$export$2e2bcd8739ae039)(function(event) {
        if (disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        navItemProps.onClick(event);
    });
    if (disabled && props.tabIndex === undefined) {
        props.tabIndex = -1;
        props['aria-disabled'] = true;
    }
    var Component = as || (action ? props.href ? 'a' : 'button' : 'div');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref
    }, props, navItemProps), {
        onClick: handleClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, meta.isActive && 'active', disabled && 'disabled', variant && "".concat(bsPrefix, "-").concat(variant), action && "".concat(bsPrefix, "-action"))
    }));
});
$0de2699266839646$var$ListGroupItem.displayName = 'ListGroupItem';
var $0de2699266839646$export$2e2bcd8739ae039 = $0de2699266839646$var$ListGroupItem;



"use client";
var $010c5059a1144c43$var$ListGroup = /*#__PURE__*/ $1aLYV.forwardRef(function(props, ref) {
    var _useUncontrolled = (0, $5e3a44538f1f449f$export$2e2bcd8739ae039)(props, {
        activeKey: 'onSelect'
    }), className = _useUncontrolled.className, initialBsPrefix = _useUncontrolled.bsPrefix, variant = _useUncontrolled.variant, horizontal = _useUncontrolled.horizontal, numbered = _useUncontrolled.numbered, _useUncontrolled_as = _useUncontrolled.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, as = _useUncontrolled_as === void 0 ? 'div' : _useUncontrolled_as, controlledProps = (0, $6acIq._)(_useUncontrolled, [
        "className",
        "bsPrefix",
        "variant",
        "horizontal",
        "numbered",
        "as"
    ]);
    var bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(initialBsPrefix, 'list-group');
    var horizontalVariant;
    if (horizontal) horizontalVariant = horizontal === true ? 'horizontal' : "horizontal-".concat(horizontal);
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $bd6614cfa53ddf4a$export$2e2bcd8739ae039), (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref
    }, controlledProps), {
        as: as,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, variant && "".concat(bsPrefix, "-").concat(variant), horizontalVariant && "".concat(bsPrefix, "-").concat(horizontalVariant), numbered && "".concat(bsPrefix, "-numbered"))
    }));
});
$010c5059a1144c43$var$ListGroup.displayName = 'ListGroup';
var $010c5059a1144c43$export$2e2bcd8739ae039 = Object.assign($010c5059a1144c43$var$ListGroup, {
    Item: (0, $0de2699266839646$export$2e2bcd8739ae039)
});


var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");






var $1a02a97bdd063b41$var$size;
function $1a02a97bdd063b41$export$2e2bcd8739ae039(recalc) {
    if (!$1a02a97bdd063b41$var$size && $1a02a97bdd063b41$var$size !== 0 || recalc) {
        if (0, $64f258eaaf92e603$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $1a02a97bdd063b41$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $1a02a97bdd063b41$var$size;
}


parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");
function $2a63eff5c26752ff$export$2e2bcd8739ae039() {
    return (0, $lliNT.useState)(null);
}







var $1aLYV = parcelRequire("1aLYV");
var $lliNT = parcelRequire("lliNT");




var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");



"use client";
var $4efcf097a08b39ed$var$ModalBody = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'modal-body');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$4efcf097a08b39ed$var$ModalBody.displayName = 'ModalBody';
var $4efcf097a08b39ed$export$2e2bcd8739ae039 = $4efcf097a08b39ed$var$ModalBody;




var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");


"use client";
var $c632d09fdc66e451$var$ModalDialog = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, contentClassName = _param.contentClassName, centered = _param.centered, size = _param.size, fullscreen = _param.fullscreen, children = _param.children, scrollable = _param.scrollable, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "contentClassName",
        "centered",
        "size",
        "fullscreen",
        "children",
        "scrollable"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'modal');
    var dialogClass = "".concat(bsPrefix, "-dialog");
    var fullScreenClass = typeof fullscreen === 'string' ? "".concat(bsPrefix, "-fullscreen-").concat(fullscreen) : "".concat(bsPrefix, "-fullscreen");
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", (0, $6fpqi._)((0, $1XAnY._)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(dialogClass, className, size && "".concat(bsPrefix, "-").concat(size), centered && "".concat(dialogClass, "-centered"), scrollable && "".concat(dialogClass, "-scrollable"), fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("".concat(bsPrefix, "-content"), contentClassName),
            children: children
        })
    }));
});
$c632d09fdc66e451$var$ModalDialog.displayName = 'ModalDialog';
var $c632d09fdc66e451$export$2e2bcd8739ae039 = $c632d09fdc66e451$var$ModalDialog;



var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");



"use client";
var $04371900b5862c5c$var$ModalFooter = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'modal-footer');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$04371900b5862c5c$var$ModalFooter.displayName = 'ModalFooter';
var $04371900b5862c5c$export$2e2bcd8739ae039 = $04371900b5862c5c$var$ModalFooter;



var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");



"use client";
var $373d1b5abedbe18a$var$ModalHeader = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, _param_closeLabel = _param.closeLabel, closeLabel = _param_closeLabel === void 0 ? 'Close' : _param_closeLabel, _param_closeButton = _param.closeButton, closeButton = _param_closeButton === void 0 ? false : _param_closeButton, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "closeLabel",
        "closeButton"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'modal-header');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $c361ae1a26c65942$export$2e2bcd8739ae039), (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    }));
});
$373d1b5abedbe18a$var$ModalHeader.displayName = 'ModalHeader';
var $373d1b5abedbe18a$export$2e2bcd8739ae039 = $373d1b5abedbe18a$var$ModalHeader;



var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $1aLYV = parcelRequire("1aLYV");




"use client";
var $ffa1e3bb77e8d25f$var$DivStyledAsH4 = (0, $2dc371b22567e8b5$export$2e2bcd8739ae039)('h4');
var $ffa1e3bb77e8d25f$var$ModalTitle = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? $ffa1e3bb77e8d25f$var$DivStyledAsH4 : tmp, props = (0, $6acIq._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'modal-title');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $1XAnY._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$ffa1e3bb77e8d25f$var$ModalTitle.displayName = 'ModalTitle';
var $ffa1e3bb77e8d25f$export$2e2bcd8739ae039 = $ffa1e3bb77e8d25f$var$ModalTitle;




"use client";
function $858037c357c14af3$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $fad1b22621dd9d86$export$2e2bcd8739ae039), (0, $6fpqi._)((0, $1XAnY._)({}, props), {
        timeout: null
    }));
}
function $858037c357c14af3$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $fad1b22621dd9d86$export$2e2bcd8739ae039), (0, $6fpqi._)((0, $1XAnY._)({}, props), {
        timeout: null
    }));
}
var $858037c357c14af3$var$Modal = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, style = _param.style, dialogClassName = _param.dialogClassName, contentClassName = _param.contentClassName, children = _param.children, tmp = _param.dialogAs, Dialog = tmp === void 0 ? (0, $c632d09fdc66e451$export$2e2bcd8739ae039) : tmp, dataBsTheme = _param['data-bs-theme'], ariaLabelledby = _param['aria-labelledby'], ariaDescribedby = _param['aria-describedby'], ariaLabel = _param['aria-label'], _param_show = _param./* BaseModal props */ show, show = _param_show === void 0 ? false : _param_show, _param_animation = _param.animation, animation = _param_animation === void 0 ? true : _param_animation, _param_backdrop = _param.backdrop, backdrop = _param_backdrop === void 0 ? true : _param_backdrop, _param_keyboard = _param.keyboard, keyboard = _param_keyboard === void 0 ? true : _param_keyboard, onEscapeKeyDown = _param.onEscapeKeyDown, onShow = _param.onShow, onHide = _param.onHide, container = _param.container, _param_autoFocus = _param.autoFocus, autoFocus = _param_autoFocus === void 0 ? true : _param_autoFocus, _param_enforceFocus = _param.enforceFocus, enforceFocus = _param_enforceFocus === void 0 ? true : _param_enforceFocus, _param_restoreFocus = _param.restoreFocus, restoreFocus = _param_restoreFocus === void 0 ? true : _param_restoreFocus, restoreFocusOptions = _param.restoreFocusOptions, onEntered = _param.onEntered, onExit = _param.onExit, onExiting = _param.onExiting, onEnter = _param.onEnter, onEntering = _param.onEntering, onExited = _param.onExited, backdropClassName = _param.backdropClassName, propsManager = _param.manager, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "style",
        "dialogClassName",
        "contentClassName",
        "children",
        "dialogAs",
        'data-bs-theme',
        'aria-labelledby',
        'aria-describedby',
        'aria-label',
        "show",
        "animation",
        "backdrop",
        "keyboard",
        "onEscapeKeyDown",
        "onShow",
        "onHide",
        "container",
        "autoFocus",
        "enforceFocus",
        "restoreFocus",
        "restoreFocusOptions",
        "onEntered",
        "onExit",
        "onExiting",
        "onEnter",
        "onEntering",
        "onExited",
        "backdropClassName",
        "manager"
    ]);
    var _useState = (0, $f9AOD._)((0, $lliNT.useState)({}), 2), modalStyle = _useState[0], setStyle = _useState[1];
    var _useState1 = (0, $f9AOD._)((0, $lliNT.useState)(false), 2), animateStaticModal = _useState1[0], setAnimateStaticModal = _useState1[1];
    var waitingForMouseUpRef = (0, $lliNT.useRef)(false);
    var ignoreBackdropClickRef = (0, $lliNT.useRef)(false);
    var removeStaticModalAnimationRef = (0, $lliNT.useRef)(null);
    var _useCallbackRef = (0, $f9AOD._)((0, $2a63eff5c26752ff$export$2e2bcd8739ae039)(), 2), modal = _useCallbackRef[0], setModalRef = _useCallbackRef[1];
    var mergedRef = (0, $d9cf73fca09b1f80$export$2e2bcd8739ae039)(ref, setModalRef);
    var handleHide = (0, $ddf2f427ad010346$export$2e2bcd8739ae039)(onHide);
    var isRTL = (0, $86d2028892b8b8bc$export$35e511eefa30ac5a)();
    bsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'modal');
    var modalContext = (0, $lliNT.useMemo)(function() {
        return {
            onHide: handleHide
        };
    }, [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $26887413ddd3bac4$export$a03641438014b436)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $64f258eaaf92e603$export$2e2bcd8739ae039)) return;
        var containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        var modalIsOverflowing = node.scrollHeight > (0, $cb03b130654deaba$export$2e2bcd8739ae039)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $1a02a97bdd063b41$export$2e2bcd8739ae039)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $1a02a97bdd063b41$export$2e2bcd8739ae039)() : undefined
        });
    }
    var handleWindowResize = (0, $ddf2f427ad010346$export$2e2bcd8739ae039)(function() {
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $869fff146bdda3b2$export$2e2bcd8739ae039)(function() {
        (0, $0e5e4de4085acd94$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    var handleDialogMouseDown = function() {
        waitingForMouseUpRef.current = true;
    };
    var handleMouseUp = function(e) {
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    var handleStaticModalAnimation = function() {
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $eb2ed0bd2d792c29$export$2e2bcd8739ae039)(modal.dialog, function() {
            setAnimateStaticModal(false);
        });
    };
    var handleStaticBackdropClick = function(e) {
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    var handleClick = function(e) {
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    var handleEscapeKeyDown = function(e) {
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === 'static') // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    var handleEnter = function(node, isAppearing) {
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    var handleExit = function(node) {
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    var handleEntering = function(node, isAppearing) {
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $fe9809a8616a080a$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    var handleExited = function(node) {
        if (node) node.style.display = ''; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $0e5e4de4085acd94$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    var renderBackdrop = (0, $lliNT.useCallback)(function(backdropProps) {
        return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", (0, $6fpqi._)((0, $1XAnY._)({}, backdropProps), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("".concat(bsPrefix, "-backdrop"), backdropClassName, !animation && 'show')
        }));
    }, [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    var baseModalStyle = (0, $1XAnY._)({}, style, modalStyle);
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = 'block';
    var renderDialog = function(dialogProps) {
        return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", (0, $6fpqi._)((0, $1XAnY._)({
            role: "dialog"
        }, dialogProps), {
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, animateStaticModal && "".concat(bsPrefix, "-static"), !animation && 'show'),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Dialog, (0, $6fpqi._)((0, $1XAnY._)({}, props), {
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            }))
        }));
    };
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $1a48f96a46bf373a$export$2e2bcd8739ae039).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $05de7f34de43cf4e$export$2e2bcd8739ae039), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $858037c357c14af3$var$DialogTransition : undefined,
            backdropTransition: animation ? $858037c357c14af3$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$858037c357c14af3$var$Modal.displayName = 'Modal';
var $858037c357c14af3$export$2e2bcd8739ae039 = Object.assign($858037c357c14af3$var$Modal, {
    Body: (0, $4efcf097a08b39ed$export$2e2bcd8739ae039),
    Header: (0, $373d1b5abedbe18a$export$2e2bcd8739ae039),
    Title: (0, $ffa1e3bb77e8d25f$export$2e2bcd8739ae039),
    Footer: (0, $04371900b5862c5c$export$2e2bcd8739ae039),
    Dialog: (0, $c632d09fdc66e451$export$2e2bcd8739ae039),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});


var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");


var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");


var $1aLYV = parcelRequire("1aLYV");


var $a4fda86567f5a934$var$PageItem = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var _param_active = _param.active, active = _param_active === void 0 ? false : _param_active, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, className = _param.className, style = _param.style, _param_activeLabel = _param.activeLabel, activeLabel = _param_activeLabel === void 0 ? '(current)' : _param_activeLabel, children = _param.children, linkStyle = _param.linkStyle, linkClassName = _param.linkClassName, _param_as = _param.as, as = _param_as === void 0 ? (0, $4ee4bd8500b08465$export$2e2bcd8739ae039) : _param_as, props = (0, $6acIq._)(_param, [
        "active",
        "disabled",
        "className",
        "style",
        "activeLabel",
        "children",
        "linkStyle",
        "linkClassName",
        "as"
    ]);
    var Component = active || disabled ? 'span' : as;
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("li", {
        ref: ref,
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, 'page-item', {
            active: active,
            disabled: disabled
        }),
        children: /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(Component, (0, $6fpqi._)((0, $1XAnY._)({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))('page-link', linkClassName),
            style: linkStyle
        }, props), {
            children: [
                children,
                active && activeLabel && /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("span", {
                    className: "visually-hidden",
                    children: activeLabel
                })
            ]
        }))
    });
});
$a4fda86567f5a934$var$PageItem.displayName = 'PageItem';
var $a4fda86567f5a934$export$2e2bcd8739ae039 = $a4fda86567f5a934$var$PageItem;
function $a4fda86567f5a934$var$createButton(name, defaultValue) {
    var label = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : name;
    var Button = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
        var children = _param.children, props = (0, $6acIq._)(_param, [
            "children"
        ]);
        return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($a4fda86567f5a934$var$PageItem, (0, $6fpqi._)((0, $1XAnY._)({}, props), {
            ref: ref,
            children: [
                /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("span", {
                    "aria-hidden": "true",
                    children: children || defaultValue
                }),
                /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("span", {
                    className: "visually-hidden",
                    children: label
                })
            ]
        }));
    });
    Button.displayName = name;
    return Button;
}
var $a4fda86567f5a934$export$b25abba66f7be210 = $a4fda86567f5a934$var$createButton('First', "\xab");
var $a4fda86567f5a934$export$1b265216817111b9 = $a4fda86567f5a934$var$createButton('Prev', "\u2039", 'Previous');
var $a4fda86567f5a934$export$1297970233533a7d = $a4fda86567f5a934$var$createButton('Ellipsis', "\u2026", 'More');
var $a4fda86567f5a934$export$b820fc49f2736e85 = $a4fda86567f5a934$var$createButton('Next', "\u203A");
var $a4fda86567f5a934$export$bed9238d8933c9a8 = $a4fda86567f5a934$var$createButton('Last', "\xbb");



"use client";
var $1cb765a5e073f955$var$Pagination = /*#__PURE__*/ $1aLYV.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, size = _param.size, props = (0, $6acIq._)(_param, [
        "bsPrefix",
        "className",
        "size"
    ]);
    var decoratedBsPrefix = (0, $86d2028892b8b8bc$export$7f387860ebffb32c)(bsPrefix, 'pagination');
    return /*#__PURE__*/ (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("ul", (0, $6fpqi._)((0, $1XAnY._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, decoratedBsPrefix, size && "".concat(decoratedBsPrefix, "-").concat(size))
    }));
});
$1cb765a5e073f955$var$Pagination.displayName = 'Pagination';
var $1cb765a5e073f955$export$2e2bcd8739ae039 = Object.assign($1cb765a5e073f955$var$Pagination, {
    First: (0, $a4fda86567f5a934$export$b25abba66f7be210),
    Prev: (0, $a4fda86567f5a934$export$1b265216817111b9),
    Ellipsis: (0, $a4fda86567f5a934$export$1297970233533a7d),
    Item: (0, $a4fda86567f5a934$export$2e2bcd8739ae039),
    Next: (0, $a4fda86567f5a934$export$b820fc49f2736e85),
    Last: (0, $a4fda86567f5a934$export$bed9238d8933c9a8)
});



var $lhPyT = parcelRequire("lhPyT");








var $h2kUE = parcelRequire("h2kUE");


var $6bbd1df5c21e35ca$export$71511d61b312f219;
"use strict";




function $6bbd1df5c21e35ca$var$_to_array(arr) {
    return $c18e3812bf284031$export$71511d61b312f219(arr) || $b16444858f6a2e44$export$71511d61b312f219(arr) || $c2dbeb089f9f1560$export$71511d61b312f219(arr) || $1656378974c9464f$export$71511d61b312f219();
}
$6bbd1df5c21e35ca$export$71511d61b312f219 = $6bbd1df5c21e35ca$var$_to_array;





var $45b8819b503a7835$export$71511d61b312f219;
"use strict";
function $45b8819b503a7835$var$_object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
$45b8819b503a7835$export$71511d61b312f219 = $45b8819b503a7835$var$_object_destructuring_empty;


var $b535bc2d74d7beda$export$71511d61b312f219;
"use strict";
function $b535bc2d74d7beda$var$_define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$b535bc2d74d7beda$export$71511d61b312f219 = $b535bc2d74d7beda$var$_define_property;


parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");


var $hDKce = parcelRequire("hDKce");

function $e38fa592e8b33da5$var$$parcel$exportWildcard(e, t) {
    return Object.keys(t).forEach(function(r) {
        "default" === r || "__esModule" === r || Object.prototype.hasOwnProperty.call(e, r) || Object.defineProperty(e, r, {
            enumerable: !0,
            get: function get() {
                return t[r];
            }
        });
    }), e;
}
function $e38fa592e8b33da5$var$$parcel$export(e, t, r, a) {
    Object.defineProperty(e, t, {
        get: r,
        set: a,
        enumerable: !0,
        configurable: !0
    });
}
function $e38fa592e8b33da5$var$$parcel$interopDefault(e) {
    return e && e.__esModule ? e.default : e;
}
var $e38fa592e8b33da5$var$$f600741b98acd6fe$exports = {};
$e38fa592e8b33da5$var$$parcel$export($e38fa592e8b33da5$var$$f600741b98acd6fe$exports, "VariantColors", function() {
    return $e38fa592e8b33da5$var$$f600741b98acd6fe$export$50b010be9260e56b;
}), $e38fa592e8b33da5$var$$parcel$export($e38fa592e8b33da5$var$$f600741b98acd6fe$exports, "text2color", function() {
    return $e38fa592e8b33da5$var$$f600741b98acd6fe$export$b480d00b75c9ac2d;
}), $e38fa592e8b33da5$var$$parcel$export($e38fa592e8b33da5$var$$f600741b98acd6fe$exports, "BadgeBar", function() {
    return $e38fa592e8b33da5$var$$f600741b98acd6fe$export$ef1c4106ceccca63;
});
var $e38fa592e8b33da5$var$$f600741b98acd6fe$var$__rest = function $f600741b98acd6fe$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $e38fa592e8b33da5$var$$f600741b98acd6fe$export$50b010be9260e56b = [
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info"
], $e38fa592e8b33da5$var$$f600741b98acd6fe$export$b480d00b75c9ac2d = function $f600741b98acd6fe$export$b480d00b75c9ac2d(e) {
    return $e38fa592e8b33da5$var$$f600741b98acd6fe$export$50b010be9260e56b[$lhPyT.sum.apply(void 0, (0, $2b3349705fb2cb54$export$71511d61b312f219)(Array.from(e, function(e) {
        return e.charCodeAt(0);
    }))) % $e38fa592e8b33da5$var$$f600741b98acd6fe$export$50b010be9260e56b.length];
}, $e38fa592e8b33da5$var$$f600741b98acd6fe$export$ef1c4106ceccca63 = function $f600741b98acd6fe$export$ef1c4106ceccca63(e) {
    var t = e.className, r = e.list, a = e.bgResolver, n = void 0 === a ? $e38fa592e8b33da5$var$$f600741b98acd6fe$export$b480d00b75c9ac2d : a, c = e.onCheck, s = e.onDelete, i = $e38fa592e8b33da5$var$$f600741b98acd6fe$var$__rest(e, [
        "className",
        "list",
        "bgResolver",
        "onCheck",
        "onDelete"
    ]);
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("ul", Object.assign({
        className: "list-unstyled m-0 d-flex flex-wrap gap-2 ".concat(void 0 === t ? "" : t)
    }, i, {
        children: r.map(function(e, t) {
            var r = e.text, a = e.link;
            return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($b4b154a3007acf25$export$2e2bcd8739ae039, {
                bg: n(r),
                text: "white",
                as: "li",
                className: "d-flex align-items-center gap-2",
                children: [
                    a || URL.canParse(r) ? (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("a", {
                        className: "text-decoration-none text-white",
                        href: a || r,
                        children: r
                    }) : c ? (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("span", {
                        onClick: function onClick() {
                            return c({
                                text: r,
                                link: a
                            }, t);
                        },
                        children: r
                    }) : r,
                    s && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($69561b249377d853$export$2e2bcd8739ae039, {
                        onClick: function onClick() {
                            return s({
                                text: r,
                                link: a
                            }, t);
                        }
                    })
                ]
            }, r);
        })
    }));
};
$e38fa592e8b33da5$var$$f600741b98acd6fe$export$ef1c4106ceccca63.displayName = "BadgeBar";
var $e38fa592e8b33da5$var$$faee9857e4bdfa8b$exports = {};
$e38fa592e8b33da5$var$$parcel$export($e38fa592e8b33da5$var$$faee9857e4bdfa8b$exports, "ImagePreview", function() {
    return $e38fa592e8b33da5$var$$faee9857e4bdfa8b$export$4a96334d5925dbf2;
});
var $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__runInitializers = function $faee9857e4bdfa8b$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__esDecorate = function $faee9857e4bdfa8b$var$__esDecorate(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__awaiter = function $faee9857e4bdfa8b$var$__awaiter(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var _$t;
            e.done ? n(e.value) : ((_$t = e.value) instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__setFunctionName = function $faee9857e4bdfa8b$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__classPrivateFieldGet = function $faee9857e4bdfa8b$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__classPrivateFieldSet = function $faee9857e4bdfa8b$var$__classPrivateFieldSet(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__rest = function $faee9857e4bdfa8b$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $e38fa592e8b33da5$var$$faee9857e4bdfa8b$export$4a96334d5925dbf2 = function() {
    var e, t, r, a, n, c, s, i, o, l, u, p = [
        $e04d4b638436dc5e$export$b6ae1bc530f4c149
    ], $ = [], f = $524de0d5a72e1bc6$exports.ObservedComponent, d = [], b = [], m = [], v = [], h = [], _ = [], j = [];
    return s = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), r.set(_$e, ($e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__runInitializers(_$e, d), $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__runInitializers(_$e, b, !1))), a.set(_$e, ($e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__runInitializers(_$e, m), $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__runInitializers(_$e, v, ""))), n.set(_$e, ($e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__runInitializers(_$e, h), $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__runInitializers(_$e, _, !1))), $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__runInitializers(_$e, j), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "downloading",
                get: function get() {
                    return $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "loadedPath",
                get: function get() {
                    return $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function set(e) {
                    $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "viewing",
                get: function get() {
                    return $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__classPrivateFieldGet(this, n, "f");
                },
                set: function set(e) {
                    $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__classPrivateFieldSet(this, n, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    var _$e = this.observedProps.src;
                    this.loadedPath = "", _$e && this.load(_$e);
                }
            },
            {
                key: "load",
                value: function value(e) {
                    return $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__awaiter(this, void 0, void 0, function() {
                        return (0, $ea05ccc2484f951f$export$71511d61b312f219)(this, function(t) {
                            switch(t.label){
                                case 0:
                                    return this.downloading = !0, [
                                        4,
                                        new Promise(function(t, r) {
                                            var a = new globalThis.Image;
                                            a.onload = t, a.onerror = r, a.src = e;
                                        })
                                    ];
                                case 1:
                                    return t.sent(), this.loadedPath = e, this.downloading = !1, [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this, _$t = this.downloading, r = this.loadedPath, a = this.viewing, n = this.props, c = n.className, s = n.loading, i = (n.src, n.fluid), o = n.rounded, l = n.roundedCircle, u = n.thumbnail, p = $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__rest(n, [
                        "className",
                        "loading",
                        "src",
                        "fluid",
                        "rounded",
                        "roundedCircle",
                        "thumbnail"
                    ]);
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", Object.assign({
                        className: $e38fa592e8b33da5$var$$parcel$interopDefault($8bd163097a5514bf$exports)("m-0", _$t && "d-flex justify-content-center align-items-center", c)
                    }, p, {
                        children: [
                            _$t ? (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($d5fc9490b2821269$export$2e2bcd8739ae039, {}) : r && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($9f5f1ff841daa39a$export$2e2bcd8739ae039, {
                                className: "object-fit-contain",
                                loading: s,
                                fluid: i,
                                rounded: o,
                                roundedCircle: l,
                                thumbnail: u,
                                src: r,
                                onClick: function onClick() {
                                    return _$e.viewing = !0;
                                }
                            }),
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($858037c357c14af3$export$2e2bcd8739ae039, {
                                centered: !0,
                                show: a,
                                onHide: function onHide() {
                                    return _$e.viewing = !1;
                                },
                                children: [
                                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($858037c357c14af3$export$2e2bcd8739ae039.Body, {
                                        className: "text-center",
                                        children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($9f5f1ff841daa39a$export$2e2bcd8739ae039, {
                                            fluid: !0,
                                            src: r
                                        })
                                    }),
                                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($858037c357c14af3$export$2e2bcd8739ae039.Footer, {
                                        className: "justify-content-center",
                                        as: "a",
                                        href: r,
                                        target: "_blank",
                                        download: r.split("/").pop(),
                                        children: r
                                    })
                                ]
                            })
                        ]
                    }));
                }
            }
        ]), t;
    }(f), r = new WeakMap, a = new WeakMap, n = new WeakMap, $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__setFunctionName(s, "ImagePreview"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = f[Symbol.metadata]) ? e : null) : void 0, i = [
        $h2kUE.observable
    ], o = [
        $h2kUE.observable
    ], l = [
        $h2kUE.observable
    ], u = [
        (0, $524de0d5a72e1bc6$exports.reaction)(function(e) {
            return e.observedProps.src;
        })
    ], $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__esDecorate(s, null, i, {
        kind: "accessor",
        name: "downloading",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "downloading" in e;
            },
            get: function get(e) {
                return e.downloading;
            },
            set: function set(e, t) {
                e.downloading = t;
            }
        },
        metadata: t
    }, b, m), $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__esDecorate(s, null, o, {
        kind: "accessor",
        name: "loadedPath",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "loadedPath" in e;
            },
            get: function get(e) {
                return e.loadedPath;
            },
            set: function set(e, t) {
                e.loadedPath = t;
            }
        },
        metadata: t
    }, v, h), $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__esDecorate(s, null, l, {
        kind: "accessor",
        name: "viewing",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "viewing" in e;
            },
            get: function get(e) {
                return e.viewing;
            },
            set: function set(e, t) {
                e.viewing = t;
            }
        },
        metadata: t
    }, _, j), $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__esDecorate(s, null, u, {
        kind: "method",
        name: "componentDidMount",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "componentDidMount" in e;
            },
            get: function get(e) {
                return e.componentDidMount;
            }
        },
        metadata: t
    }, null, d), $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__esDecorate(null, c = {
        value: s
    }, p, {
        kind: "class",
        name: s.name,
        metadata: t
    }, null, $), s = c.value, t && Object.defineProperty(s, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(s, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "ImagePreview"
    }), $e38fa592e8b33da5$var$$faee9857e4bdfa8b$var$__runInitializers(s, $), s;
}(), $e38fa592e8b33da5$var$$8663609ea235ec39$exports = {};
$e38fa592e8b33da5$var$$parcel$export($e38fa592e8b33da5$var$$8663609ea235ec39$exports, "FileTypeMap", function() {
    return $e38fa592e8b33da5$var$$8663609ea235ec39$export$413fb8502ce63cf9;
}), $e38fa592e8b33da5$var$$parcel$export($e38fa592e8b33da5$var$$8663609ea235ec39$exports, "FilePreview", function() {
    return $e38fa592e8b33da5$var$$8663609ea235ec39$export$a127194569a41afb;
});
var $e38fa592e8b33da5$var$$8663609ea235ec39$var$__rest = function $8663609ea235ec39$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $e38fa592e8b33da5$var$$8663609ea235ec39$export$413fb8502ce63cf9 = {
    stream: "binary",
    compressed: "zip",
    msword: "doc",
    document: "docx",
    powerpoint: "ppt",
    presentation: "pptx",
    excel: "xls",
    sheet: "xlsx"
}, $e38fa592e8b33da5$var$$8663609ea235ec39$export$a127194569a41afb = function $8663609ea235ec39$export$a127194569a41afb(e) {
    var t = e.className, r = e.style, a = e.hidden, n = e.type, c = e.path, s = $e38fa592e8b33da5$var$$8663609ea235ec39$var$__rest(e, [
        "className",
        "style",
        "hidden",
        "type",
        "path"
    ]), i = (0, $6bbd1df5c21e35ca$export$71511d61b312f219)((null == n ? void 0 : n.split(/\W+/)) || []), o = i[0], l = i.slice(1), u = decodeURI(new URL(c, "http://localhost").pathname.split("/").at(-1)), p = $e38fa592e8b33da5$var$$8663609ea235ec39$export$413fb8502ce63cf9[l.at(-1)] || ((null == u ? void 0 : u.includes(".")) ? u.split(".").at(-1) : l.at(-1));
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("figure", {
        className: "d-flex flex-column align-items-center justify-content-center m-0 ".concat(void 0 === t ? "" : t),
        style: r,
        hidden: a,
        children: "image" === o ? (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($e38fa592e8b33da5$var$$faee9857e4bdfa8b$export$4a96334d5925dbf2, Object.assign({
            className: "h-100",
            fluid: !0,
            loading: "lazy",
            src: c
        }, s)) : "audio" === o ? (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("audio", Object.assign({
            controls: !0,
            src: c
        }, s)) : "video" === o ? (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("video", Object.assign({
            muted: !0,
            src: c,
            onMouseEnter: function onMouseEnter(e) {
                return e.currentTarget.play();
            },
            onMouseLeave: function onMouseLeave(e) {
                return e.currentTarget.pause();
            }
        }, s)) : (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($tLNoZ.Fragment, {
            children: [
                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("a", Object.assign({
                    className: "d-inline-flex justify-content-center align-items-center",
                    href: c,
                    target: "_blank",
                    download: u
                }, s, {
                    children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("i", {
                        className: "bi bi-filetype-".concat(p || "file-earmark", " fs-1")
                    })
                })),
                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("figcaption", {
                    className: "mw-100 text-truncate",
                    children: u
                })
            ]
        })
    });
};
$e38fa592e8b33da5$var$$8663609ea235ec39$export$a127194569a41afb.displayName = "FilePreview";
var $e38fa592e8b33da5$var$$f2af1554fbcf9c96$exports = {};
$e38fa592e8b33da5$var$$parcel$export($e38fa592e8b33da5$var$$f2af1554fbcf9c96$exports, "FilePicker", function() {
    return $e38fa592e8b33da5$var$$f2af1554fbcf9c96$export$54dc470bcc5c41d1;
});
var $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__runInitializers = function $f2af1554fbcf9c96$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__esDecorate = function $f2af1554fbcf9c96$var$__esDecorate(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__awaiter = function $f2af1554fbcf9c96$var$__awaiter(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var _$t;
            e.done ? n(e.value) : ((_$t = e.value) instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__setFunctionName = function $f2af1554fbcf9c96$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__classPrivateFieldGet = function $f2af1554fbcf9c96$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__classPrivateFieldSet = function $f2af1554fbcf9c96$var$__classPrivateFieldSet(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$blobCache = new WeakMap, $e38fa592e8b33da5$var$$f2af1554fbcf9c96$export$54dc470bcc5c41d1 = function() {
    var e, t, r, a, n, c, s, i, o, l, u = [
        $e04d4b638436dc5e$export$b6ae1bc530f4c149
    ], p = [], $ = $524de0d5a72e1bc6$exports.FormComponent, f = [], d = [], b = [];
    return c = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), a.set(_$e, ($e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__runInitializers(_$e, f), $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__runInitializers(_$e, d, void 0))), r.set(_$e, ($e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__runInitializers(_$e, b), function(t) {
                if (_$e.file = t, t) _$e.innerValue = t, $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$blobCache.set(t, URL.createObjectURL(t));
                else if (_$e.value) {
                    var r = _$e.innerValue;
                    "string" == typeof r && r.startsWith("blob:") ? URL.revokeObjectURL(r) : r instanceof File && $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$blobCache.delete(r), _$e.innerValue = "";
                }
            })), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "file",
                get: function get() {
                    return $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function set(e) {
                    $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "fileType",
                get: function get() {
                    var _$e, _$t = this.observedProps.accept, r = this.file;
                    return (null == r ? void 0 : r.type) || (null == (_$e = null == r ? void 0 : r.name.match(/\.\w+$/)) ? void 0 : _$e[0]) || _$t;
                }
            },
            {
                key: "filePath",
                get: function get() {
                    var _$e = this.value;
                    return "string" == typeof _$e ? _$e : $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$blobCache.get(_$e);
                }
            },
            {
                key: "restoreFile",
                value: function value(e) {
                    return $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__awaiter(this, void 0, void 0, function() {
                        var _$t, r;
                        return (0, $ea05ccc2484f951f$export$71511d61b312f219)(this, function(a) {
                            switch(a.label){
                                case 0:
                                    if ("string" != typeof e) return [
                                        3,
                                        4
                                    ];
                                    a.label = 1;
                                case 1:
                                    return a.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]), [
                                        4,
                                        (0, $lhPyT.blobOf)(e)
                                    ];
                                case 2:
                                    return r = new File([
                                        _$t = a.sent()
                                    ], e.split("/").at(-1), {
                                        type: _$t.type
                                    }), $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$blobCache.set(r, e), [
                                        2,
                                        this.file = r
                                    ];
                                case 3:
                                    return a.sent(), [
                                        3,
                                        4
                                    ];
                                case 4:
                                    if (e instanceof File) return $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$blobCache.has(e) || $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$blobCache.set(e, URL.createObjectURL(e)), [
                                        2,
                                        this.file = e
                                    ];
                                    return [
                                        2,
                                        this.file = void 0
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    (0, $57751a2649dd1683$export$71511d61b312f219)((0, $ae6313b3cbf000af$export$71511d61b312f219)(t.prototype), "componentDidMount", this).call(this), this.restoreFile(this.value);
                }
            },
            {
                key: "renderInput",
                value: function value() {
                    var _$e = this, _$t = this.props, a = _$t.id, n = _$t.name, c = _$t.value, s = _$t.required, i = _$t.disabled, o = _$t.accept, l = _$t.multiple, u = this.filePath;
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($tLNoZ.Fragment, {
                        children: [
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("input", {
                                ref: this.ref,
                                className: "position-absolute start-0 top-0 w-100 h-100 opacity-0",
                                type: "file",
                                name: c ? void 0 : n,
                                required: !c && s,
                                id: a,
                                disabled: i,
                                accept: o,
                                multiple: l,
                                onChange: function onChange(t) {
                                    var a = t.currentTarget.files;
                                    return $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__classPrivateFieldGet(_$e, r, "f").call(_$e, null == a ? void 0 : a[0]);
                                }
                            }),
                            u && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("input", {
                                type: "hidden",
                                name: n,
                                value: u
                            })
                        ]
                    });
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this, _$t = this.filePath, a = this.fileType, n = this.props, c = n.className, s = n.style;
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                        className: "d-inline-block border rounded position-relative ".concat(void 0 === c ? "" : c),
                        style: Object.assign({
                            width: "10rem",
                            height: "10rem"
                        }, s),
                        children: [
                            _$t ? (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($e38fa592e8b33da5$var$$8663609ea235ec39$export$a127194569a41afb, {
                                className: "w-100 h-100",
                                type: a,
                                path: _$t
                            }) : (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                                className: "w-100 h-100 d-flex justify-content-center align-items-center display-1",
                                children: "+"
                            }),
                            this.renderInput(),
                            _$t && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($69561b249377d853$export$2e2bcd8739ae039, {
                                className: "position-absolute top-0 end-0",
                                style: {
                                    width: "0.5rem",
                                    height: "0.5rem"
                                },
                                onClick: function onClick() {
                                    return $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__classPrivateFieldGet(_$e, r, "f").call(_$e);
                                }
                            })
                        ]
                    });
                }
            }
        ]), t;
    }($), r = new WeakMap, a = new WeakMap, $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__setFunctionName(c, "FilePicker"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, s = [
        $h2kUE.observable
    ], i = [
        $h2kUE.computed
    ], o = [
        $h2kUE.computed
    ], l = [
        (0, $524de0d5a72e1bc6$exports.reaction)(function(e) {
            return e.value;
        })
    ], $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__esDecorate(c, null, s, {
        kind: "accessor",
        name: "file",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "file" in e;
            },
            get: function get(e) {
                return e.file;
            },
            set: function set(e, t) {
                e.file = t;
            }
        },
        metadata: t
    }, d, b), $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__esDecorate(c, null, i, {
        kind: "getter",
        name: "fileType",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "fileType" in e;
            },
            get: function get(e) {
                return e.fileType;
            }
        },
        metadata: t
    }, null, f), $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__esDecorate(c, null, o, {
        kind: "getter",
        name: "filePath",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "filePath" in e;
            },
            get: function get(e) {
                return e.filePath;
            }
        },
        metadata: t
    }, null, f), $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__esDecorate(c, null, l, {
        kind: "method",
        name: "restoreFile",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "restoreFile" in e;
            },
            get: function get(e) {
                return e.restoreFile;
            }
        },
        metadata: t
    }, null, f), $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__esDecorate(null, n = {
        value: c
    }, u, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, p), c = n.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "FilePicker"
    }), $e38fa592e8b33da5$var$$f2af1554fbcf9c96$var$__runInitializers(c, p), c;
}(), $e38fa592e8b33da5$var$$a21a50f24f1cbd28$exports = {};
$e38fa592e8b33da5$var$$parcel$export($e38fa592e8b33da5$var$$a21a50f24f1cbd28$exports, "FileModel", function() {
    return $e38fa592e8b33da5$var$$a21a50f24f1cbd28$export$424c8de2e117ab22;
}), $e38fa592e8b33da5$var$$parcel$export($e38fa592e8b33da5$var$$a21a50f24f1cbd28$exports, "FileUploader", function() {
    return $e38fa592e8b33da5$var$$a21a50f24f1cbd28$export$1a5cb5295a7d2749;
});
var $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__esDecorate = function $a21a50f24f1cbd28$var$__esDecorate(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__runInitializers = function $a21a50f24f1cbd28$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__awaiter = function $a21a50f24f1cbd28$var$__awaiter(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var _$t;
            e.done ? n(e.value) : ((_$t = e.value) instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__classPrivateFieldGet = function $a21a50f24f1cbd28$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__classPrivateFieldSet = function $a21a50f24f1cbd28$var$__classPrivateFieldSet(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__setFunctionName = function $a21a50f24f1cbd28$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__rest = function $a21a50f24f1cbd28$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $e38fa592e8b33da5$var$$a21a50f24f1cbd28$export$424c8de2e117ab22 = function() {
    var e, t, r, a, n = $6515720bcd6dbf2b$export$d12e20a4eec10acf, c = [], s = [];
    return r = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), a.set(_$e, $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__runInitializers(_$e, c, [])), $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__runInitializers(_$e, s), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "files",
                get: function get() {
                    return $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function set(e) {
                    $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "clear",
                value: function value() {
                    (0, $57751a2649dd1683$export$71511d61b312f219)((0, $ae6313b3cbf000af$export$71511d61b312f219)(t.prototype), "clear", this).call(this), this.files = [];
                }
            },
            {
                key: "upload",
                value: function value(e) {
                    return $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__awaiter(this, void 0, void 0, function() {
                        var _$t;
                        return (0, $ea05ccc2484f951f$export$71511d61b312f219)(this, function(r) {
                            return e instanceof Blob && (e = URL.createObjectURL(e)), (_$t = this.files).includes(e) || (this.files = (0, $2b3349705fb2cb54$export$71511d61b312f219)(_$t).concat([
                                e
                            ])), [
                                2,
                                e
                            ];
                        });
                    });
                }
            },
            {
                key: "delete",
                value: function value(e) {
                    return $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__awaiter(this, void 0, void 0, function() {
                        var _$t, r;
                        return (0, $ea05ccc2484f951f$export$71511d61b312f219)(this, function(a) {
                            return r = (_$t = this.files).indexOf(e), this.files = (0, $2b3349705fb2cb54$export$71511d61b312f219)(_$t.slice(0, r)).concat((0, $2b3349705fb2cb54$export$71511d61b312f219)(_$t.slice(r + 1))), [
                                2
                            ];
                        });
                    });
                }
            },
            {
                key: "move",
                value: function value(e, t) {
                    var r = this.files, a = r[e], n = r[t], c = Math.min(e, t), s = Math.max(e, t), i = r.slice(0, c), o = r.slice(c + 1, s), l = r.slice(s + 1);
                    this.files = e < t ? (0, $2b3349705fb2cb54$export$71511d61b312f219)(i).concat((0, $2b3349705fb2cb54$export$71511d61b312f219)(o), [
                        n,
                        a
                    ], (0, $2b3349705fb2cb54$export$71511d61b312f219)(l)) : (0, $2b3349705fb2cb54$export$71511d61b312f219)(i).concat([
                        a,
                        n
                    ], (0, $2b3349705fb2cb54$export$71511d61b312f219)(o), (0, $2b3349705fb2cb54$export$71511d61b312f219)(l));
                }
            }
        ]), t;
    }(n), a = new WeakMap, t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = n[Symbol.metadata]) ? e : null) : void 0, $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__esDecorate(r, null, [
        $h2kUE.observable
    ], {
        kind: "accessor",
        name: "files",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "files" in e;
            },
            get: function get(e) {
                return e.files;
            },
            set: function set(e, t) {
                e.files = t;
            }
        },
        metadata: t
    }, c, s), t && Object.defineProperty(r, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), r;
}(), $e38fa592e8b33da5$var$$a21a50f24f1cbd28$export$1a5cb5295a7d2749 = function() {
    var e, t, r, a, n, c, s, i = [
        $e04d4b638436dc5e$export$b6ae1bc530f4c149
    ], o = [], l = $524de0d5a72e1bc6$exports.FormComponent, u = [], p = [], $ = [];
    return n = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), r.set(_$e, ($e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__runInitializers(_$e, u), $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__runInitializers(_$e, p, void 0))), Object.defineProperty(_$e, "handleDrop", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__runInitializers(_$e, $), function(t) {
                    return function(r) {
                        r.preventDefault();
                        var a = _$e.props, n = _$e.pickIndex;
                        null != n && (a.store.move(n, t), _$e.innerValue = a.store.files);
                    };
                })
            }), Object.defineProperty(_$e, "handleChange", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value() {
                    var _$t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
                    return function(r) {
                        return $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__awaiter(_$e, void 0, void 0, function() {
                            var _$e;
                            return (0, $ea05ccc2484f951f$export$71511d61b312f219)(this, function(a) {
                                switch(a.label){
                                    case 0:
                                        if (_$e = this.props.store, !_$t) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            _$e.delete(_$t)
                                        ];
                                    case 1:
                                        a.sent(), a.label = 2;
                                    case 2:
                                        if (!r) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            _$e.upload(r)
                                        ];
                                    case 3:
                                        a.sent(), a.label = 4;
                                    case 4:
                                        return this.innerValue = _$e.files, [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                }
            }), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "pickIndex",
                get: function get() {
                    return $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    (0, $57751a2649dd1683$export$71511d61b312f219)((0, $ae6313b3cbf000af$export$71511d61b312f219)(t.prototype), "componentDidMount", this).call(this), this.props.store.files = this.value || [];
                }
            },
            {
                key: "restoreFile",
                value: function value(e) {
                    this.props.store.files = e;
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this, _$t = this.props, r = _$t.className, a = _$t.style, n = _$t.multiple, c = (_$t.store, _$t.value, _$t.defaultValue, _$t.onChange, $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__rest(_$t, [
                        "className",
                        "style",
                        "multiple",
                        "store",
                        "value",
                        "defaultValue",
                        "onChange"
                    ])), s = this.value;
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("ol", {
                        className: "list-inline d-flex ".concat(void 0 === r ? "m-0" : r),
                        style: a,
                        onDragOver: function onDragOver(e) {
                            return e.preventDefault();
                        },
                        children: [
                            null == s ? void 0 : s.map(function(t, r) {
                                return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("li", {
                                    className: "list-inline-item",
                                    draggable: !0,
                                    onDragStart: function onDragStart() {
                                        return _$e.pickIndex = r;
                                    },
                                    onDrop: _$e.handleDrop(r),
                                    children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($e38fa592e8b33da5$var$$f2af1554fbcf9c96$export$54dc470bcc5c41d1, Object.assign({}, c, {
                                        value: t,
                                        onChange: _$e.handleChange(t)
                                    }))
                                }, t);
                            }),
                            (n || !(null == s ? void 0 : s[0])) && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("li", {
                                className: "list-inline-item",
                                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($e38fa592e8b33da5$var$$f2af1554fbcf9c96$export$54dc470bcc5c41d1, Object.assign({}, c, {
                                    name: void 0,
                                    value: "",
                                    required: !(null == s ? void 0 : s[0]) && c.required,
                                    onChange: this.handleChange()
                                }))
                            })
                        ]
                    });
                }
            }
        ]), t;
    }(l), r = new WeakMap, $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__setFunctionName(n, "FileUploader"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = l[Symbol.metadata]) ? e : null) : void 0, c = [
        $h2kUE.observable
    ], s = [
        (0, $524de0d5a72e1bc6$exports.reaction)(function(e) {
            return e.value;
        })
    ], $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__esDecorate(n, null, c, {
        kind: "accessor",
        name: "pickIndex",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "pickIndex" in e;
            },
            get: function get(e) {
                return e.pickIndex;
            },
            set: function set(e, t) {
                e.pickIndex = t;
            }
        },
        metadata: t
    }, p, $), $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__esDecorate(n, null, s, {
        kind: "method",
        name: "restoreFile",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "restoreFile" in e;
            },
            get: function get(e) {
                return e.restoreFile;
            }
        },
        metadata: t
    }, null, u), $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__esDecorate(null, a = {
        value: n
    }, i, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, o), n = a.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "FileUploader"
    }), $e38fa592e8b33da5$var$$a21a50f24f1cbd28$var$__runInitializers(n, o), n;
}(), $e38fa592e8b33da5$var$$4e6504f15de995a8$exports = {};
$e38fa592e8b33da5$var$$parcel$export($e38fa592e8b33da5$var$$4e6504f15de995a8$exports, "FormField", function() {
    return $e38fa592e8b33da5$var$$4e6504f15de995a8$export$56e87bf42978147a;
});
var $e38fa592e8b33da5$var$$4e6504f15de995a8$var$__rest = function $4e6504f15de995a8$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $e38fa592e8b33da5$var$$4e6504f15de995a8$export$56e87bf42978147a = function $4e6504f15de995a8$export$56e87bf42978147a(e) {
    var t = e.className, r = e.style, a = e.label, n = e.placeholder, c = e.id, s = e.name, i = e.options, o = e.multiple, l = e.rows, u = e.onBlur, p = $e38fa592e8b33da5$var$$4e6504f15de995a8$var$__rest(e, [
        "className",
        "style",
        "label",
        "placeholder",
        "id",
        "name",
        "options",
        "multiple",
        "rows",
        "onBlur"
    ]);
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($fd86a401760e34c7$export$2e2bcd8739ae039.FloatingLabel, {
        className: t,
        style: r,
        label: a,
        controlId: s || c,
        onBlur: function onBlur(e) {
            e.target.checkValidity() ? (e.target.classList.remove("is-invalid"), e.currentTarget.classList.remove("is-invalid")) : (e.target.classList.add("is-invalid"), e.currentTarget.classList.add("is-invalid")), null == u || u(e);
        },
        children: i ? (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($fd86a401760e34c7$export$2e2bcd8739ae039.Select, Object.assign({
            className: o ? "h-auto" : "",
            name: s,
            multiple: o,
            htmlSize: l
        }, p, {
            children: i.map(function(e) {
                var t = e.value, r = e.text, a = e.label, n = e.disabled;
                return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("option", {
                    value: t,
                    label: a,
                    disabled: n,
                    children: r || t
                }, t);
            })
        })) : (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($fd86a401760e34c7$export$2e2bcd8739ae039.Control, Object.assign({
            className: l > 1 ? "h-auto" : "",
            name: s,
            multiple: o,
            rows: l
        }, p, {
            placeholder: n || ("string" == typeof a ? a : s || c)
        }))
    });
};
$e38fa592e8b33da5$var$$4e6504f15de995a8$export$56e87bf42978147a.displayName = "FormField";
var $e38fa592e8b33da5$var$$92bd5b9c2e8cd28e$exports = {};
$e38fa592e8b33da5$var$$parcel$export($e38fa592e8b33da5$var$$92bd5b9c2e8cd28e$exports, "RangeInput", function() {
    return $e38fa592e8b33da5$var$$92bd5b9c2e8cd28e$export$f5603a09670563b9;
});
var $e38fa592e8b33da5$var$$92bd5b9c2e8cd28e$var$__esDecorate = function $92bd5b9c2e8cd28e$var$__esDecorate(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $e38fa592e8b33da5$var$$92bd5b9c2e8cd28e$var$__runInitializers = function $92bd5b9c2e8cd28e$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $e38fa592e8b33da5$var$$92bd5b9c2e8cd28e$var$__setFunctionName = function $92bd5b9c2e8cd28e$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $e38fa592e8b33da5$var$$92bd5b9c2e8cd28e$var$__rest = function $92bd5b9c2e8cd28e$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $e38fa592e8b33da5$var$$92bd5b9c2e8cd28e$export$f5603a09670563b9 = function() {
    var e, t, r, a, n = [
        $e04d4b638436dc5e$export$b6ae1bc530f4c149
    ], c = [], s = $524de0d5a72e1bc6$exports.FormComponent;
    return $e38fa592e8b33da5$var$$92bd5b9c2e8cd28e$var$__setFunctionName(a = function(e) {
        "use strict";
        function t() {
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments);
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "renderItem",
                value: function value(e) {
                    var _$t = this.value, r = this.observedProps, a = r.icon, n = r.step, c = void 0 === n ? 1 : n, s = Math.max(Math.min((void 0 === _$t ? 0 : _$t) - c * e, +c), 0);
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("li", {
                        className: "text-center",
                        children: "function" == typeof a ? a(s) : a
                    }, e);
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this, _$t = this.observedProps, r = _$t.className, a = _$t.icon, n = _$t.min, c = _$t.max, s = void 0 === c ? a ? 5 : 100 : c, i = (_$t.onChange, $e38fa592e8b33da5$var$$92bd5b9c2e8cd28e$var$__rest(_$t, [
                        "className",
                        "icon",
                        "min",
                        "max",
                        "onChange"
                    ])), o = this.value, l = void 0 === o ? n || 0 : o;
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                        className: void 0 === r ? "d-inline-block position-relative" : r,
                        title: l + "",
                        children: [
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("input", Object.assign({
                                min: n,
                                max: s,
                                value: l
                            }, i, {
                                className: a ? "opacity-0" : "",
                                style: {
                                    margin: "0 -0.5rem",
                                    cursor: "pointer"
                                },
                                type: "range",
                                onChange: function onChange(t) {
                                    return _$e.innerValue = t.currentTarget.value;
                                }
                            })),
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("ol", {
                                className: "list-unstyled user-select-none position-absolute start-0 top-0 w-100 h-100 pe-none d-flex justify-content-around",
                                children: Array.from({
                                    length: +s
                                }, function(t, r) {
                                    return _$e.renderItem(r);
                                })
                            })
                        ]
                    });
                }
            }
        ]), t;
    }(s), "RangeInput"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = s[Symbol.metadata]) ? e : null) : void 0, $e38fa592e8b33da5$var$$92bd5b9c2e8cd28e$var$__esDecorate(null, r = {
        value: a
    }, n, {
        kind: "class",
        name: a.name,
        metadata: t
    }, null, c), a = r.value, t && Object.defineProperty(a, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(a, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "RangeInput"
    }), $e38fa592e8b33da5$var$$92bd5b9c2e8cd28e$var$__runInitializers(a, c), a;
}(), $e38fa592e8b33da5$var$$fa84453248a3f065$exports = {};
$e38fa592e8b33da5$var$$parcel$export($e38fa592e8b33da5$var$$fa84453248a3f065$exports, "TextInputTypes", function() {
    return $e38fa592e8b33da5$var$$fa84453248a3f065$export$82cd8db40d0f609c;
}), $e38fa592e8b33da5$var$$parcel$export($e38fa592e8b33da5$var$$fa84453248a3f065$exports, "BadgeInput", function() {
    return $e38fa592e8b33da5$var$$fa84453248a3f065$export$76834b0602c89bd;
});
var $e38fa592e8b33da5$var$$fa84453248a3f065$var$__esDecorate = function $fa84453248a3f065$var$__esDecorate(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $e38fa592e8b33da5$var$$fa84453248a3f065$var$__runInitializers = function $fa84453248a3f065$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $e38fa592e8b33da5$var$$fa84453248a3f065$var$__setFunctionName = function $fa84453248a3f065$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $e38fa592e8b33da5$var$$fa84453248a3f065$export$82cd8db40d0f609c = [
    "text",
    "number",
    "tel",
    "email",
    "url"
], $e38fa592e8b33da5$var$$fa84453248a3f065$export$76834b0602c89bd = function() {
    var e, t, r, a, n = [
        $e04d4b638436dc5e$export$b6ae1bc530f4c149
    ], c = [], s = $524de0d5a72e1bc6$exports.FormComponent;
    return $e38fa592e8b33da5$var$$fa84453248a3f065$var$__setFunctionName(a = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(_$e, "handleInput", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    var r = t.currentTarget, a = r.value, n = _$e.innerValue || [];
                    switch(t.key){
                        case "Enter":
                            t.preventDefault(), r.value = "", a && (_$e.innerValue = (0, $2b3349705fb2cb54$export$71511d61b312f219)(n).concat([
                                a
                            ]));
                            break;
                        case "Backspace":
                            a || (_$e.innerValue = n.slice(0, -1));
                    }
                }
            }), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "delete",
                value: function value(e) {
                    var _$t = this.innerValue;
                    this.innerValue = (0, $2b3349705fb2cb54$export$71511d61b312f219)(_$t.slice(0, e)).concat((0, $2b3349705fb2cb54$export$71511d61b312f219)(_$t.slice(e + 1)));
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this, _$t = this.value, r = this.props, a = r.className, n = r.style, c = r.type, s = r.name, i = r.required, o = r.placeholder;
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                        className: "form-control p-2 d-flex flex-wrap gap-2 ".concat(void 0 === a ? "" : a),
                        style: n,
                        children: [
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($e38fa592e8b33da5$var$$f600741b98acd6fe$export$ef1c4106ceccca63, {
                                list: (_$t || []).map(function(e) {
                                    return {
                                        text: e
                                    };
                                }),
                                onDelete: function onDelete(t, r) {
                                    return (0, $45b8819b503a7835$export$71511d61b312f219)(t), _$e.delete(r);
                                }
                            }),
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("input", {
                                className: "border-0 flex-fill",
                                style: {
                                    outline: "none"
                                },
                                type: c,
                                required: (0, $lhPyT.isEmpty)(_$t) ? i : void 0,
                                placeholder: o,
                                onKeyDown: this.handleInput
                            }),
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("input", {
                                type: "hidden",
                                name: s,
                                value: JSON.stringify(_$t)
                            })
                        ]
                    });
                }
            }
        ], [
            {
                key: "match",
                value: function value(e) {
                    return $e38fa592e8b33da5$var$$fa84453248a3f065$export$82cd8db40d0f609c.includes(e);
                }
            }
        ]), t;
    }(s), "BadgeInput"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = s[Symbol.metadata]) ? e : null) : void 0, $e38fa592e8b33da5$var$$fa84453248a3f065$var$__esDecorate(null, r = {
        value: a
    }, n, {
        kind: "class",
        name: a.name,
        metadata: t
    }, null, c), a = r.value, t && Object.defineProperty(a, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(a, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "BadgeInput"
    }), $e38fa592e8b33da5$var$$fa84453248a3f065$var$__runInitializers(a, c), a;
}(), $e38fa592e8b33da5$var$$36ed2012ed0bbec3$exports = {};
$e38fa592e8b33da5$var$$parcel$export($e38fa592e8b33da5$var$$36ed2012ed0bbec3$exports, "ArrayField", function() {
    return $e38fa592e8b33da5$var$$36ed2012ed0bbec3$export$42efeba470be9198;
});
var $e38fa592e8b33da5$var$$36ed2012ed0bbec3$var$__esDecorate = function $36ed2012ed0bbec3$var$__esDecorate(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $e38fa592e8b33da5$var$$36ed2012ed0bbec3$var$__runInitializers = function $36ed2012ed0bbec3$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $e38fa592e8b33da5$var$$36ed2012ed0bbec3$var$__setFunctionName = function $36ed2012ed0bbec3$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $e38fa592e8b33da5$var$$36ed2012ed0bbec3$export$42efeba470be9198 = function() {
    var e, t, r, a, n = [
        $e04d4b638436dc5e$export$b6ae1bc530f4c149
    ], c = [], s = $524de0d5a72e1bc6$exports.FormComponent;
    return $e38fa592e8b33da5$var$$36ed2012ed0bbec3$var$__setFunctionName(a = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(_$e, "add", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value() {
                    return _$e.innerValue = (0, $2b3349705fb2cb54$export$71511d61b312f219)(_$e.innerValue || []).concat([
                        {}
                    ]);
                }
            }), Object.defineProperty(_$e, "remove", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    var r;
                    return _$e.innerValue = null == (r = _$e.innerValue) ? void 0 : r.filter(function(e, r) {
                        return r !== t;
                    });
                }
            }), Object.defineProperty(_$e, "handleChange", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    return function(r) {
                        var a, n, c = r.currentTarget, s = (0, $lhPyT.formToJSON)(c), i = _$e.innerValue, o = (0, $2b3349705fb2cb54$export$71511d61b312f219)(i.slice(0, t)).concat([
                            s
                        ], (0, $2b3349705fb2cb54$export$71511d61b312f219)(i.slice(t + 1))).map(function(e) {
                            return (0, $h2kUE.toJS)(e);
                        });
                        null == (n = (a = _$e.props).onChange) || n.call(a, o);
                    };
                }
            }), Object.defineProperty(_$e, "handleUpdate", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    return function(r) {
                        var a = r.currentTarget;
                        return _$e.innerValue[t] = (0, $lhPyT.formToJSON)(a);
                    };
                }
            }), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "componentDidMount",
                value: function value() {
                    (0, $57751a2649dd1683$export$71511d61b312f219)((0, $ae6313b3cbf000af$export$71511d61b312f219)(t.prototype), "componentDidMount", this).call(this), (0, $lhPyT.isEmpty)(this.value) && this.add();
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e, _$t = this, r = this.props, a = r.className, n = void 0 === a ? "" : a, c = r.style, s = r.name, i = r.renderItem;
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($tLNoZ.Fragment, {
                        children: null == (_$e = this.value) ? void 0 : _$e.map(function(e, r, a) {
                            var o = a.length;
                            return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("fieldset", {
                                className: "d-flex align-items-center my-2 gap-2 ".concat(n),
                                style: c,
                                name: s,
                                onChange: _$t.handleChange(r),
                                onBlur: _$t.handleUpdate(r),
                                children: [
                                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                                        className: "flex-fill",
                                        children: i(e, r)
                                    }),
                                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($3dfaeff39cd5f1c6$export$2e2bcd8739ae039, {
                                        children: [
                                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($3a399bf6b2fd4261$export$2e2bcd8739ae039, {
                                                type: "button",
                                                size: "sm",
                                                variant: "warning",
                                                onClick: _$t.add,
                                                children: "+"
                                            }),
                                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($3a399bf6b2fd4261$export$2e2bcd8739ae039, {
                                                type: "button",
                                                size: "sm",
                                                variant: "danger",
                                                disabled: o < 2,
                                                onClick: function onClick() {
                                                    return _$t.remove(r);
                                                },
                                                children: "-"
                                            })
                                        ]
                                    })
                                ]
                            }, JSON.stringify(e));
                        })
                    });
                }
            }
        ]), t;
    }(s), "ArrayField"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = s[Symbol.metadata]) ? e : null) : void 0, $e38fa592e8b33da5$var$$36ed2012ed0bbec3$var$__esDecorate(null, r = {
        value: a
    }, n, {
        kind: "class",
        name: a.name,
        metadata: t
    }, null, c), a = r.value, t && Object.defineProperty(a, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(a, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "ArrayField"
    }), $e38fa592e8b33da5$var$$36ed2012ed0bbec3$var$__runInitializers(a, c), a;
}(), $e38fa592e8b33da5$var$$cd7ba08b282791a9$exports = {};
$e38fa592e8b33da5$var$$parcel$export($e38fa592e8b33da5$var$$cd7ba08b282791a9$exports, "RestForm", function() {
    return $e38fa592e8b33da5$var$$cd7ba08b282791a9$export$341e3470805a945e;
});
var $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__runInitializers = function $cd7ba08b282791a9$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__esDecorate = function $cd7ba08b282791a9$var$__esDecorate(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__awaiter = function $cd7ba08b282791a9$var$__awaiter(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var _$t;
            e.done ? n(e.value) : ((_$t = e.value) instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__setFunctionName = function $cd7ba08b282791a9$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__classPrivateFieldGet = function $cd7ba08b282791a9$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__classPrivateFieldSet = function $cd7ba08b282791a9$var$__classPrivateFieldSet(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__rest = function $cd7ba08b282791a9$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $e38fa592e8b33da5$var$$cd7ba08b282791a9$export$341e3470805a945e = function() {
    var e, t, r, a, n, c, s, i, o, l, u = [
        $e04d4b638436dc5e$export$b6ae1bc530f4c149
    ], p = [], $ = $524de0d5a72e1bc6$exports.ObservedComponent, f = [], d = [], b = [], m = n = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), r.set(_$e, ($e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__runInitializers(_$e, f), $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__runInitializers(_$e, d, !1))), Object.defineProperty(_$e, "handleSubmit", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__runInitializers(_$e, b), function(t) {
                    return $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__awaiter(_$e, void 0, void 0, function() {
                        var _$e, r, a, n, c, s, i;
                        return (0, $ea05ccc2484f951f$export$71511d61b312f219)(this, function(o) {
                            switch(o.label){
                                case 0:
                                    if (t.preventDefault(), t.stopPropagation(), r = (_$e = t.currentTarget).checkValidity(), this.validated = !0, !r) return [
                                        3,
                                        2
                                    ];
                                    return n = (a = this.props).id, c = a.store, s = a.onSubmit, i = (0, $lhPyT.formToJSON)(_$e), [
                                        4,
                                        null == c ? void 0 : c.updateOne(i, n)
                                    ];
                                case 1:
                                    i = o.sent(), null == s || s(i), null == c || c.clearCurrent(), o.label = 2;
                                case 2:
                                    return this.validated = !1, [
                                        2
                                    ];
                            }
                        });
                    });
                })
            }), Object.defineProperty(_$e, "handleReset", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    var r = t.currentTarget, a = _$e.props, n = a.onReset, c = a.store;
                    null == n || n((0, $lhPyT.formToJSON)(r)), null == c || c.clearCurrent();
                }
            }), Object.defineProperty(_$e, "renderFile", (0, $b535bc2d74d7beda$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", function(e) {
                var _$t = e.key, r = e.type, a = e.required, n = e.multiple, c = e.accept, s = e.uploader, i = $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__rest(e, [
                    "key",
                    "type",
                    "required",
                    "multiple",
                    "accept",
                    "uploader"
                ]);
                return function(e) {
                    var o = e[_$t], l = (Array.isArray(o) ? o : [
                        o
                    ]).filter(Boolean);
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(m.FieldBox, Object.assign({
                        name: _$t
                    }, i, {
                        children: s ? (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($e38fa592e8b33da5$var$$a21a50f24f1cbd28$export$1a5cb5295a7d2749, {
                            store: s,
                            name: null == _$t ? void 0 : _$t.toString(),
                            required: a,
                            multiple: n,
                            accept: c,
                            defaultValue: l
                        }) : l.map(function(e) {
                            return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($e38fa592e8b33da5$var$$8663609ea235ec39$export$a127194569a41afb, {
                                type: r,
                                path: e
                            });
                        })
                    }));
                };
            })), Object.defineProperty(_$e, "renderCheckGroup", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    var r = t.key, a = t.type, n = t.options, c = $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__rest(t, [
                        "key",
                        "type",
                        "options"
                    ]);
                    return function(t) {
                        return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(m.FieldBox, Object.assign({
                            name: r
                        }, c, {
                            children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                                children: _$e.fieldReady && n.map(function(e) {
                                    var n, s = e.value, i = e.label, o = void 0 === i ? s : i;
                                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($fd86a401760e34c7$export$2e2bcd8739ae039.Check, Object.assign({
                                        id: [
                                            r,
                                            s
                                        ] + "",
                                        label: o,
                                        inline: !0
                                    }, c, {
                                        type: a,
                                        name: r.toString(),
                                        value: s,
                                        defaultChecked: null == (n = t[r]) ? void 0 : n.includes(s)
                                    }), s);
                                })
                            })
                        }));
                    };
                }
            }), Object.defineProperty(_$e, "renderMultipleInput", (0, $b535bc2d74d7beda$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", function(t) {
                var r = t.key, a = (t.type, $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__rest(t, [
                    "key",
                    "type"
                ]));
                return function(t) {
                    var n = t[r];
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(m.FieldBox, Object.assign({
                        name: r
                    }, a, {
                        children: _$e.fieldReady && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($e38fa592e8b33da5$var$$fa84453248a3f065$export$76834b0602c89bd, Object.assign({}, a, {
                            name: null == r ? void 0 : r.toString(),
                            defaultValue: n
                        }))
                    }));
                };
            })), Object.defineProperty(_$e, "renderHTMLEditor", (0, $b535bc2d74d7beda$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", function(t) {
                var r = t.key, a = (t.contentEditable, t.tools), n = $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__rest(t, [
                    "key",
                    "contentEditable",
                    "tools"
                ]);
                return function(t) {
                    var c = t[r];
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)(m.FieldBox, Object.assign({
                        name: r
                    }, n, {
                        children: _$e.fieldReady && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($d1b3805234fdf37f$exports.Editor, {
                            tools: a,
                            name: null == r ? void 0 : r.toString(),
                            defaultValue: c
                        })
                    }));
                };
            })), Object.defineProperty(_$e, "renderField", (0, $b535bc2d74d7beda$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", function(t, r) {
                var a = t.key, n = t.type, c = t.step, s = t.renderLabel, i = (t.renderInput, t.validMessage), o = t.invalidMessage, l = $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__rest(t, [
                    "key",
                    "type",
                    "step",
                    "renderLabel",
                    "renderInput",
                    "validMessage",
                    "invalidMessage"
                ]);
                void 0 === r && (r = {});
                var u = "function" == typeof s ? null == s ? void 0 : s(a) : s || a;
                return function(t) {
                    var s = t[a];
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($d8869262459b9d45$export$2e2bcd8739ae039, {
                        hasValidation: _$e.customValidation,
                        children: [
                            _$e.fieldReady && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($e38fa592e8b33da5$var$$4e6504f15de995a8$export$56e87bf42978147a, Object.assign({}, r, l, {
                                type: n,
                                step: c,
                                label: u,
                                size: _$e.observedProps.size,
                                name: a.toString(),
                                defaultValue: m.dateValueOf({
                                    type: n,
                                    step: c
                                }, s)
                            })),
                            i && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($fd86a401760e34c7$export$2e2bcd8739ae039.Control.Feedback, {
                                tooltip: !0,
                                type: "valid",
                                children: i
                            }),
                            o && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($fd86a401760e34c7$export$2e2bcd8739ae039.Control.Feedback, {
                                tooltip: !0,
                                type: "invalid",
                                children: o
                            })
                        ]
                    });
                };
            })), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "validated",
                get: function get() {
                    return $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    var _$e = this.props, _$t = _$e.id, r = _$e.store;
                    _$t && (null == r || r.getOne(_$t));
                }
            },
            {
                key: "fields",
                get: function get() {
                    var _$e = this;
                    return this.observedProps.fields.map(function(t) {
                        var r = t.renderInput, a = $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__rest(t, [
                            "renderInput"
                        ]);
                        return Object.assign(Object.assign({}, a), {
                            renderInput: null != r ? r : "file" === a.type ? _$e.renderFile(a) : ("radio" === a.type || "checkbox" === a.type) && a.options ? _$e.renderCheckGroup(a) : a.contentEditable ? _$e.renderHTMLEditor(a) : !a.options && a.multiple ? _$e.renderMultipleInput(a) : a.key && _$e.renderField(a, a.rows && !a.options ? {
                                as: "textarea"
                            } : {})
                        });
                    });
                }
            },
            {
                key: "readOnly",
                get: function get() {
                    return this.fields.every(function(e) {
                        var _$t = e.readOnly, r = e.disabled;
                        return _$t || r;
                    });
                }
            },
            {
                key: "customValidation",
                get: function get() {
                    return this.fields.some(function(e) {
                        var _$t = e.validMessage, r = e.invalidMessage;
                        return _$t || r;
                    });
                }
            },
            {
                key: "fieldReady",
                get: function get() {
                    var _$e = this.observedProps, _$t = _$e.id, r = _$e.store;
                    return !_$t || (null == r ? void 0 : r.downloading) < 1;
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this.fields, _$t = this.readOnly, r = this.customValidation, a = this.validated, n = this.props, c = (n.id, n.className), s = n.size, i = n.store, o = n.translator, l = $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__rest(n, [
                        "id",
                        "className",
                        "size",
                        "store",
                        "translator"
                    ]), u = i || {}, p = u.downloading, $ = u.uploading, f = u.currentOne, d = void 0 === f ? {} : f, b = o.t, m = p > 0 || $ > 0;
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($fd86a401760e34c7$export$2e2bcd8739ae039, Object.assign({}, l, {
                        className: void 0 === c ? "d-flex flex-column gap-3" : c,
                        validated: a,
                        noValidate: r,
                        onSubmit: this.handleSubmit,
                        onReset: this.handleReset,
                        children: [
                            _$e.map(function(e) {
                                var _$t, r = e.renderInput, a = $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__rest(e, [
                                    "renderInput"
                                ]);
                                return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($tLNoZ.Fragment, {
                                    children: null == r ? void 0 : r(d, a)
                                }, null == (_$t = a.key) ? void 0 : _$t.toString());
                            }),
                            !_$t && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("footer", {
                                className: "d-flex gap-3",
                                children: [
                                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($3a399bf6b2fd4261$export$2e2bcd8739ae039, {
                                        className: "flex-fill",
                                        size: s,
                                        type: "submit",
                                        disabled: m,
                                        children: b("submit")
                                    }),
                                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($3a399bf6b2fd4261$export$2e2bcd8739ae039, {
                                        className: "flex-fill",
                                        size: s,
                                        type: "reset",
                                        variant: "danger",
                                        disabled: m,
                                        children: b("cancel")
                                    })
                                ]
                            })
                        ]
                    }));
                }
            }
        ]), t;
    }($);
    return r = new WeakMap, $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__setFunctionName(n, "RestForm"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, c = [
        $h2kUE.observable
    ], s = [
        $h2kUE.computed
    ], i = [
        $h2kUE.computed
    ], o = [
        $h2kUE.computed
    ], l = [
        $h2kUE.computed
    ], $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__esDecorate(n, null, c, {
        kind: "accessor",
        name: "validated",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "validated" in e;
            },
            get: function get(e) {
                return e.validated;
            },
            set: function set(e, t) {
                e.validated = t;
            }
        },
        metadata: t
    }, d, b), $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__esDecorate(n, null, s, {
        kind: "getter",
        name: "fields",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "fields" in e;
            },
            get: function get(e) {
                return e.fields;
            }
        },
        metadata: t
    }, null, f), $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__esDecorate(n, null, i, {
        kind: "getter",
        name: "readOnly",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "readOnly" in e;
            },
            get: function get(e) {
                return e.readOnly;
            }
        },
        metadata: t
    }, null, f), $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__esDecorate(n, null, o, {
        kind: "getter",
        name: "customValidation",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "customValidation" in e;
            },
            get: function get(e) {
                return e.customValidation;
            }
        },
        metadata: t
    }, null, f), $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__esDecorate(n, null, l, {
        kind: "getter",
        name: "fieldReady",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "fieldReady" in e;
            },
            get: function get(e) {
                return e.fieldReady;
            }
        },
        metadata: t
    }, null, f), $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__esDecorate(null, a = {
        value: n
    }, u, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, p), m = n = a.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "RestForm"
    }), Object.defineProperty(n, "dateValueOf", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function value(e, t) {
            var r = e.type, a = e.step;
            return (0, $lhPyT.isEmpty)(t) ? t : "month" === r ? (0, $lhPyT.formatDate)(t, "YYYY-MM") : "date" === r ? (0, $lhPyT.formatDate)(t, "YYYY-MM-DD") : "datetime-local" === r ? (0, $lhPyT.formatDate)(t, "YYYY-MM-DDTHH:mm".concat(60 > +(void 0 === a ? "60" : a) ? ":ss" : "")) : t;
        }
    }), Object.defineProperty(n, "FieldBox", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function value(e) {
            var t = e.name, r = e.renderLabel, a = e.validMessage, n = e.invalidMessage, c = e.children, s = $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__rest(e, [
                "name",
                "renderLabel",
                "validMessage",
                "invalidMessage",
                "children"
            ]);
            return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($fd86a401760e34c7$export$2e2bcd8739ae039.Group, Object.assign({}, s, {
                children: [
                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($fd86a401760e34c7$export$2e2bcd8739ae039.Label, {
                        children: "function" == typeof r ? r(t) : r || t
                    }),
                    c,
                    a && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($fd86a401760e34c7$export$2e2bcd8739ae039.Control.Feedback, {
                        tooltip: !0,
                        type: "valid",
                        children: a
                    }),
                    n && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($fd86a401760e34c7$export$2e2bcd8739ae039.Control.Feedback, {
                        tooltip: !0,
                        type: "invalid",
                        children: n
                    })
                ]
            }));
        }
    }), $e38fa592e8b33da5$var$$cd7ba08b282791a9$var$__runInitializers(n, p), m = n;
}(), $e38fa592e8b33da5$var$$bcc38e2aa906301f$exports = {};
$e38fa592e8b33da5$var$$parcel$export($e38fa592e8b33da5$var$$bcc38e2aa906301f$exports, "Pager", function() {
    return $e38fa592e8b33da5$var$$bcc38e2aa906301f$export$57625d62e5386b09;
});
var $e38fa592e8b33da5$var$$bcc38e2aa906301f$export$57625d62e5386b09 = function $bcc38e2aa906301f$export$57625d62e5386b09(e) {
    var t = e.pageSize, r = e.pageIndex, a = e.pageCount, n = e.onChange;
    function c() {
        var _$e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, r = {
            pageSize: t,
            pageIndex: _$e
        };
        return {
            href: "?".concat((0, $lhPyT.buildURLData)(Object.assign(Object.assign({}, (0, $lhPyT.parseURLData)()), r))),
            onClick: n && function(e) {
                e.preventDefault(), n(r);
            }
        };
    }
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("form", {
        className: "m-0 d-flex align-items-center gap-2",
        onSubmit: n && function(e) {
            return e.preventDefault(), e.stopPropagation();
        },
        children: [
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($fd86a401760e34c7$export$2e2bcd8739ae039.Control, {
                type: "number",
                name: "pageSize",
                defaultValue: t,
                min: 1,
                required: !0,
                onChange: function onChange(e) {
                    var t = e.currentTarget;
                    return t.reportValidity() && (null == n ? void 0 : n({
                        pageSize: +t.value,
                        pageIndex: r
                    }));
                }
            }),
            "x",
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($fd86a401760e34c7$export$2e2bcd8739ae039.Control, {
                type: "number",
                name: "pageIndex",
                defaultValue: r || 1,
                min: 1,
                max: a,
                required: !0,
                onChange: function onChange(e) {
                    var r = e.currentTarget;
                    return r.reportValidity() && (null == n ? void 0 : n({
                        pageSize: t,
                        pageIndex: +r.value
                    }));
                }
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($1cb765a5e073f955$export$2e2bcd8739ae039, {
                className: "m-0",
                children: [
                    r > 1 && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($1cb765a5e073f955$export$2e2bcd8739ae039.Item, Object.assign({}, c(1), {
                        children: "1"
                    })),
                    r > 3 && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($1cb765a5e073f955$export$2e2bcd8739ae039.Ellipsis, {}),
                    r > 2 && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($1cb765a5e073f955$export$2e2bcd8739ae039.Item, Object.assign({}, c(r - 1), {
                        children: r - 1
                    })),
                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($1cb765a5e073f955$export$2e2bcd8739ae039.Item, {
                        active: !0,
                        children: r
                    }),
                    a - r > 1 && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($1cb765a5e073f955$export$2e2bcd8739ae039.Item, Object.assign({}, c(r + 1), {
                        children: r + 1
                    })),
                    a - r > 2 && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($1cb765a5e073f955$export$2e2bcd8739ae039.Ellipsis, {}),
                    r < a && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($1cb765a5e073f955$export$2e2bcd8739ae039.Item, Object.assign({}, c(a), {
                        children: a
                    }))
                ]
            })
        ]
    });
};
$e38fa592e8b33da5$var$$bcc38e2aa906301f$export$57625d62e5386b09.displayName = "Pager";
var $e38fa592e8b33da5$var$$3800431d840f9bec$exports = {};
$e38fa592e8b33da5$var$$parcel$export($e38fa592e8b33da5$var$$3800431d840f9bec$exports, "RestTable", function() {
    return $e38fa592e8b33da5$var$$3800431d840f9bec$export$fd90441354a7d816;
});
var $e38fa592e8b33da5$var$$bfbc9f72f179e373$var$__rest = function $bfbc9f72f179e373$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $e38fa592e8b33da5$var$$bfbc9f72f179e373$export$28baae8ef86bbf36 = (0, $e04d4b638436dc5e$export$b6ae1bc530f4c149)(function(e) {
    var t = e.fields, r = e.store, a = e.translator, n = $e38fa592e8b33da5$var$$bfbc9f72f179e373$var$__rest(e, [
        "fields",
        "store",
        "translator"
    ]), c = r.indexKey, s = r.currentOne, i = !(0, $lhPyT.isEmpty)(s), o = s[c];
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($858037c357c14af3$export$2e2bcd8739ae039, {
        show: i,
        onHide: function onHide() {
            return r.clearCurrent();
        },
        children: [
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($858037c357c14af3$export$2e2bcd8739ae039.Header, {
                closeButton: !0,
                children: o
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($858037c357c14af3$export$2e2bcd8739ae039.Body, {
                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($e38fa592e8b33da5$var$$cd7ba08b282791a9$export$341e3470805a945e, Object.assign({
                    id: o,
                    fields: t,
                    store: r,
                    translator: a
                }, n))
            })
        ]
    });
});
$e38fa592e8b33da5$var$$aac96070b6d8b41d$export$5eeb11949c905cc1 = "SrGRNq_filterBar";
var $e38fa592e8b33da5$var$$3800431d840f9bec$var$__runInitializers = function $3800431d840f9bec$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $e38fa592e8b33da5$var$$3800431d840f9bec$var$__esDecorate = function $3800431d840f9bec$var$__esDecorate(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $e38fa592e8b33da5$var$$3800431d840f9bec$var$__awaiter = function $3800431d840f9bec$var$__awaiter(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var _$t;
            e.done ? n(e.value) : ((_$t = e.value) instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $e38fa592e8b33da5$var$$3800431d840f9bec$var$__setFunctionName = function $3800431d840f9bec$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $e38fa592e8b33da5$var$$3800431d840f9bec$var$__classPrivateFieldGet = function $3800431d840f9bec$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $e38fa592e8b33da5$var$$3800431d840f9bec$var$__classPrivateFieldSet = function $3800431d840f9bec$var$__classPrivateFieldSet(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $e38fa592e8b33da5$var$$3800431d840f9bec$var$__rest = function $3800431d840f9bec$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $e38fa592e8b33da5$var$$3800431d840f9bec$export$fd90441354a7d816 = function() {
    var e, t, r, a, n, c, s, i, o, l, u, p, $, f = [
        $e04d4b638436dc5e$export$b6ae1bc530f4c149
    ], d = [], b = $524de0d5a72e1bc6$exports.ObservedComponent, m = [], v = [], h = [];
    return n = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), r.set(_$e, ($e38fa592e8b33da5$var$$3800431d840f9bec$var$__runInitializers(_$e, m), $e38fa592e8b33da5$var$$3800431d840f9bec$var$__runInitializers(_$e, v, []))), Object.defineProperty(_$e, "toggleCheckAll", (0, $b535bc2d74d7beda$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", ($e38fa592e8b33da5$var$$3800431d840f9bec$var$__runInitializers(_$e, h), function() {
                var _$t = _$e.props, r = _$t.store, a = _$t.onCheck, n = r.indexKey, c = r.currentPage;
                _$e.checkedKeys = _$e.checkedKeys.length ? [] : c.map(function(e) {
                    return e[n];
                }), null == a || a(_$e.checkedKeys);
            }))), Object.defineProperty(_$e, "renderCustomBody", (0, $b535bc2d74d7beda$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", function(e) {
                var _$t = e.key, r = e.type, a = e.multiple, n = e.options, c = e.accept, s = e.rows;
                return "url" === r ? function(e) {
                    var r = e[_$t];
                    return r && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("a", {
                        target: "_blank",
                        href: r,
                        children: r
                    });
                } : "email" === r ? function(e) {
                    var r = e[_$t];
                    return r && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("a", {
                        href: "mailto:".concat(r),
                        children: r
                    });
                } : "tel" === r ? function(e) {
                    var r = e[_$t];
                    return r && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("a", {
                        href: "tel:".concat(r),
                        children: r
                    });
                } : "file" === r ? function(e) {
                    var r = e[_$t];
                    return (Array.isArray(r) ? r : [
                        r
                    ]).map(function(e) {
                        return e && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($e38fa592e8b33da5$var$$8663609ea235ec39$export$a127194569a41afb, {
                            type: c,
                            path: e
                        }, e);
                    });
                } : n || a ? function(e) {
                    var r = e[_$t];
                    return r && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($e38fa592e8b33da5$var$$f600741b98acd6fe$export$ef1c4106ceccca63, {
                        list: r.map(function(e) {
                            return {
                                text: e
                            };
                        })
                    });
                } : !n && s ? function(e) {
                    var r = e[_$t];
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("p", {
                        className: "m-0 text-truncate",
                        style: {
                            maxWidth: "20rem"
                        },
                        title: r,
                        children: r
                    });
                } : void 0;
            })), Object.defineProperty(_$e, "getList", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: (0, $hDKce.debounce)(function(t) {
                    var r = t.pageIndex, a = t.pageSize, n = _$e.props, c = n.store, s = n.filter;
                    c.downloading < 1 && c.getList(s, r, a);
                })
            }), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "componentDidMount",
                value: function value() {
                    var _$e = this.props, _$t = _$e.store, r = _$e.filter;
                    _$t.clear(), _$t.getList(r);
                }
            },
            {
                key: "fieldSize",
                get: function get() {
                    var _$e = this.observedProps.size;
                    return _$e ? "sm" === _$e ? "sm" : "lg" : void 0;
                }
            },
            {
                key: "checkedKeys",
                get: function get() {
                    return $e38fa592e8b33da5$var$$3800431d840f9bec$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $e38fa592e8b33da5$var$$3800431d840f9bec$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "toggleCheck",
                value: function value(e) {
                    var _$t, r, a = this.checkedKeys, n = a.indexOf(e);
                    this.checkedKeys = n < 0 ? (0, $2b3349705fb2cb54$export$71511d61b312f219)(a).concat([
                        e
                    ]) : (0, $2b3349705fb2cb54$export$71511d61b312f219)(a.slice(0, n)).concat((0, $2b3349705fb2cb54$export$71511d61b312f219)(a.slice(n + 1))), null == (r = (_$t = this.props).onCheck) || r.call(_$t, this.checkedKeys);
                }
            },
            (0, $b535bc2d74d7beda$export$71511d61b312f219)({
                key: "checkColumn"
            }, "get", function() {
                var _$e, _$t = this, r = this.checkedKeys, a = this.toggleCheckAll, n = this.observedProps.store, c = n.indexKey, s = n.currentPage;
                return _$e = {}, (0, $b535bc2d74d7beda$export$71511d61b312f219)(_$e, "renderHead", function() {
                    var _$e;
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($fd86a401760e34c7$export$2e2bcd8739ae039.Check, (_$e = {
                        type: "checkbox",
                        name: "all-".concat(c.toString()),
                        value: r + ""
                    }, (0, $b535bc2d74d7beda$export$71511d61b312f219)(_$e, "checked", !!s[0] && s.every(function(e) {
                        var _$t = e[c];
                        return r.includes(_$t);
                    })), (0, $b535bc2d74d7beda$export$71511d61b312f219)(_$e, "ref", function(e) {
                        e && (e.indeterminate = !!r.length && r.length < s.length);
                    }), (0, $b535bc2d74d7beda$export$71511d61b312f219)(_$e, "onClick", a), (0, $b535bc2d74d7beda$export$71511d61b312f219)(_$e, "onKeyUp", function(e) {
                        return " " === e.key && a();
                    }), _$e));
                }), (0, $b535bc2d74d7beda$export$71511d61b312f219)(_$e, "renderBody", function(e) {
                    var a = e[c];
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($fd86a401760e34c7$export$2e2bcd8739ae039.Check, {
                        type: "checkbox",
                        name: c.toString(),
                        value: a,
                        checked: r.includes(a),
                        onClick: function onClick() {
                            return _$t.toggleCheck(a);
                        },
                        onKeyUp: function onKeyUp(e) {
                            return " " === e.key && _$t.toggleCheck(a);
                        }
                    });
                }), _$e;
            }),
            {
                key: "operateColumn",
                get: function get() {
                    var _$e = this, _$t = this.observedProps, r = _$t.editable, a = _$t.deletable, n = _$t.columns, c = _$t.store, s = _$t.translator, i = this.fieldSize, o = s.t, l = n.every(function(e) {
                        return e.readOnly;
                    }), u = n.every(function(e) {
                        return e.disabled;
                    });
                    return {
                        renderHead: function renderHead() {
                            return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($tLNoZ.Fragment, {});
                        },
                        renderBody: function renderBody(t) {
                            return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($tLNoZ.Fragment, {
                                children: [
                                    u ? (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($tLNoZ.Fragment, {}) : r && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($3a399bf6b2fd4261$export$2e2bcd8739ae039, {
                                        className: "text-nowrap m-1",
                                        variant: l ? "primary" : "warning",
                                        size: i,
                                        onClick: function onClick() {
                                            return c.currentOne = t;
                                        },
                                        children: l ? o("view") : o("edit")
                                    }),
                                    a && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($3a399bf6b2fd4261$export$2e2bcd8739ae039, {
                                        className: "text-nowrap m-1",
                                        variant: "danger",
                                        size: i,
                                        onClick: function onClick() {
                                            return _$e.deleteList([
                                                t.id
                                            ]);
                                        },
                                        children: o("delete")
                                    })
                                ]
                            });
                        }
                    };
                }
            },
            {
                key: "columns",
                get: function get() {
                    var _$e = this, _$t = this.observedProps, r = _$t.editable, a = _$t.deletable, n = _$t.columns;
                    return [
                        _$t.onCheck && this.checkColumn
                    ].concat((0, $2b3349705fb2cb54$export$71511d61b312f219)(n.map(function(t) {
                        var r = t.renderBody, a = $e38fa592e8b33da5$var$$3800431d840f9bec$var$__rest(t, [
                            "renderBody"
                        ]);
                        return Object.assign(Object.assign({}, a), {
                            renderBody: null != r ? r : _$e.renderCustomBody(a)
                        });
                    })), [
                        (r || a) && this.operateColumn
                    ]).filter(Boolean);
                }
            },
            {
                key: "hasHeader",
                get: function get() {
                    return this.columns.some(function(e) {
                        return e.renderHead;
                    });
                }
            },
            {
                key: "hasFooter",
                get: function get() {
                    return this.columns.some(function(e) {
                        return e.renderFoot;
                    });
                }
            },
            {
                key: "editing",
                get: function get() {
                    return !(0, $lhPyT.isEmpty)(this.observedProps.store.currentOne);
                }
            },
            {
                key: "renderTable",
                value: function value() {
                    var _$e = this.props, _$t = (_$e.className, _$e.columns, _$e.store), r = (_$e.translator, _$e.editable, _$e.deletable, _$e.onCheck, _$e.onSubmit, _$e.onReset, _$e.responsive), a = $e38fa592e8b33da5$var$$3800431d840f9bec$var$__rest(_$e, [
                        "className",
                        "columns",
                        "store",
                        "translator",
                        "editable",
                        "deletable",
                        "onCheck",
                        "onSubmit",
                        "onReset",
                        "responsive"
                    ]), n = this.hasHeader, c = this.hasFooter, s = this.columns, i = this.editing, o = _$t.indexKey, l = _$t.downloading, u = _$t.currentPage;
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($60566ee939038e24$export$2e2bcd8739ae039, Object.assign({}, a, {
                        responsive: void 0 === r || r,
                        children: [
                            n && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("thead", {
                                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("tr", {
                                    className: "align-middle text-nowrap",
                                    children: s.map(function(e, t) {
                                        var r = e.key, a = e.renderHead;
                                        return (r || a) && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("th", {
                                            children: "function" == typeof a ? a(r) : a || r
                                        }, (null == r ? void 0 : r.toString()) || t);
                                    })
                                })
                            }),
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("tbody", {
                                children: !i && l > 0 ? (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("tr", {
                                    children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("td", {
                                        className: "text-center p-3",
                                        colSpan: s.length,
                                        children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($d5fc9490b2821269$export$2e2bcd8739ae039, {})
                                    })
                                }) : u.map(function(e) {
                                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("tr", {
                                        className: "align-middle",
                                        children: s.map(function(t, r) {
                                            var a = t.key, n = t.renderBody;
                                            return (a || n) && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("td", {
                                                children: (null == n ? void 0 : n(e)) || a && e[a]
                                            }, (null == a ? void 0 : a.toString()) || r);
                                        })
                                    }, e[o]);
                                })
                            }),
                            c && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("tfoot", {
                                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("tr", {
                                    className: "align-middle",
                                    children: s.map(function(e, t) {
                                        var r = e.key, a = e.renderFoot;
                                        return (r || a) && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("td", {
                                            children: "function" == typeof a ? a(r) : a || r
                                        }, (null == r ? void 0 : r.toString()) || t);
                                    })
                                })
                            })
                        ]
                    }));
                }
            },
            {
                key: "deleteList",
                value: function value(e) {
                    return $e38fa592e8b33da5$var$$3800431d840f9bec$var$__awaiter(this, void 0, void 0, function() {
                        var _$t, r, a, n, c, s, i, o, l, u;
                        return (0, $ea05ccc2484f951f$export$71511d61b312f219)(this, function(p) {
                            switch(p.label){
                                case 0:
                                    if (r = (_$t = this.props).translator, a = _$t.store, n = !0, c = !1, s = void 0, !confirm(r.t("sure_to_delete_x", {
                                        keys: e
                                    }))) return [
                                        3,
                                        8
                                    ];
                                    p.label = 1;
                                case 1:
                                    p.trys.push([
                                        1,
                                        6,
                                        7,
                                        8
                                    ]), i = e[Symbol.iterator](), p.label = 2;
                                case 2:
                                    if (n = (o = i.next()).done) return [
                                        3,
                                        5
                                    ];
                                    return l = o.value, [
                                        4,
                                        a.deleteOne(l)
                                    ];
                                case 3:
                                    p.sent(), p.label = 4;
                                case 4:
                                    return n = !0, [
                                        3,
                                        2
                                    ];
                                case 5:
                                    return [
                                        3,
                                        8
                                    ];
                                case 6:
                                    return u = p.sent(), c = !0, s = u, [
                                        3,
                                        8
                                    ];
                                case 7:
                                    try {
                                        n || null == i.return || i.return();
                                    } finally{
                                        if (c) throw s;
                                    }
                                    return [
                                        7
                                    ];
                                case 8:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this, _$t = this.props, r = _$t.className, a = _$t.editable, n = _$t.deletable, c = _$t.filterFields, s = _$t.store, i = _$t.translator, o = _$t.onSubmit, l = (_$t.onReset, $e38fa592e8b33da5$var$$3800431d840f9bec$var$__rest(_$t, [
                        "className",
                        "editable",
                        "deletable",
                        "filterFields",
                        "store",
                        "translator",
                        "onSubmit",
                        "onReset"
                    ])), u = this.fieldSize, p = i.t, $ = s.indexKey, f = s.pageSize, d = s.pageIndex, b = s.pageCount, m = s.totalCount;
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", Object.assign({
                        className: void 0 === r ? "overflow-auto d-flex flex-column gap-3" : r
                    }, l, {
                        children: [
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("header", {
                                className: "sticky-top bg-white py-3 d-flex flex-column gap-3",
                                children: [
                                    c && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($e38fa592e8b33da5$var$$cd7ba08b282791a9$export$341e3470805a945e, {
                                        className: "d-flex flex-wrap align-items-center gap-3 pb-3 border-bottom ".concat($e38fa592e8b33da5$var$$aac96070b6d8b41d$export$5eeb11949c905cc1),
                                        size: u,
                                        translator: i,
                                        fields: c,
                                        onSubmit: function onSubmit(e) {
                                            return s.getList(e, 1);
                                        },
                                        onReset: function onReset() {
                                            return s.getList({}, 1);
                                        }
                                    }),
                                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                                        className: "d-flex justify-content-between align-items-center",
                                        children: [
                                            n && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($3a399bf6b2fd4261$export$2e2bcd8739ae039, {
                                                className: "mx-2",
                                                variant: "danger",
                                                size: u,
                                                onClick: function onClick() {
                                                    return _$e.deleteList(_$e.checkedKeys);
                                                },
                                                children: p("delete")
                                            }),
                                            a && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($3a399bf6b2fd4261$export$2e2bcd8739ae039, {
                                                size: u,
                                                onClick: function onClick() {
                                                    return s.currentOne[$] = "";
                                                },
                                                children: p("create")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            this.renderTable(),
                            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("footer", {
                                className: "d-flex justify-content-between align-items-center",
                                children: [
                                    !!m && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("span", {
                                        className: "mx-3 fs14",
                                        children: p("total_x_rows", {
                                            totalCount: m
                                        })
                                    }),
                                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($e38fa592e8b33da5$var$$bcc38e2aa906301f$export$57625d62e5386b09, {
                                        pageSize: f,
                                        pageIndex: d,
                                        pageCount: b,
                                        onChange: this.getList
                                    })
                                ]
                            }),
                            a && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($e38fa592e8b33da5$var$$bfbc9f72f179e373$export$28baae8ef86bbf36, {
                                size: u,
                                fields: this.columns.map(function(e) {
                                    var _$t = e.renderHead;
                                    return Object.assign(Object.assign({}, $e38fa592e8b33da5$var$$3800431d840f9bec$var$__rest(e, [
                                        "renderHead"
                                    ])), {
                                        renderLabel: _$t
                                    });
                                }),
                                store: s,
                                translator: i,
                                onSubmit: o
                            })
                        ]
                    }));
                }
            }
        ]), t;
    }(b), r = new WeakMap, $e38fa592e8b33da5$var$$3800431d840f9bec$var$__setFunctionName(n, "RestTable"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = b[Symbol.metadata]) ? e : null) : void 0, c = [
        $h2kUE.computed
    ], s = [
        $h2kUE.observable
    ], i = [
        $h2kUE.computed
    ], o = [
        $h2kUE.computed
    ], l = [
        $h2kUE.computed
    ], u = [
        $h2kUE.computed
    ], p = [
        $h2kUE.computed
    ], $ = [
        $h2kUE.computed
    ], $e38fa592e8b33da5$var$$3800431d840f9bec$var$__esDecorate(n, null, c, {
        kind: "getter",
        name: "fieldSize",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "fieldSize" in e;
            },
            get: function get(e) {
                return e.fieldSize;
            }
        },
        metadata: t
    }, null, m), $e38fa592e8b33da5$var$$3800431d840f9bec$var$__esDecorate(n, null, s, {
        kind: "accessor",
        name: "checkedKeys",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "checkedKeys" in e;
            },
            get: function get(e) {
                return e.checkedKeys;
            },
            set: function set(e, t) {
                e.checkedKeys = t;
            }
        },
        metadata: t
    }, v, h), $e38fa592e8b33da5$var$$3800431d840f9bec$var$__esDecorate(n, null, i, {
        kind: "getter",
        name: "checkColumn",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "checkColumn" in e;
            },
            get: function get(e) {
                return e.checkColumn;
            }
        },
        metadata: t
    }, null, m), $e38fa592e8b33da5$var$$3800431d840f9bec$var$__esDecorate(n, null, o, {
        kind: "getter",
        name: "operateColumn",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "operateColumn" in e;
            },
            get: function get(e) {
                return e.operateColumn;
            }
        },
        metadata: t
    }, null, m), $e38fa592e8b33da5$var$$3800431d840f9bec$var$__esDecorate(n, null, l, {
        kind: "getter",
        name: "columns",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "columns" in e;
            },
            get: function get(e) {
                return e.columns;
            }
        },
        metadata: t
    }, null, m), $e38fa592e8b33da5$var$$3800431d840f9bec$var$__esDecorate(n, null, u, {
        kind: "getter",
        name: "hasHeader",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "hasHeader" in e;
            },
            get: function get(e) {
                return e.hasHeader;
            }
        },
        metadata: t
    }, null, m), $e38fa592e8b33da5$var$$3800431d840f9bec$var$__esDecorate(n, null, p, {
        kind: "getter",
        name: "hasFooter",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "hasFooter" in e;
            },
            get: function get(e) {
                return e.hasFooter;
            }
        },
        metadata: t
    }, null, m), $e38fa592e8b33da5$var$$3800431d840f9bec$var$__esDecorate(n, null, $, {
        kind: "getter",
        name: "editing",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "editing" in e;
            },
            get: function get(e) {
                return e.editing;
            }
        },
        metadata: t
    }, null, m), $e38fa592e8b33da5$var$$3800431d840f9bec$var$__esDecorate(null, a = {
        value: n
    }, f, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, d), n = a.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "RestTable"
    }), $e38fa592e8b33da5$var$$3800431d840f9bec$var$__runInitializers(n, d), n;
}(), $e38fa592e8b33da5$var$$3330ccfab53de794$exports = {};
$e38fa592e8b33da5$var$$parcel$export($e38fa592e8b33da5$var$$3330ccfab53de794$exports, "ScrollBoundary", function() {
    return $e38fa592e8b33da5$var$$3330ccfab53de794$export$d086fcc3bc3f366f;
});
var $e38fa592e8b33da5$var$$3330ccfab53de794$var$__rest = function $3330ccfab53de794$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $e38fa592e8b33da5$var$$3330ccfab53de794$var$EdgeOrder = [
    "top",
    "right",
    "bottom",
    "left"
], $e38fa592e8b33da5$var$$3330ccfab53de794$var$touch = function $3330ccfab53de794$var$touch(e, t) {
    return function(r) {
        if (r) {
            var a, n = null == (a = r.parentElement) ? void 0 : a.parentElement, c = n ? getComputedStyle(n) : {}, s = c.overflowX, i = c.overflowY, o = "".concat(s).concat(i).match(/auto|scroll/) ? n : null, l = [
                ,
                ,
                ,
                , 
            ].fill("0px");
            l[$e38fa592e8b33da5$var$$3330ccfab53de794$var$EdgeOrder.indexOf(e)] = "200px", new IntersectionObserver(function(r) {
                return (0, $83f83764f225915f$export$71511d61b312f219)(r, 1)[0].isIntersecting && t(e);
            }, {
                root: o,
                rootMargin: l.join(" ")
            }).observe(r);
        }
    };
}, $e38fa592e8b33da5$var$$3330ccfab53de794$export$d086fcc3bc3f366f = function $3330ccfab53de794$export$d086fcc3bc3f366f(e) {
    var t = e.className, r = e.onTouch, a = e.top, n = e.left, c = e.right, s = e.bottom, i = e.children, o = $e38fa592e8b33da5$var$$3330ccfab53de794$var$__rest(e, [
        "className",
        "onTouch",
        "top",
        "left",
        "right",
        "bottom",
        "children"
    ]);
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", Object.assign({
        className: $e38fa592e8b33da5$var$$parcel$interopDefault($8bd163097a5514bf$exports)("position-relative", t)
    }, o, {
        children: [
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                className: "position-absolute top-0 left-0 w-100",
                ref: $e38fa592e8b33da5$var$$3330ccfab53de794$var$touch("top", r),
                children: a
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                className: "position-absolute top-0 left-0 h-100",
                ref: $e38fa592e8b33da5$var$$3330ccfab53de794$var$touch("left", r),
                children: n
            }),
            i,
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                className: "position-absolute top-0 right-0 h-100",
                ref: $e38fa592e8b33da5$var$$3330ccfab53de794$var$touch("right", r),
                children: c
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                className: "position-absolute top-100 left-0 w-100",
                ref: $e38fa592e8b33da5$var$$3330ccfab53de794$var$touch("bottom", r),
                children: s
            })
        ]
    }));
};
$e38fa592e8b33da5$var$$3330ccfab53de794$export$d086fcc3bc3f366f.displayName = "ScrollBoundary";
var $e38fa592e8b33da5$var$$6c88af5e81334c9f$exports = {};
$e38fa592e8b33da5$var$$parcel$export($e38fa592e8b33da5$var$$6c88af5e81334c9f$exports, "ScrollList", function() {
    return $e38fa592e8b33da5$var$$6c88af5e81334c9f$export$797e591eba0ca37c;
});
var $e38fa592e8b33da5$var$$6c88af5e81334c9f$var$__esDecorate = function $6c88af5e81334c9f$var$__esDecorate(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $e38fa592e8b33da5$var$$6c88af5e81334c9f$var$__runInitializers = function $6c88af5e81334c9f$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $e38fa592e8b33da5$var$$6c88af5e81334c9f$var$__awaiter = function $6c88af5e81334c9f$var$__awaiter(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var _$t;
            e.done ? n(e.value) : ((_$t = e.value) instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $e38fa592e8b33da5$var$$6c88af5e81334c9f$var$__setFunctionName = function $6c88af5e81334c9f$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $e38fa592e8b33da5$var$$6c88af5e81334c9f$var$__rest = function $6c88af5e81334c9f$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $e38fa592e8b33da5$var$$6c88af5e81334c9f$export$797e591eba0ca37c = function() {
    var e, t, r, a, n = [
        $e04d4b638436dc5e$export$b6ae1bc530f4c149
    ], c = [], s = $tLNoZ.Component;
    return $e38fa592e8b33da5$var$$6c88af5e81334c9f$var$__setFunctionName(a = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(_$e, "loadMore", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: (0, $hDKce.debounce)(function(t) {
                    var r = _$e.props.store;
                    "bottom" === t && r.downloading < 1 && !r.noMore && r.getList();
                })
            }), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "componentDidMount",
                value: function value() {
                    return $e38fa592e8b33da5$var$$6c88af5e81334c9f$var$__awaiter(this, void 0, void 0, function() {
                        var _$e, _$t, r, a;
                        return (0, $ea05ccc2484f951f$export$71511d61b312f219)(this, function(n) {
                            switch(n.label){
                                case 0:
                                    return $6515720bcd6dbf2b$export$6a4eb2e7fc9e8903, _$t = (_$e = this.props).filter, r = _$e.defaultData, a = this.props.store, [
                                        4,
                                        (0, $h2kUE.when)(function() {
                                            return a.downloading < 1;
                                        })
                                    ];
                                case 1:
                                    if (n.sent(), a.clearList(), !r) return [
                                        3,
                                        3
                                    ];
                                    return [
                                        4,
                                        a.restoreList({
                                            allItems: r,
                                            filter: _$t
                                        })
                                    ];
                                case 2:
                                    n.sent(), n.label = 3;
                                case 3:
                                    return [
                                        4,
                                        a.getList(_$t, a.pageList.length + 1)
                                    ];
                                case 4:
                                    return n.sent(), [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "componentWillUnmount",
                value: function value() {
                    this.props.store.clearList();
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this.props, _$t = _$e.translator, r = _$e.store, a = _$e.renderList, n = $e38fa592e8b33da5$var$$6c88af5e81334c9f$var$__rest(_$e, [
                        "translator",
                        "store",
                        "renderList"
                    ]), c = _$t.t, s = r.noMore, i = r.allItems;
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($e38fa592e8b33da5$var$$3330ccfab53de794$export$d086fcc3bc3f366f, Object.assign({}, n, {
                        onTouch: this.loadMore,
                        children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                            children: [
                                a(i),
                                (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("footer", {
                                    className: "mt-2 text-center text-muted small",
                                    children: c(s || !i.length ? "no_more" : "load_more")
                                })
                            ]
                        })
                    }));
                }
            }
        ]), t;
    }(s), "ScrollList"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = s[Symbol.metadata]) ? e : null) : void 0, $e38fa592e8b33da5$var$$6c88af5e81334c9f$var$__esDecorate(null, r = {
        value: a
    }, n, {
        kind: "class",
        name: a.name,
        metadata: t
    }, null, c), a = r.value, t && Object.defineProperty(a, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(a, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "ScrollList"
    }), $e38fa592e8b33da5$var$$6c88af5e81334c9f$var$__runInitializers(a, c), a;
}(), $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$exports = {};
$e38fa592e8b33da5$var$$parcel$export($e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$exports, "SearchableInput", function() {
    return $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$export$2724f2f2a56ff7fc;
});
var $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$var$__esDecorate = function $5dc3ca4c9dfca0f7$var$__esDecorate(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$var$__runInitializers = function $5dc3ca4c9dfca0f7$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$var$__awaiter = function $5dc3ca4c9dfca0f7$var$__awaiter(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var _$t;
            e.done ? n(e.value) : ((_$t = e.value) instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$var$__setFunctionName = function $5dc3ca4c9dfca0f7$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $823e69b1ff06d0bf$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldGet = function $5dc3ca4c9dfca0f7$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldSet = function $5dc3ca4c9dfca0f7$var$__classPrivateFieldSet(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$export$2724f2f2a56ff7fc = function() {
    var e, t, r, a, n, c, s, i, o = [
        $e04d4b638436dc5e$export$b6ae1bc530f4c149
    ], l = [], u = $524de0d5a72e1bc6$exports.FormComponent, p = [], $ = [], f = [], d = [];
    return c = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $da4a22c62e4dca4b$export$71511d61b312f219)(this, t), _$e = (0, $412ca59b3f02764c$export$71511d61b312f219)(this, t, arguments), r.set(_$e, $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$var$__runInitializers(_$e, p, _$e.props.filter)), a.set(_$e, ($e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$var$__runInitializers(_$e, $), $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$var$__runInitializers(_$e, f, !1))), Object.defineProperty(_$e, "search", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$var$__runInitializers(_$e, d), (0, $hDKce.debounce)(function(t) {
                    return $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$var$__awaiter(_$e, void 0, void 0, function() {
                        var _$e, r, a;
                        return (0, $ea05ccc2484f951f$export$71511d61b312f219)(this, function(n) {
                            switch(n.label){
                                case 0:
                                    if (r = (_$e = this.props).store, a = _$e.labelKey, t = t.trim(), this.filter = Object.assign(Object.assign({}, this.filter), (0, $b535bc2d74d7beda$export$71511d61b312f219)({}, a, t || void 0)), !(r.downloading < 1)) return [
                                        3,
                                        5
                                    ];
                                    if (!t) return [
                                        3,
                                        4
                                    ];
                                    if (this.listShown) return [
                                        3,
                                        1
                                    ];
                                    return this.listShown = !0, [
                                        3,
                                        3
                                    ];
                                case 1:
                                    return [
                                        4,
                                        r.getList(this.filter, 1)
                                    ];
                                case 2:
                                    n.sent(), n.label = 3;
                                case 3:
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    this.listShown = !1, r.clearList(), n.label = 5;
                                case 5:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }, $lhPyT.Second))
            }), Object.defineProperty(_$e, "add", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t, r) {
                    var a = _$e.value || [];
                    !a.find(function(e) {
                        return e.value === r;
                    }) && (_$e.innerValue = (0, $2b3349705fb2cb54$export$71511d61b312f219)(a).concat([
                        {
                            label: t,
                            value: r
                        }
                    ]), _$e.props.multiple || (_$e.listShown = !1));
                }
            }), Object.defineProperty(_$e, "delete", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    return _$e.innerValue = (0, $2b3349705fb2cb54$export$71511d61b312f219)(_$e.value.slice(0, t)).concat((0, $2b3349705fb2cb54$export$71511d61b312f219)(_$e.value.slice(t + 1)));
                }
            }), Object.defineProperty(_$e, "handleBlur", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    var r = t.target, a = t.relatedTarget;
                    r.parentElement !== (null == a ? void 0 : a.parentElement) && (_$e.listShown = !1);
                }
            }), Object.defineProperty(_$e, "renderList", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    return t[0] ? (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($010c5059a1144c43$export$2e2bcd8739ae039, {
                        children: t.map(function(t) {
                            var r = _$e.observedProps, a = r.labelKey, n = r.valueKey, c = t[a], s = t[n];
                            return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($010c5059a1144c43$export$2e2bcd8739ae039.Item, {
                                as: "button",
                                type: "button",
                                action: !0,
                                onClick: function onClick() {
                                    return _$e.add(c, s);
                                },
                                children: c
                            }, s);
                        })
                    }) : _$e.observedProps.store.downloading > 0 && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                        className: "text-center my-3",
                        children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($d5fc9490b2821269$export$2e2bcd8739ae039, {})
                    });
                }
            }), _$e;
        }
        return (0, $4319b45daef5668a$export$71511d61b312f219)(t, e), (0, $f5ddaea1b57cff1c$export$71511d61b312f219)(t, [
            {
                key: "filter",
                get: function get() {
                    return $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "listShown",
                get: function get() {
                    return $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function set(e) {
                    $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            (0, $b535bc2d74d7beda$export$71511d61b312f219)({
                key: "renderOverlay"
            }, "value", function() {
                var _$e = this.filter, _$t = this.props, r = _$t.translator, a = _$t.fields, n = _$t.store, c = _$t.labelKey, s = _$t.renderList, i = void 0 === s ? this.renderList : s, o = _$e[c], l = !n.allItems.some(function(e) {
                    return e[c] === o;
                });
                return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("div", {
                    className: "position-absolute start-0 z-3 overflow-auto py-1 bg-white shadow-sm",
                    style: {
                        top: "100%",
                        maxHeight: "30vh"
                    },
                    onBlurCapture: this.handleBlur,
                    children: [
                        l && (null == a ? void 0 : a[0]) && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($3a399bf6b2fd4261$export$2e2bcd8739ae039, {
                            className: "w-100 sticky-top",
                            variant: "warning",
                            size: "sm",
                            type: "button",
                            onClick: function onClick() {
                                return n.currentOne = (0, $b535bc2d74d7beda$export$71511d61b312f219)({}, c, o);
                            },
                            children: [
                                "+ ",
                                o
                            ]
                        }),
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($e38fa592e8b33da5$var$$6c88af5e81334c9f$export$797e591eba0ca37c, {
                            translator: r,
                            store: n,
                            filter: _$e,
                            renderList: i
                        })
                    ]
                });
            }),
            (0, $b535bc2d74d7beda$export$71511d61b312f219)({
                key: "render"
            }, "value", function() {
                var _$e = this, _$t = this.value, r = this.listShown, a = this.props, n = a.translator, c = a.fields, s = a.store, i = a.labelKey, o = a.valueKey, l = a.type, u = a.name, p = a.required, $ = a.readOnly, f = a.disabled, d = a.placeholder;
                return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($d8869262459b9d45$export$2e2bcd8739ae039, (0, $b535bc2d74d7beda$export$71511d61b312f219)({
                    className: "position-relative"
                }, "children", [
                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($d8869262459b9d45$export$2e2bcd8739ae039.Text, {
                        className: "d-flex flex-wrap align-items-center gap-2",
                        children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($e38fa592e8b33da5$var$$f600741b98acd6fe$export$ef1c4106ceccca63, {
                            list: (_$t || []).map(function(e) {
                                return {
                                    text: e.label
                                };
                            }),
                            onDelete: function onDelete(t, r) {
                                return (0, $45b8819b503a7835$export$71511d61b312f219)(t), _$e.delete(r);
                            }
                        })
                    }),
                    r && this.renderOverlay(),
                    (null == c ? void 0 : c[0]) && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($e38fa592e8b33da5$var$$bfbc9f72f179e373$export$28baae8ef86bbf36, (0, $b535bc2d74d7beda$export$71511d61b312f219)({
                        translator: n,
                        fields: c,
                        store: s
                    }, "onSubmit", function(t) {
                        var r = t[i], a = t[o];
                        _$e.add(r, a), _$e.listShown = !1;
                    })),
                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("input", {
                        type: "hidden",
                        name: u,
                        value: JSON.stringify(null == _$t ? void 0 : _$t.map(function(e) {
                            return e.value;
                        }))
                    }),
                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)($fd86a401760e34c7$export$2e2bcd8739ae039.Control, {
                        type: void 0 === l ? "search" : l,
                        placeholder: d,
                        required: p,
                        readOnly: $,
                        disabled: f,
                        onChange: function onChange(t) {
                            var r = t.currentTarget.value;
                            return _$e.search(r);
                        }
                    })
                ]));
            })
        ]), t;
    }(u), r = new WeakMap, a = new WeakMap, $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$var$__setFunctionName(c, "SearchableInput"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = u[Symbol.metadata]) ? e : null) : void 0, s = [
        $h2kUE.observable
    ], i = [
        $h2kUE.observable
    ], $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$var$__esDecorate(c, null, s, {
        kind: "accessor",
        name: "filter",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "filter" in e;
            },
            get: function get(e) {
                return e.filter;
            },
            set: function set(e, t) {
                e.filter = t;
            }
        },
        metadata: t
    }, p, $), $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$var$__esDecorate(c, null, i, {
        kind: "accessor",
        name: "listShown",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "listShown" in e;
            },
            get: function get(e) {
                return e.listShown;
            },
            set: function set(e, t) {
                e.listShown = t;
            }
        },
        metadata: t
    }, f, d), $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$var$__esDecorate(null, n = {
        value: c
    }, o, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, l), c = n.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "SearchableInput"
    }), $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$var$__runInitializers(c, l), c;
}();
$e38fa592e8b33da5$var$$parcel$exportWildcard($e38fa592e8b33da5$exports, $e38fa592e8b33da5$var$$f600741b98acd6fe$exports), $e38fa592e8b33da5$var$$parcel$exportWildcard($e38fa592e8b33da5$exports, $e38fa592e8b33da5$var$$faee9857e4bdfa8b$exports), $e38fa592e8b33da5$var$$parcel$exportWildcard($e38fa592e8b33da5$exports, $e38fa592e8b33da5$var$$8663609ea235ec39$exports), $e38fa592e8b33da5$var$$parcel$exportWildcard($e38fa592e8b33da5$exports, $e38fa592e8b33da5$var$$f2af1554fbcf9c96$exports), $e38fa592e8b33da5$var$$parcel$exportWildcard($e38fa592e8b33da5$exports, $e38fa592e8b33da5$var$$a21a50f24f1cbd28$exports), $e38fa592e8b33da5$var$$parcel$exportWildcard($e38fa592e8b33da5$exports, $e38fa592e8b33da5$var$$4e6504f15de995a8$exports), $e38fa592e8b33da5$var$$parcel$exportWildcard($e38fa592e8b33da5$exports, $e38fa592e8b33da5$var$$92bd5b9c2e8cd28e$exports), $e38fa592e8b33da5$var$$parcel$exportWildcard($e38fa592e8b33da5$exports, $e38fa592e8b33da5$var$$fa84453248a3f065$exports), $e38fa592e8b33da5$var$$parcel$exportWildcard($e38fa592e8b33da5$exports, $e38fa592e8b33da5$var$$36ed2012ed0bbec3$exports), $e38fa592e8b33da5$var$$parcel$exportWildcard($e38fa592e8b33da5$exports, $e38fa592e8b33da5$var$$cd7ba08b282791a9$exports), $e38fa592e8b33da5$var$$parcel$exportWildcard($e38fa592e8b33da5$exports, $e38fa592e8b33da5$var$$bcc38e2aa906301f$exports), $e38fa592e8b33da5$var$$parcel$exportWildcard($e38fa592e8b33da5$exports, $e38fa592e8b33da5$var$$3800431d840f9bec$exports), $e38fa592e8b33da5$var$$parcel$exportWildcard($e38fa592e8b33da5$exports, $e38fa592e8b33da5$var$$3330ccfab53de794$exports), $e38fa592e8b33da5$var$$parcel$exportWildcard($e38fa592e8b33da5$exports, $e38fa592e8b33da5$var$$6c88af5e81334c9f$exports), $e38fa592e8b33da5$var$$parcel$exportWildcard($e38fa592e8b33da5$exports, $e38fa592e8b33da5$var$$5dc3ca4c9dfca0f7$exports); //# sourceMappingURL=index.js.map


parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");



var $4a8a8342c5f8fabd$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $4a8a8342c5f8fabd$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $7E0eS._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $4a8a8342c5f8fabd$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $7E0eS._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $4a8a8342c5f8fabd$export$fb01502f5340e3de = function() {
    var _classDecorators = [
        (0, $e04d4b638436dc5e$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $tLNoZ.Component);
    var _instanceExtraInitializers = [];
    var _get_columns_decorators;
    var PaginationPage = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $hdIku._)(_classThis, _classSuper);
        function _classThis() {
            (0, $173N4._)(this, _classThis);
            var _this;
            _this = (0, $7qXGD._)(this, _classThis, arguments);
            $4a8a8342c5f8fabd$var$__runInitializers(_this, _instanceExtraInitializers);
            return _this;
        }
        (0, $cFHGC._)(_classThis, [
            {
                key: "columns",
                get: function get() {
                    var t = (0, $50993b47476de2e7$export$a7357cdd1f0b0168).t;
                    return [
                        {
                            key: 'full_name',
                            renderHead: t('repository_name'),
                            renderBody: function(param) {
                                var html_url = param.html_url, full_name = param.full_name;
                                return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("a", {
                                    target: "_blank",
                                    href: html_url,
                                    rel: "noreferrer",
                                    children: full_name
                                });
                            }
                        },
                        {
                            key: 'homepage',
                            type: 'url',
                            renderHead: t('home_page')
                        },
                        {
                            key: 'language',
                            renderHead: t('programming_language')
                        },
                        {
                            key: 'topics',
                            renderHead: t('topic'),
                            renderBody: function(param) {
                                var topics = param.topics;
                                return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $tLNoZ.Fragment), {
                                    children: topics === null || topics === void 0 ? void 0 : topics.map(function(topic) {
                                        return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $b4b154a3007acf25$export$2e2bcd8739ae039), {
                                            as: "a",
                                            className: "me-2 text-decoration-none",
                                            bg: (0, $baaeda96f7555c00$exports.text2color)(topic, [
                                                'light'
                                            ]),
                                            target: "_blank",
                                            href: "https://github.com/topics/".concat(topic),
                                            children: topic
                                        }, topic);
                                    })
                                });
                            }
                        },
                        {
                            key: 'stargazers_count',
                            type: 'number',
                            renderHead: t('star_count')
                        }
                    ];
                }
            },
            {
                key: "render",
                value: function render() {
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $1a4cf9540da0f5bb$export$2e2bcd8739ae039), {
                        style: {
                            height: '91vh'
                        },
                        children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $e38fa592e8b33da5$exports.RestTable), {
                            className: "h-100 text-center",
                            columns: this.columns,
                            store: (0, $1eb99b7ce60db007$export$8701c19c4b8c549b),
                            translator: (0, $50993b47476de2e7$export$a7357cdd1f0b0168),
                            striped: true,
                            hover: true,
                            editable: true,
                            deletable: true,
                            onCheck: console.log
                        })
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    $4a8a8342c5f8fabd$var$__setFunctionName(_classThis, "PaginationPage");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _get_columns_decorators = [
            (0, $h2kUE.computed)
        ];
        $4a8a8342c5f8fabd$var$__esDecorate(_classThis, null, _get_columns_decorators, {
            kind: "getter",
            name: "columns",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "columns" in obj;
                },
                get: function(obj) {
                    return obj.columns;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $4a8a8342c5f8fabd$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        PaginationPage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $4a8a8342c5f8fabd$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return PaginationPage = _classThis;
}();












var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");

var $7E0eS = parcelRequire("7E0eS");

var $13u2V = parcelRequire("13u2V");


var $h2kUE = parcelRequire("h2kUE");

parcelRequire("1aLYV");
var $tLNoZ = parcelRequire("tLNoZ");

var $25d5d4cd20ca5a4b$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $7E0eS._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $25d5d4cd20ca5a4b$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $25d5d4cd20ca5a4b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $25d5d4cd20ca5a4b$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $7E0eS._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $25d5d4cd20ca5a4b$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $25d5d4cd20ca5a4b$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $25d5d4cd20ca5a4b$export$82ac5bfd81727a32 = function() {
    var _GitLogo_path_accessor_storage;
    var _classDecorators = [
        (0, $e04d4b638436dc5e$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $tLNoZ.Component);
    var _path_decorators;
    var _path_initializers = [];
    var _path_extraInitializers = [];
    var GitLogo = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $hdIku._)(_classThis, _classSuper);
        function _classThis() {
            (0, $173N4._)(this, _classThis);
            var _this;
            _this = (0, $7qXGD._)(this, _classThis, arguments);
            _GitLogo_path_accessor_storage.set(_this, $25d5d4cd20ca5a4b$var$__runInitializers(_this, _path_initializers, ''));
            $25d5d4cd20ca5a4b$var$__runInitializers(_this, _path_extraInitializers);
            return _this;
        }
        (0, $cFHGC._)(_classThis, [
            {
                key: "path",
                get: function get() {
                    return $25d5d4cd20ca5a4b$var$__classPrivateFieldGet(this, _GitLogo_path_accessor_storage, "f");
                },
                set: function set(value) {
                    $25d5d4cd20ca5a4b$var$__classPrivateFieldSet(this, _GitLogo_path_accessor_storage, value, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    return $25d5d4cd20ca5a4b$var$__awaiter(this, void 0, void 0, function() {
                        var name, topic, src, _a, src1;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    name = this.props.name;
                                    topic = name.toLowerCase();
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        5
                                    ]);
                                    return [
                                        4,
                                        this.loadImage("https://raw.githubusercontent.com/github/explore/master/topics/".concat(topic, "/").concat(topic, ".png"))
                                    ];
                                case 2:
                                    src = _state.sent().src;
                                    this.path = src;
                                    return [
                                        3,
                                        5
                                    ];
                                case 3:
                                    _a = _state.sent();
                                    return [
                                        4,
                                        this.loadImage("https://github.com/".concat(name, ".png"))
                                    ];
                                case 4:
                                    src1 = _state.sent().src;
                                    this.path = src1;
                                    return [
                                        3,
                                        5
                                    ];
                                case 5:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "loadImage",
                value: function loadImage(path) {
                    return new Promise(function(resolve, reject) {
                        var image = new globalThis.Image();
                        image.onload = function() {
                            return resolve(image);
                        };
                        image.onerror = reject;
                        image.src = path;
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    var path = this.path;
                    var name = this.props.name;
                    return path && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $9f5f1ff841daa39a$export$2e2bcd8739ae039), {
                        src: path,
                        alt: name,
                        fluid: true
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _GitLogo_path_accessor_storage = new WeakMap();
    $25d5d4cd20ca5a4b$var$__setFunctionName(_classThis, "GitLogo");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _path_decorators = [
            (0, $h2kUE.observable)
        ];
        $25d5d4cd20ca5a4b$var$__esDecorate(_classThis, null, _path_decorators, {
            kind: "accessor",
            name: "path",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "path" in obj;
                },
                get: function(obj) {
                    return obj.path;
                },
                set: function(obj, value) {
                    obj.path = value;
                }
            },
            metadata: _metadata
        }, _path_initializers, _path_extraInitializers);
        $25d5d4cd20ca5a4b$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        GitLogo = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $25d5d4cd20ca5a4b$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return GitLogo = _classThis;
}();


var $13b5e15de5cea655$export$3663268b2052b3d = (0, $e04d4b638436dc5e$export$b6ae1bc530f4c149)(function(param) {
    var _param_className = param.className, className = _param_className === void 0 ? 'shadow-sm' : _param_className, full_name = param.full_name, html_url = param.html_url, _param_languages = param.languages, languages = _param_languages === void 0 ? [] : _param_languages, _param_topics = param.topics, topics = _param_topics === void 0 ? [] : _param_topics, description = param.description, homepage = param.homepage;
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $71075948dbe2717f$export$2e2bcd8739ae039), {
        className: className,
        children: [
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $71075948dbe2717f$export$2e2bcd8739ae039).Body, {
                className: "d-flex flex-column gap-3",
                children: [
                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $71075948dbe2717f$export$2e2bcd8739ae039).Title, {
                        as: "h3",
                        className: "h5",
                        children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("a", {
                            target: "_blank",
                            href: html_url,
                            rel: "noreferrer",
                            children: full_name
                        })
                    }),
                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("nav", {
                        className: "flex-fill",
                        children: topics.map(function(topic) {
                            return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $b4b154a3007acf25$export$2e2bcd8739ae039), {
                                className: "text-decoration-none me-1",
                                bg: (0, $baaeda96f7555c00$exports.text2color)(topic, [
                                    'light'
                                ]),
                                as: "a",
                                target: "_blank",
                                href: "https://github.com/topics/".concat(topic),
                                children: topic
                            }, topic);
                        })
                    }),
                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $4a44c352fe7cf693$export$2e2bcd8739ae039), {
                        as: "ul",
                        className: "list-unstyled g-4",
                        xs: 4,
                        children: languages.map(function(language) {
                            return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $bce75f99777ea046$export$2e2bcd8739ae039), {
                                as: "li",
                                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $25d5d4cd20ca5a4b$export$82ac5bfd81727a32), {
                                    name: language
                                })
                            }, language);
                        })
                    }),
                    (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $71075948dbe2717f$export$2e2bcd8739ae039).Text, {
                        children: description
                    })
                ]
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $71075948dbe2717f$export$2e2bcd8739ae039).Footer, {
                className: "d-flex justify-content-between align-items-center",
                children: homepage && (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $3a399bf6b2fd4261$export$2e2bcd8739ae039), {
                    variant: "success",
                    target: "_blank",
                    href: homepage,
                    children: (0, $50993b47476de2e7$export$a7357cdd1f0b0168).t('home_page')
                })
            })
        ]
    });
});




var $a0f32a0a868a7a1b$export$5636eeba3ebdcdc3 = (0, $e04d4b638436dc5e$export$b6ae1bc530f4c149)(function() {
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $1a4cf9540da0f5bb$export$2e2bcd8739ae039), {
        children: [
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)("h1", {
                className: "my-4",
                children: (0, $50993b47476de2e7$export$a7357cdd1f0b0168).t('scroll_list')
            }),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $e38fa592e8b33da5$exports.ScrollList), {
                translator: (0, $50993b47476de2e7$export$a7357cdd1f0b0168),
                store: (0, $1eb99b7ce60db007$export$8701c19c4b8c549b),
                renderList: function(allItems) {
                    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $4a44c352fe7cf693$export$2e2bcd8739ae039), {
                        as: "ul",
                        className: "list-unstyled g-4",
                        xs: 1,
                        sm: 2,
                        children: allItems.map(function(item) {
                            return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $bce75f99777ea046$export$2e2bcd8739ae039), {
                                as: "li",
                                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $13b5e15de5cea655$export$3663268b2052b3d), Object.assign({
                                    className: "h-100 shadow-sm"
                                }, item))
                            }, item.id);
                        })
                    });
                }
            })
        ]
    });
});


var $94a964d0ae980490$export$953c2efc134d7f79 = function() {
    return (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $tLNoZ.Fragment), {
        children: [
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $aca7ac1a0ae40101$export$8b543871300e74c2), {}),
            (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $6rymm.HashRouter), {
                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $6rymm.Routes), {
                    children: [
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $6rymm.Route), {
                            path: "/",
                            element: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $ca93ea259ddc746f$export$36d69433c4f81145), {})
                        }),
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $6rymm.Route), {
                            path: "/component",
                            element: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $00200ebe4eb3ad76$export$46af595855840602), {})
                        }),
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $6rymm.Route), {
                            path: "/pagination",
                            element: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $4a8a8342c5f8fabd$export$fb01502f5340e3de), {})
                        }),
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $6rymm.Route), {
                            path: "/scroll-list",
                            element: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $a0f32a0a868a7a1b$export$5636eeba3ebdcdc3), {})
                        }),
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $6rymm.Route), {
                            path: "/chart",
                            element: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $1a4cf9540da0f5bb$export$2e2bcd8739ae039), {
                                children: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $2e53d2ece788bedf$export$2e2bcd8739ae039), {})
                            })
                        }),
                        (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $6rymm.Route), {
                            path: "/downloader",
                            element: (0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $62d578fe5a9fbe1c$export$2ad2ffac2ac2ce65), {})
                        })
                    ]
                })
            })
        ]
    });
};


(0, $3959ba5a3cb8c567$export$dfb5619354ba860)();
(0, $h2kUE.configure)({
    enforceActions: 'never'
});
self.addEventListener('unhandledrejection', function(param) {
    var reason = param.reason;
    var message = reason.message;
    if (message) self.alert(message);
});
var $4d6b8652bfb48509$var$serviceWorker = window.navigator.serviceWorker, $4d6b8652bfb48509$var$NODE_ENV = "production";
if ($4d6b8652bfb48509$var$NODE_ENV !== 'development') $4d6b8652bfb48509$var$serviceWorker === null || $4d6b8652bfb48509$var$serviceWorker === void 0 || $4d6b8652bfb48509$var$serviceWorker.register('sw.js').then((0, $lhPyT.serviceWorkerUpdate)).then(function(worker) {
    if (window.confirm('New version of this Web App detected, update now?')) worker.postMessage({
        type: 'SKIP_WAITING'
    });
});
$4d6b8652bfb48509$var$serviceWorker === null || $4d6b8652bfb48509$var$serviceWorker === void 0 || $4d6b8652bfb48509$var$serviceWorker.addEventListener('controllerchange', function() {
    return window.location.reload();
});
(0, $ce7e531d844c2b97$export$882461b6382ed46c)(document.querySelector('#app')).render((0, $d35b2f3ed94b921d$export$34b9dba7ce09269b)((0, $94a964d0ae980490$export$953c2efc134d7f79), {}));

})();
//# sourceMappingURL=React-MobX-Bootstrap-ts.dcfcb65d.js.map
